(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 95318:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(50008)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50008:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 70597:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.Z = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

/***/ }),

/***/ 43891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.Z = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

/***/ }),

/***/ 5700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; },
  "Bx": function() { return /* binding */ getDefaultMiddleware; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, applyMiddleware, bindActionCreators, combineReducers, compose, createAction, createEntityAdapter, createImmutableStateInvariantMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, findNonSerializableValue, getType, isImmutableDefault, isPlain, legacy_createStore, nanoid, unwrapResult

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.js
function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(r.length?" "+r.join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function t(n){return!!n&&!!n[G]}function r(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var t=Object.getPrototypeOf(n);return!t||t===Object.prototype}(n)||Array.isArray(n)||!!n[B]||!!n.constructor[B]||c(n)||s(n))}function e(n){if(n&&n[G])return n[G].t}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:Q)(n).forEach((function(r){return t(r,n[r],n)})):n.forEach((function(r,e){return t(e,r,n)}))}function o(n){var t=n[G];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:c(n)?2:s(n)?3:0}function u(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function c(n){return U&&n instanceof Map}function s(n){return W&&n instanceof Set}function v(n){return n.o||n.t}function p(t,r){if(void 0===r&&(r=!1),Array.isArray(t))return t.slice();var e=Object.create(Object.getPrototypeOf(t));return i(t,(function(i){if(i!==G){var o=Object.getOwnPropertyDescriptor(t,i),u=o.value;o.get&&(r||n(1),u=o.get.call(t)),o.enumerable?e[i]=u:Object.defineProperty(e,i,{value:u,writable:!0,configurable:!0})}})),e}function d(n,e){t(n)||h(n)||!r(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=l),Object.freeze(n),e&&i(n,(function(n,t){return d(t,!0)}),!0))}function l(){n(2)}function h(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function y(t){var r=V[t];return r||n( false?0:19,t),r}function b(n,t){V[n]=t}function m(){return true||0,K}function _(n,t){t&&(y("Patches"),n.u=[],n.s=[],n.v=t)}function j(n){O(n),n.p.forEach(w),n.p=null}function O(n){n===K&&(K=n.l)}function g(n){return K={p:[],l:K,h:n,m:!0,_:0}}function w(n){var t=n[G];0===t.i||1===t.i?t.j():t.O=!0}function S(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.g||y("ES5").S(e,t,o),o?(i[G].P&&(j(e),n(4)),r(t)&&(t=P(e,t),e.l||A(e,t)),e.u&&y("Patches").M(i[G],t,e.u,e.s)):t=P(e,i,[]),j(e),e.u&&e.v(e.u,e.s),t!==q?t:void 0}function P(n,t,r){if(h(t))return t;var e=t[G];if(!e)return i(t,(function(i,o){return M(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return A(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=p(e.k,!0):e.o;i(o,(function(t,i){return M(n,e,o,t,i,r)})),A(n,o,!1),r&&n.u&&y("Patches").R(e,r,n.u,n.s)}return e.o}function M(e,i,c,s,v,p){if( false&&0,t(v)){var d=P(e,v,p&&i&&3!==i.i&&!u(i.D,s)?p.concat(s):void 0);if(h=s,y=d,2===(b=o(l=c))?l.set(h,y):3===b?(l.delete(h),l.add(y)):l[h]=y,!t(d))return;e.m=!1}var l,h,y,b;if((!i||!f(v,a(i.t,s)))&&r(v)){if(!e.h.N&&e._<1)return;P(e,v),i&&i.A.l||A(e,v)}}function A(n,t,r){void 0===r&&(r=!1),n.h.N&&n.m&&d(t,r)}function x(n,t){var r=n[G],e=Reflect.getOwnPropertyDescriptor(r?v(r):n,t);return e&&e.value}function z(n){if(!n.P){if(n.P=!0,0===n.i||1===n.i){var t=n.o=p(n.t);i(n.p,(function(n,r){t[n]=r})),n.p=void 0}n.l&&z(n.l)}}function I(n){n.o||(n.o=p(n.t))}function E(n,t,r){var e=c(t)?y("MapSet").T(t,r):s(t)?y("MapSet").F(t,r):n.g?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:m(),P:!1,I:!1,D:{},l:t,t:n,k:null,p:{},o:null,j:null,C:!1},i=e,o=Y;r&&(i=[e],o=Z);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):y("ES5").J(t,r);return(r?r.A:m()).p.push(e),e}function k(n,t){n.g?z(t):y("ES5").K(t)}function R(){function e(n,t){var r=n[G];if(r&&!r.$){r.$=!0;var e=n[t];return r.$=!1,e}return n[t]}function o(n){n.P||(n.P=!0,n.l&&o(n.l))}function a(n){n.o||(n.o=c(n.t))}function c(n){var t=n&&n[G];if(t){t.$=!0;var r=p(t.k,!0);return t.$=!1,r}return p(n)}function s(n){for(var t=n.length-1;t>=0;t--){var r=n[t][G];if(!r.P)switch(r.i){case 5:l(r)&&o(r);break;case 4:d(r)&&o(r)}}}function d(n){for(var t=n.t,r=n.k,e=Object.keys(r),i=e.length-1;i>=0;i--){var o=e[i],a=t[o];if(void 0===a&&!u(t,o))return!0;var c=r[o],s=c&&c[G];if(s?s.t!==a:!f(c,a))return!0}return e.length!==Object.keys(t).length}function l(n){var t=n.k;if(t.length!==n.t.length)return!0;var r=Object.getOwnPropertyDescriptor(t,t.length-1);return!(!r||r.get)}function h(t){t.O&&n(3,JSON.stringify(v(t)))}var y={};b("ES5",{J:function(n,t){var u=Array.isArray(n),s=c(n);i(s,(function(t){!function(n,t,i){var u=y[t];u?u.enumerable=i:y[t]=u={enumerable:i,get:function(){return function(n,t){h(n);var i=e(v(n),t);return n.$?i:i===e(n.t,t)&&r(i)?(a(n),n.o[t]=E(n.A.h,i,n)):i}(this[G],t)},set:function(n){!function(n,t,r){if(h(n),n.D[t]=!0,!n.P){if(f(r,e(v(n),t)))return;o(n),a(n)}n.o[t]=r}(this[G],t,n)}},Object.defineProperty(n,t,u)}(s,t,u||function(n,t){var r=Object.getOwnPropertyDescriptor(n,t);return!(!r||!r.enumerable)}(n,t))}));var p={i:u?5:4,A:t?t.A:m(),P:!1,$:!1,I:!1,D:{},l:t,t:n,k:s,o:null,O:!1,C:!1};return Object.defineProperty(s,G,{value:p,writable:!0}),s},K:o,S:function(n,r,e){n.p.forEach((function(n){n[G].$=!0})),e?t(r)&&r[G].A===n&&s(n.p):(n.u&&function n(t){if(t&&"object"==typeof t){var r=t[G];if(r){var e=r.t,a=r.k,f=r.D,c=r.i;if(4===c)i(a,(function(t){t!==G&&(void 0!==e[t]||u(e,t)?f[t]||n(a[t]):(f[t]=!0,o(r)))})),i(e,(function(n){void 0!==a[n]||u(a,n)||(f[n]=!1,o(r))}));else if(5===c){if(l(r)&&(o(r),f.length=!0),a.length<e.length)for(var s=a.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<a.length;v++)f[v]=!0;for(var p=Math.min(a.length,e.length),d=0;d<p;d++)void 0===f[d]&&n(a[d])}}}}(n.p[0]),s(n.p))}})}function D(){function r(n){if(!n||"object"!=typeof n)return n;if(Array.isArray(n))return n.map(r);if(c(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],r(n[1])]})));if(s(n))return new Set(Array.from(n).map(r));var t=Object.create(Object.getPrototypeOf(n));for(var e in n)t[e]=r(n[e]);return t}function e(n){return t(n)?r(n):n}var f="add";b("Patches",{U:function(t,e){return e.forEach((function(e){for(var i=e.path,u=e.op,c=t,s=0;s<i.length-1;s++)"object"!=typeof(c=a(c,i[s]))&&n(15,i.join("/"));var v=o(c),p=r(e.value),d=i[i.length-1];switch(u){case"replace":switch(v){case 2:return c.set(d,p);case 3:n(16);default:return c[d]=p}case f:switch(v){case 1:return c.splice(d,0,p);case 2:return c.set(d,p);case 3:return c.add(p);default:return c[d]=p}case"remove":switch(v){case 1:return c.splice(d,1);case 2:return c.delete(d);case 3:return c.delete(e.value);default:return delete c[d]}default:n(17,u)}})),t},R:function(n,t,r,o){switch(n.i){case 0:case 4:case 2:return function(n,t,r,o){var c=n.t,s=n.o;i(n.D,(function(n,i){var v=a(c,n),p=a(s,n),d=i?u(c,n)?"replace":f:"remove";if(v!==p||"replace"!==d){var l=t.concat(n);r.push("remove"===d?{op:d,path:l}:{op:d,path:l,value:p}),o.push(d===f?{op:"remove",path:l}:"remove"===d?{op:f,path:l,value:e(v)}:{op:"replace",path:l,value:e(v)})}}))}(n,t,r,o);case 5:case 1:return function(n,t,r,i){var o=n.t,u=n.D,a=n.o;if(a.length<o.length){var c=[a,o];o=c[0],a=c[1];var s=[i,r];r=s[0],i=s[1]}for(var v=a.length-o.length,p=0;o[p]===a[p]&&p<o.length;)++p;for(var d=o.length;d>p&&o[d-1]===a[d+v-1];)--d;for(var l=p;l<d;++l)if(u[l]&&a[l]!==o[l]){var h=t.concat([l]);r.push({op:"replace",path:h,value:e(a[l])}),i.push({op:"replace",path:h,value:e(o[l])})}for(var y=r.length,b=d+v-1;b>=d;--b){var m=t.concat([b]);r[y+b-d]={op:f,path:m,value:e(a[b])},i.push({op:"remove",path:m})}}(n,t,r,o);case 3:return function(n,t,r,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=t.concat([u]);r.push({op:"remove",path:i,value:n}),e.unshift({op:f,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=t.concat([u]);r.push({op:f,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,t,r,o)}},M:function(n,t,r,e){r.push({op:"replace",path:[],value:t}),e.push({op:"replace",path:[],value:n.t})}})}function N(){function t(n,t){function r(){this.constructor=n}u(n,t),n.prototype=(r.prototype=t.prototype,new r)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function i(n){n.o||(n.o=new Set,n.t.forEach((function(t){if(r(t)){var e=E(n.A.h,t,n);n.p.set(t,e),n.o.add(e)}else n.o.add(t)})))}function o(t){t.O&&n(3,JSON.stringify(v(t)))}var u=function(n,t){return(u=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,t){n.__proto__=t}||function(n,t){for(var r in t)t.hasOwnProperty(r)&&(n[r]=t[r])})(n,t)},a=function(){function n(n,t){return this[G]={i:2,l:t,A:t?t.A:m(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}t(n,Map);var i=n.prototype;return Object.defineProperty(i,"size",{get:function(){return v(this[G]).size}}),i.has=function(n){return v(this[G]).has(n)},i.set=function(n,t){var r=this[G];return o(r),v(r).get(n)!==t&&(e(r),k(r.A.h,r),r.D.set(n,!0),r.o.set(n,t),r.D.set(n,!0)),this},i.delete=function(n){if(!this.has(n))return!1;var t=this[G];return o(t),e(t),k(t.A.h,t),t.D.set(n,!1),t.o.delete(n),!0},i.clear=function(){var n=this[G];return o(n),e(n),k(n.A.h,n),n.D=new Map,n.o.clear()},i.forEach=function(n,t){var r=this;v(this[G]).forEach((function(e,i){n.call(t,r.get(i),i,r)}))},i.get=function(n){var t=this[G];o(t);var i=v(t).get(n);if(t.I||!r(i))return i;if(i!==t.t.get(n))return i;var u=E(t.A.h,i,t);return e(t),t.o.set(n,u),u},i.keys=function(){return v(this[G]).keys()},i.values=function(){var n,t=this,r=this.keys();return(n={})[H]=function(){return t.values()},n.next=function(){var n=r.next();return n.done?n:{done:!1,value:t.get(n.value)}},n},i.entries=function(){var n,t=this,r=this.keys();return(n={})[H]=function(){return t.entries()},n.next=function(){var n=r.next();if(n.done)return n;var e=t.get(n.value);return{done:!1,value:[n.value,e]}},n},i[H]=function(){return this.entries()},n}(),f=function(){function n(n,t){return this[G]={i:3,l:t,A:t?t.A:m(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}t(n,Set);var r=n.prototype;return Object.defineProperty(r,"size",{get:function(){return v(this[G]).size}}),r.has=function(n){var t=this[G];return o(t),t.o?!!t.o.has(n)||!(!t.p.has(n)||!t.o.has(t.p.get(n))):t.t.has(n)},r.add=function(n){var t=this[G];return o(t),this.has(n)||(i(t),k(t.A.h,t),t.o.add(n)),this},r.delete=function(n){if(!this.has(n))return!1;var t=this[G];return o(t),i(t),k(t.A.h,t),t.o.delete(n)||!!t.p.has(n)&&t.o.delete(t.p.get(n))},r.clear=function(){var n=this[G];return o(n),i(n),k(n.A.h,n),n.o.clear()},r.values=function(){var n=this[G];return o(n),i(n),n.o.values()},r.entries=function(){var n=this[G];return o(n),i(n),n.o.entries()},r.keys=function(){return this.values()},r[H]=function(){return this.values()},r.forEach=function(n,t){for(var r=this.values(),e=r.next();!e.done;)n.call(t,e.value,e.value,this),e=r.next()},n}();b("MapSet",{T:function(n,t){return new a(n,t)},F:function(n,t){return new f(n,t)}})}function T(){R(),N(),D()}function F(n){return n}function C(n){return n}var J,K,$="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),U="undefined"!=typeof Map,W="undefined"!=typeof Set,X="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,q=$?Symbol("immer-nothing"):((J={})["immer-nothing"]=!0,J),B=$?Symbol("immer-draftable"):"__$immer_draftable",G=$?Symbol("immer-state"):"__$immer_state",H="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",L={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},19:function(n){return"plugin not loaded: "+n},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available"},Q="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,V={},Y={get:function(n,t){if(t===G)return n;var e=n.p;if(!n.P&&u(e,t))return e[t];var i=v(n)[t];if(n.I||!r(i))return i;if(n.P){if(i!==x(n.t,t))return i;e=n.o}return e[t]=E(n.A.h,i,n)},has:function(n,t){return t in v(n)},ownKeys:function(n){return Reflect.ownKeys(v(n))},set:function(n,t,r){if(!n.P){var e=x(n.t,t);if(r?f(e,r)||r===n.p[t]:f(e,r)&&t in n.t)return!0;I(n),z(n)}return n.D[t]=!0,n.o[t]=r,!0},deleteProperty:function(n,t){return void 0!==x(n.t,t)||t in n.t?(n.D[t]=!1,I(n),z(n)):n.D[t]&&delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=v(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e&&(e.writable=!0,e.configurable=1!==n.i||"length"!==t),e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},Z={};i(Y,(function(n,t){Z[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)}})),Z.deleteProperty=function(t,r){return false&&0,Y.deleteProperty.call(this,t[0],r)},Z.set=function(t,r,e){return false&&0,Y.set.call(this,t[0],r,e,t[0])};var nn=function(){function e(n){this.g=X,this.N="production"!=="production","boolean"==typeof(null==n?void 0:n.useProxies)&&this.setUseProxies(n.useProxies),"boolean"==typeof(null==n?void 0:n.autoFreeze)&&this.setAutoFreeze(n.autoFreeze),this.produce=this.produce.bind(this),this.produceWithPatches=this.produceWithPatches.bind(this)}var i=e.prototype;return i.produce=function(t,e,i){if("function"==typeof t&&"function"!=typeof e){var o=e;e=t;var u=this;return function(n){var t=this;void 0===n&&(n=o);for(var r=arguments.length,i=Array(r>1?r-1:0),a=1;a<r;a++)i[a-1]=arguments[a];return u.produce(n,(function(n){var r;return(r=e).call.apply(r,[t,n].concat(i))}))}}var a;if("function"!=typeof e&&n(6),void 0!==i&&"function"!=typeof i&&n(7),r(t)){var f=g(this),c=E(this,t,void 0),s=!0;try{a=e(c),s=!1}finally{s?j(f):O(f)}return"undefined"!=typeof Promise&&a instanceof Promise?a.then((function(n){return _(f,i),S(n,f)}),(function(n){throw j(f),n})):(_(f,i),S(a,f))}if((a=e(t))!==q)return void 0===a&&(a=t),this.N&&d(a,!0),a},i.produceWithPatches=function(n,t){var r,e,i=this;return"function"==typeof n?function(t){for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return i.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(e))}))}:[this.produce(n,t,(function(n,t){r=n,e=t})),r,e]},i.createDraft=function(t){r(t)||n(8);var e=g(this),i=E(this,t,void 0);return i[G].C=!0,O(e),i},i.finishDraft=function(t,r){var e=t&&t[G]; false&&(0);var i=e.A;return _(i,r),S(void 0,i)},i.setAutoFreeze=function(n){this.N=n},i.setUseProxies=function(t){X||n(20),this.g=t},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=y("Patches").U;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r.slice(e+1))}))},e}(),tn=new nn,rn=tn.produce,en=tn.produceWithPatches.bind(tn),on=tn.setAutoFreeze.bind(tn),un=tn.setUseProxies.bind(tn),an=tn.applyPatches.bind(tn),fn=tn.createDraft.bind(tn),cn=tn.finishDraft.bind(tn);/* harmony default export */ var immer_esm = (rn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js








function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * @public
 */

var composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
  if (arguments.length === 0) return undefined;
  if (typeof arguments[0] === 'object') return redux/* compose */.qC;
  return redux/* compose.apply */.qC.apply(null, arguments);
};

/**
 * Returns true if the passed value is "plain" object, i.e. an object whose
 * protoype is the root `Object.prototype`. This includes objects created
 * using object literals, but not for instance for class instances.
 *
 * @param {any} value The value to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

function getTimeMeasureUtils(maxDelay, fnName) {
  var elapsed = 0;
  return {
    measureTime: function measureTime(fn) {
      var started = Date.now();

      try {
        return fn();
      } finally {
        var finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded: function warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
      }
    }
  };
}

var isProduction = (/* unused pure expression or super */ null && ("production" === 'production'));
var prefix = 'Invariant failed'; // Throw an error if the condition fails
// Strip out error messages for production
// > Not providing an inline default argument for message as the result is smaller

function invariant(condition, message) {
  if (condition) {
    return;
  } // Condition not passed
  // In production we strip the message but still throw


  if (isProduction) {
    throw new Error(prefix);
  } // When not in production we allow the message to pass through
  // *This block will be removed in production builds*


  throw new Error(prefix + ": " + (message || ''));
}

function stringify(obj, serializer, indent, decycler) {
  return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}

function getSerialize(serializer, decycler) {
  var stack = [],
      keys = [];
  if (!decycler) decycler = function decycler(_, value) {
    if (stack[0] === value) return '[Circular ~]';
    return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) value = decycler.call(this, key, value);
    } else stack.push(value);

    return serializer == null ? value : serializer.call(this, key, value);
  };
}
/**
 * The default `isImmutable` function.
 *
 * @public
 */


function isImmutableDefault(value) {
  return typeof value !== 'object' || value === null || typeof value === 'undefined';
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations: function detectMutations() {
      return _detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}

function trackProperties(isImmutable, ignorePaths, obj, path) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }

  if (path === void 0) {
    path = [];
  }

  var tracked = {
    value: obj
  };

  if (!isImmutable(obj)) {
    tracked.children = {};

    for (var key in obj) {
      var childPath = path.concat(key);

      if (ignorePaths.length && ignorePaths.indexOf(childPath.join('.')) !== -1) {
        continue;
      }

      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }

  return tracked;
}

function _detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
  if (ignorePaths === void 0) {
    ignorePaths = [];
  }

  if (sameParentRef === void 0) {
    sameParentRef = false;
  }

  if (path === void 0) {
    path = [];
  }

  var prevObj = trackedProperty ? trackedProperty.value : undefined;
  var sameRef = prevObj === obj;

  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path: path
    };
  }

  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  } // Gather all keys from prev (tracked) and after objs


  var keysToDetect = {};
  Object.keys(trackedProperty.children).forEach(function (key) {
    keysToDetect[key] = true;
  });
  Object.keys(obj).forEach(function (key) {
    keysToDetect[key] = true;
  });
  var keys = Object.keys(keysToDetect);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var childPath = path.concat(key);

    if (ignorePaths.length && ignorePaths.indexOf(childPath.join('.')) !== -1) {
      continue;
    }

    var result = _detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);

    if (result.wasMutated) {
      return result;
    }
  }

  return {
    wasMutated: false
  };
}
/**
 * Creates a middleware that checks whether any state was mutated in between
 * dispatches or during a dispatch. If any mutations are detected, an error is
 * thrown.
 *
 * @param options Middleware options.
 *
 * @public
 */


function createImmutableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  if (true) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var _options = options,
      _options$isImmutable = _options.isImmutable,
      isImmutable = _options$isImmutable === void 0 ? isImmutableDefault : _options$isImmutable,
      ignoredPaths = _options.ignoredPaths,
      _options$warnAfter = _options.warnAfter,
      warnAfter = _options$warnAfter === void 0 ? 32 : _options$warnAfter,
      ignore = _options.ignore; // Alias ignore->ignoredPaths, but prefer ignoredPaths if present

  ignoredPaths = ignoredPaths || ignore;
  var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
  return function (_ref) {
    var getState = _ref.getState;
    var state = getState();
    var tracker = track(state);
    var result;
    return function (next) {
      return function (action) {
        var measureUtils = getTimeMeasureUtils(warnAfter, 'ImmutableStateInvariantMiddleware');
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations(); // Track before potentially not meeting the invariant

          tracker = track(state);
          !!result.wasMutated ?  false ? 0 : invariant(false) : void 0;
        });
        var dispatchedAction = next(action);
        measureUtils.measureTime(function () {
          state = getState();
          result = tracker.detectMutations(); // Track before potentially not meeting the invariant

          tracker = track(state);
          result.wasMutated && (!!result.wasMutated ?  false ? 0 : invariant(false) : void 0);
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  };
}

/**
 * Returns true if the passed value is "plain", i.e. a value that is either
 * directly JSON-serializable (boolean, number, string, array, plain object)
 * or `undefined`.
 *
 * @param val The value to check.
 *
 * @public
 */

function isPlain(val) {
  return typeof val === 'undefined' || val === null || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val) || isPlainObject(val);
}
/**
 * @public
 */

function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
  if (path === void 0) {
    path = [];
  }

  if (isSerializable === void 0) {
    isSerializable = isPlain;
  }

  if (ignoredPaths === void 0) {
    ignoredPaths = [];
  }

  var foundNestedSerializable;

  if (!isSerializable(value)) {
    return {
      keyPath: path.join('.') || '<root>',
      value: value
    };
  }

  if (typeof value !== 'object' || value === null) {
    return false;
  }

  var entries = getEntries != null ? getEntries(value) : Object.entries(value);
  var hasIgnoredPaths = ignoredPaths.length > 0;

  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        property = _ref2[0],
        nestedValue = _ref2[1];
    var nestedPath = path.concat(property);

    if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath.join('.')) >= 0) {
      continue;
    }

    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath.join('.'),
        value: nestedValue
      };
    }

    if (typeof nestedValue === 'object') {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);

      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }

  return false;
}
/**
 * Creates a middleware that, after every state change, checks if the new
 * state is serializable. If a non-serializable value is found within the
 * state, an error is printed to the console.
 *
 * @param options Middleware options.
 *
 * @public
 */

function createSerializableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  if (true) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var _options = options,
      _options$isSerializab = _options.isSerializable,
      isSerializable = _options$isSerializab === void 0 ? isPlain : _options$isSerializab,
      getEntries = _options.getEntries,
      _options$ignoredActio = _options.ignoredActions,
      ignoredActions = _options$ignoredActio === void 0 ? [] : _options$ignoredActio,
      _options$ignoredActio2 = _options.ignoredActionPaths,
      ignoredActionPaths = _options$ignoredActio2 === void 0 ? ['meta.arg'] : _options$ignoredActio2,
      _options$ignoredPaths = _options.ignoredPaths,
      ignoredPaths = _options$ignoredPaths === void 0 ? [] : _options$ignoredPaths,
      _options$warnAfter = _options.warnAfter,
      warnAfter = _options$warnAfter === void 0 ? 32 : _options$warnAfter;
  return function (storeAPI) {
    return function (next) {
      return function (action) {
        if (ignoredActions.length && ignoredActions.indexOf(action.type) !== -1) {
          return next(action);
        }

        var measureUtils = getTimeMeasureUtils(warnAfter, 'SerializableStateInvariantMiddleware');
        measureUtils.measureTime(function () {
          var foundActionNonSerializableValue = findNonSerializableValue(action, [], isSerializable, getEntries, ignoredActionPaths);

          if (foundActionNonSerializableValue) {
            var keyPath = foundActionNonSerializableValue.keyPath,
                value = foundActionNonSerializableValue.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, '\nTake a look at the logic that dispatched this action: ', action, '\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)');
          }
        });
        var result = next(action);
        measureUtils.measureTime(function () {
          var state = storeAPI.getState();
          var foundStateNonSerializableValue = findNonSerializableValue(state, [], isSerializable, getEntries, ignoredPaths);

          if (foundStateNonSerializableValue) {
            var keyPath = foundStateNonSerializableValue.keyPath,
                value = foundStateNonSerializableValue.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
          }
        });
        measureUtils.warnIfExceeded();
        return result;
      };
    };
  };
}

function isBoolean(x) {
  return typeof x === 'boolean';
}
/**
 * Returns any array containing the default middleware installed by
 * `configureStore()`. Useful if you want to configure your store with a custom
 * `middleware` array but still keep the default set.
 *
 * @return The default middleware used by `configureStore()`.
 *
 * @public
 */


function getDefaultMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$thunk = _options.thunk,
      thunk = _options$thunk === void 0 ? true : _options$thunk,
      _options$immutableChe = _options.immutableCheck,
      immutableCheck = _options$immutableChe === void 0 ? true : _options$immutableChe,
      _options$serializable = _options.serializableCheck,
      serializableCheck = _options$serializable === void 0 ? true : _options$serializable;
  var middlewareArray = [];

  if (thunk) {
    if (isBoolean(thunk)) {
      middlewareArray.push(es);
    } else {
      middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
    }
  }

  if (false) { var serializableOptions, immutableOptions; }

  return middlewareArray;
}

var IS_PRODUCTION = "production" === 'production';
/**
 * A friendly abstraction over the standard Redux `createStore()` function.
 *
 * @param config The store configuration.
 * @returns A configured Redux store.
 *
 * @public
 */

function configureStore(options) {
  var _ref = options || {},
      _ref$reducer = _ref.reducer,
      reducer = _ref$reducer === void 0 ? undefined : _ref$reducer,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? getDefaultMiddleware() : _ref$middleware,
      _ref$devTools = _ref.devTools,
      devTools = _ref$devTools === void 0 ? true : _ref$devTools,
      _ref$preloadedState = _ref.preloadedState,
      preloadedState = _ref$preloadedState === void 0 ? undefined : _ref$preloadedState,
      _ref$enhancers = _ref.enhancers,
      enhancers = _ref$enhancers === void 0 ? undefined : _ref$enhancers;

  var rootReducer;

  if (typeof reducer === 'function') {
    rootReducer = reducer;
  } else if (isPlainObject(reducer)) {
    rootReducer = (0,redux/* combineReducers */.UY)(reducer);
  } else {
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  }

  var middlewareEnhancer = redux/* applyMiddleware.apply */.md.apply(void 0, middleware);
  var finalCompose = redux/* compose */.qC;

  if (devTools) {
    finalCompose = composeWithDevTools(_extends({
      // Enable capture of stack traces for dispatched Redux actions
      trace: !IS_PRODUCTION
    }, typeof devTools === 'object' && devTools));
  }

  var storeEnhancers = [middlewareEnhancer];

  if (Array.isArray(enhancers)) {
    storeEnhancers = [middlewareEnhancer].concat(enhancers);
  } else if (typeof enhancers === 'function') {
    storeEnhancers = enhancers(storeEnhancers);
  }

  var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
  return (0,redux/* createStore */.MT)(rootReducer, preloadedState, composedEnhancer);
}

function createAction(type, prepareAction) {
  function actionCreator() {
    if (prepareAction) {
      var prepared = prepareAction.apply(void 0, arguments);

      if (!prepared) {
        throw new Error('prepareAction did not return an object');
      }

      return _extends({
        type: type,
        payload: prepared.payload
      }, 'meta' in prepared && {
        meta: prepared.meta
      }, {}, 'error' in prepared && {
        error: prepared.error
      });
    }

    return {
      type: type,
      payload: arguments.length <= 0 ? undefined : arguments[0]
    };
  }

  actionCreator.toString = function () {
    return "" + type;
  };

  actionCreator.type = type;

  actionCreator.match = function (action) {
    return action.type === type;
  };

  return actionCreator;
}
function isFSA(action) {
  return isPlainObject(action) && typeof action.type === 'string' && Object.keys(action).every(isValidKey);
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}
/**
 * Returns the action type of the actions created by the passed
 * `createAction()`-generated action creator (arbitrary action creators
 * are not supported).
 *
 * @param action The action creator whose action type to get.
 * @returns The action type used by the action creator.
 *
 * @public
 */


function getType(actionCreator) {
  return "" + actionCreator;
}

function executeReducerBuilderCallback(builderCallback) {
  var actionsMap = {};
  var builder = {
    addCase: function addCase(typeOrActionCreator, reducer) {
      var type = typeof typeOrActionCreator === 'string' ? typeOrActionCreator : typeOrActionCreator.type;

      if (type in actionsMap) {
        throw new Error('addCase cannot be called with two reducers for the same action type');
      }

      actionsMap[type] = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return actionsMap;
}

function createReducer(initialState, mapOrBuilderCallback) {
  var actionsMap = typeof mapOrBuilderCallback === 'function' ? executeReducerBuilderCallback(mapOrBuilderCallback) : mapOrBuilderCallback;
  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    var caseReducer = actionsMap[action.type];

    if (caseReducer) {
      if (t(state)) {
        // we must already be inside a `createNextState` call, likely because
        // this is being wrapped in `createReducer`, `createSlice`, or nested
        // inside an existing draft. It's safe to just pass the draft to the mutator.
        var draft = state; // We can aassume this is already a draft

        return caseReducer(draft, action) || state;
      } else {
        // @ts-ignore createNextState() produces an Immutable<Draft<S>> rather
        // than an Immutable<S>, and TypeScript cannot find out how to reconcile
        // these two types.
        return immer_esm(state, function (draft) {
          return caseReducer(draft, action);
        });
      }
    }

    return state;
  };
}

function getType$1(slice, actionKey) {
  return slice + "/" + actionKey;
}
/**
 * A function that accepts an initial state, an object full of reducer
 * functions, and a "slice name", and automatically generates
 * action creators and action types that correspond to the
 * reducers and state.
 *
 * The `reducer` argument is passed to `createReducer()`.
 *
 * @public
 */


function createSlice(options) {
  var name = options.name,
      initialState = options.initialState;

  if (!name) {
    throw new Error('`name` is a required option for createSlice');
  }

  var reducers = options.reducers || {};
  var extraReducers = typeof options.extraReducers === 'undefined' ? {} : typeof options.extraReducers === 'function' ? executeReducerBuilderCallback(options.extraReducers) : options.extraReducers;
  var reducerNames = Object.keys(reducers);
  var sliceCaseReducersByName = {};
  var sliceCaseReducersByType = {};
  var actionCreators = {};
  reducerNames.forEach(function (reducerName) {
    var maybeReducerWithPrepare = reducers[reducerName];
    var type = getType$1(name, reducerName);
    var caseReducer;
    var prepareCallback;

    if ('reducer' in maybeReducerWithPrepare) {
      caseReducer = maybeReducerWithPrepare.reducer;
      prepareCallback = maybeReducerWithPrepare.prepare;
    } else {
      caseReducer = maybeReducerWithPrepare;
    }

    sliceCaseReducersByName[reducerName] = caseReducer;
    sliceCaseReducersByType[type] = caseReducer;
    actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
  });

  var finalCaseReducers = _extends({}, extraReducers, {}, sliceCaseReducersByType);

  var reducer = createReducer(initialState, finalCaseReducers);
  return {
    name: name,
    reducer: reducer,
    actions: actionCreators,
    caseReducers: sliceCaseReducersByName
  };
}

function getInitialEntityState() {
  return {
    ids: [],
    entities: {}
  };
}
function createInitialStateFactory() {
  function getInitialState(additionalState) {
    if (additionalState === void 0) {
      additionalState = {};
    }

    return Object.assign(getInitialEntityState(), additionalState);
  }

  return {
    getInitialState: getInitialState
  };
}

function createSelectorsFactory() {
  function getSelectors(selectState) {
    var selectIds = function selectIds(state) {
      return state.ids;
    };

    var selectEntities = function selectEntities(state) {
      return state.entities;
    };

    var selectAll = createSelector(selectIds, selectEntities, function (ids, entities) {
      return ids.map(function (id) {
        return entities[id];
      });
    });

    var selectId = function selectId(_, id) {
      return id;
    };

    var selectById = function selectById(entities, id) {
      return entities[id];
    };

    var selectTotal = createSelector(selectIds, function (ids) {
      return ids.length;
    });

    if (!selectState) {
      return {
        selectIds: selectIds,
        selectEntities: selectEntities,
        selectAll: selectAll,
        selectTotal: selectTotal,
        selectById: createSelector(selectEntities, selectId, selectById)
      };
    }

    var selectGlobalizedEntities = createSelector(selectState, selectEntities);
    return {
      selectIds: createSelector(selectState, selectIds),
      selectEntities: selectGlobalizedEntities,
      selectAll: createSelector(selectState, selectAll),
      selectTotal: createSelector(selectState, selectTotal),
      selectById: createSelector(selectGlobalizedEntities, selectId, selectById)
    };
  }

  return {
    getSelectors: getSelectors
  };
}

function createSingleArgumentStateOperator(mutator) {
  var operator = createStateOperator(function (_, state) {
    return mutator(state);
  });
  return function operation(state) {
    return operator(state, undefined);
  };
}
function createStateOperator(mutator) {
  return function operation(state, arg) {
    function isPayloadActionArgument(arg) {
      return isFSA(arg);
    }

    var runMutator = function runMutator(draft) {
      if (isPayloadActionArgument(arg)) {
        mutator(arg.payload, draft);
      } else {
        mutator(arg, draft);
      }
    };

    if (isDraft(state)) {
      // we must already be inside a `createNextState` call, likely because
      // this is being wrapped in `createReducer` or `createSlice`.
      // It's safe to just pass the draft to the mutator.
      runMutator(state); // since it's a draft, we'll just return it

      return state;
    } else {
      // @ts-ignore createNextState() produces an Immutable<Draft<S>> rather
      // than an Immutable<S>, and TypeScript cannot find out how to reconcile
      // these two types.
      return createNextState(state, runMutator);
    }
  };
}

function selectIdValue(entity, selectId) {
  var key = selectId(entity);

  if (false) {}

  return key;
}

function createUnsortedStateAdapter(selectId) {
  function addOneMutably(entity, state) {
    var key = selectIdValue(entity, selectId);

    if (key in state.entities) {
      return;
    }

    state.ids.push(key);
    state.entities[key] = entity;
  }

  function addManyMutably(entities, state) {
    if (!Array.isArray(entities)) {
      entities = Object.values(entities);
    }

    for (var _iterator = entities, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var entity = _ref;
      addOneMutably(entity, state);
    }
  }

  function setAllMutably(entities, state) {
    if (!Array.isArray(entities)) {
      entities = Object.values(entities);
    }

    state.ids = [];
    state.entities = {};
    addManyMutably(entities, state);
  }

  function removeOneMutably(key, state) {
    return removeManyMutably([key], state);
  }

  function removeManyMutably(keys, state) {
    var didMutate = false;
    keys.forEach(function (key) {
      if (key in state.entities) {
        delete state.entities[key];
        didMutate = true;
      }
    });

    if (didMutate) {
      state.ids = state.ids.filter(function (id) {
        return id in state.entities;
      });
    }
  }

  function removeAllMutably(state) {
    Object.assign(state, {
      ids: [],
      entities: {}
    });
  }

  function takeNewKey(keys, update, state) {
    var original = state.entities[update.id];
    var updated = Object.assign({}, original, update.changes);
    var newKey = selectIdValue(updated, selectId);
    var hasNewKey = newKey !== update.id;

    if (hasNewKey) {
      keys[update.id] = newKey;
      delete state.entities[update.id];
    }

    state.entities[newKey] = updated;
    return hasNewKey;
  }

  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }

  function updateManyMutably(updates, state) {
    var newKeys = {};
    var updatesPerEntity = {};
    updates.forEach(function (update) {
      // Only apply updates to entities that currently exist
      if (update.id in state.entities) {
        // If there are multiple updates to one entity, merge them together
        updatesPerEntity[update.id] = _extends({}, updatesPerEntity[update.id], {}, update);
      }
    });
    updates = Object.values(updatesPerEntity);
    var didMutateEntities = updates.length > 0;

    if (didMutateEntities) {
      var didMutateIds = updates.filter(function (update) {
        return takeNewKey(newKeys, update, state);
      }).length > 0;

      if (didMutateIds) {
        state.ids = state.ids.map(function (id) {
          return newKeys[id] || id;
        });
      }
    }
  }

  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }

  function upsertManyMutably(entities, state) {
    if (!Array.isArray(entities)) {
      entities = Object.values(entities);
    }

    var added = [];
    var updated = [];

    for (var _iterator2 = entities, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var entity = _ref2;
      var id = selectIdValue(entity, selectId);

      if (id in state.entities) {
        updated.push({
          id: id,
          changes: entity
        });
      } else {
        added.push(entity);
      }
    }

    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }

  return {
    removeAll: createSingleArgumentStateOperator(removeAllMutably),
    addOne: createStateOperator(addOneMutably),
    addMany: createStateOperator(addManyMutably),
    setAll: createStateOperator(setAllMutably),
    updateOne: createStateOperator(updateOneMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    upsertMany: createStateOperator(upsertManyMutably),
    removeOne: createStateOperator(removeOneMutably),
    removeMany: createStateOperator(removeManyMutably)
  };
}

function createSortedStateAdapter(selectId, sort) {
  var _createUnsortedStateA = createUnsortedStateAdapter(selectId),
      removeOne = _createUnsortedStateA.removeOne,
      removeMany = _createUnsortedStateA.removeMany,
      removeAll = _createUnsortedStateA.removeAll;

  function addOneMutably(entity, state) {
    return addManyMutably([entity], state);
  }

  function addManyMutably(newModels, state) {
    if (!Array.isArray(newModels)) {
      newModels = Object.values(newModels);
    }

    var models = newModels.filter(function (model) {
      return !(selectIdValue(model, selectId) in state.entities);
    });

    if (models.length !== 0) {
      merge(models, state);
    }
  }

  function setAllMutably(models, state) {
    if (!Array.isArray(models)) {
      models = Object.values(models);
    }

    state.entities = {};
    state.ids = [];
    addManyMutably(models, state);
  }

  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }

  function takeUpdatedModel(models, update, state) {
    if (!(update.id in state.entities)) {
      return false;
    }

    var original = state.entities[update.id];
    var updated = Object.assign({}, original, update.changes);
    var newKey = selectIdValue(updated, selectId);
    delete state.entities[update.id];
    models.push(updated);
    return newKey !== update.id;
  }

  function updateManyMutably(updates, state) {
    var models = [];
    updates.forEach(function (update) {
      return takeUpdatedModel(models, update, state);
    });

    if (models.length !== 0) {
      merge(models, state);
    }
  }

  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }

  function upsertManyMutably(entities, state) {
    if (!Array.isArray(entities)) {
      entities = Object.values(entities);
    }

    var added = [];
    var updated = [];

    for (var _iterator = entities, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var entity = _ref;
      var id = selectIdValue(entity, selectId);

      if (id in state.entities) {
        updated.push({
          id: id,
          changes: entity
        });
      } else {
        added.push(entity);
      }
    }

    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }

  function areArraysEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0; i < a.length && i < b.length; i++) {
      if (a[i] === b[i]) {
        continue;
      }

      return false;
    }

    return true;
  }

  function merge(models, state) {
    models.sort(sort); // Insert/overwrite all new/updated

    models.forEach(function (model) {
      state.entities[selectId(model)] = model;
    });
    var allEntities = Object.values(state.entities);
    allEntities.sort(sort);
    var newSortedIds = allEntities.map(selectId);
    var ids = state.ids;

    if (!areArraysEqual(ids, newSortedIds)) {
      state.ids = newSortedIds;
    }
  }

  return {
    removeOne: removeOne,
    removeMany: removeMany,
    removeAll: removeAll,
    addOne: createStateOperator(addOneMutably),
    updateOne: createStateOperator(updateOneMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    setAll: createStateOperator(setAllMutably),
    addMany: createStateOperator(addManyMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertMany: createStateOperator(upsertManyMutably)
  };
}

/**
 *
 * @param options
 *
 * @public
 */

function createEntityAdapter(options) {
  if (options === void 0) {
    options = {};
  }

  var _sortComparer$selectI = _extends({
    sortComparer: false,
    selectId: function selectId(instance) {
      return instance.id;
    }
  }, options),
      selectId = _sortComparer$selectI.selectId,
      sortComparer = _sortComparer$selectI.sortComparer;

  var stateFactory = createInitialStateFactory();
  var selectorsFactory = createSelectorsFactory();
  var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
  return _extends({
    selectId: selectId,
    sortComparer: sortComparer
  }, stateFactory, {}, selectorsFactory, {}, stateAdapter);
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Borrowed from https://github.com/ai/nanoid/blob/3.0.2/non-secure/index.js
// This alphabet uses `A-Za-z0-9_-` symbols. A genetic algorithm helped
// optimize the gzip compression for this alphabet.
var urlAlphabet = 'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW';
/**
 *
 * @public
 */

var nanoid = function nanoid(size) {
  if (size === void 0) {
    size = 21;
  }

  var id = ''; // A compact alternative for `for (var i = 0; i < step; i++)`.

  var i = size;

  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[Math.random() * 64 | 0];
  }

  return id;
};

var commonProperties = ['name', 'message', 'stack', 'code'];

var RejectWithValue = function RejectWithValue(value) {
  this.value = value;
}; // Reworked from https://github.com/sindresorhus/serialize-error


var miniSerializeError = function miniSerializeError(value) {
  if (typeof value === 'object' && value !== null) {
    var simpleError = {};

    for (var _iterator = commonProperties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var property = _ref;

      if (typeof value[property] === 'string') {
        simpleError[property] = value[property];
      }
    }

    return simpleError;
  }

  return {
    message: String(value)
  };
};
/**
 *
 * @param typePrefix
 * @param payloadCreator
 * @param options
 *
 * @public
 */

function createAsyncThunk(typePrefix, payloadCreator, options) {
  var fulfilled = createAction(typePrefix + '/fulfilled', function (result, requestId, arg) {
    return {
      payload: result,
      meta: {
        arg: arg,
        requestId: requestId
      }
    };
  });
  var pending = createAction(typePrefix + '/pending', function (requestId, arg) {
    return {
      payload: undefined,
      meta: {
        arg: arg,
        requestId: requestId
      }
    };
  });
  var rejected = createAction(typePrefix + '/rejected', function (error, requestId, arg, payload) {
    var aborted = !!error && error.name === 'AbortError';
    var condition = !!error && error.name === 'ConditionError';
    return {
      payload: payload,
      error: miniSerializeError(error || 'Rejected'),
      meta: {
        arg: arg,
        requestId: requestId,
        aborted: aborted,
        condition: condition
      }
    };
  });
  var displayedWarning = false;
  var AC = typeof AbortController !== 'undefined' ? AbortController :
  /*#__PURE__*/
  function () {
    function _class() {
      this.signal = {
        aborted: false,
        addEventListener: function addEventListener() {},
        dispatchEvent: function dispatchEvent() {
          return false;
        },
        onabort: function onabort() {},
        removeEventListener: function removeEventListener() {}
      };
    }

    var _proto = _class.prototype;

    _proto.abort = function abort() {
      if (false) {}
    };

    return _class;
  }();

  function actionCreator(arg) {
    return function (dispatch, getState, extra) {
      var requestId = nanoid();
      var abortController = new AC();
      var abortReason;
      var abortedPromise = new Promise(function (_, reject) {
        return abortController.signal.addEventListener('abort', function () {
          return reject({
            name: 'AbortError',
            message: abortReason || 'Aborted'
          });
        });
      });

      function abort(reason) {
        abortReason = reason;
        abortController.abort();
      }

      var promise = function () {
        try {
          var _temp3 = function _temp3(_result) {
            if (_exit2) return _result;
            // We dispatch the result action _after_ the catch, to avoid having any errors
            // here get swallowed by the try/catch block,
            // per https://twitter.com/dan_abramov/status/770914221638942720
            // and https://redux-toolkit.js.org/tutorials/advanced-tutorial#async-error-handling-logic-in-thunks
            var skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;

            if (!skipDispatch) {
              dispatch(finalAction);
            }

            return finalAction;
          };

          var _exit2 = false;
          var finalAction;

          var _temp4 = _catch(function () {
            if (options && options.condition && options.condition(arg, {
              getState: getState,
              extra: extra
            }) === false) {
              throw {
                name: 'ConditionError',
                message: 'Aborted due to condition callback returning false.'
              };
            }

            dispatch(pending(requestId, arg));
            return Promise.resolve(Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch: dispatch,
              getState: getState,
              extra: extra,
              requestId: requestId,
              signal: abortController.signal,
              rejectWithValue: function rejectWithValue(value) {
                return new RejectWithValue(value);
              }
            })).then(function (result) {
              if (result instanceof RejectWithValue) {
                return rejected(null, requestId, arg, result.value);
              }

              return fulfilled(result, requestId, arg);
            })])).then(function (_Promise$race) {
              finalAction = _Promise$race;
            });
          }, function (err) {
            finalAction = rejected(err, requestId, arg);
          });

          return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
        } catch (e) {
          return Promise.reject(e);
        }
      }();

      return Object.assign(promise, {
        abort: abort
      });
    };
  }

  return Object.assign(actionCreator, {
    pending: pending,
    rejected: rejected,
    fulfilled: fulfilled,
    typePrefix: typePrefix
  });
}
/**
 * @public
 */

function unwrapResult(returned) {
  if ('error' in returned) {
    throw returned.error;
  }

  return returned.payload;
}

// we assume RTK will be used with React Native and other Proxy-less
// environments.  In addition, that's how Immer 4 behaved, and since
// we want to ship this in an RTK minor, we should keep the same behavior.

R();


//# sourceMappingURL=redux-toolkit.esm.js.map


/***/ }),

/***/ 89891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dr": function() { return /* binding */ eventFromException; },
  "aB": function() { return /* binding */ eventFromMessage; },
  "ME": function() { return /* binding */ eventFromUnknownInput; },
  "GJ": function() { return /* binding */ exceptionFromError; }
});

// UNUSED EXPORTS: eventFromError, eventFromPlainObject, eventFromString, parseStackFrames

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(34754);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var esm_stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0,object/* extractExceptionKeysForMessage */.zf)(exception),
                },
            ],
        },
        extra: {
            __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return (0,esm_stacktrace/* createStackParser */.pE)(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = severity/* Severity.Error */.z.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = severity/* Severity.Info */.z.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            (0,misc/* addExceptionTypeValue */.Db)(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if ((0,is/* isError */.VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        (0,misc/* addExceptionMechanism */.EG)(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionTypeValue */.Db)(event, "" + exception, undefined);
    (0,misc/* addExceptionMechanism */.EG)(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),

/***/ 24326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 86891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ injectReportDialog; },
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39666);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1984);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12343);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24326);




var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
                    }
                    event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, event.extra), { arguments: args });
                    return event;
                });
                (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global.document) {
        return;
    }
    if (!options.eventId) {
        _flags__WEBPACK_IMPORTED_MODULE_5__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .kg.error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        _flags__WEBPACK_IMPORTED_MODULE_5__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .kg.error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = global.document.createElement('script');
    script.async = true;
    script.src = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getReportDialogEndpoint */ .hR)(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 39038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 2 modules
var hub = __webpack_require__(6242);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/enums.js
var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return severity/* Severity.Warning */.z.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return severity/* Severity.Log */.z.Log;
}
//# sourceMappingURL=severity.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0,misc/* getEventDescription */.jH)(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target, keyAttrs)
                : (0,browser/* htmlTreeAsString */.R)(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: severity/* Severity.Error */.z.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
    var parsedFrom = (0,misc/* parseUrl */.en)(from);
    var parsedTo = (0,misc/* parseUrl */.en)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),

/***/ 69730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24326);


/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        _flags__WEBPACK_IMPORTED_MODULE_0__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map

/***/ }),

/***/ 52136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6242);
/* harmony import */ var _sentry_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13819);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9732);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58464);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62844);
/* harmony import */ var _eventbuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89891);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24326);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86891);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addInstrumentationHandler */ .o)('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */ .CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame((0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .eventFromUnknownInput */ .ME)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = _sentry_types__WEBPACK_IMPORTED_MODULE_5__/* .Severity.Error */ .z.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addInstrumentationHandler */ .o)('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */ .CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPrimitive */ .pt)(error)
            ? _eventFromRejectionWithPrimitive(error)
            : (0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .eventFromUnknownInput */ .ME)(error, undefined, attachStacktrace, true);
        event.level = _sentry_types__WEBPACK_IMPORTED_MODULE_5__/* .Severity.Error */ .z.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getLocationHref */ .l)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    _flags__WEBPACK_IMPORTED_MODULE_7__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .logger.log */ .kg.log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .addExceptionMechanism */ .EG)(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_10__/* .getCurrentHub */ .Gd)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map

/***/ }),

/***/ 61634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iP": function() { return /* binding */ LinkedErrors; }
/* harmony export */ });
/* unused harmony exports _handler, _walkErrorTree */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46769);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _eventbuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89891);




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addGlobalEventProcessor */ .c)(function (event, hint) {
            var self = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__spread */ .fl)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = (0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .exceptionFromError */ .GJ)(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__spread */ .fl)([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map

/***/ }),

/***/ 53692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30360);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86891);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
        if (this._options.setTimeout) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(originalCallback, {
            mechanism: {
                data: { function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }),
        ]);
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getOriginalFunction */ .HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }),
                options,
            ]);
        };
    });
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map

/***/ }),

/***/ 33931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserAgent; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46769);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6242);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);



var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalEventProcessor */ .c)(function (event) {
            if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (global.location && global.location.href);
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, (url && { url: url })), { headers: headers });
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),

/***/ 28455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yl": function() { return /* binding */ flush; },
  "S1": function() { return /* binding */ init; }
});

// UNUSED EXPORTS: close, defaultIntegrations, forceLoad, lastEventId, onLoad, showReportDialog, wrap

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 2 modules
var esm_hub = __webpack_require__(6242);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/flags.js
var flags = __webpack_require__(53298);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (flags/* IS_DEBUG_BUILD */.h) {
            esm_logger/* logger.enable */.kg.enable();
        }
        else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        }
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(42422);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(19116);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(46769);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(30292);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(34754);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/error.js + 1 modules
var error = __webpack_require__(77047);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && (0,tslib_es6/* __spread */.fl)(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = (0,tslib_es6/* __spread */.fl)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = (0,tslib_es6/* __spread */.fl)(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, (0,tslib_es6/* __spread */.fl)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0,object/* addNonEnumerableProperty */.xp)(integrations, 'initialized', true);
    return integrations;
}
//# sourceMappingURL=integration.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js

/* eslint-disable max-lines */




var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = (0,dsn/* makeDsn */.v)(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0,is/* isPrimitive */.pt)(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = (0,tslib_es6/* __values */.XA)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new syncpromise/* SyncPromise */.cW(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)()), timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, evt.sdkProcessingMetadata), { normalizeDepth: (0,normalize/* normalize */.Fv)(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
        if (!event) {
            return null;
        }
        var normalized = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, b), (b.data && {
                data: (0,normalize/* normalize */.Fv)(b.data, depth, maxBreadth),
            }))); }),
        })), (event.user && {
            user: (0,normalize/* normalize */.Fv)(event.user, depth, maxBreadth),
        })), (event.contexts && {
            contexts: (0,normalize/* normalize */.Fv)(event.contexts, depth, maxBreadth),
        })), (event.extra && {
            extra: (0,normalize/* normalize */.Fv)(event.extra, depth, maxBreadth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        normalized.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new error/* SentryError */.b('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new error/* SentryError */.b('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof error/* SentryError */.b) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new error/* SentryError */.b("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then(function (event) {
            if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
                throw new error/* SentryError */.b(nullErr);
            }
            return event;
        }, function (e) {
            throw new error/* SentryError */.b("beforeSend rejected with " + e);
        });
    }
    else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
        throw new error/* SentryError */.b(nullErr);
    }
    return rv;
}
//# sourceMappingURL=baseclient.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var esm_api = __webpack_require__(1984);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items) {
    if (items === void 0) { items = []; }
    return [headers, items];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
    var _a = __read(envelope, 2), headers = _a[0], items = _a[1];
    return [headers, __spread(items, [newItem])];
}
/**
 * Get the type of the envelope. Grabs the type from the first envelope item.
 */
function getEnvelopeType(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), _b = (0,tslib_es6/* __read */.CR)(_a[1], 1), _c = (0,tslib_es6/* __read */.CR)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
/**
 * Serializes an envelope into a string.
 */
function serializeEnvelope(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function (acc, item) {
        var _a = (0,tslib_es6/* __read */.CR)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0,is/* isPrimitive */.pt)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}
//# sourceMappingURL=envelope.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/request.js



/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = (0,tslib_es6/* __spread */.fl)((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */
function createSessionEnvelope(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [{ type: type }, session];
    var envelope = createEnvelope(envelopeHeaders, [envelopeItem]);
    return [envelope, type];
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: serializeEnvelope(envelope),
        type: type,
        url: (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel),
    };
}
/**
 * Create an Envelope from an event. Note that this is duplicated from below,
 * but on purpose as this will be refactored in v7.
 */
function createEventEnvelope(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
    var eventItem = [
        {
            type: eventType,
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        },
        event,
    ];
    return createEnvelope(envelopeHeaders, [eventItem]);
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0,normalize/* normalize */.Fv)(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel)
            : (0,esm_api/* getStoreEndpointWithUrlEncodedAuth */.qi)(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
        var eventItem = [
            {
                type: eventType,
                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
            },
            req.body,
        ];
        var envelope = createEnvelope(envelopeHeaders, [eventItem]);
        req.body = serializeEnvelope(envelope);
    }
    return req;
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/noop.js

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/basebackend.js






/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new error/* SentryError */.b('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new error/* SentryError */.b('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = (0,esm_api/* initAPIDetails */.hd)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = createEventEnvelope(event, api);
            void this._newTransport.send(env).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
        else {
            void this._transport.sendEvent(event).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = (0,esm_api/* initAPIDetails */.hd)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 1), env = _a[0];
            void this._newTransport.send(env).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
        else {
            void this._transport.sendSession(session).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js + 1 modules
var eventbuilder = __webpack_require__(89891);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}
//# sourceMappingURL=promisebuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now) {
    if (now === void 0) { now = Date.now(); }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now) {
    if (now === void 0) { now = Date.now(); }
    return disabledUntil(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) { now = Date.now(); }
    var updatedRateLimits = (0,tslib_es6/* __assign */.pi)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) {
        try {
            /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */
            for (var _c = (0,tslib_es6/* __values */.XA)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!parameters[1]) {
                    updatedRateLimits.all = now + delay;
                }
                else {
                    try {
                        for (var _e = (e_2 = void 0, (0,tslib_es6/* __values */.XA)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            updatedRateLimits[category] = now + delay;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    }
    return updatedRateLimits;
}
//# sourceMappingURL=ratelimit.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/status.js
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}
//# sourceMappingURL=status.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js

var ERROR_TRANSPORT_CATEGORY = 'error';
var TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
var ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
var SESSION_TRANSPORT_CATEGORY = 'session';
var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates a `NewTransport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(options, makeRequest, buffer) {
    if (buffer === void 0) { buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE); }
    var rateLimits = {};
    var flush = function (timeout) { return buffer.drain(timeout); };
    function send(envelope) {
        var envCategory = getEnvelopeType(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: serializeEnvelope(envelope),
        };
        // Don't add to buffer if transport is already rate-limited
        if (isRateLimited(rateLimits, category)) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)({
                status: 'rate_limit',
                reason: getRateLimitReason(rateLimits, category),
            });
        }
        var requestTask = function () {
            return makeRequest(request).then(function (_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = eventStatusFromHttpCode(statusCode);
                if (headers) {
                    rateLimits = updateRateLimits(rateLimits, headers);
                }
                if (status === 'success') {
                    return (0,syncpromise/* resolvedSyncPromise */.WD)({ status: status, reason: reason });
                }
                return (0,syncpromise/* rejectedSyncPromise */.$2)({
                    status: status,
                    reason: reason ||
                        body ||
                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush,
    };
}
function getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date(disabledUntil(rateLimits, category)).toISOString();
}
//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/async.js
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/flags.js
var esm_flags = __webpack_require__(24326);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js


var utils_global = (0,global/* getGlobalObject */.R)();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if ((0,supports/* isNativeFetch */.Du)(utils_global.fetch)) {
        return (cachedFetchImpl = utils_global.fetch.bind(utils_global));
    }
    var document = utils_global.document;
    var fetchImpl = utils_global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(utils_global));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(utils_global && utils_global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof utils_global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = utils_global.navigator.sendBeacon.bind(utils_global.navigator);
        return sendBeacon(url, body);
    }
    if ((0,supports/* supportsFetch */.Ak)()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/new-fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeNewFetchTransport(options, nativeFetch) {
    if (nativeFetch === void 0) { nativeFetch = getNativeFetchImplementation(); }
    function makeRequest(request) {
        var requestOptions = (0,tslib_es6/* __assign */.pi)({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function (response) {
            return response.text().then(function (body) { return ({
                body: body,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                },
                reason: response.statusText,
                statusCode: response.status,
            }); });
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js


/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        { type: 'client_report' },
        {
            timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
            discarded_events: discarded_events,
        },
    ];
    return createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
}
//# sourceMappingURL=clientreport.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/base.js





function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var base_global = (0,global/* getGlobalObject */.R)();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = (0,esm_api/* initAPIDetails */.hd)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0,esm_api/* getStoreEndpointWithUrlEncodedAuth */.qi)(this._api.dsn);
        if (this.options.sendClientReports && base_global.document) {
            base_global.document.addEventListener('visibilitychange', function () {
                if (base_global.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('No outcomes to flush');
            return;
        }
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function (key) {
            var _a = (0,tslib_es6/* __read */.CR)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key],
            };
            // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = createClientReportEnvelope(discardedEvents, this._api.tunnel && (0,dsn/* dsnToString */.R)(this._api.dsn));
        try {
            sendReport(url, serializeEnvelope(envelope));
        }
        catch (e) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        this._rateLimits = updateRateLimits(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                // eslint-disable-next-line deprecation/deprecation
                esm_logger/* logger.warn */.kg.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return new Date(disabledUntil(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return isRateLimited(this._rateLimits, category);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: ((0,supports/* supportsReferrerPolicy */.hv)() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error/* SentryError */.b) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/new-xhr.js


/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeNewXHRTransport(options) {
    function makeRequest(request) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After'),
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status,
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for (var header in options.headers) {
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error/* SentryError */.b) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

//# sourceMappingURL=xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/backend.js






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return (0,eventbuilder/* eventFromException */.dr)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = severity/* Severity.Info */.z.Info; }
        return (0,eventbuilder/* eventFromMessage */.aB)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        var api = (0,esm_api/* initAPIDetails */.hd)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel);
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if ((0,supports/* supportsFetch */.Ak)()) {
            var requestOptions = (0,tslib_es6/* __assign */.pi)({}, transportOptions.fetchParameters);
            this._newTransport = makeNewFetchTransport({ requestOptions: requestOptions, url: url });
            return new FetchTransport(transportOptions);
        }
        this._newTransport = makeNewXHRTransport({
            url: url,
            headers: transportOptions.headers,
        });
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

//# sourceMappingURL=backend.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 2 modules
var breadcrumbs = __webpack_require__(39038);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: version/* SDK_VERSION */.J,
                },
            ],
            version: version/* SDK_VERSION */.J,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = (0,global/* getGlobalObject */.R)().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0,helpers/* injectReportDialog */.BS)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(breadcrumbs/* Breadcrumbs */.O);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

//# sourceMappingURL=client.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(52136);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(61634);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(69730);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/useragent.js
var useragent = __webpack_require__(33931);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js







var defaultIntegrations = [
    new inboundfilters/* InboundFilters */.QD(),
    new functiontostring/* FunctionToString */.c(),
    new trycatch/* TryCatch */.p(),
    new breadcrumbs/* Breadcrumbs */.O(),
    new globalhandlers/* GlobalHandlers */.d(),
    new linkederrors/* LinkedErrors */.iP(),
    new dedupe/* Dedupe */.I(),
    new useragent/* UserAgent */.Z(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = (0,global/* getGlobalObject */.R)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = __assign(__assign({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (client) {
        return client.flush(timeout);
    }
    esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
    return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    IS_DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
    return resolvedSyncPromise(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return internalWrap(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = (0,global/* getGlobalObject */.R)();
    var document = window.document;
    if (typeof document === 'undefined') {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
        }
    });
}
//# sourceMappingURL=sdk.js.map

/***/ }),

/***/ 1984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ut": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "hR": function() { return /* binding */ getReportDialogEndpoint; },
/* harmony export */   "hd": function() { return /* binding */ initAPIDetails; },
/* harmony export */   "qi": function() { return /* binding */ getStoreEndpointWithUrlEncodedAuth; }
/* harmony export */ });
/* unused harmony exports API, getRequestHeaders */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30292);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata, tunnel) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */
    API.prototype.forceEnvelope = function () {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        return getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
    };
    return API;
}());

/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .urlEncode */ ._j)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/**
 * Returns an object that can be used in request headers.
 * This is needed for node and the old /store endpoint in sentry
 */
function getRequestHeaders(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) {
        header.push("sentry_secret=" + dsn.pass);
    }
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', '),
    };
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .R)(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}
//# sourceMappingURL=api.js.map

/***/ }),

/***/ 53298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 19116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FunctionToString; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20535);

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QD": function() { return /* binding */ InboundFilters; }
/* harmony export */ });
/* unused harmony exports _mergeOptions, _shouldDropEvent */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57321);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53298);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

/** JSDoc */
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) { internalOptions = {}; }
    if (clientOptions === void 0) { clientOptions = {}; }
    return {
        allowUrls: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
        denyUrls: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
        ignoreErrors: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
    };
}
/** JSDoc */
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function (message) {
        return ignoreErrors.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(message, pattern); });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(url, pattern); });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(url, pattern); });
}
function _getPossibleEventMessages(event) {
    if (event.message) {
        return [event.message];
    }
    if (event.exception) {
        try {
            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
            return ["" + value, type + ": " + value];
        }
        catch (oO) {
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Cannot extract message for event " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
            return [];
        }
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    }
    catch (e) {
        // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) { frames = []; }
    for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) {
            return _getLastValidUrl(event.stacktrace.frames);
        }
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        }
        catch (e) {
            // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    }
    catch (oO) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Cannot extract url for event " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return null;
    }
}
//# sourceMappingURL=inboundfilters.js.map

/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 6242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* binding */ Hub; },
  "Gd": function() { return /* binding */ getCurrentHub; },
  "cu": function() { return /* binding */ getMainCarrier; }
});

// UNUSED EXPORTS: API_VERSION, getActiveDomain, getHubFromCarrier, makeMain, setHubOnCarrier

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(46769);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = (0,misc/* uuid4 */.DM)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return (0,object/* dropUndefinedKeys */.Jr)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new esm_scope/* Scope */.s(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = esm_scope/* Scope.clone */.s.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? (0,esm_logger/* consoleSandbox */.Cf)(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,tslib_es6/* __spread */.fl)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    IS_DEBUG_BUILD && logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, esm_scope/* Scope.clone */.s.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    return (0,esm_global/* getGlobalSingleton */.Y)('hub', function () { return new Hub(); }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
    __SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),

/***/ 46769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82991);


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._breadcrumbs);
            newScope._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._tags);
            newScope._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._extra);
            newScope._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext._tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext._extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext.tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext.extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)() }, breadcrumb);
        this._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, event), hint);
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalSingleton */ .Y)('globalEventProcessors', function () { return []; });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ 39666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports captureMessage, captureEvent, addBreadcrumb, setContext, setExtras, setTags, setExtra, setTag, setUser, _callOnClient, startTransaction */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6242);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spread */ .fl)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ FINISH_REASON_TAG; },
/* harmony export */   "x": function() { return /* binding */ IDLE_TRANSACTION_FINISH_REASONS; }
/* harmony export */ });
// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 78955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 2 modules
var hub = __webpack_require__(6242);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/flags.js
var flags = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}
//# sourceMappingURL=errors.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);








/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
                ? 'tracesSampler returned 0 or false'
                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!(0,node/* loadModule */.$y)(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = (0,tslib_es6/* __spread */.fl)((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0,node/* isNodeEnv */.KV)()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}
//# sourceMappingURL=hubextensions.js.map

/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26257);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78955);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55334);
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33391);






var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(_span__WEBPACK_IMPORTED_MODULE_2__/* .SpanRecorder */ .gB));

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
        }
        else {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[1] */ .x[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[0] */ .x[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Transaction */ .Y));

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}
//# sourceMappingURL=idletransaction.js.map

/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());

/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
        /**
         * @inheritDoc
         */
        this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}
//# sourceMappingURL=span.js.map

/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20535);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78955);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55334);





/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hub, _sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .Hub */ .Xb)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new _span__WEBPACK_IMPORTED_MODULE_3__/* .SpanRecorder */ .gB(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .dropUndefinedKeys */ .Jr)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(_span__WEBPACK_IMPORTED_MODULE_3__/* .Span */ .Dr));

//# sourceMappingURL=transaction.js.map

/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WB": function() { return /* binding */ secToMs; },
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6242);

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * TODO(v7): Reorganize these exports
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 */

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}
// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 13819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Severity; }
/* harmony export */ });
/* unused harmony export SeverityLevels */
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map

/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 30292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ dsnToString; },
/* harmony export */   "v": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77047);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88795);



/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: " + str);
    }
    var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__read */ .CR)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!_flags__WEBPACK_IMPORTED_MODULE_2__/* .IS_DEBUG_BUILD */ .h) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}
//# sourceMappingURL=dsn.js.map

/***/ }),

/***/ 77047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ SentryError; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/polyfill.js
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),

/***/ 88795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 82991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92448);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
    var global = (obj || getGlobalObject());
    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88795);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67597);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20535);
/* harmony import */ var _stacktrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30360);
/* harmony import */ var _supports__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8823);








var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__values */ .XA)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                    _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0,_stacktrace__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(handler) + "\nError:", e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    _logger__WEBPACK_IMPORTED_MODULE_2__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsNativeFetch */ .t$)()) {
        return;
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsHistory */ .Bf)()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88795);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);



// TODO: Implement different loggers for different environments
var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function (level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    }
    finally {
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function () {
            enabled = true;
        },
        disable: function () {
            enabled = false;
        },
    };
    if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
        CONSOLE_LEVELS.forEach(function (name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (enabled) {
                    consoleSandbox(function () {
                        var _a;
                        (_a = global.console)[name].apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spread */ .fl)([PREFIX + "[" + name + "]:"], args));
                    });
                }
            };
        });
    }
    else {
        CONSOLE_LEVELS.forEach(function (name) {
            logger[name] = function () { return undefined; };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
    logger = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
}
else {
    logger = makeLogger();
}

//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports parseSemver, addContextToFrame */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ 92448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 34754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: walk

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth, maxProperties) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    }
    catch (err) {
        return { ERROR: "**non-serializable** (" + err + ")" };
    }
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = (0,tslib_es6/* __read */.CR)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
        try {
            return valueWithToJSON.toJSON();
        }
        catch (err) {
            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // Get the simple cases out of the way first
    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) {
        return stringified;
    }
    // We're also done if we've reached the max depth
    if (depth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace('object ', '');
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = (Array.isArray(value) ? [] : {});
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = ((0,is/* isError */.VZ)(value) || (0,is/* isEvent */.cO)(value) ? (0,object/* convertToPlainObject */.Sh)(value) : value);
    for (var visitKey in visitable) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
// TODO remove this in v7 (this means the method will no longer be exported, under any name)

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key, 
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
            return '[Global]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if ((0,is/* isSyntheticEvent */.Cy)(value)) {
            return '[SyntheticEvent]';
        }
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + (0,stacktrace/* getFunctionName */.$P)(value) + "]";
        }
        if (typeof value === 'symbol') {
            return "[" + String(value) + "]";
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') {
            return "[BigInt: " + String(value) + "]";
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    }
    catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
//# sourceMappingURL=normalize.js.map

/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58464);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function convertToPlainObject(value) {
    var newObj = value;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
    }
    else if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
        var event_1 = value;
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
            newObj.detail = event_1.detail;
        }
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
    try {
        return (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser__WEBPACK_IMPORTED_MODULE_2__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
    var extractedProps = {};
    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            extractedProps[property] = obj[property];
        }
    }
    return extractedProps;
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(val)) {
        var rv = {};
        try {
            for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__values */ .XA)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof val[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(val[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map

/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports snipLine, escapeStringForRegex */
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!(0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "hv": function() { return /* binding */ supportsReferrerPolicy; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsErrorEvent, supportsDOMError, supportsDOMException, supportsReportingObserver */
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88795);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports usingPerformanceAPI, _browserPerformanceTimeOriginMode */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92448);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 25436:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"XT0OUDfod1dOQCwEKsHcV"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["page-builder-frontend-production@sentry"]={id:"XT0OUDfod1dOQCwEKsHcV"};
      

/***/ }),

/***/ 64567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 68901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(64567);
} else {}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 11073:
/***/ (function(module) {

module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};

/***/ }),

/***/ 51206:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.attributeRules = void 0;
var boolbase_1 = __webpack_require__(11073);
/**
 * All reserved characters in a regex, used for escaping.
 *
 * Taken from XRegExp, (c) 2007-2020 Steven Levithan under the MIT license
 * https://github.com/slevithan/xregexp/blob/95eeebeb8fac8754d54eafe2b4743661ac1cf028/src/xregexp.js#L794
 */
var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function escapeRegex(value) {
    return value.replace(reChars, "\\$&");
}
/**
 * Attributes that are case-insensitive in HTML.
 *
 * @private
 * @see https://html.spec.whatwg.org/multipage/semantics-other.html#case-sensitivity-of-selectors
 */
var caseInsensitiveAttributes = new Set([
    "accept",
    "accept-charset",
    "align",
    "alink",
    "axis",
    "bgcolor",
    "charset",
    "checked",
    "clear",
    "codetype",
    "color",
    "compact",
    "declare",
    "defer",
    "dir",
    "direction",
    "disabled",
    "enctype",
    "face",
    "frame",
    "hreflang",
    "http-equiv",
    "lang",
    "language",
    "link",
    "media",
    "method",
    "multiple",
    "nohref",
    "noresize",
    "noshade",
    "nowrap",
    "readonly",
    "rel",
    "rev",
    "rules",
    "scope",
    "scrolling",
    "selected",
    "shape",
    "target",
    "text",
    "type",
    "valign",
    "valuetype",
    "vlink",
]);
function shouldIgnoreCase(selector, options) {
    return typeof selector.ignoreCase === "boolean"
        ? selector.ignoreCase
        : selector.ignoreCase === "quirks"
            ? !!options.quirksMode
            : !options.xmlMode && caseInsensitiveAttributes.has(selector.name);
}
/**
 * Attribute selectors
 */
exports.attributeRules = {
    equals: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length === value.length &&
                    attr.toLowerCase() === value &&
                    next(elem));
            };
        }
        return function (elem) {
            return adapter.getAttributeValue(elem, name) === value && next(elem);
        };
    },
    hyphen: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function hyphenIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    (attr.length === len || attr.charAt(len) === "-") &&
                    attr.substr(0, len).toLowerCase() === value &&
                    next(elem));
            };
        }
        return function hyphen(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return (attr != null &&
                (attr.length === len || attr.charAt(len) === "-") &&
                attr.substr(0, len) === value &&
                next(elem));
        };
    },
    element: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (/\s/.test(value)) {
            return boolbase_1.falseFunc;
        }
        var regex = new RegExp("(?:^|\\s)".concat(escapeRegex(value), "(?:$|\\s)"), shouldIgnoreCase(data, options) ? "i" : "");
        return function element(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return (attr != null &&
                attr.length >= value.length &&
                regex.test(attr) &&
                next(elem));
        };
    },
    exists: function (next, _a, _b) {
        var name = _a.name;
        var adapter = _b.adapter;
        return function (elem) { return adapter.hasAttrib(elem, name) && next(elem); };
    },
    start: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if (len === 0) {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length >= len &&
                    attr.substr(0, len).toLowerCase() === value &&
                    next(elem));
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) &&
                next(elem);
        };
    },
    end: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = -value.length;
        if (len === 0) {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var _a;
                return ((_a = adapter
                    .getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) &&
                next(elem);
        };
    },
    any: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (value === "") {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            var regex_1 = new RegExp(escapeRegex(value), "i");
            return function anyIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length >= value.length &&
                    regex_1.test(attr) &&
                    next(elem));
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) &&
                next(elem);
        };
    },
    not: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if (value === "") {
            return function (elem) {
                return !!adapter.getAttributeValue(elem, name) && next(elem);
            };
        }
        else if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return ((attr == null ||
                    attr.length !== value.length ||
                    attr.toLowerCase() !== value) &&
                    next(elem));
            };
        }
        return function (elem) {
            return adapter.getAttributeValue(elem, name) !== value && next(elem);
        };
    },
};


/***/ }),

/***/ 98866:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compileToken = exports.compileUnsafe = exports.compile = void 0;
var css_what_1 = __webpack_require__(67209);
var boolbase_1 = __webpack_require__(11073);
var sort_1 = __importDefault(__webpack_require__(57353));
var procedure_1 = __webpack_require__(57177);
var general_1 = __webpack_require__(93621);
var subselects_1 = __webpack_require__(61768);
/**
 * Compiles a selector to an executable function.
 *
 * @param selector Selector to compile.
 * @param options Compilation options.
 * @param context Optional context for the selector.
 */
function compile(selector, options, context) {
    var next = compileUnsafe(selector, options, context);
    return (0, subselects_1.ensureIsTag)(next, options.adapter);
}
exports.compile = compile;
function compileUnsafe(selector, options, context) {
    var token = typeof selector === "string" ? (0, css_what_1.parse)(selector) : selector;
    return compileToken(token, options, context);
}
exports.compileUnsafe = compileUnsafe;
function includesScopePseudo(t) {
    return (t.type === "pseudo" &&
        (t.name === "scope" ||
            (Array.isArray(t.data) &&
                t.data.some(function (data) { return data.some(includesScopePseudo); }))));
}
var DESCENDANT_TOKEN = { type: css_what_1.SelectorType.Descendant };
var FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant",
};
var SCOPE_TOKEN = {
    type: css_what_1.SelectorType.Pseudo,
    name: "scope",
    data: null,
};
/*
 * CSS 4 Spec (Draft): 3.3.1. Absolutizing a Scope-relative Selector
 * http://www.w3.org/TR/selectors4/#absolutizing
 */
function absolutize(token, _a, context) {
    var adapter = _a.adapter;
    // TODO Use better check if the context is a document
    var hasContext = !!(context === null || context === void 0 ? void 0 : context.every(function (e) {
        var parent = adapter.isTag(e) && adapter.getParent(e);
        return e === subselects_1.PLACEHOLDER_ELEMENT || (parent && adapter.isTag(parent));
    }));
    for (var _i = 0, token_1 = token; _i < token_1.length; _i++) {
        var t = token_1[_i];
        if (t.length > 0 && (0, procedure_1.isTraversal)(t[0]) && t[0].type !== "descendant") {
            // Don't continue in else branch
        }
        else if (hasContext && !t.some(includesScopePseudo)) {
            t.unshift(DESCENDANT_TOKEN);
        }
        else {
            continue;
        }
        t.unshift(SCOPE_TOKEN);
    }
}
function compileToken(token, options, context) {
    var _a;
    token = token.filter(function (t) { return t.length > 0; });
    token.forEach(sort_1.default);
    context = (_a = options.context) !== null && _a !== void 0 ? _a : context;
    var isArrayContext = Array.isArray(context);
    var finalContext = context && (Array.isArray(context) ? context : [context]);
    absolutize(token, options, finalContext);
    var shouldTestNextSiblings = false;
    var query = token
        .map(function (rules) {
        if (rules.length >= 2) {
            var first = rules[0], second = rules[1];
            if (first.type !== "pseudo" || first.name !== "scope") {
                // Ignore
            }
            else if (isArrayContext && second.type === "descendant") {
                rules[1] = FLEXIBLE_DESCENDANT_TOKEN;
            }
            else if (second.type === "adjacent" ||
                second.type === "sibling") {
                shouldTestNextSiblings = true;
            }
        }
        return compileRules(rules, options, finalContext);
    })
        .reduce(reduceRules, boolbase_1.falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
}
exports.compileToken = compileToken;
function compileRules(rules, options, context) {
    var _a;
    return rules.reduce(function (previous, rule) {
        return previous === boolbase_1.falseFunc
            ? boolbase_1.falseFunc
            : (0, general_1.compileGeneralSelector)(previous, rule, options, context, compileToken);
    }, (_a = options.rootFunc) !== null && _a !== void 0 ? _a : boolbase_1.trueFunc);
}
function reduceRules(a, b) {
    if (b === boolbase_1.falseFunc || a === boolbase_1.trueFunc) {
        return a;
    }
    if (a === boolbase_1.falseFunc || b === boolbase_1.trueFunc) {
        return b;
    }
    return function combine(elem) {
        return a(elem) || b(elem);
    };
}


/***/ }),

/***/ 93621:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compileGeneralSelector = void 0;
var attributes_1 = __webpack_require__(70996);
var pseudo_selectors_1 = __webpack_require__(98677);
var css_what_1 = __webpack_require__(67209);
/*
 * All available rules
 */
function compileGeneralSelector(next, selector, options, context, compileToken) {
    var adapter = options.adapter, equals = options.equals;
    switch (selector.type) {
        case css_what_1.SelectorType.PseudoElement: {
            throw new Error("Pseudo-elements are not supported by css-select");
        }
        case css_what_1.SelectorType.ColumnCombinator: {
            throw new Error("Column combinators are not yet supported by css-select");
        }
        case css_what_1.SelectorType.Attribute: {
            if (selector.namespace != null) {
                throw new Error("Namespaced attributes are not yet supported by css-select");
            }
            if (!options.xmlMode || options.lowerCaseAttributeNames) {
                selector.name = selector.name.toLowerCase();
            }
            return attributes_1.attributeRules[selector.action](next, selector, options);
        }
        case css_what_1.SelectorType.Pseudo: {
            return (0, pseudo_selectors_1.compilePseudoSelector)(next, selector, options, context, compileToken);
        }
        // Tags
        case css_what_1.SelectorType.Tag: {
            if (selector.namespace != null) {
                throw new Error("Namespaced tag names are not yet supported by css-select");
            }
            var name_1 = selector.name;
            if (!options.xmlMode || options.lowerCaseTags) {
                name_1 = name_1.toLowerCase();
            }
            return function tag(elem) {
                return adapter.getName(elem) === name_1 && next(elem);
            };
        }
        // Traversal
        case css_what_1.SelectorType.Descendant: {
            if (options.cacheResults === false ||
                typeof WeakSet === "undefined") {
                return function descendant(elem) {
                    var current = elem;
                    while ((current = adapter.getParent(current))) {
                        if (adapter.isTag(current) && next(current)) {
                            return true;
                        }
                    }
                    return false;
                };
            }
            // @ts-expect-error `ElementNode` is not extending object
            var isFalseCache_1 = new WeakSet();
            return function cachedDescendant(elem) {
                var current = elem;
                while ((current = adapter.getParent(current))) {
                    if (!isFalseCache_1.has(current)) {
                        if (adapter.isTag(current) && next(current)) {
                            return true;
                        }
                        isFalseCache_1.add(current);
                    }
                }
                return false;
            };
        }
        case "_flexibleDescendant": {
            // Include element itself, only used while querying an array
            return function flexibleDescendant(elem) {
                var current = elem;
                do {
                    if (adapter.isTag(current) && next(current))
                        return true;
                } while ((current = adapter.getParent(current)));
                return false;
            };
        }
        case css_what_1.SelectorType.Parent: {
            return function parent(elem) {
                return adapter
                    .getChildren(elem)
                    .some(function (elem) { return adapter.isTag(elem) && next(elem); });
            };
        }
        case css_what_1.SelectorType.Child: {
            return function child(elem) {
                var parent = adapter.getParent(elem);
                return parent != null && adapter.isTag(parent) && next(parent);
            };
        }
        case css_what_1.SelectorType.Sibling: {
            return function sibling(elem) {
                var siblings = adapter.getSiblings(elem);
                for (var i = 0; i < siblings.length; i++) {
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling))
                        break;
                    if (adapter.isTag(currentSibling) && next(currentSibling)) {
                        return true;
                    }
                }
                return false;
            };
        }
        case css_what_1.SelectorType.Adjacent: {
            if (adapter.prevElementSibling) {
                return function adjacent(elem) {
                    var previous = adapter.prevElementSibling(elem);
                    return previous != null && next(previous);
                };
            }
            return function adjacent(elem) {
                var siblings = adapter.getSiblings(elem);
                var lastElement;
                for (var i = 0; i < siblings.length; i++) {
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling))
                        break;
                    if (adapter.isTag(currentSibling)) {
                        lastElement = currentSibling;
                    }
                }
                return !!lastElement && next(lastElement);
            };
        }
        case css_what_1.SelectorType.Universal: {
            if (selector.namespace != null && selector.namespace !== "*") {
                throw new Error("Namespaced universal selectors are not yet supported by css-select");
            }
            return next;
        }
    }
}
exports.compileGeneralSelector = compileGeneralSelector;


/***/ }),

/***/ 75366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.aliases = exports.pseudos = exports.filters = exports.is = exports.selectOne = exports.selectAll = exports.prepareContext = exports._compileToken = exports._compileUnsafe = exports.compile = void 0;
var DomUtils = __importStar(__webpack_require__(89432));
var boolbase_1 = __webpack_require__(11073);
var compile_1 = __webpack_require__(98866);
var subselects_1 = __webpack_require__(61768);
var defaultEquals = function (a, b) { return a === b; };
var defaultOptions = {
    adapter: DomUtils,
    equals: defaultEquals,
};
function convertOptionFormats(options) {
    var _a, _b, _c, _d;
    /*
     * We force one format of options to the other one.
     */
    // @ts-expect-error Default options may have incompatible `Node` / `ElementNode`.
    var opts = options !== null && options !== void 0 ? options : defaultOptions;
    // @ts-expect-error Same as above.
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : (opts.adapter = DomUtils);
    // @ts-expect-error `equals` does not exist on `Options`
    (_b = opts.equals) !== null && _b !== void 0 ? _b : (opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : defaultEquals);
    return opts;
}
function wrapCompile(func) {
    return function addAdapter(selector, options, context) {
        var opts = convertOptionFormats(options);
        return func(selector, opts, context);
    };
}
/**
 * Compiles the query, returns a function.
 */
exports.compile = wrapCompile(compile_1.compile);
exports._compileUnsafe = wrapCompile(compile_1.compileUnsafe);
exports._compileToken = wrapCompile(compile_1.compileToken);
function getSelectorFunc(searchFunc) {
    return function select(query, elements, options) {
        var opts = convertOptionFormats(options);
        if (typeof query !== "function") {
            query = (0, compile_1.compileUnsafe)(query, opts, elements);
        }
        var filteredElements = prepareContext(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
    };
}
function prepareContext(elems, adapter, shouldTestNextSiblings) {
    if (shouldTestNextSiblings === void 0) { shouldTestNextSiblings = false; }
    /*
     * Add siblings if the query requires them.
     * See https://github.com/fb55/css-select/pull/43#issuecomment-225414692
     */
    if (shouldTestNextSiblings) {
        elems = appendNextSiblings(elems, adapter);
    }
    return Array.isArray(elems)
        ? adapter.removeSubsets(elems)
        : adapter.getChildren(elems);
}
exports.prepareContext = prepareContext;
function appendNextSiblings(elem, adapter) {
    // Order matters because jQuery seems to check the children before the siblings
    var elems = Array.isArray(elem) ? elem.slice(0) : [elem];
    var elemsLength = elems.length;
    for (var i = 0; i < elemsLength; i++) {
        var nextSiblings = (0, subselects_1.getNextSiblings)(elems[i], adapter);
        elems.push.apply(elems, nextSiblings);
    }
    return elems;
}
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns All matching elements.
 *
 */
exports.selectAll = getSelectorFunc(function (query, elems, options) {
    return query === boolbase_1.falseFunc || !elems || elems.length === 0
        ? []
        : options.adapter.findAll(query, elems);
});
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns the first match, or null if there was no match.
 */
exports.selectOne = getSelectorFunc(function (query, elems, options) {
    return query === boolbase_1.falseFunc || !elems || elems.length === 0
        ? null
        : options.adapter.findOne(query, elems);
});
/**
 * Tests whether or not an element is matched by query.
 *
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elem The element to test if it matches the query.
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns
 */
function is(elem, query, options) {
    var opts = convertOptionFormats(options);
    return (typeof query === "function" ? query : (0, compile_1.compile)(query, opts))(elem);
}
exports.is = is;
/**
 * Alias for selectAll(query, elems, options).
 * @see [compile] for supported selector queries.
 */
exports["default"] = exports.selectAll;
// Export filters, pseudos and aliases to allow users to supply their own.
var pseudo_selectors_1 = __webpack_require__(98677);
Object.defineProperty(exports, "filters", ({ enumerable: true, get: function () { return pseudo_selectors_1.filters; } }));
Object.defineProperty(exports, "pseudos", ({ enumerable: true, get: function () { return pseudo_selectors_1.pseudos; } }));
Object.defineProperty(exports, "aliases", ({ enumerable: true, get: function () { return pseudo_selectors_1.aliases; } }));


/***/ }),

/***/ 57177:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isTraversal = exports.procedure = void 0;
exports.procedure = {
    universal: 50,
    tag: 30,
    attribute: 1,
    pseudo: 0,
    "pseudo-element": 0,
    "column-combinator": -1,
    descendant: -1,
    child: -1,
    parent: -1,
    sibling: -1,
    adjacent: -1,
    _flexibleDescendant: -1,
};
function isTraversal(t) {
    return exports.procedure[t.type] < 0;
}
exports.isTraversal = isTraversal;


/***/ }),

/***/ 92968:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.aliases = void 0;
/**
 * Aliases are pseudos that are expressed as selectors.
 */
exports.aliases = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])",
};


/***/ }),

/***/ 57689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.filters = void 0;
var nth_check_1 = __importDefault(__webpack_require__(97540));
var boolbase_1 = __webpack_require__(11073);
function getChildFunc(next, adapter) {
    return function (elem) {
        var parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
    };
}
exports.filters = {
    contains: function (next, text, _a) {
        var adapter = _a.adapter;
        return function contains(elem) {
            return next(elem) && adapter.getText(elem).includes(text);
        };
    },
    icontains: function (next, text, _a) {
        var adapter = _a.adapter;
        var itext = text.toLowerCase();
        return function icontains(elem) {
            return (next(elem) &&
                adapter.getText(elem).toLowerCase().includes(itext));
        };
    },
    // Location specific methods
    "nth-child": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = 0; i < siblings.length; i++) {
                if (equals(elem, siblings[i]))
                    break;
                if (adapter.isTag(siblings[i])) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-child": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthLastChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = siblings.length - 1; i >= 0; i--) {
                if (equals(elem, siblings[i]))
                    break;
                if (adapter.isTag(siblings[i])) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-of-type": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = 0; i < siblings.length; i++) {
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling))
                    break;
                if (adapter.isTag(currentSibling) &&
                    adapter.getName(currentSibling) === adapter.getName(elem)) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-of-type": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = siblings.length - 1; i >= 0; i--) {
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling))
                    break;
                if (adapter.isTag(currentSibling) &&
                    adapter.getName(currentSibling) === adapter.getName(elem)) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    // TODO determine the actual root element
    root: function (next, _rule, _a) {
        var adapter = _a.adapter;
        return function (elem) {
            var parent = adapter.getParent(elem);
            return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
    },
    scope: function (next, rule, options, context) {
        var equals = options.equals;
        if (!context || context.length === 0) {
            // Equivalent to :root
            return exports.filters.root(next, rule, options);
        }
        if (context.length === 1) {
            // NOTE: can't be unpacked, as :has uses this for side-effects
            return function (elem) { return equals(context[0], elem) && next(elem); };
        }
        return function (elem) { return context.includes(elem) && next(elem); };
    },
    hover: dynamicStatePseudo("isHovered"),
    visited: dynamicStatePseudo("isVisited"),
    active: dynamicStatePseudo("isActive"),
};
/**
 * Dynamic state pseudos. These depend on optional Adapter methods.
 *
 * @param name The name of the adapter method to call.
 * @returns Pseudo for the `filters` object.
 */
function dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, _a) {
        var adapter = _a.adapter;
        var func = adapter[name];
        if (typeof func !== "function") {
            return boolbase_1.falseFunc;
        }
        return function active(elem) {
            return func(elem) && next(elem);
        };
    };
}


/***/ }),

/***/ 98677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compilePseudoSelector = exports.aliases = exports.pseudos = exports.filters = void 0;
/*
 * Pseudo selectors
 *
 * Pseudo selectors are available in three forms:
 *
 * 1. Filters are called when the selector is compiled and return a function
 *  that has to return either false, or the results of `next()`.
 * 2. Pseudos are called on execution. They have to return a boolean.
 * 3. Subselects work like filters, but have an embedded selector that will be run separately.
 *
 * Filters are great if you want to do some pre-processing, or change the call order
 * of `next()` and your code.
 * Pseudos should be used to implement simple checks.
 */
var boolbase_1 = __webpack_require__(11073);
var css_what_1 = __webpack_require__(67209);
var filters_1 = __webpack_require__(57689);
Object.defineProperty(exports, "filters", ({ enumerable: true, get: function () { return filters_1.filters; } }));
var pseudos_1 = __webpack_require__(57221);
Object.defineProperty(exports, "pseudos", ({ enumerable: true, get: function () { return pseudos_1.pseudos; } }));
var aliases_1 = __webpack_require__(92968);
Object.defineProperty(exports, "aliases", ({ enumerable: true, get: function () { return aliases_1.aliases; } }));
var subselects_1 = __webpack_require__(61768);
function compilePseudoSelector(next, selector, options, context, compileToken) {
    var name = selector.name, data = selector.data;
    if (Array.isArray(data)) {
        return subselects_1.subselects[name](next, data, options, context, compileToken);
    }
    if (name in aliases_1.aliases) {
        if (data != null) {
            throw new Error("Pseudo ".concat(name, " doesn't have any arguments"));
        }
        // The alias has to be parsed here, to make sure options are respected.
        var alias = (0, css_what_1.parse)(aliases_1.aliases[name]);
        return subselects_1.subselects.is(next, alias, options, context, compileToken);
    }
    if (name in filters_1.filters) {
        return filters_1.filters[name](next, data, options, context);
    }
    if (name in pseudos_1.pseudos) {
        var pseudo_1 = pseudos_1.pseudos[name];
        (0, pseudos_1.verifyPseudoArgs)(pseudo_1, name, data);
        return pseudo_1 === boolbase_1.falseFunc
            ? boolbase_1.falseFunc
            : next === boolbase_1.trueFunc
                ? function (elem) { return pseudo_1(elem, options, data); }
                : function (elem) { return pseudo_1(elem, options, data) && next(elem); };
    }
    throw new Error("unmatched pseudo-class :".concat(name));
}
exports.compilePseudoSelector = compilePseudoSelector;


/***/ }),

/***/ 57221:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifyPseudoArgs = exports.pseudos = void 0;
// While filters are precompiled, pseudos get called when they are needed
exports.pseudos = {
    empty: function (elem, _a) {
        var adapter = _a.adapter;
        return !adapter.getChildren(elem).some(function (elem) {
            // FIXME: `getText` call is potentially expensive.
            return adapter.isTag(elem) || adapter.getText(elem) !== "";
        });
    },
    "first-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var firstChild = adapter
            .getSiblings(elem)
            .find(function (elem) { return adapter.isTag(elem); });
        return firstChild != null && equals(elem, firstChild);
    },
    "last-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        for (var i = siblings.length - 1; i >= 0; i--) {
            if (equals(elem, siblings[i]))
                return true;
            if (adapter.isTag(siblings[i]))
                break;
        }
        return false;
    },
    "first-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for (var i = 0; i < siblings.length; i++) {
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling))
                return true;
            if (adapter.isTag(currentSibling) &&
                adapter.getName(currentSibling) === elemName) {
                break;
            }
        }
        return false;
    },
    "last-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for (var i = siblings.length - 1; i >= 0; i--) {
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling))
                return true;
            if (adapter.isTag(currentSibling) &&
                adapter.getName(currentSibling) === elemName) {
                break;
            }
        }
        return false;
    },
    "only-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var elemName = adapter.getName(elem);
        return adapter
            .getSiblings(elem)
            .every(function (sibling) {
            return equals(elem, sibling) ||
                !adapter.isTag(sibling) ||
                adapter.getName(sibling) !== elemName;
        });
    },
    "only-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        return adapter
            .getSiblings(elem)
            .every(function (sibling) { return equals(elem, sibling) || !adapter.isTag(sibling); });
    },
};
function verifyPseudoArgs(func, name, subselect) {
    if (subselect === null) {
        if (func.length > 2) {
            throw new Error("pseudo-selector :".concat(name, " requires an argument"));
        }
    }
    else if (func.length === 2) {
        throw new Error("pseudo-selector :".concat(name, " doesn't have any arguments"));
    }
}
exports.verifyPseudoArgs = verifyPseudoArgs;


/***/ }),

/***/ 61768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.subselects = exports.getNextSiblings = exports.ensureIsTag = exports.PLACEHOLDER_ELEMENT = void 0;
var boolbase_1 = __webpack_require__(11073);
var procedure_1 = __webpack_require__(57177);
/** Used as a placeholder for :has. Will be replaced with the actual element. */
exports.PLACEHOLDER_ELEMENT = {};
function ensureIsTag(next, adapter) {
    if (next === boolbase_1.falseFunc)
        return boolbase_1.falseFunc;
    return function (elem) { return adapter.isTag(elem) && next(elem); };
}
exports.ensureIsTag = ensureIsTag;
function getNextSiblings(elem, adapter) {
    var siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1)
        return [];
    var elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1)
        return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
}
exports.getNextSiblings = getNextSiblings;
var is = function (next, token, options, context, compileToken) {
    var opts = {
        xmlMode: !!options.xmlMode,
        adapter: options.adapter,
        equals: options.equals,
    };
    var func = compileToken(token, opts, context);
    return function (elem) { return func(elem) && next(elem); };
};
/*
 * :not, :has, :is, :matches and :where have to compile selectors
 * doing this in src/pseudos.ts would lead to circular dependencies,
 * so we add them here
 */
exports.subselects = {
    is: is,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */
    matches: is,
    where: is,
    not: function (next, token, options, context, compileToken) {
        var opts = {
            xmlMode: !!options.xmlMode,
            adapter: options.adapter,
            equals: options.equals,
        };
        var func = compileToken(token, opts, context);
        if (func === boolbase_1.falseFunc)
            return next;
        if (func === boolbase_1.trueFunc)
            return boolbase_1.falseFunc;
        return function not(elem) {
            return !func(elem) && next(elem);
        };
    },
    has: function (next, subselect, options, _context, compileToken) {
        var adapter = options.adapter;
        var opts = {
            xmlMode: !!options.xmlMode,
            adapter: adapter,
            equals: options.equals,
        };
        // @ts-expect-error Uses an array as a pointer to the current element (side effects)
        var context = subselect.some(function (s) {
            return s.some(procedure_1.isTraversal);
        })
            ? [exports.PLACEHOLDER_ELEMENT]
            : undefined;
        var compiled = compileToken(subselect, opts, context);
        if (compiled === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (compiled === boolbase_1.trueFunc) {
            return function (elem) {
                return adapter.getChildren(elem).some(adapter.isTag) && next(elem);
            };
        }
        var hasElement = ensureIsTag(compiled, adapter);
        var _a = compiled.shouldTestNextSiblings, shouldTestNextSiblings = _a === void 0 ? false : _a;
        /*
         * `shouldTestNextSiblings` will only be true if the query starts with
         * a traversal (sibling or adjacent). That means we will always have a context.
         */
        if (context) {
            return function (elem) {
                context[0] = elem;
                var childs = adapter.getChildren(elem);
                var nextElements = shouldTestNextSiblings
                    ? __spreadArray(__spreadArray([], childs, true), getNextSiblings(elem, adapter), true) : childs;
                return (next(elem) && adapter.existsOne(hasElement, nextElements));
            };
        }
        return function (elem) {
            return next(elem) &&
                adapter.existsOne(hasElement, adapter.getChildren(elem));
        };
    },
};


/***/ }),

/***/ 57353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var css_what_1 = __webpack_require__(67209);
var procedure_1 = __webpack_require__(57177);
var attributes = {
    exists: 10,
    equals: 8,
    not: 7,
    start: 6,
    end: 6,
    any: 5,
    hyphen: 4,
    element: 4,
};
/**
 * Sort the parts of the passed selector,
 * as there is potential for optimization
 * (some types of selectors are faster than others)
 *
 * @param arr Selector to sort
 */
function sortByProcedure(arr) {
    var procs = arr.map(getProcedure);
    for (var i = 1; i < arr.length; i++) {
        var procNew = procs[i];
        if (procNew < 0)
            continue;
        for (var j = i - 1; j >= 0 && procNew < procs[j]; j--) {
            var token = arr[j + 1];
            arr[j + 1] = arr[j];
            arr[j] = token;
            procs[j + 1] = procs[j];
            procs[j] = procNew;
        }
    }
}
exports["default"] = sortByProcedure;
function getProcedure(token) {
    var proc = procedure_1.procedure[token.type];
    if (token.type === css_what_1.SelectorType.Attribute) {
        proc = attributes[token.action];
        if (proc === attributes.equals && token.name === "id") {
            // Prefer ID selectors (eg. #ID)
            proc = 9;
        }
        if (token.ignoreCase) {
            /*
             * IgnoreCase adds some overhead, prefer "normal" token
             * this is a binary operation, to ensure it's still an int
             */
            proc >>= 1;
        }
    }
    else if (token.type === css_what_1.SelectorType.Pseudo) {
        if (!token.data) {
            proc = 3;
        }
        else if (token.name === "has" || token.name === "contains") {
            proc = 0; // Expensive in any case
        }
        else if (Array.isArray(token.data)) {
            // "matches" and "not"
            proc = 0;
            for (var i = 0; i < token.data.length; i++) {
                // TODO better handling of complex selectors
                if (token.data[i].length !== 1)
                    continue;
                var cur = getProcedure(token.data[i][0]);
                // Avoid executing :has or :contains
                if (cur === 0) {
                    proc = 0;
                    break;
                }
                if (cur > proc)
                    proc = cur;
            }
            if (token.data.length > 1 && proc > 0)
                proc -= 1;
        }
        else {
            proc = 1;
        }
    }
    return proc;
}


/***/ }),

/***/ 67209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AttributeAction": function() { return /* reexport */ AttributeAction; },
  "IgnoreCaseMode": function() { return /* reexport */ IgnoreCaseMode; },
  "SelectorType": function() { return /* reexport */ SelectorType; },
  "isTraversal": function() { return /* reexport */ isTraversal; },
  "parse": function() { return /* reexport */ parse; },
  "stringify": function() { return /* reexport */ stringify; }
});

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/types.js
var SelectorType;
(function (SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})(SelectorType || (SelectorType = {}));
/**
 * Modes for ignore case.
 *
 * This could be updated to an enum, and the object is
 * the current stand-in that will allow code to be updated
 * without big changes.
 */
const IgnoreCaseMode = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false,
};
var AttributeAction;
(function (AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})(AttributeAction || (AttributeAction = {}));

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/parse.js

const reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const actionTypes = new Map([
    [126 /* Tilde */, AttributeAction.Element],
    [94 /* Circumflex */, AttributeAction.Start],
    [36 /* Dollar */, AttributeAction.End],
    [42 /* Asterisk */, AttributeAction.Any],
    [33 /* ExclamationMark */, AttributeAction.Not],
    [124 /* Pipe */, AttributeAction.Hyphen],
]);
// Pseudos, whose data property is parsed as well.
const unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context",
]);
/**
 * Checks whether a specific selector is a traversal.
 * This is useful eg. in swapping the order of elements that
 * are not traversals.
 *
 * @param selector Selector to check.
 */
function isTraversal(selector) {
    switch (selector.type) {
        case SelectorType.Adjacent:
        case SelectorType.Child:
        case SelectorType.Descendant:
        case SelectorType.Parent:
        case SelectorType.Sibling:
        case SelectorType.ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const stripQuotesFromPseudos = new Set(["contains", "icontains"]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace
        ? escaped
        : high < 0
            ? // BMP codepoint
                String.fromCharCode(high + 0x10000)
            : // Supplemental Plane codepoint (surrogate pair)
                String.fromCharCode((high >> 10) | 0xd800, (high & 0x3ff) | 0xdc00);
}
function unescapeCSS(str) {
    return str.replace(reEscape, funescape);
}
function isQuote(c) {
    return c === 39 /* SingleQuote */ || c === 34 /* DoubleQuote */;
}
function isWhitespace(c) {
    return (c === 32 /* Space */ ||
        c === 9 /* Tab */ ||
        c === 10 /* NewLine */ ||
        c === 12 /* FormFeed */ ||
        c === 13 /* CarriageReturn */);
}
/**
 * Parses `selector`, optionally with the passed `options`.
 *
 * @param selector Selector to parse.
 * @param options Options for parsing.
 * @returns Returns a two-dimensional array.
 * The first dimension represents selectors separated by commas (eg. `sub1, sub2`),
 * the second contains the relevant tokens for that selector.
 */
function parse(selector) {
    const subselects = [];
    const endIndex = parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) {
        throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    }
    return subselects;
}
function parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match(reName);
        if (!match) {
            throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        }
        const [name] = match;
        selectorIndex += offset + name.length;
        return unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while (selectorIndex < selector.length &&
            isWhitespace(selector.charCodeAt(selectorIndex))) {
            selectorIndex++;
        }
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for (; counter > 0 && selectorIndex < selector.length; selectorIndex++) {
            if (selector.charCodeAt(selectorIndex) ===
                40 /* LeftParenthesis */ &&
                !isEscaped(selectorIndex)) {
                counter++;
            }
            else if (selector.charCodeAt(selectorIndex) ===
                41 /* RightParenthesis */ &&
                !isEscaped(selectorIndex)) {
                counter--;
            }
        }
        if (counter) {
            throw new Error("Parenthesis not matched");
        }
        return unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while (selector.charCodeAt(--pos) === 92 /* BackSlash */)
            slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && isTraversal(tokens[tokens.length - 1])) {
            throw new Error("Did not expect successive traversals.");
        }
    }
    function addTraversal(type) {
        if (tokens.length > 0 &&
            tokens[tokens.length - 1].type === SelectorType.Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({ type });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: SelectorType.Attribute,
            name,
            action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks",
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */
    function finalizeSubselector() {
        if (tokens.length &&
            tokens[tokens.length - 1].type === SelectorType.Descendant) {
            tokens.pop();
        }
        if (tokens.length === 0) {
            throw new Error("Empty sub-selector");
        }
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) {
        return selectorIndex;
    }
    loop: while (selectorIndex < selector.length) {
        const firstChar = selector.charCodeAt(selectorIndex);
        switch (firstChar) {
            // Whitespace
            case 32 /* Space */:
            case 9 /* Tab */:
            case 10 /* NewLine */:
            case 12 /* FormFeed */:
            case 13 /* CarriageReturn */: {
                if (tokens.length === 0 ||
                    tokens[0].type !== SelectorType.Descendant) {
                    ensureNotTraversal();
                    tokens.push({ type: SelectorType.Descendant });
                }
                stripWhitespace(1);
                break;
            }
            // Traversals
            case 62 /* GreaterThan */: {
                addTraversal(SelectorType.Child);
                stripWhitespace(1);
                break;
            }
            case 60 /* LessThan */: {
                addTraversal(SelectorType.Parent);
                stripWhitespace(1);
                break;
            }
            case 126 /* Tilde */: {
                addTraversal(SelectorType.Sibling);
                stripWhitespace(1);
                break;
            }
            case 43 /* Plus */: {
                addTraversal(SelectorType.Adjacent);
                stripWhitespace(1);
                break;
            }
            // Special attribute selectors: .class, #id
            case 46 /* Period */: {
                addSpecialAttribute("class", AttributeAction.Element);
                break;
            }
            case 35 /* Hash */: {
                addSpecialAttribute("id", AttributeAction.Equals);
                break;
            }
            case 91 /* LeftSquareBracket */: {
                stripWhitespace(1);
                // Determine attribute name and namespace
                let name;
                let namespace = null;
                if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */) {
                    // Equivalent to no namespace
                    name = getName(1);
                }
                else if (selector.startsWith("*|", selectorIndex)) {
                    namespace = "*";
                    name = getName(2);
                }
                else {
                    name = getName(0);
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ &&
                        selector.charCodeAt(selectorIndex + 1) !==
                            61 /* Equal */) {
                        namespace = name;
                        name = getName(1);
                    }
                }
                stripWhitespace(0);
                // Determine comparison operation
                let action = AttributeAction.Exists;
                const possibleAction = actionTypes.get(selector.charCodeAt(selectorIndex));
                if (possibleAction) {
                    action = possibleAction;
                    if (selector.charCodeAt(selectorIndex + 1) !==
                        61 /* Equal */) {
                        throw new Error("Expected `=`");
                    }
                    stripWhitespace(2);
                }
                else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */) {
                    action = AttributeAction.Equals;
                    stripWhitespace(1);
                }
                // Determine value
                let value = "";
                let ignoreCase = null;
                if (action !== "exists") {
                    if (isQuote(selector.charCodeAt(selectorIndex))) {
                        const quote = selector.charCodeAt(selectorIndex);
                        let sectionEnd = selectorIndex + 1;
                        while (sectionEnd < selector.length &&
                            (selector.charCodeAt(sectionEnd) !== quote ||
                                isEscaped(sectionEnd))) {
                            sectionEnd += 1;
                        }
                        if (selector.charCodeAt(sectionEnd) !== quote) {
                            throw new Error("Attribute value didn't end");
                        }
                        value = unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                        selectorIndex = sectionEnd + 1;
                    }
                    else {
                        const valueStart = selectorIndex;
                        while (selectorIndex < selector.length &&
                            ((!isWhitespace(selector.charCodeAt(selectorIndex)) &&
                                selector.charCodeAt(selectorIndex) !==
                                    93 /* RightSquareBracket */) ||
                                isEscaped(selectorIndex))) {
                            selectorIndex += 1;
                        }
                        value = unescapeCSS(selector.slice(valueStart, selectorIndex));
                    }
                    stripWhitespace(0);
                    // See if we have a force ignore flag
                    const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                    // If the forceIgnore flag is set (either `i` or `s`), use that value
                    if (forceIgnore === 115 /* LowerS */) {
                        ignoreCase = false;
                        stripWhitespace(1);
                    }
                    else if (forceIgnore === 105 /* LowerI */) {
                        ignoreCase = true;
                        stripWhitespace(1);
                    }
                }
                if (selector.charCodeAt(selectorIndex) !==
                    93 /* RightSquareBracket */) {
                    throw new Error("Attribute selector didn't terminate");
                }
                selectorIndex += 1;
                const attributeSelector = {
                    type: SelectorType.Attribute,
                    name,
                    action,
                    value,
                    namespace,
                    ignoreCase,
                };
                tokens.push(attributeSelector);
                break;
            }
            case 58 /* Colon */: {
                if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */) {
                    tokens.push({
                        type: SelectorType.PseudoElement,
                        name: getName(2).toLowerCase(),
                        data: selector.charCodeAt(selectorIndex) ===
                            40 /* LeftParenthesis */
                            ? readValueWithParenthesis()
                            : null,
                    });
                    continue;
                }
                const name = getName(1).toLowerCase();
                let data = null;
                if (selector.charCodeAt(selectorIndex) ===
                    40 /* LeftParenthesis */) {
                    if (unpackPseudos.has(name)) {
                        if (isQuote(selector.charCodeAt(selectorIndex + 1))) {
                            throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                        }
                        data = [];
                        selectorIndex = parseSelector(data, selector, selectorIndex + 1);
                        if (selector.charCodeAt(selectorIndex) !==
                            41 /* RightParenthesis */) {
                            throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                        }
                        selectorIndex += 1;
                    }
                    else {
                        data = readValueWithParenthesis();
                        if (stripQuotesFromPseudos.has(name)) {
                            const quot = data.charCodeAt(0);
                            if (quot === data.charCodeAt(data.length - 1) &&
                                isQuote(quot)) {
                                data = data.slice(1, -1);
                            }
                        }
                        data = unescapeCSS(data);
                    }
                }
                tokens.push({ type: SelectorType.Pseudo, name, data });
                break;
            }
            case 44 /* Comma */: {
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            }
            default: {
                if (selector.startsWith("/*", selectorIndex)) {
                    const endIndex = selector.indexOf("*/", selectorIndex + 2);
                    if (endIndex < 0) {
                        throw new Error("Comment was not terminated");
                    }
                    selectorIndex = endIndex + 2;
                    // Remove leading whitespace
                    if (tokens.length === 0) {
                        stripWhitespace(0);
                    }
                    break;
                }
                let namespace = null;
                let name;
                if (firstChar === 42 /* Asterisk */) {
                    selectorIndex += 1;
                    name = "*";
                }
                else if (firstChar === 124 /* Pipe */) {
                    name = "";
                    if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */) {
                        addTraversal(SelectorType.ColumnCombinator);
                        stripWhitespace(2);
                        break;
                    }
                }
                else if (reName.test(selector.slice(selectorIndex))) {
                    name = getName(0);
                }
                else {
                    break loop;
                }
                if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ &&
                    selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */) {
                    namespace = name;
                    if (selector.charCodeAt(selectorIndex + 1) ===
                        42 /* Asterisk */) {
                        name = "*";
                        selectorIndex += 2;
                    }
                    else {
                        name = getName(1);
                    }
                }
                tokens.push(name === "*"
                    ? { type: SelectorType.Universal, namespace }
                    : { type: SelectorType.Tag, name, namespace });
            }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/stringify.js

const attribValChars = ["\\", '"'];
const pseudoValChars = [...attribValChars, "(", ")"];
const charsToEscapeInAttributeValue = new Set(attribValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInPseudoValue = new Set(pseudoValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInName = new Set([
    ...pseudoValChars,
    "~",
    "^",
    "$",
    "*",
    "+",
    "!",
    "|",
    ":",
    "[",
    "]",
    " ",
    ".",
].map((c) => c.charCodeAt(0)));
/**
 * Turns `selector` back into a string.
 *
 * @param selector Selector to stringify.
 */
function stringify(selector) {
    return selector
        .map((token) => token.map(stringifyToken).join(""))
        .join(", ");
}
function stringifyToken(token, index, arr) {
    switch (token.type) {
        // Simple types
        case SelectorType.Child:
            return index === 0 ? "> " : " > ";
        case SelectorType.Parent:
            return index === 0 ? "< " : " < ";
        case SelectorType.Sibling:
            return index === 0 ? "~ " : " ~ ";
        case SelectorType.Adjacent:
            return index === 0 ? "+ " : " + ";
        case SelectorType.Descendant:
            return " ";
        case SelectorType.ColumnCombinator:
            return index === 0 ? "|| " : " || ";
        case SelectorType.Universal:
            // Return an empty string if the selector isn't needed.
            return token.namespace === "*" &&
                index + 1 < arr.length &&
                "name" in arr[index + 1]
                ? ""
                : `${getNamespace(token.namespace)}*`;
        case SelectorType.Tag:
            return getNamespacedName(token);
        case SelectorType.PseudoElement:
            return `::${escapeName(token.name, charsToEscapeInName)}${token.data === null
                ? ""
                : `(${escapeName(token.data, charsToEscapeInPseudoValue)})`}`;
        case SelectorType.Pseudo:
            return `:${escapeName(token.name, charsToEscapeInName)}${token.data === null
                ? ""
                : `(${typeof token.data === "string"
                    ? escapeName(token.data, charsToEscapeInPseudoValue)
                    : stringify(token.data)})`}`;
        case SelectorType.Attribute: {
            if (token.name === "id" &&
                token.action === AttributeAction.Equals &&
                token.ignoreCase === "quirks" &&
                !token.namespace) {
                return `#${escapeName(token.value, charsToEscapeInName)}`;
            }
            if (token.name === "class" &&
                token.action === AttributeAction.Element &&
                token.ignoreCase === "quirks" &&
                !token.namespace) {
                return `.${escapeName(token.value, charsToEscapeInName)}`;
            }
            const name = getNamespacedName(token);
            if (token.action === AttributeAction.Exists) {
                return `[${name}]`;
            }
            return `[${name}${getActionValue(token.action)}="${escapeName(token.value, charsToEscapeInAttributeValue)}"${token.ignoreCase === null ? "" : token.ignoreCase ? " i" : " s"}]`;
        }
    }
}
function getActionValue(action) {
    switch (action) {
        case AttributeAction.Equals:
            return "";
        case AttributeAction.Element:
            return "~";
        case AttributeAction.Start:
            return "^";
        case AttributeAction.End:
            return "$";
        case AttributeAction.Any:
            return "*";
        case AttributeAction.Not:
            return "!";
        case AttributeAction.Hyphen:
            return "|";
        case AttributeAction.Exists:
            throw new Error("Shouldn't be here");
    }
}
function getNamespacedName(token) {
    return `${getNamespace(token.namespace)}${escapeName(token.name, charsToEscapeInName)}`;
}
function getNamespace(namespace) {
    return namespace !== null
        ? `${namespace === "*"
            ? "*"
            : escapeName(namespace, charsToEscapeInName)}|`
        : "";
}
function escapeName(str, charsToEscape) {
    let lastIdx = 0;
    let ret = "";
    for (let i = 0; i < str.length; i++) {
        if (charsToEscape.has(str.charCodeAt(i))) {
            ret += `${str.slice(lastIdx, i)}\\${str.charAt(i)}`;
            lastIdx = i + 1;
        }
    }
    return ret.length > 0 ? ret + str.slice(lastIdx) : str;
}

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/index.js





/***/ }),

/***/ 17837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.attributeNames = exports.elementNames = void 0;
exports.elementNames = new Map([
    ["altglyph", "altGlyph"],
    ["altglyphdef", "altGlyphDef"],
    ["altglyphitem", "altGlyphItem"],
    ["animatecolor", "animateColor"],
    ["animatemotion", "animateMotion"],
    ["animatetransform", "animateTransform"],
    ["clippath", "clipPath"],
    ["feblend", "feBlend"],
    ["fecolormatrix", "feColorMatrix"],
    ["fecomponenttransfer", "feComponentTransfer"],
    ["fecomposite", "feComposite"],
    ["feconvolvematrix", "feConvolveMatrix"],
    ["fediffuselighting", "feDiffuseLighting"],
    ["fedisplacementmap", "feDisplacementMap"],
    ["fedistantlight", "feDistantLight"],
    ["fedropshadow", "feDropShadow"],
    ["feflood", "feFlood"],
    ["fefunca", "feFuncA"],
    ["fefuncb", "feFuncB"],
    ["fefuncg", "feFuncG"],
    ["fefuncr", "feFuncR"],
    ["fegaussianblur", "feGaussianBlur"],
    ["feimage", "feImage"],
    ["femerge", "feMerge"],
    ["femergenode", "feMergeNode"],
    ["femorphology", "feMorphology"],
    ["feoffset", "feOffset"],
    ["fepointlight", "fePointLight"],
    ["fespecularlighting", "feSpecularLighting"],
    ["fespotlight", "feSpotLight"],
    ["fetile", "feTile"],
    ["feturbulence", "feTurbulence"],
    ["foreignobject", "foreignObject"],
    ["glyphref", "glyphRef"],
    ["lineargradient", "linearGradient"],
    ["radialgradient", "radialGradient"],
    ["textpath", "textPath"],
]);
exports.attributeNames = new Map([
    ["definitionurl", "definitionURL"],
    ["attributename", "attributeName"],
    ["attributetype", "attributeType"],
    ["basefrequency", "baseFrequency"],
    ["baseprofile", "baseProfile"],
    ["calcmode", "calcMode"],
    ["clippathunits", "clipPathUnits"],
    ["diffuseconstant", "diffuseConstant"],
    ["edgemode", "edgeMode"],
    ["filterunits", "filterUnits"],
    ["glyphref", "glyphRef"],
    ["gradienttransform", "gradientTransform"],
    ["gradientunits", "gradientUnits"],
    ["kernelmatrix", "kernelMatrix"],
    ["kernelunitlength", "kernelUnitLength"],
    ["keypoints", "keyPoints"],
    ["keysplines", "keySplines"],
    ["keytimes", "keyTimes"],
    ["lengthadjust", "lengthAdjust"],
    ["limitingconeangle", "limitingConeAngle"],
    ["markerheight", "markerHeight"],
    ["markerunits", "markerUnits"],
    ["markerwidth", "markerWidth"],
    ["maskcontentunits", "maskContentUnits"],
    ["maskunits", "maskUnits"],
    ["numoctaves", "numOctaves"],
    ["pathlength", "pathLength"],
    ["patterncontentunits", "patternContentUnits"],
    ["patterntransform", "patternTransform"],
    ["patternunits", "patternUnits"],
    ["pointsatx", "pointsAtX"],
    ["pointsaty", "pointsAtY"],
    ["pointsatz", "pointsAtZ"],
    ["preservealpha", "preserveAlpha"],
    ["preserveaspectratio", "preserveAspectRatio"],
    ["primitiveunits", "primitiveUnits"],
    ["refx", "refX"],
    ["refy", "refY"],
    ["repeatcount", "repeatCount"],
    ["repeatdur", "repeatDur"],
    ["requiredextensions", "requiredExtensions"],
    ["requiredfeatures", "requiredFeatures"],
    ["specularconstant", "specularConstant"],
    ["specularexponent", "specularExponent"],
    ["spreadmethod", "spreadMethod"],
    ["startoffset", "startOffset"],
    ["stddeviation", "stdDeviation"],
    ["stitchtiles", "stitchTiles"],
    ["surfacescale", "surfaceScale"],
    ["systemlanguage", "systemLanguage"],
    ["tablevalues", "tableValues"],
    ["targetx", "targetX"],
    ["targety", "targetY"],
    ["textlength", "textLength"],
    ["viewbox", "viewBox"],
    ["viewtarget", "viewTarget"],
    ["xchannelselector", "xChannelSelector"],
    ["ychannelselector", "yChannelSelector"],
    ["zoomandpan", "zoomAndPan"],
]);


/***/ }),

/***/ 97220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/*
 * Module dependencies
 */
var ElementType = __importStar(__webpack_require__(99960));
var entities_1 = __webpack_require__(45863);
/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */
var foreignNames_1 = __webpack_require__(17837);
var unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript",
]);
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
    if (!attributes)
        return;
    return Object.keys(attributes)
        .map(function (key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") {
            /* Fix up mixed-case attribute names */
            key = (_b = foreignNames_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
            return key;
        }
        return key + "=\"" + (opts.decodeEntities !== false
            ? entities_1.encodeXML(value)
            : value.replace(/"/g, "&quot;")) + "\"";
    })
        .join(" ");
}
/**
 * Self-enclosing tags
 */
var singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render(node, options) {
    if (options === void 0) { options = {}; }
    var nodes = "length" in node ? node : [node];
    var output = "";
    for (var i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options);
    }
    return output;
}
exports["default"] = render;
function renderNode(node, options) {
    switch (node.type) {
        case ElementType.Root:
            return render(node.children, options);
        case ElementType.Directive:
        case ElementType.Doctype:
            return renderDirective(node);
        case ElementType.Comment:
            return renderComment(node);
        case ElementType.CDATA:
            return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
            return renderTag(node, options);
        case ElementType.Text:
            return renderText(node, options);
    }
}
var foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
var foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */
        elem.name = (_a = foreignNames_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.has(elem.parent.name)) {
            opts = __assign(__assign({}, opts), { xmlMode: false });
        }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
    }
    var tag = "<" + elem.name;
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
        tag += " " + attribs;
    }
    if (elem.children.length === 0 &&
        (opts.xmlMode
            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
                opts.selfClosingTags !== false
            : // User explicitly asked for self-closing tags, even in HTML mode
                opts.selfClosingTags && singleTag.has(elem.name))) {
        if (!opts.xmlMode)
            tag += " ";
        tag += "/>";
    }
    else {
        tag += ">";
        if (elem.children.length > 0) {
            tag += render(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
            tag += "</" + elem.name + ">";
        }
    }
    return tag;
}
function renderDirective(elem) {
    return "<" + elem.data + ">";
}
function renderText(elem, opts) {
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (opts.decodeEntities !== false &&
        !(!opts.xmlMode &&
            elem.parent &&
            unencodedElements.has(elem.parent.name))) {
        data = entities_1.encodeXML(data);
    }
    return data;
}
function renderCdata(elem) {
    return "<![CDATA[" + elem.children[0].data + "]]>";
}
function renderComment(elem) {
    return "<!--" + elem.data + "-->";
}


/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 47915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_1 = __webpack_require__(97790);
__exportStar(__webpack_require__(97790), exports);
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 97790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.4.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.1/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.1';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 16996:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFeed = void 0;
var stringify_1 = __webpack_require__(43346);
var legacy_1 = __webpack_require__(23905);
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function getFeed(doc) {
    var feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot
        ? null
        : feedRoot.name === "feed"
            ? getAtomFeed(feedRoot)
            : getRssFeed(feedRoot);
}
exports.getFeed = getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, legacy_1.getElementsByTagName)("entry", childs).map(function (item) {
            var _a;
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "id", children);
            addConditionally(entry, "title", "title", children);
            var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs.href;
            if (href) {
                entry.link = href;
            }
            var description = fetch("summary", children) || fetch("content", children);
            if (description) {
                entry.description = description;
            }
            var pubDate = fetch("updated", children);
            if (pubDate) {
                entry.pubDate = new Date(pubDate);
            }
            return entry;
        }),
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs.href;
    if (href) {
        feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    var updated = fetch("updated", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, legacy_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "guid", children);
            addConditionally(entry, "title", "title", children);
            addConditionally(entry, "link", "link", children);
            addConditionally(entry, "description", "description", children);
            var pubDate = fetch("pubDate", children);
            if (pubDate)
                entry.pubDate = new Date(pubDate);
            return entry;
        }),
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    var updated = fetch("lastBuildDate", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width",
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements(where) {
    return (0, legacy_1.getElementsByTagName)("media:content", where).map(function (elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs.medium,
            isDefault: !!attribs.isDefault,
        };
        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) {
                media[attrib] = attribs[attrib];
            }
        }
        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) {
                media[attrib] = parseInt(attribs[attrib], 10);
            }
        }
        if (attribs.expression) {
            media.expression =
                attribs.expression;
        }
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement(tagName, node) {
    return (0, legacy_1.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where  Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch(tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    return (0, stringify_1.textContent)((0, legacy_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    var val = fetch(tagName, where, recurse);
    if (val)
        obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}


/***/ }),

/***/ 74975:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uniqueSort = exports.compareDocumentPosition = exports.removeSubsets = void 0;
var domhandler_1 = __webpack_require__(47915);
/**
 * Given an array of nodes, remove any member that is contained by another.
 *
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't subtrees of each other.
 */
function removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */
    while (--idx >= 0) {
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.includes(ancestor)) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
exports.removeSubsets = removeSubsets;
/**
 * Compare the position of one node against another node in any other document.
 * The return value is a bitmask with the following values:
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent./
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return 1 /* DISCONNECTED */;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
        }
        return 4 /* FOLLOWING */;
    }
    if (sharedParent === nodeA) {
        return 2 /* PRECEDING */ | 8 /* CONTAINS */;
    }
    return 2 /* PRECEDING */;
}
exports.compareDocumentPosition = compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document and
 * remove any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
    nodes.sort(function (a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & 2 /* PRECEDING */) {
            return -1;
        }
        else if (relative & 4 /* FOLLOWING */) {
            return 1;
        }
        return 0;
    });
    return nodes;
}
exports.uniqueSort = uniqueSort;


/***/ }),

/***/ 89432:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
__exportStar(__webpack_require__(43346), exports);
__exportStar(__webpack_require__(85010), exports);
__exportStar(__webpack_require__(26765), exports);
__exportStar(__webpack_require__(98043), exports);
__exportStar(__webpack_require__(23905), exports);
__exportStar(__webpack_require__(74975), exports);
__exportStar(__webpack_require__(16996), exports);
/** @deprecated Use these methods from `domhandler` directly. */
var domhandler_1 = __webpack_require__(47915);
Object.defineProperty(exports, "isTag", ({ enumerable: true, get: function () { return domhandler_1.isTag; } }));
Object.defineProperty(exports, "isCDATA", ({ enumerable: true, get: function () { return domhandler_1.isCDATA; } }));
Object.defineProperty(exports, "isText", ({ enumerable: true, get: function () { return domhandler_1.isText; } }));
Object.defineProperty(exports, "isComment", ({ enumerable: true, get: function () { return domhandler_1.isComment; } }));
Object.defineProperty(exports, "isDocument", ({ enumerable: true, get: function () { return domhandler_1.isDocument; } }));
Object.defineProperty(exports, "hasChildren", ({ enumerable: true, get: function () { return domhandler_1.hasChildren; } }));


/***/ }),

/***/ 23905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getElementsByTagType = exports.getElementsByTagName = exports.getElementById = exports.getElements = exports.testElement = void 0;
var domhandler_1 = __webpack_require__(47915);
var querying_1 = __webpack_require__(98043);
var Checks = {
    tag_name: function (name) {
        if (typeof name === "function") {
            return function (elem) { return (0, domhandler_1.isTag)(elem) && name(elem.name); };
        }
        else if (name === "*") {
            return domhandler_1.isTag;
        }
        return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.name === name; };
    },
    tag_type: function (type) {
        if (typeof type === "function") {
            return function (elem) { return type(elem.type); };
        }
        return function (elem) { return elem.type === type; };
    },
    tag_contains: function (data) {
        if (typeof data === "function") {
            return function (elem) { return (0, domhandler_1.isText)(elem) && data(elem.data); };
        }
        return function (elem) { return (0, domhandler_1.isText)(elem) && elem.data === data; };
    },
};
/**
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a particular value.
 */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return function (elem) { return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]); };
    }
    return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value; };
}
/**
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either
 * of the input functions returns `true` for the node.
 */
function combineFuncs(a, b) {
    return function (elem) { return a(elem) || b(elem); };
}
/**
 * @param options An object describing nodes to look for.
 * @returns A function executing all checks in `options` and returning `true`
 * if any of them match a node.
 */
function compileTest(options) {
    var funcs = Object.keys(options).map(function (key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call(Checks, key)
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
    var test = compileTest(options);
    return test ? test(node) : true;
}
exports.testElement = testElement;
/**
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements(options, nodes, recurse, limit) {
    if (limit === void 0) { limit = Infinity; }
    var test = compileTest(options);
    return test ? (0, querying_1.filter)(test, nodes, recurse, limit) : [];
}
exports.getElements = getElements;
/**
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    if (!Array.isArray(nodes))
        nodes = [nodes];
    return (0, querying_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
exports.getElementById = getElementById;
/**
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_name(tagName), nodes, recurse, limit);
}
exports.getElementsByTagName = getElementsByTagName;
/**
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_type(type), nodes, recurse, limit);
}
exports.getElementsByTagType = getElementsByTagType;


/***/ }),

/***/ 26765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.prepend = exports.prependChild = exports.append = exports.appendChild = exports.replaceElement = exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @param elem The element to be removed
 */
function removeElement(elem) {
    if (elem.prev)
        elem.prev.next = elem.next;
    if (elem.next)
        elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
    }
}
exports.removeElement = removeElement;
/**
 * Replace an element in the dom
 *
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
    var prev = (replacement.prev = elem.prev);
    if (prev) {
        prev.next = replacement;
    }
    var next = (replacement.next = elem.next);
    if (next) {
        next.prev = replacement;
    }
    var parent = (replacement.parent = elem.parent);
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
    }
}
exports.replaceElement = replaceElement;
/**
 * Append a child to an element.
 *
 * @param elem The element to append to.
 * @param child The element to be added as a child.
 */
function appendChild(elem, child) {
    removeElement(child);
    child.next = null;
    child.parent = elem;
    if (elem.children.push(child) > 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    }
    else {
        child.prev = null;
    }
}
exports.appendChild = appendChild;
/**
 * Append an element after another.
 *
 * @param elem The element to append after.
 * @param next The element be added.
 */
function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    }
    else if (parent) {
        parent.children.push(next);
    }
}
exports.append = append;
/**
 * Prepend a child to an element.
 *
 * @param elem The element to prepend before.
 * @param child The element to be added as a child.
 */
function prependChild(elem, child) {
    removeElement(child);
    child.parent = elem;
    child.prev = null;
    if (elem.children.unshift(child) !== 1) {
        var sibling = elem.children[1];
        sibling.prev = child;
        child.next = sibling;
    }
    else {
        child.next = null;
    }
}
exports.prependChild = prependChild;
/**
 * Prepend an element before another.
 *
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */
function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
        elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
exports.prepend = prepend;


/***/ }),

/***/ 98043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findAll = exports.existsOne = exports.findOne = exports.findOneChild = exports.find = exports.filter = void 0;
var domhandler_1 = __webpack_require__(47915);
/**
 * Search a node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function filter(test, node, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    if (!Array.isArray(node))
        node = [node];
    return find(test, node, recurse, limit);
}
exports.filter = filter;
/**
 * Search an array of node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find(test, nodes, recurse, limit) {
    var result = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var elem = nodes_1[_i];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                break;
        }
        if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
            var children = find(test, elem.children, recurse, limit);
            result.push.apply(result, children);
            limit -= children.length;
            if (limit <= 0)
                break;
        }
    }
    return result;
}
exports.find = find;
/**
 * Finds the first element inside of an array that matches a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
exports.findOneChild = findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first child node that passes `test`.
 */
function findOne(test, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    var elem = null;
    for (var i = 0; i < nodes.length && !elem; i++) {
        var checked = nodes[i];
        if (!(0, domhandler_1.isTag)(checked)) {
            continue;
        }
        else if (test(checked)) {
            elem = checked;
        }
        else if (recurse && checked.children.length > 0) {
            elem = findOne(test, checked.children);
        }
    }
    return elem;
}
exports.findOne = findOne;
/**
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing a test.
 */
function existsOne(test, nodes) {
    return nodes.some(function (checked) {
        return (0, domhandler_1.isTag)(checked) &&
            (test(checked) ||
                (checked.children.length > 0 &&
                    existsOne(test, checked.children)));
    });
}
exports.existsOne = existsOne;
/**
 * Search and array of nodes and its children for nodes passing a test function.
 *
 * Same as `find`, only with less options, leading to reduced complexity.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter(domhandler_1.isTag);
    var elem;
    while ((elem = stack.shift())) {
        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(domhandler_1.isTag);
        if (children && children.length > 0) {
            stack.unshift.apply(stack, children);
        }
        if (test(elem))
            result.push(elem);
    }
    return result;
}
exports.findAll = findAll;


/***/ }),

/***/ 43346:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.innerText = exports.textContent = exports.getText = exports.getInnerHTML = exports.getOuterHTML = void 0;
var domhandler_1 = __webpack_require__(47915);
var dom_serializer_1 = __importDefault(__webpack_require__(97220));
var domelementtype_1 = __webpack_require__(99960);
/**
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
    return (0, dom_serializer_1.default)(node, options);
}
exports.getOuterHTML = getOuterHTML;
/**
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
    return (0, domhandler_1.hasChildren)(node)
        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
        : "";
}
exports.getInnerHTML = getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags.
 *
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if ((0, domhandler_1.isTag)(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if ((0, domhandler_1.isCDATA)(node))
        return getText(node.children);
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.getText = getText;
/**
 * Get a node's text content.
 *
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function textContent(node) {
    if (Array.isArray(node))
        return node.map(textContent).join("");
    if ((0, domhandler_1.hasChildren)(node) && !(0, domhandler_1.isComment)(node)) {
        return textContent(node.children);
    }
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.textContent = textContent;
/**
 * Get a node's inner text.
 *
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
    if (Array.isArray(node))
        return node.map(innerText).join("");
    if ((0, domhandler_1.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node))) {
        return innerText(node.children);
    }
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.innerText = innerText;


/***/ }),

/***/ 85010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.prevElementSibling = exports.nextElementSibling = exports.getName = exports.hasAttrib = exports.getAttributeValue = exports.getSiblings = exports.getParent = exports.getChildren = void 0;
var domhandler_1 = __webpack_require__(47915);
var emptyArray = [];
/**
 * Get a node's children.
 *
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren(elem) {
    var _a;
    return (_a = elem.children) !== null && _a !== void 0 ? _a : emptyArray;
}
exports.getChildren = getChildren;
/**
 * Get a node's parent.
 *
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node.
 */
function getParent(elem) {
    return elem.parent || null;
}
exports.getParent = getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first.
 * If we don't have a parent (the element is a root node),
 * we walk the element's `prev` & `next` to get all remaining nodes.
 *
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings.
 */
function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null)
        return getChildren(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
        siblings.unshift(prev);
        (_a = prev, prev = _a.prev);
    }
    while (next != null) {
        siblings.push(next);
        (_b = next, next = _b.next);
    }
    return siblings;
}
exports.getSiblings = getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
exports.getAttributeValue = getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
    return (elem.attribs != null &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
exports.hasAttrib = hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
    return elem.name;
}
exports.getName = getName;
/**
 * Returns the next element sibling of a node.
 *
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag.
 */
function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1.isTag)(next))
        (_a = next, next = _a.next);
    return next;
}
exports.nextElementSibling = nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag.
 */
function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1.isTag)(prev))
        (_a = prev, prev = _a.prev);
    return prev;
}
exports.prevElementSibling = prevElementSibling;


/***/ }),

/***/ 89265:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () { 'use strict';

  /**
  * Utility function to execute callback for eack key->value pair.
  */
  function forEach(obj, callback) {
    if (obj) {
      for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if ({}.hasOwnProperty.call(obj, key)) {
          callback(key, obj[key]);
        }
      }
    }
  }
  /**
  * The function returns true if the string passed to it has no content.
  */

  function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
      return true;
    }

    return false;
  }

  /**
  * Mapping block-type to corresponding html tag.
  */

  var blockTypesMapping = {
    unstyled: 'p',
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'header-six': 'h6',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    blockquote: 'blockquote',
    code: 'pre'
  };
  /**
  * Function will return HTML tag for a block.
  */

  function getBlockTag(type) {
    return type && blockTypesMapping[type];
  }
  /**
  * Function will return style string for a block.
  */

  function getBlockStyle(data) {
    var styles = '';
    forEach(data, function (key, value) {
      if (value) {
        styles += "".concat(key, ":").concat(value, ";");
      }
    });
    return styles;
  }
  /**
  * The function returns an array of hashtag-sections in blocks.
  * These will be areas in block which have hashtags applicable to them.
  */

  function getHashtagRanges(blockText, hashtagConfig) {
    var sections = [];

    if (hashtagConfig) {
      var counter = 0;
      var startIndex = 0;
      var text = blockText;
      var trigger = hashtagConfig.trigger || '#';
      var separator = hashtagConfig.separator || ' ';

      for (; text.length > 0 && startIndex >= 0;) {
        if (text[0] === trigger) {
          startIndex = 0;
          counter = 0;
          text = text.substr(trigger.length);
        } else {
          startIndex = text.indexOf(separator + trigger);

          if (startIndex >= 0) {
            text = text.substr(startIndex + (separator + trigger).length);
            counter += startIndex + separator.length;
          }
        }

        if (startIndex >= 0) {
          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
          var hashtag = text.substr(0, endIndex);

          if (hashtag && hashtag.length > 0) {
            sections.push({
              offset: counter,
              length: hashtag.length + trigger.length,
              type: 'HASHTAG'
            });
          }

          counter += trigger.length;
        }
      }
    }

    return sections;
  }
  /**
  * The function returns an array of entity-sections in blocks.
  * These will be areas in block which have same entity or no entity applicable to them.
  */


  function getSections(block, hashtagConfig) {
    var sections = [];
    var lastOffset = 0;
    var sectionRanges = block.entityRanges.map(function (range) {
      var offset = range.offset,
          length = range.length,
          key = range.key;
      return {
        offset: offset,
        length: length,
        key: key,
        type: 'ENTITY'
      };
    });
    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
    sectionRanges = sectionRanges.sort(function (s1, s2) {
      return s1.offset - s2.offset;
    });
    sectionRanges.forEach(function (r) {
      if (r.offset > lastOffset) {
        sections.push({
          start: lastOffset,
          end: r.offset
        });
      }

      sections.push({
        start: r.offset,
        end: r.offset + r.length,
        entityKey: r.key,
        type: r.type
      });
      lastOffset = r.offset + r.length;
    });

    if (lastOffset < block.text.length) {
      sections.push({
        start: lastOffset,
        end: block.text.length
      });
    }

    return sections;
  }
  /**
  * Function to check if the block is an atomic entity block.
  */


  function isAtomicEntityBlock(block) {
    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
      return true;
    }

    return false;
  }
  /**
  * The function will return array of inline styles applicable to the block.
  */


  function getStyleArrayForBlock(block) {
    var text = block.text,
        inlineStyleRanges = block.inlineStyleRanges;
    var inlineStyles = {
      BOLD: new Array(text.length),
      ITALIC: new Array(text.length),
      UNDERLINE: new Array(text.length),
      STRIKETHROUGH: new Array(text.length),
      CODE: new Array(text.length),
      SUPERSCRIPT: new Array(text.length),
      SUBSCRIPT: new Array(text.length),
      COLOR: new Array(text.length),
      BGCOLOR: new Array(text.length),
      FONTSIZE: new Array(text.length),
      FONTFAMILY: new Array(text.length),
      length: text.length
    };

    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
      inlineStyleRanges.forEach(function (range) {
        var offset = range.offset;
        var length = offset + range.length;

        for (var i = offset; i < length; i += 1) {
          if (range.style.indexOf('color-') === 0) {
            inlineStyles.COLOR[i] = range.style.substring(6);
          } else if (range.style.indexOf('bgcolor-') === 0) {
            inlineStyles.BGCOLOR[i] = range.style.substring(8);
          } else if (range.style.indexOf('fontsize-') === 0) {
            inlineStyles.FONTSIZE[i] = range.style.substring(9);
          } else if (range.style.indexOf('fontfamily-') === 0) {
            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
          } else if (inlineStyles[range.style]) {
            inlineStyles[range.style][i] = true;
          }
        }
      });
    }

    return inlineStyles;
  }
  /**
  * The function will return inline style applicable at some offset within a block.
  */


  function getStylesAtOffset(inlineStyles, offset) {
    var styles = {};

    if (inlineStyles.COLOR[offset]) {
      styles.COLOR = inlineStyles.COLOR[offset];
    }

    if (inlineStyles.BGCOLOR[offset]) {
      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
    }

    if (inlineStyles.FONTSIZE[offset]) {
      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
    }

    if (inlineStyles.FONTFAMILY[offset]) {
      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
    }

    if (inlineStyles.UNDERLINE[offset]) {
      styles.UNDERLINE = true;
    }

    if (inlineStyles.ITALIC[offset]) {
      styles.ITALIC = true;
    }

    if (inlineStyles.BOLD[offset]) {
      styles.BOLD = true;
    }

    if (inlineStyles.STRIKETHROUGH[offset]) {
      styles.STRIKETHROUGH = true;
    }

    if (inlineStyles.CODE[offset]) {
      styles.CODE = true;
    }

    if (inlineStyles.SUBSCRIPT[offset]) {
      styles.SUBSCRIPT = true;
    }

    if (inlineStyles.SUPERSCRIPT[offset]) {
      styles.SUPERSCRIPT = true;
    }

    return styles;
  }
  /**
  * Function returns true for a set of styles if the value of these styles at an offset
  * are same as that on the previous offset.
  */

  function sameStyleAsPrevious(inlineStyles, styles, index) {
    var sameStyled = true;

    if (index > 0 && index < inlineStyles.length) {
      styles.forEach(function (style) {
        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
      });
    } else {
      sameStyled = false;
    }

    return sameStyled;
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */

  function addInlineStyleMarkup(style, content) {
    if (style === 'BOLD') {
      return "<strong>".concat(content, "</strong>");
    }

    if (style === 'ITALIC') {
      return "<em>".concat(content, "</em>");
    }

    if (style === 'UNDERLINE') {
      return "<ins>".concat(content, "</ins>");
    }

    if (style === 'STRIKETHROUGH') {
      return "<del>".concat(content, "</del>");
    }

    if (style === 'CODE') {
      return "<code>".concat(content, "</code>");
    }

    if (style === 'SUPERSCRIPT') {
      return "<sup>".concat(content, "</sup>");
    }

    if (style === 'SUBSCRIPT') {
      return "<sub>".concat(content, "</sub>");
    }

    return content;
  }
  /**
  * The function returns text for given section of block after doing required character replacements.
  */

  function getSectionText(text) {
    if (text && text.length > 0) {
      var chars = text.map(function (ch) {
        switch (ch) {
          case '\n':
            return '<br>';

          case '&':
            return '&amp;';

          case '<':
            return '&lt;';

          case '>':
            return '&gt;';

          default:
            return ch;
        }
      });
      return chars.join('');
    }

    return '';
  }
  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */


  function addStylePropertyMarkup(styles, text) {
    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
      var styleString = 'style="';

      if (styles.COLOR) {
        styleString += "color: ".concat(styles.COLOR, ";");
      }

      if (styles.BGCOLOR) {
        styleString += "background-color: ".concat(styles.BGCOLOR, ";");
      }

      if (styles.FONTSIZE) {
        styleString += "font-size: ".concat(styles.FONTSIZE).concat(/^\d+$/.test(styles.FONTSIZE) ? 'px' : '', ";");
      }

      if (styles.FONTFAMILY) {
        styleString += "font-family: ".concat(styles.FONTFAMILY, ";");
      }

      styleString += '"';
      return "<span ".concat(styleString, ">").concat(text, "</span>");
    }

    return text;
  }
  /**
  * Function will return markup for Entity.
  */

  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
    var entity = entityMap[entityKey];

    if (typeof customEntityTransform === 'function') {
      var html = customEntityTransform(entity, text);

      if (html) {
        return html;
      }
    }

    if (entity.type === 'MENTION') {
      return "<a href=\"".concat(entity.data.url, "\" class=\"wysiwyg-mention\" data-mention data-value=\"").concat(entity.data.value, "\">").concat(text, "</a>");
    }

    if (entity.type === 'LINK') {
      var targetOption = entity.data.targetOption || '_self';
      return "<a href=\"".concat(entity.data.url, "\" target=\"").concat(targetOption, "\">").concat(text, "</a>");
    }

    if (entity.type === 'IMAGE') {
      var alignment = entity.data.alignment;

      if (alignment && alignment.length) {
        return "<div style=\"text-align:".concat(alignment, ";\"><img src=\"").concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/></div>");
      }

      return "<img src=\"".concat(entity.data.src, "\" alt=\"").concat(entity.data.alt, "\" style=\"height: ").concat(entity.data.height, ";width: ").concat(entity.data.width, "\"/>");
    }

    if (entity.type === 'EMBEDDED_LINK') {
      return "<iframe width=\"".concat(entity.data.width, "\" height=\"").concat(entity.data.height, "\" src=\"").concat(entity.data.src, "\" frameBorder=\"0\"></iframe>");
    }

    return text;
  }
  /**
  * For a given section in a block the function will return a further list of sections,
  * with similar inline styles applicable to them.
  */


  function getInlineStyleSections(block, styles, start, end) {
    var styleSections = [];
    var text = Array.from(block.text);

    if (text.length > 0) {
      var inlineStyles = getStyleArrayForBlock(block);
      var section;

      for (var i = start; i < end; i += 1) {
        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
          section.text.push(text[i]);
          section.end = i + 1;
        } else {
          section = {
            styles: getStylesAtOffset(inlineStyles, i),
            text: [text[i]],
            start: i,
            end: i + 1
          };
          styleSections.push(section);
        }
      }
    }

    return styleSections;
  }
  /**
  * Replace leading blank spaces by &nbsp;
  */


  function trimLeadingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = 0; i < replacedText.length; i += 1) {
        if (sectionText[i] === ' ') {
          replacedText = replacedText.replace(' ', '&nbsp;');
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * Replace trailing blank spaces by &nbsp;
  */

  function trimTrailingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;

      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
        if (replacedText[i] === ' ') {
          replacedText = "".concat(replacedText.substring(0, i), "&nbsp;").concat(replacedText.substring(i + 1));
        } else {
          break;
        }
      }

      return replacedText;
    }

    return sectionText;
  }
  /**
  * The method returns markup for section to which inline styles
  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
  */

  function getStyleTagSectionMarkup(styleSection) {
    var styles = styleSection.styles,
        text = styleSection.text;
    var content = getSectionText(text);
    forEach(styles, function (style, value) {
      content = addInlineStyleMarkup(style, content);
    });
    return content;
  }
  /**
  * The method returns markup for section to which inline styles
  like color, background-color, font-size are applicable.
  */


  function getInlineStyleSectionMarkup(block, styleSection) {
    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
    var styleSectionText = '';
    styleTagSections.forEach(function (stylePropertySection) {
      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
    });
    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
    return styleSectionText;
  }
  /*
  * The method returns markup for an entity section.
  * An entity section is a continuous section in a block
  * to which same entity or no entity is applicable.
  */


  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
    var entityInlineMarkup = [];
    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
    inlineStyleSections.forEach(function (styleSection) {
      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
    });
    var sectionText = entityInlineMarkup.join('');

    if (section.type === 'ENTITY') {
      if (section.entityKey !== undefined && section.entityKey !== null) {
        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
      }
    } else if (section.type === 'HASHTAG') {
      sectionText = "<a href=\"".concat(sectionText, "\" class=\"wysiwyg-hashtag\">").concat(sectionText, "</a>");
    }

    return sectionText;
  }
  /**
  * Function will return the markup for block preserving the inline styles and
  * special characters like newlines or blank spaces.
  */


  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
    var blockMarkup = [];
    var sections = getSections(block, hashtagConfig);
    sections.forEach(function (section, index) {
      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);

      if (index === 0) {
        sectionText = trimLeadingZeros(sectionText);
      }

      if (index === sections.length - 1) {
        sectionText = trimTrailingZeros(sectionText);
      }

      blockMarkup.push(sectionText);
    });
    return blockMarkup.join('');
  }
  /**
  * Function will return html for the block.
  */

  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
    var blockHtml = [];

    if (isAtomicEntityBlock(block)) {
      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
    } else {
      var blockTag = getBlockTag(block.type);

      if (blockTag) {
        blockHtml.push("<".concat(blockTag));
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          blockHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          blockHtml.push(' dir = "auto"');
        }

        blockHtml.push('>');
        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        blockHtml.push("</".concat(blockTag, ">"));
      }
    }

    blockHtml.push('\n');
    return blockHtml.join('');
  }

  /**
  * Function to check if a block is of type list.
  */

  function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
  }
  /**
  * Function will return html markup for a list block.
  */

  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock;
    listBlocks.forEach(function (block) {
      var nestedBlock = false;

      if (!previousBlock) {
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.type !== block.type) {
        listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
        listHtml.push("<".concat(getBlockTag(block.type), ">\n"));
      } else if (previousBlock.depth === block.depth) {
        if (nestedListBlock && nestedListBlock.length > 0) {
          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
          nestedListBlock = [];
        }
      } else {
        nestedBlock = true;
        nestedListBlock.push(block);
      }

      if (!nestedBlock) {
        listHtml.push('<li');
        var blockStyle = getBlockStyle(block.data);

        if (blockStyle) {
          listHtml.push(" style=\"".concat(blockStyle, "\""));
        }

        if (directional) {
          listHtml.push(' dir = "auto"');
        }

        listHtml.push('>');
        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        listHtml.push('</li>\n');
        previousBlock = block;
      }
    });

    if (nestedListBlock && nestedListBlock.length > 0) {
      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }

    listHtml.push("</".concat(getBlockTag(previousBlock.type), ">\n"));
    return listHtml.join('');
  }

  /**
  * The function will generate html markup for given draftjs editorContent.
  */

  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];

    if (editorContent) {
      var blocks = editorContent.blocks,
          entityMap = editorContent.entityMap;

      if (blocks && blocks.length > 0) {
        var listBlocks = [];
        blocks.forEach(function (block) {
          if (isList(block.type)) {
            listBlocks.push(block);
          } else {
            if (listBlocks.length > 0) {
              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len

              html.push(listHtml);
              listBlocks = [];
            }

            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
            html.push(blockHtml);
          }
        });

        if (listBlocks.length > 0) {
          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len

          html.push(listHtml);
          listBlocks = [];
        }
      }
    }

    return html.join('');
  }

  return draftToHtml;

})));


/***/ }),

/***/ 44076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
var entities_json_1 = __importDefault(__webpack_require__(59323));
var legacy_json_1 = __importDefault(__webpack_require__(29591));
var xml_json_1 = __importDefault(__webpack_require__(2586));
var decode_codepoint_1 = __importDefault(__webpack_require__(26));
var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
exports.decodeXML = getStrictDecoder(xml_json_1.default);
exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
function getStrictDecoder(map) {
    var replace = getReplacer(map);
    return function (str) { return String(str).replace(strictEntityRe, replace); };
}
var sorter = function (a, b) { return (a < b ? 1 : -1); };
exports.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
    var keys = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}


/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var decode_json_1 = __importDefault(__webpack_require__(33600));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
}
exports["default"] = decodeCodePoint;


/***/ }),

/***/ 87322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
var xml_json_1 = __importDefault(__webpack_require__(2586));
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeXML = getASCIIEncoder(inverseXML);
var entities_json_1 = __importDefault(__webpack_require__(59323));
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function (str) { return str.codePointAt(0); }
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function (c) {
            return (c.charCodeAt(0) - 0xd800) * 0x400 +
                c.charCodeAt(1) -
                0xdc00 +
                0x10000;
        };
function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
        .toString(16)
        .toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
function escape(data) {
    return data.replace(reEscapeChars, singleCharReplacer);
}
exports.escape = escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
function escapeUTF8(data) {
    return data.replace(xmlReplacer, singleCharReplacer);
}
exports.escapeUTF8 = escapeUTF8;
function getASCIIEncoder(obj) {
    return function (data) {
        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
    };
}


/***/ }),

/***/ 45863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = __webpack_require__(44076);
var encode_1 = __webpack_require__(87322);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */
function decode(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = __webpack_require__(87322);
Object.defineProperty(exports, "encodeXML", ({ enumerable: true, get: function () { return encode_2.encodeXML; } }));
Object.defineProperty(exports, "encodeHTML", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeNonAsciiHTML", ({ enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } }));
Object.defineProperty(exports, "escape", ({ enumerable: true, get: function () { return encode_2.escape; } }));
Object.defineProperty(exports, "escapeUTF8", ({ enumerable: true, get: function () { return encode_2.escapeUTF8; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeHTML5", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
var decode_2 = __webpack_require__(44076);
Object.defineProperty(exports, "decodeXML", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));
Object.defineProperty(exports, "decodeHTML", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML5", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML4Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeHTML5Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeXMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));


/***/ }),

/***/ 86492:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 7145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);

Object.defineProperty(exports, "__esModule", ({ value: true }));
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */
    return typeof obj === 'object' && !('toString' in obj) ?
        Object.prototype.toString.call(obj).slice(8, -1) :
        obj;
}
var isProduction = typeof process === 'object' && "production" === 'production';
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */
        if (isProduction) {
            throw new Error('Invariant failed');
        }
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
                "not contain an array except as the value of $set, $push, $unshift, " +
                "$splice or any custom command allowing an array value."; });
        }
        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
            "every included key path must be plain objects containing one of the " +
            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports["default"] = defaultContext.update;
// @ts-ignore
exports["default"]["default"] = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
        "Did you forget to wrap your parameter in an array?"; });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
        "Did you forget to wrap your parameters in an array?"; });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
}


/***/ }),

/***/ 66337:
/***/ (function() {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),

/***/ 43390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _intro = _interopRequireDefault(__webpack_require__(61378));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _react = __webpack_require__(67294);

var introJsPropTypes = _interopRequireWildcard(__webpack_require__(96115));

var introJsDefaultProps = _interopRequireWildcard(__webpack_require__(89916));

var _server = __webpack_require__(6166);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Intro.js Hints Component.
 */
var Hints = /*#__PURE__*/function (_Component) {
  _inherits(Hints, _Component);

  var _super = _createSuper(Hints);

  /**
   * React Props
   * @type {Object}
   */

  /**
   * React Default Props
   * @type {Object}
   */

  /**
   * Creates a new instance of the component.
   * @class
   * @param {Object} props - The props of the component.
   */
  function Hints(props) {
    var _this;

    _classCallCheck(this, Hints);

    _this = _super.call(this, props);
    _this.introJs = null;
    _this.isConfigured = false;

    _this.installIntroJs();

    return _this;
  }
  /**
   * Lifecycle: componentDidMount.
   * We use this event to enable Intro.js hints at mount time if enabled right from the start.
   */


  _createClass(Hints, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.enabled) {
        this.configureIntroJs();
        this.renderHints();
      }
    }
    /**
     * Lifecycle: componentDidUpdate.
     * @param  {Object} prevProps - The previous props.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          enabled = _this$props.enabled,
          hints = _this$props.hints,
          options = _this$props.options;

      if (!this.isConfigured || prevProps.hints !== hints || prevProps.options !== options) {
        this.configureIntroJs();
        this.renderHints();
      }

      if (prevProps.enabled !== enabled) {
        this.renderHints();
      }
    }
    /**
     * Lifecycle: componentWillUnmount.
     * We use this even to hide the hints when the component is unmounted.
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.introJs.hideHints();
    }
    /**
     * Installs Intro.js.
     */

  }, {
    key: "installIntroJs",
    value: function installIntroJs() {
      if ((0, _server.isServer)()) {
        return;
      }

      this.introJs = (0, _intro["default"])();
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          onClose = _this$props2.onClose;

      if (onClick) {
        this.introJs.onhintclick(onClick);
      }

      if (onClose) {
        this.introJs.onhintclose(onClose);
      }
    }
    /**
     * Configures Intro.js if not already configured.
     */

  }, {
    key: "configureIntroJs",
    value: function configureIntroJs() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          hints = _this$props3.hints; // We need to remove all hints otherwise new hints won't be added.

      this.introJs.removeHints();
      this.introJs.setOptions(_objectSpread(_objectSpread({}, options), {}, {
        hints: hints
      }));
      this.isConfigured = true;
    }
    /**
     * Renders the Intro.js hints.
     */

  }, {
    key: "renderHints",
    value: function renderHints() {
      var _this$props4 = this.props,
          enabled = _this$props4.enabled,
          hints = _this$props4.hints;

      if (enabled && hints.length > 0) {
        this.introJs.showHints();
      } else if (!enabled) {
        this.introJs.hideHints();
      }
    }
    /**
     * Renders the component.
     * @return {null} We do not want to render anything.
     */

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Hints;
}(_react.Component);

exports["default"] = Hints;

_defineProperty(Hints, "propTypes", {
  enabled: _propTypes["default"].bool,
  hints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    element: _propTypes["default"].string.isRequired,
    hint: _propTypes["default"].string.isRequired,
    hintPosition: introJsPropTypes.hintPosition
  })).isRequired,
  onClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  options: introJsPropTypes.options
});

_defineProperty(Hints, "defaultProps", {
  enabled: false,
  onClick: null,
  onClose: null,
  options: introJsDefaultProps.options
});

/***/ }),

/***/ 38536:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _intro = _interopRequireDefault(__webpack_require__(61378));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _react = __webpack_require__(67294);

var _server = __webpack_require__(97762);

var introJsPropTypes = _interopRequireWildcard(__webpack_require__(96115));

var introJsDefaultProps = _interopRequireWildcard(__webpack_require__(89916));

var _server2 = __webpack_require__(6166);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Intro.js Steps Component.
 */
var Steps = /*#__PURE__*/function (_Component) {
  _inherits(Steps, _Component);

  var _super = _createSuper(Steps);

  /**
   * React Props
   * @type {Object}
   */

  /**
   * React Default Props
   * @type {Object}
   */

  /**
   * Creates a new instance of the component.
   * @class
   * @param {Object} props - The props of the component.
   */
  function Steps(props) {
    var _this;

    _classCallCheck(this, Steps);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onExit", function () {
      var onExit = _this.props.onExit;
      _this.isVisible = false;
      onExit(_this.introJs._currentStep);
    });

    _defineProperty(_assertThisInitialized(_this), "onBeforeExit", function () {
      var onBeforeExit = _this.props.onBeforeExit;

      if (onBeforeExit) {
        return onBeforeExit(_this.introJs._currentStep);
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onBeforeChange", function (nextElement) {
      if (!_this.isVisible) {
        return true;
      }

      var _this$props = _this.props,
          onBeforeChange = _this$props.onBeforeChange,
          onPreventChange = _this$props.onPreventChange;

      if (onBeforeChange) {
        var continueStep = onBeforeChange(_this.introJs._currentStep, nextElement);

        if (continueStep === false && onPreventChange) {
          setTimeout(function () {
            onPreventChange(_this.introJs._currentStep);
          }, 0);
        }

        return continueStep;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onAfterChange", function (element) {
      if (!_this.isVisible) {
        return;
      }

      var onAfterChange = _this.props.onAfterChange;

      if (onAfterChange) {
        onAfterChange(_this.introJs._currentStep, element);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (element) {
      if (!_this.isVisible) {
        return;
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(_this.introJs._currentStep, element);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onComplete", function () {
      var onComplete = _this.props.onComplete;

      if (onComplete) {
        onComplete();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateStepElement", function (stepIndex) {
      var element = document.querySelector(_this.introJs._options.steps[stepIndex].element);

      if (element) {
        _this.introJs._introItems[stepIndex].element = element;
        _this.introJs._introItems[stepIndex].position = _this.introJs._options.steps[stepIndex].position || 'auto';
      }
    });

    _this.introJs = null;
    _this.isConfigured = false; // We need to manually keep track of the visibility state to avoid a callback hell.

    _this.isVisible = false;

    _this.installIntroJs();

    return _this;
  }
  /**
   * Lifecycle: componentDidMount.
   * We use this event to enable Intro.js steps at mount time if enabled right from the start.
   */


  _createClass(Steps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.enabled) {
        this.configureIntroJs();
        this.renderSteps();
      }
    }
    /**
     * Lifecycle: componentDidUpdate.
     * @param  {Object} prevProps - The previous props.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          enabled = _this$props2.enabled,
          steps = _this$props2.steps,
          options = _this$props2.options;

      if (!this.isConfigured || prevProps.steps !== steps || prevProps.options !== options) {
        this.configureIntroJs();
        this.renderSteps();
      }

      if (prevProps.enabled !== enabled) {
        this.renderSteps();
      }
    }
    /**
     * Lifecycle: componentWillUnmount.
     * We use this even to hide the steps when the component is unmounted.
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.introJs.exit();
    }
    /**
     * Triggered when Intro.js steps are exited.
     */

  }, {
    key: "installIntroJs",

    /**
     * Installs Intro.js.
     */
    value: function installIntroJs() {
      if ((0, _server2.isServer)()) {
        return;
      }

      this.introJs = (0, _intro["default"])();
      this.introJs.onexit(this.onExit);
      this.introJs.onbeforeexit(this.onBeforeExit);
      this.introJs.onbeforechange(this.onBeforeChange);
      this.introJs.onafterchange(this.onAfterChange);
      this.introJs.onchange(this.onChange);
      this.introJs.oncomplete(this.onComplete);
    }
    /**
     * Configures Intro.js if not already configured.
     */

  }, {
    key: "configureIntroJs",
    value: function configureIntroJs() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          steps = _this$props3.steps;
      var sanitizedSteps = steps.map(function (step) {
        if ((0, _react.isValidElement)(step.intro)) {
          return _objectSpread(_objectSpread({}, step), {}, {
            intro: (0, _server.renderToStaticMarkup)(step.intro)
          });
        }

        return step;
      });
      this.introJs.setOptions(_objectSpread(_objectSpread({}, options), {}, {
        steps: sanitizedSteps
      }));
      this.isConfigured = true;
    }
    /**
     * Renders the Intro.js steps.
     */

  }, {
    key: "renderSteps",
    value: function renderSteps() {
      var _this$props4 = this.props,
          enabled = _this$props4.enabled,
          initialStep = _this$props4.initialStep,
          steps = _this$props4.steps,
          onStart = _this$props4.onStart;

      if (enabled && steps.length > 0 && !this.isVisible) {
        this.introJs.start();
        this.isVisible = true;
        this.introJs.goToStepNumber(initialStep + 1);

        if (onStart) {
          onStart(this.introJs._currentStep);
        }
      } else if (!enabled && this.isVisible) {
        this.isVisible = false;
        this.introJs.exit();
      }
    }
    /**
     * Renders the component.
     * @return {null} We do not want to render anything.
     */

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Steps;
}(_react.Component);

exports["default"] = Steps;

_defineProperty(Steps, "propTypes", {
  enabled: _propTypes["default"].bool,
  initialStep: _propTypes["default"].number.isRequired,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    element: _propTypes["default"].oneOfType([_propTypes["default"].string,
    /* istanbul ignore next */
    typeof Element === 'undefined' ? _propTypes["default"].any : _propTypes["default"].instanceOf(Element)]),
    intro: _propTypes["default"].node.isRequired,
    position: introJsPropTypes.tooltipPosition,
    tooltipClass: _propTypes["default"].string,
    highlightClass: _propTypes["default"].string
  })).isRequired,
  onStart: _propTypes["default"].func,
  onExit: _propTypes["default"].func.isRequired,
  onBeforeExit: _propTypes["default"].func,
  onBeforeChange: _propTypes["default"].func,
  onAfterChange: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onPreventChange: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  options: introJsPropTypes.options
});

_defineProperty(Steps, "defaultProps", {
  enabled: false,
  onStart: null,
  onBeforeExit: null,
  onBeforeChange: null,
  onAfterChange: null,
  onChange: null,
  onPreventChange: null,
  onComplete: null,
  options: introJsDefaultProps.options
});

/***/ }),

/***/ 89916:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.options = void 0;

/**
 * Intro.js options default proptypes.
 * @type {Object}
 */
var options = {
  hidePrev: true,
  hideNext: true
};
exports.options = options;

/***/ }),

/***/ 96115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.options = exports.hintPosition = exports.tooltipPosition = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Intro.js tooltip position proptype.
 * @type {Function}
 */
var tooltipPosition = _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left', 'bottom-left-aligned', 'bottom-middle-aligned', 'bottom-right-aligned', 'top-left-aligned', 'top-middle-aligned', 'top-right-aligned', 'auto']);
/**
 * Intro.js hint position proptype.
 * @type {Function}
 */


exports.tooltipPosition = tooltipPosition;

var hintPosition = _propTypes["default"].oneOf(['top-middle', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'bottom-middle', 'middle-left', 'middle-right', 'middle-middle']);

exports.hintPosition = hintPosition;

var options = _propTypes["default"].shape({
  nextLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].string,
  skipLabel: _propTypes["default"].string,
  doneLabel: _propTypes["default"].string,
  hidePrev: _propTypes["default"].bool,
  hideNext: _propTypes["default"].bool,
  tooltipPosition: tooltipPosition,
  tooltipClass: _propTypes["default"].string,
  highlightClass: _propTypes["default"].string,
  exitOnEsc: _propTypes["default"].bool,
  exitOnOverlayClick: _propTypes["default"].bool,
  showStepNumbers: _propTypes["default"].bool,
  keyboardNavigation: _propTypes["default"].bool,
  showButtons: _propTypes["default"].bool,
  showBullets: _propTypes["default"].bool,
  showProgress: _propTypes["default"].bool,
  scrollToElement: _propTypes["default"].bool,
  overlayOpacity: _propTypes["default"].number,
  scrollPadding: _propTypes["default"].number,
  positionPrecedence: _propTypes["default"].arrayOf(_propTypes["default"].string),
  disableInteraction: _propTypes["default"].bool,
  hintPosition: hintPosition,
  hintButtonLabel: _propTypes["default"].string,
  hintAnimation: _propTypes["default"].bool
});

exports.options = options;

/***/ }),

/***/ 6166:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isServer = isServer;

function isServer() {
  return typeof window === 'undefined';
}

/***/ }),

/***/ 87762:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "Rg", ({
  enumerable: true,
  get: function get() {
    return _Steps["default"];
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Hints["default"];
  }
});

var _Steps = _interopRequireDefault(__webpack_require__(38536));

var _Hints = _interopRequireDefault(__webpack_require__(43390));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 61378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Ii; }
/* harmony export */ });
/*!
 * Intro.js v6.0.0
 * https://introjs.com
 *
 * Copyright (C) 2012-2022 Afshin Mehrabani (@afshinmeh).
 * https://introjs.com
 *
 * Date: Sun, 10 Jul 2022 10:05:59 GMT
 */
function t(){
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
t=function(){return e};var e={},n=Object.prototype,r=n.hasOwnProperty,i="function"==typeof Symbol?Symbol:{},o=i.iterator||"@@iterator",a=i.asyncIterator||"@@asyncIterator",s=i.toStringTag||"@@toStringTag";function c(t,e,n){return Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{c({},"")}catch(t){c=function(t,e,n){return t[e]=n}}function l(t,e,n,r){var i=e&&e.prototype instanceof p?e:p,o=Object.create(i.prototype),a=new S(r||[]);return o._invoke=function(t,e,n){var r="suspendedStart";return function(i,o){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===i)throw o;return C()}for(n.method=i,n.arg=o;;){var a=n.delegate;if(a){var s=x(a,n);if(s){if(s===h)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var c=u(t,e,n);if("normal"===c.type){if(r=n.done?"completed":"suspendedYield",c.arg===h)continue;return{value:c.arg,done:n.done}}"throw"===c.type&&(r="completed",n.method="throw",n.arg=c.arg)}}}(t,n,a),o}function u(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}e.wrap=l;var h={};function p(){}function f(){}function d(){}var b={};c(b,o,(function(){return this}));var m=Object.getPrototypeOf,v=m&&m(m(j([])));v&&v!==n&&r.call(v,o)&&(b=v);var g=d.prototype=p.prototype=Object.create(b);function y(t){["next","throw","return"].forEach((function(e){c(t,e,(function(t){return this._invoke(e,t)}))}))}function w(t,e){function n(i,o,a,s){var c=u(t[i],t,o);if("throw"!==c.type){var l=c.arg,h=l.value;return h&&"object"==typeof h&&r.call(h,"__await")?e.resolve(h.__await).then((function(t){n("next",t,a,s)}),(function(t){n("throw",t,a,s)})):e.resolve(h).then((function(t){l.value=t,a(l)}),(function(t){return n("throw",t,a,s)}))}s(c.arg)}var i;this._invoke=function(t,r){function o(){return new e((function(e,i){n(t,r,e,i)}))}return i=i?i.then(o,o):o()}}function x(t,e){var n=t.iterator[e.method];if(void 0===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=void 0,x(t,e),"throw"===e.method))return h;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return h}var r=u(n,t.iterator,e.arg);if("throw"===r.type)return e.method="throw",e.arg=r.arg,e.delegate=null,h;var i=r.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=void 0),e.delegate=null,h):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,h)}function _(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function k(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function S(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(_,this),this.reset(!0)}function j(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,i=function e(){for(;++n<t.length;)if(r.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=void 0,e.done=!0,e};return i.next=i}}return{next:C}}function C(){return{value:void 0,done:!0}}return f.prototype=d,c(g,"constructor",d),c(d,"constructor",f),f.displayName=c(d,s,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===f||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,d):(t.__proto__=d,c(t,s,"GeneratorFunction")),t.prototype=Object.create(g),t},e.awrap=function(t){return{__await:t}},y(w.prototype),c(w.prototype,a,(function(){return this})),e.AsyncIterator=w,e.async=function(t,n,r,i,o){void 0===o&&(o=Promise);var a=new w(l(t,n,r,i),o);return e.isGeneratorFunction(n)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},y(g),c(g,s,"Generator"),c(g,o,(function(){return this})),c(g,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},e.values=j,S.prototype={constructor:S,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(k),!t)for(var e in this)"t"===e.charAt(0)&&r.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=void 0)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function n(n,r){return a.type="throw",a.arg=t,e.next=n,r&&(e.method="next",e.arg=void 0),!!r}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],a=o.completion;if("root"===o.tryLoc)return n("end");if(o.tryLoc<=this.prev){var s=r.call(o,"catchLoc"),c=r.call(o,"finallyLoc");if(s&&c){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);if(this.prev<o.finallyLoc)return n(o.finallyLoc)}else if(s){if(this.prev<o.catchLoc)return n(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return n(o.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var i=this.tryEntries[n];if(i.tryLoc<=this.prev&&r.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=t,a.arg=e,o?(this.method="next",this.next=o.finallyLoc,h):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),h},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),k(n),h}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;k(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:j(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=void 0),h}},e}function e(t){return e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e(t)}function n(t,e,n,r,i,o,a){try{var s=t[o](a),c=s.value}catch(t){return void n(t)}s.done?e(c):Promise.resolve(c).then(r,i)}function r(t){return function(){var e=this,r=arguments;return new Promise((function(i,o){var a=t.apply(e,r);function s(t){n(a,i,o,s,c,"next",t)}function c(t){n(a,i,o,s,c,"throw",t)}s(void 0)}))}}function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function o(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var r,i,o=[],a=!0,s=!1;try{for(n=n.call(t);!(a=(r=n.next()).done)&&(o.push(r.value),!e||o.length!==e);a=!0);}catch(t){s=!0,i=t}finally{try{a||null==n.return||n.return()}finally{if(s)throw i}}return o}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return a(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return a(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}var s=function(){var t={};return function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"introjs-stamp";return t[n]=t[n]||0,void 0===e[n]&&(e[n]=t[n]++),e[n]}}();function c(t,e,n){if(t)for(var r=0,i=t.length;r<i;r++)e(t[r],r);"function"==typeof n&&n()}var l=new function(){var t="introjs_event";this._id=function(t,e,n,r){return e+s(n)+(r?"_".concat(s(r)):"")},this.on=function(e,n,r,i,o){var a=this._id.apply(this,arguments),s=function(t){return r.call(i||e,t||window.event)};"addEventListener"in e?e.addEventListener(n,s,o):"attachEvent"in e&&e.attachEvent("on".concat(n),s),e[t]=e[t]||{},e[t][a]=s},this.off=function(e,n,r,i,o){var a=this._id.apply(this,arguments),s=e[t]&&e[t][a];s&&("removeEventListener"in e?e.removeEventListener(n,s,o):"detachEvent"in e&&e.detachEvent("on".concat(n),s),e[t][a]=null)}};function u(t,e){if(t instanceof SVGElement){var n=t.getAttribute("class")||"";n.match(e)||t.setAttribute("class","".concat(n," ").concat(e))}else{if(void 0!==t.classList)c(e.split(" "),(function(e){t.classList.add(e)}));else t.className.match(e)||(t.className+=" ".concat(e))}}function h(t,e){var n="";return t.currentStyle?n=t.currentStyle[e]:document.defaultView&&document.defaultView.getComputedStyle&&(n=document.defaultView.getComputedStyle(t,null).getPropertyValue(e)),n&&n.toLowerCase?n.toLowerCase():n}function p(t){var e=t.element;u(e,"introjs-showElement");var n=h(e,"position");"absolute"!==n&&"relative"!==n&&"sticky"!==n&&"fixed"!==n&&u(e,"introjs-relativePosition")}function f(t){var e=t.element;if(this._options.scrollToElement){var n=function(t){var e=window.getComputedStyle(t),n="absolute"===e.position,r=/(auto|scroll)/;if("fixed"===e.position)return document.body;for(var i=t;i=i.parentElement;)if(e=window.getComputedStyle(i),(!n||"static"!==e.position)&&r.test(e.overflow+e.overflowY+e.overflowX))return i;return document.body}(e);n!==document.body&&(n.scrollTop=e.offsetTop-n.offsetTop)}}function d(){if(void 0!==window.innerWidth)return{width:window.innerWidth,height:window.innerHeight};var t=document.documentElement;return{width:t.clientWidth,height:t.clientHeight}}function b(t,e,n){var r,i=e.element;if("off"!==t&&(this._options.scrollToElement&&(r="tooltip"===t?n.getBoundingClientRect():i.getBoundingClientRect(),!function(t){var e=t.getBoundingClientRect();return e.top>=0&&e.left>=0&&e.bottom+80<=window.innerHeight&&e.right<=window.innerWidth}(i)))){var o=d().height;r.bottom-(r.bottom-r.top)<0||i.clientHeight>o?window.scrollBy(0,r.top-(o/2-r.height/2)-this._options.scrollPadding):window.scrollBy(0,r.top-(o/2-r.height/2)+this._options.scrollPadding)}}function m(t){t.setAttribute("role","button"),t.tabIndex=0}function v(t){var e=t.parentNode;return!(!e||"HTML"===e.nodeName)&&("fixed"===h(t,"position")||v(e))}function g(t,e){var n=document.body,r=document.documentElement,i=window.pageYOffset||r.scrollTop||n.scrollTop,o=window.pageXOffset||r.scrollLeft||n.scrollLeft;e=e||n;var a=t.getBoundingClientRect(),s=e.getBoundingClientRect(),c=h(e,"position"),l={width:a.width,height:a.height};return"body"!==e.tagName.toLowerCase()&&"relative"===c||"sticky"===c?Object.assign(l,{top:a.top-s.top,left:a.left-s.left}):v(t)?Object.assign(l,{top:a.top,left:a.left}):Object.assign(l,{top:a.top+i,left:a.left+o})}var y=function(t){try{return!!t()}catch(t){return!0}},w=!y((function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype")})),x=Function.prototype,_=x.apply,k=x.call,S="object"==typeof Reflect&&Reflect.apply||(w?k.bind(_):function(){return k.apply(_,arguments)}),j=Function.prototype.call,C=w?j.bind(j):function(){return j.apply(j,arguments)},A=Function.prototype,E=A.bind,N=A.call,I=w&&E.bind(N,N),L=w?function(t){return t&&I(t)}:function(t){return t&&function(){return N.apply(t,arguments)}},O="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function T(t,e){return t(e={exports:{}},e.exports),e.exports}var P,R,q=function(t){return t&&t.Math==Math&&t},B=q("object"==typeof globalThis&&globalThis)||q("object"==typeof window&&window)||q("object"==typeof self&&self)||q("object"==typeof O&&O)||function(){return this}()||Function("return this")(),M=!y((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),H={}.propertyIsEnumerable,F=Object.getOwnPropertyDescriptor,D={f:F&&!H.call({1:2},1)?function(t){var e=F(this,t);return!!e&&e.enumerable}:H},$=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},z=L({}.toString),G=L("".slice),W=function(t){return G(z(t),8,-1)},V=Object,U=L("".split),Y=y((function(){return!V("z").propertyIsEnumerable(0)}))?function(t){return"String"==W(t)?U(t,""):V(t)}:V,K=TypeError,X=function(t){if(null==t)throw K("Can't call method on "+t);return t},Q=function(t){return Y(X(t))},Z=function(t){return"function"==typeof t},J=function(t){return"object"==typeof t?null!==t:Z(t)},tt=function(t){return Z(t)?t:void 0},et=function(t,e){return arguments.length<2?tt(B[t]):B[t]&&B[t][e]},nt=L({}.isPrototypeOf),rt=et("navigator","userAgent")||"",it=B.process,ot=B.Deno,at=it&&it.versions||ot&&ot.version,st=at&&at.v8;st&&(R=(P=st.split("."))[0]>0&&P[0]<4?1:+(P[0]+P[1])),!R&&rt&&(!(P=rt.match(/Edge\/(\d+)/))||P[1]>=74)&&(P=rt.match(/Chrome\/(\d+)/))&&(R=+P[1]);var ct=R,lt=!!Object.getOwnPropertySymbols&&!y((function(){var t=Symbol();return!String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&ct&&ct<41})),ut=lt&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,ht=Object,pt=ut?function(t){return"symbol"==typeof t}:function(t){var e=et("Symbol");return Z(e)&&nt(e.prototype,ht(t))},ft=String,dt=TypeError,bt=function(t){if(Z(t))return t;throw dt(function(t){try{return ft(t)}catch(t){return"Object"}}(t)+" is not a function")},mt=function(t,e){var n=t[e];return null==n?void 0:bt(n)},vt=TypeError,gt=Object.defineProperty,yt=function(t,e){try{gt(B,t,{value:e,configurable:!0,writable:!0})}catch(n){B[t]=e}return e},wt=B["__core-js_shared__"]||yt("__core-js_shared__",{}),xt=T((function(t){(t.exports=function(t,e){return wt[t]||(wt[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.23.3",mode:"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",source:"https://github.com/zloirock/core-js"})})),_t=Object,kt=function(t){return _t(X(t))},St=L({}.hasOwnProperty),jt=Object.hasOwn||function(t,e){return St(kt(t),e)},Ct=0,At=Math.random(),Et=L(1..toString),Nt=function(t){return"Symbol("+(void 0===t?"":t)+")_"+Et(++Ct+At,36)},It=xt("wks"),Lt=B.Symbol,Ot=Lt&&Lt.for,Tt=ut?Lt:Lt&&Lt.withoutSetter||Nt,Pt=function(t){if(!jt(It,t)||!lt&&"string"!=typeof It[t]){var e="Symbol."+t;lt&&jt(Lt,t)?It[t]=Lt[t]:It[t]=ut&&Ot?Ot(e):Tt(e)}return It[t]},Rt=TypeError,qt=Pt("toPrimitive"),Bt=function(t,e){if(!J(t)||pt(t))return t;var n,r=mt(t,qt);if(r){if(void 0===e&&(e="default"),n=C(r,t,e),!J(n)||pt(n))return n;throw Rt("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,r;if("string"===e&&Z(n=t.toString)&&!J(r=C(n,t)))return r;if(Z(n=t.valueOf)&&!J(r=C(n,t)))return r;if("string"!==e&&Z(n=t.toString)&&!J(r=C(n,t)))return r;throw vt("Can't convert object to primitive value")}(t,e)},Mt=function(t){var e=Bt(t,"string");return pt(e)?e:e+""},Ht=B.document,Ft=J(Ht)&&J(Ht.createElement),Dt=function(t){return Ft?Ht.createElement(t):{}},$t=!M&&!y((function(){return 7!=Object.defineProperty(Dt("div"),"a",{get:function(){return 7}}).a})),zt=Object.getOwnPropertyDescriptor,Gt={f:M?zt:function(t,e){if(t=Q(t),e=Mt(e),$t)try{return zt(t,e)}catch(t){}if(jt(t,e))return $(!C(D.f,t,e),t[e])}},Wt=M&&y((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype})),Vt=String,Ut=TypeError,Yt=function(t){if(J(t))return t;throw Ut(Vt(t)+" is not an object")},Kt=TypeError,Xt=Object.defineProperty,Qt=Object.getOwnPropertyDescriptor,Zt={f:M?Wt?function(t,e,n){if(Yt(t),e=Mt(e),Yt(n),"function"==typeof t&&"prototype"===e&&"value"in n&&"writable"in n&&!n.writable){var r=Qt(t,e);r&&r.writable&&(t[e]=n.value,n={configurable:"configurable"in n?n.configurable:r.configurable,enumerable:"enumerable"in n?n.enumerable:r.enumerable,writable:!1})}return Xt(t,e,n)}:Xt:function(t,e,n){if(Yt(t),e=Mt(e),Yt(n),$t)try{return Xt(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Kt("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},Jt=M?function(t,e,n){return Zt.f(t,e,$(1,n))}:function(t,e,n){return t[e]=n,t},te=Function.prototype,ee=M&&Object.getOwnPropertyDescriptor,ne=jt(te,"name"),re={EXISTS:ne,PROPER:ne&&"something"===function(){}.name,CONFIGURABLE:ne&&(!M||M&&ee(te,"name").configurable)},ie=L(Function.toString);Z(wt.inspectSource)||(wt.inspectSource=function(t){return ie(t)});var oe,ae,se,ce=wt.inspectSource,le=B.WeakMap,ue=Z(le)&&/native code/.test(ce(le)),he=xt("keys"),pe=function(t){return he[t]||(he[t]=Nt(t))},fe={},de=B.TypeError,be=B.WeakMap;if(ue||wt.state){var me=wt.state||(wt.state=new be),ve=L(me.get),ge=L(me.has),ye=L(me.set);oe=function(t,e){if(ge(me,t))throw new de("Object already initialized");return e.facade=t,ye(me,t,e),e},ae=function(t){return ve(me,t)||{}},se=function(t){return ge(me,t)}}else{var we=pe("state");fe[we]=!0,oe=function(t,e){if(jt(t,we))throw new de("Object already initialized");return e.facade=t,Jt(t,we,e),e},ae=function(t){return jt(t,we)?t[we]:{}},se=function(t){return jt(t,we)}}var xe={set:oe,get:ae,has:se,enforce:function(t){return se(t)?ae(t):oe(t,{})},getterFor:function(t){return function(e){var n;if(!J(e)||(n=ae(e)).type!==t)throw de("Incompatible receiver, "+t+" required");return n}}},_e=T((function(t){var e=re.CONFIGURABLE,n=xe.enforce,r=xe.get,i=Object.defineProperty,o=M&&!y((function(){return 8!==i((function(){}),"length",{value:8}).length})),a=String(String).split("String"),s=t.exports=function(t,r,s){"Symbol("===String(r).slice(0,7)&&(r="["+String(r).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),s&&s.getter&&(r="get "+r),s&&s.setter&&(r="set "+r),(!jt(t,"name")||e&&t.name!==r)&&(M?i(t,"name",{value:r,configurable:!0}):t.name=r),o&&s&&jt(s,"arity")&&t.length!==s.arity&&i(t,"length",{value:s.arity});try{s&&jt(s,"constructor")&&s.constructor?M&&i(t,"prototype",{writable:!1}):t.prototype&&(t.prototype=void 0)}catch(t){}var c=n(t);return jt(c,"source")||(c.source=a.join("string"==typeof r?r:"")),t};Function.prototype.toString=s((function(){return Z(this)&&r(this).source||ce(this)}),"toString")})),ke=function(t,e,n,r){r||(r={});var i=r.enumerable,o=void 0!==r.name?r.name:e;if(Z(n)&&_e(n,o,r),r.global)i?t[e]=n:yt(e,n);else{try{r.unsafe?t[e]&&(i=!0):delete t[e]}catch(t){}i?t[e]=n:Zt.f(t,e,{value:n,enumerable:!1,configurable:!r.nonConfigurable,writable:!r.nonWritable})}return t},Se=Math.ceil,je=Math.floor,Ce=Math.trunc||function(t){var e=+t;return(e>0?je:Se)(e)},Ae=function(t){var e=+t;return e!=e||0===e?0:Ce(e)},Ee=Math.max,Ne=Math.min,Ie=Math.min,Le=function(t){return t>0?Ie(Ae(t),9007199254740991):0},Oe=function(t){return function(e,n,r){var i,o=Q(e),a=Le(o.length),s=function(t,e){var n=Ae(t);return n<0?Ee(n+e,0):Ne(n,e)}(r,a);if(t&&n!=n){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((t||s in o)&&o[s]===n)return t||s||0;return!t&&-1}},Te={includes:Oe(!0),indexOf:Oe(!1)},Pe=Te.indexOf,Re=L([].push),qe=function(t,e){var n,r=Q(t),i=0,o=[];for(n in r)!jt(fe,n)&&jt(r,n)&&Re(o,n);for(;e.length>i;)jt(r,n=e[i++])&&(~Pe(o,n)||Re(o,n));return o},Be=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Me=Be.concat("length","prototype"),He={f:Object.getOwnPropertyNames||function(t){return qe(t,Me)}},Fe={f:Object.getOwnPropertySymbols},De=L([].concat),$e=et("Reflect","ownKeys")||function(t){var e=He.f(Yt(t)),n=Fe.f;return n?De(e,n(t)):e},ze=function(t,e,n){for(var r=$e(e),i=Zt.f,o=Gt.f,a=0;a<r.length;a++){var s=r[a];jt(t,s)||n&&jt(n,s)||i(t,s,o(e,s))}},Ge=/#|\.prototype\./,We=function(t,e){var n=Ue[Ve(t)];return n==Ke||n!=Ye&&(Z(e)?y(e):!!e)},Ve=We.normalize=function(t){return String(t).replace(Ge,".").toLowerCase()},Ue=We.data={},Ye=We.NATIVE="N",Ke=We.POLYFILL="P",Xe=We,Qe=Gt.f,Ze=function(t,e){var n,r,i,o,a,s=t.target,c=t.global,l=t.stat;if(n=c?B:l?B[s]||yt(s,{}):(B[s]||{}).prototype)for(r in e){if(o=e[r],i=t.dontCallGetSet?(a=Qe(n,r))&&a.value:n[r],!Xe(c?r:s+(l?".":"#")+r,t.forced)&&void 0!==i){if(typeof o==typeof i)continue;ze(o,i)}(t.sham||i&&i.sham)&&Jt(o,"sham",!0),ke(n,r,o,t)}},Je={};Je[Pt("toStringTag")]="z";var tn,en="[object z]"===String(Je),nn=Pt("toStringTag"),rn=Object,on="Arguments"==W(function(){return arguments}()),an=en?W:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=rn(t),nn))?n:on?W(e):"Object"==(r=W(e))&&Z(e.callee)?"Arguments":r},sn=String,cn=function(t){if("Symbol"===an(t))throw TypeError("Cannot convert a Symbol value to a string");return sn(t)},ln=function(){var t=Yt(this),e="";return t.hasIndices&&(e+="d"),t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.unicodeSets&&(e+="v"),t.sticky&&(e+="y"),e},un=B.RegExp,hn=y((function(){var t=un("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),pn=hn||y((function(){return!un("a","y").sticky})),fn={BROKEN_CARET:hn||y((function(){var t=un("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:pn,UNSUPPORTED_Y:hn},dn=Object.keys||function(t){return qe(t,Be)},bn=M&&!Wt?Object.defineProperties:function(t,e){Yt(t);for(var n,r=Q(e),i=dn(e),o=i.length,a=0;o>a;)Zt.f(t,n=i[a++],r[n]);return t},mn={f:bn},vn=et("document","documentElement"),gn=pe("IE_PROTO"),yn=function(){},wn=function(t){return"<script>"+t+"<\/script>"},xn=function(t){t.write(wn("")),t.close();var e=t.parentWindow.Object;return t=null,e},_n=function(){try{tn=new ActiveXObject("htmlfile")}catch(t){}var t,e;_n="undefined"!=typeof document?document.domain&&tn?xn(tn):((e=Dt("iframe")).style.display="none",vn.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(wn("document.F=Object")),t.close(),t.F):xn(tn);for(var n=Be.length;n--;)delete _n.prototype[Be[n]];return _n()};fe[gn]=!0;var kn,Sn,jn=Object.create||function(t,e){var n;return null!==t?(yn.prototype=Yt(t),n=new yn,yn.prototype=null,n[gn]=t):n=_n(),void 0===e?n:mn.f(n,e)},Cn=B.RegExp,An=y((function(){var t=Cn(".","s");return!(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),En=B.RegExp,Nn=y((function(){var t=En("(?<a>b)","g");return"b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),In=xe.get,Ln=xt("native-string-replace",String.prototype.replace),On=RegExp.prototype.exec,Tn=On,Pn=L("".charAt),Rn=L("".indexOf),qn=L("".replace),Bn=L("".slice),Mn=(Sn=/b*/g,C(On,kn=/a/,"a"),C(On,Sn,"a"),0!==kn.lastIndex||0!==Sn.lastIndex),Hn=fn.BROKEN_CARET,Fn=void 0!==/()??/.exec("")[1];(Mn||Fn||Hn||An||Nn)&&(Tn=function(t){var e,n,r,i,o,a,s,c=this,l=In(c),u=cn(t),h=l.raw;if(h)return h.lastIndex=c.lastIndex,e=C(Tn,h,u),c.lastIndex=h.lastIndex,e;var p=l.groups,f=Hn&&c.sticky,d=C(ln,c),b=c.source,m=0,v=u;if(f&&(d=qn(d,"y",""),-1===Rn(d,"g")&&(d+="g"),v=Bn(u,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==Pn(u,c.lastIndex-1))&&(b="(?: "+b+")",v=" "+v,m++),n=new RegExp("^(?:"+b+")",d)),Fn&&(n=new RegExp("^"+b+"$(?!\\s)",d)),Mn&&(r=c.lastIndex),i=C(On,f?n:c,v),f?i?(i.input=Bn(i.input,m),i[0]=Bn(i[0],m),i.index=c.lastIndex,c.lastIndex+=i[0].length):c.lastIndex=0:Mn&&i&&(c.lastIndex=c.global?i.index+i[0].length:r),Fn&&i&&i.length>1&&C(Ln,i[0],n,(function(){for(o=1;o<arguments.length-2;o++)void 0===arguments[o]&&(i[o]=void 0)})),i&&p)for(i.groups=a=jn(null),o=0;o<p.length;o++)a[(s=p[o])[0]]=i[s[1]];return i});var Dn=Tn;Ze({target:"RegExp",proto:!0,forced:/./.exec!==Dn},{exec:Dn});var $n=Pt("species"),zn=RegExp.prototype,Gn=L("".charAt),Wn=L("".charCodeAt),Vn=L("".slice),Un=function(t){return function(e,n){var r,i,o=cn(X(e)),a=Ae(n),s=o.length;return a<0||a>=s?t?"":void 0:(r=Wn(o,a))<55296||r>56319||a+1===s||(i=Wn(o,a+1))<56320||i>57343?t?Gn(o,a):r:t?Vn(o,a,a+2):i-56320+(r-55296<<10)+65536}},Yn={codeAt:Un(!1),charAt:Un(!0)}.charAt,Kn=function(t,e,n){return e+(n?Yn(t,e).length:1)},Xn=Math.floor,Qn=L("".charAt),Zn=L("".replace),Jn=L("".slice),tr=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,er=/\$([$&'`]|\d{1,2})/g,nr=function(t,e,n,r,i,o){var a=n+t.length,s=r.length,c=er;return void 0!==i&&(i=kt(i),c=tr),Zn(o,c,(function(o,c){var l;switch(Qn(c,0)){case"$":return"$";case"&":return t;case"`":return Jn(e,0,n);case"'":return Jn(e,a);case"<":l=i[Jn(c,1,-1)];break;default:var u=+c;if(0===u)return o;if(u>s){var h=Xn(u/10);return 0===h?o:h<=s?void 0===r[h-1]?Qn(c,1):r[h-1]+Qn(c,1):o}l=r[u-1]}return void 0===l?"":l}))},rr=TypeError,ir=function(t,e){var n=t.exec;if(Z(n)){var r=C(n,t,e);return null!==r&&Yt(r),r}if("RegExp"===W(t))return C(Dn,t,e);throw rr("RegExp#exec called on incompatible receiver")},or=Pt("replace"),ar=Math.max,sr=Math.min,cr=L([].concat),lr=L([].push),ur=L("".indexOf),hr=L("".slice),pr="$0"==="a".replace(/./,"$0"),fr=!!/./[or]&&""===/./[or]("a","$0");function dr(t,e){if(t instanceof SVGElement){var n=t.getAttribute("class")||"";t.setAttribute("class",n.replace(e,"").replace(/^\s+|\s+$/g,""))}else t.className=t.className.replace(e,"").replace(/^\s+|\s+$/g,"")}function br(t,e){var n="";if(t.style.cssText&&(n+=t.style.cssText),"string"==typeof e)n+=e;else for(var r in e)n+="".concat(r,":").concat(e[r],";");t.style.cssText=n}function mr(t){if(t){if(!this._introItems[this._currentStep])return;var e=this._introItems[this._currentStep],n=g(e.element,this._targetElement),r=this._options.helperElementPadding;v(e.element)?u(t,"introjs-fixedTooltip"):dr(t,"introjs-fixedTooltip"),"floating"===e.position&&(r=0),br(t,{width:"".concat(n.width+r,"px"),height:"".concat(n.height+r,"px"),top:"".concat(n.top-r/2,"px"),left:"".concat(n.left-r/2,"px")})}}!function(t,e,n,r){var i=Pt(t),o=!y((function(){var e={};return e[i]=function(){return 7},7!=""[t](e)})),a=o&&!y((function(){var e=!1,n=/a/;return"split"===t&&((n={}).constructor={},n.constructor[$n]=function(){return n},n.flags="",n[i]=/./[i]),n.exec=function(){return e=!0,null},n[i](""),!e}));if(!o||!a||n){var s=L(/./[i]),c=e(i,""[t],(function(t,e,n,r,i){var a=L(t),c=e.exec;return c===Dn||c===zn.exec?o&&!i?{done:!0,value:s(e,n,r)}:{done:!0,value:a(n,e,r)}:{done:!1}}));ke(String.prototype,t,c[0]),ke(zn,i,c[1])}r&&Jt(zn[i],"sham",!0)}("replace",(function(t,e,n){var r=fr?"$":"$0";return[function(t,n){var r=X(this),i=null==t?void 0:mt(t,or);return i?C(i,t,r,n):C(e,cn(r),t,n)},function(t,i){var o=Yt(this),a=cn(t);if("string"==typeof i&&-1===ur(i,r)&&-1===ur(i,"$<")){var s=n(e,o,a,i);if(s.done)return s.value}var c=Z(i);c||(i=cn(i));var l=o.global;if(l){var u=o.unicode;o.lastIndex=0}for(var h=[];;){var p=ir(o,a);if(null===p)break;if(lr(h,p),!l)break;""===cn(p[0])&&(o.lastIndex=Kn(a,Le(o.lastIndex),u))}for(var f,d="",b=0,m=0;m<h.length;m++){for(var v=cn((p=h[m])[0]),g=ar(sr(Ae(p.index),a.length),0),y=[],w=1;w<p.length;w++)lr(y,void 0===(f=p[w])?f:String(f));var x=p.groups;if(c){var _=cr([v],y,g,a);void 0!==x&&lr(_,x);var k=cn(S(i,void 0,_))}else k=nr(v,a,g,y,x,i);g>=b&&(d+=hr(a,b,g)+k,b=g+v.length)}return d+hr(a,b)}]}),!!y((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!pr||fr);var vr=Zt.f,gr=Pt("unscopables"),yr=Array.prototype;null==yr[gr]&&vr(yr,gr,{configurable:!0,value:jn(null)});var wr,xr=Te.includes;function _r(t,e,n,r,i){return t.left+e+n.width>r.width?(i.style.left="".concat(r.width-n.width-t.left,"px"),!1):(i.style.left="".concat(e,"px"),!0)}function kr(t,e,n,r){return t.left+t.width-e-n.width<0?(r.style.left="".concat(-t.left,"px"),!1):(r.style.right="".concat(e,"px"),!0)}function Sr(t,e){t.includes(e)&&t.splice(t.indexOf(e),1)}function jr(t,e,n){var r=this._options.positionPrecedence.slice(),i=d(),o=g(e).height+10,a=g(e).width+20,s=t.getBoundingClientRect(),c="floating";s.bottom+o>i.height&&Sr(r,"bottom"),s.top-o<0&&Sr(r,"top"),s.right+a>i.width&&Sr(r,"right"),s.left-a<0&&Sr(r,"left");var l,u,h=-1!==(u=(l=n||"").indexOf("-"))?l.substr(u):"";return n&&(n=n.split("-")[0]),r.length&&(c=r.includes(n)?n:r[0]),["top","bottom"].includes(c)&&(c+=function(t,e,n,r){var i=n.width,o=e/2,a=Math.min(i,window.screen.width),s=["-left-aligned","-middle-aligned","-right-aligned"];return a-t<e&&Sr(s,"-left-aligned"),(t<o||a-t<o)&&Sr(s,"-middle-aligned"),t<e&&Sr(s,"-right-aligned"),s.length?s.includes(r)?r:s[0]:"-middle-aligned"}(s.left,a,i,h)),c}function Cr(t,e,n,r){var i,o,a,s,c,l="";if(r=r||!1,e.style.top=null,e.style.right=null,e.style.bottom=null,e.style.left=null,e.style.marginLeft=null,e.style.marginTop=null,n.style.display="inherit",this._introItems[this._currentStep]){l="string"==typeof(i=this._introItems[this._currentStep]).tooltipClass?i.tooltipClass:this._options.tooltipClass,e.className=["introjs-tooltip",l].filter(Boolean).join(" "),e.setAttribute("role","dialog"),"floating"!==(c=this._introItems[this._currentStep].position)&&this._options.autoPosition&&(c=jr.call(this,t,e,c)),a=g(t),o=g(e),s=d(),u(e,"introjs-".concat(c));var h=a.width/2-o.width/2;switch(c){case"top-right-aligned":n.className="introjs-arrow bottom-right";var p=0;kr(a,p,o,e),e.style.bottom="".concat(a.height+20,"px");break;case"top-middle-aligned":n.className="introjs-arrow bottom-middle",r&&(h+=5),kr(a,h,o,e)&&(e.style.right=null,_r(a,h,o,s,e)),e.style.bottom="".concat(a.height+20,"px");break;case"top-left-aligned":case"top":n.className="introjs-arrow bottom",_r(a,r?0:15,o,s,e),e.style.bottom="".concat(a.height+20,"px");break;case"right":e.style.left="".concat(a.width+20,"px"),a.top+o.height>s.height?(n.className="introjs-arrow left-bottom",e.style.top="-".concat(o.height-a.height-20,"px")):n.className="introjs-arrow left";break;case"left":r||!0!==this._options.showStepNumbers||(e.style.top="15px"),a.top+o.height>s.height?(e.style.top="-".concat(o.height-a.height-20,"px"),n.className="introjs-arrow right-bottom"):n.className="introjs-arrow right",e.style.right="".concat(a.width+20,"px");break;case"floating":n.style.display="none",e.style.left="50%",e.style.top="50%",e.style.marginLeft="-".concat(o.width/2,"px"),e.style.marginTop="-".concat(o.height/2,"px");break;case"bottom-right-aligned":n.className="introjs-arrow top-right",kr(a,p=0,o,e),e.style.top="".concat(a.height+20,"px");break;case"bottom-middle-aligned":n.className="introjs-arrow top-middle",r&&(h+=5),kr(a,h,o,e)&&(e.style.right=null,_r(a,h,o,s,e)),e.style.top="".concat(a.height+20,"px");break;default:n.className="introjs-arrow top",_r(a,0,o,s,e),e.style.top="".concat(a.height+20,"px")}}}function Ar(){c(document.querySelectorAll(".introjs-showElement"),(function(t){dr(t,/introjs-[a-zA-Z]+/g)}))}function Er(t,e){var n=document.createElement(t);e=e||{};var r=/^(?:role|data-|aria-)/;for(var i in e){var o=e[i];"style"===i?br(n,o):i.match(r)?n.setAttribute(i,o):n[i]=o}return n}function Nr(t,e,n){if(n){var r=e.style.opacity||"1";br(e,{opacity:"0"}),window.setTimeout((function(){br(e,{opacity:r})}),10)}t.appendChild(e)}function Ir(){return parseInt(this._currentStep+1,10)/this._introItems.length*100}function Lr(){var t=document.querySelector(".introjs-disableInteraction");null===t&&(t=Er("div",{className:"introjs-disableInteraction"}),this._targetElement.appendChild(t)),mr.call(this,t)}function Or(t){var e=this,n=Er("div",{className:"introjs-bullets"});!1===this._options.showBullets&&(n.style.display="none");var r=Er("ul");r.setAttribute("role","tablist");var i=function(){e.goToStep(this.getAttribute("data-step-number"))};return c(this._introItems,(function(e,n){var o=e.step,a=Er("li"),s=Er("a");a.setAttribute("role","presentation"),s.setAttribute("role","tab"),s.onclick=i,n===t.step-1&&(s.className="active"),m(s),s.innerHTML="&nbsp;",s.setAttribute("data-step-number",o),a.appendChild(s),r.appendChild(a)})),n.appendChild(r),n}function Tr(t,e){if(this._options.showBullets){var n=document.querySelector(".introjs-bullets");n&&n.parentNode.replaceChild(Or.call(this,e),n)}}function Pr(t,e){this._options.showBullets&&(t.querySelector(".introjs-bullets li > a.active").className="",t.querySelector('.introjs-bullets li > a[data-step-number="'.concat(e.step,'"]')).className="active")}function Rr(){var t=Er("div");t.className="introjs-progress",!1===this._options.showProgress&&(t.style.display="none");var e=Er("div",{className:"introjs-progressbar"});return this._options.progressBarAdditionalClass&&(e.className+=" "+this._options.progressBarAdditionalClass),e.setAttribute("role","progress"),e.setAttribute("aria-valuemin",0),e.setAttribute("aria-valuemax",100),e.setAttribute("aria-valuenow",Ir.call(this)),e.style.cssText="width:".concat(Ir.call(this),"%;"),t.appendChild(e),t}function qr(t){t.querySelector(".introjs-progress .introjs-progressbar").style.cssText="width:".concat(Ir.call(this),"%;"),t.querySelector(".introjs-progress .introjs-progressbar").setAttribute("aria-valuenow",Ir.call(this))}function Br(t){return Mr.apply(this,arguments)}function Mr(){return(Mr=r(t().mark((function e(n){var i,o,a,s,c,l,h,d,v,g,y,w,x,_,k,S,j,C,A,E,N,I,L,O,T,P=this;return t().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(void 0===this._introChangeCallback){e.next=3;break}return e.next=3,this._introChangeCallback.call(this,n.element);case 3:if(i=this,o=document.querySelector(".introjs-helperLayer"),a=document.querySelector(".introjs-tooltipReferenceLayer"),s="introjs-helperLayer","string"==typeof n.highlightClass&&(s+=" ".concat(n.highlightClass)),"string"==typeof this._options.highlightClass&&(s+=" ".concat(this._options.highlightClass)),null!==o&&null!==a?(d=a.querySelector(".introjs-helperNumberLayer"),v=a.querySelector(".introjs-tooltiptext"),g=a.querySelector(".introjs-tooltip-title"),y=a.querySelector(".introjs-arrow"),w=a.querySelector(".introjs-tooltip"),h=a.querySelector(".introjs-skipbutton"),l=a.querySelector(".introjs-prevbutton"),c=a.querySelector(".introjs-nextbutton"),o.className=s,w.style.opacity=0,w.style.display="none",f.call(i,n),mr.call(i,o),mr.call(i,a),Ar(),i._lastShowElementTimer&&window.clearTimeout(i._lastShowElementTimer),i._lastShowElementTimer=window.setTimeout((function(){null!==d&&(d.innerHTML="".concat(n.step," ").concat(P._options.stepNumbersOfLabel," ").concat(P._introItems.length)),v.innerHTML=n.intro,g.innerHTML=n.title,w.style.display="block",Cr.call(i,n.element,w,y),Pr.call(i,a,n),qr.call(i,a),w.style.opacity=1,(null!=c&&/introjs-donebutton/gi.test(c.className)||null!=c)&&c.focus(),b.call(i,n.scrollTo,n,v)}),350)):(x=Er("div",{className:s}),_=Er("div",{className:"introjs-tooltipReferenceLayer"}),k=Er("div",{className:"introjs-arrow"}),S=Er("div",{className:"introjs-tooltip"}),j=Er("div",{className:"introjs-tooltiptext"}),C=Er("div",{className:"introjs-tooltip-header"}),A=Er("h1",{className:"introjs-tooltip-title"}),E=Er("div"),br(x,{"box-shadow":"0 0 1px 2px rgba(33, 33, 33, 0.8), rgba(33, 33, 33, ".concat(i._options.overlayOpacity.toString(),") 0 0 0 5000px")}),f.call(i,n),mr.call(i,x),mr.call(i,_),Nr(this._targetElement,x,!0),Nr(this._targetElement,_),j.innerHTML=n.intro,A.innerHTML=n.title,E.className="introjs-tooltipbuttons",!1===this._options.showButtons&&(E.style.display="none"),C.appendChild(A),S.appendChild(C),S.appendChild(j),this._options.dontShowAgain&&(N=Er("div",{className:"introjs-dontShowAgain"}),(I=Er("input",{type:"checkbox",id:"introjs-dontShowAgain",name:"introjs-dontShowAgain"})).onchange=function(t){P.setDontShowAgain(t.target.checked)},(L=Er("label",{htmlFor:"introjs-dontShowAgain"})).innerText=this._options.dontShowAgainLabel,N.appendChild(I),N.appendChild(L),S.appendChild(N)),S.appendChild(Or.call(this,n)),S.appendChild(Rr.call(this)),O=Er("div"),!0===this._options.showStepNumbers&&(O.className="introjs-helperNumberLayer",O.innerHTML="".concat(n.step," ").concat(this._options.stepNumbersOfLabel," ").concat(this._introItems.length),S.appendChild(O)),S.appendChild(k),_.appendChild(S),(c=Er("a")).onclick=r(t().mark((function e(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i._introItems.length-1===i._currentStep){t.next=5;break}return t.next=3,zr.call(i);case 3:t.next=11;break;case 5:if(!/introjs-donebutton/gi.test(c.className)){t.next=11;break}if("function"!=typeof i._introCompleteCallback){t.next=9;break}return t.next=9,i._introCompleteCallback.call(i,i._currentStep,"done");case 9:return t.next=11,wi.call(i,i._targetElement);case 11:case"end":return t.stop()}}),e)}))),m(c),c.innerHTML=this._options.nextLabel,(l=Er("a")).onclick=r(t().mark((function e(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(0===i._currentStep){t.next=3;break}return t.next=3,Wr.call(i);case 3:case"end":return t.stop()}}),e)}))),m(l),l.innerHTML=this._options.prevLabel,m(h=Er("a",{className:"introjs-skipbutton"})),h.innerHTML=this._options.skipLabel,h.onclick=r(t().mark((function e(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i._introItems.length-1!==i._currentStep||"function"!=typeof i._introCompleteCallback){t.next=3;break}return t.next=3,i._introCompleteCallback.call(i,i._currentStep,"skip");case 3:if("function"!=typeof i._introSkipCallback){t.next=6;break}return t.next=6,i._introSkipCallback.call(i);case 6:return t.next=8,wi.call(i,i._targetElement);case 8:case"end":return t.stop()}}),e)}))),C.appendChild(h),this._introItems.length>1&&E.appendChild(l),E.appendChild(c),S.appendChild(E),Cr.call(i,n.element,S,k),b.call(this,n.scrollTo,n,S)),(T=i._targetElement.querySelector(".introjs-disableInteraction"))&&T.parentNode.removeChild(T),n.disableInteraction&&Lr.call(i),0===this._currentStep&&this._introItems.length>1?(null!=c&&(c.className="".concat(this._options.buttonClass," introjs-nextbutton"),c.innerHTML=this._options.nextLabel),!0===this._options.hidePrev?(null!=l&&(l.className="".concat(this._options.buttonClass," introjs-prevbutton introjs-hidden")),null!=c&&u(c,"introjs-fullbutton")):null!=l&&(l.className="".concat(this._options.buttonClass," introjs-prevbutton introjs-disabled"))):this._introItems.length-1===this._currentStep||1===this._introItems.length?(null!=l&&(l.className="".concat(this._options.buttonClass," introjs-prevbutton")),!0===this._options.hideNext?(null!=c&&(c.className="".concat(this._options.buttonClass," introjs-nextbutton introjs-hidden")),null!=l&&u(l,"introjs-fullbutton")):null!=c&&(!0===this._options.nextToDone?(c.innerHTML=this._options.doneLabel,u(c,"".concat(this._options.buttonClass," introjs-nextbutton introjs-donebutton"))):c.className="".concat(this._options.buttonClass," introjs-nextbutton introjs-disabled"))):(null!=l&&(l.className="".concat(this._options.buttonClass," introjs-prevbutton")),null!=c&&(c.className="".concat(this._options.buttonClass," introjs-nextbutton"),c.innerHTML=this._options.nextLabel)),null!=l&&l.setAttribute("role","button"),null!=c&&c.setAttribute("role","button"),null!=h&&h.setAttribute("role","button"),null!=c&&c.focus(),p(n),void 0===this._introAfterChangeCallback){e.next=22;break}return e.next=22,this._introAfterChangeCallback.call(this,n.element);case 22:case"end":return e.stop()}}),e,this)})))).apply(this,arguments)}function Hr(t){return Fr.apply(this,arguments)}function Fr(){return(Fr=r(t().mark((function e(n){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._currentStep=n-2,void 0===this._introItems){t.next=4;break}return t.next=4,zr.call(this);case 4:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function Dr(t){return $r.apply(this,arguments)}function $r(){return($r=r(t().mark((function e(n){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._currentStepNumber=n,void 0===this._introItems){t.next=4;break}return t.next=4,zr.call(this);case 4:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function zr(){return Gr.apply(this,arguments)}function Gr(){return Gr=r(t().mark((function e(){var n,r,i=this;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._direction="forward",void 0!==this._currentStepNumber&&c(this._introItems,(function(t,e){t.step===i._currentStepNumber&&(i._currentStep=e-1,i._currentStepNumber=void 0)})),void 0===this._currentStep?this._currentStep=0:++this._currentStep,n=this._introItems[this._currentStep],r=!0,void 0===this._introBeforeChangeCallback){t.next=9;break}return t.next=8,this._introBeforeChangeCallback.call(this,n&&n.element);case 8:r=t.sent;case 9:if(!1!==r){t.next=12;break}return--this._currentStep,t.abrupt("return",!1);case 12:if(!(this._introItems.length<=this._currentStep)){t.next=19;break}if("function"!=typeof this._introCompleteCallback){t.next=16;break}return t.next=16,this._introCompleteCallback.call(this,this._currentStep,"end");case 16:return t.next=18,wi.call(this,this._targetElement);case 18:return t.abrupt("return");case 19:return t.next=21,Br.call(this,n);case 21:case"end":return t.stop()}}),e,this)}))),Gr.apply(this,arguments)}function Wr(){return Vr.apply(this,arguments)}function Vr(){return Vr=r(t().mark((function e(){var n,r;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._direction="backward",0!==this._currentStep){t.next=3;break}return t.abrupt("return",!1);case 3:if(--this._currentStep,n=this._introItems[this._currentStep],r=!0,void 0===this._introBeforeChangeCallback){t.next=10;break}return t.next=9,this._introBeforeChangeCallback.call(this,n&&n.element);case 9:r=t.sent;case 10:if(!1!==r){t.next=13;break}return++this._currentStep,t.abrupt("return",!1);case 13:return t.next=15,Br.call(this,n);case 15:case"end":return t.stop()}}),e,this)}))),Vr.apply(this,arguments)}function Ur(){return this._currentStep}function Yr(t){return Kr.apply(this,arguments)}function Kr(){return(Kr=r(t().mark((function e(n){var r,i;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(null===(r=void 0===n.code?n.which:n.code)&&(r=null===n.charCode?n.keyCode:n.charCode),"Escape"!==r&&27!==r||!0!==this._options.exitOnEsc){t.next=7;break}return t.next=5,wi.call(this,this._targetElement);case 5:t.next=39;break;case 7:if("ArrowLeft"!==r&&37!==r){t.next=12;break}return t.next=10,Wr.call(this);case 10:t.next=39;break;case 12:if("ArrowRight"!==r&&39!==r){t.next=17;break}return t.next=15,zr.call(this);case 15:t.next=39;break;case 17:if("Enter"!==r&&"NumpadEnter"!==r&&13!==r){t.next=39;break}if(!(i=n.target||n.srcElement)||!i.className.match("introjs-prevbutton")){t.next=24;break}return t.next=22,Wr.call(this);case 22:t.next=38;break;case 24:if(!i||!i.className.match("introjs-skipbutton")){t.next=32;break}if(this._introItems.length-1!==this._currentStep||"function"!=typeof this._introCompleteCallback){t.next=28;break}return t.next=28,this._introCompleteCallback.call(this,this._currentStep,"skip");case 28:return t.next=30,wi.call(this,this._targetElement);case 30:t.next=38;break;case 32:if(!i||!i.getAttribute("data-step-number")){t.next=36;break}i.click(),t.next=38;break;case 36:return t.next=38,zr.call(this);case 38:n.preventDefault?n.preventDefault():n.returnValue=!1;case 39:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function Xr(t){if(null===t||"object"!==e(t)||void 0!==t.nodeType)return t;var n={};for(var r in t)void 0!==window.jQuery&&t[r]instanceof window.jQuery?n[r]=t[r]:n[r]=Xr(t[r]);return n}function Qr(t,e){var n,r=this;return function(){for(var i=arguments.length,o=new Array(i),a=0;a<i;a++)o[a]=arguments[a];clearTimeout(n),n=setTimeout((function(){t.apply(r,o)}),e)}}function Zr(t){var e=document.querySelector(".introjs-hints");return e?e.querySelectorAll(t):[]}function Jr(t){return ti.apply(this,arguments)}function ti(){return(ti=r(t().mark((function e(n){var r;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(r=Zr('.introjs-hint[data-step="'.concat(n,'"]'))[0],pi.call(this),r&&u(r,"introjs-hidehint"),void 0===this._hintCloseCallback){t.next=6;break}return t.next=6,this._hintCloseCallback.call(this,n);case 6:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function ei(){var e=this;c(Zr(".introjs-hint"),function(){var n=r(t().mark((function n(r){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Jr.call(e,r.getAttribute("data-step"));case 2:case"end":return t.stop()}}),n)})));return function(t){return n.apply(this,arguments)}}())}function ni(){return ri.apply(this,arguments)}function ri(){return(ri=r(t().mark((function e(){var n,r=this;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!(n=Zr(".introjs-hint"))||!n.length){t.next=5;break}c(n,(function(t){ii.call(r,t.getAttribute("data-step"))})),t.next=7;break;case 5:return t.next=7,fi.call(this,this._targetElement);case 7:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function ii(t){var e=Zr('.introjs-hint[data-step="'.concat(t,'"]'))[0];e&&dr(e,/introjs-hidehint/g)}function oi(){var t=this;c(Zr(".introjs-hint"),(function(e){ai.call(t,e.getAttribute("data-step"))})),l.off(document,"click",pi,this,!1),l.off(window,"resize",bi,this,!0),this._hintsAutoRefreshFunction&&l.off(window,"scroll",this._hintsAutoRefreshFunction,this,!0)}function ai(t){var e=Zr('.introjs-hint[data-step="'.concat(t,'"]'))[0];e&&e.parentNode.removeChild(e)}function si(){return ci.apply(this,arguments)}function ci(){return(ci=r(t().mark((function e(){var n,r,i,o=this;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(n=this,null===(r=document.querySelector(".introjs-hints"))&&(r=Er("div",{className:"introjs-hints"})),i=function(t){return function(e){var r=e||window.event;r.stopPropagation&&r.stopPropagation(),null!==r.cancelBubble&&(r.cancelBubble=!0),ui.call(n,t)}},c(this._introItems,(function(t,e){if(!document.querySelector('.introjs-hint[data-step="'.concat(e,'"]'))){var n=Er("a",{className:"introjs-hint"});m(n),n.onclick=i(e),t.hintAnimation||u(n,"introjs-hint-no-anim"),v(t.element)&&u(n,"introjs-fixedhint");var a=Er("div",{className:"introjs-hint-dot"}),s=Er("div",{className:"introjs-hint-pulse"});n.appendChild(a),n.appendChild(s),n.setAttribute("data-step",e),t.targetElement=t.element,t.element=n,li.call(o,t.hintPosition,n,t.targetElement),r.appendChild(n)}})),document.body.appendChild(r),void 0===this._hintsAddedCallback){t.next=9;break}return t.next=9,this._hintsAddedCallback.call(this);case 9:this._options.hintAutoRefreshInterval>=0&&(this._hintsAutoRefreshFunction=Qr((function(){return bi.call(o)}),this._options.hintAutoRefreshInterval),l.on(window,"scroll",this._hintsAutoRefreshFunction,this,!0));case 10:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function li(t,e,n){var r=e.style,i=g.call(this,n),o=20,a=20;switch(t){default:case"top-left":r.left="".concat(i.left,"px"),r.top="".concat(i.top,"px");break;case"top-right":r.left="".concat(i.left+i.width-o,"px"),r.top="".concat(i.top,"px");break;case"bottom-left":r.left="".concat(i.left,"px"),r.top="".concat(i.top+i.height-a,"px");break;case"bottom-right":r.left="".concat(i.left+i.width-o,"px"),r.top="".concat(i.top+i.height-a,"px");break;case"middle-left":r.left="".concat(i.left,"px"),r.top="".concat(i.top+(i.height-a)/2,"px");break;case"middle-right":r.left="".concat(i.left+i.width-o,"px"),r.top="".concat(i.top+(i.height-a)/2,"px");break;case"middle-middle":r.left="".concat(i.left+(i.width-o)/2,"px"),r.top="".concat(i.top+(i.height-a)/2,"px");break;case"bottom-middle":r.left="".concat(i.left+(i.width-o)/2,"px"),r.top="".concat(i.top+i.height-a,"px");break;case"top-middle":r.left="".concat(i.left+(i.width-o)/2,"px"),r.top="".concat(i.top,"px")}}function ui(t){return hi.apply(this,arguments)}function hi(){return(hi=r(t().mark((function e(n){var r,i,o,a,s,c,l,u,h;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(r=document.querySelector('.introjs-hint[data-step="'.concat(n,'"]')),i=this._introItems[n],void 0===this._hintClickCallback){t.next=5;break}return t.next=5,this._hintClickCallback.call(this,r,i,n);case 5:if(o=pi.call(this),parseInt(o,10)!==n){t.next=8;break}return t.abrupt("return");case 8:a=Er("div",{className:"introjs-tooltip"}),s=Er("div"),c=Er("div"),l=Er("div"),a.onclick=function(t){t.stopPropagation?t.stopPropagation():t.cancelBubble=!0},s.className="introjs-tooltiptext",(u=Er("p")).innerHTML=i.hint,s.appendChild(u),this._options.hintShowButton&&((h=Er("a")).className=this._options.buttonClass,h.setAttribute("role","button"),h.innerHTML=this._options.hintButtonLabel,h.onclick=Jr.bind(this,n),s.appendChild(h)),c.className="introjs-arrow",a.appendChild(c),a.appendChild(s),this._currentStep=r.getAttribute("data-step"),l.className="introjs-tooltipReferenceLayer introjs-hintReference",l.setAttribute("data-step",r.getAttribute("data-step")),mr.call(this,l),l.appendChild(a),document.body.appendChild(l),Cr.call(this,r,a,c,!0);case 28:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function pi(){var t=document.querySelector(".introjs-hintReference");if(t){var e=t.getAttribute("data-step");return t.parentNode.removeChild(t),e}}function fi(t){return di.apply(this,arguments)}function di(){return(di=r(t().mark((function e(n){var r,i=this;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this._introItems=[],!this._options.hints){t.next=5;break}c(this._options.hints,(function(t){var e=Xr(t);"string"==typeof e.element&&(e.element=document.querySelector(e.element)),e.hintPosition=e.hintPosition||i._options.hintPosition,e.hintAnimation=e.hintAnimation||i._options.hintAnimation,null!==e.element&&i._introItems.push(e)})),t.next=9;break;case 5:if((r=n.querySelectorAll("*[data-hint]"))&&r.length){t.next=8;break}return t.abrupt("return",!1);case 8:c(r,(function(t){var e=t.getAttribute("data-hint-animation");e=e?"true"===e:i._options.hintAnimation,i._introItems.push({element:t,hint:t.getAttribute("data-hint"),hintPosition:t.getAttribute("data-hint-position")||i._options.hintPosition,hintAnimation:e,tooltipClass:t.getAttribute("data-tooltip-class"),position:t.getAttribute("data-position")||i._options.tooltipPosition})}));case 9:return t.next=11,si.call(this);case 11:l.on(document,"click",pi,this,!1),l.on(window,"resize",bi,this,!0);case 13:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function bi(){var t=this;c(this._introItems,(function(e){var n=e.targetElement,r=e.hintPosition,i=e.element;void 0!==n&&li.call(t,r,i,n)}))}function mi(t){var e=this,n=t.querySelectorAll("*[data-intro]"),r=[];if(this._options.steps)c(this._options.steps,(function(t){var n=Xr(t);if(n.step=r.length+1,n.title=n.title||"","string"==typeof n.element&&(n.element=document.querySelector(n.element)),void 0===n.element||null===n.element){var i=document.querySelector(".introjsFloatingElement");null===i&&(i=Er("div",{className:"introjsFloatingElement"}),document.body.appendChild(i)),n.element=i,n.position="floating"}n.position=n.position||e._options.tooltipPosition,n.scrollTo=n.scrollTo||e._options.scrollTo,void 0===n.disableInteraction&&(n.disableInteraction=e._options.disableInteraction),null!==n.element&&r.push(n)}));else{var i;if(n.length<1)return[];c(n,(function(t){if((!e._options.group||t.getAttribute("data-intro-group")===e._options.group)&&"none"!==t.style.display){var n=parseInt(t.getAttribute("data-step"),10);i=t.hasAttribute("data-disable-interaction")?!!t.getAttribute("data-disable-interaction"):e._options.disableInteraction,n>0&&(r[n-1]={element:t,title:t.getAttribute("data-title")||"",intro:t.getAttribute("data-intro"),step:parseInt(t.getAttribute("data-step"),10),tooltipClass:t.getAttribute("data-tooltip-class"),highlightClass:t.getAttribute("data-highlight-class"),position:t.getAttribute("data-position")||e._options.tooltipPosition,scrollTo:t.getAttribute("data-scroll-to")||e._options.scrollTo,disableInteraction:i})}}));var o=0;c(n,(function(t){if((!e._options.group||t.getAttribute("data-intro-group")===e._options.group)&&null===t.getAttribute("data-step")){for(;void 0!==r[o];)o++;i=t.hasAttribute("data-disable-interaction")?!!t.getAttribute("data-disable-interaction"):e._options.disableInteraction,r[o]={element:t,title:t.getAttribute("data-title")||"",intro:t.getAttribute("data-intro"),step:o+1,tooltipClass:t.getAttribute("data-tooltip-class"),highlightClass:t.getAttribute("data-highlight-class"),position:t.getAttribute("data-position")||e._options.tooltipPosition,scrollTo:t.getAttribute("data-scroll-to")||e._options.scrollTo,disableInteraction:i}}}))}for(var a=[],s=0;s<r.length;s++)r[s]&&a.push(r[s]);return(r=a).sort((function(t,e){return t.step-e.step})),r}function vi(t){var e=document.querySelector(".introjs-tooltipReferenceLayer"),n=document.querySelector(".introjs-helperLayer"),r=document.querySelector(".introjs-disableInteraction");if(mr.call(this,n),mr.call(this,e),mr.call(this,r),t&&(this._introItems=mi.call(this,this._targetElement),Tr.call(this,e,this._introItems[this._currentStep]),qr.call(this,e)),void 0!==this._currentStep&&null!==this._currentStep){var i=document.querySelector(".introjs-arrow"),o=document.querySelector(".introjs-tooltip");o&&i&&Cr.call(this,this._introItems[this._currentStep].element,o,i)}return bi.call(this),this}function gi(){vi.call(this)}function yi(t,e){if(t&&t.parentElement){var n=t.parentElement;e?(br(t,{opacity:"0"}),window.setTimeout((function(){try{n.removeChild(t)}catch(t){}}),500)):n.removeChild(t)}}function wi(t,e){return xi.apply(this,arguments)}function xi(){return(xi=r(t().mark((function e(n,r){var i,o;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=!0,void 0===this._introBeforeExitCallback){t.next=5;break}return t.next=4,this._introBeforeExitCallback.call(this);case 4:i=t.sent;case 5:if(r||!1!==i){t.next=7;break}return t.abrupt("return");case 7:if((o=n.querySelectorAll(".introjs-overlay"))&&o.length&&c(o,(function(t){return yi(t)})),yi(n.querySelector(".introjs-helperLayer"),!0),yi(n.querySelector(".introjs-tooltipReferenceLayer")),yi(n.querySelector(".introjs-disableInteraction")),yi(document.querySelector(".introjsFloatingElement")),Ar(),l.off(window,"keydown",Yr,this,!0),l.off(window,"resize",gi,this,!0),void 0===this._introExitCallback){t.next=23;break}return t.next=23,this._introExitCallback.call(this);case 23:this._currentStep=void 0;case 24:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function _i(e){var n=this,i=Er("div",{className:"introjs-overlay"});return br(i,{top:0,bottom:0,left:0,right:0,position:"fixed"}),e.appendChild(i),!0===this._options.exitOnOverlayClick&&(br(i,{cursor:"pointer"}),i.onclick=r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,wi.call(n,e);case 2:case"end":return t.stop()}}),r)})))),!0}function ki(t){return Si.apply(this,arguments)}function Si(){return(Si=r(t().mark((function e(n){var r;return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this.isActive()){t.next=2;break}return t.abrupt("return");case 2:if(void 0===this._introStartCallback){t.next=5;break}return t.next=5,this._introStartCallback.call(this,n);case 5:if(0!==(r=mi.call(this,n)).length){t.next=8;break}return t.abrupt("return",!1);case 8:if(this._introItems=r,!_i.call(this,n)){t.next=14;break}return t.next=12,zr.call(this);case 12:this._options.keyboardNavigation&&l.on(window,"keydown",Yr,this,!0),l.on(window,"resize",gi,this,!0);case 14:return t.abrupt("return",!1);case 15:case"end":return t.stop()}}),e,this)})))).apply(this,arguments)}function ji(t,e,n){var r,o=(i(r={},t,e),i(r,"path","/"),r);if(n){var a=new Date;a.setTime(a.getTime()+24*n*60*60*1e3),o.expires=a.toUTCString()}var s=[];for(var c in o)s.push("".concat(c,"=").concat(o[c]));return document.cookie=s.join("; "),Ci(t)}function Ci(t){return(e={},document.cookie.split(";").forEach((function(t){var n=o(t.split("="),2),r=n[0],i=n[1];e[r.trim()]=i})),e)[t];var e}Ze({target:"Array",proto:!0,forced:y((function(){return!Array(1).includes()}))},{includes:function(t){return xr(this,t,arguments.length>1?arguments[1]:void 0)}}),wr="includes",yr[gr][wr]=!0;function Ai(t){t?ji(this._options.dontShowAgainCookie,"true",this._options.dontShowAgainCookieDays):ji(this._options.dontShowAgainCookie,"",-1)}function Ei(){var t=Ci(this._options.dontShowAgainCookie);return t&&"true"===t}function Ni(t){this._targetElement=t,this._introItems=[],this._options={isActive:!0,nextLabel:"Next",prevLabel:"Back",skipLabel:"×",doneLabel:"Done",hidePrev:!1,hideNext:!1,nextToDone:!0,tooltipPosition:"bottom",tooltipClass:"",group:"",highlightClass:"",exitOnEsc:!0,exitOnOverlayClick:!0,showStepNumbers:!1,stepNumbersOfLabel:"of",keyboardNavigation:!0,showButtons:!0,showBullets:!0,showProgress:!1,scrollToElement:!0,scrollTo:"element",scrollPadding:30,overlayOpacity:.5,autoPosition:!0,positionPrecedence:["bottom","top","right","left"],disableInteraction:!1,dontShowAgain:!1,dontShowAgainLabel:"Don't show this again",dontShowAgainCookie:"introjs-dontShowAgain",dontShowAgainCookieDays:365,helperElementPadding:10,hintPosition:"top-middle",hintButtonLabel:"Got it",hintShowButton:!0,hintAutoRefreshInterval:10,hintAnimation:!0,buttonClass:"introjs-button",progressBarAdditionalClass:!1}}var Ii=function t(n){var r;if("object"===e(n))r=new Ni(n);else if("string"==typeof n){var i=document.querySelector(n);if(!i)throw new Error("There is no element with given selector.");r=new Ni(i)}else r=new Ni(document.body);return t.instances[s(r,"introjs-instance")]=r,r};Ii.version="6.0.0",Ii.instances={},Ii.fn=Ni.prototype={isActive:function(){return(!this._options.dontShowAgain||!Ei.call(this))&&this._options.isActive},clone:function(){return new Ni(this)},setOption:function(t,e){return this._options[t]=e,this},setOptions:function(t){return this._options=function(t,e){var n,r={};for(n in t)r[n]=t[n];for(n in e)r[n]=e[n];return r}(this._options,t),this},start:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ki.call(e,e._targetElement);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},goToStep:function(e){var n=this;return r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Hr.call(n,e);case 2:return t.abrupt("return",n);case 3:case"end":return t.stop()}}),r)})))()},addStep:function(t){return this._options.steps||(this._options.steps=[]),this._options.steps.push(t),this},addSteps:function(t){if(t.length){for(var e=0;e<t.length;e++)this.addStep(t[e]);return this}},goToStepNumber:function(e){var n=this;return r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Dr.call(n,e);case 2:return t.abrupt("return",n);case 3:case"end":return t.stop()}}),r)})))()},nextStep:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,zr.call(e);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},previousStep:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Wr.call(e);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},currentStep:function(){return Ur.call(this)},exit:function(e){var n=this;return r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,wi.call(n,n._targetElement,e);case 2:return t.abrupt("return",n);case 3:case"end":return t.stop()}}),r)})))()},refresh:function(t){return vi.call(this,t),this},setDontShowAgain:function(t){return Ai.call(this,t),this},onbeforechange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onbeforechange was not a function");return this._introBeforeChangeCallback=t,this},onchange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onchange was not a function.");return this._introChangeCallback=t,this},onafterchange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onafterchange was not a function");return this._introAfterChangeCallback=t,this},oncomplete:function(t){if("function"!=typeof t)throw new Error("Provided callback for oncomplete was not a function.");return this._introCompleteCallback=t,this},onhintsadded:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintsadded was not a function.");return this._hintsAddedCallback=t,this},onhintclick:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintclick was not a function.");return this._hintClickCallback=t,this},onhintclose:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintclose was not a function.");return this._hintCloseCallback=t,this},onstart:function(t){if("function"!=typeof t)throw new Error("Provided callback for onstart was not a function.");return this._introStartCallback=t,this},onexit:function(t){if("function"!=typeof t)throw new Error("Provided callback for onexit was not a function.");return this._introExitCallback=t,this},onskip:function(t){if("function"!=typeof t)throw new Error("Provided callback for onskip was not a function.");return this._introSkipCallback=t,this},onbeforeexit:function(t){if("function"!=typeof t)throw new Error("Provided callback for onbeforeexit was not a function.");return this._introBeforeExitCallback=t,this},addHints:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,fi.call(e,e._targetElement);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},hideHint:function(e){var n=this;return r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,Jr.call(n,e);case 2:return t.abrupt("return",n);case 3:case"end":return t.stop()}}),r)})))()},hideHints:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ei.call(e);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},showHint:function(t){return ii.call(this,t),this},showHints:function(){var e=this;return r(t().mark((function n(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ni.call(e);case 2:return t.abrupt("return",e);case 3:case"end":return t.stop()}}),n)})))()},removeHints:function(){return oi.call(this),this},removeHint:function(t){return ai().call(this,t),this},showHintDialog:function(e){var n=this;return r(t().mark((function r(){return t().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,ui.call(n,e);case 2:return t.abrupt("return",n);case 3:case"end":return t.stop()}}),r)})))()}};
//# sourceMappingURL=intro.module.js.map


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 86556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 42980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    assignMergeValue = __webpack_require__(86556),
    baseFor = __webpack_require__(28483),
    baseMergeDeep = __webpack_require__(59783),
    isObject = __webpack_require__(13218),
    keysIn = __webpack_require__(81704),
    safeGet = __webpack_require__(36390);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 59783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(86556),
    cloneBuffer = __webpack_require__(64626),
    cloneTypedArray = __webpack_require__(77133),
    copyArray = __webpack_require__(278),
    initCloneObject = __webpack_require__(38517),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLikeObject = __webpack_require__(29246),
    isBuffer = __webpack_require__(44144),
    isFunction = __webpack_require__(23560),
    isObject = __webpack_require__(13218),
    isPlainObject = __webpack_require__(68630),
    isTypedArray = __webpack_require__(36719),
    safeGet = __webpack_require__(36390),
    toPlainObject = __webpack_require__(59881);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 82689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseGet = __webpack_require__(97786),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    baseSortBy = __webpack_require__(71131),
    baseUnary = __webpack_require__(7518),
    compareMultiple = __webpack_require__(85022),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 25970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePickBy = __webpack_require__(63012),
    hasIn = __webpack_require__(79095);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 63012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSet = __webpack_require__(10611),
    castPath = __webpack_require__(71811);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 10611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    castPath = __webpack_require__(71811),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 71131:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 26393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 85022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(26393);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 21463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 60696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 36390:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 28583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    copyObject = __webpack_require__(98363),
    createAssigner = __webpack_require__(21463),
    isArrayLike = __webpack_require__(98612),
    isPrototype = __webpack_require__(25726),
    keys = __webpack_require__(3674);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ 63706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    createAssigner = __webpack_require__(21463),
    keys = __webpack_require__(3674);

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

module.exports = assignWith;


/***/ }),

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 2525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    castFunction = __webpack_require__(54290);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 51584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 52353:
/***/ (function(module) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 35161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 82492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(42980),
    createAssigner = __webpack_require__(21463);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(60696),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 75472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(82689),
    isArray = __webpack_require__(1469);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ 78718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePick = __webpack_require__(25970),
    flatRest = __webpack_require__(99021);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 89734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseOrderBy = __webpack_require__(82689),
    baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 59881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(53025);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && suspenseOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === "boolean") {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _useSubscription = __webpack_require__(82021);
var _loadableContext = __webpack_require__(33644);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined" && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 85579:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.QD; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.iP; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; },
  "UserAgent": function() { return useragent/* UserAgent */.Z; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(19116);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(42422);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(52136);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 2 modules
var breadcrumbs = __webpack_require__(39038);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(61634);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/useragent.js
var useragent = __webpack_require__(33931);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(69730);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0,global/* getGlobalObject */.R)();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 21 modules
var sdk = __webpack_require__(28455);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js

/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: version/* SDK_VERSION */.J,
            },
        ],
        version: version/* SDK_VERSION */.J,
    };
    (0,sdk/* init */.S1)(options);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/flags.js
var flags = __webpack_require__(78955);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
//# sourceMappingURL=tracing.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/constants.js
var constants = __webpack_require__(26257);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js




var backgroundtab_global = (0,global/* getGlobalObject */.R)();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (backgroundtab_global && backgroundtab_global.document) {
        backgroundtab_global.document.addEventListener('visibilitychange', function () {
            var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
            if (backgroundtab_global.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                flags/* IS_DEBUG_BUILD */.h &&
                    logger/* logger.log */.kg.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(constants/* FINISH_REASON_TAG */.d, constants/* IDLE_TRANSACTION_FINISH_REASONS.2 */.x[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}
//# sourceMappingURL=backgroundtab.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};
//# sourceMappingURL=bindReporter.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
//# sourceMappingURL=generateUniqueID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};
//# sourceMappingURL=initMetric.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};
//# sourceMappingURL=observe.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};
//# sourceMappingURL=onHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};
//# sourceMappingURL=getCLS.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var firstHiddenTime = -1;
var initHiddenTime = function () {
    return (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};
//# sourceMappingURL=getVisibilityWatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};
//# sourceMappingURL=getFID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};
//# sourceMappingURL=getLCP.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics.js








var metrics_global = (0,global/* getGlobalObject */.R)();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!(0,node/* isNodeEnv */.KV)() && metrics_global && metrics_global.performance && metrics_global.document) {
            if (metrics_global.performance.mark) {
                metrics_global.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!metrics_global || !metrics_global.performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
            // Gatekeeper if performance API not available
            return;
        }
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
        var responseStartTimestamp;
        var requestStartTimestamp;
        metrics_global.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            var duration = (0,utils/* msToSec */.XL)(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
                    requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(metrics_global.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                default:
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0,utils/* msToSec */.XL)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                flags/* IS_DEBUG_BUILD */.h &&
                    logger/* logger.log */.kg.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = metrics_global.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());

/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0,tslib_es6/* __rest */._T)(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild((0,tslib_es6/* __assign */.pi)({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), (0,browser/* htmlTreeAsString */.R)(source.node));
        });
    }
}
//# sourceMappingURL=metrics.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return (0,string/* isMatchingPattern */.zC)(url, origin); }) &&
                !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        (0,instrument/* addInstrumentationHandler */.o)('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        (0,instrument/* addInstrumentationHandler */.o)('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if ((0,is/* isInstanceOf */.V9)(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = (0,tslib_es6/* __spread */.fl)(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,global/* getGlobalObject */.R)();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!router_global || !router_global.location) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = router_global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'navigation' });
            }
        });
    }
}
//# sourceMappingURL=router.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js










var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = (0,tslib_es6/* __assign */.pi)({ idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                flags/* IS_DEBUG_BUILD */.h && (this._emitOptionsWarning = true);
            }
        }
        this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = (0,global/* getGlobalObject */.R)().location;
        var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration((0,utils/* secToMs */.WB)(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());

/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return extractTraceparentData(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = (0,global/* getGlobalObject */.R)().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}
//# sourceMappingURL=browsertracing.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js



// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import tracing integrations like
//
// import { Integrations } from '@sentry/tracing';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/tracing';
// const instance = new BrowserTracing();
//
// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts


// eslint-disable-next-line deprecation/deprecation





// We are patching the global object with our hub extension methods
(0,hubextensions/* addExtensionMethods */.ro)();


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js
/* eslint-disable @typescript-eslint/no-explicit-any */



var client_global = (0,global/* getGlobalObject */.R)();
var DEFAULT_TAGS = {
    'routing.instrumentation': 'next-router',
};
var activeTransaction = undefined;
var prevTransactionName = undefined;
var startTransaction = undefined;
/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    startTransaction = startTransactionCb;
    router_default().ready(function () {
        // We can only start the pageload transaction when we have access to the parameterized
        // route name. Setting the transaction name after the transaction is started could lead
        // to possible race conditions with the router, so this approach was taken.
        if (startTransactionOnPageLoad) {
            prevTransactionName = (router_default()).route !== null ? (0,misc/* stripUrlQueryAndFragment */.rt)((router_default()).route) : client_global.location.pathname;
            activeTransaction = startTransactionCb({
                name: prevTransactionName,
                op: 'pageload',
                tags: DEFAULT_TAGS,
            });
        }
        // Spans that aren't attached to any transaction are lost; so if transactions aren't
        // created (besides potentially the onpageload transaction), no need to wrap the router.
        if (!startTransactionOnLocationChange)
            return;
        // `withRouter` uses `useRouter` underneath:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
        // Router events also use the router:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
        // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
        // (instead of wrapping all of the Router's functions).
        var routerPrototype = Object.getPrototypeOf((router_default()).router);
        (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
    });
}
/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
    var wrapper = function (method, 
    // The parameterized url, ex. posts/[id]/[comment]
    url, 
    // The actual url, ex. posts/85/my-comment
    as, options) {
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var args = [];
        for (
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var _i = 4; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i < arguments.length; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i++) {
            // At the moment there are no additional arguments (meaning the rest parameter is empty).
            // This is meant to protect from future additions to Next.js API, especially since this is an
            // internal API.
            args[_i - 4] = arguments[_i];
        }
        var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
        // do not start a transaction if it's from the same page
        if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
            if (activeTransaction) {
                activeTransaction.finish();
            }
            var tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_TAGS), { method: method }), options);
            if (prevTransactionName) {
                tags.from = prevTransactionName;
            }
            prevTransactionName = newTransactionName;
            activeTransaction = startTransaction({
                name: prevTransactionName,
                op: 'navigation',
                tags: tags,
            });
        }
        return originalChangeStateWrapper.call.apply(originalChangeStateWrapper, (0,tslib_es6/* __spread */.fl)([this, method, url, as, options], args));
    };
    return wrapper;
}
//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js

var PACKAGE_NAME_PREFIX = 'npm:@sentry/';
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
    options._metadata = options._metadata || {};
    options._metadata.sdk =
        options._metadata.sdk ||
            {
                name: 'sentry.javascript.nextjs',
                packages: names.map(function (name) { return ({
                    name: "" + PACKAGE_NAME_PREFIX + name,
                    version: version/* SDK_VERSION */.J,
                }); }),
                version: version/* SDK_VERSION */.J,
            };
}
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js

/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    var match = keyPath.match(/([a-z]+)\.(.*)/i);
    if (match === null) {
        obj[keyPath] = value;
    }
    else {
        setNestedKey(obj[match[1]], match[2], value);
    }
}
/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(integration, userIntegrations, options) {
    if (options === void 0) { options = {}; }
    if (Array.isArray(userIntegrations)) {
        return addIntegrationToArray(integration, userIntegrations, options);
    }
    else {
        return addIntegrationToFunction(integration, userIntegrations, options);
    }
}
function addIntegrationToArray(integration, userIntegrations, options) {
    var includesName = false;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var x = 0; x < userIntegrations.length; x++) {
        if (userIntegrations[x].name === integration.name) {
            includesName = true;
        }
        var op = options[userIntegrations[x].name];
        if (op) {
            setNestedKey(userIntegrations[x], op.keyPath, op.value);
        }
    }
    if (includesName) {
        return userIntegrations;
    }
    return (0,tslib_es6/* __spread */.fl)(userIntegrations, [integration]);
}
function addIntegrationToFunction(integration, userIntegrationsFunc, options) {
    var wrapper = function (defaultIntegrations) {
        var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        return addIntegrationToArray(integration, userFinalIntegrations, options);
    };
    return wrapper;
}
//# sourceMappingURL=userIntegrations.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js








var Integrations = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, INTEGRATIONS), { BrowserTracing: BrowserTracing });
// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import `BrowserTracing` like this:
//
// import { Integrations } from '@sentry/nextjs';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/nextjs';
// const instance = new BrowserTracing();

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
    buildMetadata(options, ['nextjs', 'react']);
    options.environment = options.environment || "production";
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    var integrations = options.tracesSampleRate === undefined && options.tracesSampler === undefined
        ? options.integrations
        : createClientIntegrations(options.integrations);
    init((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { integrations: integrations }));
    (0,esm/* configureScope */.e)(function (scope) {
        scope.setTag('runtime', 'browser');
        scope.addEventProcessor(function (event) { return (event.type === 'transaction' && event.transaction === '/404' ? null : event); });
    });
}
var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: (0,tslib_es6/* __spread */.fl)(defaultRequestInstrumentationOptions.tracingOrigins, [/^(api\/)/]),
    routingInstrumentation: nextRouterInstrumentation,
});
function createClientIntegrations(integrations) {
    if (integrations) {
        return addIntegration(defaultBrowserTracingIntegration, integrations, {
            BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
        });
    }
    else {
        return [defaultBrowserTracingIntegration];
    }
}
//# sourceMappingURL=index.client.js.map
;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(83454);
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

var SENTRY_DSN = process.env.SENTRY_DSN || "https://b476a347490b4f21979e5ebdf68a8af2@sentry.ecomobi.com/48";
var ENVIRONMENT = process.env.ENVIRONMENT || "production" || 0;
index_client_init({
    environment: ENVIRONMENT,
    dsn: SENTRY_DSN
});


/***/ }),

/***/ 65457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ useAppSelector; },
/* harmony export */   "TL": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* unused harmony exports useForm, useInterval */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92145);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useForm = function(defaultValues) {
    return function(handler) {
        return function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(event) {
                var form, elements, data;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.preventDefault();
                            event.persist();
                            form = event.target;
                            elements = Array.from(form.elements);
                            data = elements.filter(function(element) {
                                return element.hasAttribute("name");
                            }).reduce(function(object, element) {
                                return _objectSpread({}, object, _defineProperty({}, "".concat(element.getAttribute("name")), element.value));
                            }, defaultValues);
                            _ctx.next = 7;
                            return handler(data);
                        case 7:
                            form.reset();
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var useInterval = function(callback, delay) {
    var savedCallback = useRef();
    useEffect(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    useEffect(function() {
        var handler = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _ref;
            var ref;
            return (ref = savedCallback.current) === null || ref === void 0 ? void 0 : (_ref = ref).call.apply(_ref, [
                savedCallback
            ].concat(_toConsumableArray(args)));
        };
        if (delay !== null) {
            var id = setInterval(handler, delay);
            return function() {
                return clearInterval(id);
            };
        }
    }, [
        delay
    ]);
};
// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9;


/***/ }),

/***/ 77510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ i18n; }
});

// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(36609);
;// CONCATENATED MODULE: ./src/messages/en.ts
var en = {
    translation: {
        "button_confirm_exit_TOD": "Exit",
        "button_confirm_off_TOD": "Turn off",
        "button_title_default_donation": "Make a donation to {name}",
        "cashback_default_text_button": "Get a refund now!",
        "cashback_default_title": "Shopping spree, juicy cashback",
        "cm_home": "Home",
        "default_content_setup_brand_gift": "Choose a template or create your own",
        "default_content_setup_donation": "This service is being set as default. If you want to make changes, please access the Donation service here: account.passio.eco",
        "default_title_setup_brand_gift": "Settings",
        "default_title_setup_donation": "Service Settings",
        "error_thumbnail_size_TOD": "Image exceeds size limit",
        "invitation_default_donation": "How much do you love {name}?",
        "label_tab_bar_brand_gift": "Template",
        "label_text_button_brand_gift": "Button",
        "label_text_title_brand_gift": "Title",
        "login": "Login",
        "message_default_donation": "Thank you for your donation to {name}. This would contribute a lot to the improvement of my upcoming content.",
        "placeholder_text_button_brand_gift": "Type the button's text",
        "placeholder_text_title_brand_gift": "Type your Title",
        "ss_background_TOD": "Wallpaper",
        "ss_brand_cpc_bonus": "en_Hoa h\u1ED3ng",
        "ss_brand_cpc_campaign_title": "en_Nh\u1EADn hoa h\u1ED3ng",
        "ss_brand_cpc_description": "en_M\xf4 t\u1EA3 ch\u01B0\u01A1ng tr\xecnh",
        "ss_brand_cpc_download": "en_T\u1EA3i xu\u1ED1ng",
        "ss_brand_cpc_from": "en_T\u1EEB",
        "ss_brand_cpc_join": "en_Tham gia",
        "ss_brand_cpc_join_now": "en_Tham kh\u1EA3o ngay",
        "ss_brand_cpc_join_successfully_label": "en_B\u1EA1n \u0111\xe3 tham gia ch\u01B0\u01A1ng tr\xecnh th\xe0nh c\xf4ng",
        "ss_brand_cpc_no_access_allow": "en_B\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p truy c\u1EADp v\xe0o link n\xe0y",
        "ss_brand_cpc_notice": "en_L\u01B0u \xfd",
        "ss_brand_cpc_notice_content": "en_Hoa h\u1ED3ng s\u1EBD \u0111\u01B0\u1EE3c tr\u1EA3 v\u1EC1 t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n sau 7 ng\xe0y k\u1EC3 t\u1EEB khi \u0111\u01B0\u1EE3c nghi\u1EC7m thu.",
        "ss_brand_cpc_reject": "en_\u1EA2nh nghi\u1EC7m thu c\u1EE7a b\u1EA1n \u0111\xe3 b\u1ECB t\u1EEB ch\u1ED1i. B\u1EA1n c\xf3 th\u1EC3 t\u1EA3i l\u1EA1i \u1EA3nh.",
        "ss_brand_cpc_requirement": "en_Y\xeau c\u1EA7u",
        "ss_brand_cpc_step_1": "en_B\u01B0\u1EDBc 1: T\u1EA3i \u1EA3nh d\u01B0\u1EDBi \u0111\xe2y v\u1EC1 v\xe0 up l\xean 1 n\u1EC1n t\u1EA3ng m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_brand_cpc_step_1_note": "en_L\u01B0u \xfd: up \u1EA3nh trong kho\u1EA3ng th\u1EDDi gian",
        "ss_brand_cpc_step_2": "en_B\u01B0\u1EDBc 2: T\u1EA3i \u1EA3nh nghi\u1EC7m thu (\u1EA3nh ch\u1EE5p m\xe0n h\xecnh b\xe0i \u0111\u0103ng c\u1EE7a b\u1EA1n \u1EDF b\u01B0\u1EDBc 1)",
        "ss_brand_cpc_step_2_note": "en_L\u01B0u \xfd: \u1EA3nh nghi\u1EC7m thu th\u1EC3 hi\u1EC7n th\u1EDDi gian \u0111\xe3 \u0111\u0103ng \u1EA3nh t\u1ED1i thi\u1EC3u l\xe0 12h. VD: \u1EA2nh ch\u1EE5p m\xe0n h\xecnh story \u0111\xe3 \u0111\u0103ng 12h tr\u01B0\u1EDBc tr\u1EDF l\xean.",
        "ss_brand_cpc_success": "en_\u0110\xe3 nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_text_content": "en_\u0111ang g\u1EEDi cho b\u1EA1n 01 l\u1EDDi \u0111\u1EC1 ngh\u1ECB tham gia v\xe0o ch\u01B0\u01A1ng tr\xecnh treo banner - nh\u1EADn ti\u1EC1n th\u01B0\u1EDFng.",
        "ss_brand_cpc_text_title": "en_Nh\u1EADn ti\u1EC1n d\u1EC5 d\xe0ng c\xf9ng",
        "ss_brand_cpc_time": "en_Th\u1EDDi gian",
        "ss_brand_cpc_time_end": "en_Th\u1EDDi gian k\u1EBFt th\xfac",
        "ss_brand_cpc_time_start": "en_Th\u1EDDi gian b\u1EAFt \u0111\u1EA7u",
        "ss_brand_cpc_to": "en_\u0110\u1EBFn",
        "ss_brand_cpc_upload_image": "en_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_cpc_upload_image_button": "en_T\u1EA3i \u1EA3nh l\xean",
        "ss_brand_cpc_upload_image_successfully": "en_B\u1EA1n \u0111\xe3 g\u1EEDi \u1EA3nh nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_upload_image_title": "en_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_gift_cancel_hide": "en_H\u1EE7y b\u1ECF",
        "ss_brand_gift_confirm_hide_brand": "en_X\xe1c nh\u1EADn",
        "ss_brand_gift_confirm_hide_group": "en_X\xe1c nh\u1EADn \u1EA9n nh\xf3m",
        "ss_brand_gift_disable_deal_successfully": "en_\u1EA8n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_disable_successfully": "en_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_display_hide_brand": "en_\u1EA8n Deal",
        "ss_brand_gift_display_hide_category": "en_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_display_show_brand": "en_Hi\u1EC7n Deal",
        "ss_brand_gift_display_show_category": "en_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_empty_title": "en_Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m n\xe0o",
        "ss_brand_gift_enable_deal_successfully": "en_Hi\u1EC7n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_enable_successfully": "en_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_hide_brand": "en_B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n Deal?",
        "ss_brand_gift_hide_brand_content": "en_Deal {{name}} s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB \u1EDF giao di\u1EC7n c\u1EE7a Fan. B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n deal n\xe0y?",
        "ss_brand_gift_hide_category": "en_B\u1EA1n mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_hide_category_content": "en_Nh\xf3m {{name}} v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB \u1EA9n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_list_category": "Product group list",
        "ss_brand_gift_list_empty_content": "en_Hi\u1EC7n gi\u1EDD Admin ch\u01B0a setup d\u1EEF li\u1EC7u s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_setting_cashback_default_text_button": "Get a refund now!",
        "ss_brand_gift_setting_cashback_default_title": "Shopping spree, juicy cashback",
        "ss_brand_gift_setting_default_content_setup": "Choose a template or create your own",
        "ss_brand_gift_setting_float_icon_description": "Save floating icon setting in order to increase interaction with your Fan",
        "ss_brand_gift_setting_float_icon_footer_description": "Enable feature to increase interaction with your Fan",
        "ss_brand_gift_setting_label_tab_bar_brand_gift": "Template",
        "ss_brand_gift_setting_label_text_button": "Button",
        "ss_brand_gift_setting_label_text_title_brand_gift": "Title",
        "ss_brand_gift_setting_placeholder_text_button": "Type the button's text",
        "ss_brand_gift_setting_placeholder_text_title": "Type your Title",
        "ss_brand_gift_setting_text_cashback_brand_gift": "Cashback",
        "ss_brand_gift_setting_text_custom_brand_gift": "Customize",
        "ss_brand_gift_setting_text_voucher_brand_gift": "Voucher",
        "ss_brand_gift_setting_title_block_footer": "Brand Gift Icon",
        "ss_brand_gift_setting_voucher_default_text_button": "Get your voucher now!",
        "ss_brand_gift_setting_voucher_default_title": "Tap pay, 5% cashback",
        "ss_brand_rating_setting_default_content_setup_donation": "en_Danh s\xe1ch c\xe1c ch\u01B0\u01A1ng tr\xecnh ho\xe0n ti\u1EC1n gi\u1EA3m gi\xe1 d\xe0nh cho fan c\u1EE7a b\u1EA1n. B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 nh\u1EADn hoa h\u1ED3ng ngay!",
        "ss_build_collapse_block_label": "Collapse",
        "ss_build_expand_block_label": "Expand",
        "ss_build_no_blocks_have_been_added": "No block has been added yet",
        "ss_builde_theme_setting_block": "Block",
        "ss_builder_1st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block.",
        "ss_builder_1st_block_preview_sample_title": "Block 1",
        "ss_builder_2st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block. 2nd block to see the spacing between blocks.",
        "ss_builder_2st_block_preview_sample_title": "Block 2",
        "ss_builder_add_affiliate_product_list_btn_label": "Add more product",
        "ss_builder_add_block_body_title": "Body",
        "ss_builder_add_block_expand_title": "Extended Position",
        "ss_builder_add_block_footer_title": "Footer",
        "ss_builder_add_block_header_title": "Header",
        "ss_builder_add_block_in_template": "Add block template",
        "ss_builder_add_block_in_template_successfully": "Add block template successfully",
        "ss_builder_add_block_label": "Add block",
        "ss_builder_add_block_to": "Add block to:",
        "ss_builder_add_image_of_image_popup_tilte": "Add image popup",
        "ss_builder_add_new_affiliate_product_btn_label": "Add new product",
        "ss_builder_add_new_affiliate_product_group_btn_label": "Add product group",
        "ss_builder_add_new_affiliate_product_image_title": "Product image",
        "ss_builder_add_new_affiliate_product_list_empty_content": "To add new product, please enter product url below",
        "ss_builder_add_new_affiliate_product_name_title": "Product name",
        "ss_builder_add_new_affiliate_product_title": "Add new product",
        "ss_builder_add_new_block_successfully_label": "Add new block successfully",
        "ss_builder_add_new_image": "Add new image",
        "ss_builder_add_new_image_of_image_popup_title": "Image popup",
        "ss_builder_add_new_image_of_image_slider_title": "Image",
        "ss_builder_add_new_image_popup_btn_label": "Add",
        "ss_builder_add_new_image_slider_title": "Add image",
        "ss_builder_add_new_label": "Add",
        "ss_builder_add_new_product_group_successfully_label": "Add new product group successfully",
        "ss_builder_add_new_tab_successfully_label": "Add new tab successfully",
        "ss_builder_add_new_tag_error_duplicate": "Tag is already existed",
        "ss_builder_add_new_template_btn_label": "Save",
        "ss_builder_add_new_template_image_title": "Template image",
        "ss_builder_add_new_template_label": "Create new template",
        "ss_builder_add_new_template_name_placeholder": "Enter template name",
        "ss_builder_add_new_template_name_title": "Template name",
        "ss_builder_add_new_theme_btn_label": "Create new",
        "ss_builder_add_new_theme_selection_panel_description": "Choose a method to create a Theme Template to publish to the Theme Store",
        "ss_builder_add_new_theme_selection_panel_label": "Create the theme template",
        "ss_builder_add_new_theme_template_image_title": "Theme template image",
        "ss_builder_add_new_theme_template_name_placeholder": "Enter the theme template name",
        "ss_builder_add_new_theme_template_name_title": "Theme template name",
        "ss_builder_add_story": "Add new",
        "ss_builder_add_tab_label": "Add Tab",
        "ss_builder_added_product_url_label": "Link has been added",
        "ss_builder_advanced_group_description": "Advanced blocks",
        "ss_builder_advanced_setting": "Advanced settings",
        "ss_builder_advanced_title": "Advanced",
        "ss_builder_aff_frame_max_size_content": "Max file size: 30MB.",
        "ss_builder_aff_frame_select_from_library": "Select from library",
        "ss_builder_aff_frame_support_type_file_content": "Support file format: gif, png, svg",
        "ss_builder_affiliate_add_new_tour_content_step_1": "Select a product group to categorize your products. The products below will be added to the group you choose.",
        "ss_builder_affiliate_add_new_tour_content_step_2": "Enter the link to the product, the system will automatically get the product information.",
        "ss_builder_affiliate_add_new_tour_content_step_3": "You can change the name, image, label... of product.",
        "ss_builder_affiliate_add_new_tour_content_step_4": "Click \u201CAdd\u201D button to add the above product list to the group.",
        "ss_builder_affiliate_add_new_tour_title_step_1": "Select product group",
        "ss_builder_affiliate_add_new_tour_title_step_2": "Link to product",
        "ss_builder_affiliate_add_new_tour_title_step_3": "Product information",
        "ss_builder_affiliate_add_new_tour_title_step_4": "Add new products",
        "ss_builder_affiliate_group_tour_content_step_1": "Add product groups to categorize your product categories",
        "ss_builder_affiliate_group_tour_content_step_2": "Editing and options of each group, allowing you to customize the block as you like.",
        "ss_builder_affiliate_group_tour_title_step_1": "Add product groups",
        "ss_builder_affiliate_group_tour_title_step_2": "Quick Actions",
        "ss_builder_affiliate_product_btn_see_more_placeholder": "Enter content",
        "ss_builder_affiliate_product_btn_see_more_title": "Show more button label",
        "ss_builder_affiliate_product_clean_up_popover_content": "This product will not be cleaned up automatically when the product group is full",
        "ss_builder_affiliate_product_cleanup_lock_label": "Lock cleanup",
        "ss_builder_affiliate_product_cleanup_unlock_label": "Unlock cleanup",
        "ss_builder_affiliate_product_frame_panel_title": "Select a frame",
        "ss_builder_affiliate_product_group_add_new_panel_title": "Group information",
        "ss_builder_affiliate_product_group_list_selector_label": "Product group list",
        "ss_builder_affiliate_product_group_management_title": "Product group management",
        "ss_builder_affiliate_product_group_other": "Other",
        "ss_builder_affiliate_product_group_placeholder": "Enter block title",
        "ss_builder_affiliate_product_group_quantity_label": "{{product_quantity}} products",
        "ss_builder_affiliate_product_group_quantity_warning_1": "Couldn't add",
        "ss_builder_affiliate_product_group_quantity_warning_2": "Exceeded the amount available",
        "ss_builder_affiliate_product_group_title": "Block title",
        "ss_builder_affiliate_product_image_popup_infomation_label": "Image is automatically crawl from your link. You can change to another image.",
        "ss_builder_affiliate_product_label_product_discount": "Sale",
        "ss_builder_affiliate_product_label_product_hot": "Hot",
        "ss_builder_affiliate_product_label_product_like": "Favorite",
        "ss_builder_affiliate_product_label_product_title": "Product labels",
        "ss_builder_affiliate_product_list_empty_content": "To add products please press the \u201CAdd\u201D button above",
        "ss_builder_affiliate_product_list_empty_title": "No products have been added yet",
        "ss_builder_affiliate_product_list_title": "List",
        "ss_builder_affiliate_product_moving_panel_title": "Move product",
        "ss_builder_affiliate_product_quantity_on_row_title": "No. of products per row",
        "ss_builder_affiliate_product_searching_placeholder": "Search product by name...",
        "ss_builder_affiliate_product_style_title": "Style",
        "ss_builder_affiliate_setting_popover_manual_content": "Get to know how to use the Affiliate Block, let's press the \u201CGet Started\u201D button.",
        "ss_builder_affiliate_setting_popover_manual_title": "Product tour",
        "ss_builder_affiliate_setting_tour_content_step_1": "Perform operations such as Hide/Show, Delete blocks.",
        "ss_builder_affiliate_setting_tour_content_step_2": "Set Title and Description for the block, the information will be displayed respectively after saving.",
        "ss_builder_affiliate_setting_tour_content_step_3": "Select the display style of the products in the block. After changing and saving the block you will see the changed display style in the design screen.",
        "ss_builder_affiliate_setting_tour_content_step_4": "Create new and manage Product Groups to divide the product list into groups. Fans will easily categorize and filter products by group. For example: Clothing, Shoes, Accessories,...",
        "ss_builder_affiliate_setting_tour_content_step_5": "Easy access to each product group to add new and manage products within the group.",
        "ss_builder_affiliate_setting_tour_content_step_6": "Add new products to each group by clicking the \u201CAdd\u201D button.",
        "ss_builder_affiliate_setting_tour_content_step_7": "Quick options for each product allow quick manipulation of the products in the list.",
        "ss_builder_affiliate_setting_tour_content_step_8": "After editing, adding content and products to your block, press the \u201CSave\u201D button to save and will see the changes in the \u201CDesign\u201D screen.",
        "ss_builder_affiliate_setting_tour_title_step_1": "Quick Actions",
        "ss_builder_affiliate_setting_tour_title_step_2": "Title and Description",
        "ss_builder_affiliate_setting_tour_title_step_3": "Product display configuration",
        "ss_builder_affiliate_setting_tour_title_step_4": "Product group management",
        "ss_builder_affiliate_setting_tour_title_step_5": "Product Groups",
        "ss_builder_affiliate_setting_tour_title_step_6": "Add products",
        "ss_builder_affiliate_setting_tour_title_step_7": "Product options",
        "ss_builder_affiliate_setting_tour_title_step_8": "Save products",
        "ss_builder_affiliate_upload_product_error_content": "Uploaded file need to be a json file with compatible format",
        "ss_builder_affiliate_upload_product_error_label": "Invalid file",
        "ss_builder_affiliate_upload_product_label": "Upload a product file",
        "ss_builder_all_setting_and_product": "all settings and all products inside",
        "ss_builder_all_the_blocks_are_in_your_list_by_the_blocks_of_the_template": "all the blocks are in your list by the blocks from the template",
        "ss_builder_allowed_domain_label": "The domain name does not exist, you can use this domain name",
        "ss_builder_an_unexpected_error_has_occurred": "An unexpected error has occurred.",
        "ss_builder_apply_preview_theme_template_btn_label": "Apply",
        "ss_builder_apply_template_successfully_label": "Apply template successfully",
        "ss_builder_apply_template_title": "Do you want to apply this template?",
        "ss_builder_apply_theme_premium_warning": "Theme for paid account only. Please upgrade your account to apply this template.",
        "ss_builder_apply_theme_premium_warning_title": "Do you want to apply this theme?",
        "ss_builder_apply_theme_template_successfully_label": "Apply theme template successfully",
        "ss_builder_auto_cleanup_products_warning_content_1": "Exceeded the number of products. The system will automatically cleanup the products from the bottom of the list when you add new ones.",
        "ss_builder_auto_cleanup_products_warning_content_2": "Note: Products that are on \u201CCleanup Lock\u201D will not be automatically cleaned.",
        "ss_builder_back": "Back",
        "ss_builder_background_block": "Background",
        "ss_builder_background_enable_overlay": "Overlay",
        "ss_builder_background_opacity": "Blur",
        "ss_builder_background_overlay_color": "Overlay color",
        "ss_builder_background_popover_manual_content": "Get to know how to use the Background settings, let's press the \u201CGet Started\u201D button.",
        "ss_builder_background_popover_manual_title": "Product tour",
        "ss_builder_background_setting_title": "Background Settings",
        "ss_builder_background_tour_content_step_1": "Preview area for the settings below, real time update for any change.",
        "ss_builder_background_tour_content_step_2": 'You can set site background using "Image" or "Color". With color, you can choose "Solid" or "Gradient" color.',
        "ss_builder_background_tour_title_step_1": "Preview area",
        "ss_builder_background_tour_title_step_2": "Background by Image or Color",
        "ss_builder_basic_group_description": "Basic blocks",
        "ss_builder_basic_title": "Basic",
        "ss_builder_bio_add_social_link_title": "Add social link",
        "ss_builder_bio_avatar_title": "Avatar",
        "ss_builder_bio_layout_title": "Layout",
        "ss_builder_bio_name_sub_placeholder": "Enter the sub title",
        "ss_builder_bio_name_title": "Display name",
        "ss_builder_bio_name_title_placeholder": "Enter the display name",
        "ss_builder_bio_social_link_btn_select_icon_label": "Select an icon",
        "ss_builder_bio_social_link_icon_title": "Icon",
        "ss_builder_bio_social_link_url_title": "Enter the url",
        "ss_builder_bio_sub_title": "Sub title",
        "ss_builder_bio_text_title": "Bio text",
        "ss_builder_block_affiliate_description": "Recommend Affiliate Products to your Fans",
        "ss_builder_block_background_blur": "Background blur",
        "ss_builder_block_background_color": "Background color",
        "ss_builder_block_bio_description": "Your profile picture, bio text and your social links",
        "ss_builder_block_block_card_description": "List of images with additional information in a flexible and slideable layout",
        "ss_builder_block_booking_file_alert_content": "Please create a Booking Profile before setting up",
        "ss_builder_block_booking_file_alert_title": "You have not created Booking Profile",
        "ss_builder_block_booking_file_button_label_default": "Working Profile",
        "ss_builder_block_booking_file_label": "Booking Profile url",
        "ss_builder_block_booking_file_link_tooltip": "The Booking Profile block will link to this url",
        "ss_builder_block_booking_file_switch_tooltip": "Display a link to your Booking Profile in the Bio area",
        "ss_builder_block_booking_profile_button_label": "Button label",
        "ss_builder_block_booking_profile_setting_description": "Description",
        "ss_builder_block_booking_profile_setting_title": "Title",
        "ss_builder_block_border_color": "Border Color",
        "ss_builder_block_border_style": "Style",
        "ss_builder_block_brand_gift_description": "Save floating icon setting in order to increase interaction with your Fan",
        "ss_builder_block_brand_gift_footer_description": "Enable feature to increase interaction with your Fan",
        "ss_builder_block_button_link_description": "Single button link to link to your favorite place on the internet",
        "ss_builder_block_button_multi_description": "Multi button links to link to your favorite places on the internet",
        "ss_builder_block_button_story_description": "Display featured links on your site with images and text",
        "ss_builder_block_combined_description": "Combine existing blocks into a new block type",
        "ss_builder_block_combined_description_label": "Combine existing blocks into a new block type",
        "ss_builder_block_combined_description_placeholder": "Enter content",
        "ss_builder_block_combined_heading_label": "Block title",
        "ss_builder_block_description": "Block description",
        "ss_builder_block_description_label": "Description",
        "ss_builder_block_description_placeholder": "Enter content",
        "ss_builder_block_design_hiding_label": "Hidden Block",
        "ss_builder_block_digital_product_description": "Sell your Digital Product on Passio Page",
        "ss_builder_block_donation_description": "Receive donations from Fans",
        "ss_builder_block_heading_label": "Block title",
        "ss_builder_block_heading_placeholder": "Enter content",
        "ss_builder_block_image_description": "Add an image to your site",
        "ss_builder_block_image_embed_description": "Embed anything to your site: video, audio, form,...",
        "ss_builder_block_image_gallery_description": "List of images displayed in multiple layouts and zoomable",
        "ss_builder_block_image_popup_description": "Image will be displayed as popup when fans view your site",
        "ss_builder_block_image_slider_description": "List of images displayed in an image slider",
        "ss_builder_block_is_hiding_label": "Hidden Block",
        "ss_builder_block_link_copy_successfully_label": "Coppied",
        "ss_builder_block_list_combined_description": "Combine existing blocks into a new block type",
        "ss_builder_block_main_color": "Primary color",
        "ss_builder_block_outside_space": "Block's margin",
        "ss_builder_block_rating_answer_1": "Interface",
        "ss_builder_block_rating_answer_2": "Page loading time",
        "ss_builder_block_rating_answer_3": "Experience",
        "ss_builder_block_rating_answer_4": "Support",
        "ss_builder_block_rating_answer_5": "Other",
        "ss_builder_block_rating_button_submit_rating": "Submit rating",
        "ss_builder_block_rating_button_title_open_popup": "Submit rating",
        "ss_builder_block_rating_content_rating": "Your feedback",
        "ss_builder_block_rating_content_rating_placeholder": "Please leave suggestions for Passio Page",
        "ss_builder_block_rating_description": "It would be great if Passio Page received your rating to improve the quality of service",
        "ss_builder_block_rating_description_auto_show": "Your feedback about Passio Page",
        "ss_builder_block_rating_description_star_1": "You feel unsatisfied because",
        "ss_builder_block_rating_description_star_2": "You feel unsatisfied because",
        "ss_builder_block_rating_description_star_3": "Passio Page need to improvement on",
        "ss_builder_block_rating_description_star_4": "You feel satisfied with",
        "ss_builder_block_rating_description_star_5": "You feel satisfied with",
        "ss_builder_block_rating_star_1": "Terrible",
        "ss_builder_block_rating_star_2": "Bored",
        "ss_builder_block_rating_star_3": "So far OK",
        "ss_builder_block_rating_star_4": "Nice",
        "ss_builder_block_rating_star_5": "Excellent",
        "ss_builder_block_rating_title": "Your rating",
        "ss_builder_block_rating_toast_success_rating": "Thank you for your feedback",
        "ss_builder_block_second_color": "Secondary color",
        "ss_builder_block_setting_title": "Block Settings",
        "ss_builder_block_shadow_color": "Shadow color",
        "ss_builder_block_space": "Spacing between blocks",
        "ss_builder_block_spacer_and_divider_description": "Add spacer or divider between your blocks",
        "ss_builder_block_text_description": "Add any content to your site with formatted text",
        "ss_builder_block_text_see_more_btn_default_title": "See more",
        "ss_builder_block_truth_or_dare_description": "Go all out with Truth or Dare",
        "ss_builder_block_truth_or_dare_footer_description": "Show Icon for Truth or Dare in the screen corner",
        "ss_builder_block_virtual_gift_description": "Enable to receive gifts from Fans",
        "ss_builder_block_virtual_gift_footer_description": "Show Icon for Virtual Gift in the screen corner",
        "ss_builder_blocks_general_settings_label": "General setting of blocks",
        "ss_builder_blocks_general_settings_popover_content": "Enable to apply \u201CBlock Settings\u201D in the \u201CSettings\u201D to the blocks in the list below",
        "ss_builder_blocks_label": "Blocks",
        "ss_builder_blocks_list": "List",
        "ss_builder_blocks_list_empty_content": "To add a new block please click the \u201CAdd\u201D button above",
        "ss_builder_blocks_list_empty_title": "No block have been added yet",
        "ss_builder_body_description": "You can use Tabs to divide the list of block into multi parts",
        "ss_builder_body_introduction_description": '"Body" is the main area of the site, contains the Blocks and is divided, navigated by Tabs. For example: content, images, products, ...',
        "ss_builder_body_introduction_title": "Body Position",
        "ss_builder_body_title": "Body",
        "ss_builder_bold": "Bold",
        "ss_builder_booking_profile_style_1": "Cards",
        "ss_builder_booking_profile_style_2": "Embed code",
        "ss_builder_border_dash": "Dash",
        "ss_builder_border_dot": "Dot",
        "ss_builder_border_radius_label": "Radius",
        "ss_builder_border_radius_style": "Border radius style",
        "ss_builder_border_solid": "Solid",
        "ss_builder_bottom_position_tab_label": "Bottom",
        "ss_builder_box_icon_button_filter": "Filter",
        "ss_builder_box_icon_empty_search": "No results found",
        "ss_builder_box_icon_empty_searching_description": "Please try with another keyword",
        "ss_builder_box_icon_filter_category_all": "All",
        "ss_builder_box_icon_filter_category_sub_title": "Select icon category",
        "ss_builder_box_icon_filter_category_title": "Filter",
        "ss_builder_box_icon_search_bar_placeholder": "Search icons by name...",
        "ss_builder_bp_apply_block_settings_instruction": "Turn off to display full screen width. Turn on to display by settings in Block Settings as normal blocks.",
        "ss_builder_bp_open_new_tab_instruction": "Turn on to show the icon to open a new tab in the right corner",
        "ss_builder_bp_open_new_tab_title": "Open new tab",
        "ss_builder_brand_gift_introduction_popup_title": "Add Brand Gift icon",
        "ss_builder_browser_opening_label": "Open in browser",
        "ss_builder_button_background_color": "Background color",
        "ss_builder_button_border_color": "Border color",
        "ss_builder_button_border_width": "Border width (px)",
        "ss_builder_button_close_introduction_service": "Close",
        "ss_builder_button_font_size": "Font size (px)",
        "ss_builder_button_font_weight": "Font weight",
        "ss_builder_button_line_height": "Line height",
        "ss_builder_button_link_content_title": "Title",
        "ss_builder_button_link_description": "Link description",
        "ss_builder_button_link_icon_btn_selection_label": "Select an icon",
        "ss_builder_button_link_icon_origin_url_label": "Link",
        "ss_builder_button_link_icon_title": "Select icon",
        "ss_builder_button_link_large_size_label": "Large",
        "ss_builder_button_link_middle_size_label": "Middle",
        "ss_builder_button_link_not_enought_infomation": "Link has not enough infomation",
        "ss_builder_button_link_placeholder_content_title": "Enter content",
        "ss_builder_button_link_size_selection_title": "Select a size",
        "ss_builder_button_link_small_size_label": "Small",
        "ss_builder_button_setting_title": "Button Settings",
        "ss_builder_button_text_color": "Text color",
        "ss_builder_button_title": "Button title",
        "ss_builder_cancel": "Cancel",
        "ss_builder_cancel-delete_block_label": "Cancel",
        "ss_builder_cancel-delete_image_label": "Continue to edit",
        "ss_builder_cancel-delete_social_link_btn_label": "Cancel",
        "ss_builder_cancel-delete_tab_label": "Cancel",
        "ss_builder_cancel-restore_theme_label": "Cancel",
        "ss_builder_cancel-set_default_tab_label": "Cancel",
        "ss_builder_cancel_affiliate_product_group_add_new_panel_label": "Cancel",
        "ss_builder_cancel_apply_theme_template_btn_label": "Cancel",
        "ss_builder_cancel_block_btn_label": "Cancel",
        "ss_builder_cancel_delete_aff_block_btn_label": "Cancel",
        "ss_builder_cancel_delete_card_modal_btn_label": "Continue to edit",
        "ss_builder_cancel_delete_link_modal_btn_label": "Continue editing",
        "ss_builder_cancel_delete_product_label": "Cancel",
        "ss_builder_cancel_delete_theme_template_modal_btn_label": "Cancel",
        "ss_builder_cancel_edit_block_content": "Your modifications on block will not be saved. Are you sure you want to exit?",
        "ss_builder_cancel_edit_block_title": "Cancel editting?",
        "ss_builder_cancel_hide_product_label": "Cancel",
        "ss_builder_cancel_image_slider_add_new_btn_label": "Cancel",
        "ss_builder_cancel_overwrite_theme_template_btn_label": "Cancel",
        "ss_builder_cancel_preview_theme_template_btn_label": "Close",
        "ss_builder_cancel_product_addition_modal_confirm_btn_label": "Continue adding products",
        "ss_builder_cancel_product_addition_modal_description": "Products added at this screen will not be saved.",
        "ss_builder_cancel_product_addition_modal_title": "Cancel add products?",
        "ss_builder_cancel_replace_theme_template_btn_label": "Cancel",
        "ss_builder_cancel_select_multi_items": "Cancel",
        "ss_builder_cancel_theme_selection_panel_label": "Cancel",
        "ss_builder_cancel_upload_image": "Cancel",
        "ss_builder_card_add_new_description_label": "Description",
        "ss_builder_card_add_new_label": "Label",
        "ss_builder_card_add_new_subtitle_label": "Subtitle",
        "ss_builder_card_add_new_title_label": "Title",
        "ss_builder_card_add_new_url_label": "Url",
        "ss_builder_card_additional_btn_label": "Add card",
        "ss_builder_card_btn_content_label": "Button content",
        "ss_builder_card_layout_alert_1": "This layout will not display description, label and button",
        "ss_builder_card_layout_alert_2": "This layout will not display description and button",
        "ss_builder_card_layout_label": "Layout",
        "ss_builder_card_layout_label_1": "Text under image - Left align",
        "ss_builder_card_layout_label_2": "Text under image - Center align",
        "ss_builder_card_layout_label_3": "Text over image - Center align",
        "ss_builder_card_layout_label_4": "Text over image - Left align",
        "ss_builder_card_layout_label_5": "Text on the right",
        "ss_builder_card_layout_label_6": "Text on the left",
        "ss_builder_card_layout_label_7": "Text over image - Left align 2",
        "ss_builder_card_layout_label_8": "Text over image - Center align 2",
        "ss_builder_card_url_placeholder": "http://domain.com",
        "ss_builder_category_14_up": "14+",
        "ss_builder_category_all": "All",
        "ss_builder_category_art": "Art",
        "ss_builder_category_creative": "Creative",
        "ss_builder_category_doctor": "Doctor",
        "ss_builder_category_education": "Education",
        "ss_builder_category_entertainment": "Entertainment",
        "ss_builder_category_fashion": "Fashion",
        "ss_builder_category_fitness": "Fitness",
        "ss_builder_category_food_fmcg": "Food & FMCG",
        "ss_builder_category_game": "Game",
        "ss_builder_category_health_and_beauty": "Health & Beauty",
        "ss_builder_category_ict": "ICT",
        "ss_builder_category_life_style": "Lifestyle",
        "ss_builder_category_lifestyle": "Lifestyle",
        "ss_builder_category_mom_and_kid": "Mom & Kid",
        "ss_builder_category_others": "Others",
        "ss_builder_category_pet": "Pet",
        "ss_builder_category_spirit": "Spirit",
        "ss_builder_change_image_button_label": "Change image",
        "ss_builder_change_name_product_group_successfully_label": "Change product group name successfully",
        "ss_builder_change_theme_label": "Change theme",
        "ss_builder_choose_a_prototying_method": "Choose an option to create new template",
        "ss_builder_choose_at_least_category": "Choose at least 1 category and we will suggest themes based on your selection \uD83D\uDC47",
        "ss_builder_choose_image_below": 'To add new item, please click on "Add new" button below',
        "ss_builder_choose_one_theme_preview_you_can_customize_it_later": "Choose a theme, you can customize it after applying\u2728",
        "ss_builder_choose_the_look_that_right_for_you": "Please choose a theme",
        "ss_builder_choose_this_template": "Apply",
        "ss_builder_cleanup_lock_product_successfully_label": "Lock the product cleanup successfully",
        "ss_builder_cleanup_unlock_product_successfully_label": "Unlock the product cleanup successfully",
        "ss_builder_close_panel": "Cancel",
        "ss_builder_close_panel_affiliate_product-selection-label": "Cancel",
        "ss_builder_close_panel_edit_text_block": "Close",
        "ss_builder_collapse": "See less",
        "ss_builder_color_1": "Color 1",
        "ss_builder_color_2": "Color 2",
        "ss_builder_color_picker_panel_title": "Choose a color",
        "ss_builder_confirm-cancel_image_slider_add_new_content": "Your actions have not been saved.\nAre you sure you want to exit?",
        "ss_builder_confirm-cancel_image_slider_add_new_title": "Exit editing?",
        "ss_builder_confirm-delete_block_label": "If you delete the block, the added data will be deleted. Are you sure you want to delete?",
        "ss_builder_confirm-delete_block_title": "Do you want to delete this block?",
        "ss_builder_confirm-delete_image_label": "Are you sure you want to delete this image?",
        "ss_builder_confirm-delete_image_title": "Delete image",
        "ss_builder_confirm-delete_social_link_content": "Are you sure you want to delete this item?",
        "ss_builder_confirm-delete_social_link_title": "Delete social networks?",
        "ss_builder_confirm_affiliate_product_group_add_new_panel_label": "Save",
        "ss_builder_confirm_apply_template_description": "Applying template will replace all existing blocks in your list by the template's blocks.",
        "ss_builder_confirm_apply_template_label": "Replace",
        "ss_builder_confirm_apply_theme_template_btn_label": "Confirm",
        "ss_builder_confirm_apply_theme_template_content": "Applying the theme you choose will change the appearing of entire site",
        "ss_builder_confirm_apply_theme_template_title": "Do you want to apply this theme?",
        "ss_builder_confirm_cancel_image_slider_add_new_btn_label": "Exit",
        "ss_builder_confirm_cleanup_lock_product_btn_label": "Confirm to lock",
        "ss_builder_confirm_cleanup_lock_product_selection_modal_content": "Are you sure you want to lock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_cleanup_unlock_product_btn_label": "Confirm to unlock",
        "ss_builder_confirm_cleanup_unlock_product_selection_modal_content": "Are you sure you want to unlock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_delete_aff_block_content": "This action cannot be undone. Please confirm, you understand that deleting this block will delete all products inside.",
        "ss_builder_confirm_delete_aff_block_input_placeholder": "OK",
        "ss_builder_confirm_delete_aff_block_label_enter_ok": "Enter \u201COK\u201D to confirm",
        "ss_builder_confirm_delete_aff_block_understood": "I understood",
        "ss_builder_confirm_delete_aff_block_warining": "Warning",
        "ss_builder_confirm_delete_block_btn_label": "Confirm delete",
        "ss_builder_confirm_delete_card_modal_btn_label": "Delete card",
        "ss_builder_confirm_delete_card_modal_description": "Are you sure you want to delete this card?",
        "ss_builder_confirm_delete_card_modal_label": "Delete card",
        "ss_builder_confirm_delete_combined_label": "Are you sure you want to delete the {{type}} block?",
        "ss_builder_confirm_delete_image_popup_image_label": "Confirm delete",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_content": "Are you sure you want to delete these {{quantity}} links?",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_title": "Delete links",
        "ss_builder_confirm_delete_item_checkbox_card_modal_content": "Are you sure you want to delete these {{quantity}} cards?",
        "ss_builder_confirm_delete_item_checkbox_card_modal_title": "Delete cards",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_content": "Are you sure you want to delete these {{quantity}} blocks?",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_title": "Delete block",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_content": "Are you sure you want to delete these {{quantity}} images?",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_title": "Delete gallery images",
        "ss_builder_confirm_delete_item_checkbox_story_modal_content": "Are you sure you want to delete these {{quantity}} spotlight items?",
        "ss_builder_confirm_delete_item_checkbox_story_modal_title": "Delete spotlight items",
        "ss_builder_confirm_delete_link_description": "Are you sure you want to delete this link?",
        "ss_builder_confirm_delete_product_group_modal_description": 'The group "{{group_name}}" and all the data of the products inside will be permanently deleted. Are you sure you want to delete?',
        "ss_builder_confirm_delete_product_group_modal_title": "Do you want to delete the group?",
        "ss_builder_confirm_delete_product_label": "Delete",
        "ss_builder_confirm_delete_product_modal_content": "Are you sure you want to delete this product?",
        "ss_builder_confirm_delete_product_modal_title": "Delete product",
        "ss_builder_confirm_delete_product_selection_modal_content": "Are you sure you want to delete these {{product_quantity}} products?",
        "ss_builder_confirm_delete_tab_label": "Delete",
        "ss_builder_confirm_delete_template_modal_content": "Permanently delete this template from the template list, blocks that previously used this template will not be affected",
        "ss_builder_confirm_delete_template_modal_title": "Do you want to delete this template?",
        "ss_builder_confirm_delete_theme_template_modal_btn_label": "Confirm delete",
        "ss_builder_confirm_delete_theme_template_modal_content": "Permanently delete theme template from the theme store, themes created from this theme will not be affected",
        "ss_builder_confirm_delete_theme_template_modal_title": "Do you want to delete this theme template?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_content": "Are you sure you want to hide these {{quantity}} links?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_title": "Hide links",
        "ss_builder_confirm_disable_item_checkbox_card_modal_content": "Are you sure you want to hide these {{quantity}} cards?",
        "ss_builder_confirm_disable_item_checkbox_card_modal_title": "Hide cards",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_content": "Are you sure you want to hide these {{quantity}} blocks?",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_title": "Hide block",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_content": "Are you sure you want to hide these {{quantity}} gallery images?",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_title": "Hide gallery images",
        "ss_builder_confirm_disable_item_checkbox_story_modal_content": "Are you sure you want to hide these {{quantity}} spotlights?",
        "ss_builder_confirm_disable_item_checkbox_story_modal_title": "Hide spotlights",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_content": "Are you sure you want to show these {{quantity}} links?",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_title": "Show links",
        "ss_builder_confirm_enable_item_checkbox_card_modal_content": "Are you sure you want to show these {{quantity}} cards?",
        "ss_builder_confirm_enable_item_checkbox_card_modal_title": "Show cards",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_content": "Are you sure you want to show these {{quantity}} blocks?",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_title": "Show block",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_content": "Are you sure you want to show these {{quantity}} gallery images?",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_title": "Show gallery images",
        "ss_builder_confirm_enable_item_checkbox_story_modal_content": "Are you sure you want to show these {{quantity}} spotlights?",
        "ss_builder_confirm_enable_item_checkbox_story_modal_title": "Show spotlights",
        "ss_builder_confirm_enable_product_selection_modal_content": "Are you sure you want to show these {{product_quantity}} products?",
        "ss_builder_confirm_hide_product_btn_label": "Confirm to hide",
        "ss_builder_confirm_hide_product_group_modal_description": 'The product group "{{group_name}}" and all the data of the products inside will be hidden. Are you sure you want to hide the group?',
        "ss_builder_confirm_hide_product_group_modal_title": "Do you want to hide the group?",
        "ss_builder_confirm_hide_product_label": "Confirm to hide group",
        "ss_builder_confirm_hide_product_selection_modal_content": "Are you sure you want to hide {{product_quantity}} products?",
        "ss_builder_confirm_overwrite": "Confirm overwrite",
        "ss_builder_confirm_overwrite_theme_template_btn_label": "Confirm overwrite",
        "ss_builder_confirm_overwrite_theme_template_modal_content": "Overwriting will replace all data and settings of theme template by data and settings of current theme template",
        "ss_builder_confirm_overwrite_theme_template_modal_title": "Do you want to overwrite?",
        "ss_builder_confirm_panel": "Confirm",
        "ss_builder_confirm_panel_affiliate_product-selection-label": "Confirm",
        "ss_builder_confirm_panel_edit_text_block": "Confirm",
        "ss_builder_confirm_replace_theme_template_btn_label": "Apply sample data",
        "ss_builder_confirm_replace_theme_template_content": "This action cannot be undone.\nPlease confirm that you understand that applying sample content will replace all data existing on the site.",
        "ss_builder_confirm_replace_theme_template_input_placeholder": "OK",
        "ss_builder_confirm_replace_theme_template_label_enter_ok": "Enter \u201COK\u201D to confirm",
        "ss_builder_confirm_replace_theme_template_understood": "I understood",
        "ss_builder_confirm_replace_theme_template_warining": "Warning",
        "ss_builder_confirm_restore_theme_label": "Restore editing",
        "ss_builder_confirm_set_default_tab_label": "Set default",
        "ss_builder_confirm_show_product_btn_label": "Confirm to show",
        "ss_builder_confirm_theme_template_preview_mode_btn_label": "Apply",
        "ss_builder_confirm_to_edit_label": "Continue editing",
        "ss_builder_content_1_introduction_service": "Brand Gift gathers hot deals & promotions from Brands to end users. Creators could receive attractive bonuses from Brands by bringing these deals to their followers",
        "ss_builder_content_2_introduction_service": "Turn on Brand Gift feature now to earn more",
        "ss_builder_content_creators_joined_the_passio_system": "100K+ content creators joined the Passio eco-system",
        "ss_builder_content_editor_title": "Content",
        "ss_builder_content_list_1_introduction_service": "Base Commission",
        "ss_builder_content_list_2_introduction_service": "Brand Bonus (up to 30%)",
        "ss_builder_content_list_3_introduction_service": "More than 500+ Brands from various categories with high Brand Bonus",
        "ss_builder_continue_add_brand_gift": "Discover now",
        "ss_builder_continue_edit_block_label": "Continue edititing",
        "ss_builder_continue_edit_image_popup_image_label": "Cancel",
        "ss_builder_continue_to_add_block": "Continue",
        "ss_builder_convert_and_go_to_new_version": "Sync data and go to Passio Page",
        "ss_builder_cover_image": "Cover image",
        "ss_builder_create_bio_page_free_fast": "Create Bio Page for free & fast",
        "ss_builder_create_link_with_your_name_and_imprint": "Create a bio page with your name and imprint. Theme store with many theme categories, can be easily customized right on the phone.",
        "ss_builder_create_new_theme_template_label": "Create a new theme template",
        "ss_builder_create_template": "Create template",
        "ss_builder_cusom": "Custom",
        "ss_builder_custom": "Custom",
        "ss_builder_dashed_type_label": "Dashed",
        "ss_builder_data_auto_convert": "Your old data will be sync from your old Landing Page to new Passio Page automatically",
        "ss_builder_data_can_be_convert": "You can sync the data from your old Landing Page to new Passio Page",
        "ss_builder_data_will_be_override": "Warning: the data on Passio Page will be override if you sync the data",
        "ss_builder_deep_blue_sky": "Over the horizon comes the break of dawn",
        "ss_builder_default_meta_description": "Passio Page - Home of {{creator_name}}",
        "ss_builder_defaults_label": "Default",
        "ss_builder_delete_block_label": "Delete block",
        "ss_builder_delete_block_successfully_label": "Delete block successfully",
        "ss_builder_delete_card_label": "Delete card",
        "ss_builder_delete_card_successfully_label": "Delete card successfully",
        "ss_builder_delete_image_label": "Delete image",
        "ss_builder_delete_image_successfully_label": "Delete image successfully",
        "ss_builder_delete_item_checkbox_button_multi_link_successfully_label": "Delete links successfully",
        "ss_builder_delete_item_checkbox_card_successfully_label": "Delete cards successfully",
        "ss_builder_delete_item_checkbox_combined_successfully_label": "Delete block successfully",
        "ss_builder_delete_item_checkbox_image_gallery_successfully_label": "Delete gallery images successfully",
        "ss_builder_delete_item_checkbox_story_successfully_label": "Delete spotlights successfully",
        "ss_builder_delete_link_label": "Delete link",
        "ss_builder_delete_link_successfully_label": "Delete link successfully",
        "ss_builder_delete_product_group_error_btn_confirm_label": "Close",
        "ss_builder_delete_product_group_error_content": 'Group "{{group_name}}" cannot be deleted, a minimum of 1 group is required.',
        "ss_builder_delete_product_group_error_title": "Error deleting group",
        "ss_builder_delete_product_group_label": "Delete group",
        "ss_builder_delete_product_group_successfully_label": "Delete product group successfully",
        "ss_builder_delete_product_label": "Delete product",
        "ss_builder_delete_product_successfully_label": "Delete product successfully",
        "ss_builder_delete_social_link_btn_label": "Confirm delete",
        "ss_builder_delete_social_link_label": "Delete",
        "ss_builder_delete_social_link_successfully_label": "Delete social network successfully",
        "ss_builder_delete_tab_content": 'Tab "{{tab_name}}" and all data of the blocks inside will be permanently deleted. Are you sure you want to delete?',
        "ss_builder_delete_tab_label": "Delete",
        "ss_builder_delete_tab_successfully_label": "Delete tab successfully",
        "ss_builder_delete_tab_title": "Do you want to delete tab?",
        "ss_builder_delete_template_successfully_label": "Delete template successfully",
        "ss_builder_delete_theme_template_label": "Delete",
        "ss_builder_delete_theme_template_successfully_label": "Delete theme template successfully",
        "ss_builder_description": "Description",
        "ss_builder_description_page_builder": "Build a Bio Site in 1 click and start earning money",
        "ss_builder_description_replace_template_content": "Apply theme sample data will use content from theme template to replace for all the content of your site",
        "ss_builder_design_group_floating_title": "Floating icons",
        "ss_builder_design_group_image_popup_title": "Popup",
        "ss_builder_design_label": "Design",
        "ss_builder_dialog_error_confirm_text": "Refresh",
        "ss_builder_dialog_error_content": "There have been changes from another device. You need to refresh page.",
        "ss_builder_dialog_error_title": "There is an update on your site",
        "ss_builder_digital_product_free_label": "Free",
        "ss_builder_digital_product_list_title": "Product list",
        "ss_builder_direction_of_background_image_label": "Background image position",
        "ss_builder_disable_block_successfully_label": "Hide block successfully",
        "ss_builder_disable_image_successfully_label": "Hide photo successfully",
        "ss_builder_disable_item_checkbox_button_multi_link_successfully_label": "Hide links successfully",
        "ss_builder_disable_item_checkbox_card_successfully_label": "Hide cards successfully",
        "ss_builder_disable_item_checkbox_combined_successfully_label": "Hide block successfully",
        "ss_builder_disable_item_checkbox_image_gallery_successfully_label": "Hide gallery images successfully",
        "ss_builder_disable_item_checkbox_story_successfully_label": "Hide spotlights successfully",
        "ss_builder_disable_product_group_successfully_label": "Hide product group successfully",
        "ss_builder_disable_product_successfully_label": "Hide product successfully",
        "ss_builder_disable_social_link_successfully_label": "Hide social link successfully",
        "ss_builder_disable_tab_successfully_label": "Hide tab successfully",
        "ss_builder_disable_theme_successfully_label": "Hide template successfully",
        "ss_builder_discover_now": "Discover now",
        "ss_builder_distance_blocks": "Space between blocks",
        "ss_builder_divider_color_label": "Divider color",
        "ss_builder_divider_image_label": "Divider image",
        "ss_builder_divider_label": "Divider",
        "ss_builder_divider_thickness_label": "Thickness (px)",
        "ss_builder_do_you_want_replace_sample_content": "Do you want to apply theme sample data?",
        "ss_builder_domain_site_setting_alert_infomation": "If you change your domain name, you will have to wait 30 days for the next change",
        "ss_builder_domain_site_setting_rule": "Start with a letter, contain only numbers and letters",
        "ss_builder_done_panel": "Done",
        "ss_builder_dont_add_block_from_template_description": "Unable to add {{number_block}} blocks from the template due to the 10 block limit in the list. Please delete the existing block to add new template blocks.",
        "ss_builder_dont_add_block_from_template_title": "Unable to add block",
        "ss_builder_dont_add_product_exist_at_add_new_content": "The product is already in the list",
        "ss_builder_dont_add_product_exist_at_list_content": 'The product you want to add is already in the product group "{{group_name}}".',
        "ss_builder_dont_add_same_affiliate_product_confirm_label": "Confirm",
        "ss_builder_dont_add_same_affiliate_product_modal_label": "Unable to add new product",
        "ss_builder_dont_apply_template_content_modal_description": "Applying template cannot be performed because the template no longer exists.",
        "ss_builder_dont_apply_theme_content_modal_btn_confirm_label": "Close",
        "ss_builder_dont_apply_theme_content_modal_description": "Application of sample data cannot be performed because the theme template no longer exists in the theme store.",
        "ss_builder_dont_apply_theme_content_modal_label": "Could not apply",
        "ss_builder_dot_strokes_type_label": "Dotted",
        "ss_builder_dp_title_intro": "Digital products",
        "ss_builder_drop_here_label": "Add block here",
        "ss_builder_duplicated_product_url_label": "Duplicated link",
        "ss_builder_duplicated_theme_template_name_warning": "Theme template name already exists. Please enter another name!",
        "ss_builder_earn_additional_commissions_label": "Earn additional commissions when using Passio's affiliate links",
        "ss_builder_edit_affiliate_product_group_title": "Group name",
        "ss_builder_edit_affiliate_product_title": "Edit product",
        "ss_builder_edit_block_label": "Edit",
        "ss_builder_edit_block_successfully_label": "Edit block successfully",
        "ss_builder_edit_image_of_image_popup_title": "Edit image popup",
        "ss_builder_edit_name_affiliate_product_group_title": "Change product group name",
        "ss_builder_edit_name_block_successfully_label": "Update block name successfully",
        "ss_builder_edit_product_group_label": "Change group name",
        "ss_builder_edit_tab_label": "Rename",
        "ss_builder_edit_tab_successfully_label": "Update tab successfully",
        "ss_builder_edit_template_btn_label": "Save",
        "ss_builder_edit_template_title": "Edit template",
        "ss_builder_edit_text_block_label": "Block name",
        "ss_builder_edit_theme_btn_label": "Save",
        "ss_builder_edit_theme_template_label": "Edit information",
        "ss_builder_edit_theme_template_successfully_label": "Update theme template successfully",
        "ss_builder_edit_theme_template_title": "Edit theme template info",
        "ss_builder_editor_btn-add-more": "Add",
        "ss_builder_editor_btn-cancel": "Cancel",
        "ss_builder_editor_btn-save": "Save",
        "ss_builder_email_placeholder": "Enter email",
        "ss_builder_embed_code_label": "Embed code",
        "ss_builder_embed_code_placeholder": "Please enter the embed code",
        "ss_builder_empty_block": "No block",
        "ss_builder_empty_search": "No results found",
        "ss_builder_empty_social_link_list_content": "To add a social network please press the \u201CAdd\u201D button above",
        "ss_builder_empty_social_link_list_title": "No social link added yet",
        "ss_builder_empty_template_label": "No block template",
        "ss_builder_enable_block_successfully_label": "Show block successfully",
        "ss_builder_enable_border": "Enable",
        "ss_builder_enable_button_border": "Enable border",
        "ss_builder_enable_image_successfully_label": "Show image successfully",
        "ss_builder_enable_item_checkbox_button_multi_link_successfully_label": "Show links successfully",
        "ss_builder_enable_item_checkbox_card_successfully_label": "Show cards successfully",
        "ss_builder_enable_item_checkbox_combined_successfully_label": "Show block successfully",
        "ss_builder_enable_item_checkbox_image_gallery_successfully_label": "Show gallery images successfully",
        "ss_builder_enable_item_checkbox_story_successfully_label": "Show spotlights successfully",
        "ss_builder_enable_product_group_successfully_label": "Show product group successfully",
        "ss_builder_enable_product_successfully_label": "Show product successfully",
        "ss_builder_enable_shadow": "Enable",
        "ss_builder_enable_social_link_successfully_label": "Show social link successfully",
        "ss_builder_enable_tab_successfully_label": "Show tab successfully",
        "ss_builder_enable_theme_successfully_label": "Show template successfully",
        "ss_builder_enable_tracking_link_product_label": "Enable tracking link",
        "ss_builder_enable_tracking_link_product_successfully_label": "Enable tracking link successfully",
        "ss_builder_enter_domain_site_setting_label": "Custom subdomain",
        "ss_builder_enter_font_name": "Enter font name",
        "ss_builder_enter_url_label": "Enter URL",
        "ss_builder_enter_your_url": "Enter your url",
        "ss_builder_error_block_label": "Error block",
        "ss_builder_error_invalid_email_message": "Invalid email",
        "ss_builder_error_invalid_phone_message": "Invalid phone number",
        "ss_builder_error_network_confirm_btn_label": "Close",
        "ss_builder_error_network_content": "The system is overloaded. Please try again.",
        "ss_builder_error_network_title": "System overload",
        "ss_builder_error_page_title": "Passio Page Builder - {{country}} - Error Page",
        "ss_builder_exceeding_label": "Exceed max blocks",
        "ss_builder_existed_product_group_label": "The group already exists",
        "ss_builder_expand": "See more",
        "ss_builder_expand_introduction_description": '"Extended Position" contains Blocks that do not have a fixed postion on the site. Eg: Popup, Floating Icons',
        "ss_builder_expand_introduction_title": "Extended Position",
        "ss_builder_filter_select_combined_count": "selected block(s)",
        "ss_builder_filter_select_multi_items": "last {{num_items}}",
        "ss_builder_filter_select_multi_items_card_count": "selected cards",
        "ss_builder_filter_select_multi_items_gallery_count": "selected images",
        "ss_builder_filter_select_multi_items_multi_links_count": "selected links",
        "ss_builder_filter_select_multi_items_spotlight_count": "selected spotlights",
        "ss_builder_first_guide_add_block_btn_title": "Add Block",
        "ss_builder_first_guide_add_block_description": 'Click or Drag & Drop "Add Block" button to the desired position to add a new Block to your site. Many Block types ready to add to your site, help you create beautiful, multi-purpose bio page. Let\'s explore!',
        "ss_builder_first_guide_add_block_title": "Add Block button",
        "ss_builder_first_guide_preview_btn_title": "Preview site",
        "ss_builder_first_guide_preview_description": "Preview the site to see the current changes of the site. Publish should only be made once you have previewed and are satisfied with the changes.",
        "ss_builder_first_guide_preview_title": "Preview site button",
        "ss_builder_first_guide_publish_btn_title": "Publish",
        "ss_builder_first_guide_publish_description": 'Design edits are always in "Draft" mode. The changes will be visible to your Fans once you decide to "Publish".',
        "ss_builder_first_guide_publish_title": "Publish site button",
        "ss_builder_floating_full": "Only able to add two blocks in Floating icons group",
        "ss_builder_floating_introduction_description": "Blocks inside this position will be floating displayed at the bottom/right of screen. Always display to easy access.",
        "ss_builder_floating_introduction_title": "Floating icons",
        "ss_builder_font_name_not_exist": "Font does not exist",
        "ss_builder_font_option_panel_title": "Font type",
        "ss_builder_footer_description": "These blocks will appear in all Tabs",
        "ss_builder_footer_introduction_description": "\u201CFooter\u201D contains Blocks, which always appear at the bottom of the page. For example: quick links, page info...",
        "ss_builder_footer_introduction_title": "Footer Position",
        "ss_builder_footer_title": "Footer",
        "ss_builder_frame_aff": "Product image frame",
        "ss_builder_general_setting_title": "General Setting",
        "ss_builder_generate_income_from_your_own_fan_community": "Generate income from your own fan community!",
        "ss_builder_gift_warning": "Only able to add one block",
        "ss_builder_go_back_to_site": "Go back to site",
        "ss_builder_google_font": "Google Fonts",
        "ss_builder_gradient": "Gradient",
        "ss_builder_group_is_full_of_product_modal_description": "The product group you selected is full. Please choose another group.",
        "ss_builder_group_is_full_of_product_modal_title": "Couldn't add",
        "ss_builder_group_is_hiding_label": "Hidden product group",
        "ss_builder_hard_shadow": "Hard shadow",
        "ss_builder_header_description": "These blocks will appear in all Tabs",
        "ss_builder_header_introduction_description": "\u201CHeader\u201D contains Blocks, which always appear at the top of the page. For example: Avatar image, introduction...",
        "ss_builder_header_introduction_title": "Header Position",
        "ss_builder_header_title": "Header",
        "ss_builder_heading_and_subtitle_site_setting_label": "Site title and description",
        "ss_builder_heading_site_setting_description": "Shown by search engines in their preview of your page. This is important for both SEO and social sharing.",
        "ss_builder_heading_site_setting_label": "Site title",
        "ss_builder_hide_block_label": "Hide block",
        "ss_builder_hide_card_label": "Hide card",
        "ss_builder_hide_card_successfully_label": "Hide card successfully",
        "ss_builder_hide_image_label": "Hide image",
        "ss_builder_hide_link_label": "Hide link",
        "ss_builder_hide_link_successfully_label": "Hide link successfully",
        "ss_builder_hide_product_group_error_btn_confirm_label": "Close",
        "ss_builder_hide_product_group_error_content": 'Group "{{group_name}}" cannot be hidden, need to show at least 1 group.',
        "ss_builder_hide_product_group_error_title": "Error hiding group",
        "ss_builder_hide_product_group_label": "Hide group",
        "ss_builder_hide_product_label": "Hide product",
        "ss_builder_hide_social_link_label": "Hide",
        "ss_builder_hide_tab_label": "Hide Tab",
        "ss_builder_hide_template_successfully_label": "Hide template successfully",
        "ss_builder_hide_theme_template_label": "Hide template",
        "ss_builder_hightlight_block_label": "Featured",
        "ss_builder_icon_tab_title": "Icon",
        "ss_builder_if_delete": "If you delete this Affiliate block",
        "ss_builder_image": "Image",
        "ss_builder_image_description_place_holder": "Enter content",
        "ss_builder_image_gallery": "Image gallery",
        "ss_builder_image_list_empty_content": "To add photos please press the \u201CAdd\u201D button above",
        "ss_builder_image_list_empty_title": "The image list is empty",
        "ss_builder_image_orientation": "Image orientation",
        "ss_builder_image_orientation_label": "Image orientation",
        "ss_builder_image_popup_introduction_description": "Blocks inside this position will show up as a popup when Fans view your site. Popup could be used to display important messages, call to action, advertising banner...",
        "ss_builder_image_popup_introduction_title": "Popup",
        "ss_builder_image_popup_warning": "You can add only one block of this type per page",
        "ss_builder_image_ratio_title": "Image ratio",
        "ss_builder_image_selection_label": "Select image",
        "ss_builder_image_slider_arrow_switch_title": "Arrow",
        "ss_builder_image_slider_auto_play_switch_title": "Auto play",
        "ss_builder_image_slider_dot_switch_title": "Dot slider",
        "ss_builder_image_slider_list_title": "Image list",
        "ss_builder_image_slider_ratio_selected_title": "Image ratio",
        "ss_builder_image_title_place_holder": "Enter content",
        "ss_builder_import_multi_product_url_popover_content": "You can enter one or multi urls. Each url per line.",
        "ss_builder_import_site_url_label": "Import products from URL",
        "ss_builder_import_site_url_modal_button_label": "Import products",
        "ss_builder_import_site_url_modal_description": "Enter the site url to import, support: koc.asia, mycollection.shop, linktr.ee, msha.ke",
        "ss_builder_import_site_url_modal_title": "Product page URL",
        "ss_builder_in_block_delete_forever_are_you_sure": "will be deleted permanently. Are you sure you want to delete?",
        "ss_builder_information_handler_alert": "Processing information. Please wait a moment.",
        "ss_builder_inner_space": "Block's padding",
        "ss_builder_intro_brand_gift_floating_continue": "Add now",
        "ss_builder_intro_brand_gift_floating_description": "Add Brand Gift icon now to help followers hunt deals at the low price",
        "ss_builder_intro_brand_gift_floating_reject": "Cancel",
        "ss_builder_intro_brand_gift_floating_title": "Double your income with Brand Gift Floating Icon",
        "ss_builder_intro_brand_rating_floating_description": "en_Th\xeam t\xednh n\u0103ng ngay \u0111\u1EC3 gi\xfap Fan s\u0103n deal th\xe0nh c\xf4ng v\xe0 t\u0103ng thu nh\u1EADp",
        "ss_builder_intro_brand_rating_floating_title": "en_Brand Ratings",
        "ss_builder_introduce_double_tap_button": "Continue editing",
        "ss_builder_introduce_double_tap_content": "In addition to selecting \u201CEdit\u201D in each block, you can double-click the block directly to edit it",
        "ss_builder_introduce_double_tap_label_check": "Do not show again",
        "ss_builder_introduce_double_tap_title": "Block editing tips",
        "ss_builder_invalid_product_url_label": "Invalid link",
        "ss_builder_invalid_url": "Invalid Url",
        "ss_builder_items_per_row": "Number of items per row",
        "ss_builder_keep_the_content": "Keep the content",
        "ss_builder_landscape_image_orientation_label": "Landscape orientation",
        "ss_builder_limit_reached": "Limit reached",
        "ss_builder_link_additional_btn_label": "Add Link",
        "ss_builder_link_select_service": "Choose a service",
        "ss_builder_link_text_left_layout": "Text on the left",
        "ss_builder_link_text_right_layout": "Text on the right",
        "ss_builder_link_text_under_layout": "Text below",
        "ss_builder_link_text_zig_zag_layout": "Zig Zag",
        "ss_builder_link_type_email": "Email",
        "ss_builder_link_type_phone": "Telephone",
        "ss_builder_link_type_service": "Service",
        "ss_builder_link_type_tel": "Tel",
        "ss_builder_link_type_web": "Web",
        "ss_builder_link_url": "Link Url",
        "ss_builder_list_button_multi_link_label": "List",
        "ss_builder_list_card_empty_content": "To add cards please press the button above to add",
        "ss_builder_list_card_empty_title": "No cards have been added yet",
        "ss_builder_list_card_label": "List card",
        "ss_builder_list_image_popup_title": "Image popup list",
        "ss_builder_list_label": "List",
        "ss_builder_list_link_empty_content": "To add a new link, please click the button above to add",
        "ss_builder_list_link_empty_title": "No links have been added yet",
        "ss_builder_list_title_digital_product": "List",
        "ss_builder_loading_label": "Loading",
        "ss_builder_malformed_domain_warning": "Invalid domain name",
        "ss_builder_malformed_embed_code_warning": "Invalid embed code",
        "ss_builder_manage_block_description": "Ss Builder Manage Block Description",
        "ss_builder_manage_block_title": "Blocks management",
        "ss_builder_manage_tab_description": "Tabs are used to divide list of block and navigate on the page into multi parts",
        "ss_builder_manage_tab_title": "Tab management",
        "ss_builder_management_digital_product_description": "List of your digital products",
        "ss_builder_management_digital_product_title": "Digital Product",
        "ss_builder_management_label": "Management",
        "ss_builder_medium": "Medium",
        "ss_builder_missing_required_product_url_label": "Missing required information",
        "ss_builder_modal_button_close": "Close",
        "ss_builder_move_block_successfully_label": "Move block successfully",
        "ss_builder_move_down_block_label": "Move down",
        "ss_builder_move_product_label": "Move to",
        "ss_builder_move_product_quantity_to_group_alert_label": "Move {{product_quantity}} products to",
        "ss_builder_move_product_successfully_label": "Move product successfully",
        "ss_builder_move_to_bottom_label": "Move to the bottom",
        "ss_builder_move_to_top_label": "Move to the top",
        "ss_builder_move_up_block_label": "Move up",
        "ss_builder_multi_product_url_imported_label": "Imported {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} links",
        "ss_builder_multi_product_url_importing_label": "Importing {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} links",
        "ss_builder_name_tab_input_title": "Tab name",
        "ss_builder_need_to_display_at_least_one_block": "Need to display at least one block",
        "ss_builder_need_to_display_at_least_one_card": "Need to display at least one card",
        "ss_builder_need_to_display_at_least_one_image": "Need to display at least one image",
        "ss_builder_need_to_display_at_least_one_link": "Need to display at least one link",
        "ss_builder_need_to_display_at_least_one_spotlight": "Need to display at least one spotlight",
        "ss_builder_next": "Next",
        "ss_builder_no_image_selected": "Empty list",
        "ss_builder_no_photo_has_been_selected": "No photos have been selected yet",
        "ss_builder_no_shadow": "No shadow",
        "ss_builder_no_themes_found_theme_store": "No themes found",
        "ss_builder_none_of_image_description": 'Click "Add" button to add image popup',
        "ss_builder_none_of_image_popup_alert": "No image popup",
        "ss_builder_not_add_yet_product_url_label": "Link has not been added",
        "ss_builder_not_enough_space_product_group_modal_content": "The product group you've selected does not have enough space to accommodate {{num_products}} products in the additional product list. Please remove the some products from the add list or choose another group.",
        "ss_builder_not_enough_space_product_group_modal_title": "Unable to select group",
        "ss_builder_notes": "Describe your incident in detail",
        "ss_builder_off": "Off",
        "ss_builder_on": "On",
        "ss_builder_onboarding_choose_a_suitable_theme": "Choose a suitable theme, which you can customize after applying\u2728",
        "ss_builder_onboarding_choose_the_look_for_you": "Choose a theme that's suite for you!",
        "ss_builder_onboarding_create_a_personal_page": "Create a bio page, run Affiliate Marketing, Booking, Donation, Sell digital products (documents, images, videos, presentations,...)",
        "ss_builder_onboarding_no_need_know_technology": "No need to know about technology, it is still easy to use the toolkit to create a bio page.",
        "ss_builder_onboarding_theme_store_template": "Theme store",
        "ss_builder_open_browser_label": "Open in Browser",
        "ss_builder_open_link_in_new_tab": "Open link in new tab",
        "ss_builder_open_link_in_new_tab_description": "Open link in new tab",
        "ss_builder_open_new_tab_description": "Uncheck to open link in current site. Check to open link in new window",
        "ss_builder_open_new_tab_label": "Open link in new window",
        "ss_builder_optional_color_panel_label": "Optional color",
        "ss_builder_overwrite_description": "Overwriting will replace all settings of the selected template",
        "ss_builder_overwrite_template_btn_label": "Overwrite",
        "ss_builder_overwrite_template_successfully_label": "Overwrite template successfully",
        "ss_builder_overwrite_template_title": "Overwrite template",
        "ss_builder_overwrite_theme_btn_label": "Overwrite",
        "ss_builder_overwrite_theme_template_successfully_label": "Overwrite theme template successfully",
        "ss_builder_overwrite_theme_template_title": "Overwrite theme template",
        "ss_builder_overwrite_title": "Do you want to overwrite?",
        "ss_builder_panel_add_icon_tab_title": "Select an icon",
        "ss_builder_panel_add_new_tab_title": "Tab infomation",
        "ss_builder_panel_edit_text_block_title": "Edit block name",
        "ss_builder_panel_search_label": "Search...",
        "ss_builder_panel_title": "Select block type",
        "ss_builder_paragraph_setting_font_available": "Avaiable fonts",
        "ss_builder_paragraph_setting_font_custom": "Custom font",
        "ss_builder_paragraph_setting_option": "Font option",
        "ss_builder_paragraph_setting_title": "Paragraph Settings",
        "ss_builder_partial_visible_slide_type_1": "Partial visible on right",
        "ss_builder_partial_visible_slide_type_2": "Partial visible on both sides",
        "ss_builder_partial_visible_slide_type_3": "Not partial visible",
        "ss_builder_partial_visible_slide_type_4": "Posters",
        "ss_builder_partial_visible_slide_type_5": "Panorama",
        "ss_builder_passio_page_ready": "Passio Page is ready",
        "ss_builder_passio_page_ready_description": "Passio page is ready to use and replace the old Landing Page version",
        "ss_builder_passio_premium": "Passio Premium",
        "ss_builder_personal_link_coppy_label": "Copy",
        "ss_builder_personal_link_coppy_successfully_label": "Coppied",
        "ss_builder_personal_link_sharing_title": "Share your site",
        "ss_builder_personal_link_title": "Your site url",
        "ss_builder_phone_placeholder": "Enter phone number",
        "ss_builder_placeholder_affiliate_product_enter_product_name": "Enter product name",
        "ss_builder_placeholder_dragging_content": "Drop it here",
        "ss_builder_please_wait_for_the_product_to_be_updated": "Let's wait for the products to be updated",
        "ss_builder_popover_manual_button": "Get Started",
        "ss_builder_popover_manual_button_close": "Close",
        "ss_builder_popover_manual_content": "For a tutorial on how to use the design feature, please press the \u201CGet Started\u201D button.",
        "ss_builder_popover_manual_title": "User manual",
        "ss_builder_popover_review_manual_content": "You can review the user guide at any time, by clicking this help button.",
        "ss_builder_popular_font_families": "Popular font families",
        "ss_builder_popup_confirm_button": "Confirm",
        "ss_builder_popup_management_title": "Management",
        "ss_builder_portrait_image_orientation_label": "Portrait orientation",
        "ss_builder_position_ghim_tab_selection_label": "Position",
        "ss_builder_powered_by_passio": "Powered by Ecomobi",
        "ss_builder_preview": "Preview",
        "ss_builder_preview_image_label": "Preview",
        "ss_builder_preview_theme_template_title": "Preview image",
        "ss_builder_product_design_empty_description": "Please wait for the product to be updated",
        "ss_builder_product_design_empty_title": "No products",
        "ss_builder_product_detect_link_malformed_error": "Link format is invalid",
        "ss_builder_product_detect_link_placeholder": "Enter link of product",
        "ss_builder_product_detect_link_title": "Link to product",
        "ss_builder_product_empty_searching_description": "Please try with another keyword",
        "ss_builder_product_empty_searching_title": "No results found",
        "ss_builder_product_exceeding_allowed_amount_content": "To add new product, please remove some existing products",
        "ss_builder_product_exceeding_allowed_amount_title": "Number of products reach the limitation",
        "ss_builder_product_group_add_new_btn_label": "Add the product group",
        "ss_builder_product_group_default_title": "Products",
        "ss_builder_product_group_limitation_warning_description": "The total number of products in the group has been reached the limit of {{max_products}} products. Please delete existing products if you want to add new ones.",
        "ss_builder_product_group_selection_placeholder": "Please select product group",
        "ss_builder_product_group_selection_title": "Select affiliate product group",
        "ss_builder_product_group_total_limitation_warning_content": "The total number of groups has reached the {{group_quantity_maximum}} group limit. Please delete the existing group if you want to add a new one.",
        "ss_builder_product_group_total_limitation_warning_title": "Couldn't add new product group",
        "ss_builder_product_is_hiding_label": "Hidden product",
        "ss_builder_product_link_wrapped_label": "Wrapped link",
        "ss_builder_product_list_style_grid_label": "Grid",
        "ss_builder_product_list_style_grid_one_label": "1 product",
        "ss_builder_product_list_style_grid_three_label": "3 products",
        "ss_builder_product_list_style_grid_two_label": "2 products",
        "ss_builder_product_list_style_slide_label": "Slide",
        "ss_builder_product_list_style_text_over_image_label": "Text over image",
        "ss_builder_product_list_style_zig_zag_label": "Zigzag",
        "ss_builder_product_searching_description": "Please enter product name to search",
        "ss_builder_product_searching_title": "Search product",
        "ss_builder_product_selection_option_1": "Last 10",
        "ss_builder_product_selection_option_2": "Last 20",
        "ss_builder_product_selection_option_3": "Last 50",
        "ss_builder_product_selection_option_4": "Last 5",
        "ss_builder_product_swiper_see_all": "See all",
        "ss_builder_product_title_error": "Missing product name",
        "ss_builder_product_title_missing_warning": "Enter product name",
        "ss_builder_product_total_limitation_warning_description": "The total number of products in the entire product group has been reached the limit of {{max_products_all_groups}} products. Please delete some existing products if you want to add new ones.",
        "ss_builder_product_total_limitation_warning_title": "Couldn't add new product",
        "ss_builder_product_tour_button_step_0": "Get started",
        "ss_builder_product_tour_content_step_0": "Start by following our tutuorial to experience the exciting features of Passio Page!",
        "ss_builder_product_tour_content_step_1": "Get creative with the Design screen. Easily to edit and arrange Blocks according to your own style.",
        "ss_builder_product_tour_content_step_10": "Replace your entire page content with exactly the same content of the applicable theme template. Make your page content exactly like the template.",
        "ss_builder_product_tour_content_step_11": "Preview the site to see the current changes of the site. Publish should only be made once you have previewed and are satisfied with the changes.",
        "ss_builder_product_tour_content_step_12": "By holding and dragging to move or use \u201CQuick actions\u201D to move up/down a block.",
        "ss_builder_product_tour_content_step_13": "Select \u201CEdit\u201D under \u201CQuick Actions\u201D or tap the block directly to edit.",
        "ss_builder_product_tour_content_step_14": "Quickly change the background with a picture, solid color or gradient color with full of personality.",
        "ss_builder_product_tour_content_step_15": "Many diverse, beautiful and trending theme template for you to freely choose and use.",
        "ss_builder_product_tour_content_step_16": "Advanced settings help fine-tune the theme design, change the domain name, personal brand,...",
        "ss_builder_product_tour_content_step_17": "You can re-running this product tour at any time, by clicking this help button.",
        "ss_builder_product_tour_content_step_2": "Many Block types ready to add to your site, help you create beautiful, multi-purpose bio page. Click or Drag & Drop this button to the desired position to add a new Block. Let's explore!",
        "ss_builder_product_tour_content_step_3": "Editing and more options of each block, allowing you to customize the block as you like.",
        "ss_builder_product_tour_content_step_4": 'Design edits are always in "Draft" mode. The changes will be visible to your Fans once you decide to "Publish".',
        "ss_builder_product_tour_content_step_5": "Tabs are used to organize the \u201CBody\u201D content in sections, eg: Products Tab, Videos Tab, Coupons Tab,... Click on each Tab to view and change the content inside. Edit this block to add new, manage Tabs.",
        "ss_builder_product_tour_content_step_6": "\u201CHeader\u201D contains Blocks, which always appear at the top of the page. For example: Avatar image, introduction...",
        "ss_builder_product_tour_content_step_7": '"Body" is the main area of the site, contains the Blocks and is divided, navigated by Tabs. For example: content, images, products, ...',
        "ss_builder_product_tour_content_step_8": "\u201CFooter\u201D contains Blocks, which always appear at the bottom of the page. For example: quick links, page info...",
        "ss_builder_product_tour_content_step_9": "Use this feature, if the changes you made do not satisfy you. The system will restore your Design screen back to the site version that was publishing.",
        "ss_builder_product_tour_done_label": "Done",
        "ss_builder_product_tour_next_label": "Next",
        "ss_builder_product_tour_prev_label": "Previous",
        "ss_builder_product_tour_skip_label": "Skip",
        "ss_builder_product_tour_title_step_0": "Welcome to Passio Page",
        "ss_builder_product_tour_title_step_1": "Design the theme",
        "ss_builder_product_tour_title_step_10": "Apply sample content",
        "ss_builder_product_tour_title_step_11": "Preview site",
        "ss_builder_product_tour_title_step_12": "Move a Block",
        "ss_builder_product_tour_title_step_13": "Edit a Block",
        "ss_builder_product_tour_title_step_14": "Change the background",
        "ss_builder_product_tour_title_step_15": "Theme store",
        "ss_builder_product_tour_title_step_16": "Advanced settings",
        "ss_builder_product_tour_title_step_17": "Product tour",
        "ss_builder_product_tour_title_step_2": "Add a new Block",
        "ss_builder_product_tour_title_step_3": "Quick Actions",
        "ss_builder_product_tour_title_step_4": "Publish design",
        "ss_builder_product_tour_title_step_5": "Tab menu",
        "ss_builder_product_tour_title_step_6": "Header",
        "ss_builder_product_tour_title_step_7": "Body",
        "ss_builder_product_tour_title_step_8": "Footer",
        "ss_builder_product_tour_title_step_9": "Restore editing",
        "ss_builder_product_tour_use_manual": "Product tour",
        "ss_builder_product_tour_use_manual_content": "Get to know how to use the Design screen, let's press the \u201CGet Started\u201D button.",
        "ss_builder_product_url_lists_label": "Link list",
        "ss_builder_publish_button_label": "Publish",
        "ss_builder_publish_result_description": "You have successfully publish Passio Page.\nYour page is accessible via url below.",
        "ss_builder_publish_result_successfully": "Publish theme successfully!",
        "ss_builder_publish_result_title": "Publishing result",
        "ss_builder_publish_saving": "Saving",
        "ss_builder_publish_share": "Share",
        "ss_builder_publish_view_page": "View site",
        "ss_builder_randomize": "Randomize",
        "ss_builder_ready_to_build_your_personal_brand": "Ready to build your personal brand with Passio now \uD83D\uDC96",
        "ss_builder_recently_color_panel_label": "Recently used colors",
        "ss_builder_redo_theme_label": "Redo",
        "ss_builder_reload_label": "Refresh",
        "ss_builder_replace": "replace",
        "ss_builder_replace_preview_theme_template_btn_label": "Apply",
        "ss_builder_replace_theme_label": "Apply sample content",
        "ss_builder_replace_theme_modal_content": "Apply theme template content will replace all blocks in your site by blocks from Theme Template",
        "ss_builder_replace_theme_modal_title": "Do you want to apply theme sample data?",
        "ss_builder_replace_theme_template_successfully_label": "Apply successfully",
        "ss_builder_report_sent_report_successfully": "Report sent successfully",
        "ss_builder_report_sent_report_successfully_description": "Thank you! A troubleshooting report has been sent to support",
        "ss_builder_restore_theme_content": "All theme settings and data of blocks inside the theme will be restored to published theme. Do you want to continue?",
        "ss_builder_restore_theme_label": "Restore editing",
        "ss_builder_restore_theme_successfully_label": "Successfully restored editing",
        "ss_builder_restore_theme_title": "Do you want to restore edits?",
        "ss_builder_revenue_group_description": "Start earning money now with Passio Page services",
        "ss_builder_revenue_title": "Monetization",
        "ss_builder_round_photo_label": "Rounded photo",
        "ss_builder_rounded": "Rounded",
        "ss_builder_sample_change_label": "Change template",
        "ss_builder_sample_selection_label": "Select a style",
        "ss_builder_sampling_change_label": "Select template",
        "ss_builder_save": "Save",
        "ss_builder_save_new_template_title": "Save as new template",
        "ss_builder_save_new_theme_template_successfully_label": "Save new theme successfully",
        "ss_builder_save_new_theme_template_title": "Save new theme template",
        "ss_builder_save_succesfully_description": "Your changes have been saved.",
        "ss_builder_save_succesfully_label": "Saved successfully",
        "ss_builder_search_results_theme_store": "Search results",
        "ss_builder_search_type_block": "Search block type by name",
        "ss_builder_see_less": "See less",
        "ss_builder_see_more": "See more",
        "ss_builder_see_more_btn_default_title": "See more",
        "ss_builder_select_label": "Select",
        "ss_builder_select_link_type": "Select a link type",
        "ss_builder_select_multi_items": "Select",
        "ss_builder_select_position_add_block": "Select position to add block",
        "ss_builder_select_ratio_title": "Select a ratio",
        "ss_builder_select_theme_setting_primary_color_label": "Choose the primary color",
        "ss_builder_selected_product_in_selection_label": "selected products",
        "ss_builder_send": "Send",
        "ss_builder_send_report": "Send report",
        "ss_builder_service_placeholder": "Choose a service",
        "ss_builder_set_default_tab_disable_content": 'Default Tab will be displayed first when an user enters your page. Tab ${defaultNameTab} is hidden. Set this tab as default will change this tab status to visible. Do you want to set tab "{{tab_name}}" as default?',
        "ss_builder_set_default_tab_enable_content": 'Default Tab will be displayed first when an user enters your page. Do you want to set tab "{{tab_name}}" as default?',
        "ss_builder_set_default_tab_label": "Set default",
        "ss_builder_set_default_tab_successfully_label": "Set default successfully",
        "ss_builder_set_default_tab_title": "Confirm to set default",
        "ss_builder_setting_font_weight": "Font weight",
        "ss_builder_setting_line_height": "Line height",
        "ss_builder_setting_popover_manual_content": "Get to know how to use the Settings screen, let's press the \u201CGet Started\u201D button.",
        "ss_builder_setting_popover_manual_title": "Product tour",
        "ss_builder_setting_saving": "Saving data",
        "ss_builder_setting_text_font": "Font family",
        "ss_builder_setting_text_scale": "Scale",
        "ss_builder_setting_text_size": "Font size (px)",
        "ss_builder_setting_title": "Settings",
        "ss_builder_setting_tour_content_step_1": "This is your site URL. You can copy, open or share the page path. In addition, it is also possible to quickly edit the page's favicon and domain name.",
        "ss_builder_setting_tour_content_step_2": "You can customize the general Theme Settings here. These settings will apply to your entire site.",
        "ss_builder_setting_tour_content_step_3": "You can set up your personal branding, SEO settings, domain name for your site here.",
        "ss_builder_setting_tour_title_step_1": "Site url",
        "ss_builder_setting_tour_title_step_2": "Theme settings",
        "ss_builder_setting_tour_title_step_3": "Site settings",
        "ss_builder_settings_label": "Settings",
        "ss_builder_setup_site_setting": "Site settings",
        "ss_builder_setup_theme_setting": "Theme settings",
        "ss_builder_shadows_style": "Shadow",
        "ss_builder_shape_label": "Shape",
        "ss_builder_share_label": "Share",
        "ss_builder_show_block_label": "Show block",
        "ss_builder_show_card_label": "Show card",
        "ss_builder_show_card_successfully_label": "Show card successfully",
        "ss_builder_show_image_label": "Show image",
        "ss_builder_show_link_label": "Show link",
        "ss_builder_show_link_successfully_label": "Show successful link",
        "ss_builder_show_product_group_label": "Show group",
        "ss_builder_show_product_label": "Show product",
        "ss_builder_show_social_link_label": "Show",
        "ss_builder_show_tab_label": "Show Tab",
        "ss_builder_show_template_successfully_label": "Show template successfully",
        "ss_builder_show_theme_template_label": "Show template",
        "ss_builder_site_brand_setting_label": "Personal brand",
        "ss_builder_site_domain_setting_label": "Domain",
        "ss_builder_site_setting_browser_label": "Browser",
        "ss_builder_site_setting_coppy_label": "Copy",
        "ss_builder_site_setting_favicon_title": "Favicon",
        "ss_builder_site_setting_favicon_upload_description": "The favicon is displayed next to the page's link. Upload any one of your favorite images to make Favicon.",
        "ss_builder_site_setting_label": "Site setting",
        "ss_builder_site_setting_premium": "Premium",
        "ss_builder_site_setting_share_label": "Share",
        "ss_builder_site_setting_standard": "Standard",
        "ss_builder_site_setting_upgrade": "Upgrade",
        "ss_builder_skip": "Skip",
        "ss_builder_slide_type_label": "Slider type",
        "ss_builder_social_link_btn_add_new_label": "Add social network",
        "ss_builder_social_links_list_title": "List of social links",
        "ss_builder_social_network_label": "Social network",
        "ss_builder_soft_shadow": "Soft shadow",
        "ss_builder_solid": "Solid",
        "ss_builder_solid_type_label": "Solid",
        "ss_builder_something_went_wrong": "Sorry, something went wrong",
        "ss_builder_spacer_label": "Spacing (px)",
        "ss_builder_spotlight_list_empty_content": "To add a new spotlight please press the \u201CAdd\u201D button above",
        "ss_builder_spotlight_list_empty_title": "No spotlight has been added yet",
        "ss_builder_square": "Square",
        "ss_builder_square_photo_label": "Squared photo",
        "ss_builder_start_use_passio_page": "Start using Passio Page now",
        "ss_builder_stop_label": "Stop",
        "ss_builder_story": "Spotlight",
        "ss_builder_story_title_place_holder": "Spotlight title",
        "ss_builder_style": "Style",
        "ss_builder_style_always_ghim_tab_label": "Always sticky",
        "ss_builder_style_auto_ghim_tab_label": "Auto sticky",
        "ss_builder_style_ghim_tab_selection_label": "Tab sticky",
        "ss_builder_style_grid_label": "Grid",
        "ss_builder_style_masonry_label": "Masonry",
        "ss_builder_style_not_ghim_tab_label": "No sticky",
        "ss_builder_style_slide_label": "Slide",
        "ss_builder_style_tab_icon_label": "Icon only",
        "ss_builder_style_tab_only_icon": "Icon only",
        "ss_builder_style_tab_only_image": "Image only",
        "ss_builder_style_tab_selection_label": "Style",
        "ss_builder_style_tab_text_and_icon_label": "Text & Icon",
        "ss_builder_style_tab_text_and_image_label": "Text & image",
        "ss_builder_style_tab_text_label": "Text only",
        "ss_builder_subtitle_site_setting_description": "Gives an overview of the content and information the site has to offer. Search engines use this to display website descriptions.",
        "ss_builder_subtitle_site_setting_label": "Site description",
        "ss_builder_suggested_color_panel_label": "Suggested color palette",
        "ss_builder_support_upload_image": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, up to 30MB",
        "ss_builder_support_upload_image_v2": "Support: JPG, JPEG, GIF, PNG, BMP up to 30MB",
        "ss_builder_support_upload_large_image": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, up to 50MB",
        "ss_builder_swiper_setting_premium_description_1": "Unlimited features",
        "ss_builder_swiper_setting_premium_title_1": "Premium Account",
        "ss_builder_swiper_setting_premium_title_2": "Exclusive themes",
        "ss_builder_swiper_setting_premium_title_3": "Custom domain yourdomain.com",
        "ss_builder_swiper_setting_premium_title_4": "Exclusive brand campaign",
        "ss_builder_swiper_setting_premium_title_5": "Fast withdraw",
        "ss_builder_swiper_setting_premium_title_6": "Save 25% on platform fees",
        "ss_builder_tab_layout_1": "Text on the right",
        "ss_builder_tab_layout_2": "Text below",
        "ss_builder_tabs_label": "Tabs",
        "ss_builder_template_overwrite_title": "Overwrite template",
        "ss_builder_template_search_bar_placeholder": "Search templates by name...",
        "ss_builder_template_store_instruction_subtitle": "Data and settings of selected block template will be applied to current block",
        "ss_builder_template_store_instruction_title": "Please choose a block template you want!",
        "ss_builder_template_title": "Template",
        "ss_builder_text_editor_max_length": "Enter maximum {{editor_max_length}} characters",
        "ss_builder_text_spin_loading": "Loading page",
        "ss_builder_the_application_of_the_template_will": "Applying block template will",
        "ss_builder_theme_big_button_setting": "Big button",
        "ss_builder_theme_button_setting_general": "General",
        "ss_builder_theme_display_setting": "Display setting",
        "ss_builder_theme_medium_button_setting": "Medium button",
        "ss_builder_theme_setting_background": "Background",
        "ss_builder_theme_setting_background_color_preview_title": "Preview",
        "ss_builder_theme_setting_background_color_selector_label": "Color",
        "ss_builder_theme_setting_background_content": "Max file size: 30MB.\nSupport file format: jpg, jpeg, gif, png, bmp, webp",
        "ss_builder_theme_setting_background_content_v2": "Max file size: 30MB.\nSupport file format: jpg, jpeg, gif, png, bmp",
        "ss_builder_theme_setting_background_image_preview_label": "Background Image",
        "ss_builder_theme_setting_background_image_selector_label": "Image",
        "ss_builder_theme_setting_background_image_title": "Background image",
        "ss_builder_theme_setting_block_background": "Background color",
        "ss_builder_theme_setting_block_border": "Border",
        "ss_builder_theme_setting_block_shadow": "Shadow",
        "ss_builder_theme_setting_block_style": "Style",
        "ss_builder_theme_setting_button": "Button",
        "ss_builder_theme_setting_font_title": "Text settings",
        "ss_builder_theme_setting_font_type_content": "Choose the typeface to apply to your entire site",
        "ss_builder_theme_setting_font_type_title": "Font type",
        "ss_builder_theme_setting_gadient_color": "Color",
        "ss_builder_theme_setting_general": "General",
        "ss_builder_theme_setting_gradient_color_direction_label": "Direction",
        "ss_builder_theme_setting_hard_shadow": "Hard shadow",
        "ss_builder_theme_setting_intensity_color_label": "Color intensity",
        "ss_builder_theme_setting_label": "Theme setting",
        "ss_builder_theme_setting_no_shadow": "No shadow",
        "ss_builder_theme_setting_paragraph": "Paragraph",
        "ss_builder_theme_setting_primary_color": "Color",
        "ss_builder_theme_setting_primary_color_content": "Choose the primary color to apply to your entire site",
        "ss_builder_theme_setting_primary_color_title": "Primary color",
        "ss_builder_theme_setting_save_failed_content": "An unexpected error occurred. Please try again.",
        "ss_builder_theme_setting_save_failed_title": "Error",
        "ss_builder_theme_setting_save_successfully_label": "Save the setting successfully",
        "ss_builder_theme_setting_select_background_color_label": "Choose color type",
        "ss_builder_theme_setting_select_gradient_color_label": "Choose gradient color",
        "ss_builder_theme_setting_select_solid_color_label": "Choose a color",
        "ss_builder_theme_setting_shadow": "Shadow",
        "ss_builder_theme_setting_shadow_color": "Shadow color",
        "ss_builder_theme_setting_soft_shadow": "Soft shadow",
        "ss_builder_theme_setting_text": "Button text",
        "ss_builder_theme_setting_title": "Title",
        "ss_builder_theme_small_button_setting": "Small button",
        "ss_builder_theme_store_label": "Template",
        "ss_builder_theme_store_popover_manual_content": "Get to know how to use the Theme store, let's press the \u201CGet Started\u201D button.",
        "ss_builder_theme_store_popover_manual_title": "Product tour",
        "ss_builder_theme_store_tour_content_step_1": "Search the theme quickly using theme name",
        "ss_builder_theme_store_tour_content_step_2": "Passio Page offers a lot of theme templates for you to choose. Let's apply a template you like to experience.",
        "ss_builder_theme_store_tour_title_step_1": "Search the theme template",
        "ss_builder_theme_store_tour_title_step_2": "Theme templates",
        "ss_builder_theme_template_format_create_label": "Create",
        "ss_builder_theme_template_label_tag": "Tags",
        "ss_builder_theme_template_label_tag_placeholder": "Enter tags",
        "ss_builder_theme_template_no_option": "No option",
        "ss_builder_theme_template_preview_info": "Preview your site after applying theme template",
        "ss_builder_theme_template_preview_mode_title": "Preview mode",
        "ss_builder_theme_template_search_bar_placeholder": "Search theme templates by name...",
        "ss_builder_theme_template_store_instruction_subtitle": "Theme settings of selected theme template will be applied to entrie site",
        "ss_builder_theme_template_store_instruction_title": "Please choose the theme you want!",
        "ss_builder_theme_template_store_title": "Theme store",
        "ss_builder_theme_template_theme_store": "{{num_results}} theme template(s)",
        "ss_builder_theme_template_view_theme_info": "Theme template with sample data",
        "ss_builder_theme_template_view_theme_title": "View template",
        "ss_builder_title": "Title",
        "ss_builder_title_block_affiliate_product": "Affiliate",
        "ss_builder_title_block_bio": "Bio",
        "ss_builder_title_block_booking_profile": "Booking Profile",
        "ss_builder_title_block_booking_profile_description": "Add a link to your Booking Profile page or display your Booking Profile inside the Passio Page",
        "ss_builder_title_block_booking_profile_warning": "Create a Booking Profile to use this block",
        "ss_builder_title_block_brand_gift": "Brand Gift",
        "ss_builder_title_block_brand_gift_description": "Show Icon for Brand Gift",
        "ss_builder_title_block_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_block_brand_rating": "Brand Ratings",
        "ss_builder_title_block_brand_rating_description": "en_B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_builder_title_block_button_link": "Link",
        "ss_builder_title_block_button_multi_link": "Multi Links",
        "ss_builder_title_block_card": "Cards",
        "ss_builder_title_block_digital_product": "Digital Product",
        "ss_builder_title_block_donation": "Donation",
        "ss_builder_title_block_embed": "Embed",
        "ss_builder_title_block_image": "Image",
        "ss_builder_title_block_image_gallery": "Image Gallery",
        "ss_builder_title_block_image_popup": "Image popup",
        "ss_builder_title_block_image_slider": "Image Slider",
        "ss_builder_title_block_story": "Spotlight",
        "ss_builder_title_block_tab_bar": "Tab Menu",
        "ss_builder_title_block_text": "Text",
        "ss_builder_title_block_truth_or_dare": "Truth Or Dare",
        "ss_builder_title_block_truth_or_dare_footer": "Truth Or Dare Icon",
        "ss_builder_title_block_video_shoutout": "Video Shoutout",
        "ss_builder_title_block_video_shoutout_description": "Video gifts from your idol",
        "ss_builder_title_block_virtual_gift": "Virtual Gift",
        "ss_builder_title_block_virtual_gift_footer": "Virtual Gift Icon",
        "ss_builder_title_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_color": "Text color",
        "ss_builder_title_combined": "Combined block",
        "ss_builder_title_introduction_service": "Service details",
        "ss_builder_title_page_builder": "Passio Page Builder",
        "ss_builder_title_setting_title": "Title Settings",
        "ss_builder_title_spacer_and_divider": "Spacer & Divider",
        "ss_builder_to_add_products_please_press_the_add_button_above": "To add a new product please press the \u201CAdd\u201D button above",
        "ss_builder_to_new_version": "Go to Passio Page",
        "ss_builder_top_position_tab_label": "Top",
        "ss_builder_transparent": "Transparency",
        "ss_builder_truth_or_dare_warning": "Only able to add one block",
        "ss_builder_try_another_keyword_theme_store": "No results found. Please try with another keyword.",
        "ss_builder_try_new_key": "Please try with other keywords",
        "ss_builder_type_label": "Type",
        "ss_builder_type_of_color": "Color type",
        "ss_builder_undo_theme_label": "Undo",
        "ss_builder_update_account": "Upgrade account",
        "ss_builder_upload_button_label": "Upload image",
        "ss_builder_upload_file_format_invalid_content": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_file_format_invalid_content_for_gif_png_svg": "Invalid image format. Supported format: GIF, PNG, SVG",
        "ss_builder_upload_file_format_invalid_content_v2": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP",
        "ss_builder_upload_file_size_invalid_content": "Please choose a file with a maximum size of 30MB",
        "ss_builder_upload_file_size_invalid_content_min_256": "Please choose an image with a minimum size of 256x256px",
        "ss_builder_upload_large_file_format_invalid_content": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_large_file_size_invalid_content": "Please choose a file with a maximum size of 50MB",
        "ss_builder_uploading_image": "Uploading image",
        "ss_builder_url_error_content": "Could not get information. Please check site URL.",
        "ss_builder_url_placeholder": "Enter url",
        "ss_builder_use_advanced_setting_description": "Enable advanced settings to customize the display settings of this Combined Block",
        "ss_builder_use_affiliate_link_description": "Check to use Affiliate Link of Ecomobi Passio. Uncheck to use original link",
        "ss_builder_use_affiliate_link_label": "Use Ecomobi Passio tracking link",
        "ss_builder_use_ecomobi_tracking_link": "Use Ecomobi Passio tracking link",
        "ss_builder_validate_gen_link_error_E1": "Token is invalid",
        "ss_builder_validate_gen_link_error_E2": "Your account is locked, you will not receive commission.",
        "ss_builder_validate_gen_link_error_E3": "This link is not supported with affiliate tracking, you will not receive commission.",
        "ss_builder_validate_gen_link_error_E5": "This link will not generate commission because campaign has not been aprroved. You need request to join the campaign.",
        "ss_builder_validate_gen_link_error_E6": "This link will not generate commission because you have been blocked from this campaign.",
        "ss_builder_validate_gen_link_error_E7": "Can not generate shorten link due system error.",
        "ss_builder_validate_gen_link_error_E8": "This link will not generate commission because the campaign is stopped.",
        "ss_builder_video_shoutout_answer_method_description": "If you accept the request of creator fans, you need to reply with a video",
        "ss_builder_video_shoutout_answer_method_title": "Answer method",
        "ss_builder_video_shoutout_btn_setup": "Set now",
        "ss_builder_video_shoutout_des_intro_fan": "You have 7 days to decide or reject fans' requests. If you refuse to do it, Ecomobi will refund all the paid money to the requester within 30 days.",
        "ss_builder_video_shoutout_des_intro_gift": "Through Passio, your fans can send you video requirements for special occasions: birthday, congratulations, anniversaries, video encouragement, inspiration ... with a certain fee Designed by yourself.",
        "ss_builder_video_shoutout_des_intro_policy": "You and fans can share these meaningful videos with people through social networking sites.",
        "ss_builder_video_shoutout_how_to_work": "How does the shoutout video work?",
        "ss_builder_video_shoutout_introduction": "Video Shoutout is a service that allows fans to send to Creator requirements for a personalized video for specific occasions such as birthday, graduation, congratulations, ... Creator will respond to those requirements with one with one with one with one with one. video",
        "ss_builder_video_shoutout_participate_description": "Creator can choose to make or reject fans' requirements",
        "ss_builder_video_shoutout_participate_title": "The right to join you",
        "ss_builder_video_shoutout_response_description": "After the fans submitted the request, Creator had 7 days to make the video. After this time, the amount of that request will be returned to fans",
        "ss_builder_video_shoutout_response_title": "Response time",
        "ss_builder_video_shoutout_title_intro": "Service introduction",
        "ss_builder_video_shoutout_title_intro_fan": "Make video",
        "ss_builder_video_shoutout_title_intro_gift": "Receive requirements from fans",
        "ss_builder_video_shoutout_title_intro_policy": "Share meaningful moments.",
        "ss_builder_virtual_gift_list_title": "Gift list",
        "ss_builder_wait_for_saving": "The saving process hasn't complete. Please wait a moment.",
        "ss_builder_warning_brand_gift_floating_continue": "Continue",
        "ss_builder_warning_brand_gift_floating_description": "Your floating icons position is now full. You need to remove the block in the floating icon group in the extended position. See",
        "ss_builder_warning_brand_gift_floating_description_link": "the detail instruction",
        "ss_builder_warning_brand_gift_floating_reject": "Cancel",
        "ss_builder_warning_brand_gift_floating_title": "Floating icons position is full",
        "ss_builder_warning_brand_gift_rating_description": "en_Hi\u1EC7n t\u1EA1i th\xe2n trang \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n hi\u1EC3n th\u1ECB. B\u1EA1n c\u1EA7n xo\xe1 b\u1EDBt kh\u1ED1i \u0111\u1EC3 b\u1EADt t\xednh n\u0103ng Brand Ratings",
        "ss_builder_warning_brand_rating_floating_continue": "en_\u0110\xe3 hi\u1EC3u",
        "ss_builder_warning_brand_rating_floating_title": "en_Brand Ratings",
        "ss_builder_web_browser": "Web browser",
        "ss_builder_web_label": "Ss Builder Web Label",
        "ss_builder_website_config_site_title_description": "Always displayed at the top of the page when fans visit.",
        "ss_builder_website_config_site_title_label": "Site name",
        "ss_builder_website_config_site_title_placeholder": "Enter content",
        "ss_builder_what_field_are_you_operating_in": "Which field are you working in?",
        "ss_builder_what_went_wrong": "What went wrong?",
        "ss_builder_width_tab_setting_label": "Tab width",
        "ss_builder_width_tab_type_1": "Auto",
        "ss_builder_width_tab_type_2": "Equally divided",
        "ss_builder_your_page_is_ready": "Your bio page is ready!",
        "ss_cancle_delete": "Cancel",
        "ss_challenge": "Challenge",
        "ss_confirm_delete": "Confirm delete",
        "ss_content_confirm_delete": "Are you sure you want to delete this product?",
        "ss_content_delete_forever": "To delete the product please return to the product management page",
        "ss_content_intro_dp": "Digital products are understood as online products, not grasped, containing useful content for users. For example: Video, photos, ebook, online course, ..",
        "ss_content_item1_dp": "Depending on your strengths and desires, Passio offers a full range of digital products such as photos, videos, online courses, ebooks, links, ...",
        "ss_content_item2_dp": "With less than 3 minutes, you can configure and sell a new digital product. Moreover, after the buyer successfully buys, the product will be sent immediately to their email, helping to simplify shipping and save time",
        "ss_content_success_TOD": "You have successfully installed Truth or Dare feature.",
        "ss_cover_image": "Cover image",
        "ss_cover_image_empty": "No image selected",
        "ss_cover_image_helper": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, max 4MB",
        "ss_cover_image_upload": "Upload image",
        "ss_delete_forever": "Permanently deleted",
        "ss_delete_product": "Delete display",
        "ss_display_delete": "Delete display",
        "ss_donation_currency_shortcut": "\u20B1",
        "ss_donation_setting_default_content_setup_donation": "This service is being set as default. If you want to make changes, please access the Donation service here: account.passio.eco",
        "ss_donation_setting_default_title_setup_donation": "Service Settings",
        "ss_dp_add": "Add",
        "ss_dp_cat_course": "Course / Tutorial",
        "ss_dp_cat_ebook_document": "Ebook/Document",
        "ss_dp_cat_online_consultion": "Online consulting 1-1",
        "ss_dp_cat_random_product": "Products any",
        "ss_dp_cat_ticket_account": "Ticket/ Account",
        "ss_dp_cat_video": "Exclusive video",
        "ss_dp_sell_photo": "Image",
        "ss_edit_TOD": "Edit",
        "ss_example_TOD": "Example: 100,000",
        "ss_exit_TOD": "Exit",
        "ss_first_person": "Be the first to challenge now!",
        "ss_gift_button_preview": "Send gift now!",
        "ss_gift_invitation": "Motivate {user} by sending gifts!",
        "ss_had": "Already existed",
        "ss_iframe_add_new_product": "Add new product",
        "ss_iframe_add_product": "Add product",
        "ss_iframe_choose_product_from_store": "Choose from data store",
        "ss_inline_image_empty": "You cannot leave this field blank",
        "ss_inline_txtbtn_max_length": "This field exceeds 40 characters.",
        "ss_input_placehoder": "Enter content",
        "ss_invitation_TOD": "Challenge invitation description",
        "ss_invitation_TOD_placeholder": "Enter the content invite fans to join",
        "ss_logout": "Log out",
        "ss_modal_cancel_confirm": "Cancel",
        "ss_modal_text_confirm": "Go to the Administration page",
        "ss_no": "No",
        "ss_placeholder_message_TOD": "Input your Dare",
        "ss_preview_TOD": "Continue",
        "ss_profile": "Profile",
        "ss_push_TOD": "Publish",
        "ss_rount_tod": "Challenges",
        "ss_service_introduction": "Service introduction",
        "ss_setting_TOD_background_tooltip": "Select wallpaper in 3:2 aspect ratio and maximum size of 4 MB",
        "ss_setting_TOD_field_image_background": "Add wallpaper",
        "ss_setting_TOD_field_image_background_bottom": "Background image",
        "ss_setting_TOD_field_welcome_tooltip": "The invitation will be filled automatically if you leave it blank",
        "ss_setup_now": "Set now",
        "ss_shoutout_btn_content": "Button content",
        "ss_shoutout_change_file": "Change photos/videos",
        "ss_shoutout_create_request": "Create immediately",
        "ss_shoutout_description": "Describe",
        "ss_shoutout_description_placeholder": "Enter the introduction content",
        "ss_shoutout_error_price_required": "Please enter the price",
        "ss_shoutout_error_upload": "Error occurs, uploaded failure",
        "ss_shoutout_error_video_size": "Please upload images/ videos up to 500MB",
        "ss_shoutout_error_video_type": "Please upload to the file as one of JPG, JPEG, GIF, PNG, BMP, Webp, HEIC, HEIC, HEIC, MP4, MOV",
        "ss_shoutout_file_intro": "Photo/video introduction",
        "ss_shoutout_file_intro_note": "Upload images or videos to call fans to use the shoutout video from you",
        "ss_shoutout_no_file_selected": "No photos/videos have been selected",
        "ss_shoutout_price": "Price",
        "ss_shoutout_price_placeholder": "Enter the price",
        "ss_shoutout_select_file": "Select photos/videos",
        "ss_shoutout_type_support": "Support: JPG, JPEG, GIF, PNG, BMP, Webp, HEIF, HEIC, MP4, MOV up to 500MB",
        "ss_shoutout_upload_success": "Upload the video to success",
        "ss_success_TOD": "Successful",
        "ss_success_off_TOD": "You have successfully disabled Truth or Dre feature.",
        "ss_success_on_TOD": "You have successfully enabled the Truth or Dare feature.",
        "ss_success_setup_TOD": "You have successfully installed Truth or Dare feature.",
        "ss_title_intro_dp": "What is digital product",
        "ss_title_item1_dp": "Diverse types of products for you to choose",
        "ss_title_item2_dp": "Easy to manage products and orders with a few operations",
        "ss_tod_challenge_number": "No of Challenges",
        "ss_tod_content": "Invitation content",
        "ss_tod_dare_content": "Call for challenges from your fans",
        "ss_tod_dare_fee": "Minimum amount paid for Dare by Fan",
        "ss_tod_default_content": "Dare me - I won\u2019t bite",
        "ss_tod_default_dare_content": "Wanna get a little bit naughty? Try me!",
        "ss_tod_min_price_dare_alias": "Minimum amount paid for Dare by Fan",
        "ss_tod_min_price_dare_note": "Minimum payment is 1",
        "ss_tod_setting_cover_image": "Cover image",
        "ss_tod_setting_cover_image_helper": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, max 4MB",
        "ss_tod_setting_field_welcome_tooltip": "The invitation will be filled automatically if you leave it blank",
        "ss_tod_setting_input_placehoder": "Enter content",
        "ss_tod_tooltip_content": "Character limit is 60.",
        "ss_tod_tooltip_min_price_dare": "Invitation content is up to 60 characters",
        "ss_txt_btn_TOD": "Challenge invitation",
        "ss_validate_domain_error_E1": "The domain name has been changed within 30 days, cannot be changed",
        "ss_validate_domain_error_E2": "The domain name is already exists, please try another one",
        "ss_validate_domain_error_E3": "This domain is banned",
        "ss_validate_origin_url_error_E203": "Could not resolved the domain. Please check and try again.",
        "ss_validate_origin_url_error_E5": "You are not approved to join this campaign, please request to approve",
        "ss_validate_origin_url_error_E6": "You are blocked in campaign, please contact your account manager",
        "ss_validate_origin_url_error_E7": "This URL is not supported",
        "ss_validate_origin_url_error_E9": "This campaign is stopped, please enter another URL",
        "ss_validate_origin_url_error_V0": "Invalid Url",
        "ss_validate_origin_url_error_sys": "Please enter a valid URL",
        "ss_validate_origin_url_warning_E5": "You haven't request for this campaign. Orders and commission will not be counted.",
        "ss_validate_origin_url_warning_E7": "This url isn't supported. Orders and commission will not be counted.",
        "ss_validate_origin_url_warning_E9": "This campaign is stopped. Order and Commission will not be counted.",
        "text_cashback_brand_gift": "Cashback",
        "text_custom_brand_gift": "Customize",
        "text_voucher_brand_gift": "Voucher",
        "undefined": "Undefined",
        "voucher_default_text_button": "Get your voucher now!",
        "voucher_default_title": "Tap pay, 5% cashback",
        "warning_text_TOD": "Your settings have not been saved. Do you still want to exit?",
        "warning_text_switch_TOD": "Do you want to disable Truth or Dare feature?"
    }
};
/* harmony default export */ var messages_en = (en);

;// CONCATENATED MODULE: ./src/messages/vi.ts
var vi = {
    translation: {
        "button_confirm_exit_TOD": "Tho\xe1t",
        "button_confirm_off_TOD": "T\u1EAFt",
        "button_title_default_donation": "\u1EE6ng h\u1ED9 \uD83D\uDCB5 cho {name} b\u1EA1n nh\xe9!",
        "cashback_default_text_button": "Nh\u1EADn ho\xe0n ti\u1EC1n ngay",
        "cashback_default_title": "Mua s\u1EAFm th\u1EA3 ga, ho\xe0n ti\u1EC1n c\u1EF1c \u0111\xe3",
        "cm_home": "Home",
        "default_content_setup_brand_gift": "B\u1EA1n h\xe3y ch\u1ECDn ho\u1EB7c t\u1EA1o ra n\u1ED9i dung h\u1EA5p d\u1EABn cho fan nh\xe9",
        "default_content_setup_donation": "D\u1ECBch v\u1EE5 \u0111ang \u0111\u01B0\u1EE3c c\xe0i \u0111\u1EB7t m\u1EB7c \u0111\u1ECBnh. N\u1EBFu b\u1EA1n mu\u1ED1n thay \u0111\u1ED5i, vui l\xf2ng truy c\u1EADp d\u1ECBch v\u1EE5 \u1EE6ng h\u1ED9 t\u1EA1i account.passio.eco",
        "default_title_setup_brand_gift": "Thi\u1EBFt l\u1EADp",
        "default_title_setup_donation": "Thi\u1EBFt l\u1EADp d\u1ECBch v\u1EE5",
        "error_thumbnail_size_TOD": "\u1EA2nh qu\xe1 dung l\u01B0\u1EE3ng cho ph\xe9p",
        "invitation_default_donation": "B\u1EA1n y\xeau qu\xfd {name}?",
        "label_tab_bar_brand_gift": "M\u1EABu n\u1ED9i dung",
        "label_text_button_brand_gift": "N\xfat",
        "label_text_title_brand_gift": "Ti\xeau \u0111\u1EC1",
        "login": "\u0110\u0103ng nh\u1EADp",
        "message_default_donation": "C\u1EA3m \u01A1n b\u1EA1n \u0111\xe3 \u1EE7ng h\u1ED9 {name}. Hi v\u1ECDng ch\xfang ta s\u1EBD c\xf3 nhi\u1EC1u d\u1ECBp t\u01B0\u01A1ng t\xe1c v\u1EDBi nhau n\u1EEFa nh\xe9!",
        "placeholder_text_button_brand_gift": "Nh\u1EADp n\u1ED9i dung n\xfat",
        "placeholder_text_title_brand_gift": "Nh\u1EADp n\u1ED9i dung ti\xeau \u0111\u1EC1",
        "ss_background_TOD": "\u1EA2nh backgound",
        "ss_brand_cpc_bonus": "Hoa h\u1ED3ng",
        "ss_brand_cpc_campaign_title": "Nh\u1EADn hoa h\u1ED3ng",
        "ss_brand_cpc_description": "M\xf4 t\u1EA3 ch\u01B0\u01A1ng tr\xecnh",
        "ss_brand_cpc_download": "T\u1EA3i xu\u1ED1ng",
        "ss_brand_cpc_from": "T\u1EEB",
        "ss_brand_cpc_join": "Tham gia",
        "ss_brand_cpc_join_now": "Tham kh\u1EA3o ngay",
        "ss_brand_cpc_join_successfully_label": "B\u1EA1n \u0111\xe3 tham gia ch\u01B0\u01A1ng tr\xecnh th\xe0nh c\xf4ng",
        "ss_brand_cpc_no_access_allow": "B\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p truy c\u1EADp v\xe0o link n\xe0y",
        "ss_brand_cpc_notice": "L\u01B0u \xfd",
        "ss_brand_cpc_notice_content": "Hoa h\u1ED3ng s\u1EBD \u0111\u01B0\u1EE3c tr\u1EA3 v\u1EC1 t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n sau 7 ng\xe0y k\u1EC3 t\u1EEB khi \u0111\u01B0\u1EE3c nghi\u1EC7m thu.",
        "ss_brand_cpc_reject": "\u1EA2nh nghi\u1EC7m thu c\u1EE7a b\u1EA1n \u0111\xe3 b\u1ECB t\u1EEB ch\u1ED1i. B\u1EA1n c\xf3 th\u1EC3 t\u1EA3i l\u1EA1i \u1EA3nh.",
        "ss_brand_cpc_requirement": "Y\xeau c\u1EA7u",
        "ss_brand_cpc_step_1": "B\u01B0\u1EDBc 1: T\u1EA3i \u1EA3nh d\u01B0\u1EDBi \u0111\xe2y v\u1EC1 v\xe0 up l\xean 1 n\u1EC1n t\u1EA3ng m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_brand_cpc_step_1_note": "L\u01B0u \xfd: up \u1EA3nh trong kho\u1EA3ng th\u1EDDi gian",
        "ss_brand_cpc_step_2": "B\u01B0\u1EDBc 2: T\u1EA3i \u1EA3nh nghi\u1EC7m thu (\u1EA3nh ch\u1EE5p m\xe0n h\xecnh b\xe0i \u0111\u0103ng c\u1EE7a b\u1EA1n \u1EDF b\u01B0\u1EDBc 1)",
        "ss_brand_cpc_step_2_note": "L\u01B0u \xfd: \u1EA3nh nghi\u1EC7m thu th\u1EC3 hi\u1EC7n th\u1EDDi gian \u0111\xe3 \u0111\u0103ng \u1EA3nh t\u1ED1i thi\u1EC3u l\xe0 12h. VD: \u1EA2nh ch\u1EE5p m\xe0n h\xecnh story \u0111\xe3 \u0111\u0103ng 12h tr\u01B0\u1EDBc tr\u1EDF l\xean.",
        "ss_brand_cpc_success": "\u0110\xe3 nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_text_content": "\u0111ang g\u1EEDi cho b\u1EA1n 01 l\u1EDDi \u0111\u1EC1 ngh\u1ECB tham gia v\xe0o ch\u01B0\u01A1ng tr\xecnh treo banner - nh\u1EADn ti\u1EC1n th\u01B0\u1EDFng.",
        "ss_brand_cpc_text_title": "Nh\u1EADn ti\u1EC1n d\u1EC5 d\xe0ng c\xf9ng",
        "ss_brand_cpc_time": "Th\u1EDDi gian",
        "ss_brand_cpc_time_end": "Th\u1EDDi gian k\u1EBFt th\xfac",
        "ss_brand_cpc_time_start": "Th\u1EDDi gian b\u1EAFt \u0111\u1EA7u",
        "ss_brand_cpc_to": "\u0110\u1EBFn",
        "ss_brand_cpc_upload_image": "T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_cpc_upload_image_button": "T\u1EA3i \u1EA3nh l\xean",
        "ss_brand_cpc_upload_image_successfully": "B\u1EA1n \u0111\xe3 g\u1EEDi \u1EA3nh nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_upload_image_title": "T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_gift_cancel_hide": "H\u1EE7y b\u1ECF",
        "ss_brand_gift_confirm_hide_brand": "X\xe1c nh\u1EADn",
        "ss_brand_gift_confirm_hide_group": "X\xe1c nh\u1EADn \u1EA9n nh\xf3m",
        "ss_brand_gift_disable_deal_successfully": "\u1EA8n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_disable_successfully": "\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_display_hide_brand": "\u1EA8n Deal",
        "ss_brand_gift_display_hide_category": "\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_display_show_brand": "Hi\u1EC7n Deal",
        "ss_brand_gift_display_show_category": "Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_empty_title": "Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m n\xe0o",
        "ss_brand_gift_enable_deal_successfully": "Hi\u1EC7n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_enable_successfully": "Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_hide_brand": "B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n Deal?",
        "ss_brand_gift_hide_brand_content": "Deal {{name}} s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB \u1EDF giao di\u1EC7n c\u1EE7a Fan. B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n deal n\xe0y?",
        "ss_brand_gift_hide_category": "B\u1EA1n mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_hide_category_content": "Nh\xf3m {{name}} v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB \u1EA9n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_list_category": "Danh s\xe1ch nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_list_empty_content": "Hi\u1EC7n gi\u1EDD Admin ch\u01B0a setup d\u1EEF li\u1EC7u s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_setting_cashback_default_text_button": "Nh\u1EADn ho\xe0n ti\u1EC1n ngay",
        "ss_brand_gift_setting_cashback_default_title": "Mua s\u1EAFm th\u1EA3 ga, ho\xe0n ti\u1EC1n c\u1EF1c \u0111\xe3",
        "ss_brand_gift_setting_default_content_setup": "B\u1EA1n h\xe3y ch\u1ECDn ho\u1EB7c t\u1EA1o ra n\u1ED9i dung h\u1EA5p d\u1EABn cho fan nh\xe9",
        "ss_brand_gift_setting_float_icon_description": "B\u1EA1n h\xe3y l\u01B0u c\xe0i \u0111\u1EB7t floating icon \u0111\u1EC3 gi\xfap b\u1EA1n t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan c\u1EE7a m\xecnh nhi\u1EC1u h\u01A1n",
        "ss_brand_gift_setting_float_icon_footer_description": "B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_brand_gift_setting_label_tab_bar_brand_gift": "M\u1EABu n\u1ED9i dung",
        "ss_brand_gift_setting_label_text_button": "N\xfat",
        "ss_brand_gift_setting_label_text_title_brand_gift": "Ti\xeau \u0111\u1EC1",
        "ss_brand_gift_setting_placeholder_text_button": "Nh\u1EADp n\u1ED9i dung n\xfat",
        "ss_brand_gift_setting_placeholder_text_title": "Nh\u1EADp n\u1ED9i dung ti\xeau \u0111\u1EC1",
        "ss_brand_gift_setting_text_cashback_brand_gift": "Ho\xe0n ti\u1EC1n",
        "ss_brand_gift_setting_text_custom_brand_gift": "C\xe1 nh\xe2n h\xf3a",
        "ss_brand_gift_setting_text_voucher_brand_gift": "Voucher",
        "ss_brand_gift_setting_title_block_footer": "Brand Gift Icon",
        "ss_brand_gift_setting_voucher_default_text_button": "Nh\u1EADn voucher ngay",
        "ss_brand_gift_setting_voucher_default_title": "Ch\u1EA1m l\u1EB9 thanh to\xe1n, ho\xe0n ti\u1EC1n 5%",
        "ss_brand_rating_setting_default_content_setup_donation": "Danh s\xe1ch c\xe1c ch\u01B0\u01A1ng tr\xecnh ho\xe0n ti\u1EC1n gi\u1EA3m gi\xe1 d\xe0nh cho fan c\u1EE7a b\u1EA1n. B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 nh\u1EADn hoa h\u1ED3ng ngay!",
        "ss_build_collapse_block_label": "Thu g\u1ECDn",
        "ss_build_expand_block_label": "M\u1EDF r\u1ED9ng",
        "ss_build_no_blocks_have_been_added": "Ch\u01B0a c\xf3 kh\u1ED1i n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builde_theme_setting_block": "Kh\u1ED1i",
        "ss_builder_1st_block_preview_sample_description": "\u0110\xe2y l\xe0 n\u1ED9i dung v\xed d\u1EE5 c\u1EE7a kh\u1ED1i, b\u1EA1n c\xf3 th\u1EC3 th\u1EA5y c\xe1ch ph\xf4ng ch\u1EEF, m\xe0u s\u1EAFc hi\u1EC3n th\u1ECB trong kh\u1ED1i.",
        "ss_builder_1st_block_preview_sample_title": "Kh\u1ED1i 1",
        "ss_builder_2st_block_preview_sample_description": "\u0110\xe2y l\xe0 n\u1ED9i dung v\xed d\u1EE5 c\u1EE7a kh\u1ED1i, b\u1EA1n c\xf3 th\u1EC3 th\u1EA5y c\xe1ch ph\xf4ng ch\u1EEF, m\xe0u s\u1EAFc hi\u1EC3n th\u1ECB trong kh\u1ED1i. Kh\u1ED1i th\u1EE9 2 \u0111\u1EC3 th\u1EA5y kho\u1EA3ng c\xe1ch gi\u1EEFa c\xe1c kh\u1ED1i.",
        "ss_builder_2st_block_preview_sample_title": "Kh\u1ED1i 2",
        "ss_builder_add_affiliate_product_list_btn_label": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_add_block_body_title": "Th\xe2n trang",
        "ss_builder_add_block_expand_title": "M\u1EDF r\u1ED9ng",
        "ss_builder_add_block_footer_title": "Cu\u1ED1i trang",
        "ss_builder_add_block_header_title": "\u0110\u1EA7u trang",
        "ss_builder_add_block_in_template": "Th\xeam kh\u1ED1i m\u1EABu",
        "ss_builder_add_block_in_template_successfully": "Th\xeam kh\u1ED1i m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_add_block_label": "Th\xeam kh\u1ED1i",
        "ss_builder_add_block_to": "Th\xeam kh\u1ED1i v\xe0o:",
        "ss_builder_add_image_of_image_popup_tilte": "Th\xeam \u1EA3nh",
        "ss_builder_add_new_affiliate_product_btn_label": "Th\xeam m\u1EDBi s\u1EA3n ph\u1EA9m",
        "ss_builder_add_new_affiliate_product_group_btn_label": "Th\xeam nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_add_new_affiliate_product_image_title": "\u1EA2nh s\u1EA3n ph\u1EA9m",
        "ss_builder_add_new_affiliate_product_list_empty_content": "\u0110\u1EC3 th\xeam s\u1EA3n ph\u1EA9m vui l\xf2ng nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn v\xe0o \xf4 b\xean d\u01B0\u1EDBi",
        "ss_builder_add_new_affiliate_product_name_title": "T\xean s\u1EA3n ph\u1EA9m",
        "ss_builder_add_new_affiliate_product_title": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_add_new_block_successfully_label": "Th\xeam m\u1EDBi kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_add_new_image": "Th\xeam m\u1EDBi \u1EA3nh",
        "ss_builder_add_new_image_of_image_popup_title": "\u1EA2nh",
        "ss_builder_add_new_image_of_image_slider_title": "\u1EA2nh",
        "ss_builder_add_new_image_popup_btn_label": "Th\xeam",
        "ss_builder_add_new_image_slider_title": "Th\xeam \u1EA3nh",
        "ss_builder_add_new_label": "Th\xeam",
        "ss_builder_add_new_product_group_successfully_label": "Th\xeam nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_add_new_tab_successfully_label": "Th\xeam tab m\u1EDBi th\xe0nh c\xf4ng",
        "ss_builder_add_new_tag_error_duplicate": "Tag \u0111\xe3 t\u1ED3n t\u1EA1i",
        "ss_builder_add_new_template_btn_label": "L\u01B0u m\u1EDBi",
        "ss_builder_add_new_template_image_title": "\u1EA2nh m\u1EABu",
        "ss_builder_add_new_template_label": "T\u1EA1o m\u1EDBi m\u1EABu",
        "ss_builder_add_new_template_name_placeholder": "Nh\u1EADp t\xean m\u1EABu",
        "ss_builder_add_new_template_name_title": "T\xean m\u1EABu",
        "ss_builder_add_new_theme_btn_label": "L\u01B0u m\u1EDBi",
        "ss_builder_add_new_theme_selection_panel_description": "Ch\u1ECDn ph\u01B0\u01A1ng th\u1EE9c t\u1EA1o giao di\u1EC7n m\u1EABu \u0111\u1EC3 xu\u1EA5t b\u1EA3n l\xean C\u1EEDa h\xe0ng giao di\u1EC7n",
        "ss_builder_add_new_theme_selection_panel_label": "T\u1EA1o giao di\u1EC7n m\u1EABu",
        "ss_builder_add_new_theme_template_image_title": "\u1EA2nh giao di\u1EC7n m\u1EABu",
        "ss_builder_add_new_theme_template_name_placeholder": "Nh\u1EADp t\xean giao di\u1EC7n m\u1EABu",
        "ss_builder_add_new_theme_template_name_title": "T\xean giao di\u1EC7n m\u1EABu",
        "ss_builder_add_story": "Th\xeam m\u1EDBi",
        "ss_builder_add_tab_label": "Th\xeam Tab",
        "ss_builder_added_product_url_label": "\u0110\u01B0\u1EDDng d\u1EABn \u0111\xe3 \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_advanced_group_description": "C\xe1c kh\u1ED1i n\xe2ng cao",
        "ss_builder_advanced_setting": "Thi\u1EBFt l\u1EADp n\xe2ng cao",
        "ss_builder_advanced_title": "N\xe2ng cao",
        "ss_builder_aff_frame_max_size_content": "K\xedch th\u01B0\u1EDBc t\u1EC7p t\u1ED1i \u0111a: 30MB.",
        "ss_builder_aff_frame_select_from_library": "Ch\u1ECDn t\u1EEB th\u01B0 vi\u1EC7n",
        "ss_builder_aff_frame_support_type_file_content": "\u0110\u1ECBnh d\u1EA1ng h\u1ED7 tr\u1EE3: gif, png, svg",
        "ss_builder_affiliate_add_new_tour_content_step_1": "L\u1EF1a ch\u1ECDn nh\xf3m s\u1EA3n ph\u1EA9m \u0111\u1EC3 ph\xe2n lo\u1EA1i s\u1EA3n ph\u1EA9m c\u1EE7a b\u1EA1n. C\xe1c s\u1EA3n ph\u1EA9m b\xean d\u01B0\u1EDBi s\u1EBD \u0111\u01B0\u1EE3c th\xeam v\xe0o nh\xf3m b\u1EA1n ch\u1ECDn.",
        "ss_builder_affiliate_add_new_tour_content_step_2": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt t\u1EDBi s\u1EA3n ph\u1EA9m, h\u1EC7 th\u1ED1ng s\u1EBD t\u1EF1 \u0111\u1ED9ng l\u1EA5y th\xf4ng tin c\u1EE7a s\u1EA3n ph\u1EA9m.",
        "ss_builder_affiliate_add_new_tour_content_step_3": "B\u1EA1n c\xf3 th\u1EC3 thay \u0111\u1ED5i t\xean, h\xecnh \u1EA3nh, nh\xe3n... s\u1EA3n ph\u1EA9m.",
        "ss_builder_affiliate_add_new_tour_content_step_4": "Nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u0111\u1EC3 th\xeam danh s\xe1ch c\xe1c s\u1EA3n ph\u1EA9m b\xean tr\xean v\xe0o nh\xf3m.",
        "ss_builder_affiliate_add_new_tour_title_step_1": "Ch\u1ECDn nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_add_new_tour_title_step_2": "\u0110\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_affiliate_add_new_tour_title_step_3": "Th\xf4ng tin s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_add_new_tour_title_step_4": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_group_tour_content_step_1": "Th\xeam nh\xf3m s\u1EA3n ph\u1EA9m \u0111\u1EC3 ph\xe2n lo\u1EA1i danh m\u1EE5c s\u1EA3n ph\u1EA9m c\u1EE7a b\u1EA1n",
        "ss_builder_affiliate_group_tour_content_step_2": "Ch\u1EC9nh s\u1EEDa v\xe0 c\xe1c t\xf9y ch\u1ECDn c\u1EE7a t\u1EEBng nh\xf3m, cho ph\xe9p b\u1EA1n t\xf9y ch\u1EC9nh kh\u1ED1i theo \xfd mu\u1ED1n.",
        "ss_builder_affiliate_group_tour_title_step_1": "Th\xeam nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_group_tour_title_step_2": "T\xe1c v\u1EE5 nhanh",
        "ss_builder_affiliate_product_btn_see_more_placeholder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_affiliate_product_btn_see_more_title": "N\u1ED9i dung n\xfat xem th\xeam",
        "ss_builder_affiliate_product_clean_up_popover_content": "S\u1EA3n ph\u1EA9m n\xe0y s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c d\u1ECDn d\u1EB9p t\u1EF1 \u0111\u1ED9ng khi nh\xf3m \u0111\u1EA7y s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_cleanup_lock_label": "Kh\xf3a d\u1ECDn d\u1EB9p",
        "ss_builder_affiliate_product_cleanup_unlock_label": "M\u1EDF kh\xf3a d\u1ECDn d\u1EB9p",
        "ss_builder_affiliate_product_frame_panel_title": "Ch\u1ECDn khung \u1EA3nh",
        "ss_builder_affiliate_product_group_add_new_panel_title": "Th\xf4ng tin nh\xf3m",
        "ss_builder_affiliate_product_group_list_selector_label": "Danh s\xe1ch nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_group_management_title": "Qu\u1EA3n l\xfd nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_group_other": "Kh\xe1c",
        "ss_builder_affiliate_product_group_placeholder": "Nh\u1EADp ti\xeau \u0111\u1EC1 kh\u1ED1i",
        "ss_builder_affiliate_product_group_quantity_label": "{{product_quantity}} s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_group_quantity_warning_1": "Kh\xf4ng th\u1EC3 th\xeam",
        "ss_builder_affiliate_product_group_quantity_warning_2": "V\u01B0\u1EE3t qu\xe1 s\u1ED1 l\u01B0\u1EE3ng c\xf2n tr\u1ED1ng",
        "ss_builder_affiliate_product_group_title": "Ti\xeau \u0111\u1EC1 kh\u1ED1i",
        "ss_builder_affiliate_product_image_popup_infomation_label": "\u1EA2nh s\u1EA3n ph\u1EA9m m\u1EB7c \u0111\u1ECBnh \u0111\u01B0\u1EE3c l\u1EA5y t\u1EEB s\xe0n. B\u1EA1n c\xf3 th\u1EC3 thay \u0111\u1ED5i \u1EA3nh mong mu\u1ED1n.",
        "ss_builder_affiliate_product_label_product_discount": "Gi\u1EA3m gi\xe1",
        "ss_builder_affiliate_product_label_product_hot": "Hot",
        "ss_builder_affiliate_product_label_product_like": "Y\xeau th\xedch",
        "ss_builder_affiliate_product_label_product_title": "Nh\xe3n s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_list_empty_content": "\u0110\u1EC3 th\xeam s\u1EA3n ph\u1EA9m vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_affiliate_product_list_empty_title": "Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_affiliate_product_list_title": "Danh s\xe1ch",
        "ss_builder_affiliate_product_moving_panel_title": "Di chuy\u1EC3n s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_product_quantity_on_row_title": "S\u1ED1 s\u1EA3n ph\u1EA9m tr\xean m\u1ED9t h\xe0ng",
        "ss_builder_affiliate_product_searching_placeholder": "T\xecm ki\u1EBFm s\u1EA3n ph\u1EA9m theo t\xean...",
        "ss_builder_affiliate_product_style_title": "Phong c\xe1ch",
        "ss_builder_affiliate_setting_popover_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng cho kh\u1ED1i Affiliate vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1\u201D",
        "ss_builder_affiliate_setting_popover_manual_title": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_affiliate_setting_tour_content_step_1": "Th\u1EF1c hi\u1EC7n c\xe1c thao t\xe1c nh\u01B0 \u1EA8n/Hi\u1EC7n, X\xf3a kh\u1ED1i.",
        "ss_builder_affiliate_setting_tour_content_step_2": "Thi\u1EBFt l\u1EADp Ti\xeau \u0111\u1EC1 v\xe0 M\xf4 t\u1EA3 cho kh\u1ED1i, th\xf4ng tin s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB t\u01B0\u01A1ng \u1EE9ng sau khi l\u01B0u.",
        "ss_builder_affiliate_setting_tour_content_step_3": "L\u1EF1a ch\u1ECDn phong c\xe1ch hi\u1EC3n th\u1ECB c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m trong kh\u1ED1i. Sau khi thay \u0111\u1ED5i v\xe0 l\u01B0u kh\u1ED1i b\u1EA1n s\u1EBD th\u1EA5y phong c\xe1ch hi\u1EC3n th\u1ECB thay \u0111\u1ED5i \u1EDF m\xe0n h\xecnh thi\u1EBFt k\u1EBF.",
        "ss_builder_affiliate_setting_tour_content_step_4": "T\u1EA1o m\u1EDBi v\xe0 qu\u1EA3n l\xfd Nh\xf3m s\u1EA3n ph\u1EA9m \u0111\u1EC3 ph\xe2n chia danh s\xe1ch s\u1EA3n ph\u1EA9m th\xe0nh t\u1EEBng nh\xf3m. Fan s\u1EBD d\u1EC5 d\xe0ng ph\xe2n lo\u1EA1i v\xe0 l\u1ECDc s\u1EA3n ph\u1EA9m theo t\u1EEBng nh\xf3m. V\xed d\u1EE5: Qu\u1EA7n \xe1o, Gi\xe0y d\xe9p, Ph\u1EE5 ki\u1EC7n,...",
        "ss_builder_affiliate_setting_tour_content_step_5": "D\u1EC5 d\xe0ng truy c\u1EADp v\xe0o t\u1EEBng nh\xf3m s\u1EA3n ph\u1EA9m \u0111\u1EC3 th\xeam m\u1EDBi v\xe0 qu\u1EA3n l\xfd c\xe1c s\u1EA3n ph\u1EA9m b\xean trong nh\xf3m.",
        "ss_builder_affiliate_setting_tour_content_step_6": "Th\xeam m\u1EDBi s\u1EA3n ph\u1EA9m v\xe0o t\u1EEBng nh\xf3m b\u1EB1ng c\xe1ch nh\u1EA5n v\xe0o n\xfat \u201CTh\xeam\u201D.",
        "ss_builder_affiliate_setting_tour_content_step_7": "C\xe1c t\xf9y ch\u1ECDn nhanh v\u1EDBi t\u1EEBng s\u1EA3n ph\u1EA9m cho ph\xe9p thao t\xe1c nhanh v\u1EDBi c\xe1c s\u1EA3n ph\u1EA9m trong danh s\xe1ch.",
        "ss_builder_affiliate_setting_tour_content_step_8": "Sau khi ch\u1EC9nh s\u1EEDa, th\xeam n\u1ED9i dung, s\u1EA3n ph\u1EA9m v\xe0o kh\u1ED1i c\u1EE7a b\u1EA1n nh\u1EA5n n\xfat \u201CL\u01B0u\u201D \u0111\u1EC3 l\u01B0u l\u1EA1i v\xe0 s\u1EBD th\u1EA5y c\xe1c thay \u0111\u1ED5i \u1EDF m\xe0n h\xecnh \u201CThi\u1EBFt k\u1EBF\u201D.",
        "ss_builder_affiliate_setting_tour_title_step_1": "T\xe1c v\u1EE5 nhanh",
        "ss_builder_affiliate_setting_tour_title_step_2": "Ti\xeau \u0111\u1EC1 v\xe0 M\xf4 t\u1EA3",
        "ss_builder_affiliate_setting_tour_title_step_3": "C\u1EA5u h\xecnh hi\u1EC3n th\u1ECB s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_setting_tour_title_step_4": "Qu\u1EA3n l\xfd nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_setting_tour_title_step_5": "Nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_setting_tour_title_step_6": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_setting_tour_title_step_7": "T\xf9y ch\u1ECDn t\u1EEBng s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_setting_tour_title_step_8": "L\u01B0u s\u1EA3n ph\u1EA9m",
        "ss_builder_affiliate_upload_product_error_content": "T\u1EC7p t\u1EA3i l\xean c\u1EA7n l\xe0 t\u1EC7p json v\xe0 c\xf3 \u0111\u1ECBnh d\u1EA1ng ph\xf9 h\u1EE3p",
        "ss_builder_affiliate_upload_product_error_label": "T\u1EC7p kh\xf4ng h\u1EE3p l\u1EC7",
        "ss_builder_affiliate_upload_product_label": "T\u1EA3i t\u1EC7p s\u1EA3n ph\u1EA9m",
        "ss_builder_all_setting_and_product": "c\xe1c thi\u1EBFt l\u1EADp v\xe0 t\u1EA5t c\u1EA3 s\u1EA3n ph\u1EA9m",
        "ss_builder_all_the_blocks_are_in_your_list_by_the_blocks_of_the_template": "t\u1EA5t c\u1EA3 c\xe1c kh\u1ED1i \u0111ang c\xf3 trong danh s\xe1ch c\u1EE7a b\u1EA1n b\u1EB1ng c\xe1c kh\u1ED1i c\u1EE7a m\u1EABu",
        "ss_builder_allowed_domain_label": "T\xean mi\u1EC1n ch\u01B0a t\u1ED3n t\u1EA1i, b\u1EA1n c\xf3 th\u1EC3 d\xf9ng t\xean mi\u1EC1n n\xe0y",
        "ss_builder_an_unexpected_error_has_occurred": "\u0110\xe3 x\u1EA3y ra l\u1ED7i kh\xf4ng mong mu\u1ED1n t\u1EEB h\u1EC7 th\u1ED1ng.",
        "ss_builder_apply_preview_theme_template_btn_label": "\xc1p d\u1EE5ng",
        "ss_builder_apply_template_successfully_label": "\xc1p d\u1EE5ng m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_apply_template_title": "B\u1EA1n mu\u1ED1n \xe1p d\u1EE5ng m\u1EABu n\xe0y?",
        "ss_builder_apply_theme_premium_warning": "Giao di\u1EC7n d\xe0nh ri\xeang cho t\xe0i kho\u1EA3n tr\u1EA3 ph\xed. Vui l\xf2ng n\xe2ng c\u1EA5p t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n \u0111\u1EC3 \xe1p d\u1EE5ng m\u1EABu n\xe0y.",
        "ss_builder_apply_theme_premium_warning_title": "B\u1EA1n mu\u1ED1n \xe1p d\u1EE5ng giao di\u1EC7n n\xe0y?",
        "ss_builder_apply_theme_template_successfully_label": "\xc1p d\u1EE5ng giao di\u1EC7n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_auto_cleanup_products_warning_content_1": "V\u01B0\u1EE3t qu\xe1 s\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m. H\u1EC7 th\u1ED1ng s\u1EBD t\u1EF1 d\u1ECDn d\u1EB9p nh\u1EEFng s\u1EA3n ph\u1EA9m \u1EDF cu\u1ED1i danh s\xe1ch khi b\u1EA1n th\xeam m\u1EDBi.",
        "ss_builder_auto_cleanup_products_warning_content_2": "L\u01B0u \xfd: Nh\u1EEFng s\u1EA3n ph\u1EA9m \u0111ang \u201CKh\xf3a d\u1ECDn d\u1EB9p\u201D s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c t\u1EF1 \u0111\u1ED9ng d\u1ECDn d\u1EB9p.",
        "ss_builder_back": "Quay l\u1EA1i",
        "ss_builder_background_block": "N\u1EC1n kh\u1ED1i",
        "ss_builder_background_enable_overlay": "L\u1EDBp ph\u1EE7",
        "ss_builder_background_opacity": "\u0110\u1ED9 l\xe0m m\u1EDD",
        "ss_builder_background_overlay_color": "M\xe0u l\u1EDBp ph\u1EE7",
        "ss_builder_background_popover_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng cho thi\u1EBFt l\u1EADp n\u1EC1n vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1\u201D",
        "ss_builder_background_popover_manual_title": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_background_setting_title": "Thi\u1EBFt l\u1EADp n\u1EC1n",
        "ss_builder_background_tour_content_step_1": "Ph\u1EA7n xem tr\u01B0\u1EDBc cho c\xe1c thi\u1EBFt l\u1EADp b\xean d\u01B0\u1EDBi, c\u1EADp nh\u1EADt th\u1EDDi gian th\u1EF1c theo c\xe1c thay \u0111\u1ED5i.",
        "ss_builder_background_tour_content_step_2": "B\u1EA1n c\xf3 th\u1EC3 thi\u1EBFt l\u1EADp \u1EA3nh n\u1EC1n cho trang c\u1EE7a b\u1EA1n b\u1EB1ng \u201C\u1EA2nh\u201D ho\u1EB7c \u201CM\xe0u s\u1EAFc\u201D. V\u1EDBi m\xe0u s\u1EAFc b\u1EA1n c\xf3 th\u1EC3 l\u1EF1a ch\u1ECDn \u201CM\xe0u \u0111\u1EB7c\u201D ho\u1EB7c \u201CD\u1EA3i m\xe0u\u201D",
        "ss_builder_background_tour_title_step_1": "Ph\u1EA7n xem tr\u01B0\u1EDBc",
        "ss_builder_background_tour_title_step_2": "N\u1EC1n b\u1EB1ng \u1EA3nh ho\u1EB7c m\xe0u s\u1EAFc",
        "ss_builder_basic_group_description": "C\xe1c kh\u1ED1i c\u01A1 b\u1EA3n",
        "ss_builder_basic_title": "C\u01A1 b\u1EA3n",
        "ss_builder_bio_add_social_link_title": "Th\xeam m\u1EA1ng x\xe3 h\u1ED9i",
        "ss_builder_bio_avatar_title": "\u1EA2nh \u0111\u1EA1i di\u1EC7n",
        "ss_builder_bio_layout_title": "B\u1ED1 c\u1EE5c",
        "ss_builder_bio_name_sub_placeholder": "Nh\u1EADp ti\xeau \u0111\u1EC1 ph\u1EE5",
        "ss_builder_bio_name_title": "T\xean hi\u1EC3n th\u1ECB",
        "ss_builder_bio_name_title_placeholder": "Nh\u1EADp t\xean hi\u1EC3n th\u1ECB",
        "ss_builder_bio_social_link_btn_select_icon_label": "Ch\u1ECDn icon",
        "ss_builder_bio_social_link_icon_title": "Bi\u1EC3u t\u01B0\u1EE3ng",
        "ss_builder_bio_social_link_url_title": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_bio_sub_title": "Ti\xeau \u0111\u1EC1 ph\u1EE5",
        "ss_builder_bio_text_title": "Gi\u1EDBi thi\u1EC7u b\u1EA3n th\xe2n",
        "ss_builder_block_affiliate_description": "Gi\u1EDBi thi\u1EC7u c\xe1c s\u1EA3n ph\u1EA9m Affiliate \u0111\u1EBFn Fan c\u1EE7a b\u1EA1n",
        "ss_builder_block_background_blur": "\u0110\u1ED9 l\xe0m m\u1EDD",
        "ss_builder_block_background_color": "Ma\u0300u n\xea\u0300n",
        "ss_builder_block_bio_description": "\u1EA2nh \u0111\u1EA1i di\u1EC7n, th\xf4ng tin gi\u1EDBi thi\u1EC7u v\xe0 c\xe1c li\xean k\u1EBFt m\u1EA1ng x\xe3 h\u1ED9i",
        "ss_builder_block_block_card_description": "Hi\u1EC3n th\u1ECB danh s\xe1ch h\xecnh \u1EA3nh k\xe8m nhi\u1EC1u th\xf4ng tin v\u1EDBi b\u1ED1 c\u1EE5c \u0111a d\u1EA1ng v\xe0 c\xf3 th\u1EC3 tr\u01B0\u1EE3t",
        "ss_builder_block_booking_file_alert_content": "Vui l\xf2ng t\u1EA1o Booking Profile tr\u01B0\u1EDBc khi thi\u1EBFt l\u1EADp",
        "ss_builder_block_booking_file_alert_title": "B\u1EA1n ch\u01B0a t\u1EA1o Booking Profile",
        "ss_builder_block_booking_file_button_label_default": "H\u1ED3 s\u01A1 c\xf4ng vi\u1EC7c",
        "ss_builder_block_booking_file_label": "\u0110\u01B0\u1EDDng d\u1EABn Booking Profile",
        "ss_builder_block_booking_file_link_tooltip": "Kh\u1ED1i Booking Profile s\u1EBD li\xean k\u1EBFt \u0111\u1EBFn \u0111\u01B0\u1EDDng d\u1EABn n\xe0y",
        "ss_builder_block_booking_file_switch_tooltip": "Hi\u1EC3n th\u1ECB li\xean k\u1EBFt t\u1EDBi Booking Profile c\u1EE7a b\u1EA1n \u1EDF khu v\u1EF1c Bio",
        "ss_builder_block_booking_profile_button_label": "N\u1ED9i dung n\xfat",
        "ss_builder_block_booking_profile_setting_description": "M\xf4 t\u1EA3",
        "ss_builder_block_booking_profile_setting_title": "Ti\xeau \u0111\u1EC1",
        "ss_builder_block_border_color": "M\xe0u vi\u1EC1n",
        "ss_builder_block_border_style": "Phong c\xe1ch",
        "ss_builder_block_brand_gift_description": "B\u1EA1n h\xe3y l\u01B0u c\xe0i \u0111\u1EB7t floating icon \u0111\u1EC3 gi\xfap b\u1EA1n t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan c\u1EE7a m\xecnh nhi\u1EC1u h\u01A1n",
        "ss_builder_block_brand_gift_footer_description": "B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_builder_block_button_link_description": "Li\xean k\u1EBFt \u0111\u01A1n \u0111\u1EBFn trang y\xeau th\xedch c\u1EE7a b\u1EA1n tr\xean internet",
        "ss_builder_block_button_multi_description": "Danh s\xe1ch c\xe1c li\xean k\u1EBFt \u0111\u01A1n \u0111\u1EBFn c\xe1c trang y\xeau th\xedch c\u1EE7a b\u1EA1n tr\xean internet",
        "ss_builder_block_button_story_description": "Hi\u1EC3n th\u1ECB c\xe1c li\xean k\u1EBFt n\u1ED5i b\u1EADt tr\xean site c\u1EE7a b\u1EA1n b\u1EB1ng h\xecnh \u1EA3nh v\xe0 ch\u1EEF",
        "ss_builder_block_combined_description": "K\u1EBFt h\u1EE3p c\xe1c kh\u1ED1i c\xf3 s\u1EB5n th\xe0nh m\u1ED9t ki\u1EC3u kh\u1ED1i m\u1EDBi",
        "ss_builder_block_combined_description_label": "K\u1EBFt h\u1EE3p c\xe1c kh\u1ED1i c\xf3 s\u1EB5n th\xe0nh m\u1ED9t ki\u1EC3u kh\u1ED1i m\u1EDBi",
        "ss_builder_block_combined_description_placeholder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_block_combined_heading_label": "Ti\xeau \u0111\u1EC1 kh\u1ED1i",
        "ss_builder_block_description": "M\xf4 t\u1EA3 kh\u1ED1i",
        "ss_builder_block_description_label": "M\xf4 t\u1EA3",
        "ss_builder_block_description_placeholder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_block_design_hiding_label": "Kh\u1ED1i \u0111ang b\u1ECB \u1EA9n",
        "ss_builder_block_digital_product_description": "B\xe1n s\u1EA3n ph\u1EA9m s\u1ED1 tr\xean Passio Page",
        "ss_builder_block_donation_description": "Nh\u1EADn ti\u1EC1n \u1EE7ng h\u1ED9 t\u1EEB Fan",
        "ss_builder_block_heading_label": "Ti\xeau \u0111\u1EC1 kh\u1ED1i",
        "ss_builder_block_heading_placeholder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_block_image_description": "Th\xeam m\u1ED9t h\xecnh \u1EA3nh v\xe0o trang c\u1EE7a b\u1EA1n",
        "ss_builder_block_image_embed_description": "Nh\xfang b\u1EA5t k\u1EF3 m\xe3 nh\xfang n\xe0o v\xe0o site c\u1EE7a b\u1EA1n: video, \xe2m thanh, form,...",
        "ss_builder_block_image_gallery_description": "Danh s\xe1ch h\xecnh \u1EA3nh v\u1EDBi b\u1ED1 c\u1EE5c \u0111a d\u1EA1ng v\xe0 c\xf3 th\u1EC3 ph\xf3ng to",
        "ss_builder_block_image_popup_description": "\u1EA2nh s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB d\u1EA1ng popup khi fan truy c\u1EADp v\xe0o trang c\xe1 nh\xe2n c\u1EE7a b\u1EA1n",
        "ss_builder_block_image_slider_description": "Danh s\xe1ch h\xecnh \u1EA3nh d\u1EA1ng tr\u01B0\u1EE3t ngang",
        "ss_builder_block_is_hiding_label": "Kh\u1ED1i \u0111ang b\u1ECB \u1EA9n",
        "ss_builder_block_link_copy_successfully_label": "\u0110\xe3 sao ch\xe9p",
        "ss_builder_block_list_combined_description": "K\u1EBFt h\u1EE3p c\xe1c kh\u1ED1i c\xf3 s\u1EB5n th\xe0nh m\u1ED9t ki\u1EC3u kh\u1ED1i m\u1EDBi",
        "ss_builder_block_main_color": "M\xe0u ch\xednh",
        "ss_builder_block_outside_space": "Kho\u1EA3ng c\xe1ch ngo\xe0i kh\u1ED1i",
        "ss_builder_block_rating_answer_1": "Giao di\u1EC7n",
        "ss_builder_block_rating_answer_2": "Th\u1EDDi gian t\u1EA3i trang",
        "ss_builder_block_rating_answer_3": "Tr\u1EA3i nghi\u1EC7m",
        "ss_builder_block_rating_answer_4": "H\u1ED7 tr\u1EE3",
        "ss_builder_block_rating_answer_5": "Kh\xe1c",
        "ss_builder_block_rating_button_submit_rating": "G\u1EEDi \u0111\xe1nh gi\xe1",
        "ss_builder_block_rating_button_title_open_popup": "G\u1EEDi \u0111\xe1nh gi\xe1",
        "ss_builder_block_rating_content_rating": "N\u1ED9i dung \u0111\xe1nh gi\xe1",
        "ss_builder_block_rating_content_rating_placeholder": "H\xe3y \u0111\u1EC3 l\u1EA1i g\xf3p \xfd cho Passio Page nh\xe9",
        "ss_builder_block_rating_description": "S\u1EBD th\u1EADt tuy\u1EC7t v\u1EDDi n\u1EBFu Passio Page nh\u1EADn \u0111\u01B0\u1EE3c \u0111\xe1nh gi\xe1 c\u1EE7a b\u1EA1n \u0111\u1EC3 n\xe2ng cao ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5",
        "ss_builder_block_rating_description_auto_show": "\u0110\xe1nh gi\xe1 c\u1EE7a b\u1EA1n v\u1EC1 Passio Page",
        "ss_builder_block_rating_description_star_1": "B\u1EA1n th\u1EA5y ch\u01B0a h\xe0i l\xf2ng v\xec",
        "ss_builder_block_rating_description_star_2": "B\u1EA1n th\u1EA5y ch\u01B0a h\xe0i l\xf2ng v\xec",
        "ss_builder_block_rating_description_star_3": "Passio Page c\u1EA7n c\u1EA3i ti\u1EBFn v\u1EC1",
        "ss_builder_block_rating_description_star_4": "B\u1EA1n th\u1EA5y h\xe0i l\xf2ng v\xec",
        "ss_builder_block_rating_description_star_5": "B\u1EA1n th\u1EA5y h\xe0i l\xf2ng v\xec",
        "ss_builder_block_rating_star_1": "Th\u1EA5t v\u1ECDng",
        "ss_builder_block_rating_star_2": "Ch\xe1n nh\u1EC9",
        "ss_builder_block_rating_star_3": "D\xf9ng \u0111\u01B0\u1EE3c",
        "ss_builder_block_rating_star_4": "T\u1ED1t \u0111\xf3",
        "ss_builder_block_rating_star_5": "Xu\u1EA5t s\u1EAFc",
        "ss_builder_block_rating_title": "\u0110\xe1nh gi\xe1 c\u1EE7a b\u1EA1n",
        "ss_builder_block_rating_toast_success_rating": "C\u1EA3m \u01A1n b\u1EA1n \u0111\xe3 \u0111\xe1nh gi\xe1",
        "ss_builder_block_second_color": "M\xe0u ph\u1EE5",
        "ss_builder_block_setting_title": "Thi\u1EBFt l\u1EADp kh\u1ED1i",
        "ss_builder_block_shadow_color": "M\xe0u \u0111\u1ED5 b\xf3ng",
        "ss_builder_block_space": "Kho\u1EA3ng c\xe1ch gi\u1EEFa c\xe1c kh\u1ED1i",
        "ss_builder_block_spacer_and_divider_description": "Th\xeam kho\u1EA3ng c\xe1ch ho\u1EB7c d\u1EA3i ph\xe2n c\xe1ch gi\u1EEFa c\xe1c kh\u1ED1i c\u1EE7a b\u1EA1n",
        "ss_builder_block_text_description": "Th\xeam n\u1ED9i dung v\xe0o trang c\u1EE7a b\u1EA1n b\u1EB1ng v\u0103n b\u1EA3n c\xf3 \u0111\u1ECBnh d\u1EA1ng",
        "ss_builder_block_text_see_more_btn_default_title": "Xem th\xeam",
        "ss_builder_block_truth_or_dare_description": "Ch\u01A1i t\u1EDBi b\u1EBFn v\u1EDBi game Truth or Dare",
        "ss_builder_block_truth_or_dare_footer_description": "Hi\u1EC3n th\u1ECB icon Truth or Dare \u1EDF g\xf3c m\xe0n h\xecnh",
        "ss_builder_block_virtual_gift_description": "B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 nh\u1EADn qu\xe0 t\u1EB7ng t\u1EEB Fan",
        "ss_builder_block_virtual_gift_footer_description": "Hi\u1EC3n th\u1ECB icon nh\u1EADn qu\xe0 \u1EDF g\xf3c m\xe0n h\xecnh",
        "ss_builder_blocks_general_settings_label": "Thi\u1EBFt l\u1EADp chung c\xe1c kh\u1ED1i",
        "ss_builder_blocks_general_settings_popover_content": "B\u1EADt \u0111\u1EC3 \xe1p d\u1EE5ng \u201CThi\u1EBFt l\u1EADp kh\u1ED1i\u201D trong ph\u1EA7n thi\u1EBFt l\u1EADp to\xe0n trang cho c\xe1c kh\u1ED1i \u1EDF danh s\xe1ch ph\xeda d\u01B0\u1EDBi",
        "ss_builder_blocks_label": "Kh\u1ED1i",
        "ss_builder_blocks_list": "Danh s\xe1ch",
        "ss_builder_blocks_list_empty_content": "\u0110\u1EC3 th\xeam kh\u1ED1i vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_blocks_list_empty_title": "Ch\u01B0a c\xf3 kh\u1ED1i n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_body_description": "C\xf3 th\u1EC3 s\u1EED d\u1EE5ng c\xe1c Tabs \u0111\u1EC3 ph\xe2n chia danh s\xe1ch c\xe1c kh\u1ED1i th\xe0nh t\u1EEBng ph\u1EA7n",
        "ss_builder_body_introduction_description": '"Th\xe2n trang" l\xe0 ph\u1EA7n n\u1ED9i dung ch\xednh c\u1EE7a trang, ch\u1EE9a c\xe1c Kh\u1ED1i v\xe0 \u0111\u01B0\u1EE3c ph\xe2n chia, \u0111i\u1EC1u h\u01B0\u1EDBng b\u1EDFi Tabs. V\xed d\u1EE5 nh\u01B0: n\u1ED9i dung, h\xecnh \u1EA3nh, s\u1EA3n ph\u1EA9m,...',
        "ss_builder_body_introduction_title": "V\u1ECB tr\xed Th\xe2n trang",
        "ss_builder_body_title": "Th\xe2n trang",
        "ss_builder_bold": "\u0110\u1EADm",
        "ss_builder_booking_profile_style_1": "Th\u1EBB n\u1ED9i dung",
        "ss_builder_booking_profile_style_2": "M\xe3 nh\xfang",
        "ss_builder_border_dash": "N\xe9t \u0111\u1EE9t",
        "ss_builder_border_dot": "N\xe9t ch\u1EA5m",
        "ss_builder_border_radius_label": "\u0110\u1ED9 bo g\xf3c",
        "ss_builder_border_radius_style": "Ki\u1EC3u bo g\xf3c",
        "ss_builder_border_solid": "N\xe9t li\u1EC1n",
        "ss_builder_bottom_position_tab_label": "D\u01B0\u1EDBi c\xf9ng",
        "ss_builder_box_icon_button_filter": "L\u1ECDc",
        "ss_builder_box_icon_empty_search": "Kh\xf4ng th\u1EA5y k\u1EBFt qu\u1EA3 n\xe0o",
        "ss_builder_box_icon_empty_searching_description": "H\xe3y th\u1EED v\u1EDBi t\u1EEB kh\xf3a kh\xe1c",
        "ss_builder_box_icon_filter_category_all": "T\u1EA5t c\u1EA3",
        "ss_builder_box_icon_filter_category_sub_title": "Ch\u1ECDn danh m\u1EE5c icon",
        "ss_builder_box_icon_filter_category_title": "B\u1ED9 l\u1ECDc",
        "ss_builder_box_icon_search_bar_placeholder": "T\xecm ki\u1EBFm icon theo t\xean...",
        "ss_builder_bp_apply_block_settings_instruction": "T\u1EAFt \u0111\u1EC3 hi\u1EC3n th\u1ECB to\xe0n chi\u1EC1u r\u1ED9ng m\xe0n h\xecnh. B\u1EADt \u0111\u1EC3 hi\u1EC3n th\u1ECB theo thi\u1EBFt l\u1EADp kh\u1ED1i nh\u01B0 c\xe1c kh\u1ED1i th\xf4ng th\u01B0\u1EDDng.",
        "ss_builder_bp_open_new_tab_instruction": "B\u1EADt \u0111\u1EC3 hi\u1EC3n th\u1ECB icon m\u1EDF c\u1EEDa s\u1ED5 m\u1EDBi \u1EDF g\xf3c ph\u1EA3i",
        "ss_builder_bp_open_new_tab_title": "M\u1EDF c\u1EEDa s\u1ED5 m\u1EDBi",
        "ss_builder_brand_gift_introduction_popup_title": "Th\xeam icon Brand Gift",
        "ss_builder_browser_opening_label": "M\u1EDF tr\xean tr\xecnh duy\u1EC7t",
        "ss_builder_button_background_color": "M\xe0u n\u1EC1n",
        "ss_builder_button_border_color": "M\xe0u vi\u1EC1n",
        "ss_builder_button_border_width": "\u0110\u1ED9 d\xe0y vi\u1EC1n (px)",
        "ss_builder_button_close_introduction_service": "\u0110\xf3ng",
        "ss_builder_button_font_size": "K\xedch th\u01B0\u1EDBc ch\u1EEF (px)",
        "ss_builder_button_font_weight": "\u0110\u1ED9 \u0111\u1EADm ch\u1EEF",
        "ss_builder_button_line_height": "Chi\u1EC1u cao d\xf2ng",
        "ss_builder_button_link_content_title": "Ti\xeau \u0111\u1EC1 li\xean k\u1EBFt",
        "ss_builder_button_link_description": "M\xf4 t\u1EA3 li\xean k\u1EBFt",
        "ss_builder_button_link_icon_btn_selection_label": "Ch\u1ECDn icon",
        "ss_builder_button_link_icon_origin_url_label": "\u0110\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_button_link_icon_title": "Ch\u1ECDn icon",
        "ss_builder_button_link_large_size_label": "L\u1EDBn",
        "ss_builder_button_link_middle_size_label": "V\u1EEBa",
        "ss_builder_button_link_not_enought_infomation": "Link ch\u01B0a \u0111\u1EE7 th\xf4ng tin",
        "ss_builder_button_link_placeholder_content_title": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_button_link_size_selection_title": "Ch\u1ECDn k\xedch th\u01B0\u1EDBc",
        "ss_builder_button_link_small_size_label": "Nh\u1ECF",
        "ss_builder_button_setting_title": "Thi\u1EBFt l\u1EADp n\xfat b\u1EA5m",
        "ss_builder_button_text_color": "M\xe0u ch\u1EEF",
        "ss_builder_button_title": "Ti\xeau \u0111\u1EC1 n\xfat",
        "ss_builder_cancel": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel-delete_block_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel-delete_image_label": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_cancel-delete_social_link_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel-delete_tab_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel-restore_theme_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel-set_default_tab_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_affiliate_product_group_add_new_panel_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_apply_theme_template_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_block_btn_label": "Tho\xe1t",
        "ss_builder_cancel_delete_aff_block_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_delete_card_modal_btn_label": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_cancel_delete_link_modal_btn_label": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_cancel_delete_product_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_delete_theme_template_modal_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_edit_block_content": "C\xe1c ch\u1EC9nh s\u1EEDa c\u1EE7a b\u1EA1n s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u. B\u1EA1n c\xf3 ch\u1EAFc ch\u1EAFn mu\u1ED1n tho\xe1t kh\xf4ng?",
        "ss_builder_cancel_edit_block_title": "Tho\xe1t ch\u1EC9nh s\u1EEDa?",
        "ss_builder_cancel_hide_product_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_image_slider_add_new_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_overwrite_theme_template_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_preview_theme_template_btn_label": "\u0110\xf3ng",
        "ss_builder_cancel_product_addition_modal_confirm_btn_label": "Ti\u1EBFp t\u1EE5c th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_cancel_product_addition_modal_description": "C\xe1c s\u1EA3n ph\u1EA9m \u0111\xe3 th\xeam t\u1EA1i m\xe0n h\xecnh n\xe0y s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u.",
        "ss_builder_cancel_product_addition_modal_title": "H\u1EE7y th\xeam s\u1EA3n ph\u1EA9m?",
        "ss_builder_cancel_replace_theme_template_btn_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_select_multi_items": "Hu\u1EF7 b\u1ECF",
        "ss_builder_cancel_theme_selection_panel_label": "H\u1EE7y b\u1ECF",
        "ss_builder_cancel_upload_image": "Hu\u1EF7 b\u1ECF",
        "ss_builder_card_add_new_description_label": "M\xf4 t\u1EA3",
        "ss_builder_card_add_new_label": "Nh\xe3n",
        "ss_builder_card_add_new_subtitle_label": "Ph\u1EE5 \u0111\u1EC1",
        "ss_builder_card_add_new_title_label": "Ti\xeau \u0111\u1EC1",
        "ss_builder_card_add_new_url_label": "\u0110\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_card_additional_btn_label": "Th\xeam card",
        "ss_builder_card_btn_content_label": "N\u1ED9i dung n\xfat",
        "ss_builder_card_layout_alert_1": "B\u1ED1 c\u1EE5c n\xe0y s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB m\xf4 t\u1EA3, nh\xe3n v\xe0 n\xfat",
        "ss_builder_card_layout_alert_2": "B\u1ED1 c\u1EE5c n\xe0y s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB m\xf4 t\u1EA3 v\xe0 n\xfat",
        "ss_builder_card_layout_label": "B\u1ED1 c\u1EE5c",
        "ss_builder_card_layout_label_1": "Ch\u1EEF d\u01B0\u1EDBi \u1EA3nh tr\xe1i",
        "ss_builder_card_layout_label_2": "Ch\u1EEF d\u01B0\u1EDBi \u1EA3nh gi\u1EEFa",
        "ss_builder_card_layout_label_3": "Ch\u1EEF tr\xean \u1EA3nh gi\u1EEFa",
        "ss_builder_card_layout_label_4": "Ch\u1EEF tr\xean \u1EA3nh tr\xe1i",
        "ss_builder_card_layout_label_5": "Ch\u1EEF ph\u1EA3i",
        "ss_builder_card_layout_label_6": "Ch\u1EEF tr\xe1i",
        "ss_builder_card_layout_label_7": "Ch\u1EEF tr\xean \u1EA3nh tr\xe1i 2",
        "ss_builder_card_layout_label_8": "Ch\u1EEF tr\xean \u1EA3nh gi\u1EEFa 2",
        "ss_builder_card_url_placeholder": "http://domain.com",
        "ss_builder_category_14_up": "14+",
        "ss_builder_category_all": "T\u1EA5t c\u1EA3",
        "ss_builder_category_art": "Art",
        "ss_builder_category_creative": "S\xe1ng t\u1EA1o",
        "ss_builder_category_doctor": "Doctor",
        "ss_builder_category_education": "Gi\xe1o d\u1EE5c",
        "ss_builder_category_entertainment": "Entertainment",
        "ss_builder_category_fashion": "Th\u1EDDi trang",
        "ss_builder_category_fitness": "Fitness",
        "ss_builder_category_food_fmcg": "Food & FMCG",
        "ss_builder_category_game": "Game",
        "ss_builder_category_health_and_beauty": "S\u1EE9c kh\u1ECFe v\xe0 l\xe0m \u0111\u1EB9p",
        "ss_builder_category_ict": "ICT",
        "ss_builder_category_life_style": "Phong c\xe1ch s\u1ED1ng",
        "ss_builder_category_lifestyle": "Phong c\xe1ch s\u1ED1ng",
        "ss_builder_category_mom_and_kid": "M\u1EB9 v\xe0 b\xe9",
        "ss_builder_category_others": "Kh\xe1c",
        "ss_builder_category_pet": "Pet",
        "ss_builder_category_spirit": "Spirit",
        "ss_builder_change_image_button_label": "\u0110\u1ED5i \u1EA3nh",
        "ss_builder_change_name_product_group_successfully_label": "\u0110\u1ED5i t\xean nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_change_theme_label": "Thay \u0111\u1ED5i giao di\u1EC7n",
        "ss_builder_choose_a_prototying_method": "Ch\u1ECDn ph\u01B0\u01A1ng th\u1EE9c t\u1EA1o m\u1EABu",
        "ss_builder_choose_at_least_category": "Ch\u1ECDn \xedt nh\u1EA5t 1 l\u0129nh v\u1EF1c v\xe0 ch\xfang t\xf4i s\u1EBD g\u1EE3i \xfd giao di\u1EC7n d\u1EF1a tr\xean l\u1EF1a ch\u1ECDn c\u1EE7a b\u1EA1n \uD83D\uDC47",
        "ss_builder_choose_image_below": '\u0110\u1EC3 th\xeam m\u1EE5c m\u1EDBi vui l\xf2ng nh\u1EA5n n\xfat "Th\xeam m\u1EDBi" \u1EDF ph\xeda d\u01B0\u1EDBi',
        "ss_builder_choose_one_theme_preview_you_can_customize_it_later": "Ch\u1ECDn m\u1ED9t ch\u1EE7 \u0111\u1EC1 ph\xf9 h\u1EE3p, b\u1EA1n c\xf3 th\u1EC3 t\xf9y ch\u1EC9nh sau khi \xe1p d\u1EE5ng\u2728",
        "ss_builder_choose_the_look_that_right_for_you": "Ch\u1ECDn giao di\u1EC7n",
        "ss_builder_choose_this_template": "\xc1p d\u1EE5ng",
        "ss_builder_cleanup_lock_product_successfully_label": "Kh\xf3a d\u1ECDn d\u1EB9p s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_cleanup_unlock_product_successfully_label": "M\u1EDF kh\xf3a d\u1ECDn d\u1EB9p s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_close_panel": "H\u1EE7y b\u1ECF",
        "ss_builder_close_panel_affiliate_product-selection-label": "H\u1EE7y b\u1ECF",
        "ss_builder_close_panel_edit_text_block": "\u0110\xf3ng",
        "ss_builder_collapse": "Thu g\u1ECDn",
        "ss_builder_color_1": "M\xe0u 1",
        "ss_builder_color_2": "M\xe0u 2",
        "ss_builder_color_picker_panel_title": "Ch\u1ECDn m\xe0u",
        "ss_builder_confirm-cancel_image_slider_add_new_content": "C\xe1c thao t\xe1c c\u1EE7a b\u1EA1n ch\u01B0a \u0111\u01B0\u1EE3c l\u01B0u.\nB\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n tho\xe1t kh\xf4ng ?",
        "ss_builder_confirm-cancel_image_slider_add_new_title": "Tho\xe1t ch\u1EC9nh s\u1EEDa?",
        "ss_builder_confirm-delete_block_label": "N\u1EBFu b\u1EA1n x\xf3a kh\u1ED1i, c\xe1c thi\u1EBFt l\u1EADp kh\u1ED1i v\xe0 d\u1EEF li\u1EC7u \u0111\xe3 \u0111\u01B0\u1EE3c th\xeam v\xe0o kh\u1ED1i s\u1EBD b\u1ECB x\xf3a v\u0129nh vi\u1EC5n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a kh\xf4ng?",
        "ss_builder_confirm-delete_block_title": "B\u1EA1n mu\u1ED1n x\xf3a kh\u1ED1i n\xe0y?",
        "ss_builder_confirm-delete_image_label": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a \u1EA3nh n\xe0y?",
        "ss_builder_confirm-delete_image_title": "X\xf3a \u1EA3nh",
        "ss_builder_confirm-delete_social_link_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a m\u1EE5c n\xe0y?",
        "ss_builder_confirm-delete_social_link_title": "X\xf3a m\u1EA1ng x\xe3 h\u1ED9i?",
        "ss_builder_confirm_affiliate_product_group_add_new_panel_label": "L\u01B0u",
        "ss_builder_confirm_apply_template_description": "Vi\u1EC7c \xe1p d\u1EE5ng m\u1EABu s\u1EBD thay th\u1EBF t\u1EA5t c\u1EA3 c\xe1c kh\u1ED1i \u0111ang c\xf3 trong danh s\xe1ch c\u1EE7a b\u1EA1n b\u1EB1ng c\xe1c kh\u1ED1i c\u1EE7a m\u1EABu.",
        "ss_builder_confirm_apply_template_label": "Thay th\u1EBF",
        "ss_builder_confirm_apply_theme_template_btn_label": "X\xe1c nh\u1EADn \xe1p d\u1EE5ng",
        "ss_builder_confirm_apply_theme_template_content": "Vi\u1EC7c \xe1p d\u1EE5ng giao di\u1EC7n b\u1EA1n ch\u1ECDn s\u1EBD thay \u0111\u1ED5i to\xe0n b\u1ED9 giao di\u1EC7n trang c\u1EE7a b\u1EA1n",
        "ss_builder_confirm_apply_theme_template_title": "B\u1EA1n mu\u1ED1n \xe1p d\u1EE5ng giao di\u1EC7n n\xe0y?",
        "ss_builder_confirm_cancel_image_slider_add_new_btn_label": "Tho\xe1t",
        "ss_builder_confirm_cleanup_lock_product_btn_label": "X\xe1c nh\u1EADn kh\xf3a",
        "ss_builder_confirm_cleanup_lock_product_selection_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n kh\xf3a d\u1ECDn d\u1EB9p {{product_quantity}} s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_cleanup_unlock_product_btn_label": "X\xe1c nh\u1EADn m\u1EDF",
        "ss_builder_confirm_cleanup_unlock_product_selection_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n m\u1EDF kh\xf3a d\u1ECDn d\u1EB9p {{product_quantity}} s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_delete_aff_block_content": "Thao t\xe1c n\xe0y kh\xf4ng th\u1EC3 ho\xe0n t\xe1c. H\xe3y x\xe1c nh\u1EADn, b\u1EA1n hi\u1EC3u vi\u1EC7c x\xf3a kh\u1ED1i n\xe0y s\u1EBD x\xf3a to\xe0n b\u1ED9 c\xe1c s\u1EA3n ph\u1EA9m b\xean trong.",
        "ss_builder_confirm_delete_aff_block_input_placeholder": "OK",
        "ss_builder_confirm_delete_aff_block_label_enter_ok": "Nh\u1EADp \u201COK\u201D \u0111\u1EC3 x\xe1c nh\u1EADn",
        "ss_builder_confirm_delete_aff_block_understood": "T\xf4i \u0111\xe3 hi\u1EC3u",
        "ss_builder_confirm_delete_aff_block_warining": "C\u1EA3nh b\xe1o",
        "ss_builder_confirm_delete_block_btn_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_confirm_delete_card_modal_btn_label": "X\xf3a card",
        "ss_builder_confirm_delete_card_modal_description": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a card n\xe0y?",
        "ss_builder_confirm_delete_card_modal_label": "X\xf3a card",
        "ss_builder_confirm_delete_combined_label": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 kh\u1ED1i {{type}}?",
        "ss_builder_confirm_delete_image_popup_image_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 {{quantity}} li\xean k\u1EBFt n\xe0y?",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_title": "Xo\xe1 li\xean k\u1EBFt",
        "ss_builder_confirm_delete_item_checkbox_card_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 {{quantity}} th\u1EBB n\u1ED9i dung n\xe0y?",
        "ss_builder_confirm_delete_item_checkbox_card_modal_title": "Xo\xe1 th\u1EBB n\u1ED9i dung",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 {{quantity}} kh\u1ED1i n\xe0y?",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_title": "Xo\xe1 kh\u1ED1i",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 {{quantity}} \u1EA3nh n\xe0y?",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_title": "Xo\xe1 \u1EA3nh",
        "ss_builder_confirm_delete_item_checkbox_story_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n xo\xe1 {{quantity}} ti\xeau \u0111i\u1EC3m n\xe0y?",
        "ss_builder_confirm_delete_item_checkbox_story_modal_title": "Xo\xe1 ti\xeau \u0111i\u1EC3m",
        "ss_builder_confirm_delete_link_description": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a link n\xe0y?",
        "ss_builder_confirm_delete_product_group_modal_description": 'Nh\xf3m "{{group_name}}" v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB x\xf3a v\u0129nh vi\u1EC5n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a?',
        "ss_builder_confirm_delete_product_group_modal_title": "B\u1EA1n mu\u1ED1n x\xf3a nh\xf3m?",
        "ss_builder_confirm_delete_product_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_confirm_delete_product_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_delete_product_modal_title": "X\xf3a s\u1EA3n ph\u1EA9m",
        "ss_builder_confirm_delete_product_selection_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a {{product_quantity}} s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_delete_tab_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_confirm_delete_template_modal_content": "X\xf3a v\u0129nh vi\u1EC5n m\u1EABu n\xe0y kh\u1ECFi danh s\xe1ch m\u1EABu, c\xe1c kh\u1ED1i s\u1EED d\u1EE5ng m\u1EABu n\xe0y tr\u01B0\u1EDBc \u0111\xf3 s\u1EBD kh\xf4ng b\u1ECB \u1EA3nh h\u01B0\u1EDFng",
        "ss_builder_confirm_delete_template_modal_title": "B\u1EA1n mu\u1ED1n x\xf3a m\u1EABu?",
        "ss_builder_confirm_delete_theme_template_modal_btn_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_confirm_delete_theme_template_modal_content": "X\xf3a v\u0129nh vi\u1EC5n giao di\u1EC7n m\u1EABu kh\u1ECFi c\u1EEDa h\xe0ng giao di\u1EC7n, nh\u1EEFng theme \u0111\u01B0\u1EE3c t\u1EA1o ra t\u1EEB giao di\u1EC7n m\u1EABu n\xe0y s\u1EBD kh\xf4ng b\u1ECB \u1EA3nh h\u01B0\u1EDFng",
        "ss_builder_confirm_delete_theme_template_modal_title": "B\u1EA1n mu\u1ED1n x\xf3a giao di\u1EC7n m\u1EABu?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{quantity}} li\xean k\u1EBFt n\xe0y?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_title": "\u1EA8n li\xean k\u1EBFt",
        "ss_builder_confirm_disable_item_checkbox_card_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{quantity}} th\u1EBB n\u1ED9i dung n\xe0y?",
        "ss_builder_confirm_disable_item_checkbox_card_modal_title": "\u1EA8n th\u1EBB n\u1ED9i dung",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{quantity}} kh\u1ED1i n\xe0y?",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_title": "\u1EA8n kh\u1ED1i",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{quantity}} \u1EA3nh n\xe0y?",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_title": "\u1EA8n \u1EA3nh",
        "ss_builder_confirm_disable_item_checkbox_story_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{quantity}} ti\xeau \u0111i\u1EC3m n\xe0y?",
        "ss_builder_confirm_disable_item_checkbox_story_modal_title": "\u1EA8n ti\xeau \u0111i\u1EC3m",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{quantity}} li\xean k\u1EBFt n\xe0y?",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_title": "Hi\u1EC7n li\xean k\u1EBFt",
        "ss_builder_confirm_enable_item_checkbox_card_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{quantity}} th\u1EBB n\u1ED9i dung n\xe0y?",
        "ss_builder_confirm_enable_item_checkbox_card_modal_title": "Hi\u1EC7n th\u1EBB n\u1ED9i dung",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{quantity}} kh\u1ED1i n\xe0y?",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_title": "Hi\u1EC7n kh\u1ED1i",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{quantity}} \u1EA3nh n\xe0y?",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_title": "Hi\u1EC7n \u1EA3nh",
        "ss_builder_confirm_enable_item_checkbox_story_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{quantity}} ti\xeau \u0111i\u1EC3m n\xe0y?",
        "ss_builder_confirm_enable_item_checkbox_story_modal_title": "Hi\u1EC7n ti\xeau \u0111i\u1EC3m",
        "ss_builder_confirm_enable_product_selection_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n hi\u1EC7n {{product_quantity}} s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_hide_product_btn_label": "X\xe1c nh\u1EADn \u1EA9n",
        "ss_builder_confirm_hide_product_group_modal_description": 'Nh\xf3m "{{group_name}}" v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB \u1EA9n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n nh\xf3m?',
        "ss_builder_confirm_hide_product_group_modal_title": "B\u1EA1n mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_builder_confirm_hide_product_label": "X\xe1c nh\u1EADn \u1EA9n nh\xf3m",
        "ss_builder_confirm_hide_product_selection_modal_content": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n {{product_quantity}} s\u1EA3n ph\u1EA9m n\xe0y?",
        "ss_builder_confirm_overwrite": "X\xe1c nh\u1EADn l\u01B0u \u0111\xe8",
        "ss_builder_confirm_overwrite_theme_template_btn_label": "X\xe1c nh\u1EADn l\u01B0u \u0111\xe8",
        "ss_builder_confirm_overwrite_theme_template_modal_content": "L\u01B0u \u0111\xe8 s\u1EBD thay th\u1EBF to\xe0n b\u1ED9 d\u1EEF li\u1EC7u v\xe0 thi\u1EBFt l\u1EADp c\u1EE7a Theme m\u1EABu b\u1EB1ng d\u1EEF li\u1EC7u v\xe0 thi\u1EBFt l\u1EADp c\u1EE7a Theme hi\u1EC7n t\u1EA1i",
        "ss_builder_confirm_overwrite_theme_template_modal_title": "B\u1EA1n mu\u1ED1n l\u01B0u \u0111\xe8?",
        "ss_builder_confirm_panel": "X\xe1c nh\u1EADn",
        "ss_builder_confirm_panel_affiliate_product-selection-label": "X\xe1c nh\u1EADn",
        "ss_builder_confirm_panel_edit_text_block": "X\xe1c nh\u1EADn",
        "ss_builder_confirm_replace_theme_template_btn_label": "\xc1p d\u1EE5ng n\u1ED9i dung m\u1EABu",
        "ss_builder_confirm_replace_theme_template_content": "Thao t\xe1c n\xe0y kh\xf4ng th\u1EC3 ho\xe0n t\xe1c.\nH\xe3y x\xe1c nh\u1EADn, b\u1EA1n hi\u1EC3u vi\u1EC7c \xe1p d\u1EE5ng n\u1ED9i dung m\u1EABu s\u1EBD thay th\u1EBF to\xe0n b\u1ED9 d\u1EEF li\u1EC7u \u0111\xe3 c\xf3 tr\xean trang.",
        "ss_builder_confirm_replace_theme_template_input_placeholder": "OK",
        "ss_builder_confirm_replace_theme_template_label_enter_ok": "Nh\u1EADp \u201COK\u201D \u0111\u1EC3 x\xe1c nh\u1EADn",
        "ss_builder_confirm_replace_theme_template_understood": "T\xf4i \u0111\xe3 hi\u1EC3u",
        "ss_builder_confirm_replace_theme_template_warining": "C\u1EA3nh b\xe1o",
        "ss_builder_confirm_restore_theme_label": "Kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_confirm_set_default_tab_label": "\u0110\u1EB7t m\u1EB7c \u0111\u1ECBnh",
        "ss_builder_confirm_show_product_btn_label": "X\xe1c nh\u1EADn hi\u1EC7n",
        "ss_builder_confirm_theme_template_preview_mode_btn_label": "\xc1p d\u1EE5ng",
        "ss_builder_confirm_to_edit_label": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_content_1_introduction_service": 'Brand Gift l\xe0 h\xecnh th\u1EE9c qu\u1EA3ng b\xe1 c\xe1c CTKM, deal hot t\u1EEB th\u01B0\u01A1ng hi\u1EC7u d\xe0nh cho fan/followers nh\u1EB1m t\u0103ng cao t\u1EC9 l\u1EC7 "ch\u1ED1t \u0111\u01A1n" v\xe0 mang v\u1EC1 hoa h\u1ED3ng "kh\u1EE7ng" cho creators.. V\u1EDBi m\u1ED7i l\u01B0\u1EE3t l\u01B0u voucher th\xe0nh c\xf4ng t\u1EEB link Brand Gift, b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c nh\u1EADn \u0111\u01B0\u1EE3c ch\xednh s\xe1ch hoa h\u1ED3ng si\xeau h\u1EA5p d\u1EABn:',
        "ss_builder_content_2_introduction_service": "B\u1EADt Brand Gift \u0111\u1EC3 nh\u1EADn ti\u1EC1n th\u01B0\u1EDFng lu\xf4n k\u1EBBo l\u1EE1!",
        "ss_builder_content_creators_joined_the_passio_system": "100K+ nh\xe0 s\xe1ng t\u1EA1o n\u1ED9i dung \u0111\xe3 tham gia v\xe0o h\u1EC7 th\u1ED1ng Passio",
        "ss_builder_content_editor_title": "N\u1ED9i dung",
        "ss_builder_content_list_1_introduction_service": "Hoa h\u1ED3ng s\xe0n",
        "ss_builder_content_list_2_introduction_service": "Hoa h\u1ED3ng th\u01B0\u01A1ng hi\u1EC7u (up to 30%)",
        "ss_builder_content_list_3_introduction_service": "500+ th\u01B0\u01A1ng hi\u1EC7u l\u1EDBn thu\u1ED9c \u0111a l\u0129nh v\u1EF1c v\u1EDBi nhi\u1EC1u ch\u01B0\u01A1ng tr\xecnh bonus",
        "ss_builder_continue_add_brand_gift": "Kh\xe1m ph\xe1 ngay",
        "ss_builder_continue_edit_block_label": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_continue_edit_image_popup_image_label": "H\u1EE7y b\u1ECF",
        "ss_builder_continue_to_add_block": "Ti\u1EBFp t\u1EE5c",
        "ss_builder_convert_and_go_to_new_version": "\u0110\u1ED3ng b\u1ED9 v\xe0 \u0111\u1EBFn Passio Page",
        "ss_builder_cover_image": "\u1EA2nh b\xeca",
        "ss_builder_create_bio_page_free_fast": "T\u1EA1o Biopage mi\u1EC5n ph\xed & nhanh ch\xf3ng",
        "ss_builder_create_link_with_your_name_and_imprint": "T\u1EA1o trang c\xe1 nh\xe2n mang t\xean v\xe0 d\u1EA5u \u1EA5n c\u1EE7a b\u1EA1n. Kho giao di\u1EC7n nhi\u1EC1u ch\u1EE7 \u0111\u1EC1 \u0111a d\u1EA1ng, c\xf3 th\u1EC3 t\xf9y bi\u1EBFn d\u1EC5 d\xe0ng ngay tr\xean \u0111i\u1EC7n tho\u1EA1i.",
        "ss_builder_create_new_theme_template_label": "T\u1EA1o giao di\u1EC7n m\u1EABu m\u1EDBi",
        "ss_builder_create_template": "T\u1EA1o m\u1EABu",
        "ss_builder_cusom": "T\xf9y ch\u1EC9nh",
        "ss_builder_custom": "T\xf9y ch\u1EC9nh",
        "ss_builder_dashed_type_label": "N\xe9t \u0111\u1EE9t",
        "ss_builder_data_auto_convert": "H\u1EC7 th\u1ED1ng s\u1EBD t\u1EF1 \u0111\u1ED9ng \u0111\u1ED3ng b\u1ED9 d\u1EEF li\u1EC7u t\u1EEB Landing Page c\u0169 sang Passio Page m\u1EDBi.",
        "ss_builder_data_can_be_convert": "B\u1EA1n c\xf3 th\u1EC3 \u0111\u1ED3ng b\u1ED9 l\u1EA1i d\u1EEF li\u1EC7u t\u1EEB Landing Page c\u0169 sang Passio Page m\u1EDBi.",
        "ss_builder_data_will_be_override": "L\u01B0u \xfd: N\u1EBFu \u0111\u1ED3ng b\u1ED9 l\u1EA1i s\u1EBD ghi \u0111\xe8 l\xean d\u1EEF li\u1EC7u \u0111ang c\xf3 tr\xean Passio Page",
        "ss_builder_deep_blue_sky": "B\u1EA7u tr\u1EDDi trong xanh th\u0103m th\u1EB3m",
        "ss_builder_default_meta_description": "Passio Page - Ng\xf4i nh\xe0 c\u1EE7a {{creator_name}}",
        "ss_builder_defaults_label": "M\u1EB7c \u0111\u1ECBnh",
        "ss_builder_delete_block_label": "X\xf3a kh\u1ED1i",
        "ss_builder_delete_block_successfully_label": "X\xf3a kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_delete_card_label": "X\xf3a card",
        "ss_builder_delete_card_successfully_label": "X\xf3a card th\xe0nh c\xf4ng",
        "ss_builder_delete_image_label": "X\xf3a \u1EA3nh",
        "ss_builder_delete_image_successfully_label": "X\xf3a \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_delete_item_checkbox_button_multi_link_successfully_label": "Xo\xe1 li\xean k\u1EBFt th\xe0nh c\xf4ng",
        "ss_builder_delete_item_checkbox_card_successfully_label": "Xo\xe1 th\u1EBB n\u1ED9i dung th\xe0nh c\xf4ng",
        "ss_builder_delete_item_checkbox_combined_successfully_label": "Xo\xe1 kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_delete_item_checkbox_image_gallery_successfully_label": "Xo\xe1 \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_delete_item_checkbox_story_successfully_label": "Xo\xe1 ti\xeau \u0111i\u1EC3m th\xe0nh c\xf4ng",
        "ss_builder_delete_link_label": "X\xf3a link",
        "ss_builder_delete_link_successfully_label": "X\xf3a link th\xe0nh c\xf4ng",
        "ss_builder_delete_product_group_error_btn_confirm_label": "\u0110\xf3ng",
        "ss_builder_delete_product_group_error_content": 'Nh\xf3m "{{group_name}}" kh\xf4ng th\u1EC3 b\u1ECB x\xf3a, c\u1EA7n t\u1ED1i thi\u1EC3u hi\u1EC3n th\u1ECB 1 nh\xf3m.',
        "ss_builder_delete_product_group_error_title": "L\u1ED7i x\xf3a nh\xf3m",
        "ss_builder_delete_product_group_label": "X\xf3a nh\xf3m",
        "ss_builder_delete_product_group_successfully_label": "X\xf3a nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_delete_product_label": "X\xf3a s\u1EA3n ph\u1EA9m",
        "ss_builder_delete_product_successfully_label": "X\xf3a s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_delete_social_link_btn_label": "X\xe1c nh\u1EADn x\xf3a",
        "ss_builder_delete_social_link_label": "X\xf3a",
        "ss_builder_delete_social_link_successfully_label": "X\xf3a m\u1EA1ng x\xe3 h\u1ED9i th\xe0nh c\xf4ng",
        "ss_builder_delete_tab_content": 'Tab "{{tab_name}}" v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c kh\u1ED1i b\xean trong s\u1EBD b\u1ECB x\xf3a v\u0129nh vi\u1EC5n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a?',
        "ss_builder_delete_tab_label": "X\xf3a",
        "ss_builder_delete_tab_successfully_label": "X\xf3a tab th\xe0nh c\xf4ng",
        "ss_builder_delete_tab_title": "B\u1EA1n mu\u1ED1n x\xf3a tab?",
        "ss_builder_delete_template_successfully_label": "X\xf3a m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_delete_theme_template_label": "X\xf3a",
        "ss_builder_delete_theme_template_successfully_label": "X\xf3a giao di\u1EC7n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_description": "M\xf4 t\u1EA3",
        "ss_builder_description_page_builder": "X\xe2y d\u1EF1ng trang c\xe1 nh\xe2n ch\u1EC9 v\u1EDBi 1 click v\xe0 b\u1EAFt \u0111\u1EA7u ki\u1EBFm ti\u1EC1n ngay",
        "ss_builder_description_replace_template_content": "\xc1p d\u1EE5ng n\u1ED9i dung m\u1EABu s\u1EBD s\u1EED d\u1EE5ng to\xe0n b\u1ED9 n\u1ED9i dung t\u1EEB giao di\u1EC7n m\u1EABu thay th\u1EBF cho n\u1ED9i dung \u0111ang c\xf3 tr\xean trang c\u1EE7a b\u1EA1n",
        "ss_builder_design_group_floating_title": "Floating icons",
        "ss_builder_design_group_image_popup_title": "Popup",
        "ss_builder_design_label": "Thi\u1EBFt k\u1EBF",
        "ss_builder_dialog_error_confirm_text": "L\xe0m m\u1EDBi",
        "ss_builder_dialog_error_content": "\u0110\xe3 c\xf3 thay \u0111\u1ED5i thi\u1EBFt k\u1EBF t\u1EEB m\u1ED9t thi\u1EBFt b\u1ECB kh\xe1c. B\u1EA1n c\u1EA7n l\xe0m m\u1EDBi l\u1EA1i trang.",
        "ss_builder_dialog_error_title": "C\xf3 thay \u0111\u1ED5i x\u1EA3y ra",
        "ss_builder_digital_product_free_label": "Mi\u1EC5n ph\xed",
        "ss_builder_digital_product_list_title": "Danh s\xe1ch s\u1EA3n ph\u1EA9m",
        "ss_builder_direction_of_background_image_label": "V\u1ECB tr\xed \u1EA3nh n\u1EC1n",
        "ss_builder_disable_block_successfully_label": "\u1EA8n kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_disable_image_successfully_label": "\u1EA8n \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_disable_item_checkbox_button_multi_link_successfully_label": "\u1EA8n li\xean k\u1EBFt th\xe0nh c\xf4ng",
        "ss_builder_disable_item_checkbox_card_successfully_label": "\u1EA8n th\u1EBB n\u1ED9i dung th\xe0nh c\xf4ng",
        "ss_builder_disable_item_checkbox_combined_successfully_label": "\u1EA8n kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_disable_item_checkbox_image_gallery_successfully_label": "\u1EA8n \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_disable_item_checkbox_story_successfully_label": "\u1EA8n ti\xeau \u0111i\u1EC3m th\xe0nh c\xf4ng",
        "ss_builder_disable_product_group_successfully_label": "\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_disable_product_successfully_label": "\u1EA8n s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_disable_social_link_successfully_label": "\u1EA8n m\u1EA1ng x\xe3 h\u1ED9i th\xe0nh c\xf4ng",
        "ss_builder_disable_tab_successfully_label": "\u1EA8n tab th\xe0nh c\xf4ng",
        "ss_builder_disable_theme_successfully_label": "\u1EA8n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_discover_now": "Kh\xe1m ph\xe1 ngay",
        "ss_builder_distance_blocks": "Kho\u1EA3ng c\xe1ch gi\u1EEFa c\xe1c kh\u1ED1i",
        "ss_builder_divider_color_label": "M\xe0u d\u1EA3i ph\xe2n c\xe1ch",
        "ss_builder_divider_image_label": "\u1EA2nh d\u1EA3i ph\xe2n c\xe1ch",
        "ss_builder_divider_label": "D\u1EA3i ph\xe2n c\xe1ch",
        "ss_builder_divider_thickness_label": "\u0110\u1ED9 d\u1EA7y n\xe9t (px)",
        "ss_builder_do_you_want_replace_sample_content": "B\u1EA1n mu\u1ED1n \xe1p d\u1EE5ng n\u1ED9i dung giao di\u1EC7n m\u1EABu?",
        "ss_builder_domain_site_setting_alert_infomation": "N\u1EBFu b\u1EA1n \u0111\u1ED5i t\xean mi\u1EC1n, b\u1EA1n s\u1EBD ph\u1EA3i \u0111\u1EE3i 30 ng\xe0y cho l\u1EA7n ti\u1EBFp theo",
        "ss_builder_domain_site_setting_rule": "B\u1EAFt \u0111\u1EA7u b\u1EB1ng ch\u1EEF, ch\u1EC9 ch\u1EE9a s\u1ED1 v\xe0 ch\u1EEF",
        "ss_builder_done_panel": "Xong",
        "ss_builder_dont_add_block_from_template_description": "Kh\xf4ng th\u1EC3 th\xeam {{number_block}} kh\u1ED1i t\u1EEB m\u1EABu do gi\u1EDBi h\u1EA1n 10 kh\u1ED1i trong danh s\xe1ch. Vui l\xf2ng x\xf3a b\u1EDBt kh\u1ED1i \u0111\xe3 c\xf3 \u0111\u1EC3 th\xeam kh\u1ED1i m\u1EABu.",
        "ss_builder_dont_add_block_from_template_title": "Kh\xf4ng th\u1EC3 th\xeam kh\u1ED1i",
        "ss_builder_dont_add_product_exist_at_add_new_content": "S\u1EA3n ph\u1EA9m b\u1EA1n mu\u1ED1n th\xeam \u0111\xe3 c\xf3 trong danh s\xe1ch s\u1EA3n ph\u1EA9m th\xeam m\u1EDBi.",
        "ss_builder_dont_add_product_exist_at_list_content": 'S\u1EA3n ph\u1EA9m b\u1EA1n mu\u1ED1n th\xeam \u0111\xe3 c\xf3 trong nh\xf3m s\u1EA3n ph\u1EA9m "{{group_name}}".',
        "ss_builder_dont_add_same_affiliate_product_confirm_label": "\u0110\u1ED3ng \xfd",
        "ss_builder_dont_add_same_affiliate_product_modal_label": "Kh\xf4ng th\xeam \u0111\u01B0\u1EE3c s\u1EA3n ph\u1EA9m",
        "ss_builder_dont_apply_template_content_modal_description": "Qu\xe1 tr\xecnh \xe1p d\u1EE5ng m\u1EABu kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n \u0111\u01B0\u1EE3c do m\u1EABu kh\xf4ng c\xf2n t\u1ED3n t\u1EA1i.",
        "ss_builder_dont_apply_theme_content_modal_btn_confirm_label": "\u0110\xf3ng",
        "ss_builder_dont_apply_theme_content_modal_description": "Qu\xe1 tr\xecnh \xe1p d\u1EE5ng d\u1EEF li\u1EC7u m\u1EABu kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n \u0111\u01B0\u1EE3c do giao di\u1EC7n m\u1EABu kh\xf4ng c\xf2n t\u1ED3n t\u1EA1i \u1EDF c\u1EEDa h\xe0ng giao di\u1EC7n.",
        "ss_builder_dont_apply_theme_content_modal_label": "Kh\xf4ng th\u1EC3 \xe1p d\u1EE5ng",
        "ss_builder_dot_strokes_type_label": "N\xe9t ch\u1EA5m",
        "ss_builder_dp_title_intro": "S\u1EA3n ph\u1EA9m s\u1ED1",
        "ss_builder_drop_here_label": "Th\xeam kh\u1ED1i v\xe0o \u0111\xe2y",
        "ss_builder_duplicated_product_url_label": "\u0110\u01B0\u1EDDng d\u1EABn b\u1ECB tr\xf9ng l\u1EB7p",
        "ss_builder_duplicated_theme_template_name_warning": "T\xean giao di\u1EC7n m\u1EABu \u0111\xe3 t\u1ED3n t\u1EA1i. Vui l\xf2ng nh\u1EADp t\xean kh\xe1c!",
        "ss_builder_earn_additional_commissions_label": "Ki\u1EBFm extra commission khi s\u1EED d\u1EE5ng link affiliate c\u1EE7a Passio",
        "ss_builder_edit_affiliate_product_group_title": "T\xean nh\xf3m",
        "ss_builder_edit_affiliate_product_title": "Ch\u1EC9nh s\u1EEDa s\u1EA3n ph\u1EA9m",
        "ss_builder_edit_block_label": "Ch\u1EC9nh s\u1EEDa",
        "ss_builder_edit_block_successfully_label": "Ch\u1EC9nh s\u1EEDa kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_edit_image_of_image_popup_title": "Ch\u1EC9nh s\u1EEDa \u1EA3nh popup",
        "ss_builder_edit_name_affiliate_product_group_title": "\u0110\u1ED5i t\xean nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_edit_name_block_successfully_label": "C\u1EADp nh\u1EADt t\xean kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_edit_product_group_label": "\u0110\u1ED5i t\xean nh\xf3m",
        "ss_builder_edit_tab_label": "\u0110\u1ED5i t\xean",
        "ss_builder_edit_tab_successfully_label": "C\u1EADp nh\u1EADt tab th\xe0nh c\xf4ng",
        "ss_builder_edit_template_btn_label": "L\u01B0u",
        "ss_builder_edit_template_title": "S\u1EEDa th\xf4ng tin m\u1EABu",
        "ss_builder_edit_text_block_label": "T\xean kh\u1ED1i",
        "ss_builder_edit_theme_btn_label": "L\u01B0u",
        "ss_builder_edit_theme_template_label": "S\u1EEDa th\xf4ng tin",
        "ss_builder_edit_theme_template_successfully_label": "C\u1EADp nh\u1EADt th\xe0nh c\xf4ng",
        "ss_builder_edit_theme_template_title": "S\u1EEDa th\xf4ng tin giao di\u1EC7n m\u1EABu",
        "ss_builder_editor_btn-add-more": "Th\xeam",
        "ss_builder_editor_btn-cancel": "H\u1EE7y b\u1ECF",
        "ss_builder_editor_btn-save": "L\u01B0u",
        "ss_builder_email_placeholder": "Nh\u1EADp email",
        "ss_builder_embed_code_label": "M\xe3 nh\xfang",
        "ss_builder_embed_code_placeholder": "Vui l\xf2ng nh\u1EADp m\xe3 nh\xfang",
        "ss_builder_empty_block": "Ch\u01B0a c\xf3 kh\u1ED1i",
        "ss_builder_empty_search": "Kh\xf4ng th\u1EA5y k\u1EBFt qu\u1EA3 n\xe0o",
        "ss_builder_empty_social_link_list_content": "\u0110\u1EC3 th\xeam m\u1EA1ng x\xe3 h\u1ED9i vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_empty_social_link_list_title": "Ch\u01B0a c\xf3 m\u1EA1ng x\xe3 h\u1ED9i n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_empty_template_label": "Ch\u01B0a c\xf3 m\u1EABu n\xe0o",
        "ss_builder_enable_block_successfully_label": "Hi\u1EC7n kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_enable_border": "Hi\u1EC3n th\u1ECB",
        "ss_builder_enable_button_border": "Hi\u1EC3n th\u1ECB vi\u1EC1n",
        "ss_builder_enable_image_successfully_label": "Hi\u1EC7n \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_enable_item_checkbox_button_multi_link_successfully_label": "Hi\u1EC7n li\xean k\u1EBFt th\xe0nh c\xf4ng",
        "ss_builder_enable_item_checkbox_card_successfully_label": "Hi\u1EC7n th\u1EBB n\u1ED9i dung th\xe0nh c\xf4ng",
        "ss_builder_enable_item_checkbox_combined_successfully_label": "Hi\u1EC7n kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_enable_item_checkbox_image_gallery_successfully_label": "Hi\u1EC7n \u1EA3nh th\xe0nh c\xf4ng",
        "ss_builder_enable_item_checkbox_story_successfully_label": "Hi\u1EC7n ti\xeau \u0111i\u1EC3m th\xe0nh c\xf4ng",
        "ss_builder_enable_product_group_successfully_label": "Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_enable_product_successfully_label": "Hi\u1EC7n s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_enable_shadow": "Hi\u1EC3n th\u1ECB",
        "ss_builder_enable_social_link_successfully_label": "Hi\u1EC7n m\u1EA1ng x\xe3 h\u1ED9i th\xe0nh c\xf4ng",
        "ss_builder_enable_tab_successfully_label": "Hi\u1EC7n tab th\xe0nh c\xf4ng",
        "ss_builder_enable_theme_successfully_label": "Hi\u1EC7n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_enable_tracking_link_product_label": "B\u1EADt tracking link",
        "ss_builder_enable_tracking_link_product_successfully_label": "B\u1EADt tracking link th\xe0nh c\xf4ng",
        "ss_builder_enter_domain_site_setting_label": "\u0110\u01B0\u1EDDng d\u1EABn t\xean mi\u1EC1n ri\xeang",
        "ss_builder_enter_font_name": "Nh\u1EADp t\xean ph\xf4ng",
        "ss_builder_enter_url_label": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_enter_your_url": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn c\u1EE7a b\u1EA1n",
        "ss_builder_error_block_label": "L\u1ED7i hi\u1EC3n th\u1ECB kh\u1ED1i",
        "ss_builder_error_invalid_email_message": "Email kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng",
        "ss_builder_error_invalid_phone_message": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng",
        "ss_builder_error_network_confirm_btn_label": "\u0110\xf3ng",
        "ss_builder_error_network_content": "H\u1EC7 th\u1ED1ng \u0111ang b\u1ECB qu\xe1 t\u1EA3i. Vui l\xf2ng th\u1EED l\u1EA1i.",
        "ss_builder_error_network_title": "H\u1EC7 th\u1ED1ng qu\xe1 t\u1EA3i",
        "ss_builder_error_page_title": "Passio Page Builder - {{country}} - Error Page",
        "ss_builder_exceeding_label": "V\u01B0\u1EE3t qu\xe1 gi\u1EDBi h\u1EA1n",
        "ss_builder_existed_product_group_label": "Nh\xf3m \u0111\xe3 t\u1ED3n t\u1EA1i",
        "ss_builder_expand": "Xem th\xeam",
        "ss_builder_expand_introduction_description": "V\u1ECB tr\xed \u201CM\u1EDF r\u1ED9ng\u201D ch\u1EE9a c\xe1c Kh\u1ED1i kh\xf4ng n\u1EB1m c\u1ED1 \u0111\u1ECBnh tr\xean trang. V\xed d\u1EE5 nh\u01B0: Popup, Icon n\u1ED5i",
        "ss_builder_expand_introduction_title": "V\u1ECB tr\xed M\u1EDF r\u1ED9ng",
        "ss_builder_filter_select_combined_count": "kh\u1ED1i \u0111\xe3 ch\u1ECDn",
        "ss_builder_filter_select_multi_items": "{{num_items}} cu\u1ED1i",
        "ss_builder_filter_select_multi_items_card_count": "th\u1EBB n\u1ED9i dung \u0111\xe3 ch\u1ECDn",
        "ss_builder_filter_select_multi_items_gallery_count": "\u1EA3nh \u0111\xe3 ch\u1ECDn",
        "ss_builder_filter_select_multi_items_multi_links_count": "li\xean k\u1EBFt \u0111\xe3 ch\u1ECDn",
        "ss_builder_filter_select_multi_items_spotlight_count": "ti\xeau \u0111i\u1EC3m \u0111\xe3 ch\u1ECDn",
        "ss_builder_first_guide_add_block_btn_title": "Th\xeam kh\u1ED1i",
        "ss_builder_first_guide_add_block_description": 'Nh\u1EA5n ho\u1EB7c K\xe9o & Th\u1EA3 n\xfat "Th\xeam kh\u1ED1i" \u0111\u1EBFn v\u1ECB tr\xed mong mu\u1ED1n \u0111\u1EC3 th\xeam Kh\u1ED1i m\u1EDBi v\xe0o trang c\u1EE7a b\u1EA1n. R\u1EA5t nhi\u1EC1u ki\u1EC3u Kh\u1ED1i c\xf3 s\u1EB5n, gi\xfap b\u1EA1n s\xe1ng t\u1EA1o trang c\xe1 nh\xe2n \u0111\u1EB9p m\u1EAFt, \u0111a m\u1EE5c \u0111\xedch. H\xe3y kh\xe1m ph\xe1 nh\xe9!',
        "ss_builder_first_guide_add_block_title": "N\xfat Th\xeam Kh\u1ED1i",
        "ss_builder_first_guide_preview_btn_title": "Xem tr\u01B0\u1EDBc trang",
        "ss_builder_first_guide_preview_description": "Xem tr\u01B0\u1EDBc trang \u0111\u1EC3 th\u1EA5y c\xe1c thay \u0111\u1ED5i hi\u1EC7n t\u1EA1i c\u1EE7a trang. Ch\u1EC9 n\xean Xu\u1EA5t b\u1EA3n khi b\u1EA1n \u0111\xe3 xem tr\u01B0\u1EDBc v\xe0 h\xe0i l\xf2ng v\u1EDBi c\xe1c thay \u0111\u1ED5i.",
        "ss_builder_first_guide_preview_title": "N\xfat xem tr\u01B0\u1EDBc trang",
        "ss_builder_first_guide_publish_btn_title": "Xu\u1EA5t b\u1EA3n",
        "ss_builder_first_guide_publish_description": 'C\xe1c ch\u1EC9nh s\u1EEDa Thi\u1EBFt k\u1EBF lu\xf4n \u1EDF ch\u1EBF \u0111\u1ED9 "B\u1EA3n nh\xe1p". C\xe1c thay \u0111\u1ED5i s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB cho Fan c\u1EE7a b\u1EA1n sau khi b\u1EA1n quy\u1EBFt \u0111\u1ECBnh "Xu\u1EA5t b\u1EA3n".',
        "ss_builder_first_guide_publish_title": "N\xfat xu\u1EA5t b\u1EA3n thi\u1EBFt k\u1EBF",
        "ss_builder_floating_full": "Ch\u1EC9 \u0111\u01B0\u1EE3c th\xeam t\u1ED1i \u0111a hai kh\u1ED1i trong nh\xf3m Floating icons",
        "ss_builder_floating_introduction_description": "C\xe1c kh\u1ED1i n\u1EB1m trong v\u1ECB tr\xed n\xe0y s\u1EBD hi\u1EC3n th\u1ECB d\u1EA1ng icon n\u1ED5i \u1EDF g\xf3c d\u01B0\u1EDBi, b\xean ph\u1EA3i c\u1EE7a m\xe0n h\xecnh. Lu\xf4n hi\u1EC3n th\u1ECB \u0111\u1EC3 d\u1EC5 d\xe0ng truy c\u1EADp t\u1EDBi.",
        "ss_builder_floating_introduction_title": "Icon n\u1ED5i",
        "ss_builder_font_name_not_exist": "Ph\xf4ng ch\u1EEF kh\xf4ng t\u1ED3n t\u1EA1i",
        "ss_builder_font_option_panel_title": "Ki\u1EC3u ch\u1EEF",
        "ss_builder_footer_description": "C\xe1c kh\u1ED1i n\xe0y s\u1EBD lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF m\u1ECDi Tabs",
        "ss_builder_footer_introduction_description": "\u201CCu\u1ED1i trang\u201D ch\u1EE9a c\xe1c Kh\u1ED1i, lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF ph\u1EA7n d\u01B0\u1EDBi c\xf9ng c\u1EE7a trang. V\xed d\u1EE5 nh\u01B0: li\xean k\u1EBFt nhanh, th\xf4ng tin trang...",
        "ss_builder_footer_introduction_title": "V\u1ECB tr\xed Cu\u1ED1i trang",
        "ss_builder_footer_title": "Cu\u1ED1i trang",
        "ss_builder_frame_aff": "Khung \u1EA3nh s\u1EA3n ph\u1EA9m",
        "ss_builder_general_setting_title": "Thi\u1EBFt l\u1EADp chung",
        "ss_builder_generate_income_from_your_own_fan_community": "T\u1EA1o thu nh\u1EADp t\u1EEB ch\xednh c\u1ED9ng \u0111\u1ED3ng fans c\u1EE7a m\xecnh!",
        "ss_builder_gift_warning": "Ch\u1EC9 \u0111\u01B0\u1EE3c th\xeam m\u1ED9t kh\u1ED1i n\xe0y tr\xean trang",
        "ss_builder_go_back_to_site": "Tr\u1EDF v\u1EC1 trang ch\xednh",
        "ss_builder_google_font": "Google Fonts",
        "ss_builder_gradient": "D\u1EA3i m\xe0u",
        "ss_builder_group_is_full_of_product_modal_description": "Nh\xf3m s\u1EA3n ph\u1EA9m b\u1EA1n ch\u1ECDn \u0111\xe3 \u0111\u1EA7y. Vui l\xf2ng ch\u1ECDn nh\xf3m kh\xe1c",
        "ss_builder_group_is_full_of_product_modal_title": "Kh\xf4ng th\u1EC3 th\xeam",
        "ss_builder_group_is_hiding_label": "Nh\xf3m s\u1EA3n ph\u1EA9m \u0111ang b\u1ECB \u1EA9n",
        "ss_builder_hard_shadow": "\u0110\u1ED5 b\xf3ng c\u1EE9ng",
        "ss_builder_header_description": "C\xe1c kh\u1ED1i n\xe0y s\u1EBD lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF m\u1ECDi Tabs",
        "ss_builder_header_introduction_description": "\u201C\u0110\u1EA7u trang\u201D ch\u1EE9a c\xe1c Kh\u1ED1i, lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF ph\u1EA7n tr\xean c\xf9ng c\u1EE7a trang. V\xed d\u1EE5 nh\u01B0: \u1EA3nh \u0111\u1EA1i di\u1EC7n, ph\u1EA7n gi\u1EDBi thi\u1EC7u...",
        "ss_builder_header_introduction_title": "V\u1ECB tr\xed \u0110\u1EA7u trang",
        "ss_builder_header_title": "\u0110\u1EA7u trang",
        "ss_builder_heading_and_subtitle_site_setting_label": "Ti\xeau \u0111\u1EC1 v\xe0 m\xf4 t\u1EA3 trang",
        "ss_builder_heading_site_setting_description": "\u0110\u01B0\u1EE3c hi\u1EC3n th\u1ECB b\u1EDFi c\xe1c c\xf4ng c\u1EE5 t\xecm ki\u1EBFm trong b\u1EA3n xem tr\u01B0\u1EDBc c\u1EE7a h\u1ECD v\u1EC1 trang c\u1EE7a b\u1EA1n. \u0110i\u1EC1u n\xe0y quan tr\u1ECDng \u0111\u1ED1i v\u1EDBi c\u1EA3 SEO v\xe0 chia s\u1EBB qua m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_builder_heading_site_setting_label": "Ti\xeau \u0111\u1EC1 trang",
        "ss_builder_hide_block_label": "\u1EA8n kh\u1ED1i",
        "ss_builder_hide_card_label": "\u1EA8n card",
        "ss_builder_hide_card_successfully_label": "\u1EA8n card th\xe0nh c\xf4ng",
        "ss_builder_hide_image_label": "\u1EA8n \u1EA3nh",
        "ss_builder_hide_link_label": "\u1EA8n link",
        "ss_builder_hide_link_successfully_label": "\u1EA8n link th\xe0nh c\xf4ng",
        "ss_builder_hide_product_group_error_btn_confirm_label": "\u0110\xf3ng",
        "ss_builder_hide_product_group_error_content": 'Nh\xf3m "{{group_name}}" kh\xf4ng th\u1EC3 b\u1ECB \u1EA9n, c\u1EA7n t\u1ED1i thi\u1EC3u hi\u1EC3n th\u1ECB 1 nh\xf3m.',
        "ss_builder_hide_product_group_error_title": "L\u1ED7i \u1EA9n nh\xf3m",
        "ss_builder_hide_product_group_label": "\u1EA8n nh\xf3m",
        "ss_builder_hide_product_label": "\u1EA8n s\u1EA3n ph\u1EA9m",
        "ss_builder_hide_social_link_label": "\u1EA8n",
        "ss_builder_hide_tab_label": "\u1EA8n Tab",
        "ss_builder_hide_template_successfully_label": "\u1EA8n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_hide_theme_template_label": "\u1EA8n m\u1EABu",
        "ss_builder_hightlight_block_label": "N\u1ED5i b\u1EADt",
        "ss_builder_icon_tab_title": "Bi\u1EC3u t\u01B0\u1EE3ng",
        "ss_builder_if_delete": "N\u1EBFu b\u1EA1n x\xf3a kh\u1ED1i Affiliate",
        "ss_builder_image": "\u1EA2nh",
        "ss_builder_image_description_place_holder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_image_gallery": "Image gallery",
        "ss_builder_image_list_empty_content": "\u0110\u1EC3 th\xeam \u1EA3nh vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_image_list_empty_title": "Ch\u01B0a c\xf3 \u1EA3nh n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_image_orientation": "H\u01B0\u1EDBng \u1EA3nh",
        "ss_builder_image_orientation_label": "H\u01B0\u1EDBng \u1EA3nh",
        "ss_builder_image_popup_introduction_description": "C\xe1c kh\u1ED1i n\u1EB1m trong v\u1ECB tr\xed n\xe0y s\u1EBD bung l\xean d\u1EA1ng popup khi Fan truy c\u1EADp v\xe0o trang c\u1EE7a b\u1EA1n. Popup d\xf9ng \u0111\u1EC3 hi\u1EC3n th\u1ECB th\xf4ng b\xe1o quan tr\u1ECDng, k\xeau g\u1ECDi h\xe0nh \u0111\u1ED9ng, banner qu\u1EA3ng c\xe1o...",
        "ss_builder_image_popup_introduction_title": "Popup",
        "ss_builder_image_popup_warning": "Ch\u1EC9 \u0111\u01B0\u1EE3c th\xeam m\u1ED9t kh\u1ED1i n\xe0y tr\xean trang",
        "ss_builder_image_ratio_title": "Ch\u1ECDn t\u1EF7 l\u1EC7",
        "ss_builder_image_selection_label": "Ch\u1ECDn \u1EA3nh",
        "ss_builder_image_slider_arrow_switch_title": "M\u0169i t\xean",
        "ss_builder_image_slider_auto_play_switch_title": "T\u1EF1 \u0111\u1ED9ng chuy\u1EC3n",
        "ss_builder_image_slider_dot_switch_title": "Dot slider",
        "ss_builder_image_slider_list_title": "Danh s\xe1ch \u1EA3nh",
        "ss_builder_image_slider_ratio_selected_title": "T\u1EF7 l\u1EC7 \u1EA3nh",
        "ss_builder_image_title_place_holder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_import_multi_product_url_popover_content": "B\u1EA1n c\xf3 th\u1EC3 nh\u1EADp m\u1ED9t ho\u1EB7c nhi\u1EC1u \u0111\u01B0\u1EDDng d\u1EABn. M\u1ED7i \u0111\u01B0\u1EDDng d\u1EABn tr\xean m\u1ED9t d\xf2ng.",
        "ss_builder_import_site_url_label": "Import s\u1EA3n ph\u1EA9m t\u1EEB URL",
        "ss_builder_import_site_url_modal_button_label": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_import_site_url_modal_description": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn \u0111\u1EC3 import, h\u1ED7 tr\u1EE3: koc.asia, mycollection.shop, linktr.ee, msha.ke",
        "ss_builder_import_site_url_modal_title": "\u0110\u01B0\u1EDDng d\u1EABn trang s\u1EA3n ph\u1EA9m",
        "ss_builder_in_block_delete_forever_are_you_sure": "trong kh\u1ED1i s\u1EBD b\u1ECB x\xf3a v\u0129nh vi\u1EC5n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a kh\xf4ng?",
        "ss_builder_information_handler_alert": "\u0110ang x\u1EED l\xfd th\xf4ng tin. Vui l\xf2ng ch\u1EDD trong gi\xe2y l\xe1t.",
        "ss_builder_inner_space": "Kho\u1EA3ng c\xe1ch trong kh\u1ED1i",
        "ss_builder_intro_brand_gift_floating_continue": "Th\xeam ngay",
        "ss_builder_intro_brand_gift_floating_description": "Th\xeam Brand Gift icon ngay \u0111\u1EC3 gi\xfap followers s\u0103n deal ch\u1ED1t \u0111\u01A1n th\xe0nh c\xf4ng",
        "ss_builder_intro_brand_gift_floating_reject": "T\u1EEB ch\u1ED1i",
        "ss_builder_intro_brand_gift_floating_title": "X2 thu nh\u1EADp c\xf9ng Brand Gift Floating Icon",
        "ss_builder_intro_brand_rating_floating_description": "Th\xeam t\xednh n\u0103ng ngay \u0111\u1EC3 gi\xfap Fan s\u0103n deal th\xe0nh c\xf4ng v\xe0 t\u0103ng thu nh\u1EADp",
        "ss_builder_intro_brand_rating_floating_title": "Brand Ratings",
        "ss_builder_introduce_double_tap_button": "Ti\u1EBFp t\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_introduce_double_tap_content": "Ngo\xe0i c\xe1ch ch\u1ECDn \u201CCh\u1EC9nh s\u1EEDa\u201D \u1EDF t\u1EEBng kh\u1ED1i b\u1EA1n c\xf3 th\u1EC3 nh\u1EA5n \u0111\xfap tr\u1EF1c ti\u1EBFp v\xe0o kh\u1ED1i \u0111\u1EC3 ch\u1EC9nh s\u1EEDa.",
        "ss_builder_introduce_double_tap_label_check": "Kh\xf4ng hi\u1EC3n th\u1ECB l\u1EA1i l\u1EA7n sau",
        "ss_builder_introduce_double_tap_title": "M\u1EB9o ch\u1EC9nh s\u1EEDa kh\u1ED1i",
        "ss_builder_invalid_product_url_label": "\u0110\u01B0\u1EDDng d\u1EABn kh\xf4ng h\u1EE3p l\u1EC7",
        "ss_builder_invalid_url": "\u0110\u01B0\u1EDDng d\u1EABn kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng",
        "ss_builder_items_per_row": "S\u1ED1 item tr\xean m\u1ED9t h\xe0ng",
        "ss_builder_keep_the_content": "Gi\u1EEF l\u1EA1i n\u1ED9i dung",
        "ss_builder_landscape_image_orientation_label": "Theo chi\u1EC1u ngang",
        "ss_builder_limit_reached": "\u0110\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n",
        "ss_builder_link_additional_btn_label": "Th\xeam Link",
        "ss_builder_link_select_service": "Ch\u1ECDn d\u1ECBch v\u1EE5",
        "ss_builder_link_text_left_layout": "Ch\u1EEF tr\xe1i",
        "ss_builder_link_text_right_layout": "Ch\u1EEF ph\u1EA3i",
        "ss_builder_link_text_under_layout": "Ch\u1EEF d\u01B0\u1EDBi",
        "ss_builder_link_text_zig_zag_layout": "Zig Zag",
        "ss_builder_link_type_email": "Email",
        "ss_builder_link_type_phone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
        "ss_builder_link_type_service": "D\u1ECBch v\u1EE5",
        "ss_builder_link_type_tel": "Tel",
        "ss_builder_link_type_web": "Web",
        "ss_builder_link_url": "\u0110\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_list_button_multi_link_label": "Danh s\xe1ch",
        "ss_builder_list_card_empty_content": "\u0110\u1EC3 th\xeam th\u1EBB n\u1ED9i dung vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_list_card_empty_title": "Ch\u01B0a c\xf3 th\u1EBB n\u1ED9i dung n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_list_card_label": "Danh s\xe1ch card",
        "ss_builder_list_image_popup_title": "Danh s\xe1ch",
        "ss_builder_list_label": "Danh s\xe1ch",
        "ss_builder_list_link_empty_content": "\u0110\u1EC3 th\xeam li\xean k\u1EBFt vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_list_link_empty_title": "Ch\u01B0a c\xf3 li\xean k\u1EBFt n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_list_title_digital_product": "Danh s\xe1ch",
        "ss_builder_loading_label": "\u0110ang t\u1EA3i",
        "ss_builder_malformed_domain_warning": "T\xean mi\u1EC1n kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng cho ph\xe9p",
        "ss_builder_malformed_embed_code_warning": "M\xe3 nh\xfang kh\xf4ng h\u1EE3p l\u1EC7",
        "ss_builder_manage_block_description": "Ss Builder Manage Block Description",
        "ss_builder_manage_block_title": "Qu\u1EA3n l\xfd kh\u1ED1i",
        "ss_builder_manage_tab_description": "Tabs d\xf9ng \u0111\u1EC3 ph\xe2n chia danh s\xe1ch c\xe1c kh\u1ED1i th\xe0nh t\u1EEBng ph\u1EA7n",
        "ss_builder_manage_tab_title": "Qu\u1EA3n l\xfd Tab",
        "ss_builder_management_digital_product_description": "Danh s\xe1ch s\u1EA3n ph\u1EA9m s\u1ED1 c\u1EE7a b\u1EA1n",
        "ss_builder_management_digital_product_title": "Digital Product",
        "ss_builder_management_label": "Qu\u1EA3n tr\u1ECB",
        "ss_builder_medium": "V\u1EEBa",
        "ss_builder_missing_required_product_url_label": "Thi\u1EBFu th\xf4ng tin b\u1EAFt bu\u1ED9c",
        "ss_builder_modal_button_close": "\u0110\xf3ng",
        "ss_builder_move_block_successfully_label": "Di chuy\u1EC3n kh\u1ED1i th\xe0nh c\xf4ng",
        "ss_builder_move_down_block_label": "Chuy\u1EC3n xu\u1ED1ng d\u01B0\u1EDBi",
        "ss_builder_move_product_label": "Di chuy\u1EC3n t\u1EDBi",
        "ss_builder_move_product_quantity_to_group_alert_label": "Di chuy\u1EC3n {{product_quantity}} s\u1EA3n ph\u1EA9m t\u1EDBi nh\xf3m",
        "ss_builder_move_product_successfully_label": "Di chuy\u1EC3n s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_builder_move_to_bottom_label": "Xu\u1ED1ng d\u01B0\u1EDBi c\xf9ng",
        "ss_builder_move_to_top_label": "L\xean tr\xean c\xf9ng",
        "ss_builder_move_up_block_label": "Chuy\u1EC3n l\xean tr\xean",
        "ss_builder_multi_product_url_imported_label": "\u0110\xe3 th\xeam {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_multi_product_url_importing_label": "\u0110ang th\xeam {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_name_tab_input_title": "T\xean Tab",
        "ss_builder_need_to_display_at_least_one_block": "C\u1EA7n hi\u1EC3n th\u1ECB t\u1ED1i thi\u1EC3u m\u1ED9t kh\u1ED1i",
        "ss_builder_need_to_display_at_least_one_card": "C\u1EA7n hi\u1EC3n th\u1ECB t\u1ED1i thi\u1EC3u m\u1ED9t th\u1EBB n\u1ED9i dung",
        "ss_builder_need_to_display_at_least_one_image": "C\u1EA7n hi\u1EC3n th\u1ECB t\u1ED1i thi\u1EC3u m\u1ED9t \u1EA3nh",
        "ss_builder_need_to_display_at_least_one_link": "C\u1EA7n hi\u1EC3n th\u1ECB t\u1ED1i thi\u1EC3u m\u1ED9t li\xean k\u1EBFt",
        "ss_builder_need_to_display_at_least_one_spotlight": "C\u1EA7n hi\u1EC3n th\u1ECB t\u1ED1i thi\u1EC3u m\u1ED9t ti\xeau \u0111i\u1EC3m",
        "ss_builder_next": "Ti\u1EBFp theo",
        "ss_builder_no_image_selected": "Danh s\xe1ch r\u1ED7ng",
        "ss_builder_no_photo_has_been_selected": "Ch\u01B0a c\xf3 \u1EA3nh n\xe0o \u0111\u01B0\u1EE3c ch\u1ECDn",
        "ss_builder_no_shadow": "Kh\xf4ng \u0111\u1ED5 b\xf3ng",
        "ss_builder_no_themes_found_theme_store": "Kh\xf4ng c\xf3 giao di\u1EC7n n\xe0o",
        "ss_builder_none_of_image_description": '\u0110\u1EC3 th\xeam \u1EA3nh popup vui l\xf2ng nh\u1EA5n n\xfat "Th\xeam" \u1EDF ph\xeda tr\xean',
        "ss_builder_none_of_image_popup_alert": "Ch\u01B0a c\xf3 \u1EA3nh n\xe0o",
        "ss_builder_not_add_yet_product_url_label": "\u0110\u01B0\u1EDDng d\u1EABn ch\u01B0a \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_not_enough_space_product_group_modal_content": "Nh\xf3m s\u1EA3n ph\u1EA9m b\u1EA1n ch\u1ECDn kh\xf4ng \u0111\u1EE7 ch\u1ED7 ch\u1EE9a {{num_products}} s\u1EA3n ph\u1EA9m trong danh s\xe1ch th\xeam. Vui l\xf2ng x\xf3a b\u1EDBt s\u1EA3n ph\u1EA9m trong danh s\xe1ch th\xeam ho\u1EB7c ch\u1ECDn nh\xf3m kh\xe1c.",
        "ss_builder_not_enough_space_product_group_modal_title": "Kh\xf4ng th\u1EC3 ch\u1ECDn nh\xf3m",
        "ss_builder_notes": "M\xf4 t\u1EA3 chi ti\u1EBFt l\u1ED7i",
        "ss_builder_off": "T\u1EAFt",
        "ss_builder_on": "B\u1EADt",
        "ss_builder_onboarding_choose_a_suitable_theme": "Ch\u1ECDn m\u1ED9t ch\u1EE7 \u0111\u1EC1 ph\xf9 h\u1EE3p, b\u1EA1n c\xf3 th\u1EC3 t\xf9y ch\u1EC9nh sau khi \xe1p d\u1EE5ng\u2728",
        "ss_builder_onboarding_choose_the_look_for_you": "Ch\u1ECDn giao di\u1EC7n ph\xf9 h\u1EE3p v\u1EDBi b\u1EA1n!",
        "ss_builder_onboarding_create_a_personal_page": "T\u1EA1o trang c\xe1 nh\xe2n, l\xe0m Affliate Marketing, nh\u1EADn Booking, Donation, B\xe1n s\u1EA3n ph\u1EA9m s\u1ED1 (t\xe0i li\u1EC7u, h\xecnh \u1EA3nh, video, thuy\u1EBFt tr\xecnh,...)",
        "ss_builder_onboarding_no_need_know_technology": "Kh\xf4ng c\u1EA7n hi\u1EC3u bi\u1EBFt v\u1EC1 c\xf4ng ngh\u1EC7 v\u1EABn c\xf3 th\u1EC3 d\u1EC5 d\xe0ng s\u1EED d\u1EE5ng b\u1ED9 c\xf4ng c\u1EE5 \u0111\u1EC3 t\u1EA1o n\xean bio page.",
        "ss_builder_onboarding_theme_store_template": "Kho giao di\u1EC7n m\u1EABu",
        "ss_builder_open_browser_label": "M\u1EDF tr\xean tr\xecnh duy\u1EC7t",
        "ss_builder_open_link_in_new_tab": "M\u1EDF li\xean k\u1EBFt trong tab m\u1EDBi",
        "ss_builder_open_link_in_new_tab_description": "M\u1EDF li\xean k\u1EBFt trong tab m\u1EDBi",
        "ss_builder_open_new_tab_description": "B\u1ECF t\xedch ch\u1ECDn \u0111\u1EC3 m\u1EDF li\xean k\u1EBFt t\u1EA1i trang. T\xedch ch\u1ECDn \u0111\u1EC3 m\u1EDF li\xean k\u1EBFt trong c\u1EEDa s\u1ED5 m\u1EDBi.",
        "ss_builder_open_new_tab_label": "M\u1EDF li\xean k\u1EBFt trong c\u1EEDa s\u1ED5 m\u1EDBi",
        "ss_builder_optional_color_panel_label": "M\xe0u t\xf9y ch\u1ECDn",
        "ss_builder_overwrite_description": "Vi\u1EC7c l\u01B0u \u0111\xe8 s\u1EBD thay th\u1EBF to\xe0n b\u1ED9 thi\u1EBFt l\u1EADp c\u1EE7a m\u1EABu \u0111\u01B0\u1EE3c ch\u1ECDn",
        "ss_builder_overwrite_template_btn_label": "L\u01B0u \u0111\xe8",
        "ss_builder_overwrite_template_successfully_label": "L\u01B0u \u0111\xe8 th\xe0nh c\xf4ng",
        "ss_builder_overwrite_template_title": "L\u01B0u \u0111\xe8 m\u1EABu",
        "ss_builder_overwrite_theme_btn_label": "L\u01B0u \u0111\xe8",
        "ss_builder_overwrite_theme_template_successfully_label": "L\u01B0u \u0111\xe8 th\xe0nh c\xf4ng",
        "ss_builder_overwrite_theme_template_title": "L\u01B0u \u0111\xe8 giao di\u1EC7n m\u1EABu",
        "ss_builder_overwrite_title": "B\u1EA1n mu\u1ED1n l\u01B0u \u0111\xe8?",
        "ss_builder_panel_add_icon_tab_title": "Ch\u1ECDn icon",
        "ss_builder_panel_add_new_tab_title": "Th\xf4ng tin Tab",
        "ss_builder_panel_edit_text_block_title": "S\u1EEDa t\xean kh\u1ED1i",
        "ss_builder_panel_search_label": "T\xecm ki\u1EBFm...",
        "ss_builder_panel_title": "Ch\u1ECDn ki\u1EC3u kh\u1ED1i",
        "ss_builder_paragraph_setting_font_available": "Ph\xf4ng c\xf3 s\u1EB5n",
        "ss_builder_paragraph_setting_font_custom": "Ph\xf4ng t\xf9y ch\u1EC9nh",
        "ss_builder_paragraph_setting_option": "T\xf9y ch\u1ECDn",
        "ss_builder_paragraph_setting_title": "Thi\u1EBFt l\u1EADp \u0111o\u1EA1n v\u0103n",
        "ss_builder_partial_visible_slide_type_1": "L\u1EA5p l\xf3 ph\u1EA3i",
        "ss_builder_partial_visible_slide_type_2": "L\u1EA5p l\xf3 hai b\xean",
        "ss_builder_partial_visible_slide_type_3": "Kh\xf4ng l\u1EA5p l\xf3",
        "ss_builder_partial_visible_slide_type_4": "Posters",
        "ss_builder_partial_visible_slide_type_5": "Panorama",
        "ss_builder_passio_page_ready": "Passio Page \u0111\xe3 s\u1EB5n s\xe0ng",
        "ss_builder_passio_page_ready_description": "Passio Page \u0111\xe3 s\u1EB5n s\xe0ng \u0111\u1EC3 s\u1EED d\u1EE5ng v\xe0 thay th\u1EBF cho h\u1EC7 th\u1ED1ng Landing Page c\u0169.",
        "ss_builder_passio_premium": "Passio Premium",
        "ss_builder_personal_link_coppy_label": "Sao ch\xe9p",
        "ss_builder_personal_link_coppy_successfully_label": "\u0110\xe3 sao ch\xe9p",
        "ss_builder_personal_link_sharing_title": "Chia s\u1EBB trang c\xe1 nh\xe2n c\u1EE7a b\u1EA1n",
        "ss_builder_personal_link_title": "\u0110\u01B0\u1EDDng d\u1EABn trang c\xe1 nh\xe2n c\u1EE7a b\u1EA1n",
        "ss_builder_phone_placeholder": "Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
        "ss_builder_placeholder_affiliate_product_enter_product_name": "Nh\u1EADp t\xean s\u1EA3n ph\u1EA9m",
        "ss_builder_placeholder_dragging_content": "Th\u1EA3 v\xe0o \u0111\xe2y",
        "ss_builder_please_wait_for_the_product_to_be_updated": "H\xe3y ch\u1EDD s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt nh\xe9",
        "ss_builder_popover_manual_button": "B\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1",
        "ss_builder_popover_manual_button_close": "\u0110\xf3ng",
        "ss_builder_popover_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng t\xednh n\u0103ng Thi\u1EBFt k\u1EBF vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u\u201D",
        "ss_builder_popover_manual_title": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_popover_review_manual_content": "B\u1EA1n c\xf3 th\u1EC3 xem l\u1EA1i h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng b\u1EA5t k\u1EF3 khi n\xe0o, b\u1EB1ng c\xe1ch nh\u1EA5n v\xe0o n\xfat tr\u1EE3 gi\xfap n\xe0y.",
        "ss_builder_popular_font_families": "Ph\xf4ng ch\u1EEF th\xf4ng d\u1EE5ng",
        "ss_builder_popup_confirm_button": "X\xe1c nh\u1EADn",
        "ss_builder_popup_management_title": "Qu\u1EA3n tr\u1ECB",
        "ss_builder_portrait_image_orientation_label": "Theo chi\u1EC1u d\u1ECDc",
        "ss_builder_position_ghim_tab_selection_label": "V\u1ECB tr\xed",
        "ss_builder_powered_by_passio": "Cung c\u1EA5p b\u1EDFi Ecomobi",
        "ss_builder_preview": "Xem tr\u01B0\u1EDBc",
        "ss_builder_preview_image_label": "Xem tr\u01B0\u1EDBc",
        "ss_builder_preview_theme_template_title": "Xem tr\u01B0\u1EDBc \u1EA3nh",
        "ss_builder_product_design_empty_description": "H\xe3y ch\u1EDD s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt nh\xe9",
        "ss_builder_product_design_empty_title": "Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m",
        "ss_builder_product_detect_link_malformed_error": "\u0110\u01B0\u1EDDng d\u1EABn kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng",
        "ss_builder_product_detect_link_placeholder": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn s\u1EA3n ph\u1EA9m",
        "ss_builder_product_detect_link_title": "\u0110\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_product_empty_searching_description": "H\xe3y th\u1EED v\u1EDBi t\u1EEB kh\xf3a kh\xe1c",
        "ss_builder_product_empty_searching_title": "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 n\xe0o",
        "ss_builder_product_exceeding_allowed_amount_content": "\u0110\u1EC3 th\xeam s\u1EA3n ph\u1EA9m m\u1EDBi vui l\xf2ng x\xf3a b\u1EDBt s\u1EA3n ph\u1EA9m c\u0169",
        "ss_builder_product_exceeding_allowed_amount_title": "Qu\xe1 s\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_product_group_add_new_btn_label": "Th\xeam nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_product_group_default_title": "S\u1EA3n ph\u1EA9m",
        "ss_builder_product_group_limitation_warning_description": "T\u1ED5ng s\u1ED1 s\u1EA3n ph\u1EA9m trong nh\xf3m \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n {{max_products}} s\u1EA3n ph\u1EA9m. Vui l\xf2ng x\xf3a b\u1EDBt s\u1EA3n ph\u1EA9m \u0111\xe3 c\xf3 n\u1EBFu b\u1EA1n mu\u1ED1n th\xeam m\u1EDBi.",
        "ss_builder_product_group_selection_placeholder": "Vui l\xf2ng ch\u1ECDn nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_product_group_selection_title": "Ch\u1ECDn nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_builder_product_group_total_limitation_warning_content": "T\u1ED5ng s\u1ED1 nh\xf3m \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n {{group_quantity_maximum}} nh\xf3m. Vui l\xf2ng x\xf3a b\u1EDBt nh\xf3m \u0111\xe3 c\xf3 n\u1EBFu b\u1EA1n mu\u1ED1n th\xeam m\u1EDBi.",
        "ss_builder_product_group_total_limitation_warning_title": "Kh\xf4ng th\u1EC3 th\xeam nh\xf3m",
        "ss_builder_product_is_hiding_label": "S\u1EA3n ph\u1EA9m \u0111ang b\u1ECB \u1EA9n",
        "ss_builder_product_link_wrapped_label": "\u0110\xe3 b\u1ECDc link",
        "ss_builder_product_list_style_grid_label": "D\u1EA1ng l\u01B0\u1EDBi",
        "ss_builder_product_list_style_grid_one_label": "1 s\u1EA3n ph\u1EA9m",
        "ss_builder_product_list_style_grid_three_label": "3 s\u1EA3n ph\u1EA9m",
        "ss_builder_product_list_style_grid_two_label": "2 s\u1EA3n ph\u1EA9m",
        "ss_builder_product_list_style_slide_label": "D\u1EA1ng tr\u01B0\u1EE3t",
        "ss_builder_product_list_style_text_over_image_label": "Ch\u1EEF tr\xean \u1EA3nh",
        "ss_builder_product_list_style_zig_zag_label": "Zigzag",
        "ss_builder_product_searching_description": "Nh\u1EADp t\u1EEB kh\xf3a \u1EDF tr\xean \u0111\u1EC3 t\xecm ki\u1EBFm nh\xe9",
        "ss_builder_product_searching_title": "T\xecm ki\u1EBFm s\u1EA3n ph\u1EA9m",
        "ss_builder_product_selection_option_1": "10 cu\u1ED1i",
        "ss_builder_product_selection_option_2": "20 cu\u1ED1i",
        "ss_builder_product_selection_option_3": "50 cu\u1ED1i",
        "ss_builder_product_selection_option_4": "5 cu\u1ED1i",
        "ss_builder_product_swiper_see_all": "Xem t\u1EA5t c\u1EA3",
        "ss_builder_product_title_error": "Thi\u1EBFu t\xean s\u1EA3n ph\u1EA9m",
        "ss_builder_product_title_missing_warning": "Nh\u1EADp t\xean s\u1EA3n ph\u1EA9m",
        "ss_builder_product_total_limitation_warning_description": "T\u1ED5ng s\u1ED1 s\u1EA3n ph\u1EA9m trong to\xe0n b\u1ED9 nh\xf3m \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n {{max_products_all_groups}} s\u1EA3n ph\u1EA9m. Vui l\xf2ng x\xf3a b\u1EDBt s\u1EA3n ph\u1EA9m \u0111\xe3 c\xf3 n\u1EBFu b\u1EA1n mu\u1ED1n th\xeam m\u1EDBi.",
        "ss_builder_product_total_limitation_warning_title": "Kh\xf4ng th\u1EC3 th\xeam s\u1EA3n ph\u1EA9m",
        "ss_builder_product_tour_button_step_0": "B\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1",
        "ss_builder_product_tour_content_step_0": "B\u1EAFt \u0111\u1EA7u theo h\u01B0\u1EDBng d\u1EABn c\u1EE7a ch\xfang t\xf4i \u0111\u1EC3 tr\u1EA3i nghi\u1EC7m nh\u1EEFng t\xednh n\u0103ng h\u1EA5p d\u1EABn c\u1EE7a Passio Page nh\xe9!",
        "ss_builder_product_tour_content_step_1": "Th\u1ECFa s\u1EE9c s\xe1ng t\u1EA1o v\u1EDBi m\xe0n h\xecnh Thi\u1EBFt k\u1EBF. D\u1EC5 d\xe0ng ch\u1EC9nh s\u1EEDa, s\u1EAFp x\u1EBFp v\u1ECB tr\xed c\xe1c Kh\u1ED1i t\xf9y \xfd theo phong c\xe1ch c\u1EE7a ri\xeang b\u1EA1n.",
        "ss_builder_product_tour_content_step_10": "Thay th\u1EBF to\xe0n b\u1ED9 n\u1ED9i dung trang c\u1EE7a b\u1EA1n gi\u1ED1ng h\u1EC7t n\u1ED9i dung c\u1EE7a giao di\u1EC7n m\u1EABu \u0111ang \xe1p d\u1EE5ng. Gi\xfap trang c\u1EE7a b\u1EA1n c\xf3 n\u1ED9i dung gi\u1ED1ng h\u1EC7t nh\u01B0 m\u1EABu.",
        "ss_builder_product_tour_content_step_11": "Xem tr\u01B0\u1EDBc trang \u0111\u1EC3 th\u1EA5y c\xe1c thay \u0111\u1ED5i hi\u1EC7n t\u1EA1i c\u1EE7a trang. Ch\u1EC9 n\xean Xu\u1EA5t b\u1EA3n khi b\u1EA1n \u0111\xe3 xem tr\u01B0\u1EDBc v\xe0 h\xe0i l\xf2ng v\u1EDBi c\xe1c thay \u0111\u1ED5i.",
        "ss_builder_product_tour_content_step_12": "B\u1EB1ng c\xe1ch nh\u1EA5n gi\u1EEF v\xe0 k\xe9o th\u1EA3 \u0111\u1EC3 di chuy\u1EC3n ho\u1EB7c s\u1EED d\u1EE5ng \u201CT\xe1c v\u1EE5 nhanh\u201D \u0111\u1EC3 di chuy\u1EC3n l\xean/xu\u1ED1ng m\u1ED9t kh\u1ED1i.",
        "ss_builder_product_tour_content_step_13": "Ch\u1ECDn \u201CCh\u1EC9nh s\u1EEDa\u201D trong \u201CT\xe1c v\u1EE5 nhanh\u201D ho\u1EB7c nh\u1EA5n tr\u1EF1c ti\u1EBFp v\xe0o kh\u1ED1i \u0111\u1EC3 ch\u1EC9nh s\u1EEDa.",
        "ss_builder_product_tour_content_step_14": "Thay \u0111\u1ED5i n\u1EC1n nhanh ch\xf3ng b\u1EB1ng h\xecnh \u1EA3nh, m\xe0u s\u1EAFc ho\u1EB7c d\u1EA3i m\xe0u \u0111\u1EA7y c\xe1 t\xednh.",
        "ss_builder_product_tour_content_step_15": "Nhi\u1EC1u m\u1EABu giao di\u1EC7n \u0111a d\u1EA1ng ch\u1EE7 \u0111\u1EC1, \u0111\u1EB9p m\u1EAFt v\xe0 theo xu h\u01B0\u1EDBng \u0111\u1EC3 b\u1EA1n tho\u1EA3 s\u1EE9c l\u1EF1a ch\u1ECDn v\xe0 s\u1EED d\u1EE5ng.",
        "ss_builder_product_tour_content_step_16": "C\xe1c thi\u1EBFt l\u1EADp n\xe2ng cao gi\xfap tinh ch\u1EC9nh giao di\u1EC7n, thay \u0111\u1ED5i t\xean mi\u1EC1n, th\u01B0\u01A1ng hi\u1EC7u c\xe1 nh\xe2n,...",
        "ss_builder_product_tour_content_step_17": "B\u1EA1n c\xf3 th\u1EC3 xem l\u1EA1i h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng b\u1EA5t k\u1EF3 khi n\xe0o, b\u1EB1ng c\xe1ch nh\u1EA5n v\xe0o n\xfat tr\u1EE3 gi\xfap n\xe0y.",
        "ss_builder_product_tour_content_step_2": "R\u1EA5t nhi\u1EC1u ki\u1EC3u Kh\u1ED1i s\u1EB5n s\xe0ng \u0111\u1EC3 th\xeam v\xe0o trang c\u1EE7a b\u1EA1n, gi\xfap b\u1EA1n s\xe1ng t\u1EA1o trang c\xe1 nh\xe2n \u0111\u1EB9p m\u1EAFt, \u0111a m\u1EE5c \u0111\xedch. Nh\u1EA5n ho\u1EB7c K\xe9o & Th\u1EA3 n\xfat n\xe0y \u0111\u1EBFn v\u1ECB tr\xed mong mu\u1ED1n \u0111\u1EC3 th\xeam Kh\u1ED1i m\u1EDBi. H\xe3y kh\xe1m ph\xe1 nh\xe9!",
        "ss_builder_product_tour_content_step_3": "Ch\u1EC9nh s\u1EEDa v\xe0 c\xe1c t\xf9y ch\u1ECDn c\u1EE7a t\u1EEBng kh\u1ED1i, cho ph\xe9p b\u1EA1n t\xf9y ch\u1EC9nh kh\u1ED1i theo \xfd mu\u1ED1n.",
        "ss_builder_product_tour_content_step_4": 'C\xe1c ch\u1EC9nh s\u1EEDa Thi\u1EBFt k\u1EBF lu\xf4n \u1EDF ch\u1EBF \u0111\u1ED9 "B\u1EA3n nh\xe1p". C\xe1c thay \u0111\u1ED5i s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB cho Fan c\u1EE7a b\u1EA1n sau khi b\u1EA1n quy\u1EBFt \u0111\u1ECBnh "Xu\u1EA5t b\u1EA3n".',
        "ss_builder_product_tour_content_step_5": "Tab d\xf9ng \u0111\u1EC3 t\u1ED5 ch\u1EE9c n\u1ED9i dung \u201CTh\xe2n trang\u201D theo nhi\u1EC1u ph\u1EA7n, v\xed d\u1EE5: Tab S\u1EA3n ph\u1EA9m, Tab Video, Tab M\xe3 gi\u1EA3m gi\xe1,... Nh\u1EA5n v\xe0o t\u1EEBng Tab \u0111\u1EC3 xem v\xe0 thay \u0111\u1ED5i n\u1ED9i dung b\xean trong. Ch\u1EC9nh s\u1EEDa kh\u1ED1i n\xe0y \u0111\u1EC3 th\xeam m\u1EDBi, qu\u1EA3n l\xfd Tabs.",
        "ss_builder_product_tour_content_step_6": "\u201C\u0110\u1EA7u trang\u201D ch\u1EE9a c\xe1c Kh\u1ED1i, lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF ph\u1EA7n tr\xean c\xf9ng c\u1EE7a trang. V\xed d\u1EE5 nh\u01B0: \u1EA3nh \u0111\u1EA1i di\u1EC7n, ph\u1EA7n gi\u1EDBi thi\u1EC7u...",
        "ss_builder_product_tour_content_step_7": '"Th\xe2n trang" l\xe0 ph\u1EA7n n\u1ED9i dung ch\xednh c\u1EE7a trang, ch\u1EE9a c\xe1c Kh\u1ED1i v\xe0 \u0111\u01B0\u1EE3c ph\xe2n chia, \u0111i\u1EC1u h\u01B0\u1EDBng b\u1EDFi Tabs. V\xed d\u1EE5 nh\u01B0: n\u1ED9i dung, h\xecnh \u1EA3nh, s\u1EA3n ph\u1EA9m,...',
        "ss_builder_product_tour_content_step_8": "\u201CCu\u1ED1i trang\u201D ch\u1EE9a c\xe1c Kh\u1ED1i, lu\xf4n xu\u1EA5t hi\u1EC7n \u1EDF ph\u1EA7n d\u01B0\u1EDBi c\xf9ng c\u1EE7a trang. V\xed d\u1EE5 nh\u01B0: li\xean k\u1EBFt nhanh, th\xf4ng tin trang...",
        "ss_builder_product_tour_content_step_9": "S\u1EED d\u1EE5ng t\xednh n\u0103ng n\xe0y, n\u1EBFu c\xe1c thay \u0111\u1ED5i kh\xf4ng l\xe0m b\u1EA1n v\u1EEBa \xfd. H\u1EC7 th\u1ED1ng s\u1EBD kh\xf4i ph\u1EE5c m\xe0n h\xecnh Thi\u1EBFt k\u1EBF c\u1EE7a b\u1EA1n tr\u1EDF v\u1EC1 nh\u01B0 trang \u0111ang xu\u1EA5t b\u1EA3n.",
        "ss_builder_product_tour_done_label": "Xong",
        "ss_builder_product_tour_next_label": "Ti\u1EBFp theo",
        "ss_builder_product_tour_prev_label": "Quay l\u1EA1i",
        "ss_builder_product_tour_skip_label": "B\u1ECF qua",
        "ss_builder_product_tour_title_step_0": "Ch\xe0o m\u1EEBng \u0111\u1EBFn Passio Page",
        "ss_builder_product_tour_title_step_1": "Thi\u1EBFt k\u1EBF giao di\u1EC7n",
        "ss_builder_product_tour_title_step_10": "\xc1p d\u1EE5ng n\u1ED9i dung m\u1EABu",
        "ss_builder_product_tour_title_step_11": "Xem tr\u01B0\u1EDBc trang",
        "ss_builder_product_tour_title_step_12": "Di chuy\u1EC3n v\u1ECB tr\xed Kh\u1ED1i",
        "ss_builder_product_tour_title_step_13": "Ch\u1EC9nh s\u1EEDa Kh\u1ED1i",
        "ss_builder_product_tour_title_step_14": "Thay \u0111\u1ED5i h\xecnh n\u1EC1n",
        "ss_builder_product_tour_title_step_15": "C\u1EEDa h\xe0ng m\u1EABu giao di\u1EC7n",
        "ss_builder_product_tour_title_step_16": "Thi\u1EBFt l\u1EADp n\xe2ng cao",
        "ss_builder_product_tour_title_step_17": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_product_tour_title_step_2": "Th\xeam m\u1ED9t Kh\u1ED1i m\u1EDBi",
        "ss_builder_product_tour_title_step_3": "T\xe1c v\u1EE5 nhanh",
        "ss_builder_product_tour_title_step_4": "Xu\u1EA5t b\u1EA3n thi\u1EBFt k\u1EBF",
        "ss_builder_product_tour_title_step_5": "Tab menu",
        "ss_builder_product_tour_title_step_6": "V\u1ECB tr\xed \u0110\u1EA7u trang",
        "ss_builder_product_tour_title_step_7": "V\u1ECB tr\xed Th\xe2n trang",
        "ss_builder_product_tour_title_step_8": "V\u1ECB tr\xed Cu\u1ED1i trang",
        "ss_builder_product_tour_title_step_9": "Kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_product_tour_use_manual": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_product_tour_use_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng m\xe0n h\xecnh Thi\u1EBFt k\u1EBF vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1\u201D",
        "ss_builder_product_url_lists_label": "Danh s\xe1ch \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_publish_button_label": "Xu\u1EA5t B\u1EA3n",
        "ss_builder_publish_result_description": "Ch\xfac m\u1EEBng b\u1EA1n \u0111\xe3 xu\u1EA5t b\u1EA3n th\xe0nh c\xf4ng Passio Page.\nTrang c\u1EE7a b\u1EA1n c\xf3 th\u1EC3 \u0111\u01B0\u1EE3c truy c\u1EADp qua \u0111\u01B0\u1EDDng d\u1EABn b\xean d\u01B0\u1EDBi.",
        "ss_builder_publish_result_successfully": "Xu\u1EA5t b\u1EA3n th\xe0nh c\xf4ng!",
        "ss_builder_publish_result_title": "K\u1EBFt qu\u1EA3 xu\u1EA5t b\u1EA3n",
        "ss_builder_publish_saving": "\u0110ang l\u01B0u",
        "ss_builder_publish_share": "Chia s\u1EBB",
        "ss_builder_publish_view_page": "Xem trang",
        "ss_builder_randomize": "Ch\u1ECDn ng\u1EABu nhi\xean",
        "ss_builder_ready_to_build_your_personal_brand": "S\u1EB5n s\xe0ng x\xe2y d\u1EF1ng th\u01B0\u01A1ng hi\u1EC7u c\xe1 nh\xe2n c\xf9ng Passio ngay n\xe0o \uD83D\uDC96",
        "ss_builder_recently_color_panel_label": "M\xe0u s\u1EED d\u1EE5ng g\u1EA7n \u0111\xe2y",
        "ss_builder_redo_theme_label": "L\xe0m l\u1EA1i",
        "ss_builder_reload_label": "L\xe0m m\u1EDBi",
        "ss_builder_replace": "thay th\u1EBF",
        "ss_builder_replace_preview_theme_template_btn_label": "\xc1p d\u1EE5ng",
        "ss_builder_replace_theme_label": "\xc1p d\u1EE5ng n\u1ED9i dung m\u1EABu",
        "ss_builder_replace_theme_modal_content": "\xc1p d\u1EE5ng n\u1ED9i dung m\u1EABu s\u1EBD thay th\u1EBF t\u1EA5t c\u1EA3 c\xe1c kh\u1ED1i tr\xean trang c\u1EE7a b\u1EA1n b\u1EB1ng c\xe1c kh\u1ED1i t\u1EEB giao di\u1EC7n m\u1EABu",
        "ss_builder_replace_theme_modal_title": "B\u1EA1n mu\u1ED1n \xe1p d\u1EE5ng n\u1ED9i dung giao di\u1EC7n m\u1EABu?",
        "ss_builder_replace_theme_template_successfully_label": "\xc1p d\u1EE5ng th\xe0nh c\xf4ng",
        "ss_builder_report_sent_report_successfully": "G\u1EEDi b\xe1o l\u1ED7i th\xe0nh c\xf4ng",
        "ss_builder_report_sent_report_successfully_description": "C\u1EA3m \u01A1n b\u1EA1n! Th\xf4ng b\xe1o l\u1ED7i \u0111\xe3 \u0111\u01B0\u1EE3c g\u1EEDi th\xe0nh c\xf4ng t\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3",
        "ss_builder_restore_theme_content": "To\xe0n b\u1ED9 c\u1EA5u h\xecnh c\u1EE7a giao di\u1EC7n v\xe0 n\u1ED9i dung c\u1EE7a c\xe1c kh\u1ED1i b\xean trong s\u1EBD kh\xf4i ph\u1EE5c l\u1EA1i nh\u01B0 giao di\u1EC7n \u0111\xe3 xu\u1EA5t b\u1EA3n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa?",
        "ss_builder_restore_theme_label": "Kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa",
        "ss_builder_restore_theme_successfully_label": "Kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa th\xe0nh c\xf4ng",
        "ss_builder_restore_theme_title": "B\u1EA1n mu\u1ED1n kh\xf4i ph\u1EE5c ch\u1EC9nh s\u1EEDa?",
        "ss_builder_revenue_group_description": "B\u1EAFt \u0111\u1EA7u ki\u1EBFm ti\u1EC1n ngay v\u1EDBi c\xe1c d\u1ECBch v\u1EE5 c\u1EE7a Passio Page",
        "ss_builder_revenue_title": "Ki\u1EBFm ti\u1EC1n",
        "ss_builder_round_photo_label": "\u1EA2nh tr\xf2n",
        "ss_builder_rounded": "Bo g\xf3c",
        "ss_builder_sample_change_label": "\u0110\u1ED5i m\u1EABu",
        "ss_builder_sample_selection_label": "Ch\u1ECDn m\u1EABu",
        "ss_builder_sampling_change_label": "Ch\u1ECDn m\u1EABu",
        "ss_builder_save": "L\u01B0u",
        "ss_builder_save_new_template_title": "L\u01B0u m\u1EDBi m\u1EABu",
        "ss_builder_save_new_theme_template_successfully_label": "L\u01B0u m\u1EDBi th\xe0nh c\xf4ng",
        "ss_builder_save_new_theme_template_title": "L\u01B0u m\u1EDBi giao di\u1EC7n m\u1EABu",
        "ss_builder_save_succesfully_description": "Nh\u1EEFng thay \u0111\u1ED5i c\u1EE7a b\u1EA1n \u0111\xe3 \u0111\u01B0\u1EE3c l\u01B0u l\u1EA1i.",
        "ss_builder_save_succesfully_label": "L\u01B0u th\xe0nh c\xf4ng",
        "ss_builder_search_results_theme_store": "K\u1EBFt qu\u1EA3 t\xecm ki\u1EBFm",
        "ss_builder_search_type_block": "T\xecm ki\u1EBFm ki\u1EC3u kh\u1ED1i theo t\xean",
        "ss_builder_see_less": "R\xfat g\u1ECDn",
        "ss_builder_see_more": "Xem th\xeam",
        "ss_builder_see_more_btn_default_title": "Xem th\xeam",
        "ss_builder_select_label": "Ch\u1ECDn",
        "ss_builder_select_link_type": "Ch\u1ECDn lo\u1EA1i \u0111\u01B0\u1EDDng d\u1EABn",
        "ss_builder_select_multi_items": "Ch\u1ECDn",
        "ss_builder_select_position_add_block": "Ch\u1ECDn v\u1ECB tr\xed th\xeam kh\u1ED1i",
        "ss_builder_select_ratio_title": "Ch\u1ECDn t\u1EF7 l\u1EC7",
        "ss_builder_select_theme_setting_primary_color_label": "Ch\u1ECDn m\xe0u ch\u1EE7 \u0111\u1EA1o",
        "ss_builder_selected_product_in_selection_label": "s\u1EA3n ph\u1EA9m \u0111\xe3 ch\u1ECDn",
        "ss_builder_send": "G\u1EEDi",
        "ss_builder_send_report": "G\u1EEDi b\xe1o l\u1ED7i",
        "ss_builder_service_placeholder": "Ch\u1ECDn d\u1ECBch v\u1EE5",
        "ss_builder_set_default_tab_disable_content": 'Tab \u0111\u01B0\u1EE3c \u0111\u1EB7t m\u1EB7c \u0111\u1ECBnh s\u1EBD \u0111\u01B0\u1EE3c th\u1EA5y \u0111\u1EA7u ti\xean khi ng\u01B0\u1EDDi d\xf9ng v\xe0o trang c\u1EE7a b\u1EA1n. Tab "{{tab_name}}" \u0111ang b\u1ECB \u1EA9n. N\u1EBFu \u0111\u1EB7t l\xe0m m\u1EB7c \u0111\u1ECBnh s\u1EBD chuy\u1EC3n tr\u1EA1ng th\xe1i tab n\xe0y th\xe0nh hi\u1EC3n th\u1ECB. B\u1EA1n c\xf3 mu\u1ED1n \u0111\u1EB7t tab "{{tab_name}}" l\xe0m m\u1EB7c \u0111\u1ECBnh kh\xf4ng?',
        "ss_builder_set_default_tab_enable_content": 'Tab \u0111\u01B0\u1EE3c \u0111\u1EB7t m\u1EB7c \u0111\u1ECBnh s\u1EBD \u0111\u01B0\u1EE3c th\u1EA5y \u0111\u1EA7u ti\xean khi ng\u01B0\u1EDDi d\xf9ng v\xe0o trang c\u1EE7a b\u1EA1n. B\u1EA1n c\xf3 mu\u1ED1n \u0111\u1EB7t tab "{{tab_name}}" l\xe0m m\u1EB7c \u0111\u1ECBnh kh\xf4ng?',
        "ss_builder_set_default_tab_label": "\u0110\u1EB7t m\u1EB7c \u0111\u1ECBnh",
        "ss_builder_set_default_tab_successfully_label": "\u0110\u1EB7t m\u1EB7c \u0111\u1ECBnh th\xe0nh c\xf4ng",
        "ss_builder_set_default_tab_title": "X\xe1c nh\u1EADn \u0111\u1EB7t m\u1EB7c \u0111\u1ECBnh",
        "ss_builder_setting_font_weight": "\u0110\u1ED9 \u0111\u1EADm",
        "ss_builder_setting_line_height": "Chi\u1EC1u cao d\xf2ng",
        "ss_builder_setting_popover_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng cho Thi\u1EBFt l\u1EADp vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1\u201D",
        "ss_builder_setting_popover_manual_title": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_setting_saving": "\u0110ang l\u01B0u thi\u1EBFt l\u1EADp",
        "ss_builder_setting_text_font": "Ph\xf4ng ch\u1EEF",
        "ss_builder_setting_text_scale": "T\u1EC9 l\u1EC7",
        "ss_builder_setting_text_size": "K\xedch th\u01B0\u1EDBc ch\u1EEF (px)",
        "ss_builder_setting_title": "C\xe0i \u0111\u1EB7t",
        "ss_builder_setting_tour_content_step_1": "\u0110\xe2y l\xe0 \u0111\u01B0\u1EDDng d\u1EABn trang c\u1EE7a b\u1EA1n. B\u1EA1n c\xf3 th\u1EC3 sao ch\xe9p, m\u1EDF ho\u1EB7c chia s\u1EBB \u0111\u01B0\u1EDDng d\u1EABn trang. Ngo\xe0i ra c\u0169ng c\xf3 th\u1EC3 ch\u1EC9nh s\u1EEDa nhanh favicon v\xe0 t\xean mi\u1EC1n c\u1EE7a trang.",
        "ss_builder_setting_tour_content_step_2": "B\u1EA1n c\xf3 th\u1EC3 t\xf9y ch\u1EC9nh c\xe1c thi\u1EBFt l\u1EADp chung cho giao di\u1EC7n \u1EDF \u0111\xe2y. C\xe1c thi\u1EBFt l\u1EADp n\xe0y s\u1EBD \xe1p d\u1EE5ng l\xean to\xe0n trang c\u1EE7a b\u1EA1n.",
        "ss_builder_setting_tour_content_step_3": "B\u1EA1n c\xf3 th\u1EC3 thi\u1EBFt l\u1EADp th\u01B0\u01A1ng hi\u1EC7u c\xe1 nh\xe2n, c\xe1c thi\u1EBFt l\u1EADp SEO, c\u0169ng nh\u01B0 t\xean mi\u1EC1n cho trang c\u1EE7a b\u1EA1n \u1EDF \u0111\xe2y.",
        "ss_builder_setting_tour_title_step_1": "\u0110\u01B0\u1EDDng d\u1EABn trang",
        "ss_builder_setting_tour_title_step_2": "Thi\u1EBFt l\u1EADp giao di\u1EC7n",
        "ss_builder_setting_tour_title_step_3": "Thi\u1EBFt l\u1EADp trang",
        "ss_builder_settings_label": "Thi\u1EBFt l\u1EADp",
        "ss_builder_setup_site_setting": "Thi\u1EBFt l\u1EADp trang",
        "ss_builder_setup_theme_setting": "Thi\u1EBFt l\u1EADp giao di\u1EC7n",
        "ss_builder_shadows_style": "\u0110\u1ED5 b\xf3ng",
        "ss_builder_shape_label": "H\xecnh d\u1EA1ng",
        "ss_builder_share_label": "Chia s\u1EBB",
        "ss_builder_show_block_label": "Hi\u1EC7n kh\u1ED1i",
        "ss_builder_show_card_label": "Hi\u1EC7n card",
        "ss_builder_show_card_successfully_label": "Hi\u1EC7n card th\xe0nh c\xf4ng",
        "ss_builder_show_image_label": "Hi\u1EC7n \u1EA3nh",
        "ss_builder_show_link_label": "Hi\u1EC7n link",
        "ss_builder_show_link_successfully_label": "Hi\u1EC7n link th\xe0nh c\xf4ng",
        "ss_builder_show_product_group_label": "Hi\u1EC7n nh\xf3m",
        "ss_builder_show_product_label": "Hi\u1EC7n s\u1EA3n ph\u1EA9m",
        "ss_builder_show_social_link_label": "Hi\u1EC7n",
        "ss_builder_show_tab_label": "Hi\u1EC7n Tab",
        "ss_builder_show_template_successfully_label": "Hi\u1EC7n m\u1EABu th\xe0nh c\xf4ng",
        "ss_builder_show_theme_template_label": "Hi\u1EC7n m\u1EABu",
        "ss_builder_site_brand_setting_label": "Th\u01B0\u01A1ng hi\u1EC7u c\xe1 nh\xe2n",
        "ss_builder_site_domain_setting_label": "T\xean mi\u1EC1n",
        "ss_builder_site_setting_browser_label": "Tr\xecnh duy\u1EC7t",
        "ss_builder_site_setting_coppy_label": "Sao ch\xe9p",
        "ss_builder_site_setting_favicon_title": "Favicon",
        "ss_builder_site_setting_favicon_upload_description": "Favicon \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB b\xean c\u1EA1nh \u0111\u01B0\u1EDDng link c\u1EE7a trang. T\u1EA3i l\xean b\u1EA5t k\u1EF3 m\u1ED9t h\xecnh \u1EA3nh y\xeau th\xedch c\u1EE7a b\u1EA1n \u0111\u1EC3 l\xe0m Favicon nh\xe9.",
        "ss_builder_site_setting_label": "C\xe0i \u0111\u1EB7t trang",
        "ss_builder_site_setting_premium": "Cao c\u1EA5p",
        "ss_builder_site_setting_share_label": "Chia s\u1EBB",
        "ss_builder_site_setting_standard": "C\u01A1 b\u1EA3n",
        "ss_builder_site_setting_upgrade": "N\xe2ng c\u1EA5p",
        "ss_builder_skip": "B\u1ECF qua",
        "ss_builder_slide_type_label": "Ki\u1EC3u tr\u01B0\u1EE3t",
        "ss_builder_social_link_btn_add_new_label": "Th\xeam m\u1EA1ng x\xe3 h\u1ED9i",
        "ss_builder_social_links_list_title": "Danh s\xe1ch",
        "ss_builder_social_network_label": "M\u1EA1ng x\xe3 h\u1ED9i",
        "ss_builder_soft_shadow": "\u0110\u1ED5 b\xf3ng m\u1EC1m",
        "ss_builder_solid": "M\xe0u \u0111\u1EB7c",
        "ss_builder_solid_type_label": "N\xe9t li\u1EC1n",
        "ss_builder_something_went_wrong": "Xin l\u1ED7i, c\xf3 l\u1ED7i x\u1EA3y ra",
        "ss_builder_spacer_label": "Kho\u1EA3ng c\xe1ch (px)",
        "ss_builder_spotlight_list_empty_content": "\u0110\u1EC3 th\xeam ti\xeau \u0111i\u1EC3m vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_spotlight_list_empty_title": "Ch\u01B0a c\xf3 ti\xeau \u0111i\u1EC3m n\xe0o \u0111\u01B0\u1EE3c th\xeam",
        "ss_builder_square": "Vu\xf4ng",
        "ss_builder_square_photo_label": "\u1EA2nh vu\xf4ng",
        "ss_builder_start_use_passio_page": "B\u1EAFt \u0111\u1EA7u s\u1EED d\u1EE5ng Passio Page ngay n\xe0o!",
        "ss_builder_stop_label": "D\u1EEBng",
        "ss_builder_story": "Spotlight",
        "ss_builder_story_title_place_holder": "Ti\xeau \u0111\u1EC1 Spotlight",
        "ss_builder_style": "Phong c\xe1ch",
        "ss_builder_style_always_ghim_tab_label": "Lu\xf4n ghim",
        "ss_builder_style_auto_ghim_tab_label": "T\u1EF1 \u0111\u1ED9ng ghim",
        "ss_builder_style_ghim_tab_selection_label": "Ghim th\xe0nh ph\u1EA7n",
        "ss_builder_style_grid_label": "D\u1EA1ng l\u01B0\u1EDBi",
        "ss_builder_style_masonry_label": "D\u1EA1ng l\u01B0\u1EDBi xen k\u1EBD",
        "ss_builder_style_not_ghim_tab_label": "Kh\xf4ng ghim",
        "ss_builder_style_slide_label": "D\u1EA1ng tr\u01B0\u1EE3t",
        "ss_builder_style_tab_icon_label": "Ch\u1EC9 Icon",
        "ss_builder_style_tab_only_icon": "Ch\u1EC9 icon",
        "ss_builder_style_tab_only_image": "Ch\u1EC9 \u1EA3nh",
        "ss_builder_style_tab_selection_label": "Phong c\xe1ch",
        "ss_builder_style_tab_text_and_icon_label": "Ch\u1EEF & Icon",
        "ss_builder_style_tab_text_and_image_label": "Ch\u1EEF & \u1EA3nh",
        "ss_builder_style_tab_text_label": "Ch\u1EC9 ch\u1EEF",
        "ss_builder_subtitle_site_setting_description": "\u0110\u01B0a ra m\u1ED9t c\xe1i nh\xecn t\u1ED5ng quan v\u1EC1 n\u1ED9i dung v\xe0 th\xf4ng tin m\xe0 trang web cung c\u1EA5p. C\xf4ng c\u1EE5 t\xecm ki\u1EBFm s\u1EED d\u1EE5ng \u0111i\u1EC1u n\xe0y \u0111\u1EC3 hi\u1EC3n th\u1ECB m\xf4 t\u1EA3 trang web.",
        "ss_builder_subtitle_site_setting_label": "M\xf4 t\u1EA3 trang",
        "ss_builder_suggested_color_panel_label": "B\u1EA3ng m\xe0u g\u1EE3i \xfd",
        "ss_builder_support_upload_image": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP, WebP, t\u1ED1i \u0111a 30MB",
        "ss_builder_support_upload_image_v2": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP t\u1ED1i \u0111a 30MB",
        "ss_builder_support_upload_large_image": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP, WebP, t\u1ED1i \u0111a 50MB",
        "ss_builder_swiper_setting_premium_description_1": "T\xednh n\u0103ng kh\xf4ng gi\u1EDBi h\u1EA1n",
        "ss_builder_swiper_setting_premium_title_1": "T\xe0i kho\u1EA3n Premium",
        "ss_builder_swiper_setting_premium_title_2": "Kho theme \u0111\u1ED9c quy\u1EC1n",
        "ss_builder_swiper_setting_premium_title_3": "T\xean mi\u1EC1n ri\xeang yourdomain.com",
        "ss_builder_swiper_setting_premium_title_4": "Chi\u1EBFn d\u1ECBch th\u01B0\u01A1ng hi\u1EC7u \u0111\u1ED9c quy\u1EC1n",
        "ss_builder_swiper_setting_premium_title_5": "R\xfat ti\u1EC1n nhanh ch\xf3ng",
        "ss_builder_swiper_setting_premium_title_6": "Ti\u1EBFt ki\u1EC7m 25% ph\xed n\u1EC1n t\u1EA3ng",
        "ss_builder_tab_layout_1": "Ch\u1EEF ph\u1EA3i",
        "ss_builder_tab_layout_2": "Ch\u1EEF d\u01B0\u1EDBi",
        "ss_builder_tabs_label": "Tabs",
        "ss_builder_template_overwrite_title": "L\u01B0u \u0111\xe8 m\u1EABu",
        "ss_builder_template_search_bar_placeholder": "T\xecm ki\u1EBFm m\u1EABu theo t\xean...",
        "ss_builder_template_store_instruction_subtitle": "D\u1EEF li\u1EC7u v\xe0 thi\u1EBFt l\u1EADp c\u1EE7a m\u1EABu \u0111\u01B0\u1EE3c ch\u1ECDn s\u1EBD \u0111\u01B0\u1EE3c \xe1p d\u1EE5ng v\xe0o kh\u1ED1i hi\u1EC7n t\u1EA1i",
        "ss_builder_template_store_instruction_title": "H\xe3y ch\u1ECDn m\u1EABu kh\u1ED1i b\u1EA1n mu\u1ED1n!",
        "ss_builder_template_title": "M\u1EABu",
        "ss_builder_text_editor_max_length": "Nh\u1EADp t\u1ED1i \u0111a {{editor_max_length}} k\xfd t\u1EF1",
        "ss_builder_text_spin_loading": "\u0110ang t\u1EA3i trang",
        "ss_builder_the_application_of_the_template_will": "Vi\u1EC7c \xe1p d\u1EE5ng m\u1EABu s\u1EBD",
        "ss_builder_theme_big_button_setting": "N\xfat b\u1EA5m to",
        "ss_builder_theme_button_setting_general": "Chung",
        "ss_builder_theme_display_setting": "C\xe0i \u0111\u1EB7t giao di\u1EC7n",
        "ss_builder_theme_medium_button_setting": "N\xfat b\u1EA5m v\u1EEBa",
        "ss_builder_theme_setting_background": "N\u1EC1n",
        "ss_builder_theme_setting_background_color_preview_title": "Xem tr\u01B0\u1EDBc",
        "ss_builder_theme_setting_background_color_selector_label": "M\xe0u s\u1EAFc",
        "ss_builder_theme_setting_background_content": "Dung l\u01B0\u1EE3ng t\u1EC7p t\u1ED1i \u0111a: 30MB. \n\u0110\u1ECBnh d\u1EA1ng h\u1ED7 tr\u1EE3: jpg, jpeg, gif, png, bmp, webp",
        "ss_builder_theme_setting_background_content_v2": "Dung l\u01B0\u1EE3ng t\u1EC7p t\u1ED1i \u0111a: 30MB. \n\u0110\u1ECBnh d\u1EA1ng h\u1ED7 tr\u1EE3: jpg, jpeg, gif, png, bmp",
        "ss_builder_theme_setting_background_image_preview_label": "\u1EA2nh n\u1EC1n",
        "ss_builder_theme_setting_background_image_selector_label": "\u1EA2nh",
        "ss_builder_theme_setting_background_image_title": "H\xecnh n\u1EC1n",
        "ss_builder_theme_setting_block_background": "M\xe0u n\u1EC1n",
        "ss_builder_theme_setting_block_border": "\u0110\u01B0\u1EDDng vi\u1EC1n",
        "ss_builder_theme_setting_block_shadow": "\u0110\u1ED5 b\xf3ng",
        "ss_builder_theme_setting_block_style": "Phong c\xe1ch",
        "ss_builder_theme_setting_button": "N\xfat b\u1EA5m",
        "ss_builder_theme_setting_font_title": "Thi\u1EBFt l\u1EADp ch\u1EEF",
        "ss_builder_theme_setting_font_type_content": "Ch\u1ECDn ki\u1EC3u ch\u1EEF \u0111\u1EC3 \xe1p d\u1EE5ng ki\u1EC3u ch\u1EEF l\xean to\xe0n trang c\u1EE7a b\u1EA1n",
        "ss_builder_theme_setting_font_type_title": "Ki\u1EC3u ch\u1EEF",
        "ss_builder_theme_setting_gadient_color": "M\xe0u",
        "ss_builder_theme_setting_general": "Chung",
        "ss_builder_theme_setting_gradient_color_direction_label": "H\u01B0\u1EDBng",
        "ss_builder_theme_setting_hard_shadow": "\u0110\u1ED5 b\xf3ng c\u1EE9ng",
        "ss_builder_theme_setting_intensity_color_label": "C\u01B0\u1EDDng \u0111\u1ED9 m\xe0u",
        "ss_builder_theme_setting_label": "C\xe0i \u0111\u1EB7t giao di\u1EC7n",
        "ss_builder_theme_setting_no_shadow": "Kh\xf4ng \u0111\u1ED5 b\xf3ng",
        "ss_builder_theme_setting_paragraph": "\u0110o\u1EA1n v\u0103n",
        "ss_builder_theme_setting_primary_color": "M\xe0u",
        "ss_builder_theme_setting_primary_color_content": "Ch\u1ECDn m\xe0u ch\u1EE7 \u0111\u1EA1o \u0111\u1EC3 \xe1p d\u1EE5ng m\xe0u l\xean to\xe0n trang c\u1EE7a b\u1EA1n",
        "ss_builder_theme_setting_primary_color_title": "M\xe0u ch\u1EE7 \u0111\u1EA1o",
        "ss_builder_theme_setting_save_failed_content": "\u0110\xe3 x\u1EA3y ra l\u1ED7i kh\xf4ng mong mu\u1ED1n. Vui l\xf2ng th\u1EED l\u1EA1i.",
        "ss_builder_theme_setting_save_failed_title": "\u0110\xe3 x\u1EA3y ra l\u1ED7i",
        "ss_builder_theme_setting_save_successfully_label": "L\u01B0u thi\u1EBFt l\u1EADp th\xe0nh c\xf4ng",
        "ss_builder_theme_setting_select_background_color_label": "Ch\u1ECDn ki\u1EC3u m\xe0u",
        "ss_builder_theme_setting_select_gradient_color_label": "Ch\u1ECDn d\u1EA3i m\xe0u",
        "ss_builder_theme_setting_select_solid_color_label": "Ch\u1ECDn m\xe0u",
        "ss_builder_theme_setting_shadow": "\u0110\u1ED5 b\xf3ng",
        "ss_builder_theme_setting_shadow_color": "M\xe0u \u0111\u1ED5 b\xf3ng",
        "ss_builder_theme_setting_soft_shadow": "\u0110\u1ED5 b\xf3ng m\u1EC1m",
        "ss_builder_theme_setting_text": "Ch\u1EEF trong n\xfat b\u1EA5m",
        "ss_builder_theme_setting_title": "Ti\xeau \u0111\u1EC1",
        "ss_builder_theme_small_button_setting": "N\xfat b\u1EA5m nh\u1ECF",
        "ss_builder_theme_store_label": "M\u1EABu",
        "ss_builder_theme_store_popover_manual_content": "\u0110\u1EC3 xem h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng m\xe0n h\xecnh C\u1EEDa h\xe0ng giao di\u1EC7n vui l\xf2ng nh\u1EA5n n\xfat \u201CB\u1EAFt \u0111\u1EA7u kh\xe1m ph\xe1\u201D",
        "ss_builder_theme_store_popover_manual_title": "H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng",
        "ss_builder_theme_store_tour_content_step_1": "T\xecm ki\u1EBFm giao di\u1EC7n nhanh ch\xf3ng theo t\xean giao di\u1EC7n",
        "ss_builder_theme_store_tour_content_step_2": "Passio Page cung c\u1EA5p r\u1EA5t nhi\u1EC1u giao di\u1EC7n m\u1EABu cho b\u1EA1n l\u1EF1a ch\u1ECDn. H\xe3y \xe1p d\u1EE5ng m\u1ED9t m\u1EABu b\u1EA1n \u01B0ng \xfd \u0111\u1EC3 tr\u1EA3i nghi\u1EC7m nh\xe9.",
        "ss_builder_theme_store_tour_title_step_1": "T\xecm ki\u1EBFm giao di\u1EC7n m\u1EABu",
        "ss_builder_theme_store_tour_title_step_2": "Danh s\xe1ch gian di\u1EC7n m\u1EABu",
        "ss_builder_theme_template_format_create_label": "T\u1EA1o",
        "ss_builder_theme_template_label_tag": "Tags",
        "ss_builder_theme_template_label_tag_placeholder": "Nh\u1EADp tags",
        "ss_builder_theme_template_no_option": "Kh\xf4ng c\xf3 k\u1EBFt qu\u1EA3",
        "ss_builder_theme_template_preview_info": "Xem tr\u01B0\u1EDBc giao di\u1EC7n trang c\u1EE7a b\u1EA1n sau khi \xe1p d\u1EE5ng m\u1EABu",
        "ss_builder_theme_template_preview_mode_title": "Ch\u1EBF \u0111\u1ED9 xem tr\u01B0\u1EDBc",
        "ss_builder_theme_template_search_bar_placeholder": "T\xecm ki\u1EBFm m\u1EABu giao di\u1EC7n theo t\xean...",
        "ss_builder_theme_template_store_instruction_subtitle": "Thi\u1EBFt l\u1EADp giao di\u1EC7n s\u1EBD \u0111\u01B0\u1EE3c \xe1p d\u1EE5ng theo ch\u1EE7 \u0111\u1EC1 l\xean to\xe0n trang",
        "ss_builder_theme_template_store_instruction_title": "H\xe3y ch\u1ECDn ch\u1EE7 \u0111\u1EC1 b\u1EA1n mu\u1ED1n!",
        "ss_builder_theme_template_store_title": "C\u1EEDa h\xe0ng giao di\u1EC7n",
        "ss_builder_theme_template_theme_store": "{{num_results}} giao di\u1EC7n m\u1EABu",
        "ss_builder_theme_template_view_theme_info": "Giao di\u1EC7n m\u1EABu v\u1EDBi d\u1EEF li\u1EC7u m\u1EABu",
        "ss_builder_theme_template_view_theme_title": "Xem m\u1EABu",
        "ss_builder_title": "Ti\xeau \u0111\u1EC1",
        "ss_builder_title_block_affiliate_product": "Affiliate",
        "ss_builder_title_block_bio": "Bio",
        "ss_builder_title_block_booking_profile": "Booking Profile",
        "ss_builder_title_block_booking_profile_description": "Th\xeam \u0111\u01B0\u1EDDng d\u1EABn t\u1EDBi trang Booking Profile c\u1EE7a b\u1EA1n ho\u1EB7c hi\u1EC3n th\u1ECB Booking Profile b\xean trong Passio Page",
        "ss_builder_title_block_booking_profile_warning": "T\u1EA1o Booking Profile \u0111\u1EC3 s\u1EED d\u1EE5ng kh\u1ED1i n\xe0y",
        "ss_builder_title_block_brand_gift": "Brand Gift",
        "ss_builder_title_block_brand_gift_description": "Hi\u1EC3n th\u1ECB icon qu\xe0 t\u1EB7ng t\u1EEB nh\xe3n h\xe0ng gi\xfap fan truy c\u1EADp mua h\xe0ng nhanh ch\xf3ng",
        "ss_builder_title_block_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_block_brand_rating": "Brand Ratings",
        "ss_builder_title_block_brand_rating_description": "B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_builder_title_block_button_link": "Li\xean k\u1EBFt",
        "ss_builder_title_block_button_multi_link": "Multi Links",
        "ss_builder_title_block_card": "Th\u1EBB n\u1ED9i dung",
        "ss_builder_title_block_digital_product": "S\u1EA3n ph\u1EA9m s\u1ED1",
        "ss_builder_title_block_donation": "\u1EE6ng h\u1ED9",
        "ss_builder_title_block_embed": "Embed",
        "ss_builder_title_block_image": "Image",
        "ss_builder_title_block_image_gallery": "Image Gallery",
        "ss_builder_title_block_image_popup": "\u1EA2nh popup",
        "ss_builder_title_block_image_slider": "Image Slider",
        "ss_builder_title_block_story": "Ti\xeau \u0111i\u1EC3m",
        "ss_builder_title_block_tab_bar": "Tab Menu",
        "ss_builder_title_block_text": "V\u0103n b\u1EA3n",
        "ss_builder_title_block_truth_or_dare": "Truth Or Dare",
        "ss_builder_title_block_truth_or_dare_footer": "Truth Or Dare Icon",
        "ss_builder_title_block_video_shoutout": "Video Shoutout",
        "ss_builder_title_block_video_shoutout_description": "Video qu\xe0 t\u1EB7ng t\u1EEB th\u1EA7n t\u01B0\u1EE3ng c\u1EE7a b\u1EA1n",
        "ss_builder_title_block_virtual_gift": "Virtual Gift",
        "ss_builder_title_block_virtual_gift_footer": "Virtual Gift Icon",
        "ss_builder_title_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_color": "M\xe0u ch\u1EEF",
        "ss_builder_title_combined": "Kh\u1ED1i k\u1EBFt h\u1EE3p",
        "ss_builder_title_introduction_service": "Th\xf4ng tin d\u1ECBch v\u1EE5",
        "ss_builder_title_page_builder": "Passio Page Builder",
        "ss_builder_title_setting_title": "Thi\u1EBFt l\u1EADp ti\xeau \u0111\u1EC1",
        "ss_builder_title_spacer_and_divider": "Spacer & Divider",
        "ss_builder_to_add_products_please_press_the_add_button_above": "\u0110\u1EC3 th\xeam s\u1EA3n ph\u1EA9m vui l\xf2ng nh\u1EA5n n\xfat \u201CTh\xeam\u201D \u1EDF ph\xeda tr\xean",
        "ss_builder_to_new_version": "\u0110i \u0111\u1EBFn Passio Page",
        "ss_builder_top_position_tab_label": "Tr\xean c\xf9ng",
        "ss_builder_transparent": "\u0110\u1ED9 trong su\u1ED1t",
        "ss_builder_truth_or_dare_warning": "Ch\u1EC9 \u0111\u01B0\u1EE3c th\xeam m\u1ED9t kh\u1ED1i n\xe0y tr\xean trang",
        "ss_builder_try_another_keyword_theme_store": "Kh\xf4ng c\xf3 giao di\u1EC7n m\u1EABu n\xe0o ph\xf9 h\u1EE3p v\u1EDBi t\u1EEB kh\xf3a c\u1EE7a b\u1EA1n. H\xe3y th\u1EED m\u1ED9t t\u1EEB kh\xf3a kh\xe1c.",
        "ss_builder_try_new_key": "H\xe3y th\u1EED v\u1EDBi t\u1EEB kh\xf3a kh\xe1c",
        "ss_builder_type_label": "Ki\u1EC3u",
        "ss_builder_type_of_color": "Ki\u1EC3u m\xe0u",
        "ss_builder_undo_theme_label": "Ho\xe0n t\xe1c",
        "ss_builder_update_account": "N\xe2ng c\u1EA5p t\xe0i kho\u1EA3n",
        "ss_builder_upload_button_label": "T\u1EA3i \u1EA3nh l\xean",
        "ss_builder_upload_file_format_invalid_content": "\u1EA2nh kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng. Vui l\xf2ng ch\u1ECDn m\u1ED9t trong c\xe1c \u0111\u1ECBnh d\u1EA1ng: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_file_format_invalid_content_for_gif_png_svg": "\u1EA2nh kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng. Vui l\xf2ng ch\u1ECDn m\u1ED9t trong c\xe1c \u0111\u1ECBnh d\u1EA1ng: GIF, PNG, SVG",
        "ss_builder_upload_file_format_invalid_content_v2": "\u1EA2nh kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng. Vui l\xf2ng ch\u1ECDn m\u1ED9t trong c\xe1c \u0111\u1ECBnh d\u1EA1ng: JPG, JPEG, GIF, PNG, BMP",
        "ss_builder_upload_file_size_invalid_content": "Vui l\xf2ng ch\u1ECDn file c\xf3 dung l\u01B0\u1EE3ng t\u1ED1i \u0111a 30MB",
        "ss_builder_upload_file_size_invalid_content_min_256": "Vui l\xf2ng ch\u1ECDn \u1EA3nh c\xf3 k\xedch th\u01B0\u1EDBc t\u1ED1i thi\u1EC3u 256x256px",
        "ss_builder_upload_large_file_format_invalid_content": "\u1EA2nh kh\xf4ng \u0111\xfang \u0111\u1ECBnh d\u1EA1ng. Vui l\xf2ng ch\u1ECDn m\u1ED9t trong c\xe1c \u0111\u1ECBnh d\u1EA1ng: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_large_file_size_invalid_content": "Vui l\xf2ng ch\u1ECDn file c\xf3 dung l\u01B0\u1EE3ng t\u1ED1i \u0111a 50MB",
        "ss_builder_uploading_image": "\u0110ang t\u1EA3i \u1EA3nh",
        "ss_builder_url_error_content": "Kh\xf4ng th\u1EC3 l\u1EA5y th\xf4ng tin. Vui l\xf2ng ki\u1EC3m tra l\u1EA1i \u0111\u01B0\u1EDDng d\u1EABn.",
        "ss_builder_url_placeholder": "Nh\u1EADp \u0111\u01B0\u1EDDng d\u1EABn li\xean k\u1EBFt",
        "ss_builder_use_advanced_setting_description": "B\u1EADt thi\u1EBFt l\u1EADp n\xe2ng cao \u0111\u1EC3 t\xf9y ch\u1EC9nh c\xe0i \u0111\u1EB7t hi\u1EC3n th\u1ECB ri\xeang cho Kh\u1ED1i k\u1EBFt h\u1EE3p n\xe0y",
        "ss_builder_use_affiliate_link_description": "T\xedch ch\u1ECDn \u0111\u1EC3 s\u1EED d\u1EE5ng Link Affiliate c\u1EE7a Ecomobi Passio. B\u1ECF tick ch\u1ECDn \u0111\u1EC3 s\u1EED d\u1EE5ng link c\u1EE7a b\u1EA1n.",
        "ss_builder_use_affiliate_link_label": "S\u1EED d\u1EE5ng tracking link c\u1EE7a Ecomobi Passio",
        "ss_builder_use_ecomobi_tracking_link": "S\u1EED d\u1EE5ng tracking link c\u1EE7a Ecomobi Passio",
        "ss_builder_validate_gen_link_error_E1": "Token kh\xf4ng h\u1EE3p l\u1EC7",
        "ss_builder_validate_gen_link_error_E2": "T\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n \u0111\xe3 b\u1ECB kh\xf3a, b\u1EA1n s\u1EBD kh\xf4ng nh\u1EADn \u0111\u01B0\u1EE3c hoa h\u1ED3ng.",
        "ss_builder_validate_gen_link_error_E3": "Li\xean k\u1EBFt n\xe0y kh\xf4ng \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 affiliate, b\u1EA1n s\u1EBD kh\xf4ng nh\u1EADn \u0111\u01B0\u1EE3c hoa h\u1ED3ng.",
        "ss_builder_validate_gen_link_error_E5": "Li\xean k\u1EBFt kh\xf4ng nh\u1EADn \u0111\u01B0\u1EE3c hoa h\u1ED3ng do chi\u1EBFn d\u1ECBch ch\u01B0a \u0111\u01B0\u1EE3c duy\u1EC7t. B\u1EA1n c\u1EA7n \u0111\u0103ng k\xfd tham gia chi\u1EBFn d\u1ECBch.",
        "ss_builder_validate_gen_link_error_E6": "Li\xean k\u1EBFt kh\xf4ng nh\u1EADn \u0111\u01B0\u1EE3c hoa h\u1ED3ng do b\u1EA1n \u0111\xe3 b\u1ECB ch\u1EB7n kh\u1ECFi chi\u1EBFn d\u1ECBch n\xe0y.",
        "ss_builder_validate_gen_link_error_E7": "Kh\xf4ng t\u1EA1o \u0111\u01B0\u1EE3c li\xean k\u1EBFt r\xfat g\u1ECDn do c\xf3 l\u1ED7i t\u1EEB h\u1EC7 th\u1ED1ng.",
        "ss_builder_validate_gen_link_error_E8": "Li\xean k\u1EBFt kh\xf4ng nh\u1EADn \u0111\u01B0\u1EE3c hoa h\u1ED3ng do chi\u1EBFn d\u1ECBch \u0111\xe3 k\u1EBFt th\xfac.",
        "ss_builder_video_shoutout_answer_method_description": "N\u1EBFu ch\u1EA5p nh\u1EADn y\xeau c\u1EA7u c\u1EE7a Fan Creator c\u1EA7n tr\u1EA3 l\u1EDDi l\u1EA1i b\u1EB1ng m\u1ED9t video",
        "ss_builder_video_shoutout_answer_method_title": "Ph\u01B0\u01A1ng th\u1EE9c tr\u1EA3 l\u1EDDi",
        "ss_builder_video_shoutout_btn_setup": "Thi\u1EBFt l\u1EADp ngay",
        "ss_builder_video_shoutout_des_intro_fan": "B\u1EA1n c\xf3 7 ng\xe0y \u0111\u1EC3 quy\u1EBFt \u0111\u1ECBnh th\u1EF1c hi\u1EC7n ho\u1EB7c t\u1EEB ch\u1ED1i y\xeau c\u1EA7u c\u1EE7a fan. N\u1EBFu b\u1EA1n t\u1EEB ch\u1ED1i kh\xf4ng th\u1EF1c hi\u1EC7n th\xec Ecomobi s\u1EBD ho\xe0n l\u1EA1i to\xe0n b\u1ED9 s\u1ED1 ti\u1EC1n \u0111\xe3 thanh to\xe1n t\u1EDBi ng\u01B0\u1EDDi y\xeau c\u1EA7u trong v\xf2ng 30 ng\xe0y.",
        "ss_builder_video_shoutout_des_intro_gift": "Th\xf4ng qua Passio, fan c\u1EE7a b\u1EA1n c\xf3 th\u1EC3 g\u1EEDi t\u1EDBi b\u1EA1n nh\u1EEFng y\xeau c\u1EA7u th\u1EF1c hi\u1EC7n video cho c\xe1c d\u1ECBp \u0111\u1EB7c bi\u1EC7t : sinh nh\u1EADt, ch\xfac m\u1EEBng, ng\xe0y k\u1EF7 ni\u1EC7m, video \u0111\u1ED9ng vi\xean, truy\u1EC1n c\u1EA3m h\u1EE9ng... v\u1EDBi m\u1ED9t kho\u1EA3n ph\xed nh\u1EA5t \u0111\u1ECBnh do ch\xednh b\u1EA1n \u0111\u1EC1 ra.",
        "ss_builder_video_shoutout_des_intro_policy": "B\u1EA1n v\xe0 fan c\xf3 th\u1EC3 chia s\u1EBB nh\u1EEFng video \xfd ngh\u0129a n\xe0y v\u1EDBi m\u1ECDi ng\u01B0\u1EDDi th\xf4ng qua c\xe1c trang m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_builder_video_shoutout_how_to_work": "Video ShoutOut ho\u1EA1t \u0111\u1ED9ng nh\u01B0 th\u1EBF n\xe0o?",
        "ss_builder_video_shoutout_introduction": "Video ShoutOut l\xe0 d\u1ECBch v\u1EE5 cho ph\xe9p Fan g\u1EEDi t\u1EDBi Creator nh\u1EEFng y\xeau c\u1EA7u v\u1EC1 m\u1ED9t video c\xe1 nh\xe2n h\xf3a cho c\xe1c d\u1ECBp c\u1EE5 th\u1EC3 nh\u01B0: Sinh nh\u1EADt, t\u1ED1t nghi\u1EC7p, ch\xfac m\u1EEBng,... Creator s\u1EBD ph\u1EA3n h\u1ED3i l\u1EA1i c\xe1c y\xeau c\u1EA7u \u0111\xf3 b\u1EB1ng m\u1ED9t video",
        "ss_builder_video_shoutout_participate_description": "Creator c\xf3 th\u1EC3 ch\u1ECDn th\u1EF1c hi\u1EC7n ho\u1EB7c t\u1EEB ch\u1ED1i y\xeau c\u1EA7u c\u1EE7a Fan",
        "ss_builder_video_shoutout_participate_title": "Quy\u1EC1n tham gia \u1EDF b\u1EA1n",
        "ss_builder_video_shoutout_response_description": "Sau khi Fan g\u1EEDi y\xeau c\u1EA7u, Creator c\xf3 7 ng\xe0y \u0111\u1EC3 th\u1EF1c hi\u1EC7n Video. Sau th\u1EDDi gian n\xe0y, s\u1ED1 ti\u1EC1n c\u1EE7a y\xeau c\u1EA7u \u0111\xf3 s\u1EBD \u0111\u01B0\u1EE3c ho\xe0n tr\u1EA3 l\u1EA1i Fan",
        "ss_builder_video_shoutout_response_title": "Th\u1EDDi gian ph\u1EA3n h\u1ED3i",
        "ss_builder_video_shoutout_title_intro": "Gi\u1EDBi thi\u1EC7u d\u1ECBch v\u1EE5",
        "ss_builder_video_shoutout_title_intro_fan": "Th\u1EF1c hi\u1EC7n Video",
        "ss_builder_video_shoutout_title_intro_gift": "Nh\u1EADn y\xeau c\u1EA7u t\u1EEB fan",
        "ss_builder_video_shoutout_title_intro_policy": "Chia s\u1EBB nh\u1EEFng kho\u1EA3nh kh\u1EAFc \xfd ngh\u0129a.",
        "ss_builder_virtual_gift_list_title": "Danh s\xe1ch qu\xe0 t\u1EB7ng",
        "ss_builder_wait_for_saving": "Qu\xe1 tr\xecnh l\u01B0u l\u1EA1i thi\u1EBFt l\u1EADp ch\u01B0a ho\xe0n t\u1EA5t. Vui l\xf2ng \u0111\u1EE3i trong gi\xe2y l\xe1t.",
        "ss_builder_warning_brand_gift_floating_continue": "Ti\u1EBFp t\u1EE5c",
        "ss_builder_warning_brand_gift_floating_description": "Hi\u1EC7n t\u1EA1i v\u1ECB tr\xed floating icon c\u1EE7a b\u1EA1n \u0111\xe3 h\u1EBFt. B\u1EA1n c\u1EA7n ph\u1EA3i x\xf3a b\u1EDBt block trong nh\xf3m floating icon \u1EDF v\u1ECB tr\xed m\u1EDF r\u1ED9ng. Xem",
        "ss_builder_warning_brand_gift_floating_description_link": "h\u01B0\u1EDBng d\u1EABn chi ti\u1EBFt",
        "ss_builder_warning_brand_gift_floating_reject": "T\u1EEB ch\u1ED1i",
        "ss_builder_warning_brand_gift_floating_title": "Floating icon \u0111\xe3 h\u1EBFt v\u1ECB tr\xed tr\u1ED1ng",
        "ss_builder_warning_brand_gift_rating_description": "Hi\u1EC7n t\u1EA1i th\xe2n trang \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n hi\u1EC3n th\u1ECB. B\u1EA1n c\u1EA7n xo\xe1 b\u1EDBt kh\u1ED1i \u0111\u1EC3 b\u1EADt t\xednh n\u0103ng Brand Ratings",
        "ss_builder_warning_brand_rating_floating_continue": "\u0110\xe3 hi\u1EC3u",
        "ss_builder_warning_brand_rating_floating_title": "Brand Ratings",
        "ss_builder_web_browser": "Tr\xecnh duy\u1EC7t web",
        "ss_builder_web_label": "Ss Builder Web Label",
        "ss_builder_website_config_site_title_description": "Lu\xf4n hi\u1EC3n th\u1ECB ngay tr\xean \u0111\u1EA7u trang khi fan truy c\u1EADp.",
        "ss_builder_website_config_site_title_label": "T\xean trang",
        "ss_builder_website_config_site_title_placeholder": "Nh\u1EADp n\u1ED9i dung",
        "ss_builder_what_field_are_you_operating_in": "B\u1EA1n \u0111ang ho\u1EA1t \u0111\u1ED9ng trong l\u0129nh v\u1EF1c n\xe0o?",
        "ss_builder_what_went_wrong": "N\u1ED9i dung b\xe1o l\u1ED7i",
        "ss_builder_width_tab_setting_label": "\u0110\u1ED9 r\u1ED9ng Tab",
        "ss_builder_width_tab_type_1": "T\u1EF1 \u0111\u1ED9ng",
        "ss_builder_width_tab_type_2": "Chia \u0111\u1EC1u",
        "ss_builder_your_page_is_ready": "Trang c\xe1 nh\xe2n c\u1EE7a b\u1EA1n \u0111\xe3 s\u1EB5n s\xe0ng!",
        "ss_cancle_delete": "Hu\u1EF7 b\u1ECF",
        "ss_challenge": "Th\xe1ch th\u1EE9c",
        "ss_confirm_delete": "X\xe1c nh\u1EADn xo\xe1",
        "ss_content_confirm_delete": "B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a s\u1EA3n ph\u1EA9m kh\u1ECFi danh s\xe1ch n\xe0y?",
        "ss_content_delete_forever": "\u0110\u1EC3 x\xf3a s\u1EA3n ph\u1EA9m vui l\xf2ng quay v\u1EC1 trang qu\u1EA3n tr\u1ECB s\u1EA3n ph\u1EA9m",
        "ss_content_intro_dp": "S\u1EA3n ph\u1EA9m s\u1ED1 \u0111\u01B0\u01A1\u0323c hi\xea\u0309u la\u0300 nh\u01B0\u0303ng sa\u0309n ph\xe2\u0309m tr\u1EF1c tuy\u1EBFn, kh\xf4ng c\xe2\u0300m n\u0103\u0301m \u0111\u01B0\u01A1\u0323c, ch\u01B0\u0301a n\xf4\u0323i dung h\u01B0\u0303u i\u0301ch cho ng\u01B0\u01A1\u0300i s\u01B0\u0309 du\u0323ng. V\xed d\u1EE5: Video, H\xecnh \u1EA3nh, Ebook, Kh\xf3a h\u1ECDc online,..",
        "ss_content_item1_dp": "T\xf9y thu\u1ED9c v\xe0o th\u1EBF m\u1EA1nh v\xe0 mong mu\u1ED1n c\u1EE7a b\u1EA1n, Passio cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7 c\xe1c lo\u1EA1i s\u1EA3n ph\u1EA9m s\u1ED1 nh\u01B0: \u1EA2nh, Video, Kh\xf3a h\u1ECDc online, Ebook, S\u1EA3n ph\u1EA9m d\u1EA1ng link,...",
        "ss_content_item2_dp": "Ch\u1EC9 v\u1EDBi ch\u01B0a \u0111\u1EBFn 3 ph\xfat, b\u1EA1n \u0111\xe3 c\xf3 th\u1EC3 c\u1EA5u h\xecnh v\xe0 \u0111\u0103ng b\xe1n m\u1ED9t s\u1EA3n ph\u1EA9m s\u1ED1 m\u1EDBi. H\u01A1n n\u1EEFa, sau khi ng\u01B0\u1EDDi mua thanh tho\xe1n th\xe0nh c\xf4ng, s\u1EA3n ph\u1EA9m s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi ngay t\u1EDBi email c\u1EE7a h\u1ECD, gi\xfap \u0111\u01A1n gi\u1EA3n h\xf3a vi\u1EC7c v\u1EADn chuy\u1EC3n v\xe0 ti\u1EBFt ki\u1EC7m th\u1EDDi gian",
        "ss_content_success_TOD": "B\u1EA1n \u0111\xe3 c\xe0i \u0111\u1EB7t t\xednh n\u0103ng Truth or Dare th\xe0nh c\xf4ng.",
        "ss_cover_image": "\u1EA2nh b\xeca",
        "ss_cover_image_empty": "Ch\u01B0a c\xf3 \u1EA3nh n\xe0o \u0111\u01B0\u1EE3c ch\u1ECDn",
        "ss_cover_image_helper": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP, WebP, t\u1ED1i \u0111a 4MB",
        "ss_cover_image_upload": "Ta\u0309i a\u0309nh l\xean",
        "ss_delete_forever": "X\xf3a v\u0129nh vi\u1EC5n",
        "ss_delete_product": "Xo\xe1 hi\u1EC3n th\u1ECB",
        "ss_display_delete": "Xo\xe1 hi\u1EC3n th\u1ECB",
        "ss_donation_currency_shortcut": "\u20AB",
        "ss_donation_setting_default_content_setup_donation": "D\u1ECBch v\u1EE5 \u0111ang \u0111\u01B0\u1EE3c c\xe0i \u0111\u1EB7t m\u1EB7c \u0111\u1ECBnh. N\u1EBFu b\u1EA1n mu\u1ED1n thay \u0111\u1ED5i, vui l\xf2ng truy c\u1EADp d\u1ECBch v\u1EE5 \u1EE6ng h\u1ED9 t\u1EA1i account.passio.eco",
        "ss_donation_setting_default_title_setup_donation": "Thi\u1EBFt l\u1EADp d\u1ECBch v\u1EE5",
        "ss_dp_add": "Th\xeam",
        "ss_dp_cat_course": "Kh\xf3a h\u1ECDc/ Tutorial",
        "ss_dp_cat_ebook_document": "Ebook/ Ta\u0300i li\xea\u0323u",
        "ss_dp_cat_online_consultion": "T\u01B0 v\u1EA5n online 1-1",
        "ss_dp_cat_random_product": "S\u1EA3n ph\u1EA9m b\u1EA5t k\u1EF3",
        "ss_dp_cat_ticket_account": "V\xe9/ T\xe0i kho\u1EA3n",
        "ss_dp_cat_video": "Video \u0111\xf4\u0323c quy\xea\u0300n",
        "ss_dp_sell_photo": "\u1EA2nh",
        "ss_edit_TOD": "Ch\u1EC9nh s\u1EEDa",
        "ss_example_TOD": "V\xed d\u1EE5: 100,000",
        "ss_exit_TOD": "Tho\xe1t",
        "ss_first_person": "Tr\u1EDF th\xe0nh ng\u01B0\u1EDDi \u0111\u1EA7u ti\xean th\u1EED th\xe1ch ngay n\xe0o!",
        "ss_gift_button_preview": "G\u1EEDi qu\xe0 li\u1EC1n tay!",
        "ss_gift_invitation": "T\u1EB7ng qu\xe0 ngay cho {user} \u0111\u1EC3 m\xecnh c\xf3 th\xeam nhi\u1EC1u \u0111\u1ED9ng l\u1EF1c nh\xe9!",
        "ss_had": "\u0110\xe3 c\xf3",
        "ss_iframe_add_new_product": "Th\xeam s\u1EA3n ph\u1EA9m m\u1EDBi",
        "ss_iframe_add_product": "Th\xeam s\u1EA3n ph\u1EA9m",
        "ss_iframe_choose_product_from_store": "Ch\u1ECDn t\u1EEB kho d\u1EEF li\u1EC7u",
        "ss_inline_image_empty": "Tr\u01B0\u1EDDng n\xe0y kh\xf4ng \u0111\u01B0\u1EE3c \u0111\u1EC3 tr\u1ED1ng",
        "ss_inline_txtbtn_max_length": "Tr\u01B0\u1EDDng n\xe0y v\u01B0\u1EE3t qu\xe1 40 k\xfd t\u1EF1.",
        "ss_input_placehoder": "Nh\u1EADp n\u1ED9i dung",
        "ss_invitation_TOD": "N\u1ED9i dung m\u1EDDi ch\xe0o th\u1EF1c hi\u1EC7n th\u1EED th\xe1ch",
        "ss_invitation_TOD_placeholder": "Nh\u1EADp n\u1ED9i dung m\u1EDDi fan tham gia",
        "ss_logout": "\u0110\u0103ng xu\u1EA5t",
        "ss_modal_cancel_confirm": "H\u1EE7y b\u1ECF",
        "ss_modal_text_confirm": "\u0110i \u0111\u1EBFn trang qu\u1EA3n tr\u1ECB",
        "ss_no": "Kh\xf4ng",
        "ss_placeholder_message_TOD": "Nh\u1EADp n\u1ED9i dung th\xe1ch th\u1EE9c",
        "ss_preview_TOD": "Ti\u1EBFp t\u1EE5c",
        "ss_profile": "H\u1ED3 s\u01A1",
        "ss_push_TOD": "\u0110\u0103ng t\u1EA3i",
        "ss_rount_tod": "L\u01B0\u1EE3t th\u1EED th\xe1ch",
        "ss_service_introduction": "Gi\u1EDBi thi\u1EC7u d\u1ECBch v\u1EE5",
        "ss_setting_TOD_background_tooltip": "Ch\u1ECDn \u1EA3nh n\u1EC1n t\u1EF7 l\u1EC7 3:2 v\u1EDBi dung l\u01B0\u1EE3ng t\u1ED1i \u0111a 4 MB",
        "ss_setting_TOD_field_image_background": "Th\xeam h\xecnh n\u1EC1n",
        "ss_setting_TOD_field_image_background_bottom": "H\xecnh n\u1EC1n",
        "ss_setting_TOD_field_welcome_tooltip": "N\u1ED9i dung L\u1EDDi k\xeau g\u1ECDi fan th\u1EED th\xe1ch s\u1EBD t\u1EF1 \u0111\u1ED9ng \u0111i\u1EC1n n\u1EBFu b\u1EA1n b\u1ECF tr\u1ED1ng.",
        "ss_setup_now": "Thi\u1EBFt l\u1EADp ngay",
        "ss_shoutout_btn_content": "N\u1ED9i dung n\xfat",
        "ss_shoutout_change_file": "\u0110\u1ED5i \u1EA3nh/video",
        "ss_shoutout_create_request": "T\u1EA1o y\xeau c\u1EA7u ngay",
        "ss_shoutout_description": "M\xf4 t\u1EA3",
        "ss_shoutout_description_placeholder": "Nh\u1EADp v\xe0o n\u1ED9i dung gi\u1EDBi thi\u1EC7u",
        "ss_shoutout_error_price_required": "Vui l\xf2ng nh\u1EADp v\xe0o gi\xe1 ti\u1EC1n",
        "ss_shoutout_error_upload": "C\xf3 l\u1ED7i x\u1EA3y ra, t\u1EA3i l\xean th\u1EA5t b\u1EA1i",
        "ss_shoutout_error_video_size": "Vui l\xf2ng t\u1EA3i l\xean h\xecnh \u1EA3nh/ video t\u1ED1i \u0111a 500MB",
        "ss_shoutout_error_video_type": "Vui l\xf2ng t\u1EA3i l\xean file l\xe0 m\u1ED9t trong c\xe1c \u0111\u1ECBnh d\u1EA1ng JPG, JPEG, GIF, PNG, BMP, WebP, HEIF, HEIC, MP4, MOV",
        "ss_shoutout_file_intro": "\u1EA2nh/video gi\u1EDBi thi\u1EC7u",
        "ss_shoutout_file_intro_note": "T\u1EA3i l\xean h\xecnh \u1EA3nh ho\u1EB7c video \u0111\u1EC3 k\xeau g\u1ECDi Fan s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 Video Shoutout t\u1EEB b\u1EA1n",
        "ss_shoutout_no_file_selected": "Ch\u01B0a c\xf3 \u1EA3nh/video n\xe0o \u0111\u01B0\u1EE3c ch\u1ECDn",
        "ss_shoutout_price": "Gi\xe1 ti\u1EC1n",
        "ss_shoutout_price_placeholder": "Nh\u1EADp v\xe0o gi\xe1 ti\u1EC1n",
        "ss_shoutout_select_file": "Ch\u1ECDn \u1EA3nh/video",
        "ss_shoutout_type_support": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP, WebP, HEIF, HEIC, MP4, MOV t\u1ED1i \u0111a 500MB",
        "ss_shoutout_upload_success": "T\u1EA3i video l\xean th\xe0nh c\xf4ng",
        "ss_success_TOD": "Th\xe0nh c\xf4ng",
        "ss_success_off_TOD": "B\u1EA1n \u0111\xe3 t\u1EAFt t\xednh n\u0103ng Truth or Dare th\xe0nh c\xf4ng.",
        "ss_success_on_TOD": "B\u1EA1n \u0111\xe3 b\u1EADt t\xednh n\u0103ng Truth or Dare th\xe0nh c\xf4ng.",
        "ss_success_setup_TOD": "B\u1EA1n \u0111\xe3 c\xe0i \u0111\u1EB7t t\xednh n\u0103ng Truth or Dare th\xe0nh c\xf4ng.",
        "ss_title_intro_dp": "S\u1EA3n ph\u1EA9m s\u1ED1 l\xe0 g\xec",
        "ss_title_item1_dp": "\u0110a d\u1EA1ng c\xe1c lo\u1EA1i s\u1EA3n ph\u1EA9m cho b\u1EA1n l\u1EF1a ch\u1ECDn",
        "ss_title_item2_dp": "D\u1EC5 d\xe0ng qu\u1EA3n l\xfd s\u1EA3n ph\u1EA9m v\xe0 \u0111\u01A1n h\xe0ng b\u1EB1ng m\u1ED9t v\xe0i thao t\xe1c",
        "ss_tod_challenge_number": "S\u1ED1 th\u1EED th\xe1ch",
        "ss_tod_content": "N\u1ED9i dung m\u1EDDi ch\xe0o",
        "ss_tod_dare_content": "L\u1EDDi k\xeau g\u1ECDi fan g\u1EEDi th\u1EED th\xe1ch",
        "ss_tod_dare_fee": "S\u1ED1 ti\u1EC1n t\u1ED1i thi\u1EC3u fan thanh to\xe1n \u0111\u01A1n Dare",
        "ss_tod_default_content": "Th\u1EED lu\xf4n s\u1EE3 g\xec!",
        "ss_tod_default_dare_content": "Cao th\u1EE7 c\xf3 g\u1EB7p th\xe1ch \u0111\u1EA5u? Th\u1EED th\xe1ch th\u1EE9c m\xecnh xem!",
        "ss_tod_min_price_dare_alias": "S\u1ED1 ti\u1EC1n t\u1ED1i thi\u1EC3u fan thanh to\xe1n \u0111\u01A1n Dare",
        "ss_tod_min_price_dare_note": "Thanh to\xe1n t\u1ED1i thi\u1EC3u l\xe0 1,000 \u20AB",
        "ss_tod_setting_cover_image": "\u1EA2nh b\xeca",
        "ss_tod_setting_cover_image_helper": "H\u1ED7 tr\u1EE3: JPG, JPEG, GIF, PNG, BMP, WebP, t\u1ED1i \u0111a 4MB",
        "ss_tod_setting_field_welcome_tooltip": "N\u1ED9i dung L\u1EDDi k\xeau g\u1ECDi fan th\u1EED th\xe1ch s\u1EBD t\u1EF1 \u0111\u1ED9ng \u0111i\u1EC1n n\u1EBFu b\u1EA1n b\u1ECF tr\u1ED1ng.",
        "ss_tod_setting_input_placehoder": "Nh\u1EADp n\u1ED9i dung",
        "ss_tod_tooltip_content": "N\u1ED9i dung l\u1EDDi m\u1EDDi ch\xe0o gi\u1EDBi h\u1EA1n t\u1ED1i \u0111a 60 k\xfd t\u1EF1.",
        "ss_tod_tooltip_min_price_dare": "N\u1ED9i dung l\u1EDDi m\u1EDDi ch\xe0o t\u1ED1i \u0111a 60 k\xfd t\u1EF1.",
        "ss_txt_btn_TOD": "L\u1EDDi k\xeau g\u1ECDi fan g\u1EEDi th\u1EED th\xe1ch",
        "ss_validate_domain_error_E1": "T\xean mi\u1EC1n \u0111\xe3 \u0111\u01B0\u1EE3c \u0111\u1ED5i trong v\xf2ng 30 ng\xe0y, kh\xf4ng th\u1EC3 \u0111\u1ED5i",
        "ss_validate_domain_error_E2": "T\xean mi\u1EC1n \u0111\xe3 t\u1ED3n t\u1EA1i, xin vui l\xf2ng th\u1EED t\xean kh\xe1c",
        "ss_validate_domain_error_E3": "T\xean mi\u1EC1n n\xe0y b\u1ECB c\u1EA5m",
        "ss_validate_origin_url_error_E203": "Kh\xf4ng th\u1EC3 t\xecm th\u1EA5y t\xean mi\u1EC1n n\xe0y. Vui l\xf2ng ki\u1EC3m tra v\xe0 th\u1EED l\u1EA1i.",
        "ss_validate_origin_url_error_E5": "B\u1EA1n ch\u01B0a \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t chi\u1EBFn d\u1ECBch n\xe0y, vui l\xf2ng y\xeau c\u1EA7u ph\xea duy\u1EC7t chi\u1EBFn d\u1ECBch",
        "ss_validate_origin_url_error_E6": "B\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c tham gia chi\u1EBFn d\u1ECBch n\xe0y, vui l\xf2ng ki\u1EC3m tra l\u1EA1i v\u1EDBi nh\xe2n vi\xean h\u1ED7 tr\u1EE3",
        "ss_validate_origin_url_error_E7": "H\u1EC7 th\u1ED1ng kh\xf4ng h\u1ED7 tr\u1EE3 URL n\xe0y",
        "ss_validate_origin_url_error_E9": "Chi\u1EBFn d\u1ECBch \u0111\xe3 k\u1EBFt th\xfac, vui l\xf2ng ch\u1ECDn URL kh\xe1c",
        "ss_validate_origin_url_error_V0": "Url kh\xf4ng h\u1EE3p l\u1EC7",
        "ss_validate_origin_url_error_sys": "Vui l\xf2ng nh\u1EADp m\u1ED9t URL h\u1EE3p l\u1EC7",
        "ss_validate_origin_url_warning_E5": "B\u1EA1n ch\u01B0a \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t chi\u1EBFn d\u1ECBch n\xe0y. Order v\xe0 Commission s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c ghi nh\u1EADn.",
        "ss_validate_origin_url_warning_E7": "Li\xean k\u1EBFt kh\xf4ng \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3. Order v\xe0 Commission s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c ghi nh\u1EADn.",
        "ss_validate_origin_url_warning_E9": "Chi\u1EBFn d\u1ECBch n\xe0y \u0111\xe3 k\u1EBFt th\xfac. Order v\xe0 Commission s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c ghi nh\u1EADn.",
        "text_cashback_brand_gift": "Ho\xe0n ti\u1EC1n",
        "text_custom_brand_gift": "C\xe1 nh\xe2n h\xf3a",
        "text_voucher_brand_gift": "Voucher",
        "undefined": "Undefined",
        "voucher_default_text_button": "Nh\u1EADn voucher ngay",
        "voucher_default_title": "Ch\u1EA1m l\u1EB9 thanh to\xe1n, ho\xe0n ti\u1EC1n 5%",
        "warning_text_TOD": "C\xe0i \u0111\u1EB7t c\u1EE7a b\u1EA1n ch\u01B0a \u0111\u01B0\u1EE3c l\u01B0u. B\u1EA1n v\u1EABn mu\u1ED1n tho\xe1t ch\u1EE9?",
        "warning_text_switch_TOD": "B\u1EA1n c\xf3 mu\u1ED1n t\u1EAFt t\xednh n\u0103ng Truth or Dare kh\xf4ng?"
    }
};
/* harmony default export */ var messages_vi = (vi);

;// CONCATENATED MODULE: ./src/messages/id.ts
var id = {
    translation: {
        "button_confirm_exit_TOD": "Ya/Keluar",
        "button_confirm_off_TOD": "Ya",
        "button_title_default_donation": "Berikan dukungan ke {name}!",
        "cashback_default_text_button": "Dapatkan pengembalian dana sekarang!",
        "cashback_default_title": "Nikmati belanja mudah, cashback besar",
        "cm_home": "Home",
        "default_content_setup_brand_gift": "Pilih template atau buat sendiri",
        "default_content_setup_donation": "Layanan ini sedang diatur secara default. Jika Anda ingin mengubah, silakan kunjungi layanan Donasi di account.passio.eco",
        "default_title_setup_brand_gift": "Pengaturan",
        "default_title_setup_donation": "Pengaturan layanan",
        "error_thumbnail_size_TOD": "Ukuran gambar berlebihan",
        "invitation_default_donation": "Apa kamu menyukai {name}?",
        "label_tab_bar_brand_gift": "Template",
        "label_text_button_brand_gift": "Tombol",
        "label_text_title_brand_gift": "Judul",
        "login": "Masuk",
        "message_default_donation": "Terima kasih atas dukungan Anda ke {name}. Semoga kita memiliki lebih banyak kesempatan untuk berinteraksi satu sama lain!",
        "placeholder_text_button_brand_gift": "Masukkan teks tombol",
        "placeholder_text_title_brand_gift": "Masukkan judul",
        "ss_background_TOD": "Foto background",
        "ss_brand_cpc_bonus": "id_Hoa h\u1ED3ng",
        "ss_brand_cpc_campaign_title": "Ss Brand Cpc Campaign Title",
        "ss_brand_cpc_description": "id_M\xf4 t\u1EA3 ch\u01B0\u01A1ng tr\xecnh",
        "ss_brand_cpc_download": "id_T\u1EA3i xu\u1ED1ng",
        "ss_brand_cpc_from": "id_T\u1EEB",
        "ss_brand_cpc_join": "id_Tham gia",
        "ss_brand_cpc_join_now": "id_Tham kh\u1EA3o ngay",
        "ss_brand_cpc_join_successfully_label": "id_B\u1EA1n \u0111\xe3 tham gia ch\u01B0\u01A1ng tr\xecnh th\xe0nh c\xf4ng",
        "ss_brand_cpc_no_access_allow": "id_B\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p truy c\u1EADp v\xe0o link n\xe0y",
        "ss_brand_cpc_notice": "id_L\u01B0u \xfd",
        "ss_brand_cpc_notice_content": "id_Hoa h\u1ED3ng s\u1EBD \u0111\u01B0\u1EE3c tr\u1EA3 v\u1EC1 t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n sau 7 ng\xe0y k\u1EC3 t\u1EEB khi \u0111\u01B0\u1EE3c nghi\u1EC7m thu.",
        "ss_brand_cpc_reject": "id_\u1EA2nh nghi\u1EC7m thu c\u1EE7a b\u1EA1n \u0111\xe3 b\u1ECB t\u1EEB ch\u1ED1i. B\u1EA1n c\xf3 th\u1EC3 t\u1EA3i l\u1EA1i \u1EA3nh.",
        "ss_brand_cpc_requirement": "Ss Brand Cpc Requirement",
        "ss_brand_cpc_step_1": "id_B\u01B0\u1EDBc 1: T\u1EA3i \u1EA3nh d\u01B0\u1EDBi \u0111\xe2y v\u1EC1 v\xe0 up l\xean 1 n\u1EC1n t\u1EA3ng m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_brand_cpc_step_1_note": "id_L\u01B0u \xfd: up \u1EA3nh trong kho\u1EA3ng th\u1EDDi gian",
        "ss_brand_cpc_step_2": "id_B\u01B0\u1EDBc 2: T\u1EA3i \u1EA3nh nghi\u1EC7m thu (\u1EA3nh ch\u1EE5p m\xe0n h\xecnh b\xe0i \u0111\u0103ng c\u1EE7a b\u1EA1n \u1EDF b\u01B0\u1EDBc 1)",
        "ss_brand_cpc_step_2_note": "Ss Brand Cpc Step 2 Note",
        "ss_brand_cpc_success": "id_\u0110\xe3 nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_text_content": "id_\u0111ang g\u1EEDi cho b\u1EA1n 01 l\u1EDDi \u0111\u1EC1 ngh\u1ECB tham gia v\xe0o ch\u01B0\u01A1ng tr\xecnh treo banner - nh\u1EADn ti\u1EC1n th\u01B0\u1EDFng.",
        "ss_brand_cpc_text_title": "id_Nh\u1EADn ti\u1EC1n d\u1EC5 d\xe0ng c\xf9ng",
        "ss_brand_cpc_time": "id_Th\u1EDDi gian",
        "ss_brand_cpc_time_end": "id_Th\u1EDDi gian k\u1EBFt th\xfac",
        "ss_brand_cpc_time_start": "id_Th\u1EDDi gian b\u1EAFt \u0111\u1EA7u",
        "ss_brand_cpc_to": "id_\u0110\u1EBFn",
        "ss_brand_cpc_upload_image": "id_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_cpc_upload_image_button": "id_T\u1EA3i \u1EA3nh l\xean",
        "ss_brand_cpc_upload_image_successfully": "id_B\u1EA1n \u0111\xe3 g\u1EEDi \u1EA3nh nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_upload_image_title": "id_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_gift_cancel_hide": "id_H\u1EE7y b\u1ECF",
        "ss_brand_gift_confirm_hide_brand": "id_X\xe1c nh\u1EADn",
        "ss_brand_gift_confirm_hide_group": "id_X\xe1c nh\u1EADn \u1EA9n nh\xf3m",
        "ss_brand_gift_disable_deal_successfully": "id_\u1EA8n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_disable_successfully": "id_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_display_hide_brand": "id_\u1EA8n Deal",
        "ss_brand_gift_display_hide_category": "id_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_display_show_brand": "id_Hi\u1EC7n Deal",
        "ss_brand_gift_display_show_category": "id_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_empty_title": "id_Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m n\xe0o",
        "ss_brand_gift_enable_deal_successfully": "id_Hi\u1EC7n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_enable_successfully": "id_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_hide_brand": "id_B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n Deal?",
        "ss_brand_gift_hide_brand_content": "id_Deal {{name}} s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB \u1EDF giao di\u1EC7n c\u1EE7a Fan. B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n deal n\xe0y?",
        "ss_brand_gift_hide_category": "id_B\u1EA1n mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_hide_category_content": "id_Nh\xf3m {{name}} v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB \u1EA9n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_list_category": "Product group list",
        "ss_brand_gift_list_empty_content": "id_Hi\u1EC7n gi\u1EDD Admin ch\u01B0a setup d\u1EEF li\u1EC7u s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_setting_cashback_default_text_button": "Dapatkan pengembalian dana sekarang!",
        "ss_brand_gift_setting_cashback_default_title": "Nikmati belanja mudah, cashback besar",
        "ss_brand_gift_setting_default_content_setup": "Pilih template atau buat sendiri",
        "ss_brand_gift_setting_float_icon_description": "Simpan pengaturan floating icon untuk meningkatkan interaksi dengan fan",
        "ss_brand_gift_setting_float_icon_footer_description": "Aktifkan fitur ini untuk meningkatkan interaksi dengan fan",
        "ss_brand_gift_setting_label_tab_bar_brand_gift": "Template",
        "ss_brand_gift_setting_label_text_button": "Tombol",
        "ss_brand_gift_setting_label_text_title_brand_gift": "Judul",
        "ss_brand_gift_setting_placeholder_text_button": "Masukkan teks tombol",
        "ss_brand_gift_setting_placeholder_text_title": "Masukkan judul",
        "ss_brand_gift_setting_text_cashback_brand_gift": "Cashback",
        "ss_brand_gift_setting_text_custom_brand_gift": "Customize",
        "ss_brand_gift_setting_text_voucher_brand_gift": "Voucher",
        "ss_brand_gift_setting_title_block_footer": "Brand Gift Icon",
        "ss_brand_gift_setting_voucher_default_text_button": "Dapatkan voucher sekarang!",
        "ss_brand_gift_setting_voucher_default_title": "Klik bayar, cashback 5%",
        "ss_brand_rating_setting_default_content_setup_donation": "id_Danh s\xe1ch c\xe1c ch\u01B0\u01A1ng tr\xecnh ho\xe0n ti\u1EC1n gi\u1EA3m gi\xe1 d\xe0nh cho fan c\u1EE7a b\u1EA1n. B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 nh\u1EADn hoa h\u1ED3ng ngay!",
        "ss_build_collapse_block_label": "Sembunyikan",
        "ss_build_expand_block_label": "Perluas",
        "ss_build_no_blocks_have_been_added": "Belum ada blok",
        "ss_builde_theme_setting_block": "Blok",
        "ss_builder_1st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block.",
        "ss_builder_1st_block_preview_sample_title": "Block 1",
        "ss_builder_2st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block. 2nd block to see the spacing between blocks.",
        "ss_builder_2st_block_preview_sample_title": "Block 2",
        "ss_builder_add_affiliate_product_list_btn_label": "Tambahkan lebih banyak produk",
        "ss_builder_add_block_body_title": "Body",
        "ss_builder_add_block_expand_title": "Extended Position",
        "ss_builder_add_block_footer_title": "Footer",
        "ss_builder_add_block_header_title": "Header",
        "ss_builder_add_block_in_template": "Tambah blok template",
        "ss_builder_add_block_in_template_successfully": "Add block template successfully",
        "ss_builder_add_block_label": "Tambah Blok",
        "ss_builder_add_block_to": "Tambah blok ke:",
        "ss_builder_add_image_of_image_popup_tilte": "Tambahkan gambar pop-up",
        "ss_builder_add_new_affiliate_product_btn_label": "Tambahkan produk baru",
        "ss_builder_add_new_affiliate_product_group_btn_label": "Tambahkan grup produk",
        "ss_builder_add_new_affiliate_product_image_title": "Gambar produk",
        "ss_builder_add_new_affiliate_product_list_empty_content": "Untuk menambahkan produk baru, silakan masukkan url produk di bawah ini",
        "ss_builder_add_new_affiliate_product_name_title": "Nama Produk",
        "ss_builder_add_new_affiliate_product_title": "Tambahkan produk baru",
        "ss_builder_add_new_block_successfully_label": "Berhasil tambahkan blok baru",
        "ss_builder_add_new_image": "Tambahkan gambar baru",
        "ss_builder_add_new_image_of_image_popup_title": "Gambar pop-up",
        "ss_builder_add_new_image_of_image_slider_title": "Gambar",
        "ss_builder_add_new_image_popup_btn_label": "Tambah",
        "ss_builder_add_new_image_slider_title": "Tambah gambar",
        "ss_builder_add_new_label": "Tambah",
        "ss_builder_add_new_product_group_successfully_label": "Sukses menambahkan grup produk",
        "ss_builder_add_new_tab_successfully_label": "Berhasil tambahkan tab baru",
        "ss_builder_add_new_tag_error_duplicate": "Tag sudah pernah dibuat",
        "ss_builder_add_new_template_btn_label": "Simpan",
        "ss_builder_add_new_template_image_title": "Gambar Template",
        "ss_builder_add_new_template_label": "Buat template baru",
        "ss_builder_add_new_template_name_placeholder": "Masukkan nama template",
        "ss_builder_add_new_template_name_title": "Nama Template",
        "ss_builder_add_new_theme_btn_label": "Buat baru",
        "ss_builder_add_new_theme_selection_panel_description": "Pilih metode untuk membuat Template Tema untuk dipublikasikan ke Theme Store.",
        "ss_builder_add_new_theme_selection_panel_label": "Buat template tema",
        "ss_builder_add_new_theme_template_image_title": "Gambar template tema",
        "ss_builder_add_new_theme_template_name_placeholder": "Masukkan nama template tema",
        "ss_builder_add_new_theme_template_name_title": "Nama template tema",
        "ss_builder_add_story": "Tambah yang baru",
        "ss_builder_add_tab_label": "Tambahkan Tab",
        "ss_builder_added_product_url_label": "Tautan sudah ditambahkan",
        "ss_builder_advanced_group_description": "Blok lanjutan",
        "ss_builder_advanced_setting": "Pengaturan lanjutan",
        "ss_builder_advanced_title": "Canggih",
        "ss_builder_aff_frame_max_size_content": "Ukuran file maks: 30MB.",
        "ss_builder_aff_frame_select_from_library": "Pilih dari Library",
        "ss_builder_aff_frame_support_type_file_content": "Mendukung format file: gif, png, svg",
        "ss_builder_affiliate_add_new_tour_content_step_1": "Pilih Grup Produk untuk mengkategorikan produk mu. Produk berikut akan ditambahkan ke grup yang kamu pilih.",
        "ss_builder_affiliate_add_new_tour_content_step_2": "Masukkan Link untuk produk, sistem akan otomatis mencari data produk.",
        "ss_builder_affiliate_add_new_tour_content_step_3": "Kamu dapat mengubah nama, gambar, label dari produk.",
        "ss_builder_affiliate_add_new_tour_content_step_4": 'Pilih menu "Tambah Produk" untuk menambah produk diatas ke dalam grup.',
        "ss_builder_affiliate_add_new_tour_title_step_1": "Pilih Grup Produk",
        "ss_builder_affiliate_add_new_tour_title_step_2": "Link Produk",
        "ss_builder_affiliate_add_new_tour_title_step_3": "Info Produk",
        "ss_builder_affiliate_add_new_tour_title_step_4": "Tambah Produk",
        "ss_builder_affiliate_group_tour_content_step_1": "Tambah grup atau kategori produk",
        "ss_builder_affiliate_group_tour_content_step_2": "Mengatur dan merubah setiap grup, memudahkan dalam mengatur blok sesuai yang diinginkan.",
        "ss_builder_affiliate_group_tour_title_step_1": "Tambah Grup Produk",
        "ss_builder_affiliate_group_tour_title_step_2": "Quick Actions",
        "ss_builder_affiliate_product_btn_see_more_placeholder": "Masukkan konten",
        "ss_builder_affiliate_product_btn_see_more_title": "Tampilkan label tombol lainnya",
        "ss_builder_affiliate_product_clean_up_popover_content": "Produk ini tidak akan dibersihkan secara otomatis ketika grup produk penuh",
        "ss_builder_affiliate_product_cleanup_lock_label": "Tutup fitur pembersihan",
        "ss_builder_affiliate_product_cleanup_unlock_label": "Buka fitur pembersihan",
        "ss_builder_affiliate_product_frame_panel_title": "Pilih frame",
        "ss_builder_affiliate_product_group_add_new_panel_title": "Informasi grup",
        "ss_builder_affiliate_product_group_list_selector_label": "List Grup Produk",
        "ss_builder_affiliate_product_group_management_title": "Manajemen grup produk",
        "ss_builder_affiliate_product_group_other": "Lainnya",
        "ss_builder_affiliate_product_group_placeholder": "Masukkan judul blok",
        "ss_builder_affiliate_product_group_quantity_label": "{{product_quantity}} produk",
        "ss_builder_affiliate_product_group_quantity_warning_1": "Tidak bisa menambahkan",
        "ss_builder_affiliate_product_group_quantity_warning_2": "Melebihi jumlah yang tersedia",
        "ss_builder_affiliate_product_group_title": "Judul blok",
        "ss_builder_affiliate_product_image_popup_infomation_label": "Gambar dipasang secara otomatis dari link produk. Kamu dapat mengganti dengan gambar lain.",
        "ss_builder_affiliate_product_label_product_discount": "Diskon",
        "ss_builder_affiliate_product_label_product_hot": "Hot",
        "ss_builder_affiliate_product_label_product_like": "Favorit",
        "ss_builder_affiliate_product_label_product_title": "Label produk",
        "ss_builder_affiliate_product_list_empty_content": "To add products please press the \u201CAdd\u201D button above",
        "ss_builder_affiliate_product_list_empty_title": "Belum ada produk yang ditambahkan",
        "ss_builder_affiliate_product_list_title": "List",
        "ss_builder_affiliate_product_moving_panel_title": "Pindahkan ke",
        "ss_builder_affiliate_product_quantity_on_row_title": "Jumlah produk per baris",
        "ss_builder_affiliate_product_searching_placeholder": "Cari produk berdasarkan nama",
        "ss_builder_affiliate_product_style_title": "Gaya",
        "ss_builder_affiliate_setting_popover_manual_content": 'Cari tahu bagaimana cara kerja Blok Affiliate,mulai dengan menekan menu "Memulai"',
        "ss_builder_affiliate_setting_popover_manual_title": "Panduan Passio",
        "ss_builder_affiliate_setting_tour_content_step_1": "Melakukan perintah Sembunyikan/Tampilkan, Hapus blok.",
        "ss_builder_affiliate_setting_tour_content_step_2": "Atur Judul dan Deskripsi untuk blok, the info blok akan tampil setelah disimpan.",
        "ss_builder_affiliate_setting_tour_content_step_3": "Pilih style tampilan produk di dalam blok. Setelah mengubah dan menyimpan pengaturan blok ini maka akan otomatis terupdate/",
        "ss_builder_affiliate_setting_tour_content_step_4": "Buat dan atur Product Groups untuk memisahkan produk sesuai dengan kategori. Sehingga membuat fans dapat mencari produk yang diinginkan lebih mudah. Contoh : Pakaian, Sepatu, Aksesoris dan lainnya",
        "ss_builder_affiliate_setting_tour_content_step_5": "Akses cepat ke tiap Product Group untuk menambahkan produk di masing-masing kategori.",
        "ss_builder_affiliate_setting_tour_content_step_6": 'Tambah produk baru dengan memilih menu "Tambah"',
        "ss_builder_affiliate_setting_tour_content_step_7": "Pengaturan cepat untuk setiap produk sehingga memudahkan dalam mengatur list produk.",
        "ss_builder_affiliate_setting_tour_content_step_8": 'Setelah merubah, dan menambahkan produk kedalam blok, tekan menu "Simpan" dan akan otomatis terupdate.',
        "ss_builder_affiliate_setting_tour_title_step_1": "Quick Actions",
        "ss_builder_affiliate_setting_tour_title_step_2": "Judul dan deskripsi",
        "ss_builder_affiliate_setting_tour_title_step_3": "Tampilan List Produk",
        "ss_builder_affiliate_setting_tour_title_step_4": "Pengaturan Grup Produk",
        "ss_builder_affiliate_setting_tour_title_step_5": "Grup Produk",
        "ss_builder_affiliate_setting_tour_title_step_6": "Tambah Produk",
        "ss_builder_affiliate_setting_tour_title_step_7": "Opsi Produk",
        "ss_builder_affiliate_setting_tour_title_step_8": "Simpan Produk",
        "ss_builder_affiliate_upload_product_error_content": "File yang diunggah harus berupa json file dengan format file yang diperbolehkan",
        "ss_builder_affiliate_upload_product_error_label": "Format file salah",
        "ss_builder_affiliate_upload_product_label": "Unggah file produk",
        "ss_builder_all_setting_and_product": "semua pengaturan dan produk di dalamnya",
        "ss_builder_all_the_blocks_are_in_your_list_by_the_blocks_of_the_template": "seluruh blok yang ada di list dengan blok dari template",
        "ss_builder_allowed_domain_label": "Nama domain belum terdaftar, Anda dapat menggunakan nama domain ini",
        "ss_builder_an_unexpected_error_has_occurred": "Sebuah kesalahan yang tidak terduga telah terjadi.",
        "ss_builder_apply_preview_theme_template_btn_label": "Apply",
        "ss_builder_apply_template_successfully_label": "Sukses menggunakan template",
        "ss_builder_apply_template_title": "Kamu ingin menggunakan template ini?",
        "ss_builder_apply_theme_premium_warning": "Tema ini khusus untuk akun premium. Silahkan upgrade tipe akun mu untuk menggunakan tema ini.",
        "ss_builder_apply_theme_premium_warning_title": "Apakah kamu ingin mengaktifkan tema ini?",
        "ss_builder_apply_theme_template_successfully_label": "Sukses menerapkan template tema baru",
        "ss_builder_auto_cleanup_products_warning_content_1": "Melebihi jumlah produk. Sistem akan secara otomatis membersihkan produk terlama ketika Anda menambahkan yang baru.",
        "ss_builder_auto_cleanup_products_warning_content_2": "Catatan: Produk yang ada di \u201CTutup fitur pembersihan\u201D tidak akan dibersihkan secara otomatis.",
        "ss_builder_back": "Kembali",
        "ss_builder_background_block": "Background",
        "ss_builder_background_enable_overlay": "Overlay",
        "ss_builder_background_opacity": "Blur",
        "ss_builder_background_overlay_color": "Warna Overlay",
        "ss_builder_background_popover_manual_content": 'Cari tahu cara menggunakan pengaturan Background, tekan menu "Memulai".',
        "ss_builder_background_popover_manual_title": "Panduan Passio",
        "ss_builder_background_setting_title": "Pengaturan Background",
        "ss_builder_background_tour_content_step_1": "Menampilkan area dengan pengaturan berikut, akan diubah secara otomatis setelah pengaturan disimpan.",
        "ss_builder_background_tour_content_step_2": 'Kamu dapat mengatur background dengan menggunakan "Image" atau "Color". Dengan warna kamu dapat menggunakan warna "Solid" atau "Gradient".',
        "ss_builder_background_tour_title_step_1": "Area tampilan",
        "ss_builder_background_tour_title_step_2": "Background dengan gambar atau set warna.",
        "ss_builder_basic_group_description": "Blok dasar",
        "ss_builder_basic_title": "Dasar",
        "ss_builder_bio_add_social_link_title": "Tambahkan sosial media",
        "ss_builder_bio_avatar_title": "Avatar",
        "ss_builder_bio_layout_title": "Tata Letak",
        "ss_builder_bio_name_sub_placeholder": "Enter the sub title",
        "ss_builder_bio_name_title": "Nama yang ditampilkan",
        "ss_builder_bio_name_title_placeholder": "Enter the display name",
        "ss_builder_bio_social_link_btn_select_icon_label": "PIlih Ikon",
        "ss_builder_bio_social_link_icon_title": "Ikon",
        "ss_builder_bio_social_link_url_title": "Masukkan URL",
        "ss_builder_bio_sub_title": "Judul",
        "ss_builder_bio_text_title": "Bio perkenalan",
        "ss_builder_block_affiliate_description": "Rekomendasikan Produk Affiliate kepada Fans",
        "ss_builder_block_background_blur": "Background blur",
        "ss_builder_block_background_color": "Warna background",
        "ss_builder_block_bio_description": "Gambar profil, teks bio, dan tautan sosial Anda",
        "ss_builder_block_block_card_description": "Daftar gambar dengan informasi tambahan dalam bentuk yang fleksibel dan dapat digeser",
        "ss_builder_block_booking_file_alert_content": "Silahkan buat Booking Profile sebelumnya",
        "ss_builder_block_booking_file_alert_title": "Kamu belum membuat Booking Profile",
        "ss_builder_block_booking_file_button_label_default": "Working Profile",
        "ss_builder_block_booking_file_label": "Booking Profile url",
        "ss_builder_block_booking_file_link_tooltip": "Booking Profile akan memblok link ke url",
        "ss_builder_block_booking_file_switch_tooltip": "Tampilkan link ke Booking Profile di bagian bio",
        "ss_builder_block_booking_profile_button_label": "Tombol konten",
        "ss_builder_block_booking_profile_setting_description": "Deskripsi",
        "ss_builder_block_booking_profile_setting_title": "Judul",
        "ss_builder_block_border_color": "Warna border",
        "ss_builder_block_border_style": "Gaya",
        "ss_builder_block_brand_gift_description": "Simpan pengaturan floating icon untuk meningkatkan interaksi dengan fan",
        "ss_builder_block_brand_gift_footer_description": "Aktifkan fitur ini untuk meningkatkan interaksi dengan fan",
        "ss_builder_block_button_link_description": "Tombol link untuk menautkan ke tempat favorit Anda di internet",
        "ss_builder_block_button_multi_description": "Multi tombol link untuk menautkan ke tempat favorit Anda di internet",
        "ss_builder_block_button_story_description": "Tampilkan tautan di situs Anda dengan gambar dan teks",
        "ss_builder_block_combined_description": "Gabungkan blok yang sudah kamu buat menjadi blok baru",
        "ss_builder_block_combined_description_label": "Gabungkan blok yang sudah kamu buat menjadi blok baru",
        "ss_builder_block_combined_description_placeholder": "Masukkan konten",
        "ss_builder_block_combined_heading_label": "Judul Blok",
        "ss_builder_block_description": "Deskripsi Blok",
        "ss_builder_block_description_label": "Deskripsi",
        "ss_builder_block_description_placeholder": "Masukan konten",
        "ss_builder_block_design_hiding_label": "Blok tersembunyi",
        "ss_builder_block_digital_product_description": "Jual Digital Produk di Passio Page",
        "ss_builder_block_donation_description": "Terima donasi dari penggemar",
        "ss_builder_block_heading_label": "Judul blok",
        "ss_builder_block_heading_placeholder": "Masukan konten",
        "ss_builder_block_image_description": "Tambahkan gambar ke situs Anda",
        "ss_builder_block_image_embed_description": "Embed apa pun ke situs Anda: video, audio, formulir,...",
        "ss_builder_block_image_gallery_description": "Daftar gambar yang ditampilkan dalam multi playouts dan dapat diperbesar",
        "ss_builder_block_image_popup_description": "Foto akan ditampilkan dalam bentuk popup saat penggemar mengunjungi profil Anda",
        "ss_builder_block_image_slider_description": "Daftar gambar yang ditampilkan dalam penggeser gambar",
        "ss_builder_block_is_hiding_label": "Blok tersembunyi",
        "ss_builder_block_link_copy_successfully_label": "Sudah disalin",
        "ss_builder_block_list_combined_description": "Gabungkan blok yang sudah kamu buat menjadi blok baru",
        "ss_builder_block_main_color": "Warna utama",
        "ss_builder_block_outside_space": "Jarak di luar blok",
        "ss_builder_block_rating_answer_1": "Tampilan",
        "ss_builder_block_rating_answer_2": "Waktu Loading",
        "ss_builder_block_rating_answer_3": "Pengalaman selama menggunakan apps",
        "ss_builder_block_rating_answer_4": "Dukungan Layanan",
        "ss_builder_block_rating_answer_5": "Lainnya",
        "ss_builder_block_rating_button_submit_rating": "Berikan rating",
        "ss_builder_block_rating_button_title_open_popup": "Berikan rating",
        "ss_builder_block_rating_content_rating": "Feedback mu",
        "ss_builder_block_rating_content_rating_placeholder": "Silahkan tinggalkan saran untuk Passio Page",
        "ss_builder_block_rating_description": "Rating mu sangat berharga untuk Passio Page agar dapat terus memberikan layanan terbaik kedepannya",
        "ss_builder_block_rating_description_auto_show": "Feedback tentang Passio Page",
        "ss_builder_block_rating_description_star_1": "Merasa tidak puas karena",
        "ss_builder_block_rating_description_star_2": "Merasa tidak puas karena",
        "ss_builder_block_rating_description_star_3": "Passio Page perlu ditingkatkan di bagian",
        "ss_builder_block_rating_description_star_4": "Merasa puas karena",
        "ss_builder_block_rating_description_star_5": "Merasa puas karena",
        "ss_builder_block_rating_star_1": "Kurang",
        "ss_builder_block_rating_star_2": "Biasa saja",
        "ss_builder_block_rating_star_3": "Cukup OK",
        "ss_builder_block_rating_star_4": "Bagus",
        "ss_builder_block_rating_star_5": "Terbaik!",
        "ss_builder_block_rating_title": "Your rating",
        "ss_builder_block_rating_toast_success_rating": "Terimakasih untuk sarannya!",
        "ss_builder_block_second_color": "Warna sekunder",
        "ss_builder_block_setting_title": "Pengaturan Blok",
        "ss_builder_block_shadow_color": "Warna bayangan",
        "ss_builder_block_space": "Spacing between blocks",
        "ss_builder_block_spacer_and_divider_description": "Add spacer or divider between your blocks",
        "ss_builder_block_text_description": "Tambahkan konten apa pun ke situs Anda dengan teks",
        "ss_builder_block_text_see_more_btn_default_title": "Lihat lainnya",
        "ss_builder_block_truth_or_dare_description": "Main game menyenangkan dengan Truth or Dare",
        "ss_builder_block_truth_or_dare_footer_description": "Tampilkan ikon Truth or Dare di pojok layar",
        "ss_builder_block_virtual_gift_description": "Aktifkan fitur ini untuk menerima hadiah dari penggemar",
        "ss_builder_block_virtual_gift_footer_description": "Tampilkan ikon Virtual Gift di pojok layar",
        "ss_builder_blocks_general_settings_label": "Pengaturan Blok",
        "ss_builder_blocks_general_settings_popover_content": 'Aktifkan untuk mengaplikasikan "Settingan Blok" di bagian "Settings" blok dibawah ini',
        "ss_builder_blocks_label": "Blok",
        "ss_builder_blocks_list": "List",
        "ss_builder_blocks_list_empty_content": 'Untuk menambah blok baru pilih menu "Tambah/Add" diatas',
        "ss_builder_blocks_list_empty_title": "Belum ada blok tersedia",
        "ss_builder_body_description": "Anda dapat menggunakan Tab untuk membagikan blok menjadi beberapa bagian",
        "ss_builder_body_introduction_description": '"Body" adalah area utama situs, berisi Blok dan terbagi-bagi oleh Tab. Misalnya: konten, gambar, produk,...',
        "ss_builder_body_introduction_title": "Body Position",
        "ss_builder_body_title": "Body",
        "ss_builder_bold": "Bold",
        "ss_builder_booking_profile_style_1": "Kartu",
        "ss_builder_booking_profile_style_2": "Embed code",
        "ss_builder_border_dash": "Dash",
        "ss_builder_border_dot": "Dot",
        "ss_builder_border_radius_label": "Radius",
        "ss_builder_border_radius_style": "Gaya sudut bulat",
        "ss_builder_border_solid": "Padat",
        "ss_builder_bottom_position_tab_label": "Bottom",
        "ss_builder_box_icon_button_filter": "Filter",
        "ss_builder_box_icon_empty_search": "Hasil tidak ditemukan",
        "ss_builder_box_icon_empty_searching_description": "Coba dengan kata kunci lain",
        "ss_builder_box_icon_filter_category_all": "Semua",
        "ss_builder_box_icon_filter_category_sub_title": "Pilih kategori ikon",
        "ss_builder_box_icon_filter_category_title": "Filter",
        "ss_builder_box_icon_search_bar_placeholder": "Cari ikon berdasarkan nama...",
        "ss_builder_bp_apply_block_settings_instruction": "Turn off to display full screen width. Turn on to display by settings in Block Settings as normal blocks.",
        "ss_builder_bp_open_new_tab_instruction": "Turn on to show the icon to open a new tab in the right corner",
        "ss_builder_bp_open_new_tab_title": "Open new tab",
        "ss_builder_brand_gift_introduction_popup_title": "Tambah Brand Gift icon",
        "ss_builder_browser_opening_label": "Buka dalam bentuk browser",
        "ss_builder_button_background_color": "Warna background",
        "ss_builder_button_border_color": "Warna border",
        "ss_builder_button_border_width": "Lebar border (px)",
        "ss_builder_button_close_introduction_service": "Tutup",
        "ss_builder_button_font_size": "Ukuran font (px)",
        "ss_builder_button_font_weight": "Berat font",
        "ss_builder_button_line_height": "Tinggi garis",
        "ss_builder_button_link_content_title": "Judul",
        "ss_builder_button_link_description": "Deskripsi Link",
        "ss_builder_button_link_icon_btn_selection_label": "Pilih Ikon",
        "ss_builder_button_link_icon_origin_url_label": "Link",
        "ss_builder_button_link_icon_title": "Ikon",
        "ss_builder_button_link_large_size_label": "Besar",
        "ss_builder_button_link_middle_size_label": "Medium",
        "ss_builder_button_link_not_enought_infomation": "Link belum cukup informasi",
        "ss_builder_button_link_placeholder_content_title": "Masukan konten",
        "ss_builder_button_link_size_selection_title": "Pilih ukuran",
        "ss_builder_button_link_small_size_label": "Kecil",
        "ss_builder_button_setting_title": "Pengaturan Tombol",
        "ss_builder_button_text_color": "Warna teks",
        "ss_builder_button_title": "Button title",
        "ss_builder_cancel": "Batal",
        "ss_builder_cancel-delete_block_label": "Batal",
        "ss_builder_cancel-delete_image_label": "Lanjutkan mengubah",
        "ss_builder_cancel-delete_social_link_btn_label": "Batal",
        "ss_builder_cancel-delete_tab_label": "Batal",
        "ss_builder_cancel-restore_theme_label": "Batal",
        "ss_builder_cancel-set_default_tab_label": "Batal",
        "ss_builder_cancel_affiliate_product_group_add_new_panel_label": "Batal",
        "ss_builder_cancel_apply_theme_template_btn_label": "Batalkan",
        "ss_builder_cancel_block_btn_label": "Keluar",
        "ss_builder_cancel_delete_aff_block_btn_label": "Batal",
        "ss_builder_cancel_delete_card_modal_btn_label": "Lanjut mengatur",
        "ss_builder_cancel_delete_link_modal_btn_label": "Lanjutkan mengedit",
        "ss_builder_cancel_delete_product_label": "Batal",
        "ss_builder_cancel_delete_theme_template_modal_btn_label": "Batalkan",
        "ss_builder_cancel_edit_block_content": "Modifikasi Anda di blok tidak akan disimpan. Anda yakin ingin keluar?",
        "ss_builder_cancel_edit_block_title": "Batalkan pengeditan?",
        "ss_builder_cancel_hide_product_label": "Batal",
        "ss_builder_cancel_image_slider_add_new_btn_label": "Batal",
        "ss_builder_cancel_overwrite_theme_template_btn_label": "Bantalkan",
        "ss_builder_cancel_preview_theme_template_btn_label": "Tutup",
        "ss_builder_cancel_product_addition_modal_confirm_btn_label": "Lanjutkan menambahkan produk",
        "ss_builder_cancel_product_addition_modal_description": "Produk yang ditambahkan pada layar ini tidak akan disimpan.",
        "ss_builder_cancel_product_addition_modal_title": "Batal tambahkan produk?",
        "ss_builder_cancel_replace_theme_template_btn_label": "Batal",
        "ss_builder_cancel_select_multi_items": "Batal",
        "ss_builder_cancel_theme_selection_panel_label": "Batalkan",
        "ss_builder_cancel_upload_image": "Batalkan",
        "ss_builder_card_add_new_description_label": "Deskripsi",
        "ss_builder_card_add_new_label": "Label",
        "ss_builder_card_add_new_subtitle_label": "Sub judul",
        "ss_builder_card_add_new_title_label": "Judul",
        "ss_builder_card_add_new_url_label": "Url",
        "ss_builder_card_additional_btn_label": "Tambahkan kartu",
        "ss_builder_card_btn_content_label": "Tombol konten",
        "ss_builder_card_layout_alert_1": "Layout ini tidak akan menampilkan deskripsi, label, dan tombol",
        "ss_builder_card_layout_alert_2": "Layout ini tidak menampilkan deskripsi dan tombol",
        "ss_builder_card_layout_label": "Layout",
        "ss_builder_card_layout_label_1": "Teks di bawah gambar - Ratakan paragraf di kiri",
        "ss_builder_card_layout_label_2": "Teks di bawah gambar - Ratakan paragraf di tengah",
        "ss_builder_card_layout_label_3": "Teks di atas gambar - Ratakan paragraf di tengah",
        "ss_builder_card_layout_label_4": "Teks di atas gambar - Ratakan paragraf di kiri",
        "ss_builder_card_layout_label_5": "Teks di kanan",
        "ss_builder_card_layout_label_6": "Teks di kiri",
        "ss_builder_card_layout_label_7": "Teks di atas gambar - Ratakan paragraf di sebelah kiri 2",
        "ss_builder_card_layout_label_8": "Teks di atas gambar - Ratakan paragraf di tengah 2",
        "ss_builder_card_url_placeholder": "http://domain.com",
        "ss_builder_category_14_up": "14+",
        "ss_builder_category_all": "Semua",
        "ss_builder_category_art": "Seni",
        "ss_builder_category_creative": "Creative",
        "ss_builder_category_doctor": "Dokter",
        "ss_builder_category_education": "Education",
        "ss_builder_category_entertainment": "Entertainment",
        "ss_builder_category_fashion": "Fashion",
        "ss_builder_category_fitness": "Fitness",
        "ss_builder_category_food_fmcg": "Food & FMCG",
        "ss_builder_category_game": "Game",
        "ss_builder_category_health_and_beauty": "Health & Beauty",
        "ss_builder_category_ict": "ICT",
        "ss_builder_category_life_style": "Lifestyle",
        "ss_builder_category_lifestyle": "Lifestyle",
        "ss_builder_category_mom_and_kid": "Mom & Kid",
        "ss_builder_category_others": "Lainnya",
        "ss_builder_category_pet": "Binatang peliharaan",
        "ss_builder_category_spirit": "Spirit",
        "ss_builder_change_image_button_label": "Ganti gambar",
        "ss_builder_change_name_product_group_successfully_label": "Sukses mengubah nama grup produk",
        "ss_builder_change_theme_label": "Ubah tema",
        "ss_builder_choose_a_prototying_method": "Pilih opsi untuk membuat template baru",
        "ss_builder_choose_at_least_category": "Pilih setidaknya 1 kategori dan kami akan menyarankan tema berdasarkan pilihan Anda\uD83D\uDC47",
        "ss_builder_choose_image_below": 'Klik tombol "Tambah baru" di bawah untuk menambahkan yang baru',
        "ss_builder_choose_one_theme_preview_you_can_customize_it_later": "Pilih satu tema, Anda dapat menyesuaikannya setelah menerapkan\u2728",
        "ss_builder_choose_the_look_that_right_for_you": "Silakan pilih tema",
        "ss_builder_choose_this_template": "Apply",
        "ss_builder_cleanup_lock_product_successfully_label": "Tutup fitur pembersihan suskes",
        "ss_builder_cleanup_unlock_product_successfully_label": "Buka fitur pembersihan suskes",
        "ss_builder_close_panel": "Batal",
        "ss_builder_close_panel_affiliate_product-selection-label": "Batal",
        "ss_builder_close_panel_edit_text_block": "Tutup",
        "ss_builder_collapse": "Lihat lebih sedikit",
        "ss_builder_color_1": "Warna 1",
        "ss_builder_color_2": "Warna 2",
        "ss_builder_color_picker_panel_title": "Pilih warna",
        "ss_builder_confirm-cancel_image_slider_add_new_content": "Tindakan Anda belum disimpan.\nApakah Anda ingin menyimpan sebelum keluar?",
        "ss_builder_confirm-cancel_image_slider_add_new_title": "Batalkan pengeditan?",
        "ss_builder_confirm-delete_block_label": "Jika Anda menghapus blok, perubahan dan data yang ditambahkan akan dihapus. Yakin ingin menghapus?",
        "ss_builder_confirm-delete_block_title": "Apakah Anda ingin menghapus blok ini?",
        "ss_builder_confirm-delete_image_label": "Anda yakin ingin menghapus gambar ini?",
        "ss_builder_confirm-delete_image_title": "Hapus gambar",
        "ss_builder_confirm-delete_social_link_content": "Apakah kamu yakin menghapus item ini?",
        "ss_builder_confirm-delete_social_link_title": "Apakah kamu yakin menghapus sosial media ini?",
        "ss_builder_confirm_affiliate_product_group_add_new_panel_label": "Simpan",
        "ss_builder_confirm_apply_template_description": "Mengaktifkan template akan mengubah seluruh blok di list mu dengan yang ada di template.",
        "ss_builder_confirm_apply_template_label": "Ubah",
        "ss_builder_confirm_apply_theme_template_btn_label": "Konfirmasi",
        "ss_builder_confirm_apply_theme_template_content": "Menerapkan tema yang Anda pilih akan mengubah tampilan seluruh situs web",
        "ss_builder_confirm_apply_theme_template_title": "Apakah Anda ingin menerapkan tema ini?",
        "ss_builder_confirm_cancel_image_slider_add_new_btn_label": "Keluar",
        "ss_builder_confirm_cleanup_lock_product_btn_label": "Konfirmasi mengunci",
        "ss_builder_confirm_cleanup_lock_product_selection_modal_content": "Are you sure you want to lock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_cleanup_unlock_product_btn_label": "Konfirmasi membuka",
        "ss_builder_confirm_cleanup_unlock_product_selection_modal_content": "Are you sure you want to unlock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_delete_aff_block_content": "Tindakan ini tidak bisa dibatalkan. Harap konfirmasi, Anda memahami bahwa menghapus blok ini akan menghapus semua produk di dalamnya.",
        "ss_builder_confirm_delete_aff_block_input_placeholder": "OK",
        "ss_builder_confirm_delete_aff_block_label_enter_ok": 'Tekan "OK" untuk konfirmasi',
        "ss_builder_confirm_delete_aff_block_understood": "Saya mengerti",
        "ss_builder_confirm_delete_aff_block_warining": "Peringatan",
        "ss_builder_confirm_delete_block_btn_label": "Konfirmasi penghapusan",
        "ss_builder_confirm_delete_card_modal_btn_label": "Hapus kartu",
        "ss_builder_confirm_delete_card_modal_description": "Apakah Anda yakin hapus kartu ini?",
        "ss_builder_confirm_delete_card_modal_label": "Hapus kartu",
        "ss_builder_confirm_delete_combined_label": "Yakin ingin menghapus tipe {{type}} blok ini?",
        "ss_builder_confirm_delete_image_popup_image_label": "Konfirmasi hapus",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_content": "Apa anda yakin menghapus {{quantity}} link ini?",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_title": "Hapus link",
        "ss_builder_confirm_delete_item_checkbox_card_modal_content": "Apa anda yakin menghapus {{quantity}} kartu/cards ini?",
        "ss_builder_confirm_delete_item_checkbox_card_modal_title": "Hapus kartu/cards",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_content": "Hapus {{quantity}} Blok ini?",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_title": "Hapus Blok",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_content": "Apa anda yakin menghapus {{quantity}} gambar ini?",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_title": "Hapus galeri gambar",
        "ss_builder_confirm_delete_item_checkbox_story_modal_content": "Apa anda yakin menghapus {{quantity}} spotlight ini?",
        "ss_builder_confirm_delete_item_checkbox_story_modal_title": "Hapus Spotlight",
        "ss_builder_confirm_delete_link_description": "Anda yakin ingin menghapus link ini?",
        "ss_builder_confirm_delete_product_group_modal_description": 'Grup "{{group_name}}" dan semua data produk di dalamnya akan dihapus secara permanen. Apakah Anda yakin ingin menghapus?',
        "ss_builder_confirm_delete_product_group_modal_title": "Apakah Anda ingin menghapus grup?",
        "ss_builder_confirm_delete_product_label": "Hapus",
        "ss_builder_confirm_delete_product_modal_content": "Apakah kamu yakin ingin menghapus produk ini?",
        "ss_builder_confirm_delete_product_modal_title": "Hapus produk",
        "ss_builder_confirm_delete_product_selection_modal_content": "Apakah Anda yakin ingin hapus {{product_quantity}} produk ini ?",
        "ss_builder_confirm_delete_tab_label": "Hapus",
        "ss_builder_confirm_delete_template_modal_content": "Hapus template ini dari list template, blok yang sebelumnya digunakan di template ini tidak akan terdampak",
        "ss_builder_confirm_delete_template_modal_title": "Kamu ingin menghapus template ini?",
        "ss_builder_confirm_delete_theme_template_modal_btn_label": "Konfirmasi penghapusan",
        "ss_builder_confirm_delete_theme_template_modal_content": "Hapus template tema secara permanen dari Theme Store, tema yang dibuat dari tema ini tidak akan terpengaruh",
        "ss_builder_confirm_delete_theme_template_modal_title": "Apakah Anda ingin menghapus template tema ini?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_content": "Sembunyikan {{quantity}} link ini?",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_title": "Sembunyikan link",
        "ss_builder_confirm_disable_item_checkbox_card_modal_content": "Sembuntikan {{quantity}} kartu/cards ini?",
        "ss_builder_confirm_disable_item_checkbox_card_modal_title": "Sembunyikan kartu/cards",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_content": "Sembunyikan {{quantity}} Blok ini?",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_title": "Sembunyikan Blok",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_content": "Sembunyikan {{quantity}} galeri gambar ini?",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_title": "Sembunyikan galeri gambar",
        "ss_builder_confirm_disable_item_checkbox_story_modal_content": "Sembunyikan {{quantity}} spotlight ini?",
        "ss_builder_confirm_disable_item_checkbox_story_modal_title": "Sembunyikan spotlight",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_content": "Tampilkan {{quantity}} link ini?",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_title": "Tampilkan link",
        "ss_builder_confirm_enable_item_checkbox_card_modal_content": "Tampilkan {{quantity}} kartu/cards?",
        "ss_builder_confirm_enable_item_checkbox_card_modal_title": "Tampilkan kartu/cards",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_content": "Tampilkan {{quantity}} Blok ini?",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_title": "Tampilkan Blok",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_content": "Tampilkan {{quantity}} galeri gambar ini?",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_title": "Tampilkan galeri gambar",
        "ss_builder_confirm_enable_item_checkbox_story_modal_content": "Tampilkan {{quantity}} spotlight ini?",
        "ss_builder_confirm_enable_item_checkbox_story_modal_title": "Tampilkan spotlight",
        "ss_builder_confirm_enable_product_selection_modal_content": "Apakah Anda yakin ingin menampilkan {{product_quantity}} produk ini ?",
        "ss_builder_confirm_hide_product_btn_label": "Konfirmasi untuk menyembunyikan",
        "ss_builder_confirm_hide_product_group_modal_description": 'Grup produk "{{group_name}}" dan semua data produk di dalamnya akan disembunyikan. Apakah Anda yakin ingin menyembunyikan grup?',
        "ss_builder_confirm_hide_product_group_modal_title": "Apakah Anda ingin menyembunyikan grup?",
        "ss_builder_confirm_hide_product_label": "Konfirmasi untuk menyembunyikan grup",
        "ss_builder_confirm_hide_product_selection_modal_content": "Apakah Anda yakin ingin menyembunyikan {{product_quantity}} produk ini ?",
        "ss_builder_confirm_overwrite": "Konfirmasi menimpa template",
        "ss_builder_confirm_overwrite_theme_template_btn_label": "Konfirmasi penimpaan",
        "ss_builder_confirm_overwrite_theme_template_modal_content": "Timpa akan menggantikan semua data dan pengaturan template tema dengan data dan pengaturan template tema terbaru",
        "ss_builder_confirm_overwrite_theme_template_modal_title": "Apakah Anda ingin menimpa?",
        "ss_builder_confirm_panel": "Konfirmasi",
        "ss_builder_confirm_panel_affiliate_product-selection-label": "Konfirmasi",
        "ss_builder_confirm_panel_edit_text_block": "Konfirmasi",
        "ss_builder_confirm_replace_theme_template_btn_label": "Terapkan sampel data",
        "ss_builder_confirm_replace_theme_template_content": "Tindakan ini tidak bisa dibatalkan.\nHarap konfirmasi bahwa Anda memahami jika menerapkan konten sampel akan menggantikan semua data yang ada di situs.",
        "ss_builder_confirm_replace_theme_template_input_placeholder": "OK",
        "ss_builder_confirm_replace_theme_template_label_enter_ok": 'Tekan "OK" untuk mengonfirmasi',
        "ss_builder_confirm_replace_theme_template_understood": "Saya mengerti",
        "ss_builder_confirm_replace_theme_template_warining": "Peringatan",
        "ss_builder_confirm_restore_theme_label": "Pulihkan pengeditan",
        "ss_builder_confirm_set_default_tab_label": "Pengaturan standar",
        "ss_builder_confirm_show_product_btn_label": "Konfirmasi untuk menampilkan",
        "ss_builder_confirm_theme_template_preview_mode_btn_label": "Terapkan",
        "ss_builder_confirm_to_edit_label": "Lanjut ubah",
        "ss_builder_content_1_introduction_service": 'Brand Gift adalah bentuk mempromosikan suatu produk promosi, hot deal dari Brand kepada fans/followers untuk meningkatkan "jumlah orders" dan mencapai "komisi besar" untuk Kreator. Setiap voucher yang berhasil dari link Brand Gift, Anda akan menerima kebijakan komisi yang sangat menarik.',
        "ss_builder_content_2_introduction_service": "Jangan ketinggalan! Aktifkan Brand Gift untuk menerima bonus",
        "ss_builder_content_creators_joined_the_passio_system": "100K+ content creators sudah bergabung dengan Passio eco-system",
        "ss_builder_content_editor_title": "Isi",
        "ss_builder_content_list_1_introduction_service": "Komisi dari marketplace",
        "ss_builder_content_list_2_introduction_service": "Brand Bonus (hingga 30%)",
        "ss_builder_content_list_3_introduction_service": "500+ Brand besar di berbagai bidang dengan banyak program bonus",
        "ss_builder_continue_add_brand_gift": "Coba Sekarang",
        "ss_builder_continue_edit_block_label": "Lanjutkan mengubah",
        "ss_builder_continue_edit_image_popup_image_label": "Batal",
        "ss_builder_continue_to_add_block": "Lanjut",
        "ss_builder_convert_and_go_to_new_version": "Sinkronkan data dan buka Passio Page",
        "ss_builder_cover_image": "Gambar Cover",
        "ss_builder_create_bio_page_free_fast": "Buat Bio Page dengan gratis & cepat",
        "ss_builder_create_link_with_your_name_and_imprint": "Buat halaman bio dengan nama dan brandmu. Theme Store dengan banyak kategori tema, dan dapat dengan mudah diatur sesuai dengan keinginan.",
        "ss_builder_create_new_theme_template_label": "Buat template tema baru",
        "ss_builder_create_template": "Buat Template",
        "ss_builder_cusom": "Custom",
        "ss_builder_custom": "Custom",
        "ss_builder_dashed_type_label": "Dashed",
        "ss_builder_data_auto_convert": "Data lama Anda akan disinkronkan dari Landing Page lama ke Passio Page baru secara otomatis",
        "ss_builder_data_can_be_convert": "Anda dapat menyinkronkan data dari Landing Page lama ke Passio Page baru",
        "ss_builder_data_will_be_override": "Peringatan: data di Passio Page akan ditimpa jika Anda menyinkronkan data",
        "ss_builder_deep_blue_sky": "Langit biru",
        "ss_builder_default_meta_description": "Passio Page - Home of {{creator_name}}",
        "ss_builder_defaults_label": "Default",
        "ss_builder_delete_block_label": "Hapus blok",
        "ss_builder_delete_block_successfully_label": "Berhasil hapus blok",
        "ss_builder_delete_card_label": "Hapus kartu",
        "ss_builder_delete_card_successfully_label": "Hapus kartu berhasil",
        "ss_builder_delete_image_label": "Hapus gambar",
        "ss_builder_delete_image_successfully_label": "Berhasil hapus gambar",
        "ss_builder_delete_item_checkbox_button_multi_link_successfully_label": "Sukses menghapus link",
        "ss_builder_delete_item_checkbox_card_successfully_label": "Sukses menghapus kartu/cards",
        "ss_builder_delete_item_checkbox_combined_successfully_label": "Sukses menghapus blok",
        "ss_builder_delete_item_checkbox_image_gallery_successfully_label": "Sukses menghapus galeri gambar",
        "ss_builder_delete_item_checkbox_story_successfully_label": "Sukses menghapus spotlight",
        "ss_builder_delete_link_label": "Hapus link",
        "ss_builder_delete_link_successfully_label": "Hapus link berhasil",
        "ss_builder_delete_product_group_error_btn_confirm_label": "Tutup",
        "ss_builder_delete_product_group_error_content": 'Grup "{{group_name}}" tidak dapat dihapus, diperlukan minimal 1 grup.',
        "ss_builder_delete_product_group_error_title": "Terjadi kesalahan saat menghapus grup",
        "ss_builder_delete_product_group_label": "Hapus grup",
        "ss_builder_delete_product_group_successfully_label": "Sukses menghapus grup produk",
        "ss_builder_delete_product_label": "Hapus produk",
        "ss_builder_delete_product_successfully_label": "Berhasil hapus produk",
        "ss_builder_delete_social_link_btn_label": "Hapus",
        "ss_builder_delete_social_link_label": "Hapus",
        "ss_builder_delete_social_link_successfully_label": "Berhasil menghapus",
        "ss_builder_delete_tab_content": 'Tab "{{tab_name}}" dan semua data blok di dalamnya akan dihapus secara permanen. Anda yakin ingin menghapus?',
        "ss_builder_delete_tab_label": "Hapus",
        "ss_builder_delete_tab_successfully_label": "Berhasil hapus tab",
        "ss_builder_delete_tab_title": "Apakah Anda ingin menghapus tab?",
        "ss_builder_delete_template_successfully_label": "Sukses menghapus template",
        "ss_builder_delete_theme_template_label": "Hapus",
        "ss_builder_delete_theme_template_successfully_label": "Hapus template tema berhasil",
        "ss_builder_description": "Deskripsi",
        "ss_builder_description_page_builder": "Membangun Situs Bio dalam 1 klik dan mulailah menghasilkan uang",
        "ss_builder_description_replace_template_content": "Terapkan tema data sampel akan menggunakan konten dari tema template untuk menggantikan semua konten situs Anda",
        "ss_builder_design_group_floating_title": "Floating icons",
        "ss_builder_design_group_image_popup_title": "Popup",
        "ss_builder_design_label": "Desain",
        "ss_builder_dialog_error_confirm_text": "Refresh",
        "ss_builder_dialog_error_content": "Ada perubahan dari perangkat lain. Anda perlu refresh halaman.",
        "ss_builder_dialog_error_title": "Ada pembaruan di situs Anda",
        "ss_builder_digital_product_free_label": "Gratis",
        "ss_builder_digital_product_list_title": "List produk",
        "ss_builder_direction_of_background_image_label": "Posisi Background",
        "ss_builder_disable_block_successfully_label": "Berhasil sembunyikan blok",
        "ss_builder_disable_image_successfully_label": "Sukses sembunyikan foto",
        "ss_builder_disable_item_checkbox_button_multi_link_successfully_label": "Sukses menyembunyikan link",
        "ss_builder_disable_item_checkbox_card_successfully_label": "Sukses menyembunyikan kartu/cards",
        "ss_builder_disable_item_checkbox_combined_successfully_label": "Sukses menyembunyikan blok",
        "ss_builder_disable_item_checkbox_image_gallery_successfully_label": "Sukses menyembunyikan galeri gambar",
        "ss_builder_disable_item_checkbox_story_successfully_label": "Sukses menyembunyikan spotlight",
        "ss_builder_disable_product_group_successfully_label": "Sukses menyembunyikan grup produk",
        "ss_builder_disable_product_successfully_label": "Berhasil sembunyikan produk",
        "ss_builder_disable_social_link_successfully_label": "Sembunyikan sosial media berhasil",
        "ss_builder_disable_tab_successfully_label": "Tab berhasil disembunyikan",
        "ss_builder_disable_theme_successfully_label": "Sukses menyembunyikan template",
        "ss_builder_discover_now": "Temukan sekarang",
        "ss_builder_distance_blocks": "Jarak antar Blok",
        "ss_builder_divider_color_label": "Divider color",
        "ss_builder_divider_image_label": "Divider image",
        "ss_builder_divider_label": "Divider",
        "ss_builder_divider_thickness_label": "Thickness (px)",
        "ss_builder_do_you_want_replace_sample_content": "Apakah Anda ingin menerapkan tema data sampel ?",
        "ss_builder_domain_site_setting_alert_infomation": "Jika Anda mengubah nama domain, Anda harus menunggu 30 hari untuk dapat mengubah kembali.",
        "ss_builder_domain_site_setting_rule": "Mulai dengan huruf, hanya berisi angka dan huruf",
        "ss_builder_done_panel": "Selesai",
        "ss_builder_dont_add_block_from_template_description": "Tidak dapat menambah {{number_block}} blok dari template karena batasan maksimal 10 block dari list. Silahkan hapus blok yang sudah ada untuk menambahkan blok template.",
        "ss_builder_dont_add_block_from_template_title": "Tidak dapat menambahkan blok",
        "ss_builder_dont_add_product_exist_at_add_new_content": "Produk sudah ada di list",
        "ss_builder_dont_add_product_exist_at_list_content": 'Produk yang ingin Anda tambahkan sudah ada di grup produk "{{group_name}}".',
        "ss_builder_dont_add_same_affiliate_product_confirm_label": "Konfirmasi",
        "ss_builder_dont_add_same_affiliate_product_modal_label": "Tidak dapat menambahkan produk baru",
        "ss_builder_dont_apply_template_content_modal_description": "Template tidak bisa digunakan karena template tidak tersedia.",
        "ss_builder_dont_apply_theme_content_modal_btn_confirm_label": "Tutup",
        "ss_builder_dont_apply_theme_content_modal_description": "Aplikasi data sampel tidak dapat dilakukan karena tema template tidak tersedia di Theme Store.",
        "ss_builder_dont_apply_theme_content_modal_label": "Tidak bisa menerapkan",
        "ss_builder_dot_strokes_type_label": "Dotted",
        "ss_builder_dp_title_intro": "Digital products",
        "ss_builder_drop_here_label": "Tambah blok disini",
        "ss_builder_duplicated_product_url_label": "Tautan duplikat",
        "ss_builder_duplicated_theme_template_name_warning": "Nama antarmuka itu sudah ada. Silakan masukkan nama lain!",
        "ss_builder_earn_additional_commissions_label": "Earn additional commissions when using Passio's affiliate links",
        "ss_builder_edit_affiliate_product_group_title": "Nama grup",
        "ss_builder_edit_affiliate_product_title": "Edit produk",
        "ss_builder_edit_block_label": "Ubah",
        "ss_builder_edit_block_successfully_label": "Berhasil edit blok",
        "ss_builder_edit_image_of_image_popup_title": "Edit gambar pop-up",
        "ss_builder_edit_name_affiliate_product_group_title": "Ubah nama grup produk",
        "ss_builder_edit_name_block_successfully_label": "Berhasil edit nama blok",
        "ss_builder_edit_product_group_label": "Ganti Nama",
        "ss_builder_edit_tab_label": "Ganti nama",
        "ss_builder_edit_tab_successfully_label": "Berhasil edit tab",
        "ss_builder_edit_template_btn_label": "Simpan",
        "ss_builder_edit_template_title": "Atur template",
        "ss_builder_edit_text_block_label": "Nama blok",
        "ss_builder_edit_theme_btn_label": "Simpan",
        "ss_builder_edit_theme_template_label": "Edit Info",
        "ss_builder_edit_theme_template_successfully_label": "Update template tema berhasil",
        "ss_builder_edit_theme_template_title": "Edit info template tema",
        "ss_builder_editor_btn-add-more": "Tambah",
        "ss_builder_editor_btn-cancel": "Batal",
        "ss_builder_editor_btn-save": "Simpan",
        "ss_builder_email_placeholder": "Masukan email",
        "ss_builder_embed_code_label": "Embed code",
        "ss_builder_embed_code_placeholder": "Tolong masukkan kode embed",
        "ss_builder_empty_block": "Tidak ada Blok",
        "ss_builder_empty_search": "Hasil tidak ditemukan",
        "ss_builder_empty_social_link_list_content": 'Untuk menambahkan jejaring sosial, tekan tombol "Tambah" di atas',
        "ss_builder_empty_social_link_list_title": "Belum ada jejaring sosial yang ditambahkan",
        "ss_builder_empty_template_label": "Tidak ada template blok",
        "ss_builder_enable_block_successfully_label": "Berhasil tampilkan blok",
        "ss_builder_enable_border": "Aktifkan",
        "ss_builder_enable_button_border": "Aktifkan border",
        "ss_builder_enable_image_successfully_label": "Sukses tampilkan gambar",
        "ss_builder_enable_item_checkbox_button_multi_link_successfully_label": "Sukses menampilkan link",
        "ss_builder_enable_item_checkbox_card_successfully_label": "Sukses menampilkan kartu/cards",
        "ss_builder_enable_item_checkbox_combined_successfully_label": "Sukses menampilkan blok",
        "ss_builder_enable_item_checkbox_image_gallery_successfully_label": "Sukses menampilkan galeri gambar",
        "ss_builder_enable_item_checkbox_story_successfully_label": "Sukses menampilkan spotlight",
        "ss_builder_enable_product_group_successfully_label": "Sukses menampilkan grup produk",
        "ss_builder_enable_product_successfully_label": "Berhasil tampilkan produk",
        "ss_builder_enable_shadow": "Aktifkan",
        "ss_builder_enable_social_link_successfully_label": "Tampilkan sosial media berhasil",
        "ss_builder_enable_tab_successfully_label": "Tab berhasil ditampilkan",
        "ss_builder_enable_theme_successfully_label": "Sukses menampilkan template",
        "ss_builder_enable_tracking_link_product_label": "Aktifkan tracking link",
        "ss_builder_enable_tracking_link_product_successfully_label": "Sukses mengaktifkan tracking link",
        "ss_builder_enter_domain_site_setting_label": "Jalur domain pribadi",
        "ss_builder_enter_font_name": "Masukkan nama font",
        "ss_builder_enter_url_label": "Masukkan link",
        "ss_builder_enter_your_url": "Masukkan URL",
        "ss_builder_error_block_label": "Blok Error",
        "ss_builder_error_invalid_email_message": "Email tidak valid",
        "ss_builder_error_invalid_phone_message": "Nomor telepon tidak valid",
        "ss_builder_error_network_confirm_btn_label": "Tutup",
        "ss_builder_error_network_content": "Sistem kelebihan beban. Silakan coba lagi.",
        "ss_builder_error_network_title": "System overload",
        "ss_builder_error_page_title": "Passio Page Builder - {{country}} - Halaman Error",
        "ss_builder_exceeding_label": "Mencapai maksimum blok",
        "ss_builder_existed_product_group_label": "Grup sudah ada",
        "ss_builder_expand": "Lihat lebih banyak",
        "ss_builder_expand_introduction_description": '"Extended Position" berisi blok yang tidak memiliki posisi yang tetap. Misal: Popup, Floating Icons',
        "ss_builder_expand_introduction_title": "Extended Position",
        "ss_builder_filter_select_combined_count": "blok dipilih",
        "ss_builder_filter_select_multi_items": "{{num_items}} terakhir",
        "ss_builder_filter_select_multi_items_card_count": "kartu/card dipilih",
        "ss_builder_filter_select_multi_items_gallery_count": "gambar dipilih",
        "ss_builder_filter_select_multi_items_multi_links_count": "link dipilih",
        "ss_builder_filter_select_multi_items_spotlight_count": "spotlight dipilih",
        "ss_builder_first_guide_add_block_btn_title": "Tambah Blok",
        "ss_builder_first_guide_add_block_description": 'Tap atau Drag & Drop di menu "Tambah Blok" arahkan ke posisi yang ingin Anda tambahkan blok di passio page mu. Ada banyak tipe blok yang bisa kamu tambahkan agar passio page mu lebih keren dan menarik. Ayo coba!',
        "ss_builder_first_guide_add_block_title": "Tambah menu Blok",
        "ss_builder_first_guide_preview_btn_title": "Preview site",
        "ss_builder_first_guide_preview_description": "Pratinjau situs untuk melihat perubahan situs saat ini. Simpan tampilan setelah kamu puas dengan pratinjau saat ini.",
        "ss_builder_first_guide_preview_title": "Menu Pratinjau Situs",
        "ss_builder_first_guide_publish_btn_title": "Publikasikan",
        "ss_builder_first_guide_publish_description": 'Pengeditan desain selalu dalam mode "Draft". Perubahan akan terlihat oleh Fans Anda setelah Anda memutuskan untuk mem"Publikasikan".',
        "ss_builder_first_guide_publish_title": "Tampilkan Ke publik",
        "ss_builder_floating_full": "Hanya bisa menambah 2 blok di grup Floating Icons",
        "ss_builder_floating_introduction_description": "Blok di Floating Icons ini akan selalu muncul di pojok kanan layar.",
        "ss_builder_floating_introduction_title": "Floating icons",
        "ss_builder_font_name_not_exist": "Font tidak tersedia",
        "ss_builder_font_option_panel_title": "Jenis huruf",
        "ss_builder_footer_description": "Blok-blok tersebut akan muncul di semua Tab",
        "ss_builder_footer_introduction_description": "\u201CFooter\u201D berisi Blok, yang selalu muncul di bagian bawah halaman. Misalnya: tautan cepat, info halaman...",
        "ss_builder_footer_introduction_title": "Footer Position",
        "ss_builder_footer_title": "Footer",
        "ss_builder_frame_aff": "Frame gambar produk",
        "ss_builder_general_setting_title": "Pengaturan umum",
        "ss_builder_generate_income_from_your_own_fan_community": "Monetize passion mu dan dapatkan support dari fansmu!",
        "ss_builder_gift_warning": "Hanya bisa menambah satu blok",
        "ss_builder_go_back_to_site": "Kembali ke halaman utama",
        "ss_builder_google_font": "Google Fonts",
        "ss_builder_gradient": "Gradiasi",
        "ss_builder_group_is_full_of_product_modal_description": "Grup produk yang Anda pilih sudah penuh. Silakan pilih grup lain",
        "ss_builder_group_is_full_of_product_modal_title": "Tidak bisa menambahkan",
        "ss_builder_group_is_hiding_label": "Sembunyikan grup produk",
        "ss_builder_hard_shadow": "Hard shadow",
        "ss_builder_header_description": "Blok-blok tersebut akan muncul di semua Tab",
        "ss_builder_header_introduction_description": "\u201CHeader\u201D berisi Blok, yang selalu muncul di bagian atas halaman. Misalnya: gambar Avatar, pengantar...",
        "ss_builder_header_introduction_title": "Header Position",
        "ss_builder_header_title": "Header",
        "ss_builder_heading_and_subtitle_site_setting_label": "Judul dan subjudul",
        "ss_builder_heading_site_setting_description": "Ditampilkan oleh mesin pencari di pratinjau halaman Anda. Ini penting bagi SEO dan berbagi melalui jejaring sosial.",
        "ss_builder_heading_site_setting_label": "Judul halaman",
        "ss_builder_hide_block_label": "Sembunyikan blok",
        "ss_builder_hide_card_label": "Sembunyikan kartu",
        "ss_builder_hide_card_successfully_label": "Sembunyikan kartu berhasil",
        "ss_builder_hide_image_label": "Sembunyikan gambar",
        "ss_builder_hide_link_label": "Sembunyikan link",
        "ss_builder_hide_link_successfully_label": "Sembunyikan link berhasil",
        "ss_builder_hide_product_group_error_btn_confirm_label": "Tutup",
        "ss_builder_hide_product_group_error_content": 'Grup "{{group_name}}" tidak dapat disembunyikan, harus menampilkan setidaknya 1 grup.',
        "ss_builder_hide_product_group_error_title": "Terjadi kesalahan saat menyembunyikan grup",
        "ss_builder_hide_product_group_label": "Sembunyikan grup",
        "ss_builder_hide_product_label": "Sembunyikan produk",
        "ss_builder_hide_social_link_label": "Sembunyikan",
        "ss_builder_hide_tab_label": "Sembunyi Tab",
        "ss_builder_hide_template_successfully_label": "Suklses menyembunyikan template",
        "ss_builder_hide_theme_template_label": "Hide template",
        "ss_builder_hightlight_block_label": "Pilihan terbaik",
        "ss_builder_icon_tab_title": "Ikon",
        "ss_builder_if_delete": "Jika Anda menghapus blok Affiliate ini,",
        "ss_builder_image": "Gambar",
        "ss_builder_image_description_place_holder": "Masukkan konten",
        "ss_builder_image_gallery": "Galeri gambar",
        "ss_builder_image_list_empty_content": "Untuk menambahkan gambar baru, silakan klik tombol di bawah ini",
        "ss_builder_image_list_empty_title": "Daftar gambar kosong",
        "ss_builder_image_orientation": "Gambar orientasi",
        "ss_builder_image_orientation_label": "Gambar orientasi",
        "ss_builder_image_popup_introduction_description": "Blok di posisi ini akan muncul sebagai popup ketika fans melihat passio page milikmu. Popup dapat digunakan untuk menampilkan info penting, call to action, atau penayangan iklan...",
        "ss_builder_image_popup_introduction_title": "Popup",
        "ss_builder_image_popup_warning": "Anda hanya dapat menambahkan satu blok jenis ini per halaman",
        "ss_builder_image_ratio_title": "Rasio gambar",
        "ss_builder_image_selection_label": "Pilih gambar",
        "ss_builder_image_slider_arrow_switch_title": "Panah",
        "ss_builder_image_slider_auto_play_switch_title": "Putar otomatis",
        "ss_builder_image_slider_dot_switch_title": "Dot slider",
        "ss_builder_image_slider_list_title": "Daftar gambar",
        "ss_builder_image_slider_ratio_selected_title": "Rasio gambar",
        "ss_builder_image_title_place_holder": "Masukkan konten",
        "ss_builder_import_multi_product_url_popover_content": "Anda dapat memasukkan satu atau beberapa url. Satu url per baris.",
        "ss_builder_import_site_url_label": "Unggah file produk dengan URL",
        "ss_builder_import_site_url_modal_button_label": "Unggah produk",
        "ss_builder_import_site_url_modal_description": "Masukkan link yang ingin diunggah, contoh: koc.asia, mycollection.shop, linktr.ee, msha.ke",
        "ss_builder_import_site_url_modal_title": "Link halaman produk",
        "ss_builder_in_block_delete_forever_are_you_sure": "akan dihapus secara permanen. Anda yakin ingin menghapus?",
        "ss_builder_information_handler_alert": "Sedang diproses. Harap tunggu sebentar.",
        "ss_builder_inner_space": "Jarak dalam",
        "ss_builder_intro_brand_gift_floating_continue": "Tambah sekarang",
        "ss_builder_intro_brand_gift_floating_description": "Tambah Brand Gift Icon sekarang untuk membantu fansmu mendapat diskon dari Brands",
        "ss_builder_intro_brand_gift_floating_reject": "Batal",
        "ss_builder_intro_brand_gift_floating_title": "Lipat gandakan pendapatanmu dengan Brand Gift Floating Icon",
        "ss_builder_intro_brand_rating_floating_description": "id_Th\xeam t\xednh n\u0103ng ngay \u0111\u1EC3 gi\xfap Fan s\u0103n deal th\xe0nh c\xf4ng v\xe0 t\u0103ng thu nh\u1EADp",
        "ss_builder_intro_brand_rating_floating_title": "id_Brand Ratings",
        "ss_builder_introduce_double_tap_button": "Lanjutkan perubahan",
        "ss_builder_introduce_double_tap_content": 'Selain dengan menggunakan menu "Edit" di tiap blok, kamu juga dapat melakukan double klik blok yang ingin diubah untuk melakukan perubahan.',
        "ss_builder_introduce_double_tap_label_check": "Jangan tampilkan lagi",
        "ss_builder_introduce_double_tap_title": "Tips Pengaturan blok",
        "ss_builder_invalid_product_url_label": "Tautan tidak valid",
        "ss_builder_invalid_url": "URL tidak valid",
        "ss_builder_items_per_row": "Jumlah item per baris",
        "ss_builder_keep_the_content": "Pertahankan kontennya",
        "ss_builder_landscape_image_orientation_label": "Orientasi lanskap",
        "ss_builder_limit_reached": "Mencapai limit",
        "ss_builder_link_additional_btn_label": "Tambahkan Link",
        "ss_builder_link_select_service": "Pilih layanan",
        "ss_builder_link_text_left_layout": "Teks di sebelah kiri",
        "ss_builder_link_text_right_layout": "Teks di sebelah kanan",
        "ss_builder_link_text_under_layout": "Teks di bawah ini",
        "ss_builder_link_text_zig_zag_layout": "Zig Zag",
        "ss_builder_link_type_email": "Email",
        "ss_builder_link_type_phone": "Telepon",
        "ss_builder_link_type_service": "Layanan",
        "ss_builder_link_type_tel": "Tel",
        "ss_builder_link_type_web": "Web",
        "ss_builder_link_url": "Link URL",
        "ss_builder_list_button_multi_link_label": "List",
        "ss_builder_list_card_empty_content": "Untuk menambahkan kartu silahkan tekan tombol di atas untuk menambahkan",
        "ss_builder_list_card_empty_title": "Belum ada tag konten yang ditambahkan",
        "ss_builder_list_card_label": "Daftar kartu",
        "ss_builder_list_image_popup_title": "List gambar pop-up",
        "ss_builder_list_label": "List",
        "ss_builder_list_link_empty_content": "Untuk menambahkan link, silakan klik tombol \u201CTambah\u201D di atas",
        "ss_builder_list_link_empty_title": "Belum ada tautan yang ditambahkan",
        "ss_builder_list_title_digital_product": "List",
        "ss_builder_loading_label": "Memuat",
        "ss_builder_malformed_domain_warning": "Nama domain tidak valid",
        "ss_builder_malformed_embed_code_warning": "Kode embed tidak valid",
        "ss_builder_manage_block_description": "Ss Builder Manage Block Description",
        "ss_builder_manage_block_title": "Manajemen blok",
        "ss_builder_manage_tab_description": "Tab digunakan untuk membagi daftar blok menjadi beberapa bagian",
        "ss_builder_manage_tab_title": "Manajemen Tab",
        "ss_builder_management_digital_product_description": "List of your digital products",
        "ss_builder_management_digital_product_title": "Digital Product",
        "ss_builder_management_label": "Management",
        "ss_builder_medium": "Medium",
        "ss_builder_missing_required_product_url_label": "Info belum lengkap",
        "ss_builder_modal_button_close": "Tutup",
        "ss_builder_move_block_successfully_label": "Sukses mengubah posisi blok",
        "ss_builder_move_down_block_label": "Turun",
        "ss_builder_move_product_label": "Pindah ke",
        "ss_builder_move_product_quantity_to_group_alert_label": "Pindahkan {{product_quantity}} produk ke",
        "ss_builder_move_product_successfully_label": "Sukses memindahkan produk",
        "ss_builder_move_to_bottom_label": "Pindah ke bawah",
        "ss_builder_move_to_top_label": "Pindah ke atas",
        "ss_builder_move_up_block_label": "Naik",
        "ss_builder_multi_product_url_imported_label": "Sudah ditambah {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} links",
        "ss_builder_multi_product_url_importing_label": "Sedang proses menambahkan {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} links",
        "ss_builder_name_tab_input_title": "Nama tab",
        "ss_builder_need_to_display_at_least_one_block": "Need to display at least one block",
        "ss_builder_need_to_display_at_least_one_card": "Harus menampilkan minimal satu kartu/card",
        "ss_builder_need_to_display_at_least_one_image": "Harus menampilkan minimal satu gambar",
        "ss_builder_need_to_display_at_least_one_link": "Harus menampilkan minimal satu link",
        "ss_builder_need_to_display_at_least_one_spotlight": "Harus menampilkan minimal satu spotlight",
        "ss_builder_next": "Lanjut",
        "ss_builder_no_image_selected": "Daftar kosong",
        "ss_builder_no_photo_has_been_selected": "Belum ada foto yang dipilih",
        "ss_builder_no_shadow": "No shadow",
        "ss_builder_no_themes_found_theme_store": "Tidak ada tema yang ditemukan",
        "ss_builder_none_of_image_description": 'Klik tombol "Tambah" untuk menambahkan gambar pop-up',
        "ss_builder_none_of_image_popup_alert": "Tidak ada gambar pop-up",
        "ss_builder_not_add_yet_product_url_label": "Tautan belum ditambahkan",
        "ss_builder_not_enough_space_product_group_modal_content": "Grup produk yang Anda pilih tidak memiliki cukup ruang untuk menampung {{num_products}} produk di daftar produk yang akan ditambah. Harap hapus beberapa produk dari daftar produk yang akan ditambah atau pilih grup lain.",
        "ss_builder_not_enough_space_product_group_modal_title": "Tidak dapat memilih grup",
        "ss_builder_notes": "Deskripsikan laporan error mu",
        "ss_builder_off": "Off",
        "ss_builder_on": "On",
        "ss_builder_onboarding_choose_a_suitable_theme": "Pilih tema yang sesuai, Anda dapat menyesuaikan setelah menerapkan\u2728",
        "ss_builder_onboarding_choose_the_look_for_you": "Pilih tampilan yang sesuai dengan Anda!",
        "ss_builder_onboarding_create_a_personal_page": "Buat halaman bio, jalankan Affiliate Marketing, Booking, Donasi, Jual produk digital (dokumen, gambar, video, presentasi,...)",
        "ss_builder_onboarding_no_need_know_technology": "Tidak perlu repot-repot lagi, cukup dengan beberapa langkah kamu sudah bisa punya bio page sendiri.",
        "ss_builder_onboarding_theme_store_template": "Theme store",
        "ss_builder_open_browser_label": "Buka di Browser",
        "ss_builder_open_link_in_new_tab": "Buka tautan di tab baru",
        "ss_builder_open_link_in_new_tab_description": "Buka tautan di tab baru",
        "ss_builder_open_new_tab_description": "Hapus centang untuk membuka tautan di situs saat ini. Centang untuk membuka tautan di jendela baru",
        "ss_builder_open_new_tab_label": "Buka tautan di jendela baru",
        "ss_builder_optional_color_panel_label": "Warna opsional",
        "ss_builder_overwrite_description": "Menimpa template ini akan mengubah seluruh pengaturan dari template",
        "ss_builder_overwrite_template_btn_label": "Ubah",
        "ss_builder_overwrite_template_successfully_label": "Sukses menimpa template",
        "ss_builder_overwrite_template_title": "Timpa template",
        "ss_builder_overwrite_theme_btn_label": "Timpa",
        "ss_builder_overwrite_theme_template_successfully_label": "Sukses mengubah template tema",
        "ss_builder_overwrite_theme_template_title": "Timpa template tema",
        "ss_builder_overwrite_title": "Apakamu ingin menimpa template ini?",
        "ss_builder_panel_add_icon_tab_title": "Pilih ikon",
        "ss_builder_panel_add_new_tab_title": "Tab informasi",
        "ss_builder_panel_edit_text_block_title": "Mengubah nama blok",
        "ss_builder_panel_search_label": "Cari...",
        "ss_builder_panel_title": "Pilih jenis blok",
        "ss_builder_paragraph_setting_font_available": "Fonts tersedia",
        "ss_builder_paragraph_setting_font_custom": "Custom font",
        "ss_builder_paragraph_setting_option": "Opsi font",
        "ss_builder_paragraph_setting_title": "Pengaturan Paragraf",
        "ss_builder_partial_visible_slide_type_1": "Terlihat parsial di kanan",
        "ss_builder_partial_visible_slide_type_2": "Terlihat parsial di kanan kiri",
        "ss_builder_partial_visible_slide_type_3": "Tidak terlihat parsial",
        "ss_builder_partial_visible_slide_type_4": "Poster",
        "ss_builder_partial_visible_slide_type_5": "Panorama",
        "ss_builder_passio_page_ready": "Halaman Passio sudah siap",
        "ss_builder_passio_page_ready_description": "Halaman Passio siap digunakan dan menggantikan Landing Page versi lama",
        "ss_builder_passio_premium": "Passio Premium",
        "ss_builder_personal_link_coppy_label": "Salin",
        "ss_builder_personal_link_coppy_successfully_label": "Sudah disalin",
        "ss_builder_personal_link_sharing_title": "Bagikan profil Anda",
        "ss_builder_personal_link_title": "Tautan profil Anda",
        "ss_builder_phone_placeholder": "Masukkan nomor telepon",
        "ss_builder_placeholder_affiliate_product_enter_product_name": "Isi nama produk",
        "ss_builder_placeholder_dragging_content": "Taruh disini",
        "ss_builder_please_wait_for_the_product_to_be_updated": "Tunggu sebentar ya sambil menunggu produk di update.",
        "ss_builder_popover_manual_button": "Mulai",
        "ss_builder_popover_manual_button_close": "Close",
        "ss_builder_popover_manual_content": 'Untuk melihat panduan cara menggunakan fitur Desain, silahkan tekan tombol \u201CMulai".',
        "ss_builder_popover_manual_title": "Panduan pengguna",
        "ss_builder_popover_review_manual_content": "Kamu dapat membuka kembali panduan ini kapan saja dengan mengklik menu Bantuan.",
        "ss_builder_popular_font_families": "Huruf populer",
        "ss_builder_popup_confirm_button": "Konfirmasi",
        "ss_builder_popup_management_title": "Management",
        "ss_builder_portrait_image_orientation_label": "Orientasi portret",
        "ss_builder_position_ghim_tab_selection_label": "Posisi",
        "ss_builder_powered_by_passio": "Powered by Ecomobi",
        "ss_builder_preview": "Pratinjau",
        "ss_builder_preview_image_label": "Pratinjau",
        "ss_builder_preview_theme_template_title": "Preview gambar",
        "ss_builder_product_design_empty_description": "Please wait for the product to be updated",
        "ss_builder_product_design_empty_title": "Tidak ada produk",
        "ss_builder_product_detect_link_malformed_error": "Format tautan tidak valid",
        "ss_builder_product_detect_link_placeholder": "Masukkan tautan produk",
        "ss_builder_product_detect_link_title": "Link produk",
        "ss_builder_product_empty_searching_description": "Coba dengan kata kunci lain",
        "ss_builder_product_empty_searching_title": "Hasil tidak ditemukan",
        "ss_builder_product_exceeding_allowed_amount_content": "Untuk menambahkan produk baru, harap hapus beberapa produk yang sudah ada",
        "ss_builder_product_exceeding_allowed_amount_title": "Jumlah produk mencapai batasan",
        "ss_builder_product_group_add_new_btn_label": "Tambahkan grup produk",
        "ss_builder_product_group_default_title": "Produk",
        "ss_builder_product_group_limitation_warning_description": "Total produk dalam grup telah mencapai batas {{max_products}} produk. Tolong hapus produk yang telah ada jika Anda ingin menambahkan yang baru.",
        "ss_builder_product_group_selection_placeholder": "Silakan pilih grup produk",
        "ss_builder_product_group_selection_title": "Pilih grup produk afiliasi",
        "ss_builder_product_group_total_limitation_warning_content": "Maksimal {{group_quantity_maximum}} grup produk. Silahkan hapus grup produk lainnya jika ingin menambahkan grup baru.",
        "ss_builder_product_group_total_limitation_warning_title": "Tidak dapat menambah grup produk baru",
        "ss_builder_product_is_hiding_label": "Hidden product",
        "ss_builder_product_link_wrapped_label": "Wrapped link",
        "ss_builder_product_list_style_grid_label": "Grid",
        "ss_builder_product_list_style_grid_one_label": "1 produk",
        "ss_builder_product_list_style_grid_three_label": "3 produk",
        "ss_builder_product_list_style_grid_two_label": "2 produk",
        "ss_builder_product_list_style_slide_label": "Slide",
        "ss_builder_product_list_style_text_over_image_label": "Text over image",
        "ss_builder_product_list_style_zig_zag_label": "Zigzag",
        "ss_builder_product_searching_description": "Masukkan nama produk untuk mencari",
        "ss_builder_product_searching_title": "Cari produk",
        "ss_builder_product_selection_option_1": "10 produk terakhir",
        "ss_builder_product_selection_option_2": "20 produk terakhir",
        "ss_builder_product_selection_option_3": "50 produk terakhir",
        "ss_builder_product_selection_option_4": "5 produk terakhir",
        "ss_builder_product_swiper_see_all": "Lihat semua",
        "ss_builder_product_title_error": "Missing product name",
        "ss_builder_product_title_missing_warning": "Masukkan nama produk",
        "ss_builder_product_total_limitation_warning_description": "Total produk di seluruh grup telah mencapai batas {{max_products_all_groups}} produk. Tolong hapus produk yang telah ada jika Anda ingin menambahkan yang baru.",
        "ss_builder_product_total_limitation_warning_title": "Tidak dapat menambahkan produk baru",
        "ss_builder_product_tour_button_step_0": "Mulai",
        "ss_builder_product_tour_content_step_0": "Mulailah dengan mengikuti tutorial kami untuk menikmati fitur-fitur menarik dari Passio Page!",
        "ss_builder_product_tour_content_step_1": "Yuk berkreasi dengan layar Desain. Mudah untuk mengedit dan mengatur Blok sesuai dengan gaya Anda sendiri.",
        "ss_builder_product_tour_content_step_10": "Ganti seluruh konten halaman Anda dengan konten yang persis sama dari template tema yang berlaku. Jadikan konten halaman Anda persis seperti template",
        "ss_builder_product_tour_content_step_11": "Pratinjau situs untuk melihat perubahan situs saat ini. Publikasikan hanya boleh dilakukan setelah Anda melihat pratinjau dan puas dengan perubahannya.",
        "ss_builder_product_tour_content_step_12": 'Tahan dan seret untuk memindahkan atau gunakan "Tindakan cepat" untuk memindahkan blok ke atas/bawah.',
        "ss_builder_product_tour_content_step_13": 'Pilih "Ubah" di "Tindakan Cepat" atau langsung klik blok untuk mengedit.',
        "ss_builder_product_tour_content_step_14": "Pakai gambar, warna solid, atau warna gradien yang sesuai dengan keinginan Anda untuk mengubah latar belakang dengan cepat",
        "ss_builder_product_tour_content_step_15": "Banyak tema yang beragam, indah, dan sedang tren untuk Anda pilih dan gunakan dengan bebas",
        "ss_builder_product_tour_content_step_16": "Pengaturan lanjutan membantu menyempurnakan desain tema, mengubah nama domain, merek pribadi, dll",
        "ss_builder_product_tour_content_step_17": "Anda dapat menjalankan kembali panduan pengguna ini kapan saja, dengan mengeklik tombol bantuan ini.",
        "ss_builder_product_tour_content_step_2": "Banyak tipe Blok yang bisa ditambahkan untuk mempercantik halaman Anda. Kreasikan passio page sesuai dengan gayamu, cukup tap atau drag dan drop di posisi yang kamu inginkan untuk menambah blok baru. Yuk coba sekarang!",
        "ss_builder_product_tour_content_step_3": "Pengeditan dan lebih banyak opsi untuk setiap blok, izinkan Anda menyesuaikan blok seperti yang Anda inginkan.",
        "ss_builder_product_tour_content_step_4": 'Pengeditan desain selalu dalam mode "Draft". Perubahan akan terlihat oleh Fans Anda setelah Anda memutuskan untuk "Publikasikan".',
        "ss_builder_product_tour_content_step_5": 'Tab digunakan untuk membagi "Body" menjadi beberapa bagian, misalnya Tab Produk, Tab Video, Tab Kupon, ... Klik pada setiap Tab untuk melihat dan mengubah konten di dalamnya. Edit blok ini untuk menambahkan yang baru, mengelola Tab.',
        "ss_builder_product_tour_content_step_6": "\u201CHeader\u201D berisi Blok, yang selalu muncul di bagian atas halaman. Misalnya: gambar Avatar, pengantar...",
        "ss_builder_product_tour_content_step_7": '"Body" adalah area utama situs, berisi Blok dan terbagi-bagi oleh Tab. Misalnya: konten, gambar, produk, ...',
        "ss_builder_product_tour_content_step_8": "\u201CFooter\u201D berisi Blok, yang selalu muncul di bagian bawah halaman. Misalnya: tautan cepat, info halaman...",
        "ss_builder_product_tour_content_step_9": "Gunakan fitur ini, jika perubahan yang Anda buat tidak memuaskan Anda. Sistem akan memulihkan layar Desain Anda kembali ke versi situs yang sebelumnya.",
        "ss_builder_product_tour_done_label": "Selesai",
        "ss_builder_product_tour_next_label": "Lanjut",
        "ss_builder_product_tour_prev_label": "Kembali",
        "ss_builder_product_tour_skip_label": "Lewati",
        "ss_builder_product_tour_title_step_0": "Selamat datang di Passio Page",
        "ss_builder_product_tour_title_step_1": "Desain tema",
        "ss_builder_product_tour_title_step_10": "Terapkan konten sampel",
        "ss_builder_product_tour_title_step_11": "Pratinjau situs",
        "ss_builder_product_tour_title_step_12": "Pindahkan Blok",
        "ss_builder_product_tour_title_step_13": "Mengedit Blok",
        "ss_builder_product_tour_title_step_14": "Ubah background",
        "ss_builder_product_tour_title_step_15": "Theme store",
        "ss_builder_product_tour_title_step_16": "Pengaturan lanjutan",
        "ss_builder_product_tour_title_step_17": "Panduan pengguna",
        "ss_builder_product_tour_title_step_2": "Tambahkan Blok baru",
        "ss_builder_product_tour_title_step_3": "Aksi Cepat",
        "ss_builder_product_tour_title_step_4": "Publikasikan desain",
        "ss_builder_product_tour_title_step_5": "Tab menu",
        "ss_builder_product_tour_title_step_6": "Header",
        "ss_builder_product_tour_title_step_7": "Body",
        "ss_builder_product_tour_title_step_8": "Footer",
        "ss_builder_product_tour_title_step_9": "Restore pengeditan",
        "ss_builder_product_tour_use_manual": "Panduan pengguna",
        "ss_builder_product_tour_use_manual_content": "Untuk lihat tutorial menggunakan fitur Design, silahkan tekan tombol \u201CMulai\u201D.",
        "ss_builder_product_url_lists_label": "Daftar tautan",
        "ss_builder_publish_button_label": "Menerbitkan",
        "ss_builder_publish_result_description": "Anda telah berhasil menerbitkan Halaman Passio. Halaman Anda dapat diakses melalui URL di bawah ini.",
        "ss_builder_publish_result_successfully": "Tema berhasil diterbitkan!",
        "ss_builder_publish_result_title": "Hasil publikasi",
        "ss_builder_publish_saving": "Simpan",
        "ss_builder_publish_share": "Share",
        "ss_builder_publish_view_page": "Lihat halaman",
        "ss_builder_randomize": "Pilih secara acak",
        "ss_builder_ready_to_build_your_personal_brand": "Siap membangun brand pribadi Anda dengan Passio sekarang \uD83D\uDC96",
        "ss_builder_recently_color_panel_label": "Warna yang baru saja digunakan",
        "ss_builder_redo_theme_label": "Ulangi",
        "ss_builder_reload_label": "Refresh",
        "ss_builder_replace": "mengubah",
        "ss_builder_replace_preview_theme_template_btn_label": "Apply",
        "ss_builder_replace_theme_label": "Terapkan konten sampel",
        "ss_builder_replace_theme_modal_content": "Terapkan tema template konten akan menggantikan semua blok di situs Anda dengan blok Tema Template",
        "ss_builder_replace_theme_modal_title": "Apakah Anda ingin menerapkan tema data sampel ?",
        "ss_builder_replace_theme_template_successfully_label": "Berhasil menggunakan tema",
        "ss_builder_report_sent_report_successfully": "Laporan berhasil dikirim",
        "ss_builder_report_sent_report_successfully_description": "Terimakasih atas laporannya! Permasalahan ini akan di proses dalam waktu dekat",
        "ss_builder_restore_theme_content": "Seluruh pengaturan tema dan data blok di dalam tema akan dikembalikan ke tema yang dipublikasikan. Apakah Anda ingin melanjutkan?",
        "ss_builder_restore_theme_label": "Pulihkan pengeditan",
        "ss_builder_restore_theme_successfully_label": "Berhasil memulihkan pengeditan",
        "ss_builder_restore_theme_title": "Apakah Anda ingin memulihkan hasil edit?",
        "ss_builder_revenue_group_description": "Mulai hasilkan uang sekarang dengan layanan Passio Page",
        "ss_builder_revenue_title": "Cari uang",
        "ss_builder_round_photo_label": "Rounded photo",
        "ss_builder_rounded": "Bulat",
        "ss_builder_sample_change_label": "Ubah template",
        "ss_builder_sample_selection_label": "Pilih gaya",
        "ss_builder_sampling_change_label": "Pilih template",
        "ss_builder_save": "Simpan",
        "ss_builder_save_new_template_title": "Simpan sebagai template baru",
        "ss_builder_save_new_theme_template_successfully_label": "Sukses menyimpan tema baru",
        "ss_builder_save_new_theme_template_title": "Simpan template tema baru",
        "ss_builder_save_succesfully_description": "Perubahan sudah disimpan",
        "ss_builder_save_succesfully_label": "Berhasil simpan",
        "ss_builder_search_results_theme_store": "Hasil pencarian",
        "ss_builder_search_type_block": "Cari type blok pakai nama",
        "ss_builder_see_less": "Lihat lebih sedikit",
        "ss_builder_see_more": "Lihat lainnya",
        "ss_builder_see_more_btn_default_title": "Lihat lainnya",
        "ss_builder_select_label": "Pilih",
        "ss_builder_select_link_type": "Pilih tipe link",
        "ss_builder_select_multi_items": "Pilih",
        "ss_builder_select_position_add_block": "Pilih posisi untuk menambahkan blok",
        "ss_builder_select_ratio_title": "Pilih rasio",
        "ss_builder_select_theme_setting_primary_color_label": "Pilih warna primer",
        "ss_builder_selected_product_in_selection_label": "Produk terpilih",
        "ss_builder_send": "Kirim",
        "ss_builder_send_report": "Kirim Laporan",
        "ss_builder_service_placeholder": "Pilih layanan",
        "ss_builder_set_default_tab_disable_content": 'Tab standar akan ditampilkan pertama kali ketika pengguna memasuki halaman Anda. Tab "{{tab_name}}" sedang disembunyikan. Atur tab ini sebagai standar akan mengubah status tab ini menjadi terlihat. Apakah Anda ingin terapkan tab "{{tab_name}}" sebagai standar?',
        "ss_builder_set_default_tab_enable_content": 'Tab standar akan ditampilkan pertama kali ketika pengguna memasuki halaman Anda. Apakah Anda ingin terapkan tab "{{tab_name}}" sebagai standar?',
        "ss_builder_set_default_tab_label": "Pengaturan standar",
        "ss_builder_set_default_tab_successfully_label": "Berhasil tetapkan default",
        "ss_builder_set_default_tab_title": "Konfirmasi untuk pengaturan standar",
        "ss_builder_setting_font_weight": "Berat font",
        "ss_builder_setting_line_height": "Tinggi garis",
        "ss_builder_setting_popover_manual_content": 'Cari tahu bagaimana cara kerja menu "Pengaturan", pilih menu "Memulai".',
        "ss_builder_setting_popover_manual_title": "Panduan Passio",
        "ss_builder_setting_saving": "Simpan data",
        "ss_builder_setting_text_font": "Jenis Font",
        "ss_builder_setting_text_scale": "Skala",
        "ss_builder_setting_text_size": "Ukuran huruf (px)",
        "ss_builder_setting_title": "Pengaturan",
        "ss_builder_setting_tour_content_step_1": "Ini adalah link dari web passiomu. Kamu dapat mengcopy, membuka, dan membagikan passio pagemu dengan link ini. Selain itu juga kamu bisa dapat mengubah favicon dan nama domain sesuai dengan personal brandmu.",
        "ss_builder_setting_tour_content_step_2": "Kamu dapat mengubah tema tampilan passio page mu disini. Pengaturan ini akan mengubah seluruh tampilan sesuai dengan pilihanmu.",
        "ss_builder_setting_tour_content_step_3": "Kamu dapat mengatur personal branding, pengaturan SEO, nama domain dari sini.",
        "ss_builder_setting_tour_title_step_1": "Website url",
        "ss_builder_setting_tour_title_step_2": "Theme settings",
        "ss_builder_setting_tour_title_step_3": "Site settings",
        "ss_builder_settings_label": "Pengaturan",
        "ss_builder_setup_site_setting": "Site settings",
        "ss_builder_setup_theme_setting": "Theme settings",
        "ss_builder_shadows_style": "Shadow",
        "ss_builder_shape_label": "Shape",
        "ss_builder_share_label": "Bagikan",
        "ss_builder_show_block_label": "Tampilkan blok",
        "ss_builder_show_card_label": "Tampilkan kartu",
        "ss_builder_show_card_successfully_label": "Tampilkan kartu berhasil",
        "ss_builder_show_image_label": "Tampilkan gambar",
        "ss_builder_show_link_label": "Tampilkan link",
        "ss_builder_show_link_successfully_label": "Tampilkan link berhasil",
        "ss_builder_show_product_group_label": "Tampilkan grup",
        "ss_builder_show_product_label": "Tampilkan produk",
        "ss_builder_show_social_link_label": "Tampilkan",
        "ss_builder_show_tab_label": "Tampilkan Tab",
        "ss_builder_show_template_successfully_label": "Sukses menampilkan template",
        "ss_builder_show_theme_template_label": "Show template",
        "ss_builder_site_brand_setting_label": "Merek pribadi",
        "ss_builder_site_domain_setting_label": "Domain",
        "ss_builder_site_setting_browser_label": "Browser",
        "ss_builder_site_setting_coppy_label": "Salin",
        "ss_builder_site_setting_favicon_title": "Favicon",
        "ss_builder_site_setting_favicon_upload_description": "Favicon ditampilkan di sebelah tautan halaman. Unggah gambar favorit apapun untuk membuat Favicon.",
        "ss_builder_site_setting_label": "Pengaturan halaman",
        "ss_builder_site_setting_premium": "Premium",
        "ss_builder_site_setting_share_label": "Bagikan",
        "ss_builder_site_setting_standard": "Standard",
        "ss_builder_site_setting_upgrade": "Upgrade",
        "ss_builder_skip": "Lewati",
        "ss_builder_slide_type_label": "Tiper geser",
        "ss_builder_social_link_btn_add_new_label": "Tambahkan sosial media",
        "ss_builder_social_links_list_title": "Daftar sosial media",
        "ss_builder_social_network_label": "Social network",
        "ss_builder_soft_shadow": "Soft shadow",
        "ss_builder_solid": "Solid",
        "ss_builder_solid_type_label": "Solid",
        "ss_builder_something_went_wrong": "Maaf, terjadi kesalahan",
        "ss_builder_spacer_label": "Spacing (px)",
        "ss_builder_spotlight_list_empty_content": 'Untuk menambahkan Spotlight baru silahkan tekan "Tambah" diatas',
        "ss_builder_spotlight_list_empty_title": "Belum ada Spotlight yang aktif",
        "ss_builder_square": "Kotak",
        "ss_builder_square_photo_label": "Squared photo",
        "ss_builder_start_use_passio_page": "Mulai gunakan Passio Page sekarang",
        "ss_builder_stop_label": "Berhenti",
        "ss_builder_story": "Spotlight",
        "ss_builder_story_title_place_holder": "Judul spotlight",
        "ss_builder_style": "Gaya",
        "ss_builder_style_always_ghim_tab_label": "Always sticky",
        "ss_builder_style_auto_ghim_tab_label": "Auto sticky",
        "ss_builder_style_ghim_tab_selection_label": "Sematkan bagian",
        "ss_builder_style_grid_label": "Grid",
        "ss_builder_style_masonry_label": "Masonry",
        "ss_builder_style_not_ghim_tab_label": "No sticky",
        "ss_builder_style_slide_label": "Geser",
        "ss_builder_style_tab_icon_label": "Hanya Ikon",
        "ss_builder_style_tab_only_icon": "Ikon saja",
        "ss_builder_style_tab_only_image": "Gambar saja",
        "ss_builder_style_tab_selection_label": "Tampilan",
        "ss_builder_style_tab_text_and_icon_label": "Teks & Ikon",
        "ss_builder_style_tab_text_and_image_label": "Text & image",
        "ss_builder_style_tab_text_label": "Hanya teks",
        "ss_builder_subtitle_site_setting_description": "Memberikan gambaran umum tentang konten dan informasi yang ditawarkan situs. Mesin pencari menggunakan ini untuk menampilkan deskripsi situs web.",
        "ss_builder_subtitle_site_setting_label": "Subjudul",
        "ss_builder_suggested_color_panel_label": "Palet warna disarankan",
        "ss_builder_support_upload_image": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, sampai 30MB",
        "ss_builder_support_upload_image_v2": "Support: JPG, JPEG, GIF, PNG, BMP sampai 30MB",
        "ss_builder_support_upload_large_image": "Support: JPG, JPEG, GIF, PNG, BMP, WebP, sampai 50MB",
        "ss_builder_swiper_setting_premium_description_1": "Fitur tak terbatas",
        "ss_builder_swiper_setting_premium_title_1": "Akun Premium",
        "ss_builder_swiper_setting_premium_title_2": "Tema Ekslusif",
        "ss_builder_swiper_setting_premium_title_3": "Domain custom sesuai brandingmu",
        "ss_builder_swiper_setting_premium_title_4": "Brand Campaign Eklusif",
        "ss_builder_swiper_setting_premium_title_5": "Penarikan komisi lebih cepat",
        "ss_builder_swiper_setting_premium_title_6": "Diskon 25% untuk biaya layanan",
        "ss_builder_tab_layout_1": "Teks sebelah kanan",
        "ss_builder_tab_layout_2": "Teks di bawah",
        "ss_builder_tabs_label": "Tab",
        "ss_builder_template_overwrite_title": "Menimpa Template",
        "ss_builder_template_search_bar_placeholder": "Cari template berdasarkan nama...",
        "ss_builder_template_store_instruction_subtitle": "Data dan pengaturan template blok akan di aplikasikan ke blok saat ini",
        "ss_builder_template_store_instruction_title": "Silahkan pilih template blok yang kamu inginkan!",
        "ss_builder_template_title": "Template",
        "ss_builder_text_editor_max_length": "Maksimum {{editor_max_length}} karakter",
        "ss_builder_text_spin_loading": "Loading page",
        "ss_builder_the_application_of_the_template_will": "Menggunakan template akan",
        "ss_builder_theme_big_button_setting": "Tombol besar",
        "ss_builder_theme_button_setting_general": "General",
        "ss_builder_theme_display_setting": "Pengaturan tampilan",
        "ss_builder_theme_medium_button_setting": "Tombol medium",
        "ss_builder_theme_setting_background": "Background",
        "ss_builder_theme_setting_background_color_preview_title": "Pratinjau",
        "ss_builder_theme_setting_background_color_selector_label": "Warna",
        "ss_builder_theme_setting_background_content": "Ukuran file maks: 30MB.\nMendukung format file: jpg, jpeg, gif, png, bmp, webp",
        "ss_builder_theme_setting_background_content_v2": "Ukuran file maks: 30MB.\nMendukung format file: jpg, jpeg, gif, png, bmp",
        "ss_builder_theme_setting_background_image_preview_label": "Gambar background",
        "ss_builder_theme_setting_background_image_selector_label": "Gambar",
        "ss_builder_theme_setting_background_image_title": "Gambar background",
        "ss_builder_theme_setting_block_background": "Warna background",
        "ss_builder_theme_setting_block_border": "Border",
        "ss_builder_theme_setting_block_shadow": "Shadow",
        "ss_builder_theme_setting_block_style": "Gaya",
        "ss_builder_theme_setting_button": "Tombol",
        "ss_builder_theme_setting_font_title": "Pengaturan teks",
        "ss_builder_theme_setting_font_type_content": "Pilih tipe font untuk diaplikasikan ke seluruh situs Anda",
        "ss_builder_theme_setting_font_type_title": "Tipe font",
        "ss_builder_theme_setting_gadient_color": "Warna",
        "ss_builder_theme_setting_general": "General",
        "ss_builder_theme_setting_gradient_color_direction_label": "Petunjuk",
        "ss_builder_theme_setting_hard_shadow": "Hard shadow",
        "ss_builder_theme_setting_intensity_color_label": "Intensitas warna",
        "ss_builder_theme_setting_label": "Pengaturan tema",
        "ss_builder_theme_setting_no_shadow": "No shadow",
        "ss_builder_theme_setting_paragraph": "Paragraf",
        "ss_builder_theme_setting_primary_color": "Warna",
        "ss_builder_theme_setting_primary_color_content": "Pilih warna primer untuk diterapkan ke seluruh situs Anda",
        "ss_builder_theme_setting_primary_color_title": "Warna primer",
        "ss_builder_theme_setting_save_failed_content": "Terjadi kesalahan yang tidak terduga. Silakan coba lagi.",
        "ss_builder_theme_setting_save_failed_title": "Error",
        "ss_builder_theme_setting_save_successfully_label": "Berhasil simpan pengaturan",
        "ss_builder_theme_setting_select_background_color_label": "Pilih tipe warna",
        "ss_builder_theme_setting_select_gradient_color_label": "Pilih warna gradien",
        "ss_builder_theme_setting_select_solid_color_label": "Pilih warna",
        "ss_builder_theme_setting_shadow": "Shadow",
        "ss_builder_theme_setting_shadow_color": "Warna bayangan",
        "ss_builder_theme_setting_soft_shadow": "Soft shadow",
        "ss_builder_theme_setting_text": "Tombol Teks",
        "ss_builder_theme_setting_title": "Judul",
        "ss_builder_theme_small_button_setting": "Tombol kecil",
        "ss_builder_theme_store_label": "Template",
        "ss_builder_theme_store_popover_manual_content": 'Cari tahu cara menggunakan Theme Store dengan menekan menu "Memulai".',
        "ss_builder_theme_store_popover_manual_title": "Panduan Passio",
        "ss_builder_theme_store_tour_content_step_1": "Cari tema lebih cepat dengan mencari nama tema",
        "ss_builder_theme_store_tour_content_step_2": "Passio Page menawarkan beragam macam tampilan tema yang bisa kamu pilih. Coba template yang tersedia sekarang.",
        "ss_builder_theme_store_tour_title_step_1": "Cari template tema",
        "ss_builder_theme_store_tour_title_step_2": "Template Tema",
        "ss_builder_theme_template_format_create_label": "Buat",
        "ss_builder_theme_template_label_tag": "Tags",
        "ss_builder_theme_template_label_tag_placeholder": "Masukkan tags",
        "ss_builder_theme_template_no_option": "Tidak ada pilihan",
        "ss_builder_theme_template_preview_info": "Pratinjau passio page mu setelah mengaplikasikan tema",
        "ss_builder_theme_template_preview_mode_title": "Preview",
        "ss_builder_theme_template_search_bar_placeholder": "Cari template tema berdasarkan nama...",
        "ss_builder_theme_template_store_instruction_subtitle": "Pengaturan tema dari template tema yang dipilih akan diterapkan ke situs web",
        "ss_builder_theme_template_store_instruction_title": "Silakan pilih tema yang Anda inginkan!",
        "ss_builder_theme_template_store_title": "Theme Store",
        "ss_builder_theme_template_theme_store": "{{num_results}} tema template",
        "ss_builder_theme_template_view_theme_info": "Tema template dengan contoh data",
        "ss_builder_theme_template_view_theme_title": "Lihat template",
        "ss_builder_title": "Judul",
        "ss_builder_title_block_affiliate_product": "Affiliate",
        "ss_builder_title_block_bio": "Bio",
        "ss_builder_title_block_booking_profile": "Booking Profile",
        "ss_builder_title_block_booking_profile_description": "Tambahkan link ke halaman Booking Profile atau tampilkan Booking Profile di Passio Page",
        "ss_builder_title_block_booking_profile_warning": "Buat Booking Profile untuk menambahkan blok ini",
        "ss_builder_title_block_brand_gift": "Brand Gift",
        "ss_builder_title_block_brand_gift_description": "Tampilkan ikon Brand Gift",
        "ss_builder_title_block_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_block_brand_rating": "Brand Ratings",
        "ss_builder_title_block_brand_rating_description": "id_B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_builder_title_block_button_link": "Link",
        "ss_builder_title_block_button_multi_link": "Multi Links",
        "ss_builder_title_block_card": "Kartu",
        "ss_builder_title_block_digital_product": "Produk Digital",
        "ss_builder_title_block_donation": "Donasi",
        "ss_builder_title_block_embed": "Embed",
        "ss_builder_title_block_image": "Gambar",
        "ss_builder_title_block_image_gallery": "Galeri gambar",
        "ss_builder_title_block_image_popup": "Gambar pop-up",
        "ss_builder_title_block_image_slider": "Image Slider",
        "ss_builder_title_block_story": "Spotlight",
        "ss_builder_title_block_tab_bar": "Tab Menu",
        "ss_builder_title_block_text": "Teks",
        "ss_builder_title_block_truth_or_dare": "Truth Or Dare",
        "ss_builder_title_block_truth_or_dare_footer": "Truth Or Dare Icon",
        "ss_builder_title_block_video_shoutout": "Video Shoutout",
        "ss_builder_title_block_video_shoutout_description": "Hadiah video dari idola Anda",
        "ss_builder_title_block_virtual_gift": "Virtual Gift",
        "ss_builder_title_block_virtual_gift_footer": "Virtual Gift Icon",
        "ss_builder_title_brand_gift_footer": "Brand Gift Icon",
        "ss_builder_title_color": "Warna teks",
        "ss_builder_title_combined": "Gabungkan Blok",
        "ss_builder_title_introduction_service": "Layanan Informasi",
        "ss_builder_title_page_builder": "Passio Page Builder",
        "ss_builder_title_setting_title": "Pengaturan Judul",
        "ss_builder_title_spacer_and_divider": "Spacer & Divider",
        "ss_builder_to_add_products_please_press_the_add_button_above": "Untuk menambahkan Produk baru silahkan tekan \u201CTambah\u201D diatas.",
        "ss_builder_to_new_version": "Pergi ke Passio Page",
        "ss_builder_top_position_tab_label": "Top",
        "ss_builder_transparent": "Transparency",
        "ss_builder_truth_or_dare_warning": "Hanya bisa menambah satu blok",
        "ss_builder_try_another_keyword_theme_store": "Tidak ada hasil yang ditemukan. Silakan coba lagi dengan kata kunci lain.",
        "ss_builder_try_new_key": "Coba dengan kata kunci lain",
        "ss_builder_type_label": "Type",
        "ss_builder_type_of_color": "Tipe Warna",
        "ss_builder_undo_theme_label": "Kembali",
        "ss_builder_update_account": "Upgrade account",
        "ss_builder_upload_button_label": "Unggah gambar",
        "ss_builder_upload_file_format_invalid_content": "Format gambar tidak valid. Format yang didukung: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_file_format_invalid_content_for_gif_png_svg": "Format gambar tidak valid. Format yang didukung: GIF, PNG, SVG",
        "ss_builder_upload_file_format_invalid_content_v2": "Format gambar tidak valid. Format yang didukung: JPG, JPEG, GIF, PNG, BMP",
        "ss_builder_upload_file_size_invalid_content": "Silakan pilih file dengan ukuran maksimum 30MB",
        "ss_builder_upload_file_size_invalid_content_min_256": "Silahkan pilih gambar dengan ukuran minimum 256x256px",
        "ss_builder_upload_large_file_format_invalid_content": "Format gambar tidak valid. Format yang didukung: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_large_file_size_invalid_content": "Silakan pilih file dengan ukuran maksimum 50MB",
        "ss_builder_uploading_image": "Uploading image",
        "ss_builder_url_error_content": "Tidak menemukan info. Silahkan periksa kembali URL",
        "ss_builder_url_placeholder": "Masukkan url",
        "ss_builder_use_advanced_setting_description": "Pengaturan lanjutan dapat digunakan untuk mengubah tampilan dari Blok gabungan ini",
        "ss_builder_use_affiliate_link_description": "Centang untuk menggunakan link Afiliasi Ecomobi Passio. Hapus centang untuk menggunakan link asli",
        "ss_builder_use_affiliate_link_label": "Gunakan tautan pelacakan Ecomobi Passio",
        "ss_builder_use_ecomobi_tracking_link": "Gunakan link tracking Ecomobi Passio",
        "ss_builder_validate_gen_link_error_E1": "Token tidak valid",
        "ss_builder_validate_gen_link_error_E2": "Akunmu di blokir, kamu tidak akan menerima komisi.",
        "ss_builder_validate_gen_link_error_E3": "Link ini tidak didukung oleh sistem affiliate tracking, kamu tidak akan menerima komisi.",
        "ss_builder_validate_gen_link_error_E5": "Link ini tidak dapat menghasilkan komisi karena campaign mu beli di setujui. Silahkan request di menu Campaign atau hubungi account managermu.",
        "ss_builder_validate_gen_link_error_E6": "Link ini tidak menghasilkan komisi karena kamu telah di blok dari campaign ini.",
        "ss_builder_validate_gen_link_error_E7": "Tidak dapat mempersingkat link karena sistem error.",
        "ss_builder_validate_gen_link_error_E8": "Link ini tidak menghasilkan komisi karena campaign sedang di pause.",
        "ss_builder_video_shoutout_answer_method_description": "Jika Anda menerima permintaan penggemar pencipta, Anda perlu membalas dengan video",
        "ss_builder_video_shoutout_answer_method_title": "Metode jawaban",
        "ss_builder_video_shoutout_btn_setup": "Setel sekarang",
        "ss_builder_video_shoutout_des_intro_fan": "Anda memiliki 7 hari untuk memutuskan atau menolak permintaan penggemar. Jika Anda menolak untuk melakukannya, Ecomobi akan mengembalikan semua uang yang dibayar kepada pemohon dalam waktu 30 hari.",
        "ss_builder_video_shoutout_des_intro_gift": "Melalui Passio, penggemar Anda dapat mengirimi Anda persyaratan video untuk acara -acara khusus: ulang tahun, selamat, peringatan, dorongan video, inspirasi ... dengan biaya tertentu yang dirancang sendiri.",
        "ss_builder_video_shoutout_des_intro_policy": "Anda dan penggemar dapat berbagi video yang bermakna ini dengan orang -orang melalui situs jejaring sosial.",
        "ss_builder_video_shoutout_how_to_work": "Bagaimana cara kerja video teriakan?",
        "ss_builder_video_shoutout_introduction": "Video Shoutout adalah layanan yang memungkinkan penggemar untuk mengirim ke persyaratan pencipta untuk video yang dipersonalisasi untuk acara -acara tertentu seperti ulang tahun, kelulusan, selamat, ... Pencipta akan menanggapi persyaratan tersebut dengan satu dengan satu dengan satu dengan satu. Video. Video.",
        "ss_builder_video_shoutout_participate_description": "Pencipta dapat memilih untuk membuat atau menolak persyaratan penggemar",
        "ss_builder_video_shoutout_participate_title": "Hak untuk bergabung dengan Anda",
        "ss_builder_video_shoutout_response_description": "Setelah penggemar mengirimkan permintaan, Creator memiliki 7 hari untuk membuat video. Setelah waktu ini, jumlah permintaan itu akan dikembalikan ke penggemar",
        "ss_builder_video_shoutout_response_title": "Waktu merespon",
        "ss_builder_video_shoutout_title_intro": "Pendahuluan Layanan",
        "ss_builder_video_shoutout_title_intro_fan": "Membuat video",
        "ss_builder_video_shoutout_title_intro_gift": "Menerima persyaratan dari penggemar",
        "ss_builder_video_shoutout_title_intro_policy": "Berbagi momen yang bermakna.",
        "ss_builder_virtual_gift_list_title": "List hadiah",
        "ss_builder_wait_for_saving": "Proses penyimpanan belum selesai. Harap tunggu sebentar.",
        "ss_builder_warning_brand_gift_floating_continue": "Lanjutkan",
        "ss_builder_warning_brand_gift_floating_description": "Posisi untuk Floating Icon penuh. Anda harus menghapus blok di bagian grup Floating Icon di dalam menu Blok Tambahan/Extended. Lihat",
        "ss_builder_warning_brand_gift_floating_description_link": "Instruksi detilnya",
        "ss_builder_warning_brand_gift_floating_reject": "Batal",
        "ss_builder_warning_brand_gift_floating_title": "Posisi untuk Floating Icon sudah penuh",
        "ss_builder_warning_brand_gift_rating_description": "id_Hi\u1EC7n t\u1EA1i th\xe2n trang \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n hi\u1EC3n th\u1ECB. B\u1EA1n c\u1EA7n xo\xe1 b\u1EDBt kh\u1ED1i \u0111\u1EC3 b\u1EADt t\xednh n\u0103ng Brand Ratings",
        "ss_builder_warning_brand_rating_floating_continue": "id_\u0110\xe3 hi\u1EC3u",
        "ss_builder_warning_brand_rating_floating_title": "id_Brand Ratings",
        "ss_builder_web_browser": "Web browser",
        "ss_builder_web_label": "Ss Builder Web Label",
        "ss_builder_website_config_site_title_description": "Akan muncul di bagian atas halaman saat fansmu mengunjungi passio pagemu.",
        "ss_builder_website_config_site_title_label": "Judul Halaman",
        "ss_builder_website_config_site_title_placeholder": "Masukkan isi konten",
        "ss_builder_what_field_are_you_operating_in": "Anda bergerak di bidang apa?",
        "ss_builder_what_went_wrong": "Hal apa yang salah?",
        "ss_builder_width_tab_setting_label": "Tab width",
        "ss_builder_width_tab_type_1": "Auto",
        "ss_builder_width_tab_type_2": "Dibagi rata",
        "ss_builder_your_page_is_ready": "Halaman bio Anda sudah siap!",
        "ss_cancle_delete": "Cancel",
        "ss_challenge": "Dare",
        "ss_confirm_delete": "Confirm delete",
        "ss_content_confirm_delete": "Are you sure you want to delete this product?",
        "ss_content_delete_forever": "Untuk menghapus produk, silakan kembali ke halaman manajemen produk",
        "ss_content_intro_dp": "Digital products are understood as online products, not grasped, containing useful content for users. For example: Video, photos, ebook, online course, ..",
        "ss_content_item1_dp": "Depending on your strengths and desires, Passio offers a full range of digital products such as photos, videos, online courses, ebooks, links, ...",
        "ss_content_item2_dp": "With less than 3 minutes, you can configure and sell a new digital product. Moreover, after the buyer successfully buys, the product will be sent immediately to their email, helping to simplify shipping and save time",
        "ss_content_success_TOD": "Fitur Truth Or Dare sudah aktif!",
        "ss_cover_image": "Cover image",
        "ss_cover_image_empty": "Belum ada gambar yang dipilih",
        "ss_cover_image_helper": "Dukung: JPG, JPEG, GIF, PNG, BMP, WebP, maksimal 4MB",
        "ss_cover_image_upload": "Upload gambar",
        "ss_delete_forever": "Dihapus secara permanen",
        "ss_delete_product": "Delete display",
        "ss_display_delete": "Delete display",
        "ss_donation_currency_shortcut": "Rp",
        "ss_donation_setting_default_content_setup_donation": "Layanan ini sedang diatur secara default. Jika Anda ingin mengubah, silakan kunjungi layanan Donasi di account.passio.eco",
        "ss_donation_setting_default_title_setup_donation": "Pengaturan layanan",
        "ss_dp_add": "Add",
        "ss_dp_cat_course": "Kursus",
        "ss_dp_cat_ebook_document": "Ebook/Document",
        "ss_dp_cat_online_consultion": "Online consulting 1-1",
        "ss_dp_cat_random_product": "Products any",
        "ss_dp_cat_ticket_account": "Tiket/Akun",
        "ss_dp_cat_video": "Exclusive video",
        "ss_dp_sell_photo": "Gambar",
        "ss_edit_TOD": "Edit",
        "ss_example_TOD": "Contoh: RP.100000",
        "ss_exit_TOD": "Batalkan",
        "ss_first_person": "Jadilah yang pertama untuk menantang sekarang!",
        "ss_gift_button_preview": "Kirim hadiah sekarang!",
        "ss_gift_invitation": "Motivasikan {user} dengan mengirimkannya hadiah untuk dia lebih semangat!",
        "ss_had": "Sudah ada",
        "ss_iframe_add_new_product": "Tambahkan produk baru",
        "ss_iframe_add_product": "Tambahkan produk",
        "ss_iframe_choose_product_from_store": "Pilih dari Gudang Data",
        "ss_inline_image_empty": "Sekolah ini tidak diizinkan pergi",
        "ss_inline_txtbtn_max_length": "Sekolah ini melebihi 40 karakter.",
        "ss_input_placehoder": "Isi konten",
        "ss_invitation_TOD": "Penawaran konten untuk melakukan tantangan",
        "ss_invitation_TOD_placeholder": "Masukkan Konten Undang Penggemar untuk Bergabung",
        "ss_logout": "Keluar",
        "ss_modal_cancel_confirm": "Membatalkan",
        "ss_modal_text_confirm": "Pergi ke halaman Administrasi",
        "ss_no": "Tidak",
        "ss_placeholder_message_TOD": "Masukkan konten tantangan",
        "ss_preview_TOD": "Lanjut",
        "ss_profile": "Mengajukan",
        "ss_push_TOD": "Unggah",
        "ss_rount_tod": "Tantangan",
        "ss_service_introduction": "Perkenalkan Layanan",
        "ss_setting_TOD_background_tooltip": "Pilih gambar latar belakang dengan rasio 3: 2 dan kapasitas maksimum 4 MB",
        "ss_setting_TOD_field_image_background": "Tambahkan wallpaper",
        "ss_setting_TOD_field_image_background_bottom": "Gambar latar belakang",
        "ss_setting_TOD_field_welcome_tooltip": "Kalimat ajakan untuk penggemar yang memberi tantangan otomatis terisi di sistem.",
        "ss_setup_now": "Set now",
        "ss_shoutout_btn_content": "Konten tombol",
        "ss_shoutout_change_file": "Ubah foto/video",
        "ss_shoutout_create_request": "Buat segera",
        "ss_shoutout_description": "Menggambarkan",
        "ss_shoutout_description_placeholder": "Masukkan konten Pendahuluan",
        "ss_shoutout_error_price_required": "Harap masukkan harganya",
        "ss_shoutout_error_upload": "Kesalahan terjadi, kegagalan yang diunggah",
        "ss_shoutout_error_video_size": "Harap unggah gambar/ video hingga 500MB",
        "ss_shoutout_error_video_type": "Harap unggah ke file sebagai salah satu dari JPG, JPEG, GIF, PNG, BMP, Webp, Heic, Heic, HEIC, MP4, MOV",
        "ss_shoutout_file_intro": "PENDAHULUAN FOTO/VIDEO",
        "ss_shoutout_file_intro_note": "Unggah gambar atau video untuk menghubungi penggemar untuk menggunakan video Shoutout dari Anda",
        "ss_shoutout_no_file_selected": "Tidak ada foto/video yang dipilih",
        "ss_shoutout_price": "Harga",
        "ss_shoutout_price_placeholder": "Masukkan harga",
        "ss_shoutout_select_file": "Pilih foto/video",
        "ss_shoutout_type_support": "Dukungan: JPG, JPEG, GIF, PNG, BMP, Webp, Heif, HEIC, MP4, MOV hingga 500MB",
        "ss_shoutout_upload_success": "Unggah video ke Success",
        "ss_success_TOD": "Sukses",
        "ss_success_off_TOD": "Anda telah mematikan fitur Truth Or Dare.",
        "ss_success_on_TOD": "Anda telah membuka fitur Truth Or Dare",
        "ss_success_setup_TOD": "Anda telah berhasil membuka fitur Truth Or Dare.",
        "ss_title_intro_dp": "What is digital product",
        "ss_title_item1_dp": "Diverse types of products for you to choose",
        "ss_title_item2_dp": "Easy to manage products and orders with a few operations",
        "ss_tod_challenge_number": "id_S\u1ED1 th\u1EED th\xe1ch",
        "ss_tod_content": "Selamat datang konten",
        "ss_tod_dare_content": "Ajak para penggemar untuk kasih tantangan",
        "ss_tod_dare_fee": "Jumlah minimum yang dibayar fans untuk Dare",
        "ss_tod_default_content": "Tantang aku!",
        "ss_tod_default_dare_content": "Berani main denganku? Coba sekarang!",
        "ss_tod_min_price_dare_alias": "S\u1ED1 ti\u1EC1n t\u1ED1i thi\u1EC3u fan thanh to\xe1n \u0111\u01A1n Dare_id",
        "ss_tod_min_price_dare_note": "Pembayaran minimum adalah 1,000",
        "ss_tod_setting_cover_image": "Cover image",
        "ss_tod_setting_cover_image_helper": "Dukung: JPG, JPEG, GIF, PNG, BMP, WebP, maksimal 4MB",
        "ss_tod_setting_field_welcome_tooltip": "Kalimat ajakan untuk penggemar yang memberi tantangan otomatis terisi di sistem.",
        "ss_tod_setting_input_placehoder": "Isi konten",
        "ss_tod_tooltip_content": "Konten penawaran terbatas maksimum 60 karakter.",
        "ss_tod_tooltip_min_price_dare": "Selamat datang konten termasuk maksimal 60 huruf",
        "ss_txt_btn_TOD": "Ajak penggemar untuk memberi tantangan",
        "ss_validate_domain_error_E1": "Nama domain telah diubah dalam waktu 30 hari, tidak dapat diubah",
        "ss_validate_domain_error_E2": "Nama domain sudah ada, silakan coba yang lain",
        "ss_validate_domain_error_E3": "Domain ini dilarang",
        "ss_validate_origin_url_error_E203": "Nama domain ini tidak dapat ditemukan. Harap periksa dan coba lagi.",
        "ss_validate_origin_url_error_E5": "Anda tidak disetujui untuk bergabung dengan kampanye ini, harap minta persetujuan",
        "ss_validate_origin_url_error_E6": "Anda tidak diperbolehkan untuk berpartisipasi dalam kampanye ini, silakan hubungi staf pendukung",
        "ss_validate_origin_url_error_E7": "URL ini tidak didukung",
        "ss_validate_origin_url_error_E9": "Kampanye telah berakhir, silakan pilih URL lain",
        "ss_validate_origin_url_error_V0": "URL tidak valid",
        "ss_validate_origin_url_error_sys": "Harap masukkan URL yang valid",
        "ss_validate_origin_url_warning_E5": "Anda belum disetujui untuk kampanye ini. Order dan Komisi tidak akan terhitung",
        "ss_validate_origin_url_warning_E7": "URL ini tidak didukung. Order dan komisi tidak akan terhitung.",
        "ss_validate_origin_url_warning_E9": "Kampanye telah berakhir. Order dan Komisi tidak akan terhitung.",
        "text_cashback_brand_gift": "Cashback",
        "text_custom_brand_gift": "Customize",
        "text_voucher_brand_gift": "Voucher",
        "undefined": "Undefined",
        "voucher_default_text_button": "Dapatkan voucher sekarang!",
        "voucher_default_title": "Klik bayar, cashback 5%",
        "warning_text_TOD": "Pengaturan Anda belum disimpan. Apakah Anda masih ingin membatalkan?",
        "warning_text_switch_TOD": "Apakah Anda ingin mematikan truth or dare?"
    }
};
/* harmony default export */ var messages_id = (id);

;// CONCATENATED MODULE: ./src/messages/th.ts
var th = {
    translation: {
        "button_confirm_exit_TOD": "\u0E2D\u0E2D\u0E01",
        "button_confirm_off_TOD": "\u0E1B\u0E34\u0E14",
        "button_title_default_donation": "\u0E42\u0E14\u0E40\u0E19\u0E17 \uD83D\uDCB5 \u0E43\u0E2B\u0E49 {name} \u0E19\u0E49\u0E32\u0E32\u0E32",
        "cashback_default_text_button": "\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19\u0E17\u0E31\u0E19\u0E17\u0E35!",
        "cashback_default_title": "\u0E0A\u0E49\u0E2D\u0E1B\u0E2A\u0E19\u0E38\u0E01 \u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E38\u0E14\u0E46",
        "cm_home": "\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01",
        "default_content_setup_brand_gift": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2D\u0E07",
        "default_content_setup_donation": "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E42\u0E14\u0E40\u0E19\u0E17\u0E17\u0E35\u0E48 account.passio.eco",
        "default_title_setup_brand_gift": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "default_title_setup_donation": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "error_thumbnail_size_TOD": "\u0E04\u0E27\u0E32\u0E21\u0E08\u0E38\u0E20\u0E32\u0E1E\u0E21\u0E32\u0E01\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B",
        "invitation_default_donation": "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E19\u0E23\u0E31\u0E01 {name}?",
        "label_tab_bar_brand_gift": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "label_text_button_brand_gift": "\u0E1B\u0E38\u0E48\u0E21",
        "label_text_title_brand_gift": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "login": "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
        "message_default_donation": "\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 {name} \u0E2B\u0E27\u0E31\u0E07\u0E27\u0E48\u0E32\u0E40\u0E23\u0E32\u0E08\u0E30\u0E21\u0E35\u0E42\u0E2D\u0E01\u0E32\u0E2A\u0E40\u0E08\u0E2D\u0E01\u0E31\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E19\u0E49\u0E32\u0E32\u0E32!",
        "placeholder_text_button_brand_gift": "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E1B\u0E38\u0E48\u0E21",
        "placeholder_text_title_brand_gift": "\u0E01\u0E23\u0E2D\u0E01\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_background_TOD": "\u0E23\u0E39\u0E1B\u0E2B\u0E19\u0E49\u0E32\u0E1B\u0E01",
        "ss_brand_cpc_bonus": "th_Hoa h\u1ED3ng",
        "ss_brand_cpc_campaign_title": "th_Nh\u1EADn hoa h\u1ED3ng",
        "ss_brand_cpc_description": "th_M\xf4 t\u1EA3 ch\u01B0\u01A1ng tr\xecnh",
        "ss_brand_cpc_download": "th_T\u1EA3i xu\u1ED1ng",
        "ss_brand_cpc_from": "th_T\u1EEB",
        "ss_brand_cpc_join": "th_Tham gia",
        "ss_brand_cpc_join_now": "th_Tham kh\u1EA3o ngay",
        "ss_brand_cpc_join_successfully_label": "th_B\u1EA1n \u0111\xe3 tham gia ch\u01B0\u01A1ng tr\xecnh th\xe0nh c\xf4ng",
        "ss_brand_cpc_no_access_allow": "th_B\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p truy c\u1EADp v\xe0o link n\xe0y",
        "ss_brand_cpc_notice": "th_L\u01B0u \xfd",
        "ss_brand_cpc_notice_content": "th_Hoa h\u1ED3ng s\u1EBD \u0111\u01B0\u1EE3c tr\u1EA3 v\u1EC1 t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n sau 7 ng\xe0y k\u1EC3 t\u1EEB khi \u0111\u01B0\u1EE3c nghi\u1EC7m thu.",
        "ss_brand_cpc_reject": "th_\u1EA2nh nghi\u1EC7m thu c\u1EE7a b\u1EA1n \u0111\xe3 b\u1ECB t\u1EEB ch\u1ED1i. B\u1EA1n c\xf3 th\u1EC3 t\u1EA3i l\u1EA1i \u1EA3nh.",
        "ss_brand_cpc_requirement": "th_Y\xeau c\u1EA7u",
        "ss_brand_cpc_step_1": "th_B\u01B0\u1EDBc 1: T\u1EA3i \u1EA3nh d\u01B0\u1EDBi \u0111\xe2y v\u1EC1 v\xe0 up l\xean 1 n\u1EC1n t\u1EA3ng m\u1EA1ng x\xe3 h\u1ED9i.",
        "ss_brand_cpc_step_1_note": "th_L\u01B0u \xfd: up \u1EA3nh trong kho\u1EA3ng th\u1EDDi gian",
        "ss_brand_cpc_step_2": "th_B\u01B0\u1EDBc 2: T\u1EA3i \u1EA3nh nghi\u1EC7m thu (\u1EA3nh ch\u1EE5p m\xe0n h\xecnh b\xe0i \u0111\u0103ng c\u1EE7a b\u1EA1n \u1EDF b\u01B0\u1EDBc 1)",
        "ss_brand_cpc_step_2_note": "th_L\u01B0u \xfd: \u1EA3nh nghi\u1EC7m thu th\u1EC3 hi\u1EC7n th\u1EDDi gian \u0111\xe3 \u0111\u0103ng \u1EA3nh t\u1ED1i thi\u1EC3u l\xe0 12h. VD: \u1EA2nh ch\u1EE5p m\xe0n h\xecnh story \u0111\xe3 \u0111\u0103ng 12h tr\u01B0\u1EDBc tr\u1EDF l\xean.",
        "ss_brand_cpc_success": "th_\u0110\xe3 nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_text_content": "th_\u0111ang g\u1EEDi cho b\u1EA1n 01 l\u1EDDi \u0111\u1EC1 ngh\u1ECB tham gia v\xe0o ch\u01B0\u01A1ng tr\xecnh treo banner - nh\u1EADn ti\u1EC1n th\u01B0\u1EDFng.",
        "ss_brand_cpc_text_title": "th_Nh\u1EADn ti\u1EC1n d\u1EC5 d\xe0ng c\xf9ng",
        "ss_brand_cpc_time": "th_Th\u1EDDi gian",
        "ss_brand_cpc_time_end": "th_Th\u1EDDi gian k\u1EBFt th\xfac",
        "ss_brand_cpc_time_start": "th_Th\u1EDDi gian b\u1EAFt \u0111\u1EA7u",
        "ss_brand_cpc_to": "th_\u0110\u1EBFn",
        "ss_brand_cpc_upload_image": "th_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_cpc_upload_image_button": "th_T\u1EA3i \u1EA3nh l\xean",
        "ss_brand_cpc_upload_image_successfully": "th_B\u1EA1n \u0111\xe3 g\u1EEDi \u1EA3nh nghi\u1EC7m thu th\xe0nh c\xf4ng",
        "ss_brand_cpc_upload_image_title": "th_T\u1EA3i \u1EA3nh nghi\u1EC7m thu",
        "ss_brand_gift_cancel_hide": "th_H\u1EE7y b\u1ECF",
        "ss_brand_gift_confirm_hide_brand": "th_X\xe1c nh\u1EADn",
        "ss_brand_gift_confirm_hide_group": "th_X\xe1c nh\u1EADn \u1EA9n nh\xf3m",
        "ss_brand_gift_disable_deal_successfully": "th_\u1EA8n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_disable_successfully": "th_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_display_hide_brand": "th_\u1EA8n Deal",
        "ss_brand_gift_display_hide_category": "th_\u1EA8n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_display_show_brand": "th_Hi\u1EC7n Deal",
        "ss_brand_gift_display_show_category": "th_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_empty_title": "th_Ch\u01B0a c\xf3 s\u1EA3n ph\u1EA9m n\xe0o",
        "ss_brand_gift_enable_deal_successfully": "th_Hi\u1EC7n Deal th\xe0nh c\xf4ng",
        "ss_brand_gift_enable_successfully": "th_Hi\u1EC7n nh\xf3m s\u1EA3n ph\u1EA9m th\xe0nh c\xf4ng",
        "ss_brand_gift_hide_brand": "th_B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n Deal?",
        "ss_brand_gift_hide_brand_content": "th_Deal {{name}} s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB \u1EDF giao di\u1EC7n c\u1EE7a Fan. B\u1EA1n c\xf3 mu\u1ED1n \u1EA9n deal n\xe0y?",
        "ss_brand_gift_hide_category": "th_B\u1EA1n mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_hide_category_content": "th_Nh\xf3m {{name}} v\xe0 to\xe0n b\u1ED9 d\u1EEF li\u1EC7u c\u1EE7a c\xe1c s\u1EA3n ph\u1EA9m b\xean trong s\u1EBD b\u1ECB \u1EA9n. B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n \u1EA9n nh\xf3m?",
        "ss_brand_gift_list_category": "th_Danh s\xe1ch nh\xf3m s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_list_empty_content": "th_Hi\u1EC7n gi\u1EDD Admin ch\u01B0a setup d\u1EEF li\u1EC7u s\u1EA3n ph\u1EA9m",
        "ss_brand_gift_setting_cashback_default_text_button": "\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19\u0E17\u0E31\u0E19\u0E17\u0E35!",
        "ss_brand_gift_setting_cashback_default_title": "\u0E0A\u0E49\u0E2D\u0E1B\u0E2A\u0E19\u0E38\u0E01 \u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E38\u0E14\u0E46",
        "ss_brand_gift_setting_default_content_setup": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2D\u0E07",
        "ss_brand_gift_setting_float_icon_description": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E0F\u0E34\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E01\u0E31\u0E1A\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_brand_gift_setting_float_icon_footer_description": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E0F\u0E34\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E01\u0E31\u0E1A\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_brand_gift_setting_label_tab_bar_brand_gift": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_brand_gift_setting_label_text_button": "\u0E1B\u0E38\u0E48\u0E21",
        "ss_brand_gift_setting_label_text_title_brand_gift": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_brand_gift_setting_placeholder_text_button": "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E1B\u0E38\u0E48\u0E21",
        "ss_brand_gift_setting_placeholder_text_title": "\u0E01\u0E23\u0E2D\u0E01\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_brand_gift_setting_text_cashback_brand_gift": "Cashback",
        "ss_brand_gift_setting_text_custom_brand_gift": "\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07",
        "ss_brand_gift_setting_text_voucher_brand_gift": "Voucher",
        "ss_brand_gift_setting_title_block_footer": "\u0E44\u0E2D\u0E04\u0E2D\u0E19 Brand Gift",
        "ss_brand_gift_setting_voucher_default_text_button": "\u0E23\u0E31\u0E1A\u0E40\u0E27\u0E32\u0E40\u0E0A\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49!",
        "ss_brand_gift_setting_voucher_default_title": "\u0E41\u0E15\u0E30\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E48\u0E32\u0E22 \u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19 5%",
        "ss_brand_rating_setting_default_content_setup_donation": "th_Danh s\xe1ch c\xe1c ch\u01B0\u01A1ng tr\xecnh ho\xe0n ti\u1EC1n gi\u1EA3m gi\xe1 d\xe0nh cho fan c\u1EE7a b\u1EA1n. B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 nh\u1EADn hoa h\u1ED3ng ngay!",
        "ss_build_collapse_block_label": "\u0E22\u0E48\u0E2D",
        "ss_build_expand_block_label": "\u0E02\u0E22\u0E32\u0E22",
        "ss_build_no_blocks_have_been_added": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builde_theme_setting_block": "\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_1st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block.",
        "ss_builder_1st_block_preview_sample_title": "Block 1",
        "ss_builder_2st_block_preview_sample_description": "Here is the example content of block, you can see how the fonts and colors are displayed in the block. 2nd block to see the spacing between blocks.",
        "ss_builder_2st_block_preview_sample_title": "Block 2",
        "ss_builder_add_affiliate_product_list_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E35\u0E01",
        "ss_builder_add_block_body_title": "Body",
        "ss_builder_add_block_expand_title": "\u0E02\u0E22\u0E32\u0E22",
        "ss_builder_add_block_footer_title": "Footer",
        "ss_builder_add_block_header_title": "Header",
        "ss_builder_add_block_in_template": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_add_block_in_template_successfully": "Add block template successfully",
        "ss_builder_add_block_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_add_block_to": "\u0E41\u0E2D\u0E14\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E02\u0E49\u0E32\u0E44\u0E1B\u0E22\u0E31\u0E07:",
        "ss_builder_add_image_of_image_popup_tilte": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_add_new_affiliate_product_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_add_new_affiliate_product_group_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_add_new_affiliate_product_image_title": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_add_new_affiliate_product_list_empty_content": "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48 url \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_add_new_affiliate_product_name_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_add_new_affiliate_product_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_add_new_block_successfully_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E2B\u0E21\u0E48\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_add_new_image": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E20\u0E32\u0E1E\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_add_new_image_of_image_popup_title": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_add_new_image_of_image_slider_title": "\u0E20\u0E32\u0E1E",
        "ss_builder_add_new_image_popup_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21",
        "ss_builder_add_new_image_slider_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E20\u0E32\u0E1E",
        "ss_builder_add_new_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21",
        "ss_builder_add_new_product_group_successfully_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_add_new_tab_successfully_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21 Tab \u0E43\u0E2B\u0E21\u0E48\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_add_new_tag_error_duplicate": "\u0E41\u0E17\u0E47\u0E01\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_add_new_template_btn_label": "Save",
        "ss_builder_add_new_template_image_title": "\u0E23\u0E39\u0E1B\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_add_new_template_label": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_add_new_template_name_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_add_new_template_name_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_add_new_theme_btn_label": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_add_new_theme_selection_panel_description": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07 Theme Store",
        "ss_builder_add_new_theme_selection_panel_label": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_add_new_theme_template_image_title": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_add_new_theme_template_name_placeholder": "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_add_new_theme_template_name_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_add_story": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_add_tab_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_added_product_url_label": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_advanced_group_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E41\u0E1A\u0E1A\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
        "ss_builder_advanced_setting": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
        "ss_builder_advanced_title": "\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
        "ss_builder_aff_frame_max_size_content": "\u0E02\u0E19\u0E32\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14: 30MB.",
        "ss_builder_aff_frame_select_from_library": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E44\u0E25\u0E1A\u0E23\u0E32\u0E23\u0E35",
        "ss_builder_aff_frame_support_type_file_content": "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E1F\u0E25\u0E4C: gif, png, svg",
        "ss_builder_affiliate_add_new_tour_content_step_1": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E07\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_affiliate_add_new_tour_content_step_2": "\u0E43\u0E2A\u0E48\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E44\u0E14\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_affiliate_add_new_tour_content_step_3": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E09\u0E25\u0E32\u0E01... \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49",
        "ss_builder_affiliate_add_new_tour_content_step_4": "\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E1E\u0E34\u0E48\u0E21\u201D \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E25\u0E07\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_affiliate_add_new_tour_title_step_1": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_add_new_tour_title_step_2": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_add_new_tour_title_step_3": "Product information",
        "ss_builder_affiliate_add_new_tour_title_step_4": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_affiliate_group_tour_content_step_1": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_affiliate_group_tour_content_step_2": "\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E25\u0E30\u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E15\u0E32\u0E21\u0E43\u0E08\u0E0A\u0E2D\u0E1A",
        "ss_builder_affiliate_group_tour_title_step_1": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_group_tour_title_step_2": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E14\u0E48\u0E27\u0E19",
        "ss_builder_affiliate_product_btn_see_more_placeholder": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_affiliate_product_btn_see_more_title": "\u0E41\u0E2A\u0E14\u0E07\u0E1B\u0E38\u0E48\u0E21\u0E1B\u0E49\u0E32\u0E22\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        "ss_builder_affiliate_product_clean_up_popover_content": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E31\u0E27\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E15\u0E47\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19",
        "ss_builder_affiliate_product_cleanup_lock_label": "\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07",
        "ss_builder_affiliate_product_cleanup_unlock_label": "\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07",
        "ss_builder_affiliate_product_frame_panel_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E1F\u0E23\u0E21",
        "ss_builder_affiliate_product_group_add_new_panel_title": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_affiliate_product_group_list_selector_label": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_product_group_management_title": "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_product_group_other": "\u0E2D\u0E37\u0E48\u0E19",
        "ss_builder_affiliate_product_group_placeholder": "\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_affiliate_product_group_quantity_label": "{{product_quantity}} \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_product_group_quantity_warning_1": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49",
        "ss_builder_affiliate_product_group_quantity_warning_2": "\u0E40\u0E01\u0E34\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48",
        "ss_builder_affiliate_product_group_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_affiliate_product_image_popup_infomation_label": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E08\u0E30\u0E16\u0E39\u0E01\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E08\u0E32\u0E01\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E1E\u0E2D\u0E37\u0E48\u0E19\u0E44\u0E14\u0E49",
        "ss_builder_affiliate_product_label_product_discount": "\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32",
        "ss_builder_affiliate_product_label_product_hot": "Hot",
        "ss_builder_affiliate_product_label_product_like": "\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E2D\u0E1A",
        "ss_builder_affiliate_product_label_product_title": "\u0E09\u0E25\u0E32\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_product_list_empty_content": '\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19',
        "ss_builder_affiliate_product_list_empty_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_product_list_title": "List",
        "ss_builder_affiliate_product_moving_panel_title": "\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48",
        "ss_builder_affiliate_product_quantity_on_row_title": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E48\u0E2D\u0E41\u0E16\u0E27",
        "ss_builder_affiliate_product_searching_placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E32\u0E21\u0E0A\u0E37\u0E48\u0E2D",
        "ss_builder_affiliate_product_style_title": "\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_affiliate_setting_popover_manual_content": "\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49 Block Affiliate \u0E40\u0E23\u0E32\u0E21\u0E32\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u201D \u0E01\u0E31\u0E19",
        "ss_builder_affiliate_setting_popover_manual_title": "Product tour",
        "ss_builder_affiliate_setting_tour_content_step_1": "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E40\u0E0A\u0E48\u0E19 \u0E0B\u0E48\u0E2D\u0E19/\u0E41\u0E2A\u0E14\u0E07 \u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_affiliate_setting_tour_content_step_2": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E15\u0E32\u0E21\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_affiliate_setting_tour_content_step_3": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E25\u0E30\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E1B\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "ss_builder_affiliate_setting_tour_content_step_4": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E1A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E46 \u0E41\u0E1F\u0E19\u0E46 \u0E08\u0E30\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E41\u0E25\u0E30\u0E01\u0E23\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E32\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22 \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 \u0E40\u0E2A\u0E37\u0E49\u0E2D\u0E1C\u0E49\u0E32 \u0E23\u0E2D\u0E07\u0E40\u0E17\u0E49\u0E32 \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E14\u0E31\u0E1A...",
        "ss_builder_affiliate_setting_tour_content_step_5": "\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E25\u0E30\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E20\u0E32\u0E22\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_affiliate_setting_tour_content_step_6": '\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E25\u0E07\u0E43\u0E19\u0E41\u0E15\u0E48\u0E25\u0E30\u0E01\u0E25\u0E38\u0E48\u0E21\u0E42\u0E14\u0E22\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21"',
        "ss_builder_affiliate_setting_tour_content_step_7": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E14\u0E48\u0E27\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E25\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_affiliate_setting_tour_content_step_8": "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E41\u0E01\u0E49\u0E44\u0E02 \u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E25\u0E07\u0E43\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E43\u0E2B\u0E49\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u201D \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u201C\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u201D",
        "ss_builder_affiliate_setting_tour_title_step_1": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E14\u0E48\u0E27\u0E19",
        "ss_builder_affiliate_setting_tour_title_step_2": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_builder_affiliate_setting_tour_title_step_3": "\u0E01\u0E32\u0E23\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_setting_tour_title_step_4": "\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_setting_tour_title_step_5": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_setting_tour_title_step_6": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_setting_tour_title_step_7": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_setting_tour_title_step_8": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_affiliate_upload_product_error_content": "\u0E44\u0E1F\u0E25\u0E4C\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1F\u0E25\u0E4C json \u0E41\u0E25\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_affiliate_upload_product_error_label": "\u0E44\u0E1F\u0E25\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_affiliate_upload_product_label": "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_all_setting_and_product": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E41\u0E25\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E20\u0E32\u0E22\u0E43\u0E19",
        "ss_builder_all_the_blocks_are_in_your_list_by_the_blocks_of_the_template": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E08\u0E32\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_allowed_domain_label": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49",
        "ss_builder_an_unexpected_error_has_occurred": "\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E04\u0E32\u0E14\u0E04\u0E34\u0E14\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19.",
        "ss_builder_apply_preview_theme_template_btn_label": "\u0E43\u0E0A\u0E49",
        "ss_builder_apply_template_successfully_label": "\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_apply_template_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_apply_theme_premium_warning": "\u0E18\u0E35\u0E21\u0E19\u0E35\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E41\u0E2D\u0E04\u0E40\u0E04\u0E32\u0E17\u0E4C\u0E17\u0E35\u0E48\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E19\u0E35\u0E49",
        "ss_builder_apply_theme_premium_warning_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E18\u0E35\u0E21\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_apply_theme_template_successfully_label": "\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_auto_cleanup_products_warning_content_1": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E01\u0E34\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49 \u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_auto_cleanup_products_warning_content_2": "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E2B\u0E21\u0E14 \u201C\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u201D \u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_back": "\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A",
        "ss_builder_background_block": "\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_background_enable_overlay": "\u0E01\u0E32\u0E23\u0E04\u0E38\u0E21\u0E42\u0E17\u0E19",
        "ss_builder_background_opacity": "\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1A\u0E25\u0E2D",
        "ss_builder_background_overlay_color": "\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E35\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E1E",
        "ss_builder_background_popover_manual_content": "\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07 \u0E40\u0E23\u0E32\u0E21\u0E32\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u201D \u0E01\u0E31\u0E19",
        "ss_builder_background_popover_manual_title": "Product tour",
        "ss_builder_background_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_background_tour_content_step_1": "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07 \u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E43\u0E14\u0E46",
        "ss_builder_background_tour_content_step_2": '\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49 "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E" \u0E2B\u0E23\u0E37\u0E2D "\u0E2A\u0E35" \u0E14\u0E49\u0E27\u0E22\u0E2A\u0E35 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35 "\u0E17\u0E36\u0E1A" \u0E2B\u0E23\u0E37\u0E2D "\u0E44\u0E25\u0E48\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E2A\u0E35"',
        "ss_builder_background_tour_title_step_1": "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_background_tour_title_step_2": "\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E15\u0E32\u0E21\u0E20\u0E32\u0E1E\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35",
        "ss_builder_basic_group_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E41\u0E1A\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19",
        "ss_builder_basic_title": "\u0E02\u0E31\u0E49\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19",
        "ss_builder_bio_add_social_link_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25",
        "ss_builder_bio_avatar_title": "\u0E23\u0E39\u0E1B\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
        "ss_builder_bio_layout_title": "\u0E40\u0E25\u0E22\u0E4C\u0E40\u0E2D\u0E32\u0E15\u0E4C",
        "ss_builder_bio_name_sub_placeholder": "Enter the sub title",
        "ss_builder_bio_name_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "ss_builder_bio_name_title_placeholder": "Enter the display name",
        "ss_builder_bio_social_link_btn_select_icon_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_bio_social_link_icon_title": "\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_bio_social_link_url_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C Url",
        "ss_builder_bio_sub_title": "\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22",
        "ss_builder_bio_text_title": "\u0E44\u0E1A\u0E42\u0E2D",
        "ss_builder_block_affiliate_description": "\u0E41\u0E19\u0E30\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 Affiliate \u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_background_blur": "\u0E40\u0E1A\u0E25\u0E2D",
        "ss_builder_block_background_color": "\u0E2A\u0E35\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_block_bio_description": "\u0E23\u0E39\u0E1B\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E35\u0E27\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34 \u0E41\u0E25\u0E30\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_block_card_description": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E32\u0E14\u0E2B\u0E25\u0E32\u0E22\u0E41\u0E25\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E31\u0E14\u0E44\u0E14\u0E49",
        "ss_builder_block_booking_file_alert_content": "\u0E42\u0E1B\u0E23\u0E14\u0E2A\u0E23\u0E49\u0E32\u0E07 Booking Profile \u0E01\u0E48\u0E2D\u0E19\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "ss_builder_block_booking_file_alert_title": "\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07 Booking Profile",
        "ss_builder_block_booking_file_button_label_default": "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19",
        "ss_builder_block_booking_file_label": "Booking Profile url",
        "ss_builder_block_booking_file_link_tooltip": "Booking Profile \u0E08\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49",
        "ss_builder_block_booking_file_switch_tooltip": "\u0E41\u0E2A\u0E14\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C Booking Profile \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32 Bio",
        "ss_builder_block_booking_profile_button_label": "\u0E1B\u0E38\u0E48\u0E21\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C",
        "ss_builder_block_booking_profile_setting_description": "\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_builder_block_booking_profile_setting_title": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_block_border_color": "\u0E2A\u0E35\u0E02\u0E2D\u0E1A",
        "ss_builder_block_border_style": "\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_block_brand_gift_description": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E0F\u0E34\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E01\u0E31\u0E1A\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_brand_gift_footer_description": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E0F\u0E34\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E01\u0E31\u0E1A\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_button_link_description": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E14\u0E35\u0E22\u0E27\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E40\u0E27\u0E47\u0E1B\u0E44\u0E0B\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15",
        "ss_builder_block_button_multi_description": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2B\u0E25\u0E32\u0E22\u0E1B\u0E38\u0E48\u0E21\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E40\u0E27\u0E47\u0E1B\u0E44\u0E0B\u0E15\u0E4C\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E40\u0E19\u0E47\u0E15",
        "ss_builder_block_button_story_description": "\u0E41\u0E2A\u0E14\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E42\u0E14\u0E40\u0E14\u0E48\u0E19\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_block_combined_description": "\u0E23\u0E27\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01\u0E21\u0E32\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19",
        "ss_builder_block_combined_description_label": "\u0E23\u0E27\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01\u0E21\u0E32\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19",
        "ss_builder_block_combined_description_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_block_combined_heading_label": "\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_description": "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_description_label": "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_builder_block_description_placeholder": "\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_block_design_hiding_label": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E0B\u0E48\u0E2D\u0E19\u0E2D\u0E22\u0E39\u0E48",
        "ss_builder_block_digital_product_description": "\u0E02\u0E32\u0E22 Digital Product \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19 Passio Page",
        "ss_builder_block_donation_description": "\u0E23\u0E31\u0E1A\u0E42\u0E14\u0E40\u0E19\u0E17\u0E08\u0E32\u0E01 Fan",
        "ss_builder_block_heading_label": "\u0E2B\u0E31\u0E27\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_heading_placeholder": "\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_block_image_description": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E02\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_image_embed_description": "\u0E1D\u0E31\u0E07\u0E17\u0E38\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E25\u0E07\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13: \u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D \u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 \u0E2F\u0E25\u0E2F",
        "ss_builder_block_image_gallery_description": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E40\u0E25\u0E22\u0E4C\u0E40\u0E2D\u0E32\u0E15\u0E4C\u0E41\u0E25\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E0B\u0E39\u0E21\u0E44\u0E14\u0E49",
        "ss_builder_block_image_popup_description": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E08\u0E30\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E41\u0E1A\u0E1A\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_image_slider_description": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E19\u0E42\u0E2B\u0E21\u0E14\u0E1B\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_block_is_hiding_label": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E0B\u0E48\u0E2D\u0E19\u0E2D\u0E22\u0E39\u0E48",
        "ss_builder_block_link_copy_successfully_label": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_block_list_combined_description": "\u0E23\u0E27\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01\u0E21\u0E32\u0E01\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19",
        "ss_builder_block_main_color": "\u0E2A\u0E35\u0E2B\u0E25\u0E31\u0E01",
        "ss_builder_block_outside_space": "\u0E23\u0E30\u0E22\u0E30\u0E2B\u0E48\u0E32\u0E07\u0E20\u0E32\u0E22\u0E19\u0E2D\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_rating_answer_1": "\u0E2D\u0E34\u0E19\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E40\u0E1F\u0E0B",
        "ss_builder_block_rating_answer_2": "\u0E40\u0E27\u0E25\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E1E\u0E08",
        "ss_builder_block_rating_answer_3": "\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C",
        "ss_builder_block_rating_answer_4": "\u0E0B\u0E31\u0E1E\u0E1E\u0E2D\u0E23\u0E4C\u0E15",
        "ss_builder_block_rating_answer_5": "\u0E2D\u0E37\u0E48\u0E19\u0E46",
        "ss_builder_block_rating_button_submit_rating": "\u0E2A\u0E48\u0E07\u0E04\u0E30\u0E41\u0E19\u0E19",
        "ss_builder_block_rating_button_title_open_popup": "\u0E2A\u0E48\u0E07\u0E04\u0E30\u0E41\u0E19\u0E19",
        "ss_builder_block_rating_content_rating": "\u0E1F\u0E35\u0E14\u0E41\u0E1A\u0E04\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_rating_content_rating_placeholder": "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E41\u0E19\u0E30\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A Passio Page",
        "ss_builder_block_rating_description": "\u0E08\u0E30\u0E14\u0E35\u0E21\u0E32\u0E01\u0E2B\u0E32\u0E01 Passio Page \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E30\u0E41\u0E19\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E04\u0E38\u0E13\u0E20\u0E32\u0E1E\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_block_rating_description_auto_show": "\u0E1F\u0E35\u0E14\u0E41\u0E1A\u0E04\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A Passio Page",
        "ss_builder_block_rating_description_star_1": "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E1E\u0E36\u0E07\u0E1E\u0E2D\u0E43\u0E08\u0E40\u0E1E\u0E23\u0E32\u0E30",
        "ss_builder_block_rating_description_star_2": "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E1E\u0E36\u0E07\u0E1E\u0E2D\u0E43\u0E08\u0E40\u0E1E\u0E23\u0E32\u0E30",
        "ss_builder_block_rating_description_star_3": "Passio Page \u0E04\u0E27\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07",
        "ss_builder_block_rating_description_star_4": "\u0E04\u0E38\u0E13\u0E1E\u0E36\u0E07\u0E1E\u0E2D\u0E43\u0E08\u0E01\u0E31\u0E1A",
        "ss_builder_block_rating_description_star_5": "\u0E04\u0E38\u0E13\u0E1E\u0E36\u0E07\u0E1E\u0E2D\u0E43\u0E08\u0E01\u0E31\u0E1A",
        "ss_builder_block_rating_star_1": "\u0E41\u0E22\u0E48",
        "ss_builder_block_rating_star_2": "\u0E40\u0E1A\u0E37\u0E48\u0E2D",
        "ss_builder_block_rating_star_3": "\u0E40\u0E09\u0E22\u0E46",
        "ss_builder_block_rating_star_4": "\u0E14\u0E35",
        "ss_builder_block_rating_star_5": "\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21",
        "ss_builder_block_rating_title": "\u0E04\u0E30\u0E41\u0E19\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_block_rating_toast_success_rating": "\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1F\u0E35\u0E14\u0E41\u0E1A\u0E04",
        "ss_builder_block_second_color": "\u0E2A\u0E35\u0E23\u0E2D\u0E07",
        "ss_builder_block_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_shadow_color": "\u0E2A\u0E35\u0E40\u0E07\u0E32",
        "ss_builder_block_space": "\u0E23\u0E30\u0E22\u0E30\u0E2B\u0E48\u0E32\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_block_spacer_and_divider_description": "Add spacer or divider between your blocks",
        "ss_builder_block_text_description": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E40\u0E02\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E08\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_block_text_see_more_btn_default_title": "\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        "ss_builder_block_truth_or_dare_description": "\u0E25\u0E38\u0E22\u0E01\u0E31\u0E19\u0E40\u0E25\u0E22\u0E01\u0E31\u0E25\u0E40\u0E01\u0E21 Truth or Dare",
        "ss_builder_block_truth_or_dare_footer_description": "\u0E41\u0E2A\u0E14\u0E07\u0E44\u0E2D\u0E04\u0E2D\u0E19 Truth or Dare \u0E17\u0E35\u0E48\u0E21\u0E38\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D",
        "ss_builder_block_virtual_gift_description": "\u0E40\u0E1B\u0E34\u0E14\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E08\u0E32\u0E01 Fan",
        "ss_builder_block_virtual_gift_footer_description": "\u0E41\u0E2A\u0E14\u0E07\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A Virtual Gift \u0E17\u0E35\u0E48\u0E21\u0E38\u0E21\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D",
        "ss_builder_blocks_general_settings_label": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E02\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_blocks_general_settings_popover_content": '\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49 "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E25\u0E47\u0E2D\u0E01" \u0E43\u0E19 "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32" \u0E02\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07',
        "ss_builder_blocks_label": "\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_blocks_list": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
        "ss_builder_blocks_list_empty_content": '\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19',
        "ss_builder_blocks_list_empty_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_body_description": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E1A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E2A\u0E48\u0E27\u0E19\u0E44\u0E14\u0E49",
        "ss_builder_body_introduction_description": '"Body" \u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E41\u0E25\u0E30\u0E44\u0E14\u0E49\u0E41\u0E1A\u0E48\u0E07\u0E2D\u0E2D\u0E01 \u0E19\u0E33\u0E17\u0E32\u0E07\u0E42\u0E14\u0E22\u0E41\u0E17\u0E47\u0E1A \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19: \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 ...',
        "ss_builder_body_introduction_title": "Body Position",
        "ss_builder_body_title": "Body",
        "ss_builder_bold": "\u0E2B\u0E19\u0E32",
        "ss_builder_booking_profile_style_1": "\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_booking_profile_style_2": "Embed code",
        "ss_builder_border_dash": "Dash",
        "ss_builder_border_dot": "Dot",
        "ss_builder_border_radius_label": "\u0E42\u0E04\u0E49\u0E07\u0E21\u0E19",
        "ss_builder_border_radius_style": "\u0E41\u0E1A\u0E1A\u0E42\u0E04\u0E49\u0E07\u0E21\u0E19",
        "ss_builder_border_solid": "Solid",
        "ss_builder_bottom_position_tab_label": "\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_box_icon_button_filter": "Filter",
        "ss_builder_box_icon_empty_search": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C",
        "ss_builder_box_icon_empty_searching_description": "\u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E14\u0E2D\u0E37\u0E48\u0E19\u0E46",
        "ss_builder_box_icon_filter_category_all": "\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
        "ss_builder_box_icon_filter_category_sub_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_box_icon_filter_category_title": "Filter",
        "ss_builder_box_icon_search_bar_placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E15\u0E32\u0E21\u0E0A\u0E37\u0E48\u0E2D...",
        "ss_builder_bp_apply_block_settings_instruction": "Turn off to display full screen width. Turn on to display by settings in Block Settings as normal blocks.",
        "ss_builder_bp_open_new_tab_instruction": "Turn on to show the icon to open a new tab in the right corner",
        "ss_builder_bp_open_new_tab_title": "Open new tab",
        "ss_builder_brand_gift_introduction_popup_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E2D\u0E04\u0E2D\u0E19 Brand Gift",
        "ss_builder_browser_opening_label": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
        "ss_builder_button_background_color": "\u0E2A\u0E35\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_button_border_color": "\u0E2A\u0E35\u0E40\u0E2A\u0E49\u0E19\u0E02\u0E2D\u0E1A",
        "ss_builder_button_border_width": "\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E19\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E02\u0E2D\u0E1A (px)",
        "ss_builder_button_close_introduction_service": "\u0E1B\u0E34\u0E14",
        "ss_builder_button_font_size": "\u0E02\u0E19\u0E32\u0E14 font (px)",
        "ss_builder_button_font_weight": "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E31\u0E01 font",
        "ss_builder_button_line_height": "\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07\u0E02\u0E2D\u0E07\u0E40\u0E2A\u0E49\u0E19",
        "ss_builder_button_link_content_title": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_button_link_description": "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_button_link_icon_btn_selection_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_button_link_icon_origin_url_label": "\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_button_link_icon_title": "\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_button_link_large_size_label": "\u0E43\u0E2B\u0E0D\u0E48",
        "ss_builder_button_link_middle_size_label": "\u0E01\u0E25\u0E32\u0E07",
        "ss_builder_button_link_not_enought_infomation": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D",
        "ss_builder_button_link_placeholder_content_title": "\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_button_link_size_selection_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E19\u0E32\u0E14",
        "ss_builder_button_link_small_size_label": "\u0E40\u0E25\u0E47\u0E01",
        "ss_builder_button_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1B\u0E38\u0E48\u0E21",
        "ss_builder_button_text_color": "\u0E2A\u0E35\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_button_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E1B\u0E38\u0E48\u0E21",
        "ss_builder_cancel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel-delete_block_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel-delete_image_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D",
        "ss_builder_cancel-delete_social_link_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel-delete_tab_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel-restore_theme_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel-set_default_tab_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_affiliate_product_group_add_new_panel_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_apply_theme_template_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_block_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_delete_aff_block_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_delete_card_modal_btn_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D",
        "ss_builder_cancel_delete_link_modal_btn_label": "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D",
        "ss_builder_cancel_delete_product_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_delete_theme_template_modal_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_edit_block_content": "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_cancel_edit_block_title": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_cancel_hide_product_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_image_slider_add_new_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_overwrite_theme_template_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_preview_theme_template_btn_label": "\u0E1B\u0E34\u0E14",
        "ss_builder_cancel_product_addition_modal_confirm_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E48\u0E2D",
        "ss_builder_cancel_product_addition_modal_description": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_cancel_product_addition_modal_title": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
        "ss_builder_cancel_replace_theme_template_btn_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_select_multi_items": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_theme_selection_panel_label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_cancel_upload_image": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E34\u0E01",
        "ss_builder_card_add_new_description_label": "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_builder_card_add_new_label": "\u0E09\u0E25\u0E32\u0E01",
        "ss_builder_card_add_new_subtitle_label": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E23\u0E2D\u0E07",
        "ss_builder_card_add_new_title_label": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_card_add_new_url_label": "Url",
        "ss_builder_card_additional_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_card_btn_content_label": "\u0E1B\u0E38\u0E48\u0E21\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C",
        "ss_builder_card_layout_alert_1": "\u0E40\u0E25\u0E22\u0E4C\u0E40\u0E2D\u0E32\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22 \u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E1B\u0E38\u0E48\u0E21",
        "ss_builder_card_layout_alert_2": "\u0E40\u0E25\u0E22\u0E4C\u0E40\u0E2D\u0E32\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22 \u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E1B\u0E38\u0E48\u0E21",
        "ss_builder_card_layout_label": "Layout",
        "ss_builder_card_layout_label_1": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E43\u0E15\u0E49\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E0A\u0E34\u0E14\u0E0B\u0E49\u0E32\u0E22",
        "ss_builder_card_layout_label_2": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E43\u0E15\u0E49\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E01\u0E36\u0E48\u0E07\u0E01\u0E25\u0E32\u0E07",
        "ss_builder_card_layout_label_3": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E01\u0E36\u0E48\u0E07\u0E01\u0E25\u0E32\u0E07",
        "ss_builder_card_layout_label_4": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E0A\u0E34\u0E14\u0E0B\u0E49\u0E32\u0E22",
        "ss_builder_card_layout_label_5": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32",
        "ss_builder_card_layout_label_6": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22",
        "ss_builder_card_layout_label_7": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E0A\u0E34\u0E14\u0E0B\u0E49\u0E32\u0E22 2",
        "ss_builder_card_layout_label_8": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E - \u0E08\u0E31\u0E14\u0E01\u0E36\u0E48\u0E07\u0E01\u0E25\u0E32\u0E07 2",
        "ss_builder_card_url_placeholder": "http://domain.com",
        "ss_builder_category_14_up": "14+",
        "ss_builder_category_all": "\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
        "ss_builder_category_art": "\u0E28\u0E34\u0E25\u0E1B\u0E30",
        "ss_builder_category_creative": "\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C",
        "ss_builder_category_doctor": "\u0E2B\u0E21\u0E2D",
        "ss_builder_category_education": "\u0E01\u0E32\u0E23\u0E28\u0E36\u0E01\u0E29\u0E32",
        "ss_builder_category_entertainment": "\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E40\u0E17\u0E34\u0E07",
        "ss_builder_category_fashion": "\u0E41\u0E1F\u0E0A\u0E31\u0E48\u0E19",
        "ss_builder_category_fitness": "\u0E1F\u0E34\u0E15\u0E40\u0E19\u0E2A",
        "ss_builder_category_food_fmcg": "\u0E2D\u0E32\u0E2B\u0E32\u0E23\u0E41\u0E25\u0E30\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E38\u0E1B\u0E42\u0E20\u0E04\u0E1A\u0E23\u0E34\u0E42\u0E20\u0E04",
        "ss_builder_category_game": "\u0E40\u0E01\u0E21",
        "ss_builder_category_health_and_beauty": "\u0E2A\u0E38\u0E02\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E07\u0E32\u0E21",
        "ss_builder_category_ict": "\u0E44\u0E2D\u0E0B\u0E35\u0E17\u0E35",
        "ss_builder_category_life_style": "\u0E44\u0E25\u0E1F\u0E4C\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_category_lifestyle": "\u0E44\u0E25\u0E1F\u0E4C\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_category_mom_and_kid": "\u0E41\u0E21\u0E48\u0E41\u0E25\u0E30\u0E40\u0E14\u0E47\u0E01",
        "ss_builder_category_others": "\u0E2D\u0E37\u0E48\u0E19",
        "ss_builder_category_pet": "\u0E2A\u0E31\u0E15\u0E27\u0E4C\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07",
        "ss_builder_category_spirit": "\u0E08\u0E34\u0E15\u0E27\u0E34\u0E0D\u0E0D\u0E32\u0E13",
        "ss_builder_change_image_button_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_change_name_product_group_successfully_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_change_theme_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E18\u0E35\u0E21",
        "ss_builder_choose_a_prototying_method": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_choose_at_least_category": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E23\u0E32\u0E08\u0E30\u0E41\u0E19\u0E30\u0E19\u0E33\u0E18\u0E35\u0E21\u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \uD83D\uDC47",
        "ss_builder_choose_image_below": '\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48" \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07',
        "ss_builder_choose_one_theme_preview_you_can_customize_it_later": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E0B\u0E36\u0E48\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E43\u0E0A\u0E49\u2728",
        "ss_builder_choose_the_look_that_right_for_you": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E18\u0E35\u0E21",
        "ss_builder_choose_this_template": "\u0E43\u0E0A\u0E49",
        "ss_builder_cleanup_lock_product_successfully_label": "\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_cleanup_unlock_product_successfully_label": "\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E49\u0E32\u0E07\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_close_panel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_close_panel_affiliate_product-selection-label": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_close_panel_edit_text_block": "\u0E1B\u0E34\u0E14",
        "ss_builder_collapse": "\u0E14\u0E39\u0E19\u0E49\u0E2D\u0E22\u0E25\u0E07",
        "ss_builder_color_1": "\u0E2A\u0E35\u0E17\u0E35\u0E48 1",
        "ss_builder_color_2": "\u0E2A\u0E35\u0E17\u0E35\u0E48 2",
        "ss_builder_color_picker_panel_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35",
        "ss_builder_confirm-cancel_image_slider_add_new_content": "\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E17\u0E33\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\n\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E48\u0E2D\u0E19\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm-cancel_image_slider_add_new_title": "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_confirm-delete_block_label": "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E07\u0E43\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A",
        "ss_builder_confirm-delete_block_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm-delete_image_label": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E08\u0E30\u0E25\u0E1A\u0E20\u0E32\u0E1E\u0E19\u0E35\u0E49\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm-delete_image_title": "\u0E25\u0E1A\u0E20\u0E32\u0E1E",
        "ss_builder_confirm-delete_social_link_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49",
        "ss_builder_confirm-delete_social_link_title": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22",
        "ss_builder_confirm_affiliate_product_group_add_new_panel_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_confirm_apply_template_description": "\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E08\u0E30\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_confirm_apply_template_label": "\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48",
        "ss_builder_confirm_apply_theme_template_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_apply_theme_template_content": "\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E30\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E23\u0E39\u0E1B\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C\u0E02\u0E2D\u0E07\u0E17\u0E31\u0E49\u0E07\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_confirm_apply_theme_template_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E18\u0E35\u0E21\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_cancel_image_slider_add_new_btn_label": "\u0E2D\u0E2D\u0E01",
        "ss_builder_confirm_cleanup_lock_product_btn_label": "Confirm to lock",
        "ss_builder_confirm_cleanup_lock_product_selection_modal_content": "Are you sure you want to lock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_cleanup_unlock_product_btn_label": "Confirm to unlock",
        "ss_builder_confirm_cleanup_unlock_product_selection_modal_content": "Are you sure you want to unlock {{product_quantity}} products cleanup?",
        "ss_builder_confirm_delete_aff_block_content": "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E49\u0E27\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E19\u0E35\u0E49\u0E08\u0E30\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_confirm_delete_aff_block_input_placeholder": "OK",
        "ss_builder_confirm_delete_aff_block_label_enter_ok": "\u0E01\u0E14 \u201COK\u201D \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_delete_aff_block_understood": "\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_confirm_delete_aff_block_warining": "\u0E04\u0E33\u0E40\u0E15\u0E37\u0E2D\u0E19",
        "ss_builder_confirm_delete_block_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A",
        "ss_builder_confirm_delete_card_modal_btn_label": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_confirm_delete_card_modal_description": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E43\u0E1A\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_card_modal_label": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_confirm_delete_combined_label": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_confirm_delete_image_popup_image_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A {{quantity}} \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_item_checkbox_button_multi_link_modal_title": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_confirm_delete_item_checkbox_card_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A {{quantity}} \u0E01\u0E32\u0E23\u0E4C\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_item_checkbox_card_modal_title": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_item_checkbox_combined_modal_title": "\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E08\u0E33\u0E19\u0E27\u0E19 {{quantity}} \u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_item_checkbox_image_gallery_modal_title": "\u0E25\u0E1A\u0E20\u0E32\u0E1E\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E48",
        "ss_builder_confirm_delete_item_checkbox_story_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E14\u0E48\u0E19 {{quantity}} \u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_item_checkbox_story_modal_title": "\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_confirm_delete_link_description": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_product_group_modal_description": '\u0E01\u0E25\u0E38\u0E48\u0E21 "{{group_name}}" \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48',
        "ss_builder_confirm_delete_product_group_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_delete_product_label": "\u0E25\u0E1A",
        "ss_builder_confirm_delete_product_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_product_modal_title": "\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_confirm_delete_product_selection_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A {{product_quantity}}  \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_delete_tab_label": "\u0E25\u0E1A",
        "ss_builder_confirm_delete_template_modal_content": "\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23 \u0E41\u0E15\u0E48\u0E01\u0E32\u0E23\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E19\u0E35\u0E49\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A",
        "ss_builder_confirm_delete_template_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_delete_theme_template_modal_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A",
        "ss_builder_confirm_delete_theme_template_modal_content": "\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23\u0E08\u0E32\u0E01 Theme Store \u0E17\u0E38\u0E01\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E18\u0E35\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A",
        "ss_builder_confirm_delete_theme_template_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E17\u0E02\u0E2D\u0E07\u0E18\u0E35\u0E21\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19 {{quantity}} \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_disable_item_checkbox_button_multi_link_modal_title": "\u0E0B\u0E48\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_confirm_disable_item_checkbox_card_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19 {{quantity}} \u0E01\u0E32\u0E23\u0E4C\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_disable_item_checkbox_card_modal_title": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_disable_item_checkbox_combined_modal_title": "\u0E0B\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19 {{quantity}} \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_disable_item_checkbox_image_gallery_modal_title": "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E43\u0E19\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35",
        "ss_builder_confirm_disable_item_checkbox_story_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19 {{quantity}} \u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_disable_item_checkbox_story_modal_title": "\u0E0B\u0E48\u0E2D\u0E19\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07 {{quantity}} \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_enable_item_checkbox_button_multi_link_modal_title": "\u0E42\u0E0A\u0E27\u0E4C\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_confirm_enable_item_checkbox_card_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E44\u0E2B\u0E21\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07 {{quantity}} \u0E01\u0E32\u0E23\u0E4C\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_enable_item_checkbox_card_modal_title": "\u0E42\u0E0A\u0E27\u0E4C\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_enable_item_checkbox_combined_modal_title": "\u0E41\u0E2A\u0E14\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07 {{quantity}} \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_enable_item_checkbox_image_gallery_modal_title": "\u0E41\u0E2A\u0E14\u0E07\u0E20\u0E32\u0E1E\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E48",
        "ss_builder_confirm_enable_item_checkbox_story_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07 {{quantity}} \u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_enable_item_checkbox_story_modal_title": "\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_confirm_enable_product_selection_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07 {{product_quantity}} \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_hide_product_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E48\u0E2D\u0E19",
        "ss_builder_confirm_hide_product_group_modal_description": '\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 "{{group_name}}" \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E30\u0E16\u0E39\u0E01\u0E0B\u0E48\u0E2D\u0E19\u0E44\u0E27\u0E49 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21',
        "ss_builder_confirm_hide_product_group_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_hide_product_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_confirm_hide_product_selection_modal_content": "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19 {{product_quantity}} \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_confirm_overwrite": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A",
        "ss_builder_confirm_overwrite_theme_template_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A",
        "ss_builder_confirm_overwrite_theme_template_modal_content": "\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A\u0E08\u0E30\u0E2A\u0E27\u0E21\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E14\u0E49\u0E27\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19",
        "ss_builder_confirm_overwrite_theme_template_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_confirm_panel": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_panel_affiliate_product-selection-label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_panel_edit_text_block": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_replace_theme_template_btn_label": "\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_confirm_replace_theme_template_content": "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E44\u0E14\u0E49 \n\u0E42\u0E1B\u0E23\u0E14\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E49\u0E27\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E08\u0E30\u0E41\u0E17\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_confirm_replace_theme_template_input_placeholder": "OK",
        "ss_builder_confirm_replace_theme_template_label_enter_ok": "\u0E01\u0E14 \u201COK\u201D \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_confirm_replace_theme_template_understood": "\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_confirm_replace_theme_template_warining": "\u0E04\u0E33\u0E40\u0E15\u0E37\u0E37\u0E2D\u0E19",
        "ss_builder_confirm_restore_theme_label": "\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_confirm_set_default_tab_label": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19",
        "ss_builder_confirm_show_product_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07",
        "ss_builder_confirm_theme_template_preview_mode_btn_label": "\u0E43\u0E0A\u0E49",
        "ss_builder_confirm_to_edit_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D",
        "ss_builder_content_1_introduction_service": "Brand Gift \u0E40\u0E1B\u0E47\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22 \u0E40\u0E2A\u0E19\u0E2D\u0E14\u0E35\u0E25\u0E2A\u0E38\u0E14\u0E1E\u0E34\u0E40\u0E28\u0E29\u0E08\u0E32\u0E01\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E43\u0E2B\u0E49\u0E41\u0E01\u0E48\u0E41\u0E1F\u0E19\u0E46/\u0E1C\u0E39\u0E49\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E01\u0E32\u0E23\u0E40\u0E01\u0E34\u0E14\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D \u0E41\u0E25\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49 Creators \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E2A\u0E38\u0E14\u0E1B\u0E31\u0E07 \u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E40\u0E01\u0E47\u0E1A\u0E1A\u0E31\u0E15\u0E23\u0E01\u0E33\u0E19\u0E31\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E08\u0E32\u0E01\u0E25\u0E34\u0E07\u0E04\u0E4C Brand Gift \u0E41\u0E15\u0E48\u0E25\u0E30\u0E04\u0E23\u0E31\u0E49\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E15\u0E32\u0E21\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E17\u0E35\u0E48\u0E19\u0E48\u0E32\u0E2A\u0E19\u0E43\u0E08\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E32\u0E01",
        "ss_builder_content_2_introduction_service": "\u0E40\u0E1B\u0E34\u0E14 Brand Gift \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E44\u0E21\u0E48\u0E1E\u0E25\u0E32\u0E14\u0E42\u0E2D\u0E01\u0E32\u0E2A\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E42\u0E1A\u0E19\u0E31\u0E2A!",
        "ss_builder_content_creators_joined_the_passio_system": "100K+ \u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C\u0E04\u0E23\u0E35\u0E40\u0E2D\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Passio eco-system",
        "ss_builder_content_editor_title": "\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C",
        "ss_builder_content_list_1_introduction_service": "\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E13",
        "ss_builder_content_list_2_introduction_service": "\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E08\u0E32\u0E01\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C (\u0E16\u0E36\u0E07 30%)",
        "ss_builder_content_list_3_introduction_service": "\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E23\u0E32\u0E22\u0E43\u0E2B\u0E0D\u0E48\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 500 \u0E41\u0E2B\u0E48\u0E07\u0E43\u0E19\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E2A\u0E32\u0E02\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E42\u0E1B\u0E23\u0E41\u0E01\u0E23\u0E21\u0E42\u0E1A\u0E19\u0E31\u0E2A\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22",
        "ss_builder_continue_add_brand_gift": "\u0E04\u0E49\u0E19\u0E1E\u0E1A\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
        "ss_builder_continue_edit_block_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        "ss_builder_continue_edit_image_popup_image_label": "\u0E22\u0E31\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_continue_to_add_block": "\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        "ss_builder_convert_and_go_to_new_version": "\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32 Passio Page",
        "ss_builder_cover_image": "\u0E20\u0E32\u0E1E\u0E2B\u0E19\u0E49\u0E32\u0E1B\u0E01",
        "ss_builder_create_bio_page_free_fast": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E1A\u0E42\u0E2D\u0E1F\u0E23\u0E35\u0E41\u0E25\u0E30\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_create_link_with_your_name_and_imprint": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E1A\u0E42\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 Theme store \u0E21\u0E35\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E18\u0E35\u0E21\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22 \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22\u0E1A\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        "ss_builder_create_new_theme_template_label": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_create_template": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_cusom": "\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07",
        "ss_builder_custom": "\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07",
        "ss_builder_dashed_type_label": "\u0E40\u0E2A\u0E49\u0E19\u0E1B\u0E23\u0E30",
        "ss_builder_data_auto_convert": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32 Landing Page \u0E23\u0E38\u0E48\u0E19\u0E40\u0E01\u0E48\u0E32\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32 Passio Page \u0E23\u0E38\u0E48\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_data_can_be_convert": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32 Landing Page \u0E23\u0E38\u0E48\u0E19\u0E40\u0E01\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32 Passio Page \u0E23\u0E38\u0E48\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E14\u0E49",
        "ss_builder_data_will_be_override": "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E0B\u0E34\u0E07\u0E04\u0E4C \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32 Passio Page",
        "ss_builder_deep_blue_sky": "\u0E17\u0E49\u0E2D\u0E07\u0E1F\u0E49\u0E32\u0E2A\u0E35\u0E1F\u0E49\u0E32",
        "ss_builder_default_meta_description": "Passio Page - Home of {{creator_name}}",
        "ss_builder_defaults_label": "\u0E04\u0E48\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
        "ss_builder_delete_block_label": "\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_delete_block_successfully_label": "\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_delete_card_label": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_delete_card_successfully_label": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_image_label": "\u0E25\u0E1A\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_delete_image_successfully_label": "\u0E25\u0E1A\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_delete_item_checkbox_button_multi_link_successfully_label": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_item_checkbox_card_successfully_label": "\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_item_checkbox_combined_successfully_label": "\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_item_checkbox_image_gallery_successfully_label": "\u0E25\u0E1A\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E43\u0E19\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_item_checkbox_story_successfully_label": "\u0E25\u0E1A\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_link_label": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_delete_link_successfully_label": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_delete_product_group_error_btn_confirm_label": "\u0E01\u0E25\u0E31\u0E1A",
        "ss_builder_delete_product_group_error_content": '\u0E01\u0E25\u0E38\u0E48\u0E21 "{{group_name}}" \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E1A\u0E44\u0E14\u0E49 \u0E15\u0E49\u0E2D\u0E07\u0E41\u0E2A\u0E14\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E01\u0E25\u0E38\u0E48\u0E21',
        "ss_builder_delete_product_group_error_title": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_delete_product_group_label": "\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_delete_product_group_successfully_label": "\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_product_label": "\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_delete_product_successfully_label": "\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_social_link_btn_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A",
        "ss_builder_delete_social_link_label": "\u0E25\u0E1A",
        "ss_builder_delete_social_link_successfully_label": "\u0E25\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_delete_tab_content": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_delete_tab_label": "\u0E25\u0E1A",
        "ss_builder_delete_tab_successfully_label": "\u0E25\u0E1A Tab \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_delete_tab_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E08\u0E30\u0E25\u0E1A\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_delete_template_successfully_label": "\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_delete_theme_template_label": "\u0E25\u0E1A",
        "ss_builder_delete_theme_template_successfully_label": "\u0E25\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_description": "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_builder_description_page_builder": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E44\u0E1A\u0E42\u0E2D\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E04\u0E25\u0E34\u0E01\u0E41\u0E25\u0E30\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E17\u0E31\u0E19\u0E17\u0E35",
        "ss_builder_description_replace_template_content": "\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E08\u0E08\u0E32\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_design_group_floating_title": "\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22",
        "ss_builder_design_group_image_popup_title": "Popup",
        "ss_builder_design_label": "\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "ss_builder_dialog_error_confirm_text": "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
        "ss_builder_dialog_error_content": "\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
        "ss_builder_dialog_error_title": "\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_digital_product_free_label": "\u0E1F\u0E23\u0E35",
        "ss_builder_digital_product_list_title": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_direction_of_background_image_label": "\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_disable_block_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_disable_image_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_disable_item_checkbox_button_multi_link_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_item_checkbox_card_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_item_checkbox_combined_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_item_checkbox_image_gallery_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E43\u0E19\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_item_checkbox_story_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_product_group_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_product_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_disable_social_link_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_disable_tab_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19 Tab \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_disable_theme_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_discover_now": "\u0E04\u0E49\u0E19\u0E1E\u0E1A\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
        "ss_builder_distance_blocks": "\u0E0A\u0E48\u0E2D\u0E07\u0E27\u0E48\u0E32\u0E07\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_divider_color_label": "\u0E2A\u0E35\u0E04\u0E31\u0E48\u0E19",
        "ss_builder_divider_image_label": "\u0E20\u0E32\u0E1E\u0E04\u0E31\u0E48\u0E19",
        "ss_builder_divider_label": "\u0E15\u0E31\u0E27\u0E04\u0E31\u0E48\u0E19",
        "ss_builder_divider_thickness_label": "\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E19\u0E32 (px)",
        "ss_builder_do_you_want_replace_sample_content": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E18\u0E35\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_domain_site_setting_alert_infomation": "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E2D 30 \u0E27\u0E31\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E23\u0E31\u0E49\u0E07\u0E16\u0E31\u0E14\u0E44\u0E1B",
        "ss_builder_domain_site_setting_rule": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E08\u0E32\u0E01\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 \u0E21\u0E35\u0E41\u0E15\u0E48\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_done_panel": "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_dont_add_block_from_template_description": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E21\u0E35\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14 10 \u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_dont_add_block_from_template_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49",
        "ss_builder_dont_add_product_exist_at_add_new_content": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_dont_add_product_exist_at_list_content": '\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\n"{{\u0E0A\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21}}"',
        "ss_builder_dont_add_same_affiliate_product_confirm_label": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_dont_add_same_affiliate_product_modal_label": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E14\u0E49",
        "ss_builder_dont_apply_template_content_modal_description": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_dont_apply_theme_content_modal_btn_confirm_label": "\u0E1B\u0E34\u0E14",
        "ss_builder_dont_apply_theme_content_modal_description": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49 \u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19 Theme Store \u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        "ss_builder_dont_apply_theme_content_modal_label": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49",
        "ss_builder_dot_strokes_type_label": "\u0E08\u0E38\u0E14",
        "ss_builder_dp_title_intro": "Digital products",
        "ss_builder_drop_here_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
        "ss_builder_duplicated_product_url_label": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0B\u0E49\u0E33",
        "ss_builder_duplicated_theme_template_name_warning": "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E37\u0E48\u0E19!",
        "ss_builder_earn_additional_commissions_label": "Earn additional commissions when using Passio's affiliate links",
        "ss_builder_edit_affiliate_product_group_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_edit_affiliate_product_title": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_edit_block_label": "\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_edit_block_successfully_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_edit_image_of_image_popup_title": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_edit_name_affiliate_product_group_title": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_edit_name_block_successfully_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_edit_product_group_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D",
        "ss_builder_edit_tab_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D",
        "ss_builder_edit_tab_successfully_label": "\u0E41\u0E01\u0E49\u0E44\u0E02 Tab \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_edit_template_btn_label": "Save",
        "ss_builder_edit_template_title": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_edit_text_block_label": "\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_edit_theme_btn_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_edit_theme_template_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
        "ss_builder_edit_theme_template_successfully_label": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_edit_theme_template_title": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E02\u0E2D\u0E07\u0E18\u0E35\u0E21",
        "ss_builder_editor_btn-add-more": "\u0E40\u0E1E\u0E34\u0E48\u0E21",
        "ss_builder_editor_btn-cancel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_editor_btn-save": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_email_placeholder": "\u0E01\u0E23\u0E2D\u0E01\u0E2D\u0E35\u0E40\u0E21\u0E25",
        "ss_builder_embed_code_label": "Embed code",
        "ss_builder_embed_code_placeholder": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01 embed code",
        "ss_builder_empty_block": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_empty_search": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C",
        "ss_builder_empty_social_link_list_content": "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E40\u0E19\u0E47\u0E15\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E01 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E1E\u0E34\u0E48\u0E21\u201D \u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19",
        "ss_builder_empty_social_link_list_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25",
        "ss_builder_empty_template_label": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_enable_block_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_enable_border": "\u0E41\u0E2A\u0E14\u0E07",
        "ss_builder_enable_button_border": "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E02\u0E2D\u0E1A",
        "ss_builder_enable_image_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_item_checkbox_button_multi_link_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_item_checkbox_card_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_enable_item_checkbox_combined_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_item_checkbox_image_gallery_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E20\u0E32\u0E1E\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_item_checkbox_story_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E15\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_product_group_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_product_successfully_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_shadow": "\u0E41\u0E2A\u0E14\u0E07",
        "ss_builder_enable_social_link_successfully_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22",
        "ss_builder_enable_tab_successfully_label": "\u0E41\u0E2A\u0E14\u0E07 Tab \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_enable_theme_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enable_tracking_link_product_label": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 tracking link",
        "ss_builder_enable_tracking_link_product_successfully_label": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 tracking link \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_enter_domain_site_setting_label": "\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
        "ss_builder_enter_font_name": "\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E1F\u0E2D\u0E19\u0E15\u0E4C",
        "ss_builder_enter_url_label": "\u0E43\u0E2A\u0E48 URL",
        "ss_builder_enter_your_url": "\u0E43\u0E2A\u0E48 URL \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_error_block_label": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_error_invalid_email_message": "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_error_invalid_phone_message": "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_error_network_confirm_btn_label": "\u0E1B\u0E34\u0E14",
        "ss_builder_error_network_content": "\u0E23\u0E30\u0E1A\u0E1A\u0E21\u0E35\u0E42\u0E2D\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07.",
        "ss_builder_error_network_title": "\u0E23\u0E30\u0E1A\u0E1A\u0E42\u0E2D\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E42\u0E2B\u0E25\u0E14",
        "ss_builder_error_page_title": "Passio Page Builder - {{country}} - Error Page",
        "ss_builder_exceeding_label": "\u0E40\u0E01\u0E34\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14",
        "ss_builder_existed_product_group_label": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_expand": "\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        "ss_builder_expand_introduction_description": '"\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E02\u0E22\u0E32\u0E22" \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E41\u0E19\u0E48\u0E19\u0E2D\u0E19\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C \u0E40\u0E0A\u0E48\u0E19: \u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E \u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22',
        "ss_builder_expand_introduction_title": "\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E02\u0E22\u0E32\u0E22",
        "ss_builder_filter_select_combined_count": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_filter_select_multi_items": "{{num_items}} \u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
        "ss_builder_filter_select_multi_items_card_count": "\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_filter_select_multi_items_gallery_count": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_filter_select_multi_items_multi_links_count": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_filter_select_multi_items_spotlight_count": "\u0E44\u0E1F\u0E2A\u0E1B\u0E2D\u0E23\u0E4C\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_first_guide_add_block_btn_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_first_guide_add_block_description": '\u0E04\u0E25\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E32\u0E01\u0E41\u0E25\u0E30\u0E27\u0E32\u0E07\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01" \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E2B\u0E21\u0E48\u0E25\u0E07\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E07\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E35\u0E27\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E17\u0E35\u0E48\u0E2A\u0E27\u0E22\u0E07\u0E32\u0E21\u0E41\u0E25\u0E30\u0E2D\u0E40\u0E19\u0E01\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C \u0E21\u0E32\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E01\u0E31\u0E19\u0E40\u0E16\u0E2D\u0E30!',
        "ss_builder_first_guide_add_block_title": "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_first_guide_preview_btn_title": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_first_guide_preview_description": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C \u0E04\u0E27\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E25\u0E30\u0E1E\u0E2D\u0E43\u0E08\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E41\u0E25\u0E49\u0E27\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_first_guide_preview_title": "\u0E1B\u0E38\u0E48\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_first_guide_publish_btn_title": "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48",
        "ss_builder_first_guide_publish_description": '\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E08\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E2B\u0E21\u0E14 "\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07" \u0E40\u0E2A\u0E21\u0E2D \u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48"',
        "ss_builder_first_guide_publish_title": "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_floating_full": "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E44\u0E14\u0E49\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_floating_introduction_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E19\u0E35\u0E49\u0E08\u0E30\u0E25\u0E2D\u0E22\u0E2D\u0E22\u0E39\u0E48\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07/\u0E02\u0E27\u0E32\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D \u0E41\u0E2A\u0E14\u0E07\u0E40\u0E2A\u0E21\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22",
        "ss_builder_floating_introduction_title": "\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22",
        "ss_builder_font_name_not_exist": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E19\u0E35\u0E49",
        "ss_builder_font_option_panel_title": "\u0E41\u0E1A\u0E1A\u0E2D\u0E31\u0E01\u0E29\u0E23",
        "ss_builder_footer_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E19\u0E17\u0E38\u0E01\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_footer_introduction_description": "\u201CFooter\u201D \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2A\u0E21\u0E2D \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E22\u0E48\u0E2D \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C...",
        "ss_builder_footer_introduction_title": "Footer Position",
        "ss_builder_footer_title": "Footer",
        "ss_builder_frame_aff": "\u0E40\u0E1F\u0E23\u0E21\u0E23\u0E39\u0E1B\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_general_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
        "ss_builder_generate_income_from_your_own_fan_community": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E0A\u0E38\u0E21\u0E0A\u0E19\u0E41\u0E1F\u0E19\u0E04\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2D\u0E07!",
        "ss_builder_gift_warning": "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_go_back_to_site": "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E44\u0E0B\u0E15\u0E4C\u0E2B\u0E25\u0E31\u0E01",
        "ss_builder_google_font": "\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E01\u0E39\u0E40\u0E01\u0E34\u0E25",
        "ss_builder_gradient": "\u0E44\u0E25\u0E48\u0E42\u0E17\u0E19\u0E2A\u0E35",
        "ss_builder_group_is_full_of_product_modal_description": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E15\u0E47\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2D\u0E37\u0E48\u0E19",
        "ss_builder_group_is_full_of_product_modal_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49",
        "ss_builder_group_is_hiding_label": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E0B\u0E48\u0E2D\u0E19\u0E2D\u0E22\u0E39\u0E48",
        "ss_builder_hard_shadow": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32\u0E41\u0E1A\u0E1A\u0E2B\u0E19\u0E32",
        "ss_builder_header_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E19\u0E17\u0E38\u0E01\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_header_introduction_description": "\u201CHeader\u201D \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E2A\u0E38\u0E14\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2A\u0E21\u0E2D \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19\u0E23\u0E39\u0E1B\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C \u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33...",
        "ss_builder_header_introduction_title": "Header Position",
        "ss_builder_header_title": "Header",
        "ss_builder_heading_and_subtitle_site_setting_label": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E25\u0E30\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22",
        "ss_builder_heading_site_setting_description": "\u0E41\u0E2A\u0E14\u0E07\u0E42\u0E14\u0E22\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E19\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07 SEO \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E17\u0E32\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22",
        "ss_builder_heading_site_setting_label": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E2B\u0E19\u0E49\u0E32",
        "ss_builder_hide_block_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_hide_card_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_hide_card_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_hide_image_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_hide_link_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_hide_link_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_hide_product_group_error_btn_confirm_label": "\u0E1B\u0E34\u0E14",
        "ss_builder_hide_product_group_error_content": '\u0E01\u0E25\u0E38\u0E48\u0E21 "{{group_name}}" \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E0B\u0E48\u0E2D\u0E19\u0E44\u0E14\u0E49 \u0E15\u0E49\u0E2D\u0E07\u0E41\u0E2A\u0E14\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E01\u0E25\u0E38\u0E48\u0E21',
        "ss_builder_hide_product_group_error_title": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_hide_product_group_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_hide_product_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_hide_social_link_label": "\u0E0B\u0E48\u0E2D\u0E19",
        "ss_builder_hide_tab_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_hide_template_successfully_label": "\u0E0B\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_hide_theme_template_label": "Hide template",
        "ss_builder_hightlight_block_label": "\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C",
        "ss_builder_icon_tab_title": "\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_if_delete": "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01 Affiliate \u0E19\u0E35\u0E49",
        "ss_builder_image": "\u0E20\u0E32\u0E1E",
        "ss_builder_image_description_place_holder": "\u0E01\u0E23\u0E2D\u0E01\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C",
        "ss_builder_image_gallery": "\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E48\u0E20\u0E32\u0E1E",
        "ss_builder_image_list_empty_content": "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19",
        "ss_builder_image_list_empty_title": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_image_orientation": "\u0E01\u0E32\u0E23\u0E27\u0E32\u0E07\u0E41\u0E19\u0E27\u0E20\u0E32\u0E1E",
        "ss_builder_image_orientation_label": "\u0E01\u0E32\u0E23\u0E27\u0E32\u0E07\u0E41\u0E19\u0E27\u0E20\u0E32\u0E1E",
        "ss_builder_image_popup_introduction_description": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E19\u0E35\u0E49\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E41\u0E1F\u0E19\u0E46 \u0E14\u0E39\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E04\u0E31\u0E0D \u0E04\u0E33\u0E01\u0E23\u0E30\u0E15\u0E38\u0E49\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 \u0E1B\u0E49\u0E32\u0E22\u0E42\u0E06\u0E29\u0E13\u0E32...",
        "ss_builder_image_popup_introduction_title": "Popup",
        "ss_builder_image_popup_warning": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2B\u0E19\u0E49\u0E32",
        "ss_builder_image_ratio_title": "\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2A\u0E48\u0E27\u0E19\u0E20\u0E32\u0E1E",
        "ss_builder_image_selection_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_image_slider_arrow_switch_title": "\u0E25\u0E39\u0E01\u0E28\u0E23",
        "ss_builder_image_slider_auto_play_switch_title": "\u0E40\u0E25\u0E48\u0E19\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_image_slider_dot_switch_title": "Dot slider",
        "ss_builder_image_slider_list_title": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_image_slider_ratio_selected_title": "\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2A\u0E48\u0E27\u0E19\u0E20\u0E32\u0E1E",
        "ss_builder_image_title_place_holder": "\u0E01\u0E23\u0E2D\u0E01\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E19\u0E15\u0E4C",
        "ss_builder_import_multi_product_url_popover_content": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E49\u0E2D\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E25\u0E32\u0E22 URL  \u0E1B\u0E49\u0E2D\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07 URL \u0E15\u0E48\u0E2D\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14",
        "ss_builder_import_site_url_label": "\u0E2D\u0E34\u0E21\u0E1E\u0E2D\u0E23\u0E4C\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01 URL",
        "ss_builder_import_site_url_modal_button_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_import_site_url_modal_description": "\u0E43\u0E2A\u0E48 URL \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2D\u0E34\u0E21\u0E1E\u0E2D\u0E23\u0E4C\u0E17 \u0E0B\u0E31\u0E1E\u0E1E\u0E2D\u0E23\u0E4C\u0E15: koc.asia  mycollection.shop, linktr.ee, msha.ke",
        "ss_builder_import_site_url_modal_title": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_in_block_delete_forever_are_you_sure": "\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A?",
        "ss_builder_information_handler_alert": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1B\u0E23\u0E30\u0E21\u0E27\u0E25\u0E1C\u0E25\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48",
        "ss_builder_inner_space": "\u0E02\u0E19\u0E32\u0E14\u0E02\u0E49\u0E32\u0E07\u0E43\u0E19",
        "ss_builder_intro_brand_gift_floating_continue": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E25\u0E22",
        "ss_builder_intro_brand_gift_floating_description": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E2D\u0E04\u0E2D\u0E19 Brand Gift \u0E17\u0E31\u0E19\u0E17\u0E35\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E04\u0E39\u0E1B\u0E2D\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E2A\u0E38\u0E14\u0E2E\u0E34\u0E15",
        "ss_builder_intro_brand_gift_floating_reject": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_intro_brand_gift_floating_title": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E2D\u0E07\u0E40\u0E17\u0E48\u0E32\u0E14\u0E49\u0E27\u0E22\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22 Brand Gift",
        "ss_builder_intro_brand_rating_floating_description": "th_Th\xeam t\xednh n\u0103ng ngay \u0111\u1EC3 gi\xfap Fan s\u0103n deal th\xe0nh c\xf4ng v\xe0 t\u0103ng thu nh\u1EADp",
        "ss_builder_intro_brand_rating_floating_title": "th_Brand Ratings",
        "ss_builder_introduce_double_tap_button": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E48\u0E2D",
        "ss_builder_introduce_double_tap_content": "\u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01 \u201C\u0E41\u0E01\u0E49\u0E44\u0E02\u201D \u0E43\u0E19\u0E41\u0E15\u0E48\u0E25\u0E30\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E31\u0E1A\u0E40\u0E1A\u0E34\u0E25\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02\u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01\u0E14\u0E49\u0E27\u0E22",
        "ss_builder_introduce_double_tap_label_check": "\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        "ss_builder_introduce_double_tap_title": "\u0E40\u0E04\u0E25\u0E47\u0E14\u0E25\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_invalid_product_url_label": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_invalid_url": "URL \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_items_per_row": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E41\u0E16\u0E27",
        "ss_builder_keep_the_content": "\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_landscape_image_orientation_label": "\u0E41\u0E19\u0E27\u0E19\u0E2D\u0E19",
        "ss_builder_limit_reached": "\u0E16\u0E36\u0E07\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_link_additional_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_link_select_service": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_link_text_left_layout": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22",
        "ss_builder_link_text_right_layout": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32",
        "ss_builder_link_text_under_layout": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_link_text_zig_zag_layout": "\u0E0B\u0E34\u0E01\u0E41\u0E0B\u0E01",
        "ss_builder_link_type_email": "\u0E2D\u0E35\u0E40\u0E21\u0E25",
        "ss_builder_link_type_phone": "\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        "ss_builder_link_type_service": "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_link_type_tel": "Tel",
        "ss_builder_link_type_web": "Web",
        "ss_builder_link_url": "\u0E25\u0E34\u0E07\u0E04\u0E4C URL",
        "ss_builder_list_button_multi_link_label": "\u0E25\u0E34\u0E2A\u0E4C\u0E15",
        "ss_builder_list_card_empty_content": "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E4C\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21",
        "ss_builder_list_card_empty_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E17\u0E47\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_list_card_label": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_list_image_popup_title": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_list_label": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
        "ss_builder_list_link_empty_content": '\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E2D\u0E22\u0E39\u0E48\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19',
        "ss_builder_list_link_empty_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_list_title_digital_product": "List",
        "ss_builder_loading_label": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14",
        "ss_builder_malformed_domain_warning": "\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_malformed_embed_code_warning": "embed code \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_manage_block_description": "Ss Builder Manage Block Description",
        "ss_builder_manage_block_title": "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_manage_tab_description": "\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E1A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E2A\u0E48\u0E27\u0E19",
        "ss_builder_manage_tab_title": "\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_management_digital_product_description": "List of your digital products",
        "ss_builder_management_digital_product_title": "Digital Product",
        "ss_builder_management_label": "Management",
        "ss_builder_medium": "\u0E01\u0E25\u0E32\u0E07",
        "ss_builder_missing_required_product_url_label": "\u0E02\u0E32\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19",
        "ss_builder_modal_button_close": "\u0E1B\u0E34\u0E14",
        "ss_builder_move_block_successfully_label": "\u0E22\u0E49\u0E32\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_move_down_block_label": "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E1B\u0E02\u0E49\u0E32\u0E07\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_move_product_label": "\u0E22\u0E49\u0E32\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48",
        "ss_builder_move_product_quantity_to_group_alert_label": "\u0E22\u0E49\u0E32\u0E22 {{product_quantity}} \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E1B\u0E17\u0E35\u0E48",
        "ss_builder_move_product_successfully_label": "\u0E22\u0E49\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_move_to_bottom_label": "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E1B\u0E02\u0E49\u0E32\u0E07\u0E25\u0E48\u0E32\u0E07\u0E2A\u0E38\u0E14",
        "ss_builder_move_to_top_label": "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E1B\u0E02\u0E49\u0E32\u0E07\u0E1A\u0E19\u0E2A\u0E38\u0E14",
        "ss_builder_move_up_block_label": "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E1B\u0E02\u0E49\u0E32\u0E07\u0E1A\u0E19",
        "ss_builder_multi_product_url_imported_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21 {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_multi_product_url_importing_label": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21 {{successfullyUrlQuantity}}/{{detectedUrlQuantity}} \u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_name_tab_input_title": "\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_need_to_display_at_least_one_block": "Need to display at least one block",
        "ss_builder_need_to_display_at_least_one_card": "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E1A",
        "ss_builder_need_to_display_at_least_one_image": "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E20\u0E32\u0E1E\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E20\u0E32\u0E1E",
        "ss_builder_need_to_display_at_least_one_link": "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_need_to_display_at_least_one_spotlight": "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E15\u0E4C\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E14\u0E27\u0E07",
        "ss_builder_next": "\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        "ss_builder_no_image_selected": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E27\u0E48\u0E32\u0E07",
        "ss_builder_no_photo_has_been_selected": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_no_shadow": "\u0E44\u0E21\u0E48\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32",
        "ss_builder_no_themes_found_theme_store": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E18\u0E35\u0E21",
        "ss_builder_none_of_image_description": '\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E',
        "ss_builder_none_of_image_popup_alert": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_not_add_yet_product_url_label": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_not_enough_space_product_group_modal_content": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E21\u0E35\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{num_products}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E1A\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2D\u0E37\u0E48\u0E19",
        "ss_builder_not_enough_space_product_group_modal_title": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E44\u0E14\u0E49",
        "ss_builder_notes": "\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E42\u0E14\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_off": "\u0E1B\u0E34\u0E14",
        "ss_builder_on": "\u0E40\u0E1B\u0E34\u0E14",
        "ss_builder_onboarding_choose_a_suitable_theme": "\u0E08\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E0A\u0E49\u2728",
        "ss_builder_onboarding_choose_the_look_for_you": "\u0E08\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13!",
        "ss_builder_onboarding_create_a_personal_page": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E1A\u0E42\u0E2D \u0E17\u0E33 Affiliate Marketing, Booking, Donation, \u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 (\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23, \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E, \u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D, \u0E01\u0E32\u0E23\u0E19\u0E33\u0E40\u0E2A\u0E19\u0E2D,...)",
        "ss_builder_onboarding_no_need_know_technology": "\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E40\u0E17\u0E04\u0E42\u0E19\u0E42\u0E25\u0E22\u0E35 \u0E07\u0E48\u0E32\u0E22\u0E15\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E0A\u0E38\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E1A\u0E42\u0E2D",
        "ss_builder_onboarding_theme_store_template": "\u0E04\u0E25\u0E31\u0E07\u0E40\u0E01\u0E47\u0E1A\u0E18\u0E35\u0E21",
        "ss_builder_open_browser_label": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
        "ss_builder_open_link_in_new_tab": "\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_open_link_in_new_tab_description": "\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_open_new_tab_description": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E01\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_open_new_tab_label": "\u0E40\u0E1B\u0E34\u0E14\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_optional_color_panel_label": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35\u0E2D\u0E37\u0E48\u0E19\u0E46",
        "ss_builder_overwrite_description": "\u0E01\u0E32\u0E23\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E08\u0E30\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_overwrite_template_btn_label": "\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A",
        "ss_builder_overwrite_template_successfully_label": "\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_overwrite_template_title": "\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_overwrite_theme_btn_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A",
        "ss_builder_overwrite_theme_template_successfully_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_overwrite_theme_template_title": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_overwrite_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_panel_add_icon_tab_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_panel_add_new_tab_title": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_panel_edit_text_block_title": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_panel_search_label": "\u0E04\u0E49\u0E19\u0E2B\u0E32...",
        "ss_builder_panel_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_paragraph_setting_font_available": "\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48",
        "ss_builder_paragraph_setting_font_custom": "\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07",
        "ss_builder_paragraph_setting_option": "\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E2D\u0E07",
        "ss_builder_paragraph_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "ss_builder_partial_visible_slide_type_1": "\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E44\u0E14\u0E49\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E32\u0E07\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32",
        "ss_builder_partial_visible_slide_type_2": "\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E44\u0E14\u0E49\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2A\u0E2D\u0E07\u0E14\u0E49\u0E32\u0E19",
        "ss_builder_partial_visible_slide_type_3": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E44\u0E14\u0E49\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19",
        "ss_builder_partial_visible_slide_type_4": "Posters",
        "ss_builder_partial_visible_slide_type_5": "\u0E1E\u0E32\u0E42\u0E19\u0E23\u0E32\u0E21\u0E32",
        "ss_builder_passio_page_ready": "Passio Page \u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_passio_page_ready_description": "\u0E2B\u0E19\u0E49\u0E32 Passio Page \u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E41\u0E17\u0E19\u0E2B\u0E19\u0E49\u0E32 Landing Page \u0E23\u0E38\u0E48\u0E19\u0E40\u0E01\u0E48\u0E32",
        "ss_builder_passio_premium": "Passio Premium",
        "ss_builder_personal_link_coppy_label": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
        "ss_builder_personal_link_coppy_successfully_label": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_personal_link_sharing_title": "\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_personal_link_title": "URL \u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_phone_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        "ss_builder_placeholder_affiliate_product_enter_product_name": "\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_placeholder_dragging_content": "\u0E27\u0E32\u0E07\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
        "ss_builder_please_wait_for_the_product_to_be_updated": "\u0E23\u0E2D\u0E2D\u0E31\u0E1E\u0E40\u0E14\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E01\u0E31\u0E19",
        "ss_builder_popover_manual_button": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
        "ss_builder_popover_manual_button_close": "\u0E1B\u0E34\u0E14",
        "ss_builder_popover_manual_content": '\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19"',
        "ss_builder_popover_manual_title": "\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49",
        "ss_builder_popover_review_manual_content": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E48\u0E32\u0E19\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E22\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E19\u0E35\u0E49",
        "ss_builder_popular_font_families": "\u0E41\u0E1A\u0E1A\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
        "ss_builder_popup_confirm_button": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
        "ss_builder_popup_management_title": "Management",
        "ss_builder_portrait_image_orientation_label": "\u0E41\u0E19\u0E27\u0E15\u0E31\u0E49\u0E07",
        "ss_builder_position_ghim_tab_selection_label": "\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07",
        "ss_builder_powered_by_passio": "Powered by Ecomobi",
        "ss_builder_preview": "\u0E41\u0E2A\u0E14\u0E07\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_preview_image_label": "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_preview_theme_template_title": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_product_design_empty_description": "Please wait for the product to be updated",
        "ss_builder_product_design_empty_title": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_detect_link_malformed_error": "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_product_detect_link_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_detect_link_title": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_empty_searching_description": "\u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E14\u0E2D\u0E37\u0E48\u0E19\u0E46",
        "ss_builder_product_empty_searching_title": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_exceeding_allowed_amount_content": "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E2D\u0E01",
        "ss_builder_product_exceeding_allowed_amount_title": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E16\u0E36\u0E07\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_product_group_add_new_btn_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_group_default_title": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_group_limitation_warning_description": "The total number of products in the group has been reached the limit of {{max_products}} products. Please delete existing products if you want to add new ones.",
        "ss_builder_product_group_selection_placeholder": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_group_selection_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 affiliate",
        "ss_builder_product_group_total_limitation_warning_content": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E16\u0E36\u0E07\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14 {{group_quantity_maximum}} \u0E01\u0E25\u0E38\u0E48\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E16\u0E49\u0E32\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_product_group_total_limitation_warning_title": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_product_is_hiding_label": "Hidden product",
        "ss_builder_product_link_wrapped_label": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E22\u0E48\u0E2D",
        "ss_builder_product_list_style_grid_label": "\u0E41\u0E1A\u0E1A\u0E01\u0E23\u0E34\u0E14",
        "ss_builder_product_list_style_grid_one_label": "1 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_list_style_grid_three_label": "3 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_list_style_grid_two_label": "2 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_list_style_slide_label": "\u0E41\u0E1A\u0E1A\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19",
        "ss_builder_product_list_style_text_over_image_label": "Text over image",
        "ss_builder_product_list_style_zig_zag_label": "Zigzag",
        "ss_builder_product_searching_description": "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32",
        "ss_builder_product_searching_title": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_selection_option_1": "10 \u0E2D\u0E31\u0E19\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22",
        "ss_builder_product_selection_option_2": "20 \u0E2D\u0E31\u0E19\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22",
        "ss_builder_product_selection_option_3": "50 \u0E2D\u0E31\u0E19\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22",
        "ss_builder_product_selection_option_4": "5 \u0E2D\u0E31\u0E19\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22",
        "ss_builder_product_swiper_see_all": "\u0E14\u0E39\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
        "ss_builder_product_title_error": "Missing product name",
        "ss_builder_product_title_missing_warning": "\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_total_limitation_warning_description": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E16\u0E36\u0E07\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14 {{max_products_all_groups}} \u0E2D\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_product_total_limitation_warning_title": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_product_tour_button_step_0": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
        "ss_builder_product_tour_content_step_0": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E15\u0E32\u0E21\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E31\u0E21\u0E1C\u0E31\u0E2A\u0E01\u0E31\u0E1A\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E19\u0E48\u0E32\u0E2A\u0E19\u0E43\u0E08\u0E02\u0E2D\u0E07 Passio Page!",
        "ss_builder_product_tour_content_step_1": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E23\u0E23\u0E04\u0E4C\u0E14\u0E49\u0E27\u0E22\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E40\u0E23\u0E35\u0E22\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E32\u0E21\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E07\u0E48\u0E32\u0E22\u0E14\u0E32\u0E22",
        "ss_builder_product_tour_content_step_10": "\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E40\u0E14\u0E35\u0E22\u0E27\u0E01\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E0A\u0E49 \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E01\u0E31\u0E1A\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_product_tour_content_step_11": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C \u0E04\u0E27\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E25\u0E30\u0E1E\u0E2D\u0E43\u0E08\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E41\u0E25\u0E49\u0E27\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_product_tour_content_step_12": '\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E01\u0E14\u0E04\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49\u0E41\u0E25\u0E30\u0E25\u0E32\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E22\u0E49\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E0A\u0E49 "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E02\u0E36\u0E49\u0E19/\u0E25\u0E07',
        "ss_builder_product_tour_content_step_13": '\u0E40\u0E25\u0E37\u0E2D\u0E01 "\u0E41\u0E01\u0E49\u0E44\u0E02" \u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19 "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27" \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E14\u0E17\u0E35\u0E48\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02',
        "ss_builder_product_tour_content_step_14": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E14\u0E49\u0E27\u0E22\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E2A\u0E35\u0E17\u0E36\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E25\u0E48\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E2A\u0E35\u0E17\u0E35\u0E48\u0E40\u0E15\u0E47\u0E21\u0E44\u0E1B\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E38\u0E04\u0E25\u0E34\u0E01\u0E20\u0E32\u0E1E",
        "ss_builder_product_tour_content_step_15": "\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22 \u0E2A\u0E27\u0E22\u0E07\u0E32\u0E21 \u0E41\u0E25\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E19\u0E34\u0E22\u0E21\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2D\u0E34\u0E2A\u0E23\u0E30",
        "ss_builder_product_tour_content_step_16": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07\u0E0A\u0E48\u0E27\u0E22\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E18\u0E35\u0E21 \u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19 \u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25...",
        "ss_builder_product_tour_content_step_17": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D \u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E19\u0E35\u0E49",
        "ss_builder_product_tour_content_step_2": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E07\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E35\u0E27\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E17\u0E35\u0E48\u0E2A\u0E27\u0E22\u0E07\u0E32\u0E21\u0E41\u0E25\u0E30\u0E2D\u0E40\u0E19\u0E01\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C \u0E04\u0E25\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E32\u0E01\u0E41\u0E25\u0E30\u0E27\u0E32\u0E07\u0E1B\u0E38\u0E48\u0E21\u0E19\u0E35\u0E49\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E2B\u0E21\u0E48 \u0E21\u0E32\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E01\u0E31\u0E19\u0E40\u0E16\u0E2D\u0E30!",
        "ss_builder_product_tour_content_step_3": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E25\u0E30\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E15\u0E32\u0E21\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23",
        "ss_builder_product_tour_content_step_4": '\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E08\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E2B\u0E21\u0E14 "\u0E23\u0E48\u0E32\u0E07" \u0E40\u0E2A\u0E21\u0E2D \u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48"',
        "ss_builder_product_tour_content_step_5": '\u0E41\u0E17\u0E47\u0E1A\u0E44\u0E14\u0E49\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E1A\u0E48\u0E07 "Body" \u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E2A\u0E48\u0E27\u0E19 \u0E40\u0E0A\u0E48\u0E19 \u0E41\u0E17\u0E47\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E41\u0E17\u0E47\u0E1A\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D \u0E41\u0E17\u0E47\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14 \u0E2F\u0E25\u0E2F \u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E41\u0E15\u0E48\u0E25\u0E30\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E41\u0E25\u0E30\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E20\u0E32\u0E22\u0E43\u0E19 \u0E41\u0E01\u0E49\u0E44\u0E02\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E19\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48 \u0E2B\u0E23\u0E37\u0E2D\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E41\u0E17\u0E47\u0E1A',
        "ss_builder_product_tour_content_step_6": "\u201CHeader\u201D \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01 \u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E2A\u0E38\u0E14\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2A\u0E21\u0E2D \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 Avatar \u0E1A\u0E17\u0E19\u0E33...",
        "ss_builder_product_tour_content_step_7": '"Body" \u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E41\u0E25\u0E30\u0E44\u0E14\u0E49\u0E41\u0E1A\u0E48\u0E07\u0E2D\u0E2D\u0E01 \u0E19\u0E33\u0E17\u0E32\u0E07\u0E42\u0E14\u0E22\u0E41\u0E17\u0E47\u0E1A \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19: \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 ...',
        "ss_builder_product_tour_content_step_8": "\u201CFooter\u201D \u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2A\u0E21\u0E2D \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 \u0E25\u0E34\u0E07\u0E04\u0E4C\u0E22\u0E48\u0E2D \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E0B\u0E15\u0E4C...",
        "ss_builder_product_tour_content_step_9": "\u0E43\u0E0A\u0E49\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E19\u0E35\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E17\u0E33\u0E44\u0E1B\u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E43\u0E08\u0E04\u0E38\u0E13 \u0E0B\u0E36\u0E48\u0E07\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E25\u0E31\u0E1A\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E48\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48",
        "ss_builder_product_tour_done_label": "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19",
        "ss_builder_product_tour_next_label": "\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        "ss_builder_product_tour_prev_label": "\u0E01\u0E25\u0E31\u0E1A",
        "ss_builder_product_tour_skip_label": "\u0E02\u0E49\u0E32\u0E21",
        "ss_builder_product_tour_title_step_0": "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48 Passio Page",
        "ss_builder_product_tour_title_step_1": "\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E18\u0E35\u0E21",
        "ss_builder_product_tour_title_step_10": "\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_product_tour_title_step_11": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_product_tour_title_step_12": "\u0E22\u0E49\u0E32\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_product_tour_title_step_13": "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_product_tour_title_step_14": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_product_tour_title_step_15": "\u0E23\u0E49\u0E32\u0E19\u0E18\u0E35\u0E21",
        "ss_builder_product_tour_title_step_16": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
        "ss_builder_product_tour_title_step_17": "\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49",
        "ss_builder_product_tour_title_step_2": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_product_tour_title_step_3": "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_product_tour_title_step_4": "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "ss_builder_product_tour_title_step_5": "\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E21\u0E19\u0E39",
        "ss_builder_product_tour_title_step_6": "Header",
        "ss_builder_product_tour_title_step_7": "Body",
        "ss_builder_product_tour_title_step_8": "Footer",
        "ss_builder_product_tour_title_step_9": "\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_product_tour_use_manual": "\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49",
        "ss_builder_product_tour_use_manual_content": "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u201D",
        "ss_builder_product_url_lists_label": "\u0E15\u0E32\u0E23\u0E32\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_publish_button_label": "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48",
        "ss_builder_publish_result_description": "Passio Page \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27\n\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E1E\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E32\u0E01\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_publish_result_successfully": "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E18\u0E35\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27!",
        "ss_builder_publish_result_title": "\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48",
        "ss_builder_publish_saving": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_publish_share": "\u0E41\u0E0A\u0E23\u0E4C",
        "ss_builder_publish_view_page": "\u0E0A\u0E21\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_randomize": "\u0E2A\u0E38\u0E48\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_ready_to_build_your_personal_brand": "\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22 Passio \u0E40\u0E25\u0E22 \uD83D\uDC96",
        "ss_builder_recently_color_panel_label": "\u0E2A\u0E35\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
        "ss_builder_redo_theme_label": "\u0E17\u0E33\u0E0B\u0E49\u0E33",
        "ss_builder_reload_label": "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
        "ss_builder_replace": "\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48",
        "ss_builder_replace_preview_theme_template_btn_label": "\u0E43\u0E0A\u0E49",
        "ss_builder_replace_theme_label": "\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_replace_theme_modal_content": "\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E18\u0E35\u0E21\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E08\u0E30\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E18\u0E35\u0E21\u0E18\u0E35\u0E21\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_replace_theme_modal_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E18\u0E35\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_replace_theme_template_successfully_label": "\u0E19\u0E33\u0E21\u0E32\u0E43\u0E0A\u0E49\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_report_sent_report_successfully": "\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_report_sent_report_successfully_description": "\u0E02\u0E2D\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13! \u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_restore_theme_content": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E18\u0E35\u0E21\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E20\u0E32\u0E22\u0E43\u0E19\u0E18\u0E35\u0E21\u0E08\u0E30\u0E16\u0E39\u0E01\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_restore_theme_label": "\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_builder_restore_theme_successfully_label": "\u0E04\u0E37\u0E19\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_restore_theme_title": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
        "ss_builder_revenue_group_description": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E2D\u0E2D\u0E19\u0E44\u0E25\u0E19\u0E4C\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07 Passio Page",
        "ss_builder_revenue_title": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49",
        "ss_builder_round_photo_label": "\u0E20\u0E32\u0E1E\u0E01\u0E25\u0E21",
        "ss_builder_rounded": "\u0E42\u0E04\u0E49\u0E07\u0E21\u0E19",
        "ss_builder_sample_change_label": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_sample_selection_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_sampling_change_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_save": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_builder_save_new_template_title": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_save_new_theme_template_successfully_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E18\u0E35\u0E21\u0E43\u0E2B\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_save_new_theme_template_title": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E43\u0E2B\u0E21\u0E48",
        "ss_builder_save_succesfully_description": "\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_save_succesfully_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_search_results_theme_store": "\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
        "ss_builder_search_type_block": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E15\u0E32\u0E21\u0E0A\u0E37\u0E48\u0E2D",
        "ss_builder_see_less": "\u0E14\u0E39\u0E19\u0E49\u0E2D\u0E22\u0E25\u0E07",
        "ss_builder_see_more": "\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        "ss_builder_see_more_btn_default_title": "\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        "ss_builder_select_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_select_link_type": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_select_multi_items": "\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_select_position_add_block": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_select_ratio_title": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2A\u0E48\u0E27\u0E19",
        "ss_builder_select_theme_setting_primary_color_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35\u0E2B\u0E25\u0E31\u0E01",
        "ss_builder_selected_product_in_selection_label": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_send": "\u0E2A\u0E48\u0E07",
        "ss_builder_send_report": "\u0E2A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_service_placeholder": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_set_default_tab_disable_content": 'Tab \u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E36\u0E49\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 Tab ${defaultNameTab} \u0E16\u0E39\u0E01\u0E0B\u0E48\u0E2D\u0E19\u0E2D\u0E22\u0E39\u0E48 \u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Tab \u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E08\u0E30\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30 Tab \u0E19\u0E35\u0E49\u0E43\u0E2B\u0E49\u0E21\u0E2D\u0E07\u0E40\u0E2B\u0E47\u0E19\u0E44\u0E14\u0E49 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Tab "{{tab_name}}" \u0E40\u0E1B\u0E47\u0E19\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48',
        "ss_builder_set_default_tab_enable_content": 'Tab \u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E36\u0E49\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Tab "{{tab_name}}" \u0E40\u0E1B\u0E47\u0E19\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48',
        "ss_builder_set_default_tab_label": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19",
        "ss_builder_set_default_tab_successfully_label": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_set_default_tab_title": "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19",
        "ss_builder_setting_font_weight": "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E31\u0E01 font",
        "ss_builder_setting_line_height": "\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07",
        "ss_builder_setting_popover_manual_content": "\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 \u0E40\u0E23\u0E32\u0E21\u0E32\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u201D \u0E01\u0E31\u0E19",
        "ss_builder_setting_popover_manual_title": "Product tour",
        "ss_builder_setting_saving": "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
        "ss_builder_setting_text_font": "\u0E1F\u0E2D\u0E19\u0E15\u0E4C\u0E2D\u0E31\u0E01\u0E29\u0E23",
        "ss_builder_setting_text_scale": "\u0E2D\u0E31\u0E15\u0E23\u0E32",
        "ss_builder_setting_text_size": "\u0E02\u0E19\u0E32\u0E14 font (px)",
        "ss_builder_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "ss_builder_setting_tour_content_step_1": "\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D URL \u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u0E40\u0E1B\u0E34\u0E14 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02 favicon \u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E25\u0E30\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_setting_tour_content_step_2": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E18\u0E35\u0E21\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48 \u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_setting_tour_content_step_3": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25 \u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 SEO \u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
        "ss_builder_setting_tour_title_step_1": "Site url",
        "ss_builder_setting_tour_title_step_2": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E18\u0E35\u0E21",
        "ss_builder_setting_tour_title_step_3": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_settings_label": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        "ss_builder_setup_site_setting": "Site settings",
        "ss_builder_setup_theme_setting": "Theme settings",
        "ss_builder_shadows_style": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32",
        "ss_builder_shape_label": "\u0E23\u0E39\u0E1B\u0E17\u0E23\u0E07",
        "ss_builder_share_label": "\u0E41\u0E0A\u0E23\u0E4C",
        "ss_builder_show_block_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E1A\u0E25\u0E47\u0E2D\u0E01",
        "ss_builder_show_card_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_show_card_successfully_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E01\u0E32\u0E23\u0E4C\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_show_image_label": "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_show_link_label": "\u0E41\u0E2A\u0E14\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_show_link_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
        "ss_builder_show_product_group_label": "\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E25\u0E38\u0E48\u0E21",
        "ss_builder_show_product_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        "ss_builder_show_social_link_label": "\u0E42\u0E0A\u0E27\u0E4C",
        "ss_builder_show_tab_label": "\u0E42\u0E0A\u0E27\u0E4C\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_show_template_successfully_label": "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_builder_show_theme_template_label": "Show template",
        "ss_builder_site_brand_setting_label": "\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
        "ss_builder_site_domain_setting_label": "\u0E42\u0E14\u0E40\u0E21\u0E19",
        "ss_builder_site_setting_browser_label": "\u0E40\u0E1A\u0E23\u0E32\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
        "ss_builder_site_setting_coppy_label": "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
        "ss_builder_site_setting_favicon_title": "Favicon",
        "ss_builder_site_setting_favicon_upload_description": "Favicon \u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E32\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E40\u0E1E\u0E08 \u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E20\u0E32\u0E1E\u0E42\u0E1B\u0E23\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07 Favicon",
        "ss_builder_site_setting_label": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_site_setting_premium": "\u0E1E\u0E23\u0E35\u0E40\u0E21\u0E35\u0E22\u0E21",
        "ss_builder_site_setting_share_label": "\u0E41\u0E0A\u0E23\u0E4C",
        "ss_builder_site_setting_standard": "\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19",
        "ss_builder_site_setting_upgrade": "\u0E2D\u0E31\u0E1E\u0E1B\u0E40\u0E01\u0E23\u0E14",
        "ss_builder_skip": "\u0E02\u0E49\u0E32\u0E21",
        "ss_builder_slide_type_label": "\u0E41\u0E1A\u0E1A\u0E2A\u0E44\u0E25\u0E14\u0E4C",
        "ss_builder_social_link_btn_add_new_label": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22",
        "ss_builder_social_links_list_title": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E0A\u0E48\u0E2D\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22",
        "ss_builder_social_network_label": "\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E40\u0E19\u0E47\u0E15\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E01",
        "ss_builder_soft_shadow": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32\u0E41\u0E1A\u0E1A\u0E1A\u0E32\u0E07",
        "ss_builder_solid": "\u0E2A\u0E35\u0E17\u0E36\u0E1A",
        "ss_builder_solid_type_label": "\u0E02\u0E2D\u0E07\u0E41\u0E02\u0E47\u0E07",
        "ss_builder_something_went_wrong": "\u0E02\u0E2D\u0E42\u0E17\u0E29 \u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_spacer_label": "\u0E23\u0E30\u0E22\u0E30\u0E2B\u0E48\u0E32\u0E07 (px)",
        "ss_builder_spotlight_list_empty_content": '\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E17\u0E4C\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19',
        "ss_builder_spotlight_list_empty_title": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E1B\u0E2D\u0E15\u0E44\u0E25\u0E15\u0E4C",
        "ss_builder_square": "\u0E2A\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E35\u0E48\u0E22\u0E21",
        "ss_builder_square_photo_label": "\u0E20\u0E32\u0E1E\u0E2A\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E35\u0E48\u0E22\u0E21\u0E08\u0E31\u0E15\u0E38\u0E23\u0E31\u0E2A",
        "ss_builder_start_use_passio_page": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32 Passio Page \u0E17\u0E31\u0E19\u0E17\u0E35!",
        "ss_builder_stop_label": "\u0E2B\u0E22\u0E38\u0E14",
        "ss_builder_story": "\u0E2A\u0E1B\u0E2D\u0E23\u0E4C\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_story_title_place_holder": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E2A\u0E1B\u0E2D\u0E23\u0E4C\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_style": "\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_style_always_ghim_tab_label": "\u0E1B\u0E31\u0E01\u0E2B\u0E21\u0E38\u0E14\u0E40\u0E2A\u0E21\u0E2D",
        "ss_builder_style_auto_ghim_tab_label": "\u0E1B\u0E31\u0E01\u0E2B\u0E21\u0E38\u0E14\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_style_ghim_tab_selection_label": "\u0E1B\u0E31\u0E01\u0E2B\u0E21\u0E38\u0E14\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_style_grid_label": "\u0E41\u0E1A\u0E1A\u0E01\u0E23\u0E34\u0E14",
        "ss_builder_style_masonry_label": "Masonry",
        "ss_builder_style_not_ghim_tab_label": "\u0E44\u0E21\u0E48\u0E1B\u0E31\u0E01\u0E2B\u0E21\u0E38\u0E14",
        "ss_builder_style_slide_label": "\u0E41\u0E1A\u0E1A\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19",
        "ss_builder_style_tab_icon_label": "\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_style_tab_only_icon": "\u0E43\u0E0A\u0E49\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_style_tab_only_image": "\u0E43\u0E0A\u0E49\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_style_tab_selection_label": "\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_style_tab_text_and_icon_label": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21&\u0E44\u0E2D\u0E04\u0E2D\u0E19",
        "ss_builder_style_tab_text_and_image_label": "Text & image",
        "ss_builder_style_tab_text_label": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_subtitle_site_setting_description": "\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E43\u0E2B\u0E49\u0E20\u0E32\u0E1E\u0E23\u0E27\u0E21\u0E02\u0E2D\u0E07\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E19\u0E33\u0E44\u0E1B\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_subtitle_site_setting_label": "\u0E04\u0E33\u0E1A\u0E23\u0E23\u0E22\u0E32\u0E22",
        "ss_builder_suggested_color_panel_label": "\u0E08\u0E32\u0E19\u0E2A\u0E35\u0E17\u0E35\u0E48\u0E41\u0E19\u0E30\u0E19\u0E33",
        "ss_builder_support_upload_image": "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19: JPG, JPEG, GIF, PNG, BMP, WebP, up to 30MB",
        "ss_builder_support_upload_image_v2": "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19: JPG, JPEG, GIF, PNG, BMP up to 30MB",
        "ss_builder_support_upload_large_image": "\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A: JPG, JPEG, GIF, PNG, BMP, WebP, up to 50MB",
        "ss_builder_swiper_setting_premium_description_1": "\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14",
        "ss_builder_swiper_setting_premium_title_1": "\u0E41\u0E2D\u0E04\u0E40\u0E04\u0E32\u0E17\u0E4C\u0E1E\u0E23\u0E35\u0E40\u0E21\u0E35\u0E22\u0E21",
        "ss_builder_swiper_setting_premium_title_2": "\u0E18\u0E35\u0E21\u0E1E\u0E34\u0E40\u0E28\u0E29",
        "ss_builder_swiper_setting_premium_title_3": "\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E42\u0E14\u0E40\u0E21\u0E19 yourdomain.com",
        "ss_builder_swiper_setting_premium_title_4": "\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E1E\u0E34\u0E40\u0E28\u0E29",
        "ss_builder_swiper_setting_premium_title_5": "\u0E16\u0E2D\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_swiper_setting_premium_title_6": "\u0E1B\u0E23\u0E30\u0E2B\u0E22\u0E31\u0E14\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21 25%",
        "ss_builder_tab_layout_1": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32",
        "ss_builder_tab_layout_2": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07",
        "ss_builder_tabs_label": "\u0E41\u0E17\u0E47\u0E1A",
        "ss_builder_template_overwrite_title": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E01\u0E32\u0E23\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A",
        "ss_builder_template_search_bar_placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E15\u0E32\u0E21\u0E0A\u0E37\u0E48\u0E2D...",
        "ss_builder_template_store_instruction_subtitle": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19",
        "ss_builder_template_store_instruction_title": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23",
        "ss_builder_template_title": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_text_editor_max_length": "\u0E1B\u0E49\u0E2D\u0E19\u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 {{editor_max_length}} \u0E15\u0E31\u0E27",
        "ss_builder_text_spin_loading": "Loading page",
        "ss_builder_the_application_of_the_template_will": "\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E08\u0E30",
        "ss_builder_theme_big_button_setting": "\u0E1B\u0E38\u0E48\u0E21\u0E43\u0E2B\u0E0D\u0E48",
        "ss_builder_theme_button_setting_general": "\u0E17\u0E31\u0E48\u0E48\u0E27\u0E44\u0E1B",
        "ss_builder_theme_display_setting": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E17\u0E31\u0E48\u0E31\u0E48\u0E27\u0E44\u0E1B",
        "ss_builder_theme_medium_button_setting": "\u0E1B\u0E38\u0E48\u0E21\u0E01\u0E25\u0E32\u0E07",
        "ss_builder_theme_setting_background": "\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_theme_setting_background_color_preview_title": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_theme_setting_background_color_selector_label": "\u0E2A\u0E35",
        "ss_builder_theme_setting_background_content": "\u0E02\u0E19\u0E32\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14: 30MB.\n\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E1F\u0E25\u0E4C: jpg, jpeg, gif, png, bmp, webp",
        "ss_builder_theme_setting_background_content_v2": "\u0E02\u0E19\u0E32\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14: 30MB.\n\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E1F\u0E25\u0E4C: jpg, jpeg, gif, png, bmp",
        "ss_builder_theme_setting_background_image_preview_label": "\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_theme_setting_background_image_selector_label": "\u0E20\u0E32\u0E1E",
        "ss_builder_theme_setting_background_image_title": "\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_theme_setting_block_background": "\u0E2A\u0E35\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_builder_theme_setting_block_border": "\u0E02\u0E2D\u0E1A",
        "ss_builder_theme_setting_block_shadow": "\u0E40\u0E07\u0E32",
        "ss_builder_theme_setting_block_style": "\u0E2A\u0E44\u0E15\u0E25\u0E4C",
        "ss_builder_theme_setting_button": "\u0E1B\u0E38\u0E48\u0E21",
        "ss_builder_theme_setting_font_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_theme_setting_font_type_content": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_theme_setting_font_type_title": "\u0E41\u0E1A\u0E1A\u0E2D\u0E31\u0E01\u0E29\u0E23",
        "ss_builder_theme_setting_gadient_color": "\u0E2A\u0E35",
        "ss_builder_theme_setting_general": "\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
        "ss_builder_theme_setting_gradient_color_direction_label": "\u0E17\u0E34\u0E28\u0E17\u0E32\u0E07",
        "ss_builder_theme_setting_hard_shadow": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32\u0E41\u0E1A\u0E1A\u0E2B\u0E19\u0E32",
        "ss_builder_theme_setting_intensity_color_label": "\u0E04\u0E27\u0E32\u0E21\u0E40\u0E02\u0E49\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E35",
        "ss_builder_theme_setting_label": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E18\u0E35\u0E21",
        "ss_builder_theme_setting_no_shadow": "\u0E44\u0E21\u0E48\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32",
        "ss_builder_theme_setting_paragraph": "\u0E22\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32",
        "ss_builder_theme_setting_primary_color": "\u0E2A\u0E35",
        "ss_builder_theme_setting_primary_color_content": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35\u0E2B\u0E25\u0E31\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_theme_setting_primary_color_title": "\u0E2A\u0E35\u0E2B\u0E25\u0E31\u0E01",
        "ss_builder_theme_setting_save_failed_content": "\u0E40\u0E01\u0E34\u0E14\u0E04\u0E27\u0E32\u0E21\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E04\u0E32\u0E14\u0E04\u0E34\u0E14. \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07.",
        "ss_builder_theme_setting_save_failed_title": "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_theme_setting_save_successfully_label": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22",
        "ss_builder_theme_setting_select_background_color_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E35",
        "ss_builder_theme_setting_select_gradient_color_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E44\u0E25\u0E48\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E2A\u0E35",
        "ss_builder_theme_setting_select_solid_color_label": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E35",
        "ss_builder_theme_setting_shadow": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32",
        "ss_builder_theme_setting_shadow_color": "\u0E2A\u0E35\u0E40\u0E07\u0E32",
        "ss_builder_theme_setting_soft_shadow": "\u0E43\u0E2A\u0E48\u0E40\u0E07\u0E32\u0E41\u0E1A\u0E1A\u0E1A\u0E32\u0E07",
        "ss_builder_theme_setting_text": "\u0E1B\u0E38\u0E48\u0E21\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_theme_setting_title": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_theme_small_button_setting": "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E25\u0E47\u0E01",
        "ss_builder_theme_store_label": "Template",
        "ss_builder_theme_store_popover_manual_content": "\u0E17\u0E33\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49 Theme store \u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 \u201C\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u201D",
        "ss_builder_theme_store_popover_manual_title": "Product tour",
        "ss_builder_theme_store_tour_content_step_1": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E18\u0E35\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E18\u0E35\u0E21",
        "ss_builder_theme_store_tour_content_step_2": "Passio Page \u0E21\u0E35\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01 \u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E31\u0E21\u0E1C\u0E31\u0E2A",
        "ss_builder_theme_store_tour_title_step_1": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_theme_store_tour_title_step_2": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_theme_template_format_create_label": "\u0E2A\u0E23\u0E49\u0E32\u0E07",
        "ss_builder_theme_template_label_tag": "\u0E41\u0E17\u0E47\u0E01",
        "ss_builder_theme_template_label_tag_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E41\u0E17\u0E47\u0E01",
        "ss_builder_theme_template_no_option": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
        "ss_builder_theme_template_preview_info": "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E43\u0E0A\u0E49\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21",
        "ss_builder_theme_template_preview_mode_title": "\u0E42\u0E2B\u0E21\u0E14\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_theme_template_search_bar_placeholder": "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E15\u0E32\u0E21\u0E0A\u0E37\u0E48\u0E2D...",
        "ss_builder_theme_template_store_instruction_subtitle": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E18\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_theme_template_store_instruction_title": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E18\u0E35\u0E21\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23!",
        "ss_builder_theme_template_store_title": "Theme store",
        "ss_builder_theme_template_theme_store": "{{num_results}} \u0E18\u0E35\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07(s)",
        "ss_builder_theme_template_view_theme_info": "\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E18\u0E35\u0E21\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
        "ss_builder_theme_template_view_theme_title": "\u0E14\u0E39\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15",
        "ss_builder_title": "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_title_block_affiliate_product": "Affiliate",
        "ss_builder_title_block_bio": "Bio",
        "ss_builder_title_block_booking_profile": "Booking Profile",
        "ss_builder_title_block_booking_profile_description": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E25\u0E34\u0E07\u0E01\u0E4C Booking Profile \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E2A\u0E14\u0E07 Booking Profile \u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32 Passio",
        "ss_builder_title_block_booking_profile_warning": "\u0E2A\u0E23\u0E49\u0E32\u0E07 Booking Profile  \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E19\u0E35\u0E49",
        "ss_builder_title_block_brand_gift": "Brand Gift",
        "ss_builder_title_block_brand_gift_description": "\u0E41\u0E2A\u0E14\u0E07\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E08\u0E32\u0E01\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19\u0E46 \u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E41\u0E25\u0E30\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        "ss_builder_title_block_brand_gift_footer": "\u0E44\u0E2D\u0E04\u0E2D\u0E19 Brand Gift",
        "ss_builder_title_block_brand_rating": "Brand Ratings",
        "ss_builder_title_block_brand_rating_description": "th_B\u1EADt t\xednh n\u0103ng \u0111\u1EC3 t\u0103ng t\u01B0\u01A1ng t\xe1c v\u1EDBi Fan",
        "ss_builder_title_block_button_link": "\u0E25\u0E34\u0E07\u0E04\u0E4C",
        "ss_builder_title_block_button_multi_link": "\u0E21\u0E31\u0E25\u0E15\u0E34\u0E25\u0E34\u0E07\u0E01\u0E4C",
        "ss_builder_title_block_card": "\u0E01\u0E32\u0E23\u0E4C\u0E14",
        "ss_builder_title_block_digital_product": "Digital Product",
        "ss_builder_title_block_donation": "Donation",
        "ss_builder_title_block_embed": "Embed",
        "ss_builder_title_block_image": "\u0E20\u0E32\u0E1E",
        "ss_builder_title_block_image_gallery": "\u0E41\u0E01\u0E25\u0E40\u0E25\u0E2D\u0E23\u0E35\u0E48\u0E20\u0E32\u0E1E",
        "ss_builder_title_block_image_popup": "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1E",
        "ss_builder_title_block_image_slider": "Image Slider",
        "ss_builder_title_block_story": "\u0E2A\u0E1B\u0E2D\u0E23\u0E4C\u0E15\u0E44\u0E25\u0E17\u0E4C",
        "ss_builder_title_block_tab_bar": "Tab Menu",
        "ss_builder_title_block_text": "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
        "ss_builder_title_block_truth_or_dare": "Truth Or Dare",
        "ss_builder_title_block_truth_or_dare_footer": "Truth Or Dare Icon",
        "ss_builder_title_block_video_shoutout": "Video Shoutout",
        "ss_builder_title_block_video_shoutout_description": "\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E08\u0E32\u0E01\u0E44\u0E2D\u0E14\u0E2D\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        "ss_builder_title_block_virtual_gift": "Virtual Gift",
        "ss_builder_title_block_virtual_gift_footer": "Virtual Gift Icon",
        "ss_builder_title_brand_gift_footer": "\u0E44\u0E2D\u0E04\u0E2D\u0E19 Brand Gift",
        "ss_builder_title_color": "\u0E2A\u0E35",
        "ss_builder_title_combined": "\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E23\u0E27\u0E21",
        "ss_builder_title_introduction_service": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_title_page_builder": "Passio Page Builder",
        "ss_builder_title_setting_title": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D",
        "ss_builder_title_spacer_and_divider": "Spacer & Divider",
        "ss_builder_to_add_products_please_press_the_add_button_above": '\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1E\u0E34\u0E48\u0E21" \u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19',
        "ss_builder_to_new_version": "\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32 Passio Page",
        "ss_builder_top_position_tab_label": "\u0E1A\u0E19",
        "ss_builder_transparent": "\u0E04\u0E27\u0E32\u0E21\u0E42\u0E1B\u0E23\u0E48\u0E07\u0E43\u0E2A",
        "ss_builder_truth_or_dare_warning": "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E14\u0E35\u0E22\u0E27\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19",
        "ss_builder_try_another_keyword_theme_store": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E14\u0E2D\u0E37\u0E48\u0E19",
        "ss_builder_try_new_key": "\u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E14\u0E2D\u0E37\u0E48\u0E19\u0E46",
        "ss_builder_type_label": "\u0E0A\u0E19\u0E34\u0E14",
        "ss_builder_type_of_color": "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E35",
        "ss_builder_undo_theme_label": "\u0E40\u0E25\u0E34\u0E01\u0E17\u0E33",
        "ss_builder_update_account": "\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
        "ss_builder_upload_button_label": "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E20\u0E32\u0E1E",
        "ss_builder_upload_file_format_invalid_content": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_file_format_invalid_content_for_gif_png_svg": "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E20\u0E32\u0E1E\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E43\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2B\u0E19\u0E36\u0E48\u0E07: GIF, PNG, SVG",
        "ss_builder_upload_file_format_invalid_content_v2": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP",
        "ss_builder_upload_file_size_invalid_content": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 30MB",
        "ss_builder_upload_file_size_invalid_content_min_256": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33 256x256px",
        "ss_builder_upload_large_file_format_invalid_content": "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A: JPG, JPEG, GIF, PNG, BMP, WebP",
        "ss_builder_upload_large_file_size_invalid_content": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 50MB",
        "ss_builder_uploading_image": "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_builder_url_error_content": "\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        "ss_builder_url_placeholder": "\u0E1B\u0E49\u0E2D\u0E19 URL",
        "ss_builder_use_advanced_setting_description": "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25\u0E02\u0E2D\u0E07\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E23\u0E27\u0E21\u0E19\u0E35\u0E49",
        "ss_builder_use_affiliate_link_description": "\u0E15\u0E34\u0E4A\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49 Affiliate Link \u0E02\u0E2D\u0E07 Ecomobi Passio \u0E25\u0E1A\u0E15\u0E34\u0E4A\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E15\u0E49\u0E19\u0E09\u0E1A\u0E31\u0E1A",
        "ss_builder_use_affiliate_link_label": "\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E02\u0E2D\u0E07 Ecomobi Passio",
        "ss_builder_use_ecomobi_tracking_link": "\u0E43\u0E0A\u0E49\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E02\u0E2D\u0E07 Ecomobi Passio",
        "ss_builder_validate_gen_link_error_E1": "\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_builder_validate_gen_link_error_E2": "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E25\u0E47\u0E2D\u0E04 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19",
        "ss_builder_validate_gen_link_error_E3": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E41\u0E2D\u0E1F\u0E1F\u0E34\u0E25\u0E34\u0E40\u0E2D\u0E17 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19",
        "ss_builder_validate_gen_link_error_E5": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E19\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D",
        "ss_builder_validate_gen_link_error_E6": "\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E19\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E19\u0E35\u0E49",
        "ss_builder_validate_gen_link_error_E7": "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E22\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E1A",
        "ss_builder_validate_gen_link_error_E8": "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E19\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E2B\u0E22\u0E38\u0E14\u0E0A\u0E31\u0E48\u0E27\u0E04\u0E23\u0E32\u0E27",
        "ss_builder_video_shoutout_answer_method_description": "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E41\u0E1F\u0E19 \u0E46 \u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_builder_video_shoutout_answer_method_title": "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A",
        "ss_builder_video_shoutout_btn_setup": "\u0E15\u0E31\u0E49\u0E07\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
        "ss_builder_video_shoutout_des_intro_fan": "\u0E04\u0E38\u0E13\u0E21\u0E35 7 \u0E27\u0E31\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E41\u0E1F\u0E19 \u0E46 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E17\u0E35\u0E48\u0E08\u0E30\u0E17\u0E33 Ecomobi \u0E08\u0E30\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E20\u0E32\u0E22\u0E43\u0E19 30 \u0E27\u0E31\u0E19",
        "ss_builder_video_shoutout_des_intro_gift": "\u0E1C\u0E48\u0E32\u0E19 Passio \u0E41\u0E1F\u0E19 \u0E46 \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E43\u0E19\u0E42\u0E2D\u0E01\u0E32\u0E2A\u0E1E\u0E34\u0E40\u0E28\u0E29: \u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14, \u0E02\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E14\u0E35, \u0E27\u0E31\u0E19\u0E04\u0E23\u0E1A\u0E23\u0E2D\u0E1A, \u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E08\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D, \u0E41\u0E23\u0E07\u0E1A\u0E31\u0E19\u0E14\u0E32\u0E25\u0E43\u0E08 ... \u0E14\u0E49\u0E27\u0E22\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07",
        "ss_builder_video_shoutout_des_intro_policy": "\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E41\u0E1F\u0E19 \u0E46 \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E17\u0E35\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E04\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E2A\u0E31\u0E07\u0E04\u0E21\u0E2D\u0E2D\u0E19\u0E44\u0E25\u0E19\u0E4C",
        "ss_builder_video_shoutout_how_to_work": "\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D Shoutout \u0E17\u0E33\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23?",
        "ss_builder_video_shoutout_introduction": "Video Shoutout \u0E40\u0E1B\u0E47\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19 \u0E46 \u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E2D\u0E01\u0E32\u0E2A\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E0A\u0E48\u0E19\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E01\u0E32\u0E23\u0E28\u0E36\u0E01\u0E29\u0E32\u0E02\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E14\u0E35 ... \u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E30\u0E15\u0E2D\u0E1A\u0E2A\u0E19\u0E2D\u0E07\u0E15\u0E48\u0E2D\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E01\u0E31\u0E1A\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E01\u0E31\u0E1A\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E01\u0E31\u0E1A\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D.",
        "ss_builder_video_shoutout_participate_description": "\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E08\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E41\u0E1F\u0E19 \u0E46",
        "ss_builder_video_shoutout_participate_title": "\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13",
        "ss_builder_video_shoutout_response_description": "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E41\u0E1F\u0E19 \u0E46 \u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E21\u0E35\u0E40\u0E27\u0E25\u0E32 7 \u0E27\u0E31\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E27\u0E25\u0E32\u0E19\u0E35\u0E49\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E02\u0E2D\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E41\u0E1F\u0E19 \u0E46",
        "ss_builder_video_shoutout_response_title": "\u0E40\u0E27\u0E25\u0E32\u0E15\u0E2D\u0E1A\u0E2A\u0E19\u0E2D\u0E07",
        "ss_builder_video_shoutout_title_intro": "\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_builder_video_shoutout_title_intro_fan": "\u0E17\u0E33\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_builder_video_shoutout_title_intro_gift": "\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E08\u0E32\u0E01\u0E41\u0E1F\u0E19 \u0E46",
        "ss_builder_video_shoutout_title_intro_policy": "\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E21\u0E32\u0E22",
        "ss_builder_virtual_gift_list_title": "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D",
        "ss_builder_wait_for_saving": "\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48.",
        "ss_builder_warning_brand_gift_floating_continue": "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        "ss_builder_warning_brand_gift_floating_description": "\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E15\u0E47\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E25\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E43\u0E19\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E02\u0E22\u0E32\u0E22 \u0E14\u0E39",
        "ss_builder_warning_brand_gift_floating_description_link": "\u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33\u0E42\u0E14\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14",
        "ss_builder_warning_brand_gift_floating_reject": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_builder_warning_brand_gift_floating_title": "\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E2D\u0E22\u0E40\u0E15\u0E47\u0E21",
        "ss_builder_warning_brand_gift_rating_description": "th_Hi\u1EC7n t\u1EA1i th\xe2n trang \u0111\xe3 \u0111\u1EA1t t\u1EDBi gi\u1EDBi h\u1EA1n hi\u1EC3n th\u1ECB. B\u1EA1n c\u1EA7n xo\xe1 b\u1EDBt kh\u1ED1i \u0111\u1EC3 b\u1EADt t\xednh n\u0103ng Brand Ratings",
        "ss_builder_warning_brand_rating_floating_continue": "th_\u0110\xe3 hi\u1EC3u",
        "ss_builder_warning_brand_rating_floating_title": "th_Brand Ratings",
        "ss_builder_web_browser": "\u0E40\u0E27\u0E47\u0E1A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
        "ss_builder_web_label": "Ss Builder Web Label",
        "ss_builder_website_config_site_title_description": "\u0E41\u0E2A\u0E14\u0E07\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E2A\u0E38\u0E14\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E2A\u0E21\u0E2D\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E41\u0E1F\u0E19 \u0E46 \u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21",
        "ss_builder_website_config_site_title_label": "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C",
        "ss_builder_website_config_site_title_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_builder_what_field_are_you_operating_in": "\u0E04\u0E38\u0E13\u0E17\u0E33\u0E07\u0E32\u0E19\u0E14\u0E49\u0E32\u0E19\u0E44\u0E2B\u0E19",
        "ss_builder_what_went_wrong": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
        "ss_builder_width_tab_setting_label": "Tab width",
        "ss_builder_width_tab_type_1": "\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        "ss_builder_width_tab_type_2": "\u0E41\u0E1A\u0E48\u0E07\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E19",
        "ss_builder_your_page_is_ready": "\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E1A\u0E42\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E41\u0E25\u0E49\u0E27!",
        "ss_cancle_delete": "Cancel",
        "ss_challenge": "\u0E01\u0E32\u0E23\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22",
        "ss_confirm_delete": "Confirm delete",
        "ss_content_confirm_delete": "Are you sure you want to delete this product?",
        "ss_content_delete_forever": "\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
        "ss_content_intro_dp": "Digital products are understood as online products, not grasped, containing useful content for users. For example: Video, photos, ebook, online course, ..",
        "ss_content_item1_dp": "Depending on your strengths and desires, Passio offers a full range of digital products such as photos, videos, online courses, ebooks, links, ...",
        "ss_content_item2_dp": "With less than 3 minutes, you can configure and sell a new digital product. Moreover, after the buyer successfully buys, the product will be sent immediately to their email, helping to simplify shipping and save time",
        "ss_content_success_TOD": "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34 Truth \u0E2B\u0E23\u0E37\u0E2D Dare \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_cover_image": "\u0E20\u0E32\u0E1E\u0E2B\u0E19\u0E49\u0E32\u0E1B\u0E01",
        "ss_cover_image_empty": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_cover_image_helper": "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19: JPG, JPEG, GIF, PNG, BMP, WebP, max 4MB",
        "ss_cover_image_upload": "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        "ss_delete_forever": "\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E16\u0E32\u0E27\u0E23",
        "ss_delete_product": "Delete display",
        "ss_display_delete": "Delete display",
        "ss_donation_currency_shortcut": "\u0E3F",
        "ss_donation_setting_default_content_setup_donation": "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E42\u0E14\u0E40\u0E19\u0E17\u0E17\u0E35\u0E48 account.passio.eco",
        "ss_donation_setting_default_title_setup_donation": "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_dp_add": "Add",
        "ss_dp_cat_course": "\u0E04\u0E2D\u0E23\u0E4C\u0E2A",
        "ss_dp_cat_ebook_document": "Ebook/Document",
        "ss_dp_cat_online_consultion": "Online consulting 1-1",
        "ss_dp_cat_random_product": "Products any",
        "ss_dp_cat_ticket_account": "\u0E15\u0E31\u0E4B\u0E27 / \u0E41\u0E2D\u0E04\u0E40\u0E04\u0E32\u0E17\u0E4C",
        "ss_dp_cat_video": "Exclusive video",
        "ss_dp_sell_photo": "\u0E23\u0E39\u0E1B",
        "ss_edit_TOD": "\u0E41\u0E01\u0E49\u0E44\u0E02",
        "ss_example_TOD": "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07: 100,000",
        "ss_exit_TOD": "\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A",
        "ss_first_person": "\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E19\u0E41\u0E23\u0E01\u0E17\u0E35\u0E48\u0E08\u0E30\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49!",
        "ss_gift_button_preview": "\u0E2A\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E17\u0E31\u0E19\u0E17\u0E35!",
        "ss_gift_invitation": "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49 {user} \u0E21\u0E35\u0E41\u0E23\u0E07\u0E08\u0E39\u0E07\u0E43\u0E08\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19\u0E21\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E17\u0E31\u0E19\u0E17\u0E35",
        "ss_had": "\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
        "ss_iframe_add_new_product": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E43\u0E2B\u0E21\u0E48",
        "ss_iframe_add_product": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
        "ss_iframe_choose_product_from_store": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E04\u0E25\u0E31\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
        "ss_inline_image_empty": "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E1F\u0E34\u0E25\u0E14\u0E4C\u0E19\u0E35\u0E49",
        "ss_inline_txtbtn_max_length": "\u0E1F\u0E34\u0E25\u0E14\u0E4C\u0E19\u0E35\u0E49\u0E40\u0E01\u0E34\u0E19 40 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
        "ss_input_placehoder": "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_invitation_TOD": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E40\u0E0A\u0E34\u0E0D\u0E0A\u0E27\u0E19\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22",
        "ss_invitation_TOD_placeholder": "\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E40\u0E0A\u0E34\u0E0D\u0E41\u0E1F\u0E19\u0E46\u0E17\u0E38\u0E01\u0E04\u0E19 \u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
        "ss_logout": "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
        "ss_modal_cancel_confirm": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        "ss_modal_text_confirm": "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E2B\u0E32\u0E23",
        "ss_no": "\u0E44\u0E21\u0E48",
        "ss_placeholder_message_TOD": "\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22",
        "ss_preview_TOD": "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
        "ss_profile": "\u0E44\u0E1F\u0E25\u0E4C",
        "ss_push_TOD": "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14",
        "ss_rount_tod": "\u0E23\u0E2D\u0E1A\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22",
        "ss_service_introduction": "\u0E41\u0E19\u0E30\u0E19\u0E33\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
        "ss_setting_TOD_background_tooltip": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E14\u0E49\u0E27\u0E22\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2A\u0E48\u0E27\u0E19 3: 2 \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E08\u0E38\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 4 MB",
        "ss_setting_TOD_field_image_background": "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E27\u0E2D\u0E25\u0E25\u0E4C\u0E40\u0E1B\u0E40\u0E1B\u0E2D\u0E23\u0E4C",
        "ss_setting_TOD_field_image_background_bottom": "\u0E20\u0E32\u0E1E\u0E1E\u0E37\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07",
        "ss_setting_TOD_field_welcome_tooltip": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E40\u0E23\u0E35\u0E22\u0E01\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19\u0E46\u0E17\u0E38\u0E01\u0E04\u0E19 \u0E21\u0E32\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E08\u0E30\u0E01\u0E23\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E44\u0E27\u0E49",
        "ss_setup_now": "Set now",
        "ss_shoutout_btn_content": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1B\u0E38\u0E48\u0E21",
        "ss_shoutout_change_file": "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E/\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_shoutout_create_request": "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E17\u0E31\u0E19\u0E17\u0E35",
        "ss_shoutout_description": "\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22",
        "ss_shoutout_description_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E17\u0E19\u0E33",
        "ss_shoutout_error_price_required": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E32\u0E04\u0E32",
        "ss_shoutout_error_upload": "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_shoutout_error_video_size": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E/ \u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 500MB",
        "ss_shoutout_error_video_type": "\u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E44\u0E1F\u0E25\u0E4C\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19 JPG, JPEG, GIF, PNG, BMP, Webp, Heic, Heic, Heic, MP4, MOV",
        "ss_shoutout_file_intro": "\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E/\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_shoutout_file_intro_note": "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E42\u0E17\u0E23\u0E2B\u0E32\u0E41\u0E1F\u0E19 \u0E46 \u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D Shoutout \u0E08\u0E32\u0E01\u0E04\u0E38\u0E13",
        "ss_shoutout_no_file_selected": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E/\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_shoutout_price": "\u0E23\u0E32\u0E04\u0E32",
        "ss_shoutout_price_placeholder": "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E32\u0E04\u0E32",
        "ss_shoutout_select_file": "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E/\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D",
        "ss_shoutout_type_support": "\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19: JPG, JPEG, GIF, PNG, BMP, Webp, Heif, Heic, MP4, Mov \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 500MB",
        "ss_shoutout_upload_success": "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D\u0E2A\u0E39\u0E48\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_success_TOD": "\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_success_off_TOD": "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E34\u0E14\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34 Truth \u0E2B\u0E23\u0E37\u0E2D Dare \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_success_on_TOD": "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E1B\u0E34\u0E14\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34 Truth \u0E2B\u0E23\u0E37\u0E2D Dare \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_success_setup_TOD": "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34 Truth \u0E2B\u0E23\u0E37\u0E2D Dare \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
        "ss_title_intro_dp": "What is digital product",
        "ss_title_item1_dp": "Diverse types of products for you to choose",
        "ss_title_item2_dp": "Easy to manage products and orders with a few operations",
        "ss_tod_challenge_number": "th_\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E17\u0E49\u0E32",
        "ss_tod_content": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D",
        "ss_tod_dare_content": "\u0E40\u0E0A\u0E34\u0E0D\u0E0A\u0E27\u0E19\u0E41\u0E1F\u0E19\u0E46 \u0E21\u0E32\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E17\u0E49\u0E32",
        "ss_tod_dare_fee": "\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E17\u0E35\u0E48\u0E41\u0E1F\u0E19\u0E08\u0E48\u0E32\u0E22\u0E43\u0E2B\u0E49\u0E2D\u0E2D\u0E23\u0E4C\u0E40\u0E14\u0E2D\u0E23\u0E4C Dare",
        "ss_tod_default_content": "\u0E25\u0E2D\u0E07\u0E40\u0E25\u0E22 \u0E01\u0E25\u0E31\u0E27\u0E2D\u0E30\u0E44\u0E23\u0E40\u0E2D\u0E48\u0E22",
        "ss_tod_default_dare_content": "\u0E41\u0E01\u0E25\u0E49\u0E07\u0E44\u0E14\u0E49 \u0E41\u0E01\u0E25\u0E49\u0E07\u0E44\u0E1B! \u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E21\u0E32\u0E43\u0E2B\u0E49\u0E09\u0E31\u0E19\u0E2A\u0E34",
        "ss_tod_min_price_dare_alias": "\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E17\u0E35\u0E48\u0E41\u0E1F\u0E19\u0E08\u0E48\u0E32\u0E22\u0E43\u0E2B\u0E49\u0E2D\u0E2D\u0E23\u0E4C\u0E40\u0E14\u0E2D\u0E23\u0E4C Dare",
        "ss_tod_min_price_dare_note": "\u0E0A\u0E33\u0E23\u0E30\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E1A\u0E32\u0E17",
        "ss_tod_setting_cover_image": "\u0E20\u0E32\u0E1E\u0E2B\u0E19\u0E49\u0E32\u0E1B\u0E01",
        "ss_tod_setting_cover_image_helper": "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19: JPG, JPEG, GIF, PNG, BMP, WebP, max 4MB",
        "ss_tod_setting_field_welcome_tooltip": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E40\u0E23\u0E35\u0E22\u0E01\u0E43\u0E2B\u0E49\u0E41\u0E1F\u0E19\u0E46\u0E17\u0E38\u0E01\u0E04\u0E19 \u0E21\u0E32\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E08\u0E30\u0E01\u0E23\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E44\u0E27\u0E49",
        "ss_tod_setting_input_placehoder": "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32",
        "ss_tod_tooltip_content": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 60 \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30",
        "ss_tod_tooltip_min_price_dare": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E04\u0E33\u0E40\u0E0A\u0E34\u0E0D\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 60 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
        "ss_txt_btn_TOD": "\u0E41\u0E1F\u0E19\u0E46\u0E17\u0E38\u0E01\u0E04\u0E19 \u0E2A\u0E48\u0E07\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E21\u0E32\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22",
        "ss_validate_domain_error_E1": "\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E20\u0E32\u0E22\u0E43\u0E19 30 \u0E27\u0E31\u0E19 \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
        "ss_validate_domain_error_E2": "\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E2D\u0E37\u0E48\u0E19",
        "ss_validate_domain_error_E3": "\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E41\u0E1A\u0E19",
        "ss_validate_origin_url_error_E203": "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E40\u0E21\u0E19\u0E19\u0E35\u0E49 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E30\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        "ss_validate_origin_url_error_E5": "\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E02\u0E2D\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D",
        "ss_validate_origin_url_error_E6": "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E43\u0E19\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E31\u0E1A\u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
        "ss_validate_origin_url_error_E7": "\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A URL \u0E19\u0E35\u0E49",
        "ss_validate_origin_url_error_E9": "\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E25\u0E07\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01 URL \u0E2D\u0E37\u0E48\u0E19",
        "ss_validate_origin_url_error_V0": "URL \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_validate_origin_url_error_sys": "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01 URL \u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        "ss_validate_origin_url_warning_E5": "\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E19\u0E35\u0E49 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_validate_origin_url_warning_E7": "\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "ss_validate_origin_url_warning_E9": "\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E19\u0E35\u0E49\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
        "text_cashback_brand_gift": "Cashback",
        "text_custom_brand_gift": "\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07",
        "text_voucher_brand_gift": "Voucher",
        "undefined": "Undefined",
        "voucher_default_text_button": "\u0E23\u0E31\u0E1A\u0E40\u0E27\u0E32\u0E40\u0E0A\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49!",
        "voucher_default_title": "\u0E41\u0E15\u0E30\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E48\u0E32\u0E22 \u0E23\u0E31\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19 5%",
        "warning_text_TOD": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
        "warning_text_switch_TOD": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1B\u0E34\u0E14\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34 Truth \u0E2B\u0E23\u0E37\u0E2D Dare \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48"
    }
};
/* harmony default export */ var messages_th = (th);

;// CONCATENATED MODULE: ./src/messages/index.ts




var resource = {
    en: messages_en,
    vi: messages_vi,
    id: messages_id,
    th: messages_th
};
/* harmony default export */ var messages = (resource);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js
var context = __webpack_require__(68718);
;// CONCATENATED MODULE: ./src/app/i18n.ts



i18next/* default.use */.ZP.use(context/* initReactI18next */.Db) // passes i18n down to react-i18next
.init({
    resources: messages,
    lng: "en",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
        escapeValue: false
    }
}).then(function(r) {});
/* harmony default export */ var i18n = (i18next/* default */.ZP);


/***/ }),

/***/ 71214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeaderTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64035);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function HeaderTitle(props) {
    var title = props.title, _enableClose = props.enableClose, enableClose = _enableClose === void 0 ? true : _enableClose, _onClose = props.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "panel-header px-2 py-3 text-center relative items-center border-b",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[15px]",
                children: title
            }),
            enableClose ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "cursor-pointer absolute right-[12px] top-[50%] translate-y-[-50%] tr p-1",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ClosePopupIcon */ .Hn, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
};


/***/ }),

/***/ 51039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InnerPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function InnerPopup(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .GI, _objectSpread({}, props, {
        className: className ? "".concat(className, " inner-popup eco-popup") : "inner-popup eco-popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "m-auto w-full bg-white max-w-[500px] rounded-t-lg",
            children: props.children
        })
    }));
};


/***/ }),

/***/ 57457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E2": function() { return /* binding */ checkIntroDigitalProduct; },
  "Gc": function() { return /* binding */ deleteBlock; },
  "PM": function() { return /* binding */ saveAttributes; },
  "K1": function() { return /* binding */ saveBlock; },
  "cN": function() { return /* binding */ saveIntroDigitalProduct; },
  "Ro": function() { return /* binding */ saveTabsAttributes; },
  "K6": function() { return /* binding */ sortBlock; }
});

// UNUSED EXPORTS: requestUploadImageUrlFromJson

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/share/api/createAxios.ts
var createAxios = __webpack_require__(88549);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 91 modules
var block_conf = __webpack_require__(60920);
// EXTERNAL MODULE: ./src/features/block/libs/index.ts
var libs = __webpack_require__(22814);
;// CONCATENATED MODULE: ./src/features/block/config/constants.ts
var LIMITED_PAYLOAD_SIZE = 1024 * 1024; //1MB
var CHUNK_PAYLOAD_SIZE = 0.5 * 1024 * 1024; //500KB

;// CONCATENATED MODULE: ./src/features/block/api/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var API_PATH = {
    BLOCK: "/api/v1/builder/block",
    SORT_BLOCK: "/api/v1/builder/block/sort",
    SAVE_ATTRIBUTES: "api/v1/builder/block/save-attributes",
    SAVE_TABS_ATTRIBUTE: "api/v1/builder/block/save-tabs-attribute",
    SAVE_INTRO_DIGITAL_PRODUCT: "/api/mini-store/v1/catalog/save-has-intro-dp",
    CHECK_INTRO_DIGITAL_PRODUCT: "/api/mini-store/v1/catalog/check-has-intro-dp",
    UPLOAD_IMAGE_URL_FROM_JSON_FILE: "/api/v1/builder/block/aff/update-image-from-json"
};
var gatewayInstance = (0,createAxios/* CreateGatewayAxios */.Ev)();
var saveBlock = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(baseUpdateData, block) {
        var ref3, blockString, byteSize, response, totalChunks, chunkNumber, start, end, chunk, blockDataResponse, ref1, ref2, isUpdateImageUrlJson;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    blockString = JSON.stringify(block);
                    byteSize = new TextEncoder().encode(blockString).length;
                    response = null;
                    if (!(byteSize >= LIMITED_PAYLOAD_SIZE)) {
                        _ctx.next = 19;
                        break;
                    }
                    totalChunks = Math.ceil((blockString === null || blockString === void 0 ? void 0 : blockString.length) / CHUNK_PAYLOAD_SIZE);
                    chunkNumber = 0;
                case 7:
                    if (!(chunkNumber < totalChunks)) {
                        _ctx.next = 17;
                        break;
                    }
                    start = chunkNumber * CHUNK_PAYLOAD_SIZE;
                    end = (chunkNumber + 1) * CHUNK_PAYLOAD_SIZE;
                    chunk = blockString === null || blockString === void 0 ? void 0 : blockString.slice(start, end);
                    _ctx.next = 13;
                    return gatewayInstance.post(API_PATH.BLOCK, _objectSpread({}, baseUpdateData, {
                        payloadChunk: chunk,
                        chunkNumber: chunkNumber,
                        totalChunks: totalChunks
                    }));
                case 13:
                    response = _ctx.sent;
                case 14:
                    chunkNumber++;
                    _ctx.next = 7;
                    break;
                case 17:
                    _ctx.next = 22;
                    break;
                case 19:
                    _ctx.next = 21;
                    return gatewayInstance.post(API_PATH.BLOCK, _objectSpread({}, baseUpdateData, {
                        data: block
                    }));
                case 21:
                    response = _ctx.sent;
                case 22:
                    blockDataResponse = response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.data;
                    if (!((blockDataResponse === null || blockDataResponse === void 0 ? void 0 : blockDataResponse.block_type) === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP)) {
                        _ctx.next = 29;
                        break;
                    }
                    ;
                    isUpdateImageUrlJson = blockDataResponse === null || blockDataResponse === void 0 ? void 0 : (ref1 = blockDataResponse.content_attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.some(function(group) {
                        if (group) {
                            var ref;
                            var products = (group === null || group === void 0 ? void 0 : (ref = group.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
                            return !!((0,libs/* isExistedProductFromJson */.gJ)(products) && (0,libs/* isExistedInvalidImageUrl */.ZB)(products));
                        }
                    });
                    if (!isUpdateImageUrlJson) {
                        _ctx.next = 29;
                        break;
                    }
                    _ctx.next = 29;
                    return requestUploadImageUrlFromJson();
                case 29:
                    return _ctx.abrupt("return", response);
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveBlock(baseUpdateData, block) {
        return _ref.apply(this, arguments);
    };
}();
var deleteBlock = function(baseUpdateData, blockId) {
    return gatewayInstance.delete(API_PATH.BLOCK, {
        params: _objectSpread({}, baseUpdateData, {
            id: blockId
        })
    });
};
var sortBlock = function(baseUpdateData, sortData) {
    return gatewayInstance.post(API_PATH.SORT_BLOCK, _objectSpread({}, baseUpdateData, {
        data: sortData
    }));
};
var saveAttributes = function(baseUpdateData, id, data) {
    return gatewayInstance.post(API_PATH.SAVE_ATTRIBUTES, _objectSpread({}, baseUpdateData, {
        data: {
            id: id,
            data: data
        }
    }));
};
var saveTabsAttributes = function(baseUpdateData, id, data) {
    return gatewayInstance.post(API_PATH.SAVE_TABS_ATTRIBUTE, _objectSpread({}, baseUpdateData, {
        data: {
            id: id,
            tabs: data
        }
    }));
};
var saveIntroDigitalProduct = function() {
    return gatewayInstance.post(API_PATH.SAVE_INTRO_DIGITAL_PRODUCT);
};
var checkIntroDigitalProduct = function() {
    return gatewayInstance.get(API_PATH.CHECK_INTRO_DIGITAL_PRODUCT);
};
var requestUploadImageUrlFromJson = function() {
    return gatewayInstance.put(API_PATH.UPLOAD_IMAGE_URL_FROM_JSON_FILE);
};


/***/ }),

/***/ 91937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55016);
/* harmony import */ var _share_helper_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52741);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31567);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var DetectedUrlLists = function(props) {
    var onCancel = props.onCancel, urlLists = props.urlLists;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)().t;
    var popoverRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var styleRender = function(data) {
        var style = {
            marginTop: "12px",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#FFFFFF"
        };
        switch(data){
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.DUPLICATE */ .oL.DUPLICATE:
                style = _objectSpread({}, style, {
                    border: "1px solid #FF8F1F"
                });
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.INVALID */ .oL.INVALID:
                style = _objectSpread({}, style, {
                    border: "1px solid #FF3141"
                });
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.NOT_ADDED_YET */ .oL.NOT_ADDED_YET:
                style = _objectSpread({}, style, {
                    border: "1px solid #EEEEEE"
                });
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.SUCCESS */ .oL.SUCCESS:
                style = _objectSpread({}, style, {
                    border: "1px solid #00B578"
                });
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.MISSING_REQUIRED */ .oL.MISSING_REQUIRED:
                style = _objectSpread({}, style, {
                    border: "1px solid #1890FF"
                });
                break;
            default:
                style = _objectSpread({}, style, {
                    border: "1px solid #00B578"
                });
                break;
        }
        return style;
    };
    var iconRender = function(data) {
        var iconElement = null;
        var contentPopover = "";
        switch(data){
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.DUPLICATE */ .oL.DUPLICATE:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .DuplicatedIcon */ .Kp, {
                    className: "w-[15px] h-[15px]",
                    fillColor: "#FF8F1F"
                });
                contentPopover = t("ss_builder_duplicated_product_url_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.INVALID */ .oL.INVALID:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .InfomationCircleIcon */ .Hw, {
                    className: "w-[15px] h-[15px]",
                    fillColor: "#FF3141"
                });
                contentPopover = t("ss_builder_invalid_product_url_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.NOT_ADDED_YET */ .oL.NOT_ADDED_YET:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .CircleIcon */ .J$, {
                    className: "w-[15px] h-[15px]"
                });
                contentPopover = t("ss_builder_not_add_yet_product_url_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.SUCCESS */ .oL.SUCCESS:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckCircleIcon */ .rE, {
                    className: "w-[15px] h-[15px]",
                    fillColor: "#00B578"
                });
                contentPopover = t("ss_builder_added_product_url_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_URL_CHECKING.MISSING_REQUIRED */ .oL.MISSING_REQUIRED:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .RenameIcon */ .xj, {
                    className: "w-[15px] h-[15px]",
                    fillColor: "#1890FF"
                });
                contentPopover = t("ss_builder_missing_required_product_url_label");
                break;
            default:
                iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckCircleIcon */ .rE, {
                    className: "w-[15px] h-[15px]",
                    fillColor: "#00B578"
                });
                contentPopover = t("ss_builder_added_product_url_label");
                break;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Popover */ .J2, {
            content: contentPopover,
            trigger: "click",
            placement: "top",
            mode: "dark",
            stopPropagation: [
                "click"
            ],
            getContainer: function() {
                return popoverRef.current;
            },
            children: iconElement
        });
    };
    var copyLinkProduct = function(value) {
        (0,_share_helper_browser__WEBPACK_IMPORTED_MODULE_6__/* .copyToClipboard */ .v)(value);
        antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_personal_link_coppy_successfully_label")
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .NavBar */ .l2, {
                backArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .BackAngelIcon */ .Nz, {}),
                onBack: onCancel,
                className: "max-width-content-class w-full bg-[#FFFFFF] fixed top-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-row text-center items-center justify-center gap-[10px] text-[13px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-titleFontSize",
                        children: t("ss_builder_product_url_lists_label")
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-5 px-3 pt-[45px]",
                children: urlLists === null || urlLists === void 0 ? void 0 : urlLists.map(function(ele, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: styleRender(ele === null || ele === void 0 ? void 0 : ele.valid_type),
                        ref: popoverRef,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "py-[10px] px-[11px]",
                                style: {
                                    borderRight: "1px solid #EEEEEE"
                                },
                                children: index < 9 ? "0".concat(index + 1) : index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center gap-1 py-[10px] px-[11px] grow w-[20vw] md:w-[84%]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "cursor-pointer",
                                        children: iconRender(ele === null || ele === void 0 ? void 0 : ele.valid_type)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-[15px] grow",
                                        children: ele === null || ele === void 0 ? void 0 : ele.url
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cursor-pointer py-[10px] px-[11px]",
                                onClick: function() {
                                    return copyLinkProduct(ele === null || ele === void 0 ? void 0 : ele.url);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .CoppyIcon */ .ef, {
                                    className: "w-4 h-4"
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DetectedUrlLists);


/***/ }),

/***/ 54925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "om": function() { return /* binding */ STEP_INDEX; },
/* harmony export */   "qU": function() { return /* binding */ AFFILIATE_ADD_NEW_TOUR_CLASS_NAME; }
/* harmony export */ });
var AFFILIATE_ADD_NEW_TOUR_CLASS_NAME = {
    STEP_1: "affiliate-add-new-group-selection",
    STEP_2: "affiliate-add-new-link-detect-input",
    STEP_3: "affiliate-add-new-product-detect-information",
    STEP_4: "affiliate-add-new-button-group"
};
var STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
    STEP_4: 3
};
var steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-add-new-tour-step-1.gif",
        title_key: "ss_builder_affiliate_add_new_tour_title_step_1",
        intro_key: "ss_builder_affiliate_add_new_tour_content_step_1",
        element_class: AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-add-new-tour-step-2.gif",
        title_key: "ss_builder_affiliate_add_new_tour_title_step_2",
        intro_key: "ss_builder_affiliate_add_new_tour_content_step_2",
        element_class: AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "",
        position: "bottom-middle-aligned"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-add-new-tour-step-3.gif",
        title_key: "ss_builder_affiliate_add_new_tour_title_step_3",
        intro_key: "ss_builder_affiliate_add_new_tour_content_step_3",
        element_class: AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_3,
        tooltip_class: "",
        position: "top"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-add-new-tour-step-4.gif",
        title_key: "ss_builder_affiliate_add_new_tour_title_step_4",
        intro_key: "ss_builder_affiliate_add_new_tour_content_step_4",
        element_class: AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_4,
        tooltip_class: "show-label-text product-tour-custom",
        position: "top"
    }, 
];


/***/ }),

/***/ 84825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateProductGroup_AffiliateProductAddNew; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/user/userApi.ts
var userApi = __webpack_require__(63681);
// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var api = __webpack_require__(85861);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupPickerView/index.tsx
var AffiliateProductGroupPickerView = __webpack_require__(63542);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductItem/index.tsx
var ProductItem = __webpack_require__(35501);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/AutoCleanupProductsWarning/index.tsx




var AutoCleanupProductsWarning = function(param) {
    var isShowWarning = param.isShowWarning;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isShowWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-[12px_16px] bg-[#FFFFFF]",
            style: {
                border: "1px solid #EEEEEE"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-left items-center text-[13px] leading-[17px] gap-2 bg-[#FFF9ED] p-3 rounded-lg",
                style: {
                    border: "1px dashed #FFD591"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                            className: "w-4 h-4",
                            fillColor: "#FF8F1F"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_auto_cleanup_products_warning_content_1")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_auto_cleanup_products_warning_content_2")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var AffiliateProductAddNew_AutoCleanupProductsWarning = (AutoCleanupProductsWarning);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/ProductAddNewTourOpening/affiliate-add-new-tour-config.ts
var affiliate_add_new_tour_config = __webpack_require__(54925);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/ProductAddNewInput/index.tsx







var ProductAddNewInput = function(props) {
    var detectProductUrl = props.detectProductUrl, onChangeProductLink = props.onChangeProductLink, onPasteProductLink = props.onPasteProductLink, disabledInput = props.disabledInput, disabledAddMoreBtn = props.disabledAddMoreBtn, onClickAddMoreBtn = props.onClickAddMoreBtn, onClickStopBtn = props.onClickStopBtn, isValidUrl = props.isValidUrl, isLoadingBtn = props.isLoadingBtn;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isLoadingBtn) {
            var textarea = document.querySelector(".detect-product-link-textarea");
            textarea.style.cssText = "height:auto; padding:0";
        }
    }, [
        isLoadingBtn
    ]);
    (0,react.useEffect)(function() {
        var autosize = function autosize() {
            var el = this;
            setTimeout(function() {
                el.style.cssText = "height:" + el.scrollHeight + "px";
            }, 0);
        };
        var textarea = document.querySelector(".detect-product-link-textarea");
        textarea.addEventListener("keydown", autosize);
        return function() {
            return removeEventListener("keydown", autosize);
        };
    }, [
        detectProductUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(affiliate_add_new_tour_config/* AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_2 */.qU.STEP_2, "p-[12px_16px] bg-[#FFFFFF] m-3 rounded-lg"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] leading-[23px] text-[#666666] flex flex-row items-center gap-1",
                        ref: popoverRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_product_detect_link_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                    content: t("ss_builder_import_multi_product_url_popover_content"),
                                    trigger: "click",
                                    placement: "top",
                                    mode: "dark",
                                    stopPropagation: [
                                        "click"
                                    ],
                                    getContainer: function() {
                                        return popoverRef.current;
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                                        className: "w-[17px] h-[17px]",
                                        fillColor: "#1890FF"
                                    })
                                })
                            })
                        ]
                    }),
                    isLoadingBtn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                        size: "mini",
                        fill: "outline",
                        color: "primary",
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            padding: "3px 12px 3px 12px"
                        },
                        onClick: onClickStopBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BanIcon */.SC, {
                                className: "w-[13px] h-[13px]",
                                fillColor: "#ee3244ff"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_stop_label")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                        size: "mini",
                        fill: "solid",
                        color: "primary",
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            padding: "3px 12px 3px 12px"
                        },
                        onClick: onClickAddMoreBtn,
                        disabled: disabledAddMoreBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                className: "w-[13px] h-[13px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_add_new_label")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        className: "detect-product-link-textarea",
                        placeholder: t("ss_builder_product_detect_link_placeholder"),
                        onChange: function(e) {
                            return onChangeProductLink(e);
                        },
                        onPaste: function(e) {
                            return onPasteProductLink(e);
                        },
                        value: detectProductUrl,
                        disabled: disabledInput
                    }),
                    isLoadingBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            backgroundColor: "#FFFFFF",
                            opacity: "0.6"
                        },
                        className: "absolute top-0 left-0 w-full h-full justify-center rounded-lg flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                            color: "primary",
                            style: {
                                "--size": "32px",
                                margin: "auto"
                            }
                        })
                    })
                ]
            }),
            isValidUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[13px] leading-[17px] text-[#FF3141]",
                children: t("ss_builder_product_detect_link_malformed_error")
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductAddNew_ProductAddNewInput = (ProductAddNewInput);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/ProductGroupSelection/index.tsx







var ProductGroupSelection = function(props) {
    var productGroupPickerValue = props.productGroupPickerValue, placeholder = props.placeholder, onOpenProductGroupSelection = props.onOpenProductGroupSelection, isDisabledSelection = props.isDisabledSelection;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(affiliate_add_new_tour_config/* AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_1 */.qU.STEP_1, "p-[12px_16px] bg-[#FFFFFF] flex flex-row items-center justify-between"),
        onClick: function() {
            return !isDisabledSelection ? onOpenProductGroupSelection() : {};
        },
        style: {
            opacity: isDisabledSelection ? "50%" : "",
            cursor: !isDisabledSelection ? "pointer" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] leading-[23px] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_product_group_selection_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                        value: productGroupPickerValue,
                        placeholder: placeholder,
                        readOnly: true,
                        className: "w-full text-ellipsis overflow-hidden whitespace-nowrap"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                className: "w-4 h-4",
                fillColor: "#333333"
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductAddNew_ProductGroupSelection = (ProductGroupSelection);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/DetectedUrlLists/index.tsx
var DetectedUrlLists = __webpack_require__(91937);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./node_modules/intro.js/introjs.css
var introjs = __webpack_require__(50982);
// EXTERNAL MODULE: ./src/features/share/components/ProductTourComponent/index.tsx
var ProductTourComponent = __webpack_require__(17347);
// EXTERNAL MODULE: ./src/features/share/icons/product-tour-icon.tsx
var product_tour_icon = __webpack_require__(16525);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/ProductAddNewTourOpening/ProductAddNewTour/index.tsx







var ProductAddNewTour = function(param) {
    var isHideStep3 = param.isHideStep3, handleHideAddNewTour = param.handleHideAddNewTour;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var productAddNewTourRef = (0,react.useRef)(null);
    var setRef = function(ref) {
        productAddNewTourRef.current = ref;
        var fullscreenContentElement = document.getElementsByClassName("full-screen-popup-content");
        if (productAddNewTourRef.current) {
            productAddNewTourRef.current.introJs._targetElement = fullscreenContentElement[(fullscreenContentElement === null || fullscreenContentElement === void 0 ? void 0 : fullscreenContentElement.length) - 1];
        }
    };
    var stepsDefault = affiliate_add_new_tour_config/* steps.map */.S6.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: (ele === null || ele === void 0 ? void 0 : ele.position) || "auto"
        };
    });
    var onExit = function() {
        handleHideAddNewTour();
    };
    var onBeforeExit = function(stepIndex) {};
    var onChangeProductTour = function(nextStepIndex, nextElement) {
        var fullScreenPopupContent = document.querySelectorAll(".full-screen-popup-content");
        var popupConentScrollHeight = fullScreenPopupContent[(fullScreenPopupContent === null || fullScreenPopupContent === void 0 ? void 0 : fullScreenPopupContent.length) - 1].scrollTop;
        var tooltipElement = document.querySelectorAll(".introjs-fixedTooltip");
        if (tooltipElement) {
            if (isHideStep3 && nextStepIndex !== affiliate_add_new_tour_config/* STEP_INDEX.STEP_3 */.om.STEP_3 || !isHideStep3 && nextStepIndex !== affiliate_add_new_tour_config/* STEP_INDEX.STEP_4 */.om.STEP_4) {
                for(var i = 0; i < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i++){
                    tooltipElement[i].style.cssText = "top:".concat(nextElement.getBoundingClientRect().top + popupConentScrollHeight - 5, "px !important");
                    tooltipElement[i].style.position = "absolute";
                    tooltipElement[i].style.background = "#FFFFFF";
                }
            } else {
                for(var i1 = 0; i1 < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i1++){
                    tooltipElement[i1].style.cssText = "";
                    tooltipElement[i1].style.position = "";
                    tooltipElement[i1].style.background = "";
                }
            }
        }
    };
    var onCompleteProductTour = function() {
        handleHideAddNewTour();
    };
    var onBeforeChange = function(nextStepIndex, nextElement) {
    // if (nextStepIndex === STEP_INDEX.STEP_2) {
    //   nextElement.scrollIntoView();
    // }
    // if (nextStepIndex === STEP_INDEX.STEP_3) {
    //   nextElement.scrollIntoView();
    // }
    };
    var stepsFilter = isHideStep3 ? stepsDefault === null || stepsDefault === void 0 ? void 0 : stepsDefault.filter(function(ele, idx) {
        return idx !== affiliate_add_new_tour_config/* STEP_INDEX.STEP_3 */.om.STEP_3;
    }) : stepsDefault;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsFilter,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var ProductAddNewTourOpening_ProductAddNewTour = (ProductAddNewTour);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/ProductAddNewTourOpening/index.tsx






var ProductAddNewTourOpening = function(param) {
    var isHideStep3 = param.isHideStep3;
    var ref = (0,react.useState)(false), isOpenProductAddNewTour = ref[0], setIsOpenProductAddNewTour = ref[1];
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    (0,react.useEffect)(function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isOpenAffiliateAddNewTour: isOpenProductAddNewTour
            }
        }));
        var timer = setTimeout(function() {
            var settingTourOverlay = document.getElementsByClassName("introjs-overlay")[0];
            var affiliateAddNewWrapper = document.querySelector(".affiliate-add-new-wrapper");
            if (isOpenProductAddNewTour) {
                settingTourOverlay.style.display = "none";
            } else {
                settingTourOverlay === null || settingTourOverlay === void 0 ? void 0 : settingTourOverlay.remove();
            }
            if (isOpenProductAddNewTour) {
                affiliateAddNewWrapper.style.cssText = "pointer-events: none;";
            } else {
                affiliateAddNewWrapper.style.cssText = "";
            }
        }, 100);
        (function() {
            return clearTimeout(timer);
        });
    }, [
        isOpenProductAddNewTour
    ]);
    var handleHideAddNewTour = function() {
        setIsOpenProductAddNewTour(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: function() {
                    return setIsOpenProductAddNewTour(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                    width: 20,
                    height: 20,
                    className: "cursor-pointer"
                })
            }),
            isOpenProductAddNewTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAddNewTourOpening_ProductAddNewTour, {
                isHideStep3: isHideStep3,
                handleHideAddNewTour: handleHideAddNewTour
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductAddNew_ProductAddNewTourOpening = (ProductAddNewTourOpening);

// EXTERNAL MODULE: ./src/features/share/helper/validator.ts
var validator = __webpack_require__(52893);
// EXTERNAL MODULE: ./src/features/block/libs/index.ts
var libs = __webpack_require__(22814);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFile/helper.ts
var helper = __webpack_require__(93475);
;// CONCATENATED MODULE: ./src/features/share/configs/image.ts
var PASSIO_DEFAULT_IMAGE = "https://image.passio.eco/page-builder/page-builder/images-default/product-default.jpeg";

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



























var AffiliateProductAddNew = function(props) {
    var ref18, ref1;
    var callbackCancelAffiliateProductAddNew = props.callbackCancelAffiliateProductAddNew, callbackSaveAffiliateProductAddNew = props.callbackSaveAffiliateProductAddNew, affiliateProductGroupData = props.affiliateProductGroupData, activeProductGroup = props.activeProductGroup, callbackAddNewAffiliateProductGroup = props.callbackAddNewAffiliateProductGroup, productGroupMaximum = props.productGroupMaximum;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var isOpenAffiliateAddNewTour = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig.isOpenAffiliateAddNewTour;
    });
    var isStopDetectingUrl = (0,react.useRef)(false);
    var ref2 = (0,react.useState)(false), isValidUrl = ref2[0], setIsValidUrl = ref2[1];
    var ref3 = (0,react.useState)(false), isLoadingBtn = ref3[0], setIsLoadingBtn = ref3[1];
    var ref4 = (0,react.useState)(false), isCheckQuantityProducts = ref4[0], setIsCheckQuantityProductts = ref4[1];
    var ref5 = (0,react.useState)(false), isOpenProductGroupSelection = ref5[0], setIsOpenProductGroupSelection = ref5[1];
    var ref6 = (0,react.useState)(false), isOpenDetectedUrlLists = ref6[0], setIsOpenDetectedUrlLists = ref6[1];
    var ref7 = (0,react.useState)([]), listProducts1 = ref7[0], setListProducts = ref7[1];
    var ref8 = (0,react.useState)(""), detectProductUrl = ref8[0], setDetectProductUrl = ref8[1];
    var ref9 = (0,react.useState)([]), uploadedImageArr = ref9[0], setUploadedImageArr = ref9[1];
    var ref10 = (0,react.useState)([]), productResponseArrDefault = ref10[0], setProductResponseArrDefault = ref10[1];
    var ref11 = (0,react.useState)(false), isValidFileFormat = ref11[0], setIsValidFileFormat = ref11[1];
    var ref12 = (0,react.useState)(false), isValidFileSize = ref12[0], setIsValidFileSize = ref12[1];
    var ref13 = (0,react.useState)([]), productIdValidArr = ref13[0], setProductIdValidArr = ref13[1];
    var ref14 = (0,react.useState)(activeProductGroup), productGroupValue = ref14[0], setProductGroupValue = ref14[1];
    var ref15 = (0,react.useState)([]), detectedUrlLists = ref15[0], setDetectedUrlLists = ref15[1];
    var ref16 = (0,react.useState)(0), detectedUrlQuantity = ref16[0], setDetectedUrlQuantity = ref16[1];
    var successfulDetectedProductArr = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        if (activeProductGroup) {
            setProductGroupValue(activeProductGroup);
        }
    }, [
        activeProductGroup
    ]);
    var activedTabProductLists = (0,react.useMemo)(function() {
        var ref;
        var activedProductGroup = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return x.uid === productGroupValue;
        });
        var ref17;
        return (ref17 = activedProductGroup === null || activedProductGroup === void 0 ? void 0 : (ref = activedProductGroup.content_attributes) === null || ref === void 0 ? void 0 : ref.items) !== null && ref17 !== void 0 ? ref17 : [];
    }, [
        affiliateProductGroupData,
        productGroupValue
    ]);
    var listProductsDisplay = (0,react.useMemo)(function() {
        var ref;
        var productIdArr = listProducts1 === null || listProducts1 === void 0 ? void 0 : listProducts1.map(function(x) {
            return x === null || x === void 0 ? void 0 : x.id;
        });
        var arrIndex = (ref = productIdArr.map(function(item, index) {
            if (productIdArr.indexOf(item) != index) return index;
        })) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
            return typeof x === "number";
        });
        return listProducts1 === null || listProducts1 === void 0 ? void 0 : listProducts1.filter(function(ele, idx) {
            return !(arrIndex === null || arrIndex === void 0 ? void 0 : arrIndex.includes(idx));
        });
    }, [
        listProducts1
    ]);
    var existedProductLists = (0,react.useMemo)(function() {
        var existedProductArr = [];
        affiliateProductGroupData.forEach(function(x) {
            var ref;
            var affiliateProductArr = (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
            existedProductArr = _toConsumableArray(existedProductArr).concat(_toConsumableArray(affiliateProductArr));
        });
        return existedProductArr;
    }, [
        affiliateProductGroupData
    ]);
    var handleDetectInfomationProduct = (0,react.useCallback)(function(productId, url) {
        var productInfomation = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = affiliateProductGroupData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var product = _step.value;
                var ref;
                var ref19;
                var listProducts = (ref19 = product === null || product === void 0 ? void 0 : (ref = product.content_attributes) === null || ref === void 0 ? void 0 : ref.items) !== null && ref19 !== void 0 ? ref19 : [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = listProducts[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var item = _step1.value;
                        if (String(item.uid) === String(productId) || (0,helper/* compareSameEcomerceUrl */.K9)(item === null || item === void 0 ? void 0 : item.origin_link, url)) {
                            var ref20;
                            productInfomation = {
                                productGroupName: (product === null || product === void 0 ? void 0 : product.title) || (product === null || product === void 0 ? void 0 : (ref20 = product.content_attributes) === null || ref20 === void 0 ? void 0 : ref20.title_product_group),
                                productId: productId
                            };
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return productInfomation;
    }, [
        affiliateProductGroupData
    ]);
    var checkValidUrl = function(url) {
        return (0,lib/* validURL */.b3)(url);
    };
    var detectAffiliateProductUrl = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(url, isDuplicated, isMultiUrls) {
            var ref40, ref21, ref22, ref23, ref24, existedProductUrlArrs, listProductUrlArrs, isCheckUrl, checkQuantityProducts, response, ref25, timeoutPromise, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, isSuccess, productDetectData, isCheckExistProductAddNew, isCheckExistProductSelection, isDuplicatedWhenDetectingMultiUrl, existProductInformation, shorternLink, currentTime, createdAtTime;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        existedProductUrlArrs = existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.map(function(x) {
                            return x === null || x === void 0 ? void 0 : x.origin_link;
                        });
                        listProductUrlArrs = (ref40 = successfulDetectedProductArr.current) === null || ref40 === void 0 ? void 0 : ref40.map(function(x) {
                            return x === null || x === void 0 ? void 0 : x.origin_link;
                        });
                        isCheckUrl = checkValidUrl(url);
                        checkQuantityProducts = !!(((ref21 = activedTabProductLists === null || activedTabProductLists === void 0 ? void 0 : activedTabProductLists.filter(function(x) {
                            return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) === 1;
                        })) === null || ref21 === void 0 ? void 0 : ref21.length) + ((ref22 = successfulDetectedProductArr.current) === null || ref22 === void 0 ? void 0 : ref22.length) >= configs_const/* PRODUCT_MAX */.Kh);
                        response = null;
                        _ctx.prev = 6;
                        if (!(!isCheckUrl && isMultiUrls)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", configs_const/* PRODUCT_URL_CHECKING.INVALID */.oL.INVALID);
                    case 11:
                        if (!(isMultiUrls && (isDuplicated || (existedProductUrlArrs === null || existedProductUrlArrs === void 0 ? void 0 : existedProductUrlArrs.some(function(x) {
                            return (0,helper/* compareSameEcomerceUrl */.K9)(x, url);
                        })) || (listProductUrlArrs === null || listProductUrlArrs === void 0 ? void 0 : listProductUrlArrs.some(function(x) {
                            return (0,helper/* compareSameEcomerceUrl */.K9)(x, url);
                        }))))) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", configs_const/* PRODUCT_URL_CHECKING.DUPLICATE */.oL.DUPLICATE);
                    case 15:
                        ;
                        if (!(checkQuantityProducts || !productGroupValue && ((ref25 = successfulDetectedProductArr.current) === null || ref25 === void 0 ? void 0 : ref25.length) >= configs_const/* PRODUCT_MAX */.Kh)) {
                            _ctx.next = 21;
                            break;
                        }
                        setIsCheckQuantityProductts(true);
                        setIsLoadingBtn(false);
                        setDetectProductUrl("");
                        return _ctx.abrupt("return", configs_const/* STOP_DETECTING */.qW);
                    case 21:
                        timeoutPromise = new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                resolve(null);
                            }, 30000);
                        });
                        _ctx.next = 24;
                        return Promise.race([
                            timeoutPromise,
                            (0,api/* requestDetectProductUrl */.r_)(url), 
                        ]);
                    case 24:
                        //Nếu trong 10s mà trả về response thì sẽ lấy response đó, ngược lại sẽ trả về null
                        response = _ctx.sent;
                    case 25:
                        _ctx.next = 30;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t0 = _ctx["catch"](6);
                        console.log("Request error", _ctx.t0);
                    case 30:
                        if (!(response && /^20[0-9]$/.test(response === null || response === void 0 ? void 0 : (ref23 = response.status) === null || ref23 === void 0 ? void 0 : ref23.toString()) && (response === null || response === void 0 ? void 0 : (ref24 = response.data) === null || ref24 === void 0 ? void 0 : ref24.data))) {
                            _ctx.next = 61;
                            break;
                        }
                        ;
                        isSuccess = response === null || response === void 0 ? void 0 : (ref26 = response.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : ref27.success;
                        productDetectData = _objectSpread({}, response === null || response === void 0 ? void 0 : (ref28 = response.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.data) === null || ref29 === void 0 ? void 0 : ref29.product, {
                            cat_id: response === null || response === void 0 ? void 0 : (ref30 = response.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.data) === null || ref31 === void 0 ? void 0 : ref31.cat_id,
                            image: (response === null || response === void 0 ? void 0 : (ref32 = response.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.product) === null || ref34 === void 0 ? void 0 : ref34.image) || PASSIO_DEFAULT_IMAGE
                        });
                        isCheckExistProductAddNew = Array.isArray(listProductsDisplay) && (listProductUrlArrs === null || listProductUrlArrs === void 0 ? void 0 : listProductUrlArrs.length) > 0 && listProductsDisplay.some(function(x) {
                            return String(x.id) === String(productDetectData.id) || (0,helper/* compareSameEcomerceUrl */.K9)(x === null || x === void 0 ? void 0 : x.origin_link, url.trim());
                        });
                        isCheckExistProductSelection = Array.isArray(existedProductLists) && (existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.length) > 0 && (existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.some(function(x) {
                            return String(x.uid) === String(productDetectData.id) || (0,helper/* compareSameEcomerceUrl */.K9)(x === null || x === void 0 ? void 0 : x.origin_link, url.trim());
                        }));
                        isDuplicatedWhenDetectingMultiUrl = isMultiUrls && (((ref36 = (ref35 = successfulDetectedProductArr.current) === null || ref35 === void 0 ? void 0 : ref35.map(function(x) {
                            return x === null || x === void 0 ? void 0 : x.id;
                        })) === null || ref36 === void 0 ? void 0 : ref36.includes(productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.id)) || isCheckExistProductAddNew || isCheckExistProductSelection);
                        if (!isDuplicatedWhenDetectingMultiUrl) {
                            _ctx.next = 39;
                            break;
                        }
                        return _ctx.abrupt("return", configs_const/* PRODUCT_URL_CHECKING.DUPLICATE */.oL.DUPLICATE);
                    case 39:
                        (ref37 = successfulDetectedProductArr.current) === null || ref37 === void 0 ? void 0 : ref37.push(productDetectData);
                        existProductInformation = handleDetectInfomationProduct(productDetectData.id, url === null || url === void 0 ? void 0 : url.trim());
                        shorternLink = null;
                        _ctx.prev = 42;
                        _ctx.next = 45;
                        return (0,userApi/* genLink */._3)(url, {
                            sub1: "ig",
                            sub2: "true",
                            traffic_source: "ss-landing-copy"
                        });
                    case 45:
                        shorternLink = _ctx.sent;
                        _ctx.next = 51;
                        break;
                    case 48:
                        _ctx.prev = 48;
                        _ctx.t1 = _ctx["catch"](42);
                        console.log(_ctx.t1);
                    case 51:
                        if (!(!isMultiUrls && (isCheckExistProductSelection || isCheckExistProductAddNew))) {
                            _ctx.next = 54;
                            break;
                        }
                        es/* Modal.alert */.u_.alert({
                            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                className: "w-11 h-11",
                                fillColor: "#FF8F1F",
                                onClick: function() {}
                            }),
                            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col text-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-lg font-bold leading-[25px]",
                                        children: t("ss_builder_dont_add_same_affiliate_product_modal_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: isCheckExistProductSelection ? t("ss_builder_dont_add_product_exist_at_list_content", {
                                            group_name: existProductInformation === null || existProductInformation === void 0 ? void 0 : existProductInformation.productGroupName
                                        }) : t("ss_builder_dont_add_product_exist_at_add_new_content")
                                    })
                                ]
                            }),
                            confirmText: t("ss_builder_dont_add_same_affiliate_product_confirm_label"),
                            onConfirm: function() {
                                return;
                            }
                        });
                        return _ctx.abrupt("return", true);
                    case 54:
                        currentTime = new Date();
                        createdAtTime = currentTime.toISOString();
                        setListProducts(function(value) {
                            var ref, ref38, ref39;
                            return [
                                _objectSpread({}, productDetectData, {
                                    shortern_link: shorternLink,
                                    use_aff_url: 1,
                                    origin_link: url,
                                    warning_code: isSuccess ? response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref38 = ref.data) === null || ref38 === void 0 ? void 0 : ref38.warning_code : null,
                                    error_code: !isSuccess ? response === null || response === void 0 ? void 0 : (ref39 = response.data) === null || ref39 === void 0 ? void 0 : ref39.error_code : null,
                                    createdAt: createdAtTime
                                }), 
                            ].concat(_toConsumableArray(value));
                        });
                        setProductResponseArrDefault(function(data) {
                            return [
                                _objectSpread({}, productDetectData), 
                            ].concat(_toConsumableArray(data));
                        });
                        return _ctx.abrupt("return", configs_const/* PRODUCT_URL_CHECKING.SUCCESS */.oL.SUCCESS);
                    case 61:
                        if (!isMultiUrls) {
                            _ctx.next = 65;
                            break;
                        }
                        return _ctx.abrupt("return", configs_const/* PRODUCT_URL_CHECKING.NOT_ADDED_YET */.oL.NOT_ADDED_YET);
                    case 65:
                        //Hiển thị modal báo lỗi và cho kết thúc việc phân tích sản phẩm với trường hợp 1 url
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isErrorNetwork: true
                            }
                        }));
                        setIsLoadingBtn(false);
                        setDetectProductUrl("");
                        return _ctx.abrupt("return", configs_const/* STOP_DETECTING */.qW);
                    case 69:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    27
                ],
                [
                    42,
                    48
                ]
            ]);
        }));
        return function detectAffiliateProductUrl(url, isDuplicated, isMultiUrls) {
            return _ref.apply(this, arguments);
        };
    }();
    var validateDetectProductUrl = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(valueInput) {
            var isFulledProductsAllGroups, ref, ref41, formatedUrls, duplicatedUrlIndexArr, isMultiUrls, count, res, url, isDuplicated, notYetDetectedUrlLists;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isStopDetectingUrl.current = false;
                        setDetectedUrlLists([]);
                        setIsLoadingBtn(true);
                        isFulledProductsAllGroups = !!((existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.length) + (listProductsDisplay === null || listProductsDisplay === void 0 ? void 0 : listProductsDisplay.length) + 1 > configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A);
                        if (!isFulledProductsAllGroups) {
                            _ctx.next = 8;
                            break;
                        }
                        {
                            es/* Modal.show */.u_.show({
                                className: "modal-error-class",
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                    className: "w-12 h-12",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px] mb-2",
                                            children: t("ss_builder_product_total_limitation_warning_title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_product_total_limitation_warning_description", {
                                                max_products_all_groups: configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A
                                            })
                                        })
                                    ]
                                }),
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_confirm_replace_theme_template_understood")
                                    }, 
                                ]
                            });
                        }
                        _ctx.next = 53;
                        break;
                    case 8:
                        ;
                        if (!(((ref = valueInput === null || valueInput === void 0 ? void 0 : valueInput.trim()) === null || ref === void 0 ? void 0 : ref.length) > 0)) {
                            _ctx.next = 52;
                            break;
                        }
                        ;
                        formatedUrls = (0,lib/* formatDetectedUrls */.yl)(valueInput === null || valueInput === void 0 ? void 0 : valueInput.trim());
                        setDetectedUrlQuantity(formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.length);
                        duplicatedUrlIndexArr = (0,helper/* findIndexDuplicateLinks */.FY)(formatedUrls);
                        isMultiUrls = (formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.length) > 1;
                        count = 0;
                        res = null;
                    case 17:
                        if (!(count < (formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.length))) {
                            _ctx.next = 48;
                            break;
                        }
                        if (!isStopDetectingUrl.current) {
                            _ctx.next = 20;
                            break;
                        }
                        return _ctx.abrupt("break", 48);
                    case 20:
                        url = formatedUrls.slice(count, count + 1);
                        isDuplicated = duplicatedUrlIndexArr === null || duplicatedUrlIndexArr === void 0 ? void 0 : duplicatedUrlIndexArr.includes(count);
                        if (!(url[0] && (isMultiUrls || !isMultiUrls && (0,lib/* validURL */.b3)(url[0])))) {
                            _ctx.next = 43;
                            break;
                        }
                        _ctx.prev = 23;
                        _ctx.next = 26;
                        return detectAffiliateProductUrl(url[0], isDuplicated, isMultiUrls);
                    case 26:
                        res = _ctx.sent;
                        _ctx.next = 32;
                        break;
                    case 29:
                        _ctx.prev = 29;
                        _ctx.t0 = _ctx["catch"](23);
                        console.log(_ctx.t0);
                    case 32:
                        if (!res) {
                            _ctx.next = 39;
                            break;
                        }
                        if (!(res === configs_const/* STOP_DETECTING */.qW)) {
                            _ctx.next = 35;
                            break;
                        }
                        return _ctx.abrupt("break", 48);
                    case 35:
                        if (isMultiUrls) {
                            setDetectedUrlLists(function(state) {
                                return _toConsumableArray(state).concat([
                                    {
                                        url: url[0],
                                        valid_type: res
                                    }, 
                                ]);
                            });
                        }
                        count++;
                        _ctx.next = 40;
                        break;
                    case 39:
                        return _ctx.abrupt("break", 48);
                    case 40:
                        if (count >= (formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.length)) {
                            setIsLoadingBtn(false);
                            setDetectProductUrl("");
                        }
                        _ctx.next = 46;
                        break;
                    case 43:
                        setIsValidUrl(true);
                        setIsLoadingBtn(false);
                        return _ctx.abrupt("break", 48);
                    case 46:
                        _ctx.next = 17;
                        break;
                    case 48:
                        notYetDetectedUrlLists = (ref41 = formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.slice(count, formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.length)) === null || ref41 === void 0 ? void 0 : ref41.map(function(ele) {
                            return {
                                url: ele,
                                valid_type: configs_const/* PRODUCT_URL_CHECKING.NOT_ADDED_YET */.oL.NOT_ADDED_YET
                            };
                        });
                        setDetectedUrlLists(function(state) {
                            return _toConsumableArray(state).concat(_toConsumableArray(notYetDetectedUrlLists));
                        });
                        _ctx.next = 53;
                        break;
                    case 52:
                        {
                            setIsLoadingBtn(false);
                        // setIsValidUrl(true);
                        }
                    case 53:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    23,
                    29
                ]
            ]);
        }));
        return function(valueInput) {
            return _ref.apply(this, arguments);
        };
    }(), [
        existedProductLists,
        activedTabProductLists,
        listProductsDisplay
    ]);
    var handleDeleteProduct = (0,react.useCallback)(function(productId) {
        var ref, ref42;
        var newListProducts = listProductsDisplay.filter(function(x) {
            return x.id !== productId;
        });
        successfulDetectedProductArr.current = newListProducts;
        var newProductResponseDefault = productResponseArrDefault.filter(function(x) {
            return x.id !== productId;
        });
        setListProducts(newListProducts);
        setProductResponseArrDefault(newProductResponseDefault);
        if (((ref = activedTabProductLists === null || activedTabProductLists === void 0 ? void 0 : activedTabProductLists.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) === 1;
        })) === null || ref === void 0 ? void 0 : ref.length) + ((ref42 = successfulDetectedProductArr.current) === null || ref42 === void 0 ? void 0 : ref42.length) >= configs_const/* PRODUCT_MAX */.Kh) {
            setIsCheckQuantityProductts(true);
        } else {
            setIsCheckQuantityProductts(false);
        }
    }, [
        listProductsDisplay,
        activedTabProductLists,
        productResponseArrDefault
    ]);
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        var isCheckHasTitleProduct = listProductsDisplay.every(function(x) {
            return x.name && x.name.trim();
        });
        // const isCheckHasImageProduct = listProducts.every((x) => x.image);
        if (listProductsDisplay.length > 0 && isCheckHasTitleProduct && // isCheckHasImageProduct &&
        productGroupValue && !isLoadingBtn) {
            return true;
        }
        return false;
    }, [
        listProductsDisplay,
        productGroupValue,
        isLoadingBtn
    ]);
    var isExceedMaximumProducts = (0,react.useMemo)(function() {
        return (activedTabProductLists === null || activedTabProductLists === void 0 ? void 0 : activedTabProductLists.length) > 0 && (listProductsDisplay === null || listProductsDisplay === void 0 ? void 0 : listProductsDisplay.length) + (activedTabProductLists === null || activedTabProductLists === void 0 ? void 0 : activedTabProductLists.length) >= configs_const/* PRODUCT_MAX */.Kh;
    }, [
        listProductsDisplay,
        activedTabProductLists
    ]);
    var handleSaveAffiliateProductAddNew = (0,react.useCallback)(function() {
        if (activedTabProductLists && activedTabProductLists.length === 0) {
            var ref;
            var dataConfirm = listProductsDisplay && Array.isArray(listProductsDisplay) && listProductsDisplay.map(function(ele, idx) {
                return _objectSpread({}, ele, {
                    uid: ele.id || "aff-item-" + (0,v4/* default */.Z)(),
                    sort_order: idx + 1,
                    title: ele.name,
                    enable: 1,
                    is_cleanup_lock: 2,
                    image_name: ele.image_name || "",
                    image_base64: ele.image_base64
                });
            });
            var newAffiliateProductGroupData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
                return ele.uid !== productGroupValue ? ele : _objectSpread({}, ele, {
                    content_attributes: _objectSpread({}, ele.content_attributes, {
                        items: dataConfirm
                    })
                });
            });
            callbackSaveAffiliateProductAddNew(newAffiliateProductGroupData, productGroupValue);
            (0,libs/* scrollToNewItem */.i)("product-".concat((ref = dataConfirm[0]) === null || ref === void 0 ? void 0 : ref.uid));
        } else {
            var ref43;
            var dataConfirm1 = listProductsDisplay && Array.isArray(listProductsDisplay) && listProductsDisplay.map(function(ele, idx) {
                return _objectSpread({}, ele, {
                    uid: ele.id,
                    sort_order: idx + 1,
                    title: ele.name,
                    enable: 1,
                    is_cleanup_lock: 2,
                    image_name: ele.image_name || "",
                    image_base64: ele.image_base64
                });
            });
            var newListProducts = _toConsumableArray(dataConfirm1).concat(_toConsumableArray(activedTabProductLists));
            if ((newListProducts === null || newListProducts === void 0 ? void 0 : newListProducts.length) > configs_const/* PRODUCT_MAX */.Kh) {
                var ref44;
                var excessProductsLength = (newListProducts === null || newListProducts === void 0 ? void 0 : newListProducts.length) - configs_const/* PRODUCT_MAX */.Kh;
                var removedProductsArr = (ref44 = newListProducts === null || newListProducts === void 0 ? void 0 : newListProducts.filter(function(x) {
                    return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) !== 1;
                })) === null || ref44 === void 0 ? void 0 : ref44.slice(-excessProductsLength);
                newListProducts = newListProducts === null || newListProducts === void 0 ? void 0 : newListProducts.filter(function(x) {
                    return !(removedProductsArr === null || removedProductsArr === void 0 ? void 0 : removedProductsArr.some(function(y) {
                        return (y === null || y === void 0 ? void 0 : y.uid) === (x === null || x === void 0 ? void 0 : x.uid);
                    }));
                });
            }
            var newListProductsReSortOrder = newListProducts.map(function(ele, idx) {
                return _objectSpread({}, ele, {
                    sort_order: idx + 1
                });
            });
            var newAffiliateProductGroupData1 = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
                return ele.uid !== productGroupValue ? ele : _objectSpread({}, ele, {
                    content_attributes: _objectSpread({}, ele.content_attributes, {
                        items: newListProductsReSortOrder
                    })
                });
            });
            callbackSaveAffiliateProductAddNew(newAffiliateProductGroupData1, productGroupValue);
            (0,libs/* scrollToNewItem */.i)("product-".concat((ref43 = dataConfirm1[0]) === null || ref43 === void 0 ? void 0 : ref43.uid));
        }
    }, [
        productGroupValue,
        activedTabProductLists,
        affiliateProductGroupData,
        listProductsDisplay, 
    ]);
    var handleCancelAffiliateProductAddNew = function() {
        if ((listProductsDisplay === null || listProductsDisplay === void 0 ? void 0 : listProductsDisplay.length) >= 1) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_product_addition_modal_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_product_addition_modal_description")
                }),
                confirmText: t("ss_builder_cancel_product_addition_modal_confirm_btn_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    isStopDetectingUrl.current = true;
                    callbackCancelAffiliateProductAddNew();
                }
            });
        } else {
            isStopDetectingUrl.current = true;
            callbackCancelAffiliateProductAddNew();
        }
    };
    var handleCheckAffiliateUrl = function(productId) {
        var newListProducts = listProductsDisplay.map(function(ele) {
            return productId === ele.id ? _objectSpread({}, ele, {
                use_aff_url: ele.use_aff_url === 1 ? 2 : 1
            }) : ele;
        });
        setListProducts(newListProducts);
    };
    var handleCheckOpenNewTab = function(productId, openNewTab) {
        var newListProducts = listProductsDisplay.map(function(ele) {
            var isEcommerce = (0,validator/* checkOpenNewTab */.lq)(new URL(ele === null || ele === void 0 ? void 0 : ele.origin_link));
            return productId === ele.id ? _objectSpread({}, ele, {
                open_new_tab: isEcommerce ? true : openNewTab
            }) : ele;
        });
        setListProducts(newListProducts);
    };
    var handleChangeNameProduct = function(value, productId) {
        var newListProducts = listProductsDisplay.map(function(ele) {
            return productId === ele.id ? _objectSpread({}, ele, {
                name: value
            }) : ele;
        });
        setListProducts(newListProducts);
    };
    var handleSelectLabelProduct = function(data, productId) {
        if (data && Array.isArray(data)) {
            var newListProducts = listProducts1.map(function(ele) {
                return productId === ele.id ? _objectSpread({}, ele, {
                    label_product: data
                }) : ele;
            });
            setListProducts(newListProducts);
        }
    };
    var handleImageUrl = function(data, productId) {
        var imgFileItems = data && data[data.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
            if (!(productIdValidArr === null || productIdValidArr === void 0 ? void 0 : productIdValidArr.includes(productId))) {
                setProductIdValidArr(_toConsumableArray(productIdValidArr).concat([
                    productId
                ]));
            }
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
            if (!(productIdValidArr === null || productIdValidArr === void 0 ? void 0 : productIdValidArr.includes(productId))) {
                setProductIdValidArr(_toConsumableArray(productIdValidArr).concat([
                    productId
                ]));
            }
        } else {
            setUploadedImageArr(data);
            var newListProducts = listProductsDisplay.map(function(ele) {
                return productId === ele.id ? _objectSpread({}, ele, {
                    image: imgFileItems.dataBase64,
                    image_name: imgFileItems.fileName,
                    image_base64: imgFileItems.dataBase64
                }) : ele;
            });
            setListProducts(newListProducts);
            if (productIdValidArr === null || productIdValidArr === void 0 ? void 0 : productIdValidArr.includes(productId)) {
                var newProductIdValidArr = productIdValidArr === null || productIdValidArr === void 0 ? void 0 : productIdValidArr.filter(function(x) {
                    return x !== productId;
                });
                setProductIdValidArr(newProductIdValidArr);
            }
        }
    };
    var productRatioAdded = "".concat(activedTabProductLists.length + listProductsDisplay.length < configs_const/* PRODUCT_MAX */.Kh ? activedTabProductLists.length + listProductsDisplay.length : configs_const/* PRODUCT_MAX */.Kh, "/").concat(configs_const/* PRODUCT_MAX */.Kh);
    var productGroupPickerValue = (0,react.useMemo)(function() {
        var ref, ref45;
        return productGroupValue ? (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupValue;
        })) === null || ref === void 0 ? void 0 : (ref45 = ref.content_attributes) === null || ref45 === void 0 ? void 0 : ref45.title_product_group : "";
    }, [
        productGroupValue,
        affiliateProductGroupData
    ]);
    var onChangeProductLink = function(e) {
        var ref, ref46;
        e.preventDefault();
        setDetectProductUrl(e.target.value);
        if (((ref46 = (ref = e.target.value) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref46 === void 0 ? void 0 : ref46.length) === 0) {
            setIsValidUrl(false);
        } else {
            var ref47;
            var formatedUrls = (0,lib/* formatDetectedUrls */.yl)((ref47 = e.target.value) === null || ref47 === void 0 ? void 0 : ref47.trim());
            var isInvalid = formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.every(function(x) {
                return !(0,lib/* validURL */.b3)(x);
            });
            setIsValidUrl(isInvalid);
        }
    };
    var onPasteProductLink = function(event) {
        var ref;
        event.preventDefault();
        var textareaElement = document === null || document === void 0 ? void 0 : document.querySelector(".detect-product-link-textarea");
        if (isLoadingBtn) {
            return;
        }
        if (((ref = detectProductUrl === null || detectProductUrl === void 0 ? void 0 : detectProductUrl.trim()) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            if ((document === null || document === void 0 ? void 0 : document.activeElement) === textareaElement) {
                var start = textareaElement === null || textareaElement === void 0 ? void 0 : textareaElement.selectionStart;
                var end = textareaElement === null || textareaElement === void 0 ? void 0 : textareaElement.selectionEnd;
                var part1 = (detectProductUrl === null || detectProductUrl === void 0 ? void 0 : detectProductUrl.slice(0, start)) || "";
                var part2 = (detectProductUrl === null || detectProductUrl === void 0 ? void 0 : detectProductUrl.slice(end)) || "";
                var newDetectProductUrl = "".concat(part1).concat(event.clipboardData.getData("text")).concat(part2);
                var formatedUrls = (0,lib/* formatDetectedUrls */.yl)(newDetectProductUrl === null || newDetectProductUrl === void 0 ? void 0 : newDetectProductUrl.trim());
                var isInvalid = formatedUrls === null || formatedUrls === void 0 ? void 0 : formatedUrls.every(function(x) {
                    return !(0,lib/* validURL */.b3)(x);
                });
                setIsValidUrl(isInvalid);
                setDetectProductUrl(newDetectProductUrl);
            }
        } else {
            var ref48;
            var formatedUrls1 = (0,lib/* formatDetectedUrls */.yl)((ref48 = event.clipboardData.getData("text")) === null || ref48 === void 0 ? void 0 : ref48.trim());
            var isInvalid1 = formatedUrls1 === null || formatedUrls1 === void 0 ? void 0 : formatedUrls1.every(function(x) {
                return !(0,lib/* validURL */.b3)(x);
            });
            setIsValidUrl(isInvalid1);
            setDetectProductUrl(event.clipboardData.getData("text"));
            if (!isInvalid1) {
                validateDetectProductUrl(event.clipboardData.getData("text"));
            }
        }
    };
    var successfullyUrlQuantity = ((ref18 = detectedUrlLists === null || detectedUrlLists === void 0 ? void 0 : detectedUrlLists.filter(function(x) {
        return (x === null || x === void 0 ? void 0 : x.valid_type) === configs_const/* PRODUCT_URL_CHECKING.SUCCESS */.oL.SUCCESS;
    })) === null || ref18 === void 0 ? void 0 : ref18.length) || 0;
    var handleStopDetectUrl = function() {
        isStopDetectingUrl.current = true;
        setIsLoadingBtn(false);
        setDetectProductUrl("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "affiliate-add-new-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-between gap-1 py-[10px] bg-white px-3",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Badge */.Ct, {
                            color: "var(--adm-color-primary)",
                            content: productRatioAdded,
                            style: {
                                "--top": "50%",
                                "--right": "-25px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg leading-6",
                                children: t("ss_builder_add_new_affiliate_product_title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew_ProductAddNewTourOpening, {
                        isHideStep3: (listProductsDisplay === null || listProductsDisplay === void 0 ? void 0 : listProductsDisplay.length) <= 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("w-full h-full", isOpenAffiliateAddNewTour ? "pb-[300px]" : "pb-[100px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew_ProductGroupSelection, {
                        productGroupPickerValue: productGroupPickerValue,
                        placeholder: !productGroupValue && t("ss_builder_product_group_selection_placeholder"),
                        onOpenProductGroupSelection: function() {
                            return setIsOpenProductGroupSelection(true);
                        },
                        isDisabledSelection: isLoadingBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew_AutoCleanupProductsWarning, {
                        isShowWarning: isExceedMaximumProducts && !isCheckQuantityProducts
                    }),
                    isCheckQuantityProducts ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center py-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ExclamationTriangleIcon */.LP, {
                                    className: "align-middle w-8 h-8",
                                    fillColor: "var(--adm-color-primary)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: t("ss_builder_product_exceeding_allowed_amount_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: t("ss_builder_product_exceeding_allowed_amount_content")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew_ProductAddNewInput, {
                        detectProductUrl: detectProductUrl,
                        onChangeProductLink: onChangeProductLink,
                        onPasteProductLink: onPasteProductLink,
                        disabledInput: isLoadingBtn,
                        disabledAddMoreBtn: isValidUrl || ((ref1 = detectProductUrl === null || detectProductUrl === void 0 ? void 0 : detectProductUrl.trim()) === null || ref1 === void 0 ? void 0 : ref1.length) === 0,
                        onClickAddMoreBtn: function() {
                            return validateDetectProductUrl(detectProductUrl);
                        },
                        onClickStopBtn: handleStopDetectUrl,
                        isValidUrl: isValidUrl,
                        isLoadingBtn: isLoadingBtn
                    }),
                    detectedUrlQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cursor-pointer mx-3",
                        onClick: function() {
                            return !isLoadingBtn ? setIsOpenDetectedUrlLists(true) : {};
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NoticeBar */.P8, {
                            extra: !isLoadingBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                                className: "w-[18px] h-[18px]",
                                fillColor: "#389E0D"
                            }),
                            icon: !isLoadingBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIconV3 */.BW, {
                                className: "w-[18px] h-[18px]",
                                fillColor: "#389E0D"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                                color: "#1677FF",
                                style: {
                                    "--size": "16px"
                                }
                            }),
                            content: isLoadingBtn ? t("ss_builder_multi_product_url_importing_label", {
                                successfullyUrlQuantity: successfullyUrlQuantity,
                                detectedUrlQuantity: detectedUrlQuantity
                            }) : t("ss_builder_multi_product_url_imported_label", {
                                successfullyUrlQuantity: successfullyUrlQuantity,
                                detectedUrlQuantity: detectedUrlQuantity
                            }),
                            style: {
                                borderRadius: "8px",
                                "--background-color": isLoadingBtn ? "#D0E4FF" : "#D9F7BE",
                                "--text-color": isLoadingBtn ? "#1677FF" : "#389E0D",
                                "--border-color": isLoadingBtn ? "#D0E4FF" : "#D9F7BE"
                            }
                        })
                    }),
                    (listProductsDisplay === null || listProductsDisplay === void 0 ? void 0 : listProductsDisplay.length) > 0 ? listProductsDisplay.map(function(ele, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem/* default */.Z, {
                            item: ele,
                            index: index,
                            onUpdateName: function onUpdateName(name) {
                                handleChangeNameProduct(name, ele.id);
                            },
                            onUpdateImage: function onUpdateImage(image) {
                                handleImageUrl(image, ele.id);
                            },
                            onCheckUseAffiliateUrl: function onCheckUseAffiliateUrl(checked) {
                                handleCheckAffiliateUrl(ele.id);
                            },
                            onCheckOpenNewTab: function onCheckOpenNewTab(openNewTab) {
                                handleCheckOpenNewTab(ele.id, openNewTab);
                            },
                            onSelectLabelProduct: function onSelectLabelProduct(labelProduct) {
                                handleSelectLabelProduct(labelProduct, ele.id);
                            },
                            onDelete: function onDelete() {
                                handleDeleteProduct(ele.id);
                            },
                            isValidFileFormat: !!(productIdValidArr.includes(ele.id) && isValidFileFormat),
                            isValidFileSize: !!(productIdValidArr.includes(ele.id) && isValidFileSize)
                        }, ele.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()(affiliate_add_new_tour_config/* AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_4 */.qU.STEP_4, "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                onClick: handleCancelAffiliateProductAddNew,
                                children: t("ss_builder_editor_btn-cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                disabled: !isSaveButtonEnable,
                                color: "primary",
                                onClick: handleSaveAffiliateProductAddNew,
                                children: t("ss_builder_editor_btn-add-more")
                            })
                        })
                    ]
                })
            }),
            isOpenProductGroupSelection && /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupPickerView/* default */.Z, {
                affiliateProductGroupData: affiliateProductGroupData,
                visible: isOpenProductGroupSelection,
                onCancelAffiliateProductGroupSelection: function() {
                    return setIsOpenProductGroupSelection(false);
                },
                defaultValue: productGroupValue,
                onSelectAffiliateProductGroup: function(val) {
                    return setProductGroupValue(val);
                },
                onAddNewAffiliateProductGroup: callbackAddNewAffiliateProductGroup,
                productGroupMaximum: productGroupMaximum,
                listProducts: listProductsDisplay
            }),
            isOpenDetectedUrlLists && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenDetectedUrlLists,
                onMaskClick: function() {
                    setIsOpenDetectedUrlLists(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetectedUrlLists/* default */.Z, {
                    onCancel: function() {
                        return setIsOpenDetectedUrlLists(false);
                    },
                    urlLists: detectedUrlLists
                })
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductAddNew = (AffiliateProductAddNew);


/***/ }),

/***/ 22023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateProductGroup_AffiliateProductEdit; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/user/userApi.ts
var userApi = __webpack_require__(63681);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupPickerView/index.tsx
var AffiliateProductGroupPickerView = __webpack_require__(63542);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductItem/index.tsx
var ProductItem = __webpack_require__(35501);
// EXTERNAL MODULE: ./src/features/share/helper/validator.ts
var validator = __webpack_require__(52893);
// EXTERNAL MODULE: ./src/features/block/components/HiddenWarningUI/index.tsx
var HiddenWarningUI = __webpack_require__(62904);
;// CONCATENATED MODULE: ./src/features/block/components/MoreActionsCommon/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var MoreActionsCommon = function(param1) {
    var className = param1.className, visible = param1.visible, options = param1.options, fillColor = param1.fillColor, popoverContainerId = param1.popoverContainerId;
    var popoverContainerRef = (0,react.useRef)(null);
    var actions = (0,react.useMemo)(function() {
        return options.map(function(param) {
            var key = param.key, icon = param.icon, text = param.text, action = param.action;
            return {
                key: key,
                icon: icon,
                text: text,
                onClick: action
            };
        });
    }, [
        options
    ]);
    var getContainer = function() {
        if (popoverContainerId) {
            return document.getElementById(popoverContainerId);
        }
        return popoverContainerRef.current;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverContainerRef,
        className: "cursor-pointer w-full h-full flex items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, _objectSpread({
            mode: "dark",
            actions: actions,
            placement: "bottom-end",
            trigger: "click",
            stopPropagation: [
                "click"
            ],
            getContainer: getContainer
        }, visible ? {
            visible: true
        } : {}, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                className: className,
                fillColor: fillColor
            })
        }))
    });
};
/* harmony default export */ var components_MoreActionsCommon = (MoreActionsCommon);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListItems/index.tsx
var ProductListItems = __webpack_require__(7804);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductEdit/MoreActions/index.tsx
function MoreActions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MoreActions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MoreActions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var MoreActions = function(param) {
    var productData = param.productData, onUpdateProductData = param.onUpdateProductData, onDeleteProduct = param.onDeleteProduct;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var isEnable = !!(productData.enable === configs_const/* STATUS.ENABLE */.Q_.ENABLE);
    var isCleanUpLock = !!(productData.is_cleanup_lock === configs_const/* STATUS.ENABLE */.Q_.ENABLE);
    var onDisableEnableProduct = function() {
        var newStatus = isEnable ? configs_const/* STATUS.DISABLE */.Q_.DISABLE : configs_const/* STATUS.ENABLE */.Q_.ENABLE;
        onUpdateProductData(MoreActions_objectSpread({}, productData, {
            enable: newStatus
        }));
        SuccessToast(t(isEnable ? "ss_builder_disable_product_successfully_label" : "ss_builder_enable_product_successfully_label"));
    };
    var onCleanUpLockProduct = function() {
        var newStatus = isCleanUpLock ? configs_const/* STATUS.DISABLE */.Q_.DISABLE : configs_const/* STATUS.ENABLE */.Q_.ENABLE;
        onUpdateProductData(MoreActions_objectSpread({}, productData, {
            is_cleanup_lock: newStatus
        }));
        SuccessToast(t(!isCleanUpLock ? "ss_builder_cleanup_lock_product_successfully_label" : "ss_builder_cleanup_unlock_product_successfully_label"));
    };
    var confirmDeleteProduct = function() {
        var onConfirm = function() {
            onDeleteProduct();
            SuccessToast(t("ss_builder_delete_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_delete_product_modal_title"),
            description: t("ss_builder_confirm_delete_product_modal_content"),
            confirmText: t("ss_builder_confirm_delete_product_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var options = [
        {
            key: ProductListItems/* ActionEnum.VISIBLE_HIDE_PRODUCT */.X.VISIBLE_HIDE_PRODUCT,
            icon: isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: isEnable ? t("ss_builder_hide_product_label") : t("ss_builder_show_product_label"),
            action: onDisableEnableProduct
        },
        {
            key: ProductListItems/* ActionEnum.DELETE_PRODUCT */.X.DELETE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_product_label"),
            action: confirmDeleteProduct
        },
        {
            key: ProductListItems/* ActionEnum.CLEANUP_LOCK_PRODUCT */.X.CLEANUP_LOCK_PRODUCT,
            icon: !isCleanUpLock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BroomIcon */.Vj, {
                className: "w-5 h-5",
                fillColor: "white"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BroomLockIcon */.mP, {
                className: "w-5 h-5",
                fillColor: "white"
            }),
            text: !isCleanUpLock ? t("ss_builder_affiliate_product_cleanup_lock_label") : t("ss_builder_affiliate_product_cleanup_unlock_label"),
            action: onCleanUpLockProduct
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MoreActionsCommon, {
        options: options
    });
};
/* harmony default export */ var AffiliateProductEdit_MoreActions = (MoreActions);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductEdit/index.tsx
function AffiliateProductEdit_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AffiliateProductEdit_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AffiliateProductEdit_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var AffiliateProductEdit = function(props) {
    var productData = props.productData, callBackCancelAffiliateProductEdit = props.callBackCancelAffiliateProductEdit, callBackSaveAffiliateProductEdit = props.callBackSaveAffiliateProductEdit, affiliateProductGroupData = props.affiliateProductGroupData, callbackAddNewAffiliateProductGroup = props.callbackAddNewAffiliateProductGroup, activeProductGroup = props.activeProductGroup, productGroupMaximum = props.productGroupMaximum;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var ref6 = (0,react.useState)(productData), productDataState = ref6[0], setProductDataState = ref6[1];
    var ref1 = (0,react.useState)([]), uploadedImageArr = ref1[0], setUploadedImageArr = ref1[1];
    var ref2 = (0,react.useState)(false), isValidFileFormat = ref2[0], setIsValidFileFormat = ref2[1];
    var ref3 = (0,react.useState)(false), isValidFileSize = ref3[0], setIsValidFileSize = ref3[1];
    var ref4 = (0,react.useState)(activeProductGroup), productGroupValue = ref4[0], setProductGroupValue = ref4[1];
    var ref5 = (0,react.useState)(false), isOpenProductGroupSelection = ref5[0], setIsOpenProductGroupSelection = ref5[1];
    (0,react.useEffect)(function() {
        if (!(productData === null || productData === void 0 ? void 0 : productData.shortern_link)) {
            (0,userApi/* genLinkV2 */.Dk)(productData.origin_link, {
                sub1: "ig",
                sub2: "true",
                traffic_source: "ss-landing-copy"
            }).then(function(res) {
                setProductDataState(function(state) {
                    return AffiliateProductEdit_objectSpread({}, state, {
                        shortern_link: res === null || res === void 0 ? void 0 : res.link_shorten,
                        gen_link_err_code: !(res === null || res === void 0 ? void 0 : res.success) ? res === null || res === void 0 ? void 0 : res.code : null
                    });
                });
            }).catch(console.log);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (productData) {
            setProductDataState(productData);
        }
    }, [
        productData
    ]);
    var handleCheckOpenNewTab = function(openNewTab) {
        var isEcommerce = (0,validator/* checkOpenNewTab */.lq)(new URL(productDataState === null || productDataState === void 0 ? void 0 : productDataState.origin_link));
        var productDataClone = cloneDeep_default()(productDataState);
        productDataClone.open_new_tab = isEcommerce ? true : openNewTab;
        setProductDataState(productDataClone);
    };
    var handleChangeNameProduct = function(value) {
        var productDataClone = cloneDeep_default()(productDataState);
        productDataClone.title = value;
        setProductDataState(productDataClone);
    };
    var handleDeleteImageProduct = function() {
        var productDataClone = cloneDeep_default()(productDataState);
        productDataClone.image = productData === null || productData === void 0 ? void 0 : productData.image;
        setProductDataState(productDataClone);
    };
    var handleImageUrl = function(data) {
        var imgFileItems = data && data[data.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(data);
            var productDataClone = cloneDeep_default()(productDataState);
            productDataClone.image = imgFileItems.dataBase64;
            productDataClone.image_name = imgFileItems.fileName;
            productDataClone.image_base64 = imgFileItems.dataBase64;
            setProductDataState(productDataClone);
        }
    };
    var handleCheckAffiliateUrl = function() {
        var productDataClone = cloneDeep_default()(productDataState);
        productDataClone.use_aff_url = productDataClone.use_aff_url === 1 ? 2 : 1;
        setProductDataState(productDataClone);
    };
    var handleSelectLabelProduct = function(data) {
        var productDataClone = cloneDeep_default()(productDataState);
        productDataClone.label_product = data && Array.isArray(data) ? data : [];
        setProductDataState(productDataClone);
    };
    var handleCancelAffiliateProductEdit = function() {
        callBackCancelAffiliateProductEdit();
    };
    var handleSaveAffiliateProductEdit = (0,react.useCallback)(function() {
        var currentTime = new Date();
        var updatedAtTime = currentTime.toISOString();
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        var activedProductGroupData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return x.uid === productGroupValue;
        });
        if (productGroupValue === activeProductGroup) {
            var ref;
            var newActivedProductGroup = AffiliateProductEdit_objectSpread({}, activedProductGroupData, {
                content_attributes: AffiliateProductEdit_objectSpread({}, activedProductGroupData.content_attributes, {
                    items: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref = activedProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : ref.items.map(function(ele) {
                        if (ele.uid === productDataState.uid) {
                            if (productDataState === null || productDataState === void 0 ? void 0 : productDataState.post_link) {
                                return AffiliateProductEdit_objectSpread({}, productDataState, {
                                    updatedAt: updatedAtTime
                                });
                            }
                            return productDataState;
                        }
                        return ele;
                    })
                })
            });
            var newAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.map(function(ele) {
                return ele.uid === productGroupValue ? newActivedProductGroup : ele;
            });
            callBackSaveAffiliateProductEdit(newAffiliateProductGroupData);
        } else {
            var productGroupDataAfterAddingProductId = affiliateProductGroupDataClone.map(function(element) {
                if (element.uid === productGroupValue) {
                    var ref;
                    var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                    if (productDataState) {
                        if (productDataState === null || productDataState === void 0 ? void 0 : productDataState.post_link) {
                            productList.unshift(AffiliateProductEdit_objectSpread({}, productDataState, {
                                updatedAt: updatedAtTime
                            }));
                        } else productList.unshift(productDataState);
                    }
                    var newProductListSortOrder = productList.map(function(ele, index) {
                        return AffiliateProductEdit_objectSpread({}, ele, {
                            sort_order: index + 1
                        });
                    });
                    return AffiliateProductEdit_objectSpread({}, element, {
                        content_attributes: AffiliateProductEdit_objectSpread({}, element.content_attributes, {
                            items: newProductListSortOrder
                        })
                    });
                } else return element;
            });
            //Remove product from the old product group
            var productGroupDataAfterRemovingProductId = productGroupDataAfterAddingProductId.map(function(element) {
                if (element.uid === activeProductGroup) {
                    var ref;
                    var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                    var productListRemovedProductId = productList.filter(function(x) {
                        return x.uid !== (productDataState === null || productDataState === void 0 ? void 0 : productDataState.uid);
                    });
                    var productListRemovedProductIdSortOrder = productListRemovedProductId.map(function(ele, index) {
                        return AffiliateProductEdit_objectSpread({}, ele, {
                            sort_order: index + 1
                        });
                    });
                    return AffiliateProductEdit_objectSpread({}, element, {
                        content_attributes: AffiliateProductEdit_objectSpread({}, element.content_attributes, {
                            items: productListRemovedProductIdSortOrder
                        })
                    });
                } else return element;
            });
            callBackSaveAffiliateProductEdit(productGroupDataAfterRemovingProductId);
        }
        callBackCancelAffiliateProductEdit();
    }, [
        affiliateProductGroupData,
        productGroupValue,
        productDataState
    ]);
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        if ((JSON.stringify(productDataState) !== JSON.stringify(productData) || productGroupValue !== activeProductGroup) && // productDataState.image &&
        productDataState.title && productDataState.title.trim() && productDataState.origin_link && productGroupValue) {
            return true;
        }
        return false;
    }, [
        productDataState,
        productData,
        productGroupValue,
        activeProductGroup
    ]);
    var productGroupPickerValue = (0,react.useMemo)(function() {
        var ref, ref7;
        return productGroupValue ? (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupValue;
        })) === null || ref === void 0 ? void 0 : (ref7 = ref.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.title_product_group : "";
    }, [
        productGroupValue,
        affiliateProductGroupData
    ]);
    var onDeleteProduct = function() {
        var newAffiliateProductGroupData = affiliateProductGroupData.map(function(element) {
            if (element.uid === productGroupValue) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                var newProductList = productList.filter(function(x) {
                    return x.uid !== productDataState.uid;
                });
                var newProductListSortOrder = newProductList.map(function(ele, index) {
                    return AffiliateProductEdit_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return AffiliateProductEdit_objectSpread({}, element, {
                    content_attributes: AffiliateProductEdit_objectSpread({}, element.content_attributes, {
                        items: newProductListSortOrder
                    })
                });
            } else return element;
        });
        callBackSaveAffiliateProductEdit(newAffiliateProductGroupData);
        callBackCancelAffiliateProductEdit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 bg-white relative",
                ref: popoverRef,
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_edit_affiliate_product_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductEdit_MoreActions, {
                            productData: productDataState,
                            onUpdateProductData: function(data) {
                                return setProductDataState(data);
                            },
                            onDeleteProduct: onDeleteProduct
                        })
                    })
                ]
            }),
            (productDataState === null || productDataState === void 0 ? void 0 : productDataState.enable) != configs_const/* ENABLE_BLOCK */.C5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenWarningUI/* default */.Z, {
                label: t("ss_builder_product_is_hiding_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-[12px_16px] bg-[#FFFFFF] flex flex-row items-center justify-between cursor-pointer",
                onClick: function() {
                    return setIsOpenProductGroupSelection(true);
                },
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] leading-[23px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_product_group_selection_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: !productGroupValue && t("ss_builder_product_group_selection_placeholder"),
                                value: productGroupPickerValue,
                                readOnly: true,
                                className: "w-full text-ellipsis overflow-hidden whitespace-nowrap"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                        className: "w-4 h-4",
                        fillColor: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem/* default */.Z, {
                item: productDataState,
                onUpdateName: function onUpdateName(name) {
                    handleChangeNameProduct(name);
                },
                onCheckOpenNewTab: function onCheckOpenNewTab(openNewTab) {
                    handleCheckOpenNewTab(openNewTab);
                },
                onUpdateImage: function onUpdateImage(image) {
                    if (image == null) {
                        handleDeleteImageProduct();
                    } else {
                        handleImageUrl(image);
                    }
                },
                onCheckUseAffiliateUrl: function onCheckUseAffiliateUrl(checked) {
                    handleCheckAffiliateUrl();
                },
                onSelectLabelProduct: function onSelectLabelProduct(labelProduct) {
                    handleSelectLabelProduct(labelProduct);
                },
                isValidFileFormat: isValidFileFormat,
                isValidFileSize: isValidFileSize,
                isEdit: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                onClick: handleCancelAffiliateProductEdit,
                                children: t("ss_builder_editor_btn-cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                disabled: !isSaveButtonEnable,
                                color: "primary",
                                onClick: handleSaveAffiliateProductEdit,
                                children: t("ss_builder_editor_btn-save")
                            })
                        })
                    ]
                })
            }),
            isOpenProductGroupSelection && /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupPickerView/* default */.Z, {
                affiliateProductGroupData: affiliateProductGroupData,
                visible: isOpenProductGroupSelection,
                onCancelAffiliateProductGroupSelection: function() {
                    return setIsOpenProductGroupSelection(false);
                },
                defaultValue: productGroupValue,
                onSelectAffiliateProductGroup: function(val) {
                    return setProductGroupValue(val);
                },
                onAddNewAffiliateProductGroup: callbackAddNewAffiliateProductGroup,
                productGroupMaximum: productGroupMaximum
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductEdit = (AffiliateProductEdit);


/***/ }),

/***/ 39603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var _features_block_block_conf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60920);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25934);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var _share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85558);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var PRODUCT_GROUP_NAME_MAX_LENGTH = 25;
var AffiliateProductGroupAddNew = function(props) {
    var onCancelAffiliateProductGroupAddNew = props.onCancelAffiliateProductGroupAddNew, affiliateProductGroupDefault = props.affiliateProductGroupDefault, onSaveAffiliateProductGroupAddNew = props.onSaveAffiliateProductGroupAddNew, affiliateProductGroupList = props.affiliateProductGroupList;
    var valueInputDefault = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return affiliateProductGroupDefault === null || affiliateProductGroupDefault === void 0 ? void 0 : affiliateProductGroupDefault.title;
    }, [
        affiliateProductGroupDefault
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(valueInputDefault || ""), valueInput = ref1[0], setValueInput = ref1[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (valueInputDefault) {
            setValueInput(valueInputDefault);
        }
    }, [
        valueInputDefault
    ]);
    var handleConfirmAffiliateProductGroupAddNew = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var defaultAffiliateProductData = {
            uid: "affiliate-product-".concat((0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)()),
            sort_order: 1,
            enable: 1,
            block_type: _features_block_block_conf__WEBPACK_IMPORTED_MODULE_3__/* .BLOCK_TYPE.AFF_PRODUCT */ .bF.AFF_PRODUCT,
            title: valueInput,
            content_attributes: {
                items: [],
                title_product_group: valueInput
            },
            style_attributes: {}
        };
        if (!affiliateProductGroupDefault) {
            onSaveAffiliateProductGroupAddNew(defaultAffiliateProductData, defaultAffiliateProductData.uid);
            antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Toast.show */ .FN.show({
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIcon */ .rE, {
                    className: "text-center inline-block",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_add_new_product_group_successfully_label")
                })
            });
        } else {
            onSaveAffiliateProductGroupAddNew(_objectSpread({}, affiliateProductGroupDefault, {
                title: valueInput,
                content_attributes: _objectSpread({}, affiliateProductGroupDefault === null || affiliateProductGroupDefault === void 0 ? void 0 : affiliateProductGroupDefault.content_attributes, {
                    title_product_group: valueInput
                })
            }), affiliateProductGroupDefault.uid);
            antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Toast.show */ .FN.show({
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIcon */ .rE, {
                    className: "text-center inline-block",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_change_name_product_group_successfully_label")
                })
            });
        }
        onCancelAffiliateProductGroupAddNew();
    }, [
        valueInput
    ]);
    var isExistProductGroup = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref2;
        if ((ref2 = affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.filter(function(e) {
            return (e === null || e === void 0 ? void 0 : e.uid) !== (affiliateProductGroupDefault === null || affiliateProductGroupDefault === void 0 ? void 0 : affiliateProductGroupDefault.uid);
        })) === null || ref2 === void 0 ? void 0 : ref2.find(function(x) {
            var ref;
            return (x === null || x === void 0 ? void 0 : (ref = x.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === valueInput.toLowerCase();
        })) {
            return true;
        } else return false;
    }, [
        affiliateProductGroupList,
        valueInput,
        affiliateProductGroupDefault
    ]);
    var isDisableConfirmAffiliateProductGroupAddNew = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (valueInput && valueInput !== valueInputDefault && !isExistProductGroup) {
            return false;
        } else return true;
    }, [
        valueInput,
        valueInputDefault,
        isExistProductGroup
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-1 py-3 px-4",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-[15px] text-[#666666] leading-[150%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_edit_affiliate_product_group_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .II, {
                        onChange: function(val) {
                            setValueInput(val);
                        },
                        placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder"),
                        value: valueInput || "",
                        style: {
                            // border: "1px solid #F1F1F1",
                            padding: "5px",
                            borderRadius: "5px"
                        },
                        autoFocus: true,
                        maxLength: PRODUCT_GROUP_NAME_MAX_LENGTH
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                        children: "".concat(valueInput.length, "/").concat(PRODUCT_GROUP_NAME_MAX_LENGTH)
                    }),
                    isExistProductGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[13px] leading-[131%] text-[#FF3141]",
                        children: t("ss_builder_existed_product_group_label")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onConfirm: !isDisableConfirmAffiliateProductGroupAddNew ? handleConfirmAffiliateProductGroupAddNew : function() {},
                title: t("ss_builder_confirm_affiliate_product_group_add_new_panel_label"),
                isDisable: isDisableConfirmAffiliateProductGroupAddNew
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AffiliateProductGroupAddNew);


/***/ }),

/***/ 63542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85558);
/* harmony import */ var _share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21043);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55016);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13408);
/* harmony import */ var antd_mobile_es_utils_sleep__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24547);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31567);
/* harmony import */ var _AffiliateProductGroupManagement_AffiliateProductGroupAddNew__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39603);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var AffiliateProductGroupPickerView = function(props) {
    var affiliateProductGroupData = props.affiliateProductGroupData, visible = props.visible, onCancelAffiliateProductGroupSelection = props.onCancelAffiliateProductGroupSelection, defaultValue = props.defaultValue, onSelectAffiliateProductGroup = props.onSelectAffiliateProductGroup, onAddNewAffiliateProductGroup = props.onAddNewAffiliateProductGroup, productGroupMaximum = props.productGroupMaximum, listProducts = props.listProducts;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)().t;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(defaultValue), groupPickerValue = ref4[0], setGroupPickerValue = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), isOpenAddMoreProductGroup = ref1[0], setIsOpenAddMoreProductGroup = ref1[1];
    var columns = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(x) {
        var ref, ref2, ref3;
        return {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex flex-row gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        children: [
                            x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group,
                            " ",
                            "(".concat(x === null || x === void 0 ? void 0 : (ref2 = x.content_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.length, "/").concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh, ")")
                        ]
                    }),
                    (x === null || x === void 0 ? void 0 : x.enable) !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "icon-checklist",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_5__/* .EyeVisibleIcon */ .m0, {
                            className: "w-4 h-4",
                            fillColor: "#333333"
                        })
                    })
                ]
            }),
            value: x === null || x === void 0 ? void 0 : x.uid
        };
    });
    var handleSaveAffiliateProductGroupAddNew = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var affiliateProductGroupListClone, checkExistProductIdx, newAffiliateProductGroupDataSortOrder, element;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        affiliateProductGroupListClone = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_7___default()(affiliateProductGroupData);
                        checkExistProductIdx = affiliateProductGroupListClone && affiliateProductGroupListClone.findIndex(function(x) {
                            return x.uid === data.uid;
                        });
                        if (checkExistProductIdx >= 0) {
                            affiliateProductGroupListClone[checkExistProductIdx] = data;
                        } else {
                            affiliateProductGroupListClone = _toConsumableArray(affiliateProductGroupData).concat([
                                data
                            ]);
                        }
                        newAffiliateProductGroupDataSortOrder = affiliateProductGroupListClone.map(function(ele, idx) {
                            return _objectSpread({}, ele, {
                                sort_order: idx + 1
                            });
                        });
                        onAddNewAffiliateProductGroup(newAffiliateProductGroupDataSortOrder);
                        setGroupPickerValue(data === null || data === void 0 ? void 0 : data.uid);
                        _ctx.next = 8;
                        return (0,antd_mobile_es_utils_sleep__WEBPACK_IMPORTED_MODULE_11__/* .sleep */ ._)(500);
                    case 8:
                        element = document.getElementsByClassName(data === null || data === void 0 ? void 0 : data.uid);
                        if (element[0]) {
                            element[0].scrollIntoView();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSaveAffiliateProductGroupAddNew(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var newColumns = // {
    //   value: "",
    //   label: "",
    // },
    _toConsumableArray(columns);
    var isFullProductsInGroup = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        var ref, ref5, ref6, ref7;
        return !!(((ref7 = (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return x.uid === groupPickerValue;
        })) === null || ref === void 0 ? void 0 : (ref5 = ref.content_attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.items) === null || ref6 === void 0 ? void 0 : ref6.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) === 1;
        })) === null || ref7 === void 0 ? void 0 : ref7.length) >= _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh);
    }, [
        affiliateProductGroupData,
        groupPickerValue
    ]);
    var isNotEnoughSpaceGroup = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        var ref, ref8, ref9, ref10;
        return !!(((ref10 = (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return x.uid === groupPickerValue;
        })) === null || ref === void 0 ? void 0 : (ref8 = ref.content_attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.items) === null || ref9 === void 0 ? void 0 : ref9.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) === 1;
        })) === null || ref10 === void 0 ? void 0 : ref10.length) + (listProducts === null || listProducts === void 0 ? void 0 : listProducts.length) >= _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh);
    }, [
        affiliateProductGroupData,
        groupPickerValue,
        listProducts
    ]);
    var handleConfirmProductGroupPicker = function(val) {
        if (isFullProductsInGroup) {
            antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Modal.show */ .u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_5__/* .InformationTriangleIcon */ .Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_group_is_full_of_product_modal_title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "",
                            children: t("ss_builder_group_is_full_of_product_modal_description")
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_delete_product_group_error_btn_confirm_label")
                    }, 
                ]
            });
        } else if (isNotEnoughSpaceGroup) {
            antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Modal.show */ .u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_5__/* .InformationTriangleIcon */ .Lm, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_not_enough_space_product_group_modal_title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "",
                            children: t("ss_builder_not_enough_space_product_group_modal_content", {
                                num_products: listProducts === null || listProducts === void 0 ? void 0 : listProducts.length
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_delete_product_group_error_btn_confirm_label")
                    }, 
                ]
            });
        } else onSelectAffiliateProductGroup(val);
    };
    var handleCancelProductGroup = function() {
        onCancelAffiliateProductGroupSelection();
    };
    var handleSelectProductGroup = function() {
        handleConfirmProductGroupPicker(groupPickerValue);
        handleCancelProductGroup();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        var timer = setTimeout(function() {
            var element = document.getElementsByClassName(groupPickerValue);
            if (element[0]) {
                element[0].scrollIntoView();
            }
        }, 50);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                visible: isOpenAddMoreProductGroup ? !visible : visible,
                onMaskClick: function() {
                    return onCancelAffiliateProductGroupSelection();
                },
                title: t("ss_builder_product_group_selection_title"),
                onClose: function() {
                    return onCancelAffiliateProductGroupSelection();
                },
                classNameBody: "max-h-[60vh] min-h-[30vh]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "h-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "check-list-aff-group ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .CheckList */ .Su, {
                                value: [
                                    groupPickerValue
                                ],
                                onChange: function(val) {
                                    return val[0] ? setGroupPickerValue(val[0]) : {};
                                },
                                className: "pb-[110px] overflow-y-auto",
                                children: newColumns.map(function(ele, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .CheckList.Item */ .Su.Item, {
                                        value: ele.value,
                                        className: ele.value,
                                        children: ele.label
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "absolute bottom-0 left-0 w-full bg-white box-btn-aff-group",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
                                    className: "w-full",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                        border: "none"
                                    },
                                    color: "primary",
                                    onClick: function() {
                                        setIsOpenAddMoreProductGroup(true);
                                    },
                                    disabled: columns.length >= productGroupMaximum,
                                    fill: "outline",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_5__/* .AddIcon */ .T8, {
                                            fillColor: "#EE3244",
                                            className: "w-[18px] h-[18px]"
                                        }),
                                        t("ss_builder_product_group_add_new_btn_label"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            children: "".concat(columns.length, "/").concat(productGroupMaximum)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    isDisable: groupPickerValue ? false : true,
                                    onConfirm: handleSelectProductGroup
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                visible: isOpenAddMoreProductGroup,
                onMaskClick: function() {
                    return setIsOpenAddMoreProductGroup(false);
                },
                title: t("ss_builder_add_new_affiliate_product_group_btn_label"),
                onClose: function() {
                    return setIsOpenAddMoreProductGroup(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AffiliateProductGroupManagement_AffiliateProductGroupAddNew__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    onCancelAffiliateProductGroupAddNew: function() {
                        return setIsOpenAddMoreProductGroup(false);
                    },
                    onSaveAffiliateProductGroupAddNew: handleSaveAffiliateProductGroupAddNew,
                    affiliateProductGroupList: affiliateProductGroupData
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AffiliateProductGroupPickerView);


/***/ }),

/***/ 31153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13408);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55016);
/* harmony import */ var _share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85558);







var AffiliateProductMovingPanel = function(props) {
    var callbackCancelAffiliateProductMovingPanel = props.callbackCancelAffiliateProductMovingPanel, callbackConfirmAffiliateProductMovingPanel = props.callbackConfirmAffiliateProductMovingPanel, _allowedMovingAffiliateProductGroup = props.allowedMovingAffiliateProductGroup, allowedMovingAffiliateProductGroup = _allowedMovingAffiliateProductGroup === void 0 ? [] : _allowedMovingAffiliateProductGroup, productMovingQuantity = props.productMovingQuantity;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), valueCheckedArr = ref16[0], setValueCheckedArr = ref16[1];
    var handleConfirmAffiliateProductMovingPanel = function() {
        callbackConfirmAffiliateProductMovingPanel(valueCheckedArr[0]);
        callbackCancelAffiliateProductMovingPanel();
    };
    var handleGetCheckedProductGroup = function(val) {
        var newValueCheckedArr = [];
        var value = val[val.length - 1];
        if (value) newValueCheckedArr.push(value);
        setValueCheckedArr(newValueCheckedArr);
    };
    var isEnableConfirmProductSelectedList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (valueCheckedArr === null || valueCheckedArr === void 0 ? void 0 : valueCheckedArr.length) > 0;
    }, [
        valueCheckedArr
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "affiliate-product-moving-panel",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                className: "pb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "pl-3",
                    children: [
                        t("ss_builder_move_product_quantity_to_group_alert_label", {
                            product_quantity: productMovingQuantity
                        }),
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Checkbox.Group */ .XZ.Group, {
                    onChange: handleGetCheckedProductGroup,
                    value: valueCheckedArr,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .List */ .aV, {
                        className: "affiliate-product-moving-panel-content",
                        style: {
                            "--border-bottom": "unset",
                            "--border-top": "unset"
                        },
                        children: allowedMovingAffiliateProductGroup === null || allowedMovingAffiliateProductGroup === void 0 ? void 0 : allowedMovingAffiliateProductGroup.map(function(ele, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .List.Item */ .aV.Item, {
                                arrow: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Checkbox */ .XZ, {
                                    value: ele.uid,
                                    disabled: (ele === null || ele === void 0 ? void 0 : (ref = ele.content_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length) >= _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh || productMovingQuantity > _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh - (ele === null || ele === void 0 ? void 0 : (ref2 = ele.content_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.length),
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex items-center gap-[6px] flex-row"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-[17px] leading-[22px] font-normal",
                                                    children: ele.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4", (ele === null || ele === void 0 ? void 0 : (ref4 = ele.content_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.items) === null || ref5 === void 0 ? void 0 : ref5.length) >= _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh || productMovingQuantity > _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh - (ele === null || ele === void 0 ? void 0 : (ref6 = ele.content_attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.items) === null || ref7 === void 0 ? void 0 : ref7.length) ? "text-[#FF3141]" : "text-[#8C8C8C]"),
                                                    children: [
                                                        t("ss_builder_affiliate_product_group_quantity_label", {
                                                            product_quantity: "".concat(ele === null || ele === void 0 ? void 0 : (ref8 = ele.content_attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.items) === null || ref9 === void 0 ? void 0 : ref9.length, "/").concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh)
                                                        }),
                                                        ".\xa0",
                                                        (ele === null || ele === void 0 ? void 0 : (ref10 = ele.content_attributes) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.items) === null || ref11 === void 0 ? void 0 : ref11.length) >= _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh && t("ss_builder_affiliate_product_group_quantity_warning_1"),
                                                        (ele === null || ele === void 0 ? void 0 : (ref12 = ele.content_attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.items) === null || ref13 === void 0 ? void 0 : ref13.length) !== _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh && productMovingQuantity > _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_MAX */ .Kh - (ele === null || ele === void 0 ? void 0 : (ref14 = ele.content_attributes) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.items) === null || ref15 === void 0 ? void 0 : ref15.length) && t("ss_builder_affiliate_product_group_quantity_warning_2")
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, index);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                onConfirm: isEnableConfirmProductSelectedList ? handleConfirmAffiliateProductMovingPanel : function() {},
                isDisable: !isEnableConfirmProductSelectedList
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AffiliateProductMovingPanel);


/***/ }),

/***/ 7246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P9": function() { return /* binding */ AFFILIATE_SETTING_TOUR_CLASS_NAME; },
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "om": function() { return /* binding */ STEP_INDEX; }
/* harmony export */ });
var AFFILIATE_SETTING_TOUR_CLASS_NAME = {
    STEP_1: "affiliate-setting-tour-more-options-header",
    STEP_2: "affiliate-setting-tour-heading-area",
    STEP_3: "affiliate-setting-tour-layout-config",
    STEP_4: "affiliate-setting-tour-group-management-button",
    STEP_5: "affiliate-setting-tour-group-tab-list",
    STEP_6: "affiliate-setting-tour-product-addition",
    STEP_7: "affiliate-setting-product-more-options",
    STEP_8: "affiliate-setting-saving-button",
    STEP_9: "affiliate-setting-user-manual"
};
var STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
    STEP_4: 3,
    STEP_5: 4,
    STEP_6: 5,
    STEP_7: 6,
    STEP_8: 7,
    STEP_9: 8
};
var steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-1.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_1",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_1",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-2.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_2",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_2",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "",
        position: "bottom-middle-aligned"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-3.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_3",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_3",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_3,
        tooltip_class: "auto",
        position: "top"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-4.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_4",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_4",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_4,
        tooltip_class: "",
        position: "top"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-5.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_5",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_5",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_5,
        tooltip_class: "",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-6.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_6",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_6",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_6,
        tooltip_class: "",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-7.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_7",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_7",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_7,
        tooltip_class: "",
        position: "top"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-step-8.gif",
        title_key: "ss_builder_affiliate_setting_tour_title_step_8",
        intro_key: "ss_builder_affiliate_setting_tour_content_step_8",
        element_class: AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_8,
        tooltip_class: "show-label-text product-tour-custom",
        position: "top"
    }, 
];


/***/ }),

/***/ 35501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_components_AutoScrollSelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80878);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55016);
/* harmony import */ var _share_helper_browser__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52741);
/* harmony import */ var _share_helper_validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11116);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31567);
/* harmony import */ var _AffiliateProductAddNew_ProductAddNewTourOpening_affiliate_add_new_tour_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54925);
/* harmony import */ var _share_components_AntImage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32554);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _features_block_block_editor_AffiliateProductGroup_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69283);
/* harmony import */ var _share_helper_image__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79704);















var PRODUCT_NAME_MAX_LENGTH = 250;
function ProductItem(props) {
    var item = props.item, index = props.index, onUpdateName = props.onUpdateName, onUpdateImage = props.onUpdateImage, onCheckUseAffiliateUrl = props.onCheckUseAffiliateUrl, onCheckOpenNewTab = props.onCheckOpenNewTab, onSelectLabelProduct = props.onSelectLabelProduct, _isValidFileFormat = props.isValidFileFormat, isValidFileFormat = _isValidFileFormat === void 0 ? false : _isValidFileFormat, _isValidFileSize = props.isValidFileSize, isValidFileSize = _isValidFileSize === void 0 ? false : _isValidFileSize, _onDelete = props.onDelete, onDelete = _onDelete === void 0 ? false : _onDelete, _isEdit = props.isEdit, isEdit = _isEdit === void 0 ? false : _isEdit;
    var ref8 = (0,_features_block_block_editor_AffiliateProductGroup_context__WEBPACK_IMPORTED_MODULE_11__/* .useAffiliateContext */ .U)(), frameData = ref8.frameData, usingFrame = ref8.usingFrame;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)();
    var cleanupPopoverRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var ref2;
    var labelProductDefault = (ref2 = item === null || item === void 0 ? void 0 : item.label_product) !== null && ref2 !== void 0 ? ref2 : [];
    var isCleanupLock = !!((item === null || item === void 0 ? void 0 : item.is_cleanup_lock) === 1);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), uploadedImageArr = ref3[0], setUploadedImageArr = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(labelProductDefault), labelProduct = ref4[0], setLabelProduct = ref4[1];
    var openInNewTabDefault = (item === null || item === void 0 ? void 0 : item.open_new_tab) || false;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(openInNewTabDefault), openNewTab = ref5[0], setOpenNewTab = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), isEcommerce = ref6[0], setIsEcommerce = ref6[1];
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
        onCheckOpenNewTab(data);
    };
    var checkEcomerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,_share_helper_validator__WEBPACK_IMPORTED_MODULE_3__/* .checkOpenNewTab */ .lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (item === null || item === void 0 ? void 0 : item.origin_link) {
            checkEcomerce(item === null || item === void 0 ? void 0 : item.origin_link);
        }
    }, [
        item === null || item === void 0 ? void 0 : item.origin_link
    ]);
    var copyLinkProduct = function(value) {
        (0,_share_helper_browser__WEBPACK_IMPORTED_MODULE_14__/* .copyToClipboard */ .v)(value);
        antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_personal_link_coppy_successfully_label")
            })
        });
    };
    var displayLink = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        if (!(item === null || item === void 0 ? void 0 : item.shortern_link)) {
            return item.origin_link;
        }
        if (item.use_aff_url != 1) {
            return item.origin_link;
        }
        return item === null || item === void 0 ? void 0 : item.shortern_link;
    }, [
        item
    ]);
    var productTitle = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.title);
    var labelProductOptions = [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .HotIcon */ .q7, {
                        width: 16,
                        height: 16
                    }),
                    t("ss_builder_affiliate_product_label_product_hot")
                ]
            }),
            value: _share_configs_const__WEBPACK_IMPORTED_MODULE_2__/* .LABEL_PRODUCT.HOT */ .u.HOT
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .SaleIcon */ .rG, {
                        width: 16,
                        height: 16
                    }),
                    t("ss_builder_affiliate_product_label_product_discount")
                ]
            }),
            value: _share_configs_const__WEBPACK_IMPORTED_MODULE_2__/* .LABEL_PRODUCT.SALE */ .u.SALE
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .FavouriteIcon */ .EL, {
                        width: 16,
                        height: 16
                    }),
                    t("ss_builder_affiliate_product_label_product_like")
                ]
            }),
            value: _share_configs_const__WEBPACK_IMPORTED_MODULE_2__/* .LABEL_PRODUCT.FAVOURITE */ .u.FAVOURITE
        }, 
    ];
    var handleSelectLabelProduct = function(arr, extend) {
        setLabelProduct(arr);
        onSelectLabelProduct(arr);
    };
    var imageResizing = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        var ref;
        if (!(item === null || item === void 0 ? void 0 : item.image_base64) && ((ref = item.image) === null || ref === void 0 ? void 0 : ref.startsWith("https://passio-prod"))) {
            var ref7;
            return "".concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_2__/* .DOMAIN_RESIZE_IMG */ .V5, "/160x160/").concat((ref7 = item.image) === null || ref7 === void 0 ? void 0 : ref7.split("/passio-prod/")[1]);
        } else return item.image;
    }, [
        item.image,
        item.image_base64
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: ref1,
        className: classnames__WEBPACK_IMPORTED_MODULE_10___default()(isEdit && "pb-[100px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-3 py-5 flex flex-row gap-3 text-center items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Ellipsis */ .mH, {
                        className: "text-[#999999] text-[15px] leading-5 text-ellipsis",
                        content: displayLink
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: function() {
                                    return copyLinkProduct(displayLink);
                                },
                                className: "p-1 cursor-pointer mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CopyIcon */ .TI, {
                                    className: "cursor-pointer"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: function() {
                                    return (0,_share_helper_browser__WEBPACK_IMPORTED_MODULE_14__/* .openInNewBrowser */ .i)(displayLink);
                                },
                                className: "mr-2 p-1 cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .GlobalIcon */ .ww, {
                                    className: "cursor-pointer"
                                })
                            }),
                            onDelete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "p-1 cursor-pointer mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .TrashIcon */ .XH, {
                                    // className="w-5 h-5 cursor-pointer"
                                    fillColor: "#333",
                                    onClick: onDelete
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "p-[12px_16px] bg-[#FFFFFF] mx-3 rounded-lg mb-6",
                style: {
                    border: productTitle ? "none" : "2px solid #ee3244ff"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: index === 0 && _AffiliateProductAddNew_ProductAddNewTourOpening_affiliate_add_new_tour_config__WEBPACK_IMPORTED_MODULE_8__/* .AFFILIATE_ADD_NEW_TOUR_CLASS_NAME.STEP_3 */ .qU.STEP_3,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-[15px] leading-[23px] text-[#666666]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-red-600",
                                                children: "*"
                                            }),
                                            t("ss_builder_add_new_affiliate_product_name_title")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Input */ .II, {
                                        value: productTitle,
                                        onChange: function(val) {
                                            if ((val === null || val === void 0 ? void 0 : val.length) <= PRODUCT_NAME_MAX_LENGTH) onUpdateName(val);
                                        },
                                        maxLength: PRODUCT_NAME_MAX_LENGTH,
                                        placeholder: t("ss_builder_placeholder_affiliate_product_enter_product_name")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                        children: "".concat(productTitle ? productTitle.length : 0, "/").concat(PRODUCT_NAME_MAX_LENGTH)
                                    }),
                                    !productTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[#FF3141] mt-1 text-[13px] leading-[131%]",
                                        children: t("ss_builder_product_title_missing_warning")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-[15px] leading-[23px] text-[#666666] flex flex-row gap-1 text-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: t("ss_builder_add_new_affiliate_product_image_title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Popover */ .J2, {
                                                content: t("ss_builder_affiliate_product_image_popup_infomation_label"),
                                                trigger: "click",
                                                placement: "top",
                                                mode: "dark",
                                                stopPropagation: [
                                                    "click"
                                                ],
                                                getContainer: function() {
                                                    return ref1.current;
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .QuestionCircleIcon */ .pT, {
                                                    className: "w-[15px] h-[15px] cursor-pointer"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "grid grid-cols-[120px_auto] gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_AntImage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                                src: imageResizing || "https://image.passio.eco/160x160/page-builder/page-builder/images-default/product-default.jpeg",
                                                                fit: "cover",
                                                                style: {
                                                                    borderRadius: "8px"
                                                                },
                                                                width: 120,
                                                                height: 120
                                                            }),
                                                            usingFrame && frameData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "absolute w-[120px] h-[120px] top-0 left-0",
                                                                style: {
                                                                    background: 'url("'.concat((0,_share_helper_image__WEBPACK_IMPORTED_MODULE_12__/* .getHorizontalResizeUrl */ .L)(frameData.urlEU, 160), '") no-repeat  bottom left / contain'),
                                                                    aspectRatio: "1/1",
                                                                    borderRadius: "4px"
                                                                }
                                                            }),
                                                            isCleanupLock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Popover */ .J2, {
                                                                content: t("ss_builder_affiliate_product_clean_up_popover_content"),
                                                                trigger: "click",
                                                                placement: "bottom",
                                                                mode: "dark",
                                                                stopPropagation: [
                                                                    "click"
                                                                ],
                                                                getContainer: function() {
                                                                    return cleanupPopoverRef.current;
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "absolute bottom-1 right-1 cursor-pointer",
                                                                    onClick: function(e) {
                                                                        return e.stopPropagation();
                                                                    },
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "relative rounded-ful",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "p-3 rounded-full bg-black opacity-80"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "absolute z-[2] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .BroomLockIcon */ .mP, {
                                                                                    className: "w-[14px] h-[14px]",
                                                                                    fillColor: "#FFFFFF"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mb-12 leading-4",
                                                                children: t("ss_builder_theme_setting_background_content")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex gap-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ImageUploader */ .wA, {
                                                                    onChange: onUpdateImage,
                                                                    upload: function(file) {
                                                                        return (0,_share_lib__WEBPACK_IMPORTED_MODULE_5__/* .mockUpload */ .Hq)(file, 514, 980);
                                                                    },
                                                                    className: "grow",
                                                                    value: uploadedImageArr,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
                                                                        color: "primary",
                                                                        fill: "solid",
                                                                        size: "middle",
                                                                        className: "w-full",
                                                                        children: t("ss_builder_change_image_button_label")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            isValidFileFormat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-row gap-1 items-center mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationTriangleIcon */ .Lm, {
                                                        fillColor: "#FF3141",
                                                        className: "w-4 h-4"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[#FF3141]",
                                                        children: t("ss_builder_upload_file_format_invalid_content")
                                                    })
                                                ]
                                            }),
                                            isValidFileSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-row gap-1 items-center mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationTriangleIcon */ .Lm, {
                                                        fillColor: "#FF3141",
                                                        className: "w-4 h-4"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[#FF3141]",
                                                        children: t("ss_builder_upload_file_size_invalid_content")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[15px] text-[#666666] mb-1 leading-[150%]",
                                children: t("ss_builder_affiliate_product_label_product_title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_AutoScrollSelector__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                options: labelProductOptions,
                                onChange: handleSelectLabelProduct,
                                isMultiple: true,
                                value: labelProduct,
                                className: "auto-scroll-label-product"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Checkbox */ .XZ, {
                                checked: !!(item.use_aff_url === 1),
                                onChange: onCheckUseAffiliateUrl,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-left",
                                    children: t("ss_builder_use_affiliate_link_label")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Popover */ .J2, {
                                content: t("ss_builder_use_affiliate_link_description"),
                                placement: "top-start",
                                mode: "dark",
                                trigger: "click",
                                stopPropagation: [
                                    "click"
                                ],
                                getContainer: function() {
                                    return ref1.current;
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "w-[22px] h-[22px] flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationIcon */ .Yk, {
                                        className: "w-4 h-4 cursor-pointer",
                                        onClick: function() {},
                                        fillColor: "#1890FF"
                                    })
                                })
                            })
                        ]
                    }),
                    !isEcommerce && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Checkbox */ .XZ, {
                                        checked: !!openNewTab,
                                        onChange: handleChangeOpenNewTab,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_open_new_tab_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Popover */ .J2, {
                                        content: t("ss_builder_open_new_tab_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationIcon */ .Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    item.warning_code && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row text-left items-center text-[13px] leading-[17px] text-[#F59020] gap-2 bg-[#FFF9ED] p-[8px_12px] rounded",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationIcon */ .Yk, {
                                        className: "w-[18px] h-[18px]",
                                        fillColor: "#FF6010"
                                    }),
                                    t("ss_validate_origin_url_warning_".concat(item.warning_code))
                                ]
                            })
                        ]
                    }),
                    ((item === null || item === void 0 ? void 0 : item.gen_link_err_code) || (item === null || item === void 0 ? void 0 : item.error_code)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Divider */ .iz, {}),
                            (item === null || item === void 0 ? void 0 : item.gen_link_err_code) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-[8px] font-normal leading-[21px] text-[15px] ",
                                style: {
                                    border: "1px dashed #FFD591",
                                    backgroundColor: "#FFF9ED",
                                    color: "#FF6010",
                                    borderRadius: "4px",
                                    padding: "8px 12px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "my-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .WarningIcon */ .aN, {
                                            className: "m-auto"
                                        })
                                    }),
                                    t("ss_builder_validate_gen_link_error_".concat(item.gen_link_err_code))
                                ]
                            }),
                            (item === null || item === void 0 ? void 0 : item.error_code) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[13px] leading-[17px] text-[#FF3141] ",
                                children: t("ss_builder_validate_origin_url_error_".concat(item.error_code))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ActionEnum; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31567);
/* harmony import */ var _AffiliateProductTourOpening_ProductSettingTour_setting_tour_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7246);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65457);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55016);
/* harmony import */ var _share_components_AntImage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32554);
/* harmony import */ var _share_hooks_toast__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95880);
/* harmony import */ var _share_hooks_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5996);
/* harmony import */ var _features_block_block_editor_AffiliateProductGroup_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69283);
/* harmony import */ var _share_helper_image__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79704);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ActionEnum;
(function(ActionEnum) {
    ActionEnum["VISIBLE_HIDE_PRODUCT"] = "visible-hide-product";
    ActionEnum["DELETE_PRODUCT"] = "delete-product";
    ActionEnum["MOVE_PRODUCT"] = "move-product";
    ActionEnum["MOVE_TO_TOP"] = "move-to-top";
    ActionEnum["MOVE_TO_BOTTOM"] = "move-to-bottom";
    ActionEnum["CLEANUP_LOCK_PRODUCT"] = "cleanup-lock-product";
    ActionEnum["EDIT_PRODUCT"] = "edit-product";
})(ActionEnum || (ActionEnum = {}));
var ProductListItems = function(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)().t;
    var ref3 = (0,_features_block_block_editor_AffiliateProductGroup_context__WEBPACK_IMPORTED_MODULE_11__/* .useAffiliateContext */ .U)(), frameData = ref3.frameData, usingFrame = ref3.usingFrame;
    var index = props.index, productData = props.productData, isFinalItem = props.isFinalItem, isOnlyItem = props.isOnlyItem, isOnlyProductGroup = props.isOnlyProductGroup, onRemoveProductItem = props.onRemoveProductItem, onDisableEnableProduct = props.onDisableEnableProduct, callbackOpenEditProduct = props.callbackOpenEditProduct, onMoveProductItem = props.onMoveProductItem, onMoveToTopProductItem = props.onMoveToTopProductItem, onMoveToBottomProductItem = props.onMoveToBottomProductItem, onCleanupLockProduct = props.onCleanupLockProduct;
    var SuccessToast = (0,_share_hooks_toast__WEBPACK_IMPORTED_MODULE_9__/* .useToast */ .p)().SuccessToast;
    var ConfirmModal = (0,_share_hooks_modal__WEBPACK_IMPORTED_MODULE_10__/* .useModal */ .dd)().ConfirmModal;
    var isEnable = !!((productData === null || productData === void 0 ? void 0 : productData.enable) === 1);
    var isCleanupLock = !!((productData === null || productData === void 0 ? void 0 : productData.is_cleanup_lock) === 1);
    var isOpenAffiliateSettingTour = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.dynamicConfig) === null || ref === void 0 ? void 0 : ref.isOpenAffiliateSettingTour;
    });
    var popoverContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var popoverOptionRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), forceVisiblePopoverProduct = ref1[0], setForceVisiblePopoverProduct = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var castWindow = window;
        if (index === 0) {
            castWindow.triggerVisibleAffiliatePopoverProductDetail = setForceVisiblePopoverProduct;
            (function() {
                if (castWindow.triggerVisibleAffiliatePopoverProductDetail) {
                    castWindow.triggerVisibleAffiliatePopoverProductDetail = undefined;
                    setForceVisiblePopoverProduct(false);
                }
            });
        }
    }, []);
    var ref2;
    var labelProduct = (ref2 = productData === null || productData === void 0 ? void 0 : productData.label_product) !== null && ref2 !== void 0 ? ref2 : [];
    var actions = [
        {
            key: ActionEnum.VISIBLE_HIDE_PRODUCT,
            icon: !isEnable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .EyeHiddenIcon */ .Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .EyeVisibleIcon */ .m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_product_label") : t("ss_builder_hide_product_label")
        },
        {
            key: ActionEnum.DELETE_PRODUCT,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .DeleteIcon */ .pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_product_label")
        },
        {
            key: ActionEnum.MOVE_PRODUCT,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .FolderArrowRightIcon */ .Ao, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_move_product_label")
        },
        {
            key: ActionEnum.MOVE_TO_TOP,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .MoveToTopIcon */ .yS, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_move_to_top_label")
        },
        {
            key: ActionEnum.MOVE_TO_BOTTOM,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .MoveToBottomIcon */ .hd, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_move_to_bottom_label")
        },
        {
            key: ActionEnum.CLEANUP_LOCK_PRODUCT,
            icon: !isCleanupLock ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .BroomLockIcon */ .mP, {
                className: "",
                fillColor: "white"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .BroomIcon */ .Vj, {
                className: "",
                fillColor: "white"
            }),
            text: !isCleanupLock ? t("ss_builder_affiliate_product_cleanup_lock_label") : t("ss_builder_affiliate_product_cleanup_unlock_label")
        }, 
    ];
    var actionsFilter = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var actionsDefault = actions;
        if (index === 0 || isOnlyItem) {
            actionsDefault = actionsDefault.filter(function(x) {
                return x.key !== ActionEnum.MOVE_TO_TOP;
            });
        }
        if (isFinalItem || isOnlyItem) {
            actionsDefault = actionsDefault.filter(function(x) {
                return x.key !== ActionEnum.MOVE_TO_BOTTOM;
            });
        }
        if (isOnlyProductGroup) {
            actionsDefault = actionsDefault.filter(function(x) {
                return x.key !== ActionEnum.MOVE_PRODUCT;
            });
        }
        return actionsDefault;
    }, [
        index,
        isFinalItem,
        isOnlyItem,
        isOnlyProductGroup,
        actions
    ]);
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case ActionEnum.VISIBLE_HIDE_PRODUCT:
                handleEnableDisableProduct();
                break;
            case ActionEnum.DELETE_PRODUCT:
                confirmRemoveProduct();
                break;
            case ActionEnum.MOVE_PRODUCT:
                handleMoveProduct();
                break;
            case ActionEnum.MOVE_TO_TOP:
                handleMoveToTop();
                break;
            case ActionEnum.MOVE_TO_BOTTOM:
                handleMoveToBottom();
                break;
            case ActionEnum.CLEANUP_LOCK_PRODUCT:
                handleCleanupLockProduct();
                break;
            default:
        }
    };
    var handleCleanupLockProduct = function() {
        var cleanupLockStatus = !isCleanupLock ? 1 : 2;
        onCleanupLockProduct(index, cleanupLockStatus);
        SuccessToast(isCleanupLock ? t("ss_builder_cleanup_unlock_product_successfully_label") : t("ss_builder_cleanup_lock_product_successfully_label"));
    };
    var handleMoveToTop = function() {
        onMoveToTopProductItem(productData.uid);
    };
    var handleMoveToBottom = function() {
        onMoveToBottomProductItem(productData.uid);
    };
    var handleMoveProduct = function() {
        onMoveProductItem(productData.uid);
    };
    var confirmRemoveProduct = function() {
        var onConfirm = function() {
            onRemoveProductItem(index);
            SuccessToast(t("ss_builder_delete_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_delete_product_modal_title"),
            icon: _share_hooks_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalIconConfig.INFO_PRIMARY_CIRCLE */ .vi.INFO_PRIMARY_CIRCLE,
            description: t("ss_builder_confirm_delete_product_modal_content"),
            confirmText: t("ss_builder_confirm_delete_product_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleEditProduct = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditProduct(productData);
    };
    var handleEnableDisableProduct = function() {
        var productStatus = !isEnable ? 1 : 2;
        onDisableEnableProduct(index, productStatus);
        SuccessToast(isEnable ? t("ss_builder_disable_product_successfully_label") : t("ss_builder_enable_product_successfully_label"));
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var labelProductIcon = function() {
        return labelProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-1 mt-1",
            children: [
                labelProduct.includes(_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .LABEL_PRODUCT.HOT */ .u.HOT) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "label-product-icon-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .HotIcon */ .q7, {
                        width: 12,
                        height: 12
                    })
                }),
                labelProduct.includes(_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .LABEL_PRODUCT.SALE */ .u.SALE) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "label-product-icon-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .SaleIcon */ .rG, {
                        width: 12,
                        height: 12
                    })
                }),
                labelProduct.includes(_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .LABEL_PRODUCT.FAVOURITE */ .u.FAVOURITE) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "label-product-icon-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .FavouriteIcon */ .EL, {
                        width: 12,
                        height: 12
                    })
                })
            ]
        });
    };
    var visibleStep7Checking = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var value = {};
        if (isOpenAffiliateSettingTour) {
            value = forceVisiblePopoverProduct && index === 0 ? {
                visible: true
            } : {
                visible: false
            };
        }
        return value;
    }, [
        isOpenAffiliateSettingTour,
        forceVisiblePopoverProduct,
        index
    ]);
    var imageResizing = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var ref;
        if (!productData.image_base64 && ((ref = productData.image) === null || ref === void 0 ? void 0 : ref.startsWith("https://passio-prod"))) {
            var ref4;
            return "".concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .DOMAIN_RESIZE_IMG */ .V5, "/80x80/").concat((ref4 = productData.image) === null || ref4 === void 0 ? void 0 : ref4.split("/passio-prod/")[1]);
        } else return productData.image;
    }, [
        productData.image,
        productData.image_base64
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: popoverContainerRef,
        id: index === 0 && _AffiliateProductTourOpening_ProductSettingTour_setting_tour_config__WEBPACK_IMPORTED_MODULE_5__/* .AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_7 */ .P9.STEP_7,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .List */ .aV, {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .List.Item */ .aV.Item, {
                prefix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .DragIcon */ .Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-row items-center gap-[15px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        onClick: handleClickMoreIcon,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Popover.Menu */ .J2.Menu, _objectSpread({
                            className: index === 0 && _AffiliateProductTourOpening_ProductSettingTour_setting_tour_config__WEBPACK_IMPORTED_MODULE_5__/* .AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_7 */ .P9.STEP_7,
                            mode: "dark",
                            actions: actionsFilter,
                            placement: "left",
                            trigger: "click",
                            stopPropagation: [
                                "click"
                            ],
                            getContainer: function() {
                                return popoverContainerRef.current;
                            },
                            onAction: function(item) {
                                return handleClickPopoverItem(item);
                            },
                            ref: popoverOptionRef
                        }, visibleStep7Checking, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .MoreIcon */ .nX, {
                                className: "mr-3"
                            })
                        }))
                    })
                }),
                onClick: handleEditProduct,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center gap-[6px] flex-row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_AntImage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: imageResizing,
                                    width: 40,
                                    height: 40,
                                    fit: "cover",
                                    style: {
                                        outline: "rgba(0, 0, 0, 0.16) solid 1px",
                                        outlineOffset: "-1px",
                                        borderRadius: "4px",
                                        opacity: !isEnable ? "40%" : ""
                                    }
                                }),
                                usingFrame && frameData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute w-10 h-10 top-0 left-0",
                                    style: {
                                        background: 'url("'.concat((0,_share_helper_image__WEBPACK_IMPORTED_MODULE_12__/* .getHorizontalResizeUrl */ .L)(frameData.urlEU, 160), '") no-repeat left bottom/ contain'),
                                        aspectRatio: "1/1",
                                        borderRadius: "4px"
                                    }
                                }),
                                isCleanupLock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Popover */ .J2, {
                                    content: t("ss_builder_affiliate_product_clean_up_popover_content"),
                                    trigger: "click",
                                    placement: "bottom",
                                    mode: "dark",
                                    stopPropagation: [
                                        "click"
                                    ],
                                    getContainer: function() {
                                        return popoverContainerRef.current;
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-[-10px] left-[-10px] cursor-pointer",
                                        onClick: function(e) {
                                            return e.stopPropagation();
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative rounded-ful",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "p-3 rounded-full bg-black opacity-80"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "absolute z-[2] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .BroomLockIcon */ .mP, {
                                                        className: "w-[14px] h-[14px]",
                                                        fillColor: "#FFFFFF"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex flex-col w-[30vw] md:w-[10vw] grow", !isEnable && "opacity-40"),
                            children: [
                                (productData === null || productData === void 0 ? void 0 : productData.title) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                    children: productData.title
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-sm text-[#FF3141]",
                                    children: t("ss_builder_product_title_error")
                                }),
                                productData && productData.use_aff_url === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .CheckCircleIcon */ .rE, {
                                                className: "w-4 h-4",
                                                fillColor: "#00B578"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                            children: t("ss_builder_product_link_wrapped_label")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                    children: productData.origin_link
                                }),
                                labelProductIcon()
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductListItems);


/***/ }),

/***/ 96223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateProductGroup_ProductListLayoutHandler; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/components/PopupComponent/index.tsx
var PopupComponent = __webpack_require__(21043);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/index.tsx + 6 modules
var AffiliateProductAddNew = __webpack_require__(84825);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductEdit/index.tsx + 2 modules
var AffiliateProductEdit = __webpack_require__(22023);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js + 26 modules
var react_beautiful_dnd_esm = __webpack_require__(9276);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListItems/index.tsx
var ProductListItems = __webpack_require__(7804);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductTourOpening/ProductSettingTour/setting-tour-config.ts
var setting_tour_config = __webpack_require__(7246);
// EXTERNAL MODULE: ./src/features/share/components/PlaceholderCustomDragging/index.tsx
var PlaceholderCustomDragging = __webpack_require__(14120);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductLists/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














var AffiliateProductLists = function(props) {
    var affiliateProductGroupItem = props.affiliateProductGroupItem, callbackOpenAddAffiliateProduct = props.callbackOpenAddAffiliateProduct, callbackOpenEditProduct = props.callbackOpenEditProduct, callBackMoveProductItem = props.callBackMoveProductItem, callBackUpdateAffiliateProductGroupData = props.callBackUpdateAffiliateProductGroupData, callbackOpenAffiliateProductSelection = props.callbackOpenAffiliateProductSelection, isSticky = props.isSticky, isFulledProductsAllGroups = props.isFulledProductsAllGroups, isEnableSticky = props.isEnableSticky, stickyTop = props.stickyTop, isOnlyProductGroup = props.isOnlyProductGroup;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref2 = (0,react.useState)({}), placeholderProps1 = ref2[0], setPlaceholderProps = ref2[1];
    var ref1;
    var affiliateProductArr = (0,react.useMemo)(function() {
        var ref;
        return (ref1 = affiliateProductGroupItem === null || affiliateProductGroupItem === void 0 ? void 0 : (ref = affiliateProductGroupItem.content_attributes) === null || ref === void 0 ? void 0 : ref.items) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        affiliateProductGroupItem
    ]);
    var isAllowedToAddProducts = (0,react.useMemo)(function() {
        var ref;
        return ((ref = affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.is_cleanup_lock) === 1;
        })) === null || ref === void 0 ? void 0 : ref.length) < configs_const/* PRODUCT_MAX */.Kh;
    }, [
        affiliateProductArr
    ]);
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(affiliateProductArr);
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedProductList = result.map(function(ele, idx) {
            return _objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedProductList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: itemsOrder
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var onRemoveProductItem = function(index) {
        var affiliateProductClone = cloneDeep_default()(affiliateProductArr);
        var newProductItems = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.filter(function(ele, idx) {
            return idx !== index;
        });
        var newProductItemsSortOrder = newProductItems === null || newProductItems === void 0 ? void 0 : newProductItems.map(function(ele, idx) {
            return _objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: newProductItemsSortOrder
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var onDisableEnableProduct = function(index, productStatus) {
        var currentTime = new Date();
        var updatedAtTime = currentTime.toISOString();
        var affiliateProductClone = cloneDeep_default()(affiliateProductArr);
        var newProductItems = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.map(function(ele, idx) {
            return idx === index ? _objectSpread({}, ele, {
                enable: productStatus,
                updatedAt: updatedAtTime
            }) : ele;
        });
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: newProductItems
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var productRate = (0,react.useMemo)(function() {
        return "".concat(affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.length, "/").concat(configs_const/* PRODUCT_MAX */.Kh);
    }, [
        affiliateProductArr
    ]);
    var handleOpenAddAffiliateProduct = function() {
        if (isFulledProductsAllGroups) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_total_limitation_warning_description", {
                                max_products_all_groups: configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else if (!isAllowedToAddProducts) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_group_limitation_warning_description", {
                                max_products: configs_const/* PRODUCT_MAX */.Kh
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else {
            callbackOpenAddAffiliateProduct();
        }
    };
    var handleOpenEditProduct = function(productData) {
        callbackOpenEditProduct(productData);
    };
    var onMoveProductItem = function(productId) {
        callBackMoveProductItem(productId);
    };
    var onMoveToTopProductItem = function(productId) {
        var affiliateProductClone = cloneDeep_default()(affiliateProductArr);
        var productData = affiliateProductClone.find(function(x) {
            return x.uid === productId;
        });
        var productListsAfterRemoveItem = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.filter(function(x) {
            return x.uid !== productId;
        });
        var newProductLists = [
            productData
        ].concat(_toConsumableArray(productListsAfterRemoveItem));
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: newProductLists === null || newProductLists === void 0 ? void 0 : newProductLists.map(function(ele, idx) {
                    return _objectSpread({}, ele, {
                        sort_order: idx + 1
                    });
                })
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var onMoveToBottomProductItem = function(productId) {
        var affiliateProductClone = cloneDeep_default()(affiliateProductArr);
        var productData = affiliateProductClone.find(function(x) {
            return x.uid === productId;
        });
        var productListsAfterRemoveItem = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.filter(function(x) {
            return x.uid !== productId;
        });
        productListsAfterRemoveItem.push(productData);
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: productListsAfterRemoveItem === null || productListsAfterRemoveItem === void 0 ? void 0 : productListsAfterRemoveItem.map(function(ele, idx) {
                    return _objectSpread({}, ele, {
                        sort_order: idx + 1
                    });
                })
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var onCleanupLockProduct = function(index, cleanupLockStatus) {
        var affiliateProductClone = cloneDeep_default()(affiliateProductArr);
        var newProductItems = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.map(function(ele, idx) {
            return idx === index ? _objectSpread({}, ele, {
                is_cleanup_lock: cleanupLockStatus
            }) : ele;
        });
        var newAffiliateProductGroupData = _objectSpread({}, affiliateProductGroupItem, {
            content_attributes: _objectSpread({}, affiliateProductGroupItem.content_attributes, {
                items: newProductItems
            })
        });
        callBackUpdateAffiliateProductGroupData(newAffiliateProductGroupData);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_6 */.P9.STEP_6,
                className: classnames_default()(setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_6 */.P9.STEP_6, "affiliate-product-list-header flex flex-row justify-between p-4", isEnableSticky && "sticky z-10"),
                style: {
                    backgroundColor: isSticky ? "white" : "",
                    boxShadow: isSticky ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "",
                    top: "".concat(stickyTop, "px")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] text-[#666666]",
                            children: t("ss_builder_affiliate_product_list_title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-grow justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                size: "small",
                                fill: "solid",
                                color: "primary",
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "3px 12px 3px 12px",
                                    opacity: isFulledProductsAllGroups || !isAllowedToAddProducts ? "40%" : ""
                                },
                                onClick: handleOpenAddAffiliateProduct,
                                disabled: affiliateProductArr.length >= configs_const/* PRODUCT_MAX */.Kh,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                        className: "w-[15px] h-[15px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("ss_builder_add_new_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: productRate
                                    })
                                ]
                            }),
                            (affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                fill: "outline",
                                color: "primary",
                                size: "small",
                                onClick: callbackOpenAffiliateProductSelection,
                                children: t("ss_builder_select_label")
                            })
                        ]
                    })
                ]
            }),
            (affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                    onDragEnd: onDragEnd,
                    onDragUpdate: onDragUpdate,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                        droppableId: affiliateProductGroupItem === null || affiliateProductGroupItem === void 0 ? void 0 : affiliateProductGroupItem.uid,
                        children: function(provided1, snapshot1) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", _objectSpread({}, provided1.droppableProps, {
                                ref: provided1.innerRef,
                                className: "relative",
                                children: [
                                    affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.map(function(ele, index) {
                                        var ref, ref3, ref4, ref5;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                            draggableId: (ele === null || ele === void 0 ? void 0 : (ref = ele.post_link) === null || ref === void 0 ? void 0 : ref.id) ? "product-".concat(ele === null || ele === void 0 ? void 0 : (ref3 = ele.post_link) === null || ref3 === void 0 ? void 0 : ref3.id) : "product-".concat(ele === null || ele === void 0 ? void 0 : ele.uid),
                                            index: index,
                                            children: function(provided, snapshot) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", _objectSpread({
                                                    ref: provided.innerRef
                                                }, provided.draggableProps, provided.dragHandleProps, {
                                                    className: classnames_default()("mt-2", !(ele === null || ele === void 0 ? void 0 : ele.title) && "adm-item-error", snapshot.isDragging && "adm-item-custom"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItems/* default */.Z, {
                                                        isFinalItem: index === (affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.length) - 1,
                                                        isOnlyItem: (affiliateProductArr === null || affiliateProductArr === void 0 ? void 0 : affiliateProductArr.length) === 1,
                                                        isOnlyProductGroup: isOnlyProductGroup,
                                                        index: index,
                                                        productData: ele,
                                                        onRemoveProductItem: onRemoveProductItem,
                                                        onDisableEnableProduct: onDisableEnableProduct,
                                                        callbackOpenEditProduct: handleOpenEditProduct,
                                                        onMoveProductItem: onMoveProductItem,
                                                        onMoveToTopProductItem: onMoveToTopProductItem,
                                                        onMoveToBottomProductItem: onMoveToBottomProductItem,
                                                        onCleanupLockProduct: onCleanupLockProduct
                                                    })
                                                }));
                                            }
                                        }, (ele === null || ele === void 0 ? void 0 : (ref4 = ele.post_link) === null || ref4 === void 0 ? void 0 : ref4.id) ? "product-".concat(ele === null || ele === void 0 ? void 0 : (ref5 = ele.post_link) === null || ref5 === void 0 ? void 0 : ref5.id) : "product-".concat(ele === null || ele === void 0 ? void 0 : ele.uid));
                                    }),
                                    provided1.placeholder,
                                    !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                        placeholderProps: placeholderProps1,
                                        content: t("ss_builder_placeholder_dragging_content"),
                                        style: {
                                            backgroundColor: "rgba(230, 247, 255, 0.75)",
                                            border: "1px dashed #1890FF",
                                            borderRadius: "4px",
                                            color: "#1890FF"
                                        }
                                    })
                                ]
                            }));
                        }
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col text-center items-center justify-center my-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PackageIcon */.jt, {
                            className: "w-8 h-8",
                            fillColor: "#333333"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#333333] text-lg leading-6",
                        children: t("ss_builder_affiliate_product_list_empty_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#8C8C8C] text-xs leading-4",
                        children: t("ss_builder_affiliate_product_list_empty_content")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductLists = (AffiliateProductLists);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductMovingPanel/index.tsx
var AffiliateProductMovingPanel = __webpack_require__(31153);
// EXTERNAL MODULE: ./src/features/share/icons/line-icon.tsx
var line_icon = __webpack_require__(45297);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductSelection/index.tsx












var ActionEnum;
(function(ActionEnum) {
    ActionEnum["VISIBLE_PRODUCT"] = "visible-product";
    ActionEnum["HIDE_PRODUCT"] = "hide-product";
    ActionEnum["MOVE_PRODUCT"] = "move-product";
    ActionEnum["CLEANUP_LOCK_PRODUCT"] = "cleanup-lock-product";
    ActionEnum["CLEANUP_UNLOCK_PRODUCT"] = "cleanup-unlock-product";
    ActionEnum["ENABLE_TRACKING_LINK"] = "enable-tracking-link";
})(ActionEnum || (ActionEnum = {}));
var AffiliateProductSelection = function(props) {
    var affiliateProductLists = props.affiliateProductLists, isSticky = props.isSticky, isOnlyProductGroup = props.isOnlyProductGroup, callBackCancelAffiliateProductSelection = props.callBackCancelAffiliateProductSelection, onDeleteProducts = props.onDeleteProducts, onEnableProducts = props.onEnableProducts, onEnableTrackingLinkProducts = props.onEnableTrackingLinkProducts, onHideProducts = props.onHideProducts, onMoveProducts = props.onMoveProducts, onCleanupLockProducts = props.onCleanupLockProducts, onCleanupUnlockProducts = props.onCleanupUnlockProducts, allowedMovingAffiliateProductGroup = props.allowedMovingAffiliateProductGroup, stickyTop = props.stickyTop;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var ref2 = (0,react.useState)([]), valueCheckedArr = ref2[0], setValueCheckedArr = ref2[1];
    var ref1 = (0,react.useState)(false), isOpenMoveAffiliateProductsPanel = ref1[0], setIsOpenMoveAffiliateProductsPanel = ref1[1];
    var actions = [
        {
            key: ActionEnum.VISIBLE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }),
            text: t("ss_builder_show_product_label")
        },
        {
            key: ActionEnum.HIDE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: t("ss_builder_hide_product_label")
        },
        {
            key: ActionEnum.MOVE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FolderArrowRightIcon */.Ao, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_move_product_label")
        },
        {
            key: ActionEnum.CLEANUP_LOCK_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BroomLockIcon */.mP, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_affiliate_product_cleanup_lock_label")
        },
        {
            key: ActionEnum.CLEANUP_UNLOCK_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BroomIcon */.Vj, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_affiliate_product_cleanup_unlock_label")
        },
        {
            key: ActionEnum.ENABLE_TRACKING_LINK,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* CheckCircleIconV2 */.lo, {
                className: "",
                fillColor: "white"
            }),
            text: t("ss_builder_enable_tracking_link_product_label")
        }, 
    ];
    var handleGetCheckedProductGroup = function(val) {
        setValueCheckedArr(val);
    };
    var handleSelectProductOption = (0,react.useCallback)(function(optionValue) {
        var affiliateProductListsClone = cloneDeep_default()(affiliateProductLists);
        if ((affiliateProductLists === null || affiliateProductLists === void 0 ? void 0 : affiliateProductLists.length) >= optionValue) {
            var ref;
            var newValueCheckedArr = (ref = affiliateProductListsClone.slice(-optionValue)) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                return x.uid;
            });
            setValueCheckedArr(newValueCheckedArr);
        } else {
            setValueCheckedArr(affiliateProductLists === null || affiliateProductLists === void 0 ? void 0 : affiliateProductLists.map(function(x) {
                return x.uid;
            }));
        }
    }, [
        affiliateProductLists
    ]);
    var handleGetValueCheckedCustom = function(checked) {
        if (checked) {
            setValueCheckedArr(affiliateProductLists === null || affiliateProductLists === void 0 ? void 0 : affiliateProductLists.map(function(x) {
                return x.uid;
            }));
        } else {
            setValueCheckedArr([]);
        }
    };
    var handleDeleteProducts = function() {
        var onConfirm = function() {
            onDeleteProducts(valueCheckedArr);
            SuccessToast(t("ss_builder_delete_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_delete_product_modal_title"),
            description: t("ss_builder_confirm_delete_product_selection_modal_content", {
                product_quantity: valueCheckedArr.length
            }),
            confirmText: t("ss_builder_confirm_delete_product_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleEnableProducts = function() {
        var onConfirm = function() {
            onEnableProducts(valueCheckedArr);
            SuccessToast(t("ss_builder_enable_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_show_product_label"),
            description: t("ss_builder_confirm_enable_product_selection_modal_content", {
                product_quantity: valueCheckedArr.length
            }),
            confirmText: t("ss_builder_confirm_show_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleHideProducts = function() {
        var onConfirm = function() {
            onHideProducts(valueCheckedArr);
            SuccessToast(t("ss_builder_disable_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_hide_product_label"),
            description: t("ss_builder_confirm_hide_product_selection_modal_content", {
                product_quantity: valueCheckedArr.length
            }),
            confirmText: t("ss_builder_confirm_hide_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleCleanupLockProducts = function() {
        var onConfirm = function() {
            onCleanupLockProducts(valueCheckedArr);
            SuccessToast(t("ss_builder_cleanup_lock_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_affiliate_product_cleanup_lock_label"),
            description: t("ss_builder_confirm_cleanup_lock_product_selection_modal_content", {
                product_quantity: valueCheckedArr.length
            }),
            confirmText: t("ss_builder_confirm_cleanup_lock_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleCleanupUnlockProducts = function() {
        var onConfirm = function() {
            onCleanupUnlockProducts(valueCheckedArr);
            SuccessToast(t("ss_builder_cleanup_unlock_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_affiliate_product_cleanup_unlock_label"),
            description: t("ss_builder_confirm_cleanup_unlock_product_selection_modal_content", {
                product_quantity: valueCheckedArr.length
            }),
            confirmText: t("ss_builder_confirm_cleanup_unlock_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case ActionEnum.VISIBLE_PRODUCT:
                handleEnableProducts();
                break;
            case ActionEnum.HIDE_PRODUCT:
                handleHideProducts();
                break;
            case ActionEnum.MOVE_PRODUCT:
                setIsOpenMoveAffiliateProductsPanel(true);
                break;
            case ActionEnum.CLEANUP_LOCK_PRODUCT:
                handleCleanupLockProducts();
                break;
            case ActionEnum.CLEANUP_UNLOCK_PRODUCT:
                handleCleanupUnlockProducts();
                break;
            case ActionEnum.ENABLE_TRACKING_LINK:
                onEnableTrackingLinkProducts(valueCheckedArr);
                SuccessToast(t("ss_builder_enable_tracking_link_product_successfully_label"));
                break;
            default:
        }
    };
    var handleConfirmAffiliateProductMovingPanel = function(productGroupId) {
        onMoveProducts(valueCheckedArr, productGroupId);
    };
    var actionsFilter = (0,react.useMemo)(function() {
        var actionsDefault = actions;
        if (isOnlyProductGroup) {
            actionsDefault = actionsDefault.filter(function(x) {
                return x.key !== ActionEnum.MOVE_PRODUCT;
            });
        }
        return actionsDefault;
    }, [
        isOnlyProductGroup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "affiliate-product-list-selection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "affiliate-product-list-header py-4 px-3 sticky z-10",
                style: {
                    backgroundColor: isSticky ? "white" : "",
                    boxShadow: isSticky ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "",
                    top: "".concat(stickyTop, "px")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-[15px] text-[#666666]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red-600",
                                            children: "*"
                                        }),
                                        t("ss_builder_affiliate_product_list_title")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                    size: "small",
                                    fill: "solid",
                                    color: "primary",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "8px"
                                    },
                                    onClick: callBackCancelAffiliateProductSelection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseCircleIcon */.uC, {
                                            className: "w-[15px] h-[15px]",
                                            fillColor: "white"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: t("ss_builder_close_panel")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-4 items-center ml-[10px] mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                onChange: handleGetValueCheckedCustom,
                                indeterminate: valueCheckedArr.length > 0 && valueCheckedArr.length < affiliateProductLists.length,
                                checked: valueCheckedArr.length === affiliateProductLists.length
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("ss_builder_select_label"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row gap-2 items-center",
                                        children: [
                                            10,
                                            20,
                                            50
                                        ].map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                shape: "rounded",
                                                fill: "solid",
                                                size: "small",
                                                onClick: function() {
                                                    return handleSelectProductOption(item);
                                                },
                                                children: t("ss_builder_filter_select_multi_items", {
                                                    num_items: item
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox.Group */.XZ.Group, {
                    onChange: handleGetCheckedProductGroup,
                    value: valueCheckedArr,
                    children: affiliateProductLists === null || affiliateProductLists === void 0 ? void 0 : affiliateProductLists.map(function(ele, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(es/* List */.aV, {
                            style: {
                                "--border-bottom": "unset",
                                "--border-top": "unset",
                                marginBottom: "10px"
                            },
                            className: classnames_default()(!(ele === null || ele === void 0 ? void 0 : ele.title) && "adm-item-error"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                                arrow: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                            value: ele.uid,
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("flex items-center gap-[6px] flex-row"),
                                                style: {
                                                    opacity: (ele === null || ele === void 0 ? void 0 : ele.enable) !== 1 ? "40%" : ""
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                        src: ele.image,
                                                        width: 40,
                                                        height: 40,
                                                        fit: "cover",
                                                        style: {
                                                            outline: "rgba(0, 0, 0, 0.16) solid 1px",
                                                            outlineOffset: "-1px",
                                                            borderRadius: "4px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                                        children: [
                                                            ele.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-[17px] leading-[22px] font-normal",
                                                                children: ele.title
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-sm text-[#FF3141]",
                                                                children: t("ss_builder_product_title_error")
                                                            }),
                                                            (ele === null || ele === void 0 ? void 0 : ele.use_aff_url) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex flex-row gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                                                            className: "w-4 h-4",
                                                                            fillColor: "#00B578"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                                                        children: t("ss_builder_product_link_wrapped_label")
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                                                children: ele === null || ele === void 0 ? void 0 : ele.origin_link
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        (ele === null || ele === void 0 ? void 0 : ele.is_cleanup_lock) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                            content: t("ss_builder_affiliate_product_clean_up_popover_content"),
                                            trigger: "click",
                                            placement: "bottom",
                                            mode: "dark",
                                            stopPropagation: [
                                                "click"
                                            ],
                                            getContainer: function() {
                                                return popoverRef.current;
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-[-5px] left-[25px] cursor-pointer",
                                                onClick: function(e) {
                                                    return e.stopPropagation();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative rounded-ful",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "p-3 rounded-full bg-black opacity-80"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "absolute z-[2] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BroomLockIcon */.mP, {
                                                                className: "w-[14px] h-[14px]",
                                                                fillColor: "#FFFFFF"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, index)
                        });
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-3 flex w-full justify-between items-center gap-2 z-[11] bg-[#FFFFFF]",
                ref: popoverRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-lg leading-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[#EE3244]",
                                children: [
                                    valueCheckedArr === null || valueCheckedArr === void 0 ? void 0 : valueCheckedArr.length,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_selected_product_in_selection_label")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "small",
                                style: {
                                    border: "unset",
                                    padding: "3px 8px"
                                },
                                disabled: (valueCheckedArr === null || valueCheckedArr === void 0 ? void 0 : valueCheckedArr.length) === 0,
                                onClick: handleDeleteProducts,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    fillColor: "#EE3244"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center gap-[15px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                                        mode: "dark",
                                        actions: actionsFilter,
                                        placement: "top",
                                        trigger: "click",
                                        stopPropagation: [
                                            "click"
                                        ],
                                        getContainer: function() {
                                            return popoverRef.current;
                                        },
                                        onAction: function(item) {
                                            return handleClickPopoverItem(item);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            size: "small",
                                            style: {
                                                border: "unset",
                                                padding: "3px 8px"
                                            },
                                            disabled: (valueCheckedArr === null || valueCheckedArr === void 0 ? void 0 : valueCheckedArr.length) === 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                                className: "cursor-pointer"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenMoveAffiliateProductsPanel,
                onMaskClick: function() {
                    return setIsOpenMoveAffiliateProductsPanel(false);
                },
                title: t("ss_builder_affiliate_product_moving_panel_title"),
                onClose: function() {
                    return setIsOpenMoveAffiliateProductsPanel(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductMovingPanel/* default */.Z, {
                    callbackCancelAffiliateProductMovingPanel: function() {
                        return setIsOpenMoveAffiliateProductsPanel(false);
                    },
                    callbackConfirmAffiliateProductMovingPanel: handleConfirmAffiliateProductMovingPanel,
                    allowedMovingAffiliateProductGroup: allowedMovingAffiliateProductGroup,
                    productMovingQuantity: valueCheckedArr === null || valueCheckedArr === void 0 ? void 0 : valueCheckedArr.length
                })
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductSelection = (AffiliateProductSelection);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListLayoutHandler/index.tsx
function ProductListLayoutHandler_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductListLayoutHandler_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductListLayoutHandler_arrayLikeToArray(arr);
}
function ProductListLayoutHandler_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductListLayoutHandler_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductListLayoutHandler_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductListLayoutHandler_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductListLayoutHandler_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductListLayoutHandler_toConsumableArray(arr) {
    return ProductListLayoutHandler_arrayWithoutHoles(arr) || ProductListLayoutHandler_iterableToArray(arr) || ProductListLayoutHandler_unsupportedIterableToArray(arr) || ProductListLayoutHandler_nonIterableSpread();
}
function ProductListLayoutHandler_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductListLayoutHandler_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductListLayoutHandler_arrayLikeToArray(o, minLen);
}















var ProductListLayoutHandler = function(props) {
    var ref8;
    var affiliateProductGroupData = props.affiliateProductGroupData, activeProductGroup = props.activeProductGroup, onUpdateProductGroupData = props.onUpdateProductGroupData, isSticky = props.isSticky, productGroupMaximum = props.productGroupMaximum, onCheckProductSelectionOpening = props.onCheckProductSelectionOpening, stickyTop = props.stickyTop;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var isOpenAffiliateSettingTour = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isOpenAffiliateSettingTour;
    var ref1 = (0,react.useState)(false), isOpenAffiliateProductSelection = ref1[0], setIsOpenAffiliateProductSelection = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenAddAffiliateProduct = ref2[0], setIsOpenAddAffiliateProduct = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenAffiliateProductEdit = ref3[0], setIsOpenAffiliateProductEdit = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenMoveAffiliateProductPanel = ref4[0], setIsOpenMoveAffiliateProductPanel = ref4[1];
    var ref5 = (0,react.useState)(null), productEditData = ref5[0], setProductEditData = ref5[1];
    var ref6 = (0,react.useState)(null), productSelectedId = ref6[0], setProductSelectedId = ref6[1];
    (0,react.useEffect)(function() {
        onCheckProductSelectionOpening && onCheckProductSelectionOpening(isOpenAffiliateProductSelection);
    }, [
        isOpenAffiliateProductSelection
    ]);
    var activedProductGroupData = (0,react.useMemo)(function() {
        return affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return x.uid === activeProductGroup;
        });
    }, [
        affiliateProductGroupData,
        activeProductGroup
    ]);
    var handleDeleteProducts = function(data) {
        var ref, ref7;
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        var activedAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.find(function(x) {
            return x.uid === activeProductGroup;
        });
        var newProductListsData = activedAffiliateProductGroupData === null || activedAffiliateProductGroupData === void 0 ? void 0 : (ref = activedAffiliateProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : (ref7 = ref.items) === null || ref7 === void 0 ? void 0 : ref7.filter(function(y) {
            return !data.includes(y.uid);
        });
        var newAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.map(function(ele) {
            return ele.uid === activeProductGroup ? ProductListLayoutHandler_objectSpread({}, activedAffiliateProductGroupData, {
                content_attributes: ProductListLayoutHandler_objectSpread({}, activedAffiliateProductGroupData.content_attributes, {
                    items: newProductListsData
                })
            }) : ele;
        });
        onUpdateProductGroupData(newAffiliateProductGroupData);
        setIsOpenAffiliateProductSelection(false);
    };
    var handleEnableProducts = function(data) {
        handleUpdateDataField(data, "enable", 1);
    };
    var handleHideProducts = function(data) {
        handleUpdateDataField(data, "enable", 2);
    };
    var handleCleanupUnlockProducts = function(data) {
        handleUpdateDataField(data, "is_cleanup_lock", 2);
    };
    var handleCleanupLockProducts = function(data) {
        handleUpdateDataField(data, "is_cleanup_lock", 1);
    };
    var handleEnableTrackingLinkProducts = function(data) {
        handleUpdateDataField(data, "use_aff_url", 1);
    };
    var handleMoveProducts = (0,react.useCallback)(function(data, productGroupId) {
        var ref11, ref9, ref10;
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        var productsAddNew = (ref11 = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.find(function(a) {
            return a.uid === activeProductGroup;
        })) === null || ref11 === void 0 ? void 0 : (ref9 = ref11.content_attributes) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : ref10.filter(function(x) {
            return data === null || data === void 0 ? void 0 : data.includes(x.uid);
        });
        //Add more products into the new product group
        var productGroupDataAfterAddingProductId = affiliateProductGroupDataClone.map(function(element) {
            if (element.uid === productGroupId) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                var newProductLists = ProductListLayoutHandler_toConsumableArray(productsAddNew).concat(ProductListLayoutHandler_toConsumableArray(productList));
                var newProductListSortOrder = newProductLists.map(function(ele, index) {
                    return ProductListLayoutHandler_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductListLayoutHandler_objectSpread({}, element, {
                    content_attributes: ProductListLayoutHandler_objectSpread({}, element.content_attributes, {
                        items: newProductListSortOrder
                    })
                });
            } else return element;
        });
        //Remove product from the old product group
        var productGroupDataAfterRemovingProductId = productGroupDataAfterAddingProductId.map(function(element) {
            if (element.uid === activeProductGroup) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                var productListRemovedProductId = productList.filter(function(x) {
                    return !(data === null || data === void 0 ? void 0 : data.includes(x.uid));
                });
                var productListRemovedProductIdSortOrder = productListRemovedProductId.map(function(ele, index) {
                    return ProductListLayoutHandler_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductListLayoutHandler_objectSpread({}, element, {
                    content_attributes: ProductListLayoutHandler_objectSpread({}, element.content_attributes, {
                        items: productListRemovedProductIdSortOrder
                    })
                });
            } else return element;
        });
        onUpdateProductGroupData(productGroupDataAfterRemovingProductId);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_move_product_successfully_label")
            })
        });
        setIsOpenAffiliateProductSelection(false);
    }, [
        affiliateProductGroupData,
        productSelectedId,
        activeProductGroup
    ]);
    var handleUpdateDataField = function(data, key, value) {
        var ref, ref12;
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        var activedAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.find(function(x) {
            return x.uid === activeProductGroup;
        });
        var newProductListsData = activedAffiliateProductGroupData === null || activedAffiliateProductGroupData === void 0 ? void 0 : (ref = activedAffiliateProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : (ref12 = ref.items) === null || ref12 === void 0 ? void 0 : ref12.map(function(ele) {
            return data.includes(ele.uid) ? ProductListLayoutHandler_objectSpread({}, ele, ProductListLayoutHandler_defineProperty({}, key, value)) : ele;
        });
        var newAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.map(function(ele) {
            return ele.uid === activeProductGroup ? ProductListLayoutHandler_objectSpread({}, activedAffiliateProductGroupData, {
                content_attributes: ProductListLayoutHandler_objectSpread({}, activedAffiliateProductGroupData.content_attributes, {
                    items: newProductListsData
                })
            }) : ele;
        });
        onUpdateProductGroupData(newAffiliateProductGroupData);
        setIsOpenAffiliateProductSelection(false);
    };
    var allowedMovingAffiliateProductGroup = (0,react.useMemo)(function() {
        return affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.filter(function(x) {
            return x.uid !== activeProductGroup;
        });
    }, [
        affiliateProductGroupData,
        activeProductGroup
    ]);
    var isFulledProductsAllGroups = (0,react.useMemo)(function() {
        var existedProductArr = [];
        affiliateProductGroupData.forEach(function(x) {
            var ref;
            var affiliateProductArr = (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
            existedProductArr = ProductListLayoutHandler_toConsumableArray(existedProductArr).concat(ProductListLayoutHandler_toConsumableArray(affiliateProductArr));
        });
        return !!((existedProductArr === null || existedProductArr === void 0 ? void 0 : existedProductArr.length) >= configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A);
    }, [
        affiliateProductGroupData
    ]);
    var handleOpenAddAffiliateProduct = function() {
        setIsOpenAddAffiliateProduct(true);
        setProductEditData(null);
    };
    var handleOpenEditProduct = function(productData) {
        setIsOpenAffiliateProductEdit(true);
        setProductEditData(productData);
    };
    var handleMoveAffiliateProductItem = function(productId) {
        setIsOpenMoveAffiliateProductPanel(true);
        setProductSelectedId(productId);
    };
    var handleCancelAffiliateProductMovingPanel = function() {
        setIsOpenMoveAffiliateProductPanel(false);
    };
    var handleConfirmAffiliateProductMovingPanel = (0,react.useCallback)(function(productGroupId) {
        var productDataAddNew = null;
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        affiliateProductGroupDataClone.forEach(function(element) {
            if (element.uid === activeProductGroup) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                productDataAddNew = productList.find(function(x) {
                    return x.uid === productSelectedId;
                });
            }
        });
        //Add more product into the new product group
        var productGroupDataAfterAddingProductId = affiliateProductGroupDataClone.map(function(element) {
            if (element.uid === productGroupId) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                productDataAddNew && productList.unshift(productDataAddNew);
                var newProductListSortOrder = productList.map(function(ele, index) {
                    return ProductListLayoutHandler_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductListLayoutHandler_objectSpread({}, element, {
                    content_attributes: ProductListLayoutHandler_objectSpread({}, element.content_attributes, {
                        items: newProductListSortOrder
                    })
                });
            } else return element;
        });
        //Remove product from the old product group
        var productGroupDataAfterRemovingProductId = productGroupDataAfterAddingProductId.map(function(element) {
            if (element.uid === activeProductGroup) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                var productListRemovedProductId = productList.filter(function(x) {
                    return x.uid !== productSelectedId;
                });
                var productListRemovedProductIdSortOrder = productListRemovedProductId.map(function(ele, index) {
                    return ProductListLayoutHandler_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductListLayoutHandler_objectSpread({}, element, {
                    content_attributes: ProductListLayoutHandler_objectSpread({}, element.content_attributes, {
                        items: productListRemovedProductIdSortOrder
                    })
                });
            } else return element;
        });
        onUpdateProductGroupData(productGroupDataAfterRemovingProductId);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_move_product_successfully_label")
            })
        });
    }, [
        affiliateProductGroupData,
        productSelectedId,
        activeProductGroup
    ]);
    var onUpdateAffiliateProductGroupData = function(data) {
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        var newAffiliateProductGroupData = affiliateProductGroupDataClone === null || affiliateProductGroupDataClone === void 0 ? void 0 : affiliateProductGroupDataClone.map(function(ele) {
            return ele.uid === data.uid ? data : ele;
        });
        onUpdateProductGroupData(newAffiliateProductGroupData);
    };
    var handleCancelAffiliateProductAddNew = function() {
        setIsOpenAddAffiliateProduct(false);
    };
    var handleSaveAffiliateProductAddNew = function(data) {
        onUpdateProductGroupData(data);
        setIsOpenAddAffiliateProduct(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpenAffiliateProductSelection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_AffiliateProductSelection, {
                affiliateProductLists: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref8 = activedProductGroupData.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.items,
                isSticky: isSticky,
                callBackCancelAffiliateProductSelection: function() {
                    return setIsOpenAffiliateProductSelection(false);
                },
                onDeleteProducts: handleDeleteProducts,
                onEnableProducts: handleEnableProducts,
                onHideProducts: handleHideProducts,
                onMoveProducts: handleMoveProducts,
                onCleanupLockProducts: handleCleanupLockProducts,
                onCleanupUnlockProducts: handleCleanupUnlockProducts,
                onEnableTrackingLinkProducts: handleEnableTrackingLinkProducts,
                allowedMovingAffiliateProductGroup: allowedMovingAffiliateProductGroup,
                isOnlyProductGroup: (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) === 1,
                stickyTop: stickyTop
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_AffiliateProductLists, {
                callbackOpenAddAffiliateProduct: function() {
                    return handleOpenAddAffiliateProduct();
                },
                callbackOpenEditProduct: handleOpenEditProduct,
                affiliateProductGroupItem: activedProductGroupData,
                callBackMoveProductItem: handleMoveAffiliateProductItem,
                callBackUpdateAffiliateProductGroupData: onUpdateAffiliateProductGroupData,
                callbackOpenAffiliateProductSelection: function() {
                    return setIsOpenAffiliateProductSelection(true);
                },
                isSticky: isSticky,
                isFulledProductsAllGroups: isFulledProductsAllGroups,
                isOnlyProductGroup: (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) === 1,
                isEnableSticky: !isOpenAffiliateSettingTour,
                stickyTop: stickyTop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenMoveAffiliateProductPanel,
                onMaskClick: function() {
                    return handleCancelAffiliateProductMovingPanel();
                },
                title: t("ss_builder_affiliate_product_moving_panel_title"),
                onClose: function() {
                    return handleCancelAffiliateProductMovingPanel();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductMovingPanel/* default */.Z, {
                    callbackCancelAffiliateProductMovingPanel: handleCancelAffiliateProductMovingPanel,
                    callbackConfirmAffiliateProductMovingPanel: handleConfirmAffiliateProductMovingPanel,
                    allowedMovingAffiliateProductGroup: affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.filter(function(x) {
                        return x.uid !== activeProductGroup;
                    }),
                    productMovingQuantity: 1
                })
            }),
            isOpenAffiliateProductEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAffiliateProductEdit,
                onMaskClick: function() {
                    return setIsOpenAffiliateProductEdit(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductEdit/* default */.Z, {
                    productData: productEditData,
                    activeProductGroup: activeProductGroup,
                    callBackCancelAffiliateProductEdit: function() {
                        return setIsOpenAffiliateProductEdit(false);
                    },
                    callBackSaveAffiliateProductEdit: function(val) {
                        return onUpdateProductGroupData(val);
                    },
                    affiliateProductGroupData: affiliateProductGroupData,
                    callbackAddNewAffiliateProductGroup: function(val) {
                        return onUpdateProductGroupData(val);
                    },
                    productGroupMaximum: productGroupMaximum
                })
            }),
            isOpenAddAffiliateProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddAffiliateProduct,
                onMaskClick: function() {
                    setIsOpenAddAffiliateProduct(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew/* default */.Z, {
                    callbackCancelAffiliateProductAddNew: handleCancelAffiliateProductAddNew,
                    callbackSaveAffiliateProductAddNew: handleSaveAffiliateProductAddNew,
                    affiliateProductGroupData: affiliateProductGroupData,
                    activeProductGroup: activeProductGroup,
                    callbackAddNewAffiliateProductGroup: function(val) {
                        return onUpdateProductGroupData(val);
                    },
                    productGroupMaximum: productGroupMaximum
                })
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_ProductListLayoutHandler = (ProductListLayoutHandler);


/***/ }),

/***/ 84829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ INDEX_NOT_FOUND; },
/* harmony export */   "EI": function() { return /* binding */ DEFAULT_OTHER_AFF_BLOCK; },
/* harmony export */   "SN": function() { return /* binding */ REG_ECOMERCE_ID; },
/* harmony export */   "T": function() { return /* binding */ DEFAULT_AFF_BLOCK; },
/* harmony export */   "Uk": function() { return /* binding */ SOURCE_URL_TYPE; },
/* harmony export */   "ZI": function() { return /* binding */ TYPE_JSON; },
/* harmony export */   "gP": function() { return /* binding */ IMG_PRODUCT_DEFAULT; }
/* harmony export */ });
/* unused harmony exports DEFAULT_OTHER_GROUP, MAX_PRODUCT_ITEMS, IMPORT_TYPE */
var TYPE_JSON = "application/json";
var IMG_PRODUCT_DEFAULT = "https://image.passio.eco/160x160/page-builder/page-builder/images-default/product-default.jpeg";
var DEFAULT_AFF_BLOCK = {
    uid: "",
    block_type: "affiliate_product",
    content_attributes: {
        items: [],
        title_product_group: ""
    },
    enable: 1,
    sort_order: 1,
    style_attributes: {},
    title: ""
};
var DEFAULT_OTHER_AFF_BLOCK = {
    uid: "",
    block_type: "affiliate_product",
    content_attributes: {
        items: [],
        title_product_group: "Other"
    },
    enable: 1,
    sort_order: 1,
    style_attributes: {},
    title: "Other"
};
var DEFAULT_OTHER_GROUP = "Other";
var INDEX_NOT_FOUND = -1;
var MAX_PRODUCT_ITEMS = 400;
var SOURCE_URL_TYPE = {
    SHOPEE: "shopee",
    LAZADA: "lazada",
    TIKI: "tiki",
    OTHER: "other"
};
var REG_ECOMERCE_ID = {
    shopee: /https?:\/\/(?:www\.)?shopee\.vn\/.*?(\.\d+\.\d+)/i,
    lazada: /https?:\/\/(?:www\.)?lazada\..*?(i\d+-s\d+)/i,
    tiki: /https?:\/\/(?:www\.)?tiki\..*?(p\d+)\./i
};
var IMPORT_TYPE = {
    BY_JSON: "by_json",
    BY_URL: "by_url"
};


/***/ }),

/***/ 93475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FY": function() { return /* binding */ findIndexDuplicateLinks; },
/* harmony export */   "Ir": function() { return /* binding */ convertProductType2; },
/* harmony export */   "K9": function() { return /* binding */ compareSameEcomerceUrl; },
/* harmony export */   "LH": function() { return /* binding */ getSourceUrl; },
/* harmony export */   "VL": function() { return /* binding */ convertProductType1; },
/* harmony export */   "zf": function() { return /* binding */ validateProductUrl; }
/* harmony export */ });
/* unused harmony exports removeProtocolAndQueryParamUrl, getEcomerceUrlId, getATProductsWithCategory, detectMultiProductLinks */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _share_helper_validator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52893);
/* harmony import */ var _ProductUploadFromSiteUrl_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87521);
/* harmony import */ var _ProductUploadFromSiteUrl_libs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21927);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84829);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55016);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






// export const convertProductType1 = (data) => {
//   let result;
//   if (data?.productAll && data?.categories) {
//     data?.productAll.forEach((prod) => {
//       data?.categories.forEach((cat) => {
//         if (
//           prod?.category_id === cat?.id ||
//           prod?.category_other_id === cat?.id
//         )
//           prod.category_name = cat?.name;
//       });
//       prod.url = prod?.product_url;
//       prod.product_name = prod?.product_title;
//       prod.product_image = prod?.image_url;
//     });
//     result = {
//       products: data?.productAll,
//     };
//   }
//   return result;
// };
var convertProductType1 = function() {
    var _ref1 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1(data) {
        var ref, ref1, atDomain, categories, influencer_id, landingpage_id, use_aff_url, url, products, productTotal, result;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    ;
                    atDomain = data === null || data === void 0 ? void 0 : data.atDomain;
                    categories = (data === null || data === void 0 ? void 0 : data.categories) || [];
                    influencer_id = data === null || data === void 0 ? void 0 : (ref = data.landingPageInfo) === null || ref === void 0 ? void 0 : ref.influencer_id;
                    landingpage_id = data === null || data === void 0 ? void 0 : (ref1 = data.landingPageInfo) === null || ref1 === void 0 ? void 0 : ref1.id;
                    use_aff_url = data === null || data === void 0 ? void 0 : data.use_aff_url;
                    url = "".concat(atDomain, "/api/v1/profile/list-product-paginate");
                    _ctx1.next = 9;
                    return Promise.all(categories.map(function() {
                        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cat) {
                            var category_id, category_other_id, performance_category_id, params, response, productsOfCat;
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        category_id = cat === null || cat === void 0 ? void 0 : cat.id;
                                        category_other_id = null;
                                        performance_category_id = cat === null || cat === void 0 ? void 0 : cat.performance_category_id;
                                        if (performance_category_id) {
                                            category_id = performance_category_id;
                                            category_other_id = cat === null || cat === void 0 ? void 0 : cat.id;
                                        }
                                        params = {
                                            influencer_id: influencer_id,
                                            landingpage_id: landingpage_id,
                                            category_id: category_id,
                                            page: 1,
                                            category_other_id: category_other_id
                                        };
                                        response = null;
                                        _ctx.prev = 6;
                                        _ctx.next = 9;
                                        return getATProductsWithCategory(url, params);
                                    case 9:
                                        response = _ctx.sent;
                                        _ctx.next = 15;
                                        break;
                                    case 12:
                                        _ctx.prev = 12;
                                        _ctx.t0 = _ctx["catch"](6);
                                        console.log("err", _ctx.t0);
                                    case 15:
                                        productsOfCat = response === null || response === void 0 ? void 0 : response.map(function(prod) {
                                            return _objectSpread({}, prod, {
                                                category_name: cat === null || cat === void 0 ? void 0 : cat.name,
                                                url: prod === null || prod === void 0 ? void 0 : prod.product_url,
                                                product_name: prod === null || prod === void 0 ? void 0 : prod.product_title,
                                                product_image: prod === null || prod === void 0 ? void 0 : prod.image_url,
                                                use_aff_url: use_aff_url
                                            });
                                        });
                                        return _ctx.abrupt("return", productsOfCat || []);
                                    case 17:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    6,
                                    12
                                ]
                            ]);
                        }));
                        return function(cat) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 9:
                    products = _ctx1.sent;
                    productTotal = products.reduce(function(total, currentArray) {
                        if (Array.isArray(total)) {
                            return total.concat(currentArray);
                        }
                    }, []);
                    result = {
                        products: productTotal
                    };
                    return _ctx1.abrupt("return", result);
                case 13:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function convertProductType1(data) {
        return _ref1.apply(this, arguments);
    };
}();
var convertProductType2 = function() {
    var _ref2 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dataProd) {
        var result, urlSuffix, use_aff_url, ref9, ref2, groupLists, products, productTotal, ref3, ref4, arrProd, ref5, ref6;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
            while(1)switch(_ctx2.prev = _ctx2.next){
                case 0:
                    result = null;
                    urlSuffix = dataProd === null || dataProd === void 0 ? void 0 : dataProd.urlSuffix;
                    use_aff_url = dataProd === null || dataProd === void 0 ? void 0 : dataProd.use_aff_url;
                    if (!urlSuffix) {
                        _ctx2.next = 14;
                        break;
                    }
                    ;
                    groupLists = (dataProd === null || dataProd === void 0 ? void 0 : (ref9 = dataProd.data) === null || ref9 === void 0 ? void 0 : (ref2 = ref9.landingPageBaseInfo) === null || ref2 === void 0 ? void 0 : ref2.groupList) || [];
                    if (!((groupLists === null || groupLists === void 0 ? void 0 : groupLists.length) > 0)) {
                        _ctx2.next = 12;
                        break;
                    }
                    _ctx2.next = 9;
                    return Promise.all(groupLists.map(function() {
                        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(group) {
                            var ref, ref7, ref8, response, params, linkList;
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        response = null;
                                        params = {
                                            urlSuffix: urlSuffix,
                                            groupId: group.groupId
                                        };
                                        _ctx.prev = 3;
                                        _ctx.next = 6;
                                        return (0,_ProductUploadFromSiteUrl_api__WEBPACK_IMPORTED_MODULE_2__/* .requestGetDataFromShopeeAff */ .z2)(params);
                                    case 6:
                                        response = _ctx.sent;
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](3);
                                        console.log("err", _ctx.t0);
                                    case 12:
                                        if (!(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref7 = ref.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.landingPageLinkList) === null || ref8 === void 0 ? void 0 : ref8.linkList)) {
                                            _ctx.next = 15;
                                            break;
                                        }
                                        linkList = response.data.data.landingPageLinkList.linkList;
                                        return _ctx.abrupt("return", linkList.map(function(prod) {
                                            return _objectSpread({}, prod, {
                                                id: prod === null || prod === void 0 ? void 0 : prod.linkId,
                                                url: prod === null || prod === void 0 ? void 0 : prod.link,
                                                product_name: prod === null || prod === void 0 ? void 0 : prod.linkName,
                                                product_image: prod === null || prod === void 0 ? void 0 : prod.image,
                                                category_name: group.groupName,
                                                use_aff_url: use_aff_url
                                            });
                                        }));
                                    case 15:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    3,
                                    9
                                ]
                            ]);
                        }));
                        return function(group) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 9:
                    products = _ctx2.sent;
                    productTotal = products.reduce(function(total, currentArray) {
                        if (Array.isArray(total)) {
                            return total.concat(currentArray);
                        }
                    }, []);
                    result = {
                        products: productTotal
                    };
                case 12:
                    _ctx2.next = 15;
                    break;
                case 14:
                    {
                        ;
                        arrProd = [];
                        if (dataProd === null || dataProd === void 0 ? void 0 : (ref3 = dataProd.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.landingPageLinkList) === null || ref4 === void 0 ? void 0 : ref4.linkList) {
                            ;
                            dataProd === null || dataProd === void 0 ? void 0 : (ref5 = dataProd.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.landingPageLinkList) === null || ref6 === void 0 ? void 0 : ref6.linkList.forEach(function(prod) {
                                arrProd.push(_objectSpread({}, prod, {
                                    id: prod === null || prod === void 0 ? void 0 : prod.linkId,
                                    url: prod === null || prod === void 0 ? void 0 : prod.link,
                                    product_name: prod === null || prod === void 0 ? void 0 : prod.linkName,
                                    product_image: prod === null || prod === void 0 ? void 0 : prod.image,
                                    use_aff_url: use_aff_url
                                }));
                            });
                            result = {
                                products: arrProd
                            };
                        }
                    }
                case 15:
                    return _ctx2.abrupt("return", result);
                case 16:
                case "end":
                    return _ctx2.stop();
            }
        }, _callee2);
    }));
    return function convertProductType2(dataProd) {
        return _ref2.apply(this, arguments);
    };
}();
var getSourceUrl = function(urlString) {
    var url = new URL(urlString);
    var domainURL = "";
    var sourceType = _constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_URL_TYPE.OTHER */ .Uk.OTHER;
    domainURL = url === null || url === void 0 ? void 0 : url.hostname;
    for(var key in _constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_URL_TYPE */ .Uk){
        if (domainURL.includes(_constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_URL_TYPE */ .Uk[key])) sourceType = _constant__WEBPACK_IMPORTED_MODULE_3__/* .SOURCE_URL_TYPE */ .Uk[key];
    }
    return {
        source_url: url,
        domain: domainURL,
        source_type: sourceType
    };
};
var removeProtocolAndQueryParamUrl = function(url) {
    var urlWithoutProtocol = url.replace(/https?:\/\/(?:www\.)?/i, "");
    var urlWithoutQueryParams = urlWithoutProtocol.replace(/\/?\?.*/i, "");
    return urlWithoutQueryParams;
};
var getEcomerceUrlId = function(url) {
    if (!url) return null;
    var result = "";
    var regx = null;
    if (_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.shopee.test */ .SN.shopee.test(url)) {
        regx = url.match(_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.shopee */ .SN.shopee);
        result = regx === null || regx === void 0 ? void 0 : regx[1];
    } else if (_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.lazada.test */ .SN.lazada.test(url)) {
        regx = url.match(_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.lazada */ .SN.lazada);
        result = regx === null || regx === void 0 ? void 0 : regx[1];
    } else if (_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.tiki.test */ .SN.tiki.test(url)) {
        regx = url.match(_constant__WEBPACK_IMPORTED_MODULE_3__/* .REG_ECOMERCE_ID.tiki */ .SN.tiki);
        result = regx === null || regx === void 0 ? void 0 : regx[1];
    }
    return result;
};
var compareSameEcomerceUrl = function(url1, url2) {
    if (!url1 || !url2) return false;
    var ecomerceId1 = getEcomerceUrlId(url1);
    var ecomerceId2 = getEcomerceUrlId(url2);
    var checkUrl1 = removeProtocolAndQueryParamUrl(url1);
    var checkUrl2 = removeProtocolAndQueryParamUrl(url2);
    if (ecomerceId1 && ecomerceId2) {
        return ecomerceId1 === ecomerceId2;
    }
    return checkUrl1 === checkUrl2;
};
function getATProductsWithCategory(url, params) {
    return _getATProductsWithCategory.apply(this, arguments);
}
function _getATProductsWithCategory() {
    _getATProductsWithCategory = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, params) {
        var productTotal, requestUrl, response, ref, ref10, products, newProductTotal, nextPageData, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    productTotal = _args.length > 2 && _args[2] !== void 0 ? _args[2] : [];
                    requestUrl = (0,_ProductUploadFromSiteUrl_libs__WEBPACK_IMPORTED_MODULE_5__/* .addParamsToUrl */ .Sr)(url, params);
                    _ctx.next = 4;
                    return (0,_ProductUploadFromSiteUrl_api__WEBPACK_IMPORTED_MODULE_2__/* .requestGetDataFromUrl */ .tb)(requestUrl);
                case 4:
                    response = _ctx.sent;
                    if (!response.success) {
                        _ctx.next = 17;
                        break;
                    }
                    ;
                    products = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref10 = ref.products) === null || ref10 === void 0 ? void 0 : ref10.data) || [];
                    if (!(Array.isArray(products) && products.length > 0)) {
                        _ctx.next = 16;
                        break;
                    }
                    newProductTotal = _toConsumableArray(productTotal).concat(_toConsumableArray(products));
                    _ctx.next = 12;
                    return getATProductsWithCategory(url, _objectSpread({}, params, {
                        page: (params === null || params === void 0 ? void 0 : params.page) + 1
                    }), newProductTotal);
                case 12:
                    nextPageData = _ctx.sent;
                    return _ctx.abrupt("return", nextPageData);
                case 16:
                    return _ctx.abrupt("return", productTotal);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getATProductsWithCategory.apply(this, arguments);
}
var validateProductUrl = function(prod, allProducts, detectUrlList) {
    var result = {
        valid: false,
        url: {}
    };
    if ((prod === null || prod === void 0 ? void 0 : prod.url) && (prod === null || prod === void 0 ? void 0 : prod.product_name) && (0,_share_helper_validator__WEBPACK_IMPORTED_MODULE_1__/* .isValidUrl */ .jv)(prod === null || prod === void 0 ? void 0 : prod.url)) {
        var ref11;
        var productId = (ref11 = String((prod === null || prod === void 0 ? void 0 : prod.id) || (prod === null || prod === void 0 ? void 0 : prod.uid))) === null || ref11 === void 0 ? void 0 : ref11.trim();
        var isExistedInAllProducts = allProducts === null || allProducts === void 0 ? void 0 : allProducts.some(function(x) {
            var ref;
            return ((ref = String((x === null || x === void 0 ? void 0 : x.id) || (x === null || x === void 0 ? void 0 : x.uid))) === null || ref === void 0 ? void 0 : ref.trim()) === productId || compareSameEcomerceUrl(x === null || x === void 0 ? void 0 : x.origin_link, prod === null || prod === void 0 ? void 0 : prod.url);
        });
        var isExistedInDetectedUrlList = !!(detectUrlList === null || detectUrlList === void 0 ? void 0 : detectUrlList.find(function(x) {
            return compareSameEcomerceUrl(x === null || x === void 0 ? void 0 : x.url, prod === null || prod === void 0 ? void 0 : prod.url);
        }));
        var checkExist = isExistedInAllProducts || isExistedInDetectedUrlList;
        result = {
            valid: !checkExist,
            url: {
                url: prod === null || prod === void 0 ? void 0 : prod.url,
                valid_type: checkExist ? _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_URL_CHECKING.DUPLICATE */ .oL.DUPLICATE : _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_URL_CHECKING.SUCCESS */ .oL.SUCCESS
            }
        };
    } else if ((prod === null || prod === void 0 ? void 0 : prod.url) && (prod === null || prod === void 0 ? void 0 : prod.product_name) && !(0,_share_helper_validator__WEBPACK_IMPORTED_MODULE_1__/* .isValidUrl */ .jv)(prod === null || prod === void 0 ? void 0 : prod.url)) {
        result.url = {
            url: prod === null || prod === void 0 ? void 0 : prod.url,
            valid_type: _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_URL_CHECKING.INVALID */ .oL.INVALID
        };
    } else if (!(prod === null || prod === void 0 ? void 0 : prod.url) || !(prod === null || prod === void 0 ? void 0 : prod.product_name)) {
        result.url = {
            url: prod === null || prod === void 0 ? void 0 : prod.url,
            valid_type: _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_URL_CHECKING.MISSING_REQUIRED */ .oL.MISSING_REQUIRED
        };
    } else {
        result.url = {
            url: prod === null || prod === void 0 ? void 0 : prod.url,
            valid_type: _share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_URL_CHECKING.NOT_ADDED_YET */ .oL.NOT_ADDED_YET
        };
    }
    return result;
};
var findIndexDuplicateLinks = function(arr) {
    var arrIndex = arr.map(function(item, index) {
        if (arr.indexOf(item) != index) return index;
    });
    return arrIndex === null || arrIndex === void 0 ? void 0 : arrIndex.filter(function(x) {
        return typeof x === "number";
    });
};
function detectMultiProductLinks(productLinks) {
    var duplicatedUrlIndexArr = findIndexDuplicateLinks(productLinks);
}


/***/ }),

/***/ 87521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* binding */ requestGetHTMLDataFromUrl; },
/* harmony export */   "tb": function() { return /* binding */ requestGetDataFromUrl; },
/* harmony export */   "z2": function() { return /* binding */ requestGetDataFromShopeeAff; }
/* harmony export */ });
/* unused harmony exports gatewayInstance, myPassioInstance */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var GATEWAY_PATH = {
    GET_DATA: "api/v1/pub/builder/general/get-data",
    GET_DATA_FROM_SHOPEE_AFF: "api/v1/pub/builder/general/get-data-from-shopee-aff"
};
var API_PATH = {
    GET_HTML_DATA: "api/crawl-site/get-data-url"
};
var gatewayInstance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: "https://gateway.passio.eco"
});
var myPassioInstance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: "https://my.passio.eco"
});
var requestGetDataFromUrl = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayInstance.get(GATEWAY_PATH.GET_DATA, {
                        params: {
                            url: url
                        }
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetDataFromUrl(url) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetDataFromShopeeAff = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayInstance.get(GATEWAY_PATH.GET_DATA_FROM_SHOPEE_AFF, {
                        params: params
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetDataFromShopeeAff(params) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetHTMLDataFromUrl = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return myPassioInstance.get(API_PATH.GET_HTML_DATA, {
                        params: {
                            url: url
                        }
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetHTMLDataFromUrl(url) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 77081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LO": function() { return /* binding */ FILE_NAME_REGEX; },
/* harmony export */   "Np": function() { return /* binding */ AT_CATEGORY_REGEX; },
/* harmony export */   "Qu": function() { return /* binding */ MSHAKE_URL_REGEX; },
/* harmony export */   "U1": function() { return /* binding */ AT_URL_REGEX; },
/* harmony export */   "Xx": function() { return /* binding */ DOMAIN_REGEX; },
/* harmony export */   "ul": function() { return /* binding */ LINKTREE_URL_REGEX; },
/* harmony export */   "vT": function() { return /* binding */ SHOPEE_AFF_URL_REGEX; }
/* harmony export */ });
var FILE_NAME_REGEX = /(\d+_[0-9a-z\-]+?_\d+\.json)\\?["']/gi;
var DOMAIN_REGEX = /^https?:\/\/([^:\/\n]+)/im;
var AT_URL_REGEX = /^https?:\/\/[a-zA-Z0-9\-]+\.koc\.asia\/?$/;
var SHOPEE_AFF_URL_REGEX = /^https:\/\/mycollection\.shop\/[a-zA-Z0-9\-._]+\/?$/;
var AT_CATEGORY_REGEX = /vi_json\s+\=\s+{(?:.|\n)*?}/gi;
var MSHAKE_URL_REGEX = /^https:\/\/msha\.ke\/[a-zA-Z0-9_\-]+(?:#[a-zA-Z0-9_\-]+)?$/;
var LINKTREE_URL_REGEX = /^https:\/\/linktr\.ee\/[a-zA-Z0-9_\-]+(?:\?[a-zA-Z0-9_=&%-]+)?$/;


/***/ }),

/***/ 21927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fy": function() { return /* binding */ validateATURL; },
/* harmony export */   "Sr": function() { return /* binding */ addParamsToUrl; },
/* harmony export */   "Xf": function() { return /* binding */ validateMshakeURL; },
/* harmony export */   "Yu": function() { return /* binding */ validateLinkTreeURL; },
/* harmony export */   "q7": function() { return /* binding */ validateShopeeAffURL; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77081);

function addParamsToUrl(requestUrl, params) {
    var url = new URL(requestUrl);
    var searchParams = new URLSearchParams();
    // Loop through the params object and append each key-value pair to the searchParams
    for(var key in params){
        if (params.hasOwnProperty(key)) {
            var value = params[key];
            searchParams.append(key, value);
        }
    }
    // Set the searchParams as the query string of the URL
    url.search = searchParams.toString();
    return url.toString();
}
var validateATURL = function(value) {
    return !_constants__WEBPACK_IMPORTED_MODULE_0__/* .AT_URL_REGEX.test */ .U1.test(value);
};
var validateShopeeAffURL = function(value) {
    return !_constants__WEBPACK_IMPORTED_MODULE_0__/* .SHOPEE_AFF_URL_REGEX.test */ .vT.test(value);
};
var validateMshakeURL = function(value) {
    return !_constants__WEBPACK_IMPORTED_MODULE_0__/* .MSHAKE_URL_REGEX.test */ .Qu.test(value);
};
var validateLinkTreeURL = function(value) {
    return !_constants__WEBPACK_IMPORTED_MODULE_0__/* .LINKTREE_URL_REGEX.test */ .ul.test(value);
};


/***/ }),

/***/ 69283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useAffiliateContext; },
/* harmony export */   "X": function() { return /* binding */ AffiliateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var AffiliateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var useAffiliateContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AffiliateContext);
};


/***/ }),

/***/ 92338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ BOOKING_PROFILE_FIELD; },
/* harmony export */   "W": function() { return /* binding */ BOOKING_PROFILE_STYLE; }
/* harmony export */ });
var BOOKING_PROFILE_FIELD = {
    IMAGE: "image",
    TITLE: "booking_profile_title",
    DESCRIPTION: "booking_profile_description",
    BUTTON_CONTENT: "booking_profile_button_content",
    STYLE: "booking_profile_style",
    OPEN_NEW_TAB: "open_new_tab",
    APPLY_BLOCK_SETTINGS: "apply_block_settings"
};
var BOOKING_PROFILE_STYLE = {
    CARD_CONTENT: "card_content",
    EMBED_CODE: "embed_code"
};


/***/ }),

/***/ 49961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _share_api_createAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88549);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var baseApiUrlGW = "https://gateway.passio.eco";
var API_URL = {
    list_product: "".concat(baseApiUrlGW, "/api/mini-store/v1/catalog/product/list/v2")
};
var CaxiosGW = (0,_share_api_createAxios__WEBPACK_IMPORTED_MODULE_1__/* .CreateGatewayAxios */ .Ev)();
var digitalProductApi = {
    listProduct: function listProduct(params) {
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return CaxiosGW.get(API_URL.list_product, {
                            params: params
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (digitalProductApi);


/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CAT_ID; }
/* harmony export */ });
var CAT_ID = {
    RANDOM_PRODUCT: 1,
    ONLINE_CONSULTION: 2,
    COURSE: 3,
    VIDEO: 4,
    EXCLUSIVE_EBOOK: 5,
    TICKET_ACCOUNT: 7,
    PHOTO: 8
};


/***/ }),

/***/ 53443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jf": function() { return /* binding */ IFRAME_ACTION; },
/* harmony export */   "pp": function() { return /* binding */ ACTION_KEY; },
/* harmony export */   "t2": function() { return /* binding */ URL_IFRAME; },
/* harmony export */   "tP": function() { return /* binding */ MOVE; }
/* harmony export */ });
var ACTION_KEY = {
    EDIT: "edit",
    DELETE_DISPLAY: "delete-display",
    UP_FIRST: "up-first",
    DOWN_LAST: "down-last",
    DELETE: "delete"
};
var IFRAME_ACTION = {
    CLOSE_IFRAME: "close-iframe",
    LIST_DATA: "list-data",
    GET_DATA: "get-data",
    RECIVED_DATA: "received-data",
    SAVE_INTRO: "save-intro",
    FETCH_DATA: "fetch-data"
};
var MOVE = {
    UP_FIRST: "up-first",
    DOWN_LAST: "down-last"
};
var URL_IFRAME = {
    SELECT_CATEGORY: "select-category",
    IFRAME: "iframe",
    EDIT: "edit",
    COURSE: "course",
    PHOTO: "photo",
    TICKET_ACCOUNT: "ticket-account"
};


/***/ }),

/***/ 60821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ digitalProductAction; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);

var initialState = {
    isDeleteItems: false,
    dataEdit: null,
    dataRemove: null
};
var digitalProductSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "digitalProduct",
    initialState: initialState,
    reducers: {
        setIsDeleteItems: function(state, action) {
            state.isDeleteItems = action.payload;
        },
        setDataEdit: function(state, action) {
            state.dataEdit = action.payload;
        },
        setDataRemove: function(state, action) {
            state.dataRemove = action.payload;
        }
    }
});
var digitalProductAction = digitalProductSlice.actions;
/* harmony default export */ __webpack_exports__["Z"] = (digitalProductSlice.reducer);


/***/ }),

/***/ 69851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ IMAGE_MAX; },
  "Z": function() { return /* binding */ block_editor_ImagePopup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 91 modules
var block_conf = __webpack_require__(60920);
// EXTERNAL MODULE: ./src/features/block/libs/index.ts
var libs = __webpack_require__(22814);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/components/StickyChecking/index.tsx
var StickyChecking = __webpack_require__(22143);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/hooks/index.ts
var hooks = __webpack_require__(16565);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/helpers.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var IMAGE_POPUP_ACTION;
(function(IMAGE_POPUP_ACTION) {
    IMAGE_POPUP_ACTION["SORT_LIST"] = "SORT_LIST";
    IMAGE_POPUP_ACTION["REMOVE_ITEM"] = "REMOVE_ITEM";
    IMAGE_POPUP_ACTION["SWITCH_STATUS"] = "SWITCH_STATUS";
    IMAGE_POPUP_ACTION["SAVE_ITEM"] = "SAVE_ITEM";
})(IMAGE_POPUP_ACTION || (IMAGE_POPUP_ACTION = {}));
var saveItem = function(state, action) {
    var newState = _toConsumableArray(state);
    var isNotExist = Object.is(newState.findIndex(function(e) {
        return Object.is(e.uid, action.payload.uid);
    }), -1);
    if (isNotExist) {
        newState.push(_objectSpread({}, action.payload, {
            sort_order: newState.length
        }));
    } else {
        newState = newState.map(function(e) {
            return Object.is(e.uid, action.payload.uid) ? _objectSpread({}, action.payload) : e;
        });
    }
    return newState;
};
var removeItem = function(state, action) {
    var newState = _toConsumableArray(state);
    newState = newState.filter(function(e) {
        return e.uid !== action.payload.uid;
    }).map(function(e, index) {
        return _objectSpread({}, e, {
            sort_order: index + 1
        });
    });
    return newState;
};
var sortItem = function(state, action) {
    var newState = _toConsumableArray(state);
    newState = action ? _toConsumableArray(action.payload) : null;
    return newState;
};
var switchStatusItem = function(state, action) {
    var newState = _toConsumableArray(state);
    newState = newState.map(function(e) {
        return !Object.is(e.uid, action.payload.uid) ? _objectSpread({}, e) : _objectSpread({}, e, {
            enable: Object.is(e.enable, configs_const/* ENABLE_BLOCK */.C5) ? configs_const/* DISABLE_BLOCK */.gK : configs_const/* ENABLE_BLOCK */.C5
        });
    });
    return newState;
};
var listImgPopupReducer = function(state, action1) {
    var _obj;
    var imagePopupAction = (_obj = {}, _defineProperty(_obj, IMAGE_POPUP_ACTION.SAVE_ITEM, saveItem), _defineProperty(_obj, IMAGE_POPUP_ACTION.REMOVE_ITEM, removeItem), _defineProperty(_obj, IMAGE_POPUP_ACTION.SORT_LIST, sortItem), _defineProperty(_obj, IMAGE_POPUP_ACTION.SWITCH_STATUS, switchStatusItem), _obj);
    var changeImagePopupList = function(action) {
        return imagePopupAction[action];
    };
    return changeImagePopupList(action1.type)(state, action1);
};

// EXTERNAL MODULE: ./src/features/block/components/FormInput/index.tsx
var FormInput = __webpack_require__(56751);
// EXTERNAL MODULE: ./src/features/block/components/LinkInput/index.tsx + 2 modules
var LinkInput = __webpack_require__(86293);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/ImagePopupForm/components/CheckBoxWithTooltip.tsx




var CheckBoxWithTooltip = function(props) {
    var value = props.value, tooltip = props.tooltip, onChange = props.onChange, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row text-center items-center leading-[22px] gap-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                checked: value,
                onChange: onChange,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-left",
                    children: title
                })
            }),
            tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                content: tooltip,
                placement: "top-start",
                mode: "dark",
                trigger: "click",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "ml-1 w-[14px] h-[14px]",
                    fillColor: "#1890FF"
                })
            })
        ]
    });
};
/* harmony default export */ var components_CheckBoxWithTooltip = (CheckBoxWithTooltip);

// EXTERNAL MODULE: ./src/features/share/components/UploadImage/index.tsx
var UploadImage = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/ImagePopupForm/components/ImageUpload.tsx
function ImageUpload_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ImageUpload_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ImageUpload_arrayLikeToArray(arr);
}
function ImageUpload_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ImageUpload_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImageUpload_toConsumableArray(arr) {
    return ImageUpload_arrayWithoutHoles(arr) || ImageUpload_iterableToArray(arr) || ImageUpload_unsupportedIterableToArray(arr) || ImageUpload_nonIterableSpread();
}
function ImageUpload_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ImageUpload_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageUpload_arrayLikeToArray(o, minLen);
}







var IMAGE_STATUS;
(function(IMAGE_STATUS) {
    IMAGE_STATUS["INVALID_SIZE"] = "INVALID_SIZE";
    IMAGE_STATUS["INVALID_FORMAT"] = "INVALID_FORMAT";
    IMAGE_STATUS["NONE"] = "NONE";
    IMAGE_STATUS["DONE"] = "DONE";
})(IMAGE_STATUS || (IMAGE_STATUS = {}));
var RESIZE = {
    MAX_WIDTH: 512,
    MAX_HEIGHT: 512
};
var ImageUpload = function(props) {
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var value = props.value, onChange = props.onChange;
    var errorMsg = {
        INVALID_SIZE: t("ss_builder_upload_file_size_invalid_content"),
        INVALID_FORMAT: t("ss_builder_upload_file_format_invalid_content")
    };
    var ref2 = (0,react.useState)(IMAGE_STATUS.NONE), imgStatus = ref2[0], setImgStatus = ref2[1];
    var ref3 = (0,react.useState)([]), listImg = ref3[0], setListImg = ref3[1];
    var handleChangeImgs = function(imgs) {
        var lastImg = imgs && imgs[imgs.length - 1];
        var isImgFormatInvalid = lastImg === null || lastImg === void 0 ? void 0 : lastImg.isValidFormat;
        var isImgSizeInvalid = lastImg === null || lastImg === void 0 ? void 0 : lastImg.isValidSize;
        if (isImgFormatInvalid) {
            setImgStatus(IMAGE_STATUS.INVALID_FORMAT);
        } else if (isImgSizeInvalid) {
            setImgStatus(IMAGE_STATUS.INVALID_SIZE);
        } else {
            setImgStatus(IMAGE_STATUS.DONE);
            setListImg(imgs);
            onChange({
                base64: lastImg.dataBase64,
                url: lastImg.url,
                file_name: lastImg.fileName
            });
        }
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-4 bg-white mt-[1px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[15px] text-[#666666]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-red-600",
                            children: "*"
                        }),
                        t("ss_builder_add_new_image_of_image_popup_title")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                    valueUrlImage: (ref4 = value === null || value === void 0 ? void 0 : value.url) !== null && ref4 !== void 0 ? ref4 : (ref1 = (ref = ImageUpload_toConsumableArray(listImg)) === null || ref === void 0 ? void 0 : ref.pop()) === null || ref1 === void 0 ? void 0 : ref1.url,
                    imageRatio: "16/9"
                }),
                errorMsg[imgStatus] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-1 items-center mt-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                            fillColor: "#FF3141",
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#FF3141]",
                            children: errorMsg[imgStatus]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-2 mt-4 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                        onChange: handleChangeImgs,
                        upload: function(file) {
                            return (0,lib/* mockUpload */.Hq)(file, RESIZE.MAX_WIDTH, RESIZE.MAX_HEIGHT);
                        },
                        className: "w-full",
                        value: listImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            block: true,
                            color: "primary",
                            fill: "solid",
                            size: "middle",
                            className: "w-full grow",
                            children: t("ss_builder_upload_button_label")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ImageUpload = (ImageUpload);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/ImagePopupForm/index.tsx
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};










var ImagePopupForm = function(props) {
    var ref17, ref1;
    var value1 = props.value, onCancel = props.onCancel, onSubmit = props.onSubmit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref2;
    var defaultUseAffiliateUrl = (ref2 = value1 === null || value1 === void 0 ? void 0 : value1.use_aff_url) !== null && ref2 !== void 0 ? ref2 : Object.is(_typeof(value1 === null || value1 === void 0 ? void 0 : value1.use_aff_url), "undefined") ? configs_const/* STATUS.ENABLE */.Q_.ENABLE : configs_const/* STATUS.DISABLE */.Q_.DISABLE;
    var defaultOpenNewTab = value1 === null || value1 === void 0 ? void 0 : value1.is_open_new_tab;
    var defaultOriginUrl = (value1 === null || value1 === void 0 ? void 0 : (ref17 = value1.link) === null || ref17 === void 0 ? void 0 : ref17.value) || "";
    var ref3;
    var defaultLink = (ref3 = value1 === null || value1 === void 0 ? void 0 : value1.link) !== null && ref3 !== void 0 ? ref3 : {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: (value1 === null || value1 === void 0 ? void 0 : (ref1 = value1.link) === null || ref1 === void 0 ? void 0 : ref1.value) || ""
    };
    var defaultImg = {
        url: value1 === null || value1 === void 0 ? void 0 : value1.image
    };
    var ref4 = (0,react.useState)(defaultUseAffiliateUrl), useAffiliateUrl = ref4[0], setUseAffiliateUrl = ref4[1];
    var ref5 = (0,react.useState)(defaultOpenNewTab), isOpenNewTab = ref5[0], setIsOpenNewTab = ref5[1];
    var ref6 = (0,react.useState)(defaultLink), link = ref6[0], setLink = ref6[1];
    var ref7 = (0,react.useState)(defaultImg), image = ref7[0], setImage = ref7[1];
    var ref8 = (0,react.useState)(false), isLoadingSubmitBtn = ref8[0], setIsLoadingSubmitBtn = ref8[1];
    var ref9 = (0,react.useState)(false), isError = ref9[0], setIsError = ref9[1];
    var ref10 = (0,react.useState)(defaultOriginUrl), originUrl = ref10[0], setOriginUrl = ref10[1];
    var ref11 = (0,react.useState)(false), isEcomerce = ref11[0], setIsEcomerce = ref11[1];
    var onUpdateLinkData = function(linkData) {
        setOriginUrl(linkData.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? linkData.value : null);
        setLink(linkData);
    };
    var handleChangeUseAffiliateUrl = function(value) {
        return setUseAffiliateUrl(value ? configs_const/* STATUS.ENABLE */.Q_.ENABLE : configs_const/* STATUS.DISABLE */.Q_.DISABLE);
    };
    var handleSubmitForm = function() {
        var ref, ref12, ref13, ref14, ref15, ref16;
        onSubmit({
            is_open_new_tab: isEcomerce ? undefined : !!isOpenNewTab,
            uid: (ref = value1 === null || value1 === void 0 ? void 0 : value1.uid) !== null && ref !== void 0 ? ref : "image-".concat((0,v4/* default */.Z)()),
            sort_order: (ref12 = value1 === null || value1 === void 0 ? void 0 : value1.sort_order) !== null && ref12 !== void 0 ? ref12 : 0,
            enable: (ref13 = value1 === null || value1 === void 0 ? void 0 : value1.enable) !== null && ref13 !== void 0 ? ref13 : configs_const/* ENABLE_BLOCK */.C5,
            image: (ref14 = image === null || image === void 0 ? void 0 : image.url) !== null && ref14 !== void 0 ? ref14 : value1 === null || value1 === void 0 ? void 0 : value1.image,
            image_base64: (ref15 = value1 === null || value1 === void 0 ? void 0 : value1.image_base64) !== null && ref15 !== void 0 ? ref15 : image === null || image === void 0 ? void 0 : image.base64,
            image_name: (ref16 = value1 === null || value1 === void 0 ? void 0 : value1.image_name) !== null && ref16 !== void 0 ? ref16 : image === null || image === void 0 ? void 0 : image.file_name,
            use_aff_url: useAffiliateUrl,
            origin_url: link.value,
            target_url: link.value,
            link: link
        });
    };
    (0,react.useEffect)(function() {
        var url = link && link.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? link.target_url : originUrl;
        if (url) {
            var ref;
            var ecom = link && link.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB && url && ((ref = new URL(url)) === null || ref === void 0 ? void 0 : ref.host);
            setIsEcomerce(configs_const/* LIST_ECOMMERCE.some */.hb.some(function(item) {
                return ecom && ecom.includes(item);
            }));
        }
    }, [
        originUrl,
        link
    ]);
    var isImagePopupChanged = (0,react.useMemo)(function() {
        var isLinkChanged = JSON.stringify({
            value: link.value,
            type: link.type
        }) !== JSON.stringify({
            value: defaultLink.value,
            type: defaultLink.type
        });
        var isImgChanged = JSON.stringify(image) !== JSON.stringify(defaultImg);
        var isOpenNewTabChanged = isOpenNewTab !== defaultOpenNewTab;
        var isUseAffUrlChanged = useAffiliateUrl !== defaultUseAffiliateUrl;
        return isLinkChanged || isImgChanged || isOpenNewTabChanged || isUseAffUrlChanged;
    }, [
        useAffiliateUrl,
        isOpenNewTab,
        image,
        link
    ]);
    var isDisableSubmitBtn = !!!(image === null || image === void 0 ? void 0 : image.url) || isLoadingSubmitBtn || !isImagePopupChanged || isError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 relative bg-white text-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    children: t("ss_builder_add_image_of_image_popup_tilte")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[12px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImageUpload, {
                    value: image,
                    onChange: setImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                        label: t("ss_builder_button_link_icon_origin_url_label"),
                        isRequire: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                            item: link,
                            onChange: onUpdateLinkData,
                            onLoading: setIsLoadingSubmitBtn,
                            onError: function(errorMessage) {
                                setIsError(!!errorMessage);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    Object.is(link.type, LinkInput/* LinkTypeEnum.WEB */.Z.WEB) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckBoxWithTooltip, {
                                value: Object.is(useAffiliateUrl, configs_const/* STATUS.ENABLE */.Q_.ENABLE),
                                onChange: handleChangeUseAffiliateUrl,
                                title: t("ss_builder_use_affiliate_link_label"),
                                tooltip: t("ss_builder_use_affiliate_link_description")
                            }),
                            !isEcomerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckBoxWithTooltip, {
                                        value: isOpenNewTab,
                                        onChange: setIsOpenNewTab,
                                        title: t("ss_builder_open_new_tab_label"),
                                        tooltip: t("ss_builder_open_new_tab_description")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed bottom-0 p-2 flex max-w-[486px] w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: onCancel,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: isDisableSubmitBtn,
                            color: "primary",
                            onClick: handleSubmitForm,
                            loading: isLoadingSubmitBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ImagePopup_ImagePopupForm = (ImagePopupForm);

// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js + 26 modules
var react_beautiful_dnd_esm = __webpack_require__(9276);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/block/components/LinkInput/components/ServiceSelectorPopup/index.tsx
var ServiceSelectorPopup = __webpack_require__(39523);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/ImagePoupList/components/ImagePopupItem.tsx










var ImgPopupItem = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var imgPopup = props.imgPopup, onChangeItem = props.onChangeItem, onOpenEditImgPopup = props.onOpenEditImgPopup;
    var isEnable = !!(imgPopup && imgPopup.enable === configs_const/* ENABLE_BLOCK */.C5);
    var popoverRef = (0,react.useRef)(null);
    var optionalActions = [
        {
            key: IMAGE_POPUP_ACTION.SWITCH_STATUS,
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_image_label") : t("ss_builder_hide_image_label")
        },
        {
            key: IMAGE_POPUP_ACTION.REMOVE_ITEM,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_image_label")
        }, 
    ];
    var MoreOptionalActions = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleOpenOptionalAction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: optionalActions,
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: handleOptionalActions,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleOptionalActions = function(item) {
        var key = item && item.key;
        switch(key){
            case IMAGE_POPUP_ACTION.SWITCH_STATUS:
                handleSwitchImgPopupStatus();
                break;
            case IMAGE_POPUP_ACTION.REMOVE_ITEM:
                confirmRemoveItem();
                break;
            default:
                break;
        }
    };
    var confirmRemoveItem = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIconAlert */.bR, {
                className: "",
                fillColor: "#FF3141",
                width: 40,
                height: 40
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_confirm_delete_image_popup_image_label"),
            cancelText: t("ss_builder_continue_edit_image_popup_image_label"),
            onConfirm: function() {
                onChangeItem(IMAGE_POPUP_ACTION.REMOVE_ITEM, imgPopup);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return void 0;
            }
        });
    };
    var handleEditImgPopup = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        onOpenEditImgPopup(imgPopup);
    };
    var handleSwitchImgPopupStatus = function() {
        onChangeItem(IMAGE_POPUP_ACTION.SWITCH_STATUS, imgPopup);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_image_successfully_label") : t("ss_builder_enable_image_successfully_label")
            })
        });
    };
    var handleOpenOptionalAction = function(event) {
        event.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreOptionalActions, {}),
                onClick: handleEditImgPopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: imgPopup.image,
                            width: 40,
                            height: 40,
                            fit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                    children: (imgPopup === null || imgPopup === void 0 ? void 0 : (ref = imgPopup.link) === null || ref === void 0 ? void 0 : ref.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? imgPopup === null || imgPopup === void 0 ? void 0 : (ref1 = imgPopup.link) === null || ref1 === void 0 ? void 0 : ref1.value : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(imgPopup === null || imgPopup === void 0 ? void 0 : (ref2 = imgPopup.link) === null || ref2 === void 0 ? void 0 : ref2.value))
                                }),
                                (imgPopup === null || imgPopup === void 0 ? void 0 : (ref3 = imgPopup.link) === null || ref3 === void 0 ? void 0 : ref3.type) === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: imgPopup.use_aff_url === configs_const/* STATUS.ENABLE */.Q_.ENABLE && (imgPopup === null || imgPopup === void 0 ? void 0 : (ref4 = imgPopup.link) === null || ref4 === void 0 ? void 0 : ref4.value) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                                    className: "w-4 h-4",
                                                    fillColor: "#00B578"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                                children: t("ss_builder_product_link_wrapped_label")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4 text-[#8C8C8C]",
                                        children: (imgPopup === null || imgPopup === void 0 ? void 0 : (ref5 = imgPopup.link) === null || ref5 === void 0 ? void 0 : ref5.value) || ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ImagePopupItem = (ImgPopupItem);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/features/share/components/PlaceholderCustomDragging/index.tsx
var PlaceholderCustomDragging = __webpack_require__(14120);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/ImagePoupList/index.tsx
function ImagePoupList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImagePoupList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImagePoupList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var ImagePopupList = function(props) {
    var onDragEnd = props.onDragEnd, listImgPopup = props.listImgPopup, onChangeItem = props.onChangeItem, onOpenEditImgPopup = props.onOpenEditImgPopup, onDragUpdate = props.onDragUpdate, placeholderProps = props.placeholderProps;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
            onDragEnd: onDragEnd,
            onDragUpdate: onDragUpdate,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                droppableId: "blocks-".concat(block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP),
                children: function(provided1, snapshot1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", ImagePoupList_objectSpread({}, provided1.droppableProps, {
                        ref: provided1.innerRef,
                        className: "relative",
                        children: [
                            listImgPopup && listImgPopup.length > 0 && listImgPopup.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                    draggableId: "blocks-".concat(ele.uid),
                                    index: index,
                                    children: function(provided, snapshot) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", ImagePoupList_objectSpread({
                                            ref: provided.innerRef
                                        }, provided.draggableProps, provided.dragHandleProps, {
                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePopupItem, {
                                                imgPopup: ele,
                                                onOpenEditImgPopup: onOpenEditImgPopup,
                                                onChangeItem: onChangeItem
                                            })
                                        }));
                                    }
                                }, "blocks-".concat(ele.uid));
                            }),
                            provided1.placeholder,
                            !isEmpty_default()(placeholderProps) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                placeholderProps: placeholderProps,
                                content: t("ss_builder_placeholder_dragging_content"),
                                style: {
                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                    border: "1px dashed #1890FF",
                                    borderRadius: "4px",
                                    color: "#1890FF"
                                }
                            })
                        ]
                    }));
                }
            })
        })
    });
};
/* harmony default export */ var ImagePoupList = (ImagePopupList);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImagePopup/index.tsx
function ImagePopup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ImagePopup_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ImagePopup_arrayLikeToArray(arr);
}
function ImagePopup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImagePopup_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImagePopup_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImagePopup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImagePopup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || ImagePopup_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ImagePopup_toConsumableArray(arr) {
    return ImagePopup_arrayWithoutHoles(arr) || ImagePopup_iterableToArray(arr) || ImagePopup_unsupportedIterableToArray(arr) || ImagePopup_nonIterableSpread();
}
function ImagePopup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ImagePopup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImagePopup_arrayLikeToArray(o, minLen);
}
















var IMAGE_MAX = 3;
var ImagePopup = function(props) {
    var ref5;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, handleCancelBlock = props.handleCancelBlock, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,hooks/* usePopup */.BF)(), visible = ref1.visible, closeImgPopupForm = ref1.closePopup, openImgPopupForm = ref1.openPopup;
    var ref2 = (0,react.useState)({}), placeholderProps1 = ref2[0], setPlaceholderProps = ref2[1];
    // const currentBlock = useAppSelector((state) => state.edittingBlock);
    var defaultImgPopupList = defaultBlockData.uid ? defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref5 = defaultBlockData.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.items : [];
    var ref3 = (0,react.useState)(), imgPopup = ref3[0], setImgPopup = ref3[1];
    var ref4 = (0,react.useReducer)(listImgPopupReducer, defaultImgPopupList), imgPopupList = ref4[0], dispatchImgPopupList = ref4[1];
    var reoderImgPopupList = function(startIndex, endIndex) {
        var result = ImagePopup_toConsumableArray(imgPopupList);
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedList = result.map(function(ele, id) {
            return ImagePopup_objectSpread({}, ele, {
                sort_order: id + 1
            });
        });
        return orderedList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var listOrdered = reoderImgPopupList(startIndex, endIndex);
        dispatchImgPopupList({
            type: IMAGE_POPUP_ACTION.SORT_LIST,
            payload: listOrdered
        });
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var handleChangeImgPopup = function(action, item) {
        dispatchImgPopupList({
            type: action,
            payload: item
        });
        (0,libs/* scrollToNewItem */.i)("blocks-".concat(item === null || item === void 0 ? void 0 : item.uid));
        if (Object.is(action, IMAGE_POPUP_ACTION.SAVE_ITEM)) resetImgPopupForm();
    };
    var openEditImgPopup = function(item) {
        setImgPopup(item);
        openImgPopupForm();
    };
    var resetImgPopupForm = function() {
        setImgPopup(undefined);
        closeImgPopupForm();
    };
    (0,react.useEffect)(function() {
        var isImgPopupListChanged = JSON.stringify(imgPopupList) !== JSON.stringify(defaultImgPopupList);
        var isOldBlock = !!block.uid;
        var isImgPopupListInValid = imgPopupList.findIndex(function(e) {
            return Object.is(e.enable, configs_const/* ENABLE_BLOCK */.C5);
        }) === -1;
        var blockEditting = {
            uid: "image-popup-".concat((0,v4/* default */.Z)()),
            sort_order: 1,
            enable: configs_const/* ENABLE_BLOCK */.C5,
            block_type: block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP,
            title: t("ss_builder_title_block_image_popup"),
            content_attributes: {
                items: imgPopupList
            }
        };
        if (isOldBlock) {
            blockEditting = ImagePopup_objectSpread({}, block, {
                content_attributes: {
                    items: imgPopupList
                }
            });
        }
        setEditStatus(isImgPopupListChanged);
        setButtonStatus(isImgPopupListInValid || !isImgPopupListChanged);
        onUpdateData(blockEditting);
    }, [
        imgPopupList
    ]);
    var EmptyData = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col text-center items-center justify-center my-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "inline-block mb-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIconEmpty */.yI, {
                        className: "align-middle w-8 h-8"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#333333] text-lg leading-6",
                    children: t("ss_builder_image_list_empty_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#8C8C8C] text-xs leading-4",
                    children: t("ss_builder_image_list_empty_content")
                })
            ]
        });
    };
    var imageEnable = (0,react.useMemo)(function() {
        return imgPopupList === null || imgPopupList === void 0 ? void 0 : imgPopupList.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        imgPopupList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-image-popup-editor-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between px-3 pt-4 pb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-[15px] text-[#666666]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                }),
                                                t("ss_builder_list_label")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-grow justify-end gap-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                            size: "small",
                                            fill: "solid",
                                            color: "primary",
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "3px 12px 3px 12px"
                                            },
                                            onClick: openImgPopupForm,
                                            disabled: imgPopupList.length === IMAGE_MAX,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                    className: "w-[15px] h-[15px]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("ss_builder_add_new_label")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        " ",
                                                        "".concat(imgPopupList.length, "/").concat(IMAGE_MAX),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            imageEnable.length === 0 && imgPopupList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                                style: {
                                    color: "var(--adm-color-danger)"
                                },
                                children: t("ss_builder_need_to_display_at_least_one_image")
                            })
                        ]
                    }),
                    !!imgPopupList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePoupList, {
                        onDragEnd: onDragEnd,
                        listImgPopup: imgPopupList,
                        onChangeItem: handleChangeImgPopup,
                        onOpenEditImgPopup: openEditImgPopup,
                        onDragUpdate: onDragUpdate,
                        placeholderProps: placeholderProps1
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyData, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: visible,
                onMaskClick: closeImgPopupForm,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePopup_ImagePopupForm, {
                    value: imgPopup,
                    onCancel: resetImgPopupForm,
                    onSubmit: function(value) {
                        handleChangeImgPopup(IMAGE_POPUP_ACTION.SAVE_ITEM, value);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_ImagePopup = (ImagePopup);


/***/ }),

/***/ 89216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DIVIDER_LAYOUT_TYPE_ENUM; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var _share_components_DisplayColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26340);
/* harmony import */ var _share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21043);
/* harmony import */ var _features_setting_components_ThemeSetting_ColorPicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76034);







var DIVIDER_LAYOUT_TYPE_ENUM;
(function(DIVIDER_LAYOUT_TYPE_ENUM) {
    DIVIDER_LAYOUT_TYPE_ENUM["SOLID"] = "solid";
    DIVIDER_LAYOUT_TYPE_ENUM["DASHED"] = "dashed";
    DIVIDER_LAYOUT_TYPE_ENUM["DOT_STROKES"] = "dot_strokes";
})(DIVIDER_LAYOUT_TYPE_ENUM || (DIVIDER_LAYOUT_TYPE_ENUM = {}));
var DefaultsLayoutSetting = function(props) {
    var divider_type = props.divider_type, divider_thickness = props.divider_thickness, divider_color = props.divider_color, onUpdateSettingData = props.onUpdateSettingData;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpenColorPicker = ref[0], setIsOpenColorPicker = ref[1];
    var layoutTypeOptions = [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/divider-solid-type.svg"
            }),
            value: DIVIDER_LAYOUT_TYPE_ENUM.SOLID,
            description: t("ss_builder_solid_type_label")
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/divider-dashed-type.svg"
            }),
            value: DIVIDER_LAYOUT_TYPE_ENUM.DASHED,
            description: t("ss_builder_dashed_type_label")
        },
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/divider-dot-strokes-type.svg"
            }),
            value: DIVIDER_LAYOUT_TYPE_ENUM.DOT_STROKES,
            description: t("ss_builder_dot_strokes_type_label")
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_type_label")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Selector */ .Qf, {
                        columns: 3,
                        options: layoutTypeOptions,
                        onChange: function(val) {
                            if (val.length > 0) onUpdateSettingData("divider_type", val[0]);
                        },
                        value: [
                            divider_type
                        ],
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .iz, {
                style: {
                    margin: "12px 0px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_divider_thickness_label")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Slider */ .iR, {
                        onChange: function(val) {
                            return onUpdateSettingData("divider_thickness", parseInt(val.toString()));
                        },
                        ticks: true,
                        marks: {
                            1: 1,
                            2: 2,
                            3: 3,
                            4: 4,
                            5: 5,
                            6: 6,
                            7: 7,
                            8: 8,
                            9: 9,
                            10: 10
                        },
                        min: 1,
                        step: 1,
                        max: 10,
                        value: divider_thickness
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .iz, {
                style: {
                    margin: "12px 0px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_divider_color_label")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_DisplayColor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        backgroundColor: divider_color,
                        onClickOpenColorPicker: setIsOpenColorPicker
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                visible: isOpenColorPicker,
                onMaskClick: function() {
                    return setIsOpenColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenColorPicker(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_ThemeSetting_ColorPicker__WEBPACK_IMPORTED_MODULE_5__/* .ColorPickerV2 */ ._, {
                    defaultColor: divider_color,
                    onCancel: function() {
                        return setIsOpenColorPicker(false);
                    },
                    onColorSelected: function(data) {
                        return onUpdateSettingData("divider_color", data);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultsLayoutSetting);


/***/ }),

/***/ 15231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ LAYOUT_TYPE_ENUM; },
  "Z": function() { return /* binding */ SpacerAndDivider_DividerSetting; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/DefaultsLayoutSetting/index.tsx
var DefaultsLayoutSetting = __webpack_require__(89216);
// EXTERNAL MODULE: ./src/features/share/components/ImageUploadCommon/index.tsx + 4 modules
var ImageUploadCommon = __webpack_require__(71856);
// EXTERNAL MODULE: ./src/features/share/components/ImageUploadCommon/constants.ts
var constants = __webpack_require__(60880);
;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/ImageLayoutSetting/index.tsx





var ImageLayoutSetting = function(props) {
    var onUpdateSettingData = props.onUpdateSettingData, divider_image = props.divider_image;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadCommon/* default */.Z, {
        value: divider_image,
        onChange: function(img) {
            return onUpdateSettingData("divider_image", img);
        },
        layout_type: constants/* IMAGE_UPLOAD_LAYOUTS.LAYOUT_1 */.Dc.LAYOUT_1,
        label: t("ss_builder_divider_image_label"),
        isRequired: true
    });
};
/* harmony default export */ var DividerSetting_ImageLayoutSetting = (ImageLayoutSetting);

;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var LAYOUT_TYPE_ENUM;
(function(LAYOUT_TYPE_ENUM) {
    LAYOUT_TYPE_ENUM["DEFAULTS"] = "defaults";
    LAYOUT_TYPE_ENUM["IMAGE"] = "image";
})(LAYOUT_TYPE_ENUM || (LAYOUT_TYPE_ENUM = {}));
var DividerSetting = function(props) {
    var onUpdateSettingData = props.onUpdateSettingData, onCheckDividerEnable = props.onCheckDividerEnable, layout_type = props.layout_type, enableDivider = props.enableDivider;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(enableDivider), isShowDividerSetting = ref[0], setIsShowDividerSetting = ref[1];
    var ref1 = (0,react.useState)(layout_type), layoutType = ref1[0], setLayoutType = ref1[1];
    (0,react.useEffect)(function() {
        setIsShowDividerSetting(enableDivider);
    }, [
        enableDivider
    ]);
    (0,react.useEffect)(function() {
        setLayoutType(layout_type);
    }, [
        layout_type
    ]);
    (0,react.useEffect)(function() {
        onCheckDividerEnable(isShowDividerSetting);
    }, [
        isShowDividerSetting
    ]);
    (0,react.useEffect)(function() {
        onUpdateSettingData("layout_type", layoutType);
    }, [
        layoutType
    ]);
    var layoutOptions = [
        {
            label: t("ss_builder_defaults_label"),
            value: LAYOUT_TYPE_ENUM.DEFAULTS
        },
        {
            label: t("ss_builder_theme_setting_background_image_selector_label"),
            value: LAYOUT_TYPE_ENUM.IMAGE
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-3 bg-white px-4 py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_divider_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                        defaultChecked: isShowDividerSetting,
                        uncheckedText: t("ss_builder_off"),
                        checkedText: t("ss_builder_on"),
                        onChange: function(value) {
                            return setIsShowDividerSetting(value);
                        }
                    })
                ]
            }),
            isShowDividerSetting && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "12px 0px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base mb-4",
                                children: t("ss_builder_style")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                columns: 2,
                                options: layoutOptions,
                                onChange: function(val) {
                                    if (val.length > 0) setLayoutType(val[0]);
                                },
                                value: [
                                    layoutType
                                ],
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "12px 0px"
                        }
                    }),
                    layoutType === LAYOUT_TYPE_ENUM.DEFAULTS && /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultsLayoutSetting/* default */.Z, _objectSpread({}, props)),
                    layoutType === LAYOUT_TYPE_ENUM.IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerSetting_ImageLayoutSetting, _objectSpread({}, props))
                ]
            })
        ]
    });
};
/* harmony default export */ var SpacerAndDivider_DividerSetting = (DividerSetting);


/***/ }),

/***/ 66639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var DividerImage = function(param) {
    var divider_image = param.divider_image;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
        src: divider_image,
        className: "divider-image"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DividerImage);


/***/ }),

/***/ 26124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _DividerSetting_DefaultsLayoutSetting__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89216);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var DividerLine = function(props) {
    var divider_thickness = props.divider_thickness, divider_color = props.divider_color, divider_type = props.divider_type;
    var styleRender = function() {
        var style = {};
        switch(divider_type){
            case _DividerSetting_DefaultsLayoutSetting__WEBPACK_IMPORTED_MODULE_2__/* .DIVIDER_LAYOUT_TYPE_ENUM.SOLID */ .J.SOLID:
                style = {
                    borderStyle: "solid"
                };
                break;
            case _DividerSetting_DefaultsLayoutSetting__WEBPACK_IMPORTED_MODULE_2__/* .DIVIDER_LAYOUT_TYPE_ENUM.DASHED */ .J.DASHED:
                style = {
                    borderStyle: "dashed"
                };
                break;
            case _DividerSetting_DefaultsLayoutSetting__WEBPACK_IMPORTED_MODULE_2__/* .DIVIDER_LAYOUT_TYPE_ENUM.DOT_STROKES */ .J.DOT_STROKES:
                style = {
                    borderStyle: "dotted"
                };
                break;
        }
        return style;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
        style: _objectSpread({
            borderColor: divider_color,
            height: divider_thickness,
            borderWidth: "0 0 ".concat(divider_thickness, "px")
        }, styleRender())
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DividerLine);


/***/ }),

/***/ 60920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l5": function() { return /* binding */ BLOCK_DATA_SAVE_MIDDLEWARE; },
  "s_": function() { return /* binding */ BLOCK_EDIT_COMPONENT_CONFIG; },
  "bF": function() { return /* binding */ BLOCK_TYPE; },
  "wu": function() { return /* binding */ BLOCK_TYPE_LANGUAGE_KEY; },
  "lO": function() { return /* binding */ requestPostLinkMiddlewareV2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/mini-store/mini-store.config.tsx + 20 modules
var mini_store_config = __webpack_require__(98267);
// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var api = __webpack_require__(85861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/setting/components/Icons/index.tsx
var Icons = __webpack_require__(76143);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupAddNew/index.tsx
var AffiliateProductGroupAddNew = __webpack_require__(39603);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js + 26 modules
var react_beautiful_dnd_esm = __webpack_require__(9276);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupTour/group-tour-config.ts
var AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME = {
    STEP_1: "affiliate-product-group-add-new-button",
    STEP_2: "affiliate-product-group-item-popover"
};
var STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1
};
var steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-group-tour-step-1.gif",
        title_key: "ss_builder_affiliate_group_tour_title_step_1",
        intro_key: "ss_builder_affiliate_group_tour_content_step_1",
        element_class: AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-group-tour-step-2.gif",
        title_key: "ss_builder_affiliate_group_tour_title_step_2",
        intro_key: "ss_builder_affiliate_group_tour_content_step_2",
        element_class: AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "show-label-text product-tour-custom",
        position: "bottom"
    }, 
];

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupItems/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var AffiliateProductGroupItems = function(props) {
    var ref3;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var index = props.index, productData = props.productData, onRemoveItem = props.onRemoveItem, onDisableEnableProduct = props.onDisableEnableProduct, onEditAffiliateProductGroup = props.onEditAffiliateProductGroup, affiliateProductGroupList = props.affiliateProductGroupList, onActiveProductGroup = props.onActiveProductGroup;
    var isOpenAffiliateGroupTour = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.dynamicConfig) === null || ref === void 0 ? void 0 : ref.isOpenAffiliateGroupTour;
    });
    var isEnable = !!(productData && productData.enable === 1);
    var popoverContainerRef = (0,react.useRef)(null);
    var popoverRef = (0,react.useRef)(null);
    var defaultGroupName = productData === null || productData === void 0 ? void 0 : productData.title;
    var ref1;
    var affProductLists = (ref1 = productData === null || productData === void 0 ? void 0 : (ref3 = productData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.items) !== null && ref1 !== void 0 ? ref1 : [];
    var affiliateProductGroupListEnable = (0,react.useMemo)(function() {
        return affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        affiliateProductGroupList
    ]);
    var ref2 = (0,react.useState)(false), forceVisiblePopoverProductGroup = ref2[0], setForceVisiblePopoverProductGroup = ref2[1];
    (0,react.useEffect)(function() {
        var castWindow = window;
        var isOpen = false;
        if ((affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) > 1) {
            isOpen = !!(index === 1);
        } else {
            isOpen = !!(index === 0);
        }
        if (isOpen) {
            castWindow.triggerVisibleAffiliatePopoverProductGroup = setForceVisiblePopoverProductGroup;
            (function() {
                if (castWindow.triggerVisibleAffiliatePopoverProductGroup) {
                    castWindow.triggerVisibleAffiliatePopoverProductGroup = undefined;
                    setForceVisiblePopoverProductGroup(false);
                }
            });
        }
    }, [
        affiliateProductGroupList
    ]);
    var actions = [
        {
            key: "edit-product-group",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditTabIcon */.jJ, {
                className: ""
            }),
            text: t("ss_builder_edit_product_group_label")
        },
        {
            key: "eye-visible-product-group",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_product_group_label") : t("ss_builder_hide_product_group_label")
        }, 
    ];
    (affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) >= 2 && actions.push({
        key: "delete-product-group",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
            className: ""
        }),
        text: t("ss_builder_delete_product_group_label")
    });
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "edit-product-group":
                handleEditProductGroup();
                break;
            case "eye-visible-product-group":
                handleEnableDisableProductGroup();
                break;
            case "delete-product-group":
                confirmRemoveProductGroup();
                break;
            default:
        }
    };
    var handleEditProductGroup = function() {
        onEditAffiliateProductGroup(productData);
    };
    var confirmRemoveProductGroup = function() {
        if (affiliateProductGroupListEnable.length <= 1 && isEnable) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px]",
                            children: t("ss_builder_delete_product_group_error_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_delete_product_group_error_content", {
                                group_name: defaultGroupName
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_delete_product_group_error_btn_confirm_label")
                    }, 
                ]
            });
        } else {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "var(--adm-color-primary)",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm_delete_product_group_modal_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_confirm_delete_product_group_modal_description", {
                        group_name: defaultGroupName
                    })
                }),
                confirmText: t("ss_builder_confirm_delete_product_label"),
                cancelText: t("ss_builder_cancel_delete_product_label"),
                onConfirm: function() {
                    onRemoveItem(index);
                    es/* Toast.show */.FN.show({
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                            className: "text-center inline-block",
                            fillColor: "#00B578"
                        }),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: t("ss_builder_delete_product_group_successfully_label")
                        })
                    });
                },
                onCancel: function() {
                    return;
                }
            });
        }
    };
    var handleEnableDisableProductGroup = function() {
        var productStatus = !isEnable ? 1 : 2;
        onDisableEnableProduct(index, productStatus);
    };
    var handleClickMoreIcon = function(event) {
        event.stopPropagation();
    };
    var visibleStep2Checking = (0,react.useMemo)(function() {
        var value = {};
        if (isOpenAffiliateGroupTour) {
            value = forceVisiblePopoverProductGroup && ((affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) <= 1 && index === 0 || (affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) > 1 && index === 1) ? {
                visible: true
            } : {
                visible: false
            };
        }
        return value;
    }, [
        isOpenAffiliateGroupTour,
        forceVisiblePopoverProductGroup,
        affiliateProductGroupList,
        index, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverContainerRef,
        onClick: function() {
            return onActiveProductGroup(productData === null || productData === void 0 ? void 0 : productData.uid);
        },
        className: "cursor-pointer",
        id: index === 0 && AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME.STEP_2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row items-center gap-[15px] cursor-pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        onClick: handleClickMoreIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, _objectSpread({
                            className: ((affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) <= 1 && index === 0 || (affiliateProductGroupList === null || affiliateProductGroupList === void 0 ? void 0 : affiliateProductGroupList.length) > 1 && index === 1) && AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME.STEP_2,
                            mode: "dark",
                            actions: actions,
                            placement: "left",
                            trigger: "click",
                            stopPropagation: [
                                "click"
                            ],
                            getContainer: function() {
                                return popoverContainerRef.current;
                            },
                            onAction: function(item) {
                                return handleClickPopoverItem(item);
                            },
                            ref: popoverRef
                        }, visibleStep2Checking, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                className: "mr-3"
                            })
                        }))
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                children: productData.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()("text-ellipsis whitespace-nowrap overflow-hidden text-xs leading-4", affProductLists.length >= configs_const/* PRODUCT_MAX */.Kh ? "text-[#FF3141]" : "text-[#8C8C8C]"),
                                children: t("ss_builder_affiliate_product_group_quantity_label", {
                                    product_quantity: "".concat(affProductLists.length, "/").concat(configs_const/* PRODUCT_MAX */.Kh)
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var AffiliateProductGroupManagement_AffiliateProductGroupItems = (AffiliateProductGroupItems);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupListItems/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AffiliateProductGroupListItems_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AffiliateProductGroupListItems_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AffiliateProductGroupListItems_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var AffiliateProductGroupListItems = function(props) {
    var affiliateProductGroupList = props.affiliateProductGroupList, onUpdateAffiliateProductGroupList = props.onUpdateAffiliateProductGroupList, onEditAffiliateProductGroup = props.onEditAffiliateProductGroup, onActiveProductGroup = props.onActiveProductGroup;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(affiliateProductGroupList);
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedProductList = result.map(function(ele, idx) {
            return AffiliateProductGroupListItems_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedProductList;
    };
    var onDragEnd = function(result) {
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        onUpdateAffiliateProductGroupList(itemsOrder);
    };
    var onRemoveItem = function(index) {
        var affiliateProductClone = cloneDeep_default()(affiliateProductGroupList);
        var newProductItems = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.filter(function(ele, idx) {
            return idx !== index;
        });
        onUpdateAffiliateProductGroupList(newProductItems);
    };
    var onDisableEnableProduct = function(index, productStatus) {
        var ref;
        var affiliateProductClone = cloneDeep_default()(affiliateProductGroupList);
        var affiliateProductGroupListEnable = affiliateProductClone === null || affiliateProductClone === void 0 ? void 0 : affiliateProductClone.filter(function(x) {
            return x.enable === 1;
        });
        var newProductItems = affiliateProductClone && Array.isArray(affiliateProductClone) && affiliateProductClone.map(function(ele, idx) {
            return idx === index ? AffiliateProductGroupListItems_objectSpread({}, ele, {
                enable: productStatus
            }) : ele;
        });
        if (((ref = affiliateProductClone[index]) === null || ref === void 0 ? void 0 : ref.enable) !== 1) {
            onUpdateAffiliateProductGroupList(newProductItems);
            es/* Toast.show */.FN.show({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                    className: "text-center inline-block w-[30px] h-[30px]",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_enable_product_group_successfully_label")
                })
            });
        } else {
            if (affiliateProductGroupListEnable.length >= 2) {
                var ref1;
                es/* Modal.confirm */.u_.confirm({
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                        className: "w-11 h-11",
                        fillColor: "var(--adm-color-primary)",
                        onClick: function() {}
                    }),
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t("ss_builder_confirm_hide_product_group_modal_title")
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                        children: t("ss_builder_confirm_hide_product_group_modal_description", {
                            group_name: (ref1 = affiliateProductClone[index]) === null || ref1 === void 0 ? void 0 : ref1.title
                        })
                    }),
                    confirmText: t("ss_builder_confirm_hide_product_label"),
                    cancelText: t("ss_builder_cancel_hide_product_label"),
                    onConfirm: function() {
                        onUpdateAffiliateProductGroupList(newProductItems);
                        es/* Toast.show */.FN.show({
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                className: "text-center inline-block w-[30px] h-[30px]",
                                fillColor: "#00B578"
                            }),
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: t("ss_builder_disable_product_group_successfully_label")
                            })
                        });
                    },
                    onCancel: function() {
                        return;
                    }
                });
            } else {
                var ref2;
                es/* Modal.show */.u_.show({
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                        className: "w-11 h-11",
                        fillColor: "#FF8F1F",
                        onClick: function() {}
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg font-bold leading-[25px]",
                                children: t("ss_builder_hide_product_group_error_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: t("ss_builder_hide_product_group_error_content", {
                                    group_name: (ref2 = affiliateProductClone[index]) === null || ref2 === void 0 ? void 0 : ref2.title
                                })
                            })
                        ]
                    }),
                    className: "modal-error-class",
                    closeOnAction: true,
                    actions: [
                        {
                            key: "confirm",
                            text: t("ss_builder_hide_product_group_error_btn_confirm_label")
                        }, 
                    ]
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
            onDragEnd: onDragEnd,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                droppableId: "blocks-".concat(BLOCK_TYPE.AFF_PRODUCT_GROUP),
                children: function(provided1, snapshot1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", AffiliateProductGroupListItems_objectSpread({}, provided1.droppableProps, {
                        ref: provided1.innerRef,
                        children: [
                            affiliateProductGroupList && affiliateProductGroupList.length > 0 && affiliateProductGroupList.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                    draggableId: "blocks-".concat(ele.uid),
                                    index: index,
                                    children: function(provided, snapshot) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", AffiliateProductGroupListItems_objectSpread({
                                            ref: provided.innerRef
                                        }, provided.draggableProps, provided.dragHandleProps, {
                                            className: classnames_default()(index !== 0 && "mt-2", snapshot.isDragging && "adm-item-custom "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupManagement_AffiliateProductGroupItems, {
                                                affiliateProductGroupList: affiliateProductGroupList,
                                                index: index,
                                                productData: ele,
                                                onRemoveItem: onRemoveItem,
                                                onDisableEnableProduct: onDisableEnableProduct,
                                                onEditAffiliateProductGroup: onEditAffiliateProductGroup,
                                                onActiveProductGroup: onActiveProductGroup
                                            })
                                        }));
                                    }
                                }, "blocks-".concat(ele.uid));
                            }),
                            provided1.placeholder
                        ]
                    }));
                }
            })
        })
    });
};
/* harmony default export */ var AffiliateProductGroupManagement_AffiliateProductGroupListItems = (AffiliateProductGroupListItems);

// EXTERNAL MODULE: ./src/features/share/components/PopupComponent/index.tsx
var PopupComponent = __webpack_require__(21043);
// EXTERNAL MODULE: ./src/features/share/icons/product-tour-icon.tsx
var product_tour_icon = __webpack_require__(16525);
// EXTERNAL MODULE: ./src/features/share/components/ProductTourComponent/index.tsx
var ProductTourComponent = __webpack_require__(17347);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupTour/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var AffiliateProductGroupTour = function(props) {
    var handleHideProductGroupTour = props.handleHideProductGroupTour;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var productGroupTourRef = (0,react.useRef)(null);
    var setRef = function(ref) {
        productGroupTourRef.current = ref;
        var fullscreenContentElement = document.getElementsByClassName("full-screen-popup-content");
        if (productGroupTourRef.current) {
            productGroupTourRef.current.introJs._targetElement = fullscreenContentElement[(fullscreenContentElement === null || fullscreenContentElement === void 0 ? void 0 : fullscreenContentElement.length) - 1];
        }
    };
    var stepsDefault = steps.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: ele.position
        };
    });
    var onExit = function() {
        handleHideProductGroupTour();
    };
    var onBeforeExit = function(stepIndex) {
        var castWindow = window;
        if (stepIndex === STEP_INDEX.STEP_1) {
            castWindow.triggerVisibleAffiliatePopoverProductGroup(false);
        }
    };
    var onChangeProductTour = function(nextStepIndex, nextElement) {
        var fullScreenPopupContent = document.querySelectorAll(".full-screen-popup-content");
        var popupConentScrollHeight = fullScreenPopupContent[(fullScreenPopupContent === null || fullScreenPopupContent === void 0 ? void 0 : fullScreenPopupContent.length) - 1].scrollTop;
        var tooltipElement = document.querySelectorAll(".introjs-fixedTooltip");
        if (tooltipElement) {
            if (nextStepIndex !== STEP_INDEX.STEP_1) {
                for(var i = 0; i < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i++){
                    tooltipElement[i].style.cssText = "top:".concat(nextElement.getBoundingClientRect().top + popupConentScrollHeight - 5, "px !important");
                    tooltipElement[i].style.position = "absolute";
                    tooltipElement[i].style.background = "#FFFFFF";
                }
            } else {
                for(var i1 = 0; i1 < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i1++){
                    tooltipElement[i1].style.cssText = "";
                    tooltipElement[i1].style.position = "";
                    tooltipElement[i1].style.background = "";
                }
            }
        }
        var castWindow = window;
        if (nextStepIndex === STEP_INDEX.STEP_1) {
            castWindow.triggerVisibleAffiliatePopoverProductGroup(false);
        }
    };
    var onCompleteProductTour = function() {
        var castWindow = window;
        castWindow.triggerVisibleAffiliatePopoverProductGroup(false);
        handleHideProductGroupTour();
    };
    var onBeforeChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            var castWindow, scrollElement;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        castWindow = window;
                        if (!(nextStepIndex === STEP_INDEX.STEP_2)) {
                            _ctx.next = 7;
                            break;
                        }
                        castWindow.triggerVisibleAffiliatePopoverProductGroup(true);
                        scrollElement = document.getElementById("product-group-scroll-element");
                        scrollElement.scrollIntoView(true);
                        _ctx.next = 7;
                        return new Promise(function(resolve, reject) {
                            var ref;
                            (ref = productGroupTourRef.current) === null || ref === void 0 ? void 0 : ref.updateStepElement(1);
                            setTimeout(function() {
                                return resolve({});
                            }, 10);
                        });
                    case 7:
                        if (nextStepIndex === STEP_INDEX.STEP_1) {
                            castWindow.triggerVisibleAffiliatePopoverProductGroup(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onBeforeChange(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsDefault,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var AffiliateProductGroupManagement_AffiliateProductGroupTour = (AffiliateProductGroupTour);

// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/index.tsx
function AffiliateProductGroupManagement_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AffiliateProductGroupManagement_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AffiliateProductGroupManagement_arrayLikeToArray(arr);
}
function AffiliateProductGroupManagement_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AffiliateProductGroupManagement_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AffiliateProductGroupManagement_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AffiliateProductGroupManagement_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AffiliateProductGroupManagement_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AffiliateProductGroupManagement_slicedToArray(arr, i) {
    return AffiliateProductGroupManagement_arrayWithHoles(arr) || AffiliateProductGroupManagement_iterableToArrayLimit(arr, i) || AffiliateProductGroupManagement_unsupportedIterableToArray(arr, i) || AffiliateProductGroupManagement_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || AffiliateProductGroupManagement_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function AffiliateProductGroupManagement_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AffiliateProductGroupManagement_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AffiliateProductGroupManagement_arrayLikeToArray(o, minLen);
}














var AffiliateProductGroupManagement = function(props) {
    var onCancelAffiliateProductGroupManagement = props.onCancelAffiliateProductGroupManagement, onUpdateAffiliateProductGroup = props.onUpdateAffiliateProductGroup, affiliateProductGroupData = props.affiliateProductGroupData, productGroupMaximum = props.productGroupMaximum, onActiveProductGroup = props.onActiveProductGroup;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ref5 = (0,react.useState)(false), isOpenAddNewProductGroup = ref5[0], setIsOpenAddNewProductGroup = ref5[1];
    var ref1 = (0,react.useState)(affiliateProductGroupData), affiliateProductGroupList = ref1[0], setAffiliateProductGroupList = ref1[1];
    var ref2 = (0,react.useState)(null), affiliateProductGroupDefault = ref2[0], setAffiliateProductGroupDefault = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenGroupManagementTour = ref3[0], setIsOpenGroupManagementTour = ref3[1];
    var ref4 = (0,react.useState)(false), isSticky = ref4[0], setIsSticky = ref4[1];
    var stickyRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref = stickyRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = AffiliateProductGroupManagement_slicedToArray(param, 1), e = _param[0];
            // console.log(e);
            setIsSticky(e.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        observer.observe(ref);
        return function() {
            return observer.unobserve(ref);
        };
    }, [
        stickyRef
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isOpenAffiliateGroupTour: isOpenGroupManagementTour
            }
        }));
        var timer = setTimeout(function() {
            var settingTourOverlay = document.getElementsByClassName("introjs-overlay")[0];
            if (isOpenGroupManagementTour) {
                settingTourOverlay.style.display = "none";
            } else {
                settingTourOverlay === null || settingTourOverlay === void 0 ? void 0 : settingTourOverlay.remove();
            }
        }, 100);
        (function() {
            return clearTimeout(timer);
        });
    }, [
        isOpenGroupManagementTour
    ]);
    var handleOpenAddNewProductGroup = function() {
        if ((affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) >= productGroupMaximum) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_group_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_group_total_limitation_warning_content", {
                                group_quantity_maximum: productGroupMaximum
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else {
            setAffiliateProductGroupDefault(null);
            setIsOpenAddNewProductGroup(true);
        }
    };
    var handleSaveAffiliateProductGroupAddNew = function(data) {
        var affiliateProductGroupListClone = cloneDeep_default()(affiliateProductGroupList);
        var checkExistProductIdx = affiliateProductGroupListClone && affiliateProductGroupListClone.findIndex(function(x) {
            return x.uid === data.uid;
        });
        if (checkExistProductIdx >= 0) {
            affiliateProductGroupListClone[checkExistProductIdx] = data;
        } else {
            affiliateProductGroupListClone = _toConsumableArray(affiliateProductGroupList).concat([
                data
            ]);
        }
        var newAffiliateProductGroupDataSortOrder = affiliateProductGroupListClone.map(function(ele, idx) {
            return AffiliateProductGroupManagement_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        setAffiliateProductGroupList(newAffiliateProductGroupDataSortOrder);
    };
    (0,react.useEffect)(function() {
        onUpdateAffiliateProductGroup(affiliateProductGroupList);
    }, [
        affiliateProductGroupList
    ]);
    var handleUpdateAffiliateProductGroupList = function(data) {
        setAffiliateProductGroupList(data);
    };
    var handleEditAffiliateProductGroup = function(data) {
        setIsOpenAddNewProductGroup(true);
        setAffiliateProductGroupDefault(data);
    };
    var productGroupRate = (0,react.useMemo)(function() {
        return "".concat(affiliateProductGroupList.length, "/").concat(productGroupMaximum);
    }, [
        affiliateProductGroupList,
        productGroupMaximum
    ]);
    var popupAddNewTitle = affiliateProductGroupDefault ? t("ss_builder_edit_name_affiliate_product_group_title") : t("ss_builder_add_new_affiliate_product_group_btn_label");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-5 relative",
        style: {
            pointerEvents: isOpenGroupManagementTour ? "none" : "unset"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-lg text-[#333333] font-normal flex text-center items-center gap-1 p-3 bg-white sticky top-0 z-10",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onCancelAffiliateProductGroupManagement();
                        },
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BackArrow */.D1, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "flex-1 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "flex items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                                    className: "w-[22px] h-[22px]"
                                }),
                                t("ss_builder_affiliate_product_group_management_title")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return setIsOpenGroupManagementTour(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "product-group-scroll-element"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[52px] absolute w-full z-[9] top-0 left-0",
                ref: stickyRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "affiliate-product-list-header flex flex-row justify-between py-4 px-3 sticky top-[52px] z-[9]",
                style: {
                    backgroundColor: isSticky ? "white" : "",
                    boxShadow: isSticky ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : ""
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-[15px] text-[#666666]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-red-600",
                                    children: "*"
                                }),
                                t("ss_builder_affiliate_product_list_title")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: AFFILIATE_GROUP_MANAGEMENT_TOUR_CLASS_NAME.STEP_1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                            size: "small",
                            fill: "solid",
                            color: "primary",
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px",
                                padding: "3px 12px 3px 12px",
                                opacity: affiliateProductGroupList.length >= productGroupMaximum ? "40%" : ""
                            },
                            onClick: handleOpenAddNewProductGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                    className: "w-[15px] h-[15px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("ss_builder_add_new_label")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: productGroupRate
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupManagement_AffiliateProductGroupListItems, {
                affiliateProductGroupList: affiliateProductGroupList,
                onUpdateAffiliateProductGroupList: handleUpdateAffiliateProductGroupList,
                onEditAffiliateProductGroup: handleEditAffiliateProductGroup,
                onActiveProductGroup: onActiveProductGroup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenAddNewProductGroup,
                // onMaskClick={() => setIsOpenAddNewProductGroup(false)}
                title: popupAddNewTitle,
                onClose: function() {
                    return setIsOpenAddNewProductGroup(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupAddNew/* default */.Z, {
                    onCancelAffiliateProductGroupAddNew: function() {
                        return setIsOpenAddNewProductGroup(false);
                    },
                    affiliateProductGroupDefault: affiliateProductGroupDefault,
                    onSaveAffiliateProductGroupAddNew: handleSaveAffiliateProductGroupAddNew,
                    affiliateProductGroupList: affiliateProductGroupList
                })
            }),
            isOpenGroupManagementTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupManagement_AffiliateProductGroupTour, {
                handleHideProductGroupTour: function() {
                    return setIsOpenGroupManagementTour(false);
                }
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductGroupManagement = (AffiliateProductGroupManagement);

// EXTERNAL MODULE: ./src/features/share/components/AutoScrollSelector/index.tsx
var AutoScrollSelector = __webpack_require__(80878);
// EXTERNAL MODULE: ./src/features/design/components/ListItemScrollHorizontal/index.tsx
var ListItemScrollHorizontal = __webpack_require__(82071);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductGroupTabItemDetail/index.tsx



var ProductGroupTabItemDetail = function(props) {
    var ref = (0,react.useRef)(null);
    var item = props.item, onSelect = props.onSelect, selected = props.selected, isDisabledSelection = props.isDisabledSelection, onClickAction = props.onClickAction;
    (0,react.useEffect)(function() {
        if (selected) {
            onSelect(ref.current);
        }
    }, [
        selected
    ]);
    var isHideProductGroup = (0,react.useMemo)(function() {
        return !!(!selected && isDisabledSelection || (item === null || item === void 0 ? void 0 : item.enable) !== 1);
    }, [
        selected,
        isDisabledSelection,
        item
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: ref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                block: true,
                size: "middle",
                style: {
                    whiteSpace: "nowrap",
                    border: "none",
                    color: selected ? "#EE3244" : "",
                    borderBottom: selected ? "2px solid #EE3244" : "2px solid #ffffff",
                    borderRadius: "0px",
                    opacity: isHideProductGroup ? "40%" : ""
                },
                onClick: function(e) {
                    if (!isDisabledSelection) {
                        e.stopPropagation();
                        onSelect(ref.current);
                        onClickAction();
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    children: item.title
                })
            })
        })
    });
};
/* harmony default export */ var AffiliateProductGroup_ProductGroupTabItemDetail = (ProductGroupTabItemDetail);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductTourOpening/ProductSettingTour/setting-tour-config.ts
var setting_tour_config = __webpack_require__(7246);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListLayoutHandler/index.tsx + 2 modules
var ProductListLayoutHandler = __webpack_require__(96223);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFile/constant.ts
var constant = __webpack_require__(84829);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./src/features/share/helper/validator.ts
var validator = __webpack_require__(52893);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFile/style.module.scss
var style_module = __webpack_require__(35819);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/utils/sleep.js
var sleep = __webpack_require__(24547);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFile/helper.ts
var helper = __webpack_require__(93475);
// EXTERNAL MODULE: ./src/features/share/components/InputCustom/style.module.scss
var InputCustom_style_module = __webpack_require__(76557);
var InputCustom_style_module_default = /*#__PURE__*/__webpack_require__.n(InputCustom_style_module);
;// CONCATENATED MODULE: ./src/features/share/components/InputCustom/index.tsx
function InputCustom_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var InputCustom = function(param) {
    var label = param.label, placeholder = param.placeholder, maxLength = param.maxLength, _required = param.required, required = _required === void 0 ? false : _required, _isMultiline = param.isMultiline, isMultiline = _isMultiline === void 0 ? false : _isMultiline, _hasBottomDivider = param.hasBottomDivider, hasBottomDivider = _hasBottomDivider === void 0 ? false : _hasBottomDivider, _classNameText = param.classNameText, classNameText = _classNameText === void 0 ? "" : _classNameText, error = param.error, styleLabel = param.styleLabel, onChange = param.onChange, _type = param.type, type = _type === void 0 ? "text" : _type, value1 = param.value, numberLine = param.numberLine, _showCountCharacter = param.showCountCharacter, showCountCharacter = _showCountCharacter === void 0 ? false : _showCountCharacter, _hasNoBorder = param.hasNoBorder, hasNoBorder = _hasNoBorder === void 0 ? false : _hasNoBorder, onKeyDown = param.onKeyDown, extra = param.extra, textTooltip = param.textTooltip, _inputMode = param.inputMode, inputMode = _inputMode === void 0 ? "text" : _inputMode;
    var handleChange = function(value) {
        if (maxLength) {
            if ((value === null || value === void 0 ? void 0 : value.length) <= maxLength) {
                onChange(value === null || value === void 0 ? void 0 : value.substring(0, maxLength));
            }
        } else {
            onChange(value);
        }
    };
    var countCharacter = (0,react.useMemo)(function() {
        var result = "";
        if (maxLength && showCountCharacter) result = "".concat((value1 === null || value1 === void 0 ? void 0 : value1.length) || 0, "/").concat(maxLength);
        return result;
    }, [
        maxLength,
        showCountCharacter,
        value1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((InputCustom_style_module_default()).inputCustom, InputCustom_defineProperty({}, (InputCustom_style_module_default()).inputNoBorder, hasNoBorder)),
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666] mb-1",
                                style: styleLabel,
                                children: [
                                    required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] text-[#FF3141] ml-[-7px] font-simsun",
                                        children: "*"
                                    }),
                                    label
                                ]
                            }),
                            textTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-1 mt-[-5px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                    content: textTooltip,
                                    placement: "top-start",
                                    mode: "dark",
                                    trigger: "click",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                        className: "ml-1 w-[14px] h-[14px]",
                                        onClick: function() {},
                                        fillColor: "#1890FF"
                                    })
                                })
                            })
                        ]
                    }),
                    isMultiline && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                className: "".concat(classNameText),
                                maxLength: maxLength,
                                placeholder: placeholder,
                                onChange: handleChange,
                                value: value1,
                                rows: numberLine,
                                autoComplete: "false"
                            }),
                            extra && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lead-2",
                                children: extra
                            })
                        ]
                    }),
                    !isMultiline && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                className: "".concat(classNameText),
                                maxLength: maxLength,
                                placeholder: placeholder,
                                onChange: handleChange,
                                type: type,
                                value: value1,
                                autoComplete: "false",
                                autoCorrect: "off",
                                onKeyDown: onKeyDown,
                                inputMode: inputMode
                            }),
                            extra && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lead-2",
                                children: extra
                            })
                        ]
                    }),
                    showCountCharacter && countCharacter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right pt-1",
                        children: countCharacter
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 text-[#FF3141] text-left ",
                style: {
                    fontSize: 13
                },
                children: error
            }),
            hasBottomDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                style: {
                    marginTop: 12,
                    marginBottom: 12
                }
            })
        ]
    });
};
/* harmony default export */ var components_InputCustom = (InputCustom);

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/ContentModal.tsx





function ContentModal(props) {
    var onChange = props.onChange, errorMsg = props.errorMsg, value = props.value, onCheckExtraCommission = props.onCheckExtraCommission, _extraCommissionCheck = props.extraCommissionCheck, extraCommissionCheck = _extraCommissionCheck === void 0 ? true : _extraCommissionCheck;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-[#666666] mb-1",
                children: t("ss_builder_import_site_url_modal_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                onChange: onChange,
                placeholder: t("ss_builder_enter_url_label"),
                error: errorMsg,
                value: value
            }),
            value && !errorMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                checked: extraCommissionCheck,
                onChange: onCheckExtraCommission,
                style: {
                    "--icon-size": "20px",
                    "--font-size": "15px"
                },
                className: "mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_earn_additional_commissions_label")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/api/index.ts
var ProductUploadFromSiteUrl_api = __webpack_require__(87521);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/constants/index.tsx
var constants = __webpack_require__(77081);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/hooks/useGetJsonFileURL.tsx
function useGetJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetJsonFileURL_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var useGetJsonFileURL = function(url1, isInvalidURL) {
    var ref6 = (0,react.useState)(null), urlValue = ref6[0], setUrlValue = ref6[1];
    var ref1 = (0,react.useState)(null), categories = ref1[0], setCategories = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = useGetJsonFileURL_asyncToGenerator(runtime_default().mark(function _callee(url) {
                var response, ref, ref4, ref5, htmlValue, validString, categoryMatch, categoryObj, domainMatch, subdomain, matches, fileName, jsonUrl;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,ProductUploadFromSiteUrl_api/* requestGetDataFromUrl */.tb)(url);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Error fetching HTML:", _ctx.t0);
                            setIsLoading(false);
                            setIsError(true);
                        case 12:
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                ;
                                htmlValue = response.data;
                                validString = htmlValue.match(constants/* FILE_NAME_REGEX */.LO);
                                console.log("validString", validString);
                                categoryMatch = htmlValue.match(constants/* AT_CATEGORY_REGEX */.Np);
                                categoryObj = JSON.parse((ref = categoryMatch[0]) === null || ref === void 0 ? void 0 : ref.split("=")[1]);
                                domainMatch = url.match(constants/* DOMAIN_REGEX */.Xx);
                                subdomain = (ref4 = domainMatch[1]) === null || ref4 === void 0 ? void 0 : ref4.split(".")[0];
                                matches = (ref5 = validString[0]) === null || ref5 === void 0 ? void 0 : ref5.match(/([^\\\/]*?\.json)/);
                                fileName = matches && matches[1] ? matches[1] : null;
                                if (fileName) {
                                    jsonUrl = "".concat(url.replace(/\/$/, ""), "/json/profile/").concat(subdomain, "/").concat(fileName);
                                    setUrlValue(jsonUrl);
                                    setIsLoading(false);
                                }
                                if (categoryObj) {
                                    setCategories(categoryObj);
                                }
                                setIsError(false);
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchData(url) {
                return _ref.apply(this, arguments);
            };
        }();
        if (url1 && !isInvalidURL) {
            setIsLoading(true);
            var newUrl = url1 === null || url1 === void 0 ? void 0 : url1.replace("https", "http");
            fetchData(newUrl);
        }
    }, [
        url1,
        isInvalidURL
    ]);
    return {
        urlValue: urlValue,
        isLoading: isLoading,
        categories: categories,
        isError: isError
    };
};

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/hooks/useGetProductsFromJsonFileURL.tsx
function useGetProductsFromJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetProductsFromJsonFileURL_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetProductsFromJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetProductsFromJsonFileURL_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useGetProductsFromJsonFileURL = function(url1) {
    var ref = (0,react.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = useGetProductsFromJsonFileURL_asyncToGenerator(runtime_default().mark(function _callee(url) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,ProductUploadFromSiteUrl_api/* requestGetDataFromUrl */.tb)(url);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Error fetching data:", _ctx.t0);
                            setIsLoading(false);
                            setIsError(true);
                        case 12:
                            if (response === null || response === void 0 ? void 0 : response.success) {
                                setData(response.data);
                                setIsLoading(false);
                                setIsError(false);
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchData(url) {
                return _ref.apply(this, arguments);
            };
        }();
        if (url1) {
            setIsLoading(true);
            fetchData(url1);
        }
    }, [
        url1
    ]);
    return {
        data: data,
        isLoading: isLoading,
        isError: isError
    };
};

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/hooks/useGetProductsFromShopeeAff.tsx
function useGetProductsFromShopeeAff_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetProductsFromShopeeAff_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetProductsFromShopeeAff_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetProductsFromShopeeAff_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useGetProductsFromShopeeAff = function(url, isInvalidURL) {
    var ref = (0,react.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var parts = url.split("/");
    var urlSuffix = parts[parts.length - 1];
    (0,react.useEffect)(function() {
        var params = {
            urlSuffix: urlSuffix
        };
        var fetchData = function() {
            var _ref = useGetProductsFromShopeeAff_asyncToGenerator(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,ProductUploadFromSiteUrl_api/* requestGetDataFromShopeeAff */.z2)(params);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Error fetching data:", _ctx.t0);
                            setIsLoading(false);
                            setIsError(true);
                        case 12:
                            if (response === null || response === void 0 ? void 0 : response.success) {
                                setData(response.data);
                                setIsLoading(false);
                                setIsError(false);
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (url && !isInvalidURL) {
            setIsLoading(true);
            fetchData();
        }
    }, [
        url
    ]);
    return {
        data: data,
        urlSuffix: urlSuffix,
        isLoading: isLoading,
        isError: isError
    };
};

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/hooks/useGetProductLinksFromMshake.tsx
function useGetProductLinksFromMshake_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetProductLinksFromMshake_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetProductLinksFromMshake_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetProductLinksFromMshake_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useGetProductLinksFromMshake = function(url1, isInvalidURL) {
    var ref5 = (0,react.useState)(null), links1 = ref5[0], setLinks = ref5[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = useGetProductLinksFromMshake_asyncToGenerator(runtime_default().mark(function _callee(url) {
                var response, ref, htmlValue, parser, doc, regex, classValue, items, links, i, ref3, ref4, href;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,ProductUploadFromSiteUrl_api/* requestGetHTMLDataFromUrl */.B7)(url);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Error fetching HTML:", _ctx.t0);
                            setIsLoading(false);
                            setIsError(true);
                        case 12:
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                ;
                                htmlValue = response.data;
                                parser = new DOMParser();
                                doc = parser.parseFromString(htmlValue, "text/html");
                                regex = /look\d+-links__link-container/;
                                classValue = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.match(regex)[0];
                                items = doc.querySelectorAll(".".concat(classValue));
                                links = [];
                                for(i = 0; i < (items === null || items === void 0 ? void 0 : items.length); i++){
                                    ;
                                    href = (ref4 = (ref3 = items[i]) === null || ref3 === void 0 ? void 0 : ref3.getElementsByTagName("a")[0]) === null || ref4 === void 0 ? void 0 : ref4.getAttribute("href");
                                    if (href) {
                                        links.push(href);
                                    }
                                }
                                setLinks(links);
                                setIsLoading(false);
                                setIsError(false);
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchData(url) {
                return _ref.apply(this, arguments);
            };
        }();
        if (url1 && !isInvalidURL) {
            setIsLoading(true);
            fetchData(url1);
        }
    }, [
        url1,
        isInvalidURL
    ]);
    return {
        isLoading: isLoading,
        links: links1,
        isError: isError
    };
};

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/libs/index.tsx
var libs = __webpack_require__(21927);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/hooks/useGetProductLinksFromLinkTree.tsx
function useGetProductLinksFromLinkTree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetProductLinksFromLinkTree_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetProductLinksFromLinkTree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetProductLinksFromLinkTree_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var PRODUCT_URL_ELEMENT_CLASS = "pkAuV";
var useGetProductLinksFromLinkTree = function(url1, isInvalidURL) {
    var ref4 = (0,react.useState)(null), links1 = ref4[0], setLinks = ref4[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = useGetProductLinksFromLinkTree_asyncToGenerator(runtime_default().mark(function _callee(url) {
                var response, htmlValue, parser, doc, items, links, i, ref, ref3, href;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,ProductUploadFromSiteUrl_api/* requestGetHTMLDataFromUrl */.B7)(url);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Error fetching HTML:", _ctx.t0);
                            setIsLoading(false);
                            setIsError(true);
                        case 12:
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                htmlValue = response.data;
                                parser = new DOMParser();
                                doc = parser.parseFromString(htmlValue, "text/html");
                                items = doc.querySelectorAll(".".concat(PRODUCT_URL_ELEMENT_CLASS));
                                links = [];
                                for(i = 0; i < items.length; i++){
                                    ;
                                    href = (ref3 = (ref = items[i]) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("a")[0]) === null || ref3 === void 0 ? void 0 : ref3.getAttribute("href");
                                    if (href) {
                                        links.push(href);
                                    }
                                }
                                setLinks(links);
                                setIsLoading(false);
                                setIsError(false);
                            }
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchData(url) {
                return _ref.apply(this, arguments);
            };
        }();
        if (url1 && !isInvalidURL) {
            setIsLoading(true);
            fetchData(url1);
        }
    }, [
        url1,
        isInvalidURL
    ]);
    return {
        isLoading: isLoading,
        links: links1,
        isError: isError
    };
};

;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFromSiteUrl/index.tsx
function ProductUploadFromSiteUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductUploadFromSiteUrl_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductUploadFromSiteUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductUploadFromSiteUrl_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductUploadFromSiteUrl_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductUploadFromSiteUrl_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductUploadFromSiteUrl_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var ProductUploadFromSiteUrl = function(param) {
    var onUpdateData = param.onUpdateData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ref = (0,react.useState)(""), valueURL = ref[0], setValueURL = ref[1];
    var ref1 = (0,react.useState)(true), extraCommissionValue = ref1[0], setExtraCommissionValue = ref1[1];
    var handleConfirm = function() {
        var _ref = ProductUploadFromSiteUrl_asyncToGenerator(runtime_default().mark(function _callee() {
            var use_aff_url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        use_aff_url = extraCommissionValue ? configs_const/* STATUS.ENABLE */.Q_.ENABLE : configs_const/* STATUS.DISABLE */.Q_.DISABLE;
                        if (newATData) {
                            onUpdateData(ProductUploadFromSiteUrl_objectSpread({}, newATData, {
                                atDomain: atDomain === null || atDomain === void 0 ? void 0 : atDomain.replace("https", "http"),
                                use_aff_url: use_aff_url
                            }));
                        } else if (shopeeAffData) {
                            onUpdateData(ProductUploadFromSiteUrl_objectSpread({}, shopeeAffData, {
                                urlSuffix: urlSuffix,
                                use_aff_url: use_aff_url
                            }));
                        } else if (mshakeProductLinks) {
                            onUpdateData({
                                productLinks: mshakeProductLinks,
                                use_aff_url: use_aff_url
                            });
                        } else if (linktreeProductLinks) {
                            onUpdateData({
                                productLinks: linktreeProductLinks,
                                use_aff_url: use_aff_url
                            });
                        }
                        handleCancel();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isUploadProductFromSiteUrl: false
            }
        }));
    };
    var handleChange = function(value) {
        var valueTrim = value.trim();
        setValueURL(valueTrim);
    };
    var atDomain = (valueURL === null || valueURL === void 0 ? void 0 : valueURL.match(constants/* DOMAIN_REGEX */.Xx)) ? valueURL === null || valueURL === void 0 ? void 0 : valueURL.match(constants/* DOMAIN_REGEX */.Xx)[0] : null;
    var isInvalidATURL = (0,libs/* validateATURL */.Fy)(valueURL);
    var isInvalidShopeeAffURL = (0,libs/* validateShopeeAffURL */.q7)(valueURL);
    var isInvalidMshakeURL = (0,libs/* validateMshakeURL */.Xf)(valueURL);
    var isInvalidLinkTreeURL = (0,libs/* validateLinkTreeURL */.Yu)(valueURL);
    //Lấy data từ AT URL
    var ref2 = useGetJsonFileURL(valueURL, isInvalidATURL), jsonFileURL = ref2.urlValue, getJsonFileUrlLoading = ref2.isLoading, atCategories = ref2.categories, isGetJsonFileURLError = ref2.isError;
    var ref3 = useGetProductsFromJsonFileURL(jsonFileURL), ATData = ref3.data, getDataFromJsonFileURLLoading = ref3.isLoading, isGetProductsFromJsonFileURLError = ref3.isError;
    var newATData = (0,react.useMemo)(function() {
        var categories = (ATData === null || ATData === void 0 ? void 0 : ATData.categories) || [];
        var newCategories = categories.map(function(category) {
            var categoryName = category.name;
            if (atCategories === null || atCategories === void 0 ? void 0 : atCategories.hasOwnProperty(categoryName)) {
                categoryName = atCategories[categoryName];
            }
            return ProductUploadFromSiteUrl_objectSpread({}, category, {
                name: categoryName
            });
        });
        if ((newCategories === null || newCategories === void 0 ? void 0 : newCategories.length) > 0) {
            return ProductUploadFromSiteUrl_objectSpread({}, ATData, {
                categories: newCategories
            });
        }
        return ATData;
    }, [
        ATData,
        atCategories
    ]);
    //Lấy data từ Shopee Afiliate
    var ref4 = useGetProductsFromShopeeAff(valueURL, isInvalidShopeeAffURL), shopeeAffData = ref4.data, urlSuffix = ref4.urlSuffix, getDataFromShopeeAffLoading = ref4.isLoading, isGetProductsFromShopeeAffError = ref4.isError;
    //Lấy danh sách đường dẫn sản phẩm từ Mshake
    var ref5 = useGetProductLinksFromMshake(valueURL, isInvalidMshakeURL), getDataFromMshakeLoading = ref5.isLoading, mshakeProductLinks = ref5.links, isGetProductsFromMshakeError = ref5.isError;
    //Lấy danh sách đường dẫn sản phẩm từ Link Tree
    var ref6 = useGetProductLinksFromLinkTree(valueURL, isInvalidLinkTreeURL), getDataFromLinkTreeLoading = ref6.isLoading, linktreeProductLinks = ref6.links, isGetProductsFromLinkTreeError = ref6.isError;
    var isLoadingBtn = getJsonFileUrlLoading || getDataFromJsonFileURLLoading || getDataFromShopeeAffLoading || getDataFromMshakeLoading || getDataFromLinkTreeLoading;
    var errorMsg1 = (0,react.useMemo)(function() {
        var errorMsg = "";
        if (valueURL) {
            if (isInvalidATURL && isInvalidShopeeAffURL && isInvalidMshakeURL && isInvalidLinkTreeURL) {
                errorMsg = t("ss_builder_invalid_url");
            } else if (isGetJsonFileURLError || isGetProductsFromJsonFileURLError || isGetProductsFromShopeeAffError || isGetProductsFromMshakeError || isGetProductsFromLinkTreeError) {
                errorMsg = t("ss_builder_url_error_content");
            }
        }
        return errorMsg;
    }, [
        valueURL,
        isInvalidATURL,
        isInvalidShopeeAffURL,
        isInvalidMshakeURL,
        isInvalidLinkTreeURL,
        isGetJsonFileURLError,
        isGetProductsFromJsonFileURLError,
        isGetProductsFromShopeeAffError,
        isGetProductsFromMshakeError,
        isGetProductsFromLinkTreeError,
        t, 
    ]);
    var isDisableBtn = isInvalidATURL && isInvalidShopeeAffURL && isInvalidMshakeURL && isInvalidLinkTreeURL || isLoadingBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
            visible: true,
            // closeOnMaskClick={true}
            // showCloseButton={true}
            title: t("ss_builder_import_site_url_modal_title"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentModal, {
                onChange: handleChange,
                errorMsg: errorMsg1,
                value: valueURL,
                onCheckExtraCommission: function(val) {
                    return setExtraCommissionValue(val);
                },
                extraCommissionCheck: extraCommissionValue
            }),
            closeOnAction: true,
            actions: [
                {
                    key: "confirm",
                    text: isLoadingBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {
                        color: "white"
                    }) : t("ss_builder_import_site_url_modal_button_label"),
                    // text: t("ss_builder_import_site_url_modal_button_label"),
                    primary: true,
                    onClick: function() {
                        return handleConfirm();
                    },
                    disabled: isDisableBtn,
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }
                },
                {
                    key: "cancel",
                    text: t("ss_builder_cancel"),
                    onClick: function() {
                        return handleCancel();
                    }
                }, 
            ]
        })
    });
};
/* harmony default export */ var AffiliateProductGroup_ProductUploadFromSiteUrl = (ProductUploadFromSiteUrl);

// EXTERNAL MODULE: ./src/features/user/userApi.ts
var userApi = __webpack_require__(63681);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductUploadFile/index.tsx
function ProductUploadFile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductUploadFile_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductUploadFile_arrayLikeToArray(arr);
}
function ProductUploadFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductUploadFile_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductUploadFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductUploadFile_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductUploadFile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductUploadFile_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductUploadFile_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductUploadFile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductUploadFile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductUploadFile_toConsumableArray(arr) {
    return ProductUploadFile_arrayWithoutHoles(arr) || ProductUploadFile_iterableToArray(arr) || ProductUploadFile_unsupportedIterableToArray(arr) || ProductUploadFile_nonIterableSpread();
}
function ProductUploadFile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductUploadFile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductUploadFile_arrayLikeToArray(o, minLen);
}




















var ProductUploadFile = function(param) {
    var isUploadProductFile = param.isUploadProductFile, isUploadProductFromSiteUrl = param.isUploadProductFromSiteUrl, affiliateProductGroupData = param.affiliateProductGroupData, onChange = param.onChange;
    var inputRef = (0,react.useRef)(null);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ErrorModal = (0,modal/* useModal */.dd)().ErrorModal;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var OTHER_PRODUCT_GROUP = ProductUploadFile_objectSpread({}, constant/* DEFAULT_OTHER_AFF_BLOCK */.EI, {
        content_attributes: ProductUploadFile_objectSpread({}, constant/* DEFAULT_OTHER_AFF_BLOCK.content_attributes */.EI.content_attributes, {
            title_product_group: t("ss_builder_affiliate_product_group_other")
        }),
        title: t("ss_builder_affiliate_product_group_other")
    });
    var ref3 = (0,react.useState)(false), visibleLoadingUpload = ref3[0], setVisibleLoadingUpload = ref3[1];
    var ref1 = (0,react.useState)(0), totalUploadItem = ref1[0], setTotalUploadItem = ref1[1];
    var ref2 = (0,react.useState)(0), successNumberItem = ref2[0], setSuccessNumberItem = ref2[1];
    var existedProductLists = (0,react.useMemo)(function() {
        var existedProductArr = [];
        affiliateProductGroupData.forEach(function(x) {
            var ref;
            var affiliateProductArr = (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
            existedProductArr = ProductUploadFile_toConsumableArray(existedProductArr).concat(ProductUploadFile_toConsumableArray(affiliateProductArr));
        });
        return existedProductArr;
    }, [
        affiliateProductGroupData
    ]);
    (0,react.useEffect)(function() {
        if (isUploadProductFile) {
            inputRef.current.click();
            dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                data: {
                    isUploadProductFile: false
                }
            }));
        }
    }, [
        isUploadProductFile
    ]);
    var handleFileSelect = function(event) {
        var file = event.target.files[0];
        if ((file === null || file === void 0 ? void 0 : file.type) !== constant/* TYPE_JSON */.ZI) {
            ErrorModal({
                title: t("ss_builder_affiliate_upload_product_error_label"),
                icon: modal/* ModalIconConfig.ERROR_PRIMARY_CIRCLE */.vi.ERROR_PRIMARY_CIRCLE,
                description: t("ss_builder_affiliate_upload_product_error_content"),
                confirmText: t("ss_builder_delete_product_group_error_btn_confirm_label")
            });
            inputRef.current.value = "";
            return;
        }
        var reader = new FileReader();
        reader.onload = function handleFileSelect(e) {
            var contents = String(e.target.result);
            try {
                var data = JSON.parse(contents);
                handleConvertData(data);
            } catch (error) {
                console.log(error);
            }
            inputRef.current.value = "";
        };
        reader.readAsText(file);
    };
    var handleConvertData = function() {
        var _ref = ProductUploadFile_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var ref, ref4, productLinks, categories, groupList, result, ref5, listProduct, detectUrlList, validUrlList, ref6, listProduct1, detectUrlList1, validUrlList1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setVisibleLoadingUpload(true);
                        setTotalUploadItem(0);
                        productLinks = data === null || data === void 0 ? void 0 : data.productLinks;
                        categories = data === null || data === void 0 ? void 0 : data.categories;
                        groupList = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref4 = ref.landingPageBaseInfo) === null || ref4 === void 0 ? void 0 : ref4.groupList;
                        result = data;
                        if (!productLinks) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 10;
                        return convertBaseMultiLinks(data);
                    case 10:
                        ref5 = _ctx.sent;
                        listProduct = ref5.listProduct;
                        detectUrlList = ref5.detectUrlList;
                        validUrlList = ref5.validUrlList;
                        onChange({
                            listProduct: listProduct,
                            detectUrlList: detectUrlList,
                            validUrlList: validUrlList
                        });
                        return _ctx.abrupt("return");
                    case 16:
                        if (!((categories === null || categories === void 0 ? void 0 : categories.length) > 0)) {
                            _ctx.next = 22;
                            break;
                        }
                        _ctx.next = 19;
                        return (0,helper/* convertProductType1 */.VL)(data);
                    case 19:
                        result = _ctx.sent;
                        _ctx.next = 26;
                        break;
                    case 22:
                        if (!groupList) {
                            _ctx.next = 26;
                            break;
                        }
                        _ctx.next = 25;
                        return (0,helper/* convertProductType2 */.Ir)(data);
                    case 25:
                        result = _ctx.sent;
                    case 26:
                        _ctx.next = 28;
                        return convertBaseJsonFile(result);
                    case 28:
                        ref6 = _ctx.sent;
                        listProduct1 = ref6.listProduct;
                        detectUrlList1 = ref6.detectUrlList;
                        validUrlList1 = ref6.validUrlList;
                        onChange({
                            listProduct: listProduct1,
                            detectUrlList: detectUrlList1,
                            validUrlList: validUrlList1
                        });
                    case 33:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConvertData(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var convertBaseJsonFile = function() {
        var _ref = ProductUploadFile_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var ref23, listProduct, allProducts, prod, detectUrlList, validUrlList, count, sortOrder, ref7, ref8, validateUrl, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, idxOther, idxProduct, sourceUrl, prodUid, ref18, // If found category name, add it into group category product
            ref19, ref20, ref21, ref22;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        listProduct = cloneDeep_default()(affiliateProductGroupData);
                        allProducts = listProduct === null || listProduct === void 0 ? void 0 : listProduct.reduce(function(acc, product) {
                            var ref;
                            return acc.concat(product === null || product === void 0 ? void 0 : (ref = product.content_attributes) === null || ref === void 0 ? void 0 : ref.items);
                        }, []);
                        prod = cloneDeep_default()(data === null || data === void 0 ? void 0 : data.products);
                        detectUrlList = [];
                        validUrlList = [];
                        count = 0;
                        sortOrder = (ref23 = affiliateProductGroupData[(affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) - 1]) === null || ref23 === void 0 ? void 0 : ref23.sort_order;
                        setTotalUploadItem(prod === null || prod === void 0 ? void 0 : prod.length);
                    case 9:
                        if (!(count < (prod === null || prod === void 0 ? void 0 : prod.length))) {
                            _ctx.next = 44;
                            break;
                        }
                        ;
                        _ctx.next = 13;
                        return (0,sleep/* sleep */._)(1);
                    case 13:
                        validateUrl = (0,helper/* validateProductUrl */.zf)(prod[count], allProducts, detectUrlList);
                        detectUrlList.push(validateUrl.url);
                        if (!(((ref7 = prod[count]) === null || ref7 === void 0 ? void 0 : ref7.url) && ((ref8 = prod[count]) === null || ref8 === void 0 ? void 0 : ref8.product_name) && validateUrl.valid)) {
                            _ctx.next = 40;
                            break;
                        }
                        ;
                        idxOther = listProduct.findIndex(function(x) {
                            var ref, ref24;
                            return (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group) === (OTHER_PRODUCT_GROUP === null || OTHER_PRODUCT_GROUP === void 0 ? void 0 : (ref24 = OTHER_PRODUCT_GROUP.content_attributes) === null || ref24 === void 0 ? void 0 : ref24.title_product_group);
                        });
                        idxProduct = listProduct.findIndex(function(x) {
                            var ref, ref25, ref26, ref27;
                            return (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : (ref25 = ref.title_product_group) === null || ref25 === void 0 ? void 0 : ref25.toUpperCase()) === ((ref26 = prod[count]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.category_name) === null || ref27 === void 0 ? void 0 : ref27.toUpperCase());
                        });
                        sourceUrl = (0,helper/* getSourceUrl */.LH)((ref9 = prod[count]) === null || ref9 === void 0 ? void 0 : ref9.url);
                        validUrlList.push((ref10 = prod[count]) === null || ref10 === void 0 ? void 0 : ref10.url);
                        prod[count].id = ((ref11 = prod[count]) === null || ref11 === void 0 ? void 0 : ref11.id) || (0,v4/* default */.Z)();
                        prod[count].uid = ((ref12 = prod[count]) === null || ref12 === void 0 ? void 0 : ref12.id) || (0,v4/* default */.Z)();
                        _ctx.next = 25;
                        return (0,validator/* checkImageUrl */.qx)((ref13 = prod[count]) === null || ref13 === void 0 ? void 0 : ref13.product_image);
                    case 25:
                        if (!_ctx.sent) {
                            _ctx.next = 29;
                            break;
                        }
                        _ctx.t0 = (ref14 = prod[count]) === null || ref14 === void 0 ? void 0 : ref14.product_image;
                        _ctx.next = 30;
                        break;
                    case 29:
                        _ctx.t0 = constant/* IMG_PRODUCT_DEFAULT */.gP;
                    case 30:
                        prod[count].image = _ctx.t0;
                        prod[count].title = (ref15 = prod[count]) === null || ref15 === void 0 ? void 0 : ref15.product_name;
                        prod[count].name = (ref16 = prod[count]) === null || ref16 === void 0 ? void 0 : ref16.product_name;
                        prod[count].enable = configs_const/* STATUS.ENABLE */.Q_.ENABLE;
                        // prod[count].use_aff_url = STATUS.ENABLE;
                        prod[count].origin_link = (ref17 = prod[count]) === null || ref17 === void 0 ? void 0 : ref17.url;
                        if (isUploadProductFromSiteUrl) {
                            prod[count].is_import_by_url = true;
                        } else {
                            prod[count].is_import_json = true;
                        }
                        prod[count] = ProductUploadFile_objectSpread({}, prod[count], sourceUrl);
                        prod[count] = omit_default()(prod[count], [
                            "product_image",
                            "product_name",
                            "url", 
                        ]);
                        prodUid = "affiliate-product-".concat((0,v4/* default */.Z)());
                        if (!prod[count].hasOwnProperty("category_name") || prod[count].category_name === "") {
                            //Find group product other, if it not found, create product other
                            if (idxOther === constant/* INDEX_NOT_FOUND */.Ap) {
                                sortOrder = sortOrder + 1;
                                listProduct.push(ProductUploadFile_objectSpread({}, OTHER_PRODUCT_GROUP, {
                                    content_attributes: ProductUploadFile_objectSpread({}, OTHER_PRODUCT_GROUP.content_attributes, {
                                        items: [
                                            ProductUploadFile_objectSpread({}, prod[count])
                                        ]
                                    }),
                                    uid: prodUid,
                                    sort_order: sortOrder
                                }));
                            } else if (idxOther > constant/* INDEX_NOT_FOUND */.Ap) {
                                ;
                                (ref18 = listProduct[idxOther]) === null || ref18 === void 0 ? void 0 : ref18.content_attributes.items.push(prod[count]);
                            }
                        } else if (idxProduct > constant/* INDEX_NOT_FOUND */.Ap) {
                            ;
                            (ref20 = (ref19 = listProduct[idxProduct]) === null || ref19 === void 0 ? void 0 : ref19.content_attributes.items) === null || ref20 === void 0 ? void 0 : ref20.push(prod[count]);
                        } else if (idxProduct === constant/* INDEX_NOT_FOUND */.Ap) {
                            ;
                            // If not found category name, create group category product
                            sortOrder = sortOrder + 1;
                            listProduct.push(ProductUploadFile_objectSpread({}, constant/* DEFAULT_AFF_BLOCK */.T, {
                                content_attributes: ProductUploadFile_objectSpread({}, constant/* DEFAULT_AFF_BLOCK.content_attributes */.T.content_attributes, {
                                    items: [
                                        ProductUploadFile_objectSpread({}, prod[count])
                                    ],
                                    title_product_group: (ref21 = prod[count]) === null || ref21 === void 0 ? void 0 : ref21.category_name
                                }),
                                title: (ref22 = prod[count]) === null || ref22 === void 0 ? void 0 : ref22.category_name,
                                uid: prodUid,
                                sort_order: sortOrder
                            }));
                        }
                    case 40:
                        count++;
                        setSuccessNumberItem(validUrlList.length);
                        _ctx.next = 9;
                        break;
                    case 44:
                        setVisibleLoadingUpload(false);
                        setSuccessNumberItem(0);
                        return _ctx.abrupt("return", {
                            listProduct: listProduct,
                            detectUrlList: detectUrlList,
                            validUrlList: validUrlList
                        });
                    case 47:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function convertBaseJsonFile(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var convertBaseMultiLinks = function() {
        var _ref = ProductUploadFile_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var ref41, productLinks, use_aff_url, listProduct, detectUrlList, validUrlList, detectedProductIdArr, count, sortOrder, ref28, ref29, detectedResponse, timeoutPromise, ref30, ref31, ref32, ref33, productDetectData, isCheckExistProduct, ref34, ref35, ref36, ref37, ref38, sourceUrl, isSuccess, shorternLink, currentTime, createdAtTime, newProduct, idxOther, prodUid, ref39;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        productLinks = data === null || data === void 0 ? void 0 : data.productLinks;
                        use_aff_url = data === null || data === void 0 ? void 0 : data.use_aff_url;
                        listProduct = cloneDeep_default()(affiliateProductGroupData);
                        detectUrlList = [];
                        validUrlList = [];
                        detectedProductIdArr = [];
                        count = 0;
                        sortOrder = (ref41 = affiliateProductGroupData[(affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) - 1]) === null || ref41 === void 0 ? void 0 : ref41.sort_order;
                        setTotalUploadItem(productLinks === null || productLinks === void 0 ? void 0 : productLinks.length);
                    case 10:
                        if (!(count < (productLinks === null || productLinks === void 0 ? void 0 : productLinks.length))) {
                            _ctx.next = 62;
                            break;
                        }
                        ;
                        _ctx.next = 14;
                        return (0,sleep/* sleep */._)(1);
                    case 14:
                        detectedResponse = null;
                        _ctx.prev = 15;
                        timeoutPromise = new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                resolve(null);
                            }, 30000);
                        });
                        _ctx.next = 19;
                        return Promise.race([
                            timeoutPromise,
                            (0,api/* requestDetectProductUrl */.r_)(productLinks[count]), 
                        ]);
                    case 19:
                        //Nếu trong 10s mà trả về response thì sẽ lấy response đó, ngược lại sẽ trả về null
                        detectedResponse = _ctx.sent;
                        _ctx.next = 25;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](15);
                        console.log("Request error", _ctx.t0);
                    case 25:
                        if (!(detectedResponse && /^20[0-9]$/.test(detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref28 = detectedResponse.status) === null || ref28 === void 0 ? void 0 : ref28.toString()) && (detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref29 = detectedResponse.data) === null || ref29 === void 0 ? void 0 : ref29.data))) {
                            _ctx.next = 57;
                            break;
                        }
                        ;
                        productDetectData = ProductUploadFile_objectSpread({}, detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref30 = detectedResponse.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.data) === null || ref31 === void 0 ? void 0 : ref31.product, {
                            product_id: detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref32 = detectedResponse.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.data) === null || ref33 === void 0 ? void 0 : ref33.product_id
                        });
                        isCheckExistProduct = !!(Array.isArray(existedProductLists) && (existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.length) > 0 && (existedProductLists === null || existedProductLists === void 0 ? void 0 : existedProductLists.some(function(x) {
                            return String(x.uid) === String(productDetectData.id) || (0,helper/* compareSameEcomerceUrl */.K9)(x === null || x === void 0 ? void 0 : x.origin_link, productLinks[count]);
                        })) || detectedProductIdArr.includes(productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.id));
                        if (!isCheckExistProduct) {
                            _ctx.next = 33;
                            break;
                        }
                        {
                            detectUrlList.push({
                                url: productLinks[count],
                                valid_type: configs_const/* PRODUCT_URL_CHECKING.DUPLICATE */.oL.DUPLICATE
                            });
                        }
                        _ctx.next = 55;
                        break;
                    case 33:
                        ;
                        sourceUrl = (0,helper/* getSourceUrl */.LH)(productLinks[count]);
                        isSuccess = detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref34 = detectedResponse.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : ref35.success;
                        shorternLink = null;
                        _ctx.prev = 37;
                        _ctx.next = 40;
                        return (0,userApi/* genLink */._3)(productLinks[count], {
                            sub1: "ig",
                            sub2: "true",
                            traffic_source: "ss-landing-copy"
                        });
                    case 40:
                        shorternLink = _ctx.sent;
                        _ctx.next = 46;
                        break;
                    case 43:
                        _ctx.prev = 43;
                        _ctx.t1 = _ctx["catch"](37);
                        console.log(_ctx.t1);
                    case 46:
                        currentTime = new Date();
                        createdAtTime = currentTime.toISOString();
                        newProduct = ProductUploadFile_objectSpread({}, productDetectData, sourceUrl, {
                            id: (productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.id) || (0,v4/* default */.Z)(),
                            uid: (productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.id) || (0,v4/* default */.Z)(),
                            title: productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.name,
                            enable: configs_const/* STATUS.ENABLE */.Q_.ENABLE,
                            shortern_link: shorternLink,
                            use_aff_url: use_aff_url,
                            origin_link: productLinks[count],
                            warning_code: isSuccess ? detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref36 = detectedResponse.data) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.data) === null || ref37 === void 0 ? void 0 : ref37.warning_code : null,
                            error_code: !isSuccess ? detectedResponse === null || detectedResponse === void 0 ? void 0 : (ref38 = detectedResponse.data) === null || ref38 === void 0 ? void 0 : ref38.error_code : null,
                            createdAt: createdAtTime
                        });
                        idxOther = listProduct.findIndex(function(x) {
                            var ref, ref40;
                            return (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group) === (OTHER_PRODUCT_GROUP === null || OTHER_PRODUCT_GROUP === void 0 ? void 0 : (ref40 = OTHER_PRODUCT_GROUP.content_attributes) === null || ref40 === void 0 ? void 0 : ref40.title_product_group);
                        });
                        prodUid = "affiliate-product-".concat((0,v4/* default */.Z)());
                        //Find group product other, if it not found, create product other
                        if (idxOther === constant/* INDEX_NOT_FOUND */.Ap) {
                            sortOrder = sortOrder + 1;
                            listProduct.push(ProductUploadFile_objectSpread({}, OTHER_PRODUCT_GROUP, {
                                content_attributes: ProductUploadFile_objectSpread({}, OTHER_PRODUCT_GROUP.content_attributes, {
                                    items: [
                                        newProduct
                                    ]
                                }),
                                uid: prodUid,
                                sort_order: sortOrder
                            }));
                        } else if (idxOther > constant/* INDEX_NOT_FOUND */.Ap) {
                            ;
                            (ref39 = listProduct[idxOther]) === null || ref39 === void 0 ? void 0 : ref39.content_attributes.items.push(newProduct);
                        }
                        validUrlList.push(productLinks[count]);
                        detectedProductIdArr.push(productDetectData === null || productDetectData === void 0 ? void 0 : productDetectData.id);
                        detectUrlList.push({
                            url: productLinks[count],
                            valid_type: configs_const/* PRODUCT_URL_CHECKING.SUCCESS */.oL.SUCCESS
                        });
                    case 55:
                        _ctx.next = 58;
                        break;
                    case 57:
                        {
                            detectUrlList.push({
                                url: productLinks[count],
                                valid_type: configs_const/* PRODUCT_URL_CHECKING.NOT_ADDED_YET */.oL.NOT_ADDED_YET
                            });
                        }
                    case 58:
                        count++;
                        setSuccessNumberItem(validUrlList === null || validUrlList === void 0 ? void 0 : validUrlList.length);
                        _ctx.next = 10;
                        break;
                    case 62:
                        setVisibleLoadingUpload(false);
                        setSuccessNumberItem(0);
                        return _ctx.abrupt("return", {
                            listProduct: listProduct,
                            detectUrlList: detectUrlList,
                            validUrlList: validUrlList
                        });
                    case 65:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    15,
                    22
                ],
                [
                    37,
                    43
                ]
            ]);
        }));
        return function convertBaseMultiLinks(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateDataFromSiteUrl = function(data) {
        handleConvertData(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isUploadProductFromSiteUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_ProductUploadFromSiteUrl, {
                onUpdateData: handleUpdateDataFromSiteUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).uploadProductFile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    ref: inputRef,
                    type: "file",
                    accept: ".json",
                    className: "invisible h-[0] w-[0]",
                    onChange: handleFileSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                visible: visibleLoadingUpload,
                style: {
                    width: 151,
                    height: 118
                },
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                                color: "#EE3244",
                                style: {
                                    "--size": "32px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] text-[#333333]",
                            children: !!totalUploadItem ? t("ss_builder_multi_product_url_importing_label", {
                                successfullyUrlQuantity: successNumberItem,
                                detectedUrlQuantity: totalUploadItem
                            }) : t("ss_builder_information_handler_alert")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_ProductUploadFile = (ProductUploadFile);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/DetectedUrlLists/index.tsx
var DetectedUrlLists = __webpack_require__(91937);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/Frame/const.ts
var LIST_FRAME = [
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/91d62e8c-eda1-4e26-ba3b-1d083761052f1-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/1-ST.svg",
        id: 1
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/2-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/2-ST.svg",
        id: 2
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/58d6d2ca-8c69-4a2d-bab5-196e009c07e13-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/3-ST.svg",
        id: 3
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/24b8cc44-bdb8-41b6-a247-5b004b1f0f2b4-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/4-ST.svg",
        id: 4
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/5-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/5-ST.svg",
        id: 5
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/6-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/6-ST.svg",
        id: 6
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/7-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/7-ST.svg",
        id: 7
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/a52e8319-a963-44c3-9bd8-fd71d6e090348-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/8-ST.svg",
        id: 8
    },
    {
        urlEU: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/d3180365-5d5f-4e57-98f3-a4926be11e559-EU.png",
        url: "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/632d34c653c0c84ca461b2dc/9-ST.svg",
        id: 9
    }, 
];
var TYPE_FILE_IMAGE_FRAME = [
    "image/gif",
    "image/png",
    "image/svg+xml", 
];
var TRANSPARENT_IMAGE = "https://passio-prod.s3-ap-southeast-1.amazonaws.com/passio-prod/builder/62971a2c53c0c838726388eb/92d9f969-560d-47bb-8367-cb3b344d37a2transparent_bg.svg";

// EXTERNAL MODULE: ./node_modules/lodash/isBoolean.js
var isBoolean = __webpack_require__(51584);
var isBoolean_default = /*#__PURE__*/__webpack_require__.n(isBoolean);
// EXTERNAL MODULE: ./src/features/share/helper/image.ts
var helper_image = __webpack_require__(79704);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/Frame/ListFrame.tsx






var ListFrame = function(props) {
    var setFrame = props.setFrame, frame = props.frame, setUsingFromList = props.setUsingFromList, usingFromList = props.usingFromList, onClose = props.onClose;
    var ref = (0,react.useState)(frame), frameSelected = ref[0], setFrameSelected = ref[1];
    (0,react.useEffect)(function() {
        if (isBoolean_default()(usingFromList) && !usingFromList) setFrameSelected({});
    }, [
        usingFromList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-3 gap-3 p-3 pt-0 mb-5",
        children: LIST_FRAME.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full h-full",
                onClick: function() {
                    setFrameSelected(item);
                    setFrame(item);
                    setUsingFromList(true);
                    onClose();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            backgroundImage: "url(".concat((0,helper_image/* getHorizontalResizeUrl */.L)(item.urlEU, 160), ") , url(").concat(TRANSPARENT_IMAGE, ")"),
                            backgroundPosition: "left bottom, top left",
                            backgroundRepeat: "no-repeat, repeat",
                            backgroundSize: "cover, auto",
                            aspectRatio: "1/1",
                            borderRadius: "4px",
                            border: item.url === (frame === null || frame === void 0 ? void 0 : frame.url) && usingFromList ? "2px solid #EE3244" : ""
                        }
                    }),
                    item.id === (frameSelected === null || frameSelected === void 0 ? void 0 : frameSelected.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-2 right-2 rounded-full bg-[#EE3244]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIconV2 */.lo, {
                            className: "w-5 h-5 ",
                            fillColor: "white"
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var Frame_ListFrame = (ListFrame);

// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/Frame/index.tsx
function Frame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Frame_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Frame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Frame_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var FrameAff = function(props) {
    var triggerOpenClose = props.triggerOpenClose, handleClickSave = props.handleClickSave, frameDefault = props.frameDefault, usingFrameDefault = props.usingFrameDefault;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref = (0,react.useState)(usingFrameDefault), useFrameAff = ref[0], setUseFrameAff = ref[1];
    var ref1 = (0,react.useState)(false), isOpenPopup = ref1[0], setIsOpenPopup = ref1[1];
    var ref2 = (0,react.useState)([]), uploadedImageArr = ref2[0], setUploadedImageArr = ref2[1];
    var ref3 = (0,react.useState)(frameDefault.urlEU || LIST_FRAME[0].urlEU), valueUrlImage = ref3[0], setValueUrlImage = ref3[1];
    var ref4 = (0,react.useState)(null), valueNameImage = ref4[0], setValueNameImage = ref4[1];
    var ref5 = (0,react.useState)(null), valueImageBase64 = ref5[0], setValueImageBase64 = ref5[1];
    var ref6 = (0,react.useState)(false), isValidFileFormat = ref6[0], setIsValidFileFormat = ref6[1];
    var ref7 = (0,react.useState)(false), isValidFileSize = ref7[0], setIsValidFileSize = ref7[1];
    var ref8 = (0,react.useState)(frameDefault), frameData = ref8[0], setFrameData = ref8[1];
    var ref9 = (0,react.useState)(), usingFromList = ref9[0], setUsingFromList = ref9[1];
    var disableButtonSave = (0,react.useMemo)(function() {
        if (valueImageBase64 && !usingFromList) return false;
        return !(useFrameAff !== usingFrameDefault || JSON.stringify(frameData) !== JSON.stringify(frameDefault));
    }, [
        useFrameAff,
        usingFrameDefault,
        frameData,
        frameDefault,
        valueImageBase64,
        usingFromList, 
    ]);
    var uploadImageFrame = function() {
        var _ref = Frame_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var image, image_name, responseImage, dataRequestUploadImage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        image = data.image, image_name = data.image_name;
                        responseImage = null;
                        if (image === null || image === void 0 ? void 0 : image.startsWith("http")) {
                            _ctx.next = 13;
                            break;
                        }
                        dataRequestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: image_name,
                            content: image
                        };
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUploadImage */.MR)(dataRequestUploadImage);
                    case 7:
                        responseImage = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        return _ctx.abrupt("return", responseImage);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ]
            ]);
        }));
        return function uploadImageFrame(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function() {
        var _ref = Frame_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (valueImageBase64) {
                            uploadImageFrame({
                                image: valueImageBase64,
                                image_name: valueNameImage
                            }).then(function(res) {
                                handleClickSave(useFrameAff, {
                                    url: res.url,
                                    urlEU: res.url
                                });
                                triggerOpenClose(false);
                            }).catch(function(e) {
                                return console.log(e);
                            });
                        } else {
                            handleClickSave(useFrameAff, frameData);
                            triggerOpenClose(false);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBeforeUpload = function(file) {
        var fileType = file === null || file === void 0 ? void 0 : file.type;
        if (TYPE_FILE_IMAGE_FRAME.includes(fileType)) return file;
        setIsValidFileFormat(true);
        return null;
    };
    var handleUploadImageUrl = function(value) {
        setUsingFromList(false);
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var handleClose = function() {
        if (disableButtonSave) {
            triggerOpenClose(false);
        } else {
            ConfirmModal({
                title: t("ss_builder_cancel_edit_block_title"),
                description: t("ss_builder_cancel_edit_block_content"),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    triggerOpenClose(false);
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                className: "bg-white sticky top-0 z-[9999]",
                onBack: function() {
                    return triggerOpenClose(false);
                },
                backArrow: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center text-[18px] font-normal text-[#333]",
                    children: [
                        t("ss_builder_frame_aff"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute right-[18px] cursor-pointer w-8 h-8 flex justify-center items-center",
                            onClick: function() {
                                return triggerOpenClose(true);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-3 px-4 bg-white ",
                style: {
                    borderTop: "1px solid #EEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] leading-[22px] font-normal text-[#666666] font-normal",
                        children: t("ss_builder_frame_aff")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                        checked: useFrameAff,
                        className: "mt-2",
                        onChange: function(val) {
                            return setUseFrameAff(val);
                        },
                        uncheckedText: t("ss_builder_off"),
                        checkedText: t("ss_builder_on")
                    }),
                    !!useFrameAff && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                className: "!my-3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-[120px_auto] gap-4 mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            backgroundImage: "url(".concat((0,helper_image/* getHorizontalResizeUrl */.L)(usingFromList ? frameData.url : valueUrlImage), ") , url(").concat(TRANSPARENT_IMAGE, ")"),
                                            backgroundPosition: "left bottom, top left",
                                            backgroundRepeat: "no-repeat, repeat",
                                            backgroundSize: "contain, auto",
                                            aspectRatio: "1/1",
                                            borderRadius: "4px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-[22px] leading-4 text-[#8C8C8C] text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_aff_frame_max_size_content")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_aff_frame_support_type_file_content")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                                beforeUpload: handleBeforeUpload,
                                                onChange: handleUploadImageUrl,
                                                upload: function(file) {
                                                    return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                                },
                                                className: "flex-grow",
                                                value: uploadedImageArr,
                                                // accept="image/png, image/gif, image/svg"
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                    // color="primary"
                                                    fill: "solid",
                                                    size: "small",
                                                    className: "w-full grow",
                                                    style: {
                                                        color: "#EE3244",
                                                        border: "1px solid #EE3244"
                                                    },
                                                    children: t("ss_builder_upload_button_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                color: "primary",
                                                fill: "solid",
                                                size: "small",
                                                className: "w-full !mt-2 grow",
                                                onClick: function() {
                                                    return setIsOpenPopup(true);
                                                },
                                                children: t("ss_builder_aff_frame_select_from_library")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_format_invalid_content_for_gif_png_svg")
                                    })
                                ]
                            }),
                            isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_size_invalid_content")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                style: {
                    borderTop: "1px solid #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            // onClick={() => triggerOpenClose(false)}
                            onClick: function() {
                                return handleClose();
                            },
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: handleClick,
                            disabled: disableButtonSave,
                            children: t("ss_builder_save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenPopup,
                onMaskClick: function() {
                    return setIsOpenPopup(false);
                },
                title: t("ss_builder_affiliate_product_frame_panel_title"),
                onClose: function() {
                    return setIsOpenPopup(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Frame_ListFrame, {
                    frame: frameData,
                    setFrame: setFrameData,
                    setUsingFromList: setUsingFromList,
                    usingFromList: usingFromList,
                    onClose: function() {
                        return setIsOpenPopup(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Frame = (FrameAff);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/context.tsx
var context = __webpack_require__(69283);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/index.tsx
function AffiliateProductGroup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AffiliateProductGroup_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AffiliateProductGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AffiliateProductGroup_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AffiliateProductGroup_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AffiliateProductGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AffiliateProductGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AffiliateProductGroup_slicedToArray(arr, i) {
    return AffiliateProductGroup_arrayWithHoles(arr) || AffiliateProductGroup_iterableToArrayLimit(arr, i) || AffiliateProductGroup_unsupportedIterableToArray(arr, i) || AffiliateProductGroup_nonIterableRest();
}
function AffiliateProductGroup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AffiliateProductGroup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AffiliateProductGroup_arrayLikeToArray(o, minLen);
}























var BLOCK_HEADING_MAXIMUM = 50;
var BLOCK_DESCRIPTION_MAXIMUM = 250;
var AffiliateProductGroup = function(props) {
    var ref29, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "affiliate-product-group-".concat((0,v4/* default */.Z)());
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ref9 = (0,react.useState)(false), isSticky = ref9[0], setIsSticky = ref9[1];
    var ref10 = (0,react.useState)(false), openProductSelectionChecking = ref10[0], setOpenProductSelectionChecking = ref10[1];
    var stickyRef = (0,react.useRef)(null);
    var headingAreaRef = (0,react.useRef)(null);
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var hiddenSteps = ((dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.affiliateSettingTour) || {}).hiddenSteps;
    var isOpenAffiliateSettingTour = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isOpenAffiliateSettingTour;
    var KEY = edittingBlock === null || edittingBlock === void 0 ? void 0 : edittingBlock.KEY;
    var isUploadProductFile = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.dynamicConfig) === null || ref === void 0 ? void 0 : ref.isUploadProductFile;
    });
    var isUploadProductFromSiteUrl = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.dynamicConfig) === null || ref === void 0 ? void 0 : ref.isUploadProductFromSiteUrl;
    });
    var ref11 = (0,react.useState)(false), isOpenDetectedUrlLists = ref11[0], setIsOpenDetectedUrlLists = ref11[1];
    var ref12 = (0,react.useState)([]), detectedUrlList = ref12[0], setDetectedUrlList = ref12[1];
    var ref13 = (0,react.useState)([]), validUrlList1 = ref13[0], setValidUrlList = ref13[1];
    var ref14 = (0,react.useState)(false), isShowNoticeUpload = ref14[0], setIsShowNoticeUpload = ref14[1];
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    (0,react.useEffect)(function() {
        var ref = stickyRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = AffiliateProductGroup_slicedToArray(param, 1), e = _param[0];
            setIsSticky(e.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        observer.observe(ref);
        return function() {
            return observer.unobserve(ref);
        };
    }, [
        stickyRef
    ]);
    var affiliateProductDefault = (0,react.useMemo)(function() {
        return {
            uid: "affiliate-product-".concat((0,v4/* default */.Z)()),
            sort_order: 1,
            enable: 1,
            block_type: BLOCK_TYPE.AFF_PRODUCT,
            title: t("ss_builder_product_group_default_title"),
            content_attributes: {
                items: [],
                title_product_group: t("ss_builder_product_group_default_title")
            },
            style_attributes: {}
        };
    }, []);
    var elementId = (0,react.useMemo)(function() {
        return "e" + Math.random().toString(36).slice(2, 7);
    }, []);
    var defaultValueEditAffiliateProductGroup = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : defaultValueEditAffiliateProductGroup.title) || "Affiliate Product";
    var valueDescriptionBlockDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref29 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref29 === void 0 ? void 0 : ref29.block_description) || "";
    var affiliateProductGroupArrDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref1 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.items) || [
        affiliateProductDefault
    ];
    var seeMoreBtnContentDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref2 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.see_more_btn_content) || t("ss_builder_see_more_btn_default_title");
    var affiliateProductTitleDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref3 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.title_product_group) || "";
    var activeProductGroupDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : defaultValueEditAffiliateProductGroup.content_attributes[defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : defaultValueEditAffiliateProductGroup.uid]) || ((ref4 = affiliateProductGroupArrDefault[0]) === null || ref4 === void 0 ? void 0 : ref4.uid);
    var styleProductDisplayDefault = (0,react.useMemo)(function() {
        var ref;
        var ref30;
        var styleDisPlay = (ref30 = defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref = defaultValueEditAffiliateProductGroup.style_attributes) === null || ref === void 0 ? void 0 : ref.style_display) !== null && ref30 !== void 0 ? ref30 : "grid";
        if (styleDisPlay && styleDisPlay.includes("grid")) {
            return "grid";
        } else return styleDisPlay;
    }, [
        defaultValueEditAffiliateProductGroup
    ]);
    var usingFrameDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref5 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.using_frame) || false;
    var frameOfAffDefault = (defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref6 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.frame_of_aff) || LIST_FRAME[0];
    var ref15 = (0,react.useState)(styleProductDisplayDefault || "grid"), styleProductDisplay = ref15[0], setStyleProductDisplay = ref15[1];
    var ref16;
    var is_created_new = (ref16 = defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref7 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.is_created_new) !== null && ref16 !== void 0 ? ref16 : false;
    var product_group_maximum = defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref8 = defaultValueEditAffiliateProductGroup.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.product_group_maximum;
    var styleGridProductDisplayDefault = (0,react.useMemo)(function() {
        var ref, ref31;
        var styleDisPlay = defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref = defaultValueEditAffiliateProductGroup.style_attributes) === null || ref === void 0 ? void 0 : ref.style_display;
        var itemOnRow = defaultValueEditAffiliateProductGroup === null || defaultValueEditAffiliateProductGroup === void 0 ? void 0 : (ref31 = defaultValueEditAffiliateProductGroup.style_attributes) === null || ref31 === void 0 ? void 0 : ref31.item_on_row;
        if (styleDisPlay && styleDisPlay === "grid-1") {
            return configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE;
        } else if (styleDisPlay && styleDisPlay === "grid-2") {
            return configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO;
        } else if (styleDisPlay && styleDisPlay === "grid-3") {
            return configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE;
        } else {
            if (styleProductDisplay !== "grid" && styleProductDisplay !== "text-over-image") {
                return null;
            } else {
                if (itemOnRow) {
                    return itemOnRow;
                } else return configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO;
            }
        }
    }, [
        defaultValueEditAffiliateProductGroup,
        styleProductDisplay
    ]);
    var ref17 = (0,react.useState)(styleGridProductDisplayDefault || configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO), styleGridProductDisplay = ref17[0], setStyleGridProductDisplay = ref17[1];
    var ref18 = (0,react.useState)(affiliateProductGroupArrDefault), affiliateProductGroupData = ref18[0], setAffiliateProductGroupData = ref18[1];
    var ref19 = (0,react.useState)(activeProductGroupDefault), activeProductGroup = ref19[0], setActiveProductGroup = ref19[1];
    var ref20 = (0,react.useState)(seeMoreBtnContentDefault || t("ss_builder_see_more_btn_default_title")), seeMoreBtnContent = ref20[0], setSeeMoreBtnContent = ref20[1];
    var ref21 = (0,react.useState)(affiliateProductTitleDefault || ""), affiliateProductTitle = ref21[0], setAffiliateProductTitle = ref21[1];
    var ref22 = (0,react.useState)(false), isOpenAddProdcutGroup = ref22[0], setIsOpenAddProductGroup = ref22[1];
    var ref23 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref23[0], setValueDescriptionBlock = ref23[1];
    var ref24 = (0,react.useState)(is_created_new), isCreatedNew = ref24[0], setIsCreatedNew = ref24[1];
    var ref25 = (0,react.useState)(false), isClickAction = ref25[0], setIsClickAction = ref25[1];
    var ref26 = (0,react.useState)(false), openSettingFrame = ref26[0], setOpenSettingFrame = ref26[1];
    var ref27 = (0,react.useState)(usingFrameDefault), usingFrame = ref27[0], setUsingFrame = ref27[1];
    var ref28 = (0,react.useState)(frameOfAffDefault), frameData = ref28[0], setFrameData = ref28[1];
    var productGroupQuantityDefaultRef = (0,react.useRef)(affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length);
    var activedProductGroupData = (0,react.useMemo)(function() {
        return affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === activeProductGroup;
        });
    }, [
        affiliateProductGroupData,
        activeProductGroup
    ]);
    var productGroupMaximumRef = (0,react.useRef)(product_group_maximum);
    var productGroupMaximum = (0,react.useMemo)(function() {
        var productGroupQuantity = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length;
        var PRODUCT_GROUP_QUANTITY_CHECKING = 25;
        if (productGroupMaximumRef.current) {
            if (productGroupMaximumRef.current === configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                return productGroupMaximumRef.current;
            } else {
                if (productGroupQuantity >= productGroupQuantityDefaultRef.current) {
                    productGroupQuantityDefaultRef.current = productGroupQuantity;
                    return productGroupMaximumRef.current;
                } else {
                    productGroupQuantityDefaultRef.current = productGroupQuantity;
                    if (productGroupMaximumRef.current - productGroupQuantity >= 5) {
                        if (productGroupQuantity + 5 > configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                            productGroupMaximumRef.current = productGroupQuantity + 5;
                            return productGroupQuantity + 5;
                        } else {
                            productGroupMaximumRef.current = configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                            return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                        }
                    } else {
                        return productGroupMaximumRef.current;
                    }
                }
            }
        } else {
            if (KEY === configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW) {
                setIsCreatedNew(true);
                return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
            } else {
                if (isCreatedNew) {
                    return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                } else {
                    if (productGroupQuantity > configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                        if (productGroupQuantity > productGroupQuantityDefaultRef.current) {
                            return productGroupQuantityDefaultRef.current + 5;
                        } else {
                            productGroupQuantityDefaultRef.current = productGroupQuantity;
                            return productGroupQuantity + 5;
                        }
                    } else {
                        if (productGroupQuantity > PRODUCT_GROUP_QUANTITY_CHECKING) {
                            if (productGroupQuantity > productGroupQuantityDefaultRef.current) {
                                return productGroupQuantityDefaultRef.current + 5;
                            } else {
                                productGroupQuantityDefaultRef.current = productGroupQuantity;
                                return productGroupQuantity + 5;
                            }
                        } else {
                            setIsCreatedNew(true);
                            return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                        }
                    }
                }
            }
        }
    }, [
        isCreatedNew,
        affiliateProductGroupData
    ]);
    (0,react.useEffect)(function() {
        var hiddenStepsClone = Array.from(hiddenSteps);
        if (KEY === configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW) {
            var ref, ref32;
            if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1);
            if ((activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref = activedProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : (ref32 = ref.items) === null || ref32 === void 0 ? void 0 : ref32.length) <= 0) {
                if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
            } else {
                if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                    return x !== setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7;
                });
            }
        } else {
            if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                return x !== setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1;
            });
            if (openProductSelectionChecking) {
                if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6);
                if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
                if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8);
            } else {
                var ref33, ref34;
                if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                    return x !== setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6;
                });
                if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                    return x !== setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7;
                });
                if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                    return x !== setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8;
                });
                if ((activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref33 = activedProductGroupData.content_attributes) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.items) === null || ref34 === void 0 ? void 0 : ref34.length) <= 0) {
                    if (!(hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7))) hiddenStepsClone.push(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
                } else {
                    if (hiddenStepsClone === null || hiddenStepsClone === void 0 ? void 0 : hiddenStepsClone.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7)) hiddenStepsClone = hiddenStepsClone.filter(function(x) {
                        return x !== setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7;
                    });
                }
            }
        }
        dispatch((0,dynamicSlice/* setParamsAffiliateProductTours */.ln)({
            data: {
                hiddenSteps: hiddenStepsClone
            }
        }));
    }, [
        activedProductGroupData,
        KEY,
        openProductSelectionChecking
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultAffiliateProductData = {
                uid: UID,
                sort_order: 1,
                enable: configs_const/* ENABLE_BLOCK */.C5,
                block_type: BLOCK_TYPE.AFF_PRODUCT_GROUP,
                title: titleBlockDefault,
                content_attributes: {
                    items: affiliateProductGroupData,
                    title_product_group: affiliateProductTitle,
                    see_more_btn_content: seeMoreBtnContent,
                    block_description: valueDescriptionBlock,
                    block_heading: affiliateProductTitle,
                    is_created_new: isCreatedNew,
                    product_group_maximum: productGroupMaximum,
                    using_frame: usingFrame,
                    frame_of_aff: frameData
                },
                style_attributes: {
                    style_display: styleProductDisplay,
                    item_on_row: styleGridProductDisplay
                }
            };
            onUpdateData(defaultAffiliateProductData);
        } else {
            onUpdateData(AffiliateProductGroup_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    items: affiliateProductGroupData,
                    title_product_group: affiliateProductTitle,
                    see_more_btn_content: seeMoreBtnContent,
                    block_description: valueDescriptionBlock,
                    block_heading: affiliateProductTitle,
                    is_created_new: isCreatedNew,
                    product_group_maximum: productGroupMaximum,
                    using_frame: usingFrame,
                    frame_of_aff: frameData
                },
                style_attributes: {
                    style_display: styleProductDisplay,
                    item_on_row: styleGridProductDisplay
                }
            }));
        }
    }, [
        affiliateProductGroupData,
        affiliateProductTitle,
        seeMoreBtnContent,
        styleProductDisplay,
        styleGridProductDisplay,
        valueDescriptionBlock,
        isCreatedNew,
        productGroupMaximum,
        usingFrame,
        frameData, 
    ]);
    (0,react.useEffect)(function() {
        if (styleProductDisplay !== "grid" && styleProductDisplay !== "text-over-image") {
            setStyleGridProductDisplay(null);
        } else {
            if (!styleGridProductDisplay) {
                setStyleGridProductDisplay(configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO);
            }
        }
    }, [
        styleProductDisplay,
        styleGridProductDisplay
    ]);
    var isExistErrorProduct = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.some(function(group) {
        var ref, ref35;
        return group === null || group === void 0 ? void 0 : (ref = group.content_attributes) === null || ref === void 0 ? void 0 : (ref35 = ref.items) === null || ref35 === void 0 ? void 0 : ref35.some(function(item) {
            return !(item === null || item === void 0 ? void 0 : item.title);
        });
    });
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (seeMoreBtnContent && !defaultValueEditAffiliateProductGroup && !isExistErrorProduct) return false;
        return !(seeMoreBtnContent && !isExistErrorProduct && (JSON.stringify(affiliateProductGroupData) !== JSON.stringify(affiliateProductGroupArrDefault) || styleProductDisplay !== styleProductDisplayDefault || styleGridProductDisplay !== styleGridProductDisplayDefault || affiliateProductTitle !== affiliateProductTitleDefault || seeMoreBtnContent !== seeMoreBtnContentDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || usingFrame !== usingFrameDefault || frameData !== frameOfAffDefault));
    }, [
        affiliateProductGroupData,
        affiliateProductGroupArrDefault,
        styleProductDisplay,
        styleProductDisplayDefault,
        styleGridProductDisplay,
        styleGridProductDisplayDefault,
        affiliateProductTitle,
        affiliateProductTitleDefault,
        seeMoreBtnContent,
        seeMoreBtnContentDefault,
        valueDescriptionBlock,
        valueDescriptionBlockDefault,
        frameData,
        usingFrame,
        isExistErrorProduct, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(affiliateProductGroupData) !== JSON.stringify(affiliateProductGroupArrDefault) || styleProductDisplay !== styleProductDisplayDefault || styleGridProductDisplay !== styleGridProductDisplayDefault || affiliateProductTitle !== affiliateProductTitleDefault || seeMoreBtnContent !== seeMoreBtnContentDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || usingFrame !== usingFrameDefault || frameData !== frameOfAffDefault) {
            return true;
        } else return false;
    }, [
        affiliateProductGroupData,
        affiliateProductGroupArrDefault,
        styleProductDisplay,
        styleProductDisplayDefault,
        styleGridProductDisplay,
        styleGridProductDisplayDefault,
        affiliateProductTitle,
        affiliateProductTitleDefault,
        seeMoreBtnContent,
        seeMoreBtnContentDefault,
        valueDescriptionBlock,
        valueDescriptionBlockDefault,
        frameData,
        usingFrame, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var styleProductDisplayOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/afiliate-product-grid-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                id: elementId + "-" + configs_const/* PRODUCT_DISPLAY_STYLES.GRID */.y$.GRID,
                children: t("ss_builder_product_list_style_grid_label")
            }),
            value: configs_const/* PRODUCT_DISPLAY_STYLES.GRID */.y$.GRID
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/affiliate-product-slide-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                id: elementId + "-" + configs_const/* PRODUCT_DISPLAY_STYLES.SLIDE */.y$.SLIDE,
                children: t("ss_builder_product_list_style_slide_label")
            }),
            value: configs_const/* PRODUCT_DISPLAY_STYLES.SLIDE */.y$.SLIDE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/affiliate-product-text-over-image-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                id: elementId + "-" + configs_const/* PRODUCT_DISPLAY_STYLES.TEXT_OVER_IMAGE */.y$.TEXT_OVER_IMAGE,
                children: t("ss_builder_product_list_style_text_over_image_label")
            }),
            value: configs_const/* PRODUCT_DISPLAY_STYLES.TEXT_OVER_IMAGE */.y$.TEXT_OVER_IMAGE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/affiliate-product-zig-zag-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                id: elementId + "-" + configs_const/* PRODUCT_DISPLAY_STYLES.ZIGZAG */.y$.ZIGZAG,
                children: t("ss_builder_product_list_style_zig_zag_label")
            }),
            value: configs_const/* PRODUCT_DISPLAY_STYLES.ZIGZAG */.y$.ZIGZAG
        }, 
    ];
    var styleProductOnLineOptions = [
        {
            label: "1",
            value: configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE
        },
        {
            label: "2",
            value: configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO
        },
        {
            label: "3",
            value: configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE
        }, 
    ];
    var handleSelectStyleProductDisplay = function(arr) {
        if (arr && arr.length) {
            var valueStyle = arr[0];
            setStyleProductDisplay(valueStyle);
        }
    };
    var handleSelectStyleProductOnLineOptions = function(arr) {
        if (arr && arr.length) {
            var valueGridStyle = arr[0];
            setStyleGridProductDisplay(valueGridStyle);
        }
    };
    var handleChangeAffiliateProductTitle = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= BLOCK_HEADING_MAXIMUM) {
            setAffiliateProductTitle(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var handleChangeSeeMoreBtnContent = function(value) {
        if (seeMoreBtnContent.length <= 25) {
            setSeeMoreBtnContent(value);
        }
    };
    var handleUpdateAffiliateProductGroup = function(data) {
        setAffiliateProductGroupData(data);
    };
    var handleUploadProductFile = function(param) {
        var listProduct = param.listProduct, detectUrlList = param.detectUrlList, validUrlList = param.validUrlList;
        //set active group has first valid added item
        if ((listProduct === null || listProduct === void 0 ? void 0 : listProduct.length) && (validUrlList === null || validUrlList === void 0 ? void 0 : validUrlList.length)) {
            var activeUid = null;
            for(var key = 0; key < (listProduct === null || listProduct === void 0 ? void 0 : listProduct.length); key++){
                var ref, ref36;
                var items = (ref = listProduct[key]) === null || ref === void 0 ? void 0 : (ref36 = ref.content_attributes) === null || ref36 === void 0 ? void 0 : ref36.items;
                for(var keyItem = 0; keyItem < (items === null || items === void 0 ? void 0 : items.length); keyItem++){
                    if (items[keyItem].origin_link === validUrlList[0]) {
                        var ref37;
                        activeUid = (ref37 = listProduct[key]) === null || ref37 === void 0 ? void 0 : ref37.uid;
                        break;
                    }
                }
                if (activeUid) break;
            }
            if (activeUid) setActiveProductGroup(activeUid);
            setAffiliateProductGroupData(listProduct);
        }
        setDetectedUrlList(detectUrlList);
        setValidUrlList(validUrlList);
        setIsShowNoticeUpload(true);
    };
    var handleOpenSettingFrame = function(value) {
        setOpenSettingFrame(value);
    };
    var handleClickSaveFrame = function(useFrame, data) {
        setUsingFrame(useFrame);
        setFrameData(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* AffiliateContext.Provider */.X.Provider, {
        value: {
            frameData: frameData,
            usingFrame: usingFrame
        },
        children: [
            isShowNoticeUpload && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cursor-pointer",
                onClick: function() {
                    return setIsOpenDetectedUrlLists(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NoticeBar */.P8, {
                    extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                        className: "w-[18px] h-[18px]",
                        fillColor: "#389E0D"
                    }),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIconV3 */.BW, {
                        className: "w-[18px] h-[18px]",
                        fillColor: "#389E0D"
                    }),
                    content: t("ss_builder_multi_product_url_imported_label", {
                        successfullyUrlQuantity: validUrlList1 === null || validUrlList1 === void 0 ? void 0 : validUrlList1.length,
                        detectedUrlQuantity: detectedUrlList === null || detectedUrlList === void 0 ? void 0 : detectedUrlList.length
                    }),
                    style: {
                        "--background-color": "#D9F7BE",
                        "--text-color": "#389E0D",
                        "--border-color": "#D9F7BE"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_2 */.P9.STEP_2,
                className: classnames_default()(setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_2 */.P9.STEP_2, "bg-white px-4 py-[13px]"),
                ref: headingAreaRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_affiliate_product_group_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_affiliate_product_group_placeholder"),
                                onChange: handleChangeAffiliateProductTitle,
                                value: affiliateProductTitle,
                                maxLength: BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(affiliateProductTitle ? affiliateProductTitle.length : 0, "/").concat(BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_3 */.P9.STEP_3,
                        className: classnames_default()(setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_3 */.P9.STEP_3),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_affiliate_product_style_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoScrollSelector/* default */.Z, {
                                elementId: elementId,
                                options: styleProductDisplayOptions,
                                value: styleProductDisplay,
                                onChange: handleSelectStyleProductDisplay
                            }),
                            (styleProductDisplay === "grid" || styleProductDisplay === "text-over-image") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[15px] text-[#666666]",
                                                children: t("ss_builder_affiliate_product_quantity_on_row_title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                                options: styleProductOnLineOptions,
                                                value: [
                                                    styleGridProductDisplay
                                                ],
                                                onChange: handleSelectStyleProductOnLineOptions,
                                                columns: 3,
                                                style: {
                                                    "--border": "solid transparent 1px",
                                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_affiliate_product_btn_see_more_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: seeMoreBtnContent,
                                placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder"),
                                onChange: handleChangeSeeMoreBtnContent,
                                maxLength: 25
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3 p-3 bg-white flex justify-between cursor-pointer",
                onClick: function() {
                    return handleOpenSettingFrame(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FrameIcon */.ek, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[17px] leading-[22px] font-normal text-[#333333]",
                                children: t("ss_builder_frame_aff")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowIcon */.e0, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white px-4 pt-3 pb-3",
                        ref: stickyRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                            className: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_4 */.P9.STEP_4,
                            block: true,
                            color: "primary",
                            fill: "outline",
                            size: "middle",
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px"
                            },
                            onClick: function() {
                                return setIsOpenAddProductGroup(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PackageIcon */.jt, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: "#ee3244"
                                }),
                                t("ss_builder_affiliate_product_group_management_title")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_5 */.P9.STEP_5,
                        className: classnames_default()(setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_5 */.P9.STEP_5, "bg-white", !isOpenAffiliateSettingTour && "sticky z-10"),
                        style: {
                            borderBottom: "2px solid #eee",
                            top: !isOpenAffiliateSettingTour ? (block === null || block === void 0 ? void 0 : block.enable) === 1 ? 45 : 83 : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemScrollHorizontal/* default */.Z, {
                            children: affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AffiliateProductGroup_ProductGroupTabItemDetail, {
                                    item: item,
                                    onSelect: function(ele) {
                                        if (!openProductSelectionChecking) {
                                            setActiveProductGroup(item.uid);
                                            ele.scrollIntoView({
                                                block: "nearest",
                                                behavior: isClickAction ? "smooth" : "auto",
                                                inline: "center"
                                            });
                                        }
                                    },
                                    selected: activeProductGroup === (item === null || item === void 0 ? void 0 : item.uid),
                                    isDisabledSelection: openProductSelectionChecking,
                                    onClickAction: function() {
                                        return setIsClickAction(true);
                                    }
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListLayoutHandler/* default */.Z, {
                        affiliateProductGroupData: affiliateProductGroupData,
                        activeProductGroup: activeProductGroup,
                        onUpdateProductGroupData: function(data) {
                            return setAffiliateProductGroupData(data);
                        },
                        isSticky: isSticky,
                        productGroupMaximum: productGroupMaximum,
                        onCheckProductSelectionOpening: function(val) {
                            return setOpenProductSelectionChecking(val);
                        },
                        stickyTop: !isOpenAffiliateSettingTour ? (block === null || block === void 0 ? void 0 : block.enable) === 1 ? 86 : 124 : 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_ProductUploadFile, {
                isUploadProductFile: isUploadProductFile,
                onChange: handleUploadProductFile,
                affiliateProductGroupData: affiliateProductGroupData,
                isUploadProductFromSiteUrl: isUploadProductFromSiteUrl
            }),
            isOpenAddProdcutGroup && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddProdcutGroup,
                onMaskClick: function() {
                    return setIsOpenAddProductGroup(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_AffiliateProductGroupManagement, {
                    onCancelAffiliateProductGroupManagement: function() {
                        return setIsOpenAddProductGroup(false);
                    },
                    onUpdateAffiliateProductGroup: handleUpdateAffiliateProductGroup,
                    affiliateProductGroupData: affiliateProductGroupData,
                    productGroupMaximum: productGroupMaximum,
                    onActiveProductGroup: function(value) {
                        setActiveProductGroup(value);
                        setIsOpenAddProductGroup(false);
                        setIsClickAction(false);
                    }
                })
            }),
            isOpenDetectedUrlLists && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenDetectedUrlLists,
                onMaskClick: function() {
                    setIsOpenDetectedUrlLists(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetectedUrlLists/* default */.Z, {
                    onCancel: function() {
                        return setIsOpenDetectedUrlLists(false);
                    },
                    urlLists: detectedUrlList
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: openSettingFrame,
                onMaskClick: function() {
                    return setOpenSettingFrame(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Frame, {
                    triggerOpenClose: handleOpenSettingFrame,
                    handleClickSave: handleClickSaveFrame,
                    frameDefault: frameData,
                    usingFrameDefault: usingFrame
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_AffiliateProductGroup = (AffiliateProductGroup);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/features/block/libs/index.ts
var block_libs = __webpack_require__(22814);
// EXTERNAL MODULE: ./src/features/share/components/StickyChecking/index.tsx
var StickyChecking = __webpack_require__(22143);
// EXTERNAL MODULE: ./src/features/share/icons/social-network-icon-svg.tsx
var social_network_icon_svg = __webpack_require__(23110);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/SocialLinkSelectedIcon/index.tsx






var SocialLinkSelectedIcon = function(props) {
    var callbackCancelSelectedSocialLinkIcon = props.callbackCancelSelectedSocialLinkIcon, callbackConfirmSelectedSocialLinkIcon = props.callbackConfirmSelectedSocialLinkIcon, valueIconDefault = props.valueIconDefault;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(valueIconDefault), valueIcon = ref[0], setValueIcon = ref[1];
    var handleCancelSelectedSocialLinkIcon = function() {
        callbackCancelSelectedSocialLinkIcon();
    };
    var listSocialLinkIconOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* FacebookIcon */.Vq, {
                className: "align-middle inline-block"
            }),
            description: "Facebook",
            value: configs_const/* SOCIAL_LINK.FACEBOOK */.Xv.FACEBOOK
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* MessengerIcon */.qA, {
                className: "align-middle inline-block"
            }),
            description: "Messenger",
            value: configs_const/* SOCIAL_LINK.MESSENGER */.Xv.MESSENGER
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* InstagramIcon */.yu, {
                className: "align-middle inline-block"
            }),
            description: "Instagram",
            value: configs_const/* SOCIAL_LINK.INSTAGRAM */.Xv.INSTAGRAM
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LinkedInIcon */.nI, {
                className: "align-middle inline-block"
            }),
            description: "LinkedIn",
            value: configs_const/* SOCIAL_LINK.LINKEDIN */.Xv.LINKEDIN
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* PinterestIcon */.cH, {
                className: "align-middle inline-block"
            }),
            description: "Pinterest",
            value: configs_const/* SOCIAL_LINK.PINTEREST */.Xv.PINTEREST
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* SnapchatIcon */.Zr, {
                className: "align-middle inline-block"
            }),
            description: "Snapchat",
            value: configs_const/* SOCIAL_LINK.SNAPCHAT */.Xv.SNAPCHAT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LineChatIcon */.uG, {
                className: "align-middle inline-block"
            }),
            description: "Line Chat",
            value: configs_const/* SOCIAL_LINK.LINECHAT */.Xv.LINECHAT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TiktokIcon */.bF, {
                className: "align-middle inline-block"
            }),
            description: "Tiktok",
            value: configs_const/* SOCIAL_LINK.TIKTOK */.Xv.TIKTOK
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitchIcon */.jG, {
                className: "align-middle inline-block"
            }),
            description: "Twitch",
            value: configs_const/* SOCIAL_LINK.TWITCH */.Xv.TWITCH
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitterIcon */.Zm, {
                className: "align-middle inline-block"
            }),
            description: "Twitter",
            value: configs_const/* SOCIAL_LINK.TWITTER */.Xv.TWITTER
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* WhatsappIcon */.ud, {
                className: "align-middle inline-block"
            }),
            description: "WhatsApp",
            value: configs_const/* SOCIAL_LINK.WHATSAPP */.Xv.WHATSAPP
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* YoutubeIcon */.LK, {
                className: "align-middle inline-block"
            }),
            description: "Youtube",
            value: configs_const/* SOCIAL_LINK.YOUTUBE */.Xv.YOUTUBE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DiscordIcon */.D7, {
                className: "align-middle inline-block"
            }),
            description: "Discord",
            value: configs_const/* SOCIAL_LINK.DISCORD */.Xv.DISCORD
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* BehanceIcon */.wE, {
                className: "align-middle inline-block"
            }),
            description: "Behance",
            value: configs_const/* SOCIAL_LINK.BEHANCE */.Xv.BEHANCE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DribbleIcon */.Ir, {
                className: "align-middle inline-block"
            }),
            description: "Dribble",
            value: configs_const/* SOCIAL_LINK.DRIBBLE */.Xv.DRIBBLE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* EmailIcon */.LQ, {
                className: "align-middle inline-block"
            }),
            description: "Email",
            value: configs_const/* SOCIAL_LINK.EMAIL */.Xv.EMAIL
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TelIcon */.lj, {
                className: "align-middle inline-block w-[32px] h-[32px]"
            }),
            description: "Tel",
            value: configs_const/* SOCIAL_LINK.TEL */.Xv.TEL
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* Lemon8Icon */.UI, {
                className: "align-middle inline-block w-[32px] h-[32px]"
            }),
            description: "Lemon8",
            value: configs_const/* SOCIAL_LINK.LEMON8 */.Xv.LEMON8
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {
                className: "align-middle inline-block"
            }),
            description: "Other",
            value: configs_const/* SOCIAL_LINK.OTHER */.Xv.OTHER
        }, 
    ];
    var handleSelectedSocialLinkIcon = function(value) {
        var socialLinkIconType = value[0];
        setValueIcon(socialLinkIconType);
        callbackConfirmSelectedSocialLinkIcon(socialLinkIconType);
        callbackCancelSelectedSocialLinkIcon();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-3 max-h-full overflow-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                columns: 4,
                options: listSocialLinkIconOptions,
                onChange: handleSelectedSocialLinkIcon,
                value: [
                    valueIcon
                ],
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    "--checked-color": "#fff",
                    "--padding": "8px"
                },
                className: "selector-social-link"
            })
        })
    });
};
/* harmony default export */ var Bio_SocialLinkSelectedIcon = (SocialLinkSelectedIcon);

// EXTERNAL MODULE: ./src/features/share/components/ButtonConfirmPopup/index.tsx
var ButtonConfirmPopup = __webpack_require__(85558);
// EXTERNAL MODULE: ./src/features/block/components/FormInput/index.tsx
var FormInput = __webpack_require__(56751);
// EXTERNAL MODULE: ./src/features/block/components/LinkInput/index.tsx + 2 modules
var LinkInput = __webpack_require__(86293);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/SocialLinkAddNew/index.tsx
function SocialLinkAddNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SocialLinkAddNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SocialLinkAddNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var socialLinkAddNew = function(props) {
    var callbackCancelSocialLinkAddNew = props.callbackCancelSocialLinkAddNew, callbackConfirmSocialLinkAddNew = props.callbackConfirmSocialLinkAddNew, socialLinkEditData = props.socialLinkEditData;
    var valueLinkDefault = socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.url;
    var valueIconDefault = socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.icon;
    var defaultLinkData = (socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: valueLinkDefault
    };
    var UID = "social-network-".concat((0,v4/* default */.Z)());
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var hasAffiliateUrlDefault = (socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.use_aff_url) ? !!((socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.use_aff_url) === 1) : false;
    var openInNewTabDefault = socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.open_new_tab;
    var ref = (0,react.useState)(valueLinkDefault), valueLink = ref[0], setValueLink = ref[1];
    var ref1 = (0,react.useState)(valueIconDefault), valueIcon = ref1[0], setValueIcon = ref1[1];
    var ref2 = (0,react.useState)(false), isDisableBtnSave = ref2[0], setIsDisableBtnSave = ref2[1];
    var ref3 = (0,react.useState)(false), isLoadingBtn = ref3[0], setIsLoadingBtn = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenSelectedSocialLinkIcon = ref4[0], setIsOpenSelectedSocialLinkIcon = ref4[1];
    var ref5 = (0,react.useState)(false), isValidUrl = ref5[0], setIsValidUrl = ref5[1];
    var ref6 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref6[0], setHasAffiliateUrl = ref6[1];
    var ref7 = (0,react.useState)(defaultLinkData), linkData1 = ref7[0], setLinkData = ref7[1];
    var ref8 = (0,react.useState)(false), isEcommerce = ref8[0], setIsEcommerce = ref8[1];
    var ref9 = (0,react.useState)(openInNewTabDefault), openNewTab = ref9[0], setOpenNewTab = ref9[1];
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var checkEcomerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var handleConfirmAddNewTab = function() {
        var defaultSocialLinkData = {
            uid: UID,
            url: valueLink,
            icon: valueIcon,
            sort_order: 1,
            enable: 1,
            // use_aff_url:
            //   hasAffiliateUrl && linkData.type === LinkTypeEnum.WEB ? 1 : 2,
            link_data: linkData1,
            open_new_tab: isEcommerce ? true : openNewTab
        };
        if (socialLinkEditData) {
            callbackConfirmSocialLinkAddNew(SocialLinkAddNew_objectSpread({}, socialLinkEditData, {
                uid: (socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.uid) || UID,
                url: valueLink,
                icon: valueIcon,
                // use_aff_url:
                //   hasAffiliateUrl && linkData.type === LinkTypeEnum.WEB ? 1 : 2,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            }));
        } else callbackConfirmSocialLinkAddNew(defaultSocialLinkData);
        handleCancelSocialLinkAddNew();
    };
    var handleCancelSocialLinkAddNew = function() {
        callbackCancelSocialLinkAddNew();
    };
    var handleOpenSelectedSocialLinkIcon = function() {
        setIsOpenSelectedSocialLinkIcon(true);
    };
    var isEnableConfirmAddNewsocialLink = (0,react.useMemo)(function() {
        if ((valueLink || linkData1.value) && !isDisableBtnSave && valueIcon && !isValidUrl && (valueIcon !== valueIconDefault || valueLink !== valueLinkDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || openNewTab !== openInNewTabDefault)) {
            return true;
        }
        return false;
    }, [
        valueLink,
        valueIcon,
        valueIconDefault,
        valueLinkDefault,
        isValidUrl,
        isDisableBtnSave,
        defaultLinkData,
        linkData1,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        openNewTab,
        openInNewTabDefault, 
    ]);
    var handleSelectedSocialLinkIcon = function(socialLinkIconType) {
        setValueIcon(socialLinkIconType);
    };
    var handleCancelSelectedSocialLinkIcon = function() {
        setIsOpenSelectedSocialLinkIcon(false);
    };
    var handleChangeOriginUrl = function(value) {
        var isCheckUrl = (0,lib/* validURL */.b3)(value);
        if (isCheckUrl) {
            setIsValidUrl(false);
        } else {
            setIsValidUrl(true);
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcomerce(linkData1.value);
        } else if (socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.url) checkEcomerce(socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.url);
    }, [
        socialLinkEditData === null || socialLinkEditData === void 0 ? void 0 : socialLinkEditData.url,
        linkData1
    ]);
    var SocialLinkIconRender = function(data) {
        var type = data.valueIcon;
        var element = null;
        switch(type){
            case configs_const/* SOCIAL_LINK.FACEBOOK */.Xv.FACEBOOK:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* FacebookIcon */.Vq, {});
                break;
            case configs_const/* SOCIAL_LINK.MESSENGER */.Xv.MESSENGER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* MessengerIcon */.qA, {});
                break;
            case configs_const/* SOCIAL_LINK.INSTAGRAM */.Xv.INSTAGRAM:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* InstagramIcon */.yu, {});
                break;
            case configs_const/* SOCIAL_LINK.LINKEDIN */.Xv.LINKEDIN:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LinkedInIcon */.nI, {});
                break;
            case configs_const/* SOCIAL_LINK.SNAPCHAT */.Xv.SNAPCHAT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* SnapchatIcon */.Zr, {});
                break;
            case configs_const/* SOCIAL_LINK.LINECHAT */.Xv.LINECHAT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LineChatIcon */.uG, {});
                break;
            case configs_const/* SOCIAL_LINK.YOUTUBE */.Xv.YOUTUBE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* YoutubeIcon */.LK, {});
                break;
            case configs_const/* SOCIAL_LINK.TIKTOK */.Xv.TIKTOK:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TiktokIcon */.bF, {});
                break;
            case configs_const/* SOCIAL_LINK.TWITCH */.Xv.TWITCH:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitchIcon */.jG, {});
                break;
            case configs_const/* SOCIAL_LINK.TWITTER */.Xv.TWITTER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitterIcon */.Zm, {});
                break;
            case configs_const/* SOCIAL_LINK.WHATSAPP */.Xv.WHATSAPP:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* WhatsappIcon */.ud, {});
                break;
            case configs_const/* SOCIAL_LINK.DISCORD */.Xv.DISCORD:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DiscordIcon */.D7, {});
                break;
            case configs_const/* SOCIAL_LINK.BEHANCE */.Xv.BEHANCE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* BehanceIcon */.wE, {});
                break;
            case configs_const/* SOCIAL_LINK.DRIBBLE */.Xv.DRIBBLE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DribbleIcon */.Ir, {});
                break;
            case configs_const/* SOCIAL_LINK.PINTEREST */.Xv.PINTEREST:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* PinterestIcon */.cH, {});
                break;
            case configs_const/* SOCIAL_LINK.EMAIL */.Xv.EMAIL:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* EmailIcon */.LQ, {});
                break;
            case configs_const/* SOCIAL_LINK.TEL */.Xv.TEL:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TelIcon */.lj, {});
                break;
            case configs_const/* SOCIAL_LINK.LEMON8 */.Xv.LEMON8:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* Lemon8Icon */.UI, {});
                break;
            case configs_const/* SOCIAL_LINK.OTHER */.Xv.OTHER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {});
                break;
            default:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconDefault */.QL, {
                    className: "",
                    fillColor: "#333",
                    width: 24,
                    height: 24
                });
        }
        return element;
    };
    var onUpdateLinkData = function(linkData) {
        if (linkData.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setValueLink(linkData.value);
        } else {
            setValueLink(null);
        }
        setLinkData(linkData);
    };
    (0,react.useEffect)(function() {
        setIsDisableBtnSave(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setIsLoadingBtn(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsDisableBtnSave,
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-3",
                        style: {
                            borderTop: "1px solid #EEEEEE"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                label: t("ss_builder_button_link_icon_origin_url_label"),
                                isRequire: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                    item: linkData1,
                                    onChange: function(item) {
                                        onUpdateLinkData(item);
                                    },
                                    onLoading: onAffLoading,
                                    onError: function(errorMessage) {
                                        setIsValidUrl(!!errorMessage);
                                    },
                                    getPopupRef: function() {
                                        return null;
                                    },
                                    isHiddenService: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_bio_social_link_icon_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        style: {
                                            backgroundColor: "#F0F0F0",
                                            border: "none"
                                        },
                                        onClick: handleOpenSelectedSocialLinkIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinkIconRender, {
                                            valueIcon: valueIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row items-center gap-2 grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            block: true,
                                            size: "middle",
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "5px"
                                            },
                                            onClick: handleOpenSelectedSocialLinkIcon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[17px] leading-6",
                                                children: t("ss_builder_bio_social_link_btn_select_icon_label")
                                            })
                                        })
                                    })
                                ]
                            }),
                            linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                icon: function(checked) {
                                                    return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsChecked */.z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsNotChecked */.VP, {});
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                        onConfirm: isEnableConfirmAddNewsocialLink ? handleConfirmAddNewTab : function() {},
                        isDisable: !isEnableConfirmAddNewsocialLink,
                        loading: isLoadingBtn
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSelectedSocialLinkIcon,
                onMaskClick: function() {
                    return handleCancelSelectedSocialLinkIcon();
                },
                title: t("ss_builder_panel_add_icon_tab_title"),
                onClose: function() {
                    return handleCancelSelectedSocialLinkIcon();
                },
                classNameBody: "h-[60vh] popup-hard popup-hard-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio_SocialLinkSelectedIcon, {
                    callbackCancelSelectedSocialLinkIcon: handleCancelSelectedSocialLinkIcon,
                    callbackConfirmSelectedSocialLinkIcon: handleSelectedSocialLinkIcon,
                    valueIconDefault: valueIcon
                })
            })
        ]
    });
};
/* harmony default export */ var SocialLinkAddNew = (socialLinkAddNew);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/SocialLinkItems/index.tsx








var socialLinkItems = function(props) {
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var index = props.index, socialLinkData = props.socialLinkData, onRemoveItem = props.onRemoveItem, onDisableEnableSocialLink = props.onDisableEnableSocialLink, callbackOpenEditSocialLink = props.callbackOpenEditSocialLink;
    var isEnable = !!(socialLinkData && socialLinkData.enable === 1);
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: "eye-visible-social-network",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_social_link_label") : t("ss_builder_hide_social_link_label")
        },
        {
            key: "delete-social-network",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_social_link_label")
        }, 
    ];
    var MoreElement = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: actions,
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-social-network":
                handleEnableDisableSocialLink();
                break;
            case "delete-social-network":
                confirmRemoveSocialLink();
                break;
            default:
        }
    };
    var confirmRemoveSocialLink = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_social_link_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_social_link_content")
            }),
            confirmText: t("ss_builder_delete_social_link_btn_label"),
            cancelText: t("ss_builder_cancel-delete_social_link_btn_label"),
            onConfirm: function() {
                onRemoveItem(index);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_social_link_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleEditImage = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditSocialLink(socialLinkData);
    };
    var handleEnableDisableSocialLink = function() {
        var socialLinkStatus = !isEnable ? 1 : 2;
        onDisableEnableSocialLink(index, socialLinkStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_social_link_successfully_label") : t("ss_builder_enable_social_link_successfully_label")
            })
        });
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var SocialLinkIconRender = (0,react.useCallback)(function(data) {
        var type = data.valueIcon;
        var element = null;
        switch(type){
            case configs_const/* SOCIAL_LINK.FACEBOOK */.Xv.FACEBOOK:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* FacebookIcon */.Vq, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.MESSENGER */.Xv.MESSENGER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* MessengerIcon */.qA, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.INSTAGRAM */.Xv.INSTAGRAM:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* InstagramIcon */.yu, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.LINKEDIN */.Xv.LINKEDIN:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LinkedInIcon */.nI, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.SNAPCHAT */.Xv.SNAPCHAT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* SnapchatIcon */.Zr, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.LINECHAT */.Xv.LINECHAT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LineChatIcon */.uG, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.YOUTUBE */.Xv.YOUTUBE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* YoutubeIcon */.LK, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.TIKTOK */.Xv.TIKTOK:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TiktokIcon */.bF, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.TWITCH */.Xv.TWITCH:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitchIcon */.jG, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.TWITTER */.Xv.TWITTER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitterIcon */.Zm, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.WHATSAPP */.Xv.WHATSAPP:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* WhatsappIcon */.ud, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.DISCORD */.Xv.DISCORD:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DiscordIcon */.D7, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.BEHANCE */.Xv.BEHANCE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* BehanceIcon */.wE, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.DRIBBLE */.Xv.DRIBBLE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DribbleIcon */.Ir, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.PINTEREST */.Xv.PINTEREST:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* PinterestIcon */.cH, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.EMAIL */.Xv.EMAIL:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* EmailIcon */.LQ, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.TEL */.Xv.TEL:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TelIcon */.lj, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.LEMON8 */.Xv.LEMON8:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* Lemon8Icon */.UI, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            case configs_const/* SOCIAL_LINK.OTHER */.Xv.OTHER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {
                    className: "w-8 h-8 rounded-lg"
                });
                break;
            default:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {
                    className: "w-8 h-8 rounded-lg"
                });
        }
        return element;
    }, []);
    var linkDatavalue = socialLinkData.url || (socialLinkData === null || socialLinkData === void 0 ? void 0 : (ref = socialLinkData.link_data) === null || ref === void 0 ? void 0 : ref.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {}),
                onClick: handleEditImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinkIconRender, {
                            valueIcon: socialLinkData.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                    children: socialLinkData.icon && typeof socialLinkData.icon === "string" && socialLinkData.icon.charAt(0).toUpperCase() + socialLinkData.icon.slice(1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex",
                                    style: {
                                        marginTop: "2px"
                                    },
                                    children: (socialLinkData === null || socialLinkData === void 0 ? void 0 : socialLinkData.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                children: t("ss_builder_product_link_wrapped_label")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-xs leading-4 font-normal text-[#8C8C8C] text-ellipsis whitespace-nowrap overflow-hidden",
                                        children: linkDatavalue
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var SocialLinkItems = (socialLinkItems);

// EXTERNAL MODULE: ./src/features/share/components/PlaceholderCustomDragging/index.tsx
var PlaceholderCustomDragging = __webpack_require__(14120);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/SocialLinkList/index.tsx
function SocialLinkList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SocialLinkList_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SocialLinkList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SocialLinkList_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SocialLinkList_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SocialLinkList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SocialLinkList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SocialLinkList_slicedToArray(arr, i) {
    return SocialLinkList_arrayWithHoles(arr) || SocialLinkList_iterableToArrayLimit(arr, i) || SocialLinkList_unsupportedIterableToArray(arr, i) || SocialLinkList_nonIterableRest();
}
function SocialLinkList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SocialLinkList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SocialLinkList_arrayLikeToArray(o, minLen);
}


















var socialLinkList = function(props) {
    var socialLinkListSortOrder = props.socialLinkListSortOrder, callBackUpdateSocialLinkItems = props.callBackUpdateSocialLinkItems;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref3 = (0,react.useState)({}), placeholderProps1 = ref3[0], setPlaceholderProps = ref3[1];
    var ref1 = (0,react.useState)(false), isOpenSocialLinkAddNew = ref1[0], setIsOpenSocialLinkAddNew = ref1[1];
    var ref2 = (0,react.useState)(null), socialLinkEditData = ref2[0], setSocialLinkEditData = ref2[1];
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(socialLinkListSortOrder);
        var ref = SocialLinkList_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return SocialLinkList_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        callBackUpdateSocialLinkItems(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var handleOpenAddSocialLink = function() {
        setIsOpenSocialLinkAddNew(true);
    };
    var onRemoveItem = function(index) {
        var socialLinkListClone = cloneDeep_default()(socialLinkListSortOrder);
        var newItems = socialLinkListClone && Array.isArray(socialLinkListClone) && socialLinkListClone.filter(function(ele, idx) {
            return idx !== index;
        });
        callBackUpdateSocialLinkItems(newItems);
    };
    var onDisableEnableSocialLink = function(index, socialLinkStatus) {
        var socialLinkListClone = cloneDeep_default()(socialLinkListSortOrder);
        var newItems = socialLinkListClone && Array.isArray(socialLinkListClone) && socialLinkListClone.map(function(ele, idx) {
            return idx === index ? SocialLinkList_objectSpread({}, ele, {
                enable: socialLinkStatus
            }) : ele;
        });
        callBackUpdateSocialLinkItems(newItems);
    };
    var handleConfirmSocialLinkAddNew = function(data) {
        var indexItemEdit = socialLinkListSortOrder && socialLinkListSortOrder.findIndex(function(x) {
            return x.uid === data.uid;
        });
        var newSocialLinkArr = cloneDeep_default()(socialLinkListSortOrder);
        if (indexItemEdit >= 0) {
            newSocialLinkArr[indexItemEdit] = data;
            callBackUpdateSocialLinkItems(newSocialLinkArr);
        } else {
            newSocialLinkArr.push(data);
            var newSocialLinkReSortOrder = newSocialLinkArr.map(function(ele, idx) {
                return SocialLinkList_objectSpread({}, ele, {
                    sort_order: idx + 1
                });
            });
            callBackUpdateSocialLinkItems(newSocialLinkReSortOrder);
            var index = newSocialLinkReSortOrder === null || newSocialLinkReSortOrder === void 0 ? void 0 : newSocialLinkReSortOrder.findIndex(function(x) {
                return x.uid === (data === null || data === void 0 ? void 0 : data.uid);
            });
            (0,block_libs/* scrollToNewItem */.i)("bio-".concat(data === null || data === void 0 ? void 0 : data.uid, "-").concat(index));
        }
    };
    var handleOpenEditSocialLink = function(data) {
        setIsOpenSocialLinkAddNew(true);
        setSocialLinkEditData(data);
    };
    var handleCancelSocialLinkAddNew = function() {
        setIsOpenSocialLinkAddNew(false);
        setSocialLinkEditData(null);
    };
    var socialLinkRate = (0,react.useMemo)(function() {
        return socialLinkListSortOrder && "".concat(socialLinkListSortOrder.length, "/").concat(configs_const/* social_link_MAX */.Wu);
    }, [
        socialLinkListSortOrder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-bio-editor-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between px-3 py-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666]",
                                        children: t("ss_builder_social_links_list_title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-grow justify-end gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                        size: "small",
                                        fill: "solid",
                                        color: "primary",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "3px 12px 3px 12px"
                                        },
                                        onClick: handleOpenAddSocialLink,
                                        disabled: socialLinkListSortOrder.length === configs_const/* social_link_MAX */.Wu,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                className: "w-[15px] h-[15px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_add_new_label")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: socialLinkRate
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    (socialLinkListSortOrder === null || socialLinkListSortOrder === void 0 ? void 0 : socialLinkListSortOrder.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                            onDragEnd: onDragEnd,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                droppableId: "blocks-".concat(BLOCK_TYPE.BIO),
                                children: function(provided1, snapshot1) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", SocialLinkList_objectSpread({}, provided1.droppableProps, {
                                        ref: provided1.innerRef,
                                        className: "relative",
                                        children: [
                                            socialLinkListSortOrder === null || socialLinkListSortOrder === void 0 ? void 0 : socialLinkListSortOrder.map(function(ele, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                    draggableId: (ele === null || ele === void 0 ? void 0 : ele.uid) ? "bio-".concat(ele === null || ele === void 0 ? void 0 : ele.uid, "-").concat(index) : "bio-".concat(ele === null || ele === void 0 ? void 0 : ele.id, "-").concat(index),
                                                    index: index,
                                                    children: function(provided, snapshot) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", SocialLinkList_objectSpread({
                                                            ref: provided.innerRef
                                                        }, provided.draggableProps, provided.dragHandleProps, {
                                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinkItems, {
                                                                index: index,
                                                                socialLinkData: ele,
                                                                onRemoveItem: onRemoveItem,
                                                                onDisableEnableSocialLink: onDisableEnableSocialLink,
                                                                callbackOpenEditSocialLink: handleOpenEditSocialLink
                                                            })
                                                        }));
                                                    }
                                                }, (ele === null || ele === void 0 ? void 0 : ele.uid) ? "bio-".concat(ele === null || ele === void 0 ? void 0 : ele.uid, "-").concat(index) : "bio-".concat(ele === null || ele === void 0 ? void 0 : ele.id, "-").concat(index));
                                            }),
                                            provided1.placeholder,
                                            !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                placeholderProps: placeholderProps1,
                                                content: t("ss_builder_placeholder_dragging_content"),
                                                style: {
                                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                    border: "1px dashed #1890FF",
                                                    borderRadius: "4px",
                                                    color: "#1890FF"
                                                }
                                            })
                                        ]
                                    }));
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShareIcon */.jN, {
                                    className: "align-middle w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: t("ss_builder_empty_social_link_list_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: t("ss_builder_empty_social_link_list_content")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSocialLinkAddNew,
                onMaskClick: function() {
                    return handleCancelSocialLinkAddNew();
                },
                title: t("ss_builder_bio_add_social_link_title"),
                onClose: function() {
                    return handleCancelSocialLinkAddNew();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinkAddNew, {
                    callbackCancelSocialLinkAddNew: handleCancelSocialLinkAddNew,
                    callbackConfirmSocialLinkAddNew: handleConfirmSocialLinkAddNew,
                    socialLinkEditData: socialLinkEditData
                })
            })
        ]
    });
};
/* harmony default export */ var SocialLinkList = (socialLinkList);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/components/EditorPropTypes.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var eventPropTypes = {
    onActivate: prop_types.func,
    onAddUndo: prop_types.func,
    onBeforeAddUndo: prop_types.func,
    onBeforeExecCommand: prop_types.func,
    onBeforeGetContent: prop_types.func,
    onBeforeRenderUI: prop_types.func,
    onBeforeSetContent: prop_types.func,
    onBeforePaste: prop_types.func,
    onBlur: prop_types.func,
    onChange: prop_types.func,
    onClearUndos: prop_types.func,
    onClick: prop_types.func,
    onContextMenu: prop_types.func,
    onCommentChange: prop_types.func,
    onCopy: prop_types.func,
    onCut: prop_types.func,
    onDblclick: prop_types.func,
    onDeactivate: prop_types.func,
    onDirty: prop_types.func,
    onDrag: prop_types.func,
    onDragDrop: prop_types.func,
    onDragEnd: prop_types.func,
    onDragGesture: prop_types.func,
    onDragOver: prop_types.func,
    onDrop: prop_types.func,
    onExecCommand: prop_types.func,
    onFocus: prop_types.func,
    onFocusIn: prop_types.func,
    onFocusOut: prop_types.func,
    onGetContent: prop_types.func,
    onHide: prop_types.func,
    onInit: prop_types.func,
    onKeyDown: prop_types.func,
    onKeyPress: prop_types.func,
    onKeyUp: prop_types.func,
    onLoadContent: prop_types.func,
    onMouseDown: prop_types.func,
    onMouseEnter: prop_types.func,
    onMouseLeave: prop_types.func,
    onMouseMove: prop_types.func,
    onMouseOut: prop_types.func,
    onMouseOver: prop_types.func,
    onMouseUp: prop_types.func,
    onNodeChange: prop_types.func,
    onObjectResizeStart: prop_types.func,
    onObjectResized: prop_types.func,
    onObjectSelected: prop_types.func,
    onPaste: prop_types.func,
    onPostProcess: prop_types.func,
    onPostRender: prop_types.func,
    onPreProcess: prop_types.func,
    onProgressState: prop_types.func,
    onRedo: prop_types.func,
    onRemove: prop_types.func,
    onReset: prop_types.func,
    onSaveContent: prop_types.func,
    onSelectionChange: prop_types.func,
    onSetAttrib: prop_types.func,
    onSetContent: prop_types.func,
    onShow: prop_types.func,
    onSubmit: prop_types.func,
    onUndo: prop_types.func,
    onVisualAid: prop_types.func,
    onSkinLoadError: prop_types.func,
    onThemeLoadError: prop_types.func,
    onModelLoadError: prop_types.func,
    onPluginLoadError: prop_types.func,
    onIconsLoadError: prop_types.func,
    onLanguageLoadError: prop_types.func,
    onScriptsLoad: prop_types.func,
    onScriptsLoadError: prop_types.func,
};
var EditorPropTypes = __assign({ apiKey: prop_types.string, id: prop_types.string, inline: prop_types.bool, init: prop_types.object, initialValue: prop_types.string, onEditorChange: prop_types.func, value: prop_types.string, tagName: prop_types.string, cloudChannel: prop_types.string, plugins: prop_types.oneOfType([prop_types.string, prop_types.array]), toolbar: prop_types.oneOfType([prop_types.string, prop_types.array]), disabled: prop_types.bool, textareaName: prop_types.string, tinymceScriptSrc: prop_types.oneOfType([
        prop_types.string,
        prop_types.arrayOf(prop_types.string),
        prop_types.arrayOf(prop_types.shape({
            src: prop_types.string,
            async: prop_types.bool,
            defer: prop_types.bool
        }))
    ]), rollback: prop_types.oneOfType([prop_types.number, prop_types.oneOf([false])]), scriptLoading: prop_types.shape({
        async: prop_types.bool,
        defer: prop_types.bool,
        delay: prop_types.number
    }) }, eventPropTypes);

;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/Utils.js

var isFunction = function (x) { return typeof x === 'function'; };
var isEventProp = function (name) { return name in eventPropTypes; };
var eventAttrToEventName = function (attrName) { return attrName.substr(2); };
var configHandlers2 = function (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
    var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
    var currEventKeys = Object.keys(props).filter(isEventProp);
    var removedKeys = prevEventKeys.filter(function (key) { return props[key] === undefined; });
    var addedKeys = currEventKeys.filter(function (key) { return prevProps[key] === undefined; });
    removedKeys.forEach(function (key) {
        // remove event handler
        var eventName = eventAttrToEventName(key);
        var wrappedHandler = boundHandlers[eventName];
        off(eventName, wrappedHandler);
        delete boundHandlers[eventName];
    });
    addedKeys.forEach(function (key) {
        var wrappedHandler = adapter(handlerLookup, key);
        var eventName = eventAttrToEventName(key);
        boundHandlers[eventName] = wrappedHandler;
        on(eventName, wrappedHandler);
    });
};
var configHandlers = function (editor, prevProps, props, boundHandlers, lookup) {
    return configHandlers2(lookup, editor.on.bind(editor), editor.off.bind(editor), 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    function (handlerLookup, key) { return function (e) { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }; }, prevProps, props, boundHandlers);
};
var unique = 0;
var uuid = function (prefix) {
    var time = Date.now();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
var isTextareaOrInput = function (element) {
    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
// eslint-disable-next-line max-len
var mergePlugins = function (initPlugins, inputPlugins) { return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins)); };
var isBeforeInputEventAvailable = function () { return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function'; };
var isInDoc = function (elem) {
    if (!('isConnected' in Node.prototype)) {
        // Fallback for IE and old Edge
        var current = elem;
        var parent_1 = elem.parentNode;
        while (parent_1 != null) {
            current = parent_1;
            parent_1 = current.parentNode;
        }
        return current === elem.ownerDocument;
    }
    return elem.isConnected;
};
var setMode = function (editor, mode) {
    if (editor !== undefined) {
        if (editor.mode != null && typeof editor.mode === 'object' && typeof editor.mode.set === 'function') {
            editor.mode.set(mode);
        }
        else { // support TinyMCE 4
            editor.setMode(mode);
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/ScriptLoader2.js
var ScriptLoader2_assign = (undefined && undefined.__assign) || function () {
    ScriptLoader2_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ScriptLoader2_assign.apply(this, arguments);
};

var injectScriptTag = function (doc, item, handler) {
    var _a, _b;
    var scriptTag = doc.createElement('script');
    scriptTag.referrerPolicy = 'origin';
    scriptTag.type = 'application/javascript';
    scriptTag.id = item.id;
    scriptTag.src = item.src;
    scriptTag.async = (_a = item.async) !== null && _a !== void 0 ? _a : false;
    scriptTag.defer = (_b = item.defer) !== null && _b !== void 0 ? _b : false;
    var loadHandler = function () {
        scriptTag.removeEventListener('load', loadHandler);
        scriptTag.removeEventListener('error', errorHandler);
        handler(item.src);
    };
    var errorHandler = function (err) {
        scriptTag.removeEventListener('load', loadHandler);
        scriptTag.removeEventListener('error', errorHandler);
        handler(item.src, err);
    };
    scriptTag.addEventListener('load', loadHandler);
    scriptTag.addEventListener('error', errorHandler);
    if (doc.head) {
        doc.head.appendChild(scriptTag);
    }
};
var createDocumentScriptLoader = function (doc) {
    var lookup = {};
    var scriptLoadOrErrorHandler = function (src, err) {
        var item = lookup[src];
        item.done = true;
        item.error = err;
        for (var _i = 0, _a = item.handlers; _i < _a.length; _i++) {
            var h = _a[_i];
            h(src, err);
        }
        item.handlers = [];
    };
    var loadScripts = function (items, success, failure) {
        // eslint-disable-next-line no-console
        var failureOrLog = function (err) { return failure !== undefined ? failure(err) : console.error(err); };
        if (items.length === 0) {
            failureOrLog(new Error('At least one script must be provided'));
            return;
        }
        var successCount = 0;
        var failed = false;
        var loaded = function (_src, err) {
            if (failed) {
                return;
            }
            if (err) {
                failed = true;
                failureOrLog(err);
            }
            else if (++successCount === items.length) {
                success();
            }
        };
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var existing = lookup[item.src];
            if (existing) {
                if (existing.done) {
                    loaded(item.src, existing.error);
                }
                else {
                    existing.handlers.push(loaded);
                }
            }
            else {
                // create a new entry
                var id = uuid('tiny-');
                lookup[item.src] = {
                    id: id,
                    src: item.src,
                    done: false,
                    error: null,
                    handlers: [loaded],
                };
                injectScriptTag(doc, ScriptLoader2_assign({ id: id }, item), scriptLoadOrErrorHandler);
            }
        }
    };
    var deleteScripts = function () {
        var _a;
        for (var _i = 0, _b = Object.values(lookup); _i < _b.length; _i++) {
            var item = _b[_i];
            var scriptTag = doc.getElementById(item.id);
            if (scriptTag != null && scriptTag.tagName === 'SCRIPT') {
                (_a = scriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(scriptTag);
            }
        }
        lookup = {};
    };
    var getDocument = function () { return doc; };
    return {
        loadScripts: loadScripts,
        deleteScripts: deleteScripts,
        getDocument: getDocument
    };
};
var createScriptLoader = function () {
    var cache = [];
    var getDocumentScriptLoader = function (doc) {
        var loader = cache.find(function (l) { return l.getDocument() === doc; });
        if (loader === undefined) {
            loader = createDocumentScriptLoader(doc);
            cache.push(loader);
        }
        return loader;
    };
    var loadList = function (doc, items, delay, success, failure) {
        var doLoad = function () { return getDocumentScriptLoader(doc).loadScripts(items, success, failure); };
        if (delay > 0) {
            setTimeout(doLoad, delay);
        }
        else {
            doLoad();
        }
    };
    var reinitialize = function () {
        for (var loader = cache.pop(); loader != null; loader = cache.pop()) {
            loader.deleteScripts();
        }
    };
    return {
        loadList: loadList,
        reinitialize: reinitialize
    };
};
var ScriptLoader = createScriptLoader();

;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/TinyMCE.js
var getTinymce = function (view) {
    var global = view;
    return global && global.tinymce ? global.tinymce : null;
};


;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/components/Editor.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Editor_assign = (undefined && undefined.__assign) || function () {
    Editor_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Editor_assign.apply(this, arguments);
};





var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor(props) {
        var _this = this;
        var _a, _b, _c;
        _this = _super.call(this, props) || this;
        _this.rollbackTimer = undefined;
        _this.valueCursor = undefined;
        _this.rollbackChange = function () {
            var editor = _this.editor;
            var value = _this.props.value;
            if (editor && value && value !== _this.currentContent) {
                editor.undoManager.ignore(function () {
                    editor.setContent(value);
                    // only restore cursor on inline editors when they are focused
                    // as otherwise it will cause a focus grab
                    if (_this.valueCursor && (!_this.inline || editor.hasFocus())) {
                        try {
                            editor.selection.moveToBookmark(_this.valueCursor);
                        }
                        catch (e) { /* ignore */ }
                    }
                });
            }
            _this.rollbackTimer = undefined;
        };
        _this.handleBeforeInput = function (_evt) {
            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
                if (!_this.inline || _this.editor.hasFocus()) {
                    try {
                        // getBookmark throws exceptions when the editor has not been focused
                        // possibly only in inline mode but I'm not taking chances
                        _this.valueCursor = _this.editor.selection.getBookmark(3);
                    }
                    catch (e) { /* ignore */ }
                }
            }
        };
        _this.handleBeforeInputSpecial = function (evt) {
            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') {
                _this.handleBeforeInput(evt);
            }
        };
        _this.handleEditorChange = function (_evt) {
            var editor = _this.editor;
            if (editor && editor.initialized) {
                var newContent = editor.getContent();
                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) {
                    // start a timer and revert to the value if not applied in time
                    if (!_this.rollbackTimer) {
                        _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === 'number' ? _this.props.rollback : 200);
                    }
                }
                if (newContent !== _this.currentContent) {
                    _this.currentContent = newContent;
                    if (isFunction(_this.props.onEditorChange)) {
                        _this.props.onEditorChange(newContent, editor);
                    }
                }
            }
        };
        _this.handleEditorChangeSpecial = function (evt) {
            if (evt.key === 'Backspace' || evt.key === 'Delete') {
                _this.handleEditorChange(evt);
            }
        };
        _this.initialise = function (attempts) {
            var _a, _b, _c;
            if (attempts === void 0) { attempts = 0; }
            var target = _this.elementRef.current;
            if (!target) {
                return; // Editor has been unmounted
            }
            if (!isInDoc(target)) {
                // this is probably someone trying to help by rendering us offscreen
                // but we can't do that because the editor iframe must be in the document
                // in order to have state
                if (attempts === 0) {
                    // we probably just need to wait for the current events to be processed
                    setTimeout(function () { return _this.initialise(1); }, 1);
                }
                else if (attempts < 100) {
                    // wait for ten seconds, polling every tenth of a second
                    setTimeout(function () { return _this.initialise(attempts + 1); }, 100);
                }
                else {
                    // give up, at this point it seems that more polling is unlikely to help
                    throw new Error('tinymce can only be initialised when in a document');
                }
                return;
            }
            var tinymce = getTinymce(_this.view);
            if (!tinymce) {
                throw new Error('tinymce should have been loaded into global scope');
            }
            var finalInit = Editor_assign(Editor_assign({}, _this.props.init), { selector: undefined, target: target, readonly: _this.props.disabled, inline: _this.inline, plugins: mergePlugins((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins), toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar, setup: function (editor) {
                    _this.editor = editor;
                    _this.bindHandlers({});
                    // When running in inline mode the editor gets the initial value
                    // from the innerHTML of the element it is initialized on.
                    // However we don't want to take on the responsibility of sanitizing
                    // to remove XSS in the react integration so we have a chicken and egg
                    // problem... We avoid it by sneaking in a set content before the first
                    // "official" setContent and using TinyMCE to do the sanitization.
                    if (_this.inline && !isTextareaOrInput(target)) {
                        editor.once('PostRender', function (_evt) {
                            editor.setContent(_this.getInitialValue(), { no_events: true });
                        });
                    }
                    if (_this.props.init && isFunction(_this.props.init.setup)) {
                        _this.props.init.setup(editor);
                    }
                }, init_instance_callback: function (editor) {
                    var _a, _b;
                    // check for changes that happened since tinymce.init() was called
                    var initialValue = _this.getInitialValue();
                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
                    if (_this.currentContent !== initialValue) {
                        _this.currentContent = initialValue;
                        // same as resetContent in TinyMCE 5
                        editor.setContent(initialValue);
                        editor.undoManager.clear();
                        editor.undoManager.add();
                        editor.setDirty(false);
                    }
                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
                    setMode(_this.editor, disabled ? 'readonly' : 'design');
                    // ensure existing init_instance_callback is called
                    if (_this.props.init && isFunction(_this.props.init.init_instance_callback)) {
                        _this.props.init.init_instance_callback(editor);
                    }
                } });
            if (!_this.inline) {
                target.style.visibility = '';
            }
            if (isTextareaOrInput(target)) {
                target.value = _this.getInitialValue();
            }
            tinymce.init(finalInit);
        };
        _this.id = _this.props.id || uuid('tiny-react');
        _this.elementRef = react.createRef();
        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
        _this.boundHandlers = {};
        return _this;
    }
    Object.defineProperty(Editor.prototype, "view", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.elementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.defaultView) !== null && _b !== void 0 ? _b : window;
        },
        enumerable: false,
        configurable: true
    });
    Editor.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a, _b;
        if (this.rollbackTimer) {
            clearTimeout(this.rollbackTimer);
            this.rollbackTimer = undefined;
        }
        if (this.editor) {
            this.bindHandlers(prevProps);
            if (this.editor.initialized) {
                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
                    // same as resetContent in TinyMCE 5
                    this.editor.setContent(this.props.initialValue);
                    this.editor.undoManager.clear();
                    this.editor.undoManager.add();
                    this.editor.setDirty(false);
                }
                else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
                    var localEditor_1 = this.editor;
                    localEditor_1.undoManager.transact(function () {
                        // inline editors grab focus when restoring selection
                        // so we don't try to keep their selection unless they are currently focused
                        var cursor;
                        if (!_this.inline || localEditor_1.hasFocus()) {
                            try {
                                // getBookmark throws exceptions when the editor has not been focused
                                // possibly only in inline mode but I'm not taking chances
                                cursor = localEditor_1.selection.getBookmark(3);
                            }
                            catch (e) { /* ignore */ }
                        }
                        var valueCursor = _this.valueCursor;
                        localEditor_1.setContent(_this.props.value);
                        if (!_this.inline || localEditor_1.hasFocus()) {
                            for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
                                var bookmark = _a[_i];
                                if (bookmark) {
                                    try {
                                        localEditor_1.selection.moveToBookmark(bookmark);
                                        _this.valueCursor = bookmark;
                                        break;
                                    }
                                    catch (e) { /* ignore */ }
                                }
                            }
                        }
                    });
                }
                if (this.props.disabled !== prevProps.disabled) {
                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
                    setMode(this.editor, disabled ? 'readonly' : 'design');
                }
            }
        }
    };
    Editor.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (getTinymce(this.view) !== null) {
            this.initialise();
        }
        else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0) {
            (_b = (_a = this.props).onScriptsLoadError) === null || _b === void 0 ? void 0 : _b.call(_a, new Error('No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array.'));
        }
        else if ((_c = this.elementRef.current) === null || _c === void 0 ? void 0 : _c.ownerDocument) {
            var successHandler = function () {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoad) === null || _b === void 0 ? void 0 : _b.call(_a);
                _this.initialise();
            };
            var errorHandler = function (err) {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoadError) === null || _b === void 0 ? void 0 : _b.call(_a, err);
            };
            ScriptLoader.loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (_e = (_d = this.props.scriptLoading) === null || _d === void 0 ? void 0 : _d.delay) !== null && _e !== void 0 ? _e : 0, successHandler, errorHandler);
        }
    };
    Editor.prototype.componentWillUnmount = function () {
        var _this = this;
        var editor = this.editor;
        if (editor) {
            editor.off(this.changeEvents(), this.handleEditorChange);
            editor.off(this.beforeInputEvent(), this.handleBeforeInput);
            editor.off('keypress', this.handleEditorChangeSpecial);
            editor.off('keydown', this.handleBeforeInputSpecial);
            editor.off('NewBlock', this.handleEditorChange);
            Object.keys(this.boundHandlers).forEach(function (eventName) {
                editor.off(eventName, _this.boundHandlers[eventName]);
            });
            this.boundHandlers = {};
            editor.remove();
            this.editor = undefined;
        }
    };
    Editor.prototype.render = function () {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.changeEvents = function () {
        var _a, _b, _c;
        var isIE = (_c = (_b = (_a = getTinymce(this.view)) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE();
        return (isIE
            ? 'change keyup compositionend setcontent CommentChange'
            : 'change input compositionend setcontent CommentChange');
    };
    Editor.prototype.beforeInputEvent = function () {
        return isBeforeInputEventAvailable() ? 'beforeinput SelectionChange' : 'SelectionChange';
    };
    Editor.prototype.renderInline = function () {
        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
        return react.createElement(tagName, {
            ref: this.elementRef,
            id: this.id
        });
    };
    Editor.prototype.renderIframe = function () {
        return react.createElement('textarea', {
            ref: this.elementRef,
            style: { visibility: 'hidden' },
            name: this.props.textareaName,
            id: this.id
        });
    };
    Editor.prototype.getScriptSources = function () {
        var _a, _b;
        var async = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async;
        var defer = (_b = this.props.scriptLoading) === null || _b === void 0 ? void 0 : _b.defer;
        if (this.props.tinymceScriptSrc !== undefined) {
            if (typeof this.props.tinymceScriptSrc === 'string') {
                return [{ src: this.props.tinymceScriptSrc, async: async, defer: defer }];
            }
            // multiple scripts can be specified which allows for hybrid mode
            return this.props.tinymceScriptSrc.map(function (item) {
                if (typeof item === 'string') {
                    // async does not make sense for multiple items unless
                    // they are not dependent (which will be unlikely)
                    return { src: item, async: async, defer: defer };
                }
                else {
                    return item;
                }
            });
        }
        // fallback to the cloud when the tinymceScriptSrc is not specified
        var channel = this.props.cloudChannel;
        var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
        var cloudTinyJs = "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
        return [{ src: cloudTinyJs, async: async, defer: defer }];
    };
    Editor.prototype.getInitialValue = function () {
        if (typeof this.props.initialValue === 'string') {
            return this.props.initialValue;
        }
        else if (typeof this.props.value === 'string') {
            return this.props.value;
        }
        else {
            return '';
        }
    };
    Editor.prototype.bindHandlers = function (prevProps) {
        var _this = this;
        if (this.editor !== undefined) {
            // typescript chokes trying to understand the type of the lookup function
            configHandlers(this.editor, prevProps, this.props, this.boundHandlers, function (key) { return _this.props[key]; });
            // check if we should monitor editor changes
            var isValueControlled = function (p) { return p.onEditorChange !== undefined || p.value !== undefined; };
            var wasControlled = isValueControlled(prevProps);
            var nowControlled = isValueControlled(this.props);
            if (!wasControlled && nowControlled) {
                this.editor.on(this.changeEvents(), this.handleEditorChange);
                this.editor.on(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.on('keydown', this.handleBeforeInputSpecial);
                this.editor.on('keyup', this.handleEditorChangeSpecial);
                this.editor.on('NewBlock', this.handleEditorChange);
            }
            else if (wasControlled && !nowControlled) {
                this.editor.off(this.changeEvents(), this.handleEditorChange);
                this.editor.off(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.off('keydown', this.handleBeforeInputSpecial);
                this.editor.off('keyup', this.handleEditorChangeSpecial);
                this.editor.off('NewBlock', this.handleEditorChange);
            }
        }
    };
    Editor.propTypes = EditorPropTypes;
    Editor.defaultProps = {
        cloudChannel: '6'
    };
    return Editor;
}(react.Component));


;// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js



;// CONCATENATED MODULE: ./src/features/block/block-editor/TextV2/EditorComp/index.tsx
function EditorComp_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditorComp_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditorComp_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





// import initFullProps from "./init-config";
var EditorComp = function(props) {
    var value = props.value, onUpdateValue = props.onUpdateValue, handleInit = props.handleInit, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var displaySettings = siteSettings && Object.values(siteSettings).length > 0 && siteSettings.display_setting;
    var titleSetting = displaySettings === null || displaySettings === void 0 ? void 0 : displaySettings.title_setting;
    var paragraphSetting = displaySettings === null || displaySettings === void 0 ? void 0 : displaySettings.paragraph_setting;
    var ref = titleSetting || {}, tmp = ref.font_family, titleFontFamily = tmp === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : tmp, tmp1 = ref.font_color, titleColor = tmp1 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : tmp1, tmp2 = ref.font_size, titleFontSize = tmp2 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : tmp2, tmp3 = ref.ratio, titleRatio = tmp3 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : tmp3, tmp4 = ref.font_weight, titleFontWeight = tmp4 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : tmp4, tmp5 = ref.line_height, titleLineHeight = tmp5 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : tmp5;
    var ref1 = paragraphSetting || {}, tmp6 = ref1.font_family, paragraphFontFamily = tmp6 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : tmp6, tmp7 = ref1.font_color, paragraphColor = tmp7 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : tmp7, tmp8 = ref1.font_size, paragraphFontSize = tmp8 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : tmp8, tmp9 = ref1.ratio, paragraphRatio = tmp9 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE : tmp9, tmp10 = ref1.font_weight, paragraphFontWeight = tmp10 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : tmp10, tmp11 = ref1.line_height, paragraphLineHeight = tmp11 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : tmp11;
    var initFullProps = (0,react.useMemo)(function() {
        var fontSizeH1 = titleFontSize * titleRatio * titleRatio * titleRatio * titleRatio * titleRatio;
        var fontSizeH2 = titleFontSize * titleRatio * titleRatio * titleRatio * titleRatio;
        var fontSizeH3 = titleFontSize * titleRatio * titleRatio * titleRatio;
        var fontSizeH4 = titleFontSize * titleRatio * titleRatio;
        var fontSizeH5 = titleFontSize * titleRatio;
        var init = {
            placeholder: placeholder,
            menubar: false,
            formats: {
            },
            block_formats: "Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6",
            preformatted: false,
            toolbar: "fullscreen | undo redo | formatselect | bold italic | bullist numlist | forecolor backcolor |             alignleft aligncenter alignright alignjustify | removeformat ",
            lists_indent_on_tab: false,
            plugins: "fullscreen wordcount lists paste",
            branding: false,
            statusbar: false,
            body_class: "editor-class",
            height: "414px",
            content_style: "\n      @import url('https://fonts.googleapis.com/css?family=".concat(paragraphFontFamily, "');\n      @import url('https://fonts.googleapis.com/css?family=").concat(titleFontFamily, "');\n      body {\n        padding-top: 20px;\n        font-family: ").concat(paragraphFontFamily, ";\n        line-height: ").concat(paragraphLineHeight, ";\n        font-size: ").concat(paragraphFontSize, "px; \n      }\n      blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre {\n        margin: 0;\n      }\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      .h7 {\n        line-height: ").concat(titleLineHeight, ";\n        margin: 1.25rem 0 0.5rem 0;\n        font-family: ").concat(titleFontFamily, ";\n        color: unset;\n        font-weight: unset;\n      }\n\n      h1 {\n        font-size: ").concat(fontSizeH1, "px; \n      }\n\n      h2 {\n        font-size: ").concat(fontSizeH2, "px; \n      }\n      h3 {\n        font-size: ").concat(fontSizeH3, "px; \n      }\n      h4 {\n        font-size: ").concat(fontSizeH4, "px; \n      }\n      h5 {\n        font-size: ").concat(fontSizeH5, "px; \n      }\n      h6 {\n        font-size: ").concat(titleFontSize, "px;\n      }\n      .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {\n        font-size: 14px;\n        line-height: 22px;\n        color: rgba(0, 0, 0, 0.25);\n      }\n    }\n        ")
        };
        return init;
    }, [
        titleFontFamily,
        titleFontSize,
        titleLineHeight,
        titleRatio,
        paragraphFontFamily,
        paragraphFontSize,
        paragraphLineHeight, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
            id: "Editor",
            tinymceScriptSrc: "/static/tinymce/tinymce.min.js",
            value: value,
            init: EditorComp_objectSpread({}, initFullProps),
            onInit: handleInit,
            onEditorChange: onUpdateValue
        })
    });
};
/* harmony default export */ var TextV2_EditorComp = (EditorComp);

// EXTERNAL MODULE: ./node_modules/draftjs-to-html/lib/draftjs-to-html.js
var draftjs_to_html = __webpack_require__(89265);
var draftjs_to_html_default = /*#__PURE__*/__webpack_require__.n(draftjs_to_html);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/const.ts

var imageOptions = function() {
    var imageOrientation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE;
    return [
        {
            label: "1:1",
            value: "1/1"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "4:3" : "3:4",
            value: "4/3"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:2" : "2:3",
            value: "3/2"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "16:9" : "9:16",
            value: "16/9"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "21:9" : "9:21",
            value: "21/9"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:1" : "1:3",
            value: "3/1"
        }, 
    ];
};
var DATA_BIO_BOOKING_PROFILE_DEFAULT = {
    bio_booking_profile_display: false,
    bio_booking_profile_title: "",
    bio_booking_profile_description: "",
    bio_booking_profile_button_label: "H\u1ED3 s\u01A1 c\xf4ng vi\u1EC7c"
};
var BIO_BOOKING_PROFILE_FIELD = {
    BIO_BOOKING_PROFILE_FIELD_DISPLAY: "bio_booking_profile_display",
    BIO_BOOKING_PROFILE_FIELD_TITLE: "bio_booking_profile_title",
    BIO_BOOKING_PROFILE_FIELD_DESCRIPTION: "bio_booking_profile_description",
    BIO_BOOKING_PROFILE_FIELD_LABEL: "bio_booking_profile_button_label"
};
var TIME_REFRESH = (/* unused pure expression or super */ null && (60 * 1000)); // 1 minutes
var FINISH_ONBOARDING = 1;

// EXTERNAL MODULE: ./src/features/share/components/UploadImage/index.tsx
var UploadImage = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/CoverImageAddNew/index.tsx
function CoverImageAddNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CoverImageAddNew_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CoverImageAddNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CoverImageAddNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CoverImageAddNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CoverImageAddNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CoverImageAddNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var CoverImageAddNew = function(props) {
    var imageRatio = props.imageRatio, callBackCancelImageCoverAddNew = props.callBackCancelImageCoverAddNew, handleSaveImageCover = props.handleSaveImageCover, imageCoverEditData = props.imageCoverEditData, indexImageCoverEdit = props.indexImageCoverEdit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "cover-image-".concat((0,v4/* default */.Z)());
    var originUrlDefault = imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.origin_url;
    var affiliateUrlDefault = imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.target_url;
    var valueUrlImageDefault = imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.image;
    var hasAffiliateUrlDefault = (imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.use_aff_url) ? !!((imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.use_aff_url) === 1) : true;
    var defaultLinkData = (imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: originUrlDefault
    };
    var openInNewTabDefault = (imageCoverEditData === null || imageCoverEditData === void 0 ? void 0 : imageCoverEditData.open_new_tab) || false;
    var ref24 = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref24[0], setValueUrlImage = ref24[1];
    var ref1 = (0,react.useState)(""), valueNameImage = ref1[0], setValueNameImage = ref1[1];
    var ref2 = (0,react.useState)(null), valueImageBase64 = ref2[0], setValueImageBase64 = ref2[1];
    var ref3 = (0,react.useState)([]), uploadedImageArr = ref3[0], setUploadedImageArr = ref3[1];
    var ref4 = (0,react.useState)(originUrlDefault || ""), originUrl = ref4[0], setOriginUrl = ref4[1];
    var ref5 = (0,react.useState)(affiliateUrlDefault || ""), affiliateUrl = ref5[0], setAffiliateUrl = ref5[1];
    var ref6 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref6[0], setHasAffiliateUrl = ref6[1];
    var ref7 = (0,react.useState)(false), isValidUrl = ref7[0], setIsValidUrl = ref7[1];
    var ref8 = (0,react.useState)(false), isLoadingBtn = ref8[0], setIsLoadingBtn = ref8[1];
    var ref9 = (0,react.useState)(null), errorCode1 = ref9[0], setErrorCode = ref9[1];
    var ref10 = (0,react.useState)(null), warningCode1 = ref10[0], setWarningCode = ref10[1];
    var ref11 = (0,react.useState)(false), isDisableBtnSave = ref11[0], setIsDisableBtnSave = ref11[1];
    var ref12 = (0,react.useState)(false), isValidFileFormat = ref12[0], setIsValidFileFormat = ref12[1];
    var ref13 = (0,react.useState)(false), isValidFileSize = ref13[0], setIsValidFileSize = ref13[1];
    var ref14 = (0,react.useState)(defaultLinkData), linkData1 = ref14[0], setLinkData = ref14[1];
    var ref15 = (0,react.useState)(false), isEcommerce = ref15[0], setIsEcommerce = ref15[1];
    var ref16 = (0,react.useState)(openInNewTabDefault), openNewTab = ref16[0], setOpenNewTab = ref16[1];
    var checkEcomerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcomerce(linkData1.target_url);
        } else if (originUrl) checkEcomerce(originUrl);
    }, [
        originUrl,
        linkData1
    ]);
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    (0,react.useEffect)(function() {
        if (valueUrlImageDefault) {
            setValueUrlImage(valueUrlImageDefault);
        }
        if (originUrlDefault) {
            setOriginUrl(originUrlDefault);
        }
        if (affiliateUrlDefault) {
            setAffiliateUrl(affiliateUrlDefault);
        }
        if (hasAffiliateUrlDefault) {
            setHasAffiliateUrl(hasAffiliateUrlDefault);
        }
    }, [
        valueUrlImageDefault,
        originUrlDefault,
        affiliateUrlDefault,
        hasAffiliateUrlDefault, 
    ]);
    var validateOriginUrl = function(data) {
        if (data) {
            var validateUrl = function() {
                var _ref = CoverImageAddNew_asyncToGenerator(runtime_default().mark(function _callee() {
                    var response, ref, isSuccess, ref17, ref18, ref19, ref20, isAccepted, targetUrl, ref21, ref22, warningCode, ref23, errorCode;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = null;
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return (0,api/* requestValidateUrl */.nN)(data);
                            case 4:
                                response = _ctx.sent;
                                _ctx.next = 10;
                                break;
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](1);
                                console.log(_ctx.t0);
                            case 10:
                                if (response) {
                                    ;
                                    setIsLoadingBtn(false);
                                    setIsDisableBtnSave(false);
                                    isSuccess = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success;
                                    if (isSuccess) {
                                        ;
                                        isAccepted = response === null || response === void 0 ? void 0 : (ref17 = response.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.accepted;
                                        targetUrl = response === null || response === void 0 ? void 0 : (ref19 = response.data) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.data) === null || ref20 === void 0 ? void 0 : ref20.target_url;
                                        setAffiliateUrl(targetUrl);
                                        if (!isAccepted) {
                                            ;
                                            warningCode = response === null || response === void 0 ? void 0 : (ref21 = response.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.data) === null || ref22 === void 0 ? void 0 : ref22.warning_code;
                                            setWarningCode(warningCode);
                                            setErrorCode(null);
                                        } else {
                                            setWarningCode(null);
                                        }
                                    } else {
                                        ;
                                        errorCode = response === null || response === void 0 ? void 0 : (ref23 = response.data) === null || ref23 === void 0 ? void 0 : ref23.error_code;
                                        setErrorCode(errorCode);
                                        setWarningCode(null);
                                    }
                                }
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                return function validateUrl() {
                    return _ref.apply(this, arguments);
                };
            }();
            var isCheckUrl = (0,lib/* validURL */.b3)(data);
            if (isCheckUrl) {
                setIsLoadingBtn(true);
                validateUrl();
                setIsValidUrl(false);
            } else {
                setIsValidUrl(true);
            }
        } else {
            setErrorCode(null);
            setIsValidUrl(false);
            setIsDisableBtnSave(false);
        }
        setWarningCode(null);
    };
    var handleDeleteImage = function() {
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                setValueUrlImage(null);
                setUploadedImageArr([]);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleSaveImage = function() {
        var defaultImageData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
            image: valueImageBase64 || valueUrlImage,
            image_base64: valueImageBase64,
            origin_url: originUrl,
            target_url: affiliateUrl,
            image_name: valueNameImage,
            link_data: linkData1,
            open_new_tab: isEcommerce ? true : openNewTab
        };
        if (imageCoverEditData) {
            handleSaveImageCover(CoverImageAddNew_objectSpread({}, imageCoverEditData, {
                use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                image: valueImageBase64 || valueUrlImage,
                image_base64: valueImageBase64,
                origin_url: originUrl,
                target_url: affiliateUrl,
                image_name: valueNameImage,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            }));
        } else {
            handleSaveImageCover(defaultImageData);
        }
        callBackCancelImageCoverAddNew();
        setValueUrlImage(null);
        setOriginUrl("");
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelImageSliderAddNew = function() {
        if (valueUrlImage && valueUrlImage !== valueUrlImageDefault || originUrl && originUrl !== originUrlDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || openNewTab !== openInNewTabDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "var(--adm-color-primary)",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_content")
                }),
                confirmText: t("ss_builder_confirm_cancel_image_slider_add_new_btn_label"),
                cancelText: t("ss_builder_cancel_image_slider_add_new_btn_label"),
                onConfirm: function() {
                    callBackCancelImageCoverAddNew();
                    setValueUrlImage(null);
                    setOriginUrl("");
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                },
                onCancel: function() {
                    return;
                }
            });
        } else {
            callBackCancelImageCoverAddNew();
            setValueUrlImage(null);
            setOriginUrl("");
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        if (typeof hasAffiliateUrl === "boolean" && valueUrlImage && // originUrl &&
        (valueUrlImage !== valueUrlImageDefault || originUrl !== originUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || openNewTab !== openInNewTabDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault) && !isValidUrl && !isDisableBtnSave) {
            return true;
        } else return false;
    }, [
        hasAffiliateUrl,
        valueUrlImage,
        valueUrlImageDefault,
        originUrl,
        originUrlDefault,
        hasAffiliateUrlDefault,
        isValidUrl,
        isDisableBtnSave,
        linkData1,
        defaultLinkData,
        openNewTab,
        openInNewTabDefault, 
    ]);
    var onUpdateLinkData = function(linkData) {
        if (linkData.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setOriginUrl(linkData.value);
        } else {
            setOriginUrl(null);
        }
        setLinkData(linkData);
    };
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIcon */.XB, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: typeof indexImageCoverEdit === "number" ? "Image ".concat(indexImageCoverEdit + 1) : "Image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white mb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_add_new_image_of_image_slider_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                        valueUrlImage: valueUrlImage,
                        imageRatio: imageRatio
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                color: valueUrlImage ? "primary" : "default",
                                fill: "solid",
                                className: "",
                                onClick: valueUrlImage ? handleDeleteImage : function() {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: valueUrlImage ? "#FFFFFF" : "#CCCCCC"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleImageUrl,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                },
                                className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                value: uploadedImageArr,
                                // disableUpload={isDisableUploadBtn}
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    block: true,
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full grow",
                                    children: t("ss_builder_upload_button_label")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                            label: t("ss_builder_button_link_icon_origin_url_label"),
                            isRequire: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                item: linkData1,
                                onChange: function(item) {
                                    onUpdateLinkData(item);
                                },
                                onLoading: onAffLoading,
                                onError: function(errorMessage) {
                                    setIsValidUrl(!!errorMessage);
                                }
                            })
                        })
                    }),
                    linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                        onChange: handleCheckAffiliateUrl,
                                        icon: function(checked) {
                                            return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsChecked */.z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsNotChecked */.VP, {});
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_use_affiliate_link_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_use_affiliate_link_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            }),
                            !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                icon: function(checked) {
                                                    return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsChecked */.z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsNotChecked */.VP, {});
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelImageSliderAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveImage,
                            loading: isLoadingBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Bio_CoverImageAddNew = (CoverImageAddNew);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/CoverImageList/index.tsx








var CoverImageList = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var AFF_CODE = 1;
    var index = props.index, imageData = props.imageData, onRemoveItem = props.onRemoveItem, onDisableEnableImage = props.onDisableEnableImage, callbackOpenEditImage = props.callbackOpenEditImage;
    var isEnable = !!(imageData && imageData.enable === 1);
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: "eye-visible-image",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_image_label") : t("ss_builder_hide_image_label")
        },
        {
            key: "delete-image",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_image_label")
        }, 
    ];
    var MoreElement = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: actions,
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-image":
                handleEnableDisableImage();
                break;
            case "delete-image":
                confirmRemoveImage();
                break;
            default:
        }
    };
    var confirmRemoveImage = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                onRemoveItem(index);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleEditImage = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditImage(imageData, index);
    };
    var handleEnableDisableImage = function() {
        var imageStatus = !isEnable ? 1 : 2;
        onDisableEnableImage(index, imageStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_image_successfully_label") : t("ss_builder_enable_image_successfully_label")
            })
        });
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var getContent = function() {
        var content = "";
        if (imageData.link_data.type !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE) {
            content = imageData.link_data.value;
        } else {
            if (imageData.link_data.value === configs_const/* TRUTH_OR_DATE */.z0) content = t("ss_builder_title_block_truth_or_dare");
            if (imageData.link_data.value === configs_const/* GIFT */.R_) content = t("ss_builder_title_block_brand_gift");
            if (imageData.link_data.value === configs_const/* DONATION */.px) content = t("ss_builder_title_block_donation");
        }
        return content;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {}),
                onClick: handleEditImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: imageData === null || imageData === void 0 ? void 0 : imageData.image,
                            width: 40,
                            height: 40,
                            fit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs leading-4 font-normal text-[#8C8C8C] text-ellipsis whitespace-nowrap overflow-hidden",
                                children: (imageData === null || imageData === void 0 ? void 0 : imageData.use_aff_url) === AFF_CODE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    style: {
                                        marginTop: "2px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontSize: "12px",
                                                color: "#8C8C8C",
                                                fontWeight: 400
                                            },
                                            children: t("ss_builder_product_link_wrapped_label")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                    className: "text-[#999999] text-[15px] leading-5 text-ellipsis",
                                    content: getContent()
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Bio_CoverImageList = (CoverImageList);

// EXTERNAL MODULE: ./src/features/block/block-editor/Bio/BookingProfileLink/style.module.scss
var BookingProfileLink_style_module = __webpack_require__(35815);
var BookingProfileLink_style_module_default = /*#__PURE__*/__webpack_require__.n(BookingProfileLink_style_module);
// EXTERNAL MODULE: ./src/features/share/helper/browser.ts
var browser = __webpack_require__(52741);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/BookingProfileLink/index.tsx
function BookingProfileLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BookingProfileLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BookingProfileLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var BookingProfileLink = function(param) {
    var data = param.data, onChange = param.onChange;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var domain = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.kol) === null || ref1 === void 0 ? void 0 : ref1.domain;
    });
    var bookingProfileSeller = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.bookingProfile;
    });
    var bookingProfileLink = (0,react.useMemo)(function() {
        var link = "";
        if (domain) {
            link = "https://".concat(domain, "/booking-profile");
        }
        return link;
    }, [
        domain
    ]);
    var ErrorModal = (0,modal/* useModal */.dd)().ErrorModal;
    var handleChange = function(nameField, value) {
        var dataCurrent = cloneDeep_default()(data);
        onChange(BookingProfileLink_objectSpread({}, dataCurrent, BookingProfileLink_defineProperty({}, nameField, value)));
    };
    var handleClickCoppyLink = function() {
        (0,browser/* copyToClipboard */.v)(bookingProfileLink);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_block_link_copy_successfully_label")
            })
        });
    };
    var handleChangeSwitch = function(nameField, val) {
        if (val) {
            if ((bookingProfileSeller === null || bookingProfileSeller === void 0 ? void 0 : bookingProfileSeller.finish_onboard) !== FINISH_ONBOARDING) {
                ErrorModal({
                    title: t("ss_builder_block_booking_file_alert_title"),
                    icon: modal/* ModalIconConfig.INFO_WARNING_TRIANGLE */.vi.INFO_WARNING_TRIANGLE,
                    description: t("ss_builder_block_booking_file_alert_content"),
                    confirmText: t("ss_builder_modal_button_close")
                });
                return;
            }
        }
        var dataCurrent = cloneDeep_default()(data);
        onChange(BookingProfileLink_objectSpread({}, dataCurrent, BookingProfileLink_defineProperty({}, nameField, val)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BookingProfileLink_style_module_default()).bookingProfile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse */.UO, {
            defaultActiveKey: [
                "booking-profile"
            ],
            accordion: false,
            arrow: function(active) {
                return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse.Panel */.UO.Panel, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[17px] leading-[22px] font-normal",
                        children: t("ss_builder_block_booking_file_label")
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white w-full px-4 py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[15px] text-[#666666] font-normal",
                                            children: t("ss_builder_enable_shadow")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_block_booking_file_switch_tooltip"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[21px] h-[21px] flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                                                        fillColor: "#1890FF",
                                                        className: "w-[15px] h-[15px] cursor-pointer"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                    defaultChecked: false,
                                    checked: (data === null || data === void 0 ? void 0 : data.bio_booking_profile_display) || false,
                                    onChange: function(val) {
                                        return handleChangeSwitch(BIO_BOOKING_PROFILE_FIELD.BIO_BOOKING_PROFILE_FIELD_DISPLAY, val);
                                    }
                                })
                            ]
                        }),
                        (data === null || data === void 0 ? void 0 : data.bio_booking_profile_display) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white pt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                    style: {
                                        margin: "0px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                                            label: t("ss_builder_block_booking_profile_setting_title"),
                                            value: data.bio_booking_profile_title,
                                            maxLength: 50,
                                            placeholder: t("ss_builder_block_description_placeholder"),
                                            onChange: function(value) {
                                                return handleChange(BIO_BOOKING_PROFILE_FIELD.BIO_BOOKING_PROFILE_FIELD_TITLE, value);
                                            },
                                            hasNoBorder: true,
                                            showCountCharacter: true,
                                            hasBottomDivider: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                                            label: t("ss_builder_block_booking_profile_setting_description"),
                                            value: data.bio_booking_profile_description,
                                            maxLength: 250,
                                            placeholder: t("ss_builder_block_description_placeholder"),
                                            onChange: function(value) {
                                                return handleChange(BIO_BOOKING_PROFILE_FIELD.BIO_BOOKING_PROFILE_FIELD_DESCRIPTION, value);
                                            },
                                            hasNoBorder: true,
                                            isMultiline: true,
                                            showCountCharacter: true,
                                            hasBottomDivider: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                                            label: t("ss_builder_block_booking_profile_button_label"),
                                            value: data.bio_booking_profile_button_label,
                                            maxLength: 25,
                                            placeholder: t("ss_builder_block_description_placeholder"),
                                            onChange: function(value) {
                                                return handleChange(BIO_BOOKING_PROFILE_FIELD.BIO_BOOKING_PROFILE_FIELD_LABEL, value);
                                            },
                                            hasNoBorder: true,
                                            required: true,
                                            showCountCharacter: true,
                                            hasBottomDivider: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "overflow-hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-x-1 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-[#666666] text-[15px] leading-[150%]",
                                                            children: t("ss_builder_block_booking_file_label")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                            content: t("ss_builder_block_booking_file_link_tooltip"),
                                                            placement: "top-start",
                                                            mode: "dark",
                                                            trigger: "click",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[21px] h-[21px] flex items-center justify-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                                                                    fillColor: "#1890FF",
                                                                    className: "w-[15px] h-[15px] cursor-pointer"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center w-full justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-[17px] leading-[150%] truncate",
                                                            style: {
                                                                color: "rgba(51, 51, 51, 0.4)"
                                                            },
                                                            children: bookingProfileLink
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-[24px] h-[24px] cursor-pointer flex items-center justify-center",
                                                            onClick: handleClickCoppyLink,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CoppyAltIcon */.tO, {
                                                                width: 16,
                                                                height: 16
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, "booking-profile")
        })
    });
};
/* harmony default export */ var Bio_BookingProfileLink = (BookingProfileLink);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Bio/index.tsx
function Bio_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Bio_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Bio_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Bio_arrayLikeToArray(arr);
}
function Bio_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Bio_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Bio_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Bio_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Bio_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Bio_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Bio_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Bio_slicedToArray(arr, i) {
    return Bio_arrayWithHoles(arr) || Bio_iterableToArrayLimit(arr, i) || Bio_unsupportedIterableToArray(arr, i) || Bio_nonIterableRest();
}
function Bio_toConsumableArray(arr) {
    return Bio_arrayWithoutHoles(arr) || Bio_iterableToArray(arr) || Bio_unsupportedIterableToArray(arr) || Bio_nonIterableSpread();
}
function Bio_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Bio_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Bio_arrayLikeToArray(o, minLen);
}





























var BioComponent = function(props) {
    var ref30, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData;
    var IMAGE_COVER_MAX = 5;
    var defaultAvatar = "https://image.passio.eco/page-builder/page-builder/images-default/bio-default.svg";
    var DROPPABLE_ID = "cover-image-droppable-id";
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "bio-".concat((0,v4/* default */.Z)());
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    // const edittingBlock = useAppSelector((state) => state.edittingBlock);
    // const KEY = edittingBlock && edittingBlock.KEY;
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    // const tabUid = edittingBlock && edittingBlock.tab_uid;
    // const positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEditBio = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = defaultValueEditBio && defaultValueEditBio.title || "Bio";
    var styleBioValueDefault = defaultValueEditBio && defaultValueEditBio.style_attributes && defaultValueEditBio.style_attributes.style_display || configs_const/* BIO_DISPLAY_STYLES.STYLE1 */.uT.STYLE1;
    var valueUrlImageDefault = defaultValueEditBio && defaultValueEditBio.content_attributes && defaultValueEditBio.content_attributes.bio_image || defaultAvatar;
    var valueNameImageDefault = defaultValueEditBio && defaultValueEditBio.content_attributes && defaultValueEditBio.content_attributes.bio_image_name || null;
    var valueBioNameDefault = defaultValueEditBio && defaultValueEditBio.content_attributes && defaultValueEditBio.content_attributes.bio_name || "";
    var valueBioSubtitleDefault = defaultValueEditBio && defaultValueEditBio.content_attributes && defaultValueEditBio.content_attributes.bio_subtitle || "";
    var contentBioStateDefault = (0,react.useMemo)(function() {
        var ref;
        var bioContent = defaultValueEditBio === null || defaultValueEditBio === void 0 ? void 0 : (ref = defaultValueEditBio.content_attributes) === null || ref === void 0 ? void 0 : ref.bio_content;
        if (bioContent) {
            if (typeof bioContent == "string") {
                return bioContent;
            } else {
                return draftjs_to_html_default()(bioContent);
            }
        } else {
            return null;
        }
    }, [
        defaultValueEditBio === null || defaultValueEditBio === void 0 ? void 0 : (ref30 = defaultValueEditBio.content_attributes) === null || ref30 === void 0 ? void 0 : ref30.bio_content
    ]);
    var elementId = (0,react.useMemo)(function() {
        return "e" + Math.random().toString(36).slice(2, 7);
    }, []);
    var socialLinkArrDefault = defaultValueEditBio && defaultValueEditBio.content_attributes && defaultValueEditBio.content_attributes.social_link_items || [];
    var defaultIsShowCoverImage = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref1 = defaultBlockData.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.bio_show_cover_image) || false;
    var defaultImageRatio = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref2 = defaultBlockData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.bio_image_ratio) || "16/9";
    var defaultIsAutoSwitch = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref3 = defaultBlockData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.bio_auto_switch) || false;
    var defaultListCoverImage = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref4 = defaultBlockData.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.bio_cover_image_list) || [];
    var defaultBookingProfile = {
        bio_booking_profile_display: (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref5 = defaultBlockData.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.bio_booking_profile_display) || false,
        bio_booking_profile_title: (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref6 = defaultBlockData.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.bio_booking_profile_title) || "",
        bio_booking_profile_description: (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref7 = defaultBlockData.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.bio_booking_profile_description) || "",
        bio_booking_profile_button_label: (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : (ref8 = defaultBlockData.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.bio_booking_profile_button_label) || t("ss_builder_block_booking_file_button_label_default")
    };
    var ref9 = (0,react.useState)(styleBioValueDefault), styleBioValue = ref9[0], setStyleBioValue = ref9[1];
    var ref10 = (0,react.useState)([]), uploadedImageArr = ref10[0], setUploadedImageArr = ref10[1];
    var ref11 = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref11[0], setValueUrlImage = ref11[1];
    var ref12 = (0,react.useState)(valueNameImageDefault), valueNameImage = ref12[0], setValueNameImage = ref12[1];
    var ref13 = (0,react.useState)(null), valueImageBase64 = ref13[0], setValueImageBase64 = ref13[1];
    var ref14 = (0,react.useState)(valueBioNameDefault), valueBioName = ref14[0], setValueBioName = ref14[1];
    var ref15 = (0,react.useState)(valueBioSubtitleDefault), valueBioSubTitle = ref15[0], setValueBioSubTitle = ref15[1];
    var ref16 = (0,react.useState)(contentBioStateDefault), contentBioState = ref16[0], setContentBioState = ref16[1];
    var ref17 = (0,react.useState)(socialLinkArrDefault), socialLinkArr = ref17[0], setSocialLinkArr = ref17[1];
    var ref18 = (0,react.useState)(false), isValidFileFormat = ref18[0], setIsValidFileFormat = ref18[1];
    var ref19 = (0,react.useState)(false), isValidFileSize = ref19[0], setIsValidFileSize = ref19[1];
    var ref20 = (0,react.useState)(0), count = ref20[0], setCount = ref20[1];
    var ref21 = (0,react.useState)(defaultIsShowCoverImage), isShowCoverImage = ref21[0], setIsShowCoverImage = ref21[1];
    var ref22 = (0,react.useState)(defaultIsAutoSwitch), isAutoSwitch = ref22[0], setIsAutoSwitch = ref22[1];
    var ref23 = (0,react.useState)(defaultImageRatio), imageRatio = ref23[0], setImageRatio = ref23[1];
    var ref24 = (0,react.useState)(defaultListCoverImage), imageCoverList = ref24[0], setImageCoverList = ref24[1];
    var ref25 = (0,react.useState)(false), isOpenAddNewPopup = ref25[0], setIsOpenAddNewPopup = ref25[1];
    var ref26 = (0,react.useState)(null), imageCoverEditData = ref26[0], setImageCoverEditData = ref26[1];
    var ref27 = (0,react.useState)(null), indexImageCoverEdit = ref27[0], setIndexImageCoverEdit = ref27[1];
    var ref28 = (0,react.useState)(defaultBookingProfile), bioBookingProfile = ref28[0], setBioBookingFile = ref28[1];
    var ref29 = (0,react.useState)({}), placeholderProps1 = ref29[0], setPlaceholderProps = ref29[1];
    var charCount = function(editor) {
        return editor.getContent({
            format: "text"
        }).length;
    };
    var socialLinkListSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(socialLinkArr, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        socialLinkArr
    ]);
    var isValidMaxLength = (0,react.useMemo)(function() {
        return count > configs_const/* EDITOR_MAX_LENGTH */.r7;
    }, [
        count
    ]);
    var checkFieldRequired = (0,react.useMemo)(function() {
        var dataRequired = {
            valueBioName: valueBioName,
            bioBookingProfileButtonLabel: bioBookingProfile.bio_booking_profile_button_label
        };
        var isValid = Object.values(dataRequired).every(function(x) {
            return x;
        });
        return isValid;
    }, [
        bioBookingProfile,
        valueBioName
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (!isValidMaxLength && checkFieldRequired && valueBioName && valueBioName.trim().length > 0 && (JSON.stringify(socialLinkArr) !== JSON.stringify(socialLinkArrDefault) || valueBioName !== valueBioNameDefault || valueBioSubTitle !== valueBioSubtitleDefault || valueUrlImage !== valueUrlImageDefault || styleBioValue !== styleBioValueDefault || contentBioState !== contentBioStateDefault || isShowCoverImage !== defaultIsShowCoverImage || isAutoSwitch !== defaultIsAutoSwitch || imageRatio !== defaultImageRatio || imageCoverList !== defaultListCoverImage) || checkFieldRequired && !isEqual_default()(bioBookingProfile, defaultBookingProfile)) {
            return false;
        } else return true;
    }, [
        isValidMaxLength,
        valueBioName,
        socialLinkArr,
        socialLinkArrDefault,
        valueBioNameDefault,
        valueBioSubTitle,
        valueBioSubtitleDefault,
        valueUrlImage,
        valueUrlImageDefault,
        styleBioValue,
        styleBioValueDefault,
        contentBioState,
        contentBioStateDefault,
        isShowCoverImage,
        defaultIsShowCoverImage,
        isAutoSwitch,
        defaultIsAutoSwitch,
        imageRatio,
        defaultImageRatio,
        imageCoverList,
        defaultListCoverImage,
        bioBookingProfile,
        defaultBookingProfile,
        checkFieldRequired, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(socialLinkArr) !== JSON.stringify(socialLinkArrDefault) || valueBioName !== valueBioNameDefault || valueBioSubTitle !== valueBioSubtitleDefault || valueUrlImage !== valueUrlImageDefault || styleBioValue !== styleBioValueDefault || contentBioState !== contentBioStateDefault || isShowCoverImage !== defaultIsShowCoverImage || isAutoSwitch !== defaultIsAutoSwitch || imageRatio !== defaultImageRatio || imageCoverList !== defaultListCoverImage || !isEqual_default()(bioBookingProfile, defaultBookingProfile)) {
            return true;
        } else return false;
    }, [
        valueBioName,
        socialLinkArr,
        socialLinkArrDefault,
        valueBioNameDefault,
        valueBioSubTitle,
        valueBioSubtitleDefault,
        valueUrlImage,
        valueUrlImageDefault,
        styleBioValue,
        styleBioValueDefault,
        contentBioState,
        contentBioStateDefault,
        isShowCoverImage,
        defaultIsShowCoverImage,
        isAutoSwitch,
        defaultIsAutoSwitch,
        imageRatio,
        defaultImageRatio,
        imageCoverList,
        defaultListCoverImage,
        bioBookingProfile,
        defaultBookingProfile,
        checkFieldRequired, 
    ]);
    var imageCoverListSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(imageCoverList, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        imageCoverList
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultBioData = {
                uid: UID,
                sort_order: 1,
                enable: configs_const/* ENABLE_BLOCK */.C5,
                block_type: BLOCK_TYPE.BIO,
                title: titleBlockDefault,
                content_attributes: {
                    social_link_items: socialLinkListSortOrder,
                    bio_image: valueImageBase64 || valueUrlImage || defaultAvatar,
                    bio_image_base64: valueImageBase64,
                    bio_name: valueBioName,
                    bio_subtitle: valueBioSubTitle,
                    bio_content: contentBioState,
                    bio_image_name: valueNameImage,
                    bio_show_cover_image: isShowCoverImage,
                    bio_image_ratio: imageRatio,
                    bio_auto_switch: isAutoSwitch,
                    bio_cover_image_list: imageCoverList,
                    bio_booking_profile_display: bioBookingProfile.bio_booking_profile_display,
                    bio_booking_profile_title: bioBookingProfile.bio_booking_profile_title.trim(),
                    bio_booking_profile_description: bioBookingProfile.bio_booking_profile_description.trim(),
                    bio_booking_profile_button_label: bioBookingProfile.bio_booking_profile_button_label.trim()
                },
                style_attributes: {
                    style_display: styleBioValue
                }
            };
            onUpdateData(defaultBioData);
        } else {
            onUpdateData(Bio_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    social_link_items: socialLinkListSortOrder,
                    bio_image: valueImageBase64 || valueUrlImage || defaultAvatar,
                    bio_image_base64: valueImageBase64,
                    bio_name: valueBioName,
                    bio_subtitle: valueBioSubTitle,
                    bio_content: contentBioState,
                    bio_image_name: valueNameImage,
                    bio_show_cover_image: isShowCoverImage,
                    bio_image_ratio: imageRatio,
                    bio_auto_switch: isAutoSwitch,
                    bio_cover_image_list: imageCoverList,
                    bio_booking_profile_display: bioBookingProfile.bio_booking_profile_display,
                    bio_booking_profile_title: bioBookingProfile.bio_booking_profile_title.trim(),
                    bio_booking_profile_description: bioBookingProfile.bio_booking_profile_description.trim(),
                    bio_booking_profile_button_label: bioBookingProfile.bio_booking_profile_button_label.trim()
                },
                style_attributes: {
                    style_display: styleBioValue
                }
            }));
        }
    }, [
        styleBioValue,
        valueImageBase64,
        valueBioName,
        valueBioSubTitle,
        contentBioState,
        socialLinkListSortOrder,
        valueNameImage,
        valueUrlImage,
        isShowCoverImage,
        imageRatio,
        isAutoSwitch,
        imageCoverList,
        bioBookingProfile, 
    ]);
    var styleBioOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE1 */.uT.STYLE1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-1.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 1")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE1 */.uT.STYLE1
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE2 */.uT.STYLE2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-2.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 2")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE2 */.uT.STYLE2
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE3 */.uT.STYLE3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-3.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 3")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE3 */.uT.STYLE3
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE4 */.uT.STYLE4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-4.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 4")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE4 */.uT.STYLE4
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE5 */.uT.STYLE5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-5.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 5")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE5 */.uT.STYLE5
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE6 */.uT.STYLE6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-6.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 6")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE6 */.uT.STYLE6
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* BIO_DISPLAY_STYLES.STYLE7 */.uT.STYLE7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    // fit="cover"
                    src: "https://image.passio.eco/page-builder/page-builder/bio-layout/bio-style-layout-7.svg",
                    width: 96,
                    height: 96
                })
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat(t("ss_builder_bio_layout_title"), " 7")
            }),
            value: configs_const/* BIO_DISPLAY_STYLES.STYLE7 */.uT.STYLE7
        }, 
    ];
    var handleSelectStyleBio = function(arr) {
        if (arr && arr.length) {
            var valueStyle = arr[0];
            setStyleBioValue(valueStyle);
        }
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleChangeBioName = function(value) {
        setValueBioName(value);
    };
    var handleChangeBioSubTitle = function(value) {
        setValueBioSubTitle(value);
    };
    var handleDeleteImage = function() {
        setValueUrlImage(null);
        setValueImageBase64(null);
        setValueNameImage(null);
        setUploadedImageArr([]);
    };
    var onContentStateChange = function(value, editor) {
        var cCount = charCount(editor);
        setContentBioState(value);
        setCount(cCount);
    };
    var handleInitEditor = function(value, editor) {
        setCount(charCount(editor));
    };
    var handleSelectImageRatio = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            setImageRatio(valueRatio);
        }
    };
    var imageRate = (0,react.useMemo)(function() {
        return imageCoverListSortOrder && "".concat(imageCoverListSortOrder.length, "/").concat(IMAGE_COVER_MAX);
    }, [
        imageCoverListSortOrder
    ]);
    var handleOpenAddImageCover = function() {
        setIsOpenAddNewPopup(true);
        setIndexImageCoverEdit(null);
        setImageCoverEditData(null);
    };
    var handleSaveImageCover = function(data) {
        var imageSliderClone = cloneDeep_default()(imageCoverListSortOrder);
        if (Array.isArray(imageSliderClone)) {
            if (imageCoverEditData) {
                var indexEditItems = imageSliderClone.findIndex(function(x) {
                    return x.uid === imageCoverEditData.uid;
                });
                imageSliderClone[indexEditItems] = data;
            } else {
                if (imageSliderClone.length === 0) {
                    imageSliderClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = imageSliderClone.map(function(x) {
                        return x.sort_order;
                    });
                    imageSliderClone.push(Bio_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, Bio_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setImageCoverList(imageSliderClone);
            !imageCoverEditData && (0,block_libs/* scrollToNewItem */.i)(data === null || data === void 0 ? void 0 : data.uid);
        }
    };
    var reorder = function(start, end) {
        var result = Array.from(imageCoverListSortOrder);
        var ref = Bio_slicedToArray(result.splice(start, 1), 1), itemRemove = ref[0];
        result.splice(end, 0, itemRemove);
        var orderedImageCoverList = result.map(function(ele, index) {
            return Bio_objectSpread({}, ele, {
                sort_order: index + 1
            });
        });
        return orderedImageCoverList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setImageCoverList(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(index) {
        var imageSliderClone = cloneDeep_default()(imageCoverListSortOrder);
        var newImageItems = imageSliderClone && Array.isArray(imageSliderClone) && imageSliderClone.filter(function(ele, idx) {
            return idx !== index;
        });
        setImageCoverList(newImageItems);
    };
    var onDisableEnableImage = function(index, imageStatus) {
        var imageSliderClone = cloneDeep_default()(imageCoverListSortOrder);
        var newImageItems = imageSliderClone && Array.isArray(imageSliderClone) && imageSliderClone.map(function(ele, idx) {
            return idx === index ? Bio_objectSpread({}, ele, {
                enable: imageStatus
            }) : ele;
        });
        setImageCoverList(newImageItems);
    };
    var handleOpenEditImageCover = function(imageData, index) {
        setIsOpenAddNewPopup(true);
        setIndexImageCoverEdit(index);
        setImageCoverEditData(imageData);
    };
    var handleChangeProfile = function(data) {
        var dataCurrent = cloneDeep_default()(bioBookingProfile);
        setBioBookingFile(Bio_objectSpread({}, dataCurrent, data));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_bio_layout_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoScrollSelector/* default */.Z, {
                                elementId: elementId,
                                options: styleBioOptions,
                                value: styleBioValue,
                                onChange: handleSelectStyleBio
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_bio_avatar_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-[120px_auto] gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                        src: valueUrlImage || "https://i.ecomobi.com/ssp/passio-page/avatar-default.png",
                                        fit: "cover",
                                        style: {
                                            borderRadius: "8px",
                                            maxWidth: "120px",
                                            maxHeight: "120px",
                                            backgroundColor: "#EEEEEE"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-8 leading-4 text-[#8C8C8C]",
                                                children: t("ss_builder_theme_setting_background_content")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                        size: "middle",
                                                        color: valueUrlImage ? "primary" : "primary",
                                                        disabled: valueUrlImage ? false : true,
                                                        fill: "outline",
                                                        className: "",
                                                        onClick: handleDeleteImage,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                                            className: "w-[17px] h-[17px]",
                                                            fillColor: valueUrlImage ? "var(--adm-color-primary)" : "var(--adm-color-primary)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                                        onChange: handleImageUrl,
                                                        upload: function(file) {
                                                            return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                                        },
                                                        className: "flex-grow",
                                                        value: uploadedImageArr,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                            color: "primary",
                                                            fill: "solid",
                                                            size: "middle",
                                                            className: "w-full",
                                                            children: t("ss_builder_upload_button_label")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_format_invalid_content")
                                    })
                                ]
                            }),
                            isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_size_invalid_content")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_bio_name_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueBioName,
                                onChange: handleChangeBioName,
                                maxLength: 50,
                                placeholder: t("ss_builder_bio_name_title_placeholder")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueBioName.length, "/50")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_bio_sub_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueBioSubTitle,
                                onChange: handleChangeBioSubTitle,
                                maxLength: 80,
                                placeholder: t("ss_builder_bio_name_sub_placeholder")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueBioSubTitle.length, "/80")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_bio_text_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextV2_EditorComp, {
                                value: contentBioState,
                                onUpdateValue: onContentStateChange,
                                handleInit: handleInitEditor,
                                placeholder: t("ss_builder_block_description_placeholder")
                            }),
                            count <= configs_const/* EDITOR_MAX_LENGTH */.r7 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("text-[13px] leading-[17px] w-full text-right mt-2 text-[#999999]"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "".concat(count, "/").concat(configs_const/* EDITOR_MAX_LENGTH */.r7)
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("text-[13px] leading-[17px] w-full d-flex justify-between mt-2 gap-4 text-[red]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("ss_builder_text_editor_max_length", {
                                            editor_max_length: configs_const/* EDITOR_MAX_LENGTH */.r7
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "".concat(count, "/").concat(configs_const/* EDITOR_MAX_LENGTH */.r7)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-3 bg-white py-3 pl-3 text-[17px] leading-[22px] font-normal",
                children: t("ss_builder_social_network_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinkList, {
                socialLinkListSortOrder: socialLinkListSortOrder,
                callBackUpdateSocialLinkItems: function(data) {
                    return setSocialLinkArr(data);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[17px] leading-[22px] font-normal py-[12px] pl-[12px]",
                        children: t("ss_builder_cover_image")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "0px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] font-normal",
                                children: t("ss_builder_enable_shadow")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                defaultChecked: false,
                                checked: isShowCoverImage,
                                onChange: function(val) {
                                    return setIsShowCoverImage(val);
                                }
                            })
                        ]
                    }),
                    isShowCoverImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    margin: "0px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 pt-[13px] pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666] leading-[22px] font-normal mb-2",
                                        children: t("ss_builder_image_slider_ratio_selected_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: imageOptions(),
                                        value: [
                                            imageRatio
                                        ],
                                        onChange: handleSelectImageRatio,
                                        columns: 4,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    margin: "0px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666] font-normal",
                                        children: t("ss_builder_image_slider_auto_play_switch_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                        defaultChecked: false,
                                        checked: isAutoSwitch,
                                        onChange: function(val) {
                                            return setIsAutoSwitch(val);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isShowCoverImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-bio-editor-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between px-3 py-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666]",
                                        children: t("ss_builder_social_links_list_title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-grow justify-end gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                        size: "small",
                                        fill: "solid",
                                        color: "primary",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "3px 12px 3px 12px"
                                        },
                                        onClick: handleOpenAddImageCover,
                                        disabled: imageCoverListSortOrder.length >= IMAGE_COVER_MAX,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                className: "w-[15px] h-[15px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_add_new_label")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: imageRate
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    (imageCoverList === null || imageCoverList === void 0 ? void 0 : imageCoverList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                            onDragEnd: onDragEnd,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                droppableId: DROPPABLE_ID,
                                children: function(provided1, snapshot1) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", Bio_objectSpread({}, provided1.droppableProps, {
                                        ref: provided1.innerRef,
                                        className: "relative",
                                        children: [
                                            (imageCoverListSortOrder === null || imageCoverListSortOrder === void 0 ? void 0 : imageCoverListSortOrder.length) > 0 && imageCoverListSortOrder.map(function(ele, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                    draggableId: ele.uid,
                                                    index: index,
                                                    children: function(provided, snapshot) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", Bio_objectSpread({
                                                            ref: provided.innerRef
                                                        }, provided.draggableProps, provided.dragHandleProps, {
                                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio_CoverImageList, {
                                                                index: index,
                                                                imageData: ele,
                                                                onRemoveItem: onRemoveItem,
                                                                onDisableEnableImage: onDisableEnableImage,
                                                                callbackOpenEditImage: handleOpenEditImageCover
                                                            })
                                                        }));
                                                    }
                                                }, ele.uid);
                                            }),
                                            provided1.placeholder,
                                            !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                placeholderProps: placeholderProps1,
                                                content: t("ss_builder_placeholder_dragging_content"),
                                                style: {
                                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                    border: "1px dashed #1890FF",
                                                    borderRadius: "4px",
                                                    color: "#1890FF"
                                                }
                                            })
                                        ]
                                    }));
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIconEmpty */.yI, {
                                    className: "align-middle w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: t("ss_builder_image_list_empty_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: t("ss_builder_image_list_empty_content")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio_BookingProfileLink, {
                data: bioBookingProfile,
                onChange: handleChangeProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewPopup,
                onMaskClick: function() {
                    return setIsOpenAddNewPopup(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio_CoverImageAddNew, {
                    imageRatio: imageRatio,
                    callBackCancelImageCoverAddNew: function() {
                        return setIsOpenAddNewPopup(false);
                    },
                    handleSaveImageCover: handleSaveImageCover,
                    imageCoverEditData: imageCoverEditData,
                    indexImageCoverEdit: indexImageCoverEdit
                })
            })
        ]
    });
};
/* harmony default export */ var Bio = (BioComponent);

// EXTERNAL MODULE: ./src/features/share/IconRender/index.tsx
var IconRender = __webpack_require__(39608);
// EXTERNAL MODULE: ./src/features/share/icons/line-icon.tsx
var line_icon = __webpack_require__(45297);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
;// CONCATENATED MODULE: ./src/features/share/components/PopupHorizontalComponent/index.tsx
function PopupHorizontalComponent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupHorizontalComponent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupHorizontalComponent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function PopupHorizontalComponent(param) {
    var visible = param.visible, onMaskClick = param.onMaskClick, children = param.children, _position = param.position, position = _position === void 0 ? "bottom" : _position, _classNameBody = param.classNameBody, classNameBody = _classNameBody === void 0 ? "" : _classNameBody, _className = param.className, className = _className === void 0 ? "adm-popup-right" : _className, _style = param.style, style = _style === void 0 ? {} : _style, _title = param.title, title = _title === void 0 ? "" : _title, _subTitle = param.subTitle, subTitle = _subTitle === void 0 ? "" : _subTitle, _showConfirmButton = param.showConfirmButton, showConfirmButton = _showConfirmButton === void 0 ? false : _showConfirmButton, _mask = param.mask, mask = _mask === void 0 ? true : _mask, onConfirmButton = param.onConfirmButton, _confirmButtonLabel = param.confirmButtonLabel, confirmButtonLabel = _confirmButtonLabel === void 0 ? "" : _confirmButtonLabel, disabledConfirmButton = param.disabledConfirmButton, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popup */.GI, {
        visible: visible,
        onMaskClick: onMaskClick,
        position: position,
        bodyClassName: "adm-popup-body-horizontal",
        bodyStyle: {
            backgroundColor: "none"
        },
        className: className,
        mask: mask,
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("bg-[#fff] max-width-content-layout popup-body-horizontal m-auto relative h-full", "".concat(classNameBody)),
            style: PopupHorizontalComponent_objectSpread({}, style),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-header",
                    children: title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* NavBar */.l2, {
                        onBack: onClose,
                        style: {
                            "--height": "44px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "main-title",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sub-title",
                                children: subTitle
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-body overflow-y-auto",
                    children: children
                }),
                showConfirmButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                    onConfirm: onConfirmButton,
                    title: confirmButtonLabel,
                    isDisable: disabledConfirmButton
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/share/components/ListIconBuilder/index.tsx
function ListIconBuilder_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListIconBuilder_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ListIconBuilder_arrayLikeToArray(arr);
}
function ListIconBuilder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ListIconBuilder_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ListIconBuilder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ListIconBuilder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ListIconBuilder_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ListIconBuilder_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListIconBuilder_toConsumableArray(arr) {
    return ListIconBuilder_arrayWithoutHoles(arr) || ListIconBuilder_iterableToArray(arr) || ListIconBuilder_unsupportedIterableToArray(arr) || ListIconBuilder_nonIterableSpread();
}
function ListIconBuilder_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListIconBuilder_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListIconBuilder_arrayLikeToArray(o, minLen);
}














var PER_PAGE = 80;
var ListIconBuilder = function(props) {
    var callbackCancelListIcon = props.callbackCancelListIcon, callbackConfirmListIcon = props.callbackConfirmListIcon, defaultNameIcon = props.defaultNameIcon;
    var firstLoad = (0,react.useRef)(1);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(defaultNameIcon), valueIcon = ref[0], setValueIcon = ref[1];
    var ref1 = (0,react.useState)(null), valueUrlIcon = ref1[0], setValueUrlIcon = ref1[1];
    var ref2 = (0,react.useState)([]), listIconLine = ref2[0], setListIconLine = ref2[1];
    var ref3 = (0,react.useState)(true), hasMoreIconLine = ref3[0], setHasMoreIconLine = ref3[1];
    var ref4 = (0,react.useState)([]), listIconSolid = ref4[0], setListIconSolid = ref4[1];
    var ref5 = (0,react.useState)(true), hasMoreIconSolid = ref5[0], setHasMoreIconSolid = ref5[1];
    var ref6 = (0,react.useState)(configs_const/* STYLE_ICON.LINE */.Xl.LINE), style = ref6[0], setStyle = ref6[1];
    var ref7 = (0,react.useState)(1), page1 = ref7[0], setPage = ref7[1];
    var ref8 = (0,react.useState)(null), category = ref8[0], setCategory = ref8[1];
    var ref9 = (0,react.useState)(null), inputValue = ref9[0], setInputValue = ref9[1];
    var ref10 = (0,react.useState)(false), emptySearch = ref10[0], setEmptySearch = ref10[1];
    var ref11 = (0,react.useState)(false), isOpenSelectedCategory = ref11[0], setIsOpenSelectedCategory = ref11[1];
    var ref12 = (0,react.useState)(null), valueCategory = ref12[0], setValueCategory = ref12[1];
    var ref13 = (0,react.useState)([]), listCategories = ref13[0], setListCategories = ref13[1];
    var ref14 = (0,react.useState)(false), disableTabLine = ref14[0], setDisableTabLine = ref14[1];
    var ref15 = (0,react.useState)(false), disableTabSolid = ref15[0], setDisableTabSolid = ref15[1];
    (0,react.useEffect)(function() {
        setValueIcon(defaultNameIcon);
    }, [
        defaultNameIcon
    ]);
    var handleConfirmAddIcon = function() {
        handleCancelSelectedIcon();
        callbackConfirmListIcon({
            valueIcon: valueIcon,
            valueUrlIcon: valueUrlIcon
        });
    };
    var handleCancelSelectedIcon = function() {
        callbackCancelListIcon();
    };
    var InfiniteScrollContent = function(param) {
        var hasMore = param.hasMore;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("ss_builder_loading_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {})
                ]
            }) : null
        });
    };
    function loadMoreIconLine() {
        return _loadMoreIconLine.apply(this, arguments);
    }
    function _loadMoreIconLine() {
        _loadMoreIconLine = ListIconBuilder_asyncToGenerator(runtime_default().mark(function _callee() {
            var keyWord, params, response, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyWord = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                        _ctx.next = 3;
                        return (0,sleep/* sleep */._)(1000);
                    case 3:
                        params = {
                            page: page1,
                            per_page: PER_PAGE,
                            key_word: keyWord || inputValue,
                            style: style,
                            category: valueCategory,
                            visible: configs_const/* VISIBLE_ICON.SHOW */.Gv.SHOW
                        };
                        _ctx.next = 6;
                        return (0,api/* fetchIconBuilder */.Lb)(params);
                    case 6:
                        response = _ctx.sent;
                        if (response) setListIconLine(function(value) {
                            return ListIconBuilder_toConsumableArray(value).concat(ListIconBuilder_toConsumableArray(response));
                        });
                        handleSetPage(page1 + 1);
                        if (Array.isArray(response) && response.length === 0) setHasMoreIconLine(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _loadMoreIconLine.apply(this, arguments);
    }
    function loadMoreIconSolid() {
        return _loadMoreIconSolid.apply(this, arguments);
    }
    function _loadMoreIconSolid() {
        _loadMoreIconSolid = ListIconBuilder_asyncToGenerator(runtime_default().mark(function _callee() {
            var keyWord, params, response, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyWord = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                        _ctx.next = 3;
                        return (0,sleep/* sleep */._)(1000);
                    case 3:
                        params = {
                            page: page1,
                            per_page: PER_PAGE,
                            key_word: keyWord || inputValue,
                            style: style,
                            category: valueCategory,
                            visible: configs_const/* VISIBLE_ICON.SHOW */.Gv.SHOW
                        };
                        _ctx.next = 6;
                        return (0,api/* fetchIconBuilder */.Lb)(params);
                    case 6:
                        response = _ctx.sent;
                        if (response) setListIconSolid(function(value) {
                            return ListIconBuilder_toConsumableArray(value).concat(ListIconBuilder_toConsumableArray(response));
                        });
                        handleSetPage(page1 + 1);
                        if (Array.isArray(response) && response.length === 0) setHasMoreIconSolid(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _loadMoreIconSolid.apply(this, arguments);
    }
    console.log("listIconLine", listIconLine);
    var listIconOptionsLine = listIconLine && Array.isArray(listIconLine) && listIconLine.map(function(ele) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                iconName: ele.icon_file_name
            }),
            value: ele.icon_file_name
        };
    });
    console.log("listIconSolid", listIconSolid);
    var listIconOptionsSolid = listIconSolid && Array.isArray(listIconSolid) && listIconSolid.map(function(ele) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                iconName: ele.icon_file_name
            }),
            value: ele.icon_file_name
        };
    });
    var firstCategory = {
        label: t("ss_builder_box_icon_filter_category_all"),
        value: null
    };
    var listCategoryOptions = listCategories && Array.isArray(listCategories) && listCategories.map(function(ele) {
        return {
            label: ele.name,
            value: ele.name
        };
    });
    listCategoryOptions.unshift(firstCategory);
    var handleSelectedIconLine = function(value) {
        if (value && value.length) {
            setValueIcon(value[0]);
            var urlIcon = listIconLine.find(function(x) {
                return x.icon_file_name === value[0];
            }).url;
            setValueUrlIcon(urlIcon);
        }
    };
    var handleSelectedIconSolid = function(value) {
        if (value && value.length) {
            setValueIcon(value[0]);
            var urlIcon = listIconSolid.find(function(x) {
                return x.icon_file_name === value[0];
            }).url;
            setValueUrlIcon(urlIcon);
        }
    };
    var handleRequestSearchIcon = function() {
        var _ref = ListIconBuilder_asyncToGenerator(runtime_default().mark(function _callee(value) {
            var response, params;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = null;
                        params = {
                            page: 1,
                            per_page: PER_PAGE,
                            key_word: value,
                            style: style,
                            category: valueCategory,
                            visible: configs_const/* VISIBLE_ICON.SHOW */.Gv.SHOW
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* fetchIconBuilder */.Lb)(params);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        setEmptySearch(response.length === 0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        // if (style === STYLE_ICON.LINE) {
        //   setListIconLine(response);
        //   if (Array.isArray(response) && response.length === 0)
        //     setHasMoreIconLine(false);
        // } else {
        //   setListIconSolid(response);
        //   if (Array.isArray(response) && response.length === 0)
        //     setHasMoreIconSolid(false);
        // }
        // if (style === STYLE_ICON.LINE) {
        //   loadMoreIconLine(value);
        // } else {
        //   loadMoreIconSolid(value);
        // }
        }));
        return function handleRequestSearchIcon(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearchIcon = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        setInputValue(value);
    };
    var handleClearSearchIcon = function() {
        setInputValue(null);
    // handleRequestSearchIcon(null);
    };
    var handleSetPage = function(page) {
        setPage(page);
    };
    var handleSetActiveTab = function(value) {
        if (value === configs_const/* STYLE_ICON.LINE */.Xl.LINE) {
            setDisableTabSolid(true);
        } else {
            setDisableTabLine(true);
        }
        handleSetPage(1);
        setStyle(value);
    };
    var useDebounceSearch = (0,esm/* useDebounce */.Nr)(inputValue, 700);
    var useDebounceCategory = (0,esm/* useDebounce */.Nr)(valueCategory, 700);
    var useDebounceStyle = (0,esm/* useDebounce */.Nr)(style, 700);
    (0,react.useEffect)(function() {
        handleSetPage(1);
        if (style === configs_const/* STYLE_ICON.LINE */.Xl.LINE) {
            setListIconLine([]);
            setHasMoreIconLine(true);
            setDisableTabSolid(false);
        } else {
            setListIconSolid([]);
            setHasMoreIconSolid(true);
            setDisableTabLine(false);
        }
        handleRequestSearchIcon(inputValue);
    }, [
        useDebounceSearch,
        useDebounceCategory,
        useDebounceStyle,
        style
    ]);
    var handleOpenListCategories = function(value) {
        setIsOpenSelectedCategory(value);
    };
    var handleFetchCategories = function() {
        var _ref = ListIconBuilder_asyncToGenerator(runtime_default().mark(function _callee() {
            var value, response, params, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        value = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null;
                        response = null;
                        params = {
                            page: 1,
                            per_page: 100,
                            key_word: value
                        };
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,api/* fetchCategoryBuilder */.FU)(params);
                    case 6:
                        response = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        setListCategories(response);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function handleFetchCategories() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenPopupFilter = function() {
        handleOpenListCategories(true);
        handleFetchCategories();
    };
    var handleSelectedCategory = function(value) {
        if (value && value.length) {
            handleSetPage(1);
            if (style === configs_const/* STYLE_ICON.LINE */.Xl.LINE) {
                setHasMoreIconLine(true);
            } else {
                setHasMoreIconSolid(true);
            }
            setValueCategory(value[0]);
            handleOpenListCategories(false);
        }
    };
    var EmptySearch = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "result-empty flex flex-col justify-center text-center gap-2 mt-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    src: "https://image.passio.eco/page-builder/ssp-landing-page/product-searching-empty-image.png",
                    width: 260,
                    height: 128,
                    className: "m-auto"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: t("ss_builder_box_icon_empty_search")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sub-title",
                    children: t("ss_builder_box_icon_empty_searching_description")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-h-full overflow-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "box-icon p-3 pt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search-bar-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                                    placeholder: t("ss_builder_box_icon_search_bar_placeholder"),
                                    style: {
                                        "--height": "36px"
                                    },
                                    onSearch: function(val) {
                                        return handleSearchIcon(val);
                                    },
                                    onChange: function(val) {
                                        return handleSearchIcon(val);
                                    },
                                    onClear: function() {
                                        return handleClearSearchIcon();
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                    size: "small",
                                    className: "button-filter",
                                    fill: "none",
                                    onClick: function() {
                                        return handleOpenPopupFilter();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* FilterIcon */.k1, {
                                            width: 15,
                                            height: 15,
                                            fillColor: valueCategory ? "var(--adm-color-primary)" : "#333"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: classnames_default()("button-title", valueCategory ? "text-primary" : "text-[#333]"),
                                            children: t("ss_builder_box_icon_button_filter")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Tabs */.mQ, {
                            defaultActiveKey: style,
                            activeLineMode: "auto",
                            stretch: false,
                            onChange: function(key) {
                                return handleSetActiveTab(key);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tabs.Tab */.mQ.Tab, {
                                    title: configs_const/* STYLE_ICON_TITLE.LINE */.KO.LINE,
                                    disabled: disableTabLine,
                                    children: !emptySearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                                columns: 4,
                                                options: listIconOptionsLine,
                                                onChange: handleSelectedIconLine,
                                                value: [
                                                    valueIcon
                                                ],
                                                style: {
                                                    "--border": "solid transparent 1px",
                                                    "--checked-border": "solid var(--adm-color-primary) 1px",
                                                    "--checked-color": "#fff",
                                                    "--color": "#f5f5f5",
                                                    "--border-radius": "4px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* InfiniteScroll */.v_, {
                                                loadMore: loadMoreIconLine,
                                                hasMore: hasMoreIconLine,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                                                    hasMore: hasMoreIconLine
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch, {})
                                }, configs_const/* STYLE_ICON.LINE */.Xl.LINE),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tabs.Tab */.mQ.Tab, {
                                    title: configs_const/* STYLE_ICON_TITLE.SOLID */.KO.SOLID,
                                    disabled: disableTabSolid,
                                    children: !emptySearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                                columns: 4,
                                                options: listIconOptionsSolid,
                                                onChange: handleSelectedIconSolid,
                                                value: [
                                                    valueIcon
                                                ],
                                                style: {
                                                    "--border": "solid transparent 1px",
                                                    "--checked-border": "solid var(--adm-color-primary) 1px",
                                                    "--checked-color": "#fff",
                                                    "--color": "#f5f5f5",
                                                    "--border-radius": "4px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* InfiniteScroll */.v_, {
                                                loadMore: loadMoreIconSolid,
                                                hasMore: hasMoreIconSolid,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                                                    hasMore: hasMoreIconSolid
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch, {})
                                }, configs_const/* STYLE_ICON.SOLID */.Xl.SOLID)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                onConfirm: valueIcon ? handleConfirmAddIcon : function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupHorizontalComponent, {
                visible: isOpenSelectedCategory,
                onMaskClick: function() {
                    return handleOpenListCategories(false);
                },
                title: t("ss_builder_box_icon_filter_category_title"),
                subTitle: t("ss_builder_box_icon_filter_category_sub_title"),
                onClose: function() {
                    return handleOpenListCategories(false);
                },
                classNameBody: "",
                mask: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-2 bg-[#f5f5f5] h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                        columns: 2,
                        options: listCategoryOptions,
                        onChange: handleSelectedCategory,
                        value: [
                            valueCategory
                        ],
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px",
                            "--checked-color": "#fff",
                            "--color": "#fff",
                            "--border-radius": "4px"
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_ListIconBuilder = (ListIconBuilder);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonLink/LinkLayouts/index.tsx






var LinkLayouts = function(props) {
    var linkLayout = props.linkLayout, onUpdateLinkLayout = props.onUpdateLinkLayout, isMultiLink = props.isMultiLink;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var elementId = (0,react.useMemo)(function() {
        return "e" + Math.random().toString(36).slice(2, 7);
    }, []);
    var linkLayoutsOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/text-right-layout.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_link_text_right_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/text-left-layout.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_link_text_left_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/text-under-layout.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_link_text_under_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER
        }, 
    ];
    var linkLayoutsOptionsForMulti = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextRightMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT,
                className: "mt-1",
                children: t("ss_builder_link_text_right_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextLeftMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT,
                className: "mt-1",
                children: t("ss_builder_link_text_left_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextUnderMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER,
                className: "mt-1",
                children: t("ss_builder_link_text_under_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextZigZagMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG,
                className: "mt-1",
                children: t("ss_builder_link_text_zig_zag_layout")
            }),
            value: configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG
        }, 
    ];
    var handleSelectLinkLayout = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            onUpdateLinkLayout(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#666666]",
                children: t("ss_builder_bio_layout_title")
            }),
            isMultiLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoScrollSelector/* default */.Z, {
                elementId: elementId,
                options: linkLayoutsOptionsForMulti,
                value: linkLayout,
                onChange: handleSelectLinkLayout,
                isMulti: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: linkLayoutsOptions,
                value: [
                    linkLayout
                ],
                onChange: handleSelectLinkLayout,
                columns: 3,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px"
                }
            })
        ]
    });
};
/* harmony default export */ var ButtonLink_LinkLayouts = (LinkLayouts);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonLink/LinkStyleDisplay/index.tsx






var LinkStyleDisplay = function(props) {
    var styleLinkDisplay = props.styleLinkDisplay, onUpdateStyleLinkDisplay = props.onUpdateStyleLinkDisplay, isMulti = props.isMulti;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var elementId = (0,react.useMemo)(function() {
        return "e" + Math.random().toString(36).slice(2, 7);
    }, []);
    var styleLinkOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/text-and-icon-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_text_and_icon_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/text-and-image-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_text_and_image_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/only-text-style.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_text_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT
        }, 
    ];
    var styleLinkOptionsForMulti = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextAndIconMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON,
                className: "mt-1",
                children: t("ss_builder_style_tab_text_and_icon_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/TextAndImageMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE,
                className: "mt-1",
                children: t("ss_builder_style_tab_text_and_image_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/OnlyTextMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT,
                className: "mt-1",
                children: t("ss_builder_style_tab_text_label")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/OnlyIconMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON,
                className: "mt-1",
                children: t("ss_builder_style_tab_only_icon")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/OnlyImageMulti.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: elementId + "-" + configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE,
                className: "mt-1",
                children: t("ss_builder_style_tab_only_image")
            }),
            value: configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE
        }, 
    ];
    var handleSelectStyleLinkDisplay = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            onUpdateStyleLinkDisplay(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#666666]",
                children: t("ss_builder_style")
            }),
            isMulti ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoScrollSelector/* default */.Z, {
                elementId: elementId,
                options: styleLinkOptionsForMulti,
                value: styleLinkDisplay,
                onChange: handleSelectStyleLinkDisplay,
                isMulti: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: styleLinkOptions,
                value: [
                    styleLinkDisplay
                ],
                onChange: handleSelectStyleLinkDisplay,
                columns: 3,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px"
                }
            })
        ]
    });
};
/* harmony default export */ var ButtonLink_LinkStyleDisplay = (LinkStyleDisplay);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonLink/LinkTemplateSelection/index.tsx






var LinkTemplateSelection = function(props) {
    var linkTemplateDefault = props.linkTemplateDefault, onUpdateLinkTemplate = props.onUpdateLinkTemplate, onCancelLinkTemplate = props.onCancelLinkTemplate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(linkTemplateDefault), linkTemplate = ref[0], setLinkTemplate = ref[1];
    (0,react.useEffect)(function() {
        if (linkTemplateDefault) setLinkTemplate(linkTemplateDefault);
    }, [
        linkTemplateDefault
    ]);
    var linkLayoutsOptions = configs_const/* LINK_TEMPLATE_ARR.map */.hV.map(function(ele) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: ele.image
            }),
            value: ele.value
        };
    });
    var handleSelectLinkTemplate = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setLinkTemplate(value);
        }
    };
    var handleSaveLinkTemplate = function() {
        onUpdateLinkTemplate(linkTemplate);
        onCancelLinkTemplate();
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (!linkTemplate || linkTemplate === linkTemplateDefault) {
            return true;
        } else return false;
    }, [
        linkTemplate,
        linkTemplateDefault
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_sample_selection_label")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: linkLayoutsOptions,
                value: [
                    linkTemplate
                ],
                onChange: handleSelectLinkTemplate,
                columns: 1,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    margin: "16px 12px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: onCancelLinkTemplate,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: isDisableBtnSave,
                            color: "primary",
                            onClick: handleSaveLinkTemplate,
                            children: t("ss_builder_done_panel")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ButtonLink_LinkTemplateSelection = (LinkTemplateSelection);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonLink/index.tsx
function ButtonLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




















var LINK_HEADING_MAXIMUM = 100;
var LINK_DESCRIPTION_MAXIMUM = 250;
var BLOCK_TITLE_MAXIMUM = 50;
var ButtonLink_BLOCK_DESCRIPTION_MAXIMUM = 250;
var ButtonLink = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, setButtonLoading = props.setButtonLoading, handleCancelBlock = props.handleCancelBlock, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "button-link-".concat((0,v4/* default */.Z)());
    // const edittingBlock = useAppSelector((state) => state.edittingBlock);
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    var defaultValueEdit = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = "Link";
    var originUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref = defaultValueEdit.content_attributes) === null || ref === void 0 ? void 0 : ref.origin_url) || "";
    var affiliateUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref1 = defaultValueEdit.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.target_url) || "";
    var buttonSizeDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref2 = defaultValueEdit.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.button_size) || "middle";
    var buttonContentDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref3 = defaultValueEdit.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.button_content) || "";
    var buttonLinkDescriptionDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref4 = defaultValueEdit.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.button_description) || "";
    var buttonIconDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref5 = defaultValueEdit.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.button_icon) || configs_const/* TAB_ICON_DEFAULT */.FL;
    var buttonIconUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref6 = defaultValueEdit.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.button_icon_url) || null;
    var hasAffiliateUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref7 = defaultValueEdit.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.use_aff_url) ? !!((defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref8 = defaultValueEdit.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.use_aff_url) === 1) : true;
    var openInNewTabDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref9 = defaultValueEdit.content_attributes) === null || ref9 === void 0 ? void 0 : ref9.open_new_tab) || false;
    var ref18 = (0,react.useState)(false), isEcomerce = ref18[0], setIsEcomerce = ref18[1];
    var imageDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref10 = defaultValueEdit.content_attributes) === null || ref10 === void 0 ? void 0 : ref10.image) || null;
    var defaultLinkData = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref11 = defaultValueEdit.content_attributes) === null || ref11 === void 0 ? void 0 : ref11.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: originUrlDefault
    };
    var styleLinkDisplayDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref12 = defaultValueEdit.style_attributes) === null || ref12 === void 0 ? void 0 : ref12.button_link_style) || configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON;
    var linkLayoutDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref13 = defaultValueEdit.style_attributes) === null || ref13 === void 0 ? void 0 : ref13.button_link_layout) || configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    var linkTemplateDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref14 = defaultValueEdit.style_attributes) === null || ref14 === void 0 ? void 0 : ref14.button_link_template) || configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1;
    var blockTitleDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref15 = defaultValueEdit.content_attributes) === null || ref15 === void 0 ? void 0 : ref15.block_title) || "";
    var blockDescriptionDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref16 = defaultValueEdit.content_attributes) === null || ref16 === void 0 ? void 0 : ref16.block_description) || "";
    var ref19 = (0,react.useState)(buttonSizeDefault), buttonSize = ref19[0], setButtonSize = ref19[1];
    var ref20 = (0,react.useState)(buttonContentDefault), buttonContent = ref20[0], setButtonContent = ref20[1];
    var ref21 = (0,react.useState)(buttonLinkDescriptionDefault), buttonLinkDescription = ref21[0], setButtonLinkDescription = ref21[1];
    var ref22 = (0,react.useState)(buttonIconDefault), buttonIcon = ref22[0], setButtonIcon = ref22[1];
    var ref23 = (0,react.useState)(buttonIconUrlDefault), buttonIconUrl = ref23[0], setButtonIconUrl = ref23[1];
    var ref24 = (0,react.useState)(false), isOpenSelectedIcon = ref24[0], setIsOpenSelectedIcon = ref24[1];
    var ref25 = (0,react.useState)(false), isOpenTemplateSelection = ref25[0], setIsOpenTemplateSelection = ref25[1];
    var ref26 = (0,react.useState)(originUrlDefault), originUrl = ref26[0], setOriginUrl = ref26[1];
    var ref27 = (0,react.useState)(affiliateUrlDefault), affiliateUrl = ref27[0], setAffiliateUrl = ref27[1];
    var ref28 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref28[0], setHasAffiliateUrl = ref28[1];
    var ref29 = (0,react.useState)(defaultLinkData), linkData1 = ref29[0], setLinkData = ref29[1];
    var ref30 = (0,react.useState)(openInNewTabDefault), openNewTab = ref30[0], setOpenNewTab = ref30[1];
    var ref31 = (0,react.useState)(false), isValidUrl = ref31[0], setIsValidUrl = ref31[1];
    var ref32 = (0,react.useState)(false), isLoadingBtn = ref32[0], setIsLoadingBtn = ref32[1];
    var ref33 = (0,react.useState)(false), isCheckDisableBtnSave = ref33[0], setIsCheckDisableBtnSave = ref33[1];
    var ref34 = (0,react.useState)(styleLinkDisplayDefault), styleLinkDisplay = ref34[0], setStyleLinkDisplay = ref34[1];
    var ref35 = (0,react.useState)(linkLayoutDefault), linkLayout = ref35[0], setLinkLayout = ref35[1];
    var ref36 = (0,react.useState)(linkTemplateDefault), linkTemplate = ref36[0], setLinkTemplate = ref36[1];
    var ref37 = (0,react.useState)([]), uploadedImageArr = ref37[0], setUploadedImageArr = ref37[1];
    var ref38 = (0,react.useState)(imageDefault), valueUrlImage = ref38[0], setValueUrlImage = ref38[1];
    var ref39 = (0,react.useState)(null), valueNameImage = ref39[0], setValueNameImage = ref39[1];
    var ref40 = (0,react.useState)(null), valueImageBase64 = ref40[0], setValueImageBase64 = ref40[1];
    var ref41 = (0,react.useState)(false), isValidFileFormat = ref41[0], setIsValidFileFormat = ref41[1];
    var ref42 = (0,react.useState)(false), isValidFileSize = ref42[0], setIsValidFileSize = ref42[1];
    var ref43 = (0,react.useState)(blockTitleDefault), blockTitle = ref43[0], setBlockTitle = ref43[1];
    var ref44 = (0,react.useState)(blockDescriptionDefault), blockDescription = ref44[0], setBlockDescription = ref44[1];
    var checkEcomerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcomerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcomerce(linkData1.target_url);
        } else if (originUrl) checkEcomerce(originUrl);
    }, [
        originUrl,
        linkData1
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultImageData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.BUTTON_LINK,
                title: titleBlockDefault,
                content_attributes: {
                    button_content: buttonContent,
                    button_icon: buttonIcon,
                    button_icon_url: buttonIconUrl,
                    use_aff_url: hasAffiliateUrl === true ? 1 : 2,
                    target_url: affiliateUrl,
                    origin_url: originUrl,
                    button_description: buttonLinkDescription,
                    image: valueImageBase64 || valueUrlImage,
                    image_name: valueNameImage,
                    link_data: linkData1,
                    image_base64: valueImageBase64,
                    open_new_tab: isEcomerce ? true : openNewTab,
                    is_ecomerce: isEcomerce,
                    block_title: blockTitle,
                    block_description: blockDescription
                },
                style_attributes: {
                    button_size: buttonSize,
                    button_link_template: linkTemplate,
                    button_link_layout: linkLayout,
                    button_link_style: styleLinkDisplay
                }
            };
            onUpdateData(defaultImageData);
        } else {
            onUpdateData(ButtonLink_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    button_content: buttonContent,
                    button_icon: buttonIcon,
                    button_icon_url: buttonIconUrl,
                    use_aff_url: hasAffiliateUrl === true ? 1 : 2,
                    target_url: affiliateUrl,
                    origin_url: originUrl,
                    button_description: buttonLinkDescription,
                    image: valueImageBase64 || valueUrlImage,
                    image_name: valueNameImage,
                    image_base64: valueImageBase64,
                    open_new_tab: isEcomerce ? true : openNewTab,
                    is_ecomerce: isEcomerce,
                    link_data: linkData1,
                    block_title: blockTitle,
                    block_description: blockDescription
                },
                style_attributes: {
                    button_size: buttonSize,
                    button_link_template: linkTemplate,
                    button_link_layout: linkLayout,
                    button_link_style: styleLinkDisplay
                }
            }));
        }
    }, [
        buttonIconUrl,
        buttonContent,
        buttonIcon,
        buttonSize,
        hasAffiliateUrl,
        affiliateUrl,
        originUrl,
        buttonLinkDescription,
        valueImageBase64,
        valueUrlImage,
        valueNameImage,
        linkTemplate,
        linkLayout,
        styleLinkDisplay,
        linkData1,
        openNewTab,
        isEcomerce,
        blockDescription,
        blockTitle, 
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if ((originUrl || linkData1.value) && (buttonContent && styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT || buttonIcon && styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON || valueUrlImage && styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE) && (buttonContent !== buttonContentDefault || buttonLinkDescription !== buttonLinkDescriptionDefault || buttonIcon !== buttonIconDefault || buttonSize !== buttonSizeDefault || originUrl !== originUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || linkTemplate !== linkTemplateDefault || styleLinkDisplay !== styleLinkDisplayDefault || linkLayout !== linkLayoutDefault || valueUrlImage !== imageDefault || openNewTab !== openInNewTabDefault || blockDescription !== blockDescriptionDefault || blockTitle !== blockTitleDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault) && !isValidUrl && !isCheckDisableBtnSave) {
            return false;
        } else return true;
    }, [
        buttonContent,
        buttonContentDefault,
        originUrl,
        originUrlDefault,
        buttonIcon,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        buttonIconDefault,
        isValidUrl,
        buttonSize,
        buttonSizeDefault,
        isCheckDisableBtnSave,
        buttonLinkDescription,
        buttonLinkDescriptionDefault,
        linkTemplate,
        linkTemplateDefault,
        styleLinkDisplay,
        styleLinkDisplayDefault,
        valueUrlImage,
        imageDefault,
        linkLayout,
        linkLayoutDefault,
        openNewTab,
        openInNewTabDefault,
        linkData1.value,
        blockDescription,
        blockDescriptionDefault,
        blockTitle,
        blockTitleDefault, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (buttonContent !== buttonContentDefault || originUrl !== originUrlDefault || buttonIcon !== buttonIconDefault || buttonSize !== buttonSizeDefault || linkTemplate !== linkTemplateDefault || styleLinkDisplay !== styleLinkDisplayDefault || linkLayout !== linkLayoutDefault || valueUrlImage !== imageDefault || buttonLinkDescription !== buttonLinkDescriptionDefault || blockDescription !== blockDescriptionDefault || blockTitle !== blockTitleDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || !isEqual_default()(linkData1, defaultLinkData)) {
            return true;
        } else return false;
    }, [
        buttonContent,
        buttonContentDefault,
        originUrl,
        originUrlDefault,
        buttonIcon,
        buttonIconDefault,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        buttonSize,
        buttonSizeDefault,
        linkTemplate,
        linkTemplateDefault,
        styleLinkDisplay,
        styleLinkDisplayDefault,
        valueUrlImage,
        imageDefault,
        linkLayout,
        linkLayoutDefault,
        buttonLinkDescription,
        buttonLinkDescriptionDefault,
        blockDescription,
        blockDescriptionDefault,
        blockTitle,
        blockTitleDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        setButtonLoading(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var onUpdateLinkData = function(linkData) {
        if (linkData.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setOriginUrl(linkData.value);
        } else {
            setOriginUrl(null);
        }
        setLinkData(linkData);
    };
    var buttonSizeOptions = [
        {
            label: t("ss_builder_button_link_small_size_label"),
            value: "small"
        },
        {
            label: t("ss_builder_button_link_middle_size_label"),
            value: "middle"
        },
        {
            label: t("ss_builder_button_link_large_size_label"),
            value: "large"
        }, 
    ];
    var handleSelectButtonSize = function(arr) {
        if (arr && arr.length) {
            var valueSize = arr[0];
            setButtonSize(valueSize);
        }
    };
    (0,react.useEffect)(function() {
        setAffiliateUrl(linkData1.target_url);
    }, [
        linkData1.target_url
    ]);
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var handleOpenSelectedIcon = function() {
        setIsOpenSelectedIcon(true);
    };
    var handleConfirmListIcon = function(data) {
        var valueIcon = data.valueIcon, valueUrlIcon = data.valueUrlIcon;
        setButtonIcon(valueIcon);
        setButtonIconUrl(valueUrlIcon);
    };
    var handleChangeButtonContent = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= LINK_HEADING_MAXIMUM) {
            setButtonContent(data);
        }
    };
    var handleChangeButtonLinkDescription = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= LINK_DESCRIPTION_MAXIMUM) {
            setButtonLinkDescription(data);
        }
    };
    var handleChangeBlockTitle = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= BLOCK_TITLE_MAXIMUM) setBlockTitle(data);
    };
    var handleChangeBlockDescription = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= ButtonLink_BLOCK_DESCRIPTION_MAXIMUM) setBlockDescription(data);
    };
    var handleCancelListIcon = function() {
        setIsOpenSelectedIcon(false);
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsCheckDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsCheckDisableBtnSave,
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_sample_selection_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: (ref17 = configs_const/* LINK_TEMPLATE_ARR */.hV === null || configs_const/* LINK_TEMPLATE_ARR */.hV === void 0 ? void 0 : configs_const/* LINK_TEMPLATE_ARR.find */.hV.find(function(x) {
                                return x.value === linkTemplate;
                            })) === null || ref17 === void 0 ? void 0 : ref17.image
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                            block: true,
                            color: "default",
                            size: "middle",
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "16px",
                                gap: "5px",
                                borderColor: "var(--adm-color-primary)",
                                color: "var(--adm-color-primary)"
                            },
                            onClick: function() {
                                return setIsOpenTemplateSelection(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: "var(--adm-color-primary)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("ss_builder_sampling_change_label")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_button_link_placeholder_content_title"),
                                value: blockTitle || "",
                                onChange: function(val) {
                                    handleChangeBlockTitle(val);
                                },
                                maxLength: BLOCK_TITLE_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(blockTitle.length, "/").concat(BLOCK_TITLE_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_block_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                value: blockDescription || "",
                                onChange: function(val) {
                                    handleChangeBlockDescription(val);
                                },
                                maxLength: ButtonLink_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(blockDescription.length, "/").concat(ButtonLink_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_LinkStyleDisplay, {
                        styleLinkDisplay: styleLinkDisplay,
                        onUpdateStyleLinkDisplay: function(val) {
                            return setStyleLinkDisplay(val);
                        }
                    }),
                    styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[15px] text-[#666666]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-red-600",
                                                children: "*"
                                            }),
                                            t("ss_builder_button_link_icon_title")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                style: {
                                                    padding: buttonIcon ? "7px 10px 1px 10px" : "7px 10px 3px 10px",
                                                    backgroundColor: "#F0F0F0",
                                                    border: "none"
                                                },
                                                onClick: handleOpenSelectedIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                                    type: IconRender/* TypeIconEnum.SETTING */.l.SETTING,
                                                    iconName: buttonIcon !== null && buttonIcon !== void 0 ? buttonIcon : configs_const/* TAB_ICON_DEFAULT */.FL
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-row gap-2 justify-between grow",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                    block: true,
                                                    color: "primary",
                                                    size: "middle",
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        gap: "5px"
                                                    },
                                                    onClick: handleOpenSelectedIcon,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                            className: "w-[18px] h-[18px]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-[17px] leading-6",
                                                            children: t("ss_builder_button_link_icon_btn_selection_label")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[15px] leading-[150%] text-[#666666]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-red-600",
                                                children: "*"
                                            }),
                                            t("ss_builder_image_selection_label")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-[120px_auto] gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                src: valueUrlImage !== null && valueUrlImage !== void 0 ? valueUrlImage : "https://i.ecomobi.com/ssp/passio-page/image-default.png",
                                                fit: "cover",
                                                style: {
                                                    borderRadius: "8px",
                                                    maxWidth: "120px",
                                                    maxHeight: "120px",
                                                    backgroundColor: "#EEEEEE",
                                                    border: "1px solid #EEEEEE"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-8 leading-4 text-[#8C8C8C] text-xs",
                                                        children: t("ss_builder_theme_setting_background_content")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex gap-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                                            onChange: handleImageUrl,
                                                            upload: function(file) {
                                                                return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                                            },
                                                            className: "flex-grow",
                                                            value: uploadedImageArr,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                                color: "primary",
                                                                fill: "solid",
                                                                size: "middle",
                                                                className: "w-full",
                                                                children: t("ss_builder_upload_button_label")
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-1 items-center mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                                fillColor: "#FF3141",
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#FF3141]",
                                                children: t("ss_builder_upload_file_format_invalid_content")
                                            })
                                        ]
                                    }),
                                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-1 items-center mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                                fillColor: "#FF3141",
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#FF3141]",
                                                children: t("ss_builder_upload_file_size_invalid_content")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    styleLinkDisplay !== configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_LinkLayouts, {
                                linkLayout: linkLayout,
                                onUpdateLinkLayout: function(val) {
                                    return setLinkLayout(val);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_button_link_size_selection_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: buttonSizeOptions,
                                value: [
                                    buttonSize
                                ],
                                onChange: handleSelectButtonSize,
                                columns: 3,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_button_link_content_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_button_link_placeholder_content_title"),
                                value: buttonContent || "",
                                onChange: function(val) {
                                    handleChangeButtonContent(val);
                                },
                                maxLength: LINK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(buttonContent.length, "/").concat(LINK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_button_link_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                value: buttonLinkDescription || "",
                                onChange: function(val) {
                                    handleChangeButtonLinkDescription(val);
                                },
                                maxLength: LINK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(buttonLinkDescription.length, "/").concat(LINK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                            label: t("ss_builder_button_link_icon_origin_url_label"),
                            isRequire: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                item: linkData1,
                                onChange: function(item) {
                                    onUpdateLinkData(item);
                                },
                                onLoading: onAffLoading,
                                onError: function(errorMessage) {
                                    setIsValidUrl(!!errorMessage);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                        onChange: handleCheckAffiliateUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_use_affiliate_link_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_use_affiliate_link_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            !isEcomerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: !!openNewTab,
                                        onChange: handleChangeOpenNewTab,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_open_new_tab_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_open_new_tab_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSelectedIcon,
                onMaskClick: function() {
                    return handleCancelListIcon();
                },
                title: t("ss_builder_panel_add_icon_tab_title"),
                onClose: function() {
                    return handleCancelListIcon();
                },
                classNameBody: "h-[80vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListIconBuilder, {
                    callbackCancelListIcon: handleCancelListIcon,
                    callbackConfirmListIcon: handleConfirmListIcon,
                    defaultNameIcon: buttonIcon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenTemplateSelection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_LinkTemplateSelection, {
                    linkTemplateDefault: linkTemplate,
                    onUpdateLinkTemplate: function(val) {
                        return setLinkTemplate(val);
                    },
                    onCancelLinkTemplate: function() {
                        return setIsOpenTemplateSelection(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_ButtonLink = (ButtonLink);

// EXTERNAL MODULE: ./src/features/block/components/LinkInput/components/ServiceSelectorPopup/index.tsx
var ServiceSelectorPopup = __webpack_require__(39523);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonMultiLinks/ButtonMultiLinksItemAddNew/LinkTemplateSelection.tsx






var LinkTemplateSelection_LinkTemplateSelection = function(props) {
    var linkTemplateDefault = props.linkTemplateDefault, onUpdateLinkTemplate = props.onUpdateLinkTemplate, onCancelLinkTemplate = props.onCancelLinkTemplate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(linkTemplateDefault), linkTemplate = ref[0], setLinkTemplate = ref[1];
    (0,react.useEffect)(function() {
        if (linkTemplateDefault) setLinkTemplate(linkTemplateDefault);
    }, [
        linkTemplateDefault
    ]);
    var linkLayoutsOptions = configs_const/* LINK_TEMPLATE_ARR.map */.hV.map(function(ele) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: ele.image
            }),
            value: ele.value
        };
    });
    var handleSelectLinkTemplate = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setLinkTemplate(value);
        }
    };
    var handleSaveLinkTemplate = function() {
        onUpdateLinkTemplate(linkTemplate);
        onCancelLinkTemplate();
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (!linkTemplate || linkTemplate === linkTemplateDefault) {
            return true;
        } else return false;
    }, [
        linkTemplate,
        linkTemplateDefault
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_sample_selection_label")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: linkLayoutsOptions,
                value: [
                    linkTemplate
                ],
                onChange: handleSelectLinkTemplate,
                columns: 1,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    margin: "16px 12px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: onCancelLinkTemplate,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: isDisableBtnSave,
                            color: "primary",
                            onClick: handleSaveLinkTemplate,
                            children: t("ss_builder_done_panel")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ButtonMultiLinksItemAddNew_LinkTemplateSelection = (LinkTemplateSelection_LinkTemplateSelection);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonMultiLinks/ButtonMultiLinksItemAddNew/index.tsx
function ButtonMultiLinksItemAddNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonMultiLinksItemAddNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonMultiLinksItemAddNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var LINK_TITLE_MAXIMUM = 100;
var ButtonMultiLinksItemAddNew_LINK_DESCRIPTION_MAXIMUM = 250;
var ButtonMultiLinksItemAddNew = function(props) {
    var ref33, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var callBackCancelLinkAddNew = props.callBackCancelLinkAddNew, handleSaveLinkAddNew = props.handleSaveLinkAddNew, linkEditData = props.linkEditData, blockType = props.blockType, styleOfParent = props.styleOfParent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "".concat(blockType, "-").concat((0,v4/* default */.Z)());
    var style = styleOfParent === null || styleOfParent === void 0 ? void 0 : (ref33 = styleOfParent.style_attributes) === null || ref33 === void 0 ? void 0 : ref33.button_link_style;
    var linkUrlDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref1 = linkEditData.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.link_url) || "";
    var valueUrlImageDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref2 = linkEditData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.image) || "";
    var linkTitleDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref3 = linkEditData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.link_title) || "";
    var linkDescriptionDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref4 = linkEditData.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.link_description) || "";
    var buttonIconDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref5 = linkEditData.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.button_icon) || "";
    var defaultLinkData = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref6 = linkEditData.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: linkUrlDefault
    };
    var openInNewTabDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref7 = linkEditData.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.open_new_tab) || false;
    var linkTemplateDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref8 = linkEditData.style_attributes) === null || ref8 === void 0 ? void 0 : ref8.button_link_template) || configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1;
    var buttonIconUrlDefault = (linkEditData === null || linkEditData === void 0 ? void 0 : (ref9 = linkEditData.content_attributes) === null || ref9 === void 0 ? void 0 : ref9.button_icon_url) || null;
    var hasAffiliateUrlDefault = linkEditData ? (linkEditData === null || linkEditData === void 0 ? void 0 : (ref10 = linkEditData.content_attributes) === null || ref10 === void 0 ? void 0 : ref10.use_aff_url) === 1 : true;
    var ref12 = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref12[0], setValueUrlImage = ref12[1];
    var ref13 = (0,react.useState)(""), valueNameImage = ref13[0], setValueNameImage = ref13[1];
    var ref14 = (0,react.useState)(null), valueImageBase64 = ref14[0], setValueImageBase64 = ref14[1];
    var ref15 = (0,react.useState)([]), uploadedImageArr = ref15[0], setUploadedImageArr = ref15[1];
    var ref16 = (0,react.useState)(linkUrlDefault), linkUrl = ref16[0], setLinkUrl = ref16[1];
    var ref17 = (0,react.useState)(linkTitleDefault), linkTitle = ref17[0], setLinkTitle = ref17[1];
    var ref18 = (0,react.useState)(linkDescriptionDefault), linkDescription = ref18[0], setLinkDescription = ref18[1];
    var ref19 = (0,react.useState)(false), isValidUrl = ref19[0], setIsValidUrl = ref19[1];
    var ref20 = (0,react.useState)(false), isLoadingBtn = ref20[0], setIsLoadingBtn = ref20[1];
    var ref21 = (0,react.useState)(false), isDisableBtnSave = ref21[0], setIsDisableBtnSave = ref21[1];
    var ref22 = (0,react.useState)(false), isValidFileFormat = ref22[0], setIsValidFileFormat = ref22[1];
    var ref23 = (0,react.useState)(false), isValidFileSize = ref23[0], setIsValidFileSize = ref23[1];
    var ref24 = (0,react.useState)(linkTemplateDefault), linkTemplate = ref24[0], setLinkTemplate = ref24[1];
    var ref25 = (0,react.useState)(false), isOpenTemplateSelection = ref25[0], setIsOpenTemplateSelection = ref25[1];
    var ref26 = (0,react.useState)(buttonIconDefault), buttonIcon = ref26[0], setButtonIcon = ref26[1];
    var ref27 = (0,react.useState)(buttonIconUrlDefault), buttonIconUrl = ref27[0], setButtonIconUrl = ref27[1];
    var ref28 = (0,react.useState)(false), isOpenSelectedIcon = ref28[0], setIsOpenSelectedIcon = ref28[1];
    var ref29 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref29[0], setHasAffiliateUrl = ref29[1];
    var ref30 = (0,react.useState)(defaultLinkData), linkData1 = ref30[0], setLinkData = ref30[1];
    var ref31 = (0,react.useState)(false), isEcommerce = ref31[0], setIsEcommerce = ref31[1];
    var ref32 = (0,react.useState)(openInNewTabDefault), openNewTab = ref32[0], setOpenNewTab = ref32[1];
    var checkEcommerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcommerce(linkData1.target_url);
        }
    }, [
        linkData1
    ]);
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var handleSaveButtonMultiLinks = function() {
        var defaultData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            block_type: BLOCK_TYPE.BUTTON_LINK,
            title: "Link",
            content_attributes: {
                button_icon: buttonIcon,
                button_icon_url: buttonIconUrl,
                use_aff_url: hasAffiliateUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                image: valueImageBase64 || valueUrlImage,
                image_name: valueNameImage,
                image_base64: valueImageBase64,
                link_title: linkTitle,
                link_url: linkUrl,
                link_description: linkDescription,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            },
            style_attributes: ButtonMultiLinksItemAddNew_objectSpread({}, styleOfParent.style_attributes, {
                button_link_template: linkTemplate
            })
        };
        if (linkEditData) {
            handleSaveLinkAddNew({
                uid: linkEditData.uid,
                sort_order: linkEditData.sort_order,
                enable: linkEditData.enable,
                block_type: BLOCK_TYPE.BUTTON_LINK,
                title: "Link",
                content_attributes: {
                    image: valueImageBase64 || valueUrlImage,
                    image_name: valueNameImage,
                    image_base64: valueImageBase64,
                    link_title: linkTitle,
                    link_url: linkUrl,
                    link_description: linkDescription,
                    button_icon: buttonIcon,
                    button_icon_url: buttonIconUrl,
                    use_aff_url: hasAffiliateUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                    link_data: linkData1,
                    open_new_tab: isEcommerce ? true : openNewTab
                },
                style_attributes: ButtonMultiLinksItemAddNew_objectSpread({}, styleOfParent.style_attributes, {
                    button_link_template: linkTemplate
                })
            });
        } else {
            handleSaveLinkAddNew(defaultData);
        }
        callBackCancelLinkAddNew();
        setValueUrlImage(null);
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelLinkAddNew = function() {
        if (valueUrlImage && valueUrlImage !== valueUrlImageDefault || linkUrl !== linkUrlDefault || linkTitle !== linkTitleDefault || linkDescription !== linkDescriptionDefault || openNewTab !== openInNewTabDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "var(--adm-color-primary)",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_content")
                }),
                confirmText: t("ss_builder_confirm_cancel_image_slider_add_new_btn_label"),
                cancelText: t("ss_builder_cancel_image_slider_add_new_btn_label"),
                onConfirm: function() {
                    callBackCancelLinkAddNew();
                    setValueUrlImage(null);
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                },
                onCancel: function() {
                    return;
                }
            });
        } else {
            callBackCancelLinkAddNew();
            setValueUrlImage(null);
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleChangeLinkDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= ButtonMultiLinksItemAddNew_LINK_DESCRIPTION_MAXIMUM) {
            setLinkDescription(val);
        }
    };
    var handleChangeLinkTitle = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= LINK_TITLE_MAXIMUM) {
            setLinkTitle(val);
        }
    };
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var handleOpenSelectedIcon = function() {
        setIsOpenSelectedIcon(true);
    };
    var handleCancelListIcon = function() {
        setIsOpenSelectedIcon(false);
    };
    var handleConfirmListIcon = function(data) {
        var valueIcon = data.valueIcon, valueUrlIcon = data.valueUrlIcon;
        setButtonIcon(valueIcon);
        setButtonIconUrl(valueUrlIcon);
    };
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var onUpdateLinkData = function(linkData) {
        if (linkData.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setLinkUrl(linkData.value);
        } else {
            setLinkUrl(null);
        }
        setLinkData(linkData);
    };
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        var ref;
        var hasImg = (styleOfParent.style_attributes.button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE || styleOfParent.style_attributes.button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE) && !(linkEditData === null || linkEditData === void 0 ? void 0 : (ref = linkEditData.content_attributes) === null || ref === void 0 ? void 0 : ref.image) ? uploadedImageArr === null || uploadedImageArr === void 0 ? void 0 : uploadedImageArr.length : true;
        if ((linkUrl || linkData1.value) && (valueUrlImage !== valueUrlImageDefault || linkDescription !== linkDescriptionDefault || linkTitle !== linkTitleDefault || linkUrl !== linkUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || buttonIcon !== buttonIconDefault || linkTemplate !== linkTemplateDefault || hasAffiliateUrl !== hasAffiliateUrlDefault || openNewTab !== openInNewTabDefault) && !isValidUrl && !isDisableBtnSave && hasImg) {
            return true;
        } else return false;
    }, [
        valueUrlImage,
        valueUrlImageDefault,
        isValidUrl,
        isDisableBtnSave,
        linkDescription,
        linkDescriptionDefault,
        linkTitle,
        linkTitleDefault,
        linkUrl,
        linkUrlDefault,
        buttonIcon,
        buttonIconDefault,
        linkTemplate,
        linkTemplateDefault,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        linkData1,
        defaultLinkData,
        openNewTab,
        openInNewTabDefault, 
    ]);
    (0,react.useEffect)(function() {
        setIsDisableBtnSave(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setIsLoadingBtn(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsDisableBtnSave,
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ButtonLinkIcon */.fv, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw]",
                        style: {
                            fontSize: "18px"
                        },
                        children: "Link"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 bg-white my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_sample_selection_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                    src: (ref11 = configs_const/* LINK_TEMPLATE_ARR */.hV === null || configs_const/* LINK_TEMPLATE_ARR */.hV === void 0 ? void 0 : configs_const/* LINK_TEMPLATE_ARR.find */.hV.find(function(x) {
                                        return x.value === linkTemplate;
                                    })) === null || ref11 === void 0 ? void 0 : ref11.image
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                    block: true,
                                    color: "default",
                                    size: "middle",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "16px",
                                        gap: "5px",
                                        borderColor: "var(--adm-color-primary)",
                                        color: "var(--adm-color-primary)"
                                    },
                                    onClick: function() {
                                        return setIsOpenTemplateSelection(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                                            className: "w-[17px] h-[17px]",
                                            fillColor: "var(--adm-color-primary)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: t("ss_builder_sample_change_label")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " bg-white mt-3 px-4 py-[13px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE || style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-[15px] leading-[150%] text-[#666666]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-red-600",
                                                            children: "*"
                                                        }),
                                                        t("ss_builder_image_selection_label")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid grid-cols-[120px_auto] gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                            src: valueUrlImage !== null && valueUrlImage !== void 0 ? valueUrlImage : "https://i.ecomobi.com/ssp/passio-page/image-default.png",
                                                            fit: "cover",
                                                            style: {
                                                                borderRadius: "8px",
                                                                maxWidth: "120px",
                                                                maxHeight: "120px",
                                                                backgroundColor: "#EEEEEE",
                                                                border: "1px solid #EEEEEE"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mb-8 leading-4 text-[#8C8C8C] text-xs",
                                                                    children: t("ss_builder_theme_setting_background_content")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex gap-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                                                        onChange: handleImageUrl,
                                                                        upload: function(file) {
                                                                            return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                                                        },
                                                                        className: "flex-grow",
                                                                        value: uploadedImageArr,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                                            color: "primary",
                                                                            fill: "solid",
                                                                            size: "middle",
                                                                            className: "w-full",
                                                                            children: t("ss_builder_upload_button_label")
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row gap-1 items-center mt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                                            fillColor: "#FF3141",
                                                            className: "w-4 h-4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-[#FF3141]",
                                                            children: t("ss_builder_upload_file_format_invalid_content")
                                                        })
                                                    ]
                                                }),
                                                isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row gap-1 items-center mt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                                            fillColor: "#FF3141",
                                                            className: "w-4 h-4"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-[#FF3141]",
                                                            children: t("ss_builder_upload_file_size_invalid_content")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            (style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[15px] text-[#666666]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-red-600",
                                                        children: "*"
                                                    }),
                                                    t("ss_builder_button_link_icon_title")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                        style: {
                                                            backgroundColor: "#F0F0F0",
                                                            border: "none"
                                                        },
                                                        children: buttonIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                                            iconName: buttonIcon
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconDefault */.QL, {
                                                            className: "",
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-row gap-2 justify-between grow",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                            block: true,
                                                            color: "primary",
                                                            size: "middle",
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                gap: "5px"
                                                            },
                                                            onClick: handleOpenSelectedIcon,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                                    className: "w-[18px] h-[18px]"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-[17px] leading-6",
                                                                    children: t("ss_builder_button_link_icon_btn_selection_label")
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-[15px] leading-[13px] text-[#666666]",
                                                children: [
                                                    style === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-red-600",
                                                        children: "*"
                                                    }),
                                                    t("ss_builder_card_add_new_title_label")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                                placeholder: t("ss_builder_block_heading_placeholder"),
                                                onChange: handleChangeLinkTitle,
                                                value: linkTitle,
                                                maxLength: LINK_TITLE_MAXIMUM
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                                children: "".concat(linkTitle ? linkTitle.length : 0, "/").concat(LINK_TITLE_MAXIMUM)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[15px] leading-[13px] text-[#666666]",
                                                children: t("ss_builder_card_add_new_description_label")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                                placeholder: t("ss_builder_block_description_placeholder"),
                                                onChange: handleChangeLinkDescription,
                                                value: linkDescription,
                                                maxLength: ButtonMultiLinksItemAddNew_LINK_DESCRIPTION_MAXIMUM
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                                children: "".concat(linkDescription ? linkDescription.length : 0, "/").concat(ButtonMultiLinksItemAddNew_LINK_DESCRIPTION_MAXIMUM)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                label: t("ss_builder_button_link_icon_origin_url_label"),
                                isRequire: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                    item: linkData1,
                                    onChange: function(item) {
                                        onUpdateLinkData(item);
                                    },
                                    onLoading: onAffLoading,
                                    onError: function(errorMessage) {
                                        setIsValidUrl(!!errorMessage);
                                    }
                                })
                            }),
                            linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                                onChange: handleCheckAffiliateUrl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_use_affiliate_link_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_use_affiliate_link_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelLinkAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveButtonMultiLinks,
                            loading: isLoadingBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSelectedIcon,
                onMaskClick: function() {
                    return handleCancelListIcon();
                },
                title: t("ss_builder_panel_add_icon_tab_title"),
                onClose: function() {
                    return handleCancelListIcon();
                },
                classNameBody: "h-[80vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListIconBuilder, {
                    callbackCancelListIcon: handleCancelListIcon,
                    callbackConfirmListIcon: handleConfirmListIcon,
                    defaultNameIcon: buttonIcon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenTemplateSelection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMultiLinksItemAddNew_LinkTemplateSelection, {
                    linkTemplateDefault: linkTemplate,
                    onUpdateLinkTemplate: function(val) {
                        return setLinkTemplate(val);
                    },
                    onCancelLinkTemplate: function() {
                        return setIsOpenTemplateSelection(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var ButtonMultiLinks_ButtonMultiLinksItemAddNew = (ButtonMultiLinksItemAddNew);

// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
// EXTERNAL MODULE: ./src/features/block/components/ItemsWithCheckbox/index.tsx + 3 modules
var ItemsWithCheckbox = __webpack_require__(46819);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonMultiLinks/ListItems/LinkItem.tsx









var LinkItemModeDrag = function(props1) {
    var ref, ref1, ref2, ref3;
    var ele = props1.item, isOnlyText = props1.isOnlyText, isShowIcon = props1.isShowIcon, isShowImage = props1.isShowImage, labelObject = props1.labelObject, onDisableEnableItem = props1.onDisableEnableItem, onRemoveItem = props1.onRemoveItem, onEditItem = props1.onEditItem;
    var content_attributes = ele.content_attributes;
    var popoverRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var linkDatavalue = content_attributes.link_url || (content_attributes === null || content_attributes === void 0 ? void 0 : (ref = content_attributes.link_data) === null || ref === void 0 ? void 0 : ref.value);
    var isEnough = true;
    if (isShowIcon) {
        var ref4;
        isEnough = !!(linkDatavalue && (ele === null || ele === void 0 ? void 0 : (ref4 = ele.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.button_icon));
    }
    if (isShowImage) {
        var ref5;
        isEnough = !!(linkDatavalue && (ele === null || ele === void 0 ? void 0 : (ref5 = ele.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.image));
    }
    if (isOnlyText) {
        isEnough = !!(linkDatavalue && content_attributes.link_title);
    }
    var handleClickMoreIcon = function(event) {
        // event.preventDefault();
        event.stopPropagation();
    };
    var handleClickPopoverItem = function(item, itemData) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-item":
                onDisableEnableItem(itemData);
                break;
            case "delete-item":
                onRemoveItem(itemData);
                break;
            default:
        }
    };
    var MoreElement = function(props) {
        var itemData = props.itemData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: [
                        {
                            key: "eye-visible-item",
                            icon: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                                className: ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                                className: ""
                            }),
                            text: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? labelObject === null || labelObject === void 0 ? void 0 : labelObject.showItemLabel : labelObject === null || labelObject === void 0 ? void 0 : labelObject.hideItemLabel
                        },
                        {
                            key: "delete-item",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                                className: ""
                            }),
                            text: labelObject === null || labelObject === void 0 ? void 0 : labelObject.deleteItemLabel
                        }, 
                    ],
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item, itemData);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {
                    itemData: ele
                }),
                onClick: function() {
                    return onEditItem(ele);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex items-center gap-[6px] flex-row", ele.enable !== 1 && "opacity-40"),
                        children: [
                            isShowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                src: ele === null || ele === void 0 ? void 0 : (ref1 = ele.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.image,
                                width: 40,
                                height: 40,
                                fit: "cover",
                                style: {
                                    borderRadius: "4px"
                                }
                            }),
                            isShowIcon && isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                iconName: ele === null || ele === void 0 ? void 0 : (ref2 = ele.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.button_icon
                            }) : isShowIcon && !isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconDefault */.QL, {
                                className: ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                        children: ele.content_attributes.link_title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        style: {
                                            marginTop: "2px"
                                        },
                                        children: (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                    children: t("ss_builder_product_link_wrapped_label")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                            children: (content_attributes === null || content_attributes === void 0 ? void 0 : (ref3 = content_attributes.link_data) === null || ref3 === void 0 ? void 0 : ref3.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !isEnough && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        style: {
                            marginTop: "2px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* XIcon */.b0, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontSize: "12px",
                                    color: "#FF3141"
                                },
                                children: t("ss_builder_button_link_not_enought_infomation")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var LinkItemModeSelect = function(props) {
    var ref, ref6;
    var isOnlyText = props.isOnlyText, isShowIcon = props.isShowIcon, isShowImage = props.isShowImage, enable = props.enable, content_attributes = props.content_attributes;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var linkDatavalue = (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.link_url) || (content_attributes === null || content_attributes === void 0 ? void 0 : (ref = content_attributes.link_data) === null || ref === void 0 ? void 0 : ref.value);
    var isEnough = true;
    if (isShowIcon) {
        isEnough = !!(linkDatavalue && (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.button_icon));
    }
    if (isShowImage) {
        isEnough = !!(linkDatavalue && (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.image));
    }
    if (isOnlyText) {
        isEnough = !!(linkDatavalue && content_attributes.link_title);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center gap-[6px] flex-row", enable !== 1 && "opacity-40"),
                children: [
                    isShowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.image,
                        width: 40,
                        height: 40,
                        fit: "cover",
                        style: {
                            borderRadius: "4px"
                        }
                    }),
                    isShowIcon && isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                        iconName: content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.button_icon
                    }) : isShowIcon && !isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconDefault */.QL, {
                        className: ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                children: content_attributes.link_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex",
                                style: {
                                    marginTop: "2px"
                                },
                                children: (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                            children: t("ss_builder_product_link_wrapped_label")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                    children: (content_attributes === null || content_attributes === void 0 ? void 0 : (ref6 = content_attributes.link_data) === null || ref6 === void 0 ? void 0 : ref6.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                                })
                            })
                        ]
                    })
                ]
            }),
            !isEnough && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                style: {
                    marginTop: "2px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* XIcon */.b0, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: "12px",
                            color: "#FF3141"
                        },
                        children: t("ss_builder_button_link_not_enought_infomation")
                    })
                ]
            })
        ]
    });
};
var LinkItem = {
    LinkItemModeSelect: LinkItemModeSelect,
    LinkItemModeDrag: LinkItemModeDrag
};
/* harmony default export */ var ListItems_LinkItem = (LinkItem);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonMultiLinks/ListItems/index.tsx
function ListItems_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListItems_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListItems_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ListItems_arrayLikeToArray(arr);
}
function ListItems_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListItems_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ListItems_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListItems_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListItems_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListItems_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListItems_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ListItems_slicedToArray(arr, i) {
    return ListItems_arrayWithHoles(arr) || ListItems_iterableToArrayLimit(arr, i) || ListItems_unsupportedIterableToArray(arr, i) || ListItems_nonIterableRest();
}
function ListItems_toConsumableArray(arr) {
    return ListItems_arrayWithoutHoles(arr) || ListItems_iterableToArray(arr) || ListItems_unsupportedIterableToArray(arr) || ListItems_nonIterableSpread();
}
function ListItems_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListItems_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListItems_arrayLikeToArray(o, minLen);
}























var ListItems = function(props1) {
    var ref9, ref1, ref2, ref3;
    var blockType = props1.blockType, listItemDataDefault = props1.listItemDataDefault, onUpdateListDataItem = props1.onUpdateListDataItem, labelObject = props1.labelObject, imageRatio = props1.imageRatio, styleOfParent = props1.styleOfParent, setShowFooterBlockEdit = props1.setShowFooterBlockEdit;
    var ref4 = (0,react.useState)(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG), mode = ref4[0], setMode = ref4[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(listItemDataDefault), listItemData = ref5[0], setListItemData = ref5[1];
    var ref6 = (0,react.useState)(null), itemEditData = ref6[0], setItemEditData = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenAddNewItem = ref7[0], setIsOpenAddNewItem = ref7[1];
    var ref8 = (0,react.useState)({}), placeholderProps1 = ref8[0], setPlaceholderProps = ref8[1];
    var listItemDataSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(listItemData, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        listItemData
    ]);
    var linkEnable = (0,react.useMemo)(function() {
        return listItemData.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        listItemData
    ]);
    var isShowIcon = (styleOfParent === null || styleOfParent === void 0 ? void 0 : (ref9 = styleOfParent.style_attributes) === null || ref9 === void 0 ? void 0 : ref9.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || (styleOfParent === null || styleOfParent === void 0 ? void 0 : (ref1 = styleOfParent.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON;
    var isShowImage = (styleOfParent === null || styleOfParent === void 0 ? void 0 : (ref2 = styleOfParent.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE || (styleOfParent === null || styleOfParent === void 0 ? void 0 : (ref3 = styleOfParent.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE;
    var isOnlyText = (styleOfParent === null || styleOfParent === void 0 ? void 0 : styleOfParent.style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT;
    (0,react.useEffect)(function() {
        if (listItemDataSortOrder) onUpdateListDataItem(listItemDataSortOrder);
    }, [
        listItemDataSortOrder
    ]);
    var handleClickMoreIcon = function(event) {
        // event.preventDefault();
        event.stopPropagation();
    };
    var handleClickPopoverItem = function(item, itemData) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-item":
                onDisableEnableItem(itemData);
                break;
            case "delete-item":
                onRemoveItem(itemData);
                break;
            default:
        }
    };
    var MoreElement = function(props) {
        var itemData = props.itemData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: [
                        {
                            key: "eye-visible-item",
                            icon: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                                className: ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                                className: ""
                            }),
                            text: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? labelObject === null || labelObject === void 0 ? void 0 : labelObject.showItemLabel : labelObject === null || labelObject === void 0 ? void 0 : labelObject.hideItemLabel
                        },
                        {
                            key: "delete-item",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                                className: ""
                            }),
                            text: labelObject === null || labelObject === void 0 ? void 0 : labelObject.deleteItemLabel
                        }, 
                    ],
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item, itemData);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleOpenAddItem = function() {
        setIsOpenAddNewItem(true);
        setItemEditData(null);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(listItemDataSortOrder);
        var ref = ListItems_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return ListItems_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setListItemData(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(itemData) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        var newItems = listItemDataSortOrderClone && Array.isArray(listItemDataSortOrderClone) && listItemDataSortOrderClone.filter(function(ele) {
            return ele.uid !== itemData.uid;
        });
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteLinkModalLabel
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteLinkModalDescription
            }),
            confirmText: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteLinkModalBtnLabel,
            cancelText: labelObject === null || labelObject === void 0 ? void 0 : labelObject.cancelDeleteLinkModalBtnLabel,
            onConfirm: function() {
                setListItemData(newItems);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.deleteItemSuccessfullyLabel
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var onDisableEnableItem = function(itemData) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        var newImageItems = listItemDataSortOrderClone && Array.isArray(listItemDataSortOrderClone) && listItemDataSortOrderClone.map(function(ele) {
            return ele.uid === itemData.uid ? ListItems_objectSpread({}, ele, {
                enable: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? 1 : 2
            }) : ele;
        });
        setListItemData(newImageItems);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) === 1 ? labelObject === null || labelObject === void 0 ? void 0 : labelObject.hideItemSuccessfullyLabel : labelObject === null || labelObject === void 0 ? void 0 : labelObject.showItemSuccessfullyLabel
            })
        });
    };
    var listItemRate = (0,react.useMemo)(function() {
        return listItemDataSortOrder && "".concat(listItemDataSortOrder.length, "/").concat(configs_const/* MULTI_LINK_MAX */.Ku);
    }, [
        listItemDataSortOrder
    ]);
    var handleEditItem = function(item) {
        setIsOpenAddNewItem(true);
        setItemEditData(item);
    };
    var handleSaveItemAddNew = function(data) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        if (Array.isArray(listItemDataSortOrderClone)) {
            if (itemEditData) {
                var indexEditItems = listItemDataSortOrderClone.findIndex(function(x) {
                    return (x === null || x === void 0 ? void 0 : x.uid) === (itemEditData === null || itemEditData === void 0 ? void 0 : itemEditData.uid);
                });
                listItemDataSortOrderClone[indexEditItems] = data;
            } else {
                if (listItemDataSortOrderClone.length === 0) {
                    listItemDataSortOrderClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = listItemDataSortOrderClone.map(function(x) {
                        return x.sort_order;
                    });
                    listItemDataSortOrderClone.push(ListItems_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, ListItems_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setListItemData(listItemDataSortOrderClone);
            !itemEditData && (0,block_libs/* scrollToNewItem */.i)("blocks-".concat(data === null || data === void 0 ? void 0 : data.uid));
        }
    };
    var renderLinksSelectItemsMode = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "mt-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWithCheckbox/* default */.Z, {
                propertyIndex: "uid",
                onCancel: swichToDragMode,
                item: ListItems_LinkItem.LinkItemModeSelect,
                onChange: setListItemData,
                defaultItems: listItemDataSortOrder.map(function(e) {
                    return ListItems_objectSpread({
                        uid: e.uid,
                        id: e.uid
                    }, e, {
                        isShowIcon: isShowIcon,
                        isShowImage: isShowImage,
                        isOnlyText: isOnlyText
                    });
                }),
                header: {
                    title: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listTitle,
                    sticky: true
                },
                footer: {
                    countTitle: t("ss_builder_filter_select_multi_items_multi_links_count")
                },
                blockType: blockType
            })
        });
    };
    var swichToDragMode = function() {
        setMode(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG);
        setShowFooterBlockEdit(true);
    };
    var switchToSelectItemsMode = function() {
        setMode(config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS);
        setShowFooterBlockEdit(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mode === config_interface/* ITEMS_MODE.DRAG */.yo.DRAG && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-button-multi-link-editor-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between px-3 pt-4 pb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-[15px] text-[#666666]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                }),
                                                labelObject === null || labelObject === void 0 ? void 0 : labelObject.listTitle
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-grow justify-end gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                size: "small",
                                                fill: "solid",
                                                color: "primary",
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "3px 12px 3px 12px"
                                                },
                                                onClick: handleOpenAddItem,
                                                disabled: listItemDataSortOrder.length >= configs_const/* MULTI_LINK_MAX */.Ku,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                        className: "w-[15px] h-[15px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_add_new_label")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: listItemRate
                                                    })
                                                ]
                                            }),
                                            listItemDataSortOrder.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                onClick: switchToSelectItemsMode,
                                                color: "primary",
                                                fill: "outline",
                                                size: "small",
                                                children: t("ss_builder_select_label")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            linkEnable.length === 0 && listItemDataSortOrder.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                                style: {
                                    color: "var(--adm-color-danger)"
                                },
                                children: t("ss_builder_need_to_display_at_least_one_link")
                            })
                        ]
                    }),
                    (listItemDataSortOrder === null || listItemDataSortOrder === void 0 ? void 0 : listItemDataSortOrder.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                            onDragEnd: onDragEnd,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                droppableId: "blocks-".concat(blockType),
                                children: function(provided1, snapshot1) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", ListItems_objectSpread({}, provided1.droppableProps, {
                                        ref: provided1.innerRef,
                                        className: "relative",
                                        children: [
                                            (listItemDataSortOrder === null || listItemDataSortOrder === void 0 ? void 0 : listItemDataSortOrder.length) > 0 && listItemDataSortOrder.map(function(ele, index) {
                                                var ref14;
                                                var content_attributes = ele.content_attributes;
                                                var linkDatavalue = content_attributes.link_url || (content_attributes === null || content_attributes === void 0 ? void 0 : (ref14 = content_attributes.link_data) === null || ref14 === void 0 ? void 0 : ref14.value);
                                                var isEnough = true;
                                                if (isShowIcon) {
                                                    var ref10;
                                                    isEnough = !!(linkDatavalue && (ele === null || ele === void 0 ? void 0 : (ref10 = ele.content_attributes) === null || ref10 === void 0 ? void 0 : ref10.button_icon));
                                                }
                                                if (isShowImage) {
                                                    var ref11;
                                                    isEnough = !!(linkDatavalue && (ele === null || ele === void 0 ? void 0 : (ref11 = ele.content_attributes) === null || ref11 === void 0 ? void 0 : ref11.image));
                                                }
                                                if (isOnlyText) {
                                                    isEnough = !!(linkDatavalue && content_attributes.link_title);
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                    draggableId: "blocks-".concat(ele.uid),
                                                    index: index,
                                                    children: function(provided, snapshot) {
                                                        var ref, ref12, ref13;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", ListItems_objectSpread({
                                                            ref: provided.innerRef
                                                        }, provided.draggableProps, provided.dragHandleProps, {
                                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                ref: popoverRef,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* List.Item */.aV.Item, {
                                                                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                                                                            className: ""
                                                                        }),
                                                                        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {
                                                                            itemData: ele
                                                                        }),
                                                                        onClick: function() {
                                                                            return handleEditItem(ele);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: classnames_default()("flex items-center gap-[6px] flex-row", ele.enable !== 1 && "opacity-40"),
                                                                                children: [
                                                                                    isShowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                                                        src: ele === null || ele === void 0 ? void 0 : (ref = ele.content_attributes) === null || ref === void 0 ? void 0 : ref.image,
                                                                                        width: 40,
                                                                                        height: 40,
                                                                                        fit: "cover",
                                                                                        style: {
                                                                                            borderRadius: "4px"
                                                                                        }
                                                                                    }),
                                                                                    isShowIcon && isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                                                                        iconName: ele === null || ele === void 0 ? void 0 : (ref12 = ele.content_attributes) === null || ref12 === void 0 ? void 0 : ref12.button_icon
                                                                                    }) : isShowIcon && !isEnough ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconDefault */.QL, {
                                                                                        className: ""
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                                                                                children: ele.content_attributes.link_title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "flex",
                                                                                                style: {
                                                                                                    marginTop: "2px"
                                                                                                },
                                                                                                children: (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                                                                            children: t("ss_builder_product_link_wrapped_label")
                                                                                                        })
                                                                                                    ]
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                                                                    children: (content_attributes === null || content_attributes === void 0 ? void 0 : (ref13 = content_attributes.link_data) === null || ref13 === void 0 ? void 0 : ref13.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            !isEnough && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex",
                                                                                style: {
                                                                                    marginTop: "2px"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* XIcon */.b0, {}),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: "12px",
                                                                                            color: "#FF3141"
                                                                                        },
                                                                                        children: t("ss_builder_button_link_not_enought_infomation")
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }));
                                                    }
                                                }, "blocks-".concat(ele.uid));
                                            }),
                                            provided1.placeholder,
                                            !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                placeholderProps: placeholderProps1,
                                                content: t("ss_builder_placeholder_dragging_content"),
                                                style: {
                                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                    border: "1px dashed #1890FF",
                                                    borderRadius: "4px",
                                                    color: "#1890FF"
                                                }
                                            })
                                        ]
                                    }));
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ButtonMultiLinkIcon */.aZ, {
                                    className: "align-middle w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listEmptyLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listEmptyDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                        visible: isOpenAddNewItem,
                        onMaskClick: function() {
                            return setIsOpenAddNewItem(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMultiLinks_ButtonMultiLinksItemAddNew, {
                            imageRatio: imageRatio,
                            callBackCancelLinkAddNew: function() {
                                return setIsOpenAddNewItem(false);
                            },
                            linkEditData: itemEditData,
                            indexLinkEdit: itemEditData ? listItemData === null || listItemData === void 0 ? void 0 : listItemData.findIndex(function(x) {
                                return (x === null || x === void 0 ? void 0 : x.uid) === (itemEditData === null || itemEditData === void 0 ? void 0 : itemEditData.uid);
                            }) : null,
                            blockType: blockType,
                            handleSaveLinkAddNew: handleSaveItemAddNew,
                            styleOfParent: styleOfParent
                        })
                    })
                ]
            }),
            mode === config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS && renderLinksSelectItemsMode(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewItem,
                onMaskClick: function() {
                    return setIsOpenAddNewItem(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMultiLinks_ButtonMultiLinksItemAddNew, {
                    imageRatio: imageRatio,
                    callBackCancelLinkAddNew: function() {
                        return setIsOpenAddNewItem(false);
                    },
                    linkEditData: itemEditData,
                    indexLinkEdit: itemEditData ? listItemData === null || listItemData === void 0 ? void 0 : listItemData.findIndex(function(x) {
                        return (x === null || x === void 0 ? void 0 : x.uid) === (itemEditData === null || itemEditData === void 0 ? void 0 : itemEditData.uid);
                    }) : null,
                    blockType: blockType,
                    handleSaveLinkAddNew: handleSaveItemAddNew,
                    styleOfParent: styleOfParent
                })
            })
        ]
    });
};
/* harmony default export */ var ButtonMultiLinks_ListItems = (ListItems);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ButtonMultiLinks/index.tsx
function ButtonMultiLinks_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonMultiLinks_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonMultiLinks_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ButtonMultiLinks_LINK_HEADING_MAXIMUM = 50;
var ButtonMultiLinks_LINK_DESCRIPTION_MAXIMUM = 250;
var itemOnRowOptions = [
    {
        label: "1",
        value: configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE
    },
    {
        label: "2",
        value: configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO
    }, 
];
var itemOnRowOptionsV2 = [
    {
        label: "1",
        value: configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE
    },
    {
        label: "2",
        value: configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO
    },
    {
        label: "3",
        value: configs_const/* CARD_ITEM_ON_ROW.THREE */.nG.THREE
    },
    {
        label: "4",
        value: configs_const/* CARD_ITEM_ON_ROW.FOUR */.nG.FOUR
    },
    {
        label: "5",
        value: configs_const/* CARD_ITEM_ON_ROW.FIVE */.nG.FIVE
    },
    {
        label: "6",
        value: configs_const/* CARD_ITEM_ON_ROW.SIX */.nG.SIX
    }, 
];
var ButtonMultiLinks = function(props) {
    var ref45, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, setButtonLoading = props.setButtonLoading, defaultBlockData = props.defaultBlockData, setShowFooterBlockEdit = props.setShowFooterBlockEdit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "button-link-".concat((0,v4/* default */.Z)());
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    // const edittingBlock = useAppSelector((state) => {
    //   return state.edittingBlock;
    // });
    // const KEY = edittingBlock && edittingBlock.KEY;
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    // const tabUid = edittingBlock && edittingBlock.tab_uid;
    // const positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEdit = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = "Multi Links";
    var originUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref45 = defaultValueEdit.content_attributes) === null || ref45 === void 0 ? void 0 : ref45.origin_url) || "";
    var listLinkDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref1 = defaultValueEdit.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.items) || [];
    var affiliateUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref2 = defaultValueEdit.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.target_url) || "";
    var buttonSizeDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref3 = defaultValueEdit.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.button_size) || "middle";
    var buttonContentDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref4 = defaultValueEdit.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.button_content) || "";
    var buttonLinkDescriptionDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref5 = defaultValueEdit.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.button_description) || "";
    var buttonIconDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref6 = defaultValueEdit.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.button_icon) || configs_const/* TAB_ICON_DEFAULT */.FL;
    var buttonIconUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref7 = defaultValueEdit.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.button_icon_url) || null;
    var hasAffiliateUrlDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref8 = defaultValueEdit.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.use_aff_url) ? !!((defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref9 = defaultValueEdit.content_attributes) === null || ref9 === void 0 ? void 0 : ref9.use_aff_url) === 1) : true;
    var imageDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref10 = defaultValueEdit.content_attributes) === null || ref10 === void 0 ? void 0 : ref10.image) || null;
    var styleLinkDisplayDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref11 = defaultValueEdit.style_attributes) === null || ref11 === void 0 ? void 0 : ref11.button_link_style) || configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON;
    var linkLayoutDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref12 = defaultValueEdit.style_attributes) === null || ref12 === void 0 ? void 0 : ref12.button_link_layout) || configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    var linkTemplateDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref13 = defaultValueEdit.style_attributes) === null || ref13 === void 0 ? void 0 : ref13.button_link_template) || configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1;
    var itemOnRowDefault = (defaultValueEdit === null || defaultValueEdit === void 0 ? void 0 : (ref14 = defaultValueEdit.style_attributes) === null || ref14 === void 0 ? void 0 : ref14.item_on_row) || "1";
    var ref15 = (0,react.useState)(buttonSizeDefault), buttonSize = ref15[0], setButtonSize = ref15[1];
    var ref16 = (0,react.useState)(buttonContentDefault), buttonContent = ref16[0], setButtonContent = ref16[1];
    var ref17 = (0,react.useState)(buttonLinkDescriptionDefault), buttonLinkDescription = ref17[0], setButtonLinkDescription = ref17[1];
    var ref18 = (0,react.useState)(buttonIconDefault), buttonIcon = ref18[0], setButtonIcon = ref18[1];
    var ref19 = (0,react.useState)(buttonIconUrlDefault), buttonIconUrl = ref19[0], setButtonIconUrl = ref19[1];
    var ref20 = (0,react.useState)(false), isOpenSelectedIcon = ref20[0], setIsOpenSelectedIcon = ref20[1];
    var ref21 = (0,react.useState)(false), isOpenTemplateSelection = ref21[0], setIsOpenTemplateSelection = ref21[1];
    var ref22 = (0,react.useState)(originUrlDefault), originUrl = ref22[0], setOriginUrl = ref22[1];
    var ref23 = (0,react.useState)(affiliateUrlDefault), affiliateUrl = ref23[0], setAffiliateUrl = ref23[1];
    var ref24 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref24[0], setHasAffiliateUrl = ref24[1];
    var ref25 = (0,react.useState)(false), isValidUrl = ref25[0], setIsValidUrl = ref25[1];
    var ref26 = (0,react.useState)(false), isLoadingBtn = ref26[0], setIsLoadingBtn = ref26[1];
    var ref27 = (0,react.useState)(null), errorCode = ref27[0], setErrorCode = ref27[1];
    var ref28 = (0,react.useState)(null), warningCode = ref28[0], setWarningCode = ref28[1];
    var ref29 = (0,react.useState)(false), isCheckDisableBtnSave = ref29[0], setIsCheckDisableBtnSave = ref29[1];
    var ref30 = (0,react.useState)(styleLinkDisplayDefault), styleLinkDisplay = ref30[0], setStyleLinkDisplay = ref30[1];
    var ref31 = (0,react.useState)(linkLayoutDefault), linkLayout = ref31[0], setLinkLayout = ref31[1];
    var ref32 = (0,react.useState)(linkTemplateDefault), linkTemplate = ref32[0], setLinkTemplate = ref32[1];
    var ref33 = (0,react.useState)([]), uploadedImageArr = ref33[0], setUploadedImageArr = ref33[1];
    var ref34 = (0,react.useState)(imageDefault), valueUrlImage = ref34[0], setValueUrlImage = ref34[1];
    var ref35 = (0,react.useState)(null), valueNameImage = ref35[0], setValueNameImage = ref35[1];
    var ref36 = (0,react.useState)(null), valueImageBase64 = ref36[0], setValueImageBase64 = ref36[1];
    var ref37 = (0,react.useState)(false), isValidFileFormat = ref37[0], setIsValidFileFormat = ref37[1];
    var ref38 = (0,react.useState)(false), isValidFileSize = ref38[0], setIsValidFileSize = ref38[1];
    var ref39 = (0,react.useState)(itemOnRowDefault), itemOnRow = ref39[0], setItemOnRow = ref39[1];
    var ref40 = (0,react.useState)(listLinkDefault), listLink = ref40[0], setListLink = ref40[1];
    var ref41 = (0,react.useState)(null), styleOfParent = ref41[0], setStyleOfParent = ref41[1];
    var ref42;
    var ref43 = (0,react.useState)((ref42 = block === null || block === void 0 ? void 0 : block.enable) !== null && ref42 !== void 0 ? ref42 : configs_const/* ENABLE_BLOCK */.C5), isEnable = ref43[0], setIsEnable = ref43[1];
    var ref44 = (0,react.useState)(false), checkIsEnought = ref44[0], setCheckIsEnought = ref44[1];
    var labelObject = {
        listTitle: t("ss_builder_list_button_multi_link_label"),
        listEmptyLabel: t("ss_builder_list_link_empty_title"),
        listEmptyDescription: t("ss_builder_list_link_empty_content"),
        itemAdditionalBtnLabel: t("ss_builder_link_additional_btn_label"),
        deleteItemLabel: t("ss_builder_delete_link_label"),
        deleteItemSuccessfullyLabel: t("ss_builder_delete_link_successfully_label"),
        showItemLabel: t("ss_builder_show_link_label"),
        showItemSuccessfullyLabel: t("ss_builder_show_link_successfully_label"),
        hideItemLabel: t("ss_builder_hide_link_label"),
        hideItemSuccessfullyLabel: t("ss_builder_hide_link_successfully_label"),
        confirmDeleteLinkModalLabel: t("ss_builder_delete_link_label"),
        confirmDeleteLinkModalDescription: t("ss_builder_confirm_delete_link_description"),
        confirmDeleteLinkModalBtnLabel: t("ss_builder_delete_link_label"),
        cancelDeleteLinkModalBtnLabel: t("ss_builder_cancel_delete_link_modal_btn_label")
    };
    var listLinkEnable = (0,react.useMemo)(function() {
        return listLink === null || listLink === void 0 ? void 0 : listLink.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.enable) === 1;
        });
    }, [
        listLink
    ]);
    (0,react.useEffect)(function() {
        if (buttonSize || linkLayout || styleLinkDisplay || itemOnRow) setStyleOfParent({
            style_attributes: {
                button_size: buttonSize || "",
                button_link_layout: linkLayout || "",
                button_link_style: styleLinkDisplay || "",
                item_on_row: itemOnRow || ""
            }
        });
    }, [
        buttonSize,
        linkLayout,
        styleLinkDisplay,
        itemOnRow
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.BUTTON_MULTI_LINK,
                title: titleBlockDefault,
                content_attributes: {
                    items: listLink === null || listLink === void 0 ? void 0 : listLink.map(function(link) {
                        var ref;
                        return ButtonMultiLinks_objectSpread({}, link, {
                            style_attributes: {
                                button_size: buttonSize,
                                button_link_template: link === null || link === void 0 ? void 0 : (ref = link.style_attributes) === null || ref === void 0 ? void 0 : ref.button_link_template,
                                button_link_layout: linkLayout,
                                button_link_style: styleLinkDisplay,
                                item_on_row: linkLayout === configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG ? 1 : itemOnRow
                            }
                        });
                    }),
                    button_content: buttonContent,
                    button_description: buttonLinkDescription
                },
                style_attributes: {
                    button_size: buttonSize,
                    button_link_template: linkTemplate,
                    button_link_layout: linkLayout,
                    button_link_style: styleLinkDisplay,
                    item_on_row: linkLayout === configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG ? 1 : itemOnRow
                }
            };
            onUpdateData(defaultData);
        } else {
            onUpdateData(ButtonMultiLinks_objectSpread({}, block, {
                enable: isEnable,
                title: titleBlockDefault,
                content_attributes: {
                    button_content: buttonContent,
                    button_description: buttonLinkDescription,
                    items: listLink === null || listLink === void 0 ? void 0 : listLink.map(function(link) {
                        var ref;
                        return ButtonMultiLinks_objectSpread({}, link, {
                            style_attributes: {
                                button_size: buttonSize,
                                button_link_template: link === null || link === void 0 ? void 0 : (ref = link.style_attributes) === null || ref === void 0 ? void 0 : ref.button_link_template,
                                button_link_layout: linkLayout,
                                button_link_style: styleLinkDisplay,
                                item_on_row: linkLayout === configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG ? 1 : itemOnRow
                            }
                        });
                    })
                },
                style_attributes: {
                    button_size: buttonSize,
                    button_link_template: linkTemplate,
                    button_link_layout: linkLayout,
                    button_link_style: styleLinkDisplay,
                    item_on_row: linkLayout === configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG ? 1 : itemOnRow
                }
            }));
        }
    }, [
        buttonIconUrl,
        buttonContent,
        buttonIcon,
        buttonSize,
        hasAffiliateUrl,
        affiliateUrl,
        originUrl,
        buttonLinkDescription,
        valueImageBase64,
        valueUrlImage,
        valueNameImage,
        linkTemplate,
        linkLayout,
        styleLinkDisplay,
        listLink,
        itemOnRow,
        isEnable, 
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if ((buttonContent !== buttonContentDefault || buttonLinkDescription !== buttonLinkDescriptionDefault || buttonIcon !== buttonIconDefault || buttonSize !== buttonSizeDefault || originUrl !== originUrlDefault || linkTemplate !== linkTemplateDefault || styleLinkDisplay !== styleLinkDisplayDefault || linkLayout !== linkLayoutDefault || valueUrlImage !== imageDefault || itemOnRow !== itemOnRowDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || JSON.stringify(listLink) !== JSON.stringify(listLinkDefault)) && !isValidUrl && !isCheckDisableBtnSave && listLink.length !== 0 && checkIsEnought && listLinkEnable.length > 0) {
            return false;
        } else return true;
    }, [
        buttonContent,
        buttonContentDefault,
        originUrl,
        originUrlDefault,
        buttonIcon,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        buttonIconDefault,
        isValidUrl,
        buttonSize,
        buttonSizeDefault,
        isCheckDisableBtnSave,
        buttonLinkDescription,
        buttonLinkDescriptionDefault,
        linkTemplate,
        linkTemplateDefault,
        styleLinkDisplay,
        styleLinkDisplayDefault,
        valueUrlImage,
        imageDefault,
        linkLayout,
        linkLayoutDefault,
        listLink,
        itemOnRow,
        itemOnRowDefault,
        checkIsEnought,
        listLinkEnable, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (buttonContent !== buttonContentDefault || originUrl !== originUrlDefault || buttonIcon !== buttonIconDefault || buttonSize !== buttonSizeDefault || linkTemplate !== linkTemplateDefault || styleLinkDisplay !== styleLinkDisplayDefault || linkLayout !== linkLayoutDefault || valueUrlImage !== imageDefault || itemOnRow !== itemOnRowDefault || buttonLinkDescription !== buttonLinkDescriptionDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || JSON.stringify(listLink) !== JSON.stringify(listLinkDefault)) {
            return true;
        } else return false;
    }, [
        buttonContent,
        buttonContentDefault,
        originUrl,
        originUrlDefault,
        buttonIcon,
        buttonIconDefault,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        buttonSize,
        buttonSizeDefault,
        linkTemplate,
        linkTemplateDefault,
        styleLinkDisplay,
        styleLinkDisplayDefault,
        valueUrlImage,
        imageDefault,
        linkLayout,
        linkLayoutDefault,
        buttonLinkDescription,
        buttonLinkDescriptionDefault,
        listLink,
        listLinkDefault,
        itemOnRow,
        itemOnRowDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        setButtonLoading(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    (0,react.useEffect)(function() {
        var content_attributes = block.content_attributes, style_attributes = block.style_attributes;
        var isShowIcon = (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON;
        var isShowImage = (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE || (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE;
        var isOnlytext = (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.button_link_style) === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT;
        var listItem = content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.items;
        var listItemFilter = listItem === null || listItem === void 0 ? void 0 : listItem.filter(function(item) {
            var ref, ref46;
            var linkDatavalue = item.content_attributes.link_url || ((ref = item.content_attributes) === null || ref === void 0 ? void 0 : (ref46 = ref.link_data) === null || ref46 === void 0 ? void 0 : ref46.value);
            if (isShowIcon) {
                return item.content_attributes.button_icon && linkDatavalue;
            }
            if (isShowImage) {
                return item.content_attributes.image && linkDatavalue;
            }
            if (isOnlytext) {
                return item.content_attributes.link_title && linkDatavalue;
            }
        });
        if ((listItemFilter === null || listItemFilter === void 0 ? void 0 : listItemFilter.length) === (listItem === null || listItem === void 0 ? void 0 : listItem.length)) {
            setCheckIsEnought(true);
        } else setCheckIsEnought(false);
    }, [
        listLink,
        block
    ]);
    var buttonSizeOptions = [
        {
            label: t("ss_builder_button_link_small_size_label"),
            value: "small"
        },
        {
            label: t("ss_builder_button_link_middle_size_label"),
            value: "middle"
        },
        {
            label: t("ss_builder_button_link_large_size_label"),
            value: "large"
        }, 
    ];
    var handleSelectButtonSize = function(arr) {
        if (arr && arr.length) {
            var valueSize = arr[0];
            setButtonSize(valueSize);
        }
    };
    var handleConfirmListIcon = function(data) {
        var valueIcon = data.valueIcon, valueUrlIcon = data.valueUrlIcon;
        setButtonIcon(valueIcon);
        setButtonIconUrl(valueUrlIcon);
    };
    var handleChangeButtonContent = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= ButtonMultiLinks_LINK_HEADING_MAXIMUM) {
            setButtonContent(data);
        }
    };
    var handleChangeButtonLinkDescription = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) <= ButtonMultiLinks_LINK_DESCRIPTION_MAXIMUM) {
            setButtonLinkDescription(data);
        }
    };
    var handleCancelListIcon = function() {
        setIsOpenSelectedIcon(false);
    };
    var handleSelectItemOnRow = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setItemOnRow(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white my-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_block_heading_label")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_button_link_placeholder_content_title"),
                                value: buttonContent || "",
                                onChange: function(val) {
                                    handleChangeButtonContent(val);
                                },
                                maxLength: ButtonMultiLinks_LINK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(buttonContent.length, "/").concat(ButtonMultiLinks_LINK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                value: buttonLinkDescription || "",
                                onChange: function(val) {
                                    handleChangeButtonLinkDescription(val);
                                },
                                maxLength: ButtonMultiLinks_LINK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(buttonLinkDescription.length, "/").concat(ButtonMultiLinks_LINK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 bg-white my-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " bg-white my-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_LinkStyleDisplay, {
                            styleLinkDisplay: styleLinkDisplay,
                            onUpdateStyleLinkDisplay: function(val) {
                                if (val === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE || val === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON || val === configs_const/* LINK_STYLE_DISPLAY.ONLY_TEXT */.Bx.ONLY_TEXT) {
                                    var a = Number(itemOnRowDefault) > 3 ? "1" : itemOnRowDefault;
                                    setItemOnRow(Number(itemOnRowDefault) > 3 ? "1" : "".concat(itemOnRowDefault));
                                }
                                if (val === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE || val === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON) {
                                    setLinkLayout(configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER);
                                }
                                setStyleLinkDisplay(val);
                            },
                            isMulti: true
                        }),
                        (styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON || styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_LinkLayouts, {
                                    linkLayout: linkLayout,
                                    onUpdateLinkLayout: function(val) {
                                        if (val !== configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG) {
                                            setItemOnRow(itemOnRowDefault && "1");
                                        }
                                        setLinkLayout(val);
                                    },
                                    isMultiLink: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                        linkLayout !== configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[15px] leading-[13px] text-[#666666]",
                                            children: t("ss_builder_items_per_row")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                            options: styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE ? itemOnRowOptionsV2 : itemOnRowOptions,
                                            value: [
                                                itemOnRow
                                            ],
                                            onChange: handleSelectItemOnRow,
                                            columns: styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || styleLinkDisplay === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE ? 6 : 2,
                                            style: {
                                                "--border": "solid transparent 1px",
                                                "--checked-border": "solid var(--adm-color-primary) 1px"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] text-[#666666]",
                                    children: t("ss_builder_button_link_size_selection_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                    options: buttonSizeOptions,
                                    value: [
                                        buttonSize
                                    ],
                                    onChange: handleSelectButtonSize,
                                    columns: 3,
                                    style: {
                                        "--border": "solid transparent 1px",
                                        "--checked-border": "solid var(--adm-color-primary) 1px"
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMultiLinks_ListItems, {
                blockType: block === null || block === void 0 ? void 0 : block.block_type,
                listItemDataDefault: listLink,
                ITEM_MAXIMUM: 30,
                onUpdateListDataItem: function(val) {
                    setListLink(val);
                },
                labelObject: labelObject,
                imageRatio: {},
                styleOfParent: styleOfParent,
                setShowFooterBlockEdit: setShowFooterBlockEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSelectedIcon,
                onMaskClick: function() {
                    return handleCancelListIcon();
                },
                title: t("ss_builder_panel_add_icon_tab_title"),
                onClose: function() {
                    return handleCancelListIcon();
                },
                classNameBody: "h-[80vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListIconBuilder, {
                    callbackCancelListIcon: handleCancelListIcon,
                    callbackConfirmListIcon: handleConfirmListIcon,
                    defaultNameIcon: buttonIcon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenTemplateSelection
            })
        ]
    });
};
/* harmony default export */ var block_editor_ButtonMultiLinks = (ButtonMultiLinks);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/CardLayouts/index.tsx






var CardLayouts = function(props) {
    var cardLayoutValue = props.cardLayoutValue, onUpdateCardLayoutValue = props.onUpdateCardLayoutValue, isCardStyleSlide = props.isCardStyleSlide;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var elementId = (0,react.useMemo)(function() {
        return "e" + Math.random().toString(36).slice(2, 7);
    }, []);
    var cardLayoutOptions = (0,react.useMemo)(function() {
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text under image - Left align.png",
                    height: 96,
                    width: 96,
                    className: "m-auto",
                    "data-value": configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_1")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text under image - Center align.png",
                    height: 96,
                    width: 96,
                    className: "m-auto",
                    "data-value": configs_const/* CARD_LAYOUTS.LAYOUT_2 */.IT.LAYOUT_2
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_2 */.IT.LAYOUT_2,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_2")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_2 */.IT.LAYOUT_2
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text over image - Center align.png",
                    height: 96,
                    width: 96,
                    className: "m-auto",
                    "data-value": configs_const/* CARD_LAYOUTS.LAYOUT_3 */.IT.LAYOUT_3
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_3 */.IT.LAYOUT_3,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_3")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_3 */.IT.LAYOUT_3
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text over image - Left align.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_4 */.IT.LAYOUT_4,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_4")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_4 */.IT.LAYOUT_4
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text on the right.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_5")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text on the left.png",
                    width: 96,
                    height: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_6")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text over image - Left align 2.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_7")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/Text over image - Center align 2.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: elementId + "-" + configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8,
                    className: "mt-1",
                    children: t("ss_builder_card_layout_label_8")
                }),
                value: configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8
            }, 
        ];
    }, []);
    var handleSelectCardLayout = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            onUpdateCardLayoutValue(value);
        }
    };
    var cardLayoutOptionsMemo = (0,react.useMemo)(function() {
        if (isCardStyleSlide) {
            return cardLayoutOptions === null || cardLayoutOptions === void 0 ? void 0 : cardLayoutOptions.filter(function(x) {
                return x.value !== configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 && x.value !== configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6;
            });
        } else {
            return cardLayoutOptions;
        }
    }, [
        isCardStyleSlide
    ]);
    // useEffect(() => {
    //   const element = document.querySelector(`#${elementId} .adm-selector-item-active`);
    //   element.scrollIntoView({block: 'nearest', inline: 'center'});
    //   // element.querySelector('');
    // }, []);
    // useEffect(() => {
    //   const childElementId = elementId + "-" + cardLayoutValue;
    //   const element = document.getElementById(childElementId);
    //   if(element){
    //     element.scrollIntoView({block: 'nearest', inline: 'center', behavior: "smooth"});
    //   }
    // }, [cardLayoutValue])
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: elementId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[15px] leading-[13px] text-[#666666]",
                children: t("ss_builder_card_layout_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoScrollSelector/* default */.Z, {
                elementId: elementId,
                options: cardLayoutOptionsMemo,
                value: cardLayoutValue,
                onChange: handleSelectCardLayout
            })
        ]
    });
};
/* harmony default export */ var Card_CardLayouts = (CardLayouts);

// EXTERNAL MODULE: ./src/features/share/components/dnd-scrollable/index.tsx
var dnd_scrollable = __webpack_require__(77345);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/CardSlideType/index.tsx






var CardSlideType = function(props) {
    var cardSlideValue = props.cardSlideValue, onUpdateCardSlideValue = props.onUpdateCardSlideValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var cardSlideTypeOptions = [
        // {
        //   label: (
        //     <Image
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-1.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_1")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.PARTIAL_VISIBLE_RIGHT,
        // },
        // {
        //   label: (
        //     <Image
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-2.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_2")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.PARTIAL_VISIBLE_BOTH_SIDES,
        // },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-3.png",
                width: 96,
                height: 96,
                className: "m-auto"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_partial_visible_slide_type_3")
            }),
            value: configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE
        },
        // {
        //   label: (
        //     <Image
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-4.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_4")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.POSTERS,
        // },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-5.png",
                width: 96,
                height: 96,
                className: "m-auto"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_partial_visible_slide_type_5")
            }),
            value: configs_const/* SLIDE_STYLE.PANORAMA */.jw.PANORAMA
        }, 
    ];
    var handleSelectCardSlideType = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            onUpdateCardSlideValue(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[15px] leading-[13px] text-[#666666]",
                children: t("ss_builder_slide_type_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                className: "selector-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                    options: cardSlideTypeOptions,
                    value: [
                        cardSlideValue
                    ],
                    onChange: handleSelectCardSlideType,
                    //   columns={4}
                    style: {
                        "--border": "solid transparent 1px",
                        "--checked-border": "solid var(--adm-color-primary) 1px"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Card_CardSlideType = (CardSlideType);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/CardStyle/index.tsx






var CardStyle = function(props) {
    var cardStyleValue = props.cardStyleValue, onUpdateCardStyleValue = props.onUpdateCardStyleValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var cardStyleOptions = (0,react.useMemo)(function() {
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/display-styles/card-grid-type.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_style_grid_label")
                }),
                value: configs_const/* CARD_STYLE.GRID */.wi.GRID
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/display-styles/card-slide-type.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_style_slide_label")
                }),
                value: configs_const/* CARD_STYLE.SLIDE */.wi.SLIDE
            }, 
        ];
    }, []);
    var handleSelectCardStyle = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            onUpdateCardStyleValue(valueRatio);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[15px] leading-[13px] text-[#666666]",
                children: t("ss_builder_style")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                className: "selector-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                    options: cardStyleOptions,
                    value: [
                        cardStyleValue
                    ],
                    onChange: handleSelectCardStyle,
                    style: {
                        "--border": "solid transparent 1px",
                        "--checked-border": "solid var(--adm-color-primary) 1px"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Card_CardStyle = (CardStyle);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/ImageOrientation/index.tsx






var ImageOrientation = function(props) {
    var imageOrientationDefault = props.imageOrientationDefault, imageRatioDefault = props.imageRatioDefault, onUpdateImageOrientationValue = props.onUpdateImageOrientationValue, onUpdateImageRatioValue = props.onUpdateImageRatioValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ratioDefault = (0,react.useMemo)(function() {
        var valueRatio = imageRatioDefault || "1/1";
        if (imageOrientationDefault === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        imageRatioDefault,
        imageOrientationDefault
    ]);
    var ref = (0,react.useState)(imageOrientationDefault), imageOrientation1 = ref[0], setImageOrientation = ref[1];
    var ref1 = (0,react.useState)(ratioDefault), imageRatio = ref1[0], setImageRatio = ref1[1];
    var imageRatioDetection = (0,react.useMemo)(function() {
        var valueRatio = imageRatio;
        if (imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        imageOrientation1,
        imageRatio
    ]);
    var imageOptions = [
        {
            label: "1:1",
            value: "1/1"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "4:3" : "3:4",
            value: "4/3"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:2" : "2:3",
            value: "3/2"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "16:9" : "9:16",
            value: "16/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "21:9" : "9:21",
            value: "21/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:1" : "1:3",
            value: "3/1"
        }, 
    ];
    var imageOrientationOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/landscape.png",
                height: 96,
                width: 96,
                className: "m-auto"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_landscape_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/portrait.png",
                height: 96,
                width: 96,
                className: "m-auto"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_portrait_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT
        }, 
    ];
    (0,react.useEffect)(function() {
        if (imageRatioDetection) {
            onUpdateImageRatioValue(imageRatioDetection);
        }
    }, [
        imageRatioDetection
    ]);
    (0,react.useEffect)(function() {
        if (imageOrientation1) {
            onUpdateImageOrientationValue(imageOrientation1);
        }
    }, [
        imageOrientation1
    ]);
    var handleSelectImageRatio = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            setImageRatio(valueRatio);
        }
    };
    var handleSelectImageOrientation = function(arr) {
        if (arr && arr.length) {
            var imageOrientation = arr[0];
            setImageOrientation(imageOrientation);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[15px] leading-[13px] text-[#666666]",
                        children: t("ss_builder_image_orientation_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                        className: "selector-scroll",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                            options: imageOrientationOptions,
                            value: [
                                imageOrientation1
                            ],
                            onChange: handleSelectImageOrientation,
                            style: {
                                "--border": "solid transparent 1px",
                                "--checked-border": "solid var(--adm-color-primary) 1px"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_image_slider_ratio_selected_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                        options: imageOptions,
                        value: [
                            imageRatio
                        ],
                        onChange: handleSelectImageRatio,
                        columns: 4,
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Card_ImageOrientation = (ImageOrientation);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/CardItemAddNew/index.tsx
function CardItemAddNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardItemAddNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardItemAddNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var CARD_TITLE_MAXIMUM = 50;
var CARD_SUBTITLE_MAXIMUM = 50;
var CARD_LABEL_MAXIMUM = 25;
var CARD_DESCRIPTION_MAXIMUM = 250;
var CardItemAddNew = function(props) {
    var ref;
    var imageRatio = props.imageRatio, callBackCancelCardAddNew = props.callBackCancelCardAddNew, handleSaveCardAddNew = props.handleSaveCardAddNew, cardEditData = props.cardEditData, blockType = props.blockType;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "".concat(blockType, "-").concat((0,v4/* default */.Z)());
    var isUseAffUrl = cardEditData ? (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.use_aff_url) === 1 : true;
    var cardUrlDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.card_url) || "";
    var valueUrlImageDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.image) || "";
    var cardTitleDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.card_title) || "";
    var cardSubtitleDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.card_subtitle) || "";
    var cardLabelDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.card_label) || "";
    var cardDescriptionDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.card_description) || "";
    var defaultLinkData = (cardEditData === null || cardEditData === void 0 ? void 0 : cardEditData.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: cardUrlDefault
    };
    var openInNewTabDefault = (cardEditData === null || cardEditData === void 0 ? void 0 : (ref = cardEditData.content_attributes) === null || ref === void 0 ? void 0 : ref.open_new_tab) || false;
    var ref1 = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref1[0], setValueUrlImage = ref1[1];
    var ref2 = (0,react.useState)(""), valueNameImage = ref2[0], setValueNameImage = ref2[1];
    var ref3 = (0,react.useState)(null), valueImageBase64 = ref3[0], setValueImageBase64 = ref3[1];
    var ref4 = (0,react.useState)([]), uploadedImageArr = ref4[0], setUploadedImageArr = ref4[1];
    var ref5 = (0,react.useState)(cardUrlDefault), cardUrl = ref5[0], setCardUrl = ref5[1];
    var ref6 = (0,react.useState)(cardLabelDefault), cardLabel = ref6[0], setCardLabel = ref6[1];
    var ref7 = (0,react.useState)(cardTitleDefault), cardTitle = ref7[0], setCardTitle = ref7[1];
    var ref8 = (0,react.useState)(cardSubtitleDefault), cardSubtitle = ref8[0], setCardSubtitle = ref8[1];
    var ref9 = (0,react.useState)(cardDescriptionDefault), cardDescription = ref9[0], setCardDescription = ref9[1];
    var ref10 = (0,react.useState)(false), isValidUrl = ref10[0], setIsValidUrl = ref10[1];
    var ref11 = (0,react.useState)(false), isLoadingBtn = ref11[0], setIsLoadingBtn = ref11[1];
    var ref12 = (0,react.useState)(false), isDisableBtnSave = ref12[0], setIsDisableBtnSave = ref12[1];
    var ref13 = (0,react.useState)(false), isValidFileFormat = ref13[0], setIsValidFileFormat = ref13[1];
    var ref14 = (0,react.useState)(false), isValidFileSize = ref14[0], setIsValidFileSize = ref14[1];
    var ref15 = (0,react.useState)(isUseAffUrl), hasCardUrl = ref15[0], setHasCardUrl = ref15[1];
    var ref16 = (0,react.useState)(defaultLinkData), linkData1 = ref16[0], setLinkData = ref16[1];
    var ref17 = (0,react.useState)(false), isEcommerce = ref17[0], setIsEcommerce = ref17[1];
    var ref18 = (0,react.useState)(openInNewTabDefault), openNewTab = ref18[0], setOpenNewTab = ref18[1];
    var checkEcommerce = function(data) {
        if (data) {
            var ecommerceOrSocial = new URL(data);
            setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcommerce(linkData1.target_url);
        }
    }, [
        linkData1
    ]);
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var handleSaveCard = function() {
        var defaultData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            image: valueImageBase64 || valueUrlImage,
            image_name: valueNameImage,
            image_base64: valueImageBase64,
            card_title: cardTitle,
            card_subtitle: cardSubtitle,
            card_label: cardLabel,
            card_url: cardUrl,
            card_description: cardDescription,
            use_aff_url: hasCardUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
            link_data: linkData1,
            open_new_tab: isEcommerce ? true : openNewTab
        };
        if (cardEditData) {
            handleSaveCardAddNew(CardItemAddNew_objectSpread({}, cardEditData, {
                image: valueImageBase64 || valueUrlImage,
                image_base64: valueImageBase64,
                card_title: cardTitle,
                card_subtitle: cardSubtitle,
                card_label: cardLabel,
                card_url: cardUrl,
                card_description: cardDescription,
                image_name: valueNameImage,
                use_aff_url: hasCardUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            }));
        } else {
            handleSaveCardAddNew(defaultData);
        }
        callBackCancelCardAddNew();
        setValueUrlImage(null);
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelCardAddNew = function() {
        if (linkData1.value !== defaultLinkData.value || valueUrlImage && valueUrlImage !== valueUrlImageDefault || cardUrl !== cardUrlDefault || cardTitle !== cardTitleDefault || cardSubtitle !== cardSubtitleDefault || cardDescription !== cardDescriptionDefault || cardLabel !== cardLabelDefault || openNewTab !== openInNewTabDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "var(--adm-color-primary)",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_content")
                }),
                confirmText: t("ss_builder_confirm_cancel_image_slider_add_new_btn_label"),
                cancelText: t("ss_builder_cancel_image_slider_add_new_btn_label"),
                onConfirm: function() {
                    callBackCancelCardAddNew();
                    setValueUrlImage(null);
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                },
                onCancel: function() {
                    return;
                }
            });
        } else {
            callBackCancelCardAddNew();
            setValueUrlImage(null);
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleChangeCardDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= CARD_DESCRIPTION_MAXIMUM) {
            setCardDescription(val);
        }
    };
    var handleChangeCardTitle = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= CARD_TITLE_MAXIMUM) {
            setCardTitle(val);
        }
    };
    var handleChangeCardSubtitle = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= CARD_SUBTITLE_MAXIMUM) {
            setCardSubtitle(val);
        }
    };
    var handleChangeCardLabel = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= CARD_LABEL_MAXIMUM) {
            setCardLabel(val);
        }
    };
    var handleCheckCardUrl = function(data) {
        setHasCardUrl(data);
    };
    var onUpdateLinkData = function(linkData) {
        if (linkData.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setCardUrl(linkData.value);
        } else {
            setCardUrl(null);
        }
        setLinkData(linkData);
    };
    (0,react.useEffect)(function() {
        setIsDisableBtnSave(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setIsLoadingBtn(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsDisableBtnSave,
        setIsLoadingBtn
    ]);
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        if (valueUrlImage && (valueUrlImage !== valueUrlImageDefault || cardDescription !== cardDescriptionDefault || cardTitle !== cardTitleDefault || cardSubtitle !== cardSubtitleDefault || cardLabel !== cardLabelDefault || cardUrl !== cardUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || isUseAffUrl !== hasCardUrl || openNewTab !== openInNewTabDefault) && !isValidUrl && !isDisableBtnSave) {
            return true;
        } else return false;
    }, [
        valueUrlImage,
        valueUrlImageDefault,
        isValidUrl,
        isDisableBtnSave,
        cardDescription,
        cardDescriptionDefault,
        cardLabel,
        cardLabelDefault,
        cardSubtitle,
        cardSubtitleDefault,
        cardTitle,
        cardTitleDefault,
        cardUrl,
        cardUrlDefault,
        hasCardUrl,
        linkData1,
        defaultLinkData,
        openNewTab,
        openInNewTabDefault, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-2 relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CardIcon */._K, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t("ss_builder_title_block_card")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white px-4 py-[13px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_add_new_image_of_image_slider_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                                valueUrlImage: valueUrlImage,
                                imageRatio: imageRatio
                            }),
                            isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_format_invalid_content")
                                    })
                                ]
                            }),
                            isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_size_invalid_content")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                    onChange: handleImageUrl,
                                    upload: function(file) {
                                        return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                    },
                                    className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                    value: uploadedImageArr,
                                    // disableUpload={isDisableUploadBtn}
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        block: true,
                                        color: "primary",
                                        fill: "solid",
                                        size: "middle",
                                        className: "w-full grow",
                                        children: t("ss_builder_upload_button_label")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " bg-white mt-3 px-4 py-[13px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] leading-[13px] text-[#666666]",
                                        children: t("ss_builder_card_add_new_title_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                        placeholder: t("ss_builder_block_heading_placeholder"),
                                        onChange: handleChangeCardTitle,
                                        value: cardTitle,
                                        maxLength: CARD_TITLE_MAXIMUM
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                        children: "".concat(cardTitle ? cardTitle.length : 0, "/").concat(CARD_TITLE_MAXIMUM)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] leading-[13px] text-[#666666]",
                                        children: t("ss_builder_card_add_new_subtitle_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                        placeholder: t("ss_builder_block_heading_placeholder"),
                                        onChange: handleChangeCardSubtitle,
                                        value: cardSubtitle,
                                        maxLength: CARD_SUBTITLE_MAXIMUM
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                        children: "".concat(cardSubtitle ? cardSubtitle.length : 0, "/").concat(CARD_SUBTITLE_MAXIMUM)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] leading-[13px] text-[#666666]",
                                        children: t("ss_builder_card_add_new_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                        placeholder: t("ss_builder_block_heading_placeholder"),
                                        onChange: handleChangeCardLabel,
                                        value: cardLabel,
                                        maxLength: CARD_LABEL_MAXIMUM
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                        children: "".concat(cardLabel ? cardLabel.length : 0, "/").concat(CARD_LABEL_MAXIMUM)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] leading-[13px] text-[#666666]",
                                        children: t("ss_builder_card_add_new_description_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                        placeholder: t("ss_builder_block_description_placeholder"),
                                        onChange: handleChangeCardDescription,
                                        value: cardDescription,
                                        maxLength: CARD_DESCRIPTION_MAXIMUM
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                        children: "".concat(cardDescription ? cardDescription.length : 0, "/").concat(CARD_DESCRIPTION_MAXIMUM)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                label: t("ss_builder_button_link_icon_origin_url_label"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                    item: linkData1,
                                    onChange: function(item) {
                                        onUpdateLinkData(item);
                                    },
                                    onLoading: onAffLoading,
                                    onError: function(errorMessage) {
                                        setIsValidUrl(!!errorMessage);
                                    }
                                })
                            }),
                            linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: typeof hasCardUrl !== "boolean" ? true : hasCardUrl,
                                                onChange: handleCheckCardUrl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_use_affiliate_link_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_use_affiliate_link_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                stopPropagation: [
                                                    "click"
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelCardAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveCard,
                            loading: isLoadingBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Card_CardItemAddNew = (CardItemAddNew);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/ListIems/CardModeSelect.tsx








var CardModeSelect = function(props) {
    var enable = props.enable, image = props.image, card_title = props.card_title, use_aff_url = props.use_aff_url, link_url = props.link_url, link_data = props.link_data;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var linkDatavalue = link_url || (link_data === null || link_data === void 0 ? void 0 : link_data.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex items-center gap-[6px] flex-row", enable !== 1 && "opacity-40"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    src: image,
                    width: 40,
                    height: 40,
                    fit: "cover",
                    style: {
                        borderRadius: "4px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                            children: card_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            style: {
                                marginTop: "2px"
                            },
                            children: use_aff_url === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                        children: t("ss_builder_product_link_wrapped_label")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                children: (link_data === null || link_data === void 0 ? void 0 : link_data.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ListIems_CardModeSelect = (CardModeSelect);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/ListIems/index.tsx
function ListIems_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListIems_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListIems_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ListIems_arrayLikeToArray(arr);
}
function ListIems_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListIems_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ListIems_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListIems_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListIems_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListIems_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListIems_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ListIems_slicedToArray(arr, i) {
    return ListIems_arrayWithHoles(arr) || ListIems_iterableToArrayLimit(arr, i) || ListIems_unsupportedIterableToArray(arr, i) || ListIems_nonIterableRest();
}
function ListIems_toConsumableArray(arr) {
    return ListIems_arrayWithoutHoles(arr) || ListIems_iterableToArray(arr) || ListIems_unsupportedIterableToArray(arr) || ListIems_nonIterableSpread();
}
function ListIems_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListIems_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListIems_arrayLikeToArray(o, minLen);
}





















var ListIems_ListItems = function(props1) {
    var blockType = props1.blockType, listItemDataDefault = props1.listItemDataDefault, ITEM_MAXIMUM = props1.ITEM_MAXIMUM, onUpdateListDataItem = props1.onUpdateListDataItem, labelObject = props1.labelObject, imageRatio = props1.imageRatio, setShowFooterBlockEdit = props1.setShowFooterBlockEdit;
    var ref5 = (0,react.useState)(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG), mode = ref5[0], setMode = ref5[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(listItemDataDefault), listItemData = ref1[0], setListItemData = ref1[1];
    var ref2 = (0,react.useState)(null), itemEditData = ref2[0], setItemEditData = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenAddNewItem = ref3[0], setIsOpenAddNewItem = ref3[1];
    var ref4 = (0,react.useState)({}), placeholderProps1 = ref4[0], setPlaceholderProps = ref4[1];
    var listItemDataSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(listItemData, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        listItemData
    ]);
    var cardEnable = (0,react.useMemo)(function() {
        return listItemData.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        listItemData
    ]);
    (0,react.useEffect)(function() {
        if (listItemDataSortOrder) onUpdateListDataItem(listItemDataSortOrder);
    }, [
        listItemDataSortOrder
    ]);
    var handleClickMoreIcon = function(event) {
        // event.preventDefault();
        event.stopPropagation();
    };
    var handleClickPopoverItem = function(item, itemData) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-item":
                onDisableEnableItem(itemData);
                break;
            case "delete-item":
                onRemoveItem(itemData);
                break;
            default:
        }
    };
    var MoreElement = function(props) {
        var itemData = props.itemData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: [
                        {
                            key: "eye-visible-item",
                            icon: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                                className: ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                                className: ""
                            }),
                            text: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? labelObject === null || labelObject === void 0 ? void 0 : labelObject.showItemLabel : labelObject === null || labelObject === void 0 ? void 0 : labelObject.hideItemLabel
                        },
                        {
                            key: "delete-item",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                                className: ""
                            }),
                            text: labelObject === null || labelObject === void 0 ? void 0 : labelObject.deleteItemLabel
                        }, 
                    ],
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item, itemData);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleOpenAddItem = function() {
        setIsOpenAddNewItem(true);
        setItemEditData(null);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(listItemDataSortOrder);
        var ref = ListIems_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return ListIems_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setListItemData(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(itemData) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        var newItems = listItemDataSortOrderClone && Array.isArray(listItemDataSortOrderClone) && listItemDataSortOrderClone.filter(function(ele) {
            return ele.uid !== itemData.uid;
        });
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteCardModalLabel
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteCardModalDescription
            }),
            confirmText: labelObject === null || labelObject === void 0 ? void 0 : labelObject.confirmDeleteCardModalBtnLabel,
            cancelText: labelObject === null || labelObject === void 0 ? void 0 : labelObject.cancelDeleteCardModalBtnLabel,
            onConfirm: function() {
                setListItemData(newItems);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.deleteItemSuccessfullyLabel
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var onDisableEnableItem = function(itemData) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        var newImageItems = listItemDataSortOrderClone && Array.isArray(listItemDataSortOrderClone) && listItemDataSortOrderClone.map(function(ele) {
            return ele.uid === itemData.uid ? ListIems_objectSpread({}, ele, {
                enable: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) !== 1 ? 1 : 2
            }) : ele;
        });
        setListItemData(newImageItems);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: (itemData === null || itemData === void 0 ? void 0 : itemData.enable) === 1 ? labelObject === null || labelObject === void 0 ? void 0 : labelObject.hideItemSuccessfullyLabel : labelObject === null || labelObject === void 0 ? void 0 : labelObject.showItemSuccessfullyLabel
            })
        });
    };
    var listItemRate = (0,react.useMemo)(function() {
        return listItemDataSortOrder && "".concat(listItemDataSortOrder.length, "/").concat(ITEM_MAXIMUM);
    }, [
        listItemDataSortOrder
    ]);
    var handleEditItem = function(item) {
        setIsOpenAddNewItem(true);
        setItemEditData(item);
    };
    var handleSaveItemAddNew = function(data) {
        var listItemDataSortOrderClone = cloneDeep_default()(listItemDataSortOrder);
        if (Array.isArray(listItemDataSortOrderClone)) {
            if (itemEditData) {
                var indexEditItems = listItemDataSortOrderClone.findIndex(function(x) {
                    return (x === null || x === void 0 ? void 0 : x.uid) === (itemEditData === null || itemEditData === void 0 ? void 0 : itemEditData.uid);
                });
                listItemDataSortOrderClone[indexEditItems] = data;
            } else {
                if (listItemDataSortOrderClone.length === 0) {
                    listItemDataSortOrderClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = listItemDataSortOrderClone.map(function(x) {
                        return x.sort_order;
                    });
                    listItemDataSortOrderClone.push(ListIems_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, ListIems_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setListItemData(listItemDataSortOrderClone);
            !itemEditData && (0,block_libs/* scrollToNewItem */.i)("blocks-".concat(data === null || data === void 0 ? void 0 : data.uid));
        }
    };
    var renderLinksSelectItemsMode = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "mt-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWithCheckbox/* default */.Z, {
                propertyIndex: "uid",
                onCancel: swichToDragMode,
                item: ListIems_CardModeSelect,
                onChange: setListItemData,
                defaultItems: listItemDataSortOrder.map(function(e) {
                    return ListIems_objectSpread({
                        id: e.uid
                    }, e);
                }),
                header: {
                    title: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listTitle,
                    sticky: true
                },
                footer: {
                    countTitle: t("ss_builder_filter_select_multi_items_card_count")
                },
                blockType: blockType
            })
        });
    };
    var swichToDragMode = function() {
        setMode(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG);
        setShowFooterBlockEdit(true);
    };
    var switchToSelectItemsMode = function() {
        setMode(config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS);
        setShowFooterBlockEdit(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mode === config_interface/* ITEMS_MODE.DRAG */.yo.DRAG && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-card-editor-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between px-3 pt-4 pb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-[15px] text-[#666666]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-red-600",
                                                    children: "*"
                                                }),
                                                labelObject === null || labelObject === void 0 ? void 0 : labelObject.listTitle
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-grow justify-end gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                size: "small",
                                                fill: "solid",
                                                color: "primary",
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "3px 12px 3px 12px"
                                                },
                                                onClick: handleOpenAddItem,
                                                disabled: listItemDataSortOrder.length === ITEM_MAXIMUM,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                        className: "w-[15px] h-[15px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_add_new_label")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: listItemRate
                                                    })
                                                ]
                                            }),
                                            listItemDataSortOrder.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                onClick: switchToSelectItemsMode,
                                                color: "primary",
                                                fill: "outline",
                                                size: "small",
                                                children: t("ss_builder_select_label")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            cardEnable.length === 0 && listItemData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                                style: {
                                    color: "var(--adm-color-danger)"
                                },
                                children: t("ss_builder_need_to_display_at_least_one_card")
                            })
                        ]
                    }),
                    (listItemDataSortOrder === null || listItemDataSortOrder === void 0 ? void 0 : listItemDataSortOrder.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                            onDragEnd: onDragEnd,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                droppableId: "blocks-".concat(blockType),
                                children: function(provided1, snapshot1) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", ListIems_objectSpread({}, provided1.droppableProps, {
                                        ref: provided1.innerRef,
                                        className: "relative",
                                        children: [
                                            (listItemDataSortOrder === null || listItemDataSortOrder === void 0 ? void 0 : listItemDataSortOrder.length) > 0 && listItemDataSortOrder.map(function(ele, index) {
                                                var ref6;
                                                var linkDatavalue = ele.link_url || (ele === null || ele === void 0 ? void 0 : (ref6 = ele.link_data) === null || ref6 === void 0 ? void 0 : ref6.value);
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                    draggableId: "blocks-".concat(ele.uid),
                                                    index: index,
                                                    children: function(provided, snapshot) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", ListIems_objectSpread({
                                                            ref: provided.innerRef
                                                        }, provided.draggableProps, provided.dragHandleProps, {
                                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                ref: popoverRef,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                                                                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                                                                            className: ""
                                                                        }),
                                                                        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {
                                                                            itemData: ele
                                                                        }),
                                                                        onClick: function() {
                                                                            return handleEditItem(ele);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: classnames_default()("flex items-center gap-[6px] flex-row", ele.enable !== 1 && "opacity-40"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                                                    src: ele.image,
                                                                                    width: 40,
                                                                                    height: 40,
                                                                                    fit: "cover",
                                                                                    style: {
                                                                                        borderRadius: "4px"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                                                                            children: ele.card_title
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "flex",
                                                                                            style: {
                                                                                                marginTop: "2px"
                                                                                            },
                                                                                            children: (ele === null || ele === void 0 ? void 0 : ele.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                        className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                                                                        children: t("ss_builder_product_link_wrapped_label")
                                                                                                    })
                                                                                                ]
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                                                                children: (ele === null || ele === void 0 ? void 0 : (ref = ele.link_data) === null || ref === void 0 ? void 0 : ref.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        }));
                                                    }
                                                }, "blocks-".concat(ele.uid));
                                            }),
                                            provided1.placeholder,
                                            !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                placeholderProps: placeholderProps1,
                                                content: t("ss_builder_placeholder_dragging_content"),
                                                style: {
                                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                    border: "1px dashed #1890FF",
                                                    borderRadius: "4px",
                                                    color: "#1890FF"
                                                }
                                            })
                                        ]
                                    }));
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CardIcon */._K, {
                                    className: "align-middle w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listEmptyLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: labelObject === null || labelObject === void 0 ? void 0 : labelObject.listEmptyDescription
                            })
                        ]
                    })
                ]
            }),
            mode === config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS && renderLinksSelectItemsMode(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewItem,
                onMaskClick: function() {
                    return setIsOpenAddNewItem(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardItemAddNew, {
                    imageRatio: imageRatio,
                    callBackCancelCardAddNew: function() {
                        return setIsOpenAddNewItem(false);
                    },
                    cardEditData: itemEditData,
                    indexCardEdit: itemEditData ? listItemData === null || listItemData === void 0 ? void 0 : listItemData.findIndex(function(x) {
                        return (x === null || x === void 0 ? void 0 : x.uid) === (itemEditData === null || itemEditData === void 0 ? void 0 : itemEditData.uid);
                    }) : null,
                    blockType: blockType,
                    handleSaveCardAddNew: handleSaveItemAddNew
                })
            })
        ]
    });
};
/* harmony default export */ var ListIems = (ListIems_ListItems);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Card/index.tsx
function Card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var Card_BLOCK_HEADING_MAXIMUM = 50;
var Card_BLOCK_DESCRIPTION_MAXIMUM = 250;
var SEE_MORE_BTN_MAXIMUM = 25;
var Card = function(props) {
    var ref19, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData, setShowFooterBlockEdit = props.setShowFooterBlockEdit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "cards-".concat((0,v4/* default */.Z)());
    var CARD_TITLE_DEFAULT = t("ss_builder_title_block_card");
    var defaultValueEditCard = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = CARD_TITLE_DEFAULT;
    var valueHeadingBlockDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref19 = defaultValueEditCard.content_attributes) === null || ref19 === void 0 ? void 0 : ref19.block_heading) || "";
    var valueDescriptionBlockDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref1 = defaultValueEditCard.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.block_description) || "";
    var seeMoreBtnContentDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref2 = defaultValueEditCard.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.see_more_btn_content) || t("ss_builder_see_more_btn_default_title");
    var listCardDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref3 = defaultValueEditCard.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.items) || [];
    var cardStyleDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref4 = defaultValueEditCard.style_attributes) === null || ref4 === void 0 ? void 0 : ref4.card_style) || configs_const/* CARD_STYLE.GRID */.wi.GRID;
    var cardSlideTypeDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref5 = defaultValueEditCard.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.card_slide_type) || configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE;
    var cardLayoutDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref6 = defaultValueEditCard.style_attributes) === null || ref6 === void 0 ? void 0 : ref6.card_layout) || configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1;
    var ref9 = (0,react.useState)(cardLayoutDefault), cardLayout = ref9[0], setCardLayout = ref9[1];
    var itemOnRowDefault = (0,react.useMemo)(function() {
        var ref;
        var item_on_row = defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref = defaultValueEditCard.style_attributes) === null || ref === void 0 ? void 0 : ref.item_on_row;
        if (cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_2 */.IT.LAYOUT_2 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_3 */.IT.LAYOUT_3 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_4 */.IT.LAYOUT_4) {
            return null;
        } else {
            if (item_on_row) {
                return item_on_row;
            } else return configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE;
        }
    }, [
        defaultValueEditCard,
        cardLayout
    ]);
    var ratioDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref7 = defaultValueEditCard.style_attributes) === null || ref7 === void 0 ? void 0 : ref7.ratio) || "16/9";
    var imageOrientationDefault = (defaultValueEditCard === null || defaultValueEditCard === void 0 ? void 0 : (ref8 = defaultValueEditCard.style_attributes) === null || ref8 === void 0 ? void 0 : ref8.image_orientation) || configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE;
    var ref10 = (0,react.useState)(ratioDefault), imageRatio = ref10[0], setImageRatio = ref10[1];
    var ref11 = (0,react.useState)(cardStyleDefault), cardStyle = ref11[0], setCardStyle = ref11[1];
    var ref12 = (0,react.useState)(cardSlideTypeDefault), cardSlideType = ref12[0], setCardSlideType = ref12[1];
    var ref13 = (0,react.useState)(itemOnRowDefault), itemOnRow = ref13[0], setItemOnRow = ref13[1];
    var ref14 = (0,react.useState)(seeMoreBtnContentDefault), seeMoreBtnContent = ref14[0], setSeeMoreBtnContent = ref14[1];
    var ref15 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref15[0], setValueHeadingBlock = ref15[1];
    var ref16 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref16[0], setValueDescriptionBlock = ref16[1];
    var ref17 = (0,react.useState)(imageOrientationDefault), imageOrientation = ref17[0], setImageOrientation = ref17[1];
    var ref18 = (0,react.useState)(listCardDefault), listCard = ref18[0], setListCard = ref18[1];
    var listCardEnable = (0,react.useMemo)(function() {
        return listCard === null || listCard === void 0 ? void 0 : listCard.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        listCard
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultCardData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.CARD,
                title: titleBlockDefault,
                content_attributes: {
                    items: listCard,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    see_more_btn_content: seeMoreBtnContent
                },
                style_attributes: {
                    ratio: imageRatio,
                    image_orientation: imageOrientation,
                    item_on_row: itemOnRow,
                    card_style: cardStyle,
                    card_slide_type: cardSlideType,
                    card_layout: cardLayout
                }
            };
            onUpdateData(defaultCardData);
        } else {
            onUpdateData(Card_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    items: listCard,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    see_more_btn_content: seeMoreBtnContent
                },
                style_attributes: {
                    ratio: imageRatio,
                    image_orientation: imageOrientation,
                    item_on_row: itemOnRow,
                    card_style: cardStyle,
                    card_slide_type: cardSlideType,
                    card_layout: cardLayout
                }
            }));
        }
    }, [
        imageOrientation,
        valueHeadingBlock,
        valueDescriptionBlock,
        imageRatio,
        seeMoreBtnContent,
        itemOnRow,
        cardStyle,
        cardSlideType,
        cardLayout,
        listCard, 
    ]);
    (0,react.useEffect)(function() {
        if (cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8) {
            setItemOnRow(null);
        } else {
            if (!itemOnRow) {
                setItemOnRow(configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE);
            }
        }
    }, [
        cardLayout,
        itemOnRow
    ]);
    (0,react.useEffect)(function() {
        if (cardStyle === configs_const/* CARD_STYLE.SLIDE */.wi.SLIDE && (cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6)) {
            setCardLayout(configs_const/* CARD_LAYOUTS.LAYOUT_4 */.IT.LAYOUT_4);
        }
    }, [
        cardLayout,
        cardStyle
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if ((listCard === null || listCard === void 0 ? void 0 : listCard.length) > 0 && seeMoreBtnContent && (JSON.stringify(listCard) !== JSON.stringify(listCardDefault) || imageRatio !== ratioDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation !== imageOrientationDefault || itemOnRow !== itemOnRowDefault || cardStyle !== cardStyleDefault || cardSlideType !== cardSlideTypeDefault || cardLayout !== cardLayoutDefault || seeMoreBtnContent !== seeMoreBtnContentDefault) && listCardEnable.length > 0) {
            return false;
        } else return true;
    }, [
        listCard,
        listCardDefault,
        imageRatio,
        ratioDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation,
        imageOrientationDefault,
        itemOnRow,
        itemOnRowDefault,
        cardStyle,
        cardStyleDefault,
        cardSlideType,
        cardSlideTypeDefault,
        cardLayout,
        cardLayoutDefault,
        seeMoreBtnContent,
        seeMoreBtnContentDefault,
        listCardEnable, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(listCard) !== JSON.stringify(listCardDefault) || imageRatio !== ratioDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation !== imageOrientationDefault || itemOnRow !== itemOnRowDefault || cardStyle !== cardStyleDefault || cardSlideType !== cardSlideTypeDefault || cardLayout !== cardLayoutDefault || seeMoreBtnContent !== seeMoreBtnContentDefault) {
            return true;
        } else return false;
    }, [
        listCard,
        listCardDefault,
        imageRatio,
        ratioDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation,
        imageOrientationDefault,
        itemOnRow,
        itemOnRowDefault,
        cardStyle,
        cardStyleDefault,
        cardSlideType,
        cardSlideTypeDefault,
        cardLayout,
        cardLayoutDefault,
        seeMoreBtnContent,
        seeMoreBtnContentDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var itemOnRowOptions = [
        {
            label: "1",
            value: configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE
        },
        {
            label: "2",
            value: configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO
        }, 
    ];
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Card_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Card_BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var handleSelectItemOnRow = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setItemOnRow(value);
        }
    };
    var handleChangeSeeMoreBtnContent = function(value) {
        if ((value === null || value === void 0 ? void 0 : value.length) <= SEE_MORE_BTN_MAXIMUM) {
            setSeeMoreBtnContent(value);
        }
    };
    var labelObject = {
        listTitle: t("ss_builder_list_label"),
        listEmptyLabel: t("ss_builder_list_card_empty_title"),
        listEmptyDescription: t("ss_builder_list_card_empty_content"),
        itemAdditionalBtnLabel: t("ss_builder_card_additional_btn_label"),
        deleteItemLabel: t("ss_builder_delete_card_label"),
        deleteItemSuccessfullyLabel: t("ss_builder_delete_card_successfully_label"),
        showItemLabel: t("ss_builder_show_card_label"),
        showItemSuccessfullyLabel: t("ss_builder_show_card_successfully_label"),
        hideItemLabel: t("ss_builder_hide_card_label"),
        hideItemSuccessfullyLabel: t("ss_builder_hide_card_successfully_label"),
        confirmDeleteCardModalLabel: t("ss_builder_confirm_delete_card_modal_label"),
        confirmDeleteCardModalDescription: t("ss_builder_confirm_delete_card_modal_description"),
        confirmDeleteCardModalBtnLabel: t("ss_builder_confirm_delete_card_modal_btn_label"),
        cancelDeleteCardModalBtnLabel: t("ss_builder_cancel_delete_card_modal_btn_label")
    };
    var isCardStyleSlide = (0,react.useMemo)(function() {
        return cardStyle === configs_const/* CARD_STYLE.SLIDE */.wi.SLIDE;
    }, [
        cardStyle
    ]);
    var isDisplayItemOnRow = (0,react.useMemo)(function() {
        return cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7 && cardLayout !== configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8;
    }, [
        cardLayout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_heading_placeholder"),
                                onChange: handleChangeBlockHeading,
                                value: valueHeadingBlock,
                                maxLength: Card_BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(Card_BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: Card_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(Card_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardStyle, {
                        cardStyleValue: cardStyle,
                        onUpdateCardStyleValue: function(val) {
                            return setCardStyle(val);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    cardStyle === configs_const/* CARD_STYLE.SLIDE */.wi.SLIDE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardSlideType, {
                                cardSlideValue: cardSlideType,
                                onUpdateCardSlideValue: function(val) {
                                    return setCardSlideType(val);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardLayouts, {
                        cardLayoutValue: cardLayout,
                        onUpdateCardLayoutValue: function(val) {
                            return setCardLayout(val);
                        },
                        isCardStyleSlide: isCardStyleSlide
                    }),
                    isDisplayItemOnRow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] leading-[13px] text-[#666666]",
                                        children: t("ss_builder_items_per_row")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: itemOnRowOptions,
                                        value: [
                                            itemOnRow
                                        ],
                                        onChange: handleSelectItemOnRow,
                                        columns: 2,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    (cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                className: "ml-1 w-[14px] h-[14px]",
                                onClick: function() {},
                                fillColor: "#1890FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_card_layout_alert_1")
                            })
                        ]
                    }),
                    (cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7 || cardLayout === configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                className: "ml-1 w-[14px] h-[14px]",
                                onClick: function() {},
                                fillColor: "#1890FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_card_layout_alert_2")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_card_btn_content_label")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: seeMoreBtnContent,
                                placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder"),
                                onChange: handleChangeSeeMoreBtnContent,
                                maxLength: SEE_MORE_BTN_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(seeMoreBtnContent ? seeMoreBtnContent.length : 0, "/").concat(SEE_MORE_BTN_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_ImageOrientation, {
                        imageOrientationDefault: imageOrientation,
                        imageRatioDefault: imageRatio,
                        onUpdateImageOrientationValue: function(val) {
                            return setImageOrientation(val);
                        },
                        onUpdateImageRatioValue: function(val) {
                            return setImageRatio(val);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListIems, {
                blockType: block === null || block === void 0 ? void 0 : block.block_type,
                listItemDataDefault: listCard,
                ITEM_MAXIMUM: 20,
                onUpdateListDataItem: function(val) {
                    return setListCard(val);
                },
                labelObject: labelObject,
                imageRatio: imageRatio,
                setShowFooterBlockEdit: setShowFooterBlockEdit
            })
        ]
    });
};
/* harmony default export */ var block_editor_Card = (Card);

// EXTERNAL MODULE: ./src/features/block/api/index.tsx + 1 modules
var block_api = __webpack_require__(57457);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/api/index.tsx
var DigitalProduct_api = __webpack_require__(49961);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/constants/index.tsx
var DigitalProduct_constants = __webpack_require__(53443);
;// CONCATENATED MODULE: ./src/features/block/block-editor/DigitalProduct/icons/index.tsx

var MoveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250860)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.75279 10.5843H19.2528C19.4959 10.5843 19.7291 10.4877 19.901 10.3158C20.0729 10.1439 20.1695 9.91076 20.1695 9.66764C20.1695 9.42453 20.0729 9.19137 19.901 9.01946C19.7291 8.84755 19.4959 8.75098 19.2528 8.75098H2.75279C2.50967 8.75098 2.27651 8.84755 2.10461 9.01946C1.9327 9.19137 1.83612 9.42453 1.83612 9.66764C1.83612 9.91076 1.9327 10.1439 2.10461 10.3158C2.27651 10.4877 2.50967 10.5843 2.75279 10.5843ZM19.2528 12.4176H2.75279C2.50967 12.4176 2.27651 12.5142 2.10461 12.6861C1.9327 12.858 1.83612 13.0912 1.83612 13.3343C1.83612 13.5774 1.9327 13.8106 2.10461 13.9825C2.27651 14.1544 2.50967 14.251 2.75279 14.251H19.2528C19.4959 14.251 19.7291 14.1544 19.901 13.9825C20.0729 13.8106 20.1695 13.5774 20.1695 13.3343C20.1695 13.0912 20.0729 12.858 19.901 12.6861C19.7291 12.5142 19.4959 12.4176 19.2528 12.4176Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250860",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var ThreeDot = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250909)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        className: "clickable-area",
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.0028 9.66797C10.6402 9.66797 10.2858 9.77549 9.98426 9.97694C9.68277 10.1784 9.44779 10.4647 9.30903 10.7997C9.17027 11.1347 9.13396 11.5033 9.2047 11.859C9.27544 12.2146 9.45005 12.5413 9.70645 12.7977C9.96284 13.0541 10.2895 13.2287 10.6451 13.2994C11.0008 13.3701 11.3694 13.3338 11.7044 13.1951C12.0394 13.0563 12.3257 12.8213 12.5272 12.5198C12.7286 12.2184 12.8361 11.8639 12.8361 11.5013C12.8361 11.0151 12.643 10.5488 12.2992 10.2049C11.9554 9.86112 11.489 9.66797 11.0028 9.66797ZM4.58614 9.66797C4.22354 9.66797 3.86909 9.77549 3.5676 9.97694C3.26611 10.1784 3.03112 10.4647 2.89236 10.7997C2.7536 11.1347 2.7173 11.5033 2.78804 11.859C2.85877 12.2146 3.03338 12.5413 3.28978 12.7977C3.54618 13.0541 3.87284 13.2287 4.22848 13.2994C4.58411 13.3701 4.95273 13.3338 5.28773 13.1951C5.62273 13.0563 5.90905 12.8213 6.1105 12.5198C6.31195 12.2184 6.41948 11.8639 6.41948 11.5013C6.41948 11.0151 6.22632 10.5488 5.8825 10.2049C5.53869 9.86112 5.07237 9.66797 4.58614 9.66797ZM17.4195 9.66797C17.0569 9.66797 16.7024 9.77549 16.4009 9.97694C16.0994 10.1784 15.8645 10.4647 15.7257 10.7997C15.5869 11.1347 15.5506 11.5033 15.6214 11.859C15.6921 12.2146 15.8667 12.5413 16.1231 12.7977C16.3795 13.0541 16.7062 13.2287 17.0618 13.2994C17.4174 13.3701 17.7861 13.3338 18.1211 13.1951C18.4561 13.0563 18.7424 12.8213 18.9438 12.5198C19.1453 12.2184 19.2528 11.8639 19.2528 11.5013C19.2528 11.0151 19.0597 10.5488 18.7158 10.2049C18.372 9.86112 17.9057 9.66797 17.4195 9.66797Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250909",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        className: "clickable-area",
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var DeleteIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250924)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.6663 4.99935H13.333V4.16602C13.333 3.50297 13.0696 2.86709 12.6008 2.39825C12.1319 1.92941 11.496 1.66602 10.833 1.66602H9.16633C8.50329 1.66602 7.8674 1.92941 7.39856 2.39825C6.92972 2.86709 6.66633 3.50297 6.66633 4.16602V4.99935H3.333C3.11198 4.99935 2.90002 5.08715 2.74374 5.24343C2.58746 5.39971 2.49966 5.61167 2.49966 5.83268C2.49966 6.0537 2.58746 6.26566 2.74374 6.42194C2.90002 6.57822 3.11198 6.66602 3.333 6.66602H4.16633V15.8327C4.16633 16.4957 4.42972 17.1316 4.89856 17.6005C5.3674 18.0693 6.00329 18.3327 6.66633 18.3327H13.333C13.996 18.3327 14.6319 18.0693 15.1008 17.6005C15.5696 17.1316 15.833 16.4957 15.833 15.8327V6.66602H16.6663C16.8873 6.66602 17.0993 6.57822 17.2556 6.42194C17.4119 6.26566 17.4997 6.0537 17.4997 5.83268C17.4997 5.61167 17.4119 5.39971 17.2556 5.24343C17.0993 5.08715 16.8873 4.99935 16.6663 4.99935ZM8.333 4.16602C8.333 3.945 8.42079 3.73304 8.57708 3.57676C8.73336 3.42048 8.94532 3.33268 9.16633 3.33268H10.833C11.054 3.33268 11.266 3.42048 11.4223 3.57676C11.5785 3.73304 11.6663 3.945 11.6663 4.16602V4.99935H8.333V4.16602ZM14.1663 15.8327C14.1663 16.0537 14.0785 16.2657 13.9223 16.4219C13.766 16.5782 13.554 16.666 13.333 16.666H6.66633C6.44532 16.666 6.23336 16.5782 6.07708 16.4219C5.9208 16.2657 5.833 16.0537 5.833 15.8327V6.66602H14.1663V15.8327Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250924",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var UpFirstIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250951)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.000976562)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.75798 5.24167C4.67873 5.1658 4.58527 5.10633 4.48298 5.06667C4.2801 4.98332 4.05253 4.98332 3.84965 5.06667C3.74735 5.10633 3.6539 5.1658 3.57465 5.24167L1.90798 6.90833C1.75106 7.06525 1.6629 7.27808 1.6629 7.5C1.6629 7.72192 1.75106 7.93475 1.90798 8.09167C2.0649 8.24859 2.27773 8.33674 2.49965 8.33674C2.72156 8.33674 2.93439 8.24859 3.09131 8.09167L3.33298 7.84167V14.1667C3.33298 14.3877 3.42078 14.5996 3.57706 14.7559C3.73334 14.9122 3.9453 15 4.16631 15C4.38733 15 4.59929 14.9122 4.75557 14.7559C4.91185 14.5996 4.99965 14.3877 4.99965 14.1667V7.84167L5.24131 8.09167C5.31878 8.16977 5.41095 8.23177 5.5125 8.27408C5.61405 8.31638 5.72297 8.33817 5.83298 8.33817C5.94299 8.33817 6.05191 8.31638 6.15346 8.27408C6.25501 8.23177 6.34718 8.16977 6.42465 8.09167C6.50275 8.0142 6.56475 7.92203 6.60706 7.82048C6.64936 7.71893 6.67114 7.61001 6.67114 7.5C6.67114 7.38999 6.64936 7.28107 6.60706 7.17952C6.56475 7.07797 6.50275 6.9858 6.42465 6.90833L4.75798 5.24167ZM9.16631 6.66667H17.4996C17.7207 6.66667 17.9326 6.57887 18.0889 6.42259C18.2452 6.26631 18.333 6.05435 18.333 5.83333C18.333 5.61232 18.2452 5.40036 18.0889 5.24408C17.9326 5.0878 17.7207 5 17.4996 5H9.16631C8.9453 5 8.73334 5.0878 8.57706 5.24408C8.42078 5.40036 8.33298 5.61232 8.33298 5.83333C8.33298 6.05435 8.42078 6.26631 8.57706 6.42259C8.73334 6.57887 8.9453 6.66667 9.16631 6.66667ZM17.4996 13.3333H9.16631C8.9453 13.3333 8.73334 13.4211 8.57706 13.5774C8.42078 13.7337 8.33298 13.9457 8.33298 14.1667C8.33298 14.3877 8.42078 14.5996 8.57706 14.7559C8.73334 14.9122 8.9453 15 9.16631 15H17.4996C17.7207 15 17.9326 14.9122 18.0889 14.7559C18.2452 14.5996 18.333 14.3877 18.333 14.1667C18.333 13.9457 18.2452 13.7337 18.0889 13.5774C17.9326 13.4211 17.7207 13.3333 17.4996 13.3333ZM17.4996 9.16667H9.16631C8.9453 9.16667 8.73334 9.25446 8.57706 9.41074C8.42078 9.56702 8.33298 9.77899 8.33298 10C8.33298 10.221 8.42078 10.433 8.57706 10.5893C8.73334 10.7455 8.9453 10.8333 9.16631 10.8333H17.4996C17.7207 10.8333 17.9326 10.7455 18.0889 10.5893C18.2452 10.433 18.333 10.221 18.333 10C18.333 9.77899 18.2452 9.56702 18.0889 9.41074C17.9326 9.25446 17.7207 9.16667 17.4996 9.16667Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250951",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.000976562)"
                    })
                })
            })
        ]
    });
};
var DownLastIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "21",
        viewBox: "0 0 28 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250978)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.00195312)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.24131 11.9093L4.99965 12.1593V5.83431C4.99965 5.6133 4.91185 5.40133 4.75557 5.24505C4.59929 5.08877 4.38733 5.00098 4.16631 5.00098C3.9453 5.00098 3.73334 5.08877 3.57706 5.24505C3.42078 5.40133 3.33298 5.6133 3.33298 5.83431V12.1593L3.09131 11.9093C2.93439 11.7524 2.72156 11.6642 2.49965 11.6642C2.27773 11.6642 2.0649 11.7524 1.90798 11.9093C1.75106 12.0662 1.6629 12.2791 1.6629 12.501C1.6629 12.7229 1.75106 12.9357 1.90798 13.0926L3.57465 14.7593C3.6539 14.8352 3.74735 14.8946 3.84965 14.9343C3.9494 14.9784 4.05725 15.0012 4.16631 15.0012C4.27537 15.0012 4.38323 14.9784 4.48298 14.9343C4.58527 14.8946 4.67873 14.8352 4.75798 14.7593L6.42465 13.0926C6.50235 13.0149 6.56398 12.9227 6.60603 12.8212C6.64808 12.7197 6.66972 12.6109 6.66972 12.501C6.66972 12.3911 6.64808 12.2823 6.60603 12.1808C6.56398 12.0792 6.50235 11.987 6.42465 11.9093C6.34695 11.8316 6.25471 11.77 6.15319 11.7279C6.05167 11.6859 5.94286 11.6642 5.83298 11.6642C5.7231 11.6642 5.61429 11.6859 5.51277 11.7279C5.41125 11.77 5.31901 11.8316 5.24131 11.9093ZM9.16631 6.66764H17.4996C17.7207 6.66764 17.9326 6.57985 18.0889 6.42357C18.2452 6.26728 18.333 6.05532 18.333 5.83431C18.333 5.6133 18.2452 5.40133 18.0889 5.24505C17.9326 5.08877 17.7207 5.00098 17.4996 5.00098H9.16631C8.9453 5.00098 8.73334 5.08877 8.57706 5.24505C8.42078 5.40133 8.33298 5.6133 8.33298 5.83431C8.33298 6.05532 8.42078 6.26728 8.57706 6.42357C8.73334 6.57985 8.9453 6.66764 9.16631 6.66764ZM17.4996 9.16764H9.16631C8.9453 9.16764 8.73334 9.25544 8.57706 9.41172C8.42078 9.568 8.33298 9.77996 8.33298 10.001C8.33298 10.222 8.42078 10.434 8.57706 10.5902C8.73334 10.7465 8.9453 10.8343 9.16631 10.8343H17.4996C17.7207 10.8343 17.9326 10.7465 18.0889 10.5902C18.2452 10.434 18.333 10.222 18.333 10.001C18.333 9.77996 18.2452 9.568 18.0889 9.41172C17.9326 9.25544 17.7207 9.16764 17.4996 9.16764ZM17.4996 13.3343H9.16631C8.9453 13.3343 8.73334 13.4221 8.57706 13.5784C8.42078 13.7347 8.33298 13.9466 8.33298 14.1676C8.33298 14.3887 8.42078 14.6006 8.57706 14.7569C8.73334 14.9132 8.9453 15.001 9.16631 15.001H17.4996C17.7207 15.001 17.9326 14.9132 18.0889 14.7569C18.2452 14.6006 18.333 14.3887 18.333 14.1676C18.333 13.9466 18.2452 13.7347 18.0889 13.5784C17.9326 13.4221 17.7207 13.3343 17.4996 13.3343Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250978",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00195312)"
                    })
                })
            })
        ]
    });
};
var WarningIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "46",
        height: "40",
        viewBox: "0 0 46 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M44.4 31L28.2 2.99997C26.6 0.199974 22.8 -0.800026 20 0.799974C19 1.39997 18.2 2.19997 17.8 2.99997L1.59999 31C-7.62939e-06 33.8 0.999993 37.6 3.79999 39.2C4.79999 39.8 5.79999 40 6.79999 40H39C42.4 40 45 37.2 45 34C45.2 32.8 44.8 31.8 44.4 31ZM23 32C21.8 32 21 31.2 21 30C21 28.8 21.8 28 23 28C24.2 28 25 28.8 25 30C25 31.2 24.2 32 23 32ZM25 22C25 23.2 24.2 24 23 24C21.8 24 21 23.2 21 22V14C21 12.8 21.8 12 23 12C24.2 12 25 12.8 25 14V22Z",
            fill: "#FF8F1F"
        })
    });
};
var RandomProductIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_243730)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.3917 5.18501C11.3447 5.127 11.2852 5.08027 11.2177 5.04826C11.1502 5.01624 11.0764 4.99976 11.0017 5.00001H10.0017V4.50001C10.0017 4.10219 9.84367 3.72066 9.56237 3.43935C9.28106 3.15805 8.89953 3.00001 8.50171 3.00001H5.36171L5.20171 2.50001C5.09798 2.20663 4.90558 1.95276 4.65116 1.77359C4.39674 1.59442 4.09289 1.49881 3.78171 1.50001H2.00171C1.60388 1.50001 1.22235 1.65805 0.941049 1.93935C0.659744 2.22066 0.501709 2.60219 0.501709 3.00001V9.00001C0.501709 9.39784 0.659744 9.77937 0.941049 10.0607C1.22235 10.342 1.60388 10.5 2.00171 10.5H9.20171C9.54232 10.499 9.87244 10.3821 10.1378 10.1686C10.4031 9.95503 10.5879 9.65753 10.6617 9.32501L11.5017 5.61001C11.5169 5.53547 11.5149 5.45844 11.4958 5.38479C11.4768 5.31114 11.4412 5.24282 11.3917 5.18501ZM2.68671 9.11001C2.66131 9.2228 2.5976 9.3233 2.50644 9.39441C2.41528 9.46552 2.30229 9.50284 2.18671 9.50001H2.00171C1.8691 9.50001 1.74192 9.44733 1.64816 9.35356C1.55439 9.2598 1.50171 9.13262 1.50171 9.00001V3.00001C1.50171 2.8674 1.55439 2.74023 1.64816 2.64646C1.74192 2.55269 1.8691 2.50001 2.00171 2.50001H3.78171C3.89074 2.49432 3.99864 2.52447 4.08893 2.58587C4.17921 2.64726 4.24692 2.73652 4.28171 2.84001L4.55171 3.66001C4.58379 3.75538 4.64391 3.83886 4.72419 3.89952C4.80448 3.96018 4.9012 3.9952 5.00171 4.00001H8.50171C8.63432 4.00001 8.76149 4.05269 8.85526 4.14646C8.94903 4.24023 9.00171 4.3674 9.00171 4.50001V5.00001H4.00171C3.88613 4.99719 3.77314 5.0345 3.68198 5.10561C3.59081 5.17672 3.52711 5.27722 3.50171 5.39001L2.68671 9.11001ZM9.68671 9.11001C9.66131 9.2228 9.5976 9.3233 9.50644 9.39441C9.41528 9.46552 9.30229 9.50284 9.18671 9.50001H3.60671C3.63253 9.4443 3.65102 9.38548 3.66171 9.32501L4.40171 6.00001H10.4017L9.68671 9.11001Z",
                        fill: "#059669"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_243730",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var OnlineConsultionIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_243786)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.15171 6.11C6.4185 5.87907 6.63248 5.59344 6.77915 5.27251C6.92581 4.95158 7.00171 4.60285 7.00171 4.25C7.00171 3.58696 6.73832 2.95107 6.26948 2.48223C5.80063 2.01339 5.16475 1.75 4.50171 1.75C3.83867 1.75 3.20278 2.01339 2.73394 2.48223C2.2651 2.95107 2.00171 3.58696 2.00171 4.25C2.00171 4.60285 2.07761 4.95158 2.22427 5.27251C2.37093 5.59344 2.58492 5.87907 2.85171 6.11C2.15178 6.42694 1.55794 6.93876 1.1412 7.58427C0.724457 8.22978 0.502445 8.98166 0.501709 9.75C0.501709 9.88261 0.554387 10.0098 0.648156 10.1036C0.741924 10.1973 0.869101 10.25 1.00171 10.25C1.13432 10.25 1.26149 10.1973 1.35526 10.1036C1.44903 10.0098 1.50171 9.88261 1.50171 9.75C1.50171 8.95435 1.81778 8.19129 2.38039 7.62868C2.943 7.06607 3.70606 6.75 4.50171 6.75C5.29736 6.75 6.06042 7.06607 6.62303 7.62868C7.18564 8.19129 7.50171 8.95435 7.50171 9.75C7.50171 9.88261 7.55439 10.0098 7.64816 10.1036C7.74192 10.1973 7.8691 10.25 8.00171 10.25C8.13432 10.25 8.26149 10.1973 8.35526 10.1036C8.44903 10.0098 8.50171 9.88261 8.50171 9.75C8.50097 8.98166 8.27896 8.22978 7.86222 7.58427C7.44548 6.93876 6.85164 6.42694 6.15171 6.11ZM4.50171 5.75C4.20504 5.75 3.91503 5.66203 3.66835 5.4972C3.42168 5.33238 3.22942 5.09811 3.11589 4.82403C3.00236 4.54994 2.97265 4.24834 3.03053 3.95736C3.08841 3.66639 3.23127 3.39912 3.44105 3.18934C3.65083 2.97956 3.9181 2.8367 4.20907 2.77882C4.50005 2.72094 4.80164 2.75065 5.07573 2.86418C5.34982 2.97771 5.58409 3.16997 5.74891 3.41664C5.91374 3.66332 6.00171 3.95333 6.00171 4.25C6.00171 4.64782 5.84367 5.02936 5.56237 5.31066C5.28106 5.59196 4.89953 5.75 4.50171 5.75ZM9.37171 5.91C9.69169 5.54966 9.90071 5.10453 9.97361 4.62817C10.0465 4.15181 9.98017 3.66454 9.78259 3.225C9.58501 2.78546 9.26461 2.4124 8.85994 2.15071C8.45528 1.88903 7.98361 1.74987 7.50171 1.75C7.3691 1.75 7.24192 1.80268 7.14816 1.89645C7.05439 1.99021 7.00171 2.11739 7.00171 2.25C7.00171 2.38261 7.05439 2.50979 7.14816 2.60355C7.24192 2.69732 7.3691 2.75 7.50171 2.75C7.89953 2.75 8.28106 2.90804 8.56237 3.18934C8.84367 3.47064 9.00171 3.85218 9.00171 4.25C9.001 4.51262 8.93136 4.77045 8.79974 4.99771C8.66812 5.22497 8.47915 5.41369 8.25171 5.545C8.17758 5.58776 8.11566 5.64883 8.07189 5.72237C8.02812 5.79591 8.00395 5.87945 8.00171 5.965C7.99962 6.04988 8.01918 6.1339 8.05854 6.20913C8.09791 6.28436 8.15578 6.34833 8.22671 6.395L8.42171 6.525L8.48671 6.56C9.08941 6.84586 9.59786 7.298 9.9522 7.86316C10.3065 8.42832 10.492 9.08297 10.4867 9.75C10.4867 9.88261 10.5394 10.0098 10.6332 10.1036C10.7269 10.1973 10.8541 10.25 10.9867 10.25C11.1193 10.25 11.2465 10.1973 11.3403 10.1036C11.434 10.0098 11.4867 9.88261 11.4867 9.75C11.4908 8.98271 11.2986 8.22713 10.9284 7.55503C10.5583 6.88294 10.0224 6.31666 9.37171 5.91Z",
                        fill: "#0891B2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_243786",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var CourseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_243674)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.0917 5.095C9.73207 5.02992 9.36719 4.99812 9.00171 5C8.79171 5 8.58671 5 8.38171 5.04C8.1265 4.69944 7.80074 4.41802 7.42671 4.215C7.74799 3.86413 7.92635 3.40574 7.92671 2.93C7.92671 2.41813 7.72338 1.92723 7.36143 1.56528C6.99949 1.20334 6.50858 1 5.99671 1C5.48485 1 4.99394 1.20334 4.632 1.56528C4.27005 1.92723 4.06671 2.41813 4.06671 2.93C4.06708 3.40574 4.24544 3.86413 4.56671 4.215C4.19491 4.41908 3.86968 4.69834 3.61171 5.035C3.41671 5 3.21171 5 3.00171 5C2.63593 5.00142 2.27105 5.03657 1.91171 5.105C1.79524 5.1263 1.6901 5.18824 1.61501 5.27981C1.53993 5.37137 1.49978 5.48661 1.50171 5.605V9.73C1.5016 9.80345 1.51766 9.87603 1.54877 9.94258C1.57988 10.0091 1.62527 10.068 1.68171 10.115C1.7378 10.1623 1.8036 10.1967 1.87446 10.2157C1.94532 10.2347 2.01949 10.2379 2.09171 10.225C2.39092 10.1598 2.6956 10.123 3.00171 10.115C3.97026 10.1139 4.9178 10.3973 5.72671 10.93L5.79171 10.955C5.85804 10.9838 5.92942 10.9991 6.00171 11C6.04944 10.9994 6.09674 10.991 6.14171 10.975H6.17671L6.24171 10.95C7.05833 10.4037 8.01919 10.113 9.00171 10.115C9.3072 10.1164 9.61187 10.1466 9.91171 10.205C9.98394 10.2179 10.0581 10.2147 10.129 10.1957C10.1998 10.1767 10.2656 10.1423 10.3217 10.095C10.3782 10.048 10.4235 9.98912 10.4547 9.92258C10.4858 9.85604 10.5018 9.78345 10.5017 9.71V5.585C10.5013 5.46832 10.4601 5.35546 10.3852 5.26597C10.3103 5.17648 10.2065 5.116 10.0917 5.095ZM6.00171 2C6.23594 2.01721 6.45498 2.1224 6.61485 2.29444C6.77471 2.46649 6.86357 2.69264 6.86357 2.9275C6.86357 3.16235 6.77471 3.38851 6.61485 3.56056C6.45498 3.7326 6.23594 3.83779 6.00171 3.855C5.76749 3.83779 5.54845 3.7326 5.38858 3.56056C5.22872 3.38851 5.13986 3.16235 5.13986 2.9275C5.13986 2.69264 5.22872 2.46649 5.38858 2.29444C5.54845 2.1224 5.76749 2.01721 6.00171 2ZM5.50171 9.665C4.71805 9.30276 3.86505 9.1151 3.00171 9.115C2.83671 9.115 2.67171 9.115 2.50171 9.14V6C2.921 5.9531 3.34462 5.9615 3.76171 6.025H3.81671C4.41251 6.1345 4.98346 6.35135 5.50171 6.665V9.665ZM6.00171 5.8C5.77938 5.67174 5.54888 5.55816 5.31171 5.46H5.28171C5.11671 5.395 4.95171 5.33 4.78171 5.28C5.12887 5.00369 5.55805 4.85066 6.00171 4.845C6.4442 4.84781 6.87326 4.99727 7.22171 5.27C6.79726 5.40251 6.38825 5.5802 6.00171 5.8ZM9.50171 9.14C8.47504 9.03684 7.43944 9.20944 6.50171 9.64V6.64C7.02091 6.3344 7.59221 6.12758 8.18672 6.03H8.28671C8.6887 5.9674 9.09713 5.95732 9.50171 6V9.14Z",
                        fill: "#DB2777"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_243674",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var VideoExclusiveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_243421)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.7667 3.575C10.6907 3.53112 10.6045 3.50801 10.5167 3.50801C10.4289 3.50801 10.3427 3.53112 10.2667 3.575L8.50171 4.445C8.48746 4.05679 8.32316 3.68924 8.04339 3.41972C7.76361 3.1502 7.39019 2.99974 7.00171 3H2.50171C2.10388 3 1.72235 3.15804 1.44105 3.43934C1.15974 3.72064 1.00171 4.10218 1.00171 4.5V7.5C1.00171 7.89782 1.15974 8.27936 1.44105 8.56066C1.72235 8.84197 2.10388 9 2.50171 9H7.00171C7.39019 9.00026 7.76361 8.8498 8.04339 8.58028C8.32316 8.31076 8.48746 7.94322 8.50171 7.555L10.2817 8.445C10.3499 8.47994 10.4251 8.49876 10.5017 8.5C10.5953 8.5003 10.6871 8.47431 10.7667 8.425C10.8388 8.37997 10.8982 8.31731 10.9393 8.24295C10.9804 8.16859 11.0019 8.08497 11.0017 8V4C11.0019 3.91503 10.9804 3.83141 10.9393 3.75705C10.8982 3.68269 10.8388 3.62004 10.7667 3.575ZM7.50171 7.5C7.50171 7.63261 7.44903 7.75979 7.35526 7.85355C7.26149 7.94732 7.13432 8 7.00171 8H2.50171C2.3691 8 2.24192 7.94732 2.14816 7.85355C2.05439 7.75979 2.00171 7.63261 2.00171 7.5V4.5C2.00171 4.36739 2.05439 4.24022 2.14816 4.14645C2.24192 4.05268 2.3691 4 2.50171 4H7.00171C7.13432 4 7.26149 4.05268 7.35526 4.14645C7.44903 4.24022 7.50171 4.36739 7.50171 4.5V7.5ZM10.0017 7.19L8.50171 6.44V5.56L10.0017 4.81V7.19Z",
                        fill: "#D97706"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_243421",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var EbookExclusiveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_243618)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.5017 3C10.3691 3 10.2419 3.05268 10.1482 3.14645C10.0544 3.24021 10.0017 3.36739 10.0017 3.5V8.5C10.0017 8.89782 9.84367 9.27936 9.56237 9.56066C9.28106 9.84196 8.89953 10 8.50171 10H3.50171C3.3691 10 3.24192 10.0527 3.14816 10.1464C3.05439 10.2402 3.00171 10.3674 3.00171 10.5C3.00171 10.6326 3.05439 10.7598 3.14816 10.8536C3.24192 10.9473 3.3691 11 3.50171 11H8.50171C9.16475 11 9.80064 10.7366 10.2695 10.2678C10.7383 9.79893 11.0017 9.16304 11.0017 8.5V3.5C11.0017 3.36739 10.949 3.24021 10.8553 3.14645C10.7615 3.05268 10.6343 3 10.5017 3ZM9.00171 7.5V2.5C9.00171 2.10218 8.84367 1.72064 8.56237 1.43934C8.28106 1.15804 7.89953 1 7.50171 1H2.50171C2.10388 1 1.72235 1.15804 1.44105 1.43934C1.15974 1.72064 1.00171 2.10218 1.00171 2.5V7.5C1.00171 7.89782 1.15974 8.27936 1.44105 8.56066C1.72235 8.84196 2.10388 9 2.50171 9H7.50171C7.89953 9 8.28106 8.84196 8.56237 8.56066C8.84367 8.27936 9.00171 7.89782 9.00171 7.5ZM5.00171 2H6.00171V4.43L5.82171 4.28C5.73187 4.20517 5.61864 4.16419 5.50171 4.16419C5.38478 4.16419 5.27155 4.20517 5.18171 4.28L5.00171 4.43V2ZM2.00171 7.5V2.5C2.00171 2.36739 2.05439 2.24021 2.14816 2.14645C2.24192 2.05268 2.3691 2 2.50171 2H4.00171V5.5C4.0017 5.59558 4.02909 5.68916 4.08064 5.76966C4.13218 5.85015 4.20571 5.91419 4.29253 5.95417C4.37934 5.99416 4.4758 6.00843 4.57048 5.99528C4.66515 5.98214 4.75407 5.94213 4.82671 5.88L5.50171 5.315L6.17671 5.88C6.26728 5.95745 6.38254 6.00001 6.50171 6C6.57405 5.99949 6.64551 5.98417 6.71171 5.955C6.7985 5.91483 6.87195 5.85062 6.92335 5.76997C6.97475 5.68933 7.00195 5.59563 7.00171 5.5V2H7.50171C7.63432 2 7.76149 2.05268 7.85526 2.14645C7.94903 2.24021 8.00171 2.36739 8.00171 2.5V7.5C8.00171 7.63261 7.94903 7.75979 7.85526 7.85355C7.76149 7.94732 7.63432 8 7.50171 8H2.50171C2.3691 8 2.24192 7.94732 2.14816 7.85355C2.05439 7.75979 2.00171 7.63261 2.00171 7.5Z",
                        fill: "#9333EA"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_243618",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var RequiredIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "8",
        height: "24",
        viewBox: "0 0 8 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6526_237306)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "23",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.91797 11.3477L3.92578 12.1094L5.91797 12.8711C6.42578 13.0664 6.71875 13.2227 6.79688 13.3398C6.875 13.457 6.91406 13.5742 6.91406 13.6914C6.91406 14.0039 6.85547 14.1797 6.73828 14.2188C6.62109 14.2578 6.50391 14.2773 6.38672 14.2773C6.26953 14.2773 6.15234 14.2578 6.03516 14.2188C5.91797 14.1406 5.78125 14.043 5.625 13.9258L3.80859 12.2852L4.21875 14.7461C4.25781 14.8633 4.27734 14.9805 4.27734 15.0977C4.27734 15.1758 4.27734 15.2344 4.27734 15.2734C4.27734 15.5078 4.21875 15.6836 4.10156 15.8008C3.98438 15.8789 3.84766 15.918 3.69141 15.918C3.57422 15.918 3.4375 15.8789 3.28125 15.8008C3.16406 15.7227 3.10547 15.5469 3.10547 15.2734C3.10547 15.1953 3.125 15.1172 3.16406 15.0391C3.16406 14.9609 3.16406 14.8633 3.16406 14.7461L3.63281 12.2852L1.81641 13.9258C1.69922 14.0039 1.5625 14.082 1.40625 14.1602C1.28906 14.2383 1.17188 14.2773 1.05469 14.2773C0.9375 14.2773 0.820312 14.2383 0.703125 14.1602C0.585938 14.082 0.527344 13.9258 0.527344 13.6914C0.527344 13.5352 0.585938 13.3984 0.703125 13.2812C0.820312 13.1641 1.09375 13.0273 1.52344 12.8711L3.51562 12.1094L1.52344 11.3477C1.25 11.2305 1.01562 11.1328 0.820312 11.0547C0.625 10.9375 0.527344 10.7617 0.527344 10.5273C0.527344 10.332 0.585938 10.1953 0.703125 10.1172C0.820312 10 0.9375 9.94141 1.05469 9.94141C1.17188 9.94141 1.28906 9.98047 1.40625 10.0586C1.5625 10.0977 1.69922 10.1758 1.81641 10.293L3.63281 11.9336L3.22266 9.47266C3.22266 9.35547 3.22266 9.25781 3.22266 9.17969C3.18359 9.10156 3.16406 9.02344 3.16406 8.94531C3.16406 8.78906 3.22266 8.65234 3.33984 8.53516C3.45703 8.37891 3.59375 8.30078 3.75 8.30078C3.98438 8.30078 4.14062 8.37891 4.21875 8.53516C4.29688 8.69141 4.33594 8.82812 4.33594 8.94531C4.33594 9.02344 4.33594 9.12109 4.33594 9.23828C4.33594 9.31641 4.31641 9.39453 4.27734 9.47266L3.80859 11.9336L5.625 10.293C5.78125 10.1367 5.91797 10.0391 6.03516 10C6.15234 9.96094 6.26953 9.94141 6.38672 9.94141C6.54297 9.94141 6.66016 10 6.73828 10.1172C6.85547 10.2344 6.91406 10.3711 6.91406 10.5273C6.91406 10.6836 6.875 10.8203 6.79688 10.9375C6.71875 11.0156 6.42578 11.1523 5.91797 11.3477Z",
                        fill: "#FF3141"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6526_237306",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "23",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7491_319597)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.84341 2.03027C7.91245 2.03027 7.96841 2.08624 7.96841 2.15527V7.03027H12.8434C12.9124 7.03027 12.9684 7.08624 12.9684 7.15527V7.84277C12.9684 7.91181 12.9124 7.96777 12.8434 7.96777H7.96841V12.8428C7.96841 12.9118 7.91245 12.9678 7.84341 12.9678H7.15591C7.08688 12.9678 7.03091 12.9118 7.03091 12.8428V7.96777H2.15591C2.08688 7.96777 2.03091 7.91181 2.03091 7.84277V7.15527C2.03091 7.08624 2.08688 7.03027 2.15591 7.03027H7.03091V2.15527C7.03091 2.08624 7.08688 2.03027 7.15591 2.03027H7.84341Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7491_319597",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var TicketAccountIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_11364_179423)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        transform: "translate(0 0.0117188)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25179 5.84538C5.09708 5.84538 4.94871 5.90684 4.83931 6.01623C4.72992 6.12563 4.66846 6.274 4.66846 6.42871V7.59538C4.66846 7.75009 4.72992 7.89846 4.83931 8.00786C4.94871 8.11725 5.09708 8.17871 5.25179 8.17871C5.4065 8.17871 5.55487 8.11725 5.66427 8.00786C5.77367 7.89846 5.83512 7.75009 5.83512 7.59538V6.42871C5.83512 6.274 5.77367 6.12563 5.66427 6.01623C5.55487 5.90684 5.4065 5.84538 5.25179 5.84538ZM12.2518 6.42871C12.4065 6.42871 12.5549 6.36725 12.6643 6.25786C12.7737 6.14846 12.8351 6.00009 12.8351 5.84538V3.51204C12.8351 3.35733 12.7737 3.20896 12.6643 3.09957C12.5549 2.99017 12.4065 2.92871 12.2518 2.92871H1.75179C1.59708 2.92871 1.44871 2.99017 1.33931 3.09957C1.22992 3.20896 1.16846 3.35733 1.16846 3.51204V5.84538C1.16846 6.00009 1.22992 6.14846 1.33931 6.25786C1.44871 6.36725 1.59708 6.42871 1.75179 6.42871C1.9065 6.42871 2.05487 6.49017 2.16427 6.59957C2.27367 6.70896 2.33512 6.85733 2.33512 7.01204C2.33512 7.16675 2.27367 7.31513 2.16427 7.42452C2.05487 7.53392 1.9065 7.59538 1.75179 7.59538C1.59708 7.59538 1.44871 7.65684 1.33931 7.76623C1.22992 7.87563 1.16846 8.024 1.16846 8.17871V10.512C1.16846 10.6668 1.22992 10.8151 1.33931 10.9245C1.44871 11.0339 1.59708 11.0954 1.75179 11.0954H12.2518C12.4065 11.0954 12.5549 11.0339 12.6643 10.9245C12.7737 10.8151 12.8351 10.6668 12.8351 10.512V8.17871C12.8351 8.024 12.7737 7.87563 12.6643 7.76623C12.5549 7.65684 12.4065 7.59538 12.2518 7.59538C12.0971 7.59538 11.9487 7.53392 11.8393 7.42452C11.7299 7.31513 11.6685 7.16675 11.6685 7.01204C11.6685 6.85733 11.7299 6.70896 11.8393 6.59957C11.9487 6.49017 12.0971 6.42871 12.2518 6.42871ZM11.6685 5.36704C11.3306 5.48966 11.0387 5.71333 10.8324 6.00764C10.6262 6.30195 10.5155 6.65264 10.5155 7.01204C10.5155 7.37145 10.6262 7.72214 10.8324 8.01645C11.0387 8.31076 11.3306 8.53442 11.6685 8.65704V9.92871H5.83512C5.83512 9.774 5.77367 9.62563 5.66427 9.51623C5.55487 9.40684 5.4065 9.34538 5.25179 9.34538C5.09708 9.34538 4.94871 9.40684 4.83931 9.51623C4.72992 9.62563 4.66846 9.774 4.66846 9.92871H2.33512V8.65704C2.67296 8.53442 2.96486 8.31076 3.17113 8.01645C3.37741 7.72214 3.48807 7.37145 3.48807 7.01204C3.48807 6.65264 3.37741 6.30195 3.17113 6.00764C2.96486 5.71333 2.67296 5.48966 2.33512 5.36704V4.09538H4.66846C4.66846 4.25009 4.72992 4.39846 4.83931 4.50786C4.94871 4.61725 5.09708 4.67871 5.25179 4.67871C5.4065 4.67871 5.55487 4.61725 5.66427 4.50786C5.77367 4.39846 5.83512 4.25009 5.83512 4.09538H11.6685V5.36704Z",
                        fill: "#16A34A"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_11364_179423",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(0 0.0117188)"
                    })
                })
            })
        ]
    });
};
var PhotoCatIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_13371_10679)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        transform: "translate(0 0.00585938)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.0854 1.17285H2.9187C2.45457 1.17285 2.00945 1.35723 1.68126 1.68541C1.35308 2.0136 1.1687 2.45872 1.1687 2.92285V11.0895C1.1687 11.5536 1.35308 11.9988 1.68126 12.327C2.00945 12.6551 2.45457 12.8395 2.9187 12.8395H11.0854C11.1813 12.8382 11.277 12.8284 11.3712 12.8104L11.5462 12.7695H11.587H11.6162L11.832 12.6879L11.9079 12.647C11.9662 12.612 12.0304 12.5829 12.0887 12.542C12.1666 12.4847 12.2406 12.4224 12.3104 12.3554L12.3512 12.3029C12.4085 12.2448 12.4611 12.1824 12.5087 12.1162L12.5612 12.0404C12.6019 11.9754 12.6371 11.9071 12.6662 11.8362C12.6822 11.8082 12.6959 11.7789 12.707 11.7487C12.7362 11.6787 12.7537 11.6029 12.777 11.527V11.4395C12.8101 11.3255 12.8297 11.2081 12.8354 11.0895V2.92285C12.8354 2.45872 12.651 2.0136 12.3228 1.68541C11.9946 1.35723 11.5495 1.17285 11.0854 1.17285ZM2.9187 11.6729C2.76399 11.6729 2.61562 11.6114 2.50622 11.502C2.39683 11.3926 2.33537 11.2442 2.33537 11.0895V8.57535L4.25453 6.65035C4.30876 6.59568 4.37328 6.55228 4.44436 6.52266C4.51545 6.49305 4.59169 6.4778 4.6687 6.4778C4.74571 6.4778 4.82195 6.49305 4.89304 6.52266C4.96412 6.55228 5.02864 6.59568 5.08287 6.65035L10.0995 11.6729H2.9187ZM11.6687 11.0895C11.6682 11.1614 11.6543 11.2326 11.6279 11.2995C11.6145 11.328 11.5989 11.3553 11.5812 11.3812C11.5656 11.4059 11.548 11.4293 11.5287 11.4512L8.40787 8.33035L8.9212 7.81702C8.97543 7.76234 9.03995 7.71895 9.11103 7.68933C9.18212 7.65972 9.25836 7.64447 9.33537 7.64447C9.41237 7.64447 9.48862 7.65972 9.5597 7.68933C9.63079 7.71895 9.6953 7.76234 9.74953 7.81702L11.6687 9.74202V11.0895ZM11.6687 8.09118L10.572 7.00618C10.2382 6.68943 9.79556 6.51285 9.33537 6.51285C8.87518 6.51285 8.43253 6.68943 8.0987 7.00618L7.58537 7.51952L5.90537 5.83952C5.57154 5.52276 5.12889 5.34618 4.6687 5.34618C4.20851 5.34618 3.76586 5.52276 3.43203 5.83952L2.33537 6.92452V2.92285C2.33537 2.76814 2.39683 2.61977 2.50622 2.51037C2.61562 2.40098 2.76399 2.33952 2.9187 2.33952H11.0854C11.2401 2.33952 11.3885 2.40098 11.4978 2.51037C11.6072 2.61977 11.6687 2.76814 11.6687 2.92285V8.09118Z",
                        fill: "#4F46E5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_13371_10679",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(0 0.00585938)"
                    })
                })
            })
        ]
    });
};
var AddProductPlusIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_14169_80427)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        rx: "6",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.8335 9.16683H10.8335V4.16683C10.8335 3.94582 10.7457 3.73385 10.5894 3.57757C10.4331 3.42129 10.2212 3.3335 10.0002 3.3335C9.77915 3.3335 9.56719 3.42129 9.41091 3.57757C9.25463 3.73385 9.16683 3.94582 9.16683 4.16683V9.16683H4.16683C3.94582 9.16683 3.73385 9.25463 3.57757 9.41091C3.42129 9.56719 3.3335 9.77915 3.3335 10.0002C3.3335 10.2212 3.42129 10.4331 3.57757 10.5894C3.73385 10.7457 3.94582 10.8335 4.16683 10.8335H9.16683V15.8335C9.16683 16.0545 9.25463 16.2665 9.41091 16.4228C9.56719 16.579 9.77915 16.6668 10.0002 16.6668C10.2212 16.6668 10.4331 16.579 10.5894 16.4228C10.7457 16.2665 10.8335 16.0545 10.8335 15.8335V10.8335H15.8335C16.0545 10.8335 16.2665 10.7457 16.4228 10.5894C16.579 10.4331 16.6668 10.2212 16.6668 10.0002C16.6668 9.77915 16.579 9.56719 16.4228 9.41091C16.2665 9.25463 16.0545 9.16683 15.8335 9.16683Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14169_80427",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        rx: "6",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ChooseDataStoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_14169_80446)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        rx: "6",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.25817 6.42508L9.1665 4.50841V12.5001C9.1665 12.7211 9.2543 12.9331 9.41058 13.0893C9.56686 13.2456 9.77882 13.3334 9.99984 13.3334C10.2209 13.3334 10.4328 13.2456 10.5891 13.0893C10.7454 12.9331 10.8332 12.7211 10.8332 12.5001V4.50841L12.7415 6.42508C12.819 6.50318 12.9111 6.56518 13.0127 6.60749C13.1142 6.64979 13.2232 6.67158 13.3332 6.67158C13.4432 6.67158 13.5521 6.64979 13.6537 6.60749C13.7552 6.56518 13.8474 6.50318 13.9248 6.42508C14.0029 6.34761 14.0649 6.25544 14.1072 6.15389C14.1496 6.05234 14.1713 5.94342 14.1713 5.83341C14.1713 5.7234 14.1496 5.61448 14.1072 5.51293C14.0649 5.41138 14.0029 5.31921 13.9248 5.24174L10.5915 1.90841C10.5123 1.83254 10.4188 1.77307 10.3165 1.73341C10.1136 1.65006 9.88605 1.65006 9.68317 1.73341C9.58088 1.77307 9.48742 1.83254 9.40817 1.90841L6.07484 5.24174C5.99714 5.31944 5.9355 5.41168 5.89345 5.5132C5.8514 5.61472 5.82976 5.72353 5.82976 5.83341C5.82976 5.94329 5.8514 6.0521 5.89345 6.15362C5.9355 6.25514 5.99714 6.34738 6.07484 6.42508C6.15254 6.50278 6.24478 6.56441 6.3463 6.60646C6.44781 6.64851 6.55662 6.67015 6.6665 6.67015C6.77639 6.67015 6.88519 6.64851 6.98671 6.60646C7.08823 6.56441 7.18047 6.50278 7.25817 6.42508ZM17.4998 10.0001C17.2788 10.0001 17.0669 10.0879 16.9106 10.2442C16.7543 10.4004 16.6665 10.6124 16.6665 10.8334V15.8334C16.6665 16.0544 16.5787 16.2664 16.4224 16.4227C16.2661 16.5789 16.0542 16.6667 15.8332 16.6667H4.1665C3.94549 16.6667 3.73353 16.5789 3.57725 16.4227C3.42097 16.2664 3.33317 16.0544 3.33317 15.8334V10.8334C3.33317 10.6124 3.24537 10.4004 3.08909 10.2442C2.93281 10.0879 2.72085 10.0001 2.49984 10.0001C2.27882 10.0001 2.06686 10.0879 1.91058 10.2442C1.7543 10.4004 1.6665 10.6124 1.6665 10.8334V15.8334C1.6665 16.4965 1.9299 17.1323 2.39874 17.6012C2.86758 18.07 3.50346 18.3334 4.1665 18.3334H15.8332C16.4962 18.3334 17.1321 18.07 17.6009 17.6012C18.0698 17.1323 18.3332 16.4965 18.3332 15.8334V10.8334C18.3332 10.6124 18.2454 10.4004 18.0891 10.2442C17.9328 10.0879 17.7209 10.0001 17.4998 10.0001Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14169_80446",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        rx: "6",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var EditIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "21",
        viewBox: "0 0 28 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_14169_68679)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.00195312)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.1665 15.0011H7.69984C7.80951 15.0018 7.91823 14.9807 8.01976 14.9393C8.12129 14.8978 8.21364 14.8367 8.2915 14.7595L14.0582 8.98446L16.4248 6.6678C16.5029 6.59033 16.5649 6.49816 16.6072 6.39661C16.6496 6.29506 16.6713 6.18614 16.6713 6.07613C16.6713 5.96612 16.6496 5.8572 16.6072 5.75565C16.5649 5.6541 16.5029 5.56193 16.4248 5.48446L12.8915 1.90946C12.814 1.83136 12.7219 1.76936 12.6203 1.72705C12.5188 1.68475 12.4098 1.66296 12.2998 1.66296C12.1898 1.66296 12.0809 1.68475 11.9794 1.72705C11.8778 1.76936 11.7856 1.83136 11.7082 1.90946L9.35817 4.2678L3.57484 10.0428C3.4976 10.1207 3.4365 10.213 3.39503 10.3145C3.35356 10.4161 3.33254 10.5248 3.33317 10.6345V14.1678C3.33317 14.3888 3.42097 14.6008 3.57725 14.7571C3.73353 14.9133 3.94549 15.0011 4.1665 15.0011ZM12.2998 3.67613L14.6582 6.03446L13.4748 7.2178L11.1165 4.85946L12.2998 3.67613ZM4.99984 10.9761L9.9415 6.03446L12.2998 8.3928L7.35817 13.3345H4.99984V10.9761ZM17.4998 16.6678H2.49984C2.27882 16.6678 2.06686 16.7556 1.91058 16.9119C1.7543 17.0682 1.6665 17.2801 1.6665 17.5011C1.6665 17.7221 1.7543 17.9341 1.91058 18.0904C2.06686 18.2467 2.27882 18.3345 2.49984 18.3345H17.4998C17.7209 18.3345 17.9328 18.2467 18.0891 18.0904C18.2454 17.9341 18.3332 17.7221 18.3332 17.5011C18.3332 17.2801 18.2454 17.0682 18.0891 16.9119C17.9328 16.7556 17.7209 16.6678 17.4998 16.6678Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14169_68679",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00195312)"
                    })
                })
            })
        ]
    });
};
var DeleteForeverIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "21",
        viewBox: "0 0 28 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_14169_68814)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.00598145)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.33284 15.0052C8.55386 15.0052 8.76582 14.9174 8.9221 14.7611C9.07838 14.6049 9.16618 14.3929 9.16618 14.1719V9.17188C9.16618 8.95086 9.07838 8.7389 8.9221 8.58262C8.76582 8.42634 8.55386 8.33854 8.33284 8.33854C8.11183 8.33854 7.89987 8.42634 7.74359 8.58262C7.58731 8.7389 7.49951 8.95086 7.49951 9.17188V14.1719C7.49951 14.3929 7.58731 14.6049 7.74359 14.7611C7.89987 14.9174 8.11183 15.0052 8.33284 15.0052ZM16.6662 5.00521H13.3328V4.17188C13.3328 3.50883 13.0695 2.87295 12.6006 2.40411C12.1318 1.93527 11.4959 1.67188 10.8328 1.67188H9.16618C8.50314 1.67188 7.86725 1.93527 7.39841 2.40411C6.92957 2.87295 6.66618 3.50883 6.66618 4.17188V5.00521H3.33285C3.11183 5.00521 2.89987 5.09301 2.74359 5.24929C2.58731 5.40557 2.49951 5.61753 2.49951 5.83854C2.49951 6.05956 2.58731 6.27152 2.74359 6.4278C2.89987 6.58408 3.11183 6.67188 3.33285 6.67188H4.16618V15.8385C4.16618 16.5016 4.42957 17.1375 4.89841 17.6063C5.36725 18.0752 6.00314 18.3385 6.66618 18.3385H13.3328C13.9959 18.3385 14.6318 18.0752 15.1006 17.6063C15.5695 17.1375 15.8328 16.5016 15.8328 15.8385V6.67188H16.6662C16.8872 6.67188 17.0992 6.58408 17.2554 6.4278C17.4117 6.27152 17.4995 6.05956 17.4995 5.83854C17.4995 5.61753 17.4117 5.40557 17.2554 5.24929C17.0992 5.09301 16.8872 5.00521 16.6662 5.00521ZM8.33284 4.17188C8.33284 3.95086 8.42064 3.7389 8.57692 3.58262C8.7332 3.42634 8.94516 3.33854 9.16618 3.33854H10.8328C11.0539 3.33854 11.2658 3.42634 11.4221 3.58262C11.5784 3.7389 11.6662 3.95086 11.6662 4.17188V5.00521H8.33284V4.17188ZM14.1662 15.8385C14.1662 16.0596 14.0784 16.2715 13.9221 16.4278C13.7658 16.5841 13.5539 16.6719 13.3328 16.6719H6.66618C6.44516 16.6719 6.2332 16.5841 6.07692 16.4278C5.92064 16.2715 5.83284 16.0596 5.83284 15.8385V6.67188H14.1662V15.8385ZM11.6662 15.0052C11.8872 15.0052 12.0992 14.9174 12.2554 14.7611C12.4117 14.6049 12.4995 14.3929 12.4995 14.1719V9.17188C12.4995 8.95086 12.4117 8.7389 12.2554 8.58262C12.0992 8.42634 11.8872 8.33854 11.6662 8.33854C11.4452 8.33854 11.2332 8.42634 11.0769 8.58262C10.9206 8.7389 10.8328 8.95086 10.8328 9.17188V14.1719C10.8328 14.3929 10.9206 14.6049 11.0769 14.7611C11.2332 14.9174 11.4452 15.0052 11.6662 15.0052Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14169_68814",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00598145)"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/config/type.ts
var type = __webpack_require__(710);
;// CONCATENATED MODULE: ./src/features/block/block-editor/DigitalProduct/config/category.ts
function category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var _obj;
var categoryBackgroundMap = (_obj = {}, category_defineProperty(_obj, type/* CAT_ID.RANDOM_PRODUCT */.m.RANDOM_PRODUCT, "#D1FAE5"), category_defineProperty(_obj, type/* CAT_ID.ONLINE_CONSULTION */.m.ONLINE_CONSULTION, "#CFFAFE"), category_defineProperty(_obj, type/* CAT_ID.COURSE */.m.COURSE, "#FFE4E6"), category_defineProperty(_obj, type/* CAT_ID.VIDEO */.m.VIDEO, "#FEF3C7"), category_defineProperty(_obj, type/* CAT_ID.EXCLUSIVE_EBOOK */.m.EXCLUSIVE_EBOOK, "#F3E8FF"), category_defineProperty(_obj, type/* CAT_ID.TICKET_ACCOUNT */.m.TICKET_ACCOUNT, "#F0FDF4"), category_defineProperty(_obj, type/* CAT_ID.PHOTO */.m.PHOTO, "#EEF2FF"), _obj);
var _obj1;
var categoryTextColorMap = (_obj1 = {}, category_defineProperty(_obj1, type/* CAT_ID.RANDOM_PRODUCT */.m.RANDOM_PRODUCT, "#059669"), category_defineProperty(_obj1, type/* CAT_ID.ONLINE_CONSULTION */.m.ONLINE_CONSULTION, "#06B6D4"), category_defineProperty(_obj1, type/* CAT_ID.COURSE */.m.COURSE, "#DB2777"), category_defineProperty(_obj1, type/* CAT_ID.VIDEO */.m.VIDEO, "#D97706"), category_defineProperty(_obj1, type/* CAT_ID.EXCLUSIVE_EBOOK */.m.EXCLUSIVE_EBOOK, "#9333EA"), category_defineProperty(_obj1, type/* CAT_ID.TICKET_ACCOUNT */.m.TICKET_ACCOUNT, "#16A34A"), category_defineProperty(_obj1, type/* CAT_ID.PHOTO */.m.PHOTO, "#4F46E5"), _obj1);
var _obj2;
var categoryNameMap = (_obj2 = {}, category_defineProperty(_obj2, type/* CAT_ID.RANDOM_PRODUCT */.m.RANDOM_PRODUCT, "ss_dp_cat_random_product"), category_defineProperty(_obj2, type/* CAT_ID.ONLINE_CONSULTION */.m.ONLINE_CONSULTION, "ss_dp_cat_online_consultion"), category_defineProperty(_obj2, type/* CAT_ID.COURSE */.m.COURSE, "ss_dp_cat_course"), category_defineProperty(_obj2, type/* CAT_ID.VIDEO */.m.VIDEO, "ss_dp_cat_video"), category_defineProperty(_obj2, type/* CAT_ID.EXCLUSIVE_EBOOK */.m.EXCLUSIVE_EBOOK, "ss_dp_cat_ebook_document"), category_defineProperty(_obj2, type/* CAT_ID.TICKET_ACCOUNT */.m.TICKET_ACCOUNT, "ss_dp_cat_ticket_account"), category_defineProperty(_obj2, type/* CAT_ID.PHOTO */.m.PHOTO, "ss_dp_sell_photo"), _obj2);

// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/components/ProductItem/style.module.scss
var ProductItem_style_module = __webpack_require__(76616);
var ProductItem_style_module_default = /*#__PURE__*/__webpack_require__.n(ProductItem_style_module);
;// CONCATENATED MODULE: ./src/features/block/block-editor/DigitalProduct/components/ProductItem/index.tsx
function ProductItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var ProductItem_obj;
var ICON_MAP = (ProductItem_obj = {}, ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.RANDOM_PRODUCT */.m.RANDOM_PRODUCT, /*#__PURE__*/ (0,jsx_runtime.jsx)(RandomProductIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.ONLINE_CONSULTION */.m.ONLINE_CONSULTION, /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineConsultionIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.COURSE */.m.COURSE, /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.VIDEO */.m.VIDEO, /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoExclusiveIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.EXCLUSIVE_EBOOK */.m.EXCLUSIVE_EBOOK, /*#__PURE__*/ (0,jsx_runtime.jsx)(EbookExclusiveIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.TICKET_ACCOUNT */.m.TICKET_ACCOUNT, /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketAccountIcon, {})), ProductItem_defineProperty(ProductItem_obj, type/* CAT_ID.PHOTO */.m.PHOTO, /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoCatIcon, {})), ProductItem_obj);
function ProductItem(param1) {
    var item1 = param1.item, countryCode = param1.countryCode, handleMove = param1.handleMove, handleDelete = param1.handleDelete, popoverActive = param1.popoverActive, setPopoverActive = param1.setPopoverActive, number = param1.number, lastList = param1.lastList, handleChooseIframe = param1.handleChooseIframe;
    var ref, ref1, ref2;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: DigitalProduct_constants/* ACTION_KEY.EDIT */.pp.EDIT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditIcon, {}),
            text: t("ss_builder_edit_block_label")
        },
        {
            key: DigitalProduct_constants/* ACTION_KEY.DELETE_DISPLAY */.pp.DELETE_DISPLAY,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteIcon, {}),
            text: t("ss_display_delete"),
            onClick: function() {
                return handleClickDelete();
            }
        }
    ];
    if (number !== 0) {
        actions.push({
            key: DigitalProduct_constants/* ACTION_KEY.UP_FIRST */.pp.UP_FIRST,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpFirstIcon, {}),
            text: t("ss_builder_move_to_top_label")
        });
    }
    if (number !== lastList) {
        actions.push({
            key: DigitalProduct_constants/* ACTION_KEY.DOWN_LAST */.pp.DOWN_LAST,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownLastIcon, {}),
            text: t("ss_builder_move_to_bottom_label")
        });
    }
    actions.push({
        key: DigitalProduct_constants/* ACTION_KEY.DELETE */.pp.DELETE,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteForeverIcon, {}),
        text: t("ss_delete_forever")
    });
    var handleClickPopoverItem = function(node) {
        switch(node.key){
            case DigitalProduct_constants/* ACTION_KEY.UP_FIRST */.pp.UP_FIRST:
                handleMove(item1.id, DigitalProduct_constants/* MOVE.UP_FIRST */.tP.UP_FIRST);
                break;
            case DigitalProduct_constants/* ACTION_KEY.DOWN_LAST */.pp.DOWN_LAST:
                handleMove(item1.id, DigitalProduct_constants/* MOVE.DOWN_LAST */.tP.DOWN_LAST);
                break;
            case DigitalProduct_constants/* ACTION_KEY.EDIT */.pp.EDIT:
                handleEditProduct(item1);
                break;
            case DigitalProduct_constants/* ACTION_KEY.DELETE */.pp.DELETE:
                handleClickDeleteForever();
                break;
        }
    };
    var handleClickThreeDot = function() {
        if (popoverActive === item1.id) {
            setPopoverActive(null);
        } else {
            setPopoverActive(item1.id);
        }
    };
    var handleShowIcon = function(item) {
        return ICON_MAP[item] || null;
    };
    var handleClickDelete = function() {
        es/* Modal.confirm */.u_.confirm({
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon, {
                            className: "mx-auto"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-bold text-lg text-center mt-3",
                        children: t("ss_delete_product")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 text-center",
                        children: t("ss_content_confirm_delete")
                    })
                ]
            }),
            confirmText: t("ss_confirm_delete"),
            cancelText: t("ss_cancle_delete"),
            onConfirm: function() {
                handleDelete(item1.id);
            }
        });
    };
    var handleClickDeleteForever = function() {
        setPopoverActive(null);
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://i.ecomobi.com/ssp/builder/digital-product/delete-product.gif"
                })
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ProductItem_style_module_default())["title-modal-delete-forever"]),
                        children: t("ss_delete_forever")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ProductItem_style_module_default())["content-modal-delete-forever"]),
                        children: t("ss_content_delete_forever")
                    })
                ]
            }),
            confirmText: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ProductItem_style_module_default())["button-confirm-delete-forever"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((ProductItem_style_module_default())["text-confirm"]),
                    children: t("ss_modal_text_confirm")
                })
            }),
            cancelText: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ProductItem_style_module_default())["button-cancel-delete-forever"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((ProductItem_style_module_default())["text-cancel"]),
                    children: t("ss_modal_cancel_confirm")
                })
            }),
            closeOnMaskClick: true,
            className: (ProductItem_style_module_default())["container-modal-delete-forever"],
            onConfirm: function() {
                var params = {
                    isSetting: true
                };
                handleChooseIframe(DigitalProduct_constants/* URL_IFRAME.IFRAME */.t2.IFRAME, params);
            }
        });
    };
    var handleEditProduct = function(item) {
        var params = {
            actionCloseIframe: true
        };
        if (item.category.id == type/* CAT_ID.COURSE */.m.COURSE) {
            handleChooseIframe("".concat(DigitalProduct_constants/* URL_IFRAME.COURSE */.t2.COURSE, "/").concat(item.id), params);
        } else if (item.category.id == type/* CAT_ID.PHOTO */.m.PHOTO) {
            handleChooseIframe("".concat(DigitalProduct_constants/* URL_IFRAME.PHOTO */.t2.PHOTO, "/").concat(item.id), params);
        } else if (item.category.id == type/* CAT_ID.TICKET_ACCOUNT */.m.TICKET_ACCOUNT) {
            handleChooseIframe("".concat(DigitalProduct_constants/* URL_IFRAME.TICKET_ACCOUNT */.t2.TICKET_ACCOUNT, "/").concat(item.id), params);
        } else {
            handleChooseIframe("".concat(DigitalProduct_constants/* URL_IFRAME.EDIT */.t2.EDIT, "/").concat(item.id), params);
        }
    };
    (0,react.useEffect)(function() {
        var handleClickOutsidePopover = function(event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                var isDropdownItem = event.target.closest(".adm-popover-menu-item");
                var isThreeDot = event.target.closest(".clickable-area");
                if (!isThreeDot) {
                    if (!isDropdownItem) {
                        setPopoverActive(null);
                    }
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutsidePopover);
        return function() {
            document.removeEventListener("mousedown", handleClickOutsidePopover);
        };
    }, [
        popoverRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between bg-white p-3 items-center rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoveIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                src: ((ref = item1.category) === null || ref === void 0 ? void 0 : ref.id) === type/* CAT_ID.PHOTO */.m.PHOTO ? item1 === null || item1 === void 0 ? void 0 : (ref1 = item1.cover_image) === null || ref1 === void 0 ? void 0 : ref1.url : item1.thumbnail ? item1.thumbnail : (item1 === null || item1 === void 0 ? void 0 : (ref2 = item1.thumbnails) === null || ref2 === void 0 ? void 0 : ref2.length) ? item1 === null || item1 === void 0 ? void 0 : item1.thumbnails[0].url : "",
                                className: "rounded-lg ml-3 w-10 h-10",
                                style: {
                                    backgroundSize: "cover",
                                    aspectRatio: "1/1",
                                    objectFit: "cover",
                                    width: "100%",
                                    maxWidth: "40px"
                                },
                                onError: function(param) {
                                    var currentTarget = param.currentTarget;
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: "vertical",
                                            display: "-webkit-box",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            wordBreak: "break-word"
                                        },
                                        className: "text-base font-normal",
                                        children: (0,lib/* htmlDecode */.l_)(item1.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base pb-1 leading-[100%] font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                        children: item1.price > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red-600 font-medium",
                                            children: "".concat((0,lib/* formatNumberToCurrencyDonation */.Si)(item1.price), " ").concat((0,lib/* formatUnitSymbol */.Pb)(countryCode))
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-green-500 font-medium",
                                            children: t("ss_builder_digital_product_free_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-1 py-[2px] rounded text-[11px] font-[500] whitespace-nowrap w-fit",
                                        style: {
                                            backgroundColor: categoryBackgroundMap[item1.category.id],
                                            color: categoryTextColorMap[item1.category.id]
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-center",
                                            children: [
                                                handleShowIcon(item1.category.id),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-1",
                                                    children: t(categoryNameMap[item1.category.id])
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "popover-content",
                        ref: popoverRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                            mode: "dark",
                            actions: actions,
                            placement: "bottomRight",
                            trigger: "click",
                            stopPropagation: [
                                "click"
                            ],
                            getContainer: function() {
                                return popoverRef.current;
                            },
                            visible: popoverActive === item1.id,
                            onAction: function(node) {
                                return handleClickPopoverItem(node);
                            },
                            destroyOnHide: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer three-dot-svg",
                                onClick: handleClickThreeDot,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDot, {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-3"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/store/digitalProductSlice.ts
var digitalProductSlice = __webpack_require__(60821);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/style.module.scss
var DigitalProduct_style_module = __webpack_require__(70346);
var DigitalProduct_style_module_default = /*#__PURE__*/__webpack_require__.n(DigitalProduct_style_module);
;// CONCATENATED MODULE: ./src/features/block/block-editor/DigitalProduct/index.tsx
function DigitalProduct_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DigitalProduct_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DigitalProduct_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return DigitalProduct_arrayLikeToArray(arr);
}
function DigitalProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DigitalProduct_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DigitalProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DigitalProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DigitalProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DigitalProduct_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function DigitalProduct_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DigitalProduct_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DigitalProduct_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DigitalProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DigitalProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DigitalProduct_slicedToArray(arr, i) {
    return DigitalProduct_arrayWithHoles(arr) || DigitalProduct_iterableToArrayLimit(arr, i) || DigitalProduct_unsupportedIterableToArray(arr, i) || DigitalProduct_nonIterableRest();
}
function DigitalProduct_toConsumableArray(arr) {
    return DigitalProduct_arrayWithoutHoles(arr) || DigitalProduct_iterableToArray(arr) || DigitalProduct_unsupportedIterableToArray(arr) || DigitalProduct_nonIterableSpread();
}
function DigitalProduct_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DigitalProduct_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DigitalProduct_arrayLikeToArray(o, minLen);
}


















var dataSendIframe = [];
var DigitalProduct = function(props) {
    var ref17, ref1, ref2, ref3;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, handleCancelBlock = props.handleCancelBlock;
    var url_Iframe = "https://account.passio.eco/";
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "digital-product-".concat((0,v4/* default */.Z)());
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var dataEditRedux = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.digitalProduct.dataEdit;
    });
    var dataRemoveRedux = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.digitalProduct.dataRemove;
    });
    var ref4 = (0,react.useState)(null), showIntro = ref4[0], setShowIntro = ref4[1];
    var ref5 = (0,react.useState)(false), showPopup = ref5[0], setShowPopup = ref5[1];
    var ref6 = (0,react.useState)(""), urlIframe = ref6[0], setUrlIframe = ref6[1];
    var countryCode = user === null || user === void 0 ? void 0 : (ref17 = user.kol) === null || ref17 === void 0 ? void 0 : ref17.country;
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var defaultValueEditDigitalProduct = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var digitalProductDefault = (0,react.useMemo)(function() {
        return {
            uid: "digital-product-".concat((0,v4/* default */.Z)()),
            sort_order: 1,
            enable: 1,
            block_type: BLOCK_TYPE.DIGITAL_PRODUCT,
            title: t("ss_builder_product_group_default_title"),
            content_attributes: {
                dp_items: [],
                dp_data: []
            },
            style_attributes: {}
        };
    }, []);
    var ref7;
    var digitalProductGroupArrDefault = (ref7 = (defaultValueEditDigitalProduct === null || defaultValueEditDigitalProduct === void 0 ? void 0 : (ref1 = defaultValueEditDigitalProduct.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.dp_data) ? defaultValueEditDigitalProduct === null || defaultValueEditDigitalProduct === void 0 ? void 0 : (ref2 = defaultValueEditDigitalProduct.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.dp_data : defaultValueEditDigitalProduct === null || defaultValueEditDigitalProduct === void 0 ? void 0 : (ref3 = defaultValueEditDigitalProduct.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.dp_items) !== null && ref7 !== void 0 ? ref7 : [];
    var titleBlockDefault = "Digital Product";
    var ref8 = (0,react.useState)([]), digitalProductArr = ref8[0], setDigitalProductArr = ref8[1];
    var ref9 = (0,react.useState)(null), popoverActive = ref9[0], setPopoverActive = ref9[1];
    var ref10 = (0,react.useState)(false), openIframe = ref10[0], setOpenIframe = ref10[1];
    var ref11 = (0,react.useState)(false), loadingIframe = ref11[0], setLoadingIframe = ref11[1];
    var ref12 = (0,react.useState)(false), loading = ref12[0], setLoading = ref12[1];
    var ref13 = (0,react.useState)(false), hasRemove = ref13[0], setHasRemove = ref13[1];
    var ref14 = (0,react.useState)([]), digitalProductDefaultNotItemsDelete = ref14[0], setDigitalProductDefaultNotItemsDelete = ref14[1];
    var fetchDataProductApi = function() {
        var _ref = DigitalProduct_asyncToGenerator(runtime_default().mark(function _callee(listID) {
            var params, res, sortResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = listID ? {
                            ids: listID.join(",")
                        } : {
                            status: 1
                        };
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return DigitalProduct_api/* default.listProduct */.Z.listProduct(params);
                    case 5:
                        res = _ctx.sent;
                        if (!res.success) {
                            _ctx.next = 10;
                            break;
                        }
                        sortResponse = listID ? listID.map(function(id) {
                            return res.data.find(function(item) {
                                return item.id === id;
                            });
                        }).filter(Boolean) : res.data;
                        setDigitalProductArr(sortResponse);
                        return _ctx.abrupt("return", res.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 15:
                        _ctx.prev = 15;
                        setLoading(false);
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    15,
                    18
                ]
            ]);
        }));
        return function fetchDataProductApi(listID) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchProduct = function() {
        var _ref = DigitalProduct_asyncToGenerator(runtime_default().mark(function _callee(dataFetch) {
            var ref, ref15, ref16;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!dataFetch) {
                            _ctx.next = 4;
                            break;
                        }
                        fetchDataProductApi(dataFetch);
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(block.content_attributes === undefined)) {
                            _ctx.next = 7;
                            break;
                        }
                        setDigitalProductArr([]);
                        return _ctx.abrupt("return");
                    case 7:
                        if (!(Object.keys(block.content_attributes).length === 0)) {
                            _ctx.next = 10;
                            break;
                        }
                        fetchDataProductApi();
                        return _ctx.abrupt("return");
                    case 10:
                        if (!(((ref = block.content_attributes) === null || ref === void 0 ? void 0 : ref.items) && ((ref15 = block.content_attributes) === null || ref15 === void 0 ? void 0 : ref15.items.length) === 0)) {
                            _ctx.next = 13;
                            break;
                        }
                        fetchDataProductApi();
                        return _ctx.abrupt("return");
                    case 13:
                        if ((ref16 = block.content_attributes) === null || ref16 === void 0 ? void 0 : ref16.dp_items.length) {
                            _ctx.next = 16;
                            break;
                        }
                        setDigitalProductArr([]);
                        return _ctx.abrupt("return");
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchProduct(dataFetch) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkOnlyIdInside = function(array) {
        if (array) {
            return array.every(function(element) {
                return typeof element === "number";
            });
        } else {
            return false;
        }
    };
    var isEditDataStatus = (0,react.useMemo)(function() {
        var ref, ref18;
        if (typeof digitalProductGroupArrDefault !== "object" && JSON.stringify(digitalProductArr.filter(Boolean).map(function(item) {
            return item.id;
        })) === JSON.stringify(digitalProductDefaultNotItemsDelete)) {
            return false;
        }
        if (showIntro) {
            return false;
        } else if ((((ref = digitalProductGroupArrDefault.content_attributes) === null || ref === void 0 ? void 0 : ref.dp_data.length) === 0 || ((ref18 = digitalProductGroupArrDefault.content_attributes) === null || ref18 === void 0 ? void 0 : ref18.dp_items.length) === 0) && digitalProductArr.filter(Boolean).length === 0) {
            return false;
        } else if (JSON.stringify(digitalProductArr.filter(Boolean).map(function(item) {
            return item.id;
        })) !== (checkOnlyIdInside(digitalProductGroupArrDefault) ? JSON.stringify(digitalProductGroupArrDefault) : JSON.stringify(digitalProductGroupArrDefault.map(function(item) {
            return item.id;
        })))) {
            return true;
        } else return false;
    }, [
        digitalProductArr,
        digitalProductGroupArrDefault,
        showIntro
    ]);
    (0,react.useEffect)(function() {
        if (typeof digitalProductGroupArrDefault !== "object" && digitalProductArr.length > 0) {
            var filterArrDefault = digitalProductGroupArrDefault.map(function(id) {
                return digitalProductArr.find(function(item) {
                    return item.id === id;
                });
            });
            setDigitalProductDefaultNotItemsDelete(filterArrDefault.filter(Boolean));
        }
    }, [
        digitalProductArr
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(false);
    }, []);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("message", handleMessage, false);
        return function() {
            return window.removeEventListener("message", handleMessage);
        };
    }, [
        dataEditRedux,
        dataRemoveRedux,
        block
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultDigitalProductData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.DIGITAL_PRODUCT,
                title: titleBlockDefault,
                content_attributes: {
                    dp_items: [],
                    dp_data: []
                },
                style_attributes: {}
            };
            onUpdateData(defaultDigitalProductData);
        } else {
            onUpdateData(DigitalProduct_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    dp_items: digitalProductArr.filter(Boolean).map(function(item) {
                        return item.id;
                    }),
                    dp_data: digitalProductArr,
                    hasInit: true,
                    hasRemove: hasRemove,
                    use_extra_function: hasRemove
                },
                style_attributes: {}
            }));
        }
    }, [
        digitalProductArr
    ]);
    var handleMessage = function(event) {
        switch(event.data.key){
            case DigitalProduct_constants/* IFRAME_ACTION.CLOSE_IFRAME */.Jf.CLOSE_IFRAME:
                // props.handleCancelBlock()
                handleCloseIframe(event.data);
                break;
            case DigitalProduct_constants/* IFRAME_ACTION.GET_DATA */.Jf.GET_DATA:
                handleLoadingSuccess();
                break;
            case DigitalProduct_constants/* IFRAME_ACTION.RECIVED_DATA */.Jf.RECIVED_DATA:
                handleRecivedMessage(event.data.data);
                break;
            case DigitalProduct_constants/* IFRAME_ACTION.SAVE_INTRO */.Jf.SAVE_INTRO:
                handleSetUp();
                break;
        }
    };
    var handleCloseIframe = function(dataIframeClose) {
        var ref, ref19, ref20;
        setOpenIframe(false);
        setLoadingIframe(false);
        if (dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref = dataIframeClose.data) === null || ref === void 0 ? void 0 : ref.isIntro) {
            props.handleCancelBlock();
        }
        if ((dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref19 = dataIframeClose.data) === null || ref19 === void 0 ? void 0 : ref19.dataRemove.length) > 0 || (dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref20 = dataIframeClose.data) === null || ref20 === void 0 ? void 0 : ref20.dataEdit.length) > 0) {
            var ref21, ref22, ref23, ref24, ref25, ref26;
            setHasRemove(true);
            var dataRemove = dataRemoveRedux ? DigitalProduct_toConsumableArray(dataRemoveRedux) : [];
            var dataEdit = dataEditRedux ? DigitalProduct_toConsumableArray(dataEditRedux) : [];
            dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref21 = dataIframeClose.data) === null || ref21 === void 0 ? void 0 : ref21.dataEdit.forEach(function(item, index) {
                var findItem = dataEdit.findIndex(function(x) {
                    return x.id === item.id;
                });
                if (findItem !== -1) {
                    dataEdit[findItem] = item;
                } else {
                    dataEdit.push(item);
                }
            });
            if (dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref22 = dataIframeClose.data) === null || ref22 === void 0 ? void 0 : ref22.dataEdit) {
                dispatch(digitalProductSlice/* digitalProductAction.setDataEdit */.t.setDataEdit(DigitalProduct_toConsumableArray(dataEdit)));
            }
            dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref23 = dataIframeClose.data) === null || ref23 === void 0 ? void 0 : ref23.dataRemove.forEach(function(item, index) {
                var findItem = dataRemove.findIndex(function(x) {
                    return x === item;
                });
                if (findItem === -1) {
                    dataRemove.push(item);
                }
            });
            if (dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref24 = dataIframeClose.data) === null || ref24 === void 0 ? void 0 : ref24.dataRemove) {
                dispatch(digitalProductSlice/* digitalProductAction.setDataRemove */.t.setDataRemove(DigitalProduct_toConsumableArray(dataRemove)));
            }
            var newData = [];
            (ref25 = block.content_attributes) === null || ref25 === void 0 ? void 0 : ref25.dp_data.forEach(function(item) {
                var newItem = Object.assign({}, item);
                var editIndex = dataEdit.findIndex(function(edit) {
                    return edit.id === item.id;
                });
                if (editIndex !== -1) {
                    Object.assign(newItem, dataEdit[editIndex]);
                }
                var removeIndex = dataRemove.findIndex(function(removeId) {
                    return removeId === item.id;
                });
                if (removeIndex === -1) {
                    newData.push(newItem);
                }
            });
            if (dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref26 = dataIframeClose.data) === null || ref26 === void 0 ? void 0 : ref26.dataNew) {
                var ref27;
                var dataNew = dataIframeClose === null || dataIframeClose === void 0 ? void 0 : (ref27 = dataIframeClose.data) === null || ref27 === void 0 ? void 0 : ref27.dataNew;
                var checkDuplicate = newData.find(function(x) {
                    return x.id === dataNew.id;
                });
                if (!checkDuplicate) {
                    var ref28, ref29;
                    var dataConvert = {
                        currency: dataNew.currency,
                        id: dataNew.id,
                        category: {
                            id: (ref28 = dataNew.category) === null || ref28 === void 0 ? void 0 : ref28.id
                        },
                        ordinal_number_lucky_card: dataNew.ordinal_number_lucky_card,
                        original_price: dataNew.original_price,
                        price: dataNew.price,
                        name: dataNew.name,
                        product_type: dataNew.product_type,
                        thumbnail: ((ref29 = dataNew.thumbnails) === null || ref29 === void 0 ? void 0 : ref29.length) > 0 ? dataNew.thumbnails[0].url_small : null,
                        cover_image: (dataNew === null || dataNew === void 0 ? void 0 : dataNew.cover_image) ? dataNew === null || dataNew === void 0 ? void 0 : dataNew.cover_image : null
                    };
                    newData.push(dataConvert);
                }
            }
            onUpdateData(DigitalProduct_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    dp_data: newData,
                    hasInit: true,
                    hasRemove: hasRemove,
                    use_extra_function: hasRemove
                },
                style_attributes: {}
            }));
            setDigitalProductArr(newData);
        }
    };
    var handleRecivedMessage = function(dataIframe) {
        if (dataIframe === null || dataIframe === void 0 ? void 0 : dataIframe.isChange) {
            setHasRemove(true);
            onUpdateData(DigitalProduct_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    hasRemove: true,
                    use_extra_function: true
                },
                style_attributes: {}
            }));
        }
        setDigitalProductArr(dataIframe.dataEdit);
        if (!(dataIframe === null || dataIframe === void 0 ? void 0 : dataIframe.noCloseIframe)) {
            setOpenIframe(false);
        }
        if (dataIframe === null || dataIframe === void 0 ? void 0 : dataIframe.closeLoadingIframe) {
            setLoadingIframe(false);
        }
    };
    var reorder = function(list, startIndex, endIndex) {
        var result = Array.from(list);
        var ref = DigitalProduct_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var handleOnDragEnd = function(result) {
        if (!result.destination) return;
        var newList = reorder(digitalProductArr, result.source.index, result.destination.index);
        setDigitalProductArr(DigitalProduct_toConsumableArray(newList));
    };
    var handleMove = function(id, move) {
        var result = Array.from(digitalProductArr.filter(Boolean));
        var findIndex = result.findIndex(function(item) {
            return item.id === id;
        });
        var ref = DigitalProduct_slicedToArray(result.splice(findIndex, 1), 1), removed = ref[0];
        if (move === DigitalProduct_constants/* MOVE.UP_FIRST */.tP.UP_FIRST) {
            result.splice(0, 0, removed);
        } else {
            result.splice(result.length, 0, removed);
        }
        setPopoverActive(null);
        setDigitalProductArr(DigitalProduct_toConsumableArray(result));
    };
    var handleDelete = function(id) {
        var result = Array.from(digitalProductArr.filter(Boolean));
        var findIndex = result.findIndex(function(item) {
            return item.id === id;
        });
        result.splice(findIndex, 1);
        setDigitalProductArr(DigitalProduct_toConsumableArray(result));
    };
    var handleOpenIframeLoading = function() {
        dataSendIframe = digitalProductArr.filter(Boolean);
        setShowPopup(false);
        setOpenIframe(true);
        setLoadingIframe(true);
        setPopoverActive(null);
    };
    var handleChooseIframe = function(url) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (params) {
            var paramsString = new URLSearchParams(params).toString();
            setUrlIframe(url + "?isIframe=true&" + paramsString);
        } else {
            setUrlIframe(url + "?isIframe=true");
        }
        handleOpenIframeLoading();
    };
    var handleLoadingSuccess = function() {
        var iframe = document.getElementById("select-list-iframe");
        if (!iframe) {
            return;
        }
        iframe.contentWindow.postMessage({
            "key": DigitalProduct_constants/* IFRAME_ACTION.LIST_DATA */.Jf.LIST_DATA,
            "data": dataSendIframe
        }, "*");
        setLoadingIframe(false);
    };
    (0,react.useEffect)(function() {
        var ref, ref30, ref31, ref32;
        var itemData = ((ref = block.content_attributes) === null || ref === void 0 ? void 0 : (ref30 = ref.dp_data) === null || ref30 === void 0 ? void 0 : ref30.length) > 0 ? block.content_attributes.dp_data : null;
        var itemID = ((ref31 = block.content_attributes) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.dp_items) === null || ref32 === void 0 ? void 0 : ref32.length) > 0 ? block.content_attributes.dp_items : null;
        if (itemData) {
            setDigitalProductArr(itemData);
        } else {
            fetchProduct(itemID);
        }
    }, []);
    var checkHasIntro = function() {
        var _ref = DigitalProduct_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, dataRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,block_api/* checkIntroDigitalProduct */.E2)();
                    case 3:
                        res = _ctx.sent;
                        dataRes = res.data;
                        if (!dataRes.success) {
                            _ctx.next = 8;
                            break;
                        }
                        setShowIntro(!dataRes.has_intro_dp);
                        return _ctx.abrupt("return");
                    case 8:
                        _ctx.next = 12;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                    case 12:
                        setShowIntro(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function checkHasIntro() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkHasIntro();
    }, []);
    var handleSetUp = function() {
        var _ref = DigitalProduct_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,block_api/* saveIntroDigitalProduct */.cN)();
                    case 3:
                        setShowIntro(false);
                        _ctx.next = 8;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function handleSetUp() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showIntro === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (showIntro) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full fixed min-h-screen top-0 left-0",
            style: {
                zIndex: 999999
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "".concat(url_Iframe, "kol/digital-product/intro?isIframe=true"),
                className: "min-h-screen w-full"
            })
        });
    }
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center min-w-full min-h-screen absolute top-0 bottom-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("ss_builder_loading_label")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popup */.GI, {
                visible: showPopup,
                bodyClassName: "adm-popup-body-position-bottom-panel",
                bodyStyle: {
                    backgroundColor: "none"
                },
                onClose: function() {
                    return setShowPopup(false);
                },
                closeOnMaskClick: true,
                destroyOnClose: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-[#fff] max-width-content-layout m-auto relative h-full max-h-[80vh]",
                    style: {
                        borderRadius: "8px 8px 0px 0px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "popup-header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title ".concat((DigitalProduct_style_module_default())["title-header-popup"]),
                                children: t("ss_iframe_add_product")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "popup-body overflow-y-auto border-t-[1px] border-b-[1px] border-[#EEEEEE]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* List */.aV, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                                            onClick: function() {
                                                return handleChooseIframe(DigitalProduct_constants/* URL_IFRAME.SELECT_CATEGORY */.t2.SELECT_CATEGORY, {
                                                    closeIframe: true,
                                                    actionCloseIframe: true
                                                });
                                            },
                                            clickable: false,
                                            className: "cursor-pointer ".concat((DigitalProduct_style_module_default())["list-item-popup"]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddProductPlusIcon, {
                                                        className: "mr-3"
                                                    }),
                                                    " ",
                                                    t("ss_iframe_add_new_product")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                                            onClick: function() {
                                                return handleChooseIframe(DigitalProduct_constants/* URL_IFRAME.IFRAME */.t2.IFRAME);
                                            },
                                            clickable: false,
                                            className: "cursor-pointer ".concat((DigitalProduct_style_module_default())["list-item-popup"]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseDataStoreIcon, {
                                                        className: "mr-3"
                                                    }),
                                                    t("ss_iframe_choose_product_from_store")
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            loadingIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center min-w-full min-h-screen absolute top-0 bottom-0",
                style: {
                    zIndex: 9999,
                    backgroundColor: "rgba(0, 0, 0, 0.5)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                    className: "text-white"
                })
            }),
            openIframe && !loadingIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center min-w-full min-h-screen absolute top-0 bottom-0",
                style: {
                    zIndex: 99999,
                    backgroundColor: "#FFF"
                }
            }),
            openIframe && urlIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full fixed min-h-screen top-0 left-0",
                style: {
                    zIndex: 999999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    id: "select-list-iframe",
                    src: "".concat(url_Iframe, "kol/digital-product/").concat(urlIframe),
                    className: "min-h-screen w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " py-[13px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-[17px] font-normal text-[#666666] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredIcon, {}),
                                        " ",
                                        t("ss_builder_list_title_digital_product")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "text-white bg-[#EE3244] text-[15px] px-3 py-[3px] rounded-[4px] mr-3 flex items-center",
                                    onClick: function() {
                                        return setShowPopup(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {})
                                        }),
                                        " ",
                                        t("ss_dp_add")
                                    ]
                                })
                            ]
                        }),
                        digitalProductArr && (digitalProductArr === null || digitalProductArr === void 0 ? void 0 : digitalProductArr.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-3 px-3 mt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                                    onDragEnd: handleOnDragEnd,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                        droppableId: "droppable",
                                        children: function(droppableProvided) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                ref: droppableProvided.innerRef,
                                                children: [
                                                    digitalProductArr.filter(Boolean).map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                            draggableId: item.id.toString(),
                                                            index: index,
                                                            children: function(provided, snapshot) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", DigitalProduct_objectSpread({
                                                                    ref: provided.innerRef
                                                                }, provided.draggableProps, provided.dragHandleProps, {
                                                                    style: DigitalProduct_objectSpread({}, provided.draggableProps.style, {
                                                                        opacity: snapshot.isDragging ? 0.8 : 1
                                                                    }),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                                                        item: item,
                                                                        countryCode: countryCode,
                                                                        handleMove: handleMove,
                                                                        handleDelete: handleDelete,
                                                                        popoverActive: popoverActive,
                                                                        setPopoverActive: setPopoverActive,
                                                                        number: index,
                                                                        lastList: digitalProductArr.filter(Boolean).length - 1,
                                                                        handleChooseIframe: handleChooseIframe
                                                                    })
                                                                }));
                                                            }
                                                        }, item.id);
                                                    }),
                                                    droppableProvided.placeholder
                                                ]
                                            });
                                        }
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-center items-center justify-center mt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                        src: "https://i.ecomobi.com/ssp/passio-page/empty_digital_product.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#333333] text-lg leading-6 pb-[2px]",
                                    children: t("ss_builder_affiliate_product_list_empty_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#8C8C8C] text-xs leading-4",
                                    children: t("ss_builder_affiliate_product_list_empty_content")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_DigitalProduct = (DigitalProduct);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Embed/index.tsx
function Embed_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Embed_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Embed_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Embed_BLOCK_HEADING_MAXIMUM = 50;
var Embed_BLOCK_DESCRIPTION_MAXIMUM = 250;
var Embed = function(props) {
    var ref11, ref1, ref2;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "emabed-".concat((0,v4/* default */.Z)());
    // const dispatch = useAppDispatch();
    // const edittingBlock = useAppSelector((state) => state.edittingBlock);
    // const KEY = edittingBlock && edittingBlock.KEY;
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    // const tabUid = edittingBlock && edittingBlock.tab_uid;
    // const positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEditEmbed = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : defaultBlockData.uid) ? defaultBlockData : null;
    var titleBlockDefault = "Embed";
    var valueHeadingBlockDefault = (defaultValueEditEmbed === null || defaultValueEditEmbed === void 0 ? void 0 : (ref11 = defaultValueEditEmbed.content_attributes) === null || ref11 === void 0 ? void 0 : ref11.block_heading) || "";
    var valueDescriptionBlockDefault = (defaultValueEditEmbed === null || defaultValueEditEmbed === void 0 ? void 0 : (ref1 = defaultValueEditEmbed.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.block_description) || "";
    var valueEmbedCodeDefault = (defaultValueEditEmbed === null || defaultValueEditEmbed === void 0 ? void 0 : (ref2 = defaultValueEditEmbed.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.embed_code) || "";
    var ref3 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref3[0], setValueHeadingBlock = ref3[1];
    var ref4 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref4[0], setValueDescriptionBlock = ref4[1];
    var ref5 = (0,react.useState)(valueEmbedCodeDefault), valueEmbedCode = ref5[0], setValueEmbedCode = ref5[1];
    var ref6 = (0,react.useState)(null), embedCodeValid = ref6[0], setEmbedCodeValid = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenEditTitleImageBlock = ref7[0], setIsOpenEditTitleImageBlock = ref7[1];
    var ref8;
    var ref9 = (0,react.useState)((ref8 = block === null || block === void 0 ? void 0 : block.enable) !== null && ref8 !== void 0 ? ref8 : configs_const/* ENABLE_BLOCK */.C5), isEnable = ref9[0], setIsEnable = ref9[1];
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var ref;
            var defaultEmbedData = {
                uid: UID,
                sort_order: 1,
                enable: configs_const/* ENABLE_BLOCK */.C5,
                block_type: BLOCK_TYPE.EMBED,
                title: titleBlockDefault,
                content_attributes: {
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    embed_code: (ref = transformEmbedContent(valueEmbedCode)) === null || ref === void 0 ? void 0 : ref.trim()
                },
                style_attributes: {}
            };
            onUpdateData(defaultEmbedData);
        } else {
            var ref10;
            onUpdateData(Embed_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    embed_code: (ref10 = transformEmbedContent(valueEmbedCode)) === null || ref10 === void 0 ? void 0 : ref10.trim()
                },
                style_attributes: {}
            }));
        }
    }, [
        valueHeadingBlock,
        valueDescriptionBlock,
        valueEmbedCode
    ]);
    var handleClickEditIcon = function() {
        setIsOpenEditTitleImageBlock(true);
    };
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Embed_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Embed_BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var transformEmbedContent = function(embedString) {
        var listAttrs = (0,validator/* extractAttrFromString */.as)(embedString);
        var titleAttr = listAttrs && listAttrs.find(function(e) {
            return e[0] === "title";
        });
        var titleValueClean = titleAttr && titleAttr.length > 1 && titleAttr[1].replaceAll(">", "&gt;").replaceAll("<", "&lt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");
        var newEmbedString = embedString.replace(/(?:title=(.+?)"+)/, 'title="'.concat(titleValueClean, '"'));
        return newEmbedString;
    };
    var handleChangeEmbedCode = function(embed) {
        setValueEmbedCode(embed);
        setEmbedCodeValid(!(0,validator/* checkDirtyCodeIframe */.iO)(embed));
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (valueEmbedCode && (valueEmbedCode !== valueEmbedCodeDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault) && !embedCodeValid) {
            return false;
        } else return true;
    }, [
        titleBlockDefault,
        valueEmbedCode,
        valueEmbedCodeDefault,
        valueHeadingBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlock,
        valueDescriptionBlockDefault,
        embedCodeValid, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (valueEmbedCode !== valueEmbedCodeDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault) {
            return true;
        } else return false;
    }, [
        valueEmbedCode,
        valueEmbedCodeDefault,
        valueHeadingBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlock,
        valueDescriptionBlockDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var handeSetEnableBlock = function() {
        setIsEnable(isEnable === configs_const/* ENABLE_BLOCK */.C5 ? configs_const/* DISABLE_BLOCK */.gK : configs_const/* ENABLE_BLOCK */.C5);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_heading_placeholder"),
                                onChange: handleChangeBlockHeading,
                                value: valueHeadingBlock,
                                maxLength: Embed_BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(Embed_BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: Embed_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(Embed_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-600",
                        children: "*"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[15px] leading-[13px] text-[#666666]",
                        children: t("ss_builder_embed_code_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                        placeholder: t("ss_builder_embed_code_placeholder"),
                        onChange: handleChangeEmbedCode,
                        value: valueEmbedCode,
                        rows: 8
                    }),
                    embedCodeValid && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] text-[#FF3141]",
                        children: t("ss_builder_malformed_embed_code_warning")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var block_editor_Embed = (Embed);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Gift/index.tsx
function Gift_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Gift_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Gift_arrayLikeToArray(arr);
}
function Gift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Gift_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Gift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Gift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Gift_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Gift_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Gift_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Gift_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Gift_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Gift_toConsumableArray(arr) {
    return Gift_arrayWithoutHoles(arr) || Gift_iterableToArray(arr) || Gift_unsupportedIterableToArray(arr) || Gift_nonIterableSpread();
}
function Gift_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Gift_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gift_arrayLikeToArray(o, minLen);
}











var GiftComponent = function(props) {
    var ref5, ref1;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, handleCancelBlock = props.handleCancelBlock;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "virtual-gift-".concat((0,v4/* default */.Z)());
    var count = (0,react.useRef)(1);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId = user === null || user === void 0 ? void 0 : (ref5 = user.kol) === null || ref5 === void 0 ? void 0 : ref5._id;
    var countryCode = user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var KEY = edittingBlock && edittingBlock.KEY;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEditGift = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var titleBlockDefault = "Virtual Gift";
    var ref2 = (0,react.useState)([]), virtualGiftArr = ref2[0], setVirtualGiftArr = ref2[1];
    var ref3 = (0,react.useState)(true), hasMoreIcon = ref3[0], setHasMoreIcon = ref3[1];
    (0,react.useEffect)(function() {
        loadMoreIcon();
    }, []);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultGiftData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.GIFT,
                title: titleBlockDefault,
                content_attributes: {
                },
                style_attributes: {}
            };
            onUpdateData(defaultGiftData);
        } else {
            onUpdateData(Gift_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                },
                style_attributes: {}
            }));
        }
    }, []);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (KEY === "add-new-block" && virtualGiftArr.length > 0) {
            return false;
        } else return true;
    }, [
        virtualGiftArr,
        KEY
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    var InfiniteScrollContent = function(param) {
        var hasMore = param.hasMore;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("ss_builder_loading_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {})
                ]
            }) : null
        });
    };
    function loadMoreIcon() {
        return _loadMoreIcon.apply(this, arguments);
    }
    function _loadMoreIcon() {
        _loadMoreIcon = Gift_asyncToGenerator(runtime_default().mark(function _callee() {
            var response, data, ref, ref4, virtualGiftData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(count.current !== 1)) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,sleep/* sleep */._)(1000);
                    case 3:
                        response = null;
                        data = {
                            page: count.current,
                            per_page: 10,
                            country_code: countryCode,
                            user_id: userId
                        };
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,api/* requestGetListVirtualGift */.ik)(data);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 14:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            ;
                            virtualGiftData = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref4 = ref.data) === null || ref4 === void 0 ? void 0 : ref4.items.map(function(item) {
                                return {
                                    id: item.id,
                                    name: item.name,
                                    description: item.description,
                                    image_url: (item === null || item === void 0 ? void 0 : item.thumbnails[0]) ? item === null || item === void 0 ? void 0 : item.thumbnails[0].url : ""
                                };
                            });
                            setVirtualGiftArr(function(value) {
                                return Gift_toConsumableArray(value).concat(Gift_toConsumableArray(virtualGiftData));
                            });
                            if (Array.isArray(virtualGiftData) && virtualGiftData.length === 0) {
                                setHasMoreIcon(false);
                            }
                        }
                        count.current = count.current + 1;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return _loadMoreIcon.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " px-4 py-[13px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] text-[#666666]",
                    children: t("ss_builder_virtual_gift_list_title")
                }),
                virtualGiftArr && virtualGiftArr.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        virtualGiftArr.map(function(ele, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                                src: ele.image_url,
                                                width: 40,
                                                height: 40,
                                                fit: "cover"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                                        children: ele.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-xs leading-4 font-normal text-[#8C8C8C] text-ellipsis whitespace-nowrap overflow-hidden",
                                                        children: ele.description
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, ele.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* InfiniteScroll */.v_, {
                            loadMore: loadMoreIcon,
                            hasMore: hasMoreIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                                hasMore: hasMoreIcon
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InboxIcon */.xx, {
                                className: "align-middle"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#333333] text-lg leading-6",
                            children: t("ss_builder_affiliate_product_list_empty_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#8C8C8C] text-xs leading-4",
                            children: t("ss_builder_affiliate_product_list_empty_content")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Gift = (GiftComponent);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Image/index.tsx
function Image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Image_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Image_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Image_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Image_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var Image_BLOCK_HEADING_MAXIMUM = 50;
var Image_BLOCK_DESCRIPTION_MAXIMUM = 250;
var ImageComponent = function(props) {
    var ref33, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, setButtonLoading = props.setButtonLoading, handleCancelBlock = props.handleCancelBlock, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "image-gallery-".concat((0,v4/* default */.Z)());
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    // const edittingBlock = useAppSelector((state) => state.edittingBlock);
    // const KEY = edittingBlock && edittingBlock.KEY;
    // const edittingBlockData =
    //   block ?? (edittingBlock && edittingBlock.block_data);
    // const tabUid = edittingBlock && edittingBlock.tab_uid;
    // const positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEditImage = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = "Image";
    var imageUrlDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref33 = defaultValueEditImage.content_attributes) === null || ref33 === void 0 ? void 0 : ref33.image) || "";
    var valueHeadingBlockDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref1 = defaultValueEditImage.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.block_heading) || "";
    var valueDescriptionBlockDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref2 = defaultValueEditImage.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_description) || "";
    var originUrlDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref3 = defaultValueEditImage.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.origin_url) || "";
    var affiliateUrlDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref4 = defaultValueEditImage.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.target_url) || "";
    var imageOrientationDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref5 = defaultValueEditImage.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.image_orientation) || configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE;
    var ratioDefault = (0,react.useMemo)(function() {
        var ref;
        var valueRatio = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref = defaultValueEditImage.style_attributes) === null || ref === void 0 ? void 0 : ref.ratio) || "16/9";
        if (imageOrientationDefault === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        defaultValueEditImage,
        imageOrientationDefault
    ]);
    var hasAffiliateUrlDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref6 = defaultValueEditImage.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.use_aff_url) ? !!((defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref7 = defaultValueEditImage.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.use_aff_url) === 1) : true;
    var defaultLinkData = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref8 = defaultValueEditImage.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: originUrlDefault
    };
    var openInNewTabDefault = (defaultValueEditImage === null || defaultValueEditImage === void 0 ? void 0 : (ref9 = defaultValueEditImage.content_attributes) === null || ref9 === void 0 ? void 0 : ref9.open_new_tab) || false;
    var ref10 = (0,react.useState)(defaultLinkData), linkData1 = ref10[0], setLinkData = ref10[1];
    var ref11 = (0,react.useState)(ratioDefault), imageRatio = ref11[0], setImageRatio = ref11[1];
    var ref12 = (0,react.useState)(imageUrlDefault), valueUrlImage = ref12[0], setValueUrlImage = ref12[1];
    var ref13 = (0,react.useState)(""), valueNameImage = ref13[0], setValueNameImage = ref13[1];
    var ref14 = (0,react.useState)(null), valueImageBase64 = ref14[0], setValueImageBase64 = ref14[1];
    var ref15 = (0,react.useState)([]), uploadedImageArr = ref15[0], setUploadedImageArr = ref15[1];
    var ref16 = (0,react.useState)(originUrlDefault), originUrl = ref16[0], setOriginUrl = ref16[1];
    var ref17 = (0,react.useState)(affiliateUrlDefault), affiliateUrl = ref17[0], setAffiliateUrl = ref17[1];
    var ref18 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref18[0], setHasAffiliateUrl = ref18[1];
    var ref19 = (0,react.useState)(false), isValidUrl = ref19[0], setIsValidUrl = ref19[1];
    var ref20 = (0,react.useState)(false), isLoadingBtn = ref20[0], setIsLoadingBtn = ref20[1];
    var ref21 = (0,react.useState)(null), errorCode1 = ref21[0], setErrorCode = ref21[1];
    var ref22 = (0,react.useState)(null), warningCode1 = ref22[0], setWarningCode = ref22[1];
    var ref23 = (0,react.useState)(false), isCheckDisableBtnSave = ref23[0], setIsCheckDisableBtnSave = ref23[1];
    var ref24 = (0,react.useState)(false), isValidFileFormat = ref24[0], setIsValidFileFormat = ref24[1];
    var ref25 = (0,react.useState)(false), isValidFileSize = ref25[0], setIsValidFileSize = ref25[1];
    var ref26 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref26[0], setValueHeadingBlock = ref26[1];
    var ref27 = (0,react.useState)(imageOrientationDefault), imageOrientation1 = ref27[0], setImageOrientation = ref27[1];
    var ref28 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref28[0], setValueDescriptionBlock = ref28[1];
    var ref29;
    var ref30 = (0,react.useState)((ref29 = block === null || block === void 0 ? void 0 : block.enable) !== null && ref29 !== void 0 ? ref29 : configs_const/* ENABLE_BLOCK */.C5), isEnable = ref30[0], setIsEnable = ref30[1];
    var ref31 = (0,react.useState)(false), isEcommerce = ref31[0], setIsEcommerce = ref31[1];
    var ref32 = (0,react.useState)(openInNewTabDefault), openNewTab = ref32[0], setOpenNewTab = ref32[1];
    var imageRatioDetection = (0,react.useMemo)(function() {
        var valueRatio = imageRatio;
        if (imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        imageOrientation1,
        imageRatio
    ]);
    var checkEcommerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcommerce(linkData1.target_url);
        } else if (originUrl) checkEcommerce(originUrl);
    }, [
        originUrl,
        linkData1
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultImageData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.IMAGE,
                title: titleBlockDefault,
                content_attributes: {
                    image: valueImageBase64 || valueUrlImage,
                    image_base64: valueImageBase64,
                    image_name: valueNameImage,
                    use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                    target_url: affiliateUrl,
                    origin_url: originUrl,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    open_new_tab: isEcommerce || linkData1.type !== LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? true : openNewTab,
                    is_ecommerce: isEcommerce,
                    link_data: linkData1
                },
                style_attributes: {
                    ratio: imageRatioDetection,
                    image_orientation: imageOrientation1
                }
            };
            onUpdateData(defaultImageData);
        } else {
            onUpdateData(Image_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    image: valueImageBase64 || valueUrlImage,
                    image_base64: valueImageBase64,
                    image_name: valueNameImage,
                    use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                    target_url: affiliateUrl,
                    origin_url: originUrl,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    link_data: linkData1,
                    open_new_tab: isEcommerce || linkData1.type !== LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? true : openNewTab,
                    is_ecommerce: isEcommerce
                },
                style_attributes: {
                    ratio: imageRatioDetection,
                    image_orientation: imageOrientation1
                }
            }));
        }
    }, [
        valueUrlImage,
        imageRatioDetection,
        valueImageBase64,
        valueNameImage,
        hasAffiliateUrl,
        affiliateUrl,
        originUrl,
        imageOrientation1,
        valueHeadingBlock,
        valueDescriptionBlock,
        openNewTab,
        linkData1,
        isEcommerce, 
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (valueUrlImage && (valueUrlImage !== imageUrlDefault || imageRatio !== ratioDefault || originUrl !== originUrlDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation1 !== imageOrientationDefault || openNewTab !== openInNewTabDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault) && !isValidUrl && !isCheckDisableBtnSave) {
            return false;
        } else return true;
    }, [
        imageRatio,
        ratioDefault,
        originUrl,
        originUrlDefault,
        valueUrlImage,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        imageUrlDefault,
        isValidUrl,
        isCheckDisableBtnSave,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation1,
        imageOrientationDefault,
        openNewTab,
        openInNewTabDefault,
        linkData1.value, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (imageRatio !== ratioDefault || originUrl !== originUrlDefault || valueUrlImage !== imageUrlDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation1 !== imageOrientationDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || !isEqual_default()(linkData1, defaultLinkData) || openNewTab !== openInNewTabDefault) {
            return true;
        } else return false;
    }, [
        imageRatio,
        ratioDefault,
        originUrl,
        originUrlDefault,
        valueUrlImage,
        imageUrlDefault,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation1,
        imageOrientationDefault,
        openNewTab,
        openInNewTabDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        setButtonLoading(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var imageOptions = [
        {
            label: "1:1",
            value: "1/1"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "4:3" : "3:4",
            value: "4/3"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:2" : "2:3",
            value: "3/2"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "16:9" : "9:16",
            value: "16/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "21:9" : "9:21",
            value: "21/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:1" : "1:3",
            value: "3/1"
        }, 
    ];
    var imageOrientationOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/landscape.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_landscape_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/portrait.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_portrait_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT
        }, 
    ];
    var handleSelectImageRatio = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            setImageRatio(valueRatio);
        }
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleDeleteImage = function() {
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                setValueUrlImage(null);
                setUploadedImageArr([]);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var validateOriginUrl = function(data) {
        if (data) {
            var validateUrl = function() {
                var _ref = Image_asyncToGenerator(runtime_default().mark(function _callee() {
                    var response, ref, isSuccess, ref34, ref35, ref36, ref37, isAccepted, targetUrl, ref38, ref39, warningCode, ref40, errorCode;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = null;
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return (0,api/* requestValidateUrl */.nN)(data);
                            case 4:
                                response = _ctx.sent;
                                _ctx.next = 10;
                                break;
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](1);
                                console.log(_ctx.t0);
                            case 10:
                                if (response) {
                                    ;
                                    setIsLoadingBtn(false);
                                    setIsCheckDisableBtnSave(false);
                                    isSuccess = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success;
                                    if (isSuccess) {
                                        ;
                                        isAccepted = response === null || response === void 0 ? void 0 : (ref34 = response.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : ref35.accepted;
                                        targetUrl = response === null || response === void 0 ? void 0 : (ref36 = response.data) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.data) === null || ref37 === void 0 ? void 0 : ref37.target_url;
                                        setAffiliateUrl(targetUrl);
                                        if (!isAccepted) {
                                            ;
                                            warningCode = response === null || response === void 0 ? void 0 : (ref38 = response.data) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.data) === null || ref39 === void 0 ? void 0 : ref39.warning_code;
                                            setWarningCode(warningCode);
                                            setErrorCode(null);
                                        } else {
                                            setWarningCode(null);
                                        }
                                    } else {
                                        ;
                                        errorCode = response === null || response === void 0 ? void 0 : (ref40 = response.data) === null || ref40 === void 0 ? void 0 : ref40.error_code;
                                        setErrorCode(errorCode);
                                        setWarningCode(null);
                                    }
                                }
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                return function validateUrl() {
                    return _ref.apply(this, arguments);
                };
            }();
            var isCheckUrl = (0,lib/* validURL */.b3)(data);
            if (isCheckUrl) {
                setIsLoadingBtn(true);
                validateUrl();
                setIsValidUrl(false);
            } else {
                setIsValidUrl(true);
            }
        } else {
            setErrorCode(null);
            setIsValidUrl(false);
            setIsCheckDisableBtnSave(false);
        }
        setWarningCode(null);
    };
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Image_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Image_BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var handleSelectImageOrientation = function(arr) {
        if (arr && arr.length) {
            var imageOrientation = arr[0];
            setImageOrientation(imageOrientation);
        }
    };
    var onUpdateLinkData = function(linkData) {
        if (linkData.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setOriginUrl(linkData.value);
        } else {
            setOriginUrl(null);
        }
        setLinkData(linkData);
    };
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsCheckDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsCheckDisableBtnSave,
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_add_new_image_of_image_slider_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                        valueUrlImage: valueUrlImage,
                        imageRatio: imageRatio
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                color: valueUrlImage ? "primary" : "default",
                                fill: "solid",
                                className: "",
                                onClick: valueUrlImage ? handleDeleteImage : function() {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: valueUrlImage ? "#FFFFFF" : "#CCCCCC"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleImageUrl,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                },
                                className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                value: uploadedImageArr,
                                // disableUpload={isDisableUploadBtn}
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    block: true,
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full grow",
                                    children: t("ss_builder_upload_button_label")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_heading_placeholder"),
                                onChange: handleChangeBlockHeading,
                                value: valueHeadingBlock,
                                maxLength: Image_BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(Image_BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: Image_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(Image_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white my-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_image_orientation_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: imageOrientationOptions,
                                value: [
                                    imageOrientation1
                                ],
                                onChange: handleSelectImageOrientation,
                                columns: 4,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_image_slider_ratio_selected_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: imageOptions,
                                value: [
                                    imageRatio
                                ],
                                onChange: handleSelectImageRatio,
                                columns: 4,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                            label: t("ss_builder_button_link_icon_origin_url_label"),
                            isRequire: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                item: linkData1,
                                onChange: function(item) {
                                    onUpdateLinkData(item);
                                },
                                onLoading: onAffLoading,
                                onError: function(errorMessage) {
                                    setIsValidUrl(!!errorMessage);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                        onChange: handleCheckAffiliateUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_use_affiliate_link_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_use_affiliate_link_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: !!openNewTab,
                                        onChange: handleChangeOpenNewTab,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_open_new_tab_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_open_new_tab_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Image = (ImageComponent);

// EXTERNAL MODULE: ./src/features/share/components/FieldTitle/index.tsx
var FieldTitle = __webpack_require__(28484);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageGallery/ImageListItem/index.tsx






var ImageGalleryListItem = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var index = props.index, imageData = props.imageData, onRemoveItem = props.onRemoveItem, onDisableEnableImage = props.onDisableEnableImage, callbackOpenEditImage = props.callbackOpenEditImage;
    var isEnable = !!(imageData && imageData.enable === 1);
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: "eye-visible-image",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_image_label") : t("ss_builder_hide_image_label")
        },
        {
            key: "delete-image",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_image_label")
        }, 
    ];
    var MoreElement = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleClickMoreIcon,
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: actions,
                    placement: "left",
                    trigger: "click",
                    // stopPropagation={["click"]}
                    // getContainer={() => popoverRef.current}
                    onAction: function(item) {
                        return handleClickPopoverItem(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-image":
                handleEnableDisableImage();
                break;
            case "delete-image":
                confirmRemoveImage();
                break;
            default:
        }
    };
    var confirmRemoveImage = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                onRemoveItem(index);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleEditImage = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditImage(imageData, index);
    };
    var handleEnableDisableImage = function() {
        var imageStatus = !isEnable ? 1 : 2;
        onDisableEnableImage(index, imageStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_image_successfully_label") : t("ss_builder_enable_image_successfully_label")
            })
        });
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {}),
                onClick: handleEditImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: imageData.image,
                            width: 40,
                            height: 40,
                            fit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                children: imageData === null || imageData === void 0 ? void 0 : imageData.title
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ImageListItem = (ImageGalleryListItem);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageGallery/ImageListItem/ImageSelectMode.tsx





var ImageSelectMode = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var image = props.image, enable = props.enable, title = props.title;
    var isEnable = enable === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                src: image,
                width: 40,
                height: 40,
                fit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                    children: title
                })
            })
        ]
    });
};
/* harmony default export */ var ImageListItem_ImageSelectMode = (ImageSelectMode);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageGallery/ImageNewImage/index.tsx
function ImageNewImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImageNewImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImageNewImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var ImageGalleryNewImage = function(props) {
    var DESCRIPTION_MAXIMUM = 250;
    var TITLE_MAXIMUM = 50;
    var imageRatio = props.imageRatio, callBackCancelImageSliderAddNew = props.callBackCancelImageSliderAddNew, handleSaveImageSlider = props.handleSaveImageSlider, imageEditData = props.imageEditData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "image-".concat((0,v4/* default */.Z)());
    var valueUrlImageDefault = imageEditData && imageEditData.image;
    var defaultTitle = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.title;
    var defaultDescription = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.description;
    var ref = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref[0], setValueUrlImage = ref[1];
    var ref1 = (0,react.useState)(null), valueNameImage = ref1[0], setValueNameImage = ref1[1];
    var ref2 = (0,react.useState)(null), valueImageBase64 = ref2[0], setValueImageBase64 = ref2[1];
    var ref3 = (0,react.useState)([]), uploadedImageArr = ref3[0], setUploadedImageArr = ref3[1];
    var ref4 = (0,react.useState)(""), message = ref4[0], setMessage = ref4[1];
    var ref5 = (0,react.useState)(defaultTitle), title = ref5[0], setTitle = ref5[1];
    var ref6 = (0,react.useState)(defaultDescription), description = ref6[0], setDescription = ref6[1];
    var ref7 = (0,react.useState)(false), isValidFileFormat = ref7[0], setIsValidFileFormat = ref7[1];
    var ref8 = (0,react.useState)(false), isValidFileSize = ref8[0], setIsValidFileSize = ref8[1];
    (0,react.useEffect)(function() {
        if (valueUrlImageDefault) {
            setValueUrlImage(valueUrlImageDefault);
        }
        if (message) {
            setMessage(message);
        }
    }, [
        valueUrlImageDefault
    ]);
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleSaveImage = function() {
        var defaultImageData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            image: valueImageBase64 || valueUrlImage,
            image_base64: valueImageBase64,
            title: title,
            description: description,
            name: valueNameImage
        };
        if (imageEditData) {
            handleSaveImageSlider(ImageNewImage_objectSpread({}, imageEditData, {
                image: valueImageBase64 || valueUrlImage,
                image_base64: valueImageBase64,
                title: title,
                description: description
            }));
        } else {
            handleSaveImageSlider(defaultImageData);
        }
        callBackCancelImageSliderAddNew();
        setValueUrlImage(null);
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelImageSliderAddNew = function() {
        if (valueUrlImage && valueUrlImage !== valueUrlImageDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    callBackCancelImageSliderAddNew();
                    setValueUrlImage(null);
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                }
            });
        } else {
            callBackCancelImageSliderAddNew();
            setValueUrlImage(null);
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleSetDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= DESCRIPTION_MAXIMUM) {
            setDescription(val);
        }
    };
    var isSaveButtonEnable = valueUrlImage && (valueUrlImage !== valueUrlImageDefault || title !== defaultTitle || description !== defaultDescription);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: title && title != "" ? title : t("ss_builder_image_gallery")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                        title: t("ss_builder_image"),
                        isRequire: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                        valueUrlImage: valueUrlImage,
                        imageRatio: imageRatio
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-2 mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                            onChange: handleImageUrl,
                            upload: function(file) {
                                return (0,lib/* mockUpload */.Hq)(file, 2000, 2000);
                            },
                            className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                            value: uploadedImageArr,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                block: true,
                                color: "primary",
                                fill: "solid",
                                size: "middle",
                                className: "w-full grow",
                                children: t("ss_builder_upload_button_label")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                                title: t("ss_builder_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                type: "text",
                                value: title,
                                placeholder: t("ss_builder_image_title_place_holder"),
                                onChange: function(value) {
                                    setTitle(value);
                                },
                                maxLength: TITLE_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1 text-gray-500 text-sm text-right",
                                children: [
                                    title ? title.length : 0,
                                    "/",
                                    TITLE_MAXIMUM
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                                title: t("ss_builder_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                onChange: function(value) {
                                    handleSetDescription(value);
                                },
                                value: description,
                                placeholder: t("ss_builder_image_description_place_holder"),
                                maxLength: DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1 text-gray-500 text-sm text-right",
                                children: [
                                    description ? description.length : 0,
                                    "/",
                                    DESCRIPTION_MAXIMUM
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelImageSliderAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveImage,
                            children: t("ss_builder_done_panel")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ImageNewImage = (ImageGalleryNewImage);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageGallery/index.tsx
function ImageGallery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ImageGallery_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ImageGallery_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ImageGallery_arrayLikeToArray(arr);
}
function ImageGallery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImageGallery_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ImageGallery_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ImageGallery_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImageGallery_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImageGallery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImageGallery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ImageGallery_slicedToArray(arr, i) {
    return ImageGallery_arrayWithHoles(arr) || ImageGallery_iterableToArrayLimit(arr, i) || ImageGallery_unsupportedIterableToArray(arr, i) || ImageGallery_nonIterableRest();
}
function ImageGallery_toConsumableArray(arr) {
    return ImageGallery_arrayWithoutHoles(arr) || ImageGallery_iterableToArray(arr) || ImageGallery_unsupportedIterableToArray(arr) || ImageGallery_nonIterableSpread();
}
function ImageGallery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ImageGallery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageGallery_arrayLikeToArray(o, minLen);
}

























var IMAGE_MAX = 30;
var IMAGE_RATIO_VALUE_DEFAULT = "16/9";
var NUMBER_PER_ROW_DEFAULT = 2;
var NUMBER_ITEM_PER_ROW_SLIDE_DEFAULT = 1;
var ImageGallery = function(props) {
    var ref23, ref1, ref2, ref3, ref4;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData, setShowFooterBlockEdit = props.setShowFooterBlockEdit;
    var DESCRIPTION_MAXIMUM = 250;
    var TITLE_MAXIMUM = 50;
    var BLOCK_TITLE_DEFAULT = "Image Gallery";
    var UID = "image-gallery-".concat((0,v4/* default */.Z)());
    var ref5 = (0,react.useState)(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG), mode = ref5[0], setMode = ref5[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var defaultValueEditImageGallery = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = BLOCK_TITLE_DEFAULT;
    var imageArrDefault = defaultValueEditImageGallery && defaultValueEditImageGallery.content_attributes && defaultValueEditImageGallery.content_attributes.items || [];
    var ref6;
    var imageGalleryTitleDefault = (ref6 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref23 = defaultValueEditImageGallery.content_attributes) === null || ref23 === void 0 ? void 0 : ref23.title_image_gallery) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var imageGalleryDescriptionDefault = (ref7 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref1 = defaultValueEditImageGallery.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.description_image_gallery) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var numberItemsPerRowDefault = (ref8 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref2 = defaultValueEditImageGallery.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.number_items_per_row) !== null && ref8 !== void 0 ? ref8 : 1;
    var ref9;
    var imageOrientationDefault = (ref9 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref3 = defaultValueEditImageGallery.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.image_orientation) !== null && ref9 !== void 0 ? ref9 : configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE;
    var ref10;
    var slideStyleDefault = (ref10 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref4 = defaultValueEditImageGallery.style_attributes) === null || ref4 === void 0 ? void 0 : ref4.slide_style) !== null && ref10 !== void 0 ? ref10 : configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE;
    var imageRatioDefault = (0,react.useMemo)(function() {
        var ref;
        var valueRatio = (defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref = defaultValueEditImageGallery.style_attributes) === null || ref === void 0 ? void 0 : ref.ratio) || IMAGE_RATIO_VALUE_DEFAULT;
        if (imageOrientationDefault === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        defaultValueEditImageGallery,
        imageOrientationDefault
    ]);
    var styleImageGalleryDisplayDefault = (0,react.useMemo)(function() {
        var ref;
        var ref24;
        var styleDisPlay = (ref24 = defaultValueEditImageGallery === null || defaultValueEditImageGallery === void 0 ? void 0 : (ref = defaultValueEditImageGallery.style_attributes) === null || ref === void 0 ? void 0 : ref.style_display) !== null && ref24 !== void 0 ? ref24 : configs_const/* STYLE_SLIDE_IMAGE.GRID */.D5.GRID;
        if (styleDisPlay && styleDisPlay.includes(configs_const/* STYLE_SLIDE_IMAGE.GRID */.D5.GRID)) {
            return configs_const/* STYLE_SLIDE_IMAGE.GRID */.D5.GRID;
        } else return styleDisPlay;
    }, [
        defaultValueEditImageGallery
    ]);
    var ref11 = (0,react.useState)(false), isOpenAddNewImageImage = ref11[0], setIsOpenAddNewImageImage = ref11[1];
    var ref12 = (0,react.useState)(imageArrDefault), imageArr = ref12[0], setImageArr = ref12[1];
    var ref13 = (0,react.useState)(null), imageEditData = ref13[0], setImageEditData = ref13[1];
    var ref14 = (0,react.useState)(null), indexImageEdit = ref14[0], setIndexImageEdit = ref14[1];
    var ref15 = (0,react.useState)(imageGalleryTitleDefault), imageGalleryTitle = ref15[0], setImageGalleryTitle = ref15[1];
    var ref16 = (0,react.useState)(imageGalleryDescriptionDefault), imageGalleryDescription = ref16[0], setImageGalleryDescription = ref16[1];
    var ref17 = (0,react.useState)(styleImageGalleryDisplayDefault), styleImageGalleryDisplay = ref17[0], setStyleImageGalleryDisplay = ref17[1];
    var ref18 = (0,react.useState)(numberItemsPerRowDefault), numberItemsPerRow = ref18[0], setNumberItemsPerRow = ref18[1];
    var ref19 = (0,react.useState)(imageOrientationDefault), imageOrientation = ref19[0], setImageOrientation = ref19[1];
    var ref20 = (0,react.useState)(imageRatioDefault), imageRatio = ref20[0], setImageRatio = ref20[1];
    var ref21 = (0,react.useState)(slideStyleDefault), slideStyle = ref21[0], setSlideStyle = ref21[1];
    var ref22 = (0,react.useState)({}), placeholderProps1 = ref22[0], setPlaceholderProps = ref22[1];
    var handleChangeImageGalleryTitle = function(value) {
        if ((value === null || value === void 0 ? void 0 : value.length) <= TITLE_MAXIMUM) {
            setImageGalleryTitle(value);
        }
    };
    var handleChangeImageGalleryDescription = function(value) {
        if ((value === null || value === void 0 ? void 0 : value.length) <= DESCRIPTION_MAXIMUM) {
            setImageGalleryDescription(value);
        }
    };
    var imageSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(imageArr, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        imageArr
    ]);
    var imageEnable = (0,react.useMemo)(function() {
        return imageArr === null || imageArr === void 0 ? void 0 : imageArr.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        imageArr
    ]);
    var imageRatioDetection = (0,react.useMemo)(function() {
        var valueRatio = imageRatio;
        if (imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        imageOrientation,
        imageRatio
    ]);
    (0,react.useEffect)(function() {
        if (imageSortOrder.length) {
            setButtonStatus(false);
        } else {
            setButtonStatus(true);
        }
    }, [
        imageSortOrder
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(true);
    }, []);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultImageData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.IMAGE_GALLERY,
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSortOrder,
                    title_image_gallery: imageGalleryTitle,
                    description_image_gallery: imageGalleryDescription
                },
                style_attributes: {
                    style_display: styleImageGalleryDisplay,
                    number_items_per_row: numberItemsPerRow,
                    image_orientation: imageOrientation,
                    ratio: imageRatioDetection,
                    slide_style: slideStyle
                }
            };
            onUpdateData(defaultImageData);
        } else {
            onUpdateData(ImageGallery_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSortOrder,
                    title_image_gallery: imageGalleryTitle,
                    description_image_gallery: imageGalleryDescription
                },
                style_attributes: {
                    style_display: styleImageGalleryDisplay,
                    number_items_per_row: numberItemsPerRow,
                    image_orientation: imageOrientation,
                    ratio: imageRatioDetection,
                    slide_style: slideStyle
                }
            }));
        }
    }, [
        imageSortOrder,
        imageGalleryTitle,
        imageGalleryDescription,
        imageRatioDetection,
        styleImageGalleryDisplay,
        numberItemsPerRow,
        imageOrientation,
        imageRatioDetection,
        slideStyle, 
    ]);
    var imageRate = (0,react.useMemo)(function() {
        return imageSortOrder && "".concat(imageSortOrder.length, "/").concat(IMAGE_MAX);
    }, [
        imageSortOrder
    ]);
    var handleSaveImage = function(data) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        if (Array.isArray(imageClone)) {
            if (imageEditData) {
                var indexEditItems = imageClone.findIndex(function(x) {
                    return x.uid === imageEditData.uid;
                });
                imageClone[indexEditItems] = data;
            } else {
                if (imageClone.length === 0) {
                    imageClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = imageClone.map(function(x) {
                        return x.sort_order;
                    });
                    imageClone.push(ImageGallery_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, ImageGallery_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setImageArr(imageClone);
            setEditStatus(true);
            !imageEditData && (0,block_libs/* scrollToNewItem */.i)("blocks-".concat(data === null || data === void 0 ? void 0 : data.uid));
        }
    };
    var handleOpenAddImageSlider = function() {
        setIsOpenAddNewImageImage(true);
        setImageEditData(null);
        setIndexImageEdit(null);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(imageSortOrder);
        var ref = ImageGallery_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return ImageGallery_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setImageArr(itemsOrder);
        setButtonStatus(false);
        setEditStatus(true);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(index) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        var newImageItems = imageClone && Array.isArray(imageClone) && imageClone.filter(function(ele, idx) {
            return idx !== index;
        });
        setImageArr(newImageItems);
    };
    var onDisableEnableImage = function(index, imageStatus) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        var newImageItems = imageClone && Array.isArray(imageClone) && imageClone.map(function(ele, idx) {
            return idx === index ? ImageGallery_objectSpread({}, ele, {
                enable: imageStatus
            }) : ele;
        });
        setImageArr(newImageItems);
    };
    var handleSelectStyleImageGalleryOptions = function(arr) {
        if (arr && arr.length) {
            setStyleImageGalleryDisplay(arr[0]);
            if (arr[0] === configs_const/* STYLE_SLIDE_IMAGE.MASONRY */.D5.MASONRY) {
                setNumberItemsPerRow(NUMBER_PER_ROW_DEFAULT);
            }
            if (arr[0] === configs_const/* STYLE_SLIDE_IMAGE.SLIDE */.D5.SLIDE) {
                setNumberItemsPerRow(NUMBER_ITEM_PER_ROW_SLIDE_DEFAULT);
            }
        }
    };
    var handleSelectItemsPerRowOptions = function(arr) {
        if (arr && arr.length) {
            setNumberItemsPerRow(arr[0]);
        }
    };
    var handleSelectImageOrientationOptions = function(arr) {
        if (arr && arr.length) {
            setImageOrientation(arr[0]);
        }
    };
    var handleSelectImageRatioOptions = function(arr) {
        if (arr && arr.length) {
            setImageRatio(arr[0]);
        }
    };
    var handleSelectSlideStyleOptions = function(arr) {
        if (arr && arr.length) {
            setSlideStyle(arr[0]);
        }
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if ((imageSortOrder === null || imageSortOrder === void 0 ? void 0 : imageSortOrder.length) > 0 && (JSON.stringify(imageArr) !== JSON.stringify(imageArrDefault) || imageGalleryTitle !== imageGalleryTitleDefault || imageGalleryDescription !== imageGalleryDescriptionDefault || styleImageGalleryDisplay !== styleImageGalleryDisplayDefault || numberItemsPerRow !== numberItemsPerRowDefault || imageOrientation !== imageOrientationDefault || slideStyle !== slideStyleDefault || imageRatio !== imageRatioDefault) && imageEnable.length > 0) {
            return false;
        }
        return true;
    }, [
        imageGalleryTitle,
        imageGalleryTitleDefault,
        imageGalleryDescription,
        imageGalleryDescriptionDefault,
        styleImageGalleryDisplay,
        styleImageGalleryDisplayDefault,
        numberItemsPerRow,
        numberItemsPerRowDefault,
        imageOrientation,
        imageRatioDetection,
        imageOrientationDefault,
        slideStyle,
        slideStyleDefault,
        imageEnable, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(imageArr) !== JSON.stringify(imageArrDefault) || imageGalleryTitle !== imageGalleryTitleDefault || imageGalleryDescription !== imageGalleryDescriptionDefault || styleImageGalleryDisplay !== styleImageGalleryDisplayDefault || numberItemsPerRow !== numberItemsPerRowDefault || imageOrientation !== imageOrientationDefault || slideStyle !== slideStyleDefault || imageRatio !== imageRatioDefault) {
            return true;
        }
        return false;
    }, [
        imageGalleryTitle,
        imageGalleryTitleDefault,
        imageGalleryDescription,
        imageGalleryDescriptionDefault,
        styleImageGalleryDisplay,
        styleImageGalleryDisplayDefault,
        numberItemsPerRow,
        numberItemsPerRowDefault,
        imageOrientation,
        imageRatioDetection,
        imageOrientationDefault,
        slideStyle,
        slideStyleDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var handleOpenEditImage = function(imageData, index) {
        setIsOpenAddNewImageImage(true);
        setImageEditData(imageData);
        setIndexImageEdit(index);
    };
    var styleImageGalleryOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/image-gallery-grid.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_grid_label")
            }),
            value: configs_const/* STYLE_SLIDE_IMAGE.GRID */.D5.GRID
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/image-gallery-slide.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_slide_label")
            }),
            value: configs_const/* STYLE_SLIDE_IMAGE.SLIDE */.D5.SLIDE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/image-gallery-interlaced.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_masonry_label")
            }),
            value: configs_const/* STYLE_SLIDE_IMAGE.MASONRY */.D5.MASONRY
        }, 
    ];
    var numberItemsPerRowOptions = [
        {
            label: 1,
            value: 1
        },
        {
            label: 2,
            value: 2
        },
        {
            label: 3,
            value: 3
        }, 
    ];
    var numberItemsPerRowOptionsSlide = [
        {
            label: 1,
            value: 1
        },
        {
            label: 2,
            value: 2
        }, 
    ];
    var imageOrientationOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/image-gallery-landscape.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_landscape_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/layout-types/image-gallery-portrait.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_portrait_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT
        }, 
    ];
    var imageRatioOptions = [
        {
            label: "1:1",
            value: "1/1"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "4:3" : "3:4",
            value: "4/3"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:2" : "2:3",
            value: "3/2"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "16:9" : "9:16",
            value: "16/9"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "21:9" : "9:21",
            value: "21/9"
        },
        {
            label: imageOrientation === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:1" : "1:3",
            value: "3/1"
        }, 
    ];
    var slideStyleOptions = [
        // {
        //   label: (
        //     <Image
        //     width={96}
        //     height={96}
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-1.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_1")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.PARTIAL_VISIBLE_RIGHT,
        // },
        // {
        //   label: (
        //     <Image
        //     width={96}
        //     height={96}
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-2.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_2")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.PARTIAL_VISIBLE_BOTH_SIDES,
        // },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                width: 96,
                height: 96,
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-3.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_partial_visible_slide_type_3")
            }),
            value: configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE
        },
        // {
        //   label: (
        //     <Image
        //     width={96}
        //     height={96}
        //       fit="cover"
        //       src="https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-4.png"
        //     />
        //   ),
        //   description: (
        //     <div className="mt-1">
        //       {t("ss_builder_partial_visible_slide_type_4")}
        //     </div>
        //   ),
        //   value: SLIDE_STYLE.POSTERS,
        // },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                width: 96,
                height: 96,
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/display-styles/partial-visible-style-5.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_partial_visible_slide_type_5")
            }),
            value: configs_const/* SLIDE_STYLE.PANORAMA */.jw.PANORAMA
        }, 
    ];
    var renderLinksSelectItemsMode = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWithCheckbox/* default */.Z, {
                propertyIndex: "uid",
                onCancel: swichToDragMode,
                item: ImageListItem_ImageSelectMode,
                onChange: setImageArr,
                defaultItems: imageSortOrder.map(function(e) {
                    return ImageGallery_objectSpread({
                        id: e.uid
                    }, e);
                }),
                header: {
                    title: t("ss_builder_list_label"),
                    sticky: true
                },
                footer: {
                    countTitle: t("ss_builder_filter_select_multi_items_gallery_count")
                },
                blockType: block.block_type
            })
        });
    };
    var swichToDragMode = function() {
        setMode(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG);
        setShowFooterBlockEdit(true);
    };
    var switchToSelectItemsMode = function() {
        setMode(config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS);
        setShowFooterBlockEdit(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_affiliate_product_group_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                        placeholder: t("ss_builder_block_description_placeholder"),
                        onChange: handleChangeImageGalleryTitle,
                        value: imageGalleryTitle,
                        maxLength: TITLE_MAXIMUM
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-1 text-gray-500 text-sm text-right",
                        children: [
                            imageGalleryTitle ? imageGalleryTitle.length : 0,
                            "/",
                            TITLE_MAXIMUM
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "10px 0"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeImageGalleryDescription,
                                value: imageGalleryDescription,
                                maxLength: DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1 text-gray-500 text-sm text-right",
                                children: [
                                    imageGalleryDescription ? imageGalleryDescription.length : 0,
                                    "/",
                                    DESCRIPTION_MAXIMUM
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "10px 0"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3 p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] mb-1",
                                children: t("ss_builder_style")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: styleImageGalleryOptions,
                                value: [
                                    styleImageGalleryDisplay
                                ],
                                onChange: handleSelectStyleImageGalleryOptions,
                                columns: 3,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    styleImageGalleryDisplay === configs_const/* STYLE_SLIDE_IMAGE.SLIDE */.D5.SLIDE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] mb-1",
                                children: t("ss_builder_slide_type_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                                className: "selector-scroll scroll-style-slide",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                    options: slideStyleOptions,
                                    value: [
                                        slideStyle
                                    ],
                                    onChange: handleSelectSlideStyleOptions,
                                    style: {
                                        "--border": "solid transparent 1px",
                                        "--checked-border": "solid var(--adm-color-primary) 1px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                        ]
                    }),
                    styleImageGalleryDisplay !== configs_const/* STYLE_SLIDE_IMAGE.MASONRY */.D5.MASONRY && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666] mb-1",
                                        children: t("ss_builder_items_per_row")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: styleImageGalleryDisplay !== configs_const/* STYLE_SLIDE_IMAGE.SLIDE */.D5.SLIDE ? numberItemsPerRowOptions : numberItemsPerRowOptionsSlide,
                                        value: [
                                            numberItemsPerRow
                                        ],
                                        onChange: handleSelectItemsPerRowOptions,
                                        columns: 3,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666] mb-1",
                                        children: t("ss_builder_image_orientation")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: imageOrientationOptions,
                                        value: [
                                            imageOrientation
                                        ],
                                        onChange: handleSelectImageOrientationOptions,
                                        columns: 3,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[15px] text-[#666666] mb-1",
                                        children: t("ss_builder_image_slider_ratio_selected_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: imageRatioOptions,
                                        value: [
                                            imageRatio
                                        ],
                                        onChange: handleSelectImageRatioOptions,
                                        columns: 4,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            mode === config_interface/* ITEMS_MODE.DRAG */.yo.DRAG && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                        previousStickyElementId: "block-image-gallery-editor-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between px-3 pt-4 pb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[15px] text-[#666666]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                                                title: t("ss_builder_list_label"),
                                                isRequire: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-grow justify-end gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                size: "small",
                                                fill: "solid",
                                                color: "primary",
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "3px 12px 3px 12px"
                                                },
                                                onClick: handleOpenAddImageSlider,
                                                disabled: imageSortOrder.length === IMAGE_MAX,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                        className: "w-[15px] h-[15px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_add_new_label")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: imageRate
                                                    })
                                                ]
                                            }),
                                            imageSortOrder.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                onClick: switchToSelectItemsMode,
                                                color: "primary",
                                                fill: "outline",
                                                size: "small",
                                                children: t("ss_builder_select_label")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            imageEnable.length === 0 && imageArr.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                                style: {
                                    color: "var(--adm-color-danger)"
                                },
                                children: t("ss_builder_need_to_display_at_least_one_image")
                            })
                        ]
                    }),
                    imageSortOrder && imageSortOrder.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                            onDragEnd: onDragEnd,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                droppableId: "blocks-".concat(BLOCK_TYPE.IMAGE_GALLERY),
                                children: function(provided1, snapshot1) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", ImageGallery_objectSpread({}, provided1.droppableProps, {
                                        ref: provided1.innerRef,
                                        className: "relative",
                                        children: [
                                            imageSortOrder && imageSortOrder.length > 0 && imageSortOrder.map(function(ele, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                    draggableId: "blocks-".concat(ele.uid),
                                                    index: index,
                                                    children: function(provided, snapshot) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", ImageGallery_objectSpread({
                                                            ref: provided.innerRef
                                                        }, provided.draggableProps, provided.dragHandleProps, {
                                                            className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageListItem, {
                                                                index: index,
                                                                imageData: ele,
                                                                onRemoveItem: onRemoveItem,
                                                                onDisableEnableImage: onDisableEnableImage,
                                                                callbackOpenEditImage: handleOpenEditImage
                                                            })
                                                        }));
                                                    }
                                                }, "blocks-".concat(ele.uid));
                                            }),
                                            provided1.placeholder,
                                            !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                placeholderProps: placeholderProps1,
                                                content: t("ss_builder_placeholder_dragging_content"),
                                                style: {
                                                    backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                    border: "1px dashed #1890FF",
                                                    borderRadius: "4px",
                                                    color: "#1890FF"
                                                }
                                            })
                                        ]
                                    }));
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageGalleryIcon */.lP, {
                                    className: "align-middle w-8 h-8"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: t("ss_builder_image_list_empty_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: t("ss_builder_image_list_empty_content")
                            })
                        ]
                    })
                ]
            }),
            mode === config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS && renderLinksSelectItemsMode(),
            isOpenAddNewImageImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewImageImage,
                onMaskClick: function() {
                    return setIsOpenAddNewImageImage(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageNewImage, {
                    imageRatio: imageRatioDetection,
                    callBackCancelImageSliderAddNew: function() {
                        return setIsOpenAddNewImageImage(false);
                    },
                    handleSaveImageSlider: handleSaveImage,
                    imageEditData: imageEditData,
                    indexImageEdit: indexImageEdit
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_ImageGallery = (ImageGallery);

// EXTERNAL MODULE: ./src/features/block/block-editor/ImagePopup/index.tsx + 6 modules
var ImagePopup = __webpack_require__(69851);
;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageSlider/ImageListItems/index.tsx








var ImageListItems = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var AFF_CODE = 1;
    var index = props.index, imageData = props.imageData, onRemoveItem = props.onRemoveItem, onDisableEnableImage = props.onDisableEnableImage, callbackOpenEditImage = props.callbackOpenEditImage;
    var isEnable = !!(imageData && imageData.enable === 1);
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: "eye-visible-image",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_image_label") : t("ss_builder_hide_image_label")
        },
        {
            key: "delete-image",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_image_label")
        }, 
    ];
    var MoreElement = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: actions,
                    placement: "left",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    onAction: function(item) {
                        return handleClickPopoverItem(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-image":
                handleEnableDisableImage();
                break;
            case "delete-image":
                confirmRemoveImage();
                break;
            default:
        }
    };
    var confirmRemoveImage = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                onRemoveItem(index);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleEditImage = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditImage(imageData, index);
    };
    var handleEnableDisableImage = function() {
        var imageStatus = !isEnable ? 1 : 2;
        onDisableEnableImage(index, imageStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_image_successfully_label") : t("ss_builder_enable_image_successfully_label")
            })
        });
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var getContent = function() {
        var content = "";
        if (imageData.link_data.type !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE) {
            content = imageData.link_data.value;
        } else {
            if (imageData.link_data.value === configs_const/* TRUTH_OR_DATE */.z0) content = t("ss_builder_title_block_truth_or_dare");
            if (imageData.link_data.value === configs_const/* GIFT */.R_) content = t("ss_builder_title_block_brand_gift");
            if (imageData.link_data.value === configs_const/* DONATION */.px) content = t("ss_builder_title_block_donation");
        }
        return content;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {}),
                onClick: handleEditImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: imageData.image,
                            width: 40,
                            height: 40,
                            fit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: [
                                imageData.image_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                    children: imageData.image_description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xs leading-4 font-normal text-[#8C8C8C] text-ellipsis whitespace-nowrap overflow-hidden",
                                    children: imageData.use_aff_url === AFF_CODE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        style: {
                                            marginTop: "2px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontSize: "12px",
                                                    color: "#8C8C8C",
                                                    fontWeight: 400
                                                },
                                                children: t("ss_builder_product_link_wrapped_label")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        className: "text-[#999999] text-[15px] leading-5 text-ellipsis",
                                        content: getContent()
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ImageSlider_ImageListItems = (ImageListItems);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageSlider/ImageSliderAddNew/index.tsx
function ImageSliderAddNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImageSliderAddNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImageSliderAddNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var IMAGE_DESCRIPTION_MAXIMUM = 50;
var ImageSliderAddNew = function(props) {
    var imageRatio = props.imageRatio, callBackCancelImageSliderAddNew = props.callBackCancelImageSliderAddNew, handleSaveImageSlider = props.handleSaveImageSlider, imageEditData = props.imageEditData, indexImageEdit = props.indexImageEdit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "image-".concat((0,v4/* default */.Z)());
    var originUrlDefault = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.origin_url;
    var affiliateUrlDefault = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.target_url;
    var valueUrlImageDefault = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.image;
    var valueDescriptionImageDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.image_description) || "";
    var hasAffiliateUrlDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.use_aff_url) ? !!((imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.use_aff_url) === 1) : true;
    var defaultLinkData = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: originUrlDefault
    };
    var openInNewTabDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.open_new_tab) || false;
    var ref = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref[0], setValueUrlImage = ref[1];
    var ref1 = (0,react.useState)(""), valueNameImage = ref1[0], setValueNameImage = ref1[1];
    var ref2 = (0,react.useState)(valueDescriptionImageDefault), valueDescriptionImage = ref2[0], setValueDescriptionImage = ref2[1];
    var ref3 = (0,react.useState)(null), valueImageBase64 = ref3[0], setValueImageBase64 = ref3[1];
    var ref4 = (0,react.useState)([]), uploadedImageArr = ref4[0], setUploadedImageArr = ref4[1];
    var ref5 = (0,react.useState)(originUrlDefault || ""), originUrl = ref5[0], setOriginUrl = ref5[1];
    var ref6 = (0,react.useState)(affiliateUrlDefault || ""), affiliateUrl = ref6[0], setAffiliateUrl = ref6[1];
    var ref7 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref7[0], setHasAffiliateUrl = ref7[1];
    var ref8 = (0,react.useState)(false), isValidUrl = ref8[0], setIsValidUrl = ref8[1];
    var ref9 = (0,react.useState)(false), isLoadingBtn = ref9[0], setIsLoadingBtn = ref9[1];
    var ref10 = (0,react.useState)(false), isDisableBtnSave = ref10[0], setIsDisableBtnSave = ref10[1];
    var ref11 = (0,react.useState)(false), isValidFileFormat = ref11[0], setIsValidFileFormat = ref11[1];
    var ref12 = (0,react.useState)(false), isValidFileSize = ref12[0], setIsValidFileSize = ref12[1];
    var ref13 = (0,react.useState)(defaultLinkData), linkData1 = ref13[0], setLinkData = ref13[1];
    var ref14 = (0,react.useState)(false), isEcommerce = ref14[0], setIsEcommerce = ref14[1];
    var ref15 = (0,react.useState)(openInNewTabDefault), openNewTab = ref15[0], setOpenNewTab = ref15[1];
    var checkEcomerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcomerce(linkData1.target_url);
        } else if (originUrl) checkEcomerce(originUrl);
    }, [
        originUrl,
        linkData1
    ]);
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    (0,react.useEffect)(function() {
        if (valueUrlImageDefault) {
            setValueUrlImage(valueUrlImageDefault);
        }
        if (originUrlDefault) {
            setOriginUrl(originUrlDefault);
        }
        if (affiliateUrlDefault) {
            setAffiliateUrl(affiliateUrlDefault);
        }
        if (hasAffiliateUrlDefault) {
            setHasAffiliateUrl(hasAffiliateUrlDefault);
        }
    }, [
        valueUrlImageDefault,
        originUrlDefault,
        affiliateUrlDefault,
        hasAffiliateUrlDefault, 
    ]);
    var handleDeleteImage = function() {
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                setValueUrlImage(null);
                setUploadedImageArr([]);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block w-[30px] h-[30px]",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleSaveImage = function() {
        var defaultImageData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
            image: valueImageBase64 || valueUrlImage,
            image_base64: valueImageBase64,
            origin_url: originUrl,
            target_url: affiliateUrl,
            image_name: valueNameImage,
            image_description: valueDescriptionImage,
            link_data: linkData1,
            open_new_tab: isEcommerce ? true : openNewTab
        };
        if (imageEditData) {
            handleSaveImageSlider(ImageSliderAddNew_objectSpread({}, imageEditData, {
                use_aff_url: hasAffiliateUrl === true && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                image: valueImageBase64 || valueUrlImage,
                image_base64: valueImageBase64,
                origin_url: originUrl,
                target_url: affiliateUrl,
                image_name: valueNameImage,
                image_description: valueDescriptionImage,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            }));
        } else {
            handleSaveImageSlider(defaultImageData);
        }
        callBackCancelImageSliderAddNew();
        setValueUrlImage(null);
        setOriginUrl("");
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelImageSliderAddNew = function() {
        if (valueUrlImage && valueUrlImage !== valueUrlImageDefault || originUrl && originUrl !== originUrlDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || openNewTab !== openInNewTabDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "var(--adm-color-primary)",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_confirm-cancel_image_slider_add_new_content")
                }),
                confirmText: t("ss_builder_confirm_cancel_image_slider_add_new_btn_label"),
                cancelText: t("ss_builder_cancel_image_slider_add_new_btn_label"),
                onConfirm: function() {
                    callBackCancelImageSliderAddNew();
                    setValueUrlImage(null);
                    setOriginUrl("");
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                },
                onCancel: function() {
                    return;
                }
            });
        } else {
            callBackCancelImageSliderAddNew();
            setValueUrlImage(null);
            setOriginUrl("");
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var handleChangeImageDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= IMAGE_DESCRIPTION_MAXIMUM) {
            setValueDescriptionImage(val);
        }
    };
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        if (typeof hasAffiliateUrl === "boolean" && valueUrlImage && // originUrl &&
        (valueUrlImage !== valueUrlImageDefault || valueDescriptionImage !== valueDescriptionImageDefault || originUrl !== originUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || openNewTab !== openInNewTabDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault) && !isValidUrl && !isDisableBtnSave) {
            return true;
        } else return false;
    }, [
        hasAffiliateUrl,
        valueUrlImage,
        valueUrlImageDefault,
        originUrl,
        originUrlDefault,
        hasAffiliateUrlDefault,
        isValidUrl,
        isDisableBtnSave,
        valueDescriptionImage,
        valueDescriptionImageDefault,
        linkData1,
        defaultLinkData,
        openNewTab,
        openInNewTabDefault, 
    ]);
    var onUpdateLinkData = function(linkData) {
        if (linkData.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setOriginUrl(linkData.value);
        } else {
            setOriginUrl(null);
        }
        setLinkData(linkData);
    };
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIcon */.XB, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: typeof indexImageEdit === "number" ? "Image ".concat(indexImageEdit + 1) : "Image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white mb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_add_new_image_of_image_slider_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                        valueUrlImage: valueUrlImage,
                        imageRatio: imageRatio
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                color: valueUrlImage ? "primary" : "default",
                                fill: "solid",
                                className: "",
                                onClick: valueUrlImage ? handleDeleteImage : function() {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: valueUrlImage ? "#FFFFFF" : "#CCCCCC"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleImageUrl,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                },
                                className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                value: uploadedImageArr,
                                // disableUpload={isDisableUploadBtn}
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    block: true,
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full grow",
                                    children: t("ss_builder_upload_button_label")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeImageDescription,
                                value: valueDescriptionImage,
                                maxLength: IMAGE_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionImage ? valueDescriptionImage.length : 0, "/").concat(IMAGE_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                            label: t("ss_builder_button_link_icon_origin_url_label"),
                            isRequire: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                                item: linkData1,
                                onChange: function(item) {
                                    onUpdateLinkData(item);
                                },
                                onLoading: onAffLoading,
                                onError: function(errorMessage) {
                                    setIsValidUrl(!!errorMessage);
                                }
                            })
                        })
                    }),
                    linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                        onChange: handleCheckAffiliateUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-left",
                                            children: t("ss_builder_use_affiliate_link_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_use_affiliate_link_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            }),
                            !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelImageSliderAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveImage,
                            loading: isLoadingBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ImageSlider_ImageSliderAddNew = (ImageSliderAddNew);

;// CONCATENATED MODULE: ./src/features/block/block-editor/ImageSlider/index.tsx
function ImageSlider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ImageSlider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ImageSlider_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ImageSlider_arrayLikeToArray(arr);
}
function ImageSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImageSlider_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ImageSlider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ImageSlider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImageSlider_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImageSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImageSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ImageSlider_slicedToArray(arr, i) {
    return ImageSlider_arrayWithHoles(arr) || ImageSlider_iterableToArrayLimit(arr, i) || ImageSlider_unsupportedIterableToArray(arr, i) || ImageSlider_nonIterableRest();
}
function ImageSlider_toConsumableArray(arr) {
    return ImageSlider_arrayWithoutHoles(arr) || ImageSlider_iterableToArray(arr) || ImageSlider_unsupportedIterableToArray(arr) || ImageSlider_nonIterableSpread();
}
function ImageSlider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ImageSlider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageSlider_arrayLikeToArray(o, minLen);
}




















var ImageSlider_IMAGE_MAX = 5;
var ImageSlider_BLOCK_HEADING_MAXIMUM = 50;
var ImageSlider_BLOCK_DESCRIPTION_MAXIMUM = 250;
var ImageSliderComponent = function(props) {
    var ref22, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "image-slider-".concat((0,v4/* default */.Z)());
    var defaultValueEditImageSlider = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = "Image Slider";
    var imageSliderArrDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref22 = defaultValueEditImageSlider.content_attributes) === null || ref22 === void 0 ? void 0 : ref22.items) || [];
    var valueHeadingBlockDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref1 = defaultValueEditImageSlider.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.block_heading) || "";
    var valueDescriptionBlockDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref2 = defaultValueEditImageSlider.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_description) || "";
    var enableDotDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref3 = defaultValueEditImageSlider.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.enable_dot) !== undefined ? defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref4 = defaultValueEditImageSlider.style_attributes) === null || ref4 === void 0 ? void 0 : ref4.enable_dot : true;
    var enableArrowDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref5 = defaultValueEditImageSlider.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.enable_arrow) !== undefined ? defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref6 = defaultValueEditImageSlider.style_attributes) === null || ref6 === void 0 ? void 0 : ref6.enable_arrow : false;
    var enableAutoPlayDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref7 = defaultValueEditImageSlider.style_attributes) === null || ref7 === void 0 ? void 0 : ref7.enable_auto_play) !== undefined ? defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref8 = defaultValueEditImageSlider.style_attributes) === null || ref8 === void 0 ? void 0 : ref8.enable_auto_play : false;
    var imageOrientationDefault = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref9 = defaultValueEditImageSlider.style_attributes) === null || ref9 === void 0 ? void 0 : ref9.image_orientation) || configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE;
    var ratioDefault = (0,react.useMemo)(function() {
        var ref;
        var valueRatio = (defaultValueEditImageSlider === null || defaultValueEditImageSlider === void 0 ? void 0 : (ref = defaultValueEditImageSlider.style_attributes) === null || ref === void 0 ? void 0 : ref.ratio) || "16/9";
        if (imageOrientationDefault === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        defaultValueEditImageSlider,
        imageOrientationDefault
    ]);
    var ref10 = (0,react.useState)(ratioDefault), imageRatio = ref10[0], setImageRatio = ref10[1];
    var ref11 = (0,react.useState)(false), isOpenAddNewImageSlider = ref11[0], setIsOpenAddNewImageSlider = ref11[1];
    var ref12 = (0,react.useState)(imageSliderArrDefault), imageSliderArr = ref12[0], setImageSliderArr = ref12[1];
    var ref13 = (0,react.useState)(enableDotDefault), enableDot = ref13[0], setEnableDot = ref13[1];
    var ref14 = (0,react.useState)(enableArrowDefault), enableArrow = ref14[0], setEnableArrow = ref14[1];
    var ref15 = (0,react.useState)(enableAutoPlayDefault), enableAutoPlay = ref15[0], setEnableAutoPlay = ref15[1];
    var ref16 = (0,react.useState)(null), imageEditData = ref16[0], setImageEditData = ref16[1];
    var ref17 = (0,react.useState)(null), indexImageEdit = ref17[0], setIndexImageEdit = ref17[1];
    var ref18 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref18[0], setValueHeadingBlock = ref18[1];
    var ref19 = (0,react.useState)(imageOrientationDefault), imageOrientation1 = ref19[0], setImageOrientation = ref19[1];
    var ref20 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref20[0], setValueDescriptionBlock = ref20[1];
    var ref21 = (0,react.useState)({}), placeholderProps1 = ref21[0], setPlaceholderProps = ref21[1];
    var imageSliderSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(imageSliderArr, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        imageSliderArr
    ]);
    var imageEnable = (0,react.useMemo)(function() {
        return imageSliderArr.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        imageSliderArr
    ]);
    var imageSliderEnable = imageSliderSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    var imageRatioDetection = (0,react.useMemo)(function() {
        var valueRatio = imageRatio;
        if (imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT) {
            var revertRatioArr = valueRatio === null || valueRatio === void 0 ? void 0 : valueRatio.split("/");
            valueRatio = "".concat(revertRatioArr[1], "/").concat(revertRatioArr[0]);
        }
        return valueRatio;
    }, [
        imageOrientation1,
        imageRatio
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultImageSliderData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.IMAGE_SLIDER,
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSliderSortOrder,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock
                },
                style_attributes: {
                    enable_dot: enableDot,
                    enable_arrow: enableArrow,
                    enable_auto_play: enableAutoPlay,
                    ratio: imageRatioDetection,
                    image_orientation: imageOrientation1
                }
            };
            onUpdateData(defaultImageSliderData);
        } else {
            onUpdateData(ImageSlider_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSliderSortOrder,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock
                },
                style_attributes: {
                    enable_dot: enableDot,
                    enable_arrow: enableArrow,
                    enable_auto_play: enableAutoPlay,
                    ratio: imageRatioDetection,
                    image_orientation: imageOrientation1
                }
            }));
        }
    }, [
        imageSliderSortOrder,
        enableDot,
        enableArrow,
        enableAutoPlay,
        imageRatioDetection,
        valueHeadingBlock,
        valueDescriptionBlock,
        imageOrientation1, 
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (imageSliderEnable && imageSliderEnable.length > 0 && (JSON.stringify(imageSliderArr) !== JSON.stringify(imageSliderArrDefault) || imageRatio !== ratioDefault || enableDot !== enableDotDefault || enableArrow !== enableArrowDefault || enableAutoPlay !== enableAutoPlayDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation1 !== imageOrientationDefault) && imageEnable.length > 0) {
            return false;
        } else return true;
    }, [
        imageSliderSortOrder,
        imageSliderArr,
        imageSliderArrDefault,
        imageRatio,
        ratioDefault,
        enableDot,
        enableArrow,
        enableArrowDefault,
        enableAutoPlay,
        enableAutoPlayDefault,
        enableDotDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation1,
        imageOrientationDefault,
        imageEnable, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(imageSliderArr) !== JSON.stringify(imageSliderArrDefault) || imageRatio !== ratioDefault || enableDot !== enableDotDefault || enableArrow !== enableArrowDefault || enableAutoPlay !== enableAutoPlayDefault || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || imageOrientation1 !== imageOrientationDefault) {
            return true;
        } else return false;
    }, [
        imageSliderArr,
        imageSliderArrDefault,
        imageRatio,
        ratioDefault,
        enableDot,
        enableArrow,
        enableArrowDefault,
        enableAutoPlay,
        enableAutoPlayDefault,
        enableDotDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageOrientation1,
        imageOrientationDefault, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var imageRate = (0,react.useMemo)(function() {
        return imageSliderSortOrder && "".concat(imageSliderSortOrder.length, "/").concat(ImageSlider_IMAGE_MAX);
    }, [
        imageSliderSortOrder
    ]);
    var handleSaveImageSlider = function(data) {
        var imageSliderClone = cloneDeep_default()(imageSliderSortOrder);
        if (Array.isArray(imageSliderClone)) {
            if (imageEditData) {
                var indexEditItems = imageSliderClone.findIndex(function(x) {
                    return x.uid === imageEditData.uid;
                });
                imageSliderClone[indexEditItems] = data;
            } else {
                if (imageSliderClone.length === 0) {
                    imageSliderClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = imageSliderClone.map(function(x) {
                        return x.sort_order;
                    });
                    imageSliderClone.push(ImageSlider_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, ImageSlider_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setImageSliderArr(imageSliderClone);
            !imageEditData && (0,block_libs/* scrollToNewItem */.i)("blocks-".concat(data === null || data === void 0 ? void 0 : data.uid));
        }
    };
    var imageSliderOptions = [
        {
            label: "1:1",
            value: "1/1"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "4:3" : "3:4",
            value: "4/3"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:2" : "2:3",
            value: "3/2"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "16:9" : "9:16",
            value: "16/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "21:9" : "9:21",
            value: "21/9"
        },
        {
            label: imageOrientation1 === configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE ? "3:1" : "1:3",
            value: "3/1"
        }, 
    ];
    var imageOrientationOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/landscape.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_landscape_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.LANDSCAPE */.Jd.LANDSCAPE
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://i.ecomobi.com/ssp/passio-page/config/portrait.png"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_portrait_image_orientation_label")
            }),
            value: configs_const/* IMAGE_ORIENTATION_TYPE.PORTRAIT */.Jd.PORTRAIT
        }, 
    ];
    var handleSelectImageRatio = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            setImageRatio(valueRatio);
        }
    };
    var handleOpenAddImageSlider = function() {
        setIsOpenAddNewImageSlider(true);
        setImageEditData(null);
        setIndexImageEdit(null);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(imageSliderSortOrder);
        var ref = ImageSlider_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return ImageSlider_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setImageSliderArr(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(index) {
        var imageSliderClone = cloneDeep_default()(imageSliderSortOrder);
        var newImageItems = imageSliderClone && Array.isArray(imageSliderClone) && imageSliderClone.filter(function(ele, idx) {
            return idx !== index;
        });
        setImageSliderArr(newImageItems);
    };
    var onDisableEnableImage = function(index, imageStatus) {
        var imageSliderClone = cloneDeep_default()(imageSliderSortOrder);
        var newImageItems = imageSliderClone && Array.isArray(imageSliderClone) && imageSliderClone.map(function(ele, idx) {
            return idx === index ? ImageSlider_objectSpread({}, ele, {
                enable: imageStatus
            }) : ele;
        });
        setImageSliderArr(newImageItems);
    };
    var handleOpenEditImage = function(imageData, index) {
        setIsOpenAddNewImageSlider(true);
        setImageEditData(imageData);
        setIndexImageEdit(index);
    };
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= ImageSlider_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= ImageSlider_BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var handleSelectImageOrientation = function(arr) {
        if (arr && arr.length) {
            var imageOrientation = arr[0];
            setImageOrientation(imageOrientation);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_heading_placeholder"),
                                onChange: handleChangeBlockHeading,
                                value: valueHeadingBlock,
                                maxLength: ImageSlider_BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(ImageSlider_BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: ImageSlider_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(ImageSlider_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_image_orientation_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: imageOrientationOptions,
                                value: [
                                    imageOrientation1
                                ],
                                onChange: handleSelectImageOrientation,
                                columns: 4,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_image_slider_ratio_selected_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                        options: imageSliderOptions,
                        value: [
                            imageRatio
                        ],
                        onChange: handleSelectImageRatio,
                        columns: 4,
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_image_slider_dot_switch_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                defaultChecked: true,
                                checked: enableDot,
                                onChange: function(val) {
                                    return setEnableDot(val);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_image_slider_arrow_switch_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                defaultChecked: true,
                                checked: enableArrow,
                                onChange: function(val) {
                                    return setEnableArrow(val);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: t("ss_builder_image_slider_auto_play_switch_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                defaultChecked: true,
                                checked: enableAutoPlay,
                                onChange: function(val) {
                                    return setEnableAutoPlay(val);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                            previousStickyElementId: "block-image-slider-editor-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row justify-between px-3 pt-4 pb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[15px] text-[#666666]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-red-600",
                                                        children: "*"
                                                    }),
                                                    t("ss_builder_list_label")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-grow justify-end gap-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                                size: "small",
                                                fill: "solid",
                                                color: "primary",
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    padding: "3px 12px 3px 12px"
                                                },
                                                onClick: handleOpenAddImageSlider,
                                                disabled: imageSliderSortOrder.length === ImageSlider_IMAGE_MAX,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                        className: "w-[15px] h-[15px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_add_new_label")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: imageRate
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                imageEnable.length === 0 && imageSliderArr.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                                    style: {
                                        color: "var(--adm-color-danger)"
                                    },
                                    children: t("ss_builder_need_to_display_at_least_one_image")
                                })
                            ]
                        }),
                        imageSliderSortOrder && imageSliderSortOrder.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                                onDragEnd: onDragEnd,
                                onDragUpdate: onDragUpdate,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                                    droppableId: "blocks-".concat(BLOCK_TYPE.IMAGE_SLIDER),
                                    children: function(provided1, snapshot1) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", ImageSlider_objectSpread({}, provided1.droppableProps, {
                                            ref: provided1.innerRef,
                                            className: "relative",
                                            children: [
                                                imageSliderSortOrder && imageSliderSortOrder.length > 0 && imageSliderSortOrder.map(function(ele, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                        draggableId: "blocks-".concat(ele.uid),
                                                        index: index,
                                                        children: function(provided, snapshot) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", ImageSlider_objectSpread({
                                                                ref: provided.innerRef
                                                            }, provided.draggableProps, provided.dragHandleProps, {
                                                                className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImageListItems, {
                                                                    index: index,
                                                                    imageData: ele,
                                                                    onRemoveItem: onRemoveItem,
                                                                    onDisableEnableImage: onDisableEnableImage,
                                                                    callbackOpenEditImage: handleOpenEditImage
                                                                })
                                                            }));
                                                        }
                                                    }, "blocks-".concat(ele.uid));
                                                }),
                                                provided1.placeholder,
                                                !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                                    placeholderProps: placeholderProps1,
                                                    content: t("ss_builder_placeholder_dragging_content"),
                                                    style: {
                                                        backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                        border: "1px dashed #1890FF",
                                                        borderRadius: "4px",
                                                        color: "#1890FF"
                                                    }
                                                })
                                            ]
                                        }));
                                    }
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-center items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageSliderIcon */.E8, {
                                        className: "align-middle w-8 h-8"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#333333] text-lg leading-6",
                                    children: t("ss_builder_image_list_empty_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#8C8C8C] text-xs leading-4",
                                    children: t("ss_builder_image_list_empty_content")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewImageSlider,
                onMaskClick: function() {
                    return setIsOpenAddNewImageSlider(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImageSliderAddNew, {
                    imageRatio: imageRatioDetection,
                    callBackCancelImageSliderAddNew: function() {
                        return setIsOpenAddNewImageSlider(false);
                    },
                    handleSaveImageSlider: handleSaveImageSlider,
                    imageEditData: imageEditData,
                    indexImageEdit: indexImageEdit
                })
            })
        ]
    });
};
/* harmony default export */ var ImageSlider = (ImageSliderComponent);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Story/StoryListItem/index.tsx








var StoryListItem = function(props) {
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var index = props.index, imageData = props.imageData, onRemoveItem = props.onRemoveItem, onDisableEnableImage = props.onDisableEnableImage, callbackOpenEditImage = props.callbackOpenEditImage;
    var isEnable = !!(imageData && imageData.enable === 1);
    var linkDatavalue = imageData.origin_url || (imageData === null || imageData === void 0 ? void 0 : (ref = imageData.link_data) === null || ref === void 0 ? void 0 : ref.value);
    var popoverRef = (0,react.useRef)(null);
    var actions = [
        {
            key: "eye-visible-image",
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: !isEnable ? t("ss_builder_show_image_label") : t("ss_builder_hide_image_label")
        },
        {
            key: "delete-image",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: ""
            }),
            text: t("ss_builder_delete_image_label")
        }, 
    ];
    var MoreElement = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row items-center gap-[15px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleClickMoreIcon,
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                    mode: "dark",
                    actions: actions,
                    placement: "left",
                    trigger: "click",
                    // stopPropagation={["click"]}
                    // getContainer={() => popoverRef.current}
                    onAction: function(item) {
                        return handleClickPopoverItem(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "mr-3"
                    })
                })
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "eye-visible-image":
                handleEnableDisableImage();
                break;
            case "delete-image":
                confirmRemoveImage();
                break;
            default:
        }
    };
    var confirmRemoveImage = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_cancel-delete_image_label"),
            onConfirm: function() {
                onRemoveItem(index);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block",
                        fillColor: "#00B578"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleEditImage = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        callbackOpenEditImage(imageData, index);
    };
    var handleEnableDisableImage = function() {
        var imageStatus = !isEnable ? 1 : 2;
        onDisableEnableImage(index, imageStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable ? t("ss_builder_disable_image_successfully_label") : t("ss_builder_enable_image_successfully_label")
            })
        });
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: popoverRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DragIcon */.Vn, {
                    className: ""
                }),
                extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreElement, {}),
                onClick: handleEditImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: imageData.image,
                            width: 40,
                            height: 40,
                            fit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                    children: imageData.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex",
                                    style: {
                                        marginTop: "2px"
                                    },
                                    children: (imageData === null || imageData === void 0 ? void 0 : imageData.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                                children: t("ss_builder_product_link_wrapped_label")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                        children: (imageData === null || imageData === void 0 ? void 0 : (ref1 = imageData.link_data) === null || ref1 === void 0 ? void 0 : ref1.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Story_StoryListItem = (StoryListItem);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Story/StoryNewImage/index.tsx
function StoryNewImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function StoryNewImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            StoryNewImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var StoryNewImage = function(props) {
    var callBackCancelImageSliderAddNew = props.callBackCancelImageSliderAddNew, handleSaveImageSlider = props.handleSaveImageSlider, imageEditData = props.imageEditData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "image-".concat((0,v4/* default */.Z)());
    var originUrlDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.origin_url) || null;
    var affiliateUrlDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.target_url) || null;
    var valueUrlImageDefault = imageEditData && imageEditData.image;
    var defaultTitle = imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.title;
    var hasAffiliateUrlDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.use_aff_url) ? !!((imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.use_aff_url) === 1) : true;
    var defaultLinkData = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.link_data) || {
        type: LinkInput/* LinkTypeEnum.WEB */.Z.WEB,
        value: originUrlDefault
    };
    var openInNewTabDefault = (imageEditData === null || imageEditData === void 0 ? void 0 : imageEditData.open_new_tab) || false;
    var ref = (0,react.useState)(valueUrlImageDefault), valueUrlImage = ref[0], setValueUrlImage = ref[1];
    var ref1 = (0,react.useState)(""), valueNameImage = ref1[0], setValueNameImage = ref1[1];
    var ref2 = (0,react.useState)(null), valueImageBase64 = ref2[0], setValueImageBase64 = ref2[1];
    var ref3 = (0,react.useState)([]), uploadedImageArr = ref3[0], setUploadedImageArr = ref3[1];
    var ref4 = (0,react.useState)(originUrlDefault), originUrl = ref4[0], setOriginUrl = ref4[1];
    var ref5 = (0,react.useState)(affiliateUrlDefault), affiliateUrl = ref5[0], setAffiliateUrl = ref5[1];
    var ref6 = (0,react.useState)(hasAffiliateUrlDefault), hasAffiliateUrl = ref6[0], setHasAffiliateUrl = ref6[1];
    var ref7 = (0,react.useState)(false), isValidUrl = ref7[0], setIsValidUrl = ref7[1];
    var ref8 = (0,react.useState)(false), isLoadingBtn = ref8[0], setIsLoadingBtn = ref8[1];
    var ref9 = (0,react.useState)(false), isDisableBtnSave = ref9[0], setIsDisableBtnSave = ref9[1];
    var ref10 = (0,react.useState)(defaultTitle), title = ref10[0], setTitle = ref10[1];
    var ref11 = (0,react.useState)(false), isValidFileFormat = ref11[0], setIsValidFileFormat = ref11[1];
    var ref12 = (0,react.useState)(false), isValidFileSize = ref12[0], setIsValidFileSize = ref12[1];
    var ref13 = (0,react.useState)(defaultLinkData), linkData1 = ref13[0], setLinkData = ref13[1];
    var ref14 = (0,react.useState)(false), isEcommerce = ref14[0], setIsEcommerce = ref14[1];
    var ref15 = (0,react.useState)(openInNewTabDefault), openNewTab = ref15[0], setOpenNewTab = ref15[1];
    var handleChangeOpenNewTab = function(data) {
        setOpenNewTab(data);
    };
    var checkEcommerce = function(data) {
        if (data) {
            try {
                var ecommerceOrSocial = new URL(data);
                setIsEcommerce((0,validator/* checkOpenNewTab */.lq)(ecommerceOrSocial));
            } catch (err) {
                console.log(err);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (linkData1 && linkData1.type == LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            checkEcommerce(linkData1.target_url);
        } else if (originUrl) checkEcommerce(originUrl);
    }, [
        originUrl,
        linkData1
    ]);
    var handleDeleteImage = function() {
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "#FF8F1F",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_image_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm-delete_image_label")
            }),
            confirmText: t("ss_builder_delete_image_label"),
            cancelText: t("ss_builder_close_panel"),
            onConfirm: function() {
                setValueUrlImage(null);
                setUploadedImageArr([]);
                es/* Toast.show */.FN.show({
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                        className: "text-center inline-block"
                    }),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_delete_image_successfully_label")
                    })
                });
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
        }
    };
    var handleSaveImage = function() {
        var defaultImageData = {
            uid: UID,
            sort_order: 1,
            enable: 1,
            use_aff_url: hasAffiliateUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
            image: valueImageBase64 || valueUrlImage,
            image_base64: valueImageBase64,
            title: title,
            origin_url: originUrl,
            target_url: affiliateUrl,
            name: valueNameImage,
            link_data: linkData1,
            open_new_tab: isEcommerce ? true : openNewTab
        };
        if (imageEditData) {
            handleSaveImageSlider(StoryNewImage_objectSpread({}, imageEditData, {
                use_aff_url: hasAffiliateUrl && linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB ? 1 : 2,
                image: valueImageBase64 || valueUrlImage,
                image_base64: valueImageBase64,
                title: title,
                origin_url: originUrl,
                target_url: affiliateUrl,
                link_data: linkData1,
                open_new_tab: isEcommerce ? true : openNewTab
            }));
        } else {
            handleSaveImageSlider(defaultImageData);
        }
        callBackCancelImageSliderAddNew();
        setValueUrlImage(null);
        setUploadedImageArr([]);
        setValueImageBase64(null);
    };
    var handleCancelImageSliderAddNew = function() {
        if (valueUrlImage && valueUrlImage !== valueUrlImageDefault || originUrl && originUrl !== originUrlDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || openNewTab !== openInNewTabDefault) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    callBackCancelImageSliderAddNew();
                    setValueUrlImage(null);
                    setUploadedImageArr([]);
                    setValueImageBase64(null);
                }
            });
        } else {
            callBackCancelImageSliderAddNew();
            setValueUrlImage(null);
            setUploadedImageArr([]);
            setValueImageBase64(null);
        }
    };
    var handleCheckAffiliateUrl = function(data) {
        setHasAffiliateUrl(data);
    };
    var onUpdateLinkData = function(linkData) {
        if (linkData.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB) {
            setOriginUrl(linkData.value);
        } else {
            setOriginUrl(null);
        }
        setLinkData(linkData);
    };
    var isSaveButtonEnable = (0,react.useMemo)(function() {
        return valueUrlImage && (originUrl || linkData1.value) && title && (valueUrlImage !== valueUrlImageDefault || originUrl !== originUrlDefault || typeof hasAffiliateUrl === "boolean" && hasAffiliateUrl !== hasAffiliateUrlDefault || JSON.stringify(linkData1) !== JSON.stringify(defaultLinkData) || title !== defaultTitle || openNewTab !== openInNewTabDefault) && !isValidUrl && !isDisableBtnSave;
    }, [
        valueUrlImage,
        valueUrlImageDefault,
        isValidUrl,
        hasAffiliateUrl,
        hasAffiliateUrlDefault,
        linkData1,
        defaultLinkData,
        originUrl,
        originUrlDefault,
        title,
        defaultTitle,
        isDisableBtnSave,
        openNewTab,
        openInNewTabDefault, 
    ]);
    (0,react.useEffect)(function() {
        setIsDisableBtnSave(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setIsLoadingBtn(isLoadingBtn);
    }, [
        isLoadingBtn
    ]);
    var onAffLoading = (0,react.useCallback)(function(isLoading) {
        setIsDisableBtnSave(isLoading);
        setIsLoadingBtn(isLoading);
    }, [
        setIsDisableBtnSave,
        setIsLoadingBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-[2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: title && title != "" ? title : t("ss_builder_story")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white pb-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                        title: t("ss_builder_image"),
                        isRequire: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                        valueUrlImage: valueUrlImage,
                        imageRatio: "1/1"
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                color: valueUrlImage ? "primary" : "default",
                                fill: "solid",
                                className: "",
                                onClick: valueUrlImage ? handleDeleteImage : function() {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: valueUrlImage ? "#FFFFFF" : "#CCCCCC"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleImageUrl,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, 160, 160, [], 2);
                                },
                                className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                value: uploadedImageArr,
                                // disableUpload={isDisableUploadBtn}
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    block: true,
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full grow",
                                    children: t("ss_builder_upload_button_label")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                        label: t("ss_builder_button_link_icon_origin_url_label"),
                        isRequire: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkInput/* default */.C, {
                            item: linkData1,
                            onChange: function(item) {
                                onUpdateLinkData(item);
                            },
                            onLoading: onAffLoading,
                            onError: function(errorMessage) {
                                setIsValidUrl(!!errorMessage);
                            }
                        })
                    }),
                    linkData1.type === LinkInput/* LinkTypeEnum.WEB */.Z.WEB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                        checked: typeof hasAffiliateUrl !== "boolean" ? true : hasAffiliateUrl,
                                        onChange: handleCheckAffiliateUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: t("ss_builder_use_ecomobi_tracking_link")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                        content: t("ss_builder_use_affiliate_link_description"),
                                        placement: "top-start",
                                        mode: "dark",
                                        trigger: "click",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                            className: "ml-1 w-[14px] h-[14px]",
                                            onClick: function() {},
                                            fillColor: "#1890FF"
                                        })
                                    })
                                ]
                            }),
                            !isEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-center items-center leading-[22px] gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                                checked: !!openNewTab,
                                                onChange: handleChangeOpenNewTab,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-left",
                                                    children: t("ss_builder_open_new_tab_label")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                content: t("ss_builder_open_new_tab_description"),
                                                placement: "top-start",
                                                mode: "dark",
                                                trigger: "click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                                    className: "ml-1 w-[14px] h-[14px]",
                                                    onClick: function() {},
                                                    fillColor: "#1890FF"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitle/* default */.Z, {
                                title: t("ss_builder_title"),
                                isRequire: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                type: "text",
                                value: title,
                                placeholder: t("ss_builder_story_title_place_holder"),
                                onChange: function(value) {
                                    setTitle(value);
                                },
                                maxLength: 25
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-1 text-gray-500 text-sm text-right",
                                children: [
                                    title ? title.length : 0,
                                    "/25"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelImageSliderAddNew,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: !isSaveButtonEnable,
                            color: "primary",
                            onClick: handleSaveImage,
                            loading: isLoadingBtn,
                            children: t("ss_builder_editor_btn-save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Story_StoryNewImage = (StoryNewImage);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Story/StoryListItem/StoryItemSelectMode.tsx








var StoryItemSelectMode = function(props) {
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var index = props.index, imageData = props.imageData;
    var isEnable = !!(imageData && imageData.enable === 1);
    var linkDatavalue = imageData.origin_url || (imageData === null || imageData === void 0 ? void 0 : (ref = imageData.link_data) === null || ref === void 0 ? void 0 : ref.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex items-center gap-[6px] flex-row", !isEnable && "opacity-40"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                src: imageData.image,
                width: 40,
                height: 40,
                fit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                        children: imageData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex",
                        style: {
                            marginTop: "2px"
                        },
                        children: (imageData === null || imageData === void 0 ? void 0 : imageData.use_aff_url) === 1 && linkDatavalue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TickIcon */.Ye, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-1 text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                                    children: t("ss_builder_product_link_wrapped_label")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[12px] text-[#8C8C8C] leading-4 font-normal text-ellipsis whitespace-nowrap overflow-hidden",
                            children: (imageData === null || imageData === void 0 ? void 0 : (ref1 = imageData.link_data) === null || ref1 === void 0 ? void 0 : ref1.type) !== LinkInput/* LinkTypeEnum.SERVICE */.Z.SERVICE ? linkDatavalue : t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(linkDatavalue))
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryListItem_StoryItemSelectMode = (StoryItemSelectMode);

;// CONCATENATED MODULE: ./src/features/block/block-editor/Story/index.tsx
function Story_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Story_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Story_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Story_arrayLikeToArray(arr);
}
function Story_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Story_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Story_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Story_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Story_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Story_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Story_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Story_slicedToArray(arr, i) {
    return Story_arrayWithHoles(arr) || Story_iterableToArrayLimit(arr, i) || Story_unsupportedIterableToArray(arr, i) || Story_nonIterableRest();
}
function Story_toConsumableArray(arr) {
    return Story_arrayWithoutHoles(arr) || Story_iterableToArray(arr) || Story_unsupportedIterableToArray(arr) || Story_nonIterableSpread();
}
function Story_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Story_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Story_arrayLikeToArray(o, minLen);
}























var Story_IMAGE_MAX = 20;
var Story_BLOCK_HEADING_MAXIMUM = 50;
var Story_BLOCK_DESCRIPTION_MAXIMUM = 250;
var StoryComponent = function(props) {
    var ref15, ref1, ref2, ref3, ref4;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData, setShowFooterBlockEdit = props.setShowFooterBlockEdit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "story-block-".concat((0,v4/* default */.Z)());
    var defaultValueEditStory = defaultBlockData && defaultBlockData.uid ? defaultBlockData : null;
    var titleBlockDefault = "Spotlight";
    var imageArrDefault = (defaultValueEditStory === null || defaultValueEditStory === void 0 ? void 0 : (ref15 = defaultValueEditStory.content_attributes) === null || ref15 === void 0 ? void 0 : ref15.items) || [];
    var valueHeadingBlockDefault = (defaultValueEditStory === null || defaultValueEditStory === void 0 ? void 0 : (ref1 = defaultValueEditStory.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.block_heading) || "";
    var valueDescriptionBlockDefault = (defaultValueEditStory === null || defaultValueEditStory === void 0 ? void 0 : (ref2 = defaultValueEditStory.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_description) || "";
    var defaultTypeOfImage = (defaultValueEditStory === null || defaultValueEditStory === void 0 ? void 0 : (ref3 = defaultValueEditStory.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.type_of_image) || configs_const/* ROUND_PHOTO */.xY;
    var defaultSizeOfImage = (defaultValueEditStory === null || defaultValueEditStory === void 0 ? void 0 : (ref4 = defaultValueEditStory.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.size_of_image) || configs_const/* MIDDLE */.uo;
    var ref5 = (0,react.useState)(false), isOpenAddNewImageStory = ref5[0], setIsOpenAddNewImageStory = ref5[1];
    var ref6 = (0,react.useState)(imageArrDefault), imageArr = ref6[0], setImageArr = ref6[1];
    var ref7 = (0,react.useState)(null), imageEditData = ref7[0], setImageEditData = ref7[1];
    var ref8 = (0,react.useState)(null), indexImageEdit = ref8[0], setIndexImageEdit = ref8[1];
    var ref9 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref9[0], setValueHeadingBlock = ref9[1];
    var ref10 = (0,react.useState)(valueDescriptionBlockDefault), valueDescriptionBlock = ref10[0], setValueDescriptionBlock = ref10[1];
    var ref11 = (0,react.useState)({}), placeholderProps1 = ref11[0], setPlaceholderProps = ref11[1];
    var ref12 = (0,react.useState)(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG), mode = ref12[0], setMode = ref12[1];
    var swichToDragMode = function() {
        setMode(config_interface/* ITEMS_MODE.DRAG */.yo.DRAG);
        setShowFooterBlockEdit(true);
    };
    var switchToSelectItemsMode = function() {
        setMode(config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS);
        setShowFooterBlockEdit(false);
    };
    var ref13 = (0,react.useState)(defaultTypeOfImage), typeOfImage = ref13[0], setTypeOfImage = ref13[1];
    var ref14 = (0,react.useState)(defaultSizeOfImage), sizeOfImage = ref14[0], setSizeOfImage = ref14[1];
    var option = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/spotlight-layout/Spotlight-style-1.svg"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_round_photo_label")
            }),
            value: configs_const/* ROUND_PHOTO */.xY
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/spotlight-layout/Spotlight-style-2.svg"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_square_photo_label")
            }),
            value: configs_const/* SQUARE_PHOTO */.C0
        }, 
    ];
    var sizeOptions = [
        {
            label: t("ss_builder_button_link_small_size_label"),
            value: configs_const/* SMAll */.NQ
        },
        {
            label: t("ss_builder_button_link_middle_size_label"),
            value: configs_const/* MIDDLE */.uo
        },
        {
            label: t("ss_builder_button_link_large_size_label"),
            value: configs_const/* BIG */.JE
        }, 
    ];
    var imageSortOrder = (0,react.useMemo)(function() {
        return orderBy_default()(imageArr, [
            "sort_order"
        ], [
            "asc"
        ]);
    }, [
        imageArr
    ]);
    var imageEnable = (0,react.useMemo)(function() {
        return imageArr.filter(function(item) {
            return item.enable === 1;
        });
    }, [
        imageArr
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if ((imageSortOrder === null || imageSortOrder === void 0 ? void 0 : imageSortOrder.length) > 0 && (JSON.stringify(imageArr) !== JSON.stringify(imageArrDefault) || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || typeOfImage !== defaultTypeOfImage || sizeOfImage !== defaultSizeOfImage) && imageEnable.length > 0) {
            return false;
        } else return true;
    }, [
        imageSortOrder,
        imageArr,
        imageArrDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        imageEnable,
        typeOfImage,
        defaultTypeOfImage,
        sizeOfImage,
        defaultSizeOfImage, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(imageArr) !== JSON.stringify(imageArrDefault) || valueHeadingBlock !== valueHeadingBlockDefault || valueDescriptionBlock !== valueDescriptionBlockDefault || typeOfImage !== defaultTypeOfImage || sizeOfImage !== defaultSizeOfImage) {
            return true;
        } else return false;
    }, [
        imageArr,
        imageArrDefault,
        valueHeadingBlock,
        valueDescriptionBlock,
        valueHeadingBlockDefault,
        valueDescriptionBlockDefault,
        typeOfImage,
        defaultTypeOfImage,
        sizeOfImage,
        defaultSizeOfImage, 
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultStoryData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.STORY,
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSortOrder,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    type_of_image: typeOfImage,
                    size_of_image: sizeOfImage
                },
                style_attributes: {}
            };
            onUpdateData(defaultStoryData);
        } else {
            onUpdateData(Story_objectSpread({}, block, {
                uid: (block === null || block === void 0 ? void 0 : block.uid) || UID,
                title: titleBlockDefault,
                content_attributes: {
                    items: imageSortOrder,
                    block_heading: valueHeadingBlock,
                    block_description: valueDescriptionBlock,
                    type_of_image: typeOfImage,
                    size_of_image: sizeOfImage
                },
                style_attributes: {}
            }));
        }
    }, [
        imageSortOrder,
        valueHeadingBlock,
        valueDescriptionBlock,
        typeOfImage,
        sizeOfImage, 
    ]);
    var imageRate = (0,react.useMemo)(function() {
        return imageSortOrder && "".concat(imageSortOrder.length, "/").concat(Story_IMAGE_MAX);
    }, [
        imageSortOrder
    ]);
    var handleSaveStory = function(data) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        if (Array.isArray(imageClone)) {
            if (imageEditData) {
                var indexEditItems = imageClone.findIndex(function(x) {
                    return x.uid === imageEditData.uid;
                });
                imageClone[indexEditItems] = data;
            } else {
                if (imageClone.length === 0) {
                    imageClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = imageClone.map(function(x) {
                        return x.sort_order;
                    });
                    imageClone.push(Story_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, Story_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            setImageArr(imageClone);
            var index = imageClone === null || imageClone === void 0 ? void 0 : imageClone.findIndex(function(x) {
                return x.uid === (data === null || data === void 0 ? void 0 : data.uid);
            });
            !imageEditData && (0,block_libs/* scrollToNewItem */.i)("blocks-".concat(data === null || data === void 0 ? void 0 : data.uid, "-").concat(index));
        }
    };
    var handleOpenAddImageSlider = function() {
        setIsOpenAddNewImageStory(true);
        setImageEditData(null);
        setIndexImageEdit(null);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(imageSortOrder);
        var ref = Story_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedImageList = result.map(function(ele, idx) {
            return Story_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedImageList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        var startIndex = result && result.source && result.source.index;
        var endIndex = result && result.destination && result.destination.index;
        if (!result.destination || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        setImageArr(itemsOrder);
    };
    var onDragUpdate = function(event) {
        if (!event.destination) {
            return;
        }
        var placeholderProps = (0,lib/* getPlaceholderProps */.UY)(event);
        setPlaceholderProps(placeholderProps);
    };
    var onRemoveItem = function(index) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        var newImageItems = imageClone && Array.isArray(imageClone) && imageClone.filter(function(ele, idx) {
            return idx !== index;
        });
        setImageArr(newImageItems);
    };
    var onDisableEnableImage = function(index, imageStatus) {
        var imageClone = cloneDeep_default()(imageSortOrder);
        var newImageItems = imageClone && Array.isArray(imageClone) && imageClone.map(function(ele, idx) {
            return idx === index ? Story_objectSpread({}, ele, {
                enable: imageStatus
            }) : ele;
        });
        setImageArr(newImageItems);
    };
    var handleOpenEditImage = function(imageData, index) {
        setIsOpenAddNewImageStory(true);
        setImageEditData(imageData);
        setIndexImageEdit(index);
    };
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Story_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= Story_BLOCK_DESCRIPTION_MAXIMUM) {
            setValueDescriptionBlock(val);
        }
    };
    var handleSelectImages = function(items) {
        setImageArr(items);
    };
    var renderImagesOnDragMode = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                    previousStickyElementId: "block-story-editor-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between px-3 pt-4 pb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[15px] text-[#666666]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-red-600",
                                                children: "*"
                                            }),
                                            t("ss_builder_list_label")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-grow justify-end gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                            size: "small",
                                            fill: "solid",
                                            color: "primary",
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "3px 12px 3px 12px"
                                            },
                                            onClick: handleOpenAddImageSlider,
                                            disabled: imageSortOrder.length === Story_IMAGE_MAX,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                    className: "w-[15px] h-[15px]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: t("ss_builder_add_new_label")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: imageRate
                                                })
                                            ]
                                        }),
                                        imageSortOrder.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            onClick: switchToSelectItemsMode,
                                            color: "primary",
                                            fill: "outline",
                                            size: "small",
                                            children: t("ss_builder_select_label")
                                        })
                                    ]
                                })
                            ]
                        }),
                        imageEnable.length === 0 && imageArr.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-3 pb-4 text-[13px] font-normal leading-[17px]",
                            style: {
                                color: "var(--adm-color-danger)"
                            },
                            children: t("ss_builder_need_to_display_at_least_one_spotlight")
                        })
                    ]
                }),
                imageSortOrder && imageSortOrder.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                        onDragEnd: onDragEnd,
                        onDragUpdate: onDragUpdate,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                            droppableId: "blocks-".concat(BLOCK_TYPE.STORY),
                            children: function(provided1, snapshot1) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", Story_objectSpread({}, provided1.droppableProps, {
                                    ref: provided1.innerRef,
                                    className: "relative",
                                    children: [
                                        imageSortOrder && imageSortOrder.length > 0 && imageSortOrder.map(function(ele, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                draggableId: "blocks-".concat(ele.uid, "-").concat(index),
                                                index: index,
                                                children: function(provided, snapshot) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", Story_objectSpread({
                                                        ref: provided.innerRef
                                                    }, provided.draggableProps, provided.dragHandleProps, {
                                                        className: classnames_default()("mt-2", snapshot.isDragging && "adm-item-custom"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Story_StoryListItem, {
                                                            index: index,
                                                            imageData: ele,
                                                            onRemoveItem: onRemoveItem,
                                                            onDisableEnableImage: onDisableEnableImage,
                                                            callbackOpenEditImage: handleOpenEditImage
                                                        })
                                                    }));
                                                }
                                            }, "blocks-".concat(ele.uid, "-").concat(index));
                                        }),
                                        provided1.placeholder,
                                        !isEmpty_default()(placeholderProps1) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderCustomDragging/* default */.Z, {
                                            placeholderProps: placeholderProps1,
                                            content: t("ss_builder_placeholder_dragging_content"),
                                            style: {
                                                backgroundColor: "rgba(230, 247, 255, 0.75)",
                                                border: "1px dashed #1890FF",
                                                borderRadius: "4px",
                                                color: "#1890FF"
                                            }
                                        })
                                    ]
                                }));
                            }
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StoryIcon */.J0, {
                                className: "align-middle w-8 h-8"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#333333] text-lg leading-6",
                            children: t("ss_builder_spotlight_list_empty_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#8C8C8C] text-xs leading-4",
                            children: t("ss_builder_spotlight_list_empty_content")
                        })
                    ]
                })
            ]
        });
    };
    var renderImagesOnSelectItemsMode = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWithCheckbox/* default */.Z, {
            propertyIndex: "uid",
            onCancel: swichToDragMode,
            item: StoryListItem_StoryItemSelectMode,
            onChange: handleSelectImages,
            defaultItems: imageSortOrder.map(function(e) {
                return Story_objectSpread({}, e, {
                    imageData: e
                });
            }),
            header: {
                title: t("ss_builder_list_label"),
                sticky: true
            },
            footer: {
                countTitle: t("ss_builder_filter_select_multi_items_spotlight_count")
            },
            blockType: block.block_type
        });
    };
    var handleSelectType = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setTypeOfImage(value);
        }
    };
    var handleSelectSize = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setSizeOfImage(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_heading_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_block_heading_placeholder"),
                                onChange: handleChangeBlockHeading,
                                value: valueHeadingBlock,
                                maxLength: Story_BLOCK_HEADING_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(Story_BLOCK_HEADING_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-[13px] text-[#666666]",
                                children: t("ss_builder_block_description_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                placeholder: t("ss_builder_block_description_placeholder"),
                                onChange: handleChangeBlockDescription,
                                value: valueDescriptionBlock,
                                maxLength: Story_BLOCK_DESCRIPTION_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueDescriptionBlock ? valueDescriptionBlock.length : 0, "/").concat(Story_BLOCK_DESCRIPTION_MAXIMUM)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " bg-white mt-3 px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_shape_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                        options: option,
                        value: [
                            typeOfImage
                        ],
                        onChange: handleSelectType,
                        columns: 3,
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_button_link_size_selection_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                        options: sizeOptions,
                        value: [
                            sizeOfImage
                        ],
                        onChange: handleSelectSize,
                        columns: 3,
                        style: {
                            "--border": "solid transparent 1px",
                            "--checked-border": "solid var(--adm-color-primary) 1px"
                        }
                    })
                ]
            }),
            mode === config_interface/* ITEMS_MODE.DRAG */.yo.DRAG && renderImagesOnDragMode(),
            mode === config_interface/* ITEMS_MODE.SELECT_ITEMS */.yo.SELECT_ITEMS && renderImagesOnSelectItemsMode(),
            isOpenAddNewImageStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewImageStory,
                onMaskClick: function() {
                    return setIsOpenAddNewImageStory(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Story_StoryNewImage, {
                    callBackCancelImageSliderAddNew: function() {
                        return setIsOpenAddNewImageStory(false);
                    },
                    handleSaveImageSlider: handleSaveStory,
                    imageEditData: imageEditData,
                    indexImageEdit: indexImageEdit
                })
            })
        ]
    });
};
/* harmony default export */ var Story = (StoryComponent);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(28860);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/TabManagement/NewTabComponent/index.tsx










var TAB_NAME_MAXIMUM = 25;
var NewTabComponent = function(props) {
    var cancelTabFloatingPanel = props.cancelTabFloatingPanel, onConfirmAddNewTab = props.onConfirmAddNewTab, tabValueDefault = props.tabValueDefault;
    var UID = "tab-".concat((0,v4/* default */.Z)());
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var inputRef = (0,react.useRef)(null);
    var valueNameTabDefault = (0,react.useMemo)(function() {
        return tabValueDefault === null || tabValueDefault === void 0 ? void 0 : tabValueDefault.name;
    }, [
        tabValueDefault
    ]);
    var ref;
    var valueIconDefault = (0,react.useMemo)(function() {
        return (ref = tabValueDefault === null || tabValueDefault === void 0 ? void 0 : tabValueDefault.icon) !== null && ref !== void 0 ? ref : configs_const/* TAB_ICON_DEFAULT */.FL;
    }, [
        tabValueDefault
    ]);
    var valueIconUrlDefault = (0,react.useMemo)(function() {
        return tabValueDefault === null || tabValueDefault === void 0 ? void 0 : tabValueDefault.icon_url;
    }, [
        tabValueDefault
    ]);
    var ref1 = (0,react.useState)(valueNameTabDefault), valueNameTab = ref1[0], setValueNameTab = ref1[1];
    var ref2 = (0,react.useState)(valueIconDefault), valueIcon1 = ref2[0], setValueIcon = ref2[1];
    var ref3 = (0,react.useState)(valueIconUrlDefault), valueIconUrl = ref3[0], setValueIconUrl = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenSelectedTabIcon = ref4[0], setIsOpenSelectedTabIcon = ref4[1];
    (0,react.useEffect)(function() {
        setValueNameTab(valueNameTabDefault);
    }, [
        valueNameTabDefault
    ]);
    (0,react.useEffect)(function() {
        setValueIcon(valueIconDefault);
    }, [
        valueIconDefault
    ]);
    (0,react.useEffect)(function() {
        setValueIconUrl(valueIconUrlDefault);
    }, [
        valueIconUrlDefault
    ]);
    var handleConfirmAddNewTab = function() {
        var defaultTabData = {
            uid: UID,
            name: valueNameTab,
            icon: valueIcon1,
            sort_order: 1,
            block_list: [],
            enable: 1,
            icon_url: valueIconUrl
        };
        onConfirmAddNewTab(defaultTabData);
        handleCancelTabFloatingPanel();
    };
    (0,react.useEffect)(function() {
        inputRef.current.focus();
    }, [
        inputRef
    ]);
    var handleCancelTabFloatingPanel = function() {
        cancelTabFloatingPanel();
    };
    var handleOpenSelectedTabIcon = function() {
        setIsOpenSelectedTabIcon(true);
    };
    var handleConfirmListIcon = function(data) {
        var valueIcon = data.valueIcon, valueUrlIcon = data.valueUrlIcon;
        setValueIcon(valueIcon);
        setValueIconUrl(valueUrlIcon);
    };
    var isEnableConfirmAddNewTab = (0,react.useMemo)(function() {
        var valueNameTabTrim = valueNameTab && valueNameTab.trim();
        if (valueNameTabTrim && valueNameTabTrim.length > 0) {
            return true;
        }
        return false;
    }, [
        valueNameTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-3 border-t-[1px] border-t-[#EEEEEE]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_name_tab_input_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueNameTab || "",
                                onChange: function(val) {
                                    if (val.length <= TAB_NAME_MAXIMUM) {
                                        setValueNameTab(val);
                                    }
                                },
                                ref: inputRef,
                                maxLength: TAB_NAME_MAXIMUM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueNameTab ? valueNameTab.length : 0, "/").concat(TAB_NAME_MAXIMUM)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    marginTop: "12px",
                                    marginBottom: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("ss_builder_icon_tab_title")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        style: {
                                            padding: valueIcon1 ? "7px 10px 1px 10px" : "",
                                            backgroundColor: "#F0F0F0",
                                            border: "none"
                                        },
                                        onClick: handleOpenSelectedTabIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                            iconName: valueIcon1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row items-center gap-2 grow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            block: true,
                                            size: "middle",
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "5px"
                                            },
                                            onClick: handleOpenSelectedTabIcon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[17px] leading-6",
                                                children: t("ss_builder_panel_add_icon_tab_title")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                        onConfirm: isEnableConfirmAddNewTab ? handleConfirmAddNewTab : function() {},
                        isDisable: !isEnableConfirmAddNewTab
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSelectedTabIcon,
                onMaskClick: function() {
                    return setIsOpenSelectedTabIcon(false);
                },
                title: t("ss_builder_panel_add_icon_tab_title"),
                onClose: function() {
                    return setIsOpenSelectedTabIcon(false);
                },
                classNameBody: "h-[80vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListIconBuilder, {
                    callbackCancelListIcon: function() {
                        return setIsOpenSelectedTabIcon(false);
                    },
                    callbackConfirmListIcon: handleConfirmListIcon,
                    defaultNameIcon: valueIcon1
                })
            })
        ]
    });
};
/* harmony default export */ var TabManagement_NewTabComponent = (NewTabComponent);

// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/TabManagement/index.tsx
function TabManagement_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TabManagement_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TabManagement_arrayLikeToArray(arr);
}
function TabManagement_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabManagement_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TabManagement_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TabManagement_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabManagement_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TabManagement_toConsumableArray(arr) {
    return TabManagement_arrayWithoutHoles(arr) || TabManagement_iterableToArray(arr) || TabManagement_unsupportedIterableToArray(arr) || TabManagement_nonIterableSpread();
}
function TabManagement_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TabManagement_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TabManagement_arrayLikeToArray(o, minLen);
}











var TAB_QUANTITY_MAX = 4;
var ListTabsComponent = dynamic_default()(__webpack_require__.e(/* import() */ 948).then(__webpack_require__.bind(__webpack_require__, 14948)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14948)
            ];
        }
    }
});
function DragListComponent(props) {
    var ref = (0,react.useState)(false), winReady = ref[0], setwinReady = ref[1];
    (0,react.useEffect)(function() {
        setwinReady(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: winReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTabsComponent, TabManagement_objectSpread({}, props)) : null
    });
}
var TabManagement = function(props) {
    var onUpdateListTabsData = props.onUpdateListTabsData, listTabsDataDefault = props.listTabsDataDefault;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenTabFloatingPanel = ref[0], setIsOpenTabFloatingPanel = ref[1];
    var ref1 = (0,react.useState)(null), tabValueEdit = ref1[0], setTabValueEdit = ref1[1];
    var blockRate = (0,react.useMemo)(function() {
        return "".concat(listTabsDataDefault.length, "/").concat(TAB_QUANTITY_MAX);
    }, [
        listTabsDataDefault
    ]);
    var isDisableBtn = (0,react.useMemo)(function() {
        return listTabsDataDefault.length === TAB_QUANTITY_MAX;
    }, [
        listTabsDataDefault
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleOpenFloatingPanel = function() {
        setIsOpenTabFloatingPanel(true);
        setTabValueEdit(null);
    };
    var handleConfirmAddNewTab = function(data) {
        var listTabsDataDefaultClone = cloneDeep_default()(listTabsDataDefault);
        if (!tabValueEdit) {
            //Add new tab
            if (Array.isArray(listTabsDataDefaultClone)) {
                if (listTabsDataDefaultClone.length === 0) {
                    listTabsDataDefaultClone.push(data);
                } else {
                    var _Math;
                    var sortIdArr = listTabsDataDefaultClone.map(function(x) {
                        return x.sort_order;
                    });
                    listTabsDataDefaultClone.push(TabManagement_objectSpread({}, data, {
                        sort_order: (_Math = Math).max.apply(_Math, TabManagement_toConsumableArray(sortIdArr)) + 1
                    }));
                }
            }
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.TAB */.Bt.TAB, "Tab_Add_Tab".concat(listTabsDataDefaultClone.length), "Tab ".concat(listTabsDataDefaultClone.length), ga_events/* ACTION_CONFIG.ADD */.AN.ADD);
            onUpdateListTabsData(listTabsDataDefaultClone);
            es/* Toast.show */.FN.show({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                    className: "text-center inline-block w-[30px] h-[30px]",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_add_new_tab_successfully_label")
                })
            });
        } else {
            //Edit old tab
            var newListTabsData = listTabsDataDefaultClone === null || listTabsDataDefaultClone === void 0 ? void 0 : listTabsDataDefaultClone.map(function(ele) {
                return (ele === null || ele === void 0 ? void 0 : ele.uid) === (tabValueEdit === null || tabValueEdit === void 0 ? void 0 : tabValueEdit.uid) ? TabManagement_objectSpread({}, tabValueEdit, {
                    icon: data === null || data === void 0 ? void 0 : data.icon,
                    icon_url: data === null || data === void 0 ? void 0 : data.icon_url,
                    name: data === null || data === void 0 ? void 0 : data.name
                }) : ele;
            });
            var index = listTabsDataDefaultClone.findIndex(function(item) {
                return (item === null || item === void 0 ? void 0 : item.uid) === (tabValueEdit === null || tabValueEdit === void 0 ? void 0 : tabValueEdit.uid);
            }) + 1;
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.TAB */.Bt.TAB, "Tab_Rename_Tab".concat(index), "Tab ".concat(index), ga_events/* ACTION_CONFIG.RENAME */.AN.RENAME);
            onUpdateListTabsData(newListTabsData);
            es/* Toast.show */.FN.show({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                    className: "text-center inline-block w-[30px] h-[30px]",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_edit_tab_successfully_label")
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: "20px 12px 24px"
                },
                className: "tab-component-class",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] text-[#666666] mb-1",
                                    children: t("ss_builder_manage_tab_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-grow justify-end gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                        size: "small",
                                        fill: "solid",
                                        color: "primary",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "3px 12px 3px 12px"
                                        },
                                        onClick: handleOpenFloatingPanel,
                                        disabled: isDisableBtn,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                className: "w-[15px] h-[15px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_add_new_label")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: blockRate || ""
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DragListComponent, {
                            tabListBody: listTabsDataDefault,
                            callbackOpenEditTab: function(data) {
                                setIsOpenTabFloatingPanel(true);
                                setTabValueEdit(data);
                            },
                            onUpdateListTabsData: onUpdateListTabsData
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenTabFloatingPanel,
                onMaskClick: function() {
                    return setIsOpenTabFloatingPanel(false);
                },
                title: t("ss_builder_panel_add_new_tab_title"),
                onClose: function() {
                    return setIsOpenTabFloatingPanel(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabManagement_NewTabComponent, {
                    cancelTabFloatingPanel: function() {
                        return setIsOpenTabFloatingPanel(false);
                    },
                    onConfirmAddNewTab: handleConfirmAddNewTab,
                    tabValueDefault: tabValueEdit
                })
            })
        ]
    });
};
/* harmony default export */ var TabMenu_TabManagement = (TabManagement);

;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/TabLayouts/index.tsx






var TabLayouts = function(props) {
    var tabLayoutValue = props.tabLayoutValue, onUpdateTabLayoutValue = props.onUpdateTabLayoutValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var tabLayoutOptions = (0,react.useMemo)(function() {
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/tab-text-right-layout.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_tab_layout_1")
                }),
                value: configs_const/* TAB_LAYOUT.TEXT_RIGHT */.Ic.TEXT_RIGHT
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/layout-types/tab-text-under-layout.png",
                    height: 96,
                    width: 96,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_tab_layout_2")
                }),
                value: configs_const/* TAB_LAYOUT.TEXT_UNDER */.Ic.TEXT_UNDER
            }, 
        ];
    }, []);
    var handleSelectTabLayout = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            onUpdateTabLayoutValue(valueRatio);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#666666] mb-1",
                children: t("ss_builder_card_layout_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                className: "selector-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                    options: tabLayoutOptions,
                    value: [
                        tabLayoutValue
                    ],
                    onChange: handleSelectTabLayout,
                    style: {
                        "--border": "solid transparent 1px",
                        "--checked-border": "solid var(--adm-color-primary) 1px",
                        "--checked-color": "#fff"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var TabMenu_TabLayouts = (TabLayouts);

;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/TabWidthDisplay/index.tsx





var TabWidthDisplay = function(props) {
    var tabWidthDisplayValue = props.tabWidthDisplayValue, onUpdateTabWidthDisplayValue = props.onUpdateTabWidthDisplayValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var tabWidthDisplayOptions = (0,react.useMemo)(function() {
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/display-styles/width-tab-auto.png",
                    height: 77,
                    width: 77,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_width_tab_type_1")
                }),
                value: configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    fit: "cover",
                    src: "https://image.passio.eco/page-builder/page-builder/display-styles/width-tab-equal.png",
                    height: 77,
                    width: 77,
                    className: "m-auto"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: t("ss_builder_width_tab_type_2")
                }),
                value: configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL
            }, 
        ];
    }, []);
    var handleSelectTabWidthDisplay = function(arr) {
        if (arr && arr.length) {
            var valueRatio = arr[0];
            onUpdateTabWidthDisplayValue(valueRatio);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#666666] mb-1",
                children: t("ss_builder_width_tab_setting_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: tabWidthDisplayOptions,
                value: [
                    tabWidthDisplayValue
                ],
                onChange: handleSelectTabWidthDisplay,
                columns: 3,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    "--checked-color": "#fff"
                }
            })
        ]
    });
};
/* harmony default export */ var TabMenu_TabWidthDisplay = (TabWidthDisplay);

;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/TabTemplateSelection/index.tsx






var TabTemplateSelection = function(props) {
    var tabTemplateDefault = props.tabTemplateDefault, onUpdateTabTemplate = props.onUpdateTabTemplate, onCancelTabTemplate = props.onCancelTabTemplate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(tabTemplateDefault), tabTemplate = ref[0], setTabTemplate = ref[1];
    (0,react.useEffect)(function() {
        if (tabTemplateDefault) setTabTemplate(tabTemplateDefault);
    }, [
        tabTemplateDefault
    ]);
    var tabLayoutsOptions = configs_const/* TAB_TEMPLATE_LIST.map */.h4.map(function(ele) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: ele.image
            }),
            value: ele.value
        };
    });
    var handleSelectTabTemplate = function(arr) {
        if (arr && arr.length) {
            var value = arr[0];
            setTabTemplate(value);
        }
    };
    var handleSaveTabTemplate = function() {
        onUpdateTabTemplate(tabTemplate);
        onCancelTabTemplate();
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (!tabTemplate || tabTemplate === tabTemplateDefault) {
            return true;
        } else return false;
    }, [
        tabTemplate,
        tabTemplateDefault
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_sample_selection_label")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: tabLayoutsOptions,
                value: [
                    tabTemplate
                ],
                onChange: handleSelectTabTemplate,
                columns: 1,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    "--checked-color": "#fff",
                    "--color": "#fff",
                    margin: "16px 12px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed bottom-0 p-2 flex max-width-content-class w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: onCancelTabTemplate,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            disabled: isDisableBtnSave,
                            color: "primary",
                            onClick: handleSaveTabTemplate,
                            children: t("ss_builder_done_panel")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TabMenu_TabTemplateSelection = (TabTemplateSelection);

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/components/Icons/index.tsx
var components_Icons = __webpack_require__(14562);
// EXTERNAL MODULE: ./src/features/share/components/DisplayColor/index.tsx
var DisplayColor = __webpack_require__(26340);
// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/ColorPicker/index.tsx + 218 modules
var ColorPicker = __webpack_require__(76034);
;// CONCATENATED MODULE: ./src/features/block/block-editor/TabMenu/index.tsx
function TabMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var TabMenu = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var block = props.block, onUpdateData = props.onUpdateData, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var positionState = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.positions;
    });
    var positionStateBody = positionState.find(function(x) {
        return x.slug === "body";
    });
    var tabListBody = positionStateBody && positionStateBody.block_list && positionStateBody.block_list[0] && positionStateBody.block_list[0].content_attributes && positionStateBody.block_list[0].content_attributes.tabs;
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueTabMenu = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var titleBlockDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : defaultValueTabMenu.title) || "Tab Menu";
    var styleTabMenuDisplayDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref = defaultValueTabMenu.style_attributes) === null || ref === void 0 ? void 0 : ref.display_style) || configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON;
    var styleGhimTabMenuDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref1 = defaultValueTabMenu.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.ghim_style) || configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM;
    var positionTabMenuDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref2 = defaultValueTabMenu.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.position_style) || configs_const/* TAB_POSITION.TOP */.Fe.TOP;
    var tabLayoutDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref3 = defaultValueTabMenu.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.tab_layout) || configs_const/* TAB_LAYOUT.TEXT_RIGHT */.Ic.TEXT_RIGHT;
    var tabWidthDisplayDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref4 = defaultValueTabMenu.style_attributes) === null || ref4 === void 0 ? void 0 : ref4.tab_width_display) || configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO;
    var tabTemplateDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref5 = defaultValueTabMenu.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.tab_template) || configs_const/* TAB_TEMPLATE.TEMPLATE_1 */.um.TEMPLATE_1;
    var tabShadowEnableDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref6 = defaultValueTabMenu.style_attributes) === null || ref6 === void 0 ? void 0 : ref6.tab_shadow_enable) || configs_const/* TAB_SETTING.SHADOW_ENABLE */.bp.SHADOW_ENABLE;
    var tabShadowColorDefault = (defaultValueTabMenu === null || defaultValueTabMenu === void 0 ? void 0 : (ref7 = defaultValueTabMenu.style_attributes) === null || ref7 === void 0 ? void 0 : ref7.tab_shadow_color) || configs_const/* TAB_SETTING.SHADOW_COLOR */.bp.SHADOW_COLOR;
    var listTabsDataDefault = tabListBody;
    var ref9 = (0,react.useState)(titleBlockDefault), valueTitleInput = ref9[0], setValueTilteInput = ref9[1];
    var ref10 = (0,react.useState)(titleBlockDefault), valueInput = ref10[0], setValueInput = ref10[1];
    var ref11 = (0,react.useState)(styleTabMenuDisplayDefault), styleTabMenuDisplay = ref11[0], setStyleTabMenuDisplay = ref11[1];
    var ref12 = (0,react.useState)(styleGhimTabMenuDefault), styleGhimTabMenu = ref12[0], setStyleGhimTabMenu = ref12[1];
    var ref13 = (0,react.useState)(positionTabMenuDefault), positionTabMenu = ref13[0], setPositionTabMenu = ref13[1];
    var ref14;
    var ref15 = (0,react.useState)((ref14 = block === null || block === void 0 ? void 0 : block.enable) !== null && ref14 !== void 0 ? ref14 : configs_const/* ENABLE_BLOCK */.C5), isEnable = ref15[0], setIsEnable = ref15[1];
    var ref16 = (0,react.useState)(listTabsDataDefault), listTabsData = ref16[0], setListTabsData = ref16[1];
    var ref17 = (0,react.useState)(tabLayoutDefault), tabLayout = ref17[0], setTabLayout = ref17[1];
    var ref18 = (0,react.useState)(tabWidthDisplayDefault), tabWidthDisplay = ref18[0], setTabWidthDisplay = ref18[1];
    var ref19 = (0,react.useState)(tabTemplateDefault), tabTemplate = ref19[0], setTabTemplate = ref19[1];
    var ref20 = (0,react.useState)(tabShadowEnableDefault), tabShadowEnable = ref20[0], setTabShadowEnable = ref20[1];
    var ref21 = (0,react.useState)(tabShadowColorDefault), tabShadowColor = ref21[0], setTabShadowColor = ref21[1];
    var ref22 = (0,react.useState)(false), isOpenTemplateSelection = ref22[0], setIsOpenTemplateSelection = ref22[1];
    var ref23 = (0,react.useState)(false), isOpenShadowColorPicker = ref23[0], setIsOpenShadowColorPicker = ref23[1];
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var styleTabMenuOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/tab-template/phong-cach-chu-va-icon.svg",
                className: "m-auto",
                width: 77,
                height: 77
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_text_and_icon_label")
            }),
            value: configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/tab-template/phong-cach-chi-chu.svg",
                className: "m-auto",
                width: 77,
                height: 77
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_text_label")
            }),
            value: configs_const/* TAB_DISPLAY.TEXT */.Nu.TEXT
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/tab-template/phong-cach-chi-icon.svg",
                className: "m-auto",
                width: 77,
                height: 77
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_style_tab_icon_label")
            }),
            value: configs_const/* TAB_DISPLAY.ICON */.Nu.ICON
        }, 
    ];
    var styleGhimTabMenuOptions = [
        {
            label: t("ss_builder_style_not_ghim_tab_label"),
            value: configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM
        },
        {
            label: t("ss_builder_style_always_ghim_tab_label"),
            value: configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM
        }, 
    ];
    var positionTabMenuOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/tab-template/position-top.svg",
                className: "m-auto",
                width: 77,
                height: 77
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_top_position_tab_label")
            }),
            value: configs_const/* TAB_POSITION.TOP */.Fe.TOP
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                fit: "cover",
                src: "https://image.passio.eco/page-builder/page-builder/tab-template/position-bottom.svg",
                className: "m-auto",
                width: 77,
                height: 77
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: t("ss_builder_bottom_position_tab_label")
            }),
            value: configs_const/* TAB_POSITION.BOTTOM */.Fe.BOTTOM
        }, 
    ];
    (0,react.useEffect)(function() {
        onUpdateData(TabMenu_objectSpread({}, block, {
            title: valueTitleInput,
            content_attributes: {
                items: listTabsData
            },
            style_attributes: {
                display_style: styleTabMenuDisplay,
                ghim_style: styleGhimTabMenu,
                position_style: positionTabMenu,
                tab_layout: tabLayout,
                tab_width_display: tabWidthDisplay,
                tab_template: tabTemplate,
                tab_shadow_enable: tabShadowEnable,
                tab_shadow_color: tabShadowColor
            }
        }));
    }, [
        valueTitleInput,
        styleTabMenuDisplay,
        styleGhimTabMenu,
        positionTabMenu,
        listTabsData,
        tabLayout,
        tabWidthDisplay,
        tabTemplate,
        tabShadowEnable,
        tabShadowColor, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (JSON.stringify(listTabsData) !== JSON.stringify(listTabsDataDefault) || valueInput !== titleBlockDefault || styleTabMenuDisplay !== styleTabMenuDisplayDefault || styleGhimTabMenu !== styleGhimTabMenuDefault || tabLayout !== tabLayoutDefault || tabWidthDisplay !== tabWidthDisplayDefault || tabTemplate !== tabTemplateDefault || tabShadowEnable !== tabShadowEnableDefault || tabShadowColor !== tabShadowColorDefault || positionTabMenu && positionTabMenu !== positionTabMenuDefault) {
            return true;
        } else return false;
    }, [
        valueInput,
        titleBlockDefault,
        styleTabMenuDisplay,
        styleTabMenuDisplayDefault,
        styleGhimTabMenu,
        styleGhimTabMenuDefault,
        positionTabMenu,
        positionTabMenuDefault,
        listTabsData,
        listTabsDataDefault,
        tabLayout,
        tabLayoutDefault,
        tabWidthDisplay,
        tabWidthDisplayDefault,
        tabTemplate,
        tabTemplateDefault,
        tabShadowEnable,
        tabShadowEnableDefault,
        tabShadowColor,
        tabShadowColorDefault, 
    ]);
    (0,react.useEffect)(function() {
        var isDisableBtnSave = !isEditDataStatus;
        setButtonStatus(isDisableBtnSave);
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var handleSelectStyleTabMenuDisplay = function(arr) {
        if (arr && arr.length) {
            var valueStyle = arr[0];
            setStyleTabMenuDisplay(valueStyle);
            if (valueStyle !== configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON) {
                setTabLayout(null);
            } else {
                setTabLayout(tabLayoutDefault);
            }
        }
    };
    var handleSelectStyleGhimTabMenu = function(arr) {
        if (arr && arr.length) {
            var valueGhimStyle = arr[0];
            setStyleGhimTabMenu(valueGhimStyle);
            if (valueGhimStyle && valueGhimStyle !== configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM) {
                setPositionTabMenu(configs_const/* TAB_POSITION.TOP */.Fe.TOP);
            }
        }
    };
    var handleSelectPositionTabMenu = function(arr) {
        if (arr && arr.length) {
            var valuePosition = arr[0];
            if (styleGhimTabMenu && styleGhimTabMenu === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM) {
                setPositionTabMenu(valuePosition);
            } else setPositionTabMenu(null);
        }
    };
    var onChangeShadowColor = function(color) {
        setTabShadowColor(color);
    };
    var onUpdateShadowData = function(value) {
        setTabShadowEnable(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMenu_TabManagement, {
                onUpdateListTabsData: function(data) {
                    return setListTabsData(data);
                },
                listTabsDataDefault: listTabsData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666] zzzz",
                        children: t("ss_builder_sample_selection_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: (ref8 = configs_const/* TAB_TEMPLATE_LIST */.h4 === null || configs_const/* TAB_TEMPLATE_LIST */.h4 === void 0 ? void 0 : configs_const/* TAB_TEMPLATE_LIST.find */.h4.find(function(x) {
                            return x.value === tabTemplate;
                        })) === null || ref8 === void 0 ? void 0 : ref8.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                        block: true,
                        color: "default",
                        size: "middle",
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "12px",
                            gap: "5px",
                            borderColor: "var(--adm-color-primary)",
                            color: "var(--adm-color-primary)"
                        },
                        onClick: function() {
                            return setIsOpenTemplateSelection(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SampleSelectionIcon */.ix, {
                                className: "w-[17px] h-[17px]",
                                fillColor: "var(--adm-color-primary)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("ss_builder_sample_change_label")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] mb-1",
                                children: t("ss_builder_style_tab_selection_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: styleTabMenuOptions,
                                value: [
                                    styleTabMenuDisplay
                                ],
                                onChange: handleSelectStyleTabMenuDisplay,
                                columns: 3,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px",
                                    "--checked-color": "#fff"
                                }
                            })
                        ]
                    }),
                    styleTabMenuDisplay === configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMenu_TabLayouts, {
                                tabLayoutValue: tabLayout,
                                onUpdateTabLayoutValue: function(val) {
                                    return setTabLayout(val);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] mb-1",
                                children: t("ss_builder_style_ghim_tab_selection_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                options: styleGhimTabMenuOptions,
                                value: [
                                    styleGhimTabMenu
                                ],
                                onChange: handleSelectStyleGhimTabMenu,
                                columns: 2,
                                style: {
                                    "--border": "solid transparent 1px",
                                    "--checked-border": "solid var(--adm-color-primary) 1px",
                                    "--checked-color": "#fff"
                                }
                            })
                        ]
                    }),
                    styleGhimTabMenu === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-1",
                                        children: t("ss_builder_position_ghim_tab_selection_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: positionTabMenuOptions,
                                        value: [
                                            positionTabMenu
                                        ],
                                        onChange: handleSelectPositionTabMenu,
                                        columns: 3,
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px",
                                            "--checked-color": "#fff"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMenu_TabWidthDisplay, {
                        tabWidthDisplayValue: tabWidthDisplay,
                        onUpdateTabWidthDisplayValue: function(val) {
                            return setTabWidthDisplay(val);
                        }
                    })
                ]
            }),
            styleGhimTabMenu !== configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 mb-2 flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icons/* ShadowIcon */.vf, {
                                    className: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[17px] leading-[22px]",
                                children: t("ss_builder_theme_setting_block_shadow")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base mb-4",
                                children: t("ss_builder_enable_shadow")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                defaultChecked: tabShadowEnable !== null && tabShadowEnable !== void 0 ? tabShadowEnable : false,
                                uncheckedText: t("ss_builder_off"),
                                checkedText: t("ss_builder_on"),
                                onChange: function(value) {
                                    return onUpdateShadowData(value);
                                }
                            }),
                            tabShadowEnable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_block_shadow_color")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: tabShadowColor,
                                                onClickOpenColorPicker: setIsOpenShadowColorPicker
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenTemplateSelection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMenu_TabTemplateSelection, {
                    tabTemplateDefault: tabTemplate,
                    onUpdateTabTemplate: function(val) {
                        return setTabTemplate(val);
                    },
                    onCancelTabTemplate: function() {
                        return setIsOpenTemplateSelection(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenShadowColorPicker,
                onMaskClick: function() {},
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: tabShadowColor,
                    onCancel: function() {
                        setIsOpenShadowColorPicker(false);
                    },
                    onColorSelected: onChangeShadowColor
                })
            })
        ]
    });
};
/* harmony default export */ var block_editor_TabMenu = (TabMenu);

;// CONCATENATED MODULE: ./src/features/block/middleware/highlight-story.ts
function highlight_story_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function highlight_story_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                highlight_story_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                highlight_story_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function highlight_story_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function highlight_story_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            highlight_story_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var highlightStoryMiddleware = function() {
    var _ref1 = highlight_story_asyncToGenerator(runtime_default().mark(function _callee1(data, extraData) {
        var imageArrItems, response, arrRequest, arrUrl, newImageArrItems, newData;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    if (!data) {
                        _ctx1.next = 18;
                        break;
                    }
                    imageArrItems = data.content_attributes && data.content_attributes.items;
                    response = null;
                    _ctx1.prev = 3;
                    arrRequest = imageArrItems && Array.isArray(imageArrItems) && imageArrItems.map(function() {
                        var _ref = highlight_story_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var dataRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!(ele.image_base64 && ele.name)) {
                                            _ctx.next = 7;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return (0,api/* requestUploadImage */.MR)(highlight_story_objectSpread({}, extraData, {
                                            content: ele.image_base64,
                                            name: ele.name
                                        }));
                                    case 3:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 7:
                                        delete ele.image_base64;
                                        delete ele.image_name;
                                        return _ctx.abrupt("return", ele);
                                    case 10:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 7;
                    return Promise.all(arrRequest);
                case 7:
                    response = _ctx1.sent;
                    _ctx1.next = 13;
                    break;
                case 10:
                    _ctx1.prev = 10;
                    _ctx1.t0 = _ctx1["catch"](3);
                    console.log(_ctx1.t0);
                case 13:
                    if (!(response && response.every(function(x) {
                        return x !== undefined;
                    }))) {
                        _ctx1.next = 18;
                        break;
                    }
                    arrUrl = response.map(function(ele) {
                        var ref;
                        return (ref = ele === null || ele === void 0 ? void 0 : ele.url) !== null && ref !== void 0 ? ref : ele.image;
                    });
                    newImageArrItems = imageArrItems.map(function(element, index) {
                        delete element.image_base64;
                        delete element.image_name;
                        return highlight_story_objectSpread({}, element, {
                            image: arrUrl[index]
                        });
                    });
                    newData = highlight_story_objectSpread({}, data, {
                        content_attributes: highlight_story_objectSpread({}, data.content_attributes, {
                            items: newImageArrItems
                        })
                    });
                    return _ctx1.abrupt("return", newData);
                case 18:
                    return _ctx1.abrupt("return", data);
                case 19:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function highlightStoryMiddleware(data, extraData) {
        return _ref1.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/block/middleware/ImageGallery/index.ts
function ImageGallery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ImageGallery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ImageGallery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ImageGallery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function middleware_ImageGallery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function middleware_ImageGallery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            middleware_ImageGallery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ImageGalleryMiddleware = function() {
    var _ref1 = ImageGallery_asyncToGenerator(runtime_default().mark(function _callee1(data, extraData) {
        var imageArrItems, response, arrRequest, arrUrl, newImageArrItems, newData;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    if (!data) {
                        _ctx1.next = 18;
                        break;
                    }
                    imageArrItems = data.content_attributes && data.content_attributes.items;
                    response = null;
                    _ctx1.prev = 3;
                    arrRequest = imageArrItems && Array.isArray(imageArrItems) && imageArrItems.map(function() {
                        var _ref = ImageGallery_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var dataRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!(ele.image_base64 && ele.name)) {
                                            _ctx.next = 7;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return (0,api/* requestUploadImage */.MR)(middleware_ImageGallery_objectSpread({}, extraData, {
                                            content: ele.image_base64,
                                            name: ele.name
                                        }));
                                    case 3:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 7:
                                        delete ele.image_base64;
                                        delete ele.image_name;
                                        return _ctx.abrupt("return", ele);
                                    case 10:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 7;
                    return Promise.all(arrRequest);
                case 7:
                    response = _ctx1.sent;
                    _ctx1.next = 13;
                    break;
                case 10:
                    _ctx1.prev = 10;
                    _ctx1.t0 = _ctx1["catch"](3);
                    console.log(_ctx1.t0);
                case 13:
                    if (!(response && response.every(function(x) {
                        return x !== undefined;
                    }))) {
                        _ctx1.next = 18;
                        break;
                    }
                    arrUrl = response.map(function(ele) {
                        var ref;
                        return (ref = ele === null || ele === void 0 ? void 0 : ele.url) !== null && ref !== void 0 ? ref : ele.image;
                    });
                    newImageArrItems = imageArrItems.map(function(element, index) {
                        delete element.image_base64;
                        delete element.image_name;
                        return middleware_ImageGallery_objectSpread({}, element, {
                            image: arrUrl[index]
                        });
                    });
                    newData = middleware_ImageGallery_objectSpread({}, data, {
                        content_attributes: middleware_ImageGallery_objectSpread({}, data.content_attributes, {
                            items: newImageArrItems
                        })
                    });
                    return _ctx1.abrupt("return", newData);
                case 18:
                    return _ctx1.abrupt("return", data);
                case 19:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function ImageGalleryMiddleware(data, extraData) {
        return _ref1.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/block/block-editor/TextV2/index.tsx
function TextV2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TextV2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TextV2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var TextV2_BLOCK_HEADING_MAXIMUM = 50;
var TextV2 = function(props) {
    var ref;
    var block = props.block, onUpdateData = props.onUpdateData, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData1 = props.defaultBlockData;
    var defaultValueEditText = (defaultBlockData1 === null || defaultBlockData1 === void 0 ? void 0 : defaultBlockData1.uid) ? defaultBlockData1 : null;
    var valueHeadingBlockDefault = (defaultValueEditText === null || defaultValueEditText === void 0 ? void 0 : (ref = defaultValueEditText.content_attributes) === null || ref === void 0 ? void 0 : ref.block_heading) || "";
    var UID = defaultBlockData1 && "".concat(defaultBlockData1 === null || defaultBlockData1 === void 0 ? void 0 : defaultBlockData1.block_type, "-").concat((0,v4/* default */.Z)());
    var draft_content = ((defaultValueEditText === null || defaultValueEditText === void 0 ? void 0 : defaultValueEditText.content_attributes) || {}).draft_content;
    var defaultValue = typeof draft_content === "string" ? draft_content : draftjs_to_html_default()(draft_content);
    var ref1 = (0,react.useState)(defaultValue), contentState = ref1[0], setContentState = ref1[1];
    var ref2 = (0,react.useState)(0), count = ref2[0], setCount = ref2[1];
    var ref3;
    var ref4 = (0,react.useState)((ref3 = block === null || block === void 0 ? void 0 : block.enable) !== null && ref3 !== void 0 ? ref3 : configs_const/* ENABLE_BLOCK */.C5), isEnable = ref4[0], setIsEnable = ref4[1];
    var ref5 = (0,react.useState)(valueHeadingBlockDefault), valueHeadingBlock = ref5[0], setValueHeadingBlock = ref5[1];
    (0,react.useEffect)(function() {
        setContentState(defaultValue);
    }, [
        defaultValue
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultBlockData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: configs_const/* BLOCK_TYPE_CONFIG.TEXT */.x_.TEXT,
                title: "Text",
                content_attributes: {
                    block_heading: valueHeadingBlock,
                    draft_content: contentState
                },
                style_attibutes: {}
            };
            onUpdateData(defaultBlockData);
        } else {
            onUpdateData(TextV2_objectSpread({}, block, {
                content_attributes: {
                    block_heading: valueHeadingBlock,
                    draft_content: contentState
                }
            }));
        }
    }, [
        contentState,
        valueHeadingBlock
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (contentState.length > 0 && contentState.trim().length > 0 && count <= configs_const/* EDITOR_BLOCK_TEXT_MAX_LENGTH */.nK && (valueHeadingBlock !== valueHeadingBlockDefault || defaultValue !== contentState)) {
            return false;
        }
        return true;
    }, [
        contentState,
        defaultValue,
        count,
        valueHeadingBlock,
        valueHeadingBlockDefault, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (valueHeadingBlock !== valueHeadingBlockDefault || defaultValue !== contentState) return true;
        else return false;
    }, [
        contentState,
        defaultValue,
        valueHeadingBlock,
        valueHeadingBlockDefault
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    var charCount = function(editor) {
        return editor.getContent({
            format: "text"
        }).length;
    };
    var handleUpdateValue = function(value, editor) {
        var cCount = charCount(editor);
        setContentState(value);
        setCount(cCount);
    };
    var handleInitEditor = function(value, editor) {
        setCount(charCount(editor));
    };
    var handleChangeBlockHeading = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= TextV2_BLOCK_HEADING_MAXIMUM) {
            setValueHeadingBlock(val);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 pt-4 pb-5 bg-white mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[15px] leading-[150%] text-[#666666] mb-1",
                            children: t("ss_builder_block_heading_label")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                            placeholder: t("ss_builder_block_heading_placeholder"),
                            onChange: handleChangeBlockHeading,
                            value: valueHeadingBlock,
                            maxLength: TextV2_BLOCK_HEADING_MAXIMUM
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                            children: "".concat(valueHeadingBlock ? valueHeadingBlock.length : 0, "/").concat(TextV2_BLOCK_HEADING_MAXIMUM)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-4 pb-5 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] leading-[150%] text-[#666666] mb-[5px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_content_editor_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextV2_EditorComp, {
                        value: contentState,
                        onUpdateValue: handleUpdateValue,
                        handleInit: handleInitEditor,
                        placeholder: t("ss_builder_block_description_placeholder")
                    }),
                    count <= configs_const/* EDITOR_BLOCK_TEXT_MAX_LENGTH */.nK ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("text-[13px] leading-[17px] w-full text-right mt-2 text-[#999999]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(count, "/").concat(configs_const/* EDITOR_BLOCK_TEXT_MAX_LENGTH */.nK)
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("text-[13px] leading-[17px] w-full d-flex justify-between mt-2 gap-4 text-[red]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_text_editor_max_length", {
                                    editor_max_length: configs_const/* EDITOR_BLOCK_TEXT_MAX_LENGTH */.nK
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "".concat(count, "/").concat(configs_const/* EDITOR_BLOCK_TEXT_MAX_LENGTH */.nK)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var block_editor_TextV2 = (TextV2);

;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/SpacerSetting/index.tsx




var SpacerSetting = function(props) {
    var onUpdateSettingData = props.onUpdateSettingData, spacing_value = props.spacing_value;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-3 bg-white px-4 py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[15px]",
                        children: t("ss_builder_spacer_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[13px] text-[#EE3244]",
                        children: spacing_value || 4
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                popover: true,
                onChange: function(val) {
                    return onUpdateSettingData("spacing_value", parseInt(val.toString()));
                },
                // ticks={true}
                marks: {
                    4: 4,
                    6: "",
                    8: "",
                    10: "",
                    12: "",
                    14: "",
                    16: "",
                    18: "",
                    20: "",
                    22: "",
                    24: "",
                    26: "",
                    28: "",
                    30: "",
                    32: "",
                    34: "",
                    36: "",
                    38: "",
                    40: "",
                    42: "",
                    44: "",
                    46: "",
                    48: "",
                    50: "",
                    52: "",
                    54: "",
                    56: "",
                    58: "",
                    60: "",
                    62: "",
                    64: 64
                },
                min: 4,
                step: 1,
                max: 64,
                value: spacing_value
            })
        ]
    });
};
/* harmony default export */ var SpacerAndDivider_SpacerSetting = (SpacerSetting);

// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/index.tsx + 1 modules
var DividerSetting = __webpack_require__(15231);
// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/DefaultsLayoutSetting/index.tsx
var DefaultsLayoutSetting = __webpack_require__(89216);
;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/CurrentBlock/indesx.tsx
function indesx_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function indesx_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            indesx_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var CurrentBlock = function(param) {
    var siteSettings = param.siteSettings, index = param.index;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.display_setting) || {}, paragraph_setting = ref.paragraph_setting, title_setting = ref.title_setting, block_setting = ref.block_setting;
    var ref1 = title_setting || {}, tmp = ref1.font_family, font_family_title = tmp === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : tmp, tmp1 = ref1.font_color, font_color_title = tmp1 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : tmp1, tmp2 = ref1.scale, scale_title = tmp2 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : tmp2, tmp3 = ref1.font_size, font_size_title = tmp3 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : tmp3, tmp4 = ref1.font_weight, font_weight_title = tmp4 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : tmp4, tmp5 = ref1.line_height, line_height_title = tmp5 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : tmp5;
    var ref2 = paragraph_setting || {}, tmp6 = ref2.font_family, font_family_paragraph = tmp6 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : tmp6, tmp7 = ref2.font_color, font_color_paragraph = tmp7 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : tmp7, tmp8 = ref2.font_size, font_size_paragraph = tmp8 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : tmp8, tmp9 = ref2.font_weight, font_weight_paragraph = tmp9 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : tmp9, tmp10 = ref2.line_height, line_height_paragraph = tmp10 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : tmp10;
    var ref3 = block_setting || {}, block_style = ref3.block_style, block_background = ref3.block_background, block_border = ref3.block_border, block_shadow = ref3.block_shadow;
    var ref4 = block_style || {}, _radius_type = ref4.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE : _radius_type, _radius_value = ref4.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS : _radius_value, _inner_space = ref4.inner_space, inner_space = _inner_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE : _inner_space, _inner_space_number = ref4.inner_space_number, inner_space_number = _inner_space_number === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : _inner_space_number;
    var ref5 = block_background || {}, tmp11 = ref5.color, blockBackgroundColor = tmp11 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR : tmp11, _blur = ref5.blur, blur = _blur === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR : _blur;
    var ref6 = block_border || {}, tmp12 = ref6.enable, borderEnable = tmp12 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE : tmp12, _border_width = ref6.border_width, border_width = _border_width === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH : _border_width, tmp13 = ref6.color, borderColor = tmp13 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR : tmp13, tmp14 = ref6.type, borderType = tmp14 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE : tmp14;
    var ref7 = block_shadow || {}, tmp15 = ref7.enable, shadowEnable = tmp15 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE : tmp15, tmp16 = ref7.color, shadowColor = tmp16 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR : tmp16;
    var font_size_title_block = font_size_title * scale_title * scale_title * scale_title;
    var boxShadowStyle = shadowEnable === true ? {
        boxShadow: "0px 4px 4px " + shadowColor
    } : {};
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "8px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = borderEnable === true ? {
        borderWidth: border_width + "px",
        borderStyle: borderType,
        borderColor: borderColor
    } : {
        border: "none"
    };
    var innerSpaceNumber = typeof inner_space_number === "number" ? "".concat(inner_space_number, "px") : inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-3 pb-3",
        style: indesx_objectSpread({
            backgroundColor: blockBackgroundColor,
            borderRadius: borderRadiusValue,
            backdropFilter: "blur(".concat(blur, "px) "),
            WebkitBackdropFilter: "blur(".concat(blur, "px) "),
            paddingLeft: innerSpaceNumber,
            paddingRight: innerSpaceNumber
        }, styleBorder, boxShadowStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-titleFontSize",
                style: {
                    color: font_color_title,
                    fontSize: font_size_title_block,
                    lineHeight: line_height_title,
                    fontWeight: font_weight_title,
                    fontFamily: font_family_title
                },
                children: t("ss_builder_".concat(index, "st_block_preview_sample_title"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-block-preview",
                style: {
                    color: font_color_paragraph,
                    fontSize: font_size_paragraph,
                    lineHeight: line_height_paragraph,
                    fontWeight: font_weight_paragraph,
                    fontFamily: font_family_paragraph
                },
                children: t("ss_builder_".concat(index, "st_block_preview_sample_description"))
            })
        ]
    });
};
/* harmony default export */ var indesx = (CurrentBlock);

// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/SpacerAndDividerSample/DividerImage/index.tsx
var DividerImage = __webpack_require__(66639);
// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/SpacerAndDividerSample/DividerLine/index.tsx
var DividerLine = __webpack_require__(26124);
;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/SpacerAndDividerSample/index.tsx





var SpacerAndDividerSample = function(param) {
    var block = param.block;
    var ref = (block === null || block === void 0 ? void 0 : block.content_attributes) || {}, spacing_value = ref.spacing_value, divider_thickness = ref.divider_thickness, divider_color = ref.divider_color, divider_image = ref.image;
    var ref1 = (block === null || block === void 0 ? void 0 : block.style_attributes) || {}, divider_type = ref1.divider_type, layout_type = ref1.layout_type;
    if (!layout_type) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "".concat(spacing_value, "px")
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "".concat(spacing_value / 2, "px")
                }
            }),
            layout_type === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerLine/* default */.Z, {
                divider_thickness: divider_thickness,
                divider_color: divider_color,
                divider_type: divider_type
            }),
            layout_type === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerImage/* default */.Z, {
                divider_image: divider_image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "".concat(spacing_value / 2, "px")
                }
            })
        ]
    });
};
/* harmony default export */ var Preview_SpacerAndDividerSample = (SpacerAndDividerSample);

;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/index.tsx
function Preview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Preview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Preview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var BACKGROUND_TYPE_IMAGE = "image";
var BACKGROUND_TYPE_SOLID = "solid";
var BACKGROUND_TYPE_GRADENT = "gradient";
var BACKGROUND_TYPE_COLOR = "color";
function Preview(param) {
    var block = param.block;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.display_setting) || {}, background = ref.background, block_setting = ref.block_setting;
    var layout_type = ((block === null || block === void 0 ? void 0 : block.style_attributes) || {}).layout_type;
    var ref1 = background || {}, _type = ref1.type, type = _type === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : _type, _color = ref1.color, color = _color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID */.Vw.COLOR_SOLID : _color, gradient = ref1.gradient, _image = ref1.image, image = _image === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.IMAGE */.Vw.IMAGE : _image, _enable_overlay = ref1.enable_overlay, enable_overlay = _enable_overlay === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_ENABLE */.Vw.OVERLAY_ENABLE : _enable_overlay, _overlay_color = ref1.overlay_color, overlay_color = _overlay_color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_COLOR */.Vw.OVERLAY_COLOR : _overlay_color, tmp = ref1.blur, blurBackgroundSetting = tmp === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp;
    var block_style = (block_setting || {}).block_style;
    var ref2 = block_style || {}, _block_space = ref2.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, _outside_space = ref2.outside_space, outside_space = _outside_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE : _outside_space;
    var styleBackgroundImage = type === BACKGROUND_TYPE_IMAGE ? {
        backgroundPosition: "center center",
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    var checkStyleBackgroundImage = function() {
        switch(type){
            case BACKGROUND_TYPE_IMAGE:
                return 'url("'.concat(image, '")');
            case BACKGROUND_TYPE_GRADENT:
                return gradient;
            default:
                return "";
        }
    };
    var styleOutsideSpace = outside_space ? {
        marginLeft: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        marginRight: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        width: "calc(100% - ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2, "px) ")
    } : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("bg-white mb-2 top-[45px] z-[11]", layout_type === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS && "sticky"),
            style: {
                top: block.enable === 1 ? "45px" : "83px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3 pt-4 pb-4 w-full h-full relative overflow-hidden",
                children: [
                    type === BACKGROUND_TYPE_IMAGE && enable_overlay === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[1]",
                        style: {
                            backgroundColor: overlay_color
                        }
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat object-cover",
                        style: Preview_objectSpread({
                            backgroundColor: type === BACKGROUND_TYPE_SOLID || type === BACKGROUND_TYPE_COLOR ? color : "",
                            backgroundImage: "".concat(checkStyleBackgroundImage()),
                            borderBottom: "1px solid var(--adm-color-border)"
                        }, styleBackgroundImage)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-[3]",
                        style: Preview_objectSpread({}, styleOutsideSpace),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(indesx, {
                                siteSettings: siteSettings,
                                index: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(block_space / 2, "px")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_SpacerAndDividerSample, {
                                block: block
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(block_space / 2, "px")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(indesx, {
                                siteSettings: siteSettings,
                                index: 2
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/block/block-editor/SpacerAndDivider/index.tsx
function SpacerAndDivider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SpacerAndDivider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SpacerAndDivider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_SETTING = {
    SPACING_VALUE: 4,
    DIVIDER_TYPE: DefaultsLayoutSetting/* DIVIDER_LAYOUT_TYPE_ENUM.SOLID */.J.SOLID,
    DIVIDER_THICKNESS: 1,
    DIVIDER_COLOR: "#000000"
};
var SpacerAndDivider = function(props) {
    var block = props.block, onUpdateData = props.onUpdateData, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData1 = props.defaultBlockData;
    // const edittingBlock = useAppSelector((state) => state.edittingBlock);
    // const edittingBlockData = edittingBlock && edittingBlock.block_data;
    var defaultValueEditBlock = defaultBlockData1 && defaultBlockData1.uid ? defaultBlockData1 : null;
    var UID = "".concat(BLOCK_TYPE.SPACER_AND_DIVIDER.split("_").join("-"), "-").concat((0,v4/* default */.Z)());
    var ref4 = (defaultValueEditBlock === null || defaultValueEditBlock === void 0 ? void 0 : defaultValueEditBlock.content_attributes) || {}, spacing_value = ref4.spacing_value, divider_thickness1 = ref4.divider_thickness, divider_color1 = ref4.divider_color, image = ref4.image;
    var ref1 = (defaultValueEditBlock === null || defaultValueEditBlock === void 0 ? void 0 : defaultValueEditBlock.style_attributes) || {}, divider_type1 = ref1.divider_type, layout_type1 = ref1.layout_type;
    var enableDividerDefault = !!layout_type1;
    var settingDataDefault = {
        spacing_value: spacing_value || DEFAULT_SETTING.SPACING_VALUE,
        divider_type: enableDividerDefault ? divider_type1 || DefaultsLayoutSetting/* DIVIDER_LAYOUT_TYPE_ENUM.SOLID */.J.SOLID : null,
        divider_thickness: enableDividerDefault ? divider_thickness1 || DEFAULT_SETTING.DIVIDER_THICKNESS : null,
        divider_color: enableDividerDefault ? divider_color1 || DEFAULT_SETTING.DIVIDER_COLOR : null,
        divider_image: {
            url: enableDividerDefault ? image : null
        },
        layout_type: enableDividerDefault ? layout_type1 || DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS : null
    };
    var ref2 = (0,react.useState)(settingDataDefault), settingData = ref2[0], setSettingData = ref2[1];
    var ref3 = (0,react.useState)(enableDividerDefault), enableDivider = ref3[0], setEnableDivider = ref3[1];
    (0,react.useEffect)(function() {
        if (enableDivider) {
            var ref = settingData || {}, divider_type = ref.divider_type, divider_thickness = ref.divider_thickness, divider_color = ref.divider_color, layout_type = ref.layout_type;
            !divider_type && handleUpdateSettingData("divider_type", DefaultsLayoutSetting/* DIVIDER_LAYOUT_TYPE_ENUM.SOLID */.J.SOLID);
            !divider_thickness && handleUpdateSettingData("divider_thickness", DEFAULT_SETTING.DIVIDER_THICKNESS);
            !divider_color && handleUpdateSettingData("divider_color", DEFAULT_SETTING.DIVIDER_COLOR);
            !layout_type && handleUpdateSettingData("layout_type", DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS);
        }
    }, [
        enableDivider,
        divider_type1,
        divider_thickness1,
        divider_color1,
        layout_type1, 
    ]);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var ref, ref5, ref6;
            var defaultBlockData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: BLOCK_TYPE.SPACER_AND_DIVIDER,
                content_attributes: {
                    spacing_value: settingData === null || settingData === void 0 ? void 0 : settingData.spacing_value,
                    divider_thickness: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_thickness : null,
                    divider_color: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_color : null,
                    image: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref = settingData.divider_image) === null || ref === void 0 ? void 0 : ref.url : null,
                    image_base64: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref5 = settingData.divider_image) === null || ref5 === void 0 ? void 0 : ref5.base64 : undefined,
                    image_name: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref6 = settingData.divider_image) === null || ref6 === void 0 ? void 0 : ref6.file_name : undefined
                },
                style_attributes: {
                    divider_type: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_type : null,
                    layout_type: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.layout_type : null
                }
            };
            onUpdateData(defaultBlockData);
        } else {
            var ref7, ref8, ref9;
            onUpdateData(SpacerAndDivider_objectSpread({}, block, {
                content_attributes: {
                    spacing_value: settingData === null || settingData === void 0 ? void 0 : settingData.spacing_value,
                    divider_thickness: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_thickness : null,
                    divider_color: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_color : null,
                    image: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref7 = settingData.divider_image) === null || ref7 === void 0 ? void 0 : ref7.url : null,
                    image_base64: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref8 = settingData.divider_image) === null || ref8 === void 0 ? void 0 : ref8.base64 : undefined,
                    image_name: enableDivider ? settingData === null || settingData === void 0 ? void 0 : (ref9 = settingData.divider_image) === null || ref9 === void 0 ? void 0 : ref9.file_name : undefined
                },
                style_attributes: {
                    divider_type: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.divider_type : null,
                    layout_type: enableDivider ? settingData === null || settingData === void 0 ? void 0 : settingData.layout_type : null
                }
            }));
        }
    }, [
        settingData,
        enableDivider
    ]);
    var handleUpdateSettingData = function(key, value) {
        setSettingData(function(state) {
            return SpacerAndDivider_objectSpread({}, state, SpacerAndDivider_defineProperty({}, key, value));
        });
    };
    var isDisableBtnSave = (0,react.useMemo)(function() {
        var isChecked = true;
        if (defaultValueEditBlock) {
            if (enableDividerDefault) {
                var ref, ref10;
                if (!enableDivider || (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS && (settingData.divider_color !== settingDataDefault.divider_color || settingData.divider_thickness !== settingDataDefault.divider_thickness || settingData.divider_type !== settingDataDefault.divider_type || settingData.spacing_value !== settingDataDefault.spacing_value) || settingData.spacing_value !== settingDataDefault.spacing_value && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref = settingData.divider_image) === null || ref === void 0 ? void 0 : ref.url) || settingData.divider_image.url !== settingDataDefault.divider_image.url || settingData.layout_type !== settingDataDefault.layout_type && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref10 = settingData.divider_image) === null || ref10 === void 0 ? void 0 : ref10.url) || settingData.layout_type !== settingDataDefault.layout_type && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS) {
                    isChecked = false;
                } else isChecked = true;
            } else {
                var ref11, ref12, ref13, ref14;
                if (!enableDivider && settingData.spacing_value !== settingDataDefault.spacing_value || enableDivider && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS || settingData.spacing_value !== settingDataDefault.spacing_value && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS || settingData.spacing_value !== settingDataDefault.spacing_value && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref11 = settingData.divider_image) === null || ref11 === void 0 ? void 0 : ref11.url) || enableDivider && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref12 = settingData.divider_image) === null || ref12 === void 0 ? void 0 : ref12.url) && (settingData === null || settingData === void 0 ? void 0 : (ref13 = settingData.divider_image) === null || ref13 === void 0 ? void 0 : ref13.url) !== (settingDataDefault === null || settingDataDefault === void 0 ? void 0 : (ref14 = settingDataDefault.divider_image) === null || ref14 === void 0 ? void 0 : ref14.url)) {
                    isChecked = false;
                } else isChecked = true;
            }
        } else {
            var ref15, ref16, ref17, ref18;
            if (!enableDivider || enableDivider && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS || settingData.spacing_value !== settingDataDefault.spacing_value && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref15 = settingData.divider_image) === null || ref15 === void 0 ? void 0 : ref15.url) || enableDivider && (settingData === null || settingData === void 0 ? void 0 : settingData.layout_type) === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && (settingData === null || settingData === void 0 ? void 0 : (ref16 = settingData.divider_image) === null || ref16 === void 0 ? void 0 : ref16.url) && (settingData === null || settingData === void 0 ? void 0 : (ref17 = settingData.divider_image) === null || ref17 === void 0 ? void 0 : ref17.url) !== (settingDataDefault === null || settingDataDefault === void 0 ? void 0 : (ref18 = settingDataDefault.divider_image) === null || ref18 === void 0 ? void 0 : ref18.url)) {
                isChecked = false;
            } else isChecked = true;
        }
        return isChecked;
    }, [
        settingData,
        defaultValueEditBlock,
        enableDivider,
        settingDataDefault,
        enableDividerDefault, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (enableDivider !== enableDividerDefault || JSON.stringify(settingData) !== JSON.stringify(settingDataDefault)) {
            return true;
        } else return false;
    }, [
        settingData,
        enableDivider,
        settingDataDefault,
        enableDividerDefault
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
    }, [
        isEditDataStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                block: block
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpacerAndDivider_SpacerSetting, {
                spacing_value: settingData === null || settingData === void 0 ? void 0 : settingData.spacing_value,
                onUpdateSettingData: handleUpdateSettingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerSetting/* default */.Z, {
                enableDivider: enableDivider,
                divider_type: settingData === null || settingData === void 0 ? void 0 : settingData.divider_type,
                divider_thickness: settingData === null || settingData === void 0 ? void 0 : settingData.divider_thickness,
                divider_color: settingData === null || settingData === void 0 ? void 0 : settingData.divider_color,
                divider_image: settingData === null || settingData === void 0 ? void 0 : settingData.divider_image,
                layout_type: settingData === null || settingData === void 0 ? void 0 : settingData.layout_type,
                onUpdateSettingData: handleUpdateSettingData,
                onCheckDividerEnable: function(val) {
                    return setEnableDivider(val);
                }
            })
        ]
    });
};
/* harmony default export */ var block_editor_SpacerAndDivider = (SpacerAndDivider);

// EXTERNAL MODULE: ./src/features/block/block-editor/BookingProfile/constant.ts
var BookingProfile_constant = __webpack_require__(92338);
;// CONCATENATED MODULE: ./src/features/block/block-editor/BookingProfile/components/StyleSelector/index.tsx





var StyleSelector = function(param) {
    var onUpdateData = param.onUpdateData, data = param.data;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var styleOptions = [
        {
            label: t("ss_builder_booking_profile_style_1"),
            value: BookingProfile_constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT
        },
        {
            label: t("ss_builder_booking_profile_style_2"),
            value: BookingProfile_constant/* BOOKING_PROFILE_STYLE.EMBED_CODE */.W.EMBED_CODE
        }, 
    ];
    var handleSelectStyle = function(arr) {
        if (arr && arr.length) {
            var valueSize = arr[0];
            onUpdateData(valueSize);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4 py-3 bg-white mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#666666]",
                children: t("ss_builder_style")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                options: styleOptions,
                value: [
                    data
                ],
                onChange: handleSelectStyle,
                columns: 2,
                style: {
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    "--checked-color": "#FFFFFF"
                }
            })
        ]
    });
};
/* harmony default export */ var components_StyleSelector = (StyleSelector);

// EXTERNAL MODULE: ./src/features/share/components/ImageUploadCommon/index.tsx + 4 modules
var ImageUploadCommon = __webpack_require__(71856);
// EXTERNAL MODULE: ./src/features/share/components/ImageUploadCommon/constants.ts
var ImageUploadCommon_constants = __webpack_require__(60880);
;// CONCATENATED MODULE: ./src/features/block/block-editor/BookingProfile/components/CardContentStyle/index.tsx







var CardContentStyle = function(param) {
    var handleChange = param.handleChange, handleErrorImage = param.handleErrorImage, image = param.image, booking_profile_title = param.booking_profile_title, booking_profile_description = param.booking_profile_description, booking_profile_button_content = param.booking_profile_button_content;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 py-3 bg-white mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadCommon/* default */.Z, {
                    value: image,
                    onChange: function(img) {
                        return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.IMAGE */.U.IMAGE, img);
                    },
                    layout_type: ImageUploadCommon_constants/* IMAGE_UPLOAD_LAYOUTS.LAYOUT_2 */.Dc.LAYOUT_2,
                    label: t("ss_builder_image"),
                    isRequired: true,
                    maxWidth: ImageUploadCommon_constants/* RESIZE.MAX_WIDTH */.sF.MAX_WIDTH,
                    resizeType: ImageUploadCommon_constants/* TYPE_RESIZE.WIDTH */.uX.WIDTH,
                    className: "p-0",
                    onError: handleErrorImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-3 bg-white mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                        label: t("ss_builder_block_booking_profile_setting_title"),
                        value: booking_profile_title,
                        maxLength: 50,
                        placeholder: t("ss_builder_block_description_placeholder"),
                        onChange: function(value) {
                            return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.TITLE */.U.TITLE, value);
                        },
                        hasNoBorder: true,
                        showCountCharacter: true,
                        hasBottomDivider: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                        label: t("ss_builder_block_booking_profile_setting_description"),
                        value: booking_profile_description,
                        maxLength: 250,
                        placeholder: t("ss_builder_block_description_placeholder"),
                        onChange: function(value) {
                            return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.DESCRIPTION */.U.DESCRIPTION, value);
                        },
                        hasNoBorder: true,
                        isMultiline: true,
                        showCountCharacter: true,
                        hasBottomDivider: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputCustom, {
                        label: t("ss_builder_block_booking_profile_button_label"),
                        value: booking_profile_button_content,
                        maxLength: 25,
                        placeholder: t("ss_builder_block_description_placeholder"),
                        onChange: function(value) {
                            return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.BUTTON_CONTENT */.U.BUTTON_CONTENT, value);
                        },
                        hasNoBorder: true,
                        required: true,
                        showCountCharacter: true,
                        hasBottomDivider: false
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardContentStyle = (CardContentStyle);

;// CONCATENATED MODULE: ./src/features/share/components/SwitchFieldCustom/index.tsx




var SwitchFieldCustom = function(param) {
    var label = param.label, onChange = param.onChange, _checked = param.checked, checked = _checked === void 0 ? false : _checked, _defaultChecked = param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, _helperContent = param.helperContent, helperContent = _helperContent === void 0 ? "" : _helperContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-x-1",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666] font-normal",
                        children: label
                    }),
                    helperContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                            content: helperContent,
                            placement: "top-start",
                            mode: "dark",
                            trigger: "click",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[21px] h-[21px] flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                                    fillColor: "#1890FF",
                                    className: "w-[15px] h-[15px] cursor-pointer"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                defaultChecked: defaultChecked,
                checked: checked,
                onChange: onChange
            })
        ]
    });
};
/* harmony default export */ var components_SwitchFieldCustom = (SwitchFieldCustom);

;// CONCATENATED MODULE: ./src/features/block/block-editor/BookingProfile/components/EmbedCodeStyle/index.tsx






var EmbedCodeStyle = function(param) {
    var handleChange = param.handleChange, openNewTab = param.openNewTab, applyBlockSettings = param.applyBlockSettings;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-3 bg-white mb-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwitchFieldCustom, {
                    checked: openNewTab,
                    onChange: function(val) {
                        return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.OPEN_NEW_TAB */.U.OPEN_NEW_TAB, val);
                    },
                    label: t("ss_builder_bp_open_new_tab_title"),
                    helperContent: t("ss_builder_bp_open_new_tab_instruction")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                    style: {
                        marginTop: 12,
                        marginBottom: 12
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwitchFieldCustom, {
                    checked: applyBlockSettings,
                    onChange: function(val) {
                        return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.APPLY_BLOCK_SETTINGS */.U.APPLY_BLOCK_SETTINGS, val);
                    },
                    label: t("ss_builder_block_setting_title"),
                    helperContent: t("ss_builder_bp_apply_block_settings_instruction")
                })
            ]
        })
    });
};
/* harmony default export */ var components_EmbedCodeStyle = (EmbedCodeStyle);

;// CONCATENATED MODULE: ./src/features/block/block-editor/BookingProfile/index.tsx
function BookingProfile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BookingProfile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BookingProfile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var BookingProfile = function(props) {
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus, defaultBlockData = props.defaultBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "booking-profile-".concat((0,v4/* default */.Z)());
    var dataBookingProfileDefault = (defaultBlockData === null || defaultBlockData === void 0 ? void 0 : defaultBlockData.uid) ? defaultBlockData : null;
    var dataInitial = {
        title: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : dataBookingProfileDefault.title) || BLOCK_TYPE.BOOKING_PROFILE,
        image: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref12 = dataBookingProfileDefault.content_attributes) === null || ref12 === void 0 ? void 0 : ref12.image) || "",
        image_name: dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref1 = dataBookingProfileDefault.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.image_name,
        image_base64: dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref2 = dataBookingProfileDefault.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.image_base64,
        booking_profile_title: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref3 = dataBookingProfileDefault.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.booking_profile_title) || "",
        booking_profile_description: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref4 = dataBookingProfileDefault.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.booking_profile_description) || "",
        booking_profile_button_content: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref5 = dataBookingProfileDefault.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.booking_profile_button_content) || t("ss_builder_block_booking_file_button_label_default"),
        booking_profile_style: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref6 = dataBookingProfileDefault.style_attributes) === null || ref6 === void 0 ? void 0 : ref6.booking_profile_style) || BookingProfile_constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT,
        open_new_tab: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref7 = dataBookingProfileDefault.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.open_new_tab) || false,
        apply_block_settings: (dataBookingProfileDefault === null || dataBookingProfileDefault === void 0 ? void 0 : (ref8 = dataBookingProfileDefault.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.apply_block_settings) || false
    };
    var ref9 = (0,react.useState)(dataInitial), dataBookingProfile = ref9[0], setDataBookingProfile = ref9[1];
    var ref10 = (0,react.useState)(false), errorImage = ref10[0], setErrorImage = ref10[1];
    var domain = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref11;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref11 = ref.kol) === null || ref11 === void 0 ? void 0 : ref11.domain;
    });
    var bookingProfileLink = (0,react.useMemo)(function() {
        var link = "";
        if (domain) {
            link = "https://".concat(domain, "/booking-profile");
        }
        return link;
    }, [
        domain
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        var dataRequired = {
            bookingProfileButtonContent: dataBookingProfile.booking_profile_button_content,
            image: dataBookingProfile.image
        };
        var isValidRequired = Object.values(dataRequired).every(function(x) {
            return x;
        });
        var isError = !!(dataBookingProfile.booking_profile_style === BookingProfile_constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT && (!isValidRequired || errorImage));
        if (isEqual_default()(dataInitial, dataBookingProfile) || isError) {
            return true;
        }
        return false;
    }, [
        dataBookingProfile,
        dataInitial
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (!isEqual_default()(dataInitial, dataBookingProfile)) {
            return true;
        }
        return false;
    }, [
        dataBookingProfile
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
        return function() {
            setButtonStatus(true);
        };
    }, [
        isDisableBtnSave
    ]);
    (0,react.useEffect)(function() {
        setEditStatus(isEditDataStatus);
        return function() {
            setEditStatus(false);
        };
    }, [
        isEditDataStatus
    ]);
    (0,react.useEffect)(function() {
        var contentAttributes = {
            image: dataBookingProfile.image,
            image_name: dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.image_name,
            image_base64: dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.image_base64,
            booking_profile_title: dataBookingProfile.booking_profile_title.trim(),
            booking_profile_description: dataBookingProfile.booking_profile_description.trim(),
            booking_profile_button_content: dataBookingProfile.booking_profile_button_content.trim(),
            open_new_tab: (dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.open_new_tab) || false,
            apply_block_settings: (dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.apply_block_settings) || false
        };
        var styleAttributes = {
            booking_profile_style: (dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.booking_profile_style) || BookingProfile_constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT
        };
        if (!block.uid) {
            var defaultBookingProfile = {
                uid: UID,
                sort_order: 1,
                enable: configs_const/* ENABLE_BLOCK */.C5,
                block_type: BLOCK_TYPE.BOOKING_PROFILE,
                title: dataBookingProfile.title,
                content_attributes: contentAttributes,
                style_attributes: styleAttributes
            };
            onUpdateData(defaultBookingProfile);
        } else {
            onUpdateData(BookingProfile_objectSpread({}, block, {
                title: dataBookingProfile.title,
                content_attributes: contentAttributes,
                style_attributes: styleAttributes
            }));
        }
    }, [
        dataBookingProfile
    ]);
    var handleChange = function(nameField, value) {
        var dataBookingProfileCurrent = cloneDeep_default()(dataBookingProfile);
        if (nameField === BookingProfile_constant/* BOOKING_PROFILE_FIELD.IMAGE */.U.IMAGE) {
            setDataBookingProfile(BookingProfile_objectSpread({}, dataBookingProfileCurrent, {
                image_name: value === null || value === void 0 ? void 0 : value.file_name,
                image_base64: value === null || value === void 0 ? void 0 : value.base64,
                image: value === null || value === void 0 ? void 0 : value.url
            }));
            return;
        }
        setDataBookingProfile(BookingProfile_objectSpread({}, dataBookingProfileCurrent, BookingProfile_defineProperty({}, nameField, value)));
    };
    var handleClickCoppyLink = function() {
        (0,browser/* copyToClipboard */.v)(bookingProfileLink);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_block_link_copy_successfully_label")
            })
        });
    };
    var handleErrorImage = function(error) {
        setErrorImage(error);
    };
    var cardContentMode = !!((dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.booking_profile_style) === BookingProfile_constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT);
    var embedCodeMode = !!((dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.booking_profile_style) === BookingProfile_constant/* BOOKING_PROFILE_STYLE.EMBED_CODE */.W.EMBED_CODE);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StyleSelector, {
                data: dataBookingProfile === null || dataBookingProfile === void 0 ? void 0 : dataBookingProfile.booking_profile_style,
                onUpdateData: function(val) {
                    return handleChange(BookingProfile_constant/* BOOKING_PROFILE_FIELD.STYLE */.U.STYLE, val);
                }
            }),
            cardContentMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardContentStyle, {
                handleChange: handleChange,
                handleErrorImage: handleErrorImage,
                image: dataBookingProfile.image,
                booking_profile_title: dataBookingProfile.booking_profile_title,
                booking_profile_description: dataBookingProfile.booking_profile_description,
                booking_profile_button_content: dataBookingProfile.booking_profile_button_content
            }),
            embedCodeMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmbedCodeStyle, {
                handleChange: handleChange,
                openNewTab: dataBookingProfile.open_new_tab,
                applyBlockSettings: dataBookingProfile.apply_block_settings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-3 bg-white overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-x-1 mb-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#666666] text-[15px] leading-[150%]",
                                children: t("ss_builder_block_booking_file_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                content: t("ss_builder_block_booking_file_link_tooltip"),
                                placement: "top-start",
                                mode: "dark",
                                trigger: "click",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[21px] h-[21px] flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                                        fillColor: "#1890FF",
                                        className: "w-[15px] h-[15px] cursor-pointer"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center w-full justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[17px] leading-[150%] truncate",
                                style: {
                                    color: "rgba(51, 51, 51, 0.4)"
                                },
                                children: bookingProfileLink
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[24px] h-[24px] cursor-pointer flex items-center justify-center",
                                onClick: handleClickCoppyLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CoppyAltIcon */.tO, {
                                    width: 16,
                                    height: 16
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var block_editor_BookingProfile = (BookingProfile);

;// CONCATENATED MODULE: ./src/features/block/block.conf.ts
function block_conf_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function block_conf_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return block_conf_arrayLikeToArray(arr);
}
function block_conf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function block_conf_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                block_conf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                block_conf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function block_conf_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function block_conf_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function block_conf_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function block_conf_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            block_conf_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function block_conf_toConsumableArray(arr) {
    return block_conf_arrayWithoutHoles(arr) || block_conf_iterableToArray(arr) || block_conf_unsupportedIterableToArray(arr) || block_conf_nonIterableSpread();
}
function block_conf_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return block_conf_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return block_conf_arrayLikeToArray(o, minLen);
}














// import {
//   VIDEO_SHOUTOUT_BLOCK,
//   VIDEO_SHOUTOUT_BLOCK_TYPE,
//   VIDEO_SHOUTOUT_MIDDLEWARE,
// } from "@features/video-shoutout/config";









var Combined = react.lazy(function() {
    return Promise.all(/* import() */[__webpack_require__.e(779), __webpack_require__.e(286), __webpack_require__.e(551), __webpack_require__.e(258)]).then(__webpack_require__.bind(__webpack_require__, 43119));
});
var BLOCK_TYPE = block_conf_objectSpread({
    TEXT: "text",
    TAB_BAR: "tab_bar",
    TAB: "tabs",
    IMAGE_SLIDER: "image_slider",
    AFF_PRODUCT: "affiliate_product",
    STORY: "story",
    BIO: "bio",
    IMAGE: "image",
    BUTTON_LINK: "button_link",
    GIFT: "gift",
    DIGITAL_PRODUCT: "digital_product",
    // VIDEO_SHOUTOUT: "video_shoutout",
    AFF_PRODUCT_GROUP: "affiliate_product_group",
    IMAGE_GALLERY: "image_gallery",
    EMBED: "embed",
    CARD: "card",
    BUTTON_MULTI_LINK: "button_multi_link",
    IMAGE_POPUP: "image_popup",
    SPACER_AND_DIVIDER: "spacer_and_divider",
    COMBINED: "combined",
    BOOKING_PROFILE: "booking_profile"
}, mini_store_config/* MINI_STORE_BLOCK_TYPE */.Av);
var block_conf_obj;
var BLOCK_EDIT_COMPONENT_CONFIG = block_conf_objectSpread((block_conf_obj = {}, block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.TEXT, block_editor_TextV2), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.IMAGE_SLIDER, ImageSlider), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.TAB_BAR, block_editor_TabMenu), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.STORY, Story), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.BIO, Bio), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.IMAGE, Image), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.BUTTON_LINK, block_editor_ButtonLink), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.GIFT, Gift), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.DIGITAL_PRODUCT, block_editor_DigitalProduct), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.AFF_PRODUCT_GROUP, block_editor_AffiliateProductGroup), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.IMAGE_GALLERY, block_editor_ImageGallery), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.EMBED, block_editor_Embed), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.CARD, block_editor_Card), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.BUTTON_MULTI_LINK, block_editor_ButtonMultiLinks), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.IMAGE_POPUP, ImagePopup/* default */.Z), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.SPACER_AND_DIVIDER, block_editor_SpacerAndDivider), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.COMBINED, Combined), block_conf_defineProperty(block_conf_obj, BLOCK_TYPE.BOOKING_PROFILE, block_editor_BookingProfile), block_conf_obj), mini_store_config/* MINI_STORE_BLOCK */.LN);
var block_conf_obj1;
var BLOCK_TYPE_LANGUAGE_KEY = (block_conf_obj1 = {}, block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BUTTON_LINK, "ss_builder_title_block_button_link"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.IMAGE, "ss_builder_title_block_image"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.TEXT, "ss_builder_title_block_text"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BIO, "ss_builder_title_block_bio"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.STORY, "ss_builder_title_block_story"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.IMAGE_SLIDER, "ss_builder_title_block_image_slider"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BUTTON_MULTI_LINK, "ss_builder_title_block_button_multi_link"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.CARD, "ss_builder_title_block_card"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.EMBED, "ss_builder_title_block_embed"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.IMAGE_GALLERY, "ss_builder_title_block_image_gallery"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.AFF_PRODUCT_GROUP, "ss_builder_title_block_affiliate_product"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.GIFT, "ss_builder_title_block_virtual_gift"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.GIFT_FOOTER, "ss_builder_title_block_virtual_gift_footer"), // [BLOCK_TYPE.TRUTH_OR_DARE]: "ss_builder_title_block_truth_or_dare",
// [BLOCK_TYPE.TRUTH_OR_DARE_FOOTER]:
//   "ss_builder_title_block_truth_or_dare_footer",
block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.DONATION, "ss_builder_title_block_donation"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.DIGITAL_PRODUCT, "ss_builder_title_block_digital_product"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BRAND_GIFT, "ss_builder_title_block_brand_gift"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BRAND_GIFT_FOOTER, "ss_brand_gift_setting_title_block_footer"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.TAB_BAR, "ss_builder_title_block_tab_bar"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.IMAGE_POPUP, "ss_builder_title_block_image_popup"), // [BLOCK_TYPE.VIDEO_SHOUTOUT]: "ss_builder_title_block_video_shoutout",
block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.SPACER_AND_DIVIDER, "ss_builder_title_spacer_and_divider"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.COMBINED, "ss_builder_title_combined"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BRAND_RATING, "ss_builder_title_block_brand_rating"), block_conf_defineProperty(block_conf_obj1, BLOCK_TYPE.BOOKING_PROFILE, "ss_builder_title_block_booking_profile"), block_conf_obj1);
var uploadImageBase64Middleware = function() {
    var _ref1 = block_conf_asyncToGenerator(runtime_default().mark(function _callee1(data, extraData) {
        var imageArrItems, response, arrRequest, arrUrl, newImageArrItems, newData;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    if (!data) {
                        _ctx1.next = 18;
                        break;
                    }
                    imageArrItems = data.content_attributes && data.content_attributes.items;
                    response = null;
                    _ctx1.prev = 3;
                    arrRequest = imageArrItems && Array.isArray(imageArrItems) && imageArrItems.map(function() {
                        var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var eleImage, isImageBase64, requestContent, dataRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        eleImage = ele === null || ele === void 0 ? void 0 : ele.image;
                                        isImageBase64 = typeof eleImage == "string" && eleImage.startsWith("data:image");
                                        if (!(ele.image_base64 && ele.image_name || isImageBase64)) {
                                            _ctx.next = 11;
                                            break;
                                        }
                                        requestContent = block_conf_objectSpread({}, extraData, {
                                            content: ele.image_base64,
                                            name: ele.image_name
                                        });
                                        if (isImageBase64) {
                                            requestContent = block_conf_objectSpread({}, extraData, {
                                                content: eleImage,
                                                name: (ele === null || ele === void 0 ? void 0 : ele.image_name) || "image_name"
                                            });
                                        }
                                        _ctx.next = 7;
                                        return (0,api/* requestUploadImage */.MR)(requestContent);
                                    case 7:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 11:
                                        return _ctx.abrupt("return", block_conf_objectSpread({}, ele, {
                                            image_base64: undefined,
                                            image_name: undefined
                                        }));
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 7;
                    return Promise.all(arrRequest);
                case 7:
                    response = _ctx1.sent;
                    _ctx1.next = 13;
                    break;
                case 10:
                    _ctx1.prev = 10;
                    _ctx1.t0 = _ctx1["catch"](3);
                    throw _ctx1.t0;
                case 13:
                    if (!(response && response.every(function(x) {
                        return x !== undefined;
                    }))) {
                        _ctx1.next = 18;
                        break;
                    }
                    arrUrl = response.map(function(ele) {
                        var ref;
                        return (ref = ele === null || ele === void 0 ? void 0 : ele.url) !== null && ref !== void 0 ? ref : ele.image;
                    });
                    newImageArrItems = imageArrItems.map(function(element, index) {
                        return block_conf_objectSpread({}, element, {
                            image_base64: undefined,
                            image_name: undefined,
                            image: arrUrl[index]
                        });
                    });
                    newData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            items: newImageArrItems
                        })
                    });
                    return _ctx1.abrupt("return", newData);
                case 18:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function uploadImageBase64Middleware(data, extraData) {
        return _ref1.apply(this, arguments);
    };
}();
var requestPostLinkMiddleware = function() {
    var _ref2 = block_conf_asyncToGenerator(runtime_default().mark(function _callee2(data, extraData) {
        var ref, responsePostLink, newDataBlock, newProductsList, arrRequestPostLink, arrPostLink, newProductsItems, newData;
        return runtime_default().wrap(function _callee$(_ctx2) {
            while(1)switch(_ctx2.prev = _ctx2.next){
                case 0:
                    if (!data) {
                        _ctx2.next = 23;
                        break;
                    }
                    ;
                    responsePostLink = null;
                    _ctx2.next = 5;
                    return uploadImageBase64Middleware(data, extraData);
                case 5:
                    newDataBlock = _ctx2.sent;
                    newProductsList = newDataBlock === null || newDataBlock === void 0 ? void 0 : (ref = newDataBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                    if (!newProductsList) {
                        _ctx2.next = 23;
                        break;
                    }
                    _ctx2.prev = 8;
                    arrRequestPostLink = newProductsList && Array.isArray(newProductsList) && newProductsList.map(function() {
                        var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var dataRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (ele.post_link) {
                                            _ctx.next = 7;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return (0,api/* requestCreatePostLink */.mM)({
                                            origin_url: ele.origin_link,
                                            title: ele.title,
                                            image: ele.image,
                                            product: {
                                                id: ele.uid,
                                                name: ele.title,
                                                image: ele.image,
                                                source_url: ele.source_url,
                                                domain: ele.domain,
                                                source_id: ele.source_id,
                                                shop_id: ele.shop_id,
                                                source_type: ele.source_type
                                            }
                                        });
                                    case 3:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 7:
                                        return _ctx.abrupt("return", ele);
                                    case 8:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx2.next = 12;
                    return Promise.all(arrRequestPostLink);
                case 12:
                    responsePostLink = _ctx2.sent;
                    _ctx2.next = 18;
                    break;
                case 15:
                    _ctx2.prev = 15;
                    _ctx2.t0 = _ctx2["catch"](8);
                    console.log(_ctx2.t0);
                case 18:
                    if (!(responsePostLink && responsePostLink.every(function(x) {
                        return x !== undefined;
                    }))) {
                        _ctx2.next = 23;
                        break;
                    }
                    arrPostLink = responsePostLink.map(function(ele) {
                        return !ele.post_link ? {
                            id: ele.data.id,
                            origin_url: ele.data.url,
                            target_url: ele.data.target_url
                        } : ele.post_link;
                    });
                    newProductsItems = newProductsList.map(function(element, index) {
                        return !element.post_link ? {
                            uid: element.uid,
                            sort_order: element.sort_order,
                            image: element.image,
                            title: element.title,
                            use_aff_url: element.use_aff_url,
                            source_type: element.source_type,
                            enable: element.enable,
                            origin_link: element.origin_link,
                            post_link: arrPostLink[index]
                        } : element;
                    });
                    newData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            items: newProductsItems
                        })
                    });
                    return _ctx2.abrupt("return", newData);
                case 23:
                case "end":
                    return _ctx2.stop();
            }
        }, _callee2, null, [
            [
                8,
                15
            ]
        ]);
    }));
    return function requestPostLinkMiddleware(data, extraData) {
        return _ref2.apply(this, arguments);
    };
}();
var requestPostLinkMiddlewareV2 = function() {
    var _ref3 = block_conf_asyncToGenerator(runtime_default().mark(function _callee3(data, extraData) {
        var ref1, productGroupArr, productGroupItemsArr, newProductGroupData;
        return runtime_default().wrap(function _callee$(_ctx3) {
            while(1)switch(_ctx3.prev = _ctx3.next){
                case 0:
                    if (!data) {
                        _ctx3.next = 11;
                        break;
                    }
                    ;
                    productGroupArr = data === null || data === void 0 ? void 0 : (ref1 = data.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.items;
                    _ctx3.next = 5;
                    return Promise.all(productGroupArr === null || productGroupArr === void 0 ? void 0 : productGroupArr.map(function() {
                        var _ref4 = block_conf_asyncToGenerator(runtime_default().mark(function _callee4(ele1) {
                            var ref, responsePostLink, newDataBlock, newProductsList, arrRequestPostLink, arrPostLink, newProductsItems, newData;
                            return runtime_default().wrap(function _callee$(_ctx4) {
                                while(1)switch(_ctx4.prev = _ctx4.next){
                                    case 0:
                                        ;
                                        responsePostLink = null;
                                        _ctx4.next = 4;
                                        return uploadImageBase64Middleware(ele1, extraData);
                                    case 4:
                                        newDataBlock = _ctx4.sent;
                                        newProductsList = newDataBlock === null || newDataBlock === void 0 ? void 0 : (ref = newDataBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                                        if (!newProductsList) {
                                            _ctx4.next = 16;
                                            break;
                                        }
                                        arrRequestPostLink = newProductsList && Array.isArray(newProductsList) && newProductsList.map(function() {
                                            var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                                                var params, dataRequest;
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            if (ele.post_link) {
                                                                _ctx.next = 8;
                                                                break;
                                                            }
                                                            ;
                                                            params = {
                                                                origin_url: ele.origin_link,
                                                                title: ele.title,
                                                                image: ele.image,
                                                                product: {
                                                                    id: ele.uid,
                                                                    name: ele.title,
                                                                    image: ele.image,
                                                                    source_url: ele.source_url,
                                                                    domain: ele.domain,
                                                                    shortern_link: ele.shortern_link,
                                                                    source_id: ele.source_id,
                                                                    shop_id: ele.shop_id,
                                                                    source_type: ele.source_type
                                                                }
                                                            };
                                                            //Api postlink chỉ yêu cầu params is_import_json nên chỉ cần gửi lên is_import_json cho tất cả trường hợp
                                                            if ((ele === null || ele === void 0 ? void 0 : ele.is_import_json) || (ele === null || ele === void 0 ? void 0 : ele.is_import_by_url)) {
                                                                params.is_import_json = true;
                                                                delete params.product.id;
                                                            }
                                                            _ctx.next = 6;
                                                            return (0,api/* requestCreatePostLink */.mM)(params);
                                                        case 6:
                                                            dataRequest = _ctx.sent;
                                                            return _ctx.abrupt("return", dataRequest);
                                                        case 8:
                                                            return _ctx.abrupt("return", ele.post_link);
                                                        case 9:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(ele) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }());
                                        _ctx4.next = 10;
                                        return Promise.all(arrRequestPostLink);
                                    case 10:
                                        responsePostLink = _ctx4.sent.filter(function(item) {
                                            return !!item;
                                        });
                                        if (!(responsePostLink && responsePostLink.every(function(x) {
                                            return x !== undefined;
                                        }))) {
                                            _ctx4.next = 16;
                                            break;
                                        }
                                        arrPostLink = responsePostLink.map(function(ele) {
                                            // throw "Some item";
                                            if (ele.post_link) {
                                                return ele.post_link;
                                            }
                                            if (ele === null || ele === void 0 ? void 0 : ele.data) {
                                                return {
                                                    id: ele.data.id,
                                                    origin_url: ele.data.url,
                                                    target_url: ele.data.target_url
                                                };
                                            }
                                            return null;
                                        });
                                        newProductsItems = newProductsList.map(function(element, index) {
                                            var newProduct;
                                            newProduct = {
                                                uid: element.uid,
                                                sort_order: element.sort_order,
                                                image: element.image,
                                                title: element.title,
                                                use_aff_url: element.use_aff_url,
                                                source_type: element.source_type,
                                                enable: element.enable,
                                                origin_link: element.origin_link,
                                                shortern_link: element.shortern_link,
                                                is_cleanup_lock: element.is_cleanup_lock,
                                                label_product: element.label_product,
                                                post_link: arrPostLink ? arrPostLink[index] : null,
                                                open_new_tab: element === null || element === void 0 ? void 0 : element.open_new_tab,
                                                cat_id: element.cat_id,
                                                createdAt: element.createdAt
                                            };
                                            if (element === null || element === void 0 ? void 0 : element.is_import_json) {
                                                newProduct.is_import_json = element === null || element === void 0 ? void 0 : element.is_import_json;
                                                newProduct.id = (element === null || element === void 0 ? void 0 : element.id) || element.uid;
                                            } else if (element === null || element === void 0 ? void 0 : element.is_import_by_url) {
                                                newProduct.is_import_by_url = element === null || element === void 0 ? void 0 : element.is_import_by_url;
                                                newProduct.id = (element === null || element === void 0 ? void 0 : element.id) || element.uid;
                                            }
                                            return !element.post_link ? newProduct : element;
                                        }).filter(function(item) {
                                            return !!item.post_link;
                                        });
                                        newData = block_conf_objectSpread({}, ele1, {
                                            content_attributes: block_conf_objectSpread({}, ele1.content_attributes, {
                                                items: newProductsItems
                                            })
                                        });
                                        return _ctx4.abrupt("return", newData);
                                    case 16:
                                    case "end":
                                        return _ctx4.stop();
                                }
                            }, _callee4);
                        }));
                        return function(ele1) {
                            return _ref4.apply(this, arguments);
                        };
                    }())).catch(function(e) {
                        throw e;
                    });
                case 5:
                    productGroupItemsArr = _ctx3.sent;
                    if (!productGroupItemsArr) {
                        _ctx3.next = 9;
                        break;
                    }
                    newProductGroupData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            items: productGroupItemsArr
                        })
                    });
                    return _ctx3.abrupt("return", newProductGroupData);
                case 9:
                    _ctx3.next = 12;
                    break;
                case 11:
                    return _ctx3.abrupt("return", data);
                case 12:
                case "end":
                    return _ctx3.stop();
            }
        }, _callee3);
    }));
    return function requestPostLinkMiddlewareV2(data, extraData) {
        return _ref3.apply(this, arguments);
    };
}();
var BioMiddleware = function() {
    var _ref5 = block_conf_asyncToGenerator(runtime_default().mark(function _callee5(data, extraData) {
        var ref5, ref2, imageData, imageName, listCoverImage, listImageInBio, response, arrRequest, ref3, ref4, newData, newListCoverImage;
        return runtime_default().wrap(function _callee$(_ctx5) {
            while(1)switch(_ctx5.prev = _ctx5.next){
                case 0:
                    if (!data) {
                        _ctx5.next = 23;
                        break;
                    }
                    ;
                    imageData = data.content_attributes && data.content_attributes.bio_image_base64;
                    imageName = data.content_attributes && data.content_attributes.bio_image_name;
                    listCoverImage = data === null || data === void 0 ? void 0 : (ref5 = data.content_attributes) === null || ref5 === void 0 ? void 0 : (ref2 = ref5.bio_cover_image_list) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                        return {
                            content: item === null || item === void 0 ? void 0 : item.image_base64,
                            name: item === null || item === void 0 ? void 0 : item.image_name
                        };
                    });
                    listImageInBio = [
                        {
                            content: imageData,
                            name: imageName
                        }, 
                    ].concat(block_conf_toConsumableArray(listCoverImage));
                    response = null;
                    _ctx5.prev = 7;
                    arrRequest = listImageInBio === null || listImageInBio === void 0 ? void 0 : listImageInBio.map(function() {
                        var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var dataRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!((ele === null || ele === void 0 ? void 0 : ele.content) && (ele === null || ele === void 0 ? void 0 : ele.name))) {
                                            _ctx.next = 7;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return (0,api/* requestUploadImage */.MR)(block_conf_objectSpread({}, extraData, {
                                            content: ele === null || ele === void 0 ? void 0 : ele.content,
                                            name: ele === null || ele === void 0 ? void 0 : ele.name
                                        }));
                                    case 3:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 7:
                                        return _ctx.abrupt("return", ele);
                                    case 8:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx5.next = 11;
                    return Promise.all(arrRequest);
                case 11:
                    response = _ctx5.sent;
                    _ctx5.next = 17;
                    break;
                case 14:
                    _ctx5.prev = 14;
                    _ctx5.t0 = _ctx5["catch"](7);
                    console.log(_ctx5.t0);
                case 17:
                    if (!response) {
                        _ctx5.next = 23;
                        break;
                    }
                    ;
                    ;
                    newListCoverImage = data === null || data === void 0 ? void 0 : (ref3 = data.content_attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.bio_cover_image_list) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, index) {
                        var ref;
                        return block_conf_objectSpread({}, item, {
                            image_base64: null,
                            image: ((ref = response[index + 1]) === null || ref === void 0 ? void 0 : ref.url) || (item === null || item === void 0 ? void 0 : item.image)
                        });
                    });
                    if (imageData && imageName) {
                        newData = block_conf_objectSpread({}, data, {
                            content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                                bio_image_base64: undefined,
                                bio_image_name: undefined,
                                bio_image: response[0].url,
                                bio_cover_image_list: block_conf_toConsumableArray(newListCoverImage)
                            })
                        });
                    } else {
                        newData = block_conf_objectSpread({}, data, {
                            content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                                bio_image_base64: undefined,
                                bio_image_name: undefined,
                                bio_cover_image_list: block_conf_toConsumableArray(newListCoverImage)
                            })
                        });
                    }
                    return _ctx5.abrupt("return", newData);
                case 23:
                case "end":
                    return _ctx5.stop();
            }
        }, _callee5, null, [
            [
                7,
                14
            ]
        ]);
    }));
    return function BioMiddleware(data, extraData) {
        return _ref5.apply(this, arguments);
    };
}();
var ImageMiddleware = function() {
    var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(data, extraData) {
        var imageData, imageName, response, imageUrl, newData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!data) {
                        _ctx.next = 21;
                        break;
                    }
                    imageData = data.content_attributes && data.content_attributes.image_base64;
                    imageName = data.content_attributes && data.content_attributes.image_name;
                    response = null;
                    _ctx.prev = 4;
                    if (!(imageData && imageName)) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 8;
                    return (0,api/* requestUploadImage */.MR)(block_conf_objectSpread({}, extraData, {
                        content: imageData,
                        name: imageName
                    }));
                case 8:
                    response = _ctx.sent;
                    _ctx.next = 12;
                    break;
                case 11:
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.next = 17;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](4);
                    console.log(_ctx.t0);
                case 17:
                    if (!response) {
                        _ctx.next = 21;
                        break;
                    }
                    imageUrl = response === null || response === void 0 ? void 0 : response.url;
                    newData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            image_base64: undefined,
                            image_name: undefined,
                            image: imageUrl
                        })
                    });
                    return _ctx.abrupt("return", newData);
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                14
            ]
        ]);
    }));
    return function ImageMiddleware(data, extraData) {
        return _ref.apply(this, arguments);
    };
}();
var TabBarMiddleware = function() {
    var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(data, extraData, extraFunction) {
        var ref, newTabs;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!data) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    newTabs = data === null || data === void 0 ? void 0 : (ref = data.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                    if (newTabs) {
                        extraFunction === null || extraFunction === void 0 ? void 0 : extraFunction.handleUpdateTabsBody(newTabs);
                        data.content_attributes.items = undefined;
                    }
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function TabBarMiddleware(data, extraData, extraFunction) {
        return _ref.apply(this, arguments);
    };
}();
var ImageMiddleWareMulti = function() {
    var _ref6 = block_conf_asyncToGenerator(runtime_default().mark(function _callee6(data, extraData) {
        var imageArrItems, response, arrRequest, arrUrl, newImageArrItems, newData;
        return runtime_default().wrap(function _callee$(_ctx6) {
            while(1)switch(_ctx6.prev = _ctx6.next){
                case 0:
                    if (!data) {
                        _ctx6.next = 18;
                        break;
                    }
                    imageArrItems = data.content_attributes && data.content_attributes.items;
                    response = null;
                    _ctx6.prev = 3;
                    arrRequest = imageArrItems && Array.isArray(imageArrItems) && imageArrItems.map(function() {
                        var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(ele) {
                            var ref, ref6, ref7, ref8, dataRequest, ref9, ref10;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        if (!(((ref = ele.content_attributes) === null || ref === void 0 ? void 0 : ref.image_base64) && ((ref6 = ele.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.image_name))) {
                                            _ctx.next = 9;
                                            break;
                                        }
                                        ;
                                        _ctx.next = 5;
                                        return (0,api/* requestUploadImage */.MR)(block_conf_objectSpread({}, extraData, {
                                            content: (ref7 = ele.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.image_base64,
                                            name: (ref8 = ele.content_attributes) === null || ref8 === void 0 ? void 0 : ref8.image_name
                                        }));
                                    case 5:
                                        dataRequest = _ctx.sent;
                                        return _ctx.abrupt("return", dataRequest);
                                    case 9:
                                        ;
                                        ele === null || ele === void 0 ? void 0 : (ref9 = ele.content_attributes) === null || ref9 === void 0 ? void 0 : delete ref9.image_base64;
                                        ele === null || ele === void 0 ? void 0 : (ref10 = ele.content_attributes) === null || ref10 === void 0 ? void 0 : delete ref10.image_name;
                                        return _ctx.abrupt("return", ele);
                                    case 13:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(ele) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx6.next = 7;
                    return Promise.all(arrRequest);
                case 7:
                    response = _ctx6.sent;
                    _ctx6.next = 13;
                    break;
                case 10:
                    _ctx6.prev = 10;
                    _ctx6.t0 = _ctx6["catch"](3);
                    console.log(_ctx6.t0);
                case 13:
                    if (!(response && response.every(function(x) {
                        return x !== undefined;
                    }))) {
                        _ctx6.next = 18;
                        break;
                    }
                    arrUrl = response.map(function(ele) {
                        var ref;
                        var ref11;
                        return (ref11 = ele === null || ele === void 0 ? void 0 : ele.url) !== null && ref11 !== void 0 ? ref11 : ele === null || ele === void 0 ? void 0 : (ref = ele.content_attributes) === null || ref === void 0 ? void 0 : ref.image;
                    });
                    newImageArrItems = imageArrItems.map(function(element, index) {
                        var ref, ref12;
                        element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : delete ref.image_base64;
                        element === null || element === void 0 ? void 0 : (ref12 = element.content_attributes) === null || ref12 === void 0 ? void 0 : delete ref12.image_name;
                        return block_conf_objectSpread({}, element, {
                            content_attributes: block_conf_objectSpread({}, element.content_attributes, {
                                image: arrUrl[index]
                            })
                        });
                    });
                    newData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            items: newImageArrItems
                        })
                    });
                    return _ctx6.abrupt("return", newData);
                case 18:
                case "end":
                    return _ctx6.stop();
            }
        }, _callee6, null, [
            [
                3,
                10
            ]
        ]);
    }));
    return function ImageMiddleWareMulti(data, extraData) {
        return _ref6.apply(this, arguments);
    };
}();
var CombinedMiddleWare = function() {
    var _ref7 = block_conf_asyncToGenerator(runtime_default().mark(function _callee7(data, extraData, extraFunction) {
        var listBlock, middlewareArr, response1, newData;
        return runtime_default().wrap(function _callee$(_ctx7) {
            while(1)switch(_ctx7.prev = _ctx7.next){
                case 0:
                    _ctx7.prev = 0;
                    if (!data) {
                        _ctx7.next = 9;
                        break;
                    }
                    listBlock = data.content_attributes.blocks || [];
                    middlewareArr = listBlock.map(function() {
                        var _ref = block_conf_asyncToGenerator(runtime_default().mark(function _callee(block) {
                            var response;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!BLOCK_DATA_SAVE_MIDDLEWARE[block.block_type]) {
                                            _ctx.next = 5;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return BLOCK_DATA_SAVE_MIDDLEWARE[block.block_type](block, extraData, extraFunction);
                                    case 3:
                                        response = _ctx.sent;
                                        return _ctx.abrupt("return", response);
                                    case 5:
                                        return _ctx.abrupt("return", block);
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(block) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx7.next = 6;
                    return Promise.all(middlewareArr);
                case 6:
                    response1 = _ctx7.sent;
                    newData = block_conf_objectSpread({}, data, {
                        content_attributes: block_conf_objectSpread({}, data.content_attributes, {
                            blocks: response1
                        })
                    });
                    return _ctx7.abrupt("return", newData);
                case 9:
                    _ctx7.next = 14;
                    break;
                case 11:
                    _ctx7.prev = 11;
                    _ctx7.t0 = _ctx7["catch"](0);
                    console.log(_ctx7.t0);
                case 14:
                case "end":
                    return _ctx7.stop();
            }
        }, _callee7, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function CombinedMiddleWare(data, extraData, extraFunction) {
        return _ref7.apply(this, arguments);
    };
}();
var block_conf_obj2;
var BLOCK_DATA_SAVE_MIDDLEWARE = block_conf_objectSpread((block_conf_obj2 = {}, block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.IMAGE_SLIDER, uploadImageBase64Middleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.AFF_PRODUCT_GROUP, requestPostLinkMiddlewareV2), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.AFF_PRODUCT, requestPostLinkMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.STORY, highlightStoryMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.BIO, BioMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.IMAGE, ImageMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.IMAGE_GALLERY, ImageGalleryMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.CARD, uploadImageBase64Middleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.BUTTON_LINK, ImageMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.TAB_BAR, TabBarMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.BUTTON_MULTI_LINK, ImageMiddleWareMulti), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.IMAGE_POPUP, uploadImageBase64Middleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.SPACER_AND_DIVIDER, ImageMiddleware), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.COMBINED, CombinedMiddleWare), block_conf_defineProperty(block_conf_obj2, BLOCK_TYPE.BOOKING_PROFILE, ImageMiddleware), block_conf_obj2), mini_store_config/* MINI_STORE_MIDDLEWARE */.kY);


/***/ }),

/***/ 56751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function FormInput(props) {
    var label = props.label, _isRequire = props.isRequire, isRequire = _isRequire === void 0 ? false : _isRequire;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[15px] text-[#666666]",
                children: [
                    isRequire ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-red-600",
                        children: "*"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    label
                ]
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 62904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64035);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31567);




var HidddenWarningUI = function(param) {
    var label = param.label;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-[#FFF3E9] flex justify-center items-center p-2 gap-[10px]",
        style: {
            borderWidth: "1px 0px",
            borderStyle: "solid",
            borderColor: "#FFF3E9"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .EyeVisibleIcon */ .m0, {
                className: "align-middle inline-block fill-black",
                fillColor: "#FF6010",
                width: 18,
                height: 18
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[#FF6010]",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HidddenWarningUI);


/***/ }),

/***/ 46819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ItemsWithCheckbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/features/block/hooks/useHandleItems.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ACTIVE_STATUS;
(function(ACTIVE_STATUS) {
    ACTIVE_STATUS[ACTIVE_STATUS["ENABLE"] = 1] = "ENABLE";
    ACTIVE_STATUS[ACTIVE_STATUS["DISABLE"] = 2] = "DISABLE";
})(ACTIVE_STATUS || (ACTIVE_STATUS = {}));
var useActionItem = function(defaultList, propertiesIndex) {
    var ref1 = (0,react.useState)(cloneDeep_default()(defaultList)), items1 = ref1[0], setItems = ref1[1];
    var updateSortOrder = function(list) {
        return list.map(function(e, id) {
            return _objectSpread({}, e, {
                sort_order: id
            });
        });
    };
    var onReOrder = function(startIndex, endIndex) {
        var newItems = updateSortOrder(cloneDeep_default()(items1));
        var ref = _slicedToArray(newItems.splice(startIndex, 1), 1), removed = ref[0];
        newItems.splice(endIndex, 0, removed);
        setItems(updateSortOrder(newItems));
        return newItems;
    };
    var onAdd = function(item, position) {
        var newItems = cloneDeep_default()(items1);
        position === "TOP" ? newItems.unshift(item) : newItems.push(item);
        setItems(updateSortOrder(newItems));
        return newItems;
    };
    var onRemove = function(ids) {
        var newItems = items1.filter(function(e) {
            return !ids.includes(e[propertiesIndex]);
        });
        newItems = updateSortOrder(newItems);
        setItems(newItems);
        return newItems;
    };
    var onEnable = function(ids) {
        var newItems = cloneDeep_default()(items1).map(function(e) {
            return _objectSpread({}, e, {
                enable: ids.includes(e[propertiesIndex]) ? ACTIVE_STATUS.ENABLE : e.enable
            });
        });
        setItems(updateSortOrder(newItems));
        return newItems;
    };
    var onDisable = function(ids) {
        var newItems = cloneDeep_default()(items1).map(function(e) {
            return _objectSpread({}, e, {
                enable: ids.includes(e[propertiesIndex]) ? ACTIVE_STATUS.DISABLE : e.enable
            });
        });
        setItems(updateSortOrder(newItems));
        return newItems;
    };
    var onReset = function(items) {
        setItems(items);
        return items;
    };
    return {
        items: items1,
        onAdd: onAdd,
        onRemove: onRemove,
        onReOrder: onReOrder,
        onEnable: onEnable,
        onDisable: onDisable,
        onReset: onReset
    };
};
/* harmony default export */ var useHandleItems = (useActionItem);

// EXTERNAL MODULE: ./src/features/share/components/StickyChecking/index.tsx
var StickyChecking = __webpack_require__(22143);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./src/features/block/components/ItemsWithCheckbox/components/ItemWithCheckbox.tsx
function ItemWithCheckbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ItemWithCheckbox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ItemWithCheckbox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var ItemWithCheckbox = function(props) {
    var Item = props.itemUI, checked1 = props.checked, onChecked = props.onChecked, data = props.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
        className: "mt-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                checked: checked1,
                onChange: onChecked,
                icon: function(checked) {
                    return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsChecked */.z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsNotChecked */.VP, {});
                }
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, ItemWithCheckbox_objectSpread({}, data))
        })
    });
};
/* harmony default export */ var components_ItemWithCheckbox = (ItemWithCheckbox);

;// CONCATENATED MODULE: ./src/features/block/components/ItemsWithCheckbox/components/ListItemWithCheckbox.tsx
function ListItemWithCheckbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListItemWithCheckbox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListItemWithCheckbox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var ListItemWithCheckbox = function(props) {
    var defaultItems = props.defaultItems, Item = props.item, onSelect = props.onSelect, propertyIndex = props.propertyIndex;
    var onChange = function(list) {
        onSelect(list === null || list === void 0 ? void 0 : list.filter(function(e) {
            return e.checked;
        }));
    };
    var onChecked = function(id, value) {
        var newList = defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
            return ListItemWithCheckbox_objectSpread({}, item, {
                checked: item[propertyIndex] === id ? value : item.checked
            });
        });
        onChange(newList);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_ItemWithCheckbox, {
                data: item,
                itemUI: Item,
                checked: !!(item === null || item === void 0 ? void 0 : item.checked),
                onChecked: function(value) {
                    return onChecked(item[propertyIndex], value);
                }
            }, item[propertyIndex]);
        })
    });
};
/* harmony default export */ var components_ListItemWithCheckbox = (ListItemWithCheckbox);

;// CONCATENATED MODULE: ./src/features/block/components/ItemsWithCheckbox/index.tsx
function ItemsWithCheckbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ItemsWithCheckbox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ItemsWithCheckbox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var ActionEnum;
(function(ActionEnum) {
    ActionEnum[ActionEnum["VISIBLE"] = 0] = "VISIBLE";
    ActionEnum[ActionEnum["HIDE"] = 1] = "HIDE";
})(ActionEnum || (ActionEnum = {}));
var ItemsWithCheckbox = function(props) {
    var ref4;
    var defaultItems = props.defaultItems, Item = props.item, onChange = props.onChange, header = props.header, onCancel = props.onCancel, propertyIndex = props.propertyIndex, blockType = props.blockType, previousStickyElementId = props.previousStickyElementId;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var defaultItemsClone = cloneDeep_default()(defaultItems);
    var ref1 = useHandleItems(defaultItemsClone, "uid"), onReOrder = ref1.onReOrder, onRemove = ref1.onRemove, onDisable = ref1.onDisable, onEnable = ref1.onEnable, onAdd = ref1.onAdd, onReset = ref1.onReset;
    var popoverRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(defaultItemsClone), selectedItems = ref2[0], setSelectedItem = ref2[1];
    var actions = [
        {
            key: ActionEnum.VISIBLE,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: ""
            }),
            text: t("ss_builder_confirm_enable_item_checkbox_".concat(blockType, "_modal_title"))
        },
        {
            key: ActionEnum.HIDE,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: ""
            }),
            text: t("ss_builder_confirm_disable_item_checkbox_".concat(blockType, "_modal_title"))
        }, 
    ];
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case ActionEnum.VISIBLE:
                confirmEnable();
                break;
            case ActionEnum.HIDE:
                confirmDisable();
                break;
        }
    };
    var checkedItem1 = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(function(x) {
        return (x === null || x === void 0 ? void 0 : x.checked) === true;
    });
    var handleAction = function(action) {
        var ref, ref3;
        var ids = (ref3 = (ref = cloneDeep_default()(selectedItems)) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.checked) === true;
        })) === null || ref3 === void 0 ? void 0 : ref3.map(function(e) {
            return e[propertyIndex];
        });
        var newItems = action(ids);
        onChange(newItems);
        onCancel();
    };
    var handleSelect = function(list) {
        var newData = defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
            var checkedItem = list === null || list === void 0 ? void 0 : list.find(function(x) {
                return x.uid === item.uid;
            });
            return checkedItem || item;
        });
        setSelectedItem(newData);
    };
    var confirmEnable = function() {
        var onConfirm = function() {
            handleAction(onEnable);
            SuccessToast(t("ss_builder_enable_item_checkbox_".concat(blockType, "_successfully_label")));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_enable_item_checkbox_".concat(blockType, "_modal_title")),
            description: t("ss_builder_confirm_enable_item_checkbox_".concat(blockType, "_modal_content"), {
                quantity: checkedItem1.length
            }),
            confirmText: t("ss_builder_confirm_show_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var confirmRemove = function() {
        var onConfirm = function() {
            handleAction(onRemove);
            SuccessToast(t("ss_builder_delete_item_checkbox_".concat(blockType, "_successfully_label")));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_delete_item_checkbox_".concat(blockType, "_modal_title")),
            description: t("ss_builder_confirm_delete_item_checkbox_".concat(blockType, "_modal_content"), {
                quantity: checkedItem1.length
            }),
            confirmText: t("ss_builder_confirm_delete_product_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var confirmDisable = function() {
        var onConfirm = function() {
            handleAction(onDisable);
            SuccessToast(t("ss_builder_disable_item_checkbox_".concat(blockType, "_successfully_label")));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_disable_item_checkbox_".concat(blockType, "_modal_title")),
            description: t("ss_builder_confirm_disable_item_checkbox_".concat(blockType, "_modal_content"), {
                quantity: checkedItem1.length
            }),
            confirmText: t("ss_builder_confirm_hide_product_btn_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var previousStickyElementIdMemo = (0,react.useMemo)(function() {
        return previousStickyElementId || "block-".concat(blockType, "-editor-header");
    }, [
        previousStickyElementId,
        blockType
    ]);
    var handleCheckAll = function(value) {
        var newList = defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
            return ItemsWithCheckbox_objectSpread({}, item, {
                checked: value
            });
        });
        setSelectedItem(newList);
    };
    var handleSelectLast = function(count) {
        if ((defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.length) >= count) {
            var ref;
            var checkedData = (ref = defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.slice(Math.max(defaultItems.length - count, 0))) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                return ItemsWithCheckbox_objectSpread({}, item, {
                    checked: true
                });
            });
            var newData = defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
                var checkedItem = checkedData === null || checkedData === void 0 ? void 0 : checkedData.find(function(x) {
                    return x.uid === item.uid;
                });
                return checkedItem || item;
            });
            setSelectedItem(newData);
            return;
        }
        setSelectedItem(defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(function(item) {
            return ItemsWithCheckbox_objectSpread({}, item, {
                checked: true
            });
        }));
    };
    var indeterminate = (0,react.useMemo)(function() {
        return checkedItem1.length > 0 && checkedItem1.length < defaultItems.length;
    }, [
        checkedItem1,
        defaultItems
    ]);
    var isCheckAll = (0,react.useMemo)(function() {
        return selectedItems.every(function(e) {
            return e.checked;
        });
    }, [
        selectedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyChecking/* default */.Z, {
                previousStickyElementId: previousStickyElementIdMemo,
                currentStickyElementId: "header-list-items-checkbox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: "flex justify-between items-center z-10 px-3 py-4 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    header.title
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                onClick: onCancel,
                                size: "small",
                                fill: "solid",
                                color: "primary",
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseCircleIcon */.uC, {
                                        className: "w-[15px] h-[15px]",
                                        fillColor: "white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("ss_builder_cancel_select_multi_items")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-4 items-center ml-[10px] pb-4 z-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                                indeterminate: indeterminate,
                                checked: isCheckAll,
                                onChange: handleCheckAll,
                                icon: function(checked) {
                                    return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsChecked */.z, {}) : indeterminate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IndeterminateCheckboxIcon */.Xy, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconIsNotChecked */.VP, {});
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("ss_builder_select_multi_items"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row gap-2 items-center",
                                        children: [
                                            5,
                                            10,
                                            20
                                        ].map(function(e) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                shape: "rounded",
                                                fill: "solid",
                                                size: "small",
                                                onClick: function() {
                                                    return handleSelectLast(e);
                                                },
                                                children: t("ss_builder_filter_select_multi_items", {
                                                    num_items: e
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListItemWithCheckbox, {
                propertyIndex: "uid",
                defaultItems: selectedItems,
                item: Item,
                onSelect: handleSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-3 flex w-full justify-between items-center gap-2 z-[11] bg-[#FFFFFF]",
                ref: popoverRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-lg leading-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[#EE3244]",
                                children: [
                                    checkedItem1 === null || checkedItem1 === void 0 ? void 0 : checkedItem1.length,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (props === null || props === void 0 ? void 0 : (ref4 = props.footer) === null || ref4 === void 0 ? void 0 : ref4.countTitle) || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "small",
                                style: {
                                    border: "unset",
                                    padding: "3px 8px"
                                },
                                disabled: (checkedItem1 === null || checkedItem1 === void 0 ? void 0 : checkedItem1.length) === 0,
                                onClick: confirmRemove,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                    fillColor: "#EE3244"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                style: {
                                    opacity: (checkedItem1 === null || checkedItem1 === void 0 ? void 0 : checkedItem1.length) === 0 && "0.4"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, ItemsWithCheckbox_objectSpread({
                                    mode: "dark",
                                    actions: actions,
                                    placement: "top",
                                    trigger: "click",
                                    stopPropagation: [
                                        "click"
                                    ],
                                    getContainer: function() {
                                        return popoverRef.current;
                                    },
                                    onAction: function(item) {
                                        return handleClickPopoverItem(item);
                                    }
                                }, (checkedItem1 === null || checkedItem1 === void 0 ? void 0 : checkedItem1.length) === 0 ? {
                                    visible: false
                                } : {}, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        size: "small",
                                        style: {
                                            border: "unset",
                                            padding: "3px 8px"
                                        },
                                        disabled: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) === 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                            className: " cursor-pointer"
                                        })
                                    })
                                }))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ItemsWithCheckbox = (ItemsWithCheckbox);


/***/ }),

/***/ 39523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ getServiceLabelKey; },
/* harmony export */   "ZP": function() { return /* binding */ ServiceSelectorPopup; },
/* harmony export */   "h_": function() { return /* binding */ LinkServiceEnum; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _design_components_HeaderTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71214);
/* harmony import */ var _design_components_InnerPopup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51039);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31567);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13408);
/* harmony import */ var _share_icons_block_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65679);
/* harmony import */ var _share_IconRender__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39608);








var LinkServiceEnum;
(function(LinkServiceEnum) {
    LinkServiceEnum["DIGITAL"] = "digital";
    LinkServiceEnum["DONATION"] = "donation";
    LinkServiceEnum["GIFT"] = "gift";
    LinkServiceEnum["BRAND_GIFT"] = "brand_gift";
    LinkServiceEnum["TRUTH_OR_DARE"] = "tod";
})(LinkServiceEnum || (LinkServiceEnum = {}));
var SERVICE_ITEMS = [
    // {
    //     value: LinkServiceEnum.DIGITAL,
    //     label_key: 'ss_builder_title_block_digital_product',
    //     icon: <DigitalProducticonV2 className="align-middle inline-block w-6 h-6 rounded-lg" />
    // },
    {
        value: LinkServiceEnum.DONATION,
        label_key: "ss_builder_title_block_donation",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons_block_icons__WEBPACK_IMPORTED_MODULE_5__/* .IconDonation */ .qN, {
            className: "align-middle inline-block w-6 h-6 rounded-lg"
        })
    },
    {
        value: LinkServiceEnum.GIFT,
        label_key: "ss_builder_title_block_virtual_gift",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons_block_icons__WEBPACK_IMPORTED_MODULE_5__/* .GiftIconV2 */ .uR, {
            className: "align-middle inline-block w-6 h-6 rounded-lg"
        })
    },
    {
        value: LinkServiceEnum.BRAND_GIFT,
        label_key: "ss_builder_title_block_brand_gift",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons_block_icons__WEBPACK_IMPORTED_MODULE_5__/* .IconBrandGift */ .T0, {
            className: "align-middle inline-block w-6 h-6 rounded-lg"
        })
    },
    {
        value: LinkServiceEnum.TRUTH_OR_DARE,
        label_key: "ss_builder_title_block_truth_or_dare",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons_block_icons__WEBPACK_IMPORTED_MODULE_5__/* .TruthOrDareIcon */ .ZR, {
            className: "align-middle rounded-lg inline-block w-6 h-6 "
        })
    }, 
];
var getServiceLabelKey = function(value) {
    var item1 = SERVICE_ITEMS.find(function(item) {
        return item.value == value;
    });
    if (item1) {
        return item1.label_key;
    }
    return "None";
};
function ServiceSelectorPopup(props) {
    var ref4, ref1;
    var visible = props.visible, onSelect = props.onSelect, onClose = props.onClose, _getContainer = props.getContainer, getContainer = _getContainer === void 0 ? function() {
        return document.body;
    } : _getContainer, _defaultValue = props.defaultValue, defaultValue = _defaultValue === void 0 ? LinkServiceEnum.DIGITAL : _defaultValue;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)().t;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultValue), selectedValue = ref2[0], setSelectedValue = ref2[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var selectItem = function(value) {
        setSelectedValue(value);
    // onSelect(value);
    // onClose();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (visible) {
            setSelectedValue(defaultValue);
        }
    }, [
        visible
    ]);
    var _current;
    var maxServiceHeight = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        if ((containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) && buttonRef.current.offsetHeight) {
            var ref3;
            return (containerRef === null || containerRef === void 0 ? void 0 : (ref3 = containerRef.current) === null || ref3 === void 0 ? void 0 : ref3.offsetHeight) - buttonRef.current.offsetHeight;
        }
        return "100%";
    }, [
        containerRef.current && ((ref4 = containerRef.current) === null || ref4 === void 0 ? void 0 : ref4.offsetHeight),
        (_current = buttonRef.current) !== null && _current !== void 0 ? _current : (ref1 = buttonRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_components_InnerPopup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "rounded-t-lg",
        getContainer: getContainer,
        visible: visible,
        onClose: onClose,
        children: visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: containerRef,
            className: "relative rounded-t-lg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_components_HeaderTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClose: onClose,
                    title: t("ss_builder_link_select_service")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        maxHeight: maxServiceHeight
                    },
                    className: "h-full border-b",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .List */ .aV, {
                        children: SERVICE_ITEMS.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .List.Item */ .aV.Item, {
                                onClick: function() {
                                    return selectItem(item.value);
                                },
                                prefix: item.icon,
                                clickable: true,
                                arrow: false,
                                className: "relative",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between text-[17px]",
                                    children: [
                                        t(item.label_key),
                                        selectedValue == item.value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_IconRender__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            className: "w-4 h-4",
                                            containerClass: "block",
                                            fillColor: "#EE3244",
                                            iconName: "check.svg"
                                        })
                                    ]
                                })
                            }, item.value);
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: buttonRef,
                    className: "py-3 text-center bottom-0 px-4 bg-white",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                        className: "w-full",
                        onClick: function() {
                            onSelect(selectedValue);
                            onClose();
                        },
                        disabled: !selectedValue,
                        type: "button",
                        color: "primary",
                        children: t("ss_builder_popup_confirm_button")
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 86293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LinkTypeEnum; },
  "C": function() { return /* binding */ LinkInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/design-components/HeaderTitle/index.tsx
var HeaderTitle = __webpack_require__(71214);
// EXTERNAL MODULE: ./src/design-components/InnerPopup/index.tsx
var InnerPopup = __webpack_require__(51039);
// EXTERNAL MODULE: ./src/features/share/IconRender/index.tsx
var IconRender = __webpack_require__(39608);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
;// CONCATENATED MODULE: ./src/features/block/components/LinkInput/components/LinkTypeSelectorPopup/index.tsx








var LINK_TYPE_ITEMS = [
    {
        value: configs_const/* LINK_TYPE_LIST.WEB */.IZ.WEB,
        label_key: "ss_builder_link_type_web",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
            containerClass: "block",
            iconName: "globe.svg"
        })
    },
    {
        value: configs_const/* LINK_TYPE_LIST.PHONE */.IZ.PHONE,
        label_key: "ss_builder_link_type_phone",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
            containerClass: "block",
            iconName: "phone.svg"
        })
    },
    {
        value: configs_const/* LINK_TYPE_LIST.EMAIL */.IZ.EMAIL,
        label_key: "ss_builder_link_type_email",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
            containerClass: "block",
            iconName: "envelope.svg"
        })
    },
    {
        value: configs_const/* LINK_TYPE_LIST.SERVICE */.IZ.SERVICE,
        label_key: "ss_builder_link_type_service",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
            containerClass: "block",
            iconName: "selfie.svg"
        })
    }, 
];
function LinkTypeSelectorPopup(props) {
    var visible = props.visible, isHiddenService = props.isHiddenService, onSelect = props.onSelect, onClose = props.onClose, _getContainer = props.getContainer, getContainer = _getContainer === void 0 ? function() {
        return document.body;
    } : _getContainer;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var selectItem = function(value) {
        onSelect(value);
        onClose();
    };
    var linkTypeItem = LINK_TYPE_ITEMS;
    if (isHiddenService) {
        linkTypeItem = LINK_TYPE_ITEMS.filter(function(LINK_TYPE_ITEMS1) {
            return LINK_TYPE_ITEMS1.value !== configs_const/* LINK_TYPE_LIST.SERVICE */.IZ.SERVICE;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPopup/* default */.Z, {
        className: "",
        getContainer: getContainer,
        visible: visible,
        onClose: onClose,
        children: [
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle/* default */.Z, {
                    onClose: onClose,
                    title: t("ss_builder_select_link_type")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
                children: linkTypeItem.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                        onClick: function() {
                            return selectItem(item.value);
                        },
                        prefix: item.icon,
                        clickable: true,
                        arrow: false,
                        children: t(item.label_key)
                    }, item.value);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/block/components/LinkInput/components/ServiceSelectorPopup/index.tsx
var ServiceSelectorPopup = __webpack_require__(39523);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var api = __webpack_require__(85861);
// EXTERNAL MODULE: ./src/features/share/helper/validator.ts
var validator = __webpack_require__(52893);
;// CONCATENATED MODULE: ./src/features/block/components/LinkInput/helper/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var getIconName = function(type) {
    if (type == LinkTypeEnum.WEB) {
        return "globe.svg";
    } else if (type == LinkTypeEnum.PHONE) {
        return "phone.svg";
    } else if (type == LinkTypeEnum.EMAIL) {
        return "envelope.svg";
    } else if (type == LinkTypeEnum.SERVICE) {
        return "selfie.svg";
    }
    return "globe.svg";
};
var getPlaceHolderKey = function(type) {
    if (type == LinkTypeEnum.WEB) {
        return "ss_builder_url_placeholder";
    } else if (type == LinkTypeEnum.PHONE) {
        return "ss_builder_phone_placeholder";
    } else if (type == LinkTypeEnum.EMAIL) {
        return "ss_builder_email_placeholder";
    } else if (type == LinkTypeEnum.SERVICE) {
        return "ss_builder_service_placeholder";
    }
    return "ss_builder_url_placeholder";
};
var getLabelKey = function(type) {
    var reduce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (type == LinkTypeEnum.WEB) {
        return "ss_builder_link_type_web";
    } else if (type == LinkTypeEnum.PHONE) {
        if (reduce) {
            return "ss_builder_link_type_tel";
        }
        return "ss_builder_link_type_phone";
    } else if (type == LinkTypeEnum.EMAIL) {
        return "ss_builder_link_type_email";
    } else if (type == LinkTypeEnum.SERVICE) {
        return "ss_builder_link_type_service";
    }
    return "ss_builder_link_type_web";
};
function validateEmailUrl(url) {
    if (url) {
        if (url.indexOf("?") === -1) {
            return (0,validator/* isValidEmail */.vV)(url.toLowerCase());
        }
        var data = url.split("?");
        return (0,validator/* isValidEmail */.vV)(data[0].toLocaleLowerCase()) && (0,validator/* isValidQueryString */.AS)("".concat(data[1]));
    }
}
var validateLink = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
        var checkApiError, errorKey, warningKey, trimValue, ref, response, isSuccess, ref1, ref2, ref3, ref4, isAccepted, targetUrl, ref5, ref6, warningCode, ref7, errorCode, errorKey1, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    checkApiError = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    if (!data.value) {
                        _ctx.next = 36;
                        break;
                    }
                    errorKey = null;
                    warningKey = null;
                    trimValue = data.value.replaceAll(" ", "");
                    if (data.type == LinkTypeEnum.EMAIL) {
                        if (!validateEmailUrl(trimValue)) {
                            errorKey = "ss_builder_error_invalid_email_message";
                        }
                    }
                    if (data.type == LinkTypeEnum.PHONE) {
                        if (!(0,validator/* isPhoneNumber */.xT)(trimValue)) {
                            errorKey = "ss_builder_error_invalid_phone_message";
                        }
                    }
                    if (data.type == LinkTypeEnum.WEB) {
                        if (!(0,validator/* isValidUrl */.jv)(trimValue)) {
                            errorKey = "ss_builder_invalid_url";
                        }
                    }
                    if (!(!errorKey && data.type == LinkTypeEnum.WEB)) {
                        _ctx.next = 35;
                        break;
                    }
                    ;
                    _ctx.next = 12;
                    return (0,api/* requestValidateUrl */.nN)(trimValue);
                case 12:
                    response = _ctx.sent;
                    isSuccess = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success;
                    if (!isSuccess) {
                        _ctx.next = 28;
                        break;
                    }
                    ;
                    isAccepted = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.accepted;
                    targetUrl = response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.target_url;
                    if (isAccepted) {
                        _ctx.next = 25;
                        break;
                    }
                    ;
                    warningCode = response === null || response === void 0 ? void 0 : (ref5 = response.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.warning_code;
                    if (warningCode) {
                        warningKey = "ss_validate_origin_url_warning_".concat(warningCode);
                    }
                    return _ctx.abrupt("return", {
                        error_key: null,
                        warning_key: warningKey,
                        target_url: targetUrl,
                        allow_aff: isAccepted
                    });
                case 25:
                    return _ctx.abrupt("return", {
                        error_key: null,
                        warning_key: null,
                        target_url: targetUrl,
                        allow_aff: isAccepted
                    });
                case 26:
                    _ctx.next = 33;
                    break;
                case 28:
                    ;
                    errorCode = response === null || response === void 0 ? void 0 : (ref7 = response.data) === null || ref7 === void 0 ? void 0 : ref7.error_code;
                    errorKey1 = null;
                    if (errorCode) {
                        errorKey1 = "ss_validate_origin_url_error_".concat(errorCode);
                    }
                    return _ctx.abrupt("return", {
                        error_key: checkApiError ? errorKey1 : null,
                        warning_key: null
                    });
                case 33:
                    _ctx.next = 36;
                    break;
                case 35:
                    return _ctx.abrupt("return", {
                        error_key: errorKey,
                        warning_key: null
                    });
                case 36:
                    return _ctx.abrupt("return", {
                        error_key: null,
                        warning_key: null
                    });
                case 37:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function validateLink(data) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/block/components/LinkInput/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var LINK_TYPE_WEB = "web";
var LINK_TYPE_PHONE = "phone";
var LINK_TYPE_EMAIL = "email";
var LINK_TYPE_SERVICE = "service";
var LinkTypeEnum;
(function(LinkTypeEnum) {
    LinkTypeEnum["WEB"] = "web";
    LinkTypeEnum["PHONE"] = "phone";
    LinkTypeEnum["EMAIL"] = "email";
    LinkTypeEnum["SERVICE"] = "service";
})(LinkTypeEnum || (LinkTypeEnum = {}));
var DownIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "9",
        height: "10",
        viewBox: "0 0 9 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.62426 2.93668H1.37625C1.2327 2.93668 1.09351 2.98579 0.982157 3.07452C0.713341 3.28991 0.671584 3.68104 0.889072 3.94726L4.01308 7.76903C4.04092 7.80263 4.07136 7.83364 4.10616 7.86121C4.37498 8.07659 4.76907 8.03524 4.98743 7.76903L8.11056 3.94726C8.20104 3.83698 8.24976 3.69914 8.24976 3.55698C8.25062 3.21409 7.96963 2.93668 7.62426 2.93668Z",
            fill: "#CCCCCC"
        })
    });
};
var ArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.79794 0.703245L7.85859 6.55293C8.04317 6.73671 8.05403 7.02795 7.89116 7.22437L7.85859 7.26004L1.79821 13.2937C1.77322 13.3185 1.7394 13.3325 1.70414 13.3325H0.661898C0.58826 13.3325 0.528564 13.2728 0.528564 13.1992C0.528564 13.1637 0.542692 13.1297 0.567822 13.1047L6.77307 6.92641L0.574246 0.894742C0.521469 0.843388 0.520316 0.758974 0.571669 0.706197C0.596771 0.6804 0.631236 0.665848 0.66723 0.665848H1.70534C1.73989 0.665848 1.77309 0.679255 1.79794 0.703245Z",
            fill: "#CCCCCC"
        })
    });
};
function LinkInput(props) {
    var item = props.item, onChange = props.onChange, _onError = props.onError, onError = _onError === void 0 ? function() {} : _onError, _onWarning = props.onWarning, onWarning = _onWarning === void 0 ? function() {} : _onWarning, _onLoading = props.onLoading, onLoading = _onLoading === void 0 ? function() {} : _onLoading, _isHiddenService = props.isHiddenService, isHiddenService = _isHiddenService === void 0 ? false : _isHiddenService;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var debounceValue = (0,esm/* useDebounce */.Nr)(item, 1000);
    var containerRef = (0,react.useRef)();
    var _getPopupRef = props.getPopupRef, getPopupRef = _getPopupRef === void 0 ? function() {
        return containerRef.current;
    } : _getPopupRef;
    var ref = (0,react.useState)(false), showLinkSelectorPopup = ref[0], setShowLinkSelectorPopup = ref[1];
    var ref1 = (0,react.useState)(false), showServiceSelectorPopup = ref1[0], setShowServiceSelectorPopup = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(null), warningMessage = ref3[0], setWarningMessage = ref3[1];
    var iconName = getIconName(item.type);
    var placeHolderKey = getPlaceHolderKey(item.type);
    var onUpdateType = function(type) {
        if (type != item.type) {
            onLoading(false);
            var value = type !== LinkTypeEnum.SERVICE ? "" : ServiceSelectorPopup/* LinkServiceEnum.DONATION */.h_.DONATION;
            onChange({
                type: type,
                value: value
            });
        } else {
            onChange(_objectSpread({}, item, {
                type: type
            }));
        }
    };
    var valueDisplayElement = (0,react.useMemo)(function() {
        if (item.type !== LinkTypeEnum.SERVICE) {
            var type = "url";
            if (item.type === LinkTypeEnum.EMAIL) type = "email";
            if (item.type === LinkTypeEnum.PHONE) type = "tel";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                type: type,
                placeholder: t(placeHolderKey),
                value: item.value || "",
                onChange: function(val) {
                    onLoading(true);
                    onChange(_objectSpread({}, item, {
                        value: val
                    }));
                }
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            onClick: function() {
                return setShowServiceSelectorPopup(true);
            },
            className: "text-lg w-full flex items-center justify-between pr-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t((0,ServiceSelectorPopup/* getServiceLabelKey */.Hr)(item.value))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
                })
            ]
        });
    }, [
        item,
        placeHolderKey
    ]);
    var isFirstRender = (0,esm/* useIsFirstRender */.YZ)();
    (0,react.useEffect)(function() {
        if (isFirstRender) {
            return;
        }
        if (debounceValue.value) {
            onLoading(true);
            validateLink(debounceValue).then(function(result) {
                if (result.warning_key) {
                    setWarningMessage(result.warning_key ? t(result.warning_key) : null);
                } else {
                    setWarningMessage(null);
                }
                if (result.error_key) {
                    setErrorMessage(result.error_key ? t(result.error_key) : null);
                } else {
                    setErrorMessage(null);
                }
                onChange(_objectSpread({}, item, {
                    target_url: (result === null || result === void 0 ? void 0 : result.target_url) || debounceValue.value,
                    allow_aff: result === null || result === void 0 ? void 0 : result.allow_aff
                }));
                onLoading(false);
            });
        } else {
            setWarningMessage(null);
            setErrorMessage(null);
            onLoading(false);
        }
    }, [
        debounceValue.type,
        debounceValue.value
    ]);
    (0,react.useEffect)(function() {
        onWarning(warningMessage);
    }, [
        warningMessage
    ]);
    (0,react.useEffect)(function() {
        onError(errorMessage);
    }, [
        errorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex items-center border-r cursor-pointer",
                        onClick: function() {
                            return setShowLinkSelectorPopup(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-[6px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                    className: "w-d h-4",
                                    containerClass: "flex",
                                    iconName: iconName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-[6px] text-lg",
                                children: t(getLabelKey(item.type, true))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-[6px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownIcon, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow pl-3",
                        children: valueDisplayElement
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[13px] leading-[17px] text-[#FF3141]",
                children: errorMessage
            }),
            warningMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[13px] leading-[17px] text-[#F59020]",
                children: warningMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTypeSelectorPopup, {
                getContainer: getPopupRef,
                visible: showLinkSelectorPopup,
                onSelect: onUpdateType,
                onClose: function() {
                    return setShowLinkSelectorPopup(false);
                },
                isHiddenService: isHiddenService
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceSelectorPopup/* default */.ZP, {
                defaultValue: item.value,
                getContainer: getPopupRef,
                visible: showServiceSelectorPopup,
                onSelect: function(value) {
                    return onChange(_objectSpread({}, item, {
                        value: value
                    }));
                },
                onClose: function() {
                    return setShowServiceSelectorPopup(false);
                }
            })
        ]
    });
};


/***/ }),

/***/ 93807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* binding */ SelectionStateEnum; },
/* harmony export */   "Rz": function() { return /* binding */ POSITION_TYPE; },
/* harmony export */   "fP": function() { return /* binding */ SelectionState; },
/* harmony export */   "yo": function() { return /* binding */ ITEMS_MODE; }
/* harmony export */ });
var SelectionStateEnum;
(function(SelectionStateEnum) {
    SelectionStateEnum[SelectionStateEnum["ENABLE"] = 1] = "ENABLE";
    SelectionStateEnum[SelectionStateEnum["DISABLE"] = 2] = "DISABLE";
    SelectionStateEnum[SelectionStateEnum["HIDDEN"] = 3] = "HIDDEN";
})(SelectionStateEnum || (SelectionStateEnum = {}));
var SelectionState = {
    ENABLE: 1,
    DISABLE: 2,
    HIDDEN: 3
};
var POSITION_TYPE;
(function(POSITION_TYPE) {
    POSITION_TYPE["HEADER"] = "header";
    POSITION_TYPE["BODY"] = "body";
    POSITION_TYPE["FOOTER"] = "footer";
    POSITION_TYPE["EXPAND"] = "expand";
})(POSITION_TYPE || (POSITION_TYPE = {}));
var ITEMS_MODE;
(function(ITEMS_MODE) {
    ITEMS_MODE[ITEMS_MODE["DRAG"] = 0] = "DRAG";
    ITEMS_MODE[ITEMS_MODE["SELECT_ITEMS"] = 1] = "SELECT_ITEMS";
})(ITEMS_MODE || (ITEMS_MODE = {}));


/***/ }),

/***/ 22814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ object_equals; },
/* harmony export */   "KL": function() { return /* binding */ generateColorFunc; },
/* harmony export */   "ZB": function() { return /* binding */ isExistedInvalidImageUrl; },
/* harmony export */   "ZJ": function() { return /* binding */ _delete; },
/* harmony export */   "gJ": function() { return /* binding */ isExistedProductFromJson; },
/* harmony export */   "i": function() { return /* binding */ scrollToNewItem; },
/* harmony export */   "xZ": function() { return /* binding */ getMeta; }
/* harmony export */ });
/* unused harmony exports validateImageUrl, validateEcoServerImageUrl */
/* harmony import */ var _share_lib_generateColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31753);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var scrollToNewItem = function(elementId) {
    var queryAttr = "data-rbd-drag-handle-draggable-id";
    var domQuery = "[".concat(queryAttr, "='").concat(elementId, "']");
    setTimeout(function() {
        var addNewElement = document.querySelector(domQuery);
        addNewElement === null || addNewElement === void 0 ? void 0 : addNewElement.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, 300);
};
function _delete(obj, prop) {
    if (obj && obj[prop] && !obj[prop].length) delete obj[prop];
}
function object_equals(x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same
    if (!_instanceof(x, Object) || !_instanceof(y, Object)) return false;
    // if they are not strictly equal, they both need to be Objects
    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.
    for(var p in x){
        if (!x.hasOwnProperty(p)) continue;
        // other properties were tested using x.constructor === y.constructor
        if (!y.hasOwnProperty(p)) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined
        if (x[p] === y[p]) continue;
        // if they have the same strict value or identity then they are equal
        if (typeof x[p] !== "object") return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal
        if (!object_equals(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
    }
    for(p in y)if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
    // allows x[ p ] to be set to undefined
    return true;
}
function generateColorFunc(color) {
    var COLOR_LENGTH_DEFAULT = 9;
    var opacityColor = (color === null || color === void 0 ? void 0 : color.length) == COLOR_LENGTH_DEFAULT ? color.slice(-2) : "ff";
    var parseColorValues = _share_lib_generateColor__WEBPACK_IMPORTED_MODULE_0__/* .parseColorValues */ .Yu(color) || [];
    var ref;
    var calculateShades = _share_lib_generateColor__WEBPACK_IMPORTED_MODULE_0__/* .calculateShades */ .ZN((ref = parseColorValues[0]) !== null && ref !== void 0 ? ref : color.replace("#", ""));
    var ref1;
    var calculateTints = _share_lib_generateColor__WEBPACK_IMPORTED_MODULE_0__/* .calculateTints */ .SC((ref1 = parseColorValues[0]) !== null && ref1 !== void 0 ? ref1 : color.replace("#", ""));
    return _toConsumableArray(calculateTints.reverse()).concat(_toConsumableArray(calculateShades)).map(function(ele) {
        return "".concat(ele).concat(opacityColor);
    });
}
var getMeta = function(url) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = function(err) {
            return reject(err);
        };
        img.src = url;
    });
};
var isExistedProductFromJson = function(products) {
    return !!(products === null || products === void 0 ? void 0 : products.some(function(product) {
        return product.is_import_json === true || (product === null || product === void 0 ? void 0 : product.is_import_by_url) === true;
    }));
};
var validateImageUrl = function(url) {
    var shopeeRegex = /https?:\/\/(.+\.)?(shopee\.[a-z\.]{2,}|shope\.ee|shp\.ee)\/file\//g;
    var lzdRegex = /https?:\/\/(?:.+\.)?(?:slatic|alicdn)\.[a-z\.]{2,}\//g;
    var tikiRegex = /https?:\/\/(?:.+\.)?tikicdn\.[a-z\.]{2,}\//g;
    return shopeeRegex.test(url) || lzdRegex.test(url) || tikiRegex.test(url) || validateEcoServerImageUrl(url);
};
var validateEcoServerImageUrl = function(url) {
    return (url === null || url === void 0 ? void 0 : url.startsWith("https://s.dev.ecomobi.com")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://file-dev.ecomobi.com")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://i.ecomobi.com")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://ss.ecomobi.com")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://passio-prod.s3-ap-southeast-1.amazonaws.com")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://image.passio.eco"));
};
var isExistedInvalidImageUrl = function(products) {
    return !!(products === null || products === void 0 ? void 0 : products.some(function(product) {
        return !validateImageUrl(product === null || product === void 0 ? void 0 : product.image);
    }));
};


/***/ }),

/***/ 18684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mw": function() { return /* binding */ openPopup; },
/* harmony export */   "j4": function() { return /* binding */ closePopup; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);

var initialState = {
    open: false,
    block_data: null,
    position_uid: null,
    tab_uid: null,
    position_id: null,
    KEY: null,
    sort_order: null
};
var edittingBlockSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "edittingBlock",
    initialState: initialState,
    reducers: {
        openPopup: function(state, param) {
            var _payload = param.payload, block = _payload.block, _position_uid = _payload.position_uid, position_uid = _position_uid === void 0 ? null : _position_uid, _tab_uid = _payload.tab_uid, tab_uid = _tab_uid === void 0 ? null : _tab_uid, _KEY = _payload.KEY, KEY = _KEY === void 0 ? null : _KEY, _position_id = _payload.position_id, position_id = _position_id === void 0 ? null : _position_id, _sort_order = _payload.sort_order, sort_order = _sort_order === void 0 ? null : _sort_order;
            state.open = true;
            state.block_data = block;
            state.position_uid = position_uid;
            state.position_id = position_id, state.tab_uid = tab_uid;
            state.KEY = KEY;
            state.sort_order = sort_order;
        },
        closePopup: function(state) {
            state.open = false;
            state.block_data = null;
            state.position_uid = null;
            state.tab_uid = null;
            state.KEY = null;
            state.sort_order = null;
        }
    }
});
var _actions = edittingBlockSlice.actions;
var openPopup = _actions.openPopup, closePopup = _actions.closePopup;
/* harmony default export */ __webpack_exports__["ZP"] = (edittingBlockSlice.reducer);


/***/ }),

/***/ 80560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ findBlock; },
/* harmony export */   "r": function() { return /* binding */ getParentId; }
/* harmony export */ });
/* harmony import */ var _features_block_block_conf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60920);

function findBlock(positions, query) {
    var id = query.id, uid = query.uid, positionSlug = query.positionSlug, tabUid = query.tabUid;
    if (!id && !uid) {
        throw "Uid or id is required";
    }
    if (positionSlug == "body" && !tabUid) {
        throw "Tab uid is required";
    }
    var blockList = [];
    if (positionSlug === "body") {
        blockList = getBlockListInTab(tabUid, positions);
    } else {
        blockList = positions.find(function(position) {
            return position.slug == positionSlug;
        }).block_list;
    }
    if (id) {
        return blockList.find(function(block) {
            return block.id === id;
        });
    } else {
        return blockList.find(function(block) {
            return block.uid === uid;
        });
    }
}
function getBlockListInTab(tabUid, positions) {
    var ref;
    var tabs = positions.find(function(position) {
        return position.slug == "body";
    }).block_list.find(function(item) {
        return item.block_type == _features_block_block_conf__WEBPACK_IMPORTED_MODULE_0__/* .BLOCK_TYPE.TAB */ .bF.TAB;
    });
    if (!tabs) {
        throw "Block tab not found";
    }
    var tabList = tabs === null || tabs === void 0 ? void 0 : (ref = tabs.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs;
    if (!tabList) {
        throw "Tab list not found";
    }
    var tab1 = tabList.find(function(tab) {
        return tab.uid == tabUid;
    });
    if (!tab1) {
        throw "Tab not found";
    }
    var blockList = tab1 === null || tab1 === void 0 ? void 0 : tab1.block_list;
    if (!blockList) {
        throw "Block list not found";
    }
    return blockList;
}
function getParentId(positions, query) {
    var positionSlug = query.positionSlug, tabUid = query.tabUid;
    var tabs = positions.find(function(position) {
        return position.slug == "body";
    }).block_list.find(function(item) {
        return item.block_type == _features_block_block_conf__WEBPACK_IMPORTED_MODULE_0__/* .BLOCK_TYPE.TAB */ .bF.TAB;
    });
    if (!tabs) {
        throw "Block tab not found";
    }
    if (!positionSlug) {
        throw "Position Slug not found";
    }
    if (positionSlug === "header" || positionSlug === "footer") {
        return "0";
    } else {
        return tabs === null || tabs === void 0 ? void 0 : tabs.id;
    }
}


/***/ }),

/***/ 36629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddNewBlock_AddNewBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/share/IconRender/index.tsx
var IconRender = __webpack_require__(39608);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/features/share/components/Box/index.tsx








var boxStyle = {
    "--border-color": "#eee",
    "--background-color": "#fff",
    "--text-color": "#333333"
};
var SingleBoxComponent = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var onSelect = props.onSelect, item = props.item, selected = props.selected;
    var getTitle = (0,react.useMemo)(function() {
        var id = item && item.id;
        switch(id){
            case config_interface/* POSITION_TYPE.HEADER */.Rz.HEADER:
                return t("ss_builder_header_title");
            case config_interface/* POSITION_TYPE.FOOTER */.Rz.FOOTER:
                return t("ss_builder_footer_title");
            case config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND:
                return t("ss_build_expand_block_label");
            case config_interface/* POSITION_TYPE.BODY */.Rz.BODY:
                return t("ss_builder_body_title");
            default:
        }
    }, [
        item
    ]);
    if (item === null || item === void 0 ? void 0 : item.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                contentPosition: "left",
                className: classnames_default()("divider-design divider-design-popup adm-default", item.id === config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND && "expand-position-title"),
                style: {
                    margin: "0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center font-normal",
                    children: getTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return !item.disabled && onSelect(item === null || item === void 0 ? void 0 : item.id);
                },
                className: classnames_default()("p-[10px] bg-[#F5F5F5] mb-3 rounded-[2px]", item.disabled ? "cursor-not-allowed" : "cursor-pointer "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                    className: "w-full",
                    style: {
                        "--checked-border": "solid var(--adm-color-primary) 1px",
                        "--color": "#FFFFFF"
                    },
                    options: [
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    item.title,
                                    " (",
                                    "".concat(item.count, "/").concat(item.max),
                                    ")",
                                    item.disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("text-[#FF3141] text-[13px]"),
                                        children: item.message
                                    })
                                ]
                            }),
                            value: item.id,
                            disabled: item.disabled
                        }, 
                    ],
                    onChange: function(val) {
                        return onSelect(val[0]);
                    },
                    value: [
                        selected === null || selected === void 0 ? void 0 : selected.position
                    ]
                })
            })
        ]
    });
};
var MultiBoxComponent = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var onSelect = props.onSelect, item = props.item, selected = props.selected;
    var style = {
        maxWidth: "calc(100% - 20px)"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                contentPosition: "left",
                className: "divider-design divider-design-popup adm-default",
                style: {
                    margin: "0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center font-normal",
                    children: t("ss_builder_body_title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-[10px] pb-[2px] mb-3 bg-[#F5F5F5] rounded-[2px] text-[15px] text-[#999] selector-body",
                children: item.listBox.map(function(ele, index) {
                    if (ele === null || ele === void 0 ? void 0 : ele.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                            className: "w-full",
                            style: {
                                "--checked-border": "solid var(--adm-color-primary) 1px",
                                "--color": "#FFFFFF"
                            },
                            options: [
                                {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        style: style,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mr-2 h-[18px] flex items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                                                    iconName: ele.icon
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[80%] pr-1",
                                                                children: ele.title
                                                            }),
                                                            "(",
                                                            ele.count,
                                                            "/",
                                                            ele.max,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-[20px]",
                                                        children: [
                                                            ele.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* HomeIcon */.tv, {
                                                                width: 16,
                                                                height: 16
                                                            }),
                                                            ele.enable && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                                                                fillColor: "#999",
                                                                width: 16,
                                                                height: 16
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            ele.disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#FF3141] text-[13px] text-left",
                                                children: ele.message
                                            })
                                        ]
                                    }),
                                    value: ele.id,
                                    disabled: ele.disabled
                                }, 
                            ],
                            onChange: function(val) {
                                return !ele.disabled && onSelect(item === null || item === void 0 ? void 0 : item.id, val[0]);
                            },
                            value: [
                                selected === null || selected === void 0 ? void 0 : selected.uid
                            ]
                        })
                    }, ele.id || index);
                })
            })
        ]
    });
};
var Box = {
    SingleBox: SingleBoxComponent,
    MultiBox: MultiBoxComponent
};

;// CONCATENATED MODULE: ./src/features/design/components/AddNewBlock/BlockLayoutComponent/PositionOption.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var ONE_TAB = 1;
var PositionOption = function(props) {
    var ref5;
    var position = props.position, onSelect = props.onSelect, selected = props.selected, extraProps = props.extraProps;
    var positionTransformed = (0,react.useMemo)(function() {
        var ref7, ref1, ref2, ref3, ref4;
        var tabLists = ((ref7 = position === null || position === void 0 ? void 0 : position.block_list[0]) === null || ref7 === void 0 ? void 0 : (ref1 = ref7.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.tabs) || [];
        var countOfBlock = (position === null || position === void 0 ? void 0 : position.slug) !== config_interface/* POSITION_TYPE.BODY */.Rz.BODY ? (position === null || position === void 0 ? void 0 : (ref2 = position.block_list) === null || ref2 === void 0 ? void 0 : ref2.length) || 0 : ((ref3 = tabLists[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.block_list) === null || ref4 === void 0 ? void 0 : ref4.length) || 0;
        var isPositionFull = countOfBlock >= position.block_maximum;
        var displayEnablePosition = (position === null || position === void 0 ? void 0 : position.enable) !== configs_const/* ENABLE_POSITION */.Qz;
        var style = isPositionFull ? "cursor-not-allowed" : "cursor-pointer ";
        var isHiddenPositon = (position === null || position === void 0 ? void 0 : position.slug) === (extraProps === null || extraProps === void 0 ? void 0 : extraProps.position_slug);
        var tabs = tabLists === null || tabLists === void 0 ? void 0 : tabLists.map(function(e) {
            var ref, ref6;
            var isTabFull = (e === null || e === void 0 ? void 0 : (ref = e.block_list) === null || ref === void 0 ? void 0 : ref.length) >= position.block_maximum;
            var displayEnableTab = (e === null || e === void 0 ? void 0 : e.enable) !== configs_const/* ENABLE_POSITION */.Qz;
            var isHiddenTab = (e === null || e === void 0 ? void 0 : e.uid) === (extraProps === null || extraProps === void 0 ? void 0 : extraProps.tab_uid);
            return _objectSpread({}, e, {
                count: e === null || e === void 0 ? void 0 : (ref6 = e.block_list) === null || ref6 === void 0 ? void 0 : ref6.length,
                max: position.block_maximum,
                disabled: isTabFull,
                message: position.limited_msg || "",
                title: (e === null || e === void 0 ? void 0 : e.name) || "",
                enable: displayEnableTab,
                active: e === null || e === void 0 ? void 0 : e.isDefault,
                id: e.uid,
                hidden: isHiddenTab
            });
        });
        return _objectSpread({}, position, {
            is_enabled: displayEnablePosition,
            block_count: countOfBlock,
            is_disabled: isPositionFull,
            style: style,
            tabs: tabs,
            is_hidden: isHiddenPositon
        });
    }, [
        position,
        extraProps
    ]);
    if ((positionTransformed === null || positionTransformed === void 0 ? void 0 : positionTransformed.tabs) && (positionTransformed === null || positionTransformed === void 0 ? void 0 : (ref5 = positionTransformed.tabs) === null || ref5 === void 0 ? void 0 : ref5.length) <= ONE_TAB) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box.SingleBox, {
            item: {
                id: positionTransformed.slug,
                title: positionTransformed.translated_title,
                count: positionTransformed.block_count,
                max: positionTransformed.block_maximum,
                disabled: positionTransformed.is_disabled,
                message: positionTransformed.limited_msg,
                enable: positionTransformed.is_enabled,
                hidden: positionTransformed.is_hidden
            },
            onSelect: onSelect,
            selected: selected
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box.MultiBox, {
        item: {
            id: positionTransformed.slug,
            title: positionTransformed.translated_title,
            listBox: positionTransformed.tabs
        },
        onSelect: onSelect,
        selected: selected
    });
};
/* harmony default export */ var BlockLayoutComponent_PositionOption = (PositionOption);

;// CONCATENATED MODULE: ./src/features/design/components/AddNewBlock/AddNewBlock.tsx
function AddNewBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddNewBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddNewBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var AddNewBlock = function(props) {
    var ref, ref1, ref2;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var position1 = props.position, onSelectBlock = props.onSelectBlock, tabUid = props.tabUid, positionSlug = props.positionSlug, selectedBlock = props.selectedBlock, isHideExpandPosition = props.isHideExpandPosition;
    var headerPosition = position1 === null || position1 === void 0 ? void 0 : position1.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.HEADER */.Rz.HEADER;
    });
    var bodyPosition = position1 === null || position1 === void 0 ? void 0 : position1.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.BODY */.Rz.BODY;
    });
    var footerPosition = position1 === null || position1 === void 0 ? void 0 : position1.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.FOOTER */.Rz.FOOTER;
    });
    var expandPosition = position1 === null || position1 === void 0 ? void 0 : position1.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
    });
    var extraProps = {
        tab_uid: tabUid,
        position_slug: positionSlug
    };
    var bodyTabs = (ref1 = (ref = position1 === null || position1 === void 0 ? void 0 : position1.find(function(x) {
        return (x === null || x === void 0 ? void 0 : x.slug) === config_interface/* POSITION_TYPE.BODY */.Rz.BODY;
    })) === null || ref === void 0 ? void 0 : ref.block_list[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
    var handleSelectPosition = function(slug, id) {
        var position = slug;
        var uid = "";
        if (Object.is(position, config_interface/* POSITION_TYPE.BODY */.Rz.BODY)) {
            var defaultTab = bodyTabs && bodyTabs[0];
            uid = id ? id : defaultTab === null || defaultTab === void 0 ? void 0 : defaultTab.uid;
        }
        onSelectBlock({
            position: position,
            uid: uid
        });
    };
    var positionArrRender = (0,react.useMemo)(function() {
        var positionArrDefault = [
            headerPosition,
            bodyPosition,
            footerPosition
        ];
        if (!isHideExpandPosition) {
            positionArrDefault.push(expandPosition);
        }
        return positionArrDefault;
    }, [
        headerPosition,
        bodyPosition,
        footerPosition,
        expandPosition,
        isHideExpandPosition, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "floating-new-block-position adm-default h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-5 pt-0 new-block-position overflow-auto",
            children: positionArrRender.map(function(e) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLayoutComponent_PositionOption, {
                    position: AddNewBlock_objectSpread({}, e, {
                        translated_title: t("ss_builder_add_block_".concat(e.slug, "_title")),
                        block_maximum: configs_const/* MAX_NUMBER_BLOCK */.ET["".concat(e.slug.toUpperCase())],
                        limited_msg: t("ss_builder_limit_reached")
                    }),
                    onSelect: handleSelectPosition,
                    selected: selectedBlock,
                    extraProps: extraProps
                }, e.slug);
            })
        })
    });
};
/* harmony default export */ var AddNewBlock_AddNewBlock = (AddNewBlock);


/***/ }),

/***/ 62055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65457);
/* harmony import */ var _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60920);
/* harmony import */ var _features_block_config_interface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93807);
/* harmony import */ var _features_block_store_edittingBlockSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18684);
/* harmony import */ var _features_design_store_externalStateSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42372);
/* harmony import */ var _features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99265);
/* harmony import */ var _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55016);
/* harmony import */ var _share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21043);
/* harmony import */ var _share_HOC_portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62944);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64035);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11116);
/* harmony import */ var _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2991);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(13408);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89734);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(31567);
/* harmony import */ var use_double_tap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90767);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5678);
/* harmony import */ var _AddNewBlock_AddNewBlock__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(36629);
/* harmony import */ var _ProductTour_product_tour_config__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35445);
/* harmony import */ var _share_hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16565);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
























var MOVE_ACTION;
(function(MOVE_ACTION) {
    MOVE_ACTION["UP"] = "up";
    MOVE_ACTION["DOWN"] = "down";
})(MOVE_ACTION || (MOVE_ACTION = {}));
var BlockWrapper = function(props) {
    var ref11, ref1, ref2;
    var blockType = props.blockType, // onClick,
    children = props.children, isEnable = props.isEnable, positionSlug = props.positionSlug, blockUid = props.blockUid, tabUid = props.tabUid, index1 = props.index, _listBlocksSortOrder = props.listBlocksSortOrder, listBlocksSortOrder = _listBlocksSortOrder === void 0 ? [] : _listBlocksSortOrder, // outsideSpace,
    // insideSpace,
    isFirstItem = props.isFirstItem, _isApplyBlockSettings = props.isApplyBlockSettings, isApplyBlockSettings = _isApplyBlockSettings === void 0 ? true : _isApplyBlockSettings, _isHideMoreActions = props.// useAdvancedSetting,
    isHideMoreActions, isHideMoreActions = _isHideMoreActions === void 0 ? false : _isHideMoreActions, advancedSetting = props.advancedSetting;
    var CONFIRM_TEXT = "OK";
    var BLOCKS_DONT_MOVE_TO_ANOTHER_POSITION = [
        _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.TAB */ .bF.TAB,
        _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.TAB_BAR */ .bF.TAB_BAR, 
    ];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$)().t;
    var dispatch = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppDispatch */ .TL)();
    var popoverRef = (0,react__WEBPACK_IMPORTED_MODULE_16__.useRef)(null);
    var blockRef = (0,react__WEBPACK_IMPORTED_MODULE_16__.useRef)(null);
    var positionState = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.positions;
    });
    var siteSettings = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.siteSettings;
    });
    var introduceDoubleTap = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.introduce_double_tap;
    });
    var ref3 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref11 = siteSettings.display_setting) === null || ref11 === void 0 ? void 0 : (ref1 = ref11.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref3.inner_space_number, outside_space = ref3.outside_space, inner_space = ref3.inner_space;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(false), isOpenConfirmEnterText = ref4[0], setIsOpenConfirmEnterText = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(false), isOpenPositionSelection = ref5[0], setIsOpenPositionSelection = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(null), valueConfirmText = ref6[0], setValueConfirmText = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(false), forceVisible = ref7[0], setForceVisible = ref7[1];
    var passioPageProfile = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.passioPageProfile;
    });
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(), selectedBlock = ref8[0], setSelectedBlock = ref8[1];
    var debouncedValueConfirmText = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_18__/* .useDebounce */ .Nr)(valueConfirmText, 500);
    var selectedBlockData = listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.find(function(x) {
        return (x === null || x === void 0 ? void 0 : x.uid) === blockUid;
    });
    var blockTypeEvent = _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .BLOCK_TYPE_EVENT_CONFIG */ .Aw[blockType === null || blockType === void 0 ? void 0 : blockType.toUpperCase()] || (0,_share_lib__WEBPACK_IMPORTED_MODULE_11__/* .handleCapitalizeFirstLetter */ .Tz)(blockType);
    var ref9 = (0,_share_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useResizeObserveElement */ .pM)(blockRef), blockHeight = ref9.height;
    var isValidBlockHeight = !!(blockHeight <= 32);
    var isEnableConfirm = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        return !(typeof debouncedValueConfirmText === "string" && debouncedValueConfirmText.toLowerCase() === CONFIRM_TEXT.toLowerCase());
    }, [
        debouncedValueConfirmText
    ]);
    var actions1 = [
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.VISIBLE_BLOCK */ .am.VISIBLE_BLOCK,
            icon: isEnable === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .EyeVisibleIcon */ .m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .EyeHiddenIcon */ .Fl, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: isEnable === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5 ? t("ss_builder_hide_block_label") : t("ss_builder_show_block_label")
        },
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .ArrowUp */ .a2, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_up_block_label")
        },
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .ArrowDown */ .K5, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_down_block_label")
        },
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.EDIT_BLOCK */ .am.EDIT_BLOCK,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .EditTabIcon */ .jJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_block_label")
        },
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .FolderArrowRightIcon */ .Ao, {
                className: "w-5 h-5",
                fillColor: "white"
            }),
            text: t("ss_builder_move_product_label")
        },
        {
            key: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.DELETE_BLOCK */ .am.DELETE_BLOCK,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .DeleteIcon */ .pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_block_label")
        }, 
    ];
    var actionFilterOptions = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var actionFilter = actions1;
        if (listBlocksSortOrder.length === 1) {
            actionFilter = actionFilter.filter(function(actions) {
                return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK && actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK;
            });
        }
        if (index1 === 0) {
            actionFilter = actionFilter.filter(function(actions) {
                return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK;
            });
        }
        if (index1 === listBlocksSortOrder.length - 1) {
            actionFilter = actionFilter.filter(function(actions) {
                return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK;
            });
        }
        if (BLOCKS_DONT_MOVE_TO_ANOTHER_POSITION.includes(blockType) || positionSlug === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .POSITION_MAIN_LAYOUT.EXPAND */ .Kw.EXPAND) {
            actionFilter = actionFilter.filter(function(actions) {
                return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK;
            });
        }
        if (positionSlug === _features_block_config_interface__WEBPACK_IMPORTED_MODULE_3__/* .POSITION_TYPE.EXPAND */ .Rz.EXPAND) {
            if ([
                _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.IMAGE_POPUP */ .bF.IMAGE_POPUP
            ].includes(blockType)) {
                actionFilter = actionFilter.filter(function(e) {
                    return ![
                        _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK,
                        _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK,
                        _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK, 
                    ].includes(e.key);
                });
            } else if ([
                _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.GIFT_FOOTER */ .bF.GIFT_FOOTER,
                _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */ .bF.TRUTH_OR_DARE_FOOTER,
                _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.BRAND_GIFT_FOOTER */ .bF.BRAND_GIFT_FOOTER, 
            ].includes(blockType)) {
                var floatingBlocks = positionState.find(function(position) {
                    return position.slug === _features_block_config_interface__WEBPACK_IMPORTED_MODULE_3__/* .POSITION_TYPE.EXPAND */ .Rz.EXPAND;
                }).block_list.filter(function(block) {
                    return [
                        _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.GIFT_FOOTER */ .bF.GIFT_FOOTER,
                        _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */ .bF.TRUTH_OR_DARE_FOOTER,
                        _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.BRAND_GIFT_FOOTER */ .bF.BRAND_GIFT_FOOTER, 
                    ].includes(block.block_type);
                });
                if (floatingBlocks.length === 1) {
                    actionFilter = actionFilter.filter(function(e) {
                        return ![
                            _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK,
                            _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK,
                            _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK, 
                        ].includes(e.key);
                    });
                } else {
                    actionFilter = actionFilter.filter(function(e) {
                        return ![
                            _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK
                        ].includes(e.key);
                    });
                    if (index1 === 0) {
                        actionFilter = actionFilter.filter(function(actions) {
                            return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK;
                        });
                    }
                    if (index1 === floatingBlocks.length - 1) {
                        actionFilter = actionFilter.filter(function(actions) {
                            return actions.key !== _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK;
                        });
                    }
                }
            }
        }
        return actionFilter;
    }, [
        listBlocksSortOrder,
        index1,
        blockType
    ]);
    var moreElementRight = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var value = "";
        if (!(advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting)) {
            if (typeof outside_space === "boolean") {
                value = outside_space ? "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */ .eJ.OUTSIDE_SPACE_NUMBER + 4, "px") : "4px";
            } else {
                value = "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */ .eJ.OUTSIDE_SPACE_NUMBER + 4, "px");
            }
        } else {
            value = (advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_block_space) ? "16px" : "4px";
        }
        return value;
    }, [
        outside_space,
        advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting,
        advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_block_space, 
    ]);
    var outsideSpaceMemo = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var value = "";
        if (typeof outside_space === "boolean") {
            value = outside_space ? "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */ .eJ.OUTSIDE_SPACE_NUMBER, "px") : "0px";
        } else {
            value = "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */ .eJ.OUTSIDE_SPACE_NUMBER, "px");
        }
        return value;
    }, [
        outside_space
    ]);
    var insideSpaceMemo = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var value = "";
        if (typeof inner_space_number === "number") {
            value = "".concat(inner_space_number, "px");
        } else {
            if (typeof inner_space === "boolean") {
                value = inner_space ? "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */ .eJ.INNER_SPACE_NUMBER, "px") : "0px";
            } else {
                value = "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */ .eJ.INNER_SPACE_NUMBER, "px");
            }
        }
        return value;
    }, [
        inner_space_number,
        inner_space
    ]);
    var blockHiddenOverlayWidth = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var value = "";
        if (typeof outside_space === "boolean") {
            value = "calc(100% - ".concat(outside_space ? "24px" : "0px", ")");
        } else {
            value = "calc(100% - 24px)";
        }
        return value;
    }, [
        outside_space
    ]);
    var bindDoubleTapToBlock = (0,use_double_tap__WEBPACK_IMPORTED_MODULE_17__/* .useDoubleTap */ .i)(function(event) {
        openBlockEditor(event);
        _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_GoEditQuick_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.START_EDITING_QUICK */ .AN.START_EDITING_QUICK);
    });
    var handleChangeBlockStatus = function() {
        if (isEnable === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5) {
            _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_Hide_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.HIDE */ .AN.HIDE);
        } else {
            _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_Show_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.SHOW */ .AN.SHOW);
        }
        var blockStatus = isEnable === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5 ? _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .DISABLE_BLOCK */ .gK : _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5;
        dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__/* .disableEnableBlock */ .a8)({
            positionSlug: positionSlug,
            blockUid: blockUid,
            blockStatus: blockStatus,
            tabUid: tabUid
        }));
        antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: isEnable === _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ENABLE_BLOCK */ .C5 ? t("ss_builder_disable_block_successfully_label") : t("ss_builder_enable_block_successfully_label")
            })
        });
    };
    var handleCloseModalConfirmText = function() {
        setIsOpenConfirmEnterText(false);
        setValueConfirmText(null);
    };
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    };
    var onRemoveItem = function(index) {
        var deletedBlock = listBlocksSortOrder.find(function(ele, idx) {
            return ele.uid === blockUid;
        });
        dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__/* .deleteBlock */ .Gc)({
            deletedBlock: deletedBlock,
            positionSlug: positionSlug,
            tabUid: tabUid
        }));
    };
    var openPositionSelection = function() {
        return setIsOpenPositionSelection(true);
    };
    var openConfirmRemoveBlockPopup = function() {
        var isAffProduct = listBlocksSortOrder[index1].block_type === _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.AFF_PRODUCT */ .bF.AFF_PRODUCT || listBlocksSortOrder[index1].block_type === _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.AFF_PRODUCT_GROUP */ .bF.AFF_PRODUCT_GROUP;
        antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Modal.confirm */ .u_.confirm({
            header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CloseCircleIconV2 */ .GD, {
                width: 48,
                height: 48,
                fillColor: "var(--adm-color-primary)"
            }),
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: t("ss_builder_confirm-delete_block_title")
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: isAffProduct ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "break-words",
                    children: [
                        t("ss_builder_if_delete"),
                        ",",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-[#ee3244ff]",
                            children: [
                                " ",
                                t("ss_builder_all_setting_and_product"),
                                " "
                            ]
                        }),
                        t("ss_builder_in_block_delete_forever_are_you_sure")
                    ]
                }) : t("ss_builder_confirm-delete_block_label")
            }),
            confirmText: t("ss_builder_confirm_delete_block_btn_label"),
            cancelText: t("ss_builder_cancel-delete_block_label"),
            onConfirm: function() {
                if (blockType === _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.AFF_PRODUCT */ .bF.AFF_PRODUCT || blockType === _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.AFF_PRODUCT_GROUP */ .bF.AFF_PRODUCT_GROUP) {
                    setIsOpenConfirmEnterText(true);
                } else {
                    onRemoveItem(index1);
                    _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_Delete_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.DELETE */ .AN.DELETE);
                    antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Toast.show */ .FN.show({
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CheckCircleIcon */ .rE, {
                            className: "text-center inline-block w-[30px] h-[30px]",
                            fillColor: "#00B578"
                        }),
                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-center",
                            children: t("ss_builder_delete_block_successfully_label")
                        })
                    });
                }
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleUpdateStatusIntroduceDoubleTap = function() {
        dispatch((0,_features_design_store_externalStateSlice__WEBPACK_IMPORTED_MODULE_5__/* .setIntroduceDoubleTapState */ .n_)(_features_design_store_externalStateSlice__WEBPACK_IMPORTED_MODULE_5__/* .IntroduceDoubleTapEnum.FALSE */ .G_.FALSE));
    };
    var openModalIntroduceDoubleTap = function() {
        var isDontShowAgain = false;
        antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Modal.alert */ .u_.alert({
            image: "https://image.passio.eco/page-builder/page-builder/position-modal/introduce-edit-block.svg",
            title: t("ss_builder_introduce_double_tap_title"),
            className: "modal-product-tour modal-default",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                        children: t("ss_builder_introduce_double_tap_content")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Checkbox */ .XZ, {
                        block: true,
                        onChange: function(val) {
                            return isDontShowAgain = val;
                        },
                        className: "mt-5 radio_introduce",
                        children: t("ss_builder_introduce_double_tap_label_check")
                    })
                ]
            }),
            confirmText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex items-center w-full justify-center gap-2 leading-[140%] text-[17px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .PenIcon */ .Mw, {
                        width: 17,
                        height: 17,
                        fillColor: "#fff"
                    }),
                    " ",
                    t("ss_builder_introduce_double_tap_button")
                ]
            }),
            onConfirm: function() {
                if (isDontShowAgain) {
                    handleUpdateStatusIntroduceDoubleTap();
                }
                openBlockEditor();
                _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.START_EDITING_POPOVER */ .AN.START_EDITING_POPOVER);
                return;
            }
        });
    };
    var handleSelectBlockAction = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.VISIBLE_BLOCK */ .am.VISIBLE_BLOCK:
                handleChangeBlockStatus();
                break;
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_UP_BLOCK */ .am.MOVE_UP_BLOCK:
                handleChangeBlockOrder(MOVE_ACTION.UP);
                break;
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_DOWN_BLOCK */ .am.MOVE_DOWN_BLOCK:
                handleChangeBlockOrder(MOVE_ACTION.DOWN);
                break;
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.EDIT_BLOCK */ .am.EDIT_BLOCK:
                if (introduceDoubleTap == _features_design_store_externalStateSlice__WEBPACK_IMPORTED_MODULE_5__/* .IntroduceDoubleTapEnum.TRUE */ .G_.TRUE) {
                    openModalIntroduceDoubleTap();
                } else {
                    openBlockEditor();
                    _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.START_EDITING_POPOVER */ .AN.START_EDITING_POPOVER);
                }
                break;
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.MOVE_BLOCK */ .am.MOVE_BLOCK:
                openPositionSelection();
                break;
            case _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .ACTION_BLOCK.DELETE_BLOCK */ .am.DELETE_BLOCK:
                openConfirmRemoveBlockPopup();
                break;
            default:
                if (introduceDoubleTap == _features_design_store_externalStateSlice__WEBPACK_IMPORTED_MODULE_5__/* .IntroduceDoubleTapEnum.TRUE */ .G_.TRUE) {
                    openModalIntroduceDoubleTap();
                } else {
                    openBlockEditor();
                    _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.START_EDITING_POPOVER */ .AN.START_EDITING_POPOVER);
                }
        }
    };
    var handleRemoveBlock = function() {
        onRemoveItem(index1);
        antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_delete_block_successfully_label")
            })
        });
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(listBlocksSortOrder);
        if (positionSlug === _features_block_config_interface__WEBPACK_IMPORTED_MODULE_3__/* .POSITION_TYPE.EXPAND */ .Rz.EXPAND) {
            var imgPopup = result.filter(function(e) {
                return [
                    _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.IMAGE_POPUP */ .bF.IMAGE_POPUP
                ].includes(e.block_type);
            });
            var floating = result.filter(function(e) {
                return [
                    _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */ .bF.TRUTH_OR_DARE_FOOTER,
                    _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.GIFT_FOOTER */ .bF.GIFT_FOOTER,
                    _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.BRAND_GIFT_FOOTER */ .bF.BRAND_GIFT_FOOTER, 
                ].includes(e.block_type);
            });
            var updatedOrderExpandBlock = lodash_sortBy__WEBPACK_IMPORTED_MODULE_15___default()(imgPopup, [
                "sort_order"
            ]).concat(lodash_sortBy__WEBPACK_IMPORTED_MODULE_15___default()(floating, [
                "sort_order"
            ])).map(function(e, index) {
                return _objectSpread({}, e, {
                    sort_order: index
                });
            });
            result = _toConsumableArray(updatedOrderExpandBlock);
        }
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedBlockList = result.map(function(ele, idx) {
            return _objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        var sortedBlocks = lodash_sortBy__WEBPACK_IMPORTED_MODULE_15___default()(orderedBlockList, [
            "sort_order"
        ]).map(function(e, index) {
            return _objectSpread({}, e, {
                sort_order: index
            });
        });
        return sortedBlocks;
    };
    var handleChangeBlockOrder = function(action) {
        var sortOrder = selectedBlockData.sort_order;
        var startIndex = positionSlug === _features_block_config_interface__WEBPACK_IMPORTED_MODULE_3__/* .POSITION_TYPE.EXPAND */ .Rz.EXPAND ? sortOrder : index1;
        var endIndex = action === MOVE_ACTION.DOWN ? startIndex + 1 : startIndex - 1;
        if (endIndex < 0 || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__/* .sortBlock */ .K6)({
            itemsOrder: itemsOrder,
            positionSlug: positionSlug,
            tabUid: tabUid
        }));
        if (action === MOVE_ACTION.UP) {
            _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_MoveUp_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.MOVE_UP */ .AN.MOVE_UP);
        } else {
            _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "Block_MoveDown_".concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.MOVE_DOWN */ .AN.MOVE_DOWN);
        }
    };
    var handleMoveBlockToOtherPosition = function() {
        _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .CATEGORY_CONFIG.BLOCK */ .Bt.BLOCK, "".concat(_share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .EVENT_CONFIG.MOVE_TO */ .f1.MOVE_TO).concat(blockTypeEvent), blockTypeEvent, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_12__/* .ACTION_CONFIG.MOVE_TO */ .AN.MOVE_TO);
        if (selectedBlock) {
            if ((selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.position) !== "body") {
                dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__/* .moveBlockToPosition */ .wY)({
                    blockData: selectedBlockData,
                    oldPositionSlug: positionSlug,
                    newPositionSlug: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.position,
                    oldTabUid: tabUid,
                    newTabUid: null
                }));
            }
            if (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.uid) {
                dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_6__/* .moveBlockToPosition */ .wY)({
                    blockData: selectedBlockData,
                    oldPositionSlug: positionSlug,
                    newPositionSlug: "body",
                    oldTabUid: tabUid,
                    newTabUid: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.uid
                }));
            }
        }
        antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_move_block_successfully_label")
            })
        });
    };
    var openBlockEditor = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        dispatch((0,_features_block_store_edittingBlockSlice__WEBPACK_IMPORTED_MODULE_4__/* .openPopup */ .Mw)({
            block: selectedBlockData,
            position_uid: positionSlug,
            tab_uid: tabUid,
            KEY: _features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .KEY_BLOCK.EDIT */ .ne.EDIT
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_16__.useEffect)(function() {
        var castWindow = window;
        if (isFirstItem) {
            castWindow.triggerVisiblePopoverBlock = setForceVisible;
        }
        (function() {
            if (castWindow.triggerVisiblePopoverBlock) {
                castWindow.triggerVisiblePopoverBlock = undefined;
                setForceVisible(false);
            }
        });
    }, [
        isFirstItem
    ]);
    var styleChecking = (0,react__WEBPACK_IMPORTED_MODULE_16__.useMemo)(function() {
        var marginValue = outsideSpaceMemo;
        if (advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) {
            marginValue = (advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_block_space) ? "12px" : null;
        }
        return {
            marginLeft: marginValue,
            marginRight: marginValue,
            paddingLeft: !(advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) ? insideSpaceMemo : null,
            paddingRight: !(advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) ? insideSpaceMemo : null
        };
    }, [
        advancedSetting,
        outsideSpaceMemo,
        insideSpaceMemo
    ]);
    if (!isApplyBlockSettings) {
        var ref10;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_14___default()("relative", "block-".concat((ref10 = blockType === null || blockType === void 0 ? void 0 : blockType.split("_")) === null || ref10 === void 0 ? void 0 : ref10.join("-"))),
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        style: {
            cursor: "auto",
            minHeight: isValidBlockHeight ? "32px" : ""
        },
        ref: popoverRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: isFirstItem ? "".concat(_ProductTour_product_tour_config__WEBPACK_IMPORTED_MODULE_20__/* .PRODUCT_TOUR_CLASS_NAME.STEP_12 */ .uN.STEP_12, " ").concat(_ProductTour_product_tour_config__WEBPACK_IMPORTED_MODULE_20__/* .PRODUCT_TOUR_CLASS_NAME.STEP_13 */ .uN.STEP_13) : "",
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    maxHeight: "70vh",
                    zIndex: -1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({}, bindDoubleTapToBlock, {
                className: classnames__WEBPACK_IMPORTED_MODULE_14___default()("block-".concat((ref2 = blockType === null || blockType === void 0 ? void 0 : blockType.split("_")) === null || ref2 === void 0 ? void 0 : ref2.join("-")), "overflow-hidden h-full block-dragging", !(advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) && "block-class", blockType !== _features_block_block_conf__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TYPE.COMBINED */ .bF.COMBINED && "bg-block-drag-drop"),
                id: blockUid,
                style: _objectSpread({
                    minHeight: isValidBlockHeight ? "32px" : "",
                    display: isValidBlockHeight ? "flex" : "",
                    alignItems: isValidBlockHeight ? "center" : ""
                }, styleChecking, props.extraStyle),
                ref: blockRef,
                children: children
            })),
            isEnable !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
                className: "absolute top-0 block w-full h-full text-center block-border-radius z-[5]",
                style: {
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    width: blockHiddenOverlayWidth,
                    left: "50%",
                    transform: "translateX(-50%)"
                }
            }, bindDoubleTapToBlock, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        position: "relative",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .EyeVisibleIcon */ .m0, {
                            className: "align-middle inline-block fill-black",
                            fillColor: "#333"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[#333]",
                            children: t("ss_builder_block_design_hiding_label")
                        })
                    ]
                })
            })),
            !isHideMoreActions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_14___default()("flex flex-row items-center justify-center absolute w-[32px] h-[32px] gap-[15px] cursor-pointer z-[5]"),
                style: {
                    backgroundColor: "rgba(0, 0, 0, 0.15)",
                    borderRadius: "100px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    right: moreElementRight,
                    top: isValidBlockHeight ? "0px" : "4px"
                },
                onClick: handleClickMoreIcon,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative",
                    ref: popoverRef,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Popover.Menu */ .J2.Menu, _objectSpread({}, forceVisible ? {
                        visible: true
                    } : {}, {
                        className: isFirstItem ? "popover-block ".concat(_ProductTour_product_tour_config__WEBPACK_IMPORTED_MODULE_20__/* .PRODUCT_TOUR_CLASS_NAME.STEP_3 */ .uN.STEP_3) : "popover-block",
                        mode: "dark",
                        actions: actionFilterOptions,
                        placement: "bottom-end",
                        trigger: "click",
                        stopPropagation: [
                            "click"
                        ],
                        getContainer: function() {
                            return popoverRef.current;
                        },
                        onAction: handleSelectBlockAction,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .MoreIcon */ .nX, {
                            fillColor: "#fff",
                            className: "fill-white"
                        })
                    }))
                })
            }),
            isOpenConfirmEnterText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_HOC_portal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                elementId: "modalPortal",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u_, {
                    visible: isOpenConfirmEnterText,
                    content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                                children: t("ss_builder_confirm_delete_aff_block_content")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-3 mb-1 text-[#666]",
                                children: t("ss_builder_confirm_delete_aff_block_label_enter_ok")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Input */ .II, {
                                placeholder: t("ss_builder_confirm_delete_aff_block_input_placeholder"),
                                onChange: setValueConfirmText,
                                className: "input-rounded",
                                maxLength: 20,
                                minLength: 1
                            })
                        ]
                    }),
                    closeOnAction: true,
                    onClose: handleCloseModalConfirmText,
                    className: "confirm-text-preview-apply-content",
                    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_10__/* .CloseCircleIconV2 */ .GD, {
                        width: 48,
                        height: 48,
                        fillColor: "#FF3141"
                    }),
                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: t("ss_builder_confirm_delete_aff_block_warining")
                    }),
                    actions: [
                        {
                            key: "confirm",
                            text: t("ss_builder_confirm_delete_aff_block_understood"),
                            className: "confirm-text",
                            primary: true,
                            disabled: isEnableConfirm,
                            onClick: handleRemoveBlock
                        },
                        {
                            key: "cancel",
                            text: t("ss_builder_cancel_delete_aff_block_btn_label"),
                            className: "cancel-text"
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_PopupComponent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                visible: isOpenPositionSelection,
                onMaskClick: function() {
                    return setIsOpenPositionSelection(false);
                },
                title: t("ss_builder_move_product_label"),
                onClose: function() {
                    return setIsOpenPositionSelection(false);
                },
                style: {
                    borderRadius: "8px 8px 0px 0px",
                    maxWidth: outside_space ? "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .MAX_WIDTH_OUTSIDE_ON */ .NY, "px") : "".concat(_features_share_configs_const__WEBPACK_IMPORTED_MODULE_7__/* .MAX_WIDTH_CONTENT_LAYOUT */ .t, "px")
                },
                showConfirmButton: true,
                onConfirmButton: handleMoveBlockToOtherPosition,
                confirmButtonLabel: t("ss_builder_popup_confirm_button"),
                disabledConfirmButton: !selectedBlock,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AddNewBlock_AddNewBlock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    position: positionState,
                    onSelectBlock: function(data) {
                        return setSelectedBlock(data);
                    },
                    tabUid: tabUid,
                    positionSlug: positionSlug,
                    selectedBlock: selectedBlock,
                    isHideExpandPosition: true
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockWrapper);


/***/ }),

/***/ 82071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_components_dnd_scrollable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77345);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32457);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var ListItemScrollHorizontal = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, children = props.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var styleDnScrollable = {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dndItemContainer), " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_components_dnd_scrollable__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            style: styleDnScrollable,
            elementRef: ref,
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dndContainer),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListItemScrollHorizontal);


/***/ }),

/***/ 35445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "om": function() { return /* binding */ STEP_INDEX; },
/* harmony export */   "uN": function() { return /* binding */ PRODUCT_TOUR_CLASS_NAME; }
/* harmony export */ });
var PRODUCT_TOUR_CLASS_NAME = {
    STEP_1: "product-tour-design",
    STEP_2: "product-tour-new-block",
    STEP_3: "product-tour-quick-action",
    STEP_4: "product-tour-publish",
    STEP_5: "product-tour-tab-list",
    STEP_6: "product-tour-header",
    STEP_7: "product-tour-body",
    STEP_8: "product-tour-footer",
    STEP_9: "product-tour-restore-edit",
    STEP_10: "product-tour-apply-theme-content",
    STEP_11: "product-tour-preview",
    STEP_12: "product-tour-move-block-position",
    STEP_13: "product-tour-edit-block",
    STEP_14: "product-tour-background-setting",
    STEP_15: "product-tour-theme-store",
    STEP_16: "product-tour-advanced-settings",
    STEP_17: "product-tour-user-manual"
};
var STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
    STEP_4: 3,
    STEP_5: 4,
    STEP_6: 5,
    STEP_7: 6,
    STEP_8: 7,
    STEP_9: 8,
    STEP_10: 9,
    STEP_11: 10,
    STEP_12: 11,
    STEP_13: 12,
    STEP_14: 13,
    STEP_15: 14,
    STEP_16: 15,
    STEP_17: 16
};
var steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-1.gif",
        title_key: "ss_builder_product_tour_title_step_1",
        intro_key: "ss_builder_product_tour_content_step_1",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-2.gif",
        title_key: "ss_builder_product_tour_title_step_2",
        intro_key: "ss_builder_product_tour_content_step_2",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "",
        position: "",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-3.gif",
        title_key: "ss_builder_product_tour_title_step_3",
        intro_key: "ss_builder_product_tour_content_step_3",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_3,
        tooltip_class: "auto",
        position: "bottom-right-aligned",
        tooltip_position: "bottom-right-aligned"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-4.gif",
        title_key: "ss_builder_product_tour_title_step_4",
        intro_key: "ss_builder_product_tour_content_step_4",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_4,
        tooltip_class: "",
        position: "bottom-right-aligned",
        tooltip_position: "bottom-right-aligned"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-5.gif",
        title_key: "ss_builder_product_tour_title_step_5",
        intro_key: "ss_builder_product_tour_content_step_5",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_5,
        tooltip_class: "",
        position: "top",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-6.gif",
        title_key: "ss_builder_product_tour_title_step_6",
        intro_key: "ss_builder_product_tour_content_step_6",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_6,
        tooltip_class: "",
        position: "top",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-7.gif",
        title_key: "ss_builder_product_tour_title_step_7",
        intro_key: "ss_builder_product_tour_content_step_7",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_7,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-8.gif",
        title_key: "ss_builder_product_tour_title_step_8",
        intro_key: "ss_builder_product_tour_content_step_8",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_8,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-9.gif",
        title_key: "ss_builder_product_tour_title_step_9",
        intro_key: "ss_builder_product_tour_content_step_9",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_9,
        tooltip_class: "",
        position: "bottom",
        highlight_class: "product-tour-restore-edit"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-10.gif",
        title_key: "ss_builder_product_tour_title_step_10",
        intro_key: "ss_builder_product_tour_content_step_10",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_10,
        tooltip_class: "",
        position: "bottom",
        highlight_class: "product-tour-apply-theme-content"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-11.gif",
        title_key: "ss_builder_product_tour_title_step_11",
        intro_key: "ss_builder_product_tour_content_step_11",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_11,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-12.gif",
        title_key: "ss_builder_product_tour_title_step_12",
        intro_key: "ss_builder_product_tour_content_step_12",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_12,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-13.gif",
        title_key: "ss_builder_product_tour_title_step_13",
        intro_key: "ss_builder_product_tour_content_step_13",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_13,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-14.gif",
        title_key: "ss_builder_product_tour_title_step_14",
        intro_key: "ss_builder_product_tour_content_step_14",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_14,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-15.gif",
        title_key: "ss_builder_product_tour_title_step_15",
        intro_key: "ss_builder_product_tour_content_step_15",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_15,
        tooltip_class: "",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-16.gif",
        title_key: "ss_builder_product_tour_title_step_16",
        intro_key: "ss_builder_product_tour_content_step_16",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_16,
        tooltip_class: "product-tour-custom",
        position: "bottom",
        using_selector: true
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-17.gif",
        title_key: "ss_builder_product_tour_title_step_17",
        intro_key: "ss_builder_product_tour_content_step_17",
        element_class: PRODUCT_TOUR_CLASS_NAME.STEP_17,
        tooltip_class: "show-label-text",
        position: "bottom",
        using_selector: true
    }, 
];


/***/ }),

/***/ 42372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ setDataFont; },
/* harmony export */   "DH": function() { return /* binding */ getExternalState; },
/* harmony export */   "G_": function() { return /* binding */ IntroduceDoubleTapEnum; },
/* harmony export */   "ZR": function() { return /* binding */ setFontLoading; },
/* harmony export */   "aM": function() { return /* binding */ setValidFontWeight; },
/* harmony export */   "bq": function() { return /* binding */ setValidFont; },
/* harmony export */   "dK": function() { return /* binding */ FloatingIntroStatus; },
/* harmony export */   "kh": function() { return /* binding */ FLOATING; },
/* harmony export */   "lA": function() { return /* binding */ setFirstGuideState; },
/* harmony export */   "m5": function() { return /* binding */ setFloatingIntroductionState; },
/* harmony export */   "n_": function() { return /* binding */ setIntroduceDoubleTapState; },
/* harmony export */   "x9": function() { return /* binding */ FirstGuideStateEnum; },
/* harmony export */   "yT": function() { return /* binding */ getExternalStateSuccess; },
/* harmony export */   "z1": function() { return /* binding */ setFloatingBlockIntroductionState; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var FirstGuideStateEnum;
(function(FirstGuideStateEnum) {
    FirstGuideStateEnum["ADD_BLOCK"] = "add_block";
    FirstGuideStateEnum["PREVIEW"] = "preview";
    FirstGuideStateEnum["PUBLISH"] = "publish";
    FirstGuideStateEnum["DONE"] = "done";
})(FirstGuideStateEnum || (FirstGuideStateEnum = {}));
var IntroduceDoubleTapEnum;
(function(IntroduceDoubleTapEnum) {
    IntroduceDoubleTapEnum[IntroduceDoubleTapEnum["TRUE"] = 1] = "TRUE";
    IntroduceDoubleTapEnum[IntroduceDoubleTapEnum["FALSE"] = 2] = "FALSE";
})(IntroduceDoubleTapEnum || (IntroduceDoubleTapEnum = {}));
var FloatingIntroStatus;
(function(FloatingIntroStatus) {
    FloatingIntroStatus[FloatingIntroStatus["ENABLE"] = 1] = "ENABLE";
    FloatingIntroStatus[FloatingIntroStatus["DISABLE"] = 2] = "DISABLE";
})(FloatingIntroStatus || (FloatingIntroStatus = {}));
var FLOATING;
(function(FLOATING) {
    FLOATING["BRAND_GIFT_FOOTER"] = "brand_gift";
    FLOATING["BRAND_RATING_BLOCK"] = "brand_rating";
})(FLOATING || (FLOATING = {}));
var initialExternalState = {
    guide_state: FirstGuideStateEnum.DONE,
    introduce_double_tap: IntroduceDoubleTapEnum.TRUE,
    floating_icon: _defineProperty({}, FLOATING.BRAND_GIFT_FOOTER, FloatingIntroStatus.DISABLE),
    floating_block: _defineProperty({}, FLOATING.BRAND_RATING_BLOCK, FloatingIntroStatus.DISABLE),
    data_font: {
        title: "",
        paragraph: ""
    },
    is_valid_font: true,
    font_weight_available: [],
    is_font_loading: false
};
var externalStateSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "externalState",
    initialState: initialExternalState,
    reducers: {
        getExternalState: function() {},
        getExternalStateSuccess: function(state, action) {
            return _objectSpread({}, action.payload);
        },
        setFirstGuideState: function(state, action) {
            state.guide_state = action.payload;
        },
        setIntroduceDoubleTapState: function(state, action) {
            state.introduce_double_tap = action.payload;
        },
        setFloatingIntroductionState: function(state, action) {
            state.floating_icon = action.payload;
        },
        setFloatingBlockIntroductionState: function(state, action) {
            state.floating_block = action.payload;
        },
        setDataFont: function(state, action) {
            state.data_font = action.payload;
        },
        setValidFont: function(state, action) {
            state.is_valid_font = action.payload;
        },
        setValidFontWeight: function(state, action) {
            state.font_weight_available = action.payload;
        },
        setFontLoading: function(state, action) {
            state.is_font_loading = action.payload;
        }
    }
});
var _actions = externalStateSlice.actions;
var getExternalState = _actions.getExternalState, getExternalStateSuccess = _actions.getExternalStateSuccess, setFirstGuideState = _actions.setFirstGuideState, setIntroduceDoubleTapState = _actions.setIntroduceDoubleTapState, setFloatingIntroductionState = _actions.setFloatingIntroductionState, setFloatingBlockIntroductionState = _actions.setFloatingBlockIntroductionState, setDataFont = _actions.setDataFont, setValidFont = _actions.setValidFont, setValidFontWeight = _actions.setValidFontWeight, setFontLoading = _actions.setFontLoading;
/* harmony default export */ __webpack_exports__["ZP"] = (externalStateSlice.reducer);


/***/ }),

/***/ 66625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uf": function() { return /* binding */ setBookingProfile; }
/* harmony export */ });
/* unused harmony export bookingProfileSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var initialState = {
    finish_product_tour: null,
    finish_product_tour_at: null,
    finish_onboard: null,
    finish_onboard_at: null,
    user_id: null,
    categories: [],
    selected_template_id: null,
    createdAt: null,
    country: null,
    username: null,
    background: {
        color: null,
        gradient: null,
        type: null,
        color_type: null
    },
    banner: null,
    image: null,
    name: null,
    slug: null,
    last_publish_at: null,
    id: null
};
var bookingProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "bookingProfile",
    initialState: initialState,
    reducers: {
        setBookingProfile: function(state, param) {
            var data = param.payload.data;
            return _objectSpread({}, state, data);
        }
    }
});
var setBookingProfile = bookingProfileSlice.actions.setBookingProfile;
/* harmony default export */ __webpack_exports__["ZP"] = (bookingProfileSlice.reducer);


/***/ }),

/***/ 72976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I4": function() { return /* binding */ setCreatorProfile; }
/* harmony export */ });
/* unused harmony export creatorProfileSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5700);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55016);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var initialState = {
    finish_product_tour: null,
    finish_product_tour_at: null,
    finish_onboard: _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .INITIAL_ONBOARDING */ .hB,
    finish_onboard_at: null,
    user_id: null,
    categories: [],
    selected_template_id: null,
    createdAt: null,
    country: null,
    username: null,
    background: {
        color: null,
        gradient: null,
        type: null,
        color_type: null
    },
    banner: null,
    image: null,
    name: null,
    slug: null,
    last_publish_at: null,
    id: null,
    categoriesInitial: []
};
var creatorProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "creatorProfile",
    initialState: initialState,
    reducers: {
        setCreatorProfile: function(state, param) {
            var data = param.payload.data;
            return _objectSpread({}, state, data);
        }
    }
});
var setCreatorProfile = creatorProfileSlice.actions.setCreatorProfile;
/* harmony default export */ __webpack_exports__["ZP"] = (creatorProfileSlice.reducer);


/***/ }),

/***/ 24865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ setDynamicParams; },
/* harmony export */   "_7": function() { return /* binding */ setParamsThemeSetting; },
/* harmony export */   "bu": function() { return /* binding */ removePendingProcessData; },
/* harmony export */   "ip": function() { return /* binding */ addPendingProcessData; },
/* harmony export */   "ln": function() { return /* binding */ setParamsAffiliateProductTours; },
/* harmony export */   "qS": function() { return /* binding */ setParamsTab; },
/* harmony export */   "sT": function() { return /* binding */ setError; },
/* harmony export */   "wT": function() { return /* binding */ setParamsBlock; }
/* harmony export */ });
/* unused harmony export dynamicSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5700);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55016);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var initialState = {
    blocks: {
        KEY: "",
        indexBlock: 0,
        type: "",
        listBlocksData: null,
        positionSlug: "",
        tabUid: ""
    },
    tabs: {
        isOpenTabFloatingPanel: false,
        defaultNameTab: "",
        defaultNameTabIcon: _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .TAB_ICON_DEFAULT */ .FL,
        KEY: "",
        tabListBody: null,
        indexTab: 0,
        activeKeyTab: "",
        urlIcon: "",
        positionTabMenu: ""
    },
    themeSettings: {
        primaryColor: "",
        fontFamily: "",
        imageUrl: "",
        gradientColor: "",
        solidColor: "",
        typeBackground: "",
        recentlyColor: []
    },
    affiliateSettingTour: {
        hiddenSteps: []
    },
    pendingProcessData: [],
    isEditContentPage: false,
    isOpenFloatingPanel: false,
    isErrorNetwork: false,
    isSaving: false,
    isError: false,
    isRetry: false,
    isEnableHeaderDynamic: false,
    isSavingProductTour: false,
    isOpenProductTourDynamic: false,
    isOpenAffiliateSettingTour: false,
    isOpenAffiliateGroupTour: false,
    isOpenAffiliateAddNewTour: false,
    isMarginSettingTour: false,
    isMarginBackground: false,
    isUploadProductFile: false,
    isUploadProductFromSiteUrl: false
};
var dynamicSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "dynamicConfig",
    initialState: initialState,
    reducers: {
        setDynamicParams: function(state, param) {
            var data = param.payload.data;
            if (typeof data.isEditContentPage === "boolean") {
                state.isEditContentPage = data.isEditContentPage;
            }
            if (typeof data.isOpenFloatingPanel === "boolean") {
                state.isOpenFloatingPanel = data.isOpenFloatingPanel;
            }
            if (typeof data.isErrorNetwork === "boolean") {
                state.isErrorNetwork = data.isErrorNetwork;
            }
            if (typeof data.isSaving === "boolean") {
                state.isSaving = data.isSaving;
            }
            if (typeof data.isError === "boolean") {
                state.isError = data.isError;
            }
            if (typeof data.isRetry === "boolean") {
                state.isRetry = data.isRetry;
            }
            if (typeof data.isSavingProductTour === "boolean") {
                state.isSavingProductTour = data.isSavingProductTour;
            }
            if (typeof data.isEnableHeaderDynamic === "boolean") {
                state.isEnableHeaderDynamic = data.isEnableHeaderDynamic;
            }
            if (typeof data.isOpenProductTourDynamic === "boolean") {
                state.isOpenProductTourDynamic = data.isOpenProductTourDynamic;
            }
            if (typeof data.isOpenAffiliateSettingTour === "boolean") {
                state.isOpenAffiliateSettingTour = data.isOpenAffiliateSettingTour;
            }
            if (typeof data.isOpenAffiliateGroupTour === "boolean") {
                state.isOpenAffiliateGroupTour = data.isOpenAffiliateGroupTour;
            }
            if (typeof data.isOpenAffiliateAddNewTour === "boolean") {
                state.isOpenAffiliateAddNewTour = data.isOpenAffiliateAddNewTour;
            }
            if (typeof data.isMarginSettingTour === "boolean") {
                state.isMarginSettingTour = data.isMarginSettingTour;
            }
            if (typeof data.isMarginBackground === "boolean") {
                state.isMarginBackground = data.isMarginBackground;
            }
            if (typeof data.isUploadProductFile === "boolean") {
                state.isUploadProductFile = data.isUploadProductFile;
            }
            if (typeof data.isUploadProductFromSiteUrl === "boolean") {
                state.isUploadProductFromSiteUrl = data.isUploadProductFromSiteUrl;
            }
        },
        setParamsBlock: function(state, param) {
            var data = param.payload.data;
            state.blocks = _objectSpread({}, state.blocks, data);
        },
        setParamsTab: function(state, param) {
            var data = param.payload.data;
            state.tabs = _objectSpread({}, state.tabs, data);
        },
        setParamsThemeSetting: function(state, param) {
            var data = param.payload.data;
            state.themeSettings = _objectSpread({}, state.themeSettings, data);
        },
        setParamsAffiliateProductTours: function(state, param) {
            var data = param.payload.data;
            state.affiliateSettingTour = _objectSpread({}, state.affiliateSettingTour, data);
        },
        addPendingProcessData: function(state, param) {
            var _payload = param.payload, id = _payload.id, data = _payload.data;
            return _objectSpread({}, state, {
                pendingProcessData: _toConsumableArray(state.pendingProcessData).concat([
                    {
                        id: id,
                        data: data
                    }, 
                ])
            });
        },
        removePendingProcessData: function(state, param) {
            var id = param.payload.id;
            return _objectSpread({}, state, {
                pendingProcessData: state.pendingProcessData.filter(function(item) {
                    return item.id !== id;
                })
            });
        },
        setError: function(state, param) {
            var is_error = param.payload.is_error;
            state.isError = is_error;
        }
    }
});
var _actions = dynamicSlice.actions;
var setDynamicParams = _actions.setDynamicParams, setParamsBlock = _actions.setParamsBlock, setParamsTab = _actions.setParamsTab, setParamsThemeSetting = _actions.setParamsThemeSetting, setParamsAffiliateProductTours = _actions.setParamsAffiliateProductTours, addPendingProcessData = _actions.addPendingProcessData, removePendingProcessData = _actions.removePendingProcessData, setError = _actions.setError;
/* harmony default export */ __webpack_exports__["ZP"] = (dynamicSlice.reducer);


/***/ }),

/***/ 30053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gx": function() { return /* binding */ FINISH_PRODUCT_TOUR_ENUM; },
/* harmony export */   "bW": function() { return /* binding */ POSITION_SLUG; },
/* harmony export */   "lp": function() { return /* binding */ CREATOR_ROLE_ENUM; },
/* harmony export */   "s2": function() { return /* binding */ FINISH_ONBOARD_ENUM; },
/* harmony export */   "sG": function() { return /* binding */ CREATOR_TYPE_ENUM; }
/* harmony export */ });
var POSITION_SLUG = {
    HEADER: "header",
    BODY: "body",
    FOOTER: "footer",
    EXPAND: "expand"
};
var CREATOR_ROLE_ENUM;
(function(CREATOR_ROLE_ENUM) {
    CREATOR_ROLE_ENUM[CREATOR_ROLE_ENUM["ADMIN"] = 1] = "ADMIN";
    CREATOR_ROLE_ENUM[CREATOR_ROLE_ENUM["THEME_CREATOR"] = 2] = "THEME_CREATOR";
    CREATOR_ROLE_ENUM[CREATOR_ROLE_ENUM["SELLER"] = 3] = "SELLER";
})(CREATOR_ROLE_ENUM || (CREATOR_ROLE_ENUM = {}));
var CREATOR_TYPE_ENUM;
(function(CREATOR_TYPE_ENUM) {
    CREATOR_TYPE_ENUM[CREATOR_TYPE_ENUM["NORMAL"] = 0] = "NORMAL";
    CREATOR_TYPE_ENUM[CREATOR_TYPE_ENUM["FOURTEEN"] = 1] = "FOURTEEN";
})(CREATOR_TYPE_ENUM || (CREATOR_TYPE_ENUM = {}));
var FINISH_ONBOARD_ENUM;
(function(FINISH_ONBOARD_ENUM) {
    FINISH_ONBOARD_ENUM[FINISH_ONBOARD_ENUM["TRUE"] = 1] = "TRUE";
    FINISH_ONBOARD_ENUM[FINISH_ONBOARD_ENUM["FALSE"] = 2] = "FALSE";
})(FINISH_ONBOARD_ENUM || (FINISH_ONBOARD_ENUM = {}));
var FINISH_PRODUCT_TOUR_ENUM;
(function(FINISH_PRODUCT_TOUR_ENUM) {
    FINISH_PRODUCT_TOUR_ENUM[FINISH_PRODUCT_TOUR_ENUM["TRUE"] = 1] = "TRUE";
    FINISH_PRODUCT_TOUR_ENUM[FINISH_PRODUCT_TOUR_ENUM["FALSE"] = 2] = "FALSE";
})(FINISH_PRODUCT_TOUR_ENUM || (FINISH_PRODUCT_TOUR_ENUM = {}));


/***/ }),

/***/ 69067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gA": function() { return /* binding */ setPassioPageProfile; }
/* harmony export */ });
/* unused harmony export passioPageProfileSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5700);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30053);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var initialState = {
    id: "",
    name: "",
    avatar: "",
    email: "",
    country: "",
    cps_user_id: "",
    eop_user_id: "",
    username: "",
    creator_role: _interface__WEBPACK_IMPORTED_MODULE_0__/* .CREATOR_ROLE_ENUM.SELLER */ .lp.SELLER,
    passio_page_onboard_state: null,
    finish_product_tour: null,
    site_id: null,
    domain: "",
    creator_type: _interface__WEBPACK_IMPORTED_MODULE_0__/* .CREATOR_TYPE_ENUM.NORMAL */ .sG.NORMAL
};
var passioPageProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "passioPageProfile",
    initialState: initialState,
    reducers: {
        setPassioPageProfile: function(state, param) {
            var data = param.payload.data;
            return _objectSpread({}, state, data);
        }
    }
});
var setPassioPageProfile = passioPageProfileSlice.actions.setPassioPageProfile;
/* harmony default export */ __webpack_exports__["ZP"] = (passioPageProfileSlice.reducer);


/***/ }),

/***/ 99265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U6": function() { return /* binding */ addBlock; },
  "ZP": function() { return /* binding */ positionsSlice; },
  "Gc": function() { return /* binding */ deleteBlock; },
  "a8": function() { return /* binding */ disableEnableBlock; },
  "uX": function() { return /* binding */ disableEnablePosition; },
  "WZ": function() { return /* binding */ getBlocksBySlug; },
  "wY": function() { return /* binding */ moveBlockToPosition; },
  "N$": function() { return /* binding */ removeBlock; },
  "sk": function() { return /* binding */ setBlock; },
  "wq": function() { return /* binding */ setPosition; },
  "K6": function() { return /* binding */ sortBlock; },
  "Df": function() { return /* binding */ updateBlock; },
  "g2": function() { return /* binding */ updateTabsBody; }
});

// UNUSED EXPORTS: addTab, allPosition, changeTitleBlock, deleteTab, disableEnableTab, positionSlice, setDefaultTab, sortTab, updateTab

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(5700);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
// EXTERNAL MODULE: ./node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(7145);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 91 modules
var block_conf = __webpack_require__(60920);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./src/features/main/store/positionsSlice.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var initialState = [];
var positionSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "positions",
    initialState: initialState,
    reducers: {
        setPosition: function(state, param) {
            var positions = param.payload.positions;
            return positions.map(function(position) {
                var ref;
                if (position.slug !== configs_const/* POSITION_MAIN_LAYOUT.BODY */.Kw.BODY) {
                    if (position.slug === configs_const/* POSITION_MAIN_LAYOUT.FOOTER */.Kw.FOOTER) {
                        var blockListFooter = position.block_list;
                        var newBlockList = blockListFooter.filter(function(item) {
                            return item.block_type !== block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR;
                        });
                        return _objectSpread({}, position, {
                            block_list: newBlockList
                        });
                    }
                    return position;
                }
                var blockList = position.block_list;
                var tabBlock = blockList.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
                });
                var tabs = tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs;
                var hasIsDefault = tabs === null || tabs === void 0 ? void 0 : tabs.find(function(x) {
                    return x.isDefault == true;
                });
                var newTabs = tabs.map(function(item, index) {
                    if (index == 0 && !hasIsDefault) {
                        return _objectSpread({}, item, {
                            isDefault: true
                        });
                    }
                    return item;
                });
                var newTabBlock = immutability_helper_default()(tabBlock, {
                    content_attributes: {
                        tabs: {
                            $set: newTabs
                        }
                    }
                });
                return immutability_helper_default()(position, {
                    block_list: {
                        $apply: function(blocks) {
                            return blocks.map(function(block) {
                                if (block.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB) {
                                    return newTabBlock;
                                }
                                return block;
                            });
                        }
                    }
                });
            });
        },
        disableEnablePosition: function(state, param) {
            var _payload = param.payload, enableValue = _payload.enableValue, positionSlug = _payload.positionSlug;
            var positionIndex = state.findIndex(function(x) {
                return x.slug === positionSlug;
            });
            state[positionIndex] = _objectSpread({}, state[positionIndex], {
                enable: enableValue
            });
        },
        sortBlock: function(state, param) {
            var _payload = param.payload, itemsOrder = _payload.itemsOrder, positionSlug = _payload.positionSlug, tabUid = _payload.tabUid;
            var index = state.findIndex(function(x) {
                return x.slug === positionSlug;
            });
            var newTabList = state[index] && state[index].block_list && state[index].block_list[0] && state[index].block_list[0].content_attributes && state[index].block_list[0].content_attributes.tabs && state[index].block_list[0].content_attributes.tabs.map(function(tab) {
                return tab.uid === tabUid ? _objectSpread({}, tab, {
                    block_list: itemsOrder
                }) : tab;
            });
            var newStateData = positionSlug === "body" ? _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newTabList
                        })
                    }), 
                ]
            }) : _objectSpread({}, state[index], {
                block_list: itemsOrder
            });
            state[index] = newStateData;
        },
        addBlock: function(state, param) {
            var _payload = param.payload, tabUid = _payload.tabUid, positionSlug = _payload.positionSlug, blockData = _payload.blockData;
            var newBlockIndex = blockData.sort_order - 1;
            return state.map(function(position) {
                if (positionSlug == position.slug) {
                    var ref;
                    if (positionSlug !== "body") {
                        //Update for none body block
                        var blockLists = sortBy_default()(_toConsumableArray(position.block_list), [
                            "sort_order"
                        ]);
                        blockLists.splice(newBlockIndex, 0, blockData);
                        return immutability_helper_default()(position, {
                            block_list: {
                                $set: blockLists
                            }
                        });
                    }
                    // Update for tab block
                    var tabBlock = position.block_list[0] || {};
                    var tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                    var newTabList = tabList.map(function(tab) {
                        if (tab.uid === tabUid) {
                            var blockLists = sortBy_default()(_toConsumableArray(tab.block_list), [
                                "sort_order"
                            ]);
                            blockLists.splice(newBlockIndex, 0, blockData);
                            return immutability_helper_default()(tab, {
                                block_list: {
                                    $set: blockLists
                                }
                            });
                        }
                        return tab;
                    });
                    var newTabBlock = immutability_helper_default()(tabBlock, {
                        content_attributes: {
                            tabs: {
                                $set: newTabList
                            }
                        }
                    });
                    return immutability_helper_default()(position, {
                        block_list: {
                            $set: [
                                newTabBlock
                            ]
                        }
                    });
                }
                return position;
            });
        },
        setBlock: function(state, param) {
            var _payload = param.payload, tabUid = _payload.tabUid, positionSlug = _payload.positionSlug, blockData = _payload.blockData;
            var newState = state.map(function(position) {
                var ref;
                if (position.slug !== positionSlug) {
                    return position;
                }
                var loadNewBlocks = function(blocks) {
                    return blocks.map(function(block) {
                        if (block.id == blockData.id || block.uid == blockData.uid) {
                            return _objectSpread({}, block, blockData);
                        }
                        return block;
                    });
                };
                if (positionSlug !== "body") {
                    return immutability_helper_default()(position, {
                        block_list: {
                            $apply: loadNewBlocks
                        }
                    });
                }
                var tabBlock = position.block_list[0] || {};
                var tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                var newTabList = tabList.map(function(tab) {
                    if (tab.uid === tabUid) {
                        return immutability_helper_default()(tab, {
                            block_list: {
                                $apply: loadNewBlocks
                            }
                        });
                    }
                    return tab;
                });
                var newTabBlock = immutability_helper_default()(tabBlock, {
                    content_attributes: {
                        tabs: {
                            $set: newTabList
                        }
                    }
                });
                return immutability_helper_default()(position, {
                    block_list: {
                        $set: [
                            newTabBlock
                        ]
                    }
                });
            });
            return newState;
        },
        removeBlock: function(state, param) {
            var _payload = param.payload, deletedBlock = _payload.deletedBlock, positionSlug = _payload.positionSlug, tabUid = _payload.tabUid;
            var newState = state.map(function(position) {
                var ref;
                if (position.slug !== positionSlug) {
                    return position;
                }
                var removeBlocks = function(blocks) {
                    return blocks.filter(function(block) {
                        return block.id !== deletedBlock.id || block.uid != deletedBlock.uid;
                    });
                };
                if (positionSlug !== "body") {
                    return immutability_helper_default()(position, {
                        block_list: {
                            $apply: removeBlocks
                        }
                    });
                }
                var tabBlock = position.block_list[0] || {};
                var tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                var newTabList = tabList.map(function(tab) {
                    if (tab.uid === tabUid) {
                        return immutability_helper_default()(tab, {
                            block_list: {
                                $apply: removeBlocks
                            }
                        });
                    }
                    return tab;
                });
                var newTabBlock = immutability_helper_default()(tabBlock, {
                    content_attributes: {
                        tabs: {
                            $set: newTabList
                        }
                    }
                });
                return immutability_helper_default()(position, {
                    block_list: {
                        $set: [
                            newTabBlock
                        ]
                    }
                });
            });
            return newState;
        },
        moveBlockToPosition: function(state, param) {
            var _payload = param.payload, blockData = _payload.blockData, oldPositionSlug = _payload.oldPositionSlug, newPositionSlug = _payload.newPositionSlug, oldTabUid = _payload.oldTabUid, newTabUid = _payload.newTabUid;
            var newStateAfterRemovingBlock = state.map(function(position) {
                var removeBlocks = function(blocks) {
                    return blocks.filter(function(block) {
                        return (block === null || block === void 0 ? void 0 : block.id) !== (blockData === null || blockData === void 0 ? void 0 : blockData.id) || (block === null || block === void 0 ? void 0 : block.uid) != (blockData === null || blockData === void 0 ? void 0 : blockData.uid);
                    });
                };
                if (oldPositionSlug === (position === null || position === void 0 ? void 0 : position.slug)) {
                    var ref;
                    if (oldPositionSlug !== "body") {
                        return immutability_helper_default()(position, {
                            block_list: {
                                $apply: removeBlocks
                            }
                        });
                    }
                    var tabBlock = position === null || position === void 0 ? void 0 : position.block_list[0];
                    var tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                    var newTabList = tabList.map(function(tab) {
                        if (tab.uid === oldTabUid) {
                            return immutability_helper_default()(tab, {
                                block_list: {
                                    $apply: removeBlocks
                                }
                            });
                        }
                        return tab;
                    });
                    var newTabBlock = immutability_helper_default()(tabBlock, {
                        content_attributes: {
                            tabs: {
                                $set: newTabList
                            }
                        }
                    });
                    return immutability_helper_default()(position, {
                        block_list: {
                            $set: [
                                newTabBlock
                            ]
                        }
                    });
                } else return position;
            });
            var newState = newStateAfterRemovingBlock === null || newStateAfterRemovingBlock === void 0 ? void 0 : newStateAfterRemovingBlock.map(function(position) {
                if (newPositionSlug === position.slug) {
                    var ref;
                    if (newPositionSlug !== "body") {
                        var _Math;
                        //Update for none body block
                        var listSortOrder = position.block_list.map(function(block) {
                            return block.sort_order;
                        });
                        var newSortOrder = (listSortOrder === null || listSortOrder === void 0 ? void 0 : listSortOrder.length) ? (_Math = Math).max.apply(_Math, _toConsumableArray(listSortOrder)) + 1 : 1;
                        return immutability_helper_default()(position, {
                            block_list: {
                                $push: [
                                    _objectSpread({}, blockData, {
                                        sort_order: newSortOrder
                                    })
                                ]
                            }
                        });
                    }
                    // Update for tab block
                    var tabBlock = position.block_list[0] || {};
                    var tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                    var newTabList = tabList.map(function(tab) {
                        if (tab.uid === newTabUid) {
                            var _Math;
                            var listSortOrder = tab.block_list.map(function(block) {
                                return block.sort_order;
                            });
                            var newSortOrder = (listSortOrder === null || listSortOrder === void 0 ? void 0 : listSortOrder.length) ? (_Math = Math).max.apply(_Math, _toConsumableArray(listSortOrder)) + 1 : 1;
                            return immutability_helper_default()(tab, {
                                block_list: {
                                    $push: [
                                        _objectSpread({}, blockData, {
                                            sort_order: newSortOrder
                                        })
                                    ]
                                }
                            });
                        }
                        return tab;
                    });
                    var newTabBlock = immutability_helper_default()(tabBlock, {
                        content_attributes: {
                            tabs: {
                                $set: newTabList
                            }
                        }
                    });
                    return immutability_helper_default()(position, {
                        block_list: {
                            $set: [
                                newTabBlock
                            ]
                        }
                    });
                }
                return position;
            });
            return newState;
        },
        updateBlock: function(state, param) {
            var _payload = param.payload, tabUid = _payload.tabUid, positionSlug = _payload.positionSlug, blockData = _payload.blockData;
        },
        deleteBlock: function(state, param) {
            var _payload = param.payload, deletedBlock = _payload.deletedBlock, positionSlug = _payload.positionSlug, tabUid = _payload.tabUid;
        },
        disableEnableBlock: function(state, param) {
            var _payload = param.payload, positionSlug = _payload.positionSlug, blockUid = _payload.blockUid, blockStatus = _payload.blockStatus, tabUid = _payload.tabUid;
            var index = state.findIndex(function(x) {
                return x.slug === positionSlug;
            });
            var tabsList = state[index].block_list && state[index].block_list[0] && state[index].block_list[0].content_attributes && state[index].block_list[0].content_attributes.tabs;
            var blockList = positionSlug === "body" ? tabsList.find(function(x) {
                return x.uid === tabUid;
            }).block_list : state[index].block_list;
            var newBlockList = blockList.map(function(block, index) {
                return block.uid === blockUid ? _objectSpread({}, block, {
                    enable: blockStatus
                }) : block;
            });
            var newTabList = tabsList && Array.isArray(tabsList) && tabsList.map(function(tab) {
                return tab.uid === tabUid ? _objectSpread({}, tab, {
                    block_list: newBlockList
                }) : tab;
            });
            var newStateData = positionSlug === "body" ? _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newTabList
                        })
                    }), 
                ]
            }) : _objectSpread({}, state[index], {
                block_list: newBlockList
            });
            state[index] = newStateData;
        },
        changeTitleBlock: function(state, param) {
            var _payload = param.payload, positionSlug = _payload.positionSlug, blockUid = _payload.blockUid, newTitleBlock = _payload.newTitleBlock, tabUid = _payload.tabUid;
            var index = state.findIndex(function(x) {
                return x.slug === positionSlug;
            });
            var tabsList = state[index].block_list && state[index].block_list[0] && state[index].block_list[0].content_attributes && state[index].block_list[0].content_attributes.tabs;
            var blockList = positionSlug === "body" ? tabsList.find(function(x) {
                return x.uid === tabUid;
            }).block_list : state[index].block_list;
            var newBlockList = blockList.map(function(block, index) {
                return block.uid === blockUid ? _objectSpread({}, block, {
                    title: newTitleBlock
                }) : block;
            });
            var newTabList = tabsList && Array.isArray(tabsList) && tabsList.map(function(tab) {
                return tab.uid === tabUid ? _objectSpread({}, tab, {
                    block_list: newBlockList
                }) : tab;
            });
            var newStateData = positionSlug === "body" ? _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newTabList
                        })
                    }), 
                ]
            }) : _objectSpread({}, state[index], {
                block_list: newBlockList
            });
            state[index] = newStateData;
        },
        addTab: function(state, param) {
            var newDataTabList = param.payload.newDataTabList;
            var index = state.findIndex(function(x) {
                return x.slug === "body";
            });
            state[index] = _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newDataTabList
                        })
                    }), 
                ]
            });
        },
        sortTab: function(state, param) {
            var itemsOrder = param.payload.itemsOrder;
            var index = state.findIndex(function(x) {
                return x.slug === "body";
            });
            state[index] = _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: itemsOrder
                        })
                    }), 
                ]
            });
        },
        updateTab: function(state, param) {
            var _payload = param.payload, valueNameTab = _payload.valueNameTab, defaultNameTabIcon = _payload.defaultNameTabIcon, indexTab = _payload.indexTab, urlIcon = _payload.urlIcon;
            var index1 = state.findIndex(function(x) {
                return x.slug === "body";
            });
            var tabsList = state[index1].block_list && state[index1].block_list[0] && state[index1].block_list[0].content_attributes && state[index1].block_list[0].content_attributes.tabs;
            var newTablist = tabsList && tabsList.map(function(ele, index) {
                return indexTab === index ? _objectSpread({}, ele, {
                    name: valueNameTab,
                    icon: defaultNameTabIcon,
                    icon_url: urlIcon
                }) : ele;
            });
            state[index1] = _objectSpread({}, state[index1], {
                block_list: [
                    _objectSpread({}, state[index1].block_list[0], {
                        content_attributes: _objectSpread({}, state[index1].block_list[0].content_attributes, {
                            tabs: newTablist
                        })
                    }), 
                ]
            });
        },
        deleteTab: function(state, param) {
            var newItems = param.payload.newItems;
            var index = state.findIndex(function(x) {
                return x.slug === "body";
            });
            state[index] = _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newItems
                        })
                    }), 
                ]
            });
        },
        disableEnableTab: function(state, param) {
            var _payload = param.payload, tabUid = _payload.tabUid, tabStatus = _payload.tabStatus;
            var index = state.findIndex(function(x) {
                return x.slug === "body";
            });
            var tabsList = state[index].block_list && state[index].block_list[0] && state[index].block_list[0].content_attributes && state[index].block_list[0].content_attributes.tabs;
            var newTablist = tabsList && tabsList.map(function(ele, index) {
                return tabUid === ele.uid ? _objectSpread({}, ele, {
                    enable: tabStatus
                }) : ele;
            });
            state[index] = _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: newTablist
                        })
                    }), 
                ]
            });
        },
        setDefaultTab: function(state, param) {
            var _payload = param.payload, indexTab = _payload.indexTab, tabStatus = _payload.tabStatus;
            var index2 = state.findIndex(function(x) {
                return x.slug === "body";
            });
            var tabsList = state[index2].block_list && state[index2].block_list[0] && state[index2].block_list[0].content_attributes && state[index2].block_list[0].content_attributes.tabs;
            var tabDefaultInitial = tabsList.find(function(x) {
                return x.isDefault === true;
            });
            delete tabDefaultInitial.isDefault;
            var newTablist = tabsList && tabsList.map(function(ele, index) {
                return indexTab === index ? _objectSpread({}, ele, {
                    isDefault: true,
                    enable: tabStatus
                }) : ele;
            });
            state[index2] = _objectSpread({}, state[index2], {
                block_list: [
                    _objectSpread({}, state[index2].block_list[0], {
                        content_attributes: _objectSpread({}, state[index2].block_list[0].content_attributes, {
                            tabs: newTablist
                        })
                    }), 
                ]
            });
        },
        updateTabsBody: function(state, param) {
            var data = param.payload.data;
            var index = state.findIndex(function(x) {
                return x.slug === "body";
            });
            state[index] = _objectSpread({}, state[index], {
                block_list: [
                    _objectSpread({}, state[index].block_list[0], {
                        content_attributes: _objectSpread({}, state[index].block_list[0].content_attributes, {
                            tabs: data
                        })
                    }), 
                ]
            });
        }
    }
});
var _actions = positionSlice.actions;
var sortBlock = _actions.sortBlock, addBlock = _actions.addBlock, deleteBlock = _actions.deleteBlock, removeBlock = _actions.removeBlock, updateBlock = _actions.updateBlock, moveBlockToPosition = _actions.moveBlockToPosition, setBlock = _actions.setBlock, setPosition = _actions.setPosition, disableEnableBlock = _actions.disableEnableBlock, disableEnablePosition = _actions.disableEnablePosition, changeTitleBlock = _actions.changeTitleBlock, addTab = _actions.addTab, sortTab = _actions.sortTab, updateTab = _actions.updateTab, deleteTab = _actions.deleteTab, disableEnableTab = _actions.disableEnableTab, setDefaultTab = _actions.setDefaultTab, updateTabsBody = _actions.updateTabsBody;
var allPosition = function(state) {
    return state.positions;
};
var getBlocksBySlug = function(slug, includeBlockType) {
    return createSelector([
        allPosition
    ], function(positions) {
        var blocks = [];
        if (positions) {
            if (slug === "all") {
                blocks = positions.reduce(function(accumulator, currentValue) {
                    return accumulator.concat(currentValue.block_list);
                }, []);
            } else if (slug == store_interface/* POSITION_SLUG.BODY */.bW.BODY) {
                var ref, ref1, ref2;
                var listTabInBody = (ref1 = (ref = positions === null || positions === void 0 ? void 0 : positions.find(function(x) {
                    return (x === null || x === void 0 ? void 0 : x.slug) === configs_const/* POSITION_MAIN_LAYOUT.BODY */.Kw.BODY;
                })) === null || ref === void 0 ? void 0 : ref.block_list[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
                blocks = listTabInBody === null || listTabInBody === void 0 ? void 0 : listTabInBody.reduce(function(accumulator, currentValue) {
                    return accumulator.concat(currentValue.block_list);
                }, []);
            } else {
                var ref3;
                blocks = (ref3 = positions.find(function(position) {
                    return position.slug === slug;
                })) === null || ref3 === void 0 ? void 0 : ref3.block_list;
            }
        }
        if (includeBlockType) {
            blocks = blocks && blocks.filter(function(block) {
                return includeBlockType.includes(block === null || block === void 0 ? void 0 : block.block_type);
            });
            blocks = sortBy_default()(blocks, [
                "sort_order"
            ]);
        }
        return blocks;
    });
};
/* harmony default export */ var positionsSlice = (positionSlice.reducer);


/***/ }),

/***/ 24882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H9": function() { return /* binding */ setDisplaySetting; },
/* harmony export */   "cP": function() { return /* binding */ setSiteInfo; },
/* harmony export */   "rm": function() { return /* binding */ setHasChange; },
/* harmony export */   "xO": function() { return /* binding */ setVersion; }
/* harmony export */ });
/* unused harmony exports siteSettingSlice, block_style */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var initialState = {
    display_setting: {
        background: {
            gradient: "",
            image: "",
            type: "",
            color: ""
        },
        primary_color: "",
        font_family: ""
    }
};
var siteSettingSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "siteSettings",
    initialState: initialState,
    reducers: {
        setSiteInfo: function(state, param) {
            var sites = param.payload.sites;
            return sites;
        },
        setDisplaySetting: function(state, param) {
            var data = param.payload.data;
            state.display_setting = _objectSpread({}, state.display_setting, data);
        },
        setVersion: function(state, param) {
            var version = param.payload.version;
            return _objectSpread({}, state, {
                version: version
            });
        },
        setHasChange: function(state, param) {
            var has_change = param.payload.has_change;
            return _objectSpread({}, state, {
                has_change: has_change
            });
        }
    }
});
var block_style = function(state) {
    var ref, ref1, ref2;
    return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : ref2.block_style;
};
var _actions = siteSettingSlice.actions;
var setSiteInfo = _actions.setSiteInfo, setDisplaySetting = _actions.setDisplaySetting, setVersion = _actions.setVersion, setHasChange = _actions.setHasChange;
/* harmony default export */ __webpack_exports__["ZP"] = (siteSettingSlice.reducer);


/***/ }),

/***/ 50049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "me": function() { return /* binding */ setWebsiteConfig; }
/* harmony export */ });
/* unused harmony export websiteConfigSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var initialState = {
    favicon: "",
    id: "",
    meta_description: "",
    meta_title: "",
    site_title: ""
};
var websiteConfigSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "websiteConfig",
    initialState: initialState,
    reducers: {
        setWebsiteConfig: function(state, param) {
            var data = param.payload.data;
            return _objectSpread({}, state, data);
        }
    }
});
var setWebsiteConfig = websiteConfigSlice.actions.setWebsiteConfig;
/* harmony default export */ __webpack_exports__["ZP"] = (websiteConfigSlice.reducer);


/***/ }),

/***/ 98267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LN": function() { return /* binding */ MINI_STORE_BLOCK; },
  "Av": function() { return /* binding */ MINI_STORE_BLOCK_TYPE; },
  "vi": function() { return /* binding */ MINI_STORE_DESIGN_COMPONENT; },
  "kY": function() { return /* binding */ MINI_STORE_MIDDLEWARE; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 91 modules
var block_conf = __webpack_require__(60920);
// EXTERNAL MODULE: ./src/features/mini-store/share/api/index.tsx
var api = __webpack_require__(25109);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
;// CONCATENATED MODULE: ./src/features/mini-store/share/helper/price.ts

var getMaxPrice = function(country) {
    switch(country){
        case configs_const/* COUNTRY_VN */.ie:
            return 9999999999;
        case configs_const/* COUNTRY_ID */.HV:
            return 200000000;
        case configs_const/* COUNTRY_MY */.n7:
            return 90000000;
        case configs_const/* COUNTRY_SG */.YA:
            return 50000;
        case configs_const/* COUNTRY_PH */.KP:
            return 100000000;
        case configs_const/* COUNTRY_TH */.Un:
            return 50000000;
        default:
            return 10000;
    }
};
var getMinPrice = function(country) {
    switch(country){
        case configs_const/* COUNTRY_VN */.ie:
            return 1000;
        case configs_const/* COUNTRY_ID */.HV:
            return 1000;
        case configs_const/* COUNTRY_MY */.n7:
            return 1;
        case configs_const/* COUNTRY_SG */.YA:
            return 1;
        case configs_const/* COUNTRY_PH */.KP:
            return 1000;
        case configs_const/* COUNTRY_TH */.Un:
            return 20;
        default:
            return 1;
    }
};

// EXTERNAL MODULE: ./src/features/mini-store/share/hook.ts
var hook = __webpack_require__(25013);
// EXTERNAL MODULE: ./src/features/user/userSlice.ts
var userSlice = __webpack_require__(79206);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var es = __webpack_require__(92145);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/features/mini-store/block/Donation/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











function Donation(props) {
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var profile = (0,es/* useSelector */.v9)(userSlice/* selectProfile */.tM);
    var t = (0,hook/* useAppTranslation */.S)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var defaultValueEditBio = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var titleBlockDefault = "Donation";
    var KEY = edittingBlock && edittingBlock.KEY;
    (0,react.useEffect)(function() {
        var getParams = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var store, dataParams, UID, defaultDonateData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,api/* fetchStoreToken */.uL)();
                        case 2:
                            store = _ctx.sent;
                            dataParams = {
                                name: t("invitation_default_donation", {
                                    name: profile.username
                                }),
                                acceptance_criteria: t("message_default_donation", {
                                    name: profile.username
                                }),
                                price: getMinPrice(profile.country),
                                max_price: getMaxPrice(profile.country),
                                seller_id: store.seller_id,
                                btn_donation_title: t("button_title_default_donation", {
                                    name: profile.username
                                }),
                                country: profile.country
                            };
                            if (!block.uid) {
                                UID = "donation-".concat((0,v4/* default */.Z)());
                                defaultDonateData = {
                                    uid: UID,
                                    sort_order: 1,
                                    enable: 1,
                                    block_type: block_conf/* BLOCK_TYPE.DONATION */.bF.DONATION,
                                    title: "Donation",
                                    content_attributes: {
                                        dataParams: dataParams
                                    },
                                    style_attributes: {}
                                };
                                onUpdateData(defaultDonateData);
                                setButtonStatus(false);
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getParams() {
                return _ref.apply(this, arguments);
            };
        }();
        getParams();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white mt-4 px-4 py-3 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "",
                    src: "https://i.ecomobi.com/ssp/mini-store/donation/image-frame.png",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-lg",
                    children: t("ss_donation_setting_default_title_setup_donation")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-xs text-[#8C8C8C]",
                    children: t("ss_donation_setting_default_content_setup_donation")
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/features/design/components/BlockWrapper/index.tsx
var BlockWrapper = __webpack_require__(62055);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var antd_mobile_es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
;// CONCATENATED MODULE: ./src/features/mini-store/design/DonationDesign/index.tsx
function DonationDesign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DonationDesign_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DonationDesign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DonationDesign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










function DonationDesign(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var t = (0,hook/* useAppTranslation */.S)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var enable = blockData && blockData.enable;
    var allowService = window["AllowStore"];
    var loadDetailDonation = function() {
        var _ref = DonationDesign_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* getDetailDonation */.Ft)();
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadDetailDonation() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react_query_es.useQuery)("LoadDetailDonation", loadDetailDonation, {
        refetchOnWindowFocus: false
    }), isLoading = ref3.isLoading, detailDonate = ref3.data;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "loading"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (!detailDonate.name || !(allowService === null || allowService === void 0 ? void 0 : allowService.allow_view_donation)) && "opacity-50",
                    src: "https://i.ecomobi.com/ssp/mini-store/donation/image-frame.png",
                    alt: ""
                }),
                !!detailDonate.name && (allowService === null || allowService === void 0 ? void 0 : allowService.allow_view_donation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "w-full pt-2 pb-4 break-words text-center",
                            children: (0,lib/* htmlDecode */.l_)(detailDonate.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Button */.zx, {
                            // className={`w-full button-border-radius button-background-color button-border-width button-border-color button-border-style button-text-color button-box-shadow middle-button`}
                            className: "w-full pp-button",
                            children: (0,lib/* htmlDecode */.l_)(detailDonate.btn_donation_title) || "hello"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(36609);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGiftFooter/index.tsx





function TruthOrDareFooter(props) {
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var UID = "brand-gift-footer-".concat((0,v4/* default */.Z)());
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultBrandGiftFooterData = {
                uid: UID,
                sort_order: 1,
                enable: 1,
                block_type: block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER,
                title: "Brand Gift Footer",
                content_attributes: {},
                style_attributes: {}
            };
            onUpdateData(defaultBrandGiftFooterData);
            setButtonStatus(false);
            setEditStatus(false);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#FFF] border solid border-[#EEEEEE] flex flex-col justify-center items-center py-3 mt-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                width: 512,
                src: "https://i.ecomobi.com/ssp/mini-store/brand-gift/background-brand-gift.png",
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[#8C8C8C] text-xs",
                children: (0,i18next.t)("ss_brand_gift_setting_float_icon_description")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var share_api = __webpack_require__(85861);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/utils/sleep.js
var sleep = __webpack_require__(24547);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./src/features/mini-store/block/GiftFooter/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function GiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function GiftFooter_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                GiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                GiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var GiftFooter = function(props) {
    var ref6, ref1;
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var UID = "virtual-gift-footer-".concat((0,v4/* default */.Z)());
    var count = (0,react.useRef)(1);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId = user === null || user === void 0 ? void 0 : (ref6 = user.kol) === null || ref6 === void 0 ? void 0 : ref6._id;
    var countryCode = user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var KEY = edittingBlock && edittingBlock.KEY;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var defaultValueEditGift = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var titleBlockDefault = "Virtual Gift Footer";
    var ref2 = (0,react.useState)([]), virtualGiftArr = ref2[0], setVirtualGiftArr = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenEditTitleGiftBlock = ref3[0], setIsOpenEditTitleGiftBlock = ref3[1];
    var ref4 = (0,react.useState)(true), hasMoreIcon = ref4[0], setHasMoreIcon = ref4[1];
    (0,react.useEffect)(function() {
        loadMoreIcon();
    }, []);
    (0,react.useEffect)(function() {
        if (!block.uid) {
            var defaultGiftData = {
                uid: UID,
                sort_order: 1,
                enable: configs_const/* ENABLE_BLOCK */.C5,
                block_type: block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER,
                title: titleBlockDefault,
                content_attributes: {
                },
                style_attributes: {}
            };
            onUpdateData(defaultGiftData);
        } else {
            onUpdateData(_objectSpread({}, block, {
                title: titleBlockDefault,
                content_attributes: {
                },
                style_attributes: {}
            }));
        }
    }, []);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (KEY === "add-new-block" && virtualGiftArr.length > 0) {
            return false;
        } else return true;
    }, [
        virtualGiftArr,
        KEY
    ]);
    (0,react.useEffect)(function() {
        setButtonStatus(isDisableBtnSave);
    }, [
        isDisableBtnSave
    ]);
    var InfiniteScrollContent = function(param) {
        var hasMore = param.hasMore;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("ss_builder_loading_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* DotLoading */.k_, {})
                ]
            }) : null
        });
    };
    function loadMoreIcon() {
        return _loadMoreIcon.apply(this, arguments);
    }
    function _loadMoreIcon() {
        _loadMoreIcon = GiftFooter_asyncToGenerator(runtime_default().mark(function _callee() {
            var response, data, ref, ref5, virtualGiftData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(count.current !== 1)) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return (0,sleep/* sleep */._)(1000);
                    case 3:
                        response = null;
                        data = {
                            page: count.current,
                            per_page: 10,
                            country_code: countryCode,
                            user_id: userId
                        };
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,share_api/* requestGetListVirtualGift */.ik)(data);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 14:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            ;
                            virtualGiftData = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref5 = ref.data) === null || ref5 === void 0 ? void 0 : ref5.items.map(function(item) {
                                return {
                                    id: item.id,
                                    name: item.name,
                                    description: item.description,
                                    image_url: (item === null || item === void 0 ? void 0 : item.thumbnails[0]) ? item === null || item === void 0 ? void 0 : item.thumbnails[0].url : ""
                                };
                            });
                            setVirtualGiftArr(function(value) {
                                return _toConsumableArray(value).concat(_toConsumableArray(virtualGiftData));
                            });
                            if (Array.isArray(virtualGiftData) && virtualGiftData.length === 0) {
                                setHasMoreIcon(false);
                            }
                        }
                        count.current = count.current + 1;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return _loadMoreIcon.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " px-4 py-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: t("ss_builder_virtual_gift_list_title")
                    }),
                    virtualGiftArr && virtualGiftArr.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            virtualGiftArr.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* List */.aV, {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* List.Item */.aV.Item, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Image */.Ee, {
                                                    src: ele.image_url,
                                                    width: 40,
                                                    height: 40,
                                                    fit: "cover"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col w-[30vw] md:w-[10vw] grow",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-ellipsis whitespace-nowrap overflow-hidden text-lg leading-6 font-normal",
                                                            children: ele.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-xs leading-4 font-normal text-[#8C8C8C] text-ellipsis whitespace-nowrap overflow-hidden",
                                                            children: ele.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, ele.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* InfiniteScroll */.v_, {
                                loadMore: loadMoreIcon,
                                hasMore: hasMoreIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                                    hasMore: hasMoreIcon
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-center items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InboxIcon */.xx, {
                                    className: "align-middle"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333333] text-lg leading-6",
                                children: t("ss_builder_affiliate_product_list_empty_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#8C8C8C] text-xs leading-4",
                                children: t("ss_builder_affiliate_product_list_empty_content")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var block_GiftFooter = (GiftFooter);

;// CONCATENATED MODULE: ./src/features/mini-store/design/BlockVirtualGiftFooter/index.tsx
function BlockVirtualGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockVirtualGiftFooter_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockVirtualGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockVirtualGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function BlockVirtualGiftFooter(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var allowService = window["AllowStore"];
    var t = (0,hook/* useAppTranslation */.S)().t;
    var loadStore = function() {
        var _ref = BlockVirtualGiftFooter_asyncToGenerator(runtime_default().mark(function _callee() {
            var store;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* fetchStoreToken */.uL)();
                    case 2:
                        store = _ctx.sent;
                        if (!store) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", store);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadStore() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react_query_es.useQuery)("LoadStore", loadStore, {
        refetchOnWindowFocus: false
    }), isLoading = ref3.isLoading, store1 = ref3.data;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "loading"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        extraStyle: {
            padding: "0",
            // border: "0",
            borderWidth: "0",
            background: "transparent",
            backdropFilter: "none",
            borderStyle: "none",
            boxShadow: "none"
        },
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col justify-center items-center p-3 rounded-lg",
            style: {
                border: "1px solid rgba(130, 130, 130, 0.75)"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://image.passio.eco/page-builder/page-builder/service-icon/gift.png"
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/design/BlockBrandGiftFooter/index.tsx
function BlockBrandGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockBrandGiftFooter_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockBrandGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockBrandGiftFooter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function BlockBrandGiftFooter(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var allowService = window["AllowStore"];
    var t = (0,hook/* useAppTranslation */.S)().t;
    var loadStore = function() {
        var _ref = BlockBrandGiftFooter_asyncToGenerator(runtime_default().mark(function _callee() {
            var store;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* fetchStoreToken */.uL)();
                    case 2:
                        store = _ctx.sent;
                        if (!store) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", store);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadStore() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react_query_es.useQuery)("LoadStore", loadStore, {
        refetchOnWindowFocus: false
    }), isLoading = ref3.isLoading, store1 = ref3.data;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "loading"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        extraStyle: {
            padding: "0",
            // border: "0",
            borderWidth: "0",
            background: "transparent",
            backdropFilter: "none",
            borderStyle: "none",
            boxShadow: "none"
        },
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col justify-center items-center p-3 rounded-lg",
            style: {
                border: "1px solid rgba(130, 130, 130, 0.75)"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                width: "49px",
                height: "49px",
                className: !(allowService === null || allowService === void 0 ? void 0 : allowService.allow_view_brand_gift) && "opacity-50",
                src: "https://i.ecomobi.com/ssp/mini-store/brand-gift/icon-brand-gift-builder.png",
                alt: ""
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/middleware/DonationMiddleWare/index.tsx
function DonationMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DonationMiddleWare_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DonationMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DonationMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var DONATION_ON = 1;
var DonationMiddleWare = function() {
    var _ref = DonationMiddleWare_asyncToGenerator(runtime_default().mark(function _callee(data, extraData) {
        var params, store, dataUpdate;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!data) {
                        _ctx.next = 18;
                        break;
                    }
                    params = data.content_attributes && data.content_attributes.dataParams;
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return (0,api/* fetchStoreToken */.uL)();
                case 5:
                    store = _ctx.sent;
                    if (!(store && store.donation_status != DONATION_ON)) {
                        _ctx.next = 13;
                        break;
                    }
                    dataUpdate = {
                        donation_status: DONATION_ON,
                        id: store.id
                    };
                    _ctx.next = 10;
                    return (0,share_api/* updateStore */.Y3)(dataUpdate);
                case 10:
                    if (store.product_donation_status) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 13;
                    return (0,share_api/* saveSettingDonation */.FG)(params);
                case 13:
                    _ctx.next = 18;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](2);
                    return _ctx.abrupt("return", data);
                case 18:
                    return _ctx.abrupt("return", data);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                15
            ]
        ]);
    }));
    return function DonationMiddleWare(data, extraData) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/mini-store/setting/constants.ts
var BACK_GROUND_IMAGE = {
    BRAND_GIFT: "https://i.ecomobi.com/ssp/mini-store/brand-gift/background-brand-gift.png",
    BRAND_RATING: "https://i.ecomobi.com/ssp/mini-store/brand-deal/BrandRatingsPP.jpg"
};
var MAX_LENGTH_INPUT_TITLE = 60;
var MAX_LENGTH_INPUT_BUTTON = 40;
var NAME_SERVICE = {
    BRAND_GIFT: "brand_gift"
};

// EXTERNAL MODULE: ./src/features/mini-store/block/BrandGift/style.module.scss
var style_module = __webpack_require__(23290);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js + 26 modules
var react_beautiful_dnd_esm = __webpack_require__(9276);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/constants/index.tsx
var ACTION_KEY = {
    HIDE_DISPLAY: "hide-display",
    UP_FIRST: "up-first",
    DOWN_LAST: "down-last"
};
var IFRAME_ACTION = {
    CLOSE_IFRAME: "close-iframe",
    LIST_DATA: "list-data",
    GET_DATA: "get-data",
    RECIVED_DATA: "received-data"
};
var MOVE = {
    UP_FIRST: "up-first",
    DOWN_LAST: "down-last"
};

;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/icons/index.tsx

var MoveIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 22 : _width, _height = param.height, height = _height === void 0 ? 23 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250860)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.75279 10.5843H19.2528C19.4959 10.5843 19.7291 10.4877 19.901 10.3158C20.0729 10.1439 20.1695 9.91076 20.1695 9.66764C20.1695 9.42453 20.0729 9.19137 19.901 9.01946C19.7291 8.84755 19.4959 8.75098 19.2528 8.75098H2.75279C2.50967 8.75098 2.27651 8.84755 2.10461 9.01946C1.9327 9.19137 1.83612 9.42453 1.83612 9.66764C1.83612 9.91076 1.9327 10.1439 2.10461 10.3158C2.27651 10.4877 2.50967 10.5843 2.75279 10.5843ZM19.2528 12.4176H2.75279C2.50967 12.4176 2.27651 12.5142 2.10461 12.6861C1.9327 12.858 1.83612 13.0912 1.83612 13.3343C1.83612 13.5774 1.9327 13.8106 2.10461 13.9825C2.27651 14.1544 2.50967 14.251 2.75279 14.251H19.2528C19.4959 14.251 19.7291 14.1544 19.901 13.9825C20.0729 13.8106 20.1695 13.5774 20.1695 13.3343C20.1695 13.0912 20.0729 12.858 19.901 12.6861C19.7291 12.5142 19.4959 12.4176 19.2528 12.4176Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250860",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var ThreeDot = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250909)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.0028 9.66797C10.6402 9.66797 10.2858 9.77549 9.98426 9.97694C9.68277 10.1784 9.44779 10.4647 9.30903 10.7997C9.17027 11.1347 9.13396 11.5033 9.2047 11.859C9.27544 12.2146 9.45005 12.5413 9.70645 12.7977C9.96284 13.0541 10.2895 13.2287 10.6451 13.2994C11.0008 13.3701 11.3694 13.3338 11.7044 13.1951C12.0394 13.0563 12.3257 12.8213 12.5272 12.5198C12.7286 12.2184 12.8361 11.8639 12.8361 11.5013C12.8361 11.0151 12.643 10.5488 12.2992 10.2049C11.9554 9.86112 11.489 9.66797 11.0028 9.66797ZM4.58614 9.66797C4.22354 9.66797 3.86909 9.77549 3.5676 9.97694C3.26611 10.1784 3.03112 10.4647 2.89236 10.7997C2.7536 11.1347 2.7173 11.5033 2.78804 11.859C2.85877 12.2146 3.03338 12.5413 3.28978 12.7977C3.54618 13.0541 3.87284 13.2287 4.22848 13.2994C4.58411 13.3701 4.95273 13.3338 5.28773 13.1951C5.62273 13.0563 5.90905 12.8213 6.1105 12.5198C6.31195 12.2184 6.41948 11.8639 6.41948 11.5013C6.41948 11.0151 6.22632 10.5488 5.8825 10.2049C5.53869 9.86112 5.07237 9.66797 4.58614 9.66797ZM17.4195 9.66797C17.0569 9.66797 16.7024 9.77549 16.4009 9.97694C16.0994 10.1784 15.8645 10.4647 15.7257 10.7997C15.5869 11.1347 15.5506 11.5033 15.6214 11.859C15.6921 12.2146 15.8667 12.5413 16.1231 12.7977C16.3795 13.0541 16.7062 13.2287 17.0618 13.2994C17.4174 13.3701 17.7861 13.3338 18.1211 13.1951C18.4561 13.0563 18.7424 12.8213 18.9438 12.5198C19.1453 12.2184 19.2528 11.8639 19.2528 11.5013C19.2528 11.0151 19.0597 10.5488 18.7158 10.2049C18.372 9.86112 17.9057 9.66797 17.4195 9.66797Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250909",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var DeleteIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_6027_250924)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.6663 4.99935H13.333V4.16602C13.333 3.50297 13.0696 2.86709 12.6008 2.39825C12.1319 1.92941 11.496 1.66602 10.833 1.66602H9.16633C8.50329 1.66602 7.8674 1.92941 7.39856 2.39825C6.92972 2.86709 6.66633 3.50297 6.66633 4.16602V4.99935H3.333C3.11198 4.99935 2.90002 5.08715 2.74374 5.24343C2.58746 5.39971 2.49966 5.61167 2.49966 5.83268C2.49966 6.0537 2.58746 6.26566 2.74374 6.42194C2.90002 6.57822 3.11198 6.66602 3.333 6.66602H4.16633V15.8327C4.16633 16.4957 4.42972 17.1316 4.89856 17.6005C5.3674 18.0693 6.00329 18.3327 6.66633 18.3327H13.333C13.996 18.3327 14.6319 18.0693 15.1008 17.6005C15.5696 17.1316 15.833 16.4957 15.833 15.8327V6.66602H16.6663C16.8873 6.66602 17.0993 6.57822 17.2556 6.42194C17.4119 6.26566 17.4997 6.0537 17.4997 5.83268C17.4997 5.61167 17.4119 5.39971 17.2556 5.24343C17.0993 5.08715 16.8873 4.99935 16.6663 4.99935ZM8.333 4.16602C8.333 3.945 8.42079 3.73304 8.57708 3.57676C8.73336 3.42048 8.94532 3.33268 9.16633 3.33268H10.833C11.054 3.33268 11.266 3.42048 11.4223 3.57676C11.5785 3.73304 11.6663 3.945 11.6663 4.16602V4.99935H8.333V4.16602ZM14.1663 15.8327C14.1663 16.0537 14.0785 16.2657 13.9223 16.4219C13.766 16.5782 13.554 16.666 13.333 16.666H6.66633C6.44532 16.666 6.23336 16.5782 6.07708 16.4219C5.9208 16.2657 5.833 16.0537 5.833 15.8327V6.66602H14.1663V15.8327Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_6027_250924",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var UpFirstIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250951)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.000976562)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.75798 5.24167C4.67873 5.1658 4.58527 5.10633 4.48298 5.06667C4.2801 4.98332 4.05253 4.98332 3.84965 5.06667C3.74735 5.10633 3.6539 5.1658 3.57465 5.24167L1.90798 6.90833C1.75106 7.06525 1.6629 7.27808 1.6629 7.5C1.6629 7.72192 1.75106 7.93475 1.90798 8.09167C2.0649 8.24859 2.27773 8.33674 2.49965 8.33674C2.72156 8.33674 2.93439 8.24859 3.09131 8.09167L3.33298 7.84167V14.1667C3.33298 14.3877 3.42078 14.5996 3.57706 14.7559C3.73334 14.9122 3.9453 15 4.16631 15C4.38733 15 4.59929 14.9122 4.75557 14.7559C4.91185 14.5996 4.99965 14.3877 4.99965 14.1667V7.84167L5.24131 8.09167C5.31878 8.16977 5.41095 8.23177 5.5125 8.27408C5.61405 8.31638 5.72297 8.33817 5.83298 8.33817C5.94299 8.33817 6.05191 8.31638 6.15346 8.27408C6.25501 8.23177 6.34718 8.16977 6.42465 8.09167C6.50275 8.0142 6.56475 7.92203 6.60706 7.82048C6.64936 7.71893 6.67114 7.61001 6.67114 7.5C6.67114 7.38999 6.64936 7.28107 6.60706 7.17952C6.56475 7.07797 6.50275 6.9858 6.42465 6.90833L4.75798 5.24167ZM9.16631 6.66667H17.4996C17.7207 6.66667 17.9326 6.57887 18.0889 6.42259C18.2452 6.26631 18.333 6.05435 18.333 5.83333C18.333 5.61232 18.2452 5.40036 18.0889 5.24408C17.9326 5.0878 17.7207 5 17.4996 5H9.16631C8.9453 5 8.73334 5.0878 8.57706 5.24408C8.42078 5.40036 8.33298 5.61232 8.33298 5.83333C8.33298 6.05435 8.42078 6.26631 8.57706 6.42259C8.73334 6.57887 8.9453 6.66667 9.16631 6.66667ZM17.4996 13.3333H9.16631C8.9453 13.3333 8.73334 13.4211 8.57706 13.5774C8.42078 13.7337 8.33298 13.9457 8.33298 14.1667C8.33298 14.3877 8.42078 14.5996 8.57706 14.7559C8.73334 14.9122 8.9453 15 9.16631 15H17.4996C17.7207 15 17.9326 14.9122 18.0889 14.7559C18.2452 14.5996 18.333 14.3877 18.333 14.1667C18.333 13.9457 18.2452 13.7337 18.0889 13.5774C17.9326 13.4211 17.7207 13.3333 17.4996 13.3333ZM17.4996 9.16667H9.16631C8.9453 9.16667 8.73334 9.25446 8.57706 9.41074C8.42078 9.56702 8.33298 9.77899 8.33298 10C8.33298 10.221 8.42078 10.433 8.57706 10.5893C8.73334 10.7455 8.9453 10.8333 9.16631 10.8333H17.4996C17.7207 10.8333 17.9326 10.7455 18.0889 10.5893C18.2452 10.433 18.333 10.221 18.333 10C18.333 9.77899 18.2452 9.56702 18.0889 9.41074C17.9326 9.25446 17.7207 9.16667 17.4996 9.16667Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250951",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.000976562)"
                    })
                })
            })
        ]
    });
};
var DownLastIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "21",
        viewBox: "0 0 28 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6027_250978)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.00195312)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.24131 11.9093L4.99965 12.1593V5.83431C4.99965 5.6133 4.91185 5.40133 4.75557 5.24505C4.59929 5.08877 4.38733 5.00098 4.16631 5.00098C3.9453 5.00098 3.73334 5.08877 3.57706 5.24505C3.42078 5.40133 3.33298 5.6133 3.33298 5.83431V12.1593L3.09131 11.9093C2.93439 11.7524 2.72156 11.6642 2.49965 11.6642C2.27773 11.6642 2.0649 11.7524 1.90798 11.9093C1.75106 12.0662 1.6629 12.2791 1.6629 12.501C1.6629 12.7229 1.75106 12.9357 1.90798 13.0926L3.57465 14.7593C3.6539 14.8352 3.74735 14.8946 3.84965 14.9343C3.9494 14.9784 4.05725 15.0012 4.16631 15.0012C4.27537 15.0012 4.38323 14.9784 4.48298 14.9343C4.58527 14.8946 4.67873 14.8352 4.75798 14.7593L6.42465 13.0926C6.50235 13.0149 6.56398 12.9227 6.60603 12.8212C6.64808 12.7197 6.66972 12.6109 6.66972 12.501C6.66972 12.3911 6.64808 12.2823 6.60603 12.1808C6.56398 12.0792 6.50235 11.987 6.42465 11.9093C6.34695 11.8316 6.25471 11.77 6.15319 11.7279C6.05167 11.6859 5.94286 11.6642 5.83298 11.6642C5.7231 11.6642 5.61429 11.6859 5.51277 11.7279C5.41125 11.77 5.31901 11.8316 5.24131 11.9093ZM9.16631 6.66764H17.4996C17.7207 6.66764 17.9326 6.57985 18.0889 6.42357C18.2452 6.26728 18.333 6.05532 18.333 5.83431C18.333 5.6133 18.2452 5.40133 18.0889 5.24505C17.9326 5.08877 17.7207 5.00098 17.4996 5.00098H9.16631C8.9453 5.00098 8.73334 5.08877 8.57706 5.24505C8.42078 5.40133 8.33298 5.6133 8.33298 5.83431C8.33298 6.05532 8.42078 6.26728 8.57706 6.42357C8.73334 6.57985 8.9453 6.66764 9.16631 6.66764ZM17.4996 9.16764H9.16631C8.9453 9.16764 8.73334 9.25544 8.57706 9.41172C8.42078 9.568 8.33298 9.77996 8.33298 10.001C8.33298 10.222 8.42078 10.434 8.57706 10.5902C8.73334 10.7465 8.9453 10.8343 9.16631 10.8343H17.4996C17.7207 10.8343 17.9326 10.7465 18.0889 10.5902C18.2452 10.434 18.333 10.222 18.333 10.001C18.333 9.77996 18.2452 9.568 18.0889 9.41172C17.9326 9.25544 17.7207 9.16764 17.4996 9.16764ZM17.4996 13.3343H9.16631C8.9453 13.3343 8.73334 13.4221 8.57706 13.5784C8.42078 13.7347 8.33298 13.9466 8.33298 14.1676C8.33298 14.3887 8.42078 14.6006 8.57706 14.7569C8.73334 14.9132 8.9453 15.001 9.16631 15.001H17.4996C17.7207 15.001 17.9326 14.9132 18.0889 14.7569C18.2452 14.6006 18.333 14.3887 18.333 14.1676C18.333 13.9466 18.2452 13.7347 18.0889 13.5784C17.9326 13.4221 17.7207 13.3343 17.4996 13.3343Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6027_250978",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00195312)"
                    })
                })
            })
        ]
    });
};
var WarningIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "46",
        height: "40",
        viewBox: "0 0 46 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M44.4 31L28.2 2.99997C26.6 0.199974 22.8 -0.800026 20 0.799974C19 1.39997 18.2 2.19997 17.8 2.99997L1.59999 31C-7.62939e-06 33.8 0.999993 37.6 3.79999 39.2C4.79999 39.8 5.79999 40 6.79999 40H39C42.4 40 45 37.2 45 34C45.2 32.8 44.8 31.8 44.4 31ZM23 32C21.8 32 21 31.2 21 30C21 28.8 21.8 28 23 28C24.2 28 25 28.8 25 30C25 31.2 24.2 32 23 32ZM25 22C25 23.2 24.2 24 23 24C21.8 24 21 23.2 21 22V14C21 12.8 21.8 12 23 12C24.2 12 25 12.8 25 14V22Z",
            fill: "#FF8F1F"
        })
    });
};
var RequiredIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "8",
        height: "24",
        viewBox: "0 0 8 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_6526_237306)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        width: "8",
                        height: "23",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.91797 11.3477L3.92578 12.1094L5.91797 12.8711C6.42578 13.0664 6.71875 13.2227 6.79688 13.3398C6.875 13.457 6.91406 13.5742 6.91406 13.6914C6.91406 14.0039 6.85547 14.1797 6.73828 14.2188C6.62109 14.2578 6.50391 14.2773 6.38672 14.2773C6.26953 14.2773 6.15234 14.2578 6.03516 14.2188C5.91797 14.1406 5.78125 14.043 5.625 13.9258L3.80859 12.2852L4.21875 14.7461C4.25781 14.8633 4.27734 14.9805 4.27734 15.0977C4.27734 15.1758 4.27734 15.2344 4.27734 15.2734C4.27734 15.5078 4.21875 15.6836 4.10156 15.8008C3.98438 15.8789 3.84766 15.918 3.69141 15.918C3.57422 15.918 3.4375 15.8789 3.28125 15.8008C3.16406 15.7227 3.10547 15.5469 3.10547 15.2734C3.10547 15.1953 3.125 15.1172 3.16406 15.0391C3.16406 14.9609 3.16406 14.8633 3.16406 14.7461L3.63281 12.2852L1.81641 13.9258C1.69922 14.0039 1.5625 14.082 1.40625 14.1602C1.28906 14.2383 1.17188 14.2773 1.05469 14.2773C0.9375 14.2773 0.820312 14.2383 0.703125 14.1602C0.585938 14.082 0.527344 13.9258 0.527344 13.6914C0.527344 13.5352 0.585938 13.3984 0.703125 13.2812C0.820312 13.1641 1.09375 13.0273 1.52344 12.8711L3.51562 12.1094L1.52344 11.3477C1.25 11.2305 1.01562 11.1328 0.820312 11.0547C0.625 10.9375 0.527344 10.7617 0.527344 10.5273C0.527344 10.332 0.585938 10.1953 0.703125 10.1172C0.820312 10 0.9375 9.94141 1.05469 9.94141C1.17188 9.94141 1.28906 9.98047 1.40625 10.0586C1.5625 10.0977 1.69922 10.1758 1.81641 10.293L3.63281 11.9336L3.22266 9.47266C3.22266 9.35547 3.22266 9.25781 3.22266 9.17969C3.18359 9.10156 3.16406 9.02344 3.16406 8.94531C3.16406 8.78906 3.22266 8.65234 3.33984 8.53516C3.45703 8.37891 3.59375 8.30078 3.75 8.30078C3.98438 8.30078 4.14062 8.37891 4.21875 8.53516C4.29688 8.69141 4.33594 8.82812 4.33594 8.94531C4.33594 9.02344 4.33594 9.12109 4.33594 9.23828C4.33594 9.31641 4.31641 9.39453 4.27734 9.47266L3.80859 11.9336L5.625 10.293C5.78125 10.1367 5.91797 10.0391 6.03516 10C6.15234 9.96094 6.26953 9.94141 6.38672 9.94141C6.54297 9.94141 6.66016 10 6.73828 10.1172C6.85547 10.2344 6.91406 10.3711 6.91406 10.5273C6.91406 10.6836 6.875 10.8203 6.79688 10.9375C6.71875 11.0156 6.42578 11.1523 5.91797 11.3477Z",
                        fill: "#FF3141"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_6526_237306",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "8",
                        height: "23",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_7491_319597)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        width: "15",
                        height: "15",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.84341 2.03027C7.91245 2.03027 7.96841 2.08624 7.96841 2.15527V7.03027H12.8434C12.9124 7.03027 12.9684 7.08624 12.9684 7.15527V7.84277C12.9684 7.91181 12.9124 7.96777 12.8434 7.96777H7.96841V12.8428C7.96841 12.9118 7.91245 12.9678 7.84341 12.9678H7.15591C7.08688 12.9678 7.03091 12.9118 7.03091 12.8428V7.96777H2.15591C2.08688 7.96777 2.03091 7.91181 2.03091 7.84277V7.15527C2.03091 7.08624 2.08688 7.03027 2.15591 7.03027H7.03091V2.15527C7.03091 2.08624 7.08688 2.03027 7.15591 2.03027H7.84341Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_7491_319597",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "15",
                        height: "15",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_12167_556988)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.763672)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.2487 11.1144L9.06041 5.93521C8.9752 5.84929 8.87381 5.7811 8.76211 5.73456C8.65041 5.68802 8.53059 5.66406 8.40958 5.66406C8.28857 5.66406 8.16876 5.68802 8.05705 5.73456C7.94535 5.7811 7.84396 5.84929 7.75875 5.93521C7.58802 6.10696 7.49219 6.33929 7.49219 6.58146C7.49219 6.82363 7.58802 7.05596 7.75875 7.22771L12.2962 11.811L7.75875 16.3485C7.58802 16.5203 7.49219 16.7526 7.49219 16.9948C7.49219 17.237 7.58802 17.4693 7.75875 17.641C7.84364 17.7277 7.94489 17.7966 8.0566 17.8438C8.16832 17.891 8.2883 17.9155 8.40958 17.916C8.53086 17.9155 8.65084 17.891 8.76256 17.8438C8.87428 17.7966 8.97552 17.7277 9.06041 17.641L14.2487 12.4619C14.3418 12.376 14.4161 12.2719 14.4668 12.1559C14.5176 12.0399 14.5439 11.9147 14.5439 11.7881C14.5439 11.6615 14.5176 11.5363 14.4668 11.4204C14.4161 11.3044 14.3418 11.2002 14.2487 11.1144Z",
                        fill: "#CCCCCC"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_12167_556988",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.763672)"
                    })
                })
            })
        ]
    });
};
var EditIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_12519_122399)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.331 6.75959C18.3311 6.74962 18.3312 6.73784 18.3312 6.72603C18.3312 6.02198 18.0437 5.3851 17.5796 4.9265L17.5794 4.92628C17.1043 4.47025 16.4579 4.18945 15.7461 4.18945C15.0342 4.18945 14.3878 4.47025 13.9118 4.92718L13.9127 4.92632L7.86271 10.9763H7.66102C5.50536 11.0361 3.77393 12.7707 3.71945 14.922L3.71936 14.9272L3.66436 17.9155C3.66419 17.9224 3.66406 17.9306 3.66406 17.9388C3.66406 18.1907 3.76568 18.419 3.93025 18.5847L3.93021 18.5846C4.10011 18.7382 4.32634 18.8321 4.57457 18.8321C4.57685 18.8321 4.57913 18.8321 4.5814 18.8321H4.58106L7.56941 18.7771C9.72592 18.7226 11.4605 16.9911 11.5201 14.8411L11.5203 14.8355V14.6247L17.5794 8.57467C18.0435 8.11864 18.3312 7.48425 18.3312 6.7827C18.3312 6.77462 18.3311 6.76655 18.3311 6.75847V6.75972L18.331 6.75959ZM7.56021 16.9437L5.49771 16.9987V14.9545C5.51834 13.7554 6.49527 12.7912 7.69741 12.7912C7.6975 12.7912 7.69763 12.7912 7.69771 12.7912C7.6978 12.7912 7.69793 12.7912 7.69805 12.7912C8.78654 12.7912 9.6689 13.6736 9.6689 14.7621C9.6689 14.775 9.66877 14.7878 9.66856 14.8007V14.7987C9.63964 15.9589 8.71697 16.8944 7.56472 16.9436L7.56021 16.9437V16.9437ZM16.2869 7.27293L10.9061 12.6537C10.7577 12.4345 10.6009 12.2427 10.4286 12.0662L10.4294 12.067C10.2551 11.8922 10.0631 11.7351 9.85629 11.5988L9.84275 11.5904L15.2236 6.21874C15.3616 6.08687 15.549 6.0057 15.7553 6.0057C15.9615 6.0057 16.149 6.08687 16.2872 6.219L16.2869 6.21874C16.4175 6.35246 16.4981 6.5355 16.4981 6.73737C16.4981 6.74515 16.4979 6.75297 16.4977 6.7607V6.75959C16.4977 6.76036 16.4977 6.76122 16.4977 6.76212C16.4977 6.96145 16.4171 7.14196 16.2868 7.27293H16.2869Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_12519_122399",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var EyeVisibleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.9399 6.07994C11.2907 6.02617 11.6451 5.99943 11.9999 5.99994C15.1799 5.99994 18.1699 8.28994 19.9099 11.9999C19.6438 12.5645 19.3433 13.1122 19.0099 13.6399C18.9041 13.8038 18.8485 13.9949 18.8499 14.1899C18.8522 14.4082 18.9257 14.6197 19.0594 14.7922C19.1931 14.9647 19.3795 15.0888 19.5903 15.1455C19.8011 15.2021 20.0246 15.1883 20.2267 15.106C20.4289 15.0238 20.5986 14.8776 20.7099 14.6899C21.1759 13.9579 21.5806 13.1886 21.9199 12.3899C21.9736 12.2652 22.0013 12.1308 22.0013 11.9949C22.0013 11.8591 21.9736 11.7247 21.9199 11.5999C19.8999 6.90994 16.0999 3.99994 11.9999 3.99994C11.5306 3.99758 11.062 4.03774 10.5999 4.11994C10.4686 4.14227 10.343 4.19024 10.2302 4.26112C10.1174 4.332 10.0197 4.4244 9.94263 4.53304C9.86555 4.64169 9.81063 4.76445 9.78101 4.89432C9.75138 5.02419 9.74762 5.15862 9.76994 5.28994C9.79227 5.42126 9.84024 5.5469 9.91112 5.65968C9.982 5.77247 10.0744 5.87018 10.183 5.94726C10.2917 6.02433 10.4144 6.07925 10.5443 6.10888C10.6742 6.13851 10.8086 6.14227 10.9399 6.11994V6.07994ZM3.70994 2.28994C3.6167 2.1967 3.50601 2.12274 3.38419 2.07228C3.26237 2.02182 3.1318 1.99585 2.99994 1.99585C2.86808 1.99585 2.73751 2.02182 2.61569 2.07228C2.49387 2.12274 2.38318 2.1967 2.28994 2.28994C2.10164 2.47824 1.99585 2.73364 1.99585 2.99994C1.99585 3.26624 2.10164 3.52164 2.28994 3.70994L5.38994 6.79994C3.97551 8.16147 2.8498 9.79393 2.07994 11.5999C2.02488 11.7261 1.99646 11.8623 1.99646 11.9999C1.99646 12.1376 2.02488 12.2738 2.07994 12.3999C4.09994 17.0899 7.89994 19.9999 11.9999 19.9999C13.797 19.9875 15.5517 19.4524 17.0499 18.4599L20.2899 21.7099C20.3829 21.8037 20.4935 21.8781 20.6154 21.9288C20.7372 21.9796 20.8679 22.0057 20.9999 22.0057C21.132 22.0057 21.2627 21.9796 21.3845 21.9288C21.5064 21.8781 21.617 21.8037 21.7099 21.7099C21.8037 21.617 21.8781 21.5064 21.9288 21.3845C21.9796 21.2627 22.0057 21.132 22.0057 20.9999C22.0057 20.8679 21.9796 20.7372 21.9288 20.6154C21.8781 20.4935 21.8037 20.3829 21.7099 20.2899L3.70994 2.28994ZM10.0699 11.4799L12.5199 13.9299C12.3509 13.9784 12.1758 14.002 11.9999 13.9999C11.4695 13.9999 10.9608 13.7892 10.5857 13.4142C10.2107 13.0391 9.99994 12.5304 9.99994 11.9999C9.99789 11.8241 10.0215 11.649 10.0699 11.4799ZM11.9999 17.9999C8.81994 17.9999 5.82994 15.7099 4.09994 11.9999C4.74603 10.5737 5.66301 9.28652 6.79994 8.20994L8.56994 9.99994C8.15419 10.7587 7.99568 11.6319 8.1182 12.4884C8.24072 13.3449 8.63766 14.1386 9.24947 14.7504C9.86128 15.3622 10.655 15.7592 11.5115 15.8817C12.368 16.0042 13.2411 15.8457 13.9999 15.4299L15.5899 16.9999C14.501 17.6408 13.2634 17.9856 11.9999 17.9999Z",
            fill: fillColor
        })
    });
};
var EyeHiddenIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21.9199 11.6C19.8999 6.91 16.0999 4 11.9999 4C7.89994 4 4.09994 6.91 2.07994 11.6C2.02488 11.7262 1.99646 11.8623 1.99646 12C1.99646 12.1377 2.02488 12.2738 2.07994 12.4C4.09994 17.09 7.89994 20 11.9999 20C16.0999 20 19.8999 17.09 21.9199 12.4C21.975 12.2738 22.0034 12.1377 22.0034 12C22.0034 11.8623 21.975 11.7262 21.9199 11.6ZM11.9999 18C8.82994 18 5.82994 15.71 4.09994 12C5.82994 8.29 8.82994 6 11.9999 6C15.1699 6 18.1699 8.29 19.8999 12C18.1699 15.71 15.1699 18 11.9999 18ZM11.9999 8C11.2088 8 10.4355 8.2346 9.77766 8.67412C9.11987 9.11365 8.60718 9.73836 8.30443 10.4693C8.00168 11.2002 7.92246 12.0044 8.0768 12.7804C8.23114 13.5563 8.61211 14.269 9.17152 14.8284C9.73093 15.3878 10.4437 15.7688 11.2196 15.9231C11.9955 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8863 14.8801 15.3258 14.2223C15.7653 13.5645 15.9999 12.7911 15.9999 12C15.9999 10.9391 15.5785 9.92172 14.8284 9.17157C14.0782 8.42143 13.0608 8 11.9999 8ZM11.9999 14C11.6044 14 11.2177 13.8827 10.8888 13.6629C10.5599 13.4432 10.3036 13.1308 10.1522 12.7654C10.0008 12.3999 9.9612 11.9978 10.0384 11.6098C10.1155 11.2219 10.306 10.8655 10.5857 10.5858C10.8654 10.3061 11.2218 10.1156 11.6098 10.0384C11.9977 9.96126 12.3999 10.0009 12.7653 10.1522C13.1308 10.3036 13.4431 10.56 13.6629 10.8889C13.8826 11.2178 13.9999 11.6044 13.9999 12C13.9999 12.5304 13.7892 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 11.9999 14Z",
            fill: fillColor
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/Component/ListBrand/index.tsx
function ListBrand_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListBrand_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ListBrand_arrayLikeToArray(arr);
}
function ListBrand_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListBrand_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListBrand_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListBrand_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListBrand_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || ListBrand_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ListBrand_toConsumableArray(arr) {
    return ListBrand_arrayWithoutHoles(arr) || ListBrand_iterableToArray(arr) || ListBrand_unsupportedIterableToArray(arr) || ListBrand_nonIterableSpread();
}
function ListBrand_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListBrand_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListBrand_arrayLikeToArray(o, minLen);
}








var ListBrand = function(props) {
    var arrBrand = props.arrBrand, setArrBrand = props.setArrBrand, onUpdateData = props.onUpdateData, listBrandTitle = props.listBrandTitle;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,react.useState)(null), popoverActive = ref1[0], setPopoverActive = ref1[1];
    var reorder = function(list, startIndex, endIndex) {
        var result = Array.from(list);
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var handleOnDragEnd = function(result) {
        if (!result.destination) return;
        var newList = reorder(arrBrand, result.source.index, result.destination.index);
        setArrBrand(ListBrand_toConsumableArray(newList));
    };
    var handleMove = function(id, move) {
        var result = Array.from(arrBrand.filter(Boolean));
        var findIndex = result.findIndex(function(item) {
            return item.id === id;
        });
        var ref = _slicedToArray(result.splice(findIndex, 1), 1), removed = ref[0];
        if (move === MOVE.UP_FIRST) result.splice(0, 0, removed);
        else result.splice(result.length, 0, removed);
        setPopoverActive(null);
        setArrBrand(ListBrand_toConsumableArray(result));
    };
    var handleHide = function(id) {
        var result = Array.from(arrBrand.filter(Boolean));
        var findIndex = result.find(function(item) {
            return item.id === id;
        });
        findIndex.brand_enable = findIndex.brand_enable === 1 ? 0 : 1;
        setArrBrand(ListBrand_toConsumableArray(result));
        setPopoverActive(null);
        antd_mobile_es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: findIndex.brand_enable !== 1 ? t("ss_brand_gift_disable_deal_successfully") : t("ss_brand_gift_enable_deal_successfully")
            })
        });
    };
    var emtpy = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col text-center items-center justify-center mt-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Image */.Ee, {
                    src: "https://i.ecomobi.com/ssp/passio-page/empty_digital_product.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#333333] text-lg leading-6 pb-[2px]",
                    children: t("ss_brand_gift_empty_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[#8C8C8C] text-xs leading-4",
                    children: [
                        " ",
                        t("ss_brand_gift_list_empty_content")
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: arrBrand && (arrBrand === null || arrBrand === void 0 ? void 0 : arrBrand.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-2 px-3 py-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                onDragEnd: handleOnDragEnd,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                    droppableId: "droppable",
                    children: function(droppableProvided) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            ref: droppableProvided.innerRef,
                            className: "flex flex-col gap-2",
                            children: [
                                arrBrand.filter(Boolean).map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                        draggableId: item === null || item === void 0 ? void 0 : item.id.toString(),
                                        index: index,
                                        children: function(provided, snapshot) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", ListBrand_objectSpread({}, provided.draggableProps, provided.dragHandleProps, {
                                                ref: provided.innerRef,
                                                style: ListBrand_objectSpread({}, provided.draggableProps.style, {
                                                    opacity: snapshot.isDragging ? 0.8 : 1
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                                    item: item,
                                                    handleMove: handleMove,
                                                    popoverActive: popoverActive,
                                                    setPopoverActive: setPopoverActive,
                                                    number: index,
                                                    lastList: arrBrand.filter(Boolean).length - 1,
                                                    handleHide: handleHide,
                                                    arr: arrBrand,
                                                    setArr: setArrBrand,
                                                    onUpdateData: onUpdateData,
                                                    category: false
                                                })
                                            }));
                                        }
                                    }, item.id);
                                }),
                                droppableProvided.placeholder
                            ]
                        });
                    }
                })
            })
        }) : emtpy()
    });
};
/* harmony default export */ var Component_ListBrand = (ListBrand);

// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/Component/Item/index.tsx











function Item(param1) {
    var item1 = param1.item, handleMove = param1.handleMove, popoverActive = param1.popoverActive, setPopoverActive = param1.setPopoverActive, number = param1.number, lastList = param1.lastList, handleHide = param1.handleHide, category = param1.category, onUpdateData = param1.onUpdateData, arr = param1.arr, setArr = param1.setArr;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(category), cate = ref[0];
    var itemId = category ? item1.category_id : item1.id;
    var isEnable = category ? item1.category_enable : item1.brand_enable;
    var name = category ? item1.category_name : item1.brand_name;
    var ref1 = (0,react.useState)([]), listBrand = ref1[0], setListBrand = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenListBrand = ref2[0], setIsOpenListBrand = ref2[1];
    var ref3 = (0,react.useState)(""), listBrandTitle = ref3[0], setListBrandTitle = ref3[1];
    (0,react.useEffect)(function() {
        listBrandTitle && arr.find(function(item) {
            if (item.category_name === listBrandTitle) item.list = listBrand;
        });
        setArr(arr);
    }, [
        listBrand
    ]);
    var actions = [
        {
            key: ACTION_KEY.HIDE_DISPLAY,
            icon: !isEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeHiddenIcon, {
                className: ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeVisibleIcon, {
                className: ""
            }),
            text: isEnable ? category ? t("ss_brand_gift_display_hide_category") : t("ss_brand_gift_display_hide_brand") : category ? t("ss_brand_gift_display_show_category") : t("ss_brand_gift_display_show_brand"),
            onClick: function() {
                if (isEnable) {
                    setPopoverActive(null);
                    antd_mobile_es/* Modal.confirm */.u_.confirm({
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon, {
                                    className: "mx-auto"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-bold text-lg text-center mt-3",
                                    children: category ? t("ss_brand_gift_hide_category") : t("ss_brand_gift_hide_brand")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2 text-center",
                                    children: category ? t("ss_brand_gift_hide_category_content", {
                                        name: name
                                    }) : t("ss_brand_gift_hide_brand_content", {
                                        name: name
                                    })
                                })
                            ]
                        }),
                        confirmText: category ? t("ss_brand_gift_confirm_hide_group") : t("ss_brand_gift_confirm_hide_brand"),
                        cancelText: t("ss_brand_gift_cancel_hide"),
                        onConfirm: function() {
                            return handleHide(itemId);
                        }
                    });
                } else handleHide(itemId);
            }
        }
    ];
    if (number !== 0) {
        actions.push({
            key: ACTION_KEY.UP_FIRST,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpFirstIcon, {}),
            text: t("ss_builder_move_to_top_label")
        });
    }
    if (number !== lastList) {
        actions.push({
            key: ACTION_KEY.DOWN_LAST,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownLastIcon, {}),
            text: t("ss_builder_move_to_bottom_label")
        });
    }
    var handleClickPopoverItem = function(node) {
        switch(node.key){
            case ACTION_KEY.UP_FIRST:
                handleMove(itemId, MOVE.UP_FIRST);
                break;
            case ACTION_KEY.DOWN_LAST:
                handleMove(itemId, MOVE.DOWN_LAST);
                break;
        }
    };
    var handleClickThreeDot = function() {
        if (popoverActive === itemId) setPopoverActive(null);
        else setPopoverActive(itemId);
    };
    var showListBrand = function(id) {
        var index = arr.find(function(item) {
            return item.category_id === id;
        });
        setPopoverActive(null);
        setListBrandTitle(index.category_name);
        setListBrand(index.list);
        setIsOpenListBrand(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between bg-white p-3 items-center rounded ".concat(category ? "cursor-pointer" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center ".concat(category ? "flex-1" : "max-w-[95%]", " ").concat(isEnable ? "" : "opacity-50"),
                        onClick: function() {
                            category && showListBrand(itemId);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoveIcon, {
                                width: 22,
                                height: 23
                            }),
                            !cate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                src: item1 === null || item1 === void 0 ? void 0 : item1.image,
                                className: "rounded-lg ml-3 w-10 h-10 bg-cover aspect-square object-cover",
                                onError: function(param) {
                                    var currentTarget = param.currentTarget;
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-2 text-base font-normal text-ellipsis overflow-hidden whitespace-nowrap line-clamp-1 max-w-[80%]",
                                children: [
                                    (0,lib/* htmlDecode */.l_)(category ? item1.category_name : item1.brand_name),
                                    category ? " (".concat(item1 === null || item1 === void 0 ? void 0 : item1.list.length, ")") : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: popoverRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Popover.Menu */.J2.Menu, {
                                    mode: "dark",
                                    actions: actions,
                                    placement: "bottomRight",
                                    trigger: "click",
                                    stopPropagation: [
                                        "click"
                                    ],
                                    getContainer: function() {
                                        return popoverRef.current;
                                    },
                                    visible: popoverActive === itemId,
                                    onAction: function(node) {
                                        return handleClickPopoverItem(node);
                                    },
                                    destroyOnHide: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cursor-pointer",
                                        onClick: handleClickThreeDot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDot, {})
                                    })
                                })
                            }),
                            category ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                onClick: function() {
                                    return showListBrand(itemId);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(full_screen_popup/* default */.Z, {
                visible: isOpenListBrand,
                onMaskClick: function() {
                    return setIsOpenListBrand(false);
                },
                heightFitContent: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row text-center items-center justify-center py-3 bg-white sticky top-0",
                        ref: popoverRef,
                        style: {
                            boxShadow: "inset 0px -1px 0px #EEEEEE"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row justify-between absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Button */.zx, {
                                    className: "p-0.5",
                                    style: {
                                        border: "none"
                                    },
                                    onClick: function() {
                                        setIsOpenListBrand(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviousImageSliderIcon */._L, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-lg leading-6 flex",
                                        children: [
                                            listBrandTitle,
                                            " (",
                                            listBrand && (listBrand === null || listBrand === void 0 ? void 0 : listBrand.length),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ListBrand, {
                        onUpdateData: onUpdateData,
                        arrBrand: listBrand,
                        setArrBrand: setListBrand,
                        listBrandTitle: listBrandTitle
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/Component/List/index.tsx
function List_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function List_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function List_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return List_arrayLikeToArray(arr);
}
function List_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function List_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function List_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function List_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function List_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function List_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            List_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function List_slicedToArray(arr, i) {
    return List_arrayWithHoles(arr) || List_iterableToArrayLimit(arr, i) || List_unsupportedIterableToArray(arr, i) || List_nonIterableRest();
}
function List_toConsumableArray(arr) {
    return List_arrayWithoutHoles(arr) || List_iterableToArray(arr) || List_unsupportedIterableToArray(arr) || List_nonIterableSpread();
}
function List_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return List_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return List_arrayLikeToArray(o, minLen);
}









var BrandGiftListCate = function(props) {
    var brandGiftArr = props.brandGiftArr, setBrandGiftArr = props.setBrandGiftArr, onUpdateData = props.onUpdateData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,react.useState)(null), popoverActive = ref1[0], setPopoverActive = ref1[1];
    var reorder = function(list, startIndex, endIndex) {
        var result = Array.from(list);
        var ref = List_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var handleOnDragEnd = function(result) {
        if (!result.destination) return;
        var newList = reorder(brandGiftArr, result.source.index, result.destination.index);
        setBrandGiftArr(List_toConsumableArray(newList));
    };
    var handleMove = function(id, move) {
        var result = Array.from(brandGiftArr.filter(Boolean));
        var findIndex = result.findIndex(function(item) {
            return item.category_id === id;
        });
        var ref = List_slicedToArray(result.splice(findIndex, 1), 1), removed = ref[0];
        if (move === MOVE.UP_FIRST) result.splice(0, 0, removed);
        else result.splice(result.length, 0, removed);
        setPopoverActive(null);
        setBrandGiftArr(List_toConsumableArray(result));
    };
    var handleHide = function(id) {
        var result = Array.from(brandGiftArr.filter(Boolean));
        var findIndex = brandGiftArr.find(function(item) {
            return item.category_id === id;
        });
        findIndex.category_enable = findIndex.category_enable === 1 ? 0 : 1;
        setBrandGiftArr(List_toConsumableArray(result));
        setPopoverActive(null);
        antd_mobile_es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: findIndex.category_enable !== 1 ? t("ss_brand_gift_disable_successfully") : t("ss_brand_gift_enable_successfully")
            })
        });
    };
    var emtpy = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col text-center items-center justify-center mt-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Image */.Ee, {
                    src: "https://i.ecomobi.com/ssp/passio-page/empty_digital_product.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#333333] text-lg leading-6 pb-[2px]",
                    children: t("ss_builder_affiliate_product_list_empty_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#8C8C8C] text-xs leading-4",
                    children: t("ss_builder_affiliate_product_list_empty_content")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-3 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#EE3244] text-[17px] font-normal border-b-2 border-[#EE3244] w-fit",
                    children: t("ss_brand_gift_list_category")
                })
            }),
            brandGiftArr && (brandGiftArr === null || brandGiftArr === void 0 ? void 0 : brandGiftArr.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-2 px-3 mt-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                    onDragEnd: handleOnDragEnd,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                        droppableId: "droppable",
                        children: function(droppableProvided) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: droppableProvided.innerRef,
                                className: "flex flex-col gap-2",
                                children: [
                                    brandGiftArr.filter(Boolean).map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                            draggableId: item.category_id.toString(),
                                            index: index,
                                            children: function(provided, snapshot) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", List_objectSpread({}, provided.draggableProps, provided.dragHandleProps, {
                                                    ref: provided.innerRef,
                                                    style: List_objectSpread({}, provided.draggableProps.style, {
                                                        opacity: snapshot.isDragging ? 0.8 : 1
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                                        item: item,
                                                        handleMove: handleMove,
                                                        popoverActive: popoverActive,
                                                        setPopoverActive: setPopoverActive,
                                                        number: index,
                                                        lastList: brandGiftArr.filter(Boolean).length - 1,
                                                        handleHide: handleHide,
                                                        category: true,
                                                        onUpdateData: onUpdateData,
                                                        arr: brandGiftArr,
                                                        setArr: setBrandGiftArr
                                                    })
                                                }));
                                            }
                                        }, item.category_id);
                                    }),
                                    droppableProvided.placeholder
                                ]
                            });
                        }
                    })
                })
            }) : emtpy()
        ]
    });
};
/* harmony default export */ var List = (BrandGiftListCate);

// EXTERNAL MODULE: ./src/features/share/api/createAxios.ts
var createAxios = __webpack_require__(88549);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/brandGiftApi.tsx
function brandGiftApi_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function brandGiftApi_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                brandGiftApi_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                brandGiftApi_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var baseApiUrlGW = "https://gateway.passio.eco";
var API_URL = {
    list_category: "".concat(baseApiUrlGW, "/api/mini-store/v1/catalog/brand-gift/categories"),
    setting: "".concat(baseApiUrlGW, "/api/mini-store/v1/catalog/brand-gift/categories/setting")
};
var CaxiosGW = (0,createAxios/* CreateGatewayAxios */.Ev)();
var brandGiftApi = {
    listCategory: function listCategory(params) {
        return brandGiftApi_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return CaxiosGW.get(API_URL.list_category, {
                            params: params
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    setting: function setting(params) {
        return brandGiftApi_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return CaxiosGW.post(API_URL.setting, params);
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }
};
/* harmony default export */ var BrandGift_brandGiftApi = (brandGiftApi);

;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/index.tsx
function BrandGift_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BrandGift_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BrandGift_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BrandGift_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BrandGift_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BrandGift_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BrandGift_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BrandGift_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BrandGift_slicedToArray(arr, i) {
    return BrandGift_arrayWithHoles(arr) || BrandGift_iterableToArrayLimit(arr, i) || BrandGift_unsupportedIterableToArray(arr, i) || BrandGift_nonIterableRest();
}
function BrandGift_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BrandGift_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BrandGift_arrayLikeToArray(o, minLen);
}

















function BrandGift(props) {
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var profile = (0,es/* useSelector */.v9)(userSlice/* selectProfile */.tM);
    var t = (0,hook/* useAppTranslation */.S)().t;
    var ref = (0,react.useState)(""), inputStateTitle = ref[0], setInputStateTitle = ref[1];
    var ref1 = (0,react.useState)(""), inputStateButton = ref1[0], setInputStateButton = ref1[1];
    var ref2 = (0,react.useState)(""), inputTitle = ref2[0], setInputTitle = ref2[1];
    var ref3 = (0,react.useState)(""), inputButton = ref3[0], setInputButton = ref3[1];
    var ref4 = (0,react.useState)([]), brandGiftArr = ref4[0], setBrandGiftArr = ref4[1];
    var tabs = [
        {
            key: "cashback",
            title: t("ss_brand_gift_setting_text_cashback_brand_gift")
        },
        {
            key: "voucher",
            title: t("ss_brand_gift_setting_text_voucher_brand_gift")
        },
        {
            key: "custom",
            title: t("ss_brand_gift_setting_text_custom_brand_gift")
        }, 
    ];
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var defaultValueEditBrandGift = edittingBlockData && edittingBlockData.uid ? edittingBlockData : null;
    var brandGiftDefault = (0,react.useMemo)(function() {
        var contentAttributes = {
            key: activeKey,
            title: inputTitle.trim(),
            button: inputButton.trim(),
            country: profile.country
        };
        return {
            uid: "brand-gift-".concat((0,v4/* default */.Z)()),
            sort_order: 1,
            enable: 1,
            block_type: block_conf/* BLOCK_TYPE.BRAND_GIFT */.bF.BRAND_GIFT,
            title: "Brand Gift",
            content_attributes: BrandGift_objectSpread({}, contentAttributes, {
                cate_items: []
            }),
            style_attributes: {}
        };
    }, []);
    var ref5 = (0,react.useState)(null), activeKey = ref5[0], setActiveKey = ref5[1];
    var loadDetailBrand = function() {
        var _ref = BrandGift_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* getDetailBrandGift */.nm)(NAME_SERVICE.BRAND_GIFT);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {});
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function loadDetailBrand() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCategory = function() {
        var _ref = BrandGift_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return BrandGift_brandGiftApi.listCategory({
                            country: profile.country
                        });
                    case 3:
                        res = _ctx.sent;
                        setBrandGiftArr(res.data);
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {});
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = BrandGift_slicedToArray((0,react_query_es.useQueries)([
        {
            queryKey: "loadDetailBrand",
            queryFn: loadDetailBrand,
            cacheTime: 0,
            refetchOnWindowFocus: false
        },
        {
            queryKey: "loadCategory",
            queryFn: loadCategory,
            cacheTime: 0,
            refetchOnWindowFocus: false
        }, 
    ]), 1), ref7 = ref6[0], isFetched = ref7.isFetched, data = ref7.data;
    (0,react.useEffect)(function() {
        if (!(block === null || block === void 0 ? void 0 : block.uid)) {
            onUpdateData(brandGiftDefault);
        } else {
            var contentAttributes = {
                key: activeKey,
                title: inputTitle.trim(),
                button: inputButton.trim(),
                country: profile.country
            };
            onUpdateData(BrandGift_objectSpread({}, block, {
                title: "Brand Gift",
                content_attributes: BrandGift_objectSpread({}, contentAttributes, {
                    cate_items: brandGiftArr,
                    hasInit: true
                }),
                style_attributes: {}
            }));
        }
    }, [
        activeKey,
        inputTitle,
        inputButton,
        brandGiftArr
    ]);
    (0,react.useEffect)(function() {
        if (isFetched) {
            if (data === null || data === void 0 ? void 0 : data.template_key) {
                onChangeTabBar((0,lib/* htmlDecode */.l_)(data === null || data === void 0 ? void 0 : data.template_key));
                setInputTitle((0,lib/* htmlDecode */.l_)(data === null || data === void 0 ? void 0 : data.block_title));
                setInputButton((0,lib/* htmlDecode */.l_)(data === null || data === void 0 ? void 0 : data.button_text));
                setInputStateTitle((0,lib/* htmlDecode */.l_)(data === null || data === void 0 ? void 0 : data.block_title));
                setInputStateButton((0,lib/* htmlDecode */.l_)(data === null || data === void 0 ? void 0 : data.button_text));
            } else onChangeTabBar("cashback");
        }
    }, [
        data,
        isFetched
    ]);
    (0,react.useEffect)(function() {
        if (inputTitle.trim().length <= 0 || inputButton.trim().length <= 0) setButtonStatus(true);
        else setButtonStatus(false);
    }, [
        inputTitle,
        inputButton
    ]);
    var onChangeTabBar = function(e) {
        setActiveKey(e);
        switch(e){
            case "cashback":
                setInputTitle(t("ss_brand_gift_setting_cashback_default_title"));
                setInputButton(t("ss_brand_gift_setting_cashback_default_text_button"));
                break;
            case "voucher":
                setInputTitle(t("ss_brand_gift_setting_voucher_default_title"));
                setInputButton(t("ss_brand_gift_setting_voucher_default_text_button"));
                break;
            case "custom":
                setInputTitle(inputStateTitle);
                setInputButton(inputStateButton);
                break;
        }
    };
    var onChangeTitle = function(e) {
        if (e.length > MAX_LENGTH_INPUT_TITLE) return;
        setInputTitle(e);
        setInputStateTitle(e);
    };
    var onChangeButton = function(e) {
        if (e.length > MAX_LENGTH_INPUT_BUTTON) return;
        setInputButton(e);
        setInputStateButton(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white mt-4 py-3 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "",
                        alt: "",
                        src: BACK_GROUND_IMAGE.BRAND_GIFT
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg",
                        children: t("default_title_setup_brand_gift")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "font-normal",
                        children: t("ss_brand_gift_setting_default_content_setup")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).tabContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-left text-[15px] mb-1 text-[#666666]",
                                children: t("ss_brand_gift_setting_label_tab_bar_brand_gift")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* TabBar */.nj, {
                                activeKey: activeKey,
                                onChange: function(e) {
                                    return onChangeTabBar(e);
                                },
                                children: tabs.map(function(tab) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* TabBar.Item */.nj.Item, {
                                        title: tab.title
                                    }, tab.key);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(antd_mobile_es/* Form */.l0, {
                className: "bg-white mt-3 flex flex-col gap-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(antd_mobile_es/* Form.Item */.l0.Item, {
                        name: "title",
                        label: t("ss_brand_gift_setting_label_text_title_brand_gift"),
                        rules: [
                            {
                                required: activeKey == "custom"
                            }
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Input */.II, {
                                disabled: activeKey != "custom",
                                value: (0,lib/* htmlDecode */.l_)(inputTitle),
                                onChange: function(e) {
                                    return onChangeTitle(e);
                                },
                                maxLength: MAX_LENGTH_INPUT_TITLE,
                                placeholder: t("ss_brand_gift_setting_placeholder_text_title"),
                                clearable: true
                            }),
                            activeKey == "custom" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-right text-[13px] text-[#999999] ".concat((inputTitle === null || inputTitle === void 0 ? void 0 : inputTitle.length) > MAX_LENGTH_INPUT_TITLE && "text-"),
                                children: [
                                    inputTitle === null || inputTitle === void 0 ? void 0 : inputTitle.length,
                                    "/",
                                    MAX_LENGTH_INPUT_TITLE
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(antd_mobile_es/* Form.Item */.l0.Item, {
                        name: "text-button",
                        label: t("ss_brand_gift_setting_label_text_button"),
                        rules: [
                            {
                                required: activeKey == "custom"
                            }
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Input */.II, {
                                disabled: activeKey != "custom",
                                value: (0,lib/* htmlDecode */.l_)(inputButton),
                                onChange: function(e) {
                                    return onChangeButton(e);
                                },
                                maxLength: MAX_LENGTH_INPUT_BUTTON,
                                placeholder: t("ss_brand_gift_setting_placeholder_text_button"),
                                clearable: true
                            }),
                            activeKey == "custom" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-right text-[13px] text-[#999999]",
                                children: [
                                    inputButton === null || inputButton === void 0 ? void 0 : inputButton.length,
                                    "/",
                                    MAX_LENGTH_INPUT_BUTTON
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                block: block,
                onUpdateData: onUpdateData,
                brandGiftArr: brandGiftArr,
                setBrandGiftArr: setBrandGiftArr
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/share/configs/rxjs.ts + 20 modules
var rxjs = __webpack_require__(18109);
;// CONCATENATED MODULE: ./src/features/mini-store/design/BlockBrandGift/index.tsx
function BlockBrandGift_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BlockBrandGift_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BlockBrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockBrandGift_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockBrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockBrandGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BlockBrandGift_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BlockBrandGift_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BlockBrandGift_slicedToArray(arr, i) {
    return BlockBrandGift_arrayWithHoles(arr) || BlockBrandGift_iterableToArrayLimit(arr, i) || BlockBrandGift_unsupportedIterableToArray(arr, i) || BlockBrandGift_nonIterableRest();
}
function BlockBrandGift_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BlockBrandGift_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BlockBrandGift_arrayLikeToArray(o, minLen);
}
















function BlockBrandGift(props) {
    var ref, ref1, ref2, ref3;
    var profile = (0,es/* useSelector */.v9)(userSlice/* selectProfile */.tM);
    var t = (0,hook/* useAppTranslation */.S)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var enable = blockData && blockData.enable;
    var ref5 = (0,react.useState)(true), loadApi = ref5[0], setLoadApi = ref5[1];
    var allowStore = window["AllowStore"];
    var loadDetailBrand = function() {
        var _ref = BlockBrandGift_asyncToGenerator(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,api/* getDetailBrandGift */.nm)(NAME_SERVICE.BRAND_GIFT);
                    case 3:
                        response = _ctx.sent;
                        if (!response) {
                            _ctx.next = 7;
                            break;
                        }
                        setLoadApi(false);
                        return _ctx.abrupt("return", response);
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {});
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function loadDetailBrand() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = BlockBrandGift_slicedToArray((0,react_query_es.useQueries)([
        {
            queryKey: [
                "loadDetailBrand",
                loadApi
            ],
            queryFn: loadDetailBrand,
            refetchOnWindowFocus: loadApi
        }, 
    ]), 1), data1 = ref6[0];
    (0,react.useEffect)(function() {
        var subscription = rxjs/* dataService.getObservable */.c.getObservable().subscribe(function(data) {
            if (data.loading) {
                setLoadApi(true);
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, []);
    var handlerClick = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        dispatch((0,edittingBlockSlice/* openPopup */.Mw)({
            block: blockData,
            position_uid: positionSlug,
            tab_uid: tabUid,
            KEY: configs_const/* KEY_BLOCK.EDIT */.ne.EDIT
        }));
    };
    if (data1 === null || data1 === void 0 ? void 0 : data1.isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Loading */.gb, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    width: 512,
                    src: BACK_GROUND_IMAGE.BRAND_GIFT,
                    className: !(allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_gift) && "opacity-50",
                    alt: ""
                }),
                (allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_gift) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: (0,lib/* htmlDecode */.l_)(data1 === null || data1 === void 0 ? void 0 : (ref2 = data1.data) === null || ref2 === void 0 ? void 0 : ref2.block_title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_mobile_es/* Button */.zx, {
                            className: "adm-button adm-button-default adm-button-shape-default w-full button-border-radius button-background-color button-border-width button-border-color button-border-style button-text-color button-box-shadow",
                            children: (0,lib/* htmlDecode */.l_)(data1 === null || data1 === void 0 ? void 0 : (ref3 = data1.data) === null || ref3 === void 0 ? void 0 : ref3.button_text)
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/middleware/BrandGiftMiddleWare/index.tsx
function BrandGiftMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BrandGiftMiddleWare_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BrandGiftMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BrandGiftMiddleWare_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BrandGiftMiddleWare_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BrandGiftMiddleWare_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BrandGiftMiddleWare_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var BrandGiftMiddleWare = function() {
    var _ref = BrandGiftMiddleWare_asyncToGenerator(runtime_default().mark(function _callee(data, extraData) {
        var content, newData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!data) {
                        _ctx.next = 16;
                        break;
                    }
                    content = data.content_attributes && data.content_attributes;
                    if (!(content.cate_items && content.cate_items.length)) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return BrandGift_brandGiftApi.setting({
                        setting: content.cate_items
                    });
                case 5:
                    _ctx.prev = 5;
                    _ctx.next = 8;
                    return (0,api/* postSaveBrandGift */.a7)({
                        block_title: content.title,
                        button_text: content.button,
                        template_key: content.key,
                        service: NAME_SERVICE.BRAND_GIFT,
                        cate_items: content.cate_items
                    });
                case 8:
                    rxjs/* dataService.publish */.c.publish({
                        loading: true
                    });
                    newData = BrandGiftMiddleWare_objectSpread({}, data, {
                        content_attributes: {
                            block_title: content.title,
                            button_text: content.button,
                            template_key: content.key,
                            service: NAME_SERVICE.BRAND_GIFT,
                            cate_items: content.cate_items
                        }
                    });
                    return _ctx.abrupt("return", newData);
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](5);
                    return _ctx.abrupt("return", data);
                case 16:
                    return _ctx.abrupt("return", data);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                5,
                13
            ]
        ]);
    }));
    return function BrandGiftMiddleWare(data, extraData) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandRating/index.tsx
function BrandRating_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BrandRating_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BrandRating_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BrandRating_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










function BrandRating(props) {
    var onUpdateData = props.onUpdateData, block = props.block, setButtonStatus = props.setButtonStatus, setEditStatus = props.setEditStatus;
    var profile = (0,es/* useSelector */.v9)(userSlice/* selectProfile */.tM);
    var t = (0,hook/* useAppTranslation */.S)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var titleBlockDefault = "Brand Rating";
    var KEY = edittingBlock && edittingBlock.KEY;
    (0,react.useEffect)(function() {
        var getParams = function() {
            var _ref = BrandRating_asyncToGenerator(runtime_default().mark(function _callee() {
                var UID, defaultDonateData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!block.uid) {
                                UID = "brand-rating-".concat((0,v4/* default */.Z)());
                                defaultDonateData = {
                                    uid: UID,
                                    sort_order: 1,
                                    enable: 1,
                                    block_type: block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING,
                                    title: titleBlockDefault,
                                    content_attributes: {},
                                    style_attributes: {}
                                };
                                onUpdateData(defaultDonateData);
                                setButtonStatus(false);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getParams() {
                return _ref.apply(this, arguments);
            };
        }();
        getParams();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white mt-4 px-4 py-3 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "rounded-xl",
                    src: BACK_GROUND_IMAGE.BRAND_RATING,
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-xs text-[#8C8C8C] mt-2",
                    children: t("ss_brand_rating_setting_default_content_setup_donation")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/design/BlockBrandRating/index.tsx





function BlockBrandRating(props) {
    var ref, ref1;
    var t = (0,hook/* useAppTranslation */.S)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var allowStore = window["AllowStore"];
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block-heading-class ".concat(!(allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_rating) && "opacity-60"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "design-class h3",
                    children: t("ss_builder_title_block_brand_rating")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    width: 48,
                    height: 48,
                    src: "https://i.ecomobi.com/ssp/mini-store/brand-deal/brandRatingDetails.png",
                    className: "mx-auto mt-2",
                    alt: ""
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/mini-store/mini-store.config.tsx
function mini_store_config_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var MINI_STORE_BLOCK_TYPE = {
    DONATION: "donation",
    TRUTH_OR_DARE: "tod",
    TRUTH_OR_DARE_FOOTER: "tod_footer",
    GIFT_FOOTER: "gift_footer",
    BRAND_GIFT: "brand_gift",
    BRAND_GIFT_FOOTER: "brand_gift_footer",
    BRAND_RATING: "brand_rating"
};
var _obj;
var MINI_STORE_DESIGN_COMPONENT = (_obj = {}, mini_store_config_defineProperty(_obj, MINI_STORE_BLOCK_TYPE.DONATION, DonationDesign), // [MINI_STORE_BLOCK_TYPE.TRUTH_OR_DARE]: BlockTruthOrDare,
mini_store_config_defineProperty(_obj, MINI_STORE_BLOCK_TYPE.GIFT_FOOTER, BlockVirtualGiftFooter), // [MINI_STORE_BLOCK_TYPE.TRUTH_OR_DARE_FOOTER]: BlockTruthOrDareFooter,
mini_store_config_defineProperty(_obj, MINI_STORE_BLOCK_TYPE.BRAND_GIFT, BlockBrandGift), mini_store_config_defineProperty(_obj, MINI_STORE_BLOCK_TYPE.BRAND_GIFT_FOOTER, BlockBrandGiftFooter), mini_store_config_defineProperty(_obj, MINI_STORE_BLOCK_TYPE.BRAND_RATING, BlockBrandRating), _obj);
var _obj1;
var MINI_STORE_BLOCK = (_obj1 = {}, mini_store_config_defineProperty(_obj1, MINI_STORE_BLOCK_TYPE.DONATION, Donation), // [MINI_STORE_BLOCK_TYPE.TRUTH_OR_DARE]: TruthOrDare,
// [MINI_STORE_BLOCK_TYPE.TRUTH_OR_DARE_FOOTER]: TruthOrDareFooter,
mini_store_config_defineProperty(_obj1, MINI_STORE_BLOCK_TYPE.GIFT_FOOTER, block_GiftFooter), mini_store_config_defineProperty(_obj1, MINI_STORE_BLOCK_TYPE.BRAND_GIFT, BrandGift), mini_store_config_defineProperty(_obj1, MINI_STORE_BLOCK_TYPE.BRAND_GIFT_FOOTER, TruthOrDareFooter), mini_store_config_defineProperty(_obj1, MINI_STORE_BLOCK_TYPE.BRAND_RATING, BrandRating), _obj1);
var _obj2;
var MINI_STORE_MIDDLEWARE = (_obj2 = {}, mini_store_config_defineProperty(_obj2, MINI_STORE_BLOCK_TYPE.DONATION, DonationMiddleWare), // [MINI_STORE_BLOCK_TYPE.TRUTH_OR_DARE]: TODMiddleWare,
mini_store_config_defineProperty(_obj2, MINI_STORE_BLOCK_TYPE.BRAND_GIFT, BrandGiftMiddleWare), _obj2);


/***/ }),

/***/ 25109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ getDetailDonation; },
/* harmony export */   "a7": function() { return /* binding */ postSaveBrandGift; },
/* harmony export */   "nm": function() { return /* binding */ getDetailBrandGift; },
/* harmony export */   "uL": function() { return /* binding */ fetchStoreToken; },
/* harmony export */   "yK": function() { return /* binding */ fetchAllowStore; }
/* harmony export */ });
/* unused harmony export getDetailTOD */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _share_api_createAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88549);
/* provided dependency */ var process = __webpack_require__(83454);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var baseUrl = process.env.NEXT_PUBLIC_BUILDER_API_PS1SIO_URL;
var STORE_PATH = {
    GET_DETAIL_TOD: "/api/mini-store/v1/catalog/gateway/product/trust-or-dare/detail",
    GET_DETAIL_DONATION: "/api/mini-store/v1/catalog/gateway/donation/detail",
    GET_STORE: "/api/mini-store/v1/store/creator",
    POST_SAVE_BRAND: "/api/mini-store/v1/creator/creator-setup-service/save",
    GET_DETAIL_BRAND: "api/mini-store/v1/creator/creator-setup-service/detail",
    GET_ALLOW_STORE: "/api/mini-store/v1/public/store/allow-store"
};
var instanceAxios = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: baseUrl
});
var gatewayAxious = (0,_share_api_createAxios__WEBPACK_IMPORTED_MODULE_2__/* .CreateGatewayAxios */ .Ev)();
var getDetailTOD = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(STORE_PATH.GET_DETAIL_TOD);
                case 2:
                    response = _ctx.sent;
                    if (!response.data.success) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response.data.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDetailTOD() {
        return _ref.apply(this, arguments);
    };
}();
var getDetailDonation = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(STORE_PATH.GET_DETAIL_DONATION);
                case 2:
                    response = _ctx.sent;
                    if (!response.data.success) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response.data.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDetailDonation() {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoreToken = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(STORE_PATH.GET_STORE);
                case 2:
                    response = _ctx.sent;
                    if (!response.data.success) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response.data.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchStoreToken() {
        return _ref.apply(this, arguments);
    };
}();
var postSaveBrandGift = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post(STORE_PATH.POST_SAVE_BRAND, data);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postSaveBrandGift(data) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailBrandGift = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(service) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(STORE_PATH.GET_DETAIL_BRAND, {
                        params: {
                            service: service
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    if (!response.data.success) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", response.data.data);
                case 7:
                    return _ctx.abrupt("return", {});
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDetailBrandGift(service) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAllowStore = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cps_user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(STORE_PATH.GET_ALLOW_STORE, {
                        params: {
                            cps_user_id: cps_user_id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    if (!response.data.success) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response.data.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchAllowStore(cps_user_id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useAppTranslation; }
/* harmony export */ });
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31567);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var useAppTranslation = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    var translation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(keyword, replace) {
        var result = t(keyword);
        if (!replace) return result;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(replace)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _slicedToArray(_step.value, 2), key = _value[0], value = _value[1];
                result = result.replace(":" + key, value).replace("{" + key + "}", value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        t
    ]);
    return {
        t: translation
    };
};


/***/ }),

/***/ 76143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AZ": function() { return /* binding */ BackgroundIcon; },
/* harmony export */   "D1": function() { return /* binding */ BackArrow; },
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "Fv": function() { return /* binding */ TIcon; },
/* harmony export */   "H": function() { return /* binding */ NoShadowCustomIcon; },
/* harmony export */   "J7": function() { return /* binding */ AwardIconV2; },
/* harmony export */   "KE": function() { return /* binding */ HardShadowCustomIcon; },
/* harmony export */   "M3": function() { return /* binding */ AwardIcon; },
/* harmony export */   "N9": function() { return /* binding */ HeaderIcon; },
/* harmony export */   "NX": function() { return /* binding */ ButtonIconV2; },
/* harmony export */   "O$": function() { return /* binding */ HardShadowRoundedIcon; },
/* harmony export */   "T8": function() { return /* binding */ SoftShadowCustomIcon; },
/* harmony export */   "TV": function() { return /* binding */ SoftShadowSquareIcon; },
/* harmony export */   "UB": function() { return /* binding */ DotRoundedIcon; },
/* harmony export */   "VL": function() { return /* binding */ TextIcon; },
/* harmony export */   "_N": function() { return /* binding */ HeaderIconV2; },
/* harmony export */   "ak": function() { return /* binding */ NoShadowRoundedIcon; },
/* harmony export */   "dy": function() { return /* binding */ GeneralIcon; },
/* harmony export */   "k9": function() { return /* binding */ IconGeneral; },
/* harmony export */   "lp": function() { return /* binding */ ParagraphIcon; },
/* harmony export */   "m6": function() { return /* binding */ SiteIconV2; },
/* harmony export */   "mB": function() { return /* binding */ NoShadowSquareIcon; },
/* harmony export */   "oA": function() { return /* binding */ DashRoundedIcon; },
/* harmony export */   "qG": function() { return /* binding */ StyleIcon; },
/* harmony export */   "qK": function() { return /* binding */ SoftShadowRoundedIcon; },
/* harmony export */   "sz": function() { return /* binding */ IconDocument; },
/* harmony export */   "wD": function() { return /* binding */ BlockIcon; },
/* harmony export */   "y1": function() { return /* binding */ HardShadowSquareIcon; }
/* harmony export */ });
/* unused harmony exports LinkIcon, SquareIcon, RoundedIcon, CustomIcon, SiteIcon, DotSquareIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var GeneralIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? "40" : _width, _height = param.height, height = _height === void 0 ? "40" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.875",
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28.8749 16.18V11C28.8749 10.7348 28.7696 10.4804 28.582 10.2929C28.3945 10.1054 28.1401 10 27.8749 10C27.6097 10 27.3553 10.1054 27.1678 10.2929C26.9803 10.4804 26.8749 10.7348 26.8749 11V16.18C26.2958 16.3902 25.7954 16.7736 25.4418 17.2782C25.0881 17.7827 24.8984 18.3839 24.8984 19C24.8984 19.6161 25.0881 20.2173 25.4418 20.7218C25.7954 21.2264 26.2958 21.6098 26.8749 21.82V29C26.8749 29.2652 26.9803 29.5196 27.1678 29.7071C27.3553 29.8946 27.6097 30 27.8749 30C28.1401 30 28.3945 29.8946 28.582 29.7071C28.7696 29.5196 28.8749 29.2652 28.8749 29V21.82C29.4541 21.6098 29.9545 21.2264 30.3081 20.7218C30.6617 20.2173 30.8514 19.6161 30.8514 19C30.8514 18.3839 30.6617 17.7827 30.3081 17.2782C29.9545 16.7736 29.4541 16.3902 28.8749 16.18ZM27.8749 20C27.6771 20 27.4838 19.9414 27.3193 19.8315C27.1549 19.7216 27.0267 19.5654 26.951 19.3827C26.8753 19.2 26.8555 18.9989 26.8941 18.8049C26.9327 18.6109 27.028 18.4327 27.1678 18.2929C27.3077 18.153 27.4858 18.0578 27.6798 18.0192C27.8738 17.9806 28.0749 18.0004 28.2576 18.0761C28.4403 18.1518 28.5965 18.28 28.7064 18.4444C28.8163 18.6089 28.8749 18.8022 28.8749 19C28.8749 19.2652 28.7696 19.5196 28.582 19.7071C28.3945 19.8946 28.1401 20 27.8749 20ZM21.8749 22.18V11C21.8749 10.7348 21.7696 10.4804 21.582 10.2929C21.3945 10.1054 21.1401 10 20.8749 10C20.6097 10 20.3553 10.1054 20.1678 10.2929C19.9803 10.4804 19.8749 10.7348 19.8749 11V22.18C19.2958 22.3902 18.7954 22.7736 18.4418 23.2782C18.0881 23.7827 17.8984 24.3839 17.8984 25C17.8984 25.6161 18.0881 26.2173 18.4418 26.7218C18.7954 27.2264 19.2958 27.6098 19.8749 27.82V29C19.8749 29.2652 19.9803 29.5196 20.1678 29.7071C20.3553 29.8946 20.6097 30 20.8749 30C21.1401 30 21.3945 29.8946 21.582 29.7071C21.7696 29.5196 21.8749 29.2652 21.8749 29V27.82C22.4541 27.6098 22.9545 27.2264 23.3081 26.7218C23.6617 26.2173 23.8514 25.6161 23.8514 25C23.8514 24.3839 23.6617 23.7827 23.3081 23.2782C22.9545 22.7736 22.4541 22.3902 21.8749 22.18ZM20.8749 26C20.6771 26 20.4838 25.9414 20.3193 25.8315C20.1549 25.7216 20.0267 25.5654 19.951 25.3827C19.8753 25.2 19.8555 24.9989 19.8941 24.8049C19.9327 24.6109 20.028 24.4327 20.1678 24.2929C20.3077 24.153 20.4858 24.0578 20.6798 24.0192C20.8738 23.9806 21.0749 24.0004 21.2576 24.0761C21.4403 24.1518 21.5965 24.28 21.7064 24.4444C21.8163 24.6089 21.8749 24.8022 21.8749 25C21.8749 25.2652 21.7696 25.5196 21.582 25.7071C21.3945 25.8946 21.1401 26 20.8749 26ZM14.8749 14.18V11C14.8749 10.7348 14.7696 10.4804 14.582 10.2929C14.3945 10.1054 14.1401 10 13.8749 10C13.6097 10 13.3553 10.1054 13.1678 10.2929C12.9803 10.4804 12.8749 10.7348 12.8749 11V14.18C12.2958 14.3902 11.7954 14.7736 11.4418 15.2782C11.0881 15.7827 10.8984 16.3839 10.8984 17C10.8984 17.6161 11.0881 18.2173 11.4418 18.7218C11.7954 19.2264 12.2958 19.6098 12.8749 19.82V29C12.8749 29.2652 12.9803 29.5196 13.1678 29.7071C13.3553 29.8946 13.6097 30 13.8749 30C14.1401 30 14.3945 29.8946 14.582 29.7071C14.7696 29.5196 14.8749 29.2652 14.8749 29V19.82C15.4541 19.6098 15.9545 19.2264 16.3081 18.7218C16.6617 18.2173 16.8514 17.6161 16.8514 17C16.8514 16.3839 16.6617 15.7827 16.3081 15.2782C15.9545 14.7736 15.4541 14.3902 14.8749 14.18ZM13.8749 18C13.6771 18 13.4838 17.9414 13.3193 17.8315C13.1549 17.7216 13.0267 17.5654 12.951 17.3827C12.8753 17.2 12.8555 16.9989 12.8941 16.8049C12.9327 16.6109 13.028 16.4327 13.1678 16.2929C13.3077 16.153 13.4858 16.0578 13.6798 16.0192C13.8738 15.9806 14.0749 16.0004 14.2576 16.0761C14.4403 16.1518 14.5965 16.28 14.7064 16.4444C14.8163 16.6089 14.8749 16.8022 14.8749 17C14.8749 17.2652 14.7696 17.5196 14.582 17.7071C14.3945 17.8946 14.1401 18 13.8749 18Z",
                fill: "#333333"
            })
        ]
    });
};
var BlockIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.625",
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29.625 10H17.625C17.3598 10 17.1054 10.1054 16.9179 10.2929C16.7304 10.4804 16.625 10.7348 16.625 11V15H14.625C14.3598 15 14.1054 15.1054 13.9179 15.2929C13.7304 15.4804 13.625 15.7348 13.625 16V20H11.625C11.3598 20 11.1054 20.1054 10.9179 20.2929C10.7304 20.4804 10.625 20.7348 10.625 21V29C10.625 29.2652 10.7304 29.5196 10.9179 29.7071C11.1054 29.8946 11.3598 30 11.625 30H19.625C19.8902 30 20.1446 29.8946 20.3321 29.7071C20.5196 29.5196 20.625 29.2652 20.625 29V27H24.625C24.8902 27 25.1446 26.8946 25.3321 26.7071C25.5196 26.5196 25.625 26.2652 25.625 26V24H29.625C29.8902 24 30.1446 23.8946 30.3321 23.7071C30.5196 23.5196 30.625 23.2652 30.625 23V11C30.625 10.7348 30.5196 10.4804 30.3321 10.2929C30.1446 10.1054 29.8902 10 29.625 10ZM18.625 28H12.625V22H18.625V28ZM23.625 25H20.625V21C20.625 20.7348 20.5196 20.4804 20.3321 20.2929C20.1446 20.1054 19.8902 20 19.625 20H15.625V17H23.625V25ZM28.625 22H25.625V16C25.625 15.7348 25.5196 15.4804 25.3321 15.2929C25.1446 15.1054 24.8902 15 24.625 15H18.625V12H28.625V22Z",
                fill: "#333333"
            })
        ]
    });
};
var BackgroundIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.4163 3.66577H4.58301C3.85366 3.66577 3.15419 3.9555 2.63846 4.47123C2.12274 4.98695 1.83301 5.68643 1.83301 6.41577V15.5824C1.83301 16.3118 2.12274 17.0113 2.63846 17.527C3.15419 18.0427 3.85366 18.3324 4.58301 18.3324H17.4163C18.1457 18.3324 18.8452 18.0427 19.3609 17.527C19.8766 17.0113 20.1663 16.3118 20.1663 15.5824V6.41577C20.1663 5.68643 19.8766 4.98695 19.3609 4.47123C18.8452 3.9555 18.1457 3.66577 17.4163 3.66577ZM4.58301 16.4991C4.33989 16.4991 4.10674 16.4025 3.93483 16.2306C3.76292 16.0587 3.66634 15.8256 3.66634 15.5824V13.3641L6.69134 10.3483C6.86269 10.1803 7.09307 10.0862 7.33301 10.0862C7.57295 10.0862 7.80332 10.1803 7.97467 10.3483L14.1255 16.4991H4.58301ZM18.333 15.5824C18.333 15.8256 18.2364 16.0587 18.0645 16.2306C17.8926 16.4025 17.6595 16.4991 17.4163 16.4991H16.7105L13.218 12.9883L14.0247 12.1816C14.196 12.0136 14.4264 11.9196 14.6663 11.9196C14.9063 11.9196 15.1367 12.0136 15.308 12.1816L18.333 15.1974V15.5824ZM18.333 12.6124L16.6097 10.8983C16.0872 10.3963 15.3908 10.116 14.6663 10.116C13.9418 10.116 13.2455 10.3963 12.723 10.8983L11.9163 11.7049L9.27634 9.06494C8.75389 8.563 8.0575 8.28268 7.33301 8.28268C6.60851 8.28268 5.91212 8.563 5.38967 9.06494L3.66634 10.7791V6.41577C3.66634 6.17266 3.76292 5.9395 3.93483 5.76759C4.10674 5.59568 4.33989 5.4991 4.58301 5.4991H17.4163C17.6595 5.4991 17.8926 5.59568 18.0645 5.76759C18.2364 5.9395 18.333 6.17266 18.333 6.41577V12.6124Z",
                fill: "#333333"
            })
        ]
    });
};
var HeaderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.375 6C15.2437 5.99997 15.1136 6.02581 14.9923 6.07605C14.8709 6.12629 14.7607 6.19995 14.6678 6.29282C14.575 6.38568 14.5013 6.49593 14.4511 6.61728C14.4008 6.73862 14.375 6.86867 14.375 7V11H10.375V7C10.375 6.73478 10.2696 6.48043 10.0821 6.29289C9.89457 6.10536 9.64022 6 9.375 6C9.10978 6 8.85543 6.10536 8.66789 6.29289C8.48036 6.48043 8.375 6.73478 8.375 7V17C8.375 17.2652 8.48036 17.5196 8.66789 17.7071C8.85543 17.8946 9.10978 18 9.375 18C9.64022 18 9.89457 17.8946 10.0821 17.7071C10.2696 17.5196 10.375 17.2652 10.375 17V13H14.375V17C14.375 17.2652 14.4804 17.5196 14.6679 17.7071C14.8554 17.8946 15.1098 18 15.375 18C15.6402 18 15.8946 17.8946 16.0821 17.7071C16.2696 17.5196 16.375 17.2652 16.375 17V7C16.375 6.86867 16.3492 6.73862 16.2989 6.61728C16.2487 6.49593 16.175 6.38568 16.0822 6.29282C15.9893 6.19995 15.8791 6.12629 15.7577 6.07605C15.6364 6.02581 15.5063 5.99997 15.375 6ZM19.375 2H5.375C4.57962 2.00087 3.81706 2.31722 3.25464 2.87964C2.69222 3.44206 2.37587 4.20462 2.375 5V19C2.37587 19.7954 2.69222 20.5579 3.25464 21.1204C3.81706 21.6828 4.57962 21.9991 5.375 22H19.375C20.1704 21.9991 20.9329 21.6828 21.4954 21.1204C22.0578 20.5579 22.3741 19.7954 22.375 19V5C22.3741 4.20462 22.0578 3.44206 21.4954 2.87964C20.9329 2.31722 20.1704 2.00087 19.375 2ZM20.375 19C20.3747 19.2651 20.2693 19.5193 20.0818 19.7068C19.8943 19.8943 19.6401 19.9997 19.375 20H5.375C5.10986 19.9997 4.85566 19.8943 4.66819 19.7068C4.48071 19.5193 4.37526 19.2651 4.375 19V5C4.37526 4.73486 4.48071 4.48066 4.66819 4.29319C4.85566 4.10571 5.10986 4.00026 5.375 4H19.375C19.6401 4.00026 19.8943 4.10571 20.0818 4.29319C20.2693 4.48066 20.3747 4.73486 20.375 5V19Z",
            fill: "#333333"
        })
    });
};
var HeaderIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.375",
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23.375 14C23.2437 14 23.1136 14.0258 22.9923 14.0761C22.8709 14.1263 22.7607 14.2 22.6678 14.2928C22.575 14.3857 22.5013 14.4959 22.4511 14.6173C22.4008 14.7386 22.375 14.8687 22.375 15V19H18.375V15C18.375 14.7348 18.2696 14.4804 18.0821 14.2929C17.8946 14.1054 17.6402 14 17.375 14C17.1098 14 16.8554 14.1054 16.6679 14.2929C16.4804 14.4804 16.375 14.7348 16.375 15V25C16.375 25.2652 16.4804 25.5196 16.6679 25.7071C16.8554 25.8946 17.1098 26 17.375 26C17.6402 26 17.8946 25.8946 18.0821 25.7071C18.2696 25.5196 18.375 25.2652 18.375 25V21H22.375V25C22.375 25.2652 22.4804 25.5196 22.6679 25.7071C22.8554 25.8946 23.1098 26 23.375 26C23.6402 26 23.8946 25.8946 24.0821 25.7071C24.2696 25.5196 24.375 25.2652 24.375 25V15C24.375 14.8687 24.3492 14.7386 24.2989 14.6173C24.2487 14.4959 24.175 14.3857 24.0822 14.2928C23.9893 14.2 23.8791 14.1263 23.7577 14.0761C23.6364 14.0258 23.5063 14 23.375 14ZM27.375 10H13.375C12.5796 10.0009 11.8171 10.3172 11.2546 10.8796C10.6922 11.4421 10.3759 12.2046 10.375 13V27C10.3759 27.7954 10.6922 28.5579 11.2546 29.1204C11.8171 29.6828 12.5796 29.9991 13.375 30H27.375C28.1704 29.9991 28.9329 29.6828 29.4954 29.1204C30.0578 28.5579 30.3741 27.7954 30.375 27V13C30.3741 12.2046 30.0578 11.4421 29.4954 10.8796C28.9329 10.3172 28.1704 10.0009 27.375 10ZM28.375 27C28.3747 27.2651 28.2693 27.5193 28.0818 27.7068C27.8943 27.8943 27.6401 27.9997 27.375 28H13.375C13.1099 27.9997 12.8557 27.8943 12.6682 27.7068C12.4807 27.5193 12.3753 27.2651 12.375 27V13C12.3753 12.7349 12.4807 12.4807 12.6682 12.2932C12.8557 12.1057 13.1099 12.0003 13.375 12H27.375C27.6401 12.0003 27.8943 12.1057 28.0818 12.2932C28.2693 12.4807 28.3747 12.7349 28.375 13V27Z",
                fill: "#333333"
            })
        ]
    });
};
var TextIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.125",
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20.125 14H17.125C16.8598 14 16.6054 14.1054 16.4179 14.2929C16.2304 14.4804 16.125 14.7348 16.125 15V25C16.125 25.2652 16.2304 25.5196 16.4179 25.7071C16.6054 25.8946 16.8598 26 17.125 26C17.3902 26 17.6446 25.8946 17.8321 25.7071C18.0196 25.5196 18.125 25.2652 18.125 25V22H20.125C21.1859 22 22.2033 21.5786 22.9534 20.8284C23.7036 20.0783 24.125 19.0609 24.125 18C24.125 16.9391 23.7036 15.9217 22.9534 15.1716C22.2033 14.4214 21.1859 14 20.125 14ZM20.125 20H18.125V16H20.125C20.6554 16 21.1641 16.2107 21.5392 16.5858C21.9143 16.9609 22.125 17.4696 22.125 18C22.125 18.5304 21.9143 19.0391 21.5392 19.4142C21.1641 19.7893 20.6554 20 20.125 20ZM27.125 10H13.125C12.3294 10 11.5663 10.3161 11.0037 10.8787C10.4411 11.4413 10.125 12.2044 10.125 13V27C10.125 27.7956 10.4411 28.5587 11.0037 29.1213C11.5663 29.6839 12.3294 30 13.125 30H27.125C27.9206 30 28.6837 29.6839 29.2463 29.1213C29.8089 28.5587 30.125 27.7956 30.125 27V13C30.125 12.2044 29.8089 11.4413 29.2463 10.8787C28.6837 10.3161 27.9206 10 27.125 10ZM28.125 27C28.125 27.2652 28.0196 27.5196 27.8321 27.7071C27.6446 27.8946 27.3902 28 27.125 28H13.125C12.8598 28 12.6054 27.8946 12.4179 27.7071C12.2304 27.5196 12.125 27.2652 12.125 27V13C12.125 12.7348 12.2304 12.4804 12.4179 12.2929C12.6054 12.1054 12.8598 12 13.125 12H27.125C27.3902 12 27.6446 12.1054 27.8321 12.2929C28.0196 12.4804 28.125 12.7348 28.125 13V27Z",
                fill: "#333333"
            })
        ]
    });
};
var LinkIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.16644 16.0867L7.54393 17.6634C7.11848 18.0888 6.54145 18.3278 5.93977 18.3278C5.33809 18.3278 4.76105 18.0888 4.3356 17.6634C3.91015 17.2379 3.67113 16.6609 3.67113 16.0592C3.67113 15.4575 3.91015 14.8805 4.3356 14.455L8.49727 10.2842C8.90575 9.87439 9.45612 9.63728 10.0345 9.62192C10.6129 9.60657 11.1751 9.81414 11.6048 10.2017L11.7148 10.2934C11.8886 10.4635 12.1229 10.5577 12.3662 10.5551C12.6094 10.5525 12.8417 10.4534 13.0119 10.2796C13.182 10.1058 13.2762 9.87147 13.2736 9.62822C13.271 9.38497 13.1719 9.15271 12.9981 8.98252C12.9464 8.91563 12.8913 8.85138 12.8331 8.79002C12.0506 8.10923 11.0386 7.7513 10.002 7.78875C8.9655 7.82619 7.98195 8.25621 7.2506 8.99169L3.03394 13.1625C2.31743 13.9424 1.92992 14.969 1.95234 16.0278C1.97475 17.0866 2.40536 18.0959 3.15423 18.8447C3.9031 19.5936 4.91233 20.0242 5.97116 20.0466C7.02999 20.069 8.05654 19.6815 8.83644 18.965L10.4223 17.4159C10.5789 17.245 10.6649 17.0213 10.6632 16.7895C10.6614 16.5578 10.572 16.3354 10.4128 16.1669C10.2537 15.9985 10.0367 15.8966 9.80541 15.8817C9.57416 15.8668 9.34586 15.94 9.16644 16.0867ZM18.9656 3.03336C18.1945 2.26703 17.1515 1.83691 16.0644 1.83691C14.9772 1.83691 13.9342 2.26703 13.1631 3.03336L11.5773 4.58253C11.4207 4.75335 11.3346 4.97713 11.3364 5.20885C11.3381 5.44057 11.4276 5.66303 11.5867 5.83147C11.7458 5.99991 11.9629 6.10182 12.1941 6.1167C12.4254 6.13159 12.6537 6.05834 12.8331 5.91169L14.4189 4.33503C14.8444 3.90957 15.4214 3.67056 16.0231 3.67056C16.6248 3.67056 17.2018 3.90957 17.6273 4.33503C18.0527 4.76048 18.2917 5.33751 18.2917 5.93919C18.2917 6.54087 18.0527 7.11791 17.6273 7.54336L13.4656 11.7142C13.0571 12.124 12.5067 12.3611 11.9283 12.3765C11.3499 12.3918 10.7877 12.1842 10.3581 11.7967L10.2481 11.705C10.0743 11.5348 9.83996 11.4407 9.59671 11.4433C9.35346 11.4458 9.1212 11.5449 8.95102 11.7188C8.78084 11.8926 8.68668 12.1269 8.68926 12.3702C8.69184 12.6134 8.79094 12.8457 8.96477 13.0159C9.03135 13.084 9.10174 13.1482 9.1756 13.2084C9.95905 13.8871 10.9706 14.2437 12.0065 14.2063C13.0424 14.1688 14.0257 13.7402 14.7581 13.0067L18.9289 8.83586C19.7002 8.06959 20.1369 7.02932 20.1437 5.94217C20.1506 4.85502 19.7271 3.80931 18.9656 3.03336Z",
                fill: "#333333"
            })
        ]
    });
};
var ButtonIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.875",
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.9749 19H16.7749C16.1749 19 15.7749 19.4 15.7749 20C15.7749 20.6 16.1749 21 16.7749 21H25.0749C25.6749 21 26.0749 20.6 26.0749 20C25.9749 19.4 25.5749 19 24.9749 19Z",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M25.775 14.8999H15.975C13.175 14.8999 10.875 17.1999 10.875 19.9999C10.875 22.7999 13.175 25.0999 15.975 25.0999H25.775C28.575 25.0999 30.875 22.7999 30.875 19.9999C30.875 17.1999 28.575 14.8999 25.775 14.8999ZM25.775 23.0999H15.975C14.275 23.0999 12.875 21.6999 12.875 19.9999C12.875 18.2999 14.275 16.8999 15.975 16.8999H25.775C27.475 16.8999 28.875 18.2999 28.875 19.9999C28.875 21.6999 27.475 23.0999 25.775 23.0999Z",
                fill: "#333333"
            })
        ]
    });
};
var ButtonIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.9749 11H8.7749C8.1749 11 7.7749 11.4 7.7749 12C7.7749 12.6 8.1749 13 8.7749 13H17.0749C17.6749 13 18.0749 12.6 18.0749 12C17.9749 11.4 17.5749 11 16.9749 11Z",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.775 6.8999H7.975C5.175 6.8999 2.875 9.1999 2.875 11.9999C2.875 14.7999 5.175 17.0999 7.975 17.0999H17.775C20.575 17.0999 22.875 14.7999 22.875 11.9999C22.875 9.1999 20.575 6.8999 17.775 6.8999ZM17.775 15.0999H7.975C6.275 15.0999 4.875 13.6999 4.875 11.9999C4.875 10.2999 6.275 8.8999 7.975 8.8999H17.775C19.475 8.8999 20.875 10.2999 20.875 11.9999C20.875 13.6999 19.475 15.0999 17.775 15.0999Z",
                fill: "#333333"
            })
        ]
    });
};
var StyleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3359 6.26203C18.336 6.25206 18.3361 6.24028 18.3361 6.22847C18.3361 5.52443 18.0486 4.88754 17.5845 4.42894L17.5842 4.42872C17.1091 3.9727 16.4628 3.69189 15.7509 3.69189C15.0391 3.69189 14.3927 3.9727 13.9167 4.42962L13.9176 4.42877L7.86759 10.4788H7.6659C5.51024 10.5385 3.77882 12.2731 3.72433 14.4245L3.72425 14.4296L3.66925 17.4179C3.66907 17.4249 3.66895 17.4331 3.66895 17.4412C3.66895 17.6932 3.77057 17.9214 3.93514 18.0871L3.93509 18.0871C4.10499 18.2406 4.33122 18.3346 4.57945 18.3346C4.58173 18.3346 4.58401 18.3346 4.58629 18.3346H4.58594L7.57429 18.2796C9.73081 18.225 11.4654 16.4936 11.525 14.3435L11.5251 14.3379V14.1271L17.5843 8.07711C18.0484 7.62109 18.3361 6.98669 18.3361 6.28514C18.3361 6.27707 18.336 6.26899 18.336 6.26091V6.26216L18.3359 6.26203ZM7.56509 16.4462L5.50259 16.5012V14.457C5.52322 13.2579 6.50016 12.2937 7.70229 12.2937C7.70238 12.2937 7.70251 12.2937 7.70259 12.2937C7.70268 12.2937 7.70281 12.2937 7.70294 12.2937C8.79142 12.2937 9.67379 13.176 9.67379 14.2645C9.67379 14.2774 9.67366 14.2903 9.67344 14.3031V14.3012C9.64452 15.4613 8.72186 16.3968 7.56961 16.446L7.56509 16.4461V16.4462ZM16.2918 6.77538L10.911 12.1562C10.7626 11.9369 10.6058 11.7452 10.4335 11.5687L10.4343 11.5695C10.26 11.3946 10.068 11.2376 9.86117 11.1012L9.84764 11.0928L15.2285 5.72118C15.3665 5.58931 15.5538 5.50814 15.7601 5.50814C15.9664 5.50814 16.1539 5.58931 16.2921 5.72144L16.2918 5.72118C16.4224 5.8549 16.5029 6.03795 16.5029 6.23981C16.5029 6.24759 16.5028 6.25541 16.5026 6.26314V6.26203C16.5026 6.2628 16.5026 6.26366 16.5026 6.26456C16.5026 6.46389 16.422 6.64441 16.2917 6.77538H16.2918Z",
                fill: "#333333"
            })
        ]
    });
};
var TIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.5863 5.50098H6.4196C6.17648 5.50098 5.94332 5.59755 5.77142 5.76946C5.59951 5.94137 5.50293 6.17453 5.50293 6.41764C5.50293 6.66076 5.59951 6.89392 5.77142 7.06582C5.94332 7.23773 6.17648 7.33431 6.4196 7.33431H10.0863V15.5843C10.0863 15.8274 10.1828 16.0606 10.3547 16.2325C10.5267 16.4044 10.7598 16.501 11.0029 16.501C11.246 16.501 11.4792 16.4044 11.6511 16.2325C11.823 16.0606 11.9196 15.8274 11.9196 15.5843V7.33431H15.5863C15.8294 7.33431 16.0625 7.23773 16.2344 7.06582C16.4064 6.89392 16.5029 6.66076 16.5029 6.41764C16.5029 6.17453 16.4064 5.94137 16.2344 5.76946C16.0625 5.59755 15.8294 5.50098 15.5863 5.50098Z",
                fill: "#333333"
            })
        ]
    });
};
var IconGeneral = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 22 : _width, _height = param.height, height = _height === void 0 ? 22 : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3363 7.49947V2.75114C18.3363 2.50802 18.2398 2.27487 18.0679 2.10296C17.896 1.93105 17.6628 1.83447 17.4197 1.83447C17.1766 1.83447 16.9434 1.93105 16.7715 2.10296C16.5996 2.27487 16.503 2.50802 16.503 2.75114V7.49947C15.9721 7.69216 15.5134 8.04363 15.1893 8.50612C14.8651 8.96862 14.6912 9.5197 14.6912 10.0845C14.6912 10.6492 14.8651 11.2003 15.1893 11.6628C15.5134 12.1253 15.9721 12.4768 16.503 12.6695V19.2511C16.503 19.4943 16.5996 19.7274 16.7715 19.8993C16.9434 20.0712 17.1766 20.1678 17.4197 20.1678C17.6628 20.1678 17.896 20.0712 18.0679 19.8993C18.2398 19.7274 18.3363 19.4943 18.3363 19.2511V12.6695C18.8672 12.4768 19.3259 12.1253 19.6501 11.6628C19.9742 11.2003 20.1481 10.6492 20.1481 10.0845C20.1481 9.5197 19.9742 8.96862 19.6501 8.50612C19.3259 8.04363 18.8672 7.69216 18.3363 7.49947ZM17.4197 11.0011C17.2384 11.0011 17.0612 10.9474 16.9104 10.8467C16.7597 10.7459 16.6422 10.6028 16.5728 10.4353C16.5034 10.2678 16.4853 10.0835 16.5206 9.90564C16.556 9.72782 16.6433 9.56449 16.7715 9.43629C16.8997 9.30809 17.063 9.22079 17.2408 9.18542C17.4187 9.15005 17.603 9.1682 17.7705 9.23758C17.938 9.30696 18.0811 9.42445 18.1819 9.5752C18.2826 9.72594 18.3363 9.90317 18.3363 10.0845C18.3363 10.3276 18.2398 10.5607 18.0679 10.7327C17.896 10.9046 17.6628 11.0011 17.4197 11.0011ZM11.9197 12.9995V2.75114C11.9197 2.50802 11.8231 2.27487 11.6512 2.10296C11.4793 1.93105 11.2461 1.83447 11.003 1.83447C10.7599 1.83447 10.5267 1.93105 10.3548 2.10296C10.1829 2.27487 10.0863 2.50802 10.0863 2.75114V12.9995C9.55546 13.1922 9.09677 13.5436 8.77262 14.0061C8.44847 14.4686 8.27458 15.0197 8.27458 15.5845C8.27458 16.1492 8.44847 16.7003 8.77262 17.1628C9.09677 17.6253 9.55546 17.9768 10.0863 18.1695V19.2511C10.0863 19.4943 10.1829 19.7274 10.3548 19.8993C10.5267 20.0712 10.7599 20.1678 11.003 20.1678C11.2461 20.1678 11.4793 20.0712 11.6512 19.8993C11.8231 19.7274 11.9197 19.4943 11.9197 19.2511V18.1695C12.4506 17.9768 12.9093 17.6253 13.2334 17.1628C13.5576 16.7003 13.7315 16.1492 13.7315 15.5845C13.7315 15.0197 13.5576 14.4686 13.2334 14.0061C12.9093 13.5436 12.4506 13.1922 11.9197 12.9995ZM11.003 16.5011C10.8217 16.5011 10.6445 16.4474 10.4937 16.3467C10.343 16.2459 10.2255 16.1028 10.1561 15.9353C10.0867 15.7678 10.0686 15.5835 10.104 15.4056C10.1393 15.2278 10.2266 15.0645 10.3548 14.9363C10.483 14.8081 10.6464 14.7208 10.8242 14.6854C11.002 14.65 11.1863 14.6682 11.3538 14.7376C11.5213 14.807 11.6645 14.9245 11.7652 15.0752C11.8659 15.2259 11.9197 15.4032 11.9197 15.5845C11.9197 15.8276 11.8231 16.0607 11.6512 16.2327C11.4793 16.4046 11.2461 16.5011 11.003 16.5011ZM5.50301 5.66614V2.75114C5.50301 2.50802 5.40644 2.27487 5.23453 2.10296C5.06262 1.93105 4.82946 1.83447 4.58635 1.83447C4.34323 1.83447 4.11007 1.93105 3.93817 2.10296C3.76626 2.27487 3.66968 2.50802 3.66968 2.75114V5.66614C3.13879 5.85883 2.6801 6.2103 2.35595 6.67279C2.0318 7.13528 1.85791 7.68636 1.85791 8.25114C1.85791 8.81592 2.0318 9.367 2.35595 9.82949C2.6801 10.292 3.13879 10.6435 3.66968 10.8361V19.2511C3.66968 19.4943 3.76626 19.7274 3.93817 19.8993C4.11007 20.0712 4.34323 20.1678 4.58635 20.1678C4.82946 20.1678 5.06262 20.0712 5.23453 19.8993C5.40644 19.7274 5.50301 19.4943 5.50301 19.2511V10.8361C6.0339 10.6435 6.49259 10.292 6.81674 9.82949C7.14089 9.367 7.31478 8.81592 7.31478 8.25114C7.31478 7.68636 7.14089 7.13528 6.81674 6.67279C6.49259 6.2103 6.0339 5.85883 5.50301 5.66614ZM4.58635 9.16781C4.40505 9.16781 4.22782 9.11404 4.07707 9.01332C3.92633 8.91259 3.80884 8.76943 3.73946 8.60193C3.67008 8.43443 3.65192 8.25012 3.68729 8.07231C3.72266 7.89449 3.80997 7.73116 3.93817 7.60296C4.06636 7.47476 4.2297 7.38746 4.40751 7.35209C4.58533 7.31672 4.76964 7.33487 4.93714 7.40425C5.10464 7.47363 5.2478 7.59112 5.34853 7.74187C5.44925 7.89261 5.50301 8.06984 5.50301 8.25114C5.50301 8.49425 5.40644 8.72741 5.23453 8.89932C5.06262 9.07123 4.82946 9.16781 4.58635 9.16781Z",
                fill: fillColor
            })
        ]
    });
};
var ParagraphIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.0026 5.50114H8.2526C8.00949 5.50114 7.77633 5.59772 7.60442 5.76962C7.43251 5.94153 7.33594 6.17469 7.33594 6.41781V15.5845C7.33594 15.8276 7.43251 16.0607 7.60442 16.2327C7.77633 16.4046 8.00949 16.5011 8.2526 16.5011C8.49572 16.5011 8.72888 16.4046 8.90078 16.2327C9.07269 16.0607 9.16927 15.8276 9.16927 15.5845V12.8345H11.0026C11.9751 12.8345 12.9077 12.4482 13.5953 11.7605C14.283 11.0729 14.6693 10.1403 14.6693 9.16781C14.6693 8.19535 14.283 7.26271 13.5953 6.57508C12.9077 5.88745 11.9751 5.50114 11.0026 5.50114ZM11.0026 11.0011H9.16927V7.33447H11.0026C11.4888 7.33447 11.9551 7.52763 12.299 7.87144C12.6428 8.21526 12.8359 8.68158 12.8359 9.16781C12.8359 9.65404 12.6428 10.1204 12.299 10.4642C11.9551 10.808 11.4888 11.0011 11.0026 11.0011ZM17.4193 1.83447H4.58594C3.85659 1.83447 3.15712 2.1242 2.64139 2.63993C2.12567 3.15565 1.83594 3.85513 1.83594 4.58447V17.4178C1.83594 18.1472 2.12567 18.8466 2.64139 19.3623C3.15712 19.8781 3.85659 20.1678 4.58594 20.1678H17.4193C18.1486 20.1678 18.8481 19.8781 19.3638 19.3623C19.8795 18.8466 20.1693 18.1472 20.1693 17.4178V4.58447C20.1693 3.85513 19.8795 3.15565 19.3638 2.63993C18.8481 2.1242 18.1486 1.83447 17.4193 1.83447ZM18.3359 17.4178C18.3359 17.6609 18.2394 17.8941 18.0675 18.066C17.8955 18.2379 17.6624 18.3345 17.4193 18.3345H4.58594C4.34282 18.3345 4.10966 18.2379 3.93776 18.066C3.76585 17.8941 3.66927 17.6609 3.66927 17.4178V4.58447C3.66927 4.34136 3.76585 4.1082 3.93776 3.93629C4.10966 3.76438 4.34282 3.66781 4.58594 3.66781H17.4193C17.6624 3.66781 17.8955 3.76438 18.0675 3.93629C18.2394 4.1082 18.3359 4.34136 18.3359 4.58447V17.4178Z",
                fill: "#333333"
            })
        ]
    });
};
var BackArrow = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.8524 3.05536L6.7614 11.8299C6.48453 12.1056 6.46825 12.5424 6.71254 12.8371L6.7614 12.8906L15.852 21.941C15.8894 21.9783 15.9402 21.9993 15.9931 21.9993H17.5564C17.6669 21.9993 17.7564 21.9097 17.7564 21.7993C17.7564 21.7461 17.7352 21.6951 17.6976 21.6575L8.38967 12.3901L17.6879 3.34261C17.7671 3.26558 17.7688 3.13896 17.6918 3.05979C17.6541 3.0211 17.6024 2.99927 17.5484 2.99927H15.9913C15.9395 2.99927 15.8897 3.01938 15.8524 3.05536Z",
            fill: "#333333"
        })
    });
};
var SquareIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "77",
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "77",
                height: "77",
                fill: "url(#patternr0)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternr0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_166007",
                            transform: "scale(0.00438596)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_166007",
                        width: "228",
                        height: "228",
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADkCAYAAACIV4iNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF/SURBVHgB7dWxDcIAEATBNyKjG9fgnBqojBpozBmxiSFFQis0k/3nq5sBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBby75uxwAJpwEyBAkhgoSQ8+fj+bgP8BuX6+3ttpAQIkgIESSECBJCBAkhgoQQQUKIICFEkBAiSAgRJIQIEkIECSGChBBBQoggIUSQECJICBEkhAgSQgQJIYKEEEFCiCAhRJAQIkgIESSECBJCBAkhgoQQQUKIICFEkBAiSAgRJIQIEkIECSGChBBBQoggIUSQECJICBEkhAgSQgQJIYKEEEFCiCAhRJAQIkgIESSELPu6HQMkWEgIESSECBIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB/8gIBwgg/tcfD/QAAAABJRU5ErkJggg=="
                    })
                ]
            })
        ]
    });
};
var RoundedIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "77",
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "77",
                height: "77",
                fill: "url(#patternr1)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternr1",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_166017",
                            transform: "scale(0.00438596)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_166017",
                        width: "228",
                        height: "228",
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADkCAYAAACIV4iNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATYSURBVHgB7ds/bBNXHMDx985JW8ESKsSInK1DKwwLDEgEIaouFNiAhYHOhb1DYewGeyvBUkZALFVRIZUYYCGuYKATFlspVbKABLbves9R0Nlx+GujGz4fyQp+d5ftq9/duxACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfKr7ticuthbmQzR7JY74vFrFVLjXLz1wARq2Un04RinYWG4uh//Lalvbiyttc+MYgl1vfNHtZ90wjxJNBgPBeyjgvZvnsuS3t3zqvO2/DIFcn4syPRQhnAjARZU/ns7x3bqOJOTbINBWLrH+rvLwZgAmLnZg39o+bluuCXG4dbBVZuDIuxmLzptD79mDof/lFyLdtDUX5AYbFZ89D9uhxmLlzL2R3l0L25Om4szq9PBzd1r7RHlqtftloMqbwXpw+NQgReDczN2+H2cvXxoS5flK+CjI9MxbZ7NJojGkivjx2ZDAdgfeTpuYnl6+Gmes3Ro+UUXZ3rj1TZq/Wyw2c0Ri7xw+HF6dOiBE+UGroxXcnBk2NHGnmg/ZWDSbk6q1q71H1tDQZU4zAZH3686/rJmXMZ+bTretgQvZj92z1YHpmTLepwOS9PH5ksClalZfv+tPPuPrsOLNcPfji+1Ohd2BvAKaj8eBh+OyHn6pLKzHvzWf9bHZoFKbpKEaYrvTGYmRvZi61mIUiX6iu9nbvDMD0dQ8dHPreCPm+LItxR3Wxv2dXAKYv/2r4vX5RxFba1GkOnTS/PQDTN7qxU77zaKYgh/4Hh3eO8HGM+dPTuSwAtSFIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjgoQaESTUiCChRgQJNSJIqBFBQo0IEmpEkFAjKciV6kL852kApi8+ez66tJKC7FRXsn8FCR9D9ujx8EIROllRhL+GTrr/MADT17hzb+h7jEU7K2JcrC7OXr8RgOlr3F0aXsjDYtbIu1dD5Tky3dc2HpiSME0zN2+H7Mno42H/WralvbhShOJSdfnTC7+Me+AEJiC1NXv52vBaKC6mFgevPbK8f37oYFnu6AXAZKS21k3HvH8u/RgEWZbZKafkhaGLrv8uSpiw1FRqqyq1lxpM/45ri8uthbkiNpbKrZ5m9eTuoa9D9/jhUGzeFID3s3abOhpjKIrO50t/zL86r3qsjLJZRnlrNMpi29bw8tjh0DuwNwDvJm2SflLuy6y7TS1jjEV//9p0TOLoxU9aC62Z2LgyGuXg+jLM/u6dobdnV8jnt5uaMEbag0nxZff/HkzEsRukqzEeLWNsD1077hduNCmBCRgzGdfE1133364D52OIpwMwEWkDp3yrcTa94hh3PL7pF6RpmcfG2RjjyQC8uyKsFLG4lF4vjpuKVW8Mck3ahe2H7EgZ5kI5NXeUS83y6rkADCsGf/nWKSNsF3n2ZyN0r240EQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmLz/Aa1een79WpebAAAAAElFTkSuQmCC"
                    })
                ]
            })
        ]
    });
};
var CustomIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "77",
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "77",
                height: "77",
                fill: "url(#patternr2)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternr2",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_166027",
                            transform: "scale(0.00438596)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_166027",
                        width: "228",
                        height: "228",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var SiteIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21.32 9.55L19.43 8.92L20.32 7.14C20.4102 6.95369 20.4404 6.74397 20.4064 6.53978C20.3723 6.33558 20.2758 6.14699 20.13 6L18 3.87C17.8522 3.72209 17.6618 3.62421 17.4555 3.59013C17.2493 3.55605 17.0375 3.58748 16.85 3.68L15.07 4.57L14.44 2.68C14.3735 2.483 14.2472 2.31163 14.0787 2.18975C13.9102 2.06787 13.7079 2.00155 13.5 2H10.5C10.2904 1.99946 10.0858 2.06482 9.91537 2.18685C9.7449 2.30887 9.61709 2.48138 9.55 2.68L8.92 4.57L7.14 3.68C6.95369 3.58978 6.74397 3.55961 6.53978 3.59364C6.33558 3.62767 6.14699 3.72423 6 3.87L3.87 6C3.72209 6.14777 3.62421 6.33818 3.59013 6.54446C3.55605 6.75074 3.58748 6.96251 3.68 7.15L4.57 8.93L2.68 9.56C2.483 9.62654 2.31163 9.75283 2.18975 9.92131C2.06787 10.0898 2.00155 10.2921 2 10.5V13.5C1.99946 13.7096 2.06482 13.9142 2.18685 14.0846C2.30887 14.2551 2.48138 14.3829 2.68 14.45L4.57 15.08L3.68 16.86C3.58978 17.0463 3.55961 17.256 3.59364 17.4602C3.62767 17.6644 3.72423 17.853 3.87 18L6 20.13C6.14777 20.2779 6.33818 20.3758 6.54446 20.4099C6.75074 20.444 6.96251 20.4125 7.15 20.32L8.93 19.43L9.56 21.32C9.62709 21.5186 9.7549 21.6911 9.92537 21.8132C10.0958 21.9352 10.3004 22.0005 10.51 22H13.51C13.7196 22.0005 13.9242 21.9352 14.0946 21.8132C14.2651 21.6911 14.3929 21.5186 14.46 21.32L15.09 19.43L16.87 20.32C17.0551 20.4079 17.2628 20.4369 17.4649 20.4029C17.667 20.3689 17.8538 20.2737 18 20.13L20.13 18C20.2779 17.8522 20.3758 17.6618 20.4099 17.4555C20.444 17.2493 20.4125 17.0375 20.32 16.85L19.43 15.07L21.32 14.44C21.517 14.3735 21.6884 14.2472 21.8103 14.0787C21.9321 13.9102 21.9985 13.7079 22 13.5V10.5C22.0005 10.2904 21.9352 10.0858 21.8132 9.91537C21.6911 9.7449 21.5186 9.61709 21.32 9.55ZM20 12.78L18.8 13.18C18.5241 13.2695 18.2709 13.418 18.0581 13.6151C17.8452 13.8122 17.6778 14.0533 17.5675 14.3216C17.4571 14.5899 17.4064 14.879 17.419 15.1688C17.4315 15.4586 17.5069 15.7422 17.64 16L18.21 17.14L17.11 18.24L16 17.64C15.7436 17.5122 15.4627 17.4411 15.1763 17.4313C14.89 17.4215 14.6049 17.4734 14.3403 17.5834C14.0758 17.6934 13.8379 17.8589 13.6429 18.0688C13.4479 18.2787 13.3003 18.5281 13.21 18.8L12.81 20H11.22L10.82 18.8C10.7305 18.5241 10.582 18.2709 10.3849 18.0581C10.1878 17.8452 9.94671 17.6778 9.67842 17.5675C9.41014 17.4571 9.12105 17.4064 8.83123 17.419C8.5414 17.4315 8.25777 17.5069 8 17.64L6.86 18.21L5.76 17.11L6.36 16C6.4931 15.7422 6.56852 15.4586 6.58105 15.1688C6.59358 14.879 6.5429 14.5899 6.43254 14.3216C6.32218 14.0533 6.15478 13.8122 5.94195 13.6151C5.72912 13.418 5.47595 13.2695 5.2 13.18L4 12.78V11.22L5.2 10.82C5.47595 10.7305 5.72912 10.582 5.94195 10.3849C6.15478 10.1878 6.32218 9.94671 6.43254 9.67842C6.5429 9.41014 6.59358 9.12105 6.58105 8.83123C6.56852 8.5414 6.4931 8.25777 6.36 8L5.79 6.89L6.89 5.79L8 6.36C8.25777 6.4931 8.5414 6.56852 8.83123 6.58105C9.12105 6.59358 9.41014 6.5429 9.67842 6.43254C9.94671 6.32218 10.1878 6.15478 10.3849 5.94195C10.582 5.72912 10.7305 5.47595 10.82 5.2L11.22 4H12.78L13.18 5.2C13.2695 5.47595 13.418 5.72912 13.6151 5.94195C13.8122 6.15478 14.0533 6.32218 14.3216 6.43254C14.5899 6.5429 14.879 6.59358 15.1688 6.58105C15.4586 6.56852 15.7422 6.4931 16 6.36L17.14 5.79L18.24 6.89L17.64 8C17.5122 8.25645 17.4411 8.53735 17.4313 8.82369C17.4215 9.11003 17.4734 9.39513 17.5834 9.65969C17.6934 9.92424 17.8589 10.1621 18.0688 10.3571C18.2787 10.5521 18.5281 10.6997 18.8 10.79L20 11.19V12.78ZM12 8C11.2089 8 10.4355 8.2346 9.77772 8.67413C9.11993 9.11365 8.60724 9.73836 8.30448 10.4693C8.00173 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61217 14.269 9.17158 14.8284C9.73099 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17158C14.0783 8.42143 13.0609 8 12 8ZM12 14C11.6044 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3036 13.1308 10.1522 12.7654C10.0009 12.3999 9.96126 11.9978 10.0384 11.6098C10.1156 11.2219 10.3061 10.8655 10.5858 10.5858C10.8655 10.3061 11.2219 10.1156 11.6098 10.0384C11.9978 9.96126 12.3999 10.0009 12.7654 10.1522C13.1308 10.3036 13.4432 10.56 13.6629 10.8889C13.8827 11.2178 14 11.6044 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14Z",
            fill: fillColor
        })
    });
};
var AwardIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.87 17.25L18.16 12.57C18.7145 11.5515 19.0034 10.4097 19 9.25C19 7.39348 18.2625 5.61301 16.9497 4.30025C15.637 2.9875 13.8565 2.25 12 2.25C10.1435 2.25 8.363 2.9875 7.05025 4.30025C5.73749 5.61301 5 7.39348 5 9.25C4.99655 10.4097 5.28545 11.5515 5.84 12.57L3.13 17.25C3.04206 17.4023 2.99584 17.5751 2.99602 17.751C2.99619 17.9269 3.04275 18.0996 3.13099 18.2517C3.21923 18.4039 3.34603 18.53 3.4986 18.6175C3.65118 18.705 3.82412 18.7507 4 18.75H6.87L8.33 21.21C8.37921 21.2915 8.43983 21.3656 8.51 21.43C8.69537 21.6087 8.94253 21.709 9.2 21.71H9.34C9.49097 21.6893 9.63522 21.6345 9.76174 21.5495C9.88825 21.4646 9.99369 21.3519 10.07 21.22L12 17.9L13.93 21.25C14.0074 21.38 14.1134 21.4908 14.2398 21.5739C14.3663 21.6571 14.5099 21.7104 14.66 21.73H14.8C15.0609 21.7316 15.3121 21.6311 15.5 21.45C15.5673 21.3893 15.6246 21.3184 15.67 21.24L17.13 18.78H20C20.1762 18.7807 20.3495 18.7348 20.5023 18.647C20.655 18.5592 20.7819 18.4326 20.87 18.28C20.9634 18.1245 21.0128 17.9464 21.0128 17.765C21.0128 17.5836 20.9634 17.4055 20.87 17.25ZM9.19 18.78L8.3 17.29C8.21236 17.1422 8.08811 17.0194 7.93922 16.9336C7.79033 16.8478 7.62184 16.8018 7.45 16.8H5.72L7.15 14.32C8.13472 15.2689 9.37581 15.9085 10.72 16.16L9.19 18.78ZM12 14.25C11.0111 14.25 10.0444 13.9568 9.22215 13.4073C8.3999 12.8579 7.75904 12.077 7.3806 11.1634C7.00216 10.2498 6.90314 9.24445 7.09607 8.27455C7.289 7.30464 7.7652 6.41373 8.46446 5.71447C9.16373 5.0152 10.0546 4.539 11.0245 4.34607C11.9945 4.15315 12.9998 4.25216 13.9134 4.6306C14.827 5.00904 15.6079 5.6499 16.1573 6.47215C16.7068 7.29439 17 8.26109 17 9.25C17 10.5761 16.4732 11.8479 15.5355 12.7855C14.5978 13.7232 13.3261 14.25 12 14.25ZM16.55 16.8C16.3782 16.8018 16.2097 16.8478 16.0608 16.9336C15.9119 17.0194 15.7876 17.1422 15.7 17.29L14.81 18.78L13.29 16.13C14.6295 15.8734 15.866 15.2343 16.85 14.29L18.28 16.77L16.55 16.8Z",
            fill: fillColor
        })
    });
};
var NoShadowSquareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                stroke: "black",
                strokeWidth: "2"
            })
        ]
    });
};
var NoShadowRoundedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                rx: "4",
                stroke: "black",
                strokeWidth: "2"
            })
        ]
    });
};
var NoShadowCustomIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                rx: "10",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "28.3684",
                width: "75",
                height: "20",
                rx: "10",
                stroke: "black",
                strokeWidth: "2"
            })
        ]
    });
};
var SoftShadowSquareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 81 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_d_23619_905774)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "5",
                        y: "29.5",
                        width: "71",
                        height: "18",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "4",
                        y: "28.5",
                        width: "73",
                        height: "20",
                        stroke: "black",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_d_23619_905774",
                    x: "0",
                    y: "26.5",
                    width: "81",
                    height: "28",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_23619_905774"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_23619_905774",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
var SoftShadowRoundedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 81 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_d_23619_905780)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "5",
                        y: "29.5",
                        width: "71",
                        height: "18",
                        rx: "4",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "4",
                        y: "28.5",
                        width: "73",
                        height: "20",
                        rx: "5",
                        stroke: "black",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_d_23619_905780",
                    x: "0",
                    y: "26.5",
                    width: "81",
                    height: "28",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_23619_905780"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_23619_905780",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
var SoftShadowCustomIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 81 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_d_23619_905784)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "5",
                        y: "29.5",
                        width: "71",
                        height: "18",
                        rx: "9",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "4",
                        y: "28.5",
                        width: "73",
                        height: "20",
                        rx: "10",
                        stroke: "black",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_d_23619_905784",
                    x: "0",
                    y: "26.5",
                    width: "81",
                    height: "28",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_23619_905784"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_23619_905784",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
var HardShadowSquareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.4254",
                fill: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.4254",
                stroke: "black",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.4254",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.4254",
                stroke: "black",
                strokeWidth: "1.5"
            })
        ]
    });
};
var HardShadowRoundedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.5",
                rx: "3.25",
                fill: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.5",
                rx: "3.25",
                stroke: "black",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.5",
                rx: "3.25",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.5",
                rx: "3.25",
                stroke: "black",
                strokeWidth: "1.5"
            })
        ]
    });
};
var HardShadowCustomIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.5",
                rx: "9.25",
                fill: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.75",
                y: "31.2873",
                width: "73.5",
                height: "18.5",
                rx: "9.25",
                stroke: "black",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.5",
                rx: "9.25",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.75",
                y: "29.2873",
                width: "73.5",
                height: "18.5",
                rx: "9.25",
                stroke: "black",
                strokeWidth: "1.5"
            })
        ]
    });
};
var DashRoundedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 78 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.5",
                y: "27.3684",
                width: "73",
                height: "20",
                rx: "5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2.5",
                y: "27.3684",
                width: "73",
                height: "20",
                rx: "5",
                stroke: "black",
                strokeWidth: "2",
                strokeDasharray: "12 3"
            })
        ]
    });
};
var DotRoundedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 78 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "3.5",
                y: "28.5",
                width: "71",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "3.5",
                y: "28.5",
                width: "71",
                height: "20",
                rx: "4",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeDasharray: "1 4"
            })
        ]
    });
};
var DotSquareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 77 : _width, _height = param.height, height = _height === void 0 ? 77 : _height;
    return /*#__PURE__*/ _jsxs("svg", {
        width: width,
        height: height,
        viewBox: "0 0 77 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "28.5",
                width: "71",
                height: "20",
                rx: "10",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "3",
                y: "28.5",
                width: "71",
                height: "20",
                rx: "10",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeDasharray: "1 4"
            })
        ]
    });
};
var AwardIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28.8701 25.25L26.1601 20.57C26.7146 19.5515 27.0035 18.4097 27.0001 17.25C27.0001 15.3935 26.2626 13.613 24.9498 12.3003C23.6371 10.9875 21.8566 10.25 20.0001 10.25C18.1436 10.25 16.3631 10.9875 15.0503 12.3003C13.7376 13.613 13.0001 15.3935 13.0001 17.25C12.9966 18.4097 13.2855 19.5515 13.8401 20.57L11.1301 25.25C11.0421 25.4023 10.9959 25.5751 10.9961 25.751C10.9963 25.9269 11.0428 26.0996 11.1311 26.2517C11.2193 26.4039 11.3461 26.53 11.4987 26.6175C11.6513 26.705 11.8242 26.7507 12.0001 26.75H14.8701L16.3301 29.21C16.3793 29.2915 16.4399 29.3656 16.5101 29.43C16.6955 29.6087 16.9426 29.709 17.2001 29.71H17.3401C17.491 29.6893 17.6353 29.6345 17.7618 29.5495C17.8883 29.4646 17.9938 29.3519 18.0701 29.22L20.0001 25.9L21.9301 29.25C22.0075 29.38 22.1134 29.4908 22.2399 29.5739C22.3663 29.6571 22.51 29.7104 22.6601 29.73H22.8001C23.061 29.7316 23.3122 29.6311 23.5001 29.45C23.5673 29.3893 23.6247 29.3184 23.6701 29.24L25.1301 26.78H28.0001C28.1763 26.7807 28.3495 26.7348 28.5023 26.647C28.6551 26.5592 28.782 26.4326 28.8701 26.28C28.9635 26.1245 29.0129 25.9464 29.0129 25.765C29.0129 25.5836 28.9635 25.4055 28.8701 25.25ZM17.1901 26.78L16.3001 25.29C16.2124 25.1422 16.0882 25.0194 15.9393 24.9336C15.7904 24.8478 15.6219 24.8018 15.4501 24.8H13.7201L15.1501 22.32C16.1348 23.2689 17.3759 23.9085 18.7201 24.16L17.1901 26.78ZM20.0001 22.25C19.0112 22.25 18.0445 21.9568 17.2222 21.4073C16.4 20.8579 15.7591 20.077 15.3807 19.1634C15.0022 18.2498 14.9032 17.2445 15.0961 16.2745C15.2891 15.3046 15.7653 14.4137 16.4645 13.7145C17.1638 13.0152 18.0547 12.539 19.0246 12.3461C19.9945 12.1531 20.9999 12.2522 21.9135 12.6306C22.8271 13.009 23.608 13.6499 24.1574 14.4721C24.7068 15.2944 25.0001 16.2611 25.0001 17.25C25.0001 18.5761 24.4733 19.8479 23.5356 20.7855C22.5979 21.7232 21.3262 22.25 20.0001 22.25ZM24.5501 24.8C24.3782 24.8018 24.2097 24.8478 24.0609 24.9336C23.912 25.0194 23.7877 25.1422 23.7001 25.29L22.8101 26.78L21.2901 24.13C22.6296 23.8734 23.866 23.2343 24.8501 22.29L26.2801 24.77L24.5501 24.8Z",
                fill: "#333333"
            })
        ]
    });
};
var SiteIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "40",
                height: "40",
                rx: "8",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29.4102 16.6401C29.4102 16.6401 29.4102 16.6401 29.4102 16.5901C28.7056 14.6663 27.4271 13.0054 25.7477 11.832C24.0683 10.6586 22.0689 10.0293 20.0202 10.0293C17.9714 10.0293 15.9721 10.6586 14.2927 11.832C12.6133 13.0054 11.3348 14.6663 10.6302 16.5901C10.6302 16.5901 10.6302 16.5901 10.6302 16.6401C9.84332 18.811 9.84332 21.1892 10.6302 23.3601C10.6302 23.3601 10.6302 23.3601 10.6302 23.4101C11.3348 25.3339 12.6133 26.9948 14.2927 28.1683C15.9721 29.3417 17.9714 29.971 20.0202 29.971C22.0689 29.971 24.0683 29.3417 25.7477 28.1683C27.4271 26.9948 28.7056 25.3339 29.4102 23.4101C29.4102 23.4101 29.4102 23.4101 29.4102 23.3601C30.1971 21.1892 30.1971 18.811 29.4102 16.6401ZM12.2602 22.0001C11.9134 20.6893 11.9134 19.3109 12.2602 18.0001H14.1202C13.9602 19.3287 13.9602 20.6716 14.1202 22.0001H12.2602ZM13.0802 24.0001H14.4802C14.7149 24.892 15.0504 25.7542 15.4802 26.5701C14.4995 25.9021 13.6797 25.0242 13.0802 24.0001ZM14.4802 16.0001H13.0802C13.6711 14.9792 14.4804 14.1016 15.4502 13.4301C15.0307 14.2474 14.7053 15.1095 14.4802 16.0001ZM19.0002 27.7001C17.772 26.7988 16.9093 25.4854 16.5702 24.0001H19.0002V27.7001ZM19.0002 22.0001H16.1402C15.9536 20.6733 15.9536 19.3269 16.1402 18.0001H19.0002V22.0001ZM19.0002 16.0001H16.5702C16.9093 14.5149 17.772 13.2014 19.0002 12.3001V16.0001ZM26.9202 16.0001H25.5202C25.2855 15.1083 24.95 14.2461 24.5202 13.4301C25.5009 14.0982 26.3207 14.9761 26.9202 16.0001ZM21.0002 12.3001C22.2284 13.2014 23.091 14.5149 23.4302 16.0001H21.0002V12.3001ZM21.0002 27.7001V24.0001H23.4302C23.091 25.4854 22.2284 26.7988 21.0002 27.7001ZM23.8602 22.0001H21.0002V18.0001H23.8602C24.0468 19.3269 24.0468 20.6733 23.8602 22.0001ZM24.5502 26.5701C24.98 25.7542 25.3155 24.892 25.5502 24.0001H26.9502C26.3507 25.0242 25.5309 25.9021 24.5502 26.5701ZM27.7402 22.0001H25.8802C25.9615 21.3366 26.0016 20.6686 26.0002 20.0001C26.0013 19.3316 25.9612 18.6637 25.8802 18.0001H27.7402C28.087 19.3109 28.087 20.6893 27.7402 22.0001Z",
                fill: "#333333"
            })
        ]
    });
};
var IconDocument = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2497 21.3529H8.74967C3.77217 21.3529 1.64551 19.2262 1.64551 14.2487V8.7487C1.64551 3.7712 3.77217 1.64453 8.74967 1.64453H14.2497C19.2272 1.64453 21.3538 3.7712 21.3538 8.7487V14.2487C21.3538 19.2262 19.2272 21.3529 14.2497 21.3529ZM8.74967 3.01953C4.52384 3.01953 3.02051 4.52286 3.02051 8.7487V14.2487C3.02051 18.4745 4.52384 19.9779 8.74967 19.9779H14.2497C18.4755 19.9779 19.9788 18.4745 19.9788 14.2487V8.7487C19.9788 4.52286 18.4755 3.01953 14.2497 3.01953H8.74967ZM14.9372 9.4362H8.06217C7.68634 9.4362 7.37467 9.12453 7.37467 8.7487C7.37467 8.37286 7.68634 8.0612 8.06217 8.0612H14.9372C15.313 8.0612 15.6247 8.37286 15.6247 8.7487C15.6247 9.12453 15.313 9.4362 14.9372 9.4362ZM8.06217 14.9362H14.9372C15.313 14.9362 15.6247 14.6245 15.6247 14.2487C15.6247 13.8729 15.313 13.5612 14.9372 13.5612H8.06217C7.68634 13.5612 7.37467 13.8729 7.37467 14.2487C7.37467 14.6245 7.68634 14.9362 8.06217 14.9362Z",
            fill: "#333333"
        })
    });
};


/***/ }),

/***/ 14562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vf": function() { return /* binding */ ShadowIcon; }
/* harmony export */ });
/* unused harmony exports SolidIcon, DotIcon, DashIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SolidIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "78",
        viewBox: "0 0 77 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                y: "0.00341797",
                width: "77",
                height: "77",
                fill: "url(#patternb0)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternb0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_220187",
                            transform: "scale(0.00438596)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_220187",
                        width: "228",
                        height: "228",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var DotIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "78",
        viewBox: "0 0 77 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                y: "0.00341797",
                width: "77",
                height: "77",
                fill: "url(#patternb1)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternb1",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_220201",
                            transform: "translate(0 0.00862069) scale(0.00431034)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_220201",
                        width: "232",
                        height: "228",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var DashIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        className: className,
        width: "77",
        height: "78",
        viewBox: "0 0 77 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                y: "0.00341797",
                width: "77",
                height: "77",
                fill: "url(#patternb2)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("pattern", {
                        id: "patternb2",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#image0_7831_220211",
                            transform: "scale(0.00438596)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("image", {
                        id: "image0_7831_220211",
                        width: "228",
                        height: "228",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var ShadowIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_7831_220237)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.00390625)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.58594 11.005C4.58594 10.7619 4.48936 10.5288 4.31745 10.3569C4.14554 10.185 3.91239 10.0884 3.66927 10.0884H2.7526C2.50949 10.0884 2.27633 10.185 2.10442 10.3569C1.93251 10.5288 1.83594 10.7619 1.83594 11.005C1.83594 11.2482 1.93251 11.4813 2.10442 11.6532C2.27633 11.8251 2.50949 11.9217 2.7526 11.9217H3.66927C3.91239 11.9217 4.14554 11.8251 4.31745 11.6532C4.48936 11.4813 4.58594 11.2482 4.58594 11.005ZM5.1726 15.5884L4.52177 16.2392C4.35104 16.411 4.25521 16.6433 4.25521 16.8855C4.25521 17.1276 4.35104 17.36 4.52177 17.5317C4.69352 17.7024 4.92585 17.7983 5.16802 17.7983C5.41019 17.7983 5.64252 17.7024 5.81427 17.5317L6.4651 16.8809C6.61528 16.7055 6.69375 16.4799 6.68484 16.2492C6.67593 16.0185 6.58029 15.7997 6.41704 15.6364C6.25378 15.4732 6.03494 15.3776 5.80424 15.3686C5.57353 15.3597 5.34796 15.4382 5.1726 15.5884ZM11.0026 4.58838C11.2457 4.58838 11.4789 4.4918 11.6508 4.31989C11.8227 4.14798 11.9193 3.91483 11.9193 3.67171V2.75505C11.9193 2.51193 11.8227 2.27877 11.6508 2.10686C11.4789 1.93496 11.2457 1.83838 11.0026 1.83838C10.7595 1.83838 10.5263 1.93496 10.3544 2.10686C10.1825 2.27877 10.0859 2.51193 10.0859 2.75505V3.67171C10.0859 3.91483 10.1825 4.14798 10.3544 4.31989C10.5263 4.4918 10.7595 4.58838 11.0026 4.58838ZM16.1909 6.73338C16.4314 6.73237 16.6619 6.63689 16.8326 6.46755L17.4834 5.81671C17.5794 5.73454 17.6573 5.63341 17.7124 5.51968C17.7674 5.40596 17.7983 5.28209 17.8032 5.15584C17.808 5.0296 17.7868 4.90371 17.7407 4.78608C17.6946 4.66845 17.6247 4.56162 17.5354 4.47228C17.446 4.38295 17.3392 4.31305 17.2216 4.26696C17.1039 4.22088 16.978 4.1996 16.8518 4.20448C16.7256 4.20936 16.6017 4.24028 16.488 4.2953C16.3742 4.35032 16.2731 4.42825 16.1909 4.52421L15.5859 5.17505C15.4152 5.34679 15.3194 5.57912 15.3194 5.8213C15.3194 6.06347 15.4152 6.2958 15.5859 6.46755C15.7475 6.62829 15.9632 6.72307 16.1909 6.73338ZM5.19094 6.46755C5.36168 6.63689 5.59213 6.73237 5.8326 6.73338C5.95324 6.73408 6.07283 6.71095 6.18452 6.66534C6.2962 6.61972 6.39778 6.5525 6.48344 6.46755C6.65417 6.2958 6.75 6.06347 6.75 5.8213C6.75 5.57912 6.65417 5.34679 6.48344 5.17505L5.8326 4.52421C5.74774 4.43814 5.64675 4.36963 5.5354 4.32259C5.42406 4.27555 5.30454 4.2509 5.18367 4.25004C5.0628 4.24919 4.94294 4.27216 4.83095 4.31763C4.71895 4.3631 4.61701 4.43018 4.53094 4.51505C4.44487 4.59991 4.37635 4.7009 4.32931 4.81225C4.28227 4.92359 4.25762 5.04311 4.25677 5.16398C4.25505 5.40809 4.35037 5.64288 4.52177 5.81671L5.19094 6.46755ZM19.2526 10.0884H18.3359C18.0928 10.0884 17.8597 10.185 17.6878 10.3569C17.5158 10.5288 17.4193 10.7619 17.4193 11.005C17.4193 11.2482 17.5158 11.4813 17.6878 11.6532C17.8597 11.8251 18.0928 11.9217 18.3359 11.9217H19.2526C19.4957 11.9217 19.7289 11.8251 19.9008 11.6532C20.0727 11.4813 20.1693 11.2482 20.1693 11.005C20.1693 10.7619 20.0727 10.5288 19.9008 10.3569C19.7289 10.185 19.4957 10.0884 19.2526 10.0884ZM16.8326 15.5884C16.6585 15.4915 16.4575 15.454 16.2601 15.4816C16.0627 15.5092 15.8798 15.6004 15.7388 15.7413C15.5979 15.8822 15.5068 16.0652 15.4792 16.2626C15.4516 16.4599 15.4891 16.6609 15.5859 16.835L16.2368 17.4859C16.4085 17.6566 16.6409 17.7524 16.883 17.7524C17.1252 17.7524 17.3575 17.6566 17.5293 17.4859C17.7 17.3141 17.7958 17.0818 17.7958 16.8396C17.7958 16.5975 17.7 16.3651 17.5293 16.1934L16.8326 15.5884ZM11.0026 5.96338C10.0055 5.96338 9.0307 6.25907 8.2016 6.81305C7.37251 7.36704 6.7263 8.15444 6.34471 9.07568C5.96312 9.99693 5.86328 11.0106 6.05781 11.9886C6.25235 12.9666 6.73252 13.865 7.43761 14.57C8.1427 15.2751 9.04104 15.7553 10.019 15.9498C10.997 16.1444 12.0107 16.0445 12.932 15.6629C13.8532 15.2813 14.6406 14.6351 15.1946 13.806C15.7486 12.9769 16.0443 12.0022 16.0443 11.005C16.0418 9.66866 15.5099 8.3877 14.5649 7.44273C13.62 6.49775 12.339 5.9658 11.0026 5.96338ZM11.0026 14.2134C10.3681 14.2134 9.74776 14.0252 9.22015 13.6727C8.69254 13.3201 8.28132 12.8191 8.03849 12.2328C7.79566 11.6466 7.73212 11.0015 7.85592 10.3791C7.97971 9.75677 8.28528 9.1851 8.73397 8.73641C9.18266 8.28772 9.75433 7.98215 10.3767 7.85836C10.999 7.73456 11.6441 7.7981 12.2304 8.04093C12.8166 8.28376 13.3177 8.69498 13.6702 9.22259C14.0228 9.7502 14.2109 10.3705 14.2109 11.005C14.2109 11.8559 13.8729 12.672 13.2712 13.2737C12.6696 13.8754 11.8535 14.2134 11.0026 14.2134ZM11.0026 17.4217C10.7595 17.4217 10.5263 17.5183 10.3544 17.6902C10.1825 17.8621 10.0859 18.0953 10.0859 18.3384V19.255C10.0859 19.4982 10.1825 19.7313 10.3544 19.9032C10.5263 20.0751 10.7595 20.1717 11.0026 20.1717C11.2457 20.1717 11.4789 20.0751 11.6508 19.9032C11.8227 19.7313 11.9193 19.4982 11.9193 19.255V18.3384C11.9193 18.0953 11.8227 17.8621 11.6508 17.6902C11.4789 17.5183 11.2457 17.4217 11.0026 17.4217Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7831_220237",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.00390625)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 76034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ColorPickerV2; },
  "Z": function() { return /* binding */ ThemeSetting_ColorPicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./src/features/share/configs/rxjs.ts + 20 modules
var rxjs = __webpack_require__(18109);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/reactcss/lib/index.js
var lib = __webpack_require__(79941);
;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/alpha.js
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/checkboard.js
var checkboardCache = {};

var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Checkboard.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0,react.isValidElement)(children) ? react.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : react.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

/* harmony default export */ var common_Checkboard = (Checkboard);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Alpha.js
var Alpha_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0,lib/* default */.ZP)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': Alpha_extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return react.createElement(
        'div',
        { style: styles.alpha },
        react.createElement(
          'div',
          { style: styles.checkboard },
          react.createElement(common_Checkboard, { renderers: this.props.renderers })
        ),
        react.createElement('div', { style: styles.gradient }),
        react.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Alpha = (Alpha);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/EditableInput.js
var EditableInput_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function EditableInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditableInput_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditableInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = function (_ref) {
  EditableInput_inherits(EditableInput, _ref);

  function EditableInput(props) {
    EditableInput_classCallCheck(this, EditableInput);

    var _this = EditableInput_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  EditableInput_createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0,lib/* default */.ZP)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return react.createElement(
        'div',
        { style: styles.wrap },
        react.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? react.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_EditableInput = (EditableInput);
;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/hue.js
var hue_calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Hue.js
var Hue_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Hue_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hue_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Hue_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Hue = function (_ref) {
  Hue_inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    Hue_classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Hue_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue_calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), Hue_possibleConstructorReturn(_this, _ret);
  }

  Hue_createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0,lib/* default */.ZP)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return react.createElement(
        'div',
        { style: styles.hue },
        react.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          react.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Hue = (Hue);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ var _freeGlobal = (freeGlobal);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["__core-js_shared__"];

/* harmony default export */ var _coreJsData = (coreJsData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

/* harmony default export */ var _Map = (Map);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var lodash_es_defineProperty = (defineProperty);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && lodash_es_defineProperty) {
    lodash_es_defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !lodash_es_eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = (baseFor);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneBuffer.js


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ var _cloneBuffer = (cloneBuffer);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return lodash_es_isObjectLike(value) && lodash_es_isArrayLike(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var lodash_es_stubFalse = (stubFalse);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var isBuffer_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var isBuffer_freeModule = isBuffer_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var isBuffer_moduleExports = isBuffer_freeModule && isBuffer_freeModule.exports === isBuffer_freeExports;

/** Built-in value references. */
var isBuffer_Buffer = isBuffer_moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = isBuffer_Buffer ? isBuffer_Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || lodash_es_stubFalse;

/* harmony default export */ var lodash_es_isBuffer = (isBuffer);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var isPlainObject_funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var isPlainObject_funcToString = isPlainObject_funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = isPlainObject_funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    isPlainObject_funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseIsTypedArray_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[_baseIsTypedArray_objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nodeUtil.js


/** Detect free variable `exports`. */
var _nodeUtil_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _nodeUtil_freeModule = _nodeUtil_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _nodeUtil_moduleExports = _nodeUtil_freeModule && _nodeUtil_freeModule.exports === _nodeUtil_freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = _nodeUtil_moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = _nodeUtil_freeModule && _nodeUtil_freeModule.require && _nodeUtil_freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ var _nodeUtil = (nodeUtil);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var _isIndex_MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? _isIndex_MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ var _isIndex = (isIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && lodash_es_isBuffer(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, lodash_es_keysIn(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = lodash_es_isArray(srcValue),
        isBuff = !isArr && lodash_es_isBuffer(srcValue),
        isTyped = !isArr && !isBuff && lodash_es_isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (lodash_es_isArray(objValue)) {
        newValue = objValue;
      }
      else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (lodash_es_isPlainObject(srcValue) || lodash_es_isArguments(srcValue)) {
      newValue = objValue;
      if (lodash_es_isArguments(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      }
      else if (!lodash_es_isObject(objValue) || lodash_es_isFunction(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (lodash_es_isObject(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, lodash_es_keysIn);
}

/* harmony default export */ var _baseMerge = (baseMerge);

;// CONCATENATED MODULE: ./node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_identity = (identity);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !lodash_es_defineProperty ? lodash_es_identity : function(func, string) {
  return lodash_es_defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, lodash_es_identity), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isIterateeCall.js





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!lodash_es_isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (lodash_es_isArrayLike(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return lodash_es_eq(object[index], value);
  }
  return false;
}

/* harmony default export */ var _isIterateeCall = (isIterateeCall);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_createAssigner.js



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ var _createAssigner = (createAssigner);

;// CONCATENATED MODULE: ./node_modules/lodash-es/merge.js



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

/* harmony default export */ var lodash_es_merge = (merge);

;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Raised.js





var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return react.createElement(
    'div',
    { style: styles.wrap },
    react.createElement('div', { style: styles.bg }),
    react.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: (prop_types_default()).string,
  zDepth: prop_types_default().oneOf([0, 1, 2, 3, 4, 5]),
  radius: (prop_types_default()).number,
  styles: (prop_types_default()).object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/* harmony default export */ var common_Raised = (Raised);
;// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

/* harmony default export */ var lodash_es_now = (now);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ var _trimmedEndIndex = (trimmedEndIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTrim.js


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ var _baseTrim = (baseTrim);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ var lodash_es_toNumber = (toNumber);

;// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var debounce_nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? debounce_nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce);

;// CONCATENATED MODULE: ./node_modules/lodash-es/throttle.js



/** Error message constants. */
var throttle_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(throttle_FUNC_ERROR_TEXT);
  }
  if (lodash_es_isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return lodash_es_debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ var lodash_es_throttle = (throttle);

;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/saturation.js
var saturation_calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Saturation.js
var Saturation_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Saturation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Saturation_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Saturation_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Saturation = function (_ref) {
  Saturation_inherits(Saturation, _ref);

  function Saturation(props) {
    Saturation_classCallCheck(this, Saturation);

    var _this = Saturation_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation_calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = lodash_es_throttle(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  Saturation_createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0,lib/* default */.ZP)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return react.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        react.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        react.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          react.createElement('div', { style: styles.black, className: 'saturation-black' }),
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Saturation = (Saturation);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForOwn.js



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwn = (baseForOwn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseEach.js


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!lodash_es_isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ var _createBaseEach = (createBaseEach);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEach.js



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

/* harmony default export */ var _baseEach = (baseEach);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_castFunction.js


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : lodash_es_identity;
}

/* harmony default export */ var _castFunction = (castFunction);

;// CONCATENATED MODULE: ./node_modules/lodash-es/forEach.js





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEach = (forEach);

// EXTERNAL MODULE: ./node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__(17621);
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);
;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/color.js



var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  lodash_es_forEach(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = function toState(data, oldHue) {
  var color = data.hex ? tinycolor_default()(data.hex) : tinycolor_default()(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor_default()(hex).isValid();
};

var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return tinycolor_default()(type + ' (' + stringWithoutDegree + ')')._ok;
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/ColorWrap.js
var ColorWrap_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ColorWrap_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColorWrap_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColorWrap_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColorWrap_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    ColorWrap_inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      ColorWrap_classCallCheck(this, ColorPicker);

      var _this = ColorWrap_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = ColorWrap_extends({}, toState(props.color, 0));

      _this.debounce = lodash_es_debounce(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    ColorWrap_createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return react.createElement(Picker, ColorWrap_extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return ColorWrap_extends({}, toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(react.PureComponent || react.Component);

  ColorPicker.propTypes = ColorWrap_extends({}, Picker.propTypes);

  ColorPicker.defaultProps = ColorWrap_extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

/* harmony default export */ var common_ColorWrap = (ColorWrap);
;// CONCATENATED MODULE: ./node_modules/react-color/es/helpers/interaction.js
var interaction_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var interaction_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function interaction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function interaction_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function interaction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-invalid-this */


var handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    interaction_inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      interaction_classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = interaction_possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), interaction_possibleConstructorReturn(_this, _ret);
    }

    interaction_createClass(Focus, [{
      key: 'render',
      value: function render() {
        return react.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          react.createElement(Component, interaction_extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(react.Component);
};
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/Swatch.js
var Swatch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var ENTER = 13;

var Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0,lib/* default */.ZP)({
    default: {
      swatch: Swatch_extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return react.createElement(
    'div',
    Swatch_extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && react.createElement(common_Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

/* harmony default export */ var common_Swatch = (handleFocus(Swatch));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/common/index.js








;// CONCATENATED MODULE: ./node_modules/react-color/es/components/alpha/AlphaPointer.js



var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var alpha_AlphaPointer = (AlphaPointer);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/alpha/Alpha.js
var alpha_Alpha_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    react.createElement(common_Alpha, alpha_Alpha_extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: alpha_AlphaPointer
};

/* harmony default export */ var alpha_Alpha = (common_ColorWrap(AlphaPicker));
;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = (SetCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ var _cacheHas = (cacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ var _setToArray = (setToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var _equalByTag_boolTag = '[object Boolean]',
    _equalByTag_dateTag = '[object Date]',
    _equalByTag_errorTag = '[object Error]',
    _equalByTag_mapTag = '[object Map]',
    _equalByTag_numberTag = '[object Number]',
    _equalByTag_regexpTag = '[object RegExp]',
    _equalByTag_setTag = '[object Set]',
    _equalByTag_stringTag = '[object String]',
    _equalByTag_symbolTag = '[object Symbol]';

var _equalByTag_arrayBufferTag = '[object ArrayBuffer]',
    _equalByTag_dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case _equalByTag_dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case _equalByTag_arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case _equalByTag_boolTag:
    case _equalByTag_dateTag:
    case _equalByTag_numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case _equalByTag_errorTag:
      return object.name == other.name && object.message == other.message;

    case _equalByTag_regexpTag:
    case _equalByTag_stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case _equalByTag_mapTag:
      var convert = _mapToArray;

    case _equalByTag_setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case _equalByTag_symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

/* harmony default export */ var _DataView = (DataView);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

/* harmony default export */ var _Promise = (Promise);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var _Set_Set = _getNative(_root, 'Set');

/* harmony default export */ var _Set = (_Set_Set);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && lodash_es_isBuffer(object)) {
    if (!lodash_es_isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = (baseIsEqual);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var _baseIsMatch_COMPARE_PARTIAL_FLAG = 1,
    _baseIsMatch_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, _baseIsMatch_COMPARE_PARTIAL_FLAG | _baseIsMatch_COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !lodash_es_isObject(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = lodash_es_keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ var _isKey = (isKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/memoize.js


/** Error message constants. */
var memoize_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(memoize_FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* harmony default export */ var _castPath = (castPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var _toKey_INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_toKey_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ var _baseGet = (baseGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/get.js


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get_get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ var lodash_es_get = (get_get);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) &&
    (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* harmony default export */ var _hasPath = (hasPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = lodash_es_get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? lodash_es_hasIn(object, path)
      : _baseIsEqual(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);

;// CONCATENATED MODULE: ./node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return lodash_es_identity;
  }
  if (typeof value == 'object') {
    return lodash_es_isArray(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = (baseIteratee);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMap.js



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ var _baseMap = (baseMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/map.js





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayMap : _baseMap;
  return func(collection, _baseIteratee(iteratee, 3));
}

/* harmony default export */ var lodash_es_map = (map);

;// CONCATENATED MODULE: ./node_modules/react-color/es/components/block/BlockSwatches.js






var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.swatches },
    lodash_es_map(colors, function (c) {
      return react.createElement(common_Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    react.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ var block_BlockSwatches = (BlockSwatches);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/block/Block.js









var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return react.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    react.createElement('div', { style: styles.triangle }),
    react.createElement(
      'div',
      { style: styles.head },
      transparent && react.createElement(common_Checkboard, { borderRadius: '6px 6px 0 0' }),
      react.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(block_BlockSwatches, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      react.createElement(common_EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  triangle: prop_types_default().oneOf(['top', 'hide']),
  styles: (prop_types_default()).object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

/* harmony default export */ var block_Block = (common_ColorWrap(Block));
;// CONCATENATED MODULE: ./node_modules/material-colors/dist/colors.es2015.js
var colors_es2015_red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ var colors_es2015 = ({
  red: colors_es2015_red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});

;// CONCATENATED MODULE: ./node_modules/react-color/es/components/circle/CircleSwatch.js





var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return react.createElement(
    'div',
    { style: styles.swatch },
    react.createElement(common_Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

/* harmony default export */ var circle_CircleSwatch = ((0,lib/* handleHover */.tz)(CircleSwatch));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/circle/Circle.js










var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    lodash_es_map(colors, function (c) {
      return react.createElement(circle_CircleSwatch, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  circleSize: (prop_types_default()).number,
  circleSpacing: (prop_types_default()).number,
  styles: (prop_types_default()).object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [colors_es2015_red[500], pink[500], purple[500], deepPurple[500], indigo[500], blue[500], lightBlue[500], cyan[500], teal[500], green[500], lightGreen[500], lime[500], yellow[500], amber[500], orange[500], deepOrange[500], brown[500], blueGrey[500]],
  styles: {}
};

/* harmony default export */ var circle_Circle = (common_ColorWrap(Circle));
;// CONCATENATED MODULE: ./node_modules/lodash-es/isUndefined.js
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ var lodash_es_isUndefined = (isUndefined);

// EXTERNAL MODULE: ./node_modules/@icons/material/UnfoldMoreHorizontalIcon.js
var UnfoldMoreHorizontalIcon = __webpack_require__(43891);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/chrome/ChromeFields.js
var ChromeFields_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ChromeFields_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ChromeFields_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ChromeFields_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-did-mount-set-state, no-param-reassign */









var ChromeFields = function (_React$Component) {
  ChromeFields_inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    ChromeFields_classCallCheck(this, ChromeFields);

    var _this = ChromeFields_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!lodash_es_isUndefined(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!lodash_es_isUndefined(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  ChromeFields_createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0,lib/* default */.ZP)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return react.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        react.createElement(
          'div',
          { style: styles.toggle },
          react.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            react.createElement(UnfoldMoreHorizontalIcon/* default */.Z, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(react.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

/* harmony default export */ var chrome_ChromeFields = (ChromeFields);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/chrome/ChromePointer.js



var ChromePointer = function ChromePointer() {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var chrome_ChromePointer = (ChromePointer);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/chrome/ChromePointerCircle.js



var ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var chrome_ChromePointerCircle = (ChromePointerCircle);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/chrome/Chrome.js










var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: chrome_ChromePointerCircle,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.color },
          react.createElement(
            'div',
            { style: styles.swatch },
            react.createElement('div', { style: styles.active }),
            react.createElement(common_Checkboard, { renderers: renderers })
          )
        ),
        react.createElement(
          'div',
          { style: styles.toggles },
          react.createElement(
            'div',
            { style: styles.hue },
            react.createElement(common_Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: chrome_ChromePointer,
              onChange: onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: chrome_ChromePointer,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      react.createElement(chrome_ChromeFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  disableAlpha: (prop_types_default()).bool,
  styles: (prop_types_default()).object,
  defaultView: prop_types_default().oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

/* harmony default export */ var chrome_Chrome = (common_ColorWrap(Chrome));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/compact/CompactColor.js






var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return react.createElement(
    common_Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    react.createElement('div', { style: styles.dot })
  );
};

/* harmony default export */ var compact_CompactColor = (CompactColor);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/compact/CompactFields.js





var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    react.createElement('div', { style: styles.active }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

/* harmony default export */ var compact_CompactFields = (CompactFields);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/compact/Compact.js











var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return react.createElement(
    common_Raised,
    { style: styles.Compact, styles: passedStyles },
    react.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      react.createElement(
        'div',
        null,
        lodash_es_map(colors, function (c) {
          return react.createElement(compact_CompactColor, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        react.createElement('div', { style: styles.clear })
      ),
      react.createElement(compact_CompactFields, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  styles: (prop_types_default()).object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

/* harmony default export */ var compact_Compact = (common_ColorWrap(Compact));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/github/GithubSwatch.js





var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return react.createElement(
    'div',
    { style: styles.swatch },
    react.createElement(common_Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

/* harmony default export */ var github_GithubSwatch = ((0,lib/* handleHover */.tz)(GithubSwatch));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/github/Github.js









var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    react.createElement('div', { style: styles.triangleShadow }),
    react.createElement('div', { style: styles.triangle }),
    lodash_es_map(colors, function (c) {
      return react.createElement(github_GithubSwatch, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  triangle: prop_types_default().oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: (prop_types_default()).object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

/* harmony default export */ var github_Github = (common_ColorWrap(Github));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/hue/HuePointer.js



var SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var HuePointer = (SliderPointer);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/hue/Hue.js
var Hue_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return react.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    react.createElement(common_Hue, Hue_extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: (prop_types_default()).object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: HuePointer,
  styles: {}
};

/* harmony default export */ var hue_Hue = (common_ColorWrap(HuePicker));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/material/Material.js







var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return react.createElement(
    common_Raised,
    { styles: passedStyles },
    react.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      react.createElement(common_EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      react.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* harmony default export */ var material_Material = (common_ColorWrap(Material));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/PhotoshopFields.js






var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields },
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    react.createElement('div', { style: styles.divider }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    react.createElement('div', { style: styles.divider }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    react.createElement(
      'div',
      { style: styles.fieldSymbols },
      react.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      react.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      react.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

/* harmony default export */ var PhotoshopFields = (PhotoshopPicker);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/PhotoshopPointerCircle.js



var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var photoshop_PhotoshopPointerCircle = (PhotoshopPointerCircle);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/PhotoshopPointer.js



var PhotoshopPointer_PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.pointer },
    react.createElement(
      'div',
      { style: styles.left },
      react.createElement('div', { style: styles.leftInside })
    ),
    react.createElement(
      'div',
      { style: styles.right },
      react.createElement('div', { style: styles.rightInside })
    )
  );
};

/* harmony default export */ var PhotoshopPointer = (PhotoshopPointer_PhotoshopPointerCircle);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/PhotoshopButton.js



var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return react.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

/* harmony default export */ var photoshop_PhotoshopButton = (PhotoshopButton);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/PhotoshopPreviews.js



var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return react.createElement(
    'div',
    null,
    react.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    react.createElement(
      'div',
      { style: styles.swatches },
      react.createElement('div', { style: styles.new }),
      react.createElement('div', { style: styles.current })
    ),
    react.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

/* harmony default export */ var photoshop_PhotoshopPreviews = (PhotoshopPreviews);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/photoshop/Photoshop.js
var Photoshop_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Photoshop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Photoshop_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Photoshop_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Photoshop = function (_React$Component) {
  Photoshop_inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    Photoshop_classCallCheck(this, Photoshop);

    var _this = Photoshop_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  Photoshop_createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0,lib/* default */.ZP)(lodash_es_merge({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return react.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        react.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        react.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.saturation },
            react.createElement(common_Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: photoshop_PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.hue },
            react.createElement(common_Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: PhotoshopPointer,
              onChange: this.props.onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.controls },
            react.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              react.createElement(
                'div',
                { style: styles.previews },
                react.createElement(photoshop_PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              react.createElement(
                'div',
                { style: styles.actions },
                react.createElement(photoshop_PhotoshopButton, { label: 'OK', onClick: this.props.onAccept, active: true }),
                react.createElement(photoshop_PhotoshopButton, { label: 'Cancel', onClick: this.props.onCancel }),
                react.createElement(PhotoshopFields, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(react.Component);

Photoshop.propTypes = {
  header: (prop_types_default()).string,
  styles: (prop_types_default()).object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

/* harmony default export */ var photoshop_Photoshop = (common_ColorWrap(Photoshop));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/sketch/SketchFields.js
/* eslint-disable no-param-reassign */







var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    react.createElement(
      'div',
      { style: styles.double },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.alpha },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

/* harmony default export */ var sketch_SketchFields = (SketchFields);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/sketch/SketchPresetColors.js
var SketchPresetColors_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return react.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return react.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        react.createElement(common_Swatch, SketchPresetColors_extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: prop_types_default().arrayOf(prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().shape({
    color: (prop_types_default()).string,
    title: (prop_types_default()).string
  })])).isRequired
};

/* harmony default export */ var sketch_SketchPresetColors = (SketchPresetColors);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/sketch/Sketch.js
var Sketch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': Sketch_extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      react.createElement(
        'div',
        { style: styles.sliders },
        react.createElement(
          'div',
          { style: styles.hue },
          react.createElement(common_Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.alpha },
          react.createElement(common_Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      react.createElement(
        'div',
        { style: styles.color },
        react.createElement(common_Checkboard, null),
        react.createElement('div', { style: styles.activeColor })
      )
    ),
    react.createElement(sketch_SketchFields, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    react.createElement(sketch_SketchPresetColors, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: (prop_types_default()).bool,
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  styles: (prop_types_default()).object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

/* harmony default export */ var sketch_Sketch = (common_ColorWrap(Sketch));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/slider/SliderSwatch.js



var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return react.createElement('div', { style: styles.swatch, onClick: handleClick });
};

/* harmony default export */ var slider_SliderSwatch = (SliderSwatch);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/slider/SliderSwatches.js





var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return react.createElement(
    'div',
    { style: styles.swatches },
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    react.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ var slider_SliderSwatches = (SliderSwatches);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/slider/SliderPointer.js



var SliderPointer_SliderPointer = function SliderPointer() {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var slider_SliderPointer = (SliderPointer_SliderPointer);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/slider/Slider.js









var Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return react.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    react.createElement(
      'div',
      { style: styles.hue },
      react.createElement(common_Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatches },
      react.createElement(slider_SliderSwatches, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: (prop_types_default()).object
};
Slider.defaultProps = {
  pointer: slider_SliderPointer,
  styles: {}
};

/* harmony default export */ var slider_Slider = (common_ColorWrap(Slider));
// EXTERNAL MODULE: ./node_modules/@icons/material/CheckIcon.js
var CheckIcon = __webpack_require__(70597);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/swatches/SwatchesColor.js







var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return react.createElement(
    common_Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    react.createElement(
      'div',
      { style: styles.check },
      react.createElement(CheckIcon/* default */.Z, null)
    )
  );
};

/* harmony default export */ var swatches_SwatchesColor = (SwatchesColor);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/swatches/SwatchesGroup.js






var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0,lib/* default */.ZP)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.group },
    lodash_es_map(group, function (color, i) {
      return react.createElement(swatches_SwatchesColor, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

/* harmony default export */ var swatches_SwatchesGroup = (SwatchesGroup);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/swatches/Swatches.js










var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    react.createElement(
      common_Raised,
      null,
      react.createElement(
        'div',
        { style: styles.overflow },
        react.createElement(
          'div',
          { style: styles.body },
          lodash_es_map(colors, function (group) {
            return react.createElement(swatches_SwatchesGroup, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          react.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  height: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf(prop_types_default().arrayOf((prop_types_default()).string)),
  styles: (prop_types_default()).object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[colors_es2015_red[900], colors_es2015_red[700], colors_es2015_red[500], colors_es2015_red[300], colors_es2015_red[100]], [pink[900], pink[700], pink[500], pink[300], pink[100]], [purple[900], purple[700], purple[500], purple[300], purple[100]], [deepPurple[900], deepPurple[700], deepPurple[500], deepPurple[300], deepPurple[100]], [indigo[900], indigo[700], indigo[500], indigo[300], indigo[100]], [blue[900], blue[700], blue[500], blue[300], blue[100]], [lightBlue[900], lightBlue[700], lightBlue[500], lightBlue[300], lightBlue[100]], [cyan[900], cyan[700], cyan[500], cyan[300], cyan[100]], [teal[900], teal[700], teal[500], teal[300], teal[100]], ['#194D33', green[700], green[500], green[300], green[100]], [lightGreen[900], lightGreen[700], lightGreen[500], lightGreen[300], lightGreen[100]], [lime[900], lime[700], lime[500], lime[300], lime[100]], [yellow[900], yellow[700], yellow[500], yellow[300], yellow[100]], [amber[900], amber[700], amber[500], amber[300], amber[100]], [orange[900], orange[700], orange[500], orange[300], orange[100]], [deepOrange[900], deepOrange[700], deepOrange[500], deepOrange[300], deepOrange[100]], [brown[900], brown[700], brown[500], brown[300], brown[100]], [blueGrey[900], blueGrey[700], blueGrey[500], blueGrey[300], blueGrey[100]], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

/* harmony default export */ var swatches_Swatches = (common_ColorWrap(Swatches));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/twitter/Twitter.js









var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    react.createElement('div', { style: styles.triangleShadow }),
    react.createElement('div', { style: styles.triangle }),
    react.createElement(
      'div',
      { style: styles.body },
      lodash_es_map(colors, function (c, i) {
        return react.createElement(common_Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      react.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      react.createElement(common_EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      react.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  triangle: prop_types_default().oneOf(['hide', 'top-left', 'top-right']),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  styles: (prop_types_default()).object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

/* harmony default export */ var twitter_Twitter = (common_ColorWrap(Twitter));
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/google/GooglePointerCircle.js




var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: prop_types_default().shape({
    h: (prop_types_default()).number,
    s: (prop_types_default()).number,
    l: (prop_types_default()).number,
    a: (prop_types_default()).number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ var google_GooglePointerCircle = (GooglePointerCircle);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/google/GooglePointer.js




var GooglePointer = function GooglePointer(props) {
  var styles = (0,lib/* default */.ZP)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: prop_types_default().shape({
    h: (prop_types_default()).number,
    s: (prop_types_default()).number,
    l: (prop_types_default()).number,
    a: (prop_types_default()).number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ var google_GooglePointer = (GooglePointer);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/google/GoogleFields.js





var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = (0,lib/* default */.ZP)({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return react.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    react.createElement(
      'div',
      { style: styles.fields },
      react.createElement(
        'div',
        { style: styles.double },
        react.createElement(common_EditableInput, {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      react.createElement(
        'div',
        { style: styles.column },
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* harmony default export */ var google_GoogleFields = (GoogleFields);
;// CONCATENATED MODULE: ./node_modules/react-color/es/components/google/Google.js










var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib/* default */.ZP)(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return react.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    react.createElement(
      'div',
      { style: styles.head },
      header
    ),
    react.createElement('div', { style: styles.swatch }),
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: google_GooglePointerCircle,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.hue },
          react.createElement(common_Hue, {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: google_GooglePointer,
            onChange: onChange
          })
        )
      ),
      react.createElement(google_GoogleFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  styles: (prop_types_default()).object,
  header: (prop_types_default()).string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

/* harmony default export */ var google_Google = (common_ColorWrap(Google));
;// CONCATENATED MODULE: ./node_modules/react-color/es/index.js


















// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var share_lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/ColorPicker/style.module.css
var style_module = __webpack_require__(68679);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/features/share/components/ButtonConfirmPopup/index.tsx
var ButtonConfirmPopup = __webpack_require__(85558);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ColorPicker/index.tsx














var RECENTLY_COLOR_MAXIMUM = 10;
var ColorPicker = function(props) {
    var indexColor = props.indexColor, actionKey = props.actionKey, callbackCancelColorPicker = props.callbackCancelColorPicker, _defaultColor = props.defaultColor, defaultColor = _defaultColor === void 0 ? "#000" : _defaultColor;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var themeSettings = dynamicConfig && dynamicConfig.themeSettings;
    var recentlyColor = themeSettings.recentlyColor;
    var ref = (0,react.useState)(defaultColor), colorState = ref[0], setColorState = ref[1];
    var ref1 = (0,react.useState)((0,share_lib/* hexToRgba */.a7)(defaultColor)), colorStatePicker = ref1[0], setColorStatePicker = ref1[1];
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleChangeColor = function(color) {
        var hexColor = (0,share_lib/* rgbaToHex */.s)(color.rgb);
        setColorState(hexColor);
        setColorStatePicker(color.rgb);
    };
    var handleChangeRecentColor = function(color) {
        setColorState(color);
        setColorStatePicker((0,share_lib/* hexToRgba */.a7)(color));
    };
    var handleCancelColorPicker = function() {
        callbackCancelColorPicker();
    };
    var handleConfirmColorPicker = function() {
        handleCancelColorPicker();
        var newRecentlyColor = cloneDeep_default()(recentlyColor);
        if (colorState) newRecentlyColor.unshift(colorState);
        var newRecentlyColorFilter = Array.from(new Set(newRecentlyColor));
        if (newRecentlyColorFilter.length > RECENTLY_COLOR_MAXIMUM) newRecentlyColorFilter.pop();
        dispatch((0,dynamicSlice/* setParamsThemeSetting */._7)({
            data: {
                recentlyColor: newRecentlyColorFilter
            }
        }));
        switch(actionKey){
            case "SELECT_BACKGROUND_GRADIENT_COLOR":
                if (indexColor !== undefined) {
                    rxjs/* dataService.publish */.c.publish({
                        selectedBackgroundGradientColor: colorState,
                        indexColor: indexColor
                    });
                }
                break;
            case "SELECT_BACKGROUND_SOLID_COLOR":
                rxjs/* dataService.publish */.c.publish({
                    selectedBackgroundSolidColor: colorState
                });
                break;
            case "SELECT_PRIMARY_COLOR":
                rxjs/* dataService.publish */.c.publish({
                    selectedMainColor: colorState
                });
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-3",
        children: [
            recentlyColor[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] leading-[17px] mb-3",
                                children: t("ss_builder_recently_color_panel_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-wrap",
                                children: recentlyColor.map(function(ele, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[28px] h-[28px] rounded-[50%] cursor-pointer relative overflow-hidden mr-[10px] mb-[10px]",
                                        style: {
                                            backgroundColor: (0,share_lib/* getGlobalColor */.mg)(ele)
                                        },
                                        onClick: function() {
                                            handleChangeRecentColor(ele);
                                        },
                                        children: [
                                            (0,share_lib/* getOpacityFromHex */.eq)(ele) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                style: {
                                                    background: "repeat #fff url(https://image.passio.eco/page-builder/page-builder/background-default/checkerboard-v2.png) "
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                style: {
                                                    backgroundColor: ele
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[100%] h-[100%] absolute left-0 top-0 rounded-[50%]",
                                                style: {
                                                    outline: "rgba(0, 0, 0, 0.2) solid 1px",
                                                    outlineOffset: "-1px"
                                                }
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] mb-3",
                        children: t("ss_builder_suggested_color_panel_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_Circle, {
                        // onSwatchHover={handleChangeColor}
                        onChange: handleChangeColor,
                        color: colorState,
                        width: "100%",
                        className: (style_module_default())["circle-picker-custom"],
                        circleSpacing: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[11px] text-[#191919] leading-[16px] mb-2 font-medium",
                        children: t("ss_builder_optional_color_panel_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chrome_Chrome, {
                        color: colorStatePicker,
                        onChange: handleChangeColor,
                        width: "100%",
                        className: (style_module_default())["circle-picker-custom"]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                onConfirm: colorState ? handleConfirmColorPicker : function() {}
            })
        ]
    });
};
var ColorPickerV2 = function(props) {
    var defaultColor = props.defaultColor, onColorSelected = props.onColorSelected, onCancel = props.onCancel;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var themeSettings = dynamicConfig && dynamicConfig.themeSettings;
    var recentlyColor = themeSettings.recentlyColor;
    var ref = (0,react.useState)(defaultColor), colorState = ref[0], setColorState = ref[1];
    var ref2 = (0,react.useState)((0,share_lib/* hexToRgba */.a7)(defaultColor)), colorStatePicker = ref2[0], setColorStatePicker = ref2[1];
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleChangeColor = function(color) {
        var hexColor = (0,share_lib/* rgbaToHex */.s)(color.rgb);
        setColorState(hexColor);
        setColorStatePicker(color.rgb);
    };
    var handleChangeRecentColor = function(color) {
        setColorState(color);
        setColorStatePicker((0,share_lib/* hexToRgba */.a7)(color));
    };
    var handleCancelColorPicker = function() {
        onCancel();
    };
    var handleConfirmColorPicker = function() {
        var newRecentlyColor = cloneDeep_default()(recentlyColor);
        if (colorState) newRecentlyColor.unshift(colorState);
        var newRecentlyColorFilter = Array.from(new Set(newRecentlyColor));
        if (newRecentlyColorFilter.length > RECENTLY_COLOR_MAXIMUM) newRecentlyColorFilter.pop();
        dispatch((0,dynamicSlice/* setParamsThemeSetting */._7)({
            data: {
                recentlyColor: newRecentlyColorFilter
            }
        }));
        onColorSelected(colorState);
        handleCancelColorPicker();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            recentlyColor[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 recent-color",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] leading-[17px] mb-3",
                                children: t("ss_builder_recently_color_panel_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-wrap",
                                children: recentlyColor.map(function(ele, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[28px] h-[28px] rounded-[50%] cursor-pointer relative overflow-hidden mr-[10px] mb-[10px]",
                                        style: {
                                            backgroundColor: (0,share_lib/* getGlobalColor */.mg)(ele)
                                        },
                                        onClick: function() {
                                            handleChangeRecentColor(ele);
                                        },
                                        children: [
                                            (0,share_lib/* getOpacityFromHex */.eq)(ele) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                style: {
                                                    background: "repeat #fff url(https://image.passio.eco/page-builder/page-builder/background-default/checkerboard-v2.png) "
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                style: {
                                                    backgroundColor: ele
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[100%] h-[100%] absolute left-0 top-0 rounded-[50%]",
                                                style: {
                                                    outline: "rgba(0, 0, 0, 0.2) solid 1px",
                                                    outlineOffset: "-1px"
                                                }
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] mb-3",
                        children: t("ss_builder_suggested_color_panel_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_Circle, {
                        // onSwatchHover={handleChangeColor}
                        onChange: handleChangeColor,
                        color: colorState,
                        width: "100%",
                        className: (style_module_default())["circle-picker-custom"],
                        circleSpacing: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[11px] text-[#191919] leading-[16px] mb-2 font-medium",
                        children: t("ss_builder_optional_color_panel_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chrome_Chrome, {
                        color: colorStatePicker,
                        onChange: handleChangeColor,
                        width: "100%",
                        className: (style_module_default())["circle-picker-custom"],
                        circleSpacing: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                onConfirm: colorState ? handleConfirmColorPicker : function() {}
            })
        ]
    });
};
/* harmony default export */ var ThemeSetting_ColorPicker = (ColorPicker);


/***/ }),

/***/ 62944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);


var Portal = function(param) {
    var children = param.children, elementId = param.elementId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setMounted(true);
        return function() {
            return setMounted(false);
        };
    }, []);
    return mounted ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(children, document.querySelector("#".concat(elementId))) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Portal);


/***/ }),

/***/ 39608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TypeIconEnum; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27856);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _share_icons_line_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45297);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);






var TypeIconEnum;
(function(TypeIconEnum) {
    TypeIconEnum["ICON"] = "icon";
    TypeIconEnum["SETTING"] = "setting";
})(TypeIconEnum || (TypeIconEnum = {}));
var IconRender = function(props) {
    var iconName = props.iconName, fillColor = props.fillColor, className = props.className, _containerClass = props.containerClass, containerClass = _containerClass === void 0 ? "inline-block" : _containerClass, _type = props.type, type = _type === void 0 ? TypeIconEnum.ICON : _type;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), valueIcon = ref[0], setValueIcon = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect)(function() {
        if (containerRef.current && className) {
            var valueClassArr = typeof className === "string" && className.split(" ");
            valueClassArr.forEach(function(ele) {
                return containerRef.current.firstElementChild && containerRef.current.firstElementChild.classList.add(ele);
            });
        }
    }, [
        className,
        containerRef.current,
        valueIcon
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (iconName) {
            fetch("".concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .ICON_RENDER_URL */ .Sv, "/").concat(iconName)).then(function(response) {
                if (response.status && /^20[0-9]$/.test(response.status.toString())) {
                    return response.text();
                } else return null;
            }).then(function(data) {
                setValueIcon(data);
            }).catch(function(error) {
                return console.log(error);
            });
        }
    }, [
        iconName
    ]);
    var valueIconFill = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (fillColor) {
            var pattern = new RegExp(/fill=\"[a-zA-Z0-9\#!]+\"/g);
            var result = valueIcon && valueIcon.replace(pattern, "fill=".concat(fillColor));
            return result;
        } else {
            return valueIcon;
        }
    }, [
        valueIcon,
        fillColor
    ]);
    var cleanValueIconFill = dompurify__WEBPACK_IMPORTED_MODULE_3__.sanitize(valueIconFill);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !cleanValueIconFill && type === TypeIconEnum.SETTING ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: containerRef,
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(containerClass, "w-[24px] h-[24px]"),
            style: {
                opacity: "0.4"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons_line_icon__WEBPACK_IMPORTED_MODULE_4__/* .EmptyIcon */ .tL, {})
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: containerRef,
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(containerClass, !cleanValueIconFill ? "w-[24px] h-[24px]" : ""),
            dangerouslySetInnerHTML: {
                __html: cleanValueIconFill
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconRender);


/***/ }),

/***/ 88549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ CreateAxiosSASS; },
/* harmony export */   "Ev": function() { return /* binding */ CreateGatewayAxios; },
/* harmony export */   "ZP": function() { return /* binding */ CreateAxios; }
/* harmony export */ });
/* harmony import */ var _configs_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(935);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _features_share_helper_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98390);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var _share_configs_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40229);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39666);
/* provided dependency */ var process = __webpack_require__(83454);






var token = js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .KEY_TOKEN */ .JE);
var gatewayToken = js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .KEY_GATEWAY_TOKEN */ .sL);
function CreateAxios() {
    var instance;
    if (token) {
        instance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
            baseURL: process.env.API_URL,
            headers: {
                Authorization: "Bearer ".concat(token)
            }
        });
    } else instance = (axios__WEBPACK_IMPORTED_MODULE_1___default());
    instance.interceptors.request.use(function(config) {
        // Do something before request is sent
        return config;
    }, function(error) {
        // Do something with request error
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error);
        return Promise.reject(error);
    });
    // Add a response interceptor
    instance.interceptors.response.use(function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    //return response.data; //neu chi muon lay data
    }, function(error) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error);
        if (error.response.status === 401) {
            (0,_features_share_helper_system__WEBPACK_IMPORTED_MODULE_5__/* .logError */ .H)(error.response, "createAxios");
            js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].remove */ .Z.remove(_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .KEY_TOKEN */ .JE);
            window.location.href = _share_configs_pages__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_PAGE.login */ ._L.login;
        }
        return Promise.reject(error);
    });
    return instance;
};
function CreateGatewayAxios() {
    var instance;
    if (gatewayToken) {
        instance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
            baseURL: "https://gateway.passio.eco",
            headers: {
                Authorization: "Bearer ".concat(gatewayToken)
            }
        });
    } else instance = (axios__WEBPACK_IMPORTED_MODULE_1___default());
    instance.interceptors.request.use(function(config) {
        // Do something before request is sent
        return config;
    }, function(error) {
        // Do something with request error
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error);
        return Promise.reject(error);
    });
    // Add a response interceptor
    instance.interceptors.response.use(function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    //return response.data; //neu chi muon lay data
    }, function(error) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error);
        if (error.response.status === 401) {
            (0,_features_share_helper_system__WEBPACK_IMPORTED_MODULE_5__/* .logError */ .H)(error.response, "createAxios");
            js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].remove */ .Z.remove(_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .KEY_GATEWAY_TOKEN */ .sL);
            window.location.href = _share_configs_pages__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_PAGE.login */ ._L.login;
        }
        return Promise.reject(error);
    });
    return instance;
}
function CreateAxiosSASS() {
    var instance;
    if (token) {
        instance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
            baseURL: "https://saas.passio.eco",
            // baseURL: "https://dev.saas.passio.eco",
            headers: {
                Authorization: "Bearer ".concat(token)
            }
        });
    } else instance = (axios__WEBPACK_IMPORTED_MODULE_1___default());
    instance.interceptors.request.use(function(config) {
        // Do something before request is sent
        return config;
    }, function(error) {
        // Do something with request error
        return Promise.reject(error);
    });
    // Add a response interceptor
    instance.interceptors.response.use(function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    //return response.data; //neu chi muon lay data
    }, function(error) {
        if (error.response.status === 401) {
            (0,_features_share_helper_system__WEBPACK_IMPORTED_MODULE_5__/* .logError */ .H)(error.response, "createAxios");
            js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].remove */ .Z.remove(_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .KEY_TOKEN */ .JE);
            window.location.href = _share_configs_pages__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_PAGE.login */ ._L.login;
        }
        return Promise.reject(error);
    });
    return instance;
}


/***/ }),

/***/ 85861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ sendRating; },
/* harmony export */   "B5": function() { return /* binding */ requestReplaceThemeTemplate; },
/* harmony export */   "Dw": function() { return /* binding */ createManyTagThemeTemplate; },
/* harmony export */   "Dx": function() { return /* binding */ fetchSiteSetting; },
/* harmony export */   "FG": function() { return /* binding */ saveSettingDonation; },
/* harmony export */   "FU": function() { return /* binding */ fetchCategoryBuilder; },
/* harmony export */   "H$": function() { return /* binding */ fetchCreatorProfile; },
/* harmony export */   "IU": function() { return /* binding */ requestSearchThemeTemplate; },
/* harmony export */   "Ic": function() { return /* binding */ requestSaveThemeTemplate; },
/* harmony export */   "Kv": function() { return /* binding */ fetchBookingProfile; },
/* harmony export */   "Kz": function() { return /* binding */ updateCreator; },
/* harmony export */   "Lb": function() { return /* binding */ fetchIconBuilder; },
/* harmony export */   "MR": function() { return /* binding */ requestUploadImage; },
/* harmony export */   "OW": function() { return /* binding */ requestSaveDomain; },
/* harmony export */   "Qi": function() { return /* binding */ fetchPassioPageProfile; },
/* harmony export */   "T_": function() { return /* binding */ requestUpdateThemeTemplate; },
/* harmony export */   "Tx": function() { return /* binding */ sendReportError; },
/* harmony export */   "Xg": function() { return /* binding */ getPackageSass; },
/* harmony export */   "Y3": function() { return /* binding */ updateStore; },
/* harmony export */   "aP": function() { return /* binding */ publishSetting; },
/* harmony export */   "aY": function() { return /* binding */ requestValidateDomain; },
/* harmony export */   "c4": function() { return /* binding */ saveSiteSetting; },
/* harmony export */   "dA": function() { return /* binding */ requestRestoreTheme; },
/* harmony export */   "dm": function() { return /* binding */ requestGetTemplate; },
/* harmony export */   "do": function() { return /* binding */ getListCampaign; },
/* harmony export */   "e4": function() { return /* binding */ requestGetSelectedThemeTemplate; },
/* harmony export */   "fu": function() { return /* binding */ requestDeleteTemplate; },
/* harmony export */   "h4": function() { return /* binding */ requestApplyThemeTemplate; },
/* harmony export */   "hQ": function() { return /* binding */ sendRequestNoNeedToRating; },
/* harmony export */   "iF": function() { return /* binding */ getPackageOfUser; },
/* harmony export */   "ik": function() { return /* binding */ requestGetListVirtualGift; },
/* harmony export */   "jn": function() { return /* binding */ fetchCategory; },
/* harmony export */   "mM": function() { return /* binding */ requestCreatePostLink; },
/* harmony export */   "mW": function() { return /* binding */ requestUpdateTemplate; },
/* harmony export */   "nN": function() { return /* binding */ requestValidateUrl; },
/* harmony export */   "ow": function() { return /* binding */ updateCampaignImage; },
/* harmony export */   "pw": function() { return /* binding */ updateCampaignStatus; },
/* harmony export */   "r_": function() { return /* binding */ requestDetectProductUrl; },
/* harmony export */   "s2": function() { return /* binding */ requestGetSiteSetting; },
/* harmony export */   "sV": function() { return /* binding */ requestSearchTag; },
/* harmony export */   "tv": function() { return /* binding */ checkSettingEmpty; },
/* harmony export */   "ty": function() { return /* binding */ requestDeleteThemeTemplate; },
/* harmony export */   "ux": function() { return /* binding */ requestSearchTemplate; },
/* harmony export */   "vL": function() { return /* binding */ requestSaveSiteSetting; },
/* harmony export */   "w": function() { return /* binding */ sendRequestLogin; }
/* harmony export */ });
/* unused harmony exports getTestHeader, requestGetSite, requestSaveSite, requestPublishSite, fetchIcons, saveDisplaySetting, requestSaveThemeSettings, fetchAffiliateProducts, requestGetListDigitalProduct, checkLdpEmpty, includeDataSettingTheme, saveCategory, applyThemeOnboarding, finishOnboarding, saveSettingTOD, finishProductTour, createTagThemeTemplate */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _createAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88549);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var baseUrl = "https://builder-api.passio.eco";
var BUILDER_PATH = {
    SITE_SETTING: "site-setting",
    PUBLISH_SETTING: "site-setting/publish"
};
var API_PATH = {
    SELLER: "/api/v1/builder/seller",
    SITE_SETTING: "/api/v1/builder/site-setting",
    SITE_SETTING_PULISH: "/api/v1/builder/site-setting/publish",
    GET_LIST_CAMPAIGN: "/api/mini-store/v1/cpc/list/creator",
    UPDATE_CAMPAIGN_STATUS: "/api/mini-store/v1/cpc/creator-confirm-join-campaign",
    UPDATE_CAMPAIGN_IMAGE: "/api/mini-store/v1/cpc/creator-submit-acceptance-image",
    BOOKING_FILE_SELLER: "/api/v1/media-kit-builder/seller"
};
var instanceAxios = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: baseUrl
});
var gatewayAxious = (0,_createAxios__WEBPACK_IMPORTED_MODULE_2__/* .CreateGatewayAxios */ .Ev)();
var Axious = (0,_createAxios__WEBPACK_IMPORTED_MODULE_2__/* .CreateAxiosSASS */ .$y)();
var Caxios = (0,_createAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)();
var getTestHeader = function() {
    gatewayAxious.get("api/builder/seller/header").then(function(data) {
        return console.log(data);
    });
};
var requestGetSite = function(userId) {
    return instanceAxios.get(BUILDER_PATH.SITE_SETTING, {
        params: {
            user_id: userId
        }
    }).then(function(param) {
        var data = param.data;
        return data;
    }).catch(function(error) {
        console.log(error);
    });
};
var requestSaveSite = function(dataResquest) {
    return instanceAxios.post(BUILDER_PATH.SITE_SETTING, dataResquest).then(function(param) {
        var data = param.data;
        return data;
    }).catch(function(error) {
        console.log(error);
    });
};
var requestPublishSite = function(dataResquest) {
    return instanceAxios.post(BUILDER_PATH.PUBLISH_SETTING, dataResquest).then(function(param) {
        var data = param.data;
        return data;
    }).catch(function(error) {
        console.log(error);
    });
};
var publishSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post(API_PATH.SITE_SETTING_PULISH, dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function publishSetting(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSiteSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userId) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get(API_PATH.SITE_SETTING, {
                        params: {
                            user_id: userId
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchSiteSetting(userId) {
        return _ref.apply(this, arguments);
    };
}();
var saveSiteSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post(API_PATH.SITE_SETTING, requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveSiteSetting(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIcons = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var page, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    page = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 1;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/icons", {
                        params: {
                            page: page
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchIcons() {
        return _ref.apply(this, arguments);
    };
}();
var saveDisplaySetting = function(userId, displaySetting) {};
var requestSaveThemeSettings = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataResquest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/site-setting/display-setting", dataResquest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSaveThemeSettings(dataResquest) {
        return _ref.apply(this, arguments);
    };
}();
var requestUploadImage = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataResquest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/image/upload", dataResquest);
                case 2:
                    response = _ctx.sent;
                    if (!(response && /^20[0-9]$/.test(response.status.toString()))) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // return response;
    }));
    return function requestUploadImage(dataResquest) {
        return _ref.apply(this, arguments);
    };
}();
var requestRestoreTheme = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataResquest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/site-setting/reset", dataResquest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestRestoreTheme(dataResquest) {
        return _ref.apply(this, arguments);
    };
}();
var requestValidateUrl = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(urlValue) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/passio-page/aff/is-url-support", {
                        params: {
                            url: urlValue
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestValidateUrl(urlValue) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAffiliateProducts = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var search, limit, page, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    search = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "", limit = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 10, page = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 1;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/passio-page/aff/post-link/search", {
                        params: {
                            search: search,
                            page: page,
                            limit: limit
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchAffiliateProducts() {
        return _ref.apply(this, arguments);
    };
}();
var requestDetectProductUrl = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(urlValue) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/passio-page/aff/product/detect", {
                        params: {
                            url: urlValue
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestDetectProductUrl(urlValue) {
        return _ref.apply(this, arguments);
    };
}();
var requestCreatePostLink = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataResquest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/passio-page/aff/post-link/create", dataResquest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestCreatePostLink(dataResquest) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetListVirtualGift = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var page, per_page, country_code, user_id, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    page = data.page, per_page = data.per_page, country_code = data.country_code, user_id = data.user_id;
                    _ctx.next = 3;
                    return gatewayAxious.get("api/mini-store/v1/public/catalog/end-user/product/virtual-gift/list-cps", {
                        params: {
                            page: page,
                            per_page: per_page,
                            country_code: country_code,
                            user_id: user_id
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetListVirtualGift(data) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetListDigitalProduct = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var page, per_page, country_code, user_id, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    page = data.page, per_page = data.per_page, country_code = data.country_code, user_id = data.user_id;
                    _ctx.next = 3;
                    return gatewayAxious.get("api/mini-store/v1/public/catalog/end-user/product/list-cps", {
                        params: {
                            page: page,
                            per_page: per_page,
                            country_code: country_code,
                            user_id: user_id
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetListDigitalProduct(data) {
        return _ref.apply(this, arguments);
    };
}();
var checkLdpEmpty = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/passio-page/aff/is-ldp-empty", {
                        params: {
                            user_id: user_id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkLdpEmpty(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var checkSettingEmpty = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/builder/site-setting/is-setting-empty", {
                        params: {
                            user_id: user_id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkSettingEmpty(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var includeDataSettingTheme = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/builder/site-setting/is-setting-empty", {
                        params: {
                            user_id: user_id,
                            include_data: true
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function includeDataSettingTheme(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCategory = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/pub/builder/category");
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCategory() {
        return _ref.apply(this, arguments);
    };
}();
var saveCategory = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/seller/update-category", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveCategory(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var applyThemeOnboarding = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/theme-template/apply-theme", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function applyThemeOnboarding(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var finishOnboarding = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/passio-page/aff/finish-onboard", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function finishOnboarding(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var requestValidateDomain = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(domainValue) {
        var response, dataRequest;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    response = null;
                    dataRequest = {
                        domain: domainValue
                    };
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return gatewayAxious.post("/api/v1/passio-page/aff/domain/validate", dataRequest);
                case 5:
                    response = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](2);
                    if (_ctx.t0) {
                        response = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.response;
                    }
                case 11:
                    return _ctx.abrupt("return", response);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    }));
    return function requestValidateDomain(domainValue) {
        return _ref.apply(this, arguments);
    };
}();
var requestSaveSiteSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/website-config", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSaveSiteSetting(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetSiteSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/builder/website-config", {
                        params: {
                            user_id: user_id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetSiteSetting(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var requestSaveDomain = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(domainValue) {
        var dataRequest, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dataRequest = {
                        domain: domainValue
                    };
                    _ctx.next = 3;
                    return gatewayAxious.post("/api/v1/passio-page/aff/domain/update", dataRequest);
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSaveDomain(domainValue) {
        return _ref.apply(this, arguments);
    };
}();
var requestSearchThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var _per_page, per_page, keyword, is_admin, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _per_page = data.per_page, per_page = _per_page === void 0 ? 100 : _per_page, keyword = data.keyword, is_admin = data.is_admin;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/theme-template/search", {
                        params: is_admin ? {
                            keyword: keyword,
                            per_page: per_page,
                            is_admin: 1
                        } : {
                            keyword: keyword,
                            per_page: per_page
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSearchThemeTemplate(data) {
        return _ref.apply(this, arguments);
    };
}();
var requestSaveThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/theme-template", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSaveThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestUpdateThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/theme-template/update-info", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestUpdateThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestDeleteThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.delete("/api/v1/builder/theme-template", {
                        params: {
                            id: id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestDeleteThemeTemplate(id) {
        return _ref.apply(this, arguments);
    };
}();
var requestApplyThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/theme-template/apply-theme", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestApplyThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPassioPageProfile = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userId) {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/seller-landing/v1/public/seller-by-cps-id", {
                        params: {
                            cps_user_id: userId
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPassioPageProfile(userId) {
        return _ref.apply(this, arguments);
    };
}();
var requestReplaceThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/theme-template/load-template-data", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestReplaceThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetSelectedThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user_id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/builder/theme-template/get-selected-template", {
                        params: {
                            user_id: user_id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetSelectedThemeTemplate(user_id) {
        return _ref.apply(this, arguments);
    };
}();
var updateStore = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", gatewayAxious.post("/api/mini-store/v1/store/creator", params));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateStore(params) {
        return _ref.apply(this, arguments);
    };
}();
var saveSettingDonation = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", gatewayAxious.post("/api/mini-store/v1/catalog/setting-donation/gateway/save", params));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveSettingDonation(params) {
        return _ref.apply(this, arguments);
    };
}();
var saveSettingTOD = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", gatewayAxious.post("/api/mini-store/v1/catalog/tod/gateway/save", params));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveSettingTOD(params) {
        return _ref.apply(this, arguments);
    };
}();
var finishProductTour = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/passio-page/aff/finish-product-tour", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function finishProductTour(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var sendReportError = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/error-report", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendReportError(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var requestSearchTag = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var _per_page, per_page, keyword, is_admin, type, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _per_page = data.per_page, per_page = _per_page === void 0 ? 100 : _per_page, keyword = data.keyword, is_admin = data.is_admin, type = data.type;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/tag/search", {
                        params: {
                            keyword: keyword,
                            per_page: per_page,
                            type: type
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSearchTag(data) {
        return _ref.apply(this, arguments);
    };
}();
var createTagThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/tag", dataRequest);
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createTagThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var createManyTagThemeTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/tag/create-many", dataRequest);
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createManyTagThemeTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestSearchTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var _per_page, per_page, keyword, is_admin, block_type, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _per_page = data.per_page, per_page = _per_page === void 0 ? 100 : _per_page, keyword = data.keyword, is_admin = data.is_admin, block_type = data.block_type;
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/block-template/list", {
                        params: is_admin ? {
                            keyword: keyword,
                            per_page: per_page,
                            is_admin: is_admin,
                            block_type: block_type
                        } : {
                            keyword: keyword,
                            per_page: per_page,
                            block_type: block_type
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestSearchTemplate(data) {
        return _ref.apply(this, arguments);
    };
}();
var requestDeleteTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.delete("/api/v1/builder/block-template", {
                        params: {
                            id: id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestDeleteTemplate(id) {
        return _ref.apply(this, arguments);
    };
}();
var requestUpdateTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataRequest) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("/api/v1/builder/block-template", dataRequest);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestUpdateTemplate(dataRequest) {
        return _ref.apply(this, arguments);
    };
}();
var requestGetTemplate = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.get("/api/v1/builder/block-template/get-data", {
                        params: {
                            id: id
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestGetTemplate(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIconBuilder = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var params, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/icon-builder", {
                        params: params
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchIconBuilder() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCategoryBuilder = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var params, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return gatewayAxious.get("/api/v1/builder/icon-builder/categories", {
                        params: params
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCategoryBuilder() {
        return _ref.apply(this, arguments);
    };
}();
var getPackageOfUser = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return Axious.post("/api/auth/detail");
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPackageOfUser() {
        return _ref.apply(this, arguments);
    };
}();
var getPackageSass = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return Axious.get("/api/saas/package/list");
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPackageSass() {
        return _ref.apply(this, arguments);
    };
}();
var sendRating = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/rating-service/add", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendRating(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var sendRequestNoNeedToRating = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/site-setting/no-need-to-rating", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendRequestNoNeedToRating(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var sendRequestLogin = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestData) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return gatewayAxious.post("api/v1/builder/history", requestData);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendRequestLogin(requestData) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCreatorProfile = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.get(API_PATH.SELLER);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchCreatorProfile() {
        return _ref.apply(this, arguments);
    };
}();
var updateCreator = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.put(API_PATH.SELLER, data);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function updateCreator(data) {
        return _ref.apply(this, arguments);
    };
}();
var getListCampaign = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.get(API_PATH.GET_LIST_CAMPAIGN);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getListCampaign() {
        return _ref.apply(this, arguments);
    };
}();
var updateCampaignStatus = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.post(API_PATH.UPDATE_CAMPAIGN_STATUS, data);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function updateCampaignStatus(data) {
        return _ref.apply(this, arguments);
    };
}();
var updateCampaignImage = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.post(API_PATH.UPDATE_CAMPAIGN_IMAGE, data);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function updateCampaignImage(data) {
        return _ref.apply(this, arguments);
    };
}();
var fetchBookingProfile = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return gatewayAxious.get(API_PATH.BOOKING_FILE_SELLER);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchBookingProfile() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 32554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AntImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function AntImage(_param) {
    var src = _param.src, rest = _objectWithoutProperties(_param, [
        "src"
    ]);
    var defaultImage = "https://image.passio.eco/page-builder/page-builder/images-default/product-default.jpeg";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isError = ref[0], setIsError = ref[1];
    var imgSrc = isError ? defaultImage : src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, _objectSpread({
        src: imgSrc
    }, rest, {
        onError: function() {
            setIsError(true);
        }
    }));
};


/***/ }),

/***/ 80878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _dnd_scrollable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77345);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var AutoScrollSelector = function(props) {
    var options = props.options, value = props.value, onChange = props.onChange, elementId = props.elementId, isMulti = props.isMulti, _className = props.className, className = _className === void 0 ? null : _className, style = props.style, _isMultiple = props.isMultiple, isMultiple = _isMultiple === void 0 ? false : _isMultiple;
    var valueSelector = Array.isArray(value) ? value : [
        value
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timer = isMulti ? setTimeout(function() {
            var element = document.querySelectorAll(".adm-selector-item-active");
            if (element) {
                element[0].scrollIntoView({
                    block: "nearest",
                    inline: "center",
                    behavior: "smooth"
                });
            }
        }, 200) : null;
        var timer1 = setTimeout(function() {
            var element = document.querySelector("#".concat(elementId, " .adm-selector-item-active"));
            if (element) {
                element.scrollIntoView({
                    block: "nearest",
                    inline: "center",
                    behavior: "smooth"
                });
            }
        }, 500);
        return function() {
            isMulti ? clearTimeout(timer) : null;
            clearTimeout(timer1);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var childElementId = elementId + "-" + value;
        var element = document.getElementById(childElementId);
        if (element) {
            element.scrollIntoView({
                block: "nearest",
                inline: "center",
                behavior: "smooth"
            });
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: elementId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dnd_scrollable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("selector-scroll", className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Selector */ .Qf, {
                options: options,
                value: valueSelector,
                onChange: onChange,
                multiple: isMultiple,
                style: _objectSpread({
                    "--border": "solid transparent 1px",
                    "--checked-border": "solid var(--adm-color-primary) 1px",
                    "--checked-color": "#fff"
                }, style)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoScrollSelector);


/***/ }),

/***/ 85558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonConfirmPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13408);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31567);



function ButtonConfirmPopup(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var onConfirm = props.onConfirm, _isDisable = props.isDisable, isDisable = _isDisable === void 0 ? false : _isDisable, _title = props.title, title = _title === void 0 ? t("ss_builder_popup_confirm_button") : _title, _loading = props.loading, loading = _loading === void 0 ? false : _loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "btn-popup-confirm",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            block: true,
            color: "primary",
            style: {
                fontSize: "17px"
            },
            onClick: onConfirm,
            disabled: isDisable,
            loading: loading,
            children: title
        })
    });
};


/***/ }),

/***/ 26340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DisplayColor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11116);



function DisplayColor(param) {
    var backgroundColor = param.backgroundColor, onClickOpenColorPicker = param.onClickOpenColorPicker;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-12 h-12 rounded-[50%] cursor-pointer relative overflow-hidden",
            style: {
                backgroundColor: (0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .getGlobalColor */ .mg)(backgroundColor)
            },
            onClick: function() {
                return onClickOpenColorPicker(true);
            },
            children: [
                (0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .getOpacityFromHex */ .eq)(backgroundColor) !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[50%] h-[100%] absolute right-0 top-0",
                    style: {
                        background: "repeat #fff url(https://image.passio.eco/page-builder/page-builder/background-default/checkerboard-v2.png) "
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[50%] h-[100%] absolute right-0 top-0",
                    style: {
                        backgroundColor: backgroundColor
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[100%] h-[100%] absolute left-0 top-0 rounded-[50%]",
                    style: {
                        outline: "rgba(0, 0, 0, 0.2) solid 1px",
                        outlineOffset: "-1px"
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 28484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FieldTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function FieldTitle(param) {
    var title = param.title, _isRequire = param.isRequire, isRequire = _isRequire === void 0 ? false : _isRequire;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-[15px] text-[#666666]",
        children: [
            isRequire && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-500",
                children: "*"
            }),
            title
        ]
    });
};


/***/ }),

/***/ 60880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ DEFAULT_UPLOAD_IMG_URL; },
/* harmony export */   "Dc": function() { return /* binding */ IMAGE_UPLOAD_LAYOUTS; },
/* harmony export */   "sF": function() { return /* binding */ RESIZE; },
/* harmony export */   "uX": function() { return /* binding */ TYPE_RESIZE; }
/* harmony export */ });
/* unused harmony export DEFAULT_IMG_URL */
var IMAGE_UPLOAD_LAYOUTS = {
    LAYOUT_1: "layout-1",
    LAYOUT_2: "layout-2"
};
var RESIZE = {
    MAX_WIDTH: 512,
    MAX_HEIGHT: 512
};
var DEFAULT_IMG_URL = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
var DEFAULT_UPLOAD_IMG_URL = "https://image.passio.eco/page-builder/page-builder/images-default/image-default.png";
var TYPE_RESIZE = {
    LARG_DIMENSION: 1,
    SMALL_DIMENSION: 2,
    WIDTH: 3,
    HEIGHT: 4
};


/***/ }),

/***/ 71856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ImageUploadCommon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/share/components/ImageUploadCommon/constants.ts
var constants = __webpack_require__(60880);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 249 modules
var es = __webpack_require__(13408);
;// CONCATENATED MODULE: ./src/features/share/components/ImageUploadCommon/components/layouts/Layout1/index.tsx







var Layout1 = function(props) {
    var listImg = props.listImg, handleChangeImgs = props.handleChangeImgs, imgStatus = props.imgStatus, errorMsg = props.errorMsg, value = props.value;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-[120px_auto] gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: (value === null || value === void 0 ? void 0 : value.url) || "https://i.ecomobi.com/ssp/passio-page/image-default.png",
                        fit: "cover",
                        style: {
                            borderRadius: "8px",
                            maxWidth: "120px",
                            maxHeight: "120px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-12 leading-4",
                                children: t("ss_builder_theme_setting_background_content")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleChangeImgs,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, constants/* RESIZE.MAX_WIDTH */.sF.MAX_WIDTH);
                                },
                                className: "flex-grow",
                                value: listImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full",
                                    children: t("ss_builder_upload_button_label")
                                })
                            })
                        ]
                    })
                ]
            }),
            errorMsg[imgStatus] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1 items-center mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                        fillColor: "#FF3141",
                        className: "w-4 h-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#FF3141]",
                        children: errorMsg[imgStatus]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layouts_Layout1 = (Layout1);

;// CONCATENATED MODULE: ./src/features/share/components/ImageUploadCommon/components/layouts/Layout2/UploadImage/index.tsx





var UploadImage = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var valueUrlImage = props.valueUrlImage, imageRatio = props.imageRatio, _textHelper = props.textHelper, textHelper = _textHelper === void 0 ? "ss_builder_support_upload_image" : _textHelper, isUseBorderErr = props.isUseBorderErr, error = props.error, _hasFit = props.hasFit, hasFit = _hasFit === void 0 ? true : _hasFit;
    return valueUrlImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
        src: valueUrlImage,
        fit: hasFit ? "cover" : "contain",
        style: {
            aspectRatio: imageRatio,
            border: "1px solid #D9D9D9",
            borderRadius: "2px"
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            border: !isUseBorderErr ? " 1px solid #EEEEEE" : "1px solid ".concat(!error ? "#D9D9D9" : "#FF3141"),
            height: "200px",
            borderRadius: "2px"
        },
        className: "adm-image rounded-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    src: constants/* DEFAULT_UPLOAD_IMG_URL */.$G,
                    fit: "cover",
                    style: {
                        backgroundSize: "cover",
                        aspectRatio: imageRatio,
                        width: "150px",
                        height: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "text-center font-medium mt-5 text-[#000000] text-[15.6px] leading-[130%] mb-0.5",
                children: t("ss_builder_no_photo_has_been_selected")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center text-[13px] text-[#8C8C8C] leading-[131%]",
                children: t(textHelper)
            })
        ]
    });
};
/* harmony default export */ var Layout2_UploadImage = (UploadImage);

;// CONCATENATED MODULE: ./src/features/share/components/ImageUploadCommon/components/layouts/Layout2/index.tsx








var Layout2 = function(props) {
    var listImg = props.listImg, handleChangeImgs = props.handleChangeImgs, imgStatus = props.imgStatus, errorMsg = props.errorMsg, value = props.value, _maxWidth = props.maxWidth, maxWidth = _maxWidth === void 0 ? constants/* RESIZE.MAX_WIDTH */.sF.MAX_WIDTH : _maxWidth, _maxHeight = props.maxHeight, maxHeight = _maxHeight === void 0 ? constants/* RESIZE.MAX_HEIGHT */.sF.MAX_HEIGHT : _maxHeight, _resizeType = props.resizeType, resizeType = _resizeType === void 0 ? 1 : _resizeType, _isRequired = props.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, hasFit = props.hasFit;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleDeleteImage = function() {
        handleChangeImgs([
            {
                base64: "",
                url: "",
                file_name: ""
            }
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout2_UploadImage, {
                                    valueUrlImage: value,
                                    imageRatio: "16/9",
                                    hasFit: hasFit
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    !isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        size: "middle",
                                        color: "default",
                                        fill: "solid",
                                        style: {
                                            borderColor: "#EE3244"
                                        },
                                        disabled: value ? false : true,
                                        onClick: handleDeleteImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                            className: "w-[17px] h-[17px]",
                                            fillColor: "#EE3244"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                        onChange: handleChangeImgs,
                                        upload: function(file) {
                                            return (0,lib/* mockUpload */.Hq)(file, maxWidth, maxHeight, resizeType);
                                        },
                                        className: "flex-grow",
                                        value: listImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            color: "primary",
                                            fill: "solid",
                                            size: "middle",
                                            className: "w-full",
                                            children: t("ss_builder_upload_button_label")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            errorMsg[imgStatus] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1 items-center mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-4 h-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                            fillColor: "#FF3141",
                            className: "w-4 h-4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#FF3141]",
                        children: errorMsg[imgStatus]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layouts_Layout2 = (Layout2);

;// CONCATENATED MODULE: ./src/features/share/components/ImageUploadCommon/components/layouts/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var _obj;
var IMAGE_UPLOAD_LAYOUT_COMPONENT = (_obj = {}, _defineProperty(_obj, constants/* IMAGE_UPLOAD_LAYOUTS.LAYOUT_1 */.Dc.LAYOUT_1, layouts_Layout1), _defineProperty(_obj, constants/* IMAGE_UPLOAD_LAYOUTS.LAYOUT_2 */.Dc.LAYOUT_2, layouts_Layout2), _obj);
var Layout = function(props1) {
    var LayoutRender = (0,react.useCallback)(function(props) {
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (IMAGE_UPLOAD_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.layout_type]) {
            var RenderComponent = IMAGE_UPLOAD_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.layout_type];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, _objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutRender, _objectSpread({}, props1));
};
/* harmony default export */ var layouts = (Layout);

;// CONCATENATED MODULE: ./src/features/share/components/ImageUploadCommon/index.tsx




var IMAGE_STATUS;
(function(IMAGE_STATUS) {
    IMAGE_STATUS["INVALID_SIZE"] = "INVALID_SIZE";
    IMAGE_STATUS["INVALID_FORMAT"] = "INVALID_FORMAT";
    IMAGE_STATUS["NONE"] = "NONE";
    IMAGE_STATUS["DONE"] = "DONE";
})(IMAGE_STATUS || (IMAGE_STATUS = {}));
var ImageUploadCommon = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var value = props.value, onChange = props.onChange, layout_type = props.layout_type, label = props.label, _isRequired = props.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, maxHeight = props.maxHeight, maxWidth = props.maxWidth, resizeType = props.resizeType, defaultImg = props.defaultImg, hasFit = props.hasFit, className = props.className, onError = props.onError;
    var errorMsg = {
        INVALID_SIZE: t("ss_builder_upload_file_size_invalid_content"),
        INVALID_FORMAT: t("ss_builder_upload_file_format_invalid_content")
    };
    var ref = (0,react.useState)(IMAGE_STATUS.NONE), imgStatus = ref[0], setImgStatus = ref[1];
    var ref1 = (0,react.useState)([]), listImg = ref1[0], setListImg = ref1[1];
    var handleChangeImgs = function(imgs) {
        var lastImg = imgs && imgs[imgs.length - 1];
        var isImgFormatInvalid = lastImg === null || lastImg === void 0 ? void 0 : lastImg.isValidFormat;
        var isImgSizeInvalid = lastImg === null || lastImg === void 0 ? void 0 : lastImg.isValidSize;
        if (isImgFormatInvalid) {
            setImgStatus(IMAGE_STATUS.INVALID_FORMAT);
            onError(true);
        } else if (isImgSizeInvalid) {
            setImgStatus(IMAGE_STATUS.INVALID_SIZE);
            onError(true);
        } else {
            setImgStatus(IMAGE_STATUS.DONE);
            setListImg(imgs);
            onChange({
                base64: lastImg.dataBase64,
                url: lastImg.url,
                file_name: lastImg.fileName
            });
            onError(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-4 bg-white ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[15px] text-[#666666] pb-1 ",
                    children: [
                        isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[15px] text-[#FF3141] ml-[-7px] font-simsun",
                            children: "*"
                        }),
                        label
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts, {
                    listImg: listImg,
                    handleChangeImgs: handleChangeImgs,
                    imgStatus: imgStatus,
                    errorMsg: errorMsg,
                    value: value,
                    layout_type: layout_type,
                    maxHeight: maxHeight,
                    maxWidth: maxWidth,
                    resizeType: resizeType,
                    isRequired: isRequired,
                    defaultImg: defaultImg,
                    hasFit: hasFit,
                    className: className
                })
            ]
        })
    });
};
/* harmony default export */ var components_ImageUploadCommon = (ImageUploadCommon);


/***/ }),

/***/ 14120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PlaceholderCustomDragging = function(param) {
    var placeholderProps = param.placeholderProps, content = param.content, style = param.style, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "absolute flex justify-center items-center flex-row gap-1",
        style: _objectSpread({
            top: placeholderProps.clientY,
            left: placeholderProps.clientX,
            height: placeholderProps.clientHeight,
            width: placeholderProps.clientWidth
        }, style),
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[13px] font-medium leading-[131%]",
                children: content
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlaceholderCustomDragging);


/***/ }),

/***/ 21043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopupComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var _ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85558);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function PopupComponent(param) {
    var visible = param.visible, onMaskClick = param.onMaskClick, children = param.children, _position = param.position, position = _position === void 0 ? "bottom" : _position, _classNameBody = param.classNameBody, classNameBody = _classNameBody === void 0 ? "" : _classNameBody, _style = param.style, style = _style === void 0 ? {} : _style, _title = param.title, title = _title === void 0 ? "" : _title, _showConfirmButton = param.showConfirmButton, showConfirmButton = _showConfirmButton === void 0 ? false : _showConfirmButton, onConfirmButton = param.onConfirmButton, _confirmButtonLabel = param.confirmButtonLabel, confirmButtonLabel = _confirmButtonLabel === void 0 ? "" : _confirmButtonLabel, disabledConfirmButton = param.disabledConfirmButton, onClose = param.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Popup */ .GI, {
        visible: visible,
        onMaskClick: onMaskClick,
        position: position,
        bodyClassName: "adm-popup-body-position-bottom-panel",
        bodyStyle: {
            backgroundColor: "none"
        },
        children: visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("bg-[#fff] max-width-content-layout m-auto relative h-full max-h-screen", "".concat(classNameBody)),
            style: _objectSpread({
                borderRadius: "8px 8px 0px 0px"
            }, style),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-header",
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "popup-close",
                            onClick: function() {
                                onClose();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .ClosePopupIcon */ .Hn, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-body overflow-y-auto",
                    children: children
                }),
                showConfirmButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonConfirmPopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    onConfirm: onConfirmButton,
                    title: confirmButtonLabel,
                    isDisable: disabledConfirmButton
                })
            ]
        })
    });
};


/***/ }),

/***/ 17347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var intro_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31567);
/* harmony import */ var intro_js_introjs_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50982);
/* harmony import */ var intro_js_introjs_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(intro_js_introjs_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _share_icons_product_tour_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16525);






var ProductTourComponent = function(props) {
    var steps = props.steps, onExit = props.onExit, onBeforeExit = props.onBeforeExit, onChange = props.onChange, onComplete = props.onComplete, onBeforeChange = props.onBeforeChange, setRef = props.setRef;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    var options = {
        hideNext: false,
        hidePrev: true,
        showBullets: false,
        showStepNumbers: true,
        nextToDone: true,
        exitOnOverlayClick: false,
        exitOnEsc: false,
        stepNumbersOfLabel: "/",
        doneLabel: t("ss_builder_product_tour_done_label"),
        prevLabel: '<span class="prev-label">\n        '.concat(_share_icons_product_tour_icon__WEBPACK_IMPORTED_MODULE_5__/* .prevTourIcon */ .Uk, "\n      </span>"),
        nextLabel: '<span class="next-label"><span class="text-label-intro hidden">' + t("ss_builder_product_tour_next_label") + "</span>\n      ".concat(_share_icons_product_tour_icon__WEBPACK_IMPORTED_MODULE_5__/* .nextTourIcon */ .Wy, "\n    </span>"),
        skipLabel: t("ss_builder_product_tour_skip_label")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intro_js_react__WEBPACK_IMPORTED_MODULE_1__/* .Steps */ .Rg, {
            enabled: true,
            steps: steps,
            initialStep: 0,
            onExit: onExit,
            onBeforeExit: onBeforeExit,
            options: options,
            onChange: onChange,
            onComplete: onComplete,
            onBeforeChange: onBeforeChange,
            ref: setRef
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductTourComponent);


/***/ }),

/***/ 22143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var StickyChecking = function(param1) {
    var children = param1.children, heightStickyCondition = param1.heightStickyCondition, onCheckSticky = param1.onCheckSticky, previousStickyElementId = param1.previousStickyElementId, currentStickyElementId = param1.currentStickyElementId, stickyStyles = param1.stickyStyles;
    var stickyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSticky = ref3[0], setIsSticky = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), previousStickyElementTop1 = ref1[0], setPreviousStickyElementTop = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), previousStickyElementHeight1 = ref2[0], setPreviousStickyElementHeight = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        onCheckSticky && onCheckSticky(isSticky);
    }, [
        isSticky
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref = stickyRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), e = _param[0];
            setIsSticky(e.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        observer.observe(ref);
        return function() {
            return observer.unobserve(ref);
        };
    }, [
        stickyRef.current
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (previousStickyElementId) {
            setTimeout(function() {
                var ref, ref4, ref5;
                var previousStickyElement = document.querySelector("#".concat(previousStickyElementId));
                var previousStickyElementHeight = ((ref = previousStickyElement === null || previousStickyElement === void 0 ? void 0 : previousStickyElement.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.height) || (previousStickyElement === null || previousStickyElement === void 0 ? void 0 : previousStickyElement.clientHeight);
                var previousStickyElementTop = ((ref4 = previousStickyElement === null || previousStickyElement === void 0 ? void 0 : previousStickyElement.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.top) || parseFloat(previousStickyElement === null || previousStickyElement === void 0 ? void 0 : (ref5 = previousStickyElement.style) === null || ref5 === void 0 ? void 0 : ref5.top);
                if (previousStickyElementHeight) setPreviousStickyElementHeight(previousStickyElementHeight);
                if (previousStickyElementTop) setPreviousStickyElementTop(previousStickyElementTop);
            }, 100);
        }
    });
    var heightStickyChecking = heightStickyCondition || previousStickyElementHeight1 + previousStickyElementTop1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: stickyRef,
                className: "absolute left-0 w-1",
                style: {
                    height: "".concat(heightStickyChecking, "px"),
                    top: "-".concat(heightStickyChecking, "px")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: currentStickyElementId,
                className: "sticky z-10",
                style: _objectSpread({
                    backgroundColor: isSticky ? "white" : "",
                    boxShadow: isSticky ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "",
                    top: "".concat(heightStickyChecking, "px")
                }, stickyStyles),
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyChecking);


/***/ }),

/***/ 94261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31567);




var UploadImage = function(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var valueUrlImage = props.valueUrlImage, imageRatio = props.imageRatio, _textHelper = props.textHelper, textHelper = _textHelper === void 0 ? "ss_builder_support_upload_image" : _textHelper, isUseBorderErr = props.isUseBorderErr, error = props.error;
    return valueUrlImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
        src: valueUrlImage,
        fit: "cover",
        style: {
            backgroundSize: "cover",
            aspectRatio: imageRatio,
            border: "1px solid #D9D9D9"
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            border: !isUseBorderErr ? " 1px solid #EEEEEE" : "1px solid ".concat(!error ? "#D9D9D9" : "#FF3141"),
            height: "200px"
        },
        className: "adm-image ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "https://image.passio.eco/page-builder/page-builder/images-default/image-default.png",
                    fit: "cover",
                    style: {
                        backgroundSize: "cover",
                        aspectRatio: imageRatio,
                        // border: "1px solid #D9D9D9",
                        width: "150px",
                        height: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "flex justify-center items-center",
                style: {
                    fontWeight: "var(--heading-font-weight)",
                    fontSize: "var(--heading-font-size)",
                    fontFamily: "var(--heading-font-family)",
                    lineHeight: "var(--heading-line-height)",
                    marginTop: "20px"
                },
                children: t("ss_builder_no_photo_has_been_selected")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                style: {
                    fontWeight: "var(--paragraph-font-weight)",
                    fontSize: "var(--paragraph-font-size)",
                    fontFamily: "var(--paragraph-font-family)",
                    lineHeight: "var(--paragraph-line-height)"
                },
                children: t(textHelper)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UploadImage);


/***/ }),

/***/ 77345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DndScrollable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81431);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function DndScrollable(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), allowToScroll = ref[0], setAllowToScroll = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), startX = ref1[0], setStartX = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), scrollLeft = ref2[0], setScrollLeft = ref2[1];
    var children = props.children, className = props.className, elementRef = props.elementRef, rest = _objectWithoutProperties(props, [
        "children",
        "className",
        "elementRef"
    ]);
    var hookRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(elementRef);
    var ref3 = elementRef ? elementRef : hookRef;
    var onMouseDown = function(e) {
        setAllowToScroll(true);
        var slider = ref3.current;
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
    };
    var onMouseUp = function(e) {
        setAllowToScroll(false);
    };
    var onMouseLeave = function(e) {
        setAllowToScroll(false);
    };
    var onMouseMove = function(e) {
        if (!allowToScroll) return;
        var slider = e.currentTarget;
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        var walk = x - startX; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: ref3,
        className: "".concat(className, "\n            ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container))
    }, rest, {
        children: props.children
    }));
};


/***/ }),

/***/ 40015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreenPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55016);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function FullScreenPopup(param) {
    var visible = param.visible, onMaskClick = param.onMaskClick, children = param.children, _position = param.position, position = _position === void 0 ? "bottom" : _position, _heightPopup = param.heightPopup, heightPopup = _heightPopup === void 0 ? "100%" : _heightPopup, _popupPanel = param.popupPanel, popupPanel = _popupPanel === void 0 ? false : _popupPanel, _isLimitWidth = param.isLimitWidth, isLimitWidth = _isLimitWidth === void 0 ? true : _isLimitWidth, _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className, _heightFitContent = param.heightFitContent, heightFitContent = _heightFitContent === void 0 ? false : _heightFitContent;
    var stylePopup = style;
    if (popupPanel) {
        stylePopup = _objectSpread({}, stylePopup, {
            maxWidth: "".concat(_share_configs_const__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH_CONTENT_LAYOUT */ .t, "px"),
            borderRadius: "8px 8px 0 0"
        });
    }
    return visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Popup */ .GI, {
        visible: visible,
        onMaskClick: onMaskClick,
        position: position,
        className: popupPanel ? "".concat(className) : "".concat(className, " full-screen-popup"),
        bodyClassName: popupPanel ? "adm-popup-body-position-bottom-panel" : "full-screen-popup-body m-auto",
        bodyStyle: {
            backgroundColor: "none"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .SafeArea */ .Eq, {
                position: "top"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("full-screen-popup-content bg-[#f5f5f5] m-auto relative"),
                style: _objectSpread({
                    overflow: "overlay",
                    height: heightPopup ? heightPopup : "100%"
                }, stylePopup),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(isLimitWidth && "max-width-content-class", "w-full h-full m-auto", heightFitContent && "h-fit"),
                    children: children
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .SafeArea */ .Eq, {
                position: "bottom"
            })
        ]
    });
};


/***/ }),

/***/ 55016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ MAX_PRODUCTS_ALL_GROUPS; },
/* harmony export */   "AA": function() { return /* binding */ MAX_WIDTH_SCREEN_SIZE; },
/* harmony export */   "Aw": function() { return /* binding */ TAB_WIDTH_DISPLAY; },
/* harmony export */   "BC": function() { return /* binding */ BLOCK_TAB_MENU_DESIGN_CLASS; },
/* harmony export */   "Bx": function() { return /* binding */ LINK_STYLE_DISPLAY; },
/* harmony export */   "C0": function() { return /* binding */ SQUARE_PHOTO; },
/* harmony export */   "C5": function() { return /* binding */ ENABLE_BLOCK; },
/* harmony export */   "D5": function() { return /* binding */ STYLE_SLIDE_IMAGE; },
/* harmony export */   "EK": function() { return /* binding */ TAB_GHIM_STYLE; },
/* harmony export */   "ET": function() { return /* binding */ MAX_NUMBER_BLOCK; },
/* harmony export */   "Ei": function() { return /* binding */ LINK_TEMPLATE; },
/* harmony export */   "Ep": function() { return /* binding */ KEY_IS_LOGIN; },
/* harmony export */   "F": function() { return /* binding */ TAB_BAR_INDEX; },
/* harmony export */   "FL": function() { return /* binding */ TAB_ICON_DEFAULT; },
/* harmony export */   "FU": function() { return /* binding */ BLOCK_NOT_DISPLAY; },
/* harmony export */   "Fe": function() { return /* binding */ TAB_POSITION; },
/* harmony export */   "GR": function() { return /* binding */ FINISH_PRODUCT_TOUR; },
/* harmony export */   "Gv": function() { return /* binding */ VISIBLE_ICON; },
/* harmony export */   "HV": function() { return /* binding */ COUNTRY_ID; },
/* harmony export */   "IT": function() { return /* binding */ CARD_LAYOUTS; },
/* harmony export */   "IZ": function() { return /* binding */ LINK_TYPE_LIST; },
/* harmony export */   "Ic": function() { return /* binding */ TAB_LAYOUT; },
/* harmony export */   "JE": function() { return /* binding */ BIG; },
/* harmony export */   "JQ": function() { return /* binding */ BUILDER_IMAGE_HOST; },
/* harmony export */   "J_": function() { return /* binding */ PRODUCT_ON_ROW; },
/* harmony export */   "Jd": function() { return /* binding */ IMAGE_ORIENTATION_TYPE; },
/* harmony export */   "KO": function() { return /* binding */ STYLE_ICON_TITLE; },
/* harmony export */   "KP": function() { return /* binding */ COUNTRY_PH; },
/* harmony export */   "Kh": function() { return /* binding */ PRODUCT_MAX; },
/* harmony export */   "Ku": function() { return /* binding */ MULTI_LINK_MAX; },
/* harmony export */   "Kw": function() { return /* binding */ POSITION_MAIN_LAYOUT; },
/* harmony export */   "MC": function() { return /* binding */ DISABLE_POSITION; },
/* harmony export */   "NL": function() { return /* binding */ PASSIO_IMAGE_HOST; },
/* harmony export */   "NQ": function() { return /* binding */ SMAll; },
/* harmony export */   "NY": function() { return /* binding */ MAX_WIDTH_OUTSIDE_ON; },
/* harmony export */   "Nu": function() { return /* binding */ TAB_DISPLAY; },
/* harmony export */   "O": function() { return /* binding */ FONT_GOOGLE; },
/* harmony export */   "OX": function() { return /* binding */ BUTTON_SETTING_RADIUS_STYLE; },
/* harmony export */   "Q5": function() { return /* binding */ LINK_LAYOUTS; },
/* harmony export */   "QD": function() { return /* binding */ FONT_AVAILABLE; },
/* harmony export */   "Q_": function() { return /* binding */ STATUS; },
/* harmony export */   "Qz": function() { return /* binding */ ENABLE_POSITION; },
/* harmony export */   "R_": function() { return /* binding */ GIFT; },
/* harmony export */   "Sl": function() { return /* binding */ THEME_PREVIEW_KEY; },
/* harmony export */   "Sv": function() { return /* binding */ ICON_RENDER_URL; },
/* harmony export */   "Un": function() { return /* binding */ COUNTRY_TH; },
/* harmony export */   "V5": function() { return /* binding */ DOMAIN_RESIZE_IMG; },
/* harmony export */   "Vm": function() { return /* binding */ OLD_PASSIO_DEFAULT_ICON; },
/* harmony export */   "Vw": function() { return /* binding */ BACKGROUND_SETTING_DEFAULT_VALUE; },
/* harmony export */   "WL": function() { return /* binding */ TAB_STICKY_CLASS; },
/* harmony export */   "Wu": function() { return /* binding */ social_link_MAX; },
/* harmony export */   "Xe": function() { return /* binding */ BUTTON_SETTING_DEFAULT_VALUE; },
/* harmony export */   "Xl": function() { return /* binding */ STYLE_ICON; },
/* harmony export */   "Xv": function() { return /* binding */ SOCIAL_LINK; },
/* harmony export */   "YA": function() { return /* binding */ COUNTRY_SG; },
/* harmony export */   "aV": function() { return /* binding */ AFFILIATE_LAYOUT_MAX_HEIGHT; },
/* harmony export */   "am": function() { return /* binding */ ACTION_BLOCK; },
/* harmony export */   "ax": function() { return /* binding */ TEMPLATE_KEY; },
/* harmony export */   "bp": function() { return /* binding */ TAB_SETTING; },
/* harmony export */   "cQ": function() { return /* binding */ THEME_PREVIEW_BY_IMAGE_KEY; },
/* harmony export */   "eJ": function() { return /* binding */ BLOCK_SETTING_DEFAULT_VALUE; },
/* harmony export */   "f8": function() { return /* binding */ countryCurrencyMap; },
/* harmony export */   "fS": function() { return /* binding */ TEMPLATE_RENDER_LIST_KEY; },
/* harmony export */   "gK": function() { return /* binding */ DISABLE_BLOCK; },
/* harmony export */   "h3": function() { return /* binding */ MEDIUM_BUTTON_SETTING_DEFAULT_VALUE; },
/* harmony export */   "h4": function() { return /* binding */ TAB_TEMPLATE_LIST; },
/* harmony export */   "hB": function() { return /* binding */ INITIAL_ONBOARDING; },
/* harmony export */   "hV": function() { return /* binding */ LINK_TEMPLATE_ARR; },
/* harmony export */   "hb": function() { return /* binding */ LIST_ECOMMERCE; },
/* harmony export */   "ie": function() { return /* binding */ COUNTRY_VN; },
/* harmony export */   "if": function() { return /* binding */ BLOCK_FILTER_GROUP_TYPE; },
/* harmony export */   "jc": function() { return /* binding */ MULTI_BUTTON_LINK_ITEM_ON_ROW; },
/* harmony export */   "jj": function() { return /* binding */ SLIDE; },
/* harmony export */   "jw": function() { return /* binding */ SLIDE_STYLE; },
/* harmony export */   "kH": function() { return /* binding */ CREATOR_FOURTEEN_DEFAULT_ICON; },
/* harmony export */   "kW": function() { return /* binding */ TAB_BAR_KEY; },
/* harmony export */   "lI": function() { return /* binding */ TITLE_SETTING_DEFAULT_VALUE; },
/* harmony export */   "lN": function() { return /* binding */ POSITION_DROPPABLE_ID; },
/* harmony export */   "n7": function() { return /* binding */ COUNTRY_MY; },
/* harmony export */   "nG": function() { return /* binding */ CARD_ITEM_ON_ROW; },
/* harmony export */   "nK": function() { return /* binding */ EDITOR_BLOCK_TEXT_MAX_LENGTH; },
/* harmony export */   "ne": function() { return /* binding */ KEY_BLOCK; },
/* harmony export */   "nf": function() { return /* binding */ USER_DEVICE; },
/* harmony export */   "no": function() { return /* binding */ PARAGRAPH_SETTING_DEFAULT_VALUE; },
/* harmony export */   "oL": function() { return /* binding */ PRODUCT_URL_CHECKING; },
/* harmony export */   "px": function() { return /* binding */ DONATION; },
/* harmony export */   "q9": function() { return /* binding */ THEME_RENDER_LIST_KEY; },
/* harmony export */   "qD": function() { return /* binding */ FONT_OPTIONS; },
/* harmony export */   "qW": function() { return /* binding */ STOP_DETECTING; },
/* harmony export */   "r7": function() { return /* binding */ EDITOR_MAX_LENGTH; },
/* harmony export */   "r8": function() { return /* binding */ BUTTON_SETTING_SHADOW_STYLE; },
/* harmony export */   "s0": function() { return /* binding */ GG_FONT_URI; },
/* harmony export */   "s2": function() { return /* binding */ SMALL_BUTTON_SETTING_DEFAULT_VALUE; },
/* harmony export */   "t": function() { return /* binding */ MAX_WIDTH_CONTENT_LAYOUT; },
/* harmony export */   "tQ": function() { return /* binding */ BIG_BUTTON_SETTING_DEFAULT_VALUE; },
/* harmony export */   "tk": function() { return /* binding */ PRODUCT_MAX_DEFAULT; },
/* harmony export */   "tn": function() { return /* binding */ THEME_SETTING_BACKGROUND_TYPE; },
/* harmony export */   "u": function() { return /* binding */ LABEL_PRODUCT; },
/* harmony export */   "uG": function() { return /* binding */ PACKAGE_TYPE; },
/* harmony export */   "uT": function() { return /* binding */ BIO_DISPLAY_STYLES; },
/* harmony export */   "um": function() { return /* binding */ TAB_TEMPLATE; },
/* harmony export */   "uo": function() { return /* binding */ MIDDLE; },
/* harmony export */   "vF": function() { return /* binding */ THEME_TEMPLATE_KEY; },
/* harmony export */   "wO": function() { return /* binding */ PASSIO_DEFAULT_ICON; },
/* harmony export */   "wT": function() { return /* binding */ FINISH_ONBOARDING; },
/* harmony export */   "wi": function() { return /* binding */ CARD_STYLE; },
/* harmony export */   "xC": function() { return /* binding */ PRODUCT_GROUP_MAXIMUM; },
/* harmony export */   "xG": function() { return /* binding */ POSITION_STICKY; },
/* harmony export */   "xY": function() { return /* binding */ ROUND_PHOTO; },
/* harmony export */   "x_": function() { return /* binding */ BLOCK_TYPE_CONFIG; },
/* harmony export */   "y$": function() { return /* binding */ PRODUCT_DISPLAY_STYLES; },
/* harmony export */   "yv": function() { return /* binding */ GENERAL_SETTING_DEFAULT_VALUE; },
/* harmony export */   "yz": function() { return /* binding */ IS_DISPLAY_IMPORT_PRODUCT_FILE; },
/* harmony export */   "z0": function() { return /* binding */ TRUTH_OR_DATE; }
/* harmony export */ });
/* unused harmony exports KEY_TAB, COUNTRY_EN, IS_ONBOARDING, FILLCOLOR_DEFAULT_TAB, ENDABLE, DISABLE, MAX_WIDTH_BODY, IS_PRODUCT_TOUR, DETECT_URL_PROCESS_STATUS, PRODUCT_URL_CHECKING_STATUS, HIDE_THEME_TEMPLATE, SHOW_THEME_TEMPLATE, TEMPLATE_PREVIEW_BY_IMAGE_KEY */
/* provided dependency */ var process = __webpack_require__(83454);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PASSIO_DEFAULT_ICON = "https://i.ecomobi.com/256x256/ssp/passio-page/passio.png";
var OLD_PASSIO_DEFAULT_ICON = "https://i.ecomobi.com/128x128/ssp/passio-page/passio.png";
var CREATOR_FOURTEEN_DEFAULT_ICON = "https://i.ecomobi.com/256x256/ssp/passio-page/favicon-14.png";
var PRODUCT_MAX_DEFAULT = 12;
var PRODUCT_MAX = 400;
var MAX_PRODUCTS_ALL_GROUPS = 5000;
var PRODUCT_GROUP_MAXIMUM = 30;
var social_link_MAX = 6;
var EDITOR_MAX_LENGTH = 500;
var EDITOR_BLOCK_TEXT_MAX_LENGTH = 5000;
var BLOCK_NOT_DISPLAY = [
    "gift_footer, tod_footer, brand_gift_footer"
];
var TAB_ICON_DEFAULT = "star.svg";
var BLOCK_TYPE_CONFIG = {
    TEXT: "text",
    TAB_BAR: "tab_bar",
    TAB: "tabs"
};
var THEME_TEMPLATE_KEY = {
    SAVE_NEW: "save-new",
    OVERWRITE: "overwrite",
    EDIT: "edit"
};
var THEME_RENDER_LIST_KEY = {
    THEME_STORE: "theme-store",
    THEME_OVERWRITE_SELECTION: "theme-overwrite-selection"
};
var THEME_PREVIEW_BY_IMAGE_KEY = {
    PREVIEW: "preview",
    PREVIEW_AND_APPLY: "preview-and-apply",
    PREVIEW_AND_REPLACE: "preview-and-replace"
};
var THEME_PREVIEW_KEY = {
    PREVIEW_AND_APPLY: "preview-and-apply",
    PREVIEW_AND_APPLY_CONTENT: "preview-and-apply-content"
};
var KEY_BLOCK = {
    EDIT: "edit-block",
    ADD_NEW: "add-new-block"
};
var KEY_TAB = {
    EDIT: "edit-tab",
    ADD_NEW: "add-new-tab"
};
var ICON_RENDER_URL = "https://image.passio.eco/page-builder/icon-builder";
var THEME_SETTING_BACKGROUND_TYPE = {
    COLOR: "color",
    GRADIENT: "gradient",
    IMAGE: "image"
};
var TAB_BAR_INDEX = {
    DESIGN: 0,
    BACKGROUND: 1,
    TEMPLATE: 2,
    SETTING: 3,
    MANAGEMENT: 4
};
var TAB_BAR_KEY = {
    DESIGN: "design",
    BACKGROUND: "background",
    TEMPLATE: "theme-store",
    SETTING: "setting",
    MANAGEMENT: "management"
};
var FONT_OPTIONS = [
    {
        label: "Roboto",
        value: "Roboto"
    },
    {
        label: "Be Vietnam Pro",
        value: "Be Vietnam Pro"
    },
    {
        label: "Nunito",
        value: "Nunito"
    },
    {
        label: "Dosis",
        value: "Dosis"
    },
    {
        label: "Barlow Condensed",
        value: "Barlow Condensed"
    },
    {
        label: "Play",
        value: "Play"
    },
    {
        label: "Roboto Slab",
        value: "Roboto Slab"
    },
    {
        label: "Lora",
        value: "Lora"
    },
    {
        label: "Crimson Text",
        value: "Crimson Text"
    },
    {
        label: "Alegreya",
        value: "Alegreya"
    }, 
];
var IMAGE_ORIENTATION_TYPE = {
    PORTRAIT: "portrait",
    LANDSCAPE: "landscape"
};
var STYLE_SLIDE_IMAGE = {
    GRID: "grid",
    SLIDE: "slide",
    MASONRY: "masonry"
};
var CARD_STYLE = {
    GRID: "grid",
    SLIDE: "slide"
};
var CARD_ITEM_ON_ROW = {
    ONE: "1",
    TWO: "2",
    THREE: "3",
    FOUR: "4",
    FIVE: "5",
    SIX: "6"
};
var TAB_DISPLAY = {
    TEXT_AND_ICON: "text-and-icon",
    TEXT: "text",
    ICON: "icon"
};
var TAB_LAYOUT = {
    TEXT_RIGHT: "text-right",
    TEXT_UNDER: "text-under"
};
var TAB_GHIM_STYLE = {
    NOT_GHIM: "not-ghim",
    ALWAYS_GHIM: "always-ghim",
    AUTO_GHIM: "auto-ghim"
};
var TAB_POSITION = {
    TOP: "top",
    BOTTOM: "bottom"
};
var TAB_WIDTH_DISPLAY = {
    AUTO: "auto",
    EQUAL: "equal"
};
var SLIDE_STYLE = {
    PARTIAL_VISIBLE_RIGHT: "partial-visible-right",
    PARTIAL_VISIBLE_BOTH_SIDES: "partial-visible-both-sides",
    NOT_PARTIAL_VISIBLE: "not-partial-visible",
    POSTERS: "posters",
    PANORAMA: "panorama"
};
var CARD_LAYOUTS = {
    LAYOUT_1: "text-below-image-left",
    LAYOUT_2: "text-below-image-center",
    LAYOUT_3: "text-above-image-center",
    LAYOUT_4: "text-above-image-left",
    LAYOUT_5: "text-right",
    LAYOUT_6: "text-left",
    LAYOUT_7: "text-above-image-left-2",
    LAYOUT_8: "text-above-image-center-2"
};
var PRODUCT_DISPLAY_STYLES = {
    GRID: "grid",
    SLIDE: "slide",
    TEXT_OVER_IMAGE: "text-over-image",
    ZIGZAG: "zigzag"
};
var PRODUCT_ON_ROW = {
    ONE: "1",
    TWO: "2",
    THREE: "3"
};
var LINK_STYLE_DISPLAY = {
    TEXT_AND_ICON: "text-and-icon",
    TEXT_AND_IMAGE: "text-and-image",
    ONLY_TEXT: "only-text",
    ONLY_ICON: "only-icon",
    ONLY_IMAGE: "only-image"
};
var LINK_LAYOUTS = {
    TEXT_RIGHT: "text-right",
    TEXT_LEFT: "text-left",
    TEXT_UNDER: "text-under",
    TEXT_ZIG_ZAG: "text-zig-zag"
};
var LINK_TEMPLATE = {
    TEMPLATE1: "template1",
    TEMPLATE2: "template2",
    TEMPLATE3: "template3"
};
var LINK_TEMPLATE_ARR = [
    {
        value: LINK_TEMPLATE.TEMPLATE1,
        image: "https://image.passio.eco/page-builder/page-builder/link-template/link-template-1.png"
    },
    {
        value: LINK_TEMPLATE.TEMPLATE2,
        image: "https://image.passio.eco/page-builder/page-builder/link-template/link-template-2.png"
    },
    {
        value: LINK_TEMPLATE.TEMPLATE3,
        image: "https://image.passio.eco/page-builder/page-builder/link-template/link-template-3.png"
    }, 
];
var COUNTRY_VN = "VN";
var COUNTRY_EN = "OTHER";
var COUNTRY_ID = "ID";
var COUNTRY_SG = "SG";
var COUNTRY_PH = "PH";
var COUNTRY_MY = "MY";
var COUNTRY_TH = "TH";
var GENERAL_SETTING_DEFAULT_VALUE = {
    PRIMARY_COLOR: "#ee3244ff",
    SECONDARY_COLOR: "#0A2463ff"
};
var BLOCK_SETTING_DEFAULT_VALUE = {
    BLOCK_STYLE: "rounded",
    BORDER_RADIUS: 8,
    BORDER_WIDTH: 1,
    INNER_SPACE: true,
    INNER_SPACE_NUMBER: 12,
    OUTSIDE_SPACE: true,
    OUTSIDE_SPACE_NUMBER: 12,
    BACKGROUND_COLOR: "#FFFFFFBF",
    TAB_BACKGROUND_COLOR: "#FFFFFFFF",
    BACKGROUND_BLUR: 0,
    BORDER_ENABLE: false,
    BORDER_COLOR: "#FFFFFFBF",
    BORDER_STYLE: "solid",
    SHADOW_ENABLE: false,
    SHADOW_COLOR: "#00000040",
    BLOCK_SPACE: 12
};
var BACKGROUND_SETTING_DEFAULT_VALUE = {
    BACKGROUND_TYPE: "solid",
    IMAGE: null,
    BLUR: 0,
    OVERLAY_ENABLE: false,
    OVERLAY_COLOR: "#00000066",
    COLOR_SOLID: "#f5f5f5ff",
    COLOR_GRADIENT_GENERATOR_FIRST_COLOR: "#f9a8d4ff",
    COLOR_GRADIENT_GENERATOR_SECOND_COLOR: "#a5b4fcff",
    COLOR_GRADIENT_INTENSITY: 300,
    COLOR_GRADIENT_DIRECTION: "to bottom"
};
var FONT_GOOGLE = 2;
var FONT_AVAILABLE = 1;
var TITLE_SETTING_DEFAULT_VALUE = {
    FONT_FAMILY: "roboto",
    FONT_COLOR: "#333333ff",
    FONT_SIZE: 13,
    FONT_SCALE: "1.200",
    FONT_WEIGHT: 500,
    LINE_HEIGHT: 1.3,
    USING_FONT_CUSTOM: FONT_AVAILABLE,
    FONT_FAMILY_CUSTOM: "Roboto"
};
var PARAGRAPH_SETTING_DEFAULT_VALUE = {
    FONT_FAMILY: "Roboto",
    FONT_COLOR: "#333333ff",
    FONT_SIZE: 13,
    FONT_SCALE: "1.200",
    FONT_WEIGHT: 400,
    LINE_HEIGHT: 1.5,
    USING_FONT_CUSTOM: FONT_AVAILABLE,
    FONT_FAMILY_CUSTOM: "Roboto"
};
var BUTTON_SETTING_SHADOW_STYLE = {
    NO_SHADOW: "no_shadow",
    SOFT_SHADOW: "soft_shadow",
    HARD_SHADOW: "hard_shadow"
};
var BUTTON_SETTING_DEFAULT_VALUE = {
    ENABLE_BORDER: true,
    BORDER_COLOR: "#EE3244ff",
    BACKGROUND_COLOR: "#EE3244ff",
    TEXT_COLOR: "#FFFFFFff",
    BORDER_WIDTH: 1,
    RADIUS_TYPE: "rounded",
    RADIUS_VALUE: 8,
    SHADOW_TYPE: BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW,
    SOFT_SHADOW_COLOR: "#00000026",
    HARD_SHADOW_COLOR: "#000000"
};
var BIG_BUTTON_SETTING_DEFAULT_VALUE = {
    FONT_SIZE: 18,
    LINE_HEIGHT: 1.4,
    FONT_WEIGHT: 500
};
var MEDIUM_BUTTON_SETTING_DEFAULT_VALUE = {
    FONT_SIZE: 17,
    LINE_HEIGHT: 1.4,
    FONT_WEIGHT: 400
};
var SMALL_BUTTON_SETTING_DEFAULT_VALUE = {
    FONT_SIZE: 15,
    LINE_HEIGHT: 1.4,
    FONT_WEIGHT: 400
};
var BUTTON_SETTING_RADIUS_STYLE = {
    SQUARE: "square",
    ROUNDED: "rounded",
    CUSTOM: "custom"
};
var IS_ONBOARDING = 2;
var FINISH_ONBOARDING = 1;
var INITIAL_ONBOARDING = 0;
var BIO_DISPLAY_STYLES = {
    STYLE1: "style-1",
    STYLE2: "style-2",
    STYLE3: "style-3",
    STYLE4: "style-4",
    STYLE5: "style-5",
    STYLE6: "style-6",
    STYLE7: "style-7"
};
var ACTION_BLOCK = {
    VISIBLE_BLOCK: "eye-visible-block",
    MOVE_UP_BLOCK: "move-up-block",
    MOVE_DOWN_BLOCK: "move-down-block",
    EDIT_BLOCK: "edit-block",
    MOVE_BLOCK: "move-block",
    DELETE_BLOCK: "delete-block",
    // CREATE_NEW_TEMPLATE:"create-new-template",
    HANDLE_TEMPLATE: "handle-template",
    UPLOAD_AFFILIATE_PRODUCT: "upload-affiliate-product",
    IMPORT_SITE_URL: "import-site-url"
};
var ENABLE_BLOCK = 1;
var DISABLE_BLOCK = 2;
var STATUS;
(function(STATUS) {
    STATUS[STATUS["ENABLE"] = 1] = "ENABLE";
    STATUS[STATUS["DISABLE"] = 2] = "DISABLE";
})(STATUS || (STATUS = {}));
var POSITION_MAIN_LAYOUT = {
    HEADER: "header",
    BODY: "body",
    FOOTER: "footer",
    EXPAND: "expand"
};
var MAX_NUMBER_BLOCK = {
    HEADER: 4,
    BODY: 10,
    FOOTER: 4,
    EXPAND: 5
};
var FILLCOLOR_DEFAULT_TAB = "#ee3244";
var ENDABLE = 1;
var DISABLE = 2;
var BUILDER_IMAGE_HOST = process.env.BUILDER_IMAGE_HOST || "https://passio-prod.s3-ap-southeast-1.amazonaws.com";
var PASSIO_IMAGE_HOST = process.env.PASSIO_IMAGE_HOST || "https://image.passio.eco";
var MULTI_BUTTON_LINK_ITEM_ON_ROW = {
    ONE: "1",
    TWO: "2",
    THREE: "3",
    FOUR: "4",
    FIVE: "5",
    SIX: "6"
};
var MULTI_LINK_MAX = 30;
var BLOCK_TAB_MENU_DESIGN_CLASS = "block-tab-menu-design";
var MAX_WIDTH_OUTSIDE_ON = 476;
var MAX_WIDTH_BODY = "500px";
var TAB_TEMPLATE = {
    TEMPLATE_1: "template_1",
    TEMPLATE_2: "template_2"
};
var TAB_TEMPLATE_LIST = [
    {
        value: TAB_TEMPLATE.TEMPLATE_1,
        image: "https://image.passio.eco/page-builder/page-builder/tab-template/tab_template_1.svg"
    },
    {
        value: TAB_TEMPLATE.TEMPLATE_2,
        image: "https://image.passio.eco/page-builder/page-builder/tab-template/tab_template_2.svg"
    }, 
];
var TAB_SETTING = {
    SHADOW_ENABLE: false,
    SHADOW_COLOR: "#00000026"
};
var IS_PRODUCT_TOUR = 2;
var FINISH_PRODUCT_TOUR = 1;
var ENABLE_POSITION = 1;
var DISABLE_POSITION = 0;
var BLOCK_FILTER_GROUP_TYPE = {
    ALL: "all",
    BASIC: "basic",
    ADVANCED: "advanced",
    MONETIZATION: "monetization",
    HIGHLIGHT: "highlight"
};
var MAX_WIDTH_CONTENT_LAYOUT = 500;
var LINK_TYPE_LIST = {
    WEB: "web",
    PHONE: "phone",
    EMAIL: "email",
    SERVICE: "service"
};
var SOCIAL_LINK = {
    FACEBOOK: "facebook",
    MESSENGER: "messenger",
    INSTAGRAM: "instagram",
    LINKEDIN: "linkedin",
    PINTEREST: "pinterest",
    SNAPCHAT: "snapchat",
    LINECHAT: "linechat",
    TIKTOK: "tiktok",
    TWITCH: "twitch",
    TWITTER: "twitter",
    WHATSAPP: "whatsapp",
    YOUTUBE: "youtube",
    DISCORD: "discord",
    BEHANCE: "behance",
    DRIBBLE: "dribble",
    EMAIL: "email",
    TEL: "tel",
    LEMON8: "lemon8",
    OTHER: "other"
};
var LIST_ECOMMERCE = [
    "shopee",
    "lazada",
    "tiki",
    "youtube",
    "tiktok"
];
var PRODUCT_URL_CHECKING = {
    INVALID: "invalid",
    DUPLICATE: "duplicate",
    NOT_ADDED_YET: "not_added_yet",
    SUCCESS: "success",
    MISSING_REQUIRED: "missing_required"
};
var STOP_DETECTING = "stop-detecting";
var DETECT_URL_PROCESS_STATUS;
(function(DETECT_URL_PROCESS_STATUS) {
    DETECT_URL_PROCESS_STATUS["STOP_DETECTING"] = "stop-detecting";
    DETECT_URL_PROCESS_STATUS["CONTINUE"] = "continue";
})(DETECT_URL_PROCESS_STATUS || (DETECT_URL_PROCESS_STATUS = {}));
var PRODUCT_URL_CHECKING_STATUS;
(function(PRODUCT_URL_CHECKING_STATUS) {
    PRODUCT_URL_CHECKING_STATUS["INVALID"] = "invalid";
    PRODUCT_URL_CHECKING_STATUS["DUPLICATE"] = "duplicate";
    PRODUCT_URL_CHECKING_STATUS["DUPLICATE_PRODUCT"] = "duplicate_product";
    PRODUCT_URL_CHECKING_STATUS["SINGLE_URL_DUPLICATE_PRODUCT"] = "single_dup";
    PRODUCT_URL_CHECKING_STATUS["NOT_ADDED_YET"] = "not_added_yet";
    PRODUCT_URL_CHECKING_STATUS["SUCCESS"] = "success";
    PRODUCT_URL_CHECKING_STATUS["MAXIMUM_OR_NOT_EXIST_GROUP"] = "maximum_or_not_exist_group";
})(PRODUCT_URL_CHECKING_STATUS || (PRODUCT_URL_CHECKING_STATUS = {}));
var _obj;
var countryCurrencyMap = (_obj = {}, _defineProperty(_obj, COUNTRY_VN, "VND"), _defineProperty(_obj, COUNTRY_ID, "IDR"), _defineProperty(_obj, COUNTRY_PH, "PHP"), _defineProperty(_obj, COUNTRY_TH, "THB"), _defineProperty(_obj, COUNTRY_SG, "SGD"), _defineProperty(_obj, COUNTRY_MY, "MYR"), _defineProperty(_obj, COUNTRY_EN, "OTH"), _obj);
var DONATION = "donation";
var GIFT = "gift";
var TRUTH_OR_DATE = "tod";
var LABEL_PRODUCT = {
    HOT: "hot",
    SALE: "sale",
    FAVOURITE: "favourite"
};
var AFFILIATE_LAYOUT_MAX_HEIGHT = 1260;
var HIDE_THEME_TEMPLATE = "hide";
var SHOW_THEME_TEMPLATE = "show";
var POSITION_STICKY = "sticky";
var TAB_STICKY_CLASS = "tab-sticky";
var POSITION_DROPPABLE_ID = {
    HEADER: "designs-header",
    BODY: "designs-body",
    FOOTER: "designs-footer",
    EXPAND_POPUP: "expand-popup",
    EXPAND_FLOATING_ICONS: "expand-floating-icons",
    ADD_NEW_BLOCK_BUTTON_DRAGGING: "add-new-block-button-dragging"
};
var DOMAIN_RESIZE_IMG = "https://image.passio.eco/passio-prod";
var ROUND_PHOTO = 1;
var SQUARE_PHOTO = 2;
var SMAll = "small";
var MIDDLE = "middle";
var BIG = "big";
var TEMPLATE_KEY = {
    SAVE_NEW: "save-new",
    OVERWRITE: "overwrite",
    EDIT: "edit"
};
var TEMPLATE_PREVIEW_BY_IMAGE_KEY = {
    PREVIEW: "preview"
};
var TEMPLATE_RENDER_LIST_KEY = {
    TEMPLATE_LIST: "template-list",
    TEMPLATE_OVERWRITE_SELECTION: "template-overwrite-selection",
    TEMPLATE_APPLY: "template-apply"
};
var STYLE_ICON = {
    LINE: "line",
    SOLID: "solid"
};
var STYLE_ICON_TITLE = {
    LINE: "Line",
    SOLID: "Solid"
};
var VISIBLE_ICON = {
    SHOW: "show",
    HIDE: "hide"
};
var PACKAGE_TYPE = {
    PREMIUM: 1,
    FREE: 2
};
var KEY_IS_LOGIN = "is_login";
var USER_DEVICE = {
    DESKTOP: "desktop",
    TABLET: "tablet",
    MOBILE: "mobile"
};
var MAX_WIDTH_SCREEN_SIZE = {
    MOBILE: 480,
    DESKTOP: 768
};
var SLIDE = "slide";
var IS_DISPLAY_IMPORT_PRODUCT_FILE = 1;
var GG_FONT_URI = "https://fonts.googleapis.com/css";


/***/ }),

/***/ 40229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_L": function() { return /* binding */ AUTH_PAGE; },
/* harmony export */   "p5": function() { return /* binding */ ONBOARDING_PAGE; },
/* harmony export */   "s6": function() { return /* binding */ HOME_PAGE; }
/* harmony export */ });
/* harmony import */ var _share_configs_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(935);

var AUTH_PAGE = {
    register: "".concat(_share_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .PASSIO_HOME_PAGE */ .n4, "/register"),
    login: "".concat(_share_configs_system__WEBPACK_IMPORTED_MODULE_0__/* .PASSIO_HOME_PAGE */ .n4, "/login?redirect-to-page=passio-page")
};
var ONBOARDING_PAGE = {
    onboarding: "/onboarding"
};
var HOME_PAGE = "/";


/***/ }),

/***/ 18109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ dataService; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/config.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
/**
 * The global configuration object for RxJS, used to configure things
 * like what Promise contructor should used to create Promises
 */
var config = {
    /**
     * The promise constructor used by default for methods such as
     * {@link toPromise} and {@link forEach}
     */
    Promise: undefined,
    /**
     * If true, turns on synchronous error rethrowing, which is a deprecated behavior
     * in v6 and higher. This behavior enables bad patterns like wrapping a subscribe
     * call in a try/catch block. It also enables producer interference, a nasty bug
     * where a multicast can be broken for all observers by a downstream consumer with
     * an unhandled error. DO NOT USE THIS FLAG UNLESS IT'S NEEDED TO BY TIME
     * FOR MIGRATION REASONS.
     */
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/hostReportError.js
/**
 * Throws an error on another job so that it's picked up by the runtime's
 * uncaught error handling mechanism.
 * @param err the error to throw
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; });
}
//# sourceMappingURL=hostReportError.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Observer.js
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (config.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            hostReportError(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isObject.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x != null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/errorObject.js
// typeof any so that it we don't have to cast when comparing a result to the error object
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/tryCatch.js
/** PURE_IMPORTS_START _errorObject PURE_IMPORTS_END */

var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject.e = e;
        return errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
//# sourceMappingURL=tryCatch.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        var _this = _super.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '') || this;
        _this.errors = errors;
        _this.name = 'UnsubscriptionError';
        Object.setPrototypeOf(_this, UnsubscriptionError.prototype);
        return _this;
    }
    return UnsubscriptionError;
}(Error));

//# sourceMappingURL=UnsubscriptionError.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_tryCatch,_util_errorObject,_util_UnsubscriptionError PURE_IMPORTS_END */






/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = /*@__PURE__*/ (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        /** @internal */
        this._parent = null;
        /** @internal */
        this._parents = null;
        /** @internal */
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction(_unsubscribe)) {
            var trial = tryCatch(_unsubscribe).call(this);
            if (trial === errorObject) {
                hasErrors = true;
                errors = errors || (errorObject.e instanceof UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject.e.errors) : [errorObject.e]);
            }
        }
        if (isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject(sub)) {
                    var trial = tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject.e;
                        if (err instanceof UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    /** @internal */
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    /** @nocollapse */
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? /*@__PURE__*/ Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
var $$rxSubscriber = (/* unused pure expression or super */ null && (rxSubscriber));
//# sourceMappingURL=rxSubscriber.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        /** @internal */ _this.syncErrorValue = null;
        /** @internal */ _this.syncErrorThrown = false;
        /** @internal */ _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): For situations where Node has multiple copies of rxjs in
                    // node_modules, we cannot rely on `instanceof` checks
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[rxSubscriber]();
                        _this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        _this.destination = trustedSubscriber;
                        trustedSubscriber.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     * @nocollapse
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription));

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== empty) {
                context = Object.create(observerOrNext);
                if (isFunction(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!config.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                hostReportError(err);
                return true;
            }
        }
        return false;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber]);
}
//# sourceMappingURL=Subscriber.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/toSubscriber.js
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber]) {
            return nextOrObserver[rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber(empty);
    }
    return new Subscriber(nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
/** Symbol.observable or a string "@@observable". Used for interop */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
/* tslint:disable:no-empty */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
/** PURE_IMPORTS_START _util_toSubscriber,_internal_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */




/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = /*@__PURE__*/ (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        /** Internal implementation detail, do not use directly. */
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (config.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [promiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     * @nocollapse
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

/**
 * Decides between a passed promise constructor from consuming code,
 * A default configured promise constructor, and the native promise
 * constructor and returns it. If nothing can be found, it will throw
 * an error.
 * @param promiseCtor The optional promise constructor to passed by consuming code
 */
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = config.Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var _this = _super.call(this, 'object unsubscribed') || this;
        _this.name = 'ObjectUnsubscribedError';
        Object.setPrototypeOf(_this, ObjectUnsubscribedError.prototype);
        return _this;
    }
    return ObjectUnsubscribedError;
}(Error));

//# sourceMappingURL=ObjectUnsubscribedError.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/SubjectSubscription.js
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription));

//# sourceMappingURL=SubjectSubscription.js.map

;// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(Subscriber));

/**
 * @class Subject<T>
 */
var Subject = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    /**@nocollapse */
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));

/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    tslib_es6/* __extends */.ZT(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map

;// CONCATENATED MODULE: ./src/features/share/configs/rxjs.ts

var subject = new Subject();
var dataService = {
    publish: function(data) {
        return subject.next(data);
    },
    getObservable: function() {
        return subject.asObservable();
    }
};


/***/ }),

/***/ 935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ ENVIRONMENT; },
/* harmony export */   "JE": function() { return /* binding */ KEY_TOKEN; },
/* harmony export */   "n4": function() { return /* binding */ PASSIO_HOME_PAGE; },
/* harmony export */   "sL": function() { return /* binding */ KEY_GATEWAY_TOKEN; },
/* harmony export */   "sQ": function() { return /* binding */ PASSIO_MAIN_DOMAIN; }
/* harmony export */ });
/* unused harmony export HOME_PAGE_SSP */
/* provided dependency */ var process = __webpack_require__(83454);
var HOME_PAGE_SSP = process.env.NEXT_PUBLIC_HOME_PAGE_SSP || "https://ssp.ecomobi.com";
var PASSIO_HOME_PAGE = "https://account.passio.eco" || 0;
var KEY_TOKEN = "passio_access_token" || 0;
var KEY_GATEWAY_TOKEN = "passio_gw_access_token" || 0;
var PASSIO_MAIN_DOMAIN = "passio.eco" || 0;
var ENVIRONMENT = "production" || 0;


/***/ }),

/***/ 52741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ openInNewBrowser; },
/* harmony export */   "v": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var openInNewBrowser = function(url) {
    var castWindow = window;
    if (castWindow.flutter_inappwebview !== undefined) {
        var _flutter_inappwebview;
        var args = [
            {
                url: url
            }
        ];
        (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
            "openInBrowser"
        ].concat(_toConsumableArray(args)));
    } else {
        window.open(url);
    }
};
var copyToClipboard = function(value) {
    var castWindow = window;
    var args2 = [
        {
            text: value
        }
    ];
    if (castWindow.flutter_inappwebview !== undefined) {
        var _flutter_inappwebview;
        (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
            "copyToClipboard"
        ].concat(_toConsumableArray(args2)));
    } else {
        navigator.clipboard.writeText(value);
    }
};


/***/ }),

/***/ 79704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getHorizontalResizeUrl; }
/* harmony export */ });
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55016);

var getHorizontalResizeUrl = function(url) {
    var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 140;
    if (url.startsWith(_share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .BUILDER_IMAGE_HOST */ .JQ) && url.indexOf("passio-prod/builder") !== -1) {
        return url.replace(_share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .BUILDER_IMAGE_HOST */ .JQ, _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .PASSIO_IMAGE_HOST */ .NL).replace("passio-prod/builder", "passio-prod/".concat(width, "/builder"));
    } else {
        return url;
    }
};


/***/ }),

/***/ 98390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; }
/* harmony export */ });
/* unused harmony exports isClient, isLocal, isDevelopment, isStaging, isProduction */
function isClient() {
    return "object" !== "undefined";
}
function isLocal() {
    return "production" === "local";
}
function isDevelopment() {
    return "production" === "dev";
}
function isStaging() {
    return "production" === "staging";
}
function isProduction() {
    return "production" === "prod";
}
function logError(e) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    console.log(e, "//" + path);
}


/***/ }),

/***/ 52893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ isValidQueryString; },
/* harmony export */   "as": function() { return /* binding */ extractAttrFromString; },
/* harmony export */   "iO": function() { return /* binding */ checkDirtyCodeIframe; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lq": function() { return /* binding */ checkOpenNewTab; },
/* harmony export */   "qx": function() { return /* binding */ checkImageUrl; },
/* harmony export */   "vV": function() { return /* binding */ isValidEmail; },
/* harmony export */   "xT": function() { return /* binding */ isPhoneNumber; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55016);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48966);
/* harmony import */ var validator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(validator__WEBPACK_IMPORTED_MODULE_2__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function isPhoneNumber(value) {
    var regex = RegExp("^(((\\(\\+?[0-9]{1,3}\\))|(\\+[0-9]{1,3}))?[0-9\\-\\.\\s]{3,14})(?<!.*?(\\s|\\-|\\.){2,}.*)$");
    return regex.test(value);
}
function isValidEmail(email) {
    var regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return regex.test(email);
}
function isValidUrl(url) {
    try {
        return validator__WEBPACK_IMPORTED_MODULE_2___default().isURL(url);
    } catch (e) {
        return false;
    }
}
function isValidQueryString(query) {
    var regex = /^([\w-]+(=[\w@ .,-]*)?(&[\w-]+(=[\w@ .,-]*)?)*)?$/;
    return regex.test(query);
}
function checkOpenNewTab(ecommerceOrSocial) {
    var host = ecommerceOrSocial === null || ecommerceOrSocial === void 0 ? void 0 : ecommerceOrSocial.host;
    var regexEcommerce = /(^([0-9a-z-]+.)?(shopee|lazada|tiki).[a-z]+(.[a-z]+)?$)/i;
    var regexSocialNetwork = /^http(s)?:\/\/([0-9a-z-]+\.)?((facebook|messenger|instagram|linkedin|pinterest|snapchat|line|tiktok|twitch|twitter|whatsapp|youtube|discord|behance|dribbble|telegram|skype|zalo|viber|wechat|discord|tumblr|quora|reddit|medium|weibo|ask)\.([a-z]{2,16})|(t\.me|youtu\.be|m\.me|wa\.me))/i;
    var check = _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .LIST_ECOMMERCE.some */ .hb.some(function(item) {
        return host.includes(item);
    });
    var regexForService = /^http(s)?:\/\/([0-9a-z-])+(\.dev)?\.passio\.eco\/[0-9a-z-]+/i;
    var regexShoppe = /https?:\/\/(www\.)?(shopee\.(com|vn|ph|co\.th|co\.id|sg|com\.my)|shope\.ee|shp\.ee)/i;
    var regexTiki = /https?:\/\/(www\.)?(ti\.ki|tiki\.vn)/i;
    var regexLazada = /https?:\/\/(www\.|s\.|c\.)?lazada\.(com|vn|com\.ph|co\.th|co\.id|sg|com\.my)/i;
    return regexEcommerce.test(host) || regexSocialNetwork.test(ecommerceOrSocial) || regexForService.test(ecommerceOrSocial) || check || regexShoppe.test(ecommerceOrSocial) || regexTiki.test(ecommerceOrSocial) || regexLazada.test(ecommerceOrSocial);
}
var extractAttrFromString = function(embedString) {
    var ref2, ref1;
    var extractAttrsRgx = RegExp(/(?:[a-z]+=("(.*?)"|([0-9]+))|src=(.+?)(?:\s|>|\/>)|[a-z]+)/, "ig");
    var arr = (ref2 = embedString === null || embedString === void 0 ? void 0 : embedString.trim()) === null || ref2 === void 0 ? void 0 : ref2.match(extractAttrsRgx);
    var listAttrs = arr && ((ref1 = arr === null || arr === void 0 ? void 0 : arr.filter(function(e) {
        return e !== "iframe";
    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
        var ref;
        return (ref = e === null || e === void 0 ? void 0 : e.replaceAll('"', "")) === null || ref === void 0 ? void 0 : ref.split("=");
    }));
    return listAttrs;
};
var checkDirtyCodeIframe = function(embedString) {
    var isValid = false;
    var embedTransformed = embedString === null || embedString === void 0 ? void 0 : embedString.trim();
    var validateSrcAttr = function(src) {
        return /^https?:\/\/[^<>]+$/i.test(src);
    };
    var validateWidthOrHeightAttr = function(value) {
        return /^[0-9]{1,3}%|[0-9]+$/i.test(value);
    };
    var validateStyleAttr = function(style) {
        return /^[0-9a-z\s\#\+\-\*\/%:;\(\)"'_&\.,]*$/i.test(style);
    };
    var validateTitleAttr = function(title) {
        return true;
    };
    var validateAllowAttr = function(allow) {
        return /^[0-9a-z\s-;']*$/i.test(allow);
    };
    var validateAllowfullscreenAttr = function(allowfullscreen) {
        if (!!allowfullscreen) {
            return /^(0|1|true|false|yes|no|)$/i.test(allowfullscreen);
        }
        return true;
    };
    var validateFrameBorderAttr = function(frameBorder) {
        return /^(0|1|true|false|yes|no)$/i.test(frameBorder);
    };
    var validateScrollingAttr = function(scrolling) {
        return /^(auto|0|1|true|false|yes|no)$/i.test(scrolling);
    };
    var validateLoadingAttr = function(loading) {
        return /^(eager|lazy)$/i.test(loading);
    };
    var validateClassAttr = function(cls) {
        return /^[0-9a-z\s-_]*$/i.test(cls);
    };
    var validateIdAttr = function(id) {
        return /^[0-9a-z\s-_]*$/i.test(id);
    };
    var groupFuncCheckAttr = {
        id: validateIdAttr,
        class: validateClassAttr,
        src: validateSrcAttr,
        width: validateWidthOrHeightAttr,
        height: validateWidthOrHeightAttr,
        style: validateStyleAttr,
        title: validateTitleAttr,
        allow: validateAllowAttr,
        allowfullscreen: validateAllowfullscreenAttr,
        frameborder: validateFrameBorderAttr,
        scrolling: validateScrollingAttr,
        loading: validateLoadingAttr
    };
    var isSingleIframe = /^\s*<iframe\s[^<>]*?(?:title=".*?")?[^<>]*?(?:\/>|>\s*<\/iframe>)\s*$/i.test(embedTransformed);
    if (isSingleIframe) {
        var ref3;
        var listAcceptAttr = Object.keys(groupFuncCheckAttr);
        var listAttrs = extractAttrFromString(embedTransformed);
        var notRequiredHaveValueFields = [
            "allowfullscreen"
        ];
        //Kiểm tra các thuộc tính phải có dạng [attribute]=value, ngoại trừ các trường không bắt buộc ở array bên trên
        var isRequiredHaveValue = (ref3 = listAttrs === null || listAttrs === void 0 ? void 0 : listAttrs.filter(function(attr) {
            var ref;
            return !(notRequiredHaveValueFields === null || notRequiredHaveValueFields === void 0 ? void 0 : notRequiredHaveValueFields.includes((ref = attr[0]) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()));
        })) === null || ref3 === void 0 ? void 0 : ref3.every(function(attr) {
            return attr[1] !== undefined && attr[1] !== null;
        });
        //Kiểm tra các thuộc tính đều nằm trong list các thuộc tính cho phép và giá trị của chúng thỏa mãn điều kiện tương ứng
        var isAcceptAttrAll = listAttrs.every(function(attr) {
            var ref, ref5, ref6;
            return listAcceptAttr.includes((ref = attr[0]) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) && groupFuncCheckAttr[(ref5 = attr[0]) === null || ref5 === void 0 ? void 0 : ref5.toLocaleLowerCase()]((ref6 = attr[1]) === null || ref6 === void 0 ? void 0 : ref6.toLocaleLowerCase());
        });
        isValid = isRequiredHaveValue && isAcceptAttrAll;
    }
    return isValid;
};
var checkImageUrl = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return new Promise(function(resolve) {
                        var img = new Image();
                        img.onload = function() {
                            resolve(true);
                        };
                        img.onerror = function() {
                            resolve(false);
                        };
                        img.src = url;
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkImageUrl(url) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 16565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ usePopup; },
/* harmony export */   "iU": function() { return /* binding */ useDetectdevice; },
/* harmony export */   "pM": function() { return /* binding */ useResizeObserveElement; }
/* harmony export */ });
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55016);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51206);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var resize_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30215);




var usePopup = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref[0], setVisible = ref[1];
    var openPopup = function() {
        return setVisible(true);
    };
    var closePopup = function() {
        return setVisible(false);
    };
    return {
        visible: visible,
        openPopup: openPopup,
        closePopup: closePopup
    };
};
var useDetectdevice = function() {
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), isDevice = ref4[0], setIsDevice = ref4[1];
    var handleResize = function() {
        setIsDevice(detectScreenSize(window.innerWidth));
    };
    var detectScreenSize = function(windowWidth) {
        var ref, ref1, ref2, ref3;
        var detectWidthDevice = "";
        var userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
        if ((ref = bowser__WEBPACK_IMPORTED_MODULE_1___default().parse(userAgent)) === null || ref === void 0 ? void 0 : (ref1 = ref.platform) === null || ref1 === void 0 ? void 0 : ref1.type) return (ref2 = bowser__WEBPACK_IMPORTED_MODULE_1___default().parse(userAgent)) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.platform) === null || ref3 === void 0 ? void 0 : ref3.type;
        // if library not detect device
        if (windowWidth <= _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .MAX_WIDTH_SCREEN_SIZE.MOBILE */ .AA.MOBILE) {
            detectWidthDevice = _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .USER_DEVICE.MOBILE */ .nf.MOBILE;
        } else if (windowWidth > _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .MAX_WIDTH_SCREEN_SIZE.DESKTOP */ .AA.DESKTOP) {
            detectWidthDevice = _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .USER_DEVICE.DESKTOP */ .nf.DESKTOP;
        } else {
            detectWidthDevice = _share_configs_const__WEBPACK_IMPORTED_MODULE_0__/* .USER_DEVICE.TABLET */ .nf.TABLET;
        }
        return detectWidthDevice;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect)(function() {
        setIsDevice(detectScreenSize(window.innerWidth));
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return isDevice;
};
var useResizeObserveElement = function(ref) {
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), height = ref5[0], setHeight = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), width = ref6[0], setWidth = ref6[1];
    if (true) {
        (0,resize_observer__WEBPACK_IMPORTED_MODULE_3__/* .install */ .N9)();
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current)) return;
        var resizeObserver = new ResizeObserver(function() {
            var _$ref, _$ref1;
            if (ref === null || ref === void 0 ? void 0 : (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.offsetHeight) setHeight(ref.current.offsetHeight);
            if (ref === null || ref === void 0 ? void 0 : (_$ref1 = ref.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.offsetWidth) setWidth(ref.current.offsetWidth);
        });
        resizeObserver.observe(ref === null || ref === void 0 ? void 0 : ref.current);
        return function() {
            return resizeObserver.disconnect();
        }; // clean up
    }, []);
    return {
        width: width,
        height: height
    };
};


/***/ }),

/***/ 5996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dd": function() { return /* binding */ useModal; },
/* harmony export */   "vi": function() { return /* binding */ ModalIconConfig; }
/* harmony export */ });
/* unused harmony export ICON_RENDER */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64035);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31567);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var ModalIconConfig;
(function(ModalIconConfig) {
    ModalIconConfig["INFO_PRIMARY_CIRCLE"] = "info-primary-circle";
    ModalIconConfig["INFO_WARNING_CIRCLE"] = "info-warning-circle";
    ModalIconConfig["INFO_PRIMARY_TRIANGLE"] = "info-primary-triangle";
    ModalIconConfig["INFO_WARNING_TRIANGLE"] = "info-warning-triangle";
    ModalIconConfig["ERROR_PRIMARY_CIRCLE"] = "error-primary-circle";
})(ModalIconConfig || (ModalIconConfig = {}));
var _obj;
var ICON_RENDER = (_obj = {}, _defineProperty(_obj, ModalIconConfig.INFO_PRIMARY_CIRCLE, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationIcon */ .Yk, {
    className: "w-12 h-12",
    fillColor: "#EE3244"
})), _defineProperty(_obj, ModalIconConfig.INFO_WARNING_CIRCLE, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationIcon */ .Yk, {
    className: "w-12 h-12",
    fillColor: "#FF8F1F"
})), _defineProperty(_obj, ModalIconConfig.INFO_PRIMARY_TRIANGLE, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationTriangleIcon */ .Lm, {
    className: "w-12 h-12",
    fillColor: "#EE3244"
})), _defineProperty(_obj, ModalIconConfig.INFO_WARNING_TRIANGLE, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationTriangleIcon */ .Lm, {
    className: "w-12 h-12",
    fillColor: "#FF8F1F"
})), _defineProperty(_obj, ModalIconConfig.ERROR_PRIMARY_CIRCLE, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .CloseCircleIconV2 */ .GD, {
    width: 48,
    height: 48,
    fillColor: "#FF3141"
})), _obj);
var useModal = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    //Error Modal
    var ErrorModal = function(param) {
        var title = param.title, image = param.image, _icon = param.icon, icon = _icon === void 0 ? ModalIconConfig.INFO_WARNING_TRIANGLE : _icon, description = param.description, confirmText = param.confirmText, className = param.className, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {
            return null;
        } : _onClose;
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Modal.show */ .u_.show({
            className: "modal-error-class ".concat(className),
            image: image,
            header: ICON_RENDER[icon],
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col text-center items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-lg font-bold leading-[25px]",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: description
                    })
                ]
            }),
            closeOnAction: true,
            actions: [
                {
                    key: "confirm",
                    text: confirmText
                }, 
            ],
            onClose: onClose
        });
    };
    //Confirm Modal
    var ConfirmModal = function(param) {
        var title = param.title, _icon = param.icon, icon = _icon === void 0 ? ModalIconConfig.INFO_WARNING_TRIANGLE : _icon, image = param.image, className = param.className, description = param.description, confirmText = param.confirmText, _cancelText = param.cancelText, cancelText = _cancelText === void 0 ? t("ss_builder_cancel") : _cancelText, onConfirm = param.onConfirm, _onCancel = param.onCancel, onCancel = _onCancel === void 0 ? function() {
            return;
        } : _onCancel;
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Modal.confirm */ .u_.confirm({
            image: image,
            header: ICON_RENDER[icon],
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: title
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: description
            }),
            className: className,
            confirmText: confirmText,
            cancelText: cancelText,
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    };
    //Alert Modal
    var AlertModal = function(param) {
        var title = param.title, image = param.image, icon = param.icon, description = param.description, confirmText = param.confirmText, className = param.className, onConfirm = param.onConfirm;
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Modal.alert */ .u_.alert({
            image: image,
            title: title,
            header: ICON_RENDER[icon] || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            className: className,
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: description
            }),
            confirmText: confirmText,
            onConfirm: onConfirm
        });
    };
    //Alert Modal
    var ContentCustomModal = function(param) {
        var title = param.title, image = param.image, icon = param.icon, content = param.content, confirmText = param.confirmText, className = param.className, onConfirm = param.onConfirm;
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Modal.alert */ .u_.alert({
            image: image,
            title: title,
            header: ICON_RENDER[icon] || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            className: className,
            content: content,
            confirmText: confirmText,
            onConfirm: onConfirm
        });
    };
    return {
        ErrorModal: ErrorModal,
        ConfirmModal: ConfirmModal,
        AlertModal: AlertModal,
        ContentCustomModal: ContentCustomModal
    };
};


/***/ }),

/***/ 95880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13408);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64035);




var useToast = function() {
    var SuccessToast = function(label) {
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .CheckCircleIcon */ .rE, {
                className: "text-center inline-block",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: label
            })
        });
    };
    var FailedToast = function(label) {
        return antd_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Toast.show */ .FN.show({
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .ExclamationTriangleIcon */ .LP, {
                className: "text-center inline-block",
                fillColor: "var(--adm-color-warning)",
                width: 24,
                height: 24
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: label
            })
        });
    };
    return {
        SuccessToast: SuccessToast,
        FailedToast: FailedToast
    };
};


/***/ }),

/***/ 65679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ IconBrandRating; },
/* harmony export */   "GS": function() { return /* binding */ ImagePopupIcon; },
/* harmony export */   "HF": function() { return /* binding */ TextIconColor; },
/* harmony export */   "Lr": function() { return /* binding */ SpotLightIconColor; },
/* harmony export */   "Nv": function() { return /* binding */ DigitalProducticonV2; },
/* harmony export */   "Qy": function() { return /* binding */ AffiliateIconV2; },
/* harmony export */   "T0": function() { return /* binding */ IconBrandGift; },
/* harmony export */   "Vf": function() { return /* binding */ CardIconColor; },
/* harmony export */   "ZR": function() { return /* binding */ TruthOrDareIcon; },
/* harmony export */   "e_": function() { return /* binding */ MultiLinksIconColor; },
/* harmony export */   "jN": function() { return /* binding */ ButtonLinkIconColor; },
/* harmony export */   "kM": function() { return /* binding */ BioIconColor; },
/* harmony export */   "mQ": function() { return /* binding */ ImageGalleryIconColor; },
/* harmony export */   "mc": function() { return /* binding */ BookingProfileBlockIcon; },
/* harmony export */   "o2": function() { return /* binding */ CombinedBlockIcon; },
/* harmony export */   "o9": function() { return /* binding */ ImageIconColor; },
/* harmony export */   "ox": function() { return /* binding */ SpacerAndDividerIcon; },
/* harmony export */   "qN": function() { return /* binding */ IconDonation; },
/* harmony export */   "rG": function() { return /* binding */ ImageSliderIconColor; },
/* harmony export */   "uR": function() { return /* binding */ GiftIconV2; },
/* harmony export */   "xC": function() { return /* binding */ EmbedIconColor; }
/* harmony export */ });
/* unused harmony exports AffiliateIcon, GiftIcon, DigitalProductIcon, BioIcon, IconVideoShoutout */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var ButtonLinkIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384139)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#0A72FB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384139)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M25.224 30.1158L20.3278 35.012C20.3278 35.012 20.3278 35.0122 20.3277 35.0122C20.3277 35.0122 20.3277 35.0123 20.3276 35.0123C18.3029 37.0371 15.0082 37.0372 12.9833 35.0123C12.0023 34.0313 11.4622 32.7271 11.4622 31.34C11.4622 29.9531 12.0023 28.6491 12.9829 27.6681C12.9831 27.668 12.9832 27.6679 12.9833 27.6678L17.8794 22.7715C18.5554 22.0954 18.5554 20.9993 17.8793 20.3234C17.2034 19.6474 16.1072 19.6474 15.4312 20.3234L10.535 25.2196C10.5347 25.22 10.5343 25.2204 10.534 25.2208C8.89995 26.8554 8 29.0286 8 31.34C8 33.652 8.90029 35.8256 10.5352 37.4604C12.2226 39.1478 14.439 39.9915 16.6555 39.9915C18.8721 39.9915 21.0886 39.1478 22.7758 37.4604V37.4603C22.7759 37.4603 22.7759 37.4602 22.7759 37.4602L27.6721 32.5639C28.348 31.888 28.348 30.7918 27.672 30.1158C26.9961 29.4398 25.9001 29.4398 25.224 30.1158Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M39.9998 16.6514C39.9998 14.3394 39.0994 12.1659 37.4645 10.531C34.0897 7.15627 28.5985 7.15639 25.2239 10.531C25.2237 10.5312 25.2235 10.5314 25.2234 10.5316L20.3274 15.4275C19.6513 16.1034 19.6513 17.1997 20.3274 17.8756C20.6655 18.2138 21.1084 18.3827 21.5515 18.3827C21.9944 18.3827 22.4376 18.2137 22.7755 17.8756L27.6715 12.9797C27.6716 12.9795 27.6719 12.9794 27.6721 12.9791C29.6968 10.9544 32.9915 10.9543 35.0164 12.9791C35.9972 13.9601 36.5376 15.2643 36.5376 16.6514C36.5376 18.0384 35.9975 19.3424 35.0167 20.3233C35.0166 20.3234 35.0165 20.3235 35.0164 20.3237L30.1202 25.2199C29.4443 25.8959 29.4443 26.992 30.1203 27.6681C30.4584 28.0061 30.9014 28.1752 31.3444 28.1752C31.7874 28.1752 32.2305 28.0061 32.5685 27.6681L37.4646 22.7718C37.465 22.7714 37.4653 22.771 37.4657 22.7706C39.0997 21.136 39.9998 18.9628 39.9998 16.6514Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M17.8796 30.1158C18.2176 30.4538 18.6607 30.6229 19.1036 30.6229C19.5467 30.6229 19.9897 30.4538 20.3277 30.1158L30.1203 20.3233C30.7963 19.6473 30.7963 18.5512 30.1203 17.8751C29.4443 17.1992 28.3482 17.1992 27.6721 17.8751L17.8796 27.6675C17.2035 28.3437 17.2035 29.4398 17.8796 30.1158Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384139",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384139"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384139",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384139"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384139",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0392157 0 0 0 0 0.447059 0 0 0 0 0.984314 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384139"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384139",
                                result: "effect3_innerShadow_31008_384139"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ImageIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384171)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#FC7B03"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter1_dii_31008_384171)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M36.3825 9H11.6193C9.6232 9 8 10.6227 8 12.6211V35.38C8 37.3761 9.6232 38.9971 11.6193 38.9971H36.3824C38.3785 38.9971 40 37.3761 40 35.38V12.6211C40.0001 10.6227 38.3786 9 36.3825 9ZM28.6929 14.3853C30.6232 14.3853 32.1887 15.9508 32.1887 17.881C32.1887 19.8112 30.6231 21.3768 28.6929 21.3768C26.762 21.3768 25.1971 19.8112 25.1971 17.881C25.1971 15.9508 26.762 14.3853 28.6929 14.3853ZM35.2475 35.6515H13.2531C12.2876 35.6515 11.8576 34.9529 12.2929 34.0912L18.2922 22.2083C18.7269 21.3466 19.5554 21.2697 20.1421 22.0364L26.1747 29.92C26.7614 30.6868 27.7869 30.752 28.4656 30.065L29.9414 28.5706C30.6196 27.8836 31.6188 27.9687 32.1723 28.7593L35.9938 34.2181C36.5462 35.0099 36.213 35.6515 35.2475 35.6515Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384171",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384171"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384171",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384171"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384171",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384171"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384171",
                                result: "effect3_innerShadow_31008_384171"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var TextIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384199)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#6452FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter1_dii_31008_384199)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M34 8H14.6667C12.644 8 11 9.644 11 11.6667V36.3333C11 38.356 12.644 40 14.6667 40H34C36.0227 40 37.6667 38.356 37.6667 36.3333V11.6667C37.6667 9.644 36.0227 8 34 8ZM15 19.6667C15 19.1147 15.448 18.6667 16 18.6667H23.3333C23.8853 18.6667 24.3333 19.1147 24.3333 19.6667V21C24.3333 21.552 23.8853 22 23.3333 22C22.7813 22 22.3333 21.552 22.3333 21C22.3333 20.8159 22.1841 20.6667 22 20.6667H21.5C21.0398 20.6667 20.6667 21.0398 20.6667 21.5V25C20.6667 25.5523 21.2093 25.9953 21.5082 26.4598C21.6085 26.6156 21.6667 26.801 21.6667 27C21.6667 27.552 21.2187 28 20.6667 28H18.6667C18.1147 28 17.6667 27.552 17.6667 27C17.6667 26.801 17.7249 26.6156 17.8252 26.4598C18.1241 25.9953 18.6667 25.5523 18.6667 25V21.5C18.6667 21.0398 18.2936 20.6667 17.8333 20.6667H17.3333C17.1492 20.6667 17 20.8159 17 21C17 21.552 16.552 22 16 22C15.448 22 15 21.552 15 21V19.6667ZM32.6667 36H16C15.448 36 15 35.552 15 35C15 34.448 15.448 34 16 34H32.6667C33.2187 34 33.6667 34.448 33.6667 35C33.6667 35.552 33.2187 36 32.6667 36ZM32.6667 32H16C15.448 32 15 31.552 15 31C15 30.448 15.448 30 16 30H32.6667C33.2187 30 33.6667 30.448 33.6667 31C33.6667 31.552 33.2187 32 32.6667 32ZM32.6667 28H28C27.448 28 27 27.552 27 27C27 26.448 27.448 26 28 26H32.6667C33.2187 26 33.6667 26.448 33.6667 27C33.6667 27.552 33.2187 28 32.6667 28ZM32.6667 24.3333H28C27.448 24.3333 27 23.8853 27 23.3333C27 22.7813 27.448 22.3333 28 22.3333H32.6667C33.2187 22.3333 33.6667 22.7813 33.6667 23.3333C33.6667 23.8853 33.2187 24.3333 32.6667 24.3333ZM32.6667 20.6667H28C27.448 20.6667 27 20.2187 27 19.6667C27 19.1147 27.448 18.6667 28 18.6667H32.6667C33.2187 18.6667 33.6667 19.1147 33.6667 19.6667C33.6667 20.2187 33.2187 20.6667 32.6667 20.6667Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384199",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384199"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384199",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384199"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384199",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.439216 0 0 0 0 0.372549 0 0 0 0 1 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384199"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384199",
                                result: "effect3_innerShadow_31008_384199"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var BioIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384236)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#12AD56"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384236)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18.9966 23.6548C20.4175 24.6926 22.1721 25.2981 24.0625 25.2981C28.686 25.2981 32.7115 21.296 32.7115 16.649C32.7115 11.8797 28.8318 8 24.0625 8C19.2932 8 15.4135 11.8797 15.4135 16.649C15.4135 19.5279 16.822 22.0856 18.9966 23.6548Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M31.6737 24.7421C29.6844 26.6201 27.0032 27.7692 24.0625 27.7692C21.1218 27.7692 18.4406 26.6201 16.4513 24.7421C11.4225 27.4603 8 32.7857 8 38.8894C8 39.569 8.55601 40.125 9.23558 40.125H38.8894C39.569 40.125 40.125 39.569 40.125 38.8894C40.125 32.7857 36.7024 27.4603 31.6737 24.7421Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384236",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384236"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384236",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384236"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384236",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384236"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384236",
                                result: "effect3_innerShadow_31008_384236"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var SpotLightIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384264)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#FAB500"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384264)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M33.8775 18.6043L28.5944 17.8365L26.2318 13.0486C25.3196 11.1997 22.6807 11.199 21.7681 13.0485L19.4054 17.8365L14.1224 18.6043C12.0824 18.9007 11.2664 21.4104 12.743 22.8502L16.5659 26.5771L15.6635 31.8396C15.315 33.8715 17.4491 35.4233 19.2747 34.4637L23.9999 31.979L28.7253 34.4637C30.553 35.4246 32.6841 33.867 32.3363 31.8396L31.4339 26.5771L35.2568 22.8502C36.7329 21.4109 35.9183 18.9009 33.8775 18.6043Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M16.4206 12.1958L15.145 10.4398C14.7986 9.96321 14.1316 9.8575 13.6551 10.2039C13.1785 10.5502 13.0729 11.2173 13.4191 11.694L14.6948 13.45C15.0413 13.9268 15.7085 14.0322 16.1847 13.6859C16.6613 13.3397 16.7669 12.6724 16.4206 12.1958Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.1873 27.933C12.0052 27.3727 11.4036 27.0658 10.8432 27.2481L8.73729 27.9325C8.17704 28.1145 7.87048 28.7164 8.05248 29.2768C8.23485 29.8382 8.83773 30.1435 9.39654 29.9617L11.5025 29.2773C12.0628 29.0953 12.3694 28.4934 12.1873 27.933Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M34.3449 10.2039C33.8684 9.8575 33.2013 9.96314 32.855 10.4398L31.5793 12.1958C31.233 12.6724 31.3387 13.3397 31.8153 13.6859C32.292 14.0323 32.959 13.9265 33.3052 13.45L34.5809 11.694C34.9272 11.2173 34.8215 10.5502 34.3449 10.2039Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M39.2627 27.9325L37.1567 27.2481C36.5964 27.0657 35.9947 27.3727 35.8126 27.933C35.6306 28.4933 35.9371 29.0952 36.4974 29.2773L38.6034 29.9617C39.1626 30.1436 39.7652 29.8379 39.9475 29.2768C40.1295 28.7164 39.8229 28.1146 39.2627 27.9325Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M24 36.2029C23.4109 36.2029 22.9334 36.6805 22.9334 37.2697V39.4349C22.9334 40.0241 23.4109 40.5017 24 40.5017C24.589 40.5017 25.0666 40.0241 25.0666 39.4349V37.2697C25.0667 36.6805 24.5891 36.2029 24 36.2029Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384264",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384264"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384264",
                        x: "6.76",
                        y: "8.13",
                        width: "34.605",
                        height: "34.9899",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384264"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384264",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 0.764706 0 0 0 0 0.141176 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384264"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384264",
                                result: "effect3_innerShadow_31008_384264"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ImageSliderIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_36939_305395)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#FC7B03"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_36939_305395)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M9 10.5263C9 9.13107 10.1311 8 11.5263 8H36.7895C38.1847 8 39.3158 9.13107 39.3158 10.5263V30.7368C39.3158 32.132 38.1847 33.2632 36.7895 33.2632H11.5263C10.1311 33.2632 9 32.132 9 30.7368V10.5263ZM22.4737 14.7368C22.4737 16.5972 20.9656 18.1053 19.1053 18.1053C17.2449 18.1053 15.7368 16.5972 15.7368 14.7368C15.7368 12.8765 17.2449 11.3684 19.1053 11.3684C20.9656 11.3684 22.4737 12.8765 22.4737 14.7368ZM33.54 29.8947H14.7707C14.1788 29.8947 13.8468 29.2749 14.1933 28.8303L19.3223 23.3721C19.5965 23.0892 20.0729 23.0892 20.3616 23.3587L22.7147 25.8526L27.132 19.4108C27.4352 19.0066 28.0703 19.0201 28.3445 19.4378L34.1752 28.8842C34.4349 29.3423 34.0885 29.8947 33.54 29.8947Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M17.421 40.3684C18.3512 40.3684 19.1052 39.6144 19.1052 38.6842C19.1052 37.754 18.3512 37 17.421 37C16.4909 37 15.7368 37.754 15.7368 38.6842C15.7368 39.6144 16.4909 40.3684 17.421 40.3684Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M25.8421 38.6842C25.8421 39.6144 25.088 40.3684 24.1578 40.3684C23.2277 40.3684 22.4736 39.6144 22.4736 38.6842C22.4736 37.754 23.2277 37 24.1578 37C25.088 37 25.8421 37.754 25.8421 38.6842Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M30.8951 40.3684C31.8253 40.3684 32.5794 39.6144 32.5794 38.6842C32.5794 37.754 31.8253 37 30.8951 37C29.965 37 29.2109 37.754 29.2109 38.6842C29.2109 39.6144 29.965 40.3684 30.8951 40.3684Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_36939_305395",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_36939_305395"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_36939_305395",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "35.2284",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_36939_305395"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_36939_305395",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_36939_305395"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_36939_305395",
                                result: "effect3_innerShadow_36939_305395"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var MultiLinksIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384329)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#345ECA"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384329)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14.67 19.0638C13.4954 20.2384 11.2783 22.4556 10.2746 23.4592C8.8188 24.9151 8 26.8914 8 28.9516C8 31.0118 8.8188 32.9881 10.2746 34.4455C10.6397 34.809 11.0095 35.1788 11.3731 35.5439C12.8305 36.9997 14.8068 37.8185 16.867 37.8185C18.9272 37.8185 20.9035 36.9997 22.3593 35.5439L26.7547 31.1485C27.3607 30.5426 27.3607 29.5575 26.7547 28.9516C26.1488 28.3456 25.1637 28.3456 24.5578 28.9516C23.3832 30.1262 21.1661 32.3433 20.1624 33.347C19.2892 34.2202 18.1037 34.7111 16.867 34.7111C15.6302 34.7111 14.4447 34.2202 13.5716 33.347C13.2064 32.9819 12.8367 32.6121 12.4715 32.247C11.5984 31.3738 11.1074 30.1883 11.1074 28.9516C11.1074 27.7148 11.5984 26.5294 12.4715 25.6562L16.867 21.2608C17.4729 20.6548 17.4729 19.6698 16.867 19.0638C16.261 18.4579 15.276 18.4579 14.67 19.0638Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M31.1485 26.7547C32.3231 25.5801 34.5402 23.363 35.5439 22.3593C36.9997 20.9035 37.8185 18.9272 37.8185 16.867C37.8185 14.8068 36.9997 12.8305 35.5439 11.3731C35.1788 11.0095 34.809 10.6397 34.4455 10.2746C32.9881 8.8188 31.0118 8 28.9516 8C26.8914 8 24.9151 8.8188 23.4592 10.2746C22.4556 11.2783 20.2384 13.4954 19.0638 14.67C18.4579 15.276 18.4579 16.261 19.0638 16.867C19.6698 17.4729 20.6548 17.4729 21.2608 16.867C22.4354 15.6924 24.6525 13.4752 25.6562 12.4715C26.5294 11.5984 27.7148 11.1074 28.9516 11.1074C30.1883 11.1074 31.3738 11.5984 32.247 12.4715C32.6121 12.8367 32.9819 13.2064 33.347 13.5716C34.2202 14.4447 34.7111 15.6302 34.7111 16.867C34.7111 18.1037 34.2202 19.2892 33.347 20.1624C32.3433 21.1661 30.1262 23.3832 28.9516 24.5578C28.3456 25.1637 28.3456 26.1488 28.9516 26.7547C29.5575 27.3607 30.5426 27.3607 31.1485 26.7547Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18.5157 29.5015L29.5019 18.5152C30.1079 17.9078 30.1079 16.9243 29.5019 16.3168C28.8945 15.7108 27.911 15.7108 27.3035 16.3168L16.3173 27.303C15.7113 27.9105 15.7113 28.894 16.3173 29.5015C16.9247 30.1074 17.9082 30.1074 18.5157 29.5015Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M33.0099 30.6777L33.0068 38.4462C33.0068 39.3039 33.7029 39.9999 34.5605 39.9999C35.4182 39.9999 36.1142 39.3039 36.1142 38.4462L36.1173 30.6777C36.1173 29.8201 35.4213 29.124 34.5636 29.124C33.706 29.124 33.0099 29.8201 33.0099 30.6777Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M30.6777 36.1142L38.4462 36.1173C39.3039 36.1173 39.9999 35.4213 39.9999 34.5636C39.9999 33.706 39.3039 33.0099 38.4462 33.0099L30.6777 33.0068C29.8201 33.0068 29.124 33.7029 29.124 34.5605C29.124 35.4182 29.8201 36.1142 30.6777 36.1142Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384329",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384329"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384329",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384329"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384329",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.792157 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384329"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384329",
                                result: "effect3_innerShadow_31008_384329"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CardIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384402)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#6452FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384402)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M38.7636 8H9.7109C9.02809 8 8.47461 8.47755 8.47461 9.06667V27.2C8.47461 27.7891 9.02809 28.2666 9.7109 28.2666H38.7636C39.4464 28.2666 39.9999 27.7891 39.9999 27.2V9.06667C39.9999 8.47755 39.4464 8 38.7636 8Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.58736 34.5333H28.3788C29.0616 34.5333 29.6151 33.8617 29.6151 33.0333C29.6151 32.2048 29.0616 31.5333 28.3788 31.5333H9.58736C8.90456 31.5333 8.35107 32.2048 8.35107 33.0333C8.35107 33.8617 8.90456 34.5333 9.58736 34.5333Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M38.2691 36.8667H9.58736C8.90456 36.8667 8.35107 37.5382 8.35107 38.3667C8.35107 39.1952 8.90456 39.8667 9.58736 39.8667H38.2691C38.952 39.8667 39.5054 39.1952 39.5054 38.3667C39.5054 37.5382 38.952 36.8667 38.2691 36.8667Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384402",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384402"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384402",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384402"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384402",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.462745 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384402"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384402",
                                result: "effect3_innerShadow_31008_384402"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EmbedIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384430)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#1D59F4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384430)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M40 8H8V16.0122C8.06062 16.0042 8.12276 16 8.18605 16H39.814C39.8772 16 39.9394 16.0042 40 16.0122V8ZM27.1163 13.9534C27.7328 13.9534 28.2326 13.4537 28.2326 12.8372C28.2326 12.2207 27.7328 11.7209 27.1163 11.7209C26.4998 11.7209 26 12.2207 26 12.8372C26 13.4537 26.4998 13.9534 27.1163 13.9534ZM32.3258 12.8372C32.3258 13.4537 31.826 13.9534 31.2095 13.9534C30.593 13.9534 30.0933 13.4537 30.0933 12.8372C30.0933 12.2207 30.593 11.7209 31.2095 11.7209C31.826 11.7209 32.3258 12.2207 32.3258 12.8372ZM35.3023 13.9534C35.9188 13.9534 36.4186 13.4537 36.4186 12.8372C36.4186 12.2207 35.9188 11.7209 35.3023 11.7209C34.6858 11.7209 34.186 12.2207 34.186 12.8372C34.186 13.4537 34.6858 13.9534 35.3023 13.9534Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M40 17.9878C39.9394 17.9958 39.8772 18 39.814 18H8.18605C8.12276 18 8.06062 17.9958 8 17.9878V40H40V17.9878ZM21.1541 33.7263L24.7262 23.01C24.9212 22.4251 25.5537 22.1095 26.1387 22.303C26.7236 22.498 27.0391 23.1306 26.8456 23.7155L23.2735 34.4318C23.0786 35.0167 22.446 35.3322 21.8611 35.1387C21.2761 34.9438 20.9606 34.3112 21.1541 33.7263ZM27.8251 25.9376L30.6069 28.7209L27.8251 31.5042C27.389 31.9388 27.389 32.6472 27.8251 33.0818C28.2597 33.5179 28.9682 33.5179 29.4028 33.0818L32.9749 29.5097C33.411 29.0736 33.411 28.3682 32.9749 27.9321L29.4028 24.36C28.9682 23.9239 28.2597 23.9239 27.8251 24.36C27.389 24.7946 27.389 25.503 27.8251 25.9376ZM15.0253 27.9321L18.5974 24.36C19.032 23.9239 19.7405 23.9239 20.1751 24.36C20.6112 24.7946 20.6112 25.503 20.1751 25.9376L17.3933 28.7209L20.1751 31.5042C20.6112 31.9388 20.6112 32.6472 20.1751 33.0818C19.7405 33.5179 19.032 33.5179 18.5974 33.0818L15.0253 29.5097C14.5892 29.0736 14.5892 28.3682 15.0253 27.9321Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384430",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384430"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384430",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384430"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384430",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.792157 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384430"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384430",
                                result: "effect3_innerShadow_31008_384430"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ImageGalleryIconColor = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_31008_384496)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#FC7B03"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_31008_384496)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.7893 8H11.7893C9.929 8 8.4209 9.5081 8.4209 11.3684C8.4209 13.2288 9.92899 14.7369 11.7893 14.7369H19.7893C21.6496 14.7369 23.1577 13.2288 23.1577 11.3684C23.1577 9.5081 21.6496 8 19.7893 8Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.1577 16.4211H12.4209C10.2118 16.4211 8.4209 18.2119 8.4209 20.4211V36C8.4209 38.2091 10.2118 40 12.4209 40H19.1577C21.3669 40 23.1577 38.2091 23.1577 36V20.4211C23.1577 18.2119 21.3669 16.4211 19.1577 16.4211Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M35.5789 24.8421H28.842C26.6329 24.8421 24.842 26.633 24.842 28.8421V36.0001C24.842 38.2092 26.6329 40.0001 28.842 40.0001H35.5789C37.788 40.0001 39.5789 38.2092 39.5789 36.0001V28.8421C39.5789 26.633 37.788 24.8421 35.5789 24.8421Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M35.5789 8H28.842C26.6329 8 24.842 9.79086 24.842 12V19.1579C24.842 21.3671 26.6334 23.1579 28.8425 23.1579H35.5784C37.7875 23.1579 39.5789 21.3671 39.5789 19.1579V12C39.5789 9.79086 37.788 8 35.5789 8Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_31008_384496",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_31008_384496"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_31008_384496",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_31008_384496"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_31008_384496",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_31008_384496"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_31008_384496",
                                result: "effect3_innerShadow_31008_384496"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ImagePopupIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_29757_346560)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#FC7B03"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_29757_346560)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M27.9909 11.7429H11.3091C9.48407 11.7429 8 13.2264 8 15.0536V35.8617C8 37.6867 9.48407 39.1687 11.3091 39.1687H33.9497C35.7746 39.1687 37.2571 37.6867 37.2571 35.8617V21.0091C36.3018 21.5141 35.2129 21.8 34.0571 21.8C30.27 21.8 27.2 18.73 27.2 14.9429C27.2 13.7871 27.4859 12.6982 27.9909 11.7429ZM32.912 36.1099H12.8028C11.9201 36.1099 11.527 35.4713 11.9249 34.6833L17.4101 23.819C17.8075 23.0312 18.5649 22.9609 19.1014 23.6618L24.6169 30.8697C25.1533 31.5708 26.0909 31.6304 26.7114 31.0023L28.0607 29.636C28.6807 29.0079 29.5943 29.0857 30.1004 29.8085L33.5943 34.7994C34.0994 35.5234 33.7947 36.1099 32.912 36.1099Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M34.0571 20.8857C37.3393 20.8857 40 18.225 40 14.9429C40 11.6607 37.3393 9 34.0571 9C30.775 9 28.1143 11.6607 28.1143 14.9429C28.1143 18.225 30.775 20.8857 34.0571 20.8857ZM36.5716 13.8C36.9503 13.4213 36.9503 12.8073 36.5716 12.4286C36.1929 12.0499 35.5788 12.0499 35.2001 12.4286L34.0573 13.5714L32.9144 12.4286C32.5357 12.0499 31.9217 12.0499 31.543 12.4286C31.1643 12.8073 31.1643 13.4213 31.543 13.8L32.6858 14.9429L31.543 16.0857C31.1643 16.4645 31.1643 17.0785 31.543 17.4572C31.9217 17.8359 32.5357 17.8359 32.9144 17.4572L34.0573 16.3143L35.2002 17.4572C35.5789 17.8359 36.1929 17.8359 36.5716 17.4572C36.9503 17.0785 36.9503 16.4645 36.5716 16.0858L35.4287 14.9429L36.5716 13.8Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_29757_346560",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_29757_346560"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_29757_346560",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_29757_346560"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_29757_346560",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_29757_346560"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_29757_346560",
                                result: "effect3_innerShadow_29757_346560"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AffiliateIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14 11H10C9.46957 11 8.96086 10.7893 8.58579 10.4142C8.21071 10.0391 8 9.53043 8 9C8 8.46957 8.21071 7.96086 8.58579 7.58579C8.96086 7.21071 9.46957 7 10 7H15C15.2652 7 15.5196 7.10536 15.7071 7.29289C15.8946 7.48043 16 7.73478 16 8C16 8.26522 16.1054 8.51957 16.2929 8.70711C16.4804 8.89464 16.7348 9 17 9C17.2652 9 17.5196 8.89464 17.7071 8.70711C17.8946 8.51957 18 8.26522 18 8C18 7.20435 17.6839 6.44129 17.1213 5.87868C16.5587 5.31607 15.7956 5 15 5H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V5H10C8.93913 5 7.92172 5.42143 7.17157 6.17157C6.42143 6.92172 6 7.93913 6 9C6 10.0609 6.42143 11.0783 7.17157 11.8284C7.92172 12.5786 8.93913 13 10 13H14C14.5304 13 15.0391 13.2107 15.4142 13.5858C15.7893 13.9609 16 14.4696 16 15C16 15.5304 15.7893 16.0391 15.4142 16.4142C15.0391 16.7893 14.5304 17 14 17H9C8.73478 17 8.48043 16.8946 8.29289 16.7071C8.10536 16.5196 8 16.2652 8 16C8 15.7348 7.89464 15.4804 7.70711 15.2929C7.51957 15.1054 7.26522 15 7 15C6.73478 15 6.48043 15.1054 6.29289 15.2929C6.10536 15.4804 6 15.7348 6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19H11V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19H14C15.0609 19 16.0783 18.5786 16.8284 17.8284C17.5786 17.0783 18 16.0609 18 15C18 13.9391 17.5786 12.9217 16.8284 12.1716C16.0783 11.4214 15.0609 11 14 11Z",
            fill: fillColor
        })
    });
};
var AffiliateIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6_74650)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter0_i_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "#5117B5"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter1_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.759 15.9024C18.649 16.0929 18.4053 16.1582 18.2148 16.0482L11.8008 12.3451C11.6102 12.2351 11.5449 11.9914 11.6549 11.8008C11.7649 11.6102 12.0086 11.5449 12.1992 11.655L18.6132 15.3581C18.8038 15.4681 18.8691 15.7118 18.759 15.9024Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter2_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M14.0201 4.46128C14.2327 4.51823 14.3588 4.73671 14.3019 4.94926L12.385 12.1031C12.328 12.3157 12.1095 12.4418 11.897 12.3849C11.6844 12.3279 11.5583 12.1095 11.6153 11.8969L13.5321 4.74302C13.5891 4.53046 13.8076 4.40432 14.0201 4.46128Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter3_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M6.4812 6.48126C6.6368 6.32566 6.88908 6.32566 7.04468 6.48126L12.2817 11.7183C12.4373 11.8739 12.4373 12.1261 12.2817 12.2817C12.1261 12.4373 11.8738 12.4373 11.7182 12.2817L6.4812 7.04474C6.3256 6.88914 6.3256 6.63686 6.4812 6.48126Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter4_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M9.97989 19.5387C9.76733 19.4818 9.64119 19.2633 9.69815 19.0507L11.615 11.8969C11.672 11.6843 11.8905 11.5582 12.103 11.6151C12.3156 11.6721 12.4417 11.8905 12.3847 12.1031L10.4679 19.257C10.4109 19.4695 10.1924 19.5957 9.97989 19.5387Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter5_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.19531 12C4.19531 11.7799 4.3737 11.6016 4.59375 11.6016L12 11.6016C12.2201 11.6016 12.3984 11.7799 12.3984 12C12.3984 12.2201 12.2201 12.3984 12 12.3984L4.59375 12.3984C4.3737 12.3984 4.19531 12.2201 4.19531 12Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter6_dii_6_74650)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.0001 17.4C14.9824 17.4 17.4001 14.9823 17.4001 12C17.4001 9.01764 14.9824 6.59998 12.0001 6.59998C9.01776 6.59998 6.6001 9.01764 6.6001 12C6.6001 14.9823 9.01776 17.4 12.0001 17.4Z",
                                fill: "#ED7200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M17.3848 12C17.3848 14.9739 14.974 17.3847 12.0001 17.3847C9.02621 17.3847 6.61539 14.9739 6.61539 12C6.61539 9.02608 9.02621 6.61527 12.0001 6.61527C14.974 6.61527 17.3848 9.02608 17.3848 12Z",
                                stroke: "url(#paint0_linear_6_74650)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.0305822"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter7_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12.5618 11.4383H11.4385C11.1015 11.4383 10.8769 11.2136 10.8769 10.8767C10.8769 10.5397 11.1016 10.3151 11.4385 10.3151H13.1234C13.4604 10.3151 13.685 10.0904 13.685 9.75347C13.685 9.41649 13.4603 9.19186 13.1234 9.19186H12.5618C12.5618 8.85487 12.3371 8.63025 12.0002 8.63025C11.6632 8.63025 11.4385 8.85492 11.4385 9.19186C10.4838 9.19186 9.75366 9.92197 9.75366 10.8767C9.75366 11.8315 10.4838 12.5616 11.4385 12.5616H12.5618C12.8988 12.5616 13.1234 12.7863 13.1234 13.1232C13.1234 13.4602 12.8988 13.6849 12.5618 13.6849H10.8769C10.5399 13.6849 10.3153 13.9095 10.3153 14.2465C10.3153 14.5835 10.54 14.8081 10.8769 14.8081H11.4385C11.4385 15.1451 11.6632 15.3697 12.0002 15.3697C12.3371 15.3697 12.5618 15.145 12.5618 14.8081C13.5166 14.8081 14.2467 14.078 14.2467 13.1232C14.2467 12.1684 13.5166 11.4383 12.5618 11.4383Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter8_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M14.4629 3.98047C15.1101 3.98047 15.6348 3.4558 15.6348 2.80859C15.6348 2.16139 15.1101 1.63672 14.4629 1.63672C13.8157 1.63672 13.291 2.16139 13.291 2.80859C13.291 3.4558 13.8157 3.98047 14.4629 3.98047Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter9_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M6.44336 5.27142C6.44336 4.62421 5.91869 4.09955 5.27148 4.09955C4.62428 4.09955 4.09961 4.62421 4.09961 5.27142C4.09961 5.91863 4.62428 6.4433 5.27148 6.4433C5.91869 6.4433 6.44336 5.91863 6.44336 5.27142Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter10_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2.48438 13.1651C3.13158 13.1651 3.65625 12.6404 3.65625 11.9932C3.65625 11.346 3.13158 10.8214 2.48438 10.8214C1.83717 10.8214 1.3125 11.346 1.3125 11.9932C1.3125 12.6404 1.83717 13.1651 2.48438 13.1651Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter11_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M9.53711 22.3633C10.1843 22.3633 10.709 21.8386 10.709 21.1914C10.709 20.5442 10.1843 20.0195 9.53711 20.0195C8.8899 20.0195 8.36523 20.5442 8.36523 21.1914C8.36523 21.8386 8.8899 22.3633 9.53711 22.3633Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter12_dii_6_74650)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M21.4126 16.7578C21.4126 16.1106 20.8879 15.5859 20.2407 15.5859C19.5935 15.5859 19.0688 16.1106 19.0688 16.7578C19.0688 17.405 19.5935 17.9297 20.2407 17.9297C20.8879 17.9297 21.4126 17.405 21.4126 16.7578Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_6_74650",
                        x: "0",
                        y: "0",
                        width: "24",
                        height: "28.1421",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "4.14213"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "5.11675"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_6_74650",
                        x: "11.2743",
                        y: "11.3724",
                        width: "7.8654",
                        height: "5.25281",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_dii_6_74650",
                        x: "11.2743",
                        y: "4.21857",
                        width: "3.36833",
                        height: "8.70355",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter3_dii_6_74650",
                        x: "6.03727",
                        y: "6.1355",
                        width: "6.68839",
                        height: "6.7865",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter4_dii_6_74650",
                        x: "9.35734",
                        y: "11.3724",
                        width: "3.36833",
                        height: "8.70355",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter5_dii_6_74650",
                        x: "3.86808",
                        y: "11.3725",
                        width: "8.85758",
                        height: "1.5495",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter6_dii_6_74650",
                        x: "5.78902",
                        y: "6.27554",
                        width: "12.4222",
                        height: "13.8268",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.48665"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.405541"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "2.70241"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.33827"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.408731"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.917466"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter7_dii_6_74650",
                        x: "9.07014",
                        y: "8.15179",
                        width: "5.85996",
                        height: "8.31153",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.410111"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.341759"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.478463"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.546815"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.862745 0 0 0 0 0.415686 0 0 0 0 0 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.136704"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.136704"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.862745 0 0 0 0 0.415686 0 0 0 0 0 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter8_dii_6_74650",
                        x: "12.9638",
                        y: "1.40766",
                        width: "2.99821",
                        height: "3.09638",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter9_dii_6_74650",
                        x: "3.77238",
                        y: "3.87049",
                        width: "2.99821",
                        height: "3.09638",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter10_dii_6_74650",
                        x: "0.985271",
                        y: "10.5923",
                        width: "2.99821",
                        height: "3.09638",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter11_dii_6_74650",
                        x: "8.03801",
                        y: "19.7905",
                        width: "2.99821",
                        height: "3.09638",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter12_dii_6_74650",
                        x: "18.7416",
                        y: "15.3569",
                        width: "2.99821",
                        height: "3.09638",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.196337"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.163615"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_6_74650",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.22906"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.261783"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_6_74650"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0654458"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_6_74650",
                                result: "effect3_innerShadow_6_74650"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_6_74650",
                        x1: "12.0001",
                        y1: "6.59998",
                        x2: "12.0001",
                        y2: "17.4",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_6_74650",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var GiftIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 49 48",
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_26566_339148)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter0_i_26566_339148)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0.875",
                            width: "48",
                            height: "48",
                            fill: "#FF57B1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_26566_339148)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M31.1411 10.0783C31.8709 10.3615 32.5026 10.861 32.9524 11.5343C33.3529 12.1337 33.5707 12.8196 33.6029 13.5141C33.612 13.7102 33.6063 13.907 33.5857 14.1027C33.5335 14.6001 33.3853 15.0906 33.1401 15.5452C32.7348 16.2986 32.1116 16.8813 31.3701 17.2295C31.2642 17.2793 31.1559 17.3242 31.0454 17.3642C30.9936 17.383 30.941 17.4007 30.8879 17.4174C30.6126 17.5039 30.3206 17.5621 30.0218 17.5886C29.9169 17.598 29.8111 17.6034 29.7049 17.6047L24.9849 17.5801L24.967 17.5866L22.2489 17.5714L20.047 17.5733C18.6037 17.586 17.2909 16.7764 16.6094 15.514C15.9461 14.245 16.0219 12.7084 16.8345 11.5169C17.442 10.6034 18.3914 10.015 19.4549 9.85425C19.7023 9.80551 19.9628 9.79266 20.2299 9.798C21.1426 9.84226 21.9717 10.1891 22.619 10.7588C22.6499 10.786 22.6803 10.8136 22.7103 10.8417C23.0102 11.123 23.2678 11.4539 23.4726 11.8259L24.886 14.4343L26.3117 11.8379C26.9539 10.6265 28.1723 9.87943 29.5355 9.81421C30.0126 9.79575 30.476 9.85935 30.9095 9.99681C30.9877 10.0216 31.0649 10.0488 31.1411 10.0783Z",
                                fill: "#FF9029"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M33.1252 15.5371L33.1252 15.5372C32.7216 16.2874 32.101 16.8674 31.3629 17.2141C31.2574 17.2636 31.1496 17.3084 31.0396 17.3482C30.988 17.3669 30.9357 17.3846 30.8828 17.4012C30.6087 17.4873 30.3179 17.5453 30.0203 17.5717C29.9158 17.581 29.8105 17.5863 29.7048 17.5877L24.985 17.5631L24.985 17.562L24.9791 17.5641L24.964 17.5696L22.249 17.5544L22.2489 17.5544L20.047 17.5562L20.0469 17.5562C18.6101 17.5689 17.303 16.7631 16.6244 15.506C15.964 14.2425 16.0396 12.7127 16.8486 11.5264L16.8486 11.5264L16.8487 11.5263C17.4535 10.617 18.3986 10.0311 19.4574 9.87108L19.4574 9.8711L19.4582 9.87095C19.7039 9.82254 19.963 9.8097 20.2293 9.81502C21.138 9.85913 21.9634 10.2045 22.6078 10.7716C22.6385 10.7986 22.6688 10.8261 22.6986 10.8541C22.9972 11.1342 23.2537 11.4637 23.4576 11.834C23.4577 11.8341 23.4577 11.8341 23.4577 11.8341L24.871 14.4425L24.8859 14.4699L24.9009 14.4425L26.3266 11.8461L26.3267 11.8459C26.966 10.64 28.1788 9.89618 29.5362 9.83122C30.0113 9.81284 30.4727 9.87619 30.9043 10.013C30.9822 10.0377 31.0591 10.0648 31.1349 10.0942C31.8615 10.3761 32.4904 10.8734 32.9382 11.5438L32.9524 11.5343L32.9382 11.5438C33.337 12.1405 33.5538 12.8234 33.5859 13.5149C33.5949 13.7102 33.5893 13.9061 33.5688 14.1009C33.5168 14.5961 33.3693 15.0845 33.1252 15.5371Z",
                                stroke: "url(#paint0_linear_26566_339148)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.0340466",
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter2_dii_26566_339148)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M34.4184 38.2032C36.0101 38.2032 37.2948 36.9183 37.2948 35.3268V20.1584C37.2948 17.9199 37.3105 16.881 37.3073 16.4399C37.3039 15.9696 36.7776 16.5681 36.3542 16.7728L33.8551 17.9808C33.6642 18.0731 33.4416 18.0682 33.2295 18.0682L13.3247 18.0682C12.7877 18.0682 12.3658 18.4901 12.3658 19.027V35.3268C12.3658 36.9183 13.6506 38.2032 15.2423 38.2032L34.4184 38.2032Z",
                                fill: "#3083FC"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M37.2714 35.3268C37.2714 36.9054 35.9971 38.1797 34.4184 38.1797L15.2423 38.1797C13.6635 38.1797 12.3893 36.9054 12.3893 35.3268V19.027C12.3893 18.503 12.8006 18.0917 13.3247 18.0917L33.2295 18.0917C33.2401 18.0917 33.2508 18.0917 33.2615 18.0917C33.4629 18.092 33.6785 18.0922 33.8653 18.0019L36.3644 16.7939C36.4722 16.7418 36.5858 16.6649 36.6948 16.5874C36.724 16.5666 36.7528 16.5458 36.7811 16.5254C36.8592 16.469 36.9334 16.4155 37.0007 16.3731C37.0465 16.3443 37.0881 16.3212 37.1248 16.3063C37.1618 16.2912 37.1913 16.2853 37.2137 16.288C37.2343 16.2905 37.2503 16.3003 37.2622 16.3221C37.275 16.3454 37.2835 16.3829 37.2839 16.4401C37.2852 16.614 37.2835 16.8808 37.281 17.2774C37.2772 17.8865 37.2714 18.8021 37.2714 20.1584V35.3268Z",
                                stroke: "url(#paint1_linear_26566_339148)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.046875",
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter3_dii_26566_339148)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M10.4844 15.0342C10.4844 14.2222 11.1426 13.564 11.9546 13.564H37.8423C38.6543 13.564 39.3125 14.2222 39.3125 15.0342V20.7991C39.3125 21.0748 39.089 21.2983 38.8133 21.2983H10.9836C10.7079 21.2983 10.4844 21.0748 10.4844 20.7991V15.0342Z",
                                fill: "#3083FC"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M10.5078 15.0342C10.5078 14.2352 11.1556 13.5874 11.9546 13.5874H37.8423C38.6413 13.5874 39.2891 14.2352 39.2891 15.0342V20.7991C39.2891 21.0619 39.076 21.2749 38.8133 21.2749H10.9836C10.7208 21.2749 10.5078 21.0619 10.5078 20.7991V15.0342Z",
                                stroke: "url(#paint2_linear_26566_339148)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.046875",
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter4_dii_26566_339148)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M24.7256 33.5768C24.7774 33.6297 24.8479 33.659 24.9217 33.659C24.9955 33.659 25.066 33.6297 25.1178 33.5768L28.6414 30.0065C30.1109 28.5179 29.0667 25.9463 26.977 25.9463C25.722 25.9463 25.1461 26.8685 24.9217 27.0408C24.6962 26.8678 24.124 25.9463 22.8664 25.9463C20.7833 25.9463 19.7262 28.5113 21.2023 30.0065L24.7256 33.5768Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_26566_339148",
                        x: "0.875",
                        y: "0",
                        width: "48",
                        height: "52.1421",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "4.14213"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "5.11675"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 0.820333 0 0 0 0 0.358333 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_26566_339148"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_26566_339148",
                        x: "15.2598",
                        y: "9.43569",
                        width: "19.2503",
                        height: "11.1773",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.541778"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.451481"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26566_339148",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "3.00854"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.71644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.689297"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.669844"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_26566_339148",
                                result: "effect3_innerShadow_26566_339148"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_dii_26566_339148",
                        x: "11.4629",
                        y: "14.3988",
                        width: "26.7478",
                        height: "26.8129",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.541778"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.451481"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26566_339148",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "3.00854"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.71644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-1.86539"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1.0214"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_26566_339148",
                                result: "effect3_innerShadow_26566_339148"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter3_dii_26566_339148",
                        x: "9.58141",
                        y: "13.2028",
                        width: "30.6341",
                        height: "11.1041",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.541778"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.451481"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26566_339148",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "3.00854"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.71644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.455033"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1.0214"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_26566_339148",
                                result: "effect3_innerShadow_26566_339148"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter4_dii_26566_339148",
                        x: "20.1151",
                        y: "25.5166",
                        width: "9.61195",
                        height: "8.78086",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.23936"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.199466"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26566_339148",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.429672"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.657595"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.262745 0 0 0 0 0.533333 0 0 0 0 0.929412 0 0 0 0.55 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_26566_339148"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.0797865"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.0797865"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_26566_339148",
                                result: "effect3_innerShadow_26566_339148"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_26566_339148",
                        x1: "24.8849",
                        y1: "9.79688",
                        x2: "24.8849",
                        y2: "17.6047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_26566_339148",
                        x1: "24.8303",
                        y1: "20.8807",
                        x2: "24.8303",
                        y2: "38.2032",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint2_linear_26566_339148",
                        x1: "24.8984",
                        y1: "13.564",
                        x2: "24.8984",
                        y2: "21.2983",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_26566_339148",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white",
                            transform: "translate(0.875)"
                        })
                    })
                ]
            })
        ]
    });
};
var GiftIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18 7.00004H17.65C17.8782 6.5328 17.9979 6.02002 18 5.50004C18.003 4.80336 17.7975 4.12173 17.4098 3.54287C17.0221 2.96401 16.4701 2.51442 15.8247 2.25198C15.1794 1.98953 14.4703 1.92624 13.7886 2.07025C13.107 2.21426 12.4841 2.55898 12 3.06004C11.5159 2.55898 10.893 2.21426 10.2114 2.07025C9.52975 1.92624 8.82061 1.98953 8.17525 2.25198C7.5299 2.51442 6.97786 2.96401 6.59019 3.54287C6.20252 4.12173 5.99697 4.80336 6 5.50004C6.00213 6.02002 6.12178 6.5328 6.35 7.00004H6C5.20435 7.00004 4.44129 7.31611 3.87868 7.87872C3.31607 8.44133 3 9.20439 3 10V12C3 12.2653 3.10536 12.5196 3.29289 12.7071C3.48043 12.8947 3.73478 13 4 13H5V19C5 19.7957 5.31607 20.5588 5.87868 21.1214C6.44129 21.684 7.20435 22 8 22H16C16.7956 22 17.5587 21.684 18.1213 21.1214C18.6839 20.5588 19 19.7957 19 19V13H20C20.2652 13 20.5196 12.8947 20.7071 12.7071C20.8946 12.5196 21 12.2653 21 12V10C21 9.20439 20.6839 8.44133 20.1213 7.87872C19.5587 7.31611 18.7956 7.00004 18 7.00004ZM11 20H8C7.73478 20 7.48043 19.8947 7.29289 19.7071C7.10536 19.5196 7 19.2653 7 19V13H11V20ZM11 11H5V10C5 9.73482 5.10536 9.48047 5.29289 9.29293C5.48043 9.10539 5.73478 9.00004 6 9.00004H11V11ZM11 7.00004H9.5C9.20333 7.00004 8.91332 6.91206 8.66665 6.74724C8.41997 6.58242 8.22771 6.34815 8.11418 6.07406C8.00065 5.79997 7.97094 5.49837 8.02882 5.2074C8.0867 4.91643 8.22956 4.64916 8.43934 4.43938C8.64912 4.2296 8.91639 4.08674 9.20736 4.02886C9.49834 3.97098 9.79994 4.00069 10.074 4.11422C10.3481 4.22775 10.5824 4.42001 10.7472 4.66668C10.912 4.91336 11 5.20337 11 5.50004V7.00004ZM13 5.50004C13 5.20337 13.088 4.91336 13.2528 4.66668C13.4176 4.42001 13.6519 4.22775 13.926 4.11422C14.2001 4.00069 14.5017 3.97098 14.7926 4.02886C15.0836 4.08674 15.3509 4.2296 15.5607 4.43938C15.7704 4.64916 15.9133 4.91643 15.9712 5.2074C16.0291 5.49837 15.9994 5.79997 15.8858 6.07406C15.7723 6.34815 15.58 6.58242 15.3334 6.74724C15.0867 6.91206 14.7967 7.00004 14.5 7.00004H13V5.50004ZM17 19C17 19.2653 16.8946 19.5196 16.7071 19.7071C16.5196 19.8947 16.2652 20 16 20H13V13H17V19ZM19 11H13V9.00004H18C18.2652 9.00004 18.5196 9.10539 18.7071 9.29293C18.8946 9.48047 19 9.73482 19 10V11Z",
            fill: fillColor
        })
    });
};
var DigitalProductIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7 14H9C9.26522 14 9.51957 13.8946 9.70711 13.7071C9.89464 13.5196 10 13.2652 10 13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM13 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H13C13.2652 18 13.5196 17.8946 13.7071 17.7071C13.8946 17.5196 14 17.2652 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16ZM19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM14 4V7.29L12.49 6.45C12.338 6.36223 12.1655 6.31603 11.99 6.31603C11.8145 6.31603 11.642 6.36223 11.49 6.45L10 7.29V4H14ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00105 9.17451 8.04776 9.34571 8.13547 9.49658C8.22319 9.64746 8.34886 9.77274 8.5 9.86C8.65202 9.94777 8.82446 9.99397 9 9.99397C9.17554 9.99397 9.34798 9.94777 9.5 9.86L12 8.47L14.51 9.87C14.6595 9.9547 14.8282 9.99947 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z",
            fill: fillColor
        })
    });
};
var DigitalProducticonV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_26663_338318)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter0_i_26663_338318)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "#5117B5"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_26663_338318)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M38.9381 20.0156H38.0515C37.0741 20.0156 36.2818 19.2233 36.2818 18.2459V17.3594C36.2821 17.0977 36.2309 16.8385 36.1309 16.5966C36.0309 16.3547 35.8841 16.135 35.6991 15.9499C35.514 15.7649 35.2943 15.6181 35.0524 15.5181C34.8105 15.4181 34.5513 15.3668 34.2896 15.3672H24.1626C23.8661 15.3673 23.5733 15.3011 23.3057 15.1736C23.038 15.0461 22.8021 14.8604 22.6154 14.6301L21.3138 13.0297C21.0657 12.7227 20.7521 12.4751 20.3959 12.3051C20.0397 12.135 19.6499 12.0468 19.2552 12.0469H11.7115C11.4497 12.0465 11.1905 12.0978 10.9487 12.1978C10.7068 12.2978 10.487 12.4445 10.302 12.6296C10.1169 12.8147 9.97019 13.0344 9.8702 13.2763C9.7702 13.5181 9.71891 13.7774 9.71926 14.0391V33.6754C9.71789 33.9745 9.77654 34.2709 9.89175 34.5469C10.007 34.823 10.1764 35.0731 10.39 35.2825C10.5994 35.4961 10.8495 35.6655 11.1255 35.7807C11.4015 35.8959 11.6979 35.9545 11.997 35.9532H34.3494C34.8428 35.953 35.3229 35.7931 35.7179 35.4975C36.1129 35.2018 36.4016 34.7863 36.5408 34.3129L40.2131 21.7156C40.2704 21.5177 40.2809 21.3092 40.2438 21.1065C40.2068 20.9038 40.1231 20.7125 39.9995 20.5477C39.8759 20.3828 39.7156 20.249 39.5314 20.1567C39.3472 20.0643 39.1441 20.016 38.9381 20.0156Z",
                                fill: "#ED7200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M21.3006 13.0404L21.3006 13.0404L22.6022 14.6408C22.7905 14.8731 23.0284 15.0603 23.2983 15.189C23.5683 15.3176 23.8636 15.3843 24.1626 15.3842H34.2896C34.5491 15.3839 34.8061 15.4347 35.0459 15.5339C35.2857 15.633 35.5036 15.7785 35.687 15.962C35.8705 16.1454 36.016 16.3633 36.1151 16.6031C36.2143 16.8429 36.2651 17.0999 36.2648 17.3594V18.2459C36.2648 19.2327 37.0647 20.0327 38.0515 20.0327H38.938C39.1414 20.0331 39.342 20.0807 39.5238 20.1719C39.7056 20.263 39.8638 20.3952 39.9859 20.5579C40.1079 20.7206 40.1905 20.9095 40.2271 21.1096C40.2637 21.3097 40.2533 21.5155 40.1967 21.7109L36.5245 34.3081C36.3863 34.7779 36.0997 35.1904 35.7077 35.4839C35.3156 35.7773 34.8391 35.936 34.3494 35.9361H11.997H11.9969C11.7001 35.9375 11.406 35.8793 11.1321 35.765C10.8581 35.6506 10.6099 35.4825 10.4021 35.2705L10.4019 35.2703C10.1899 35.0625 10.0218 34.8143 9.90746 34.5404C9.79313 34.2664 9.73492 33.9723 9.73629 33.6755V33.6754L9.73629 14.0391L9.73629 14.039C9.73594 13.7796 9.78679 13.5226 9.88593 13.2828C9.98507 13.043 10.1305 12.8251 10.314 12.6416C10.4975 12.4582 10.7154 12.3127 10.9552 12.2135C11.195 12.1144 11.452 12.0636 11.7114 12.0639H11.7115L19.2552 12.0639C19.6474 12.0638 20.0346 12.1514 20.3885 12.3204C20.7424 12.4894 21.0541 12.7354 21.3006 13.0404Z",
                                stroke: "url(#paint0_linear_26663_338318)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.0340466",
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter2_dii_26663_338318)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M38.9372 20.0156H20.0604C19.5676 20.0157 19.0881 20.1756 18.6938 20.4713C18.2996 20.7671 18.0119 21.1827 17.874 21.6559L14.1818 34.3138C14.0439 34.7868 13.7563 35.2022 13.3622 35.4978C12.9681 35.7933 12.4887 35.9531 11.9961 35.9531H34.351C34.8439 35.9532 35.3236 35.7933 35.7179 35.4976C36.1122 35.2018 36.4 34.7861 36.538 34.3129L40.2123 21.7156C40.27 21.5177 40.2809 21.309 40.244 21.1062C40.2071 20.9033 40.1235 20.7118 39.9998 20.5468C39.876 20.3819 39.7156 20.248 39.5312 20.1558C39.3468 20.0636 39.1434 20.0156 38.9372 20.0156Z",
                                fill: "#FF8413"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.3898 35.9361C12.7444 35.8743 13.0815 35.7296 13.3724 35.5114C13.7694 35.2136 14.0592 34.7951 14.1981 34.3186L17.8903 21.6606L17.874 21.6559L17.8903 21.6606C18.0272 21.191 18.3128 20.7785 18.704 20.485C19.0953 20.1914 19.5713 20.0327 20.0604 20.0326H38.9372C39.1408 20.0326 39.3415 20.08 39.5236 20.171C39.7056 20.2621 39.864 20.3942 39.9861 20.5571C40.1083 20.7199 40.1908 20.9089 40.2272 21.1092C40.2636 21.3095 40.2529 21.5155 40.1959 21.7109L36.5216 34.3081L36.538 34.3129L36.5216 34.3081C36.3847 34.7778 36.0991 35.1904 35.7077 35.484C35.3163 35.7775 34.8402 35.9362 34.351 35.9361H12.3898Z",
                                stroke: "url(#paint1_linear_26663_338318)",
                                strokeOpacity: "0.5",
                                strokeWidth: "0.0340466",
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter3_dii_26663_338318)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M26.521 24.4519C26.6321 24.0585 27.0476 23.8603 27.2689 24.0952L31.4056 28.4853C31.6269 28.7202 31.488 29.2119 31.1557 29.3704L24.9424 32.334C24.61 32.4925 24.3334 32.199 24.4445 31.8056L26.521 24.4519Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_26663_338318",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "52.1421",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "4.14213"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "5.11675"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_26663_338318"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_26663_338318",
                        x: "8.81628",
                        y: "11.6857",
                        width: "32.3523",
                        height: "27.276",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.541778"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.451481"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26663_338318",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "3.00854"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.71644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.455033"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1.0214"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_26663_338318",
                                result: "effect3_innerShadow_26663_338318"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_dii_26663_338318",
                        x: "11.0931",
                        y: "19.6544",
                        width: "30.0755",
                        height: "19.3072",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.541778"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.451481"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26663_338318",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "3.00854"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.71644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.455033"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1.0214"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_26663_338318",
                                result: "effect3_innerShadow_26663_338318"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter3_dii_26663_338318",
                        x: "23.9121",
                        y: "23.639",
                        width: "8.10835",
                        height: "9.55058",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.304379"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.253649"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_26663_338318",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.355109"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.405839"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.929412 0 0 0 0 0.447059 0 0 0 0 0 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_26663_338318"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.10146"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.10146"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_26663_338318",
                                result: "effect3_innerShadow_26663_338318"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_26663_338318",
                        x1: "24.9924",
                        y1: "12.0469",
                        x2: "24.9924",
                        y2: "35.9532",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_26663_338318",
                        x1: "26.1308",
                        y1: "20.0156",
                        x2: "26.1308",
                        y2: "35.9531",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_26663_338318",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var BioIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 2C10.0605 2.00369 8.16387 2.57131 6.54122 3.63374C4.91856 4.69617 3.63988 6.20754 2.86093 7.98377C2.08197 9.76 1.83636 11.7244 2.15401 13.6378C2.47166 15.5511 3.33887 17.3308 4.64999 18.76C5.58641 19.775 6.72293 20.5851 7.98793 21.1392C9.25292 21.6933 10.619 21.9793 12 21.9793C13.381 21.9793 14.7471 21.6933 16.012 21.1392C17.277 20.5851 18.4136 19.775 19.35 18.76C20.6611 17.3308 21.5283 15.5511 21.846 13.6378C22.1636 11.7244 21.918 9.76 21.139 7.98377C20.3601 6.20754 19.0814 4.69617 17.4588 3.63374C15.8361 2.57131 13.9395 2.00369 12 2ZM12 20C9.92845 19.9969 7.9389 19.1903 6.44999 17.75C6.90203 16.6495 7.67102 15.7083 8.65924 15.0459C9.64746 14.3835 10.8103 14.0298 12 14.0298C13.1897 14.0298 14.3525 14.3835 15.3407 15.0459C16.329 15.7083 17.0979 16.6495 17.55 17.75C16.0611 19.1903 14.0715 19.9969 12 20ZM9.99999 10C9.99999 9.60444 10.1173 9.21776 10.337 8.88886C10.5568 8.55996 10.8692 8.30362 11.2346 8.15224C11.6001 8.00087 12.0022 7.96126 12.3902 8.03843C12.7781 8.1156 13.1345 8.30608 13.4142 8.58579C13.6939 8.86549 13.8844 9.22186 13.9616 9.60982C14.0387 9.99778 13.9991 10.3999 13.8477 10.7654C13.6964 11.1308 13.44 11.4432 13.1111 11.6629C12.7822 11.8827 12.3955 12 12 12C11.4696 12 10.9608 11.7893 10.5858 11.4142C10.2107 11.0391 9.99999 10.5304 9.99999 10ZM18.91 16C18.0165 14.4718 16.6414 13.283 15 12.62C15.5092 12.0427 15.8409 11.3307 15.9555 10.5694C16.07 9.80822 15.9625 9.03011 15.6457 8.3285C15.329 7.62688 14.8166 7.03156 14.1699 6.61397C13.5232 6.19637 12.7698 5.97425 12 5.97425C11.2302 5.97425 10.4768 6.19637 9.83008 6.61397C9.1834 7.03156 8.67096 7.62688 8.35424 8.3285C8.03752 9.03011 7.92997 9.80822 8.04452 10.5694C8.15906 11.3307 8.49082 12.0427 8.99999 12.62C7.35859 13.283 5.98346 14.4718 5.08999 16C4.37793 14.7871 4.00171 13.4065 3.99999 12C3.99999 9.87827 4.84284 7.84344 6.34313 6.34315C7.84342 4.84285 9.87826 4 12 4C14.1217 4 16.1566 4.84285 17.6568 6.34315C19.1571 7.84344 20 9.87827 20 12C19.9983 13.4065 19.622 14.7871 18.91 16Z",
            fill: fillColor
        })
    });
};
var IconBrandGift = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({}, props, {
        src: "https://i.ecomobi.com/ssp/mini-store/brand-gift/icon-brand-gift.png"
    }));
};
var IconBrandRating = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({}, props, {
        src: "https://i.ecomobi.com/ssp/mini-store/brand-deal/brandRatingDetails.png"
    }));
};
var TruthOrDareIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        width: 33,
        height: 32,
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2_31)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter0_i_2_31)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: 0.5,
                            width: 32,
                            height: 32,
                            fill: "#FA6B22"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_2_31)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M11.1697 12.6978L11.1697 12.6978L11.1701 12.6984C11.2476 12.8032 11.2745 12.9925 11.2442 13.273L11.1226 14.3995C11.0979 14.6283 11.0865 14.7881 11.0889 14.8779C11.0905 14.9377 11.0971 14.9999 11.1087 15.0646C11.1212 15.1349 11.1823 15.1797 11.2541 15.1797H11.9163C12.0406 15.1797 12.1326 15.0531 12.1196 14.939C12.1157 14.905 12.1137 14.871 12.1136 14.8371C12.1138 14.7268 12.1233 14.5839 12.1423 14.4083L12.2591 13.3258C12.2985 12.9604 12.28 12.6663 12.2016 12.445C12.1322 12.233 11.9894 12.0886 11.7746 12.0127C12.2085 11.8296 12.4561 11.4183 12.5238 10.7911L12.5647 10.4127C12.6169 9.92846 12.5402 9.56634 12.3294 9.33141C12.119 9.09041 11.7584 8.97245 11.2538 8.97245H9.95746C9.86357 8.97245 9.77928 9.04812 9.76921 9.14147L9.13575 15.0107C9.12568 15.104 9.19363 15.1797 9.28752 15.1797H9.9681C10.062 15.1797 10.1463 15.104 10.1564 15.0107L10.4099 12.6618C10.4172 12.5942 10.4782 12.5394 10.5462 12.5394H10.736C10.9572 12.5394 11.0988 12.5945 11.1697 12.6978ZM11.2863 11.4699L11.2863 11.4699L11.2858 11.4704C11.1873 11.5638 11.0447 11.6127 10.8537 11.6127H10.6462C10.5782 11.6127 10.529 11.5579 10.5363 11.4903L10.6948 10.0216C10.7021 9.95396 10.7632 9.89915 10.8312 9.89915H11.1272C11.2938 9.89915 11.4043 9.94753 11.4652 10.0396L11.4652 10.0396L11.4657 10.0403C11.533 10.1337 11.5575 10.2884 11.5336 10.5095L11.4823 10.9848C11.4572 11.2172 11.3902 11.3767 11.2863 11.4699ZM13.6091 14.8641L13.6093 14.8643C13.8336 15.1343 14.1863 15.2677 14.6628 15.2677C15.1394 15.2677 15.5208 15.1343 15.8034 14.8643L15.8036 14.8641C16.0864 14.5885 16.2535 14.1978 16.3077 13.6954L16.7992 9.14147C16.8093 9.04812 16.7413 8.97245 16.6474 8.97245H16.0022C15.9084 8.97245 15.8241 9.04812 15.814 9.14147L15.3149 13.7659C15.2923 13.9747 15.2327 14.1201 15.1408 14.2076L15.1402 14.2082C15.0537 14.2957 14.9351 14.341 14.7805 14.341C14.6262 14.341 14.5141 14.2958 14.4405 14.2079C14.3731 14.1203 14.3478 13.9748 14.3703 13.7659L14.8694 9.14147C14.8795 9.04812 14.8116 8.97245 14.7177 8.97245H14.0371C13.9432 8.97245 13.8589 9.04812 13.8488 9.14147L13.3573 13.6954C13.3031 14.1978 13.3858 14.5885 13.6091 14.8641ZM5.83148 9.89915H6.55632C6.62433 9.89915 6.67354 9.95396 6.66624 10.0216L6.12778 15.0107C6.1177 15.104 6.18565 15.1797 6.27954 15.1797H6.96013C7.05402 15.1797 7.1383 15.104 7.14838 15.0107L7.68684 10.0216C7.69414 9.95396 7.75519 9.89915 7.82319 9.89915H8.54803C8.64193 9.89915 8.72621 9.82347 8.73628 9.73012L8.79982 9.14147C8.80989 9.04812 8.74194 8.97245 8.64805 8.97245H5.9315C5.8376 8.97245 5.75332 9.04812 5.74324 9.14148L5.67971 9.73012C5.66964 9.82347 5.73759 9.89915 5.83148 9.89915ZM17.8222 9.89915H18.547C18.615 9.89915 18.6642 9.95396 18.6569 10.0216L18.1185 15.0107C18.1084 15.104 18.1763 15.1797 18.2702 15.1797H18.9508C19.0447 15.1797 19.129 15.104 19.1391 15.0107L19.6775 10.0216C19.6848 9.95396 19.7459 9.89915 19.8139 9.89915H20.5387C20.6326 9.89915 20.7169 9.82347 20.727 9.73012L20.7905 9.14147C20.8006 9.04812 20.7326 8.97245 20.6387 8.97245H17.9222C17.8283 8.97245 17.744 9.04812 17.7339 9.14148L17.6704 9.73012C17.6603 9.82347 17.7283 9.89915 17.8222 9.89915ZM22.6287 8.97245H21.9481C21.8543 8.97245 21.77 9.04812 21.7599 9.14147L21.1264 15.0107C21.1164 15.104 21.1843 15.1797 21.2782 15.1797H21.9588C22.0527 15.1797 22.137 15.104 22.147 15.0107L22.4148 12.5298C22.4221 12.4622 22.4831 12.4074 22.5511 12.4074H23.3025C23.3705 12.4074 23.4198 12.4622 23.4125 12.5298L23.1447 15.0107C23.1346 15.104 23.2026 15.1797 23.2965 15.1797H23.9771C24.071 15.1797 24.1552 15.104 24.1653 15.0107L24.7988 9.14147C24.8088 9.04812 24.7409 8.97245 24.647 8.97245H23.9664C23.8725 8.97245 23.7882 9.04812 23.7782 9.14148L23.5389 11.3583C23.5316 11.4259 23.4706 11.4807 23.4026 11.4807H22.6512C22.5832 11.4807 22.5339 11.4259 22.5412 11.3583L22.7805 9.14147C22.7906 9.04812 22.7226 8.97245 22.6287 8.97245Z",
                                fill: "white",
                                stroke: "white",
                                strokeWidth: 0.046875
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                filter: "url(#filter2_d_2_31)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M6.13358 21.6328C5.77716 21.6328 5.51603 21.5323 5.35019 21.3312C5.18435 21.1302 5.12276 20.8461 5.16544 20.4789L5.44588 18.0662C5.48855 17.6991 5.61618 17.415 5.82876 17.2139C6.04135 17.0129 6.32585 16.9123 6.68227 16.9123C7.03869 16.9123 7.29982 17.0129 7.46566 17.2139C7.6315 17.415 7.69309 17.6991 7.65041 18.0662L7.36997 20.4789C7.3273 20.8461 7.19967 21.1302 6.98709 21.3312C6.77451 21.5323 6.49 21.6328 6.13358 21.6328ZM6.20979 20.9772C6.4606 20.9772 6.60354 20.8264 6.63859 20.5248L6.9297 18.0203C6.96476 17.7187 6.85688 17.568 6.60606 17.568C6.35525 17.568 6.21231 17.7187 6.17726 18.0203L5.88615 20.5248C5.85109 20.8264 5.95897 20.9772 6.20979 20.9772Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M8.79583 17.1235C8.80517 17.0431 8.87837 16.9779 8.95932 16.9779H9.88861C10.2626 16.9779 10.5253 17.0653 10.6766 17.2401C10.8284 17.4106 10.8834 17.675 10.8418 18.0334L10.809 18.3154C10.754 18.7888 10.5626 19.0896 10.2347 19.2178C10.2311 19.2192 10.2283 19.2226 10.2279 19.2264V19.2264C10.2274 19.2304 10.2297 19.234 10.2335 19.2353C10.3998 19.2884 10.5084 19.3948 10.5594 19.5545C10.6154 19.7162 10.6276 19.9326 10.5961 20.2036L10.5024 21.01C10.4872 21.1411 10.4791 21.2482 10.4783 21.3312C10.4782 21.3385 10.4783 21.3457 10.4785 21.353C10.4813 21.4573 10.3974 21.5673 10.2913 21.5673H9.8813C9.81915 21.5673 9.76724 21.5286 9.75854 21.4688C9.75294 21.4304 9.74982 21.3933 9.74918 21.3575C9.748 21.2919 9.75731 21.1739 9.77713 21.0034L9.87467 20.1642C9.89906 19.9544 9.88088 19.808 9.82012 19.725C9.76377 19.6419 9.65199 19.6004 9.48478 19.6004H9.38054C9.29959 19.6004 9.22639 19.6656 9.21704 19.746L9.02227 21.4217C9.01292 21.5021 8.93973 21.5673 8.85878 21.5673H8.42587C8.34493 21.5673 8.28688 21.5021 8.29623 21.4217L8.79583 17.1235ZM9.57419 18.9448C9.7194 18.9448 9.83152 18.9076 9.91056 18.8333C9.99401 18.759 10.0459 18.6344 10.0662 18.4596L10.1074 18.1056C10.1267 17.9395 10.1098 17.8193 10.0569 17.745C10.0083 17.6707 9.92021 17.6335 9.79261 17.6335H9.60916C9.52821 17.6335 9.45501 17.6987 9.44566 17.7791L9.3271 18.7992C9.31775 18.8796 9.3758 18.9448 9.45674 18.9448H9.57419Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M9.80005 19.7394L9.80004 19.7394L9.80045 19.74C9.85634 19.8164 9.8755 19.9555 9.85123 20.1642L9.75369 21.0034C9.73389 21.1738 9.72438 21.2933 9.72559 21.3605C9.72625 21.3974 9.72946 21.4354 9.73517 21.4747C9.74553 21.5459 9.80704 21.5906 9.87859 21.5906H10.2886C10.3505 21.5906 10.4051 21.5583 10.4432 21.5128C10.4811 21.4675 10.5036 21.4079 10.5021 21.3497C10.5019 21.3427 10.5018 21.3358 10.5019 21.3288C10.5027 21.2469 10.5107 21.1407 10.5258 21.01L10.6196 20.2036C10.6513 19.9309 10.6393 19.7109 10.5819 19.545C10.5323 19.39 10.43 19.283 10.2764 19.2247C10.5954 19.0841 10.7788 18.777 10.8325 18.3154L10.8652 18.0334C10.9072 17.6719 10.8523 17.4003 10.6952 17.2238C10.5383 17.0426 10.2683 16.9546 9.89132 16.9546H8.96203C8.86813 16.9546 8.78323 17.0302 8.77239 17.1235L8.27279 21.4217C8.26195 21.5149 8.32928 21.5906 8.42317 21.5906H8.85607C8.94996 21.5906 9.03487 21.5149 9.04571 21.4217L9.24048 19.746C9.24833 19.6784 9.30983 19.6237 9.37783 19.6237H9.48208C9.64623 19.6237 9.74924 19.6645 9.80005 19.7394ZM9.8959 18.8168L9.8959 18.8168L9.89535 18.8174C9.82305 18.8853 9.71837 18.9215 9.5769 18.9215H9.45945C9.39145 18.9215 9.34268 18.8667 9.35053 18.7992L9.4691 17.7791C9.47695 17.7116 9.53845 17.6568 9.60645 17.6568H9.7899C9.91299 17.6568 9.99304 17.6925 10.0366 17.7591L10.0366 17.7591L10.0371 17.7598C10.0856 17.8278 10.103 17.9413 10.0839 18.1056L10.0428 18.4596C10.0227 18.6321 9.97204 18.749 9.8959 18.8168ZM5.33122 21.3471C5.50198 21.5542 5.76993 21.6561 6.13088 21.6561C6.49182 21.6561 6.78347 21.5542 7.00236 21.3471C7.22085 21.1405 7.35028 20.85 7.39341 20.4789L7.67385 18.0662C7.71698 17.6952 7.65508 17.4047 7.48463 17.198C7.31387 16.991 7.04592 16.889 6.68497 16.889C6.32403 16.889 6.03238 16.991 5.81349 17.198C5.595 17.4047 5.46557 17.6952 5.42244 18.0662L5.142 20.4789C5.09887 20.85 5.16077 21.1405 5.33122 21.3471ZM6.61516 20.5248C6.59793 20.673 6.55462 20.7798 6.48876 20.8493C6.4237 20.9179 6.33298 20.9539 6.21249 20.9539C6.092 20.9539 6.00966 20.9179 5.96056 20.8493C5.91085 20.7798 5.89236 20.673 5.90959 20.5248L6.20069 18.0203C6.21792 17.8722 6.26123 17.7654 6.3271 17.6959C6.39215 17.6272 6.48287 17.5912 6.60336 17.5912C6.72385 17.5912 6.80619 17.6272 6.85529 17.6959C6.905 17.7654 6.92349 17.8722 6.90626 18.0203L6.61516 20.5248Z",
                                        stroke: "white",
                                        strokeWidth: 0.046875
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14.2189 22.0256L14.2189 22.0256L14.2183 22.0262C14.1318 22.1137 14.0132 22.1591 13.8586 22.1591H13.5095C13.4415 22.1591 13.3923 22.1043 13.3996 22.0367L13.843 17.9276C13.8503 17.86 13.9114 17.8052 13.9794 17.8052H14.3285C14.4831 17.8052 14.5919 17.8506 14.6595 17.9381L14.6595 17.9381L14.66 17.9387C14.733 18.0262 14.7613 18.1715 14.7387 18.3804L14.393 21.5839C14.3704 21.7928 14.3108 21.9381 14.2189 22.0256ZM22.5393 20.6039L22.5393 20.6039L22.5397 20.6044C22.6172 20.7093 22.6441 20.8985 22.6138 21.1791L22.4923 22.3056C22.4676 22.5343 22.4562 22.6942 22.4585 22.7839C22.4601 22.8437 22.4667 22.906 22.4783 22.9707C22.4909 23.0409 22.552 23.0858 22.6237 23.0858H23.2859C23.4102 23.0858 23.5023 22.9592 23.4892 22.845C23.4853 22.811 23.4833 22.777 23.4832 22.7431L23.4596 22.7456L23.4832 22.7432C23.4834 22.6329 23.493 22.49 23.5119 22.3144L23.6287 21.2319C23.6682 20.8665 23.6496 20.5724 23.5713 20.3511C23.5019 20.1391 23.359 19.9947 23.1443 19.9188C23.5781 19.7357 23.8258 19.3243 23.8935 18.6972L23.9343 18.3188C23.9866 17.8345 23.9099 17.4724 23.699 17.2375C23.4886 16.9965 23.128 16.8785 22.6234 16.8785H21.3271C21.2332 16.8785 21.1489 16.9542 21.1389 17.0476L20.5054 22.9168C20.4953 23.0101 20.5633 23.0858 20.6572 23.0858H21.3378C21.4316 23.0858 21.5159 23.0101 21.526 22.9168L21.7795 20.5679C21.7868 20.5003 21.8479 20.4455 21.9159 20.4455H22.1057C22.3269 20.4455 22.4685 20.5006 22.5393 20.6039ZM22.656 19.376L22.6554 19.3765C22.5569 19.4699 22.4144 19.5188 22.2234 19.5188H22.0159C21.9479 19.5188 21.8987 19.464 21.906 19.3964L22.0645 17.9276C22.0718 17.86 22.1328 17.8052 22.2008 17.8052H22.4969C22.6635 17.8052 22.774 17.8536 22.8349 17.9457L22.8348 17.9457L22.8353 17.9464C22.9026 18.0398 22.9271 18.1945 22.9033 18.4156L22.852 18.8908C22.8269 19.1232 22.7598 19.2828 22.656 19.376ZM14.4463 16.8785H13.1057C13.0118 16.8785 12.9275 16.9542 12.9174 17.0476L12.284 22.9168C12.2739 23.0101 12.3418 23.0858 12.4357 23.0858H13.7763C14.2643 23.0858 14.6485 22.9555 14.9249 22.6911C15.2008 22.4272 15.3641 22.0421 15.4183 21.5399L15.7546 18.4244C15.8088 17.9222 15.7285 17.5372 15.5096 17.2732C15.2903 17.0088 14.9342 16.8785 14.4463 16.8785ZM19.0295 16.8785H17.9598C17.8765 16.8785 17.799 16.9386 17.7767 17.0204L16.1819 22.8896C16.1539 22.9924 16.2237 23.0858 16.3285 23.0858H16.9323C17.0167 23.0858 17.095 23.0242 17.1162 22.9412L17.3598 21.9848C17.3751 21.9247 17.4318 21.8801 17.493 21.8801H18.455L18.496 22.9944C18.4979 23.0468 18.5389 23.0858 18.5922 23.0858H19.321C19.4258 23.0858 19.5157 22.9924 19.51 22.8896L19.182 17.0204C19.1775 16.9386 19.1129 16.8785 19.0295 16.8785ZM18.3253 18.0806L18.4211 20.8578C18.4237 20.9315 18.359 20.9974 18.2841 20.9974H17.7449C17.6701 20.9974 17.6197 20.9317 17.6379 20.8581L18.3253 18.0806ZM22.855 17.9315C22.9269 18.0313 22.9508 18.1926 22.9267 18.4156L22.8754 18.8908C22.8501 19.1255 22.7819 19.2928 22.6708 19.3925L22.855 17.9315ZM27.8046 16.8785H25.4421C25.3483 16.8785 25.264 16.9542 25.2539 17.0476L24.6204 22.9168C24.6104 23.0101 24.6783 23.0858 24.7722 23.0858H27.1347C27.2286 23.0858 27.3129 23.0101 27.3229 22.9168L27.3865 22.3281C27.3965 22.2348 27.3286 22.1591 27.2347 22.1591H25.846C25.7779 22.1591 25.7287 22.1043 25.736 22.0367L25.9088 20.4359C25.9161 20.3683 25.9771 20.3135 26.0451 20.3135H27.0887C27.1826 20.3135 27.2668 20.2378 27.2769 20.1445L27.3404 19.5558C27.3505 19.4625 27.2826 19.3868 27.1887 19.3868H26.1452C26.0772 19.3868 26.0279 19.332 26.0352 19.2644L26.1795 17.9276C26.1868 17.86 26.2479 17.8052 26.3159 17.8052H27.7046C27.7985 17.8052 27.8828 17.7295 27.8929 17.6362L27.9564 17.0476C27.9665 16.9542 27.8985 16.8785 27.8046 16.8785Z",
                                fill: "white",
                                stroke: "white",
                                strokeWidth: 0.046875
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter3_dii_2_31)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M16.2967 25.7057C16.3665 25.517 16.6335 25.517 16.7033 25.7057L16.9718 26.4313C16.9938 26.4907 17.0406 26.5375 17.0999 26.5594L17.8255 26.8279C18.0143 26.8978 18.0143 27.1647 17.8255 27.2346L17.0999 27.5031C17.0406 27.525 16.9938 27.5718 16.9718 27.6312L16.7033 28.3568C16.6335 28.5455 16.3665 28.5455 16.2967 28.3568L16.0282 27.6312C16.0062 27.5718 15.9594 27.525 15.9001 27.5031L15.1745 27.2346C14.9857 27.1647 14.9857 26.8978 15.1745 26.8279L15.9001 26.5594C15.9594 26.5375 16.0062 26.4907 16.0282 26.4313L16.2967 25.7057Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter4_dii_2_31)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M16.2967 3.67447C16.3665 3.48573 16.6335 3.48573 16.7033 3.67447L16.9718 4.40009C16.9938 4.45943 17.0406 4.50622 17.0999 4.52817L17.8255 4.79668C18.0143 4.86652 18.0143 5.13348 17.8255 5.20332L17.0999 5.47183C17.0406 5.49378 16.9938 5.54057 16.9718 5.59991L16.7033 6.32553C16.6335 6.51427 16.3665 6.51427 16.2967 6.32553L16.0282 5.59991C16.0062 5.54057 15.9594 5.49378 15.9001 5.47183L15.1745 5.20332C14.9857 5.13348 14.9857 4.86652 15.1745 4.79668L15.9001 4.52817C15.9594 4.50622 16.0062 4.45943 16.0282 4.40009L16.2967 3.67447Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_2_31",
                        x: 0.5,
                        y: 0,
                        width: 32,
                        height: 42.2335,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 11.4077
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 5.11675
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.917647 0 0 0 0 0.101961 0 0 0 0 0.439216 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_2_31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_2_31",
                        x: 4.13335,
                        y: 8.56042,
                        width: 24.8194,
                        height: 16.1036,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.583089
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.485908
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_2_31",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.0707813
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.601641
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.264609
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.194363
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_2_31",
                                result: "effect3_innerShadow_2_31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_d_2_31",
                        x: 4.99195,
                        y: 16.8658,
                        width: 6.02369,
                        height: 5.04006,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.113217
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.0566084
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_2_31",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter3_dii_2_31",
                        x: 14.0611,
                        y: 25.0874,
                        width: 4.8778,
                        height: 4.9658,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.583089
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.485908
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_2_31",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.727031
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.238359
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.194363
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.194363
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_2_31",
                                result: "effect3_innerShadow_2_31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter4_dii_2_31",
                        x: 14.0611,
                        y: 3.05619,
                        width: 4.8778,
                        height: 4.9658,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.583089
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.485908
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_2_31",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.727031
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.238359
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_2_31"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.194363
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.194363
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_2_31",
                                result: "effect3_innerShadow_2_31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_2_31",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: 32,
                            height: 32,
                            fill: "white",
                            transform: "translate(0.5)"
                        })
                    })
                ]
            })
        ]
    }));
};
var IconDonation = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        width: 33,
        height: 32,
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_3548_84500)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter0_i_3548_84500)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: 0.5,
                            width: 32,
                            height: 32,
                            fill: "#FD8900"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter1_dii_3548_84500)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M16.0571 25.6004C16.1823 25.7283 16.3528 25.7993 16.5313 25.7993C16.7097 25.7993 16.8802 25.7283 17.0055 25.6004L25.5251 16.9679C29.0781 13.3688 26.5535 7.15088 21.5006 7.15088C18.4663 7.15088 17.0738 9.3807 16.5313 9.79718C15.986 9.37892 14.6025 7.15088 11.5619 7.15088C6.52504 7.15088 3.96931 13.3528 7.53827 16.9679L16.0571 25.6004Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter2_dii_3548_84500)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M21.8438 25.4375C24.795 25.4375 27.1875 23.045 27.1875 20.0938C27.1875 17.1425 24.795 14.75 21.8438 14.75C18.8925 14.75 16.5 17.1425 16.5 20.0938C16.5 23.045 18.8925 25.4375 21.8438 25.4375Z",
                                fill: "#267E17"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M27.1705 20.0938C27.1705 23.0356 24.7856 25.4205 21.8438 25.4205C18.9019 25.4205 16.517 23.0356 16.517 20.0938C16.517 17.1519 18.9019 14.767 21.8438 14.767C24.7856 14.767 27.1705 17.1519 27.1705 20.0938Z",
                                stroke: "url(#paint0_linear_3548_84500)",
                                strokeOpacity: 0.5,
                                strokeWidth: 0.0340466,
                                style: {
                                    mixBlendMode: "overlay"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        filter: "url(#filter3_dii_3548_84500)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M22.3995 19.5381H21.288C20.9545 19.5381 20.7322 19.3158 20.7322 18.9823C20.7322 18.6489 20.9545 18.4266 21.288 18.4266H22.9553C23.2888 18.4266 23.5111 18.2042 23.5111 17.8708C23.5111 17.5373 23.2887 17.315 22.9553 17.315H22.3995C22.3995 16.9816 22.1772 16.7593 21.8438 16.7593C21.5103 16.7593 21.288 16.9816 21.288 17.315C20.3432 17.315 19.6207 18.0375 19.6207 18.9824C19.6207 19.9272 20.3432 20.6497 21.288 20.6497H22.3996C22.7331 20.6497 22.9554 20.872 22.9554 21.2055C22.9554 21.5389 22.733 21.7612 22.3996 21.7612H20.7323C20.3988 21.7612 20.1765 21.9836 20.1765 22.317C20.1765 22.6505 20.3988 22.8728 20.7323 22.8728H21.288C21.288 23.2062 21.5104 23.4285 21.8438 23.4285C22.1773 23.4285 22.3995 23.2062 22.3995 22.8728C23.3444 22.8728 24.0669 22.1503 24.0669 21.2054C24.0669 20.2606 23.3444 19.5381 22.3995 19.5381Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_3548_84500",
                        x: 0.5,
                        y: 0,
                        width: 32,
                        height: 36.1421,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 4.14213
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 5.11675
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_3548_84500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_3548_84500",
                        x: 4.42725,
                        y: 5.59254,
                        width: 24.205,
                        height: 22.5217,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.868111
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.723426
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3548_84500",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -1.55834
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 2.38497
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.929412 0 0 0 0 0.556863 0 0 0 0 0 0 0 0 0.55 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.28937
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.28937
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_3548_84500",
                                result: "effect3_innerShadow_3548_84500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter2_dii_3548_84500",
                        x: 15.597,
                        y: 14.3888,
                        width: 12.4934,
                        height: 14.0572,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.541778
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.451481
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3548_84500",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 3.00854
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 3.71644
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "shape",
                                result: "effect2_innerShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.455033
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 1.0214
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "overlay",
                                in2: "effect2_innerShadow_3548_84500",
                                result: "effect3_innerShadow_3548_84500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter3_dii_3548_84500",
                        x: 19.1134,
                        y: 16.4042,
                        width: 5.46079,
                        height: 7.83622,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: 0.304379
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.253649
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_3548_84500",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.355109
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.405839
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.14902 0 0 0 0 0.494118 0 0 0 0 0.0901961 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_3548_84500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: -0.10146
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: 0.10146
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_3548_84500",
                                result: "effect3_innerShadow_3548_84500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_3548_84500",
                        x1: 21.8438,
                        y1: 14.75,
                        x2: 21.8438,
                        y2: 25.4375,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: 1,
                                stopColor: "white",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_3548_84500",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: 32,
                            height: 32,
                            fill: "white",
                            transform: "translate(0.5)"
                        })
                    })
                ]
            })
        ]
    }));
};
var IconVideoShoutout = function(props) {
    return /*#__PURE__*/ _jsx("img", _objectSpread({}, props, {
        src: "https://i.ecomobi.com/ssp/Video-shoutout/video-shoutout-icon.png"
    }));
};
var SpacerAndDividerIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_36079_317161)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#0A72FB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_36079_317161)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.5 17.5C19.5 18.8807 18.3807 20 17 20C15.6193 20 14.5 18.8807 14.5 17.5C14.5 16.1193 15.6193 15 17 15C18.3807 15 19.5 16.1193 19.5 17.5Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M26.5 17.5C26.5 18.8807 25.3807 20 24 20C22.6193 20 21.5 18.8807 21.5 17.5C21.5 16.1193 22.6193 15 24 15C25.3807 15 26.5 16.1193 26.5 17.5Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M31 20C32.3807 20 33.5 18.8807 33.5 17.5C33.5 16.1193 32.3807 15 31 15C29.6193 15 28.5 16.1193 28.5 17.5C28.5 18.8807 29.6193 20 31 20Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12ZM12 11H36C36.5523 11 37 11.4477 37 12V36C37 36.5523 36.5523 37 36 37H12C11.4477 37 11 36.5523 11 36V12C11 11.4477 11.4477 11 12 11Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_36079_317161",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_36079_317161"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_36079_317161",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_36079_317161"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_36079_317161",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_36079_317161"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_36079_317161",
                                result: "effect3_innerShadow_36079_317161"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var CombinedBlockIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_i_1908_368244)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        rx: "8",
                        fill: "#12AD56"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_1908_368244)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                                id: "path-2-inside-1_1908_368244",
                                fill: "white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12Z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12 11H36V5H12V11ZM37 12V36H43V12H37ZM36 37H12V43H36V37ZM11 36V12H5V36H11ZM12 37C11.4477 37 11 36.5523 11 36H5C5 39.866 8.13401 43 12 43V37ZM37 36C37 36.5523 36.5523 37 36 37V43C39.866 43 43 39.866 43 36H37ZM36 11C36.5523 11 37 11.4477 37 12H43C43 8.13401 39.866 5 36 5V11ZM12 5C8.13401 5 5 8.13401 5 12H11C11 11.4477 11.4477 11 12 11V5Z",
                                fill: "white",
                                mask: "url(#path-2-inside-1_1908_368244)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M15 17C15 15.8954 15.8954 15 17 15H31C32.1046 15 33 15.8954 33 17V20.4483C33 21.5529 32.1046 22.4483 31 22.4483H17C15.8954 22.4483 15 21.5529 15 20.4483V17Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M15 27.4483C15 26.3437 15.8954 25.4483 17 25.4483H31C32.1046 25.4483 33 26.3437 33 27.4483V30.8966C33 32.0012 32.1046 32.8966 31 32.8966H17C15.8954 32.8966 15 32.0012 15 30.8966V27.4483Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_1908_368244",
                        x: "0",
                        y: "0",
                        width: "48",
                        height: "56.2843",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "8.28426"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "10.2335"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1908_368244"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_1908_368244",
                        x: "6.76",
                        y: "7.13",
                        width: "34.605",
                        height: "34.985",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "0.75"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.62"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1908_368244"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1908_368244",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.87"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_1908_368244"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "0.25"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_1908_368244",
                                result: "effect3_innerShadow_1908_368244"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var BookingProfileBlockIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 48 : _width, _height = param.height, height = _height === void 0 ? 48 : _height, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 1024 1024",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2462_25036)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter0_i_2462_25036)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "1024",
                                height: "1024",
                                fill: "#FF0066"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "1024",
                                height: "1024",
                                fill: "white",
                                "fill-opacity": "0.2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M882 512C882 307.654 716.345 142 512 142C307.655 142 142 307.654 142 512C142 716.345 307.655 881.999 512 881.999C716.345 881.999 882 716.345 882 512Z",
                        stroke: "url(#paint0_linear_2462_25036)",
                        strokeWidth: "40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        filter: "url(#filter1_dii_2462_25036)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M711.619 647.82C815.878 587.346 815.878 436.791 711.619 376.316L524.248 267.631C419.624 206.944 288.568 282.433 288.568 403.384L288.568 620.753C288.568 741.704 419.624 817.192 524.248 756.505L711.619 647.82ZM629.184 540.87C651.311 528.044 651.311 496.094 629.184 483.268L471.958 392.131C449.764 379.267 421.973 395.28 421.973 420.933L421.973 603.206C421.973 628.858 449.764 644.871 471.958 632.007L629.184 540.87Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "288.569",
                                y: "564.179",
                                width: "133.396",
                                height: "236.087",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M288.568 935.156C390.862 926.13 420.121 848.879 421.965 811.381V780.267H288.568V935.156Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_i_2462_25036",
                        x: "0",
                        y: "0",
                        width: "1024",
                        height: "1240.73",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feMorphology", {
                                radius: "57",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "effect1_innerShadow_2462_25036"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "216.73"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "218.315"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.709804 0 0 0 0 0 0 0 0 0 0.698039 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_2462_25036"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter1_dii_2462_25036",
                        x: "271.236",
                        y: "227.544",
                        width: "535.91",
                        height: "735.344",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "10.3993"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "8.6661"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2462_25036"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_2462_25036",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-18.6677"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "54.0247"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.4 0 0 0 0.55 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_2462_25036"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "-3.46644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "3.46644"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_innerShadow_2462_25036",
                                result: "effect3_innerShadow_2462_25036"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_2462_25036",
                        x1: "512",
                        y1: "901.999",
                        x2: "512",
                        y2: "122",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                "stop-color": "#FF98D0",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FF98D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_2462_25036",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "1024",
                            height: "1024",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 64035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ TikiIcon; },
/* harmony export */   "$o": function() { return /* binding */ ArrowUpLeft; },
/* harmony export */   "AD": function() { return /* binding */ RightArrowIcon; },
/* harmony export */   "AY": function() { return /* binding */ ShareIconV2; },
/* harmony export */   "AZ": function() { return /* binding */ BackgroundIcon; },
/* harmony export */   "Ao": function() { return /* binding */ FolderArrowRightIcon; },
/* harmony export */   "BW": function() { return /* binding */ CheckCircleIconV3; },
/* harmony export */   "CE": function() { return /* binding */ CrownIcon; },
/* harmony export */   "E8": function() { return /* binding */ ImageSliderIcon; },
/* harmony export */   "EL": function() { return /* binding */ FavouriteIcon; },
/* harmony export */   "FS": function() { return /* binding */ PubLishIcon; },
/* harmony export */   "Fl": function() { return /* binding */ EyeHiddenIcon; },
/* harmony export */   "GD": function() { return /* binding */ CloseCircleIconV2; },
/* harmony export */   "GV": function() { return /* binding */ ArrowCenter; },
/* harmony export */   "Gu": function() { return /* binding */ ArrowUpRight; },
/* harmony export */   "Hn": function() { return /* binding */ ClosePopupIcon; },
/* harmony export */   "Hw": function() { return /* binding */ InfomationCircleIcon; },
/* harmony export */   "J$": function() { return /* binding */ CircleIcon; },
/* harmony export */   "J0": function() { return /* binding */ StoryIcon; },
/* harmony export */   "K5": function() { return /* binding */ ArrowDown; },
/* harmony export */   "KL": function() { return /* binding */ DownIcon; },
/* harmony export */   "KP": function() { return /* binding */ AdvanceSettingIcon; },
/* harmony export */   "Kp": function() { return /* binding */ DuplicatedIcon; },
/* harmony export */   "LC": function() { return /* binding */ AngleDownIcon; },
/* harmony export */   "LP": function() { return /* binding */ ExclamationTriangleIcon; },
/* harmony export */   "LR": function() { return /* binding */ ColorIcon; },
/* harmony export */   "LZ": function() { return /* binding */ ArrowRightIcon; },
/* harmony export */   "Lm": function() { return /* binding */ InformationTriangleIcon; },
/* harmony export */   "Mq": function() { return /* binding */ NextImageSliderIcon; },
/* harmony export */   "Mw": function() { return /* binding */ PenIcon; },
/* harmony export */   "N": function() { return /* binding */ SaveIcon; },
/* harmony export */   "NC": function() { return /* binding */ ArrowDownRight; },
/* harmony export */   "Nz": function() { return /* binding */ BackAngelIcon; },
/* harmony export */   "PL": function() { return /* binding */ TabDefaultIcon; },
/* harmony export */   "Pz": function() { return /* binding */ ErrorIcon; },
/* harmony export */   "QL": function() { return /* binding */ IconDefault; },
/* harmony export */   "Qq": function() { return /* binding */ ExpandIcon; },
/* harmony export */   "SC": function() { return /* binding */ BanIcon; },
/* harmony export */   "T8": function() { return /* binding */ AddIcon; },
/* harmony export */   "TI": function() { return /* binding */ CopyIcon; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "UF": function() { return /* binding */ DesignIcon; },
/* harmony export */   "UO": function() { return /* binding */ QuestionIcon; },
/* harmony export */   "V7": function() { return /* binding */ CopyIconV2; },
/* harmony export */   "VP": function() { return /* binding */ IconIsNotChecked; },
/* harmony export */   "Vj": function() { return /* binding */ BroomIcon; },
/* harmony export */   "Vn": function() { return /* binding */ DragIcon; },
/* harmony export */   "Vt": function() { return /* binding */ StoreIcon; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "W5": function() { return /* binding */ CollapseIcon; },
/* harmony export */   "Wr": function() { return /* binding */ ClosePositionInfoIcon; },
/* harmony export */   "X0": function() { return /* binding */ ThemeStoreIcon; },
/* harmony export */   "XB": function() { return /* binding */ ImageIcon; },
/* harmony export */   "XH": function() { return /* binding */ TrashIcon; },
/* harmony export */   "Xd": function() { return /* binding */ ArrowLeft; },
/* harmony export */   "Xy": function() { return /* binding */ IndeterminateCheckboxIcon; },
/* harmony export */   "YP": function() { return /* binding */ ShopeeIcon; },
/* harmony export */   "Ye": function() { return /* binding */ TickIcon; },
/* harmony export */   "Yk": function() { return /* binding */ InformationIcon; },
/* harmony export */   "Z": function() { return /* binding */ IconImage; },
/* harmony export */   "_H": function() { return /* binding */ EditIconV2; },
/* harmony export */   "_K": function() { return /* binding */ CardIcon; },
/* harmony export */   "_L": function() { return /* binding */ PreviousImageSliderIcon; },
/* harmony export */   "_f": function() { return /* binding */ AngelDownIcon; },
/* harmony export */   "a2": function() { return /* binding */ ArrowUp; },
/* harmony export */   "aA": function() { return /* binding */ LazadaIcon; },
/* harmony export */   "aN": function() { return /* binding */ WarningIcon; },
/* harmony export */   "aZ": function() { return /* binding */ ButtonMultiLinkIcon; },
/* harmony export */   "ag": function() { return /* binding */ AddCircleIcon; },
/* harmony export */   "b0": function() { return /* binding */ XIcon; },
/* harmony export */   "bR": function() { return /* binding */ CloseIconAlert; },
/* harmony export */   "bj": function() { return /* binding */ TemplateIcon; },
/* harmony export */   "cD": function() { return /* binding */ WarningIconIntroBrandGift; },
/* harmony export */   "cO": function() { return /* binding */ EmptyBlocksInCombined; },
/* harmony export */   "cR": function() { return /* binding */ LineRename; },
/* harmony export */   "ci": function() { return /* binding */ CommentInformationIcon; },
/* harmony export */   "e0": function() { return /* binding */ ArrowIcon; },
/* harmony export */   "e3": function() { return /* binding */ UploadIcon; },
/* harmony export */   "e8": function() { return /* binding */ AngelUpIcon; },
/* harmony export */   "ef": function() { return /* binding */ CoppyIcon; },
/* harmony export */   "ek": function() { return /* binding */ FrameIcon; },
/* harmony export */   "fX": function() { return /* binding */ InfomationPositionIcon; },
/* harmony export */   "fv": function() { return /* binding */ ButtonLinkIcon; },
/* harmony export */   "fx": function() { return /* binding */ XIconV2; },
/* harmony export */   "gc": function() { return /* binding */ PreviewThemeIcon; },
/* harmony export */   "gn": function() { return /* binding */ CrownIconNoColor; },
/* harmony export */   "gz": function() { return /* binding */ ClosePopupIconV2; },
/* harmony export */   "hd": function() { return /* binding */ MoveToBottomIcon; },
/* harmony export */   "ix": function() { return /* binding */ SampleSelectionIcon; },
/* harmony export */   "jJ": function() { return /* binding */ EditTabIcon; },
/* harmony export */   "jN": function() { return /* binding */ ShareIcon; },
/* harmony export */   "jS": function() { return /* binding */ CrownIconV2; },
/* harmony export */   "jt": function() { return /* binding */ PackageIcon; },
/* harmony export */   "kI": function() { return /* binding */ PlaceHolderImageIcon; },
/* harmony export */   "ki": function() { return /* binding */ PassioIcon; },
/* harmony export */   "l1": function() { return /* binding */ ReplaceIcon; },
/* harmony export */   "l2": function() { return /* binding */ ArrowDownLeft; },
/* harmony export */   "lP": function() { return /* binding */ ImageGalleryIcon; },
/* harmony export */   "lo": function() { return /* binding */ CheckCircleIconV2; },
/* harmony export */   "m0": function() { return /* binding */ EyeVisibleIcon; },
/* harmony export */   "mP": function() { return /* binding */ BroomLockIcon; },
/* harmony export */   "mw": function() { return /* binding */ OpenNewTab; },
/* harmony export */   "n6": function() { return /* binding */ SwatchBookIcon; },
/* harmony export */   "nH": function() { return /* binding */ IntroIcon; },
/* harmony export */   "nX": function() { return /* binding */ MoreIcon; },
/* harmony export */   "oS": function() { return /* binding */ DropDownIcon2; },
/* harmony export */   "ol": function() { return /* binding */ ArrowRight; },
/* harmony export */   "ox": function() { return /* binding */ AddIconTemplateV2; },
/* harmony export */   "pJ": function() { return /* binding */ DeleteIcon; },
/* harmony export */   "pT": function() { return /* binding */ QuestionCircleIcon; },
/* harmony export */   "q7": function() { return /* binding */ HotIcon; },
/* harmony export */   "qY": function() { return /* binding */ SettingIcon; },
/* harmony export */   "qo": function() { return /* binding */ InformationIconCombined; },
/* harmony export */   "rE": function() { return /* binding */ CheckCircleIcon; },
/* harmony export */   "rG": function() { return /* binding */ SaleIcon; },
/* harmony export */   "s9": function() { return /* binding */ ShareIconV3; },
/* harmony export */   "tL": function() { return /* binding */ EmptyIcon; },
/* harmony export */   "tO": function() { return /* binding */ CoppyAltIcon; },
/* harmony export */   "tm": function() { return /* binding */ SuccessIcon; },
/* harmony export */   "tv": function() { return /* binding */ HomeIcon; },
/* harmony export */   "u4": function() { return /* binding */ RandomizeIcon; },
/* harmony export */   "uC": function() { return /* binding */ CloseCircleIcon; },
/* harmony export */   "v": function() { return /* binding */ RestoreIcon; },
/* harmony export */   "ww": function() { return /* binding */ GlobalIcon; },
/* harmony export */   "xC": function() { return /* binding */ BackIcon; },
/* harmony export */   "xj": function() { return /* binding */ RenameIcon; },
/* harmony export */   "xx": function() { return /* binding */ InboxIcon; },
/* harmony export */   "yI": function() { return /* binding */ ImageIconEmpty; },
/* harmony export */   "yS": function() { return /* binding */ MoveToTopIcon; },
/* harmony export */   "yu": function() { return /* binding */ DropDownIcon1; },
/* harmony export */   "z": function() { return /* binding */ IconIsChecked; }
/* harmony export */ });
/* unused harmony exports TabIcon, BlockIcon, EditIcon, TextIcon, EmbedIcon, CardIconV2, UndoIcon, RedoIcon, ThemeChangeIcon, ConfirmIcon, ExitIcon, ClearFormatIcon, TabInitialIcon, DeleteTabIcon, CloseCircleSolidIcon, UploadImageIcon, ImageIconV2, VideoIcon, EditTabDesignIcon, DefaultIcon, BookMarkIcon, EmptyImagePopupIcon, InfoIcon, AddCircleIconV2, AddIconTemplate */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DesignIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.1246 0.748845C19.6382 0.28553 18.9922 0.0270996 18.3204 0.0270996C17.6487 0.0270996 17.0027 0.28553 16.5163 0.748845L7.17708 10.0822C6.88654 10.0262 6.5913 9.99833 6.29542 9.99883C5.69392 9.99711 5.09806 10.1147 4.54233 10.3449C3.98661 10.575 3.48206 10.9132 3.05792 11.3397C1.93125 12.4672 1.13625 15.4922 0.900418 17.1347C0.848102 17.49 0.872958 17.8524 0.973297 18.1973C1.07364 18.5421 1.2471 18.8613 1.48188 19.1331C1.71666 19.4049 2.00725 19.6229 2.33386 19.7723C2.66047 19.9217 3.01543 19.9989 3.37458 19.9988C3.49699 19.9989 3.61924 19.9903 3.74042 19.973C5.38292 19.7372 8.40708 18.9422 9.53542 17.8155C10.0652 17.2842 10.4563 16.6307 10.6743 15.9127C10.8923 15.1948 10.9304 14.4342 10.7854 13.698L20.1246 4.35717C20.6018 3.87801 20.8698 3.22928 20.8698 2.55301C20.8698 1.87674 20.6018 1.22801 20.1246 0.748845ZM8.35542 16.6372C7.75125 17.2413 5.43875 18.0447 3.50209 18.323C3.37266 18.3417 3.24065 18.3301 3.11645 18.2892C2.99224 18.2483 2.87922 18.1791 2.78625 18.0872C2.69361 17.9947 2.62406 17.8817 2.58323 17.7573C2.54241 17.6329 2.53145 17.5007 2.55125 17.3713C2.82875 15.4355 3.63458 13.1213 4.23625 12.518C4.79145 12.018 5.51739 11.7501 6.26433 11.7696C7.01127 11.7891 7.72223 12.0945 8.25058 12.6228C8.77892 13.1512 9.08435 13.8621 9.10386 14.6091C9.12336 15.356 8.85547 16.082 8.35542 16.6372ZM18.9479 3.17884L10.0971 12.0305C9.76823 11.5326 9.34326 11.1053 8.84709 10.7738L17.6946 1.92551C17.8629 1.76474 18.0868 1.67503 18.3196 1.67503C18.5524 1.67503 18.7762 1.76474 18.9446 1.92551C19.0272 2.0075 19.0929 2.105 19.1378 2.21242C19.1828 2.31983 19.206 2.43506 19.2063 2.55148C19.2067 2.66791 19.184 2.78326 19.1396 2.89091C19.0953 2.99857 19.0301 3.09641 18.9479 3.17884Z",
            fill: fillColor
        })
    });
};
var TabIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10 5C9.80222 5 9.60888 5.05865 9.44443 5.16853C9.27998 5.27841 9.15181 5.43459 9.07612 5.61732C9.00043 5.80004 8.98063 6.00111 9.01921 6.19509C9.0578 6.38907 9.15304 6.56725 9.29289 6.70711C9.43275 6.84696 9.61093 6.9422 9.80491 6.98079C9.99889 7.01937 10.2 6.99957 10.3827 6.92388C10.5654 6.84819 10.7216 6.72002 10.8315 6.55557C10.9414 6.39112 11 6.19778 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01921 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM14 5C13.8022 5 13.6089 5.05865 13.4444 5.16853C13.28 5.27841 13.1518 5.43459 13.0761 5.61732C13.0004 5.80004 12.9806 6.00111 13.0192 6.19509C13.0578 6.38907 13.153 6.56725 13.2929 6.70711C13.4327 6.84696 13.6109 6.9422 13.8049 6.98079C13.9989 7.01937 14.2 6.99957 14.3827 6.92388C14.5654 6.84819 14.7216 6.72002 14.8315 6.55557C14.9414 6.39112 15 6.19778 15 6C15 5.73478 14.8946 5.48043 14.7071 5.29289C14.5196 5.10536 14.2652 5 14 5ZM20 1H4C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V20C1 20.7956 1.31607 21.5587 1.87868 22.1213C2.44129 22.6839 3.20435 23 4 23H20C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20V4C23 3.20435 22.6839 2.44129 22.1213 1.87868C21.5587 1.31607 20.7956 1 20 1ZM21 20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V11H21V20ZM21 9H3V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V9Z",
            fill: fillColor
        })
    });
};
var BlockIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10 13H4C3.73478 13 3.48043 13.1054 3.29289 13.2929C3.10536 13.4804 3 13.7348 3 14V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H10C10.2652 21 10.5196 20.8946 10.7071 20.7071C10.8946 20.5196 11 20.2652 11 20V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 19H5V15H9V19ZM20 3H14C13.7348 3 13.4804 3.10536 13.2929 3.29289C13.1054 3.48043 13 3.73478 13 4V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H20C20.2652 11 20.5196 10.8946 20.7071 10.7071C20.8946 10.5196 21 10.2652 21 10V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3ZM19 9H15V5H19V9ZM20 16H18V14C18 13.7348 17.8946 13.4804 17.7071 13.2929C17.5196 13.1054 17.2652 13 17 13C16.7348 13 16.4804 13.1054 16.2929 13.2929C16.1054 13.4804 16 13.7348 16 14V16H14C13.7348 16 13.4804 16.1054 13.2929 16.2929C13.1054 16.4804 13 16.7348 13 17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18H16V20C16 20.2652 16.1054 20.5196 16.2929 20.7071C16.4804 20.8946 16.7348 21 17 21C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20V18H20C20.2652 18 20.5196 17.8946 20.7071 17.7071C20.8946 17.5196 21 17.2652 21 17C21 16.7348 20.8946 16.4804 20.7071 16.2929C20.5196 16.1054 20.2652 16 20 16ZM10 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V10C3 10.2652 3.10536 10.5196 3.29289 10.7071C3.48043 10.8946 3.73478 11 4 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V4C11 3.73478 10.8946 3.48043 10.7071 3.29289C10.5196 3.10536 10.2652 3 10 3ZM9 9H5V5H9V9Z",
            fill: fillColor
        })
    });
};
var SettingIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.32 9.55L19.43 8.92L20.32 7.14C20.4102 6.95369 20.4404 6.74397 20.4064 6.53978C20.3723 6.33558 20.2758 6.14699 20.13 6L18 3.87C17.8522 3.72209 17.6618 3.62421 17.4555 3.59013C17.2493 3.55605 17.0375 3.58748 16.85 3.68L15.07 4.57L14.44 2.68C14.3735 2.483 14.2472 2.31163 14.0787 2.18975C13.9102 2.06787 13.7079 2.00155 13.5 2H10.5C10.2904 1.99946 10.0858 2.06482 9.91537 2.18685C9.7449 2.30887 9.61709 2.48138 9.55 2.68L8.92 4.57L7.14 3.68C6.95369 3.58978 6.74397 3.55961 6.53978 3.59364C6.33558 3.62767 6.14699 3.72423 6 3.87L3.87 6C3.72209 6.14777 3.62421 6.33818 3.59013 6.54446C3.55605 6.75074 3.58748 6.96251 3.68 7.15L4.57 8.93L2.68 9.56C2.483 9.62654 2.31163 9.75283 2.18975 9.92131C2.06787 10.0898 2.00155 10.2921 2 10.5V13.5C1.99946 13.7096 2.06482 13.9142 2.18685 14.0846C2.30887 14.2551 2.48138 14.3829 2.68 14.45L4.57 15.08L3.68 16.86C3.58978 17.0463 3.55961 17.256 3.59364 17.4602C3.62767 17.6644 3.72423 17.853 3.87 18L6 20.13C6.14777 20.2779 6.33818 20.3758 6.54446 20.4099C6.75074 20.444 6.96251 20.4125 7.15 20.32L8.93 19.43L9.56 21.32C9.62709 21.5186 9.7549 21.6911 9.92537 21.8132C10.0958 21.9352 10.3004 22.0005 10.51 22H13.51C13.7196 22.0005 13.9242 21.9352 14.0946 21.8132C14.2651 21.6911 14.3929 21.5186 14.46 21.32L15.09 19.43L16.87 20.32C17.0551 20.4079 17.2628 20.4369 17.4649 20.4029C17.667 20.3689 17.8538 20.2737 18 20.13L20.13 18C20.2779 17.8522 20.3758 17.6618 20.4099 17.4555C20.444 17.2493 20.4125 17.0375 20.32 16.85L19.43 15.07L21.32 14.44C21.517 14.3735 21.6884 14.2472 21.8103 14.0787C21.9321 13.9102 21.9985 13.7079 22 13.5V10.5C22.0005 10.2904 21.9352 10.0858 21.8132 9.91537C21.6911 9.7449 21.5186 9.61709 21.32 9.55ZM20 12.78L18.8 13.18C18.5241 13.2695 18.2709 13.418 18.0581 13.6151C17.8452 13.8122 17.6778 14.0533 17.5675 14.3216C17.4571 14.5899 17.4064 14.879 17.419 15.1688C17.4315 15.4586 17.5069 15.7422 17.64 16L18.21 17.14L17.11 18.24L16 17.64C15.7436 17.5122 15.4627 17.4411 15.1763 17.4313C14.89 17.4215 14.6049 17.4734 14.3403 17.5834C14.0758 17.6934 13.8379 17.8589 13.6429 18.0688C13.4479 18.2787 13.3003 18.5281 13.21 18.8L12.81 20H11.22L10.82 18.8C10.7305 18.5241 10.582 18.2709 10.3849 18.0581C10.1878 17.8452 9.94671 17.6778 9.67842 17.5675C9.41014 17.4571 9.12105 17.4064 8.83123 17.419C8.5414 17.4315 8.25777 17.5069 8 17.64L6.86 18.21L5.76 17.11L6.36 16C6.4931 15.7422 6.56852 15.4586 6.58105 15.1688C6.59358 14.879 6.5429 14.5899 6.43254 14.3216C6.32218 14.0533 6.15478 13.8122 5.94195 13.6151C5.72912 13.418 5.47595 13.2695 5.2 13.18L4 12.78V11.22L5.2 10.82C5.47595 10.7305 5.72912 10.582 5.94195 10.3849C6.15478 10.1878 6.32218 9.94671 6.43254 9.67842C6.5429 9.41014 6.59358 9.12105 6.58105 8.83123C6.56852 8.5414 6.4931 8.25777 6.36 8L5.79 6.89L6.89 5.79L8 6.36C8.25777 6.4931 8.5414 6.56852 8.83123 6.58105C9.12105 6.59358 9.41014 6.5429 9.67842 6.43254C9.94671 6.32218 10.1878 6.15478 10.3849 5.94195C10.582 5.72912 10.7305 5.47595 10.82 5.2L11.22 4H12.78L13.18 5.2C13.2695 5.47595 13.418 5.72912 13.6151 5.94195C13.8122 6.15478 14.0533 6.32218 14.3216 6.43254C14.5899 6.5429 14.879 6.59358 15.1688 6.58105C15.4586 6.56852 15.7422 6.4931 16 6.36L17.14 5.79L18.24 6.89L17.64 8C17.5122 8.25645 17.4411 8.53735 17.4313 8.82369C17.4215 9.11003 17.4734 9.39513 17.5834 9.65969C17.6934 9.92424 17.8589 10.1621 18.0688 10.3571C18.2787 10.5521 18.5281 10.6997 18.8 10.79L20 11.19V12.78ZM12 8C11.2089 8 10.4355 8.2346 9.77772 8.67413C9.11993 9.11365 8.60724 9.73836 8.30448 10.4693C8.00173 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61217 14.269 9.17158 14.8284C9.73099 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17158C14.0783 8.42143 13.0609 8 12 8ZM12 14C11.6044 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3036 13.1308 10.1522 12.7654C10.0009 12.3999 9.96126 11.9978 10.0384 11.6098C10.1156 11.2219 10.3061 10.8655 10.5858 10.5858C10.8655 10.3061 11.2219 10.1156 11.6098 10.0384C11.9978 9.96126 12.3999 10.0009 12.7654 10.1522C13.1308 10.3036 13.4432 10.56 13.6629 10.8889C13.8827 11.2178 14 11.6044 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14Z",
            fill: fillColor
        })
    });
};
var InformationIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12.55 15.5H11.45C11.3395 15.5 11.25 15.5895 11.25 15.7V16.8C11.25 16.9105 11.3395 17 11.45 17H12.55C12.6605 17 12.75 16.9105 12.75 16.8V15.7C12.75 15.5895 12.6605 15.5 12.55 15.5ZM12.55 7H11.45C11.3395 7 11.25 7.08954 11.25 7.2V13.8C11.25 13.9105 11.3395 14 11.45 14H12.55C12.6605 14 12.75 13.9105 12.75 13.8V7.2C12.75 7.08954 12.6605 7 12.55 7Z",
            fill: fillColor
        })
    });
};
var CommentInformationIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V15C11 15.2652 11.1054 15.5196 11.2929 15.7071C11.4804 15.8946 11.7348 16 12 16C12.2652 16 12.5196 15.8946 12.7071 15.7071C12.8946 15.5196 13 15.2652 13 15V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11ZM12 8C11.8022 8 11.6089 8.05865 11.4444 8.16853C11.28 8.27841 11.1518 8.43459 11.0761 8.61732C11.0004 8.80004 10.9806 9.00111 11.0192 9.19509C11.0578 9.38907 11.153 9.56725 11.2929 9.70711C11.4327 9.84696 11.6109 9.9422 11.8049 9.98079C11.9989 10.0194 12.2 9.99957 12.3827 9.92388C12.5654 9.84819 12.7216 9.72002 12.8315 9.55557C12.9414 9.39112 13 9.19778 13 9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8ZM12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92894 4.92893C3.05357 6.8043 2 9.34784 2 12C1.99126 14.3091 2.7908 16.5485 4.26 18.33L2.26 20.33C2.12125 20.4706 2.02725 20.6492 1.98988 20.8432C1.9525 21.0372 1.97342 21.2379 2.05 21.42C2.13306 21.5999 2.26771 21.7511 2.43685 21.8544C2.60599 21.9577 2.802 22.0083 3 22H12C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM12 20H5.41L6.34 19.07C6.43449 18.9774 6.50966 18.8669 6.56116 18.7451C6.61265 18.6232 6.63945 18.4923 6.64 18.36C6.63625 18.0962 6.52842 17.8446 6.34 17.66C5.03059 16.352 4.21518 14.6305 4.03269 12.7888C3.85021 10.947 4.31195 9.09901 5.33923 7.55952C6.36652 6.02004 7.89579 4.88436 9.66652 4.34597C11.4372 3.80759 13.3399 3.8998 15.0502 4.60691C16.7606 5.31402 18.1729 6.59227 19.0464 8.22389C19.92 9.85551 20.2009 11.7395 19.8411 13.555C19.4814 15.3705 18.5033 17.005 17.0735 18.1802C15.6438 19.3554 13.8508 19.9985 12 20Z",
            fill: fillColor
        })
    });
};
var InformationTriangleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22.7 17.5L14.6 3.49999C13.8 2.09999 11.9 1.59999 10.5 2.39999C10 2.69999 9.60001 3.09999 9.40001 3.49999L1.30001 17.5C0.500011 18.9 1.00001 20.8 2.40001 21.6C2.90001 21.9 3.40001 22 3.90001 22H20C21.7 22 23 20.6 23 19C23.1 18.4 22.9 17.9 22.7 17.5ZM12 18C11.4 18 11 17.6 11 17C11 16.4 11.4 16 12 16C12.6 16 13 16.4 13 17C13 17.6 12.6 18 12 18ZM13 13C13 13.6 12.6 14 12 14C11.4 14 11 13.6 11 13V8.99999C11 8.39999 11.4 7.99999 12 7.99999C12.6 7.99999 13 8.39999 13 8.99999V13Z",
            fill: fillColor
        })
    });
};
var DragIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.83333 11.8334H14.1667M2.83333 6.16675H14.1667H2.83333Z",
            stroke: "#333333",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var MoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM5 10C4.60444 10 4.21776 10.1173 3.88886 10.3371C3.55996 10.5568 3.30362 10.8692 3.15224 11.2346C3.00087 11.6001 2.96126 12.0022 3.03843 12.3902C3.1156 12.7781 3.30608 13.1345 3.58579 13.4142C3.86549 13.6939 4.22186 13.8844 4.60982 13.9616C4.99778 14.0387 5.39992 13.9991 5.76537 13.8478C6.13082 13.6964 6.44318 13.44 6.66294 13.1111C6.8827 12.7822 7 12.3956 7 12C7 11.4696 6.78929 10.9609 6.41421 10.5858C6.03914 10.2107 5.53043 10 5 10ZM19 10C18.6044 10 18.2178 10.1173 17.8889 10.3371C17.56 10.5568 17.3036 10.8692 17.1522 11.2346C17.0009 11.6001 16.9613 12.0022 17.0384 12.3902C17.1156 12.7781 17.3061 13.1345 17.5858 13.4142C17.8655 13.6939 18.2219 13.8844 18.6098 13.9616C18.9978 14.0387 19.3999 13.9991 19.7654 13.8478C20.1308 13.6964 20.4432 13.44 20.6629 13.1111C20.8827 12.7822 21 12.3956 21 12C21 11.4696 20.7893 10.9609 20.4142 10.5858C20.0391 10.2107 19.5304 10 19 10Z",
            fill: fillColor
        })
    });
};
var RightArrowIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.6974 2.5561L17.7884 11.3306C18.0652 11.6063 18.0815 12.0432 17.8372 12.3378L17.7884 12.3913L8.6978 21.4417C8.66032 21.4791 8.60959 21.5 8.5567 21.5H6.99334C6.88288 21.5 6.79333 21.4105 6.79333 21.3C6.79333 21.2468 6.81453 21.1958 6.85222 21.1583L16.1601 11.8908L6.86186 2.84334C6.78269 2.76631 6.78096 2.63969 6.85799 2.56052C6.89564 2.52183 6.94734 2.5 7.00133 2.5H8.5585C8.61032 2.5 8.66012 2.52011 8.6974 2.5561Z",
            fill: fillColor
        })
    });
};
var AddIcon = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#ffffff" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19 11H13V5C13 4.73478 12.8946 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5V11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H11V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z",
            fill: fillColor
        })
    });
};
var IconDefault = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#b7b7b7" : _fillColor, _width = param.width, width = _width === void 0 ? 27 : _width, _height = param.height, height = _height === void 0 ? 28 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 28 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: fillColor,
            d: "M16.1333 12.0337C16.2666 12.167 16.4 12.167 16.6666 12.167H26C26.8 12.167 27.3333 11.6337 27.3333 10.8337C27.3333 10.567 27.3333 10.4337 27.2 10.3003L22.5333 0.966992C22.1333 0.300325 21.3333 0.0336589 20.6666 0.433659C20.5333 0.566992 20.2666 0.700325 20.1333 0.966992L15.4666 10.3003C15.2 10.8337 15.4666 11.6337 16.1333 12.0337ZM21.3333 4.43366L23.8666 9.50033H18.8L21.3333 4.43366ZM6.66663 0.166992C3.33329 0.166992 0.666626 2.83366 0.666626 6.16699C0.666626 9.50033 3.33329 12.167 6.66663 12.167C9.99996 12.167 12.6666 9.50033 12.6666 6.16699C12.6666 2.83366 9.99996 0.166992 6.66663 0.166992ZM6.66663 9.50033C4.79996 9.50033 3.33329 8.03366 3.33329 6.16699C3.33329 4.30033 4.79996 2.83366 6.66663 2.83366C8.53329 2.83366 9.99996 4.30033 9.99996 6.16699C9.99996 8.03366 8.53329 9.50033 6.66663 9.50033ZM12.2666 15.2337C11.7333 14.7003 10.9333 14.7003 10.4 15.2337L6.66663 18.967L2.93329 15.2337C2.39996 14.7003 1.59996 14.7003 1.06663 15.2337C0.533293 15.767 0.533293 16.567 1.06663 17.1003L4.79996 20.8337L1.06663 24.567C0.533293 25.1003 0.533293 25.9003 1.06663 26.4337C1.59996 26.967 2.39996 26.967 2.93329 26.4337L6.66663 22.7003L10.4 26.4337C10.9333 26.967 11.7333 26.967 12.2666 26.4337C12.8 25.9003 12.8 25.1003 12.2666 24.567L8.53329 20.8337L12.2666 17.1003C12.8 16.567 12.8 15.767 12.2666 15.2337ZM26 14.8337H16.6666C15.8666 14.8337 15.3333 15.367 15.3333 16.167V25.5003C15.3333 26.3003 15.8666 26.8337 16.6666 26.8337H26C26.8 26.8337 27.3333 26.3003 27.3333 25.5003V16.167C27.3333 15.367 26.8 14.8337 26 14.8337ZM24.6666 24.167H18V17.5003H24.6666V24.167Z"
        })
    });
};
var PackageIcon = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#ffffff" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 14H9C9.26522 14 9.51957 13.8946 9.70711 13.7071C9.89464 13.5196 10 13.2652 10 13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM13 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H13C13.2652 18 13.5196 17.8946 13.7071 17.7071C13.8946 17.5196 14 17.2652 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16ZM19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM14 4V7.29L12.49 6.45C12.338 6.36223 12.1655 6.31603 11.99 6.31603C11.8145 6.31603 11.642 6.36223 11.49 6.45L10 7.29V4H14ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00105 9.17451 8.04776 9.34571 8.13547 9.49658C8.22319 9.64746 8.34886 9.77274 8.5 9.86C8.65202 9.94777 8.82446 9.99397 9 9.99397C9.17554 9.99397 9.34798 9.94777 9.5 9.86L12 8.47L14.51 9.87C14.6595 9.9547 14.8282 9.99947 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z",
            fill: fillColor
        })
    });
};
var EditIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onClick = param.onClick, _width = param.width, width = _width === void 0 ? "14" : _width, _height = param.height, height = _height === void 0 ? "15" : _height;
    return /*#__PURE__*/ _jsx("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2.33554 11.5006H5.16221C5.24995 11.5011 5.33692 11.4843 5.41815 11.4511C5.49937 11.4179 5.57325 11.3691 5.63554 11.3073L10.2489 6.68728L12.1422 4.83394C12.2047 4.77197 12.2543 4.69823 12.2881 4.61699C12.322 4.53576 12.3394 4.44862 12.3394 4.36061C12.3394 4.2726 12.322 4.18547 12.2881 4.10423C12.2543 4.02299 12.2047 3.94925 12.1422 3.88728L9.31554 1.02728C9.25357 0.964791 9.17983 0.915195 9.09859 0.881349C9.01735 0.847504 8.93022 0.830078 8.84221 0.830078C8.7542 0.830078 8.66706 0.847504 8.58582 0.881349C8.50458 0.915195 8.43085 0.964791 8.36887 1.02728L6.48887 2.91394L1.86221 7.53394C1.80042 7.59624 1.75154 7.67011 1.71836 7.75134C1.68518 7.83256 1.66837 7.91954 1.66887 8.00728V10.8339C1.66887 11.0108 1.73911 11.1803 1.86414 11.3053C1.98916 11.4304 2.15873 11.5006 2.33554 11.5006ZM8.84221 2.44061L10.7289 4.32728L9.78221 5.27394L7.89554 3.38728L8.84221 2.44061ZM3.00221 8.28061L6.95554 4.32728L8.84221 6.21394L4.88887 10.1673H3.00221V8.28061ZM13.0022 12.8339H1.00221C0.825396 12.8339 0.655827 12.9042 0.530803 13.0292C0.405779 13.1542 0.335541 13.3238 0.335541 13.5006C0.335541 13.6774 0.405779 13.847 0.530803 13.972C0.655827 14.097 0.825396 14.1673 1.00221 14.1673H13.0022C13.179 14.1673 13.3486 14.097 13.4736 13.972C13.5986 13.847 13.6689 13.6774 13.6689 13.5006C13.6689 13.3238 13.5986 13.1542 13.4736 13.0292C13.3486 12.9042 13.179 12.8339 13.0022 12.8339Z",
            fill: "#333333"
        })
    });
};
var EyeVisibleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.9399 6.07994C11.2907 6.02617 11.6451 5.99943 11.9999 5.99994C15.1799 5.99994 18.1699 8.28994 19.9099 11.9999C19.6438 12.5645 19.3433 13.1122 19.0099 13.6399C18.9041 13.8038 18.8485 13.9949 18.8499 14.1899C18.8522 14.4082 18.9257 14.6197 19.0594 14.7922C19.1931 14.9647 19.3795 15.0888 19.5903 15.1455C19.8011 15.2021 20.0246 15.1883 20.2267 15.106C20.4289 15.0238 20.5986 14.8776 20.7099 14.6899C21.1759 13.9579 21.5806 13.1886 21.9199 12.3899C21.9736 12.2652 22.0013 12.1308 22.0013 11.9949C22.0013 11.8591 21.9736 11.7247 21.9199 11.5999C19.8999 6.90994 16.0999 3.99994 11.9999 3.99994C11.5306 3.99758 11.062 4.03774 10.5999 4.11994C10.4686 4.14227 10.343 4.19024 10.2302 4.26112C10.1174 4.332 10.0197 4.4244 9.94263 4.53304C9.86555 4.64169 9.81063 4.76445 9.78101 4.89432C9.75138 5.02419 9.74762 5.15862 9.76994 5.28994C9.79227 5.42126 9.84024 5.5469 9.91112 5.65968C9.982 5.77247 10.0744 5.87018 10.183 5.94726C10.2917 6.02433 10.4144 6.07925 10.5443 6.10888C10.6742 6.13851 10.8086 6.14227 10.9399 6.11994V6.07994ZM3.70994 2.28994C3.6167 2.1967 3.50601 2.12274 3.38419 2.07228C3.26237 2.02182 3.1318 1.99585 2.99994 1.99585C2.86808 1.99585 2.73751 2.02182 2.61569 2.07228C2.49387 2.12274 2.38318 2.1967 2.28994 2.28994C2.10164 2.47824 1.99585 2.73364 1.99585 2.99994C1.99585 3.26624 2.10164 3.52164 2.28994 3.70994L5.38994 6.79994C3.97551 8.16147 2.8498 9.79393 2.07994 11.5999C2.02488 11.7261 1.99646 11.8623 1.99646 11.9999C1.99646 12.1376 2.02488 12.2738 2.07994 12.3999C4.09994 17.0899 7.89994 19.9999 11.9999 19.9999C13.797 19.9875 15.5517 19.4524 17.0499 18.4599L20.2899 21.7099C20.3829 21.8037 20.4935 21.8781 20.6154 21.9288C20.7372 21.9796 20.8679 22.0057 20.9999 22.0057C21.132 22.0057 21.2627 21.9796 21.3845 21.9288C21.5064 21.8781 21.617 21.8037 21.7099 21.7099C21.8037 21.617 21.8781 21.5064 21.9288 21.3845C21.9796 21.2627 22.0057 21.132 22.0057 20.9999C22.0057 20.8679 21.9796 20.7372 21.9288 20.6154C21.8781 20.4935 21.8037 20.3829 21.7099 20.2899L3.70994 2.28994ZM10.0699 11.4799L12.5199 13.9299C12.3509 13.9784 12.1758 14.002 11.9999 13.9999C11.4695 13.9999 10.9608 13.7892 10.5857 13.4142C10.2107 13.0391 9.99994 12.5304 9.99994 11.9999C9.99789 11.8241 10.0215 11.649 10.0699 11.4799ZM11.9999 17.9999C8.81994 17.9999 5.82994 15.7099 4.09994 11.9999C4.74603 10.5737 5.66301 9.28652 6.79994 8.20994L8.56994 9.99994C8.15419 10.7587 7.99568 11.6319 8.1182 12.4884C8.24072 13.3449 8.63766 14.1386 9.24947 14.7504C9.86128 15.3622 10.655 15.7592 11.5115 15.8817C12.368 16.0042 13.2411 15.8457 13.9999 15.4299L15.5899 16.9999C14.501 17.6408 13.2634 17.9856 11.9999 17.9999Z",
            fill: fillColor
        })
    });
};
var EyeHiddenIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.9199 11.6C19.8999 6.91 16.0999 4 11.9999 4C7.89994 4 4.09994 6.91 2.07994 11.6C2.02488 11.7262 1.99646 11.8623 1.99646 12C1.99646 12.1377 2.02488 12.2738 2.07994 12.4C4.09994 17.09 7.89994 20 11.9999 20C16.0999 20 19.8999 17.09 21.9199 12.4C21.975 12.2738 22.0034 12.1377 22.0034 12C22.0034 11.8623 21.975 11.7262 21.9199 11.6ZM11.9999 18C8.82994 18 5.82994 15.71 4.09994 12C5.82994 8.29 8.82994 6 11.9999 6C15.1699 6 18.1699 8.29 19.8999 12C18.1699 15.71 15.1699 18 11.9999 18ZM11.9999 8C11.2088 8 10.4355 8.2346 9.77766 8.67412C9.11987 9.11365 8.60718 9.73836 8.30443 10.4693C8.00168 11.2002 7.92246 12.0044 8.0768 12.7804C8.23114 13.5563 8.61211 14.269 9.17152 14.8284C9.73093 15.3878 10.4437 15.7688 11.2196 15.9231C11.9955 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8863 14.8801 15.3258 14.2223C15.7653 13.5645 15.9999 12.7911 15.9999 12C15.9999 10.9391 15.5785 9.92172 14.8284 9.17157C14.0782 8.42143 13.0608 8 11.9999 8ZM11.9999 14C11.6044 14 11.2177 13.8827 10.8888 13.6629C10.5599 13.4432 10.3036 13.1308 10.1522 12.7654C10.0008 12.3999 9.9612 11.9978 10.0384 11.6098C10.1155 11.2219 10.306 10.8655 10.5857 10.5858C10.8654 10.3061 11.2218 10.1156 11.6098 10.0384C11.9977 9.96126 12.3999 10.0009 12.7653 10.1522C13.1308 10.3036 13.4431 10.56 13.6629 10.8889C13.8826 11.2178 13.9999 11.6044 13.9999 12C13.9999 12.5304 13.7892 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 11.9999 14Z",
            fill: fillColor
        })
    });
};
var DeleteIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.4996 3.3326H13.9163C13.7228 2.39211 13.2111 1.54705 12.4673 0.939865C11.7235 0.332675 10.7931 0.00047841 9.83293 -0.000732422H8.16626C7.20609 0.00047841 6.27569 0.332675 5.53188 0.939865C4.78808 1.54705 4.27634 2.39211 4.08293 3.3326H1.49959C1.27858 3.3326 1.06662 3.4204 0.910337 3.57668C0.754057 3.73296 0.66626 3.94492 0.66626 4.16593C0.66626 4.38695 0.754057 4.59891 0.910337 4.75519C1.06662 4.91147 1.27858 4.99927 1.49959 4.99927H2.33293V15.8326C2.33425 16.9373 2.77366 17.9963 3.55478 18.7774C4.33589 19.5585 5.39493 19.9979 6.49959 19.9993H11.4996C12.6043 19.9979 13.6633 19.5585 14.4444 18.7774C15.2255 17.9963 15.6649 16.9373 15.6663 15.8326V4.99927H16.4996C16.7206 4.99927 16.9326 4.91147 17.0889 4.75519C17.2451 4.59891 17.3329 4.38695 17.3329 4.16593C17.3329 3.94492 17.2451 3.73296 17.0889 3.57668C16.9326 3.4204 16.7206 3.3326 16.4996 3.3326ZM8.16626 1.66593H9.83293C10.3498 1.66656 10.8539 1.82708 11.2759 2.12547C11.698 2.42386 12.0174 2.84551 12.1904 3.3326H5.80876C5.98175 2.84551 6.30118 2.42386 6.72325 2.12547C7.14532 1.82708 7.64936 1.66656 8.16626 1.66593ZM13.9996 15.8326C13.9996 16.4956 13.7362 17.1315 13.2674 17.6004C12.7985 18.0692 12.1626 18.3326 11.4996 18.3326H6.49959C5.83655 18.3326 5.20067 18.0692 4.73183 17.6004C4.26299 17.1315 3.99959 16.4956 3.99959 15.8326V4.99927H13.9996V15.8326ZM7.33299 14.9987C7.55401 14.9987 7.76597 14.9109 7.92225 14.7547C8.07853 14.5984 8.16633 14.3864 8.16633 14.1654V9.16542C8.16633 8.9444 8.07853 8.73244 7.92225 8.57616C7.76597 8.41988 7.55401 8.33208 7.33299 8.33208C7.11198 8.33208 6.90002 8.41988 6.74374 8.57616C6.58746 8.73244 6.49966 8.9444 6.49966 9.16542V14.1654C6.49966 14.3864 6.58746 14.5984 6.74374 14.7547C6.90002 14.9109 7.11198 14.9987 7.33299 14.9987ZM11.2555 14.7547C11.0992 14.9109 10.8872 14.9987 10.6662 14.9987C10.4452 14.9987 10.2332 14.9109 10.077 14.7547C9.92067 14.5984 9.83287 14.3864 9.83287 14.1654V9.16542C9.83287 8.9444 9.92067 8.73244 10.077 8.57616C10.2332 8.41988 10.4452 8.33208 10.6662 8.33208C10.8872 8.33208 11.0992 8.41988 11.2555 8.57616C11.4118 8.73244 11.4996 8.9444 11.4996 9.16542V14.1654C11.4996 14.3864 11.4118 14.5984 11.2555 14.7547Z",
            fill: fillColor
        })
    });
};
var TextIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17 6H7C6.73478 6 6.48043 6.10536 6.29289 6.29289C6.10536 6.48043 6 6.73478 6 7C6 7.26522 6.10536 7.51957 6.29289 7.70711C6.48043 7.89464 6.73478 8 7 8H11V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V8H17C17.2652 8 17.5196 7.89464 17.7071 7.70711C17.8946 7.51957 18 7.26522 18 7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6Z",
            fill: fillColor
        })
    });
};
var StoryIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        width: "24",
        height: "24",
        viewBox: "0 0 25 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.1133 20.2803L20.8867 17.0537C20.7627 16.9287 20.6152 16.8295 20.4528 16.7618C20.2903 16.6941 20.116 16.6593 19.94 16.6593C19.764 16.6593 19.5897 16.6941 19.4272 16.7618C19.2648 16.8295 19.1173 16.9287 18.9933 17.0537L14.22 21.827C14.0964 21.9516 13.9987 22.0993 13.9323 22.2618C13.866 22.4242 13.8323 22.5982 13.8333 22.7737V26.0003C13.8333 26.3539 13.9738 26.6931 14.2239 26.9431C14.4739 27.1932 14.813 27.3337 15.1667 27.3337H18.3933C18.5688 27.3347 18.7428 27.301 18.9052 27.2347C19.0677 27.1683 19.2154 27.0706 19.34 26.947L24.1133 22.1737C24.2383 22.0497 24.3375 21.9022 24.4052 21.7398C24.4729 21.5773 24.5077 21.403 24.5077 21.227C24.5077 21.051 24.4729 20.8767 24.4052 20.7142C24.3375 20.5517 24.2383 20.4043 24.1133 20.2803ZM17.8333 24.667H16.5V23.3337L19.94 19.8937L21.2733 21.227L17.8333 24.667ZM9.83333 24.667H4.5C4.14638 24.667 3.80724 24.5265 3.55719 24.2765C3.30714 24.0264 3.16667 23.6873 3.16667 23.3337V4.66699C3.16667 4.31337 3.30714 3.97423 3.55719 3.72418C3.80724 3.47413 4.14638 3.33366 4.5 3.33366H11.1667V7.33366C11.1667 8.39453 11.5881 9.41194 12.3382 10.1621C13.0884 10.9122 14.1058 11.3337 15.1667 11.3337H19.1667V12.667C19.1667 13.0206 19.3071 13.3598 19.5572 13.6098C19.8072 13.8598 20.1464 14.0003 20.5 14.0003C20.8536 14.0003 21.1928 13.8598 21.4428 13.6098C21.6929 13.3598 21.8333 13.0206 21.8333 12.667V10.0003C21.8333 10.0003 21.8333 10.0003 21.8333 9.92033C21.8194 9.79784 21.7926 9.67717 21.7533 9.56033V9.44033C21.6892 9.30323 21.6037 9.17721 21.5 9.06699L13.5 1.06699C13.3898 0.96328 13.2638 0.877767 13.1267 0.813659C13.0869 0.808006 13.0465 0.808006 13.0067 0.813659L12.58 0.666992H4.5C3.43913 0.666992 2.42172 1.08842 1.67157 1.83857C0.921427 2.58871 0.5 3.60613 0.5 4.66699V23.3337C0.5 24.3945 0.921427 25.4119 1.67157 26.1621C2.42172 26.9122 3.43913 27.3337 4.5 27.3337H9.83333C10.187 27.3337 10.5261 27.1932 10.7761 26.9431C11.0262 26.6931 11.1667 26.3539 11.1667 26.0003C11.1667 25.6467 11.0262 25.3076 10.7761 25.0575C10.5261 24.8075 10.187 24.667 9.83333 24.667ZM13.8333 5.21366L17.2867 8.66699H15.1667C14.813 8.66699 14.4739 8.52652 14.2239 8.27647C13.9738 8.02642 13.8333 7.68728 13.8333 7.33366V5.21366ZM7.16667 16.667H15.1667C15.5203 16.667 15.8594 16.5265 16.1095 16.2765C16.3595 16.0264 16.5 15.6873 16.5 15.3337C16.5 14.98 16.3595 14.6409 16.1095 14.3909C15.8594 14.1408 15.5203 14.0003 15.1667 14.0003H7.16667C6.81304 14.0003 6.47391 14.1408 6.22386 14.3909C5.97381 14.6409 5.83333 14.98 5.83333 15.3337C5.83333 15.6873 5.97381 16.0264 6.22386 16.2765C6.47391 16.5265 6.81304 16.667 7.16667 16.667ZM7.16667 11.3337H8.5C8.85362 11.3337 9.19276 11.1932 9.44281 10.9431C9.69286 10.6931 9.83333 10.3539 9.83333 10.0003C9.83333 9.6467 9.69286 9.30757 9.44281 9.05752C9.19276 8.80747 8.85362 8.66699 8.5 8.66699H7.16667C6.81304 8.66699 6.47391 8.80747 6.22386 9.05752C5.97381 9.30757 5.83333 9.6467 5.83333 10.0003C5.83333 10.3539 5.97381 10.6931 6.22386 10.9431C6.47391 11.1932 6.81304 11.3337 7.16667 11.3337ZM9.83333 19.3337H7.16667C6.81304 19.3337 6.47391 19.4741 6.22386 19.7242C5.97381 19.9742 5.83333 20.3134 5.83333 20.667C5.83333 21.0206 5.97381 21.3598 6.22386 21.6098C6.47391 21.8599 6.81304 22.0003 7.16667 22.0003H9.83333C10.187 22.0003 10.5261 21.8599 10.7761 21.6098C11.0262 21.3598 11.1667 21.0206 11.1667 20.667C11.1667 20.3134 11.0262 19.9742 10.7761 19.7242C10.5261 19.4741 10.187 19.3337 9.83333 19.3337Z",
            fill: "#333333"
        })
    });
};
var EmbedIcon = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.2322 4.92857L9.80112 18.7159C9.70522 19.2598 10.0684 19.7784 10.6123 19.8743C11.1562 19.9702 11.6748 19.6071 11.7707 19.0632L14.2018 5.27586C14.2977 4.73197 13.9345 4.21331 13.3907 4.11741C12.8468 4.0215 12.3281 4.38467 12.2322 4.92857Z",
                fill: fillColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.60999 7.38991C7.42263 7.20366 7.16918 7.09912 6.90499 7.09912C6.64081 7.09912 6.38736 7.20366 6.19999 7.38991L2.29999 11.2899C2.11374 11.4773 2.0092 11.7307 2.0092 11.9949C2.0092 12.2591 2.11374 12.5126 2.29999 12.6999L6.19999 16.5999C6.29296 16.6936 6.40356 16.768 6.52542 16.8188C6.64728 16.8696 6.77798 16.8957 6.90999 16.8957C7.04201 16.8957 7.17271 16.8696 7.29457 16.8188C7.41643 16.768 7.52703 16.6936 7.61999 16.5999C7.71372 16.507 7.78812 16.3963 7.83889 16.2745C7.88965 16.1526 7.91579 16.0219 7.91579 15.8899C7.91579 15.7579 7.88965 15.6272 7.83889 15.5053C7.78812 15.3835 7.71372 15.2729 7.61999 15.1799L4.40999 11.9999L7.60999 8.80991C7.79625 8.62255 7.90079 8.3691 7.90079 8.10491C7.90079 7.84073 7.79625 7.58728 7.60999 7.39991V7.38991Z",
                fill: fillColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.38 7.40017C16.1937 7.58753 16.0892 7.84098 16.0892 8.10517C16.0892 8.36935 16.1937 8.62281 16.38 8.81017L19.58 12.0002L16.39 15.1902C16.2963 15.2831 16.2219 15.3937 16.1711 15.5156C16.1203 15.6375 16.0942 15.7682 16.0942 15.9002C16.0942 16.0322 16.1203 16.1629 16.1711 16.2847C16.2219 16.4066 16.2963 16.5172 16.39 16.6102C16.483 16.7039 16.5936 16.7783 16.7154 16.8291C16.8373 16.8798 16.968 16.906 17.1 16.906C17.232 16.906 17.3627 16.8798 17.4846 16.8291C17.6064 16.7783 17.717 16.7039 17.81 16.6102L21.7 12.7102C21.8862 12.5228 21.9908 12.2694 21.9908 12.0052C21.9908 11.741 21.8862 11.4875 21.7 11.3002L17.81 7.40017C17.6226 7.21392 17.3692 7.10938 17.105 7.10938C16.8408 7.10938 16.5874 7.21392 16.4 7.40017H16.38Z",
                fill: fillColor
            })
        ]
    });
};
var CardIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 11H18C18.2652 11 18.5196 10.8946 18.7071 10.7071C18.8946 10.5196 19 10.2652 19 10V9C19 8.73478 18.8946 8.48043 18.7071 8.29289C18.5196 8.10536 18.2652 8 18 8H17C16.7348 8 16.4804 8.10536 16.2929 8.29289C16.1054 8.48043 16 8.73478 16 9V10C16 10.2652 16.1054 10.5196 16.2929 10.7071C16.4804 10.8946 16.7348 11 17 11ZM6 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H6C5.73478 10 5.48043 10.1054 5.29289 10.2929C5.10536 10.4804 5 10.7348 5 11C5 11.2652 5.10536 11.5196 5.29289 11.7071C5.48043 11.8946 5.73478 12 6 12ZM22 4H2C1.73478 4 1.48043 4.10536 1.29289 4.29289C1.10536 4.48043 1 4.73478 1 5V19C1 19.2652 1.10536 19.5196 1.29289 19.7071C1.48043 19.8946 1.73478 20 2 20H22C22.2652 20 22.5196 19.8946 22.7071 19.7071C22.8946 19.5196 23 19.2652 23 19V5C23 4.73478 22.8946 4.48043 22.7071 4.29289C22.5196 4.10536 22.2652 4 22 4ZM21 18H3V6H21V18ZM6 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14H6C5.73478 14 5.48043 14.1054 5.29289 14.2929C5.10536 14.4804 5 14.7348 5 15C5 15.2652 5.10536 15.5196 5.29289 15.7071C5.48043 15.8946 5.73478 16 6 16Z",
            fill: fillColor
        })
    });
};
var CardIconV2 = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        className: className,
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 26H6C5.46957 26 4.96086 26.2107 4.58579 26.5858C4.21071 26.9609 4 27.4696 4 28V42C4 42.5304 4.21071 43.0391 4.58579 43.4142C4.96086 43.7893 5.46957 44 6 44H20C20.5304 44 21.0391 43.7893 21.4142 43.4142C21.7893 43.0391 22 42.5304 22 42V28C22 27.4696 21.7893 26.9609 21.4142 26.5858C21.0391 26.2107 20.5304 26 20 26ZM18 40H8V30H18V40ZM42 4H28C27.4696 4 26.9609 4.21071 26.5858 4.58579C26.2107 4.96086 26 5.46957 26 6V20C26 20.5304 26.2107 21.0391 26.5858 21.4142C26.9609 21.7893 27.4696 22 28 22H42C42.5304 22 43.0391 21.7893 43.4142 21.4142C43.7893 21.0391 44 20.5304 44 20V6C44 5.46957 43.7893 4.96086 43.4142 4.58579C43.0391 4.21071 42.5304 4 42 4V4ZM40 18H30V8H40V18ZM42 26H28C27.4696 26 26.9609 26.2107 26.5858 26.5858C26.2107 26.9609 26 27.4696 26 28V42C26 42.5304 26.2107 43.0391 26.5858 43.4142C26.9609 43.7893 27.4696 44 28 44H42C42.5304 44 43.0391 43.7893 43.4142 43.4142C43.7893 43.0391 44 42.5304 44 42V28C44 27.4696 43.7893 26.9609 43.4142 26.5858C43.0391 26.2107 42.5304 26 42 26ZM40 40H30V30H40V40ZM20 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4V4ZM18 18H8V8H18V18Z",
            fill: fillColor
        })
    });
};
var SaveIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.9434 4.80546L8.1934 1.05546C8.13581 0.999237 8.06789 0.954671 7.9934 0.924206C7.91591 0.892717 7.83328 0.875768 7.74965 0.874207H2.74965C2.25237 0.874207 1.77545 1.07175 1.42382 1.42338C1.07219 1.77501 0.874649 2.25193 0.874649 2.74921V10.2492C0.874649 10.7465 1.07219 11.2234 1.42382 11.575C1.77545 11.9267 2.25237 12.1242 2.74965 12.1242H10.2496C10.7469 12.1242 11.2238 11.9267 11.5755 11.575C11.9271 11.2234 12.1246 10.7465 12.1246 10.2492V5.24921C12.1251 5.16695 12.1094 5.08541 12.0783 5.00926C12.0472 4.93312 12.0013 4.86386 11.9434 4.80546ZM4.62465 2.12421H7.12465V3.37421H4.62465V2.12421ZM8.37465 10.8742H4.62465V8.99921C4.62465 8.83345 4.6905 8.67448 4.80771 8.55726C4.92492 8.44005 5.08389 8.37421 5.24965 8.37421H7.74965C7.91541 8.37421 8.07438 8.44005 8.19159 8.55726C8.3088 8.67448 8.37465 8.83345 8.37465 8.99921V10.8742ZM10.8746 10.2492C10.8746 10.415 10.8088 10.5739 10.6916 10.6911C10.5744 10.8084 10.4154 10.8742 10.2496 10.8742H9.62465V8.99921C9.62465 8.50193 9.4271 8.02501 9.07547 7.67338C8.72384 7.32175 8.24693 7.12421 7.74965 7.12421H5.24965C4.75237 7.12421 4.27545 7.32175 3.92382 7.67338C3.57219 8.02501 3.37465 8.50193 3.37465 8.99921V10.8742H2.74965C2.58389 10.8742 2.42492 10.8084 2.30771 10.6911C2.1905 10.5739 2.12465 10.415 2.12465 10.2492V2.74921C2.12465 2.58345 2.1905 2.42448 2.30771 2.30726C2.42492 2.19005 2.58389 2.12421 2.74965 2.12421H3.37465V3.99921C3.37465 4.16497 3.4405 4.32394 3.55771 4.44115C3.67492 4.55836 3.83389 4.62421 3.99965 4.62421H7.74965C7.91541 4.62421 8.07438 4.55836 8.19159 4.44115C8.3088 4.32394 8.37465 4.16497 8.37465 3.99921V3.00546L10.8746 5.50546V10.2492Z",
            fill: "#333333"
        })
    });
};
var UndoIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.874649 5.87421C1.04041 5.87421 1.19938 5.94005 1.31659 6.05726C1.4338 6.17448 1.49965 6.33345 1.49965 6.49921C1.49221 7.66985 1.89322 8.80645 2.63361 9.71324C3.37401 10.62 4.40744 11.2403 5.55592 11.4671C6.7044 11.6939 7.89604 11.5132 8.92559 10.9559C9.95513 10.3987 10.7581 9.49993 11.1963 8.41436C11.6345 7.32879 11.6804 6.1244 11.3261 5.00863C10.9719 3.89285 10.2396 2.93554 9.25546 2.30157C8.27132 1.6676 7.0969 1.39665 5.93449 1.5354C4.77207 1.67415 3.69442 2.21391 2.88715 3.06171H4.38715C4.55291 3.06171 4.71188 3.12755 4.82909 3.24476C4.9463 3.36197 5.01215 3.52095 5.01215 3.68671C5.01215 3.85247 4.9463 4.01144 4.82909 4.12865C4.71188 4.24586 4.55291 4.31171 4.38715 4.31171H1.5559C1.39014 4.31171 1.23117 4.24586 1.11396 4.12865C0.996747 4.01144 0.930899 3.85247 0.930899 3.68671V0.874206C0.930899 0.708446 0.996747 0.549475 1.11396 0.432265C1.23117 0.315054 1.39014 0.249206 1.5559 0.249206C1.72166 0.249206 1.88063 0.315054 1.99784 0.432265C2.11505 0.549475 2.1809 0.708446 2.1809 0.874206V1.98046C3.22173 0.985493 4.57418 0.380427 6.00964 0.267537C7.4451 0.154647 8.87551 0.540859 10.0591 1.36089C11.2426 2.18092 12.1068 3.38446 12.5054 4.76807C12.904 6.15169 12.8126 7.6305 12.2468 8.95454C11.6809 10.2786 10.6752 11.3666 9.39971 12.0347C8.12422 12.7029 6.65715 12.9101 5.2465 12.6214C3.83585 12.3327 2.56815 11.5658 1.65769 10.4503C0.747231 9.33475 0.249858 7.9391 0.249649 6.49921C0.249649 6.33345 0.315497 6.17448 0.432707 6.05726C0.549917 5.94005 0.708889 5.87421 0.874649 5.87421Z",
            fill: fillColor
        })
    });
};
var RedoIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.1247 5.87421C11.9589 5.87421 11.7999 5.94005 11.6827 6.05726C11.5655 6.17448 11.4997 6.33345 11.4997 6.49921C11.5071 7.66985 11.1061 8.80645 10.3657 9.71324C9.62529 10.62 8.59186 11.2403 7.44338 11.4671C6.2949 11.6939 5.10326 11.5132 4.07371 10.9559C3.04417 10.3987 2.24115 9.49993 1.80298 8.41436C1.3648 7.32879 1.3189 6.1244 1.67316 5.00863C2.02743 3.89285 2.7597 2.93554 3.74384 2.30157C4.72798 1.6676 5.9024 1.39665 7.06481 1.5354C8.22723 1.67415 9.30488 2.21391 10.1122 3.06171H8.61215C8.44639 3.06171 8.28742 3.12755 8.17021 3.24476C8.053 3.36197 7.98715 3.52095 7.98715 3.68671C7.98715 3.85247 8.053 4.01144 8.17021 4.12865C8.28742 4.24586 8.44639 4.31171 8.61215 4.31171H11.4434C11.6092 4.31171 11.7681 4.24586 11.8853 4.12865C12.0026 4.01144 12.0684 3.85247 12.0684 3.68671V0.874206C12.0684 0.708446 12.0026 0.549475 11.8853 0.432265C11.7681 0.315054 11.6092 0.249206 11.4434 0.249206C11.2776 0.249206 11.1187 0.315054 11.0015 0.432265C10.8842 0.549475 10.8184 0.708446 10.8184 0.874206V1.98046C9.77757 0.985493 8.42512 0.380427 6.98966 0.267537C5.5542 0.154647 4.12379 0.540859 2.94023 1.36089C1.75666 2.18092 0.892532 3.38446 0.493919 4.76807C0.0953058 6.15169 0.186657 7.6305 0.752531 8.95454C1.3184 10.2786 2.32409 11.3666 3.59959 12.0347C4.87508 12.7029 6.34215 12.9101 7.7528 12.6214C9.16345 12.3327 10.4311 11.5658 11.3416 10.4503C12.2521 9.33475 12.7494 7.9391 12.7497 6.49921C12.7497 6.33345 12.6838 6.17448 12.5666 6.05726C12.4494 5.94005 12.2904 5.87421 12.1247 5.87421Z",
            fill: fillColor
        })
    });
};
var RestoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.44 2C8.87638 2.00731 6.41349 2.99891 4.56 4.77V3C4.56 2.73478 4.45464 2.48043 4.2671 2.29289C4.07957 2.10536 3.82521 2 3.56 2C3.29478 2 3.04043 2.10536 2.85289 2.29289C2.66535 2.48043 2.56 2.73478 2.56 3V7.5C2.56 7.76522 2.66535 8.01957 2.85289 8.20711C3.04043 8.39464 3.29478 8.5 3.56 8.5H8.06C8.32521 8.5 8.57957 8.39464 8.7671 8.20711C8.95464 8.01957 9.06 7.76522 9.06 7.5C9.06 7.23478 8.95464 6.98043 8.7671 6.79289C8.57957 6.60536 8.32521 6.5 8.06 6.5H5.66C6.57171 5.53701 7.7085 4.81576 8.96813 4.40114C10.2277 3.98651 11.5707 3.89152 12.8761 4.1247C14.1816 4.35788 15.4086 4.91193 16.4468 5.73699C17.485 6.56205 18.3018 7.63226 18.8237 8.85133C19.3457 10.0704 19.5564 11.4001 19.4369 12.7208C19.3174 14.0415 18.8715 15.3118 18.1392 16.4174C17.407 17.5231 16.4114 18.4293 15.242 19.0547C14.0726 19.68 12.7661 20.0049 11.44 20C11.1748 20 10.9204 20.1054 10.7329 20.2929C10.5454 20.4804 10.44 20.7348 10.44 21C10.44 21.2652 10.5454 21.5196 10.7329 21.7071C10.9204 21.8946 11.1748 22 11.44 22C14.0922 22 16.6357 20.9464 18.5111 19.0711C20.3864 17.1957 21.44 14.6522 21.44 12C21.44 9.34784 20.3864 6.8043 18.5111 4.92893C16.6357 3.05357 14.0922 2 11.44 2ZM11.44 8C11.1748 8 10.9204 8.10536 10.7329 8.29289C10.5454 8.48043 10.44 8.73478 10.44 9V12C10.44 12.2652 10.5454 12.5196 10.7329 12.7071C10.9204 12.8946 11.1748 13 11.44 13H13.44C13.7052 13 13.9596 12.8946 14.1471 12.7071C14.3346 12.5196 14.44 12.2652 14.44 12C14.44 11.7348 14.3346 11.4804 14.1471 11.2929C13.9596 11.1054 13.7052 11 13.44 11H12.44V9C12.44 8.73478 12.3346 8.48043 12.1471 8.29289C11.9596 8.10536 11.7052 8 11.44 8Z",
            fill: fillColor
        })
    });
};
var ReplaceIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V5C5 4.73478 5.10536 4.48043 5.29289 4.29289C5.48043 4.10536 5.73478 4 6 4H11V7C11 7.79565 11.3161 8.55871 11.8787 9.12132C12.4413 9.68393 13.2044 10 14 10H17V12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12V9C19 9 19 9 19 8.94C18.9896 8.84813 18.9695 8.75763 18.94 8.67V8.58C18.8897 8.4754 18.8258 8.37789 18.75 8.29V8.29L12.75 2.29C12.6621 2.21419 12.5646 2.15031 12.46 2.1C12.4301 2.09576 12.3999 2.09576 12.37 2.1L12.06 2H6C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H11C11.2652 22 11.5196 21.8946 11.7071 21.7071C11.8946 21.5196 12 21.2652 12 21C12 20.7348 11.8946 20.4804 11.7071 20.2929C11.5196 20.1054 11.2652 20 11 20ZM13 5.41L15.59 8H14C13.7348 8 13.4804 7.89464 13.2929 7.70711C13.1054 7.51957 13 7.26522 13 7V5.41ZM19 15H13.41L14.71 13.71C14.8983 13.5217 15.0041 13.2663 15.0041 13C15.0041 12.7337 14.8983 12.4783 14.71 12.29C14.5217 12.1017 14.2663 11.9959 14 11.9959C13.7337 11.9959 13.4783 12.1017 13.29 12.29L10.29 15.29C10.2017 15.3872 10.1306 15.4988 10.08 15.62C9.97998 15.8635 9.97998 16.1365 10.08 16.38C10.1258 16.5036 10.1974 16.6161 10.29 16.71L13.29 19.71C13.383 19.8037 13.4936 19.8781 13.6154 19.9289C13.7373 19.9797 13.868 20.0058 14 20.0058C14.132 20.0058 14.2627 19.9797 14.3846 19.9289C14.5064 19.8781 14.617 19.8037 14.71 19.71C14.8037 19.617 14.8781 19.5064 14.9289 19.3846C14.9797 19.2627 15.0058 19.132 15.0058 19C15.0058 18.868 14.9797 18.7373 14.9289 18.6154C14.8781 18.4936 14.8037 18.383 14.71 18.29L13.41 17H19C19.2652 17 19.5196 16.8946 19.7071 16.7071C19.8946 16.5196 20 16.2652 20 16C20 15.7348 19.8946 15.4804 19.7071 15.2929C19.5196 15.1054 19.2652 15 19 15Z",
            fill: fillColor
        })
    });
};
var CopyIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11C14.4402 2.10576 14.4099 2.10576 14.38 2.11C14.2784 2.05174 14.1662 2.01434 14.05 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V6H6C5.20435 6 4.44129 6.31607 3.87868 6.87868C3.31607 7.44129 3 8.20435 3 9V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H14C14.7956 22 15.5587 21.6839 16.1213 21.1213C16.6839 20.5587 17 19.7956 17 19V18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM15 19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V9C5 8.73478 5.10536 8.48043 5.29289 8.29289C5.48043 8.10536 5.73478 8 6 8H7V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H15V19ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z",
            fill: fillColor
        })
    });
};
var ThemeChangeIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.41999 15.5399C7.23374 15.7273 7.1292 15.9807 7.1292 16.2449C7.1292 16.5091 7.23374 16.7625 7.41999 16.9499C7.51295 17.0436 7.62355 17.118 7.74541 17.1688C7.86727 17.2196 7.99798 17.2457 8.12999 17.2457C8.262 17.2457 8.39271 17.2196 8.51457 17.1688C8.63643 17.118 8.74703 17.0436 8.83999 16.9499C9.02624 16.7625 9.13078 16.5091 9.13078 16.2449C9.13078 15.9807 9.02624 15.7273 8.83999 15.5399C8.74703 15.4462 8.63643 15.3718 8.51457 15.321C8.39271 15.2702 8.262 15.2441 8.12999 15.2441C7.99798 15.2441 7.86727 15.2702 7.74541 15.321C7.62355 15.3718 7.51295 15.4462 7.41999 15.5399ZM7.41999 7.04989C7.23374 7.23726 7.1292 7.49071 7.1292 7.75489C7.1292 8.01908 7.23374 8.27253 7.41999 8.45989C7.51295 8.55362 7.62355 8.62802 7.74541 8.67879C7.86727 8.72955 7.99798 8.75569 8.12999 8.75569C8.262 8.75569 8.39271 8.72955 8.51457 8.67879C8.63643 8.62802 8.74703 8.55362 8.83999 8.45989C9.02624 8.27253 9.13078 8.01908 9.13078 7.75489C9.13078 7.49071 9.02624 7.23726 8.83999 7.04989C8.74703 6.95617 8.63643 6.88177 8.51457 6.831C8.39271 6.78023 8.262 6.7541 8.12999 6.7541C7.99798 6.7541 7.86727 6.78023 7.74541 6.831C7.62355 6.88177 7.51295 6.95617 7.41999 7.04989ZM12.37 17.0499C12.1722 17.0499 11.9789 17.1085 11.8144 17.2184C11.65 17.3283 11.5218 17.4845 11.4461 17.6672C11.3704 17.8499 11.3506 18.051 11.3892 18.245C11.4278 18.439 11.523 18.6171 11.6629 18.757C11.8027 18.8969 11.9809 18.9921 12.1749 19.0307C12.3689 19.0693 12.5699 19.0495 12.7527 18.9738C12.9354 18.8981 13.0916 18.7699 13.2015 18.6055C13.3113 18.441 13.37 18.2477 13.37 18.0499C13.3768 17.9144 13.3559 17.779 13.3087 17.6518C13.2615 17.5247 13.1889 17.4085 13.0954 17.3102C13.0018 17.212 12.8893 17.1339 12.7646 17.0805C12.6399 17.0272 12.5056 16.9997 12.37 16.9999V17.0499ZM6.36999 11.0499C6.17221 11.0499 5.97887 11.1085 5.81442 11.2184C5.64997 11.3283 5.5218 11.4845 5.44611 11.6672C5.37042 11.8499 5.35062 12.051 5.3892 12.245C5.42779 12.439 5.52303 12.6171 5.66288 12.757C5.80274 12.8969 5.98092 12.9921 6.1749 13.0307C6.36888 13.0693 6.56995 13.0495 6.75267 12.9738C6.9354 12.8981 7.09158 12.7699 7.20146 12.6055C7.31134 12.441 7.36999 12.2477 7.36999 12.0499C7.37677 11.9144 7.35592 11.779 7.30871 11.6518C7.26151 11.5247 7.18892 11.4085 7.09538 11.3102C7.00184 11.212 6.88929 11.1339 6.76459 11.0805C6.63988 11.0272 6.50563 10.9997 6.36999 10.9999V11.0499ZM12.37 5.04989C12.1722 5.04989 11.9789 5.10854 11.8144 5.21842C11.65 5.32831 11.5218 5.48449 11.4461 5.66721C11.3704 5.84994 11.3506 6.051 11.3892 6.24499C11.4278 6.43897 11.523 6.61715 11.6629 6.757C11.8027 6.89685 11.9809 6.99209 12.1749 7.03068C12.3689 7.06926 12.5699 7.04946 12.7527 6.97377C12.9354 6.89809 13.0916 6.76991 13.2015 6.60546C13.3113 6.44102 13.37 6.24768 13.37 6.04989C13.3768 5.91443 13.3559 5.779 13.3087 5.65184C13.2615 5.52468 13.1889 5.40846 13.0954 5.31024C13.0018 5.21202 12.8893 5.13385 12.7646 5.0805C12.6399 5.02715 12.5056 4.99972 12.37 4.99989V5.04989ZM15.91 7.09989C15.7695 7.23951 15.6737 7.41768 15.6346 7.61182C15.5956 7.80597 15.615 8.00734 15.6905 8.19041C15.7661 8.37348 15.8942 8.53001 16.0588 8.64016C16.2234 8.7503 16.417 8.8091 16.615 8.8091C16.813 8.8091 17.0066 8.7503 17.1712 8.64016C17.3358 8.53001 17.4639 8.37348 17.5394 8.19041C17.615 8.00734 17.6344 7.80597 17.5953 7.61182C17.5563 7.41768 17.4604 7.23951 17.32 7.09989C17.1393 6.90685 16.8895 6.79321 16.6253 6.78384C16.3611 6.77447 16.1039 6.87013 15.91 7.04989V7.09989ZM22.21 7.09989C21.2957 5.27219 19.8904 3.73531 18.1516 2.6616C16.4128 1.58788 14.4092 1.01978 12.3656 1.021C10.322 1.02222 8.31911 1.59271 6.58157 2.66851C4.84404 3.7443 3.44054 5.28286 2.52847 7.11166C1.6164 8.94045 1.23181 10.9872 1.41783 13.0223C1.60386 15.0574 2.35314 17.0005 3.58166 18.6336C4.81017 20.2668 6.46935 21.5254 8.37313 22.2683C10.2769 23.0113 12.35 23.2092 14.36 22.8399C14.8654 22.7448 15.3468 22.5499 15.7761 22.2666C16.2054 21.9833 16.5738 21.6172 16.86 21.1899C17.1683 20.7253 17.3811 20.2039 17.4858 19.6562C17.5905 19.1086 17.5852 18.5455 17.47 17.9999C17.407 17.6702 17.3736 17.3355 17.37 16.9999C17.3744 16.0309 17.6602 15.084 18.1929 14.2744C18.7255 13.4648 19.4818 12.8275 20.37 12.4399C20.8489 12.2255 21.2787 11.9152 21.633 11.5282C21.9873 11.1413 22.2586 10.6858 22.43 10.1899C22.6034 9.68318 22.6733 9.1468 22.6355 8.61258C22.5977 8.07835 22.453 7.55715 22.21 7.07989V7.09989ZM20.51 9.53989C20.4247 9.77921 20.2922 9.99898 20.1204 10.1862C19.9487 10.3734 19.7411 10.5243 19.51 10.6299C18.28 11.1805 17.235 12.0744 16.5006 13.2044C15.7663 14.3343 15.3737 15.6523 15.37 16.9999C15.3715 17.47 15.4184 17.9388 15.51 18.3999C15.5711 18.6817 15.5751 18.9729 15.5219 19.2562C15.4686 19.5396 15.3592 19.8095 15.2 20.0499C15.0653 20.2603 14.8881 20.4402 14.6797 20.578C14.4713 20.7157 14.2363 20.8084 13.99 20.8499C13.4558 20.9503 12.9135 21.0005 12.37 20.9999C11.1642 21.0005 9.9705 20.7587 8.85991 20.289C7.74932 19.8193 6.74444 19.1313 5.90495 18.2656C5.06546 17.4 4.40847 16.3745 3.97301 15.2501C3.53754 14.1256 3.33247 12.9251 3.36999 11.7199C3.4476 9.47269 4.359 7.33485 5.92662 5.72286C7.49424 4.11086 9.60582 3.14018 11.85 2.99989H12.36C14.0357 3.00031 15.6781 3.46858 17.1021 4.35196C18.5261 5.23534 19.6752 6.49874 20.42 7.99989C20.6492 8.47488 20.6816 9.02118 20.51 9.51989V9.53989ZM12.37 10.9999C12.1722 10.9999 11.9789 11.0585 11.8144 11.1684C11.65 11.2783 11.5218 11.4345 11.4461 11.6172C11.3704 11.7999 11.3506 12.001 11.3892 12.195C11.4278 12.389 11.523 12.5671 11.6629 12.707C11.8027 12.8469 11.9809 12.9421 12.1749 12.9807C12.3689 13.0193 12.5699 12.9995 12.7527 12.9238C12.9354 12.8481 13.0916 12.7199 13.2015 12.5555C13.3113 12.391 13.37 12.1977 13.37 11.9999C13.37 11.7347 13.2646 11.4803 13.0771 11.2928C12.8896 11.1053 12.6352 10.9999 12.37 10.9999Z",
            fill: fillColor
        })
    });
};
var BackIcon = function(param) {
    var className = param.className, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 11H9.41L12.71 7.71C12.8983 7.5217 13.0041 7.2663 13.0041 7C13.0041 6.7337 12.8983 6.47831 12.71 6.29C12.5217 6.1017 12.2663 5.99591 12 5.99591C11.7337 5.99591 11.4783 6.1017 11.29 6.29L6.29 11.29C6.19896 11.3851 6.1276 11.4973 6.08 11.62C5.97999 11.8635 5.97999 12.1365 6.08 12.38C6.1276 12.5028 6.19896 12.6149 6.29 12.71L11.29 17.71C11.383 17.8037 11.4936 17.8781 11.6154 17.9289C11.7373 17.9797 11.868 18.0058 12 18.0058C12.132 18.0058 12.2627 17.9797 12.3846 17.9289C12.5064 17.8781 12.617 17.8037 12.71 17.71C12.8037 17.617 12.8781 17.5064 12.9289 17.3846C12.9797 17.2627 13.0058 17.132 13.0058 17C13.0058 16.868 12.9797 16.7373 12.9289 16.6154C12.8781 16.4936 12.8037 16.383 12.71 16.29L9.41 13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11Z",
            fill: "#333333"
        })
    });
};
var ConfirmIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM17.9101 8.5H16.3543C16.3013 8.5 16.2504 8.52107 16.2129 8.55857L10.6961 14.0746L8.17958 11.5582C8.14207 11.5207 8.0912 11.4996 8.03816 11.4996H6.4827C6.42967 11.4996 6.37881 11.5207 6.34131 11.5582C6.26319 11.6363 6.26316 11.7629 6.34125 11.841C6.42917 11.929 6.5171 12.0169 6.60502 12.1049C6.62887 12.1288 6.65325 12.1532 6.67813 12.1781L6.83305 12.3334C7.15375 12.655 7.53643 13.0404 7.92601 13.4333L8.21862 13.7286C9.12764 14.6461 9.99919 15.5287 10.1333 15.6643L10.1505 15.6816C10.4434 15.9745 10.9183 15.9745 11.2112 15.6816L18.0516 8.84142C18.0891 8.80392 18.1101 8.75304 18.1101 8.7C18.1101 8.58954 18.0206 8.5 17.9101 8.5Z",
            fill: fillColor
        })
    });
};
var ExitIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM9.33769 8H7.78189C7.72885 8 7.67797 8.02107 7.64047 8.05858C7.56236 8.13669 7.56237 8.26332 7.64047 8.34142L11.1495 11.8503L7.34141 15.6586C7.3039 15.6961 7.28283 15.747 7.28283 15.8C7.28283 15.9105 7.37237 16 7.48283 16H9.03766C9.0907 16 9.14157 15.9789 9.17908 15.9414L12.21 12.9108L15.2409 15.9414C15.2784 15.9789 15.3293 16 15.3823 16H16.9382C16.9912 16 17.0421 15.9789 17.0796 15.9414C17.1577 15.8633 17.1577 15.7367 17.0796 15.6586L13.271 11.8498L16.7796 8.34142C16.8171 8.30392 16.8382 8.25304 16.8382 8.2C16.8382 8.08954 16.7486 8 16.6382 8H15.0819C15.0288 8 14.978 8.02107 14.9405 8.05859L12.21 10.7893L9.47911 8.05857C9.4416 8.02107 9.39074 8 9.33769 8Z",
            fill: fillColor
        })
    });
};
var CheckCircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM16.2 10.3L11.4 15.1C11 15.5 10.4 15.5 10 15.1L7.8 12.9C7.4 12.5 7.4 11.9 7.8 11.5C8.2 11.1 8.8 11.1 9.2 11.5L10.7 13L14.8 8.9C15.2 8.5 15.8 8.5 16.2 8.9C16.6 9.3 16.6 9.9 16.2 10.3Z",
            fill: fillColor
        })
    });
};
var CheckCircleIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.7 7.19999C18.3 6.79999 17.7 6.79999 17.3 7.19999L9.8 14.7L6.7 11.6C6.3 11.2 5.7 11.2 5.3 11.6C4.9 12 4.9 12.6 5.3 13L9.1 16.8C9.3 17 9.5 17.1 9.8 17.1C10.1 17.1 10.3 17 10.5 16.8L18.7 8.59999C19.1 8.19999 19.1 7.59999 18.7 7.19999Z",
            fill: fillColor
        })
    });
};
var PassioIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6318 5.83647C17.9317 6.58441 18.0806 7.38427 18.07 8.19C18.0798 9.71504 17.5308 11.1909 16.5267 12.3387C15.5225 13.4866 14.1328 14.227 12.62 14.42H5.93V8.19C5.9193 6.56577 6.55158 5.00326 7.68881 3.84355C8.82604 2.68383 10.3759 2.02109 12 2C12.8058 2.00521 13.6026 2.16975 14.3445 2.48415C15.0864 2.79855 15.7589 3.25661 16.323 3.83194C16.8872 4.40728 17.332 5.08853 17.6318 5.83647ZM6.98216 17.7182C7.37184 17.4683 7.82714 17.3401 8.28997 17.35C8.59364 17.35 8.89427 17.4105 9.1742 17.5282C9.45413 17.6459 9.70773 17.8184 9.92012 18.0354C10.1325 18.2524 10.2994 18.5097 10.411 18.7921C10.5226 19.0746 10.5766 19.3764 10.57 19.68C10.5699 20.143 10.4319 20.5954 10.1736 20.9795C9.91525 21.3637 9.54836 21.6622 9.11969 21.837C8.69102 22.0118 8.22 22.0549 7.76671 21.9609C7.31342 21.8669 6.89842 21.64 6.57464 21.3091C6.25087 20.9782 6.03299 20.5584 5.94882 20.1032C5.86464 19.6479 5.91797 19.178 6.10202 18.7532C6.28606 18.3284 6.59247 17.9681 6.98216 17.7182Z",
            fill: fillColor
        })
    });
};
var PreviewThemeIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 15 : _width, _height = param.height, height = _height === void 0 ? 15 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.6996 5.24921C11.4371 2.31796 9.06215 0.499207 6.49965 0.499207C3.93714 0.499207 1.56214 2.31796 0.299645 5.24921C0.26523 5.32806 0.247467 5.41317 0.247467 5.49921C0.247467 5.58524 0.26523 5.67035 0.299645 5.74921C1.56214 8.68046 3.93714 10.4992 6.49965 10.4992C9.06215 10.4992 11.4371 8.68046 12.6996 5.74921C12.7341 5.67035 12.7518 5.58524 12.7518 5.49921C12.7518 5.41317 12.7341 5.32806 12.6996 5.24921ZM6.49965 9.24921C4.51839 9.24921 2.64339 7.81796 1.56214 5.49921C2.64339 3.18046 4.51839 1.74921 6.49965 1.74921C8.4809 1.74921 10.3559 3.18046 11.4371 5.49921C10.3559 7.81796 8.4809 9.24921 6.49965 9.24921ZM6.49965 2.99921C6.00519 2.99921 5.52184 3.14583 5.11072 3.42053C4.6996 3.69524 4.37917 4.08568 4.18995 4.5425C4.00073 4.99931 3.95122 5.50198 4.04768 5.98693C4.14414 6.47188 4.38225 6.91734 4.73188 7.26697C5.08151 7.6166 5.52697 7.85471 6.01192 7.95117C6.49687 8.04763 6.99954 7.99812 7.45635 7.80891C7.91317 7.61969 8.30362 7.29925 8.57832 6.88813C8.85302 6.47701 8.99965 5.99366 8.99965 5.49921C8.99965 4.83617 8.73625 4.20028 8.26741 3.73144C7.79857 3.2626 7.16269 2.99921 6.49965 2.99921ZM6.49965 6.74921C6.25242 6.74921 6.01074 6.6759 5.80518 6.53854C5.59962 6.40119 5.4394 6.20597 5.3448 5.97756C5.25019 5.74915 5.22543 5.49782 5.27366 5.25534C5.32189 5.01287 5.44095 4.79014 5.61576 4.61532C5.79058 4.44051 6.01331 4.32146 6.25578 4.27322C6.49826 4.22499 6.74959 4.24975 6.978 4.34436C7.20641 4.43897 7.40163 4.59918 7.53898 4.80474C7.67633 5.01031 7.74965 5.25198 7.74965 5.49921C7.74965 5.83073 7.61795 6.14867 7.38353 6.38309C7.14911 6.61751 6.83117 6.74921 6.49965 6.74921Z",
            fill: fillColor
        })
    });
};
var ClearFormatIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onClick = param.onClick;
    return /*#__PURE__*/ _jsx("svg", {
        width: "17",
        height: "14",
        viewBox: "0 0 17 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.71 0.660081C11.8976 0.847617 12.0029 1.10197 12.0029 1.36719C12.0029 1.6324 11.8976 1.88676 11.71 2.07429C11.5225 2.26183 11.2681 2.36719 11.0029 2.36719H7.00293V12.9672C7.00293 13.2324 6.89757 13.4868 6.71004 13.6743C6.5225 13.8618 6.26815 13.9672 6.00293 13.9672C5.73771 13.9672 5.48336 13.8618 5.29582 13.6743C5.10829 13.4868 5.00293 13.2324 5.00293 12.9672V2.36719H1.00293C0.737713 2.36719 0.483359 2.26183 0.295823 2.07429C0.108287 1.88676 0.00292969 1.6324 0.00292969 1.36719C0.00292969 1.10197 0.108287 0.847617 0.295823 0.660081C0.483359 0.472545 0.737713 0.367188 1.00293 0.367188H11.0029C11.2681 0.367188 11.5225 0.472545 11.71 0.660081ZM15.7129 6.12698L14.4329 7.40698L15.6929 8.69698C15.7976 8.78662 15.8826 8.89694 15.9426 9.02101C16.0027 9.14507 16.0364 9.2802 16.0417 9.41792C16.047 9.55564 16.0238 9.69297 15.9735 9.8213C15.9233 9.94962 15.847 10.0662 15.7496 10.1636C15.6521 10.2611 15.5356 10.3373 15.4072 10.3876C15.2789 10.4379 15.1416 10.4611 15.0039 10.4558C14.8661 10.4505 14.731 10.4167 14.6069 10.3567C14.4829 10.2967 14.3726 10.2117 14.2829 10.107L13.0029 8.83698L11.7229 10.097C11.5316 10.2608 11.2855 10.3464 11.0339 10.3367C10.7822 10.327 10.5434 10.2226 10.3653 10.0445C10.1872 9.86644 10.0829 9.6277 10.0732 9.37603C10.0635 9.12435 10.1491 8.87828 10.3129 8.68698L11.5829 7.40698L10.3129 6.12698C10.1491 5.93567 10.0635 5.6896 10.0732 5.43792C10.0829 5.18625 10.1872 4.94751 10.3653 4.76941C10.5434 4.59132 10.7822 4.48698 11.0339 4.47726C11.2855 4.46754 11.5316 4.55315 11.7229 4.71698L13.0029 5.99698L14.3029 4.71698C14.3926 4.61229 14.5029 4.52727 14.6269 4.46725C14.751 4.40723 14.8861 4.3735 15.0239 4.36818C15.1616 4.36286 15.2989 4.38606 15.4272 4.43634C15.5556 4.48661 15.6721 4.56287 15.7696 4.66033C15.867 4.75778 15.9433 4.87433 15.9935 5.00265C16.0438 5.13098 16.067 5.26831 16.0617 5.40603C16.0564 5.54375 16.0227 5.67888 15.9626 5.80295C15.9026 5.92701 15.8176 6.03733 15.7129 6.12698Z",
            fill: "#333333"
        })
    });
};
var CloseIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, onClick = param.onClick, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 17 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.8045 0.694703C15.6795 0.569722 15.51 0.499512 15.3332 0.499512C15.1564 0.499512 14.9869 0.569722 14.8619 0.694703L7.99986 7.5567L1.13786 0.694703C1.01284 0.569722 0.8433 0.499512 0.666524 0.499512C0.489748 0.499512 0.320209 0.569722 0.195191 0.694703C0.0702103 0.819721 0 0.98926 0 1.16604C0 1.34281 0.0702103 1.51235 0.195191 1.63737L7.05719 8.49937L0.195191 15.3614C0.0702103 15.4864 0 15.6559 0 15.8327C0 16.0095 0.0702103 16.179 0.195191 16.304C0.320209 16.429 0.489748 16.4992 0.666524 16.4992C0.8433 16.4992 1.01284 16.429 1.13786 16.304L7.99986 9.44204L14.8619 16.304C14.9869 16.429 15.1564 16.4992 15.3332 16.4992C15.51 16.4992 15.6795 16.429 15.8045 16.304C15.9295 16.179 15.9997 16.0095 15.9997 15.8327C15.9997 15.6559 15.9295 15.4864 15.8045 15.3614L8.94252 8.49937L15.8045 1.63737C15.9295 1.51235 15.9997 1.34281 15.9997 1.16604C15.9997 0.98926 15.9295 0.819721 15.8045 0.694703Z",
            fill: fillColor
        })
    });
};
var TabInitialIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsx("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11.6029 8.90122C11.7029 9.00122 11.8029 9.00122 12.0029 9.00122H19.0029C19.6029 9.00122 20.0029 8.60122 20.0029 8.00122C20.0029 7.80122 20.0029 7.70122 19.9029 7.60122L16.4029 0.601221C16.1029 0.101221 15.5029 -0.0987793 15.0029 0.201221C14.9029 0.301221 14.7029 0.401221 14.6029 0.601221L11.1029 7.60122C10.9029 8.00122 11.1029 8.60122 11.6029 8.90122ZM15.5029 3.20122L17.4029 7.00122H13.6029L15.5029 3.20122ZM4.50293 0.0012207C2.00293 0.0012207 0.00292973 2.00122 0.00292973 4.50122C0.00292973 7.00122 2.00293 9.00122 4.50293 9.00122C7.00293 9.00122 9.00293 7.00122 9.00293 4.50122C9.00293 2.00122 7.00293 0.0012207 4.50293 0.0012207ZM4.50293 7.00122C3.10293 7.00122 2.00293 5.90122 2.00293 4.50122C2.00293 3.10122 3.10293 2.00122 4.50293 2.00122C5.90293 2.00122 7.00293 3.10122 7.00293 4.50122C7.00293 5.90122 5.90293 7.00122 4.50293 7.00122ZM8.70293 11.3012C8.30293 10.9012 7.70293 10.9012 7.30293 11.3012L4.50293 14.1012L1.70293 11.3012C1.30293 10.9012 0.70293 10.9012 0.30293 11.3012C-0.0970703 11.7012 -0.0970703 12.3012 0.30293 12.7012L3.10293 15.5012L0.30293 18.3012C-0.0970703 18.7012 -0.0970703 19.3012 0.30293 19.7012C0.70293 20.1012 1.30293 20.1012 1.70293 19.7012L4.50293 16.9012L7.30293 19.7012C7.70293 20.1012 8.30293 20.1012 8.70293 19.7012C9.10293 19.3012 9.10293 18.7012 8.70293 18.3012L5.90293 15.5012L8.70293 12.7012C9.10293 12.3012 9.10293 11.7012 8.70293 11.3012ZM19.0029 11.0012H12.0029C11.4029 11.0012 11.0029 11.4012 11.0029 12.0012V19.0012C11.0029 19.6012 11.4029 20.0012 12.0029 20.0012H19.0029C19.6029 20.0012 20.0029 19.6012 20.0029 19.0012V12.0012C20.0029 11.4012 19.6029 11.0012 19.0029 11.0012ZM18.0029 18.0012H13.0029V13.0012H18.0029V18.0012Z",
            fill: "#BFBFBF"
        })
    });
};
var DeleteTabIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19Z",
            fill: fillColor
        })
    });
};
var EditTabIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 17.9999H9.24C9.37161 18.0007 9.50207 17.9755 9.62391 17.9257C9.74574 17.8759 9.85656 17.8026 9.95 17.7099L16.87 10.7799L19.71 7.99994C19.8037 7.90698 19.8781 7.79637 19.9289 7.67452C19.9797 7.55266 20.0058 7.42195 20.0058 7.28994C20.0058 7.15793 19.9797 7.02722 19.9289 6.90536C19.8781 6.7835 19.8037 6.6729 19.71 6.57994L15.47 2.28994C15.377 2.19621 15.2664 2.12182 15.1446 2.07105C15.0227 2.02028 14.892 1.99414 14.76 1.99414C14.628 1.99414 14.4973 2.02028 14.3754 2.07105C14.2536 2.12182 14.143 2.19621 14.05 2.28994L11.23 5.11994L4.29 12.0499C4.19732 12.1434 4.12399 12.2542 4.07423 12.376C4.02446 12.4979 3.99924 12.6283 4 12.7599V16.9999C4 17.2652 4.10536 17.5195 4.29289 17.707C4.48043 17.8946 4.73478 17.9999 5 17.9999ZM14.76 4.40994L17.59 7.23994L16.17 8.65994L13.34 5.82994L14.76 4.40994ZM6 13.1699L11.93 7.23994L14.76 10.0699L8.83 15.9999H6V13.1699ZM21 19.9999H3C2.73478 19.9999 2.48043 20.1053 2.29289 20.2928C2.10536 20.4804 2 20.7347 2 20.9999C2 21.2652 2.10536 21.5195 2.29289 21.707C2.48043 21.8946 2.73478 21.9999 3 21.9999H21C21.2652 21.9999 21.5196 21.8946 21.7071 21.707C21.8946 21.5195 22 21.2652 22 20.9999C22 20.7347 21.8946 20.4804 21.7071 20.2928C21.5196 20.1053 21.2652 19.9999 21 19.9999Z",
            fill: fillColor
        })
    });
};
var SampleSelectionIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20 6.83015C20.0001 6.81927 20.0002 6.80643 20.0002 6.79354C20.0002 6.02549 19.6865 5.33071 19.1802 4.83041L19.18 4.83018C18.6617 4.3327 17.9566 4.02637 17.18 4.02637C16.4034 4.02637 15.6983 4.3327 15.179 4.83116L15.18 4.83023L8.58001 11.4302H8.35998C6.00835 11.4954 4.11952 13.3877 4.06009 15.7346L4.05999 15.7402L3.99999 19.0002C3.99981 19.0078 3.99966 19.0168 3.99966 19.0257C3.99966 19.3005 4.11052 19.5495 4.29006 19.7302L4.29001 19.7302C4.47535 19.8977 4.72215 20.0002 4.99295 20.0002C4.99543 20.0002 4.99791 20.0002 5.0004 20.0002H5.00002L8.26004 19.9402C10.6126 19.8807 12.5049 17.9918 12.5699 15.6463L12.5701 15.6402V15.4102L19.18 8.81024C19.6863 8.31276 20.0002 7.6207 20.0002 6.85537C20.0002 6.84655 20.0001 6.83774 20.0001 6.82893V6.83029L20 6.83015ZM8.25001 17.9401L6.00001 18.0001V15.7701C6.02251 14.462 7.08826 13.4101 8.39968 13.4101C8.39977 13.4101 8.39991 13.4101 8.40001 13.4101C8.4001 13.4101 8.40024 13.4101 8.40038 13.4101C9.58782 13.4101 10.5504 14.3727 10.5504 15.5601C10.5504 15.5742 10.5503 15.5882 10.55 15.6022V15.6001C10.5185 16.8658 9.51193 17.8863 8.25493 17.9399L8.25001 17.9401V17.9401ZM17.77 7.39016L11.9001 13.2601C11.7382 13.0209 11.5672 12.8118 11.3792 12.6192L11.38 12.6201C11.1899 12.4293 10.9805 12.258 10.7548 12.1093L10.7401 12.1001L16.6101 6.24013C16.7606 6.09627 16.965 6.00773 17.1901 6.00773C17.4151 6.00773 17.6196 6.09627 17.7704 6.24041L17.77 6.24013C17.9125 6.38601 18.0004 6.5857 18.0004 6.80591C18.0004 6.8144 18.0002 6.82293 18 6.83137V6.83015C18 6.83099 18 6.83193 18 6.83291C18 7.05037 17.9121 7.24729 17.7699 7.39016H17.77Z",
            fill: fillColor
        })
    });
};
var CloseCircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75ZM9.17 15.5804C8.98 15.5804 8.79 15.5104 8.64 15.3604C8.35 15.0704 8.35 14.5904 8.64 14.3004L10.94 12.0004L8.64 9.70035C8.35 9.41035 8.35 8.93035 8.64 8.64035C8.93 8.35035 9.41 8.35035 9.7 8.64035L12 10.9404L14.3 8.64035C14.59 8.35035 15.07 8.35035 15.36 8.64035C15.65 8.93035 15.65 9.41035 15.36 9.70035L13.06 12.0004L15.36 14.3004C15.65 14.5904 15.65 15.0704 15.36 15.3604C15.21 15.5104 15.02 15.5804 14.83 15.5804C14.64 15.5804 14.45 15.5104 14.3 15.3604L12 13.0604L9.7 15.3604C9.56 15.5104 9.36 15.5804 9.17 15.5804Z",
            fill: fillColor
        })
    });
};
var CloseCircleSolidIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z",
            fill: fillColor
        })
    });
};
var UploadImageIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18.42 8.22002C17.809 6.81602 16.7545 5.65109 15.4181 4.90374C14.0817 4.15639 12.5371 3.86785 11.021 4.08233C9.50487 4.2968 8.10093 5.00247 7.02425 6.09119C5.94758 7.17991 5.25759 8.59163 5.06 10.11C4.10659 10.3383 3.27022 10.9089 2.70974 11.7132C2.14925 12.5176 1.90368 13.4997 2.01966 14.4732C2.13564 15.4467 2.60509 16.3437 3.33887 16.9939C4.07264 17.644 5.01963 18.0021 6 18C6.26522 18 6.51957 17.8947 6.70711 17.7071C6.89464 17.5196 7 17.2652 7 17C7 16.7348 6.89464 16.4804 6.70711 16.2929C6.51957 16.1054 6.26522 16 6 16C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0392 4 14.5304 4 14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12C6.26522 12 6.51957 11.8947 6.70711 11.7071C6.89464 11.5196 7 11.2652 7 11C7.00255 9.8173 7.42429 8.67377 8.19027 7.7726C8.95625 6.87143 10.0169 6.27097 11.1837 6.07789C12.3506 5.88481 13.5481 6.11162 14.5636 6.71803C15.579 7.32443 16.3466 8.27116 16.73 9.39002C16.7872 9.56186 16.8899 9.71495 17.0273 9.83295C17.1647 9.95095 17.3315 10.0294 17.51 10.06C18.1761 10.1859 18.7799 10.5336 19.223 11.0466C19.6662 11.5595 19.9226 12.2074 19.9504 12.8847C19.9782 13.5619 19.7759 14.2287 19.3763 14.7762C18.9767 15.3238 18.4035 15.7199 17.75 15.9C17.4927 15.9663 17.2724 16.1321 17.1373 16.3609C17.0023 16.5897 16.9637 16.8628 17.03 17.12C17.0963 17.3773 17.2621 17.5977 17.4909 17.7327C17.7197 17.8677 17.9927 17.9063 18.25 17.84C19.3024 17.5619 20.2353 16.948 20.907 16.0915C21.5787 15.235 21.9526 14.1826 21.9718 13.0943C21.9911 12.0059 21.6546 10.9411 21.0136 10.0613C20.3725 9.18161 19.4619 8.53512 18.42 8.22002ZM12.71 10.29C12.6149 10.199 12.5028 10.1276 12.38 10.08C12.1365 9.98 11.8635 9.98 11.62 10.08C11.4972 10.1276 11.3851 10.199 11.29 10.29L8.29 13.29C8.1017 13.4783 7.99591 13.7337 7.99591 14C7.99591 14.2663 8.1017 14.5217 8.29 14.71C8.4783 14.8983 8.7337 15.0041 9 15.0041C9.2663 15.0041 9.5217 14.8983 9.71 14.71L11 13.41V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8947 11.7348 20 12 20C12.2652 20 12.5196 19.8947 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V13.41L14.29 14.71C14.383 14.8037 14.4936 14.8781 14.6154 14.9289C14.7373 14.9797 14.868 15.0058 15 15.0058C15.132 15.0058 15.2627 14.9797 15.3846 14.9289C15.5064 14.8781 15.617 14.8037 15.71 14.71C15.8037 14.6171 15.8781 14.5065 15.9289 14.3846C15.9797 14.2627 16.0058 14.132 16.0058 14C16.0058 13.868 15.9797 13.7373 15.9289 13.6154C15.8781 13.4936 15.8037 13.383 15.71 13.29L12.71 10.29Z",
            fill: fillColor
        })
    });
};
var DownIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20.332 6.5H3.67064C3.28786 6.5 2.91668 6.63095 2.61974 6.86759C1.90289 7.44194 1.79154 8.48498 2.37151 9.19488L10.7022 19.3863C10.7764 19.4759 10.8576 19.5586 10.9504 19.6321C11.6673 20.2064 12.7182 20.0962 13.3005 19.3863L21.6288 9.19488C21.8701 8.90081 22 8.53322 22 8.15415C22.0023 7.23977 21.253 6.5 20.332 6.5Z",
            fill: "#333333"
        })
    });
};
var TrashIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#CCCCCC" : _fillColor, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19Z",
            fill: fillColor
        })
    });
};
var ImageIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height;
    return /*#__PURE__*/ _jsx("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fill: fillColor,
            d: "M38 4H10C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10V38C4 39.5913 4.63214 41.1174 5.75736 42.2426C6.88258 43.3679 8.4087 44 10 44H38C38.329 43.9954 38.6569 43.962 38.98 43.9L39.58 43.76H39.72H39.82L40.56 43.48L40.82 43.34C41.02 43.22 41.24 43.12 41.44 42.98C41.7071 42.7835 41.9609 42.5697 42.2 42.34L42.34 42.16C42.5364 41.961 42.7169 41.747 42.88 41.52L43.06 41.26C43.1997 41.0373 43.3201 40.8032 43.42 40.56C43.4749 40.464 43.5217 40.3637 43.56 40.26C43.66 40.02 43.72 39.76 43.8 39.5V39.2C43.9134 38.8092 43.9805 38.4064 44 38V10C44 8.4087 43.3679 6.88258 42.2426 5.75736C41.1174 4.63214 39.5913 4 38 4ZM10 40C9.46957 40 8.96086 39.7893 8.58579 39.4142C8.21071 39.0391 8 38.5304 8 38V29.38L14.58 22.78C14.7659 22.5925 14.9871 22.4438 15.2308 22.3422C15.4746 22.2407 15.736 22.1884 16 22.1884C16.264 22.1884 16.5254 22.2407 16.7692 22.3422C17.0129 22.4438 17.2341 22.5925 17.42 22.78L34.62 40H10ZM40 38C39.9981 38.2466 39.9507 38.4907 39.86 38.72C39.8143 38.8175 39.7608 38.9111 39.7 39C39.6465 39.0847 39.5863 39.1649 39.52 39.24L28.82 28.54L30.58 26.78C30.7659 26.5925 30.9871 26.4438 31.2308 26.3422C31.4746 26.2407 31.736 26.1884 32 26.1884C32.264 26.1884 32.5254 26.2407 32.7692 26.3422C33.0129 26.4438 33.2341 26.5925 33.42 26.78V26.78L40 33.38V38ZM40 27.72L36.24 24C35.0954 22.914 33.5778 22.3086 32 22.3086C30.4222 22.3086 28.9046 22.914 27.76 24L26 25.76L20.24 20C19.0954 18.914 17.5778 18.3086 16 18.3086C14.4222 18.3086 12.9046 18.914 11.76 20L8 23.72V10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H38C38.5304 8 39.0391 8.21071 39.4142 8.58579C39.7893 8.96086 40 9.46957 40 10V27.72Z"
        })
    });
};
var ImageIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.83333 -0.000732422H13.1667C14.0504 0.00032615 14.8976 0.351856 15.5225 0.976748C16.1474 1.60164 16.4989 2.44887 16.5 3.3326V12.6659C16.4989 13.5497 16.1474 14.3969 15.5225 15.0218C14.8976 15.6467 14.0504 15.9982 13.1667 15.9993H3.83333C2.9496 15.9982 2.10237 15.6467 1.47748 15.0218C0.852588 14.3969 0.501059 13.5497 0.5 12.6659V3.3326C0.501059 2.44887 0.852588 1.60164 1.47748 0.976748C2.10237 0.351856 2.9496 0.00032615 3.83333 -0.000732422ZM13.1667 1.3326H3.83333C3.3029 1.3326 2.79419 1.54331 2.41912 1.91839C2.04405 2.29346 1.83333 2.80217 1.83333 3.3326V9.72327L4.14333 7.41393C4.45287 7.10431 4.82038 6.8587 5.22485 6.69113C5.62933 6.52356 6.06285 6.43731 6.50067 6.43731C6.93848 6.43731 7.37201 6.52356 7.77648 6.69113C8.18096 6.8587 8.54846 7.10431 8.858 7.41393L14.9667 13.5226C15.0971 13.2558 15.1655 12.9629 15.1667 12.6659V3.3326C15.1667 2.80217 14.956 2.29346 14.5809 1.91839C14.2058 1.54331 13.6971 1.3326 13.1667 1.3326ZM2.41912 14.0801C2.79419 14.4552 3.3029 14.6659 3.83333 14.6659H13.1667C13.4637 14.6648 13.7565 14.5964 14.0233 14.4659L7.91467 8.3566C7.72893 8.17075 7.5084 8.02331 7.26566 7.92273C7.02293 7.82214 6.76275 7.77036 6.5 7.77036C6.23725 7.77036 5.97707 7.82214 5.73434 7.92273C5.4916 8.02331 5.27107 8.17075 5.08533 8.3566L1.83333 11.6086V12.6659C1.83333 13.1964 2.04405 13.7051 2.41912 14.0801ZM12.4631 6.6058C12.0794 6.86219 11.6283 6.99903 11.1668 6.99903C10.5479 6.99903 9.95443 6.7532 9.51685 6.31562C9.07926 5.87803 8.83343 5.28454 8.83343 4.6657C8.83343 4.20421 8.97028 3.75309 9.22667 3.36937C9.48306 2.98566 9.84748 2.68659 10.2738 2.50998C10.7002 2.33338 11.1694 2.28717 11.622 2.3772C12.0746 2.46723 12.4904 2.68946 12.8167 3.01579C13.143 3.34211 13.3652 3.75787 13.4553 4.21049C13.5453 4.66311 13.4991 5.13227 13.3225 5.55863C13.1459 5.98499 12.8468 6.34941 12.4631 6.6058ZM11.7223 3.83423C11.5579 3.72435 11.3645 3.6657 11.1668 3.6657C10.9015 3.6657 10.6472 3.77106 10.4597 3.95859C10.2721 4.14613 10.1668 4.40049 10.1668 4.6657C10.1668 4.86348 10.2254 5.05682 10.3353 5.22127C10.4452 5.38572 10.6014 5.51389 10.7841 5.58958C10.9668 5.66527 11.1679 5.68507 11.3619 5.64649C11.5558 5.6079 11.734 5.51266 11.8739 5.37281C12.0137 5.23296 12.109 5.05477 12.1475 4.86079C12.1861 4.66681 12.1663 4.46574 12.0906 4.28302C12.015 4.10029 11.8868 3.94411 11.7223 3.83423Z",
            fill: fillColor
        })
    });
};
var ImageGalleryIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M38 4H10C8.4087 4 6.88258 4.63214 5.75736 5.75736C4.63214 6.88258 4 8.4087 4 10V30C4 31.5913 4.63214 33.1174 5.75736 34.2426C6.88258 35.3679 8.4087 36 10 36H33.18L40.58 43.42C40.7669 43.6054 40.9885 43.752 41.2322 43.8515C41.4759 43.9511 41.7368 44.0015 42 44C42.2624 44.0068 42.5226 43.952 42.76 43.84C43.1252 43.69 43.4379 43.4352 43.6586 43.1077C43.8792 42.7803 43.998 42.3949 44 42V10C44 8.4087 43.3679 6.88258 42.2426 5.75736C41.1174 4.63214 39.5913 4 38 4ZM11.54 32H10C9.46957 32 8.96086 31.7893 8.58579 31.4142C8.21071 31.0391 8 30.5304 8 30V29.16L14.6 22.58C14.9747 22.2075 15.4816 21.9984 16.01 21.9984C16.5384 21.9984 17.0453 22.2075 17.42 22.58L19.16 24.32L11.54 32ZM40 37.18L35.42 32.58C35.2331 32.3946 35.0115 32.248 34.7678 32.1485C34.5241 32.0489 34.2632 31.9985 34 32H17.18L30.6 18.58C30.9739 18.2135 31.4765 18.0083 32 18.0083C32.5235 18.0083 33.0261 18.2135 33.4 18.58L40 25.16V37.18ZM40 19.52L36.24 15.78C35.115 14.6564 33.59 14.0253 32 14.0253C30.41 14.0253 28.885 14.6564 27.76 15.78L22 21.52L20.24 19.78C19.1001 18.6849 17.5807 18.0733 16 18.0733C14.4193 18.0733 12.8999 18.6849 11.76 19.78L8 23.52V10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H38C38.5304 8 39.0391 8.21071 39.4142 8.58579C39.7893 8.96086 40 9.46957 40 10V19.52Z",
            fill: fillColor
        })
    });
};
var ColorIcon = function(param) {
    var className = param.className, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.68687 0.530473C6.68948 0.145471 7.75935 -0.0337099 8.83269 0.00361129C10.8625 0.0983529 12.7827 0.952267 14.2126 2.3961C15.6424 3.83993 16.4777 5.76829 16.5527 7.79894C16.5787 8.8328 16.4028 9.86181 16.0347 10.8283C15.9597 11.0255 15.8364 11.2008 15.6759 11.3379C15.5155 11.475 15.3232 11.5696 15.1167 11.6129C14.9068 11.6592 14.6886 11.6516 14.4824 11.5909C14.2762 11.5301 14.0887 11.4182 13.9374 11.2656L13.8707 11.1989C13.5366 10.8646 13.1103 10.6373 12.6465 10.5463C12.1826 10.4553 11.7021 10.5045 11.2664 10.6879C10.8307 10.8712 10.4595 11.1802 10.2002 11.5754C9.94089 11.9707 9.80529 12.4343 9.81069 12.9069L9.83202 15.2989C9.83261 15.4665 9.77011 15.6281 9.65696 15.7516C9.5438 15.8751 9.38829 15.9515 9.22135 15.9656C9.00135 15.9843 8.78002 15.9989 8.55469 15.9989C6.43371 15.9965 4.40032 15.1528 2.90056 13.6531C1.40081 12.1533 0.557158 10.1199 0.554688 7.99895C0.554665 6.92495 0.770894 5.86196 1.19048 4.87332C1.61007 3.88469 2.22443 2.99066 2.99693 2.24453C3.76943 1.49841 4.68426 0.915474 5.68687 0.530473ZM14.8114 10.2609L14.8207 10.2703L14.8227 10.2656C15.1068 9.48644 15.2414 8.66067 15.2194 7.83161C15.157 6.13997 14.4615 4.53347 13.2706 3.33045C12.0797 2.12744 10.4803 1.4157 8.78935 1.33628C8.71069 1.33228 8.63202 1.33228 8.55402 1.33228C6.78591 1.32432 5.08706 2.01907 3.83119 3.26369C2.57532 4.5083 1.86531 6.20083 1.85735 7.96894C1.8494 9.73705 2.54415 11.4359 3.78876 12.6918C5.03338 13.9476 6.72591 14.6577 8.49402 14.6656L8.47802 12.9176C8.47203 12.1813 8.68521 11.4598 9.09043 10.845C9.49565 10.2302 10.0746 9.74984 10.7536 9.46501C11.4326 9.18018 12.181 9.10377 12.9036 9.24551C13.6262 9.38724 14.2903 9.74071 14.8114 10.2609ZM8.57585 3.366C8.38471 3.41678 8.21292 3.5231 8.08221 3.67151C7.95149 3.81992 7.86771 4.00376 7.84147 4.19977C7.81523 4.39579 7.8477 4.59519 7.93477 4.77276C8.02185 4.95033 8.15962 5.09809 8.33066 5.19736C8.50171 5.29663 8.69835 5.34296 8.89573 5.33048C9.0931 5.318 9.28234 5.24728 9.43952 5.12725C9.59671 5.00723 9.71477 4.84329 9.77879 4.65617C9.8428 4.46905 9.8499 4.26715 9.79918 4.076C9.76549 3.94905 9.70712 3.82997 9.62741 3.72558C9.5477 3.62118 9.44819 3.53352 9.33459 3.46758C9.22099 3.40165 9.09551 3.35874 8.96532 3.34131C8.83514 3.32388 8.70279 3.33227 8.57585 3.366ZM11.9093 5.36599C11.7182 5.41677 11.5464 5.52309 11.4157 5.6715C11.285 5.81991 11.2012 6.00374 11.1749 6.19976C11.1487 6.39578 11.1812 6.59518 11.2682 6.77274C11.3553 6.95031 11.4931 7.09807 11.6641 7.19734C11.8352 7.29662 12.0318 7.34294 12.2292 7.33046C12.4266 7.31799 12.6158 7.24726 12.773 7.12724C12.9302 7.00722 13.0482 6.84328 13.1123 6.65616C13.1763 6.46904 13.1834 6.26714 13.1327 6.07599C13.099 5.94903 13.0406 5.82996 12.9609 5.72556C12.8812 5.62117 12.7817 5.5335 12.6681 5.46757C12.5545 5.40164 12.429 5.35873 12.2988 5.3413C12.1686 5.32387 12.0363 5.33226 11.9093 5.36599ZM4.74909 5.6715C4.8798 5.52309 5.05159 5.41677 5.24273 5.36599C5.36967 5.33226 5.50202 5.32387 5.6322 5.3413C5.76239 5.35873 5.88787 5.40164 6.00147 5.46757C6.11507 5.5335 6.21457 5.62117 6.29429 5.72556C6.374 5.82996 6.43237 5.94903 6.46606 6.07599C6.51678 6.26714 6.50968 6.46904 6.44566 6.65616C6.38165 6.84328 6.26358 7.00722 6.1064 7.12724C5.94922 7.24726 5.75998 7.31799 5.5626 7.33046C5.36523 7.34294 5.16859 7.29662 4.99754 7.19734C4.8265 7.09807 4.68873 6.95031 4.60165 6.77274C4.51458 6.59518 4.48211 6.39578 4.50835 6.19976C4.53459 6.00374 4.61837 5.81991 4.74909 5.6715ZM5.24273 9.36601C5.05159 9.41679 4.8798 9.52311 4.74909 9.67152C4.61837 9.81993 4.53459 10.0038 4.50835 10.1998C4.48211 10.3958 4.51458 10.5952 4.60165 10.7728C4.68873 10.9503 4.8265 11.0981 4.99754 11.1974C5.16859 11.2966 5.36523 11.343 5.5626 11.3305C5.75998 11.318 5.94922 11.2473 6.1064 11.1273C6.26358 11.0072 6.38165 10.8433 6.44566 10.6562C6.50968 10.4691 6.51678 10.2672 6.46606 10.076C6.43237 9.94906 6.374 9.82998 6.29429 9.72559C6.21457 9.62119 6.11507 9.53353 6.00147 9.46759C5.88787 9.40166 5.76239 9.35875 5.6322 9.34132C5.50202 9.32389 5.36967 9.33228 5.24273 9.36601Z",
            fill: "#333333"
        })
    });
};
var VideoIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 13 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2.08443 0.665771C2.31124 0.665771 2.53379 0.725371 2.72828 0.838207L11.5586 5.96137C12.1512 6.3052 12.3434 7.0485 11.9878 7.62157C11.8821 7.7919 11.7347 7.93445 11.5586 8.03665L2.72828 13.1598C2.13564 13.5037 1.36694 13.3178 1.01135 12.7448C0.894649 12.5567 0.833008 12.3415 0.833008 12.1222V1.87585V1.87585C0.833008 1.20754 1.39328 0.665771 2.08442 0.665771H2.08443ZM2.08443 1.57333C1.92582 1.57333 1.79232 1.68814 1.77377 1.84045L1.77158 1.87585V12.1222V12.1222C1.77158 12.2892 1.91154 12.4248 2.08432 12.4248C2.1287 12.4248 2.17257 12.4157 2.21302 12.3981L2.24524 12.3817L11.0758 7.25827C11.224 7.17224 11.2719 6.9864 11.183 6.84317C11.1629 6.81085 11.1367 6.78244 11.1059 6.75941L11.0758 6.73975L2.24523 1.61629C2.19663 1.58816 2.14106 1.57333 2.08442 1.57333H2.08443Z",
            fill: "#333333"
        })
    });
};
var ArrowDownRight = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.7709 22.6031C22.2623 22.1025 22.5367 21.4284 22.5346 20.7269L22.544 12.6282C22.5429 12.2759 22.4025 11.9384 22.1535 11.6894C21.9044 11.4403 21.5669 11.2999 21.2146 11.2988C21.0386 11.2981 20.8642 11.3322 20.7014 11.3993C20.5387 11.4663 20.3908 11.5649 20.2663 11.6893C20.1419 11.8138 20.0433 11.9617 19.9763 12.1244C19.9092 12.2872 19.8751 12.4616 19.8758 12.6376L19.8853 18.8319L10.4572 9.40378C10.2071 9.15373 9.86799 9.01326 9.51437 9.01326C9.16075 9.01326 8.82161 9.15373 8.57156 9.40378C8.32151 9.65383 8.18104 9.99297 8.18104 10.3466C8.18104 10.7002 8.32151 11.0394 8.57156 11.2894L17.9997 20.7175L11.796 20.7175C11.4422 20.7162 11.1023 20.8556 10.8513 21.1049C10.6002 21.3542 10.4584 21.693 10.4572 22.0468C10.4559 22.4007 10.5953 22.7405 10.8446 22.9916C11.0939 23.2426 11.4327 23.3844 11.7865 23.3856L19.8853 23.3762C20.5914 23.3783 21.2695 23.1003 21.7709 22.6031Z",
            fill: "#374957"
        })
    });
};
var ArrowDownLeft = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22.5524 9.39968L13.1243 18.8278L13.1243 12.6241C13.125 12.4481 13.0909 12.2737 13.0238 12.1109C12.9568 11.9481 12.8582 11.8003 12.7338 11.6758C12.6093 11.5513 12.4614 11.4528 12.2987 11.3857C12.1359 11.3187 11.9615 11.2846 11.7855 11.2853C11.4332 11.2863 11.0957 11.4267 10.8466 11.6758C10.5976 11.9249 10.4572 12.2624 10.4561 12.6147L10.4655 20.7134C10.4634 21.4195 10.7415 22.0976 11.2386 22.599C11.7393 23.0904 12.4133 23.3648 13.1148 23.3627L21.2136 23.3721C21.3888 23.3715 21.5621 23.3364 21.7237 23.2687C21.8854 23.2011 22.0321 23.1023 22.1555 22.978C22.279 22.8537 22.3767 22.7063 22.4432 22.5442C22.5096 22.3821 22.5435 22.2085 22.5429 22.0333C22.5423 21.8581 22.5072 21.6848 22.4396 21.5231C22.372 21.3615 22.2732 21.2148 22.1488 21.0914C22.0245 20.9679 21.8771 20.8702 21.715 20.8037C21.5529 20.7372 21.3793 20.7033 21.2041 20.704L15.0099 20.7134L24.438 11.2853C24.688 11.0352 24.8285 10.6961 24.8285 10.3425C24.8285 9.98886 24.688 9.64972 24.438 9.39967C24.1879 9.14963 23.8488 9.00915 23.4952 9.00915C23.1415 9.00915 22.8024 9.14963 22.5524 9.39968Z",
            fill: "#374957"
        })
    });
};
var ArrowUpRight = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.7616 9.40368C21.261 8.91225 20.5869 8.63787 19.8854 8.64L11.7866 8.63058C11.4344 8.63163 11.0969 8.77202 10.8478 9.0211C10.5987 9.27017 10.4583 9.60769 10.4573 9.95994C10.4566 10.136 10.4907 10.3104 10.5577 10.4731C10.6247 10.6359 10.7233 10.7838 10.8478 10.9082C10.9723 11.0327 11.1201 11.1313 11.2829 11.1983C11.4456 11.2653 11.6201 11.2994 11.7961 11.2987L17.9903 11.2893L8.56223 20.7174C8.31218 20.9674 8.17171 21.3066 8.17171 21.6602C8.17171 22.0138 8.31218 22.353 8.56223 22.603C8.81228 22.853 9.15142 22.9935 9.50504 22.9935C9.85866 22.9935 10.1978 22.853 10.4478 22.603L19.8759 13.1749L19.8759 19.3786C19.8747 19.7324 20.014 20.0722 20.2633 20.3233C20.5126 20.5744 20.8515 20.7161 21.2053 20.7174C21.5591 20.7186 21.8989 20.5793 22.15 20.33C22.4011 20.0807 22.5428 19.7418 22.5441 19.388L22.5347 11.2893C22.5368 10.5832 22.2587 9.90507 21.7616 9.40368Z",
            fill: "#374957"
        })
    });
};
var ArrowRight = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.4997 16.0014C24.4932 15.2999 24.2105 14.6293 23.713 14.1347L17.993 8.4014C17.7432 8.15306 17.4053 8.01367 17.053 8.01367C16.7008 8.01367 16.3628 8.15306 16.113 8.4014C15.988 8.52535 15.8888 8.67281 15.8212 8.83529C15.7535 8.99777 15.7186 9.17205 15.7186 9.34806C15.7186 9.52408 15.7535 9.69835 15.8212 9.86083C15.8888 10.0233 15.988 10.1708 16.113 10.2947L20.4997 14.6681H7.16634C6.81272 14.6681 6.47358 14.8085 6.22353 15.0586C5.97348 15.3086 5.83301 15.6478 5.83301 16.0014C5.83301 16.355 5.97348 16.6941 6.22353 16.9442C6.47358 17.1942 6.81272 17.3347 7.16634 17.3347H20.4997L16.113 21.7214C15.8619 21.9707 15.7202 22.3095 15.7189 22.6633C15.7177 23.0171 15.857 23.357 16.1063 23.608C16.3556 23.8591 16.6945 24.0009 17.0483 24.0021C17.4021 24.0034 17.7419 23.864 17.993 23.6147L23.713 17.8814C24.2138 17.3836 24.4967 16.7075 24.4997 16.0014Z",
            fill: "#374957"
        })
    });
};
var ArrowLeft = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M25.8333 14.6682H12.5L16.8867 10.2815C17.0116 10.1576 17.1108 10.0101 17.1785 9.84765C17.2462 9.68517 17.2811 9.51089 17.2811 9.33488C17.2811 9.15886 17.2462 8.98459 17.1785 8.82211C17.1108 8.65963 17.0116 8.51216 16.8867 8.38821C16.6368 8.13988 16.2989 8.00049 15.9467 8.00049C15.5944 8.00049 15.2565 8.13988 15.0067 8.38821L9.28667 14.1215C8.78588 14.6193 8.50298 15.2954 8.5 16.0015C8.50649 16.703 8.78913 17.3737 9.28667 17.8682L15.0067 23.6015C15.131 23.725 15.2784 23.8227 15.4405 23.8892C15.6026 23.9557 15.7762 23.9896 15.9514 23.9889C16.1266 23.9883 16.2999 23.9532 16.4615 23.8856C16.6232 23.818 16.7699 23.7192 16.8933 23.5949C17.0168 23.4705 17.1145 23.3231 17.181 23.161C17.2475 22.9989 17.2814 22.8253 17.2807 22.6501C17.2801 22.475 17.245 22.3016 17.1774 22.14C17.1098 21.9784 17.011 21.8316 16.8867 21.7082L12.5 17.3349H25.8333C26.187 17.3349 26.5261 17.1944 26.7761 16.9443C27.0262 16.6943 27.1667 16.3552 27.1667 16.0015C27.1667 15.6479 27.0262 15.3088 26.7761 15.0587C26.5261 14.8087 26.187 14.6682 25.8333 14.6682Z",
            fill: "#374957"
        })
    });
};
var ArrowDown = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#374957" : _fillColor, _width = param.width, width = _width === void 0 ? 33 : _width, _height = param.height, height = _height === void 0 ? 33 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.1134 16.9482C23.9895 16.8232 23.842 16.724 23.6795 16.6564C23.517 16.5887 23.3428 16.5538 23.1667 16.5538C22.9907 16.5538 22.8165 16.5887 22.654 16.6564C22.4915 16.724 22.344 16.8232 22.2201 16.9482L17.8334 21.3349V8.00155C17.8334 7.64792 17.6929 7.30879 17.4429 7.05874C17.1928 6.80869 16.8537 6.66821 16.5001 6.66821C16.1465 6.66821 15.8073 6.80869 15.5573 7.05874C15.3072 7.30879 15.1667 7.64792 15.1667 8.00155V21.3349L10.7801 16.9482C10.6561 16.8232 10.5087 16.724 10.3462 16.6564C10.1837 16.5887 10.0094 16.5538 9.83341 16.5538C9.6574 16.5538 9.48312 16.5887 9.32064 16.6564C9.15817 16.724 9.0107 16.8232 8.88675 16.9482C8.63841 17.198 8.49902 17.536 8.49902 17.8882C8.49902 18.2405 8.63841 18.5784 8.88675 18.8282L14.6201 24.5482C15.1179 25.049 15.794 25.3319 16.5001 25.3349C17.2016 25.3284 17.8722 25.0458 18.3667 24.5482L24.1001 18.8282C24.3502 18.5802 24.492 18.2432 24.4945 17.891C24.497 17.5387 24.36 17.1998 24.1134 16.9482Z",
            fill: fillColor
        })
    });
};
var ArrowUp = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#374957" : _fillColor, _width = param.width, width = _width === void 0 ? 33 : _width, _height = param.height, height = _height === void 0 ? 33 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.1134 13.1749L18.3801 7.45489C17.8804 6.95822 17.2046 6.67944 16.5001 6.67944C15.7956 6.67944 15.1197 6.95822 14.6201 7.45489L8.88675 13.1749C8.63841 13.4247 8.49902 13.7626 8.49902 14.1149C8.49902 14.4671 8.63841 14.8051 8.88675 15.0549C9.0107 15.1799 9.15817 15.2791 9.32064 15.3467C9.48312 15.4144 9.6574 15.4493 9.83341 15.4493C10.0094 15.4493 10.1837 15.4144 10.3462 15.3467C10.5087 15.2791 10.6561 15.1799 10.7801 15.0549L15.1667 10.6682V25.3349C15.1667 25.6885 15.3072 26.0277 15.5573 26.2777C15.8073 26.5277 16.1465 26.6682 16.5001 26.6682C16.8537 26.6682 17.1928 26.5277 17.4429 26.2777C17.6929 26.0277 17.8334 25.6885 17.8334 25.3349V10.6682L22.2201 15.0549C22.4694 15.306 22.8082 15.4477 23.162 15.449C23.5159 15.4502 23.8557 15.3109 24.1067 15.0616C24.3578 14.8123 24.4996 14.4734 24.5008 14.1196C24.5021 13.7658 24.3627 13.426 24.1134 13.1749V13.1749Z",
            fill: fillColor
        })
    });
};
var ArrowUpLeft = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.4284 20.7135L15.0004 11.2854L21.204 11.2854C21.3801 11.2861 21.5545 11.252 21.7172 11.185C21.88 11.1179 22.0279 11.0194 22.1523 10.8949C22.2768 10.7704 22.3754 10.6226 22.4424 10.4598C22.5094 10.297 22.5435 10.1226 22.5428 9.94662C22.5418 9.59437 22.4014 9.25685 22.1523 9.00778C21.9032 8.7587 21.5657 8.6183 21.2135 8.61726L13.1147 8.62668C12.4086 8.62457 11.7305 8.9026 11.2291 9.39978V9.39978C10.7377 9.90039 10.4633 10.5745 10.4655 11.276L10.456 19.3747C10.4566 19.5499 10.4918 19.7232 10.5594 19.8849C10.627 20.0465 10.7258 20.1932 10.8501 20.3166C10.9744 20.4401 11.1218 20.5378 11.2839 20.6043C11.446 20.6708 11.6196 20.7047 11.7948 20.7041C11.97 20.7034 12.1434 20.6683 12.305 20.6007C12.4666 20.5331 12.6133 20.4343 12.7368 20.31C12.8602 20.1857 12.958 20.0382 13.0244 19.8762C13.0909 19.7141 13.1248 19.5405 13.1242 19.3653L13.1147 13.171L22.5428 22.5991C22.7929 22.8492 23.132 22.9896 23.4856 22.9896C23.8393 22.9896 24.1784 22.8492 24.4284 22.5991C24.6785 22.3491 24.819 22.0099 24.819 21.6563C24.819 21.3027 24.6785 20.9635 24.4284 20.7135Z",
            fill: "#374957"
        })
    });
};
var RandomizeIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"
        })
    });
};
var TabDefaultIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20 8.00001L14 2.74001C13.45 2.24805 12.7379 1.97607 12 1.97607C11.2621 1.97607 10.55 2.24805 10 2.74001L4 8.00001C3.68237 8.28408 3.4289 8.63256 3.25647 9.02225C3.08404 9.41194 2.99661 9.83389 3 10.26V19C3 19.7957 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H18C18.7956 22 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7957 21 19V10.25C21.002 9.82557 20.9138 9.40555 20.7415 9.01769C20.5691 8.62983 20.3164 8.28296 20 8.00001ZM14 20H10V15C10 14.7348 10.1054 14.4804 10.2929 14.2929C10.4804 14.1054 10.7348 14 11 14H13C13.2652 14 13.5196 14.1054 13.7071 14.2929C13.8946 14.4804 14 14.7348 14 15V20ZM19 19C19 19.2652 18.8946 19.5196 18.7071 19.7071C18.5196 19.8946 18.2652 20 18 20H16V15C16 14.2044 15.6839 13.4413 15.1213 12.8787C14.5587 12.3161 13.7956 12 13 12H11C10.2043 12 9.44129 12.3161 8.87868 12.8787C8.31607 13.4413 8 14.2044 8 15V20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V10.25C5.00018 10.108 5.03059 9.9677 5.08922 9.83839C5.14784 9.70907 5.23333 9.59372 5.34 9.50001L11.34 4.25001C11.5225 4.08969 11.7571 4.00127 12 4.00127C12.2429 4.00127 12.4775 4.08969 12.66 4.25001L18.66 9.50001C18.7667 9.59372 18.8522 9.70907 18.9108 9.83839C18.9694 9.9677 18.9998 10.108 19 10.25V19Z",
            fill: fillColor
        })
    });
};
var PreviousImageSliderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.50001 12.8L14.2 18.4C14.6 18.8 15.2 18.8 15.6 18.4C16 18 16 17.4 15.6 17L10.7 12L15.6 6.99999C16 6.59999 16 5.99999 15.6 5.59999C15.4 5.39999 15.2 5.29999 14.9 5.29999C14.6 5.29999 14.4 5.39999 14.2 5.59999L8.50001 11.2C8.10001 11.7 8.10001 12.3 8.50001 12.8C8.50001 12.7 8.50001 12.7 8.50001 12.8Z",
            fill: fillColor
        })
    });
};
var NextImageSliderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.54 11.29L9.88001 5.64001C9.78705 5.54628 9.67645 5.47188 9.55459 5.42111C9.43273 5.37035 9.30202 5.34421 9.17001 5.34421C9.038 5.34421 8.90729 5.37035 8.78544 5.42111C8.66358 5.47188 8.55298 5.54628 8.46001 5.64001C8.27376 5.82737 8.16922 6.08082 8.16922 6.34501C8.16922 6.60919 8.27376 6.86264 8.46001 7.05001L13.41 12.05L8.46001 17C8.27376 17.1874 8.16922 17.4408 8.16922 17.705C8.16922 17.9692 8.27376 18.2226 8.46001 18.41C8.55263 18.5045 8.66307 18.5797 8.78495 18.6312C8.90682 18.6827 9.03771 18.7095 9.17001 18.71C9.30232 18.7095 9.4332 18.6827 9.55508 18.6312C9.67695 18.5797 9.7874 18.5045 9.88001 18.41L15.54 12.76C15.6415 12.6664 15.7225 12.5527 15.7779 12.4262C15.8333 12.2997 15.8619 12.1631 15.8619 12.025C15.8619 11.8869 15.8333 11.7503 15.7779 11.6238C15.7225 11.4973 15.6415 11.3836 15.54 11.29Z",
            fill: fillColor
        })
    });
};
var ShareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 14.0001C17.4092 14.004 16.8265 14.1388 16.294 14.3947C15.7615 14.6506 15.2922 15.0213 14.92 15.4801L9.82 13.1301C10.0598 12.3959 10.0598 11.6044 9.82 10.8701L14.92 8.52011C15.5216 9.24608 16.3603 9.73619 17.2881 9.90395C18.216 10.0717 19.1732 9.90634 19.9909 9.43702C20.8087 8.96769 21.4344 8.22459 21.7575 7.33886C22.0807 6.45312 22.0806 5.4817 21.7573 4.59602C21.434 3.71035 20.8081 2.96736 19.9903 2.49818C19.1725 2.02901 18.2152 1.86381 17.2874 2.03174C16.3597 2.19967 15.521 2.68993 14.9195 3.41601C14.318 4.14208 13.9924 5.05729 14 6.00011C14.003 6.23835 14.0264 6.47588 14.07 6.71011L8.79 9.14011C8.22708 8.58969 7.51424 8.21763 6.7408 8.07054C5.96736 7.92345 5.16772 8.00788 4.44205 8.31325C3.71638 8.61861 3.09696 9.13133 2.6614 9.78718C2.22584 10.443 1.9935 11.2128 1.9935 12.0001C1.9935 12.7874 2.22584 13.5572 2.6614 14.2131C3.09696 14.8689 3.71638 15.3816 4.44205 15.687C5.16772 15.9923 5.96736 16.0768 6.7408 15.9297C7.51424 15.7826 8.22708 15.4105 8.79 14.8601L14.07 17.2901C14.0264 17.5243 14.003 17.7619 14 18.0001C14 18.7912 14.2346 19.5646 14.6741 20.2224C15.1136 20.8802 15.7384 21.3929 16.4693 21.6956C17.2002 21.9984 18.0044 22.0776 18.7804 21.9233C19.5563 21.7689 20.269 21.388 20.8284 20.8285C21.3878 20.2691 21.7688 19.5564 21.9231 18.7805C22.0775 18.0046 21.9983 17.2003 21.6955 16.4694C21.3928 15.7385 20.8801 15.1138 20.2223 14.6742C19.5645 14.2347 18.7911 14.0001 18 14.0001ZM18 4.00011C18.3956 4.00011 18.7822 4.11741 19.1111 4.33718C19.44 4.55694 19.6964 4.8693 19.8478 5.23475C19.9991 5.6002 20.0387 6.00233 19.9616 6.3903C19.8844 6.77826 19.6939 7.13462 19.4142 7.41433C19.1345 7.69403 18.7781 7.88451 18.3902 7.96169C18.0022 8.03886 17.6001 7.99925 17.2346 7.84787C16.8692 7.6965 16.5568 7.44015 16.3371 7.11125C16.1173 6.78236 16 6.39568 16 6.00011C16 5.46968 16.2107 4.96097 16.5858 4.5859C16.9609 4.21083 17.4696 4.00011 18 4.00011ZM6 14.0001C5.60443 14.0001 5.21776 13.8828 4.88886 13.6631C4.55996 13.4433 4.30361 13.1309 4.15224 12.7655C4.00086 12.4 3.96126 11.9979 4.03843 11.6099C4.1156 11.222 4.30608 10.8656 4.58578 10.5859C4.86549 10.3062 5.22185 10.1157 5.60982 10.0385C5.99778 9.96137 6.39991 10.001 6.76536 10.1524C7.13082 10.3037 7.44317 10.5601 7.66294 10.889C7.8827 11.2179 8 11.6046 8 12.0001C8 12.5305 7.78928 13.0393 7.41421 13.4143C7.03914 13.7894 6.53043 14.0001 6 14.0001ZM18 20.0001C17.6044 20.0001 17.2178 19.8828 16.8889 19.6631C16.56 19.4433 16.3036 19.1309 16.1522 18.7655C16.0009 18.4 15.9613 17.9979 16.0384 17.6099C16.1156 17.222 16.3061 16.8656 16.5858 16.5859C16.8655 16.3062 17.2219 16.1157 17.6098 16.0385C17.9978 15.9614 18.3999 16.001 18.7654 16.1524C19.1308 16.3037 19.4432 16.5601 19.6629 16.889C19.8827 17.2179 20 17.6046 20 18.0001C20 18.5305 19.7893 19.0393 19.4142 19.4143C19.0391 19.7894 18.5304 20.0001 18 20.0001Z",
            fill: fillColor
        })
    });
};
var InboxIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.0557 2H5.05566C4.26028 2.00087 3.49772 2.31722 2.9353 2.87964C2.37288 3.44206 2.05653 4.20462 2.05566 5V19C2.05653 19.7954 2.37288 20.5579 2.9353 21.1204C3.49772 21.6828 4.26028 21.9991 5.05566 22H19.0557C19.851 21.9991 20.6136 21.6828 21.176 21.1204C21.7384 20.5579 22.0548 19.7954 22.0557 19V5C22.0548 4.20462 21.7384 3.44206 21.176 2.87964C20.6136 2.31722 19.851 2.00087 19.0557 2ZM5.05566 4H19.0557C19.3208 4.00026 19.575 4.10571 19.7625 4.29319C19.95 4.48066 20.0554 4.73486 20.0557 5V13H17.5908C17.2615 12.9997 16.9373 13.0809 16.6469 13.2363C16.3566 13.3917 16.1092 13.6165 15.9268 13.8906L14.5205 16H9.59082L8.18457 13.8906C8.00214 13.6165 7.75474 13.3917 7.46441 13.2363C7.17407 13.0809 6.84982 12.9997 6.52051 13H4.05566V5C4.05593 4.73486 4.16137 4.48066 4.34885 4.29319C4.53633 4.10571 4.79053 4.00026 5.05566 4ZM19.0557 20H5.05566C4.79053 19.9997 4.53633 19.8943 4.34885 19.7068C4.16137 19.5193 4.05593 19.2651 4.05566 19V15H6.52051L7.92676 17.1094C8.1092 17.3835 8.35659 17.6083 8.64693 17.7637C8.93726 17.9191 9.26152 18.0003 9.59082 18H14.5205C14.8498 18.0003 15.1741 17.9191 15.4644 17.7637C15.7547 17.6083 16.0021 17.3835 16.1846 17.1094L17.5908 15H20.0557V19C20.0554 19.2651 19.95 19.5193 19.7625 19.7068C19.575 19.8943 19.3208 19.9997 19.0557 20Z",
            fill: fillColor
        })
    });
};
var ShopeeIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.3471 22.417H4.53493C2.84312 22.417 1.47156 21.0454 1.47156 19.3536V4.79964C1.47156 3.10783 2.84312 1.73627 4.53493 1.73627H19.3472C21.0391 1.73627 22.4106 3.10783 22.4106 4.79964V19.3536C22.4106 21.0456 21.0391 22.417 19.3471 22.417Z",
                fill: "url(#paint0_linear_5471_268465)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.1362 8.05317C19.1362 7.88161 18.9983 7.74248 18.8279 7.74248H15.488C15.4062 5.56223 13.8498 3.82355 11.9414 3.82355C10.033 3.82355 8.47659 5.56223 8.39484 7.74248H5.05041C4.88259 7.74567 4.74722 7.88348 4.74722 8.05317C4.74722 8.06123 4.74778 8.06948 4.74853 8.07755H4.74609L5.22272 18.5875C5.22272 18.6167 5.22403 18.6462 5.22647 18.676C5.22647 18.6829 5.22703 18.6891 5.22778 18.6959L5.22909 18.7184L5.23041 18.7189C5.30278 19.4507 5.83359 20.0397 6.55491 20.067L6.55678 20.0684H17.219L17.2195 20.0678C17.9538 20.0479 18.5489 19.4507 18.6113 18.7103L18.6119 18.7097L18.6125 18.6998C18.613 18.6923 18.6138 18.6848 18.6138 18.6767C18.6151 18.658 18.6162 18.6392 18.6162 18.6212L19.1365 8.06949H19.136C19.1362 8.06367 19.1362 8.05861 19.1362 8.05317ZM11.9414 4.77174C13.3313 4.77174 14.4648 6.09117 14.5178 7.74248H9.36497C9.41784 6.09117 10.5509 4.77174 11.9414 4.77174ZM14.5784 15.9816C14.4843 16.7614 14.0114 17.3865 13.2788 17.6991C12.8708 17.8739 12.3237 17.968 11.8902 17.938C11.2139 17.9125 10.5788 17.7477 9.99366 17.4471C9.78403 17.3399 9.47278 17.1252 9.23316 16.9244C9.17259 16.8737 9.16509 16.8415 9.20503 16.7839C9.22678 16.7515 9.26672 16.6928 9.35541 16.563C9.48328 16.3754 9.49884 16.3521 9.51384 16.3298C9.55434 16.2674 9.62109 16.2617 9.68672 16.3135C9.69366 16.3185 9.69366 16.3185 9.69928 16.3229C9.70997 16.3309 9.70997 16.3309 9.73547 16.351C9.76097 16.3709 9.77597 16.3829 9.78234 16.3872C10.4137 16.8818 11.1492 17.167 11.8915 17.1957C12.9247 17.1812 13.6675 16.7172 13.8005 16.0041C13.9471 15.2192 13.3308 14.5412 12.1255 14.1632C11.7481 14.0453 10.7954 13.6635 10.6195 13.5606C9.79472 13.0765 9.40866 12.4427 9.46359 11.6592C9.54778 10.5737 10.5554 9.76392 11.8293 9.7583C12.3989 9.75774 12.9672 9.87567 13.513 10.1057C13.7063 10.1875 14.0513 10.3752 14.1706 10.4639C14.2392 10.5145 14.2529 10.573 14.2137 10.6367C14.1912 10.6735 14.155 10.7316 14.0789 10.8533L14.0776 10.8546C13.9771 11.0144 13.9741 11.0192 13.951 11.0567C13.9111 11.1179 13.8637 11.1235 13.792 11.0779C13.2074 10.6855 12.56 10.4879 11.8475 10.4734C10.961 10.4909 10.2967 11.0187 10.253 11.7379C10.2412 12.3874 10.7283 12.8609 11.7802 13.2227C13.9152 13.9084 14.7325 14.7126 14.5784 15.9816Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_5471_268465",
                    x1: "1.47146",
                    y1: "12.0766",
                    x2: "22.4106",
                    y2: "12.0766",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#FF6633"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.3304",
                            stopColor: "#FD5D32"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.8782",
                            stopColor: "#F7432E"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.9944",
                            stopColor: "#F53D2D"
                        })
                    ]
                })
            })
        ]
    });
};
var LazadaIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_5471_268464)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.0051 21.4852C11.8347 21.4864 11.6669 21.4429 11.5187 21.3588C10.2492 20.6244 0.846995 14.7291 0.492018 14.5492C0.221748 14.423 0.0372682 14.1648 0.00560437 13.8682V5.59939C-0.00143203 5.29078 0.151114 5.0003 0.409205 4.83089L0.477404 4.79201C1.3869 4.22774 4.43177 2.36968 4.91331 2.10221C5.02382 2.03663 5.14966 2.00135 5.27812 2C5.39864 2.00135 5.517 2.03139 5.62354 2.08759C5.62354 2.08759 9.88435 4.8649 10.5362 5.11297C10.9935 5.32307 11.4922 5.42781 11.9954 5.41942C12.5656 5.43142 13.129 5.29385 13.6297 5.0206C14.2669 4.68493 18.338 2.10221 18.3818 2.10221C18.4845 2.04014 18.6024 2.00821 18.7223 2.00974C18.8509 2.01037 18.9769 2.04565 19.0871 2.11195C19.6416 2.4184 23.4162 4.72877 23.5765 4.83089C23.842 4.99101 24.003 5.27968 23.9998 5.58965V13.8585C23.97 14.1557 23.7848 14.4149 23.5134 14.5395C23.1583 14.734 13.7853 20.6292 12.4915 21.3491C12.3442 21.4366 12.1764 21.4835 12.0051 21.4853V21.4852Z",
                        fill: "url(#paint0_linear_5471_268464)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.9567 21.4854H12.0053C12.1757 21.4864 12.3434 21.443 12.4917 21.3589C13.7611 20.6244 23.1585 14.7292 23.5136 14.5493C23.785 14.4247 23.9702 14.1654 23.9999 13.8683V5.59943C24.0015 5.45942 23.9699 5.32104 23.9075 5.19574L11.9567 11.7573V21.4854Z",
                        fill: "url(#paint1_linear_5471_268464)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.9148 21.3687H11.8667C11.6981 21.3699 11.5321 21.3268 11.3854 21.2436C10.1294 20.517 0.832276 14.6846 0.480997 14.5065C0.212441 14.3833 0.0292243 14.1269 -0.000184205 13.8329V5.65214C-0.00180799 5.51357 0.0295852 5.37672 0.0911988 5.25269L11.9148 11.7444V21.3687Z",
                        fill: "url(#paint2_linear_5471_268464)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_5471_268464",
                        x1: "0.0067771",
                        y1: "11.8356",
                        x2: "23.8664",
                        y2: "11.6508",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#FFB800"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.329412",
                                stopColor: "#F28000"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.560784",
                                stopColor: "#F73B72"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.780392",
                                stopColor: "#FB1CBD"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.929412",
                                stopColor: "#FD08ED"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF00FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_5471_268464",
                        x1: "6.71951",
                        y1: "19.5745",
                        x2: "31.0648",
                        y2: "6.09478",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#ED0A3F"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ED0A3F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint2_linear_5471_268464",
                        x1: "9.81821",
                        y1: "8.67328",
                        x2: "-3.38469",
                        y2: "13.533",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#ED5B00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.0862745",
                                stopColor: "#F37D00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.14902",
                                stopColor: "#EF6200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.501961",
                                stopColor: "#FB8A00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F9A000"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_5471_268464",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var TikiIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_5471_268463)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.00531 20.6421C8.40767 20.6421 7.9231 20.1576 7.9231 19.56V11.1421C7.9231 10.5444 8.4076 10.0599 9.00531 10.0599C9.60295 10.0599 10.0875 10.5444 10.0875 11.1421V19.5601C10.0875 20.1576 9.60295 20.6421 9.00531 20.6421Z",
                        fill: "#26AAE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.4349 20.6421C20.8372 20.6421 20.3528 20.1576 20.3528 19.56V11.1421C20.3528 10.5444 20.8372 10.0599 21.4349 10.0599C22.0326 10.0599 22.5171 10.5444 22.5171 11.1421V19.5601C22.5171 20.1576 22.0326 20.6421 21.4349 20.6421Z",
                        fill: "#26AAE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M6.39663 10.1443H1.02465C0.458752 10.1443 0 10.603 0 11.1689C0 11.7348 0.458752 12.1936 1.02465 12.1936H2.65286V19.584C2.65286 20.1499 3.11161 20.6086 3.6775 20.6086H3.77602C4.34191 20.6086 4.80066 20.1498 4.80066 19.584V12.1936H6.39663C6.96253 12.1936 7.42128 11.7348 7.42128 11.1689C7.42135 10.603 6.9626 10.1443 6.39663 10.1443Z",
                        fill: "#26AAE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.6071 15.9642C13.6071 17.1378 13.6088 18.2845 13.6064 19.4312C13.6048 20.1934 13.205 20.6133 12.4934 20.6087C11.7957 20.6041 11.4149 20.2063 11.4136 19.4492C11.4092 16.7286 11.4096 14.008 11.4133 11.2875C11.4144 10.5264 11.8278 10.074 12.5022 10.07C13.2249 10.0657 13.6053 10.487 13.6067 11.2983C13.6083 12.2525 13.6071 13.2066 13.6071 14.2904C13.9841 13.8941 14.2902 13.5749 14.5935 13.2529C15.481 12.3109 16.3648 11.3655 17.2554 10.4264C17.5914 10.0721 17.9984 9.96965 18.4614 10.1483C18.8726 10.3071 19.0961 10.6143 19.1253 11.0499C19.1545 11.4881 18.8922 11.797 18.6101 12.0792C17.8614 12.8282 17.1057 13.5703 16.346 14.3082C15.6459 14.9882 15.6419 14.9842 16.3305 15.7028C17.2769 16.6904 18.2233 17.6778 19.1697 18.6654C19.3854 18.8905 19.5825 19.1285 19.6183 19.4534C19.6653 19.8777 19.5723 20.2446 19.1665 20.4699C18.7625 20.6944 18.1782 20.6758 17.843 20.3605C17.3619 19.9078 16.9131 19.4197 16.4619 18.9361C15.5993 18.0113 14.7456 17.0781 13.8849 16.1515C13.8195 16.0812 13.774 15.9762 13.6071 15.9642Z",
                        fill: "#26AAE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8.95048 8.68004C7.85963 8.68004 6.97523 7.79571 6.97523 6.70479C6.97523 6.52517 6.99963 6.3514 7.04457 6.18604H10.8564C10.9013 6.3514 10.9257 6.52517 10.9257 6.70479C10.9258 7.79571 10.0414 8.68004 8.95048 8.68004ZM8.95048 4C7.5432 4 6.40234 5.14085 6.40234 6.54814C6.40234 7.95542 7.5432 9.09628 8.95048 9.09628C10.3578 9.09628 11.4987 7.95542 11.4987 6.54814C11.4987 5.14085 10.3578 4 8.95048 4Z",
                        fill: "#26AAE1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.4518 8.68004C20.3609 8.68004 19.4766 7.79571 19.4766 6.70479C19.4766 6.52517 19.501 6.3514 19.5459 6.18604H23.3577C23.4026 6.3514 23.427 6.52517 23.427 6.70479C23.427 7.79571 22.5427 8.68004 21.4518 8.68004ZM21.4518 4C20.0445 4 18.9037 5.14085 18.9037 6.54814C18.9037 7.95542 20.0445 9.09628 21.4518 9.09628C22.8591 9.09628 23.9999 7.95542 23.9999 6.54814C24 5.14085 22.8591 4 21.4518 4Z",
                        fill: "#26AAE1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_5471_268463",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ExclamationTriangleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22.7 17.5L14.6 3.49999C13.8 2.09999 11.9 1.59999 10.5 2.39999C10 2.69999 9.60001 3.09999 9.40001 3.49999L1.30001 17.5C0.500011 18.9 1.00001 20.8 2.40001 21.6C2.90001 21.9 3.40001 22 3.90001 22H20C21.7 22 23 20.6 23 19C23.1 18.4 22.9 17.9 22.7 17.5ZM12 18C11.4 18 11 17.6 11 17C11 16.4 11.4 16 12 16C12.6 16 13 16.4 13 17C13 17.6 12.6 18 12 18ZM13 13C13 13.6 12.6 14 12 14C11.4 14 11 13.6 11 13V8.99999C11 8.39999 11.4 7.99999 12 7.99999C12.6 7.99999 13 8.39999 13 8.99999V13Z",
            fill: fillColor
        })
    });
};
var EditTabDesignIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 7.24002C22.0008 7.10841 21.9755 6.97795 21.9258 6.85611C21.876 6.73427 21.8027 6.62346 21.71 6.53002L17.47 2.29002C17.3766 2.19734 17.2657 2.12401 17.1439 2.07425C17.0221 2.02448 16.8916 1.99926 16.76 2.00002C16.6284 1.99926 16.4979 2.02448 16.3761 2.07425C16.2543 2.12401 16.1434 2.19734 16.05 2.29002L13.22 5.12002L2.29 16.05C2.19732 16.1435 2.12399 16.2543 2.07423 16.3761C2.02447 16.4979 1.99924 16.6284 2 16.76V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8947 2.73478 22 3 22H7.24C7.37993 22.0076 7.51989 21.9857 7.65082 21.9358C7.78175 21.8858 7.90071 21.8089 8 21.71L18.87 10.78L21.71 8.00002C21.8013 7.9031 21.8756 7.79155 21.93 7.67002C21.9396 7.59031 21.9396 7.50973 21.93 7.43002C21.9347 7.38347 21.9347 7.33657 21.93 7.29002L22 7.24002ZM6.83 20H4V17.17L13.93 7.24002L16.76 10.07L6.83 20ZM18.17 8.66002L15.34 5.83002L16.76 4.42002L19.58 7.24002L18.17 8.66002Z",
            fill: fillColor
        })
    });
};
var QuestionCircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5ZM13 16.2V17.3C13 17.4105 12.9105 17.5 12.8 17.5H11.7C11.5895 17.5 11.5 17.4105 11.5 17.3V16.2C11.5 16.0895 11.5895 16 11.7 16H12.8C12.9105 16 13 16.0895 13 16.2ZM12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.0853 14.446 12.4245 13.0005 12.8549L13.0001 14.3C13 14.4104 12.9104 14.4999 12.8 14.5H11.7C11.5895 14.5 11.5 14.4105 11.5 14.3V11.7C11.5 11.5895 11.5895 11.5 11.7 11.5H12C13.1046 11.5 14 10.6046 14 9.5C14 8.39543 13.1046 7.5 12 7.5C10.8954 7.5 10 8.39543 10 9.5H8.5C8.5 7.567 10.067 6 12 6Z",
            fill: fillColor
        })
    });
};
var GlobalIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.41 8.63988C21.41 8.63988 21.41 8.63988 21.41 8.58988C20.7054 6.6661 19.4269 5.00516 17.7475 3.83174C16.0681 2.65832 14.0687 2.02905 12.02 2.02905C9.97125 2.02905 7.97193 2.65832 6.29251 3.83174C4.61308 5.00516 3.3346 6.6661 2.63 8.58988C2.63 8.58988 2.63 8.58988 2.63 8.63988C1.84312 10.8108 1.84312 13.189 2.63 15.3599C2.63 15.3599 2.63 15.3599 2.63 15.4099C3.3346 17.3337 4.61308 18.9946 6.29251 20.168C7.97193 21.3414 9.97125 21.9707 12.02 21.9707C14.0687 21.9707 16.0681 21.3414 17.7475 20.168C19.4269 18.9946 20.7054 17.3337 21.41 15.4099C21.41 15.4099 21.41 15.4099 21.41 15.3599C22.1969 13.189 22.1969 10.8108 21.41 8.63988ZM4.26 13.9999C3.91322 12.6891 3.91322 11.3107 4.26 9.99988H6.12C5.96003 11.3284 5.96003 12.6713 6.12 13.9999H4.26ZM5.08 15.9999H6.48C6.71472 16.8917 7.05021 17.7539 7.48 18.5699C6.4993 17.9018 5.67949 17.0239 5.08 15.9999ZM6.48 7.99988H5.08C5.67087 6.97897 6.48019 6.10135 7.45 5.42988C7.03055 6.24713 6.70514 7.1093 6.48 7.99988ZM11 19.6999C9.77176 18.7986 8.90915 17.4851 8.57 15.9999H11V19.6999ZM11 13.9999H8.14C7.95339 12.6731 7.95339 11.3267 8.14 9.99988H11V13.9999ZM11 7.99988H8.57C8.90915 6.51465 9.77176 5.2012 11 4.29988V7.99988ZM18.92 7.99988H17.52C17.2853 7.10804 16.9498 6.24582 16.52 5.42988C17.5007 6.09795 18.3205 6.97582 18.92 7.99988ZM13 4.29988C14.2282 5.2012 15.0908 6.51465 15.43 7.99988H13V4.29988ZM13 19.6999V15.9999H15.43C15.0908 17.4851 14.2282 18.7986 13 19.6999ZM15.86 13.9999H13V9.99988H15.86C16.0466 11.3267 16.0466 12.6731 15.86 13.9999ZM16.55 18.5699C16.9798 17.7539 17.3153 16.8917 17.55 15.9999H18.95C18.3505 17.0239 17.5307 17.9018 16.55 18.5699ZM19.74 13.9999H17.88C17.9613 13.3363 18.0014 12.6684 18 11.9999C18.0011 11.3314 17.961 10.6635 17.88 9.99988H19.74C20.0868 11.3107 20.0868 12.6891 19.74 13.9999Z",
            fill: fillColor
        })
    });
};
var ImageSliderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C10.4385 2.00113 8.8989 2.36793 7.50461 3.07104C6.11032 3.77414 4.90006 4.79399 3.97078 6.04891C3.0415 7.30383 2.41901 8.75894 2.15319 10.2977C1.88737 11.8364 1.9856 13.416 2.44 14.91C2.43421 14.9431 2.43421 14.9769 2.44 15.01C2.81677 16.2218 3.42463 17.3493 4.23 18.33L2.23 20.33C2.09125 20.4706 1.99725 20.6492 1.95988 20.8432C1.9225 21.0372 1.94343 21.2379 2.02 21.42C2.10495 21.6049 2.24427 21.7595 2.41938 21.8631C2.59449 21.9668 2.79705 22.0145 3 22H12C14.0872 21.9985 16.1215 21.3439 17.818 20.128C19.5144 18.9122 20.7879 17.196 21.46 15.22V15.14C21.8085 14.1294 21.9909 13.069 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20H5.41L5.71 19.71L14.12 11.29C14.3069 11.1068 14.5583 11.0041 14.82 11.0041C15.0818 11.0041 15.3331 11.1068 15.52 11.29L19.14 14.89L19.37 15.11C18.7584 16.5594 17.7331 17.7964 16.4222 18.6661C15.1114 19.5359 13.5732 19.9999 12 20ZM4.54 14.87L6.12 13.29C6.30737 13.1037 6.56082 12.9992 6.825 12.9992C7.08919 12.9992 7.34264 13.1037 7.53 13.29L8.4 14.16L5.68 16.9C5.19892 16.2853 4.81449 15.6007 4.54 14.87ZM19.95 12.87L16.95 9.87C16.3875 9.3082 15.625 8.99264 14.83 8.99264C14.035 8.99264 13.2725 9.3082 12.71 9.87L9.82 12.76L8.94 11.89C8.37792 11.3312 7.61756 11.0176 6.825 11.0176C6.03245 11.0176 5.27209 11.3312 4.71 11.89L4 12.56C3.99004 12.3735 3.99004 12.1865 4 12C4 9.87827 4.84286 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1572 7.84344 20 9.87827 20 12C20.0149 12.2865 20.0149 12.5735 20 12.86L19.95 12.87Z",
            fill: fillColor
        })
    });
};
var ButtonLinkIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.11 15.3901L8.22999 19.2701C7.76023 19.7235 7.13285 19.9768 6.47999 19.9768C5.82713 19.9768 5.19975 19.7235 4.72999 19.2701C4.49959 19.0406 4.31678 18.7679 4.19204 18.4676C4.0673 18.1673 4.00309 17.8453 4.00309 17.5201C4.00309 17.1949 4.0673 16.8729 4.19204 16.5726C4.31678 16.2723 4.49959 15.9996 4.72999 15.7701L8.60999 11.8901C8.79829 11.7018 8.90408 11.4464 8.90408 11.1801C8.90408 10.9138 8.79829 10.6584 8.60999 10.4701C8.42169 10.2818 8.16629 10.176 7.89999 10.176C7.63369 10.176 7.37829 10.2818 7.18999 10.4701L3.30999 14.3601C2.52835 15.2109 2.10561 16.3308 2.13006 17.4858C2.15452 18.6409 2.62427 19.7419 3.44122 20.5589C4.25817 21.3758 5.35915 21.8456 6.51424 21.87C7.66932 21.8945 8.7892 21.4717 9.63999 20.6901L13.53 16.8101C13.7183 16.6218 13.8241 16.3664 13.8241 16.1001C13.8241 15.8338 13.7183 15.5784 13.53 15.3901C13.3417 15.2018 13.0863 15.096 12.82 15.096C12.5537 15.096 12.2983 15.2018 12.11 15.3901ZM20.69 3.31009C19.8488 2.4741 18.711 2.00488 17.525 2.00488C16.339 2.00488 15.2012 2.4741 14.36 3.31009L10.47 7.19009C10.3768 7.28333 10.3028 7.39402 10.2523 7.51585C10.2019 7.63767 10.1759 7.76824 10.1759 7.90009C10.1759 8.03195 10.2019 8.16252 10.2523 8.28434C10.3028 8.40617 10.3768 8.51686 10.47 8.61009C10.5632 8.70333 10.6739 8.77729 10.7957 8.82775C10.9176 8.87821 11.0481 8.90419 11.18 8.90419C11.3118 8.90419 11.4424 8.87821 11.5642 8.82775C11.6861 8.77729 11.7968 8.70333 11.89 8.61009L15.77 4.73009C16.2398 4.27672 16.8671 4.02335 17.52 4.02335C18.1728 4.02335 18.8002 4.27672 19.27 4.73009C19.5004 4.95958 19.6832 5.2323 19.8079 5.53261C19.9327 5.83292 19.9969 6.15491 19.9969 6.48009C19.9969 6.80528 19.9327 7.12727 19.8079 7.42758C19.6832 7.72789 19.5004 8.00061 19.27 8.23009L15.39 12.1101C15.2963 12.2031 15.2219 12.3137 15.1711 12.4355C15.1203 12.5574 15.0942 12.6881 15.0942 12.8201C15.0942 12.9521 15.1203 13.0828 15.1711 13.2047C15.2219 13.3265 15.2963 13.4371 15.39 13.5301C15.483 13.6238 15.5936 13.6982 15.7154 13.749C15.8373 13.7998 15.968 13.8259 16.1 13.8259C16.232 13.8259 16.3627 13.7998 16.4846 13.749C16.6064 13.6982 16.717 13.6238 16.81 13.5301L20.69 9.64009C21.526 8.79887 21.9952 7.66107 21.9952 6.47509C21.9952 5.28912 21.526 4.15131 20.69 3.31009ZM8.82999 15.1701C8.92343 15.2628 9.03425 15.3361 9.15608 15.3859C9.27792 15.4356 9.40838 15.4609 9.53999 15.4601C9.6716 15.4609 9.80206 15.4356 9.9239 15.3859C10.0457 15.3361 10.1565 15.2628 10.25 15.1701L15.17 10.2501C15.3583 10.0618 15.4641 9.8064 15.4641 9.54009C15.4641 9.27379 15.3583 9.0184 15.17 8.83009C14.9817 8.64179 14.7263 8.536 14.46 8.536C14.1937 8.536 13.9383 8.64179 13.75 8.83009L8.82999 13.7501C8.73626 13.8431 8.66187 13.9537 8.6111 14.0755C8.56033 14.1974 8.53419 14.3281 8.53419 14.4601C8.53419 14.5921 8.56033 14.7228 8.6111 14.8447C8.66187 14.9665 8.73626 15.0771 8.82999 15.1701Z",
            fill: fillColor
        })
    });
};
var DefaultIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.6 10.9C13.7 11 13.8 11 14 11H21C21.6 11 22 10.6 22 10C22 9.8 22 9.7 21.9 9.6L18.4 2.6C18.1 2.1 17.5 1.9 17 2.2C16.9 2.3 16.7 2.4 16.6 2.6L13.1 9.6C12.9 10 13.1 10.6 13.6 10.9ZM17.5 5.2L19.4 9H15.6L17.5 5.2ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2ZM6.5 9C5.1 9 4 7.9 4 6.5C4 5.1 5.1 4 6.5 4C7.9 4 9 5.1 9 6.5C9 7.9 7.9 9 6.5 9ZM10.7 13.3C10.3 12.9 9.7 12.9 9.3 13.3L6.5 16.1L3.7 13.3C3.3 12.9 2.7 12.9 2.3 13.3C1.9 13.7 1.9 14.3 2.3 14.7L5.1 17.5L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.7 22.1 3.3 22.1 3.7 21.7L6.5 18.9L9.3 21.7C9.7 22.1 10.3 22.1 10.7 21.7C11.1 21.3 11.1 20.7 10.7 20.3L7.9 17.5L10.7 14.7C11.1 14.3 11.1 13.7 10.7 13.3ZM21 13H14C13.4 13 13 13.4 13 14V21C13 21.6 13.4 22 14 22H21C21.6 22 22 21.6 22 21V14C22 13.4 21.6 13 21 13ZM20 20H15V15H20V20Z",
            fill: fillColor
        })
    });
};
var StoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22 7.82001C22.0048 7.75677 22.0048 7.69325 22 7.63001L20 2.63001C19.9219 2.43237 19.7828 2.26475 19.603 2.15147C19.4232 2.03819 19.212 1.98514 19 2.00001H5C4.79972 1.99982 4.604 2.05977 4.43818 2.17209C4.27237 2.28442 4.1441 2.44395 4.07 2.63001L2.07 7.63001C2.06518 7.69325 2.06518 7.75677 2.07 7.82001C2.03677 7.87568 2.01311 7.93652 2 8.00001C2.01113 8.69125 2.20123 9.36781 2.55174 9.96369C2.90226 10.5596 3.40124 11.0544 4 11.4V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8947 4.73478 22 5 22H19C19.2652 22 19.5196 21.8947 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21V11.44C20.6046 11.091 21.1072 10.5898 21.4581 9.98635C21.809 9.38287 21.9958 8.69807 22 8.00001C22.0094 7.94038 22.0094 7.87965 22 7.82001ZM13 20H11V16H13V20ZM18 20H15V15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14H10C9.73478 14 9.48043 14.1054 9.29289 14.2929C9.10536 14.4804 9 14.7348 9 15V20H6V12C6.56947 11.9968 7.13169 11.872 7.64905 11.634C8.16642 11.3961 8.627 11.0503 9 10.62C9.37537 11.0456 9.83701 11.3865 10.3542 11.62C10.8715 11.8535 11.4325 11.9743 12 11.9743C12.5675 11.9743 13.1285 11.8535 13.6458 11.62C14.163 11.3865 14.6246 11.0456 15 10.62C15.373 11.0503 15.8336 11.3961 16.3509 11.634C16.8683 11.872 17.4305 11.9968 18 12V20ZM18 10C17.4696 10 16.9609 9.7893 16.5858 9.41423C16.2107 9.03915 16 8.53045 16 8.00001C16 7.7348 15.8946 7.48044 15.7071 7.29291C15.5196 7.10537 15.2652 7.00001 15 7.00001C14.7348 7.00001 14.4804 7.10537 14.2929 7.29291C14.1054 7.48044 14 7.7348 14 8.00001C14 8.53045 13.7893 9.03915 13.4142 9.41423C13.0391 9.7893 12.5304 10 12 10C11.4696 10 10.9609 9.7893 10.5858 9.41423C10.2107 9.03915 10 8.53045 10 8.00001C10 7.7348 9.89464 7.48044 9.70711 7.29291C9.51957 7.10537 9.26522 7.00001 9 7.00001C8.73478 7.00001 8.48043 7.10537 8.29289 7.29291C8.10536 7.48044 8 7.7348 8 8.00001C8.00985 8.26266 7.96787 8.52467 7.87646 8.77109C7.78505 9.01751 7.646 9.24351 7.46725 9.43619C7.28849 9.62887 7.07354 9.78446 6.83466 9.89407C6.59578 10.0037 6.33764 10.0652 6.075 10.075C5.54457 10.0949 5.02796 9.90327 4.63882 9.54226C4.44614 9.36351 4.29055 9.14855 4.18094 8.90967C4.07133 8.67079 4.00985 8.41266 4 8.15001L5.68 4.00001H18.32L20 8.15001C19.9621 8.65403 19.7348 9.125 19.3637 9.46822C18.9927 9.81143 18.5054 10.0014 18 10Z",
            fill: fillColor
        })
    });
};
var FolderArrowRightIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19 5.50002H12.72L12.4 4.50002C12.1926 3.91325 11.8077 3.40553 11.2989 3.04718C10.7901 2.68884 10.1824 2.49762 9.56 2.50002H5C4.20435 2.50002 3.44129 2.81609 2.87868 3.3787C2.31607 3.94131 2 4.70437 2 5.50002V18.5C2 19.2957 2.31607 20.0587 2.87868 20.6213C3.44129 21.184 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.184 21.1213 20.6213C21.6839 20.0587 22 19.2957 22 18.5V8.50002C22 7.70437 21.6839 6.94131 21.1213 6.3787C20.5587 5.81609 19.7956 5.50002 19 5.50002ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3947 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3947 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V5.50002C4 5.23481 4.10536 4.98045 4.29289 4.79292C4.48043 4.60538 4.73478 4.50002 5 4.50002H9.56C9.76964 4.49948 9.97416 4.56484 10.1446 4.68686C10.3151 4.80889 10.4429 4.9814 10.51 5.18002L11.05 6.82002C11.1171 7.01864 11.2449 7.19116 11.4154 7.31318C11.5858 7.4352 11.7904 7.50056 12 7.50002H19C19.2652 7.50002 19.5196 7.60538 19.7071 7.79292C19.8946 7.98045 20 8.23481 20 8.50002V18.5Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.4234 13.8841C15.3758 14.0068 15.3044 14.119 15.2134 14.2141L13.2134 16.2141C13.1204 16.3078 13.0098 16.3822 12.8879 16.433C12.7661 16.4838 12.6354 16.5099 12.5034 16.5099C12.3713 16.5099 12.2406 16.4838 12.1188 16.433C11.9969 16.3822 11.8863 16.3078 11.7934 16.2141C11.6996 16.1211 11.6252 16.0105 11.5745 15.8887C11.5237 15.7668 11.4976 15.6361 11.4976 15.5041C11.4976 15.3721 11.5237 15.2414 11.5745 15.1195C11.6252 14.9977 11.6996 14.8871 11.7934 14.7941L12.0934 14.5041L9.50335 14.5041C9.23814 14.5041 8.98378 14.3987 8.79625 14.2112C8.60871 14.0237 8.50335 13.7693 8.50335 13.5041C8.50335 13.2389 8.60871 12.9845 8.79625 12.797C8.98378 12.6094 9.23814 12.5041 9.50335 12.5041L12.0934 12.5041L11.7934 12.2141C11.6051 12.0258 11.4993 11.7704 11.4993 11.5041C11.4993 11.2378 11.6051 10.9824 11.7934 10.7941C11.9817 10.6058 12.2371 10.5 12.5034 10.5C12.7697 10.5 13.0251 10.6058 13.2134 10.7941L15.2134 12.7941C15.3044 12.8892 15.3758 13.0013 15.4234 13.1241C15.5234 13.3676 15.5234 13.6406 15.4234 13.8841Z",
                fill: fillColor
            })
        ]
    });
};
var MoveToTopIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.71 6.29C5.6149 6.19896 5.50275 6.12759 5.38 6.08C5.13654 5.97998 4.86346 5.97998 4.62 6.08C4.49725 6.12759 4.38511 6.19896 4.29 6.29L2.29 8.29C2.1017 8.4783 1.99591 8.7337 1.99591 9C1.99591 9.2663 2.1017 9.5217 2.29 9.71C2.47831 9.8983 2.7337 10.0041 3 10.0041C3.2663 10.0041 3.5217 9.8983 3.71 9.71L4 9.41V17C4 17.2652 4.10536 17.5196 4.2929 17.7071C4.48043 17.8946 4.73479 18 5 18C5.26522 18 5.51957 17.8946 5.70711 17.7071C5.89465 17.5196 6 17.2652 6 17V9.41L6.29 9.71C6.38297 9.80373 6.49357 9.87812 6.61543 9.92889C6.73728 9.97966 6.86799 10.0058 7 10.0058C7.13201 10.0058 7.26272 9.97966 7.38458 9.92889C7.50644 9.87812 7.61704 9.80373 7.71 9.71C7.80373 9.61704 7.87812 9.50644 7.92889 9.38458C7.97966 9.26272 8.0058 9.13201 8.0058 9C8.0058 8.86799 7.97966 8.73728 7.92889 8.61542C7.87812 8.49356 7.80373 8.38296 7.71 8.29L5.71 6.29ZM11 8H21C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H11C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7C10 7.26522 10.1054 7.51957 10.2929 7.70711C10.4804 7.89464 10.7348 8 11 8ZM21 16H11C10.7348 16 10.4804 16.1054 10.2929 16.2929C10.1054 16.4804 10 16.7348 10 17C10 17.2652 10.1054 17.5196 10.2929 17.7071C10.4804 17.8946 10.7348 18 11 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM21 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12C10 12.2652 10.1054 12.5196 10.2929 12.7071C10.4804 12.8946 10.7348 13 11 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z",
            fill: fillColor
        })
    });
};
var MoveToBottomIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.28994 14.29L5.99994 14.59V7C5.99994 6.73478 5.89458 6.48043 5.70705 6.29289C5.51951 6.10536 5.26516 6 4.99994 6C4.73472 6 4.48037 6.10536 4.29283 6.29289C4.1053 6.48043 3.99994 6.73478 3.99994 7V14.59L3.70994 14.29C3.52164 14.1017 3.26624 13.9959 2.99994 13.9959C2.73364 13.9959 2.47824 14.1017 2.28994 14.29C2.10164 14.4783 1.99585 14.7337 1.99585 15C1.99585 15.2663 2.10164 15.5217 2.28994 15.71L4.28994 17.71C4.38505 17.801 4.49719 17.8724 4.61994 17.92C4.73964 17.9729 4.86907 18.0002 4.99994 18.0002C5.13081 18.0002 5.26024 17.9729 5.37994 17.92C5.50269 17.8724 5.61484 17.801 5.70994 17.71L7.70994 15.71C7.80318 15.6168 7.87714 15.5061 7.9276 15.3842C7.97806 15.2624 8.00403 15.1319 8.00403 15C8.00403 14.8681 7.97806 14.7376 7.9276 14.6158C7.87714 14.4939 7.80318 14.3832 7.70994 14.29C7.6167 14.1968 7.50601 14.1228 7.38419 14.0723C7.26237 14.0219 7.1318 13.9959 6.99994 13.9959C6.86808 13.9959 6.73751 14.0219 6.61569 14.0723C6.49387 14.1228 6.38318 14.1968 6.28994 14.29ZM10.9999 8H20.9999C21.2652 8 21.5195 7.89464 21.707 7.70711C21.8946 7.51957 21.9999 7.26522 21.9999 7C21.9999 6.73478 21.8946 6.48043 21.707 6.29289C21.5195 6.10536 21.2652 6 20.9999 6H10.9999C10.7347 6 10.4804 6.10536 10.2928 6.29289C10.1053 6.48043 9.99994 6.73478 9.99994 7C9.99994 7.26522 10.1053 7.51957 10.2928 7.70711C10.4804 7.89464 10.7347 8 10.9999 8ZM20.9999 11H10.9999C10.7347 11 10.4804 11.1054 10.2928 11.2929C10.1053 11.4804 9.99994 11.7348 9.99994 12C9.99994 12.2652 10.1053 12.5196 10.2928 12.7071C10.4804 12.8946 10.7347 13 10.9999 13H20.9999C21.2652 13 21.5195 12.8946 21.707 12.7071C21.8946 12.5196 21.9999 12.2652 21.9999 12C21.9999 11.7348 21.8946 11.4804 21.707 11.2929C21.5195 11.1054 21.2652 11 20.9999 11ZM20.9999 16H10.9999C10.7347 16 10.4804 16.1054 10.2928 16.2929C10.1053 16.4804 9.99994 16.7348 9.99994 17C9.99994 17.2652 10.1053 17.5196 10.2928 17.7071C10.4804 17.8946 10.7347 18 10.9999 18H20.9999C21.2652 18 21.5195 17.8946 21.707 17.7071C21.8946 17.5196 21.9999 17.2652 21.9999 17C21.9999 16.7348 21.8946 16.4804 21.707 16.2929C21.5195 16.1054 21.2652 16 20.9999 16Z",
            fill: fillColor
        })
    });
};
var UploadIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.71 6.70994L11 5.40994V16.9999C11 17.2652 11.1054 17.5195 11.2929 17.707C11.4804 17.8946 11.7348 17.9999 12 17.9999C12.2652 17.9999 12.5196 17.8946 12.7071 17.707C12.8946 17.5195 13 17.2652 13 16.9999V5.40994L14.29 6.70994C14.383 6.80367 14.4936 6.87806 14.6154 6.92883C14.7373 6.9796 14.868 7.00574 15 7.00574C15.132 7.00574 15.2627 6.9796 15.3846 6.92883C15.5064 6.87806 15.617 6.80367 15.71 6.70994C15.8037 6.61698 15.8781 6.50637 15.9289 6.38452C15.9797 6.26266 16.0058 6.13195 16.0058 5.99994C16.0058 5.86793 15.9797 5.73722 15.9289 5.61536C15.8781 5.4935 15.8037 5.3829 15.71 5.28994L12.71 2.28994C12.617 2.19621 12.5064 2.12182 12.3846 2.07105C12.2627 2.02028 12.132 1.99414 12 1.99414C11.868 1.99414 11.7373 2.02028 11.6154 2.07105C11.4936 2.12182 11.383 2.19621 11.29 2.28994L8.29 5.28994C8.1017 5.47824 7.99591 5.73364 7.99591 5.99994C7.99591 6.26624 8.1017 6.52164 8.29 6.70994C8.4783 6.89824 8.7337 7.00403 9 7.00403C9.2663 7.00403 9.5217 6.89824 9.71 6.70994ZM18 8.99994H16C15.7348 8.99994 15.4804 9.1053 15.2929 9.29283C15.1054 9.48037 15 9.73472 15 9.99994C15 10.2652 15.1054 10.5195 15.2929 10.707C15.4804 10.8946 15.7348 10.9999 16 10.9999H18C18.2652 10.9999 18.5196 11.1053 18.7071 11.2928C18.8946 11.4804 19 11.7347 19 11.9999V18.9999C19 19.2652 18.8946 19.5195 18.7071 19.707C18.5196 19.8946 18.2652 19.9999 18 19.9999H6C5.73478 19.9999 5.48043 19.8946 5.29289 19.707C5.10536 19.5195 5 19.2652 5 18.9999V11.9999C5 11.7347 5.10536 11.4804 5.29289 11.2928C5.48043 11.1053 5.73478 10.9999 6 10.9999H8C8.26522 10.9999 8.51957 10.8946 8.70711 10.707C8.89464 10.5195 9 10.2652 9 9.99994C9 9.73472 8.89464 9.48037 8.70711 9.29283C8.51957 9.1053 8.26522 8.99994 8 8.99994H6C5.20435 8.99994 4.44129 9.31601 3.87868 9.87862C3.31607 10.4412 3 11.2043 3 11.9999V18.9999C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 21.9999 6 21.9999H18C18.7956 21.9999 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7956 21 18.9999V11.9999C21 11.2043 20.6839 10.4412 20.1213 9.87862C19.5587 9.31601 18.7956 8.99994 18 8.99994Z",
            fill: fillColor
        })
    });
};
var InfomationCircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM13 15.5C13 15.7652 12.8946 16.0196 12.7071 16.2071C12.5196 16.3946 12.2652 16.5 12 16.5C11.7348 16.5 11.4804 16.3946 11.2929 16.2071C11.1054 16.0196 11 15.7652 11 15.5V12.5C11 12.2348 11.1054 11.9804 11.2929 11.7929C11.4804 11.6054 11.7348 11.5 12 11.5C12.2652 11.5 12.5196 11.6054 12.7071 11.7929C12.8946 11.9804 13 12.2348 13 12.5V15.5ZM12 10C11.7528 10 11.5111 9.92669 11.3055 9.78934C11.1 9.65199 10.9398 9.45676 10.8452 9.22835C10.7505 8.99995 10.7258 8.74861 10.774 8.50614C10.8223 8.26366 10.9413 8.04093 11.1161 7.86612C11.2909 7.6913 11.5137 7.57225 11.7561 7.52402C11.9986 7.47579 12.25 7.50054 12.4784 7.59515C12.7068 7.68976 12.902 7.84998 13.0393 8.05554C13.1767 8.2611 13.25 8.50277 13.25 8.75C13.25 9.08152 13.1183 9.39946 12.8839 9.63388C12.6495 9.8683 12.3315 10 12 10Z",
            fill: fillColor
        })
    });
};
var ThemeStoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 16C6.80222 16 6.60888 16.0586 6.44443 16.1685C6.27998 16.2784 6.15181 16.4346 6.07612 16.6173C6.00043 16.8 5.98063 17.0011 6.01921 17.1951C6.0578 17.3891 6.15304 17.5673 6.29289 17.7071C6.43275 17.847 6.61093 17.9422 6.80491 17.9808C6.99889 18.0194 7.19996 17.9996 7.38268 17.9239C7.56541 17.8482 7.72159 17.72 7.83147 17.5556C7.94135 17.3911 8 17.1978 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16ZM19.06 12L20.29 10.77C20.8518 10.2075 21.1674 9.445 21.1674 8.65C21.1674 7.855 20.8518 7.0925 20.29 6.53L17.46 3.71C16.8975 3.1482 16.135 2.83264 15.34 2.83264C14.545 2.83264 13.7825 3.1482 13.22 3.71L12 4.94C11.9843 4.15479 11.6613 3.40706 11.1004 2.85736C10.5395 2.30766 9.78536 1.99984 9 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V15C22.0002 14.2146 21.6923 13.4605 21.1426 12.8996C20.5929 12.3387 19.8452 12.0157 19.06 12ZM10 19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289C9.89464 4.48043 10 4.73478 10 5V19ZM12 7.76L14.64 5.12C14.8274 4.93375 15.0808 4.82921 15.345 4.82921C15.6092 4.82921 15.8626 4.93375 16.05 5.12L18.88 8C19.0663 8.18736 19.1708 8.44081 19.1708 8.705C19.1708 8.96919 19.0663 9.22264 18.88 9.41L16 12.29L12 16.24V7.76ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H11.82C11.9226 19.7036 11.9799 19.3935 11.99 19.08L17.07 14H19C19.2652 14 19.5196 14.1054 19.7071 14.2929C19.8946 14.4804 20 14.7348 20 15V19Z",
            fill: fillColor
        })
    });
};
var HomeIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20 8.00001L14 2.74001C13.45 2.24805 12.7379 1.97607 12 1.97607C11.262 1.97607 10.55 2.24805 9.99997 2.74001L3.99997 8.00001C3.68234 8.28408 3.42887 8.63256 3.25644 9.02225C3.08402 9.41194 2.99659 9.83389 2.99997 10.26V19C2.99997 19.7957 3.31604 20.5587 3.87865 21.1213C4.44126 21.6839 5.20432 22 5.99997 22H18C18.7956 22 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7957 21 19V10.25C21.0019 9.82557 20.9138 9.40555 20.7414 9.01769C20.5691 8.62983 20.3163 8.28296 20 8.00001V8.00001ZM14 20H9.99997V15C9.99997 14.7348 10.1053 14.4804 10.2929 14.2929C10.4804 14.1054 10.7348 14 11 14H13C13.2652 14 13.5195 14.1054 13.7071 14.2929C13.8946 14.4804 14 14.7348 14 15V20ZM19 19C19 19.2652 18.8946 19.5196 18.7071 19.7071C18.5195 19.8946 18.2652 20 18 20H16V15C16 14.2044 15.6839 13.4413 15.1213 12.8787C14.5587 12.3161 13.7956 12 13 12H11C10.2043 12 9.44126 12.3161 8.87865 12.8787C8.31604 13.4413 7.99997 14.2044 7.99997 15V20H5.99997C5.73476 20 5.4804 19.8946 5.29287 19.7071C5.10533 19.5196 4.99997 19.2652 4.99997 19V10.25C5.00015 10.108 5.03057 9.9677 5.08919 9.83839C5.14781 9.70907 5.2333 9.59372 5.33997 9.50001L11.34 4.25001C11.5225 4.08969 11.7571 4.00127 12 4.00127C12.2429 4.00127 12.4775 4.08969 12.66 4.25001L18.66 9.50001C18.7666 9.59372 18.8521 9.70907 18.9108 9.83839C18.9694 9.9677 18.9998 10.108 19 10.25V19Z",
            fill: fillColor
        })
    });
};
var BookMarkIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16 2H8.00001C7.20436 2 6.4413 2.31607 5.87869 2.87868C5.31608 3.44129 5.00001 4.20435 5.00001 5V21C4.99931 21.1762 5.04518 21.3495 5.13299 21.5023C5.22079 21.655 5.3474 21.7819 5.50001 21.87C5.65203 21.9578 5.82447 22.004 6.00001 22.004C6.17554 22.004 6.34799 21.9578 6.50001 21.87L12 18.69L17.5 21.87C17.6524 21.9564 17.8248 22.0012 18 22C18.1752 22.0012 18.3476 21.9564 18.5 21.87C18.6526 21.7819 18.7792 21.655 18.867 21.5023C18.9548 21.3495 19.0007 21.1762 19 21V5C19 4.20435 18.6839 3.44129 18.1213 2.87868C17.5587 2.31607 16.7957 2 16 2ZM17 19.27L12.5 16.67C12.348 16.5822 12.1755 16.536 12 16.536C11.8245 16.536 11.652 16.5822 11.5 16.67L7.00001 19.27V5C7.00001 4.73478 7.10536 4.48043 7.2929 4.29289C7.48044 4.10536 7.73479 4 8.00001 4H16C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8947 4.48043 17 4.73478 17 5V19.27Z",
            fill: fillColor
        })
    });
};
var ButtonMultiLinkIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_19556_127249)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.1096 15.3898L8.22959 19.2698C8.00011 19.5002 7.72738 19.683 7.42707 19.8078C7.12676 19.9325 6.80478 19.9967 6.47959 19.9967C6.15441 19.9967 5.83242 19.9325 5.53211 19.8078C5.2318 19.683 4.95908 19.5002 4.72959 19.2698C4.49799 19.041 4.31411 18.7685 4.18862 18.4681C4.06312 18.1677 3.99849 17.8454 3.99849 17.5198C3.99849 17.1943 4.06312 16.8719 4.18862 16.5715C4.31411 16.2711 4.49799 15.9986 4.72959 15.7698L8.60959 11.8898C8.7979 11.7015 8.90368 11.4461 8.90368 11.1798C8.90368 10.9135 8.7979 10.6581 8.60959 10.4698C8.42129 10.2815 8.16589 10.1757 7.89959 10.1757C7.63329 10.1757 7.3779 10.2815 7.18959 10.4698L3.30959 14.3598C2.52795 15.2106 2.10521 16.3305 2.12967 17.4856C2.15412 18.6407 2.62387 19.7417 3.44082 20.5586C4.25778 21.3756 5.35876 21.8453 6.51384 21.8698C7.66892 21.8942 8.7888 21.4715 9.63959 20.6898L13.5296 16.8098C13.7179 16.6215 13.8237 16.3661 13.8237 16.0998C13.8237 15.8335 13.7179 15.5781 13.5296 15.3898C13.3413 15.2015 13.0859 15.0957 12.8196 15.0957C12.5533 15.0957 12.2979 15.2015 12.1096 15.3898ZM8.82959 15.1698C8.92303 15.2625 9.03385 15.3358 9.15569 15.3856C9.27752 15.4354 9.40799 15.4606 9.53959 15.4598C9.6712 15.4606 9.80166 15.4354 9.9235 15.3856C10.0453 15.3358 10.1562 15.2625 10.2496 15.1698L15.1696 10.2498C15.3579 10.0615 15.4637 9.80614 15.4637 9.53984C15.4637 9.27353 15.3579 9.01814 15.1696 8.82984C14.9813 8.64153 14.7259 8.53575 14.4596 8.53575C14.1933 8.53575 13.9379 8.64153 13.7496 8.82984L8.82959 13.7498C8.73586 13.8428 8.66147 13.9534 8.6107 14.0753C8.55993 14.1971 8.53379 14.3278 8.53379 14.4598C8.53379 14.5918 8.55993 14.7226 8.6107 14.8444C8.66147 14.9663 8.73586 15.0769 8.82959 15.1698ZM20.9996 17.9998H19.9996V16.9998C19.9996 16.7346 19.8942 16.4803 19.7067 16.2927C19.5192 16.1052 19.2648 15.9998 18.9996 15.9998C18.7344 15.9998 18.48 16.1052 18.2925 16.2927C18.1049 16.4803 17.9996 16.7346 17.9996 16.9998V17.9998H16.9996C16.7344 17.9998 16.48 18.1052 16.2925 18.2927C16.1049 18.4803 15.9996 18.7346 15.9996 18.9998C15.9996 19.2651 16.1049 19.5194 16.2925 19.7069C16.48 19.8945 16.7344 19.9998 16.9996 19.9998H17.9996V20.9998C17.9996 21.2651 18.1049 21.5194 18.2925 21.7069C18.48 21.8945 18.7344 21.9998 18.9996 21.9998C19.2648 21.9998 19.5192 21.8945 19.7067 21.7069C19.8942 21.5194 19.9996 21.2651 19.9996 20.9998V19.9998H20.9996C21.2648 19.9998 21.5192 19.8945 21.7067 19.7069C21.8942 19.5194 21.9996 19.2651 21.9996 18.9998C21.9996 18.7346 21.8942 18.4803 21.7067 18.2927C21.5192 18.1052 21.2648 17.9998 20.9996 17.9998ZM16.8096 13.5298L20.6896 9.63984C21.4712 8.78904 21.894 7.66917 21.8695 6.51408C21.8451 5.359 21.3753 4.25802 20.5584 3.44107C19.7414 2.62412 18.6404 2.15436 17.4853 2.12991C16.3303 2.10546 15.2104 2.52819 14.3596 3.30984L10.4696 7.18984C10.3764 7.28307 10.3024 7.39377 10.2519 7.51559C10.2015 7.63741 10.1755 7.76798 10.1755 7.89984C10.1755 8.0317 10.2015 8.16226 10.2519 8.28409C10.3024 8.40591 10.3764 8.5166 10.4696 8.60984C10.5628 8.70307 10.6735 8.77704 10.7953 8.8275C10.9172 8.87796 11.0477 8.90393 11.1796 8.90393C11.3115 8.90393 11.442 8.87796 11.5638 8.8275C11.6857 8.77704 11.7964 8.70307 11.8896 8.60984L15.7696 4.72984C15.9991 4.49944 16.2718 4.31663 16.5721 4.19189C16.8724 4.06715 17.1944 4.00294 17.5196 4.00294C17.8448 4.00294 18.1668 4.06715 18.4671 4.19189C18.7674 4.31663 19.0401 4.49944 19.2696 4.72984C19.5012 4.95864 19.6851 5.23115 19.8106 5.53155C19.9361 5.83195 20.0007 6.15427 20.0007 6.47984C20.0007 6.8054 19.9361 7.12772 19.8106 7.42812C19.6851 7.72853 19.5012 8.00103 19.2696 8.22984L15.3896 12.1098C15.2959 12.2028 15.2215 12.3134 15.1707 12.4353C15.1199 12.5571 15.0938 12.6878 15.0938 12.8198C15.0938 12.9518 15.1199 13.0826 15.1707 13.2044C15.2215 13.3263 15.2959 13.4369 15.3896 13.5298C15.4826 13.6236 15.5932 13.698 15.715 13.7487C15.8369 13.7995 15.9676 13.8256 16.0996 13.8256C16.2316 13.8256 16.3623 13.7995 16.4842 13.7487C16.606 13.698 16.7166 13.6236 16.8096 13.5298Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_19556_127249",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var SwatchBookIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 16C6.80222 16 6.60888 16.0586 6.44443 16.1685C6.27998 16.2784 6.15181 16.4346 6.07612 16.6173C6.00043 16.8 5.98063 17.0011 6.01921 17.1951C6.0578 17.3891 6.15304 17.5673 6.29289 17.7071C6.43275 17.847 6.61093 17.9422 6.80491 17.9808C6.99889 18.0194 7.19996 17.9996 7.38268 17.9239C7.56541 17.8482 7.72159 17.72 7.83147 17.5556C7.94135 17.3911 8 17.1978 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16ZM19.06 12L20.29 10.77C20.8518 10.2075 21.1674 9.445 21.1674 8.65C21.1674 7.855 20.8518 7.0925 20.29 6.53L17.46 3.71C16.8975 3.1482 16.135 2.83264 15.34 2.83264C14.545 2.83264 13.7825 3.1482 13.22 3.71L12 4.94C11.9843 4.15479 11.6613 3.40706 11.1004 2.85736C10.5395 2.30766 9.78536 1.99984 9 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V15C22.0002 14.2146 21.6923 13.4605 21.1426 12.8996C20.5929 12.3387 19.8452 12.0157 19.06 12ZM10 19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289C9.89464 4.48043 10 4.73478 10 5V19ZM12 7.76L14.64 5.12C14.8274 4.93375 15.0808 4.82921 15.345 4.82921C15.6092 4.82921 15.8626 4.93375 16.05 5.12L18.88 8C19.0662 8.18736 19.1708 8.44081 19.1708 8.705C19.1708 8.96919 19.0662 9.22264 18.88 9.41L16 12.29L12 16.24V7.76ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H11.82C11.9226 19.7036 11.9799 19.3935 11.99 19.08L17.07 14H19C19.2652 14 19.5196 14.1054 19.7071 14.2929C19.8946 14.4804 20 14.7348 20 15V19Z",
            fill: fillColor
        })
    });
};
var XIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_22682_134016)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.99967 1.33203C4.32634 1.33203 1.33301 4.32536 1.33301 7.9987C1.33301 11.672 4.32634 14.6654 7.99967 14.6654C11.673 14.6654 14.6663 11.672 14.6663 7.9987C14.6663 4.32536 11.673 1.33203 7.99967 1.33203ZM10.2397 9.53203C10.433 9.72536 10.433 10.0454 10.2397 10.2387C10.1397 10.3387 10.013 10.3854 9.88634 10.3854C9.75968 10.3854 9.63301 10.3387 9.53301 10.2387L7.99967 8.70537L6.46634 10.2387C6.36634 10.3387 6.23967 10.3854 6.11301 10.3854C5.98634 10.3854 5.85967 10.3387 5.75968 10.2387C5.56634 10.0454 5.56634 9.72536 5.75968 9.53203L7.29301 7.9987L5.75968 6.46536C5.56634 6.27203 5.56634 5.95203 5.75968 5.7587C5.95301 5.56536 6.27301 5.56536 6.46634 5.7587L7.99967 7.29203L9.53301 5.7587C9.72634 5.56536 10.0463 5.56536 10.2397 5.7587C10.433 5.95203 10.433 6.27203 10.2397 6.46536L8.70634 7.9987L10.2397 9.53203Z",
                        fill: "#FF3141"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_22682_134016",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var TickIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.99967 1.83203C4.33301 1.83203 1.33301 4.83203 1.33301 8.4987C1.33301 12.1654 4.33301 15.1654 7.99967 15.1654C11.6663 15.1654 14.6663 12.1654 14.6663 8.4987C14.6663 4.83203 11.6663 1.83203 7.99967 1.83203ZM10.7997 7.36537L7.59967 10.5654C7.33301 10.832 6.93301 10.832 6.66634 10.5654L5.19967 9.0987C4.93301 8.83203 4.93301 8.43203 5.19967 8.16536C5.46634 7.8987 5.86634 7.8987 6.13301 8.16536L7.13301 9.16536L9.86634 6.43203C10.133 6.16536 10.533 6.16536 10.7997 6.43203C11.0663 6.6987 11.0663 7.0987 10.7997 7.36537Z",
            fill: "#00B578"
        })
    });
};
var BackAngelIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.50001 12.8L14.2 18.4C14.6 18.8 15.2 18.8 15.6 18.4C16 18 16 17.4 15.6 17L10.7 12L15.6 6.99999C16 6.59999 16 5.99999 15.6 5.59999C15.4 5.39999 15.2 5.29999 14.9 5.29999C14.6 5.29999 14.4 5.39999 14.2 5.59999L8.50001 11.2C8.10001 11.7 8.10001 12.3 8.50001 12.8C8.50001 12.7 8.50001 12.7 8.50001 12.8Z",
            fill: fillColor
        })
    });
};
var CoppyIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3V8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11C14.4402 2.10576 14.4099 2.10576 14.38 2.11C14.2784 2.05174 14.1662 2.01434 14.05 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V6H6C5.20435 6 4.44129 6.31607 3.87868 6.87868C3.31607 7.44129 3 8.20435 3 9V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H14C14.7956 22 15.5587 21.6839 16.1213 21.1213C16.6839 20.5587 17 19.7956 17 19V18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM15 19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V9C5 8.73478 5.10536 8.48043 5.29289 8.29289C5.48043 8.10536 5.73478 8 6 8H7V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H15V19ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z",
            fill: fillColor
        })
    });
};
var BackgroundIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "25",
        height: "28",
        viewBox: "0 0 25 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_25106_296149)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        transform: "translate(0.625 3.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M19.6245 5.49918H5.62451C4.82886 5.49918 4.0658 5.81525 3.50319 6.37786C2.94058 6.94046 2.62451 7.70353 2.62451 8.49918V22.4992C2.62451 23.2948 2.94058 24.0579 3.50319 24.6205C4.0658 25.1831 4.82886 25.4992 5.62451 25.4992H19.6245C19.789 25.4969 19.953 25.4802 20.1145 25.4492L20.4145 25.3792H20.4845H20.5345L20.9045 25.2392L21.0345 25.1692C21.1345 25.1092 21.2445 25.0592 21.3445 24.9892C21.478 24.8909 21.605 24.784 21.7245 24.6692L21.7945 24.5792C21.8927 24.4797 21.983 24.3727 22.0645 24.2592L22.1545 24.1292C22.2244 24.0178 22.2846 23.9008 22.3345 23.7792C22.3619 23.7312 22.3854 23.681 22.4045 23.6292C22.4545 23.5092 22.4845 23.3792 22.5245 23.2492V23.0992C22.5812 22.9038 22.6148 22.7024 22.6245 22.4992V8.49918C22.6245 7.70353 22.3084 6.94046 21.7458 6.37786C21.1832 5.81525 20.4202 5.49918 19.6245 5.49918ZM5.62451 23.4992C5.3593 23.4992 5.10494 23.3938 4.91741 23.2063C4.72987 23.0187 4.62451 22.7644 4.62451 22.4992V18.1892L7.91451 14.8892C8.00747 14.7954 8.11808 14.7211 8.23993 14.6703C8.36179 14.6195 8.4925 14.5934 8.62451 14.5934C8.75652 14.5934 8.88723 14.6195 9.00909 14.6703C9.13095 14.7211 9.24155 14.7954 9.33451 14.8892L17.9345 23.4992H5.62451ZM20.6245 22.4992C20.6236 22.6225 20.5998 22.7445 20.5545 22.8592C20.5317 22.9079 20.5049 22.9547 20.4745 22.9992C20.4478 23.0415 20.4177 23.0816 20.3845 23.1192L15.0345 17.7692L15.9145 16.8892C16.0075 16.7954 16.1181 16.7211 16.2399 16.6703C16.3618 16.6195 16.4925 16.5934 16.6245 16.5934C16.7565 16.5934 16.8872 16.6195 17.0091 16.6703C17.1309 16.7211 17.2415 16.7954 17.3345 16.8892L20.6245 20.1892V22.4992ZM20.6245 17.3592L18.7445 15.4992C18.1722 14.9562 17.4134 14.6535 16.6245 14.6535C15.8356 14.6535 15.0768 14.9562 14.5045 15.4992L13.6245 16.3792L10.7445 13.4992C10.1722 12.9562 9.41341 12.6535 8.62451 12.6535C7.83561 12.6535 7.07679 12.9562 6.50451 13.4992L4.62451 15.3592V8.49918C4.62451 8.23396 4.72987 7.97961 4.91741 7.79207C5.10494 7.60453 5.3593 7.49918 5.62451 7.49918H19.6245C19.8897 7.49918 20.1441 7.60453 20.3316 7.79207C20.5192 7.97961 20.6245 8.23396 20.6245 8.49918V17.3592Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_25106_296149",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(0.625 3.5)"
                    })
                })
            })
        ]
    });
};
var EditIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "28",
                height: "28",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.33301 17.9991H12.1597C12.2474 17.9997 12.3344 17.9828 12.4156 17.9497C12.4968 17.9165 12.5707 17.8676 12.633 17.8058L17.2463 13.1858L19.1397 11.3325C19.2022 11.2705 19.2518 11.1968 19.2856 11.1155C19.3194 11.0343 19.3369 10.9472 19.3369 10.8591C19.3369 10.7711 19.3194 10.684 19.2856 10.6028C19.2518 10.5215 19.2022 10.4478 19.1397 10.3858L16.313 7.52581C16.251 7.46333 16.1773 7.41373 16.0961 7.37988C16.0148 7.34604 15.9277 7.32861 15.8397 7.32861C15.7517 7.32861 15.6645 7.34604 15.5833 7.37988C15.5021 7.41373 15.4283 7.46333 15.3663 7.52581L13.4863 9.41248L8.85967 14.0325C8.79789 14.0948 8.749 14.1687 8.71583 14.2499C8.68265 14.3311 8.66583 14.4181 8.66634 14.5058V17.3325C8.66634 17.5093 8.73658 17.6789 8.8616 17.8039C8.98663 17.9289 9.1562 17.9991 9.33301 17.9991ZM15.8397 8.93915L17.7263 10.8258L16.7797 11.7725L14.893 9.88581L15.8397 8.93915ZM9.99967 14.7791L13.953 10.8258L15.8397 12.7125L11.8863 16.6658H9.99967V14.7791ZM19.9997 19.3325H7.99967C7.82286 19.3325 7.65329 19.4027 7.52827 19.5277C7.40325 19.6528 7.33301 19.8223 7.33301 19.9991C7.33301 20.176 7.40325 20.3455 7.52827 20.4706C7.65329 20.5956 7.82286 20.6658 7.99967 20.6658H19.9997C20.1765 20.6658 20.3461 20.5956 20.4711 20.4706C20.5961 20.3455 20.6663 20.176 20.6663 19.9991C20.6663 19.8223 20.5961 19.6528 20.4711 19.5277C20.3461 19.4027 20.1765 19.3325 19.9997 19.3325Z",
                fill: fillColor
            })
        ]
    });
};
var CopyIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 29 : _width, _height = param.height, height = _height === void 0 ? 29 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 29 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_25301_374457)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        transform: "translate(7 7)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.9995 19.499H11.9995C11.5022 19.499 11.0253 19.3015 10.6737 18.9499C10.3221 18.5982 10.1245 18.1213 10.1245 17.624V11.374C10.1245 11.2083 10.0587 11.0493 9.94145 10.9321C9.82424 10.8149 9.66527 10.749 9.49951 10.749C9.33375 10.749 9.17478 10.8149 9.05757 10.9321C8.94036 11.0493 8.87451 11.2083 8.87451 11.374V17.624C8.87451 18.4528 9.20375 19.2477 9.7898 19.8337C10.3759 20.4198 11.1707 20.749 11.9995 20.749H16.9995C17.1653 20.749 17.3242 20.6832 17.4415 20.566C17.5587 20.4488 17.6245 20.2898 17.6245 20.124C17.6245 19.9583 17.5587 19.7993 17.4415 19.6821C17.3242 19.5649 17.1653 19.499 16.9995 19.499ZM20.1245 12.5865C20.118 12.5291 20.1054 12.4725 20.087 12.4178V12.3615C20.057 12.2973 20.0169 12.2382 19.9683 12.1865L16.2183 8.43652C16.1666 8.38791 16.1075 8.34782 16.0433 8.31777H15.987L15.787 8.24902H13.2495C12.7522 8.24902 12.2753 8.44657 11.9237 8.7982C11.5721 9.14983 11.3745 9.62674 11.3745 10.124V16.374C11.3745 16.8713 11.5721 17.3482 11.9237 17.6999C12.2753 18.0515 12.7522 18.249 13.2495 18.249H18.2495C18.7468 18.249 19.2237 18.0515 19.5753 17.6999C19.927 17.3482 20.1245 16.8713 20.1245 16.374V12.624C20.1245 12.624 20.1245 12.624 20.1245 12.5865ZM16.3745 10.3803L17.9933 11.999H16.9995C16.8338 11.999 16.6748 11.9332 16.5576 11.816C16.4404 11.6988 16.3745 11.5398 16.3745 11.374V10.3803ZM18.8745 16.374C18.8745 16.5398 18.8087 16.6988 18.6915 16.816C18.5742 16.9332 18.4153 16.999 18.2495 16.999H13.2495C13.0838 16.999 12.9248 16.9332 12.8076 16.816C12.6904 16.6988 12.6245 16.5398 12.6245 16.374V10.124C12.6245 9.95826 12.6904 9.79929 12.8076 9.68208C12.9248 9.56487 13.0838 9.49902 13.2495 9.49902H15.1245V11.374C15.1245 11.8713 15.3221 12.3482 15.6737 12.6998C16.0253 13.0515 16.5022 13.249 16.9995 13.249H18.8745V16.374Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                stroke: "#EEEEEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_25301_374457",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white",
                        transform: "translate(7 7)"
                    })
                })
            })
        ]
    });
};
var OpenNewTab = function(param) {
    var _width = param.width, width = _width === void 0 ? 29 : _width, _height = param.height, height = _height === void 0 ? 29 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 29 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_25301_374470)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        transform: "translate(7 7)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        clipPath: "url(#clip1_25301_374470)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M14.4995 21.2178C10.7933 21.2178 7.78076 18.2053 7.78076 14.499C7.78076 10.7928 10.7933 7.78027 14.4995 7.78027C18.2058 7.78027 21.2183 10.7928 21.2183 14.499C21.2183 18.2053 18.2058 21.2178 14.4995 21.2178ZM14.4995 8.71777C14.0147 8.71777 13.5437 8.77777 13.0934 8.89072C13.0917 8.93549 13.0835 8.98034 13.0683 9.02402C12.814 9.78825 12.6147 10.5692 12.4705 11.3596C13.8185 11.2103 15.1819 11.2104 16.5292 11.3599C16.3849 10.5675 16.1855 9.78431 15.9308 9.01758C15.9169 8.97581 15.9092 8.9333 15.9072 8.89113C15.4565 8.77791 14.9849 8.71777 14.4995 8.71777ZM16.6768 12.3225C15.2327 12.1418 13.7668 12.1415 12.3226 12.3217C12.1419 13.7654 12.1418 15.2309 12.3223 16.6756C13.7663 16.8564 15.2322 16.8567 16.6764 16.6764C16.8571 15.2327 16.8573 13.7672 16.6768 12.3225ZM11.4969 11.4939C11.6165 10.7685 11.7799 10.0498 11.987 9.34277C11.9588 9.34209 11.9313 9.33897 11.9046 9.33363C10.7642 9.9089 9.8391 10.8509 9.28516 12.0035C10.0116 11.7872 10.7507 11.6174 11.4969 11.4939ZM8.89158 13.0915C8.93355 13.0894 8.97609 13.0817 9.01828 13.068C9.78515 12.8128 10.5691 12.6131 11.3627 12.4687C11.2139 13.8167 11.2138 15.1802 11.3626 16.5283C10.5712 16.384 9.78934 16.1846 9.02451 15.9301C8.98081 15.9149 8.93596 15.9067 8.89118 15.905C8.77824 15.4548 8.71826 14.9838 8.71826 14.499C8.71826 14.0137 8.77839 13.5422 8.89158 13.0915ZM17.64 12.4705C18.4302 12.6147 19.2108 12.8139 19.9745 13.068C20.0189 13.0846 20.0634 13.0914 20.1078 13.0927C20.2208 13.5431 20.2808 14.0142 20.2808 14.499C20.2808 14.9839 20.2208 15.455 20.1078 15.9053C20.0651 15.9075 20.0224 15.9157 19.9808 15.9301C19.2145 16.1851 18.4311 16.3848 17.6381 16.5291C17.7881 15.1819 17.7887 13.8186 17.64 12.4705ZM19.7148 12.0054C18.9894 11.7888 18.2512 11.6187 17.5057 11.495C17.3826 10.7497 17.2132 10.0115 16.9975 9.28589C18.183 9.85629 19.1453 10.8194 19.7148 12.0054ZM9.34326 17.0114C9.34256 17.0394 9.33936 17.0668 9.33386 17.0934C9.89248 18.2011 10.797 19.1057 11.9046 19.6644C11.9312 19.6591 11.9588 19.656 11.987 19.6553C11.7799 18.9482 11.6165 18.2295 11.4968 17.504C10.7706 17.3842 10.0514 17.2201 9.34326 17.0114ZM14.4995 17.7489C13.8209 17.7489 13.1432 17.712 12.4698 17.6378C12.6141 18.4303 12.8136 19.2135 13.0683 19.9803C13.0827 20.0219 13.0909 20.0646 13.0931 20.1073C13.5435 20.2203 14.0146 20.2803 14.4995 20.2803C14.984 20.2803 15.4547 20.2204 15.9047 20.1076C15.9065 20.063 15.9149 20.018 15.9308 19.9738C16.1851 19.2095 16.3844 18.4284 16.5286 17.6379C15.8552 17.712 15.1778 17.7489 14.4995 17.7489ZM16.9912 19.7152C17.2083 18.9892 17.3789 18.2504 17.5029 17.5041C18.2302 17.3843 18.9511 17.2202 19.662 17.0114C19.6626 17.0365 19.6652 17.061 19.6695 17.0849C19.094 18.2307 18.1486 19.16 16.9912 19.7152Z",
                            fill: "#333333"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                stroke: "#EEEEEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_25301_374470",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "15",
                            height: "15",
                            fill: "white",
                            transform: "translate(7 7)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_25301_374470",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "15",
                            height: "15",
                            fill: "white",
                            transform: "translate(7 7)"
                        })
                    })
                ]
            })
        ]
    });
};
var ShareIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 29 : _width, _height = param.height, height = _height === void 0 ? 29 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 29 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_25301_374489)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        transform: "translate(7 7)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.5664 14.0571L15.5664 9.05709C15.479 8.96969 15.3676 8.91016 15.2464 8.88604C15.1252 8.86192 14.9995 8.87429 14.8853 8.92159C14.7711 8.96889 14.6735 9.04899 14.6048 9.15176C14.5362 9.25453 14.4995 9.37536 14.4995 9.49897V11.7145C12.7922 11.8726 11.2053 12.662 10.0493 13.9284C8.89339 15.1947 8.25158 16.8469 8.24951 18.5615V19.499C8.2495 19.6288 8.2899 19.7553 8.36511 19.8611C8.44031 19.9669 8.54659 20.0467 8.66918 20.0893C8.79177 20.132 8.9246 20.1354 9.04922 20.0991C9.17385 20.0628 9.28408 19.9886 9.36462 19.8869C9.9769 19.1587 10.7282 18.5598 11.5745 18.1253C12.4208 17.6908 13.3453 17.4292 14.2938 17.356C14.3249 17.3521 14.4031 17.346 14.4995 17.3399V19.499C14.4995 19.6226 14.5362 19.7434 14.6048 19.8462C14.6735 19.949 14.7711 20.0291 14.8853 20.0764C14.9995 20.1237 15.1252 20.136 15.2464 20.1119C15.3676 20.0878 15.479 20.0283 15.5664 19.9408L20.5664 14.9408C20.6244 14.8828 20.6705 14.8139 20.7019 14.7381C20.7333 14.6623 20.7495 14.581 20.7495 14.499C20.7495 14.4169 20.7333 14.3356 20.7019 14.2598C20.6705 14.184 20.6244 14.1151 20.5664 14.0571ZM15.7495 17.9902V16.6865C15.7495 16.6044 15.7334 16.5231 15.702 16.4473C15.6706 16.3714 15.6245 16.3025 15.5665 16.2445C15.5085 16.1864 15.4396 16.1404 15.3637 16.109C15.2879 16.0776 15.2066 16.0614 15.1245 16.0615C14.9652 16.0615 14.3146 16.0923 14.1486 16.1146C12.4639 16.2698 10.8604 16.9098 9.53186 17.9572C9.68257 16.5787 10.3365 15.3042 11.3684 14.3778C12.4004 13.4514 13.7378 12.9382 15.1245 12.9365C15.2066 12.9365 15.2879 12.9203 15.3637 12.8889C15.4396 12.8575 15.5085 12.8115 15.5665 12.7535C15.6245 12.6954 15.6706 12.6265 15.702 12.5507C15.7334 12.4748 15.7495 12.3936 15.7495 12.3115V11.0078L19.2407 14.499L15.7495 17.9902Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "28",
                height: "28",
                rx: "3.5",
                stroke: "#EEEEEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_25301_374489",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white",
                        transform: "translate(7 7)"
                    })
                })
            })
        ]
    });
};
var ShareIconV3 = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.707 11.293L13.707 3.29304C13.5672 3.15318 13.389 3.05794 13.195 3.01935C13.0011 2.98075 12.8 3.00055 12.6173 3.07622C12.4346 3.1519 12.2784 3.28006 12.1685 3.4445C12.0586 3.60894 12 3.80227 12 4.00004V7.54496C9.2683 7.7978 6.72926 9.0609 4.87973 11.0871C3.0302 13.1132 2.00331 15.7567 2 18.5V20C1.99998 20.2077 2.06463 20.4102 2.18495 20.5795C2.30528 20.7488 2.47532 20.8764 2.67147 20.9446C2.86762 21.0128 3.08014 21.0183 3.27954 20.9602C3.47893 20.9022 3.65531 20.7835 3.78418 20.6206C4.76383 19.4556 5.96583 18.4974 7.31997 17.8022C8.6741 17.1069 10.1532 16.6885 11.6709 16.5713C11.7207 16.565 11.8457 16.5552 12 16.5454V20C12 20.1978 12.0586 20.3911 12.1685 20.5556C12.2784 20.72 12.4346 20.8482 12.6173 20.9238C12.8 20.9995 13.0011 21.0193 13.195 20.9807C13.389 20.9421 13.5672 20.8469 13.707 20.707L21.707 12.707C21.7999 12.6142 21.8735 12.504 21.9238 12.3827C21.9741 12.2614 21.9999 12.1313 21.9999 12C21.9999 11.8687 21.9741 11.7387 21.9238 11.6174C21.8735 11.4961 21.7999 11.3859 21.707 11.293ZM14 17.586V15.5C14 15.3687 13.9742 15.2387 13.9239 15.1173C13.8737 14.996 13.8 14.8857 13.7072 14.7929C13.6143 14.7 13.5041 14.6263 13.3827 14.5761C13.2614 14.5258 13.1313 14.5 13 14.5C12.7451 14.5 11.7041 14.5494 11.4385 14.585C8.74307 14.8333 6.17736 15.8573 4.05176 17.5332C4.29289 15.3276 5.33918 13.2884 6.99026 11.8061C8.64135 10.3239 10.7812 9.50275 13 9.50004C13.1313 9.50007 13.2614 9.47423 13.3827 9.42399C13.5041 9.37374 13.6143 9.30008 13.7072 9.20722C13.8 9.11435 13.8737 9.0041 13.9239 8.88276C13.9742 8.76142 14 8.63137 14 8.50004V6.4141L19.5859 12L14 17.586Z",
            fill: fillColor
        })
    });
};
var ClosePopupIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.30425 4.05879L12.0884 10.9098L18.8721 4.05879C18.9097 4.02085 18.9609 3.99951 19.0143 3.99951H20.552C20.6625 3.99951 20.752 4.08905 20.752 4.19951C20.752 4.25221 20.7312 4.30279 20.6941 4.34024L13.1387 11.9704L20.7511 19.6588C20.8288 19.7373 20.8282 19.8639 20.7497 19.9416C20.7122 19.9787 20.6617 19.9995 20.609 19.9995H19.0717C19.0183 19.9995 18.9671 19.9782 18.9296 19.9402L12.0884 13.0311L5.24682 19.9402C5.20926 19.9782 5.15809 19.9995 5.10471 19.9995H3.56792C3.45746 19.9995 3.36792 19.91 3.36792 19.7995C3.36792 19.7468 3.38872 19.6962 3.4258 19.6588L11.0382 11.9704L3.48277 4.34023C3.40505 4.26175 3.40567 4.13511 3.48416 4.0574C3.52161 4.02031 3.57218 3.99951 3.62488 3.99951H5.16214C5.21552 3.99951 5.26669 4.02085 5.30425 4.05879Z",
            fill: fillColor
        })
    });
};
var ClosePopupIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.41 12L17.71 7.71C17.8983 7.5217 18.0041 7.2663 18.0041 7C18.0041 6.7337 17.8983 6.47831 17.71 6.29C17.5217 6.1017 17.2663 5.99591 17 5.99591C16.7337 5.99591 16.4783 6.1017 16.29 6.29L12 10.59L7.71 6.29C7.5217 6.1017 7.2663 5.99591 7 5.99591C6.7337 5.99591 6.4783 6.1017 6.29 6.29C6.1017 6.47831 5.99591 6.7337 5.99591 7C5.99591 7.2663 6.1017 7.5217 6.29 7.71L10.59 12L6.29 16.29C6.19627 16.383 6.12188 16.4936 6.07111 16.6154C6.02034 16.7373 5.9942 16.868 5.9942 17C5.9942 17.132 6.02034 17.2627 6.07111 17.3846C6.12188 17.5064 6.19627 17.617 6.29 17.71C6.38296 17.8037 6.49356 17.8781 6.61542 17.9289C6.73728 17.9797 6.86799 18.0058 7 18.0058C7.13201 18.0058 7.26272 17.9797 7.38458 17.9289C7.50644 17.8781 7.61704 17.8037 7.71 17.71L12 13.41L16.29 17.71C16.383 17.8037 16.4936 17.8781 16.6154 17.9289C16.7373 17.9797 16.868 18.0058 17 18.0058C17.132 18.0058 17.2627 17.9797 17.3846 17.9289C17.5064 17.8781 17.617 17.8037 17.71 17.71C17.8037 17.617 17.8781 17.5064 17.9289 17.3846C17.9797 17.2627 18.0058 17.132 18.0058 17C18.0058 16.868 17.9797 16.7373 17.9289 16.6154C17.8781 16.4936 17.8037 16.383 17.71 16.29L13.41 12Z",
            fill: fillColor
        })
    });
};
var BroomIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.3507 1.64503C21.4907 0.785012 20.0913 0.784969 19.2312 1.64503L14.2495 6.62676L17.3689 9.74619L22.3507 4.76446C23.2107 3.90444 23.2107 2.50504 22.3507 1.64503Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.5761 10.8087L13.1952 7.42785C12.0963 6.32889 10.3438 6.22155 9.11897 7.17821L8.96338 7.29972L16.7042 15.0406L16.8257 14.885C17.7824 13.6601 17.675 11.9077 16.5761 10.8087Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.92142 8.11377L1.25652 13.3192C1.10841 13.4349 1.01701 13.6085 1.0055 13.7961C0.994025 13.9838 1.06355 14.1673 1.19645 14.3002L3.33942 16.4432L6.90199 13.2101C7.17037 12.9666 7.58609 12.9878 7.82874 13.2551C8.07224 13.5235 8.05213 13.9384 7.78379 14.1819L4.26832 17.3722L6.6321 19.736L9.82239 16.2205C10.0659 15.9521 10.4808 15.932 10.7491 16.1755C11.0176 16.4201 11.0376 16.834 10.7941 17.1023L7.56104 20.6648L9.70401 22.8078C9.83691 22.9407 10.0204 23.0102 10.2081 22.9988C10.3957 22.9873 10.5693 22.8959 10.685 22.7477L15.8905 16.0828L7.92142 8.11377Z",
                fill: fillColor
            })
        ]
    });
};
var BroomLockIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.2312 1.42872C20.0913 0.568661 21.4907 0.568704 22.3507 1.42872C23.2107 2.28874 23.2107 3.68814 22.3507 4.54815L17.3689 9.52989L14.2495 6.41045L19.2312 1.42872ZM13.1952 7.21179L16.5761 10.5926C17.6638 11.6804 17.7801 13.4084 16.8546 14.6313L9.19928 6.97589C9.18496 6.96157 9.17045 6.94755 9.15576 6.93383C10.3787 6.00773 12.1072 6.12378 13.1952 7.21179ZM6.43683 9.05695L1.25652 13.1029C1.10841 13.2186 1.01701 13.3922 1.0055 13.5798C0.994025 13.7675 1.06355 13.9509 1.19645 14.0839L3.33942 16.2269L6.90199 12.9938C7.17037 12.7503 7.58609 12.7715 7.82874 13.0388C8.07224 13.3072 8.05213 13.7221 7.78379 13.9656L4.26832 17.1558L6.6321 19.5196L9.82239 16.0042C10.0659 15.7358 10.4808 15.7157 10.7491 15.9592C11.0176 16.2038 11.0376 16.6177 10.7941 16.886L7.56104 20.4485L9.70401 22.5915C9.83691 22.7244 10.0204 22.7939 10.2081 22.7825C10.3957 22.7709 10.5693 22.6795 10.685 22.5314L14.6892 17.4045L6.72992 9.44525C6.61174 9.32707 6.51404 9.19617 6.43683 9.05695Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "3.12164",
                y: "3.0376",
                width: "25.2861",
                height: "2",
                rx: "1",
                transform: "rotate(45 3.12164 3.0376)",
                fill: fillColor
            })
        ]
    });
};
var QuestionIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 15 : _width, _height = param.height, height = _height === void 0 ? 15 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.29 13.29C9.247 13.3375 9.20693 13.3876 9.17 13.44C9.13216 13.4957 9.10189 13.5563 9.08 13.62C9.05117 13.6767 9.03095 13.7374 9.02001 13.8C9.0151 13.8666 9.0151 13.9334 9.02001 14C9.01663 14.1312 9.04402 14.2613 9.10001 14.38C9.14492 14.5041 9.21657 14.6168 9.30989 14.7101C9.40321 14.8034 9.51591 14.8751 9.64001 14.92C9.75971 14.9729 9.88913 15.0002 10.02 15.0002C10.1509 15.0002 10.2803 14.9729 10.4 14.92C10.5241 14.8751 10.6368 14.8034 10.7301 14.7101C10.8234 14.6168 10.8951 14.5041 10.94 14.38C10.9844 14.2584 11.0048 14.1294 11 14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29C10.617 13.1963 10.5064 13.1219 10.3846 13.0711C10.2627 13.0203 10.132 12.9942 10 12.9942C9.86799 12.9942 9.73729 13.0203 9.61543 13.0711C9.49357 13.1219 9.38297 13.1963 9.29 13.29ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0V0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18V18ZM10 5C9.47307 4.99966 8.95534 5.13812 8.49891 5.40144C8.04249 5.66476 7.66347 6.04366 7.4 6.5C7.32765 6.61382 7.27907 6.7411 7.25718 6.87418C7.23529 7.00726 7.24055 7.14339 7.27263 7.27439C7.30472 7.40538 7.36297 7.52854 7.44389 7.63643C7.5248 7.74433 7.62671 7.83475 7.74348 7.90224C7.86024 7.96974 7.98945 8.01292 8.12334 8.02918C8.25722 8.04544 8.39301 8.03445 8.52254 7.99688C8.65207 7.9593 8.77266 7.89591 8.87705 7.81052C8.98145 7.72513 9.06749 7.61951 9.13 7.5C9.21811 7.3474 9.34497 7.22078 9.49775 7.13298C9.65053 7.04518 9.82379 6.9993 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73479 9 9.48043 9.10536 9.2929 9.29289C9.10536 9.48043 9 9.73478 9 10V11C9 11.2652 9.10536 11.5196 9.2929 11.7071C9.48043 11.8946 9.73479 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V10.82C11.6614 10.58 12.2174 10.1152 12.5708 9.50687C12.9242 8.89851 13.0525 8.18529 12.9334 7.49189C12.8143 6.79849 12.4552 6.16902 11.919 5.71352C11.3828 5.25801 10.7035 5.00546 10 5V5Z",
            fill: fillColor
        })
    });
};
var CloseCircleIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FF3141" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z",
            fill: fillColor
        })
    });
};
var PubLishIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.3979 17.9045C17.1535 18.1281 17 18.4381 17 18.7694C17 19.6102 17.9036 20.1158 18.5394 19.5656C20.659 17.732 22 15.0226 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.0226 3.34102 17.732 5.46056 19.5656C6.09644 20.1158 7 19.6102 7 18.7694C7 18.4381 6.8465 18.1281 6.60206 17.9045C5.00294 16.4418 4 14.338 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.338 18.9971 16.4418 17.3979 17.9045Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.6 12.8L11 11V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V11L15.4 12.8C15.8418 13.1314 16.4686 13.0418 16.8 12.6C17.1314 12.1582 17.0418 11.5314 16.6 11.2L12.72 8.29C12.2933 7.97 11.7067 7.97 11.28 8.29L7.4 11.2C6.95817 11.5314 6.86863 12.1582 7.2 12.6C7.53137 13.0418 8.15817 13.1314 8.6 12.8Z",
                fill: fillColor
            })
        ]
    });
};
var CoppyAltIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11H14.38L14.06 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z",
            fill: fillColor
        })
    });
};
var IntroIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? "24px" : _width, _height = param.height, height = _height === void 0 ? "24px" : _height, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 8.49902H6C6.26522 8.49902 6.51957 8.39367 6.70711 8.20613C6.89464 8.01859 7 7.76424 7 7.49902C7 7.23381 6.89464 6.97945 6.70711 6.79192C6.51957 6.60438 6.26522 6.49902 6 6.49902H5C4.73478 6.49902 4.48043 6.60438 4.29289 6.79192C4.10536 6.97945 4 7.23381 4 7.49902C4 7.76424 4.10536 8.01859 4.29289 8.20613C4.48043 8.39367 4.73478 8.49902 5 8.49902ZM5 10.499C4.73478 10.499 4.48043 10.6044 4.29289 10.7919C4.10536 10.9795 4 11.2338 4 11.499C4 11.7642 4.10536 12.0186 4.29289 12.2061C4.48043 12.3937 4.73478 12.499 5 12.499H11C11.2652 12.499 11.5196 12.3937 11.7071 12.2061C11.8946 12.0186 12 11.7642 12 11.499C12 11.2338 11.8946 10.9795 11.7071 10.7919C11.5196 10.6044 11.2652 10.499 11 10.499H5ZM16 7.43902C15.9896 7.34716 15.9695 7.25665 15.94 7.16902V7.07902C15.8919 6.9762 15.8278 6.88169 15.75 6.79902L9.75 0.799023C9.66733 0.72124 9.57282 0.657104 9.47 0.609023C9.44015 0.604784 9.40985 0.604784 9.38 0.609023C9.27841 0.550765 9.16622 0.513368 9.05 0.499023H3C2.20435 0.499023 1.44129 0.815094 0.87868 1.3777C0.316071 1.94031 0 2.70337 0 3.49902V17.499C0 18.2947 0.316071 19.0577 0.87868 19.6203C1.44129 20.183 2.20435 20.499 3 20.499H13C13.7956 20.499 14.5587 20.183 15.1213 19.6203C15.6839 19.0577 16 18.2947 16 17.499V7.49902C16 7.49902 16 7.49902 16 7.43902ZM10 3.90902L12.59 6.49902H11C10.7348 6.49902 10.4804 6.39367 10.2929 6.20613C10.1054 6.01859 10 5.76424 10 5.49902V3.90902ZM14 17.499C14 17.7642 13.8946 18.0186 13.7071 18.2061C13.5196 18.3937 13.2652 18.499 13 18.499H3C2.73478 18.499 2.48043 18.3937 2.29289 18.2061C2.10536 18.0186 2 17.7642 2 17.499V3.49902C2 3.23381 2.10536 2.97945 2.29289 2.79192C2.48043 2.60438 2.73478 2.49902 3 2.49902H8V5.49902C8 6.29467 8.31607 7.05773 8.87868 7.62034C9.44129 8.18295 10.2043 8.49902 11 8.49902H14V17.499ZM11 14.499H5C4.73478 14.499 4.48043 14.6044 4.29289 14.7919C4.10536 14.9795 4 15.2338 4 15.499C4 15.7642 4.10536 16.0186 4.29289 16.2061C4.48043 16.3937 4.73478 16.499 5 16.499H11C11.2652 16.499 11.5196 16.3937 11.7071 16.2061C11.8946 16.0186 12 15.7642 12 15.499C12 15.2338 11.8946 14.9795 11.7071 14.7919C11.5196 14.6044 11.2652 14.499 11 14.499Z",
            fill: fillColor
        })
    });
};
var CloseIconAlert = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FF3141" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15.7 14.3C16.1 14.7 16.1 15.3 15.7 15.7C15.3 16.1 14.7 16.1 14.3 15.7L12 13.4L9.7 15.7C9.3 16.1 8.7 16.1 8.3 15.7C7.9 15.3 7.9 14.7 8.3 14.3L10.6 12L8.3 9.7C7.9 9.3 7.9 8.7 8.3 8.3C8.7 7.9 9.3 7.9 9.7 8.3L12 10.6L14.3 8.3C14.7 7.9 15.3 7.9 15.7 8.3C16.1 8.7 16.1 9.3 15.7 9.7L13.4 12L15.7 14.3Z",
            fill: fillColor
        })
    });
};
var EmptyImagePopupIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FF3141" : _fillColor, onClick = param.onClick;
    return /*#__PURE__*/ _jsx("svg", {
        width: "27",
        height: "28",
        viewBox: "0 0 27 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.83317 16.6621H9.49984C9.85346 16.6621 10.1926 16.5216 10.4426 16.2716C10.6927 16.0215 10.8332 15.6824 10.8332 15.3288C10.8332 14.9752 10.6927 14.636 10.4426 14.386C10.1926 14.1359 9.85346 13.9954 9.49984 13.9954H6.83317C6.47955 13.9954 6.14041 14.1359 5.89036 14.386C5.64031 14.636 5.49984 14.9752 5.49984 15.3288C5.49984 15.6824 5.64031 16.0215 5.89036 16.2716C6.14041 16.5216 6.47955 16.6621 6.83317 16.6621ZM14.8332 19.3288H6.83317C6.47955 19.3288 6.14041 19.4693 5.89036 19.7193C5.64031 19.9693 5.49984 20.3085 5.49984 20.6621C5.49984 21.0157 5.64031 21.3549 5.89036 21.6049C6.14041 21.855 6.47955 21.9954 6.83317 21.9954H14.8332C15.1868 21.9954 15.5259 21.855 15.776 21.6049C16.026 21.3549 16.1665 21.0157 16.1665 20.6621C16.1665 20.3085 16.026 19.9693 15.776 19.7193C15.5259 19.4693 15.1868 19.3288 14.8332 19.3288ZM22.8332 0.662109H4.1665C3.10564 0.662109 2.08822 1.08354 1.33808 1.83368C0.587931 2.58383 0.166504 3.60124 0.166504 4.66211V23.3288C0.166504 24.3896 0.587931 25.4071 1.33808 26.1572C2.08822 26.9074 3.10564 27.3288 4.1665 27.3288H22.8332C23.894 27.3288 24.9115 26.9074 25.6616 26.1572C26.4117 25.4071 26.8332 24.3896 26.8332 23.3288V4.66211C26.8332 3.60124 26.4117 2.58383 25.6616 1.83368C24.9115 1.08354 23.894 0.662109 22.8332 0.662109ZM16.1665 3.32878V7.71544L14.1532 6.59544C13.9505 6.47842 13.7206 6.41681 13.4865 6.41681C13.2525 6.41681 13.0225 6.47842 12.8198 6.59544L10.8332 7.71544V3.32878H16.1665ZM24.1665 23.3288C24.1665 23.6824 24.026 24.0215 23.776 24.2716C23.5259 24.5216 23.1868 24.6621 22.8332 24.6621H4.1665C3.81288 24.6621 3.47374 24.5216 3.2237 24.2716C2.97365 24.0215 2.83317 23.6824 2.83317 23.3288V4.66211C2.83317 4.30849 2.97365 3.96935 3.2237 3.7193C3.47374 3.46925 3.81288 3.32878 4.1665 3.32878H8.1665V9.99544C8.16791 10.2281 8.23018 10.4564 8.34714 10.6576C8.46409 10.8587 8.63165 11.0258 8.83317 11.1421C9.03586 11.2591 9.26579 11.3207 9.49984 11.3207C9.73389 11.3207 9.96381 11.2591 10.1665 11.1421L13.4998 9.28878L16.8465 11.1554C17.0458 11.2684 17.2708 11.3281 17.4998 11.3288C17.8535 11.3288 18.1926 11.1883 18.4426 10.9383C18.6927 10.6882 18.8332 10.3491 18.8332 9.99544V3.32878H22.8332C23.1868 3.32878 23.5259 3.46925 23.776 3.7193C24.026 3.96935 24.1665 4.30849 24.1665 4.66211V23.3288Z",
            fill: "#333333"
        })
    });
};
var InfoIcon = function(param) {
    var onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ _jsx("svg", {
        className: className,
        onClick: onClick,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.99968 0.341797C5.68114 0.341797 4.3922 0.73279 3.29588 1.46533C2.19955 2.19788 1.34506 3.23907 0.840481 4.45724C0.335896 5.67541 0.203874 7.01586 0.461109 8.30907C0.718344 9.60227 1.35328 10.7902 2.28563 11.7225C3.21798 12.6549 4.40587 13.2898 5.69908 13.547C6.99228 13.8043 8.33273 13.6722 9.5509 13.1677C10.7691 12.6631 11.8103 11.8086 12.5428 10.7123C13.2754 9.61594 13.6663 8.32701 13.6663 7.00846C13.6644 5.24096 12.9614 3.54641 11.7116 2.29659C10.4617 1.04677 8.76718 0.343763 6.99968 0.341797ZM6.99968 12.3418C5.94484 12.3418 4.9137 12.029 4.03664 11.443C3.15957 10.8569 2.47599 10.024 2.07232 9.04944C1.66865 8.0749 1.56304 7.00255 1.76882 5.96798C1.97461 4.93342 2.48256 3.98311 3.22844 3.23723C3.97432 2.49135 4.92463 1.9834 5.9592 1.77761C6.99376 1.57182 8.06612 1.67744 9.04066 2.08111C10.0152 2.48477 10.8481 3.16836 11.4342 4.04542C12.0202 4.92248 12.333 5.95363 12.333 7.00846C12.3314 8.42245 11.769 9.77807 10.7691 10.7779C9.76928 11.7778 8.41367 12.3402 6.99968 12.3418ZM6.99968 6.67513C6.82287 6.67513 6.6533 6.74537 6.52827 6.87039C6.40325 6.99542 6.33301 7.16499 6.33301 7.3418V9.3418C6.33301 9.51861 6.40325 9.68818 6.52827 9.8132C6.6533 9.93823 6.82287 10.0085 6.99968 10.0085C7.17649 10.0085 7.34606 9.93823 7.47108 9.8132C7.59611 9.68818 7.66634 9.51861 7.66634 9.3418V7.3418C7.66634 7.16499 7.59611 6.99542 7.47108 6.87039C7.34606 6.74537 7.17649 6.67513 6.99968 6.67513ZM6.99968 4.00846C6.83486 4.00846 6.67374 4.05734 6.5367 4.14891C6.39966 4.24047 6.29285 4.37062 6.22978 4.52289C6.16671 4.67517 6.1502 4.84272 6.18236 5.00437C6.21451 5.16602 6.29388 5.31451 6.41042 5.43105C6.52697 5.5476 6.67545 5.62696 6.8371 5.65912C6.99875 5.69127 7.16631 5.67477 7.31858 5.6117C7.47085 5.54862 7.601 5.44181 7.69257 5.30477C7.78414 5.16773 7.83301 5.00661 7.83301 4.8418C7.83301 4.62078 7.74521 4.40882 7.58893 4.25254C7.43265 4.09626 7.22069 4.00846 6.99968 4.00846Z",
            fill: "white"
        })
    });
};
var CheckCircleIconV3 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
            fill: fillColor
        })
    });
};
var DuplicatedIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21 2H3C2.4 2 2 2.4 2 3V21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21V3C22 2.4 21.6 2 21 2ZM15 13H9C8.4 13 8 12.6 8 12C8 11.4 8.4 11 9 11H15C15.6 11 16 11.4 16 12C16 12.6 15.6 13 15 13Z",
            fill: fillColor
        })
    });
};
var CircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
            fill: fillColor
        })
    });
};
var DropDownIcon1 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#CCCCCC" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "19",
        height: "20",
        viewBox: "0 0 19 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_28627_404938)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "19",
                        height: "19",
                        transform: "translate(19 19.5) rotate(-180)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.30466 11.125C5.31087 11.2194 5.32951 11.3126 5.36007 11.4021C5.39225 11.4649 5.43214 11.5234 5.47882 11.5763C5.49169 11.6043 5.50762 11.6309 5.52632 11.6554L5.60549 11.7029C5.65837 11.7496 5.71688 11.7895 5.77965 11.8217C5.87781 11.8616 5.98247 11.883 6.08841 11.885L12.8572 11.885C12.9631 11.883 13.0677 11.8616 13.1659 11.8217C13.2287 11.7895 13.2872 11.7496 13.3401 11.7029C13.3681 11.6901 13.3947 11.6741 13.4192 11.6554C13.4933 11.5832 13.5525 11.4971 13.5934 11.4021C13.634 11.3069 13.6555 11.2047 13.6567 11.1013C13.6567 11.1013 13.6567 11.0538 13.6567 11.03C13.6531 10.954 13.6371 10.8791 13.6092 10.8083C13.5703 10.7057 13.508 10.6135 13.4272 10.5392L10.0784 7.19043C9.93008 7.04298 9.72943 6.96022 9.52028 6.96022C9.31113 6.96022 9.11048 7.04298 8.96215 7.19043L5.54215 10.5629C5.46332 10.6359 5.40121 10.725 5.36007 10.8242C5.32222 10.9199 5.30339 11.0221 5.30466 11.125Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_28627_404938",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "19",
                        height: "19",
                        fill: "white",
                        transform: "translate(19 19.5) rotate(-180)"
                    })
                })
            })
        ]
    });
};
var DropDownIcon2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#CCCCCC" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "19",
        height: "20",
        viewBox: "0 0 19 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_28519_806820)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "19",
                        height: "19",
                        transform: "translate(0 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.6956 8.87502C13.6894 8.78063 13.6707 8.68746 13.6402 8.59794C13.608 8.53516 13.5681 8.47666 13.5214 8.42377C13.5085 8.39572 13.4926 8.36917 13.4739 8.3446V8.3446L13.3948 8.2971C13.3419 8.25042 13.2834 8.21053 13.2206 8.17835C13.1224 8.13847 13.0178 8.117 12.9118 8.11502H6.14309C6.03716 8.117 5.93249 8.13847 5.83434 8.17835C5.77157 8.21053 5.71306 8.25042 5.66017 8.2971C5.63212 8.30998 5.60557 8.32591 5.58101 8.3446V8.3446C5.50695 8.41686 5.44778 8.50292 5.40684 8.59794C5.36627 8.69311 5.34476 8.79532 5.34351 8.89877C5.34351 8.89877 5.34351 8.94627 5.34351 8.97002C5.34713 9.04601 5.36318 9.12089 5.39101 9.19169C5.4299 9.29437 5.49225 9.38655 5.57309 9.46085L8.92184 12.8096C9.07017 12.9571 9.27082 13.0398 9.47996 13.0398C9.68911 13.0398 9.88976 12.9571 10.0381 12.8096V12.8096L13.4581 9.4371C13.5369 9.36418 13.599 9.27506 13.6402 9.17585C13.678 9.08013 13.6968 8.97795 13.6956 8.87502Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_28519_806820",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "19",
                        height: "19",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var CollapseIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#EE3244" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_28761_435723)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        transform: "translate(0.5 0.500488)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.8354 9.44159L8.97541 6.61492C8.91344 6.55244 8.83971 6.50284 8.75847 6.469C8.67723 6.43515 8.59009 6.41772 8.50208 6.41772C8.41407 6.41772 8.32694 6.43515 8.2457 6.469C8.16446 6.50284 8.09072 6.55244 8.02875 6.61492L5.20208 9.44159C5.1396 9.50357 5.09 9.5773 5.05615 9.65854C5.02231 9.73978 5.00488 9.82692 5.00488 9.91492C5.00488 10.0029 5.02231 10.0901 5.05615 10.1713C5.09 10.2525 5.1396 10.3263 5.20208 10.3883C5.32699 10.5124 5.49596 10.5821 5.67208 10.5821C5.84821 10.5821 6.01717 10.5124 6.14208 10.3883L8.50208 8.02826L10.8621 10.3883C10.9863 10.5114 11.1539 10.5809 11.3287 10.5816C11.4165 10.5821 11.5035 10.5653 11.5847 10.5321C11.6659 10.4989 11.7398 10.45 11.8021 10.3883C11.8668 10.3285 11.919 10.2565 11.9558 10.1765C11.9925 10.0964 12.013 10.0099 12.0161 9.92187C12.0192 9.83385 12.0048 9.74608 11.9738 9.66365C11.9428 9.58121 11.8958 9.50574 11.8354 9.44159Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_28761_435723",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0.5 0.500488)"
                    })
                })
            })
        ]
    });
};
var ExpandIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#EE3244" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_28761_391232)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        transform: "translate(0 0.133789)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.3354 6.2483C11.2105 6.12414 11.0415 6.05444 10.8654 6.05444C10.6893 6.05444 10.5203 6.12414 10.3954 6.2483L8.00208 8.6083L5.64208 6.2483C5.51717 6.12414 5.34821 6.05444 5.17208 6.05444C4.99596 6.05444 4.82699 6.12414 4.70208 6.2483C4.6396 6.31028 4.59 6.38401 4.55615 6.46525C4.52231 6.54649 4.50488 6.63363 4.50488 6.72164C4.50488 6.80965 4.52231 6.89678 4.55615 6.97802C4.59 7.05926 4.6396 7.133 4.70208 7.19497L7.52875 10.0216C7.59072 10.0841 7.66446 10.1337 7.7457 10.1676C7.82694 10.2014 7.91407 10.2188 8.00208 10.2188C8.09009 10.2188 8.17723 10.2014 8.25847 10.1676C8.33971 10.1337 8.41344 10.0841 8.47541 10.0216L11.3354 7.19497C11.3979 7.133 11.4475 7.05926 11.4813 6.97802C11.5152 6.89678 11.5326 6.80965 11.5326 6.72164C11.5326 6.63363 11.5152 6.54649 11.4813 6.46525C11.4475 6.38401 11.3979 6.31028 11.3354 6.2483Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_28761_391232",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 0.133789)"
                    })
                })
            })
        ]
    });
};
var BanIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84286 16.1566 4 14.1217 4 12C3.9978 10.2233 4.59302 8.49755 5.69 7.1L16.9 18.31C15.5025 19.407 13.7767 20.0022 12 20ZM18.31 16.9L7.1 5.69C8.49755 4.59302 10.2233 3.99779 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1572 7.84344 20 9.87827 20 12C20.0022 13.7767 19.407 15.5025 18.31 16.9Z",
            fill: fillColor
        })
    });
};
var PlaceHolderImageIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: "52",
        height: "61",
        viewBox: "0 0 52 61",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_d_1398_581868)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M38.3866 7.38672C41.1049 7.38672 43.3081 9.58497 43.3081 12.2975V45.333C43.3081 48.0456 41.1049 50.2439 38.3866 50.2439H14.2255C12.1315 50.2439 10.3596 48.9582 9.64387 47.119C9.42889 46.5654 9.30371 45.9582 9.30371 45.333V12.2975C9.30371 9.58497 11.5069 7.38672 14.2255 7.38672L38.3866 7.38672Z",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M22.7261 23.4583C22.7261 25.4306 21.1236 27.0298 19.1466 27.0298C17.1699 27.0298 15.5674 25.4306 15.5674 23.4583C15.5674 21.4859 17.1699 19.8867 19.1466 19.8867C21.1236 19.8867 22.7261 21.4859 22.7261 23.4583Z",
                        fill: "url(#paint0_linear_1398_581868)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M37.1515 50.2433H14.2255C12.1315 50.2433 10.3596 48.9576 9.64387 47.1184C9.42889 46.5648 9.30371 45.9576 9.30371 45.3325V38.5291L15.1382 32.7077C16.3553 31.4933 18.3595 31.4933 19.5766 32.7077L37.1515 50.2433Z",
                        fill: "url(#paint1_linear_1398_581868)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M43.3078 34.9577V45.3326C43.3078 48.0471 41.1066 50.2434 38.3863 50.2434H14.2252C12.1312 50.2434 10.3593 48.9577 9.64355 47.1185L30.3503 26.4577C31.5674 25.2433 33.572 25.2433 34.7887 26.4577L43.3078 34.9577Z",
                        fill: "url(#paint2_linear_1398_581868)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_d_1398_581868",
                        x: "0.651364",
                        y: "0.734372",
                        width: "51.3086",
                        height: "60.1621",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "4.32617"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1398_581868"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1398_581868",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_1398_581868",
                        x1: "19.1467",
                        y1: "19.8867",
                        x2: "19.1467",
                        y2: "27.0298",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#BEBEBE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#707070"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_1398_581868",
                        x1: "23.2276",
                        y1: "31.7969",
                        x2: "23.2276",
                        y2: "50.2433",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#BEBEBE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#707070"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint2_linear_1398_581868",
                        x1: "26.4757",
                        y1: "25.5469",
                        x2: "26.4757",
                        y2: "50.2434",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#BEBEBE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#707070"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FavouriteIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#F25220" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.9932 7.16727C23.9966 7.07601 23.9986 6.98474 23.9986 6.89294C23.9986 3.20076 21.1854 0 17.7146 0C15.1771 0 12.9924 1.80802 12.0005 4.11179C11.0086 1.80802 8.82242 0 6.28493 0C2.81412 0 0.000493567 3.20076 0.000493567 6.89294C0.000493567 6.98474 0.00342087 7.07601 0.00683606 7.16727C0.00683606 7.16727 -0.348344 11.5534 4.06164 16.3424C6.06685 18.5662 8.30917 20.6794 12 24C15.6909 20.6794 17.9332 18.5662 19.9384 16.3424C24.3479 11.5534 23.9932 7.16727 23.9932 7.16727Z",
            fill: fillColor
        })
    });
};
var ArrowRightIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 17 : _width, _height = param.height, height = _height === void 0 ? 17 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.6933 8.2308C12.6596 8.14385 12.6091 8.06442 12.5446 7.99705L9.00292 4.45539C8.93687 4.38934 8.85847 4.33695 8.77218 4.30121C8.68589 4.26547 8.5934 4.24707 8.5 4.24707C8.31137 4.24707 8.13047 4.322 7.99708 4.45539C7.93104 4.52143 7.87865 4.59983 7.84291 4.68613C7.80716 4.77242 7.78877 4.8649 7.78877 4.9583C7.78877 5.14693 7.8637 5.32784 7.99708 5.46122L10.3346 7.79164H4.95833C4.77047 7.79164 4.5903 7.86626 4.45747 7.9991C4.32463 8.13194 4.25 8.31211 4.25 8.49997C4.25 8.68783 4.32463 8.868 4.45747 9.00084C4.5903 9.13367 4.77047 9.2083 4.95833 9.2083H10.3346L7.99708 11.5387C7.93069 11.6046 7.878 11.6829 7.84204 11.7692C7.80607 11.8555 7.78756 11.9481 7.78756 12.0416C7.78756 12.1351 7.80607 12.2277 7.84204 12.314C7.878 12.4004 7.93069 12.4787 7.99708 12.5446C8.06293 12.6109 8.14127 12.6636 8.22759 12.6996C8.31391 12.7356 8.40649 12.7541 8.5 12.7541C8.59351 12.7541 8.68609 12.7356 8.77241 12.6996C8.85873 12.6636 8.93707 12.6109 9.00292 12.5446L12.5446 9.00289C12.6091 8.93552 12.6596 8.85608 12.6933 8.76914C12.7642 8.59668 12.7642 8.40325 12.6933 8.2308Z",
            fill: fillColor
        })
    });
};
var SaleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#F25220" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.8965 12.0008L23.9494 9.25452C24.0649 8.95154 23.9749 8.60807 23.7214 8.40258L21.4386 6.55171L20.9766 3.64641C20.9256 3.32543 20.6736 3.07495 20.3526 3.02395L17.4473 2.56198L15.598 0.277643C15.394 0.0241601 15.043 -0.0658337 14.7475 0.0496584L11.9997 1.10409L9.25341 0.0511582C8.94893 -0.0658337 8.60846 0.0271599 8.40297 0.279142L6.5521 2.56348L3.6468 3.02545C3.32732 3.07645 3.07534 3.32843 3.02434 3.64791L2.56237 6.55321L0.278033 8.40408C0.02605 8.60807 -0.0654436 8.95154 0.0500484 9.25452L1.10298 12.0008L0.0500484 14.7471C-0.0669435 15.0501 0.02605 15.3936 0.278033 15.5976L2.56237 17.447L3.02434 20.3523C3.07534 20.6732 3.32582 20.9252 3.6468 20.9762L6.5521 21.4382L8.40297 23.721C8.60846 23.976 8.95193 24.066 9.25491 23.949L11.9997 22.8976L14.746 23.9505C14.833 23.9835 14.923 24 15.0145 24C15.235 24 15.4525 23.9025 15.598 23.721L17.4473 21.4382L20.3526 20.9762C20.6736 20.9252 20.9256 20.6732 20.9766 20.3523L21.4386 17.447L23.7214 15.5976C23.9749 15.3921 24.0649 15.0501 23.9494 14.7471L22.8965 12.0008Z",
                fill: "#F69113"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.74954 10.5016C8.50912 10.5016 7.49969 9.49221 7.49969 8.2518C7.49969 7.01138 8.50912 6.00195 9.74954 6.00195C10.99 6.00195 11.9994 7.01138 11.9994 8.2518C11.9994 9.49221 10.99 10.5016 9.74954 10.5016ZM9.74954 7.50185C9.33557 7.50185 8.99959 7.83783 8.99959 8.2518C8.99959 8.66577 9.33557 9.00175 9.74954 9.00175C10.1635 9.00175 10.4995 8.66577 10.4995 8.2518C10.4995 7.83783 10.1635 7.50185 9.74954 7.50185Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.2492 18.0007C13.0088 18.0007 11.9994 16.9912 11.9994 15.7508C11.9994 14.5104 13.0088 13.501 14.2492 13.501C15.4896 13.501 16.4991 14.5104 16.4991 15.7508C16.4991 16.9912 15.4896 18.0007 14.2492 18.0007ZM14.2492 15.0009C13.8368 15.0009 13.4993 15.3383 13.4993 15.7508C13.4993 16.1633 13.8368 16.5008 14.2492 16.5008C14.6617 16.5008 14.9992 16.1633 14.9992 15.7508C14.9992 15.3383 14.6617 15.0009 14.2492 15.0009Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.24995 18.001C8.09846 18.001 7.94697 17.956 7.81498 17.8615C7.4775 17.62 7.39951 17.152 7.64099 16.8146L15.1405 6.31529C15.382 5.97781 15.8499 5.89981 16.1874 6.1413C16.5249 6.38128 16.6014 6.85075 16.3614 7.18673L8.86191 17.686C8.71342 17.8915 8.48393 18.001 8.24995 18.001Z",
                fill: "#FAFAFA"
            })
        ]
    });
};
var HotIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#F25220" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.032 23.9995C16.6386 23.9995 20.7785 21.4477 22.1587 17.6361C22.4507 16.8298 22.6284 15.9739 22.6284 15.0852C22.6284 10.1138 17.9355 6.10242 17.9355 6.10242C17.9355 6.10242 18.2588 7.72632 18.0577 9.10862C17.8565 10.4909 17.1153 11.3395 17.1153 11.3395C17.1153 11.3395 17.6566 9.16899 16.9374 7.71378C16.1096 6.03885 14.5656 5.26187 13.9725 3.75379C13.2899 2.01808 14.3128 -0.000488281 14.3128 -0.000488281C14.3128 -0.000488281 10.9484 1.12703 8.51717 4.03664C5.75984 7.3366 7.61787 11.5881 7.61787 11.5881C7.61787 11.5881 7.36087 10.4138 5.96738 9.46234C4.57389 8.51092 5.1384 7.03533 5.1384 7.03533C5.1384 7.03533 1.37158 10.6967 1.37158 15.0853C1.37158 16.2767 1.76496 17.4783 2.33801 18.5966C4.0325 21.9032 7.8598 23.9995 12.032 23.9995Z",
                fill: "#D10028"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 17.3153C18 14.7521 15.8698 13.0987 14.5434 12.0381C12.1815 10.149 12.6008 7.99951 12.6008 7.99951C12.6008 7.99951 7.97156 11.1413 7.24421 13.7472C6.54879 16.2395 8.29818 17.625 8.29818 17.625C8.29818 17.625 7.48302 17.3767 6.97613 16.9316C6.33047 16.3647 6.09844 15.678 6.09844 15.678C6.09844 15.678 5.82863 16.1933 6.18239 17.9565C6.43384 19.2097 7.25871 20.1476 8.22661 20.8378C10.5791 22.5153 14.2478 22.3529 16.3799 20.501C17.2935 19.7076 18 18.6594 18 17.3153Z",
                fill: "#EF7816"
            })
        ]
    });
};
var SearchIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 17 : _width, _height = param.height, height = _height === void 0 ? 17 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_30096_357530)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        transform: "translate(0 0.5)",
                        fill: fillColor,
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.3774 14.8706L12.7495 12.2639C13.7696 10.9921 14.2636 9.3777 14.1299 7.75278C13.9963 6.12787 13.2451 4.61592 12.0309 3.52782C10.8167 2.43972 9.23178 1.85818 7.60199 1.90278C5.9722 1.94738 4.42143 2.61472 3.26856 3.76759C2.11569 4.92046 1.44835 6.47122 1.40375 8.10102C1.35916 9.73081 1.9407 11.3157 3.02879 12.5299C4.11689 13.7441 5.62884 14.4953 7.25376 14.6289C8.87867 14.7626 10.493 14.2686 11.7649 13.2485L14.3716 15.8552C14.4374 15.9216 14.5158 15.9743 14.6021 16.0102C14.6884 16.0462 14.781 16.0647 14.8745 16.0647C14.968 16.0647 15.0606 16.0462 15.1469 16.0102C15.2332 15.9743 15.3116 15.9216 15.3774 15.8552C15.5051 15.7231 15.5765 15.5466 15.5765 15.3629C15.5765 15.1792 15.5051 15.0027 15.3774 14.8706ZM7.79117 13.2485C6.81051 13.2485 5.85186 12.9577 5.03647 12.4129C4.22108 11.8681 3.58555 11.0937 3.21027 10.1877C2.83498 9.28165 2.73679 8.28469 2.92811 7.32287C3.11943 6.36105 3.59167 5.47756 4.2851 4.78412C4.97854 4.09069 5.86203 3.61845 6.82385 3.42713C7.78567 3.23582 8.78263 3.33401 9.68864 3.70929C10.5947 4.08458 11.369 4.7201 11.9139 5.53549C12.4587 6.35089 12.7495 7.30953 12.7495 8.29019C12.7495 9.60523 12.2271 10.8664 11.2972 11.7963C10.3674 12.7261 9.1062 13.2485 7.79117 13.2485Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_30096_357530",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var InfomationPositionIcon = function(param) {
    var className = param.className, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.99968 0.832031C5.68114 0.832031 4.3922 1.22302 3.29588 1.95557C2.19955 2.68811 1.34506 3.7293 0.840481 4.94747C0.335896 6.16565 0.203874 7.50609 0.461109 8.7993C0.718344 10.0925 1.35328 11.2804 2.28563 12.2127C3.21798 13.1451 4.40587 13.78 5.69908 14.0373C6.99228 14.2945 8.33273 14.1625 9.5509 13.6579C10.7691 13.1533 11.8103 12.2988 12.5428 11.2025C13.2754 10.1062 13.6663 8.81724 13.6663 7.4987C13.6644 5.73119 12.9614 4.03664 11.7116 2.78682C10.4617 1.53701 8.76718 0.833997 6.99968 0.832031ZM6.99968 12.832C5.94484 12.832 4.9137 12.5192 4.03664 11.9332C3.15957 11.3472 2.47599 10.5142 2.07232 9.53968C1.66865 8.56514 1.56304 7.49278 1.76882 6.45822C1.97461 5.42365 2.48256 4.47334 3.22844 3.72746C3.97432 2.98158 4.92463 2.47363 5.9592 2.26784C6.99376 2.06206 8.06612 2.16767 9.04066 2.57134C10.0152 2.97501 10.8481 3.65859 11.4342 4.53566C12.0202 5.41272 12.333 6.44386 12.333 7.4987C12.3314 8.91269 11.769 10.2683 10.7691 11.2681C9.76928 12.268 8.41367 12.8304 6.99968 12.832ZM6.99968 7.16536C6.82287 7.16536 6.6533 7.2356 6.52827 7.36063C6.40325 7.48565 6.33301 7.65522 6.33301 7.83203V9.83203C6.33301 10.0088 6.40325 10.1784 6.52827 10.3034C6.6533 10.4285 6.82287 10.4987 6.99968 10.4987C7.17649 10.4987 7.34606 10.4285 7.47108 10.3034C7.59611 10.1784 7.66634 10.0088 7.66634 9.83203V7.83203C7.66634 7.65522 7.59611 7.48565 7.47108 7.36063C7.34606 7.2356 7.17649 7.16536 6.99968 7.16536ZM6.99968 4.4987C6.83486 4.4987 6.67374 4.54757 6.5367 4.63914C6.39966 4.73071 6.29285 4.86086 6.22978 5.01313C6.16671 5.1654 6.1502 5.33296 6.18236 5.49461C6.21451 5.65626 6.29388 5.80474 6.41042 5.92129C6.52697 6.03783 6.67545 6.1172 6.8371 6.14935C6.99875 6.18151 7.16631 6.165 7.31858 6.10193C7.47085 6.03886 7.601 5.93205 7.69257 5.79501C7.78414 5.65797 7.83301 5.49685 7.83301 5.33203C7.83301 5.11102 7.74521 4.89906 7.58893 4.74278C7.43265 4.5865 7.22069 4.4987 6.99968 4.4987Z",
            fill: "white"
        })
    });
};
var ClosePositionInfoIcon = function(param) {
    var onClick = param.onClick, className = param.className, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_31847_243140)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_31847_243140",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var PenIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22 7.24002C22.0008 7.10841 21.9756 6.97795 21.9258 6.85611C21.876 6.73427 21.8027 6.62346 21.71 6.53002L17.47 2.29002C17.3766 2.19734 17.2658 2.12401 17.1439 2.07425C17.0221 2.02448 16.8916 1.99926 16.76 2.00002C16.6284 1.99926 16.4979 2.02448 16.3761 2.07425C16.2543 2.12401 16.1435 2.19734 16.05 2.29002L13.22 5.12002L2.29002 16.05C2.19734 16.1435 2.12401 16.2543 2.07425 16.3761C2.02448 16.4979 1.99926 16.6284 2.00002 16.76V21C2.00002 21.2652 2.10537 21.5196 2.29291 21.7071C2.48045 21.8947 2.7348 22 3.00002 22H7.24002C7.37994 22.0076 7.51991 21.9857 7.65084 21.9358C7.78176 21.8858 7.90073 21.8089 8.00002 21.71L18.87 10.78L21.71 8.00002C21.8013 7.9031 21.8757 7.79155 21.93 7.67002C21.9397 7.59031 21.9397 7.50973 21.93 7.43002C21.9347 7.38347 21.9347 7.33657 21.93 7.29002L22 7.24002ZM6.83002 20H4.00002V17.17L13.93 7.24002L16.76 10.07L6.83002 20ZM18.17 8.66002L15.34 5.83002L16.76 4.42002L19.58 7.24002L18.17 8.66002Z",
            fill: fillColor
        })
    });
};
var LineRename = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.5 2C3.11928 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V15.918C22 15.3657 21.5523 14.918 21 14.918C20.4477 14.918 20 15.3657 20 15.918V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V4.5C4 4.22386 4.22386 4 4.5 4H8.93227C9.48456 4 9.93227 3.55228 9.93227 3C9.93227 2.44772 9.48456 2 8.93227 2H4.5Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.99416 18.0058H11.2342C11.3658 18.0066 11.4962 17.9813 11.6181 17.9316C11.7399 17.8818 11.8507 17.8085 11.9442 17.7158L18.8642 10.7858L21.7042 8.0058C21.7979 7.91284 21.8723 7.80223 21.923 7.68038C21.9738 7.55852 22 7.42781 22 7.2958C22 7.16379 21.9738 7.03308 21.923 6.91122C21.8723 6.78936 21.7979 6.67876 21.7042 6.5858L17.4642 2.2958C17.3712 2.20207 17.2606 2.12768 17.1387 2.07691C17.0169 2.02614 16.8862 2 16.7542 2C16.6221 2 16.4914 2.02614 16.3696 2.07691C16.2477 2.12768 16.1371 2.20207 16.0442 2.2958L13.2242 5.1258L6.28416 12.0558C6.19148 12.1492 6.11815 12.2601 6.06839 12.3819C6.01862 12.5037 5.9934 12.6342 5.99416 12.7658V17.0058C5.99416 17.271 6.09951 17.5254 6.28705 17.7129C6.47459 17.9004 6.72894 18.0058 6.99416 18.0058ZM16.7542 4.4158L19.5842 7.2458L18.1642 8.6658L15.3342 5.8358L16.7542 4.4158ZM7.99416 13.1758L13.9242 7.2458L16.7542 10.0758L10.8242 16.0058H7.99416V13.1758Z",
                fill: fillColor
            })
        ]
    });
};
var AngelDownIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.9999 9.17019C16.8126 8.98394 16.5591 8.87939 16.2949 8.87939C16.0308 8.87939 15.7773 8.98394 15.5899 9.17019L11.9999 12.7102L8.45995 9.17019C8.27259 8.98394 8.01913 8.87939 7.75495 8.87939C7.49076 8.87939 7.23731 8.98394 7.04995 9.17019C6.95622 9.26315 6.88183 9.37375 6.83106 9.49561C6.78029 9.61747 6.75415 9.74818 6.75415 9.88019C6.75415 10.0122 6.78029 10.1429 6.83106 10.2648C6.88183 10.3866 6.95622 10.4972 7.04995 10.5902L11.2899 14.8302C11.3829 14.9239 11.4935 14.9983 11.6154 15.0491C11.7372 15.0998 11.8679 15.126 11.9999 15.126C12.132 15.126 12.2627 15.0998 12.3845 15.0491C12.5064 14.9983 12.617 14.9239 12.7099 14.8302L16.9999 10.5902C17.0937 10.4972 17.1681 10.3866 17.2188 10.2648C17.2696 10.1429 17.2957 10.0122 17.2957 9.88019C17.2957 9.74818 17.2696 9.61747 17.2188 9.49561C17.1681 9.37375 17.0937 9.26315 16.9999 9.17019Z",
            fill: fillColor
        })
    });
};
var AngelUpIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.9999 13.4098L12.7099 9.16982C12.617 9.07609 12.5064 9.0017 12.3845 8.95093C12.2627 8.90016 12.132 8.87402 11.9999 8.87402C11.8679 8.87402 11.7372 8.90016 11.6154 8.95093C11.4935 9.0017 11.3829 9.07609 11.2899 9.16982L7.04995 13.4098C6.95622 13.5028 6.88183 13.6134 6.83106 13.7352C6.78029 13.8571 6.75415 13.9878 6.75415 14.1198C6.75415 14.2518 6.78029 14.3825 6.83106 14.5044C6.88183 14.6263 6.95622 14.7369 7.04995 14.8298C7.23731 15.0161 7.49076 15.1206 7.75495 15.1206C8.01913 15.1206 8.27259 15.0161 8.45995 14.8298L11.9999 11.2898L15.5399 14.8298C15.7262 15.0146 15.9776 15.1187 16.2399 15.1198C16.3716 15.1206 16.502 15.0954 16.6239 15.0456C16.7457 14.9958 16.8565 14.9225 16.9499 14.8298C17.047 14.7402 17.1254 14.6322 17.1805 14.5122C17.2356 14.3921 17.2664 14.2623 17.271 14.1302C17.2757 13.9982 17.2541 13.8666 17.2076 13.7429C17.161 13.6193 17.0905 13.506 16.9999 13.4098Z",
            fill: fillColor
        })
    });
};
var ErrorIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "15",
        height: "13",
        viewBox: "0 0 15 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.1871 9.93668L9.12464 1.18668C8.62464 0.311683 7.43714 -0.000816792 6.56214 0.499183C6.24964 0.686683 5.99964 0.936683 5.87464 1.18668L0.812141 9.93668C0.312141 10.8117 0.624641 11.9992 1.49964 12.4992C1.81214 12.6867 2.12464 12.7492 2.43714 12.7492H12.4996C13.5621 12.7492 14.3746 11.8742 14.3746 10.8742C14.4371 10.4992 14.3121 10.1867 14.1871 9.93668ZM7.49964 10.2492C7.12464 10.2492 6.87464 9.99918 6.87464 9.62418C6.87464 9.24918 7.12464 8.99918 7.49964 8.99918C7.87464 8.99918 8.12464 9.24918 8.12464 9.62418C8.12464 9.99918 7.87464 10.2492 7.49964 10.2492ZM8.12464 7.12418C8.12464 7.49918 7.87464 7.74918 7.49964 7.74918C7.12464 7.74918 6.87464 7.49918 6.87464 7.12418V4.62418C6.87464 4.24918 7.12464 3.99918 7.49964 3.99918C7.87464 3.99918 8.12464 4.24918 8.12464 4.62418V7.12418Z",
            fill: "#EE3244"
        })
    });
};
var SuccessIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 40 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.9996 0.499176C8.99963 0.499176 -0.000366211 9.49918 -0.000366211 20.4992C-0.000366211 31.4992 8.99963 40.4992 19.9996 40.4992C30.9996 40.4992 39.9996 31.4992 39.9996 20.4992C39.9996 9.49918 30.9996 0.499176 19.9996 0.499176ZM28.3996 17.0992L18.7996 26.6992C17.9996 27.4992 16.7996 27.4992 15.9996 26.6992L11.5996 22.2992C10.7996 21.4992 10.7996 20.2992 11.5996 19.4992C12.3996 18.6992 13.5996 18.6992 14.3996 19.4992L17.3996 22.4992L25.5996 14.2992C26.3996 13.4992 27.5996 13.4992 28.3996 14.2992C29.1996 15.0992 29.1996 16.2992 28.3996 17.0992Z",
            fill: "#00B578"
        })
    });
};
var EmptyIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 260 : _width, _height = param.height, height = _height === void 0 ? 80 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 261 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32034_877034)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.5",
                    width: "260",
                    height: "80",
                    fill: "url(#pattern0)"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                            xlinkHref: "#image0_32034_877034",
                            transform: "translate(0.334624) scale(0.000720591 0.00234192)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_32034_877034",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "260",
                            height: "80",
                            fill: "white",
                            transform: "translate(0.5)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
                        id: "image0_32034_877034",
                        width: "459",
                        height: "427",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
var AngleDownIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.9999 9.17019C16.8126 8.98394 16.5591 8.87939 16.2949 8.87939C16.0308 8.87939 15.7773 8.98394 15.5899 9.17019L11.9999 12.7102L8.45995 9.17019C8.27259 8.98394 8.01913 8.87939 7.75495 8.87939C7.49076 8.87939 7.23731 8.98394 7.04995 9.17019C6.95622 9.26315 6.88183 9.37375 6.83106 9.49561C6.78029 9.61747 6.75415 9.74818 6.75415 9.88019C6.75415 10.0122 6.78029 10.1429 6.83106 10.2648C6.88183 10.3866 6.95622 10.4972 7.04995 10.5902L11.2899 14.8302C11.3829 14.9239 11.4935 14.9983 11.6154 15.0491C11.7372 15.0998 11.8679 15.126 11.9999 15.126C12.132 15.126 12.2627 15.0998 12.3845 15.0491C12.5064 14.9983 12.617 14.9239 12.7099 14.8302L16.9999 10.5902C17.0937 10.4972 17.1681 10.3866 17.2188 10.2648C17.2696 10.1429 17.2957 10.0122 17.2957 9.88019C17.2957 9.74818 17.2696 9.61747 17.2188 9.49561C17.1681 9.37375 17.0937 9.26315 16.9999 9.17019Z",
            fill: fillColor
        })
    });
};
var AddCircleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16 12.75H12.75V16C12.75 16.41 12.41 16.75 12 16.75C11.59 16.75 11.25 16.41 11.25 16V12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H11.25V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z",
            fill: fillColor
        })
    });
};
var Logo = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "103",
        height: "24",
        viewBox: "0 0 103 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5467 2.5778C13.9095 3.90194 14.6752 5.69786 14.6752 7.57048C14.668 9.31848 13.9977 11.0025 12.7925 12.3003C11.5873 13.5982 9.93188 14.4186 8.14301 14.6048V14.6576H0.141113V7.67626V7.57048C0.141113 5.69786 0.906744 3.90194 2.26958 2.5778C3.63241 1.25366 5.48081 0.509766 7.40815 0.509766C9.33548 0.509766 11.1839 1.25366 12.5467 2.5778ZM1.45956 18.4348C1.90714 18.1442 2.43336 17.9891 2.97167 17.9891C3.69352 17.9891 4.3858 18.2677 4.89623 18.7637C5.40665 19.2596 5.69341 19.9322 5.69341 20.6336C5.69341 21.1566 5.53378 21.6679 5.23471 22.1028C4.93564 22.5376 4.51056 22.8766 4.01323 23.0767C3.5159 23.2769 2.96865 23.3293 2.44069 23.2272C1.91272 23.1252 1.42776 22.8733 1.04711 22.5035C0.666472 22.1337 0.407252 21.6625 0.302233 21.1495C0.197215 20.6365 0.251113 20.1048 0.457115 19.6216C0.663116 19.1384 1.01197 18.7254 1.45956 18.4348Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.7631 3.38887C34.6997 2.79379 33.4929 2.48047 32.2645 2.48047C31.0361 2.48047 29.8293 2.79379 28.7659 3.38887C27.6999 3.95197 26.8367 4.81608 26.2912 5.86602C25.6836 6.89799 25.3604 8.06378 25.3526 9.25146V19.7381C25.3493 20.1352 25.5017 20.5188 25.7793 20.8115C25.918 20.9647 26.0884 21.0879 26.2795 21.1733C26.4706 21.2586 26.6781 21.3042 26.8886 21.3069C27.299 21.3101 27.6955 21.1626 27.9979 20.8941C28.2754 20.6014 28.4279 20.2178 28.4245 19.8206V16.0223H33.2031C34.1832 15.9726 35.1292 15.6579 35.9338 15.1141C36.8885 14.5056 37.6786 13.6844 38.2377 12.7195C38.7897 11.6703 39.0819 10.5113 39.0911 9.33403C39.0835 8.12017 38.7607 6.92763 38.1524 5.86602C37.6395 4.8213 36.8049 3.95594 35.7631 3.38887ZM35.5925 11.3158C35.2783 11.903 34.7994 12.3927 34.2108 12.7286C33.6222 13.0645 32.9476 13.233 32.2645 13.2149C31.5814 13.233 30.9068 13.0645 30.3182 12.7286C29.7296 12.3927 29.2507 11.903 28.9365 11.3158C28.6001 10.6763 28.4247 9.96899 28.4247 9.25146C28.4247 8.53394 28.6001 7.82659 28.9365 7.18717C29.2507 6.59993 29.7296 6.11026 30.3182 5.77435C30.9068 5.43844 31.5814 5.26988 32.2645 5.28802C32.9476 5.26988 33.6222 5.43844 34.2108 5.77435C34.7994 6.11026 35.2783 6.59993 35.5925 7.18717C35.9289 7.82659 36.1043 8.53394 36.1043 9.25146C36.1043 9.96899 35.9289 10.6763 35.5925 11.3158ZM99.5918 3.38966C100.616 3.96803 101.469 4.79293 102.066 5.78424C102.679 6.83864 102.946 8.04772 102.834 9.25225C102.835 10.457 102.543 11.645 101.981 12.7203C101.44 13.7251 100.611 14.5568 99.5918 15.1148C98.5191 15.7604 97.2698 16.077 96.0078 16.0231C94.7506 16.0371 93.5126 15.7233 92.4239 15.1148C91.3994 14.5365 90.5469 13.7116 89.9492 12.7203C89.3482 11.6594 89.0534 10.4614 89.0959 9.25225C89.064 8.04413 89.3581 6.84883 89.9492 5.78424C90.5469 4.79293 91.3994 3.96803 92.4239 3.38966C93.5353 2.84677 94.7628 2.56395 96.0078 2.56395C97.2528 2.56395 98.4804 2.84677 99.5918 3.38966ZM98.0558 12.7203C98.6343 12.3811 99.1063 11.8958 99.4211 11.3165C99.7798 10.6853 99.9566 9.97231 99.9331 9.25225C99.9459 8.5333 99.7697 7.82298 99.4211 7.18796C99.107 6.60072 98.6281 6.11105 98.0395 5.77514C97.4508 5.43923 96.7763 5.27067 96.0932 5.28881C95.4056 5.28663 94.7293 5.45736 94.1305 5.78424C93.552 6.12336 93.08 6.60866 92.7652 7.18796C92.4065 7.81926 92.2297 8.5322 92.2532 9.25225C92.2404 9.97121 92.4166 10.6815 92.7652 11.3165C93.0794 11.9038 93.5582 12.3935 94.1469 12.7294C94.7355 13.0653 95.41 13.2338 96.0932 13.2157C96.7807 13.2179 97.457 13.0472 98.0558 12.7203ZM83.7198 3.05815C84.0307 2.803 84.4217 2.65744 84.8292 2.64529C85.0346 2.62493 85.2421 2.6517 85.4348 2.72343C85.6275 2.79516 85.8001 2.90984 85.9385 3.05815C86.216 3.3508 86.3685 3.73441 86.3651 4.13158V14.3705C86.3651 14.5657 86.3254 14.7589 86.2482 14.9393C86.171 15.1196 86.0579 15.2834 85.9153 15.4214C85.7726 15.5595 85.6033 15.6689 85.4169 15.7436C85.2306 15.8183 85.0309 15.8568 84.8292 15.8568C84.6274 15.8568 84.4277 15.8183 84.2414 15.7436C84.055 15.6689 83.8857 15.5595 83.743 15.4214C83.6004 15.2834 83.4873 15.1196 83.4101 14.9393C83.3329 14.7589 83.2932 14.5657 83.2932 14.3705V4.13158C83.2898 3.73441 83.4423 3.3508 83.7198 3.05815ZM51.6641 3.43847C52.712 4.02003 53.5844 4.85689 54.1944 5.86586C54.7846 6.84485 55.1076 7.95305 55.1331 9.08615V14.4533C55.1442 14.6513 55.112 14.8494 55.0388 15.0345C54.9655 15.2197 54.8527 15.3879 54.7078 15.5281C54.5629 15.6683 54.3891 15.7774 54.1978 15.8483C54.0064 15.9192 53.8017 15.9503 53.5971 15.9396H48.9038C48.5385 16.0081 48.1663 16.0358 47.7945 16.0222C46.6178 16.0372 45.4617 15.7217 44.4666 15.1139C43.4719 14.5524 42.6705 13.7194 42.1626 12.7193C41.5701 11.6851 41.2754 10.5159 41.3093 9.33387C41.2949 8.1173 41.6191 6.91941 42.2479 5.86586C42.858 4.85689 43.7303 4.02003 44.7782 3.43847C45.8261 2.85691 47.0131 2.55091 48.2212 2.55091C49.4292 2.55091 50.6162 2.85691 51.6641 3.43847ZM50.1838 12.7193C50.7623 12.3802 51.2343 11.8949 51.5491 11.3156C51.8856 10.6762 52.0609 9.96882 52.0609 9.2513C52.0609 8.53377 51.8856 7.82642 51.5491 7.18701C51.235 6.59976 50.7561 6.1101 50.1675 5.77419C49.5788 5.43827 48.9043 5.26972 48.2212 5.28785C47.5336 5.28568 46.8573 5.4564 46.2585 5.78329C45.6999 6.14567 45.2332 6.62553 44.8932 7.18701C44.5568 7.82642 44.3814 8.53377 44.3814 9.2513C44.3814 9.96882 44.5568 10.6762 44.8932 11.3156C45.2074 11.9028 45.6862 12.3925 46.2749 12.7284C46.8635 13.0643 47.5381 13.2329 48.2212 13.2147C48.9087 13.2169 49.585 13.0462 50.1838 12.7193ZM66.3971 8.75598C65.4859 8.30609 64.5066 7.99949 63.4958 7.84769C62.8561 7.73662 62.2279 7.57082 61.6185 7.35226C61.1918 7.18711 60.9358 7.02197 60.9358 6.85683C60.829 6.68134 60.7703 6.4824 60.7651 6.27883C60.7763 6.12255 60.8294 5.9718 60.9192 5.84146C61.0089 5.71113 61.1323 5.60573 61.2771 5.53568C61.7893 5.32161 62.3406 5.20929 62.8984 5.20539H63.2398L66.5677 5.53568C66.9045 5.52732 67.2251 5.39415 67.4632 5.16366C67.7014 4.93316 67.8391 4.62296 67.8477 4.29711V4.04939C67.8391 3.72353 67.7014 3.41333 67.4632 3.18284C67.2251 2.95235 66.9045 2.81917 66.5677 2.81081L63.1544 2.48053H62.8984C62.0561 2.49005 61.2208 2.62942 60.4238 2.89339C59.6654 3.126 58.9869 3.5542 58.4612 4.13196C57.8894 4.80204 57.6135 5.66318 57.6933 6.52874C57.7732 7.3943 58.2024 8.19453 58.8878 8.75598C59.957 9.55095 61.2215 10.0631 62.5571 10.2423C63.3964 10.3352 64.2084 10.5877 64.9464 10.9854C65.0998 11.087 65.2261 11.2222 65.3151 11.3801C65.4041 11.5379 65.4532 11.7139 65.4584 11.8937C65.467 12.0758 65.4131 12.2556 65.305 12.405C65.197 12.5543 65.0409 12.6649 64.8611 12.7194C64.2859 13.0201 63.6367 13.1629 62.9838 13.1323L59.1438 12.802C58.4612 12.802 57.8638 13.7103 57.8638 14.3708V14.7011C57.8638 15.3617 58.4612 15.6094 59.1438 15.6094L61.9598 15.9397C62.3246 16.0115 62.6972 16.0392 63.0691 16.0223C64.0981 16.0634 65.1222 15.8652 66.0557 15.4443C66.8339 15.1629 67.494 14.6403 67.933 13.958C68.3616 13.348 68.5987 12.6311 68.6157 11.8937C68.6308 11.2529 68.4529 10.6218 68.1037 10.0771C67.6514 9.51181 67.0663 9.05892 66.3971 8.75598ZM75.6125 7.84769C76.6233 7.99949 77.6027 8.30609 78.5138 8.75598C79.1831 9.05892 79.7681 9.51181 80.2204 10.0771C80.5696 10.6218 80.7475 11.2529 80.7324 11.8937C80.7154 12.6311 80.4784 13.348 80.0498 13.958C79.5899 14.6224 78.9365 15.1397 78.1725 15.4443C77.239 15.8652 76.2148 16.0634 75.1858 16.0223C74.814 16.0392 74.4413 16.0115 74.0765 15.9397L71.2606 15.6094C70.5779 15.6094 69.9806 15.3617 69.9806 14.7011V14.3708C69.9806 13.7103 70.5779 12.802 71.2606 12.802L75.1005 13.1323C75.7535 13.1629 76.4027 13.0201 76.9778 12.7194C77.1576 12.6649 77.3137 12.5543 77.4218 12.405C77.5298 12.2556 77.5838 12.0758 77.5751 11.8937C77.5699 11.7139 77.5208 11.5379 77.4318 11.3801C77.3428 11.2222 77.2165 11.087 77.0631 10.9854C76.3251 10.5877 75.5131 10.3352 74.6738 10.2423C73.3382 10.0631 72.0738 9.55095 71.0046 8.75598C70.3191 8.19453 69.8899 7.3943 69.8101 6.52874C69.7302 5.66318 70.0061 4.80204 70.5779 4.13196C71.1037 3.5542 71.7822 3.126 72.5405 2.89339C73.3375 2.62942 74.1729 2.49005 75.0152 2.48053H75.2712L78.6845 2.81081C79.0212 2.81917 79.3418 2.95235 79.58 3.18284C79.8182 3.41333 79.9558 3.72353 79.9644 4.04939V4.29711C79.9558 4.62296 79.8182 4.93316 79.58 5.16366C79.3418 5.39415 79.0212 5.52732 78.6845 5.53568L75.3565 5.20539H75.0152C74.4573 5.20929 73.906 5.32161 73.3939 5.53568C73.2491 5.60573 73.1257 5.71113 73.0359 5.84146C72.9461 5.9718 72.893 6.12255 72.8819 6.27883C72.887 6.4824 72.9458 6.68134 73.0525 6.85683C73.0525 7.02197 73.3085 7.18711 73.7352 7.35226C74.3446 7.57082 74.9728 7.73662 75.6125 7.84769Z",
                fill: "white"
            })
        ]
    });
};
var IconIsChecked = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                transform: "translate(0 0.442871)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "0.442871",
                width: "22",
                height: "22",
                rx: "4",
                fill: "#EE3244"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1290_199610)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.442871)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.5271 8.19189H14.7946C14.7355 8.19189 14.6788 8.21416 14.637 8.25388L9.88624 12.7732L7.36244 10.3734C7.32085 10.3336 7.26438 10.3111 7.20539 10.3109H5.47237C5.34935 10.3111 5.24979 10.4061 5.25 10.5232C5.25 10.5793 5.2736 10.6331 5.31533 10.6727L9.29537 14.4588C9.45854 14.614 9.67239 14.6919 9.88567 14.6919H9.89903C10.1084 14.6887 10.3167 14.6108 10.4765 14.4588L16.6847 8.55371C16.7717 8.47101 16.7718 8.33684 16.6848 8.25404C16.643 8.21421 16.5863 8.19189 16.5271 8.19189H16.5271Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1290_199610",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.442871)"
                    })
                })
            })
        ]
    });
};
var IconIsNotChecked = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                transform: "translate(0 0.442871)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.942871",
                width: "21",
                height: "21",
                rx: "3.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.942871",
                width: "21",
                height: "21",
                rx: "3.5",
                stroke: "#CCCCCC"
            })
        ]
    });
};
var ImageIconEmpty = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? "32" : _width, _height = param.height, height = _height === void 0 ? "32" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1290_271577)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "32",
                        height: "32",
                        transform: "translate(0.5 0.00341797)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M25.8327 2.66943H7.16602C6.10515 2.66943 5.08773 3.09086 4.33759 3.84101C3.58744 4.59115 3.16602 5.60857 3.16602 6.66943V25.3361C3.16602 26.397 3.58744 27.4144 4.33759 28.1645C5.08773 28.9147 6.10515 29.3361 7.16602 29.3361H25.8327C26.052 29.333 26.2706 29.3107 26.486 29.2694L26.886 29.1761H26.9794H27.046L27.5394 28.9894L27.7127 28.8961C27.846 28.8161 27.9927 28.7494 28.126 28.6561C28.3041 28.5251 28.4733 28.3826 28.6327 28.2294L28.726 28.1094C28.8569 27.9768 28.9773 27.8341 29.086 27.6828L29.206 27.5094C29.2991 27.361 29.3794 27.2049 29.446 27.0428C29.4826 26.9788 29.5138 26.9119 29.5394 26.8428C29.606 26.6828 29.646 26.5094 29.6993 26.3361V26.1361C29.7749 25.8756 29.8197 25.6071 29.8327 25.3361V6.66943C29.8327 5.60857 29.4113 4.59115 28.6611 3.84101C27.911 3.09086 26.8935 2.66943 25.8327 2.66943ZM7.16602 26.6694C6.81239 26.6694 6.47326 26.529 6.22321 26.2789C5.97316 26.0289 5.83268 25.6897 5.83268 25.3361V19.5894L10.2193 15.1894C10.3433 15.0645 10.4908 14.9653 10.6532 14.8976C10.8157 14.8299 10.99 14.795 11.166 14.795C11.342 14.795 11.5163 14.8299 11.6788 14.8976C11.8413 14.9653 11.9887 15.0645 12.1127 15.1894L23.5793 26.6694H7.16602ZM27.166 25.3361C27.1648 25.5005 27.1331 25.6632 27.0727 25.8161C27.0422 25.8811 27.0065 25.9435 26.966 26.0028C26.9303 26.0592 26.8902 26.1127 26.846 26.1628L19.7127 19.0294L20.886 17.8561C21.01 17.7311 21.1574 17.6319 21.3199 17.5642C21.4824 17.4966 21.6567 17.4617 21.8327 17.4617C22.0087 17.4617 22.183 17.4966 22.3455 17.5642C22.5079 17.6319 22.6554 17.7311 22.7793 17.8561L27.166 22.2561V25.3361ZM27.166 18.4828L24.6594 16.0028C23.8963 15.2788 22.8845 14.8751 21.8327 14.8751C20.7808 14.8751 19.7691 15.2788 19.006 16.0028L17.8327 17.1761L13.9927 13.3361C13.2296 12.6121 12.2179 12.2085 11.166 12.2085C10.1142 12.2085 9.10239 12.6121 8.33935 13.3361L5.83268 15.8161V6.66943C5.83268 6.31581 5.97316 5.97667 6.22321 5.72662C6.47326 5.47658 6.81239 5.3361 7.16602 5.3361H25.8327C26.1863 5.3361 26.5254 5.47658 26.7755 5.72662C27.0255 5.97667 27.166 6.31581 27.166 6.66943V18.4828Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1290_271577",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.5 0.00341797)"
                    })
                })
            })
        ]
    });
};
var AddCircleIconV2 = function(param) {
    var className = param.className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#ffffff" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ _jsx("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19 11H13V5C13 4.73478 12.8946 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5V11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H11V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z",
            fill: fillColor
        })
    });
};
var WarningIconIntroBrandGift = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.3997 34.9992L29.1997 6.99924C27.5997 4.19924 23.7997 3.19924 20.9997 4.79924C19.9997 5.39924 19.1997 6.19924 18.7997 6.99924L2.59966 34.9992C0.999657 37.7992 1.99966 41.5992 4.79966 43.1992C5.79966 43.7992 6.79966 43.9992 7.79966 43.9992H39.9997C43.3997 43.9992 45.9997 41.1992 45.9997 37.9992C46.1997 36.7992 45.7997 35.7992 45.3997 34.9992ZM23.9997 35.9992C22.7997 35.9992 21.9997 35.1992 21.9997 33.9992C21.9997 32.7992 22.7997 31.9992 23.9997 31.9992C25.1997 31.9992 25.9997 32.7992 25.9997 33.9992C25.9997 35.1992 25.1997 35.9992 23.9997 35.9992ZM25.9997 25.9992C25.9997 27.1992 25.1997 27.9992 23.9997 27.9992C22.7997 27.9992 21.9997 27.1992 21.9997 25.9992V17.9992C21.9997 16.7992 22.7997 15.9992 23.9997 15.9992C25.1997 15.9992 25.9997 16.7992 25.9997 17.9992V25.9992Z",
            fill: "#FF8F1F"
        })
    });
};
var WarningIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_3922_256617)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.133 11.6649L9.73302 2.33162C9.19968 1.39828 7.93302 1.06495 6.99968 1.59828C6.66635 1.79828 6.39968 2.06495 6.26635 2.33162L0.866349 11.6649C0.333015 12.5983 0.666349 13.8649 1.59968 14.3983C1.93302 14.5983 2.26635 14.6649 2.59968 14.6649H13.333C14.4664 14.6649 15.333 13.7316 15.333 12.6649C15.3997 12.2649 15.2664 11.9316 15.133 11.6649ZM7.99968 11.9983C7.59968 11.9983 7.33302 11.7316 7.33302 11.3316C7.33302 10.9316 7.59968 10.6649 7.99968 10.6649C8.39968 10.6649 8.66635 10.9316 8.66635 11.3316C8.66635 11.7316 8.39968 11.9983 7.99968 11.9983ZM8.66635 8.66495C8.66635 9.06495 8.39968 9.33162 7.99968 9.33162C7.59968 9.33162 7.33302 9.06495 7.33302 8.66495V5.99828C7.33302 5.59828 7.59968 5.33162 7.99968 5.33162C8.39968 5.33162 8.66635 5.59828 8.66635 5.99828V8.66495Z",
                        fill: "#FF6010"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3922_256617",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var IndeterminateCheckboxIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "22",
                height: "22",
                transform: "translate(0 0.5)",
                fill: "white",
                "fill-opacity": "0.01"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "1",
                width: "21",
                height: "21",
                rx: "3.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "5.5",
                y: "6",
                width: "11",
                height: "11",
                rx: "2",
                fill: "#EE3244"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "1",
                width: "21",
                height: "21",
                rx: "3.5",
                stroke: "#CCCCCC"
            })
        ]
    });
};
var EmptyBlocksInCombined = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M28.4996 10.0546H22.4463V4.0013C22.4463 3.64768 22.3058 3.30854 22.0557 3.05849C21.8057 2.80844 21.4665 2.66797 21.1129 2.66797H4.49959C4.14597 2.66797 3.80683 2.80844 3.55678 3.05849C3.30674 3.30854 3.16626 3.64768 3.16626 4.0013V20.6146C3.16626 20.9683 3.30674 21.3074 3.55678 21.5574C3.80683 21.8075 4.14597 21.948 4.49959 21.948H10.5529V28.0013C10.5529 28.3549 10.6934 28.6941 10.9435 28.9441C11.1935 29.1942 11.5326 29.3346 11.8863 29.3346H28.4996C28.8532 29.3346 29.1924 29.1942 29.4424 28.9441C29.6925 28.6941 29.8329 28.3549 29.8329 28.0013V11.388C29.8329 11.0343 29.6925 10.6952 29.4424 10.4452C29.1924 10.1951 28.8532 10.0546 28.4996 10.0546ZM27.1663 26.668H13.2196V20.6146C13.2196 20.261 13.0791 19.9219 12.8291 19.6718C12.579 19.4218 12.2399 19.2813 11.8863 19.2813H5.83293V5.33464H19.7796V11.388C19.7796 11.7416 19.9201 12.0807 20.1701 12.3308C20.4202 12.5808 20.7593 12.7213 21.1129 12.7213H27.1663V26.668Z",
            fill: "#333333"
        })
    });
};
var TemplateIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1674_46315)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0.5 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M6.91634 15.1654C6.73504 15.1654 6.55781 15.2191 6.40707 15.3198C6.25632 15.4206 6.13883 15.5637 6.06945 15.7312C6.00007 15.8987 5.98192 16.083 6.01729 16.2609C6.05266 16.4387 6.13996 16.602 6.26816 16.7302C6.39636 16.8584 6.55969 16.9457 6.73751 16.9811C6.91532 17.0165 7.09964 16.9983 7.26713 16.9289C7.43463 16.8595 7.5778 16.742 7.67852 16.5913C7.77925 16.4406 7.83301 16.2633 7.83301 16.082C7.83301 15.8389 7.73643 15.6058 7.56452 15.4338C7.39261 15.2619 7.15946 15.1654 6.91634 15.1654ZM17.9713 11.4987L19.0988 10.3712C19.6138 9.85557 19.9031 9.15662 19.9031 8.42786C19.9031 7.69911 19.6138 7.00016 19.0988 6.48453L16.5047 3.89953C15.989 3.38455 15.2901 3.09528 14.5613 3.09528C13.8326 3.09528 13.1336 3.38455 12.618 3.89953L11.4997 5.02703C11.4853 4.30726 11.1892 3.62184 10.675 3.11795C10.1609 2.61406 9.46959 2.33189 8.74967 2.33203H5.08301C4.35366 2.33203 3.65419 2.62176 3.13846 3.13749C2.62274 3.65321 2.33301 4.35269 2.33301 5.08203V17.9154C2.33301 18.6447 2.62274 19.3442 3.13846 19.8599C3.65419 20.3756 4.35366 20.6654 5.08301 20.6654H17.9163C18.6457 20.6654 19.3452 20.3756 19.8609 19.8599C20.3766 19.3442 20.6663 18.6447 20.6663 17.9154V14.2487C20.6665 13.5288 20.3843 12.8375 19.8804 12.3233C19.3765 11.8092 18.6911 11.5131 17.9713 11.4987ZM9.66634 17.9154C9.66634 18.1585 9.56976 18.3916 9.39786 18.5635C9.22595 18.7355 8.99279 18.832 8.74967 18.832H5.08301C4.83989 18.832 4.60674 18.7355 4.43483 18.5635C4.26292 18.3916 4.16634 18.1585 4.16634 17.9154V5.08203C4.16634 4.83892 4.26292 4.60576 4.43483 4.43385C4.60674 4.26194 4.83989 4.16536 5.08301 4.16536H8.74967C8.99279 4.16536 9.22595 4.26194 9.39786 4.43385C9.56976 4.60576 9.66634 4.83892 9.66634 5.08203V17.9154ZM11.4997 7.61203L13.9197 5.19203C14.0914 5.0213 14.3238 4.92547 14.5659 4.92547C14.8081 4.92547 15.0404 5.0213 15.2122 5.19203L17.8063 7.83203C17.9771 8.00378 18.0729 8.23611 18.0729 8.47828C18.0729 8.72045 17.9771 8.95278 17.8063 9.12453L15.1663 11.7645L11.4997 15.3854V7.61203ZM18.833 17.9154C18.833 18.1585 18.7364 18.3916 18.5645 18.5635C18.3926 18.7355 18.1595 18.832 17.9163 18.832H11.3347C11.4287 18.5604 11.4812 18.276 11.4905 17.9887L16.1472 13.332H17.9163C18.1595 13.332 18.3926 13.4286 18.5645 13.6005C18.7364 13.7724 18.833 14.0056 18.833 14.2487V17.9154Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1674_46315",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
var AddIconTemplate = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ _jsxs("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ _jsxs("g", {
                opacity: "0.4",
                "clip-path": "url(#clip0_2229_274748)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        transform: "translate(0 0.00390625)",
                        fill: "white",
                        "fill-opacity": "0.01"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.99959 18.9616C5.05793 18.9616 1.04126 14.9449 1.04126 10.0033C1.04126 5.06159 5.05793 1.04492 9.99959 1.04492C14.9413 1.04492 18.9579 5.06159 18.9579 10.0033C18.9579 14.9449 14.9413 18.9616 9.99959 18.9616ZM9.99959 2.29492C5.74959 2.29492 2.29126 5.75326 2.29126 10.0033C2.29126 14.2533 5.74959 17.7116 9.99959 17.7116C14.2496 17.7116 17.7079 14.2533 17.7079 10.0033C17.7079 5.75326 14.2496 2.29492 9.99959 2.29492ZM6.66626 10.6283C6.32459 10.6283 6.04126 10.3449 6.04126 10.0033C6.04126 9.66159 6.32459 9.37825 6.66626 9.37825H9.37459V6.66992C9.37459 6.32826 9.65793 6.04492 9.99959 6.04492C10.3413 6.04492 10.6246 6.32826 10.6246 6.66992V9.37825H13.3329C13.6746 9.37825 13.9579 9.66159 13.9579 10.0033C13.9579 10.3449 13.6746 10.6283 13.3329 10.6283H10.6246V13.3366C10.6246 13.6783 10.3413 13.9616 9.99959 13.9616C9.65793 13.9616 9.37459 13.6783 9.37459 13.3366V10.6283H6.66626Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_2229_274748",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00390625)"
                    })
                })
            })
        ]
    });
};
var AddIconTemplateV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "white" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_2229_273288)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: width,
                        height: height,
                        transform: "translate(0 0.00390625)",
                        fill: "white",
                        "fill-opacity": "0.01",
                        className: className
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.99959 18.9616C5.05793 18.9616 1.04126 14.9449 1.04126 10.0033C1.04126 5.06159 5.05793 1.04492 9.99959 1.04492C14.9413 1.04492 18.9579 5.06159 18.9579 10.0033C18.9579 14.9449 14.9413 18.9616 9.99959 18.9616ZM9.99959 2.29492C5.74959 2.29492 2.29126 5.75326 2.29126 10.0033C2.29126 14.2533 5.74959 17.7116 9.99959 17.7116C14.2496 17.7116 17.7079 14.2533 17.7079 10.0033C17.7079 5.75326 14.2496 2.29492 9.99959 2.29492ZM6.66626 10.6283C6.32459 10.6283 6.04126 10.3449 6.04126 10.0033C6.04126 9.66159 6.32459 9.37825 6.66626 9.37825H9.37459V6.66992C9.37459 6.32826 9.65793 6.04492 9.99959 6.04492C10.3413 6.04492 10.6246 6.32826 10.6246 6.66992V9.37825H13.3329C13.6746 9.37825 13.9579 9.66159 13.9579 10.0033C13.9579 10.3449 13.6746 10.6283 13.3329 10.6283H10.6246V13.3366C10.6246 13.6783 10.3413 13.9616 9.99959 13.9616C9.65793 13.9616 9.37459 13.6783 9.37459 13.3366V10.6283H6.66626Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2229_273288",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.00390625)"
                    })
                })
            })
        ]
    });
};
var AdvanceSettingIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 18 : _height, _width = param.width, width = _width === void 0 ? 18 : _width, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2389_349553)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        transform: "translate(0 0.500977)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.88834 6.3439C4.24251 6.3439 4.52584 6.06056 4.52584 5.7064V2.41265C4.52584 2.05848 4.24251 1.77515 3.88834 1.77515C3.53417 1.77515 3.25084 2.05848 3.25084 2.41265V5.7064C3.25084 6.05348 3.53417 6.3439 3.88834 6.3439ZM13.7484 5.7064C13.7484 6.06056 13.465 6.3439 13.1109 6.3439C12.7638 6.3439 12.4734 6.05348 12.4734 5.7064V2.41265C12.4734 2.05848 12.7567 1.77515 13.1109 1.77515C13.465 1.77515 13.7484 2.05848 13.7484 2.41265V5.7064ZM7.8621 12.294C7.8621 11.9399 8.14543 11.6565 8.4996 11.6565C8.85376 11.6565 9.1371 11.947 9.1371 12.294V15.5878C9.1371 15.9419 8.85376 16.2253 8.4996 16.2253C8.14543 16.2253 7.8621 15.9419 7.8621 15.5878V12.294ZM2.57085 7.70398H5.20585C5.55293 7.70398 5.84335 7.98731 5.84335 8.34148C5.84335 8.69565 5.56002 8.97898 5.20585 8.97898H4.52585V15.5877C4.52585 15.9419 4.24252 16.2252 3.88835 16.2252C3.53418 16.2252 3.25085 15.9419 3.25085 15.5877V8.97898H2.57085C2.21668 8.97898 1.93335 8.69565 1.93335 8.34148C1.93335 7.98731 2.21668 7.70398 2.57085 7.70398ZM14.4284 7.70398H11.7934C11.4392 7.70398 11.1559 7.98731 11.1559 8.34148C11.1559 8.69565 11.4392 8.97898 11.7934 8.97898H12.4734V15.5877C12.4734 15.9419 12.7567 16.2252 13.1109 16.2252C13.465 16.2252 13.7484 15.9419 13.7484 15.5877V8.97898H14.4284C14.7825 8.97898 15.0659 8.69565 15.0659 8.34148C15.0659 7.98731 14.7825 7.70398 14.4284 7.70398ZM9.13711 9.0214H9.81711C10.1713 9.0214 10.4546 9.30473 10.4546 9.6589C10.4546 10.0131 10.1713 10.2964 9.81711 10.2964H7.18211C6.82794 10.2964 6.54461 10.0131 6.54461 9.6589C6.54461 9.30473 6.82794 9.0214 7.18211 9.0214H7.86211V2.41265C7.86211 2.05848 8.14544 1.77515 8.49961 1.77515C8.85377 1.77515 9.13711 2.05848 9.13711 2.41265V9.0214Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2389_349553",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        fill: "white",
                        transform: "translate(0 0.500977)"
                    })
                })
            })
        ]
    });
};
var ArrowIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 22 : _width, _height = param.height, height = _height === void 0 ? 22 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#CCCCCC" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2389_349589)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.000976562)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.597 10.3513L9.71032 6.46463C9.6251 6.37871 9.52372 6.31052 9.41201 6.26398C9.30031 6.21744 9.18049 6.19348 9.05948 6.19348C8.93847 6.19348 8.81866 6.21744 8.70695 6.26398C8.59525 6.31052 8.49387 6.37871 8.40865 6.46463C8.23792 6.63638 8.14209 6.86871 8.14209 7.11088C8.14209 7.35305 8.23792 7.58538 8.40865 7.75713L11.6536 11.0021L8.40865 14.2471C8.23792 14.4189 8.14209 14.6512 8.14209 14.8934C8.14209 15.1356 8.23792 15.3679 8.40865 15.5396C8.4943 15.6246 8.59588 15.6918 8.70757 15.7374C8.81925 15.783 8.93884 15.8062 9.05948 15.8055C9.18012 15.8062 9.29971 15.783 9.4114 15.7374C9.52308 15.6918 9.62466 15.6246 9.71032 15.5396L13.597 11.653C13.6829 11.5677 13.7511 11.4664 13.7976 11.3547C13.8442 11.243 13.8681 11.1231 13.8681 11.0021C13.8681 10.8811 13.8442 10.7613 13.7976 10.6496C13.7511 10.5379 13.6829 10.4365 13.597 10.3513Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2389_349589",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.000976562)"
                    })
                })
            })
        ]
    });
};
var InformationIconCombined = function(param) {
    var _width = param.width, width = _width === void 0 ? 15 : _width, _height = param.height, height = _height === void 0 ? 15 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#1890FF" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2389_393716)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.49976 1.24915C6.26363 1.24915 5.05525 1.6157 4.02744 2.30246C2.99964 2.98922 2.19856 3.96534 1.72551 5.10737C1.25246 6.24941 1.12869 7.50608 1.36985 8.71846C1.61101 9.93084 2.20626 11.0445 3.08034 11.9186C3.95442 12.7926 5.06806 13.3879 6.28044 13.6291C7.49283 13.8702 8.74949 13.7464 9.89153 13.2734C11.0336 12.8003 12.0097 11.9993 12.6964 10.9715C13.3832 9.94365 13.7498 8.73528 13.7498 7.49915C13.7498 6.67838 13.5881 5.86566 13.274 5.10737C12.9599 4.34909 12.4995 3.66009 11.9192 3.07973C11.3388 2.49936 10.6498 2.03899 9.89153 1.7249C9.13325 1.41081 8.32052 1.24915 7.49976 1.24915ZM8.12476 9.68665C8.12476 9.85241 8.05891 10.0114 7.9417 10.1286C7.82449 10.2458 7.66552 10.3116 7.49976 10.3116C7.334 10.3116 7.17503 10.2458 7.05782 10.1286C6.94061 10.0114 6.87476 9.85241 6.87476 9.68665V7.81165C6.87476 7.64588 6.94061 7.48691 7.05782 7.3697C7.17503 7.25249 7.334 7.18665 7.49976 7.18665C7.66552 7.18665 7.82449 7.25249 7.9417 7.3697C8.05891 7.48691 8.12476 7.64588 8.12476 7.81165V9.68665ZM7.49976 6.24915C7.34524 6.24915 7.1942 6.20333 7.06572 6.11748C6.93724 6.03164 6.83711 5.90962 6.77798 5.76687C6.71885 5.62411 6.70338 5.46703 6.73352 5.31548C6.76367 5.16393 6.83807 5.02473 6.94733 4.91547C7.05659 4.80621 7.1958 4.7318 7.34734 4.70166C7.49889 4.67151 7.65598 4.68698 7.79873 4.74611C7.94148 4.80525 8.0635 4.90538 8.14934 5.03386C8.23519 5.16233 8.28101 5.31338 8.28101 5.4679C8.28101 5.6751 8.1987 5.87381 8.05219 6.02032C7.90567 6.16684 7.70696 6.24915 7.49976 6.24915Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2389_393716",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var IconImage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _height = param.height, height = _height === void 0 ? 22 : _height, _width = param.width, width = _width === void 0 ? 22 : _width, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2389_49330)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17.4195 1.83447H4.58618C3.85684 1.83447 3.15736 2.1242 2.64164 2.63993C2.12591 3.15565 1.83618 3.85513 1.83618 4.58447V17.4178C1.83618 18.1472 2.12591 18.8466 2.64164 19.3623C3.15736 19.8781 3.85684 20.1678 4.58618 20.1678H17.4195C17.5703 20.1657 17.7206 20.1504 17.8687 20.122L18.1437 20.0578H18.2078H18.2537L18.5928 19.9295L18.712 19.8653C18.8037 19.8103 18.9045 19.7645 18.9962 19.7003C19.1186 19.6103 19.2349 19.5123 19.3445 19.407L19.4087 19.3245C19.4987 19.2333 19.5814 19.1352 19.6562 19.0311L19.7387 18.912C19.8027 18.8099 19.8579 18.7026 19.9037 18.5911C19.9288 18.5472 19.9503 18.5012 19.9678 18.4536C20.0137 18.3436 20.0412 18.2245 20.0778 18.1053V17.9678C20.1298 17.7887 20.1606 17.6041 20.1695 17.4178V4.58447C20.1695 3.85513 19.8798 3.15565 19.3641 2.63993C18.8483 2.1242 18.1489 1.83447 17.4195 1.83447ZM4.58618 18.3345C4.34307 18.3345 4.10991 18.2379 3.938 18.066C3.76609 17.8941 3.66951 17.6609 3.66951 17.4178V13.467L6.68535 10.442C6.77056 10.3561 6.87195 10.2879 6.98365 10.2413C7.09536 10.1948 7.21517 10.1708 7.33618 10.1708C7.45719 10.1708 7.57701 10.1948 7.68871 10.2413C7.80041 10.2879 7.9018 10.3561 7.98701 10.442L15.8703 18.3345H4.58618ZM18.3362 17.4178C18.3353 17.5308 18.3136 17.6427 18.272 17.7478C18.2511 17.7925 18.2265 17.8354 18.1987 17.8761C18.1742 17.9149 18.1466 17.9517 18.1162 17.9861L13.212 13.082L14.0187 12.2753C14.1039 12.1894 14.2053 12.1212 14.317 12.0747C14.4287 12.0281 14.5485 12.0042 14.6695 12.0042C14.7905 12.0042 14.9103 12.0281 15.022 12.0747C15.1337 12.1212 15.2351 12.1894 15.3203 12.2753L18.3362 15.3003V17.4178ZM18.3362 12.7061L16.6128 11.0011C16.0883 10.5034 15.3927 10.2259 14.6695 10.2259C13.9464 10.2259 13.2508 10.5034 12.7262 11.0011L11.9195 11.8078L9.27951 9.16781C8.75493 8.67005 8.05934 8.39256 7.33618 8.39256C6.61302 8.39256 5.91744 8.67005 5.39285 9.16781L3.66951 10.8728V4.58447C3.66951 4.34136 3.76609 4.1082 3.938 3.93629C4.10991 3.76438 4.34307 3.66781 4.58618 3.66781H17.4195C17.6626 3.66781 17.8958 3.76438 18.0677 3.93629C18.2396 4.1082 18.3362 4.34136 18.3362 4.58447V12.7061Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2389_49330",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ArrowCenter = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2389_314827)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "32",
                        height: "32",
                        transform: "translate(0.499878)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.8865 17.7198L5.83317 24.7865V22.6665C5.83317 22.3129 5.69269 21.9737 5.44265 21.7237C5.1926 21.4736 4.85346 21.3332 4.49984 21.3332C4.14622 21.3332 3.80708 21.4736 3.55703 21.7237C3.30698 21.9737 3.1665 22.3129 3.1665 22.6665V27.9998C3.16861 28.1741 3.20485 28.3462 3.27317 28.5065C3.40847 28.8323 3.66737 29.0912 3.99317 29.2265C4.15347 29.2948 4.3256 29.3311 4.49984 29.3332H9.83317C10.1868 29.3332 10.5259 29.1927 10.776 28.9426C11.026 28.6926 11.1665 28.3535 11.1665 27.9998C11.1665 27.6462 11.026 27.3071 10.776 27.057C10.5259 26.807 10.1868 26.6665 9.83317 26.6665H7.71317L14.7798 19.6132C15.0309 19.3621 15.172 19.0216 15.172 18.6665C15.172 18.3114 15.0309 17.9709 14.7798 17.7198C14.5288 17.4688 14.1882 17.3277 13.8332 17.3277C13.4781 17.3277 13.1376 17.4688 12.8865 17.7198ZM7.71317 5.33317H9.83317C10.1868 5.33317 10.5259 5.19269 10.776 4.94265C11.026 4.6926 11.1665 4.35346 11.1665 3.99984C11.1665 3.64622 11.026 3.30708 10.776 3.05703C10.5259 2.80698 10.1868 2.6665 9.83317 2.6665H4.49984C4.3256 2.66861 4.15347 2.70485 3.99317 2.77317C3.66737 2.90847 3.40847 3.16737 3.27317 3.49317C3.20485 3.65347 3.16861 3.8256 3.1665 3.99984V9.33317C3.1665 9.68679 3.30698 10.0259 3.55703 10.276C3.80708 10.526 4.14622 10.6665 4.49984 10.6665C4.85346 10.6665 5.1926 10.526 5.44265 10.276C5.69269 10.0259 5.83317 9.68679 5.83317 9.33317V7.21317L12.8865 14.2798C13.0105 14.4048 13.1579 14.504 13.3204 14.5717C13.4829 14.6394 13.6572 14.6742 13.8332 14.6742C14.0092 14.6742 14.1835 14.6394 14.3459 14.5717C14.5084 14.504 14.6559 14.4048 14.7798 14.2798C14.9048 14.1559 15.004 14.0084 15.0717 13.8459C15.1394 13.6835 15.1742 13.5092 15.1742 13.3332C15.1742 13.1572 15.1394 12.9829 15.0717 12.8204C15.004 12.6579 14.9048 12.5105 14.7798 12.3865L7.71317 5.33317ZM28.4998 21.3332C28.1462 21.3332 27.8071 21.4736 27.557 21.7237C27.307 21.9737 27.1665 22.3129 27.1665 22.6665V24.7865L20.1132 17.7198C19.8621 17.4688 19.5216 17.3277 19.1665 17.3277C18.8114 17.3277 18.4709 17.4688 18.2198 17.7198C17.9688 17.9709 17.8277 18.3114 17.8277 18.6665C17.8277 19.0216 17.9688 19.3621 18.2198 19.6132L25.2865 26.6665H23.1665C22.8129 26.6665 22.4737 26.807 22.2237 27.057C21.9736 27.3071 21.8332 27.6462 21.8332 27.9998C21.8332 28.3535 21.9736 28.6926 22.2237 28.9426C22.4737 29.1927 22.8129 29.3332 23.1665 29.3332H28.4998C28.6741 29.3311 28.8462 29.2948 29.0065 29.2265C29.3323 29.0912 29.5912 28.8323 29.7265 28.5065C29.7948 28.3462 29.8311 28.1741 29.8332 27.9998V22.6665C29.8332 22.3129 29.6927 21.9737 29.4426 21.7237C29.1926 21.4736 28.8535 21.3332 28.4998 21.3332ZM29.7265 3.49317C29.5912 3.16737 29.3323 2.90847 29.0065 2.77317C28.8462 2.70485 28.6741 2.66861 28.4998 2.6665H23.1665C22.8129 2.6665 22.4737 2.80698 22.2237 3.05703C21.9736 3.30708 21.8332 3.64622 21.8332 3.99984C21.8332 4.35346 21.9736 4.6926 22.2237 4.94265C22.4737 5.19269 22.8129 5.33317 23.1665 5.33317H25.2865L18.2198 12.3865C18.0949 12.5105 17.9957 12.6579 17.928 12.8204C17.8603 12.9829 17.8254 13.1572 17.8254 13.3332C17.8254 13.5092 17.8603 13.6835 17.928 13.8459C17.9957 14.0084 18.0949 14.1559 18.2198 14.2798C18.3438 14.4048 18.4913 14.504 18.6537 14.5717C18.8162 14.6394 18.9905 14.6742 19.1665 14.6742C19.3425 14.6742 19.5168 14.6394 19.6793 14.5717C19.8418 14.504 19.9892 14.4048 20.1132 14.2798L27.1665 7.21317V9.33317C27.1665 9.68679 27.307 10.0259 27.557 10.276C27.8071 10.526 28.1462 10.6665 28.4998 10.6665C28.8535 10.6665 29.1926 10.526 29.4426 10.276C29.6927 10.0259 29.8332 9.68679 29.8332 9.33317V3.99984C29.8311 3.8256 29.7948 3.65347 29.7265 3.49317Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2389_314827",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.499878)"
                    })
                })
            })
        ]
    });
};
var CrownIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1.1665",
                y: "0.5",
                width: "19",
                height: "19",
                rx: "9.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_37788_690517)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "10",
                        height: "10",
                        transform: "translate(5.6665 5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip1_37788_690517)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14.7687 12.6924H6.75586V14.5514H14.7687V12.6924Z",
                                fill: "#FA8C00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M6.64941 11.2183L10.6775 5.04395L14.7786 11.2183H6.64941Z",
                                fill: "#FF8C00"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M14.7192 12.2172L15.6567 6.76465L7.68213 12.0017L14.7192 12.2172Z",
                                fill: "#EDA500"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M6.6196 12.1848L5.72021 6.73828L13.1686 12.1848H6.6196Z",
                                fill: "#FEC400"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1.1665",
                y: "0.5",
                width: "19",
                height: "19",
                rx: "9.5",
                stroke: "url(#paint0_linear_37788_690517)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_37788_690517",
                        x1: "4.49976",
                        y1: "1.96484",
                        x2: "18.4998",
                        y2: "16.4648",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#FEC400"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF8C00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_37788_690517",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            fill: "white",
                            transform: "translate(5.6665 5)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_37788_690517",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            fill: "white",
                            transform: "translate(5.6665 5)"
                        })
                    })
                ]
            })
        ]
    });
};
var CrownIconNoColor = function(param) {
    var _width = param.width, width = _width === void 0 ? "18" : _width, _height = param.height, height = _height === void 0 ? "18" : _height, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_37801_266307)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        transform: "translate(0.25 0.5)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip1_37801_266307)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M15.7243 13.5762H2.10254V16.7364H15.7243V13.5762Z",
                                fill: "#FFF0D4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.92188 11.0706L8.76969 0.574219L15.7414 11.0706H1.92188Z",
                                fill: "#FFE0A9"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15.6403 12.7693L17.234 3.5L3.67725 12.403L15.6403 12.7693Z",
                                fill: "#FFF0D4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.87075 12.7122L0.341797 3.45312L13.0041 12.7122H1.87075Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_37801_266307",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "17",
                            height: "17",
                            fill: "white",
                            transform: "translate(0.25 0.5)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_37801_266307",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "17",
                            height: "17",
                            fill: "white",
                            transform: "translate(0.25 0.5)"
                        })
                    })
                ]
            })
        ]
    });
};
var XIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_506_426572)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        y: "0.5",
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.4138 12.5041L17.7138 8.21409C17.9021 8.02579 18.0079 7.77039 18.0079 7.50409C18.0079 7.23779 17.9021 6.9824 17.7138 6.79409C17.5255 6.60579 17.2701 6.5 17.0038 6.5C16.7375 6.5 16.4822 6.60579 16.2938 6.79409L12.0038 11.0941L7.71385 6.79409C7.52554 6.60579 7.27015 6.5 7.00385 6.5C6.73754 6.5 6.48215 6.60579 6.29385 6.79409C6.10554 6.9824 5.99975 7.23779 5.99975 7.50409C5.99975 7.77039 6.10554 8.02579 6.29385 8.21409L10.5938 12.5041L6.29385 16.7941C6.20012 16.8871 6.12572 16.9977 6.07495 17.1195C6.02419 17.2414 5.99805 17.3721 5.99805 17.5041C5.99805 17.6361 6.02419 17.7668 6.07495 17.8887C6.12572 18.0105 6.20012 18.1211 6.29385 18.2141C6.38681 18.3078 6.49741 18.3822 6.61927 18.433C6.74113 18.4838 6.87183 18.5099 7.00385 18.5099C7.13586 18.5099 7.26656 18.4838 7.38842 18.433C7.51028 18.3822 7.62088 18.3078 7.71385 18.2141L12.0038 13.9141L16.2938 18.2141C16.3868 18.3078 16.4974 18.3822 16.6193 18.433C16.7411 18.4838 16.8718 18.5099 17.0038 18.5099C17.1359 18.5099 17.2666 18.4838 17.3884 18.433C17.5103 18.3822 17.6209 18.3078 17.7138 18.2141C17.8076 18.1211 17.882 18.0105 17.9327 17.8887C17.9835 17.7668 18.0096 17.6361 18.0096 17.5041C18.0096 17.3721 17.9835 17.2414 17.9327 17.1195C17.882 16.9977 17.8076 16.8871 17.7138 16.7941L13.4138 12.5041Z",
                        fill: fillColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "1",
                width: "23",
                height: "23",
                rx: "11.5",
                stroke: "#EEEEEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_506_426572",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        y: "0.5",
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var CrownIconV2 = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_345_35535)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "17",
                        height: "17",
                        transform: "translate(0.25 0.5)",
                        fill: "white",
                        "fill-opacity": "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "clip-path": "url(#clip1_345_35535)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M15.7253 13.5703H2.10352V16.7306H15.7253V13.5703Z",
                                fill: "#FFEEEE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.92188 11.0667L8.76969 0.570312L15.7414 11.0667H1.92188Z",
                                fill: "#FFA9A9"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15.6408 12.7615L17.2345 3.49219L3.67773 12.3951L15.6408 12.7615Z",
                                fill: "#FFD4D4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.87075 12.7122L0.341797 3.45312L13.0041 12.7122H1.87075Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_345_35535",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "17",
                            height: "17",
                            fill: "white",
                            transform: "translate(0.25 0.5)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_345_35535",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "17",
                            height: "17",
                            fill: "white",
                            transform: "translate(0.25 0.5)"
                        })
                    })
                ]
            })
        ]
    });
};
var RenameIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#3333333" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.5 2C3.11928 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H19.5C20.8807 22 22 20.8807 22 19.5V15.918C22 15.3657 21.5523 14.918 21 14.918C20.4477 14.918 20 15.3657 20 15.918V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V4.5C4 4.22386 4.22386 4 4.5 4H8.93227C9.48456 4 9.93227 3.55228 9.93227 3C9.93227 2.44772 9.48456 2 8.93227 2H4.5Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.99416 18.0058H11.2342C11.3658 18.0066 11.4962 17.9813 11.6181 17.9316C11.7399 17.8818 11.8507 17.8085 11.9442 17.7158L18.8642 10.7858L21.7042 8.0058C21.7979 7.91284 21.8723 7.80223 21.923 7.68038C21.9738 7.55852 22 7.42781 22 7.2958C22 7.16379 21.9738 7.03308 21.923 6.91122C21.8723 6.78936 21.7979 6.67876 21.7042 6.5858L17.4642 2.2958C17.3712 2.20207 17.2606 2.12768 17.1387 2.07691C17.0169 2.02614 16.8862 2 16.7542 2C16.6221 2 16.4914 2.02614 16.3696 2.07691C16.2477 2.12768 16.1371 2.20207 16.0442 2.2958L13.2242 5.1258L6.28416 12.0558C6.19148 12.1492 6.11815 12.2601 6.06839 12.3819C6.01862 12.5037 5.9934 12.6342 5.99416 12.7658V17.0058C5.99416 17.271 6.09951 17.5254 6.28705 17.7129C6.47459 17.9004 6.72894 18.0058 6.99416 18.0058ZM16.7542 4.4158L19.5842 7.2458L18.1642 8.6658L15.3342 5.8358L16.7542 4.4158ZM7.99416 13.1758L13.9242 7.2458L16.7542 10.0758L10.8242 16.0058H7.99416V13.1758Z",
                fill: fillColor
            })
        ]
    });
};
var FrameIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 17 18",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6278_866050)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: "0.01",
                        d: "M0 0H17V17H0z",
                        transform: "translate(0 .5)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#333",
                        d: "M14.166 11.96V6.038a2.125 2.125 0 10-2.706-2.705H5.54a2.125 2.125 0 10-2.706 2.705v5.922a2.126 2.126 0 102.706 2.706h5.921a2.124 2.124 0 102.706-2.706zm-.708-8.627a.708.708 0 110 1.416.708.708 0 010-1.416zm-9.917 0a.708.708 0 110 1.416.708.708 0 010-1.416zm0 11.333a.709.709 0 110-1.417.709.709 0 010 1.417zm7.92-1.417H5.538a2.125 2.125 0 00-1.29-1.289V6.038A2.125 2.125 0 005.54 4.75h5.921a2.124 2.124 0 001.29 1.29v5.921a2.126 2.126 0 00-1.29 1.29zm1.997 1.417a.709.709 0 110-1.418.709.709 0 010 1.418z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6278_866050",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17V17H0z",
                        transform: "translate(0 .5)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 45297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ EditAltIcon; },
/* harmony export */   "Hy": function() { return /* binding */ ExportIcon; },
/* harmony export */   "IS": function() { return /* binding */ ManagementIcon; },
/* harmony export */   "UH": function() { return /* binding */ LinkAltIcon; },
/* harmony export */   "Zi": function() { return /* binding */ AngelRightIcon; },
/* harmony export */   "aA": function() { return /* binding */ ShareIcon; },
/* harmony export */   "k1": function() { return /* binding */ FilterIcon; },
/* harmony export */   "lo": function() { return /* binding */ CheckCircleIconV2; },
/* harmony export */   "qN": function() { return /* binding */ StarFillIcon; },
/* harmony export */   "r7": function() { return /* binding */ StarIcon; },
/* harmony export */   "tL": function() { return /* binding */ EmptyIcon; },
/* harmony export */   "tO": function() { return /* binding */ CoppyAltIcon; },
/* harmony export */   "xh": function() { return /* binding */ InfoCirclesIcon; }
/* harmony export */ });
/* unused harmony export SwapIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SwapIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ _jsxs("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2 9.97738C2 9.4251 2.44772 8.97738 3 8.97738H21C21.5523 8.97738 22 9.4251 22 9.97738C22 10.5297 21.5523 10.9774 21 10.9774H3C2.44772 10.9774 2 10.5297 2 9.97738Z",
                fill: fillColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.3196 4.29289C15.7101 3.90237 16.3432 3.90237 16.7338 4.29289L21.707 9.26608C22.0975 9.65661 22.0975 10.2898 21.707 10.6803C21.3164 11.0708 20.6833 11.0708 20.2928 10.6803L15.3196 5.70711C14.929 5.31658 14.929 4.68342 15.3196 4.29289Z",
                fill: fillColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22 14.0226C22 14.5749 21.5523 15.0226 21 15.0226L3 15.0226C2.44772 15.0226 2 14.5749 2 14.0226C2 13.4703 2.44772 13.0226 3 13.0226L21 13.0226C21.5523 13.0226 22 13.4703 22 14.0226Z",
                fill: fillColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.68044 19.7071C8.28992 20.0976 7.65675 20.0976 7.26623 19.7071L2.29304 14.7339C1.90251 14.3434 1.90251 13.7102 2.29304 13.3197C2.68356 12.9292 3.31673 12.9292 3.70725 13.3197L8.68044 18.2929C9.07097 18.6834 9.07097 19.3166 8.68044 19.7071Z",
                fill: fillColor
            })
        ]
    });
};
var InfoCirclesIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM13 15.5C13 15.7652 12.8946 16.0196 12.7071 16.2071C12.5196 16.3946 12.2652 16.5 12 16.5C11.7348 16.5 11.4804 16.3946 11.2929 16.2071C11.1054 16.0196 11 15.7652 11 15.5V12.5C11 12.2348 11.1054 11.9804 11.2929 11.7929C11.4804 11.6054 11.7348 11.5 12 11.5C12.2652 11.5 12.5196 11.6054 12.7071 11.7929C12.8946 11.9804 13 12.2348 13 12.5V15.5ZM12 10C11.7528 10 11.5111 9.92669 11.3055 9.78934C11.1 9.65199 10.9398 9.45676 10.8452 9.22835C10.7505 8.99995 10.7258 8.74861 10.774 8.50614C10.8223 8.26366 10.9413 8.04093 11.1161 7.86612C11.2909 7.6913 11.5137 7.57225 11.7561 7.52402C11.9986 7.47579 12.25 7.50054 12.4784 7.59515C12.7068 7.68976 12.902 7.84998 13.0393 8.05554C13.1767 8.2611 13.25 8.50277 13.25 8.75C13.25 9.08152 13.1183 9.39946 12.8839 9.63388C12.6495 9.8683 12.3315 10 12 10Z",
            fill: fillColor
        })
    });
};
var CheckCircleIconV2 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
            fill: fillColor
        })
    });
};
var FilterIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V6.17C1.99986 6.58294 2.08497 6.99147 2.25 7.37V7.43C2.39128 7.75097 2.59139 8.04266 2.84 8.29L9 14.41V21C8.99966 21.1699 9.04264 21.3372 9.12487 21.4859C9.20711 21.6346 9.32589 21.7599 9.47 21.85C9.62914 21.9486 9.81277 22.0006 10 22C10.1565 21.9991 10.3107 21.9614 10.45 21.89L14.45 19.89C14.6149 19.8069 14.7536 19.6798 14.8507 19.5227C14.9478 19.3656 14.9994 19.1847 15 19V14.41L21.12 8.29C21.3686 8.04266 21.5687 7.75097 21.71 7.43V7.37C21.8888 6.99443 21.9876 6.58578 22 6.17V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM13.29 13.29C13.1973 13.3834 13.124 13.4943 13.0742 13.6161C13.0245 13.7379 12.9992 13.8684 13 14V18.38L11 19.38V14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29L5.41 8H18.59L13.29 13.29ZM20 6H4V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V6Z",
            fill: fillColor
        })
    });
};
var EmptyIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.6 10.9C13.7 11 13.8 11 14 11H21C21.6 11 22 10.6 22 10C22 9.8 22 9.7 21.9 9.6L18.4 2.6C18.1 2.1 17.5 1.9 17 2.2C16.9 2.3 16.7 2.4 16.6 2.6L13.1 9.6C12.9 10 13.1 10.6 13.6 10.9ZM17.5 5.2L19.4 9H15.6L17.5 5.2ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2ZM6.5 9C5.1 9 4 7.9 4 6.5C4 5.1 5.1 4 6.5 4C7.9 4 9 5.1 9 6.5C9 7.9 7.9 9 6.5 9ZM10.7 13.3C10.3 12.9 9.7 12.9 9.3 13.3L6.5 16.1L3.7 13.3C3.3 12.9 2.7 12.9 2.3 13.3C1.9 13.7 1.9 14.3 2.3 14.7L5.1 17.5L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.7 22.1 3.3 22.1 3.7 21.7L6.5 18.9L9.3 21.7C9.7 22.1 10.3 22.1 10.7 21.7C11.1 21.3 11.1 20.7 10.7 20.3L7.9 17.5L10.7 14.7C11.1 14.3 11.1 13.7 10.7 13.3ZM21 13H14C13.4 13 13 13.4 13 14V21C13 21.6 13.4 22 14 22H21C21.6 22 22 21.6 22 21V14C22 13.4 21.6 13 21 13ZM20 20H15V15H20V20Z",
            fill: fillColor
        })
    });
};
var StarIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22 9.67002C21.9368 9.48711 21.822 9.32645 21.6693 9.20753C21.5167 9.0886 21.3328 9.01652 21.14 9.00002L15.45 8.17002L12.9 3.00002C12.8181 2.83095 12.6902 2.68837 12.5311 2.5886C12.3719 2.48883 12.1878 2.43591 12 2.43591C11.8121 2.43591 11.6281 2.48883 11.4689 2.5886C11.3097 2.68837 11.1819 2.83095 11.1 3.00002L8.54998 8.16002L2.85998 9.00002C2.6749 9.02633 2.5009 9.10399 2.35773 9.22418C2.21455 9.34438 2.10794 9.5023 2.04998 9.68002C1.99692 9.8537 1.99216 10.0385 2.03621 10.2147C2.08025 10.3909 2.17144 10.5517 2.29998 10.68L6.42998 14.68L5.42998 20.36C5.39428 20.5475 5.41297 20.7413 5.48385 20.9185C5.55473 21.0957 5.67483 21.2489 5.82998 21.36C5.98119 21.4681 6.15955 21.5319 6.34503 21.5443C6.5305 21.5567 6.71575 21.5171 6.87998 21.43L12 18.76L17.1 21.44C17.2403 21.5192 17.3988 21.5606 17.56 21.56C17.7718 21.5608 17.9784 21.4942 18.15 21.37C18.3051 21.2589 18.4252 21.1057 18.4961 20.9285C18.567 20.7513 18.5857 20.5575 18.55 20.37L17.55 14.69L21.68 10.69C21.8244 10.5677 21.9311 10.4069 21.9877 10.2264C22.0444 10.0458 22.0486 9.8529 22 9.67002ZM15.85 13.67C15.7327 13.7835 15.645 13.9239 15.5944 14.079C15.5439 14.2341 15.532 14.3993 15.56 14.56L16.28 18.75L12.52 16.75C12.3753 16.673 12.2139 16.6327 12.05 16.6327C11.8861 16.6327 11.7247 16.673 11.58 16.75L7.81998 18.75L8.53998 14.56C8.56791 14.3993 8.55609 14.2341 8.50554 14.079C8.45499 13.9239 8.36725 13.7835 8.24998 13.67L5.24998 10.67L9.45998 10.06C9.62198 10.0375 9.77598 9.97556 9.90848 9.87967C10.041 9.78379 10.1479 9.65686 10.22 9.51002L12 5.70002L13.88 9.52002C13.952 9.66686 14.059 9.79379 14.1915 9.88968C14.324 9.98556 14.478 10.0475 14.64 10.07L18.85 10.68L15.85 13.67Z",
            fill: fillColor
        })
    });
};
var StarFillIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.9228 2.2245C13.3341 2.43565 13.667 2.78194 13.8699 3.20977L15.8304 7.34209L20.2142 8.00474C21.354 8.17702 22.1437 9.27786 21.9781 10.4635C21.9121 10.9357 21.6984 11.372 21.37 11.705L18.1978 14.9216L18.9467 19.4635C19.1414 20.6443 18.379 21.7658 17.2438 21.9683C16.7918 22.049 16.3268 21.9724 15.9208 21.7504L11.9999 19.606L8.0789 21.7504C7.05945 22.3079 5.79855 21.9002 5.2626 20.8397C5.04918 20.4174 4.97553 19.9337 5.05306 19.4635L5.8019 14.9216L2.62977 11.705C1.80502 10.8687 1.78815 9.49527 2.59208 8.63732C2.91221 8.29568 3.33167 8.07334 3.78554 8.00474L8.16931 7.34209L10.1298 3.20977C10.6395 2.13538 11.89 1.69426 12.9228 2.2245Z",
            fill: fillColor
        })
    });
};
var EditAltIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 17.9999H9.24C9.37161 18.0007 9.50207 17.9755 9.62391 17.9257C9.74574 17.8759 9.85656 17.8026 9.95 17.7099L16.87 10.7799L19.71 7.99994C19.8037 7.90698 19.8781 7.79637 19.9289 7.67452C19.9797 7.55266 20.0058 7.42195 20.0058 7.28994C20.0058 7.15793 19.9797 7.02722 19.9289 6.90536C19.8781 6.7835 19.8037 6.6729 19.71 6.57994L15.47 2.28994C15.377 2.19621 15.2664 2.12182 15.1446 2.07105C15.0227 2.02028 14.892 1.99414 14.76 1.99414C14.628 1.99414 14.4973 2.02028 14.3754 2.07105C14.2536 2.12182 14.143 2.19621 14.05 2.28994L11.23 5.11994L4.29 12.0499C4.19732 12.1434 4.12399 12.2542 4.07423 12.376C4.02446 12.4979 3.99924 12.6283 4 12.7599V16.9999C4 17.2652 4.10536 17.5195 4.29289 17.707C4.48043 17.8946 4.73478 17.9999 5 17.9999ZM14.76 4.40994L17.59 7.23994L16.17 8.65994L13.34 5.82994L14.76 4.40994ZM6 13.1699L11.93 7.23994L14.76 10.0699L8.83 15.9999H6V13.1699ZM21 19.9999H3C2.73478 19.9999 2.48043 20.1053 2.29289 20.2928C2.10536 20.4804 2 20.7347 2 20.9999C2 21.2652 2.10536 21.5195 2.29289 21.707C2.48043 21.8946 2.73478 21.9999 3 21.9999H21C21.2652 21.9999 21.5196 21.8946 21.7071 21.707C21.8946 21.5195 22 21.2652 22 20.9999C22 20.7347 21.8946 20.4804 21.7071 20.2928C21.5196 20.1053 21.2652 19.9999 21 19.9999Z",
            fill: fillColor
        })
    });
};
var CoppyAltIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11H14.38L14.06 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z",
            fill: fillColor
        })
    });
};
var ShareIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.707 11.293L13.707 3.29304C13.5672 3.15318 13.389 3.05794 13.195 3.01935C13.0011 2.98075 12.8 3.00055 12.6173 3.07622C12.4346 3.1519 12.2784 3.28006 12.1685 3.4445C12.0586 3.60894 12 3.80227 12 4.00004V7.54496C9.2683 7.7978 6.72926 9.0609 4.87973 11.0871C3.0302 13.1132 2.00331 15.7567 2 18.5V20C1.99998 20.2077 2.06463 20.4102 2.18495 20.5795C2.30528 20.7488 2.47532 20.8764 2.67147 20.9446C2.86762 21.0128 3.08014 21.0183 3.27954 20.9602C3.47893 20.9022 3.65531 20.7835 3.78418 20.6206C4.76383 19.4556 5.96583 18.4974 7.31997 17.8022C8.6741 17.1069 10.1532 16.6885 11.6709 16.5713C11.7207 16.565 11.8457 16.5552 12 16.5454V20C12 20.1978 12.0586 20.3911 12.1685 20.5556C12.2784 20.72 12.4346 20.8482 12.6173 20.9238C12.8 20.9995 13.0011 21.0193 13.195 20.9807C13.389 20.9421 13.5672 20.8469 13.707 20.707L21.707 12.707C21.7999 12.6142 21.8735 12.504 21.9238 12.3827C21.9741 12.2614 21.9999 12.1313 21.9999 12C21.9999 11.8687 21.9741 11.7387 21.9238 11.6174C21.8735 11.4961 21.7999 11.3859 21.707 11.293ZM14 17.586V15.5C14 15.3687 13.9742 15.2387 13.9239 15.1173C13.8737 14.996 13.8 14.8857 13.7072 14.7929C13.6143 14.7 13.5041 14.6263 13.3827 14.5761C13.2614 14.5258 13.1313 14.5 13 14.5C12.7451 14.5 11.7041 14.5494 11.4385 14.585C8.74307 14.8333 6.17736 15.8573 4.05176 17.5332C4.29289 15.3276 5.33918 13.2884 6.99026 11.8061C8.64135 10.3239 10.7812 9.50275 13 9.50004C13.1313 9.50007 13.2614 9.47423 13.3827 9.42399C13.5041 9.37374 13.6143 9.30008 13.7072 9.20722C13.8 9.11435 13.8737 9.0041 13.9239 8.88276C13.9742 8.76142 14 8.63137 14 8.50004V6.4141L19.5859 12L14 17.586Z",
            fill: "#333333"
        })
    });
};
var LinkAltIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.11 15.3901L8.23002 19.2701C7.76026 19.7235 7.13288 19.9768 6.48002 19.9768C5.82716 19.9768 5.19978 19.7235 4.73002 19.2701C4.49962 19.0406 4.31681 18.7679 4.19207 18.4676C4.06733 18.1673 4.00312 17.8453 4.00312 17.5201C4.00312 17.1949 4.06733 16.8729 4.19207 16.5726C4.31681 16.2723 4.49962 15.9996 4.73002 15.7701L8.61002 11.8901C8.79832 11.7018 8.90411 11.4464 8.90411 11.1801C8.90411 10.9138 8.79832 10.6584 8.61002 10.4701C8.42172 10.2818 8.16632 10.176 7.90002 10.176C7.63372 10.176 7.37832 10.2818 7.19002 10.4701L3.31002 14.3601C2.52838 15.2109 2.10564 16.3308 2.13009 17.4858C2.15455 18.6409 2.6243 19.7419 3.44125 20.5589C4.2582 21.3758 5.35918 21.8456 6.51427 21.87C7.66935 21.8945 8.78923 21.4717 9.64002 20.6901L13.53 16.8101C13.7183 16.6218 13.8241 16.3664 13.8241 16.1001C13.8241 15.8338 13.7183 15.5784 13.53 15.3901C13.3417 15.2018 13.0863 15.096 12.82 15.096C12.5537 15.096 12.2983 15.2018 12.11 15.3901ZM20.69 3.31009C19.8488 2.4741 18.711 2.00488 17.525 2.00488C16.339 2.00488 15.2012 2.4741 14.36 3.31009L10.47 7.19009C10.3768 7.28333 10.3028 7.39402 10.2524 7.51585C10.2019 7.63767 10.1759 7.76824 10.1759 7.90009C10.1759 8.03195 10.2019 8.16252 10.2524 8.28434C10.3028 8.40617 10.3768 8.51686 10.47 8.61009C10.5633 8.70333 10.6739 8.77729 10.7958 8.82775C10.9176 8.87821 11.0482 8.90419 11.18 8.90419C11.3119 8.90419 11.4424 8.87821 11.5643 8.82775C11.6861 8.77729 11.7968 8.70333 11.89 8.61009L15.77 4.73009C16.2398 4.27672 16.8672 4.02335 17.52 4.02335C18.1729 4.02335 18.8003 4.27672 19.27 4.73009C19.5004 4.95958 19.6832 5.2323 19.808 5.53261C19.9327 5.83292 19.9969 6.15491 19.9969 6.48009C19.9969 6.80528 19.9327 7.12727 19.808 7.42758C19.6832 7.72789 19.5004 8.00061 19.27 8.23009L15.39 12.1101C15.2963 12.2031 15.2219 12.3137 15.1711 12.4355C15.1204 12.5574 15.0942 12.6881 15.0942 12.8201C15.0942 12.9521 15.1204 13.0828 15.1711 13.2047C15.2219 13.3265 15.2963 13.4371 15.39 13.5301C15.483 13.6238 15.5936 13.6982 15.7154 13.749C15.8373 13.7998 15.968 13.8259 16.1 13.8259C16.232 13.8259 16.3627 13.7998 16.4846 13.749C16.6065 13.6982 16.7171 13.6238 16.81 13.5301L20.69 9.64009C21.526 8.79887 21.9952 7.66107 21.9952 6.47509C21.9952 5.28912 21.526 4.15131 20.69 3.31009ZM8.83002 15.1701C8.92346 15.2628 9.03428 15.3361 9.15611 15.3859C9.27795 15.4356 9.40841 15.4609 9.54002 15.4601C9.67163 15.4609 9.80209 15.4356 9.92393 15.3859C10.0458 15.3361 10.1566 15.2628 10.25 15.1701L15.17 10.2501C15.3583 10.0618 15.4641 9.8064 15.4641 9.54009C15.4641 9.27379 15.3583 9.0184 15.17 8.83009C14.9817 8.64179 14.7263 8.536 14.46 8.536C14.1937 8.536 13.9383 8.64179 13.75 8.83009L8.83002 13.7501C8.73629 13.8431 8.6619 13.9537 8.61113 14.0755C8.56036 14.1974 8.53422 14.3281 8.53422 14.4601C8.53422 14.5921 8.56036 14.7228 8.61113 14.8447C8.6619 14.9665 8.73629 15.0771 8.83002 15.1701Z",
            fill: fillColor
        })
    });
};
var ExportIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9 22.75H15C20.43 22.75 22.75 20.43 22.75 15V13C22.75 12.59 22.41 12.25 22 12.25C21.59 12.25 21.25 12.59 21.25 13V15C21.25 19.61 19.61 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H11C11.41 2.75 11.75 2.41 11.75 2C11.75 1.59 11.41 1.25 11 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75ZM22 7.55C21.59 7.55 21.25 7.21 21.25 6.8V3.81022L13.5299 11.5302C13.3799 11.6802 13.1899 11.7502 12.9999 11.7502C12.8099 11.7502 12.6199 11.6802 12.4699 11.5302C12.1799 11.2402 12.1799 10.7602 12.4699 10.4702L20.1902 2.75H17.2C16.79 2.75 16.45 2.41 16.45 2C16.45 1.59 16.79 1.25 17.2 1.25H22C22.41 1.25 22.75 1.59 22.75 2V6.8C22.75 7.21 22.41 7.55 22 7.55Z",
            fill: fillColor
        })
    });
};
var ManagementIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.5 17C7.4 17 6.5 17.9 6.5 19C6.5 20.1 7.4 21 8.5 21C9.6 21 10.5 20.1 10.5 19C10.5 17.9 9.6 17 8.5 17ZM15.5 7C16.6 7 17.5 6.1 17.5 5C17.5 3.9 16.6 3 15.5 3C14.4 3 13.5 3.9 13.5 5C13.5 6.1 14.4 7 15.5 7ZM8.5 10C7.4 10 6.5 10.9 6.5 12C6.5 13.1 7.4 14 8.5 14C9.6 14 10.5 13.1 10.5 12C10.5 10.9 9.6 10 8.5 10ZM15.5 10C14.4 10 13.5 10.9 13.5 12C13.5 13.1 14.4 14 15.5 14C16.6 14 17.5 13.1 17.5 12C17.5 10.9 16.6 10 15.5 10ZM15.5 17C14.4 17 13.5 17.9 13.5 19C13.5 20.1 14.4 21 15.5 21C16.6 21 17.5 20.1 17.5 19C17.5 17.9 16.6 17 15.5 17ZM8.5 3C7.4 3 6.5 3.9 6.5 5C6.5 6.1 7.4 7 8.5 7C9.6 7 10.5 6.1 10.5 5C10.5 3.9 9.6 3 8.5 3Z",
            fill: fillColor
        })
    });
};
var AngelRightIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height, _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999999" : _fillColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.83 11.2902L10.59 7.05019C10.497 6.95646 10.3864 6.88207 10.2646 6.8313C10.1427 6.78053 10.012 6.75439 9.88 6.75439C9.74799 6.75439 9.61729 6.78053 9.49543 6.8313C9.37357 6.88207 9.26297 6.95646 9.17 7.05019C8.98375 7.23756 8.87921 7.49101 8.87921 7.75519C8.87921 8.01938 8.98375 8.27283 9.17 8.46019L12.71 12.0002L9.17 15.5402C8.98375 15.7276 8.87921 15.981 8.87921 16.2452C8.87921 16.5094 8.98375 16.7628 9.17 16.9502C9.26344 17.0429 9.37426 17.1162 9.4961 17.166C9.61794 17.2157 9.7484 17.241 9.88 17.2402C10.0116 17.241 10.1421 17.2157 10.2639 17.166C10.3857 17.1162 10.4966 17.0429 10.59 16.9502L14.83 12.7102C14.9237 12.6172 14.9981 12.5066 15.0489 12.3848C15.0997 12.2629 15.1258 12.1322 15.1258 12.0002C15.1258 11.8682 15.0997 11.7375 15.0489 11.6156C14.9981 11.4938 14.9237 11.3832 14.83 11.2902Z",
            fill: fillColor
        })
    });
};


/***/ }),

/***/ 16525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GT": function() { return /* binding */ placeHolderImageIcon; },
/* harmony export */   "Uk": function() { return /* binding */ prevTourIcon; },
/* harmony export */   "Wy": function() { return /* binding */ nextTourIcon; }
/* harmony export */ });
var placeHolderImageIcon = '<svg class="img-placeholder" width="52" height="61" viewBox="0 0 52 61" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g filter="url(#filter0_d_1467_525870)">\n<path d="M38.3866 7.38672C41.1049 7.38672 43.3081 9.58497 43.3081 12.2975V45.333C43.3081 48.0456 41.1049 50.2439 38.3866 50.2439H14.2255C12.1315 50.2439 10.3596 48.9582 9.64387 47.119C9.42889 46.5654 9.30371 45.9582 9.30371 45.333V12.2975C9.30371 9.58497 11.5069 7.38672 14.2255 7.38672L38.3866 7.38672Z" fill="#F5F5F5"/>\n<path d="M22.7261 23.4583C22.7261 25.4306 21.1236 27.0298 19.1466 27.0298C17.1699 27.0298 15.5674 25.4306 15.5674 23.4583C15.5674 21.4859 17.1699 19.8867 19.1466 19.8867C21.1236 19.8867 22.7261 21.4859 22.7261 23.4583Z" fill="url(#paint0_linear_1467_525870)"/>\n<path d="M37.1515 50.2433H14.2255C12.1315 50.2433 10.3596 48.9576 9.64387 47.1184C9.42889 46.5648 9.30371 45.9576 9.30371 45.3325V38.5291L15.1382 32.7077C16.3553 31.4933 18.3595 31.4933 19.5766 32.7077L37.1515 50.2433Z" fill="url(#paint1_linear_1467_525870)"/>\n<path d="M43.3078 34.9577V45.3326C43.3078 48.0471 41.1066 50.2434 38.3863 50.2434H14.2252C12.1312 50.2434 10.3593 48.9577 9.64355 47.1185L30.3503 26.4577C31.5674 25.2433 33.572 25.2433 34.7887 26.4577L43.3078 34.9577Z" fill="url(#paint2_linear_1467_525870)"/>\n</g>\n<defs>\n<filter id="filter0_d_1467_525870" x="0.651364" y="0.734372" width="51.3086" height="60.1621" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n<feOffset dy="2"/>\n<feGaussianBlur stdDeviation="4.32617"/>\n<feComposite in2="hardAlpha" operator="out"/>\n<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>\n<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1467_525870"/>\n<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1467_525870" result="shape"/>\n</filter>\n<linearGradient id="paint0_linear_1467_525870" x1="19.1467" y1="19.8867" x2="19.1467" y2="27.0298" gradientUnits="userSpaceOnUse">\n<stop stop-color="#BEBEBE"/>\n<stop offset="1" stop-color="#707070"/>\n</linearGradient>\n<linearGradient id="paint1_linear_1467_525870" x1="23.2276" y1="31.7969" x2="23.2276" y2="50.2433" gradientUnits="userSpaceOnUse">\n<stop stop-color="#BEBEBE"/>\n<stop offset="1" stop-color="#707070"/>\n</linearGradient>\n<linearGradient id="paint2_linear_1467_525870" x1="26.4757" y1="25.5469" x2="26.4757" y2="50.2434" gradientUnits="userSpaceOnUse">\n<stop stop-color="#BEBEBE"/>\n<stop offset="1" stop-color="#707070"/>\n</linearGradient>\n</defs>\n</svg>\n';
var prevTourIcon = '<svg\nwidth="17"\nheight="17"\nviewBox="0 0 24 24"\nfill="none"\nxmlns="http://www.w3.org/2000/svg"\n>\n<path\n  d="M17 11.0002H9.41002L12.71 7.71019C12.8983 7.52188 13.0041 7.26649 13.0041 7.00019C13.0041 6.73388 12.8983 6.47849 12.71 6.29019C12.5217 6.10188 12.2663 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019L6.29002 11.2902C6.19898 11.3853 6.12761 11.4974 6.08002 11.6202C5.98 11.8636 5.98 12.1367 6.08002 12.3802C6.12761 12.5029 6.19898 12.6151 6.29002 12.7102L11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5065 17.8783 12.6171 17.8039 12.71 17.7102C12.8037 17.6172 12.8781 17.5066 12.9289 17.3848C12.9797 17.2629 13.0058 17.1322 13.0058 17.0002C13.0058 16.8682 12.9797 16.7375 12.9289 16.6156C12.8781 16.4937 12.8037 16.3831 12.71 16.2902L9.41002 13.0002H17C17.2652 13.0002 17.5196 12.8948 17.7071 12.7073C17.8947 12.5198 18 12.2654 18 12.0002C18 11.735 17.8947 11.4806 17.7071 11.2931C17.5196 11.1055 17.2652 11.0002 17 11.0002Z"\n  fill="#EE3244"\n/>\n</svg>';
var nextTourIcon = '<svg\nwidth="17"\nheight="17"\nviewBox="0 0 24 24"\nfill="none"\nxmlns="http://www.w3.org/2000/svg"\n>\n<path\n  d="M17.92 11.6202C17.8724 11.4974 17.801 11.3853 17.71 11.2902L12.71 6.29019C12.6168 6.19695 12.5061 6.12299 12.3842 6.07253C12.2624 6.02207 12.1319 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019C11.1968 6.38342 11.1228 6.49411 11.0723 6.61594C11.0219 6.73776 10.9959 6.86833 10.9959 7.00019C10.9959 7.26649 11.1017 7.52188 11.29 7.71019L14.59 11.0002H7C6.73478 11.0002 6.48043 11.1055 6.29289 11.2931C6.10536 11.4806 6 11.735 6 12.0002C6 12.2654 6.10536 12.5198 6.29289 12.7073C6.48043 12.8948 6.73478 13.0002 7 13.0002H14.59L11.29 16.2902C11.1963 16.3831 11.1219 16.4937 11.0711 16.6156C11.0203 16.7375 10.9942 16.8682 10.9942 17.0002C10.9942 17.1322 11.0203 17.2629 11.0711 17.3848C11.1219 17.5066 11.1963 17.6172 11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5064 17.8783 12.617 17.8039 12.71 17.7102L17.71 12.7102C17.801 12.6151 17.8724 12.5029 17.92 12.3802C18.02 12.1367 18.02 11.8636 17.92 11.6202Z"\n  fill="#fff"\n/>\n</svg>';


/***/ }),

/***/ 23110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D7": function() { return /* binding */ DiscordIcon; },
/* harmony export */   "Ir": function() { return /* binding */ DribbleIcon; },
/* harmony export */   "LK": function() { return /* binding */ YoutubeIcon; },
/* harmony export */   "LQ": function() { return /* binding */ EmailIcon; },
/* harmony export */   "UI": function() { return /* binding */ Lemon8Icon; },
/* harmony export */   "Vq": function() { return /* binding */ FacebookIcon; },
/* harmony export */   "Zm": function() { return /* binding */ TwitterIcon; },
/* harmony export */   "Zr": function() { return /* binding */ SnapchatIcon; },
/* harmony export */   "bF": function() { return /* binding */ TiktokIcon; },
/* harmony export */   "cH": function() { return /* binding */ PinterestIcon; },
/* harmony export */   "jG": function() { return /* binding */ TwitchIcon; },
/* harmony export */   "lj": function() { return /* binding */ TelIcon; },
/* harmony export */   "n1": function() { return /* binding */ GeneralLinkIcon; },
/* harmony export */   "nI": function() { return /* binding */ LinkedInIcon; },
/* harmony export */   "qA": function() { return /* binding */ MessengerIcon; },
/* harmony export */   "uG": function() { return /* binding */ LineChatIcon; },
/* harmony export */   "ud": function() { return /* binding */ WhatsappIcon; },
/* harmony export */   "wE": function() { return /* binding */ BehanceIcon; },
/* harmony export */   "yu": function() { return /* binding */ InstagramIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var FacebookIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/facebook-bmc.svg",
        alt: alt
    });
};
var MessengerIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/facebook-messenger-bmc.svg",
        alt: alt
    });
};
var InstagramIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/instagram-bmc.svg",
        alt: alt
    });
};
var LinkedInIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/linkedin-bmc.svg",
        alt: alt
    });
};
var PinterestIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/pinterest-bmc.svg",
        alt: alt
    });
};
var SnapchatIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/snapchat-bmc.svg",
        alt: alt
    });
};
var TiktokIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/tiktok-bmc.svg",
        alt: alt
    });
};
var TwitchIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/twitch-bmc.svg",
        alt: alt
    });
};
var TwitterIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/twitter-bmc.svg",
        alt: alt
    });
};
var WhatsappIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/whatsapp-bmc.svg",
        alt: alt
    });
};
var YoutubeIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/youtube-bmc.svg",
        alt: alt
    });
};
var DiscordIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/discord-bmc.svg",
        alt: alt
    });
};
var BehanceIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/behance-bmc.svg",
        alt: alt
    });
};
var DribbleIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/dribbble-bmc.svg",
        alt: alt
    });
};
var GeneralLinkIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/general-link-bmc.svg",
        alt: alt
    });
};
var LineChatIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: className,
        width: width,
        height: height,
        src: "https://image.passio.eco/page-builder/page-builder/social-icons/line-chat.svg",
        alt: alt
    });
};
var TelIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "4",
                fill: "#37C837"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 5.9375C5 5.41973 5.41973 5 5.9375 5H7.95582C8.41411 5 8.80522 5.33132 8.88056 5.78338L9.57367 9.94201C9.64133 10.348 9.4363 10.7506 9.06819 10.9347L7.61681 11.6603C8.66334 14.2609 10.7391 16.3367 13.3397 17.3832L14.0653 15.9318C14.2494 15.5637 14.652 15.3587 15.058 15.4263L19.2166 16.1194C19.6687 16.1948 20 16.5859 20 17.0442V19.0625C20 19.5803 19.5803 20 19.0625 20H17.1875C10.4565 20 5 14.5435 5 7.8125V5.9375Z",
                fill: "white"
            })
        ]
    });
};
var EmailIcon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "4",
                fill: "#E84636"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.00333 7.88355L11.9999 11.8819L19.9967 7.8835C19.9363 6.83315 19.0655 6 18 6H6C4.93452 6 4.06363 6.83318 4.00333 7.88355Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20 10.1179L11.9999 14.1179L4 10.118V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V10.1179Z",
                fill: "white"
            })
        ]
    });
};
var Lemon8Icon = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: width,
                height: height,
                rx: "4",
                fill: "#FFF700"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.9785 8.21998C19.3925 8.38404 19.0785 8.7731 19.0785 9.3356C19.0785 9.63092 19.1628 9.83717 19.3878 10.0762C19.4722 10.17 19.5097 10.2403 19.4769 10.2544C19.3129 10.3153 18.9894 10.5731 18.8769 10.7325C18.6941 10.9997 18.666 11.3887 18.816 11.6747C19.0269 12.0872 19.5332 12.3028 20.2832 12.3028C20.9488 12.2981 21.4644 12.0637 21.7035 11.6512C21.7925 11.4919 21.8066 11.4075 21.7972 11.1262C21.7832 10.8309 21.7644 10.77 21.6378 10.6106C21.5582 10.5122 21.4269 10.3856 21.3425 10.3294L21.1925 10.2309L21.4644 10.0387C21.8066 9.79498 21.9566 9.56998 21.9847 9.25123C22.0128 8.9231 21.9754 8.80123 21.7832 8.5856C21.53 8.30435 21.216 8.19185 20.6582 8.1731C20.3769 8.16373 20.105 8.18248 19.9785 8.21998ZM20.9629 8.90904C21.0097 8.93248 21.0707 9.02154 21.1035 9.10123C21.1597 9.23248 21.155 9.26998 21.0753 9.41998C20.9535 9.64967 20.5222 9.91217 20.3816 9.83717C20.2316 9.76217 20.0722 9.60279 19.9925 9.45748C19.8238 9.12467 20.1894 8.78248 20.6535 8.83873C20.78 8.85279 20.9207 8.8856 20.9629 8.90904ZM20.7847 10.9387C21.0144 11.1731 20.93 11.4778 20.6066 11.5809C20.3722 11.6606 19.9035 11.6137 19.7488 11.4965C19.6597 11.4309 19.6222 11.3559 19.6129 11.2106C19.5941 10.9669 19.716 10.784 19.9879 10.6481L20.1847 10.5544L20.4191 10.6809C20.5457 10.7512 20.7097 10.8684 20.7847 10.9387Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.191 8.93248C16.0128 9.00748 15.9519 9.13873 15.8254 9.6731C15.7457 10.0247 15.7363 10.034 15.5769 10.0762C15.1269 10.1887 15.1644 10.2028 15.0847 9.92154C14.9113 9.33092 14.4566 8.95123 13.9222 8.95123C12.9847 8.95123 12.3847 9.61685 12.3566 10.6903L12.3472 11.1356L12.1504 11.3606C11.991 11.5387 11.9254 11.5809 11.8269 11.5715C11.6019 11.5434 11.5738 11.3934 11.6347 10.5262C11.7004 9.64029 11.6769 9.36842 11.5175 9.20904C11.2363 8.92779 10.6269 9.21842 10.2379 9.8231C10.1722 9.92623 10.0457 10.1887 9.96129 10.409L9.81129 10.8075L9.82066 10.2215C9.83004 9.53717 9.78316 9.40592 9.50191 9.34967C9.28629 9.31217 8.87847 9.50435 8.68629 9.73873C8.4941 9.9731 8.26441 10.4137 8.13316 10.8075L8.02066 11.1356L8.05347 10.5497C8.07223 10.2262 8.08629 9.87935 8.09098 9.77623L8.09566 9.58873L7.88473 9.57467C7.72066 9.56529 7.6316 9.58873 7.50973 9.66842C7.27535 9.82779 7.2191 10.0762 7.21441 10.995L7.20504 11.7403L6.93785 12.0262C6.48785 12.5137 5.97691 12.7106 5.61597 12.5419C5.52222 12.4997 5.44722 12.4434 5.44722 12.4247C5.44722 12.4012 5.55972 12.3262 5.69097 12.2465C6.06597 12.0356 6.38473 11.7309 6.5066 11.4637C6.79722 10.8403 6.5066 10.095 5.93472 10.0059C5.47535 9.94029 4.90816 10.1934 4.63629 10.5872C4.34566 10.9997 4.27535 11.3887 4.33629 12.209C4.34566 12.3309 4.30816 12.3684 3.81129 12.6637C3.52066 12.8419 3.24879 12.9872 3.21129 12.9872C3.04722 12.9872 3.05191 12.7622 3.22066 11.8106C3.55816 9.93092 3.55347 9.66373 3.1691 9.2981C2.84566 8.98873 2.47535 8.98404 2.17066 9.28404C1.96441 9.49029 1.95972 9.60279 2.1191 10.2356C2.29254 10.9059 2.35347 11.5294 2.35347 12.6965C2.35347 13.6106 2.3816 13.7465 2.59722 13.8965C2.73316 13.995 3.15972 13.995 3.34722 13.8965C3.42691 13.8544 3.7316 13.5919 4.02691 13.3106C4.32222 13.0294 4.58472 12.7997 4.60816 12.7997C4.6316 12.7997 4.71597 12.87 4.79097 12.959C5.28785 13.5215 6.44097 13.4325 7.17691 12.7715L7.41129 12.5606L7.49097 12.7012C7.53785 12.7809 7.6316 12.8653 7.7066 12.8887C7.87066 12.945 8.14722 12.8747 8.21285 12.7528C8.23629 12.7059 8.29254 12.4387 8.33004 12.1575C8.46598 11.1872 8.78941 10.3575 8.96754 10.5356C8.99097 10.559 9.02379 10.9059 9.03785 11.3044C9.06597 12.0825 9.13629 12.3965 9.30504 12.5512C9.45504 12.6872 9.5441 12.7059 9.73629 12.6544C9.94723 12.5934 10.0082 12.4669 10.0832 11.8856C10.1816 11.1637 10.5332 10.2684 10.716 10.2684C10.7722 10.2684 10.7863 10.4231 10.8004 11.0981C10.8144 12.0403 10.8613 12.1856 11.166 12.345C11.4941 12.5137 12.0941 12.3544 12.4597 11.9981L12.6472 11.8106L12.741 11.9137C13.055 12.2606 13.7347 12.3919 14.1988 12.1903C14.5269 12.0497 14.8738 11.6794 15.0003 11.3325C15.0566 11.1825 15.1035 11.0325 15.1035 10.9903C15.1035 10.9106 15.141 10.8965 15.4363 10.8544L15.6519 10.8262L15.68 11.2622C15.7316 12.0075 15.8253 12.1903 16.1675 12.1903C16.4488 12.1903 16.5191 12.1012 16.6972 11.5294C16.8707 10.9575 17.1472 10.3622 17.3535 10.1137C17.6254 9.79029 17.6535 9.88404 17.541 10.7184C17.4894 11.0794 17.4472 11.5106 17.4472 11.6794C17.4472 11.9419 17.4613 12.0028 17.555 12.0872C17.7003 12.2231 18.0425 12.2278 18.2066 12.0965C18.3191 12.0122 18.3285 11.97 18.3566 11.4309C18.3753 11.1122 18.4316 10.5731 18.4832 10.2309C18.591 9.47623 18.5957 9.15279 18.5019 9.01685C18.3941 8.86685 18.141 8.83404 17.8269 8.93248C17.4566 9.04967 17.03 9.49029 16.7441 10.0481C16.6316 10.2731 16.5332 10.4559 16.5238 10.4559C16.505 10.4559 16.5566 10.1887 16.6785 9.66842C16.8097 9.09654 16.8191 8.92779 16.716 8.89029C16.5941 8.84342 16.355 8.86217 16.191 8.93248ZM13.8707 9.94029C13.8847 10.2215 14.0628 10.5919 14.2457 10.7278C14.3675 10.8169 14.3722 10.8262 14.3113 11.0231C14.2222 11.309 13.9879 11.534 13.7675 11.534C13.5519 11.534 13.355 11.3512 13.28 11.084C13.2144 10.8544 13.2144 10.4372 13.2754 10.2122C13.341 9.98717 13.6035 9.70592 13.7488 9.70592C13.8519 9.70592 13.8613 9.72935 13.8707 9.94029ZM5.76597 10.77C5.85972 10.8497 5.89254 10.9669 5.87847 11.1965C5.86441 11.3887 5.2691 11.9372 5.17535 11.8434C5.16129 11.8247 5.14722 11.684 5.14722 11.52C5.14254 11.1731 5.26441 10.859 5.44254 10.7606C5.60191 10.6715 5.65347 10.6762 5.76597 10.77Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7519 13.77C11.9207 13.9012 9.21597 14.2434 6.83004 14.7731C5.78004 15.0028 5.55504 15.0778 5.46597 15.2137C5.40035 15.3122 5.40035 15.3403 5.46597 15.4622C5.50816 15.5465 5.62535 15.645 5.74722 15.7012C6.11285 15.8794 6.32379 15.8747 7.22847 15.6684C8.98629 15.2606 11.0722 14.9325 13.1113 14.7497C14.2972 14.6419 14.9629 14.6137 16.8238 14.6044C18.6941 14.5997 18.9519 14.5856 19.055 14.52C19.2238 14.4122 19.2566 14.2669 19.1488 14.1169C19.0035 13.92 18.755 13.8262 18.2535 13.7794C17.841 13.7465 15.4457 13.7372 14.7519 13.77Z",
                fill: "black"
            })
        ]
    });
};


/***/ }),

/***/ 2991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ ACTION_CONFIG; },
/* harmony export */   "Aw": function() { return /* binding */ BLOCK_TYPE_EVENT_CONFIG; },
/* harmony export */   "Bt": function() { return /* binding */ CATEGORY_CONFIG; },
/* harmony export */   "f1": function() { return /* binding */ EVENT_CONFIG; },
/* harmony export */   "tW": function() { return /* binding */ LABEL_CONFIG; }
/* harmony export */ });
/* unused harmony exports submitEvent, submitEventV2, submitEventSearch */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var BLOCK_TYPE_EVENT_CONFIG = {
    TEXT: "Text",
    TAB_BAR: "TabMenu",
    IMAGE_SLIDER: "ImageSlider",
    AFFILIATE_PRODUCT: "Affiliate",
    STORY: "Spotlight",
    BIO: "Bio",
    IMAGE: "Image",
    BUTTON_LINK: "Link",
    GIFT: "VirtualGift",
    DIGITAL_PRODUCT: "DigitalProduct",
    AFFILIATE_PRODUCT_GROUP: "Affiliate",
    IMAGE_GALLERY: "ImageGallery",
    EMBED: "Embed",
    CARD: "Cards",
    BUTTON_MULTI_LINK: "MultiLinks",
    DONATION: "Donation",
    TOD: "TruthOrDare",
    TOD_FOOTER: "TruthOrDareFloating",
    GIFT_FOOTER: "VirtualGiftFloating",
    THEME_TEMPLATE_SEARCH_CLEAR: "ThemeTemplate_Search_Clear",
    BLOCK_TYPE_SEARCH_CLEAR: "BlockType_Search_Clear",
    COMBINED: "Combined"
};
var LABEL_CONFIG = {
    CLICK_ON: "ClickOn",
    EDIT: "Edit",
    CANCEL: "Cancel",
    CLEAR_SEARCH: "Clear Search"
};
var CATEGORY_CONFIG = {
    BLOCK: "Block",
    BLOCK_TYPE: "Block Type",
    ADD_BLOCK_BUTTON: "Add Block Button",
    POSITION: "Position",
    TAB: "Tab",
    THEME_TEMPLATE: "Theme Template",
    THEME_SETTINGS: "Theme Settings",
    SITE_SETTINGS: "Site Settings",
    SETTINGS: "Settings",
    PREVIEW_SITE: "Preview Site",
    RESTORE_EDITS: "Restore Edits",
    APPLY_SAMPLE_CONTENT: "Apply Sample Content",
    PRODUCT_TOUR_AUTO: "Product Tour Auto",
    PRODUCT_TOUR: "Product Tour",
    PUBLISH_SITE: "Publish Site",
    PUBLISH_RESULT: "Publish Result",
    POWERED_BY_LOGO: "Powered by Logo",
    POWERED_BY_TEXT: "Powered by Text",
    ERROR_PAGE: "Error Page",
    ONBOARDING: "Onboarding",
    ASK_TO_REVIEW: "Ask To Review",
    BUILDER_ACCESS: "Builder Access",
    CREATOR_SEND_REVIEW: "Creator Send Review"
};
var ACTION_CONFIG = {
    EDIT: "Edit",
    CANCEL: "Cancel",
    START_EDITING_POPOVER: "Start editing - Popover",
    START_EDITING_QUICK: "Start editing - Quick",
    HIDE: "Hide",
    SHOW: "Show",
    DELETE: "Delete",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    DRAG_DROP_UP: "Drag Drop - Up",
    DRAG_DROP_DOWN: "Drag Drop - Down",
    SEARCH: "Search",
    GROUP_FILTER: "Group Filter",
    SELECT: "Select",
    ADD: "Add",
    ADD_BLOCK: "Add Block",
    VIEW: "View",
    APPLY: "Apply",
    GENERAL: "General",
    BLOCK: "Block",
    HEADING: "Heading",
    PARAGRAPH: "Paragraph",
    BUTTON: "Button",
    PERSONAL_BRAND: "Personal brand",
    DOMAIN: "Domain",
    FAVICON_ICON: "Click Favicon Icon",
    EDIT_DOMAIN: "Click Edit Domain Icon",
    COPY_DOMAIN: "Copy Domain",
    VIEW_SITE_IN_BROWSER: "View Site in Browser",
    SHARE_SITE: "Share Site",
    TURN_ON: "Turn on",
    TURN_OFF: " Turn off",
    SET_DEFAULT: "Set default",
    RENAME: "Rename",
    VIEW_SITE: "View Site in Browser",
    SHARE: "Share Site",
    THEME_NOT_EXITS: "Theme Template Does Not Exist",
    CONFIRM: "Confirm",
    PREVIEW_SITE_IN_BROWSER: "Preview Site in Browser",
    PREVIEW_SITE: "Preview Site",
    CLICK: "Click",
    SHOW_ERROR_PAGE: "Show Error Page",
    SEND_ERROR_REPORT: "Send Error Report",
    DRAG_AND_DROP: "Drag n Drop",
    SELECT_CATEGORY: "Select Category",
    COMPLETE: "Complete",
    SUBMIT_REVIEW_FORM: "Submit Review Form",
    CLOSE_REVIEW_FORM: "Close Review Form",
    SESSION_START: "Session Start",
    MOVE_TO: "Move to",
    CLICK_REVIEW_BUTTON: "Click Review Button",
    UPGRADE_PLAN: "Upgrade Plan",
    SETTING_UPGRADE_PLAN: "Click Upgrade Plan Button"
};
var EVENT_CONFIG = {
    MOVE_TO: "Block_MoveTo_",
    CLICK_REVIEW_BUTTON: "Settings_ClickReviewButton",
    SUBMIT_REVIEW_FORM: "CreatorSendReview_SubmitReview",
    CLOSE_REVIEW_FORM: "CreatorSendReview_CloseReviewForm",
    ASK_TO_REVIEW_SUBMIT_REVIEW: "AskToReview_SubmitReview",
    ASK_TO_REVIEW_CLOSE_REVIEW_FORM: "AskToReview_CloseReviewForm",
    CREATOR_SEND_REVIEW_SUBMIT_REVIEW: "CreatorSendReview_SubmitReview",
    CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM: "CreatorSendReview_CloseReviewForm",
    THEME_TEMPLATE: "ThemeTemplate",
    SETTINGS: "Settings"
};
var submitEvent = function(category, event) {
    var label = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, action = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parameterOpts = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    if ( true && !window.gtag || typeof window.gtag !== "function") return;
    try {
        window.gtag("event", event, _objectSpread({
            event_category: category,
            event_label: label,
            event_action: action
        }, parameterOpts));
    } catch (e) {}
};
var submitEventV2 = function(profile, category, eventName) {
    var label = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, action = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parameterOpts = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    if ( true && !window.gtag || typeof window.gtag !== "function") return;
    try {
        window.gtag("event", eventName, _objectSpread({
            event_category: category,
            event_action: action,
            event_label: label,
            // domain: profile?.domain,
            seller_id: profile === null || profile === void 0 ? void 0 : profile.id,
            site_id: profile === null || profile === void 0 ? void 0 : profile.site_id
        }, parameterOpts));
    } catch (e) {}
};
var submitEventSearch = function(location, page, searchTerm) {
    if ( true && !window.gtag || typeof window.gtag !== "function") return;
    try {
        // window.gtag("event", "page_view", {
        //   search_term: searchTerm,
        //   page_location: `${location}/${page}?keyword=${searchTerm}`,
        //   page_path: page,
        // });
        window.gtag("event", "view_search_results", {
            search_term: searchTerm,
            page_location: "".concat(location, "/").concat(page, "?keyword=").concat(searchTerm),
            page_path: page
        });
    } catch (e) {}
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    submitEvent: submitEvent,
    submitEventV2: submitEventV2,
    submitEventSearch: submitEventSearch
});


/***/ }),

/***/ 31753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ calculateTints; },
/* harmony export */   "Yu": function() { return /* binding */ parseColorValues; },
/* harmony export */   "ZN": function() { return /* binding */ calculateShades; }
/* harmony export */ });
/* unused harmony exports pad, hexToRGB, intToHex, rgbToHex, rgbShade, rgbTint, calculateShade, calculateTint */
// parse an input string, looking for any number of hexadecimal color
// values, possibly with whitespace or garbage in between.  Return an array of
// color values. Supports hex shorthand.
function parseColorValues(colorValues) {
    var colorValuesArray = colorValues.match(/[0-9A-Fa-f]{6}/g);
    if (colorValuesArray) {
        colorValuesArray = colorValuesArray.map(function(item) {
            if (item.length === 3) {
                var newItem = item.toString().split("");
                newItem = newItem.reduce(function(acc, it) {
                    return acc + it + it;
                }, "");
                return newItem;
            }
            return item;
        });
    }
    return colorValuesArray; // this could be null if there are no matches
}
// pad a hexadecimal string with zeros if it needs it
function pad(number, length) {
    var str = "" + number;
    while(str.length < length){
        str = "0" + str;
    }
    return str;
}
// convert a hex string into an object with red, green, blue numeric properties
// '501214' => { red: 80, green: 18, blue: 20 }
function hexToRGB(colorValue) {
    return {
        red: parseInt(colorValue.substr(0, 2), 16),
        green: parseInt(colorValue.substr(2, 2), 16),
        blue: parseInt(colorValue.substr(4, 2), 16)
    };
}
// convert an integer to a 2-char hex string
// for sanity, round it and ensure it is between 0 and 255
// 43 => '2b'
function intToHex(rgbint) {
    return pad(Math.min(Math.max(Math.round(rgbint), 0), 255).toString(16), 2);
}
// convert one of our rgb color objects to a full hex color string
// { red: 80, green: 18, blue: 20 } => '501214'
function rgbToHex(rgb) {
    return intToHex(rgb.red) + intToHex(rgb.green) + intToHex(rgb.blue);
}
// shade one of our rgb color objects to a distance of i*10%
// ({ red: 80, green: 18, blue: 20 }, 1) => { red: 72, green: 16, blue: 18 }
function rgbShade(rgb, i) {
    return {
        red: rgb.red * (1 - 0.1 * i),
        green: rgb.green * (1 - 0.1 * i),
        blue: rgb.blue * (1 - 0.1 * i)
    };
}
// tint one of our rgb color objects to a distance of i*10%
// ({ red: 80, green: 18, blue: 20 }, 1) => { red: 98, green: 42, blue: 44 }
function rgbTint(rgb, i) {
    return {
        red: rgb.red + (255 - rgb.red) * i * 0.1,
        green: rgb.green + (255 - rgb.green) * i * 0.1,
        blue: rgb.blue + (255 - rgb.blue) * i * 0.1
    };
}
// take a hex color string and produce a list of 10 tints or shades of that color
// shadeOrTint should be either `rgbShade` or `rgbTint`, as defined above
// this allows us to use `calculate` for both shade and tint
function calculateShade(colorValue, shade) {
    var color = hexToRGB(colorValue);
    var shadeValues = [];
    for(var i = 0; i <= 8; i++){
        if (i % 2 == 0) {
            shadeValues.push("#" + rgbToHex(shade(color, i)));
        }
    }
    return shadeValues;
}
function calculateTint(colorValue, tint) {
    var color = hexToRGB(colorValue);
    var shadeValues = [];
    for(var i = 1; i <= 9; i++){
        if (i % 2 == 0 || i == 9) {
            shadeValues.push("#" + rgbToHex(tint(color, i)));
        }
    }
    return shadeValues;
}
// given a color value, return an array of ten shades in 10% increments
function calculateShades(colorValue) {
    return calculateShade(colorValue, rgbShade);
}
// given a color value, return an array of ten tints in 10% increments
function calculateTints(colorValue) {
    return calculateTint(colorValue, rgbTint);
}


/***/ }),

/***/ 11116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tB": function() { return /* binding */ colorNameToHex; },
  "yl": function() { return /* binding */ formatDetectedUrls; },
  "vx": function() { return /* binding */ formatNumberToCurrency; },
  "Si": function() { return /* binding */ formatNumberToCurrencyDonation; },
  "Pb": function() { return /* binding */ formatUnitSymbol; },
  "mg": function() { return /* binding */ getGlobalColor; },
  "Xv": function() { return /* binding */ getHexColor; },
  "eq": function() { return /* binding */ getOpacityFromHex; },
  "UY": function() { return /* binding */ getPlaceholderProps; },
  "mr": function() { return /* binding */ getRandomColor; },
  "Tz": function() { return /* binding */ handleCapitalizeFirstLetter; },
  "a7": function() { return /* binding */ hexToRgba; },
  "l_": function() { return /* binding */ htmlDecode; },
  "nI": function() { return /* binding */ isDesktop; },
  "Hq": function() { return /* binding */ mockUpload; },
  "s": function() { return /* binding */ rgbaToHex; },
  "vR": function() { return /* binding */ validDomain; },
  "b3": function() { return /* binding */ validURL; }
});

// UNUSED EXPORTS: DESKTOP_BREAK_POINT, FILE_SIZE_MAXIMUM, IMAGE_SIZE_MINIUM, allowedImageFormat, checkImageSize, convertRGBAStringColor, formatCurrencyToNumber, getBase64, getDraggedDom, getDroppableDom, getGradient, resize, validateEmail

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/hooks/index.ts
var hooks = __webpack_require__(16565);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/utils/sleep.js
var sleep = __webpack_require__(24547);
// EXTERNAL MODULE: ./node_modules/node-html-parser/dist/index.js
var dist = __webpack_require__(90698);
;// CONCATENATED MODULE: ./node_modules/node-html-parser/esm/index.js


const CommentNode = dist.CommentNode;
const HTMLElement = dist.HTMLElement;
const parse = dist.parse;
const valid = dist.valid;
const Node = dist.Node;
const TextNode = dist.TextNode;
const NodeType = dist.NodeType;

/* harmony default export */ var esm = ((/* unused pure expression or super */ null && (nhp)));
// EXTERNAL MODULE: ./node_modules/tailwindcss/colors.js
var colors = __webpack_require__(69808);
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);
;// CONCATENATED MODULE: ./src/features/share/lib/index.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var DESKTOP_BREAK_POINT = 768;
var FILE_SIZE_MAXIMUM = 30000000; //30MB = 30000000 bytes
var IMAGE_SIZE_MINIUM = 256; //256px
var allowedImageFormat = [
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/png",
    "image/bmp",
    "image/webp",
    "image/heif",
    "image/heic",
    "image/svg+xml"
];
var isDesktop = function() {
    var isDevice = (0,hooks/* useDetectdevice */.iU)();
    return isDevice === configs_const/* USER_DEVICE.DESKTOP */.nf.DESKTOP;
};
var getRandomItem = function(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
};
var isNotAllowed = function(color) {
    if (!color.match(/^[a-z]+$/)) return true;
    var unallowed = [
        "black",
        "white",
        // "rose",
        // "lime",
        // "violet",
        "emerald",
        "fuchsia",
        // "orange",
        // "cyan",
        // "amber",
        // "teal",
        "red",
        "inherit",
        "current",
        "transparent", 
    ];
    if (unallowed.includes(color)) return true;
    return false;
};
var getRandomColor = function() {
    var prevColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var allColors = Object.keys((colors_default()));
    var color = getRandomItem(allColors);
    return isNotAllowed(color) || prevColor === color ? getRandomColor(prevColor) : color;
};
var getHexColor = function(color, intensity) {
    if (!color.includes("#")) {
        if (!isNotAllowed(color)) {
            // Check if color have intensity
            if ((colors_default())[color]) {
                if ((colors_default())[color][parseInt(intensity)]) {
                    return (colors_default())[color][parseInt(intensity)];
                }
            }
        }
    }
    return color;
};
var getGradient = function(firstColor, secondColor) {
    var intensity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, direction = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "br";
    if (firstColor.includes("#") || secondColor.includes("#")) {
        return "bg-gradient-to-".concat(direction, " from-[").concat(firstColor, "] to-[").concat(secondColor, "]");
    } else {
        return "bg-gradient-to-".concat(direction, " from-").concat(firstColor, "-").concat(intensity, " to-").concat(secondColor, "-").concat(intensity);
    }
};
var getBase64 = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = function(error) {
            return reject(error);
        };
    });
};
var checkImageSize = function(file) {
    return new Promise(function(resolve) {
        var image = document.createElement("img");
        image.src = URL.createObjectURL(file);
        image.onload = function() {
            return resolve({
                width: image.width,
                height: image.height
            });
        };
    });
};
function mockUpload(file, maxWidth, maxHeight, list_accept) {
    return _mockUpload.apply(this, arguments);
}
function _mockUpload() {
    _mockUpload = _asyncToGenerator(runtime_default().mark(function _callee(file, maxWidth, maxHeight, list_accept) {
        var typeResize, isCheckImageSize, ref, size, dataBase64, dataBase64Resize, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    typeResize = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 1, isCheckImageSize = _args.length > 5 && _args[5] !== void 0 ? _args[5] : false;
                    ;
                    if (!isCheckImageSize) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 5;
                    return checkImageSize(file);
                case 5:
                    size = _ctx.sent;
                    if (!((size === null || size === void 0 ? void 0 : size.width) < IMAGE_SIZE_MINIUM || (size === null || size === void 0 ? void 0 : size.height) < IMAGE_SIZE_MINIUM)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        url: null,
                        isInvalidMinimumSize: true
                    });
                case 8:
                    if (allowedImageFormat.includes(file === null || file === void 0 ? void 0 : (ref = file.type) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase())) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        url: null,
                        isValidFormat: true
                    });
                case 12:
                    if (!((file === null || file === void 0 ? void 0 : file.size) > FILE_SIZE_MAXIMUM)) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        url: null,
                        isValidSize: true
                    });
                case 16:
                    _ctx.next = 18;
                    return (0,sleep/* sleep */._)(1000);
                case 18:
                    _ctx.prev = 18;
                    _ctx.next = 21;
                    return getBase64(file);
                case 21:
                    dataBase64 = _ctx.sent;
                    if (!dataBase64) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.next = 25;
                    return resize(dataBase64, file.type, maxWidth, maxHeight, typeResize);
                case 25:
                    dataBase64Resize = _ctx.sent;
                    return _ctx.abrupt("return", {
                        url: URL.createObjectURL(file),
                        dataBase64: dataBase64Resize,
                        fileName: file.name,
                        file: file
                    });
                case 27:
                    _ctx.next = 32;
                    break;
                case 29:
                    _ctx.prev = 29;
                    _ctx.t0 = _ctx["catch"](18);
                    console.log(_ctx.t0);
                case 32:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                18,
                29
            ]
        ]);
    }));
    return _mockUpload.apply(this, arguments);
}
var DEFAULT_WIDTH = 900;
var DEFAULT_HEIGHT = 315;
var resize = function(source, fileType, maxWidth, maxHeight, typeResize) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.src = source;
        img.onload = function(e) {
            // Create your canvas
            var canvas = document.createElement("canvas");
            var width = e.target.width;
            var height = e.target.height;
            // Add the resizing logic
            switch(typeResize){
                // resize chieu lon hon
                case 1:
                    if (width > height) {
                        if (maxWidth && width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (maxHeight) {
                            if (height > maxHeight) {
                                width *= maxHeight / height;
                                height = maxHeight;
                            }
                        } else {
                            if (maxWidth && width > maxWidth) {
                                height *= maxWidth / width;
                                width = maxWidth;
                            }
                        }
                    }
                    break;
                //resize chieu nho hon
                case 2:
                    if (width < height) {
                        if (maxWidth && width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else {
                        if (maxHeight) {
                            if (height > maxHeight) {
                                width *= maxHeight / height;
                                height = maxHeight;
                            }
                        } else {
                            if (maxWidth && width > maxWidth) {
                                height *= maxWidth / width;
                                width = maxWidth;
                            }
                        }
                    }
                    break;
                //resize chieu rong (W)
                case 3:
                    if (maxWidth && width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                    break;
                //resize chieu cao (H)
                case 4:
                    if (maxHeight && height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                    break;
                default:
            }
            console.log("width", width);
            console.log("height", height);
            console.log("typeResize", typeResize);
            //Specify the resizing result
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            return resolve(canvas.toDataURL(fileType));
        };
    });
};
var validURL = function(str) {
    var pattern1 = new RegExp(/^https?:\/\/([0-9a-z]+\-?[0-9a-z]*?\.)?[0-9a-z]+\-?[0-9a-z]+?\.[a-z]{2,}\/?.*/, "i");
    var pattern2 = new RegExp("^(mailto|tel):", "i");
    return !!pattern1.test(str) || !!pattern2.test(str);
};
var validateEmail = function(email) {
    return String(email).toLocaleLowerCase().match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/);
};
var validDomain = function(str) {
    var domainPattern = new RegExp(/^[a-z](?:_?[a-z0-9]+)*$/i);
    return !!domainPattern.test(str);
};
var convertRGBAStringColor = function(obj) {
    return "rgba(".concat(obj.r, ",").concat(obj.g, ",").concat(obj.b, ",").concat(obj.a, ")");
};
var rgbaToHex = function(obj) {
    var r = obj && obj.r;
    var g = obj && obj.g;
    var b = obj && obj.b;
    var a = obj && obj.a;
    var outParts = [
        r.toString(16),
        g.toString(16),
        b.toString(16),
        Math.round(a * 255).toString(16).substring(0, 2), 
    ];
    // Pad single-digit output values
    outParts.forEach(function(part, i) {
        if (part.length === 1) {
            outParts[i] = "0" + part;
        }
    });
    return "#" + outParts.join("");
};
var getOpacityFromHex = function(hex) {
    var COLOR_LENGTH_DEFAULT = 9;
    var alpha = (hex === null || hex === void 0 ? void 0 : hex.length) == COLOR_LENGTH_DEFAULT ? hex === null || hex === void 0 ? void 0 : hex.slice(-2) : "ff";
    var opacity = parseInt(alpha, 16) / 255;
    return opacity;
};
var hexToRgba = function(hexString) {
    var hex = hexString === null || hexString === void 0 ? void 0 : hexString.replace("#", "");
    var r, g, b, a;
    if (3 === (hex === null || hex === void 0 ? void 0 : hex.length)) {
        r = hex.charAt(0);
        g = hex.charAt(1);
        b = hex.charAt(2);
    } else if (4 === hex.length) {
        r = hex.charAt(0);
        g = hex.charAt(1);
        b = hex.charAt(2);
        a = hex.charAt(3);
    } else if (6 === hex.length) {
        r = hex.substring(0, 2);
        g = hex.substring(2, 4);
        b = hex.substring(4, 6);
    } else if (8 === hex.length) {
        r = hex.substring(0, 2);
        g = hex.substring(2, 4);
        b = hex.substring(4, 6);
        a = hex.substring(6, 8);
    } else {
        return "";
    }
    if ("undefined" === typeof a) {
        a = "ff";
    }
    if (1 === r.length) {
        r += r;
    }
    if (1 === g.length) {
        g += g;
    }
    if (1 === b.length) {
        b += b;
    }
    if (1 === a.length) {
        a += a;
    }
    r = parseInt(r, 16);
    g = parseInt(g, 16);
    b = parseInt(b, 16);
    a = parseInt(a, 16) / 255;
    return "rgba(" + r + "," + g + "," + b + "," + Math.round(a * 100) / 100 + ")";
};
var getGlobalColor = function(hex) {
    var globalColor = hex === null || hex === void 0 ? void 0 : hex.substring(0, (hex === null || hex === void 0 ? void 0 : hex.length) === 9 ? (hex === null || hex === void 0 ? void 0 : hex.length) - 2 : hex === null || hex === void 0 ? void 0 : hex.length);
    return globalColor;
};
function htmlDecode(input) {
    try {
        var domParser = new DOMParser();
        var doc = domParser.parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    } catch (error) {
        return parse(input).toString();
    }
}
var formatNumberToCurrency = function(n) {
    return n.toString().replace(/\D/g, "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
var formatCurrencyToNumber = function(n) {
    return n === null || n === void 0 ? void 0 : n.replace(/,/g, "");
};
var formatNumberToCurrencyDonation = function(n) {
    return n === null || n === void 0 ? void 0 : n.toString().replace(/\D/g, "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
var formatUnitSymbol = function(country) {
    switch(country){
        case configs_const/* COUNTRY_VN */.ie:
            return "\u0111";
        case configs_const/* COUNTRY_ID */.HV:
            return "Rp";
        case configs_const/* COUNTRY_MY */.n7:
            return "RM";
        case configs_const/* COUNTRY_SG */.YA:
            return "S$";
        case configs_const/* COUNTRY_PH */.KP:
            return "\u20B1";
        case configs_const/* COUNTRY_TH */.Un:
            return "\u0E3F";
        default:
            return "$";
    }
};
function colorNameToHex(color) {
    var colors1 = {
        amber: "#ffbf00",
        aliceBlue: "#f0f8ff",
        antiqueWhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueGray: "#6699cc",
        blueViolet: "#8a2be2",
        brown: "#a52a2a",
        burlyWood: "#deb887",
        cadetBlue: "#5f9ea0",
        chartReuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        coolGray: "#808080",
        cyan: "#00ffff",
        gold: "#ffd700",
        gray: "#808080",
        green: "#008000",
        greenYellow: "#adff2f",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lightBlue: "#add8e6",
        lightCoral: "#f08080",
        lightCyan: "#e0ffff",
        lightGrey: "#d3d3d3",
        lightGreen: "#90ee90",
        lightPink: "#ffb6c1",
        lightSalmon: "#ffa07a",
        lightYellow: "#ffffe0",
        lime: "#00ff00",
        limeGreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        paleGreen: "#98fb98",
        papayaWhip: "#ffefd5",
        peachPuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderBlue: "#b0e0e6",
        purple: "#800080",
        rebecCapurple: "#663399",
        red: "#ff0000",
        rosyBrown: "#bc8f8f",
        royalBlue: "#4169e1",
        salmon: "#fa8072",
        seaGreen: "#2e8b57",
        seaShell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyBlue: "#87ceeb",
        sky: "#87ceeb",
        slateBlue: "#6a5acd",
        slateGray: "#708090",
        slate: "#708090",
        snow: "#fffafa",
        steelBlue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whiteSmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowGreen: "#9acd32",
        stone: "#a8a29e",
        zinc: "#a1a1aa",
        neutral: "#a3a3a3",
        rose: "#fb7185"
    };
    if (typeof colors1[color.toLowerCase()] != "undefined") return colors1[color.toLowerCase()];
    return false;
}
var handleCapitalizeFirstLetter = function(text) {
    var ref;
    if (!text) return;
    var pattern = /[.\-=/_ ]/;
    var textArr = text === null || text === void 0 ? void 0 : text.split(pattern);
    var newText = (ref = textArr === null || textArr === void 0 ? void 0 : textArr.map(function(x) {
        return x.charAt(0).toUpperCase() + x.slice(1);
    })) === null || ref === void 0 ? void 0 : ref.join("");
    return newText;
};
var formatDetectedUrls = function(data) {
    var ref, ref1;
    var detectedUrls = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.split(/\r?\n/)) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x === null || x === void 0 ? void 0 : x.trim();
    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(x) {
        return x === null || x === void 0 ? void 0 : x.trim();
    });
    return detectedUrls;
};
var getDroppableDom = function(dropId) {
    var queryAttr = "data-rbd-droppable-id";
    var domQuery = "[".concat(queryAttr, "='").concat(dropId, "']");
    var element = document.querySelector(domQuery);
    return element;
};
var getDraggedDom = function(draggableId) {
    var queryAttr = "data-rbd-drag-handle-draggable-id";
    var domQuery = "[".concat(queryAttr, "='").concat(draggableId, "']");
    var element = document.querySelector(domQuery);
    return element;
};
var getPlaceholderProps = function(event) {
    var clientY = 0;
    var clientX = 0;
    var destinationIndex = event.destination.index;
    var sourceIndex = event.source.index;
    var draggedDOM = getDraggedDom(event.draggableId);
    if (!draggedDOM) {
        return;
    }
    var clientWidth = draggedDOM.clientWidth, clientHeight = draggedDOM.clientHeight;
    var childrenArray = _toConsumableArray(draggedDOM.parentNode.children);
    var movedItem = childrenArray[sourceIndex];
    childrenArray.splice(sourceIndex, 1);
    var updatedArray = _toConsumableArray(childrenArray.slice(0, destinationIndex)).concat([
        movedItem, 
    ], _toConsumableArray(childrenArray.slice(destinationIndex + 1)));
    clientY = parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) + updatedArray.slice(0, destinationIndex).reduce(function(total, curr) {
        var style = curr.currentStyle || window.getComputedStyle(curr);
        var marginTop = parseFloat(style.marginTop);
        var marginBottom = parseFloat(style.marginBottom);
        return total + curr.clientHeight + marginBottom + marginTop;
    }, 0);
    return {
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        clientY: clientY,
        clientX: clientX
    };
};


/***/ }),

/***/ 63681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ genLinkV2; },
/* harmony export */   "_3": function() { return /* binding */ genLink; }
/* harmony export */ });
/* unused harmony export genMultiLink */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _share_api_createAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88549);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var baseApiUrl = "https://ga.passio.eco";
var axios = (0,_share_api_createAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)();
var API_URL = {
    me: baseApiUrl + "/api/account/me",
    genMultiLink: baseApiUrl + "/api/v1/affiliate/generate-link/gen-multi-link"
};
var getLocaleFromCountry = function(country) {
    if ([
        "EN",
        "VN",
        "TH",
        "ID"
    ].indexOf(country) === -1) {
        return "en";
    }
    switch(country){
        case "VN":
            return "vi";
        default:
            return country.toLowerCase();
    }
};
var genMultiLink = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(text, subs) {
        var ref, res, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return axios.post(API_URL.genMultiLink, _objectSpread({
                        link: text
                    }, subs));
                case 3:
                    res = _ctx.sent;
                    data = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function genMultiLink(text, subs) {
        return _ref.apply(this, arguments);
    };
}();
var genLink = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(link, subs) {
        var multiLinkResult, results, ref;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return genMultiLink(link, subs);
                case 2:
                    multiLinkResult = _ctx.sent;
                    results = multiLinkResult === null || multiLinkResult === void 0 ? void 0 : multiLinkResult.results;
                    if (!(results && results[0])) {
                        _ctx.next = 7;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", (ref = results[0]) === null || ref === void 0 ? void 0 : ref.link_shorten);
                case 7:
                    return _ctx.abrupt("return", null);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function genLink(link, subs) {
        return _ref.apply(this, arguments);
    };
}();
var accountApi = {
    me: _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios.get(API_URL.me);
                case 3:
                    res = _ctx.sent;
                    if (!(res.status !== 200 || !res.data)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 6:
                    data = res.data.data || {};
                    return _ctx.abrupt("return", {
                        _id: data._id,
                        username: data.username,
                        mobile: data.mobile,
                        email: data.email,
                        fullname: data.fullname,
                        traffic_source: data.traffic_source,
                        link_traffic_source: data.link_traffic_source,
                        ip: data.ip,
                        _token: data._token,
                        api_token: data.api_token,
                        api_token_private: data.api_token_private,
                        salt: data.salt,
                        password: data.password,
                        currency: data.currency,
                        country: data.country,
                        locale: getLocaleFromCountry(data.country),
                        approval: data.approval,
                        register_source: data.register_source,
                        my_answers: data.my_answers,
                        chat_app: data.chat_app,
                        skype: data.skype,
                        promotion_code: data.promotion_code,
                        request_country: data.request_country,
                        address: data.address,
                        version: data.version,
                        offer_promotion_country_name: data.offer_promotion_country_name,
                        referral_code: data.referral_code,
                        verify_publisher_group: data.verify_publisher_group,
                        follower_number: data.follower_number,
                        publisher_group: data.publisher_group,
                        updated_at: data.updated_at,
                        created_at: data.created_at,
                        sync_eop_user_status: data.sync_eop_user_status,
                        eop_user_id: data.eop_user_id,
                        flag: data.flag,
                        remember_token: data.remember_token,
                        account_type: data.account_type,
                        admin_note: data.admin_note,
                        api: data.api,
                        birthday: data.birthday,
                        configs: data.configs,
                        default_rank: data.default_rank,
                        fixed_rank: data.fixed_rank,
                        hide_withdraw: data.hide_withdraw,
                        parent_id: data.parent_id,
                        payout_pending_percent: data.payout_pending_percent,
                        rate_default: data.rate_default,
                        rate_pending: data.rate_pending,
                        rate_success: data.rate_success,
                        domain: data.domain,
                        avatar: data.avatar
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", null);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))
};
var genLinkV2 = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(link, subs) {
        var multiLinkResult, results;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return genMultiLink(link, subs);
                case 2:
                    multiLinkResult = _ctx.sent;
                    results = multiLinkResult === null || multiLinkResult === void 0 ? void 0 : multiLinkResult.results;
                    if (!(results && results[0])) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", results[0]);
                case 6:
                    return _ctx.abrupt("return", null);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function genLinkV2(link, subs) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = (accountApi);


/***/ }),

/***/ 79206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RG": function() { return /* binding */ setProfile; },
/* harmony export */   "tM": function() { return /* binding */ selectProfile; }
/* harmony export */ });
/* unused harmony export getProfile */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5700);

var initialState = {
    kol: null
};
var profileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "profile",
    initialState: initialState,
    reducers: {
        setProfile: function setProfile(state, action) {
            state.kol = action.payload;
        }
    }
});
function getProfile(state) {
    return state.user.kol;
}
var setProfile = profileSlice.actions.setProfile;
var selectProfile = function(state) {
    return state.user.kol;
};
var userReducer = profileSlice.reducer;
/* harmony default export */ __webpack_exports__["ZP"] = (userReducer);


/***/ }),

/***/ 53025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MyApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/globals.css
var globals = __webpack_require__(47107);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var es = __webpack_require__(92145);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/app/i18n.ts + 5 modules
var i18n = __webpack_require__(77510);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(5700);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var redux_saga_symbols_esm_IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var redux_saga_symbols_esm_SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var redux_saga_symbols_esm_TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');



// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/is/dist/redux-saga-is.esm.js


var undef = function undef(v) {
  return v === null || v === undefined;
};
var redux_saga_is_esm_notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var redux_saga_is_esm_func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var redux_saga_is_esm_string = function string(s) {
  return typeof s === 'string';
};
var redux_saga_is_esm_array = Array.isArray;
var redux_saga_is_esm_object = function object(obj) {
  return obj && !redux_saga_is_esm_array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && redux_saga_is_esm_func(p.then);
};
var iterator = function iterator(it) {
  return it && redux_saga_is_esm_func(it.next) && redux_saga_is_esm_func(it.throw);
};
var iterable = function iterable(it) {
  return it && redux_saga_is_esm_func(Symbol) ? redux_saga_is_esm_func(it[Symbol.iterator]) : redux_saga_is_esm_array(it);
};
var task = function task(t) {
  return t && t[TASK];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[SAGA_ACTION]);
};
var observable = function observable(ob) {
  return ob && redux_saga_is_esm_func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && redux_saga_is_esm_func(buf.isEmpty) && redux_saga_is_esm_func(buf.take) && redux_saga_is_esm_func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (redux_saga_is_esm_string(pat) || symbol(pat) || redux_saga_is_esm_func(pat) || redux_saga_is_esm_array(pat) && pat.every(pattern));
};
var channel = function channel(ch) {
  return ch && redux_saga_is_esm_func(ch.take) && redux_saga_is_esm_func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return redux_saga_is_esm_func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return channel(ch) && ch[MULTICAST];
};
var redux_saga_is_esm_effect = function effect(eff) {
  return eff && eff[IO];
};



;// CONCATENATED MODULE: ./node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {}

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[CANCEL] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ var redux_saga_delay_p_esm = (delayP);

;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/io-40341e1a.js





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop = function noop() {};

if (false) {}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function io_40341e1a_check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  (0,esm_extends/* default */.Z)(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function io_40341e1a_once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {}

    return dispatch(Object.defineProperty(action, redux_saga_symbols_esm_SAGA_ACTION, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === TERMINATE;
};
var shouldCancel = function shouldCancel(res) {
  return res === TASK_CANCEL;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {}

  var completedCount = 0;
  var completed;
  var results = redux_saga_is_esm_array(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[SAGA_LOCATION];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop,
  take: noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var io_40341e1a_none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var io_40341e1a_sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: io_40341e1a_none,
  fixed: fixed,
  dropping: dropping,
  sliding: io_40341e1a_sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var io_40341e1a_CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: io_40341e1a_CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[redux_saga_symbols_esm_IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return effect(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {}

  return makeEffect(FORK, _extends({}, eff.payload, {
    detached: true
  }));
};
function io_40341e1a_take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {}

  if (pattern(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (multicast(patternOrChannel) && redux_saga_is_esm_notUndef(multicastPattern) && pattern(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (channel(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {}
}
var takeMaybe = function takeMaybe() {
  var eff = io_40341e1a_take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {}

  if (undef(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function io_40341e1a_all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function io_40341e1a_race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  io_40341e1a_check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    io_40341e1a_check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    io_40341e1a_check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    io_40341e1a_check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    io_40341e1a_check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  io_40341e1a_check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (redux_saga_is_esm_func(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (redux_saga_is_esm_array(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && redux_saga_is_esm_string(fn) && redux_saga_is_esm_func(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== io_40341e1a_delay;
};

function io_40341e1a_call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) { var arg0; }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {}

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function io_40341e1a_fork(fnDescriptor) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(io_40341e1a_fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {}

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = SELF_CANCELLATION;
  }

  if (false) {}

  return makeEffect(io_40341e1a_CANCEL, taskOrTasks);
}
function io_40341e1a_select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {}

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function io_40341e1a_actionChannel(pattern$1, buffer$1) {
  if (false) {}

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {}

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {}

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {}

  return makeEffect(SET_CONTEXT, props);
}
var io_40341e1a_delay =
/*#__PURE__*/
io_40341e1a_call.bind(null, redux_saga_delay_p_esm);



// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/deferred/dist/redux-saga-deferred.esm.js
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ var redux_saga_deferred_esm = (deferred);


;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-core.esm.js











var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    redux_saga_core_esm_flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    redux_saga_core_esm_flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function redux_saga_core_esm_flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var redux_saga_core_esm_array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var redux_saga_core_esm_string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var redux_saga_core_esm_symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return kTrue;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : redux_saga_is_esm_string(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_array(pattern) ? redux_saga_core_esm_array : stringableFunc(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_func(pattern) ? predicate : symbol(pattern) ? redux_saga_core_esm_symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: CHANNEL_END_TYPE
};
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function redux_saga_core_esm_channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = expanding();
  }

  var closed = false;
  var takers = [];

  if (false) {}

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw internalErr('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        remove(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {}

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = none();
  }

  var closed = false;
  var unsubscribe;
  var chan = redux_saga_core_esm_channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {}

  unsubscribe = once(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {}

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[MULTICAST] = true, _ref.put = function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[MATCH](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {}

    if (closed) {
      cb(END);
      return;
    }

    cb[MATCH] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = io_40341e1a_once(function () {
      ensureCanMutateNextTakers();
      remove(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[redux_saga_symbols_esm_SAGA_ACTION]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var redux_saga_core_esm_CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[CANCEL];

  if (redux_saga_is_esm_func(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;
var nextSagaId = (function () {
  return ++current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return getMetaInfo(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (iterator(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !promise(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return makeIterator(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return makeIterator(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && promise(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(TERMINATE);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, redux_saga_is_esm_notUndef(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if (promise(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (iterator(result)) {
      // resolve iterator
      proc(env, result, task.context, current, getMetaInfo(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if (undef(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) remove(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (redux_saga_is_esm_array(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = createAllStyleChildCallbacks(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === SELF_CANCELLATION) {
    cancelSingleTask(task);
  } else if (redux_saga_is_esm_array(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(redux_saga_is_esm_array(effects) ? [] : {});
    return;
  }

  var childCallbacks = createAllStyleChildCallbacks(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = redux_saga_is_esm_array(effects) ? createEmptyArray(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = noop;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = redux_saga_core_esm_channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  assignWithSymbols(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[TAKE] = runTakeEffect, _effectRunnerMap[PUT] = runPutEffect, _effectRunnerMap[ALL] = runAllEffect, _effectRunnerMap[RACE] = runRaceEffect, _effectRunnerMap[CALL] = runCallEffect, _effectRunnerMap[CPS] = runCPSEffect, _effectRunnerMap[FORK] = runForkEffect, _effectRunnerMap[JOIN] = runJoinEffect, _effectRunnerMap[io_40341e1a_CANCEL] = runCancelEffect, _effectRunnerMap[SELECT] = runSelectEffect, _effectRunnerMap[ACTION_CHANNEL] = runChannelEffect, _effectRunnerMap[CANCELLED] = runCancelledEffect, _effectRunnerMap[FLUSH] = runFlushEffect, _effectRunnerMap[GET_CONTEXT] = runGetContextEffect, _effectRunnerMap[SET_CONTEXT] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      remove(tasks, task);
      task.cont = noop;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = getLocation(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = flatMap(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var redux_saga_core_esm_toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = noop;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = redux_saga_core_esm_CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(TASK_CANCEL, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === TASK_CANCEL) {
        status = redux_saga_core_esm_CANCELLED;
      } else if (status !== redux_saga_core_esm_CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = redux_saga_core_esm_toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {}

    assignWithSymbols(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = redux_saga_deferred_esm();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[redux_saga_symbols_esm_TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === redux_saga_core_esm_CANCELLED || status === RUNNING && mainTask.status === redux_saga_core_esm_CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {}

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = noop;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = redux_saga_core_esm_CANCELLED;
      next(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (shouldCancel(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = redux_saga_core_esm_CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (shouldTerminate(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== redux_saga_core_esm_CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === redux_saga_core_esm_CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (promise(effect)) {
      resolvePromise(effect, currCb);
    } else if (iterator(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[redux_saga_symbols_esm_IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = noop; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = noop; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = noop; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? logError : _ref$onError;

  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {}

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || noop;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || noop;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || noop;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || noop;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || noop;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || noop;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) { var MIDDLEWARE_TYPE_ERROR; }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = redux/* compose.apply */.qC.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = identity;
  }

  var env = {
    channel: channel,
    dispatch: wrapSagaDispatch(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, getMetaInfo(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {}

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, (0,esm_extends/* default */.Z)({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {}

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {}

    assignWithSymbols(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ var redux_saga_core_esm = (sagaMiddlewareFactory);


;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js





/* harmony default export */ var redux_saga_core_npm_proxy_esm = (redux_saga_core_esm);

;// CONCATENATED MODULE: ./src/features/counter/counterAPI.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

function fetchCount() {
    return _fetchCount.apply(this, arguments);
}
function _fetchCount() {
    _fetchCount = _asyncToGenerator(runtime_default().mark(function _callee() {
        var amount, response, result, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    amount = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 1;
                    _ctx.next = 3;
                    return fetch("/api/counter", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            amount: amount
                        })
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchCount.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/features/counter/counterSlice.ts
function counterSlice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function counterSlice_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                counterSlice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                counterSlice_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var initialState = {
    value: 0,
    status: "idle"
};
// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
var incrementAsync = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("counter/fetchCount", function() {
    var _ref = counterSlice_asyncToGenerator(runtime_default().mark(function _callee(amount) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchCount(amount);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(amount) {
        return _ref.apply(this, arguments);
    };
}());
var counterSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "counter",
    initialState: initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        increment: function(state) {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value += 1;
        },
        decrement: function(state) {
            state.value -= 1;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        incrementByAmount: function(state, action) {
            state.value += action.payload;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: function(builder) {
        builder.addCase(incrementAsync.pending, function(state) {
            state.status = "loading";
        }).addCase(incrementAsync.fulfilled, function(state, action) {
            state.status = "idle";
            state.value += action.payload;
        });
    }
});
var _actions = counterSlice.actions;
var increment = _actions.increment, decrement = _actions.decrement, incrementByAmount = _actions.incrementByAmount;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
var selectCount = function(state) {
    return state.counter.value;
};
// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
var incrementIfOdd = function(amount) {
    return function(dispatch, getState) {
        var currentValue = selectCount(getState());
        if (currentValue % 2 === 1) {
            dispatch(incrementByAmount(amount));
        }
    };
};
/* harmony default export */ var counter_counterSlice = (counterSlice.reducer);

// EXTERNAL MODULE: ./src/features/user/userSlice.ts
var userSlice = __webpack_require__(79206);
// EXTERNAL MODULE: ./src/features/main/store/positionsSlice.ts + 2 modules
var positionsSlice = __webpack_require__(99265);
// EXTERNAL MODULE: ./src/features/main/store/siteSettingSlice.ts
var siteSettingSlice = __webpack_require__(24882);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/main/store/passioPageProfileSlice.ts
var passioPageProfileSlice = __webpack_require__(69067);
;// CONCATENATED MODULE: ./src/features/video-shoutout/store/videoShoutoutSlice.ts

var videoShoutoutSlice_initialState = {
    isUploading: false
};
var videoShoutoutSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "videoShoutout",
    initialState: videoShoutoutSlice_initialState,
    reducers: {
        setUploading: function(state, action) {
            state.isUploading = action.payload;
        }
    }
});
var videoShoutoutAction = videoShoutoutSlice.actions;
/* harmony default export */ var store_videoShoutoutSlice = (videoShoutoutSlice.reducer);

// EXTERNAL MODULE: ./src/features/design/store/externalStateSlice.ts
var externalStateSlice = __webpack_require__(42372);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-effects.esm.js







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if (channel(patternOrChannel)) {
    return 'channel';
  }

  if (stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (redux_saga_is_esm_func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return makeIterator(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_40341e1a_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_40341e1a_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_40341e1a_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_40341e1a_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: cancel(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: call.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel;
  var yActionChannel = {
    done: false,
    value: actionChannel(pattern, sliding(1))
  };

  var yTake = function yTake() {
    return {
      done: false,
      value: take(channel)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: delay(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, 'q1', "throttle(" + safeName(pattern) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: call.apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: delay(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: race({
      action: take(patternOrChannel),
      debounce: delay(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return io_40341e1a_fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io_40341e1a_fork.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, pattern, worker) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return fork.apply(void 0, [throttle, ms, pattern, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}



;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js


// EXTERNAL MODULE: ./src/features/block/api/index.tsx + 1 modules
var api = __webpack_require__(57457);
// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
// EXTERNAL MODULE: ./src/features/block/store/helper/index.tsx
var helper = __webpack_require__(80560);
;// CONCATENATED MODULE: ./src/features/main/store/savingItemSlice.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var savingItemSlice_initialState = [];
var savingItemSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "savingItem",
    initialState: savingItemSlice_initialState,
    reducers: {
        pushSavingItem: function(state, action) {
            var payload = action.payload;
            return _toConsumableArray(state).concat([
                payload.item
            ]);
        },
        releaseSavingItem: function(state, action) {
            return state.filter(function(item) {
                return item.id !== action.payload.id;
            });
        },
        executeSavingItem: function(state, action) {},
        callBackSavingItem: function(state, action) {}
    }
});
var savingItemSlice_actions = savingItemSlice.actions;
var pushSavingItem = savingItemSlice_actions.pushSavingItem, releaseSavingItem = savingItemSlice_actions.releaseSavingItem, executeSavingItem = savingItemSlice_actions.executeSavingItem, callBackSavingItem = savingItemSlice_actions.callBackSavingItem;
/* harmony default export */ var store_savingItemSlice = (savingItemSlice.reducer);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/features/main/store/saga/saving-item.ts
function saving_item_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function saving_item_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return saving_item_arrayLikeToArray(arr);
}
function saving_item_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function saving_item_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                saving_item_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                saving_item_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function saving_item_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function saving_item_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function saving_item_toConsumableArray(arr) {
    return saving_item_arrayWithoutHoles(arr) || saving_item_iterableToArray(arr) || saving_item_unsupportedIterableToArray(arr) || saving_item_nonIterableSpread();
}
function saving_item_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return saving_item_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return saving_item_arrayLikeToArray(o, minLen);
}

var _marked = runtime_default().mark(savingItemSaga);





function generateSavingProcessId(prefix) {
    return "".concat(prefix, "-") + (0,v4/* default */.Z)();
}
function savingItemSaga() {
    var saveChannel, payload1, isReponseValidDefault, getVersionFromResponseDefault, item, _isResponseValid, isResponseValid, _getVersionFromResponse, getVersionFromResponse, baseData, excuteArguments, res1, version;
    return runtime_default().wrap(function savingItemSaga$(_ctx1) {
        while(1)switch(_ctx1.prev = _ctx1.next){
            case 0:
                _ctx1.next = 2;
                return takeEvery$1(pushSavingItem.type, runtime_default().mark(function _callee(action) {
                    var payload, savingProcess, isSaving;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                payload = action.payload;
                                _ctx.next = 3;
                                return io_40341e1a_select(function(state) {
                                    return state.savingItem;
                                });
                            case 3:
                                savingProcess = _ctx.sent;
                                isSaving = savingProcess && savingProcess.length > 0;
                                _ctx.next = 7;
                                return put((0,dynamicSlice/* setDynamicParams */.B9)({
                                    data: {
                                        isSaving: isSaving
                                    }
                                }));
                            case 7:
                                _ctx.next = 9;
                                return put(executeSavingItem(payload));
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
                _ctx1.next = 4;
                return takeEvery$1(releaseSavingItem.type, runtime_default().mark(function _callee(action) {
                    var savingProcess, isSaving;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.savingItem;
                                });
                            case 2:
                                savingProcess = _ctx.sent;
                                isSaving = savingProcess && savingProcess.length > 0;
                                _ctx.next = 6;
                                return put((0,dynamicSlice/* setDynamicParams */.B9)({
                                    data: {
                                        isSaving: isSaving
                                    }
                                }));
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 4:
                _ctx1.next = 6;
                return io_40341e1a_actionChannel(executeSavingItem.type);
            case 6:
                saveChannel = _ctx1.sent;
            case 7:
                if (false) {}
                _ctx1.next = 10;
                return io_40341e1a_take(saveChannel);
            case 10:
                payload1 = _ctx1.sent.payload;
                isReponseValidDefault = function() {
                    var _ref = saving_item_asyncToGenerator(runtime_default().mark(function _callee(res) {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    return _ctx.abrupt("return", true);
                                case 1:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function isReponseValidDefault(res) {
                        return _ref.apply(this, arguments);
                    };
                }();
                getVersionFromResponseDefault = function() {
                    var _ref = saving_item_asyncToGenerator(runtime_default().mark(function _callee(res) {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    return _ctx.abrupt("return", res.data.version);
                                case 1:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function getVersionFromResponseDefault(res) {
                        return _ref.apply(this, arguments);
                    };
                }();
                item = payload1.item;
                _isResponseValid = item.isResponseValid, isResponseValid = _isResponseValid === void 0 ? isReponseValidDefault : _isResponseValid, _getVersionFromResponse = item.getVersionFromResponse, getVersionFromResponse = _getVersionFromResponse === void 0 ? getVersionFromResponseDefault : _getVersionFromResponse;
                _ctx1.next = 17;
                return io_40341e1a_select(function(state) {
                    var siteSetting = state.siteSettings;
                    return {
                        site_setting_id: siteSetting.id,
                        user_id: siteSetting.user_id,
                        version: siteSetting.version
                    };
                });
            case 17:
                baseData = _ctx1.sent;
                excuteArguments = item.getArguments(baseData);
                _ctx1.prev = 19;
                _ctx1.next = 22;
                return io_40341e1a_call.apply(void 0, [
                    item.executer
                ].concat(saving_item_toConsumableArray(excuteArguments)));
            case 22:
                res1 = _ctx1.sent;
                _ctx1.next = 25;
                return io_40341e1a_call(getVersionFromResponse, res1);
            case 25:
                version = _ctx1.sent;
                _ctx1.next = 28;
                return put((0,siteSettingSlice/* setVersion */.xO)({
                    version: version
                }));
            case 28:
                _ctx1.next = 30;
                return put((0,siteSettingSlice/* setHasChange */.rm)({
                    has_change: true
                }));
            case 30:
                _ctx1.next = 32;
                return put(callBackSavingItem({
                    id: item.id,
                    data: res1
                }));
            case 32:
                _ctx1.next = 38;
                break;
            case 34:
                _ctx1.prev = 34;
                _ctx1.t0 = _ctx1["catch"](19);
                _ctx1.next = 38;
                return put((0,dynamicSlice/* setError */.sT)({
                    is_error: true
                }));
            case 38:
                _ctx1.next = 40;
                return put(releaseSavingItem({
                    id: item.id
                }));
            case 40:
                _ctx1.next = 7;
                break;
            case 42:
            case "end":
                return _ctx1.stop();
        }
    }, _marked, null, [
        [
            19,
            34
        ]
    ]);
}
/* harmony default export */ var saving_item = (savingItemSaga);

// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 91 modules
var block_conf = __webpack_require__(60920);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./src/features/block/store/saga/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var saga_marked = runtime_default().mark(blockSaga);
var _marked1 = runtime_default().mark(handleCallBack);
var _marked2 = runtime_default().mark(handleSavingAction);











function handleSavingAction() {
    return runtime_default().wrap(function handleSavingAction$(_ctx1) {
        while(1)switch(_ctx1.prev = _ctx1.next){
            case 0:
                _ctx1.next = 2;
                return takeEvery$1(positionsSlice/* updateBlock.type */.Df.type, runtime_default().mark(function _callee(action) {
                    var blockData, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return put((0,positionsSlice/* setBlock */.sk)(action.payload));
                            case 2:
                                blockData = action.payload.blockData;
                                savingProcessId = generateSavingProcessId("update-block");
                                _ctx.next = 6;
                                return put((0,dynamicSlice/* addPendingProcessData */.ip)({
                                    id: savingProcessId,
                                    data: action.payload
                                }));
                            case 6:
                                _ctx.next = 8;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* saveBlock */.K1,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                blockData
                                            ];
                                        }
                                    }
                                }));
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
                _ctx1.next = 4;
                return takeEvery$1(positionsSlice/* deleteBlock.type */.Gc.type, runtime_default().mark(function _callee(action) {
                    var ref, ref1, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _ctx.next = 3;
                                return put((0,positionsSlice/* removeBlock */.N$)(action.payload));
                            case 3:
                                if (!(action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.deletedBlock) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                                    _ctx.next = 7;
                                    break;
                                }
                                savingProcessId = generateSavingProcessId("delete-block");
                                _ctx.next = 7;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* deleteBlock */.Gc,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                action.payload.deletedBlock.id
                                            ];
                                        }
                                    }
                                }));
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 4:
                _ctx1.next = 6;
                return takeEvery$1(positionsSlice/* addBlock.type */.U6.type, runtime_default().mark(function _callee(action) {
                    var ref3, ref2, blockLists, positions, _payload, blockData, positionSlug, tabUid, tabs, blockListsSortOrder, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                blockLists = [];
                                _ctx.next = 4;
                                return io_40341e1a_select(function(state) {
                                    return state.positions;
                                });
                            case 4:
                                positions = _ctx.sent;
                                _payload = action.payload, blockData = _payload.blockData, positionSlug = _payload.positionSlug, tabUid = _payload.tabUid;
                                tabs = (ref3 = positions.find(function(position) {
                                    return position.slug == store_interface/* POSITION_SLUG.BODY */.bW.BODY;
                                }).block_list.find(function(item) {
                                    return item.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
                                })) === null || ref3 === void 0 ? void 0 : (ref2 = ref3.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
                                positions.forEach(function(position) {
                                    if ((position === null || position === void 0 ? void 0 : position.slug) !== positionSlug) return;
                                    if (positionSlug !== store_interface/* POSITION_SLUG.BODY */.bW.BODY) {
                                        blockLists = position === null || position === void 0 ? void 0 : position.block_list;
                                    } else {
                                        var ref;
                                        blockLists = (ref = tabs === null || tabs === void 0 ? void 0 : tabs.find(function(x) {
                                            return (x === null || x === void 0 ? void 0 : x.uid) === tabUid;
                                        })) === null || ref === void 0 ? void 0 : ref.block_list;
                                    }
                                });
                                blockListsSortOrder = blockLists === null || blockLists === void 0 ? void 0 : blockLists.map(function(block, idx) {
                                    return _objectSpread({}, block, {
                                        sort_order: idx + 1
                                    });
                                });
                                savingProcessId = generateSavingProcessId("add-block");
                                _ctx.next = 12;
                                return put((0,dynamicSlice/* addPendingProcessData */.ip)({
                                    id: savingProcessId,
                                    data: action.payload
                                }));
                            case 12:
                                _ctx.next = 14;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* saveBlock */.K1,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                blockData
                                            ];
                                        }
                                    }
                                }));
                            case 14:
                                _ctx.next = 16;
                                return put((0,positionsSlice/* sortBlock */.K6)({
                                    itemsOrder: blockListsSortOrder,
                                    positionSlug: positionSlug,
                                    tabUid: tabUid
                                }));
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 6:
                _ctx1.next = 8;
                return takeEvery$1(positionsSlice/* sortBlock.type */.K6.type, runtime_default().mark(function _callee(action) {
                    var ref, blockList, sortData, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                blockList = action.payload.itemsOrder;
                                sortData = (ref = blockList === null || blockList === void 0 ? void 0 : blockList.filter(function(x) {
                                    return x.id;
                                })) === null || ref === void 0 ? void 0 : ref.map(function(block) {
                                    return {
                                        id: block.id,
                                        sort_order: block.sort_order
                                    };
                                });
                                savingProcessId = generateSavingProcessId("sort-block");
                                _ctx.next = 6;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* sortBlock */.K6,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                sortData
                                            ];
                                        }
                                    }
                                }));
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 8:
                _ctx1.next = 10;
                return takeEvery$1(positionsSlice/* disableEnableBlock.type */.a8.type, runtime_default().mark(function _callee(action) {
                    var positions, _payload, blockStatus, blockUid, positionSlug, tabUid, block, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.positions;
                                });
                            case 2:
                                positions = _ctx.sent;
                                _payload = action.payload, blockStatus = _payload.blockStatus, blockUid = _payload.blockUid, positionSlug = _payload.positionSlug, tabUid = _payload.tabUid;
                                block = (0,helper/* findBlock */.C)(positions, {
                                    uid: blockUid,
                                    positionSlug: positionSlug,
                                    tabUid: tabUid
                                });
                                savingProcessId = generateSavingProcessId("change-block-status");
                                _ctx.next = 8;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* saveAttributes */.PM,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                block.id,
                                                {
                                                    enable: blockStatus
                                                }
                                            ];
                                        }
                                    }
                                }));
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 10:
                _ctx1.next = 12;
                return takeEvery$1(positionsSlice/* moveBlockToPosition.type */.wY.type, runtime_default().mark(function _callee(action) {
                    var ref, _payload, blockData, newPositionSlug, newTabUid, positions, block, positionId, parentId, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _payload = action.payload, blockData = _payload.blockData, newPositionSlug = _payload.newPositionSlug, newTabUid = _payload.newTabUid;
                                _ctx.next = 4;
                                return io_40341e1a_select(function(state) {
                                    return state.positions;
                                });
                            case 4:
                                positions = _ctx.sent;
                                block = (0,helper/* findBlock */.C)(positions, {
                                    uid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
                                    positionSlug: newPositionSlug,
                                    tabUid: newTabUid
                                });
                                positionId = newPositionSlug !== "body" ? (ref = positions === null || positions === void 0 ? void 0 : positions.find(function(x) {
                                    return (x === null || x === void 0 ? void 0 : x.slug) === newPositionSlug;
                                })) === null || ref === void 0 ? void 0 : ref.id : "0";
                                parentId = (0,helper/* getParentId */.r)(positions, {
                                    positionSlug: newPositionSlug,
                                    tabUid: newTabUid
                                });
                                savingProcessId = generateSavingProcessId("move-block-to-position");
                                _ctx.next = 11;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* saveAttributes */.PM,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                block.id,
                                                {
                                                    tab_uid: newTabUid || "0",
                                                    position_id: positionId,
                                                    parent_id: parentId,
                                                    sort_order: block === null || block === void 0 ? void 0 : block.sort_order
                                                }, 
                                            ];
                                        }
                                    }
                                }));
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 12:
                _ctx1.next = 14;
                return takeEvery$1(positionsSlice/* addBlock.type */.U6.type, runtime_default().mark(function _callee(action) {
                    var firstGuidState;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.externalState.guide_state;
                                });
                            case 2:
                                firstGuidState = _ctx.sent;
                                if (!(firstGuidState == externalStateSlice/* FirstGuideStateEnum.ADD_BLOCK */.x9.ADD_BLOCK)) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _ctx.next = 6;
                                return put((0,externalStateSlice/* setFirstGuideState */.lA)(externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW));
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 14:
                _ctx1.next = 16;
                return takeEvery$1(positionsSlice/* updateTabsBody.type */.g2.type, runtime_default().mark(function _callee(action) {
                    var positions, tabs, blockId, data, updateTabsData, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.positions;
                                });
                            case 2:
                                positions = _ctx.sent;
                                tabs = positions.find(function(position) {
                                    return position.slug == "body";
                                }).block_list.find(function(item) {
                                    return item.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
                                });
                                blockId = tabs.id;
                                data = action.payload.data;
                                updateTabsData = data.map(function(item) {
                                    return pick_default()(item, [
                                        "enable",
                                        "icon",
                                        "icon_url",
                                        "isDefault",
                                        "name",
                                        "sort_order",
                                        "uid", 
                                    ]);
                                });
                                savingProcessId = generateSavingProcessId("update-tabs-info");
                                _ctx.next = 10;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: api/* saveTabsAttributes */.Ro,
                                        getArguments: function(baseUpdateData) {
                                            return [
                                                baseUpdateData,
                                                blockId,
                                                updateTabsData
                                            ];
                                        }
                                    }
                                }));
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 16:
            case "end":
                return _ctx1.stop();
        }
    }, _marked2);
}
function handleCallBack() {
    return runtime_default().wrap(function handleCallBack$(_ctx2) {
        while(1)switch(_ctx2.prev = _ctx2.next){
            case 0:
                _ctx2.next = 2;
                return takeEvery$1(callBackSavingItem.type, runtime_default().mark(function _callee(action) {
                    var payload, id, processDataState, pendingProcessData, res, blockData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                payload = action.payload;
                                id = payload.id;
                                if (!(id && (id.startsWith("add-block") || id.startsWith("update-block")))) {
                                    _ctx.next = 13;
                                    break;
                                }
                                _ctx.next = 5;
                                return io_40341e1a_select(function(state) {
                                    return state.dynamicConfig.pendingProcessData;
                                });
                            case 5:
                                processDataState = _ctx.sent;
                                pendingProcessData = processDataState.find(function(item) {
                                    return item.id == id;
                                });
                                res = payload.data;
                                blockData = res.data.data;
                                _ctx.next = 11;
                                return put((0,positionsSlice/* setBlock */.sk)(_objectSpread({}, pendingProcessData.data, {
                                    blockData: blockData
                                })));
                            case 11:
                                _ctx.next = 13;
                                return put((0,dynamicSlice/* removePendingProcessData */.bu)({
                                    id: id
                                }));
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _ctx2.stop();
        }
    }, _marked1);
}
function blockSaga() {
    return runtime_default().wrap(function blockSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return io_40341e1a_all([
                    handleSavingAction(),
                    handleCallBack()
                ]);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, saga_marked);
}
/* harmony default export */ var saga = (blockSaga);

;// CONCATENATED MODULE: ./src/features/main/store/savingProcessSlice.ts
function savingProcessSlice_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function savingProcessSlice_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return savingProcessSlice_arrayLikeToArray(arr);
}
function savingProcessSlice_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function savingProcessSlice_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function savingProcessSlice_toConsumableArray(arr) {
    return savingProcessSlice_arrayWithoutHoles(arr) || savingProcessSlice_iterableToArray(arr) || savingProcessSlice_unsupportedIterableToArray(arr) || savingProcessSlice_nonIterableSpread();
}
function savingProcessSlice_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return savingProcessSlice_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return savingProcessSlice_arrayLikeToArray(o, minLen);
}

var savingProcessSlice_initialState = [];
var savingProcessSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "savingProcess",
    initialState: savingProcessSlice_initialState,
    reducers: {
        addSavingElement: function(state, action) {
            return savingProcessSlice_toConsumableArray(state).concat([
                action.payload.element
            ]);
        },
        releaseSavingElement: function(state, action) {
            return state.filter(function(item) {
                return item.id !== action.payload.id;
            });
        }
    }
});
var savingProcessSlice_actions = savingProcessSlice.actions;
var addSavingElement = savingProcessSlice_actions.addSavingElement, releaseSavingElement = savingProcessSlice_actions.releaseSavingElement;
/* harmony default export */ var store_savingProcessSlice = (savingProcessSlice.reducer);

;// CONCATENATED MODULE: ./src/features/main/store/saga/saving-process.ts

var saving_process_marked = runtime_default().mark(savingProcessSaga);



function savingProcessSaga() {
    return runtime_default().wrap(function savingProcessSaga$(_ctx1) {
        while(1)switch(_ctx1.prev = _ctx1.next){
            case 0:
                _ctx1.next = 2;
                return takeEvery$1(addSavingElement.type, runtime_default().mark(function _callee(action) {
                    var savingProcess, isSaving;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.savingProcess;
                                });
                            case 2:
                                savingProcess = _ctx.sent;
                                isSaving = savingProcess && savingProcess.length > 0;
                                _ctx.next = 6;
                                return put((0,dynamicSlice/* setDynamicParams */.B9)({
                                    data: {
                                        isSaving: isSaving
                                    }
                                }));
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
                _ctx1.next = 4;
                return takeEvery$1(releaseSavingElement.type, runtime_default().mark(function _callee(action) {
                    var savingProcess, isSaving;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return io_40341e1a_select(function(state) {
                                    return state.savingProcess;
                                });
                            case 2:
                                savingProcess = _ctx.sent;
                                isSaving = savingProcess && savingProcess.length > 0;
                                _ctx.next = 6;
                                return put((0,dynamicSlice/* setDynamicParams */.B9)({
                                    data: {
                                        isSaving: isSaving
                                    }
                                }));
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 4:
            case "end":
                return _ctx1.stop();
        }
    }, saving_process_marked);
}
/* harmony default export */ var saving_process = (savingProcessSaga);

// EXTERNAL MODULE: ./src/features/share/api/createAxios.ts
var createAxios = __webpack_require__(88549);
;// CONCATENATED MODULE: ./src/features/main/api/position.ts
function position_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function position_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            position_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var API_PATH = {
    SAVE_ATTRIBUTES: "/api/v1/builder/position/update-attributes"
};
var gatewayInstance = (0,createAxios/* CreateGatewayAxios */.Ev)();
var saveAttributes = function(id, baseData, data) {
    return gatewayInstance.post(API_PATH.SAVE_ATTRIBUTES, position_objectSpread({}, baseData, {
        data: {
            id: id,
            update_data: data
        }
    }));
};

;// CONCATENATED MODULE: ./src/features/main/store/saga/position.ts

var position_marked = runtime_default().mark(positionSaga);





function positionSaga() {
    return runtime_default().wrap(function positionSaga$(_ctx1) {
        while(1)switch(_ctx1.prev = _ctx1.next){
            case 0:
                _ctx1.next = 2;
                return takeEvery$1(positionsSlice/* disableEnablePosition.type */.uX.type, runtime_default().mark(function _callee(action) {
                    var payload, positionSlug, enableValue, positions, position, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                payload = action.payload;
                                positionSlug = payload.positionSlug, enableValue = payload.enableValue;
                                _ctx.next = 4;
                                return io_40341e1a_select(function(state) {
                                    return state.positions;
                                });
                            case 4:
                                positions = _ctx.sent;
                                position = positions.find(function(item) {
                                    return item.slug == positionSlug;
                                });
                                savingProcessId = generateSavingProcessId("change-position-status");
                                _ctx.next = 9;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: saveAttributes,
                                        getArguments: function(baseData) {
                                            return [
                                                position.id,
                                                baseData,
                                                {
                                                    enable: enableValue
                                                }
                                            ];
                                        }
                                    }
                                }));
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _ctx1.stop();
        }
    }, position_marked);
}
/* harmony default export */ var position = (positionSaga);

;// CONCATENATED MODULE: ./src/features/main/api/display-setting.ts
function display_setting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function display_setting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            display_setting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var display_setting_API_PATH = {
    SAVE_DISPlAY_SETTING: "/api/v1/builder/site-setting/display-setting-v2"
};
// interface SaveAttributeData {
//     title?: string
//     enable?: number
// }
var display_setting_gatewayInstance = (0,createAxios/* CreateGatewayAxios */.Ev)();
var saveDiplaySetting = function(id, baseData, data) {
    return display_setting_gatewayInstance.post(display_setting_API_PATH.SAVE_DISPlAY_SETTING, display_setting_objectSpread({
        id: id
    }, baseData, {
        site_setting_id: undefined,
        data: {
            display_setting: data
        }
    }));
};

;// CONCATENATED MODULE: ./src/features/main/store/saga/site-setting.ts

var site_setting_marked = runtime_default().mark(siteSettingSaga);





function siteSettingSaga() {
    return runtime_default().wrap(function siteSettingSaga$(_ctx1) {
        while(1)switch(_ctx1.prev = _ctx1.next){
            case 0:
                _ctx1.next = 2;
                return takeLatest$1(siteSettingSlice/* setDisplaySetting.type */.H9.type, runtime_default().mark(function _callee(action) {
                    var payload, siteSetting, savingProcessId;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                payload = action.payload;
                                _ctx.next = 3;
                                return io_40341e1a_select(function(state) {
                                    return state.siteSettings;
                                });
                            case 3:
                                siteSetting = _ctx.sent;
                                savingProcessId = generateSavingProcessId("change-display-setting");
                                _ctx.next = 7;
                                return put(pushSavingItem({
                                    item: {
                                        id: savingProcessId,
                                        executer: saveDiplaySetting,
                                        getArguments: function(baseData) {
                                            return [
                                                siteSetting.id,
                                                baseData,
                                                payload.data
                                            ];
                                        }
                                    }
                                }));
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            case 2:
            case "end":
                return _ctx1.stop();
        }
    }, site_setting_marked);
}
/* harmony default export */ var site_setting = (siteSettingSaga);

// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/store/digitalProductSlice.ts
var digitalProductSlice = __webpack_require__(60821);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/features/design/api/index.ts
function api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function api_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                api_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var api_API_PATH = {
    EXTERNAL_STATE: "/api/v1/builder/website-config/external-state",
    SAVE_GUIDE_STATUS: "/api/v1/builder/website-config/update-first-guide-state",
    SAVE_INTRODUCE_DOUBLE_TAP_STATUS: "/api/v1/builder/website-config/update-status-introduce-double-tap"
};
var api_gatewayInstance = (0,createAxios/* CreateGatewayAxios */.Ev)();
var getGuideState = function(user_id) {
    return api_gatewayInstance.get(api_API_PATH.EXTERNAL_STATE, {
        params: {
            user_id: user_id
        }
    });
};
var setGuideState = function(user_id, state) {
    return api_gatewayInstance.post(api_API_PATH.SAVE_GUIDE_STATUS, {
        user_id: user_id,
        state: state
    });
};
var setIntroduceDoubleTapState = function(user_id, status) {
    return api_gatewayInstance.post(api_API_PATH.SAVE_INTRODUCE_DOUBLE_TAP_STATUS, {
        user_id: user_id,
        status: status
    });
};
var setFloatingIntroduceState = function(user_id, floating_icon) {
    return api_gatewayInstance.post(api_API_PATH.EXTERNAL_STATE, {
        user_id: user_id,
        floating_icon_brand_gift: floating_icon.brand_gift
    });
};
var setFloatingBlockIntroduceState = function(user_id, floating_block) {
    return api_gatewayInstance.post(api_API_PATH.EXTERNAL_STATE, {
        user_id: user_id,
        floating_block_brand_rating: floating_block.brand_rating
    });
};
var checkFontGG = function() {
    var _ref = api_asyncToGenerator(runtime_default().mark(function _callee(fontName, fontWeight) {
        var uri, API_FONT_GG;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uri = "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(fontName.replaceAll(" ", "+"));
                    API_FONT_GG = fontWeight ? "".concat(uri, ":").concat(fontWeight) : uri;
                    return _ctx.abrupt("return", axios_default().get(API_FONT_GG));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkFontGG(fontName, fontWeight) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/design/store/saga/index.ts

var store_saga_marked = runtime_default().mark(externalStateSaga);
var saga_marked1 = runtime_default().mark(setFontWeightAvailable);
var saga_marked2 = runtime_default().mark(setFloatingBlockIntroduction);
var _marked3 = runtime_default().mark(setFloatingIntroduction);
var _marked4 = runtime_default().mark(setIntroduceDoubleTap);
var _marked5 = runtime_default().mark(setFirstUserGuide);
var _marked6 = runtime_default().mark(getExternalStateData);



function getExternalStateData() {
    var userId, data, display_setting;
    return runtime_default().wrap(function getExternalStateData$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.user_id;
                });
            case 3:
                userId = _ctx.sent;
                _ctx.next = 6;
                return io_40341e1a_call(getGuideState, userId);
            case 6:
                data = _ctx.sent.data;
                _ctx.next = 9;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.display_setting;
                });
            case 9:
                display_setting = _ctx.sent;
                _ctx.next = 12;
                return put((0,externalStateSlice/* getExternalStateSuccess */.yT)({
                    guide_state: data.first_guide_state,
                    introduce_double_tap: data.introduce_double_tap,
                    floating_icon: {
                        brand_gift: data === null || data === void 0 ? void 0 : data.floating_icon_brand_gift
                    },
                    floating_block: {
                        brand_rating: data === null || data === void 0 ? void 0 : data.floating_block_brand_rating
                    },
                    data_font: {
                        title: "",
                        paragraph: ""
                    },
                    is_valid_font: true,
                    font_weight_available: [],
                    is_font_loading: false
                }));
            case 12:
                _ctx.next = 17;
                break;
            case 14:
                _ctx.prev = 14;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 17:
            case "end":
                return _ctx.stop();
        }
    }, _marked6, null, [
        [
            0,
            14
        ]
    ]);
}
function setFirstUserGuide(action) {
    var userId, newGuideState;
    return runtime_default().wrap(function setFirstUserGuide$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.user_id;
                });
            case 3:
                userId = _ctx.sent;
                newGuideState = action.payload;
                _ctx.next = 7;
                return io_40341e1a_call(setGuideState, userId, newGuideState);
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, _marked5, null, [
        [
            0,
            9
        ]
    ]);
}
function setIntroduceDoubleTap(action) {
    var userId, payload;
    return runtime_default().wrap(function setIntroduceDoubleTap$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.user_id;
                });
            case 3:
                userId = _ctx.sent;
                payload = action.payload;
                _ctx.next = 7;
                return io_40341e1a_call(setIntroduceDoubleTapState, userId, payload);
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, _marked4, null, [
        [
            0,
            9
        ]
    ]);
}
function setFloatingIntroduction(action) {
    var userId, payload;
    return runtime_default().wrap(function setFloatingIntroduction$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.user_id;
                });
            case 3:
                userId = _ctx.sent;
                payload = action.payload;
                _ctx.next = 7;
                return io_40341e1a_call(setFloatingIntroduceState, userId, payload);
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, _marked3, null, [
        [
            0,
            9
        ]
    ]);
}
function setFloatingBlockIntroduction(action) {
    var userId, payload;
    return runtime_default().wrap(function setFloatingBlockIntroduction$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return io_40341e1a_select(function(state) {
                    return state.siteSettings.user_id;
                });
            case 3:
                userId = _ctx.sent;
                payload = action.payload;
                _ctx.next = 7;
                return io_40341e1a_call(setFloatingBlockIntroduceState, userId, payload);
            case 7:
                _ctx.next = 12;
                break;
            case 9:
                _ctx.prev = 9;
                _ctx.t0 = _ctx["catch"](0);
                console.error(_ctx.t0);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, saga_marked2, null, [
        [
            0,
            9
        ]
    ]);
}
function setFontWeightAvailable(action) {
    var payload, fontName, validResponseFont, responseFontWeight, fontWeightAvailable, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;
    return runtime_default().wrap(function setFontWeightAvailable$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                if (action.payload) {
                    _ctx.next = 2;
                    break;
                }
                return _ctx.abrupt("return");
            case 2:
                payload = action.payload;
                fontName = payload.title || payload.paragraph;
                if (fontName) {
                    _ctx.next = 6;
                    break;
                }
                return _ctx.abrupt("return");
            case 6:
                validResponseFont = null;
                responseFontWeight = null;
                fontWeightAvailable = [];
                _ctx.prev = 9;
                _ctx.next = 12;
                return io_40341e1a_call(checkFontGG, fontName);
            case 12:
                validResponseFont = _ctx.sent;
                _ctx.next = 18;
                break;
            case 15:
                _ctx.prev = 15;
                _ctx.t0 = _ctx["catch"](9);
                console.error("error", _ctx.t0);
            case 18:
                if (validResponseFont) {
                    _ctx.next = 22;
                    break;
                }
                _ctx.next = 21;
                return put((0,externalStateSlice/* setValidFont */.bq)(false));
            case 21:
                return _ctx.abrupt("return");
            case 22:
                _ctx.next = 24;
                return put((0,externalStateSlice/* setValidFont */.bq)(true));
            case 24:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _ctx.prev = 25;
                _iterator = [
                    400,
                    500,
                    600,
                    700,
                    800,
                    900
                ][Symbol.iterator]();
            case 27:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _ctx.next = 41;
                    break;
                }
                item = _step.value;
                _ctx.prev = 29;
                _ctx.next = 32;
                return io_40341e1a_call(checkFontGG, fontName, item);
            case 32:
                responseFontWeight = _ctx.sent;
                if ((responseFontWeight === null || responseFontWeight === void 0 ? void 0 : responseFontWeight.status) === 200 || (responseFontWeight === null || responseFontWeight === void 0 ? void 0 : responseFontWeight.status) === "200") {
                    fontWeightAvailable.push(item);
                }
                _ctx.next = 38;
                break;
            case 36:
                _ctx.prev = 36;
                _ctx.t1 = _ctx["catch"](29);
            case 38:
                _iteratorNormalCompletion = true;
                _ctx.next = 27;
                break;
            case 41:
                _ctx.next = 47;
                break;
            case 43:
                _ctx.prev = 43;
                _ctx.t2 = _ctx["catch"](25);
                _didIteratorError = true;
                _iteratorError = _ctx.t2;
            case 47:
                _ctx.prev = 47;
                _ctx.prev = 48;
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            case 50:
                _ctx.prev = 50;
                if (!_didIteratorError) {
                    _ctx.next = 53;
                    break;
                }
                throw _iteratorError;
            case 53:
                return _ctx.finish(50);
            case 54:
                return _ctx.finish(47);
            case 55:
                _ctx.next = 57;
                return put((0,externalStateSlice/* setValidFontWeight */.aM)(fontWeightAvailable));
            case 57:
            case "end":
                return _ctx.stop();
        }
    }, saga_marked1, null, [
        [
            9,
            15
        ],
        [
            25,
            43,
            47,
            55
        ],
        [
            29,
            36
        ],
        [
            48,
            ,
            50,
            54
        ]
    ]);
}
function externalStateSaga() {
    return runtime_default().wrap(function externalStateSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return takeEvery$1(externalStateSlice/* getExternalState */.DH, getExternalStateData);
            case 2:
                _ctx.next = 4;
                return takeEvery$1(externalStateSlice/* setFirstGuideState */.lA, setFirstUserGuide);
            case 4:
                _ctx.next = 6;
                return takeEvery$1(externalStateSlice/* setIntroduceDoubleTapState */.n_, setIntroduceDoubleTap);
            case 6:
                _ctx.next = 8;
                return takeEvery$1(externalStateSlice/* setFloatingIntroductionState */.m5, setFloatingIntroduction);
            case 8:
                _ctx.next = 10;
                return takeEvery$1(externalStateSlice/* setFloatingBlockIntroductionState */.z1, setFloatingBlockIntroduction);
            case 10:
                _ctx.next = 12;
                return takeLatest$1(externalStateSlice/* setDataFont */.AQ, setFontWeightAvailable);
            case 12:
            case "end":
                return _ctx.stop();
        }
    }, store_saga_marked);
}
/* harmony default export */ var store_saga = (externalStateSaga);

// EXTERNAL MODULE: ./src/features/main/store/creatorProfileSlice.ts
var creatorProfileSlice = __webpack_require__(72976);
// EXTERNAL MODULE: ./src/features/main/store/bookingProfileSlice.ts
var bookingProfileSlice = __webpack_require__(66625);
// EXTERNAL MODULE: ./src/features/main/store/websiteConfigSlice.ts
var websiteConfigSlice = __webpack_require__(50049);
;// CONCATENATED MODULE: ./src/app/store.ts
function store_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function store_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return store_arrayLikeToArray(arr);
}
function store_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function store_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function store_toConsumableArray(arr) {
    return store_arrayWithoutHoles(arr) || store_iterableToArray(arr) || store_unsupportedIterableToArray(arr) || store_nonIterableSpread();
}
function store_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return store_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen);
}

























var sagaMiddleware = redux_saga_core_npm_proxy_esm();
var middleware = store_toConsumableArray((0,redux_toolkit_esm/* getDefaultMiddleware */.Bx)({
    thunk: true,
    serializableCheck: false
})).concat([
    sagaMiddleware, 
]);
var rootSaga = runtime_default().mark(function rootSaga1() {
    return runtime_default().wrap(function rootSaga$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return io_40341e1a_all([
                    saga(),
                    saving_process(),
                    saving_item(),
                    position(),
                    site_setting(),
                    store_saga(), 
                ]);
            case 2:
            case "end":
                return _ctx.stop();
        }
    }, rootSaga1);
});
function makeStore() {
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: {
            positions: positionsSlice/* default */.ZP,
            counter: counter_counterSlice,
            user: userSlice/* default */.ZP,
            siteSettings: siteSettingSlice/* default */.ZP,
            dynamicConfig: dynamicSlice/* default */.ZP,
            edittingBlock: edittingBlockSlice/* default */.ZP,
            passioPageProfile: passioPageProfileSlice/* default */.ZP,
            videoShoutout: store_videoShoutoutSlice,
            savingProcess: store_savingProcessSlice,
            savingItem: store_savingItemSlice,
            digitalProduct: digitalProductSlice/* default */.Z,
            externalState: externalStateSlice/* default */.ZP,
            creatorProfile: creatorProfileSlice/* default */.ZP,
            bookingProfile: bookingProfileSlice/* default */.ZP,
            websiteConfig: websiteConfigSlice/* default */.ZP
        },
        middleware: middleware
    });
}
var store = makeStore();
sagaMiddleware.run(rootSaga);
/* harmony default export */ var app_store = (store);

// EXTERNAL MODULE: ./src/features/share/configs/system.ts
var system = __webpack_require__(935);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








i18n/* default.changeLanguage */.Z.changeLanguage("en").then();
var queryClient = new react_query_es.QueryClient();
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    (0,react.useEffect)(function() {
        try {
            if (system/* ENVIRONMENT */.Gv == "production") {
                (function(h, o, t, j, a, r) {
                    h.hj = h.hj || function() {
                        (h.hj.q = h.hj.q || []).push(arguments);
                    };
                    h._hjSettings = {
                        hjid: 3101377,
                        hjsv: 6
                    };
                    a = o.getElementsByTagName("head")[0];
                    r = o.createElement("script");
                    r.async = 1;
                    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
            }
        } catch (e) {
            console.log(e);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_query_es.QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Provider */.zt, {
            store: app_store,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))
        })
    });
};


/***/ }),

/***/ 13408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ct": function() { return /* reexport */ components_badge; },
  "zx": function() { return /* reexport */ components_button; },
  "Su": function() { return /* reexport */ components_check_list; },
  "XZ": function() { return /* reexport */ components_checkbox; },
  "UO": function() { return /* reexport */ components_collapse; },
  "Vq": function() { return /* reexport */ components_dialog; },
  "iz": function() { return /* reexport */ components_divider; },
  "k_": function() { return /* reexport */ components_dot_loading; },
  "mH": function() { return /* reexport */ components_ellipsis; },
  "l0": function() { return /* reexport */ es_components_form; },
  "Ee": function() { return /* reexport */ components_image; },
  "wA": function() { return /* reexport */ components_image_uploader; },
  "v_": function() { return /* reexport */ components_infinite_scroll; },
  "II": function() { return /* reexport */ components_input; },
  "aV": function() { return /* reexport */ components_list; },
  "gb": function() { return /* reexport */ loading; },
  "u_": function() { return /* reexport */ components_modal; },
  "l2": function() { return /* reexport */ components_nav_bar; },
  "P8": function() { return /* reexport */ components_notice_bar; },
  "cW": function() { return /* reexport */ components_picker; },
  "J2": function() { return /* reexport */ components_popover; },
  "GI": function() { return /* reexport */ components_popup; },
  "j8": function() { return /* reexport */ components_rate; },
  "Eq": function() { return /* reexport */ components_safe_area; },
  "E1": function() { return /* reexport */ components_search_bar; },
  "Qf": function() { return /* reexport */ components_selector; },
  "iR": function() { return /* reexport */ components_slider; },
  "wW": function() { return /* reexport */ components_spin_loading; },
  "tq": function() { return /* reexport */ components_swiper; },
  "rs": function() { return /* reexport */ components_switch; },
  "nj": function() { return /* reexport */ components_tab_bar; },
  "mQ": function() { return /* reexport */ components_tabs; },
  "Kx": function() { return /* reexport */ components_text_area; },
  "FN": function() { return /* reexport */ components_toast; },
  "r": function() { return /* reexport */ reduceMotion; }
});

// UNUSED EXPORTS: ActionSheet, AutoCenter, Avatar, Calendar, CapsuleTabs, Card, CascadePicker, CascadePickerView, Cascader, CascaderView, CenterPopup, ConfigProvider, DatePicker, DatePickerView, Dropdown, Empty, ErrorBlock, FloatingBubble, FloatingPanel, Grid, ImageViewer, IndexBar, JumboTabs, Mask, NumberKeyboard, PageIndicator, PasscodeInput, PickerView, ProgressBar, ProgressCircle, PullToRefresh, Radio, Result, ScrollMask, SideBar, Skeleton, Space, Stepper, Steps, SwipeAction, Tag, TreeSelect, VirtualInput, WaterMark, createErrorBlock, restoreMotion, setDefaultConfig

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/global/global.css
var global = __webpack_require__(43294);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/can-use-dom.js
var can_use_dom_canUseDom = !!( true && typeof document !== "undefined" && window.document && window.document.createElement);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/global/index.js


if (can_use_dom_canUseDom) {
    // Make sure the `:active` CSS selector of `button` and `a` take effect
    // See: https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
    document.addEventListener("touchstart", function() {}, true);
} // Only for debugging. Must COMMENT this line before commit:
 // import './css-vars-patch.less'

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/badge/badge.css
var badge = __webpack_require__(34109);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/native-props.js


function withNativeProps(props, element) {
    var p = Object.assign({}, element.props);
    if (props.className) {
        p.className = classnames_default()(element.props.className, props.className);
    }
    if (props.style) {
        p.style = Object.assign(Object.assign({}, p.style), props.style);
    }
    if (props.tabIndex !== undefined) {
        p.tabIndex = props.tabIndex;
    }
    for(var key in props){
        if (!props.hasOwnProperty(key)) continue;
        if (key.startsWith("data-") || key.startsWith("aria-")) {
            p[key] = props[key];
        }
    }
    return /*#__PURE__*/ react.cloneElement(element, p);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/badge/badge.js



var classPrefix = "adm-badge";
var dot = /*#__PURE__*/ react.createElement(react.Fragment, null);
var Badge = function(props) {
    var content = props.content, color = props.color, children = props.children;
    var isDot = content === dot;
    var badgeCls = classnames_default()(classPrefix, !!children && "".concat(classPrefix, "-fixed"), isDot && "".concat(classPrefix, "-dot"), props.bordered && "".concat(classPrefix, "-bordered"));
    var element = content || content === 0 ? withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: badgeCls,
        style: {
            "--color": color
        }
    }, !isDot && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(classPrefix, "-content")
    }, content))) : null;
    return children ? /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(classPrefix, "-wrapper"), props.wrapperClassName),
        style: props.wrapperStyle
    }, children, element) : element;
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/attach-properties-to-component.js
function attachPropertiesToComponent(component, properties) {
    var ret = component;
    for(var key in properties){
        if (properties.hasOwnProperty(key)) {
            ret[key] = properties[key];
        }
    }
    return ret;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/badge/index.js



/* harmony default export */ var components_badge = (attachPropertiesToComponent(Badge, {
    dot: dot
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/button/button.css
var button_button = __webpack_require__(48542);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/dot-loading/dot-loading.css
var dot_loading = __webpack_require__(3977);
// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(28583);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
// EXTERNAL MODULE: ./node_modules/lodash/assignWith.js
var assignWith = __webpack_require__(63706);
var assignWith_default = /*#__PURE__*/__webpack_require__.n(assignWith);
// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__(52353);
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/with-default-props.js



function mergeProps() {
    for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
        items[_key] = arguments[_key];
    }
    var customizer = function customizer(objValue, srcValue) {
        return isUndefined_default()(srcValue) ? objValue : srcValue;
    };
    var ret = assign_default()({}, items[0]);
    for(var i = 1; i < items.length; i++){
        ret = assignWith_default()(ret, items[i], customizer);
    }
    return ret;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dot-loading/dot-loading.js




var dot_loading_classPrefix = "adm-dot-loading";
var colorRecord = {
    default: "var(--adm-color-weak)",
    primary: "var(--adm-color-primary)",
    white: "var(--adm-color-white)"
};
var defaultProps = {
    color: "default"
};
var DotLoading = /*#__PURE__*/ (0,react.memo)(function(p) {
    var _a;
    var props = mergeProps(defaultProps, p);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        style: {
            color: (_a = colorRecord[props.color]) !== null && _a !== void 0 ? _a : props.color
        },
        className: classnames_default()("adm-loading", dot_loading_classPrefix)
    }, /*#__PURE__*/ react.createElement("svg", {
        height: "1em",
        viewBox: "0 0 100 40",
        style: {
            verticalAlign: "-0.125em"
        }
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(-100.000000, -71.000000)"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(95.000000, 71.000000)"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(5.000000, 0.000000)"
    }, [
        0,
        1,
        2
    ].map(function(i) {
        return /*#__PURE__*/ react.createElement("rect", {
            key: i,
            fill: "currentColor",
            x: 20 + i * 26,
            y: "16",
            width: "8",
            height: "8",
            rx: "2"
        }, /*#__PURE__*/ react.createElement("animate", {
            attributeName: "y",
            from: "16",
            to: "16",
            dur: "2s",
            begin: "".concat(i * 0.2, "s"),
            repeatCount: "indefinite",
            values: "16; 6; 26; 16; 16",
            keyTimes: "0; 0.1; 0.3; 0.4; 1"
        }));
    }))))))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dot-loading/index.js


/* harmony default export */ var components_dot_loading = (DotLoading);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/validate.js

function isDef(val) {
    return val !== undefined && val !== null;
}
function isObject(val) {
    return val !== null && typeof val === "object";
}
function isPromise(obj) {
    return !!obj && typeof obj === "object" && typeof obj.then === "function";
}
function isDate(val) {
    return Object.prototype.toString.call(val) === "[object Date]" && !Number.isNaN(val.getTime());
}
function isMobile(value) {
    value = value.replace(/[^-|\d]/g, "");
    return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
}
function isNumeric(val) {
    return typeof val === "number" || /^\d+(\.\d+)?$/.test(val);
}
function isAndroid() {
    return canUseDom ? /android/.test(navigator.userAgent.toLowerCase()) : false;
}
function isIOS() {
    return can_use_dom_canUseDom ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/button/button.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var button_classPrefix = "adm-button";
var button_defaultProps = {
    color: "default",
    fill: "solid",
    block: false,
    loading: false,
    loadingIcon: /*#__PURE__*/ react.createElement(components_dot_loading, {
        color: "currentColor"
    }),
    type: "button",
    shape: "default",
    size: "middle"
};
var Button = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var props = mergeProps(button_defaultProps, p);
    var _$ref = (0,react.useState)(false), innerLoading = _$ref[0], setInnerLoading = _$ref[1];
    var nativeButtonRef = (0,react.useRef)(null);
    var loading = props.loading === "auto" ? innerLoading : props.loading;
    var disabled = props.disabled || loading;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            get nativeElement () {
                return nativeButtonRef.current;
            }
        };
    });
    var handleClick = function(e) {
        return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
            var promise;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (props.onClick) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        promise = props.onClick(e);
                        if (!isPromise(promise)) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.prev = 4;
                        setInnerLoading(true);
                        _ctx.next = 8;
                        return promise;
                    case 8:
                        setInnerLoading(false);
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        setInnerLoading(false);
                        throw _ctx.t0;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
    };
    var _obj;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("button", {
        ref: nativeButtonRef,
        type: props.type,
        onClick: handleClick,
        className: classnames_default()(button_classPrefix, props.color ? "".concat(button_classPrefix, "-").concat(props.color) : null, (_obj = {}, _defineProperty(_obj, "".concat(button_classPrefix, "-block"), props.block), _defineProperty(_obj, "".concat(button_classPrefix, "-disabled"), disabled), _defineProperty(_obj, "".concat(button_classPrefix, "-fill-outline"), props.fill === "outline"), _defineProperty(_obj, "".concat(button_classPrefix, "-fill-none"), props.fill === "none"), _defineProperty(_obj, "".concat(button_classPrefix, "-mini"), props.size === "mini"), _defineProperty(_obj, "".concat(button_classPrefix, "-small"), props.size === "small"), _defineProperty(_obj, "".concat(button_classPrefix, "-large"), props.size === "large"), _defineProperty(_obj, "".concat(button_classPrefix, "-loading"), loading), _obj), "".concat(button_classPrefix, "-shape-").concat(props.shape)),
        disabled: disabled,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onTouchStart: props.onTouchStart,
        onTouchEnd: props.onTouchEnd
    }, loading ? /*#__PURE__*/ react.createElement("div", {
        className: "".concat(button_classPrefix, "-loading-wrapper")
    }, props.loadingIcon, props.loadingText) : props.children));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/button/index.js


/* harmony default export */ var components_button = (Button);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/check-list/check-list.css
var check_list = __webpack_require__(78789);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/list/list.css
var list = __webpack_require__(19664);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/list/list.js




var list_classPrefix = "adm-list";
var list_defaultProps = {
    mode: "default"
};
var List = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var props = mergeProps(list_defaultProps, p);
    var nativeElementRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            get nativeElement () {
                return nativeElementRef.current;
            }
        };
    });
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(list_classPrefix, "".concat(list_classPrefix, "-").concat(props.mode)),
        ref: nativeElementRef
    }, props.header && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_classPrefix, "-header")
    }, props.header), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_classPrefix, "-body")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_classPrefix, "-body-inner")
    }, props.children))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/RightOutline.js

function RightOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "RightOutline-RightOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "RightOutline-RightOutlined"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "RightOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M17.3947957,5.11219264 L35.5767382,22.6612572 L35.5767382,22.6612572 C36.1304785,23.2125856 36.1630514,24.0863155 35.6744571,24.6755735 L35.5767382,24.7825775 L17.3956061,42.8834676 C17.320643,42.9580998 17.2191697,43 17.1133896,43 L13.9866673,43 C13.7657534,43 13.5866673,42.8209139 13.5866673,42.6 C13.5866673,42.4936115 13.6290496,42.391606 13.7044413,42.316542 L32.3201933,23.7816937 L32.3201933,23.7816937 L13.7237117,5.6866816 C13.5653818,5.53262122 13.5619207,5.27937888 13.7159811,5.121049 C13.7912854,5.04365775 13.8946805,5 14.0026627,5 L17.1170064,5 C17.2206403,5 17.3202292,5.04022164 17.3947957,5.11219264 Z",
        id: "RightOutline-right",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_RightOutline = (RightOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/is-node-with-content.js
function isNodeWithContent(node) {
    return node !== undefined && node !== null && node !== false;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/list/list-item.js





var list_item_classPrefix = "adm-list-item";
var ListItem = function(props) {
    var _a;
    var clickable = (_a = props.clickable) !== null && _a !== void 0 ? _a : !!props.onClick;
    var arrow = props.arrow === undefined ? clickable : props.arrow;
    var content = /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-content")
    }, isNodeWithContent(props.prefix) && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-content-prefix")
    }, props.prefix), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-content-main")
    }, isNodeWithContent(props.title) && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-title")
    }, props.title), props.children, isNodeWithContent(props.description) && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-description")
    }, props.description)), isNodeWithContent(props.extra) && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-content-extra")
    }, props.extra), isNodeWithContent(arrow) && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(list_item_classPrefix, "-content-arrow")
    }, arrow === true ? /*#__PURE__*/ react.createElement(es_RightOutline, null) : arrow));
    return withNativeProps(props, /*#__PURE__*/ react.createElement(clickable ? "a" : "div", {
        className: classnames_default()("".concat(list_item_classPrefix), clickable ? [
            "adm-plain-anchor"
        ] : [], props.disabled && "".concat(list_item_classPrefix, "-disabled")),
        onClick: props.disabled ? undefined : props.onClick
    }, content));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/list/index.js




/* harmony default export */ var components_list = (attachPropertiesToComponent(List, {
    Item: ListItem
}));

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/check-list/context.js

var CheckListContext = /*#__PURE__*/ (0,react.createContext)(null);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdate/index.js
var useUpdate_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};

var useUpdate = function useUpdate() {
  var _a = useUpdate_read((0,react.useState)({}), 2),
    setState = _a[1];
  return (0,react.useCallback)(function () {
    return setState({});
  }, []);
};
/* harmony default export */ var es_useUpdate = (useUpdate);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/index.js
var utils_isObject = function isObject(value) {
  return value !== null && typeof value === 'object';
};
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var isNumber = function isNumber(value) {
  return typeof value === 'number';
};
var isUndef = function isUndef(value) {
  return typeof value === 'undefined';
};
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/isDev.js
var isDev =  false || "production" === 'test';
/* harmony default export */ var utils_isDev = (isDev);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useMemoizedFn/index.js



function useMemoizedFn(fn) {
  if (utils_isDev) {
    if (!isFunction(fn)) {
      console.error("useMemoizedFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = (0,react.useRef)(fn);
  // why not write `fnRef.current = fn`?
  // https://github.com/alibaba/hooks/issues/728
  fnRef.current = (0,react.useMemo)(function () {
    return fn;
  }, [fn]);
  var memoizedFn = (0,react.useRef)();
  if (!memoizedFn.current) {
    memoizedFn.current = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
}
/* harmony default export */ var es_useMemoizedFn = (useMemoizedFn);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-props-value.js


function usePropsValue(options) {
    var value = options.value, defaultValue = options.defaultValue, onChange = options.onChange;
    var update = es_useUpdate();
    var stateRef = (0,react.useRef)(value !== undefined ? value : defaultValue);
    if (value !== undefined) {
        stateRef.current = value;
    }
    var setState = es_useMemoizedFn(function(v) {
        var forceTrigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // `forceTrigger` means trigger `onChange` even if `v` is the same as `stateRef.current`
        var nextValue = typeof v === "function" ? v(stateRef.current) : v;
        if (!forceTrigger && nextValue === stateRef.current) return;
        stateRef.current = nextValue;
        update();
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    });
    return [
        stateRef.current,
        setState
    ];
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/CheckOutline.js

function CheckOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "CheckOutline-CheckOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "CheckOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "CheckOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M44.309608,12.6841286 L21.2180499,35.5661955 L21.2180499,35.5661955 C20.6343343,36.1446015 19.6879443,36.1446015 19.1042286,35.5661955 C19.0538201,35.5162456 19.0077648,35.4636155 18.9660627,35.4087682 C18.9113105,35.368106 18.8584669,35.3226694 18.808302,35.2729607 L3.6903839,20.2920499 C3.53346476,20.1365529 3.53231192,19.8832895 3.68780898,19.7263704 C3.7629255,19.6505669 3.86521855,19.6079227 3.97193622,19.6079227 L7.06238923,19.6079227 C7.16784214,19.6079227 7.26902895,19.6495648 7.34393561,19.7237896 L20.160443,32.4236157 L20.160443,32.4236157 L40.656066,12.115858 C40.7309719,12.0416387 40.8321549,12 40.9376034,12 L44.0280571,12 C44.248971,12 44.4280571,12.1790861 44.4280571,12.4 C44.4280571,12.5067183 44.3854124,12.609012 44.309608,12.6841286 Z",
        id: "CheckOutline-\u8DEF\u5F84",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_CheckOutline = (CheckOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/check-list/check-list.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var check_list_classPrefix = "adm-check-list";
var check_list_defaultProps = {
    multiple: false,
    defaultValue: [],
    activeIcon: /*#__PURE__*/ react.createElement(es_CheckOutline, null)
};
var CheckList = function(p) {
    var check = function check(val) {
        if (props.multiple) {
            setValue(_toConsumableArray(value).concat([
                val
            ]));
        } else {
            setValue([
                val
            ]);
        }
    };
    var uncheck = function uncheck(val) {
        setValue(value.filter(function(item) {
            return item !== val;
        }));
    };
    var props = mergeProps(check_list_defaultProps, p);
    var ref = _slicedToArray(usePropsValue(props), 2), value = ref[0], setValue = ref[1];
    var activeIcon = props.activeIcon, disabled = props.disabled, readOnly = props.readOnly;
    return /*#__PURE__*/ react.createElement(CheckListContext.Provider, {
        value: {
            value: value,
            check: check,
            uncheck: uncheck,
            activeIcon: activeIcon,
            disabled: disabled,
            readOnly: readOnly
        }
    }, withNativeProps(props, /*#__PURE__*/ react.createElement(components_list, {
        mode: props.mode,
        className: check_list_classPrefix
    }, props.children)));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/is-dev.js
var is_dev_isDev =  false || "production" === "test";

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/dev-log.js

function devWarning(component, message) {
    if (is_dev_isDev) {
        console.warn("[antd-mobile: ".concat(component, "] ").concat(message));
    }
}
function devError(component, message) {
    if (is_dev_isDev) {
        console.error("[antd-mobile: ".concat(component, "] ").concat(message));
    }
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/check-list/check-list-item.js






var check_list_item_classPrefix = "adm-check-list-item";
var CheckListItem = function(props) {
    var context = (0,react.useContext)(CheckListContext);
    if (context === null) {
        devWarning("CheckList.Item", "CheckList.Item can only be used inside CheckList.");
        return null;
    }
    var active = context.value.includes(props.value);
    var readOnly = props.readOnly || context.readOnly;
    var extra = /*#__PURE__*/ react.createElement("div", {
        className: "".concat(check_list_item_classPrefix, "-extra")
    }, active ? context.activeIcon : null);
    return withNativeProps(props, /*#__PURE__*/ react.createElement(components_list.Item, {
        title: props.title,
        className: classnames_default()(check_list_item_classPrefix, readOnly && "".concat(check_list_item_classPrefix, "-readonly"), active && "".concat(check_list_item_classPrefix, "-active")),
        description: props.description,
        prefix: props.prefix,
        onClick: function(e) {
            var _a;
            if (readOnly) return;
            if (active) {
                context.uncheck(props.value);
            } else {
                context.check(props.value);
            }
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        arrow: false,
        clickable: !readOnly,
        extra: extra,
        disabled: props.disabled || context.disabled
    }, props.children));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/check-list/index.js




/* harmony default export */ var components_check_list = (attachPropertiesToComponent(CheckList, {
    Item: CheckListItem
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/checkbox/checkbox.css
var checkbox_checkbox = __webpack_require__(83035);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/group-context.js

var CheckboxGroupContext = /*#__PURE__*/ (0,react.createContext)(null);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/group.js
function group_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function group_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function group_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return group_arrayLikeToArray(arr);
}
function group_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function group_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function group_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function group_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function group_slicedToArray(arr, i) {
    return group_arrayWithHoles(arr) || group_iterableToArrayLimit(arr, i) || group_unsupportedIterableToArray(arr, i) || group_nonIterableRest();
}
function group_toConsumableArray(arr) {
    return group_arrayWithoutHoles(arr) || group_iterableToArray(arr) || group_unsupportedIterableToArray(arr) || group_nonIterableSpread();
}
function group_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return group_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return group_arrayLikeToArray(o, minLen);
}




var group_defaultProps = {
    disabled: false,
    defaultValue: []
};
var Group = function(p) {
    var props = mergeProps(group_defaultProps, p);
    var ref = group_slicedToArray(usePropsValue(props), 2), value = ref[0], setValue = ref[1];
    return /*#__PURE__*/ react.createElement(CheckboxGroupContext.Provider // TODO: 性能优化
    , {
        // TODO: 性能优化
        value: {
            value: value,
            disabled: props.disabled,
            check: function(v) {
                setValue(group_toConsumableArray(value).concat([
                    v
                ]));
            },
            uncheck: function(v) {
                setValue(value.filter(function(item) {
                    return item !== v;
                }));
            }
        }
    }, props.children);
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/check-icon.js


var CheckIcon = /*#__PURE__*/ (0,react.memo)(function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 40 40"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M31.5541766,15 L28.0892433,15 L28.0892434,15 C27.971052,15 27.8576674,15.044522 27.7740471,15.1239792 L18.2724722,24.1625319 L13.2248725,19.3630279 L13.2248725,19.3630279 C13.1417074,19.2834412 13.0287551,19.2384807 12.9107898,19.2380079 L9.44474455,19.2380079 L9.44474454,19.2380079 C9.19869815,19.2384085 8.99957935,19.4284738 9,19.66253 C9,19.7747587 9.04719253,19.8823283 9.13066188,19.9616418 L17.0907466,27.5338228 C17.4170809,27.8442545 17.8447695,28 18.2713393,28 L18.2980697,28 C18.7168464,27.993643 19.133396,27.8378975 19.4530492,27.5338228 L31.8693384,15.7236361 L31.8693384,15.7236361 C32.0434167,15.5582251 32.0435739,15.2898919 31.8696892,15.1242941 C31.7860402,15.0446329 31.6725052,15 31.5541421,15 L31.5541766,15 Z",
        fill: "currentColor"
    })));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/indeterminate-icon.js


var IndeterminateIcon = /*#__PURE__*/ (0,react.memo)(function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 40 40"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M20,9 C26.0752953,9 31,13.9247047 31,20 C31,26.0752953 26.0752953,31 20,31 C13.9247047,31 9,26.0752953 9,20 C9,13.9247047 13.9247047,9 20,9 Z",
        fill: "currentColor"
    })));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/native-input.js


var NativeInput = function(props) {
    var inputRef = (0,react.useRef)(null);
    var handleClick = es_useMemoizedFn(function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        var latestChecked = e.target.checked;
        if (latestChecked === props.checked) return;
        props.onChange(latestChecked);
    });
    (0,react.useEffect)(function() {
        if (props.disabled) return;
        if (!inputRef.current) return;
        var input = inputRef.current;
        input.addEventListener("click", handleClick);
        return function() {
            input.removeEventListener("click", handleClick);
        };
    }, [
        props.disabled,
        props.onChange
    ]);
    return /*#__PURE__*/ react.createElement("input", {
        ref: inputRef,
        type: props.type,
        checked: props.checked,
        onChange: function() {},
        disabled: props.disabled,
        id: props.id
    });
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/checkbox.js
function checkbox_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function checkbox_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function checkbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkbox_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function checkbox_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_slicedToArray(arr, i) {
    return checkbox_arrayWithHoles(arr) || checkbox_iterableToArrayLimit(arr, i) || checkbox_unsupportedIterableToArray(arr, i) || checkbox_nonIterableRest();
}
function checkbox_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return checkbox_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return checkbox_arrayLikeToArray(o, minLen);
}











var checkbox_classPrefix = "adm-checkbox";
var checkbox_defaultProps = {
    defaultChecked: false,
    indeterminate: false
};
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var groupContext = (0,react.useContext)(CheckboxGroupContext);
    var props = mergeProps(checkbox_defaultProps, p);
    var _$ref = checkbox_slicedToArray(usePropsValue({
        value: props.checked,
        defaultValue: props.defaultChecked,
        onChange: props.onChange
    }), 2), checked1 = _$ref[0], setChecked = _$ref[1];
    var disabled = props.disabled;
    var value = props.value;
    if (groupContext && value !== undefined) {
        if (is_dev_isDev) {
            if (p.checked !== undefined) {
                devWarning("Checkbox", "When used within `Checkbox.Group`, the `checked` prop of `Checkbox` will not work.");
            }
            if (p.defaultChecked !== undefined) {
                devWarning("Checkbox", "When used within `Checkbox.Group`, the `defaultChecked` prop of `Checkbox` will not work.");
            }
        }
        checked1 = groupContext.value.includes(value);
        setChecked = function(checked) {
            var _a;
            if (checked) {
                groupContext.check(value);
            } else {
                groupContext.uncheck(value);
            }
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, checked);
        };
        disabled = disabled || groupContext.disabled;
    }
    (0,react.useImperativeHandle)(ref, function() {
        return {
            check: function() {
                setChecked(true);
            },
            uncheck: function() {
                setChecked(false);
            },
            toggle: function() {
                setChecked(!checked1);
            }
        };
    });
    var renderIcon = function() {
        if (props.icon) {
            return /*#__PURE__*/ react.createElement("div", {
                className: "".concat(checkbox_classPrefix, "-custom-icon")
            }, props.icon(checked1, props.indeterminate));
        }
        return /*#__PURE__*/ react.createElement("div", {
            className: "".concat(checkbox_classPrefix, "-icon")
        }, props.indeterminate ? /*#__PURE__*/ react.createElement(IndeterminateIcon, null) : checked1 && /*#__PURE__*/ react.createElement(CheckIcon, null));
    };
    var _obj;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("label", {
        className: classnames_default()(checkbox_classPrefix, (_obj = {}, checkbox_defineProperty(_obj, "".concat(checkbox_classPrefix, "-checked"), checked1 && !props.indeterminate), checkbox_defineProperty(_obj, "".concat(checkbox_classPrefix, "-indeterminate"), props.indeterminate), checkbox_defineProperty(_obj, "".concat(checkbox_classPrefix, "-disabled"), disabled), checkbox_defineProperty(_obj, "".concat(checkbox_classPrefix, "-block"), props.block), _obj))
    }, /*#__PURE__*/ react.createElement(NativeInput, {
        type: "checkbox",
        checked: checked1,
        onChange: setChecked,
        disabled: disabled,
        id: props.id
    }), renderIcon(), props.children && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(checkbox_classPrefix, "-content")
    }, props.children)));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/checkbox/index.js




/* harmony default export */ var components_checkbox = (attachPropertiesToComponent(Checkbox, {
    Group: Group
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/collapse/collapse.css
var collapse = __webpack_require__(53749);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/DownOutline.js

function DownOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "DownOutline-DownOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", null, /*#__PURE__*/ react.createElement("rect", {
        id: "DownOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M5.11219264,16.3947957 L22.6612572,34.5767382 L22.6612572,34.5767382 C23.2125856,35.1304785 24.0863155,35.1630514 24.6755735,34.6744571 L24.7825775,34.5767382 L42.8834676,16.3956061 C42.9580998,16.320643 43,16.2191697 43,16.1133896 L43,12.9866673 C43,12.7657534 42.8209139,12.5866673 42.6,12.5866673 C42.4936115,12.5866673 42.391606,12.6290496 42.316542,12.7044413 L23.7816937,31.3201933 L23.7816937,31.3201933 L5.6866816,12.7237117 C5.53262122,12.5653818 5.27937888,12.5619207 5.121049,12.7159811 C5.04365775,12.7912854 5,12.8946805 5,13.0026627 L5,16.1170064 C5,16.2206403 5.04022164,16.3202292 5.11219264,16.3947957 Z",
        id: "DownOutline-down",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_DownOutline = (DownOutline);

;// CONCATENATED MODULE: ./node_modules/@react-spring/rafz/dist/react-spring-rafz.esm.js
let updateQueue = makeQueue();
const raf = fn => schedule(fn, updateQueue);
let writeQueue = makeQueue();

raf.write = fn => schedule(fn, writeQueue);

let onStartQueue = makeQueue();

raf.onStart = fn => schedule(fn, onStartQueue);

let onFrameQueue = makeQueue();

raf.onFrame = fn => schedule(fn, onFrameQueue);

let onFinishQueue = makeQueue();

raf.onFinish = fn => schedule(fn, onFinishQueue);

let timeouts = [];

raf.setTimeout = (handler, ms) => {
  let time = raf.now() + ms;

  let cancel = () => {
    let i = timeouts.findIndex(t => t.cancel == cancel);
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };

  let timeout = {
    time,
    handler,
    cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};

let findTimeout = time => ~(~timeouts.findIndex(t => t.time > time) || ~timeouts.length);

raf.cancel = fn => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
  onFinishQueue.delete(fn);
};

raf.sync = fn => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};

raf.throttle = fn => {
  let lastArgs;

  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }

  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }

  throttled.handler = fn;

  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };

  return throttled;
};

let nativeRaf = typeof window != 'undefined' ? window.requestAnimationFrame : () => {};

raf.use = impl => nativeRaf = impl;

raf.now = typeof performance != 'undefined' ? () => performance.now() : Date.now;

raf.batchedUpdates = fn => fn();

raf.catch = console.error;
raf.frameLoop = 'always';

raf.advance = () => {
  if (raf.frameLoop !== 'demand') {
    console.warn('Cannot call the manual advancement of rafz whilst frameLoop is not set as demand');
  } else {
    update();
  }
};

let ts = -1;
let pendingCount = 0;
let sync = false;

function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}

function start() {
  if (ts < 0) {
    ts = 0;

    if (raf.frameLoop !== 'demand') {
      nativeRaf(loop);
    }
  }
}

function stop() {
  ts = -1;
}

function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}

function update() {
  let prevTs = ts;
  ts = raf.now();
  let count = findTimeout(ts);

  if (count) {
    eachSafely(timeouts.splice(0, count), t => t.handler());
    pendingCount -= count;
  }

  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();

  if (!pendingCount) {
    stop();
  }
}

function makeQueue() {
  let next = new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },

    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },

    flush(arg) {
      if (current.size) {
        next = new Set();
        pendingCount -= current.size;
        eachSafely(current, fn => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }

  };
}

function eachSafely(values, each) {
  values.forEach(value => {
    try {
      each(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

const __raf = {
  count() {
    return pendingCount;
  },

  isRunning() {
    return ts >= 0;
  },

  clear() {
    ts = -1;
    timeouts = [];
    onStartQueue = makeQueue();
    updateQueue = makeQueue();
    onFrameQueue = makeQueue();
    writeQueue = makeQueue();
    onFinishQueue = makeQueue();
    pendingCount = 0;
  }

};



;// CONCATENATED MODULE: ./node_modules/@react-spring/shared/dist/react-spring-shared.esm.js





function noop() {}
const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
  value,
  writable: true,
  configurable: true
});
const react_spring_shared_esm_is = {
  arr: Array.isArray,
  obj: a => !!a && a.constructor.name === 'Object',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === undefined
};
function isEqual(a, b) {
  if (react_spring_shared_esm_is.arr(a)) {
    if (!react_spring_shared_esm_is.arr(b) || a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}
const react_spring_shared_esm_each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (react_spring_shared_esm_is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }

    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
const react_spring_shared_esm_toArray = a => react_spring_shared_esm_is.und(a) ? [] : react_spring_shared_esm_is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    react_spring_shared_esm_each(items, iterator);
  }
}
const flushCalls = (queue, ...args) => flush(queue, fn => fn(...args));
const isSSR = () => typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

let createStringInterpolator$1;
let to;
let colors$1 = null;
let skipAnimation = false;
let willAdvance = noop;
const react_spring_shared_esm_assign = globals => {
  if (globals.to) to = globals.to;
  if (globals.now) raf.now = globals.now;
  if (globals.colors !== undefined) colors$1 = globals.colors;
  if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
  if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance) willAdvance = globals.willAdvance;
  if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};

var globals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get createStringInterpolator () { return createStringInterpolator$1; },
  get to () { return to; },
  get colors () { return colors$1; },
  get skipAnimation () { return skipAnimation; },
  get willAdvance () { return willAdvance; },
  assign: react_spring_shared_esm_assign
});

const startQueue = new Set();
let currentFrame = [];
let prevFrame = [];
let priority = 0;
const frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },

  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },

  advance,

  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);

      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },

  clear() {
    currentFrame = [];
    startQueue.clear();
  }

};

function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}

function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}

function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, other => other.priority > animation.priority), 0, animation);
}

function advance(dt) {
  const nextFrame = prevFrame;

  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;

    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);

      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }

  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}

function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...parts) {
  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  }

  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;

  if (colors$1 && colors$1[color] !== undefined) {
    return colors$1[color];
  }

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + 'ff', 16) >>> 0;
  }

  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const createInterpolator = (range, output, extrapolate) => {
  if (react_spring_shared_esm_is.fun(range)) {
    return range;
  }

  if (react_spring_shared_esm_is.arr(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (react_spring_shared_esm_is.str(range.output[0])) {
    return createStringInterpolator$1(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const $get = Symbol.for('FluidValue.get');
const $observers = Symbol.for('FluidValue.observers');

const hasFluidValue = arg => Boolean(arg && arg[$get]);

const getFluidValue = arg => arg && arg[$get] ? arg[$get]() : arg;

const getFluidObservers = target => target[$observers] || null;

function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}

function callFluidObservers(target, event) {
  let observers = target[$observers];

  if (observers) {
    observers.forEach(observer => {
      callFluidObserver(observer, event);
    });
  }
}

class FluidValue {
  constructor(get) {
    this[$get] = void 0;
    this[$observers] = void 0;

    if (!get && !(get = this.get)) {
      throw Error('Unknown getter');
    }

    setFluidGetter(this, get);
  }

}

const setFluidGetter = (target, get) => setHidden(target, $get, get);

function addFluidObserver(target, observer) {
  if (target[$get]) {
    let observers = target[$observers];

    if (!observers) {
      setHidden(target, $observers, observers = new Set());
    }

    if (!observers.has(observer)) {
      observers.add(observer);

      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }

  return observer;
}

function removeFluidObserver(target, observer) {
  let observers = target[$observers];

  if (observers && observers.has(observer)) {
    const count = observers.size - 1;

    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }

    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}

const setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, 'i');
const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

const variableToRgba = input => {
  const [token, fallback] = parseCSSVariable(input);

  if (!token || isSSR()) {
    return input;
  }

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);

  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith('--')) {
    const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);

    if (_value) {
      return _value;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }

  return input;
};

const parseCSSVariable = current => {
  const match = cssVariableRegex.exec(current);
  if (!match) return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

let namedColorRegex;

const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;

const createStringInterpolator = config => {
  if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join('|')})(?!\\w)`, 'g') : /^\b$/;
  const output = config.output.map(value => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map(value => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map((_, i) => keyframes.map(values => {
    if (!(i in values)) {
      throw Error('The arity of each "output" value must be equal');
    }

    return values[i];
  }));
  const interpolators = outputRanges.map(output => createInterpolator(_extends({}, config, {
    output
  })));
  return input => {
    var _output$find;

    const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(value => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ''));
    let i = 0;
    return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ''}`).replace(rgbaRegex, rgbaRound);
  };
};

const prefix = 'react-spring: ';

const once = fn => {
  const func = fn;
  let called = false;

  if (typeof func != 'function') {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }

  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};

const warnInterpolate = once(console.warn);
function react_spring_shared_esm_deprecateInterpolate() {
  warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}

function isAnimatedString(value) {
  return react_spring_shared_esm_is.str(value) && (value[0] == '#' || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
}

const react_spring_shared_esm_useLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;

const useIsMounted = () => {
  const isMounted = (0,react.useRef)(false);
  react_spring_shared_esm_useLayoutEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

function react_spring_shared_esm_useForceUpdate() {
  const update = (0,react.useState)()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update(Math.random());
    }
  };
}

function useMemoOne(getResult, inputs) {
  const [initial] = (0,react.useState)(() => ({
    inputs,
    result: getResult()
  }));
  const committed = (0,react.useRef)();
  const prevCache = committed.current;
  let cache = prevCache;

  if (cache) {
    const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));

    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }

  (0,react.useEffect)(() => {
    committed.current = cache;

    if (prevCache == initial) {
      initial.inputs = initial.result = undefined;
    }
  }, [cache]);
  return cache.result;
}

function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }

  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }

  return true;
}

const react_spring_shared_esm_useOnce = effect => (0,react.useEffect)(effect, emptyDeps);
const emptyDeps = [];

function react_spring_shared_esm_usePrev(value) {
  const prevRef = (0,react.useRef)();
  (0,react.useEffect)(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}



;// CONCATENATED MODULE: ./node_modules/@react-spring/animated/dist/react-spring-animated.esm.js




const $node = Symbol.for('Animated:node');
const isAnimated = value => !!value && value[$node] === value;
const getAnimated = owner => owner && owner[$node];
const setAnimated = (owner, node) => defineHidden(owner, $node, node);
const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  constructor() {
    this.payload = void 0;
    setAnimated(this, this);
  }

  getPayload() {
    return this.payload || [];
  }

}

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;
    this.durationProgress = 0;
    this._value = _value;

    if (react_spring_shared_esm_is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }

  static create(value) {
    return new AnimatedValue(value);
  }

  getPayload() {
    return [this];
  }

  getValue() {
    return this._value;
  }

  setValue(value, step) {
    if (react_spring_shared_esm_is.num(value)) {
      this.lastPosition = value;

      if (step) {
        value = Math.round(value / step) * step;

        if (this.done) {
          this.lastPosition = value;
        }
      }
    }

    if (this._value === value) {
      return false;
    }

    this._value = value;
    return true;
  }

  reset() {
    const {
      done
    } = this;
    this.done = false;

    if (react_spring_shared_esm_is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done) this.lastVelocity = null;
      this.v0 = null;
    }
  }

}

class AnimatedString extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = void 0;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }

  static create(value) {
    return new AnimatedString(value);
  }

  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }

  setValue(value) {
    if (react_spring_shared_esm_is.str(value)) {
      if (value == this._string) {
        return false;
      }

      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }

    return true;
  }

  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }

    this._value = 0;
    super.reset();
  }

}

const TreeContext = {
  dependencies: null
};

class AnimatedObject extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }

  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }

  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }

  reset() {
    if (this.payload) {
      react_spring_shared_esm_each(this.payload, node => node.reset());
    }
  }

  _makePayload(source) {
    if (source) {
      const payload = new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }

  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }

    const payload = getPayload(source);

    if (payload) {
      react_spring_shared_esm_each(payload, node => this.add(node));
    }
  }

}

class AnimatedArray extends AnimatedObject {
  constructor(source) {
    super(source);
  }

  static create(source) {
    return new AnimatedArray(source);
  }

  getValue() {
    return this.source.map(node => node.getValue());
  }

  setValue(source) {
    const payload = this.getPayload();

    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }

    super.setValue(source.map(makeAnimated));
    return true;
  }

}

function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : react_spring_shared_esm_is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

function react_spring_animated_esm_extends() {
  react_spring_animated_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return react_spring_animated_esm_extends.apply(this, arguments);
}

const withAnimated = (Component, host) => {
  const hasInstance = !react_spring_shared_esm_is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return (0,react.forwardRef)((givenProps, givenRef) => {
    const instanceRef = (0,react.useRef)(null);
    const ref = hasInstance && (0,react.useCallback)(value => {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = react_spring_shared_esm_useForceUpdate();

    const callback = () => {
      const instance = instanceRef.current;

      if (hasInstance && !instance) {
        return;
      }

      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;

      if (didUpdate === false) {
        forceUpdate();
      }
    };

    const observer = new PropsObserver(callback, deps);
    const observerRef = (0,react.useRef)();
    react_spring_shared_esm_useLayoutEffect(() => {
      observerRef.current = observer;
      react_spring_shared_esm_each(deps, dep => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          react_spring_shared_esm_each(observerRef.current.deps, dep => removeFluidObserver(dep, observerRef.current));
          raf.cancel(observerRef.current.update);
        }
      };
    });
    (0,react.useEffect)(callback, []);
    react_spring_shared_esm_useOnce(() => () => {
      const observer = observerRef.current;
      react_spring_shared_esm_each(observer.deps, dep => removeFluidObserver(dep, observer));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return react.createElement(Component, react_spring_animated_esm_extends({}, usedProps, {
      ref: ref
    }));
  });
};

class PropsObserver {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }

  eventObserved(event) {
    if (event.type == 'change') {
      raf.write(this.update);
    }
  }

}

function getAnimatedState(props, host) {
  const dependencies = new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = react_spring_animated_esm_extends({}, props, {
    style: host.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}

function updateRef(ref, value) {
  if (ref) {
    if (react_spring_shared_esm_is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

const cacheKey = Symbol.for('AnimatedComponent');
const createHost = (components, {
  applyAnimatedValues: _applyAnimatedValues = () => false,
  createAnimatedStyle: _createAnimatedStyle = style => new AnimatedObject(style),
  getComponentProps: _getComponentProps = props => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: _applyAnimatedValues,
    createAnimatedStyle: _createAnimatedStyle,
    getComponentProps: _getComponentProps
  };

  const animated = Component => {
    const displayName = getDisplayName(Component) || 'Anonymous';

    if (react_spring_shared_esm_is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = `Animated(${displayName})`;
    return Component;
  };

  eachProp(components, (Component, key) => {
    if (react_spring_shared_esm_is.arr(components)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated
  };
};

const getDisplayName = arg => react_spring_shared_esm_is.str(arg) ? arg : arg && react_spring_shared_esm_is.str(arg.displayName) ? arg.displayName : react_spring_shared_esm_is.fun(arg) && arg.name || null;



;// CONCATENATED MODULE: ./node_modules/@react-spring/core/dist/react-spring-core.esm.js








function react_spring_core_esm_extends() {
  react_spring_core_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return react_spring_core_esm_extends.apply(this, arguments);
}

function callProp(value, ...args) {
  return react_spring_shared_esm_is.fun(value) ? value(...args) : value;
}
const matchProp = (value, key) => value === true || !!(key && value && (react_spring_shared_esm_is.fun(value) ? value(key) : react_spring_shared_esm_toArray(value).includes(key)));
const resolveProp = (prop, key) => react_spring_shared_esm_is.obj(prop) ? key && prop[key] : prop;
const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;

const noopTransform = value => value;

const getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  const defaults = {};

  for (const key of keys) {
    const value = transform(props[key], key);

    if (!react_spring_shared_esm_is.und(value)) {
      defaults[key] = value;
    }
  }

  return defaults;
};
const DEFAULT_PROPS = ['config', 'onProps', 'onStart', 'onChange', 'onPause', 'onResume', 'onRest'];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  const to = getForwardProps(props);

  if (to) {
    const out = {
      to
    };
    eachProp(props, (val, key) => key in to || (out[key] = val));
    return out;
  }

  return react_spring_core_esm_extends({}, props);
}
function computeGoal(value) {
  value = getFluidValue(value);
  return react_spring_shared_esm_is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props) return true;

  return false;
}
function isAsyncTo(to) {
  return react_spring_shared_esm_is.fun(to) || react_spring_shared_esm_is.arr(to) && react_spring_shared_esm_is.obj(to[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

function useChain(refs, timeSteps, timeFrame = 1000) {
  useLayoutEffect(() => {
    if (timeSteps) {
      let prevDelay = 0;
      each(refs, (ref, i) => {
        const controllers = ref.current;

        if (controllers.length) {
          let delay = timeFrame * timeSteps[i];
          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          each(controllers, ctrl => {
            each(ctrl.queue, props => {
              const memoizedDelayProp = props.delay;

              props.delay = key => delay + callProp(memoizedDelayProp || 0, key);
            });
          });
          ref.start();
        }
      });
    } else {
      let p = Promise.resolve();
      each(refs, ref => {
        const controllers = ref.current;

        if (controllers.length) {
          const queues = controllers.map(ctrl => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            each(controllers, (ctrl, i) => each(queues[i] || [], update => ctrl.queue.push(update)));
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
}

const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
const c1 = 1.70158;
const c2 = c1 * 1.525;
const c3 = c1 + 1;
const c4 = 2 * Math.PI / 3;
const c5 = 2 * Math.PI / 4.5;

const bounceOut = x => {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};

const easings = {
  linear: x => x,
  easeInQuad: x => x * x,
  easeOutQuad: x => 1 - (1 - x) * (1 - x),
  easeInOutQuad: x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: x => x * x * x,
  easeOutCubic: x => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: x => x * x * x * x,
  easeOutQuart: x => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: x => x * x * x * x * x,
  easeOutQuint: x => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: x => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: x => Math.sin(x * Math.PI / 2),
  easeInOutSine: x => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: x => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: x => c3 * x * x * x - c1 * x * x,
  easeOutBack: x => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: x => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: x => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: x => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: x => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2
};

const defaults = react_spring_core_esm_extends({}, config.default, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

class AnimationConfig {
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }

}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = react_spring_core_esm_extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = react_spring_core_esm_extends({}, defaultConfig, newConfig);
  }

  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);

  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }

  let {
    mass,
    frequency,
    damping
  } = config;

  if (!react_spring_shared_esm_is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config;
}

function sanitizeConfig(config, props) {
  if (!react_spring_shared_esm_is.und(props.decay)) {
    config.duration = undefined;
  } else {
    const isTensionConfig = !react_spring_shared_esm_is.und(props.tension) || !react_spring_shared_esm_is.und(props.friction);

    if (isTensionConfig || !react_spring_shared_esm_is.und(props.frequency) || !react_spring_shared_esm_is.und(props.damping) || !react_spring_shared_esm_is.und(props.mass)) {
      config.duration = undefined;
      config.decay = undefined;
    }

    if (isTensionConfig) {
      config.frequency = undefined;
    }
  }
}

const emptyArray = [];
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
  }

}

function scheduleProps(callId, {
  key,
  props,
  defaultProps,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    var _props$cancel;

    let delay;
    let timeout;
    let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!react_spring_shared_esm_is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      let pause = defaultProps == null ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }

    function onResume() {
      if (delay > 0 && !globals.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(react_spring_core_esm_extends({}, props, {
          callId,
          cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));
const getNoopResult = value => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
const getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
const getCancelledResult = value => ({
  value,
  cancelled: true,
  finished: false
});

function runAsync(to, props, state, target) {
  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to;
    const defaultProps = getDefaultProps(props, (value, key) => key === 'onRest' ? undefined : value);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));

    const bailIfEnded = bailSignal => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };

    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAniamtionSignal();
      return (async () => {
        if (globals.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }

        bailIfEnded(bailSignal);
        const props = react_spring_shared_esm_is.obj(arg1) ? react_spring_core_esm_extends({}, arg1) : react_spring_core_esm_extends({}, arg2, {
          to: arg1
        });
        props.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (react_spring_shared_esm_is.und(props[key])) {
            props[key] = value;
          }
        });
        const result = await target.start(props);
        bailIfEnded(bailSignal);

        if (state.paused) {
          await new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result;
      })();
    };

    let result;

    if (globals.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }

    try {
      let animating;

      if (react_spring_shared_esm_is.arr(to)) {
        animating = (async queue => {
          for (const props of queue) {
            await animate(props);
          }
        })(to);
      } else {
          animating = Promise.resolve(to(animate, target.stop.bind(target)));
        }

      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAniamtionSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : undefined;
        state.promise = parentId ? prevPromise : undefined;
      }
    }

    if (react_spring_shared_esm_is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }

    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, t => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = undefined;
  if (cancelId) state.cancelId = cancelId;
}
class BailSignal extends Error {
  constructor() {
    super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
    this.result = void 0;
  }

}
class SkipAniamtionSignal extends Error {
  constructor() {
    super('SkipAnimationSignal');
    this.result = void 0;
  }

}

const isFrameValue = value => value instanceof FrameValue;
let nextId$1 = 1;
class FrameValue extends FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId$1++;
    this.key = void 0;
    this._priority = 0;
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }

  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }

  to(...args) {
    return globals.to(this, args);
  }

  interpolate(...args) {
    react_spring_shared_esm_deprecateInterpolate();
    return globals.to(this, args);
  }

  toJSON() {
    return this.get();
  }

  observerAdded(count) {
    if (count == 1) this._attach();
  }

  observerRemoved(count) {
    if (count == 0) this._detach();
  }

  _attach() {}

  _detach() {}

  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: 'change',
      parent: this,
      value,
      idle
    });
  }

  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }

    callFluidObservers(this, {
      type: 'priority',
      parent: this,
      priority
    });
  }

}

const $P = Symbol.for('SpringPhase');
const HAS_ANIMATED = 1;
const IS_ANIMATING = 2;
const IS_PAUSED = 4;
const hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;
const isAnimating = target => (target[$P] & IS_ANIMATING) > 0;
const isPaused = target => (target[$P] & IS_PAUSED) > 0;
const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

class SpringValue extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this.defaultProps = {};
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._pendingCalls = new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;

    if (!react_spring_shared_esm_is.und(arg1) || !react_spring_shared_esm_is.und(arg2)) {
      const props = react_spring_shared_esm_is.obj(arg1) ? react_spring_core_esm_extends({}, arg1) : react_spring_core_esm_extends({}, arg2, {
        from: arg1
      });

      if (react_spring_shared_esm_is.und(props.default)) {
        props.default = true;
      }

      this.start(props);
    }
  }

  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }

  get goal() {
    return getFluidValue(this.animation.to);
  }

  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
  }

  get hasAnimated() {
    return hasAnimated(this);
  }

  get isAnimating() {
    return isAnimating(this);
  }

  get isPaused() {
    return isPaused(this);
  }

  get isDelayed() {
    return this._state.delayed;
  }

  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config,
      toValues
    } = anim;
    const payload = getPayload(anim.to);

    if (!payload && hasFluidValue(anim.to)) {
      toValues = react_spring_shared_esm_toArray(getFluidValue(anim.to));
    }

    anim.values.forEach((node, i) => {
      if (node.done) return;
      const to = node.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;

      if (!finished) {
        position = node.lastPosition;

        if (config.tension <= 0) {
          node.done = true;
          return;
        }

        let elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = react_spring_shared_esm_is.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity;

        if (!react_spring_shared_esm_is.und(config.duration)) {
          let p = 1;

          if (config.duration > 0) {
            if (this._memoizedDuration !== config.duration) {
              this._memoizedDuration = config.duration;

              if (node.durationProgress > 0) {
                node.elapsedTime = config.duration * node.durationProgress;
                elapsed = node.elapsedTime += dt;
              }
            }

            p = (config.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node.durationProgress = p;
          }

          position = from + config.easing(p) * (to - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } else if (config.decay) {
            const decay = config.decay === true ? 0.998 : config.decay;
            const e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node.lastPosition - position) < 0.1;
            velocity = v0 * e;
          } else {
              velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
              const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
              const restVelocity = config.restVelocity || precision / 10;
              const bounceFactor = config.clamp ? 0 : config.bounce;
              const canBounce = !react_spring_shared_esm_is.und(bounceFactor);
              const isGrowing = from == to ? node.v0 > 0 : from < to;
              let isMoving;
              let isBouncing = false;
              const step = 1;
              const numSteps = Math.ceil(dt / step);

              for (let n = 0; n < numSteps; ++n) {
                isMoving = Math.abs(velocity) > restVelocity;

                if (!isMoving) {
                  finished = Math.abs(to - position) <= precision;

                  if (finished) {
                    break;
                  }
                }

                if (canBounce) {
                  isBouncing = position == to || position > to == isGrowing;

                  if (isBouncing) {
                    velocity = -velocity * bounceFactor;
                    position = to;
                  }
                }

                const springForce = -config.tension * 0.000001 * (position - to);
                const dampingForce = -config.friction * 0.001 * velocity;
                const acceleration = (springForce + dampingForce) / config.mass;
                velocity = velocity + acceleration * step;
                position = position + velocity * step;
              }
            }

        node.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }

      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }

      if (node.setValue(position, config.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();

    if (idle) {
      const finalVal = getFluidValue(anim.to);

      if ((currVal !== finalVal || changed) && !config.decay) {
        node.setValue(finalVal);

        this._onChange(finalVal);
      } else if (changed && config.decay) {
        this._onChange(currVal);
      }

      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }

  set(value) {
    raf.batchedUpdates(() => {
      this._stop();

      this._focus(value);

      this._set(value);
    });
    return this;
  }

  pause() {
    this._update({
      pause: true
    });
  }

  resume() {
    this._update({
      pause: false
    });
  }

  finish() {
    if (isAnimating(this)) {
      const {
        to,
        config
      } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();

        if (!config.decay) {
          this._set(to, false);
        }

        this._stop();
      });
    }

    return this;
  }

  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }

  start(to, arg2) {
    let queue;

    if (!react_spring_shared_esm_is.und(to)) {
      queue = [react_spring_shared_esm_is.obj(to) ? to : react_spring_core_esm_extends({}, arg2, {
        to
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    return Promise.all(queue.map(props => {
      const up = this._update(props);

      return up;
    })).then(results => getCombinedResult(this, results));
  }

  stop(cancel) {
    const {
      to
    } = this.animation;

    this._focus(this.get());

    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to, cancel));
    return this;
  }

  reset() {
    this._update({
      reset: true
    });
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._start();
    } else if (event.type == 'priority') {
      this.priority = event.priority + 1;
    }
  }

  _prepareNode(props) {
    const key = this.key || '';
    let {
      to,
      from
    } = props;
    to = react_spring_shared_esm_is.obj(to) ? to[key] : to;

    if (to == null || isAsyncTo(to)) {
      to = undefined;
    }

    from = react_spring_shared_esm_is.obj(from) ? from[key] : from;

    if (from == null) {
      from = undefined;
    }

    const range = {
      to,
      from
    };

    if (!hasAnimated(this)) {
      if (props.reverse) [to, from] = [from, to];
      from = getFluidValue(from);

      if (!react_spring_shared_esm_is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
          this._set(to);
        }
    }

    return range;
  }

  _update(_ref, isLoop) {
    let props = react_spring_core_esm_extends({}, _ref);

    const {
      key,
      defaultProps
    } = this;
    if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, 'onProps');
    sendEvent(this, 'onProps', props, this);

    const range = this._prepareNode(props);

    if (Object.isFrozen(this)) {
      throw Error('Cannot animate a `SpringValue` object that is frozen. ' + 'Did you forget to pass your component to `animated(...)` before animating its props?');
    }

    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(this, 'onPause', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);

            if (isAnimating(this)) {
              this._resume();
            }

            flushCalls(state.resumeQueue);
            sendEvent(this, 'onResume', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }

  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    const hasToProp = !react_spring_shared_esm_is.und(range.to);
    const hasFromProp = !react_spring_shared_esm_is.und(range.from);

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }

    const {
      key,
      defaultProps,
      animation: anim
    } = this;
    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to = prevTo,
      from = prevFrom
    } = range;

    if (hasFromProp && !hasToProp && (!props.default || react_spring_shared_esm_is.und(to))) {
      to = from;
    }

    if (props.reverse) [to, from] = [from, to];
    const hasFromChanged = !isEqual(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }

    from = getFluidValue(from);
    const hasToChanged = !isEqual(to, prevTo);

    if (hasToChanged) {
      this._focus(to);
    }

    const hasAsyncTo = isAsyncTo(props.to);
    const {
      config
    } = anim;
    const {
      decay,
      velocity
    } = config;

    if (hasToProp || hasFromProp) {
      config.velocity = 0;
    }

    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }

    let node = getAnimated(this);

    if (!node || react_spring_shared_esm_is.und(to)) {
      return resolve(getFinishedResult(this, true));
    }

    const reset = react_spring_shared_esm_is.und(props.reset) ? hasFromProp && !props.default : !react_spring_shared_esm_is.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to);
    const isAnimatable = react_spring_shared_esm_is.num(goal) || react_spring_shared_esm_is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      const nodeType = getAnimatedType(to);

      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
      }
    }

    const goalType = node.constructor;
    let started = hasFluidValue(to);
    let finished = false;

    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }

      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config.decay, decay) || !isEqual(config.velocity, velocity)) {
        started = true;
      }
    }

    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
          this._stop(prevTo);
        }
    }

    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to) ? null : goalType == AnimatedString ? [1] : react_spring_shared_esm_toArray(goal);
      }

      if (anim.immediate != immediate) {
        anim.immediate = immediate;

        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }

      if (started) {
        const {
          onRest
        } = anim;
        react_spring_shared_esm_each(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);

        this._pendingCalls.add(resolve);

        if (anim.changed) raf.batchedUpdates(() => {
          anim.changed = !reset;
          onRest == null ? void 0 : onRest(result, this);

          if (reset) {
            callProp(defaultProps.onRest, result);
          } else {
              anim.onStart == null ? void 0 : anim.onStart(result, this);
            }
        });
      }
    }

    if (reset) {
      this._set(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
          this._pendingCalls.add(resolve);
        } else {
            resolve(getNoopResult(value));
          }
  }

  _focus(value) {
    const anim = this.animation;

    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }

      anim.to = value;

      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }

  _attach() {
    let priority = 0;
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      addFluidObserver(to, this);

      if (isFrameValue(to)) {
        priority = to.priority + 1;
      }
    }

    this.priority = priority;
  }

  _detach() {
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      removeFluidObserver(to, this);
    }
  }

  _set(arg, idle = true) {
    const value = getFluidValue(arg);

    if (!react_spring_shared_esm_is.und(value)) {
      const oldNode = getAnimated(this);

      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);

        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }

        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }

    return getAnimated(this);
  }

  _onStart() {
    const anim = this.animation;

    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, 'onStart', getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }

  _onChange(value, idle) {
    if (!idle) {
      this._onStart();

      callProp(this.animation.onChange, value, this);
    }

    callProp(this.defaultProps.onChange, value, this);

    super._onChange(value, idle);
  }

  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));

    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    if (!isAnimating(this)) {
      setActiveBit(this, true);

      if (!isPaused(this)) {
        this._resume();
      }
    }
  }

  _resume() {
    if (globals.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }

  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      react_spring_shared_esm_each(anim.values, node => {
        node.done = true;
      });

      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = undefined;
      }

      callFluidObservers(this, {
        type: 'idle',
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
      flushCalls(this._pendingCalls, result);

      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, 'onRest', result, this);
      }
    }
  }

}

function checkFinished(target, to) {
  const goal = computeGoal(to);
  const value = computeGoal(target.get());
  return isEqual(value, goal);
}

function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);

  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(react_spring_core_esm_extends({}, props, {
      loop,
      default: false,
      pause: undefined,
      to: !reverse || isAsyncTo(to) ? to : undefined,
      from: reset ? props.from : undefined,
      reset
    }, overrides));
  }
}
function createUpdate(props) {
  const {
    to,
    from
  } = props = inferTo(props);
  const keys = new Set();
  if (react_spring_shared_esm_is.obj(to)) findDefined(to, keys);
  if (react_spring_shared_esm_is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);

  if (react_spring_shared_esm_is.und(update.default)) {
    update.default = getDefaultProps(update);
  }

  return update;
}

function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}

const ACTIVE_EVENTS = ['onStart', 'onRest', 'onChange', 'onPause', 'onResume'];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : undefined;
}

function sendEvent(target, type, ...args) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : _target$animation$typ.call(_target$animation, ...args);
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
}

const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
let nextId = 1;
class Controller {
  constructor(props, flush) {
    this.id = nextId++;
    this.springs = {};
    this.queue = [];
    this.ref = void 0;
    this._flush = void 0;
    this._initialProps = void 0;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._changed = new Set();
    this._started = false;
    this._item = void 0;
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush) {
      this._flush = flush;
    }

    if (props) {
      this.start(react_spring_core_esm_extends({
        default: true
      }, props));
    }
  }

  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }

  get item() {
    return this._item;
  }

  set item(item) {
    this._item = item;
  }

  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }

  set(values) {
    for (const key in values) {
      const value = values[key];

      if (!react_spring_shared_esm_is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }

  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }

    return this;
  }

  start(props) {
    let {
      queue
    } = this;

    if (props) {
      queue = react_spring_shared_esm_toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }

  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }

    if (keys) {
      const springs = this.springs;
      react_spring_shared_esm_each(react_spring_shared_esm_toArray(keys), key => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each(spring => spring.stop(!!arg));
    }

    return this;
  }

  pause(keys) {
    if (react_spring_shared_esm_is.und(keys)) {
      this.start({
        pause: true
      });
    } else {
      const springs = this.springs;
      react_spring_shared_esm_each(react_spring_shared_esm_toArray(keys), key => springs[key].pause());
    }

    return this;
  }

  resume(keys) {
    if (react_spring_shared_esm_is.und(keys)) {
      this.start({
        pause: false
      });
    } else {
      const springs = this.springs;
      react_spring_shared_esm_each(react_spring_shared_esm_toArray(keys), key => springs[key].resume());
    }

    return this;
  }

  each(iterator) {
    eachProp(this.springs, iterator);
  }

  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;

    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart, result]) => {
        result.value = this.get();
        onStart(result, this, this._item);
      });
    }

    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;

    if (changed && onChange.size) {
      flush(onChange, ([onChange, result]) => {
        result.value = values;
        onChange(result, this, this._item);
      });
    }

    if (idle) {
      this._started = false;
      flush(onRest, ([onRest, result]) => {
        result.value = values;
        onRest(result, this, this._item);
      });
    }
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._changed.add(event.parent);

      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else return;

    raf.onFrame(this._onFrame);
  }

}
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
  const {
    keys,
    to,
    from,
    loop,
    onRest,
    onResolve
  } = props;
  const defaults = react_spring_shared_esm_is.obj(props.default) && props.default;

  if (loop) {
    props.loop = false;
  }

  if (to === false) props.to = null;
  if (from === false) props.from = null;
  const asyncTo = react_spring_shared_esm_is.arr(to) || react_spring_shared_esm_is.fun(to) ? to : undefined;

  if (asyncTo) {
    props.to = undefined;
    props.onRest = undefined;

    if (defaults) {
      defaults.onRest = undefined;
    }
  } else {
      react_spring_shared_esm_each(BATCHED_EVENTS, key => {
        const handler = props[key];

        if (react_spring_shared_esm_is.fun(handler)) {
          const queue = ctrl['_events'][key];

          props[key] = ({
            finished,
            cancelled
          }) => {
            const result = queue.get(handler);

            if (result) {
              if (!finished) result.finished = false;
              if (cancelled) result.cancelled = true;
            } else {
              queue.set(handler, {
                value: null,
                finished: finished || false,
                cancelled: cancelled || false
              });
            }
          };

          if (defaults) {
            defaults[key] = props[key];
          }
        }
      });
    }

  const state = ctrl['_state'];

  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
      props.pause = true;
    }

  const promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
  const cancel = props.cancel === true || getDefaultProp(props, 'cancel') === true;

  if (asyncTo || cancel && state.asyncId) {
    promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
      props,
      state,
      actions: {
        pause: noop,
        resume: noop,

        start(props, resolve) {
          if (cancel) {
            stopAsync(state, ctrl['_lastAsyncId']);
            resolve(getCancelledResult(ctrl));
          } else {
            props.onRest = onRest;
            resolve(runAsync(asyncTo, props, state, ctrl));
          }
        }

      }
    }));
  }

  if (state.paused) {
    await new Promise(resume => {
      state.resumeQueue.add(resume);
    });
  }

  const result = getCombinedResult(ctrl, await Promise.all(promises));

  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to);

    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }

  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }

  return result;
}
function getSprings(ctrl, props) {
  const springs = react_spring_core_esm_extends({}, ctrl.springs);

  if (props) {
    react_spring_shared_esm_each(react_spring_shared_esm_toArray(props), props => {
      if (react_spring_shared_esm_is.und(props.keys)) {
        props = createUpdate(props);
      }

      if (!react_spring_shared_esm_is.obj(props.to)) {
        props = react_spring_core_esm_extends({}, props, {
          to: undefined
        });
      }

      prepareSprings(springs, props, key => {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;

  if (observer) {
    addFluidObserver(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    react_spring_shared_esm_each(props.keys, key => {
      const spring = springs[key] || (springs[key] = create(key));
      spring['_prepareNode'](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  react_spring_shared_esm_each(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$3 = ["children"];
const SpringContext = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  const inherited = (0,react.useContext)(ctx);
  const pause = props.pause || !!inherited.pause,
        immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({
    pause,
    immediate
  }), [pause, immediate]);
  const {
    Provider
  } = ctx;
  return react.createElement(Provider, {
    value: props
  }, children);
};
const ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, react.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

const SpringRef = () => {
  const current = [];

  const SpringRef = function SpringRef(props) {
    deprecateDirectCall();
    const results = [];
    react_spring_shared_esm_each(current, (ctrl, i) => {
      if (react_spring_shared_esm_is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = _getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.current = current;

  SpringRef.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef.delete = function (ctrl) {
    const i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef.pause = function () {
    react_spring_shared_esm_each(current, ctrl => ctrl.pause(...arguments));
    return this;
  };

  SpringRef.resume = function () {
    react_spring_shared_esm_each(current, ctrl => ctrl.resume(...arguments));
    return this;
  };

  SpringRef.set = function (values) {
    react_spring_shared_esm_each(current, ctrl => ctrl.set(values));
  };

  SpringRef.start = function (props) {
    const results = [];
    react_spring_shared_esm_each(current, (ctrl, i) => {
      if (react_spring_shared_esm_is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = this._getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.stop = function () {
    react_spring_shared_esm_each(current, ctrl => ctrl.stop(...arguments));
    return this;
  };

  SpringRef.update = function (props) {
    react_spring_shared_esm_each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };

  const _getProps = function _getProps(arg, ctrl, index) {
    return react_spring_shared_esm_is.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef._getProps = _getProps;
  return SpringRef;
};

function useSprings(length, props, deps) {
  const propsFn = react_spring_shared_esm_is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  const ref = (0,react.useMemo)(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const layoutId = (0,react.useRef)(0);
  const forceUpdate = react_spring_shared_esm_useForceUpdate();
  const state = (0,react.useMemo)(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates) {
      const springs = getSprings(ctrl, updates);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
        setSprings(ctrl, springs);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates));
        });
        forceUpdate();
      });
    }

  }), []);
  const ctrls = (0,react.useRef)([...state.ctrls]);
  const updates = [];
  const prevLength = react_spring_shared_esm_usePrev(length) || 0;
  (0,react.useMemo)(() => {
    react_spring_shared_esm_each(ctrls.current.slice(length, prevLength), ctrl => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  (0,react.useMemo)(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update = propsFn ? propsFn(i, ctrl) : props[i];

      if (update) {
        updates[i] = declareUpdate(update);
      }
    }
  }

  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = (0,react.useContext)(SpringContext);
  const prevContext = react_spring_shared_esm_usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  react_spring_shared_esm_useLayoutEffect(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      react_spring_shared_esm_each(queue, cb => cb());
    }

    react_spring_shared_esm_each(ctrls.current, (ctrl, i) => {
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      const update = updates[i];

      if (update) {
        replaceRef(ctrl, update.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  react_spring_shared_esm_useOnce(() => () => {
    react_spring_shared_esm_each(state.ctrls, ctrl => ctrl.stop(true));
  });
  const values = springs.map(x => react_spring_core_esm_extends({}, x));
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  const isFn = react_spring_shared_esm_is.fun(props);
  const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

const initSpringRef = () => SpringRef();

const useSpringRef = () => useState(initSpringRef)[0];

function useTrail(length, propsArg, deps) {
  var _passedRef;

  const propsFn = is.fun(propsArg) && propsArg;
  if (propsFn && !deps) deps = [];
  let reverse = true;
  let passedRef = undefined;
  const result = useSprings(length, (i, ctrl) => {
    const props = propsFn ? propsFn(i, ctrl) : propsArg;
    passedRef = props.ref;
    reverse = reverse && props.reverse;
    return props;
  }, deps || [{}]);
  const ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
  useLayoutEffect(() => {
    each(ref.current, (ctrl, i) => {
      const parent = ref.current[i + (reverse ? 1 : -1)];

      if (parent) {
        ctrl.start({
          to: parent.springs
        });
      } else {
        ctrl.start();
      }
    });
  }, deps);

  if (propsFn || arguments.length == 3) {
    ref['_getProps'] = (propsArg, ctrl, i) => {
      const props = is.fun(propsArg) ? propsArg(i, ctrl) : propsArg;

      if (props) {
        const parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent) props.to = parent.springs;
        return props;
      }
    };

    return result;
  }

  ref['start'] = propsArg => {
    const results = [];
    each(ref.current, (ctrl, i) => {
      const props = is.fun(propsArg) ? propsArg(i, ctrl) : propsArg;
      const parent = ref.current[i + (reverse ? 1 : -1)];

      if (parent) {
        results.push(ctrl.start(react_spring_core_esm_extends({}, props, {
          to: parent.springs
        })));
      } else {
        results.push(ctrl.start(react_spring_core_esm_extends({}, props)));
      }
    });
    return results;
  };

  return result[0];
}

let TransitionPhase;

(function (TransitionPhase) {
  TransitionPhase["MOUNT"] = "mount";
  TransitionPhase["ENTER"] = "enter";
  TransitionPhase["UPDATE"] = "update";
  TransitionPhase["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));

function useTransition(data, props, deps) {
  const propsFn = is.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const items = toArray(data);
  const transitions = [];
  const usedTransitions = useRef(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useLayoutEffect(() => {
    usedTransitions.current = transitions;
  });
  useOnce(() => {
    each(usedTransitions.current, t => {
      var _t$ctrl$ref;

      (_t$ctrl$ref = t.ctrl.ref) == null ? void 0 : _t$ctrl$ref.add(t.ctrl);
      const change = changes.get(t);

      if (change) {
        t.ctrl.start(change.payload);
      }
    });
    return () => {
      each(usedTransitions.current, t => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }

        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useLayoutEffect(() => each(expired, ({
    ctrl,
    item,
    key
  }) => {
    detachRefs(ctrl, ref);
    callProp(onDestroyed, item, key);
  }));
  const reused = [];
  if (prevTransitions) each(prevTransitions, (t, i) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
      expired.push(t);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  });
  each(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: TransitionPhase.MOUNT,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });

  if (reused.length) {
    let i = -1;
    const {
      leave
    } = propsFn ? propsFn() : props;
    each(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];

      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = react_spring_core_esm_extends({}, t, {
          item: items[keyIndex]
        });
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }

  if (is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }

  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps = getDefaultProps(props);
  const changes = new Map();
  const exitingTransitions = useRef(new Map());
  const forceChange = useRef(false);
  each(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to;
    let phase;
    let propsDelay = callProp(p.delay || 0, key);

    if (prevPhase == TransitionPhase.MOUNT) {
      to = p.enter;
      phase = TransitionPhase.ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;

      if (prevPhase != TransitionPhase.LEAVE) {
        if (isLeave) {
          to = p.leave;
          phase = TransitionPhase.LEAVE;
        } else if (to = p.update) {
          phase = TransitionPhase.UPDATE;
        } else return;
      } else if (!isLeave) {
        to = p.enter;
        phase = TransitionPhase.ENTER;
      } else return;
    }

    to = callProp(to, t.item, i);
    to = is.obj(to) ? inferTo(to) : {
      to
    };

    if (!to.config) {
      const config = propsConfig || defaultProps.config;
      to.config = callProp(config, t.item, i, phase);
    }

    delay += trail;

    const payload = react_spring_core_esm_extends({}, defaultProps, {
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      reset: false
    }, to);

    if (phase == TransitionPhase.ENTER && is.und(payload.from)) {
      const _p = propsFn ? propsFn() : props;

      const from = is.und(_p.initial) || prevTransitions ? _p.from : _p.initial;
      payload.from = callProp(from, t.item, i);
    }

    const {
      onResolve
    } = payload;

    payload.onResolve = result => {
      callProp(onResolve, result);
      const transitions = usedTransitions.current;
      const t = transitions.find(t => t.key === key);
      if (!t) return;

      if (result.cancelled && t.phase != TransitionPhase.UPDATE) {
        return;
      }

      if (t.ctrl.idle) {
        const idle = transitions.every(t => t.ctrl.idle);

        if (t.phase == TransitionPhase.LEAVE) {
          const expiry = callProp(expires, t.item);

          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t.expired = true;

            if (!idle && expiryMs > 0) {
              if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }

        if (idle && transitions.some(t => t.expired)) {
          exitingTransitions.current.delete(t);

          if (exitBeforeEnter) {
            forceChange.current = true;
          }

          forceUpdate();
        }
      }
    };

    const springs = getSprings(t.ctrl, payload);

    if (phase === TransitionPhase.LEAVE && exitBeforeEnter) {
      exitingTransitions.current.set(t, {
        phase,
        springs,
        payload
      });
    } else {
      changes.set(t, {
        phase,
        springs,
        payload
      });
    }
  });
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(() => {
    if (hasContext) {
      each(transitions, t => {
        t.ctrl.start({
          default: context
        });
      });
    }
  }, [context]);
  each(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex(state => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useLayoutEffect(() => {
    each(exitingTransitions.current.size ? exitingTransitions.current : changes, ({
      phase,
      payload
    }, t) => {
      const {
        ctrl
      } = t;
      t.phase = phase;
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext && phase == TransitionPhase.ENTER) {
        ctrl.start({
          default: context
        });
      }

      if (payload) {
        replaceRef(ctrl, payload.ref);

        if (ctrl.ref && !forceChange.current) {
          ctrl.update(payload);
        } else {
          ctrl.start(payload);

          if (forceChange.current) {
            forceChange.current = false;
          }
        }
      }
    });
  }, reset ? void 0 : deps);

  const renderTransitions = render => React.createElement(React.Fragment, null, transitions.map((t, i) => {
    const {
      springs
    } = changes.get(t) || t.ctrl;
    const elem = render(react_spring_core_esm_extends({}, springs), t.item, t, i);
    return elem && elem.type ? React.createElement(elem.type, react_spring_core_esm_extends({}, elem.props, {
      key: is.str(t.key) || is.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));

  return ref ? [renderTransitions, ref] : renderTransitions;
}
let nextKey = 1;

function getKeys(items, {
  key,
  keys = key
}, prevTransitions) {
  if (keys === null) {
    const reused = new Set();
    return items.map(item => {
      const t = prevTransitions && prevTransitions.find(t => t.item === item && t.phase !== TransitionPhase.LEAVE && !reused.has(t));

      if (t) {
        reused.add(t);
        return t.key;
      }

      return nextKey++;
    });
  }

  return is.und(keys) ? items : is.fun(keys) ? items.map(keys) : toArray(keys);
}

const _excluded$2 = (/* unused pure expression or super */ null && (["children"]));
function Spring(_ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return children(useSpring(props));
}

const _excluded$1 = (/* unused pure expression or super */ null && (["items", "children"]));
function Trail(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  const trails = useTrail(items.length, props);
  return items.map((item, index) => {
    const result = children(item, index);
    return is.fun(result) ? result(trails[index]) : result;
  });
}

const _excluded = (/* unused pure expression or super */ null && (["items", "children"]));
function Transition(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return useTransition(items, props)(children);
}

class Interpolation extends FrameValue {
  constructor(source, args) {
    super();
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this._active = new Set();
    this.source = source;
    this.calc = createInterpolator(...args);

    const value = this._get();

    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }

  advance(_dt) {
    const value = this._get();

    const oldValue = this.get();

    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);

      this._onChange(value, this.idle);
    }

    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }

  _get() {
    const inputs = react_spring_shared_esm_is.arr(this.source) ? this.source.map(getFluidValue) : react_spring_shared_esm_toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }

  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      react_spring_shared_esm_each(getPayload(this), node => {
        node.done = false;
      });

      if (globals.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }

  _attach() {
    let priority = 1;
    react_spring_shared_esm_each(react_spring_shared_esm_toArray(this.source), source => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }

      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }

        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;

    this._start();
  }

  _detach() {
    react_spring_shared_esm_each(react_spring_shared_esm_toArray(this.source), source => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });

    this._active.clear();

    becomeIdle(this);
  }

  eventObserved(event) {
    if (event.type == 'change') {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);

        this._start();
      }
    } else if (event.type == 'idle') {
        this._active.delete(event.parent);
      } else if (event.type == 'priority') {
          this.priority = react_spring_shared_esm_toArray(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
        }
  }

}

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    react_spring_shared_esm_each(getPayload(self), node => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: 'idle',
      parent: self
    });
  }
}

const react_spring_core_esm_to = (source, ...args) => new Interpolation(source, args);
const react_spring_core_esm_interpolate = (source, ...args) => (deprecateInterpolate(), new Interpolation(source, args));

globals.assign({
  createStringInterpolator: createStringInterpolator,
  to: (source, args) => new Interpolation(source, args)
});
const react_spring_core_esm_update = frameLoop.advance;



// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
var react_dom_namespaceObject = /*#__PURE__*/__webpack_require__.t(react_dom, 2);
;// CONCATENATED MODULE: ./node_modules/@react-spring/web/dist/react-spring-web.esm.js






function react_spring_web_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const react_spring_web_esm_excluded$2 = ["style", "children", "scrollTop", "scrollLeft"];
const isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px';
  return ('' + value).trim();
}

const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';

  const _ref = props,
        {
    style,
    children,
    scrollTop,
    scrollLeft
  } = _ref,
        attributes = react_spring_web_esm_objectWithoutPropertiesLoose(_ref, react_spring_web_esm_excluded$2);

  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase())));

  if (children !== void 0) {
    instance.textContent = children;
  }

  for (let name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);

      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }

  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });

  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }

  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

const react_spring_web_esm_excluded$1 = ["x", "y", "z"];
const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const pxTransforms = /^(translate)/;
const degTransforms = /^(rotate|skew)/;

const addUnit = (value, unit) => react_spring_shared_esm_is.num(value) && value !== 0 ? value + unit : value;

const isValueIdentity = (value, id) => react_spring_shared_esm_is.arr(value) ? value.every(v => isValueIdentity(v, id)) : react_spring_shared_esm_is.num(value) ? value === id : parseFloat(value) === id;

class AnimatedStyle extends AnimatedObject {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref,
        style = react_spring_web_esm_objectWithoutPropertiesLoose(_ref, react_spring_web_esm_excluded$1);

    const inputs = [];
    const transforms = [];

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(xyz => [`translate3d(${xyz.map(v => addUnit(v, 'px')).join(',')})`, isValueIdentity(xyz, 0)]);
    }

    eachProp(style, (value, key) => {
      if (key === 'transform') {
        inputs.push([value || '']);
        transforms.push(transform => [transform, transform === '']);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (react_spring_shared_esm_is.und(value)) return;
        const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
        inputs.push(react_spring_shared_esm_toArray(value));
        transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : input => [`${key}(${input.map(v => addUnit(v, unit)).join(',')})`, isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    super(style);
  }

}

class FluidTransform extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this._value = null;
    this.inputs = inputs;
    this.transforms = transforms;
  }

  get() {
    return this._value || (this._value = this._get());
  }

  _get() {
    let transform = '';
    let identity = true;
    react_spring_shared_esm_each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](react_spring_shared_esm_is.arr(arg1) ? arg1 : input.map(getFluidValue));
      transform += ' ' + t;
      identity = identity && id;
    });
    return identity ? 'none' : transform;
  }

  observerAdded(count) {
    if (count == 1) react_spring_shared_esm_each(this.inputs, input => react_spring_shared_esm_each(input, value => hasFluidValue(value) && addFluidObserver(value, this)));
  }

  observerRemoved(count) {
    if (count == 0) react_spring_shared_esm_each(this.inputs, input => react_spring_shared_esm_each(input, value => hasFluidValue(value) && removeFluidObserver(value, this)));
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._value = null;
    }

    callFluidObservers(this, event);
  }

}

const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

const react_spring_web_esm_excluded = ["scrollTop", "scrollLeft"];
globals.assign({
  batchedUpdates: react_dom.unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator,
  colors: colors
});
const host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: style => new AnimatedStyle(style),
  getComponentProps: _ref => {
    let props = react_spring_web_esm_objectWithoutPropertiesLoose(_ref, react_spring_web_esm_excluded);

    return props;
  }
});
const animated = host.animated;



;// CONCATENATED MODULE: ./node_modules/ahooks/es/useMount/index.js



var useMount = function useMount(fn) {
  if (utils_isDev) {
    if (!isFunction(fn)) {
      console.error("useMount: parameter `fn` expected to be a function, but got \"".concat(typeof fn, "\"."));
    }
  }
  (0,react.useEffect)(function () {
    fn === null || fn === void 0 ? void 0 : fn();
  }, []);
};
/* harmony default export */ var es_useMount = (useMount);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-initialized.js

function useInitialized(check) {
    var initializedRef = (0,react.useRef)(check);
    if (check) {
        initializedRef.current = true;
    }
    return !!initializedRef.current;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/should-render.js

var ShouldRender = function(props) {
    var shouldRender = useShouldRender(props.active, props.forceRender, props.destroyOnClose);
    return shouldRender ? props.children : null;
};
function useShouldRender(active, forceRender, destroyOnClose) {
    var initialized = useInitialized(active);
    if (forceRender) return true;
    if (active) return true;
    if (!initialized) return false;
    return !destroyOnClose;
}

;// CONCATENATED MODULE: ./node_modules/ahooks/es/createUpdateEffect/index.js

var createUpdateEffect = function createUpdateEffect(hook) {
  return function (effect, deps) {
    var isMounted = (0,react.useRef)(false);
    // for react-refresh
    hook(function () {
      return function () {
        isMounted.current = false;
      };
    }, []);
    hook(function () {
      if (!isMounted.current) {
        isMounted.current = true;
      } else {
        return effect();
      }
    }, deps);
  };
};
/* harmony default export */ var es_createUpdateEffect = ((/* unused pure expression or super */ null && (createUpdateEffect)));
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/isBrowser.js
var isBrowser = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/* harmony default export */ var utils_isBrowser = (isBrowser);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useIsomorphicLayoutEffect/index.js


var useIsomorphicLayoutEffect = utils_isBrowser ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var es_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-isomorphic-update-layout-effect.js

var useIsomorphicUpdateLayoutEffect = createUpdateEffect(es_useIsomorphicLayoutEffect);

// EXTERNAL MODULE: ./node_modules/antd-mobile/node_modules/react-is/index.js
var react_is = __webpack_require__(68901);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/traverse-react-node.js


function traverseReactNode(children, fn) {
    var i = 0;
    function handle(target) {
        react.Children.forEach(target, function(child) {
            if (!(0,react_is.isFragment)(child)) {
                fn(child, i);
                i += 1;
            } else {
                handle(child.props.children);
            }
        });
    }
    handle(children);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/collapse/collapse.js
function collapse_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function collapse_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function collapse_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return collapse_arrayLikeToArray(arr);
}
function collapse_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function collapse_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function collapse_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function collapse_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function collapse_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function collapse_slicedToArray(arr, i) {
    return collapse_arrayWithHoles(arr) || collapse_iterableToArrayLimit(arr, i) || collapse_unsupportedIterableToArray(arr, i) || collapse_nonIterableRest();
}
function collapse_toConsumableArray(arr) {
    return collapse_arrayWithoutHoles(arr) || collapse_iterableToArray(arr) || collapse_unsupportedIterableToArray(arr) || collapse_nonIterableSpread();
}
function collapse_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return collapse_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return collapse_arrayLikeToArray(o, minLen);
}











var collapse_classPrefix = "adm-collapse";
var CollapsePanel = function() {
    return null;
};
var CollapsePanelContent = function(props) {
    var visible = props.visible;
    var innerRef = (0,react.useRef)(null);
    var shouldRender = useShouldRender(visible, props.forceRender, props.destroyOnClose);
    var ref = collapse_slicedToArray(useSpring(function() {
        return {
            from: {
                height: 0
            },
            config: {
                precision: 0.01,
                mass: 1,
                tension: 200,
                friction: 25,
                clamp: true
            }
        };
    }), 2), height = ref[0].height, api = ref[1];
    es_useMount(function() {
        if (!visible) return;
        var inner = innerRef.current;
        if (!inner) return;
        api.start({
            height: inner.offsetHeight,
            immediate: true
        });
    });
    useIsomorphicUpdateLayoutEffect(function() {
        var inner = innerRef.current;
        if (!inner) return;
        if (visible) {
            api.start({
                height: inner.offsetHeight
            });
        } else {
            api.start({
                height: inner.offsetHeight,
                immediate: true
            });
            api.start({
                height: 0
            });
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ react.createElement(animated.div, {
        className: "".concat(collapse_classPrefix, "-panel-content"),
        style: {
            height: height.to(function(v) {
                if (height.idle && visible) {
                    return "auto";
                } else {
                    return v;
                }
            })
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(collapse_classPrefix, "-panel-content-inner"),
        ref: innerRef
    }, /*#__PURE__*/ react.createElement(components_list.Item, null, shouldRender && props.children)));
};
var Collapse = function(props) {
    var _a1;
    var panels = [];
    traverseReactNode(props.children, function(child) {
        if (!/*#__PURE__*/ react.isValidElement(child)) return;
        var key = child.key;
        if (typeof key !== "string") return;
        panels.push(child);
    });
    var ref = collapse_slicedToArray(usePropsValue(props.accordion ? {
        value: props.activeKey === undefined ? undefined : props.activeKey === null ? [] : [
            props.activeKey
        ],
        defaultValue: props.defaultActiveKey === undefined || props.defaultActiveKey === null ? [] : [
            props.defaultActiveKey
        ],
        onChange: function(v) {
            var _a, _b;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, (_b = v[0]) !== null && _b !== void 0 ? _b : null);
        }
    } : {
        value: props.activeKey,
        defaultValue: (_a1 = props.defaultActiveKey) !== null && _a1 !== void 0 ? _a1 : [],
        onChange: props.onChange
    }), 2), activeKey = ref[0], setActiveKey = ref[1];
    var activeKeyList = activeKey === null ? [] : Array.isArray(activeKey) ? activeKey : [
        activeKey
    ];
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: collapse_classPrefix
    }, /*#__PURE__*/ react.createElement(components_list, null, panels.map(function(panel) {
        var handleClick = function handleClick(event) {
            var _a, _b;
            if (props.accordion) {
                if (active) {
                    setActiveKey([]);
                } else {
                    setActiveKey([
                        key
                    ]);
                }
            } else {
                if (active) {
                    setActiveKey(activeKeyList.filter(function(v) {
                        return v !== key;
                    }));
                } else {
                    setActiveKey(collapse_toConsumableArray(activeKeyList).concat([
                        key
                    ]));
                }
            }
            (_b = (_a = panel.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        var key = panel.key;
        var active = activeKeyList.includes(key);
        var renderArrow = function() {
            var arrow = /*#__PURE__*/ react.createElement(es_DownOutline, null);
            if (props.arrow !== undefined) {
                arrow = props.arrow;
            }
            if (panel.props.arrow !== undefined) {
                arrow = panel.props.arrow;
            }
            return typeof arrow === "function" ? arrow(active) : /*#__PURE__*/ react.createElement("div", {
                className: classnames_default()("".concat(collapse_classPrefix, "-arrow"), collapse_defineProperty({}, "".concat(collapse_classPrefix, "-arrow-active"), active))
            }, arrow);
        };
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: key
        }, withNativeProps(panel.props, /*#__PURE__*/ react.createElement(components_list.Item, {
            className: "".concat(collapse_classPrefix, "-panel-header"),
            onClick: handleClick,
            disabled: panel.props.disabled,
            arrow: renderArrow()
        }, panel.props.title)), /*#__PURE__*/ react.createElement(CollapsePanelContent, {
            visible: active,
            forceRender: !!panel.props.forceRender,
            destroyOnClose: !!panel.props.destroyOnClose
        }, panel.props.children));
    }))));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/collapse/index.js



/* harmony default export */ var components_collapse = (attachPropertiesToComponent(Collapse, {
    Panel: CollapsePanel
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/dialog/dialog.css
var dialog = __webpack_require__(47916);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/dialog-action-button.js




var DialogActionButton = function(props) {
    var action = props.action;
    return withNativeProps(props.action, /*#__PURE__*/ react.createElement(components_button, {
        key: action.key,
        onClick: props.onAction,
        className: classnames_default()("adm-dialog-button", {
            "adm-dialog-button-bold": action.bold
        }),
        fill: "none",
        shape: "rectangular",
        block: true,
        color: action.danger ? "danger" : "primary",
        loading: "auto",
        disabled: action.disabled
    }, action.text));
};

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/image/image.css
var image_image = __webpack_require__(97030);
// EXTERNAL MODULE: ./node_modules/staged-components/index.js
var staged_components = __webpack_require__(60713);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/to-css-length.js
function toCSSLength(val) {
    return typeof val === "number" ? "".concat(val, "px") : val;
}

// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(66337);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/domTarget.js


function getTargetElement(target, defaultElement) {
  if (!utils_isBrowser) {
    return undefined;
  }
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (isFunction(target)) {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useLatest/index.js

function useLatest(value) {
  var ref = (0,react.useRef)(value);
  ref.current = value;
  return ref;
}
/* harmony default export */ var es_useLatest = (useLatest);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useUnmount/index.js




var useUnmount = function useUnmount(fn) {
  if (utils_isDev) {
    if (!isFunction(fn)) {
      console.error("useUnmount expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = es_useLatest(fn);
  (0,react.useEffect)(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};
/* harmony default export */ var es_useUnmount = (useUnmount);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/depsAreSame.js
function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;
  for (var i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }
  return true;
}
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/createEffectWithTarget.js




var createEffectWithTarget = function createEffectWithTarget(useEffectType) {
  /**
   *
   * @param effect
   * @param deps
   * @param target target should compare ref.current vs ref.current, dom vs dom, ()=>dom vs ()=>dom
   */
  var useEffectWithTarget = function useEffectWithTarget(effect, deps, target) {
    var hasInitRef = (0,react.useRef)(false);
    var lastElementRef = (0,react.useRef)([]);
    var lastDepsRef = (0,react.useRef)([]);
    var unLoadRef = (0,react.useRef)();
    useEffectType(function () {
      var _a;
      var targets = Array.isArray(target) ? target : [target];
      var els = targets.map(function (item) {
        return getTargetElement(item);
      });
      // init run
      if (!hasInitRef.current) {
        hasInitRef.current = true;
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
        return;
      }
      if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
        (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
      }
    });
    es_useUnmount(function () {
      var _a;
      (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
      // for react-refresh
      hasInitRef.current = false;
    });
  };
  return useEffectWithTarget;
};
/* harmony default export */ var utils_createEffectWithTarget = (createEffectWithTarget);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useEffectWithTarget.js


var useEffectWithTarget = utils_createEffectWithTarget(react.useEffect);
/* harmony default export */ var utils_useEffectWithTarget = (useEffectWithTarget);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useInViewport/index.js
var useInViewport_assign = undefined && undefined.__assign || function () {
  useInViewport_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return useInViewport_assign.apply(this, arguments);
};
var useInViewport_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var useInViewport_values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};




function useInViewport(target, options) {
  var _a = useInViewport_read((0,react.useState)(), 2),
    state = _a[0],
    setState = _a[1];
  var _b = useInViewport_read((0,react.useState)(), 2),
    ratio = _b[0],
    setRatio = _b[1];
  utils_useEffectWithTarget(function () {
    var el = getTargetElement(target);
    if (!el) {
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      var e_1, _a;
      try {
        for (var entries_1 = useInViewport_values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
          var entry = entries_1_1.value;
          setRatio(entry.intersectionRatio);
          setState(entry.isIntersecting);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (entries_1_1 && !entries_1_1.done && (_a = entries_1["return"])) _a.call(entries_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }, useInViewport_assign(useInViewport_assign({}, options), {
      root: getTargetElement(options === null || options === void 0 ? void 0 : options.root)
    }));
    observer.observe(el);
    return function () {
      observer.disconnect();
    };
  }, [], target);
  return [state, ratio];
}
/* harmony default export */ var es_useInViewport = (useInViewport);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image/lazy-detector.js
function lazy_detector_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function lazy_detector_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function lazy_detector_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function lazy_detector_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function lazy_detector_slicedToArray(arr, i) {
    return lazy_detector_arrayWithHoles(arr) || lazy_detector_iterableToArrayLimit(arr, i) || lazy_detector_unsupportedIterableToArray(arr, i) || lazy_detector_nonIterableRest();
}
function lazy_detector_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return lazy_detector_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lazy_detector_arrayLikeToArray(o, minLen);
}


var LazyDetector = function(props) {
    var ref = (0,react.useRef)(null);
    var ref1 = lazy_detector_slicedToArray(es_useInViewport(ref), 1), inViewport = ref1[0];
    (0,react.useEffect)(function() {
        if (inViewport) {
            props.onActive();
        }
    }, [
        inViewport
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        ref: ref
    });
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image/image-icon.js

var ImageIcon = function() {
    return /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M41.396 6.234c1.923 0 3.487 1.574 3.487 3.505v29.14c0 1.937-1.568 3.51-3.491 3.51H6.604c-1.923 0-3.487-1.573-3.487-3.51V9.745c0-1.936 1.564-3.51 3.487-3.51Zm0 2.847H6.604c-.355 0-.654.3-.654.658V34.9l5.989-8.707a2.373 2.373 0 0 1 1.801-1.005 2.405 2.405 0 0 1 1.933.752l4.182 4.525 7.58-11.005a2.374 2.374 0 0 1 1.96-1.01c.79 0 1.532.38 1.966 1.01L42.05 34.89V9.74a.664.664 0 0 0-.654-.658Zm-28.305 2.763a3.119 3.119 0 0 1 3.117 3.117 3.119 3.119 0 0 1-3.117 3.117 3.122 3.122 0 0 1-3.117-3.117 3.119 3.119 0 0 1 3.117-3.117Z",
        fill: "#DBDBDB",
        fillRule: "nonzero"
    }));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image/broken-image-icon.js

var BrokenImageIcon = function() {
    return /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M19.233 6.233 17.42 9.08l-10.817.001a.665.665 0 0 0-.647.562l-.007.096V34.9l5.989-8.707a2.373 2.373 0 0 1 1.801-1.005 2.415 2.415 0 0 1 1.807.625l.126.127 4.182 4.525 2.267-3.292 5.461 7.841-4.065 7.375H6.604c-1.86 0-3.382-1.47-3.482-3.317l-.005-.192V9.744c0-1.872 1.461-3.405 3.296-3.505l.19-.005h12.63Zm22.163 0c1.86 0 3.382 1.472 3.482 3.314l.005.192v29.14a3.507 3.507 0 0 1-3.3 3.505l-.191.006H27.789l3.63-6.587.06-.119a1.87 1.87 0 0 0-.163-1.853l-6.928-9.949 3.047-4.422a2.374 2.374 0 0 1 1.96-1.01 2.4 2.4 0 0 1 1.86.87l.106.14L42.05 34.89V9.74a.664.664 0 0 0-.654-.658H21.855l1.812-2.848h17.73Zm-28.305 5.611c.794 0 1.52.298 2.07.788l-.843 1.325-.067.114a1.87 1.87 0 0 0 .11 1.959l.848 1.217c-.556.515-1.3.83-2.118.83a3.122 3.122 0 0 1-3.117-3.116 3.119 3.119 0 0 1 3.117-3.117Z",
        fill: "#DBDBDB",
        fillRule: "nonzero"
    }));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image/image.js









var image_classPrefix = "adm-image";
var image_defaultProps = {
    fit: "fill",
    placeholder: /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_classPrefix, "-tip")
    }, /*#__PURE__*/ react.createElement(ImageIcon, null)),
    fallback: /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_classPrefix, "-tip")
    }, /*#__PURE__*/ react.createElement(BrokenImageIcon, null)),
    lazy: false,
    draggable: false
};
var Image = (0,staged_components.staged)(function(p) {
    var renderInner = function renderInner() {
        if (failed) {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, props.fallback);
        }
        var img = /*#__PURE__*/ react.createElement("img", {
            className: "".concat(image_classPrefix, "-img"),
            src: src,
            alt: props.alt,
            onClick: props.onClick,
            onLoad: function(e) {
                var _a;
                setLoaded(true);
                (_a = props.onLoad) === null || _a === void 0 ? void 0 : _a.call(props, e);
            },
            onError: function(e) {
                var _a;
                setFailed(true);
                (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, e);
            },
            style: {
                objectFit: props.fit,
                display: loaded ? "block" : "none"
            },
            crossOrigin: props.crossOrigin,
            decoding: props.decoding,
            loading: props.loading,
            referrerPolicy: props.referrerPolicy,
            sizes: props.sizes,
            srcSet: srcSet,
            useMap: props.useMap,
            draggable: props.draggable
        });
        return /*#__PURE__*/ react.createElement(react.Fragment, null, !loaded && props.placeholder, img);
    };
    var props = mergeProps(image_defaultProps, p);
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var ref1 = (0,react.useState)(false), failed = ref1[0], setFailed = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var src = props.src;
    var srcSet = props.srcSet;
    var ref3 = (0,react.useState)(!props.lazy), initialized = ref3[0], setInitialized = ref3[1];
    src = initialized ? props.src : undefined;
    srcSet = initialized ? props.srcSet : undefined;
    useIsomorphicUpdateLayoutEffect(function() {
        setLoaded(false);
        setFailed(false);
    }, [
        src
    ]);
    var style = {};
    if (props.width) {
        style["--width"] = toCSSLength(props.width);
        style["width"] = toCSSLength(props.width);
    }
    if (props.height) {
        style["--height"] = toCSSLength(props.height);
        style["height"] = toCSSLength(props.height);
    }
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        ref: ref2,
        className: image_classPrefix,
        style: style,
        onClick: props.onContainerClick
    }, props.lazy && !initialized && /*#__PURE__*/ react.createElement(LazyDetector, {
        onActive: function() {
            setInitialized(true);
        }
    }), renderInner()));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image/index.js


/* harmony default export */ var components_image = (Image);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/auto-center/auto-center.css
var auto_center = __webpack_require__(1845);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/auto-center/auto-center.js


var auto_center_classPrefix = "adm-auto-center";
var AutoCenter = function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: auto_center_classPrefix
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(auto_center_classPrefix, "-content")
    }, props.children)));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/auto-center/index.js


/* harmony default export */ var components_auto_center = (AutoCenter);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/center-popup/center-popup.css
var center_popup = __webpack_require__(21771);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/get-container.js
function resolveContainer(getContainer) {
    var container = typeof getContainer === "function" ? getContainer() : getContainer;
    return container || document.body;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/render-to-container.js



function renderToContainer(getContainer, node) {
    if (can_use_dom_canUseDom && getContainer) {
        var container = resolveContainer(getContainer);
        return /*#__PURE__*/ (0,react_dom.createPortal)(node, container);
    }
    return node;
}

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/mask/mask.css
var mask = __webpack_require__(69542);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useUnmountedRef/index.js

var useUnmountedRef = function useUnmountedRef() {
  var unmountedRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    unmountedRef.current = false;
    return function () {
      unmountedRef.current = true;
    };
  }, []);
  return unmountedRef;
};
/* harmony default export */ var es_useUnmountedRef = (useUnmountedRef);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-touch.js

var MIN_DISTANCE = 10;
function getDirection(x, y) {
    if (x > y && x > MIN_DISTANCE) {
        return "horizontal";
    }
    if (y > x && y > MIN_DISTANCE) {
        return "vertical";
    }
    return "";
}
function useTouch() {
    var startX = (0,react.useRef)(0);
    var startY = (0,react.useRef)(0);
    var deltaX = (0,react.useRef)(0);
    var deltaY = (0,react.useRef)(0);
    var offsetX = (0,react.useRef)(0);
    var offsetY = (0,react.useRef)(0);
    var direction = (0,react.useRef)("");
    var isVertical = function() {
        return direction.current === "vertical";
    };
    var isHorizontal = function() {
        return direction.current === "horizontal";
    };
    var reset = function() {
        deltaX.current = 0;
        deltaY.current = 0;
        offsetX.current = 0;
        offsetY.current = 0;
        direction.current = "";
    };
    var start = function(event) {
        reset();
        startX.current = event.touches[0].clientX;
        startY.current = event.touches[0].clientY;
    };
    var move = function(event) {
        var touch = event.touches[0]; // Fix: Safari back will set clientX to negative number
        deltaX.current = touch.clientX < 0 ? 0 : touch.clientX - startX.current;
        deltaY.current = touch.clientY - startY.current;
        offsetX.current = Math.abs(deltaX.current);
        offsetY.current = Math.abs(deltaY.current);
        if (!direction.current) {
            direction.current = getDirection(offsetX.current, offsetY.current);
        }
    };
    return {
        move: move,
        start: start,
        reset: reset,
        startX: startX,
        startY: startY,
        deltaX: deltaX,
        deltaY: deltaY,
        offsetX: offsetX,
        offsetY: offsetY,
        direction: direction,
        isVertical: isVertical,
        isHorizontal: isHorizontal
    };
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/get-scroll-parent.js

var defaultRoot = can_use_dom_canUseDom ? window : undefined;
var overflowStylePatterns = [
    "scroll",
    "auto",
    "overlay"
];
function isElement(node) {
    var ELEMENT_NODE_TYPE = 1;
    return node.nodeType === ELEMENT_NODE_TYPE;
}
function getScrollParent(el) {
    var root = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultRoot;
    var node = el;
    while(node && node !== root && isElement(node)){
        if (node === document.body) {
            return root;
        }
        var overflowY = window.getComputedStyle(node).overflowY;
        if (overflowStylePatterns.includes(overflowY) && node.scrollHeight > node.clientHeight) {
            return node;
        }
        node = node.parentNode;
    }
    return root;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/supports-passive.js

var supportsPassive = false;
if (can_use_dom_canUseDom) {
    try {
        var opts = {};
        Object.defineProperty(opts, "passive", {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener("test-passive", null, opts);
    } catch (e) {}
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-lock-scroll.js




var totalLockCount = 0;
var BODY_LOCK_CLASS = "adm-overflow-hidden"; // 移植自vant：https://github.com/youzan/vant/blob/HEAD/src/composables/use-lock-scroll.ts
function useLockScroll(rootRef, shouldLock) {
    var touch = useTouch();
    var onTouchMove = function(event) {
        touch.move(event);
        var direction = touch.deltaY.current > 0 ? "10" : "01";
        var el = getScrollParent(event.target, rootRef.current);
        if (!el) return;
        var scrollHeight = el.scrollHeight, offsetHeight = el.offsetHeight, scrollTop = el.scrollTop;
        var status = "11";
        if (scrollTop === 0) {
            status = offsetHeight >= scrollHeight ? "00" : "01";
        } else if (scrollTop + offsetHeight >= scrollHeight) {
            status = "10";
        }
        if (status !== "11" && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
            if (event.cancelable) {
                event.preventDefault();
            }
        }
    };
    var lock = function() {
        document.addEventListener("touchstart", touch.start);
        document.addEventListener("touchmove", onTouchMove, supportsPassive ? {
            passive: false
        } : false);
        if (!totalLockCount) {
            document.body.classList.add(BODY_LOCK_CLASS);
        }
        totalLockCount++;
    };
    var unlock = function() {
        if (totalLockCount) {
            document.removeEventListener("touchstart", touch.start);
            document.removeEventListener("touchmove", onTouchMove);
            totalLockCount--;
            if (!totalLockCount) {
                document.body.classList.remove(BODY_LOCK_CLASS);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (shouldLock) {
            lock();
            return function() {
                unlock();
            };
        }
    }, [
        shouldLock
    ]);
}

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/merge-locale.js


function mergeLocale(base, patch) {
    return merge_default()(cloneDeep_default()(base), patch);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/locales/base.js
var typeTemplate = "${label} is not a valid ${type}";
var base = {
    locale: "en",
    common: {
        confirm: "Confirm",
        cancel: "Cancel",
        loading: "Loading"
    },
    Calendar: {
        markItems: [
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sun"
        ],
        renderYearAndMonth: function(year, month) {
            return "".concat(year, "/").concat(month);
        }
    },
    Cascader: {
        placeholder: "Selecting"
    },
    Dialog: {
        ok: "OK"
    },
    ErrorBlock: {
        default: {
            title: "Oops, something went wrong",
            description: "Please wait a minute and try again"
        },
        busy: {
            title: "Oops, not loading",
            description: "Try to refresh the page"
        },
        disconnected: {
            title: "Network is busy",
            description: "Try to refresh the page"
        },
        empty: {
            title: "Hmm, couldn't find that...",
            description: "Want to try a new search?"
        }
    },
    Form: {
        required: "Required",
        optional: "Optional",
        defaultValidateMessages: {
            default: "Field validation error for ${label}",
            required: "Please enter ${label}",
            enum: "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: typeTemplate,
                method: typeTemplate,
                array: typeTemplate,
                object: typeTemplate,
                number: typeTemplate,
                date: typeTemplate,
                boolean: typeTemplate,
                integer: typeTemplate,
                float: typeTemplate,
                regexp: typeTemplate,
                email: typeTemplate,
                url: typeTemplate,
                hex: typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    ImageUploader: {
        uploading: "Uploading...",
        upload: "Upload"
    },
    InfiniteScroll: {
        noMore: "No more",
        failedToLoad: "Failed to load",
        retry: "Retry"
    },
    Mask: {
        name: "Mask"
    },
    Modal: {
        ok: "OK"
    },
    PullToRefresh: {
        pulling: "Scroll down to refresh",
        canRelease: "Release to refresh immediately",
        complete: "Refresh successful"
    },
    Slider: {
        name: "Slider"
    },
    Stepper: {
        decrease: "decrease",
        increase: "increase"
    },
    Switch: {
        name: "Switch"
    }
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/locales/zh-CN.js


var zh_CN_typeTemplate = "${label}\u4E0D\u662F\u4E00\u4E2A\u6709\u6548\u7684${type}";
var zhCN = mergeLocale(base, {
    locale: "zh-CH",
    common: {
        confirm: "\u786E\u5B9A",
        cancel: "\u53D6\u6D88",
        loading: "\u52A0\u8F7D\u4E2D"
    },
    Calendar: {
        markItems: [
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D",
            "\u65E5"
        ],
        renderYearAndMonth: function(year, month) {
            return "".concat(year, "\u5E74").concat(month, "\u6708");
        }
    },
    Cascader: {
        placeholder: "\u8BF7\u9009\u62E9"
    },
    Dialog: {
        ok: "\u6211\u77E5\u9053\u4E86"
    },
    ErrorBlock: {
        default: {
            title: "\u9875\u9762\u9047\u5230\u4E00\u4E9B\u5C0F\u95EE\u9898",
            description: "\u5F85\u4F1A\u6765\u8BD5\u8BD5"
        },
        busy: {
            title: "\u524D\u65B9\u62E5\u5835",
            description: "\u5237\u65B0\u8BD5\u8BD5"
        },
        disconnected: {
            title: "\u7F51\u7EDC\u6709\u70B9\u5FD9",
            description: "\u52A8\u52A8\u624B\u6307\u5E2E\u5FD9\u4FEE\u590D"
        },
        empty: {
            title: "\u6CA1\u6709\u627E\u5230\u4F60\u9700\u8981\u7684\u4E1C\u897F",
            description: "\u627E\u627E\u5176\u4ED6\u7684\u5427"
        }
    },
    Form: {
        required: "\u5FC5\u586B",
        optional: "\u9009\u586B",
        defaultValidateMessages: {
            default: "\u5B57\u6BB5\u9A8C\u8BC1\u9519\u8BEF${label}",
            required: "\u8BF7\u8F93\u5165${label}",
            enum: "${label}\u5FC5\u987B\u662F\u5176\u4E2D\u4E00\u4E2A[${enum}]",
            whitespace: "${label}\u4E0D\u80FD\u4E3A\u7A7A\u5B57\u7B26",
            date: {
                format: "${label}\u65E5\u671F\u683C\u5F0F\u65E0\u6548",
                parse: "${label}\u4E0D\u80FD\u8F6C\u6362\u4E3A\u65E5\u671F",
                invalid: "${label}\u662F\u4E00\u4E2A\u65E0\u6548\u65E5\u671F"
            },
            types: {
                string: zh_CN_typeTemplate,
                method: zh_CN_typeTemplate,
                array: zh_CN_typeTemplate,
                object: zh_CN_typeTemplate,
                number: zh_CN_typeTemplate,
                date: zh_CN_typeTemplate,
                boolean: zh_CN_typeTemplate,
                integer: zh_CN_typeTemplate,
                float: zh_CN_typeTemplate,
                regexp: zh_CN_typeTemplate,
                email: zh_CN_typeTemplate,
                url: zh_CN_typeTemplate,
                hex: zh_CN_typeTemplate
            },
            string: {
                len: "${label}\u987B\u4E3A${len}\u4E2A\u5B57\u7B26",
                min: "${label}\u6700\u5C11${min}\u4E2A\u5B57\u7B26",
                max: "${label}\u6700\u591A${max}\u4E2A\u5B57\u7B26",
                range: "${label}\u987B\u5728${min}-${max}\u5B57\u7B26\u4E4B\u95F4"
            },
            number: {
                len: "${label}\u5FC5\u987B\u7B49\u4E8E${len}",
                min: "${label}\u6700\u5C0F\u503C\u4E3A${min}",
                max: "${label}\u6700\u5927\u503C\u4E3A${max}",
                range: "${label}\u987B\u5728${min}-${max}\u4E4B\u95F4"
            },
            array: {
                len: "\u987B\u4E3A${len}\u4E2A${label}",
                min: "\u6700\u5C11${min}\u4E2A${label}",
                max: "\u6700\u591A${max}\u4E2A${label}",
                range: "${label}\u6570\u91CF\u987B\u5728${min}-${max}\u4E4B\u95F4"
            },
            pattern: {
                mismatch: "${label}\u4E0E\u6A21\u5F0F\u4E0D\u5339\u914D${pattern}"
            }
        }
    },
    ImageUploader: {
        uploading: "\u4E0A\u4F20\u4E2D...",
        upload: "\u4E0A\u4F20"
    },
    InfiniteScroll: {
        noMore: "\u6CA1\u6709\u66F4\u591A\u4E86",
        failedToLoad: "\u52A0\u8F7D\u5931\u8D25",
        retry: "\u91CD\u65B0\u52A0\u8F7D"
    },
    Mask: {
        name: "\u906E\u7F69\u5C42"
    },
    Modal: {
        ok: "\u6211\u77E5\u9053\u4E86"
    },
    PullToRefresh: {
        pulling: "\u4E0B\u62C9\u5237\u65B0",
        canRelease: "\u91CA\u653E\u7ACB\u5373\u5237\u65B0",
        complete: "\u5237\u65B0\u6210\u529F"
    },
    Slider: {
        name: "\u6ED1\u52A8\u8F93\u5165\u6761"
    },
    Stepper: {
        decrease: "\u51CF\u5C11",
        increase: "\u589E\u52A0"
    },
    Switch: {
        name: "\u5F00\u5173"
    }
});
/* harmony default export */ var zh_CN = (zhCN);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/config-provider/config-provider.js



var defaultConfigRef = {
    current: {
        locale: zh_CN
    }
};
function setDefaultConfig(config) {
    defaultConfigRef.current = config;
}
function getDefaultConfig() {
    return defaultConfigRef.current;
}
var ConfigContext = /*#__PURE__*/ react.createContext(null);
var ConfigProvider = function(props) {
    var children = props.children, config = __rest(props, [
        "children"
    ]);
    var parentConfig = useConfig();
    return /*#__PURE__*/ React.createElement(ConfigContext.Provider, {
        value: Object.assign(Object.assign({}, parentConfig), config)
    }, children);
};
function useConfig() {
    var _a;
    return (_a = (0,react.useContext)(ConfigContext)) !== null && _a !== void 0 ? _a : getDefaultConfig();
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/with-stop-propagation.js

var eventToPropRecord = {
    "click": "onClick"
};
function withStopPropagation(events, element) {
    var props = Object.assign({}, element.props);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var key = _step.value;
            var prop = eventToPropRecord[key];
            props[prop] = function(e) {
                var _a, _b;
                e.stopPropagation();
                (_b = (_a = element.props)[prop]) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            };
        };
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return /*#__PURE__*/ react.cloneElement(element, props);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/mask/mask.js










var mask_classPrefix = "adm-mask";
var opacityRecord = {
    default: 0.55,
    thin: 0.35,
    thick: 0.75
};
var mask_defaultProps = {
    visible: true,
    destroyOnClose: false,
    forceRender: false,
    color: "black",
    opacity: "default",
    disableBodyScroll: true,
    getContainer: null,
    stopPropagation: [
        "click"
    ]
};
var Mask = function(p) {
    var props = mergeProps(mask_defaultProps, p);
    var locale = useConfig().locale;
    var ref = (0,react.useRef)(null);
    useLockScroll(ref, props.visible && props.disableBodyScroll);
    var background = (0,react.useMemo)(function() {
        var _a;
        var opacity = (_a = opacityRecord[props.opacity]) !== null && _a !== void 0 ? _a : props.opacity;
        var rgb = props.color === "white" ? "255, 255, 255" : "0, 0, 0";
        return "rgba(".concat(rgb, ", ").concat(opacity, ")");
    }, [
        props.color,
        props.opacity
    ]);
    var ref1 = (0,react.useState)(props.visible), active = ref1[0], setActive = ref1[1];
    var unmountedRef = es_useUnmountedRef();
    var opacity1 = useSpring({
        opacity: props.visible ? 1 : 0,
        config: {
            precision: 0.01,
            mass: 1,
            tension: 250,
            friction: 30,
            clamp: true
        },
        onStart: function() {
            setActive(true);
        },
        onRest: function() {
            var _a, _b;
            if (unmountedRef.current) return;
            setActive(props.visible);
            if (props.visible) {
                (_a = props.afterShow) === null || _a === void 0 ? void 0 : _a.call(props);
            } else {
                (_b = props.afterClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        }
    }).opacity;
    var node = withStopPropagation(props.stopPropagation, withNativeProps(props, /*#__PURE__*/ react.createElement(animated.div, {
        className: mask_classPrefix,
        ref: ref,
        style: Object.assign(Object.assign({}, props.style), {
            background: background,
            opacity: opacity1,
            display: active ? undefined : "none"
        }),
        onClick: function(e) {
            var _a;
            if (e.target === e.currentTarget) {
                (_a = props.onMaskClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        }
    }, props.onMaskClick && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(mask_classPrefix, "-aria-button"),
        role: "button",
        "aria-label": locale.Mask.name,
        onClick: props.onMaskClick
    }), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(mask_classPrefix, "-content")
    }, props.children))));
    return /*#__PURE__*/ react.createElement(ShouldRender, {
        active: active,
        forceRender: props.forceRender,
        destroyOnClose: props.destroyOnClose
    }, renderToContainer(props.getContainer, node));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/mask/index.js


/* harmony default export */ var components_mask = (Mask);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-inner-visible.js


function useInnerVisible(outerVisible) {
    var ref = (0,react.useState)(outerVisible), innerVisible = ref[0], setInnerVisible = ref[1];
    es_useIsomorphicLayoutEffect(function() {
        setInnerVisible(outerVisible);
    }, [
        outerVisible
    ]);
    return innerVisible;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/CloseOutline.js

function CloseOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "CloseOutline-CloseOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "CloseOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "CloseOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M10.6085104,8.11754663 L24.1768397,21.8195031 L24.1768397,21.8195031 L37.7443031,8.1175556 C37.8194278,8.04168616 37.9217669,7.999 38.0285372,7.999 L41.1040268,7.999 C41.3249407,7.999 41.5040268,8.1780861 41.5040268,8.399 C41.5040268,8.50440471 41.4624226,8.60554929 41.3882578,8.68044752 L26.2773302,23.9408235 L26.2773302,23.9408235 L41.5021975,39.3175645 C41.65763,39.4745475 41.6563731,39.7278104 41.4993901,39.8832429 C41.4244929,39.9574004 41.3233534,39.999 41.2179546,39.999 L38.1434012,39.999 C38.0366291,39.999 37.9342885,39.9563124 37.8591634,39.8804408 L24.1768397,26.0621438 L24.1768397,26.0621438 L10.4936501,39.8804497 C10.4185257,39.9563159 10.3161889,39.999 10.2094212,39.999 L7.13584526,39.999 C6.91493136,39.999 6.73584526,39.8199139 6.73584526,39.599 C6.73584526,39.4936017 6.77744443,39.3924627 6.85160121,39.3175656 L22.0763492,23.9408235 L22.0763492,23.9408235 L6.96554081,8.68044639 C6.81010226,8.52346929 6.81134951,8.27020637 6.9683266,8.11476782 C7.04322474,8.04060377 7.14436883,7.999 7.24977299,7.999 L10.3242852,7.999 C10.4310511,7.999 10.5333863,8.04168267 10.6085104,8.11754663 Z",
        id: "CloseOutline-\u8DEF\u5F84",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_CloseOutline = (CloseOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popup/popup-base-props.js
var defaultPopupBaseProps = {
    closeOnMaskClick: false,
    destroyOnClose: false,
    disableBodyScroll: true,
    forceRender: false,
    getContainer: function() {
        return document.body;
    },
    mask: true,
    showCloseButton: false,
    stopPropagation: [
        "click"
    ],
    visible: false
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/center-popup/center-popup.js














var center_popup_defaultProps = Object.assign(Object.assign({}, defaultPopupBaseProps), {
    getContainer: null
});
var CenterPopup = function(p) {
    var props = mergeProps(center_popup_defaultProps, p);
    var unmountedRef = es_useUnmountedRef();
    var style = useSpring({
        scale: props.visible ? 1 : 0.8,
        opacity: props.visible ? 1 : 0,
        config: {
            mass: 1.2,
            tension: 200,
            friction: 25,
            clamp: true
        },
        onRest: function() {
            var _a, _b;
            if (unmountedRef.current) return;
            setActive(props.visible);
            if (props.visible) {
                (_a = props.afterShow) === null || _a === void 0 ? void 0 : _a.call(props);
            } else {
                (_b = props.afterClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        }
    });
    var ref = (0,react.useState)(props.visible), active = ref[0], setActive = ref[1];
    es_useIsomorphicLayoutEffect(function() {
        if (props.visible) {
            setActive(true);
        }
    }, [
        props.visible
    ]);
    var ref1 = (0,react.useRef)(null);
    useLockScroll(ref1, props.disableBodyScroll && active);
    var maskVisible = useInnerVisible(active && props.visible);
    var body = /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("adm-center-popup-body", props.bodyClassName),
        style: props.bodyStyle
    }, props.children);
    var node = withStopPropagation(props.stopPropagation, withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: "adm-center-popup",
        style: {
            display: active ? undefined : "none",
            pointerEvents: active ? undefined : "none"
        }
    }, props.mask && /*#__PURE__*/ react.createElement(components_mask, {
        visible: maskVisible,
        forceRender: props.forceRender,
        destroyOnClose: props.destroyOnClose,
        onMaskClick: function(e) {
            var _a, _b;
            (_a = props.onMaskClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            if (props.closeOnMaskClick) {
                (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        },
        style: props.maskStyle,
        className: classnames_default()("adm-center-popup-mask", props.maskClassName),
        disableBodyScroll: false,
        stopPropagation: props.stopPropagation
    }), /*#__PURE__*/ react.createElement("div", {
        className: "adm-center-popup-wrap",
        role: props.role,
        "aria-label": props["aria-label"]
    }, /*#__PURE__*/ react.createElement(animated.div, {
        style: style,
        ref: ref1
    }, props.showCloseButton && /*#__PURE__*/ react.createElement("a", {
        className: classnames_default()("adm-center-popup-close", "adm-plain-anchor"),
        onClick: function() {
            var _a;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    }, /*#__PURE__*/ react.createElement(es_CloseOutline, null)), body)))));
    return /*#__PURE__*/ react.createElement(ShouldRender, {
        active: active,
        forceRender: props.forceRender,
        destroyOnClose: props.destroyOnClose
    }, renderToContainer(props.getContainer, node));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/center-popup/index.js


/* harmony default export */ var components_center_popup = (CenterPopup);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/dialog.js









var dialog_defaultProps = {
    actions: [],
    closeOnAction: false,
    closeOnMaskClick: false,
    getContainer: null
};
var Dialog = function(p) {
    var props = mergeProps(dialog_defaultProps, p);
    var element = /*#__PURE__*/ react.createElement(react.Fragment, null, !!props.image && /*#__PURE__*/ react.createElement("div", {
        className: cls("image-container")
    }, /*#__PURE__*/ react.createElement(components_image, {
        src: props.image,
        alt: "dialog header image",
        width: "100%"
    })), !!props.header && /*#__PURE__*/ react.createElement("div", {
        className: cls("header")
    }, /*#__PURE__*/ react.createElement(components_auto_center, null, props.header)), !!props.title && /*#__PURE__*/ react.createElement("div", {
        className: cls("title")
    }, props.title), /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(cls("content"), !props.content && cls("content-empty"))
    }, typeof props.content === "string" ? /*#__PURE__*/ react.createElement(components_auto_center, null, props.content) : props.content), /*#__PURE__*/ react.createElement("div", {
        className: cls("footer")
    }, props.actions.map(function(row, index1) {
        var actions = Array.isArray(row) ? row : [
            row
        ];
        return /*#__PURE__*/ react.createElement("div", {
            className: cls("action-row"),
            key: index1
        }, actions.map(function(action, index) {
            return /*#__PURE__*/ react.createElement(DialogActionButton, {
                key: action.key,
                action: action,
                onAction: function() {
                    return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
                        var _a, _b, _c;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    ;
                                    _ctx.next = 3;
                                    return Promise.all([
                                        (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action),
                                        (_b = props.onAction) === null || _b === void 0 ? void 0 : _b.call(props, action, index)
                                    ]);
                                case 3:
                                    if (props.closeOnAction) {
                                        (_c = props.onClose) === null || _c === void 0 ? void 0 : _c.call(props);
                                    }
                                case 4:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                }
            });
        }));
    })));
    return /*#__PURE__*/ react.createElement(components_center_popup, {
        className: classnames_default()(cls(), props.className),
        style: props.style,
        afterClose: props.afterClose,
        afterShow: props.afterShow,
        onMaskClick: props.closeOnMaskClick ? function() {
            var _a;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        } : undefined,
        visible: props.visible,
        getContainer: props.getContainer,
        bodyStyle: props.bodyStyle,
        bodyClassName: classnames_default()(cls("body"), props.image && cls("with-image"), props.bodyClassName),
        maskStyle: props.maskStyle,
        maskClassName: props.maskClassName,
        stopPropagation: props.stopPropagation,
        disableBodyScroll: props.disableBodyScroll,
        destroyOnClose: props.destroyOnClose,
        forceRender: props.forceRender,
        role: "dialog",
        "aria-label": props["aria-label"]
    }, element);
};
function cls() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "adm-dialog" + (name && "-") + name;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/render.js


 // Let compiler not to search module usage
var fullClone = Object.assign({}, react_dom_namespaceObject);
var version = fullClone.version, reactRender = fullClone.render, unmountComponentAtNode = fullClone.unmountComponentAtNode;
var createRoot;
try {
    var mainVersion = Number((version || "").split(".")[0]);
    if (mainVersion >= 18 && fullClone.createRoot) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        createRoot = fullClone.createRoot;
    }
} catch (e) {}
function toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && typeof __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === "object") {
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
    }
}
var MARK = "__antd_mobile_root__";
function legacyRender(node, container) {
    reactRender(node, container);
}
function concurrentRender(node, container) {
    toggleWarning(true);
    var root = container[MARK] || createRoot(container);
    toggleWarning(false);
    root.render(node);
    container[MARK] = root;
}
function render(node, container) {
    if (createRoot) {
        concurrentRender(node, container);
        return;
    }
    legacyRender(node, container);
} // ========================== Unmount =========================
function legacyUnmount(container) {
    return unmountComponentAtNode(container);
}
function concurrentUnmount(container) {
    return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", Promise.resolve().then(function() {
                        var _a;
                        (_a = container[MARK]) === null || _a === void 0 ? void 0 : _a.unmount();
                        delete container[MARK];
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
}
function render_unmount(container) {
    if (createRoot) {
        return concurrentUnmount(container);
    }
    return legacyUnmount(container);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/render-to-body.js

function renderToBody(element) {
    var unmount = function unmount() {
        var unmountResult = render_unmount(container);
        if (unmountResult && container.parentNode) {
            container.parentNode.removeChild(container);
        }
    };
    var container = document.createElement("div");
    document.body.appendChild(container);
    render(element, container);
    return unmount;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/render-imperatively.js


function renderImperatively(element1) {
    var Wrapper = /*#__PURE__*/ react.forwardRef(function(_, ref) {
        var onClose = function onClose() {
            var _a, _b;
            closedRef.current = true;
            setVisible(false);
            (_b = (_a = elementToRender.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        var afterClose = function afterClose() {
            var _a, _b;
            unmount();
            (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        var _$ref = (0,react.useState)(false), visible = _$ref[0], setVisible = _$ref[1];
        var closedRef = (0,react.useRef)(false);
        var _$ref1 = (0,react.useState)(element1), elementToRender = _$ref1[0], setElementToRender = _$ref1[1];
        var keyRef = (0,react.useRef)(0);
        (0,react.useEffect)(function() {
            if (!closedRef.current) {
                setVisible(true);
            } else {
                afterClose();
            }
        }, []);
        (0,react.useImperativeHandle)(ref, function() {
            return {
                close: onClose,
                replace: function(element) {
                    var _a, _b;
                    keyRef.current++;
                    (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
                    setElementToRender(element);
                }
            };
        });
        return /*#__PURE__*/ react.cloneElement(elementToRender, Object.assign(Object.assign({}, elementToRender.props), {
            key: keyRef.current,
            visible: visible,
            onClose: onClose,
            afterClose: afterClose
        }));
    });
    var wrapperRef = /*#__PURE__*/ react.createRef();
    var unmount = renderToBody(/*#__PURE__*/ react.createElement(Wrapper, {
        ref: wrapperRef
    }));
    return {
        close: function() {
            var _a;
            (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.close();
        },
        replace: function(element) {
            var _a;
            (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.replace(element);
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/show.js



var closeFnSet = new Set();
function show(props) {
    var handler = renderImperatively(/*#__PURE__*/ react.createElement(Dialog, Object.assign({}, props, {
        afterClose: function() {
            var _a;
            closeFnSet.delete(handler.close);
            (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    })));
    closeFnSet.add(handler.close);
    return handler;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/alert.js



function alert_alert(p) {
    var defaultProps = {
        confirmText: getDefaultConfig().locale.Dialog.ok
    };
    var props = mergeProps(defaultProps, p);
    return new Promise(function(resolve) {
        show(Object.assign(Object.assign({}, props), {
            closeOnAction: true,
            actions: [
                {
                    key: "confirm",
                    text: props.confirmText
                }
            ],
            onAction: props.onConfirm,
            onClose: function() {
                var _a;
                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                resolve();
            }
        }));
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/confirm.js





var confirm_defaultProps = {
    confirmText: "\u786E\u8BA4",
    cancelText: "\u53D6\u6D88"
};
function confirm_confirm(p) {
    var _this = this;
    var locale = getDefaultConfig().locale;
    var props = mergeProps(confirm_defaultProps, {
        confirmText: locale.common.confirm,
        cancelText: locale.common.cancel
    }, p);
    return new Promise(function(resolve) {
        var _this1 = _this;
        show(Object.assign(Object.assign({}, props), {
            closeOnAction: true,
            onClose: function() {
                var _a;
                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                resolve(false);
            },
            actions: [
                [
                    {
                        key: "cancel",
                        text: props.cancelText,
                        onClick: function() {
                            return __awaiter(_this1, void 0, void 0, runtime_default().mark(function _callee() {
                                var _a;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            _ctx.next = 3;
                                            return (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
                                        case 3:
                                            resolve(false);
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                        }
                    },
                    {
                        key: "confirm",
                        text: props.confirmText,
                        bold: true,
                        onClick: function() {
                            return __awaiter(_this1, void 0, void 0, runtime_default().mark(function _callee() {
                                var _b;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            _ctx.next = 3;
                                            return (_b = props.onConfirm) === null || _b === void 0 ? void 0 : _b.call(props);
                                        case 3:
                                            resolve(true);
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                        }
                    }
                ]
            ]
        }));
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/clear.js

function clear() {
    closeFnSet.forEach(function(close) {
        close();
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/dialog/index.js







/* harmony default export */ var components_dialog = (attachPropertiesToComponent(Dialog, {
    show: show,
    alert: alert_alert,
    confirm: confirm_confirm,
    clear: clear
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/divider/divider.css
var divider = __webpack_require__(57089);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/divider/divider.js




var divider_classPrefix = "adm-divider";
var divider_defaultProps = {
    contentPosition: "center",
    direction: "horizontal"
};
var Divider = function(p) {
    var props = mergeProps(divider_defaultProps, p);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(divider_classPrefix, "".concat(divider_classPrefix, "-").concat(props.direction), "".concat(divider_classPrefix, "-").concat(props.contentPosition))
    }, props.children && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(divider_classPrefix, "-content")
    }, props.children)));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/divider/index.js


/* harmony default export */ var components_divider = (Divider);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/ellipsis/ellipsis.css
var ellipsis = __webpack_require__(16433);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-resize-effect.js

function useResizeEffect(effect, targetRef) {
    var fn = es_useMemoizedFn(effect);
    es_useIsomorphicLayoutEffect(function() {
        var target = targetRef.current;
        if (!target) return;
        if (window.ResizeObserver) {
            var observer = new ResizeObserver(function() {
                fn(target);
            });
            observer.observe(target);
            return function() {
                observer.disconnect();
            };
        } else {
            fn(target);
        }
    }, [
        targetRef
    ]);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/ellipsis/ellipsis.js






var ellipsis_classPrefix = "adm-ellipsis";
var ellipsis_defaultProps = {
    direction: "end",
    rows: 1,
    expandText: "",
    collapseText: "",
    stopPropagationForActionButtons: [],
    onContentClick: function() {}
};
var Ellipsis = function(p) {
    var calcEllipsised = function calcEllipsised() {
        var root = rootRef.current;
        if (!root) return;
        var originStyle = window.getComputedStyle(root);
        var container = document.createElement("div");
        var styleNames = Array.prototype.slice.apply(originStyle);
        styleNames.forEach(function(name) {
            container.style.setProperty(name, originStyle.getPropertyValue(name));
        });
        container.style.position = "fixed";
        container.style.left = "999999px";
        container.style.top = "999999px";
        container.style.zIndex = "-1000";
        container.style.height = "auto";
        container.style.minHeight = "auto";
        container.style.maxHeight = "auto";
        container.style.textOverflow = "clip";
        container.style.whiteSpace = "normal";
        container.style.webkitLineClamp = "unset";
        container.style.display = "block";
        var lineHeight = pxToNumber(originStyle.lineHeight);
        var maxHeight = Math.floor(lineHeight * (props.rows + 0.5) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom));
        container.innerText = props.content;
        document.body.appendChild(container);
        if (container.offsetHeight <= maxHeight) {
            setExceeded(false);
        } else {
            setExceeded(true);
            var end = props.content.length;
            var actionText = expanded ? props.collapseText : props.expandText;
            function check(left, right) {
                if (right - left <= 1) {
                    if (props.direction === "end") {
                        return {
                            leading: props.content.slice(0, left) + "..."
                        };
                    } else {
                        return {
                            tailing: "..." + props.content.slice(right, end)
                        };
                    }
                }
                var middle = Math.round((left + right) / 2);
                if (props.direction === "end") {
                    container.innerText = props.content.slice(0, middle) + "..." + actionText;
                } else {
                    container.innerText = actionText + "..." + props.content.slice(middle, end);
                }
                if (container.offsetHeight <= maxHeight) {
                    if (props.direction === "end") {
                        return check(middle, right);
                    } else {
                        return check(left, middle);
                    }
                } else {
                    if (props.direction === "end") {
                        return check(left, middle);
                    } else {
                        return check(middle, right);
                    }
                }
            }
            function checkMiddle(leftPart, rightPart) {
                if (leftPart[1] - leftPart[0] <= 1 && rightPart[1] - rightPart[0] <= 1) {
                    return {
                        leading: props.content.slice(0, leftPart[0]) + "...",
                        tailing: "..." + props.content.slice(rightPart[1], end)
                    };
                }
                var leftPartMiddle = Math.floor((leftPart[0] + leftPart[1]) / 2);
                var rightPartMiddle = Math.ceil((rightPart[0] + rightPart[1]) / 2);
                container.innerText = props.content.slice(0, leftPartMiddle) + "..." + actionText + "..." + props.content.slice(rightPartMiddle, end);
                if (container.offsetHeight <= maxHeight) {
                    return checkMiddle([
                        leftPartMiddle,
                        leftPart[1]
                    ], [
                        rightPart[0],
                        rightPartMiddle
                    ]);
                } else {
                    return checkMiddle([
                        leftPart[0],
                        leftPartMiddle
                    ], [
                        rightPartMiddle,
                        rightPart[1]
                    ]);
                }
            }
            var middle1 = Math.floor((0 + end) / 2);
            var ellipsised = props.direction === "middle" ? checkMiddle([
                0,
                middle1
            ], [
                middle1,
                end
            ]) : check(0, end);
            setEllipsised(ellipsised);
        }
        document.body.removeChild(container);
    };
    var props = mergeProps(ellipsis_defaultProps, p);
    var rootRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({}), ellipsised1 = ref[0], setEllipsised = ref[1];
    var ref1 = (0,react.useState)(false), expanded = ref1[0], setExpanded = ref1[1];
    var ref2 = (0,react.useState)(false), exceeded = ref2[0], setExceeded = ref2[1];
    useResizeEffect(calcEllipsised, rootRef);
    es_useIsomorphicLayoutEffect(function() {
        calcEllipsised();
    }, [
        props.content,
        props.direction,
        props.rows,
        props.expandText,
        props.collapseText
    ]);
    var expandActionElement = exceeded && props.expandText ? withStopPropagation(props.stopPropagationForActionButtons, /*#__PURE__*/ react.createElement("a", {
        onClick: function() {
            setExpanded(true);
        }
    }, props.expandText)) : null;
    var collapseActionElement = exceeded && props.expandText ? withStopPropagation(props.stopPropagationForActionButtons, /*#__PURE__*/ react.createElement("a", {
        onClick: function() {
            setExpanded(false);
        }
    }, props.collapseText)) : null;
    var renderContent = function() {
        if (!exceeded) {
            return props.content;
        }
        if (expanded) {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, props.content, collapseActionElement);
        } else {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, ellipsised1.leading, expandActionElement, ellipsised1.tailing);
        }
    };
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        ref: rootRef,
        className: ellipsis_classPrefix,
        onClick: function(e) {
            if (e.target === e.currentTarget) {
                props.onContentClick(e);
            }
        }
    }, renderContent()));
};
function pxToNumber(value) {
    if (!value) return 0;
    var match = value.match(/^\d*(\.\d*)?/);
    return match ? Number(match[0]) : 0;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/ellipsis/index.js


/* harmony default export */ var components_ellipsis = (Ellipsis);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/form/index.css
var components_form = __webpack_require__(70689);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,objectWithoutPropertiesLoose/* default */.Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function arrayWithoutHoles_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function nonIterableSpread_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return arrayWithoutHoles_arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || nonIterableSpread_nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0,getPrototypeOf/* default */.Z)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0,possibleConstructorReturn/* default */.Z)(this, result);
  };
}
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var node_modules_react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/Children/toArray.js


function toArray_toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  react.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray_toArray(child));
    } else if ((0,node_modules_react_is.isFragment)(child) && child.props) {
      ret = ret.concat(toArray_toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/rc-util/es/warning.js
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {}
}
function note(valid, message) {
  // Support uglify
  if (false) {}
}
function resetWarned() {
  warned = {};
}
function warning_call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  warning_call(warning, valid, message);
}
function noteOnce(valid, message) {
  warning_call(note, valid, message);
}
/* harmony default export */ var es_warning = (warningOnce);
/* eslint-enable */
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/FieldContext.js


var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var warningFunc = function warningFunc() {
  es_warning(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};

var Context = /*#__PURE__*/react.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
/* harmony default export */ var FieldContext = (Context);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/typeUtil.js
function typeUtil_toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == (0,esm_typeof/* default */.Z)(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
;// CONCATENATED MODULE: ./node_modules/async-validator/dist-web/index.js
/* provided dependency */ var process = __webpack_require__(83454);
function dist_web_extends() {
  dist_web_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return dist_web_extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function dist_web_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (dist_web_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/* eslint no-console:0 */
var formatRegExp = /%[sdj%]/g;
var dist_web_warning = function warning() {}; // don't print warning message when in production env or node runtime

if (typeof process !== 'undefined' && process.env && "production" !== 'production' && 0 && 0) {}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var i = 0;
  var len = args.length;

  if (typeof template === 'function') {
    return template.apply(null, args);
  }

  if (typeof template === 'string') {
    var str = template.replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }

      if (i >= len) {
        return x;
      }

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

          break;

        default:
          return x;
      }
    });
    return str;
  }

  return template;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }

  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }

  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }

  return false;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors || []);
    total++;

    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }

    var original = index;
    index = index + 1;

    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k] || []);
  });
  return ret;
}

var AsyncValidationError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(AsyncValidationError, _Error);

  function AsyncValidationError(errors, fields) {
    var _this;

    _this = _Error.call(this, 'Async Validation Error') || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }

  return AsyncValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function (resolve, reject) {
      var next = function next(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };

      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });

    _pending["catch"](function (e) {
      return e;
    });

    return _pending;
  }

  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;

      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };

    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }

    objArrKeys.forEach(function (key) {
      var arr = objArr[key];

      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function (e) {
    return e;
  });
  return pending;
}

function isErrorObj(obj) {
  return !!(obj && obj.message !== undefined);
}

function getValue(value, path) {
  var v = value;

  for (var i = 0; i < path.length; i++) {
    if (v == undefined) {
      return v;
    }

    v = v[path[i]];
  }

  return v;
}

function complementError(rule, source) {
  return function (oe) {
    var fieldValue;

    if (rule.fullFields) {
      fieldValue = getValue(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }

    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }

    return {
      message: typeof oe === 'function' ? oe() : oe,
      fieldValue: fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];

        if (typeof value === 'object' && typeof target[s] === 'object') {
          target[s] = dist_web_extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }

  return target;
}

var required$1 = function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

var whitespace = function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};

// https://github.com/kevva/url-regex/blob/master/index.js
var urlReg;
var getUrlRegex = (function () {
  if (urlReg) {
    return urlReg;
  }

  var word = '[a-fA-F\\d:]';

  var b = function b(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : '';
  };

  var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
  var v6seg = '[a-fA-F\\d]{1,4}';
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful

  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");

  var ip = function ip(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", 'g');
  };

  ip.v4 = function (options) {
    return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), 'g');
  };

  ip.v6 = function (options) {
    return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), 'g');
  };

  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = '(?:\\S+(?::\\S*)?@)?';
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex + "$)", 'i');
  return urlReg;
});

/* eslint max-len:0 */

var pattern$2 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }

    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }

    return typeof value === 'number';
  },
  object: function object(value) {
    return typeof value === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === 'string' && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern$2.hex);
  }
};

var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    required$1(rule, value, source, errors, options);
    return;
  }

  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;

  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    } // straight typeof check

  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};

var range = function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）

  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);

  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  } // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type


  if (!key) {
    return false;
  }

  if (arr) {
    val = value.length;
  }

  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }

  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};

var ENUM$1 = 'enum';

var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];

  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(', ')));
  }
};

var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;

      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);

      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};

var rules = {
  required: required$1,
  whitespace: whitespace,
  type: type$1,
  range: range,
  "enum": enumerable$1,
  pattern: pattern$1
};

var string = function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'string');

    if (!isEmptyValue(value, 'string')) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);

      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }

  callback(errors);
};

var method = function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var number = function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (value === '') {
      value = undefined;
    }

    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var _boolean = function _boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var regexp = function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var integer = function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var floatFn = function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var array = function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if ((value === undefined || value === null) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'array');

    if (value !== undefined && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var object = function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var ENUM = 'enum';

var enumerable = function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var pattern = function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'string')) {
      rules.pattern(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var date = function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);

  if (validate) {
    if (isEmptyValue(value, 'date') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'date')) {
      var dateObject;

      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }

      rules.type(rule, dateObject, source, errors, options);

      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }

  callback(errors);
};

var required = function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value;
  rules.required(rule, value, source, errors, options, type);
  callback(errors);
};

var type = function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, ruleType);

    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var any = function any(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);
  }

  callback(errors);
};

var validators = {
  string: string,
  method: method,
  number: number,
  "boolean": _boolean,
  regexp: regexp,
  integer: integer,
  "float": floatFn,
  array: array,
  object: object,
  "enum": enumerable,
  pattern: pattern,
  date: date,
  url: type,
  hex: type,
  email: type,
  required: required,
  any: any
};

function newMessages() {
  return {
    "default": 'Validation error on field %s',
    required: '%s is required',
    "enum": '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      "boolean": '%s is not a %s',
      integer: '%s is not an %s',
      "float": '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */

var Schema = /*#__PURE__*/function () {
  // ========================= Static =========================
  // ======================== Instance ========================
  function Schema(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }

  var _proto = Schema.prototype;

  _proto.define = function define(rules) {
    var _this = this;

    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }

    if (typeof rules !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }

    this.rules = {};
    Object.keys(rules).forEach(function (name) {
      var item = rules[name];
      _this.rules[name] = Array.isArray(item) ? item : [item];
    });
  };

  _proto.messages = function messages(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }

    return this._messages;
  };

  _proto.validate = function validate(source_, o, oc) {
    var _this2 = this;

    if (o === void 0) {
      o = {};
    }

    if (oc === void 0) {
      oc = function oc() {};
    }

    var source = source_;
    var options = o;
    var callback = oc;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }

      return Promise.resolve(source);
    }

    function complete(results) {
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (var i = 0; i < results.length; i++) {
        add(results[i]);
      }

      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }

    if (options.messages) {
      var messages$1 = this.messages();

      if (messages$1 === messages) {
        messages$1 = newMessages();
      }

      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }

    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      var arr = _this2.rules[z];
      var value = source[z];
      arr.forEach(function (r) {
        var rule = r;

        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = dist_web_extends({}, source);
          }

          value = source[z] = rule.transform(value);
        }

        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = dist_web_extends({}, rule);
        } // Fill validator. Skip if nothing need to validate


        rule.validator = _this2.getValidationMethod(rule);

        if (!rule.validator) {
          return;
        }

        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this2.getType(rule);
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullField(key, schema) {
        return dist_web_extends({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }

      function cb(e) {
        if (e === void 0) {
          e = [];
        }

        var errorList = Array.isArray(e) ? e : [e];

        if (!options.suppressWarning && errorList.length) {
          Schema.warning('async-validator:', errorList);
        }

        if (errorList.length && rule.message !== undefined) {
          errorList = [].concat(rule.message);
        } // Fill error info


        var filledErrors = errorList.map(complementError(rule, source));

        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }

        if (!deep) {
          doIt(filledErrors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message !== undefined) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
            }

            return doIt(filledErrors);
          }

          var fieldsSchema = {};

          if (rule.defaultField) {
            Object.keys(data.value).map(function (key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }

          fieldsSchema = dist_web_extends({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function (field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema(paredFieldsSchema);
          schema.messages(options.messages);

          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }

          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];

            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }

            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }

            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res;

      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error); // rethrow to report error

          if (!options.suppressValidatorError) {
            setTimeout(function () {
              throw error;
            }, 0);
          }

          cb(error.message);
        }

        if (res === true) {
          cb();
        } else if (res === false) {
          cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }

      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    }, source);
  };

  _proto.getType = function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }

    if (typeof rule.validator !== 'function' && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format('Unknown rule type %s', rule.type));
    }

    return rule.type || 'string';
  };

  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }

    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');

    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }

    if (keys.length === 1 && keys[0] === 'required') {
      return validators.required;
    }

    return validators[this.getType(rule)] || undefined;
  };

  return Schema;
}();

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }

  validators[type] = validator;
};

Schema.warning = dist_web_warning;
Schema.messages = messages;
Schema.validators = validators;


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/messages.js
var messages_typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: messages_typeTemplate,
    method: messages_typeTemplate,
    array: messages_typeTemplate,
    object: messages_typeTemplate,
    number: messages_typeTemplate,
    date: messages_typeTemplate,
    boolean: messages_typeTemplate,
    integer: messages_typeTemplate,
    float: messages_typeTemplate,
    regexp: messages_typeTemplate,
    email: messages_typeTemplate,
    url: messages_typeTemplate,
    hex: messages_typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
;// CONCATENATED MODULE: ./node_modules/rc-util/es/utils/get.js
function get(entity, path) {
  var current = entity;

  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }

    current = current[path[i]];
  }

  return current;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js
var esm_toArray = __webpack_require__(84506);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/utils/set.js





function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }

  var _paths = (0,esm_toArray/* default */.Z)(paths),
      path = _paths[0],
      restPath = _paths.slice(1);

  var clone;

  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = toConsumableArray_toConsumableArray(entity);
  } else {
    clone = (0,objectSpread2/* default */.Z)({}, entity);
  } // Delete prop if `removeIfUndefined` and value is undefined


  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }

  return clone;
}

function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !get(entity, paths.slice(0, -1))) {
    return entity;
  }

  return internalSet(entity, paths, value, removeIfUndefined);
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/cloneDeep.js


function cloneDeep_cloneDeep(val) {
  if (Array.isArray(val)) {
    return cloneArrayDeep(val);
  } else if ((0,esm_typeof/* default */.Z)(val) === 'object' && val !== null) {
    return cloneObjectDeep(val);
  }

  return val;
}

function cloneObjectDeep(val) {
  if (Object.getPrototypeOf(val) === Object.prototype) {
    var res = {};

    for (var key in val) {
      res[key] = cloneDeep_cloneDeep(val[key]);
    }

    return res;
  }

  return val;
}

function cloneArrayDeep(val) {
  return val.map(function (item) {
    return cloneDeep_cloneDeep(item);
  });
}

/* harmony default export */ var utils_cloneDeep = (cloneDeep_cloneDeep);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/valueUtil.js







/**
 * Convert name to internal supported format.
 * This function should keep since we still thinking if need support like `a.b.c` format.
 * 'a' => ['a']
 * 123 => [123]
 * ['a', 123] => ['a', 123]
 */

function getNamePath(path) {
  return typeUtil_toArray(path);
}
function valueUtil_getValue(store, namePath) {
  var value = get(store, namePath);
  return value;
}
function setValue(store, namePath, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var newStore = set(store, namePath, value, removeIfUndefined);
  return newStore;
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function (namePath) {
    var value = valueUtil_getValue(store, namePath);
    newStore = setValue(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  return namePathList && namePathList.some(function (path) {
    return matchNamePath(path, namePath);
  });
}

function valueUtil_isObject(obj) {
  return (0,esm_typeof/* default */.Z)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
/**
 * Copy values into store and return a new values object
 * ({ a: 1, b: { c: 2 } }, { a: 4, b: { d: 5 } }) => { a: 4, b: { c: 2, d: 5 } }
 */


function internalSetValues(store, values) {
  var newStore = Array.isArray(store) ? toConsumableArray_toConsumableArray(store) : (0,objectSpread2/* default */.Z)({}, store);

  if (!values) {
    return newStore;
  }

  Object.keys(values).forEach(function (key) {
    var prevValue = newStore[key];
    var value = values[key]; // If both are object (but target is not array), we use recursion to set deep value

    var recursive = valueUtil_isObject(prevValue) && valueUtil_isObject(value);
    newStore[key] = recursive ? internalSetValues(prevValue, value || {}) : utils_cloneDeep(value); // Clone deep for arrays
  });
  return newStore;
}

function setValues(store) {
  for (var _len = arguments.length, restValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restValues[_key - 1] = arguments[_key];
  }

  return restValues.reduce(function (current, newStore) {
    return internalSetValues(current, newStore);
  }, store);
}
function matchNamePath(namePath, changedNamePath) {
  if (!namePath || !changedNamePath || namePath.length !== changedNamePath.length) {
    return false;
  }

  return namePath.every(function (nameUnit, i) {
    return changedNamePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }

  if (!source && target || source && !target) {
    return false;
  }

  if (!source || !target || (0,esm_typeof/* default */.Z)(source) !== 'object' || (0,esm_typeof/* default */.Z)(target) !== 'object') {
    return false;
  }

  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys = new Set([].concat(toConsumableArray_toConsumableArray(sourceKeys), toConsumableArray_toConsumableArray(targetKeys)));
  return toConsumableArray_toConsumableArray(keys).every(function (key) {
    var sourceValue = source[key];
    var targetValue = target[key];

    if (typeof sourceValue === 'function' && typeof targetValue === 'function') {
      return true;
    }

    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? undefined : arguments[1];

  if (event && event.target && (0,esm_typeof/* default */.Z)(event.target) === 'object' && valuePropName in event.target) {
    return event.target[valuePropName];
  }

  return event;
}
/**
 * Moves an array item from one position in an array to another.
 *
 * Note: This is a pure function so a new array will be returned, instead
 * of altering the array argument.
 *
 * @param array         Array in which to move an item.         (required)
 * @param moveIndex     The index of the item to move.          (required)
 * @param toIndex       The index to move item at moveIndex to. (required)
 */

function valueUtil_move(array, moveIndex, toIndex) {
  var length = array.length;

  if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) {
    return array;
  }

  var item = array[moveIndex];
  var diff = moveIndex - toIndex;

  if (diff > 0) {
    // move left
    return [].concat(toConsumableArray_toConsumableArray(array.slice(0, toIndex)), [item], toConsumableArray_toConsumableArray(array.slice(toIndex, moveIndex)), toConsumableArray_toConsumableArray(array.slice(moveIndex + 1, length)));
  }

  if (diff < 0) {
    // move right
    return [].concat(toConsumableArray_toConsumableArray(array.slice(0, moveIndex)), toConsumableArray_toConsumableArray(array.slice(moveIndex + 1, toIndex + 1)), [item], toConsumableArray_toConsumableArray(array.slice(toIndex + 1, length)));
  }

  return array;
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/validateUtil.js









 // Remove incorrect original ts define

var AsyncValidator = Schema;
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */

function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function (str) {
    var key = str.slice(2, -1);
    return kv[key];
  });
}

var CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';

function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */


function _validateRule() {
  _validateRule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cloneRule = (0,objectSpread2/* default */.Z)({}, rule); // Bug of `async-validator`
            // https://github.com/react-component/field-form/issues/316
            // https://github.com/react-component/field-form/issues/313

            delete cloneRule.ruleIndex;

            if (cloneRule.validator) {
              originValidator = cloneRule.validator;

              cloneRule.validator = function () {
                try {
                  return originValidator.apply(void 0, arguments);
                } catch (error) {
                  console.error(error);
                  return Promise.reject(CODE_LOGIC_ERROR);
                }
              };
            } // We should special handle array validate


            subRuleField = null;

            if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }

            validator = new AsyncValidator((0,defineProperty/* default */.Z)({}, name, [cloneRule]));
            messages = setValues({}, defaultValidateMessages, options.validateMessages);
            validator.messages(messages);
            result = [];
            _context2.prev = 9;
            _context2.next = 12;
            return Promise.resolve(validator.validate((0,defineProperty/* default */.Z)({}, name, value), (0,objectSpread2/* default */.Z)({}, options)));

          case 12:
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](9);

            if (_context2.t0.errors) {
              result = _context2.t0.errors.map(function (_ref4, index) {
                var message = _ref4.message;
                var mergedMessage = message === CODE_LOGIC_ERROR ? messages.default : message;
                return /*#__PURE__*/react.isValidElement(mergedMessage) ?
                /*#__PURE__*/
                // Wrap ReactNode with `key`
                react.cloneElement(mergedMessage, {
                  key: "error_".concat(index)
                }) : mergedMessage;
              });
            }

          case 17:
            if (!(!result.length && subRuleField)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 20;
            return Promise.all(value.map(function (subValue, i) {
              return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
            }));

          case 20:
            subResults = _context2.sent;
            return _context2.abrupt("return", subResults.reduce(function (prev, errors) {
              return [].concat(toConsumableArray_toConsumableArray(prev), toConsumableArray_toConsumableArray(errors));
            }, []));

          case 22:
            // Replace message with variables
            kv = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rule), {}, {
              name: name,
              enum: (rule.enum || []).join(', ')
            }, messageVariables);
            fillVariableResult = result.map(function (error) {
              if (typeof error === 'string') {
                return replaceMessage(error, kv);
              }

              return error;
            });
            return _context2.abrupt("return", fillVariableResult);

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[9, 14]]);
  }));
  return _validateRule.apply(this, arguments);
}

function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
  var name = namePath.join('.'); // Fill rule with context

  var filledRules = rules.map(function (currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;

    var cloneRule = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentRule), {}, {
      ruleIndex: ruleIndex
    }); // Replace validator if needed


    if (originValidatorFunc) {
      cloneRule.validator = function (rule, val, callback) {
        var hasPromise = false; // Wrap callback only accept when promise not provided

        var wrappedCallback = function wrappedCallback() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          // Wait a tick to make sure return type is a promise
          Promise.resolve().then(function () {
            es_warning(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');

            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        }; // Get promise


        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
        /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */

        es_warning(hasPromise, '`callback` is deprecated. Please return a promise instead.');

        if (hasPromise) {
          promise.then(function () {
            callback();
          }).catch(function (err) {
            callback(err || ' ');
          });
        }
      };
    }

    return cloneRule;
  }).sort(function (_ref, _ref2) {
    var w1 = _ref.warningOnly,
        i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly,
        i2 = _ref2.ruleIndex;

    if (!!w1 === !!w2) {
      // Let keep origin order
      return i1 - i2;
    }

    if (w1) {
      return 1;
    }

    return -1;
  }); // Do validate rules

  var summaryPromise;

  if (validateFirst === true) {
    // >>>>> Validate by serialization
    summaryPromise = new Promise( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < filledRules.length)) {
                  _context.next = 12;
                  break;
                }

                rule = filledRules[i];
                _context.next = 5;
                return validateRule(name, value, rule, options, messageVariables);

              case 5:
                errors = _context.sent;

                if (!errors.length) {
                  _context.next = 9;
                  break;
                }

                reject([{
                  errors: errors,
                  rule: rule
                }]);
                return _context.abrupt("return");

              case 9:
                i += 1;
                _context.next = 1;
                break;

              case 12:
                /* eslint-enable */
                resolve([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }());
  } else {
    // >>>>> Validate by parallel
    var rulePromises = filledRules.map(function (rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function (errors) {
        return {
          errors: errors,
          rule: rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function (errors) {
      // Always change to rejection for Field to catch
      return Promise.reject(errors);
    });
  } // Internal catch error to avoid console error log.


  summaryPromise.catch(function (e) {
    return e;
  });
  return summaryPromise;
}

function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}

function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(rulePromises) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function (errorsList) {
              var _ref5;

              var errors = (_ref5 = []).concat.apply(_ref5, toConsumableArray_toConsumableArray(errorsList));

              return errors;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}

function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}

function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(rulePromises) {
    var count;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function (resolve) {
              rulePromises.forEach(function (promise) {
                promise.then(function (ruleError) {
                  if (ruleError.errors.length) {
                    resolve([ruleError]);
                  }

                  count += 1;

                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/Field.js










var Field_excluded = ["name"];







var EMPTY_ERRORS = [];

function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
  if (typeof shouldUpdate === 'function') {
    return shouldUpdate(prev, next, 'source' in info ? {
      source: info.source
    } : {});
  }

  return prevValue !== nextValue;
} // We use Class instead of Hooks here since it will cost much code by using Hooks.


var Field = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Field, _React$Component);

  var _super = _createSuper(Field);

  /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */

  /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */
  // ============================== Subscriptions ==============================
  function Field(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Field);

    _this = _super.call(this, props); // Register on init

    _this.state = {
      resetCount: 0
    };
    _this.cancelRegisterFunc = null;
    _this.mounted = false;
    _this.touched = false;
    _this.dirty = false;
    _this.validatePromise = null;
    _this.prevValidating = void 0;
    _this.errors = EMPTY_ERRORS;
    _this.warnings = EMPTY_ERRORS;

    _this.cancelRegister = function () {
      var _this$props = _this.props,
          preserve = _this$props.preserve,
          isListField = _this$props.isListField,
          name = _this$props.name;

      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve, getNamePath(name));
      }

      _this.cancelRegisterFunc = null;
    };

    _this.getNamePath = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName,
          prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== undefined ? [].concat(toConsumableArray_toConsumableArray(prefixName), toConsumableArray_toConsumableArray(name)) : [];
    };

    _this.getRules = function () {
      var _this$props3 = _this.props,
          _this$props3$rules = _this$props3.rules,
          rules = _this$props3$rules === void 0 ? [] : _this$props3$rules,
          fieldContext = _this$props3.fieldContext;
      return rules.map(function (rule) {
        if (typeof rule === 'function') {
          return rule(fieldContext);
        }

        return rule;
      });
    };

    _this.refresh = function () {
      if (!_this.mounted) return;
      /**
       * Clean up current node.
       */

      _this.setState(function (_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    };

    _this.triggerMetaEvent = function (destroy) {
      var onMetaChange = _this.props.onMetaChange;
      onMetaChange === null || onMetaChange === void 0 ? void 0 : onMetaChange((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.getMeta()), {}, {
        destroy: destroy
      }));
    };

    _this.onStoreChange = function (prevStore, namePathList, info) {
      var _this$props4 = _this.props,
          shouldUpdate = _this$props4.shouldUpdate,
          _this$props4$dependen = _this$props4.dependencies,
          dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen,
          onReset = _this$props4.onReset;
      var store = info.store;

      var namePath = _this.getNamePath();

      var prevValue = _this.getValue(prevStore);

      var curValue = _this.getValue(store);

      var namePathMatch = namePathList && containsNamePath(namePathList, namePath); // `setFieldsValue` is a quick access to update related status

      if (info.type === 'valueUpdate' && info.source === 'external' && prevValue !== curValue) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;

        _this.triggerMetaEvent();
      }

      switch (info.type) {
        case 'reset':
          if (!namePathList || namePathMatch) {
            // Clean up state
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = null;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;

            _this.triggerMetaEvent();

            onReset === null || onReset === void 0 ? void 0 : onReset();

            _this.refresh();

            return;
          }

          break;

        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */

        case 'remove':
          {
            if (shouldUpdate) {
              _this.reRender();

              return;
            }

            break;
          }

        case 'setField':
          {
            if (namePathMatch) {
              var data = info.data;

              if ('touched' in data) {
                _this.touched = data.touched;
              }

              if ('validating' in data && !('originRCField' in data)) {
                _this.validatePromise = data.validating ? Promise.resolve([]) : null;
              }

              if ('errors' in data) {
                _this.errors = data.errors || EMPTY_ERRORS;
              }

              if ('warnings' in data) {
                _this.warnings = data.warnings || EMPTY_ERRORS;
              }

              _this.dirty = true;

              _this.triggerMetaEvent();

              _this.reRender();

              return;
            } // Handle update by `setField` with `shouldUpdate`


            if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
              _this.reRender();

              return;
            }

            break;
          }

        case 'dependenciesUpdate':
          {
            /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */
            var dependencyList = dependencies.map(getNamePath); // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
            // emitted earlier and they will work there
            // If set it may cause unnecessary twice rerendering

            if (dependencyList.some(function (dependency) {
              return containsNamePath(info.relatedFields, dependency);
            })) {
              _this.reRender();

              return;
            }

            break;
          }

        default:
          // 1. If `namePath` exists in `namePathList`, means it's related value and should update
          //      For example <List name="list"><Field name={['list', 0]}></List>
          //      If `namePathList` is [['list']] (List value update), Field should be updated
          //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
          // 2.
          //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
          //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
          //       is not provided
          //   2.2 If `shouldUpdate` provided, use customize logic to update the field
          //       else to check if value changed
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();

            return;
          }

          break;
      }

      if (shouldUpdate === true) {
        _this.reRender();
      }
    };

    _this.validateRules = function (options) {
      // We should fixed namePath & value to avoid developer change then by form function
      var namePath = _this.getNamePath();

      var currentValue = _this.getValue(); // Force change to async to avoid rule OOD under renderProps field


      var rootPromise = Promise.resolve().then(function () {
        if (!_this.mounted) {
          return [];
        }

        var _this$props5 = _this.props,
            _this$props5$validate = _this$props5.validateFirst,
            validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate,
            messageVariables = _this$props5.messageVariables;

        var _ref2 = options || {},
            triggerName = _ref2.triggerName;

        var filteredRules = _this.getRules();

        if (triggerName) {
          filteredRules = filteredRules.filter(function (rule) {
            var validateTrigger = rule.validateTrigger;

            if (!validateTrigger) {
              return true;
            }

            var triggerList = typeUtil_toArray(validateTrigger);
            return triggerList.includes(triggerName);
          });
        }

        var promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
        promise.catch(function (e) {
          return e;
        }).then(function () {
          var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ERRORS;

          if (_this.validatePromise === rootPromise) {
            _this.validatePromise = null; // Get errors & warnings

            var nextErrors = [];
            var nextWarnings = [];
            ruleErrors.forEach(function (_ref3) {
              var warningOnly = _ref3.rule.warningOnly,
                  _ref3$errors = _ref3.errors,
                  errors = _ref3$errors === void 0 ? EMPTY_ERRORS : _ref3$errors;

              if (warningOnly) {
                nextWarnings.push.apply(nextWarnings, toConsumableArray_toConsumableArray(errors));
              } else {
                nextErrors.push.apply(nextErrors, toConsumableArray_toConsumableArray(errors));
              }
            });
            _this.errors = nextErrors;
            _this.warnings = nextWarnings;

            _this.triggerMetaEvent();

            _this.reRender();
          }
        });
        return promise;
      });
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;

      _this.triggerMetaEvent(); // Force trigger re-render since we need sync renderProps with new meta


      _this.reRender();

      return rootPromise;
    };

    _this.isFieldValidating = function () {
      return !!_this.validatePromise;
    };

    _this.isFieldTouched = function () {
      return _this.touched;
    };

    _this.isFieldDirty = function () {
      // Touched or validate or has initialValue
      if (_this.dirty || _this.props.initialValue !== undefined) {
        return true;
      } // Form set initialValue


      var fieldContext = _this.props.fieldContext;

      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK),
          getInitialValue = _fieldContext$getInte.getInitialValue;

      if (getInitialValue(_this.getNamePath()) !== undefined) {
        return true;
      }

      return false;
    };

    _this.getErrors = function () {
      return _this.errors;
    };

    _this.getWarnings = function () {
      return _this.warnings;
    };

    _this.isListField = function () {
      return _this.props.isListField;
    };

    _this.isList = function () {
      return _this.props.isList;
    };

    _this.isPreserve = function () {
      return _this.props.preserve;
    };

    _this.getMeta = function () {
      // Make error & validating in cache to save perf
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath()
      };
      return meta;
    };

    _this.getOnlyChild = function (children) {
      // Support render props
      if (typeof children === 'function') {
        var meta = _this.getMeta();

        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _this.getOnlyChild(children(_this.getControlled(), meta, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      } // Filed element only


      var childList = toArray_toArray(children);

      if (childList.length !== 1 || ! /*#__PURE__*/react.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }

      return {
        child: childList[0],
        isFunction: false
      };
    };

    _this.getValue = function (store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;

      var namePath = _this.getNamePath();

      return valueUtil_getValue(store || getFieldsValue(true), namePath);
    };

    _this.getControlled = function () {
      var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          validateTrigger = _this$props6.validateTrigger,
          getValueFromEvent = _this$props6.getValueFromEvent,
          normalize = _this$props6.normalize,
          valuePropName = _this$props6.valuePropName,
          getValueProps = _this$props6.getValueProps,
          fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;

      var namePath = _this.getNamePath();

      var getInternalHooks = fieldContext.getInternalHooks,
          getFieldsValue = fieldContext.getFieldsValue;

      var _getInternalHooks = getInternalHooks(HOOK_MARK),
          dispatch = _getInternalHooks.dispatch;

      var value = _this.getValue();

      var mergedGetValueProps = getValueProps || function (val) {
        return (0,defineProperty/* default */.Z)({}, valuePropName, val);
      }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


      var originTriggerFunc = childProps[trigger];

      var control = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, childProps), mergedGetValueProps(value)); // Add trigger


      control[trigger] = function () {
        // Mark as touched
        _this.touched = true;
        _this.dirty = true;

        _this.triggerMetaEvent();

        var newValue;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }

        if (normalize) {
          newValue = normalize(newValue, value, getFieldsValue(true));
        }

        dispatch({
          type: 'updateValue',
          namePath: namePath,
          value: newValue
        });

        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      }; // Add validateTrigger


      var validateTriggerList = typeUtil_toArray(mergedValidateTrigger || []);
      validateTriggerList.forEach(function (triggerName) {
        // Wrap additional function of component, so that we can get latest value from store
        var originTrigger = control[triggerName];

        control[triggerName] = function () {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          } // Always use latest rules


          var rules = _this.props.rules;

          if (rules && rules.length) {
            // We dispatch validate to root,
            // since it will update related data with other field with same name
            dispatch({
              type: 'validateField',
              namePath: namePath,
              triggerName: triggerName
            });
          }
        };
      });
      return control;
    };

    if (props.fieldContext) {
      var getInternalHooks = props.fieldContext.getInternalHooks;

      var _getInternalHooks2 = getInternalHooks(HOOK_MARK),
          initEntityValue = _getInternalHooks2.initEntityValue;

      initEntityValue((0,assertThisInitialized/* default */.Z)(_this));
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          shouldUpdate = _this$props7.shouldUpdate,
          fieldContext = _this$props7.fieldContext;
      this.mounted = true; // Register on init

      if (fieldContext) {
        var getInternalHooks = fieldContext.getInternalHooks;

        var _getInternalHooks3 = getInternalHooks(HOOK_MARK),
            registerField = _getInternalHooks3.registerField;

        this.cancelRegisterFunc = registerField(this);
      } // One more render for component in case fields not ready


      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;

      var _this$getOnlyChild = this.getOnlyChild(children),
          child = _this$getOnlyChild.child,
          isFunction = _this$getOnlyChild.isFunction; // Not need to `cloneElement` since user can handle this in render function self


      var returnChildNode;

      if (isFunction) {
        returnChildNode = child;
      } else if ( /*#__PURE__*/react.isValidElement(child)) {
        returnChildNode = /*#__PURE__*/react.cloneElement(child, this.getControlled(child.props));
      } else {
        es_warning(!child, '`children` of Field is not validate ReactElement.');
        returnChildNode = child;
      }

      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);

  return Field;
}(react.Component);

Field.contextType = FieldContext;
Field.defaultProps = {
  trigger: 'onChange',
  valuePropName: 'value'
};

function WrapperField(_ref5) {
  var name = _ref5.name,
      restProps = _objectWithoutProperties(_ref5, Field_excluded);

  var fieldContext = react.useContext(FieldContext);
  var namePath = name !== undefined ? getNamePath(name) : undefined;
  var key = 'keep';

  if (!restProps.isListField) {
    key = "_".concat((namePath || []).join('_'));
  } // Warning if it's a directly list field.
  // We can still support multiple level field preserve.


  if (false) {}

  return /*#__PURE__*/react.createElement(Field, (0,esm_extends/* default */.Z)({
    key: key,
    name: namePath
  }, restProps, {
    fieldContext: fieldContext
  }));
}

/* harmony default export */ var es_Field = (WrapperField);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/ListContext.js

var ListContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var es_ListContext = (ListContext);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/List.js









var List_List = function List(_ref) {
  var name = _ref.name,
      initialValue = _ref.initialValue,
      children = _ref.children,
      rules = _ref.rules,
      validateTrigger = _ref.validateTrigger;
  var context = react.useContext(FieldContext);
  var keyRef = react.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = react.useMemo(function () {
    var parentPrefixName = getNamePath(context.prefixName) || [];
    return [].concat(toConsumableArray_toConsumableArray(parentPrefixName), toConsumableArray_toConsumableArray(getNamePath(name)));
  }, [context.prefixName, name]);
  var fieldContext = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, context), {}, {
      prefixName: prefixName
    });
  }, [context, prefixName]); // List context

  var listContext = react.useMemo(function () {
    return {
      getKey: function getKey(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]); // User should not pass `children` as other type.

  if (typeof children !== 'function') {
    es_warning(false, 'Form.List only accepts function as children.');
    return null;
  }

  var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
    var source = _ref2.source;

    if (source === 'internal') {
      return false;
    }

    return prevValue !== nextValue;
  };

  return /*#__PURE__*/react.createElement(es_ListContext.Provider, {
    value: listContext
  }, /*#__PURE__*/react.createElement(FieldContext.Provider, {
    value: fieldContext
  }, /*#__PURE__*/react.createElement(es_Field, {
    name: [],
    shouldUpdate: shouldUpdate,
    rules: rules,
    validateTrigger: validateTrigger,
    initialValue: initialValue,
    isList: true
  }, function (_ref3, meta) {
    var _ref3$value = _ref3.value,
        value = _ref3$value === void 0 ? [] : _ref3$value,
        onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;

    var getNewValue = function getNewValue() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    /**
     * Always get latest value in case user update fields by `form` api.
     */


    var operations = {
      add: function add(defaultValue, index) {
        // Mapping keys
        var newValue = getNewValue();

        if (index >= 0 && index <= newValue.length) {
          keyManager.keys = [].concat(toConsumableArray_toConsumableArray(keyManager.keys.slice(0, index)), [keyManager.id], toConsumableArray_toConsumableArray(keyManager.keys.slice(index)));
          onChange([].concat(toConsumableArray_toConsumableArray(newValue.slice(0, index)), [defaultValue], toConsumableArray_toConsumableArray(newValue.slice(index))));
        } else {
          if (false) {}

          keyManager.keys = [].concat(toConsumableArray_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange([].concat(toConsumableArray_toConsumableArray(newValue), [defaultValue]));
        }

        keyManager.id += 1;
      },
      remove: function remove(index) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index) ? index : [index]);

        if (indexSet.size <= 0) {
          return;
        }

        keyManager.keys = keyManager.keys.filter(function (_, keysIndex) {
          return !indexSet.has(keysIndex);
        }); // Trigger store change

        onChange(newValue.filter(function (_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move(from, to) {
        if (from === to) {
          return;
        }

        var newValue = getNewValue(); // Do not handle out of range

        if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }

        keyManager.keys = valueUtil_move(keyManager.keys, from, to); // Trigger store change

        onChange(valueUtil_move(newValue, from, to));
      }
    };
    var listValue = value || [];

    if (!Array.isArray(listValue)) {
      listValue = [];

      if (false) {}
    }

    return children(listValue.map(function (__, index) {
      var key = keyManager.keys[index];

      if (key === undefined) {
        keyManager.keys[index] = keyManager.id;
        key = keyManager.keys[index];
        keyManager.id += 1;
      }

      return {
        name: index,
        key: key,
        isListField: true
      };
    }), operations, meta);
  })));
};

/* harmony default export */ var es_List = (List_List);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/asyncUtil.js
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];

  if (!promiseList.length) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve, reject) {
    promiseList.forEach(function (promise, index) {
      promise.catch(function (e) {
        hasError = true;
        return e;
      }).then(function (result) {
        count -= 1;
        results[index] = result;

        if (count > 0) {
          return;
        }

        if (hasError) {
          reject(results);
        }

        resolve(results);
      });
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/utils/NameMap.js





var SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */

function normalize(namePath) {
  return namePath.map(function (cell) {
    return "".concat((0,esm_typeof/* default */.Z)(cell), ":").concat(cell);
  }) // Magic split
  .join(SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */


var NameMap = /*#__PURE__*/function () {
  function NameMap() {
    (0,classCallCheck/* default */.Z)(this, NameMap);

    this.kvs = new Map();
  }

  (0,createClass/* default */.Z)(NameMap, [{
    key: "set",
    value: function set(key, value) {
      this.kvs.set(normalize(key), value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.kvs.get(normalize(key));
    }
  }, {
    key: "update",
    value: function update(key, updater) {
      var origin = this.get(key);
      var next = updater(origin);

      if (!next) {
        this.delete(key);
      } else {
        this.set(key, next);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.kvs.delete(normalize(key));
    } // Since we only use this in test, let simply realize this

  }, {
    key: "map",
    value: function map(callback) {
      return toConsumableArray_toConsumableArray(this.kvs.entries()).map(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var cells = key.split(SPLIT);
        return callback({
          key: cells.map(function (cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/),
                _cell$match2 = (0,slicedToArray/* default */.Z)(_cell$match, 3),
                type = _cell$match2[1],
                unit = _cell$match2[2];

            return type === 'number' ? Number(unit) : unit;
          }),
          value: value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function (_ref3) {
        var key = _ref3.key,
            value = _ref3.value;
        json[key.join('.')] = value;
        return null;
      });
      return json;
    }
  }]);

  return NameMap;
}();

/* harmony default export */ var utils_NameMap = (NameMap);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/useForm.js






var useForm_excluded = ["name", "errors"];








var FormStore = /*#__PURE__*/(0,createClass/* default */.Z)(function FormStore(forceRootUpdate) {
  var _this = this;

  (0,classCallCheck/* default */.Z)(this, FormStore);

  this.formHooked = false;
  this.forceRootUpdate = void 0;
  this.subscribable = true;
  this.store = {};
  this.fieldEntities = [];
  this.initialValues = {};
  this.callbacks = {};
  this.validateMessages = null;
  this.preserve = null;
  this.lastValidatePromise = null;

  this.getForm = function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      _init: true,
      getInternalHooks: _this.getInternalHooks
    };
  };

  this.getInternalHooks = function (key) {
    if (key === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        destroyForm: _this.destroyForm,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue,
        registerWatch: _this.registerWatch
      };
    }

    es_warning(false, '`getInternalHooks` is internal usage. Should not call directly.');
    return null;
  };

  this.useSubscribe = function (subscribable) {
    _this.subscribable = subscribable;
  };

  this.prevWithoutPreserves = null;

  this.setInitialValues = function (initialValues, init) {
    _this.initialValues = initialValues || {};

    if (init) {
      var _this$prevWithoutPres;

      var nextStore = setValues({}, initialValues, _this.store); // We will take consider prev form unmount fields.
      // When the field is not `preserve`, we need fill this with initialValues instead of store.
      // eslint-disable-next-line array-callback-return

      (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 ? void 0 : _this$prevWithoutPres.map(function (_ref) {
        var namePath = _ref.key;
        nextStore = setValue(nextStore, namePath, valueUtil_getValue(initialValues, namePath));
      });
      _this.prevWithoutPreserves = null;

      _this.updateStore(nextStore);
    }
  };

  this.destroyForm = function () {
    var prevWithoutPreserves = new utils_NameMap();

    _this.getFieldEntities(true).forEach(function (entity) {
      if (!_this.isMergedPreserve(entity.isPreserve())) {
        prevWithoutPreserves.set(entity.getNamePath(), true);
      }
    });

    _this.prevWithoutPreserves = prevWithoutPreserves;
  };

  this.getInitialValue = function (namePath) {
    var initValue = valueUtil_getValue(_this.initialValues, namePath); // Not cloneDeep when without `namePath`

    return namePath.length ? utils_cloneDeep(initValue) : initValue;
  };

  this.setCallbacks = function (callbacks) {
    _this.callbacks = callbacks;
  };

  this.setValidateMessages = function (validateMessages) {
    _this.validateMessages = validateMessages;
  };

  this.setPreserve = function (preserve) {
    _this.preserve = preserve;
  };

  this.watchList = [];

  this.registerWatch = function (callback) {
    _this.watchList.push(callback);

    return function () {
      _this.watchList = _this.watchList.filter(function (fn) {
        return fn !== callback;
      });
    };
  };

  this.notifyWatch = function () {
    var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    // No need to cost perf when nothing need to watch
    if (_this.watchList.length) {
      var values = _this.getFieldsValue();

      _this.watchList.forEach(function (callback) {
        callback(values, namePath);
      });
    }
  };

  this.timeoutId = null;

  this.warningUnhooked = function () {
    if (false) {}
  };

  this.updateStore = function (nextStore) {
    _this.store = nextStore;
  };

  this.getFieldEntities = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!pure) {
      return _this.fieldEntities;
    }

    return _this.fieldEntities.filter(function (field) {
      return field.getNamePath().length;
    });
  };

  this.getFieldsMap = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cache = new utils_NameMap();

    _this.getFieldEntities(pure).forEach(function (field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });

    return cache;
  };

  this.getFieldEntitiesForNamePathList = function (nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }

    var cache = _this.getFieldsMap(true);

    return nameList.map(function (name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  };

  this.getFieldsValue = function (nameList, filterFunc) {
    _this.warningUnhooked();

    if (nameList === true && !filterFunc) {
      return _this.store;
    }

    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(nameList) ? nameList : null);

    var filteredNameList = [];
    fieldEntities.forEach(function (entity) {
      var _entity$isListField;

      var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath(); // Ignore when it's a list item and not specific the namePath,
      // since parent field is already take in count

      if (!nameList && ((_entity$isListField = entity.isListField) === null || _entity$isListField === void 0 ? void 0 : _entity$isListField.call(entity))) {
        return;
      }

      if (!filterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = 'getMeta' in entity ? entity.getMeta() : null;

        if (filterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  };

  this.getFieldValue = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);
    return valueUtil_getValue(_this.store, namePath);
  };

  this.getFieldsError = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);

    return fieldEntities.map(function (entity, index) {
      if (entity && !('INVALIDATE_NAME_PATH' in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }

      return {
        name: getNamePath(nameList[index]),
        errors: [],
        warnings: []
      };
    });
  };

  this.getFieldError = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);

    var fieldError = _this.getFieldsError([namePath])[0];

    return fieldError.errors;
  };

  this.getFieldWarning = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);

    var fieldError = _this.getFieldsError([namePath])[0];

    return fieldError.warnings;
  };

  this.isFieldsTouched = function () {
    _this.warningUnhooked();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var arg0 = args[0],
        arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;

    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }

    var fieldEntities = _this.getFieldEntities(true);

    var isFieldTouched = function isFieldTouched(field) {
      return field.isFieldTouched();
    }; // ===== Will get fully compare when not config namePathList =====


    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
    } // Generate a nest tree for validate


    var map = new utils_NameMap();
    namePathList.forEach(function (shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function (field) {
      var fieldNamePath = field.getNamePath(); // Find matched entity and put into list

      namePathList.forEach(function (shortNamePath) {
        if (shortNamePath.every(function (nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function (list) {
            return [].concat(toConsumableArray_toConsumableArray(list), [field]);
          });
        }
      });
    }); // Check if NameMap value is touched

    var isNamePathListTouched = function isNamePathListTouched(entities) {
      return entities.some(isFieldTouched);
    };

    var namePathListEntities = map.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  };

  this.isFieldTouched = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsTouched([name]);
  };

  this.isFieldsValidating = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntities();

    if (!nameList) {
      return fieldEntities.some(function (testField) {
        return testField.isFieldValidating();
      });
    }

    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function (testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  };

  this.isFieldValidating = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsValidating([name]);
  };

  this.resetWithFieldInitialValue = function () {
    var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create cache
    var cache = new utils_NameMap();

    var fieldEntities = _this.getFieldEntities(true);

    fieldEntities.forEach(function (field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath(); // Record only if has `initialValue`

      if (initialValue !== undefined) {
        var records = cache.get(namePath) || new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    }); // Reset

    var resetWithFields = function resetWithFields(entities) {
      entities.forEach(function (field) {
        var initialValue = field.props.initialValue;

        if (initialValue !== undefined) {
          var namePath = field.getNamePath();

          var formInitialValue = _this.getInitialValue(namePath);

          if (formInitialValue !== undefined) {
            // Warning if conflict with form initialValues and do not modify value
            es_warning(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);

            if (records && records.size > 1) {
              // Warning if multiple field set `initialValue`and do not modify value
              es_warning(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath); // Set `initialValue`


              if (!info.skipExist || originValue === undefined) {
                _this.updateStore(setValue(_this.store, namePath, toConsumableArray_toConsumableArray(records)[0].value));
              }
            }
          }
        }
      });
    };

    var requiredFieldEntities;

    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function (namePath) {
        var records = cache.get(namePath);

        if (records) {
          var _requiredFieldEntitie;

          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, toConsumableArray_toConsumableArray(toConsumableArray_toConsumableArray(records).map(function (r) {
            return r.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }

    resetWithFields(requiredFieldEntities);
  };

  this.resetFields = function (nameList) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (!nameList) {
      _this.updateStore(setValues({}, _this.initialValues));

      _this.resetWithFieldInitialValue();

      _this.notifyObservers(prevStore, null, {
        type: 'reset'
      });

      _this.notifyWatch();

      return;
    } // Reset by `nameList`


    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function (namePath) {
      var initialValue = _this.getInitialValue(namePath);

      _this.updateStore(setValue(_this.store, namePath, initialValue));
    });

    _this.resetWithFieldInitialValue({
      namePathList: namePathList
    });

    _this.notifyObservers(prevStore, namePathList, {
      type: 'reset'
    });

    _this.notifyWatch(namePathList);
  };

  this.setFields = function (fields) {
    _this.warningUnhooked();

    var prevStore = _this.store;
    var namePathList = [];
    fields.forEach(function (fieldData) {
      var name = fieldData.name,
          errors = fieldData.errors,
          data = _objectWithoutProperties(fieldData, useForm_excluded);

      var namePath = getNamePath(name);
      namePathList.push(namePath); // Value

      if ('value' in data) {
        _this.updateStore(setValue(_this.store, namePath, data.value));
      }

      _this.notifyObservers(prevStore, [namePath], {
        type: 'setField',
        data: fieldData
      });
    });

    _this.notifyWatch(namePathList);
  };

  this.getFields = function () {
    var entities = _this.getFieldEntities(true);

    var fields = entities.map(function (field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();

      var fieldData = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });

      Object.defineProperty(fieldData, 'originRCField', {
        value: true
      });
      return fieldData;
    });
    return fields;
  };

  this.initEntityValue = function (entity) {
    var initialValue = entity.props.initialValue;

    if (initialValue !== undefined) {
      var namePath = entity.getNamePath();
      var prevValue = valueUtil_getValue(_this.store, namePath);

      if (prevValue === undefined) {
        _this.updateStore(setValue(_this.store, namePath, initialValue));
      }
    }
  };

  this.isMergedPreserve = function (fieldPreserve) {
    var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
    return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
  };

  this.registerField = function (entity) {
    _this.fieldEntities.push(entity);

    var namePath = entity.getNamePath();

    _this.notifyWatch([namePath]); // Set initial values


    if (entity.props.initialValue !== undefined) {
      var prevStore = _this.store;

      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });

      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: 'valueUpdate',
        source: 'internal'
      });
    } // un-register field callback


    return function (isListField, preserve) {
      var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function (item) {
        return item !== entity;
      }); // Clean up store value if not preserve

      if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
        var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);

        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function (field) {
          return (// Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;

          _this.updateStore(setValue(_prevStore, namePath, defaultValue, true)); // Notify that field is unmount


          _this.notifyObservers(_prevStore, [namePath], {
            type: 'remove'
          }); // Dependencies update


          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }

      _this.notifyWatch([namePath]);
    };
  };

  this.dispatch = function (action) {
    switch (action.type) {
      case 'updateValue':
        {
          var namePath = action.namePath,
              value = action.value;

          _this.updateValue(namePath, value);

          break;
        }

      case 'validateField':
        {
          var _namePath = action.namePath,
              triggerName = action.triggerName;

          _this.validateFields([_namePath], {
            triggerName: triggerName
          });

          break;
        }

      default: // Currently we don't have other action. Do nothing.

    }
  };

  this.notifyObservers = function (prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, info), {}, {
        store: _this.getFieldsValue(true)
      });

      _this.getFieldEntities().forEach(function (_ref3) {
        var onStoreChange = _ref3.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  };

  this.triggerDependenciesUpdate = function (prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);

    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }

    _this.notifyObservers(prevStore, childrenFields, {
      type: 'dependenciesUpdate',
      relatedFields: [namePath].concat(toConsumableArray_toConsumableArray(childrenFields))
    });

    return childrenFields;
  };

  this.updateValue = function (name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;

    _this.updateStore(setValue(_this.store, namePath, value));

    _this.notifyObservers(prevStore, [namePath], {
      type: 'valueUpdate',
      source: 'internal'
    });

    _this.notifyWatch([namePath]); // Dependencies update


    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath); // trigger callback function


    var onValuesChange = _this.callbacks.onValuesChange;

    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }

    _this.triggerOnFieldsChange([namePath].concat(toConsumableArray_toConsumableArray(childrenFields)));
  };

  this.setFieldsValue = function (store) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (store) {
      var nextStore = setValues(_this.store, store);

      _this.updateStore(nextStore);
    }

    _this.notifyObservers(prevStore, null, {
      type: 'valueUpdate',
      source: 'external'
    });

    _this.notifyWatch();
  };

  this.getDependencyChildrenFields = function (rootNamePath) {
    var children = new Set();
    var childrenFields = [];
    var dependencies2fields = new utils_NameMap();
    /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */

    _this.getFieldEntities().forEach(function (field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function (dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function () {
          var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
          fields.add(field);
          return fields;
        });
      });
    });

    var fillChildren = function fillChildren(namePath) {
      var fields = dependencies2fields.get(namePath) || new Set();
      fields.forEach(function (field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();

          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren(fieldNamePath);
          }
        }
      });
    };

    fillChildren(rootNamePath);
    return childrenFields;
  };

  this.triggerOnFieldsChange = function (namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;

    if (onFieldsChange) {
      var fields = _this.getFields();
      /**
       * Fill errors since `fields` may be replaced by controlled fields
       */


      if (filedErrors) {
        var cache = new utils_NameMap();
        filedErrors.forEach(function (_ref4) {
          var name = _ref4.name,
              errors = _ref4.errors;
          cache.set(name, errors);
        });
        fields.forEach(function (field) {
          // eslint-disable-next-line no-param-reassign
          field.errors = cache.get(field.name) || field.errors;
        });
      }

      var changedFields = fields.filter(function (_ref5) {
        var fieldName = _ref5.name;
        return containsNamePath(namePathList, fieldName);
      });
      onFieldsChange(changedFields, fields);
    }
  };

  this.validateFields = function (nameList, options) {
    _this.warningUnhooked();

    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : []; // Collect result in promise list

    var promiseList = [];

    _this.getFieldEntities(true).forEach(function (field) {
      // Add field if not provide `nameList`
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      /**
       * Recursive validate if configured.
       * TODO: perf improvement @zombieJ
       */


      if ((options === null || options === void 0 ? void 0 : options.recursive) && provideNameList) {
        var namePath = field.getNamePath();

        if ( // nameList[i] === undefined 说明是以 nameList 开头的
        // ['name'] -> ['name','list']
        namePath.every(function (nameUnit, i) {
          return nameList[i] === nameUnit || nameList[i] === undefined;
        })) {
          namePathList.push(namePath);
        }
      } // Skip if without rule


      if (!field.props.rules || !field.props.rules.length) {
        return;
      }

      var fieldNamePath = field.getNamePath(); // Add field validate rule in to promise list

      if (!provideNameList || containsNamePath(namePathList, fieldNamePath)) {
        var promise = field.validateRules((0,objectSpread2/* default */.Z)({
          validateMessages: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultValidateMessages), _this.validateMessages)
        }, options)); // Wrap promise with field

        promiseList.push(promise.then(function () {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function (ruleErrors) {
          var mergedErrors = [];
          var mergedWarnings = [];
          ruleErrors.forEach(function (_ref6) {
            var warningOnly = _ref6.rule.warningOnly,
                errors = _ref6.errors;

            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, toConsumableArray_toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, toConsumableArray_toConsumableArray(errors));
            }
          });

          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }

          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });

    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise; // Notify fields with rule that validate has finished and need update

    summaryPromise.catch(function (results) {
      return results;
    }).then(function (results) {
      var resultNamePathList = results.map(function (_ref7) {
        var name = _ref7.name;
        return name;
      });

      _this.notifyObservers(_this.store, resultNamePathList, {
        type: 'validateFinish'
      });

      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function () {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }

      return Promise.reject([]);
    }).catch(function (results) {
      var errorList = results.filter(function (result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    }); // Do not throw in console

    returnPromise.catch(function (e) {
      return e;
    });
    return returnPromise;
  };

  this.submit = function () {
    _this.warningUnhooked();

    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;

      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          // Should print error if user `onFinish` callback failed
          console.error(err);
        }
      }
    }).catch(function (e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;

      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  };

  this.forceRootUpdate = forceRootUpdate;
});

function useForm(form) {
  var formRef = react.useRef();

  var _React$useState = react.useState({}),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      forceUpdate = _React$useState2[1];

  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      // Create a new FormStore if not provided
      var forceReRender = function forceReRender() {
        forceUpdate({});
      };

      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }

  return [formRef.current];
}

/* harmony default export */ var es_useForm = (useForm);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/FormContext.js



var FormContext = /*#__PURE__*/react.createContext({
  triggerFormChange: function triggerFormChange() {},
  triggerFormFinish: function triggerFormFinish() {},
  registerForm: function registerForm() {},
  unregisterForm: function unregisterForm() {}
});

var FormProvider = function FormProvider(_ref) {
  var validateMessages = _ref.validateMessages,
      onFormChange = _ref.onFormChange,
      onFormFinish = _ref.onFormFinish,
      children = _ref.children;
  var formContext = react.useContext(FormContext);
  var formsRef = react.useRef({});
  return /*#__PURE__*/react.createElement(FormContext.Provider, {
    value: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext), {}, {
      validateMessages: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields: changedFields,
            forms: formsRef.current
          });
        }

        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values: values,
            forms: formsRef.current
          });
        }

        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm(name, form) {
        if (name) {
          formsRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formsRef.current), {}, (0,defineProperty/* default */.Z)({}, name, form));
        }

        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm(name) {
        var newForms = (0,objectSpread2/* default */.Z)({}, formsRef.current);

        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};


/* harmony default export */ var es_FormContext = (FormContext);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/Form.js




var Form_excluded = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"];






var Form = function Form(_ref, ref) {
  var name = _ref.name,
      initialValues = _ref.initialValues,
      fields = _ref.fields,
      form = _ref.form,
      preserve = _ref.preserve,
      children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'form' : _ref$component,
      validateMessages = _ref.validateMessages,
      _ref$validateTrigger = _ref.validateTrigger,
      validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger,
      onValuesChange = _ref.onValuesChange,
      _onFieldsChange = _ref.onFieldsChange,
      _onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      restProps = _objectWithoutProperties(_ref, Form_excluded);

  var formContext = react.useContext(es_FormContext); // We customize handle event since Context will makes all the consumer re-render:
  // https://reactjs.org/docs/context.html#contextprovider

  var _useForm = es_useForm(form),
      _useForm2 = (0,slicedToArray/* default */.Z)(_useForm, 1),
      formInstance = _useForm2[0];

  var _formInstance$getInte = formInstance.getInternalHooks(HOOK_MARK),
      useSubscribe = _formInstance$getInte.useSubscribe,
      setInitialValues = _formInstance$getInte.setInitialValues,
      setCallbacks = _formInstance$getInte.setCallbacks,
      setValidateMessages = _formInstance$getInte.setValidateMessages,
      setPreserve = _formInstance$getInte.setPreserve,
      destroyForm = _formInstance$getInte.destroyForm; // Pass ref with form instance


  react.useImperativeHandle(ref, function () {
    return formInstance;
  }); // Register form into Context

  react.useEffect(function () {
    formContext.registerForm(name, formInstance);
    return function () {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]); // Pass props to store

  setValidateMessages((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange: onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);

      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);

      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed: onFinishFailed
  });
  setPreserve(preserve); // Set initial value, init store value when first mount

  var mountRef = react.useRef(null);
  setInitialValues(initialValues, !mountRef.current);

  if (!mountRef.current) {
    mountRef.current = true;
  }

  react.useEffect(function () {
    return destroyForm;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []); // Prepare children by `children` type

  var childrenNode;
  var childrenRenderProps = typeof children === 'function';

  if (childrenRenderProps) {
    var values = formInstance.getFieldsValue(true);
    childrenNode = children(values, formInstance);
  } else {
    childrenNode = children;
  } // Not use subscribe when using render props


  useSubscribe(!childrenRenderProps); // Listen if fields provided. We use ref to save prev data here to avoid additional render

  var prevFieldsRef = react.useRef();
  react.useEffect(function () {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }

    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = react.useMemo(function () {
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formInstance), {}, {
      validateTrigger: validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /*#__PURE__*/react.createElement(FieldContext.Provider, {
    value: formContextValue
  }, childrenNode);

  if (Component === false) {
    return wrapperNode;
  }

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, restProps, {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;

      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 ? void 0 : _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};

/* harmony default export */ var es_Form = (Form);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/useWatch.js






function stringify(value) {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return Math.random();
  }
}

function useWatch() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var form = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var valueStr = (0,react.useMemo)(function () {
    return stringify(value);
  }, [value]);
  var valueStrRef = (0,react.useRef)(valueStr);
  valueStrRef.current = valueStr;
  var fieldContext = (0,react.useContext)(FieldContext);
  var formInstance = form || fieldContext;
  var isValidForm = formInstance && formInstance._init; // Warning if not exist form instance

  if (false) {}

  var namePath = getNamePath(dependencies);
  var namePathRef = (0,react.useRef)(namePath);
  namePathRef.current = namePath;
  (0,react.useEffect)(function () {
    // Skip if not exist form instance
    if (!isValidForm) {
      return;
    }

    var getFieldsValue = formInstance.getFieldsValue,
        getInternalHooks = formInstance.getInternalHooks;

    var _getInternalHooks = getInternalHooks(HOOK_MARK),
        registerWatch = _getInternalHooks.registerWatch;

    var cancelRegister = registerWatch(function (store) {
      var newValue = valueUtil_getValue(store, namePathRef.current);
      var nextValueStr = stringify(newValue); // Compare stringify in case it's nest object

      if (valueStrRef.current !== nextValueStr) {
        valueStrRef.current = nextValueStr;
        setValue(newValue);
      }
    }); // TODO: We can improve this perf in future

    var initialValue = valueUtil_getValue(getFieldsValue(), namePathRef.current);
    setValue(initialValue);
    return cancelRegister;
  }, // We do not need re-register since namePath content is the same
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return value;
}

/* harmony default export */ var es_useWatch = (useWatch);
;// CONCATENATED MODULE: ./node_modules/rc-field-form/es/index.js









var InternalForm = /*#__PURE__*/react.forwardRef(es_Form);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = es_Field;
RefForm.List = es_List;
RefForm.useForm = es_useForm;
RefForm.useWatch = es_useWatch;

/* harmony default export */ var es = (RefForm);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/context.js

var defaultFormContext = {
    name: undefined,
    hasFeedback: true,
    layout: "vertical",
    requiredMarkStyle: "asterisk",
    disabled: false
};
var context_FormContext = /*#__PURE__*/ react.createContext(defaultFormContext);
var NoStyleItemContext = /*#__PURE__*/ react.createContext(null);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/header.js
var Header = function() {
    return null;
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/form-array.js



var FormArray = function(props) {
    return /*#__PURE__*/ react.createElement(es_List, {
        name: props.name,
        initialValue: props.initialValue
    }, function(rcFields, operation) {
        var fields = rcFields.map(function(field) {
            return {
                index: field.name,
                key: field.key
            };
        });
        var children = props.children(fields, operation).map(function(child, index) {
            var _a;
            return /*#__PURE__*/ react.createElement(components_list, {
                key: fields[index].key,
                mode: "card",
                header: (_a = props.renderHeader) === null || _a === void 0 ? void 0 : _a.call(props, fields[index], operation)
            }, child);
        });
        if (props.renderAdd) {
            children.push(/*#__PURE__*/ react.createElement(components_list, {
                key: "add",
                mode: "card"
            }, /*#__PURE__*/ react.createElement(components_list.Item, {
                className: "adm-form-list-operation",
                onClick: function() {
                    props.onAdd ? props.onAdd(operation) : operation.add();
                },
                arrow: false
            }, props.renderAdd())));
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
    });
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/form.js












var form_classPrefix = "adm-form";
var form_defaultProps = defaultFormContext;
var form_Form = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var collect = function collect() {
        if (items.length === 0) return;
        count += 1;
        lists.push(/*#__PURE__*/ react.createElement(components_list, {
            header: currentHeader,
            key: count,
            mode: mode
        }, items));
        items = [];
    };
    var props = mergeProps(form_defaultProps, p);
    var className = props.className, style = props.style, hasFeedback = props.hasFeedback, children = props.children, layout = props.layout, footer = props.footer, mode = props.mode, disabled = props.disabled, requiredMarkStyle = props.requiredMarkStyle, formProps = tslib_es6_rest(props, [
        "className",
        "style",
        "hasFeedback",
        "children",
        "layout",
        "footer",
        "mode",
        "disabled",
        "requiredMarkStyle"
    ]);
    var locale = useConfig().locale;
    var validateMessages = (0,react.useMemo)(function() {
        return merge_default()({}, locale.Form.defaultValidateMessages, formProps.validateMessages);
    }, [
        locale.Form.defaultValidateMessages,
        formProps.validateMessages
    ]);
    var lists = [];
    var currentHeader = null;
    var items = [];
    var count = 0;
    traverseReactNode(props.children, function(child) {
        if (/*#__PURE__*/ react.isValidElement(child)) {
            if (child.type === Header) {
                collect();
                currentHeader = child.props.children;
                return;
            }
            if (child.type === FormArray) {
                collect();
                lists.push(child);
                return;
            }
        }
        items.push(child);
    });
    collect();
    return /*#__PURE__*/ react.createElement(es, Object.assign({
        className: classnames_default()(form_classPrefix, className),
        style: style,
        ref: ref
    }, formProps, {
        validateMessages: validateMessages
    }), /*#__PURE__*/ react.createElement(context_FormContext.Provider, {
        value: {
            name: formProps.name,
            hasFeedback: hasFeedback,
            layout: layout,
            requiredMarkStyle: requiredMarkStyle,
            disabled: disabled
        }
    }, lists), footer && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(form_classPrefix, "-footer")
    }, footer));
});

// EXTERNAL MODULE: ./node_modules/rc-field-form/lib/FieldContext.js
var lib_FieldContext = __webpack_require__(11950);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/utils.js

function utils_toArray(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
} // eslint-disable-next-line @typescript-eslint/ban-types
function shouldConstruct(Component) {
    var prototype = Component.prototype;
    return !!(prototype && prototype.isReactComponent);
} // https://github.com/facebook/react/blob/ce13860281f833de8a3296b7a3dad9caced102e9/packages/react-reconciler/src/ReactFiber.new.js#L225
function isSimpleFunctionComponent(type) {
    return typeof type === "function" && !shouldConstruct(type) && type.defaultProps === undefined;
}
function isSafeSetRefComponent(component) {
    if ((0,react_is.isFragment)(component)) return false;
    if ((0,react_is.isMemo)(component)) return isSafeSetRefComponent(component.type);
    return !isSimpleFunctionComponent(component.type);
}

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/popover/popover.css
var popover = __webpack_require__(90244);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/popover/popover-menu.css
var popover_menu = __webpack_require__(9098);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/arrow.js


var Arrow = /*#__PURE__*/ (0,react.memo)(function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 30 16"
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "currentColor"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M0,0 L30,0 L18.07289,14.312538 C16.65863,16.009645 14.13637,16.238942 12.43926,14.824685 C12.25341,14.669808 12.08199,14.49839 11.92711,14.312538 L0,0 L0,0 Z"
    }))));
});

;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t){return t.split("-")[0]}function e(t){return t.split("-")[1]}function n(e){return["top","bottom"].includes(t(e))?"x":"y"}function r(t){return"y"===t?"height":"width"}function i(i,o,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,u=n(o),m=r(u),g=l[m]/2-s[m]/2,d="x"===u;let p;switch(t(o)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(e(o)){case"start":p[u]-=g*(a&&d?-1:1);break;case"end":p[u]+=g*(a&&d?-1:1)}return p}const floating_ui_core_browser_min_o=async(t,e,n)=>{const{placement:r="bottom",strategy:o="absolute",middleware:a=[],platform:l}=n,s=await(null==l.isRTL?void 0:l.isRTL(e));let c=await l.getElementRects({reference:t,floating:e,strategy:o}),{x:f,y:u}=i(c,r,s),m=r,g={};for(let n=0;n<a.length;n++){const{name:d,fn:p}=a[n],{x:h,y:y,data:x,reset:w}=await p({x:f,y:u,initialPlacement:r,placement:m,strategy:o,middlewareData:g,rects:c,platform:l,elements:{reference:t,floating:e}});f=null!=h?h:f,u=null!=y?y:u,g={...g,[d]:{...g[d],...x}},w&&("object"==typeof w&&(w.placement&&(m=w.placement),w.rects&&(c=!0===w.rects?await l.getElementRects({reference:t,floating:e,strategy:o}):w.rects),({x:f,y:u}=i(c,m,s))),n=-1)}return{x:f,y:u,placement:m,strategy:o,middlewareData:g}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:r,y:i,platform:o,rects:s,elements:c,strategy:f}=t,{boundary:u="clippingAncestors",rootBoundary:m="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=l(await o.getClippingRect({element:null==(n=await(null==o.isElement?void 0:o.isElement(y)))||n?y:y.contextElement||await(null==o.getDocumentElement?void 0:o.getDocumentElement(c.floating)),boundary:u,rootBoundary:m,strategy:f})),w=l(o.convertOffsetParentRelativeRectToViewportRelativeRect?await o.convertOffsetParentRelativeRectToViewportRelativeRect({rect:"floating"===g?{...s.floating,x:r,y:i}:s.reference,offsetParent:await(null==o.getOffsetParent?void 0:o.getOffsetParent(c.floating)),strategy:f}):s[g]);return{top:x.top-w.top+h.top,bottom:w.bottom-x.bottom+h.bottom,left:x.left-w.left+h.left,right:w.right-x.right+h.right}}const c=Math.min,f=Math.max;function u(t,e,n){return f(t,c(e,n))}const m=t=>({name:"arrow",options:t,async fn(i){const{element:o,padding:l=0}=null!=t?t:{},{x:s,y:c,placement:f,rects:m,platform:g}=i;if(null==o)return{};const d=a(l),p={x:s,y:c},h=n(f),y=e(f),x=r(h),w=await g.getDimensions(o),v="y"===h?"top":"left",b="y"===h?"bottom":"right",R=m.reference[x]+m.reference[h]-p[h]-m.floating[x],A=p[h]-m.reference[h],P=await(null==g.getOffsetParent?void 0:g.getOffsetParent(o));let T=P?"y"===h?P.clientHeight||0:P.clientWidth||0:0;0===T&&(T=m.floating[x]);const O=R/2-A/2,D=d[v],L=T-w[x]-d[b],k=T/2-w[x]/2+O,E=u(D,k,L),C=("start"===y?d[v]:d[b])>0&&k!==E&&m.reference[x]<=m.floating[x];return{[h]:p[h]-(C?k<D?D-k:L-k:0),data:{[h]:E,centerOffset:k-E}}}}),g={left:"right",right:"left",bottom:"top",top:"bottom"};function d(t){return t.replace(/left|right|bottom|top/g,(t=>g[t]))}function p(t,i,o){void 0===o&&(o=!1);const a=e(t),l=n(t),s=r(l);let c="x"===l?a===(o?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=d(c)),{main:c,cross:d(c)}}const h={start:"end",end:"start"};function y(t){return t.replace(/start|end/g,(t=>h[t]))}const x=["top","right","bottom","left"],w=x.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]);const v=function(n){return void 0===n&&(n={}),{name:"autoPlacement",options:n,async fn(r){var i,o,a,l,c;const{x:f,y:u,rects:m,middlewareData:g,placement:d,platform:h,elements:x}=r,{alignment:v=null,allowedPlacements:b=w,autoAlignment:R=!0,...A}=n,P=function(n,r,i){return(n?[...i.filter((t=>e(t)===n)),...i.filter((t=>e(t)!==n))]:i.filter((e=>t(e)===e))).filter((t=>!n||e(t)===n||!!r&&y(t)!==t))}(v,R,b),T=await s(r,A),O=null!=(i=null==(o=g.autoPlacement)?void 0:o.index)?i:0,D=P[O];if(null==D)return{};const{main:L,cross:k}=p(D,m,await(null==h.isRTL?void 0:h.isRTL(x.floating)));if(d!==D)return{x:f,y:u,reset:{placement:P[0]}};const E=[T[t(D)],T[L],T[k]],C=[...null!=(a=null==(l=g.autoPlacement)?void 0:l.overflows)?a:[],{placement:D,overflows:E}],H=P[O+1];if(H)return{data:{index:O+1,overflows:C},reset:{placement:H}};const B=C.slice().sort(((t,e)=>t.overflows[0]-e.overflows[0])),V=null==(c=B.find((t=>{let{overflows:e}=t;return e.every((t=>t<=0))})))?void 0:c.placement,F=null!=V?V:B[0].placement;return F!==d?{data:{index:O+1,overflows:C},reset:{placement:F}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(n){var r;const{placement:i,middlewareData:o,rects:a,initialPlacement:l,platform:c,elements:f}=n,{mainAxis:u=!0,crossAxis:m=!0,fallbackPlacements:g,fallbackStrategy:h="bestFit",flipAlignment:x=!0,...w}=e,v=t(i),b=g||(v===l||!x?[d(l)]:function(t){const e=d(t);return[y(t),e,y(e)]}(l)),R=[l,...b],A=await s(n,w),P=[];let T=(null==(r=o.flip)?void 0:r.overflows)||[];if(u&&P.push(A[v]),m){const{main:t,cross:e}=p(i,a,await(null==c.isRTL?void 0:c.isRTL(f.floating)));P.push(A[t],A[e])}if(T=[...T,{placement:i,overflows:P}],!P.every((t=>t<=0))){var O,D;const t=(null!=(O=null==(D=o.flip)?void 0:D.index)?O:0)+1,e=R[t];if(e)return{data:{index:t,overflows:T},reset:{placement:e}};let n="bottom";switch(h){case"bestFit":{var L;const t=null==(L=T.map((t=>[t,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:L[0].placement;t&&(n=t);break}case"initialPlacement":n=l}if(i!==n)return{reset:{placement:n}}}return{}}}};function R(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function A(t){return x.some((e=>t[e]>=0))}const P=function(t){let{strategy:e="referenceHidden",...n}=void 0===t?{}:t;return{name:"hide",async fn(t){const{rects:r}=t;switch(e){case"referenceHidden":{const e=R(await s(t,{...n,elementContext:"reference"}),r.reference);return{data:{referenceHiddenOffsets:e,referenceHidden:A(e)}}}case"escaped":{const e=R(await s(t,{...n,altBoundary:!0}),r.floating);return{data:{escapedOffsets:e,escaped:A(e)}}}default:return{}}}}};const T=function(r){return void 0===r&&(r=0),{name:"offset",options:r,async fn(i){const{x:o,y:a}=i,l=await async function(r,i){const{placement:o,platform:a,elements:l}=r,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=t(o),f=e(o),u="x"===n(o),m=["left","top"].includes(c)?-1:1,g=s&&u?-1:1,d="function"==typeof i?i(r):i;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),u?{x:h*g,y:p*m}:{x:p*m,y:h*g}}(i,r);return{x:o+l.x,y:a+l.y,data:l}}}};function O(t){return"x"===t?"y":"x"}const D=function(e){return void 0===e&&(e={}),{name:"shift",options:e,async fn(r){const{x:i,y:o,placement:a}=r,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...m}=e,g={x:i,y:o},d=await s(r,m),p=n(t(a)),h=O(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=u(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=u(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...r,[p]:y,[h]:x});return{...w,data:{x:w.x-i,y:w.y-o}}}}},L=function(e){return void 0===e&&(e={}),{options:e,fn(r){const{x:i,y:o,placement:a,rects:l,middlewareData:s}=r,{offset:c=0,mainAxis:f=!0,crossAxis:u=!0}=e,m={x:i,y:o},g=n(a),d=O(g);let p=m[g],h=m[d];const y="function"==typeof c?c({...l,placement:a}):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(u){var w,v,b,R;const e="y"===g?"width":"height",n=["top","left"].includes(t(a)),r=l.reference[d]-l.floating[e]+(n&&null!=(w=null==(v=s.offset)?void 0:v[d])?w:0)+(n?0:x.crossAxis),i=l.reference[d]+l.reference[e]+(n?0:null!=(b=null==(R=s.offset)?void 0:R[d])?b:0)-(n?x.crossAxis:0);h<r?h=r:h>i&&(h=i)}return{[g]:p,[d]:h}}}},k=function(n){return void 0===n&&(n={}),{name:"size",options:n,async fn(r){const{placement:i,rects:o,platform:a,elements:l}=r,{apply:c,...u}=n,m=await s(r,u),g=t(i),d=e(i);let p,h;"top"===g||"bottom"===g?(p=g,h=d===(await(null==a.isRTL?void 0:a.isRTL(l.floating))?"start":"end")?"left":"right"):(h=g,p="end"===d?"top":"bottom");const y=f(m.left,0),x=f(m.right,0),w=f(m.top,0),v=f(m.bottom,0),b={availableHeight:o.floating.height-(["left","right"].includes(i)?2*(0!==w||0!==v?w+v:f(m.top,m.bottom)):m[p]),availableWidth:o.floating.width-(["top","bottom"].includes(i)?2*(0!==y||0!==x?y+x:f(m.left,m.right)):m[h])},R=await a.getDimensions(l.floating);null==c||c({...r,...b});const A=await a.getDimensions(l.floating);return R.width!==A.width||R.height!==A.height?{reset:{rects:!0}}:{}}}},E=function(e){return void 0===e&&(e={}),{name:"inline",options:e,async fn(r){var i;const{placement:o,elements:s,rects:u,platform:m,strategy:g}=r,{padding:d=2,x:p,y:h}=e,y=l(m.convertOffsetParentRelativeRectToViewportRelativeRect?await m.convertOffsetParentRelativeRectToViewportRelativeRect({rect:u.reference,offsetParent:await(null==m.getOffsetParent?void 0:m.getOffsetParent(s.floating)),strategy:g}):u.reference),x=null!=(i=await(null==m.getClientRects?void 0:m.getClientRects(s.reference)))?i:[],w=a(d);const v=await m.getElementRects({reference:{getBoundingClientRect:function(){var e;if(2===x.length&&x[0].left>x[1].right&&null!=p&&null!=h)return null!=(e=x.find((t=>p>t.left-w.left&&p<t.right+w.right&&h>t.top-w.top&&h<t.bottom+w.bottom)))?e:y;if(x.length>=2){if("x"===n(o)){const e=x[0],n=x[x.length-1],r="top"===t(o),i=e.top,a=n.bottom,l=r?e.left:n.left,s=r?e.right:n.right;return{top:i,bottom:a,left:l,right:s,width:s-l,height:a-i,x:l,y:i}}const e="left"===t(o),r=f(...x.map((t=>t.right))),i=c(...x.map((t=>t.left))),a=x.filter((t=>e?t.left===i:t.right===r)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:i,right:r,width:r-i,height:s-l,x:i,y:l}}return y}},floating:s.floating,strategy:g});return u.reference.x!==v.reference.x||u.reference.y!==v.reference.y||u.reference.width!==v.reference.width||u.reference.height!==v.reference.height?{reset:{rects:v}}:{}}}};

;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function floating_ui_dom_browser_min_n(t){return t&&t.document&&t.location&&t.alert&&t.setInterval}function o(t){if(null==t)return window;if(!floating_ui_dom_browser_min_n(t)){const e=t.ownerDocument;return e&&e.defaultView||window}return t}function floating_ui_dom_browser_min_i(t){return o(t).getComputedStyle(t)}function floating_ui_dom_browser_min_r(t){return floating_ui_dom_browser_min_n(t)?"":t?(t.nodeName||"").toLowerCase():""}function floating_ui_dom_browser_min_l(){const t=navigator.userAgentData;return null!=t&&t.brands?t.brands.map((t=>t.brand+"/"+t.version)).join(" "):navigator.userAgent}function floating_ui_dom_browser_min_c(t){return t instanceof o(t).HTMLElement}function floating_ui_dom_browser_min_f(t){return t instanceof o(t).Element}function floating_ui_dom_browser_min_s(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof o(t).ShadowRoot||t instanceof ShadowRoot}function floating_ui_dom_browser_min_u(t){const{overflow:e,overflowX:n,overflowY:o}=floating_ui_dom_browser_min_i(t);return/auto|scroll|overlay|hidden/.test(e+o+n)}function floating_ui_dom_browser_min_d(t){return["table","td","th"].includes(floating_ui_dom_browser_min_r(t))}function floating_ui_dom_browser_min_h(t){const e=/firefox/i.test(floating_ui_dom_browser_min_l()),n=floating_ui_dom_browser_min_i(t);return"none"!==n.transform||"none"!==n.perspective||"paint"===n.contain||["transform","perspective"].includes(n.willChange)||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter}function floating_ui_dom_browser_min_a(){return!/^((?!chrome|android).)*safari/i.test(floating_ui_dom_browser_min_l())}const floating_ui_dom_browser_min_g=Math.min,floating_ui_dom_browser_min_p=Math.max,floating_ui_dom_browser_min_m=Math.round;function floating_ui_dom_browser_min_w(t,e,n){var i,r,l,s;void 0===e&&(e=!1),void 0===n&&(n=!1);const u=t.getBoundingClientRect();let d=1,h=1;e&&floating_ui_dom_browser_min_c(t)&&(d=t.offsetWidth>0&&floating_ui_dom_browser_min_m(u.width)/t.offsetWidth||1,h=t.offsetHeight>0&&floating_ui_dom_browser_min_m(u.height)/t.offsetHeight||1);const g=floating_ui_dom_browser_min_f(t)?o(t):window,p=!floating_ui_dom_browser_min_a()&&n,w=(u.left+(p&&null!=(i=null==(r=g.visualViewport)?void 0:r.offsetLeft)?i:0))/d,v=(u.top+(p&&null!=(l=null==(s=g.visualViewport)?void 0:s.offsetTop)?l:0))/h,y=u.width/d,x=u.height/h;return{width:y,height:x,top:v,right:w+y,bottom:v+x,left:w,x:w,y:v}}function floating_ui_dom_browser_min_v(t){return(e=t,(e instanceof o(e).Node?t.ownerDocument:t.document)||window.document).documentElement;var e}function floating_ui_dom_browser_min_y(t){return floating_ui_dom_browser_min_f(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function floating_ui_dom_browser_min_x(t){return floating_ui_dom_browser_min_w(floating_ui_dom_browser_min_v(t)).left+floating_ui_dom_browser_min_y(t).scrollLeft}function floating_ui_dom_browser_min_b(t,e,n){const o=floating_ui_dom_browser_min_c(e),i=floating_ui_dom_browser_min_v(e),l=floating_ui_dom_browser_min_w(t,o&&function(t){const e=floating_ui_dom_browser_min_w(t);return floating_ui_dom_browser_min_m(e.width)!==t.offsetWidth||floating_ui_dom_browser_min_m(e.height)!==t.offsetHeight}(e),"fixed"===n);let f={scrollLeft:0,scrollTop:0};const s={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==floating_ui_dom_browser_min_r(e)||floating_ui_dom_browser_min_u(i))&&(f=floating_ui_dom_browser_min_y(e)),floating_ui_dom_browser_min_c(e)){const t=floating_ui_dom_browser_min_w(e,!0);s.x=t.x+e.clientLeft,s.y=t.y+e.clientTop}else i&&(s.x=floating_ui_dom_browser_min_x(i));return{x:l.left+f.scrollLeft-s.x,y:l.top+f.scrollTop-s.y,width:l.width,height:l.height}}function floating_ui_dom_browser_min_L(t){return"html"===floating_ui_dom_browser_min_r(t)?t:t.assignedSlot||t.parentNode||(floating_ui_dom_browser_min_s(t)?t.host:null)||floating_ui_dom_browser_min_v(t)}function floating_ui_dom_browser_min_R(t){return floating_ui_dom_browser_min_c(t)&&"fixed"!==getComputedStyle(t).position?t.offsetParent:null}function floating_ui_dom_browser_min_T(t){const e=o(t);let n=floating_ui_dom_browser_min_R(t);for(;n&&floating_ui_dom_browser_min_d(n)&&"static"===getComputedStyle(n).position;)n=floating_ui_dom_browser_min_R(n);return n&&("html"===floating_ui_dom_browser_min_r(n)||"body"===floating_ui_dom_browser_min_r(n)&&"static"===getComputedStyle(n).position&&!floating_ui_dom_browser_min_h(n))?e:n||function(t){let e=floating_ui_dom_browser_min_L(t);for(floating_ui_dom_browser_min_s(e)&&(e=e.host);floating_ui_dom_browser_min_c(e)&&!["html","body"].includes(floating_ui_dom_browser_min_r(e));){if(floating_ui_dom_browser_min_h(e))return e;e=e.parentNode}return null}(t)||e}function W(t){if(floating_ui_dom_browser_min_c(t))return{width:t.offsetWidth,height:t.offsetHeight};const e=floating_ui_dom_browser_min_w(t);return{width:e.width,height:e.height}}function floating_ui_dom_browser_min_E(t){const e=floating_ui_dom_browser_min_L(t);return["html","body","#document"].includes(floating_ui_dom_browser_min_r(e))?t.ownerDocument.body:floating_ui_dom_browser_min_c(e)&&floating_ui_dom_browser_min_u(e)?e:floating_ui_dom_browser_min_E(e)}function H(t,e){var n;void 0===e&&(e=[]);const i=floating_ui_dom_browser_min_E(t),r=i===(null==(n=t.ownerDocument)?void 0:n.body),l=o(i),c=r?[l].concat(l.visualViewport||[],floating_ui_dom_browser_min_u(i)?i:[]):i,f=e.concat(c);return r?f:f.concat(H(c))}function C(e,n,r){return"viewport"===n?l(function(t,e){const n=o(t),i=floating_ui_dom_browser_min_v(t),r=n.visualViewport;let l=i.clientWidth,c=i.clientHeight,f=0,s=0;if(r){l=r.width,c=r.height;const t=floating_ui_dom_browser_min_a();(t||!t&&"fixed"===e)&&(f=r.offsetLeft,s=r.offsetTop)}return{width:l,height:c,x:f,y:s}}(e,r)):floating_ui_dom_browser_min_f(n)?function(t,e){const n=floating_ui_dom_browser_min_w(t,!1,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft;return{top:o,left:i,x:i,y:o,right:i+t.clientWidth,bottom:o+t.clientHeight,width:t.clientWidth,height:t.clientHeight}}(n,r):l(function(t){var e;const n=floating_ui_dom_browser_min_v(t),o=floating_ui_dom_browser_min_y(t),r=null==(e=t.ownerDocument)?void 0:e.body,l=floating_ui_dom_browser_min_p(n.scrollWidth,n.clientWidth,r?r.scrollWidth:0,r?r.clientWidth:0),c=floating_ui_dom_browser_min_p(n.scrollHeight,n.clientHeight,r?r.scrollHeight:0,r?r.clientHeight:0);let f=-o.scrollLeft+floating_ui_dom_browser_min_x(t);const s=-o.scrollTop;return"rtl"===floating_ui_dom_browser_min_i(r||n).direction&&(f+=floating_ui_dom_browser_min_p(n.clientWidth,r?r.clientWidth:0)-l),{width:l,height:c,x:f,y:s}}(floating_ui_dom_browser_min_v(e)))}function S(t){const e=H(t),n=["absolute","fixed"].includes(floating_ui_dom_browser_min_i(t).position)&&floating_ui_dom_browser_min_c(t)?floating_ui_dom_browser_min_T(t):t;return floating_ui_dom_browser_min_f(n)?e.filter((t=>floating_ui_dom_browser_min_f(t)&&function(t,e){const n=null==e.getRootNode?void 0:e.getRootNode();if(t.contains(e))return!0;if(n&&floating_ui_dom_browser_min_s(n)){let n=e;do{if(n&&t===n)return!0;n=n.parentNode||n.host}while(n)}return!1}(t,n)&&"body"!==floating_ui_dom_browser_min_r(t))):[]}const floating_ui_dom_browser_min_D={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:o,strategy:i}=t;const r=[..."clippingAncestors"===n?S(e):[].concat(n),o],l=r[0],c=r.reduce(((t,n)=>{const o=C(e,n,i);return t.top=floating_ui_dom_browser_min_p(o.top,t.top),t.right=floating_ui_dom_browser_min_g(o.right,t.right),t.bottom=floating_ui_dom_browser_min_g(o.bottom,t.bottom),t.left=floating_ui_dom_browser_min_p(o.left,t.left),t}),C(e,l,i));return{width:c.right-c.left,height:c.bottom-c.top,x:c.left,y:c.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=floating_ui_dom_browser_min_c(n),l=floating_ui_dom_browser_min_v(n);if(n===l)return e;let f={scrollLeft:0,scrollTop:0};const s={x:0,y:0};if((i||!i&&"fixed"!==o)&&(("body"!==floating_ui_dom_browser_min_r(n)||floating_ui_dom_browser_min_u(l))&&(f=floating_ui_dom_browser_min_y(n)),floating_ui_dom_browser_min_c(n))){const t=floating_ui_dom_browser_min_w(n,!0);s.x=t.x+n.clientLeft,s.y=t.y+n.clientTop}return{...e,x:e.x-f.scrollLeft+s.x,y:e.y-f.scrollTop+s.y}},isElement:floating_ui_dom_browser_min_f,getDimensions:W,getOffsetParent:floating_ui_dom_browser_min_T,getDocumentElement:floating_ui_dom_browser_min_v,getElementRects:t=>{let{reference:e,floating:n,strategy:o}=t;return{reference:floating_ui_dom_browser_min_b(e,floating_ui_dom_browser_min_T(n),o),floating:{...W(n),x:0,y:0}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===floating_ui_dom_browser_min_i(t).direction};function N(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,s=i&&!c,u=r&&!c,d=s||u?[...floating_ui_dom_browser_min_f(t)?H(t):[],...H(e)]:[];d.forEach((t=>{s&&t.addEventListener("scroll",n,{passive:!0}),u&&t.addEventListener("resize",n)}));let h,a=null;l&&(a=new ResizeObserver(n),floating_ui_dom_browser_min_f(t)&&!c&&a.observe(t),a.observe(e));let g=c?floating_ui_dom_browser_min_w(t):null;return c&&function e(){const o=floating_ui_dom_browser_min_w(t);!g||o.x===g.x&&o.y===g.y&&o.width===g.width&&o.height===g.height||n();g=o,h=requestAnimationFrame(e)}(),l||n(),()=>{var t;d.forEach((t=>{s&&t.removeEventListener("scroll",n),u&&t.removeEventListener("resize",n)})),null==(t=a)||t.disconnect(),a=null,c&&cancelAnimationFrame(h)}}const z=(t,n,o)=>floating_ui_core_browser_min_o(t,n,{platform:floating_ui_dom_browser_min_D,...o});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/wrapper.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function wrapper_getPrototypeOf(o1) {
    wrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return wrapper_getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) wrapper_setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function wrapper_setPrototypeOf(o2, p1) {
    wrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return wrapper_setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function wrapper_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function wrapper_createSuper(Derived) {
    var hasNativeReflectConstruct = wrapper_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = wrapper_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = wrapper_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var Wrapper = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Wrapper, _Component);
    var _super = wrapper_createSuper(Wrapper);
    function Wrapper() {
        _classCallCheck(this, Wrapper);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.element = null;
        return _this;
    }
    _createClass(Wrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.componentDidUpdate();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // eslint-disable-next-line
                var node = (0,react_dom.findDOMNode)(this);
                if (_instanceof(node, Element)) {
                    this.element = node;
                } else {
                    this.element = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return react.Children.only(this.props.children);
            }
        }
    ]);
    return Wrapper;
}(react.Component);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/getDocumentOrShadow.js

var checkIfAllInShadow = function checkIfAllInShadow(targets) {
  return targets.every(function (item) {
    var targetElement = getTargetElement(item);
    if (!targetElement) return false;
    if (targetElement.getRootNode() instanceof ShadowRoot) return true;
  });
};
var getShadow = function getShadow(node) {
  if (!node) {
    return document;
  }
  return node.getRootNode();
};
var getDocumentOrShadow = function getDocumentOrShadow(target) {
  if (!target || !document.getRootNode) {
    return document;
  }
  var targets = Array.isArray(target) ? target : [target];
  if (checkIfAllInShadow(targets)) {
    return getShadow(getTargetElement(targets[0]));
  }
  return document;
};
/* harmony default export */ var utils_getDocumentOrShadow = (getDocumentOrShadow);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useClickAway/index.js




function useClickAway(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = 'click';
  }
  var onClickAwayRef = es_useLatest(onClickAway);
  utils_useEffectWithTarget(function () {
    var handler = function handler(event) {
      var targets = Array.isArray(target) ? target : [target];
      if (targets.some(function (item) {
        var targetElement = getTargetElement(item);
        return !targetElement || targetElement.contains(event.target);
      })) {
        return;
      }
      onClickAwayRef.current(event);
    };
    var documentOrShadow = utils_getDocumentOrShadow(target);
    var eventNames = Array.isArray(eventName) ? eventName : [eventName];
    eventNames.forEach(function (event) {
      return documentOrShadow.addEventListener(event, handler);
    });
    return function () {
      eventNames.forEach(function (event) {
        return documentOrShadow.removeEventListener(event, handler);
      });
    };
  }, Array.isArray(eventName) ? eventName : [eventName], target);
}
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/normalize-placement.js
var record = {
    "topLeft": "top-start",
    "topRight": "top-end",
    "bottomLeft": "bottom-start",
    "bottomRight": "bottom-end",
    "leftTop": "left-start",
    "leftBottom": "left-end",
    "rightTop": "right-start",
    "rightBottom": "right-end"
};
function normalizePlacement(placement) {
    var _a;
    return (_a = record[placement]) !== null && _a !== void 0 ? _a : placement;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/convert-px.js



var tenPxTester = null;
var tester = null;
if (can_use_dom_canUseDom) {
    tenPxTester = document.createElement("div");
    tenPxTester.className = "adm-px-tester";
    tenPxTester.style.setProperty("--size", "10");
    document.body.appendChild(tenPxTester);
    tester = document.createElement("div");
    tester.className = "adm-px-tester";
    document.body.appendChild(tester);
    if (is_dev_isDev) {
        if (window.getComputedStyle(tester).position !== "fixed") {
            devError("Global", "The px tester is not rendering properly. Please make sure you have imported `antd-mobile/es/global`.");
        }
    }
}
function convertPx(px) {
    if (tenPxTester === null || tester === null) return px;
    if (tenPxTester.getBoundingClientRect().height === 10) {
        return px;
    }
    tester.style.setProperty("--size", px.toString());
    return tester.getBoundingClientRect().height;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/popover.js
function popover_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function popover_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function popover_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function popover_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function popover_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function popover_slicedToArray(arr, i) {
    return popover_arrayWithHoles(arr) || popover_iterableToArrayLimit(arr, i) || popover_unsupportedIterableToArray(arr, i) || popover_nonIterableRest();
}
function popover_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return popover_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popover_arrayLikeToArray(o, minLen);
}
















var popover_classPrefix = "adm-popover";
var popover_defaultProps = {
    placement: "top",
    defaultVisible: false,
    stopPropagation: [
        "click"
    ],
    getContainer: function() {
        return document.body;
    }
};
var Popover = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var update = function update() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee() {
            var target, floating, arrowElement, _$ref, x, y, realPlacement, middlewareData, side, arrowSide, _$ref2, arrowX, arrowY, arrowRotate;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        target = (_b = (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.element) !== null && _b !== void 0 ? _b : null;
                        floating = floatingRef.current;
                        arrowElement = arrowRef.current;
                        setTargetElement(target);
                        if (!(!target || !floating || !arrowElement)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return z(target, floating, {
                            placement: placement,
                            middleware: [
                                T(convertPx(12)),
                                D({
                                    padding: convertPx(4),
                                    crossAxis: false,
                                    limiter: L()
                                }),
                                b(),
                                P(),
                                m({
                                    element: arrowElement,
                                    padding: convertPx(12)
                                })
                            ]
                        });
                    case 8:
                        _$ref = _ctx.sent;
                        x = _$ref.x;
                        y = _$ref.y;
                        realPlacement = _$ref.placement;
                        middlewareData = _$ref.middlewareData;
                        Object.assign(floating.style, {
                            left: "".concat(x, "px"),
                            top: "".concat(y, "px")
                        });
                        side = realPlacement.split("-")[0];
                        arrowSide = ({
                            top: "bottom",
                            right: "left",
                            bottom: "top",
                            left: "right"
                        })[side];
                        _$ref2 = (_c = middlewareData.arrow) !== null && _c !== void 0 ? _c : {}, arrowX = _$ref2.x, arrowY = _$ref2.y;
                        Object.assign(arrowElement.style, popover_defineProperty({
                            left: arrowX != null ? "".concat(arrowX, "px") : "",
                            top: arrowY != null ? "".concat(arrowY, "px") : "",
                            right: "",
                            bottom: ""
                        }, arrowSide, "-".concat(convertPx(8), "px")));
                        arrowRotate = ({
                            top: "0deg",
                            bottom: "180deg",
                            left: "270deg",
                            right: "90deg"
                        })[side];
                        arrowElement.style.setProperty("--arrow-icon-rotate", arrowRotate);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var props = mergeProps(popover_defaultProps, p);
    var _mode = props.mode, mode = _mode === void 0 ? "light" : _mode;
    var placement = normalizePlacement(props.placement);
    var _$ref3 = popover_slicedToArray(usePropsValue({
        value: props.visible,
        defaultValue: props.defaultVisible,
        onChange: props.onVisibleChange
    }), 2), visible = _$ref3[0], setVisible = _$ref3[1];
    (0,react.useImperativeHandle)(ref, function() {
        return {
            show: function() {
                return setVisible(true);
            },
            hide: function() {
                return setVisible(false);
            },
            visible: visible
        };
    }, [
        visible
    ]);
    var targetRef = (0,react.useRef)(null);
    var floatingRef = (0,react.useRef)(null);
    var arrowRef = (0,react.useRef)(null);
    var floating1 = withStopPropagation(props.stopPropagation, withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(popover_classPrefix, "".concat(popover_classPrefix, "-").concat(mode), !visible && "".concat(popover_classPrefix, "-hidden")),
        ref: floatingRef
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(popover_classPrefix, "-arrow"),
        ref: arrowRef
    }, /*#__PURE__*/ react.createElement(Arrow, {
        className: "".concat(popover_classPrefix, "-arrow-icon")
    })), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(popover_classPrefix, "-inner")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(popover_classPrefix, "-inner-content")
    }, props.content)))));
    var _$ref1 = (0,react.useState)(null), targetElement = _$ref1[0], setTargetElement = _$ref1[1];
    es_useIsomorphicLayoutEffect(function() {
        update();
    });
    (0,react.useEffect)(function() {
        var handleClick = function handleClick() {
            setVisible(function(v) {
                return !v;
            });
        };
        if (!targetElement) return;
        if (!props.trigger) return;
        targetElement.addEventListener("click", handleClick);
        return function() {
            targetElement.removeEventListener("click", handleClick);
        };
    }, [
        targetElement,
        props.trigger
    ]);
    (0,react.useEffect)(function() {
        var floatingElement = floatingRef.current;
        if (!targetElement || !floatingElement) return;
        return N(targetElement, floatingElement, update, {
            elementResize: typeof ResizeObserver !== "undefined"
        });
    }, [
        targetElement
    ]);
    useClickAway(function() {
        if (!props.trigger) return;
        setVisible(false);
    }, function() {
        var _a;
        return (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.element;
    });
    var shouldRender = useShouldRender(visible, false, props.destroyOnHide);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Wrapper, {
        ref: targetRef
    }, props.children), shouldRender && renderToContainer(props.getContainer, floating1));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/popover-menu.js



var popover_menu_classPrefix = "adm-popover-menu";
var PopoverMenu = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var innerRef = (0,react.useRef)(null); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,react.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, []);
    var onClick = (0,react.useCallback)(function(e) {
        var _a;
        var onAction = props.onAction;
        if (onAction) {
            onAction(e);
        }
        (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.hide();
    }, [
        props.onAction
    ]);
    var overlay = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement("div", {
            className: "".concat(popover_menu_classPrefix, "-list")
        }, /*#__PURE__*/ react.createElement("div", {
            className: "".concat(popover_menu_classPrefix, "-list-inner")
        }, props.actions.map(function(action, index) {
            var _a1;
            return /*#__PURE__*/ react.createElement("a", {
                key: (_a1 = action.key) !== null && _a1 !== void 0 ? _a1 : index,
                className: classnames_default()("".concat(popover_menu_classPrefix, "-item"), "adm-plain-anchor", action.disabled && "".concat(popover_menu_classPrefix, "-item-disabled")),
                onClick: function() {
                    var _a;
                    if (action.disabled) return;
                    onClick(action);
                    (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action);
                }
            }, action.icon && /*#__PURE__*/ react.createElement("div", {
                className: "".concat(popover_menu_classPrefix, "-item-icon")
            }, action.icon), /*#__PURE__*/ react.createElement("div", {
                className: "".concat(popover_menu_classPrefix, "-item-text")
            }, action.text));
        })));
    }, [
        props.actions,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Popover, Object.assign({
        ref: innerRef
    }, props, {
        className: classnames_default()(popover_menu_classPrefix, props.className),
        content: overlay
    }), props.children);
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popover/index.js





/* harmony default export */ var components_popover = (attachPropertiesToComponent(Popover, {
    Menu: PopoverMenu
}));

;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/QuestionCircleOutline.js

function QuestionCircleOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "QuestionCircleOutline-QuestionCircleOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "QuestionCircleOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "QuestionCircleOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M24,5 C13.5065898,5 5,13.5065898 5,24 C5,34.4934102 13.5065898,43 24,43 C34.4934102,43 43,34.4934102 43,24 C43,13.5065898 34.4934102,5 24,5 Z M26,32.4 L26,34.6 C26,34.8209139 25.8209139,35 25.6,35 L23.4,35 C23.1790861,35 23,34.8209139 23,34.6 L23,32.4 C23,32.1790861 23.1790861,32 23.4,32 L25.6,32 C25.8209139,32 26,32.1790861 26,32.4 Z M24,12 C27.8659932,12 31,15.1340068 31,19 C31,22.1706393 28.8919961,24.8489278 26.0010432,25.7098107 L26.0001268,28.6 C25.9999299,28.8208643 25.8208644,28.9998731 25.6,29 L23.4,29 C23.1790861,29 23,28.8209139 23,28.6 L23,23.4 C23,23.1790861 23.1790861,23 23.4,23 L24,23 L24,23 C26.209139,23 28,21.209139 28,19 C28,16.790861 26.209139,15 24,15 C21.790861,15 20,16.790861 20,19 L17,19 C17,15.1340068 20.1340068,12 24,12 Z",
        id: "QuestionCircleOutline-\u5F62\u72B6",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_QuestionCircleOutline = (QuestionCircleOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/undefined-fallback.js
function undefinedFallback() {
    for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
        items[_key] = arguments[_key];
    }
    var i;
    for(i = 0; i < items.length; i++){
        if (items[i] !== undefined) break;
    }
    return items[i];
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/form-item.js
function form_item_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function form_item_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return form_item_arrayLikeToArray(arr);
}
function form_item_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function form_item_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function form_item_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function form_item_toConsumableArray(arr) {
    return form_item_arrayWithoutHoles(arr) || form_item_iterableToArray(arr) || form_item_unsupportedIterableToArray(arr) || form_item_nonIterableSpread();
}
function form_item_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return form_item_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return form_item_arrayLikeToArray(o, minLen);
}













var NAME_SPLIT = "__SPLIT__";
var form_item_classPrefix = "adm-form-item";
var MemoInput = /*#__PURE__*/ react.memo(function(param) {
    var children = param.children;
    return children;
}, function(prev, next) {
    return prev.value === next.value && prev.update === next.update;
});
var FormItemLayout = function(props) {
    var _a;
    var className = props.className, style = props.style, extra = props.extra, label = props.label, help = props.help, required = props.required, children = props.children, htmlFor = props.htmlFor, hidden = props.hidden, arrow = props.arrow, _childElementPosition = props.childElementPosition, childElementPosition = _childElementPosition === void 0 ? "normal" : _childElementPosition;
    var context = (0,react.useContext)(context_FormContext);
    var locale = useConfig().locale;
    var hasFeedback = props.hasFeedback !== undefined ? props.hasFeedback : context.hasFeedback;
    var layout = props.layout || context.layout;
    var disabled = (_a = props.disabled) !== null && _a !== void 0 ? _a : context.disabled;
    var requiredMark = function() {
        var requiredMarkStyle = context.requiredMarkStyle;
        switch(requiredMarkStyle){
            case "asterisk":
                return required && /*#__PURE__*/ react.createElement("span", {
                    className: "".concat(form_item_classPrefix, "-required-asterisk")
                }, "*");
            case "text-required":
                return required && /*#__PURE__*/ react.createElement("span", {
                    className: "".concat(form_item_classPrefix, "-required-text")
                }, "(", locale.Form.required, ")");
            case "text-optional":
                return !required && /*#__PURE__*/ react.createElement("span", {
                    className: "".concat(form_item_classPrefix, "-required-text")
                }, "(", locale.Form.optional, ")");
            default:
                return null;
        }
    }();
    var labelElement = label ? /*#__PURE__*/ react.createElement("label", {
        className: "".concat(form_item_classPrefix, "-label"),
        htmlFor: htmlFor
    }, label, requiredMark, help && /*#__PURE__*/ react.createElement(components_popover, {
        content: help,
        mode: "dark",
        trigger: "click"
    }, /*#__PURE__*/ react.createElement("span", {
        className: "".concat(form_item_classPrefix, "-label-help"),
        onClick: function(e) {
            e.preventDefault();
        }
    }, /*#__PURE__*/ react.createElement(es_QuestionCircleOutline, null)))) : null;
    var description = props.description || hasFeedback ? /*#__PURE__*/ react.createElement(react.Fragment, null, props.description, hasFeedback && /*#__PURE__*/ react.createElement(react.Fragment, null, props.errors.map(function(error, index) {
        return /*#__PURE__*/ react.createElement("div", {
            key: "error-".concat(index),
            className: "".concat(form_item_classPrefix, "-feedback-error")
        }, error);
    }), props.warnings.map(function(warning, index) {
        return /*#__PURE__*/ react.createElement("div", {
            key: "warning-".concat(index),
            className: "".concat(form_item_classPrefix, "-feedback-warning")
        }, warning);
    }))) : null;
    var _obj;
    return /*#__PURE__*/ react.createElement(components_list.Item, {
        style: style,
        title: layout === "vertical" && labelElement,
        prefix: layout === "horizontal" && labelElement,
        extra: extra,
        description: description,
        className: classnames_default()(form_item_classPrefix, className, "".concat(form_item_classPrefix, "-").concat(layout), (_obj = {}, form_item_defineProperty(_obj, "".concat(form_item_classPrefix, "-hidden"), hidden), form_item_defineProperty(_obj, "".concat(form_item_classPrefix, "-has-error"), props.errors.length), _obj)),
        disabled: disabled,
        onClick: props.onClick,
        clickable: props.clickable,
        arrow: arrow
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(form_item_classPrefix, "-child"), "".concat(form_item_classPrefix, "-child-position-").concat(childElementPosition))
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(form_item_classPrefix, "-child-inner"))
    }, children)));
};
var FormItem = function(props) {
    var renderLayout = function renderLayout(baseChildren, fieldId, meta, isRequired) {
        var _a1, _b1;
        if (noStyle && !hidden) {
            return baseChildren;
        }
        var curErrors = (_a1 = meta === null || meta === void 0 ? void 0 : meta.errors) !== null && _a1 !== void 0 ? _a1 : [];
        var errors1 = Object.keys(subMetas).reduce(function(subErrors, key) {
            var _a, _b;
            var errors = (_b = (_a = subMetas[key]) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
            if (errors.length) {
                subErrors = form_item_toConsumableArray(subErrors).concat(form_item_toConsumableArray(errors));
            }
            return subErrors;
        }, curErrors);
        var curWarnings = (_b1 = meta === null || meta === void 0 ? void 0 : meta.warnings) !== null && _b1 !== void 0 ? _b1 : [];
        var warnings1 = Object.keys(subMetas).reduce(function(subWarnings, key) {
            var _a, _b;
            var warnings = (_b = (_a = subMetas[key]) === null || _a === void 0 ? void 0 : _a.warnings) !== null && _b !== void 0 ? _b : [];
            if (warnings.length) {
                subWarnings = form_item_toConsumableArray(subWarnings).concat(form_item_toConsumableArray(warnings));
            }
            return subWarnings;
        }, curWarnings);
        return /*#__PURE__*/ react.createElement(FormItemLayout, {
            className: className,
            style: style,
            label: label,
            extra: extra,
            help: help,
            description: description,
            required: isRequired,
            disabled: disabled,
            hasFeedback: hasFeedback,
            htmlFor: fieldId,
            errors: errors1,
            warnings: warnings1,
            onClick: onClick && function(e) {
                return onClick(e, widgetRef);
            },
            hidden: hidden,
            layout: layout,
            childElementPosition: childElementPosition,
            clickable: clickable,
            arrow: arrow
        }, /*#__PURE__*/ react.createElement(NoStyleItemContext.Provider, {
            value: onSubMetaChange
        }, baseChildren));
    };
    var // 样式相关
    className = props.className, style = props.style, // FormItem 相关
    label = props.label, help = props.help, extra = props.extra, hasFeedback = props.hasFeedback, name = props.name, required = props.required, noStyle = props.noStyle, hidden = props.hidden, layout = props.layout, childElementPosition = props.childElementPosition, description = props.description, // Field 相关
    disabled = props.disabled, rules = props.rules, children = props.children, messageVariables = props.messageVariables, _trigger = props.trigger, trigger = _trigger === void 0 ? "onChange" : _trigger, _validateTrigger = props.validateTrigger, validateTrigger = _validateTrigger === void 0 ? trigger : _validateTrigger, onClick = props.onClick, shouldUpdate = props.shouldUpdate, dependencies = props.dependencies, clickable = props.clickable, arrow = props.arrow, fieldProps = tslib_es6_rest(props, [
        "className",
        "style",
        "label",
        "help",
        "extra",
        "hasFeedback",
        "name",
        "required",
        "noStyle",
        "hidden",
        "layout",
        "childElementPosition",
        "description",
        "disabled",
        "rules",
        "children",
        "messageVariables",
        "trigger",
        "validateTrigger",
        "onClick",
        "shouldUpdate",
        "dependencies",
        "clickable",
        "arrow"
    ]);
    var ref = (0,react.useContext)(context_FormContext), formName = ref.name;
    var ref1 = (0,react.useContext)(lib_FieldContext/* default */.ZP), contextValidateTrigger = ref1.validateTrigger;
    var mergedValidateTrigger = undefinedFallback(validateTrigger, contextValidateTrigger, trigger);
    var widgetRef = (0,react.useRef)(null);
    var updateRef = (0,react.useRef)(0);
    updateRef.current += 1;
    var ref2 = (0,react.useState)({}), subMetas = ref2[0], setSubMetas = ref2[1];
    var onSubMetaChange = (0,react.useCallback)(function(subMeta, namePath) {
        setSubMetas(function(prevSubMetas) {
            var nextSubMetas = Object.assign({}, prevSubMetas);
            var nameKey = namePath.join(NAME_SPLIT);
            if (subMeta.destroy) {
                delete nextSubMetas[nameKey];
            } else {
                nextSubMetas[nameKey] = subMeta;
            }
            return nextSubMetas;
        });
    }, [
        setSubMetas
    ]);
    var isRenderProps = typeof children === "function";
    if (!name && !isRenderProps && !props.dependencies) {
        return renderLayout(children);
    }
    var Variables = {};
    Variables.label = typeof label === "string" ? label : "";
    if (messageVariables) {
        Variables = Object.assign(Object.assign({}, Variables), messageVariables);
    }
    var notifyParentMetaChange = (0,react.useContext)(NoStyleItemContext);
    var onMetaChange = function(meta) {
        if (noStyle && notifyParentMetaChange) {
            var namePath = meta.name;
            notifyParentMetaChange(meta, namePath);
        }
    };
    return /*#__PURE__*/ react.createElement(es_Field, Object.assign({}, fieldProps, {
        name: name,
        shouldUpdate: shouldUpdate,
        dependencies: dependencies,
        rules: rules,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange,
        messageVariables: Variables
    }), function(control, meta, context) {
        var childNode = null;
        var isRequired = required !== undefined ? required : rules && rules.some(function(rule) {
            return !!(rule && typeof rule === "object" && rule.required);
        });
        var nameList = utils_toArray(name).length && meta ? meta.name : [];
        var fieldId = (nameList.length > 0 && formName ? [
            formName
        ].concat(form_item_toConsumableArray(nameList)) : nameList).join("_");
        if (shouldUpdate && dependencies) {
            devWarning("Form.Item", "`shouldUpdate` and `dependencies` shouldn't be used together.");
        }
        if (isRenderProps) {
            if ((shouldUpdate || dependencies) && !name) {
                childNode = children(context);
            } else {
                if (!(shouldUpdate || dependencies)) {
                    devWarning("Form.Item", "`children` of render props only work with `shouldUpdate` or `dependencies`.");
                }
                if (name) {
                    devWarning("Form.Item", "Do not use `name` with `children` of render props since it's not a field.");
                }
            } // not render props
        } else if (dependencies && !name) {
            devWarning("Form.Item", "Must set `name` or use render props when `dependencies` is set.");
        } else if (/*#__PURE__*/ react.isValidElement(children)) {
            if (children.props.defaultValue) {
                devWarning("Form.Item", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
            }
            var childProps = Object.assign(Object.assign({}, children.props), control);
            if (isSafeSetRefComponent(children)) {
                childProps.ref = function(instance) {
                    var originRef = children.ref;
                    if (originRef) {
                        if (typeof originRef === "function") {
                            originRef(instance);
                        }
                        if ("current" in originRef) {
                            originRef.current = instance;
                        }
                    }
                    widgetRef.current = instance;
                };
            }
            if (!childProps.id) {
                childProps.id = fieldId;
            } // We should keep user origin event handler
            var triggers = new Set(form_item_toConsumableArray(utils_toArray(trigger)).concat(form_item_toConsumableArray(utils_toArray(mergedValidateTrigger))));
            triggers.forEach(function(eventName) {
                childProps[eventName] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var __a, __c;
                    var _a, _b, _c;
                    (_a = control[eventName]) === null || _a === void 0 ? void 0 : (__a = _a).call.apply(__a, [
                        control
                    ].concat(form_item_toConsumableArray(args)));
                    (_c = (_b = children.props)[eventName]) === null || _c === void 0 ? void 0 : (__c = _c).call.apply(__c, [
                        _b
                    ].concat(form_item_toConsumableArray(args)));
                };
            });
            childNode = /*#__PURE__*/ react.createElement(MemoInput, {
                value: control[props.valuePropName || "value"],
                update: updateRef.current
            }, /*#__PURE__*/ react.cloneElement(children, childProps));
        } else {
            if (name) {
                devWarning("Form.Item", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.");
            }
            childNode = children;
        }
        return renderLayout(childNode, fieldId, meta, isRequired);
    });
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/form-subscribe.js




var FormSubscribe = function(props) {
    var update = es_useUpdate();
    var form = (0,react.useContext)(FieldContext);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, props.children(form.getFieldsValue(props.to), form), props.to.map(function(namePath) {
        return /*#__PURE__*/ react.createElement(Watcher, {
            key: namePath.toString(),
            form: form,
            namePath: namePath,
            onChange: update
        });
    }));
};
var Watcher = /*#__PURE__*/ (0,react.memo)(function(props) {
    var value = es_useWatch(props.namePath, props.form);
    useIsomorphicUpdateLayoutEffect(function() {
        props.onChange();
    }, [
        value
    ]);
    return null;
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/form/index.js








/* harmony default export */ var es_components_form = (attachPropertiesToComponent(form_Form, {
    Item: FormItem,
    Subscribe: FormSubscribe,
    Header: Header,
    Array: FormArray,
    useForm: es_useForm,
    useWatch: es_useWatch
}));

;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/AddOutline.js

function AddOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "AddOutline-AddOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "AddOutline-add"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "AddOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M25.1,6.5 C25.3209139,6.5 25.5,6.6790861 25.5,6.9 L25.5,22.5 L41.1,22.5 C41.3209139,22.5 41.5,22.6790861 41.5,22.9 L41.5,25.1 C41.5,25.3209139 41.3209139,25.5 41.1,25.5 L25.5,25.5 L25.5,41.1 C25.5,41.3209139 25.3209139,41.5 25.1,41.5 L22.9,41.5 C22.6790861,41.5 22.5,41.3209139 22.5,41.1 L22.5,25.5 L6.9,25.5 C6.6790861,25.5 6.5,25.3209139 6.5,25.1 L6.5,22.9 C6.5,22.6790861 6.6790861,22.5 6.9,22.5 L22.5,22.5 L22.5,6.9 C22.5,6.6790861 22.6790861,6.5 22.9,6.5 L25.1,6.5 Z",
        id: "AddOutline-\u8DEF\u5F84",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_AddOutline = (AddOutline);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/image-viewer/image-viewer.css
var image_viewer = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/safe-area/safe-area.css
var safe_area = __webpack_require__(19763);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/safe-area/safe-area.js



var safe_area_classPrefix = "adm-safe-area";
var SafeArea = function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(safe_area_classPrefix, "".concat(safe_area_classPrefix, "-position-").concat(props.position))
    }));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/safe-area/index.js


/* harmony default export */ var components_safe_area = (SafeArea);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/bound.js
function bound(position, min, max) {
    var ret = position;
    if (min !== undefined) {
        ret = Math.max(position, min);
    }
    if (max !== undefined) {
        ret = Math.min(ret, max);
    }
    return ret;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/rubberband.js

function rubberband(distance, dimension, constant) {
    return distance * dimension * constant / (dimension + constant * distance);
}
function rubberbandIfOutOfBounds(position, min, max, dimension) {
    var constant = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.15;
    if (constant === 0) return bound(position, min, max);
    if (position < min) return -rubberband(min - position, dimension, constant) + min;
    if (position > max) return +rubberband(position - max, dimension, constant) + max;
    return position;
}

;// CONCATENATED MODULE: ./node_modules/@use-gesture/core/dist/maths-b2a210f4.esm.js
function clamp(v, min, max) {
  return Math.max(min, Math.min(v, max));
}
const V = {
  toVector(v, fallback) {
    if (v === undefined) v = fallback;
    return Array.isArray(v) ? v : [v, v];
  },

  add(v1, v2) {
    return [v1[0] + v2[0], v1[1] + v2[1]];
  },

  sub(v1, v2) {
    return [v1[0] - v2[0], v1[1] - v2[1]];
  },

  addTo(v1, v2) {
    v1[0] += v2[0];
    v1[1] += v2[1];
  },

  subTo(v1, v2) {
    v1[0] -= v2[0];
    v1[1] -= v2[1];
  }

};

function maths_b2a210f4_esm_rubberband(distance, dimension, constant) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
  return distance * dimension * constant / (dimension + constant * distance);
}

function maths_b2a210f4_esm_rubberbandIfOutOfBounds(position, min, max, constant = 0.15) {
  if (constant === 0) return clamp(position, min, max);
  if (position < min) return -maths_b2a210f4_esm_rubberband(min - position, max - min, constant) + min;
  if (position > max) return +maths_b2a210f4_esm_rubberband(position - max, max - min, constant) + max;
  return position;
}
function computeRubberband(bounds, [Vx, Vy], [Rx, Ry]) {
  const [[X0, X1], [Y0, Y1]] = bounds;
  return [maths_b2a210f4_esm_rubberbandIfOutOfBounds(Vx, X0, X1, Rx), maths_b2a210f4_esm_rubberbandIfOutOfBounds(Vy, Y0, Y1, Ry)];
}



;// CONCATENATED MODULE: ./node_modules/@use-gesture/core/dist/actions-1416bf77.esm.js


function actions_1416bf77_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      actions_1416bf77_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

const EVENT_TYPE_MAP = {
  pointer: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  mouse: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  touch: {
    start: 'start',
    change: 'move',
    end: 'end'
  },
  gesture: {
    start: 'start',
    change: 'change',
    end: 'end'
  }
};

function capitalize(string) {
  if (!string) return '';
  return string[0].toUpperCase() + string.slice(1);
}

const actionsWithoutCaptureSupported = ['enter', 'leave'];

function hasCapture(capture = false, actionKey) {
  return capture && !actionsWithoutCaptureSupported.includes(actionKey);
}

function toHandlerProp(device, action = '', capture = false) {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return 'on' + capitalize(device) + capitalize(actionKey) + (hasCapture(capture, actionKey) ? 'Capture' : '');
}
const pointerCaptureEvents = ['gotpointercapture', 'lostpointercapture'];
function parseProp(prop) {
  let eventKey = prop.substring(2).toLowerCase();
  const passive = !!~eventKey.indexOf('passive');
  if (passive) eventKey = eventKey.replace('passive', '');
  const captureKey = pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
  const capture = !!~eventKey.indexOf(captureKey);
  if (capture) eventKey = eventKey.replace('capture', '');
  return {
    device: eventKey,
    capture,
    passive
  };
}
function toDomEventType(device, action = '') {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return device + actionKey;
}
function isTouch(event) {
  return 'touches' in event;
}
function getPointerType(event) {
  if (isTouch(event)) return 'touch';
  if ('pointerType' in event) return event.pointerType;
  return 'mouse';
}

function getCurrentTargetTouchList(event) {
  return Array.from(event.touches).filter(e => {
    var _event$currentTarget, _event$currentTarget$;

    return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
  });
}

function getTouchList(event) {
  return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}

function getValueEvent(event) {
  return isTouch(event) ? getTouchList(event)[0] : event;
}

function distanceAngle(P1, P2) {
  const dx = P2.clientX - P1.clientX;
  const dy = P2.clientY - P1.clientY;
  const cx = (P2.clientX + P1.clientX) / 2;
  const cy = (P2.clientY + P1.clientY) / 2;
  const distance = Math.hypot(dx, dy);
  const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
  const origin = [cx, cy];
  return {
    angle,
    distance,
    origin
  };
}
function touchIds(event) {
  return getCurrentTargetTouchList(event).map(touch => touch.identifier);
}
function touchDistanceAngle(event, ids) {
  const [P1, P2] = Array.from(event.touches).filter(touch => ids.includes(touch.identifier));
  return distanceAngle(P1, P2);
}
function pointerId(event) {
  const valueEvent = getValueEvent(event);
  return isTouch(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function pointerValues(event) {
  const valueEvent = getValueEvent(event);
  return [valueEvent.clientX, valueEvent.clientY];
}
const LINE_HEIGHT = 40;
const PAGE_HEIGHT = 800;
function wheelValues(event) {
  let {
    deltaX,
    deltaY,
    deltaMode
  } = event;

  if (deltaMode === 1) {
    deltaX *= LINE_HEIGHT;
    deltaY *= LINE_HEIGHT;
  } else if (deltaMode === 2) {
    deltaX *= PAGE_HEIGHT;
    deltaY *= PAGE_HEIGHT;
  }

  return [deltaX, deltaY];
}
function scrollValues(event) {
  var _ref, _ref2;

  const {
    scrollX,
    scrollY,
    scrollLeft,
    scrollTop
  } = event.currentTarget;
  return [(_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0, (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0];
}
function getEventDetails(event) {
  const payload = {};
  if ('buttons' in event) payload.buttons = event.buttons;

  if ('shiftKey' in event) {
    const {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    } = event;
    Object.assign(payload, {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    });
  }

  return payload;
}

function actions_1416bf77_esm_call(v, ...args) {
  if (typeof v === 'function') {
    return v(...args);
  } else {
    return v;
  }
}
function actions_1416bf77_esm_noop() {}
function chain(...fns) {
  if (fns.length === 0) return actions_1416bf77_esm_noop;
  if (fns.length === 1) return fns[0];
  return function () {
    let result;

    for (const fn of fns) {
      result = fn.apply(this, arguments) || result;
    }

    return result;
  };
}
function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}

const BEFORE_LAST_KINEMATICS_DELAY = 32;
class Engine {
  constructor(ctrl, args, key) {
    this.ctrl = ctrl;
    this.args = args;
    this.key = key;

    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init) this.init();
      this.reset();
    }
  }

  get state() {
    return this.ctrl.state[this.key];
  }

  set state(state) {
    this.ctrl.state[this.key] = state;
  }

  get shared() {
    return this.ctrl.state.shared;
  }

  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }

  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }

  get config() {
    return this.ctrl.config[this.key];
  }

  get sharedConfig() {
    return this.ctrl.config.shared;
  }

  get handler() {
    return this.ctrl.handlers[this.key];
  }

  reset() {
    const {
      state,
      shared,
      ingKey,
      args
    } = this;
    shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
    state._step = [false, false];
    state.intentional = false;
    state._movement = [0, 0];
    state._distance = [0, 0];
    state._direction = [0, 0];
    state._delta = [0, 0];
    state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
    state.args = args;
    state.axis = undefined;
    state.memo = undefined;
    state.elapsedTime = 0;
    state.direction = [0, 0];
    state.distance = [0, 0];
    state.overflow = [0, 0];
    state._movementBound = [false, false];
    state.velocity = [0, 0];
    state.movement = [0, 0];
    state.delta = [0, 0];
    state.timeStamp = 0;
  }

  start(event) {
    const state = this.state;
    const config = this.config;

    if (!state._active) {
      this.reset();
      this.computeInitial();
      state._active = true;
      state.target = event.target;
      state.currentTarget = event.currentTarget;
      state.lastOffset = config.from ? actions_1416bf77_esm_call(config.from, state) : state.offset;
      state.offset = state.lastOffset;
    }

    state.startTime = state.timeStamp = event.timeStamp;
  }

  computeValues(values) {
    const state = this.state;
    state._values = values;
    state.values = this.config.transform(values);
  }

  computeInitial() {
    const state = this.state;
    state._initial = state._values;
    state.initial = state.values;
  }

  compute(event) {
    const {
      state,
      config,
      shared
    } = this;
    state.args = this.args;
    let dt = 0;

    if (event) {
      state.event = event;
      if (config.preventDefault && event.cancelable) state.event.preventDefault();
      state.type = event.type;
      shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
      shared.locked = !!document.pointerLockElement;
      Object.assign(shared, getEventDetails(event));
      shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
      dt = event.timeStamp - state.timeStamp;
      state.timeStamp = event.timeStamp;
      state.elapsedTime = state.timeStamp - state.startTime;
    }

    if (state._active) {
      const _absoluteDelta = state._delta.map(Math.abs);

      V.addTo(state._distance, _absoluteDelta);
    }

    if (this.axisIntent) this.axisIntent(event);
    const [_m0, _m1] = state._movement;
    const [t0, t1] = config.threshold;
    const {
      _step,
      values
    } = state;

    if (config.hasCustomTransform) {
      if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
      if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
    } else {
      if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
      if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
    }

    state.intentional = _step[0] !== false || _step[1] !== false;
    if (!state.intentional) return;
    const movement = [0, 0];

    if (config.hasCustomTransform) {
      const [v0, v1] = values;
      movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
    } else {
      movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
    }

    if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
    const previousOffset = state.offset;
    const gestureIsActive = state._active && !state._blocked || state.active;

    if (gestureIsActive) {
      state.first = state._active && !state.active;
      state.last = !state._active && state.active;
      state.active = shared[this.ingKey] = state._active;

      if (event) {
        if (state.first) {
          if ('bounds' in config) state._bounds = actions_1416bf77_esm_call(config.bounds, state);
          if (this.setup) this.setup();
        }

        state.movement = movement;
        this.computeOffset();
      }
    }

    const [ox, oy] = state.offset;
    const [[x0, x1], [y0, y1]] = state._bounds;
    state.overflow = [ox < x0 ? -1 : ox > x1 ? 1 : 0, oy < y0 ? -1 : oy > y1 ? 1 : 0];
    state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
    state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
    const rubberband = state._active ? config.rubberband || [0, 0] : [0, 0];
    state.offset = computeRubberband(state._bounds, state.offset, rubberband);
    state.delta = V.sub(state.offset, previousOffset);
    this.computeMovement();

    if (gestureIsActive && (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY)) {
      state.delta = V.sub(state.offset, previousOffset);
      const absoluteDelta = state.delta.map(Math.abs);
      V.addTo(state.distance, absoluteDelta);
      state.direction = state.delta.map(Math.sign);
      state._direction = state._delta.map(Math.sign);

      if (!state.first && dt > 0) {
        state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
      }
    }
  }

  emit() {
    const state = this.state;
    const shared = this.shared;
    const config = this.config;
    if (!state._active) this.clean();
    if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
    const memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, {
      [this.aliasKey]: state.values
    }));
    if (memo !== undefined) state.memo = memo;
  }

  clean() {
    this.eventStore.clean();
    this.timeoutStore.clean();
  }

}

function selectAxis([dx, dy], threshold) {
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);

  if (absDx > absDy && absDx > threshold) {
    return 'x';
  }

  if (absDy > absDx && absDy > threshold) {
    return 'y';
  }

  return undefined;
}

class CoordinatesEngine extends Engine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "aliasKey", 'xy');
  }

  reset() {
    super.reset();
    this.state.axis = undefined;
  }

  init() {
    this.state.offset = [0, 0];
    this.state.lastOffset = [0, 0];
  }

  computeOffset() {
    this.state.offset = V.add(this.state.lastOffset, this.state.movement);
  }

  computeMovement() {
    this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
  }

  axisIntent(event) {
    const state = this.state;
    const config = this.config;

    if (!state.axis && event) {
      const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[getPointerType(event)] : config.axisThreshold;
      state.axis = selectAxis(state._movement, threshold);
    }

    state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
  }

  restrictToAxis(v) {
    if (this.config.axis || this.config.lockDirection) {
      switch (this.state.axis) {
        case 'x':
          v[1] = 0;
          break;

        case 'y':
          v[0] = 0;
          break;
      }
    }
  }

}

const identity = v => v;
const DEFAULT_RUBBERBAND = 0.15;
const commonConfigResolver = {
  enabled(value = true) {
    return value;
  },

  eventOptions(value, _k, config) {
    return _objectSpread2(_objectSpread2({}, config.shared.eventOptions), value);
  },

  preventDefault(value = false) {
    return value;
  },

  triggerAllEvents(value = false) {
    return value;
  },

  rubberband(value = 0) {
    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];

      case false:
        return [0, 0];

      default:
        return V.toVector(value);
    }
  },

  from(value) {
    if (typeof value === 'function') return value;
    if (value != null) return V.toVector(value);
  },

  transform(value, _k, config) {
    const transform = value || config.shared.transform;
    this.hasCustomTransform = !!transform;

    if (false) {}

    return transform || identity;
  },

  threshold(value) {
    return V.toVector(value, 0);
  }

};

if (false) {}

const DEFAULT_AXIS_THRESHOLD = 0;
const coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis(_v, _k, {
    axis
  }) {
    this.lockDirection = axis === 'lock';
    if (!this.lockDirection) return axis;
  },

  axisThreshold(value = DEFAULT_AXIS_THRESHOLD) {
    return value;
  },

  bounds(value = {}) {
    if (typeof value === 'function') {
      return state => coordinatesConfigResolver.bounds(value(state));
    }

    if ('current' in value) {
      return () => value.current;
    }

    if (typeof HTMLElement === 'function' && value instanceof HTMLElement) {
      return value;
    }

    const {
      left = -Infinity,
      right = Infinity,
      top = -Infinity,
      bottom = Infinity
    } = value;
    return [[left, right], [top, bottom]];
  }

});

const DISPLACEMENT = 10;
const KEYS_DELTA_MAP = {
  ArrowRight: (factor = 1) => [DISPLACEMENT * factor, 0],
  ArrowLeft: (factor = 1) => [-DISPLACEMENT * factor, 0],
  ArrowUp: (factor = 1) => [0, -DISPLACEMENT * factor],
  ArrowDown: (factor = 1) => [0, DISPLACEMENT * factor]
};
class DragEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'dragging');
  }

  reset() {
    super.reset();
    const state = this.state;
    state._pointerId = undefined;
    state._pointerActive = false;
    state._keyboardActive = false;
    state._preventScroll = false;
    state._delayed = false;
    state.swipe = [0, 0];
    state.tap = false;
    state.canceled = false;
    state.cancel = this.cancel.bind(this);
  }

  setup() {
    const state = this.state;

    if (state._bounds instanceof HTMLElement) {
      const boundRect = state._bounds.getBoundingClientRect();

      const targetRect = state.currentTarget.getBoundingClientRect();
      const _bounds = {
        left: boundRect.left - targetRect.left + state.offset[0],
        right: boundRect.right - targetRect.right + state.offset[0],
        top: boundRect.top - targetRect.top + state.offset[1],
        bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
      };
      state._bounds = coordinatesConfigResolver.bounds(_bounds);
    }
  }

  cancel() {
    const state = this.state;
    if (state.canceled) return;
    state.canceled = true;
    state._active = false;
    setTimeout(() => {
      this.compute();
      this.emit();
    }, 0);
  }

  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }

  clean() {
    this.pointerClean();
    this.state._pointerActive = false;
    this.state._keyboardActive = false;
    super.clean();
  }

  pointerDown(event) {
    const config = this.config;
    const state = this.state;
    if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
    const ctrlIds = this.ctrl.setEventIds(event);

    if (config.pointerCapture) {
      event.target.setPointerCapture(event.pointerId);
    }

    if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
    this.start(event);
    this.setupPointer(event);
    state._pointerId = pointerId(event);
    state._pointerActive = true;
    this.computeValues(pointerValues(event));
    this.computeInitial();

    if (config.preventScrollAxis && getPointerType(event) !== 'mouse') {
      state._active = false;
      this.setupScrollPrevention(event);
    } else if (config.delay > 0) {
      this.setupDelayTrigger(event);

      if (config.triggerAllEvents) {
        this.compute(event);
        this.emit();
      }
    } else {
      this.startPointerDrag(event);
    }
  }

  startPointerDrag(event) {
    const state = this.state;
    state._active = true;
    state._preventScroll = true;
    state._delayed = false;
    this.compute(event);
    this.emit();
  }

  pointerMove(event) {
    const state = this.state;
    const config = this.config;
    if (!state._pointerActive) return;
    if (state.type === event.type && event.timeStamp === state.timeStamp) return;
    const id = pointerId(event);
    if (state._pointerId !== undefined && id !== state._pointerId) return;

    const _values = pointerValues(event);

    if (document.pointerLockElement === event.target) {
      state._delta = [event.movementX, event.movementY];
    } else {
      state._delta = V.sub(_values, state._values);
      this.computeValues(_values);
    }

    V.addTo(state._movement, state._delta);
    this.compute(event);

    if (state._delayed && state.intentional) {
      this.timeoutStore.remove('dragDelay');
      state.active = false;
      this.startPointerDrag(event);
      return;
    }

    if (config.preventScrollAxis && !state._preventScroll) {
      if (state.axis) {
        if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
          state._active = false;
          this.clean();
          return;
        } else {
          this.timeoutStore.remove('startPointerDrag');
          this.startPointerDrag(event);
          return;
        }
      } else {
        return;
      }
    }

    this.emit();
  }

  pointerUp(event) {
    this.ctrl.setEventIds(event);

    try {
      if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) {
        ;
        event.target.releasePointerCapture(event.pointerId);
      }
    } catch (_unused) {
      if (false) {}
    }

    const state = this.state;
    const config = this.config;
    if (!state._active || !state._pointerActive) return;
    const id = pointerId(event);
    if (state._pointerId !== undefined && id !== state._pointerId) return;
    this.state._pointerActive = false;
    this.setActive();
    this.compute(event);
    const [dx, dy] = state._distance;
    state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;

    if (state.tap && config.filterTaps) {
      state._force = true;
    } else {
      const [dirx, diry] = state.direction;
      const [vx, vy] = state.velocity;
      const [mx, my] = state.movement;
      const [svx, svy] = config.swipe.velocity;
      const [sx, sy] = config.swipe.distance;
      const sdt = config.swipe.duration;

      if (state.elapsedTime < sdt) {
        if (Math.abs(vx) > svx && Math.abs(mx) > sx) state.swipe[0] = dirx;
        if (Math.abs(vy) > svy && Math.abs(my) > sy) state.swipe[1] = diry;
      }
    }

    this.emit();
  }

  pointerClick(event) {
    if (!this.state.tap) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  setupPointer(event) {
    const config = this.config;
    const device = config.device;

    if (false) {}

    if (config.pointerLock) {
      event.currentTarget.requestPointerLock();
    }

    if (!config.pointerCapture) {
      this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
    }
  }

  pointerClean() {
    if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
      document.exitPointerLock();
    }
  }

  preventScroll(event) {
    if (this.state._preventScroll && event.cancelable) {
      event.preventDefault();
    }
  }

  setupScrollPrevention(event) {
    this.state._preventScroll = false;
    persistEvent(event);
    const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
      passive: false
    });
    this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
    this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
    this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
  }

  setupDelayTrigger(event) {
    this.state._delayed = true;
    this.timeoutStore.add('dragDelay', () => {
      this.state._step = [0, 0];
      this.startPointerDrag(event);
    }, this.config.delay);
  }

  keyDown(event) {
    const deltaFn = KEYS_DELTA_MAP[event.key];

    if (deltaFn) {
      const state = this.state;
      const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
      this.start(event);
      state._delta = deltaFn(factor);
      state._keyboardActive = true;
      V.addTo(state._movement, state._delta);
      this.compute(event);
      this.emit();
    }
  }

  keyUp(event) {
    if (!(event.key in KEYS_DELTA_MAP)) return;
    this.state._keyboardActive = false;
    this.setActive();
    this.compute(event);
    this.emit();
  }

  bind(bindFunction) {
    const device = this.config.device;
    bindFunction(device, 'start', this.pointerDown.bind(this));

    if (this.config.pointerCapture) {
      bindFunction(device, 'change', this.pointerMove.bind(this));
      bindFunction(device, 'end', this.pointerUp.bind(this));
      bindFunction(device, 'cancel', this.pointerUp.bind(this));
      bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
    }

    bindFunction('key', 'down', this.keyDown.bind(this));
    bindFunction('key', 'up', this.keyUp.bind(this));

    if (this.config.filterTaps) {
      bindFunction('click', '', this.pointerClick.bind(this), {
        capture: true,
        passive: false
      });
    }
  }

}

function persistEvent(event) {
  'persist' in event && typeof event.persist === 'function' && event.persist();
}

const actions_1416bf77_esm_isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;

function supportsTouchEvents() {
  return actions_1416bf77_esm_isBrowser && 'ontouchstart' in window;
}

function isTouchScreen() {
  return supportsTouchEvents() || actions_1416bf77_esm_isBrowser && window.navigator.maxTouchPoints > 1;
}

function supportsPointerEvents() {
  return actions_1416bf77_esm_isBrowser && 'onpointerdown' in window;
}

function supportsPointerLock() {
  return actions_1416bf77_esm_isBrowser && 'exitPointerLock' in window.document;
}

function supportsGestureEvents() {
  try {
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}

const SUPPORT = {
  isBrowser: actions_1416bf77_esm_isBrowser,
  gesture: supportsGestureEvents(),
  touch: isTouchScreen(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};

const DEFAULT_PREVENT_SCROLL_DELAY = 250;
const DEFAULT_DRAG_DELAY = 180;
const DEFAULT_SWIPE_VELOCITY = 0.5;
const DEFAULT_SWIPE_DISTANCE = 50;
const DEFAULT_SWIPE_DURATION = 250;
const DEFAULT_DRAG_AXIS_THRESHOLD = {
  mouse: 0,
  touch: 0,
  pen: 8
};
const dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  device(_v, _k, {
    pointer: {
      touch = false,
      lock = false,
      mouse = false
    } = {}
  }) {
    this.pointerLock = lock && SUPPORT.pointerLock;
    if (SUPPORT.touch && touch) return 'touch';
    if (this.pointerLock) return 'mouse';
    if (SUPPORT.pointer && !mouse) return 'pointer';
    if (SUPPORT.touch) return 'touch';
    return 'mouse';
  },

  preventScrollAxis(value, _k, {
    preventScroll
  }) {
    this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? DEFAULT_PREVENT_SCROLL_DELAY : undefined;
    if (!SUPPORT.touchscreen || preventScroll === false) return undefined;
    return value ? value : preventScroll !== undefined ? 'y' : undefined;
  },

  pointerCapture(_v, _k, {
    pointer: {
      capture = true,
      buttons = 1
    } = {}
  }) {
    this.pointerButtons = buttons;
    return !this.pointerLock && this.device === 'pointer' && capture;
  },

  threshold(value, _k, {
    filterTaps = false,
    tapsThreshold = 3,
    axis = undefined
  }) {
    const threshold = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold;
  },

  swipe({
    velocity = DEFAULT_SWIPE_VELOCITY,
    distance = DEFAULT_SWIPE_DISTANCE,
    duration = DEFAULT_SWIPE_DURATION
  } = {}) {
    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance)),
      duration
    };
  },

  delay(value = 0) {
    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;

      case false:
        return 0;

      default:
        return value;
    }
  },

  axisThreshold(value) {
    if (!value) return DEFAULT_DRAG_AXIS_THRESHOLD;
    return _objectSpread2(_objectSpread2({}, DEFAULT_DRAG_AXIS_THRESHOLD), value);
  }

});

if (false) {}

const SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const PINCH_WHEEL_RATIO = 100;
class PinchEngine extends Engine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'pinching');

    actions_1416bf77_esm_defineProperty(this, "aliasKey", 'da');
  }

  init() {
    this.state.offset = [1, 0];
    this.state.lastOffset = [1, 0];
    this.state._pointerEvents = new Map();
  }

  reset() {
    super.reset();
    const state = this.state;
    state._touchIds = [];
    state.canceled = false;
    state.cancel = this.cancel.bind(this);
    state.turns = 0;
  }

  computeOffset() {
    const {
      type,
      movement,
      lastOffset
    } = this.state;

    if (type === 'wheel') {
      this.state.offset = V.add(movement, lastOffset);
    } else {
      this.state.offset = [(1 + movement[0]) * lastOffset[0], movement[1] + lastOffset[1]];
    }
  }

  computeMovement() {
    const {
      offset,
      lastOffset
    } = this.state;
    this.state.movement = [offset[0] / lastOffset[0], offset[1] - lastOffset[1]];
  }

  axisIntent() {
    const state = this.state;
    const [_m0, _m1] = state._movement;

    if (!state.axis) {
      const axisMovementDifference = Math.abs(_m0) * SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
      if (axisMovementDifference < 0) state.axis = 'angle';else if (axisMovementDifference > 0) state.axis = 'scale';
    }
  }

  restrictToAxis(v) {
    if (this.config.lockDirection) {
      if (this.state.axis === 'scale') v[1] = 0;else if (this.state.axis === 'angle') v[0] = 0;
    }
  }

  cancel() {
    const state = this.state;
    if (state.canceled) return;
    setTimeout(() => {
      state.canceled = true;
      state._active = false;
      this.compute();
      this.emit();
    }, 0);
  }

  touchStart(event) {
    this.ctrl.setEventIds(event);
    const state = this.state;
    const ctrlTouchIds = this.ctrl.touchIds;

    if (state._active) {
      if (state._touchIds.every(id => ctrlTouchIds.has(id))) return;
    }

    if (ctrlTouchIds.size < 2) return;
    this.start(event);
    state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
    const payload = touchDistanceAngle(event, state._touchIds);
    this.pinchStart(event, payload);
  }

  pointerStart(event) {
    if (event.buttons != null && event.buttons % 2 !== 1) return;
    this.ctrl.setEventIds(event);
    event.target.setPointerCapture(event.pointerId);
    const state = this.state;
    const _pointerEvents = state._pointerEvents;
    const ctrlPointerIds = this.ctrl.pointerIds;

    if (state._active) {
      if (Array.from(_pointerEvents.keys()).every(id => ctrlPointerIds.has(id))) return;
    }

    if (_pointerEvents.size < 2) {
      _pointerEvents.set(event.pointerId, event);
    }

    if (state._pointerEvents.size < 2) return;
    this.start(event);
    const payload = distanceAngle(...Array.from(_pointerEvents.values()));
    this.pinchStart(event, payload);
  }

  pinchStart(event, payload) {
    const state = this.state;
    state.origin = payload.origin;
    this.computeValues([payload.distance, payload.angle]);
    this.computeInitial();
    this.compute(event);
    this.emit();
  }

  touchMove(event) {
    if (!this.state._active) return;
    const payload = touchDistanceAngle(event, this.state._touchIds);
    this.pinchMove(event, payload);
  }

  pointerMove(event) {
    const _pointerEvents = this.state._pointerEvents;

    if (_pointerEvents.has(event.pointerId)) {
      _pointerEvents.set(event.pointerId, event);
    }

    if (!this.state._active) return;
    const payload = distanceAngle(...Array.from(_pointerEvents.values()));
    this.pinchMove(event, payload);
  }

  pinchMove(event, payload) {
    const state = this.state;
    const prev_a = state._values[1];
    const delta_a = payload.angle - prev_a;
    let delta_turns = 0;
    if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
    this.computeValues([payload.distance, payload.angle - 360 * delta_turns]);
    state.origin = payload.origin;
    state.turns = delta_turns;
    state._movement = [state._values[0] / state._initial[0] - 1, state._values[1] - state._initial[1]];
    this.compute(event);
    this.emit();
  }

  touchEnd(event) {
    this.ctrl.setEventIds(event);
    if (!this.state._active) return;

    if (this.state._touchIds.some(id => !this.ctrl.touchIds.has(id))) {
      this.state._active = false;
      this.compute(event);
      this.emit();
    }
  }

  pointerEnd(event) {
    const state = this.state;
    this.ctrl.setEventIds(event);

    try {
      event.target.releasePointerCapture(event.pointerId);
    } catch (_unused) {}

    if (state._pointerEvents.has(event.pointerId)) {
      state._pointerEvents.delete(event.pointerId);
    }

    if (!state._active) return;

    if (state._pointerEvents.size < 2) {
      state._active = false;
      this.compute(event);
      this.emit();
    }
  }

  gestureStart(event) {
    if (event.cancelable) event.preventDefault();
    const state = this.state;
    if (state._active) return;
    this.start(event);
    this.computeValues([event.scale, event.rotation]);
    state.origin = [event.clientX, event.clientY];
    this.compute(event);
    this.emit();
  }

  gestureMove(event) {
    if (event.cancelable) event.preventDefault();
    if (!this.state._active) return;
    const state = this.state;
    this.computeValues([event.scale, event.rotation]);
    state.origin = [event.clientX, event.clientY];
    const _previousMovement = state._movement;
    state._movement = [event.scale - 1, event.rotation];
    state._delta = V.sub(state._movement, _previousMovement);
    this.compute(event);
    this.emit();
  }

  gestureEnd(event) {
    if (!this.state._active) return;
    this.state._active = false;
    this.compute(event);
    this.emit();
  }

  wheel(event) {
    const modifierKey = this.config.modifierKey;
    if (modifierKey && !event[modifierKey]) return;
    if (!this.state._active) this.wheelStart(event);else this.wheelChange(event);
    this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
  }

  wheelStart(event) {
    this.start(event);
    this.wheelChange(event);
  }

  wheelChange(event) {
    const isR3f = ('uv' in event);

    if (!isR3f) {
      if (event.cancelable) {
        event.preventDefault();
      }

      if (false) {}
    }

    const state = this.state;
    state._delta = [-wheelValues(event)[1] / PINCH_WHEEL_RATIO * state.offset[0], 0];
    V.addTo(state._movement, state._delta);
    this.state.origin = [event.clientX, event.clientY];
    this.compute(event);
    this.emit();
  }

  wheelEnd() {
    if (!this.state._active) return;
    this.state._active = false;
    this.compute();
    this.emit();
  }

  bind(bindFunction) {
    const device = this.config.device;

    if (!!device) {
      bindFunction(device, 'start', this[device + 'Start'].bind(this));
      bindFunction(device, 'change', this[device + 'Move'].bind(this));
      bindFunction(device, 'end', this[device + 'End'].bind(this));
      bindFunction(device, 'cancel', this[device + 'End'].bind(this));
    } else {
      bindFunction('wheel', '', this.wheel.bind(this), {
        passive: false
      });
    }
  }

}

const pinchConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  device(_v, _k, {
    shared,
    pointer: {
      touch = false
    } = {}
  }) {
    const sharedConfig = shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture) return 'gesture';
    if (SUPPORT.touch && touch) return 'touch';

    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer) return 'pointer';
      if (SUPPORT.touch) return 'touch';
    }
  },

  bounds(_v, _k, {
    scaleBounds = {},
    angleBounds = {}
  }) {
    const _scaleBounds = state => {
      const D = assignDefault(actions_1416bf77_esm_call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D.min, D.max];
    };

    const _angleBounds = state => {
      const A = assignDefault(actions_1416bf77_esm_call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    };

    if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [_scaleBounds(), _angleBounds()];
    return state => [_scaleBounds(state), _angleBounds(state)];
  },

  threshold(value, _k, config) {
    this.lockDirection = config.axis === 'lock';
    const threshold = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold;
  },

  modifierKey(value) {
    if (value === undefined) return 'ctrlKey';
    return value;
  }

});

class MoveEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'moving');
  }

  move(event) {
    if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
    if (!this.state._active) this.moveStart(event);else this.moveChange(event);
    this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
  }

  moveStart(event) {
    this.start(event);
    this.computeValues(pointerValues(event));
    this.compute(event);
    this.computeInitial();
    this.emit();
  }

  moveChange(event) {
    if (!this.state._active) return;
    const values = pointerValues(event);
    const state = this.state;
    state._delta = V.sub(values, state._values);
    V.addTo(state._movement, state._delta);
    this.computeValues(values);
    this.compute(event);
    this.emit();
  }

  moveEnd(event) {
    if (!this.state._active) return;
    this.state._active = false;
    this.compute(event);
    this.emit();
  }

  bind(bindFunction) {
    bindFunction('pointer', 'change', this.move.bind(this));
    bindFunction('pointer', 'leave', this.moveEnd.bind(this));
  }

}

const moveConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});

class ScrollEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'scrolling');
  }

  scroll(event) {
    if (!this.state._active) this.start(event);
    this.scrollChange(event);
    this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
  }

  scrollChange(event) {
    if (event.cancelable) event.preventDefault();
    const state = this.state;
    const values = scrollValues(event);
    state._delta = V.sub(values, state._values);
    V.addTo(state._movement, state._delta);
    this.computeValues(values);
    this.compute(event);
    this.emit();
  }

  scrollEnd() {
    if (!this.state._active) return;
    this.state._active = false;
    this.compute();
    this.emit();
  }

  bind(bindFunction) {
    bindFunction('scroll', '', this.scroll.bind(this));
  }

}

const scrollConfigResolver = coordinatesConfigResolver;

class WheelEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'wheeling');
  }

  wheel(event) {
    if (!this.state._active) this.start(event);
    this.wheelChange(event);
    this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
  }

  wheelChange(event) {
    const state = this.state;
    state._delta = wheelValues(event);
    V.addTo(state._movement, state._delta);
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;

    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) {
      state._movement[0] = state._movementBound[0];
    }

    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) {
      state._movement[1] = state._movementBound[1];
    }

    this.compute(event);
    this.emit();
  }

  wheelEnd() {
    if (!this.state._active) return;
    this.state._active = false;
    this.compute();
    this.emit();
  }

  bind(bindFunction) {
    bindFunction('wheel', '', this.wheel.bind(this));
  }

}

const wheelConfigResolver = coordinatesConfigResolver;

class HoverEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);

    actions_1416bf77_esm_defineProperty(this, "ingKey", 'hovering');
  }

  enter(event) {
    if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
    this.start(event);
    this.computeValues(pointerValues(event));
    this.compute(event);
    this.emit();
  }

  leave(event) {
    if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
    const state = this.state;
    if (!state._active) return;
    state._active = false;
    const values = pointerValues(event);
    state._movement = state._delta = V.sub(values, state._values);
    this.computeValues(values);
    this.compute(event);
    state.delta = state.movement;
    this.emit();
  }

  bind(bindFunction) {
    bindFunction('pointer', 'enter', this.enter.bind(this));
    bindFunction('pointer', 'leave', this.leave.bind(this));
  }

}

const hoverConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});

const EngineMap = new Map();
const ConfigResolverMap = new Map();
function actions_1416bf77_esm_registerAction(action) {
  EngineMap.set(action.key, action.engine);
  ConfigResolverMap.set(action.key, action.resolver);
}
const actions_1416bf77_esm_dragAction = {
  key: 'drag',
  engine: DragEngine,
  resolver: dragConfigResolver
};
const actions_1416bf77_esm_hoverAction = {
  key: 'hover',
  engine: HoverEngine,
  resolver: hoverConfigResolver
};
const actions_1416bf77_esm_moveAction = {
  key: 'move',
  engine: MoveEngine,
  resolver: moveConfigResolver
};
const actions_1416bf77_esm_pinchAction = {
  key: 'pinch',
  engine: PinchEngine,
  resolver: pinchConfigResolver
};
const actions_1416bf77_esm_scrollAction = {
  key: 'scroll',
  engine: ScrollEngine,
  resolver: scrollConfigResolver
};
const actions_1416bf77_esm_wheelAction = {
  key: 'wheel',
  engine: WheelEngine,
  resolver: wheelConfigResolver
};



;// CONCATENATED MODULE: ./node_modules/@use-gesture/core/dist/use-gesture-core.esm.js



function use_gesture_core_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function use_gesture_core_esm_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = use_gesture_core_esm_objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const sharedConfigResolver = {
  target(value) {
    if (value) {
      return () => 'current' in value ? value.current : value;
    }

    return undefined;
  },

  enabled(value = true) {
    return value;
  },

  window(value = SUPPORT.isBrowser ? window : undefined) {
    return value;
  },

  eventOptions({
    passive = true,
    capture = false
  } = {}) {
    return {
      passive,
      capture
    };
  },

  transform(value) {
    return value;
  }

};

const use_gesture_core_esm_excluded = ["target", "eventOptions", "window", "enabled", "transform"];
function resolveWith(config = {}, resolvers) {
  const result = {};

  for (const [key, resolver] of Object.entries(resolvers)) {
    switch (typeof resolver) {
      case 'function':
        if (false) {} else {
          result[key] = resolver.call(result, config[key], key, config);
        }

        break;

      case 'object':
        result[key] = resolveWith(config[key], resolver);
        break;

      case 'boolean':
        if (resolver) result[key] = config[key];
        break;
    }
  }

  return result;
}
function parse(config, gestureKey) {
  const _ref = config,
        {
    target,
    eventOptions,
    window,
    enabled,
    transform
  } = _ref,
        rest = use_gesture_core_esm_objectWithoutProperties(_ref, use_gesture_core_esm_excluded);

  const _config = {
    shared: resolveWith({
      target,
      eventOptions,
      window,
      enabled,
      transform
    }, sharedConfigResolver)
  };

  if (gestureKey) {
    const resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (const key in rest) {
      const resolver = ConfigResolverMap.get(key);

      if (resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), resolver);
      } else if (false) {}
    }
  }

  return _config;
}

class EventStore {
  constructor(ctrl, gestureKey) {
    actions_1416bf77_esm_defineProperty(this, "_listeners", new Set());

    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }

  add(element, device, action, handler, options) {
    const listeners = this._listeners;
    const type = toDomEventType(device, action);

    const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};

    const eventOptions = _objectSpread2(_objectSpread2({}, _options), options);

    element.addEventListener(type, handler, eventOptions);

    const remove = () => {
      element.removeEventListener(type, handler, eventOptions);
      listeners.delete(remove);
    };

    listeners.add(remove);
    return remove;
  }

  clean() {
    this._listeners.forEach(remove => remove());

    this._listeners.clear();
  }

}

class TimeoutStore {
  constructor() {
    actions_1416bf77_esm_defineProperty(this, "_timeouts", new Map());
  }

  add(key, callback, ms = 140, ...args) {
    this.remove(key);

    this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
  }

  remove(key) {
    const timeout = this._timeouts.get(key);

    if (timeout) window.clearTimeout(timeout);
  }

  clean() {
    this._timeouts.forEach(timeout => void window.clearTimeout(timeout));

    this._timeouts.clear();
  }

}

class use_gesture_core_esm_Controller {
  constructor(handlers) {
    actions_1416bf77_esm_defineProperty(this, "gestures", new Set());

    actions_1416bf77_esm_defineProperty(this, "_targetEventStore", new EventStore(this));

    actions_1416bf77_esm_defineProperty(this, "gestureEventStores", {});

    actions_1416bf77_esm_defineProperty(this, "gestureTimeoutStores", {});

    actions_1416bf77_esm_defineProperty(this, "handlers", {});

    actions_1416bf77_esm_defineProperty(this, "config", {});

    actions_1416bf77_esm_defineProperty(this, "pointerIds", new Set());

    actions_1416bf77_esm_defineProperty(this, "touchIds", new Set());

    actions_1416bf77_esm_defineProperty(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });

    resolveGestures(this, handlers);
  }

  setEventIds(event) {
    if (isTouch(event)) {
      this.touchIds = new Set(touchIds(event));
      return this.touchIds;
    } else if ('pointerId' in event) {
      if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
      return this.pointerIds;
    }
  }

  applyHandlers(handlers, nativeHandlers) {
    this.handlers = handlers;
    this.nativeHandlers = nativeHandlers;
  }

  applyConfig(config, gestureKey) {
    this.config = parse(config, gestureKey);
  }

  clean() {
    this._targetEventStore.clean();

    for (const key of this.gestures) {
      this.gestureEventStores[key].clean();
      this.gestureTimeoutStores[key].clean();
    }
  }

  effect() {
    if (this.config.shared.target) this.bind();
    return () => this._targetEventStore.clean();
  }

  bind(...args) {
    const sharedConfig = this.config.shared;
    const props = {};
    let target;

    if (sharedConfig.target) {
      target = sharedConfig.target();
      if (!target) return;
    }

    if (sharedConfig.enabled) {
      for (const gestureKey of this.gestures) {
        const gestureConfig = this.config[gestureKey];
        const bindFunction = bindToProps(props, gestureConfig.eventOptions, !!target);

        if (gestureConfig.enabled) {
          const Engine = EngineMap.get(gestureKey);
          new Engine(this, args, gestureKey).bind(bindFunction);
        }
      }

      const nativeBindFunction = bindToProps(props, sharedConfig.eventOptions, !!target);

      for (const eventKey in this.nativeHandlers) {
        nativeBindFunction(eventKey, '', event => this.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, this.state.shared), {}, {
          event,
          args
        })), undefined, true);
      }
    }

    for (const handlerProp in props) {
      props[handlerProp] = chain(...props[handlerProp]);
    }

    if (!target) return props;

    for (const handlerProp in props) {
      const {
        device,
        capture,
        passive
      } = parseProp(handlerProp);

      this._targetEventStore.add(target, device, '', props[handlerProp], {
        capture,
        passive
      });
    }
  }

}

function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}

function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag) setupGesture(ctrl, 'drag');
  if (internalHandlers.wheel) setupGesture(ctrl, 'wheel');
  if (internalHandlers.scroll) setupGesture(ctrl, 'scroll');
  if (internalHandlers.move) setupGesture(ctrl, 'move');
  if (internalHandlers.pinch) setupGesture(ctrl, 'pinch');
  if (internalHandlers.hover) setupGesture(ctrl, 'hover');
}

const bindToProps = (props, eventOptions, withPassiveOption) => (device, action, handler, options = {}, isNative = false) => {
  var _options$capture, _options$passive;

  const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
  const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
  let handlerProp = isNative ? device : toHandlerProp(device, action, capture);
  if (withPassiveOption && passive) handlerProp += 'Passive';
  props[handlerProp] = props[handlerProp] || [];
  props[handlerProp].push(handler);
};

const RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;

function sortHandlers(_handlers) {
  const native = {};
  const handlers = {};
  const actions = new Set();

  for (let key in _handlers) {
    if (RE_NOT_NATIVE.test(key)) {
      actions.add(RegExp.lastMatch);
      handlers[key] = _handlers[key];
    } else {
      native[key] = _handlers[key];
    }
  }

  return [handlers, native, actions];
}

function registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
  if (!actions.has(handlerKey)) return;

  if (!EngineMap.has(key)) {
    if (false) {}

    return;
  }

  const startKey = handlerKey + 'Start';
  const endKey = handlerKey + 'End';

  const fn = state => {
    let memo = undefined;
    if (state.first && startKey in handlers) handlers[startKey](state);
    if (handlerKey in handlers) memo = handlers[handlerKey](state);
    if (state.last && endKey in handlers) handlers[endKey](state);
    return memo;
  };

  internalHandlers[key] = fn;
  config[key] = config[key] || {};
}

function parseMergedHandlers(mergedHandlers, mergedConfig) {
  const [handlers, nativeHandlers, actions] = sortHandlers(mergedHandlers);
  const internalHandlers = {};
  registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
  return {
    handlers: internalHandlers,
    config: mergedConfig,
    nativeHandlers
  };
}



;// CONCATENATED MODULE: ./node_modules/@use-gesture/react/dist/use-gesture-react.esm.js







function useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
  const ctrl = react.useMemo(() => new use_gesture_core_esm_Controller(handlers), []);
  ctrl.applyHandlers(handlers, nativeHandlers);
  ctrl.applyConfig(config, gestureKey);
  react.useEffect(ctrl.effect.bind(ctrl));
  react.useEffect(() => {
    return ctrl.clean.bind(ctrl);
  }, []);

  if (config.target === undefined) {
    return ctrl.bind.bind(ctrl);
  }

  return undefined;
}

function useDrag(handler, config) {
  actions_1416bf77_esm_registerAction(actions_1416bf77_esm_dragAction);
  return useRecognizers({
    drag: handler
  }, config || {}, 'drag');
}

function usePinch(handler, config) {
  registerAction(pinchAction);
  return useRecognizers({
    pinch: handler
  }, config || {}, 'pinch');
}

function useWheel(handler, config) {
  actions_1416bf77_esm_registerAction(actions_1416bf77_esm_wheelAction);
  return useRecognizers({
    wheel: handler
  }, config || {}, 'wheel');
}

function useScroll(handler, config) {
  registerAction(scrollAction);
  return useRecognizers({
    scroll: handler
  }, config || {}, 'scroll');
}

function useMove(handler, config) {
  registerAction(moveAction);
  return useRecognizers({
    move: handler
  }, config || {}, 'move');
}

function useHover(handler, config) {
  registerAction(hoverAction);
  return useRecognizers({
    hover: handler
  }, config || {}, 'hover');
}

function createUseGesture(actions) {
  actions.forEach(actions_1416bf77_esm_registerAction);
  return function useGesture(_handlers, _config) {
    const {
      handlers,
      nativeHandlers,
      config
    } = parseMergedHandlers(_handlers, _config || {});
    return useRecognizers(handlers, config, undefined, nativeHandlers);
  };
}

function useGesture(handlers, config) {
  const hook = createUseGesture([dragAction, pinchAction, scrollAction, wheelAction, moveAction, hoverAction]);
  return hook(handlers, config || {});
}



;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-drag-and-pinch.js

var useDragAndPinch = createUseGesture([
    actions_1416bf77_esm_dragAction,
    actions_1416bf77_esm_pinchAction
]);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-viewer/slide.js
function slide_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function slide_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function slide_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function slide_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function slide_slicedToArray(arr, i) {
    return slide_arrayWithHoles(arr) || slide_iterableToArrayLimit(arr, i) || slide_unsupportedIterableToArray(arr, i) || slide_nonIterableRest();
}
function slide_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return slide_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return slide_arrayLikeToArray(o, minLen);
}





var slide_classPrefix = "adm-image-viewer";
var Slide = function(props) {
    var boundXY = function boundXY(param, rubberband) {
        var _param = slide_slicedToArray(param, 2), x = _param[0], y = _param[1];
        var currentZoom = zoom.get();
        var xOffset = 0, yOffset = 0;
        if (imgRef.current && controlRef.current) {
            xOffset = ((currentZoom * imgRef.current.width || 0) - controlRef.current.clientWidth) / 2;
            yOffset = ((currentZoom * imgRef.current.height || 0) - controlRef.current.clientHeight) / 2;
        }
        xOffset = xOffset > 0 ? xOffset : 0;
        yOffset = yOffset > 0 ? yOffset : 0;
        var bounds = {
            left: -xOffset,
            right: xOffset,
            top: -yOffset,
            bottom: yOffset
        };
        if (rubberband) {
            return [
                rubberbandIfOutOfBounds(x, bounds.left, bounds.right, currentZoom * 50),
                rubberbandIfOutOfBounds(y, bounds.top, bounds.bottom, currentZoom * 50)
            ];
        } else {
            return [
                bound(x, bounds.left, bounds.right),
                bound(y, bounds.top, bounds.bottom)
            ];
        }
    };
    var dragLockRef = props.dragLockRef;
    var controlRef = (0,react.useRef)(null);
    var imgRef = (0,react.useRef)(null);
    var ref3 = slide_slicedToArray(useSpring(function() {
        return {
            zoom: 1,
            x: 0,
            y: 0,
            config: {
                tension: 200
            }
        };
    }), 2), ref1 = ref3[0], zoom = ref1.zoom, x1 = ref1.x, y1 = ref1.y, api = ref3[1];
    var pinchLockRef = (0,react.useRef)(false);
    useDragAndPinch({
        onDrag: function(state) {
            if (state.tap && state.elapsedTime > 0 && state.elapsedTime < 1000) {
                // 判断点击时间>0是为了过滤掉非正常操作，例如用户长按选择图片之后的取消操作（也是一次点击）
                props.onTap();
                return;
            }
            var currentZoom = zoom.get();
            if (dragLockRef) {
                dragLockRef.current = currentZoom !== 1;
            }
            if (!pinchLockRef.current && currentZoom <= 1) {
                api.start({
                    x: 0,
                    y: 0
                });
            } else {
                if (state.last) {
                    var ref = slide_slicedToArray(boundXY([
                        state.offset[0] + state.velocity[0] * state.direction[0] * 200,
                        state.offset[1] + state.velocity[1] * state.direction[1] * 200
                    ], false), 2), x = ref[0], y = ref[1];
                    api.start({
                        x: x,
                        y: y
                    });
                } else {
                    var ref2 = slide_slicedToArray(boundXY(state.offset, true), 2), x2 = ref2[0], y2 = ref2[1];
                    api.start({
                        x: x2,
                        y: y2,
                        immediate: true
                    });
                }
            }
        },
        onPinch: function(state) {
            var _a;
            pinchLockRef.current = !state.last;
            var _offset = slide_slicedToArray(state.offset, 1), d = _offset[0];
            if (d < 0) return;
            var nextZoom = state.last ? bound(d, 1, props.maxZoom) : d;
            api.start({
                zoom: nextZoom,
                immediate: !state.last
            });
            (_a = props.onZoomChange) === null || _a === void 0 ? void 0 : _a.call(props, nextZoom);
            if (state.last && nextZoom <= 1) {
                api.start({
                    x: 0,
                    y: 0
                });
                if (dragLockRef) {
                    dragLockRef.current = false;
                }
            } else {
                if (dragLockRef) {
                    dragLockRef.current = true;
                }
            }
        }
    }, {
        target: controlRef,
        drag: {
            // filterTaps: true,
            from: function() {
                return [
                    x1.get(),
                    y1.get()
                ];
            },
            pointer: {
                touch: true
            }
        },
        pinch: {
            from: function() {
                return [
                    zoom.get(),
                    0
                ];
            },
            pointer: {
                touch: true
            }
        }
    });
    return /*#__PURE__*/ react.createElement("div", {
        className: "".concat(slide_classPrefix, "-slide"),
        onPointerMove: function(e) {
            if (zoom.get() !== 1) {
                e.stopPropagation();
            }
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(slide_classPrefix, "-control"),
        ref: controlRef
    }, /*#__PURE__*/ react.createElement(animated.div, {
        className: "".concat(slide_classPrefix, "-image-wrapper"),
        style: {
            translateX: x1,
            translateY: y1,
            scale: zoom
        }
    }, /*#__PURE__*/ react.createElement("img", {
        ref: imgRef,
        src: props.image,
        draggable: false,
        alt: props.image
    }))));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-viewer/slides.js
function slides_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function slides_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function slides_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function slides_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function slides_slicedToArray(arr, i) {
    return slides_arrayWithHoles(arr) || slides_iterableToArrayLimit(arr, i) || slides_unsupportedIterableToArray(arr, i) || slides_nonIterableRest();
}
function slides_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return slides_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return slides_arrayLikeToArray(o, minLen);
}






var slides_classPrefix = "adm-image-viewer";
var Slides = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var swipeTo = function swipeTo(index) {
        var immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _a;
        var i = bound(index, 0, count - 1);
        (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, i);
        api.start({
            x: i * slideWidth,
            immediate: immediate
        });
    };
    var slideWidth = window.innerWidth + convertPx(16);
    var _$ref = slides_slicedToArray(useSpring(function() {
        return {
            x: props.defaultIndex * slideWidth,
            config: {
                tension: 250,
                clamp: true
            }
        };
    }), 2), x1 = _$ref[0].x, api = _$ref[1];
    var count = props.images.length;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            swipeTo: swipeTo
        };
    });
    var dragLockRef = (0,react.useRef)(false);
    var bind = useDrag(function(state) {
        if (dragLockRef.current) return;
        var _offset = slides_slicedToArray(state.offset, 1), offsetX = _offset[0];
        if (state.last) {
            var minIndex = Math.floor(offsetX / slideWidth);
            var maxIndex = minIndex + 1;
            var velocityOffset = Math.min(state.velocity[0] * 2000, slideWidth) * state.direction[0];
            swipeTo(bound(Math.round((offsetX + velocityOffset) / slideWidth), minIndex, maxIndex));
        } else {
            api.start({
                x: offsetX,
                immediate: true
            });
        }
    }, {
        transform: function(param) {
            var _param = slides_slicedToArray(param, 2), x = _param[0], y = _param[1];
            return [
                -x,
                y
            ];
        },
        from: function() {
            return [
                x1.get(),
                0
            ];
        },
        bounds: function() {
            return {
                left: 0,
                right: (count - 1) * slideWidth
            };
        },
        rubberband: true,
        axis: "x",
        pointer: {
            touch: true
        }
    });
    return /*#__PURE__*/ react.createElement("div", Object.assign({
        className: "".concat(slides_classPrefix, "-slides")
    }, bind()), /*#__PURE__*/ react.createElement(animated.div, {
        className: "".concat(slides_classPrefix, "-indicator")
    }, x1.to(function(v) {
        var index = bound(Math.round(v / slideWidth), 0, count - 1);
        return "".concat(index + 1, " / ").concat(count);
    })), /*#__PURE__*/ react.createElement(animated.div, {
        className: "".concat(slides_classPrefix, "-slides-inner"),
        style: {
            x: x1.to(function(x) {
                return -x;
            })
        }
    }, props.images.map(function(image) {
        return /*#__PURE__*/ react.createElement(Slide, {
            key: image,
            image: image,
            onTap: props.onTap,
            maxZoom: props.maxZoom,
            onZoomChange: function(zoom) {
                if (zoom !== 1) {
                    var index = Math.round(x1.get() / slideWidth);
                    api.start({
                        x: index * slideWidth
                    });
                }
            },
            dragLockRef: dragLockRef
        });
    })));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-viewer/image-viewer.js







var image_viewer_classPrefix = "adm-image-viewer";
var image_viewer_defaultProps = {
    maxZoom: 3,
    getContainer: null,
    visible: false
};
var ImageViewer = function(p) {
    var _a1;
    var props = mergeProps(image_viewer_defaultProps, p);
    var node = /*#__PURE__*/ react.createElement(components_mask, {
        visible: props.visible,
        disableBodyScroll: false,
        opacity: "thick",
        afterClose: props.afterClose
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_viewer_classPrefix, "-content")
    }, props.image && /*#__PURE__*/ react.createElement(Slide, {
        image: props.image,
        onTap: function() {
            var _a;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        maxZoom: props.maxZoom
    })), props.image && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_viewer_classPrefix, "-footer")
    }, (_a1 = props.renderFooter) === null || _a1 === void 0 ? void 0 : _a1.call(props, props.image), /*#__PURE__*/ react.createElement(components_safe_area, {
        position: "bottom"
    })));
    return renderToContainer(props.getContainer, node);
};
var multiDefaultProps = Object.assign(Object.assign({}, image_viewer_defaultProps), {
    defaultIndex: 0
});
var MultiImageViewer = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var _a2;
    var props = mergeProps(multiDefaultProps, p);
    var _$ref = (0,react.useState)(props.defaultIndex), index1 = _$ref[0], setIndex = _$ref[1];
    var slidesRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            swipeTo: function(index, immediate) {
                var _a;
                setIndex(index);
                (_a = slidesRef.current) === null || _a === void 0 ? void 0 : _a.swipeTo(index, immediate);
            }
        };
    });
    var onSlideChange = (0,react.useCallback)(function(index) {
        var _a;
        setIndex(index);
        (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, index);
    }, [
        props.onIndexChange
    ]);
    var node = /*#__PURE__*/ react.createElement(components_mask, {
        visible: props.visible,
        disableBodyScroll: false,
        opacity: "thick",
        afterClose: props.afterClose
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_viewer_classPrefix, "-content")
    }, props.images && /*#__PURE__*/ react.createElement(Slides, {
        ref: slidesRef,
        defaultIndex: index1,
        onIndexChange: onSlideChange,
        images: props.images,
        onTap: function() {
            var _a;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        },
        maxZoom: props.maxZoom
    })), props.images && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_viewer_classPrefix, "-footer")
    }, (_a2 = props.renderFooter) === null || _a2 === void 0 ? void 0 : _a2.call(props, props.images[index1], index1), /*#__PURE__*/ react.createElement(components_safe_area, {
        position: "bottom"
    })));
    return renderToContainer(props.getContainer, node);
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-viewer/methods.js



var handlerSet = new Set();
function showImageViewer(props) {
    clearImageViewer();
    var handler = renderImperatively(/*#__PURE__*/ react.createElement(ImageViewer, Object.assign({}, props, {
        afterClose: function() {
            var _a;
            handlerSet.delete(handler);
            (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    })));
    handlerSet.add(handler);
    return handler;
}
function showMultiImageViewer(props) {
    clearImageViewer();
    var handler = renderImperatively(/*#__PURE__*/ react.createElement(MultiImageViewer, Object.assign({}, props, {
        afterClose: function() {
            var _a;
            handlerSet.delete(handler);
            (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    })));
    handlerSet.add(handler);
    return handler;
}
function clearImageViewer() {
    handlerSet.forEach(function(handler) {
        handler.close();
    });
    handlerSet.clear();
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-viewer/index.js




var Multi = attachPropertiesToComponent(MultiImageViewer, {
    show: showMultiImageViewer
});
/* harmony default export */ var components_image_viewer = (attachPropertiesToComponent(ImageViewer, {
    Multi: Multi,
    show: showImageViewer,
    clear: clearImageViewer
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/spin-loading/spin-loading.css
var spin_loading = __webpack_require__(48606);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(61688);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/reduce-and-restore-motion.js


var reduced = false;
var subscribers = new Set();
function notify() {
    subscribers.forEach(function(subscriber) {
        subscriber();
    });
}
function reduceMotion() {
    reduced = true;
    notify();
    globals.assign({
        skipAnimation: true
    });
}
function restoreMotion() {
    reduced = false;
    notify();
    Globals.assign({
        skipAnimation: false
    });
}
function isMotionReduced() {
    return reduced;
}
function useMotionReduced() {
    return (0,shim.useSyncExternalStore)(function(onStoreChange) {
        subscribers.add(onStoreChange);
        return function() {
            subscribers.delete(onStoreChange);
        };
    }, isMotionReduced);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/spin-loading/spin-loading.js





var spin_loading_classPrefix = "adm-spin-loading";
var spin_loading_colorRecord = {
    default: "var(--adm-color-weak)",
    primary: "var(--adm-color-primary)",
    white: "var(--adm-color-white)"
};
var spin_loading_defaultProps = {
    color: "default"
};
var circumference = 15 * 3.14159265358979 * 2;
var SpinLoading = /*#__PURE__*/ (0,react.memo)(function(p) {
    var _a;
    var props = mergeProps(spin_loading_defaultProps, p);
    var motionReduced = useMotionReduced();
    var percent = useSpring({
        cancel: motionReduced,
        loop: {
            reverse: true
        },
        from: {
            percent: 80
        },
        to: {
            percent: 30
        },
        config: {
            duration: 1200
        }
    }).percent;
    return withNativeProps(props, /*#__PURE__*/ react.createElement(animated.div, {
        className: spin_loading_classPrefix,
        style: {
            "--color": (_a = spin_loading_colorRecord[props.color]) !== null && _a !== void 0 ? _a : props.color,
            "--percent": percent
        }
    }, /*#__PURE__*/ react.createElement("svg", {
        className: "".concat(spin_loading_classPrefix, "-svg"),
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ react.createElement(animated.circle, {
        className: "".concat(spin_loading_classPrefix, "-fill"),
        fill: "transparent",
        strokeWidth: "2",
        strokeDasharray: circumference,
        strokeDashoffset: percent,
        strokeLinecap: "square",
        r: 15,
        cx: 16,
        cy: 16
    }))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/spin-loading/index.js


/* harmony default export */ var components_spin_loading = (SpinLoading);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-uploader/preview-item.js






var preview_item_classPrefix = "adm-image-uploader";
var PreviewItem = function(props) {
    var renderLoading = function renderLoading() {
        return props.status === "pending" && /*#__PURE__*/ react.createElement("div", {
            className: "".concat(preview_item_classPrefix, "-cell-mask")
        }, /*#__PURE__*/ react.createElement("span", {
            className: "".concat(preview_item_classPrefix, "-cell-loading")
        }, /*#__PURE__*/ react.createElement(components_spin_loading, {
            color: "white"
        }), /*#__PURE__*/ react.createElement("span", {
            className: "".concat(preview_item_classPrefix, "-cell-mask-message")
        }, locale.ImageUploader.uploading)));
    };
    var renderDelete = function renderDelete() {
        return deletable && /*#__PURE__*/ react.createElement("span", {
            className: "".concat(preview_item_classPrefix, "-cell-delete"),
            onClick: onDelete
        }, /*#__PURE__*/ react.createElement(es_CloseOutline, {
            className: "".concat(preview_item_classPrefix, "-cell-delete-icon")
        }));
    };
    var locale = useConfig().locale;
    var url = props.url, file = props.file, deletable = props.deletable, onDelete = props.onDelete, imageFit = props.imageFit;
    var src = (0,react.useMemo)(function() {
        if (url) {
            return url;
        }
        if (file) {
            return URL.createObjectURL(file);
        }
        return "";
    }, [
        url,
        file
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(preview_item_classPrefix, "-cell"), props.status === "fail" && "".concat(preview_item_classPrefix, "-cell-fail"))
    }, /*#__PURE__*/ react.createElement(components_image, {
        className: "".concat(preview_item_classPrefix, "-cell-image"),
        src: src,
        fit: imageFit,
        onClick: props.onClick
    }), renderLoading(), renderDelete());
};
/* harmony default export */ var preview_item = (PreviewItem);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/space/space.css
var space = __webpack_require__(48610);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/space/space.js
function space_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var space_classPrefix = "adm-space";
var space_defaultProps = {
    direction: "horizontal"
};
var Space = function(p) {
    var props = mergeProps(space_defaultProps, p);
    var direction = props.direction, onClick = props.onClick;
    var _obj;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(space_classPrefix, (_obj = {}, space_defineProperty(_obj, "".concat(space_classPrefix, "-wrap"), props.wrap), space_defineProperty(_obj, "".concat(space_classPrefix, "-block"), props.block), space_defineProperty(_obj, "".concat(space_classPrefix, "-").concat(direction), true), space_defineProperty(_obj, "".concat(space_classPrefix, "-align-").concat(props.align), !!props.align), space_defineProperty(_obj, "".concat(space_classPrefix, "-justify-").concat(props.justify), !!props.justify), _obj)),
        onClick: onClick
    }, react.Children.map(props.children, function(child) {
        return child !== null && child !== undefined && /*#__PURE__*/ react.createElement("div", {
            className: "".concat(space_classPrefix, "-item")
        }, child);
    })));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/space/index.js


/* harmony default export */ var components_space = (Space);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-uploader/image-uploader.js
function image_uploader_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_uploader_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_uploader_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return image_uploader_arrayLikeToArray(arr);
}
function image_uploader_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function image_uploader_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_uploader_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_uploader_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_uploader_slicedToArray(arr, i) {
    return image_uploader_arrayWithHoles(arr) || image_uploader_iterableToArrayLimit(arr, i) || image_uploader_unsupportedIterableToArray(arr, i) || image_uploader_nonIterableRest();
}
function image_uploader_toConsumableArray(arr) {
    return image_uploader_arrayWithoutHoles(arr) || image_uploader_iterableToArray(arr) || image_uploader_unsupportedIterableToArray(arr) || image_uploader_nonIterableSpread();
}
function image_uploader_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_uploader_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_uploader_arrayLikeToArray(o, minLen);
}












var image_uploader_classPrefix = "adm-image-uploader";
var image_uploader_defaultProps = {
    disableUpload: false,
    deletable: true,
    showUpload: true,
    multiple: false,
    maxCount: 0,
    defaultValue: [],
    accept: "image/*",
    preview: true,
    showFailed: true,
    imageFit: "cover"
};
var ImageUploader = function(p) {
    var processFile = function processFile(file, fileList) {
        return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee() {
            var beforeUpload, transformedFile;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        beforeUpload = props.beforeUpload;
                        transformedFile = file;
                        _ctx.next = 4;
                        return beforeUpload === null || beforeUpload === void 0 ? void 0 : beforeUpload(file, fileList);
                    case 4:
                        transformedFile = _ctx.sent;
                        return _ctx.abrupt("return", transformedFile);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var onChange = function onChange(e) {
        var _a;
        return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee1() {
            var _this, _target, rawFiles, files, postFiles, exceed, newTasks;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        _this = this;
                        e.persist();
                        _target = e.target, rawFiles = _target.files;
                        if (rawFiles) {
                            _ctx1.next = 5;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 5:
                        files = [].slice.call(rawFiles);
                        e.target.value = ""; // HACK: fix the same file doesn't trigger onChange
                        if (!props.beforeUpload) {
                            _ctx1.next = 11;
                            break;
                        }
                        postFiles = files.map(function(file) {
                            return processFile(file, files);
                        });
                        _ctx1.next = 11;
                        return Promise.all(postFiles).then(function(filesList) {
                            files = filesList.filter(Boolean);
                        });
                    case 11:
                        if (!(files.length === 0)) {
                            _ctx1.next = 13;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 13:
                        if (maxCount > 0) {
                            exceed = value.length + files.length - maxCount;
                            if (exceed > 0) {
                                files = files.slice(0, files.length - exceed);
                                (_a = props.onCountExceed) === null || _a === void 0 ? void 0 : _a.call(props, exceed);
                            }
                        }
                        newTasks = files.map(function(file) {
                            return {
                                id: idCountRef.current++,
                                status: "pending",
                                file: file
                            };
                        });
                        setTasks(function(prev) {
                            return image_uploader_toConsumableArray(prev).concat(image_uploader_toConsumableArray(newTasks));
                        });
                        _ctx1.next = 18;
                        return Promise.all(newTasks.map(function(currentTask) {
                            return __awaiter(_this, void 0, void 0, runtime_default().mark(function _callee() {
                                var result;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.prev = 0;
                                            _ctx.next = 3;
                                            return props.upload(currentTask.file);
                                        case 3:
                                            result = _ctx.sent;
                                            setTasks(function(prev) {
                                                return prev.map(function(task) {
                                                    if (task.id === currentTask.id) {
                                                        return Object.assign(Object.assign({}, task), {
                                                            url: result.url
                                                        });
                                                    }
                                                    return task;
                                                });
                                            });
                                            setValue(function(prev) {
                                                var newVal = Object.assign({}, result);
                                                return image_uploader_toConsumableArray(prev).concat([
                                                    newVal
                                                ]);
                                            });
                                            _ctx.next = 12;
                                            break;
                                        case 8:
                                            _ctx.prev = 8;
                                            _ctx.t0 = _ctx["catch"](0);
                                            setTasks(function(prev) {
                                                return prev.map(function(task) {
                                                    if (task.id === currentTask.id) {
                                                        return Object.assign(Object.assign({}, task), {
                                                            status: "fail"
                                                        });
                                                    }
                                                    return task;
                                                });
                                            });
                                            throw _ctx.t0;
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        0,
                                        8
                                    ]
                                ]);
                            }));
                        })).catch(function(error) {
                            return console.error(error);
                        });
                    case 18:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1, this);
        }));
    };
    var previewImage = function previewImage(index) {
        imageViewerHandlerRef.current = components_image_viewer.Multi.show({
            images: value.map(function(fileItem) {
                return fileItem.url;
            }),
            defaultIndex: index,
            onClose: function() {
                imageViewerHandlerRef.current = null;
            }
        });
    };
    var locale = useConfig().locale;
    var props = mergeProps(image_uploader_defaultProps, p);
    var ref = image_uploader_slicedToArray(usePropsValue(props), 2), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)([]), tasks = ref1[0], setTasks = ref1[1];
    es_useIsomorphicLayoutEffect(function() {
        setTasks(function(prev) {
            return prev.filter(function(task) {
                if (task.url === undefined) return true;
                return !value.some(function(fileItem) {
                    return fileItem.url === task.url;
                });
            });
        });
    }, [
        value
    ]);
    var idCountRef = (0,react.useRef)(0);
    var maxCount = props.maxCount, onPreview = props.onPreview;
    var imageViewerHandlerRef = (0,react.useRef)(null);
    es_useUnmount(function() {
        var _a;
        (_a = imageViewerHandlerRef.current) === null || _a === void 0 ? void 0 : _a.close();
    });
    var showUpload = props.showUpload && (maxCount === 0 || value.length + tasks.length < maxCount);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: image_uploader_classPrefix
    }, /*#__PURE__*/ react.createElement(components_space, {
        className: "".concat(image_uploader_classPrefix, "-space"),
        wrap: true,
        block: true
    }, value.map(function(fileItem, index) {
        var _a, _b;
        return /*#__PURE__*/ react.createElement(preview_item, {
            key: (_a = fileItem.key) !== null && _a !== void 0 ? _a : index,
            url: (_b = fileItem.thumbnailUrl) !== null && _b !== void 0 ? _b : fileItem.url,
            deletable: props.deletable,
            imageFit: props.imageFit,
            onClick: function() {
                if (props.preview) {
                    previewImage(index);
                }
                onPreview && onPreview(index, fileItem);
            },
            onDelete: function() {
                return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
                    var _c, canDelete;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _ctx.next = 3;
                                return (_c = props.onDelete) === null || _c === void 0 ? void 0 : _c.call(props, fileItem);
                            case 3:
                                canDelete = _ctx.sent;
                                if (!(canDelete === false)) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 6:
                                setValue(value.filter(function(x, i) {
                                    return i !== index;
                                }));
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            }
        });
    }), tasks.map(function(task) {
        if (!props.showFailed && task.status === "fail") {
            return null;
        }
        return /*#__PURE__*/ react.createElement(preview_item, {
            key: task.id,
            file: task.file,
            deletable: task.status !== "pending",
            status: task.status,
            imageFit: props.imageFit,
            onDelete: function() {
                setTasks(tasks.filter(function(x) {
                    return x.id !== task.id;
                }));
            }
        });
    }), showUpload && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(image_uploader_classPrefix, "-upload-button-wrap")
    }, props.children ? props.children : /*#__PURE__*/ react.createElement("span", {
        className: "".concat(image_uploader_classPrefix, "-cell ").concat(image_uploader_classPrefix, "-upload-button"),
        role: "button",
        "aria-label": locale.ImageUploader.upload
    }, /*#__PURE__*/ react.createElement("span", {
        className: "".concat(image_uploader_classPrefix, "-upload-button-icon")
    }, /*#__PURE__*/ react.createElement(es_AddOutline, null))), !props.disableUpload && /*#__PURE__*/ react.createElement("input", {
        capture: props.capture,
        accept: props.accept,
        multiple: props.multiple,
        type: "file",
        className: "".concat(image_uploader_classPrefix, "-input"),
        onChange: onChange,
        "aria-hidden": true
    })))));
};

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/image-uploader/image-uploader.css
var image_uploader = __webpack_require__(141);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/image-uploader/index.js


/* harmony default export */ var components_image_uploader = (ImageUploader);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/infinite-scroll/infinite-scroll.css
var infinite_scroll = __webpack_require__(26144);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useLockFn/index.js
var useLockFn_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var useLockFn_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var useLockFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var useLockFn_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

function useLockFn(fn) {
  var _this = this;
  var lockRef = (0,react.useRef)(false);
  return (0,react.useCallback)(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return useLockFn_awaiter(_this, void 0, void 0, function () {
      var ret, e_1;
      return useLockFn_generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (lockRef.current) return [2 /*return*/];
            lockRef.current = true;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, fn.apply(void 0, useLockFn_spreadArray([], useLockFn_read(args), false))];
          case 2:
            ret = _a.sent();
            lockRef.current = false;
            return [2 /*return*/, ret];
          case 3:
            e_1 = _a.sent();
            lockRef.current = false;
            throw e_1;
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [fn]);
}
/* harmony default export */ var es_useLockFn = (useLockFn);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useThrottleFn/index.js
var useThrottleFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var useThrottleFn_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};






function useThrottleFn(fn, options) {
  var _a;
  if (utils_isDev) {
    if (!isFunction(fn)) {
      console.error("useThrottleFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = es_useLatest(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var throttled = (0,react.useMemo)(function () {
    return throttle_default()(function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(fnRef, useThrottleFn_spreadArray([], useThrottleFn_read(args), false));
    }, wait, options);
  }, []);
  es_useUnmount(function () {
    throttled.cancel();
  });
  return {
    run: throttled,
    cancel: throttled.cancel,
    flush: throttled.flush
  };
}
/* harmony default export */ var es_useThrottleFn = (useThrottleFn);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/infinite-scroll/infinite-scroll.js









function isWindow(element) {
    return element === window;
}
var infinite_scroll_classPrefix = "adm-infinite-scroll";
var infinite_scroll_defaultProps = {
    threshold: 250,
    children: function(hasMore, failed, retry) {
        return /*#__PURE__*/ react.createElement(InfiniteScrollContent, {
            hasMore: hasMore,
            failed: failed,
            retry: retry
        });
    }
};
var InfiniteScroll = function(p) {
    var retry = function retry() {
        return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setFailed(false);
                        _ctx.next = 3;
                        return doLoadMore(true);
                    case 3:
                        setFlag(nextFlagRef.current);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var props = mergeProps(infinite_scroll_defaultProps, p);
    var ref = (0,react.useState)(false), failed = ref[0], setFailed = ref[1];
    var doLoadMore = es_useLockFn(function(isRetry) {
        return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return props.loadMore(isRetry);
                    case 3:
                        _ctx.next = 9;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        setFailed(true);
                        throw _ctx.t0;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
    });
    var elementRef = (0,react.useRef)(null); // Prevent duplicated trigger of `check` function
    var ref1 = (0,react.useState)({}), flag = ref1[0], setFlag = ref1[1];
    var nextFlagRef = (0,react.useRef)(flag);
    var ref2 = (0,react.useState)(), scrollParent = ref2[0], setScrollParent = ref2[1];
    var ref3 = es_useThrottleFn(function() {
        return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
            var element, parent, rect, elementTop, current, nextFlag;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(nextFlagRef.current !== flag)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (props.hasMore) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        element = elementRef.current;
                        if (element) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        if (element.offsetParent) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        parent = getScrollParent(element);
                        setScrollParent(parent);
                        if (parent) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 13:
                        rect = element.getBoundingClientRect();
                        elementTop = rect.top;
                        current = isWindow(parent) ? window.innerHeight : parent.getBoundingClientRect().bottom;
                        if (!(current >= elementTop - props.threshold)) {
                            _ctx.next = 22;
                            break;
                        }
                        nextFlag = {};
                        nextFlagRef.current = nextFlag;
                        _ctx.next = 21;
                        return doLoadMore(false);
                    case 21:
                        setFlag(nextFlag);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    }, {
        wait: 100,
        leading: true,
        trailing: true
    }), check = ref3.run; // Make sure to trigger `loadMore` when content changes
    (0,react.useEffect)(function() {
        check();
    });
    (0,react.useEffect)(function() {
        var onScroll = function onScroll() {
            check();
        };
        var element = elementRef.current;
        if (!element) return;
        if (!scrollParent) return;
        scrollParent.addEventListener("scroll", onScroll);
        return function() {
            scrollParent.removeEventListener("scroll", onScroll);
        };
    }, [
        scrollParent
    ]);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: infinite_scroll_classPrefix,
        ref: elementRef
    }, typeof props.children === "function" ? props.children(props.hasMore, failed, retry) : props.children));
};
var InfiniteScrollContent = function(props) {
    var locale = useConfig().locale;
    if (!props.hasMore) {
        return /*#__PURE__*/ react.createElement("span", null, locale.InfiniteScroll.noMore);
    }
    if (props.failed) {
        return /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement("span", {
            className: "".concat(infinite_scroll_classPrefix, "-failed-text")
        }, locale.InfiniteScroll.failedToLoad), /*#__PURE__*/ react.createElement("a", {
            onClick: function() {
                props.retry();
            }
        }, locale.InfiniteScroll.retry));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("span", null, locale.common.loading), /*#__PURE__*/ react.createElement(components_dot_loading, null));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/infinite-scroll/index.js


/* harmony default export */ var components_infinite_scroll = (InfiniteScroll);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/input/input.css
var input = __webpack_require__(86162);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/CloseCircleFill.js

function CloseCircleFill(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "CloseCircleFill-CloseCircleFill",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "CloseCircleFill-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "CloseCircleFill-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M18.6753876,16 L15.5637812,16 C15.4576916,16 15.3559474,16.0421451 15.2809323,16.1171635 C15.124726,16.2733766 15.1247316,16.5266426 15.2809447,16.6828489 L15.2809447,16.6828489 L22.299066,23.7006641 L14.6828159,31.3171619 C14.6078042,31.3921761 14.5656632,31.4939157 14.5656632,31.6 C14.5656632,31.8209139 14.7447493,32 14.9656632,32 L14.9656632,32 L18.0753284,32 C18.1814068,32 18.2831412,31.9578638 18.3581544,31.8828594 L18.3581544,31.8828594 L24.420066,25.8216641 L30.4818451,31.8828564 C30.5568585,31.9578626 30.6585942,32 30.7646741,32 L30.7646741,32 L33.8763476,32 C33.9824309,32 34.0841695,31.9578599 34.1591835,31.8828496 C34.315397,31.7266436 34.3154031,31.4733776 34.1591972,31.3171641 L34.1591972,31.3171641 L26.542066,23.6996641 L33.5591874,16.6828489 C33.6342057,16.6078338 33.6763508,16.5060896 33.6763508,16.4 C33.6763508,16.1790861 33.4972647,16 33.2763508,16 L33.2763508,16 L30.1637654,16 C30.0576705,16 29.9559218,16.0421493 29.8809058,16.1171741 L29.8809058,16.1171741 L24.420066,21.5786641 L18.9582218,16.1171488 C18.883208,16.0421394 18.7814701,16 18.6753876,16 L18.6753876,16 Z",
        id: "CloseCircleFill-\u5F62\u72B6\u7ED3\u5408",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_CloseCircleFill = (CloseCircleFill);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/input/input.js
function input_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function input_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function input_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function input_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function input_slicedToArray(arr, i) {
    return input_arrayWithHoles(arr) || input_iterableToArrayLimit(arr, i) || input_unsupportedIterableToArray(arr, i) || input_nonIterableRest();
}
function input_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return input_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return input_arrayLikeToArray(o, minLen);
}









var input_classPrefix = "adm-input";
var input_defaultProps = {
    defaultValue: "",
    onlyShowClearWhenFocus: true
};
var Input = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var checkValue = function checkValue() {
        var nextValue = value;
        if (props.type === "number") {
            nextValue = nextValue && bound(parseFloat(nextValue), props.min, props.max).toString();
        }
        if (nextValue !== value) {
            setValue(nextValue);
        }
    };
    var props = mergeProps(input_defaultProps, p);
    var _$ref = input_slicedToArray(usePropsValue(props), 2), value = _$ref[0], setValue = _$ref[1];
    var _$ref1 = (0,react.useState)(false), hasFocus = _$ref1[0], setHasFocus = _$ref1[1];
    var compositionStartRef = (0,react.useRef)(false);
    var nativeInputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            clear: function() {
                setValue("");
            },
            focus: function() {
                var _a;
                (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: function() {
                var _a;
                (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
            get nativeElement () {
                return nativeInputRef.current;
            }
        };
    });
    var handleKeydown = function(e) {
        var _a;
        if (props.onEnterPress && (e.code === "Enter" || e.keyCode === 13)) {
            props.onEnterPress(e);
        }
        (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };
    es_useIsomorphicLayoutEffect(function() {
        var _a1;
        if (!props.enterKeyHint) return;
        (_a1 = nativeInputRef.current) === null || _a1 === void 0 ? void 0 : _a1.setAttribute("enterkeyhint", props.enterKeyHint);
        return function() {
            var _a;
            (_a = nativeInputRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute("enterkeyhint");
        };
    }, [
        props.enterKeyHint
    ]);
    var shouldShowClear = function() {
        if (!props.clearable || !value || props.readOnly) return false;
        if (props.onlyShowClearWhenFocus) {
            return hasFocus;
        } else {
            return true;
        }
    }();
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(input_classPrefix), props.disabled && "".concat(input_classPrefix, "-disabled"))
    }, /*#__PURE__*/ react.createElement("input", {
        ref: nativeInputRef,
        className: "".concat(input_classPrefix, "-element"),
        value: value,
        onChange: function(e) {
            setValue(e.target.value);
        },
        onFocus: function(e) {
            var _a;
            setHasFocus(true);
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: function(e) {
            var _a;
            setHasFocus(false);
            checkValue();
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        id: props.id,
        placeholder: props.placeholder,
        disabled: props.disabled,
        readOnly: props.readOnly,
        maxLength: props.maxLength,
        minLength: props.minLength,
        max: props.max,
        min: props.min,
        autoComplete: props.autoComplete,
        autoFocus: props.autoFocus,
        pattern: props.pattern,
        inputMode: props.inputMode,
        type: props.type,
        name: props.name,
        autoCapitalize: props.autoCapitalize,
        autoCorrect: props.autoCorrect,
        onKeyDown: handleKeydown,
        onKeyUp: props.onKeyUp,
        onCompositionStart: function(e) {
            var _a;
            compositionStartRef.current = true;
            (_a = props.onCompositionStart) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onCompositionEnd: function(e) {
            var _a;
            compositionStartRef.current = false;
            (_a = props.onCompositionEnd) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onClick: props.onClick,
        role: props.role,
        "aria-valuenow": props["aria-valuenow"],
        "aria-valuemax": props["aria-valuemax"],
        "aria-valuemin": props["aria-valuemin"]
    }), shouldShowClear && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(input_classPrefix, "-clear"),
        onMouseDown: function(e) {
            e.preventDefault();
        },
        onClick: function() {
            var _a, _b;
            setValue("");
            (_a = props.onClear) === null || _a === void 0 ? void 0 : _a.call(props); // https://github.com/ant-design/ant-design-mobile/issues/5212
            if (isIOS() && compositionStartRef.current) {
                compositionStartRef.current = false;
                (_b = nativeInputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
            }
        }
    }, /*#__PURE__*/ react.createElement(es_CloseCircleFill, null))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/input/index.js


/* harmony default export */ var components_input = (Input);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/loading/index.js
// Deprecated


/* harmony default export */ var loading = (DotLoading);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/modal/modal.css
var modal = __webpack_require__(2757);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/modal-action-button.js




var ModalActionButton = function(props) {
    var action = props.action;
    return withNativeProps(props.action, /*#__PURE__*/ react.createElement(components_button, {
        key: action.key,
        onClick: props.onAction,
        className: classnames_default()("adm-modal-button", {
            "adm-modal-button-primary": props.action.primary
        }),
        fill: props.action.primary ? "solid" : "none",
        size: props.action.primary ? "large" : "middle",
        block: true,
        color: action.danger ? "danger" : "primary",
        loading: "auto",
        disabled: action.disabled
    }, action.text));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/modal.js










var modal_defaultProps = {
    actions: [],
    closeOnAction: false,
    closeOnMaskClick: false,
    getContainer: null
};
var Modal = function(p) {
    var props = mergeProps(modal_defaultProps, p);
    var element = /*#__PURE__*/ react.createElement(react.Fragment, null, !!props.image && /*#__PURE__*/ react.createElement("div", {
        className: modal_cls("image-container")
    }, /*#__PURE__*/ react.createElement(components_image, {
        src: props.image,
        alt: "modal header image",
        width: "100%"
    })), !!props.header && /*#__PURE__*/ react.createElement("div", {
        className: modal_cls("header")
    }, /*#__PURE__*/ react.createElement(components_auto_center, null, props.header)), !!props.title && /*#__PURE__*/ react.createElement("div", {
        className: modal_cls("title")
    }, props.title), /*#__PURE__*/ react.createElement("div", {
        className: modal_cls("content")
    }, typeof props.content === "string" ? /*#__PURE__*/ react.createElement(components_auto_center, null, props.content) : props.content), /*#__PURE__*/ react.createElement(components_space, {
        direction: "vertical",
        block: true,
        className: classnames_default()(modal_cls("footer"), props.actions.length === 0 && modal_cls("footer-empty"))
    }, props.actions.map(function(action, index) {
        return /*#__PURE__*/ react.createElement(ModalActionButton, {
            key: action.key,
            action: action,
            onAction: function() {
                return __awaiter(void 0, void 0, void 0, runtime_default().mark(function _callee() {
                    var _a, _b, _c;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _ctx.next = 3;
                                return Promise.all([
                                    (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action),
                                    (_b = props.onAction) === null || _b === void 0 ? void 0 : _b.call(props, action, index)
                                ]);
                            case 3:
                                if (props.closeOnAction) {
                                    (_c = props.onClose) === null || _c === void 0 ? void 0 : _c.call(props);
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            }
        });
    })));
    return /*#__PURE__*/ react.createElement(components_center_popup, {
        className: classnames_default()(modal_cls(), props.className),
        style: props.style,
        afterClose: props.afterClose,
        afterShow: props.afterShow,
        showCloseButton: props.showCloseButton,
        closeOnMaskClick: props.closeOnMaskClick,
        onClose: props.onClose,
        visible: props.visible,
        getContainer: props.getContainer,
        bodyStyle: props.bodyStyle,
        bodyClassName: classnames_default()(modal_cls("body"), props.image && modal_cls("with-image"), props.bodyClassName),
        maskStyle: props.maskStyle,
        maskClassName: props.maskClassName,
        stopPropagation: props.stopPropagation,
        disableBodyScroll: props.disableBodyScroll,
        destroyOnClose: props.destroyOnClose,
        forceRender: props.forceRender
    }, element);
};
function modal_cls() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "adm-modal" + (name && "-") + name;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/show.js



var show_closeFnSet = new Set();
function show_show(props) {
    var handler = renderImperatively(/*#__PURE__*/ react.createElement(Modal, Object.assign({}, props, {
        afterClose: function() {
            var _a;
            show_closeFnSet.delete(handler.close);
            (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    })));
    show_closeFnSet.add(handler.close);
    return handler;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/alert.js



function modal_alert_alert(p) {
    var defaultProps = {
        confirmText: getDefaultConfig().locale.Modal.ok
    };
    var props = mergeProps(defaultProps, p);
    return new Promise(function(resolve) {
        show_show(Object.assign(Object.assign({}, props), {
            closeOnAction: true,
            actions: [
                {
                    key: "confirm",
                    text: props.confirmText,
                    primary: true
                }
            ],
            onAction: props.onConfirm,
            onClose: function() {
                var _a;
                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                resolve();
            }
        }));
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/confirm.js





var modal_confirm_defaultProps = {
    confirmText: "\u786E\u8BA4",
    cancelText: "\u53D6\u6D88"
};
function modal_confirm_confirm(p) {
    var _this = this;
    var locale = getDefaultConfig().locale;
    var props = mergeProps(modal_confirm_defaultProps, {
        confirmText: locale.common.confirm,
        cancelText: locale.common.cancel
    }, p);
    return new Promise(function(resolve) {
        var _this1 = _this;
        show_show(Object.assign(Object.assign({}, props), {
            closeOnAction: true,
            onClose: function() {
                var _a;
                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                resolve(false);
            },
            actions: [
                {
                    key: "confirm",
                    text: props.confirmText,
                    primary: true,
                    onClick: function() {
                        return __awaiter(_this1, void 0, void 0, runtime_default().mark(function _callee() {
                            var _a;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props);
                                    case 3:
                                        resolve(true);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                    }
                },
                {
                    key: "cancel",
                    text: props.cancelText,
                    onClick: function() {
                        return __awaiter(_this1, void 0, void 0, runtime_default().mark(function _callee() {
                            var _b;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return (_b = props.onCancel) === null || _b === void 0 ? void 0 : _b.call(props);
                                    case 3:
                                        resolve(false);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                    }
                }
            ]
        }));
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/clear.js

function clear_clear() {
    show_closeFnSet.forEach(function(close) {
        close();
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/modal/index.js







/* harmony default export */ var components_modal = (attachPropertiesToComponent(Modal, {
    show: show_show,
    alert: modal_alert_alert,
    confirm: modal_confirm_confirm,
    clear: clear_clear
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/nav-bar/nav-bar.css
var nav_bar = __webpack_require__(59590);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/LeftOutline.js

function LeftOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "LeftOutline-LeftOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "LeftOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "LeftOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M31.7053818,5.11219264 L13.5234393,22.6612572 L13.5234393,22.6612572 C12.969699,23.2125856 12.9371261,24.0863155 13.4257204,24.6755735 L13.5234393,24.7825775 L31.7045714,42.8834676 C31.7795345,42.9580998 31.8810078,43 31.9867879,43 L35.1135102,43 C35.3344241,43 35.5135102,42.8209139 35.5135102,42.6 C35.5135102,42.4936115 35.4711279,42.391606 35.3957362,42.316542 L16.7799842,23.7816937 L16.7799842,23.7816937 L35.3764658,5.6866816 C35.5347957,5.53262122 35.5382568,5.27937888 35.3841964,5.121049 C35.3088921,5.04365775 35.205497,5 35.0975148,5 L31.9831711,5 C31.8795372,5 31.7799483,5.04022164 31.7053818,5.11219264 Z",
        id: "LeftOutline-\u8DEF\u5F84",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_LeftOutline = (LeftOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/nav-bar/nav-bar.js





var nav_bar_classPrefix = "adm-nav-bar";
var nav_bar_defaultProps = {
    back: "",
    backArrow: true
};
var NavBar = function(p) {
    var props = mergeProps(nav_bar_defaultProps, p);
    var back = props.back, backArrow = props.backArrow;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(nav_bar_classPrefix)
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(nav_bar_classPrefix, "-left"),
        role: "button"
    }, back !== null && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(nav_bar_classPrefix, "-back"),
        onClick: props.onBack
    }, backArrow && /*#__PURE__*/ react.createElement("span", {
        className: "".concat(nav_bar_classPrefix, "-back-arrow")
    }, backArrow === true ? /*#__PURE__*/ react.createElement(es_LeftOutline, null) : backArrow), /*#__PURE__*/ react.createElement("span", {
        "aria-hidden": "true"
    }, back)), props.left), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(nav_bar_classPrefix, "-title")
    }, props.children), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(nav_bar_classPrefix, "-right")
    }, props.right)));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/nav-bar/index.js


/* harmony default export */ var components_nav_bar = (NavBar);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/notice-bar/notice-bar.css
var notice_bar = __webpack_require__(375);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/SoundOutline.js

function SoundOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "SoundOutline-SoundOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "SoundOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "SoundOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M28.267333,7.42364522 C28.6217345,7.94869119 28.8108515,8.56559899 28.8108515,9.19662571 L28.8108515,38.803714 C28.8108515,40.568974 27.3619563,42 25.5746535,42 C24.9357472,42 24.311136,41.8132153 23.7795338,41.4631847 L13.5176584,34.7058449 L8.3149307,34.706256 C5.93186028,34.706256 4,32.7982213 4,30.4445413 L4,17.6593971 C4,15.3057171 5.93186028,13.3976824 8.3149307,13.3976824 L13.3601634,13.3972713 L23.7795338,6.53715498 C25.2666597,5.55796489 27.2759158,5.95486009 28.267333,7.42364522 Z M40.4649231,8.99868666 C40.5511218,9.17742383 40.619996,9.32223121 40.6715457,9.43310881 C42.8085201,14.0295034 44,19.1437027 44,24.532755 C44,29.7837404 42.8687892,34.7737758 40.8339269,39.2781083 C40.7469512,39.4706362 40.6237802,39.7330988 40.4644141,40.0654961 C40.3689469,40.2647533 40.1300031,40.3488277 39.9307715,40.2533072 C39.9306414,40.2532448 39.9305113,40.2531824 39.9303812,40.2531198 C39.6706542,40.1282492 39.4751102,40.0342363 39.3437492,39.9710811 C38.9410401,39.777468 38.6130663,39.619786 38.3598279,39.498035 C38.2070716,39.4245934 38.0007263,39.3253875 37.740792,39.2004172 C37.5419104,39.104853 37.4580092,38.8662856 37.5532468,38.6672473 C37.7034937,38.3532445 37.8197479,38.104744 37.9020095,37.9217457 C39.7416376,33.8293278 40.763802,29.2989389 40.763802,24.532755 C40.763802,19.6931433 39.7099001,15.0966478 37.8164042,10.9549334 C37.7526807,10.8155487 37.6652043,10.6300308 37.5539748,10.3983796 C37.4585265,10.1993116 37.5423279,9.96050973 37.7412949,9.8648511 C37.9298799,9.7741839 38.0818373,9.70112639 38.1971671,9.64567856 C38.5403397,9.48068928 39.0100918,9.2548436 39.6064234,8.9681415 C39.6867211,8.9295363 39.7949893,8.87748349 39.9312282,8.81198307 C40.1301627,8.71623553 40.3690201,8.79982709 40.4649231,8.99868666 Z M24.954689,9.60481048 L14.4401642,16.5275765 C14.3748695,16.5705665 14.2984086,16.5934809 14.2202323,16.5934873 L8.3149307,16.5939685 L8.3149307,16.5939685 C7.76171792,16.5939685 7.30576856,17.0052668 7.24345545,17.5351457 L7.23619803,17.6593971 L7.23619803,30.4445413 C7.23619803,30.9909313 7.65263219,31.4412574 8.18892037,31.502802 L8.31467178,31.50997 L14.3775506,31.5094909 C14.4557573,31.5094847 14.5322502,31.5324045 14.5975676,31.5754153 L24.9546682,38.39546 C25.139173,38.5169545 25.3872345,38.4658746 25.508729,38.2813698 C25.5517339,38.2160614 25.5746535,38.1395804 25.5746535,38.0613845 L25.5746535,9.93889975 C25.5746535,9.71798585 25.3955674,9.53889975 25.1746535,9.53889975 C25.0964661,9.53889975 25.019993,9.56181436 24.954689,9.60481048 Z M34.6436115,11.798648 C34.7547335,12.030794 34.8419854,12.2167889 34.9053671,12.3566328 C36.590502,16.0746763 37.5276039,20.1956294 37.5276039,24.532755 C37.5276039,28.7641394 36.635639,32.7897635 35.0272837,36.4362183 C34.9380427,36.6385449 34.8101552,36.9146706 34.6436211,37.2645952 C34.5486602,37.4640326 34.3100191,37.5487723 34.1105639,37.4538487 C34.1101091,37.4536323 34.1096547,37.453415 34.1092007,37.4531968 C33.9190573,37.3618222 33.7721424,37.2912213 33.6684561,37.2413942 C33.186467,37.0097713 32.80073,36.824403 32.5112451,36.6852892 C32.3647538,36.6148919 32.1675294,36.5201144 31.9195719,36.4009569 C31.7210538,36.3055358 31.6370188,36.067582 31.7316042,35.8686644 C31.8690322,35.5796464 31.9753727,35.3500122 32.0506255,35.1797617 C33.4919206,31.9190071 34.2914059,28.3180945 34.2914059,24.532755 C34.2914059,20.6930477 33.46879,17.0431031 31.9881259,13.7454591 C31.9261905,13.6075203 31.840749,13.424362 31.7318014,13.1959842 C31.636885,12.9969991 31.7208632,12.7587263 31.919573,12.6632348 C32.0929373,12.5799233 32.2332164,12.5125112 32.3404102,12.4609985 C32.6888449,12.2935556 33.1655706,12.0644616 33.7705875,11.7737163 C33.8540198,11.7336223 33.9670458,11.6793068 34.1096655,11.6107699 C34.3087736,11.5152168 34.5476881,11.5990382 34.6433466,11.7980956 C34.643435,11.7982797 34.6435233,11.7984638 34.6436115,11.798648 Z",
        id: "SoundOutline-\u5F62\u72B6",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_SoundOutline = (SoundOutline);

;// CONCATENATED MODULE: ./node_modules/ahooks/es/useTimeout/index.js



function useTimeout(fn, delay) {
  var fnRef = es_useLatest(fn);
  var timerRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (!isNumber(delay) || delay < 0) {
      return;
    }
    timerRef.current = setTimeout(function () {
      fnRef.current();
    }, delay);
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [delay]);
  var clear = (0,react.useCallback)(function () {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);
  return clear;
}
/* harmony default export */ var es_useTimeout = (useTimeout);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-mutation-effect.js


function useMutationEffect(effect, targetRef, options) {
    var fn = es_useMemoizedFn(effect);
    (0,react.useEffect)(function() {
        var observer = new MutationObserver(function() {
            fn();
        });
        if (!targetRef.current) return;
        observer.observe(targetRef.current, options);
        return function() {
            observer.disconnect();
        };
    }, [
        targetRef
    ]);
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/notice-bar/notice-bar.js








var notice_bar_classPrefix = "adm-notice-bar";
var notice_bar_defaultProps = {
    color: "default",
    delay: 2000,
    speed: 50,
    icon: /*#__PURE__*/ react.createElement(es_SoundOutline, null)
};
var NoticeBar = /*#__PURE__*/ (0,react.memo)(function(p) {
    var start = function start() {
        if (delayLockRef.current) return;
        var container = containerRef.current;
        var text = textRef.current;
        if (!container || !text) return;
        if (container.offsetWidth >= text.offsetWidth) {
            animatingRef.current = false;
            text.style.removeProperty("transition-duration");
            text.style.removeProperty("transform");
            return;
        }
        if (animatingRef.current) return;
        var initial = !text.style.transform;
        text.style.transitionDuration = "0s";
        if (initial) {
            text.style.transform = "translateX(0)";
        } else {
            text.style.transform = "translateX(".concat(container.offsetWidth, "px)");
        }
        var distance = initial ? text.offsetWidth : container.offsetWidth + text.offsetWidth;
        animatingRef.current = true;
        text.style.transitionDuration = "".concat(Math.round(distance / speed), "s");
        text.style.transform = "translateX(-".concat(text.offsetWidth, "px)");
    };
    var props = mergeProps(notice_bar_defaultProps, p);
    var containerRef = (0,react.useRef)(null);
    var textRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), visible = ref[0], setVisible = ref[1];
    var speed = props.speed;
    var delayLockRef = (0,react.useRef)(true);
    var animatingRef = (0,react.useRef)(false);
    es_useTimeout(function() {
        delayLockRef.current = false;
        start();
    }, props.delay);
    useResizeEffect(function() {
        start();
    }, containerRef);
    useMutationEffect(function() {
        start();
    }, textRef, {
        subtree: true,
        childList: true,
        characterData: true
    });
    if (!visible) return null;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(notice_bar_classPrefix, "".concat(notice_bar_classPrefix, "-").concat(props.color))
    }, props.icon && /*#__PURE__*/ react.createElement("span", {
        className: "".concat(notice_bar_classPrefix, "-left")
    }, props.icon), /*#__PURE__*/ react.createElement("span", {
        ref: containerRef,
        className: "".concat(notice_bar_classPrefix, "-content")
    }, /*#__PURE__*/ react.createElement("span", {
        onTransitionEnd: function() {
            animatingRef.current = false;
            start();
        },
        ref: textRef,
        className: "".concat(notice_bar_classPrefix, "-content-inner")
    }, props.content)), (props.closeable || props.extra) && /*#__PURE__*/ react.createElement("span", {
        className: "".concat(notice_bar_classPrefix, "-right")
    }, props.extra, props.closeable && /*#__PURE__*/ react.createElement(es_CloseOutline, {
        className: "".concat(notice_bar_classPrefix, "-close-icon"),
        onClick: function() {
            var _a;
            setVisible(false);
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    }))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/notice-bar/index.js


/* harmony default export */ var components_notice_bar = (NoticeBar);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/picker/picker.css
var picker = __webpack_require__(91842);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/popup/popup.css
var popup = __webpack_require__(77194);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popup/popup.js














var popup_classPrefix = "adm-popup";
var popup_defaultProps = Object.assign(Object.assign({}, defaultPopupBaseProps), {
    position: "bottom"
});
var Popup = function(p) {
    var props = mergeProps(popup_defaultProps, p);
    var bodyCls = classnames_default()("".concat(popup_classPrefix, "-body"), props.bodyClassName, "".concat(popup_classPrefix, "-body-position-").concat(props.position));
    var ref = (0,react.useState)(props.visible), active = ref[0], setActive = ref[1];
    es_useIsomorphicLayoutEffect(function() {
        if (props.visible) {
            setActive(true);
        }
    }, [
        props.visible
    ]);
    var ref1 = (0,react.useRef)(null);
    useLockScroll(ref1, props.disableBodyScroll && active);
    var unmountedRef = es_useUnmountedRef();
    var percent = useSpring({
        percent: props.visible ? 0 : 100,
        config: {
            precision: 0.1,
            mass: 0.4,
            tension: 300,
            friction: 30
        },
        onRest: function() {
            var _a, _b;
            if (unmountedRef.current) return;
            setActive(props.visible);
            if (props.visible) {
                (_a = props.afterShow) === null || _a === void 0 ? void 0 : _a.call(props);
            } else {
                (_b = props.afterClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        }
    }).percent;
    var maskVisible = useInnerVisible(active && props.visible);
    var node = withStopPropagation(props.stopPropagation, withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: popup_classPrefix,
        onClick: props.onClick,
        style: {
            display: active ? undefined : "none"
        }
    }, props.mask && /*#__PURE__*/ react.createElement(components_mask, {
        visible: maskVisible,
        forceRender: props.forceRender,
        destroyOnClose: props.destroyOnClose,
        onMaskClick: function(e) {
            var _a, _b;
            (_a = props.onMaskClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            if (props.closeOnMaskClick) {
                (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        },
        className: props.maskClassName,
        style: props.maskStyle,
        disableBodyScroll: false,
        stopPropagation: props.stopPropagation
    }), /*#__PURE__*/ react.createElement(animated.div, {
        className: bodyCls,
        style: Object.assign(Object.assign({}, props.bodyStyle), {
            transform: percent.to(function(v) {
                if (props.position === "bottom") {
                    return "translate(0, ".concat(v, "%)");
                }
                if (props.position === "top") {
                    return "translate(0, -".concat(v, "%)");
                }
                if (props.position === "left") {
                    return "translate(-".concat(v, "%, 0)");
                }
                if (props.position === "right") {
                    return "translate(".concat(v, "%, 0)");
                }
                return "none";
            })
        }),
        ref: ref1
    }, props.showCloseButton && /*#__PURE__*/ react.createElement("a", {
        className: classnames_default()("".concat(popup_classPrefix, "-close-icon"), "adm-plain-anchor"),
        onClick: function() {
            var _a;
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    }, /*#__PURE__*/ react.createElement(es_CloseOutline, null)), props.children))));
    return /*#__PURE__*/ react.createElement(ShouldRender, {
        active: active,
        forceRender: props.forceRender,
        destroyOnClose: props.destroyOnClose
    }, renderToContainer(props.getContainer, node));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/popup/index.js


/* harmony default export */ var components_popup = (Popup);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var lodash_isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/measure-css-length.js


function measureCSSLength(raw) {
    if (raw === null || raw === undefined || raw === "") {
        if (is_dev_isDev) {
            devError("Global", "Seems like the you will encounter a style messed problem. Please check the browser environment to make sure it supports CSS variables.");
        }
        return 0;
    }
    var withUnit = raw.trim();
    if (withUnit.endsWith("px")) {
        return parseFloat(withUnit);
    } else if (withUnit.endsWith("rem")) {
        return parseFloat(withUnit) * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    } else if (withUnit.endsWith("vw")) {
        return parseFloat(withUnit) * window.innerWidth / 100;
    } else {
        if (is_dev_isDev) {
            devError("Global", "You are using a not supported CSS unit in `".concat(raw, "`. Only `px` `rem` and `vw` are supported."));
        }
        return 0;
    }
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker-view/wheel.js
function wheel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function wheel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function wheel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function wheel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function wheel_slicedToArray(arr, i) {
    return wheel_arrayWithHoles(arr) || wheel_iterableToArrayLimit(arr, i) || wheel_unsupportedIterableToArray(arr, i) || wheel_nonIterableRest();
}
function wheel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return wheel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wheel_arrayLikeToArray(o, minLen);
}









var wheel_classPrefix = "adm-picker-view";
var Wheel = /*#__PURE__*/ (0,react.memo)(function(props) {
    var onSelect = function onSelect(val) {
        props.onSelect(val, props.index);
    };
    var scrollSelect = function scrollSelect(index) {
        var finalPosition = index * -itemHeight.current;
        api.start({
            y: finalPosition
        });
        var item = column[index];
        if (!item) return;
        onSelect(item.value);
    };
    var renderAccessible = function renderAccessible() {
        if (selectedIndex === null) {
            return null;
        }
        var current = column[selectedIndex];
        var previousIndex = selectedIndex - 1;
        var nextIndex = selectedIndex + 1;
        var previous = column[previousIndex];
        var next = column[nextIndex];
        return /*#__PURE__*/ react.createElement("div", {
            className: "adm-picker-view-column-accessible"
        }, /*#__PURE__*/ react.createElement("div", {
            className: "adm-picker-view-column-accessible-current",
            role: "button",
            "aria-label": current ? "\u5F53\u524D\u9009\u62E9\u7684\u662F\uFF1A".concat(current.label) : "\u5F53\u524D\u672A\u9009\u62E9"
        }, "-"), /*#__PURE__*/ react.createElement("div", {
            className: "adm-picker-view-column-accessible-button",
            onClick: function() {
                if (!previous) return;
                scrollSelect(previousIndex);
            },
            role: previous ? "button" : "text",
            "aria-label": !previous ? "\u6CA1\u6709\u4E0A\u4E00\u9879" : "\u9009\u62E9\u4E0A\u4E00\u9879\uFF1A".concat(previous.label)
        }, "-"), /*#__PURE__*/ react.createElement("div", {
            className: "adm-picker-view-column-accessible-button",
            onClick: function() {
                if (!next) return;
                scrollSelect(nextIndex);
            },
            role: next ? "button" : "text",
            "aria-label": !next ? "\u6CA1\u6709\u4E0B\u4E00\u9879" : "\u9009\u62E9\u4E0B\u4E00\u9879\uFF1A".concat(next.label)
        }, "-"));
    };
    var value = props.value, column = props.column, renderLabel = props.renderLabel;
    var ref = wheel_slicedToArray(useSpring(function() {
        return {
            from: {
                y: 0
            },
            config: {
                tension: 400,
                mass: 0.8
            }
        };
    }), 2), y = ref[0].y, api = ref[1];
    var draggingRef = (0,react.useRef)(false);
    var rootRef = (0,react.useRef)(null);
    var itemHeight = (0,react.useRef)(34);
    es_useIsomorphicLayoutEffect(function() {
        var root = rootRef.current;
        if (!root) return;
        itemHeight.current = measureCSSLength(window.getComputedStyle(root).getPropertyValue("--item-height"));
    });
    es_useIsomorphicLayoutEffect(function() {
        if (draggingRef.current) return;
        if (value === null) return;
        var targetIndex = column.findIndex(function(item) {
            return item.value === value;
        });
        if (targetIndex < 0) return;
        var finalPosition = targetIndex * -itemHeight.current;
        api.start({
            y: finalPosition,
            immediate: y.goal !== finalPosition
        });
    }, [
        value,
        column
    ]);
    es_useIsomorphicLayoutEffect(function() {
        if (column.length === 0) {
            if (value !== null) {
                onSelect(null);
            }
        } else {
            if (!column.some(function(item) {
                return item.value === value;
            })) {
                var firstItem = column[0];
                onSelect(firstItem.value);
            }
        }
    }, [
        column,
        value
    ]);
    var handleDrag = function(state) {
        draggingRef.current = true;
        var min = -((column.length - 1) * itemHeight.current);
        var max = 0;
        if (state.last) {
            draggingRef.current = false;
            var position = state.offset[1] + state.velocity[1] * state.direction[1] * 50;
            var targetIndex = min < max ? -Math.round(bound(position, min, max) / itemHeight.current) : 0;
            scrollSelect(targetIndex);
        } else {
            var position1 = state.offset[1];
            api.start({
                y: rubberbandIfOutOfBounds(position1, min, max, itemHeight.current * 50, 0.2)
            });
        }
    };
    useDrag(function(state) {
        state.event.stopPropagation();
        handleDrag(state);
    }, {
        axis: "y",
        from: function() {
            return [
                0,
                y.get()
            ];
        },
        filterTaps: true,
        pointer: {
            touch: true
        },
        target: rootRef
    });
    useWheel(function(state) {
        state.event.stopPropagation();
        handleDrag(state);
    }, {
        axis: "y",
        from: function() {
            return [
                0,
                y.get()
            ];
        },
        preventDefault: true,
        target: props.mouseWheel ? rootRef : undefined,
        eventOptions: supportsPassive ? {
            passive: false
        } : false
    });
    var selectedIndex = null;
    return /*#__PURE__*/ react.createElement("div", {
        className: "".concat(wheel_classPrefix, "-column")
    }, /*#__PURE__*/ react.createElement(animated.div, {
        ref: rootRef,
        style: {
            translateY: y
        },
        className: "".concat(wheel_classPrefix, "-column-wheel"),
        "aria-hidden": true
    }, column.map(function(item, index) {
        var handleClick = function handleClick() {
            draggingRef.current = false;
            scrollSelect(index);
        };
        var _a;
        var selected = props.value === item.value;
        if (selected) selectedIndex = index;
        return /*#__PURE__*/ react.createElement("div", {
            key: (_a = item.key) !== null && _a !== void 0 ? _a : item.value,
            "data-selected": item.value === value,
            className: "".concat(wheel_classPrefix, "-column-item"),
            onClick: handleClick,
            "aria-hidden": !selected,
            "aria-label": selected ? "active" : ""
        }, /*#__PURE__*/ react.createElement("div", {
            className: "".concat(wheel_classPrefix, "-column-item-label")
        }, renderLabel(item)));
    })), renderAccessible());
}, function(prev, next) {
    if (prev.index !== next.index) return false;
    if (prev.value !== next.value) return false;
    if (prev.onSelect !== next.onSelect) return false;
    if (!isEqual_default()(prev.column, next.column)) {
        return false;
    }
    return true;
});
Wheel.displayName = "Wheel";

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/with-cache.js
function withCache(generate) {
    var cache = null;
    return function() {
        if (cache === null) {
            cache = generate();
        }
        return cache;
    };
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker-view/columns-extend.js


function generateColumnsExtend(rawColumns, val) {
    var columns = withCache(function() {
        var c = typeof rawColumns === "function" ? rawColumns(val) : rawColumns;
        return c.map(function(column) {
            return column.map(function(item) {
                return typeof item === "string" ? {
                    label: item,
                    value: item
                } : item;
            });
        });
    });
    var items = withCache(function() {
        return val.map(function(v, index) {
            var _a;
            var column = columns()[index];
            if (!column) return null;
            return (_a = column.find(function(item) {
                return item.value === v;
            })) !== null && _a !== void 0 ? _a : null;
        });
    });
    var extend = {
        get columns () {
            return columns();
        },
        get items () {
            return items();
        }
    };
    return extend;
}
function useColumnsExtend(rawColumns, value) {
    return (0,react.useMemo)(function() {
        return generateColumnsExtend(rawColumns, value);
    }, [
        rawColumns,
        value
    ]);
}

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useDebounceFn/index.js
var useDebounceFn_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var useDebounceFn_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};






function useDebounceFn(fn, options) {
  var _a;
  if (utils_isDev) {
    if (!isFunction(fn)) {
      console.error("useDebounceFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = es_useLatest(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var debounced = (0,react.useMemo)(function () {
    return debounce_default()(function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(fnRef, useDebounceFn_spreadArray([], useDebounceFn_read(args), false));
    }, wait, options);
  }, []);
  es_useUnmount(function () {
    debounced.cancel();
  });
  return {
    run: debounced,
    cancel: debounced.cancel,
    flush: debounced.flush
  };
}
/* harmony default export */ var es_useDebounceFn = (useDebounceFn);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js


/* harmony default export */ var useUpdateEffect = (createUpdateEffect(react.useEffect));
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useDebounceEffect/index.js
var useDebounceEffect_read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};



function useDebounceEffect(effect, deps, options) {
  var _a = useDebounceEffect_read((0,react.useState)({}), 2),
    flag = _a[0],
    setFlag = _a[1];
  var run = es_useDebounceFn(function () {
    setFlag({});
  }, options).run;
  (0,react.useEffect)(function () {
    return run();
  }, deps);
  useUpdateEffect(effect, [flag]);
}
/* harmony default export */ var es_useDebounceEffect = (useDebounceEffect);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker/picker-utils.js
var defaultRenderLabel = function(item) {
    return item.label;
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker-view/picker-view.js
function picker_view_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function picker_view_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return picker_view_arrayLikeToArray(arr);
}
function picker_view_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function picker_view_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function picker_view_toConsumableArray(arr) {
    return picker_view_arrayWithoutHoles(arr) || picker_view_iterableToArray(arr) || picker_view_unsupportedIterableToArray(arr) || picker_view_nonIterableSpread();
}
function picker_view_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return picker_view_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return picker_view_arrayLikeToArray(o, minLen);
}








var picker_view_classPrefix = "adm-picker-view";
var picker_view_defaultProps = {
    defaultValue: [],
    renderLabel: defaultRenderLabel,
    mouseWheel: false,
    loadingContent: /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix, "-loading-content")
    }, /*#__PURE__*/ react.createElement(components_spin_loading, null))
};
var PickerView = /*#__PURE__*/ (0,react.memo)(function(p) {
    var props = mergeProps(picker_view_defaultProps, p);
    var ref = (0,react.useState)(props.value === undefined ? props.defaultValue : props.value), innerValue = ref[0], setInnerValue = ref[1]; // Sync `value` to `innerValue`
    (0,react.useEffect)(function() {
        if (props.value === undefined) return; // Uncontrolled mode
        if (props.value === innerValue) return;
        setInnerValue(props.value);
    }, [
        props.value
    ]);
    (0,react.useEffect)(function() {
        if (props.value === innerValue) return;
        var timeout = window.setTimeout(function() {
            if (props.value !== undefined && props.value !== innerValue) {
                setInnerValue(props.value);
            }
        }, 1000);
        return function() {
            window.clearTimeout(timeout);
        };
    }, [
        props.value,
        innerValue
    ]);
    var extend = useColumnsExtend(props.columns, innerValue);
    var columns = extend.columns;
    es_useDebounceEffect(function() {
        var _a;
        if (props.value === innerValue) return;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, innerValue, extend);
    }, [
        innerValue
    ], {
        wait: 0,
        leading: false,
        trailing: true
    });
    var handleSelect = (0,react.useCallback)(function(val, index) {
        setInnerValue(function(prev) {
            var next = picker_view_toConsumableArray(prev);
            next[index] = val;
            return next;
        });
    }, []);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix)
    }, props.loading ? props.loadingContent : /*#__PURE__*/ react.createElement(react.Fragment, null, columns.map(function(column, index) {
        return /*#__PURE__*/ react.createElement(Wheel, {
            key: index,
            index: index,
            column: column,
            value: innerValue[index],
            onSelect: handleSelect,
            renderLabel: props.renderLabel,
            mouseWheel: props.mouseWheel
        });
    }), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix, "-mask")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix, "-mask-top")
    }), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix, "-mask-middle")
    }), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_view_classPrefix, "-mask-bottom")
    })))));
});
PickerView.displayName = "PickerView";

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/picker-view/picker-view.css
var picker_view = __webpack_require__(23673);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker-view/index.js


/* harmony default export */ var components_picker_view = (PickerView);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker/picker.js
function picker_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function picker_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function picker_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function picker_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function picker_slicedToArray(arr, i) {
    return picker_arrayWithHoles(arr) || picker_iterableToArrayLimit(arr, i) || picker_unsupportedIterableToArray(arr, i) || picker_nonIterableRest();
}
function picker_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return picker_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return picker_arrayLikeToArray(o, minLen);
}












var picker_classPrefix = "adm-picker";
var picker_defaultProps = {
    defaultValue: [],
    closeOnMaskClick: true,
    renderLabel: defaultRenderLabel,
    destroyOnClose: false,
    forceRender: false
};
var Picker = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var _a1;
    var locale = useConfig().locale;
    var props = mergeProps(picker_defaultProps, {
        confirmText: locale.common.confirm,
        cancelText: locale.common.cancel
    }, p);
    var _$ref = picker_slicedToArray(usePropsValue({
        value: props.visible,
        defaultValue: false,
        onChange: function(v) {
            var _a;
            if (v === false) {
                (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
            }
        }
    }), 2), visible = _$ref[0], setVisible = _$ref[1];
    var actions = {
        toggle: function() {
            setVisible(function(v) {
                return !v;
            });
        },
        open: function() {
            setVisible(true);
        },
        close: function() {
            setVisible(false);
        }
    };
    (0,react.useImperativeHandle)(ref, function() {
        return actions;
    });
    var _$ref1 = picker_slicedToArray(usePropsValue(Object.assign(Object.assign({}, props), {
        onChange: function(val) {
            var _a;
            var extend = generateColumnsExtend(props.columns, val);
            (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, val, extend);
        }
    })), 2), value = _$ref1[0], setValue = _$ref1[1];
    var extend1 = useColumnsExtend(props.columns, value);
    var _$ref2 = (0,react.useState)(value), innerValue = _$ref2[0], setInnerValue = _$ref2[1];
    (0,react.useEffect)(function() {
        if (innerValue !== value) {
            setInnerValue(value);
        }
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        if (!visible) {
            setInnerValue(value);
        }
    }, [
        value
    ]);
    var onChange = es_useMemoizedFn(function(val, ext) {
        var _a;
        setInnerValue(val);
        if (visible) {
            (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, val, ext);
        }
    });
    var pickerElement = withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: picker_classPrefix
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_classPrefix, "-header")
    }, /*#__PURE__*/ react.createElement("a", {
        role: "button",
        className: "".concat(picker_classPrefix, "-header-button"),
        onClick: function() {
            var _a;
            (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
            setVisible(false);
        }
    }, props.cancelText), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_classPrefix, "-header-title")
    }, props.title), /*#__PURE__*/ react.createElement("a", {
        role: "button",
        className: classnames_default()("".concat(picker_classPrefix, "-header-button"), props.loading && "".concat(picker_classPrefix, "-header-button-disabled")),
        onClick: function() {
            if (props.loading) return;
            setValue(innerValue, true);
            setVisible(false);
        },
        "aria-disabled": props.loading
    }, props.confirmText)), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(picker_classPrefix, "-body")
    }, /*#__PURE__*/ react.createElement(components_picker_view, {
        loading: props.loading,
        loadingContent: props.loadingContent,
        columns: props.columns,
        renderLabel: props.renderLabel,
        value: innerValue,
        mouseWheel: props.mouseWheel,
        onChange: onChange
    }))));
    var popupElement = /*#__PURE__*/ react.createElement(components_popup, {
        style: props.popupStyle,
        className: classnames_default()("".concat(picker_classPrefix, "-popup"), props.popupClassName),
        visible: visible,
        position: "bottom",
        onMaskClick: function() {
            var _a;
            if (!props.closeOnMaskClick) return;
            (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
            setVisible(false);
        },
        getContainer: props.getContainer,
        destroyOnClose: props.destroyOnClose,
        afterShow: props.afterShow,
        afterClose: props.afterClose,
        onClick: props.onClick,
        forceRender: props.forceRender,
        stopPropagation: props.stopPropagation
    }, pickerElement, /*#__PURE__*/ react.createElement(components_safe_area, {
        position: "bottom"
    }));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, popupElement, (_a1 = props.children) === null || _a1 === void 0 ? void 0 : _a1.call(props, extend1.items, actions));
}));
Picker.displayName = "Picker";

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker/prompt.js



function prompt_prompt(props) {
    return new Promise(function(resolve) {
        var Wrapper = function() {
            var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
            (0,react.useEffect)(function() {
                setVisible(true);
            }, []);
            return /*#__PURE__*/ react.createElement(Picker, Object.assign({}, props, {
                visible: visible,
                onConfirm: function(val, extend) {
                    var _a;
                    (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, val, extend);
                    resolve(val);
                },
                onClose: function() {
                    var _a;
                    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                    setVisible(false);
                    resolve(null);
                },
                afterClose: function() {
                    var _a;
                    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
                    unmount();
                }
            }));
        };
        var unmount = renderToBody(/*#__PURE__*/ react.createElement(Wrapper, null));
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/picker/index.js




/* harmony default export */ var components_picker = (attachPropertiesToComponent(Picker, {
    prompt: prompt_prompt
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/rate/rate.css
var rate = __webpack_require__(37414);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/rate/star.js

var Star = function() {
    // return (
    //   <svg height='1em' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
    //     <title>{'star-fill\u5907\u4EFD 71'}</title>
    //     <path
    //       d='m24 36-10.52 5.53a2 2 0 0 1-2.902-2.108l2.01-11.714-8.511-8.296a2 2 0 0 1 1.108-3.411l11.762-1.71 5.26-10.657a2 2 0 0 1 3.586 0l5.26 10.658L42.815 16a2 2 0 0 1 1.108 3.411l-8.51 8.296 2.009 11.714a2 2 0 0 1-2.902 2.109L24 36Z'
    //       fill='#E5E5E5'
    //       fillRule='evenodd'
    //     />
    //   </svg>
    // )
    return /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 42 40",
        height: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            verticalAlign: "-0.125em"
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "m21 34-10.52 5.53a2 2 0 0 1-2.902-2.108l2.01-11.714-8.511-8.296a2 2 0 0 1 1.108-3.411l11.762-1.71 5.26-10.657a2 2 0 0 1 3.586 0l5.26 10.658L39.815 14a2 2 0 0 1 1.108 3.411l-8.51 8.296 2.009 11.714a2 2 0 0 1-2.902 2.109L21 34Z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/rate/rate.js
function rate_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function rate_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function rate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function rate_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function rate_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function rate_slicedToArray(arr, i) {
    return rate_arrayWithHoles(arr) || rate_iterableToArrayLimit(arr, i) || rate_unsupportedIterableToArray(arr, i) || rate_nonIterableRest();
}
function rate_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return rate_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rate_arrayLikeToArray(o, minLen);
}






var rate_classPrefix = "adm-rate";
var rate_defaultProps = {
    count: 5,
    allowHalf: false,
    character: /*#__PURE__*/ react.createElement(Star, null),
    defaultValue: 0,
    readOnly: false,
    allowClear: true
};
var Rate = function(p) {
    var renderStar = function renderStar(v, half) {
        var _obj;
        return /*#__PURE__*/ react.createElement("div", {
            className: classnames_default()("".concat(rate_classPrefix, "-star"), (_obj = {}, rate_defineProperty(_obj, "".concat(rate_classPrefix, "-star-active"), value >= v), rate_defineProperty(_obj, "".concat(rate_classPrefix, "-star-half"), half), rate_defineProperty(_obj, "".concat(rate_classPrefix, "-star-readonly"), props.readOnly), _obj)),
            onClick: function() {
                if (props.readOnly) return;
                if (props.allowClear && value === v) {
                    setValue(0);
                } else {
                    setValue(v);
                }
            }
        }, props.character);
    };
    var props = mergeProps(rate_defaultProps, p);
    var ref = rate_slicedToArray(usePropsValue(props), 2), value = ref[0], setValue = ref[1];
    var starList = Array(props.count).fill(null);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: rate_classPrefix
    }, starList.map(function(_, i) {
        return /*#__PURE__*/ react.createElement("div", {
            key: i,
            className: classnames_default()("".concat(rate_classPrefix, "-box"))
        }, props.allowHalf && renderStar(i + 0.5, true), renderStar(i + 1, false));
    })));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/rate/index.js


/* harmony default export */ var components_rate = (Rate);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/search-bar/search-bar.css
var search_bar = __webpack_require__(19785);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/SearchOutline.js

function SearchOutline(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "SearchOutline-SearchOutline",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        id: "SearchOutline-\u7F16\u7EC4"
    }, /*#__PURE__*/ react.createElement("rect", {
        id: "SearchOutline-\u77E9\u5F62",
        fill: "#FFFFFF",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M10.2434135,10.1505371 C17.2346315,3.28315429 28.5696354,3.28315429 35.5608534,10.1505371 C42.3159331,16.7859644 42.5440954,27.4048667 36.2453405,34.3093889 L43.7095294,41.6422249 C43.8671196,41.7970419 43.8693677,42.0502979 43.7145508,42.2078881 C43.7128864,42.2095822 43.7112069,42.2112616 43.7095126,42.2129259 L42.1705322,43.7246464 C42.014915,43.8775072 41.7655181,43.8775006 41.6099089,43.7246316 L34.0775268,36.3248916 L34.0775268,36.3248916 C27.0485579,41.8551751 16.7593545,41.4200547 10.2434135,35.0195303 C3.25219551,28.1521474 3.25219551,17.0179199 10.2434135,10.1505371 Z M12.3532001,12.2229532 C6.52718516,17.9457722 6.52718516,27.2242951 12.3532001,32.9471142 C18.1792151,38.6699332 27.6250517,38.6699332 33.4510667,32.9471142 C39.2770817,27.2242951 39.2770817,17.9457722 33.4510667,12.2229532 C27.6250517,6.50013419 18.1792151,6.50013419 12.3532001,12.2229532 Z",
        id: "SearchOutline-\u5F62\u72B6",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_SearchOutline = (SearchOutline);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/search-bar/search-bar.js
function search_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_bar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_bar_slicedToArray(arr, i) {
    return search_bar_arrayWithHoles(arr) || search_bar_iterableToArrayLimit(arr, i) || search_bar_unsupportedIterableToArray(arr, i) || search_bar_nonIterableRest();
}
function search_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_bar_arrayLikeToArray(o, minLen);
}









var search_bar_classPrefix = "adm-search-bar";
var search_bar_defaultProps = {
    clearable: true,
    onlyShowClearWhenFocus: false,
    showCancelButton: false,
    defaultValue: "",
    clearOnCancel: true,
    icon: /*#__PURE__*/ react.createElement(es_SearchOutline, null)
};
var SearchBar = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var locale = useConfig().locale;
    var props = mergeProps(search_bar_defaultProps, {
        cancelText: locale.common.cancel
    }, p);
    var _$ref = search_bar_slicedToArray(usePropsValue(props), 2), value = _$ref[0], setValue = _$ref[1];
    var _$ref1 = (0,react.useState)(false), hasFocus = _$ref1[0], setHasFocus = _$ref1[1];
    var inputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            clear: function() {
                var _a;
                return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.clear();
            },
            focus: function() {
                var _a;
                return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: function() {
                var _a;
                return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
            get nativeElement () {
                var _a1, _b;
                return (_b = (_a1 = inputRef.current) === null || _a1 === void 0 ? void 0 : _a1.nativeElement) !== null && _b !== void 0 ? _b : null;
            }
        };
    });
    var renderCancelButton = function() {
        var isShowCancel;
        if (typeof props.showCancelButton === "function") {
            isShowCancel = props.showCancelButton(hasFocus, value);
        } else {
            isShowCancel = props.showCancelButton && hasFocus;
        }
        return isShowCancel && /*#__PURE__*/ react.createElement("div", {
            className: "".concat(search_bar_classPrefix, "-suffix")
        }, /*#__PURE__*/ react.createElement(components_button, {
            fill: "none",
            className: "".concat(search_bar_classPrefix, "-cancel-button"),
            onClick: function() {
                var _a, _b, _c;
                if (props.clearOnCancel) {
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.clear();
                }
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                (_c = props.onCancel) === null || _c === void 0 ? void 0 : _c.call(props);
            },
            onMouseDown: function(e) {
                e.preventDefault();
            }
        }, props.cancelText));
    };
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(search_bar_classPrefix, search_bar_defineProperty({}, "".concat(search_bar_classPrefix, "-active"), hasFocus))
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(search_bar_classPrefix, "-input-box")
    }, props.icon && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(search_bar_classPrefix, "-input-box-icon")
    }, props.icon), /*#__PURE__*/ react.createElement(components_input, {
        ref: inputRef,
        className: classnames_default()("".concat(search_bar_classPrefix, "-input"), search_bar_defineProperty({}, "".concat(search_bar_classPrefix, "-input-without-icon"), !props.icon)),
        value: value,
        onChange: setValue,
        maxLength: props.maxLength,
        placeholder: props.placeholder,
        clearable: props.clearable,
        onlyShowClearWhenFocus: props.onlyShowClearWhenFocus,
        onFocus: function(e) {
            var _a;
            setHasFocus(true);
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: function(e) {
            var _a;
            setHasFocus(false);
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onClear: props.onClear,
        type: "search",
        enterKeyHint: "search",
        onEnterPress: function() {
            var _a, _b;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            (_b = props.onSearch) === null || _b === void 0 ? void 0 : _b.call(props, value);
        }
    })), renderCancelButton()));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/search-bar/index.js


/* harmony default export */ var components_search_bar = (SearchBar);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/selector/selector.css
var selector = __webpack_require__(49779);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/grid/grid.css
var grid = __webpack_require__(4400);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/grid/grid.js




var grid_classPrefix = "adm-grid";
var Grid = function(props) {
    var style = {
        "--columns": props.columns.toString()
    };
    var gap = props.gap;
    if (gap !== undefined) {
        if (Array.isArray(gap)) {
            style["--gap-horizontal"] = toCSSLength(gap[0]);
            style["--gap-vertical"] = toCSSLength(gap[1]);
        } else {
            style["--gap"] = toCSSLength(gap);
        }
    }
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: grid_classPrefix,
        style: style
    }, props.children));
};
var GridItem = function(p) {
    var props = mergeProps({
        span: 1
    }, p);
    var itemStyle = {
        "--item-span": props.span
    };
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(grid_classPrefix, "-item"),
        style: itemStyle,
        onClick: props.onClick
    }, props.children));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/grid/index.js



/* harmony default export */ var components_grid = (attachPropertiesToComponent(Grid, {
    Item: GridItem
}));

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/selector/check-mark.js

var CheckMark = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ react.createElement("svg", {
        width: "17px",
        height: "13px",
        viewBox: "0 0 17 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(-2832.000000, -1103.000000)",
        stroke: "#FFFFFF",
        strokeWidth: "3"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(2610.000000, 955.000000)"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(24.000000, 91.000000)"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(179.177408, 36.687816)"
    }, /*#__PURE__*/ react.createElement("polyline", {
        points: "34.2767388 22 24.797043 31.4796958 21 27.6826527"
    })))))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/selector/selector.js
function selector_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function selector_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function selector_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return selector_arrayLikeToArray(arr);
}
function selector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selector_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function selector_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function selector_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function selector_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function selector_slicedToArray(arr, i) {
    return selector_arrayWithHoles(arr) || selector_iterableToArrayLimit(arr, i) || selector_unsupportedIterableToArray(arr, i) || selector_nonIterableRest();
}
function selector_toConsumableArray(arr) {
    return selector_arrayWithoutHoles(arr) || selector_iterableToArray(arr) || selector_unsupportedIterableToArray(arr) || selector_nonIterableSpread();
}
function selector_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return selector_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return selector_arrayLikeToArray(o, minLen);
}









var selector_classPrefix = "adm-selector";
var selector_defaultProps = {
    multiple: false,
    defaultValue: [],
    showCheckMark: true
};
var Selector = function(p) {
    var props = mergeProps(selector_defaultProps, p);
    var ref = selector_slicedToArray(usePropsValue({
        value: props.value,
        defaultValue: props.defaultValue,
        onChange: function(val) {
            var _a;
            var extend = {
                get items () {
                    return props.options.filter(function(option) {
                        return val.includes(option.value);
                    });
                }
            };
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val, extend);
        }
    }), 2), value = ref[0], setValue = ref[1];
    var items = props.options.map(function(option) {
        var active = (value || []).includes(option.value);
        var disabled = option.disabled || props.disabled;
        var _obj;
        var itemCls = classnames_default()("".concat(selector_classPrefix, "-item"), (_obj = {}, selector_defineProperty(_obj, "".concat(selector_classPrefix, "-item-active"), active && !props.multiple), selector_defineProperty(_obj, "".concat(selector_classPrefix, "-item-multiple-active"), active && props.multiple), selector_defineProperty(_obj, "".concat(selector_classPrefix, "-item-disabled"), disabled), _obj));
        return /*#__PURE__*/ react.createElement("div", {
            key: option.value,
            className: itemCls,
            onClick: function() {
                if (disabled) {
                    return;
                }
                if (props.multiple) {
                    var val = active ? value.filter(function(v) {
                        return v !== option.value;
                    }) : selector_toConsumableArray(value).concat([
                        option.value
                    ]);
                    setValue(val);
                } else {
                    var val1 = active ? [] : [
                        option.value
                    ];
                    setValue(val1);
                }
            }
        }, option.label, option.description && /*#__PURE__*/ react.createElement("div", {
            className: "".concat(selector_classPrefix, "-item-description")
        }, option.description), active && props.showCheckMark && /*#__PURE__*/ react.createElement("div", {
            className: "".concat(selector_classPrefix, "-check-mark-wrapper")
        }, /*#__PURE__*/ react.createElement(CheckMark, null)));
    });
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: selector_classPrefix
    }, !props.columns && /*#__PURE__*/ react.createElement(components_space, {
        wrap: true
    }, items), props.columns && /*#__PURE__*/ react.createElement(components_grid, {
        columns: props.columns,
        gap: convertPx(8)
    }, items)));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/selector/index.js


/* harmony default export */ var components_selector = (Selector);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/slider/slider.css
var slider = __webpack_require__(68643);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/ticks.js
function ticks_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var ticks_classPrefix = "adm-slider";
var Ticks = function(param) {
    var points = param.points, max = param.max, min = param.min, upperBound = param.upperBound, lowerBound = param.lowerBound;
    var range = max - min;
    var elements = points.map(function(point) {
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = point <= upperBound && point >= lowerBound;
        var style = {
            left: offset
        };
        var _obj;
        var pointClassName = classnames_default()((_obj = {}, ticks_defineProperty(_obj, "".concat(ticks_classPrefix, "-tick"), true), ticks_defineProperty(_obj, "".concat(ticks_classPrefix, "-tick-active"), isActived), _obj));
        return /*#__PURE__*/ react.createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ react.createElement("div", {
        className: "".concat(ticks_classPrefix, "-ticks")
    }, elements);
};
/* harmony default export */ var slider_ticks = (Ticks);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/marks.js
function marks_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var marks_classPrefix = "adm-slider-mark";
var Marks = function(param) {
    var marks = param.marks, upperBound = param.upperBound, lowerBound = param.lowerBound, max = param.max, min = param.min;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).filter(function(point) {
        return point >= min && point <= max;
    }).map(function(point) {
        var markPoint = marks[point];
        if (!markPoint && markPoint !== 0) {
            return null;
        }
        var isActive = point <= upperBound && point >= lowerBound;
        var _obj;
        var markClassName = classnames_default()((_obj = {}, marks_defineProperty(_obj, "".concat(marks_classPrefix, "-text"), true), marks_defineProperty(_obj, "".concat(marks_classPrefix, "-text-active"), isActive), _obj));
        var style = {
            left: "".concat((point - min) / range * 100, "%")
        };
        return /*#__PURE__*/ react.createElement("span", {
            className: markClassName,
            style: style,
            key: point
        }, markPoint);
    });
    return /*#__PURE__*/ react.createElement("div", {
        className: marks_classPrefix
    }, elements);
};
/* harmony default export */ var slider_marks = (Marks);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/thumb-icon.js


var ThumbIcon = function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("rect", {
        x: 10,
        width: 4,
        height: 24,
        rx: 2
    }), /*#__PURE__*/ react.createElement("rect", {
        y: 4,
        width: 4,
        height: 16,
        rx: 2
    }), /*#__PURE__*/ react.createElement("rect", {
        x: 20,
        y: 4,
        width: 4,
        height: 16,
        rx: 2
    }))));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/thumb.js





var thumb_classPrefix = "adm-slider";
var Thumb = function(props) {
    var value1 = props.value, min = props.min, max = props.max, disabled = props.disabled, onDrag = props.onDrag, icon = props.icon;
    var prevValue = (0,react.useRef)(value1);
    var locale = useConfig().locale;
    var currentPosition = function() {
        return {
            left: "".concat((value1 - min) / (max - min) * 100, "%"),
            right: "auto"
        };
    };
    var ref = (0,react.useState)(false), dragging = ref[0], setDragging = ref[1];
    var bind = useDrag(function(state) {
        var _a;
        if (disabled) return;
        if (state.first) {
            prevValue.current = value1;
        }
        var x = state.xy[0] - state.initial[0];
        var sliderOffsetWith = (_a = props.trackRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        if (!sliderOffsetWith) return;
        var diff = x / Math.ceil(sliderOffsetWith) * (max - min);
        onDrag(prevValue.current + diff, state.first, state.last);
        setDragging(!state.last);
    }, {
        axis: "x",
        pointer: {
            touch: true
        }
    });
    var renderPopoverContent = typeof props.popover === "function" ? props.popover : props.popover ? function(value) {
        return value.toString();
    } : null;
    var thumbElement = /*#__PURE__*/ react.createElement("div", {
        className: "".concat(thumb_classPrefix, "-thumb")
    }, icon ? icon : /*#__PURE__*/ react.createElement(ThumbIcon, {
        className: "".concat(thumb_classPrefix, "-thumb-icon")
    }));
    return /*#__PURE__*/ react.createElement("div", Object.assign({
        className: "".concat(thumb_classPrefix, "-thumb-container"),
        style: currentPosition()
    }, bind(), {
        role: "slider",
        "aria-label": props["aria-label"] || locale.Slider.name,
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value1,
        "aria-disabled": disabled
    }), renderPopoverContent ? /*#__PURE__*/ react.createElement(Popover, {
        content: renderPopoverContent(value1),
        placement: "top",
        visible: dragging,
        getContainer: null,
        mode: "dark"
    }, thumbElement) : thumbElement);
};
/* harmony default export */ var thumb = (Thumb);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/nearest.js
function nearest(arr, target) {
    return arr.reduce(function(pre, cur) {
        return Math.abs(pre - target) < Math.abs(cur - target) ? pre : cur;
    });
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/slider.js
function slider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function slider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function slider_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return slider_arrayLikeToArray(arr);
}
function slider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slider_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function slider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function slider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function slider_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function slider_slicedToArray(arr, i) {
    return slider_arrayWithHoles(arr) || slider_iterableToArrayLimit(arr, i) || slider_unsupportedIterableToArray(arr, i) || slider_nonIterableRest();
}
function slider_toConsumableArray(arr) {
    return slider_arrayWithoutHoles(arr) || slider_iterableToArray(arr) || slider_unsupportedIterableToArray(arr) || slider_nonIterableSpread();
}
function slider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return slider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return slider_arrayLikeToArray(o, minLen);
}









var slider_classPrefix = "adm-slider";
var slider_defaultProps = {
    min: 0,
    max: 100,
    step: 1,
    ticks: false,
    range: false,
    disabled: false,
    popover: false
};
var Slider = function(p) {
    var sortValue = function sortValue(val) {
        return val.sort(function(a, b) {
            return a - b;
        });
    };
    var convertValue = function convertValue(value) {
        return props.range ? value : [
            props.min,
            value
        ];
    };
    var reverseValue = function reverseValue(value) {
        return props.range ? value : value[1];
    };
    var onAfterChange = function onAfterChange(value) {
        var _a;
        (_a = props.onAfterChange) === null || _a === void 0 ? void 0 : _a.call(props, reverseValue(value));
    };
    var setSliderValue = function setSliderValue(value) {
        var next = sortValue(value);
        var current = sliderValue;
        if (next[0] === current[0] && next[1] === current[1]) return;
        setRawValue(reverseValue(next));
    };
    var getValueByPosition = function getValueByPosition(position) {
        var newPosition = position < min ? min : position > max ? max : position;
        var value = min; // 显示了刻度点，就只能移动到点上
        if (pointList.length) {
            value = nearest(pointList, newPosition);
        } else {
            var lengthPerStep = 100 / ((max - min) / step);
            var steps = Math.round(newPosition / lengthPerStep);
            value = steps * lengthPerStep * (max - min) * 0.01 + min;
        }
        return value;
    };
    var _a1;
    var props = mergeProps(slider_defaultProps, p);
    var min = props.min, max = props.max, disabled = props.disabled, marks = props.marks, ticks = props.ticks, step = props.step, icon = props.icon;
    var ref = slider_slicedToArray(usePropsValue({
        value: props.value,
        defaultValue: (_a1 = props.defaultValue) !== null && _a1 !== void 0 ? _a1 : props.range ? [
            min,
            min
        ] : min,
        onChange: props.onChange
    }), 2), rawValue = ref[0], setRawValue = ref[1];
    var sliderValue = sortValue(convertValue(rawValue));
    var trackRef = (0,react.useRef)(null);
    var fillSize = "".concat(100 * (sliderValue[1] - sliderValue[0]) / (max - min), "%");
    var fillStart = "".concat(100 * (sliderValue[0] - min) / (max - min), "%"); // 计算要显示的点
    var pointList = (0,react.useMemo)(function() {
        if (marks) {
            return Object.keys(marks).map(parseFloat).sort(function(a, b) {
                return a - b;
            });
        } else {
            var points = [];
            for(var i = min; i <= max; i += step){
                points.push(i);
            }
            return points;
        }
    }, [
        marks,
        ticks,
        step,
        min,
        max
    ]);
    var dragLockRef = (0,react.useRef)(0);
    var onTrackClick = function(event) {
        if (dragLockRef.current > 0) return;
        event.stopPropagation();
        if (disabled) return;
        var track = trackRef.current;
        if (!track) return;
        var sliderOffsetLeft = track.getBoundingClientRect().left;
        var position = (event.clientX - sliderOffsetLeft) / Math.ceil(track.offsetWidth) * (max - min) + min;
        var targetValue = getValueByPosition(position);
        var nextSliderValue;
        if (props.range) {
            // 移动的滑块采用就近原则
            if (Math.abs(targetValue - sliderValue[0]) > Math.abs(targetValue - sliderValue[1])) {
                nextSliderValue = [
                    sliderValue[0],
                    targetValue
                ];
            } else {
                nextSliderValue = [
                    targetValue,
                    sliderValue[1]
                ];
            }
        } else {
            nextSliderValue = [
                props.min,
                targetValue
            ];
        }
        setSliderValue(nextSliderValue);
        onAfterChange(nextSliderValue);
    };
    var valueBeforeDragRef = (0,react.useRef)();
    var renderThumb = function(index) {
        return /*#__PURE__*/ react.createElement(thumb, {
            key: index,
            value: sliderValue[index],
            min: min,
            max: max,
            disabled: disabled,
            trackRef: trackRef,
            icon: icon,
            popover: props.popover,
            onDrag: function(position, first, last) {
                if (first) {
                    dragLockRef.current += 1;
                    valueBeforeDragRef.current = sliderValue;
                }
                var val = getValueByPosition(position);
                var valueBeforeDrag = valueBeforeDragRef.current;
                if (!valueBeforeDrag) return;
                var next = slider_toConsumableArray(valueBeforeDrag);
                next[index] = val;
                setSliderValue(next);
                if (last) {
                    onAfterChange(next);
                    window.setTimeout(function() {
                        dragLockRef.current -= 1;
                    }, 100);
                }
            },
            "aria-label": props["aria-label"]
        });
    };
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(slider_classPrefix, slider_defineProperty({}, "".concat(slider_classPrefix, "-disabled"), disabled))
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(slider_classPrefix, "-track-container"),
        onClick: onTrackClick
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(slider_classPrefix, "-track"),
        onClick: onTrackClick,
        ref: trackRef
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(slider_classPrefix, "-fill"),
        style: {
            width: fillSize,
            left: fillStart
        }
    }), props.ticks && /*#__PURE__*/ react.createElement(slider_ticks, {
        points: pointList,
        min: min,
        max: max,
        lowerBound: sliderValue[0],
        upperBound: sliderValue[1]
    }), props.range && renderThumb(0), renderThumb(1))), marks && /*#__PURE__*/ react.createElement(slider_marks, {
        min: min,
        max: max,
        marks: marks,
        lowerBound: sliderValue[0],
        upperBound: sliderValue[1]
    })));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/slider/index.js


/* harmony default export */ var components_slider = (Slider);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/swiper/swiper.css
var swiper = __webpack_require__(48237);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/swiper/swiper-item.js


var SwiperItem = function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: "adm-swiper-item",
        onClick: props.onClick
    }, props.children));
};

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/page-indicator/page-indicator.css
var page_indicator = __webpack_require__(21141);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/page-indicator/page-indicator.js
function page_indicator_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var page_indicator_classPrefix = "adm-page-indicator";
var page_indicator_defaultProps = {
    color: "primary",
    direction: "horizontal"
};
var PageIndicator = /*#__PURE__*/ (0,react.memo)(function(p) {
    var props = mergeProps(page_indicator_defaultProps, p);
    var dots = [];
    for(var i = 0; i < props.total; i++){
        dots.push(/*#__PURE__*/ react.createElement("div", {
            key: i,
            className: classnames_default()("".concat(page_indicator_classPrefix, "-dot"), page_indicator_defineProperty({}, "".concat(page_indicator_classPrefix, "-dot-active"), props.current === i))
        }));
    }
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()(page_indicator_classPrefix, "".concat(page_indicator_classPrefix, "-").concat(props.direction), "".concat(page_indicator_classPrefix, "-color-").concat(props.color))
    }, dots));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/page-indicator/index.js


/* harmony default export */ var components_page_indicator = (PageIndicator);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/utils/use-ref-state.js

function useRefState(initialState) {
    var ref = (0,react.useState)(initialState), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useRef)(state);
    (0,react.useEffect)(function() {
        ref1.current = state;
    }, [
        state
    ]);
    return [
        state,
        setState,
        ref1
    ];
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/swiper/swiper.js
function swiper_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function swiper_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function swiper_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function swiper_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function swiper_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function swiper_slicedToArray(arr, i) {
    return swiper_arrayWithHoles(arr) || swiper_iterableToArrayLimit(arr, i) || swiper_unsupportedIterableToArray(arr, i) || swiper_nonIterableRest();
}
function swiper_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return swiper_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return swiper_arrayLikeToArray(o, minLen);
}













var swiper_classPrefix = "adm-swiper";
var swiper_defaultProps = {
    defaultIndex: 0,
    allowTouchMove: true,
    autoplay: false,
    autoplayInterval: 3000,
    loop: false,
    direction: "horizontal",
    slideSize: 100,
    trackOffset: 0,
    stuckAtBoundary: true,
    rubberband: true
};
var Swiper = /*#__PURE__*/ (0,react.forwardRef)((0,staged_components.staged)(function(p, ref) {
    var props = mergeProps(swiper_defaultProps, p);
    var isVertical = props.direction === "vertical";
    var slideRatio = props.slideSize / 100;
    var offsetRatio = props.trackOffset / 100;
    var ref1 = (0,react.useMemo)(function() {
        var count = 0;
        var validChildren = react.Children.map(props.children, function(child) {
            if (!/*#__PURE__*/ react.isValidElement(child)) return null;
            if (child.type !== SwiperItem) {
                devWarning("Swiper", "The children of `Swiper` must be `Swiper.Item` components.");
                return null;
            }
            count++;
            return child;
        });
        return {
            validChildren: validChildren,
            count: count
        };
    }, [
        props.children
    ]), validChildren1 = ref1.validChildren, count1 = ref1.count;
    if (count1 === 0 || !validChildren1) {
        devWarning("Swiper", "`Swiper` needs at least one child.");
        return null;
    }
    return function() {
        var getSlidePixels = function getSlidePixels() {
            var track = trackRef.current;
            if (!track) return 0;
            var trackPixels = isVertical ? track.offsetHeight : track.offsetWidth;
            return trackPixels * props.slideSize / 100;
        };
        var boundIndex = function boundIndex(current) {
            var min = 0;
            var max = count1 - 1;
            if (props.stuckAtBoundary) {
                min += offsetRatio / slideRatio;
                max -= (1 - slideRatio - offsetRatio) / slideRatio;
            }
            return bound(current, min, max);
        };
        var swipeTo = function swipeTo(index) {
            var immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var roundedIndex = Math.round(index);
            var targetIndex = loop ? modulus(roundedIndex, count1) : bound(roundedIndex, 0, count1 - 1);
            setCurrent(targetIndex);
            api.start({
                position: (loop ? roundedIndex : boundIndex(roundedIndex)) * 100,
                immediate: immediate
            });
        };
        var swipeNext = function swipeNext() {
            swipeTo(Math.round(position1.get() / 100) + 1);
        };
        var swipePrev = function swipePrev() {
            swipeTo(Math.round(position1.get() / 100) - 1);
        };
        var renderTrackInner = function renderTrackInner() {
            if (loop) {
                return /*#__PURE__*/ react.createElement("div", {
                    className: "".concat(swiper_classPrefix, "-track-inner")
                }, react.Children.map(validChildren1, function(child, index) {
                    var _obj;
                    return /*#__PURE__*/ react.createElement(animated.div, {
                        className: "".concat(swiper_classPrefix, "-slide"),
                        style: (_obj = {}, swiper_defineProperty(_obj, isVertical ? "y" : "x", position1.to(function(position) {
                            var finalPosition = -position + index * 100;
                            var totalWidth = count1 * 100;
                            var flagWidth = totalWidth / 2;
                            finalPosition = modulus(finalPosition + flagWidth, totalWidth) - flagWidth;
                            return "".concat(finalPosition, "%");
                        })), swiper_defineProperty(_obj, isVertical ? "top" : "left", "-".concat(index * 100, "%")), _obj)
                    }, child);
                }));
            } else {
                return /*#__PURE__*/ react.createElement(animated.div, {
                    className: "".concat(swiper_classPrefix, "-track-inner"),
                    style: swiper_defineProperty({}, isVertical ? "y" : "x", position1.to(function(position) {
                        return "".concat(-position, "%");
                    }))
                }, react.Children.map(validChildren1, function(child) {
                    return /*#__PURE__*/ react.createElement("div", {
                        className: "".concat(swiper_classPrefix, "-slide")
                    }, child);
                }));
            }
        };
        var loop = props.loop;
        if (slideRatio * (count1 - 1) < 1) {
            loop = false;
        }
        var trackRef = (0,react.useRef)(null);
        var _$ref = (0,react.useState)(props.defaultIndex), current1 = _$ref[0], setCurrent = _$ref[1];
        useUpdateEffect(function() {
            var _a;
            (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, current1);
        }, [
            current1
        ]);
        var _$ref1 = swiper_slicedToArray(useRefState(false), 3), dragging = _$ref1[0], setDragging = _$ref1[1], draggingRef = _$ref1[2];
        var _$ref2 = swiper_slicedToArray(useSpring(function() {
            return {
                position: boundIndex(current1) * 100,
                config: {
                    tension: 200,
                    friction: 30
                },
                onRest: function() {
                    if (draggingRef.current) return;
                    if (!loop) return;
                    var rawX = position1.get();
                    var totalWidth = 100 * count1;
                    var standardPosition = modulus(rawX, totalWidth);
                    if (standardPosition === rawX) return;
                    api.start({
                        position: standardPosition,
                        immediate: true
                    });
                }
            };
        }, [
            count1
        ]), 2), position1 = _$ref2[0].position, api = _$ref2[1];
        var bind = useDrag(function(state) {
            var slidePixels = getSlidePixels();
            if (!slidePixels) return;
            var paramIndex = isVertical ? 1 : 0;
            var offset = state.offset[paramIndex];
            var direction = state.direction[paramIndex];
            var velocity = state.velocity[paramIndex];
            setDragging(true);
            if (!state.last) {
                api.start({
                    position: offset * 100 / slidePixels,
                    immediate: true
                });
            } else {
                var minIndex = Math.floor(offset / slidePixels);
                var maxIndex = minIndex + 1;
                var index = Math.round((offset + velocity * 2000 * direction) / slidePixels);
                swipeTo(bound(index, minIndex, maxIndex));
                window.setTimeout(function() {
                    setDragging(false);
                });
            }
        }, {
            transform: function(param) {
                var _param = swiper_slicedToArray(param, 2), x = _param[0], y = _param[1];
                return [
                    -x,
                    -y
                ];
            },
            from: function() {
                var slidePixels = getSlidePixels();
                return [
                    position1.get() / 100 * slidePixels,
                    position1.get() / 100 * slidePixels
                ];
            },
            bounds: function() {
                if (loop) return {};
                var slidePixels = getSlidePixels();
                var lowerBound = boundIndex(0) * slidePixels;
                var upperBound = boundIndex(count1 - 1) * slidePixels;
                return isVertical ? {
                    top: lowerBound,
                    bottom: upperBound
                } : {
                    left: lowerBound,
                    right: upperBound
                };
            },
            rubberband: props.rubberband,
            axis: isVertical ? "y" : "x",
            preventScroll: !isVertical,
            pointer: {
                touch: true
            }
        });
        (0,react.useImperativeHandle)(ref, function() {
            return {
                swipeTo: swipeTo,
                swipeNext: swipeNext,
                swipePrev: swipePrev
            };
        });
        es_useIsomorphicLayoutEffect(function() {
            var maxIndex = validChildren1.length - 1;
            if (current1 > maxIndex) {
                swipeTo(maxIndex, true);
            }
        });
        var autoplay = props.autoplay, autoplayInterval = props.autoplayInterval;
        (0,react.useEffect)(function() {
            if (!autoplay || dragging) return;
            var interval = window.setInterval(function() {
                swipeNext();
            }, autoplayInterval);
            return function() {
                window.clearInterval(interval);
            };
        }, [
            autoplay,
            autoplayInterval,
            dragging
        ]);
        var style = {
            "--slide-size": "".concat(props.slideSize, "%"),
            "--track-offset": "".concat(props.trackOffset, "%")
        };
        return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
            className: classnames_default()(swiper_classPrefix, "".concat(swiper_classPrefix, "-").concat(props.direction)),
            style: style
        }, /*#__PURE__*/ react.createElement("div", Object.assign({
            ref: trackRef,
            className: classnames_default()("".concat(swiper_classPrefix, "-track"), swiper_defineProperty({}, "".concat(swiper_classPrefix, "-track-allow-touch-move"), props.allowTouchMove)),
            onClickCapture: function(e) {
                if (draggingRef.current) {
                    e.stopPropagation();
                }
            }
        }, props.allowTouchMove ? bind() : {}), renderTrackInner()), props.indicator === undefined ? /*#__PURE__*/ react.createElement("div", {
            className: "".concat(swiper_classPrefix, "-indicator")
        }, /*#__PURE__*/ react.createElement(components_page_indicator, Object.assign({}, props.indicatorProps, {
            total: count1,
            current: current1,
            direction: props.direction
        }))) : props.indicator(count1, current1)));
    };
}));
function modulus(value, division) {
    var remainder = value % division;
    return remainder < 0 ? remainder + division : remainder;
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/swiper/index.js




/* harmony default export */ var components_swiper = (attachPropertiesToComponent(Swiper, {
    Item: SwiperItem
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/switch/switch.css
var switch_switch = __webpack_require__(15348);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/switch/spin-icon.js


var SpinIcon = /*#__PURE__*/ (0,react.memo)(function(props) {
    return withNativeProps(props, /*#__PURE__*/ react.createElement("svg", {
        width: "28px",
        height: "28px",
        viewBox: "0 0 28 28"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(-137.000000, -840.000000)",
        fill: "#1576FE"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(80.000000, 823.000000)"
    }, /*#__PURE__*/ react.createElement("g", {
        transform: "translate(53.000000, 13.000000)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M17.9996753,31.5 C10.5556724,31.5 4.5,25.4443275 4.5,18.0003247 C4.5,10.5563219 10.5556724,4.5 17.9996753,4.5 C18.5355492,4.5 18.9702974,4.93474816 18.9702974,5.47062208 C18.9702974,6.006496 18.5355492,6.44124416 17.9996753,6.44124416 C11.6261524,6.44124416 6.44124416,11.6267709 6.44124416,18.0002938 C6.44124416,24.3738167 11.6261524,29.5587249 17.9996753,29.5587249 C24.3731982,29.5587249 29.5587249,24.3738167 29.5587249,18.0002938 C29.5587249,14.7964616 28.2778291,11.8169616 25.9523687,9.61220279 C25.5637302,9.24317094 25.5473089,8.62893223 25.9157222,8.23967523 C26.2841356,7.84976878 26.8989928,7.83461537 27.2882498,8.20302872 C30.0042351,10.7787368 31.5,14.2580826 31.5,18.0002938 C31.5,25.4443275 25.4436781,31.5 17.9996753,31.5 Z"
    })))))));
});

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/switch/switch.js
function switch_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function switch_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function switch_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function switch_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function switch_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function switch_slicedToArray(arr, i) {
    return switch_arrayWithHoles(arr) || switch_iterableToArrayLimit(arr, i) || switch_unsupportedIterableToArray(arr, i) || switch_nonIterableRest();
}
function switch_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return switch_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return switch_arrayLikeToArray(o, minLen);
}









var switch_classPrefix = "adm-switch";
var switch_defaultProps = {
    defaultChecked: false
};
var Switch = function(p) {
    var onClick = function onClick() {
        return __awaiter(this, void 0, void 0, runtime_default().mark(function _callee() {
            var nextChecked;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(disabled || props.loading || changing)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        nextChecked = !checked;
                        if (!props.beforeChange) {
                            _ctx.next = 18;
                            break;
                        }
                        setChanging(true);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return props.beforeChange(nextChecked);
                    case 8:
                        setChecked(nextChecked);
                        setChanging(false);
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        setChanging(false);
                        throw _ctx.t0;
                    case 16:
                        _ctx.next = 19;
                        break;
                    case 18:
                        {
                            setChecked(nextChecked);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
    };
    var props = mergeProps(switch_defaultProps, p);
    var disabled = props.disabled || props.loading || false;
    var ref = (0,react.useState)(false), changing = ref[0], setChanging = ref[1];
    var locale = useConfig().locale;
    var ref1 = switch_slicedToArray(usePropsValue({
        value: props.checked,
        defaultValue: props.defaultChecked,
        onChange: props.onChange
    }), 2), checked = ref1[0], setChecked = ref1[1];
    var _obj;
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        onClick: onClick,
        className: classnames_default()(switch_classPrefix, (_obj = {}, switch_defineProperty(_obj, "".concat(switch_classPrefix, "-checked"), checked), switch_defineProperty(_obj, "".concat(switch_classPrefix, "-disabled"), disabled || changing), _obj)),
        role: "switch",
        "aria-label": locale.Switch.name,
        "aria-checked": checked,
        "aria-disabled": disabled
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(switch_classPrefix, "-checkbox")
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(switch_classPrefix, "-handle")
    }, (props.loading || changing) && /*#__PURE__*/ react.createElement(SpinIcon, {
        className: "".concat(switch_classPrefix, "-spin-icon")
    })), /*#__PURE__*/ react.createElement("div", {
        className: "".concat(switch_classPrefix, "-inner")
    }, checked ? props.checkedText : props.uncheckedText))));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/switch/index.js


/* harmony default export */ var components_switch = (Switch);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/tab-bar/tab-bar.css
var tab_bar = __webpack_require__(20701);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/tab-bar/tab-bar.js
function tab_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function tab_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function tab_bar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tab_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function tab_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function tab_bar_slicedToArray(arr, i) {
    return tab_bar_arrayWithHoles(arr) || tab_bar_iterableToArrayLimit(arr, i) || tab_bar_unsupportedIterableToArray(arr, i) || tab_bar_nonIterableRest();
}
function tab_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return tab_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tab_bar_arrayLikeToArray(o, minLen);
}








/* istanbul ignore next */ var TabBarItem = function() {
    return null;
};
var tab_bar_classPrefix = "adm-tab-bar";
var tab_bar_defaultProps = {
    safeArea: false
};
var TabBar = function(p) {
    var _a1;
    var props = mergeProps(tab_bar_defaultProps, p);
    var firstActiveKey = null;
    var items = [];
    traverseReactNode(props.children, function(child, index) {
        if (!/*#__PURE__*/ react.isValidElement(child)) return;
        var key = child.key;
        if (typeof key !== "string") return;
        if (index === 0) {
            firstActiveKey = key;
        }
        items.push(child);
    });
    var ref = tab_bar_slicedToArray(usePropsValue({
        value: props.activeKey,
        defaultValue: (_a1 = props.defaultActiveKey) !== null && _a1 !== void 0 ? _a1 : firstActiveKey,
        onChange: function(v) {
            var _a;
            if (v === null) return;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
        }
    }), 2), activeKey = ref[0], setActiveKey = ref[1];
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: tab_bar_classPrefix
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(tab_bar_classPrefix, "-wrap")
    }, items.map(function(item) {
        var renderContent = function renderContent() {
            var iconElement = item.props.icon && /*#__PURE__*/ react.createElement("div", {
                className: "".concat(tab_bar_classPrefix, "-item-icon")
            }, typeof item.props.icon === "function" ? item.props.icon(active) : item.props.icon);
            var titleElement = item.props.title && /*#__PURE__*/ react.createElement("div", {
                className: classnames_default()("".concat(tab_bar_classPrefix, "-item-title"), Boolean(iconElement) && "".concat(tab_bar_classPrefix, "-item-title-with-icon"))
            }, typeof item.props.title === "function" ? item.props.title(active) : item.props.title);
            if (iconElement) {
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_badge, {
                    content: item.props.badge,
                    className: "".concat(tab_bar_classPrefix, "-icon-badge")
                }, iconElement), titleElement);
            } else if (titleElement) {
                return /*#__PURE__*/ react.createElement(components_badge, {
                    content: item.props.badge,
                    className: "".concat(tab_bar_classPrefix, "-title-badge")
                }, titleElement);
            }
            return null;
        };
        var active = item.key === activeKey;
        return withNativeProps(item.props, /*#__PURE__*/ react.createElement("div", {
            key: item.key,
            onClick: function() {
                var key = item.key;
                if (key === undefined || key === null) return;
                setActiveKey(key.toString());
            },
            className: classnames_default()("".concat(tab_bar_classPrefix, "-item"), tab_bar_defineProperty({}, "".concat(tab_bar_classPrefix, "-item-active"), active))
        }, renderContent()));
    })), props.safeArea && /*#__PURE__*/ react.createElement(components_safe_area, {
        position: "bottom"
    })));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/tab-bar/index.js



/* harmony default export */ var components_tab_bar = (attachPropertiesToComponent(TabBar, {
    Item: TabBarItem
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/tabs/tabs.css
var tabs = __webpack_require__(18195);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/tabs/tabs.js
function tabs_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function tabs_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function tabs_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tabs_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function tabs_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function tabs_slicedToArray(arr, i) {
    return tabs_arrayWithHoles(arr) || tabs_iterableToArrayLimit(arr, i) || tabs_unsupportedIterableToArray(arr, i) || tabs_nonIterableRest();
}
function tabs_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return tabs_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tabs_arrayLikeToArray(o, minLen);
}













var tabs_classPrefix = "adm-tabs";
var Tab = function() {
    return null;
};
var tabs_defaultProps = {
    activeLineMode: "auto",
    stretch: true
};
var Tabs = function(p) {
    var animate = function animate() {
        var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var container = tabListContainerRef.current;
        if (!container) return;
        var activeIndex = keyToIndexRecord[activeKey];
        if (activeIndex === undefined) {
            api.start({
                x: 0,
                width: 0,
                immediate: true
            });
            return;
        }
        var activeLine = activeLineRef.current;
        if (!activeLine) return;
        var activeTabWrapper = container.children.item(activeIndex + 1);
        var activeTab = activeTabWrapper.children.item(0);
        var activeTabLeft = activeTab.offsetLeft;
        var activeTabWidth = activeTab.offsetWidth;
        var activeTabWrapperLeft = activeTabWrapper.offsetLeft;
        var activeTabWrapperWidth = activeTabWrapper.offsetWidth;
        var containerWidth = container.offsetWidth;
        var containerScrollWidth = container.scrollWidth;
        var containerScrollLeft = container.scrollLeft;
        var activeLineWidth = activeLine.offsetWidth;
        var x = 0;
        var width = 0;
        if (props.activeLineMode === "auto") {
            x = activeTabLeft;
            width = activeTabWidth;
        } else if (props.activeLineMode === "full") {
            x = activeTabWrapperLeft;
            width = activeTabWrapperWidth;
        } else {
            x = activeTabLeft + (activeTabWidth - activeLineWidth) / 2;
        }
        api.start({
            x: x,
            width: width,
            immediate: immediate
        });
        var maxScrollDistance = containerScrollWidth - containerWidth;
        if (maxScrollDistance <= 0) return;
        var nextScrollLeft = bound(activeTabLeft - (containerWidth - activeTabWidth) / 2, 0, containerScrollWidth - containerWidth);
        scrollApi.start({
            scrollLeft: nextScrollLeft,
            from: {
                scrollLeft: containerScrollLeft
            },
            immediate: immediate
        });
    };
    var _a1;
    var props = mergeProps(tabs_defaultProps, p);
    var tabListContainerRef = (0,react.useRef)(null);
    var activeLineRef = (0,react.useRef)(null);
    var keyToIndexRecord = {};
    var firstActiveKey = null;
    var panes = [];
    traverseReactNode(props.children, function(child, index) {
        if (!/*#__PURE__*/ react.isValidElement(child)) return;
        var key = child.key;
        if (typeof key !== "string") return;
        if (index === 0) {
            firstActiveKey = key;
        }
        var length = panes.push(child);
        keyToIndexRecord[key] = length - 1;
    });
    var ref = tabs_slicedToArray(usePropsValue({
        value: props.activeKey,
        defaultValue: (_a1 = props.defaultActiveKey) !== null && _a1 !== void 0 ? _a1 : firstActiveKey,
        onChange: function(v) {
            var _a;
            if (v === null) return;
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, v);
        }
    }), 2), activeKey = ref[0], setActiveKey = ref[1];
    var ref1 = tabs_slicedToArray(useSpring(function() {
        return {
            x: 0,
            width: 0,
            config: {
                tension: 300,
                clamp: true
            }
        };
    }), 2), ref2 = ref1[0], x1 = ref2.x, width1 = ref2.width, api = ref1[1];
    var ref3 = tabs_slicedToArray(useSpring(function() {
        return {
            scrollLeft: 0,
            config: {
                tension: 300,
                clamp: true
            }
        };
    }), 2), scrollLeft1 = ref3[0].scrollLeft, scrollApi = ref3[1];
    var ref4 = tabs_slicedToArray(useSpring(function() {
        return {
            leftMaskOpacity: 0,
            rightMaskOpacity: 0,
            config: {
                clamp: true
            }
        };
    }), 2), ref5 = ref4[0], leftMaskOpacity = ref5.leftMaskOpacity, rightMaskOpacity = ref5.rightMaskOpacity, maskApi = ref4[1];
    es_useIsomorphicLayoutEffect(function() {
        animate(!x1.isAnimating);
    }, []);
    useIsomorphicUpdateLayoutEffect(function() {
        animate();
    }, [
        activeKey
    ]);
    useResizeEffect(function() {
        animate(!x1.isAnimating);
    }, tabListContainerRef);
    useMutationEffect(function() {
        animate(!x1.isAnimating);
    }, tabListContainerRef, {
        subtree: true,
        childList: true,
        characterData: true
    });
    var ref6 = es_useThrottleFn(function() {
        var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var container = tabListContainerRef.current;
        if (!container) return;
        var scrollLeft = container.scrollLeft;
        var showLeftMask = scrollLeft > 0;
        var showRightMask = scrollLeft + container.offsetWidth < container.scrollWidth;
        maskApi.start({
            leftMaskOpacity: showLeftMask ? 1 : 0,
            rightMaskOpacity: showRightMask ? 1 : 0,
            immediate: immediate
        });
    }, {
        wait: 100,
        trailing: true,
        leading: true
    }), updateMask = ref6.run;
    es_useIsomorphicLayoutEffect(function() {
        updateMask(true);
    }, []);
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: tabs_classPrefix
    }, /*#__PURE__*/ react.createElement("div", {
        className: "".concat(tabs_classPrefix, "-header")
    }, /*#__PURE__*/ react.createElement(animated.div, {
        className: classnames_default()("".concat(tabs_classPrefix, "-header-mask"), "".concat(tabs_classPrefix, "-header-mask-left")),
        style: {
            opacity: leftMaskOpacity
        }
    }), /*#__PURE__*/ react.createElement(animated.div, {
        className: classnames_default()("".concat(tabs_classPrefix, "-header-mask"), "".concat(tabs_classPrefix, "-header-mask-right")),
        style: {
            opacity: rightMaskOpacity
        }
    }), /*#__PURE__*/ react.createElement(animated.div, {
        className: "".concat(tabs_classPrefix, "-tab-list"),
        ref: tabListContainerRef,
        scrollLeft: scrollLeft1,
        onScroll: updateMask
    }, /*#__PURE__*/ react.createElement(animated.div, {
        ref: activeLineRef,
        className: "".concat(tabs_classPrefix, "-tab-line"),
        style: {
            width: props.activeLineMode === "fixed" ? "var(--fixed-active-line-width, 30px)" : width1,
            x: x1
        }
    }), panes.map(function(pane) {
        var _obj;
        return withNativeProps(pane.props, /*#__PURE__*/ react.createElement("div", {
            key: pane.key,
            className: classnames_default()("".concat(tabs_classPrefix, "-tab-wrapper"), tabs_defineProperty({}, "".concat(tabs_classPrefix, "-tab-wrapper-stretch"), props.stretch))
        }, /*#__PURE__*/ react.createElement("div", {
            onClick: function() {
                var key = pane.key;
                if (pane.props.disabled) return;
                if (key === undefined || key === null) {
                    return;
                }
                setActiveKey(key.toString());
            },
            className: classnames_default()("".concat(tabs_classPrefix, "-tab"), (_obj = {}, tabs_defineProperty(_obj, "".concat(tabs_classPrefix, "-tab-active"), pane.key === activeKey), tabs_defineProperty(_obj, "".concat(tabs_classPrefix, "-tab-disabled"), pane.props.disabled), _obj))
        }, pane.props.title)));
    }))), panes.map(function(pane) {
        if (pane.props.children === undefined) {
            return null;
        }
        var active = pane.key === activeKey;
        return /*#__PURE__*/ react.createElement(ShouldRender, {
            key: pane.key,
            active: active,
            forceRender: pane.props.forceRender,
            destroyOnClose: pane.props.destroyOnClose
        }, /*#__PURE__*/ react.createElement("div", {
            className: "".concat(tabs_classPrefix, "-content"),
            style: {
                display: active ? "block" : "none"
            }
        }, pane.props.children));
    })));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/tabs/index.js



/* harmony default export */ var components_tabs = (attachPropertiesToComponent(Tabs, {
    Tab: Tab
}));

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/text-area/text-area.css
var text_area = __webpack_require__(21908);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/text-area/text-area.js
function text_area_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function text_area_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function text_area_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return text_area_arrayLikeToArray(arr);
}
function text_area_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function text_area_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function text_area_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function text_area_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function text_area_slicedToArray(arr, i) {
    return text_area_arrayWithHoles(arr) || text_area_iterableToArrayLimit(arr, i) || text_area_unsupportedIterableToArray(arr, i) || text_area_nonIterableRest();
}
function text_area_toConsumableArray(arr) {
    return text_area_arrayWithoutHoles(arr) || text_area_iterableToArray(arr) || text_area_unsupportedIterableToArray(arr) || text_area_nonIterableSpread();
}
function text_area_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return text_area_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return text_area_arrayLikeToArray(o, minLen);
}






var text_area_classPrefix = "adm-text-area";
var text_area_defaultProps = {
    rows: 2,
    showCount: false,
    autoSize: false,
    defaultValue: ""
};
var TextArea = /*#__PURE__*/ (0,react.forwardRef)(function(p, ref) {
    var props = mergeProps(text_area_defaultProps, p);
    var autoSize = props.autoSize, showCount = props.showCount, maxLength = props.maxLength;
    var _$ref = text_area_slicedToArray(usePropsValue(Object.assign(Object.assign({}, props), {
        value: props.value === null ? "" : props.value
    })), 2), value = _$ref[0], setValue = _$ref[1];
    if (props.value === null) {
        devError("TextArea", "`value` prop on `TextArea` should not be `null`. Consider using an empty string to clear the component.");
    }
    var nativeTextAreaRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            clear: function() {
                setValue("");
            },
            focus: function() {
                var _a;
                (_a = nativeTextAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: function() {
                var _a;
                (_a = nativeTextAreaRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
            get nativeElement () {
                return nativeTextAreaRef.current;
            }
        };
    });
    es_useIsomorphicLayoutEffect(function() {
        if (!autoSize) return;
        var textArea = nativeTextAreaRef.current;
        if (!textArea) return;
        textArea.style.height = "auto";
        var height = textArea.scrollHeight;
        if (typeof autoSize === "object") {
            var computedStyle = window.getComputedStyle(textArea);
            var lineHeight = parseFloat(computedStyle.lineHeight);
            if (autoSize.minRows) {
                height = Math.max(height, autoSize.minRows * lineHeight);
            }
            if (autoSize.maxRows) {
                height = Math.min(height, autoSize.maxRows * lineHeight);
            }
        }
        textArea.style.height = "".concat(height, "px");
    }, [
        value,
        autoSize
    ]);
    var compositingRef = (0,react.useRef)(false);
    var count;
    var valueLength = text_area_toConsumableArray(value).length;
    if (typeof showCount === "function") {
        count = showCount(valueLength, maxLength);
    } else if (showCount) {
        count = /*#__PURE__*/ react.createElement("div", {
            className: "".concat(text_area_classPrefix, "-count")
        }, maxLength === undefined ? valueLength : valueLength + "/" + maxLength);
    }
    return withNativeProps(props, /*#__PURE__*/ react.createElement("div", {
        className: text_area_classPrefix
    }, /*#__PURE__*/ react.createElement("textarea", {
        ref: nativeTextAreaRef,
        className: "".concat(text_area_classPrefix, "-element"),
        rows: props.rows,
        value: value,
        placeholder: props.placeholder,
        onChange: function(e) {
            var v = e.target.value;
            if (maxLength && !compositingRef.current) {
                v = text_area_toConsumableArray(v).slice(0, maxLength).join("");
            }
            setValue(v);
        },
        id: props.id,
        onCompositionStart: function(e) {
            var _a;
            compositingRef.current = true;
            (_a = props.onCompositionStart) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onCompositionEnd: function(e) {
            var _a;
            compositingRef.current = false;
            if (maxLength) {
                var v = e.target.value;
                setValue(text_area_toConsumableArray(v).slice(0, maxLength).join(""));
            }
            (_a = props.onCompositionEnd) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        autoComplete: props.autoComplete,
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        readOnly: props.readOnly,
        name: props.name,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onClick: props.onClick
    }), count));
});
TextArea.defaultProps = text_area_defaultProps;

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/text-area/index.js


/* harmony default export */ var components_text_area = (TextArea);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/toast/toast.css
var toast = __webpack_require__(96988);
;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/toast/toast.js







var toast_classPrefix = "adm-toast";
var toast_defaultProps = {
    maskClickable: true,
    stopPropagation: [
        "click"
    ]
};
var InternalToast = function(p) {
    var props = mergeProps(toast_defaultProps, p);
    var maskClickable = props.maskClickable, content = props.content, icon = props.icon, position = props.position;
    var iconElement = (0,react.useMemo)(function() {
        if (icon === null || icon === undefined) return null;
        switch(icon){
            case "success":
                return /*#__PURE__*/ react.createElement(es_CheckOutline, {
                    className: "".concat(toast_classPrefix, "-icon-success")
                });
            case "fail":
                return /*#__PURE__*/ react.createElement(es_CloseOutline, {
                    className: "".concat(toast_classPrefix, "-icon-fail")
                });
            case "loading":
                return /*#__PURE__*/ react.createElement(components_spin_loading, {
                    color: "white",
                    className: "".concat(toast_classPrefix, "-loading")
                });
            default:
                return icon;
        }
    }, [
        icon
    ]);
    var top = (0,react.useMemo)(function() {
        switch(position){
            case "top":
                return "20%";
            case "bottom":
                return "80%";
            default:
                return "50%";
        }
    }, [
        position
    ]);
    return /*#__PURE__*/ react.createElement(components_mask, {
        visible: props.visible,
        destroyOnClose: true,
        opacity: 0,
        disableBodyScroll: !maskClickable,
        getContainer: props.getContainer,
        afterClose: props.afterClose,
        style: Object.assign({
            pointerEvents: maskClickable ? "none" : "auto"
        }, props.maskStyle),
        className: classnames_default()("".concat(toast_classPrefix, "-mask"), props.maskClassName),
        stopPropagation: props.stopPropagation
    }, /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("".concat(toast_classPrefix, "-wrap"))
    }, /*#__PURE__*/ react.createElement("div", {
        style: {
            top: top
        },
        className: classnames_default()("".concat(toast_classPrefix, "-main"), icon ? "".concat(toast_classPrefix, "-main-icon") : "".concat(toast_classPrefix, "-main-text"))
    }, iconElement && /*#__PURE__*/ react.createElement("div", {
        className: "".concat(toast_classPrefix, "-icon")
    }, iconElement), /*#__PURE__*/ react.createElement(components_auto_center, null, content))));
};

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/toast/methods.js




var currentHandler = null;
var currentTimeout = null;
var methods_defaultProps = {
    duration: 2000,
    position: "center",
    maskClickable: true
};
var ToastInner = function(props) {
    return /*#__PURE__*/ react.createElement(InternalToast, Object.assign({}, props));
};
function methods_show(p) {
    var props = mergeProps(methods_defaultProps, typeof p === "string" ? {
        content: p
    } : p);
    var element = /*#__PURE__*/ react.createElement(ToastInner, Object.assign({}, props, {
        onClose: function() {
            currentHandler = null;
        }
    }));
    if (currentHandler) {
        currentHandler.replace(element);
    } else {
        currentHandler = renderImperatively(element);
    }
    if (currentTimeout) {
        window.clearTimeout(currentTimeout);
    }
    if (props.duration !== 0) {
        currentTimeout = window.setTimeout(function() {
            methods_clear();
        }, props.duration);
    }
    return currentHandler;
}
function methods_clear() {
    currentHandler === null || currentHandler === void 0 ? void 0 : currentHandler.close();
    currentHandler = null;
}
function methods_config(val) {
    if (val.duration !== undefined) {
        methods_defaultProps.duration = val.duration;
    }
    if (val.position !== undefined) {
        methods_defaultProps.position = val.position;
    }
    if (val.maskClickable !== undefined) {
        methods_defaultProps.maskClickable = val.maskClickable;
    }
}

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/components/toast/index.js


var Toast = {
    show: methods_show,
    clear: methods_clear,
    config: methods_config
};
/* harmony default export */ var components_toast = (Toast);

;// CONCATENATED MODULE: ./node_modules/antd-mobile/es/index.js




















































































/***/ }),

/***/ 24547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ sleep; }
/* harmony export */ });
var sleep = function(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
};


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={991:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},293:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(991);var n=t(759);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},759:function(e,r){r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(293);module.exports=t})();

/***/ }),

/***/ 68679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-picker-custom":"style_circle-picker-custom__SKmzd"};

/***/ }),

/***/ 35819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploadProductFile":"style_uploadProductFile__dy4D7"};

/***/ }),

/***/ 35815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookingProfile":"style_bookingProfile__MZRuh"};

/***/ }),

/***/ 76616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container-modal-delete-forever":"style_container-modal-delete-forever__JoLoQ","button-confirm-delete-forever":"style_button-confirm-delete-forever__KF2tV","text-confirm":"style_text-confirm__XaUom","button-cancel-delete-forever":"style_button-cancel-delete-forever__BDLKT","text-cancel":"style_text-cancel__vZ_uN","title-modal-delete-forever":"style_title-modal-delete-forever__yCsgT","content-modal-delete-forever":"style_content-modal-delete-forever__mmkk6"};

/***/ }),

/***/ 70346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title-header-popup":"style_title-header-popup__xZUZ4","list-item-popup":"style_list-item-popup__nNkbe"};

/***/ }),

/***/ 32457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dndItemContainer":"style_dndItemContainer__CBSIF","dndContainer":"style_dndContainer__0Xu0i"};

/***/ }),

/***/ 23290:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"style_tabContent__2FJQ4"};

/***/ }),

/***/ 76557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputCustom":"style_inputCustom__KWyF9","inputNoBorder":"style_inputNoBorder__NLKW_"};

/***/ }),

/***/ 81431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__0XtLl"};

/***/ }),

/***/ 1845:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34109:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48542:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21771:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78789:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83035:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53749:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 47916:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57089:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3977:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 16433:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70689:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4400:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 141:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 199:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97030:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26144:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 86162:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 19664:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 69542:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2757:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 59590:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 375:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21141:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 23673:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 91842:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9098:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 90244:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77194:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 37414:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 19763:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 19785:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 49779:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68643:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48610:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48606:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48237:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 15348:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20701:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18195:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21908:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 96988:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 43294:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50982:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 47107:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 82021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){"use strict";var e={800:function(e){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var r=Object.getOwnPropertySymbols;var t=Object.prototype.hasOwnProperty;var u=Object.prototype.propertyIsEnumerable;function toObject(e){if(e===null||e===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(e)}function shouldUseNative(){try{if(!Object.assign){return false}var e=new String("abc");e[5]="de";if(Object.getOwnPropertyNames(e)[0]==="5"){return false}var r={};for(var t=0;t<10;t++){r["_"+String.fromCharCode(t)]=t}var u=Object.getOwnPropertyNames(r).map((function(e){return r[e]}));if(u.join("")!=="0123456789"){return false}var n={};"abcdefghijklmnopqrst".split("").forEach((function(e){n[e]=e}));if(Object.keys(Object.assign({},n)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(e){return false}}e.exports=shouldUseNative()?Object.assign:function(e,n){var a;var i=toObject(e);var s;for(var c=1;c<arguments.length;c++){a=Object(arguments[c]);for(var o in a){if(t.call(a,o)){i[o]=a[o]}}if(r){s=r(a);for(var f=0;f<s.length;f++){if(u.call(a,s[f])){i[s[f]]=a[s[f]]}}}}return i}},569:function(e,r,t){
/** @license React vundefined
 * use-subscription.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if(false){}},403:function(e,r,t){
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u=t(800),n=t(522);r.useSubscription=function(e){var r=e.getCurrentValue,t=e.subscribe,a=n.useState((function(){return{getCurrentValue:r,subscribe:t,value:r()}}));e=a[0];var i=a[1];a=e.value;if(e.getCurrentValue!==r||e.subscribe!==t)a=r(),i({getCurrentValue:r,subscribe:t,value:a});n.useDebugValue(a);n.useEffect((function(){function b(){if(!e){var n=r();i((function(e){return e.getCurrentValue!==r||e.subscribe!==t||e.value===n?e:u({},e,{value:n})}))}}var e=!1,n=t(b);b();return function(){e=!0;n()}}),[r,t]);return a}},138:function(e,r,t){if(true){e.exports=t(403)}else{}},522:function(e){e.exports=__webpack_require__(67294)}};var r={};function __nccwpck_require__(t){var u=r[t];if(u!==undefined){return u.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(138);module.exports=t})();

/***/ }),

/***/ 28860:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 38701:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function arr_back(arr) {
    return arr[arr.length - 1];
}
exports["default"] = arr_back;


/***/ }),

/***/ 90698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NodeType = exports.TextNode = exports.Node = exports.valid = exports["default"] = exports.parse = exports.HTMLElement = exports.CommentNode = void 0;
var comment_1 = __webpack_require__(91271);
Object.defineProperty(exports, "CommentNode", ({ enumerable: true, get: function () { return __importDefault(comment_1).default; } }));
var html_1 = __webpack_require__(24382);
Object.defineProperty(exports, "HTMLElement", ({ enumerable: true, get: function () { return __importDefault(html_1).default; } }));
var parse_1 = __webpack_require__(18821);
Object.defineProperty(exports, "parse", ({ enumerable: true, get: function () { return __importDefault(parse_1).default; } }));
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(parse_1).default; } }));
var valid_1 = __webpack_require__(56389);
Object.defineProperty(exports, "valid", ({ enumerable: true, get: function () { return __importDefault(valid_1).default; } }));
var node_1 = __webpack_require__(54936);
Object.defineProperty(exports, "Node", ({ enumerable: true, get: function () { return __importDefault(node_1).default; } }));
var text_1 = __webpack_require__(47923);
Object.defineProperty(exports, "TextNode", ({ enumerable: true, get: function () { return __importDefault(text_1).default; } }));
var type_1 = __webpack_require__(29979);
Object.defineProperty(exports, "NodeType", ({ enumerable: true, get: function () { return __importDefault(type_1).default; } }));


/***/ }),

/***/ 20080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var type_1 = __importDefault(__webpack_require__(29979));
function isTag(node) {
    return node && node.nodeType === type_1.default.ELEMENT_NODE;
}
function getAttributeValue(elem, name) {
    return isTag(elem) ? elem.getAttribute(name) : undefined;
}
function getName(elem) {
    return ((elem && elem.rawTagName) || '').toLowerCase();
}
function getChildren(node) {
    return node && node.childNodes;
}
function getParent(node) {
    return node ? node.parentNode : null;
}
function getText(node) {
    return node.text;
}
function removeSubsets(nodes) {
    var idx = nodes.length;
    var node;
    var ancestor;
    var replace;
    // Check if each node (or one of its ancestors) is already contained in the
    // array.
    while (--idx > -1) {
        node = ancestor = nodes[idx];
        // Temporarily remove the node under consideration
        nodes[idx] = null;
        replace = true;
        while (ancestor) {
            if (nodes.indexOf(ancestor) > -1) {
                replace = false;
                nodes.splice(idx, 1);
                break;
            }
            ancestor = getParent(ancestor);
        }
        // If the node has been found to be unique, re-insert it.
        if (replace) {
            nodes[idx] = node;
        }
    }
    return nodes;
}
function existsOne(test, elems) {
    return elems.some(function (elem) {
        return isTag(elem) ? test(elem) || existsOne(test, getChildren(elem)) : false;
    });
}
function getSiblings(node) {
    var parent = getParent(node);
    return parent && getChildren(parent);
}
function hasAttrib(elem, name) {
    return getAttributeValue(elem, name) !== undefined;
}
function findOne(test, elems) {
    var elem = null;
    for (var i = 0, l = elems.length; i < l && !elem; i++) {
        var el = elems[i];
        if (test(el)) {
            elem = el;
        }
        else {
            var childs = getChildren(el);
            if (childs && childs.length > 0) {
                elem = findOne(test, childs);
            }
        }
    }
    return elem;
}
function findAll(test, nodes) {
    var result = [];
    for (var i = 0, j = nodes.length; i < j; i++) {
        if (!isTag(nodes[i]))
            continue;
        if (test(nodes[i]))
            result.push(nodes[i]);
        var childs = getChildren(nodes[i]);
        if (childs)
            result = result.concat(findAll(test, childs));
    }
    return result;
}
exports["default"] = {
    isTag: isTag,
    getAttributeValue: getAttributeValue,
    getName: getName,
    getChildren: getChildren,
    getParent: getParent,
    getText: getText,
    removeSubsets: removeSubsets,
    existsOne: existsOne,
    getSiblings: getSiblings,
    hasAttrib: hasAttrib,
    findOne: findOne,
    findAll: findAll
};


/***/ }),

/***/ 91271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var node_1 = __importDefault(__webpack_require__(54936));
var type_1 = __importDefault(__webpack_require__(29979));
var CommentNode = /** @class */ (function (_super) {
    __extends(CommentNode, _super);
    function CommentNode(rawText, parentNode, range) {
        var _this = _super.call(this, parentNode, range) || this;
        _this.rawText = rawText;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        _this.nodeType = type_1.default.COMMENT_NODE;
        return _this;
    }
    CommentNode.prototype.clone = function () {
        return new CommentNode(this.rawText, null);
    };
    Object.defineProperty(CommentNode.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return this.rawText;
        },
        enumerable: false,
        configurable: true
    });
    CommentNode.prototype.toString = function () {
        return "<!--".concat(this.rawText, "-->");
    };
    return CommentNode;
}(node_1.default));
exports["default"] = CommentNode;


/***/ }),

/***/ 24382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = exports.base_parse = void 0;
var css_select_1 = __webpack_require__(75366);
var he_1 = __importDefault(__webpack_require__(86492));
var back_1 = __importDefault(__webpack_require__(38701));
var matcher_1 = __importDefault(__webpack_require__(20080));
var comment_1 = __importDefault(__webpack_require__(91271));
var node_1 = __importDefault(__webpack_require__(54936));
var text_1 = __importDefault(__webpack_require__(47923));
var type_1 = __importDefault(__webpack_require__(29979));
var voidTags = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
function decode(val) {
    // clone string
    return JSON.parse(JSON.stringify(he_1.default.decode(val)));
}
// https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
var Htags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup'];
var Dtags = ['details', 'dialog', 'dd', 'div', 'dt'];
var Ftags = ['fieldset', 'figcaption', 'figure', 'footer', 'form'];
var tableTags = ['table', 'td', 'tr'];
var htmlTags = ['address', 'article', 'aside', 'blockquote', 'br', 'hr', 'li', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'ul'];
var kBlockElements = new Set();
function addToKBlockElement() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var addToSet = function (array) {
        for (var index = 0; index < array.length; index++) {
            var element = array[index];
            kBlockElements.add(element);
            kBlockElements.add(element.toUpperCase());
        }
    };
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        addToSet(arg);
    }
}
addToKBlockElement(Htags, Dtags, Ftags, tableTags, htmlTags);
var DOMTokenList = /** @class */ (function () {
    function DOMTokenList(valuesInit, afterUpdate) {
        if (valuesInit === void 0) { valuesInit = []; }
        if (afterUpdate === void 0) { afterUpdate = function () { return null; }; }
        this._set = new Set(valuesInit);
        this._afterUpdate = afterUpdate;
    }
    DOMTokenList.prototype._validate = function (c) {
        if (/\s/.test(c)) {
            throw new Error("DOMException in DOMTokenList.add: The token '".concat(c, "' contains HTML space characters, which are not valid in tokens."));
        }
    };
    DOMTokenList.prototype.add = function (c) {
        this._validate(c);
        this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.replace = function (c1, c2) {
        this._validate(c2);
        this._set.delete(c1);
        this._set.add(c2);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.remove = function (c) {
        this._set.delete(c) && this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.toggle = function (c) {
        this._validate(c);
        if (this._set.has(c))
            this._set.delete(c);
        else
            this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.contains = function (c) {
        return this._set.has(c);
    };
    Object.defineProperty(DOMTokenList.prototype, "length", {
        get: function () {
            return this._set.size;
        },
        enumerable: false,
        configurable: true
    });
    DOMTokenList.prototype.values = function () {
        return this._set.values();
    };
    Object.defineProperty(DOMTokenList.prototype, "value", {
        get: function () {
            return Array.from(this._set.values());
        },
        enumerable: false,
        configurable: true
    });
    DOMTokenList.prototype.toString = function () {
        return Array.from(this._set.values()).join(' ');
    };
    return DOMTokenList;
}());
/**
 * HTMLElement, which contains a set of children.
 *
 * Note: this is a minimalist implementation, no complete tree
 *   structure provided (no parentNode, nextSibling,
 *   previousSibling etc).
 * @class HTMLElement
 * @extends {Node}
 */
var HTMLElement = /** @class */ (function (_super) {
    __extends(HTMLElement, _super);
    /**
     * Creates an instance of HTMLElement.
     * @param keyAttrs	id and class attribute
     * @param [rawAttrs]	attributes in string
     *
     * @memberof HTMLElement
     */
    function HTMLElement(tagName, keyAttrs, rawAttrs, parentNode, range) {
        if (rawAttrs === void 0) { rawAttrs = ''; }
        var _this = _super.call(this, parentNode, range) || this;
        _this.rawAttrs = rawAttrs;
        /**
         * Node Type declaration.
         */
        _this.nodeType = type_1.default.ELEMENT_NODE;
        _this.rawTagName = tagName;
        _this.rawAttrs = rawAttrs || '';
        _this.id = keyAttrs.id || '';
        _this.childNodes = [];
        _this.classList = new DOMTokenList(keyAttrs.class ? keyAttrs.class.split(/\s+/) : [], function (classList) { return _this.setAttribute('class', classList.toString()); } // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        );
        if (keyAttrs.id) {
            if (!rawAttrs) {
                _this.rawAttrs = "id=\"".concat(keyAttrs.id, "\"");
            }
        }
        if (keyAttrs.class) {
            if (!rawAttrs) {
                var cls = "class=\"".concat(_this.classList.toString(), "\"");
                if (_this.rawAttrs) {
                    _this.rawAttrs += " ".concat(cls);
                }
                else {
                    _this.rawAttrs = cls;
                }
            }
        }
        return _this;
    }
    /**
     * Quote attribute values
     * @param attr attribute value
     * @returns {string} quoted value
     */
    HTMLElement.prototype.quoteAttribute = function (attr) {
        if (attr == null) {
            return 'null';
        }
        return JSON.stringify(attr.replace(/"/g, '&quot;'));
    };
    /**
     * Remove Child element from childNodes array
     * @param {HTMLElement} node     node to remove
     */
    HTMLElement.prototype.removeChild = function (node) {
        this.childNodes = this.childNodes.filter(function (child) {
            return child !== node;
        });
        return this;
    };
    /**
     * Exchanges given child with new child
     * @param {HTMLElement} oldNode     node to exchange
     * @param {HTMLElement} newNode     new node
     */
    HTMLElement.prototype.exchangeChild = function (oldNode, newNode) {
        var children = this.childNodes;
        this.childNodes = children.map(function (child) {
            if (child === oldNode) {
                return newNode;
            }
            return child;
        });
        return this;
    };
    Object.defineProperty(HTMLElement.prototype, "tagName", {
        get: function () {
            return this.rawTagName ? this.rawTagName.toUpperCase() : this.rawTagName;
        },
        set: function (newname) {
            this.rawTagName = newname.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "localName", {
        get: function () {
            return this.rawTagName.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "isVoidElement", {
        get: function () {
            return voidTags.has(this.localName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "rawText", {
        /**
         * Get escpaed (as-it) text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return this.childNodes.reduce(function (pre, cur) {
                return (pre += cur.rawText);
            }, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "textContent", {
        get: function () {
            return decode(this.rawText);
        },
        set: function (val) {
            var content = [new text_1.default(val, this)];
            this.childNodes = content;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return decode(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "structuredText", {
        /**
         * Get structured Text (with '\n' etc.)
         * @return {string} structured text
         */
        get: function () {
            var currentBlock = [];
            var blocks = [currentBlock];
            function dfs(node) {
                if (node.nodeType === type_1.default.ELEMENT_NODE) {
                    if (kBlockElements.has(node.rawTagName)) {
                        if (currentBlock.length > 0) {
                            blocks.push((currentBlock = []));
                        }
                        node.childNodes.forEach(dfs);
                        if (currentBlock.length > 0) {
                            blocks.push((currentBlock = []));
                        }
                    }
                    else {
                        node.childNodes.forEach(dfs);
                    }
                }
                else if (node.nodeType === type_1.default.TEXT_NODE) {
                    if (node.isWhitespace) {
                        // Whitespace node, postponed output
                        currentBlock.prependWhitespace = true;
                    }
                    else {
                        var text = node.trimmedText;
                        if (currentBlock.prependWhitespace) {
                            text = " ".concat(text);
                            currentBlock.prependWhitespace = false;
                        }
                        currentBlock.push(text);
                    }
                }
            }
            dfs(this);
            return blocks
                .map(function (block) {
                return block.join('').replace(/\s{2,}/g, ' '); // Normalize each line's whitespace
            })
                .join('\n')
                .replace(/\s+$/, ''); // trimRight;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.toString = function () {
        var tag = this.rawTagName;
        if (tag) {
            var attrs = this.rawAttrs ? " ".concat(this.rawAttrs) : '';
            return this.isVoidElement ? "<".concat(tag).concat(attrs, ">") : "<".concat(tag).concat(attrs, ">").concat(this.innerHTML, "</").concat(tag, ">");
        }
        return this.innerHTML;
    };
    Object.defineProperty(HTMLElement.prototype, "innerHTML", {
        get: function () {
            return this.childNodes
                .map(function (child) {
                return child.toString();
            })
                .join('');
        },
        set: function (content) {
            //const r = parse(content, global.options); // TODO global.options ?
            var r = parse(content);
            var nodes = r.childNodes.length ? r.childNodes : [new text_1.default(content, this)];
            resetParent(nodes, this);
            resetParent(this.childNodes, null);
            this.childNodes = nodes;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.set_content = function (content, options) {
        if (options === void 0) { options = {}; }
        if (content instanceof node_1.default) {
            content = [content];
        }
        else if (typeof content == 'string') {
            var r = parse(content, options);
            content = r.childNodes.length ? r.childNodes : [new text_1.default(content, this)];
        }
        resetParent(this.childNodes, null);
        resetParent(content, this);
        this.childNodes = content;
        return this;
    };
    HTMLElement.prototype.replaceWith = function () {
        var _this = this;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        var parent = this.parentNode;
        var content = nodes
            .map(function (node) {
            if (node instanceof node_1.default) {
                return [node];
            }
            else if (typeof node == 'string') {
                // const r = parse(content, global.options); // TODO global.options ?
                var r = parse(node);
                return r.childNodes.length ? r.childNodes : [new text_1.default(node, _this)];
            }
            return [];
        })
            .flat();
        var idx = parent.childNodes.findIndex(function (child) {
            return child === _this;
        });
        resetParent([this], null);
        parent.childNodes = __spreadArray(__spreadArray(__spreadArray([], parent.childNodes.slice(0, idx), true), resetParent(content, parent), true), parent.childNodes.slice(idx + 1), true);
    };
    Object.defineProperty(HTMLElement.prototype, "outerHTML", {
        get: function () {
            return this.toString();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Trim element from right (in block) after seeing pattern in a TextNode.
     * @param  {RegExp} pattern pattern to find
     * @return {HTMLElement}    reference to current node
     */
    HTMLElement.prototype.trimRight = function (pattern) {
        for (var i = 0; i < this.childNodes.length; i++) {
            var childNode = this.childNodes[i];
            if (childNode.nodeType === type_1.default.ELEMENT_NODE) {
                childNode.trimRight(pattern);
            }
            else {
                var index = childNode.rawText.search(pattern);
                if (index > -1) {
                    childNode.rawText = childNode.rawText.substr(0, index);
                    // trim all following nodes.
                    this.childNodes.length = i + 1;
                }
            }
        }
        return this;
    };
    Object.defineProperty(HTMLElement.prototype, "structure", {
        /**
         * Get DOM structure
         * @return {string} strucutre
         */
        get: function () {
            var res = [];
            var indention = 0;
            function write(str) {
                res.push('  '.repeat(indention) + str);
            }
            function dfs(node) {
                var idStr = node.id ? "#".concat(node.id) : '';
                var classStr = node.classList.length ? ".".concat(node.classList.value.join('.')) : ''; // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-call
                write("".concat(node.rawTagName).concat(idStr).concat(classStr));
                indention++;
                node.childNodes.forEach(function (childNode) {
                    if (childNode.nodeType === type_1.default.ELEMENT_NODE) {
                        dfs(childNode);
                    }
                    else if (childNode.nodeType === type_1.default.TEXT_NODE) {
                        if (!childNode.isWhitespace) {
                            write('#text');
                        }
                    }
                });
                indention--;
            }
            dfs(this);
            return res.join('\n');
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Remove whitespaces in this sub tree.
     * @return {HTMLElement} pointer to this
     */
    HTMLElement.prototype.removeWhitespace = function () {
        var _this = this;
        var o = 0;
        this.childNodes.forEach(function (node) {
            if (node.nodeType === type_1.default.TEXT_NODE) {
                if (node.isWhitespace) {
                    return;
                }
                node.rawText = node.trimmedRawText;
            }
            else if (node.nodeType === type_1.default.ELEMENT_NODE) {
                node.removeWhitespace();
            }
            _this.childNodes[o++] = node;
        });
        this.childNodes.length = o;
        return this;
    };
    /**
     * Query CSS selector to find matching nodes.
     * @param  {string}         selector Simplified CSS selector
     * @return {HTMLElement[]}  matching elements
     */
    HTMLElement.prototype.querySelectorAll = function (selector) {
        return (0, css_select_1.selectAll)(selector, this, {
            xmlMode: true,
            adapter: matcher_1.default,
        });
    };
    /**
     * Query CSS Selector to find matching node.
     * @param  {string}         selector Simplified CSS selector
     * @return {(HTMLElement|null)}    matching node
     */
    HTMLElement.prototype.querySelector = function (selector) {
        return (0, css_select_1.selectOne)(selector, this, {
            xmlMode: true,
            adapter: matcher_1.default,
        });
    };
    /**
     * find elements by their tagName
     * @param {string} tagName the tagName of the elements to select
     */
    HTMLElement.prototype.getElementsByTagName = function (tagName) {
        var upperCasedTagName = tagName.toUpperCase();
        var re = [];
        var stack = [];
        var currentNodeReference = this;
        var index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while (index !== undefined) {
            var child = void 0;
            // make it work with sparse arrays
            do {
                child = currentNodeReference.childNodes[index++];
            } while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === type_1.default.ELEMENT_NODE) {
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByTagName#syntax
                if (tagName === '*' || child.tagName === upperCasedTagName)
                    re.push(child);
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return re;
    };
    /**
     * find element by it's id
     * @param {string} id the id of the element to select
     */
    HTMLElement.prototype.getElementById = function (id) {
        var stack = [];
        var currentNodeReference = this;
        var index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while (index !== undefined) {
            var child = void 0;
            // make it work with sparse arrays
            do {
                child = currentNodeReference.childNodes[index++];
            } while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === type_1.default.ELEMENT_NODE) {
                if (child.id === id) {
                    return child;
                }
                ;
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return null;
    };
    /**
     * traverses the Element and its parents (heading toward the document root) until it finds a node that matches the provided selector string. Will return itself or the matching ancestor. If no such element exists, it returns null.
     * @param selector a DOMString containing a selector list
     */
    HTMLElement.prototype.closest = function (selector) {
        var mapChild = new Map();
        var el = this;
        var old = null;
        function findOne(test, elems) {
            var elem = null;
            for (var i = 0, l = elems.length; i < l && !elem; i++) {
                var el_1 = elems[i];
                if (test(el_1)) {
                    elem = el_1;
                }
                else {
                    var child = mapChild.get(el_1);
                    if (child) {
                        elem = findOne(test, [child]);
                    }
                }
            }
            return elem;
        }
        while (el) {
            mapChild.set(el, old);
            old = el;
            el = el.parentNode;
        }
        el = this;
        while (el) {
            var e = (0, css_select_1.selectOne)(selector, el, {
                xmlMode: true,
                adapter: __assign(__assign({}, matcher_1.default), { getChildren: function (node) {
                        var child = mapChild.get(node);
                        return child && [child];
                    }, getSiblings: function (node) {
                        return [node];
                    }, findOne: findOne, findAll: function () {
                        return [];
                    } }),
            });
            if (e) {
                return e;
            }
            el = el.parentNode;
        }
        return null;
    };
    /**
     * Append a child node to childNodes
     * @param  {Node} node node to append
     * @return {Node}      node appended
     */
    HTMLElement.prototype.appendChild = function (node) {
        // remove the node from it's parent
        node.remove();
        this.childNodes.push(node);
        node.parentNode = this;
        return node;
    };
    Object.defineProperty(HTMLElement.prototype, "firstChild", {
        /**
         * Get first child node
         * @return {Node} first child node
         */
        get: function () {
            return this.childNodes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "lastChild", {
        /**
         * Get last child node
         * @return {Node} last child node
         */
        get: function () {
            return (0, back_1.default)(this.childNodes);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "attrs", {
        /**
         * Get attributes
         * @access private
         * @return {Object} parsed and unescaped attributes
         */
        get: function () {
            if (this._attrs) {
                return this._attrs;
            }
            this._attrs = {};
            var attrs = this.rawAttributes;
            for (var key in attrs) {
                var val = attrs[key] || '';
                this._attrs[key.toLowerCase()] = decode(val);
            }
            return this._attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "attributes", {
        get: function () {
            var ret_attrs = {};
            var attrs = this.rawAttributes;
            for (var key in attrs) {
                var val = attrs[key] || '';
                ret_attrs[key] = decode(val);
            }
            return ret_attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "rawAttributes", {
        /**
         * Get escaped (as-is) attributes
         * @return {Object} parsed attributes
         */
        get: function () {
            if (this._rawAttrs) {
                return this._rawAttrs;
            }
            var attrs = {};
            if (this.rawAttrs) {
                var re = /([a-zA-Z()#][a-zA-Z0-9-_:()#]*)(?:\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+))?/g;
                var match = void 0;
                while ((match = re.exec(this.rawAttrs))) {
                    var key = match[1];
                    var val = match[2] || null;
                    if (val && (val[0] === "'" || val[0] === "\""))
                        val = val.slice(1, val.length - 1);
                    attrs[key] = val;
                }
            }
            this._rawAttrs = attrs;
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.removeAttribute = function (key) {
        var attrs = this.rawAttributes;
        delete attrs[key];
        // Update this.attribute
        if (this._attrs) {
            delete this._attrs[key];
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs)
            .map(function (name) {
            var val = JSON.stringify(attrs[name]);
            if (val === undefined || val === 'null') {
                return name;
            }
            return "".concat(name, "=").concat(val);
        })
            .join(' ');
        // Update this.id
        if (key === 'id') {
            this.id = '';
        }
        return this;
    };
    HTMLElement.prototype.hasAttribute = function (key) {
        return key.toLowerCase() in this.attrs;
    };
    /**
     * Get an attribute
     * @return {string} value of the attribute
     */
    HTMLElement.prototype.getAttribute = function (key) {
        return this.attrs[key.toLowerCase()];
    };
    /**
     * Set an attribute value to the HTMLElement
     * @param {string} key The attribute name
     * @param {string} value The value to set, or null / undefined to remove an attribute
     */
    HTMLElement.prototype.setAttribute = function (key, value) {
        var _this = this;
        if (arguments.length < 2) {
            throw new Error("Failed to execute 'setAttribute' on 'Element'");
        }
        var k2 = key.toLowerCase();
        var attrs = this.rawAttributes;
        for (var k in attrs) {
            if (k.toLowerCase() === k2) {
                key = k;
                break;
            }
        }
        attrs[key] = String(value);
        // update this.attrs
        if (this._attrs) {
            this._attrs[k2] = decode(attrs[key]);
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs)
            .map(function (name) {
            var val = _this.quoteAttribute(attrs[name]);
            if (val === 'null' || val === '""')
                return name;
            return "".concat(name, "=").concat(val);
        })
            .join(' ');
        // Update this.id
        if (key === 'id') {
            this.id = value;
        }
    };
    /**
     * Replace all the attributes of the HTMLElement by the provided attributes
     * @param {Attributes} attributes the new attribute set
     */
    HTMLElement.prototype.setAttributes = function (attributes) {
        var _this = this;
        // Invalidate current this.attributes
        if (this._attrs) {
            delete this._attrs;
        }
        // Invalidate current this.rawAttributes
        if (this._rawAttrs) {
            delete this._rawAttrs;
        }
        // Update rawString
        this.rawAttrs = Object.keys(attributes)
            .map(function (name) {
            var val = attributes[name];
            if (val === 'null' || val === '""')
                return name;
            return "".concat(name, "=").concat(_this.quoteAttribute(String(val)));
        })
            .join(' ');
        return this;
    };
    HTMLElement.prototype.insertAdjacentHTML = function (where, html) {
        var _a, _b, _c;
        var _this = this;
        if (arguments.length < 2) {
            throw new Error('2 arguments required');
        }
        var p = parse(html);
        if (where === 'afterend') {
            var idx = this.parentNode.childNodes.findIndex(function (child) {
                return child === _this;
            });
            resetParent(p.childNodes, this.parentNode);
            (_a = this.parentNode.childNodes).splice.apply(_a, __spreadArray([idx + 1, 0], p.childNodes, false));
        }
        else if (where === 'afterbegin') {
            resetParent(p.childNodes, this);
            (_b = this.childNodes).unshift.apply(_b, p.childNodes);
        }
        else if (where === 'beforeend') {
            p.childNodes.forEach(function (n) {
                _this.appendChild(n);
            });
        }
        else if (where === 'beforebegin') {
            var idx = this.parentNode.childNodes.findIndex(function (child) {
                return child === _this;
            });
            resetParent(p.childNodes, this.parentNode);
            (_c = this.parentNode.childNodes).splice.apply(_c, __spreadArray([idx, 0], p.childNodes, false));
        }
        else {
            throw new Error("The value provided ('".concat(where, "') is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'"));
        }
        return this;
        // if (!where || html === undefined || html === null) {
        // 	return;
        // }
    };
    Object.defineProperty(HTMLElement.prototype, "nextSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = 0;
                while (i < children.length) {
                    var child = children[i++];
                    if (this === child)
                        return children[i] || null;
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "nextElementSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = 0;
                var find = false;
                while (i < children.length) {
                    var child = children[i++];
                    if (find) {
                        if (child instanceof HTMLElement) {
                            return child || null;
                        }
                    }
                    else if (this === child) {
                        find = true;
                    }
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "previousSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = children.length;
                while (i > 0) {
                    var child = children[--i];
                    if (this === child)
                        return children[i - 1] || null;
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "previousElementSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = children.length;
                var find = false;
                while (i > 0) {
                    var child = children[--i];
                    if (find) {
                        if (child instanceof HTMLElement) {
                            return child || null;
                        }
                    }
                    else if (this === child) {
                        find = true;
                    }
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "classNames", {
        get: function () {
            return this.classList.toString();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this Node
     */
    HTMLElement.prototype.clone = function () {
        return parse(this.toString()).firstChild;
    };
    return HTMLElement;
}(node_1.default));
exports["default"] = HTMLElement;
// https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
var kMarkupPattern = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][-.:0-9_a-zA-Z]*)((?:\s+[^>]*?(?:(?:'[^']*')|(?:"[^"]*"))?)*)\s*(\/?)>/g;
var kAttributePattern = /(?:^|\s)(id|class)\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+)/gi;
var kSelfClosingElements = {
    area: true,
    AREA: true,
    base: true,
    BASE: true,
    br: true,
    BR: true,
    col: true,
    COL: true,
    hr: true,
    HR: true,
    img: true,
    IMG: true,
    input: true,
    INPUT: true,
    link: true,
    LINK: true,
    meta: true,
    META: true,
    source: true,
    SOURCE: true,
    embed: true,
    EMBED: true,
    param: true,
    PARAM: true,
    track: true,
    TRACK: true,
    wbr: true,
    WBR: true,
};
var kElementsClosedByOpening = {
    li: { li: true, LI: true },
    LI: { li: true, LI: true },
    p: { p: true, div: true, P: true, DIV: true },
    P: { p: true, div: true, P: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    td: { td: true, th: true, TD: true, TH: true },
    TD: { td: true, th: true, TD: true, TH: true },
    th: { td: true, th: true, TD: true, TH: true },
    TH: { td: true, th: true, TD: true, TH: true },
    h1: { h1: true, H1: true },
    H1: { h1: true, H1: true },
    h2: { h2: true, H2: true },
    H2: { h2: true, H2: true },
    h3: { h3: true, H3: true },
    H3: { h3: true, H3: true },
    h4: { h4: true, H4: true },
    H4: { h4: true, H4: true },
    h5: { h5: true, H5: true },
    H5: { h5: true, H5: true },
    h6: { h6: true, H6: true },
    H6: { h6: true, H6: true },
};
var kElementsClosedByClosing = {
    li: { ul: true, ol: true, UL: true, OL: true },
    LI: { ul: true, ol: true, UL: true, OL: true },
    a: { div: true, DIV: true },
    A: { div: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    i: { div: true, DIV: true },
    I: { div: true, DIV: true },
    p: { div: true, DIV: true },
    P: { div: true, DIV: true },
    td: { tr: true, table: true, TR: true, TABLE: true },
    TD: { tr: true, table: true, TR: true, TABLE: true },
    th: { tr: true, table: true, TR: true, TABLE: true },
    TH: { tr: true, table: true, TR: true, TABLE: true },
};
var frameflag = 'documentfragmentcontainer';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 * @param  {string} data      html
 * @return {HTMLElement}      root element
 */
function base_parse(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var elements = options.blockTextElements || {
        script: true,
        noscript: true,
        style: true,
        pre: true,
    };
    var element_names = Object.keys(elements);
    var kBlockTextElements = element_names.map(function (it) { return new RegExp("^".concat(it, "$"), 'i'); });
    var kIgnoreElements = element_names.filter(function (it) { return elements[it]; }).map(function (it) { return new RegExp("^".concat(it, "$"), 'i'); });
    function element_should_be_ignore(tag) {
        return kIgnoreElements.some(function (it) { return it.test(tag); });
    }
    function is_block_text_element(tag) {
        return kBlockTextElements.some(function (it) { return it.test(tag); });
    }
    var createRange = function (startPos, endPos) { return [startPos - frameFlagOffset, endPos - frameFlagOffset]; };
    var root = new HTMLElement(null, {}, '', null, [0, data.length]);
    var currentParent = root;
    var stack = [root];
    var lastTextPos = -1;
    var noNestedTagIndex = undefined;
    var match;
    // https://github.com/taoqf/node-html-parser/issues/38
    data = "<".concat(frameflag, ">").concat(data, "</").concat(frameflag, ">");
    var lowerCaseTagName = options.lowerCaseTagName;
    var dataEndPos = data.length - (frameflag.length + 2);
    var frameFlagOffset = frameflag.length + 2;
    while ((match = kMarkupPattern.exec(data))) {
        // Note: Object destructuring here consistently tests as higher performance than array destructuring
        // eslint-disable-next-line prefer-const
        var matchText = match[0], leadingSlash = match[1], tagName = match[2], attributes = match[3], closingSlash = match[4];
        var matchLength = matchText.length;
        var tagStartPos = kMarkupPattern.lastIndex - matchLength;
        var tagEndPos = kMarkupPattern.lastIndex;
        // Add TextNode if content
        if (lastTextPos > -1) {
            if (lastTextPos + matchLength < tagEndPos) {
                var text = data.substring(lastTextPos, tagStartPos);
                currentParent.appendChild(new text_1.default(text, currentParent, createRange(lastTextPos, tagStartPos)));
            }
        }
        lastTextPos = kMarkupPattern.lastIndex;
        // https://github.com/taoqf/node-html-parser/issues/38
        // Skip frameflag node
        if (tagName === frameflag)
            continue;
        // Handle comments
        if (matchText[1] === '!') {
            if (options.comment) {
                // Only keep what is in between <!-- and -->
                var text = data.substring(tagStartPos + 4, tagEndPos - 3);
                currentParent.appendChild(new comment_1.default(text, currentParent, createRange(tagStartPos, tagEndPos)));
            }
            continue;
        }
        /* -- Handle tag matching -- */
        // Fix tag casing if necessary
        if (lowerCaseTagName)
            tagName = tagName.toLowerCase();
        // Handle opening tags (ie. <this> not </that>)
        if (!leadingSlash) {
            /* Populate attributes */
            var attrs = {};
            for (var attMatch = void 0; (attMatch = kAttributePattern.exec(attributes));) {
                var key = attMatch[1], val = attMatch[2];
                var isQuoted = val[0] === "'" || val[0] === "\"";
                attrs[key.toLowerCase()] = isQuoted ? val.slice(1, val.length - 1) : val;
            }
            var parentTagName = currentParent.rawTagName;
            if (!closingSlash && kElementsClosedByOpening[parentTagName]) {
                if (kElementsClosedByOpening[parentTagName][tagName]) {
                    stack.pop();
                    currentParent = (0, back_1.default)(stack);
                }
            }
            // Prevent nested A tags by terminating the last A and starting a new one : see issue #144
            if (tagName === 'a' || tagName === 'A') {
                if (noNestedTagIndex !== undefined) {
                    stack.splice(noNestedTagIndex);
                    currentParent = (0, back_1.default)(stack);
                }
                noNestedTagIndex = stack.length;
            }
            var tagEndPos_1 = kMarkupPattern.lastIndex;
            var tagStartPos_1 = tagEndPos_1 - matchLength;
            currentParent = currentParent.appendChild(
            // Initialize range (end position updated later for closed tags)
            new HTMLElement(tagName, attrs, attributes.slice(1), null, createRange(tagStartPos_1, tagEndPos_1)));
            stack.push(currentParent);
            if (is_block_text_element(tagName)) {
                // Find closing tag
                var closeMarkup = "</".concat(tagName, ">");
                var closeIndex = lowerCaseTagName
                    ? data.toLocaleLowerCase().indexOf(closeMarkup, kMarkupPattern.lastIndex)
                    : data.indexOf(closeMarkup, kMarkupPattern.lastIndex);
                var textEndPos = closeIndex === -1 ? dataEndPos : closeIndex;
                if (element_should_be_ignore(tagName)) {
                    var text = data.substring(tagEndPos_1, textEndPos);
                    if (text.length > 0 && /\S/.test(text)) {
                        currentParent.appendChild(new text_1.default(text, currentParent, createRange(tagEndPos_1, textEndPos)));
                    }
                }
                if (closeIndex === -1) {
                    lastTextPos = kMarkupPattern.lastIndex = data.length + 1;
                }
                else {
                    lastTextPos = kMarkupPattern.lastIndex = closeIndex + closeMarkup.length;
                    // Cause to be treated as self-closing, because no close found
                    leadingSlash = '/';
                }
            }
        }
        // Handle closing tags or self-closed elements (ie </tag> or <br>)
        if (leadingSlash || closingSlash || kSelfClosingElements[tagName]) {
            while (true) {
                if (tagName === 'a' || tagName === 'A')
                    noNestedTagIndex = undefined;
                if (currentParent.rawTagName === tagName) {
                    // Update range end for closed tag
                    currentParent.range[1] = createRange(-1, Math.max(lastTextPos, tagEndPos))[1];
                    stack.pop();
                    currentParent = (0, back_1.default)(stack);
                    break;
                }
                else {
                    var parentTagName = currentParent.tagName;
                    // Trying to close current tag, and move on
                    if (kElementsClosedByClosing[parentTagName]) {
                        if (kElementsClosedByClosing[parentTagName][tagName]) {
                            stack.pop();
                            currentParent = (0, back_1.default)(stack);
                            continue;
                        }
                    }
                    // Use aggressive strategy to handle unmatching markups.
                    break;
                }
            }
        }
    }
    return stack;
}
exports.base_parse = base_parse;
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function parse(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var stack = base_parse(data, options);
    var root = stack[0];
    var _loop_1 = function () {
        // Handle each error elements.
        var last = stack.pop();
        var oneBefore = (0, back_1.default)(stack);
        if (last.parentNode && last.parentNode.parentNode) {
            if (last.parentNode === oneBefore && last.tagName === oneBefore.tagName) {
                // Pair error case <h3> <h3> handle : Fixes to <h3> </h3>
                // this is wrong, becouse this will put the H3 outside the current right position which should be inside the current Html Element, see issue 152 for more info
                if (options.parseNoneClosedTags !== true) {
                    oneBefore.removeChild(last);
                    last.childNodes.forEach(function (child) {
                        oneBefore.parentNode.appendChild(child);
                    });
                    stack.pop();
                }
            }
            else {
                // Single error  <div> <h3> </div> handle: Just removes <h3>
                // Why remove? this is already a HtmlElement and the missing <H3> is already added in this case. see issue 152 for more info
                // eslint-disable-next-line no-lonely-if
                if (options.parseNoneClosedTags !== true) {
                    oneBefore.removeChild(last);
                    last.childNodes.forEach(function (child) {
                        oneBefore.appendChild(child);
                    });
                }
            }
        }
        else {
            // If it's final element just skip.
        }
    };
    while (stack.length > 1) {
        _loop_1();
    }
    // response.childNodes.forEach((node) => {
    // 	if (node instanceof HTMLElement) {
    // 		node.parentNode = null;
    // 	}
    // });
    return root;
}
exports.parse = parse;
function resetParent(nodes, parent) {
    return nodes.map(function (node) {
        node.parentNode = parent;
        return node;
    });
}


/***/ }),

/***/ 54936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var he_1 = __webpack_require__(86492);
/**
 * Node Class as base class for TextNode and HTMLElement.
 */
var Node = /** @class */ (function () {
    function Node(parentNode, range) {
        if (parentNode === void 0) { parentNode = null; }
        this.parentNode = parentNode;
        this.childNodes = [];
        Object.defineProperty(this, 'range', {
            enumerable: false,
            writable: true,
            configurable: true,
            value: range !== null && range !== void 0 ? range : [-1, -1]
        });
    }
    /**
     * Remove current node
     */
    Node.prototype.remove = function () {
        var _this = this;
        if (this.parentNode) {
            var children = this.parentNode.childNodes;
            this.parentNode.childNodes = children.filter(function (child) {
                return _this !== child;
            });
            this.parentNode = null;
        }
        return this;
    };
    Object.defineProperty(Node.prototype, "innerText", {
        get: function () {
            return this.rawText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "textContent", {
        get: function () {
            return (0, he_1.decode)(this.rawText);
        },
        set: function (val) {
            this.rawText = (0, he_1.encode)(val);
        },
        enumerable: false,
        configurable: true
    });
    return Node;
}());
exports["default"] = Node;


/***/ }),

/***/ 47923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var he_1 = __webpack_require__(86492);
var node_1 = __importDefault(__webpack_require__(54936));
var type_1 = __importDefault(__webpack_require__(29979));
/**
 * TextNode to contain a text element in DOM tree.
 * @param {string} value [description]
 */
var TextNode = /** @class */ (function (_super) {
    __extends(TextNode, _super);
    function TextNode(rawText, parentNode, range) {
        var _this = _super.call(this, parentNode, range) || this;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        _this.nodeType = type_1.default.TEXT_NODE;
        _this._rawText = rawText;
        return _this;
    }
    TextNode.prototype.clone = function () {
        return new TextNode(this._rawText, null);
    };
    Object.defineProperty(TextNode.prototype, "rawText", {
        get: function () {
            return this._rawText;
        },
        /**
         * Set rawText and invalidate trimmed caches
         */
        set: function (text) {
            this._rawText = text;
            this._trimmedRawText = void 0;
            this._trimmedText = void 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "trimmedRawText", {
        /**
         * Returns raw text with all whitespace trimmed except single leading/trailing non-breaking space
         */
        get: function () {
            if (this._trimmedRawText !== undefined)
                return this._trimmedRawText;
            this._trimmedRawText = trimText(this.rawText);
            return this._trimmedRawText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "trimmedText", {
        /**
         * Returns text with all whitespace trimmed except single leading/trailing non-breaking space
         */
        get: function () {
            if (this._trimmedText !== undefined)
                return this._trimmedText;
            this._trimmedText = trimText(this.text);
            return this._trimmedText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return (0, he_1.decode)(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "isWhitespace", {
        /**
         * Detect if the node contains only white space.
         * @return {boolean}
         */
        get: function () {
            return /^(\s|&nbsp;)*$/.test(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    TextNode.prototype.toString = function () {
        return this.rawText;
    };
    return TextNode;
}(node_1.default));
exports["default"] = TextNode;
/**
 * Trim whitespace except single leading/trailing non-breaking space
 */
function trimText(text) {
    var i = 0;
    var startPos;
    var endPos;
    while (i >= 0 && i < text.length) {
        if (/\S/.test(text[i])) {
            if (startPos === undefined) {
                startPos = i;
                i = text.length;
            }
            else {
                endPos = i;
                i = void 0;
            }
        }
        if (startPos === undefined)
            i++;
        else
            i--;
    }
    if (startPos === undefined)
        startPos = 0;
    if (endPos === undefined)
        endPos = text.length - 1;
    var hasLeadingSpace = startPos > 0 && /[^\S\r\n]/.test(text[startPos - 1]);
    var hasTrailingSpace = endPos < (text.length - 1) && /[^\S\r\n]/.test(text[endPos + 1]);
    return (hasLeadingSpace ? ' ' : '') + text.slice(startPos, endPos + 1) + (hasTrailingSpace ? ' ' : '');
}


/***/ }),

/***/ 29979:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var NodeType;
(function (NodeType) {
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
})(NodeType || (NodeType = {}));
exports["default"] = NodeType;


/***/ }),

/***/ 18821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var html_1 = __webpack_require__(24382);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return html_1.parse; } }));


/***/ }),

/***/ 56389:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var html_1 = __webpack_require__(24382);
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function valid(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var stack = (0, html_1.base_parse)(data, options);
    return Boolean(stack.length === 1);
}
exports["default"] = valid;


/***/ }),

/***/ 69769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generate = exports.compile = void 0;
var boolbase_1 = __importDefault(__webpack_require__(11073));
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 *
 * ```js
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 * ```
 */
function compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */
    if (b < 0 && a <= 0)
        return boolbase_1.default.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1)
        return function (index) { return index <= b; };
    if (a === 0)
        return function (index) { return index === b; };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1)
        return b < 0 ? boolbase_1.default.trueFunc : function (index) { return index >= b; };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */
    var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = ((b % absA) + absA) % absA;
    return a > 1
        ? function (index) { return index >= b && index % absA === bMod; }
        : function (index) { return index <= b && index % absA === bMod; };
}
exports.compile = compile;
/**
 * Returns a function that produces a monotonously increasing sequence of indices.
 *
 * If the sequence has an end, the returned function will return `null` after
 * the last index in the sequence.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing (2n+3)</caption>
 *
 * ```js
 * const gen = nthCheck.generate([2, 3])
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value (-2n+10)</caption>
 *
 * ```js
 *
 * const gen = nthCheck.generate([-2, 5]);
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function generate(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    var n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        var aPos_1 = -a;
        // Get `b mod a`
        var minValue_1 = ((b % aPos_1) + aPos_1) % aPos_1;
        return function () {
            var val = minValue_1 + aPos_1 * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0)
        return b < 0
            ? // There are no result — always return `null`
                function () { return null; }
            : // Return `b` exactly once
                function () { return (n++ === 0 ? b : null); };
    if (b < 0) {
        b += a * Math.ceil(-b / a);
    }
    return function () { return a * n++ + b; };
}
exports.generate = generate;
//# sourceMappingURL=compile.js.map

/***/ }),

/***/ 97540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sequence = exports.generate = exports.compile = exports.parse = void 0;
var parse_js_1 = __webpack_require__(7766);
Object.defineProperty(exports, "parse", ({ enumerable: true, get: function () { return parse_js_1.parse; } }));
var compile_js_1 = __webpack_require__(69769);
Object.defineProperty(exports, "compile", ({ enumerable: true, get: function () { return compile_js_1.compile; } }));
Object.defineProperty(exports, "generate", ({ enumerable: true, get: function () { return compile_js_1.generate; } }));
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of {@link parse} and {@link compile}.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */
function nthCheck(formula) {
    return (0, compile_js_1.compile)((0, parse_js_1.parse)(formula));
}
exports["default"] = nthCheck;
/**
 * Parses and compiles a formula to a generator that produces a sequence of indices.
 * Combination of {@link parse} and {@link generate}.
 *
 * @param formula The formula to compile.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing</caption>
 *
 * ```js
 * const gen = nthCheck.sequence('2n+3')
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value</caption>
 *
 * ```js
 *
 * const gen = nthCheck.sequence('-2n+5');
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function sequence(formula) {
    return (0, compile_js_1.generate)((0, parse_js_1.parse)(formula));
}
exports.sequence = sequence;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var whitespace = new Set([9, 10, 12, 13, 32]);
var ZERO = "0".charCodeAt(0);
var NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */
function parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") {
        return [2, 0];
    }
    else if (formula === "odd") {
        return [2, 1];
    }
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        }
        else {
            sign = number = 0;
        }
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) {
        throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    }
    return [a, sign * number];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") {
            idx++;
        }
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while (idx < formula.length &&
            formula.charCodeAt(idx) >= ZERO &&
            formula.charCodeAt(idx) <= NINE) {
            value = value * 10 + (formula.charCodeAt(idx) - ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while (idx < formula.length &&
            whitespace.has(formula.charCodeAt(idx))) {
            idx++;
        }
    }
}
exports.parse = parse;
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ 74241:
/***/ (function(module) {

var x=String;
var create=function() {return {isColorSupported:false,reset:x,bold:x,dim:x,italic:x,underline:x,inverse:x,hidden:x,strikethrough:x,black:x,red:x,green:x,yellow:x,blue:x,magenta:x,cyan:x,white:x,gray:x,bgBlack:x,bgRed:x,bgGreen:x,bgYellow:x,bgBlue:x,bgMagenta:x,bgCyan:x,bgWhite:x}};
module.exports=create();
module.exports.createColors = create;


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 11950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _warning = _interopRequireDefault(__webpack_require__(45520));

var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

__webpack_unused_export__ = HOOK_MARK;

var warningFunc = function warningFunc() {
  (0, _warning.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};

var Context = /*#__PURE__*/React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
var _default = Context;
exports.ZP = _default;

/***/ }),

/***/ 45520:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.call = call;
exports["default"] = void 0;
exports.note = note;
exports.noteOnce = noteOnce;
exports.resetWarned = resetWarned;
exports.warning = warning;
exports.warningOnce = warningOnce;

/* eslint-disable no-console */
var warned = {};

function warning(valid, message) {
  // Support uglify
  if (false) {}
}

function note(valid, message) {
  // Support uglify
  if (false) {}
}

function resetWarned() {
  warned = {};
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}

function noteOnce(valid, message) {
  call(note, valid, message);
}

var _default = warningOnce;
/* eslint-enable */

exports["default"] = _default;

/***/ }),

/***/ 9276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z5": function() { return /* binding */ DragDropContext; },
  "_l": function() { return /* binding */ PublicDraggable; },
  "bK": function() { return /* binding */ ConnectedDroppable; },
  "sO": function() { return /* binding */ resetServerContext; }
});

// UNUSED EXPORTS: useKeyboardSensor, useMouseSensor, useTouchSensor

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function Subscription_createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = Subscription_createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-is/index.js
var react_is = __webpack_require__(96001);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? Context_ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = Subscription_createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = useContext(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function useStore_createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function () {
    return useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/(/* unused pure expression or super */ null && (useStore_createStoreHook()));
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useDefaultStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/(/* unused pure expression or super */ null && (createDispatchHook()));
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = useReducer(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef();
  var latestStoreState = useRef();
  var latestSelectedState = useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function () {
    return useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/(/* unused pure expression or super */ null && (createSelectorHook()));
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);

;// CONCATENATED MODULE: ./node_modules/use-memo-one/dist/use-memo-one.esm.js


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = (0,react.useState)(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = (0,react.useRef)(true);
  var committed = (0,react.useRef)(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  (0,react.useEffect)(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var use_memo_one_esm_useMemo = useMemoOne;
var useCallback = useCallbackOne;



;// CONCATENATED MODULE: ./node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}



;// CONCATENATED MODULE: ./node_modules/css-box-model/dist/css-box-model.esm.js


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? 0 : invariant(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};



;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function memoize_one_esm_areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = memoize_one_esm_areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

;// CONCATENATED MODULE: ./node_modules/raf-schd/dist/raf-schd.esm.js
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ var raf_schd_esm = (rafSchd);

;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js











var react_beautiful_dnd_esm_isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log(type, message) {
  var _console;

  if (react_beautiful_dnd_esm_isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning = log.bind(null, 'warn');
var error = log.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return (0,esm_extends/* default */.Z)({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = "production" === 'production';
var react_beautiful_dnd_esm_prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function react_beautiful_dnd_esm_invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix);
  } else {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
         false ? 0 : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (false) {}
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (false) {}

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(react.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var react_beautiful_dnd_esm_isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var react_beautiful_dnd_esm_noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var react_beautiful_dnd_esm_scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return (0,esm_extends/* default */.Z)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = react_beautiful_dnd_esm_scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = (0,esm_extends/* default */.Z)({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = (0,esm_extends/* default */.Z)({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoize_one_esm(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoize_one_esm(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoize_one_esm(function (droppables) {
  return values(droppables);
});
var toDraggableList = memoize_one_esm(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = memoize_one_esm(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoize_one_esm(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return (0,esm_extends/* default */.Z)({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = (0,esm_extends/* default */.Z)({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = memoize_one_esm(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return (0,esm_extends/* default */.Z)({}, frame, {
    scroll: (0,esm_extends/* default */.Z)({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return (0,esm_extends/* default */.Z)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = (0,esm_extends/* default */.Z)({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return (0,esm_extends/* default */.Z)({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start = function start(key) {
  if (false) {}
};
var finish = function finish(key) {
  if (false) {}
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = (0,esm_extends/* default */.Z)({}, draggable, {
    placeholder: (0,esm_extends/* default */.Z)({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = (0,esm_extends/* default */.Z)({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = (0,esm_extends/* default */.Z)({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = (0,esm_extends/* default */.Z)({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = (0,esm_extends/* default */.Z)({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return (0,esm_extends/* default */.Z)({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result = (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (react_beautiful_dnd_esm_isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var updated = (0,esm_extends/* default */.Z)({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _updated = (0,esm_extends/* default */.Z)({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (react_beautiful_dnd_esm_isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (react_beautiful_dnd_esm_isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = (0,esm_extends/* default */.Z)({}, state.viewport, {
      scroll: (0,esm_extends/* default */.Z)({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var newState = (0,esm_extends/* default */.Z)({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
   false ? 0 : void 0;
}

function validateDimensions(critical, dimensions) {
  if (false) { var insideDestination; }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return react_beautiful_dnd_esm_isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = (0,esm_extends/* default */.Z)({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !react_beautiful_dnd_esm_isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var react_beautiful_dnd_esm_getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(react_beautiful_dnd_esm_getWindowScroll());
  }

  var scheduled = raf_schd_esm(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? 0 : void 0;
      return;
    }

    if (isExpired) {
       false ? 0 : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = (0,esm_extends/* default */.Z)({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = (0,esm_extends/* default */.Z)({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var react_beautiful_dnd_esm_focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? 0 : redux/* compose */.qC;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return (0,redux/* createStore */.MT)(reducer, composeEnhancers((0,redux/* applyMiddleware */.md)(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, react_beautiful_dnd_esm_focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = react_beautiful_dnd_esm_getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
     false ? 0 : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = memoize_one_esm(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? 0 : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (react_beautiful_dnd_esm_isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return react_beautiful_dnd_esm_isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (react_beautiful_dnd_esm_isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = raf_schd_esm(scrollWindow);
  var scheduleDroppableScroll = raf_schd_esm(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var react_beautiful_dnd_esm_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = use_memo_one_esm_useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = (0,react.useRef)(null);
  var dynamicRef = (0,react.useRef)(null);
  var setDynamicStyle = useCallback(memoize_one_esm(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = use_memo_one_esm_useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
     false ? 0 : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
     false ? 0 : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = (0,react.useRef)({});
  var recordRef = (0,react.useRef)(null);
  var restoreFocusFrameRef = (0,react.useRef)(null);
  var isMountedRef = (0,react.useRef)(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = use_memo_one_esm_useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = use_memo_one_esm_useMemo(createRegistry, []);
  (0,react.useEffect)(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = react.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = use_memo_one_esm_useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    (0,esm_extends/* default */.Z)(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? 0 : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults = {
  separator: '::'
};
function react_beautiful_dnd_esm_reset() {
  count = 0;
}
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults;
  }

  return use_memo_one_esm_useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = use_memo_one_esm_useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  (0,react.useEffect)(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = react.createContext(null);

var peerDependencies = {
	react: "^16.8.5 || ^17.0.0",
	"react-dom": "^16.8.5 || ^17.0.0"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? 0 : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? 0 : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? 0 : void 0;
  }

  if (doctype.publicId !== '') {
     false ? 0 : void 0;
  }
});

function useDev(useHook) {
  if (false) {}
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    (0,react.useEffect)(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, react.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = (0,react.useRef)(current);
  (0,react.useEffect)(function () {
    ref.current = current;
  });
  return ref;
}

function create() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var react_beautiful_dnd_esm_escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = (0,react.useRef)(idle$1);
  var unbindEventsRef = (0,react.useRef)(noop);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = (0,react.useRef)(noop$1);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = (0,react.useRef)(idle$2);
  var unbindEventsRef = (0,react.useRef)(noop);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
     false ? 0 : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
     false ? 0 : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
     false ? 0 : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
     false ? 0 : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return (0,esm_extends/* default */.Z)({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = raf_schd_esm(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return (0,esm_extends/* default */.Z)({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = (0,react.useState)(function () {
    return create();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = use_memo_one_esm_useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = (0,react.useRef)(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = use_memo_one_esm_useMemo(function () {
    return (0,redux/* bindActionCreators */.DE)({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = use_memo_one_esm_useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = use_memo_one_esm_useMemo(function () {
    return createAutoScroller((0,esm_extends/* default */.Z)({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, (0,redux/* bindActionCreators */.DE)({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = use_memo_one_esm_useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (false) {}

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = use_memo_one_esm_useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = use_memo_one_esm_useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  (0,react.useEffect)(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return react.createElement(AppContext.Provider, {
    value: appContext
  }, react.createElement(components_Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function reset$1() {
  count$1 = 0;
}
function useInstanceCount() {
  return use_memo_one_esm_useMemo(function () {
    return "" + count$1++;
  }, []);
}

function resetServerContext() {
  reset$1();
  react_beautiful_dnd_esm_reset();
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return react.createElement(ErrorBoundary, null, function (setCallbacks) {
    return react.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? 0 : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? 0 : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = (0,react.useContext)(Context);
  !result ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = (0,react.useRef)(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = use_memo_one_esm_useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = (0,react.useRef)(descriptor);
  var memoizedUpdateScroll = use_memo_one_esm_useMemo(function () {
    return memoize_one_esm(function (x, y) {
      !whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = use_memo_one_esm_useMemo(function () {
    return raf_schd_esm(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {}
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = use_memo_one_esm_useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = use_memo_one_esm_useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
         false ? 0 : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: react_beautiful_dnd_esm_noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = (0,react.useRef)(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = (0,react.useState)(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  (0,react.useEffect)(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return react.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = react.memo(Placeholder);

var DroppableContext = react.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

   false ? 0 : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  (0,inheritsLoose/* default */.Z)(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(react.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = use_memo_one_esm_useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = use_memo_one_esm_useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = (0,react.useRef)(entry);
  var isFirstPublishRef = (0,react.useRef)(true);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(typeof id === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !isInteger(props.index) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = (0,react.useRef)(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = (0,react.useRef)(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = use_memo_one_esm_useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = use_memo_one_esm_useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = use_memo_one_esm_useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = use_memo_one_esm_useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = use_memo_one_esm_useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoize_one_esm(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoize_one_esm(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoize_one_esm(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoize_one_esm(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoize_one_esm(getSecondarySnapshot);
  var getMemoizedProps = memoize_one_esm(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var react_beautiful_dnd_esm_mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, react_beautiful_dnd_esm_mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return react.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return react.createElement(PrivateDraggable, (0,esm_extends/* default */.Z)({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = (0,react.useContext)(AppContext);
  !appContext ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = (0,react.useRef)(null);
  var placeholderRef = (0,react.useRef)(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = react.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return react.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = use_memo_one_esm_useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = use_memo_one_esm_useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = react.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return react_dom.createPortal(node, getContainerForClone());
  }

  return react.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = (0,esm_extends/* default */.Z)({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoize_one_esm(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoize_one_esm(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;




/***/ }),

/***/ 51693:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 96001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(51693);
} else {}


/***/ }),

/***/ 68718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Db": function() { return /* binding */ initReactI18next; },
/* harmony export */   "JP": function() { return /* binding */ getDefaults; },
/* harmony export */   "OO": function() { return /* binding */ I18nContext; },
/* harmony export */   "nI": function() { return /* binding */ getI18n; },
/* harmony export */   "zv": function() { return /* binding */ ReportNamespaces; }
/* harmony export */ });
/* unused harmony exports setDefaults, setI18n, composeInitialProps, getInitialProps */
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),

/***/ 31567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js
var context = __webpack_require__(68718);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context/* I18nContext */.OO) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,context/* getI18n */.nI)();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new context/* ReportNamespaces */.zv();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0,context/* getDefaults */.JP)()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 72679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{var e={296:(e,t,r)=>{var n=/^\s+|\s+$/g,o=/^[-+]0x[0-9a-f]+$/i,i=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,l="object"==typeof self&&self&&self.Object===Object&&self,a=u||l||Function("return this")(),f=Object.prototype.toString,p=Math.max,y=Math.min,d=function(){return a.Date.now()};function b(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function h(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&"[object Symbol]"==f.call(e)}(e))return NaN;if(b(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=b(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(n,"");var r=i.test(e);return r||c.test(e)?s(e.slice(2),r?2:8):o.test(e)?NaN:+e}e.exports=function(e,t,r){var n,o,i,c,s,u,l=0,a=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function m(t){var r=n,i=o;return n=o=void 0,l=t,c=e.apply(i,r)}function O(e){return l=e,s=setTimeout(g,t),a?m(e):c}function w(e){var r=e-u;return void 0===u||r>=t||r<0||f&&e-l>=i}function g(){var e=d();if(w(e))return P(e);s=setTimeout(g,function(e){var r=t-(e-u);return f?y(r,i-(e-l)):r}(e))}function P(e){return s=void 0,v&&n?m(e):(n=o=void 0,c)}function j(){var e=d(),r=w(e);if(n=arguments,o=this,u=e,r){if(void 0===s)return O(u);if(f)return s=setTimeout(g,t),m(u)}return void 0===s&&(s=setTimeout(g,t)),c}return t=h(t)||0,b(r)&&(a=!!r.leading,i=(f="maxWait"in r)?p(h(r.maxWait)||0,t):i,v="trailing"in r?!!r.trailing:v),j.cancel=function(){void 0!==s&&clearTimeout(s),l=0,n=u=o=s=void 0},j.flush=function(){return void 0===s?c:P(d())},j}},96:(e,t,r)=>{var n="Expected a function",o=/^\s+|\s+$/g,i=/^[-+]0x[0-9a-f]+$/i,c=/^0b[01]+$/i,s=/^0o[0-7]+$/i,u=parseInt,l="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,a="object"==typeof self&&self&&self.Object===Object&&self,f=l||a||Function("return this")(),p=Object.prototype.toString,y=Math.max,d=Math.min,b=function(){return f.Date.now()};function h(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function v(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&"[object Symbol]"==p.call(e)}(e))return NaN;if(h(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=h(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var r=c.test(e);return r||s.test(e)?u(e.slice(2),r?2:8):i.test(e)?NaN:+e}e.exports=function(e,t,r){var o=!0,i=!0;if("function"!=typeof e)throw new TypeError(n);return h(r)&&(o="leading"in r?!!r.leading:o,i="trailing"in r?!!r.trailing:i),function(e,t,r){var o,i,c,s,u,l,a=0,f=!1,p=!1,m=!0;if("function"!=typeof e)throw new TypeError(n);function O(t){var r=o,n=i;return o=i=void 0,a=t,s=e.apply(n,r)}function w(e){return a=e,u=setTimeout(P,t),f?O(e):s}function g(e){var r=e-l;return void 0===l||r>=t||r<0||p&&e-a>=c}function P(){var e=b();if(g(e))return j(e);u=setTimeout(P,function(e){var r=t-(e-l);return p?d(r,c-(e-a)):r}(e))}function j(e){return u=void 0,m&&o?O(e):(o=i=void 0,s)}function T(){var e=b(),r=g(e);if(o=arguments,i=this,l=e,r){if(void 0===u)return w(l);if(p)return u=setTimeout(P,t),O(l)}return void 0===u&&(u=setTimeout(P,t)),s}return t=v(t)||0,h(r)&&(f=!!r.leading,c=(p="maxWait"in r)?y(v(r.maxWait)||0,t):c,m="trailing"in r?!!r.trailing:m),T.cancel=function(){void 0!==u&&clearTimeout(u),a=0,o=l=i=u=void 0},T.flush=function(){return void 0===u?s:j(b())},T}(e,t,{leading:o,maxWait:t,trailing:i})}},703:(e,t,r)=>{"use strict";var n=r(414);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,r,o,i,c){if(c!==n){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return r.PropTypes=r,r}},697:(e,t,r)=>{e.exports=r(703)()},414:e=>{"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var i=t[n]={exports:{}};return e[n](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};(()=>{"use strict";r.r(n),r.d(n,{LazyLoadComponent:()=>J,LazyLoadImage:()=>ue,trackWindowScroll:()=>C});const e=__webpack_require__(67294);var t=r.n(e),o=r(697);const i=__webpack_require__(73935);var c=r.n(i);function s(){return"undefined"!=typeof window&&"IntersectionObserver"in window&&"isIntersecting"in window.IntersectionObserverEntry.prototype}function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function a(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function f(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function p(e,t){return(p=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function y(e,t){if(t&&("object"===u(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var b=function(e){e.forEach((function(e){e.isIntersecting&&e.target.onVisible()}))},h={},v=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&p(e,t)}(v,e);var r,n,o,i,u=(o=v,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=d(o);if(i){var r=d(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return y(this,e)});function v(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,v),(t=u.call(this,e)).supportsObserver=!e.scrollPosition&&e.useIntersectionObserver&&s(),t.supportsObserver){var r=e.threshold;t.observer=function(e){return h[e]=h[e]||new IntersectionObserver(b,{rootMargin:e+"px"}),h[e]}(r)}return t}return r=v,(n=[{key:"componentDidMount",value:function(){this.placeholder&&this.observer&&(this.placeholder.onVisible=this.props.onVisible,this.observer.observe(this.placeholder)),this.supportsObserver||this.updateVisibility()}},{key:"componentWillUnmount",value:function(){this.observer&&this.observer.unobserve(this.placeholder)}},{key:"componentDidUpdate",value:function(){this.supportsObserver||this.updateVisibility()}},{key:"getPlaceholderBoundingBox",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.scrollPosition,t=this.placeholder.getBoundingClientRect(),r=c().findDOMNode(this.placeholder).style,n={left:parseInt(r.getPropertyValue("margin-left"),10)||0,top:parseInt(r.getPropertyValue("margin-top"),10)||0};return{bottom:e.y+t.bottom+n.top,left:e.x+t.left+n.left,right:e.x+t.right+n.left,top:e.y+t.top+n.top}}},{key:"isPlaceholderInViewport",value:function(){if("undefined"==typeof window||!this.placeholder)return!1;var e=this.props,t=e.scrollPosition,r=e.threshold,n=this.getPlaceholderBoundingBox(t),o=t.y+window.innerHeight,i=t.x,c=t.x+window.innerWidth,s=t.y;return Boolean(s-r<=n.bottom&&o+r>=n.top&&i-r<=n.right&&c+r>=n.left)}},{key:"updateVisibility",value:function(){this.isPlaceholderInViewport()&&this.props.onVisible()}},{key:"render",value:function(){var e=this,r=this.props,n=r.className,o=r.height,i=r.placeholder,c=r.style,s=r.width;if(i&&"function"!=typeof i.type)return t().cloneElement(i,{ref:function(t){return e.placeholder=t}});var u=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){a(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({display:"inline-block"},c);return void 0!==s&&(u.width=s),void 0!==o&&(u.height=o),t().createElement("span",{className:n,ref:function(t){return e.placeholder=t},style:u},i)}}])&&f(r.prototype,n),v}(t().Component);v.propTypes={onVisible:o.PropTypes.func.isRequired,className:o.PropTypes.string,height:o.PropTypes.oneOfType([o.PropTypes.number,o.PropTypes.string]),placeholder:o.PropTypes.element,threshold:o.PropTypes.number,useIntersectionObserver:o.PropTypes.bool,scrollPosition:o.PropTypes.shape({x:o.PropTypes.number.isRequired,y:o.PropTypes.number.isRequired}),width:o.PropTypes.oneOfType([o.PropTypes.number,o.PropTypes.string])},v.defaultProps={className:"",placeholder:null,threshold:100,useIntersectionObserver:!0};const m=v;var O=r(296),w=r.n(O),g=r(96),P=r.n(g),j=function(e){var t=getComputedStyle(e,null);return t.getPropertyValue("overflow")+t.getPropertyValue("overflow-y")+t.getPropertyValue("overflow-x")};const T=function(e){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t instanceof HTMLElement;){if(/(scroll|auto)/.test(j(t)))return t;t=t.parentNode}return window};function S(e){return(S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var E=["delayMethod","delayTime"];function _(){return(_=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function I(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function L(e,t){return(L=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function x(e,t){if(t&&("object"===S(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return R(e)}function R(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function k(e){return(k=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var D=function(){return"undefined"==typeof window?0:window.scrollX||window.pageXOffset},N=function(){return"undefined"==typeof window?0:window.scrollY||window.pageYOffset};const C=function(e){var r=function(r){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&L(e,t)}(a,r);var n,o,i,u,l=(i=a,u=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=k(i);if(u){var r=k(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return x(this,e)});function a(e){var r;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(r=l.call(this,e)).useIntersectionObserver=e.useIntersectionObserver&&s(),r.useIntersectionObserver)return x(r);var n=r.onChangeScroll.bind(R(r));return"debounce"===e.delayMethod?r.delayedScroll=w()(n,e.delayTime):"throttle"===e.delayMethod&&(r.delayedScroll=P()(n,e.delayTime)),r.state={scrollPosition:{x:D(),y:N()}},r.baseComponentRef=t().createRef(),r}return n=a,(o=[{key:"componentDidMount",value:function(){this.addListeners()}},{key:"componentWillUnmount",value:function(){this.removeListeners()}},{key:"componentDidUpdate",value:function(){"undefined"==typeof window||this.useIntersectionObserver||T(c().findDOMNode(this.baseComponentRef.current))!==this.scrollElement&&(this.removeListeners(),this.addListeners())}},{key:"addListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement=T(c().findDOMNode(this.baseComponentRef.current)),this.scrollElement.addEventListener("scroll",this.delayedScroll,{passive:!0}),window.addEventListener("resize",this.delayedScroll,{passive:!0}),this.scrollElement!==window&&window.addEventListener("scroll",this.delayedScroll,{passive:!0}))}},{key:"removeListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement.removeEventListener("scroll",this.delayedScroll),window.removeEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.removeEventListener("scroll",this.delayedScroll))}},{key:"onChangeScroll",value:function(){this.useIntersectionObserver||this.setState({scrollPosition:{x:D(),y:N()}})}},{key:"render",value:function(){var r=this.props,n=(r.delayMethod,r.delayTime,function(e,t){if(null==e)return{};var r,n,o=function(e,t){if(null==e)return{};var r,n,o={},i=Object.keys(e);for(n=0;n<i.length;n++)r=i[n],t.indexOf(r)>=0||(o[r]=e[r]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(n=0;n<i.length;n++)r=i[n],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}(r,E)),o=this.useIntersectionObserver?null:this.state.scrollPosition;return t().createElement(e,_({forwardRef:this.baseComponentRef,scrollPosition:o},n))}}])&&I(n.prototype,o),a}(t().Component);return r.propTypes={delayMethod:o.PropTypes.oneOf(["debounce","throttle"]),delayTime:o.PropTypes.number,useIntersectionObserver:o.PropTypes.bool},r.defaultProps={delayMethod:"throttle",delayTime:300,useIntersectionObserver:!0},r};function M(e){return(M="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function B(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function V(e,t){return(V=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function W(e,t){if(t&&("object"===M(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function z(e){return(z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var $=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&V(e,t)}(s,e);var r,n,o,i,c=(o=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=z(o);if(i){var r=z(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return W(this,e)});function s(e){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),c.call(this,e)}return r=s,(n=[{key:"render",value:function(){return t().createElement(m,this.props)}}])&&B(r.prototype,n),s}(t().Component);const U=C($);function q(e){return(q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function F(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function H(e,t){return(H=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Y(e,t){if(t&&("object"===q(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return X(e)}function X(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function A(e){return(A=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var G=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&H(e,t)}(u,e);var r,n,o,i,c=(o=u,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=A(o);if(i){var r=A(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return Y(this,e)});function u(e){var t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),t=c.call(this,e);var r=e.afterLoad,n=e.beforeLoad,o=e.scrollPosition,i=e.visibleByDefault;return t.state={visible:i},i&&(n(),r()),t.onVisible=t.onVisible.bind(X(t)),t.isScrollTracked=Boolean(o&&Number.isFinite(o.x)&&o.x>=0&&Number.isFinite(o.y)&&o.y>=0),t}return r=u,(n=[{key:"componentDidUpdate",value:function(e,t){t.visible!==this.state.visible&&this.props.afterLoad()}},{key:"onVisible",value:function(){this.props.beforeLoad(),this.setState({visible:!0})}},{key:"render",value:function(){if(this.state.visible)return this.props.children;var e=this.props,r=e.className,n=e.delayMethod,o=e.delayTime,i=e.height,c=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.width;return this.isScrollTracked||f&&s()?t().createElement(m,{className:r,height:i,onVisible:this.onVisible,placeholder:c,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,width:p}):t().createElement(U,{className:r,delayMethod:n,delayTime:o,height:i,onVisible:this.onVisible,placeholder:c,style:l,threshold:a,width:p})}}])&&F(r.prototype,n),u}(t().Component);G.propTypes={afterLoad:o.PropTypes.func,beforeLoad:o.PropTypes.func,useIntersectionObserver:o.PropTypes.bool,visibleByDefault:o.PropTypes.bool},G.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},useIntersectionObserver:!0,visibleByDefault:!1};const J=G;function K(e){return(K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var Q=["afterLoad","beforeLoad","delayMethod","delayTime","effect","placeholder","placeholderSrc","scrollPosition","threshold","useIntersectionObserver","visibleByDefault","wrapperClassName","wrapperProps"];function Z(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function ee(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?Z(Object(r),!0).forEach((function(t){te(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):Z(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function te(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function re(){return(re=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function ne(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function oe(e,t){return(oe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ie(e,t){if(t&&("object"===K(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function ce(e){return(ce=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var se=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&oe(e,t)}(s,e);var r,n,o,i,c=(o=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=ce(o);if(i){var r=ce(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return ie(this,e)});function s(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),(t=c.call(this,e)).state={loaded:!1},t}return r=s,(n=[{key:"onImageLoad",value:function(){var e=this;return this.state.loaded?null:function(){e.props.afterLoad(),e.setState({loaded:!0})}}},{key:"getImg",value:function(){var e=this.props,r=(e.afterLoad,e.beforeLoad,e.delayMethod,e.delayTime,e.effect,e.placeholder,e.placeholderSrc,e.scrollPosition,e.threshold,e.useIntersectionObserver,e.visibleByDefault,e.wrapperClassName,e.wrapperProps,function(e,t){if(null==e)return{};var r,n,o=function(e,t){if(null==e)return{};var r,n,o={},i=Object.keys(e);for(n=0;n<i.length;n++)r=i[n],t.indexOf(r)>=0||(o[r]=e[r]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(n=0;n<i.length;n++)r=i[n],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}(e,Q));return t().createElement("img",re({onLoad:this.onImageLoad()},r))}},{key:"getLazyLoadImage",value:function(){var e=this.props,r=e.beforeLoad,n=e.className,o=e.delayMethod,i=e.delayTime,c=e.height,s=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.visibleByDefault,y=e.width;return t().createElement(J,{beforeLoad:r,className:n,delayMethod:o,delayTime:i,height:c,placeholder:s,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,visibleByDefault:p,width:y},this.getImg())}},{key:"getWrappedLazyLoadImage",value:function(e){var r=this.props,n=r.effect,o=r.height,i=r.placeholderSrc,c=r.width,s=r.wrapperClassName,u=r.wrapperProps,l=this.state.loaded,a=l?" lazy-load-image-loaded":"",f=l||!i?{}:{backgroundImage:"url(".concat(i,")"),backgroundSize:"100% 100%"};return t().createElement("span",re({className:s+" lazy-load-image-background "+n+a,style:ee(ee({},f),{},{color:"transparent",display:"inline-block",height:o,width:c})},u),e)}},{key:"render",value:function(){var e=this.props,t=e.effect,r=e.placeholderSrc,n=e.visibleByDefault,o=e.wrapperClassName,i=e.wrapperProps,c=this.getLazyLoadImage();return(t||r)&&!n||o||i?this.getWrappedLazyLoadImage(c):c}}])&&ne(r.prototype,n),s}(t().Component);se.propTypes={afterLoad:o.PropTypes.func,beforeLoad:o.PropTypes.func,delayMethod:o.PropTypes.string,delayTime:o.PropTypes.number,effect:o.PropTypes.string,placeholderSrc:o.PropTypes.string,threshold:o.PropTypes.number,useIntersectionObserver:o.PropTypes.bool,visibleByDefault:o.PropTypes.bool,wrapperClassName:o.PropTypes.string,wrapperProps:o.PropTypes.object},se.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},delayMethod:"throttle",delayTime:300,effect:"",placeholderSrc:null,threshold:100,useIntersectionObserver:!0,visibleByDefault:!1,wrapperClassName:""};const ue=se})(),module.exports=n})();

/***/ }),

/***/ 59852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 46747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81832);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86755);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueries")) __webpack_require__.d(__webpack_exports__, { "useQueries": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueries; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });














 // Types



/***/ }),

/***/ 41909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 40068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 81832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutation.js




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,esm_extends/* default */.Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,logger/* getLogger */.j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new retryer/* Retryer */.m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,esm_extends/* default */.Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,esm_extends/* default */.Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,esm_extends/* default */.Z)({}, state, action.state);

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(40068);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,utils/* getAbortController */.G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,retryer/* isCancelable */.LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,retryer/* isCancelable */.LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 21216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59852);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40068);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 52943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 86755:
/***/ (function() {



/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rc": function() { return /* binding */ replaceAt; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "e5": function() { return /* binding */ difference; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports parseMutationArgs, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return _extends({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return _extends({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return _extends({}, arg2, {
      mutationFn: arg1
    });
  }

  return _extends({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useQueries": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueries; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueries")) __webpack_require__.d(__webpack_exports__, { "useQueries": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueries; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8572);



/***/ }),

/***/ 8572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useQueries": function() { return /* reexport */ useQueries; },
  "useQuery": function() { return /* reexport */ useQuery; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useInfiniteQuery, useIsFetching, useIsMutating, useMutation, useQueryClient, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queriesObserver.js





var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueriesObserver, _Subscribable);

  function QueriesObserver(client, queries) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.queries = [];
    _this.result = [];
    _this.observers = [];
    _this.observersMap = {};

    if (queries) {
      _this.setQueries(queries);
    }

    return _this;
  }

  var _proto = QueriesObserver.prototype;

  _proto.onSubscribe = function onSubscribe() {
    var _this2 = this;

    if (this.listeners.length === 1) {
      this.observers.forEach(function (observer) {
        observer.subscribe(function (result) {
          _this2.onUpdate(observer, result);
        });
      });
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.observers.forEach(function (observer) {
      observer.destroy();
    });
  };

  _proto.setQueries = function setQueries(queries, notifyOptions) {
    this.queries = queries;
    this.updateObservers(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.result;
  };

  _proto.getOptimisticResult = function getOptimisticResult(queries) {
    return this.findMatchingObservers(queries).map(function (match) {
      return match.observer.getOptimisticResult(match.defaultedQueryOptions);
    });
  };

  _proto.findMatchingObservers = function findMatchingObservers(queries) {
    var _this3 = this;

    var prevObservers = this.observers;
    var defaultedQueryOptions = queries.map(function (options) {
      return _this3.client.defaultQueryObserverOptions(options);
    });
    var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
      var match = prevObservers.find(function (observer) {
        return observer.options.queryHash === defaultedOptions.queryHash;
      });

      if (match != null) {
        return [{
          defaultedQueryOptions: defaultedOptions,
          observer: match
        }];
      }

      return [];
    });
    var matchedQueryHashes = matchingObservers.map(function (match) {
      return match.defaultedQueryOptions.queryHash;
    });
    var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
      return !matchedQueryHashes.includes(defaultedOptions.queryHash);
    });
    var unmatchedObservers = prevObservers.filter(function (prevObserver) {
      return !matchingObservers.some(function (match) {
        return match.observer === prevObserver;
      });
    });
    var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
      if (options.keepPreviousData) {
        // return previous data from one of the observers that no longer match
        var previouslyUsedObserver = unmatchedObservers[index];

        if (previouslyUsedObserver !== undefined) {
          return {
            defaultedQueryOptions: options,
            observer: previouslyUsedObserver
          };
        }
      }

      return {
        defaultedQueryOptions: options,
        observer: _this3.getObserver(options)
      };
    });

    var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
      return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
    };

    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
  };

  _proto.getObserver = function getObserver(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var currentObserver = this.observersMap[defaultedOptions.queryHash];
    return currentObserver != null ? currentObserver : new QueryObserver(this.client, defaultedOptions);
  };

  _proto.updateObservers = function updateObservers(notifyOptions) {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      var prevObservers = _this4.observers;

      var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes


      newObserverMatches.forEach(function (match) {
        return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
      });
      var newObservers = newObserverMatches.map(function (match) {
        return match.observer;
      });
      var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
        return [observer.options.queryHash, observer];
      }));
      var newResult = newObservers.map(function (observer) {
        return observer.getCurrentResult();
      });
      var hasIndexChange = newObservers.some(function (observer, index) {
        return observer !== prevObservers[index];
      });

      if (prevObservers.length === newObservers.length && !hasIndexChange) {
        return;
      }

      _this4.observers = newObservers;
      _this4.observersMap = newObserversMap;
      _this4.result = newResult;

      if (!_this4.hasListeners()) {
        return;
      }

      (0,utils/* difference */.e5)(prevObservers, newObservers).forEach(function (observer) {
        observer.destroy();
      });
      (0,utils/* difference */.e5)(newObservers, prevObservers).forEach(function (observer) {
        observer.subscribe(function (result) {
          _this4.onUpdate(observer, result);
        });
      });

      _this4.notify();
    });
  };

  _proto.onUpdate = function onUpdate(observer, result) {
    var index = this.observers.indexOf(observer);

    if (index !== -1) {
      this.result = (0,utils/* replaceAt */.Rc)(this.result, index, result);
      this.notify();
    }
  };

  _proto.notify = function notify() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.listeners.forEach(function (listener) {
        listener(_this5.result);
      });
    });
  };

  return QueriesObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQueries.js




function useQueries(queries) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var defaultedQueries = (0,react.useMemo)(function () {
    return queries.map(function (options) {
      var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options

      defaultedOptions.optimisticResults = true;
      return defaultedOptions;
    });
  }, [queries, queryClient]);

  var _React$useState2 = react.useState(function () {
    return new QueriesObserver(queryClient, defaultedQueries);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedQueries);
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setQueries(defaultedQueries, {
      listeners: false
    });
  }, [defaultedQueries, observer]);
  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 92145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext =
/*#__PURE__*/
react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription_Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = new Subscription_Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  (0,react.useEffect)(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = (/* unused pure expression or super */ null && ([]));
var NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null]));

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced_connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && isContextConsumer(React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new Subscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo(function () {
        return React.createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, _extends({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return (0,redux/* bindActionCreators */.DE)(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? defaultSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/(/* unused pure expression or super */ null && (createConnect())));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(Context_ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore =
/*#__PURE__*/
createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useStore = context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch =
/*#__PURE__*/
createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return new Subscription_Subscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector =
/*#__PURE__*/
createSelectorHook();
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js










setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 24754:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(2525);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports["default"] = autoprefix;

/***/ }),

/***/ 36002:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports["default"] = active;

/***/ }),

/***/ 91765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports["default"] = hover;

/***/ }),

/***/ 14147:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(47037);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(2525);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(68630);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(35161);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports["default"] = flattenNames;

/***/ }),

/***/ 79941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.tz = __webpack_unused_export__ = undefined;

var _flattenNames = __webpack_require__(14147);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(18556);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(24754);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(91765);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(36002);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(57742);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_unused_export__ = _hover3.default;
exports.tz = _hover3.default;
__webpack_unused_export__ = _active2.default;
__webpack_unused_export__ = _loop3.default;
var ReactCSS = __webpack_unused_export__ = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.ZP = ReactCSS;

/***/ }),

/***/ 57742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports["default"] = loopable;

/***/ }),

/***/ 18556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(2525);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(50361);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports["default"] = mergeClasses;

/***/ }),

/***/ 14890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ bindActionCreators; },
/* harmony export */   "MT": function() { return /* binding */ createStore; },
/* harmony export */   "UY": function() { return /* binding */ combineReducers; },
/* harmony export */   "md": function() { return /* binding */ applyMiddleware; },
/* harmony export */   "qC": function() { return /* binding */ compose; }
/* harmony export */ });
/* unused harmony exports __DO_NOT_USE__ActionTypes, legacy_createStore */
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}




/***/ }),

/***/ 74488:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var ContentRect = function (target) {
    if ('getBBox' in target) {
        var box = target.getBBox();
        return Object.freeze({
            height: box.height,
            left: 0,
            top: 0,
            width: box.width,
        });
    }
    else { // if (target instanceof HTMLElement) { // also includes all other non-SVGGraphicsElements
        var styles = window.getComputedStyle(target);
        return Object.freeze({
            height: parseFloat(styles.height || '0'),
            left: parseFloat(styles.paddingLeft || '0'),
            top: parseFloat(styles.paddingTop || '0'),
            width: parseFloat(styles.width || '0'),
        });
    }
};
exports.ContentRect = ContentRect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudFJlY3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvQ29udGVudFJlY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFPQSxJQUFNLFdBQVcsR0FBRyxVQUFDLE1BQWU7SUFDaEMsSUFBSSxTQUFTLElBQUssTUFBNkIsRUFBRTtRQUM3QyxJQUFNLEdBQUcsR0FBSSxNQUE2QixDQUFDLE9BQU8sRUFBRSxDQUFDO1FBQ3JELE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQztZQUNqQixNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU07WUFDbEIsSUFBSSxFQUFFLENBQUM7WUFDUCxHQUFHLEVBQUUsQ0FBQztZQUNOLEtBQUssRUFBRSxHQUFHLENBQUMsS0FBSztTQUNuQixDQUFDLENBQUM7S0FDTjtTQUFNLEVBQUUsMEZBQTBGO1FBQy9GLElBQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUMvQyxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUM7WUFDakIsTUFBTSxFQUFFLFVBQVUsQ0FBQyxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQztZQUN4QyxJQUFJLEVBQUUsVUFBVSxDQUFDLE1BQU0sQ0FBQyxXQUFXLElBQUksR0FBRyxDQUFDO1lBQzNDLEdBQUcsRUFBRSxVQUFVLENBQUMsTUFBTSxDQUFDLFVBQVUsSUFBSSxHQUFHLENBQUM7WUFDekMsS0FBSyxFQUFFLFVBQVUsQ0FBQyxNQUFNLENBQUMsS0FBSyxJQUFJLEdBQUcsQ0FBQztTQUN6QyxDQUFDLENBQUM7S0FDTjtBQUNMLENBQUMsQ0FBQztBQUVPLGtDQUFXIn0=

/***/ }),

/***/ 28981:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var ContentRect_1 = __webpack_require__(74488);
var ResizeObservation = /** @class */ (function () {
    function ResizeObservation(target) {
        this.target = target;
        this.$$broadcastWidth = this.$$broadcastHeight = 0;
    }
    Object.defineProperty(ResizeObservation.prototype, "broadcastWidth", {
        get: function () {
            return this.$$broadcastWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResizeObservation.prototype, "broadcastHeight", {
        get: function () {
            return this.$$broadcastHeight;
        },
        enumerable: true,
        configurable: true
    });
    ResizeObservation.prototype.isActive = function () {
        var cr = ContentRect_1.ContentRect(this.target);
        return !!cr
            && (cr.width !== this.broadcastWidth
                || cr.height !== this.broadcastHeight);
    };
    return ResizeObservation;
}());
exports.ResizeObservation = ResizeObservation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVzaXplT2JzZXJ2YXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvUmVzaXplT2JzZXJ2YXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2Q0FBNEM7QUFFNUM7SUFlSSwyQkFBWSxNQUFlO1FBQ3ZCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxJQUFJLENBQUMsaUJBQWlCLEdBQUcsQ0FBQyxDQUFDO0lBQ3ZELENBQUM7SUFWRCxzQkFBVyw2Q0FBYzthQUF6QjtZQUNJLE9BQU8sSUFBSSxDQUFDLGdCQUFnQixDQUFDO1FBQ2pDLENBQUM7OztPQUFBO0lBQ0Qsc0JBQVcsOENBQWU7YUFBMUI7WUFDSSxPQUFPLElBQUksQ0FBQyxpQkFBaUIsQ0FBQztRQUNsQyxDQUFDOzs7T0FBQTtJQU9NLG9DQUFRLEdBQWY7UUFDSSxJQUFNLEVBQUUsR0FBRyx5QkFBVyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUVwQyxPQUFPLENBQUMsQ0FBQyxFQUFFO2VBQ0osQ0FDQyxFQUFFLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxjQUFjO21CQUM3QixFQUFFLENBQUMsTUFBTSxLQUFLLElBQUksQ0FBQyxlQUFlLENBQ3hDLENBQUM7SUFDVixDQUFDO0lBQ0wsd0JBQUM7QUFBRCxDQUFDLEFBN0JELElBNkJDO0FBRVEsOENBQWlCIn0=

/***/ }),

/***/ 30215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var ResizeObservation_1 = __webpack_require__(28981);
var ResizeObserverEntry_1 = __webpack_require__(32778);
var resizeObservers = [];
var ResizeObserver = /** @class */ (function () {
    function ResizeObserver(callback) {
        /** @internal */
        this.$$observationTargets = [];
        /** @internal */
        this.$$activeTargets = [];
        /** @internal */
        this.$$skippedTargets = [];
        var message = callbackGuard(callback);
        if (message) {
            throw TypeError(message);
        }
        this.$$callback = callback;
    }
    ResizeObserver.prototype.observe = function (target) {
        var message = targetGuard('observe', target);
        if (message) {
            throw TypeError(message);
        }
        var index = findTargetIndex(this.$$observationTargets, target);
        if (index >= 0) {
            return;
        }
        this.$$observationTargets.push(new ResizeObservation_1.ResizeObservation(target));
        registerResizeObserver(this);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        var message = targetGuard('unobserve', target);
        if (message) {
            throw TypeError(message);
        }
        var index = findTargetIndex(this.$$observationTargets, target);
        if (index < 0) {
            return;
        }
        this.$$observationTargets.splice(index, 1);
        if (this.$$observationTargets.length === 0) {
            deregisterResizeObserver(this);
        }
    };
    ResizeObserver.prototype.disconnect = function () {
        this.$$observationTargets = [];
        this.$$activeTargets = [];
        deregisterResizeObserver(this);
    };
    return ResizeObserver;
}());
__webpack_unused_export__ = ResizeObserver;
function registerResizeObserver(resizeObserver) {
    var index = resizeObservers.indexOf(resizeObserver);
    if (index < 0) {
        resizeObservers.push(resizeObserver);
        startLoop();
    }
}
function deregisterResizeObserver(resizeObserver) {
    var index = resizeObservers.indexOf(resizeObserver);
    if (index >= 0) {
        resizeObservers.splice(index, 1);
        checkStopLoop();
    }
}
function callbackGuard(callback) {
    if (typeof (callback) === 'undefined') {
        return "Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.";
    }
    if (typeof (callback) !== 'function') {
        return "Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.";
    }
}
function targetGuard(functionName, target) {
    if (typeof (target) === 'undefined') {
        return "Failed to execute '" + functionName + "' on 'ResizeObserver': 1 argument required, but only 0 present.";
    }
    if (!(target && target.nodeType === window.Node.ELEMENT_NODE)) {
        return "Failed to execute '" + functionName + "' on 'ResizeObserver': parameter 1 is not of type 'Element'.";
    }
}
function findTargetIndex(collection, target) {
    for (var index = 0; index < collection.length; index += 1) {
        if (collection[index].target === target) {
            return index;
        }
    }
    return -1;
}
var gatherActiveObservationsAtDepth = function (depth) {
    resizeObservers.forEach(function (ro) {
        ro.$$activeTargets = [];
        ro.$$skippedTargets = [];
        ro.$$observationTargets.forEach(function (ot) {
            if (ot.isActive()) {
                var targetDepth = calculateDepthForNode(ot.target);
                if (targetDepth > depth) {
                    ro.$$activeTargets.push(ot);
                }
                else {
                    ro.$$skippedTargets.push(ot);
                }
            }
        });
    });
};
var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return !!ro.$$activeTargets.length; });
};
var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return !!ro.$$skippedTargets.length; });
};
var broadcastActiveObservations = function () {
    var shallowestTargetDepth = Infinity;
    resizeObservers.forEach(function (ro) {
        if (!ro.$$activeTargets.length) {
            return;
        }
        var entries = [];
        ro.$$activeTargets.forEach(function (obs) {
            var entry = new ResizeObserverEntry_1.ResizeObserverEntry(obs.target);
            entries.push(entry);
            obs.$$broadcastWidth = entry.contentRect.width;
            obs.$$broadcastHeight = entry.contentRect.height;
            var targetDepth = calculateDepthForNode(obs.target);
            if (targetDepth < shallowestTargetDepth) {
                shallowestTargetDepth = targetDepth;
            }
        });
        ro.$$callback(entries, ro);
        ro.$$activeTargets = [];
    });
    return shallowestTargetDepth;
};
var deliverResizeLoopErrorNotification = function () {
    var errorEvent = new window.ErrorEvent('ResizeLoopError', {
        message: 'ResizeObserver loop completed with undelivered notifications.',
    });
    window.dispatchEvent(errorEvent);
};
var calculateDepthForNode = function (target) {
    var depth = 0;
    while (target.parentNode) {
        target = target.parentNode;
        depth += 1;
    }
    return depth;
};
var notificationIteration = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopErrorNotification();
    }
};
var animationFrameCancelToken;
var startLoop = function () {
    if (animationFrameCancelToken)
        return;
    runLoop();
};
var runLoop = function () {
    animationFrameCancelToken = window.requestAnimationFrame(function () {
        notificationIteration();
        runLoop();
    });
};
var checkStopLoop = function () {
    if (animationFrameCancelToken && !resizeObservers.some(function (ro) { return !!ro.$$observationTargets.length; })) {
        window.cancelAnimationFrame(animationFrameCancelToken);
        animationFrameCancelToken = undefined;
    }
};
var install = function () {
    return window.ResizeObserver = ResizeObserver;
};
exports.N9 = install;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var ContentRect_1 = __webpack_require__(74488);
var ResizeObserverEntry = /** @class */ (function () {
    function ResizeObserverEntry(target) {
        this.target = target;
        this.contentRect = ContentRect_1.ContentRect(target);
    }
    return ResizeObserverEntry;
}());
exports.ResizeObserverEntry = ResizeObserverEntry;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVzaXplT2JzZXJ2ZXJFbnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9SZXNpemVPYnNlcnZlckVudHJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkNBQTRDO0FBRTVDO0lBR0ksNkJBQVksTUFBZTtRQUN2QixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztRQUNyQixJQUFJLENBQUMsV0FBVyxHQUFHLHlCQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDM0MsQ0FBQztJQUNMLDBCQUFDO0FBQUQsQ0FBQyxBQVBELElBT0M7QUFFUSxrREFBbUIifQ==

/***/ }),

/***/ 60713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.staged = void 0;
const react_1 = __importDefault(__webpack_require__(67294));
function processNext(next) {
    if (typeof next === 'function') {
        return (react_1.default.createElement(Stage, { stage: next }));
    }
    else {
        return next;
    }
}
function Stage(props) {
    const next = props.stage();
    return processNext(next);
}
function staged(stage) {
    return function Staged(props, ref) {
        const next = stage(props, ref);
        return processNext(next);
    };
}
exports.staged = staged;


/***/ }),

/***/ 69808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

let colors = __webpack_require__(14921)
module.exports = (colors.__esModule ? colors : { default: colors }).default


/***/ }),

/***/ 14921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _log = _interopRequireDefault(__webpack_require__(51679));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function warn({ version , from , to  }) {
    _log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning.", 
    ]);
}
var _default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a"
    },
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337"
    },
    get lightBlue () {
        warn({
            version: "v2.2",
            from: "lightBlue",
            to: "sky"
        });
        return this.sky;
    },
    get warmGray () {
        warn({
            version: "v3.0",
            from: "warmGray",
            to: "stone"
        });
        return this.stone;
    },
    get trueGray () {
        warn({
            version: "v3.0",
            from: "trueGray",
            to: "neutral"
        });
        return this.neutral;
    },
    get coolGray () {
        warn({
            version: "v3.0",
            from: "coolGray",
            to: "gray"
        });
        return this.gray;
    },
    get blueGray () {
        warn({
            version: "v3.0",
            from: "blueGray",
            to: "slate"
        });
        return this.slate;
    }
};
exports["default"] = _default;


/***/ }),

/***/ 51679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.dim = dim;
exports["default"] = void 0;
var _picocolors = _interopRequireDefault(__webpack_require__(74241));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let alreadyShown = new Set();
function log(type, messages, key) {
    if (process.env.JEST_WORKER_ID !== undefined) return;
    if (key && alreadyShown.has(key)) return;
    if (key) alreadyShown.add(key);
    console.warn("");
    messages.forEach((message)=>console.warn(type, "-", message)
    );
}
function dim(input) {
    return _picocolors.default.dim(input);
}
var _default = {
    info (key, messages) {
        log(_picocolors.default.bold(_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    warn (key, messages) {
        log(_picocolors.default.bold(_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    risk (key, messages) {
        log(_picocolors.default.bold(_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    }
};
exports["default"] = _default;


/***/ }),

/***/ 17621:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ __read; },
/* harmony export */   "XA": function() { return /* binding */ __values; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "fl": function() { return /* binding */ __spread; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 90767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function e(e,t,o){void 0===t&&(t=300),void 0===o&&(o={});var u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(n){u.current?(clearTimeout(u.current),u.current=null,e&&e(n)):u.current=setTimeout(function(){o.onSingleTap&&o.onSingleTap(n),u.current=null},t)},[e,t,o.onSingleTap]);return e?{onClick:i}:{}}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 5678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nr": function() { return /* reexport */ useDebounce_useDebounce; },
  "YZ": function() { return /* reexport */ esm_useIsFirstRender_useIsFirstRender; }
});

// UNUSED EXPORTS: useBoolean, useClickAnyWhere, useCopyToClipboard, useCountdown, useCounter, useDarkMode, useDocumentTitle, useEffectOnce, useElementSize, useEventCallback, useEventListener, useFetch, useHover, useImageOnLoad, useIntersectionObserver, useInterval, useIsClient, useIsMounted, useIsomorphicLayoutEffect, useLocalStorage, useLockedBody, useMap, useMediaQuery, useOnClickOutside, useReadLocalStorage, useScreen, useScript, useSessionStorage, useSsr, useStep, useTernaryDarkMode, useTimeout, useToggle, useUpdateEffect, useWindowSize

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js

function useBoolean_useBoolean(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const toggle = useCallback(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ var esm_useBoolean_useBoolean = ((/* unused pure expression or super */ null && (useBoolean_useBoolean)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js

function useClickAnyWhere(handler) {
    useEventListener('click', event => {
        handler(event);
    });
}
/* harmony default export */ var useClickAnyWhere_useClickAnyWhere = ((/* unused pure expression or super */ null && (useClickAnyWhere)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = useState(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ var useCopyToClipboard_useCopyToClipboard = ((/* unused pure expression or super */ null && (useCopyToClipboard)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = useCounter(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = useBoolean(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = useCallback(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    useInterval(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ var useCountdown_useCountdown = ((/* unused pure expression or super */ null && (useCountdown)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js

function useCounter_useCounter(initialValue) {
    const [count, setCount] = useState(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ var esm_useCounter_useCounter = ((/* unused pure expression or super */ null && (useCounter_useCounter)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = useLocalStorage('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    useUpdateEffect(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ var useDarkMode_useDarkMode = ((/* unused pure expression or super */ null && (useDarkMode)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react.useState)(value);
    (0,react.useEffect)(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ var useDebounce_useDebounce = (useDebounce);

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js

function useDocumentTitle(title) {
    useIsomorphicLayoutEffect(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ var useDocumentTitle_useDocumentTitle = ((/* unused pure expression or super */ null && (useDocumentTitle)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js

function useEffectOnce(effect) {
    useEffect(effect, []);
}
/* harmony default export */ var useEffectOnce_useEffectOnce = ((/* unused pure expression or super */ null && (useEffectOnce)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js


function useElementSize() {
    const [ref, setRef] = useState(null);
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = useCallback(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ var useElementSize_useElementSize = ((/* unused pure expression or super */ null && (useElementSize)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js


function useEventCallback_useEventCallback(fn) {
    const ref = useRef(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);
    return useCallback((...args) => ref.current(...args), [ref]);
}

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js


function useEventListener_useEventListener(eventName, handler, element, options) {
    const savedHandler = useRef(handler);
    useIsomorphicLayoutEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ var esm_useEventListener_useEventListener = ((/* unused pure expression or super */ null && (useEventListener_useEventListener)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js
var useFetch_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = useRef({});
    const cancelRequest = useRef(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(fetchReducer, initialState);
    useEffect(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => useFetch_awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ var useFetch_useFetch = ((/* unused pure expression or super */ null && (useFetch)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useHover/useHover.js


function useHover(elementRef) {
    const [value, setValue] = useState(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    useEventListener('mouseenter', handleMouseEnter, elementRef);
    useEventListener('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ var useHover_useHover = ((/* unused pure expression or super */ null && (useHover)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = useState(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ var useImageOnLoad_useImageOnLoad = ((/* unused pure expression or super */ null && (useImageOnLoad)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = useState();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    useEffect(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = ((/* unused pure expression or super */ null && (useIntersectionObserver)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js


function useInterval_useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ var esm_useInterval_useInterval = ((/* unused pure expression or super */ null && (useInterval_useInterval)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js

function useIsClient() {
    const [isClient, setClient] = useState(false);
    useEffect(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ var useIsClient_useIsClient = ((/* unused pure expression or super */ null && (useIsClient)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js

function useIsFirstRender_useIsFirstRender() {
    const isFirst = (0,react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ var esm_useIsFirstRender_useIsFirstRender = (useIsFirstRender_useIsFirstRender);

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js

function useIsMounted() {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return useCallback(() => isMounted.current, []);
}
/* harmony default export */ var useIsMounted_useIsMounted = ((/* unused pure expression or super */ null && (useIsMounted)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js

const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = ((/* unused pure expression or super */ null && (useIsomorphicLayoutEffect_useIsomorphicLayoutEffect)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js


function useLocalStorage_useLocalStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var esm_useLocalStorage_useLocalStorage = ((/* unused pure expression or super */ null && (useLocalStorage_useLocalStorage)));
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = useState(initialLocked);
    useIsomorphicLayoutEffect(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    useEffect(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ var useLockedBody_useLockedBody = ((/* unused pure expression or super */ null && (useLockedBody)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useMap/useMap.js

function useMap(initialState = new Map()) {
    const [map, setMap] = useState(new Map(initialState));
    const actions = {
        set: useCallback((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: useCallback(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: useCallback(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: useCallback(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ var useMap_useMap = ((/* unused pure expression or super */ null && (useMap)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js

function useMediaQuery_useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = useState(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    useEffect(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ var esm_useMediaQuery_useMediaQuery = ((/* unused pure expression or super */ null && (useMediaQuery_useMediaQuery)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    useEventListener(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ var useOnClickOutside_useOnClickOutside = ((/* unused pure expression or super */ null && (useOnClickOutside)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js


function useReadLocalStorage(key) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = useState(readValue);
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ var useReadLocalStorage_useReadLocalStorage = ((/* unused pure expression or super */ null && (useReadLocalStorage)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = useState(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ var useScreen_useScreen = ((/* unused pure expression or super */ null && (useScreen)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useScript/useScript.js

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = useState(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    useEffect(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ var useScript_useScript = ((/* unused pure expression or super */ null && (useScript)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js


function useSessionStorage(key, initialValue) {
    const readValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? useSessionStorage_parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = useState(readValue);
    const setValue = useEventCallback(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    useEffect(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = useCallback((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    useEventListener('storage', handleStorageChange);
    useEventListener('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ var useSessionStorage_useSessionStorage = ((/* unused pure expression or super */ null && (useSessionStorage)));
function useSessionStorage_parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useStep/useStep.js

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = useState(1);
    const canGoToNextStep = useMemo(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = useMemo(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = useCallback(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = useCallback(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = useCallback(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = useCallback(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ var useStep_useStep = ((/* unused pure expression or super */ null && (useStep)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js


const useTernaryDarkMode_COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = useMediaQuery(useTernaryDarkMode_COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = useLocalStorage('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = useState(isDarkOS);
    useUpdateEffect(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    useEffect(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ var useTernaryDarkMode_useTernaryDarkMode = ((/* unused pure expression or super */ null && (useTernaryDarkMode)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js


function useTimeout(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ var useTimeout_useTimeout = ((/* unused pure expression or super */ null && (useTimeout)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js

function useToggle(defaultValue) {
    const [value, setValue] = useState(!!defaultValue);
    const toggle = useCallback(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ var useToggle_useToggle = ((/* unused pure expression or super */ null && (useToggle)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js


function useUpdateEffect_useUpdateEffect(effect, deps) {
    const isFirst = useIsFirstRender();
    useEffect(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ var esm_useUpdateEffect_useUpdateEffect = ((/* unused pure expression or super */ null && (useUpdateEffect_useUpdateEffect)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js


function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ var useWindowSize_useWindowSize = ((/* unused pure expression or super */ null && (useWindowSize)));

;// CONCATENATED MODULE: ./node_modules/usehooks-ts/dist/esm/index.js












































































/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 48966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _toDate = _interopRequireDefault(__webpack_require__(8469));

var _toFloat = _interopRequireDefault(__webpack_require__(77536));

var _toInt = _interopRequireDefault(__webpack_require__(21359));

var _toBoolean = _interopRequireDefault(__webpack_require__(557));

var _equals = _interopRequireDefault(__webpack_require__(2315));

var _contains = _interopRequireDefault(__webpack_require__(89466));

var _matches = _interopRequireDefault(__webpack_require__(30661));

var _isEmail = _interopRequireDefault(__webpack_require__(83868));

var _isURL = _interopRequireDefault(__webpack_require__(66823));

var _isMACAddress = _interopRequireDefault(__webpack_require__(28999));

var _isIP = _interopRequireDefault(__webpack_require__(61028));

var _isIPRange = _interopRequireDefault(__webpack_require__(27795));

var _isFQDN = _interopRequireDefault(__webpack_require__(10221));

var _isDate = _interopRequireDefault(__webpack_require__(82549));

var _isBoolean = _interopRequireDefault(__webpack_require__(99493));

var _isLocale = _interopRequireDefault(__webpack_require__(67380));

var _isAlpha = _interopRequireWildcard(__webpack_require__(19234));

var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(94583));

var _isNumeric = _interopRequireDefault(__webpack_require__(24986));

var _isPassportNumber = _interopRequireDefault(__webpack_require__(51513));

var _isPort = _interopRequireDefault(__webpack_require__(24595));

var _isLowercase = _interopRequireDefault(__webpack_require__(43928));

var _isUppercase = _interopRequireDefault(__webpack_require__(57245));

var _isIMEI = _interopRequireDefault(__webpack_require__(15566));

var _isAscii = _interopRequireDefault(__webpack_require__(64094));

var _isFullWidth = _interopRequireDefault(__webpack_require__(77146));

var _isHalfWidth = _interopRequireDefault(__webpack_require__(82941));

var _isVariableWidth = _interopRequireDefault(__webpack_require__(49019));

var _isMultibyte = _interopRequireDefault(__webpack_require__(13590));

var _isSemVer = _interopRequireDefault(__webpack_require__(86826));

var _isSurrogatePair = _interopRequireDefault(__webpack_require__(72828));

var _isInt = _interopRequireDefault(__webpack_require__(20937));

var _isFloat = _interopRequireWildcard(__webpack_require__(79146));

var _isDecimal = _interopRequireDefault(__webpack_require__(85218));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(77117));

var _isOctal = _interopRequireDefault(__webpack_require__(66090));

var _isDivisibleBy = _interopRequireDefault(__webpack_require__(58335));

var _isHexColor = _interopRequireDefault(__webpack_require__(96298));

var _isRgbColor = _interopRequireDefault(__webpack_require__(6454));

var _isHSL = _interopRequireDefault(__webpack_require__(16648));

var _isISRC = _interopRequireDefault(__webpack_require__(34339));

var _isIBAN = _interopRequireWildcard(__webpack_require__(88177));

var _isBIC = _interopRequireDefault(__webpack_require__(42438));

var _isMD = _interopRequireDefault(__webpack_require__(90368));

var _isHash = _interopRequireDefault(__webpack_require__(18874));

var _isJWT = _interopRequireDefault(__webpack_require__(74979));

var _isJSON = _interopRequireDefault(__webpack_require__(81008));

var _isEmpty = _interopRequireDefault(__webpack_require__(54069));

var _isLength = _interopRequireDefault(__webpack_require__(20661));

var _isByteLength = _interopRequireDefault(__webpack_require__(93235));

var _isUUID = _interopRequireDefault(__webpack_require__(57278));

var _isMongoId = _interopRequireDefault(__webpack_require__(19131));

var _isAfter = _interopRequireDefault(__webpack_require__(93315));

var _isBefore = _interopRequireDefault(__webpack_require__(51464));

var _isIn = _interopRequireDefault(__webpack_require__(27228));

var _isCreditCard = _interopRequireDefault(__webpack_require__(682));

var _isIdentityCard = _interopRequireDefault(__webpack_require__(49396));

var _isEAN = _interopRequireDefault(__webpack_require__(35807));

var _isISIN = _interopRequireDefault(__webpack_require__(57148));

var _isISBN = _interopRequireDefault(__webpack_require__(87612));

var _isISSN = _interopRequireDefault(__webpack_require__(29887));

var _isTaxID = _interopRequireDefault(__webpack_require__(53058));

var _isMobilePhone = _interopRequireWildcard(__webpack_require__(28355));

var _isEthereumAddress = _interopRequireDefault(__webpack_require__(82129));

var _isCurrency = _interopRequireDefault(__webpack_require__(90094));

var _isBtcAddress = _interopRequireDefault(__webpack_require__(88021));

var _isISO = _interopRequireDefault(__webpack_require__(65061));

var _isRFC = _interopRequireDefault(__webpack_require__(94611));

var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(21727));

var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(86776));

var _isISO2 = _interopRequireDefault(__webpack_require__(19963));

var _isBase = _interopRequireDefault(__webpack_require__(2782));

var _isBase2 = _interopRequireDefault(__webpack_require__(65008));

var _isBase3 = _interopRequireDefault(__webpack_require__(2689));

var _isDataURI = _interopRequireDefault(__webpack_require__(98983));

var _isMagnetURI = _interopRequireDefault(__webpack_require__(72776));

var _isMimeType = _interopRequireDefault(__webpack_require__(44554));

var _isLatLong = _interopRequireDefault(__webpack_require__(90478));

var _isPostalCode = _interopRequireWildcard(__webpack_require__(78140));

var _ltrim = _interopRequireDefault(__webpack_require__(14959));

var _rtrim = _interopRequireDefault(__webpack_require__(29778));

var _trim = _interopRequireDefault(__webpack_require__(24790));

var _escape = _interopRequireDefault(__webpack_require__(5152));

var _unescape = _interopRequireDefault(__webpack_require__(94816));

var _stripLow = _interopRequireDefault(__webpack_require__(8035));

var _whitelist = _interopRequireDefault(__webpack_require__(34714));

var _blacklist = _interopRequireDefault(__webpack_require__(44928));

var _isWhitelisted = _interopRequireDefault(__webpack_require__(88346));

var _normalizeEmail = _interopRequireDefault(__webpack_require__(2900));

var _isSlug = _interopRequireDefault(__webpack_require__(68220));

var _isLicensePlate = _interopRequireDefault(__webpack_require__(82786));

var _isStrongPassword = _interopRequireDefault(__webpack_require__(17633));

var _isVAT = _interopRequireDefault(__webpack_require__(55977));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '13.7.0';
var validator = {
  version: version,
  toDate: _toDate.default,
  toFloat: _toFloat.default,
  toInt: _toInt.default,
  toBoolean: _toBoolean.default,
  equals: _equals.default,
  contains: _contains.default,
  matches: _matches.default,
  isEmail: _isEmail.default,
  isURL: _isURL.default,
  isMACAddress: _isMACAddress.default,
  isIP: _isIP.default,
  isIPRange: _isIPRange.default,
  isFQDN: _isFQDN.default,
  isBoolean: _isBoolean.default,
  isIBAN: _isIBAN.default,
  isBIC: _isBIC.default,
  isAlpha: _isAlpha.default,
  isAlphaLocales: _isAlpha.locales,
  isAlphanumeric: _isAlphanumeric.default,
  isAlphanumericLocales: _isAlphanumeric.locales,
  isNumeric: _isNumeric.default,
  isPassportNumber: _isPassportNumber.default,
  isPort: _isPort.default,
  isLowercase: _isLowercase.default,
  isUppercase: _isUppercase.default,
  isAscii: _isAscii.default,
  isFullWidth: _isFullWidth.default,
  isHalfWidth: _isHalfWidth.default,
  isVariableWidth: _isVariableWidth.default,
  isMultibyte: _isMultibyte.default,
  isSemVer: _isSemVer.default,
  isSurrogatePair: _isSurrogatePair.default,
  isInt: _isInt.default,
  isIMEI: _isIMEI.default,
  isFloat: _isFloat.default,
  isFloatLocales: _isFloat.locales,
  isDecimal: _isDecimal.default,
  isHexadecimal: _isHexadecimal.default,
  isOctal: _isOctal.default,
  isDivisibleBy: _isDivisibleBy.default,
  isHexColor: _isHexColor.default,
  isRgbColor: _isRgbColor.default,
  isHSL: _isHSL.default,
  isISRC: _isISRC.default,
  isMD5: _isMD.default,
  isHash: _isHash.default,
  isJWT: _isJWT.default,
  isJSON: _isJSON.default,
  isEmpty: _isEmpty.default,
  isLength: _isLength.default,
  isLocale: _isLocale.default,
  isByteLength: _isByteLength.default,
  isUUID: _isUUID.default,
  isMongoId: _isMongoId.default,
  isAfter: _isAfter.default,
  isBefore: _isBefore.default,
  isIn: _isIn.default,
  isCreditCard: _isCreditCard.default,
  isIdentityCard: _isIdentityCard.default,
  isEAN: _isEAN.default,
  isISIN: _isISIN.default,
  isISBN: _isISBN.default,
  isISSN: _isISSN.default,
  isMobilePhone: _isMobilePhone.default,
  isMobilePhoneLocales: _isMobilePhone.locales,
  isPostalCode: _isPostalCode.default,
  isPostalCodeLocales: _isPostalCode.locales,
  isEthereumAddress: _isEthereumAddress.default,
  isCurrency: _isCurrency.default,
  isBtcAddress: _isBtcAddress.default,
  isISO8601: _isISO.default,
  isRFC3339: _isRFC.default,
  isISO31661Alpha2: _isISO31661Alpha.default,
  isISO31661Alpha3: _isISO31661Alpha2.default,
  isISO4217: _isISO2.default,
  isBase32: _isBase.default,
  isBase58: _isBase2.default,
  isBase64: _isBase3.default,
  isDataURI: _isDataURI.default,
  isMagnetURI: _isMagnetURI.default,
  isMimeType: _isMimeType.default,
  isLatLong: _isLatLong.default,
  ltrim: _ltrim.default,
  rtrim: _rtrim.default,
  trim: _trim.default,
  escape: _escape.default,
  unescape: _unescape.default,
  stripLow: _stripLow.default,
  whitelist: _whitelist.default,
  blacklist: _blacklist.default,
  isWhitelisted: _isWhitelisted.default,
  normalizeEmail: _normalizeEmail.default,
  toString: toString,
  isSlug: _isSlug.default,
  isStrongPassword: _isStrongPassword.default,
  isTaxID: _isTaxID.default,
  isDate: _isDate.default,
  isLicensePlate: _isLicensePlate.default,
  isVAT: _isVAT.default,
  ibanLocales: _isIBAN.locales
};
var _default = validator;
exports["default"] = _default;
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 60079:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.commaDecimal = exports.dotDecimal = exports.farsiLocales = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
var alpha = {
  'en-US': /^[A-Z]+$/i,
  'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  'bg-BG': /^[А-Я]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[A-ZÆØÅ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'el-GR': /^[Α-ώ]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  'fi-FI': /^[A-ZÅÄÖ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'nb-NO': /^[A-ZÆØÅ]+$/i,
  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[A-ZÆØÅ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[A-ZÅÄÖ]+$/i,
  'th-TH': /^[ก-๐\s]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  'hi-IN': /^[\u0900-\u0961]+[\u0972-\u097F]*$/i
};
exports.alpha = alpha;
var alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  'bg-BG': /^[0-9А-Я]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'el-GR': /^[0-9Α-ω]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fi-FI': /^[0-9A-ZÅÄÖ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
  'th-TH': /^[ก-๙\s]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  'hi-IN': /^[\u0900-\u0963]+[\u0966-\u097F]*$/i
};
exports.alphanumeric = alphanumeric;
var decimal = {
  'en-US': '.',
  ar: '٫'
};
exports.decimal = decimal;
var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
exports.englishLocales = englishLocales;

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = "en-".concat(englishLocales[i]);
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
  decimal[locale] = decimal['en-US'];
} // Source: http://www.localeplanet.com/java/


var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
exports.arabicLocales = arabicLocales;

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = "ar-".concat(arabicLocales[_i]);
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
  decimal[_locale] = decimal.ar;
}

var farsiLocales = ['IR', 'AF'];
exports.farsiLocales = farsiLocales;

for (var _locale2, _i2 = 0; _i2 < farsiLocales.length; _i2++) {
  _locale2 = "fa-".concat(farsiLocales[_i2]);
  alphanumeric[_locale2] = alphanumeric.fa;
  decimal[_locale2] = decimal.ar;
} // Source: https://en.wikipedia.org/wiki/Decimal_mark


var dotDecimal = ['ar-EG', 'ar-LB', 'ar-LY'];
exports.dotDecimal = dotDecimal;
var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-ZM', 'es-ES', 'fr-CA', 'fr-FR', 'id-ID', 'it-IT', 'ku-IQ', 'hi-IN', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA', 'vi-VN'];
exports.commaDecimal = commaDecimal;

for (var _i3 = 0; _i3 < dotDecimal.length; _i3++) {
  decimal[dotDecimal[_i3]] = decimal['en-US'];
}

for (var _i4 = 0; _i4 < commaDecimal.length; _i4++) {
  decimal[commaDecimal[_i4]] = ',';
}

alpha['fr-CA'] = alpha['fr-FR'];
alphanumeric['fr-CA'] = alphanumeric['fr-FR'];
alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
decimal['pt-BR'] = decimal['pt-PT']; // see #862

alpha['pl-Pl'] = alpha['pl-PL'];
alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
decimal['pl-Pl'] = decimal['pl-PL']; // see #1455

alpha['fa-AF'] = alpha.fa;

/***/ }),

/***/ 44928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = blacklist;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blacklist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 89466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = contains;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _toString = _interopRequireDefault(__webpack_require__(31913));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaulContainsOptions = {
  ignoreCase: false,
  minOccurrences: 1
};

function contains(str, elem, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaulContainsOptions);

  if (options.ignoreCase) {
    return str.toLowerCase().split((0, _toString.default)(elem).toLowerCase()).length > options.minOccurrences;
  }

  return str.split((0, _toString.default)(elem)).length > options.minOccurrences;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = equals;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function equals(str, comparison) {
  (0, _assertString.default)(str);
  return str === comparison;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 5152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = escape;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 93315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAfter;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _toDate = _interopRequireDefault(__webpack_require__(8469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAfter(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original > comparison);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 19234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAlpha;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _alpha = __webpack_require__(60079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlpha(_str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _assertString.default)(_str);
  var str = _str;
  var ignore = options.ignore;

  if (ignore) {
    if (ignore instanceof RegExp) {
      str = str.replace(ignore, '');
    } else if (typeof ignore === 'string') {
      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
    } else {
      throw new Error('ignore should be instance of a String or RegExp');
    }
  }

  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alpha);
exports.locales = locales;

/***/ }),

/***/ 94583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAlphanumeric;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _alpha = __webpack_require__(60079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlphanumeric(_str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _assertString.default)(_str);
  var str = _str;
  var ignore = options.ignore;

  if (ignore) {
    if (ignore instanceof RegExp) {
      str = str.replace(ignore, '');
    } else if (typeof ignore === 'string') {
      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
    } else {
      throw new Error('ignore should be instance of a String or RegExp');
    }
  }

  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alphanumeric);
exports.locales = locales;

/***/ }),

/***/ 64094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAscii;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString.default)(str);
  return ascii.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 42438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBIC;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isISO31661Alpha = __webpack_require__(21727);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://en.wikipedia.org/wiki/ISO_9362
var isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;

function isBIC(str) {
  (0, _assertString.default)(str); // toUpperCase() should be removed when a new major version goes out that changes
  // the regex to [A-Z] (per the spec).

  if (!_isISO31661Alpha.CountryCodes.has(str.slice(4, 6).toUpperCase())) {
    return false;
  }

  return isBICReg.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase32;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base32 = /^[A-Z2-7]+=*$/;

function isBase32(str) {
  (0, _assertString.default)(str);
  var len = str.length;

  if (len % 8 === 0 && base32.test(str)) {
    return true;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 65008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase58;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
var base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;

function isBase58(str) {
  (0, _assertString.default)(str);

  if (base58Reg.test(str)) {
    return true;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBase64;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notBase64 = /[^A-Z0-9+\/=]/i;
var urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
var defaultBase64Options = {
  urlSafe: false
};

function isBase64(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaultBase64Options);
  var len = str.length;

  if (options.urlSafe) {
    return urlSafeBase64.test(str);
  }

  if (len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }

  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 51464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBefore;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _toDate = _interopRequireDefault(__webpack_require__(8469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBefore(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original < comparison);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 99493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  loose: false
};
var strictBooleans = ['true', 'false', '1', '0'];
var looseBooleans = [].concat(strictBooleans, ['yes', 'no']);

function isBoolean(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  (0, _assertString.default)(str);

  if (options.loose) {
    return looseBooleans.includes(str.toLowerCase());
  }

  return strictBooleans.includes(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 88021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBtcAddress;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// supports Bech32 addresses
var bech32 = /^(bc1)[a-z0-9]{25,39}$/;
var base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;

function isBtcAddress(str) {
  (0, _assertString.default)(str); // check for bech32

  if (str.startsWith('bc1')) {
    return bech32.test(str);
  }

  return base58.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 93235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isByteLength;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isCreditCard;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 90094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isCurrency;

var _merge = _interopRequireDefault(__webpack_require__(84808));

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencyRegex(options) {
  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
  options.digits_after_decimal.forEach(function (digit, index) {
    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
  });
  var symbol = "(".concat(options.symbol.replace(/\W/, function (m) {
    return "\\".concat(m);
  }), ")").concat(options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)

  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)


  if (options.allow_negative_sign_placeholder) {
    pattern = "( (?!\\-))?".concat(pattern);
  } else if (options.allow_space_after_symbol) {
    pattern = " ?".concat(pattern);
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  } // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space


  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_decimal: true,
  require_decimal: false,
  digits_after_decimal: [2],
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 98983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDataURI;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

function isDataURI(str) {
  (0, _assertString.default)(str);
  var data = str.split(',');

  if (data.length < 2) {
    return false;
  }

  var attributes = data.shift().trim().split(';');
  var schemeAndMediaType = attributes.shift();

  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
    return false;
  }

  var mediaType = schemeAndMediaType.substr(5);

  if (mediaType !== '' && !validMediaType.test(mediaType)) {
    return false;
  }

  for (var i = 0; i < attributes.length; i++) {
    if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') && !validAttribute.test(attributes[i])) {
      return false;
    }
  }

  for (var _i = 0; _i < data.length; _i++) {
    if (!validData.test(data[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 82549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var default_date_options = {
  format: 'YYYY/MM/DD',
  delimiters: ['/', '-'],
  strictMode: false
};

function isValidFormat(format) {
  return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
}

function zip(date, format) {
  var zippedArr = [],
      len = Math.min(date.length, format.length);

  for (var i = 0; i < len; i++) {
    zippedArr.push([date[i], format[i]]);
  }

  return zippedArr;
}

function isDate(input, options) {
  if (typeof options === 'string') {
    // Allow backward compatbility for old format isDate(input [, format])
    options = (0, _merge.default)({
      format: options
    }, default_date_options);
  } else {
    options = (0, _merge.default)(options, default_date_options);
  }

  if (typeof input === 'string' && isValidFormat(options.format)) {
    var formatDelimiter = options.delimiters.find(function (delimiter) {
      return options.format.indexOf(delimiter) !== -1;
    });
    var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function (delimiter) {
      return input.indexOf(delimiter) !== -1;
    });
    var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
    var dateObj = {};

    var _iterator = _createForOfIteratorHelper(dateAndFormat),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            dateWord = _step$value[0],
            formatWord = _step$value[1];

        if (dateWord.length !== formatWord.length) {
          return false;
        }

        dateObj[formatWord.charAt(0)] = dateWord;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return new Date("".concat(dateObj.m, "/").concat(dateObj.d, "/").concat(dateObj.y)).getDate() === +dateObj.d;
  }

  if (!options.strictMode) {
    return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 85218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDecimal;

var _merge = _interopRequireDefault(__webpack_require__(84808));

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _includes = _interopRequireDefault(__webpack_require__(18343));

var _alpha = __webpack_require__(60079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decimalRegExp(options) {
  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
  return regExp;
}

var default_decimal_options = {
  force_decimal: false,
  decimal_digits: '1,',
  locale: 'en-US'
};
var blacklist = ['', '-', '+'];

function isDecimal(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_decimal_options);

  if (options.locale in _alpha.decimal) {
    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
  }

  throw new Error("Invalid locale '".concat(options.locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 58335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDivisibleBy;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _toFloat = _interopRequireDefault(__webpack_require__(77536));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDivisibleBy(str, num) {
  (0, _assertString.default)(str);
  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 35807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEAN;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The most commonly used EAN standard is
 * the thirteen-digit EAN-13, while the
 * less commonly used 8-digit EAN-8 barcode was
 * introduced for use on small packages.
 * Also EAN/UCC-14 is used for Grouping of individual
 * trade items above unit level(Intermediate, Carton or Pallet).
 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
 * EAN consists of:
 * GS1 prefix, manufacturer code, product code and check digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
 * Reference: https://www.gtin.info/
 */

/**
 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
 */
var LENGTH_EAN_8 = 8;
var LENGTH_EAN_14 = 14;
var validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
/**
 * Get position weight given:
 * EAN length and digit index/position
 *
 * @param {number} length
 * @param {number} index
 * @return {number}
 */

function getPositionWeightThroughLengthAndIndex(length, index) {
  if (length === LENGTH_EAN_8 || length === LENGTH_EAN_14) {
    return index % 2 === 0 ? 3 : 1;
  }

  return index % 2 === 0 ? 1 : 3;
}
/**
 * Calculate EAN Check Digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
 *
 * @param {string} ean
 * @return {number}
 */


function calculateCheckDigit(ean) {
  var checksum = ean.slice(0, -1).split('').map(function (char, index) {
    return Number(char) * getPositionWeightThroughLengthAndIndex(ean.length, index);
  }).reduce(function (acc, partialSum) {
    return acc + partialSum;
  }, 0);
  var remainder = 10 - checksum % 10;
  return remainder < 10 ? remainder : 0;
}
/**
 * Check if string is valid EAN:
 * Matches EAN-8/EAN-13/EAN-14 regex
 * Has valid check digit.
 *
 * @param {string} str
 * @return {boolean}
 */


function isEAN(str) {
  (0, _assertString.default)(str);
  var actualCheckDigit = Number(str.slice(-1));
  return validEanRegex.test(str) && actualCheckDigit === calculateCheckDigit(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 83868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmail;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

var _isByteLength = _interopRequireDefault(__webpack_require__(93235));

var _isFQDN = _interopRequireDefault(__webpack_require__(10221));

var _isIP = _interopRequireDefault(__webpack_require__(61028));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  blacklisted_chars: '',
  ignore_max_length: false,
  host_blacklist: []
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var defaultMaxEmailLength = 254;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

/**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */

function validateDisplayName(display_name) {
  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid

  if (!display_name_without_quotes.trim()) {
    return false;
  } // check whether display name contains illegal character


  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

  if (contains_illegal) {
    // if contains illegal characters,
    // must to be enclosed in double-quotes, otherwise it's not a valid display name
    if (display_name_without_quotes === display_name) {
      return false;
    } // the quotes in display name must start with character symbol \


    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

    if (!all_start_with_back_slash) {
      return false;
    }
  }

  return true;
}

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(splitNameAddress);

    if (display_email) {
      var display_name = display_email[1]; // Remove display name and angle brackets to get email address
      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)

      str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
      // because there may be a space between display name and email address
      // eg. myname <address@gmail.com>
      // the display name is `myname` instead of `myname `, so need to trim the last space

      if (display_name.endsWith(' ')) {
        display_name = display_name.substr(0, display_name.length - 1);
      }

      if (!validateDisplayName(display_name)) {
        return false;
      }
    } else if (options.require_display_name) {
      return false;
    }
  }

  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
    return false;
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var lower_domain = domain.toLowerCase();

  if (options.host_blacklist.includes(lower_domain)) {
    return false;
  }

  var user = parts.join('@');

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  }))) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  if (options.blacklisted_chars) {
    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 54069:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEmpty;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_is_empty_options = {
  ignore_whitespace: false
};

function isEmpty(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_is_empty_options);
  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 82129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEthereumAddress;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eth = /^(0x)[0-9a-f]{40}$/i;

function isEthereumAddress(str) {
  (0, _assertString.default)(str);
  return eth.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 10221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFQDN;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_numeric_tld: false,
  allow_wildcard: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  /* Remove the optional wildcard before checking validity */


  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
    str = str.substring(2);
  }

  var parts = str.split('.');
  var tld = parts[parts.length - 1];

  if (options.require_tld) {
    // disallow fqdns without tld
    if (parts.length < 2) {
      return false;
    }

    if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/\s/.test(tld)) {
      return false;
    }
  } // reject numeric TLDs


  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
    return false;
  }

  return parts.every(function (part) {
    if (part.length > 63) {
      return false;
    }

    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    } // disallow parts starting or ending with hyphen


    if (/^-|-$/.test(part)) {
      return false;
    }

    if (!options.allow_underscores && /_/.test(part)) {
      return false;
    }

    return true;
  });
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 79146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFloat;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _alpha = __webpack_require__(60079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFloat(str, options) {
  (0, _assertString.default)(str);
  options = options || {};
  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));

  if (str === '' || str === '.' || str === '-' || str === '+') {
    return false;
  }

  var value = parseFloat(str.replace(',', '.'));
  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}

var locales = Object.keys(_alpha.decimal);
exports.locales = locales;

/***/ }),

/***/ 77146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isFullWidth;
exports.fullWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.fullWidth = fullWidth;

function isFullWidth(str) {
  (0, _assertString.default)(str);
  return fullWidth.test(str);
}

/***/ }),

/***/ 16648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHSL;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
var hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;

function isHSL(str) {
  (0, _assertString.default)(str); // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)

  var strippedStr = str.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/ig, '$1');

  if (strippedStr.indexOf(',') !== -1) {
    return hslComma.test(strippedStr);
  }

  return hslSpace.test(strippedStr);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 82941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHalfWidth;
exports.halfWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.halfWidth = halfWidth;

function isHalfWidth(str) {
  (0, _assertString.default)(str);
  return halfWidth.test(str);
}

/***/ }),

/***/ 18874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHash;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lengths = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
};

function isHash(str, algorithm) {
  (0, _assertString.default)(str);
  var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
  return hash.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 96298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHexColor;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;

function isHexColor(str) {
  (0, _assertString.default)(str);
  return hexcolor.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 77117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isHexadecimal;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString.default)(str);
  return hexadecimal.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 88177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIBAN;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * List of country codes with
 * corresponding IBAN regular expression
 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
 */
var ibanRegexThroughCountryCode = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
/**
 * Check whether string has correct universal IBAN format
 * The IBAN consists of up to 34 alphanumeric characters, as follows:
 * Country Code using ISO 3166-1 alpha-2, two letters
 * check digits, two digits and
 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
 *
 * @param {string} str - string under validation
 * @return {boolean}
 */

function hasValidIbanFormat(str) {
  // Strip white spaces and hyphens
  var strippedStr = str.replace(/[\s\-]+/gi, '').toUpperCase();
  var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
  return isoCountryCode in ibanRegexThroughCountryCode && ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
}
/**
   * Check whether string has valid IBAN Checksum
   * by performing basic mod-97 operation and
   * the remainder should equal 1
   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
   * -- Interpret the string as a decimal integer and
   * -- compute the remainder on division by 97 (mod 97)
   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
   *
   * @param {string} str
   * @return {boolean}
   */


function hasValidIbanChecksum(str) {
  var strippedStr = str.replace(/[^A-Z0-9]+/gi, '').toUpperCase(); // Keep only digits and A-Z latin alphabetic

  var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
  var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function (char) {
    return char.charCodeAt(0) - 55;
  });
  var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function (acc, value) {
    return Number(acc + value) % 97;
  }, '');
  return remainder === 1;
}

function isIBAN(str) {
  (0, _assertString.default)(str);
  return hasValidIbanFormat(str) && hasValidIbanChecksum(str);
}

var locales = Object.keys(ibanRegexThroughCountryCode);
exports.locales = locales;

/***/ }),

/***/ 15566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIMEI;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imeiRegexWithoutHypens = /^[0-9]{15}$/;
var imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;

function isIMEI(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // default regex for checking imei is the one without hyphens

  var imeiRegex = imeiRegexWithoutHypens;

  if (options.allow_hyphens) {
    imeiRegex = imeiRegexWithHypens;
  }

  if (!imeiRegex.test(str)) {
    return false;
  }

  str = str.replace(/-/g, '');
  var sum = 0,
      mul = 2,
      l = 14;

  for (var i = 0; i < l; i++) {
    var digit = str.substring(l - i - 1, l - i);
    var tp = parseInt(digit, 10) * mul;

    if (tp >= 10) {
      sum += tp % 10 + 1;
    } else {
      sum += tp;
    }

    if (mul === 1) {
      mul += 1;
    } else {
      mul -= 1;
    }
  }

  var chk = (10 - sum % 10) % 10;

  if (chk !== parseInt(str.substring(14, 15), 10)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 61028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIP;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */
var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  }

  if (version === '4') {
    if (!IPv4AddressRegExp.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  }

  if (version === '6') {
    return !!IPv6AddressRegExp.test(str);
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 27795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIPRange;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isIP = _interopRequireDefault(__webpack_require__(61028));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subnetMaybe = /^\d{1,3}$/;
var v4Subnet = 32;
var v6Subnet = 128;

function isIPRange(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet

  if (parts.length !== 2) {
    return false;
  }

  if (!subnetMaybe.test(parts[1])) {
    return false;
  } // Disallow preceding 0 i.e. 01, 02, ...


  if (parts[1].length > 1 && parts[1].startsWith('0')) {
    return false;
  }

  var isValidIP = (0, _isIP.default)(parts[0], version);

  if (!isValidIP) {
    return false;
  } // Define valid subnet according to IP's version


  var expectedSubnet = null;

  switch (String(version)) {
    case '4':
      expectedSubnet = v4Subnet;
      break;

    case '6':
      expectedSubnet = v6Subnet;
      break;

    default:
      expectedSubnet = (0, _isIP.default)(parts[0], '6') ? v6Subnet : v4Subnet;
  }

  return parts[1] <= expectedSubnet && parts[1] >= 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 87612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISBN;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }

  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i;

  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }

    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }

    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }

    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 57148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISIN;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/; // this link details how the check digit is calculated:
// https://www.isin.org/isin-format/. it is a little bit
// odd in that it works with digits, not numbers. in order
// to make only one pass through the ISIN characters, the
// each alpha character is handled as 2 characters within
// the loop.

function isISIN(str) {
  (0, _assertString.default)(str);

  if (!isin.test(str)) {
    return false;
  }

  var double = true;
  var sum = 0; // convert values

  for (var i = str.length - 2; i >= 0; i--) {
    if (str[i] >= 'A' && str[i] <= 'Z') {
      var value = str[i].charCodeAt(0) - 55;
      var lo = value % 10;
      var hi = Math.trunc(value / 10); // letters have two digits, so handle the low order
      // and high order digits separately.

      for (var _i = 0, _arr = [lo, hi]; _i < _arr.length; _i++) {
        var digit = _arr[_i];

        if (double) {
          if (digit >= 5) {
            sum += 1 + (digit - 5) * 2;
          } else {
            sum += digit * 2;
          }
        } else {
          sum += digit;
        }

        double = !double;
      }
    } else {
      var _digit = str[i].charCodeAt(0) - '0'.charCodeAt(0);

      if (double) {
        if (_digit >= 5) {
          sum += 1 + (_digit - 5) * 2;
        } else {
          sum += _digit * 2;
        }
      } else {
        sum += _digit;
      }

      double = !double;
    }
  }

  var check = Math.trunc((sum + 9) / 10) * 10 - sum;
  return +str[str.length - 1] === check;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 21727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO31661Alpha2;
exports.CountryCodes = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var validISO31661Alpha2CountriesCodes = new Set(['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW']);

function isISO31661Alpha2(str) {
  (0, _assertString.default)(str);
  return validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
}

var CountryCodes = validISO31661Alpha2CountriesCodes;
exports.CountryCodes = CountryCodes;

/***/ }),

/***/ 86776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO31661Alpha3;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var validISO31661Alpha3CountriesCodes = new Set(['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE']);

function isISO31661Alpha3(str) {
  (0, _assertString.default)(str);
  return validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 19963:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO4217;
exports.CurrencyCodes = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_4217
var validISO4217CurrencyCodes = new Set(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF', 'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU', 'UYW', 'UZS', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWL']);

function isISO4217(str) {
  (0, _assertString.default)(str);
  return validISO4217CurrencyCodes.has(str.toUpperCase());
}

var CurrencyCodes = validISO4217CurrencyCodes;
exports.CurrencyCodes = CurrencyCodes;

/***/ }),

/***/ 65061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISO8601;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
// from http://goo.gl/0ejHHW
var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/; // same as above, except with a strict 'T' separator between date and time

var iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

var isValidDate = function isValidDate(str) {
  // str must have passed the ISO8601 check
  // this check is meant to catch invalid dates
  // like 2009-02-31
  // first check for ordinal dates
  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);

  if (ordinalMatch) {
    var oYear = Number(ordinalMatch[1]);
    var oDay = Number(ordinalMatch[2]); // if is leap year

    if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
    return oDay <= 365;
  }

  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
  var year = match[1];
  var month = match[2];
  var day = match[3];
  var monthString = month ? "0".concat(month).slice(-2) : month;
  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare

  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));

  if (month && day) {
    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
  }

  return true;
};

function isISO8601(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var check = options.strictSeparator ? iso8601StrictSeparator.test(str) : iso8601.test(str);
  if (check && options.strict) return isValidDate(str);
  return check;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 34339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISRC;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

function isISRC(str) {
  (0, _assertString.default)(str);
  return isrc.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 29887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isISSN;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var issn = '^\\d{4}-?\\d{3}[\\dX]$';

function isISSN(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var testIssn = issn;
  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');

  if (!testIssn.test(str)) {
    return false;
  }

  var digits = str.replace('-', '').toUpperCase();
  var checksum = 0;

  for (var i = 0; i < digits.length; i++) {
    var digit = digits[i];
    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
  }

  return checksum % 11 === 0;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 49396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIdentityCard;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isInt = _interopRequireDefault(__webpack_require__(20937));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  PL: function PL(str) {
    (0, _assertString.default)(str);
    var weightOfDigits = {
      1: 1,
      2: 3,
      3: 7,
      4: 9,
      5: 1,
      6: 3,
      7: 7,
      8: 9,
      9: 1,
      10: 3,
      11: 0
    };

    if (str != null && str.length === 11 && (0, _isInt.default)(str, {
      allow_leading_zeroes: true
    })) {
      var digits = str.split('').slice(0, -1);
      var sum = digits.reduce(function (acc, digit, index) {
        return acc + Number(digit) * weightOfDigits[index + 1];
      }, 0);
      var modulo = sum % 10;
      var lastDigit = Number(str.charAt(str.length - 1));

      if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) {
        return true;
      }
    }

    return false;
  },
  ES: function ES(str) {
    (0, _assertString.default)(str);
    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
    var charsValue = {
      X: 0,
      Y: 1,
      Z: 2
    };
    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input

    var sanitized = str.trim().toUpperCase(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    } // validate the control digit


    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
      return charsValue[char];
    });
    return sanitized.endsWith(controlDigits[number % 23]);
  },
  FI: function FI(str) {
    // https://dvv.fi/en/personal-identity-code#:~:text=control%20character%20for%20a-,personal,-identity%20code%20calculated
    (0, _assertString.default)(str);

    if (str.length !== 11) {
      return false;
    }

    if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) {
      return false;
    }

    var checkDigits = '0123456789ABCDEFHJKLMNPRSTUVWXY';
    var idAsNumber = parseInt(str.slice(0, 6), 10) * 1000 + parseInt(str.slice(7, 10), 10);
    var remainder = idAsNumber % 31;
    var checkDigit = checkDigits[remainder];
    return checkDigit === str.slice(10, 11);
  },
  IN: function IN(str) {
    var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/; // multiplication table

    var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]]; // permutation table

    var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    var c = 0;
    var invertedArray = sanitized.replace(/\s/g, '').split('').map(Number).reverse();
    invertedArray.forEach(function (val, i) {
      c = d[c][p[i % 8][val]];
    });
    return c === 0;
  },
  IR: function IR(str) {
    if (!str.match(/^\d{10}$/)) return false;
    str = "0000".concat(str).substr(str.length - 6);
    if (parseInt(str.substr(3, 6), 10) === 0) return false;
    var lastNumber = parseInt(str.substr(9, 1), 10);
    var sum = 0;

    for (var i = 0; i < 9; i++) {
      sum += parseInt(str.substr(i, 1), 10) * (10 - i);
    }

    sum %= 11;
    return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
  },
  IT: function IT(str) {
    if (str.length !== 9) return false;
    if (str === 'CA00000AA') return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana

    return str.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
  },
  NO: function NO(str) {
    var sanitized = str.trim();
    if (isNaN(Number(sanitized))) return false;
    if (sanitized.length !== 11) return false;
    if (sanitized === '00000000000') return false; // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer

    var f = sanitized.split('').map(Number);
    var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
    var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
    if (k1 !== f[9] || k2 !== f[10]) return false;
    return true;
  },
  TH: function TH(str) {
    if (!str.match(/^[1-8]\d{12}$/)) return false; // validate check digit

    var sum = 0;

    for (var i = 0; i < 12; i++) {
      sum += parseInt(str[i], 10) * (13 - i);
    }

    return str[12] === ((11 - sum % 11) % 10).toString();
  },
  LK: function LK(str) {
    var old_nic = /^[1-9]\d{8}[vx]$/i;
    var new_nic = /^[1-9]\d{11}$/i;
    if (str.length === 10 && old_nic.test(str)) return true;else if (str.length === 12 && new_nic.test(str)) return true;
    return false;
  },
  'he-IL': function heIL(str) {
    var DNI = /^\d{9}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    var id = sanitized;
    var sum = 0,
        incNum;

    for (var i = 0; i < id.length; i++) {
      incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2

      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
    }

    return sum % 10 === 0;
  },
  'ar-LY': function arLY(str) {
    // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
    var NIN = /^(1|2)\d{11}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!NIN.test(sanitized)) {
      return false;
    }

    return true;
  },
  'ar-TN': function arTN(str) {
    var DNI = /^\d{8}$/; // sanitize user input

    var sanitized = str.trim(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    }

    return true;
  },
  'zh-CN': function zhCN(str) {
    var provincesAndCities = ['11', // 北京
    '12', // 天津
    '13', // 河北
    '14', // 山西
    '15', // 内蒙古
    '21', // 辽宁
    '22', // 吉林
    '23', // 黑龙江
    '31', // 上海
    '32', // 江苏
    '33', // 浙江
    '34', // 安徽
    '35', // 福建
    '36', // 江西
    '37', // 山东
    '41', // 河南
    '42', // 湖北
    '43', // 湖南
    '44', // 广东
    '45', // 广西
    '46', // 海南
    '50', // 重庆
    '51', // 四川
    '52', // 贵州
    '53', // 云南
    '54', // 西藏
    '61', // 陕西
    '62', // 甘肃
    '63', // 青海
    '64', // 宁夏
    '65', // 新疆
    '71', // 台湾
    '81', // 香港
    '82', // 澳门
    '91' // 国外
    ];
    var powers = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2'];
    var parityBit = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

    var checkAddressCode = function checkAddressCode(addressCode) {
      return provincesAndCities.includes(addressCode);
    };

    var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
      var yyyy = parseInt(birDayCode.substring(0, 4), 10);
      var mm = parseInt(birDayCode.substring(4, 6), 10);
      var dd = parseInt(birDayCode.substring(6), 10);
      var xdata = new Date(yyyy, mm - 1, dd);

      if (xdata > new Date()) {
        return false; // eslint-disable-next-line max-len
      } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
        return true;
      }

      return false;
    };

    var getParityBit = function getParityBit(idCardNo) {
      var id17 = idCardNo.substring(0, 17);
      var power = 0;

      for (var i = 0; i < 17; i++) {
        power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
      }

      var mod = power % 11;
      return parityBit[mod];
    };

    var checkParityBit = function checkParityBit(idCardNo) {
      return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
    };

    var check15IdCardNo = function check15IdCardNo(idCardNo) {
      var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
      if (!check) return false;
      var addressCode = idCardNo.substring(0, 2);
      check = checkAddressCode(addressCode);
      if (!check) return false;
      var birDayCode = "19".concat(idCardNo.substring(6, 12));
      check = checkBirthDayCode(birDayCode);
      if (!check) return false;
      return true;
    };

    var check18IdCardNo = function check18IdCardNo(idCardNo) {
      var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
      if (!check) return false;
      var addressCode = idCardNo.substring(0, 2);
      check = checkAddressCode(addressCode);
      if (!check) return false;
      var birDayCode = idCardNo.substring(6, 14);
      check = checkBirthDayCode(birDayCode);
      if (!check) return false;
      return checkParityBit(idCardNo);
    };

    var checkIdCardNo = function checkIdCardNo(idCardNo) {
      var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
      if (!check) return false;

      if (idCardNo.length === 15) {
        return check15IdCardNo(idCardNo);
      }

      return check18IdCardNo(idCardNo);
    };

    return checkIdCardNo(str);
  },
  'zh-TW': function zhTW(str) {
    var ALPHABET_CODES = {
      A: 10,
      B: 11,
      C: 12,
      D: 13,
      E: 14,
      F: 15,
      G: 16,
      H: 17,
      I: 34,
      J: 18,
      K: 19,
      L: 20,
      M: 21,
      N: 22,
      O: 35,
      P: 23,
      Q: 24,
      R: 25,
      S: 26,
      T: 27,
      U: 28,
      V: 29,
      W: 32,
      X: 30,
      Y: 31,
      Z: 33
    };
    var sanitized = str.trim().toUpperCase();
    if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
    return Array.from(sanitized).reduce(function (sum, number, index) {
      if (index === 0) {
        var code = ALPHABET_CODES[number];
        return code % 10 * 9 + Math.floor(code / 10);
      }

      if (index === 9) {
        return (10 - sum % 10 - Number(number)) % 10 === 0;
      }

      return sum + Number(number) * (9 - index);
    }, 0);
  }
};

function isIdentityCard(str, locale) {
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (validators.hasOwnProperty(key)) {
        var validator = validators[key];

        if (validator(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 27228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isIn;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _toString = _interopRequireDefault(__webpack_require__(31913));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isIn(str, options) {
  (0, _assertString.default)(str);
  var i;

  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];

    for (i in options) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString.default)(options[i]);
      }
    }

    return array.indexOf(str) >= 0;
  } else if (_typeof(options) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 20937:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isInt;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.

  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 81008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isJSON;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var default_json_options = {
  allow_primitives: false
};

function isJSON(str, options) {
  (0, _assertString.default)(str);

  try {
    options = (0, _merge.default)(options, default_json_options);
    var primitives = [];

    if (options.allow_primitives) {
      primitives = [null, false, true];
    }

    var obj = JSON.parse(str);
    return primitives.includes(obj) || !!obj && _typeof(obj) === 'object';
  } catch (e) {
    /* ignore */
  }

  return false;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 74979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isJWT;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isBase = _interopRequireDefault(__webpack_require__(2689));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isJWT(str) {
  (0, _assertString.default)(str);
  var dotSplit = str.split('.');
  var len = dotSplit.length;

  if (len > 3 || len < 2) {
    return false;
  }

  return dotSplit.reduce(function (acc, currElem) {
    return acc && (0, _isBase.default)(currElem, {
      urlSafe: true
    });
  }, true);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 90478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLatLong;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
var latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
var longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
var defaultLatLongOptions = {
  checkDMS: false
};

function isLatLong(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, defaultLatLongOptions);
  if (!str.includes(',')) return false;
  var pair = str.split(',');
  if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;

  if (options.checkDMS) {
    return latDMS.test(pair[0]) && longDMS.test(pair[1]);
  }

  return lat.test(pair[0]) && long.test(pair[1]);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 20661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLength;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1] || 0;
    max = arguments[2];
  }

  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 82786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLicensePlate;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  'cs-CZ': function csCZ(str) {
    return /^(([ABCDEFHKIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
  },
  'de-DE': function deDE(str) {
    return /^((AW|UL|AK|GA|AÖ|LF|AZ|AM|AS|ZE|AN|AB|A|KG|KH|BA|EW|BZ|HY|KM|BT|HP|B|BC|BI|BO|FN|TT|ÜB|BN|AH|BS|FR|HB|ZZ|BB|BK|BÖ|OC|OK|CW|CE|C|CO|LH|CB|KW|LC|LN|DA|DI|DE|DH|SY|NÖ|DO|DD|DU|DN|D|EI|EA|EE|FI|EM|EL|EN|PF|ED|EF|ER|AU|ZP|E|ES|NT|EU|FL|FO|FT|FF|F|FS|FD|FÜ|GE|G|GI|GF|GS|ZR|GG|GP|GR|NY|ZI|GÖ|GZ|GT|HA|HH|HM|HU|WL|HZ|WR|RN|HK|HD|HN|HS|GK|HE|HF|RZ|HI|HG|HO|HX|IK|IL|IN|J|JL|KL|KA|KS|KF|KE|KI|KT|KO|KN|KR|KC|KU|K|LD|LL|LA|L|OP|LM|LI|LB|LU|LÖ|HL|LG|MD|GN|MZ|MA|ML|MR|MY|AT|DM|MC|NZ|RM|RG|MM|ME|MB|MI|FG|DL|HC|MW|RL|MK|MG|MÜ|WS|MH|M|MS|NU|NB|ND|NM|NK|NW|NR|NI|NF|DZ|EB|OZ|TG|TO|N|OA|GM|OB|CA|EH|FW|OF|OL|OE|OG|BH|LR|OS|AA|GD|OH|KY|NP|WK|PB|PA|PE|PI|PS|P|PM|PR|RA|RV|RE|R|H|SB|WN|RS|RD|RT|BM|NE|GV|RP|SU|GL|RO|GÜ|RH|EG|RW|PN|SK|MQ|RU|SZ|RI|SL|SM|SC|HR|FZ|VS|SW|SN|CR|SE|SI|SO|LP|SG|NH|SP|IZ|ST|BF|TE|HV|OD|SR|S|AC|DW|ZW|TF|TS|TR|TÜ|UM|PZ|TP|UE|UN|UH|MN|KK|VB|V|AE|PL|RC|VG|GW|PW|VR|VK|KB|WA|WT|BE|WM|WE|AP|MO|WW|FB|WZ|WI|WB|JE|WF|WO|W|WÜ|BL|Z|GC)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(AIC|FDB|ABG|SLN|SAW|KLZ|BUL|ESB|NAB|SUL|WST|ABI|AZE|BTF|KÖT|DKB|FEU|ROT|ALZ|SMÜ|WER|AUR|NOR|DÜW|BRK|HAB|TÖL|WOR|BAD|BAR|BER|BIW|EBS|KEM|MÜB|PEG|BGL|BGD|REI|WIL|BKS|BIR|WAT|BOR|BOH|BOT|BRB|BLK|HHM|NEB|NMB|WSF|LEO|HDL|WMS|WZL|BÜS|CHA|KÖZ|ROD|WÜM|CLP|NEC|COC|ZEL|COE|CUX|DAH|LDS|DEG|DEL|RSL|DLG|DGF|LAN|HEI|MED|DON|KIB|ROK|JÜL|MON|SLE|EBE|EIC|HIG|WBS|BIT|PRÜ|LIB|EMD|WIT|ERH|HÖS|ERZ|ANA|ASZ|MAB|MEK|STL|SZB|FDS|HCH|HOR|WOL|FRG|GRA|WOS|FRI|FFB|GAP|GER|BRL|CLZ|GTH|NOH|HGW|GRZ|LÖB|NOL|WSW|DUD|HMÜ|OHA|KRU|HAL|HAM|HBS|QLB|HVL|NAU|HAS|EBN|GEO|HOH|HDH|ERK|HER|WAN|HEF|ROF|HBN|ALF|HSK|USI|NAI|REH|SAN|KÜN|ÖHR|HOL|WAR|ARN|BRG|GNT|HOG|WOH|KEH|MAI|PAR|RID|ROL|KLE|GEL|KUS|KYF|ART|SDH|LDK|DIL|MAL|VIB|LER|BNA|GHA|GRM|MTL|WUR|LEV|LIF|STE|WEL|LIP|VAI|LUP|HGN|LBZ|LWL|PCH|STB|DAN|MKK|SLÜ|MSP|TBB|MGH|MTK|BIN|MSH|EIL|HET|SGH|BID|MYK|MSE|MST|MÜR|WRN|MEI|GRH|RIE|MZG|MIL|OBB|BED|FLÖ|MOL|FRW|SEE|SRB|AIB|MOS|BCH|ILL|SOB|NMS|NEA|SEF|UFF|NEW|VOH|NDH|TDO|NWM|GDB|GVM|WIS|NOM|EIN|GAN|LAU|HEB|OHV|OSL|SFB|ERB|LOS|BSK|KEL|BSB|MEL|WTL|OAL|FÜS|MOD|OHZ|OPR|BÜR|PAF|PLÖ|CAS|GLA|REG|VIT|ECK|SIM|GOA|EMS|DIZ|GOH|RÜD|SWA|NES|KÖN|MET|LRO|BÜZ|DBR|ROS|TET|HRO|ROW|BRV|HIP|PAN|GRI|SHK|EIS|SRO|SOK|LBS|SCZ|MER|QFT|SLF|SLS|HOM|SLK|ASL|BBG|SBK|SFT|SHG|MGN|MEG|ZIG|SAD|NEN|OVI|SHA|BLB|SIG|SON|SPN|FOR|GUB|SPB|IGB|WND|STD|STA|SDL|OBG|HST|BOG|SHL|PIR|FTL|SEB|SÖM|SÜW|TIR|SAB|TUT|ANG|SDT|LÜN|LSZ|MHL|VEC|VER|VIE|OVL|ANK|OVP|SBG|UEM|UER|WLG|GMN|NVP|RDG|RÜG|DAU|FKB|WAF|WAK|SLZ|WEN|SOG|APD|WUG|GUN|ESW|WIZ|WES|DIN|BRA|BÜD|WHV|HWI|GHC|WTM|WOB|WUN|MAK|SEL|OCH|HOT|WDA)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
  },
  'de-LI': function deLI(str) {
    return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
  },
  'fi-FI': function fiFI(str) {
    return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
  },
  'pt-PT': function ptPT(str) {
    return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
  },
  'sq-AL': function sqAL(str) {
    return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
  },
  'pt-BR': function ptBR(str) {
    return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
  }
};

function isLicensePlate(str, locale) {
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      /* eslint guard-for-in: 0 */
      var validator = validators[key];

      if (validator(str)) {
        return true;
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 67380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLocale;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localeReg = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;

function isLocale(str) {
  (0, _assertString.default)(str);

  if (str === 'en_US_POSIX' || str === 'ca_ES_VALENCIA') {
    return true;
  }

  return localeReg.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 43928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isLowercase;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLowercase(str) {
  (0, _assertString.default)(str);
  return str === str.toLowerCase();
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 28999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMACAddress;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var macAddress = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
var macAddressNoSeparators = /^([0-9a-fA-F]){12}$/;
var macAddressWithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;

function isMACAddress(str, options) {
  (0, _assertString.default)(str);
  /**
   * @deprecated `no_colons` TODO: remove it in the next major
  */

  if (options && (options.no_colons || options.no_separators)) {
    return macAddressNoSeparators.test(str);
  }

  return macAddress.test(str) || macAddressWithDots.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 90368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMD5;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString.default)(str);
  return md5.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 72776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMagnetURI;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var magnetURI = /^magnet:\?xt(?:\.1)?=urn:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?($|&)/i;

function isMagnetURI(url) {
  (0, _assertString.default)(url);
  return magnetURI.test(url.trim());
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 44554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMimeType;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/
// Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"

var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"

var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

function isMimeType(str) {
  (0, _assertString.default)(str);
  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 28355:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMobilePhone;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'am-AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-KW': /^(\+?965)[569]\d{7}$/,
  'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
  'ar-PS': /^(\+?970|0)5[6|9](\d{7})$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
  'az-AZ': /^(\+994|0)(5[015]|7[07]|99)\d{7}$/,
  'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
  'ca-AD': /^(\+376)?[346]\d{5}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^((\+49|0)[1|3])([0|5][0-45-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
  'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
  'de-LU': /^(\+352)?((6\d1)\d{6})$/,
  'dv-MV': /^(\+?960)?(7[2-9]|91|9[3-9])\d{7}$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-BM': /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}))/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-GG': /^(\+?44|0)1481\d{6}$/,
  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  'en-GY': /^(\+592|0)6\d{6}$/,
  'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
  'en-KI': /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  'en-MU': /^(\+?230|0)?\d{8}$/,
  'en-NA': /^(\+?264|0)(6|8)\d{7}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
  'en-PK': /^((00|\+)?92|0)3[0-6]\d{8}$/,
  'en-PH': /^(09|\+639)\d{9}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[3689]\d{7}$/,
  'en-SL': /^(\+?232|0)\d{8}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'en-ZW': /^(\+263)[0-9]{9}$/,
  'en-BW': /^(\+?267)?(7[1-8]{1})\d{6}$/,
  'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
  'es-BO': /^(\+?591)?(6|7)\d{7}$/,
  'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  'es-CR': /^(\+506)?[2-8]\d{7}$/,
  'es-CU': /^(\+53|0053)?5\d{7}/,
  'es-DO': /^(\+?1)?8[024]9\d{7}$/,
  'es-HN': /^(\+?504)?[9|8]\d{7}$/,
  'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  'es-ES': /^(\+?34)?[6|7]\d{8}$/,
  'es-PE': /^(\+?51)?9\d{8}$/,
  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
  'es-PA': /^(\+?507)\d{7,8}$/,
  'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
  'es-SV': /^(\+?503)?[67]\d{7}$/,
  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
  'es-VE': /^(\+?58)?(2|4)\d{9}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-BF': /^(\+226|0)[67]\d{7}$/,
  'fr-CM': /^(\+?237)6[0-9]{8}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
  'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
  'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
  'fr-PF': /^(\+?689)?8[789]\d{6}$/,
  'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  'hu-HU': /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  'ka-GE': /^(\+?995)?(5|79)\d{7}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'lv-LV': /^(\+?371)2\d{7}$/,
  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'ne-NP': /^(\+?977)?9[78]\d{8}$/,
  'nl-BE': /^(\+?32|0)4\d{8}$/,
  'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'pt-AO': /^(\+244)\d{9}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'si-LK': /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sq-AL': /^(\+355|0)6[789]\d{6}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  'tg-TJ': /^(\+?992)?[5][5]\d{7}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'tk-TM': /^(\+993|993|8)\d{8}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  'vi-VN': /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  'zh-CN': /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
  'dz-BT': /^(\+?975|0)?(17|16|77|02)\d{6}$/
};
/* eslint-enable max-len */
// aliases

phones['en-CA'] = phones['en-US'];
phones['fr-CA'] = phones['en-CA'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];
phones['zh-MO'] = phones['en-MO'];
phones['ga-IE'] = phones['en-IE'];
phones['fr-CH'] = phones['de-CH'];
phones['it-CH'] = phones['fr-CH'];

function isMobilePhone(str, locale, options) {
  (0, _assertString.default)(str);

  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }

  if (Array.isArray(locale)) {
    return locale.some(function (key) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }

      return false;
    });
  } else if (locale in phones) {
    return phones[locale].test(str); // alias falsey locale as 'any'
  } else if (!locale || locale === 'any') {
    for (var key in phones) {
      // istanbul ignore else
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(phones);
exports.locales = locales;

/***/ }),

/***/ 19131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMongoId;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(77117));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMongoId(str) {
  (0, _assertString.default)(str);
  return (0, _isHexadecimal.default)(str) && str.length === 24;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 13590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isMultibyte;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString.default)(str);
  return multibyte.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 24986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isNumeric;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _alpha = __webpack_require__(60079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numericNoSymbols = /^[0-9]+$/;

function isNumeric(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_symbols) {
    return numericNoSymbols.test(str);
  }

  return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? _alpha.decimal[options.locale] : '.', "])?[0-9]+$")).test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 66090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isOctal;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var octal = /^(0o)?[0-7]+$/i;

function isOctal(str) {
  (0, _assertString.default)(str);
  return octal.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 51513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPassportNumber;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */
var passportRegexByCountryCode = {
  AM: /^[A-Z]{2}\d{7}$/,
  // ARMENIA
  AR: /^[A-Z]{3}\d{6}$/,
  // ARGENTINA
  AT: /^[A-Z]\d{7}$/,
  // AUSTRIA
  AU: /^[A-Z]\d{7}$/,
  // AUSTRALIA
  BE: /^[A-Z]{2}\d{6}$/,
  // BELGIUM
  BG: /^\d{9}$/,
  // BULGARIA
  BR: /^[A-Z]{2}\d{6}$/,
  // BRAZIL
  BY: /^[A-Z]{2}\d{7}$/,
  // BELARUS
  CA: /^[A-Z]{2}\d{6}$/,
  // CANADA
  CH: /^[A-Z]\d{7}$/,
  // SWITZERLAND
  CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
  // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
  CY: /^[A-Z](\d{6}|\d{8})$/,
  // CYPRUS
  CZ: /^\d{8}$/,
  // CZECH REPUBLIC
  DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
  // GERMANY
  DK: /^\d{9}$/,
  // DENMARK
  DZ: /^\d{9}$/,
  // ALGERIA
  EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
  // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
  ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
  // SPAIN
  FI: /^[A-Z]{2}\d{7}$/,
  // FINLAND
  FR: /^\d{2}[A-Z]{2}\d{5}$/,
  // FRANCE
  GB: /^\d{9}$/,
  // UNITED KINGDOM
  GR: /^[A-Z]{2}\d{7}$/,
  // GREECE
  HR: /^\d{9}$/,
  // CROATIA
  HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
  // HUNGARY
  IE: /^[A-Z0-9]{2}\d{7}$/,
  // IRELAND
  IN: /^[A-Z]{1}-?\d{7}$/,
  // INDIA
  ID: /^[A-C]\d{7}$/,
  // INDONESIA
  IR: /^[A-Z]\d{8}$/,
  // IRAN
  IS: /^(A)\d{7}$/,
  // ICELAND
  IT: /^[A-Z0-9]{2}\d{7}$/,
  // ITALY
  JP: /^[A-Z]{2}\d{7}$/,
  // JAPAN
  KR: /^[MS]\d{8}$/,
  // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
  LT: /^[A-Z0-9]{8}$/,
  // LITHUANIA
  LU: /^[A-Z0-9]{8}$/,
  // LUXEMBURG
  LV: /^[A-Z0-9]{2}\d{7}$/,
  // LATVIA
  LY: /^[A-Z0-9]{8}$/,
  // LIBYA
  MT: /^\d{7}$/,
  // MALTA
  MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
  // MOZAMBIQUE
  MY: /^[AHK]\d{8}$/,
  // MALAYSIA
  NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
  // NETHERLANDS
  PL: /^[A-Z]{2}\d{7}$/,
  // POLAND
  PT: /^[A-Z]\d{6}$/,
  // PORTUGAL
  RO: /^\d{8,9}$/,
  // ROMANIA
  RU: /^\d{9}$/,
  // RUSSIAN FEDERATION
  SE: /^\d{8}$/,
  // SWEDEN
  SL: /^(P)[A-Z]\d{7}$/,
  // SLOVANIA
  SK: /^[0-9A-Z]\d{7}$/,
  // SLOVAKIA
  TR: /^[A-Z]\d{8}$/,
  // TURKEY
  UA: /^[A-Z]{2}\d{6}$/,
  // UKRAINE
  US: /^\d{9}$/ // UNITED STATES

};
/**
 * Check if str is a valid passport number
 * relative to provided ISO Country Code.
 *
 * @param {string} str
 * @param {string} countryCode
 * @return {boolean}
 */

function isPassportNumber(str, countryCode) {
  (0, _assertString.default)(str);
  /** Remove All Whitespaces, Convert to UPPERCASE */

  var normalizedStr = str.replace(/\s/g, '').toUpperCase();
  return countryCode.toUpperCase() in passportRegexByCountryCode && passportRegexByCountryCode[countryCode].test(normalizedStr);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 24595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPort;

var _isInt = _interopRequireDefault(__webpack_require__(20937));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPort(str) {
  return (0, _isInt.default)(str, {
    min: 0,
    max: 65535
  });
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 78140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isPostalCode;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// common patterns
var threeDigit = /^\d{3}$/;
var fourDigit = /^\d{4}$/;
var fiveDigit = /^\d{5}$/;
var sixDigit = /^\d{6}$/;
var patterns = {
  AD: /^AD\d{3}$/,
  AT: fourDigit,
  AU: fourDigit,
  AZ: /^AZ\d{4}$/,
  BE: fourDigit,
  BG: fourDigit,
  BR: /^\d{5}-\d{3}$/,
  BY: /2[1-4]{1}\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: fourDigit,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: fiveDigit,
  DK: fourDigit,
  DO: fiveDigit,
  DZ: fiveDigit,
  EE: fiveDigit,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: fiveDigit,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: fourDigit,
  ID: fiveDigit,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
  IS: threeDigit,
  IT: fiveDigit,
  JP: /^\d{3}\-\d{4}$/,
  KE: fiveDigit,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: fourDigit,
  LV: /^LV\-\d{4}$/,
  LK: fiveDigit,
  MX: fiveDigit,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: fiveDigit,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: fourDigit,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: fourDigit,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: sixDigit,
  RU: sixDigit,
  SA: fiveDigit,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: sixDigit,
  SI: fourDigit,
  SK: /^\d{3}\s?\d{2}$/,
  TH: fiveDigit,
  TN: fourDigit,
  TW: /^\d{3}(\d{2})?$/,
  UA: fiveDigit,
  US: /^\d{5}(-\d{4})?$/,
  ZA: fourDigit,
  ZM: fiveDigit
};
var locales = Object.keys(patterns);
exports.locales = locales;

function isPostalCode(str, locale) {
  (0, _assertString.default)(str);

  if (locale in patterns) {
    return patterns[locale].test(str);
  } else if (locale === 'any') {
    for (var key in patterns) {
      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
      // istanbul ignore else
      if (patterns.hasOwnProperty(key)) {
        var pattern = patterns[key];

        if (pattern.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

/***/ }),

/***/ 94611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isRFC3339;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
var dateFullYear = /[0-9]{4}/;
var dateMonth = /(0[1-9]|1[0-2])/;
var dateMDay = /([12]\d|0[1-9]|3[01])/;
var timeHour = /([01][0-9]|2[0-3])/;
var timeMinute = /[0-5][0-9]/;
var timeSecond = /([0-5][0-9]|60)/;
var timeSecFrac = /(\.[0-9]+)?/;
var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
var rfc3339 = new RegExp("^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$"));

function isRFC3339(str) {
  (0, _assertString.default)(str);
  return rfc3339.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 6454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isRgbColor;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
var rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
var rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/;
var rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;

function isRgbColor(str) {
  var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0, _assertString.default)(str);

  if (!includePercentValues) {
    return rgbColor.test(str) || rgbaColor.test(str);
  }

  return rgbColor.test(str) || rgbaColor.test(str) || rgbColorPercent.test(str) || rgbaColorPercent.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 86826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSemVer;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _multilineRegex = _interopRequireDefault(__webpack_require__(24731));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */
var semanticVersioningRegex = (0, _multilineRegex.default)(['^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)', '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))', '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'], 'i');

function isSemVer(str) {
  (0, _assertString.default)(str);
  return semanticVersioningRegex.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 68220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSlug;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;

function isSlug(str) {
  (0, _assertString.default)(str);
  return charsetRegex.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 17633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isStrongPassword;

var _merge = _interopRequireDefault(__webpack_require__(84808));

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var upperCaseRegex = /^[A-Z]$/;
var lowerCaseRegex = /^[a-z]$/;
var numberRegex = /^[0-9]$/;
var symbolRegex = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/;
var defaultOptions = {
  minLength: 8,
  minLowercase: 1,
  minUppercase: 1,
  minNumbers: 1,
  minSymbols: 1,
  returnScore: false,
  pointsPerUnique: 1,
  pointsPerRepeat: 0.5,
  pointsForContainingLower: 10,
  pointsForContainingUpper: 10,
  pointsForContainingNumber: 10,
  pointsForContainingSymbol: 10
};
/* Counts number of occurrences of each char in a string
 * could be moved to util/ ?
*/

function countChars(str) {
  var result = {};
  Array.from(str).forEach(function (char) {
    var curVal = result[char];

    if (curVal) {
      result[char] += 1;
    } else {
      result[char] = 1;
    }
  });
  return result;
}
/* Return information about a password */


function analyzePassword(password) {
  var charMap = countChars(password);
  var analysis = {
    length: password.length,
    uniqueChars: Object.keys(charMap).length,
    uppercaseCount: 0,
    lowercaseCount: 0,
    numberCount: 0,
    symbolCount: 0
  };
  Object.keys(charMap).forEach(function (char) {
    /* istanbul ignore else */
    if (upperCaseRegex.test(char)) {
      analysis.uppercaseCount += charMap[char];
    } else if (lowerCaseRegex.test(char)) {
      analysis.lowercaseCount += charMap[char];
    } else if (numberRegex.test(char)) {
      analysis.numberCount += charMap[char];
    } else if (symbolRegex.test(char)) {
      analysis.symbolCount += charMap[char];
    }
  });
  return analysis;
}

function scorePassword(analysis, scoringOptions) {
  var points = 0;
  points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
  points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;

  if (analysis.lowercaseCount > 0) {
    points += scoringOptions.pointsForContainingLower;
  }

  if (analysis.uppercaseCount > 0) {
    points += scoringOptions.pointsForContainingUpper;
  }

  if (analysis.numberCount > 0) {
    points += scoringOptions.pointsForContainingNumber;
  }

  if (analysis.symbolCount > 0) {
    points += scoringOptions.pointsForContainingSymbol;
  }

  return points;
}

function isStrongPassword(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  (0, _assertString.default)(str);
  var analysis = analyzePassword(str);
  options = (0, _merge.default)(options || {}, defaultOptions);

  if (options.returnScore) {
    return scorePassword(analysis, options);
  }

  return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 72828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSurrogatePair;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString.default)(str);
  return surrogatePair.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 53058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isTaxID;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var algorithms = _interopRequireWildcard(__webpack_require__(83672));

var _isDate = _interopRequireDefault(__webpack_require__(82549));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * TIN Validation
 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
 *
 * EU-UK:
 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
 *
 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
 *
 * US:
 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
 *  is used to identify a business entity.
 *
 * NOTES:
 *  - Prefix 47 is being reserved for future use
 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
 *
 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
 * for more information.
 */
// Locale functions

/*
 * bg-BG validation function
 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last) digit
 */
function bgBgCheck(tin) {
  // Extract full year, normalize month and check birth date validity
  var century_year = tin.slice(0, 2);
  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 40) {
    month -= 40;
    century_year = "20".concat(century_year);
  } else if (month > 20) {
    month -= 20;
    century_year = "18".concat(century_year);
  } else {
    century_year = "19".concat(century_year);
  }

  if (month < 10) {
    month = "0".concat(month);
  }

  var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  }); // Calculate checksum by multiplying digits with fixed values

  var multip_lookup = [2, 4, 8, 5, 10, 9, 7, 3, 6];
  var checksum = 0;

  for (var i = 0; i < multip_lookup.length; i++) {
    checksum += digits[i] * multip_lookup[i];
  }

  checksum = checksum % 11 === 10 ? 0 : checksum % 11;
  return checksum === digits[9];
}
/*
 * cs-CZ validation function
 * (Rodné číslo (RČ), persons only)
 * Checks if birth date (first six digits) is valid and divisibility by 11
 * Material not in DG TAXUD document sourced from:
 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
 */


function csCzCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract full year from TIN length

  var full_year = parseInt(tin.slice(0, 2), 10);

  if (tin.length === 10) {
    if (full_year < 54) {
      full_year = "20".concat(full_year);
    } else {
      full_year = "19".concat(full_year);
    }
  } else {
    if (tin.slice(6) === '000') {
      return false;
    } // Three-zero serial not assigned before 1954


    if (full_year < 54) {
      full_year = "19".concat(full_year);
    } else {
      return false; // No 18XX years seen in any of the resources
    }
  } // Add missing zero if needed


  if (full_year.length === 3) {
    full_year = [full_year.slice(0, 2), '0', full_year.slice(2)].join('');
  } // Extract month from TIN and normalize


  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 50) {
    month -= 50;
  }

  if (month > 20) {
    // Month-plus-twenty was only introduced in 2004
    if (parseInt(full_year, 10) < 2004) {
      return false;
    }

    month -= 20;
  }

  if (month < 10) {
    month = "0".concat(month);
  } // Check date validity


  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Verify divisibility by 11


  if (tin.length === 10) {
    if (parseInt(tin, 10) % 11 !== 0) {
      // Some numbers up to and including 1985 are still valid if
      // check (last) digit equals 0 and modulo of first 9 digits equals 10
      var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;

      if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
        if (parseInt(tin.slice(9), 10) !== 0) {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  return true;
}
/*
 * de-AT validation function
 * (Abgabenkontonummer, persons/entities)
 * Verify TIN validity by calling luhnCheck()
 */


function deAtCheck(tin) {
  return algorithms.luhnCheck(tin);
}
/*
 * de-DE validation function
 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
 * Partial implementation of spec (same result with both algorithms always)
 */


function deDeCheck(tin) {
  // Split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  }); // Fill array with strings of number positions

  var occurences = [];

  for (var i = 0; i < digits.length - 1; i++) {
    occurences.push('');

    for (var j = 0; j < digits.length - 1; j++) {
      if (digits[i] === digits[j]) {
        occurences[i] += j;
      }
    }
  } // Remove digits with one occurence and test for only one duplicate/triplicate


  occurences = occurences.filter(function (a) {
    return a.length > 1;
  });

  if (occurences.length !== 2 && occurences.length !== 3) {
    return false;
  } // In case of triplicate value only two digits are allowed next to each other


  if (occurences[0].length === 3) {
    var trip_locations = occurences[0].split('').map(function (a) {
      return parseInt(a, 10);
    });
    var recurrent = 0; // Amount of neighbour occurences

    for (var _i = 0; _i < trip_locations.length - 1; _i++) {
      if (trip_locations[_i] + 1 === trip_locations[_i + 1]) {
        recurrent += 1;
      }
    }

    if (recurrent === 2) {
      return false;
    }
  }

  return algorithms.iso7064Check(tin);
}
/*
 * dk-DK validation function
 * (CPR-nummer (personnummer), persons only)
 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
 * and calculates check (last) digit
 */


function dkDkCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract year, check if valid for given century digit and add century

  var year = parseInt(tin.slice(4, 6), 10);
  var century_digit = tin.slice(6, 7);

  switch (century_digit) {
    case '0':
    case '1':
    case '2':
    case '3':
      year = "19".concat(year);
      break;

    case '4':
    case '9':
      if (year < 37) {
        year = "20".concat(year);
      } else {
        year = "19".concat(year);
      }

      break;

    default:
      if (year < 37) {
        year = "20".concat(year);
      } else if (year > 58) {
        year = "18".concat(year);
      } else {
        return false;
      }

      break;
  } // Add missing zero if needed


  if (year.length === 3) {
    year = [year.slice(0, 2), '0', year.slice(2)].join('');
  } // Check date validity


  var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;
  var weight = 4; // Multiply by weight and add to checksum

  for (var i = 0; i < 9; i++) {
    checksum += digits[i] * weight;
    weight -= 1;

    if (weight === 1) {
      weight = 7;
    }
  }

  checksum %= 11;

  if (checksum === 1) {
    return false;
  }

  return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
}
/*
 * el-CY validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
 * Verify TIN validity by calculating ASCII value of check (last) character
 */


function elCyCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.slice(0, 8).split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0; // add digits in even places

  for (var i = 1; i < digits.length; i += 2) {
    checksum += digits[i];
  } // add digits in odd places


  for (var _i2 = 0; _i2 < digits.length; _i2 += 2) {
    if (digits[_i2] < 2) {
      checksum += 1 - digits[_i2];
    } else {
      checksum += 2 * (digits[_i2] - 2) + 5;

      if (digits[_i2] > 4) {
        checksum += 2;
      }
    }
  }

  return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
}
/*
 * el-GR validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
 * Verify TIN validity by calculating check (last) digit
 * Algorithm not in DG TAXUD document- sourced from:
 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
 */


function elGrCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;

  for (var i = 0; i < 8; i++) {
    checksum += digits[i] * Math.pow(2, 8 - i);
  }

  return checksum % 11 % 10 === digits[8];
}
/*
 * en-GB validation function (should go here if needed)
 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
 * persons/entities respectively)
 */

/*
 * en-IE validation function
 * (Personal Public Service Number (PPS No), persons only)
 * Verify TIN validity by calculating check (second to last) character
 */


function enIeCheck(tin) {
  var checksum = algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
    return parseInt(a, 10);
  }), 8);

  if (tin.length === 9 && tin[8] !== 'W') {
    checksum += (tin[8].charCodeAt(0) - 64) * 9;
  }

  checksum %= 23;

  if (checksum === 0) {
    return tin[7].toUpperCase() === 'W';
  }

  return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
} // Valid US IRS campus prefixes


var enUsCampusPrefix = {
  andover: ['10', '12'],
  atlanta: ['60', '67'],
  austin: ['50', '53'],
  brookhaven: ['01', '02', '03', '04', '05', '06', '11', '13', '14', '16', '21', '22', '23', '25', '34', '51', '52', '54', '55', '56', '57', '58', '59', '65'],
  cincinnati: ['30', '32', '35', '36', '37', '38', '61'],
  fresno: ['15', '24'],
  internet: ['20', '26', '27', '45', '46', '47'],
  kansas: ['40', '44'],
  memphis: ['94', '95'],
  ogden: ['80', '90'],
  philadelphia: ['33', '39', '41', '42', '43', '46', '48', '62', '63', '64', '66', '68', '71', '72', '73', '74', '75', '76', '77', '81', '82', '83', '84', '85', '86', '87', '88', '91', '92', '93', '98', '99'],
  sba: ['31']
}; // Return an array of all US IRS campus prefixes

function enUsGetPrefixes() {
  var prefixes = [];

  for (var location in enUsCampusPrefix) {
    // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
    // istanbul ignore else
    if (enUsCampusPrefix.hasOwnProperty(location)) {
      prefixes.push.apply(prefixes, _toConsumableArray(enUsCampusPrefix[location]));
    }
  }

  return prefixes;
}
/*
 * en-US validation function
 * Verify that the TIN starts with a valid IRS campus prefix
 */


function enUsCheck(tin) {
  return enUsGetPrefixes().indexOf(tin.substr(0, 2)) !== -1;
}
/*
 * es-ES validation function
 * (Documento Nacional de Identidad (DNI)
 * or Número de Identificación de Extranjero (NIE), persons only)
 * Verify TIN validity by calculating check (last) character
 */


function esEsCheck(tin) {
  // Split characters into an array for further processing
  var chars = tin.toUpperCase().split(''); // Replace initial letter if needed

  if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
    var lead_replace = 0;

    switch (chars[0]) {
      case 'Y':
        lead_replace = 1;
        break;

      case 'Z':
        lead_replace = 2;
        break;

      default:
    }

    chars.splice(0, 1, lead_replace); // Fill with zeros if smaller than proper
  } else {
    while (chars.length < 9) {
      chars.unshift(0);
    }
  } // Calculate checksum and check according to lookup


  var lookup = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'];
  chars = chars.join('');
  var checksum = parseInt(chars.slice(0, 8), 10) % 23;
  return chars[8] === lookup[checksum];
}
/*
 * et-EE validation function
 * (Isikukood (IK), persons only)
 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
 * Material not in DG TAXUD document sourced from:
 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
 */


function etEeCheck(tin) {
  // Extract year and add century
  var full_year = tin.slice(1, 3);
  var century_digit = tin.slice(0, 1);

  switch (century_digit) {
    case '1':
    case '2':
      full_year = "18".concat(full_year);
      break;

    case '3':
    case '4':
      full_year = "19".concat(full_year);
      break;

    default:
      full_year = "20".concat(full_year);
      break;
  } // Check date validity


  var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Split digits into an array for further processing


  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 0;
  var weight = 1; // Multiply by weight and add to checksum

  for (var i = 0; i < 10; i++) {
    checksum += digits[i] * weight;
    weight += 1;

    if (weight === 10) {
      weight = 1;
    }
  } // Do again if modulo 11 of checksum is 10


  if (checksum % 11 === 10) {
    checksum = 0;
    weight = 3;

    for (var _i3 = 0; _i3 < 10; _i3++) {
      checksum += digits[_i3] * weight;
      weight += 1;

      if (weight === 10) {
        weight = 1;
      }
    }

    if (checksum % 11 === 10) {
      return digits[10] === 0;
    }
  }

  return checksum % 11 === digits[10];
}
/*
 * fi-FI validation function
 * (Henkilötunnus (HETU), persons only)
 * Checks if birth date (first six digits plus century symbol) is valid
 * and calculates check (last) digit
 */


function fiFiCheck(tin) {
  // Extract year and add century
  var full_year = tin.slice(4, 6);
  var century_symbol = tin.slice(6, 7);

  switch (century_symbol) {
    case '+':
      full_year = "18".concat(full_year);
      break;

    case '-':
      full_year = "19".concat(full_year);
      break;

    default:
      full_year = "20".concat(full_year);
      break;
  } // Check date validity


  var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Calculate check character


  var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;

  if (checksum < 10) {
    return checksum === parseInt(tin.slice(10), 10);
  }

  checksum -= 10;
  var letters_lookup = ['A', 'B', 'C', 'D', 'E', 'F', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
  return letters_lookup[checksum] === tin.slice(10);
}
/*
 * fr/nl-BE validation function
 * (Numéro national (N.N.), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
 */


function frBeCheck(tin) {
  // Zero month/day value is acceptable
  if (tin.slice(2, 4) !== '00' || tin.slice(4, 6) !== '00') {
    // Extract date from first six digits of TIN
    var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));

    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
      return false;
    }
  }

  var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
  var checkdigits = parseInt(tin.slice(9, 11), 10);

  if (checksum !== checkdigits) {
    checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;

    if (checksum !== checkdigits) {
      return false;
    }
  }

  return true;
}
/*
 * fr-FR validation function
 * (Numéro fiscal de référence (numéro SPI), persons only)
 * Verify TIN validity by calculating check (last three) digits
 */


function frFrCheck(tin) {
  tin = tin.replace(/\s/g, '');
  var checksum = parseInt(tin.slice(0, 10), 10) % 511;
  var checkdigits = parseInt(tin.slice(10, 13), 10);
  return checksum === checkdigits;
}
/*
 * fr/lb-LU validation function
 * (numéro d’identification personnelle, persons only)
 * Verify birth date validity and run Luhn and Verhoeff checks
 */


function frLuCheck(tin) {
  // Extract date and check validity
  var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Run Luhn check


  if (!algorithms.luhnCheck(tin.slice(0, 12))) {
    return false;
  } // Remove Luhn check digit and run Verhoeff check


  return algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
}
/*
 * hr-HR validation function
 * (Osobni identifikacijski broj (OIB), persons/entities)
 * Verify TIN validity by calling iso7064Check(digits)
 */


function hrHrCheck(tin) {
  return algorithms.iso7064Check(tin);
}
/*
 * hu-HU validation function
 * (Adóazonosító jel, persons only)
 * Verify TIN validity by calculating check (last) digit
 */


function huHuCheck(tin) {
  // split digits into an array for further processing
  var digits = tin.split('').map(function (a) {
    return parseInt(a, 10);
  });
  var checksum = 8;

  for (var i = 1; i < 9; i++) {
    checksum += digits[i] * (i + 1);
  }

  return checksum % 11 === digits[9];
}
/*
 * lt-LT validation function (should go here if needed)
 * (Asmens kodas, persons/entities respectively)
 * Current validation check is alias of etEeCheck- same format applies
 */

/*
 * it-IT first/last name validity check
 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
 * Due to lack of clarity between resources ("Are only Italian consonants used?
 * What happens if a person has X in their name?" etc.) only two test conditions
 * have been implemented:
 * Vowels may only be followed by other vowels or an X character
 * and X characters after vowels may only be followed by other X characters.
 */


function itItNameCheck(name) {
  // true at the first occurence of a vowel
  var vowelflag = false; // true at the first occurence of an X AFTER vowel
  // (to properly handle last names with X as consonant)

  var xflag = false;

  for (var i = 0; i < 3; i++) {
    if (!vowelflag && /[AEIOU]/.test(name[i])) {
      vowelflag = true;
    } else if (!xflag && vowelflag && name[i] === 'X') {
      xflag = true;
    } else if (i > 0) {
      if (vowelflag && !xflag) {
        if (!/[AEIOU]/.test(name[i])) {
          return false;
        }
      }

      if (xflag) {
        if (!/X/.test(name[i])) {
          return false;
        }
      }
    }
  }

  return true;
}
/*
 * it-IT validation function
 * (Codice fiscale (TIN-IT), persons only)
 * Verify name, birth date and codice catastale validity
 * and calculate check character.
 * Material not in DG-TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
 */


function itItCheck(tin) {
  // Capitalize and split characters into an array for further processing
  var chars = tin.toUpperCase().split(''); // Check first and last name validity calling itItNameCheck()

  if (!itItNameCheck(chars.slice(0, 3))) {
    return false;
  }

  if (!itItNameCheck(chars.slice(3, 6))) {
    return false;
  } // Convert letters in number spaces back to numbers if any


  var number_locations = [6, 7, 9, 10, 12, 13, 14];
  var number_replace = {
    L: '0',
    M: '1',
    N: '2',
    P: '3',
    Q: '4',
    R: '5',
    S: '6',
    T: '7',
    U: '8',
    V: '9'
  };

  for (var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++) {
    var i = _number_locations[_i4];

    if (chars[i] in number_replace) {
      chars.splice(i, 1, number_replace[chars[i]]);
    }
  } // Extract month and day, and check date validity


  var month_replace = {
    A: '01',
    B: '02',
    C: '03',
    D: '04',
    E: '05',
    H: '06',
    L: '07',
    M: '08',
    P: '09',
    R: '10',
    S: '11',
    T: '12'
  };
  var month = month_replace[chars[8]];
  var day = parseInt(chars[9] + chars[10], 10);

  if (day > 40) {
    day -= 40;
  }

  if (day < 10) {
    day = "0".concat(day);
  }

  var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);

  if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
    return false;
  } // Calculate check character by adding up even and odd characters as numbers


  var checksum = 0;

  for (var _i5 = 1; _i5 < chars.length - 1; _i5 += 2) {
    var char_to_int = parseInt(chars[_i5], 10);

    if (isNaN(char_to_int)) {
      char_to_int = chars[_i5].charCodeAt(0) - 65;
    }

    checksum += char_to_int;
  }

  var odd_convert = {
    // Maps of characters at odd places
    A: 1,
    B: 0,
    C: 5,
    D: 7,
    E: 9,
    F: 13,
    G: 15,
    H: 17,
    I: 19,
    J: 21,
    K: 2,
    L: 4,
    M: 18,
    N: 20,
    O: 11,
    P: 3,
    Q: 6,
    R: 8,
    S: 12,
    T: 14,
    U: 16,
    V: 10,
    W: 22,
    X: 25,
    Y: 24,
    Z: 23,
    0: 1,
    1: 0
  };

  for (var _i6 = 0; _i6 < chars.length - 1; _i6 += 2) {
    var _char_to_int = 0;

    if (chars[_i6] in odd_convert) {
      _char_to_int = odd_convert[chars[_i6]];
    } else {
      var multiplier = parseInt(chars[_i6], 10);
      _char_to_int = 2 * multiplier + 1;

      if (multiplier > 4) {
        _char_to_int += 2;
      }
    }

    checksum += _char_to_int;
  }

  if (String.fromCharCode(65 + checksum % 26) !== chars[15]) {
    return false;
  }

  return true;
}
/*
 * lv-LV validation function
 * (Personas kods (PK), persons only)
 * Check validity of birth date and calculate check (last) digit
 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
 * Material not in DG TAXUD document sourced from:
 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
 */


function lvLvCheck(tin) {
  tin = tin.replace(/\W/, ''); // Extract date from TIN

  var day = tin.slice(0, 2);

  if (day !== '32') {
    // No date/checksum check if new format
    var month = tin.slice(2, 4);

    if (month !== '00') {
      // No date check if unknown month
      var full_year = tin.slice(4, 6);

      switch (tin[6]) {
        case '0':
          full_year = "18".concat(full_year);
          break;

        case '1':
          full_year = "19".concat(full_year);
          break;

        default:
          full_year = "20".concat(full_year);
          break;
      } // Check date validity


      var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);

      if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
        return false;
      }
    } // Calculate check digit


    var checksum = 1101;
    var multip_lookup = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

    for (var i = 0; i < tin.length - 1; i++) {
      checksum -= parseInt(tin[i], 10) * multip_lookup[i];
    }

    return parseInt(tin[10], 10) === checksum % 11;
  }

  return true;
}
/*
 * mt-MT validation function
 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
 * Verify Identity Card Number structure (no other tests found)
 */


function mtMtCheck(tin) {
  if (tin.length !== 9) {
    // No tests for UTR
    var chars = tin.toUpperCase().split(''); // Fill with zeros if smaller than proper

    while (chars.length < 8) {
      chars.unshift(0);
    } // Validate format according to last character


    switch (tin[7]) {
      case 'A':
      case 'P':
        if (parseInt(chars[6], 10) === 0) {
          return false;
        }

        break;

      default:
        {
          var first_part = parseInt(chars.join('').slice(0, 5), 10);

          if (first_part > 32000) {
            return false;
          }

          var second_part = parseInt(chars.join('').slice(5, 7), 10);

          if (first_part === second_part) {
            return false;
          }
        }
    }
  }

  return true;
}
/*
 * nl-NL validation function
 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
 * persons/entities respectively)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function nlNlCheck(tin) {
  return algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
    return parseInt(a, 10);
  }), 9) % 11 === parseInt(tin[8], 10);
}
/*
 * pl-PL validation function
 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
 * or Numer identyfikacji podatkowej (NIP), persons/entities)
 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
 */


function plPlCheck(tin) {
  // NIP
  if (tin.length === 10) {
    // Calculate last digit by multiplying with lookup
    var lookup = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var _checksum = 0;

    for (var i = 0; i < lookup.length; i++) {
      _checksum += parseInt(tin[i], 10) * lookup[i];
    }

    _checksum %= 11;

    if (_checksum === 10) {
      return false;
    }

    return _checksum === parseInt(tin[9], 10);
  } // PESEL
  // Extract full year using month


  var full_year = tin.slice(0, 2);
  var month = parseInt(tin.slice(2, 4), 10);

  if (month > 80) {
    full_year = "18".concat(full_year);
    month -= 80;
  } else if (month > 60) {
    full_year = "22".concat(full_year);
    month -= 60;
  } else if (month > 40) {
    full_year = "21".concat(full_year);
    month -= 40;
  } else if (month > 20) {
    full_year = "20".concat(full_year);
    month -= 20;
  } else {
    full_year = "19".concat(full_year);
  } // Add leading zero to month if needed


  if (month < 10) {
    month = "0".concat(month);
  } // Check date validity


  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  } // Calculate last digit by mulitplying with odd one-digit numbers except 5


  var checksum = 0;
  var multiplier = 1;

  for (var _i7 = 0; _i7 < tin.length - 1; _i7++) {
    checksum += parseInt(tin[_i7], 10) * multiplier % 10;
    multiplier += 2;

    if (multiplier > 10) {
      multiplier = 1;
    } else if (multiplier === 5) {
      multiplier += 2;
    }
  }

  checksum = 10 - checksum % 10;
  return checksum === parseInt(tin[10], 10);
}
/*
* pt-BR validation function
* (Cadastro de Pessoas Físicas (CPF, persons)
* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
* Both inputs will be validated
*/


function ptBrCheck(tin) {
  if (tin.length === 11) {
    var _sum;

    var remainder;
    _sum = 0;
    if ( // Reject known invalid CPFs
    tin === '11111111111' || tin === '22222222222' || tin === '33333333333' || tin === '44444444444' || tin === '55555555555' || tin === '66666666666' || tin === '77777777777' || tin === '88888888888' || tin === '99999999999' || tin === '00000000000') return false;

    for (var i = 1; i <= 9; i++) {
      _sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
    }

    remainder = _sum * 10 % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
    _sum = 0;

    for (var _i8 = 1; _i8 <= 10; _i8++) {
      _sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
    }

    remainder = _sum * 10 % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
    return true;
  }

  if ( // Reject know invalid CNPJs
  tin === '00000000000000' || tin === '11111111111111' || tin === '22222222222222' || tin === '33333333333333' || tin === '44444444444444' || tin === '55555555555555' || tin === '66666666666666' || tin === '77777777777777' || tin === '88888888888888' || tin === '99999999999999') {
    return false;
  }

  var length = tin.length - 2;
  var identifiers = tin.substring(0, length);
  var verificators = tin.substring(length);
  var sum = 0;
  var pos = length - 7;

  for (var _i9 = length; _i9 >= 1; _i9--) {
    sum += identifiers.charAt(length - _i9) * pos;
    pos -= 1;

    if (pos < 2) {
      pos = 9;
    }
  }

  var result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  if (result !== parseInt(verificators.charAt(0), 10)) {
    return false;
  }

  length += 1;
  identifiers = tin.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (var _i10 = length; _i10 >= 1; _i10--) {
    sum += identifiers.charAt(length - _i10) * pos;
    pos -= 1;

    if (pos < 2) {
      pos = 9;
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  if (result !== parseInt(verificators.charAt(1), 10)) {
    return false;
  }

  return true;
}
/*
 * pt-PT validation function
 * (Número de identificação fiscal (NIF), persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function ptPtCheck(tin) {
  var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
    return parseInt(a, 10);
  }), 9) % 11;

  if (checksum > 9) {
    return parseInt(tin[8], 10) === 0;
  }

  return checksum === parseInt(tin[8], 10);
}
/*
 * ro-RO validation function
 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
 * persons only)
 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
 * Material not in DG TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
 */


function roRoCheck(tin) {
  if (tin.slice(0, 4) !== '9000') {
    // No test found for this format
    // Extract full year using century digit if possible
    var full_year = tin.slice(1, 3);

    switch (tin[0]) {
      case '1':
      case '2':
        full_year = "19".concat(full_year);
        break;

      case '3':
      case '4':
        full_year = "18".concat(full_year);
        break;

      case '5':
      case '6':
        full_year = "20".concat(full_year);
        break;

      default:
    } // Check date validity


    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

    if (date.length === 8) {
      if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
        return false;
      }
    } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
      return false;
    } // Calculate check digit


    var digits = tin.split('').map(function (a) {
      return parseInt(a, 10);
    });
    var multipliers = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
    var checksum = 0;

    for (var i = 0; i < multipliers.length; i++) {
      checksum += digits[i] * multipliers[i];
    }

    if (checksum % 11 === 10) {
      return digits[12] === 1;
    }

    return digits[12] === checksum % 11;
  }

  return true;
}
/*
 * sk-SK validation function
 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
 * Checks validity of pre-1954 birth numbers (rodné číslo) only
 * Due to the introduction of the pseudo-random BIČ it is not possible to test
 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
 */


function skSkCheck(tin) {
  if (tin.length === 9) {
    tin = tin.replace(/\W/, '');

    if (tin.slice(6) === '000') {
      return false;
    } // Three-zero serial not assigned before 1954
    // Extract full year from TIN length


    var full_year = parseInt(tin.slice(0, 2), 10);

    if (full_year > 53) {
      return false;
    }

    if (full_year < 10) {
      full_year = "190".concat(full_year);
    } else {
      full_year = "19".concat(full_year);
    } // Extract month from TIN and normalize


    var month = parseInt(tin.slice(2, 4), 10);

    if (month > 50) {
      month -= 50;
    }

    if (month < 10) {
      month = "0".concat(month);
    } // Check date validity


    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

    if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
      return false;
    }
  }

  return true;
}
/*
 * sl-SI validation function
 * (Davčna številka, persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */


function slSiCheck(tin) {
  var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
    return parseInt(a, 10);
  }), 8) % 11;

  if (checksum === 10) {
    return parseInt(tin[7], 10) === 0;
  }

  return checksum === parseInt(tin[7], 10);
}
/*
 * sv-SE validation function
 * (Personnummer or samordningsnummer, persons only)
 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
 */


function svSeCheck(tin) {
  // Make copy of TIN and normalize to two-digit year form
  var tin_copy = tin.slice(0);

  if (tin.length > 11) {
    tin_copy = tin_copy.slice(2);
  } // Extract date of birth


  var full_year = '';
  var month = tin_copy.slice(2, 4);
  var day = parseInt(tin_copy.slice(4, 6), 10);

  if (tin.length > 11) {
    full_year = tin.slice(0, 4);
  } else {
    full_year = tin.slice(0, 2);

    if (tin.length === 11 && day < 60) {
      // Extract full year from centenarian symbol
      // Should work just fine until year 10000 or so
      var current_year = new Date().getFullYear().toString();
      var current_century = parseInt(current_year.slice(0, 2), 10);
      current_year = parseInt(current_year, 10);

      if (tin[6] === '-') {
        if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) {
          full_year = "".concat(current_century - 1).concat(full_year);
        } else {
          full_year = "".concat(current_century).concat(full_year);
        }
      } else {
        full_year = "".concat(current_century - 1).concat(full_year);

        if (current_year - parseInt(full_year, 10) < 100) {
          return false;
        }
      }
    }
  } // Normalize day and check date validity


  if (day > 60) {
    day -= 60;
  }

  if (day < 10) {
    day = "0".concat(day);
  }

  var date = "".concat(full_year, "/").concat(month, "/").concat(day);

  if (date.length === 8) {
    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
      return false;
    }
  } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
    return false;
  }

  return algorithms.luhnCheck(tin.replace(/\W/, ''));
} // Locale lookup objects

/*
 * Tax id regex formats for various locales
 *
 * Where not explicitly specified in DG-TAXUD document both
 * uppercase and lowercase letters are acceptable.
 */


var taxIdFormat = {
  'bg-BG': /^\d{10}$/,
  'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
  'de-AT': /^\d{9}$/,
  'de-DE': /^[1-9]\d{10}$/,
  'dk-DK': /^\d{6}-{0,1}\d{4}$/,
  'el-CY': /^[09]\d{7}[A-Z]$/,
  'el-GR': /^([0-4]|[7-9])\d{8}$/,
  'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
  'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
  'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
  'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
  'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
  'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
  'fr-BE': /^\d{11}$/,
  'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
  // Conforms both to official spec and provided example
  'fr-LU': /^\d{13}$/,
  'hr-HR': /^\d{11}$/,
  'hu-HU': /^8\d{9}$/,
  'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
  'lv-LV': /^\d{6}-{0,1}\d{5}$/,
  // Conforms both to DG TAXUD spec and original research
  'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
  'nl-NL': /^\d{9}$/,
  'pl-PL': /^\d{10,11}$/,
  'pt-BR': /(?:^\d{11}$)|(?:^\d{14}$)/,
  'pt-PT': /^\d{9}$/,
  'ro-RO': /^\d{13}$/,
  'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
  'sl-SI': /^[1-9]\d{7}$/,
  'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
}; // taxIdFormat locale aliases

taxIdFormat['lb-LU'] = taxIdFormat['fr-LU'];
taxIdFormat['lt-LT'] = taxIdFormat['et-EE'];
taxIdFormat['nl-BE'] = taxIdFormat['fr-BE']; // Algorithmic tax id check functions for various locales

var taxIdCheck = {
  'bg-BG': bgBgCheck,
  'cs-CZ': csCzCheck,
  'de-AT': deAtCheck,
  'de-DE': deDeCheck,
  'dk-DK': dkDkCheck,
  'el-CY': elCyCheck,
  'el-GR': elGrCheck,
  'en-IE': enIeCheck,
  'en-US': enUsCheck,
  'es-ES': esEsCheck,
  'et-EE': etEeCheck,
  'fi-FI': fiFiCheck,
  'fr-BE': frBeCheck,
  'fr-FR': frFrCheck,
  'fr-LU': frLuCheck,
  'hr-HR': hrHrCheck,
  'hu-HU': huHuCheck,
  'it-IT': itItCheck,
  'lv-LV': lvLvCheck,
  'mt-MT': mtMtCheck,
  'nl-NL': nlNlCheck,
  'pl-PL': plPlCheck,
  'pt-BR': ptBrCheck,
  'pt-PT': ptPtCheck,
  'ro-RO': roRoCheck,
  'sk-SK': skSkCheck,
  'sl-SI': slSiCheck,
  'sv-SE': svSeCheck
}; // taxIdCheck locale aliases

taxIdCheck['lb-LU'] = taxIdCheck['fr-LU'];
taxIdCheck['lt-LT'] = taxIdCheck['et-EE'];
taxIdCheck['nl-BE'] = taxIdCheck['fr-BE']; // Regexes for locales where characters should be omitted before checking format

var allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
var sanitizeRegexes = {
  'de-AT': allsymbols,
  'de-DE': /[\/\\]/g,
  'fr-BE': allsymbols
}; // sanitizeRegexes locale aliases

sanitizeRegexes['nl-BE'] = sanitizeRegexes['fr-BE'];
/*
 * Validator function
 * Return true if the passed string is a valid tax identification number
 * for the specified locale.
 * Throw an error exception if the locale is not supported.
 */

function isTaxID(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str); // Copy TIN to avoid replacement if sanitized

  var strcopy = str.slice(0);

  if (locale in taxIdFormat) {
    if (locale in sanitizeRegexes) {
      strcopy = strcopy.replace(sanitizeRegexes[locale], '');
    }

    if (!taxIdFormat[locale].test(strcopy)) {
      return false;
    }

    if (locale in taxIdCheck) {
      return taxIdCheck[locale](strcopy);
    } // Fallthrough; not all locales have algorithmic checks


    return true;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 66823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isURL;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isFQDN = _interopRequireDefault(__webpack_require__(10221));

var _isIP = _interopRequireDefault(__webpack_require__(61028));

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/
var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_port: false,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false,
  allow_fragments: true,
  allow_query_components: true,
  validate_length: true
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);

  if (options.validate_length && url.length >= 2083) {
    return false;
  }

  if (!options.allow_fragments && url.includes('#')) {
    return false;
  }

  if (!options.allow_query_components && (url.includes('?') || url.includes('&'))) {
    return false;
  }

  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    if (split[0] === '') {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }

    var _auth$split = auth.split(':'),
        _auth$split2 = _slicedToArray(_auth$split, 2),
        user = _auth$split2[0],
        password = _auth$split2[1];

    if (user === '' && password === '') {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null && port_str.length > 0) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  } else if (options.require_port) {
    return false;
  }

  if (options.host_whitelist) {
    return checkHost(host, options.host_whitelist);
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 57278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isUUID;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = {
  1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str, version) {
  (0, _assertString.default)(str);
  var pattern = uuid[![undefined, null].includes(version) ? version : 'all'];
  return !!pattern && pattern.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 57245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isUppercase;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString.default)(str);
  return str === str.toUpperCase();
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 55977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isVAT;
exports.vatMatchers = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vatMatchers = {
  GB: /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/,
  IT: /^(IT)?[0-9]{11}$/,
  NL: /^(NL)?[0-9]{9}B[0-9]{2}$/
};
exports.vatMatchers = vatMatchers;

function isVAT(str, countryCode) {
  (0, _assertString.default)(str);
  (0, _assertString.default)(countryCode);

  if (countryCode in vatMatchers) {
    return vatMatchers[countryCode].test(str);
  }

  throw new Error("Invalid country code: '".concat(countryCode, "'"));
}

/***/ }),

/***/ 49019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isVariableWidth;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _isFullWidth = __webpack_require__(77146);

var _isHalfWidth = __webpack_require__(82941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isVariableWidth(str) {
  (0, _assertString.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 88346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isWhitelisted;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWhitelisted(str, chars) {
  (0, _assertString.default)(str);

  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 14959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = ltrim;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ltrim(str, chars) {
  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping

  var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
  return str.replace(pattern, '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 30661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = matches;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString.default)(str);

  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }

  return pattern.test(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 2900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = normalizeEmail;

var _merge = _interopRequireDefault(__webpack_require__(84808));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_normalize_email_options = {
  // The following options apply to all email addresses
  // Lowercases the local part of the email address.
  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
  // The domain is always lowercased, as per RFC 1035
  all_lowercase: true,
  // The following conversions are specific to GMail
  // Lowercases the local part of the GMail address (known to be case-insensitive)
  gmail_lowercase: true,
  // Removes dots from the local part of the email address, as that's ignored by GMail
  gmail_remove_dots: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  gmail_remove_subaddress: true,
  // Conversts the googlemail.com domain to gmail.com
  gmail_convert_googlemaildotcom: true,
  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
  outlookdotcom_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  outlookdotcom_remove_subaddress: true,
  // The following conversions are specific to Yahoo
  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
  yahoo_lowercase: true,
  // Removes the subaddress (e.g. "-foo") from the email address
  yahoo_remove_subaddress: true,
  // The following conversions are specific to Yandex
  // Lowercases the local part of the Yandex address (known to be case-insensitive)
  yandex_lowercase: true,
  // The following conversions are specific to iCloud
  // Lowercases the local part of the iCloud address (known to be case-insensitive)
  icloud_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  icloud_remove_subaddress: true
}; // List of domains used by iCloud

var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/

var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
// This list is likely incomplete

var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru

var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots

function dotsReplacer(match) {
  if (match.length > 1) {
    return match;
  }

  return '';
}

function normalizeEmail(email, options) {
  options = (0, _merge.default)(options, default_normalize_email_options);
  var raw_parts = email.split('@');
  var domain = raw_parts.pop();
  var user = raw_parts.join('@');
  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035

  parts[1] = parts[1].toLowerCase();

  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    // Address is GMail
    if (options.gmail_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (options.gmail_remove_dots) {
      // this does not replace consecutive dots like example..email@gmail.com
      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.gmail_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
    // Address is iCloud
    if (options.icloud_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.icloud_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
    // Address is Outlook.com
    if (options.outlookdotcom_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.outlookdotcom_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
    // Address is Yahoo
    if (options.yahoo_remove_subaddress) {
      var components = parts[0].split('-');
      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.yahoo_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
    if (options.all_lowercase || options.yandex_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preferred
  } else if (options.all_lowercase) {
    // Any other address
    parts[0] = parts[0].toLowerCase();
  }

  return parts.join('@');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 29778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rtrim;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rtrim(str, chars) {
  (0, _assertString.default)(str);

  if (chars) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g');
    return str.replace(pattern, '');
  } // Use a faster and more safe than regex trim method https://blog.stevenlevithan.com/archives/faster-trim-javascript


  var strIndex = str.length - 1;

  while (/\s/.test(str.charAt(strIndex))) {
    strIndex -= 1;
  }

  return str.slice(0, strIndex + 1);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = stripLow;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

var _blacklist = _interopRequireDefault(__webpack_require__(44928));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stripLow(str, keep_new_lines) {
  (0, _assertString.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist.default)(str, chars);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBoolean(str, strict) {
  (0, _assertString.default)(str);

  if (strict) {
    return str === '1' || /^true$/i.test(str);
  }

  return str !== '0' && !/^false$/i.test(str) && str !== '';
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 8469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toDate(date) {
  (0, _assertString.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 77536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toFloat;

var _isFloat = _interopRequireDefault(__webpack_require__(79146));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toFloat(str) {
  if (!(0, _isFloat.default)(str)) return NaN;
  return parseFloat(str);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 21359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInt;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toInt(str, radix) {
  (0, _assertString.default)(str);
  return parseInt(str, radix || 10);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 24790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = trim;

var _rtrim = _interopRequireDefault(__webpack_require__(29778));

var _ltrim = _interopRequireDefault(__webpack_require__(14959));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(str, chars) {
  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 94816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = unescape;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unescape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`').replace(/&amp;/g, '&'); // &amp; replacement has to be the last one to prevent
  // bugs with intermediate strings containing escape sequences
  // See: https://github.com/validatorjs/validator.js/issues/1827
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 83672:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.iso7064Check = iso7064Check;
exports.luhnCheck = luhnCheck;
exports.reverseMultiplyAndSum = reverseMultiplyAndSum;
exports.verhoeffCheck = verhoeffCheck;

/**
 * Algorithmic validation functions
 * May be used as is or implemented in the workflow of other validators.
 */

/*
 * ISO 7064 validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to ISO 7064 (MOD 11, 10).
 */
function iso7064Check(str) {
  var checkvalue = 10;

  for (var i = 0; i < str.length - 1; i++) {
    checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 10 * 2 % 11 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
  }

  checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
  return checkvalue === parseInt(str[10], 10);
}
/*
 * Luhn (mod 10) validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to the Luhn algorithm.
 */


function luhnCheck(str) {
  var checksum = 0;
  var second = false;

  for (var i = str.length - 1; i >= 0; i--) {
    if (second) {
      var product = parseInt(str[i], 10) * 2;

      if (product > 9) {
        // sum digits of product and add to checksum
        checksum += product.toString().split('').map(function (a) {
          return parseInt(a, 10);
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      } else {
        checksum += product;
      }
    } else {
      checksum += parseInt(str[i], 10);
    }

    second = !second;
  }

  return checksum % 10 === 0;
}
/*
 * Reverse TIN multiplication and summation helper function
 * Called with an array of single-digit integers and a base multiplier
 * to calculate the sum of the digits multiplied in reverse.
 * Normally used in variations of MOD 11 algorithmic checks.
 */


function reverseMultiplyAndSum(digits, base) {
  var total = 0;

  for (var i = 0; i < digits.length; i++) {
    total += digits[i] * (base - i);
  }

  return total;
}
/*
 * Verhoeff validation helper function
 * Called with a string of numbers
 * to validate according to the Verhoeff algorithm.
 */


function verhoeffCheck(str) {
  var d_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
  var p_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // Copy (to prevent replacement) and reverse

  var str_copy = str.split('').reverse().join('');
  var checksum = 0;

  for (var i = 0; i < str_copy.length; i++) {
    checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
  }

  return checksum === 0;
}

/***/ }),

/***/ 65571:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assertString;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType = _typeof(input);

    if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
    throw new TypeError("Expected a string but received a ".concat(invalidType));
  }
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 18343:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var includes = function includes(arr, val) {
  return arr.some(function (arrVal) {
    return val === arrVal;
  });
};

var _default = includes;
exports["default"] = _default;
module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 84808:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 24731:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = multilineRegexp;

/**
 * Build RegExp object from an array
 * of multiple/multi-line regexp parts
 *
 * @param {string[]} parts
 * @param {string} flags
 * @return {object} - RegExp object
 */
function multilineRegexp(parts, flags) {
  var regexpAsStringLiteral = parts.join('');
  return new RegExp(regexpAsStringLiteral, flags);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 31913:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toString;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function toString(input) {
  if (_typeof(input) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }

  return String(input);
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 34714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = whitelist;

var _assertString = _interopRequireDefault(__webpack_require__(65571));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whitelist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports["default"] = exports.default;

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 84506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83878);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59199);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40181);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25267);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 36609:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* unused harmony exports changeLanguage, createInstance, exists, getFixedT, hasLoadedNamespace, init, loadLanguages, loadNamespaces, loadResources, reloadResources, setDefaultNamespace, use */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60136);
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82963);
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61120);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84506);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread(_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = '_zero';

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = (0,_babel_runtime_helpers_esm_toArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val.trim();
        if (val.trim() === 'false') formatOptions[key.trim()] = false;
        if (val.trim() === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val.trim())) formatOptions[key.trim()] = parseInt(val.trim(), 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4({}, options)).format(val);
      }
    };
    this.init(options);
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  delete q.pending[name];
  q.pendingCount--;
}

var Connector = function (_EventEmitter) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = Object.keys(loaded[l]);

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loadedKeys[ns] !== undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(args[2]) === 'object' || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_this, (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ __webpack_exports__["ZP"] = (instance);



/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 33600:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

/***/ }),

/***/ 59323:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 29591:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","QUOT":"\\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}');

/***/ }),

/***/ 2586:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(25436), __webpack_exec__(85579), __webpack_exec__(6840), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);